webpackJsonp(["client"],{

/***/ "+GGQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = updateIMS;
/* harmony export (immutable) */ __webpack_exports__["b"] = updateIMSNote;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services__ = __webpack_require__("NvlE");



var _createActions = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])('IMS_ACTIONS_UPDATE_SUCCESS', 'IMS_ACTIONS_UPDATE_REQUEST', 'IMS_ACTIONS_UPDATE_FAILURE'),
    imsActionsUpdateSuccess = _createActions.imsActionsUpdateSuccess,
    imsActionsUpdateRequest = _createActions.imsActionsUpdateRequest,
    imsActionsUpdateFailure = _createActions.imsActionsUpdateFailure;

function updateIMS(phaseId, params) {
  return function (dispatch) {
    dispatch(imsActionsUpdateRequest());
    Object(__WEBPACK_IMPORTED_MODULE_1__services__["h" /* request */])('ims_actions/' + phaseId, {
      method: 'PUT',
      body: params
    }).then(function (_ref) {
      var json = _ref.json;

      dispatch(imsActionsUpdateSuccess(json));
    }, function (error) {
      dispatch(imsActionsUpdateFailure(error));
    });
  };
}

function updateIMSNote(phaseId, params) {
  return function (dispatch) {
    dispatch(imsActionsUpdateRequest());
    Object(__WEBPACK_IMPORTED_MODULE_1__services__["h" /* request */])('ims_actions/' + phaseId + '/add_note', {
      method: 'PUT',
      body: params
    }).then(function (_ref2) {
      var json = _ref2.json;

      dispatch(imsActionsUpdateSuccess(json));
    }, function (error) {
      dispatch(imsActionsUpdateFailure(error));
    });
  };
}

/***/ }),

/***/ "+SaK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___2mt9f","m-signature-pad--body":"styles__m-signature-pad--body___tMOs4","m-signature-pad--footer":"styles__m-signature-pad--footer___14Mdi","description":"styles__description___4U-g2","button":"styles__button___NCJNI","clear":"styles__clear___3f7yu","save":"styles__save___3S5pV","m-signature-pad":"styles__m-signature-pad___GZRbS","github":"styles__github___2DnnN","section":"styles__section___33kwP","titleContainer":"styles__titleContainer___2Vvf7","innerSection":"styles__innerSection___3daAA","mainTitle":"styles__mainTitle___2dnE_","mainSubtitle":"styles__mainSubtitle___3u_0-","boldWord":"styles__boldWord___3is5c","dividerLine":"styles__dividerLine___17uL1"};

/***/ }),

/***/ "+uOv":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fd1-b5c8ae85dff12ddb6bfeda0e8b305717.png";

/***/ }),

/***/ "+zLr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"switch__msignaturepad___2CHX6","m-signature-pad--body":"switch__m-signature-pad--body___37Ewv","m-signature-pad--footer":"switch__m-signature-pad--footer___1lNQs","description":"switch__description___1yqK2","button":"switch__button___2rkMG","clear":"switch__clear___2C3Jp","save":"switch__save___D5bLw","m-signature-pad":"switch__m-signature-pad___yTDbg","github":"switch__github___2fZsQ","on":"switch__on___5541T","thumb":"switch__thumb___2NBxv","ripple":"switch__ripple___1lzQf","off":"switch__off___zF2O7"};

/***/ }),

/***/ "/Blj":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "pf1-16e94c5925aefb597e45d019a3fbc736.png";

/***/ }),

/***/ "/V75":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ms-logo-0c29638c7558632a1a5f053d344405ba.png";

/***/ }),

/***/ "/biN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/gPC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchVendorTypes;
/* harmony export (immutable) */ __webpack_exports__["c"] = requestLineItems;
/* harmony export (immutable) */ __webpack_exports__["a"] = createLineItem;
/* harmony export (immutable) */ __webpack_exports__["e"] = updateLineItem;
/* harmony export (immutable) */ __webpack_exports__["d"] = setLineItemFilters;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services__ = __webpack_require__("NvlE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_qs__);




var _createActions = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])('FETCH_VENDOR_TYPES_REQUEST', 'FETCH_VENDOR_TYPES_SUCCESS', 'FETCH_VENDOR_TYPES_FAILURE'),
    fetchVendorTypesRequest = _createActions.fetchVendorTypesRequest,
    fetchVendorTypesSuccess = _createActions.fetchVendorTypesSuccess,
    fetchVendorTypesFailure = _createActions.fetchVendorTypesFailure;

function fetchVendorTypes() {
  return function (dispatch) {
    dispatch(fetchVendorTypesRequest());
    return Object(__WEBPACK_IMPORTED_MODULE_1__services__["h" /* request */])('/api/line_items/vendor_types', { headers: { Accept: 'application/json' } }).then(function (_ref) {
      var json = _ref.json;
      return dispatch(fetchVendorTypesSuccess(json.vendor_types));
    }).catch(function (errors) {
      dispatch(fetchVendorTypesFailure({ errors: errors }));
    });
  };
}

var _createActions2 = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])('LINE_ITEMS_SUCCESS', 'LINE_ITEMS_REQUEST', 'LINE_ITEMS_FAILURE'),
    lineItemsRequest = _createActions2.lineItemsRequest,
    lineItemsSuccess = _createActions2.lineItemsSuccess,
    lineItemsFailure = _createActions2.lineItemsFailure;

function requestLineItems() {
  return function (dispatch, getState) {
    dispatch(lineItemsRequest());
    var filterParams = __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(getState().lineItems.filters);
    return Object(__WEBPACK_IMPORTED_MODULE_1__services__["h" /* request */])('line_items?' + filterParams).then(function (_ref2) {
      var json = _ref2.json;

      dispatch(lineItemsSuccess(json));
    }).catch(function (error) {
      dispatch(lineItemsFailure(error));
    });
  };
}

var _createActions3 = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])('CREATE_LINE_ITEM_SUCCESS', 'CREATE_LINE_ITEM_REQUEST', 'CREATE_LINE_ITEM_FAILURE'),
    createLineItemRequest = _createActions3.createLineItemRequest,
    createLineItemSuccess = _createActions3.createLineItemSuccess,
    createLineItemFailure = _createActions3.createLineItemFailure;

function createLineItem(lineItem) {
  return function (dispatch) {
    dispatch(createLineItemRequest());

    return Object(__WEBPACK_IMPORTED_MODULE_1__services__["h" /* request */])('line_items', { method: 'POST', body: lineItem }).then(function (_ref3) {
      var json = _ref3.json;

      dispatch(createLineItemSuccess(json));
    }).catch(function (errors) {
      dispatch(createLineItemFailure({ errors: errors, line_item: lineItem }));
    });
  };
}

var _createActions4 = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])('UPDATE_LINE_ITEM_SUCCESS', 'UPDATE_LINE_ITEM_REQUEST', 'UPDATE_LINE_ITEM_FAILURE'),
    updateLineItemRequest = _createActions4.updateLineItemRequest,
    updateLineItemSuccess = _createActions4.updateLineItemSuccess,
    updateLineItemFailure = _createActions4.updateLineItemFailure;

function updateLineItem(lineItem) {
  return function (dispatch) {
    dispatch(updateLineItemRequest());

    return Object(__WEBPACK_IMPORTED_MODULE_1__services__["h" /* request */])('line_items/' + lineItem.id, { method: 'PATCH', body: lineItem }).then(function (_ref4) {
      var json = _ref4.json;
      return dispatch(updateLineItemSuccess(json));
    }).catch(function (errors) {
      return dispatch(updateLineItemFailure({ errors: errors, line_item: lineItem }));
    });
  };
}

function setLineItemFilters(filter) {
  return function (dispatch) {
    return Promise.all([dispatch({ type: 'LINE_ITEMS_SET_FILTERS', payload: filter }), dispatch(requestLineItems())]);
  };
}

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0/D+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"appBar__msignaturepad___1OhQO","m-signature-pad--body":"appBar__m-signature-pad--body___3o7cb","m-signature-pad--footer":"appBar__m-signature-pad--footer___16GFf","description":"appBar__description___AandO","button":"appBar__button___2GHZ8","clear":"appBar__clear___3wwN7","save":"appBar__save___S8AxK","m-signature-pad":"appBar__m-signature-pad___hsgYd","github":"appBar__github___6HrOZ","appBar":"appBar__appBar___3tOU_","navList":"appBar__navList___1OXhF","navListMobile":"appBar__navListMobile___3CyL8","active":"appBar__active___2F6BH","sublink":"appBar__sublink___20vR-","sublinkDesktop":"appBar__sublinkDesktop___shIyk"};

/***/ }),

/***/ "0dZs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"pageActionBar__msignaturepad___3KS6e","m-signature-pad--body":"pageActionBar__m-signature-pad--body___Q-eTV","m-signature-pad--footer":"pageActionBar__m-signature-pad--footer___h9OXs","description":"pageActionBar__description___bzGYw","button":"pageActionBar__button___2EJ1G","clear":"pageActionBar__clear___JGx93","save":"pageActionBar__save___3Kfzq","m-signature-pad":"pageActionBar__m-signature-pad___3Dacf","github":"pageActionBar__github___3GB2A","pageActionBarContainer":"pageActionBar__pageActionBarContainer___2iCqO","title":"pageActionBar__title___uEh13","subTitle":"pageActionBar__subTitle___3tpm0","banner":"pageActionBar__banner___1wwpY","middle":"pageActionBar__middle___2UQrM","scrolling":"pageActionBar__scrolling___1mC5I"};

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "1CXG":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "rf1-8843dcf30836e60ce88b120570ad9705.jpg";

/***/ }),

/***/ "1HIx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = requestEmployeeList;
/* harmony export (immutable) */ __webpack_exports__["c"] = requestEmployee;
/* harmony export (immutable) */ __webpack_exports__["b"] = createEmployee;
/* harmony export (immutable) */ __webpack_exports__["g"] = updateEmployee;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addEventToEmployee; });
/* harmony export (immutable) */ __webpack_exports__["f"] = setEmployeeFilters;
/* harmony export (immutable) */ __webpack_exports__["e"] = resetEmployeeFilters;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_redux__ = __webpack_require__("jZgO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services__ = __webpack_require__("NvlE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actionCreators__ = __webpack_require__("uJNR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_actionCreators_user__ = __webpack_require__("tHjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers__ = __webpack_require__("RbI9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_qs__);








/* NOTES
* To handle api 419 (Session expired) responses a
* JS Error will be throw from the request method.
* Each request call must have an error handler
* callback to manage any potential errors
* occured during an API request. If no particular
* error handling is needed a default callback should
* be used, otherwise the action dispatched in the
* callback must have an the error in the meta property
*/

/*
  Follow the convention of returning promises in thunks.
  That gives the ability of executing some code when the thunk
  finish... for example to show a succes message if the user
  is created
 */

var _createActions = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])({
  EMPLOYEE_LIST_SUCCESS: [function (json) {
    return json;
  }, function (json, filterParams) {
    return { query: filterParams };
  }]
}, 'EMPLOYEE_LIST_REQUEST', 'EMPLOYEE_LIST_FAILURE'),
    employeeListRequest = _createActions.employeeListRequest,
    employeeListSuccess = _createActions.employeeListSuccess,
    employeeListFailure = _createActions.employeeListFailure;

function requestEmployeeList() {
  var arg_filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  return function (dispatch, getState) {
    var state = getState();
    var page = Object(__WEBPACK_IMPORTED_MODULE_5__reducers__["o" /* getEmployeePage */])(state);
    var filters = arg_filters || Object(__WEBPACK_IMPORTED_MODULE_5__reducers__["k" /* getEmployeeFilters */])(state);
    var filterParams = __WEBPACK_IMPORTED_MODULE_6_qs___default.a.stringify(filters);
    dispatch(employeeListRequest());
    Object(__WEBPACK_IMPORTED_MODULE_2__services__["h" /* request */])('employees?page=' + page + '&' + filterParams).then(function (_ref) {
      var json = _ref.json;
      return dispatch(employeeListSuccess(json, filterParams));
    }).catch(function (error) {
      return dispatch(employeeListFailure(error));
    });
  };
}

var _createActions2 = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])({
  EMPLOYEE_RESOURCE_REQUEST: function EMPLOYEE_RESOURCE_REQUEST(id) {
    return { id: id };
  }
}, 'EMPLOYEE_RESOURCE_SUCCESS', 'EMPLOYEE_RESOURCE_FAILURE'),
    employeeResourceRequest = _createActions2.employeeResourceRequest,
    employeeResourceSuccess = _createActions2.employeeResourceSuccess,
    employeeResourceFailure = _createActions2.employeeResourceFailure;

function requestEmployee(id) {
  return function (dispatch) {
    dispatch(employeeResourceRequest(id));
    return Object(__WEBPACK_IMPORTED_MODULE_2__services__["h" /* request */])('employees/' + id).then(function (_ref2) {
      var json = _ref2.json;
      return dispatch(employeeResourceSuccess(json));
    }).catch(function (error) {
      return dispatch(employeeResourceFailure(error));
    });
  };
}

var _createActions3 = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])('EMPLOYEE_RESOURCE_CREATE_REQUEST', 'EMPLOYEE_RESOURCE_CREATE_SUCCESS', 'EMPLOYEE_RESOURCE_CREATE_FAILURE'),
    employeeResourceCreateRequest = _createActions3.employeeResourceCreateRequest,
    employeeResourceCreateSuccess = _createActions3.employeeResourceCreateSuccess,
    employeeResourceCreateFailure = _createActions3.employeeResourceCreateFailure;

function createEmployee(employee, onSuccess) {
  return function (dispatch) {
    dispatch(employeeResourceCreateRequest());
    return Object(__WEBPACK_IMPORTED_MODULE_2__services__["h" /* request */])('employees/', {
      method: 'POST',
      body: { user: employee }
    }).then(function (_ref3) {
      var json = _ref3.json;

      onSuccess(json.name, json.email);
      dispatch(employeeResourceCreateSuccess(json));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_react_router_redux__["push"])('/employees'));
    }, function (error) {
      dispatch(employeeResourceCreateFailure(error));
    });
  };
}

var _createActions4 = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])('EMPLOYEE_RESOURCE_UPDATE_REQUEST', 'EMPLOYEE_RESOURCE_UPDATE_SUCCESS', 'EMPLOYEE_RESOURCE_UPDATE_FAILURE'),
    employeeResourceUpdateRequest = _createActions4.employeeResourceUpdateRequest,
    employeeResourceUpdateSuccess = _createActions4.employeeResourceUpdateSuccess,
    employeeResourceUpdateFailure = _createActions4.employeeResourceUpdateFailure;

function updateEmployee(employee, onSuccess) {
  return function (dispatch) {
    dispatch(employeeResourceUpdateRequest());
    return Object(__WEBPACK_IMPORTED_MODULE_2__services__["h" /* request */])('employees/' + employee.id, { method: 'PUT', body: { user: employee } }).then(function (_ref4) {
      var json = _ref4.json;

      onSuccess(); // this may change in the future when refactoring
      dispatch(employeeResourceUpdateSuccess(json));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__shared_actionCreators_user__["g" /* userGetSession */])()); // Refresh user to match shared info with employee
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_actionCreators__["P" /* navigateBack */])());
    }).catch(function (error) {
      return dispatch(employeeResourceUpdateFailure(error));
    });
  };
}

var _createActions5 = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])({
  ADD_EVENT_TO_EMPLOYEE_SUCCESS: function ADD_EVENT_TO_EMPLOYEE_SUCCESS(json, employeeId) {
    return { event: json.event, employeeId: employeeId };
  }
}, 'ADD_EVENT_TO_EMPLOYEE_FAILURE', 'ADD_EVENT_TO_EMPLOYEE_REQUEST'),
    addEventToEmployeeRequest = _createActions5.addEventToEmployeeRequest,
    addEventToEmployeeSuccess = _createActions5.addEventToEmployeeSuccess,
    addEventToEmployeeFailure = _createActions5.addEventToEmployeeFailure;

var addEventToEmployee = function addEventToEmployee(employeeId, event) {
  return function (dispatch) {
    dispatch(addEventToEmployeeRequest(event));
    return Object(__WEBPACK_IMPORTED_MODULE_2__services__["h" /* request */])('employees/' + employeeId + '/events', { method: 'POST', body: event }).then(function (_ref5) {
      var json = _ref5.json;
      return dispatch(addEventToEmployeeSuccess(json, employeeId));
    }).catch(function (errors) {
      return dispatch(addEventToEmployeeFailure(errors));
    });
  };
};

function setEmployeeFilters(filter) {
  return function (dispatch) {
    dispatch({ type: 'EMPLOYEE_SET_FILTER', payload: filter });
    dispatch({ type: 'EMPLOYEE_RESET_PAGINATION' });
    dispatch(requestEmployeeList());
  };
}

function resetEmployeeFilters() {
  return function (dispatch) {
    return Promise.all([dispatch({ type: 'EMPLOYEE_RESET_FILTERS' }), dispatch({ type: 'EMPLOYEE_RESET_PAGINATION' }), dispatch(requestEmployeeList())]);
  };
}

/***/ }),

/***/ "1krR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"phoneType__msignaturepad___1aGt7","m-signature-pad--body":"phoneType__m-signature-pad--body___K--x2","m-signature-pad--footer":"phoneType__m-signature-pad--footer___3APNE","description":"phoneType__description___3Ky0s","button":"phoneType__button___31za4","clear":"phoneType__clear___1N4_W","save":"phoneType__save___e3T2b","m-signature-pad":"phoneType__m-signature-pad___OhG2v","github":"phoneType__github___1u_rA","phoneTypes":"phoneType__phoneTypes___3kHyt","phone":"phoneType__phone___1tH64","selected":"phoneType__selected___2WGM8"};

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "28Pn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"resourceDetailsCard__msignaturepad___2Jb29","m-signature-pad--body":"resourceDetailsCard__m-signature-pad--body___9571z","m-signature-pad--footer":"resourceDetailsCard__m-signature-pad--footer___2vmpl","description":"resourceDetailsCard__description___3y2NX","button":"resourceDetailsCard__button___1Ti_i","clear":"resourceDetailsCard__clear___1hcGT","save":"resourceDetailsCard__save___tFe5Y","m-signature-pad":"resourceDetailsCard__m-signature-pad___My6OH","github":"resourceDetailsCard__github___ZzXcb","card":"resourceDetailsCard__card___2vyad","divider":"resourceDetailsCard__divider___1DD3n","mainTitle":"resourceDetailsCard__mainTitle___2o0NU","mainSubtitle":"resourceDetailsCard__mainSubtitle___TpFXD","boldWord":"resourceDetailsCard__boldWord___2o9WQ","dividerLine":"resourceDetailsCard__dividerLine___W9clV","detailsElementContainer":"resourceDetailsCard__detailsElementContainer___2SeUh","tabBar":"resourceDetailsCard__tabBar___1ls06","headerChildren":"resourceDetailsCard__headerChildren___3vQIC","detailsLink":"resourceDetailsCard__detailsLink___2LYKF","activeText":"resourceDetailsCard__activeText___1906A","inactiveText":"resourceDetailsCard__inactiveText___3bWQl","titleTabs":"resourceDetailsCard__titleTabs___1ojBB","viewableZips":"resourceDetailsCard__viewableZips___VS37j"};

/***/ }),

/***/ "2QBa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___3xj0U","m-signature-pad--body":"styles__m-signature-pad--body___1zKcp","m-signature-pad--footer":"styles__m-signature-pad--footer___1MI90","description":"styles__description___27tNS","button":"styles__button___3Atp9","clear":"styles__clear___3Euvm","save":"styles__save___1EOT7","m-signature-pad":"styles__m-signature-pad___XtT-h","github":"styles__github___3sFsk","cardContainer":"styles__cardContainer___3grTS","cardContentPadding":"styles__cardContentPadding___3ff-f","cardTitle":"styles__cardTitle___2TqmU","cardTitleNote":"styles__cardTitleNote___3wUUM","cardPointer":"styles__cardPointer___1Qld6","disabledButton":"styles__disabledButton___1WLfa","cardButton":"styles__cardButton___1YG5t","mode_edit":"styles__mode_edit___1h0Nm","content_copy":"styles__content_copy___25nA8","delete":"styles__delete___3Jin6","done":"styles__done___1-Gz5","cardIcon":"styles__cardIcon___1qefA","actionText":"styles__actionText___1UmOw","actionWrapper":"styles__actionWrapper___PX75D","receiveReleaseEdit":"styles__receiveReleaseEdit___28jPF"};

/***/ }),

/***/ "2UVg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"flagList__msignaturepad___3zWK_","m-signature-pad--body":"flagList__m-signature-pad--body___3mrmT","m-signature-pad--footer":"flagList__m-signature-pad--footer___65LOx","description":"flagList__description___qPkaY","button":"flagList__button___sDgH6","clear":"flagList__clear___2If8L","save":"flagList__save___2mgiq","m-signature-pad":"flagList__m-signature-pad___3p31O","github":"flagList__github___z6NeN","flagcontainer":"flagList__flagcontainer___19fKR","flaglabel":"flagList__flaglabel___29jC2","flag":"flagList__flag___re0ny","flagIME":"flagList__flagIME___3Y2QQ","flagPresumedLead":"flagList__flagPresumedLead___1NgeZ","close":"flagList__close___1BP0W","flagtext":"flagList__flagtext___un9st","navigable":"flagList__navigable___31Dwd","tooltipFlagNote":"flagList__tooltipFlagNote___PgFm2","actionable":"flagList__actionable___3w8Wx","priorityCustomer":"flagList__priorityCustomer___Q8q0d","color":"flagList__color___3HJsD","follow-up":"flagList__follow-up___2I0_7","repair":"flagList__repair___yX2QA","tip":"flagList__tip___18M2C","needs-paperwork":"flagList__needs-paperwork___1S3V7"};

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "33h8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isAdmin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getEmployableId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getEmployableType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getPosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getManageVendorWorkrooms; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services__ = __webpack_require__("NvlE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jwt_decode__ = __webpack_require__("ytdl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jwt_decode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_config_constants__ = __webpack_require__("JKMY");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





var initialState = {
  id: null,
  name: null,
  isAuthenticated: false,
  isAuthenticating: false,
  statusText: null,
  picture_url: null,
  role: null,
  preferences: {},
  lead_cert_number: null,
  manage_vendor_workrooms: _extends({}, __WEBPACK_IMPORTED_MODULE_2_config_constants__["B" /* DEFAULT_MVW */])
};

var setUserState = function setUserState(state, payload) {
  var authToken = payload.auth_token,
      pay = _objectWithoutProperties(payload, ['auth_token']);

  var jwtPayload = __WEBPACK_IMPORTED_MODULE_1_jwt_decode___default()(authToken);
  return _extends({}, state, pay, {
    isAuthenticated: true,
    isAuthenticating: false,
    statusText: null,
    role: jwtPayload.role
  });
};

var userReducer = function userReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'LOGIN_USER_REQUEST':
      {
        return _extends({}, state, { isAuthenticating: true, statusText: null });
      }
    case 'USER_GET_SESSION_REQUEST':
      return _extends({}, state, {
        isAuthenticated: true,
        isAuthenticating: true
      });
    case 'LOGIN_USER_SUCCESS':
      {
        Object(__WEBPACK_IMPORTED_MODULE_0__services__["j" /* saveAuthToken */])(payload.auth_token);
        return setUserState(state, payload);
      }
    case 'USER_GET_SESSION_SUCCESS':
      return setUserState(state, payload);
    case 'USER_UPDATE_PREFERENCES_SUCCESS':
      return _extends({}, state, payload);
    case 'LOGIN_USER_FAILURE':
      {
        Object(__WEBPACK_IMPORTED_MODULE_0__services__["e" /* deleteAuthData */])();
        return _extends({}, initialState, { statusText: payload.error });
      }
    case 'LOGOUT_USER':
      {
        Object(__WEBPACK_IMPORTED_MODULE_0__services__["e" /* deleteAuthData */])();
        return _extends({}, initialState, { statusText: payload.reason });
      }
    default:
      {
        return state;
      }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (userReducer);

var isAdmin = function isAdmin(state) {
  return state.role === 'admin';
};
var getRole = function getRole(state) {
  return state.role;
};
var getEmployableId = function getEmployableId(state) {
  return state.employable_id;
};
var getEmployableType = function getEmployableType(state) {
  return state.employable_type;
};
var getPosition = function getPosition(state) {
  return state.position;
};
var getManageVendorWorkrooms = function getManageVendorWorkrooms(state) {
  return state.manage_vendor_workrooms;
};

/***/ }),

/***/ "3Eoq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___zZWtI","m-signature-pad--body":"styles__m-signature-pad--body___3qJeI","m-signature-pad--footer":"styles__m-signature-pad--footer___3YjD5","description":"styles__description___3gv81","button":"styles__button___FI0kd","clear":"styles__clear___2KHhg","save":"styles__save___1_M-9","m-signature-pad":"styles__m-signature-pad___5RgHW","github":"styles__github___2MDuh","layout":"styles__layout___PBwzD","InactiveContainerStyles":"styles__InactiveContainerStyles___2D0vG","shelfBottomArrow":"styles__shelfBottomArrow___2HS7i","arrowPulse":"styles__arrowPulse___2M_eH","shelfBottom":"styles__shelfBottom___3_t0e","activeContainerStyles":"styles__activeContainerStyles___1oUBj","header":"styles__header___3q9cl","headerTitle":"styles__headerTitle___nzMkP","btnWrapper":"styles__btnWrapper___2LcoY","showHideBtn":"styles__showHideBtn___1CQza","collapseAllTablesBtnContainer":"styles__collapseAllTablesBtnContainer___qfR5u","collapseAllTablesBtn":"styles__collapseAllTablesBtn___1HfTf","blankDiv":"styles__blankDiv___3ISwO","redCount":"styles__redCount___124vg","greenCount":"styles__greenCount___1xFvH","tooltip":"styles__tooltip___3TL3N","tooltipBtn":"styles__tooltipBtn___3mW_3","tooltipText":"styles__tooltipText___1uc14","tooltipImg":"styles__tooltipImg___1t5c8","content":"styles__content___MGEjG","material-icons":"styles__material-icons___22-eR","shelfBottomExpand":"styles__shelfBottomExpand___3MWbY","shelfBottomCollapse":"styles__shelfBottomCollapse___SeBEb","containerStyles":"styles__containerStyles___2YSAx","shelfBottom1":"styles__shelfBottom1___1VI_U","shelfBottom2":"styles__shelfBottom2___oRdQQ","yellowShowBtn":"styles__yellowShowBtn___2yc5S"};

/***/ }),

/***/ "3TFB":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bttBtnArrow-a518df8f0a881362953fab353fe93d1a.svg";

/***/ }),

/***/ "3w41":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___MwqQk","m-signature-pad--body":"styles__m-signature-pad--body___2bH75","m-signature-pad--footer":"styles__m-signature-pad--footer___1gFll","description":"styles__description___2D82P","button":"styles__button___2DjXq","clear":"styles__clear___Jk4a_","save":"styles__save___BVz09","m-signature-pad":"styles__m-signature-pad___1zVM-","github":"styles__github___1oSlj","headerContainer":"styles__headerContainer___1HkBx","title":"styles__title___Kta48","standardButton":"styles__standardButton___rsPLD","saveButton":"styles__saveButton___3xSnd","cancelButton":"styles__cancelButton___mCWdJ","card":"styles__card___1MPSe","checklistContainer":"styles__checklistContainer___3aVWy","checklistFlexContainer":"styles__checklistFlexContainer___maHDO","checklistUserNote":"styles__checklistUserNote___1Wro_","checklistQuestion":"styles__checklistQuestion___3kHdR","checklistText":"styles__checklistText___3GRZ1","checklistError":"styles__checklistError___1jTrr","scriptList":"styles__scriptList___3stiS"};

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "48oR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___34aUU","m-signature-pad--body":"styles__m-signature-pad--body___15fWf","m-signature-pad--footer":"styles__m-signature-pad--footer___2Ucu4","description":"styles__description___WpOqH","button":"styles__button___34I-K","clear":"styles__clear___3HJoK","save":"styles__save___mbHuC","m-signature-pad":"styles__m-signature-pad___3Fhiw","github":"styles__github___2T156","prettyDropDown":"styles__prettyDropDown___3cnys","empty":"styles__empty___1Vr5T","errored":"styles__errored___1nJ61","dropDownWrapper":"styles__dropDownWrapper___3_Yuo","dropDownLabel":"styles__dropDownLabel___1dySR","optionText":"styles__optionText___3wIf0","errorText":"styles__errorText___2zXjV","errorMessage":"styles__errorMessage___3RYac"};

/***/ }),

/***/ "49Rk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"search__msignaturepad___21Rpu","m-signature-pad--body":"search__m-signature-pad--body___28TkX","m-signature-pad--footer":"search__m-signature-pad--footer___pztq1","description":"search__description___3bZ6l","button":"search__button___2Q_TQ","clear":"search__clear___3ht4S","save":"search__save___pJMlu","m-signature-pad":"search__m-signature-pad___3QWWK","github":"search__github___1elcR","wrapper":"search__wrapper___2ps4D","inputElement":"search__inputElement___2fqjY","submit":"search__submit___2Oh2C"};

/***/ }),

/***/ "4cbU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"ZIStyles__msignaturepad___3gtw7","m-signature-pad--body":"ZIStyles__m-signature-pad--body___3HP_M","m-signature-pad--footer":"ZIStyles__m-signature-pad--footer___2tK1A","description":"ZIStyles__description___35qF7","button":"ZIStyles__button___1x2jJ","clear":"ZIStyles__clear___2ZE1b","save":"ZIStyles__save___2_TZr","m-signature-pad":"ZIStyles__m-signature-pad___2sQvL","github":"ZIStyles__github___34Ih7","tag":"ZIStyles__tag___3V7PC","remove":"ZIStyles__remove___1AOpj"};

/***/ }),

/***/ "4uL5":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "interior_handing-dcae372e64f96a24a544e76203fea5b5.png";

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "5HtU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___18SBg","m-signature-pad--body":"styles__m-signature-pad--body___23m7A","m-signature-pad--footer":"styles__m-signature-pad--footer___2sfBQ","description":"styles__description___gCtdc","button":"styles__button___1LuKq","clear":"styles__clear___rY_ES","save":"styles__save___NILMu","m-signature-pad":"styles__m-signature-pad___2Lwnv","github":"styles__github___1dyhS","seeBtnContainer":"styles__seeBtnContainer___qi3BN","seeBtnModalStyles":"styles__seeBtnModalStyles___x46ZM","seeBtnModalHover":"styles__seeBtnModalHover___2DbXR"};

/***/ }),

/***/ "5OXM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___3c05J","m-signature-pad--body":"styles__m-signature-pad--body___1kdJK","m-signature-pad--footer":"styles__m-signature-pad--footer___1YVtj","description":"styles__description____i3MO","button":"styles__button___3UTyd","clear":"styles__clear___3jIOy","save":"styles__save___1L6da","m-signature-pad":"styles__m-signature-pad___22dT_","github":"styles__github___r9QaN","headerContainer":"styles__headerContainer___2em7j","title":"styles__title___1QL_L","standardButton":"styles__standardButton___2RdpP","saveButton":"styles__saveButton___JlSF3","cancelButton":"styles__cancelButton___1veqa","card":"styles__card___1BFtr","checklistContainer":"styles__checklistContainer___3PYt6","checklistFlexContainer":"styles__checklistFlexContainer___3emqG","checklistUserNote":"styles__checklistUserNote___cKYwh","checklistQuestion":"styles__checklistQuestion___17-fg","checklistText":"styles__checklistText___3Y4k2","checklistError":"styles__checklistError___2Yxc8","scriptList":"styles__scriptList___2k_sl","prefillBanner":"styles__prefillBanner___OcmAU","prefillTag":"styles__prefillTag___1EViz","spotbotSuggestions":"styles__spotbotSuggestions___yoz_i","suggestionRow":"styles__suggestionRow___2t7_Y","suggestionInfo":"styles__suggestionInfo___2vs2w","suggestionTitle":"styles__suggestionTitle___2r2cO","suggestionReason":"styles__suggestionReason___2YM-u","suggestionActions":"styles__suggestionActions___TZpVh","appliedChip":"styles__appliedChip___3UgG0","verificationTable":"styles__verificationTable___127PZ","statusError":"styles__statusError___3Rzzr","statusCorrect":"styles__statusCorrect___3cD96"};

/***/ }),

/***/ "5nhd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return membersContainCrews; });
/* unused harmony export membersContainNonCrews */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return membersMatchAssignment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return determineProjectedCompletion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return doTimesOverlap; });
/* unused harmony export determineBookedDay */
/* unused harmony export multiDayApptsExist */
/* unused harmony export pendingMultiDayOverlap */
/* unused harmony export getOverlappingAppts */
/* unused harmony export getScheduledLengths */
/* unused harmony export ptoScheduled */
/* unused harmony export surfaceMismatch */
/* unused harmony export hasCapacityForSqft */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return maxDistanceExceeded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return existingApptsRelate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return determineCellBlock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return isTimeBlocked; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return determineAdjustedStartTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isAvailableForDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return reorderResultsAndPrioritizeCrews; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return sortSuggestions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return groupSuggestionsByPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getInstallSuggestions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services__ = __webpack_require__("NvlE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index__ = __webpack_require__("FbQg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dateUtils__ = __webpack_require__("N46Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_config_constants__ = __webpack_require__("JKMY");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var dateDay = function dateDay(date) {
  return date.day() + 1;
};

var memberIsCrew = function memberIsCrew(member) {
  return member.assignee.kind === 'Crew';
};

var memberHasMismatch = function memberHasMismatch(member) {
  return member.assignee.specificMismatch;
};

var membersContainCrews = function membersContainCrews(members) {
  return members.some(memberIsCrew);
};

var membersContainNonCrews = function membersContainNonCrews(members) {
  return members.some(function (m) {
    return !memberIsCrew(m);
  });
};

// IFI phases only: show just the assigned estimator (assessments) and the assigned
// installer's crews (assessments/installations/workorders) by default. The rest of the
// qualifying estimators/crews are hidden unless "Show Mismatched Estimators/Crews" is on.
// A phase with no estimator/installer assigned yet filters nothing (nothing to match against).
var membersMatchAssignment = function membersMatchAssignment(members, phaseSource, showMismatched, phaseEstimatorId, phaseInstallerId) {
  if (phaseSource !== 'IFI') return members;
  return members.filter(function (m) {
    var _m$assignee = m.assignee,
        kind = _m$assignee.kind,
        id = _m$assignee.id,
        installerId = _m$assignee.installer_id;

    if (kind === 'Estimator') return showMismatched || !phaseEstimatorId || id === phaseEstimatorId;
    if (kind === 'Crew') return showMismatched || !phaseInstallerId || installerId === phaseInstallerId;
    return true;
  });
};

var separateCrews = function separateCrews(members) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["partition"])(members, function (m) {
    return memberIsCrew(m);
  });
};

var separateMismatches = function separateMismatches(members) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["partition"])(members, function (m) {
    return memberHasMismatch(m);
  });
};

var getSpecificsToMatch = function getSpecificsToMatch(phaseSpecifics) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["keys"])(Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["pickBy"])(phaseSpecifics)).filter(function (k) {
    return !__WEBPACK_IMPORTED_MODULE_5_config_constants__["_7" /* NON_COMPARABLE_SPECIFIC_FIELDS */].includes(k);
  });
};

var getTimeAddedByQty = function getTimeAddedByQty(phaseLineItems, itemNumbers, multiplier) {
  var total = 0;
  phaseLineItems.forEach(function (i) {
    var timeAdded = itemNumbers.includes(i.item_number) ? parseInt(i.quantity, 10) * multiplier : 0;
    total += timeAdded;
  });
  return total;
};

var getTimeAdded = function getTimeAdded(key, phaseLineItems, sqft) {
  var _SS_PLI_MULTIPLIERS$k = __WEBPACK_IMPORTED_MODULE_5_config_constants__["_34" /* SS_PLI_MULTIPLIERS */][key],
      itemNumbers = _SS_PLI_MULTIPLIERS$k.itemNumbers,
      multiplier = _SS_PLI_MULTIPLIERS$k.multiplier;

  if (key === 'need_move_furniture') return sqft * multiplier;
  if (Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(itemNumbers) || !multiplier) return multiplier;
  return getTimeAddedByQty(phaseLineItems, itemNumbers, multiplier);
};

var getPhaseSpecificTime = function getPhaseSpecificTime(phaseSpecificsToMatch, phaseLineItems, sqft) {
  var total = 0;
  phaseSpecificsToMatch.forEach(function (s) {
    var timeAdded = s in __WEBPACK_IMPORTED_MODULE_5_config_constants__["_34" /* SS_PLI_MULTIPLIERS */] ? getTimeAdded(s, phaseLineItems, sqft) : 0;
    total += timeAdded;
  });
  return total;
};

var determineSurfaceJobLength = function determineSurfaceJobLength(specific, sqft) {
  if (specific === 0) return 0; // avoids infinity case
  return sqft * __WEBPACK_IMPORTED_MODULE_5_config_constants__["_62" /* WORK_DAY_HOURS */] / specific;
};

var determineBaseJobLength = function determineBaseJobLength(crewSpecifics, pendingSurface, sqft) {
  var hardwood_sf_per_day = crewSpecifics.hardwood_sf_per_day,
      carpet_sf_per_day = crewSpecifics.carpet_sf_per_day,
      tile_sf_per_day = crewSpecifics.tile_sf_per_day,
      laminate_sf_per_day = crewSpecifics.laminate_sf_per_day,
      vinyl_sf_per_day = crewSpecifics.vinyl_sf_per_day,
      vinyl_plank_sf_per_day = crewSpecifics.vinyl_plank_sf_per_day,
      backsplash_sf_per_day = crewSpecifics.backsplash_sf_per_day;

  switch (pendingSurface) {
    case 'Hardwood':
      return determineSurfaceJobLength(hardwood_sf_per_day, sqft);
    case 'Carpet':
      return determineSurfaceJobLength(carpet_sf_per_day, sqft);
    case 'Tile':
      return determineSurfaceJobLength(tile_sf_per_day, sqft);
    case 'Laminate':
      return determineSurfaceJobLength(laminate_sf_per_day, sqft);
    case 'Vinyl':
      return determineSurfaceJobLength(vinyl_sf_per_day, sqft);
    case 'Vinyl Plank':
      return determineSurfaceJobLength(vinyl_plank_sf_per_day, sqft);
    case 'Backsplash':
      return determineSurfaceJobLength(backsplash_sf_per_day, sqft);
    default:
      return 0;
  }
};

var determineFullDays = function determineFullDays(hours) {
  return Math.floor(hours / __WEBPACK_IMPORTED_MODULE_5_config_constants__["_62" /* WORK_DAY_HOURS */]);
};

var determineDaysFromHours = function determineDaysFromHours(hours) {
  if (__WEBPACK_IMPORTED_MODULE_5_config_constants__["_62" /* WORK_DAY_HOURS */] > hours) return 1;
  return determineFullDays(hours) + (hours % __WEBPACK_IMPORTED_MODULE_5_config_constants__["_62" /* WORK_DAY_HOURS */] > 0 ? 1 : 0);
};

var determineAddedHours = function determineAddedHours(hours) {
  return Math.ceil(hours - __WEBPACK_IMPORTED_MODULE_5_config_constants__["_62" /* WORK_DAY_HOURS */] * determineFullDays(hours));
};

var determineProjectedCompletion = function determineProjectedCompletion(hours, days, startDate, startTime, defaultStartTime) {
  var date = Object(__WEBPACK_IMPORTED_MODULE_4__dateUtils__["r" /* parseDateStrict */])(startDate, [__WEBPACK_IMPORTED_MODULE_5_config_constants__["E" /* DISPLAY_DATE */], __WEBPACK_IMPORTED_MODULE_5_config_constants__["_19" /* RAILS_DATE */]]);
  var start = __WEBPACK_IMPORTED_MODULE_1_moment___default()(date.format(__WEBPACK_IMPORTED_MODULE_5_config_constants__["E" /* DISPLAY_DATE */]) + ' ' + startTime, __WEBPACK_IMPORTED_MODULE_5_config_constants__["E" /* DISPLAY_DATE */] + ' ' + __WEBPACK_IMPORTED_MODULE_5_config_constants__["_3" /* MOMENT_TIME */], true);
  var normalizedDefaultStart = defaultStartTime || startTime;

  if (!date.isValid() || !start.isValid()) return '';

  if (days <= 1) {
    return start.clone().add(Math.ceil(hours), 'hours').format(__WEBPACK_IMPORTED_MODULE_5_config_constants__["F" /* DISPLAY_DATE_TIME */]);
  }

  var lastDayStart = __WEBPACK_IMPORTED_MODULE_1_moment___default()(date.clone().add(days - 1, 'days').format(__WEBPACK_IMPORTED_MODULE_5_config_constants__["E" /* DISPLAY_DATE */]) + ' ' + normalizedDefaultStart, __WEBPACK_IMPORTED_MODULE_5_config_constants__["E" /* DISPLAY_DATE */] + ' ' + __WEBPACK_IMPORTED_MODULE_5_config_constants__["_3" /* MOMENT_TIME */], true);
  return lastDayStart.add(determineAddedHours(hours), 'hours').format(__WEBPACK_IMPORTED_MODULE_5_config_constants__["F" /* DISPLAY_DATE_TIME */]);
};

var getCalJobLengthAttrs = function getCalJobLengthAttrs(crews, phaseSpecificsToMatch, pendingAppt) {
  var _pendingAppt$phase = pendingAppt.phase,
      phase_line_items = _pendingAppt$phase.phase_line_items,
      sqft = _pendingAppt$phase.sqft,
      name = _pendingAppt$phase.surface_type.name,
      start_date = pendingAppt.start_date,
      arrival_start_time = pendingAppt.arrival_start_time;

  var phaseSpecificTime = getPhaseSpecificTime(phaseSpecificsToMatch, phase_line_items, sqft);
  return crews.map(function (c) {
    var _c$assignee = c.assignee,
        crew_specific = _c$assignee.crew_specific,
        default_start_time = _c$assignee.default_start_time;

    var projectedJobLength = determineBaseJobLength(crew_specific, name, sqft) + phaseSpecificTime;
    var projectedJobDays = determineDaysFromHours(projectedJobLength);
    var projectedCompletion = determineProjectedCompletion(projectedJobLength, projectedJobDays, start_date, arrival_start_time, default_start_time);
    return _extends({}, c, { projectedJobLength: projectedJobLength, projectedJobDays: projectedJobDays, projectedCompletion: projectedCompletion });
  });
};

var getSuggestionJobLengthAttrs = function getSuggestionJobLengthAttrs(crews, specificsToMatch, phase) {
  var phase_line_items = phase.phase_line_items,
      sqft = phase.sqft,
      surfaceType = phase.surface_type.name;

  var specificsTime = getPhaseSpecificTime(specificsToMatch, phase_line_items, sqft);
  return crews.map(function (c) {
    var _c$assignee2 = c.assignee,
        crew_specific = _c$assignee2.crew_specific,
        delivery_dedicated = _c$assignee2.delivery_dedicated;

    var jobLengthAttrs = { projectedJobLength: null, projectedJobDays: null };
    if (!delivery_dedicated) {
      var projectedJobLength = Math.round((specificsTime + determineBaseJobLength(crew_specific, surfaceType, sqft)) * 10) / 10;
      jobLengthAttrs = {
        projectedJobLength: projectedJobLength,
        projectedJobDays: determineDaysFromHours(projectedJobLength)
      };
    }
    return _extends({}, c, jobLengthAttrs);
  });
};

var overlapExists = function overlapExists(pendingStart, pendingEnd, existingStart, existingEnd) {
  var pendingStartOverlap = pendingStart.isSameOrAfter(existingStart) && pendingStart.isSameOrBefore(existingEnd);
  var pendingEndOverlap = pendingEnd.isSameOrAfter(existingStart) && pendingEnd.isSameOrBefore(existingEnd);
  var existingStartOverlap = existingStart.isSameOrAfter(pendingStart) && existingStart.isSameOrBefore(pendingEnd);
  var existingEndOverlap = existingEnd.isSameOrAfter(pendingStart) && existingEnd.isSameOrBefore(pendingEnd);
  return pendingStartOverlap || pendingEndOverlap || existingStartOverlap || existingEndOverlap;
};

var doDatesOverlap = function doDatesOverlap(pendingAppt, existingAppt) {
  var pendingStart = __WEBPACK_IMPORTED_MODULE_1_moment___default()(pendingAppt.start_date);
  var pendingEnd = __WEBPACK_IMPORTED_MODULE_1_moment___default()(pendingAppt.end_date);
  var existingStart = __WEBPACK_IMPORTED_MODULE_1_moment___default()(existingAppt.start_date);
  var existingEnd = __WEBPACK_IMPORTED_MODULE_1_moment___default()(existingAppt.end_date);
  return overlapExists(pendingStart, pendingEnd, existingStart, existingEnd);
};

var doTimesOverlap = function doTimesOverlap(pendingAppt, existingAppt) {
  var pendingDate = pendingAppt.start_date,
      pendingTime = pendingAppt.arrival_start_time,
      projectedCompletion = pendingAppt.projectedCompletion;
  var existingDate = existingAppt.start_date,
      existingTime = existingAppt.arrival_start_time,
      projected_completion = existingAppt.projected_completion;

  if (!(projected_completion || '')) return true;
  var pendingStart = __WEBPACK_IMPORTED_MODULE_1_moment___default()(pendingDate + ' ' + pendingTime);
  var pendingEnd = __WEBPACK_IMPORTED_MODULE_1_moment___default()(projectedCompletion);
  var existingStart = __WEBPACK_IMPORTED_MODULE_1_moment___default()(existingDate + ' ' + existingTime);
  var existingEnd = __WEBPACK_IMPORTED_MODULE_1_moment___default()(projected_completion);
  return overlapExists(pendingStart, pendingEnd, existingStart, existingEnd);
};

var determineBookedDay = function determineBookedDay(overlappingAppts) {
  return overlappingAppts.length > 1;
};

var multiDayApptsExist = function multiDayApptsExist(apptLengths) {
  return apptLengths.some(function (n) {
    return n > 1;
  });
};

var pendingMultiDayOverlap = function pendingMultiDayOverlap(pendingDayCount, overlappingAppts) {
  return pendingDayCount > 1 && overlappingAppts.length > 0;
};

var determineOverlappingDates = function determineOverlappingDates(pendingAppt, crewSchedule) {
  if (crewSchedule < 1) return false;
  var values = [];
  crewSchedule.forEach(function (a) {
    return values.push(doDatesOverlap(pendingAppt, a));
  });
  return values.some(function (v) {
    return v;
  });
};

var getOverlappingAppts = function getOverlappingAppts(pendingAppt, crewSchedule) {
  return crewSchedule.filter(function (a) {
    return doDatesOverlap(pendingAppt, a);
  });
};

var getApptLength = function getApptLength(appt) {
  return Object(__WEBPACK_IMPORTED_MODULE_4__dateUtils__["e" /* getDayCount */])(appt.start_date, appt.end_date);
};

var getScheduledLengths = function getScheduledLengths(crewSchedule) {
  var lengths = [];
  crewSchedule.forEach(function (a) {
    return lengths.push(getApptLength(a));
  });
  return lengths;
};

var determineOverlappingDatesSurfacesMatch = function determineOverlappingDatesSurfacesMatch(pendingAppt, crewSchedule) {
  return !getOverlappingAppts(pendingAppt, crewSchedule).some(function (o) {
    return (((o.phase || {}).surface_type || {}).name || '') !== pendingAppt.phase.surface_type.name;
  });
};

var getOverlappingDatesAttrs = function getOverlappingDatesAttrs(crews, pendingAppt) {
  var overlapDeterminedCrews = [];
  crews.forEach(function (c) {
    var _c$ss_availability = c.ss_availability,
        appts = _c$ss_availability.appts,
        pto = _c$ss_availability.pto;

    var crewSchedule = appts.concat(pto);
    var overlappingDates = determineOverlappingDates(pendingAppt, crewSchedule);
    var overlappingDatesSurfacesMismatch = overlappingDates ? !determineOverlappingDatesSurfacesMatch(pendingAppt, crewSchedule) : false;
    overlapDeterminedCrews.push(_extends({}, c, { overlappingDates: overlappingDates, overlappingDatesSurfacesMismatch: overlappingDatesSurfacesMismatch }));
  });
  return overlapDeterminedCrews;
};

var hasSqftCapacity = function hasSqftCapacity(sfPerDay, pendingSqft, pendingDayCount, scheduledSqft) {
  if (pendingDayCount < 2) return sfPerDay - (pendingSqft + scheduledSqft) >= 0;
  return sfPerDay * pendingDayCount >= pendingSqft;
};

var isPto = function isPto(appt) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isUndefined"])(appt.phase);
};

var ptoScheduled = function ptoScheduled(crewSchedule) {
  return crewSchedule.some(function (a) {
    return isPto(a);
  });
};

var doSurfacesMatch = function doSurfacesMatch(existingSurface, pendingSurface, sameDayMultiSurface) {
  return __WEBPACK_IMPORTED_MODULE_5_config_constants__["_5" /* MULTI_SURFACE_ENABLED */].includes(pendingSurface) && pendingSurface === existingSurface || sameDayMultiSurface && !Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["difference"])([existingSurface, pendingSurface], __WEBPACK_IMPORTED_MODULE_5_config_constants__["_5" /* MULTI_SURFACE_ENABLED */]).length;
};

var surfaceMismatch = function surfaceMismatch(crewSchedule, pendingSurface, sameDayMultiSurface) {
  if (ptoScheduled(crewSchedule)) return false;
  return crewSchedule.some(function (a) {
    return !doSurfacesMatch(a.phase.surface_type.name, pendingSurface, sameDayMultiSurface);
  });
};

var hasCapacityForSqft = function hasCapacityForSqft(pendingSurface, pendingSqft, pendingDayCount, crewSchedule, crewSpecifics) {
  if (ptoScheduled(crewSchedule) || surfaceMismatch(crewSchedule, pendingSurface, crewSpecifics.same_day_multi_surface)) return false;
  var hardwood_sf_per_day = crewSpecifics.hardwood_sf_per_day,
      carpet_sf_per_day = crewSpecifics.carpet_sf_per_day,
      tile_sf_per_day = crewSpecifics.tile_sf_per_day,
      laminate_sf_per_day = crewSpecifics.laminate_sf_per_day,
      vinyl_sf_per_day = crewSpecifics.vinyl_sf_per_day,
      vinyl_plank_sf_per_day = crewSpecifics.vinyl_plank_sf_per_day,
      backsplash_sf_per_day = crewSpecifics.backsplash_sf_per_day;

  var scheduledSqft = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["sumBy"])(crewSchedule, function (a) {
    return a.phase.sqft;
  });
  switch (pendingSurface) {
    case 'Hardwood':
      return hasSqftCapacity(hardwood_sf_per_day, pendingSqft, pendingDayCount, scheduledSqft);
    case 'Carpet':
      return hasSqftCapacity(carpet_sf_per_day, pendingSqft, pendingDayCount, scheduledSqft);
    case 'Tile':
      return hasSqftCapacity(tile_sf_per_day, pendingSqft, pendingDayCount, scheduledSqft);
    case 'Laminate':
      return hasSqftCapacity(laminate_sf_per_day, pendingSqft, pendingDayCount, scheduledSqft);
    case 'Vinyl':
      return hasSqftCapacity(vinyl_sf_per_day, pendingSqft, pendingDayCount, scheduledSqft);
    case 'Vinyl Plank':
      return hasSqftCapacity(vinyl_plank_sf_per_day, pendingSqft, pendingDayCount, scheduledSqft);
    case 'Backsplash':
      return hasSqftCapacity(backsplash_sf_per_day, pendingSqft, pendingDayCount, scheduledSqft);
    default:
      return false;
  }
};

var getSuggestionMapAttr = function getSuggestionMapAttr(suggestionObj, deliverySuggestionObj, phaseId, storeId) {
  var suggestions = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(deliverySuggestionObj) ? suggestionObj.suggestions : suggestionObj.suggestions.concat(deliverySuggestionObj.suggestions);
  var editedSuggestions = suggestions.map(function (s) {
    var _s$sameDayAppt = s.sameDayAppt,
        sameDayAppt = _s$sameDayAppt === undefined ? [] : _s$sameDayAppt,
        type = s.type;

    if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(sameDayAppt)) {
      var originId = null;
      var destinationId = null;
      if (type === 'delivery') {
        originId = sameDayAppt[0].phase.store.id;
        destinationId = storeId;
      } else {
        originId = sameDayAppt.phase.id;
        destinationId = phaseId;
      }
      return Object(__WEBPACK_IMPORTED_MODULE_2__services__["g" /* getMapMatrix */])({ originId: originId, destinationId: destinationId, type: type }).then(function (m) {
        return _extends({}, s, { mapMatrix: m });
      });
    }
    return _extends({}, s, { mapMatrix: {} });
  });
  return Promise.all(editedSuggestions).then(function (allSuggestions) {
    return {
      deliverySuggestions: allSuggestions.filter(function (s) {
        return s.type === 'delivery';
      }),
      suggestions: allSuggestions.filter(function (s) {
        return s.type === 'install';
      })
    };
  }).catch(function () {
    return _extends({}, suggestionObj, deliverySuggestionObj, {});
  });
};

var warningPrefix = function warningPrefix(warning) {
  return warning ? ', ' : 'WARNING: ';
};

var maxDistanceExceeded = function maxDistanceExceeded(duration, maxTravelTime) {
  return duration / 60 > maxTravelTime;
};

var existingWorkorder = function existingWorkorder(appts) {
  return appts.some(function (a) {
    return a.phase.type === 'Workorder';
  });
};

var existingApptsRelate = function existingApptsRelate(pendingId, appts) {
  var relatedPhases = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  return appts.length && appts.every(function (a) {
    return !Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(a.phase || {}) && ((a.phase || {}).id === pendingId || relatedPhases.some(function (p) {
      return p.id === (a.phase || {}).id;
    }));
  });
};

var futureMultiOverlap = function futureMultiOverlap(date, projectedJobDays, soonestLaterAppt) {
  var start_date = soonestLaterAppt.start_date,
      end_date = soonestLaterAppt.end_date;

  return (projectedJobDays > 1 || start_date !== end_date) && date.clone().add(projectedJobDays - 1, 'days').isSameOrAfter(__WEBPACK_IMPORTED_MODULE_1_moment___default()(start_date));
};

var determineCellBlock = function determineCellBlock(date, daySched, assignee, pendingAppt, twdData, allSched, isCcs) {
  if (assignee.specificMismatch || false) return 'WARNING: crew specifics do not match phase specifics';
  var warning = '';
  var _daySched$appts = daySched.appts,
      appts = _daySched$appts === undefined ? [] : _daySched$appts,
      _daySched$pto = daySched.pto,
      pto = _daySched$pto === undefined ? {} : _daySched$pto;

  var filteredAllSched = allSched && allSched.length ? allSched.filter(function (a) {
    return a.id > 0 && a.id !== pendingAppt.id;
  }) : [];
  var filteredAppts = appts.length ? appts.filter(function (a) {
    return a.id > 0 && a.id !== pendingAppt.id;
  }) : [];
  if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isUndefined"])(pto) && !Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(pto)) {
    warning += warningPrefix(warning) + __WEBPACK_IMPORTED_MODULE_5_config_constants__["_47" /* TIME_CONSTRAINT_MESSAGES */][0];
    if (isCcs) return warning;
  }
  var relatedPhases = pendingAppt.relatedPhases,
      _pendingAppt$phase2 = pendingAppt.phase,
      id = _pendingAppt$phase2.id,
      sqft = _pendingAppt$phase2.sqft,
      zip_code = _pendingAppt$phase2.zip_code,
      name = _pendingAppt$phase2.surface_type.name;
  var _assignee$crew_specif = assignee.crew_specific,
      crew_specific = _assignee$crew_specif === undefined ? {} : _assignee$crew_specif,
      projectedCompletion = assignee.projectedCompletion,
      projectedJobDays = assignee.projectedJobDays,
      covered_zip_codes = assignee.covered_zip_codes;
  var _twdData$twd = twdData.twd,
      twd = _twdData$twd === undefined ? {} : _twdData$twd,
      _twdData$twdZip = twdData.twdZip,
      twdZip = _twdData$twdZip === undefined ? '' : _twdData$twdZip;

  if (Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isUndefined"])(twd) || Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(twd)) {
    if (twdZip && !covered_zip_codes.includes(zip_code)) {
      warning += warningPrefix(warning) + __WEBPACK_IMPORTED_MODULE_5_config_constants__["_49" /* TWD_MESSAGES */][0];
      if (isCcs) return warning;
    }
  } else if (!twd.traveling_zip_codes.includes(zip_code)) {
    warning += warningPrefix(warning) + __WEBPACK_IMPORTED_MODULE_5_config_constants__["_49" /* TWD_MESSAGES */][1];
    if (isCcs) return warning;
  }
  if (existingWorkorder(filteredAppts)) {
    warning += warningPrefix(warning) + 'workorder scheduled';
    if (isCcs) return warning;
  }
  var apptsRelate = existingApptsRelate(id, filteredAppts, relatedPhases);
  var isSurfaceMismatch = surfaceMismatch(filteredAppts, name, crew_specific.same_day_multi_surface);
  var laterAppts = !filteredAllSched.length ? [] : filteredAllSched.filter(function (a) {
    return date.isSameOrBefore(a.start_date);
  }).sort(function (a, b) {
    return __WEBPACK_IMPORTED_MODULE_1_moment___default()(a.start_date).diff(b.start_date);
  });
  var existingDQ = !Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(filteredAppts) && (!apptsRelate || isSurfaceMismatch);
  if (laterAppts.length && !existingApptsRelate(id, [laterAppts[0]], relatedPhases) && futureMultiOverlap(date, projectedJobDays, laterAppts[0])) {
    warning += warningPrefix(warning) + __WEBPACK_IMPORTED_MODULE_5_config_constants__["_47" /* TIME_CONSTRAINT_MESSAGES */][1];
  } else if (existingDQ) {
    if (multiDayApptsExist(getScheduledLengths(filteredAppts)) || pendingMultiDayOverlap(projectedJobDays, filteredAppts)) {
      warning += warningPrefix(warning) + __WEBPACK_IMPORTED_MODULE_5_config_constants__["_47" /* TIME_CONSTRAINT_MESSAGES */][1];
    }
    if (determineBookedDay(filteredAppts)) {
      warning += warningPrefix(warning) + __WEBPACK_IMPORTED_MODULE_5_config_constants__["_47" /* TIME_CONSTRAINT_MESSAGES */][2];
    }
    /*
    * RegExp object and function used to check and see if the warning already
    * contains any of the messages above.
    */
    if (!new RegExp(__WEBPACK_IMPORTED_MODULE_5_config_constants__["_47" /* TIME_CONSTRAINT_MESSAGES */].join('|')).test(warning) && filteredAppts.length && doTimesOverlap(_extends({}, pendingAppt, { projectedCompletion: projectedCompletion }), filteredAppts[0])) {
      warning += warningPrefix(warning) + __WEBPACK_IMPORTED_MODULE_5_config_constants__["_47" /* TIME_CONSTRAINT_MESSAGES */][3];
    }
    if (isSurfaceMismatch) warning += warningPrefix(warning) + __WEBPACK_IMPORTED_MODULE_5_config_constants__["_47" /* TIME_CONSTRAINT_MESSAGES */][4];
    if (!isSurfaceMismatch && !hasCapacityForSqft(name, sqft, projectedJobDays, filteredAppts, crew_specific)) warning += warningPrefix(warning) + 'over crew capacity';
  }
  return warning;
};

var isTimeBlocked = function isTimeBlocked(ssBlockage) {
  return ssBlockage === 'Blocked due to: times overlap';
};

var determineAdjustedStartTime = function determineAdjustedStartTime(existingAppt, crew) {
  var arrival_start_time = existingAppt.arrival_start_time,
      start_date = existingAppt.start_date,
      projected_completion = existingAppt.projected_completion;
  var default_start_time = crew.default_start_time,
      projectedJobLength = crew.projectedJobLength;

  if (!(projected_completion || '')) return arrival_start_time;
  var startOfDayMoment = __WEBPACK_IMPORTED_MODULE_1_moment___default()(start_date + ' ' + default_start_time);
  var existingArrivalMoment = __WEBPACK_IMPORTED_MODULE_1_moment___default()(start_date + ' ' + arrival_start_time);
  var existingCompleteMoment = __WEBPACK_IMPORTED_MODULE_1_moment___default()(projected_completion);
  if (existingArrivalMoment.diff(startOfDayMoment, 'hours', true) - 1 > projectedJobLength) return default_start_time;
  return existingCompleteMoment.add(1, 'hour').format('HH:mm');
};

var getApptRange = function getApptRange(appt) {
  return __WEBPACK_IMPORTED_MODULE_1_moment___default.a.range(__WEBPACK_IMPORTED_MODULE_1_moment___default()(appt.start_date), __WEBPACK_IMPORTED_MODULE_1_moment___default()(appt.end_date));
};

var rangeContainsDate = function rangeContainsDate(appt, date) {
  return getApptRange(appt).contains(date);
};

var coveredBySchedule = function coveredBySchedule() {
  var appts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var date = arguments[1];
  return appts.length > 0 && appts.some(function (a) {
    return rangeContainsDate(a, date);
  });
};

var getNextOpeningAttr = function getNextOpeningAttr(crews, defaultCalStart) {
  var calStartDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(defaultCalStart).format(__WEBPACK_IMPORTED_MODULE_5_config_constants__["E" /* DISPLAY_DATE */]);
  var nextOpeningDeterminedCrews = [];
  crews.forEach(function (c) {
    var projectedJobDays = c.projectedJobDays,
        _c$ss_availability2 = c.ss_availability,
        appts = _c$ss_availability2.appts,
        pto = _c$ss_availability2.pto;

    var crewSchedule = appts.concat(pto);
    var date = Object(__WEBPACK_IMPORTED_MODULE_4__dateUtils__["r" /* parseDateStrict */])(calStartDate, __WEBPACK_IMPORTED_MODULE_5_config_constants__["E" /* DISPLAY_DATE */]);
    var nextOpening = '';
    var availableDays = 0;
    while (availableDays < projectedJobDays) {
      if (coveredBySchedule(crewSchedule, date)) {
        nextOpening = '';
        date.add(1, 'day');
        availableDays = 0;
      } else if (!nextOpening) {
        nextOpening = date.format(__WEBPACK_IMPORTED_MODULE_5_config_constants__["E" /* DISPLAY_DATE */]);
        date.add(1, 'day');
        availableDays += 1;
      } else {
        date.add(1, 'day');
        availableDays += 1;
      }
    }
    nextOpeningDeterminedCrews.push(_extends({}, c, { nextOpening: nextOpening }));
  });
  return nextOpeningDeterminedCrews;
};

var isTravelZip = function isTravelZip(travelZips, phaseZip) {
  return travelZips.includes(phaseZip);
};

var coveredByTravel = function coveredByTravel(twd, date, crew, zipCode) {
  var covered_zip_codes = crew.covered_zip_codes,
      traveling_zip_codes = crew.traveling_zip_codes;

  if (twd.length < 1 || traveling_zip_codes.length < 1) return false;
  if (isTravelZip(traveling_zip_codes, zipCode)) {
    var applicableTwd = twd.find(function (t) {
      return rangeContainsDate(t, date);
    }) || {};
    return !covered_zip_codes.includes(zipCode) && (Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(applicableTwd) || !applicableTwd.traveling_zip_codes.includes(zipCode));
  }
  return coveredBySchedule(twd, date);
};

var getTimeDiff = function getTimeDiff(start, end, unit, includeDecimal) {
  return end.diff(start, unit, includeDecimal);
};

var noTimeInDay = function noTimeInDay(appt, crew) {
  var arrival_start_time = appt.arrival_start_time,
      start_date = appt.start_date,
      projected_completion = appt.projected_completion;

  if (!(projected_completion || '')) return true;
  var default_start_time = crew.default_start_time,
      _crew$projectedJobLen = crew.projectedJobLength,
      projectedJobLength = _crew$projectedJobLen === undefined ? 0 : _crew$projectedJobLen;

  var startOfDayMoment = __WEBPACK_IMPORTED_MODULE_1_moment___default()(start_date + ' ' + default_start_time);
  var existingArrivalMoment = __WEBPACK_IMPORTED_MODULE_1_moment___default()(start_date + ' ' + arrival_start_time);
  var existingCompleteMoment = __WEBPACK_IMPORTED_MODULE_1_moment___default()(projected_completion);
  var endOfDayMoment = startOfDayMoment.clone().add(__WEBPACK_IMPORTED_MODULE_5_config_constants__["_62" /* WORK_DAY_HOURS */], 'hours');
  var beforeTime = getTimeDiff(startOfDayMoment, existingArrivalMoment, 'hours', true);
  var afterTime = getTimeDiff(existingCompleteMoment, endOfDayMoment, 'hours', true);
  return afterTime - 1 < projectedJobLength && beforeTime - 1 < projectedJobLength;
};

var hasSuggestionCap = function hasSuggestionCap(capacity, existingSqft, pendingSqft) {
  return capacity - (existingSqft + pendingSqft) >= 0;
};

/*
 * TODO: this WILL need to be redone if we ever allow different surface types to
 * be scheduled on the same day. As things are currently set up, we only have
 * the means to measure capacity if appt surfaces match, as there is no formula
 * for comparing capacity of one surface to another. ANYWHERE capacity is
 * evaluated, for that matter, will need to be considered.
 */
var willBeOverCap = function willBeOverCap(surfaceType, crewSpecifics, existingSqft, pendingSqft) {
  var hardwood_sf_per_day = crewSpecifics.hardwood_sf_per_day,
      carpet_sf_per_day = crewSpecifics.carpet_sf_per_day,
      tile_sf_per_day = crewSpecifics.tile_sf_per_day,
      laminate_sf_per_day = crewSpecifics.laminate_sf_per_day,
      vinyl_sf_per_day = crewSpecifics.vinyl_sf_per_day,
      vinyl_plank_sf_per_day = crewSpecifics.vinyl_plank_sf_per_day,
      backsplash_sf_per_day = crewSpecifics.backsplash_sf_per_day;

  switch (surfaceType) {
    case 'Hardwood':
      return !hasSuggestionCap(hardwood_sf_per_day, existingSqft, pendingSqft);
    case 'Carpet':
      return !hasSuggestionCap(carpet_sf_per_day, existingSqft, pendingSqft);
    case 'Tile':
      return !hasSuggestionCap(tile_sf_per_day, existingSqft, pendingSqft);
    case 'Laminate':
      return !hasSuggestionCap(laminate_sf_per_day, existingSqft, pendingSqft);
    case 'Vinyl':
      return !hasSuggestionCap(vinyl_sf_per_day, existingSqft, pendingSqft);
    case 'Vinyl Plank':
      return !hasSuggestionCap(vinyl_plank_sf_per_day, existingSqft, pendingSqft);
    case 'Backsplash':
      return !hasSuggestionCap(backsplash_sf_per_day, existingSqft, pendingSqft);
    default:
      return true;
  }
};

var isAvailableForDay = function isAvailableForDay(date, dailyAvailability) {
  var _dailyAvailability$mo = dailyAvailability.morning,
      morning = _dailyAvailability$mo === undefined ? [] : _dailyAvailability$mo,
      _dailyAvailability$af = dailyAvailability.afternoon,
      afternoon = _dailyAvailability$af === undefined ? [] : _dailyAvailability$af;

  return morning.concat(afternoon).includes(dateDay(date));
};

var deliveryLimitByAvailability = function deliveryLimitByAvailability(date, dailyAvailability) {
  var _dailyAvailability$mo2 = dailyAvailability.morning,
      morning = _dailyAvailability$mo2 === undefined ? [] : _dailyAvailability$mo2,
      _dailyAvailability$af2 = dailyAvailability.afternoon,
      afternoon = _dailyAvailability$af2 === undefined ? [] : _dailyAvailability$af2;

  var day = dateDay(date);
  if (morning.includes(day) && afternoon.includes(day)) return 4;else if (morning.includes(day) || afternoon.includes(day)) return 2;
  return 0;
};

// const isAvailableForDayByType = (type, date, crew) =>
// crew[`${type}_availability`].includes(date.day() + 1);

var sortApptsByDelivery = function sortApptsByDelivery(appts, date) {
  var sortedAppts = { deliveryAppts: [], otherAppts: [] };
  if (!appts.length) return sortedAppts;
  var sameDayAppts = appts.filter(function (a) {
    return rangeContainsDate(a, date);
  });
  if (!sameDayAppts.length) return sortedAppts;
  var deliveryAppts = [];
  var otherAppts = [];
  sameDayAppts.forEach(function (a) {
    if (['delivery', 'delivery_hold'].includes(a.kind)) deliveryAppts.push(a);else otherAppts.push(a);
  });
  return { deliveryAppts: deliveryAppts, otherAppts: otherAppts };
};

var determineDeliveryLimit = function determineDeliveryLimit(dailyAvailability, appts, date) {
  var deliveryLimit = deliveryLimitByAvailability(date, dailyAvailability);

  var _sortApptsByDelivery = sortApptsByDelivery(appts, date),
      otherAppts = _sortApptsByDelivery.otherAppts;

  if (deliveryLimit === 0 || !otherAppts.length) return deliveryLimit;
  if (otherAppts.length > 1) return 0;else if (otherAppts.length === 1) deliveryLimit -= 2;
  return deliveryLimit;
};

var deliveryStartTime = function deliveryStartTime(dailyAvailability, crewSched, date) {
  var appts = crewSched.appts;

  var _sortApptsByDelivery2 = sortApptsByDelivery(appts, date),
      _sortApptsByDelivery3 = _sortApptsByDelivery2.deliveryAppts,
      deliveryAppts = _sortApptsByDelivery3 === undefined ? [] : _sortApptsByDelivery3;

  var existingDeliveryCount = deliveryAppts.length;
  var morning = dailyAvailability.morning,
      afternoon = dailyAvailability.afternoon;

  var day = dateDay(date);
  var deliveryLimit = determineDeliveryLimit(dailyAvailability, appts, date);
  if (deliveryLimit < 1 || existingDeliveryCount + 1 > deliveryLimit) return null;
  var startTime = '08:00';
  if (morning.includes(day) && afternoon.includes(day)) {
    startTime = existingDeliveryCount > 1 ? '13:00' : '8:00';
  } else if (afternoon.includes(day)) startTime = '13:00';
  return startTime;
};

var coveredByApptsForDelivery = function coveredByApptsForDelivery(dailyAvailability, appts, date) {
  var sameDayAppts = appts.filter(function (a) {
    return rangeContainsDate(a, date);
  });
  var deliveryAppts = [];
  sameDayAppts.forEach(function (a) {
    return ['delivery', 'delivery_hold'].includes(a.kind) ? deliveryAppts.push(a) : null;
  });
  var deliveryLimit = determineDeliveryLimit(dailyAvailability, appts, date);
  return deliveryAppts.length + 1 > deliveryLimit;
};

var coveredByAppts = function coveredByAppts(appts, date, crew, phaseData) {
  var sameDayAppts = appts.filter(function (a) {
    return rangeContainsDate(a, date);
  });
  var id = phaseData.id,
      relatedPhases = phaseData.relatedPhases,
      surfaceType = phaseData.surfaceType,
      sqft = phaseData.sqft;
  var projectedJobDays = crew.projectedJobDays,
      specifics = crew.crew_specific,
      multiSurfaceAllowed = crew.crew_specific.same_day_multi_surface;

  if (appts.length < 1 || !coveredBySchedule(appts, date) || sameDayAppts.length < 1 || existingApptsRelate(id, sameDayAppts, relatedPhases)) return false;
  if (existingWorkorder(sameDayAppts) || determineBookedDay(sameDayAppts) || !doSurfacesMatch(sameDayAppts[0].phase.surface_type.name, surfaceType, multiSurfaceAllowed) || getApptLength(sameDayAppts[0]) > 1 || projectedJobDays > 1 || willBeOverCap(surfaceType, specifics, sameDayAppts[0].phase.sqft, sqft) || noTimeInDay(sameDayAppts[0], crew)) return true;
  return false;
};

var dateAlreadySelected = function dateAlreadySelected(date, openings) {
  return openings.includes(date);
};

// const overlapsWeekend = date => [0, 6].includes(date.day());

var overlapsHoliday = function overlapsHoliday(date) {
  var holidays = [Object(__WEBPACK_IMPORTED_MODULE_4__dateUtils__["n" /* getThanksgiving */])(), Object(__WEBPACK_IMPORTED_MODULE_4__dateUtils__["d" /* getChristmasEve */])(), Object(__WEBPACK_IMPORTED_MODULE_4__dateUtils__["c" /* getChristmasDay */])()];
  return holidays.includes(date);
};

var blockedByVendor = function blockedByVendor(appts, date, _ref) {
  var source = _ref.source;

  var sameDayAppts = appts.filter(function (a) {
    return rangeContainsDate(a, date);
  });
  if (!sameDayAppts.length) return false;
  if (__WEBPACK_IMPORTED_MODULE_5_config_constants__["V" /* LHI_SOURCES */].includes(source)) {
    return sameDayAppts.some(function (a) {
      return !__WEBPACK_IMPORTED_MODULE_5_config_constants__["V" /* LHI_SOURCES */].includes(a.phase.source);
    });
  }
  return sameDayAppts.some(function (a) {
    return a.phase.source !== source;
  });
};

var isDeliveryDayCovered = function isDeliveryDayCovered(crewSched, dateData, crew, phaseData) {
  var newDate = dateData.newDate,
      openings = dateData.openings;
  var appts = crewSched.appts,
      pto = crewSched.pto,
      twd = crewSched.twd;
  var daily_availability = crew.daily_availability;

  if ( /*
       not using this for now
       !isAvailableForDayByType('delivery', newDate, crew) ||
       */
  blockedByVendor(appts, newDate, phaseData) || dateAlreadySelected(newDate.clone().format('MM/DD/YYYY'), openings) || overlapsHoliday(newDate.clone().format('MM/DD/YYYY')) || !isAvailableForDay(newDate, daily_availability) || coveredBySchedule(pto, newDate) || coveredByTravel(twd, newDate, crew, phaseData.zip_code) || coveredByApptsForDelivery(daily_availability, appts, newDate)) return true;
  return false;
};

var isDayCovered = function isDayCovered(crewSched, dateData, crew, phaseData) {
  var newDate = dateData.newDate,
      openings = dateData.openings;
  var appts = crewSched.appts,
      pto = crewSched.pto,
      twd = crewSched.twd;

  if (blockedByVendor(appts, newDate, phaseData) || dateAlreadySelected(newDate.clone().format('MM/DD/YYYY'), openings) || overlapsHoliday(newDate.clone().format('MM/DD/YYYY')) || !isAvailableForDay(newDate, crew.daily_availability) || coveredBySchedule(pto, newDate) || coveredByTravel(twd, newDate, crew, phaseData.zip_code) || coveredByAppts(appts, newDate, crew, phaseData)) return true;
  return false;
};

var getSuggestionStartTime = function getSuggestionStartTime(date, defaultStart, projDays, projLength, appts) {
  if (projDays > 1 || appts.length < 1 || !coveredBySchedule(appts, date)) return defaultStart;
  var sameDayAppt = appts.find(function (a) {
    return rangeContainsDate(a, date);
  });
  return determineAdjustedStartTime(sameDayAppt, { default_start_time: defaultStart, projectedJobLength: projLength });
};

var noMoreTwd = function noMoreTwd(date, twd, phaseZip) {
  if (!twd.length) return false;
  var currTwd = twd.find(function (d) {
    return d.traveling_zip_codes.includes(phaseZip);
  }) || null;
  if (!currTwd) return false;
  return date.isAfter(__WEBPACK_IMPORTED_MODULE_1_moment___default()(currTwd.end_date));
};

var findSameDayDeliveries = function findSameDayDeliveries(date, appts) {
  return appts.length > 0 ? appts.filter(function (a) {
    return Object(__WEBPACK_IMPORTED_MODULE_4__dateUtils__["g" /* getDisplayDateFromString */])(a.start_date, 'YYYY-MM-DD') === Object(__WEBPACK_IMPORTED_MODULE_4__dateUtils__["g" /* getDisplayDateFromString */])(date, __WEBPACK_IMPORTED_MODULE_5_config_constants__["E" /* DISPLAY_DATE */]) && ['delivery', 'delivery_hold'].includes(a.kind);
  }) || [] : [];
};

var findSameDayExisting = function findSameDayExisting(date, appts) {
  return appts.length > 0 ? appts.find(function (a) {
    return Object(__WEBPACK_IMPORTED_MODULE_4__dateUtils__["g" /* getDisplayDateFromString */])(a.start_date, 'YYYY-MM-DD') === Object(__WEBPACK_IMPORTED_MODULE_4__dateUtils__["g" /* getDisplayDateFromString */])(date, __WEBPACK_IMPORTED_MODULE_5_config_constants__["E" /* DISPLAY_DATE */]);
  }) || {} : {};
};

var determineDeliveryNoAvailability = function determineDeliveryNoAvailability(totalDays, nextOpenings) {
  return nextOpenings.length >= 5 || totalDays >= __WEBPACK_IMPORTED_MODULE_5_config_constants__["_48" /* TOTAL_DAY_LIMIT */];
};

var getSuggestionDeliveryOpenings = function getSuggestionDeliveryOpenings(crews, date, phaseData) {
  var givenDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format(__WEBPACK_IMPORTED_MODULE_5_config_constants__["E" /* DISPLAY_DATE */]);
  var nextOpeningDeterminedCrews = [];
  crews.forEach(function (c) {
    var twd = c.twd,
        ss_availability = c.ss_availability,
        assignee = c.assignee;

    if (!assignee.delivery_dedicated) return;
    var nextOpenings = [];
    var startDate = Object(__WEBPACK_IMPORTED_MODULE_4__dateUtils__["r" /* parseDateStrict */])(givenDate, __WEBPACK_IMPORTED_MODULE_5_config_constants__["E" /* DISPLAY_DATE */]);
    var noMoreAvailability = false;
    while (!noMoreAvailability && nextOpenings.length < 5) {
      if (nextOpenings.length > 0) startDate.add(1, 'day');
      var newDate = startDate.clone();
      var totalDays = 0;
      var nextOpening = '';
      var availableDays = 0;
      while (!availableDays && totalDays < __WEBPACK_IMPORTED_MODULE_5_config_constants__["_48" /* TOTAL_DAY_LIMIT */]) {
        totalDays += 1;
        if (isDeliveryDayCovered(_extends({}, ss_availability, { twd: twd }), { newDate: newDate, openings: nextOpenings.map(function (o) {
            return o.opening;
          }) }, assignee, phaseData)) {
          nextOpening = '';
          availableDays = 0;
          newDate.add(1, 'day');
        } else {
          nextOpening = newDate.format(__WEBPACK_IMPORTED_MODULE_5_config_constants__["E" /* DISPLAY_DATE */]);
          availableDays += 1;
          newDate.add(1, 'day');
        }
      }
      if (totalDays <= __WEBPACK_IMPORTED_MODULE_5_config_constants__["_48" /* TOTAL_DAY_LIMIT */]) {
        if (noMoreTwd(newDate, twd, phaseData.zip_code)) noMoreAvailability = true;
        if (!noMoreAvailability && nextOpening) {
          nextOpenings.push({
            type: 'delivery',
            opening: nextOpening,
            sameDayAppt: findSameDayDeliveries(nextOpening, ss_availability.appts),
            startTime: deliveryStartTime(assignee.daily_availability, _extends({}, ss_availability), Object(__WEBPACK_IMPORTED_MODULE_4__dateUtils__["r" /* parseDateStrict */])(nextOpening, __WEBPACK_IMPORTED_MODULE_5_config_constants__["E" /* DISPLAY_DATE */]))
          });
          noMoreAvailability = determineDeliveryNoAvailability(totalDays, nextOpenings);
        }
      }
      nextOpening = '';
      noMoreAvailability = determineDeliveryNoAvailability(totalDays, nextOpenings);
    }
    nextOpeningDeterminedCrews.push(_extends({}, c, { nextOpenings: nextOpenings }));
  });
  return nextOpeningDeterminedCrews.filter(function (c) {
    return c.nextOpenings.length > 0;
  });
};

var getSuggestionNextOpenings = function getSuggestionNextOpenings(crews, date, phaseData) {
  var zip_code = phaseData.zip_code,
      surfaceId = phaseData.surfaceId,
      isCaliBamboo = phaseData.isCaliBamboo,
      needDelivery = phaseData.needDelivery;

  var buffer = 0;
  if (needDelivery) {
    if (surfaceId === 1) {
      buffer = isCaliBamboo ? __WEBPACK_IMPORTED_MODULE_5_config_constants__["C" /* DELIVERY_BUFFERS */][surfaceId][1] : __WEBPACK_IMPORTED_MODULE_5_config_constants__["C" /* DELIVERY_BUFFERS */][surfaceId][0];
    } else buffer = __WEBPACK_IMPORTED_MODULE_5_config_constants__["C" /* DELIVERY_BUFFERS */][surfaceId][0];
  }
  var defaultMoment = __WEBPACK_IMPORTED_MODULE_1_moment___default()(date);
  if (needDelivery) defaultMoment = defaultMoment.add(buffer, 'days');
  var givenDate = defaultMoment.format(__WEBPACK_IMPORTED_MODULE_5_config_constants__["E" /* DISPLAY_DATE */]);
  var nextOpeningDeterminedCrews = [];
  crews.filter(function (c) {
    return !c.assignee.delivery_dedicated;
  }).forEach(function (c) {
    var projectedJobDays = c.projectedJobDays,
        projectedJobLength = c.projectedJobLength,
        twd = c.twd,
        ss_availability = c.ss_availability,
        assignee = c.assignee;

    var nextOpenings = [];
    var startDate = Object(__WEBPACK_IMPORTED_MODULE_4__dateUtils__["r" /* parseDateStrict */])(givenDate, __WEBPACK_IMPORTED_MODULE_5_config_constants__["E" /* DISPLAY_DATE */]);
    var noMoreAvailability = false;
    while (!noMoreAvailability && nextOpenings.length < 10) {
      if (nextOpenings.length > 0) startDate.add(1, 'day');
      var newDate = startDate.clone();
      var totalDays = 0;
      var nextOpening = '';
      var availableDays = 0;
      while (totalDays < __WEBPACK_IMPORTED_MODULE_5_config_constants__["_48" /* TOTAL_DAY_LIMIT */] && availableDays < projectedJobDays) {
        totalDays += 1;
        if (isDayCovered(_extends({}, ss_availability, { twd: twd }), { newDate: newDate, openings: nextOpenings.map(function (o) {
            return o.opening;
          }) }, _extends({}, assignee, { projectedJobDays: projectedJobDays, projectedJobLength: projectedJobLength }), phaseData)) {
          nextOpening = '';
          newDate.add(1, 'day');
          availableDays = 0;
        } else if (!nextOpening) {
          nextOpening = newDate.format(__WEBPACK_IMPORTED_MODULE_5_config_constants__["E" /* DISPLAY_DATE */]);
          newDate.add(1, 'day');
          availableDays += 1;
        } else {
          newDate.add(1, 'day');
          availableDays += 1;
        }
      }
      if (totalDays <= __WEBPACK_IMPORTED_MODULE_5_config_constants__["_48" /* TOTAL_DAY_LIMIT */]) {
        if (noMoreTwd(newDate, twd, zip_code)) noMoreAvailability = true;
        if (!noMoreAvailability) {
          nextOpenings.push({
            type: 'install',
            opening: nextOpening,
            sameDayAppt: findSameDayExisting(nextOpening, ss_availability.appts),
            startTime: getSuggestionStartTime(Object(__WEBPACK_IMPORTED_MODULE_4__dateUtils__["r" /* parseDateStrict */])(nextOpening, __WEBPACK_IMPORTED_MODULE_5_config_constants__["E" /* DISPLAY_DATE */]), assignee.default_start_time, projectedJobDays, projectedJobLength, ss_availability.appts)
          });
          if (totalDays === __WEBPACK_IMPORTED_MODULE_5_config_constants__["_48" /* TOTAL_DAY_LIMIT */]) noMoreAvailability = true;
        }
      }
      nextOpening = '';
      availableDays = 0;
      if (!noMoreAvailability) noMoreAvailability = totalDays > __WEBPACK_IMPORTED_MODULE_5_config_constants__["_48" /* TOTAL_DAY_LIMIT */];
    }
    nextOpeningDeterminedCrews.push(_extends({}, c, { nextOpenings: nextOpenings }));
  });
  return nextOpeningDeterminedCrews;
};

var hasDailyCapacity = function hasDailyCapacity(sfPerDay) {
  return sfPerDay > 0;
};

var determineZeroCapacity = function determineZeroCapacity(crewSpecifics, pendingSurface) {
  var hardwood_sf_per_day = crewSpecifics.hardwood_sf_per_day,
      carpet_sf_per_day = crewSpecifics.carpet_sf_per_day,
      tile_sf_per_day = crewSpecifics.tile_sf_per_day,
      laminate_sf_per_day = crewSpecifics.laminate_sf_per_day,
      vinyl_sf_per_day = crewSpecifics.vinyl_sf_per_day,
      vinyl_plank_sf_per_day = crewSpecifics.vinyl_plank_sf_per_day,
      backsplash_sf_per_day = crewSpecifics.backsplash_sf_per_day;

  switch (pendingSurface) {
    case 'Hardwood':
      return !hasDailyCapacity(hardwood_sf_per_day || 0);
    case 'Carpet':
      return !hasDailyCapacity(carpet_sf_per_day || 0);
    case 'Tile':
      return !hasDailyCapacity(tile_sf_per_day || 0);
    case 'Laminate':
      return !hasDailyCapacity(laminate_sf_per_day || 0);
    case 'Vinyl':
      return !hasDailyCapacity(vinyl_sf_per_day || 0);
    case 'Vinyl Plank':
      return !hasDailyCapacity(vinyl_plank_sf_per_day || 0);
    case 'Backsplash':
      return !hasDailyCapacity(backsplash_sf_per_day || 0);
    default:
      return false;
  }
};

var determineMismatchExists = function determineMismatchExists(phaseSpecificsToMatch, assignee, pendingSurface, needDelivery) {
  var crew_specific = assignee.crew_specific,
      delivery_dedicated = assignee.delivery_dedicated;

  var specificMismatch = false;
  if (needDelivery && delivery_dedicated) specificMismatch = false;else if (crew_specific.phone_call_needed || determineZeroCapacity(crew_specific, pendingSurface) || delivery_dedicated) specificMismatch = true;else {
    var values = [];
    phaseSpecificsToMatch.forEach(function (s) {
      return values.push(crew_specific[__WEBPACK_IMPORTED_MODULE_5_config_constants__["_23" /* RELATED_SPECIFIC_FIELDS */][s]]);
    });
    specificMismatch = values.some(function (v) {
      return !v;
    });
  }
  return _extends({}, assignee, { specificMismatch: specificMismatch });
};

var removeMismatches = function removeMismatches(crews, phaseSpecificsToMatch, pendingSurface, keepMismatches) {
  var needDelivery = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  var mismatchDeterminedCrews = [];
  crews.forEach(function (c) {
    return mismatchDeterminedCrews.push(_extends({}, c, {
      assignee: determineMismatchExists(phaseSpecificsToMatch, c.assignee, pendingSurface, needDelivery)
    }));
  });
  if (keepMismatches) return mismatchDeterminedCrews;
  return mismatchDeterminedCrews.filter(function (m) {
    return m.assignee.specificMismatch === false;
  });
};

var sortCrews = function sortCrews(crews) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["sortBy"])(crews, [function (c) {
    return memberHasMismatch(c);
  }, function (c) {
    return memberHasMismatch(c) ? true : c.projectedJobDays > 1;
  }, function (c) {
    if (memberHasMismatch(c)) return true;
    if (c.projectedJobDays > 1) return c.projectedJobLength;
    return __WEBPACK_IMPORTED_MODULE_5_config_constants__["_62" /* WORK_DAY_HOURS */] - c.projectedJobLength;
  }, function (c) {
    return memberHasMismatch(c) ? true : c.nextOpening;
  }, function (c) {
    return memberHasMismatch(c) ? true : c.assignee.name;
  }]);
};

/*
 * TODO: implement https://babeljs.io/docs/en/babel-plugin-proposal-pipeline-operator
 * (https://github.com/tc39/proposal-pipeline-operator)
 */
var reorderResultsAndPrioritizeCrews = function reorderResultsAndPrioritizeCrews(members, pendingAppt, defaultCalStart, isCcs) {
  var _pendingAppt$phase3 = pendingAppt.phase,
      phase_specific = _pendingAppt$phase3.phase_specific,
      name = _pendingAppt$phase3.surface_type.name;
  // separating the crews from the non-crews, return if no crews

  var partitionedMembers = separateCrews(members);
  if (!partitionedMembers[0].length) return partitionedMembers[1];
  // what fields on the crew specifics do we care about based on the phase?
  var matchingSpecifics = getSpecificsToMatch(phase_specific);
  // adding a boolean field to each crew-type member indicating if there is a mismatch
  var mismatchDeterminedCrews = removeMismatches(partitionedMembers[0], matchingSpecifics, name, isCcs === false);
  // separating mismatched crews so that we do not unnecessarily run more ss logic on them
  var partitionedCrews = separateMismatches(mismatchDeterminedCrews);
  // if we have no matching crews, no need to try and run all this logic
  var finalCrews = [];
  if (partitionedCrews[1].length > 0) {
    // determining how long a job will take based on given specifics
    var projectedJobLengthDeterminedCrews = getCalJobLengthAttrs(partitionedCrews[1], matchingSpecifics, pendingAppt);
    // determine next available window of time for new appt based on projected time required
    var nextOpeningDeterminedCrews = getNextOpeningAttr(projectedJobLengthDeterminedCrews, defaultCalStart);
    // adding back mismatch crews if there are any
    finalCrews = partitionedCrews[0].length > 0 ? partitionedCrews[0].concat(nextOpeningDeterminedCrews) : nextOpeningDeterminedCrews;
  } else finalCrews = partitionedCrews[0];
  // adding a boolean field to each crew-type member indicating if there is an overlapping date
  var sortedCrews = sortCrews(getOverlappingDatesAttrs(finalCrews, pendingAppt));
  // adding map matrix field to existing appts on same day as pending appts
  if (partitionedMembers[1].length > 0) return sortedCrews.concat(partitionedMembers[1]);
  return sortedCrews;
};

var sortDeliverySuggestions = function sortDeliverySuggestions(suggestions) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["sortBy"])(suggestions, [function (s) {
    return __WEBPACK_IMPORTED_MODULE_1_moment___default()(s.opening, __WEBPACK_IMPORTED_MODULE_5_config_constants__["E" /* DISPLAY_DATE */]);
  }, function (s) {
    return s.assignee.priority;
  }, function (s) {
    return s.assignee.name;
  }]);
};

var sortInstallSuggestions = function sortInstallSuggestions(suggestions) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["sortBy"])(suggestions, [function (s) {
    return s.projectedJobDays > 1;
  }, function (s) {
    return s.projectedJobDays > 1 ? s.projectedJobLength : false;
  }, function (s) {
    return __WEBPACK_IMPORTED_MODULE_1_moment___default()(s.opening, __WEBPACK_IMPORTED_MODULE_5_config_constants__["E" /* DISPLAY_DATE */]);
  }, function (s) {
    return s.projectedJobDays <= 1 ? __WEBPACK_IMPORTED_MODULE_5_config_constants__["_62" /* WORK_DAY_HOURS */] - Math.ceil(s.sameDayAppt.projected_job_length || 0) - s.projectedJobLength : true;
  }, function (s) {
    return s.assignee.name;
  }]);
};

var sortSuggestions = function sortSuggestions(suggestions) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'install';
  return type === 'install' ? sortInstallSuggestions(suggestions) : sortDeliverySuggestions(suggestions);
};

var groupSuggestionsByPage = function groupSuggestionsByPage(suggestions) {
  var denominator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;

  var diviedSuggestions = [];
  while (suggestions.length > 0) {
    diviedSuggestions.push(suggestions.splice(0, denominator));
  }return diviedSuggestions;
};

var invalidTime = function invalidTime(start, end) {
  return [start, end].includes('Invalid date');
};

var buildSuggestions = function buildSuggestions(crews) {
  var isDelivery = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var suggestions = [];
  crews.forEach(function (c) {
    var _c$nextOpenings = c.nextOpenings,
        nextOpenings = _c$nextOpenings === undefined ? [] : _c$nextOpenings,
        assignee = c.assignee,
        _c$projectedJobDays = c.projectedJobDays,
        projectedJobDays = _c$projectedJobDays === undefined ? null : _c$projectedJobDays,
        _c$projectedJobLength = c.projectedJobLength,
        projectedJobLength = _c$projectedJobLength === undefined ? null : _c$projectedJobLength;

    nextOpenings.forEach(function (o) {
      var suggestion = _extends({}, o, {
        key: '' + (assignee.name + o.opening),
        assignee: assignee,
        projectedJobDays: projectedJobDays,
        projectedJobLength: projectedJobLength,
        projectedCompletion: null,
        endTime: Object(__WEBPACK_IMPORTED_MODULE_4__dateUtils__["j" /* getEndTimeString */])(o.startTime, isDelivery)
      });
      if (!isDelivery && !invalidTime(o.startTime, o.endTime)) {
        suggestion.projectedCompletion = determineProjectedCompletion(projectedJobLength, projectedJobDays, o.opening, o.startTime, c.assignee.default_start_time);
      }
      suggestions.push(suggestion);
    });
  });
  var sortedSuggestions = suggestions.length > 0 ? sortSuggestions(suggestions.filter(function (s) {
    return (s.opening || '').length;
  }).filter(function (s) {
    return !invalidTime(s.startTime, s.endTime);
  }), isDelivery ? 'delivery' : 'install').slice(0, 20) : [];
  return {
    suggestions: sortedSuggestions,
    suggestionCount: sortedSuggestions.length || 0
  };
};

var deliveryStoresValid = function deliveryStoresValid(sameDayAppt, storeId) {
  var numAppts = sameDayAppt.length;
  if (!numAppts || numAppts === 2) return true;
  if (numAppts >= 4) return false;
  if ([1, 3].includes(numAppts)) return sameDayAppt[numAppts - 1].phase.store.id === storeId;
  return false;
};

var pruneSuggestionsByDistance = function pruneSuggestionsByDistance(suggestions, storeId) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["sortBy"])(suggestions, [function (s) {
    return __WEBPACK_IMPORTED_MODULE_1_moment___default()(s.opening, __WEBPACK_IMPORTED_MODULE_5_config_constants__["E" /* DISPLAY_DATE */]);
  }]).filter(function (s) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(s.sameDayAppt) || Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(s.mapMatrix) || (s.type === 'install' || deliveryStoresValid(s.sameDayAppt, storeId)) && (s.mapMatrix.duration <= 0 || s.mapMatrix.duration / 60 <= (s.assignee.crew_specific || {}).max_travel_time || 0);
  });
};

var getInstallSuggestions = function getInstallSuggestions(crews, phase, defaultCalStart, relatedPhases) {
  var phaseId = phase.id,
      type = phase.type,
      zip_code = phase.zip_code,
      sqft = phase.sqft,
      spig_delivery = phase.spig_delivery,
      phase_specific = phase.phase_specific,
      source = phase.source,
      isCaliBamboo = phase.phase_specific.is_cali_bamboo_hardwood,
      _phase$surface_type = phase.surface_type,
      surfaceId = _phase$surface_type.id,
      surfaceType = _phase$surface_type.name,
      _phase$store = phase.store,
      storeId = _phase$store.id,
      deliveryMethod = _phase$store.delivery_method;

  var needDelivery = Object(__WEBPACK_IMPORTED_MODULE_3__index__["o" /* isDeliveryPhase */])(type, surfaceType, deliveryMethod, spig_delivery);
  var specificsToMatch = getSpecificsToMatch(phase_specific);
  var matchingCrews = removeMismatches(crews, specificsToMatch, surfaceType, false, needDelivery);
  var crewsWithEstimates = getSuggestionJobLengthAttrs(matchingCrews, specificsToMatch, phase);
  var installSuggestions = buildSuggestions(getSuggestionNextOpenings(crewsWithEstimates, defaultCalStart, { phaseId: phaseId,
    zip_code: zip_code,
    sqft: sqft,
    relatedPhases: relatedPhases,
    isCaliBamboo: isCaliBamboo,
    surfaceId: surfaceId,
    needDelivery: needDelivery,
    source: source }));
  var deliverySuggestions = needDelivery ? buildSuggestions(getSuggestionDeliveryOpenings(crewsWithEstimates, defaultCalStart, { phaseId: phaseId, zip_code: zip_code, surfaceType: surfaceType, sqft: sqft, relatedPhases: relatedPhases, source: source }), true) : {};
  return getSuggestionMapAttr(installSuggestions, deliverySuggestions, phaseId, storeId).then(function (res) {
    var finalDeliverySuggestions = needDelivery ? pruneSuggestionsByDistance(res.deliverySuggestions, storeId) || [] : [];
    var finalSuggestions = (res.suggestions || []).length ? sortSuggestions(pruneSuggestionsByDistance(res.suggestions, storeId)) : [];
    return {
      deliverySuggestions: finalDeliverySuggestions,
      deliveryCount: finalDeliverySuggestions.length,
      suggestions: finalSuggestions,
      suggestionCount: finalSuggestions.length
    };
  });
};

/***/ }),

/***/ "65/N":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"assigneeSelect__msignaturepad___31rID","m-signature-pad--body":"assigneeSelect__m-signature-pad--body___3gsxL","m-signature-pad--footer":"assigneeSelect__m-signature-pad--footer___2lJSi","description":"assigneeSelect__description___2zrPS","button":"assigneeSelect__button___1-gT3","clear":"assigneeSelect__clear___14v6E","save":"assigneeSelect__save___DTHmd","m-signature-pad":"assigneeSelect__m-signature-pad___3BOXV","github":"assigneeSelect__github___1P0r6","label":"assigneeSelect__label___3GMy2"};

/***/ }),

/***/ "69gD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"helperCard__msignaturepad___36hzx","m-signature-pad--body":"helperCard__m-signature-pad--body___36K7E","m-signature-pad--footer":"helperCard__m-signature-pad--footer___3v_Ik","description":"helperCard__description___qxa-v","button":"helperCard__button___3mhBi","clear":"helperCard__clear___JpcQN","save":"helperCard__save___2gS9I","m-signature-pad":"helperCard__m-signature-pad___2yJVd","github":"helperCard__github___29WjK","helperCard":"helperCard__helperCard___3MKaj","doNotUse":"helperCard__doNotUse___1CmZq","timeOffEditButton":"helperCard__timeOffEditButton___1aodr","overdue":"helperCard__overdue___20B11"};

/***/ }),

/***/ "6BM6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___2ZvPK","m-signature-pad--body":"styles__m-signature-pad--body___1MpDa","m-signature-pad--footer":"styles__m-signature-pad--footer___3S2C7","description":"styles__description___3F56b","button":"styles__button___40bYA","clear":"styles__clear___2ympU","save":"styles__save___2Lp6W","m-signature-pad":"styles__m-signature-pad___20NE2","github":"styles__github___1RN_Q","table":"styles__table___3QMaC","headerRow":"styles__headerRow___LsKBD","contentRow":"styles__contentRow___3m7I6","expandableContentRow":"styles__expandableContentRow___1PALc","cell":"styles__cell___1676u","heading":"styles__heading___svcn9","deleteCell":"styles__deleteCell___2wd7W","saveCell":"styles__saveCell___1tjWi","errored":"styles__errored___18W0v","error":"styles__error___rV7pW","editToggleButton":"styles__editToggleButton___3HyRW","emptyTable":"styles__emptyTable___gTMgs","message":"styles__message___3VIu7"};

/***/ }),

/***/ "6qfh":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "gold-medal-a75c70ba9a80854781aaf82f708e14dd.png";

/***/ }),

/***/ "74fA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"jobHistoryStyles__msignaturepad___GDkUh","m-signature-pad--body":"jobHistoryStyles__m-signature-pad--body___2WNEl","m-signature-pad--footer":"jobHistoryStyles__m-signature-pad--footer___1ZANI","description":"jobHistoryStyles__description___7T5w7","button":"jobHistoryStyles__button___2DJcS","clear":"jobHistoryStyles__clear___18X8J","save":"jobHistoryStyles__save___3fbby","m-signature-pad":"jobHistoryStyles__m-signature-pad___zV-OV","github":"jobHistoryStyles__github___3OIv2","jobHistoryTable":"jobHistoryStyles__jobHistoryTable___1EGeT","select":"jobHistoryStyles__select___wmkgQ","datepicker":"jobHistoryStyles__datepicker___SJv-x","reasonInput":"jobHistoryStyles__reasonInput___E5yRv","mheader":"jobHistoryStyles__mheader___28mi2","mdates":"jobHistoryStyles__mdates___3r-qp","hidden":"jobHistoryStyles__hidden___1jT6f","emptyTable":"jobHistoryStyles__emptyTable___2vEmn","downloadIcon":"jobHistoryStyles__downloadIcon___3yUk7","paginationContainer":"jobHistoryStyles__paginationContainer___UFU6y"};

/***/ }),

/***/ "7UVI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"userDetailsCard__msignaturepad___A0dtR","m-signature-pad--body":"userDetailsCard__m-signature-pad--body___2FPxg","m-signature-pad--footer":"userDetailsCard__m-signature-pad--footer___1VmYG","description":"userDetailsCard__description___13ryb","button":"userDetailsCard__button___3AHrE","clear":"userDetailsCard__clear___r0xU1","save":"userDetailsCard__save___1JNaS","m-signature-pad":"userDetailsCard__m-signature-pad___8_dQf","github":"userDetailsCard__github___1lJ2n","userDetailsCard":"userDetailsCard__userDetailsCard___1-qLE"};

/***/ }),

/***/ "7hD4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"documentUploadStyles__msignaturepad___1UCpZ","m-signature-pad--body":"documentUploadStyles__m-signature-pad--body___RcPQE","m-signature-pad--footer":"documentUploadStyles__m-signature-pad--footer___345OC","description":"documentUploadStyles__description___3FzNr","button":"documentUploadStyles__button___2Kdjp","clear":"documentUploadStyles__clear___ucumd","save":"documentUploadStyles__save___24gbN","m-signature-pad":"documentUploadStyles__m-signature-pad___EuhBe","github":"documentUploadStyles__github___1uxnk","back":"documentUploadStyles__back___22qUX","container":"documentUploadStyles__container___13uZD","text":"documentUploadStyles__text___2j9aQ","warningTextContainer":"documentUploadStyles__warningTextContainer___1LKne","warningText":"documentUploadStyles__warningText___2wqeT","errorText":"documentUploadStyles__errorText___3pxt9","title":"documentUploadStyles__title___2jIFC","inputs":"documentUploadStyles__inputs___3e4rx","preview":"documentUploadStyles__preview___3GzdX","center":"documentUploadStyles__center___2R7j0","fileContainer":"documentUploadStyles__fileContainer___15smM","deleteButton":"documentUploadStyles__deleteButton___3PFud","deleteIcon":"documentUploadStyles__deleteIcon___15jYb","filesContainer":"documentUploadStyles__filesContainer___1N1so","loadingOverlay":"documentUploadStyles__loadingOverlay___3z4z4","loadingNotificationContainer":"documentUploadStyles__loadingNotificationContainer___1kmHE","loadingSpinner":"documentUploadStyles__loadingSpinner___2hOKE","actionButtons":"documentUploadStyles__actionButtons___1G6dG","modalButton":"documentUploadStyles__modalButton___2frPO","errorContainer":"documentUploadStyles__errorContainer___3BBEM"};

/***/ }),

/***/ "80jm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"login__msignaturepad___3DgQi","m-signature-pad--body":"login__m-signature-pad--body___3VOY6","m-signature-pad--footer":"login__m-signature-pad--footer___2m3KU","description":"login__description___3-nzu","button":"login__button___1VgoK","clear":"login__clear___f6X_k","save":"login__save___kR_Jj","m-signature-pad":"login__m-signature-pad___2Z0Sc","github":"login__github___cfh8r","card":"login__card___toOVm","cardActions":"login__cardActions___1V146","cardText":"login__cardText___3FJsx","line":"login__line___2UaeJ","spLogo":"login__spLogo___3YEdc","googleFaviconLogo":"login__googleFaviconLogo___1-qMC","signInBtn":"login__signInBtn___3unW0","signInText":"login__signInText___3UAKY","loginWrapper":"login__loginWrapper___nJarF","copyright":"login__copyright___1HpUO","btnContent":"login__btnContent___1PUEd","msBtnContainer":"login__msBtnContainer___3Xc8Y","msBtnImg":"login__msBtnImg___12P9g","msBtnText":"login__msBtnText___3oMRu","googleAuthBtn":"login__googleAuthBtn___2Bhum","googleAuthLogo":"login__googleAuthLogo___2a9pF"};

/***/ }),

/***/ "8258":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"table__msignaturepad___3N7vF","m-signature-pad--body":"table__m-signature-pad--body___3MLdN","m-signature-pad--footer":"table__m-signature-pad--footer___9GshU","description":"table__description___3A1jx","button":"table__button___3HEvU","clear":"table__clear___1Mh00","save":"table__save___1TtK3","m-signature-pad":"table__m-signature-pad___3bKhz","github":"table__github___1cJB5","cardTable":"table__cardTable___3X9Ay","headerRow":"table__headerRow___ivCU5","contentRow":"table__contentRow___3DqTz","column":"table__column___OZLFo","columnError":"table__columnError___3sLXR","numberColumn":"table__numberColumn___B77IR","textColumn":"table__textColumn___ejdjB","centeredColumn":"table__centeredColumn___2j5W7","smallColumn":"table__smallColumn___1vOo_","largeColumn":"table__largeColumn___1SAEV","smallInput":"table__smallInput___322UY","totalContainer":"table__totalContainer___1OaIO","calculatedTotalColumn":"table__calculatedTotalColumn___2GjQi","total":"table__total___2bBc4","totalWarning":"table__totalWarning___3wrHs","lineItemSelect":"table__lineItemSelect___tD3NF","statusSelect":"table__statusSelect___1D1bw","errored":"table__errored___2yBRL","error":"table__error___1Eiuu","saveButton":"table__saveButton___McXi6","input":"table__input___4QBVC","iconContainer":"table__iconContainer___3kI0H","calculatedTotalIcon":"table__calculatedTotalIcon___3rxc4","hidden":"table__hidden___mZCBL","emptyTable":"table__emptyTable___3A6fx","tableWrapper":"table__tableWrapper___24p82","tdIndention":"table__tdIndention___359mn"};

/***/ }),

/***/ "8hjH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"dropdown__msignaturepad___2vbQd","m-signature-pad--body":"dropdown__m-signature-pad--body___lCR10","m-signature-pad--footer":"dropdown__m-signature-pad--footer___vB5U1","description":"dropdown__description___1A5-S","button":"dropdown__button___2DkQd","clear":"dropdown__clear___XeDiK","save":"dropdown__save___2dUNf","m-signature-pad":"dropdown__m-signature-pad___iiLUE","github":"dropdown__github___1CT29","value":"dropdown__value___2VBs_","dropdown":"dropdown__dropdown___3kN1c","up":"dropdown__up___17Ipd","values":"dropdown__values___2H1H4"};

/***/ }),

/***/ "8tYY":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ah1-e1e5aa3d80e308cc5797e73da8d7a17b.png";

/***/ }),

/***/ "Brzw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___mFs4r","m-signature-pad--body":"styles__m-signature-pad--body___I_p3M","m-signature-pad--footer":"styles__m-signature-pad--footer___2c__r","description":"styles__description___3uxV9","button":"styles__button___3M4u-","clear":"styles__clear___1IepZ","save":"styles__save___29wsL","m-signature-pad":"styles__m-signature-pad___1x5OD","github":"styles__github___17LU4","messageBox":"styles__messageBox___1oU9i","error":"styles__error___2hOoS","completedList":"styles__completedList___BfLIA"};

/***/ }),

/***/ "Bypn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"savedFilters__msignaturepad___30tgC","m-signature-pad--body":"savedFilters__m-signature-pad--body___vzCPG","m-signature-pad--footer":"savedFilters__m-signature-pad--footer___g4UpB","description":"savedFilters__description___PthLx","button":"savedFilters__button___2405v","clear":"savedFilters__clear___v634Y","save":"savedFilters__save___3L9nj","m-signature-pad":"savedFilters__m-signature-pad___1nJbF","github":"savedFilters__github___3XcGX","list":"savedFilters__list___bJu3B","filter":"savedFilters__filter___1ZCUZ","header":"savedFilters__header___2kuwY","disabledHeader":"savedFilters__disabledHeader___I8V3A","name":"savedFilters__name___3ch0a","count":"savedFilters__count___2w4hb","overdue":"savedFilters__overdue___3lRrx","selected":"savedFilters__selected___2X1M_","beingDragged":"savedFilters__beingDragged___3H4u6","dragHandle":"savedFilters__dragHandle___15Q68","dragging":"savedFilters__dragging___EOV7P"};

/***/ }),

/***/ "C7qr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"checkbox__msignaturepad___3qDmW","m-signature-pad--body":"checkbox__m-signature-pad--body___q0m1e","m-signature-pad--footer":"checkbox__m-signature-pad--footer___DAo2l","description":"checkbox__description___3IGSR","button":"checkbox__button___1cvTI","clear":"checkbox__clear___1ivE7","save":"checkbox__save___1lktw","m-signature-pad":"checkbox__m-signature-pad___3SdXC","github":"checkbox__github___2Kws1","check":"checkbox__check___3p2-1","checked":"checkbox__checked___35sdg","text":"checkbox__text___1iBBh","large":"checkbox__large___90jVE"};

/***/ }),

/***/ "CCP7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"receiveReleaseAll__msignaturepad___QH6zO","m-signature-pad--body":"receiveReleaseAll__m-signature-pad--body___3XPC9","m-signature-pad--footer":"receiveReleaseAll__m-signature-pad--footer___3K6t7","description":"receiveReleaseAll__description___3Gqw_","button":"receiveReleaseAll__button___g3VxR","clear":"receiveReleaseAll__clear___2VC1g","save":"receiveReleaseAll__save___3kb1s","m-signature-pad":"receiveReleaseAll__m-signature-pad___2FVlj","github":"receiveReleaseAll__github___1Oza0","release":"receiveReleaseAll__release___3Ge3_","receive":"receiveReleaseAll__receive___1XxZC","container":"receiveReleaseAll__container___1HGa_"};

/***/ }),

/***/ "Cgcc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"react-select-styles__msignaturepad___2esik","m-signature-pad--body":"react-select-styles__m-signature-pad--body___PdNlm","m-signature-pad--footer":"react-select-styles__m-signature-pad--footer___2SqtE","description":"react-select-styles__description___3Rhxx","button":"react-select-styles__button___2WkaK","clear":"react-select-styles__clear___3HfjL","save":"react-select-styles__save___259qO","m-signature-pad":"react-select-styles__m-signature-pad___36ks8","github":"react-select-styles__github___LPZqx","prettyDropDown":"react-select-styles__prettyDropDown___20KLJ","empty":"react-select-styles__empty___RdYIF","errored":"react-select-styles__errored___1F1-q","dropDownWrapper":"react-select-styles__dropDownWrapper___3JCtk","dropDownLabel":"react-select-styles__dropDownLabel___216v7","optionText":"react-select-styles__optionText___2v4hH","errorText":"react-select-styles__errorText___10Y80","errorMessage":"react-select-styles__errorMessage___10pZG"};

/***/ }),

/***/ "CqOy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Entities */
/* unused harmony export Roles */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return canRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return canAccessCustomLaborSheet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return canAccessIfiTemplate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cancan__ = __webpack_require__("l+xD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cancan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_cancan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_config_constants__ = __webpack_require__("JKMY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__("FbQg");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var cancan = new __WEBPACK_IMPORTED_MODULE_0_cancan___default.a();
var allow = cancan.allow,
    can = cancan.can;

// Entities

var Phase = function Phase() {
  _classCallCheck(this, Phase);
};

var PhaseInfo = function PhaseInfo() {
  _classCallCheck(this, PhaseInfo);
};

var PhaseSpecifics = function PhaseSpecifics() {
  _classCallCheck(this, PhaseSpecifics);
};

var PhaseTask = function PhaseTask() {
  _classCallCheck(this, PhaseTask);
};

var Event = function Event() {
  _classCallCheck(this, Event);
};

var Schedule = function Schedule() {
  _classCallCheck(this, Schedule);
};

var Dashboard = function Dashboard() {
  _classCallCheck(this, Dashboard);
};

var LineItem = function LineItem() {
  _classCallCheck(this, LineItem);
};

var Document = function Document() {
  _classCallCheck(this, Document);
};

var Checklist = function Checklist() {
  _classCallCheck(this, Checklist);
};

var Appointment = function Appointment() {
  _classCallCheck(this, Appointment);
};

var AppointmentForm = function AppointmentForm() {
  _classCallCheck(this, AppointmentForm);
};

var SuggestionOverride = function SuggestionOverride() {
  _classCallCheck(this, SuggestionOverride);
};

var Pto = function Pto() {
  _classCallCheck(this, Pto);
};

var TravelingWorkDate = function TravelingWorkDate() {
  _classCallCheck(this, TravelingWorkDate);
};

var RelatedPhase = function RelatedPhase() {
  _classCallCheck(this, RelatedPhase);
};

var Scraper = function Scraper() {
  _classCallCheck(this, Scraper);
};

var Survey = function Survey() {
  _classCallCheck(this, Survey);
};

var Communications = function Communications() {
  _classCallCheck(this, Communications);
};

var MaterialsChecklist = function MaterialsChecklist() {
  _classCallCheck(this, MaterialsChecklist);
};

var Labor = function Labor() {
  _classCallCheck(this, Labor);
};

var Accounting = function Accounting() {
  _classCallCheck(this, Accounting);
};

var PurchaseOrder = function PurchaseOrder() {
  _classCallCheck(this, PurchaseOrder);
};

var LaborSheet = function LaborSheet() {
  _classCallCheck(this, LaborSheet);
};

var LaborTotal = function LaborTotal() {
  _classCallCheck(this, LaborTotal);
};

var ApprovedLabor = function ApprovedLabor() {
  _classCallCheck(this, ApprovedLabor);
};

var ContractorLineItem = function ContractorLineItem() {
  _classCallCheck(this, ContractorLineItem);
};

var Chargeback = function Chargeback() {
  _classCallCheck(this, Chargeback);
};

var Warehouse = function Warehouse() {
  _classCallCheck(this, Warehouse);
};

var Crew = function Crew() {
  _classCallCheck(this, Crew);
};

var CrewSpecifics = function CrewSpecifics() {
  _classCallCheck(this, CrewSpecifics);
};

var ProfitMargin = function ProfitMargin() {
  _classCallCheck(this, ProfitMargin);
};

var DueDate = function DueDate() {
  _classCallCheck(this, DueDate);
};

var TimeInPhase = function TimeInPhase() {
  _classCallCheck(this, TimeInPhase);
};

var CreatedAtDefault = function CreatedAtDefault() {
  _classCallCheck(this, CreatedAtDefault);
};

var Store = function Store() {
  _classCallCheck(this, Store);
};

var StoreDetails = function StoreDetails() {
  _classCallCheck(this, StoreDetails);
};

var StoreContact = function StoreContact() {
  _classCallCheck(this, StoreContact);
};

var PricePatchUpload = function PricePatchUpload() {
  _classCallCheck(this, PricePatchUpload);
};

var InstallationsPaperwork = function InstallationsPaperwork() {
  _classCallCheck(this, InstallationsPaperwork);
};

var WarehouseReport = function WarehouseReport() {
  _classCallCheck(this, WarehouseReport);
};

var TagsBulkPrint = function TagsBulkPrint() {
  _classCallCheck(this, TagsBulkPrint);
};

var ActivityReport = function ActivityReport() {
  _classCallCheck(this, ActivityReport);
};

var InstallWorkorderReport = function InstallWorkorderReport() {
  _classCallCheck(this, InstallWorkorderReport);
};

var JobHistory = function JobHistory() {
  _classCallCheck(this, JobHistory);
};

var Inactive = function Inactive() {
  _classCallCheck(this, Inactive);
};

var PayRate = function PayRate() {
  _classCallCheck(this, PayRate);
};

var Flag = function Flag() {
  _classCallCheck(this, Flag);
};

var Contractor = function Contractor() {
  _classCallCheck(this, Contractor);
};

var Badge = function Badge() {
  _classCallCheck(this, Badge);
};

var CreateException = function CreateException() {
  _classCallCheck(this, CreateException);
};

var Coc = function Coc() {
  _classCallCheck(this, Coc);
};

var Walkthrough = function Walkthrough() {
  _classCallCheck(this, Walkthrough);
};

var RepairInspectionReport = function RepairInspectionReport() {
  _classCallCheck(this, RepairInspectionReport);
};

var CrewInspection = function CrewInspection() {
  _classCallCheck(this, CrewInspection);
};

var BulkUpdateUpload = function BulkUpdateUpload() {
  _classCallCheck(this, BulkUpdateUpload);
};

var MarginUpload = function MarginUpload() {
  _classCallCheck(this, MarginUpload);
};

var ActivityUpload = function ActivityUpload() {
  _classCallCheck(this, ActivityUpload);
};

var BulkProjectsLoad = function BulkProjectsLoad() {
  _classCallCheck(this, BulkProjectsLoad);
};

var LowesSurveyUpload = function LowesSurveyUpload() {
  _classCallCheck(this, LowesSurveyUpload);
};

var FloorWizard = function FloorWizard() {
  _classCallCheck(this, FloorWizard);
};

var SendEmail = function SendEmail() {
  _classCallCheck(this, SendEmail);
};

var LPA = function LPA() {
  _classCallCheck(this, LPA);
};

var Leveler = function Leveler() {
  _classCallCheck(this, Leveler);
};

var EstimatorDetails = function EstimatorDetails() {
  _classCallCheck(this, EstimatorDetails);
};

var ManageVendors = function ManageVendors() {
  _classCallCheck(this, ManageVendors);
};

var SupervisorFilter = function SupervisorFilter() {
  _classCallCheck(this, SupervisorFilter);
};

var SupervisorInfo = function SupervisorInfo() {
  _classCallCheck(this, SupervisorInfo);
};

var AssignInstaller = function AssignInstaller() {
  _classCallCheck(this, AssignInstaller);
};

var InstallerPrioritizationWeights = function InstallerPrioritizationWeights() {
  _classCallCheck(this, InstallerPrioritizationWeights);
};

var IfiLrrp = function IfiLrrp() {
  _classCallCheck(this, IfiLrrp);
};

var DefaultInstallerPay = function DefaultInstallerPay() {
  _classCallCheck(this, DefaultInstallerPay);
};

var HolidayPromoSettings = function HolidayPromoSettings() {
  _classCallCheck(this, HolidayPromoSettings);
};

var SupportRequest = function SupportRequest() {
  _classCallCheck(this, SupportRequest);
};

var NonIfi = function NonIfi() {
  _classCallCheck(this, NonIfi);
};

// Roles


var Admin = function Admin() {
  _classCallCheck(this, Admin);
};

var OfficeAdmin = function OfficeAdmin() {
  _classCallCheck(this, OfficeAdmin);
};

var Regional = function Regional() {
  _classCallCheck(this, Regional);
};

var Estimator = function Estimator() {
  _classCallCheck(this, Estimator);
};

var Iqm = function Iqm() {
  _classCallCheck(this, Iqm);
};

var Installer = function Installer() {
  _classCallCheck(this, Installer);
};

var Employee = function Employee() {
  _classCallCheck(this, Employee);
};

var Workroom = function Workroom() {
  _classCallCheck(this, Workroom);
};

var LowesDocs = function LowesDocs() {
  _classCallCheck(this, LowesDocs);
};

var ContractVerification = function ContractVerification() {
  _classCallCheck(this, ContractVerification);
};

var ReviewsAndRefigures = function ReviewsAndRefigures() {
  _classCallCheck(this, ReviewsAndRefigures);
};

var Entities = {
  PHASE: new Phase(),
  PHASE_INFO: new PhaseInfo(),
  PHASE_SPECIFICS: new PhaseSpecifics(),
  PHASE_TASK: new PhaseTask(),
  EVENT: new Event(),
  SCHEDULE: new Schedule(),
  DASHBOARD: new Dashboard(),
  LINE_ITEM: new LineItem(),
  DOCUMENT: new Document(),
  CHECKLIST: new Checklist(),
  APPOINTMENT: new Appointment(),
  APPOINTMENT_FORM: new AppointmentForm(),
  SUGGESTION_OVERRIDE: new SuggestionOverride(),
  PTO: new Pto(),
  TRAVELING_WORK_DATE: new TravelingWorkDate(),
  RELATED_PHASE: new RelatedPhase(),
  SCRAPER: new Scraper(),
  SURVEY: new Survey(),
  COMMUNICATIONS: new Communications(),
  MATERIALS_CHECKLIST: new MaterialsChecklist(),
  LABOR: new Labor(),
  ACCOUNTING: new Accounting(),
  PURCHASE_ORDER: new PurchaseOrder(),
  LABOR_SHEET: new LaborSheet(),
  LABOR_TOTAL: new LaborTotal(),
  APPROVED_LABOR: new ApprovedLabor(),
  CONTRACTOR_LINE_ITEM: new ContractorLineItem(),
  CHARGEBACK: new Chargeback(),
  WAREHOUSE: new Warehouse(),
  PROFIT_MARGIN: new ProfitMargin(),
  DUE_DATE: new DueDate(),
  TIME_IN_PHASE: new TimeInPhase(),
  CREATED_AT_DEFAULT: new CreatedAtDefault(),
  STORE: new Store(),
  STORE_DETAILS: new StoreDetails(),
  STORE_CONTACT: new StoreContact(),
  PRICE_PATCH_UPLOAD: new PricePatchUpload(),
  INSTALLATIONS_PAPERWORK: new InstallationsPaperwork(),
  WAREHOUSE_REPORT: new WarehouseReport(),
  TAGS_BULK_PRINT: new TagsBulkPrint(),
  ACTIVITY_REPORT: new ActivityReport(),
  INSTALL_WORKORDER_REPORT: new InstallWorkorderReport(),
  JOB_HISTORY: new JobHistory(),
  EMPLOYEE: new Employee(),
  ESTIMATOR: new Estimator(),
  IQM: new Iqm(),
  INSTALLER: new Installer(),
  CREW: new Crew(),
  CREW_SPECIFICS: new CrewSpecifics(),
  PAY_RATE: new PayRate(),
  INACTIVE: new Inactive(),
  FLAG: new Flag(),
  CONTRACTOR: new Contractor(),
  BADGE: new Badge(),
  CREATE_EXCEPTION: new CreateException(),
  COC: new Coc(),
  WALKTHROUGH: new Walkthrough(),
  REPAIR_INSPECTION_REPORT: new RepairInspectionReport(),
  CREW_INSPECTION: new CrewInspection(),
  BULK_UPDATE_UPLOAD: new BulkUpdateUpload(),
  MARGIN_UPLOAD: new MarginUpload(),
  ACTIVITY_UPLOAD: new ActivityUpload(),
  BULK_PROJECTS_LOAD: new BulkProjectsLoad(),
  LOWES_SURVEY_UPLOAD: new LowesSurveyUpload(),
  WORKROOM: new Workroom(),
  FLOOR_WIZARD: new FloorWizard(),
  SEND_EMAIL: new SendEmail(),
  LPA: new LPA(),
  LEVELER: new Leveler(),
  ESTIMATOR_DETAILS: new EstimatorDetails(),
  MANAGE_VENDORS: new ManageVendors(),
  SUPERVISOR_FILTER: new SupervisorFilter(),
  SUPERVISOR_INFO: new SupervisorInfo(),
  ASSIGN_INSTALLER: new AssignInstaller(),
  INSTALLER_PRIORITIZATION_WEIGHTS: new InstallerPrioritizationWeights(),
  IFI_LRRP: new IfiLrrp(),
  DEFAULT_INSTALLER_PAY: new DefaultInstallerPay(),
  HOLIDAY_PROMO_SETTINGS: new HolidayPromoSettings(),
  SUPPORT_REQUEST: new SupportRequest(),
  NON_IFI: new NonIfi()
};

var Roles = {
  OFFICE_ADMIN: new OfficeAdmin(),
  REGIONAL: new Regional(),
  WORKROOM: new Workroom(),
  IQM: new Iqm(),
  LOWES_DOCS: new LowesDocs(),
  ACCOUNTING: new Accounting(),
  REVIEWS_AND_REFIGURES: new ReviewsAndRefigures(),
  ESTIMATOR: new Estimator(),
  INSTALLER: new Installer(),
  ADMIN: new Admin(),
  EMPLOYEE: new Employee(),
  CREW: new Crew()
};

var PURCHASE_ORDER_STATUSES = ['Recorded', 'Invoiced', 'Paid'];
var LOWESDOC_LABOR_SHEET_STATUSES = ['Recorded', 'Approved by Contractor'];
var LABOR_SHEET_STATUSES = ['Recorded', 'Ready for Accounting'];
var ACTIVITY_MANAGERS = ['Fatima Singletary', 'Kyle Reece', 'Jimmy Chestnut', 'Antoinette Kilpatrick', 'Jasmine Cannon'];

var self = function self(user, obj) {
  return user.attrs && user.attrs.user_id && user.attrs.user_id === obj.attrs.obj_id;
};

var employee = function employee(klass) {
  allow(klass, 'view', [Installer, Crew, Badge, ProfitMargin]);
  allow(klass, 'view_inactive', [Estimator, Installer]);
  allow(klass, 'view', [TagsBulkPrint, WarehouseReport, ActivityReport, InstallWorkorderReport, JobHistory]);
  allow(klass, 'override', Phase);
};

var phaseInfo = function phaseInfo(klass) {
  return allow(klass, 'view', PhaseInfo);
};

var recordable = function recordable(role) {
  var excludeLabor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var isAdmin = [OfficeAdmin, Regional].includes(role);
  allow(role, ['editable', 'view'], PurchaseOrder);
  allow(role, 'update', PurchaseOrder, function (user, sheet) {
    return isAdmin || !PURCHASE_ORDER_STATUSES.includes(sheet.attrs.obj_status);
  });
  allow(role, ['editable', 'view'], Chargeback);
  allow(role, 'update', Chargeback, function (user) {
    var sheet = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { attrs: {} };
    return !['Recorded', 'Uncollectable'].includes(sheet.attrs.obj_status || '');
  });
  if (excludeLabor) return;
  allow(role, ['editable', 'view', 'approve'], LaborSheet);
  var restrictedStatuses = role !== LowesDocs ? LABOR_SHEET_STATUSES : LOWESDOC_LABOR_SHEET_STATUSES;
  allow(role, 'update', LaborSheet, function (user, sheet) {
    return !restrictedStatuses.includes(sheet.attrs.obj_status);
  });
  if (isAdmin) allow(role, 'manage_closed', LaborSheet);
};

var approvedLabor = function approvedLabor(role) {
  return allow(role, 'manage', ApprovedLabor);
};

var phaseTasks = function phaseTasks(role) {
  if ([Installer, Crew].includes(role)) {
    allow(role, 'update', PhaseTask, function (user, data) {
      var _data$attrs = data.attrs,
          slug = _data$attrs.slug,
          status = _data$attrs.status;

      var hiddenSlugs = ['install_complete', 'workorder_complete', 'install_in_progress_call', 'workorder_in_progress_call', 'delivery_completed'];
      var validStatus = ['installing', 'in_progress', 'delivery'].includes(status);
      if (slug) return validStatus && !hiddenSlugs.includes(slug);
      return validStatus;
    });
  } else allow(role, 'update', PhaseTask);
};

var activityPerms = function activityPerms(role) {
  allow(role, 'view', ActivityUpload);
  allow(role, 'manage', ActivityUpload, function (user) {
    var activityAttrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { attrs: { position: '', name: '' } };
    return activityAttrs.attrs.position === 'Customer Care Specialist' || ACTIVITY_MANAGERS.includes(activityAttrs.attrs.name);
  });
};

var bulkLoadPerms = function bulkLoadPerms(role) {
  allow(role, 'manage', BulkProjectsLoad, function (user) {
    var attrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { attrs: { position: '' } };
    return role === OfficeAdmin || attrs.attrs.position === 'Customer Care Specialist';
  });
};

var supervisorFilterCheck = function supervisorFilterCheck(user) {
  var attrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { attrs: {} };
  var _attrs$attrs = attrs.attrs,
      _attrs$attrs$position = _attrs$attrs.position,
      position = _attrs$attrs$position === undefined ? '' : _attrs$attrs$position,
      _attrs$attrs$manageVe = _attrs$attrs.manageVendorWorkrooms;
  _attrs$attrs$manageVe = _attrs$attrs$manageVe === undefined ? {} : _attrs$attrs$manageVe;
  var _attrs$attrs$manageVe2 = _attrs$attrs$manageVe.ifi,
      ifi = _attrs$attrs$manageVe2 === undefined ? false : _attrs$attrs$manageVe2;


  if (!ifi) {
    return false;
  }

  // Check if role is above workroom (OfficeAdmin or Regional) or has IC/ISM position
  // Note: Admin has 'manage all' so won't reach this check
  return user instanceof OfficeAdmin || user instanceof Regional || __WEBPACK_IMPORTED_MODULE_1_config_constants__["O" /* IC_ISM_POSITIONS */].includes(position);
};

var ifiInfoCheck = function ifiInfoCheck(user) {
  var attrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { attrs: {} };
  var _attrs$attrs2 = attrs.attrs,
      _attrs$attrs2$positio = _attrs$attrs2.position,
      position = _attrs$attrs2$positio === undefined ? '' : _attrs$attrs2$positio,
      _attrs$attrs2$mvw = _attrs$attrs2.mvw,
      mvw = _attrs$attrs2$mvw === undefined ? attrs.attrs.manage_vendor_workrooms || {} : _attrs$attrs2$mvw;

  var manage_vendor_workrooms = mvw;

  if (!manage_vendor_workrooms.ifi) {
    return false;
  }

  // Check if role is Admin, OfficeAdmin, or Regional (these can always view)
  if (user instanceof Admin || user instanceof OfficeAdmin || user instanceof Regional) {
    return true;
  }

  // If workroom role, check position
  if (user instanceof Workroom) {
    return __WEBPACK_IMPORTED_MODULE_1_config_constants__["O" /* IC_ISM_POSITIONS */].includes(position);
  }

  return false;
};

var nonIfiExclusiveCheck = function nonIfiExclusiveCheck(user) {
  var attrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { attrs: {} };
  var _attrs$attrs$manage_v = attrs.attrs.manage_vendor_workrooms,
      mvw = _attrs$attrs$manage_v === undefined ? {} : _attrs$attrs$manage_v;

  return Object.keys(mvw).some(function (key) {
    return key !== 'ifi' && mvw[key] === true;
  });
};

var installerAssignedToPhaseCheck = function installerAssignedToPhaseCheck(user) {
  var attrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { attrs: {} };
  var _attrs$attrs3 = attrs.attrs,
      _attrs$attrs3$phase_i = _attrs$attrs3.phase_installer_id,
      phase_installer_id = _attrs$attrs3$phase_i === undefined ? null : _attrs$attrs3$phase_i,
      _attrs$attrs3$employa = _attrs$attrs3.employable_id,
      employable_id = _attrs$attrs3$employa === undefined ? null : _attrs$attrs3$employa;


  if (phase_installer_id == null || employable_id == null) {
    return false;
  }

  return Number(phase_installer_id) === Number(employable_id);
};

var quickScheduleIfiCheck = function quickScheduleIfiCheck(user) {
  var attrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { attrs: {} };
  return attrs.attrs.source === 'IFI';
};

var quickScheduleAssigneeCheck = function quickScheduleAssigneeCheck(phaseAssigneeKey) {
  return function (user) {
    var attrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { attrs: {} };
    var _attrs$attrs4 = attrs.attrs,
        _attrs$attrs4$source = _attrs$attrs4.source,
        source = _attrs$attrs4$source === undefined ? '' : _attrs$attrs4$source,
        _attrs$attrs4$is_self = _attrs$attrs4.is_self_schedulable,
        isSelfSchedulable = _attrs$attrs4$is_self === undefined ? false : _attrs$attrs4$is_self,
        _attrs$attrs4$employa = _attrs$attrs4.employable_id,
        employableId = _attrs$attrs4$employa === undefined ? null : _attrs$attrs4$employa;

    var phaseAssigneeId = attrs.attrs[phaseAssigneeKey];
    if (source !== 'IFI' || !isSelfSchedulable) return false;
    if (phaseAssigneeId == null || employableId == null) return false;
    return Number(phaseAssigneeId) === Number(employableId);
  };
};

// Installers may quick-schedule Assessments and Installations, but never Workorders.
var installerQuickScheduleCheck = function installerQuickScheduleCheck(user) {
  var attrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { attrs: {} };

  if (attrs.attrs.phase_type === 'Workorder') return false;
  return quickScheduleAssigneeCheck('phase_installer_id')(user, attrs);
};

var installerPrioritizationWeightsCheck = function installerPrioritizationWeightsCheck(user) {
  var attrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { attrs: {} };
  var _attrs$attrs5 = attrs.attrs,
      _attrs$attrs5$positio = _attrs$attrs5.position,
      position = _attrs$attrs5$positio === undefined ? '' : _attrs$attrs5$positio,
      _attrs$attrs5$manageV = _attrs$attrs5.manageVendorWorkrooms;
  _attrs$attrs5$manageV = _attrs$attrs5$manageV === undefined ? {} : _attrs$attrs5$manageV;
  var _attrs$attrs5$manageV2 = _attrs$attrs5$manageV.ifi,
      ifi = _attrs$attrs5$manageV2 === undefined ? false : _attrs$attrs5$manageV2;


  return ifi && (user instanceof OfficeAdmin || user instanceof Regional || __WEBPACK_IMPORTED_MODULE_1_config_constants__["O" /* IC_ISM_POSITIONS */].includes(position));
};

var estimatorDetails = function estimatorDetails(role) {
  allow(role, 'view', EstimatorDetails, function (user, obj) {
    return obj.attrs.matching;
  });
};

// Actions

// ********************* Base ********************

[OfficeAdmin, Regional, Workroom, LowesDocs, Accounting, ContractVerification, ReviewsAndRefigures, Estimator].forEach(function (klass) {
  allow(klass, 'view', [Employee, Estimator, Iqm, Store, Phase, Appointment, Event, Workroom, Document, Survey, Communications, RelatedPhase, Pto, TravelingWorkDate, Flag, Schedule, DueDate, TimeInPhase, CreatedAtDefault, PhaseSpecifics, CrewSpecifics, Dashboard]);
  allow(klass, 'create', Event);
  allow(klass, 'manage', [DueDate, Document, Flag, MaterialsChecklist]);
});

// ********************* Admin ********************

allow(Admin, 'manage', 'all');

// ********************* OfficeAdmin *********************

employee(OfficeAdmin);
allow(OfficeAdmin, 'manage', PricePatchUpload);
allow(OfficeAdmin, 'update', [Badge, Phase, RelatedPhase]);
allow(OfficeAdmin, 'manage', [Installer, Crew, Estimator, PayRate]);
allow(OfficeAdmin, ['create', 'copy', 'override', 'relate', 'cancel', 'verify_document', 'update_contractor_notes'], Phase);
allow(OfficeAdmin, 'manage', [Checklist, Appointment, AppointmentForm, Pto, TravelingWorkDate]);
allow(OfficeAdmin, 'manage', [Labor, Warehouse]);
allow(OfficeAdmin, 'view', [Accounting, LaborTotal]);
allow(OfficeAdmin, 'manage', [LaborSheet, ContractorLineItem, InstallationsPaperwork]);
allow(OfficeAdmin, 'manage', [Scraper, LowesSurveyUpload]);
allow(OfficeAdmin, 'update', Survey);
allow(OfficeAdmin, 'manage', Communications);
allow(OfficeAdmin, 'update', Store);
allow(OfficeAdmin, 'manage', StoreContact);
allow(OfficeAdmin, 'update', StoreDetails);
allow(OfficeAdmin, 'manage', Coc);
allow(OfficeAdmin, 'manage', Walkthrough);
allow(OfficeAdmin, 'manage', [RepairInspectionReport, CrewInspection, CreateException]);
allow(OfficeAdmin, 'manage', LPA);
allow(OfficeAdmin, 'view', SuggestionOverride);
allow(OfficeAdmin, 'update', FloorWizard);
allow(OfficeAdmin, 'manage', SendEmail);
allow(OfficeAdmin, 'manage', Leveler);
allow(OfficeAdmin, 'merge_to_original', PurchaseOrder);
allow(OfficeAdmin, 'view', SupervisorFilter, supervisorFilterCheck);
allow(OfficeAdmin, 'view', SupervisorInfo, ifiInfoCheck);
allow(OfficeAdmin, 'manage', AssignInstaller, ifiInfoCheck);
allow(OfficeAdmin, 'manage', IfiLrrp, ifiInfoCheck);
allow(OfficeAdmin, 'manage', DefaultInstallerPay);
allow(OfficeAdmin, 'manage', HolidayPromoSettings);
allow(OfficeAdmin, 'create', SupportRequest);
allow(OfficeAdmin, 'manage', InstallerPrioritizationWeights, installerPrioritizationWeightsCheck);
allow(OfficeAdmin, 'quick_schedule', Phase, quickScheduleIfiCheck);
allow(OfficeAdmin, 'view', NonIfi, nonIfiExclusiveCheck);
recordable(OfficeAdmin);
phaseTasks(OfficeAdmin);
phaseInfo(OfficeAdmin);
activityPerms(OfficeAdmin);
bulkLoadPerms(OfficeAdmin);

// ********************* Regional *********************

employee(Regional);
allow(Regional, 'update', [Phase, Survey, RelatedPhase]);
allow(Regional, 'manage', Communications);
allow(Regional, 'create', Phase);
allow(Regional, 'override', Phase);
allow(Regional, 'cancel', Phase);
allow(Regional, 'verify_document', Phase);
allow(Regional, 'update_contractor_notes', Phase);
allow(Regional, 'relate', Phase);
allow(Regional, 'manage', [Labor, Warehouse, Coc, Walkthrough, RepairInspectionReport, CrewInspection, CreateException, CrewSpecifics]);
allow(Regional, 'assign', Estimator);
allow(Regional, 'manage', [Checklist, Appointment, Pto, TravelingWorkDate, Accounting, ContractorLineItem, AppointmentForm, Contractor, Scraper]);
allow(Regional, 'copy', Phase);
allow(Regional, 'update', Store);
allow(Regional, 'manage', StoreContact);
allow(Regional, 'view', [PayRate, InstallationsPaperwork, LaborTotal]);
allow(Regional, 'manage', Estimator);
allow(Regional, 'resend', Installer);
allow(Regional, ['assign', 'update_basic'], [Installer, Crew]);
allow(Regional, 'manage', LPA);
allow(Regional, 'view', SuggestionOverride);
allow(Regional, 'update', FloorWizard);
allow(Regional, 'manage', Leveler);
allow(Regional, 'merge_to_original', PurchaseOrder);
allow(Regional, 'view', SupervisorFilter, supervisorFilterCheck);
allow(Regional, 'view', SupervisorInfo, ifiInfoCheck);
allow(Regional, 'manage', AssignInstaller, ifiInfoCheck);
allow(Regional, 'manage', IfiLrrp, ifiInfoCheck);
allow(Regional, 'create', SupportRequest);
allow(Regional, 'manage', InstallerPrioritizationWeights, installerPrioritizationWeightsCheck);
allow(Regional, 'quick_schedule', Phase, quickScheduleIfiCheck);
allow(Regional, 'view', NonIfi, nonIfiExclusiveCheck);
recordable(Regional);
phaseTasks(Regional);
phaseInfo(Regional);
activityPerms(Regional);

// ********************* Workroom *********************

employee(Workroom);
allow(Workroom, 'update', [Phase, Survey, RelatedPhase]);
allow(Workroom, 'manage', Communications);
allow(Workroom, 'create', Phase);
allow(Workroom, 'override', Phase);
allow(Workroom, 'cancel', Phase);
allow(Workroom, 'verify_document', Phase);
allow(Workroom, 'update_contractor_notes', Phase);
allow(Workroom, 'relate', Phase);
allow(Workroom, 'manage', [Labor, Warehouse, Coc, Walkthrough, RepairInspectionReport, CrewInspection, CreateException]);
allow(Workroom, ['assign', 'update'], Estimator);
allow(Workroom, 'manage', [Checklist, Appointment, Pto, TravelingWorkDate, Accounting, ContractorLineItem, AppointmentForm, Contractor, Scraper]);
allow(Workroom, 'copy', Phase);
allow(Workroom, 'update', Store);
allow(Workroom, 'manage', StoreContact);
allow(Workroom, 'view', [PayRate, InstallationsPaperwork, LaborTotal]);
allow(Workroom, ['assign', 'update_basic'], [Installer, Crew]);
allow(Workroom, 'update', FloorWizard);
allow(Workroom, 'manage', Leveler);
allow(Workroom, 'merge_to_original', PurchaseOrder);
allow(Workroom, 'view', SupervisorFilter, supervisorFilterCheck);
allow(Workroom, 'view', SupervisorInfo, ifiInfoCheck);
allow(Workroom, 'view', NonIfi, nonIfiExclusiveCheck);
allow(Workroom, 'manage', AssignInstaller, ifiInfoCheck);
allow(Workroom, 'manage', IfiLrrp, ifiInfoCheck);
allow(Workroom, 'manage', InstallerPrioritizationWeights, installerPrioritizationWeightsCheck);
allow(Workroom, 'quick_schedule', Phase, quickScheduleIfiCheck);
allow(Workroom, 'create', SupportRequest);
recordable(Workroom);
phaseTasks(Workroom);
phaseInfo(Workroom);
activityPerms(Workroom);
bulkLoadPerms(Workroom);

// ********************* Iqm *********************

employee(Iqm);
allow(Iqm, 'view', [PurchaseOrder, LaborSheet, ContractorLineItem, Phase, Employee, Estimator, Iqm, Store, Appointment, Event, Workroom, Document, Survey, RelatedPhase, Pto, TravelingWorkDate, Flag, Schedule, TimeInPhase, Labor, Warehouse, Installer, Crew]);
allow(Iqm, 'create', Event);
allow(Iqm, 'manage', Communications);
allow(Iqm, 'verify_document', Phase);
allow(Iqm, 'cancel', Phase);
allow(Iqm, 'override', Phase);
allow(Iqm, 'update_contractor_notes', Phase);
allow(Iqm, 'manage', [Appointment, Contractor, Document, Pto, Flag, Coc, Walkthrough, RepairInspectionReport, CrewInspection, MaterialsChecklist]);
allow(Iqm, ['editable', 'view'], Chargeback);
allow(Iqm, 'update', Chargeback, function (user, sheet) {
  return sheet.attrs.obj_status !== 'Recorded' || 'Uncollectable';
});
allow(Iqm, 'manage', AppointmentForm, function (iqmAttrs) {
  return iqmAttrs.attrs.user_name === iqmAttrs.attrs.obj_name;
});
allow(Iqm, 'view', [TagsBulkPrint, WarehouseReport, InstallationsPaperwork, InstallWorkorderReport, LaborTotal, JobHistory]);
allow(Iqm, 'view', NonIfi, nonIfiExclusiveCheck);
phaseTasks(Iqm);
phaseInfo(Iqm);

// ********************* LowesDocs *********************

employee(LowesDocs);
allow(LowesDocs, 'view', [RelatedPhase, InstallationsPaperwork, Warehouse, LaborTotal]);
allow(LowesDocs, 'manage', [Phase, Labor, Accounting, ContractorLineItem, Scraper]);
allow(LowesDocs, 'copy', Phase);
allow(LowesDocs, 'update', Store);
allow(LowesDocs, ['view', 'update', 'delete'], StoreContact);
allow(LowesDocs, 'view', NonIfi, nonIfiExclusiveCheck);
recordable(LowesDocs);
phaseTasks(LowesDocs);
phaseInfo(LowesDocs);

// ********************* Accounting *********************

employee(Accounting);
allow(Accounting, 'view', [Labor, ContractorLineItem, LaborTotal]);
allow(Accounting, 'override', Phase);
allow(Accounting, 'update', Phase);
allow(Accounting, 'update_contractor_notes', Phase);
allow(Accounting, 'manage', [Accounting, InstallationsPaperwork]);
allow(Accounting, 'copy', Phase);
allow(Accounting, 'manage', [BulkUpdateUpload, MarginUpload, Warehouse]);
allow(Accounting, ['editable', 'view', 'update', 'approve'], LaborSheet);
allow(Accounting, ['editable', 'view', 'update'], [Chargeback, PurchaseOrder, Labor]);
allow(Accounting, 'manage', Installer);
allow(Accounting, 'view', NonIfi, nonIfiExclusiveCheck);
approvedLabor(Accounting);
phaseTasks(Accounting);
phaseInfo(Accounting);

// ********************* ReviewsAndRefigures *********************

employee(ReviewsAndRefigures);
allow(ReviewsAndRefigures, 'override', Phase);
allow(ReviewsAndRefigures, 'cancel', Phase);
allow(ReviewsAndRefigures, 'update_contractor_notes', Phase);
allow(ReviewsAndRefigures, ['copy', 'update'], Phase);
allow(ReviewsAndRefigures, 'view', [Labor, LaborTotal]);
allow(ReviewsAndRefigures, 'update', Store);
allow(ReviewsAndRefigures, ['view', 'update', 'delete'], StoreContact);
allow(ReviewsAndRefigures, 'update', FloorWizard);
allow(ReviewsAndRefigures, 'view', NonIfi, nonIfiExclusiveCheck);
phaseTasks(ReviewsAndRefigures);
phaseInfo(ReviewsAndRefigures);

// ********************* Estimator ********************
allow(Estimator, 'update', Phase);
allow(Estimator, 'update_contractor_notes', Phase);
allow(Estimator, 'manage', Appointment);
allow(Estimator, 'view', [Accounting, LaborSheet, ContractorLineItem, LaborTotal, Workroom]);
allow(Estimator, 'manage', [AppointmentForm, Pto, TravelingWorkDate], self);
allow(Estimator, 'assign', Contractor, self);
allow(Estimator, 'view', [Badge], self);
allow(Estimator, 'update', FloorWizard);
allow(Estimator, 'view', NonIfi, nonIfiExclusiveCheck);
allow(Estimator, 'manage', SendEmail);
allow(Estimator, 'quick_schedule', Phase, quickScheduleAssigneeCheck('phase_estimator_id'));
phaseTasks(Estimator);
phaseInfo(Estimator);
estimatorDetails(Estimator);

// ********************* Installer ********************
allow(Installer, 'view', [Phase, Installer, Crew, Appointment, Document, Pto, TravelingWorkDate, Schedule, Workroom]);
allow(Installer, 'update_contractor_notes', Phase);
allow(Installer, 'create', Event);
allow(Installer, 'create', Flag, installerAssignedToPhaseCheck);
allow(Installer, 'view', Appointment);
allow(Installer, 'view', [Accounting, LaborSheet, ContractorLineItem, LaborTotal]);
allow(Installer, 'approve', LaborSheet);
allow(Installer, 'manage', [Coc, Walkthrough, RepairInspectionReport, CrewInspection, CreateException, MaterialsChecklist]);
allow(Installer, 'manage', IfiLrrp, installerAssignedToPhaseCheck);
allow(Installer, 'manage', [AppointmentForm, Pto, TravelingWorkDate], self);
allow(Installer, 'view', NonIfi, nonIfiExclusiveCheck);
// Installers may only schedule IFI appointments via Quick Schedule — never through the
// standard appointment create/manage flow.
allow(Installer, 'quick_schedule', Phase, installerQuickScheduleCheck);
phaseTasks(Installer);

// *********************** Crew **********************
allow(Crew, 'view', [Phase, Crew, Appointment, Document, Pto, TravelingWorkDate, Schedule]);
allow(Crew, 'update_contractor_notes', Phase);
allow(Crew, 'create', Event);
allow(Crew, 'view', Appointment);
allow(Crew, 'view', [Accounting, LaborSheet, ContractorLineItem]);
allow(Crew, 'approve', LaborSheet);
allow(Crew, 'manage', [Coc, Walkthrough, RepairInspectionReport, CrewInspection, CreateException, MaterialsChecklist]);
allow(Crew, 'manage', [AppointmentForm, Pto, TravelingWorkDate], self);
allow(Crew, 'view', NonIfi, nonIfiExclusiveCheck);
phaseTasks(Crew);

var canRole = function canRole(role, action, entity) {
  var attrs = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  var roleObj = Roles[(role || '').toUpperCase()];
  if (!roleObj) return false;
  var entityObj = void 0;
  // In the case of viewing the 'L/P & Accounting' tab - passing in 2 entities
  if (Array.isArray(entity)) {
    for (var i = 0; i < entity.length; i += 1) {
      entityObj = Entities[(entity[i] || '').toUpperCase()];
      roleObj.attrs = attrs;
      entityObj.attrs = attrs;
      if (can(roleObj, action, entityObj) === true) return true;
    }
    // Every other tab - passing in 1 entity
  } else {
    entityObj = Entities[(entity || '').toUpperCase()];
  }
  if (!entityObj) return false;
  roleObj.attrs = attrs;
  entityObj.attrs = attrs;
  return can(roleObj, action, entityObj);
};

var canAccessCustomLaborSheet = function canAccessCustomLaborSheet() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$role = _ref.role,
      role = _ref$role === undefined ? '' : _ref$role,
      _ref$phase_source = _ref.phase_source,
      phase_source = _ref$phase_source === undefined ? '' : _ref$phase_source,
      _ref$mvw = _ref.mvw,
      mvw = _ref$mvw === undefined ? {} : _ref$mvw;

  return phase_source === 'IFI' && (role === 'installer' || !!mvw.ifi);
};

var canAccessIfiTemplate = function canAccessIfiTemplate() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$role = _ref2.role,
      role = _ref2$role === undefined ? '' : _ref2$role,
      _ref2$phase_type = _ref2.phase_type,
      phase_type = _ref2$phase_type === undefined ? '' : _ref2$phase_type,
      _ref2$phase_source = _ref2.phase_source,
      phase_source = _ref2$phase_source === undefined ? '' : _ref2$phase_source;

  return Object(__WEBPACK_IMPORTED_MODULE_2__utils__["y" /* roleNotInstallerBased */])(role) && ['Assessment', 'Workorder'].includes(phase_type) && phase_source === 'IFI';
};





/***/ }),

/***/ "D1D2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"ifiLrrpModal__msignaturepad___1Sdcl","m-signature-pad--body":"ifiLrrpModal__m-signature-pad--body___2-yHx","m-signature-pad--footer":"ifiLrrpModal__m-signature-pad--footer___1qIjB","description":"ifiLrrpModal__description___5ROvH","button":"ifiLrrpModal__button___23TTz","clear":"ifiLrrpModal__clear___3z4_S","save":"ifiLrrpModal__save___TUK-j","m-signature-pad":"ifiLrrpModal__m-signature-pad___Dl33x","github":"ifiLrrpModal__github___1jfdR","form":"ifiLrrpModal__form___2dyNz","row":"ifiLrrpModal__row___2GwGx","label":"ifiLrrpModal__label___2Rvzq","input":"ifiLrrpModal__input___1e4l7","select":"ifiLrrpModal__select___3aGPA","textarea":"ifiLrrpModal__textarea___2abmQ","error":"ifiLrrpModal__error___3x3Lg","pageHeader":"ifiLrrpModal__pageHeader___3vN0R","pageSeparator":"ifiLrrpModal__pageSeparator___2PZKH","actions":"ifiLrrpModal__actions___C3JN7"};

/***/ }),

/***/ "D5fg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "entry_configuration-0fd125b3e0cb8baa16fa66a9d6329d18.png";

/***/ }),

/***/ "DB9+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"phaseCard__msignaturepad___3y8gb","m-signature-pad--body":"phaseCard__m-signature-pad--body___3VaV6","m-signature-pad--footer":"phaseCard__m-signature-pad--footer___X4YP3","description":"phaseCard__description___1p09k","button":"phaseCard__button___19rIh","clear":"phaseCard__clear___3V64F","save":"phaseCard__save___3UDu-","m-signature-pad":"phaseCard__m-signature-pad___1lkkI","github":"phaseCard__github___230-p","phaseLink":"phaseCard__phaseLink___203bu","aside":"phaseCard__aside___2XgSJ","red":"phaseCard__red___2UCBt","yellow":"phaseCard__yellow___Vl8gK","green":"phaseCard__green___2R9UU","orange":"phaseCard__orange___31vnh","aside-ss":"phaseCard__aside-ss___1uBSo","resourceCardElement":"phaseCard__resourceCardElement___11WCI","resourceCardElementTitle":"phaseCard__resourceCardElementTitle___288d7","flagsCard":"phaseCard__flagsCard___xMK6W","noteCard":"phaseCard__noteCard___1M0_y","phaseCardAside":"phaseCard__phaseCardAside___1gov5","title":"phaseCard__title___TLthc","customerInfo":"phaseCard__customerInfo___LDk9z","customerAddress":"phaseCard__customerAddress___3rArf","productType":"phaseCard__productType___2KaWQ","dueDate":"phaseCard__dueDate___-fvPo","phaseCardActionModeRight":"phaseCard__phaseCardActionModeRight___14OEB","phaseColumnFlex":"phaseCard__phaseColumnFlex___1Nv-r","phaseRowFlex":"phaseCard__phaseRowFlex___2IxMb","phaseCardColumn":"phaseCard__phaseCardColumn___H7wxZ","lrrpRequired":"phaseCard__lrrpRequired___15akB","motOnTime":"phaseCard__motOnTime___qH3pT","motWarning":"phaseCard__motWarning___OjfKh","motOverdue":"phaseCard__motOverdue___3AEgu","motNotApplicable":"phaseCard__motNotApplicable___bgjoe","phaseNoteContainer":"phaseCard__phaseNoteContainer___2PXYb","phaseTypeValue":"phaseCard__phaseTypeValue___b4ZdM","assessmentValue":"phaseCard__assessmentValue___2Mbki","workorderValue":"phaseCard__workorderValue___8FnrM","installValue":"phaseCard__installValue___14-BL","vendorSourceImg":"phaseCard__vendorSourceImg___2CJ00"};

/***/ }),

/***/ "E9uF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"modal__msignaturepad___1YPKF","m-signature-pad--body":"modal__m-signature-pad--body___31ZH-","m-signature-pad--footer":"modal__m-signature-pad--footer___1aJ9a","description":"modal__description___dJm3U","button":"modal__button___2X2cy","add":"modal__add___Qrv22","cancel":"modal__cancel___wpfet","submit":"modal__submit___3Eqc8","linkButton":"modal__linkButton___2KkSH","clear":"modal__clear___2kxSr","save":"modal__save___3pJFU","m-signature-pad":"modal__m-signature-pad___vWNfr","github":"modal__github___3xdnF","modal":"modal__modal___2i7cL","largerModal":"modal__largerModal___8rfiD","title":"modal__title___2ypNv","text":"modal__text___x0wKA","errorMessage":"modal__errorMessage___14d97","select":"modal__select___1FsOE","commSelect":"modal__commSelect___2TtqS","action":"modal__action___1xE9R","smallAction":"modal__smallAction___1kJ9Q","close":"modal__close___D_x3F","subtitle":"modal__subtitle___314sz","dropdown":"modal__dropdown___lPIAt","checkboxListItem":"modal__checkboxListItem___ixEf8","actions":"modal__actions___E4-fO","element":"modal__element___1tLf1","checkbox":"modal__checkbox___14-J1","labeledCheckboxWrapper":"modal__labeledCheckboxWrapper___2Whk1","singleAction":"modal__singleAction___3SNiV","flexWrapper":"modal__flexWrapper___mK9q4","flexItem":"modal__flexItem___kvaxb","confirmation":"modal__confirmation___1Zr7R","largeButton":"modal__largeButton___2OU44","timeInput":"modal__timeInput___3puPG","emptyTable":"modal__emptyTable___gj9iM","emptyModal":"modal__emptyModal___1JWI6","poTotal":"modal__poTotal___3UWsF","table":"modal__table___1heL5","headerRow":"modal__headerRow___2GX6X","contentRow":"modal__contentRow___20wqA","cell":"modal__cell___2QE9s","deleteCell":"modal__deleteCell___34dFN","legalText":"modal__legalText___1LfDg","signatureTitle":"modal__signatureTitle___PBV8t","signatureText":"modal__signatureText___3R5Ui","cocLink":"modal__cocLink___1Qiow","missingFieldsMessage":"modal__missingFieldsMessage___2TI2g","btnContainer":"modal__btnContainer___S51Fl","message":"modal__message___3xx9H","imsCheckboxLabel":"modal__imsCheckboxLabel___2E3pQ"};

/***/ }),

/***/ "EHD2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_toolbox__ = __webpack_require__("iXbh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_toolbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_toolbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__coloredButton_scss__ = __webpack_require__("Lu33");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__coloredButton_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__coloredButton_scss__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var ColoredButton = function ColoredButton(_ref) {
  var label = _ref.label,
      responsive = _ref.responsive,
      disabled = _ref.disabled,
      color = _ref.color,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, ['label', 'responsive', 'disabled', 'color', 'className']);

  var buttonColor = disabled ? 'gray' : color;

  var filterClasses = __WEBPACK_IMPORTED_MODULE_3_classnames___default()(__WEBPACK_IMPORTED_MODULE_4__coloredButton_scss___default.a.button, className, __WEBPACK_IMPORTED_MODULE_4__coloredButton_scss___default.a[buttonColor], _defineProperty({}, __WEBPACK_IMPORTED_MODULE_4__coloredButton_scss___default.a.responsive, responsive));

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_toolbox__["Button"], _extends({
    label: label,
    inverse: true,
    disabled: disabled,
    className: filterClasses
  }, rest));
};

ColoredButton.defaultProps = {
  label: '',
  responsive: false,
  disabled: false,
  color: 'green'
};

ColoredButton.propTypes = {
  label: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  color: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  responsive: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func
};

/* harmony default export */ __webpack_exports__["a"] = (ColoredButton);

/***/ }),

/***/ "EwDC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"tooltip__msignaturepad___2_fmI","m-signature-pad--body":"tooltip__m-signature-pad--body___j1Hg2","m-signature-pad--footer":"tooltip__m-signature-pad--footer___EoKKW","description":"tooltip__description___2GNWL","button":"tooltip__button___2kw0_","clear":"tooltip__clear___2ZSL1","save":"tooltip__save___2SOWO","m-signature-pad":"tooltip__m-signature-pad___1vyrd","github":"tooltip__github___3bT2S","tooltip-high-contrast-wo":"tooltip__tooltip-high-contrast-wo___H4AZ0","place-top":"tooltip__place-top___3vVS0","place-right":"tooltip__place-right___3l9Oe","place-left":"tooltip__place-left___1KKy1","place-bottom":"tooltip__place-bottom___IhSdp","tooltip-high-contrast-information":"tooltip__tooltip-high-contrast-information___n2mb4","tooltip-high-contrast-actionable":"tooltip__tooltip-high-contrast-actionable___2HM8v"};

/***/ }),

/***/ "F/03":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"link__msignaturepad___3_PAX","m-signature-pad--body":"link__m-signature-pad--body___3QRh9","m-signature-pad--footer":"link__m-signature-pad--footer___1GpLG","description":"link__description___79h_W","button":"link__button___3YbrU","clear":"link__clear___2iBuB","save":"link__save___17Zvn","m-signature-pad":"link__m-signature-pad___HfYKu","github":"link__github___1mbz7","link":"link__link___1gEkC","navLink":"link__navLink___2VUtW","itemText":"link__itemText___2AO70","hidden":"link__hidden___2y7Pv"};

/***/ }),

/***/ "F6G/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bj1-1d45f70fab2c13f5331f34d7972c44c8.png";

/***/ }),

/***/ "FLDy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___3H_7g","m-signature-pad--body":"styles__m-signature-pad--body___2-IFH","m-signature-pad--footer":"styles__m-signature-pad--footer___1E2wX","description":"styles__description___1fvX9","button":"styles__button___pIISP","clear":"styles__clear___QBLo8","save":"styles__save___2W2To","m-signature-pad":"styles__m-signature-pad___npFv_","github":"styles__github___1RR03","label":"styles__label___2CM_j","errorLabel":"styles__errorLabel___2Io02","errorMsg":"styles__errorMsg___2STkn","errorWrapper":"styles__errorWrapper___19smL","input":"styles__input___2Uz1y"};

/***/ }),

/***/ "FbQg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getIdFromPayload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getResource; });
/* unused harmony export createConstants */
/* unused harmony export wrapsWithApiError */
/* unused harmony export defaultApiError */
/* unused harmony export listContainsElement */
/* unused harmony export getUserData */
/* unused harmony export rejectAction */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return requireAllFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return isEmpty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return isImage; });
/* unused harmony export checkSessionExpired */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return titleize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return normalize; });
/* unused harmony export formatNotes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return mapObjectToList; });
/* unused harmony export toQueryString */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return fullAddress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return formatTelephone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return stringifyList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return error; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return errorSummary; });
/* unused harmony export hasRequiredFields */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return generateSource; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return generateStringsSource; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return nestedError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return removeNestedError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return filterTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return confirm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return filterByDivisionId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return filterByRegionId; });
/* unused harmony export phoneValue */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return smoothScrollBy; });
/* unused harmony export isApexWorkroom */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return roleNotInstallerBased; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getRandomStr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return isDeliveryPhase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return validateSource; });
/* unused harmony export isSpig */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return vendorDisplayName; });
/* unused harmony export deriveVendorKey */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return woSourceOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return validStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return deriveStatusName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return replaceFalsyObjVals; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return normalizeSource; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jwt_decode__ = __webpack_require__("ytdl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jwt_decode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actionCreators__ = __webpack_require__("uJNR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_confirm__ = __webpack_require__("sfvs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_confirm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_confirm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_ConfirmDialog__ = __webpack_require__("nAl5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_config_constants__ = __webpack_require__("JKMY");
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable no-prototype-builtins */







var getIdFromPayload = function getIdFromPayload(payload) {
  return payload.id !== null && payload.id !== undefined ? payload.id : payload.result;
};

var getResource = function getResource(entity, payload, id) {
  return payload.entities && payload.entities[entity] && payload.entities[entity][id];
};

var createConstants = function createConstants() {
  for (var _len = arguments.length, constants = Array(_len), _key = 0; _key < _len; _key++) {
    constants[_key] = arguments[_key];
  }

  return constants.reduce(function (acc, constant) {
    var thing = acc;
    thing[constant] = constant;
    return thing;
  }, {});
};

/*
  Adds an apiError property to the action meta field.
  It supports both plain objects & action creators
 */
var wrapsWithApiError = function wrapsWithApiError(target, error) {
  if ((typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object') return _extends({}, target, { meta: _extends({}, target.meta, { apiError: error }) });
  return function () {
    var action = target.apply(undefined, arguments);
    action.meta = Object.assign({}, action.meta, { apiError: error });
    return action;
  };
};

var defaultApiError = function defaultApiError(error) {
  return wrapsWithApiError({ type: 'DEFAULT_API_ERROR' }, error);
};

var listContainsElement = function listContainsElement(list, element) {
  return list.indexOf(element) > -1;
};

var getUserData = function getUserData(idToken) {
  var payload = __WEBPACK_IMPORTED_MODULE_0_jwt_decode___default()(idToken);
  return { uid: payload.sub, email: payload.email, image_url: payload.picture };
};

var rejectAction = function rejectAction(action) {
  var reason = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return action && Promise.reject(reason);
};

var requireAllFields = function requireAllFields(data, fields) {
  var errorMsg = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'All fields must be completed before saving';
  var globalErrorKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'global';
  var debug = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  var retValue = {};
  fields.forEach(function (key) {
    if (!data.hasOwnProperty(key) || data[key] == null) {
      if (debug) console.debug('Field ', key, ' not present in ', data); // eslint-disable-line no-console
      retValue = _defineProperty({}, globalErrorKey, [errorMsg]);
    }
  });
  return retValue;
};

var isEmpty = function isEmpty(obj) {
  return Object.keys(obj).length === 0;
};

var isImage = function isImage(file) {
  if (!file || typeof file !== 'string') return false;
  var exts = ['jpg', 'jpeg', 'png', 'gif'];
  var lower = file.toLowerCase();
  return exts.some(function (ext) {
    return lower.indexOf(ext) > -1;
  });
};

function checkSessionExpired(dispatch, error) {
  if (error.response && error.response.status === 419) {
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_actionCreators__["L" /* logoutUser */])('Your session has expired. You have been logged out due to inactivity.'));
  }
}

var titleize = function titleize(string) {
  return Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["startCase"])(string);
};

var normalize = function normalize(collection) {
  return collection.reduce(function (acc, item) {
    var thing = acc;
    thing[item.id] = item;
    return thing;
  }, {});
};

var formatNotes = function formatNotes(notes) {
  return notes.replace(/\n\s*\n/g, ' | ');
};

var mapObjectToList = function mapObjectToList(data) {
  return Object.keys(data).map(function (key) {
    return data[key];
  });
};

var toQueryString = function toQueryString(obj) {
  return Object.keys(obj).map(function (key) {
    return encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]);
  }).join('&');
};

var fullAddress = function fullAddress(_ref) {
  var _ref$street_address = _ref.street_address,
      street_address = _ref$street_address === undefined ? '' : _ref$street_address,
      _ref$address = _ref.address,
      address = _ref$address === undefined ? '' : _ref$address,
      _ref$city = _ref.city,
      city = _ref$city === undefined ? '' : _ref$city,
      _ref$state = _ref.state,
      state = _ref$state === undefined ? '' : _ref$state,
      _ref$zip_code = _ref.zip_code,
      zip_code = _ref$zip_code === undefined ? '' : _ref$zip_code;
  return [address || street_address, city, state, zip_code].filter(Boolean).join(', ');
};

var formatTelephone = function formatTelephone(value) {
  return value ? value.split('').filter(function (c) {
    return c.match(/\d/);
  }).map(function (n, index) {
    if (index === 3 || index === 6) return '-' + n;
    if (index === 10) return ' ext ' + n;
    return n;
  }).join('') : '';
};

var stringifyList = function stringifyList(list) {
  var selector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (v) {
    return v.name;
  };
  return list.map(function (item) {
    return selector(item);
  }).join(', ');
};

var error = function error(key, errors) {
  return errors && errors[key] && errors[key].length > 0 ? errors[key].join(', ') : null;
};

var errorSummary = function errorSummary(errorObj) {
  return Array.isArray(errorObj) ? errorObj.map(function (err) {
    return '' + err;
  }) : Object.keys(errorObj).map(function (key) {
    return Array.isArray(errorObj[key]) ? errorObj[key].map(function (err) {
      return titleize(key) + ' ' + err;
    }).join(', ') : errorObj[key];
  }).join(', ');
};

var hasRequiredFields = function hasRequiredFields(fields, object) {
  return fields.every(function (key) {
    return object.hasOwnProperty(key);
  });
};

var generateSource = function generateSource(array) {
  var selector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (v) {
    return v.name;
  };
  return array.map(function (item) {
    return { value: item.id, label: selector(item) };
  });
};

var generateStringsSource = function generateStringsSource(array) {
  return array.map(function (item) {
    return { value: item, label: item };
  });
};

var nestedError = function nestedError(property, index, name, errors) {
  return error(property + '[' + index + '].' + name, errors);
};

var removeNestedError = function removeNestedError(entity, index, errors) {
  var result = {};
  for (var i = 0; i < errors.keys; i += 1) {
    var anError = error[i];
    // if nested error not found, add it to result
    var errorName = entity.concat('[').concat(index).concat(']');
    if (anError.indexOf(errorName) === -1) result[anError] = errors[anError];
  }
  return result;
};

var filterTypes = function filterTypes(accepted, hash) {
  return Object.fromEntries(Object.entries(hash).filter(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 1),
        key = _ref3[0];

    return key.includes(accepted);
  }));
};

var defaultConfirmation = Object(__WEBPACK_IMPORTED_MODULE_2_react_confirm__["createConfirmation"])(__WEBPACK_IMPORTED_MODULE_3_components_ConfirmDialog__["a" /* default */]);

var confirm = function confirm(confirmation) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return defaultConfirmation(_extends({ confirmation: confirmation }, options));
};

var filterByDivisionId = function filterByDivisionId(divisionId) {
  return function (region) {
    return parseInt(divisionId, 10) === region.division_id;
  };
};

var filterByRegionId = function filterByRegionId(regionId) {
  return function (market) {
    return parseInt(regionId, 10) === market.region_id;
  };
};

var phoneValue = function phoneValue(number, type) {
  return number ? number + ' (' + type + ')' : '';
};

var smoothScrollBy = function smoothScrollBy(_ref4) {
  var _ref4$pixels = _ref4.pixels,
      pixels = _ref4$pixels === undefined ? 0 : _ref4$pixels,
      _ref4$percent = _ref4.percent,
      percent = _ref4$percent === undefined ? 0 : _ref4$percent;
  return setTimeout(function () {
    var body = document.body;
    var html = document.documentElement;
    var height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
    var amount = void 0;
    if (percent) amount = height * (percent / 100);else if (pixels) amount = pixels;else amount = 0;
    window.scrollBy({ left: 0, top: amount, behavior: 'smooth' });
  }, 300);
};

var isApexWorkroom = function isApexWorkroom(name) {
  return __WEBPACK_IMPORTED_MODULE_5_config_constants__["X" /* LRRP_TEST_WORKROOMS */].includes(name);
};

var roleNotInstallerBased = function roleNotInstallerBased(role) {
  var allowInstaller = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return allowInstaller ? role !== 'crew' : !['installer', 'crew'].includes(role);
};

var getRandomStr = function getRandomStr() {
  var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;

  var result = '';
  var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var charactersLength = characters.length;
  for (var i = 0; i < length; i += 1) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

var isDeliveryPhase = function isDeliveryPhase(phaseType, apptSurfaceType, storeDeliveryMethod, spigDelivery) {
  return phaseType === 'Installation' && !__WEBPACK_IMPORTED_MODULE_5_config_constants__["D" /* DELIVERY_SURFACE_TYPES_BLACKLIST */].includes(apptSurfaceType) && storeDeliveryMethod !== 'None' && spigDelivery;
};

var validateSource = function validateSource(source) {
  var arr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_5_config_constants__["V" /* LHI_SOURCES */];
  return arr.includes(source);
};

var isSpig = function isSpig(source) {
  return source === 'SPIG';
};

var vendorDisplayName = function vendorDisplayName(source, workroomName) {
  var directKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (directKey) return isSpig(source) ? source : __WEBPACK_IMPORTED_MODULE_5_config_constants__["_52" /* VENDOR_NAME_MAP */][source];
  if (workroomName && workroomName.includes('PFT-')) return __WEBPACK_IMPORTED_MODULE_5_config_constants__["_52" /* VENDOR_NAME_MAP */].PFT;
  if (validateSource(source, __WEBPACK_IMPORTED_MODULE_5_config_constants__["_8" /* NON_LHI_SOURCES */])) return __WEBPACK_IMPORTED_MODULE_5_config_constants__["_52" /* VENDOR_NAME_MAP */][source];
  return __WEBPACK_IMPORTED_MODULE_5_config_constants__["_52" /* VENDOR_NAME_MAP */].LHI;
};

// Until we make PFT its own vendor, we have to make special consideration
// TODO: Remove this function when PFT is a vendor
var deriveVendorKey = function deriveVendorKey(phaseSource, optionSource, workroomName) {
  if (optionSource === 'PFT' && (workroomName.includes('PFT-') || phaseSource === 'RF')) return 'PFT';
  if (validateSource(phaseSource)) return 'LHI';
  return phaseSource || '';
};

// Legacy behavior (reference only): options were derived from ALL_SOURCES,
// normalized to vendor-generated labels, filtered by phase vendor (with SPIG/PFT
// exceptions), deduped, then mapped to the same internal/external display labels.
var woSourceOptions = function woSourceOptions() {
  return [{ value: 'SPIG generated', label: 'Internally Generated' }, { value: 'Lowe\'s generated', label: 'Externally Generated' }];
};

var validStatus = function validStatus(status) {
  var arr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return arr.includes(status.toLowerCase());
};

var deriveStatusName = function deriveStatusName(status) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { source: '', workroom: '' };
  var source = options.source,
      workroom = options.workroom;

  return source && validStatus(status.toLowerCase(), ['provider hold', 'cpo', 'hold']) ? 'Issue - Waiting on ' + vendorDisplayName(source, workroom) : titleize(status) || 'N/A';
};

var replaceFalsyObjVals = function replaceFalsyObjVals(obj) {
  var defaultVal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'N/A';
  return Object.fromEntries(Object.entries(obj).map(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
        key = _ref6[0],
        value = _ref6[1];

    return [key, !value ? defaultVal : value];
  }));
};

var normalizeSource = function normalizeSource(source) {
  return validateSource(source) ? 'LHI' : source;
};

/***/ }),

/***/ "FhFp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"printLabel__msignaturepad___1ONkY","m-signature-pad--body":"printLabel__m-signature-pad--body___5SRP6","m-signature-pad--footer":"printLabel__m-signature-pad--footer___17nRa","description":"printLabel__description___3GACc","button":"printLabel__button___j2CX7","clear":"printLabel__clear___2Cfh2","save":"printLabel__save___23RVO","m-signature-pad":"printLabel__m-signature-pad___1m_lZ","github":"printLabel__github___2kors","wrapper":"printLabel__wrapper___3STiU","wrapperParagraph":"printLabel__wrapperParagraph___2khqs","isLarge":"printLabel__isLarge___1Cgg2"};

/***/ }),

/***/ "G/CU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"laborTables__msignaturepad___AwxsM","m-signature-pad--body":"laborTables__m-signature-pad--body___emvqG","m-signature-pad--footer":"laborTables__m-signature-pad--footer___2HAmx","description":"laborTables__description___3-H16","button":"laborTables__button___tBaVb","clear":"laborTables__clear___3oMo-","save":"laborTables__save___1IzIb","m-signature-pad":"laborTables__m-signature-pad___1l7_u","github":"laborTables__github___1HszH","cardHeader":"laborTables__cardHeader___rlazx","cardTitle":"laborTables__cardTitle___1JH8Y","cardLink":"laborTables__cardLink___30RwV","cardAction":"laborTables__cardAction___1QRpM","iconWrapper":"laborTables__iconWrapper___1xKv8","inlineTableItem":"laborTables__inlineTableItem___3cLj9","tdIndention":"laborTables__tdIndention___3Ztlw","mergeCell":"laborTables__mergeCell___2YrHl"};

/***/ }),

/***/ "Gkd3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___1xZ-m","m-signature-pad--body":"styles__m-signature-pad--body___34DaO","m-signature-pad--footer":"styles__m-signature-pad--footer___2CIG1","description":"styles__description___3kHTe","button":"styles__button___2hDMS","clear":"styles__clear___2i2h1","save":"styles__save___1uL8O","m-signature-pad":"styles__m-signature-pad___1uCpR","github":"styles__github___K6add","currencyInput":"styles__currencyInput___2KEEK","tagsInputWrapper":"styles__tagsInputWrapper___wB3Hk","tagsInputLabel":"styles__tagsInputLabel___1moPA","tagsInputElement":"styles__tagsInputElement___2MXh6","tagsInputTag":"styles__tagsInputTag___yyvEm","zipBtn":"styles__zipBtn___rgwwR","zipWrapper":"styles__zipWrapper___2kcwA","zipContainer":"styles__zipContainer___3id8F"};

/***/ }),

/***/ "HWGv":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "pro-tip-967fdb7ac67871fc9a2874140e5a3b36.png";

/***/ }),

/***/ "HwDC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"tabs__msignaturepad___1s99j","m-signature-pad--body":"tabs__m-signature-pad--body___3wqtj","m-signature-pad--footer":"tabs__m-signature-pad--footer___1k9Ql","description":"tabs__description___WMDRH","button":"tabs__button___efOq8","clear":"tabs__clear___3ByEY","save":"tabs__save___2y8Si","m-signature-pad":"tabs__m-signature-pad___3IFQV","github":"tabs__github___3yi2A","label":"tabs__label___3z61x","active":"tabs__active___1egzR","inError":"tabs__inError___xzyn3","headerOnlyTabs":"tabs__headerOnlyTabs___10tf9","tabs":"tabs__tabs___1iSfh","navigation":"tabs__navigation___16RUm","pointer":"tabs__pointer___2pouq","absoluteTabs":"tabs__absoluteTabs___3Qkfh","tab":"tabs__tab___3HmZO"};

/***/ }),

/***/ "IGnt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"thankyou__msignaturepad___c-uxz","m-signature-pad--body":"thankyou__m-signature-pad--body___3ifWy","m-signature-pad--footer":"thankyou__m-signature-pad--footer___BKmUv","description":"thankyou__description___B774x","button":"thankyou__button___2DPWH","clear":"thankyou__clear___3UqcU","save":"thankyou__save___3AcKW","m-signature-pad":"thankyou__m-signature-pad___3I4E0","github":"thankyou__github___pfW-P","wrapper":"thankyou__wrapper___26CND","card":"thankyou__card___2P8Wl","spLogo":"thankyou__spLogo___yEpx8"};

/***/ }),

/***/ "IJEG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return loadPhase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return createPhase; });
/* harmony export (immutable) */ __webpack_exports__["g"] = copyPhase;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return updatePhase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return clearValidation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addEventToPhase; });
/* harmony export (immutable) */ __webpack_exports__["l"] = overridePhaseStatus;
/* harmony export (immutable) */ __webpack_exports__["b"] = addFlagToPhase;
/* harmony export (immutable) */ __webpack_exports__["m"] = removeFlagFromPhase;
/* harmony export (immutable) */ __webpack_exports__["s"] = updatePhaseTask;
/* harmony export (immutable) */ __webpack_exports__["c"] = assignPhaseEstimator;
/* harmony export (immutable) */ __webpack_exports__["d"] = assignPhaseInstaller;
/* harmony export (immutable) */ __webpack_exports__["n"] = requestEstimatorListByWorkroom;
/* harmony export (immutable) */ __webpack_exports__["o"] = requestInstallersForAssignment;
/* harmony export (immutable) */ __webpack_exports__["p"] = requestPhaseAppointments;
/* harmony export (immutable) */ __webpack_exports__["e"] = cancelPhase;
/* harmony export (immutable) */ __webpack_exports__["t"] = verifyPhaseAssessment;
/* harmony export (immutable) */ __webpack_exports__["i"] = createSupportRequest;
/* harmony export (immutable) */ __webpack_exports__["j"] = fetchCvProposals;
/* harmony export (immutable) */ __webpack_exports__["q"] = resolveCvProposal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services__ = __webpack_require__("NvlE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_actionCreators__ = __webpack_require__("uJNR");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var _createActions = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])({
  PHASE_RESOURCE_SUCCESS: [function (json) {
    return { phase: json.phase };
  }, function (json) {
    return json.meta;
  }]
}, 'PHASE_RESOURCE_FAILURE', 'PHASE_RESOURCE_REQUEST'),
    phaseResourceSuccess = _createActions.phaseResourceSuccess,
    phaseResourceFailure = _createActions.phaseResourceFailure,
    phaseResourceRequest = _createActions.phaseResourceRequest;

var loadPhase = function loadPhase(id) {
  var optimisticState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (dispatch) {
    dispatch(phaseResourceRequest({ id: id, optimisticState: optimisticState }));
    return Object(__WEBPACK_IMPORTED_MODULE_1__services__["h" /* request */])('phases/' + id).then(function (_ref) {
      var json = _ref.json;

      dispatch(phaseResourceSuccess(json));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_actionCreators__["H" /* loadPhaseItems */])(json.phase.purchase_orders, id, 'purchaseOrders'));
    }).catch(function (error) {
      return dispatch(phaseResourceFailure(error));
    });
  };
};

var _createActions2 = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])({
  PHASE_RESOURCE_CREATE_SUCCESS: [function (json) {
    return { phase: json.phase };
  }, function (json) {
    return json.meta;
  }]
}, 'PHASE_RESOURCE_CREATE_FAILURE', 'PHASE_RESOURCE_CREATE_REQUEST'),
    phaseResourceCreateRequest = _createActions2.phaseResourceCreateRequest,
    phaseResourceCreateSuccess = _createActions2.phaseResourceCreateSuccess,
    phaseResourceCreateFailure = _createActions2.phaseResourceCreateFailure;

var createPhase = function createPhase(phase) {
  return function (dispatch) {
    dispatch(phaseResourceCreateRequest(phase));
    return Object(__WEBPACK_IMPORTED_MODULE_1__services__["d" /* create */])('phase', phase).then(function (_ref2) {
      var json = _ref2.json;

      dispatch(phaseResourceCreateSuccess(json));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_actionCreators__["H" /* loadPhaseItems */])(json.phase.purchase_orders, phase.id, 'purchaseOrders'));
    }).catch(function (error) {
      return dispatch(phaseResourceCreateFailure(error));
    });
  };
};

var _createActions3 = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])({
  PHASE_RESOURCE_COPY_SUCCESS: [function (json) {
    return { phase: json.phase };
  }, function (json) {
    return json.meta;
  }]
}, 'PHASE_RESOURCE_COPY_FAILURE', 'PHASE_RESOURCE_COPY_REQUEST'),
    phaseResourceCopyRequest = _createActions3.phaseResourceCopyRequest,
    phaseResourceCopySuccess = _createActions3.phaseResourceCopySuccess,
    phaseResourceCopyFailure = _createActions3.phaseResourceCopyFailure;

function copyPhase(phaseID, body) {
  return function (dispatch) {
    dispatch(phaseResourceCopyRequest());
    return Object(__WEBPACK_IMPORTED_MODULE_1__services__["h" /* request */])('phases/' + phaseID + '/copy', { method: 'PUT', body: body }).then(function (_ref3) {
      var json = _ref3.json;
      return dispatch(phaseResourceCopySuccess(json, phaseID));
    }).catch(function (error) {
      return dispatch(phaseResourceCopyFailure(error));
    });
  };
}

var _createActions4 = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])({
  PHASE_RESOURCE_UPDATE_SUCCESS: [function (json) {
    return { phase: json.phase };
  }, function (json) {
    return json.meta;
  }]
}, 'PHASE_RESOURCE_UPDATE_FAILURE', 'PHASE_RESOURCE_UPDATE_REQUEST'),
    phaseResourceUpdateRequest = _createActions4.phaseResourceUpdateRequest,
    phaseResourceUpdateSuccess = _createActions4.phaseResourceUpdateSuccess,
    phaseResourceUpdateFailure = _createActions4.phaseResourceUpdateFailure;

var updatePhase = function updatePhase(phase, _ref4) {
  var _ref4$actionType = _ref4.actionType,
      actionType = _ref4$actionType === undefined ? 'update' : _ref4$actionType,
      _ref4$communication = _ref4.communication,
      communication = _ref4$communication === undefined ? 'none' : _ref4$communication;
  return function (dispatch) {
    dispatch(phaseResourceUpdateRequest(phase));
    return Object(__WEBPACK_IMPORTED_MODULE_1__services__["h" /* request */])('phases/' + phase.id, {
      method: 'PUT',
      body: { phase: phase, action_type: actionType, communication: communication }
    }).then(function (_ref5) {
      var json = _ref5.json;
      return dispatch(phaseResourceUpdateSuccess(json));
    }).catch(function (error) {
      return dispatch(phaseResourceUpdateFailure(error));
    });
  };
};

var clearValidation = function clearValidation() {
  return { type: 'PHASE_RESOURCE_CLEAR_VALIDATION' };
};

var _createActions5 = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])({
  ADD_EVENT_TO_PHASE_SUCCESS: function ADD_EVENT_TO_PHASE_SUCCESS(json, phaseID) {
    return { event: json.event, phaseID: phaseID };
  }
}, 'ADD_EVENT_TO_PHASE_FAILURE', 'ADD_EVENT_TO_PHASE_REQUEST'),
    addEventToPhaseRequest = _createActions5.addEventToPhaseRequest,
    addEventToPhaseSuccess = _createActions5.addEventToPhaseSuccess,
    addEventToPhaseFailure = _createActions5.addEventToPhaseFailure;

var addEventToPhase = function addEventToPhase(phaseID, event) {
  return function (dispatch) {
    dispatch(addEventToPhaseRequest(event));
    return Object(__WEBPACK_IMPORTED_MODULE_1__services__["h" /* request */])('phases/' + phaseID + '/events', { method: 'POST', body: { event: event } }).then(function (_ref6) {
      var json = _ref6.json;
      return dispatch(addEventToPhaseSuccess(json, phaseID));
    }).catch(function (errors) {
      return dispatch(addEventToPhaseFailure(errors));
    });
  };
};

var _createActions6 = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])({
  OVERRIDE_PHASE_STATUS_SUCCESS: function OVERRIDE_PHASE_STATUS_SUCCESS(json, phaseID) {
    return { phase: json.phase, phaseID: phaseID };
  }
}, 'OVERRIDE_PHASE_STATUS_REQUEST', 'OVERRIDE_PHASE_STATUS_FAILURE'),
    overridePhaseStatusRequest = _createActions6.overridePhaseStatusRequest,
    overridePhaseStatusSuccess = _createActions6.overridePhaseStatusSuccess,
    overridePhaseStatusFailure = _createActions6.overridePhaseStatusFailure;

function overridePhaseStatus(phaseID, data) {
  var addtlData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : { source: 'other', delete_appointments: 'no' };

  return function (dispatch) {
    dispatch(overridePhaseStatusRequest());
    return Object(__WEBPACK_IMPORTED_MODULE_1__services__["h" /* request */])('phases/' + phaseID + '/status', { method: 'PATCH', body: _extends({}, data, addtlData) }).then(function (_ref7) {
      var json = _ref7.json;
      return dispatch(overridePhaseStatusSuccess(json, phaseID));
    }).catch(function (error) {
      return dispatch(overridePhaseStatusFailure(error));
    });
  };
}

var _createActions7 = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])({
  ADD_FLAG_TO_PHASE_SUCCESS: function ADD_FLAG_TO_PHASE_SUCCESS(json, phaseID) {
    return { phase: json.phase, phaseID: phaseID };
  }
}, 'ADD_FLAG_TO_PHASE_REQUEST', 'ADD_FLAG_TO_PHASE_FAILURE'),
    addFlagToPhaseRequest = _createActions7.addFlagToPhaseRequest,
    addFlagToPhaseSuccess = _createActions7.addFlagToPhaseSuccess,
    addFlagToPhaseFailure = _createActions7.addFlagToPhaseFailure;

function addFlagToPhase(phaseID, flag) {
  return function (dispatch) {
    dispatch(addFlagToPhaseRequest());
    return Object(__WEBPACK_IMPORTED_MODULE_1__services__["h" /* request */])('phases/' + phaseID + '/flags', { method: 'POST', body: { flag: flag } }).then(function (_ref8) {
      var json = _ref8.json;
      return dispatch(addFlagToPhaseSuccess(json, phaseID));
    }).catch(function (error) {
      return dispatch(addFlagToPhaseFailure(error));
    });
  };
}

var _createActions8 = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])({
  REMOVE_FLAG_FROM_PHASE_SUCCESS: function REMOVE_FLAG_FROM_PHASE_SUCCESS(json, phaseID) {
    return { phase: json.phase, phaseID: phaseID };
  }
}, 'REMOVE_FLAG_FROM_PHASE_REQUEST', 'REMOVE_FLAG_FROM_PHASE_FAILURE'),
    removeFlagFromPhaseRequest = _createActions8.removeFlagFromPhaseRequest,
    removeFlagFromPhaseSuccess = _createActions8.removeFlagFromPhaseSuccess,
    removeFlagFromPhaseFailure = _createActions8.removeFlagFromPhaseFailure;

function removeFlagFromPhase(phaseID, flag) {
  return function (dispatch) {
    dispatch(removeFlagFromPhaseRequest());
    return Object(__WEBPACK_IMPORTED_MODULE_1__services__["h" /* request */])('phases/' + phaseID + '/flags/' + flag.id, { method: 'DELETE', body: { flag: flag } }).then(function (_ref9) {
      var json = _ref9.json;
      return dispatch(removeFlagFromPhaseSuccess(json, phaseID));
    }).catch(function (error) {
      return dispatch(removeFlagFromPhaseFailure(error));
    });
  };
}

var _createActions9 = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])({
  UPDATE_PHASE_TASK_SUCCESS: function UPDATE_PHASE_TASK_SUCCESS(json, phaseID) {
    return { phase: json.phase, phaseID: phaseID };
  },
  UPDATE_PHASE_TASK_FAILURE: [function (error) {
    return error;
  }, function (_, taskID) {
    return { taskID: taskID };
  }]
}, 'UPDATE_PHASE_TASK_REQUEST'),
    updatePhaseTaskRequest = _createActions9.updatePhaseTaskRequest,
    updatePhaseTaskSuccess = _createActions9.updatePhaseTaskSuccess,
    updatePhaseTaskFailure = _createActions9.updatePhaseTaskFailure;

function updatePhaseTask(phaseID, taskID, body) {
  return function (dispatch) {
    dispatch(updatePhaseTaskRequest(taskID));
    return Object(__WEBPACK_IMPORTED_MODULE_1__services__["h" /* request */])('phases/' + phaseID + '/tasks/' + taskID, { method: 'PUT', body: body }).then(function (_ref10) {
      var json = _ref10.json;
      return dispatch(updatePhaseTaskSuccess(json, phaseID));
    }).catch(function (error) {
      return dispatch(updatePhaseTaskFailure(error, taskID));
    });
  };
}

var _createActions10 = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])({
  ASSIGN_PHASE_ESTIMATOR_SUCCESS: function ASSIGN_PHASE_ESTIMATOR_SUCCESS(json, phaseID) {
    return {
      phase: json.phase,
      phaseID: phaseID
    };
  },
  ASSIGN_PHASE_ESTIMATOR_FAILURE: [function (error) {
    return error;
  }, function (_, taskID) {
    return { taskID: taskID };
  }]
}, 'ASSIGN_PHASE_ESTIMATOR_REQUEST'),
    assignPhaseEstimatorRequest = _createActions10.assignPhaseEstimatorRequest,
    assignPhaseEstimatorSuccess = _createActions10.assignPhaseEstimatorSuccess,
    assignPhaseEstimatorFailure = _createActions10.assignPhaseEstimatorFailure;

function assignPhaseEstimator(phaseID, body) {
  return function (dispatch) {
    dispatch(assignPhaseEstimatorRequest());
    return Object(__WEBPACK_IMPORTED_MODULE_1__services__["h" /* request */])('phases/' + phaseID + '/estimator', { method: 'PUT', body: body }).then(function (_ref11) {
      var json = _ref11.json;
      return dispatch(assignPhaseEstimatorSuccess(json, phaseID));
    }).catch(function (error) {
      return dispatch(assignPhaseEstimatorFailure(error));
    });
  };
}

var _createActions11 = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])({
  ASSIGN_PHASE_INSTALLER_SUCCESS: function ASSIGN_PHASE_INSTALLER_SUCCESS(json, phaseID) {
    return {
      phase: json.phase,
      phaseID: phaseID
    };
  },
  ASSIGN_PHASE_INSTALLER_FAILURE: [function (error) {
    return error;
  }, function (_, taskID) {
    return { taskID: taskID };
  }]
}, 'ASSIGN_PHASE_INSTALLER_REQUEST'),
    assignPhaseInstallerRequest = _createActions11.assignPhaseInstallerRequest,
    assignPhaseInstallerSuccess = _createActions11.assignPhaseInstallerSuccess,
    assignPhaseInstallerFailure = _createActions11.assignPhaseInstallerFailure;

function assignPhaseInstaller(phaseID, body) {
  return function (dispatch) {
    dispatch(assignPhaseInstallerRequest());
    return Object(__WEBPACK_IMPORTED_MODULE_1__services__["h" /* request */])('phases/' + phaseID + '/installer', { method: 'PUT', body: body }).then(function (_ref12) {
      var json = _ref12.json;
      return dispatch(assignPhaseInstallerSuccess(json, phaseID));
    }).catch(function (error) {
      return dispatch(assignPhaseInstallerFailure(error));
    });
  };
}

var _createActions12 = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])({
  ESTIMATOR_LIST_BY_WORKROOM_SUCCESS: function ESTIMATOR_LIST_BY_WORKROOM_SUCCESS(json) {
    return {
      estimatorListByWorkroom: json.estimators
    };
  }
}, 'ESTIMATOR_LIST_BY_WORKROOM_REQUEST', 'ESTIMATOR_LIST_BY_WORKROOM_FAILURE'),
    estimatorListByWorkroomRequest = _createActions12.estimatorListByWorkroomRequest,
    estimatorListByWorkroomSuccess = _createActions12.estimatorListByWorkroomSuccess,
    estimatorListByWorkroomFailure = _createActions12.estimatorListByWorkroomFailure;

function requestEstimatorListByWorkroom(workroomID) {
  return function (dispatch) {
    dispatch(estimatorListByWorkroomRequest());
    return Object(__WEBPACK_IMPORTED_MODULE_1__services__["h" /* request */])('estimators?is_active=true&for_workrooms[0]=' + workroomID + '&assign_estimator=true').then(function (_ref13) {
      var json = _ref13.json;
      return dispatch(estimatorListByWorkroomSuccess(json));
    }).catch(function (error) {
      return dispatch(estimatorListByWorkroomFailure(error));
    });
  };
}

var _createActions13 = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])({
  INSTALLERS_FOR_ASSIGNMENT_SUCCESS: function INSTALLERS_FOR_ASSIGNMENT_SUCCESS(json) {
    return {
      installersForAssignment: json.installers
    };
  }
}, 'INSTALLERS_FOR_ASSIGNMENT_REQUEST', 'INSTALLERS_FOR_ASSIGNMENT_FAILURE'),
    installersForAssignmentRequest = _createActions13.installersForAssignmentRequest,
    installersForAssignmentSuccess = _createActions13.installersForAssignmentSuccess,
    installersForAssignmentFailure = _createActions13.installersForAssignmentFailure;

function requestInstallersForAssignment(workroomID, zipCode) {
  return function (dispatch) {
    dispatch(installersForAssignmentRequest());
    return Object(__WEBPACK_IMPORTED_MODULE_1__services__["h" /* request */])('installers/for_assignment/?is_active=true&workroom_id=' + workroomID + '&assign_installer=true&zip_code=' + zipCode).then(function (_ref14) {
      var json = _ref14.json;
      return dispatch(installersForAssignmentSuccess(json));
    }).catch(function (error) {
      return dispatch(installersForAssignmentFailure(error));
    });
  };
}

var _createActions14 = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])({
  PHASE_APPOINTMENTS_SUCCESS: function PHASE_APPOINTMENTS_SUCCESS(json) {
    return {
      appointments: json.appointments
    };
  }
}, 'PHASE_APPOINTMENTS_REQUEST', 'PHASE_APPOINTMENTS_FAILURE'),
    phaseAppointmentsRequest = _createActions14.phaseAppointmentsRequest,
    phaseAppointmentsSuccess = _createActions14.phaseAppointmentsSuccess,
    phaseAppointmentsFailure = _createActions14.phaseAppointmentsFailure;

function requestPhaseAppointments(phaseID) {
  return function (dispatch) {
    dispatch(phaseAppointmentsRequest());
    return Object(__WEBPACK_IMPORTED_MODULE_1__services__["h" /* request */])('phases/' + phaseID + '/appointments').then(function (_ref15) {
      var json = _ref15.json;
      return dispatch(phaseAppointmentsSuccess(json));
    }).catch(function (error) {
      return dispatch(phaseAppointmentsFailure(error));
    });
  };
}

var _createActions15 = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])({
  CANCEL_PHASE_SUCCESS: function CANCEL_PHASE_SUCCESS(json) {
    return {
      phase: json.phase
    };
  }
}, 'CANCEL_PHASE_REQUEST', 'CANCEL_PHASE_FAILURE'),
    cancelPhaseRequest = _createActions15.cancelPhaseRequest,
    cancelPhaseSuccess = _createActions15.cancelPhaseSuccess,
    cancelPhaseFailure = _createActions15.cancelPhaseFailure;

function cancelPhase(phaseID, data) {
  return function (dispatch) {
    dispatch(cancelPhaseRequest());
    return Object(__WEBPACK_IMPORTED_MODULE_1__services__["h" /* request */])('phases/' + phaseID + '/cancellation', { method: 'POST', body: data }).then(function (_ref16) {
      var json = _ref16.json;

      dispatch(cancelPhaseSuccess(json));
      dispatch(requestPhaseAppointments(phaseID));
    }).catch(function (error) {
      return dispatch(cancelPhaseFailure(error));
    });
  };
}

var _createActions16 = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])({
  VERIFY_PHASE_ASSESSMENT_SUCCESS: function VERIFY_PHASE_ASSESSMENT_SUCCESS(json) {
    return { phase: json.phase };
  }
}, 'VERIFY_PHASE_ASSESSMENT_REQUEST', 'VERIFY_PHASE_ASSESSMENT_FAILURE'),
    verifyPhaseAssessmentRequest = _createActions16.verifyPhaseAssessmentRequest,
    verifyPhaseAssessmentSuccess = _createActions16.verifyPhaseAssessmentSuccess,
    verifyPhaseAssessmentFailure = _createActions16.verifyPhaseAssessmentFailure;

function verifyPhaseAssessment(phaseData) {
  return function (dispatch) {
    dispatch(verifyPhaseAssessmentRequest());
    return Object(__WEBPACK_IMPORTED_MODULE_1__services__["h" /* request */])('phases/' + phaseData.id + '/verify_assessment', { method: 'PUT', body: phaseData }).then(function (_ref17) {
      var json = _ref17.json;
      return dispatch(verifyPhaseAssessmentSuccess(json));
    }).catch(function (error) {
      return dispatch(verifyPhaseAssessmentFailure(error));
    });
  };
}

var _createActions17 = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])({
  CREATE_SUPPORT_REQUEST_SUCCESS: function CREATE_SUPPORT_REQUEST_SUCCESS(json) {
    return { phase: json.phase };
  }
}, 'CREATE_SUPPORT_REQUEST_REQUEST', 'CREATE_SUPPORT_REQUEST_FAILURE'),
    createSupportRequestRequest = _createActions17.createSupportRequestRequest,
    createSupportRequestSuccess = _createActions17.createSupportRequestSuccess,
    createSupportRequestFailure = _createActions17.createSupportRequestFailure;

function createSupportRequest(phaseID, supportRequest) {
  return function (dispatch) {
    dispatch(createSupportRequestRequest());
    return Object(__WEBPACK_IMPORTED_MODULE_1__services__["h" /* request */])('phases/' + phaseID + '/support_requests', {
      method: 'POST',
      body: { support_request: supportRequest }
    }).then(function (_ref18) {
      var json = _ref18.json;
      return dispatch(createSupportRequestSuccess(json || {}));
    }).catch(function (error) {
      return dispatch(createSupportRequestFailure(error));
    });
  };
}

var _createActions18 = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])('CV_PROPOSALS_REQUEST', 'CV_PROPOSALS_SUCCESS', 'CV_PROPOSALS_FAILURE'),
    cvProposalsRequest = _createActions18.cvProposalsRequest,
    cvProposalsSuccess = _createActions18.cvProposalsSuccess,
    cvProposalsFailure = _createActions18.cvProposalsFailure;

// Fetches the active CV prefill proposals for a phase (M3). Resolves with the proposals array so
// the CV checklist can seed its form fields; see the ml-contract-verification pipeline.


function fetchCvProposals(phaseID) {
  return function (dispatch) {
    dispatch(cvProposalsRequest({ phaseID: phaseID }));
    return Object(__WEBPACK_IMPORTED_MODULE_1__services__["h" /* request */])('phases/' + phaseID + '/cv_proposals').then(function (_ref19) {
      var json = _ref19.json;

      dispatch(cvProposalsSuccess(json || {}));
      return json && json.cv_proposals || [];
    }).catch(function (error) {
      dispatch(cvProposalsFailure(error));
      return [];
    });
  };
}

var _createActions19 = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])('RESOLVE_CV_PROPOSAL_REQUEST', 'RESOLVE_CV_PROPOSAL_SUCCESS', 'RESOLVE_CV_PROPOSAL_FAILURE'),
    resolveCvProposalRequest = _createActions19.resolveCvProposalRequest,
    resolveCvProposalSuccess = _createActions19.resolveCvProposalSuccess,
    resolveCvProposalFailure = _createActions19.resolveCvProposalFailure;

// Resolves one CV proposal (M4/M5). Accept applies it server-side through the pipeline's
// single write path (line-item status update / assessment link); reject only records the
// label. Resolves with the updated proposal, or null on failure.


function resolveCvProposal(phaseID, proposalID, resolution) {
  return function (dispatch) {
    dispatch(resolveCvProposalRequest({ phaseID: phaseID, proposalID: proposalID, resolution: resolution }));
    return Object(__WEBPACK_IMPORTED_MODULE_1__services__["h" /* request */])('phases/' + phaseID + '/cv_proposals/' + proposalID, {
      method: 'PUT',
      body: { cv_proposal: { resolution: resolution } }
    }).then(function (_ref20) {
      var json = _ref20.json;

      dispatch(resolveCvProposalSuccess(json || {}));
      return json && json.cv_proposal || null;
    }).catch(function (error) {
      dispatch(resolveCvProposalFailure(error));
      return null;
    });
  };
}

/***/ }),

/***/ "IMTd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___3tRjf","m-signature-pad--body":"styles__m-signature-pad--body___31zx4","m-signature-pad--footer":"styles__m-signature-pad--footer___3_u-5","description":"styles__description___W7XN_","button":"styles__button___20jTP","clear":"styles__clear___1T4DT","save":"styles__save___XXSRu","m-signature-pad":"styles__m-signature-pad___u4BfT","github":"styles__github___3kEzR","selectWrapper":"styles__selectWrapper___4yoQO","levelerSelectWrapper":"styles__levelerSelectWrapper___2hICe"};

/***/ }),

/***/ "IWhS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___gTtOh","m-signature-pad--body":"styles__m-signature-pad--body___2UPMY","m-signature-pad--footer":"styles__m-signature-pad--footer___2HF05","description":"styles__description___3LYvb","button":"styles__button___Ddl-5","clear":"styles__clear___2-EM-","save":"styles__save___Xjrx-","m-signature-pad":"styles__m-signature-pad___3RPVg","github":"styles__github___3thr-","cutQuantityContainer":"styles__cutQuantityContainer___R1Dq_","cutQuantityActions":"styles__cutQuantityActions___2v4OZ","icon":"styles__icon___1Kx7V","floating":"styles__floating___1mftt"};

/***/ }),

/***/ "IfL0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___ZIsr8","m-signature-pad--body":"styles__m-signature-pad--body___3MzSR","m-signature-pad--footer":"styles__m-signature-pad--footer___1gXpn","description":"styles__description___3iQTb","button":"styles__button___3AI0m","clear":"styles__clear___22Q9d","save":"styles__save___6Ghxj","m-signature-pad":"styles__m-signature-pad___1Dtx3","github":"styles__github___3Pvmd","input-icon":"styles__input-icon___12KQZ","dollarSign":"styles__dollarSign___tGelQ"};

/***/ }),

/***/ "JKMY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export HIDE_FOR_NOW */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return CUT_POINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return NAV_CUT_POINT; });
/* unused harmony export getRandomRange */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return REFRESH_INTERVAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return FILTER_THEME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return STATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return STATES_WITH_ABBREV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return TIMEZONES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return VENDORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return LHI_SOURCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return NON_LHI_SOURCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ALL_SOURCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return DEFAULT_MVW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return VENDOR_NAME_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return VISIBILITY_RANGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return EMPLOYEE_ROLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return CONTRACTOR_ROLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return IC_ISM_POSITIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return INSTALLER_UNRESTRICTED_ROLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return SCHEDULING_REASONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return RESCHEDULE_REASONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ASSESSMENT_RESCHEDULE_REASONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return STORE_CONTACT_POSITIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return RESTRICTED_FILTER_POSITIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return PHONE_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return PHONE_TYPES_W_FAX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return INSTALLER_TABS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return PHASE_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return APPT_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return REQUIRED_APPT_FIELDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return REQUIRED_CV_FIELDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return REQUIRED_CV_FIELDS_IFI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return PHASE_APPOINTMENT_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADD_APPT_TYPE_LABELS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return DEFAULT_ARRIVAL_WINDOW_HOURS; });
/* unused harmony export WELCOME_CALL_NEEDED_FLAG */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return VERIFY_BUILD_DATE_FLAG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTIONABLE_KEYS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return CSS_FLAG_KEYS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return HOLIDAY_PROMO_FLAG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return PHASE_DETAILS_TABS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return MODE_OF_CONTACT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return AUTO_COMM_METHOD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return VINYL_SIZE_CHOICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return JOB_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return CARPET_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return CARPET_SIZES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return VINYL_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return WOOD_FLOORING_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return WOOD_INSTALL_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return TILE_STONE_LOCATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return WALL_JOB_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return TILE_OR_STONE_STYLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return TILE_OR_STONE_SIZES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return TILE_OR_STONE_PATTERN_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return TILE_JOB_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return TILE_STYLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return TILE_SIZES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return TILE_PATTERNS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return DOCUMENT_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return VALID_DOC_FILE_UPLOADS; });
/* unused harmony export REQUIRED_ERROR_MSG */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return MAX_FILE_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return MAX_EXCEL_FILE_SIZE; });
/* unused harmony export FLOOR_WIZARD_TASK_SLUG */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return CONTRACT_VERIFICATION_STATUS_COLORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return LABOR_VERIFICATION_STATUSES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return PRODUCT_VERIFICATION_STATUSES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return MERCHANDISE_VERIFICATION_STATUSES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return WAREHOUSE_MERCHANDISE_STATUSES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return WORKORDER_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return FIRM_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return CERTIFICATION_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return LRRP_DESCRIPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_63", function() { return WRITTEN_DETERMINATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return CERTIFIED_KITS_USED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return LEAD_TEST_KIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return LEAD_TEST_RESULT; });
/* unused harmony export TEST_INSTALLING_TASK_LIST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return LRRP_TEST_WORKROOMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return REMOVAL_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return POTENTIAL_HALT_MESSAGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return CHECKLIST_RESPONSE_NOTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return CHECKLIST_BASIC_YES_NO_LISTS; });
/* unused harmony export OVERLAP_RESTRICTED_SURFACES */
/* unused harmony export HARD_SURFACES */
/* unused harmony export ACTUAL_SURFACE_TYPES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return SPECIAL_SURFACE_TYPES; });
/* unused harmony export ALL_SURFACE_TYPES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return RELATED_SPECIFIC_FIELDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return NON_COMPARABLE_SPECIFIC_FIELDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ANCHORED_REMOVAL_PLIS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ANCHORED_REMOVAL_SLUGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return MULTI_ITEM_AND_SPECIFIC_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return SS_PLI_MULTIPLIERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return MULTI_SURFACE_ENABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return TIME_CONSTRAINT_MESSAGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return TWD_MESSAGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return WORK_DAY_HOURS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return DATE_FORMAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return SCHEDULE_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return DISPLAY_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return DISPLAY_TIME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return DISPLAY_DATE_TIME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return OTHER_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return RAILS_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return RAILS_DATE_ALT; });
/* unused harmony export RAILS_TIME */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return RAILS_DATE_TIME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return MOMENT_TIME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return AUTO_COMM_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return ASSIGNEE_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ALLOWED_DASHBOARD_POSITIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ALLOWED_DASHBOARD_NAMES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return TOTAL_DAY_LIMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return ASSESSMENT_LABOR_ITEMS; });
/* unused harmony export SPIG_ADDTL_MILEAGE_ITEMS */
/* unused harmony export IFI_ADDTL_MILEAGE_ITEMS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADDTL_MILEAGE_ITEMS; });
/* unused harmony export IFI_ASSESSMENT_DETAIL_ITEMS */
/* unused harmony export SPIG_ASSESSMENT_DETAIL_ITEMS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return ASSESSMENT_DETAIL_ITEMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return FIXED_LINE_ITEMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return DELIVERY_SURFACE_TYPES_BLACKLIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return NUM_DAYS_MOBILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return NUM_DAYS_DESKTOP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return SCRIPT_STATUSES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return DELIVERY_BUFFERS; });
/* unused harmony export BASE_DELIVERY_LIMIT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return EMAIL_VALIDATION_REGEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return MILLWORK_SURFACES; });
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var HIDE_FOR_NOW = true;

var CUT_POINT = 1024;
var NAV_CUT_POINT = 1343;

function getRandomRange(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

// randomize refresh time to a range between 2 and 4 minutes
var REFRESH_INTERVAL = 1000 * getRandomRange(120, 240);
var FILTER_THEME = { RTOverlay: '' };

var STATES = ['Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'DC', 'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'];

var STATES_WITH_ABBREV = {
  AL: 'Alabama',
  AK: 'Alaska',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DC: 'DC',
  DE: 'Delaware',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming'
};

var TIMEZONES = ['US/Eastern', 'US/Central', 'US/Mountain', 'US/Pacific'];

var VENDORS = ['LHI', 'RF', 'FD', 'IFI', 'AH', 'BJ', 'SAM', 'WAY'];

var LHI_SOURCES = ['IMS', 'IME', 'Manual', 'Scraper'];

var NON_LHI_SOURCES = VENDORS.filter(function (v) {
  return v !== 'LHI';
});

var ALL_SOURCES = LHI_SOURCES.concat([].concat(_toConsumableArray(NON_LHI_SOURCES), ['PFT', 'SPIG']));

var DEFAULT_MVW = {
  lhi: false, rf: false, fd: false, ah: false, ifi: false, bj: false, sam: false, way: false
};

var VENDOR_NAME_MAP = {
  LHI: 'Lowe\'s',
  RF: 'Refloor',
  FD: 'Floor & Decor',
  IFI: 'Integrity First',
  AH: 'Ace Hardware',
  BJ: 'BJ\'s',
  SAM: 'Sam\'s Club',
  WAY: 'Wayfair',
  PFT: 'Preferred Flooring & Tile'
};

var VISIBILITY_RANGES = [{ value: 14, label: '14 Days' }, { value: 7, label: '7 Days' }, { value: 3, label: '3 Days' }, { value: 1, label: 'Today' }];

var EMPLOYEE_ROLES = [{ value: 'office_admin', label: 'Office Administrator' }, { value: 'regional', label: 'Regional Manager' }, { value: 'workroom', label: 'Workroom' }, { value: 'lowes_docs', label: "Lowe's Docs" }, { value: 'accounting', label: 'Accounting' }, { value: 'reviews_and_refigures', label: 'Reviews & Refigures' }, { value: 'admin', label: 'Administrator' }];

var CONTRACTOR_ROLES = ['estimator', 'installer'];

var IC_ISM_POSITIONS = ['Installation Coordinator', 'Installation Service Manager', 'ISM - LRRP', 'Production Specialist'];

var INSTALLER_UNRESTRICTED_ROLES = ['office_admin', 'accounting', 'admin', 'regional'];

var AC_ERROR = 'AC Error Fix';
var CAPACITY_ISSUE = 'Capacity Issue';
var CUSTOMER = 'Customer';
var CUSTOMER_CALLED = 'Customer - Customer Called';
var CUSTOMER_RESCHEDULE = 'Customer Reschedule';
var DELIVERY_ISSUE = 'Delivery Issue';
var ESTIMATOR_CAPACITY = 'Estimator Capacity - Unable to Meet Customer Request';
var ESTIMATOR_SWAP = 'Estimator Swap';
var EXISTING_WINDOW = 'Narrowing Time on Existing Window';
var JOBSITE_OBSTRUCTION = 'Jobsite Obstruction';
var JOB_SITE_OBSTRUCTION = 'Job Site Obstruction';
var LOWES_CALLED = "Customer - Lowe's Called";
var NO_SHOW = 'Rescheduling No-Show';
var PRODUCT_DAMAGED = 'Product Damaged';
var PRODUCT_DELAYS = 'Product Delays';
var PRODUCT_DELAY = 'Product Delay';
var PROVIDER_RESCHEDULE = 'Provider Reschedule';
var WITHIN_TARGET = 'Within Target';

var SCHEDULING_REASONS = [{ value: CUSTOMER, label: CUSTOMER }, { value: PRODUCT_DELAYS, label: PRODUCT_DELAYS }, { value: CAPACITY_ISSUE, label: CAPACITY_ISSUE }, { value: WITHIN_TARGET, label: WITHIN_TARGET }];

var RESCHEDULE_REASONS = [{ value: PRODUCT_DELAY, label: PRODUCT_DELAY }, { value: CUSTOMER_RESCHEDULE, label: CUSTOMER }, { value: PROVIDER_RESCHEDULE, label: PROVIDER_RESCHEDULE }, { value: JOBSITE_OBSTRUCTION, label: JOB_SITE_OBSTRUCTION }, { value: PRODUCT_DAMAGED, label: PRODUCT_DAMAGED }, { value: DELIVERY_ISSUE, label: DELIVERY_ISSUE }];

var ASSESSMENT_RESCHEDULE_REASONS = [{ value: CUSTOMER_CALLED, label: CUSTOMER_CALLED }, { value: LOWES_CALLED, label: LOWES_CALLED }, { value: ESTIMATOR_CAPACITY, label: ESTIMATOR_CAPACITY }, { value: ESTIMATOR_SWAP, label: ESTIMATOR_SWAP }, { value: EXISTING_WINDOW, label: EXISTING_WINDOW }, { value: NO_SHOW, label: NO_SHOW }, { value: AC_ERROR, label: AC_ERROR }];

var STORE_CONTACT_POSITIONS = ['Customer Service Associate', 'Sales Specialist of Flooring', 'Department Manager of Flooring', 'Store Manager', 'Department Manager of Installed Sales', 'Sales Manager', 'Receiving Clerk', 'Installed Sales Coordinator', 'Installed Sales Product Associate', 'Assistant Store Manager - Sales', 'Assistant Store Manager - Support', 'Did Not Specify'];

var RESTRICTED_FILTER_POSITIONS = ['Assessment Coordinator', 'Customer Care Specialist', 'Scheduling Coordinator', 'Installation Coordinator', 'Installation Quality Manager'];

var PHONE_TYPES = ['mobile', 'desk'];
var PHONE_TYPES_W_FAX = PHONE_TYPES.concat('fax');

var INSTALLER_TABS = [{ label: 'Basic Info', ability: 'installer', editable: true }, {
  label: 'Millwork Certifications',
  ability: 'installer',
  editable: true,
  fullInstallerUpdateOnly: true
}, { label: 'Pay Rates', ability: 'pay_rate', editable: true }, { label: 'Crew', ability: 'crew', editable: true }, { label: 'Traveling Work', ability: 'crew', editable: false }, { label: 'Time Off', ability: 'pto', editable: false }, { label: 'Scores', ability: 'installer', editable: false }, { label: 'User Details History', ability: 'installer', editable: false }];

var ASSESSMENT = 'Assessment';
var INSTALLATION = 'Installation';
var WORKORDER = 'Workorder';

var PHASE_TYPES = [ASSESSMENT, INSTALLATION, WORKORDER];

var APPT_TYPES = [{ label: ASSESSMENT, value: 'assessment' }, { label: 'Assessment Hold', value: 'assessment_hold' }, { label: INSTALLATION, value: 'installation' }, { label: 'Installation Hold', value: 'installation_hold' }, { label: 'Stack Cali Bamboo', value: 'stack_cali_bamboo' }, { label: 'Deliver/Stack Cali Bamboo', value: 'deliver_stack_cali_bamboo' }, { label: 'Bust Day', value: 'bust_day' }, { label: 'Jobsite Inspection', value: 'jobsite_inspection' }, { label: 'Repair', value: 'repair' }, { label: 'Workorder Inspection', value: 'repair_inspection' }, { label: 'Crew Inspection', value: 'crew_inspection' }, { label: 'Delivery', value: 'delivery' }];

var REQUIRED_APPT_FIELDS = {
  startDate: 'Start Date',
  endDate: 'End Date',
  arrivalStart: 'Arrival Start',
  arrivalEnd: 'Arrival End',
  schedulingReason: 'Scheduling Reason',
  selectedAssignee: 'Assignee'
};

var REQUIRED_CV_FIELDS = {
  customerNote: 'Customer Note',
  newConstruction: 'New Construction',
  pavedDriveway: 'Paved Driveway',
  difficultAccess: 'Difficult Access',
  restrictedParking: 'Restricted Parking',
  elevatorAvailable: 'Elevator Available',
  floorBaseHeating: 'Floor/Baseboard Heating',
  freshPaintWalls: 'Freshly Painted Walls',
  petsPresent: 'Pets Present',
  cuttingArea: 'Cutting Area',
  rapidSetMortar: 'Rapid Set Mortar',
  woodSubfloor: 'Wood Subfloor',
  hardyBackerMortar: 'Backer Board + Mortar',
  rolledGoodsTransitions: 'Supplying Transitions For Rolled Goods',
  pickup: 'Pickup',
  gasAppliances: 'Gas Appliances',
  buildingType: 'Building Type'
};

var REQUIRED_CV_FIELDS_IFI = {
  customerNote: 'Customer Note',
  difficultAccess: 'Difficult Access',
  restrictedParking: 'Restricted Parking',
  elevatorAvailable: 'Elevator Available',
  buildingType: 'Building Type',
  pickup: 'Pickup'
};

var PHASE_APPOINTMENT_TYPES = {
  Assessment: ['assessment', 'assessment_hold'],
  Installation: ['installation', 'installation_hold', 'stack_cali_bamboo', 'deliver_stack_cali_bamboo', 'jobsite_inspection', 'bust_day', 'crew_inspection', 'delivery', 'delivery_hold'],
  Workorder: ['repair_inspection', 'repair', 'stack_cali_bamboo', 'jobsite_inspection', 'bust_day', 'crew_inspection', 'workorder_hold']
};

var ADD_APPT_TYPE_LABELS = {
  assessment: 'Add Appointment',
  assessment_hold: 'Add Assessment Hold',
  installation: 'Add Installation/Hold',
  stack_cali_bamboo: 'Add Stack Cali Bamboo',
  deliver_stack_cali_bamboo: 'Deliver Stack Cali Bamboo',
  jobsite_inspection: 'Add Jobsite Inspection',
  bust_day: 'Add Bust Day',
  crew_inspection: 'Add Crew Inspection',
  delivery: 'Add Delivery',
  repair_inspection: 'Add Virtual Inspection',
  repair: 'Add Repair',
  workorder_hold: 'Workorder Hold',
  delivery_hold: 'Add Delivery Hold'
};

var DEFAULT_ARRIVAL_WINDOW_HOURS = {
  assessment: 1,
  assessment_hold: 1,
  default: 3
};

var WELCOME_CALL_NEEDED_FLAG = 'Welcome Call Needed';

var VERIFY_BUILD_DATE_FLAG = 'Verify Build Date';

var ACTIONABLE_KEYS = ['appointment confirmation', 'commercial awaiting approval', 'complete lrrp task', 'estimator inquiry', 'needs appointment', 'ps assistance', 'poor score', 'product confirmation', 'materials requested', 'welcome call needed', 'verify build date'];

var CSS_FLAG_KEYS = ['presumed lead'];

var HOLIDAY_PROMO_FLAG = 'Holiday Promo';

var PHASE_DETAILS_TABS = [{
  label: 'History',
  routeName: 'phase-history',
  path: 'history',
  ability: 'event',
  phaseTypes: PHASE_TYPES
}, {
  label: 'Phase Info',
  routeName: 'phase-info',
  path: 'info',
  ability: 'phase_info',
  phaseTypes: PHASE_TYPES
}, {
  label: 'L/P & Accounting',
  routeName: 'phase-labor-product-accouting',
  path: 'labor-product-accounting',
  ability: ['labor', 'accounting'],
  phaseTypes: PHASE_TYPES
}, {
  label: 'Documents',
  routeName: 'phase-documents',
  path: 'documents',
  ability: 'document',
  phaseTypes: PHASE_TYPES
}, {
  label: 'Contract Verification Checklist',
  routeName: 'phase-cv-checklist',
  path: 'cv-checklist',
  ability: 'labor',
  phaseTypes: [INSTALLATION]
}, {
  label: 'Scheduling Checklist',
  routeName: 'phase-scheduling-checklist',
  path: 'scheduling-checklist',
  ability: 'appointment',
  phaseTypes: [INSTALLATION]
}, {
  label: 'Appointments',
  routeName: 'phase-appointments',
  path: 'appointments',
  ability: 'appointment',
  phaseTypes: PHASE_TYPES
}, {
  label: 'Related Phases',
  routeName: 'related-phases',
  path: 'related-phases',
  ability: 'related_phase',
  phaseTypes: PHASE_TYPES
}, {
  label: 'Materials',
  routeName: 'warehouse-materials',
  path: 'warehouse-materials',
  ability: 'warehouse',
  phaseTypes: [INSTALLATION, WORKORDER]
},
// {
//   label: 'Survey',
//   routeName: 'phase-survey',
//   path: 'phase-survey',
//   ability: 'survey',
//   phaseTypes: [INSTALLATION, WORKORDER],
// },
{
  label: 'Communication Scripts',
  routeName: 'phase-communications',
  path: 'communications',
  ability: 'communications',
  phaseTypes: [INSTALLATION, WORKORDER]
}, {
  label: 'Material Checklist Scripts',
  routeName: 'phase-materials-checklist',
  path: 'materials-checklist',
  ability: 'materials-checklist',
  phaseTypes: [INSTALLATION, WORKORDER]
}];

var MODE_OF_CONTACT = ['Phone', 'Email Address'];

var AUTO_COMM_METHOD = ['Text', 'Email', 'None'];

var VINYL_SIZE_CHOICES = ['Floating Vinyl Plank', '6-ft Wide Sheet', '12-ft Wide Sheet', '13-ft 2-in Wide Sheet', '12-in x 12-in Tile/VCT', '18-in x 18-in Tile/VCT'];

var JOB_TYPES = ['Replacement', 'New Construction', 'Mobile Home'];

var CARPET_TYPES = ['Plush/Saxony', 'Berber', 'Textured', 'Frieze', 'Level Loop', 'Cut and Loop'];

var CARPET_SIZES = ['12-ft Wide', '13-ft 2-in Wide (Wool)', '15-ft Wide', 'Mixed width - 12-ft and 15-ft'];

var VINYL_TYPES = ['Floating', 'Full Glue', 'Vinyl Commercial Tile (VCT)'];

var WOOD_FLOORING_TYPES = ['Cali Bamboo', 'Engineered Hardwood', 'Solid Hardwood'];

var WOOD_INSTALL_TYPES = ['Glue Down / Edge Glue', 'Locking / Floating', 'Nail Down / Staple Down'];

var TILE_STONE_LOCATIONS = ['Backsplash Only', 'Decorative Wall'];

var WALL_JOB_TYPES = ['New Construction', 'Replacement'];

var TILE_OR_STONE_STYLES = ['Ceramic/Porcelain Tile', 'Stone Tile', 'Glass Tile'];

var TILE_OR_STONE_SIZES = ['Mosaic', '4-in x 4-in', '6-in x 6-in', '12-in x 12-in', '16-in x 16-in'];

var TILE_OR_STONE_PATTERN_TYPES = ['Straight', 'Diagonal'];

var TILE_JOB_TYPES = ['Replacement', 'New Construction'];

var TILE_STYLES = ['Porcelain/Ceramic Tile', 'Natural Stone', 'Saltillo (tile)'];

var TILE_SIZES = ['6-in x 6-in', '12-in x 12-in', '18-in x 18-in', '24-in x 24-in', '6-in x 24-in - Plank', '12-in x 24-in - Plank', '6-in x 36-in - Plank', '8-in x 48-in - Plank'];

var TILE_PATTERNS = ['Stock Bond (Checker Board)', 'Diagonal', 'Custom Inlay', 'Stacked', 'Brick'];

var DOCUMENT_TYPES = ['Contract', 'PO', 'Assessment/Refigure', 'Floor Plan', 'Photos', 'Videos', 'Blank COC', 'Invoices', 'Work Order', 'Purchase Requests', 'Subcontractor - AP', 'Receipts', 'Check Request', 'Inspection Report', 'Misc', 'Signed Documents', 'Bill of Lading', 'LRRP Checklists'];

var VALID_DOC_FILE_UPLOADS = ['pdf', 'jpg', 'jpeg', 'png', 'doc', 'docx', 'xls', 'xlsx', 'gif', 'csv', 'ppt', 'pptx', 'tiff', 'tif', 'mp3', 'mp4', 'wav', 'mov'];

var REQUIRED_ERROR_MSG = "Can't be blank.";

var MAX_FILE_SIZE = 1024000000; // 1GB
var MAX_EXCEL_FILE_SIZE = 3000000; // 3MB
var FLOOR_WIZARD_TASK_SLUG = 'send_to_floor_wizard';

var CV_RED = '#E59C9C';
var CV_GREEN = '#ACDDB5';
var CV_YELLOW = '#FFF9AF';

var CONTRACT_VERIFICATION_STATUS_COLORS = {
  'Not Reviewed': '#FFFFFF',
  'Correct, no action': CV_GREEN,
  Resolved: CV_GREEN,
  'Exception - Resolved': CV_GREEN,
  'Error - Labor Short': CV_YELLOW,
  'Error - Labor Incorrect': CV_YELLOW,
  'Error - Product Short': CV_YELLOW,
  'Error - Product Missing': CV_YELLOW,
  'Error - Product Incorrect': CV_YELLOW,
  'Not Enough Information': CV_YELLOW,
  Irrelevant: '#A7D2FF',
  Exception: CV_RED,
  'Requested Product': CV_RED,
  'Installer Pay': CV_GREEN
};

var CONTRACT_VERIFICATION_STATUSES = ['Not Reviewed', 'Correct, no action', 'Error - {TYPE} Short', 'Error - {TYPE} Incorrect', 'Not Enough Information', 'Irrelevant'];

var createCVOptions = function createCVOptions(type) {
  for (var _len = arguments.length, addl = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    addl[_key - 1] = arguments[_key];
  }

  return CONTRACT_VERIFICATION_STATUSES.map(function (opt) {
    return opt.replace('{TYPE}', type);
  }).concat(addl);
};

var LABOR_VERIFICATION_STATUSES = createCVOptions('Labor', 'Installer Pay', 'Exception', 'Exception - Resolved');
var PRODUCT_VERIFICATION_STATUSES = createCVOptions('Product', 'Error - Product Missing', 'Exception', 'Exception - Resolved');
var MERCHANDISE_VERIFICATION_STATUSES = createCVOptions('Product', 'Requested Product', 'Resolved');

var WAREHOUSE_MERCHANDISE_STATUSES = ['In Warehouse', 'Released', 'On Order', 'Returned to Vendor', 'Returned to Store'];

var WORKORDER_TYPE = ['Inspection: Pre-Install', 'Inspection: Post-Install', 'Installation Repair', 'Return - Completion of Multi-Phase Install', 'Post-Install: Waiting on Product', 'Reinstall'];

var FIRM_NAME = 'Service Pros Installation Group, Inc.';

var CERTIFICATION_NUMBER = 'NAT-F152318-1';

var LRRP_DESCRIPTION = 'Flooring installation';

var WRITTEN_DETERMINATION = 'NO';

var CERTIFIED_KITS_USED = 'N/A';

var LEAD_TEST_KIT = 'Hybrivet Systems Leadcheck Lead Test';

var LEAD_TEST_RESULT = 'Not tested';

var TEST_INSTALLING_TASK_LIST = ['installing_en_route', 'arrived', 'sign_lrrp', 'departed', 'install_complete'];

// Remove when deployed to all workrooms
var LRRP_TEST_WORKROOMS = ['Lawrenceville', 'Marietta'];

var REMOVAL_OPTIONS = [{ value: 'need_remove_naildown_hardwood', label: 'Remove Naildown Hardwood' }, { value: 'need_remove_floating_hardwood', label: 'Remove Floating Hardwood' }, { value: 'need_remove_gluedown_hardwood', label: 'Remove Gluedown Hardwood' }, { value: 'need_remove_gluedown_carpet', label: 'Remove Gluedown Carpet' }, { value: 'need_remove_over_pad_carpet', label: 'Remove Carpet Over Pad' }, { value: 'need_remove_gluedown_vinyl', label: 'Remove Gluedown Vinyl' }, { value: 'need_remove_vinyl_plank', label: 'Remove Vinyl Plank' }, { value: 'need_remove_laminate', label: 'Remove Laminate' }, { value: 'need_remove_tile', label: 'Remove Tile' }];

var POTENTIAL_HALT_MESSAGES = {
  powerAnswered: 'Our installers will be using power tools to complete your installation. I\'d like to get you scheduled as soon as possible, but cannot do so until your home has power. When would be a good time to reach back out to you to schedule?',
  climateControlAnswered: 'For warranty and installation quality purposes, the home must maintain temperature and humidity levels. I\'d like to get you scheduled as soon as possible, but cannot do so until your home is climate controlled. When would be a good time to reach back out to you to schedule?',
  waterAnswered: 'You will need to have this turned on prior to the install date as water is required for the mixing of mortar, grout and clean-up of the tile. I\'d like to get you scheduled as soon as possible, but cannot do so until your home has running water. When would be a good time to reach back out to you to schedule?'
};

var CHECKLIST_RESPONSE_NOTES = {
  okToTextNote: '* USER NOTE: Make sure the box next to the number that the customer is ok to receive texts at is filled in (click to check/uncheck) *',
  flagNote: '* USER NOTE: If customer is anticipating labor to be done that is not on the contract (such as furniture, oversized furniture, appliances, or a toilet), please add an ISM/IC Callback flag notating customer expectations *',
  workroomNote: '* USER NOTE: If customer is anticipating labor to be done that is not on the contract (such as furniture, oversized furniture, appliances, or a toilet), please follow standard process to resolve *',
  priceAdjust: 'No problem; I will adjust this now. Lowe\'s will reach out regarding an adjustment to the price if applicable'
};

var CHECKLIST_BASIC_YES_NO_LISTS = {
  showFurnitureNote: {
    intro: { prefix: 'I see that we are moving furniture. ', base: 'Has anyone gone over what we can and cannot move?' },
    can: ['Move all furnishings, but request that they are emptied and that bedding is stripped.'],
    cannot: ['Move personal belongings such as jewelry, photos, and clothes.', 'Move pianos, aquariums, waterbeds, antiques, pool tables, holiday decorations, free standing gas heating units, large exercise equipment, safes.', 'Remove, replace or reconnect baseboard heaters and wall mounted radiators.', 'Move any electronics (If it has a power cord it will need to be moved prior to install).', 'If the customer asks for details (computers, stereos, home theaters, televisions, medical equipment, alarm systems, mechanical beds and living room furniture etc).']
  },
  showAppliancesNote: {
    intro: { prefix: 'I see that we are moving appliances. ', base: 'Has anyone gone over what we can and cannot move?' },
    can: [],
    cannot: ['Disconnect/reconnect gas appliances or gas heating units.']
  },
  showToiletNote: {
    intro: { prefix: 'I see that we are removing/replacing a toilet. ', base: 'Has anyone gone over what we can and cannot do with your bathroom furnishings?' },
    can: [],
    cannot: ['Remove and reinstall vanities and cabinets.', 'Reinstall pedestal sinks (we will remove but cannot reinstall).', 'Install a new toilet (we will remove and replace existing toilet only).']
  }
};

var OVERLAP_RESTRICTED_SURFACES = ['Hardwood', 'Tile', 'Laminate', 'Vinyl Plank', 'Backsplash'];
var HARD_SURFACES = OVERLAP_RESTRICTED_SURFACES.concat(['Vinyl']);
var ACTUAL_SURFACE_TYPES = HARD_SURFACES.concat(['Carpet']);
var SPECIAL_SURFACE_TYPES = ['Pro Direct', 'Multi'];
var ALL_SURFACE_TYPES = ACTUAL_SURFACE_TYPES.concat(SPECIAL_SURFACE_TYPES);

var RELATED_SPECIFIC_FIELDS = {
  customer_speaks_english: 'can_speak_english',
  customer_speaks_spanish: 'can_speak_spanish',
  is_backsplash_glass: 'can_do_backsplash_glass',
  is_backsplash_tile: 'can_do_backsplash_tile',
  is_backsplash_blocking: 'can_do_backsplash_blocking',
  is_berber_carpet: 'can_do_berber_carpet',
  is_binding_carpet: 'can_do_binding_carpet',
  is_cali_bamboo_hardwood: 'can_do_cali_bamboo_hardwood',
  is_floating_hardwood: 'can_do_floating_hardwood',
  is_floor_tile: 'can_do_floor_tile',
  is_gluedown_carpet: 'can_do_gluedown_carpet',
  is_gluedown_hardwood: 'can_do_gluedown_hardwood',
  is_large_format_tile: 'can_do_large_format_tile',
  is_naildown_hardwood: 'can_do_naildown_hardwood',
  is_pattern_match_carpet: 'can_do_pattern_match_carpet',
  is_patterns_tile: 'can_do_patterns_tile',
  is_steps_carpet: 'can_do_steps_carpet',
  is_steps_hardwood: 'can_do_steps_hardwood',
  is_stretch_in_carpet: 'can_do_stretch_in_carpet',
  is_vct_lvt: 'can_do_vct_lvt',
  is_vinyl_sheet: 'can_do_vinyl_sheet',
  is_gluedown_vinyl_plank: 'can_do_gluedown_vinyl_plank',
  is_floating_vinyl_plank: 'can_do_floating_vinyl_plank',
  need_move_appliances: 'can_move_appliances',
  need_move_furniture: 'can_move_furniture',
  need_move_furniture_oversized: 'can_move_furniture_oversized',
  need_remove_floating_hardwood: 'can_remove_floating_hardwood',
  need_remove_gluedown_carpet: 'can_remove_gluedown_carpet',
  need_remove_gluedown_hardwood: 'can_remove_gluedown_hardwood',
  need_remove_gluedown_vinyl: 'can_remove_gluedown_vinyl',
  need_remove_laminate: 'can_remove_laminate',
  need_remove_naildown_hardwood: 'can_remove_naildown_hardwood',
  need_remove_over_pad_carpet: 'can_remove_over_pad_carpet',
  need_remove_replace_toilet: 'can_remove_replace_toilet',
  need_remove_tile: 'can_remove_tile',
  need_remove_vinyl_plank: 'can_remove_vinyl_plank',
  need_subfloor_prep: 'can_do_subfloor_prep',
  need_subfloor_replacement: 'can_do_subfloor_replacement',
  need_remove_backsplash: 'can_remove_backsplash',
  need_install_baseboard: 'can_do_baseboard',
  need_hardsurface_transitions: 'can_install_hard_transitions'
};

var NON_COMPARABLE_SPECIFIC_FIELDS = ['id', 'customer_has_power', 'customer_has_climate_control', 'customer_has_water', 'millwork_specifics'];

var ANCHORED_REMOVAL_PLIS = ['199745', '155161', '902961', '199589', '6573974'];

var ANCHORED_REMOVAL_SLUGS = ['need_remove_gluedown_hardwood', 'need_remove_naildown_hardwood'];

var MULTI_ITEM_AND_SPECIFIC_MAP = {
  Hardwood: {
    matchingSpecifics: ['is_steps_hardwood', 'is_naildown_hardwood', 'is_gluedown_hardwood', 'is_floating_hardwood', 'is_cali_bamboo_hardwood'],
    itemNumbers: ['CL035', '188204', '188208', '188400', '724006', '724007']
  },
  Carpet: {
    matchingSpecifics: ['is_steps_carpet', 'is_stretch_in_carpet', 'is_gluedown_carpet', 'is_pattern_match_carpet', 'is_binding_carpet'],
    itemNumbers: ['167763', '503233', '227645', '228208', '700727', '729662', '282844', 'CL041']
  },
  Laminate: {
    matchingSpecifics: [],
    itemNumbers: []
  },
  Vinyl: {
    matchingSpecifics: ['is_vinyl_sheet'],
    itemNumbers: ['163973']
  },
  Tile: {
    matchingSpecifics: ['is_floor_tile', 'is_backsplash_tile', 'is_backsplash_glass', 'is_large_format_tile', 'is_patterns_tile'],
    itemNumbers: ['104728', '104730', '104734', '227597', '475356', '475358', '475359', '808996', '143967']
  },
  Backsplash: {
    matchingSpecifics: ['is_backsplash_tile', 'is_backsplash_glass', 'is_backsplash_blocking'],
    itemNumbers: ['475356', '475358', '475359']
  },
  Vinyl_Plank: {
    matchingSpecifics: ['is_gluedown_vinyl_plank', 'is_floating_vinyl_plank'],
    itemNumbers: ['503270', '1060634']
  }
};

var SS_PLI_MULTIPLIERS = {
  customer_has_power: {
    itemNumbers: [],
    multiplier: 0
  },
  customer_has_climate_control: {
    itemNumbers: [],
    multiplier: 0
  },
  customer_has_water: {
    itemNumbers: [],
    multiplier: 0
  },
  need_move_furniture: {
    itemNumbers: ['503239', '503252', '503266', '503276', '503273'],
    multiplier: 0.0008
  },
  need_move_furniture_oversized: {
    itemNumbers: ['CL008'],
    multiplier: 0
  },
  need_move_appliances: {
    itemNumbers: ['343398', '343405', '343412', '343402', '343409', '475368'],
    multiplier: 0
  },
  need_subfloor_prep: {
    itemNumbers: ['189009', '204852', '170551', 'CL001', 'CL002'],
    multiplier: 0
  },
  need_subfloor_replacement: {
    itemNumbers: ['169768', 'CL010'],
    multiplier: 0.008
  },
  need_remove_replace_toilet: {
    itemNumbers: ['227609', '199993', '227600', '163979', '475369'],
    multiplier: 0
  },
  is_steps_hardwood: {
    itemNumbers: ['CL035'],
    multiplier: 0.4
  },
  is_steps_carpet: {
    itemNumbers: ['167763', '503233'],
    multiplier: 0.1
  },
  need_remove_naildown_hardwood: {
    itemNumbers: ['155161', '199589', '405366', '199745', '902961', '6573974'],
    multiplier: 0.005
  },
  need_remove_floating_hardwood: {
    itemNumbers: ['153599', '199571', '405367', '199744'],
    multiplier: 0
  },
  need_remove_gluedown_hardwood: {
    itemNumbers: ['170577', '199616', '405365', '902961', '6573974', '199921', '199745', '155161', '199589'],
    multiplier: 0.02
  },
  need_remove_over_pad_carpet: {
    itemNumbers: ['419901', '199406', '405362', '199735'],
    multiplier: 0
  },
  need_remove_gluedown_carpet: {
    itemNumbers: ['144833', '199475', '405363', '199739'],
    multiplier: 0
  },
  need_remove_laminate: {
    itemNumbers: ['148631', '199568', '405364', '199743', '894131'],
    multiplier: 0
  },
  need_remove_tile: {
    itemNumbers: ['174252', '199682', '405361', '199922', '475345'],
    multiplier: 0.04
  },
  need_remove_gluedown_vinyl: {
    itemNumbers: ['174579', '199704', '199363', '200345', '199381'],
    multiplier: 0
  },
  need_remove_vinyl_plank: {
    itemNumbers: ['178333', '199723', '199385', '200347'],
    multiplier: 0
  },
  need_remove_backsplash: {
    itemNumbers: ['475345', '107911'],
    multiplier: 0.08
  },
  is_naildown_hardwood: {
    itemNumbers: ['188204'],
    multiplier: 0
  },
  is_gluedown_hardwood: {
    itemNumbers: ['188208'],
    multiplier: 0
  },
  is_floating_hardwood: {
    itemNumbers: ['188400', '724006', '724007'],
    multiplier: 0
  },
  is_cali_bamboo_hardwood: {
    itemNumbers: ['712505', '712217', '712504'],
    multiplier: 0
  },
  is_vinyl_sheet: {
    itemNumbers: ['163973'],
    multiplier: 0
  },
  is_vct_lvt: {
    itemNumbers: ['163978'],
    multiplier: 0
  },
  is_stretch_in_carpet: {
    itemNumbers: ['227645', '228208', '700727', '729662'],
    multiplier: 0
  },
  is_gluedown_carpet: {
    itemNumbers: ['282844'],
    multiplier: 0
  },
  is_binding_carpet: {
    itemNumbers: ['CL041'],
    multiplier: 0
  },
  is_pattern_match_carpet: {
    itemNumbers: [],
    multiplier: 0
  },
  is_berber_carpet: {
    itemNumbers: [],
    multiplier: 0
  },
  is_floor_tile: {
    itemNumbers: ['104728', '104730', '104734', '227597'],
    multiplier: 0
  },
  is_backsplash_tile: {
    itemNumbers: ['475356', '475358'],
    multiplier: 0
  },
  is_backsplash_glass: {
    itemNumbers: ['475359'],
    multiplier: 0
  },
  is_patterns_tile: {
    itemNumbers: ['143967'],
    multiplier: 0
  },
  is_large_format_tile: {
    itemNumbers: ['808996'],
    multiplier: 0
  }
};

var MULTI_SURFACE_ENABLED = ['Carpet'];
var TIME_CONSTRAINT_MESSAGES = ['day marked unavailable', 'multi-day appt conflict', '2 appts already scheduled for this day', 'times overlap', 'one-appt-a-day limit for hard surfaces'];
var TWD_MESSAGES = ['Phase zip code not covered by this crew', 'Crew traveling outside assigned territory'];

var WORK_DAY_HOURS = 9;

var DATE_FORMAT = 'MM/DD/YYYY HH:mm:ss';
var SCHEDULE_DATE = 'M/D/YYYY';
var DISPLAY_DATE = 'MM/DD/YYYY';
var DISPLAY_TIME = 'h:mm a';
var DISPLAY_DATE_TIME = DISPLAY_DATE + ' ' + DISPLAY_TIME;
var OTHER_DATE = 'MM-DD-YYYY';
var RAILS_DATE = 'YYYY-MM-DD';
var RAILS_DATE_ALT = 'YYYY-M-D';
var RAILS_TIME = 'HH:mm:ss';
var RAILS_DATE_TIME = 'YYYY-MM-DD HH:mm:ss';
var MOMENT_TIME = 'HH:mm';

var AUTO_COMM_MESSAGE = 'Changing start date/time will automatically notify the customer';

var ASSIGNEE_OPTIONS = [{ label: 'IQM', value: 'IQM' }, { label: 'Crew', value: 'Crew' }, { label: 'Estimator', value: 'Estimator' }, { label: 'Employee', value: 'Employee' }];

var ALLOWED_DASHBOARD_POSITIONS = ['Installation Service Manager', 'ISM - LRRP', 'Installation Coordinator', 'District Operations Manager', 'Regional Operations Manager', 'Director', 'Developer', 'Data Analyst'];

var ALLOWED_DASHBOARD_NAMES = [];

var TOTAL_DAY_LIMIT = 30;

var ASSESSMENT_LABOR_ITEMS = ['CL055', 'CL056', 'CL057', 'CL058'];

var SPIG_ADDTL_MILEAGE_ITEMS = ['154381', '154569', '154592', '227804', '476923'];

var IFI_ADDTL_MILEAGE_ITEMS = ['8875749', '8875751', '154641', '154658', '154660', '903182'];

var ADDTL_MILEAGE_ITEMS = SPIG_ADDTL_MILEAGE_ITEMS.concat(IFI_ADDTL_MILEAGE_ITEMS);

var IFI_ASSESSMENT_DETAIL_ITEMS = ['111511', '111537', '111551', '176957', '903180', '1058953', '1058959', '8836814', '8875748', '8875750', '8931897', '8931896'];

var SPIG_ASSESSMENT_DETAIL_ITEMS = ['111630', '111676', '111719', '111731', '176387', '172447', '1026526'];

var ASSESSMENT_DETAIL_ITEMS = SPIG_ASSESSMENT_DETAIL_ITEMS.concat(IFI_ASSESSMENT_DETAIL_ITEMS);

var FIXED_LINE_ITEMS = [{ label: 'CL055 - No Show - Estimation', price: 10, total: 10 }, { label: 'CL056 - Trip Charge - Estimation', price: 1 }];

var DELIVERY_SURFACE_TYPES_BLACKLIST = ['Carpet'];

var NUM_DAYS_MOBILE = 1;
var NUM_DAYS_DESKTOP = 7;

var SCRIPT_STATUSES = ['ready_to_review', 'installing', 'in_progress', 'follow_up', 'delivery'];

var DELIVERY_BUFFERS = {
  1: [3, 7],
  2: [null],
  3: [1],
  4: [3],
  5: [1],
  6: [1],
  7: [1]
};

var BASE_DELIVERY_LIMIT = 4;

var EMAIL_VALIDATION_REGEX = /^[-a-z0-9~!$%^&*_=+}{'?]+(\.[-a-z0-9~!$%^&*_=+}{'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i;

var MILLWORK_SURFACES = [10, 11, 12, 13];

/***/ }),

/***/ "K8d9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"LPATutorial__msignaturepad___3MiHQ","m-signature-pad--body":"LPATutorial__m-signature-pad--body___2tNWC","m-signature-pad--footer":"LPATutorial__m-signature-pad--footer___1c-6W","description":"LPATutorial__description___3ARv-","button":"LPATutorial__button___3f3Kg","clear":"LPATutorial__clear___bm7Tv","save":"LPATutorial__save___2LluP","m-signature-pad":"LPATutorial__m-signature-pad___1dRPs","github":"LPATutorial__github___3-UYr","joyrideBtn":"LPATutorial__joyrideBtn___2aG3s"};

/***/ }),

/***/ "KT9c":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "window_configuration-ba9135098b7b97e0f93744b7f9a40fda.png";

/***/ }),

/***/ "KWoV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___rDVe6","m-signature-pad--body":"styles__m-signature-pad--body___2a9C6","m-signature-pad--footer":"styles__m-signature-pad--footer___3LEVX","description":"styles__description___2IRgL","button":"styles__button___6ptCD","clear":"styles__clear___RdN17","save":"styles__save___3OF80","m-signature-pad":"styles__m-signature-pad___1tE78","github":"styles__github___3UAyP","label":"styles__label___35UAk","clearFix":"styles__clearFix___1QKdM","error":"styles__error___gDTJI","errorText":"styles__errorText___3WJQ8"};

/***/ }),

/***/ "KuO2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"phaseFilters__msignaturepad___2Njnt","m-signature-pad--body":"phaseFilters__m-signature-pad--body___3poBp","m-signature-pad--footer":"phaseFilters__m-signature-pad--footer___pkDvv","description":"phaseFilters__description___18fYi","button":"phaseFilters__button___36JZG","clear":"phaseFilters__clear___aTjBD","save":"phaseFilters__save___1qTMf","m-signature-pad":"phaseFilters__m-signature-pad___3PW5H","github":"phaseFilters__github___2UifH","selectWrapper":"phaseFilters__selectWrapper___3fU8u","filtersHelpLink":"phaseFilters__filtersHelpLink___2KgMG"};

/***/ }),

/***/ "L1+g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = requestEstimatorList;
/* harmony export (immutable) */ __webpack_exports__["h"] = setEstimatorFilters;
/* harmony export (immutable) */ __webpack_exports__["d"] = requestEstimator;
/* harmony export (immutable) */ __webpack_exports__["b"] = createEstimator;
/* harmony export (immutable) */ __webpack_exports__["i"] = updateEstimator;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getEstimatorsForZipCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addEventToEstimator; });
/* harmony export (immutable) */ __webpack_exports__["f"] = resetEstimatorFilters;
/* harmony export (immutable) */ __webpack_exports__["g"] = sendEstimatorEmail;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services__ = __webpack_require__("NvlE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers__ = __webpack_require__("RbI9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_schemas__ = __webpack_require__("oge5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_normalizr__ = __webpack_require__("rI7m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_normalizr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_normalizr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux__ = __webpack_require__("jZgO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actionCreators__ = __webpack_require__("uJNR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_qs__);









var _createActions = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])({
  ESTIMATOR_LIST_SUCCESS: function ESTIMATOR_LIST_SUCCESS(json) {
    return Object(__WEBPACK_IMPORTED_MODULE_4_normalizr__["normalize"])(json, { estimators: __WEBPACK_IMPORTED_MODULE_3_schemas__["a" /* default */].ESTIMATOR_ARRAY });
  }
}, 'ESTIMATOR_LIST_REQUEST', 'ESTIMATOR_LIST_FAILURE'),
    estimatorListRequest = _createActions.estimatorListRequest,
    estimatorListSuccess = _createActions.estimatorListSuccess,
    estimatorListFailure = _createActions.estimatorListFailure;

function requestEstimatorList() {
  return function (dispatch, getState) {
    var state = getState();
    var page = Object(__WEBPACK_IMPORTED_MODULE_2__reducers__["v" /* getEstimatorPage */])(state);
    var filterParams = __WEBPACK_IMPORTED_MODULE_7_qs___default.a.stringify(Object(__WEBPACK_IMPORTED_MODULE_2__reducers__["r" /* getEstimatorFilters */])(state));
    dispatch(estimatorListRequest());
    return Object(__WEBPACK_IMPORTED_MODULE_1__services__["h" /* request */])('estimators?page=' + page + '&' + filterParams).then(function (_ref) {
      var json = _ref.json;
      return dispatch(estimatorListSuccess(json));
    }).catch(function (error) {
      return dispatch(estimatorListFailure(error));
    });
  };
}

function setEstimatorFilters(filter) {
  return function (dispatch) {
    return Promise.all([dispatch({ type: 'ESTIMATOR_SET_FILTER', payload: filter }), dispatch({ type: 'ESTIMATOR_RESET_PAGINATION' }), dispatch(requestEstimatorList())]);
  };
}

var _createActions2 = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])({
  ESTIMATOR_RESOURCE_REQUEST: function ESTIMATOR_RESOURCE_REQUEST(id) {
    return { id: id };
  },
  ESTIMATOR_RESOURCE_SUCCESS: function ESTIMATOR_RESOURCE_SUCCESS(json) {
    return Object(__WEBPACK_IMPORTED_MODULE_4_normalizr__["normalize"])(json, __WEBPACK_IMPORTED_MODULE_3_schemas__["a" /* default */].ESTIMATOR);
  }
}, 'ESTIMATOR_RESOURCE_FAILURE'),
    estimatorResourceRequest = _createActions2.estimatorResourceRequest,
    estimatorResourceSuccess = _createActions2.estimatorResourceSuccess,
    estimatorResourceFailure = _createActions2.estimatorResourceFailure;

function requestEstimator(id) {
  return function (dispatch) {
    dispatch(estimatorResourceRequest(id));
    return Object(__WEBPACK_IMPORTED_MODULE_1__services__["h" /* request */])('estimators/' + id).then(function (_ref2) {
      var json = _ref2.json;
      return dispatch(estimatorResourceSuccess(json));
    }).catch(function (error) {
      return dispatch(estimatorResourceFailure(error));
    });
  };
}

var _createActions3 = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])({
  ESTIMATOR_RESOURCE_CREATE_SUCCESS: function ESTIMATOR_RESOURCE_CREATE_SUCCESS(json) {
    return Object(__WEBPACK_IMPORTED_MODULE_4_normalizr__["normalize"])(json, __WEBPACK_IMPORTED_MODULE_3_schemas__["a" /* default */].ESTIMATOR);
  }
}, 'ESTIMATOR_RESOURCE_CREATE_REQUEST', 'ESTIMATOR_RESOURCE_CREATE_FAILURE'),
    estimatorResourceCreateRequest = _createActions3.estimatorResourceCreateRequest,
    estimatorResourceCreateSuccess = _createActions3.estimatorResourceCreateSuccess,
    estimatorResourceCreateFailure = _createActions3.estimatorResourceCreateFailure;

function createEstimator(estimator) {
  return function (dispatch) {
    dispatch(estimatorResourceCreateRequest());
    return Object(__WEBPACK_IMPORTED_MODULE_1__services__["d" /* create */])('estimator', estimator).then(function (_ref3) {
      var json = _ref3.json;
      return Promise.all([dispatch(estimatorResourceCreateSuccess(json)), dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_react_router_redux__["push"])('/estimators'))]);
    }).catch(function (error) {
      return dispatch(estimatorResourceCreateFailure(error));
    });
  };
}

var _createActions4 = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])({
  ESTIMATOR_RESOURCE_UPDATE_SUCCESS: function ESTIMATOR_RESOURCE_UPDATE_SUCCESS(json) {
    return Object(__WEBPACK_IMPORTED_MODULE_4_normalizr__["normalize"])(json, __WEBPACK_IMPORTED_MODULE_3_schemas__["a" /* default */].ESTIMATOR);
  }
}, 'ESTIMATOR_RESOURCE_UPDATE_REQUEST', 'ESTIMATOR_RESOURCE_UPDATE_FAILURE'),
    estimatorResourceUpdateRequest = _createActions4.estimatorResourceUpdateRequest,
    estimatorResourceUpdateSuccess = _createActions4.estimatorResourceUpdateSuccess,
    estimatorResourceUpdateFailure = _createActions4.estimatorResourceUpdateFailure;

function updateEstimator(estimator) {
  return function (dispatch) {
    dispatch(estimatorResourceUpdateRequest(estimator));
    return Object(__WEBPACK_IMPORTED_MODULE_1__services__["k" /* update */])('estimator', estimator).then(function (_ref4) {
      var json = _ref4.json;
      return Promise.all([dispatch(estimatorResourceUpdateSuccess(json)), dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actionCreators__["P" /* navigateBack */])())]);
    }).catch(function (error) {
      return dispatch(estimatorResourceUpdateFailure(error));
    });
  };
}

var _createActions5 = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])('ESTIMATOR_RESOURCE_FOR_ZIP_CODE_REQUEST', 'ESTIMATOR_RESOURCE_FOR_ZIP_CODE_SUCCESS', 'ESTIMATOR_RESOURCE_FOR_ZIP_CODE_FAILURE'),
    estimatorResourceForZipCodeRequest = _createActions5.estimatorResourceForZipCodeRequest,
    estimatorResourceForZipCodeSuccess = _createActions5.estimatorResourceForZipCodeSuccess,
    estimatorResourceForZipCodeFailure = _createActions5.estimatorResourceForZipCodeFailure;

var getEstimatorsForZipCode = function getEstimatorsForZipCode(zipCode) {
  return function (dispatch) {
    dispatch(estimatorResourceForZipCodeRequest(zipCode));
    return Object(__WEBPACK_IMPORTED_MODULE_1__services__["h" /* request */])('estimators/for_zip_code/' + zipCode).then(function (_ref5) {
      var json = _ref5.json;
      return dispatch(estimatorResourceForZipCodeSuccess(json));
    }).catch(function (error) {
      return dispatch(estimatorResourceForZipCodeFailure(error));
    });
  };
};

var _createActions6 = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])({
  ADD_EVENT_TO_ESTIMATOR_SUCCESS: function ADD_EVENT_TO_ESTIMATOR_SUCCESS(json, estimatorId) {
    return { event: json.event, estimatorId: estimatorId };
  }
}, 'ADD_EVENT_TO_ESTIMATOR_FAILURE', 'ADD_EVENT_TO_ESTIMATOR_REQUEST'),
    addEventToEstimatorRequest = _createActions6.addEventToEstimatorRequest,
    addEventToEstimatorSuccess = _createActions6.addEventToEstimatorSuccess,
    addEventToEstimatorFailure = _createActions6.addEventToEstimatorFailure;

var addEventToEstimator = function addEventToEstimator(estimatorId, event) {
  return function (dispatch) {
    dispatch(addEventToEstimatorRequest(event));
    return Object(__WEBPACK_IMPORTED_MODULE_1__services__["h" /* request */])('estimators/' + estimatorId + '/events', { method: 'POST', body: event }).then(function (_ref6) {
      var json = _ref6.json;
      return dispatch(addEventToEstimatorSuccess(json, estimatorId));
    }).catch(function (errors) {
      return dispatch(addEventToEstimatorFailure(errors));
    });
  };
};

function resetEstimatorFilters() {
  return function (dispatch) {
    return Promise.all([dispatch({ type: 'ESTIMATOR_RESET_FILTERS' }), dispatch({ type: 'ESTIMATOR_RESET_PAGINATION' }), dispatch(requestEstimatorList())]);
  };
}

function sendEstimatorEmail(id, week) {
  var req = { method: 'POST', body: { week: week } };
  return Object(__WEBPACK_IMPORTED_MODULE_1__services__["h" /* request */])('estimators/' + id + '/send_email', req);
}

/***/ }),

/***/ "L2Hi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"employableHistoryFilters__msignaturepad___2C4hS","m-signature-pad--body":"employableHistoryFilters__m-signature-pad--body___7J8yN","m-signature-pad--footer":"employableHistoryFilters__m-signature-pad--footer___3y_kL","description":"employableHistoryFilters__description___vppsA","button":"employableHistoryFilters__button___1OhQx","clear":"employableHistoryFilters__clear___3HOIH","save":"employableHistoryFilters__save___3X2t5","m-signature-pad":"employableHistoryFilters__m-signature-pad___I1kAe","github":"employableHistoryFilters__github___2WGI-","employableHistorySortContainer":"employableHistoryFilters__employableHistorySortContainer___UgfJl","employableHistorySortDirection":"employableHistoryFilters__employableHistorySortDirection___3q8Am"};

/***/ }),

/***/ "LPKT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___HT36e","m-signature-pad--body":"styles__m-signature-pad--body___1_-ar","m-signature-pad--footer":"styles__m-signature-pad--footer___wc6Ry","description":"styles__description___2gXgL","button":"styles__button___NTguu","clear":"styles__clear___2_iso","save":"styles__save___3HWca","m-signature-pad":"styles__m-signature-pad___bES61","github":"styles__github___3iYL1","headerContainer":"styles__headerContainer___3njbi","title":"styles__title___Of7wJ","standardButton":"styles__standardButton___2kE_z","saveButton":"styles__saveButton___3rqyG","cancelButton":"styles__cancelButton___5njL5","card":"styles__card___2SQ_3","scriptContainer":"styles__scriptContainer___2d8U6","scriptFlexContainer":"styles__scriptFlexContainer___aOeJQ","scriptUserNote":"styles__scriptUserNote___ri-r8","scriptQuestion":"styles__scriptQuestion___KWf_F","scriptText":"styles__scriptText___3Dmp9","scriptError":"styles__scriptError___1l2Q5","scriptList":"styles__scriptList___3kqfk"};

/***/ }),

/***/ "Lu33":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"coloredButton__msignaturepad___3rLKu","m-signature-pad--body":"coloredButton__m-signature-pad--body___3mjN6","m-signature-pad--footer":"coloredButton__m-signature-pad--footer___1cqGj","description":"coloredButton__description___1PvUo","button":"coloredButton__button___kEI5U","clear":"coloredButton__clear___3XsRX","save":"coloredButton__save___3NBH6","m-signature-pad":"coloredButton__m-signature-pad___2tnJW","github":"coloredButton__github___1FWOS","green":"coloredButton__green___2gFqT","red":"coloredButton__red___23Mxk","blue":"coloredButton__blue___32Oso","yellow":"coloredButton__yellow___B8X-r","gray":"coloredButton__gray___-zcSM","darkGray":"coloredButton__darkGray___1LKAF"};

/***/ }),

/***/ "MPvU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"backToTop__msignaturepad___vN0d2","m-signature-pad--body":"backToTop__m-signature-pad--body___GYl8E","m-signature-pad--footer":"backToTop__m-signature-pad--footer___pHvNM","description":"backToTop__description___1jp7U","button":"backToTop__button___1aEZ_","clear":"backToTop__clear___1_T9n","save":"backToTop__save___2WcGz","m-signature-pad":"backToTop__m-signature-pad___3Gy4r","github":"backToTop__github___1c8mc","backToTop":"backToTop__backToTop___1Smks","fadeInDesktop":"backToTop__fadeInDesktop___1Z2cm","fadeInMobile":"backToTop__fadeInMobile___1o8F-","bttImage":"backToTop__bttImage___13onw","inactive":"backToTop__inactive___2nELd"};

/***/ }),

/***/ "MjB7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___3r0D-","m-signature-pad--body":"styles__m-signature-pad--body___3UvRf","m-signature-pad--footer":"styles__m-signature-pad--footer___1nxX1","description":"styles__description___i2Kio","button":"styles__button___YCaky","clear":"styles__clear___2Vm8f","save":"styles__save___3Pe-K","m-signature-pad":"styles__m-signature-pad___390Q_","github":"styles__github___3XCtS","breakLine":"styles__breakLine___2e-vq"};

/***/ }),

/***/ "N46Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return parseDateStrict; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return handleDateSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getLocalDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getMinLocalDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getSimpleLocalDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return isValidDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return isOverdue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formatTime; });
/* unused harmony export momentDiff */
/* unused harmony export momentDiffDuration */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getDuration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getDayCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getDaysStringFromDuration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getDisplayDateFromString; });
/* unused harmony export getTimeMoment */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getDisplayTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getEndTimeString; });
/* unused harmony export getYear */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getThanksgiving; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getChristmasEve; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getChristmasDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return sortApptsByDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return filterApptsByTodayOrLater; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__("FbQg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_config_constants__ = __webpack_require__("JKMY");




/**
 * Parses a date string strictly using moment.js and provided formats.
 * @param {string} value - The date string to parse.
 * @param {string|string[]} formats - The format(s) to use for parsing.
 * @returns {moment.Moment} A moment object representing the parsed date.
 */
var parseDateStrict = function parseDateStrict(value, formats) {
  return __WEBPACK_IMPORTED_MODULE_0_moment___default()(value, formats, true);
};

var handleDateSave = function handleDateSave(stringValue) {
  if (!stringValue) return stringValue;
  var date = __WEBPACK_IMPORTED_MODULE_0_moment___default()(stringValue, [__WEBPACK_IMPORTED_MODULE_2_config_constants__["_11" /* OTHER_DATE */], __WEBPACK_IMPORTED_MODULE_2_config_constants__["E" /* DISPLAY_DATE */]]).format(__WEBPACK_IMPORTED_MODULE_2_config_constants__["_19" /* RAILS_DATE */]);
  if (date === 'Invalid Date') return 'Invalid Date';
  return date;
};

var getMomentWithFormat = function getMomentWithFormat(utcDate, format) {
  return __WEBPACK_IMPORTED_MODULE_0_moment___default()(utcDate).local().format(format).toString();
};

var getLocalDate = function getLocalDate(utcDate) {
  return getMomentWithFormat(utcDate, 'dddd, MM/DD/YYYY, h:mm:ss a');
};

var getMinLocalDate = function getMinLocalDate(utcDate) {
  return getMomentWithFormat(utcDate, 'MM/DD/YYYY, h:mm a');
};

var getSimpleLocalDate = function getSimpleLocalDate(utcDate) {
  return getMomentWithFormat(utcDate, 'MM/DD/YYYY');
};

var isValidDate = function isValidDate(utcDate) {
  return __WEBPACK_IMPORTED_MODULE_0_moment___default()(utcDate, __WEBPACK_IMPORTED_MODULE_0_moment___default.a.ISO_8601, true).isValid();
};

var isOverdue = function isOverdue(date) {
  return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).isSameOrBefore(__WEBPACK_IMPORTED_MODULE_0_moment___default()().endOf('day'));
};

var formatTime = function formatTime(date) {
  return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date, 'HH:mm').format('hh:mma');
};

var momentDiff = function momentDiff(date1, date2) {
  var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'milliseconds';
  return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date1).diff(__WEBPACK_IMPORTED_MODULE_0_moment___default()(date2), unit);
};

var momentDiffDuration = function momentDiffDuration(date1, date2) {
  var units = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : { diff: 'milliseconds', duration: 'milliseconds' };
  return __WEBPACK_IMPORTED_MODULE_0_moment___default.a.duration(momentDiff(date1, date2, units.diff), units.duration);
};

var getDuration = function getDuration(_ref) {
  var status = _ref.status,
      created_at_default = _ref.created_at_default,
      status_began_at = _ref.status_began_at;
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { yes: false, val: '' };

  var duration = defaultValue.val;
  if (defaultValue.yes && (!created_at_default || !status_began_at)) return duration;
  if (Object(__WEBPACK_IMPORTED_MODULE_1____["C" /* validStatus */])(status, ['completed', 'canceled'])) duration = momentDiffDuration(status_began_at, created_at_default) || duration;else duration = momentDiffDuration(__WEBPACK_IMPORTED_MODULE_0_moment___default()(), created_at_default) || duration;
  return duration;
};

var getDayCount = function getDayCount(startDate, endDate) {
  return momentDiff(endDate, startDate, 'days') + 1;
};

var getDaysStringFromDuration = function getDaysStringFromDuration(duration) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if (!duration || !duration.isValid()) return defaultValue;
  var durationInDays = Math.round(duration.asDays()) || false;
  return durationInDays ? durationInDays + ' ' + (durationInDays === 1 ? 'day' : 'days') : defaultValue;
};

var getDisplayDateFromString = function getDisplayDateFromString(date, format) {
  return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date, format).format(__WEBPACK_IMPORTED_MODULE_2_config_constants__["E" /* DISPLAY_DATE */]);
};

var getTimeMoment = function getTimeMoment(time) {
  return __WEBPACK_IMPORTED_MODULE_0_moment___default()(time, __WEBPACK_IMPORTED_MODULE_2_config_constants__["_3" /* MOMENT_TIME */]);
};

var getDisplayTime = function getDisplayTime(time) {
  return getTimeMoment(time).format(__WEBPACK_IMPORTED_MODULE_2_config_constants__["G" /* DISPLAY_TIME */]);
};

var getEndTimeString = function getEndTimeString(startTime) {
  var isDelivery = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var endMoment = null;
  var startMoment = getTimeMoment(startTime);
  var noonMoment = getTimeMoment('13:00');
  var eodMoment = getTimeMoment('18:00');
  if (isDelivery) endMoment = startMoment.isBefore(noonMoment) ? noonMoment : eodMoment;else endMoment = startMoment.add(__WEBPACK_IMPORTED_MODULE_2_config_constants__["A" /* DEFAULT_ARRIVAL_WINDOW_HOURS */].default, 'h');
  return endMoment.format(__WEBPACK_IMPORTED_MODULE_2_config_constants__["_3" /* MOMENT_TIME */]);
};

var getYear = function getYear() {
  return __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YYYY');
};

var getThanksgiving = function getThanksgiving() {
  var result = __WEBPACK_IMPORTED_MODULE_0_moment___default()('11/01/' + getYear(), 'MM/DD/YYYY');
  var numThursdays = 0;
  while (numThursdays < 4) {
    var currDay = result.day();
    if (currDay === 4) numThursdays += 1;
    if (numThursdays < 4) result.add(1, 'day');
  }
  return result.format('MM/DD/YYYY');
};

var getChristmasEve = function getChristmasEve() {
  return __WEBPACK_IMPORTED_MODULE_0_moment___default()('12/24/' + getYear(), 'MM/DD/YYYY').format('MM/DD/YYYY');
};

var getChristmasDay = function getChristmasDay() {
  return __WEBPACK_IMPORTED_MODULE_0_moment___default()('12/25/' + getYear(), 'MM/DD/YYYY').format('MM/DD/YYYY');
};

var sortApptsByDate = function sortApptsByDate(appts) {
  var byEndDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return appts.sort(function (a, b) {
    return __WEBPACK_IMPORTED_MODULE_0_moment___default()(a[(byEndDate ? 'end' : 'start') + '_date'], 'YYYYMMDD').diff(__WEBPACK_IMPORTED_MODULE_0_moment___default()(b.start_date, 'YYYYMMDD'));
  });
};

var filterApptsByTodayOrLater = function filterApptsByTodayOrLater(appts) {
  var byEndDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return appts.filter(function (a) {
    return __WEBPACK_IMPORTED_MODULE_0_moment___default()(a[(byEndDate ? 'end' : 'start') + '_date'], 'YYYYMMDD').isSameOrAfter(__WEBPACK_IMPORTED_MODULE_0_moment___default()(new Date(), 'YYYYMMDD'));
  });
};

/***/ }),

/***/ "NAgv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"itemEvents__msignaturepad___2PEIP","m-signature-pad--body":"itemEvents__m-signature-pad--body___QJovU","m-signature-pad--footer":"itemEvents__m-signature-pad--footer___3eDc_","description":"itemEvents__description___2Wiu6","button":"itemEvents__button___2lEMA","clear":"itemEvents__clear___1an-r","save":"itemEvents__save___hUBqt","m-signature-pad":"itemEvents__m-signature-pad___6_gts","github":"itemEvents__github___3HHeh","container":"itemEvents__container___2z4NU","history_icon":"itemEvents__history_icon___1KoWj","dialog":"itemEvents__dialog___sbcKW","close_icon":"itemEvents__close_icon___2fg1T"};

/***/ }),

/***/ "NDtc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___28YM0","m-signature-pad--body":"styles__m-signature-pad--body___292-I","m-signature-pad--footer":"styles__m-signature-pad--footer___FmJfJ","description":"styles__description___xPm3W","button":"styles__button___3MEMj","clear":"styles__clear___3s9jp","save":"styles__save___3741_","m-signature-pad":"styles__m-signature-pad___2-Tj5","github":"styles__github___1YnoH","circular":"styles__circular___gsBGi","rotate":"styles__rotate___1P_Q2","path":"styles__path___1ekgi","dash":"styles__dash___M6o6a","color":"styles__color___2xVvS"};

/***/ }),

/***/ "Nhg6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"profileMenu__msignaturepad___3c984","m-signature-pad--body":"profileMenu__m-signature-pad--body___2O_Xw","m-signature-pad--footer":"profileMenu__m-signature-pad--footer___3V-BU","description":"profileMenu__description___m5zdO","button":"profileMenu__button___O65ob","clear":"profileMenu__clear___2n2UE","save":"profileMenu__save___2Of5e","m-signature-pad":"profileMenu__m-signature-pad___1QdG9","github":"profileMenu__github___G3t5y","neutral":"profileMenu__neutral___1eUCE","inverse":"profileMenu__inverse___2AAVU","flat":"profileMenu__flat___2-zce","wrapper":"profileMenu__wrapper___7c-gN","menu":"profileMenu__menu___1dWsG","listWrapper":"profileMenu__listWrapper___DyAQN","subMenuHorizontal":"profileMenu__subMenuHorizontal___2fFcV","disableSendEmailBtn":"profileMenu__disableSendEmailBtn___19hcZ"};

/***/ }),

/***/ "NldF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"assignedFilters__msignaturepad___cQom9","m-signature-pad--body":"assignedFilters__m-signature-pad--body___NS9IZ","m-signature-pad--footer":"assignedFilters__m-signature-pad--footer___mZyFO","description":"assignedFilters__description___WURVE","button":"assignedFilters__button___3D0fP","clear":"assignedFilters__clear___2RyQX","save":"assignedFilters__save___3wcrA","m-signature-pad":"assignedFilters__m-signature-pad___3eqh0","github":"assignedFilters__github___ujwOw","list":"assignedFilters__list___1kSgD","filter":"assignedFilters__filter___3dOlw","header":"assignedFilters__header___ZpFVh","name":"assignedFilters__name___3kWQq","count":"assignedFilters__count___1XI8_","overdue":"assignedFilters__overdue___3Cb9L","selected":"assignedFilters__selected___2ym9E"};

/***/ }),

/***/ "NvlE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./client/app/services/auth.js
var PREFIX = 'spot-ls-';
var AUTH_KEYS = ['token', 'lastRequestTime'];

function saveToLS(data) {
  Object.keys(data).forEach(function (key) {
    if (data[key]) {
      localStorage.setItem(PREFIX + key, data[key]); // Save only keys with a value
    }
  });
}

function deleteFromLS(keys) {
  keys.forEach(function (k) {
    localStorage.removeItem(PREFIX + k);
  });
}

function getQueryStringVar(key) {
  var query = window.location.search.substring(1);
  var vars = query.split('&');
  for (var i = 0; i < vars.length; i += 1) {
    var pair = vars[i].split('=');
    if (decodeURIComponent(pair[0]) === key) {
      return decodeURIComponent(pair[1]);
    }
  }
  return '';
}

function saveAuthToken(token) {
  saveToLS({ token: token });
}

function deleteAuthData() {
  deleteFromLS(AUTH_KEYS);
}

function getCurrentToken() {
  return localStorage.getItem(PREFIX + 'token');
}

function getTokenFromQueryString() {
  return getQueryStringVar('t');
}
// CONCATENATED MODULE: ./client/app/services/api.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var DEFAULT_HEADERS = {
  'Content-Type': 'application/json',
  Accept: 'application/json'
};

function errorWithResponse(response) {
  var json = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var error = new Error(response.statusText);
  if (json) {
    error.json = json;
    if (json.errors) {
      error.errors = json.errors;
    } else if (json.error) {
      error.errors = { messages: [json.error] };
    }
  }
  if (!error.errors) {
    error.errors = { messages: [response.statusText] };
  }
  if (response.status >= 500) {
    error.global = true;
  }
  error.response = response;
  return error;
}

function request(path) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : { auth: true, verbose: false, formData: false };

  var newOptions = options;
  var urlPath = path.startsWith('/') ? path : '/api/' + path;

  if (!config.formData) {
    newOptions.headers = Object.assign({}, DEFAULT_HEADERS, newOptions.headers);
  } else {
    newOptions.headers = {};
  }

  if (config.auth) {
    var token = getTokenFromQueryString() || getCurrentToken();
    Object.assign(newOptions.headers, { Authorization: 'Bearer ' + token });
  }
  if (newOptions.headers['Content-Type'] === 'application/json' && newOptions.body && _typeof(newOptions.body) === 'object') {
    newOptions.body = JSON.stringify(newOptions.body);
  }
  if (config.verbose) {
    console.info('Request to ', // eslint-disable-line no-console
    urlPath, ' with options ', JSON.stringify(newOptions, null, '\t'));
  }

  return fetch(urlPath, newOptions).catch(function (e) {
    var error = new Error(e);
    error.global = true;
    error.errors = { messages: ['Could not connect to SPOT, please check your internet connection'] };
    error.response = null;
    throw error;
  }).then(function (response) {
    return response.json().catch(function () {
      throw errorWithResponse(response);
    }).then(function (json) {
      if (!response.ok) {
        throw errorWithResponse(response, json);
      }
      return { response: response, json: json };
    });
  });
}

function requestNoAuthentication(url, options, config) {
  var cf = Object.assign({}, config, { auth: false });
  return request(url, options, cf);
}

function update(entity, data, theEntity) {
  // this doesn't let proper updates for nested entities urls
  return request(entity + 's/' + data.id, {
    method: 'PUT',
    body: _defineProperty({}, theEntity || entity, data)
  });
}

function create(entity, data, extra) {
  return request(entity + 's/', {
    method: 'POST',
    body: _extends(_defineProperty({}, entity, data), extra)
  });
}

function upload(formData, entity) {
  return request(entity + '/', {
    method: 'POST',
    body: formData
  }, {
    formData: true,
    auth: true
  });
}
// EXTERNAL MODULE: ./client/app/services/ability.js
var ability = __webpack_require__("CqOy");

// CONCATENATED MODULE: ./client/app/services/mapper.js


var mapper_getMapMatrix = function getMapMatrix(_ref) {
  var originId = _ref.originId,
      destinationId = _ref.destinationId,
      type = _ref.type;
  return request('maps?origin_id=' + originId + '&destination_id=' + destinationId + '&type=' + type).then(function (_ref2) {
    var json = _ref2.json;
    return json;
  }).catch(function (error) {
    return error;
  });
};

var getDirections = function getDirections() {
  return { error: 'Not yet implemented' };
};
// CONCATENATED MODULE: ./client/app/services/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "j", function() { return saveAuthToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "e", function() { return deleteAuthData; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "f", function() { return getCurrentToken; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getTokenFromQueryString; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "h", function() { return request; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "i", function() { return requestNoAuthentication; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "k", function() { return update; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return create; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "l", function() { return upload; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return ability["a" /* can */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return ability["b" /* canAccessCustomLaborSheet */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return ability["c" /* canAccessIfiTemplate */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "g", function() { return mapper_getMapMatrix; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getDirections; });





/***/ }),

/***/ "NwYq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"snackbar__msignaturepad___jOU9E","m-signature-pad--body":"snackbar__m-signature-pad--body___3N5H_","m-signature-pad--footer":"snackbar__m-signature-pad--footer___3B3qP","description":"snackbar__description___5daR_","button":"snackbar__button___31IKB","clear":"snackbar__clear___2DWLH","save":"snackbar__save___1B3ej","m-signature-pad":"snackbar__m-signature-pad___13p7z","github":"snackbar__github___13886","label":"snackbar__label___2zRzh","warning":"snackbar__warning___2qiHT","accept":"snackbar__accept___2gaa8"};

/***/ }),

/***/ "OywE":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bronze-medal-0c55d71190e9aff715061d9f266859da.png";

/***/ }),

/***/ "PMQ5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["i"] = requestPhaseItems;
/* harmony export (immutable) */ __webpack_exports__["j"] = requestPhaseLevelerItems;
/* harmony export (immutable) */ __webpack_exports__["f"] = loadPhaseItems;
/* harmony export (immutable) */ __webpack_exports__["d"] = createPhaseItem;
/* unused harmony export createPhaseLevelerItem */
/* unused harmony export updatePhaseLevelerItem */
/* unused harmony export updatePhaseItem */
/* harmony export (immutable) */ __webpack_exports__["k"] = savePhaseItem;
/* harmony export (immutable) */ __webpack_exports__["l"] = savePhaseLevelerItem;
/* harmony export (immutable) */ __webpack_exports__["g"] = mergePurchaseOrderToOriginal;
/* harmony export (immutable) */ __webpack_exports__["e"] = deletePhaseItem;
/* harmony export (immutable) */ __webpack_exports__["h"] = requestPhaseItemEventList;
/* harmony export (immutable) */ __webpack_exports__["b"] = copyLaborItemsToLaborSheet;
/* harmony export (immutable) */ __webpack_exports__["a"] = approveLaborSheet;
/* harmony export (immutable) */ __webpack_exports__["c"] = createExceptionItem;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services__ = __webpack_require__("NvlE");




var getKeyFromType = function getKeyFromType(type) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["trimEnd"])(Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["snakeCase"])(type), 's');
};

var getRequestBody = function getRequestBody(type, lineItem) {
  var body = {};
  var key = getKeyFromType(type);
  body[key] = lineItem;
  return body;
};

var _createActions = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])({
  REQUEST_PHASE_ITEMS_SUCCESS: [function (lineItems, phaseID, type) {
    return { line_items: lineItems, phaseID: phaseID, type: type };
  }, function (newLineItem, phaseID, type, json) {
    return json.meta || {};
  }]
}, 'REQUEST_PHASE_ITEMS_REQUEST', 'REQUEST_PHASE_ITEMS_FAILURE'),
    requestPhaseItemsRequest = _createActions.requestPhaseItemsRequest,
    requestPhaseItemsSuccess = _createActions.requestPhaseItemsSuccess,
    requestPhaseItemsFailure = _createActions.requestPhaseItemsFailure;

function requestPhaseItems(phaseId, type) {
  var key = getKeyFromType(type) + 's';
  return function (dispatch) {
    dispatch(requestPhaseItemsRequest());
    return Object(__WEBPACK_IMPORTED_MODULE_2__services__["h" /* request */])('phases/' + phaseId + '/' + key).then(function (_ref) {
      var json = _ref.json;

      if (key === 'contractor_line_items') {
        key = 'labor_sheets';
        dispatch(requestPhaseItemsSuccess(json['' + key], phaseId, 'laborSheets', json));
      }
      dispatch(requestPhaseItemsSuccess(json['' + key], phaseId, type, json));
    }).catch(function (error) {
      return dispatch(requestPhaseItemsFailure(error));
    });
  };
}

var _createActions2 = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])({
  REQUEST_PHASE_LEVELER_ITEMS_SUCCESS: [function (levelers, phaseID, type) {
    return { levelers: levelers, phaseID: phaseID, type: type };
  }, function (newLevelerItem, phaseID, type, json) {
    return json.meta || {};
  }]
}, 'REQUEST_PHASE_LEVELER_ITEMS_REQUEST', 'REQUEST_PHASE_LEVELER_ITEMS_FAILURE'),
    requestPhaseLevelerItemsFailure = _createActions2.requestPhaseLevelerItemsFailure,
    requestPhaseLevelerItemsRequest = _createActions2.requestPhaseLevelerItemsRequest,
    requestPhaseLevelerItemsSuccess = _createActions2.requestPhaseLevelerItemsSuccess;

function requestPhaseLevelerItems(phaseId, type) {
  var key = getKeyFromType(type) + 's';
  return function (dispatch) {
    dispatch(requestPhaseLevelerItemsRequest());
    return Object(__WEBPACK_IMPORTED_MODULE_2__services__["h" /* request */])('phases/' + phaseId + '/' + key).then(function (_ref2) {
      var json = _ref2.json;

      dispatch(requestPhaseLevelerItemsSuccess(json['' + key], phaseId, type, json));
    }).catch(function (error) {
      return dispatch(requestPhaseLevelerItemsFailure(error));
    });
  };
}

function loadPhaseItems(items, phaseId, type) {
  return function (dispatch) {
    dispatch(requestPhaseItemsSuccess(items, phaseId, type, {}));
  };
}

var _createActions3 = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])({
  CREATE_PHASE_ITEMS_SUCCESS: [function (newLineItem, phaseID, type) {
    return { line_item: newLineItem, phaseID: phaseID, type: type };
  }, function (newLineItem, phaseID, type, json) {
    return json.meta || {};
  }],
  CREATE_PHASE_ITEMS_FAILURE: function CREATE_PHASE_ITEMS_FAILURE(json) {
    return {
      errors: json.error,
      line_item: json.lineItem,
      type: json.type
    };
  }
}, 'CREATE_PHASE_ITEMS_REQUEST'),
    createPhaseItemsRequest = _createActions3.createPhaseItemsRequest,
    createPhaseItemsSuccess = _createActions3.createPhaseItemsSuccess,
    createPhaseItemsFailure = _createActions3.createPhaseItemsFailure;

function createPhaseItem(phaseId, lineItem, type) {
  return function (dispatch) {
    var key = getKeyFromType(type);
    dispatch(createPhaseItemsRequest());
    return Object(__WEBPACK_IMPORTED_MODULE_2__services__["h" /* request */])('phases/' + phaseId + '/' + key + 's', { method: 'POST', body: getRequestBody(type, lineItem) }).then(function (_ref3) {
      var json = _ref3.json;
      return dispatch(createPhaseItemsSuccess(json[key], phaseId, type, json));
    }).catch(function (error) {
      return dispatch(createPhaseItemsFailure({ error: error, lineItem: lineItem, type: type }));
    });
  };
}

var _createActions4 = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])({
  CREATE_PHASE_LEVELER_ITEMS_SUCCESS: [function (levelers, phaseID, type) {
    return { levelers: levelers, phaseID: phaseID, type: type };
  }, function (newLineItem, phaseID, type, json) {
    return json.meta || {};
  }],
  CREATE_PHASE_LEVELER__ITEMS_FAILURE: function CREATE_PHASE_LEVELER__ITEMS_FAILURE(json) {
    return {
      errors: json.error,
      line_item: json.lineItem,
      type: json.type
    };
  }
}, 'CREATE_PHASE_LEVELER_ITEMS_REQUEST'),
    createPhaseLevelerItemsRequest = _createActions4.createPhaseLevelerItemsRequest,
    createPhaseLevelerItemsSuccess = _createActions4.createPhaseLevelerItemsSuccess,
    createPhaseLevelerItemsFailure = _createActions4.createPhaseLevelerItemsFailure;

function createPhaseLevelerItem(phaseId, item, type) {
  var bag_size = item.bag_size,
      quantity = item.quantity;

  var newItem = { bag_size: bag_size, quantity: quantity };
  return function (dispatch) {
    var key = getKeyFromType(type);
    dispatch(createPhaseLevelerItemsRequest());
    return Object(__WEBPACK_IMPORTED_MODULE_2__services__["h" /* request */])('phases/' + phaseId + '/' + key + 's', { method: 'POST', body: getRequestBody(type, newItem) }).then(function (_ref4) {
      var json = _ref4.json;
      return dispatch(createPhaseLevelerItemsSuccess(json[key], phaseId, type, json));
    }).catch(function (error) {
      return dispatch(createPhaseLevelerItemsFailure({ error: error, newItem: newItem, type: type }));
    });
  };
}

var _createActions5 = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])({
  UPDATE_PHASE_LEVELER_ITEMS_SUCCESS: [function (levelers, phaseID, type) {
    return { levelers: levelers, phaseID: phaseID, type: type };
  }, function (newLevelerItem, phaseID, type, json) {
    return json.meta || {};
  }],
  UPDATE_PHASE_LEVELER_ITEMS_FAILURE: function UPDATE_PHASE_LEVELER_ITEMS_FAILURE(json) {
    return {
      errors: json.errors,
      levelers: json.levelers,
      type: json.type
    };
  }
}, 'UPDATE_PHASE_LEVELER_ITEMS_REQUEST'),
    updatePhaseLevelerItemsSuccess = _createActions5.updatePhaseLevelerItemsSuccess,
    updatePhaseLevelerItemsRequest = _createActions5.updatePhaseLevelerItemsRequest,
    updatePhaseLevelerItemsFailure = _createActions5.updatePhaseLevelerItemsFailure;

function updatePhaseLevelerItem(phaseId, item, type) {
  var key = getKeyFromType(type);
  return function (dispatch) {
    dispatch(updatePhaseLevelerItemsRequest());
    return Object(__WEBPACK_IMPORTED_MODULE_2__services__["h" /* request */])('phases/' + phaseId + '/' + key + 's/' + item.id, { method: 'PUT', body: getRequestBody(type, item) }).then(function (_ref5) {
      var json = _ref5.json;
      return dispatch(updatePhaseLevelerItemsSuccess(json[key], phaseId, type, json));
    }).catch(function (error) {
      return dispatch(updatePhaseLevelerItemsFailure({ error: error, item: item, type: type }));
    });
  };
}

var _createActions6 = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])({
  UPDATE_PHASE_ITEMS_SUCCESS: [function (updatedLineItem, phaseID, type) {
    return { line_item: updatedLineItem, phaseID: phaseID, type: type };
  }, function (updatedLineItem, phaseID, type, json) {
    return json.meta || {};
  }],
  UPDATE_PHASE_ITEMS_FAILURE: function UPDATE_PHASE_ITEMS_FAILURE(json) {
    return {
      errors: json.error,
      line_item: json.lineItem,
      type: json.type
    };
  }
}, 'UPDATE_PHASE_ITEMS_REQUEST'),
    updatePhaseItemsSuccess = _createActions6.updatePhaseItemsSuccess,
    updatePhaseItemsRequest = _createActions6.updatePhaseItemsRequest,
    updatePhaseItemsFailure = _createActions6.updatePhaseItemsFailure;

function updatePhaseItem(phaseId, lineItem, type) {
  var key = getKeyFromType(type);
  return function (dispatch) {
    dispatch(updatePhaseItemsRequest());
    return Object(__WEBPACK_IMPORTED_MODULE_2__services__["h" /* request */])('phases/' + phaseId + '/' + key + 's/' + lineItem.id, { method: 'PUT', body: getRequestBody(type, lineItem) }).then(function (_ref6) {
      var json = _ref6.json;
      return dispatch(updatePhaseItemsSuccess(json[key], phaseId, type, json));
    }).catch(function (error) {
      return dispatch(updatePhaseItemsFailure({ error: error, lineItem: lineItem, type: type }));
    });
  };
}

function savePhaseItem(phaseId, lineItem, type) {
  return function (dispatch) {
    if (lineItem.id > 0) {
      return dispatch(updatePhaseItem(phaseId, lineItem, type));
    }
    return dispatch(createPhaseItem(phaseId, lineItem, type));
  };
}

function savePhaseLevelerItem(phaseId, item, type) {
  return function (dispatch) {
    if (item.id > 0) {
      return dispatch(updatePhaseLevelerItem(phaseId, item, type));
    }
    return dispatch(createPhaseLevelerItem(phaseId, item, type));
  };
}

function mergePurchaseOrderToOriginal(phaseId, purchaseOrderId) {
  return function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__services__["h" /* request */])('phases/' + phaseId + '/purchase_orders/' + purchaseOrderId + '/merge_to_original', { method: 'POST' }).then(function () {
      return Promise.all([dispatch(requestPhaseItems(phaseId, 'purchaseOrders')), dispatch(requestPhaseItems(phaseId, 'phaseLineItems'))]);
    });
  };
}

var _createActions7 = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])({
  DELETE_PHASE_ITEMS_SUCCESS: [function (lineItem, phaseID, type) {
    return { line_item: lineItem, phaseID: phaseID, type: type };
  }, function (lineItem, phaseID, type, json) {
    return json.meta || {};
  }]
}, 'DELETE_PHASE_ITEMS_REQUEST', 'DELETE_PHASE_ITEMS_FAILURE'),
    deletePhaseItemsRequest = _createActions7.deletePhaseItemsRequest,
    deletePhaseItemsSuccess = _createActions7.deletePhaseItemsSuccess,
    deletePhaseItemsFailure = _createActions7.deletePhaseItemsFailure;

function deletePhaseItem(phaseId, lineItem, type) {
  return function (dispatch) {
    dispatch(deletePhaseItemsRequest());

    return Object(__WEBPACK_IMPORTED_MODULE_2__services__["h" /* request */])('phases/' + phaseId + '/' + getKeyFromType(type) + 's/' + lineItem.id, { method: 'DELETE' }).then(function (_ref7) {
      var json = _ref7.json;
      return dispatch(deletePhaseItemsSuccess(lineItem, phaseId, type, json));
    }).catch(function (errors) {
      return dispatch(deletePhaseItemsFailure({ errors: errors, line_item: lineItem, type: type }));
    });
  };
}

var _createActions8 = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])('PHASE_ITEM_EVENTS_SUCCESS', 'PHASE_ITEM_EVENTS_REQUEST', 'PHASE_ITEM_EVENTS_FAILURE'),
    phaseItemEventsRequest = _createActions8.phaseItemEventsRequest,
    phaseItemEventsSuccess = _createActions8.phaseItemEventsSuccess,
    phaseItemEventsFailure = _createActions8.phaseItemEventsFailure;

function requestPhaseItemEventList(type, lineItem) {
  var key = getKeyFromType(type) + 's';
  return function (dispatch) {
    dispatch(phaseItemEventsRequest({ type: type }));
    return Object(__WEBPACK_IMPORTED_MODULE_2__services__["h" /* request */])(key + '/' + lineItem.id + '/events').then(function (_ref8) {
      var json = _ref8.json;
      return dispatch(phaseItemEventsSuccess({ line_item: lineItem, type: type, events: json.events }));
    }, function (error) {
      dispatch(phaseItemEventsFailure(error));
    });
  };
}

function copyLaborItemsToLaborSheet(phaseId, laborSheetId) {
  return function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__services__["h" /* request */])('phases/' + phaseId + '/labor_sheets/' + laborSheetId + '/copy_labor', { method: 'POST' }).then(function (_ref9) {
      var json = _ref9.json;

      dispatch(requestPhaseItemsSuccess(json.labor_sheets, phaseId, 'laborSheets', json));
      dispatch(requestPhaseItemsSuccess(json.labor_sheets, phaseId, 'contractorLineItems', json));
    }, function (error) {
      dispatch(phaseItemEventsFailure(error));
    });
  };
}

var _createActions9 = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])('APPROVE_LABOR_SHEET_SUCCESS', 'APPROVE_LABOR_SHEET_REQUEST', 'APPROVE_LABOR_SHEET_FAILURE'),
    approveLaborSheetRequest = _createActions9.approveLaborSheetRequest,
    approveLaborSheetSuccess = _createActions9.approveLaborSheetSuccess,
    approveLaborSheetFailure = _createActions9.approveLaborSheetFailure;

function approveLaborSheet(phaseId, laborSheetId, document) {
  return function (dispatch) {
    dispatch(approveLaborSheetRequest());
    return Object(__WEBPACK_IMPORTED_MODULE_2__services__["h" /* request */])('phases/' + phaseId + '/labor_sheets/' + laborSheetId + '/document', { method: 'POST', body: { document: document } }).then(function (_ref10) {
      var json = _ref10.json;

      dispatch(requestPhaseItemsSuccess(json.labor_sheets, phaseId, 'laborSheets', json));
      dispatch(requestPhaseItemsSuccess(json.labor_sheets, phaseId, 'contractorLineItems', json));
      dispatch(approveLaborSheetSuccess(json, phaseId));
    }, function (error) {
      dispatch(approveLaborSheetFailure(error));
    });
  };
}

var _createActions10 = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])({
  CREATE_EXCEPTION_SUCCESS: function CREATE_EXCEPTION_SUCCESS(json) {
    return json;
  },
  CREATE_EXCEPTION_FAILURE: function CREATE_EXCEPTION_FAILURE(json) {
    return {
      errors: json.error,
      po: json.po,
      line_items: json.line_items,
      type: 'exception'
    };
  }
}, 'CREATE_EXCEPTION_REQUEST'),
    createExceptionRequest = _createActions10.createExceptionRequest,
    createExceptionSuccess = _createActions10.createExceptionSuccess,
    createExceptionFailure = _createActions10.createExceptionFailure;

function createExceptionItem(exceptionData) {
  var type = 'exception';
  return function (dispatch) {
    dispatch(createExceptionRequest());
    return Object(__WEBPACK_IMPORTED_MODULE_2__services__["d" /* create */])('exception', exceptionData).then(function (_ref11) {
      var json = _ref11.json;
      return dispatch(createExceptionSuccess(json));
    }).catch(function (error) {
      return dispatch(createExceptionFailure({ error: error, exceptionData: exceptionData, type: type }));
    });
  };
}

/***/ }),

/***/ "PQWF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"releaseMerchandise__msignaturepad___Mm3-7","m-signature-pad--body":"releaseMerchandise__m-signature-pad--body___2Tq1R","m-signature-pad--footer":"releaseMerchandise__m-signature-pad--footer___37-w4","description":"releaseMerchandise__description___3qAH_","button":"releaseMerchandise__button___3tmOq","clear":"releaseMerchandise__clear___-eYdq","save":"releaseMerchandise__save___2STiz","m-signature-pad":"releaseMerchandise__m-signature-pad___2YVvG","github":"releaseMerchandise__github___3CTlc","release":"releaseMerchandise__release___149ae","container":"releaseMerchandise__container___2JIZ3"};

/***/ }),

/***/ "PVeh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"itemNote__msignaturepad___3Zefl","m-signature-pad--body":"itemNote__m-signature-pad--body___A3_PS","m-signature-pad--footer":"itemNote__m-signature-pad--footer___H7LTS","description":"itemNote__description___2ztBX","button":"itemNote__button___tE8g_","clear":"itemNote__clear___25s7u","save":"itemNote__save___3bfaX","m-signature-pad":"itemNote__m-signature-pad___10yv0","github":"itemNote__github___3io99","container":"itemNote__container___1xwgz","note_icon":"itemNote__note_icon___1YH_1","no_content":"itemNote__no_content___2X9uU","close_icon":"itemNote__close_icon___QAB19","textarea":"itemNote__textarea___3pgrj","text":"itemNote__text___3FXeb","tooltipText":"itemNote__tooltipText___3KK55","error":"itemNote__error___18P1Y"};

/***/ }),

/***/ "PgQY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"CTIStyles__msignaturepad___1HEu0","m-signature-pad--body":"CTIStyles__m-signature-pad--body___2bFTT","m-signature-pad--footer":"CTIStyles__m-signature-pad--footer___2XaEP","description":"CTIStyles__description___1palt","button":"CTIStyles__button___2blk3","clear":"CTIStyles__clear___3o-n7","save":"CTIStyles__save___1Sq83","m-signature-pad":"CTIStyles__m-signature-pad___wAY8A","github":"CTIStyles__github___3i6U2","contentContainer":"CTIStyles__contentContainer___2N-Lg","zipsContainer":"CTIStyles__zipsContainer___1NakY","additionalZipsContainer":"CTIStyles__additionalZipsContainer___2TuXH","additionalZipsHeaderAndRemoveAll":"CTIStyles__additionalZipsHeaderAndRemoveAll___2_s9s","additionalZipsHeader":"CTIStyles__additionalZipsHeader___3P9RC","removeAll":"CTIStyles__removeAll___1KgAy"};

/***/ }),

/***/ "Q6F6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___3MhrL","m-signature-pad--body":"styles__m-signature-pad--body___qLmwN","m-signature-pad--footer":"styles__m-signature-pad--footer___16VpU","description":"styles__description___3H_dx","button":"styles__button___3ClCv","clear":"styles__clear___vdHyW","save":"styles__save___3Al1e","m-signature-pad":"styles__m-signature-pad___1-tfH","github":"styles__github___3YY_0","container":"styles__container___x1gfN","isComposeOpen":"styles__isComposeOpen___8NGBE","primary":"styles__primary___1Yn8G","floating":"styles__floating___IJIwa","item":"styles__item___3rxOB"};

/***/ }),

/***/ "QFJO":
/***/ (function(module, exports) {



/***/ }),

/***/ "QGgP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"installerBasicInfoDetails__msignaturepad___TF4bF","m-signature-pad--body":"installerBasicInfoDetails__m-signature-pad--body___1bphs","m-signature-pad--footer":"installerBasicInfoDetails__m-signature-pad--footer___2u220","description":"installerBasicInfoDetails__description___2NXYq","button":"installerBasicInfoDetails__button___3NhVQ","clear":"installerBasicInfoDetails__clear___1nSEr","save":"installerBasicInfoDetails__save___2qgKR","m-signature-pad":"installerBasicInfoDetails__m-signature-pad___1pbbH","github":"installerBasicInfoDetails__github___1s83e","MinProjectPriceContainer":"installerBasicInfoDetails__MinProjectPriceContainer___2M7pJ","MinProjectPrice":"installerBasicInfoDetails__MinProjectPrice___qvaLt"};

/***/ }),

/***/ "QIbJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"form__msignaturepad___3x8vL","m-signature-pad--body":"form__m-signature-pad--body___2gNZA","m-signature-pad--footer":"form__m-signature-pad--footer___20oFs","description":"form__description___jYgxP","button":"form__button___2cvRO","clear":"form__clear___nk8ew","save":"form__save___16ioE","m-signature-pad":"form__m-signature-pad___12AYF","github":"form__github___tU9eq","divider":"form__divider___2BjYK","childDivider":"form__childDivider___1hYP8","headerDivider":"form__headerDivider___wIuph","cancelButton":"form__cancelButton___ErXBq","leftButton":"form__leftButton___2xJ-L","inputTitle":"form__inputTitle___45cr5","errorText":"form__errorText___WNi4X","formElementContainer":"form__formElementContainer___1rHWI","sidebarForm":"form__sidebarForm___32FjR","sidebarInput":"form__sidebarInput___qKTDe","sidebarButton":"form__sidebarButton___JCm3F","formLabel":"form__formLabel___3Jc5Z","checkboxListLabel":"form__checkboxListLabel___2Vq5_","checkboxList":"form__checkboxList___33F6j","checkboxItem":"form__checkboxItem___kjHzo","purchaseOrdercheckbox":"form__purchaseOrdercheckbox___38ksw","rightDown":"form__rightDown___BPQs6","cvCheckboxListItem":"form__cvCheckboxListItem___2jjKt","checkboxListItem":"form__checkboxListItem___3yK2b","headerChildren":"form__headerChildren___3cl9F","smallPadding":"form__smallPadding___FcGR7","actionButton":"form__actionButton___2n09K","addChildButton":"form__addChildButton___2TXr8","deleteChildButton":"form__deleteChildButton___lb1Gv","childTitle":"form__childTitle___11lhe","bottomTitle":"form__bottomTitle___-Ps82","inputs":"form__inputs___2NhyU","childCard":"form__childCard___ykiBs","childInputs":"form__childInputs___34sXB","mediumInput":"form__mediumInput___1Cv-e","smallInput":"form__smallInput___3qUXb","largeInput":"form__largeInput___1aZyI","fullScreenInput":"form__fullScreenInput___3z6qF","inputElement":"form__inputElement___3OklK","textArea":"form__textArea___1asX6","switchTitle":"form__switchTitle___2q8kx","switchTitleAdd":"form__switchTitleAdd___39Gor","title":"form__title___2AtiF","cardTitle":"form__cardTitle___1f61N","cardSubtitle":"form__cardSubtitle___1vNcs","actionsWrapper":"form__actionsWrapper___1c9AA","doNotDisplay":"form__doNotDisplay___2uW3x","label":"form__label___1XBdh","addCommWarning":"form__addCommWarning___2F2wP","inputActions":"form__inputActions___qXgay","errorLabel":"form__errorLabel___aWRti","errorMsg":"form__errorMsg___25TqH","bigTextArea":"form__bigTextArea___3i4st","inputArea":"form__inputArea___3f1R8","signature":"form__signature___1HyUz","row":"form__row___3JB1A","statusCheckboxRow":"form__statusCheckboxRow___2Sti5","successButton":"form__successButton___1Q0T8","specificSwitch":"form__specificSwitch___3IEHb","deliveryRadioBtns":"form__deliveryRadioBtns___2Bf5L","crewSpecsContainer":"form__crewSpecsContainer___24WCI","invalidFieldsMsg":"form__invalidFieldsMsg___3WQzm","weightsError":"form__weightsError___3ZmcV","prioritizationSection":"form__prioritizationSection___1dDzg","dialogOverflowVisible":"form__dialogOverflowVisible___3nWF4"};

/***/ }),

/***/ "QSmI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"filtersDrawer__msignaturepad___1Gab5","m-signature-pad--body":"filtersDrawer__m-signature-pad--body___15s9b","m-signature-pad--footer":"filtersDrawer__m-signature-pad--footer___1N4gb","description":"filtersDrawer__description___3g7NU","button":"filtersDrawer__button___1_Vqz","clear":"filtersDrawer__clear___3uPCu","save":"filtersDrawer__save___2AhPp","m-signature-pad":"filtersDrawer__m-signature-pad___3cRXc","github":"filtersDrawer__github___3JfLq","drawer":"filtersDrawer__drawer___2YIqN","overlay":"filtersDrawer__overlay___3XUtU","subheader":"filtersDrawer__subheader___MulUn","listItem":"filtersDrawer__listItem___2h2ox","field":"filtersDrawer__field___1hb0q","active":"filtersDrawer__active___1sgCq","backdrop":"filtersDrawer__backdrop___1Id4z","close_icon":"filtersDrawer__close_icon___2pf_j","filtersList":"filtersDrawer__filtersList___3w7Jy","header":"filtersDrawer__header___31qm5","resetFilterWrapper":"filtersDrawer__resetFilterWrapper___2hhfP"};

/***/ }),

/***/ "Qdpz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___COG2k","m-signature-pad--body":"styles__m-signature-pad--body___208Wg","m-signature-pad--footer":"styles__m-signature-pad--footer___3NDHk","description":"styles__description___FTtUq","button":"styles__button___1mjoa","clear":"styles__clear___6O0wV","save":"styles__save___2VWWz","m-signature-pad":"styles__m-signature-pad___q1GbI","github":"styles__github___3p24A","editBtn":"styles__editBtn___3v7rx","inputElement":"styles__inputElement___1-SRy","errorMsg":"styles__errorMsg___1lqGd","datepicker":"styles__datepicker___Lf0mh"};

/***/ }),

/***/ "Qt/D":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"iconButtonTheme__msignaturepad___2x4F5","m-signature-pad--body":"iconButtonTheme__m-signature-pad--body___2LxWt","m-signature-pad--footer":"iconButtonTheme__m-signature-pad--footer___3MWUa","description":"iconButtonTheme__description___25dt4","button":"iconButtonTheme__button___vzVlL","clear":"iconButtonTheme__clear___2asPm","save":"iconButtonTheme__save___3gS24","m-signature-pad":"iconButtonTheme__m-signature-pad___2VYgy","github":"iconButtonTheme__github___1jZ_2","icon":"iconButtonTheme__icon___SP7jB"};

/***/ }),

/***/ "R3fY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var employableEvents_namespaceObject = {};
__webpack_require__.d(employableEvents_namespaceObject, "update_profile", function() { return update_profile_update_profile; });
__webpack_require__.d(employableEvents_namespaceObject, "note", function() { return note_note; });
var tasks_namespaceObject = {};
__webpack_require__.d(tasks_namespaceObject, "ContactCustomerPhaseTask", function() { return contact_customer_ContactCustomerPhaseTask; });
__webpack_require__.d(tasks_namespaceObject, "contact_customer", function() { return contact_customer_contact_customer; });
__webpack_require__.d(tasks_namespaceObject, "InstallContactCustomerPhaseTask", function() { return install_contact_customer_InstallContactCustomerPhaseTask; });
__webpack_require__.d(tasks_namespaceObject, "install_contact_customer", function() { return install_contact_customer; });
__webpack_require__.d(tasks_namespaceObject, "workorder_contact_customer", function() { return install_contact_customer; });
__webpack_require__.d(tasks_namespaceObject, "phase_task", function() { return phase_task_phase_task; });
__webpack_require__.d(tasks_namespaceObject, "SchedulePhaseTask", function() { return SchedulePhaseTask; });
__webpack_require__.d(tasks_namespaceObject, "schedule_install", function() { return schedule_schedule; });
__webpack_require__.d(tasks_namespaceObject, "schedule_assessment", function() { return schedule_schedule; });
__webpack_require__.d(tasks_namespaceObject, "RescheduleInstall", function() { return reschedule_install_RescheduleInstall; });
__webpack_require__.d(tasks_namespaceObject, "reschedule_install", function() { return reschedule_install; });
__webpack_require__.d(tasks_namespaceObject, "SendToFloorWizardPhaseTask", function() { return SendToFloorWizardPhaseTask; });
__webpack_require__.d(tasks_namespaceObject, "send_to_floor_wizard", function() { return send_to_floor_wizard; });
__webpack_require__.d(tasks_namespaceObject, "SignLrrp", function() { return sign_lrrp_SignLrrp; });
__webpack_require__.d(tasks_namespaceObject, "sign_lrrp", function() { return sign_lrrp; });
__webpack_require__.d(tasks_namespaceObject, "UploadedToImsPhaseTask", function() { return UploadedToImsPhaseTask; });
__webpack_require__.d(tasks_namespaceObject, "review_send_to_store", function() { return uploadedToImsPhaseTask; });
__webpack_require__.d(tasks_namespaceObject, "refigure_send_to_store", function() { return uploadedToImsPhaseTask; });
__webpack_require__.d(tasks_namespaceObject, "VerifyContract", function() { return verify_contract_VerifyContract; });
__webpack_require__.d(tasks_namespaceObject, "verify_contract", function() { return verify_contract; });
__webpack_require__.d(tasks_namespaceObject, "GenericOneClick", function() { return GenericOneClick; });
__webpack_require__.d(tasks_namespaceObject, "start_contract_verification", function() { return generic_one_click; });
__webpack_require__.d(tasks_namespaceObject, "installer_paysheet_attached", function() { return generic_one_click; });
__webpack_require__.d(tasks_namespaceObject, "review_assessment", function() { return generic_one_click; });
__webpack_require__.d(tasks_namespaceObject, "refigure_assessment", function() { return generic_one_click; });
__webpack_require__.d(tasks_namespaceObject, "arrived_at_appointment", function() { return generic_one_click; });
__webpack_require__.d(tasks_namespaceObject, "measuring_en_route", function() { return generic_one_click; });
__webpack_require__.d(tasks_namespaceObject, "installing_en_route", function() { return generic_one_click; });
__webpack_require__.d(tasks_namespaceObject, "workorder_en_route", function() { return generic_one_click; });
__webpack_require__.d(tasks_namespaceObject, "workorder_arrived", function() { return generic_one_click; });
__webpack_require__.d(tasks_namespaceObject, "workorder_departed", function() { return generic_one_click; });
__webpack_require__.d(tasks_namespaceObject, "arrived", function() { return generic_one_click; });
__webpack_require__.d(tasks_namespaceObject, "install_send_to_scheduling", function() { return generic_one_click; });
__webpack_require__.d(tasks_namespaceObject, "workorder_send_to_scheduling", function() { return generic_one_click; });
__webpack_require__.d(tasks_namespaceObject, "assessment_send_to_scheduling", function() { return generic_one_click; });
__webpack_require__.d(tasks_namespaceObject, "check_into_store", function() { return generic_one_click; });
__webpack_require__.d(tasks_namespaceObject, "driver_dispatch", function() { return generic_one_click; });
__webpack_require__.d(tasks_namespaceObject, "driver_arrived", function() { return generic_one_click; });
__webpack_require__.d(tasks_namespaceObject, "CustomerReview", function() { return customer_review_CustomerReview; });
__webpack_require__.d(tasks_namespaceObject, "installation_customer_review", function() { return customer_review; });
__webpack_require__.d(tasks_namespaceObject, "workorder_customer_review", function() { return customer_review; });
__webpack_require__.d(tasks_namespaceObject, "InProgressCall", function() { return in_progress_call_InProgressCall; });
__webpack_require__.d(tasks_namespaceObject, "install_in_progress_call", function() { return in_progress_call; });
__webpack_require__.d(tasks_namespaceObject, "workorder_in_progress_call", function() { return in_progress_call; });
__webpack_require__.d(tasks_namespaceObject, "FollowUpCall", function() { return follow_up_call_FollowUpCall; });
__webpack_require__.d(tasks_namespaceObject, "follow_up_call", function() { return follow_up_call; });
__webpack_require__.d(tasks_namespaceObject, "FollowUpDeliveryCall", function() { return follow_up_delivery_call_FollowUpDeliveryCall; });
__webpack_require__.d(tasks_namespaceObject, "follow_up_delivery_call", function() { return follow_up_delivery_call; });
__webpack_require__.d(tasks_namespaceObject, "ContractVerificationChecklist", function() { return cv_checklist_ContractVerificationChecklist; });
__webpack_require__.d(tasks_namespaceObject, "cv_checklist", function() { return cv_checklist; });
__webpack_require__.d(tasks_namespaceObject, "SchedulingChecklist", function() { return scheduling_checklist_SchedulingChecklist; });
__webpack_require__.d(tasks_namespaceObject, "scheduling_checklist", function() { return scheduling_checklist; });
__webpack_require__.d(tasks_namespaceObject, "MaterialsRequested", function() { return materials_requested_MaterialsRequested; });
__webpack_require__.d(tasks_namespaceObject, "workorder_materials_requested", function() { return workorder_materials_requested; });
__webpack_require__.d(tasks_namespaceObject, "MaterialsOrdered", function() { return materials_ordered_MaterialsOrdered; });
__webpack_require__.d(tasks_namespaceObject, "workorder_materials_ordered", function() { return workorder_materials_ordered; });
__webpack_require__.d(tasks_namespaceObject, "Departed", function() { return departed_Departed; });
__webpack_require__.d(tasks_namespaceObject, "departed", function() { return departed; });
__webpack_require__.d(tasks_namespaceObject, "departed_from_appointment", function() { return departed_departed_from_appointment; });
__webpack_require__.d(tasks_namespaceObject, "install_complete", function() { return install_complete; });
__webpack_require__.d(tasks_namespaceObject, "SubmitDocuments", function() { return workorder_upload_docs_SubmitDocuments; });
__webpack_require__.d(tasks_namespaceObject, "workorder_upload_docs", function() { return workorder_upload_docs; });
__webpack_require__.d(tasks_namespaceObject, "Delivered", function() { return delivered_Delivered; });
__webpack_require__.d(tasks_namespaceObject, "delivered", function() { return delivered; });
__webpack_require__.d(tasks_namespaceObject, "CheckOutOFStore", function() { return check_out_of_store_CheckOutOFStore; });
__webpack_require__.d(tasks_namespaceObject, "check_out_of_store", function() { return check_out_of_store; });
__webpack_require__.d(tasks_namespaceObject, "LeadAssessment", function() { return lead_assessment_LeadAssessment; });
__webpack_require__.d(tasks_namespaceObject, "lead_assessment", function() { return lead_assessment; });
__webpack_require__.d(tasks_namespaceObject, "ReceivedEta", function() { return received_eta_ReceivedEta; });
__webpack_require__.d(tasks_namespaceObject, "received_eta", function() { return received_eta; });
__webpack_require__.d(tasks_namespaceObject, "BeforePhotos", function() { return before_photos_BeforePhotos; });
__webpack_require__.d(tasks_namespaceObject, "before_photos", function() { return before_photos; });
__webpack_require__.d(tasks_namespaceObject, "AfterPhotos", function() { return after_photos_AfterPhotos; });
__webpack_require__.d(tasks_namespaceObject, "after_photos", function() { return after_photos; });
var phaseEvents_namespaceObject = {};
__webpack_require__.d(phaseEvents_namespaceObject, "getStatusUsingWindow", function() { return phaseEvents_getStatusUsingWindow; });
__webpack_require__.d(phaseEvents_namespaceObject, "appointment_deleted", function() { return appointment_deleted_appointment_deleted; });
__webpack_require__.d(phaseEvents_namespaceObject, "appointment_rescheduled", function() { return appointment_rescheduled_appointment_rescheduled; });
__webpack_require__.d(phaseEvents_namespaceObject, "appointment_scheduled", function() { return appointment_scheduled_appointment_scheduled; });
__webpack_require__.d(phaseEvents_namespaceObject, "ready_to_measure", function() { return appointment_started_appointment_started; });
__webpack_require__.d(phaseEvents_namespaceObject, "start_install", function() { return appointment_started_appointment_started; });
__webpack_require__.d(phaseEvents_namespaceObject, "start_workorder", function() { return appointment_started_appointment_started; });
__webpack_require__.d(phaseEvents_namespaceObject, "appointment_updated", function() { return appointment_updated_appointment_updated; });
__webpack_require__.d(phaseEvents_namespaceObject, "assign_estimator", function() { return assign_estimator_assign_estimator; });
__webpack_require__.d(phaseEvents_namespaceObject, "assign_installer", function() { return assign_installer_assign_installer; });
__webpack_require__.d(phaseEvents_namespaceObject, "review_assessment", function() { return review_assessment; });
__webpack_require__.d(phaseEvents_namespaceObject, "materials_ready", function() { return materials_ready; });
__webpack_require__.d(phaseEvents_namespaceObject, "check_in_measurement", function() { return check_in_measurement_check_in_measurement; });
__webpack_require__.d(phaseEvents_namespaceObject, "checkin", function() { return checkin_checkin; });
__webpack_require__.d(phaseEvents_namespaceObject, "coc_signed", function() { return coc_signed_coc_signed; });
__webpack_require__.d(phaseEvents_namespaceObject, "communication", function() { return communication_communication; });
__webpack_require__.d(phaseEvents_namespaceObject, "complete_repair", function() { return complete_repair_complete_repair; });
__webpack_require__.d(phaseEvents_namespaceObject, "contact_customer", function() { return phaseEvents_contact_customer_contact_customer; });
__webpack_require__.d(phaseEvents_namespaceObject, "install_contact_customer", function() { return phaseEvents_contact_customer_contact_customer; });
__webpack_require__.d(phaseEvents_namespaceObject, "workorder_contact_customer", function() { return phaseEvents_contact_customer_contact_customer; });
__webpack_require__.d(phaseEvents_namespaceObject, "customer_survey_updated", function() { return customer_survey_updated_customer_survey_updated; });
__webpack_require__.d(phaseEvents_namespaceObject, "due_date_updated", function() { return due_date_updated_due_date_updated; });
__webpack_require__.d(phaseEvents_namespaceObject, "flag_added", function() { return flag_added_flag_note; });
__webpack_require__.d(phaseEvents_namespaceObject, "flag_removed", function() { return flag_added_flag_note; });
__webpack_require__.d(phaseEvents_namespaceObject, "floor_wizard", function() { return floor_wizard_floor_wizard; });
__webpack_require__.d(phaseEvents_namespaceObject, "laborsheet_approved", function() { return laborsheet_approved_laborsheet_approved; });
__webpack_require__.d(phaseEvents_namespaceObject, "lowes_invoiced", function() { return lowes_invoiced_lowes_invoiced; });
__webpack_require__.d(phaseEvents_namespaceObject, "note", function() { return phaseEvents_note_note; });
__webpack_require__.d(phaseEvents_namespaceObject, "override_status", function() { return override_status_override_status; });
__webpack_require__.d(phaseEvents_namespaceObject, "phase_canceled", function() { return phase_canceled_phase_canceled; });
__webpack_require__.d(phaseEvents_namespaceObject, "phase_completed", function() { return phase_completed_phase_completed; });
__webpack_require__.d(phaseEvents_namespaceObject, "phase_created", function() { return phase_created_phase_created; });
__webpack_require__.d(phaseEvents_namespaceObject, "refigure_request", function() { return refigure_request_refigure_request; });
__webpack_require__.d(phaseEvents_namespaceObject, "rocky", function() { return rocky_rocky; });
__webpack_require__.d(phaseEvents_namespaceObject, "select_assessment", function() { return select_assessment_select_assessment; });
__webpack_require__.d(phaseEvents_namespaceObject, "review_send_to_store", function() { return send_to_store_SendToStore; });
__webpack_require__.d(phaseEvents_namespaceObject, "refigure_send_to_store", function() { return send_to_store_SendToStore; });
__webpack_require__.d(phaseEvents_namespaceObject, "communication_sent", function() { return communication_sent_communication_sent; });
__webpack_require__.d(phaseEvents_namespaceObject, "communication_error", function() { return communication_error_communication_error; });
__webpack_require__.d(phaseEvents_namespaceObject, "communication_received", function() { return communication_received_communication_received; });
__webpack_require__.d(phaseEvents_namespaceObject, "force_to_scheduling", function() { return force_to_scheduling_force_to_scheduling; });
__webpack_require__.d(phaseEvents_namespaceObject, "departed_from_appointment", function() { return departed_from_appointment_departed_from_appointment; });
__webpack_require__.d(phaseEvents_namespaceObject, "customer_callback_migration", function() { return customer_callback_migration_customer_callback_migration; });

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("GiK3");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__("KSGD");
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/react-router/es/index.js + 32 modules
var es = __webpack_require__("CIox");

// EXTERNAL MODULE: ./node_modules/react-helmet/lib/Helmet.js
var Helmet = __webpack_require__("PIAa");
var Helmet_default = /*#__PURE__*/__webpack_require__.n(Helmet);

// EXTERNAL MODULE: ./node_modules/react-router-scroll/lib/index.js
var lib = __webpack_require__("Pt99");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/redux-auth-wrapper/history3/redirect.js
var redirect = __webpack_require__("Ipx/");
var redirect_default = /*#__PURE__*/__webpack_require__.n(redirect);

// EXTERNAL MODULE: ./node_modules/redux-auth-wrapper/connectedAuthWrapper.js
var connectedAuthWrapper = __webpack_require__("iBne");
var connectedAuthWrapper_default = /*#__PURE__*/__webpack_require__.n(connectedAuthWrapper);

// EXTERNAL MODULE: ./node_modules/react-router-redux/lib/index.js
var react_router_redux_lib = __webpack_require__("jZgO");
var react_router_redux_lib_default = /*#__PURE__*/__webpack_require__.n(react_router_redux_lib);

// EXTERNAL MODULE: ./client/app/reducers/user.js
var reducers_user = __webpack_require__("33h8");

// EXTERNAL MODULE: ./client/app/services/index.js + 3 modules
var services = __webpack_require__("NvlE");

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("M4fF");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./client/app/shared/config/constants.js
var constants = __webpack_require__("JKMY");

// CONCATENATED MODULE: ./client/app/shared/components/Auth/index.jsx
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };









var userIsAuthenticated = Object(redirect["connectedReduxRedirect"])({ // eslint-disable-line new-cap
  authenticatedSelector: function authenticatedSelector(state) {
    return state.user.isAuthenticated;
  },
  authenticatingSelector: function authenticatingSelector(state) {
    return state.user.isAuthenticating;
  },
  redirectAction: react_router_redux_lib["routerActions"].replace,
  redirectPath: '/login',
  wrapperDisplayName: 'UserIsAuthenticated'
});

var Auth_adminRedirect = function adminRedirect(newLocation) {
  return function (dispatch, getState) {
    dispatch(react_router_redux_lib["routerActions"].replace(Object(reducers_user["g" /* isAdmin */])(getState().user) ? '/login' : newLocation));
  };
};

// redirect to newLocation minus the query string, expanding relative
// paths if they exist
var Auth_unauthorizedRedirect = function unauthorizedRedirect(newLocation) {
  return function (dispatch, getState) {
    var location = newLocation;
    if (newLocation.pathname.indexOf('/') !== 0) {
      var _getState = getState(),
          pathname = _getState.routing.locationBeforeTransitions.pathname;

      var newPath = pathname;
      var lastIndex = pathname.lastIndexOf('/');
      if (lastIndex > 0) {
        newPath = pathname.substring(0, lastIndex);
      }
      newPath += '/' + newLocation.pathname;
      location = _extends({}, location, { pathname: newPath });
    }
    dispatch(react_router_redux_lib["routerActions"].replace(Object(lodash["omit"])(location, 'query')));
  };
};

var userIsAdmin = Object(redirect["connectedReduxRedirect"])({ // eslint-disable-line new-cap
  authenticatedSelector: function authenticatedSelector(state) {
    return Object(reducers_user["g" /* isAdmin */])(state.user);
  },
  authenticatingSelector: function authenticatingSelector(state) {
    return state.user.isAuthenticating;
  },
  redirectAction: Auth_adminRedirect,
  redirectPath: '/no-access',
  wrapperDisplayName: 'UserIsAdmin'
});

var Auth_whichCan = function whichCan(action, model, user) {
  var _user$role = user.role,
      role = _user$role === undefined ? '' : _user$role,
      _user$position = user.position,
      position = _user$position === undefined ? '' : _user$position;

  var attrs = null;
  if (model === 'bulk_projects_load') attrs = { position: position };
  return attrs ? Object(services["a" /* can */])(role, action, model, attrs) : Object(services["a" /* can */])(role, action, model);
};

var Auth_userCan = function userCan(action, model, component) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return Object(redirect["connectedReduxRedirect"])(_extends({
    authenticatedSelector: function authenticatedSelector(state) {
      return Auth_whichCan(action, model, state.user || {});
    },
    authenticatingSelector: function authenticatingSelector(state) {
      return state.user.isAuthenticating;
    },
    redirectAction: Auth_unauthorizedRedirect,
    redirectPath: '/no-access',
    wrapperDisplayName: 'UserCan'
  }, options))(component);
};

var Auth_userAllowedOnDashboard = function userAllowedOnDashboard(_ref) {
  var user = _ref.user;

  var position = user.position;
  var userName = user.name;
  if (constants["e" /* ALLOWED_DASHBOARD_POSITIONS */].includes(position) || constants["d" /* ALLOWED_DASHBOARD_NAMES */].includes(userName)) return true;
  return false;
};

var Auth_userCanViewDashboard = function userCanViewDashboard(component) {
  return Object(redirect["connectedReduxRedirect"])({
    authenticatedSelector: function authenticatedSelector(state) {
      return Auth_userAllowedOnDashboard(state);
    },
    authenticatingSelector: function authenticatingSelector(state) {
      return state.user.isAuthenticating;
    },
    redirectAction: Auth_unauthorizedRedirect,
    redirectPath: '/no-access',
    wrapperDisplayName: 'UserCan'
  })(component);
};

var Auth_visibleFor = function visibleFor(action, model, component) {
  return connectedAuthWrapper_default()({
    authenticatedSelector: function authenticatedSelector(state) {
      return Object(services["a" /* can */])(state.user.role, action, model);
    },
    wrapperDisplayName: 'visibleFor'
  })(component);
};


/* harmony default export */ var Auth = (userIsAuthenticated);
// EXTERNAL MODULE: ./node_modules/react-css-themr/lib/index.js
var react_css_themr_lib = __webpack_require__("b0Dh");
var react_css_themr_lib_default = /*#__PURE__*/__webpack_require__.n(react_css_themr_lib);

// EXTERNAL MODULE: ./node_modules/react-toolbox/lib/index.js
var react_toolbox_lib = __webpack_require__("iXbh");
var react_toolbox_lib_default = /*#__PURE__*/__webpack_require__.n(react_toolbox_lib);

// EXTERNAL MODULE: ./client/app/shared/components/Unauthorized/card.scss
var Unauthorized_card = __webpack_require__("T3qJ");
var card_default = /*#__PURE__*/__webpack_require__.n(Unauthorized_card);

// CONCATENATED MODULE: ./client/app/shared/components/Unauthorized/index.jsx






var Unauthorized_theme = {
  RTCard: card_default.a
};

var Unauthorized_Unauthorized = function Unauthorized(_ref) {
  var restrictedItem = _ref.restrictedItem,
      additionalMessage = _ref.additionalMessage;
  return react_default.a.createElement(
    react_css_themr_lib["ThemeProvider"],
    { theme: Unauthorized_theme },
    react_default.a.createElement(
      react_toolbox_lib["Card"],
      null,
      react_default.a.createElement(
        react_toolbox_lib["CardText"],
        null,
        react_default.a.createElement(
          'p',
          null,
          'You are not authorized to access this ',
          restrictedItem || 'page',
          '.'
        ),
        additionalMessage && react_default.a.createElement(
          'p',
          null,
          additionalMessage,
          '.'
        )
      )
    )
  );
};

Unauthorized_Unauthorized.defaultProps = {
  restrictedItem: '',
  additionalMessage: ''
};

Unauthorized_Unauthorized.propTypes = {
  restrictedItem: prop_types_default.a.string,
  additionalMessage: prop_types_default.a.string
};

/* harmony default export */ var components_Unauthorized = (Unauthorized_Unauthorized);
// EXTERNAL MODULE: ./node_modules/normalize.css/normalize.css
var normalize = __webpack_require__("uMhA");
var normalize_default = /*#__PURE__*/__webpack_require__.n(normalize);

// EXTERNAL MODULE: ./client/app/shared/styles/global.scss
var global = __webpack_require__("jNK8");
var global_default = /*#__PURE__*/__webpack_require__.n(global);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 14 modules
var react_redux_es = __webpack_require__("RH2O");

// EXTERNAL MODULE: ./node_modules/react-toast-notifications/dist/index.js
var dist = __webpack_require__("r5C7");
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// EXTERNAL MODULE: ./client/app/shared/actionCreators/index.js + 27 modules
var actionCreators = __webpack_require__("uJNR");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var node_modules_classnames = __webpack_require__("HW6M");
var classnames_default = /*#__PURE__*/__webpack_require__.n(node_modules_classnames);

// EXTERNAL MODULE: ./node_modules/react-toolbox/lib/link/theme.css
var link_theme = __webpack_require__("XeQ9");
var theme_default = /*#__PURE__*/__webpack_require__.n(link_theme);

// CONCATENATED MODULE: ./client/app/shared/components/RouterLink/index.jsx
var RouterLink__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







/*
** This component wraps React Router link to add default
*  styles from React Toolbox. It also accepts an object
*  in the className property that will be merged with
*  in the final className.
 */

var RouterLink_RouterLink = function RouterLink(props) {
  var _cx;

  var className = props.className,
      otherProps = _objectWithoutProperties(props, ['className']);

  var styles = classnames_default()((_cx = {}, _defineProperty(_cx, theme_default.a.link, true), _defineProperty(_cx, className, className !== undefined), _cx));

  return react_default.a.createElement(
    es["c" /* Link */],
    RouterLink__extends({ className: styles }, otherProps),
    props.children
  );
};

RouterLink_RouterLink.propTypes = {
  className: prop_types_default.a.string,
  children: prop_types_default.a.node
};

/* harmony default export */ var components_RouterLink = (RouterLink_RouterLink);
// EXTERNAL MODULE: ./node_modules/react-responsive/dist/react-responsive.js
var react_responsive = __webpack_require__("rRH8");
var react_responsive_default = /*#__PURE__*/__webpack_require__.n(react_responsive);

// EXTERNAL MODULE: ./client/app/screens/main/screens/phases/shared/modal.scss
var shared_modal = __webpack_require__("E9uF");
var modal_default = /*#__PURE__*/__webpack_require__.n(shared_modal);

// EXTERNAL MODULE: ./client/app/shared/actionCreators/phase.js
var actionCreators_phase = __webpack_require__("IJEG");

// EXTERNAL MODULE: ./node_modules/react-toolbox/lib/button/index.js
var lib_button = __webpack_require__("pUOY");
var button_default = /*#__PURE__*/__webpack_require__.n(lib_button);

// CONCATENATED MODULE: ./client/app/shared/types/flag.js


var FlagType = prop_types_default.a.shape({
  id: prop_types_default.a.number.isRequired,
  name: prop_types_default.a.string.isRequired,
  note: prop_types_default.a.string.isRequired,
  suboption: prop_types_default.a.string,
  user_name: prop_types_default.a.string.isRequired,
  created_at: prop_types_default.a.string });

/* harmony default export */ var types_flag = (FlagType);
// EXTERNAL MODULE: ./client/app/shared/components/EstimatorAPButton/styles.scss
var EstimatorAPButton_styles = __webpack_require__("5HtU");
var styles_default = /*#__PURE__*/__webpack_require__.n(EstimatorAPButton_styles);

// CONCATENATED MODULE: ./client/app/shared/components/EstimatorAPButton/sendEstimatorAPEmailModal.jsx
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var sendEstimatorAPEmailModal_SendEstimatorAPEmailModal = function (_React$Component) {
  _inherits(SendEstimatorAPEmailModal, _React$Component);

  function SendEstimatorAPEmailModal(props) {
    _classCallCheck(this, SendEstimatorAPEmailModal);

    var _this = _possibleConstructorReturn(this, (SendEstimatorAPEmailModal.__proto__ || Object.getPrototypeOf(SendEstimatorAPEmailModal)).call(this, props));

    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleClose = _this.handleClose.bind(_this);
    return _this;
  }

  _createClass(SendEstimatorAPEmailModal, [{
    key: 'handleSubmit',
    value: function handleSubmit(week) {
      this.props.sendEmail(week);
      this.handleClose();
    }
  }, {
    key: 'handleClose',
    value: function handleClose() {
      this.props.onClose();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return react_default.a.createElement(
        react_toolbox_lib["Dialog"],
        {
          active: this.props.active,
          className: modal_default.a.modal + ' ' + styles_default.a.seeBtnModalStyles,
          type: 'fullscreen',
          onEscKeyDown: this.handleClose,
          onOverlayClick: this.handleClose
        },
        react_default.a.createElement(lib_button["IconButton"], {
          icon: 'close',
          className: modal_default.a.close,
          onClick: this.handleClose,
          tabIndex: -1
        }),
        react_default.a.createElement(
          'h5',
          { className: modal_default.a.title },
          'Send Estimator AP Email'
        ),
        react_default.a.createElement(lib_button["Button"], {
          label: 'Current Week',
          flat: true, inverse: true, ripple: true,
          className: modal_default.a.submit + ' ' + styles_default.a.seeBtnModalHover,
          onClick: function onClick() {
            return _this2.handleSubmit('current');
          }
        }),
        react_default.a.createElement(lib_button["Button"], {
          label: 'Previous Week',
          flat: true, inverse: true, ripple: true,
          className: modal_default.a.submit + ' ' + styles_default.a.seeBtnModalHover,
          onClick: function onClick() {
            return _this2.handleSubmit('previous');
          }
        })
      );
    }
  }]);

  return SendEstimatorAPEmailModal;
}(react_default.a.Component);

sendEstimatorAPEmailModal_SendEstimatorAPEmailModal.propTypes = {
  errors: prop_types_default.a.object,
  active: prop_types_default.a.bool.isRequired,
  onClose: prop_types_default.a.func.isRequired,
  clearValidation: prop_types_default.a.func.isRequired,
  sendEmail: prop_types_default.a.func,
  flag: types_flag
};

/* harmony default export */ var sendEstimatorAPEmailModal = (sendEstimatorAPEmailModal_SendEstimatorAPEmailModal);
// CONCATENATED MODULE: ./client/app/shared/components/EstimatorAPButton/index.jsx
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();









var EstimatorAPButton_EstimatorAPButton = function EstimatorAPButton(_ref) {
  var user = _ref.user,
      canSendEmail = _ref.canSendEmail,
      setCanSendEmailToFalse = _ref.setCanSendEmailToFalse,
      setCanSendEmailToTrue = _ref.setCanSendEmailToTrue,
      className = _ref.className;

  var _useState = Object(react["useState"])(false),
      _useState2 = _slicedToArray(_useState, 2),
      activeModal = _useState2[0],
      setActiveModal = _useState2[1];

  var _useToasts = Object(dist["useToasts"])(),
      addToast = _useToasts.addToast;

  var notifySuccess = function notifySuccess() {
    return addToast('Email Sent', { appearance: 'success' });
  };

  var notifyFailure = function notifyFailure() {
    return addToast('Must wait 10 sec between emails', { appearance: 'warning' });
  };

  var sendEmail = function sendEmail(week) {
    Object(actionCreators["_43" /* sendEstimatorEmail */])(user.employable_id, week);
    notifySuccess();
    setCanSendEmailToFalse();
    setTimeout(function () {
      return setCanSendEmailToTrue();
    }, 10000);
  };

  var renderSendEstimatorAPEmailModal = function renderSendEstimatorAPEmailModal() {
    if (canSendEmail) setActiveModal(true);else notifyFailure();
  };

  var closeSendEstimatorAPEmailModal = function closeSendEstimatorAPEmailModal() {
    return setActiveModal(false);
  };

  return react_default.a.createElement(
    'div',
    { className: styles_default.a.seeBtnContainer },
    react_default.a.createElement(react_toolbox_lib["ListItem"], {
      key: 'send estimator ap email',
      value: 'send estimator ap email',
      itemContent: react_default.a.createElement(
        'div',
        null,
        'Send Estimator AP Email'
      ),
      onClick: renderSendEstimatorAPEmailModal,
      selectable: canSendEmail,
      className: className
    }),
    react_default.a.createElement(sendEstimatorAPEmailModal, {
      active: activeModal === true,
      onClose: closeSendEstimatorAPEmailModal,
      sendEmail: sendEmail
    })
  );
};

EstimatorAPButton_EstimatorAPButton.propTypes = {
  user: prop_types_default.a.object,
  canSendEmail: prop_types_default.a.boolean,
  setCanSendEmailToFalse: prop_types_default.a.func,
  setCanSendEmailToTrue: prop_types_default.a.func,
  className: prop_types_default.a.string
};

/* harmony default export */ var components_EstimatorAPButton = (EstimatorAPButton_EstimatorAPButton);
// EXTERNAL MODULE: ./client/app/shared/components/NavigationBar/profileMenu.scss
var profileMenu = __webpack_require__("Nhg6");
var profileMenu_default = /*#__PURE__*/__webpack_require__.n(profileMenu);

// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var qs_lib = __webpack_require__("mw3O");
var qs_lib_default = /*#__PURE__*/__webpack_require__.n(qs_lib);

// CONCATENATED MODULE: ./client/app/shared/helpers/url.js
var url__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function url__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable no-use-before-define */



var urls = url__extends({
  crew: function crew(_crew) {
    return '/installers/' + _crew.installer_id;
  },
  schedule: function schedule(date) {
    return '/schedule' + (date ? date.format('/Y/MM/DD') : '');
  }
}, url_resource('phase', {
  members: ['info', 'history', 'labor-product-accounting', 'cv-checklist', 'scheduling-checklist', 'appointments', 'warehouse-materials', 'communications', 'materials-checklist', 'ifi-template']
}), {
  appointment: function appointment(_appointment) {
    return '/phases/' + _appointment.phase.id + '/appointments#appointment' + _appointment.id;
  },
  newAppointment: function newAppointment(phaseId, apptType) {
    return '/phases/' + phaseId + '/appointments/new/' + apptType;
  }
}, url_resource('estimator'), url_resource('iqm'), url_resource('installer'), url_resource('store'), url_resource('employee'), url_resource('workroom'), {
  phaseWarehouseMaterials: function phaseWarehouseMaterials(phaseId) {
    return '/phases/' + phaseId + '/warehouse-materials';
  },
  phasePurchaseOrders: function phasePurchaseOrders(phaseId) {
    return '/phases/' + phaseId + '/labor-product-accounting';
  },
  workroomFromPhaseDetails: function workroomFromPhaseDetails(workroomID) {
    return '/workrooms/' + workroomID;
  },
  warehouseReport: function warehouseReport() {
    return '/reports/warehouse';
  },
  installWorkorderReport: function installWorkorderReport() {
    return '/reports/install-workorder';
  },
  installerPaperwork: function installerPaperwork() {
    return '/reports/installer-paperwork';
  },
  jobHistory: function jobHistory() {
    return '/reports/job-history';
  },
  activity: function activity() {
    return '/reports/activity';
  },
  tags: function tags() {
    return '/reports/tags-report';
  },
  scraper: function scraper() {
    return '/tools/scraper';
  },
  help: function help() {
    return 'https://serviceprosig.zendesk.com/hc/en-us';
  },
  releaseNotes: function releaseNotes() {
    return 'https://serviceprosig.zendesk.com/hc/en-us/sections/115001703648-Release-Updates';
  },
  lowesItem: function lowesItem(itemId) {
    return 'https://www.lowes.com/search?searchTerm=' + itemId;
  },
  filtersHelp: function filtersHelp() {
    return 'https://serviceprosig.zendesk.com/hc/en-us/articles/115005917228-SPOT-Basics-Part-5-Dashboard-Filtering';
  }
});


function linkTo(object) {
  if (!object.kind) return null;
  var helperName = Object(lodash["camelCase"])(object.kind);
  if (!urls[helperName]) return null;
  return urls[helperName](object);
}

function join() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return Object(lodash["join"])(args, '/');
}

function url_url(path) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!opts) return path;
  var pathname = path;
  var options = url__extends({}, opts);
  if (options.query) {
    pathname += '?' + qs_lib_default.a.stringify(options.query);
    delete options.query;
  }
  return Object.keys(options).length ? url__extends({ pathname: pathname }, options) : pathname;
}

function url_resource(resourceName) {
  var _extends2;

  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var pluralResource = resourceName + 's';
  var resourceUrl = '/' + Object(lodash["kebabCase"])(pluralResource);
  var resourceUrls = url__extends((_extends2 = {}, url__defineProperty(_extends2, pluralResource, function () {
    return resourceUrl;
  }), url__defineProperty(_extends2, Object(lodash["camelCase"])('create ' + resourceName), function () {
    return join(resourceUrl, 'new');
  }), url__defineProperty(_extends2, resourceName, function (object) {
    return join(resourceUrl, object.id);
  }), url__defineProperty(_extends2, Object(lodash["camelCase"])('update ' + resourceName), function (object) {
    return join(resourceUrl, object.id, 'edit');
  }), _extends2), options.resourceUrls || {});

  if (options.members) {
    options.members.forEach(function (m) {
      resourceUrls[Object(lodash["camelCase"])(resourceName + ' ' + m)] = function (object) {
        return join(resourceUrls[resourceName](object), m);
      };
    });
  }
  return resourceUrls;
}

Object.keys(urls).forEach(function (k) {
  var f = urls[k];
  urls[k] = function () {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return url_url.apply(undefined, [f.apply(undefined, _toConsumableArray(Object(lodash["take"])(args, f.length)))].concat(_toConsumableArray(Object(lodash["takeRight"])(args, args.length - f.length))));
  };
});
// CONCATENATED MODULE: ./client/app/shared/components/NavigationBar/toggleContrast.jsx
var toggleContrast__slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

/* eslint-disable jsx-a11y/no-static-element-interactions */





var toggleContrast_Button = function Button(_ref) {
  var isToggled = _ref.isToggled,
      size = _ref.size;

  var width = void 0;
  var height = void 0;
  var x = void 0;
  var y = void 0;

  switch (size) {
    case 'small':
      width = 35;
      height = 18;
      x = 8;
      y = 18;
      break;
    case 'medium':
      width = 50;
      height = 25;
      x = 11;
      y = 25;
      break;
    case 'large':
      width = 100;
      height = 50;
      x = 22;
      y = 50;
      break;
    default:
      width = 35;
      height = 18;
      x = 8;
      y = 18;
  }

  var buttonPosition = isToggled ? 'translate(-' + x + 'px,-' + y + 'px)' : 'translate(' + x + 'px,-' + y + 'px)';

  return react_default.a.createElement(
    'div',
    {
      style: {
        height: height,
        width: width,
        display: 'grid',
        transform: buttonPosition,
        transition: 'transform 200ms ease-out'
      }
    },
    react_default.a.createElement(
      'svg',
      {
        height: '100%',
        width: '100%',
        viewBox: '0 0 16 16'
      },
      react_default.a.createElement('circle', {
        id: 'Button',
        cx: '8',
        cy: '8',
        r: '8',
        fill: '#1a1a1a'
      })
    )
  );
};

var toggleContrast_ToggleContrast = function ToggleContrast(props) {
  /**
   * The local state is set using react hooks (useState). Initial state is
   * set from redux state.
   * Redux state uses localStorage to save configurations
   */
  var _useState = Object(react["useState"])(props.useHighContrast),
      _useState2 = toggleContrast__slicedToArray(_useState, 2),
      isToggled = _useState2[0],
      setToggle = _useState2[1];

  var width = void 0;
  var height = void 0;

  switch (props.size) {
    case 'small':
      width = 35;
      height = 18;
      break;
    case 'medium':
      width = 50;
      height = 25;
      break;
    case 'large':
      width = 100;
      height = 50;
      break;
    default:
      width = 35;
      height = 18;
  }

  function handleClick() {
    var toggledState = !isToggled;
    localStorage.setItem('useHighContrast', JSON.stringify(toggledState));
    setToggle(toggledState);
    props.toggleHighContrast();
  }

  return react_default.a.createElement(
    'div',
    { style: { marginTop: 10 } },
    'Contrast',
    react_default.a.createElement(
      'div',
      {
        style: {
          marginTop: 5,
          paddingBottom: 10
        }
      },
      react_default.a.createElement(
        'span',
        { style: { display: 'flex', flexWrap: 'wrap' } },
        react_default.a.createElement(
          'div',
          {
            style: {
              overflow: 'hidden',
              height: height,
              width: width,
              cursor: 'pointer'
            },
            onClick: handleClick
          },
          react_default.a.createElement(
            'div',
            { style: { height: height, width: width, display: 'grid' } },
            react_default.a.createElement(
              'svg',
              { height: '100%', width: '100%', viewBox: '0 0 35 18' },
              react_default.a.createElement('path', {
                id: 'Body',
                d: 'M33.22 2a8.43 8.43 0 1 1 0 16.86H16.35a8.43 8.43 0 0 1 0-16.86z',
                transform: 'translate(-7.42 -1.54)',
                fill: isToggled ? '#EFB300' : '#3A91E8',
                stroke: '#1a1a1a',
                strokeMiterlimit: '10'
              })
            )
          ),
          react_default.a.createElement(toggleContrast_Button, { isToggled: isToggled, size: props.size })
        ),
        react_default.a.createElement(
          'span',
          { style: { fontSize: 12, margin: 3 } },
          isToggled ? 'High' : 'Normal'
        )
      )
    )
  );
};

toggleContrast_Button.propTypes = {
  isToggled: prop_types_default.a.bool,
  size: prop_types_default.a.string
};

toggleContrast_ToggleContrast.propTypes = {
  size: prop_types_default.a.string,
  useHighContrast: prop_types_default.a.bool,
  toggleHighContrast: prop_types_default.a.func
};

function toggleContrast_mapStateToProps(state) {
  var useHighContrast = state.settings.useHighContrast;
  return { useHighContrast: useHighContrast };
}

/* harmony default export */ var toggleContrast = (Object(react_redux_es["connect"])(toggleContrast_mapStateToProps, { toggleHighContrast: actionCreators["_58" /* toggleHighContrast */] })(toggleContrast_ToggleContrast));
// EXTERNAL MODULE: ./client/app/utils/index.js
var utils = __webpack_require__("FbQg");

// EXTERNAL MODULE: ./client/app/services/ability.js
var services_ability = __webpack_require__("CqOy");

// CONCATENATED MODULE: ./client/app/shared/components/NavigationBar/profileMenu.jsx
function profileMenu__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function profileMenu__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function profileMenu__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var profileMenu_theme = { RTButton: profileMenu_default.a };

var profileMenu_ProfileMenu = function (_Component) {
  profileMenu__inherits(ProfileMenu, _Component);

  function ProfileMenu(props) {
    profileMenu__classCallCheck(this, ProfileMenu);

    var _this = profileMenu__possibleConstructorReturn(this, (ProfileMenu.__proto__ || Object.getPrototypeOf(ProfileMenu)).call(this, props));

    Object.defineProperty(_this, 'setCanSendEmailToFalse', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ canSendEmail: false, sendEmailButtonStyle: profileMenu_default.a.disableSendEmailBtn });
      }
    });
    Object.defineProperty(_this, 'setCanSendEmailToTrue', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ canSendEmail: true, sendEmailButtonStyle: null });
      }
    });
    Object.defineProperty(_this, 'logout', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props$user$msal = _this.props.user.msal,
            msal = _this$props$user$msal === undefined ? null : _this$props$user$msal;

        if (msal) msal.logout();
        _this.props.logoutUser();
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            user = _this$props.user,
            _this$props$user = _this$props.user,
            employable_type = _this$props$user.employable_type,
            employable_id = _this$props$user.employable_id,
            name = _this$props$user.name,
            role = _this$props$user.role;

        var profileUrl = react_default.a.createElement(
          es["c" /* Link */],
          {
            to: linkTo({
              kind: employable_type,
              id: employable_id
            })
          },
          'My Profile'
        );
        return react_default.a.createElement(
          react_css_themr_lib["ThemeProvider"],
          { theme: profileMenu_theme },
          react_default.a.createElement(
            'div',
            { className: profileMenu_theme.RTButton.wrapper },
            react_default.a.createElement(
              react_toolbox_lib["Button"],
              { inverse: true },
              name,
              react_default.a.createElement(
                react_toolbox_lib["FontIcon"],
                null,
                'keyboard_arrow_down'
              )
            ),
            react_default.a.createElement(
              'div',
              { className: profileMenu_theme.RTButton.menu },
              react_default.a.createElement(
                react_toolbox_lib["List"],
                { selectable: true, className: profileMenu_theme.RTButton.listWrapper },
                Object(utils["y" /* roleNotInstallerBased */])(role, true) && react_default.a.createElement(react_toolbox_lib["ListItem"], {
                  key: 'profile',
                  value: 'profile',
                  itemContent: profileUrl
                }),
                role === 'estimator' && Object(services_ability["a" /* can */])(role, 'manage', 'send_email') && react_default.a.createElement(components_EstimatorAPButton, {
                  user: user,
                  canSendEmail: _this.state.canSendEmail,
                  setCanSendEmailToFalse: _this.setCanSendEmailToFalse,
                  setCanSendEmailToTrue: _this.setCanSendEmailToTrue,
                  className: _this.state.sendEmailButtonStyle
                }),
                react_default.a.createElement(react_toolbox_lib["ListItem"], {
                  key: 'signout',
                  value: 'signout',
                  itemContent: react_default.a.createElement(
                    'div',
                    null,
                    'Sign Out'
                  ),
                  onClick: _this.logout
                }),
                react_default.a.createElement(react_toolbox_lib["ListItem"], {
                  key: 'contrast',
                  value: 'contrast',
                  itemContent: react_default.a.createElement(toggleContrast, null),
                  ripple: false,
                  selectable: false
                })
              )
            )
          )
        );
      }
    });

    _this.state = { canSendEmail: true, sendEmailButtonStyle: null };
    return _this;
  }

  return ProfileMenu;
}(react["Component"]);

Object.defineProperty(profileMenu_ProfileMenu, 'propTypes', {
  enumerable: true,
  writable: true,
  value: {
    user: prop_types_default.a.shape({
      id: prop_types_default.a.number,
      name: prop_types_default.a.string,
      employable_id: prop_types_default.a.number,
      employable_type: prop_types_default.a.string,
      msal: prop_types_default.a.object
    }),
    logoutUser: prop_types_default.a.func
  }
});
/* harmony default export */ var NavigationBar_profileMenu = (profileMenu_ProfileMenu);
// EXTERNAL MODULE: ./client/app/shared/components/SearchBox/search.scss
var SearchBox_search = __webpack_require__("yNA9");
var search_default = /*#__PURE__*/__webpack_require__.n(SearchBox_search);

// CONCATENATED MODULE: ./client/app/shared/components/SearchBox/index.jsx
var SearchBox__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function SearchBox__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SearchBox__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function SearchBox__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var SearchBox_Search = function (_React$Component) {
  SearchBox__inherits(Search, _React$Component);

  function Search() {
    var _ref;

    var _temp, _this, _ret;

    SearchBox__classCallCheck(this, Search);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = SearchBox__possibleConstructorReturn(this, (_ref = Search.__proto__ || Object.getPrototypeOf(Search)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'state', {
      enumerable: true,
      writable: true,
      value: { value: _this.props.value }
    }), Object.defineProperty(_this, 'onChange', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        _this.setState({ value: e.target.value });
      }
    }), Object.defineProperty(_this, 'onSubmit', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        _this.props.onSubmit(e, _this.state.value);
      }
    }), _temp), SearchBox__possibleConstructorReturn(_this, _ret);
  }

  SearchBox__createClass(Search, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (newProps.value !== this.props.value) {
        this.setState({ value: newProps.value });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          theme = _props.theme,
          placeholder = _props.placeholder;

      return react_default.a.createElement(
        'form',
        { className: theme.wrapper, onSubmit: this.onSubmit },
        react_default.a.createElement('input', {
          type: 'search',
          className: theme.inputElement,
          name: 'query',
          value: this.state.value || '',
          onChange: this.onChange,
          placeholder: placeholder
        }),
        react_default.a.createElement(
          'button',
          { type: 'submit', className: theme.submit },
          react_default.a.createElement(
            react_toolbox_lib["FontIcon"],
            { className: theme.icon },
            'search'
          )
        )
      );
    }
  }]);

  return Search;
}(react_default.a.Component);

SearchBox_Search.propTypes = {
  theme: prop_types_default.a.shape({
    wrapper: prop_types_default.a.string,
    inputElement: prop_types_default.a.string,
    icon: prop_types_default.a.string
  }),
  placeholder: prop_types_default.a.string,
  value: prop_types_default.a.string,
  onSubmit: prop_types_default.a.func
};

/* harmony default export */ var SearchBox = (Object(react_css_themr_lib["themr"])('SearchBox', search_default.a)(SearchBox_Search));
// EXTERNAL MODULE: ./node_modules/mousetrap/mousetrap.js
var mousetrap = __webpack_require__("knr3");
var mousetrap_default = /*#__PURE__*/__webpack_require__.n(mousetrap);

// EXTERNAL MODULE: ./node_modules/react-toolbox/lib/list/theme.css
var list_theme = __webpack_require__("7DFl");
var list_theme_default = /*#__PURE__*/__webpack_require__.n(list_theme);

// EXTERNAL MODULE: ./client/app/shared/components/NavigationBar/appBar.scss
var appBar = __webpack_require__("0/D+");
var appBar_default = /*#__PURE__*/__webpack_require__.n(appBar);

// EXTERNAL MODULE: ./client/app/shared/components/NavigationBar/navigation.scss
var navigation = __webpack_require__("ivs0");
var navigation_default = /*#__PURE__*/__webpack_require__.n(navigation);

// EXTERNAL MODULE: ./client/app/shared/components/NavigationBar/button.scss
var NavigationBar_button = __webpack_require__("SMIQ");
var NavigationBar_button_default = /*#__PURE__*/__webpack_require__.n(NavigationBar_button);

// EXTERNAL MODULE: ./client/app/shared/components/NavigationBar/link.scss
var NavigationBar_link = __webpack_require__("F/03");
var link_default = /*#__PURE__*/__webpack_require__.n(NavigationBar_link);

// EXTERNAL MODULE: ./client/app/shared/components/NavigationBar/search.scss
var NavigationBar_search = __webpack_require__("49Rk");
var NavigationBar_search_default = /*#__PURE__*/__webpack_require__.n(NavigationBar_search);

// CONCATENATED MODULE: ./client/app/shared/components/NavigationBar/index.jsx
var NavigationBar__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function NavigationBar__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function NavigationBar__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function NavigationBar__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






















var NavigationBar_theme = { RTAppBar: appBar_default.a, RTNavigation: navigation_default.a, RTButton: NavigationBar_button_default.a, RTLink: link_default.a };

var NavigationBar_NavigationBar = function (_Component) {
  NavigationBar__inherits(NavigationBar, _Component);

  function NavigationBar(props) {
    NavigationBar__classCallCheck(this, NavigationBar);

    var _this = NavigationBar__possibleConstructorReturn(this, (NavigationBar.__proto__ || Object.getPrototypeOf(NavigationBar)).call(this, props));

    Object.defineProperty(_this, 'componentDidMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.getInitialSelectedTabFromURL();
        mousetrap_default.a.bind('g+l', _this.handleFiltersShortcut);
        mousetrap_default.a.bind('g+s', _this.handleScheduleShortcut);
      }
    });
    Object.defineProperty(_this, 'onSearch', {
      enumerable: true,
      writable: true,
      value: function value(e, _value) {
        e.preventDefault();
        var newWindow = window.open('/phases?query=' + _value, '_blank');
        newWindow.ignoreLocationFilters = false;
        return newWindow;
      }
    });
    Object.defineProperty(_this, 'setSelectedNavTab', {
      enumerable: true,
      writable: true,
      value: function value(id) {
        return _this.setState({ selectedNavTab: id });
      }
    });
    Object.defineProperty(_this, 'getInitialSelectedTabFromURL', {
      enumerable: true,
      writable: true,
      value: function value() {
        var url = window.location.href;
        if (url.includes('/schedule')) _this.setSelectedNavTab('Schedule');else if (url.includes('/employees') || url.includes('/iqms') || url.includes('/estimators') || url.includes('/installers')) _this.setSelectedNavTab('User Management');else if (url.includes('/stores') || url.includes('/workrooms') || url.includes('/pricepatchuploads') || url.includes('/bulk-updates') || url.includes('/lowes-survey') || url.includes('/line-items') || url.includes('/default-installer-pay') || url.includes('/holiday-promo-settings')) _this.setSelectedNavTab('Administration');else if (url.includes('/tools') || url.includes(urls.activity()) || url.includes(urls.installerPaperwork()) || url.includes(urls.warehouseReport()) || url.includes(urls.scraper()) || url.includes(urls.tags())) _this.setSelectedNavTab('Tools');else _this.setSelectedNavTab('Filters');
      }
    });
    Object.defineProperty(_this, 'handleFiltersShortcut', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.navigate('/phases');
      }
    });
    Object.defineProperty(_this, 'handleScheduleShortcut', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.navigate('/schedule');
      }
    });
    Object.defineProperty(_this, 'adminSubItems', {
      enumerable: true,
      writable: true,
      value: function value() {
        var items = [{ label: 'Store Management', linkTo: '/stores', ability: 'store' }, { label: 'Workroom Management', linkTo: '/workrooms', ability: 'workroom' }, { label: 'Bulk Update', linkTo: '/bulk-updates', ability: 'bulk_update_upload' }, { label: 'Margin Update', linkTo: '/margin-updates', ability: 'margin_upload' }, { label: 'Activity Update', linkTo: '/activity-updates', ability: 'activity_upload' }, { label: 'Line Items', linkTo: '/line-items', ability: 'line_item' }];
        var mvw = _this.props.user.manage_vendor_workrooms;
        if (mvw.lhi || mvw.ifi) {
          items.push({ label: 'Holiday Promo Settings', linkTo: '/holiday-promo-settings', ability: 'holiday_promo_settings' });
        }
        if (mvw.lhi) {
          items.push({ label: 'Price Patches', linkTo: '/pricepatchuploads', ability: 'price_patch_upload' });
          items.push({ label: 'Lowes C&P', linkTo: '/lowes-survey', ability: 'lowes_survey_upload' });
        }
        if (mvw.ifi && Object(services["a" /* can */])(_this.props.user.role, 'view', 'default_installer_pay')) {
          items.push({ label: 'Default Installer Pay', linkTo: '/default-installer-pay', ability: 'default_installer_pay' });
        }
        return items;
      }
    });
    Object.defineProperty(_this, 'menuItems', {
      enumerable: true,
      writable: true,
      value: function value() {
        return [{ label: 'Phases', key: 'phases', linkTo: '/phases', ability: 'phase' },
        // { label: 'Dashboard', key: 'dashboard', linkTo: '/dashboard', ability: 'dashboard' },
        { label: 'Schedule', key: 'schedule', linkTo: '/schedule', ability: 'schedule' }, {
          label: 'User Management',
          key: 'users',
          linkTo: '/employees',
          subItems: [{ label: 'Employees', linkTo: '/employees', ability: 'employee' },
          // { label: 'IQMs', linkTo: '/iqms', ability: 'iqm' },
          { label: 'Estimators', linkTo: '/estimators', ability: 'estimator' }, { label: 'Installers', linkTo: '/installers', ability: 'installer', except: 'installer' }]
        }, {
          label: 'Administration',
          key: 'administration',
          linkTo: '/stores',
          subItems: _this.adminSubItems()
        }, {
          label: 'Tools',
          key: 'tools',
          linkTo: urls.activity(),
          subItems: [{ label: 'Employee Activity', linkTo: urls.activity(), ability: 'activity_report' }, { label: 'Installations Paperwork', linkTo: urls.installerPaperwork(), ability: 'installations_paperwork' }, { label: 'Warehouse Report', linkTo: urls.warehouseReport(), ability: 'warehouse_report' }, { label: 'Install/Workorder Report', linkTo: urls.installWorkorderReport(), ability: 'warehouse_report' }, { label: 'Job History', linkTo: urls.jobHistory(), ability: 'job_history' }, { label: 'Tags Bulk Print', linkTo: urls.tags(), ability: 'tags_bulk_print' }, { label: 'Bulk Project Load', linkTo: '/bulk-projects', ability: 'bulk_projects_load' }, { label: 'Scraper', linkTo: urls.scraper(), ability: 'scraper' }]
        }];
      }
    });
    Object.defineProperty(_this, 'determinePerms', {
      enumerable: true,
      writable: true,
      value: function value(ability, except) {
        var _this$props$user = _this.props.user,
            role = _this$props$user.role,
            position = _this$props$user.position;

        return role !== except && (ability === 'bulk_projects_load' ? Object(services["a" /* can */])(role, 'manage', ability, { position: position }) : Object(services["a" /* can */])(role, 'view', ability));
      }
    });
    Object.defineProperty(_this, 'items', {
      enumerable: true,
      writable: true,
      value: function value() {
        var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.menuItems();
        return items.map(function (item) {
          var _this$props$user2 = _this.props.user,
              role = _this$props$user2.role,
              mvw = _this$props$user2.manage_vendor_workrooms;

          if (item.subItems) {
            var available = _this.items(item.subItems);
            if (!available.length) return null;
            if (item.label === 'Administration' && mvw.ifi) {
              return NavigationBar__extends({}, item, { subItems: available.map(function (i) {
                  return i.label === 'Workroom Management' ? NavigationBar__extends({}, i, { label: 'Market/Workroom Management' }) : i;
                }) });
            }if (item.label === 'Tools' && mvw.ifi && !Object(services["a" /* can */])(role, 'view', 'non_ifi', { manage_vendor_workrooms: mvw })) {
              var filtered = available.filter(function (i) {
                return !['Warehouse Report', 'Tags Bulk Print', 'Scraper'].includes(i.label);
              });
              return NavigationBar__extends({}, item, { subItems: filtered });
            }
            return NavigationBar__extends({}, item, { subItems: available });
          }
          return !item.ability || _this.determinePerms(item.ability, item.except) ? item : null;
        }).filter(function (i) {
          return !!i;
        });
      }
    });
    Object.defineProperty(_this, 'toggleSubItems', {
      enumerable: true,
      writable: true,
      value: function value(menuKey) {
        return function (ev) {
          ev.preventDefault();
          var statePiece = {};
          statePiece[menuKey] = !_this.state[menuKey];
          _this.setState(statePiece);
        };
      }
    });
    Object.defineProperty(_this, 'subMenuLink', {
      enumerable: true,
      writable: true,
      value: function value(item) {
        var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'horizontal';
        return react_default.a.createElement(
          components_RouterLink,
          {
            className: link_default.a.navLink,
            to: item.linkTo,
            onClick: type === 'vertical' ? _this.moveDrawer : null
          },
          react_default.a.createElement(
            'span',
            { className: list_theme_default.a.itemContentRoot },
            react_default.a.createElement(
              'span',
              { className: list_theme_default.a.itemText },
              item.label
            )
          )
        );
      }
    });
    Object.defineProperty(_this, 'subItems', {
      enumerable: true,
      writable: true,
      value: function value(items) {
        var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'horizontal';
        return items ? react_default.a.createElement(
          'div',
          {
            className: type === 'horizontal' ? NavigationBar_button_default.a.subMenuHorizontal : NavigationBar_button_default.a.subMenuVertical
          },
          react_default.a.createElement(
            react_toolbox_lib["List"],
            { selectable: true },
            items.map(function (item) {
              if (type === 'horizontal') {
                return react_default.a.createElement(react_toolbox_lib["ListItem"], {
                  key: item.label,
                  value: item.label,
                  itemContent: _this.subMenuLink(item),
                  className: appBar_default.a.sublinkDesktop
                });
              }
              return react_default.a.createElement(react_toolbox_lib["ListItem"], {
                key: item.label,
                value: item.label,
                itemContent: _this.subMenuLink(item, 'vertical'),
                className: appBar_default.a.sublink
              });
            })
          )
        ) : null;
      }
    });
    Object.defineProperty(_this, 'filterMenuItems', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props$user3 = _this.props.user,
            position = _this$props$user3.position,
            userName = _this$props$user3.name;

        var filteredMenuItems = _this.items().filter(function (menuItem) {
          if (menuItem.label === 'Dashboard') {
            if (constants["e" /* ALLOWED_DASHBOARD_POSITIONS */].includes(position) || constants["d" /* ALLOWED_DASHBOARD_NAMES */].includes(userName)) return true;
            return false;
          }
          return true;
        });
        return filteredMenuItems;
      }
    });
    Object.defineProperty(_this, 'renderDesktop', {
      enumerable: true,
      writable: true,
      value: function value() {
        var filteredMenuItems = _this.filterMenuItems();
        var buttonMenuItems = filteredMenuItems.map(function (menuItem) {
          var className = menuItem.label === _this.state.selectedNavTab ? NavigationBar_button_default.a.neutral + ' ' + NavigationBar_button_default.a.selected : NavigationBar_button_default.a.neutral;
          return react_default.a.createElement(
            'li',
            { // eslint-disable-line
              key: menuItem.label,
              className: className,
              onClick: function onClick() {
                return _this.setSelectedNavTab(menuItem.label);
              }
            },
            react_default.a.createElement(
              components_RouterLink,
              { to: menuItem.linkTo || '', className: link_default.a.navLink },
              menuItem.label
            ),
            menuItem.subItems != null ? _this.subItems(menuItem.subItems) : null
          );
        });
        var onPhases = _this.props.location.pathname === '/phases';
        return react_default.a.createElement(
          react_css_themr_lib["ThemeProvider"],
          { theme: NavigationBar_theme },
          react_default.a.createElement(
            react_toolbox_lib["AppBar"],
            { flat: true },
            react_default.a.createElement(
              'ul',
              { className: appBar_default.a.navList },
              buttonMenuItems
            ),
            !onPhases && react_default.a.createElement(SearchBox, {
              onSubmit: _this.onSearch,
              placeholder: 'Search phases in new tab',
              theme: NavigationBar_search_default.a
            }),
            react_default.a.createElement(NavigationBar_profileMenu, {
              user: _this.props.user,
              logoutUser: _this.props.logoutUser
            })
          )
        );
      }
    });
    Object.defineProperty(_this, 'renderMobile', {
      enumerable: true,
      writable: true,
      value: function value() {
        var filteredMenuItems = _this.filterMenuItems();
        var linkMenuItems = filteredMenuItems.map(function (menu) {
          if (menu.subItems != null) {
            return react_default.a.createElement(
              'li',
              { key: menu.key },
              react_default.a.createElement(
                'a',
                { href: menu.linkTo, onClick: _this.toggleSubItems(menu.key), style: { display: 'flex', alignItems: 'center' } },
                react_default.a.createElement(
                  'span',
                  null,
                  menu.label
                ),
                react_default.a.createElement(react_toolbox_lib["FontIcon"], { style: { flexGrow: '1' }, value: _this.state[menu.key] ? 'keyboard_arrow_up' : 'keyboard_arrow_down' })
              ),
              _this.state[menu.key] && _this.subItems(menu.subItems, 'vertical')
            );
          }
          var menuItem = react_default.a.createElement(
            components_RouterLink,
            { className: link_default.a.navLink, to: menu.linkTo || '', onClick: _this.moveDrawer, key: menu.key },
            menu.label
          );
          return react_default.a.createElement(
            'li',
            { key: menu.key },
            menuItem
          );
        });
        return react_default.a.createElement(
          react_css_themr_lib["ThemeProvider"],
          { theme: NavigationBar_theme },
          react_default.a.createElement(
            react["Fragment"],
            null,
            react_default.a.createElement(
              react_toolbox_lib["Drawer"],
              { active: _this.state.drawerOpen, onOverlayClick: _this.moveDrawer },
              react_default.a.createElement(
                'ul',
                { className: appBar_default.a.navListMobile },
                linkMenuItems
              )
            ),
            react_default.a.createElement(
              react_toolbox_lib["AppBar"],
              { className: appBar_default.a.small },
              react_default.a.createElement(react_toolbox_lib["IconButton"], { icon: 'menu', inverse: true, onClick: _this.moveDrawer }),
              react_default.a.createElement('div', { style: { position: 'absolute', right: '0', top: '0' } }),
              react_default.a.createElement(NavigationBar_profileMenu, {
                user: _this.props.user,
                logoutUser: _this.props.logoutUser
              })
            )
          )
        );
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var onPhases = _this.props.location.pathname === '/phases';
        var searchBoxSize = 216;
        var dynamicNavCutPoint = onPhases ? constants["_6" /* NAV_CUT_POINT */] - searchBoxSize : constants["_6" /* NAV_CUT_POINT */];
        return react_default.a.createElement(
          react["Fragment"],
          null,
          react_default.a.createElement(
            react_responsive_default.a,
            { maxWidth: dynamicNavCutPoint - 1 },
            _this.renderMobile()
          ),
          react_default.a.createElement(
            react_responsive_default.a,
            { minWidth: dynamicNavCutPoint },
            _this.renderDesktop()
          )
        );
      }
    });

    _this.moveDrawer = function () {
      _this.setState({ drawerOpen: !_this.state.drawerOpen });
    };
    _this.toggleSubItems = _this.toggleSubItems.bind(_this);
    _this.state = { drawerOpen: false, administration: false, selectedNavTab: '' };
    return _this;
  }

  return NavigationBar;
}(react["Component"]);

NavigationBar_NavigationBar.defaultProps = { user: { role: '', position: '', name: '' } };

NavigationBar_NavigationBar.propTypes = {
  user: prop_types_default.a.shape({
    role: prop_types_default.a.string,
    position: prop_types_default.a.string,
    name: prop_types_default.a.string,
    employable_id: prop_types_default.a.string,
    employable_type: prop_types_default.a.string,
    manage_vendor_workrooms: prop_types_default.a.object,
    isAuthenticating: prop_types_default.a.bool
  }),
  employee: prop_types_default.a.object,
  logoutUser: prop_types_default.a.func.isRequired,
  navigate: prop_types_default.a.func.isRequired,
  location: prop_types_default.a.shape({
    pathname: prop_types_default.a.string.isRequired
  }).isRequired
};

var NavigationBar_mapStateToProps = function mapStateToProps(state) {
  return { user: state.user };
};

/* harmony default export */ var components_NavigationBar = (Object(react_redux_es["connect"])(NavigationBar_mapStateToProps, { logoutUser: actionCreators["L" /* logoutUser */], navigate: actionCreators["O" /* navigate */] })(NavigationBar_NavigationBar));
// EXTERNAL MODULE: ./client/app/shared/components/Loading/styles.scss
var Loading_styles = __webpack_require__("NDtc");
var Loading_styles_default = /*#__PURE__*/__webpack_require__.n(Loading_styles);

// CONCATENATED MODULE: ./client/app/shared/components/Loading/index.jsx





var Loading_Loading = function Loading(props) {
  var size = {
    width: props.size + 'px',
    height: props.size + 'px'
  };

  var cxCySize = props.size / 2;

  return react_default.a.createElement(
    'div',
    { className: props.className },
    react_default.a.createElement(
      'div',
      { style: size },
      react_default.a.createElement(
        'svg',
        { className: Loading_styles_default.a.circular, style: size },
        react_default.a.createElement('circle', {
          className: Loading_styles_default.a.path,
          cx: cxCySize,
          cy: cxCySize,
          r: props.radius,
          fill: 'none',
          strokeWidth: '2',
          strokeMiterlimit: '10'
        })
      )
    )
  );
};

Loading_Loading.propTypes = {
  size: prop_types_default.a.oneOfType([prop_types_default.a.number, prop_types_default.a.string]),
  radius: prop_types_default.a.oneOfType([prop_types_default.a.number, prop_types_default.a.string]),
  className: prop_types_default.a.string
};

Loading_Loading.defaultProps = {
  size: '100',
  radius: '20'
};

/* harmony default export */ var components_Loading = (Object(react_css_themr_lib["themr"])('Loading', Loading_styles_default.a)(Loading_Loading));
// EXTERNAL MODULE: ./client/app/shared/styles/snackbar.scss
var snackbar = __webpack_require__("NwYq");
var snackbar_default = /*#__PURE__*/__webpack_require__.n(snackbar);

// EXTERNAL MODULE: ./client/app/shared/components/BackToTop/backToTop.scss
var BackToTop_backToTop = __webpack_require__("MPvU");
var backToTop_default = /*#__PURE__*/__webpack_require__.n(BackToTop_backToTop);

// EXTERNAL MODULE: ./client/app/assets/images/bttBtnArrow.svg
var bttBtnArrow = __webpack_require__("3TFB");
var bttBtnArrow_default = /*#__PURE__*/__webpack_require__.n(bttBtnArrow);

// CONCATENATED MODULE: ./client/app/shared/components/BackToTop/index.jsx





var BackToTop_BackToTop = function BackToTop() {
  var backToTop = document.getElementById('backToTop');

  // replace class if navigating away from page when BTT button is visible
  if (backToTop !== null && backToTop.classList.value === 'backToTop__backToTop___1Smks') {
    backToTop.classList.replace(backToTop_default.a.backToTop, backToTop_default.a.inactive);
  }

  // Variable used to toggle class once instead of every set interval,
  // fixes issue of constant event listening when user is at end of screen
  var visible = false;

  // BTT button toggle logic
  function toggleBackToTopBtn() {
    if (window.pageYOffset > screen.height) {
      if (!backToTop) backToTop = document.getElementById('backToTop');
      if (visible === false) {
        backToTop.classList.replace(backToTop_default.a.inactive, backToTop_default.a.backToTop);
      }
      visible = true;
    } else {
      if (visible === true) {
        backToTop.classList.replace(backToTop_default.a.backToTop, backToTop_default.a.inactive);
      }
      visible = false;
    }
  }

  // Minimize the frequency of checking if BTT button should be toggled
  var didScroll = false;
  function toggleDidScroll() {
    didScroll = true;
  }
  window.onscroll = toggleDidScroll;
  setInterval(function () {
    if (didScroll) {
      didScroll = false;
      toggleBackToTopBtn();
    }
  }, 100);

  function scrollToTop() {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  return react_default.a.createElement(
    'div',
    null,
    react_default.a.createElement(
      'button',
      {
        id: 'backToTop',
        className: backToTop_default.a.inactive,
        onClick: scrollToTop
      },
      react_default.a.createElement('img', { className: backToTop_default.a.bttImage, src: bttBtnArrow_default.a, alt: 'Back To Top Button' })
    )
  );
};

/* harmony default export */ var components_BackToTop = (Object(react_css_themr_lib["themr"])('BackToTop', backToTop_default.a)(BackToTop_BackToTop));
// CONCATENATED MODULE: ./client/app/screens/main/index.jsx











var main_theme = { RTSnackbar: snackbar_default.a };

var main_Main = function Main(_ref) {
  var children = _ref.children,
      isAuthenticating = _ref.isAuthenticating,
      error = _ref.error,
      location = _ref.location;
  return react_default.a.createElement(
    dist["ToastProvider"],
    { autoDismiss: true, autoDismissTimeout: 2000 },
    react_default.a.createElement(
      'div',
      null,
      react_default.a.createElement(components_NavigationBar, { location: location }),
      error && error.messages && react_default.a.createElement(
        react_css_themr_lib["ThemeProvider"],
        { theme: main_theme },
        react_default.a.createElement(
          react_toolbox_lib["Snackbar"],
          { active: true, type: 'warning' },
          react_default.a.createElement(react_toolbox_lib["FontIcon"], { value: 'warning' }),
          error.messages.join(', ')
        )
      ),
      isAuthenticating ? react_default.a.createElement(components_Loading, null) : children,
      react_default.a.createElement(components_BackToTop, null)
    )
  );
};

main_Main.propTypes = {
  children: prop_types_default.a.node,
  isAuthenticating: prop_types_default.a.bool,
  role: prop_types_default.a.string,
  error: prop_types_default.a.shape({ messages: prop_types_default.a.arrayOf(prop_types_default.a.string) }),
  location: prop_types_default.a.object
};

/* harmony default export */ var main = (Object(react_redux_es["connect"])(function (state) {
  return {
    isAuthenticating: state.user.isAuthenticating,
    role: state.user.role,
    error: state.error
  };
})(main_Main));
// EXTERNAL MODULE: ./client/app/reducers/index.js + 45 modules
var reducers = __webpack_require__("RbI9");

// CONCATENATED MODULE: ./client/app/screens/main/redirect.jsx
var redirect__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function redirect__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function redirect__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function redirect__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var IndexRedirect = function (_React$Component) {
  redirect__inherits(IndexRedirect, _React$Component);

  function IndexRedirect() {
    redirect__classCallCheck(this, IndexRedirect);

    return redirect__possibleConstructorReturn(this, (IndexRedirect.__proto__ || Object.getPrototypeOf(IndexRedirect)).apply(this, arguments));
  }

  redirect__createClass(IndexRedirect, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.replace(this.props.role === 'installer' ? '/schedule' : '/phases');
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return IndexRedirect;
}(react_default.a.Component);

IndexRedirect.propTypes = {
  replace: prop_types_default.a.func,
  role: prop_types_default.a.string
};

/* harmony default export */ var main_redirect = (Object(react_redux_es["connect"])(function (state) {
  return {
    role: Object(reducers["_12" /* getRole */])(state)
  };
}, { replace: react_router_redux_lib["routerActions"].replace })(IndexRedirect));
// EXTERNAL MODULE: ./client/app/shared/components/PageActionBar/pageActionBar.scss
var pageActionBar = __webpack_require__("0dZs");
var pageActionBar_default = /*#__PURE__*/__webpack_require__.n(pageActionBar);

// EXTERNAL MODULE: ./client/app/shared/components/PageActionButton/pageActionButton.scss
var pageActionButton = __webpack_require__("gIPr");
var pageActionButton_default = /*#__PURE__*/__webpack_require__.n(pageActionButton);

// CONCATENATED MODULE: ./client/app/shared/components/PageActionButton/index.jsx








var PageActionButton_PageActionButton = function PageActionButton(props) {
  var actionText = props.actionText || 'Text';
  var actionIcon = props.actionIcon || 'report';
  var actionColor = props.actionColor || 'blue';

  var filterClasses = classnames_default()([pageActionButton_default.a.actions, pageActionButton_default.a[actionColor]]);

  var children = react_default.a.createElement(
    'div',
    { className: pageActionButton_default.a.button },
    react_default.a.createElement(react_toolbox_lib["FontIcon"], { value: actionIcon }),
    react_default.a.createElement(
      'div',
      { className: pageActionButton_default.a.iconButtonText },
      actionText
    )
  );

  return typeof props.action === 'string' ? react_default.a.createElement(
    es["c" /* Link */],
    { className: filterClasses, to: props.action },
    children
  ) : react_default.a.createElement(
    'button',
    { className: filterClasses, onClick: props.action },
    children
  );
};

PageActionButton_PageActionButton.propTypes = {
  actionText: prop_types_default.a.string,
  actionIcon: prop_types_default.a.string,
  actionColor: prop_types_default.a.string,
  action: prop_types_default.a.oneOfType([prop_types_default.a.func, prop_types_default.a.string])
};

/* harmony default export */ var components_PageActionButton = (PageActionButton_PageActionButton);
// CONCATENATED MODULE: ./client/app/shared/components/PageActionBar/index.jsx
function PageActionBar__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function PageActionBar__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function PageActionBar__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function PageActionBar__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var PageActionBar_PageActionBar = function (_React$Component) {
  PageActionBar__inherits(PageActionBar, _React$Component);

  function PageActionBar(props) {
    PageActionBar__classCallCheck(this, PageActionBar);

    var _this = PageActionBar__possibleConstructorReturn(this, (PageActionBar.__proto__ || Object.getPrototypeOf(PageActionBar)).call(this, props));

    Object.defineProperty(_this, 'componentDidMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return window.addEventListener('scroll', _this.toggleScrollStatus, false);
      }
    });
    Object.defineProperty(_this, 'componentWillUnmount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return window.removeEventListener('scroll', _this.toggleScrollStatus, false);
      }
    });
    Object.defineProperty(_this, 'onSearch', {
      enumerable: true,
      writable: true,
      value: function value() {
        var onSearch = _this.props.onSearch;

        if (onSearch) onSearch.apply(undefined, arguments);
      }
    });
    Object.defineProperty(_this, 'toggleScrollStatus', {
      enumerable: true,
      writable: true,
      value: function value() {
        return window.pageYOffset > 0 ? _this.setState({ scrolling: true }) : _this.setState({ scrolling: false });
      }
    });
    Object.defineProperty(_this, 'renderFilterBtn', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            showFiltersBtn = _this$props.showFiltersBtn,
            toggleFilters = _this$props.toggleFilters,
            userRestrictedFilters = _this$props.userRestrictedFilters;

        return showFiltersBtn && !userRestrictedFilters ? react_default.a.createElement(components_PageActionButton, {
          actionText: 'Filter',
          actionIcon: 'filter_list',
          action: toggleFilters,
          actionColor: 'orange'
        }) : null;
      }
    });
    Object.defineProperty(_this, 'renderActions', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props2 = _this.props,
            role = _this$props2.role,
            resource = _this$props2.resource,
            hidesAddOnMobile = _this$props2.hidesAddOnMobile,
            showAdd = _this$props2.showAdd,
            addAction = _this$props2.addAction,
            _this$props2$user = _this$props2.user,
            _this$props2$user$pos = _this$props2$user.position,
            position = _this$props2$user$pos === undefined ? '' : _this$props2$user$pos,
            _this$props2$user$nam = _this$props2$user.name,
            name = _this$props2$user$nam === undefined ? '' : _this$props2$user$nam;

        if (!showAdd) return null;
        var CUT = hidesAddOnMobile ? constants["y" /* CUT_POINT */] : 0;
        return Object(services["a" /* can */])(role, 'create', resource, { position: position, name: name }) ? react_default.a.createElement(
          react_responsive_default.a,
          { minWidth: CUT },
          react_default.a.createElement(components_PageActionButton, {
            actionText: 'Add',
            actionIcon: 'add',
            action: addAction,
            actionColor: 'blue'
          })
        ) : null;
      }
    });
    Object.defineProperty(_this, 'renderSearchBox', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props3 = _this.props,
            searchText = _this$props3.searchText,
            searchValue = _this$props3.searchValue,
            parentComponent = _this$props3.parentComponent,
            employableType = _this$props3.employableType;

        if (parentComponent === 'Workrooms' && ['Estimator', 'Installer', 'Crew'].includes(employableType)) return null;
        return searchText ? react_default.a.createElement(SearchBox, {
          placeholder: searchText,
          onSubmit: _this.onSearch,
          value: searchValue
        }) : null;
      }
    });
    Object.defineProperty(_this, 'renderChildren', {
      enumerable: true,
      writable: true,
      value: function value(children, path) {
        if (children) return children;
        var subPath = path.match(/(?:employees|estimators|iqms|installers)(.+)/g);
        return !(subPath && subPath.length && subPath[0].includes('/')) ? react_default.a.createElement(
          react["Fragment"],
          null,
          react_default.a.createElement(
            'div',
            { className: pageActionBar_default.a.middle },
            _this.renderSearchBox()
          ),
          _this.renderActions()
        ) : null;
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props4 = _this.props,
            title = _this$props4.title,
            banner = _this$props4.banner,
            subTitle = _this$props4.subTitle,
            _this$props4$children = _this$props4.children,
            children = _this$props4$children === undefined ? null : _this$props4$children,
            _this$props4$path = _this$props4.path,
            path = _this$props4$path === undefined ? '' : _this$props4$path;

        return react_default.a.createElement(
          'div',
          {
            className: classnames_default()(pageActionBar_default.a.pageActionBarContainer, PageActionBar__defineProperty({}, pageActionBar_default.a.scrolling, _this.state.scrolling))
          },
          react_default.a.createElement(Helmet_default.a, { title: title }),
          _this.renderFilterBtn(),
          react_default.a.createElement(
            'div',
            { className: pageActionBar_default.a.title },
            react_default.a.createElement(
              'div',
              null,
              title,
              ' ',
              react_default.a.createElement(
                'span',
                { className: pageActionBar_default.a.banner },
                banner
              ),
              react_default.a.createElement(
                'div',
                { className: pageActionBar_default.a.subTitle },
                subTitle
              )
            )
          ),
          _this.renderChildren(children, path)
        );
      }
    });

    _this.state = { scrolling: false };
    _this.toggleScrollStatus = _this.toggleScrollStatus.bind(_this);
    return _this;
  }

  return PageActionBar;
}(react_default.a.Component);

PageActionBar_PageActionBar.propTypes = {
  role: prop_types_default.a.string,
  showFiltersBtn: prop_types_default.a.bool,
  userRestrictedFilters: prop_types_default.a.bool,
  toggleFilters: prop_types_default.a.func,
  resource: prop_types_default.a.string,
  showAdd: prop_types_default.a.bool,
  hidesAddOnMobile: prop_types_default.a.bool,
  title: prop_types_default.a.string,
  subTitle: prop_types_default.a.string,
  banner: prop_types_default.a.string,
  searchText: prop_types_default.a.string,
  searchValue: prop_types_default.a.string,
  addAction: prop_types_default.a.oneOfType([prop_types_default.a.func, prop_types_default.a.string]),
  onSearch: prop_types_default.a.func,
  children: prop_types_default.a.node,
  user: prop_types_default.a.object,
  path: prop_types_default.a.string,
  parentComponent: prop_types_default.a.string,
  employableType: prop_types_default.a.string
};

PageActionBar_PageActionBar.defaultProps = {
  showAdd: true,
  hidesAddOnMobile: false,
  showFiltersBtn: true,
  userRestrictedFilters: false,
  searchText: null,
  user: {},
  path: '',
  parentComponent: '',
  employableType: ''
};

/* harmony default export */ var components_PageActionBar = (PageActionBar_PageActionBar);
// EXTERNAL MODULE: ./client/app/shared/components/Filters/styles.scss
var Filters_styles = __webpack_require__("hG6Q");
var Filters_styles_default = /*#__PURE__*/__webpack_require__.n(Filters_styles);

// EXTERNAL MODULE: ./node_modules/reselect/lib/index.js
var reselect_lib = __webpack_require__("bndy");
var reselect_lib_default = /*#__PURE__*/__webpack_require__.n(reselect_lib);

// EXTERNAL MODULE: ./node_modules/react-select/lib/Select.js
var Select = __webpack_require__("famw");
var Select_default = /*#__PURE__*/__webpack_require__.n(Select);

// EXTERNAL MODULE: ./client/app/shared/components/StyledSelect/react-select-styles.scss
var react_select_styles = __webpack_require__("Cgcc");
var react_select_styles_default = /*#__PURE__*/__webpack_require__.n(react_select_styles);

// CONCATENATED MODULE: ./client/app/shared/components/StyledSelect/react_select.jsx
var react_select__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function react_select__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function react_select__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







var react_select_StyledSelect = function StyledSelect(props) {
  var _cx, _cx2, _cx3, _cx4;

  var className = props.className,
      required = props.required,
      error = props.error,
      resetValue = props.resetValue,
      _props$label = props.label,
      label = _props$label === undefined ? '' : _props$label,
      _props$matchProp = props.matchProp,
      matchProp = _props$matchProp === undefined ? 'label' : _props$matchProp,
      otherProps = react_select__objectWithoutProperties(props, ['className', 'required', 'error', 'resetValue', 'label', 'matchProp']);

  var resetValueSelect = resetValue || (otherProps.multi ? [] : '');
  var requiredText = required ? ' *' : '';
  var errorText = error || '';
  var classNames = classnames_default()((_cx = {}, react_select__defineProperty(_cx, react_select_styles_default.a.dropDownWrapper, true), react_select__defineProperty(_cx, className, className), _cx));
  var labelClassNames = classnames_default()((_cx2 = {}, react_select__defineProperty(_cx2, react_select_styles_default.a.dropDownLabel, true), react_select__defineProperty(_cx2, react_select_styles_default.a.errorText, errorText), _cx2));
  var dropDownClassNames = classnames_default()((_cx3 = {}, react_select__defineProperty(_cx3, react_select_styles_default.a.prettyDropDown, true), react_select__defineProperty(_cx3, react_select_styles_default.a.errored, errorText), react_select__defineProperty(_cx3, react_select_styles_default.a.empty, props.value === ''), _cx3));
  var errorMessageClassNames = classnames_default()((_cx4 = {}, react_select__defineProperty(_cx4, react_select_styles_default.a.errorText, errorText), react_select__defineProperty(_cx4, react_select_styles_default.a.errorMessage, errorText), _cx4));
  return react_default.a.createElement(
    'div',
    { className: classNames },
    react_default.a.createElement(
      'label',
      { htmlFor: 'select', className: labelClassNames },
      label,
      requiredText
    ),
    react_default.a.createElement(Select_default.a, react_select__extends({
      matchProp: matchProp
    }, otherProps, {
      resetValue: resetValueSelect,
      className: dropDownClassNames
    })),
    react_default.a.createElement(
      'span',
      { className: errorMessageClassNames },
      errorText
    )
  );
};

react_select_StyledSelect.defaultProps = { clearable: true };

react_select_StyledSelect.propTypes = {
  className: prop_types_default.a.string,
  required: prop_types_default.a.bool,
  value: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number, prop_types_default.a.bool, prop_types_default.a.array]),
  error: prop_types_default.a.string,
  label: prop_types_default.a.string,
  matchProp: prop_types_default.a.string,
  resetValue: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.array, prop_types_default.a.string]),
  isClearable: prop_types_default.a.bool
};

/* harmony default export */ var react_select = (react_select_StyledSelect);
// EXTERNAL MODULE: ./client/app/shared/components/ReactSelect/styles.scss
var ReactSelect_styles = __webpack_require__("IMTd");
var ReactSelect_styles_default = /*#__PURE__*/__webpack_require__.n(ReactSelect_styles);

// CONCATENATED MODULE: ./client/app/shared/components/formElements/WorkroomSelect/index.jsx
var WorkroomSelect__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function WorkroomSelect__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function WorkroomSelect__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function WorkroomSelect__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function WorkroomSelect__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint no-unused-vars: ["error", { "ignoreRestSiblings": true }] */












var WorkroomSelect_WorkroomSelect = function (_Component) {
  WorkroomSelect__inherits(WorkroomSelect, _Component);

  function WorkroomSelect() {
    var _ref;

    var _temp, _this, _ret;

    WorkroomSelect__classCallCheck(this, WorkroomSelect);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = WorkroomSelect__possibleConstructorReturn(this, (_ref = WorkroomSelect.__proto__ || Object.getPrototypeOf(WorkroomSelect)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'componentDidMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        if (!_this.props.loaded) _this.props.requestWorkroomList();
      }
    }), Object.defineProperty(_this, 'getOptions', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            options = _this$props.options,
            _this$props$value = _this$props.value,
            value = _this$props$value === undefined ? [] : _this$props$value,
            oneRequired = _this$props.oneRequired;

        if (oneRequired && value.length === 1) {
          return _this.props.options.map(function (o) {
            return WorkroomSelect__extends({}, o, { clearableValue: o.value !== value[0]
            });
          });
        }
        return options;
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props2 = _this.props,
            className = _this$props2.className,
            loaded = _this$props2.loaded,
            oneRequired = _this$props2.oneRequired,
            multi = _this$props2.multi,
            props = WorkroomSelect__objectWithoutProperties(_this$props2, ['className', 'loaded', 'oneRequired', 'multi']);

        return react_default.a.createElement(react_select, WorkroomSelect__extends({}, props, {
          multi: true,
          resetValue: [],
          name: 'workroom',
          className: classnames_default()(ReactSelect_styles_default.a, className),
          label: multi ? 'Workrooms' : 'Workroom',
          placeholder: 'All Workrooms',
          options: _this.getOptions(),
          clearable: !oneRequired
        }));
      }
    }), _temp), WorkroomSelect__possibleConstructorReturn(_this, _ret);
  }

  return WorkroomSelect;
}(react["Component"]);

WorkroomSelect_WorkroomSelect.defaultProps = {
  oneRequired: false,
  multi: true
};

WorkroomSelect_WorkroomSelect.propTypes = {
  options: prop_types_default.a.arrayOf(prop_types_default.a.shape({
    label: prop_types_default.a.string,
    value: prop_types_default.a.number
  })).isRequired,
  value: prop_types_default.a.oneOfType([prop_types_default.a.arrayOf(prop_types_default.a.number), prop_types_default.a.number, prop_types_default.a.array]),
  className: prop_types_default.a.string,
  loaded: prop_types_default.a.bool.isRequired,
  requestWorkroomList: prop_types_default.a.func.isRequired,
  oneRequired: prop_types_default.a.bool,
  multi: prop_types_default.a.bool
};

var getWorkroomOptions = Object(reselect_lib["createSelector"])(reducers["_37" /* getWorkroomList */], function (workrooms) {
  return Object(utils["j" /* generateSource */])(workrooms);
});

/* harmony default export */ var formElements_WorkroomSelect = (Object(react_redux_es["connect"])(function (state) {
  return {
    loaded: Object(reducers["_38" /* getWorkroomLoaded */])(state),
    options: getWorkroomOptions(state)
  };
}, { requestWorkroomList: actionCreators["_31" /* requestWorkroomList */] })(WorkroomSelect_WorkroomSelect));
// EXTERNAL MODULE: ./client/app/shared/components/ColoredButton/index.jsx
var ColoredButton = __webpack_require__("EHD2");

// EXTERNAL MODULE: ./client/app/shared/components/FiltersDrawer/filtersDrawer.scss
var filtersDrawer = __webpack_require__("QSmI");
var filtersDrawer_default = /*#__PURE__*/__webpack_require__.n(filtersDrawer);

// EXTERNAL MODULE: ./client/app/shared/styles/checkbox.scss
var styles_checkbox = __webpack_require__("C7qr");
var checkbox_default = /*#__PURE__*/__webpack_require__.n(styles_checkbox);

// CONCATENATED MODULE: ./client/app/shared/components/FiltersDrawer/index.jsx
var FiltersDrawer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };










var DEFAULT_THEME = {
  RTDrawer: filtersDrawer_default.a,
  RTList: filtersDrawer_default.a,
  RTOverlay: filtersDrawer_default.a,
  RTCheckbox: checkbox_default.a
};

var FiltersDrawer_FiltersDrawer = function FiltersDrawer(_ref) {
  var theme = _ref.theme,
      title = _ref.title,
      toggle = _ref.toggle,
      active = _ref.active,
      children = _ref.children,
      reset = _ref.reset,
      className = _ref.className;
  return react_default.a.createElement(
    react_css_themr_lib["ThemeProvider"],
    { theme: FiltersDrawer__extends({}, DEFAULT_THEME, theme) },
    react_default.a.createElement(
      react_toolbox_lib["Drawer"],
      {
        active: active,
        onOverlayClick: toggle,
        className: filtersDrawer_default.a.drawer + ' ' + className
      },
      react_default.a.createElement(react_toolbox_lib["FontIcon"], { value: 'close', className: filtersDrawer_default.a.close_icon, onClick: toggle }),
      react_default.a.createElement(
        'ul',
        { className: filtersDrawer_default.a.filtersList },
        react_default.a.createElement(
          'h5',
          { className: filtersDrawer_default.a.header },
          'Filter ',
          title
        ),
        !Object(lodash["isArray"])(children) && react_default.a.createElement(
          'li',
          { key: 'filter-item-' + children.key },
          children
        ),
        // filter because sometimes child is false
        Object(lodash["isArray"])(children) && children.filter(function (child) {
          return child;
        }).map(function (child) {
          return react_default.a.createElement(
            'li',
            { key: 'filter-item-' + child.key },
            child
          );
        }),
        reset && react_default.a.createElement(
          'li',
          null,
          react_default.a.createElement(ColoredButton["a" /* default */], {
            className: filtersDrawer_default.a.button,
            label: 'Reset filter',
            onClick: reset,
            color: 'red'
          })
        )
      )
    )
  );
};

FiltersDrawer_FiltersDrawer.defaultProps = {
  theme: {}
};

FiltersDrawer_FiltersDrawer.propTypes = {
  children: prop_types_default.a.node,
  theme: prop_types_default.a.object,
  toggle: prop_types_default.a.func.isRequired,
  active: prop_types_default.a.bool.isRequired,
  title: prop_types_default.a.string.isRequired,
  reset: prop_types_default.a.func,
  className: prop_types_default.a.string
};

/* harmony default export */ var components_FiltersDrawer = (FiltersDrawer_FiltersDrawer);
// CONCATENATED MODULE: ./client/app/shared/components/formElements/RoleSelect/index.jsx
var RoleSelect__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function RoleSelect__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/* eslint no-unused-vars: ["error", { "ignoreRestSiblings": true }] */







var RoleSelect_RoleSelect = function RoleSelect(_ref) {
  var className = _ref.className,
      props = RoleSelect__objectWithoutProperties(_ref, ['className']);

  return react_default.a.createElement(react_select, RoleSelect__extends({
    name: 'role',
    className: classnames_default()(ReactSelect_styles_default.a, className),
    label: 'Roles',
    options: constants["J" /* EMPLOYEE_ROLES */]
  }, props));
};

RoleSelect_RoleSelect.defaultProps = {
  resetValue: '',
  placeholder: 'Select A Role'
};

RoleSelect_RoleSelect.propTypes = {
  value: prop_types_default.a.oneOfType([prop_types_default.a.arrayOf(prop_types_default.a.string), prop_types_default.a.string]),
  className: prop_types_default.a.string,
  multi: prop_types_default.a.bool,
  resetValue: prop_types_default.a.oneOfType([prop_types_default.a.array, prop_types_default.a.string]),
  placeholder: prop_types_default.a.string
};

/* harmony default export */ var formElements_RoleSelect = (RoleSelect_RoleSelect);
// CONCATENATED MODULE: ./client/app/shared/components/formElements/ActiveSelect/index.jsx
var ActiveSelect__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var ActiveSelect__this = this;

function ActiveSelect__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







var ACTIVE_OPTIONS = [{ value: null, label: 'All' }, { value: true, label: 'Active' }, { value: false, label: 'Inactive' }];

var ActiveSelect_ActiveSelect = function ActiveSelect(_ref) {
  var className = _ref.className,
      props = ActiveSelect__objectWithoutProperties(_ref, ['className']);

  return react_default.a.createElement(react_select, ActiveSelect__extends({
    className: classnames_default()(ReactSelect_styles_default.a, className),
    label: 'Active Status',
    name: 'active',
    placeholder: 'Show All',
    options: ACTIVE_OPTIONS,
    onChange: ActiveSelect__this.handleActive,
    simpleValue: true
  }, props));
};

ActiveSelect_ActiveSelect.propTypes = {
  value: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.bool]).isRequired,
  className: prop_types_default.a.string
};

/* harmony default export */ var formElements_ActiveSelect = (ActiveSelect_ActiveSelect);
// CONCATENATED MODULE: ./client/app/shared/components/Filters/UserFilters/index.jsx
var UserFilters__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var UserFilters__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function UserFilters__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function UserFilters__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function UserFilters__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var PENDING_OPTIONS = [{ value: null, label: 'All' }, { value: false, label: 'Confirmed' }, { value: true, label: 'Pending' }];

var UserFilters_UserFilters = function (_Component) {
  UserFilters__inherits(UserFilters, _Component);

  function UserFilters() {
    var _ref;

    var _temp, _this, _ret;

    UserFilters__classCallCheck(this, UserFilters);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = UserFilters__possibleConstructorReturn(this, (_ref = UserFilters.__proto__ || Object.getPrototypeOf(UserFilters)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'handleFilter', {
      enumerable: true,
      writable: true,
      value: function value(key, _value) {
        var filters = UserFilters__extends({}, _this.props.filters);
        filters[key] = _value;

        _this.props.handleFilterChange(filters);
      }
    }), Object.defineProperty(_this, 'handleActive', {
      enumerable: true,
      writable: true,
      value: function value(_value2) {
        return _this.handleFilter('is_active', _value2);
      }
    }), Object.defineProperty(_this, 'handlePending', {
      enumerable: true,
      writable: true,
      value: function value(_value3) {
        return _this.handleFilter('is_pending', _value3);
      }
    }), Object.defineProperty(_this, 'handleWorkrooms', {
      enumerable: true,
      writable: true,
      value: function value(values) {
        return _this.handleFilter('for_workrooms', values.map(function (v) {
          return v.value;
        }));
      }
    }), Object.defineProperty(_this, 'handleRoles', {
      enumerable: true,
      writable: true,
      value: function value(values) {
        return _this.handleFilter('for_roles', values.map(function (v) {
          return v.value;
        }));
      }
    }), _temp), UserFilters__possibleConstructorReturn(_this, _ret);
  }

  UserFilters__createClass(UserFilters, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          filters = _props.filters,
          active = _props.active,
          title = _props.title,
          reset = _props.reset,
          showRoles = _props.showRoles,
          resource = _props.resource;

      var canViewInactive = Object(services["a" /* can */])(this.props.role, 'view_inactive', resource);
      return react_default.a.createElement(
        components_FiltersDrawer,
        {
          title: title,
          active: active,
          toggle: this.props.onOverlayClick,
          reset: reset
        },
        react_default.a.createElement(formElements_WorkroomSelect, {
          value: filters.for_workrooms,
          onChange: this.handleWorkrooms,
          className: Filters_styles_default.a.dropdown,
          key: 'workroom'
        }),
        showRoles && react_default.a.createElement(formElements_RoleSelect, {
          key: 'role',
          className: Filters_styles_default.a.dropdown,
          onChange: this.handleRoles,
          value: filters.for_roles,
          resetValue: [],
          placeholder: 'All Roles',
          multi: true
        }),
        canViewInactive && react_default.a.createElement(formElements_ActiveSelect, {
          key: 'active',
          className: Filters_styles_default.a.dropdown,
          value: filters.is_active,
          onChange: this.handleActive
        }),
        react_default.a.createElement(react_select, {
          key: 'pending',
          className: Filters_styles_default.a.dropdown,
          label: 'Pending Status',
          name: 'pending',
          placeholder: 'Show All',
          options: PENDING_OPTIONS,
          value: filters.is_pending,
          onChange: this.handlePending,
          simpleValue: true
        })
      );
    }
  }]);

  return UserFilters;
}(react["Component"]);

UserFilters_UserFilters.defaultProps = {
  showRoles: false
};

UserFilters_UserFilters.propTypes = {
  handleFilterChange: prop_types_default.a.func,
  onOverlayClick: prop_types_default.a.func,
  filters: prop_types_default.a.object,
  active: prop_types_default.a.bool,
  title: prop_types_default.a.string.isRequired,
  reset: prop_types_default.a.func.isRequired,
  showRoles: prop_types_default.a.bool,
  role: prop_types_default.a.string.isRequired,
  resource: prop_types_default.a.string.isRequired
};

/* harmony default export */ var Filters_UserFilters = (UserFilters_UserFilters);
// CONCATENATED MODULE: ./client/app/utils/permissionUtils.js


var permissionByWorkroomId = function permissionByWorkroomId(role, workrooms) {
  var employee = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var employeeWorkrooms = employee && employee.workrooms || [];
  if (role !== 'workroom' || employeeWorkrooms.length && workrooms.some(function (i) {
    return employeeWorkrooms.some(function (x) {
      return x.id === i.id;
    });
  })) return true;
  return false;
};

var permissionUtils_permissionByWorkroomName = function permissionByWorkroomName(role, workrooms, employeeWorkrooms) {
  if (constants["Q" /* INSTALLER_UNRESTRICTED_ROLES */].includes(role)) return true;
  var employeeWorkroomNames = [];
  if (employeeWorkrooms && employeeWorkrooms.length > 0) {
    employeeWorkrooms.forEach(function (w) {
      return employeeWorkroomNames.push(w.name);
    });
  }
  return employeeWorkroomNames.length > 0 && employeeWorkroomNames.some(function (w) {
    return workrooms.includes(w);
  });
};
// EXTERNAL MODULE: ./client/app/shared/components/Card/styles.scss
var Card_styles = __webpack_require__("un+S");
var Card_styles_default = /*#__PURE__*/__webpack_require__.n(Card_styles);

// CONCATENATED MODULE: ./client/app/shared/components/Card/index.jsx
var Card__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function Card__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function Card__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var Card_Card = function Card(props) {
  var _cx;

  var theme = props.theme,
      altColor = props.altColor,
      inactive = props.inactive,
      className = props.className,
      children = props.children,
      otherprops = Card__objectWithoutProperties(props, ['theme', 'altColor', 'inactive', 'className', 'children']);

  var cardStyles = classnames_default()((_cx = {}, Card__defineProperty(_cx, theme.card, true), Card__defineProperty(_cx, theme.inactive, inactive), Card__defineProperty(_cx, theme.altColor, altColor), Card__defineProperty(_cx, props.className, className), _cx));

  return react_default.a.createElement(
    'div',
    Card__extends({ className: cardStyles }, otherprops),
    children
  );
};

Card_Card.propTypes = {
  className: prop_types_default.a.string,
  altColor: prop_types_default.a.bool,
  inactive: prop_types_default.a.bool,
  theme: prop_types_default.a.shape({
    card: prop_types_default.a.string,
    inactive: prop_types_default.a.string,
    altColor: prop_types_default.a.string
  }),
  children: prop_types_default.a.node
};

/* harmony default export */ var components_Card = (Object(react_css_themr_lib["themr"])('Card', Card_styles_default.a)(Card_Card));
// EXTERNAL MODULE: ./client/app/shared/components/ResourceCardElements/resourceCardElement.scss
var resourceCardElement = __webpack_require__("xY9K");
var resourceCardElement_default = /*#__PURE__*/__webpack_require__.n(resourceCardElement);

// EXTERNAL MODULE: ./client/app/shared/components/ResourceCardElements/resourceDetailsCardElement.scss
var resourceDetailsCardElement = __webpack_require__("v6Iw");
var resourceDetailsCardElement_default = /*#__PURE__*/__webpack_require__.n(resourceDetailsCardElement);

// CONCATENATED MODULE: ./client/app/shared/components/ResourceCardElements/index.jsx
function ResourceCardElements__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var ResourceCardElements_ResourceCardElementBase = function ResourceCardElementBase(props) {
  var _cx;

  var children = props.children,
      className = props.className,
      size = props.size,
      title = props.title,
      value = props.value,
      theme = props.theme,
      wrap = props.wrap,
      isValueOptional = props.isValueOptional,
      columns = props.columns,
      halfMobile = props.halfMobile,
      noMarginTitle = props.noMarginTitle,
      noFlexMobile = props.noFlexMobile,
      _props$phaseType = props.phaseType,
      phaseType = _props$phaseType === undefined ? '' : _props$phaseType;

  var columnConfig = columns && columns.split(' ');
  var desktop = columnConfig && columnConfig.find(function (c) {
    return c.startsWith('desktop');
  });
  var mobile = columnConfig && columnConfig.find(function (c) {
    return c.startsWith('mobile');
  });

  if (isValueOptional && !value) return null;

  var getValueTheme = function getValueTheme() {
    var klass = '';
    switch (phaseType) {
      case 'Installation':
        klass = 'installValue';
        break;
      case 'Workorder':
        klass = 'workorderValue';
        break;
      case 'Assessment':
        klass = 'assessmentValue';
        break;
      default:
        klass = 'resourceCardElementValue';
    }
    return klass;
  };

  var styleClass = classnames_default()((_cx = {}, ResourceCardElements__defineProperty(_cx, theme.resourceCardElement, true), ResourceCardElements__defineProperty(_cx, theme.wrap, wrap), ResourceCardElements__defineProperty(_cx, theme.halfMobileBasic, phaseType || false), ResourceCardElements__defineProperty(_cx, theme.halfMobile, !phaseType && halfMobile !== undefined), ResourceCardElements__defineProperty(_cx, theme[size], size !== undefined), ResourceCardElements__defineProperty(_cx, theme[desktop], desktop !== undefined), ResourceCardElements__defineProperty(_cx, theme[mobile], mobile !== undefined), ResourceCardElements__defineProperty(_cx, theme.noFlexMobile, noFlexMobile), ResourceCardElements__defineProperty(_cx, className, !!className), _cx));

  var titleClass = classnames_default()(theme.resourceCardElementTitle, ResourceCardElements__defineProperty({}, theme.noMarginTitle, noMarginTitle !== undefined));

  var titleElement = title ? react_default.a.createElement(
    'span',
    { className: titleClass },
    title
  ) : null;

  // Always prefer children over value, because value could be passed to flag an optional property
  var valueHtml = void 0;
  if (children) valueHtml = children;else {
    valueHtml = react_default.a.createElement(
      'span',
      { className: theme[getValueTheme()] },
      Array.isArray(value) ? String(value) : value
    );
  }

  return react_default.a.createElement(
    'div',
    { className: styleClass },
    titleElement,
    valueHtml
  );
};

ResourceCardElements_ResourceCardElementBase.propTypes = {
  children: prop_types_default.a.node,
  className: prop_types_default.a.string,
  size: prop_types_default.a.string,
  title: prop_types_default.a.string,
  value: prop_types_default.a.node,
  theme: prop_types_default.a.object,
  isValueOptional: prop_types_default.a.bool,
  noFlexMobile: prop_types_default.a.bool,
  columns: prop_types_default.a.string,
  wrap: prop_types_default.a.bool,
  halfMobile: prop_types_default.a.bool,
  noMarginTitle: prop_types_default.a.bool,
  phaseType: prop_types_default.a.string
};

var ResourceCardElement = Object(react_css_themr_lib["themr"])('ResourceCE', resourceCardElement_default.a)(ResourceCardElements_ResourceCardElementBase);
var ResourceDetailsCardElement = Object(react_css_themr_lib["themr"])('ResourceDetailsCE', resourceDetailsCardElement_default.a)(ResourceCardElement);
// EXTERNAL MODULE: ./client/app/shared/styles/resourceCard.scss
var resourceCard = __webpack_require__("RM3C");
var resourceCard_default = /*#__PURE__*/__webpack_require__.n(resourceCard);

// CONCATENATED MODULE: ./client/app/shared/components/users/UserCard/index.jsx
function UserCard__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }











var UserCard_UserCard = function UserCard(_ref) {
  var _cx;

  var user = _ref.user,
      type = _ref.type,
      children = _ref.children,
      showEmployableType = _ref.showEmployableType,
      role = _ref.role,
      workrooms = _ref.workrooms,
      clickable = _ref.clickable;

  var canViewContactInfo = function canViewContactInfo() {
    return type !== 'installers' || permissionUtils_permissionByWorkroomName(role, user.perms_workrooms, workrooms);
  };
  var cardClasses = classnames_default()((_cx = {}, UserCard__defineProperty(_cx, resourceCard_default.a.inactive, !user.active || !canViewContactInfo()), UserCard__defineProperty(_cx, resourceCard_default.a.resourceCard, true), _cx));
  var cardContent = react_default.a.createElement(
    components_Card,
    { key: user.id, className: cardClasses, inactive: !user.active },
    showEmployableType && react_default.a.createElement(
      ResourceCardElement,
      { title: 'Type', size: 'medium' },
      user.employable_type,
      user.position && react_default.a.createElement(
        'small',
        null,
        react_default.a.createElement('br', null),
        user.position
      )
    ),
    react_default.a.createElement(
      ResourceCardElement,
      { title: 'Name', size: 'medium' },
      user.name,
      user.pending && react_default.a.createElement(
        'small',
        null,
        react_default.a.createElement('br', null),
        '[Account Pending]'
      )
    ),
    children,
    react_default.a.createElement(
      ResourceCardElement,
      { title: 'Primary Phone', size: 'medium' },
      user.primary_phone ? Object(utils["h" /* formatTelephone */])(user.primary_phone) : 'N/A',
      react_default.a.createElement(
        'span',
        { className: resourceCard_default.a.phoneType },
        '(',
        user.primary_phone_type,
        ')'
      )
    ),
    react_default.a.createElement(ResourceCardElement, { title: 'Email', size: 'large', value: user.email })
  );
  if (!canViewContactInfo()) {
    return react_default.a.createElement(
      components_Card,
      {
        key: user.id,
        className: cardClasses,
        inactive: !user.active || !canViewContactInfo()
      },
      react_default.a.createElement(
        ResourceCardElement,
        { title: 'Unavailable', size: 'medium' },
        'Installer ',
        user.id,
        ' unavailable due to workroom restrictions'
      )
    );
  }
  return clickable ? react_default.a.createElement(
    es["c" /* Link */],
    { className: resourceCard_default.a.viewLink, to: '/' + type + '/' + user.id },
    cardContent
  ) : cardContent;
};

UserCard_UserCard.defaultProps = { role: '', workrooms: [], clickable: true };

UserCard_UserCard.propTypes = {
  user: prop_types_default.a.shape({
    id: prop_types_default.a.number.isRequired,
    active: prop_types_default.a.bool.isRequired,
    pending: prop_types_default.a.bool.isRequired,
    email: prop_types_default.a.string.isRequired,
    primary_phone: prop_types_default.a.string,
    primary_phone_type: prop_types_default.a.string,
    employable_type: prop_types_default.a.string,
    position: prop_types_default.a.string
  }).isRequired,
  children: prop_types_default.a.node,
  type: prop_types_default.a.string.isRequired,
  showEmployableType: prop_types_default.a.bool,
  role: prop_types_default.a.string,
  workrooms: prop_types_default.a.array,
  clickable: prop_types_default.a.bool
};

/* harmony default export */ var users_UserCard = (UserCard_UserCard);
// CONCATENATED MODULE: ./client/app/shared/types/employee.js


var EmployeeType = prop_types_default.a.shape({
  id: prop_types_default.a.number.isRequired,
  email: prop_types_default.a.string.isRequired,
  name: prop_types_default.a.string.isRequired,
  picture_url: prop_types_default.a.string,
  position: prop_types_default.a.string,
  primary_phone: prop_types_default.a.string,
  primary_phone_type: prop_types_default.a.string,
  role: prop_types_default.a.string.isRequired,
  active: prop_types_default.a.bool.isRequired,
  pending: prop_types_default.a.bool,
  workrooms: prop_types_default.a.arrayOf(prop_types_default.a.shape({
    id: prop_types_default.a.number,
    name: prop_types_default.a.string
  })).isRequired,
  assignable: prop_types_default.a.bool.isRequired
});

/* harmony default export */ var types_employee = (EmployeeType);
// CONCATENATED MODULE: ./client/app/screens/main/screens/employees/components/employeeCard.jsx






var employeeCard_EmployeeCard = function EmployeeCard(_ref) {
  var employee = _ref.employee;
  return react_default.a.createElement(
    users_UserCard,
    { user: employee, type: 'employees' },
    react_default.a.createElement(ResourceCardElement, {
      title: 'Workroom(s)',
      size: 'small',
      value: Object(utils["A" /* stringifyList */])(employee.workrooms) || 'No Workroom'
    }),
    react_default.a.createElement(ResourceCardElement, {
      title: 'Position',
      size: 'medium',
      value: employee.position || 'No Position'
    })
  );
};

employeeCard_EmployeeCard.propTypes = {
  employee: types_employee.isRequired
};

/* harmony default export */ var employeeCard = (employeeCard_EmployeeCard);
// EXTERNAL MODULE: ./client/app/shared/components/MessageBox/index.jsx
var MessageBox = __webpack_require__("nYV9");

// EXTERNAL MODULE: ./node_modules/react-infinite/build/react-infinite.js
var react_infinite = __webpack_require__("KATD");
var react_infinite_default = /*#__PURE__*/__webpack_require__.n(react_infinite);

// CONCATENATED MODULE: ./client/app/shared/components/ListView/index.jsx







var ListView_ListView = function ListView(_ref) {
  var children = _ref.children,
      loading = _ref.loading,
      needsMore = _ref.needsMore,
      handleInfiniteLoad = _ref.handleInfiniteLoad;
  return react_default.a.createElement(
    'div',
    null,
    react_default.a.createElement(
      react_responsive_default.a,
      { minWidth: constants["y" /* CUT_POINT */] },
      !loading && children.length === 0 && 'Your search yielded no results.',
      react_default.a.createElement(
        react_infinite_default.a,
        {
          useWindowAsScrollContainer: true,
          elementHeight: 80,
          infiniteLoadBeginEdgeOffset: 0,
          onInfiniteLoad: handleInfiniteLoad,
          isInfiniteLoading: loading
        },
        children
      )
    ),
    react_default.a.createElement(
      react_responsive_default.a,
      { maxWidth: constants["y" /* CUT_POINT */] - 1 },
      react_default.a.createElement(
        react_infinite_default.a,
        {
          useWindowAsScrollContainer: true,
          elementHeight: 400,
          infiniteLoadBeginEdgeOffset: 0,
          onInfiniteLoad: handleInfiniteLoad,
          isInfiniteLoading: loading
        },
        children
      )
    ),
    needsMore ? react_default.a.createElement(components_Loading, { message: 'Loading additional resources...' }) : null
  );
};

ListView_ListView.propTypes = {
  children: prop_types_default.a.node,
  loading: prop_types_default.a.bool,
  needsMore: prop_types_default.a.bool,
  handleInfiniteLoad: prop_types_default.a.func.isRequired
};

/* harmony default export */ var components_ListView = (ListView_ListView);
// EXTERNAL MODULE: ./node_modules/redux-ui/transpiled/index.js
var transpiled = __webpack_require__("uEc2");
var transpiled_default = /*#__PURE__*/__webpack_require__.n(transpiled);

// CONCATENATED MODULE: ./client/app/screens/main/screens/employees/employeeList.jsx
var employeeList__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function employeeList__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function employeeList__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function employeeList__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var employeeList_EmployeeList = function (_Component) {
  employeeList__inherits(EmployeeList, _Component);

  function EmployeeList() {
    var _ref;

    var _temp, _this, _ret;

    employeeList__classCallCheck(this, EmployeeList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = employeeList__possibleConstructorReturn(this, (_ref = EmployeeList.__proto__ || Object.getPrototypeOf(EmployeeList)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'handleInfiniteLoad', {
      enumerable: true,
      writable: true,
      value: function value() {
        if (_this.props.needsMore) {
          _this.loadEmployees();
        }
      }
    }), _temp), employeeList__possibleConstructorReturn(_this, _ret);
  }

  employeeList__createClass(EmployeeList, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.loadEmployees();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.ui.successMessage) {
        this.props.updateUI('successMessage', '');
      }
    }
  }, {
    key: 'loadEmployees',
    value: function loadEmployees() {
      var dispatch = this.props.dispatch;

      dispatch(Object(actionCreators["Y" /* requestEmployeeList */])());
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          employees = _props.employees,
          needsMore = _props.needsMore,
          loading = _props.loading;


      return react_default.a.createElement(
        'div',
        null,
        this.props.ui.successMessage ? react_default.a.createElement(MessageBox["a" /* default */], { message: this.props.ui.successMessage }) : null,
        react_default.a.createElement(
          components_ListView,
          {
            loading: loading,
            needsMore: needsMore,
            handleInfiniteLoad: this.handleInfiniteLoad
          },
          employees.map(function (employee) {
            return react_default.a.createElement(employeeCard, {
              key: 'employee-' + employee.id,
              employee: employee
            });
          })
        )
      );
    }
  }]);

  return EmployeeList;
}(react["Component"]);

Object.defineProperty(employeeList_EmployeeList, 'propTypes', {
  enumerable: true,
  writable: true,
  value: {
    dispatch: prop_types_default.a.func.isRequired,
    ui: prop_types_default.a.shape({
      successMessage: prop_types_default.a.string
    }),
    updateUI: prop_types_default.a.func.isRequired,
    needsMore: prop_types_default.a.bool,
    loading: prop_types_default.a.bool,
    employees: prop_types_default.a.arrayOf(types_employee).isRequired,
    role: prop_types_default.a.string
  }
});


var employeeList_mapStateToProps = function mapStateToProps(state) {
  return {
    employees: Object(reducers["m" /* getEmployeeList */])(state),
    needsMore: Object(reducers["l" /* getEmployeeHasNextPage */])(state),
    loading: Object(reducers["n" /* getEmployeeLoading */])(state),
    role: Object(reducers["_12" /* getRole */])(state)
  };
};

/* harmony default export */ var employeeList = (transpiled_default()()(Object(react_redux_es["connect"])(employeeList_mapStateToProps)(employeeList_EmployeeList)));
// EXTERNAL MODULE: ./node_modules/flexbox-react/dist/index.js
var flexbox_react_dist = __webpack_require__("Hlul");
var flexbox_react_dist_default = /*#__PURE__*/__webpack_require__.n(flexbox_react_dist);

// EXTERNAL MODULE: ./client/app/shared/components/users/UserDetailsHeader/styles.scss
var UserDetailsHeader_styles = __webpack_require__("gDOu");
var UserDetailsHeader_styles_default = /*#__PURE__*/__webpack_require__.n(UserDetailsHeader_styles);

// EXTERNAL MODULE: ./client/app/shared/components/users/UserDetailsHeader/headerResourceDetailsCard.scss
var headerResourceDetailsCard = __webpack_require__("cjrT");
var headerResourceDetailsCard_default = /*#__PURE__*/__webpack_require__.n(headerResourceDetailsCard);

// CONCATENATED MODULE: ./client/app/shared/types/user.js


var UserType = prop_types_default.a.shape({
  id: prop_types_default.a.number.isRequired,
  email: prop_types_default.a.string.isRequired,
  name: prop_types_default.a.string.isRequired,
  picture_url: prop_types_default.a.string,
  primary_phone: prop_types_default.a.string,
  primary_phone_type: prop_types_default.a.string,
  active: prop_types_default.a.bool,
  pending: prop_types_default.a.bool
});

/* harmony default export */ var types_user = (UserType);

var RoleType = prop_types_default.a.shape({
  id: prop_types_default.a.number.isRequired,
  email: prop_types_default.a.string.isRequired,
  name: prop_types_default.a.string.isRequired
});
// CONCATENATED MODULE: ./client/app/shared/types/workroom.js


var WorkroomType = prop_types_default.a.shape({
  id: prop_types_default.a.number.isRequired,
  name: prop_types_default.a.string.isRequired,
  address: prop_types_default.a.string,
  city: prop_types_default.a.string,
  state: prop_types_default.a.string,
  zip_code: prop_types_default.a.string,
  phone_number: prop_types_default.a.string,
  accounting_id: prop_types_default.a.string.isRequired,
  inventory_id: prop_types_default.a.string.isRequired,
  active: prop_types_default.a.bool.isRequired
});

/* harmony default export */ var types_workroom = (WorkroomType);
// CONCATENATED MODULE: ./client/app/shared/components/users/UserDetailsHeader/index.jsx
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function UserDetailsHeader__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function UserDetailsHeader__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function UserDetailsHeader__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




















var headerResourceDetails = { ResourceDetailsCE: headerResourceDetailsCard_default.a };

var UserDetailsHeader_UserDetailsHeader = function (_Component) {
  UserDetailsHeader__inherits(UserDetailsHeader, _Component);

  function UserDetailsHeader() {
    var _ref;

    var _temp, _this, _ret;

    UserDetailsHeader__classCallCheck(this, UserDetailsHeader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = UserDetailsHeader__possibleConstructorReturn(this, (_ref = UserDetailsHeader.__proto__ || Object.getPrototypeOf(UserDetailsHeader)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'componentWillUnmount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.ui.successMessage ? _this.props.updateUI('successMessage', '') : null;
      }
    }), Object.defineProperty(_this, 'getWorkroomsString', {
      enumerable: true,
      writable: true,
      value: function value(workrooms, userWorkrooms) {
        if (workrooms.length && _this.isObjectArray(workrooms)) return Object(utils["A" /* stringifyList */])(workrooms);
        if (typeof userWorkrooms === 'string') return userWorkrooms;
        return userWorkrooms.length && _this.isObjectArray(userWorkrooms) ? Object(utils["A" /* stringifyList */])(userWorkrooms) : '';
      }
    }), Object.defineProperty(_this, 'isObjectArray', {
      enumerable: true,
      writable: true,
      value: function value() {
        var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return arr.every(function (i) {
          return (typeof i === 'undefined' ? 'undefined' : _typeof(i)) === 'object';
        });
      }
    }), Object.defineProperty(_this, 'resendLink', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        if (e) e.preventDefault();
        _this.props.userResendLink(_this.props.user.user_id).then(_this.props.updateUI('successMessage', 'The confirmation email was resent. This email will expire in 7 days.'));
      }
    }), Object.defineProperty(_this, 'renderEditHandler', {
      enumerable: true,
      writable: true,
      value: function value() {
        var view = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'large';

        if (_this.props.editHandler) return _this.props.editHandler;
        var _this$props = _this.props,
            user = _this$props.user,
            type = _this$props.type;

        var endpoint = '/' + type + '/' + user.id + '/edit';
        return view === 'large' ? react_default.a.createElement(
          components_RouterLink,
          { className: UserDetailsHeader_styles_default.a.userDetailsButton, to: endpoint },
          'Edit'
        ) : react_default.a.createElement(
          components_RouterLink,
          { to: endpoint },
          react_default.a.createElement(react_toolbox_lib["IconButton"], { className: UserDetailsHeader_styles_default.a.userDetailsEdit, icon: 'edit' })
        );
      }
    }), Object.defineProperty(_this, 'renderRightComponent', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props2 = _this.props,
            user = _this$props2.user,
            role = _this$props2.role,
            resource = _this$props2.resource,
            editHandler = _this$props2.editHandler,
            editAction = _this$props2.editAction;

        if (!editHandler && !Object(services["a" /* can */])(role, editAction, resource)) return null;
        return react_default.a.createElement(
          flexbox_react_dist_default.a,
          { alignItems: 'center' },
          react_default.a.createElement(
            react_responsive_default.a,
            { minWidth: constants["y" /* CUT_POINT */], style: { display: 'flex' } },
            user.pending && Object(services["a" /* can */])(role, 'resend', resource) ? react_default.a.createElement(
              flexbox_react_dist_default.a,
              null,
              react_default.a.createElement(
                'button',
                { className: UserDetailsHeader_styles_default.a.userDetailsLink, onClick: _this.resendLink },
                'Resend activation email'
              ),
              react_default.a.createElement('div', { className: UserDetailsHeader_styles_default.a.userDetailsLinkSeparator })
            ) : null,
            react_default.a.createElement(
              flexbox_react_dist_default.a,
              null,
              _this.renderEditHandler()
            )
          ),
          react_default.a.createElement(
            react_responsive_default.a,
            { maxWidth: constants["y" /* CUT_POINT */] - 1 },
            react_default.a.createElement(
              flexbox_react_dist_default.a,
              null,
              _this.renderEditHandler('small')
            )
          )
        );
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props3 = _this.props,
            children = _this$props3.children,
            _this$props3$workroom = _this$props3.workrooms,
            workrooms = _this$props3$workroom === undefined ? [] : _this$props3$workroom,
            role = _this$props3.role,
            _this$props3$user = _this$props3.user,
            active = _this$props3$user.active,
            _this$props3$user$wor = _this$props3$user.workrooms,
            userWorkrooms = _this$props3$user$wor === undefined ? [] : _this$props3$user$wor,
            type = _this$props3$user.type,
            name = _this$props3$user.name,
            assignable = _this$props3$user.assignable,
            _this$props3$user$pos = _this$props3$user.position,
            position = _this$props3$user$pos === undefined ? '' : _this$props3$user$pos,
            id = _this$props3$user.id,
            userRole = _this$props3$user.user;

        var statusText = active ? 'Active' : 'Inactive';
        var roleName = null;
        if (userRole) {
          var roleObj = constants["J" /* EMPLOYEE_ROLES */].find(function (r) {
            return r.value === userRole;
          });
          roleName = roleObj ? roleObj.label : userRole;
        }
        var workroomsString = _this.getWorkroomsString(workrooms, userWorkrooms);
        return react_default.a.createElement(
          flexbox_react_dist_default.a,
          { justifyContent: 'space-between', className: UserDetailsHeader_styles_default.a.userDetailsDivider },
          react_default.a.createElement(
            react_css_themr_lib["ThemeProvider"],
            { theme: headerResourceDetails },
            react_default.a.createElement(
              flexbox_react_dist_default.a,
              null,
              react_default.a.createElement(
                ResourceDetailsCardElement,
                null,
                react_default.a.createElement(
                  'h2',
                  { className: UserDetailsHeader_styles_default.a.userDetailsName },
                  Object(utils["y" /* roleNotInstallerBased */])(role) && (type === 'installer' || type === 'estimator') ? react_default.a.createElement(
                    'span',
                    { className: UserDetailsHeader_styles_default.a.nameOnly },
                    name,
                    ' (',
                    id,
                    ')'
                  ) : react_default.a.createElement(
                    'span',
                    { className: UserDetailsHeader_styles_default.a.nameOnly },
                    name
                  ),
                  roleName && Object(utils["y" /* roleNotInstallerBased */])(role) && react_default.a.createElement(
                    'span',
                    { className: UserDetailsHeader_styles_default.a.userRole },
                    ' (' + roleName + ')'
                  ),
                  ' ',
                  Object(utils["y" /* roleNotInstallerBased */])(role) && react_default.a.createElement(
                    'span',
                    { className: active ? UserDetailsHeader_styles_default.a.activeText : UserDetailsHeader_styles_default.a.inactiveText },
                    type === 'installer' || type === 'estimator' ? statusText : '(' + statusText + ')'
                  ),
                  assignable && Object(utils["y" /* roleNotInstallerBased */])(role) && react_default.a.createElement(
                    'span',
                    { className: UserDetailsHeader_styles_default.a.activeText },
                    ' (Assignable)'
                  )
                ),
                Object(utils["y" /* roleNotInstallerBased */])(role) && react_default.a.createElement(
                  'h3',
                  { className: UserDetailsHeader_styles_default.a.userDetailsPosition },
                  '' + position + (workroomsString.length ? ' in ' : '') + workroomsString
                )
              )
            )
          ),
          children,
          _this.renderRightComponent()
        );
      }
    }), _temp), UserDetailsHeader__possibleConstructorReturn(_this, _ret);
  }

  return UserDetailsHeader;
}(react["Component"]);

UserDetailsHeader_UserDetailsHeader.defaultProps = {
  workrooms: [],
  userResendLink: function userResendLink() {},
  children: null,
  updateUI: function updateUI() {},
  ui: {},
  editHandler: null,
  editAction: 'update'
};

UserDetailsHeader_UserDetailsHeader.propTypes = {
  user: types_user.isRequired,
  workrooms: prop_types_default.a.arrayOf(types_workroom),
  role: prop_types_default.a.string.isRequired,
  editAction: prop_types_default.a.string.isRequired,
  type: prop_types_default.a.string.isRequired,
  resource: prop_types_default.a.string.isRequired,
  userResendLink: prop_types_default.a.func,
  children: prop_types_default.a.node,
  updateUI: prop_types_default.a.func,
  ui: prop_types_default.a.object,
  editHandler: prop_types_default.a.node
};

/* harmony default export */ var users_UserDetailsHeader = (transpiled_default()()(Object(react_redux_es["connect"])(null, { userResendLink: actionCreators["_78" /* userResendLink */] })(UserDetailsHeader_UserDetailsHeader)));
// EXTERNAL MODULE: ./client/app/shared/components/users/UserDetailsCard/userDetailsCard.scss
var userDetailsCard = __webpack_require__("7UVI");
var userDetailsCard_default = /*#__PURE__*/__webpack_require__.n(userDetailsCard);

// CONCATENATED MODULE: ./client/app/shared/components/users/UserDetailsCard/index.jsx
var UserDetailsCard__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function UserDetailsCard__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var UserDetailsCard_UserDetailsCard = function UserDetailsCard(_ref) {
  var user = _ref.user,
      children = _ref.children,
      props = UserDetailsCard__objectWithoutProperties(_ref, ['user', 'children']);

  return react_default.a.createElement(
    components_Card,
    { key: user.id, className: userDetailsCard_default.a.userDetailsCard },
    react_default.a.createElement(users_UserDetailsHeader, UserDetailsCard__extends({ user: user }, props)),
    children
  );
};

UserDetailsCard_UserDetailsCard.propTypes = {
  user: types_user.isRequired,
  children: prop_types_default.a.node
};

/* harmony default export */ var users_UserDetailsCard = (UserDetailsCard_UserDetailsCard);
// EXTERNAL MODULE: ./client/app/shared/components/users/UserDetailsElement/styles.scss
var UserDetailsElement_styles = __webpack_require__("avsK");
var UserDetailsElement_styles_default = /*#__PURE__*/__webpack_require__.n(UserDetailsElement_styles);

// CONCATENATED MODULE: ./client/app/shared/components/users/UserDetailsElement/index.jsx
var UserDetailsElement__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function UserDetailsElement__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







var UserDetailsElement_UserDetailsElement = function UserDetailsElement(_ref) {
  var children = _ref.children,
      className = _ref.className,
      props = UserDetailsElement__objectWithoutProperties(_ref, ['children', 'className']);

  return react_default.a.createElement(
    ResourceDetailsCardElement,
    UserDetailsElement__extends({ className: classnames_default()(UserDetailsElement_styles_default.a.element, className) }, props),
    children
  );
};

UserDetailsElement_UserDetailsElement.propTypes = {
  children: prop_types_default.a.node,
  className: prop_types_default.a.string
};

/* harmony default export */ var users_UserDetailsElement = (UserDetailsElement_UserDetailsElement);
// EXTERNAL MODULE: ./client/app/shared/components/users/UserDetailsRow/styles.scss
var UserDetailsRow_styles = __webpack_require__("aVRF");
var UserDetailsRow_styles_default = /*#__PURE__*/__webpack_require__.n(UserDetailsRow_styles);

// CONCATENATED MODULE: ./client/app/shared/components/users/UserDetailsRow/index.jsx






var UserDetailsRow_UserDetailsRow = function UserDetailsRow(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      children = _ref.children;
  return react_default.a.createElement(
    react_toolbox_lib["CardText"],
    { className: UserDetailsRow_styles_default.a.row },
    react_default.a.createElement(
      'div',
      { className: UserDetailsRow_styles_default.a.titleWrapper },
      react_default.a.createElement(
        'h2',
        { className: UserDetailsRow_styles_default.a.titleRow },
        title
      ),
      subtitle
    ),
    react_default.a.createElement(
      flexbox_react_dist_default.a,
      { justifyContent: 'space-between' },
      react_default.a.createElement(
        flexbox_react_dist_default.a,
        { className: UserDetailsRow_styles_default.a.flexFullWidth },
        children
      )
    )
  );
};

UserDetailsRow_UserDetailsRow.propTypes = {
  title: prop_types_default.a.string,
  subtitle: prop_types_default.a.node,
  children: prop_types_default.a.node
};

/* harmony default export */ var users_UserDetailsRow = (UserDetailsRow_UserDetailsRow);
// CONCATENATED MODULE: ./client/app/shared/components/EmailLink/index.jsx
var EmailLink__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function EmailLink__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




var EmailLink_EmailLink = function EmailLink(_ref) {
  var email = _ref.email,
      children = _ref.children,
      props = EmailLink__objectWithoutProperties(_ref, ['email', 'children']);

  return react_default.a.createElement(
    'a',
    EmailLink__extends({ href: 'mailto:' + email }, props),
    children
  );
};

EmailLink_EmailLink.propTypes = {
  email: prop_types_default.a.string.isRequired,
  children: prop_types_default.a.node
};

/* harmony default export */ var components_EmailLink = (EmailLink_EmailLink);
// EXTERNAL MODULE: ./client/app/shared/components/users/UserDetailsBasicInfo/styles.scss
var UserDetailsBasicInfo_styles = __webpack_require__("UaJO");
var UserDetailsBasicInfo_styles_default = /*#__PURE__*/__webpack_require__.n(UserDetailsBasicInfo_styles);

// CONCATENATED MODULE: ./client/app/shared/components/users/UserDetailsBasicInfo/index.jsx
var UserDetailsBasicInfo__slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();











var UserDetailsBasicInfo_UserDetailsBasicInfo = function UserDetailsBasicInfo(_ref) {
  var contractorTableApprovedField = _ref.contractorTableApprovedField,
      leadCertField = _ref.leadCertField,
      canDeliverField = _ref.canDeliverField,
      user = _ref.user,
      role = _ref.role;
  return react_default.a.createElement(
    react["Fragment"],
    null,
    react_default.a.createElement(
      users_UserDetailsRow,
      { title: 'Contact Information' },
      react_default.a.createElement(
        users_UserDetailsElement,
        { title: 'email address' },
        react_default.a.createElement(
          components_EmailLink,
          { email: user.email },
          user.email
        )
      ),
      react_default.a.createElement(
        users_UserDetailsElement,
        { title: 'Primary Phone' },
        user.primary_phone,
        react_default.a.createElement(
          'span',
          { className: UserDetailsBasicInfo_styles_default.a.userDetailsPhoneType },
          '\xA0(',
          user.primary_phone_type,
          ')'
        )
      ),
      react_default.a.createElement(
        users_UserDetailsElement,
        {
          title: 'Secondary Phone',
          value: user.secondary_phone,
          isValueOptional: true
        },
        user.secondary_phone,
        react_default.a.createElement(
          'span',
          { className: UserDetailsBasicInfo_styles_default.a.employeeDetailsPhoneType },
          '\xA0(',
          user.secondary_phone_type,
          ')'
        )
      )
    ),
    Object(services_ability["a" /* can */])(role, 'view', 'manage_vendors') && react_default.a.createElement(
      users_UserDetailsRow,
      { title: 'Vendor Access' },
      Object.entries(user.manage_vendor_workrooms).map(function (_ref2) {
        var _ref3 = UserDetailsBasicInfo__slicedToArray(_ref2, 2),
            vendor = _ref3[0],
            hasAccess = _ref3[1];

        var upperVendor = vendor.toUpperCase();
        return react_default.a.createElement(
          users_UserDetailsElement,
          { key: upperVendor, title: constants["_52" /* VENDOR_NAME_MAP */][upperVendor] },
          hasAccess ? 'Yes' : 'No'
        );
      })
    ),
    role !== 'estimator' && react_default.a.createElement(
      users_UserDetailsRow,
      { title: 'Additional Information' },
      react_default.a.createElement(
        users_UserDetailsElement,
        { title: 'Timezone' },
        user.timezone
      ),
      leadCertField && react_default.a.createElement(
        users_UserDetailsElement,
        { title: 'Lead Cert Number' },
        user.lead_cert_number || '----'
      ),
      contractorTableApprovedField && react_default.a.createElement(
        users_UserDetailsElement,
        { title: 'Contractor Table Approved' },
        user.contractor_table_approved ? 'Yes' : 'No'
      ),
      canDeliverField && react_default.a.createElement(
        users_UserDetailsElement,
        { title: 'Can Deliver' },
        user.can_deliver ? 'Yes' : 'No'
      ),
      user.type !== 'estimator' && react_default.a.createElement(
        users_UserDetailsElement,
        { title: 'LRRP Training Expiration' },
        (user.lrrp_date_expiration || '').toString() || '----'
      )
    )
  );
};
UserDetailsBasicInfo_UserDetailsBasicInfo.defaultProps = {
  contractorTableApprovedField: false, leadCertField: false, role: ''
};

UserDetailsBasicInfo_UserDetailsBasicInfo.propTypes = {
  canDeliverField: prop_types_default.a.bool,
  contractorTableApprovedField: prop_types_default.a.bool,
  leadCertField: prop_types_default.a.bool,
  user: types_user.isRequired,
  role: prop_types_default.a.string
};

/* harmony default export */ var users_UserDetailsBasicInfo = (UserDetailsBasicInfo_UserDetailsBasicInfo);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./client/app/shared/styles/input.scss
var input = __webpack_require__("od/G");
var input_default = /*#__PURE__*/__webpack_require__.n(input);

// EXTERNAL MODULE: ./client/app/shared/components/DatePicker/styles.scss
var DatePicker_styles = __webpack_require__("vXuv");
var DatePicker_styles_default = /*#__PURE__*/__webpack_require__.n(DatePicker_styles);

// EXTERNAL MODULE: ./client/app/shared/components/DatePicker/rtDatePicker.scss
var rtDatePicker = __webpack_require__("aZp/");
var rtDatePicker_default = /*#__PURE__*/__webpack_require__.n(rtDatePicker);

// EXTERNAL MODULE: ./client/app/shared/components/DatePicker/rtButton.scss
var rtButton = __webpack_require__("lXSk");
var rtButton_default = /*#__PURE__*/__webpack_require__.n(rtButton);

// CONCATENATED MODULE: ./client/app/shared/components/DatePicker/index.jsx
var DatePicker__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function DatePicker__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function DatePicker__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function DatePicker__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function DatePicker__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function DatePicker__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var DatePicker_theme = { RTDatePicker: rtDatePicker_default.a, RTButton: rtButton_default.a };

var DatePicker_DateInput = function (_Component) {
  DatePicker__inherits(DateInput, _Component);

  function DateInput(props) {
    DatePicker__classCallCheck(this, DateInput);

    var _this = DatePicker__possibleConstructorReturn(this, (DateInput.__proto__ || Object.getPrototypeOf(DateInput)).call(this, props));

    Object.defineProperty(_this, 'componentWillReceiveProps', {
      enumerable: true,
      writable: true,
      value: function value(newProps) {
        return newProps.value !== _this.props.value ? _this.setState({ value: newProps.value }) : null;
      }
    });
    Object.defineProperty(_this, 'onChange', {
      enumerable: true,
      writable: true,
      value: function value(event) {
        return _this.setState({
          value: event.target.value
        }, _this.props.onChange(event.target.value));
      }
    });
    Object.defineProperty(_this, 'onMobileChange', {
      enumerable: true,
      writable: true,
      value: function value(event) {
        var value = event.target.value ? moment_default()(event.target.value, 'YYYY-MM-DD').format('MM/DD/YYYY') : '';
        _this.setState({ value: value }, _this.props.onChange(value));
      }
    });
    Object.defineProperty(_this, 'onPickerChange', {
      enumerable: true,
      writable: true,
      value: function value(_value) {
        var date = moment_default()(_value).format('MM/DD/YYYY');
        _this.setState({
          value: date.toString(),
          showPicker: false
        }, function () {
          _this.props.onChange(date);
          if (_this.props.onBlur) _this.props.onBlur(date);
        });
      }
    });
    Object.defineProperty(_this, 'toggleDatePicker', {
      enumerable: true,
      writable: true,
      value: function value(_value2) {
        return _this.props.disabled ? null : _this.setState({ showPicker: _value2 });
      }
    });
    Object.defineProperty(_this, 'showDatePicker', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.toggleDatePicker(true);
      }
    });
    Object.defineProperty(_this, 'hideDatePicker', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.toggleDatePicker(false);
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _cx, _cx2, _cx3;

        var _this$props = _this.props,
            label = _this$props.label,
            disabled = _this$props.disabled;

        var _this$props2 = _this.props,
            required = _this$props2.required,
            error = _this$props2.error,
            className = _this$props2.className,
            maxDate = _this$props2.maxDate,
            minDate = _this$props2.minDate,
            otherProps = DatePicker__objectWithoutProperties(_this$props2, ['required', 'error', 'className', 'maxDate', 'minDate']);

        var requiredText = required ? ' *' : '';
        var errorText = error || '';
        var rootClassNames = classnames_default()((_cx = {}, DatePicker__defineProperty(_cx, DatePicker_styles_default.a.datePickerWrapper, true), DatePicker__defineProperty(_cx, _this.props.className, className), DatePicker__defineProperty(_cx, input_default.a.errored, errorText), _cx));
        var labelClassNames = classnames_default()((_cx2 = {}, DatePicker__defineProperty(_cx2, input_default.a.label, true), DatePicker__defineProperty(_cx2, DatePicker_styles_default.a.errorText, errorText), _cx2));
        var inputClassnames = classnames_default()(input_default.a.inputElement, DatePicker_styles_default.a.inputElement);
        var mobileInputClassnames = classnames_default()(input_default.a.inputElement, DatePicker_styles_default.a.mobileInputElement);
        var errorMessageClassNames = classnames_default()((_cx3 = {}, DatePicker__defineProperty(_cx3, DatePicker_styles_default.a.errorText, errorText), DatePicker__defineProperty(_cx3, DatePicker_styles_default.a.errorMessage, errorText), _cx3));
        var momentDate = _this.state.value ? moment_default()(_this.state.value, ['MM-DD-YYYY', 'YYYY-MM-DD']) : moment_default()();
        var nativeDate = _this.state.value ? momentDate.format('YYYY-MM-DD').toString() : '';
        return react_default.a.createElement(
          react_css_themr_lib["ThemeProvider"],
          { theme: DatePicker_theme },
          react_default.a.createElement(
            'div',
            { className: rootClassNames },
            react_default.a.createElement(react_toolbox_lib["DatePicker"], DatePicker__extends({
              autoOk: true
            }, otherProps, {
              minDate: minDate,
              maxDate: maxDate,
              active: _this.state.showPicker,
              onChange: _this.onPickerChange,
              onEscKeyDown: _this.hideDatePicker,
              onOverlayClick: _this.hideDatePicker,
              onDismiss: _this.hideDatePicker,
              value: momentDate.toDate(),
              sundayFirstDayOfWeek: true
            })),
            label && react_default.a.createElement(
              'label',
              { htmlFor: 'date', className: labelClassNames },
              label,
              requiredText
            ),
            react_default.a.createElement('input', DatePicker__extends({}, otherProps, {
              type: 'text',
              value: _this.state.value,
              className: inputClassnames,
              onChange: _this.onChange,
              placeholder: _this.props.placeholder
            })),
            react_default.a.createElement('input', DatePicker__extends({}, otherProps, {
              type: 'date',
              value: nativeDate,
              className: mobileInputClassnames,
              onChange: _this.onMobileChange,
              placeholder: _this.props.placeholder
            })),
            react_default.a.createElement(
              'span',
              { className: errorMessageClassNames },
              errorText
            ),
            react_default.a.createElement(react_toolbox_lib["IconButton"], {
              className: classnames_default()(DatePicker_styles_default.a.icon, DatePicker__defineProperty({}, DatePicker_styles_default.a.disabled, disabled)),
              icon: 'date_range',
              onClick: _this.showDatePicker
            })
          )
        );
      }
    });

    _this.toggleDatePicker = _this.toggleDatePicker.bind(_this);
    _this.showDatePicker = _this.showDatePicker.bind(_this);
    _this.hideDatePicker = _this.hideDatePicker.bind(_this);
    _this.onChange = _this.onChange.bind(_this);
    _this.onMobileChange = _this.onMobileChange.bind(_this);
    _this.onPickerChange = _this.onPickerChange.bind(_this);
    _this.state = { showPicker: false, value: props.value || '' };
    return _this;
  }

  return DateInput;
}(react["Component"]);

DatePicker_DateInput.propTypes = {
  value: prop_types_default.a.string,
  onChange: prop_types_default.a.func,
  onBlur: prop_types_default.a.func,
  label: prop_types_default.a.node,
  required: prop_types_default.a.bool,
  error: prop_types_default.a.string,
  className: prop_types_default.a.string,
  placeholder: prop_types_default.a.string,
  disabled: prop_types_default.a.bool,
  minDate: prop_types_default.a.instanceOf(Date),
  maxDate: prop_types_default.a.instanceOf(Date)
};

/* harmony default export */ var DatePicker = (DatePicker_DateInput);
// EXTERNAL MODULE: ./client/app/shared/components/users/UserDetailsBadgeInfo/styles.scss
var UserDetailsBadgeInfo_styles = __webpack_require__("Qdpz");
var UserDetailsBadgeInfo_styles_default = /*#__PURE__*/__webpack_require__.n(UserDetailsBadgeInfo_styles);

// EXTERNAL MODULE: ./client/app/utils/dateUtils.js
var dateUtils = __webpack_require__("N46Y");

// CONCATENATED MODULE: ./client/app/shared/components/users/UserDetailsBadgeInfo/index.jsx
function UserDetailsBadgeInfo__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function UserDetailsBadgeInfo__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function UserDetailsBadgeInfo__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var EditCtrl = Auth_visibleFor('update', 'badge', function (_ref) {
  var isEditable = _ref.isEditable,
      onEdit = _ref.onEdit,
      onSave = _ref.onSave;
  return react_default.a.createElement(react_toolbox_lib["Button"], {
    className: UserDetailsBadgeInfo_styles_default.a.editBtn,
    label: isEditable ? 'Save Badge' : 'Edit Badge',
    onClick: isEditable ? onSave : onEdit,
    ripple: false,
    neutral: false,
    flat: true
  });
});

var inputStyle = input_default.a.inputElement + ' ' + UserDetailsBadgeInfo_styles_default.a.inputElement;

var UserDetailsBadgeInfo_UserDetailsBadgeInfo = function (_React$Component) {
  UserDetailsBadgeInfo__inherits(UserDetailsBadgeInfo, _React$Component);

  function UserDetailsBadgeInfo(props) {
    UserDetailsBadgeInfo__classCallCheck(this, UserDetailsBadgeInfo);

    var _this = UserDetailsBadgeInfo__possibleConstructorReturn(this, (UserDetailsBadgeInfo.__proto__ || Object.getPrototypeOf(UserDetailsBadgeInfo)).call(this, props));

    Object.defineProperty(_this, 'getBadgeDiff', {
      enumerable: true,
      writable: true,
      value: function value() {
        var user = _this.props.user;

        var diff = {};
        var currBadge = user.badge || null;
        if (!currBadge) currBadge = { expiration: null, number: null };
        ['expiration', 'number'].forEach(function (key) {
          if (currBadge[key] !== _this.state[key]) diff[key] = [currBadge[key], _this.state[key]];
        });
        return diff;
      }
    });
    Object.defineProperty(_this, 'handleEdit', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ isEditable: true });
      }
    });
    Object.defineProperty(_this, 'handleSave', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            user = _this$props.user,
            type = _this$props.type;
        var number = _this.state.number;

        var expiration = moment_default()(_this.state.expiration, 'MM/DD/YYYY').toISOString();
        var badgeDiff = _this.getBadgeDiff();
        var eventProps = {
          name: 'Update ' + (type === 'estimator' ? 'Estimator' : 'Empployee') + ' Profile',
          kind: 'update_profile',
          data: { updates: badgeDiff }
        };
        _this.props.updateUserBadge(user.user_id, { number: number, expiration: expiration }).then(function () {
          if (type === 'estimator') _this.props.addEventToEstimator(user.id, eventProps);else _this.props.addEventToEmployee(user.id, eventProps);
          _this.setState({ isEditable: false, errors: {} });
        }).catch(function (_ref2) {
          var errors = _ref2.errors;
          return _this.setState({ errors: errors });
        });
      }
    });
    Object.defineProperty(_this, 'handleBadgeNumber', {
      enumerable: true,
      writable: true,
      value: function value(event) {
        return _this.setState({ number: event.target.value || '' });
      }
    });
    Object.defineProperty(_this, 'handleBadgeExpiration', {
      enumerable: true,
      writable: true,
      value: function value(val) {
        return _this.setState({ expiration: val });
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$state = _this.state,
            isEditable = _this$state.isEditable,
            number = _this$state.number,
            expiration = _this$state.expiration,
            errors = _this$state.errors,
            badgeLink = _this$state.badgeLink;
        var _this$props2 = _this.props,
            role = _this$props2.role,
            authUser = _this$props2.authUser,
            user = _this$props2.user;

        var badgeDate = (expiration || '').toString() || '';
        var isBadgeOverdue = false;
        if (badgeDate) {
          var dateObj = new Date(badgeDate);
          var dateISO = dateObj.toISOString();
          isBadgeOverdue = Object(dateUtils["p" /* isOverdue */])(dateISO);
        }
        var badgeTitle = 'badge expiration';
        if (isBadgeOverdue) badgeTitle = badgeTitle + ' ***expired***';
        if (!Object(services["a" /* can */])(role, 'view', 'badge', { user_id: authUser.id, obj_id: user.user_id })) return null;
        return react_default.a.createElement(
          'div',
          null,
          react_default.a.createElement(
            users_UserDetailsRow,
            {
              title: 'Badge Details',
              subtitle: react_default.a.createElement(EditCtrl, {
                isEditable: isEditable,
                onEdit: _this.handleEdit,
                onSave: _this.handleSave
              })
            },
            react_default.a.createElement(
              users_UserDetailsElement,
              { isValueOptional: !isEditable, title: 'badge number', value: number },
              isEditable && react_default.a.createElement(
                'div',
                { className: errors.number ? input_default.a.errored : '' },
                react_default.a.createElement('input', {
                  type: 'text',
                  className: inputStyle,
                  value: number,
                  onChange: _this.handleBadgeNumber
                }),
                react_default.a.createElement(
                  'div',
                  { className: input_default.a.error },
                  react_default.a.createElement(
                    'span',
                    { className: UserDetailsBadgeInfo_styles_default.a.errorMsg },
                    errors.number
                  )
                )
              )
            ),
            react_default.a.createElement(
              users_UserDetailsElement,
              { isValueOptional: !isEditable, title: badgeTitle, value: badgeDate },
              isEditable && react_default.a.createElement(DatePicker, {
                className: UserDetailsBadgeInfo_styles_default.a.datepicker,
                value: badgeDate,
                onChange: _this.handleBadgeExpiration,
                error: errors.badgeDate
              })
            ),
            react_default.a.createElement(
              users_UserDetailsElement,
              { title: 'Badge Link', value: badgeLink },
              react_default.a.createElement(
                'a',
                { href: 'http://' + badgeLink, target: '_blank', rel: 'noopener noreferrer' },
                badgeLink
              )
            )
          )
        );
      }
    });

    var badge = _this.props.user && _this.props.user.badge || {};
    _this.state = {
      isEditable: false,
      number: badge.number || '',
      expiration: badge.expiration || '',
      badgeLink: badge.badge_link || '',
      errors: {}
    };
    return _this;
  }

  return UserDetailsBadgeInfo;
}(react_default.a.Component);

UserDetailsBadgeInfo_UserDetailsBadgeInfo.defaultProps = { type: '' };

UserDetailsBadgeInfo_UserDetailsBadgeInfo.propTypes = {
  authUser: prop_types_default.a.shape({
    id: prop_types_default.a.number.isRequired
  }).isRequired,
  role: prop_types_default.a.string.isRequired,
  user: prop_types_default.a.shape({
    badge: prop_types_default.a.shape({
      number: prop_types_default.a.string.isRequired,
      expiration: prop_types_default.a.string.isRequired
    }),
    user_id: prop_types_default.a.number.isRequired
  }).isRequired,
  type: prop_types_default.a.string,
  updateUserBadge: prop_types_default.a.func.isRequired,
  addEventToEmployee: prop_types_default.a.func,
  addEventToEstimator: prop_types_default.a.func
};

/* harmony default export */ var users_UserDetailsBadgeInfo = (Object(react_redux_es["connect"])(function (state) {
  return { role: Object(reducers["_12" /* getRole */])(state), authUser: state.user };
}, { updateUserBadge: actionCreators["_72" /* updateUserBadge */], addEventToEmployee: actionCreators["a" /* addEventToEmployee */], addEventToEstimator: actionCreators["b" /* addEventToEstimator */] })(UserDetailsBadgeInfo_UserDetailsBadgeInfo));
// EXTERNAL MODULE: ./client/app/shared/components/EmployableHistory/EmployableHistoryCard/employableHistoryCard.scss
var employableHistoryCard = __webpack_require__("fvgW");
var employableHistoryCard_default = /*#__PURE__*/__webpack_require__.n(employableHistoryCard);

// EXTERNAL MODULE: ./client/app/shared/components/EmployableHistory/EmployableHistoryCard/employableEvents/styles.scss
var employableEvents_styles = __webpack_require__("diHI");
var employableEvents_styles_default = /*#__PURE__*/__webpack_require__.n(employableEvents_styles);

// CONCATENATED MODULE: ./client/app/shared/components/EmployableHistory/EmployableHistoryCard/employableEvents/update_profile.jsx





var update_profile_update_profile = function update_profile(_ref) {
  var employableType = _ref.employableType,
      workrooms = _ref.workrooms,
      surfaceTypes = _ref.surfaceTypes,
      data = _ref.event.data;

  var updates = data.updates;

  var eventKeys = Object.keys(updates);

  var formatKey = function formatKey(key) {
    var keyArr = key.split('_');
    var capitalizedKeyArr = keyArr.map(function (el) {
      return Object(lodash["capitalize"])(el);
    });
    return capitalizedKeyArr.join(' ');
  };

  var isPopulated = function isPopulated() {
    var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return arr && Array.isArray(arr) && arr.length > 0;
  };

  var formatList = function formatList() {
    var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var key = arguments[1];

    var returnList = [];
    switch (key) {
      case 'workrooms':
        returnList = isPopulated(workrooms) && isPopulated(arr) ? workrooms.filter(function (wrkm) {
          return arr.includes(wrkm.id);
        }).map(function (wrkm) {
          return '\'' + wrkm.name + '\'';
        }) : null;
        break;
      case 'surface_types':
        returnList = isPopulated(surfaceTypes) && isPopulated(arr) ? surfaceTypes.filter(function (st) {
          return arr.includes(st.id);
        }).map(function (st) {
          return '\'' + st.name + '\'';
        }) : null;
        break;
      case 'covered_zip_codes':
        returnList = isPopulated(arr) ? arr.map(function (zip) {
          return ' ' + zip;
        }) : null;
        break;
      default:
        returnList = null;
    }
    return isPopulated(returnList) ? returnList.join(', ') : 'N/A';
  };

  // const formatStd = (item) => {
  //   let itemCopy = item;
  //   if (itemCopy == null || !itemCopy) itemCopy = 'N/A';
  //   if (typeof itemCopy === 'boolean') itemCopy = itemCopy.toString();
  //   return (Array.isArray(itemCopy) ? itemCopy.map(i =>
  //     capitalize(i)).join(', ') : capitalize(itemCopy));
  // };

  var formatStd = function formatStd(item) {
    var itemCopy = item;
    if (itemCopy == null || !itemCopy) return 'N/A';
    if (isPopulated(itemCopy)) return itemCopy.map(function (i) {
      return Object(lodash["capitalize"])(i);
    }).join(', ');else if (Array.isArray(itemCopy)) return 'N/A';else if (typeof itemCopy === 'boolean') itemCopy = itemCopy.toString();
    return typeof itemCopy === 'string' ? Object(lodash["capitalize"])(itemCopy) : 'N/A';
  };

  var getKeys = function getKeys(obj) {
    return Object.keys(obj);
  };

  var nestedProperties = function nestedProperties(key) {
    return Object.keys(data.updates[key]).map(function (nKey) {
      return nKey;
    });
  };

  var renderEmployee = function renderEmployee() {
    var nestedAttributes = ['badge', 'manage_vendor_workrooms'];
    return react_default.a.createElement(
      'ul',
      { className: employableEvents_styles_default.a.updatesList },
      eventKeys.map(function (key, ind) {
        return react_default.a.createElement(
          react["Fragment"],
          { key: '' + (updates[key] + ind) },
          nestedAttributes.includes(key) ? react_default.a.createElement(
            react["Fragment"],
            null,
            nestedProperties(key).map(function (nKey) {
              var oldVal = updates[key][nKey][0];
              var newVal = updates[key][nKey][1];
              var displayOld = typeof oldVal === 'boolean' ? oldVal.toString() : oldVal || 'N/A';
              var displayNew = typeof newVal === 'boolean' ? newVal.toString() : newVal || 'N/A';
              return react_default.a.createElement(
                'li',
                { key: '' + (updates[key][nKey] + ind) },
                formatKey(key) + ' ' + formatKey(nKey) + ': "' + displayOld + '" changed to "' + displayNew + '"'
              );
            })
          ) : react_default.a.createElement(
            'li',
            null,
            ['workrooms', 'covered_zip_codes'].includes(key) ? formatKey(key) + ': "' + formatList(updates[key][0], key) + '" changed to "' + formatList(updates[key][1], key) + '"' : formatKey(key) + ': "' + formatStd(updates[key][0]) + '" changed to "' + formatStd(updates[key][1]) + '"'
          )
        );
      })
    );
  };

  var renderInstaller = function renderInstaller() {
    var updatesOrder = ['installer', 'crew', 'helper'].filter(function (key) {
      return eventKeys.includes(key);
    });
    return react_default.a.createElement(
      'ul',
      { className: employableEvents_styles_default.a.updatesList },
      updatesOrder.map(function (ent, idx1) {
        return react_default.a.createElement(
          react["Fragment"],
          { key: '' + (updates[ent] + idx1) },
          ['crew', 'helper'].includes(ent) ? react_default.a.createElement(
            react["Fragment"],
            null,
            getKeys(updates[ent]).map(function (name, idx2) {
              return react_default.a.createElement(
                react["Fragment"],
                { key: '' + (updates[ent][name] + idx2) },
                react_default.a.createElement(
                  'li',
                  null,
                  getKeys(updates[ent])[idx2] + ' (' + Object(lodash["capitalize"])(ent) + '):'
                ),
                react_default.a.createElement(
                  'ul',
                  null,
                  getKeys(updates[ent][name]).map(function (attr, idx3) {
                    return react_default.a.createElement(
                      'li',
                      { key: '' + (updates[ent][name][attr] + idx3), className: employableEvents_styles_default.a.nestedAttribute },
                      ['workrooms', 'surface_types', 'covered_zip_codes'].includes(attr) ? formatKey(getKeys(updates[ent][name])[idx3]) + ': Changed from "' + formatList(updates[ent][name][attr][0], attr) + '" to "' + formatList(updates[ent][name][attr][1], attr) + '"' : formatKey(getKeys(updates[ent][name])[idx3]) + ': Changed from "' + (updates[ent][name][attr][0] || 'N/A') + '" to "' + (updates[ent][name][attr][1] || 'N/A') + '"'
                    );
                  })
                )
              );
            })
          ) : react_default.a.createElement(
            react["Fragment"],
            null,
            ' ',
            getKeys(updates[ent]).map(function (attr, idx) {
              return react_default.a.createElement(
                'li',
                { key: '' + (updates[ent] + idx) },
                formatKey(attr) + ': Changed from "' + updates[ent][attr][0] + '" to "' + updates[ent][attr][1] + '"'
              );
            })
          )
        );
      })
    );
  };

  return react_default.a.createElement(
    react["Fragment"],
    null,
    employableType === 'installer' && renderInstaller(),
    ['employee', 'estimator'].includes(employableType) && renderEmployee()
  );
};

update_profile_update_profile.propTypes = {
  event: prop_types_default.a.shape({
    data: prop_types_default.a.shape({
      note: prop_types_default.a.string,
      updates: prop_types_default.a.obj
    }).isRequired
  }).isRequired,
  workrooms: prop_types_default.a.array,
  surfaceTypes: prop_types_default.a.array,
  employableType: prop_types_default.a.string
};
// CONCATENATED MODULE: ./client/app/shared/components/EmployableHistory/EmployableHistoryCard/employableEvents/note.jsx



var note_note = function note(_ref) {
  var event = _ref.event;
  return react_default.a.createElement(
    'div',
    null,
    event.data.note
  );
};

note_note.propTypes = {
  event: prop_types_default.a.shape({
    bot: prop_types_default.a.bool,
    created_at: prop_types_default.a.string,
    data: prop_types_default.a.shape({
      task: prop_types_default.a.string,
      status: prop_types_default.a.string
    }).isRequired
  }).isRequired
};
// CONCATENATED MODULE: ./client/app/shared/components/EmployableHistory/EmployableHistoryCard/employableEvents/index.js


// CONCATENATED MODULE: ./client/app/shared/types/event.js


var event_EventType = prop_types_default.a.shape({
  id: prop_types_default.a.number.isRequired,
  kind: prop_types_default.a.string.isRequired,
  name: prop_types_default.a.string.isRequired,
  status: prop_types_default.a.string.isRequired,
  user: prop_types_default.a.string.isRequired,
  data: prop_types_default.a.object.isRequired,
  created_at: prop_types_default.a.string.isRequired
});

/* harmony default export */ var types_event = (event_EventType);
// CONCATENATED MODULE: ./client/app/shared/components/EmployableHistory/EmployableHistoryCard/employableEventList.jsx













var employableEventList_EmployableEventList = function EmployableEventList(_ref) {
  var events = _ref.events,
      workrooms = _ref.workrooms,
      surfaceTypes = _ref.surfaceTypes,
      employableType = _ref.employableType;

  var eventList = events.map(function (event, i) {
    var EventType = employableEvents_namespaceObject[event.kind] ? employableEvents_namespaceObject[event.kind] : note_note;
    return react_default.a.createElement(
      'div',
      { key: event.id, className: employableHistoryCard_default.a.employableEventCard },
      react_default.a.createElement(
        components_Card,
        { className: classnames_default()(resourceCard_default.a.resourceCard, employableHistoryCard_default.a.resourceCard), altColor: i % 2 !== 0 },
        react_default.a.createElement(
          'div',
          { className: classnames_default()(resourceCard_default.a.resourceCardColumn, employableHistoryCard_default.a.phaseHistoryAside) },
          react_default.a.createElement(
            'div',
            { className: resourceCard_default.a.column },
            react_default.a.createElement(ResourceCardElement, {
              title: 'Task/Event',
              value: event.name,
              size: 'large',
              theme: employableHistoryCard_default.a,
              wrap: true
            }),
            react_default.a.createElement(ResourceCardElement, {
              title: event.user_type,
              value: event.user,
              size: 'large',
              theme: employableHistoryCard_default.a,
              wrap: true
            })
          ),
          react_default.a.createElement(
            'div',
            { className: resourceCard_default.a.column },
            react_default.a.createElement(
              ResourceCardElement,
              {
                title: event.kind === 'update_profile' ? 'Updates' : 'Note',
                size: 'large',
                theme: employableHistoryCard_default.a,
                wrap: true
              },
              EventType && workrooms.length !== 0 && react_default.a.createElement(EventType, {
                event: event,
                workrooms: workrooms,
                surfaceTypes: surfaceTypes,
                employableType: employableType
              })
            ),
            react_default.a.createElement(ResourceCardElement, {
              title: 'Recorded On',
              value: moment_default()(event.created_at).local().format('dddd, MM/DD/YYYY, h:mm a').toString(),
              size: 'large',
              theme: employableHistoryCard_default.a
            })
          )
        )
      )
    );
  });
  return react_default.a.createElement(
    'section',
    null,
    eventList
  );
};

employableEventList_EmployableEventList.propTypes = {
  events: prop_types_default.a.arrayOf(types_event).isRequired,
  workrooms: prop_types_default.a.array,
  surfaceTypes: prop_types_default.a.array,
  employableType: prop_types_default.a.string
};

var employableEventList_mapStateToProps = function mapStateToProps(state) {
  return {
    workrooms: Object(reducers["_37" /* getWorkroomList */])(state) || [],
    surfaceTypes: Object(reducers["_22" /* getSurfaceTypeList */])(state) || []
  };
};

/* harmony default export */ var employableEventList = (Object(react_redux_es["connect"])(employableEventList_mapStateToProps)(employableEventList_EmployableEventList));
// EXTERNAL MODULE: ./client/app/shared/styles/contentArea.scss
var contentArea = __webpack_require__("h4x6");
var contentArea_default = /*#__PURE__*/__webpack_require__.n(contentArea);

// CONCATENATED MODULE: ./client/app/shared/components/EmployableHistory/EmployableHistoryCard/index.jsx
function EmployableHistoryCard__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function EmployableHistoryCard__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function EmployableHistoryCard__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var EmployableHistoryCard_EmployableHistoryCard = function (_React$Component) {
  EmployableHistoryCard__inherits(EmployableHistoryCard, _React$Component);

  function EmployableHistoryCard(props) {
    EmployableHistoryCard__classCallCheck(this, EmployableHistoryCard);

    var _this = EmployableHistoryCard__possibleConstructorReturn(this, (EmployableHistoryCard.__proto__ || Object.getPrototypeOf(EmployableHistoryCard)).call(this, props));

    Object.defineProperty(_this, 'componentDidMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.contentWrapper !== null ? _this.setState({ clientHeight: _this.contentWrapper.clientHeight }) : null;
      }
    });
    Object.defineProperty(_this, 'componentDidUpdate', {
      enumerable: true,
      writable: true,
      value: function value(prevProps) {
        return prevProps.collapsed !== _this.props.collapsed ? _this.setState({ collapsed: _this.props.collapsed }) : null;
      }
    });
    Object.defineProperty(_this, 'handleClick', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({
          collapsed: !_this.state.collapsed,
          icon: _this.state.collapsed ? 'up' : 'down'
        });
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$state = _this.state,
            collapsed = _this$state.collapsed,
            clientHeight = _this$state.clientHeight;
        var _this$props = _this.props,
            events = _this$props.events,
            name = _this$props.name,
            employableType = _this$props.employableType;

        var icon = 'arrow_drop_' + _this.state.icon;
        var iconStyle = employableHistoryCard_default.a.employableHistoryCard__collapseToggle;
        var heightStyle = {};
        if (collapsed) heightStyle.maxHeight = 0;else {
          heightStyle.maxHeight = (clientHeight || 0) + 500;
        }
        return react_default.a.createElement(
          components_Card,
          { className: employableHistoryCard_default.a.employableHistoryCard__container + ' ' + contentArea_default.a.contentArea },
          react_default.a.createElement(
            'section',
            { className: employableHistoryCard_default.a.employableHistoryCard },
            react_default.a.createElement(
              'div',
              { className: employableHistoryCard_default.a.employableHistoryCard__title },
              react_default.a.createElement(
                'span',
                null,
                name
              ),
              react_default.a.createElement(react_toolbox_lib["FontIcon"], { value: icon, onClick: _this.handleClick, className: iconStyle })
            ),
            react_default.a.createElement(
              'div',
              { className: employableHistoryCard_default.a.employableHistoryCard__content, style: heightStyle },
              react_default.a.createElement(
                'div',
                { ref: function ref(wrapper) {
                    _this.contentWrapper = wrapper;
                  } },
                react_default.a.createElement(employableEventList, { events: events, employableType: employableType })
              )
            )
          )
        );
      }
    });

    _this.state = {
      collapsed: props.collapsed,
      icon: props.collapsed ? 'down' : 'up',
      clientHeight: 0
    };
    return _this;
  }

  // On the first render, the component has no reference to the contentWrapper
  // and its height. We need to trigger another render if the component is
  // initially expanded so that it displays properly.


  return EmployableHistoryCard;
}(react_default.a.Component);

EmployableHistoryCard_EmployableHistoryCard.propTypes = {
  name: prop_types_default.a.string,
  collapsed: prop_types_default.a.bool,
  events: prop_types_default.a.arrayOf(prop_types_default.a.object),
  employableType: prop_types_default.a.string
};

/* harmony default export */ var EmployableHistory_EmployableHistoryCard = (EmployableHistoryCard_EmployableHistoryCard);
// EXTERNAL MODULE: ./client/app/shared/components/EmployableHistoryFilters/employableHistoryFilters.scss
var employableHistoryFilters = __webpack_require__("L2Hi");
var employableHistoryFilters_default = /*#__PURE__*/__webpack_require__.n(employableHistoryFilters);

// CONCATENATED MODULE: ./client/app/shared/components/EmployableHistoryFilters/index.jsx




var EmployableHistoryFilters_EmployableHistoryFilters = function EmployableHistoryFilters(_ref) {
  var toggleEventFilters = _ref.toggleEventFilters,
      isOnlyNotes = _ref.isOnlyNotes,
      isOnlyEditEvents = _ref.isOnlyEditEvents,
      isAllEvents = _ref.isAllEvents;
  return react_default.a.createElement(
    'div',
    { className: employableHistoryFilters_default.a.employableHistorySortContainer },
    react_default.a.createElement(
      'div',
      { className: employableHistoryFilters_default.a.employableHistorySortDirection },
      'Show Only Notes ',
      react_default.a.createElement('input', {
        type: 'radio',
        checked: isOnlyNotes,
        onChange: function onChange() {
          return toggleEventFilters('Notes');
        }
      })
    ),
    react_default.a.createElement(
      'div',
      { className: employableHistoryFilters_default.a.employableHistorySortDirection },
      'Show Only Edit Events ',
      react_default.a.createElement('input', {
        type: 'radio',
        checked: isOnlyEditEvents,
        onChange: function onChange() {
          return toggleEventFilters('Edit Events');
        }
      })
    ),
    react_default.a.createElement(
      'div',
      { className: employableHistoryFilters_default.a.employableHistorySortDirection },
      'All Events ',
      react_default.a.createElement('input', {
        type: 'radio',
        checked: isAllEvents,
        onChange: function onChange() {
          return toggleEventFilters('All');
        }
      })
    )
  );
};

EmployableHistoryFilters_EmployableHistoryFilters.propTypes = {
  isAllEvents: prop_types_default.a.bool,
  isOnlyNotes: prop_types_default.a.bool,
  isOnlyEditEvents: prop_types_default.a.bool,
  toggleEventFilters: prop_types_default.a.func
};

/* harmony default export */ var components_EmployableHistoryFilters = (EmployableHistoryFilters_EmployableHistoryFilters);
// EXTERNAL MODULE: ./client/app/shared/components/EmployableHistory/styles.scss
var EmployableHistory_styles = __webpack_require__("tVfH");
var EmployableHistory_styles_default = /*#__PURE__*/__webpack_require__.n(EmployableHistory_styles);

// CONCATENATED MODULE: ./client/app/shared/mixins/validator.js
var validator__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function validator__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function validator__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function validator__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var REQUIRED_ERROR_MSG = 'Can\'t be blank.';

var validator_isBlankOrEmpty = function isBlankOrEmpty(val) {
  return Object(lodash["isNull"])(val) || Object(lodash["isUndefined"])(val) || Object(lodash["isArrayLikeObject"])(val) && Object(lodash["isEmpty"])(val) || Object(lodash["isString"])(val) && Object(lodash["trim"])(val) === '' || Object(lodash["isBoolean"])(val) && val !== true;
};

var validator_validatorMixin = function validatorMixin(Base) {
  var _class, _temp;

  return _temp = _class = function (_Base) {
    validator__inherits(_class, _Base);

    function _class() {
      validator__classCallCheck(this, _class);

      return validator__possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
    }

    validator__createClass(_class, [{
      key: 'validate',
      value: function validate() {
        var _this2 = this;

        var checks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var validations = Object(lodash["isEmpty"])(checks) ? this.constructor.VALIDATIONS : checks;
        var errors = {};
        Object.keys(validations).forEach(function (prop) {
          if (validator_isBlankOrEmpty(_this2.valuesForValidation[prop])) {
            var msg = Object(lodash["isString"])(validations[prop]) ? validations[prop] : REQUIRED_ERROR_MSG;
            errors[prop] = [msg];
          }
        });
        this.errors = errors;
        return Object.keys(errors).length === 0;
      }
    }, {
      key: 'valuesForValidation',
      get: function get() {
        return this.state;
      }
    }, {
      key: 'errors',
      set: function set(errors) {
        this.setState({ errors: errors });
      }
    }]);

    return _class;
  }(Base), Object.defineProperty(_class, 'VALIDATIONS', {
    enumerable: true,
    writable: true,
    value: {}
  }), _temp;
};

/* harmony default export */ var validator = (validator_validatorMixin);
// CONCATENATED MODULE: ./client/app/shared/mixins/resetter.js
var resetter__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function resetter__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function resetter__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function resetter__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var resetStateMixin = function resetStateMixin(Base) {
  var _class, _temp2;

  return _temp2 = _class = function (_Base) {
    resetter__inherits(_class, _Base);

    function _class() {
      var _ref;

      var _temp, _this, _ret;

      resetter__classCallCheck(this, _class);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = resetter__possibleConstructorReturn(this, (_ref = _class.__proto__ || Object.getPrototypeOf(_class)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, "state", {
        enumerable: true,
        writable: true,
        value: _this.constructor.DEFAULT_STATE
      }), Object.defineProperty(_this, "handleClose", {
        enumerable: true,
        writable: true,
        value: _this.handleClose.bind(_this)
      }), _temp), resetter__possibleConstructorReturn(_this, _ret);
    }

    resetter__createClass(_class, [{
      key: "handleClose",
      value: function handleClose() {
        this.setState(this.constructor.DEFAULT_STATE, this.props.onClose);
      }
    }]);

    return _class;
  }(Base), Object.defineProperty(_class, "DEFAULT_STATE", {
    enumerable: true,
    writable: true,
    value: {}
  }), _temp2;
};

/* harmony default export */ var resetter = (resetStateMixin);
// CONCATENATED MODULE: ./client/app/shared/mixins/shortcuts.js
var shortcuts__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function shortcuts__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function shortcuts__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function shortcuts__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var origStopCallback = mousetrap_default.a.prototype.stopCallback;
mousetrap_default.a.prototype.stopCallback = function stopCallback(e, element, combo) {
  return origStopCallback.call(this, e, element, combo) && combo.indexOf('esc') === -1;
};

function shortcutsMixin(Base) {
  var shortcuts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  return function (_Base) {
    shortcuts__inherits(_class, _Base);

    function _class() {
      shortcuts__classCallCheck(this, _class);

      return shortcuts__possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
    }

    shortcuts__createClass(_class, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _get2,
            _this2 = this;

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        if (typeof _get(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), 'componentDidMount', this) === 'function') (_get2 = _get(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), 'componentDidMount', this)).call.apply(_get2, [this].concat(args));
        shortcuts.forEach(function (shortcut) {
          mousetrap_default.a.bind(shortcut.key, function (e) {
            _this2[shortcut.func](e);
          });
        });
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        var _get3;

        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        if (typeof _get(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), 'componentWillUnmount', this) === 'function') (_get3 = _get(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), 'componentWillUnmount', this)).call.apply(_get3, [this].concat(args));
        shortcuts.forEach(function (shortcut) {
          mousetrap_default.a.unbind(shortcut.key);
        });
      }
    }]);

    return _class;
  }(Base);
}

/* harmony default export */ var mixins_shortcuts = (shortcutsMixin);
// CONCATENATED MODULE: ./client/app/shared/components/ActivableRenderer/index.jsx
var ActivableRenderer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var ActivableRenderer__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ActivableRenderer__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function ActivableRenderer__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ActivableRenderer__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ActivableRenderer__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// From React Toolbox https://github.com/react-toolbox/react-toolbox/blob/9d6ec1eedd320610a5b3fcfaf1ad308ba3d53196/components/hoc/ActivableRenderer.js




var ActivableRenderer_ActivableRendererFactory = function ActivableRendererFactory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { delay: 0 };
  return function (ActivableComponent) {
    var _class, _temp2;

    return _temp2 = _class = function (_Component) {
      ActivableRenderer__inherits(ActivableRenderer, _Component);

      function ActivableRenderer() {
        var _ref;

        var _temp, _this, _ret;

        ActivableRenderer__classCallCheck(this, ActivableRenderer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = ActivableRenderer__possibleConstructorReturn(this, (_ref = ActivableRenderer.__proto__ || Object.getPrototypeOf(ActivableRenderer)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'state', {
          enumerable: true,
          writable: true,
          value: {
            active: _this.props.active,
            rendered: _this.props.active
          }
        }), _temp), ActivableRenderer__possibleConstructorReturn(_this, _ret);
      }

      ActivableRenderer__createClass(ActivableRenderer, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
          if (nextProps.active && !this.props.active) this.renderAndActivate();
          if (!nextProps.active && this.props.active) this.deactivateAndUnrender();
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          clearTimeout(this.activateTimeout);
          clearTimeout(this.unrenderTimeout);
        }
      }, {
        key: 'renderAndActivate',
        value: function renderAndActivate() {
          var _this2 = this;

          if (this.unrenderTimeout) clearTimeout(this.unrenderTimeout);
          this.setState({ rendered: true, active: false }, function () {
            _this2.activateTimeout = setTimeout(function () {
              return _this2.setState({ active: true });
            }, 20);
          });
        }
      }, {
        key: 'deactivateAndUnrender',
        value: function deactivateAndUnrender() {
          var _this3 = this;

          this.setState({ rendered: true, active: false }, function () {
            _this3.unrenderTimeout = setTimeout(function () {
              _this3.setState({ rendered: false });
              _this3.unrenderTimeout = null;
            }, _this3.props.delay);
          });
        }
      }, {
        key: 'render',
        value: function render() {
          var _props = this.props,
              delay = _props.delay,
              others = ActivableRenderer__objectWithoutProperties(_props, ['delay']); // eslint-disable-line no-unused-vars


          var _state = this.state,
              active = _state.active,
              rendered = _state.rendered;

          return rendered ? react_default.a.createElement(ActivableComponent, ActivableRenderer__extends({}, others, { active: active })) : null;
        }
      }]);

      return ActivableRenderer;
    }(react["Component"]), Object.defineProperty(_class, 'propTypes', {
      enumerable: true,
      writable: true,
      value: {
        active: prop_types_default.a.bool.isRequired,
        children: prop_types_default.a.node,
        delay: prop_types_default.a.number
      }
    }), Object.defineProperty(_class, 'defaultProps', {
      enumerable: true,
      writable: true,
      value: {
        delay: options.delay
      }
    }), _temp2;
  };
};

/* harmony default export */ var components_ActivableRenderer = (ActivableRenderer_ActivableRendererFactory);
// EXTERNAL MODULE: ./client/app/shared/components/ComposeWindow/styles.scss
var ComposeWindow_styles = __webpack_require__("xFof");
var ComposeWindow_styles_default = /*#__PURE__*/__webpack_require__.n(ComposeWindow_styles);

// CONCATENATED MODULE: ./client/app/shared/components/ComposeWindow/index.jsx
var ComposeWindow__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ComposeWindow__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function ComposeWindow__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ComposeWindow__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ComposeWindow__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var ComposeWindow_ComposeWindow = function (_Shortcutter) {
  ComposeWindow__inherits(ComposeWindow, _Shortcutter);

  function ComposeWindow() {
    var _ref;

    var _temp, _this, _ret;

    ComposeWindow__classCallCheck(this, ComposeWindow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = ComposeWindow__possibleConstructorReturn(this, (_ref = ComposeWindow.__proto__ || Object.getPrototypeOf(ComposeWindow)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'state', {
      enumerable: true,
      writable: true,
      value: { minimized: false }
    }), Object.defineProperty(_this, 'toggleMin', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ minimized: !_this.state.minimized });
      }
    }), Object.defineProperty(_this, 'handleCloseShortcut', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.onClose();
      }
    }), _temp), ComposeWindow__possibleConstructorReturn(_this, _ret);
  }

  ComposeWindow__createClass(ComposeWindow, [{
    key: 'render',
    value: function render() {
      var props = this.props;
      var minimized = this.state.minimized;

      var className = classnames_default()(props.className, ComposeWindow_styles_default.a.wrapper, ComposeWindow__defineProperty({}, ComposeWindow_styles_default.a.minimized, minimized));
      return react_default.a.createElement(
        'div',
        { className: className },
        react_default.a.createElement(
          'section',
          { className: ComposeWindow_styles_default.a.body },
          react_default.a.createElement(
            'div',
            { className: ComposeWindow_styles_default.a.title },
            react_default.a.createElement(
              'h6',
              null,
              props.title
            ),
            react_default.a.createElement(react_toolbox_lib["IconButton"], {
              icon: minimized ? 'keyboard_arrow_up' : 'remove',
              className: ComposeWindow_styles_default.a.headerButton,
              onClick: this.toggleMin,
              tabIndex: -1
            }),
            react_default.a.createElement(react_toolbox_lib["IconButton"], {
              icon: 'close',
              className: ComposeWindow_styles_default.a.headerButton,
              onClick: props.onClose,
              tabIndex: -1
            })
          ),
          react_default.a.createElement(
            'div',
            { className: ComposeWindow_styles_default.a.content },
            props.children
          )
        )
      );
    }
  }]);

  return ComposeWindow;
}(mixins_shortcuts(react["Component"], [{ key: 'esc', func: 'handleCloseShortcut' }]));

ComposeWindow_ComposeWindow.propTypes = {
  active: prop_types_default.a.bool,
  children: prop_types_default.a.node,
  className: prop_types_default.a.string,
  onClose: prop_types_default.a.func,
  title: prop_types_default.a.string
};

/* harmony default export */ var components_ComposeWindow = (components_ActivableRenderer()(ComposeWindow_ComposeWindow));
// EXTERNAL MODULE: ./client/app/shared/styles/form.scss
var styles_form = __webpack_require__("QIbJ");
var form_default = /*#__PURE__*/__webpack_require__.n(styles_form);

// CONCATENATED MODULE: ./client/app/shared/components/TextArea/index.jsx
var TextArea__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var TextArea__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function TextArea__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function TextArea__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function TextArea__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function TextArea__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var TextArea_TextArea = function (_React$Component) {
  TextArea__inherits(TextArea, _React$Component);

  function TextArea() {
    TextArea__classCallCheck(this, TextArea);

    return TextArea__possibleConstructorReturn(this, (TextArea.__proto__ || Object.getPrototypeOf(TextArea)).apply(this, arguments));
  }

  TextArea__createClass(TextArea, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          label = _props.label,
          className = _props.className,
          errors = _props.errors,
          props = TextArea__objectWithoutProperties(_props, ['label', 'className', 'errors']);

      var errorMsg = errors.join(', ');
      var wrapperStyles = errorMsg ? classnames_default()(input_default.a.errored, className) : className;
      var textAreaStyles = classnames_default()(input_default.a.inputElement, form_default.a.bigTextArea);
      var labelStyles = errorMsg ? classnames_default()(form_default.a.label, form_default.a.errorLabel) : form_default.a.label;
      return react_default.a.createElement(
        'div',
        { className: wrapperStyles },
        react_default.a.createElement(
          'h6',
          { className: labelStyles },
          label
        ),
        react_default.a.createElement('textarea', TextArea__extends({
          className: textAreaStyles,
          ref: function ref(el) {
            _this2.textAreaRef = el;
          }
        }, props)),
        errorMsg && react_default.a.createElement(
          'div',
          { className: input_default.a.error },
          react_default.a.createElement(
            'p',
            { className: form_default.a.errorMsg },
            errorMsg
          )
        )
      );
    }
  }]);

  return TextArea;
}(react_default.a.Component);

TextArea_TextArea.propTypes = {
  label: prop_types_default.a.string.isRequired,
  value: prop_types_default.a.string,
  onChange: prop_types_default.a.func,
  errors: prop_types_default.a.array,
  className: prop_types_default.a.string
};

TextArea_TextArea.defaultProps = {
  label: '',
  errors: []
};

/* harmony default export */ var components_TextArea = (TextArea_TextArea);
// CONCATENATED MODULE: ./client/app/shared/components/EmployableHistory/employableHistoryNoteModal.jsx
function employableHistoryNoteModal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function employableHistoryNoteModal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function employableHistoryNoteModal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var employableHistoryNoteModal_EmployableHistoryNoteModal = function (_Resetter) {
  employableHistoryNoteModal__inherits(EmployableHistoryNoteModal, _Resetter);

  function EmployableHistoryNoteModal() {
    var _ref;

    var _temp, _this, _ret;

    employableHistoryNoteModal__classCallCheck(this, EmployableHistoryNoteModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = employableHistoryNoteModal__possibleConstructorReturn(this, (_ref = EmployableHistoryNoteModal.__proto__ || Object.getPrototypeOf(EmployableHistoryNoteModal)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'handleSubmit', {
      enumerable: true,
      writable: true,
      value: function value() {
        var note = _this.textAreaComponentRef.textAreaRef.value;
        _this.setState({ note: note }, function () {
          if (!_this.validate()) return;
          var noteProps = {
            name: 'Note',
            kind: 'note',
            data: { note: note }
          };
          _this.callAddEvent(noteProps);
        });
      }
    }), Object.defineProperty(_this, 'callAddEvent', {
      enumerable: true,
      writable: true,
      value: function value(noteProps) {
        var employableId = _this.props.employable.id;
        var addEventToEmployable = void 0;
        switch (_this.props.employableType) {
          case 'employee':
            addEventToEmployable = _this.props.addEventToEmployee;
            break;
          case 'installer':
            addEventToEmployable = _this.props.addEventToInstaller;
            break;
          case 'estimator':
            addEventToEmployable = _this.props.addEventToEstimator;
            break;
          default:
        }
        addEventToEmployable(employableId, noteProps).then(function () {
          _this.handleClose();
        }).catch(function () {}); // catching this to avoid console warnings...
      }
    }), Object.defineProperty(_this, 'handleClose', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.props.clearValidation();
        _this.props.closeNoteModal();
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var errors = _this.state.errors;

        var active = _this.props.active;

        return react_default.a.createElement(
          components_ComposeWindow,
          {
            active: active,
            title: 'Add Note',
            onClose: _this.handleClose
          },
          react_default.a.createElement(components_TextArea, {
            label: 'Notes *',
            defaultValue: '',
            className: ComposeWindow_styles_default.a.compose,
            errors: errors.note,
            autoFocus: true,
            ref: function ref(comp) {
              _this.textAreaComponentRef = comp;
            }
          }),
          react_default.a.createElement(
            'div',
            { className: ComposeWindow_styles_default.a.actions },
            react_default.a.createElement(lib_button["Button"], {
              label: 'Add Note',
              primary: true, flat: true, ripple: true,
              className: ComposeWindow_styles_default.a.submit,
              onClick: _this.handleSubmit
            })
          )
        );
      }
    }), _temp), employableHistoryNoteModal__possibleConstructorReturn(_this, _ret);
  }

  return EmployableHistoryNoteModal;
}(resetter(validator(react_default.a.Component)));

Object.defineProperty(employableHistoryNoteModal_EmployableHistoryNoteModal, 'DEFAULT_STATE', {
  enumerable: true,
  writable: true,
  value: {
    note: '',
    errors: {}
  }
});
Object.defineProperty(employableHistoryNoteModal_EmployableHistoryNoteModal, 'VALIDATIONS', {
  enumerable: true,
  writable: true,
  value: { note: true }
});


employableHistoryNoteModal_EmployableHistoryNoteModal.propTypes = {
  active: prop_types_default.a.bool.isRequired,
  addEventToEmployee: prop_types_default.a.func,
  addEventToInstaller: prop_types_default.a.func,
  addEventToEstimator: prop_types_default.a.func,
  clearValidation: prop_types_default.a.func.isRequired,
  closeNoteModal: prop_types_default.a.func.isRequired,
  employable: prop_types_default.a.object.isRequired
};

employableHistoryNoteModal_EmployableHistoryNoteModal.defaultProps = { active: false };

/* harmony default export */ var employableHistoryNoteModal = (Object(react_redux_es["connect"])(null, {
  addEventToEmployee: actionCreators["a" /* addEventToEmployee */],
  addEventToInstaller: actionCreators["c" /* addEventToInstaller */],
  addEventToEstimator: actionCreators["b" /* addEventToEstimator */],
  clearValidation: actionCreators["j" /* clearValidation */]
})(employableHistoryNoteModal_EmployableHistoryNoteModal));
// CONCATENATED MODULE: ./client/app/shared/components/EmployableHistory/index.jsx
function EmployableHistory__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function EmployableHistory__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function EmployableHistory__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var EmployableHistory_EmployableHistory = function (_Component) {
  EmployableHistory__inherits(EmployableHistory, _Component);

  function EmployableHistory(props) {
    EmployableHistory__classCallCheck(this, EmployableHistory);

    var _this = EmployableHistory__possibleConstructorReturn(this, (EmployableHistory.__proto__ || Object.getPrototypeOf(EmployableHistory)).call(this, props));

    Object.defineProperty(_this, 'toggleEventFilters', {
      enumerable: true,
      writable: true,
      value: function value(filter) {
        var _this$state = _this.state,
            isOnlyNotes = _this$state.isOnlyNotes,
            isOnlyEditEvents = _this$state.isOnlyEditEvents;

        if (filter === 'Notes') {
          if (isOnlyNotes) _this.setState({ isOnlyNotes: false });else _this.setState({ isAllEvents: false, isOnlyEditEvents: false, isOnlyNotes: true });
        }
        if (filter === 'Edit Events') {
          if (isOnlyEditEvents) _this.setState({ isOnlyEditEvents: false });else _this.setState({ isAllEvents: false, isOnlyEditEvents: true, isOnlyNotes: false });
        }
        if (filter === 'All') {
          _this.setState({ isAllEvents: true, isOnlyEditEvents: false, isOnlyNotes: false });
        }
      }
    });
    Object.defineProperty(_this, 'filterEventsList', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$state2 = _this.state,
            isOnlyNotes = _this$state2.isOnlyNotes,
            isOnlyEditEvents = _this$state2.isOnlyEditEvents,
            isAllEvents = _this$state2.isAllEvents;
        var _this$props$employabl = _this.props.employable.events,
            events = _this$props$employabl === undefined ? [] : _this$props$employabl;

        var filteredEvents = [];
        if (isOnlyNotes) {
          filteredEvents = events.filter(function (event) {
            return event.kind === 'note';
          });
        } else if (isOnlyEditEvents) {
          filteredEvents = events.filter(function (event) {
            return event.kind === 'update_profile';
          });
        } else if (isAllEvents) filteredEvents = events;

        return filteredEvents;
      }
    });
    Object.defineProperty(_this, 'groupEvents', {
      enumerable: true,
      writable: true,
      value: function value() {
        // Group By Profile Updates and Notes
        var _this$state3 = _this.state,
            isOnlyNotes = _this$state3.isOnlyNotes,
            isOnlyEditEvents = _this$state3.isOnlyEditEvents;

        var scopedEvents = {};
        var events = _this.filterEventsList();
        if (isOnlyNotes) {
          // eslint-disable-next-line dot-notation
          scopedEvents['Notes'] = events;
          return scopedEvents;
        } else if (isOnlyEditEvents) {
          scopedEvents['Edit Events'] = events;
          return scopedEvents;
        }
        events.forEach(function (event) {
          var scopeName = event.name === 'Update Profile' ? 'Edit Events' : 'Notes';
          if (!scopedEvents[scopeName]) scopedEvents[scopeName] = [];
          scopedEvents[scopeName].push(event);
        });
        return scopedEvents;
      }
    });
    Object.defineProperty(_this, 'addNote', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ noteActive: true });
      }
    });
    Object.defineProperty(_this, 'closeNoteModal', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ noteActive: false });
      }
    });
    Object.defineProperty(_this, 'renderEmployableHistoryList', {
      enumerable: true,
      writable: true,
      value: function value() {
        var scopedEvents = _this.groupEvents();
        return Object.keys(scopedEvents).map(function (name) {
          return react_default.a.createElement(
            'div',
            { key: name },
            react_default.a.createElement(EmployableHistory_EmployableHistoryCard, {
              name: name,
              employableType: _this.props.employableType,
              events: scopedEvents[name]
            })
          );
        });
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            employableType = _this$props.employableType,
            _this$props$employabl2 = _this$props.employable.events,
            events = _this$props$employabl2 === undefined ? [] : _this$props$employabl2;
        var _this$state4 = _this.state,
            noteActive = _this$state4.noteActive,
            isOnlyNotes = _this$state4.isOnlyNotes,
            isOnlyEditEvents = _this$state4.isOnlyEditEvents,
            isAllEvents = _this$state4.isAllEvents;

        return react_default.a.createElement(
          react["Fragment"],
          null,
          ['installer', 'estimator'].includes(employableType) && react_default.a.createElement(
            'div',
            { className: EmployableHistory_styles_default.a.noteBtnAndFiltersContainer },
            react_default.a.createElement(
              'button',
              { className: EmployableHistory_styles_default.a.createNoteBtn, onClick: _this.addNote },
              'Add Note'
            ),
            noteActive && react_default.a.createElement(employableHistoryNoteModal, {
              active: noteActive,
              employable: _this.props.employable,
              employableType: employableType,
              closeNoteModal: _this.closeNoteModal
            }),
            events.length !== 0 && react_default.a.createElement(components_EmployableHistoryFilters, {
              toggleEventFilters: _this.toggleEventFilters,
              isAllEvents: isAllEvents,
              isOnlyNotes: isOnlyNotes,
              isOnlyEditEvents: isOnlyEditEvents
            })
          ),
          events.length === 0 ? react_default.a.createElement(
            'div',
            { className: EmployableHistory_styles_default.a.emptyList },
            'History is Empty'
          ) : _this.renderEmployableHistoryList()
        );
      }
    });

    _this.state = {
      isOnlyNotes: false,
      isOnlyEditEvents: false,
      isAllEvents: true,
      noteActive: false
    };
    _this.toggleEventFilters = _this.toggleEventFilters.bind(_this);
    return _this;
  }

  return EmployableHistory;
}(react["Component"]);

EmployableHistory_EmployableHistory.propTypes = {
  employable: prop_types_default.a.object,
  employableType: prop_types_default.a.string
};

/* harmony default export */ var components_EmployableHistory = (EmployableHistory_EmployableHistory);
// EXTERNAL MODULE: ./client/app/shared/styles/tabs.scss
var styles_tabs = __webpack_require__("HwDC");
var tabs_default = /*#__PURE__*/__webpack_require__.n(styles_tabs);

// CONCATENATED MODULE: ./client/app/screens/main/screens/employees/components/employeeDetailsCard.jsx














var detailsTheme = { RTTabs: tabs_default.a };

var employeeDetailsCard_EmployeeDetailsCard = function EmployeeDetailsCard(_ref) {
  var employee = _ref.employee,
      role = _ref.role,
      _ref$position = _ref.position,
      position = _ref$position === undefined ? '' : _ref$position,
      _ref$mvw = _ref.mvw,
      mvw = _ref$mvw === undefined ? {} : _ref$mvw,
      activeTab = _ref.activeTab,
      onTabChange = _ref.onTabChange;

  var assignedInstallers = employee.assigned_installers || [];
  return react_default.a.createElement(
    react_css_themr_lib["ThemeProvider"],
    { theme: detailsTheme },
    react_default.a.createElement(
      users_UserDetailsCard,
      { user: employee, type: 'employees', role: role, resource: 'employee' },
      react_default.a.createElement(
        react_toolbox_lib["Tabs"],
        { index: activeTab, onChange: onTabChange, className: tabs_default.a.headersOnlyTabs },
        react_default.a.createElement(
          react_toolbox_lib["Tab"],
          { label: 'Basic Info' },
          react_default.a.createElement(users_UserDetailsBasicInfo, {
            user: employee,
            leadCertField: true,
            contractorTableApprovedField: true,
            canDeliverField: true,
            role: role
          }),
          react_default.a.createElement(users_UserDetailsBadgeInfo, { user: employee }),
          Object(services["a" /* can */])(role, 'view', 'SUPERVISOR_INFO', { position: position, mvw: mvw }) && assignedInstallers.length > 0 && react_default.a.createElement(
            users_UserDetailsRow,
            { title: 'Assigned Installers' },
            react_default.a.createElement(users_UserDetailsElement, {
              title: 'Installers',
              value: assignedInstallers.join(', ')
            })
          )
        ),
        react_default.a.createElement(
          react_toolbox_lib["Tab"],
          { label: 'History' },
          react_default.a.createElement(components_EmployableHistory, { employable: employee, employableType: 'employee' })
        )
      )
    )
  );
};

employeeDetailsCard_EmployeeDetailsCard.propTypes = {
  employee: types_employee.isRequired,
  role: prop_types_default.a.string,
  position: prop_types_default.a.string,
  mvw: prop_types_default.a.object,
  activeTab: prop_types_default.a.number,
  onTabChange: prop_types_default.a.func
};

/* harmony default export */ var employeeDetailsCard = (employeeDetailsCard_EmployeeDetailsCard);
// CONCATENATED MODULE: ./client/app/screens/main/screens/employees/employeeDetails.jsx
function employeeDetails__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function employeeDetails__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function employeeDetails__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var employeeDetails_EmployeeDetails = function (_Component) {
  employeeDetails__inherits(EmployeeDetails, _Component);

  function EmployeeDetails() {
    var _ref;

    var _temp, _this, _ret;

    employeeDetails__classCallCheck(this, EmployeeDetails);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = employeeDetails__possibleConstructorReturn(this, (_ref = EmployeeDetails.__proto__ || Object.getPrototypeOf(EmployeeDetails)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'componentDidMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.requestEmployee(_this.props.id);
      }
    }), Object.defineProperty(_this, 'componentWillUnmount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.ui.successMessage ? _this.props.updateUI('successMessage', '') : null;
      }
    }), Object.defineProperty(_this, 'handleTabChange', {
      enumerable: true,
      writable: true,
      value: function value(index) {
        return _this.props.updateUI('activeTab', index);
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        return react_default.a.createElement(
          'div',
          null,
          _this.props.ui.successMessage ? react_default.a.createElement(MessageBox["a" /* default */], { message: _this.props.ui.successMessage }) : null,
          !_this.props.loading ? react_default.a.createElement(employeeDetailsCard, {
            employee: _this.props.employee,
            role: _this.props.role,
            position: _this.props.position,
            mvw: _this.props.mvw,
            onTabChange: _this.handleTabChange,
            activeTab: _this.props.ui.activeTab
          }) : react_default.a.createElement(components_Loading, null)
        );
      }
    }), _temp), employeeDetails__possibleConstructorReturn(_this, _ret);
  }

  return EmployeeDetails;
}(react["Component"]);

employeeDetails_EmployeeDetails.propTypes = {
  requestEmployee: prop_types_default.a.func,
  updateUI: prop_types_default.a.func,
  employee: prop_types_default.a.object,
  loading: prop_types_default.a.bool,
  ui: prop_types_default.a.object,
  role: prop_types_default.a.string,
  position: prop_types_default.a.string,
  mvw: prop_types_default.a.object,
  id: prop_types_default.a.number
};

var employeeDetails_mapStateToProps = function mapStateToProps(state, ownProps) {
  var id = Number(ownProps.params.id);
  var employee = Object(reducers["i" /* getEmployeeById */])(state)[id];
  return {
    id: id,
    employee: employee,
    loading: employee ? employee.loading : true,
    role: Object(reducers["_12" /* getRole */])(state),
    position: state.user.position,
    mvw: state.user.manage_vendor_workrooms || {}
  };
};

/* harmony default export */ var employeeDetails = (transpiled_default()()(Object(react_redux_es["connect"])(employeeDetails_mapStateToProps, { requestEmployee: actionCreators["X" /* requestEmployee */] })(employeeDetails_EmployeeDetails)));
// CONCATENATED MODULE: ./client/app/shared/components/PhoneType/PhoneInput/index.jsx
var PhoneInput__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var PhoneInput__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function PhoneInput__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function PhoneInput__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function PhoneInput__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var PhoneInput_PhoneInput = function (_React$Component) {
  PhoneInput__inherits(PhoneInput, _React$Component);

  function PhoneInput(props) {
    PhoneInput__classCallCheck(this, PhoneInput);

    var _this = PhoneInput__possibleConstructorReturn(this, (PhoneInput.__proto__ || Object.getPrototypeOf(PhoneInput)).call(this, props));

    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }

  PhoneInput__createClass(PhoneInput, [{
    key: 'handleChange',
    value: function handleChange(value) {
      this.props.onChange(value);
    }
  }, {
    key: 'render',
    value: function render() {
      var newProps = PhoneInput__extends({}, this.props, {
        value: Object(utils["h" /* formatTelephone */])(this.props.value),
        onChange: this.handleChange,
        type: 'tel'
      });
      return react_default.a.createElement(react_toolbox_lib["Input"], newProps);
    }
  }]);

  return PhoneInput;
}(react_default.a.Component);

Object.defineProperty(PhoneInput_PhoneInput, 'propTypes', {
  enumerable: true,
  writable: true,
  value: {
    onChange: prop_types_default.a.func.isRequired,
    value: prop_types_default.a.string
  }
});
Object.defineProperty(PhoneInput_PhoneInput, 'defaultProps', {
  enumerable: true,
  writable: true,
  value: {
    value: ''
  }
});


/* harmony default export */ var PhoneType_PhoneInput = (PhoneInput_PhoneInput);
// EXTERNAL MODULE: ./client/app/shared/components/BreakLine/styles.scss
var BreakLine_styles = __webpack_require__("MjB7");
var BreakLine_styles_default = /*#__PURE__*/__webpack_require__.n(BreakLine_styles);

// CONCATENATED MODULE: ./client/app/shared/components/BreakLine/index.jsx





var BreakLine_BreakLine = function BreakLine(_ref) {
  var theme = _ref.theme;
  return react_default.a.createElement('div', { className: theme.breakLine });
};

BreakLine_BreakLine.propTypes = {
  theme: prop_types_default.a.shape({})
};

/* harmony default export */ var components_BreakLine = (Object(react_css_themr_lib["themr"])('BreakLine', BreakLine_styles_default.a)(BreakLine_BreakLine));
// EXTERNAL MODULE: ./client/app/shared/styles/dropdown.scss
var dropdown = __webpack_require__("8hjH");
var dropdown_default = /*#__PURE__*/__webpack_require__.n(dropdown);

// EXTERNAL MODULE: ./client/app/shared/styles/card.scss
var styles_card = __webpack_require__("gTrv");
var styles_card_default = /*#__PURE__*/__webpack_require__.n(styles_card);

// EXTERNAL MODULE: ./client/app/shared/components/PhoneType/phoneType.scss
var phoneType = __webpack_require__("1krR");
var phoneType_default = /*#__PURE__*/__webpack_require__.n(phoneType);

// CONCATENATED MODULE: ./client/app/shared/components/PhoneType/index.jsx
function PhoneType__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var PhoneType_PhoneType = function PhoneType(_ref) {
  var theme = _ref.theme,
      source = _ref.source,
      value = _ref.value,
      onChange = _ref.onChange;

  var types = source || constants["_15" /* PHONE_TYPES */];
  var lastIndex = types.length - 1;
  return react_default.a.createElement(
    'div',
    { className: theme.phoneTypes },
    types.map(function (type, index) {
      var _cx;

      var classnames = classnames_default()((_cx = {}, PhoneType__defineProperty(_cx, theme.selected, type === value), PhoneType__defineProperty(_cx, theme.phone, true), _cx));
      return react_default.a.createElement(
        'span',
        { key: type },
        react_default.a.createElement(
          'button',
          { className: classnames, onClick: function onClick() {
              return onChange(type);
            } },
          type
        ),
        lastIndex !== index ? '/' : null
      );
    })
  );
};

PhoneType_PhoneType.propTypes = {
  theme: prop_types_default.a.shape({
    phoneTypes: prop_types_default.a.string,
    selected: prop_types_default.a.string,
    phone: prop_types_default.a.string
  }),
  source: prop_types_default.a.arrayOf(prop_types_default.a.string),
  value: prop_types_default.a.string,
  onChange: prop_types_default.a.func.isRequired
};

/* harmony default export */ var components_PhoneType = (Object(react_css_themr_lib["themr"])('PhoneType', phoneType_default.a)(PhoneType_PhoneType));
// EXTERNAL MODULE: ./client/app/shared/styles/switch.scss
var styles_switch = __webpack_require__("+zLr");
var switch_default = /*#__PURE__*/__webpack_require__.n(styles_switch);

// CONCATENATED MODULE: ./client/app/screens/main/screens/employees/components/employeeForm.jsx
var employeeForm__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var employeeForm__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var employeeForm__cx;

function employeeForm__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function employeeForm__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function employeeForm__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function employeeForm__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function employeeForm__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






























var employeeForm_theme = { RTInput: input_default.a, RTDropdown: dropdown_default.a, RTCard: styles_card_default.a, RTSwitch: switch_default.a };
var employeeForm_mediumInput = classnames_default()((employeeForm__cx = {}, employeeForm__defineProperty(employeeForm__cx, form_default.a.inputs, true), employeeForm__defineProperty(employeeForm__cx, form_default.a.largeInput, true), employeeForm__cx));
var cancelClass = classnames_default()([form_default.a.cancelButton, form_default.a.actionButton]);
var TIMEZONE_SOURCE = constants["_46" /* TIMEZONES */].map(function (tz) {
  return { value: tz, label: tz };
});

var employeeForm_EmployeeForm = function (_Component) {
  employeeForm__inherits(EmployeeForm, _Component);

  function EmployeeForm(props) {
    employeeForm__classCallCheck(this, EmployeeForm);

    var _this = employeeForm__possibleConstructorReturn(this, (EmployeeForm.__proto__ || Object.getPrototypeOf(EmployeeForm)).call(this, props));

    employeeForm__initialiseProps.call(_this);

    _this.handleSave = _this.handleSave.bind(_this);
    _this.handleActive = _this.handleChange.bind(_this, 'active');
    _this.handleRole = _this.handleChange.bind(_this, 'role');
    _this.handleCancel = _this.handleCancel.bind(_this);
    _this.handleSelectChange = function (key, value) {
      return _this.handleChange(key, value.map(function (v) {
        return v.value;
      }));
    };
    _this.handlePrimaryType = _this.handleChange.bind(_this, 'primary_phone_type');
    _this.handleSecondaryType = _this.handleChange.bind(_this, 'secondary_phone_type');
    _this.handleName = _this.handleChange.bind(_this, 'name');
    _this.handlePosition = _this.handleChange.bind(_this, 'position');
    _this.handleEmail = _this.handleChange.bind(_this, 'email');
    _this.handleSecondaryPhone = _this.handleChange.bind(_this, 'secondary_phone');
    _this.handlePrimaryPhone = _this.handleChange.bind(_this, 'primary_phone');
    _this.handleLeadCertNumber = _this.handleChange.bind(_this, 'lead_cert_number');
    _this.handleBadgeNumber = _this.handleChange.bind(_this, 'number');
    _this.handleBadgeExpiration = _this.handleChange.bind(_this, 'expiration');
    _this.handleWorkrooms = _this.handleSelectChange.bind(_this, 'workrooms');
    _this.handleAssignable = _this.handleChange.bind(_this, 'assignable');
    _this.handleContractorTableApproved = _this.handleChange.bind(_this, 'contractor_table_approved');
    _this.handleCanDeliver = _this.handleChange.bind(_this, 'can_deliver');
    _this.handleTimezone = _this.handleChange.bind(_this, 'timezone');
    _this.handleLrrpDateExpiration = _this.handleChange.bind(_this, 'lrrp_date_expiration');
    _this.handleLhi = _this.handleChange.bind(_this, 'lhi');
    _this.handleRf = _this.handleChange.bind(_this, 'rf');
    _this.handleFd = _this.handleChange.bind(_this, 'fd');
    _this.handleIfi = _this.handleChange.bind(_this, 'ifi');
    _this.handleAh = _this.handleChange.bind(_this, 'ah');
    _this.handleBj = _this.handleChange.bind(_this, 'bj');
    _this.handleSam = _this.handleChange.bind(_this, 'sam');
    _this.handleWay = _this.handleChange.bind(_this, 'way');

    var employee = Object(lodash["cloneDeep"])(_this.props.employee);
    var workrooms = employee && employee.workrooms.map(function (w) {
      return w.id;
    }) || [];
    _this.state = {
      invalidEmail: false,
      employee: employee && employeeForm__extends({}, employee, { workrooms: workrooms }) || {
        active: true,
        assignable: false,
        contractor_table_approved: false,
        primary_phone_type: 'mobile',
        secondary_phone_type: 'mobile',
        badge: {},
        manage_vendor_workrooms: Object(lodash["cloneDeep"])(constants["B" /* DEFAULT_MVW */]),
        workrooms: workrooms
      }
    };
    return _this;
  }

  return EmployeeForm;
}(react["Component"]);

var employeeForm__initialiseProps = function _initialiseProps() {
  var _this2 = this;

  Object.defineProperty(this, 'handleChange', {
    enumerable: true,
    writable: true,
    value: function value(key, _value) {
      var _props$updateDiff = _this2.props.updateDiff,
          updateDiff = _props$updateDiff === undefined ? null : _props$updateDiff;

      var employee = _this2.state.employee;
      var emailChange = key === 'email';
      switch (key) {
        case 'number':
        case 'expiration':
          employee.badge = employee.badge || {};
          employee.badge[key] = _value;
          if (updateDiff) updateDiff(key, _value, 'badge');
          break;
        case 'timezone':
          employee.timezone = _value.value;
          if (updateDiff) updateDiff('timezone', _value.value);
          break;
        case 'lhi':
        case 'rf':
        case 'fd':
        case 'ifi':
        case 'ah':
        case 'bj':
        case 'sam':
        case 'way':
          employee.manage_vendor_workrooms[key] = _value;
          if (updateDiff) updateDiff(key, _value, 'manage_vendor_workrooms');
          break;
        default:
          if (updateDiff) updateDiff(key, _value);
          employee[key] = emailChange ? _value.replaceAll(' ', '') : _value;
      }
      _this2.setState({ employee: employee, invalidEmail: emailChange && !_this2.validateEmail(_value) });
    }
  });
  Object.defineProperty(this, 'handleCancel', {
    enumerable: true,
    writable: true,
    value: function value() {
      return _this2.props.onCancel();
    }
  });
  Object.defineProperty(this, 'handleSave', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _state$employee = _this2.state.employee,
          badge = _state$employee.badge,
          user = employeeForm__objectWithoutProperties(_state$employee, ['badge']);

      var position = user.position,
          workrooms = user.workrooms,
          role = user.role,
          id = user.id,
          user_id = user.user_id,
          assignable = user.assignable,
          contractor_table_approved = user.contractor_table_approved,
          lrrp_date_expiration = user.lrrp_date_expiration,
          can_deliver = user.can_deliver,
          _user$manage_vendor_w = user.manage_vendor_workrooms,
          manage_vendor_workrooms = _user$manage_vendor_w === undefined ? employeeForm__extends({}, constants["B" /* DEFAULT_MVW */]) : _user$manage_vendor_w,
          userAttributes = employeeForm__objectWithoutProperties(user, ['position', 'workrooms', 'role', 'id', 'user_id', 'assignable', 'contractor_table_approved', 'lrrp_date_expiration', 'can_deliver', 'manage_vendor_workrooms']);

      var newBadge = badge || {};

      var expiration = newBadge.expiration,
          otherBadgeThings = employeeForm__objectWithoutProperties(newBadge, ['expiration']);

      _this2.props.onSave({
        position: position,
        id: id,
        role: role,
        assignable: assignable,
        contractor_table_approved: contractor_table_approved,
        can_deliver: can_deliver,
        lrrp_date_expiration: Object(dateUtils["o" /* handleDateSave */])(lrrp_date_expiration),
        manage_vendor_workrooms: manage_vendor_workrooms,
        user_attributes: employeeForm__extends({}, userAttributes, {
          id: user_id,
          workroom_ids: workrooms,
          badge_attributes: employeeForm__extends({}, otherBadgeThings, {
            expiration: Object(dateUtils["o" /* handleDateSave */])(expiration)
          })
        })
      });
    }
  });
  Object.defineProperty(this, 'validateEmail', {
    enumerable: true,
    writable: true,
    value: function value(email) {
      return constants["I" /* EMAIL_VALIDATION_REGEX */].test(email);
    }
  });
  Object.defineProperty(this, 'filterWorkroomOptionsByVendor', {
    enumerable: true,
    writable: true,
    value: function value(workrooms, mvw) {
      if (!Object.keys(mvw).length) return [];
      return workrooms.filter(function (w) {
        return mvw[w.vendor.toLowerCase()] === true;
      });
    }
  });
  Object.defineProperty(this, 'renderTitle', {
    enumerable: true,
    writable: true,
    value: function value(employee, isEdit) {
      var _cx2;

      var title = isEdit ? employee.name || 'Edit Employee' : 'Add Employee';
      var switchClassNames = classnames_default()((_cx2 = {}, employeeForm__defineProperty(_cx2, form_default.a.switchTitleAdd, !isEdit), employeeForm__defineProperty(_cx2, form_default.a.switchTitle, true), _cx2));
      return react_default.a.createElement(
        'div',
        null,
        react_default.a.createElement(
          flexbox_react_dist_default.a,
          { justifyContent: 'space-between', className: form_default.a.divider },
          react_default.a.createElement(
            'div',
            null,
            react_default.a.createElement(
              'h5',
              { className: form_default.a.cardTitle },
              title
            ),
            react_default.a.createElement(
              'p',
              { className: form_default.a.cardSubtitle },
              'Please ensure that all fields contain accurate information'
            )
          ),
          react_default.a.createElement(
            'div',
            null,
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              name: 'active',
              label: 'Account Active',
              onChange: _this2.handleActive,
              className: switchClassNames,
              checked: employee.active
            }),
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              name: 'assignable',
              label: 'Can Be Assigned',
              onChange: _this2.handleAssignable,
              className: switchClassNames,
              checked: employee.assignable
            }),
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              name: 'contractor_table_approved',
              label: 'Contractor Table Approved',
              onChange: _this2.handleContractorTableApproved,
              className: switchClassNames,
              checked: employee.contractor_table_approved
            }),
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              name: 'can_deliver',
              label: 'Can Deliver',
              onChange: _this2.handleCanDeliver,
              className: switchClassNames,
              checked: employee.can_deliver
            })
          )
        )
      );
    }
  });
  Object.defineProperty(this, 'renderVendorSection', {
    enumerable: true,
    writable: true,
    value: function value(mvw) {
      return react_default.a.createElement(
        react["Fragment"],
        null,
        react_default.a.createElement(components_BreakLine, null),
        Object.keys(constants["_52" /* VENDOR_NAME_MAP */]).filter(function (k) {
          return k !== 'PFT';
        }).map(function (k) {
          return react_default.a.createElement(react_toolbox_lib["Checkbox"], {
            key: k,
            checked: mvw[k.toLowerCase()] || false,
            label: 'Manage ' + constants["_52" /* VENDOR_NAME_MAP */][k],
            onChange: _this2['handle' + Object(lodash["capitalize"])(k)],
            className: form_default.a.checkboxListItem,
            theme: checkbox_default.a
          });
        })
      );
    }
  });
  Object.defineProperty(this, 'render', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _state = _this2.state,
          _state$employee2 = _state.employee,
          employee = _state$employee2 === undefined ? null : _state$employee2,
          invalidEmail = _state.invalidEmail;
      var _props = _this2.props,
          errors = _props.errors,
          user = _props.user,
          _props$workrooms = _props.workrooms,
          workrooms = _props$workrooms === undefined ? null : _props$workrooms;

      var isEdit = !!employee.id;
      var gError = Object(utils["c" /* error */])('global', errors);
      var badge = employee.badge || {};
      var workroomOptions = Object(utils["j" /* generateSource */])(_this2.filterWorkroomOptionsByVendor(workrooms, user.manage_vendor_workrooms));
      var defaultMvw = employee && employeeForm__typeof(employee.manage_vendor_workrooms) === 'object' ? employee.manage_vendor_workrooms : employeeForm__extends({}, constants["B" /* DEFAULT_MVW */]);
      return react_default.a.createElement(
        react_css_themr_lib["ThemeProvider"],
        { theme: employeeForm_theme },
        react_default.a.createElement(
          components_Card,
          null,
          _this2.renderTitle(employee, isEdit),
          gError ? react_default.a.createElement(MessageBox["a" /* default */], { error: true, message: gError }) : null,
          react_default.a.createElement(
            flexbox_react_dist_default.a,
            { flexWrap: 'wrap', className: form_default.a.divider },
            react_default.a.createElement(react_toolbox_lib["Input"], {
              label: 'Name',
              className: employeeForm_mediumInput,
              value: employee.name,
              onChange: _this2.handleName,
              error: Object(utils["c" /* error */])('user.name', errors),
              required: true
            }),
            react_default.a.createElement(formElements_RoleSelect, {
              className: employeeForm_mediumInput,
              onChange: _this2.handleRole,
              value: employee.role,
              error: Object(utils["c" /* error */])('role', errors),
              required: true,
              simpleValue: true
            }),
            react_default.a.createElement(react_toolbox_lib["Input"], {
              label: 'Position',
              value: employee.position,
              className: employeeForm_mediumInput,
              onChange: _this2.handlePosition,
              error: Object(utils["c" /* error */])('position', errors),
              required: true
            }),
            react_default.a.createElement(react_select, {
              className: employeeForm_mediumInput,
              label: 'Time Zone',
              placeholder: 'Select Time Zone',
              onChange: _this2.handleTimezone,
              options: TIMEZONE_SOURCE,
              value: employee.timezone,
              error: Object(utils["c" /* error */])('timezone', errors),
              required: true
            }),
            react_default.a.createElement(react_toolbox_lib["Input"], {
              label: 'Email',
              type: 'email',
              value: employee.email,
              className: employeeForm_mediumInput,
              onChange: _this2.handleEmail,
              error: invalidEmail ? 'Invalid Email' : Object(utils["c" /* error */])('user.email', errors),
              required: true
            }),
            react_default.a.createElement(
              PhoneType_PhoneInput,
              {
                label: 'Primary Phone',
                type: 'tel',
                value: employee.primary_phone,
                className: employeeForm_mediumInput,
                onChange: _this2.handlePrimaryPhone,
                error: Object(utils["c" /* error */])('user.primary_phone', errors)
              },
              react_default.a.createElement(components_PhoneType, { value: employee.primary_phone_type, onChange: _this2.handlePrimaryType })
            ),
            react_default.a.createElement(
              PhoneType_PhoneInput,
              {
                label: 'Secondary Phone',
                type: 'tel',
                value: employee.secondary_phone,
                className: employeeForm_mediumInput,
                onChange: _this2.handleSecondaryPhone,
                error: Object(utils["c" /* error */])('user.secondary_phone', errors)
              },
              react_default.a.createElement(components_PhoneType, {
                value: employee.secondary_phone_type,
                onChange: _this2.handleSecondaryType
              })
            ),
            Object(services_ability["a" /* can */])(user.role, 'manage', 'manage_vendors') && _this2.renderVendorSection(defaultMvw)
          ),
          react_default.a.createElement(
            flexbox_react_dist_default.a,
            { flexWrap: 'wrap', className: form_default.a.divider },
            react_default.a.createElement(react_toolbox_lib["Input"], {
              label: 'Badge number',
              className: employeeForm_mediumInput,
              value: badge.number || '',
              onChange: _this2.handleBadgeNumber,
              error: Object(utils["c" /* error */])('user.badge.number', errors)
            }),
            react_default.a.createElement(DatePicker, {
              label: 'Badge expiration',
              className: employeeForm_mediumInput,
              value: badge.expiration || '',
              onChange: _this2.handleBadgeExpiration,
              error: Object(utils["c" /* error */])('user.badge.expiration', errors)
            }),
            react_default.a.createElement(react_toolbox_lib["Input"], {
              label: 'Lead Cert Number',
              className: employeeForm_mediumInput,
              value: employee.lead_cert_number,
              onChange: _this2.handleLeadCertNumber,
              error: Object(utils["c" /* error */])('user.lead_cert_number', errors)
            }),
            react_default.a.createElement(DatePicker, {
              label: 'LRRP Training Expiration',
              className: employeeForm_mediumInput,
              value: employee.lrrp_date_expiration || '',
              onChange: _this2.handleLrrpDateExpiration,
              error: Object(utils["c" /* error */])('user.lrrp_date_expiration', errors)
            }),
            react_default.a.createElement(react_select, {
              multi: true,
              resetValue: [],
              name: 'EmployeeWorkrooms',
              className: ReactSelect_styles_default.a.selectWrapper,
              options: workroomOptions,
              value: employee.workrooms,
              onChange: _this2.handleWorkrooms,
              label: 'Assign workroom(s) to employee',
              placeholder: 'Select workroom(s)'
            })
          ),
          react_default.a.createElement(
            flexbox_react_dist_default.a,
            { justifyContent: 'flex-end', flexWrap: 'wrap' },
            react_default.a.createElement(
              react_toolbox_lib["CardActions"],
              { className: form_default.a.actionsWrapper },
              react_default.a.createElement(ColoredButton["a" /* default */], {
                className: cancelClass,
                responsive: true,
                color: 'gray',
                label: 'Cancel',
                onClick: _this2.handleCancel
              }),
              react_default.a.createElement(ColoredButton["a" /* default */], {
                className: form_default.a.actionButton,
                responsive: true,
                color: 'green',
                label: isEdit ? 'Save Changes' : 'Add employee',
                onClick: _this2.handleSave,
                disabled: invalidEmail
              })
            )
          )
        )
      );
    }
  });
};

employeeForm_EmployeeForm.propTypes = {
  errors: prop_types_default.a.object,
  employee: types_employee,
  workrooms: prop_types_default.a.array,
  onCancel: prop_types_default.a.func,
  onSave: prop_types_default.a.func,
  updateDiff: prop_types_default.a.func,
  user: prop_types_default.a.object
};

/* harmony default export */ var employeeForm = (employeeForm_EmployeeForm);
// CONCATENATED MODULE: ./client/app/screens/main/screens/employees/employeeNew.jsx
var employeeNew__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function employeeNew__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function employeeNew__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function employeeNew__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var employeeNew_EmployeeNew = function (_Component) {
  employeeNew__inherits(EmployeeNew, _Component);

  function EmployeeNew(props) {
    employeeNew__classCallCheck(this, EmployeeNew);

    var _this = employeeNew__possibleConstructorReturn(this, (EmployeeNew.__proto__ || Object.getPrototypeOf(EmployeeNew)).call(this, props));

    _this.handleSave = _this.handleSave.bind(_this);
    _this.handleCancel = function () {
      _this.props.dispatch(Object(actionCreators["O" /* navigate */])('/employees'));
    };
    _this.setSucessMessage = function (name, email) {
      var msg = name + ' was added. A confirmation email was sent to ' + email + '.\n      This email will expire in 7 days.';
      _this.props.updateUI('successMessage', msg);
    };
    return _this;
  }

  employeeNew__createClass(EmployeeNew, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var dispatch = this.props.dispatch;

      dispatch(Object(actionCreators["k" /* clearValidationErrors */])('EMPLOYEE'));
    }
  }, {
    key: 'handleSave',
    value: function handleSave(employee) {
      var dispatch = this.props.dispatch;

      dispatch(Object(actionCreators["n" /* createEmployee */])(employee, this.setSucessMessage));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          errors = _props.errors,
          workrooms = _props.workrooms,
          user = _props.user;

      return react_default.a.createElement(employeeForm, {
        errors: errors,
        onSave: this.handleSave,
        onCancel: this.handleCancel,
        workrooms: workrooms,
        user: user
      });
    }
  }]);

  return EmployeeNew;
}(react["Component"]);

employeeNew_EmployeeNew.propTypes = {
  dispatch: prop_types_default.a.func,
  updateUI: prop_types_default.a.func,
  errors: prop_types_default.a.object,
  workrooms: prop_types_default.a.array,
  user: prop_types_default.a.object
};

var employeeNew_mapStateToProps = function mapStateToProps(state) {
  return {
    errors: Object(reducers["j" /* getEmployeeErrors */])(state) || {},
    workrooms: Object(reducers["_37" /* getWorkroomList */])(state),
    user: state.user
  };
};

/* harmony default export */ var employeeNew = (transpiled_default()()(Object(react_redux_es["connect"])(employeeNew_mapStateToProps)(employeeNew_EmployeeNew)));
// CONCATENATED MODULE: ./client/app/screens/main/screens/employees/employeeEdit.jsx
var employeeEdit__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var employeeEdit__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function employeeEdit__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function employeeEdit__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function employeeEdit__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function employeeEdit__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var employeeEdit_EmployeeEdit = function (_Component) {
  employeeEdit__inherits(EmployeeEdit, _Component);

  function EmployeeEdit(props) {
    employeeEdit__classCallCheck(this, EmployeeEdit);

    var _this = employeeEdit__possibleConstructorReturn(this, (EmployeeEdit.__proto__ || Object.getPrototypeOf(EmployeeEdit)).call(this, props));

    Object.defineProperty(_this, 'componentDidMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.requestEmployee(_this.props.id);
      }
    });
    Object.defineProperty(_this, 'componentWillUnmount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.clearValidationErrors('EMPLOYEE');
      }
    });
    Object.defineProperty(_this, 'updateEmployeeChanges', {
      enumerable: true,
      writable: true,
      value: function value(key, _value) {
        var nestedField = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

        var newEmployeeChanges = Object.assign({}, _this.state.employeeChanges);
        if (nestedField) {
          newEmployeeChanges[nestedField] = employeeEdit__extends({}, newEmployeeChanges[nestedField] || {}, employeeEdit__defineProperty({}, key, _value));
        } else newEmployeeChanges[key] = _value;
        _this.setState({ employeeChanges: newEmployeeChanges });
      }
    });
    Object.defineProperty(_this, 'handleKey', {
      enumerable: true,
      writable: true,
      value: function value(employee, employeeChanges, key) {
        var profileDiff = {};
        var oldVal = key === 'workrooms' ? employee[key].map(function (w) {
          return w.id;
        }) : employee[key];
        var newVal = employeeChanges[key];
        if (!Object(lodash["isEqual"])(oldVal, newVal)) profileDiff[key] = [oldVal, newVal];
        return profileDiff;
      }
    });
    Object.defineProperty(_this, 'handleNestedKey', {
      enumerable: true,
      writable: true,
      value: function value(employee, employeeChanges, key) {
        var profileDiff = {};
        var nestedKeys = Object.keys(employeeChanges[key]);
        profileDiff[key] = {};
        nestedKeys.forEach(function (nKey) {
          var oldVal = employee[key] ? employee[key][nKey] : '';
          var newVal = Object(lodash["get"])(employeeChanges, [key, nKey], 'null');
          if (!Object(lodash["isEqual"])(oldVal, newVal)) profileDiff[key][nKey] = [oldVal, newVal];
        });
        if (Object.keys(profileDiff[key]).length === 0) delete profileDiff[key];
        return profileDiff;
      }
    });
    Object.defineProperty(_this, 'createProfileDiff', {
      enumerable: true,
      writable: true,
      value: function value() {
        var employeeChanges = _this.state.employeeChanges;
        var employee = _this.props.employee;

        var profileDiff = {};
        Object.keys(employeeChanges).forEach(function (key) {
          var newDiffObj = employeeEdit__typeof(employeeChanges[key]) === 'object' && !Array.isArray(employeeChanges[key]) ? _this.handleNestedKey(employee, employeeChanges, key) : _this.handleKey(employee, employeeChanges, key);
          Object.assign(profileDiff, newDiffObj);
        });
        return profileDiff;
      }
    });
    Object.defineProperty(_this, 'handleSave', {
      enumerable: true,
      writable: true,
      value: function value(employee) {
        var profileDiff = _this.createProfileDiff();
        var eventProps = {
          name: 'Update Profile',
          kind: 'update_profile',
          data: { updates: profileDiff }
        };
        _this.props.updateEmployee(employee, _this.setSuccessMessage).then(function () {
          return !Object(lodash["isEmpty"])(profileDiff) ? _this.props.addEventToEmployee(employee.id, eventProps) : null;
        });
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            employee = _this$props.employee,
            errors = _this$props.errors,
            loading = _this$props.loading,
            workrooms = _this$props.workrooms,
            user = _this$props.user;

        return !loading ? react_default.a.createElement(employeeForm, {
          employee: employee,
          errors: errors,
          onSave: _this.handleSave,
          updateDiff: _this.updateEmployeeChanges,
          onCancel: _this.handleCancel,
          workrooms: workrooms,
          user: user
        }) : react_default.a.createElement(
          'p',
          null,
          'Loading...'
        );
      }
    });

    _this.state = { employeeChanges: {} };
    _this.handleSave = _this.handleSave.bind(_this);
    _this.updateEmployeeChanges = _this.updateEmployeeChanges.bind(_this);
    _this.handleCancel = function () {
      _this.props.navigateBack();
    };
    _this.setSuccessMessage = function () {
      _this.props.updateUI('successMessage', 'Changes have been saved');
    };
    return _this;
  }

  return EmployeeEdit;
}(react["Component"]);

employeeEdit_EmployeeEdit.propTypes = {
  id: prop_types_default.a.number,
  updateUI: prop_types_default.a.func,
  updateEmployee: prop_types_default.a.func,
  addEventToEmployee: prop_types_default.a.func,
  navigateBack: prop_types_default.a.func,
  requestEmployee: prop_types_default.a.func,
  clearValidationErrors: prop_types_default.a.func,
  loading: prop_types_default.a.bool,
  employee: prop_types_default.a.object,
  errors: prop_types_default.a.object,
  workrooms: prop_types_default.a.array,
  user: prop_types_default.a.object
};

var employeeEdit_mapStateToProps = function mapStateToProps(state, ownProps) {
  var id = Number(ownProps.params.id);
  var employee = Object(reducers["i" /* getEmployeeById */])(state)[id];
  return {
    id: id,
    employee: employee,
    errors: Object(reducers["j" /* getEmployeeErrors */])(state) || {},
    loading: employee ? employee.loading : true,
    workrooms: Object(reducers["_37" /* getWorkroomList */])(state),
    user: state.user
  };
};

/* harmony default export */ var employeeEdit = (transpiled_default()()(Object(react_redux_es["connect"])(employeeEdit_mapStateToProps, {
  requestEmployee: actionCreators["X" /* requestEmployee */],
  clearValidationErrors: actionCreators["k" /* clearValidationErrors */],
  updateEmployee: actionCreators["_61" /* updateEmployee */],
  navigateBack: actionCreators["P" /* navigateBack */],
  addEventToEmployee: actionCreators["a" /* addEventToEmployee */] })(employeeEdit_EmployeeEdit)));
// CONCATENATED MODULE: ./client/app/screens/main/screens/employees/index.jsx
var employees__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function employees__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function employees__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function employees__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var employees_Employees = function (_React$Component) {
  employees__inherits(Employees, _React$Component);

  function Employees(context, props) {
    employees__classCallCheck(this, Employees);

    var _this = employees__possibleConstructorReturn(this, (Employees.__proto__ || Object.getPrototypeOf(Employees)).call(this, context, props));

    Object.defineProperty(_this, 'componentDidMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.requestWorkroomList();
      }
    });
    Object.defineProperty(_this, 'onSearch', {
      enumerable: true,
      writable: true,
      value: function value(e, _value) {
        e.preventDefault();
        var filters = employees__extends({}, _this.props.filters);
        filters.query = _value;
        _this.handleFilterChange(filters);
      }
    });
    Object.defineProperty(_this, 'addAction', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.navigate('/employees/new');
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        return react_default.a.createElement(
          'div',
          null,
          react_default.a.createElement(components_PageActionBar, {
            resource: 'employee',
            role: _this.props.role,
            addAction: _this.addAction,
            showFiltersBtn: _this.isIndexRoute(),
            title: 'Employee Management',
            searchText: 'Search for an employee by name or position',
            toggleFilters: _this.toggleFilterDrawer,
            onSearch: _this.onSearch,
            path: _this.props.location.pathname
          }),
          react_default.a.createElement(
            'div',
            { className: contentArea_default.a.contentAreaContainer },
            _this.props.children,
            react_default.a.createElement(Filters_UserFilters, {
              active: _this.state.showFilterDrawer,
              onOverlayClick: _this.toggleFilterDrawer,
              handleFilterChange: _this.handleFilterChange,
              filters: _this.props.filters,
              title: 'Employees',
              reset: _this.props.resetEmployeeFilters,
              showRoles: true,
              role: _this.props.role,
              resource: 'employee'
            })
          )
        );
      }
    });

    _this.addAction = _this.addAction.bind(_this);
    _this.toggleFilterDrawer = function () {
      return _this.setState({ showFilterDrawer: !_this.state.showFilterDrawer });
    };
    _this.handleFilterChange = function (filters) {
      return _this.props.setEmployeeFilters(filters);
    };
    _this.state = {
      showFilterDrawer: false, canViewInactive: Object(services["a" /* can */])(_this.props.role, 'view', 'inactive')
    };
    _this.isIndexRoute = function () {
      return _this.props.location.pathname === _this.props.route.path;
    };
    return _this;
  }

  return Employees;
}(react_default.a.Component);

employees_Employees.propTypes = {
  setEmployeeFilters: prop_types_default.a.func.isRequired,
  location: prop_types_default.a.shape({
    pathname: prop_types_default.a.string.isRequired
  }).isRequired,
  route: prop_types_default.a.shape({
    path: prop_types_default.a.string.isRequired
  }).isRequired,
  role: prop_types_default.a.string,
  requestWorkroomList: prop_types_default.a.func.isRequired,
  navigate: prop_types_default.a.func.isRequired,
  children: prop_types_default.a.node.isRequired,
  resetEmployeeFilters: prop_types_default.a.func.isRequired,
  filters: prop_types_default.a.object
};

var employees_mapStateToProps = function mapStateToProps(state) {
  return {
    role: Object(reducers["_12" /* getRole */])(state), filters: Object(reducers["k" /* getEmployeeFilters */])(state)
  };
};

/* harmony default export */ var screens_employees = (transpiled_default()({ key: 'employees', state: { successMessage: '', activeTab: 0 } })(Object(react_redux_es["connect"])(employees_mapStateToProps, { requestWorkroomList: actionCreators["_31" /* requestWorkroomList */], navigate: actionCreators["O" /* navigate */], setEmployeeFilters: actionCreators["_45" /* setEmployeeFilters */], resetEmployeeFilters: actionCreators["_33" /* resetEmployeeFilters */] })(employees_Employees)));


// CONCATENATED MODULE: ./client/app/shared/components/Filters/StoreFilters/index.jsx
var StoreFilters__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var StoreFilters__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function StoreFilters__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function StoreFilters__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function StoreFilters__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var mapFilterValues = function mapFilterValues(values) {
  return values.map(function (v) {
    return v.value;
  });
};

var StoreFilters_StoreFilters = function (_Component) {
  StoreFilters__inherits(StoreFilters, _Component);

  function StoreFilters() {
    var _ref;

    var _temp, _this, _ret;

    StoreFilters__classCallCheck(this, StoreFilters);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = StoreFilters__possibleConstructorReturn(this, (_ref = StoreFilters.__proto__ || Object.getPrototypeOf(StoreFilters)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'handleFilter', {
      enumerable: true,
      writable: true,
      value: function value(key, _value) {
        var filters = StoreFilters__extends({}, _this.props.filters);
        filters[key] = _value;
        _this.props.handleFilterChange(filters);
      }
    }), Object.defineProperty(_this, 'handleWorkrooms', {
      enumerable: true,
      writable: true,
      value: function value(values) {
        return _this.handleFilter('for_workrooms', mapFilterValues(values));
      }
    }), Object.defineProperty(_this, 'handleDivisions', {
      enumerable: true,
      writable: true,
      value: function value(values) {
        return _this.handleFilter('for_divisions', mapFilterValues(values));
      }
    }), Object.defineProperty(_this, 'handleRegions', {
      enumerable: true,
      writable: true,
      value: function value(values) {
        return _this.handleFilter('for_regions', mapFilterValues(values));
      }
    }), Object.defineProperty(_this, 'handleMarkets', {
      enumerable: true,
      writable: true,
      value: function value(values) {
        return _this.handleFilter('for_markets', mapFilterValues(values));
      }
    }), _temp), StoreFilters__possibleConstructorReturn(_this, _ret);
  }

  StoreFilters__createClass(StoreFilters, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.requestDivisionList();
      this.props.requestRegionList();
      this.props.requestMarketList();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          filters = _props.filters,
          active = _props.active,
          reset = _props.reset,
          divisions = _props.divisions,
          regions = _props.regions,
          markets = _props.markets;

      return react_default.a.createElement(
        components_FiltersDrawer,
        {
          title: 'Store',
          active: active,
          toggle: this.props.onOverlayClick,
          reset: reset
        },
        react_default.a.createElement(formElements_WorkroomSelect, {
          value: filters.for_workrooms,
          onChange: this.handleWorkrooms,
          className: Filters_styles_default.a.dropdown,
          key: 'workroom'
        }),
        react_default.a.createElement(react_select, {
          key: 'divisions',
          className: Filters_styles_default.a.dropdown,
          label: 'Divisions',
          name: 'divisions',
          placeholder: 'All Divisions',
          multi: true,
          options: Object(utils["j" /* generateSource */])(divisions),
          value: filters.for_divisions,
          onChange: this.handleDivisions
        }),
        react_default.a.createElement(react_select, {
          key: 'regions',
          className: Filters_styles_default.a.dropdown,
          label: 'Regions',
          name: 'regions',
          placeholder: 'All Regions',
          multi: true,
          options: Object(utils["j" /* generateSource */])(regions),
          value: filters.for_regions,
          onChange: this.handleRegions
        }),
        react_default.a.createElement(react_select, {
          key: 'markets',
          className: Filters_styles_default.a.dropdown,
          label: 'Markets',
          name: 'markets',
          placeholder: 'All Markets',
          multi: true,
          options: Object(utils["j" /* generateSource */])(markets),
          value: filters.for_markets,
          onChange: this.handleMarkets
        })
      );
    }
  }]);

  return StoreFilters;
}(react["Component"]);

StoreFilters_StoreFilters.propTypes = {
  handleFilterChange: prop_types_default.a.func,
  onOverlayClick: prop_types_default.a.func,
  filters: prop_types_default.a.object,
  active: prop_types_default.a.bool,
  reset: prop_types_default.a.func.isRequired,
  requestDivisionList: prop_types_default.a.func.isRequired,
  requestRegionList: prop_types_default.a.func.isRequired,
  requestMarketList: prop_types_default.a.func.isRequired,
  markets: prop_types_default.a.array,
  regions: prop_types_default.a.array,
  divisions: prop_types_default.a.array
};

var StoreFilters_mapStateToProps = function mapStateToProps(state) {
  return {
    markets: Object(reducers["O" /* getMarketList */])(state),
    regions: Object(reducers["_11" /* getRegionList */])(state),
    divisions: Object(reducers["d" /* getDivisionList */])(state)
  };
};

/* harmony default export */ var Filters_StoreFilters = (Object(react_redux_es["connect"])(StoreFilters_mapStateToProps, { requestDivisionList: actionCreators["W" /* requestDivisionList */], requestRegionList: actionCreators["_22" /* requestRegionList */], requestMarketList: actionCreators["_12" /* requestMarketList */] })(StoreFilters_StoreFilters));
// CONCATENATED MODULE: ./client/app/shared/types/store.js


var StoreType = prop_types_default.a.shape({
  id: prop_types_default.a.number,
  name: prop_types_default.a.string.isRequired,
  number: prop_types_default.a.string.isRequired,
  phone_number: prop_types_default.a.string.isRequired,
  region_name: prop_types_default.a.string.isRequired,
  workroom_id: prop_types_default.a.number.isRequired,
  workroom_name: prop_types_default.a.string.isRequired,
  market_name: prop_types_default.a.string,
  division_name: prop_types_default.a.string,
  cpo_iso: prop_types_default.a.string,
  disable_cpo_emails: prop_types_default.a.bool.isRequired
});

/* harmony default export */ var types_store = (StoreType);
// CONCATENATED MODULE: ./client/app/screens/main/screens/stores/components/storeCard.jsx







var storeCard_StoreCard = function StoreCard(_ref) {
  var store = _ref.store;
  return react_default.a.createElement(
    es["c" /* Link */],
    { className: resourceCard_default.a.viewLink, to: '/stores/' + store.id },
    react_default.a.createElement(
      components_Card,
      { key: store.id, className: resourceCard_default.a.resourceCard },
      react_default.a.createElement(ResourceCardElement, { title: 'Store Number', size: 'small', value: store.number }),
      react_default.a.createElement(ResourceCardElement, { title: 'Store Name', size: 'small', value: store.name }),
      react_default.a.createElement(ResourceCardElement, { title: 'Phone Number', size: 'small', value: store.phone_number }),
      react_default.a.createElement(ResourceCardElement, { title: 'Workroom', size: 'small', value: store.workroom_name || 'No Workroom' }),
      react_default.a.createElement(ResourceCardElement, { title: 'ISO/IST', size: 'small', value: store.cpo_iso })
    )
  );
};

storeCard_StoreCard.propTypes = {
  store: types_store.isRequired
};

/* harmony default export */ var storeCard = (storeCard_StoreCard);
// CONCATENATED MODULE: ./client/app/screens/main/screens/stores/storeList.jsx
var storeList__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function storeList__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function storeList__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function storeList__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var storeList_StoreList = function (_Component) {
  storeList__inherits(StoreList, _Component);

  function StoreList() {
    var _ref;

    var _temp, _this, _ret;

    storeList__classCallCheck(this, StoreList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = storeList__possibleConstructorReturn(this, (_ref = StoreList.__proto__ || Object.getPrototypeOf(StoreList)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'viewAction', {
      enumerable: true,
      writable: true,
      value: function value(id) {
        return _this.props.navigate('/stores/' + id);
      }
    }), _temp), storeList__possibleConstructorReturn(_this, _ret);
  }

  storeList__createClass(StoreList, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.requestAllStores();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.ui.successMessage) {
        this.props.updateUI('successMessage', '');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          stores = _props.stores,
          role = _props.role,
          loading = _props.loading;


      return react_default.a.createElement(
        'div',
        null,
        this.props.ui.successMessage && react_default.a.createElement(MessageBox["a" /* default */], { message: this.props.ui.successMessage }),
        loading && react_default.a.createElement(components_Loading, { message: 'Loading stores...' }),
        stores.map(function (store) {
          return react_default.a.createElement(storeCard, {
            key: 'store-' + store.id,
            role: role,
            store: store,
            onSelect: _this2.viewAction
          });
        }),
        !loading && stores.length === 0 && 'Your search yielded no results.'
      );
    }
  }]);

  return StoreList;
}(react["Component"]);

Object.defineProperty(storeList_StoreList, 'propTypes', {
  enumerable: true,
  writable: true,
  value: {
    updateUI: prop_types_default.a.func.isRequired,
    requestAllStores: prop_types_default.a.func.isRequired,
    navigate: prop_types_default.a.func.isRequired,
    ui: prop_types_default.a.shape({
      successMessage: prop_types_default.a.string
    }),
    stores: prop_types_default.a.arrayOf(types_store).isRequired,
    role: prop_types_default.a.string,
    loading: prop_types_default.a.bool
  }
});


var storeList_mapStateToProps = function mapStateToProps(state) {
  return {
    stores: Object(reducers["_18" /* getStoreList */])(state),
    loading: Object(reducers["_20" /* getStoreLoading */])(state),
    role: Object(reducers["_12" /* getRole */])(state)
  };
};

/* harmony default export */ var storeList = (transpiled_default()()(Object(react_redux_es["connect"])(storeList_mapStateToProps, { requestAllStores: actionCreators["U" /* requestAllStores */], navigate: actionCreators["O" /* navigate */] })(storeList_StoreList)));
// CONCATENATED MODULE: ./client/app/shared/components/PhoneLink/index.jsx
var PhoneLink__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function PhoneLink__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





var PhoneLink_PhoneLink = function PhoneLink(_ref) {
  var number = _ref.number,
      children = _ref.children,
      props = PhoneLink__objectWithoutProperties(_ref, ['number', 'children']);

  return react_default.a.createElement(
    'a',
    PhoneLink__extends({
      target: '_blank',
      rel: 'noopener noreferrer',
      href: 'tel:' + number
    }, props),
    children || Object(utils["h" /* formatTelephone */])(number)
  );
};

PhoneLink_PhoneLink.propTypes = {
  number: prop_types_default.a.string.isRequired,
  children: prop_types_default.a.node
};

/* harmony default export */ var components_PhoneLink = (PhoneLink_PhoneLink);
// CONCATENATED MODULE: ./client/app/shared/components/MapLink/index.jsx
var MapLink__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function MapLink__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





var MapLink_MapLink = function MapLink(_ref) {
  var address = _ref.address,
      city = _ref.city,
      state = _ref.state,
      zipCode = _ref.zipCode,
      children = _ref.children,
      props = MapLink__objectWithoutProperties(_ref, ['address', 'city', 'state', 'zipCode', 'children']);

  var q = qs_lib_default.a.stringify({ q: address + ' ' + city + ' ' + state + ' ' + zipCode });
  return react_default.a.createElement(
    'a',
    MapLink__extends({
      href: 'http://maps.google.com/maps/?' + q,
      target: '_blank',
      rel: 'noopener noreferrer'
    }, props),
    children
  );
};

MapLink_MapLink.propTypes = {
  address: prop_types_default.a.string.isRequired,
  city: prop_types_default.a.string.isRequired,
  state: prop_types_default.a.string.isRequired,
  zipCode: prop_types_default.a.string.isRequired,
  children: prop_types_default.a.node
};

/* harmony default export */ var components_MapLink = (MapLink_MapLink);
// CONCATENATED MODULE: ./client/app/shared/components/DetailsAddress/index.jsx




var DetailsAddress_DetailsAddress = function DetailsAddress(props) {
  var address = props.address || '';
  var city = props.city || '';
  var state = props.state || '';
  var zipCode = props.zipCode || '';

  return react_default.a.createElement(
    components_MapLink,
    props,
    react_default.a.createElement(
      'span',
      null,
      address
    ),
    react_default.a.createElement('br', null),
    react_default.a.createElement(
      'span',
      null,
      city,
      ', ',
      state,
      ', ',
      zipCode
    )
  );
};

DetailsAddress_DetailsAddress.propTypes = {
  address: prop_types_default.a.string,
  city: prop_types_default.a.string,
  state: prop_types_default.a.string,
  zipCode: prop_types_default.a.string
};

/* harmony default export */ var components_DetailsAddress = (DetailsAddress_DetailsAddress);
// EXTERNAL MODULE: ./client/app/shared/components/InstallerPrioritizationSliders/styles.scss
var InstallerPrioritizationSliders_styles = __webpack_require__("Wi68");
var InstallerPrioritizationSliders_styles_default = /*#__PURE__*/__webpack_require__.n(InstallerPrioritizationSliders_styles);

// CONCATENATED MODULE: ./client/app/shared/components/InstallerPrioritizationSliders/index.jsx
var InstallerPrioritizationSliders__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var InstallerPrioritizationSliders__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var InstallerPrioritizationSliders__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function InstallerPrioritizationSliders__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function InstallerPrioritizationSliders__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function InstallerPrioritizationSliders__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function InstallerPrioritizationSliders__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function InstallerPrioritizationSliders__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var InstallerPrioritizationSliders_InstallerPrioritizationSliders = function (_Component) {
  InstallerPrioritizationSliders__inherits(InstallerPrioritizationSliders, _Component);

  function InstallerPrioritizationSliders(props) {
    InstallerPrioritizationSliders__classCallCheck(this, InstallerPrioritizationSliders);

    var _this = InstallerPrioritizationSliders__possibleConstructorReturn(this, (InstallerPrioritizationSliders.__proto__ || Object.getPrototypeOf(InstallerPrioritizationSliders)).call(this, props));

    Object.defineProperty(_this, 'getInstallerName', {
      enumerable: true,
      writable: true,
      value: function value(installerId) {
        var installers = _this.props.installers;

        var installer = installers.find(function (i) {
          return i.id === installerId;
        });
        return installer ? installer.name : 'Installer #' + installerId;
      }
    });
    Object.defineProperty(_this, 'getInstallerWeight', {
      enumerable: true,
      writable: true,
      value: function value(surfaceType, installerId) {
        var weights = _this.props.weights;

        var surfaceWeights = weights[surfaceType] || {};
        var weightData = surfaceWeights[installerId];
        if (weightData === null || weightData === undefined) return 0;
        if ((typeof weightData === 'undefined' ? 'undefined' : InstallerPrioritizationSliders__typeof(weightData)) === 'object' && weightData.weight !== undefined) {
          return parseInt(weightData.weight, 10) || 0;
        }
        return parseInt(weightData, 10) || 0;
      }
    });
    Object.defineProperty(_this, 'getSortedInstallers', {
      enumerable: true,
      writable: true,
      value: function value() {
        var installers = _this.props.installers;

        var list = installers || [];
        return [].concat(InstallerPrioritizationSliders__toConsumableArray(list)).sort(function (a, b) {
          return (a.phase_count || 0) - (b.phase_count || 0);
        });
      }
    });
    Object.defineProperty(_this, 'getUsedPercentage', {
      enumerable: true,
      writable: true,
      value: function value(surfaceType) {
        var weights = _this.props.weights;

        var surfaceWeights = weights[surfaceType] || {};
        return Object.values(surfaceWeights).reduce(function (sum, val) {
          if (val === null || val === undefined) return sum;
          if ((typeof val === 'undefined' ? 'undefined' : InstallerPrioritizationSliders__typeof(val)) === 'object' && val.weight !== undefined) {
            return sum + (parseInt(val.weight, 10) || 0);
          }
          return sum + (parseInt(val, 10) || 0);
        }, 0);
      }
    });
    Object.defineProperty(_this, 'initializeAllInstallerNames', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            weights = _this$props.weights,
            surfaceTypes = _this$props.surfaceTypes,
            installers = _this$props.installers,
            onChange = _this$props.onChange,
            disabled = _this$props.disabled;

        if (disabled || !installers.length || !surfaceTypes.length) return;

        var hasChanges = false;
        var newWeights = InstallerPrioritizationSliders__extends({}, weights);

        surfaceTypes.forEach(function (surfaceType) {
          var currentSurfaceWeights = weights[surfaceType] || {};

          var needsInit = installers.some(function (installer) {
            var data = currentSurfaceWeights[installer.id];

            return !data || (typeof data === 'undefined' ? 'undefined' : InstallerPrioritizationSliders__typeof(data)) !== 'object' || !data.name;
          });

          if (needsInit) {
            hasChanges = true;
            var newSurfaceWeights = {};
            installers.forEach(function (installer) {
              var existingData = currentSurfaceWeights[installer.id];
              var weight = 0;
              if (existingData !== null && existingData !== undefined) {
                weight = (typeof existingData === 'undefined' ? 'undefined' : InstallerPrioritizationSliders__typeof(existingData)) === 'object' && existingData.weight !== undefined ? parseInt(existingData.weight, 10) || 0 : parseInt(existingData, 10) || 0;
              }
              newSurfaceWeights[installer.id] = { weight: weight, name: installer.name };
            });
            newWeights[surfaceType] = newSurfaceWeights;
          }
        });

        if (hasChanges) {
          onChange(newWeights);
        }
      }
    });
    Object.defineProperty(_this, 'buildSurfaceWeights', {
      enumerable: true,
      writable: true,
      value: function value(surfaceType, changedInstallerId, newWeight) {
        var installers = _this.props.installers;

        var newSurfaceWeights = {};

        installers.forEach(function (installer) {
          var currentWeight = _this.getInstallerWeight(surfaceType, installer.id);
          var weight = installer.id === changedInstallerId ? newWeight : currentWeight;

          newSurfaceWeights[installer.id] = {
            weight: weight,
            name: installer.name
          };
        });

        return newSurfaceWeights;
      }
    });
    Object.defineProperty(_this, 'handleSliderChange', {
      enumerable: true,
      writable: true,
      value: function value(surfaceType, installerId, e) {
        var value = parseInt(e.target.value, 10);
        var _this$props2 = _this.props,
            weights = _this$props2.weights,
            onChange = _this$props2.onChange;

        var newSurfaceWeights = _this.buildSurfaceWeights(surfaceType, installerId, value);
        var newWeights = InstallerPrioritizationSliders__extends({}, weights, InstallerPrioritizationSliders__defineProperty({}, surfaceType, newSurfaceWeights));
        onChange(newWeights);
      }
    });
    Object.defineProperty(_this, 'handleInputChange', {
      enumerable: true,
      writable: true,
      value: function value(surfaceType, installerId, e) {
        var _this$props3 = _this.props,
            weights = _this$props3.weights,
            onChange = _this$props3.onChange;

        var inputValue = e.target.value;

        // Allow empty string (treat as 0) or valid numbers 0-100
        var numValue = void 0;
        if (inputValue === '' || inputValue === null) {
          numValue = 0;
        } else {
          numValue = parseInt(inputValue, 10);
          if (Number.isNaN(numValue) || numValue < 0 || numValue > 100) return;
        }

        var newSurfaceWeights = _this.buildSurfaceWeights(surfaceType, installerId, numValue);
        var newWeights = InstallerPrioritizationSliders__extends({}, weights, InstallerPrioritizationSliders__defineProperty({}, surfaceType, newSurfaceWeights));
        onChange(newWeights);
      }
    });
    Object.defineProperty(_this, 'handleTabChange', {
      enumerable: true,
      writable: true,
      value: function value(index) {
        _this.setState({ activeTab: index });
      }
    });
    Object.defineProperty(_this, 'renderSurfaceTypeContent', {
      enumerable: true,
      writable: true,
      value: function value(surfaceType) {
        var disabled = _this.props.disabled;

        var sortedInstallers = _this.getSortedInstallers();
        var usedPercentage = _this.getUsedPercentage(surfaceType);

        return react_default.a.createElement(
          'div',
          { className: InstallerPrioritizationSliders_styles_default.a.tabContent },
          react_default.a.createElement(
            'div',
            { className: InstallerPrioritizationSliders_styles_default.a.slidersSection },
            sortedInstallers.map(function (installer) {
              return react_default.a.createElement(
                'div',
                { key: installer.id, className: InstallerPrioritizationSliders_styles_default.a.sliderRow },
                react_default.a.createElement(
                  'div',
                  { className: InstallerPrioritizationSliders_styles_default.a.installerInfo },
                  react_default.a.createElement(
                    'span',
                    { className: InstallerPrioritizationSliders_styles_default.a.installerLabel },
                    installer.name
                  ),
                  react_default.a.createElement(
                    'span',
                    { className: InstallerPrioritizationSliders_styles_default.a.phaseCount },
                    '(',
                    installer.phase_count,
                    ' phases)'
                  )
                ),
                react_default.a.createElement(
                  'div',
                  { className: InstallerPrioritizationSliders_styles_default.a.sliderControls },
                  react_default.a.createElement(
                    'div',
                    { className: InstallerPrioritizationSliders_styles_default.a.sliderWrapper },
                    react_default.a.createElement('input', {
                      type: 'range',
                      className: InstallerPrioritizationSliders_styles_default.a.slider,
                      min: 0,
                      max: 100,
                      step: 5,
                      value: _this.getInstallerWeight(surfaceType, installer.id),
                      onChange: function onChange(e) {
                        return _this.handleSliderChange(surfaceType, installer.id, e);
                      },
                      disabled: disabled
                    }),
                    react_default.a.createElement(
                      'div',
                      { className: InstallerPrioritizationSliders_styles_default.a.sliderRuler },
                      [0, 25, 50, 75, 100].map(function (tick) {
                        return react_default.a.createElement(
                          'span',
                          { key: tick, className: InstallerPrioritizationSliders_styles_default.a.rulerTick },
                          tick
                        );
                      })
                    )
                  ),
                  react_default.a.createElement(
                    'div',
                    { className: InstallerPrioritizationSliders_styles_default.a.inputGroup },
                    react_default.a.createElement('input', {
                      type: 'number',
                      className: InstallerPrioritizationSliders_styles_default.a.percentInput,
                      min: 0,
                      max: 100,
                      value: _this.getInstallerWeight(surfaceType, installer.id),
                      onChange: function onChange(e) {
                        return _this.handleInputChange(surfaceType, installer.id, e);
                      },
                      disabled: disabled
                    }),
                    react_default.a.createElement(
                      'span',
                      { className: InstallerPrioritizationSliders_styles_default.a.percentSymbol },
                      '%'
                    )
                  )
                )
              );
            })
          ),
          react_default.a.createElement(
            'div',
            { className: InstallerPrioritizationSliders_styles_default.a.totalRow },
            react_default.a.createElement(
              'span',
              { className: InstallerPrioritizationSliders_styles_default.a.totalLabel },
              'Total:'
            ),
            react_default.a.createElement(
              'span',
              { className: usedPercentage !== 100 ? InstallerPrioritizationSliders_styles_default.a.totalValueInvalid : InstallerPrioritizationSliders_styles_default.a.totalValue },
              usedPercentage,
              '%'
            )
          )
        );
      }
    });

    _this.state = {
      activeTab: 0
    };
    return _this;
  }

  InstallerPrioritizationSliders__createClass(InstallerPrioritizationSliders, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.initializeAllInstallerNames();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.installers !== this.props.installers || prevProps.surfaceTypes !== this.props.surfaceTypes) {
        this.initializeAllInstallerNames();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          installers = _props.installers,
          surfaceTypes = _props.surfaceTypes;
      var activeTab = this.state.activeTab;


      if (installers.length === 0) {
        return react_default.a.createElement(
          'div',
          { className: InstallerPrioritizationSliders_styles_default.a.container },
          react_default.a.createElement(
            'div',
            { className: InstallerPrioritizationSliders_styles_default.a.noInstallersMessage },
            'No installers are assigned to IFI workrooms yet.',
            react_default.a.createElement('br', null),
            'Please assign installers to an IFI vendor workroom first.'
          )
        );
      }

      if (!surfaceTypes || surfaceTypes.length === 0) {
        return react_default.a.createElement(
          'div',
          { className: InstallerPrioritizationSliders_styles_default.a.container },
          react_default.a.createElement(
            'div',
            { className: InstallerPrioritizationSliders_styles_default.a.noInstallersMessage },
            'No IFI surface types configured.'
          )
        );
      }

      return react_default.a.createElement(
        'div',
        { className: InstallerPrioritizationSliders_styles_default.a.container },
        react_default.a.createElement(
          react_toolbox_lib["Tabs"],
          { index: activeTab, onChange: this.handleTabChange, className: InstallerPrioritizationSliders_styles_default.a.tabs },
          surfaceTypes.map(function (surfaceType) {
            return react_default.a.createElement(
              react_toolbox_lib["Tab"],
              { key: surfaceType, label: surfaceType },
              _this2.renderSurfaceTypeContent(surfaceType)
            );
          })
        )
      );
    }
  }]);

  return InstallerPrioritizationSliders;
}(react["Component"]);

InstallerPrioritizationSliders_InstallerPrioritizationSliders.propTypes = {
  weights: prop_types_default.a.object,
  installers: prop_types_default.a.arrayOf(prop_types_default.a.shape({
    id: prop_types_default.a.number.isRequired,
    name: prop_types_default.a.string.isRequired,
    phase_count: prop_types_default.a.number.isRequired
  })),
  surfaceTypes: prop_types_default.a.arrayOf(prop_types_default.a.string),
  onChange: prop_types_default.a.func.isRequired,
  disabled: prop_types_default.a.bool
};

InstallerPrioritizationSliders_InstallerPrioritizationSliders.defaultProps = {
  weights: {},
  installers: [],
  surfaceTypes: [],
  disabled: false
};

/* harmony default export */ var components_InstallerPrioritizationSliders = (InstallerPrioritizationSliders_InstallerPrioritizationSliders);
// EXTERNAL MODULE: ./client/app/shared/styles/resourceDetailsCard.scss
var resourceDetailsCard = __webpack_require__("28Pn");
var resourceDetailsCard_default = /*#__PURE__*/__webpack_require__.n(resourceDetailsCard);

// EXTERNAL MODULE: ./client/app/shared/styles/detailsSection.scss
var detailsSection = __webpack_require__("bGvD");
var detailsSection_default = /*#__PURE__*/__webpack_require__.n(detailsSection);

// EXTERNAL MODULE: ./client/app/shared/styles/detailsCardElement.scss
var detailsCardElement = __webpack_require__("gsey");
var detailsCardElement_default = /*#__PURE__*/__webpack_require__.n(detailsCardElement);

// CONCATENATED MODULE: ./client/app/shared/types/pricePatch.js


var PricePatchType = prop_types_default.a.shape({
  name: prop_types_default.a.string
});

/* harmony default export */ var types_pricePatch = (PricePatchType);
// CONCATENATED MODULE: ./client/app/screens/main/screens/stores/components/storeDetailsCard.jsx
var storeDetailsCard__slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var storeDetailsCard__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

















var storeDetailsCard_detailsTheme = { RTCard: resourceDetailsCard_default.a, ResourceDetailsCE: detailsCardElement_default.a };

var storeDetailsCard_DetailsListingSection = function DetailsListingSection(props) {
  var title = props.title,
      t = props.theme,
      items = props.items;

  var sectionListItems = items.map(function (item) {
    return react_default.a.createElement(
      flexbox_react_dist_default.a,
      { className: t.sectionListItem, key: item.name, flexWrap: 'wrap' },
      react_default.a.createElement(ResourceDetailsCardElement, { title: 'name', value: item.name }),
      react_default.a.createElement(ResourceDetailsCardElement, { title: 'phone number', value: item.phone_number }),
      react_default.a.createElement(ResourceDetailsCardElement, { title: 'email', value: item.email }),
      react_default.a.createElement(ResourceDetailsCardElement, { title: 'position', value: item.position }),
      react_default.a.createElement(
        flexbox_react_dist_default.a,
        { className: t.innerFlexSection },
        react_default.a.createElement(ResourceDetailsCardElement, {
          title: 'Daily Installation Updates',
          value: item.installation_updates ? 'Yes' : 'No'
        }),
        react_default.a.createElement(ResourceDetailsCardElement, {
          title: 'Daily Assessment Updates',
          value: item.assessment_updates ? 'Yes' : 'No'
        }),
        react_default.a.createElement(ResourceDetailsCardElement, {
          title: 'Email Opt-In',
          value: item.email_opt_in ? 'Yes' : 'No'
        })
      )
    );
  });
  return react_default.a.createElement(
    'section',
    { className: t.section },
    react_default.a.createElement(
      'span',
      { className: t.sectionTitle },
      title
    ),
    sectionListItems
  );
};

storeDetailsCard_DetailsListingSection.propTypes = {
  title: prop_types_default.a.string,
  theme: prop_types_default.a.shape({
    sectionListItem: prop_types_default.a.string,
    section: prop_types_default.a.string,
    sectionTitle: prop_types_default.a.string
  }),
  items: prop_types_default.a.array
};

var hasWeightsConfigured = function hasWeightsConfigured(weights) {
  if (!weights || (typeof weights === 'undefined' ? 'undefined' : storeDetailsCard__typeof(weights)) !== 'object') return false;
  return Object.keys(weights).some(function (surfaceType) {
    return weights[surfaceType] && Object.keys(weights[surfaceType]).length > 0;
  });
};

// Derive surface types from weights data
var getSurfaceTypesFromWeights = function getSurfaceTypesFromWeights(weights) {
  if (!weights || (typeof weights === 'undefined' ? 'undefined' : storeDetailsCard__typeof(weights)) !== 'object') return [];
  return Object.keys(weights).filter(function (st) {
    return weights[st] && Object.keys(weights[st]).length > 0;
  });
};

// Derive installer list from weights data (extracts names from new format)
var getInstallersFromWeights = function getInstallersFromWeights(weights) {
  if (!weights || (typeof weights === 'undefined' ? 'undefined' : storeDetailsCard__typeof(weights)) !== 'object') return [];
  var installerMap = new Map();

  Object.values(weights).forEach(function (surfaceWeights) {
    if (surfaceWeights && (typeof surfaceWeights === 'undefined' ? 'undefined' : storeDetailsCard__typeof(surfaceWeights)) === 'object') {
      Object.entries(surfaceWeights).forEach(function (_ref) {
        var _ref2 = storeDetailsCard__slicedToArray(_ref, 2),
            id = _ref2[0],
            data = _ref2[1];

        var installerId = Number(id);
        if (!installerMap.has(installerId)) {
          // Extract name from new format (object with name) or fallback
          var name = data && (typeof data === 'undefined' ? 'undefined' : storeDetailsCard__typeof(data)) === 'object' && data.name ? data.name : 'Installer #' + installerId;
          installerMap.set(installerId, { id: installerId, name: name, phase_count: 0 });
        }
      });
    }
  });

  return Array.from(installerMap.values());
};

var storeDetailsCard_StoreDetailsCard = function StoreDetailsCard(props) {
  var store = props.store,
      canEdit = props.canEdit,
      pricePatch = props.pricePatch;
  var vendor = store.vendor;

  var storeContacts = store.store_contacts || [];
  var weights = store.installer_prioritization_weights;
  var showWeightsSection = store.vendor === 'IFI' && hasWeightsConfigured(weights);
  var surfaceTypes = getSurfaceTypesFromWeights(weights);
  var installers = getInstallersFromWeights(weights);

  var EditAction = react_default.a.createElement(
    components_RouterLink,
    { className: resourceDetailsCard_default.a.detailsLink, to: '/stores/' + store.id + '/edit' },
    react_default.a.createElement(
      'span',
      { className: resourceDetailsCard_default.a.editText },
      'Edit Store'
    )
  );
  var ccsSchedulableText = store.ccs_schedulable ? 'CCS Schedulable' : 'CCS Blocked';
  return react_default.a.createElement(
    react_css_themr_lib["ThemeProvider"],
    { theme: storeDetailsCard_detailsTheme },
    react_default.a.createElement(
      components_Card,
      null,
      react_default.a.createElement(
        'section',
        { className: detailsSection_default.a.section },
        react_default.a.createElement(
          flexbox_react_dist_default.a,
          { justifyContent: 'space-between' },
          react_default.a.createElement(
            'div',
            null,
            react_default.a.createElement(
              'div',
              { className: resourceDetailsCard_default.a.mainTitle },
              react_default.a.createElement(
                'span',
                { className: resourceDetailsCard_default.a.boldWord },
                '#',
                store.number
              ),
              react_default.a.createElement(
                'span',
                null,
                ' - ' + store.name
              ),
              react_default.a.createElement(
                'span',
                {
                  className: store.ccs_schedulable ? resourceDetailsCard_default.a.activeText : resourceDetailsCard_default.a.inactiveText
                },
                ' (',
                ccsSchedulableText,
                ')'
              )
            ),
            react_default.a.createElement(components_DetailsAddress, {
              className: resourceDetailsCard_default.a.mainSubtitle,
              address: store.address,
              city: store.city,
              state: store.state,
              zipCode: store.zip_code
            })
          ),
          canEdit ? EditAction : null
        )
      ),
      react_default.a.createElement('hr', { className: resourceDetailsCard_default.a.dividerLine }),
      react_default.a.createElement(
        'section',
        { className: detailsSection_default.a.section },
        react_default.a.createElement(
          flexbox_react_dist_default.a,
          { flexWrap: 'wrap', className: resourceDetailsCard_default.a.detailsElementContainer },
          react_default.a.createElement(ResourceDetailsCardElement, { title: 'vendor', value: store.vendor }),
          react_default.a.createElement(
            ResourceDetailsCardElement,
            { title: 'phone number' },
            react_default.a.createElement(components_PhoneLink, { key: store.phone_number, number: store.phone_number })
          ),
          react_default.a.createElement(ResourceDetailsCardElement, { title: 'flooring fax', value: store.fax_number_flooring }),
          react_default.a.createElement(ResourceDetailsCardElement, { title: 'installed sales fax', value: store.fax_number_installed_sales }),
          react_default.a.createElement(ResourceDetailsCardElement, { title: 'receiving fax', value: store.fax_number_receiving }),
          react_default.a.createElement(ResourceDetailsCardElement, { title: vendor === 'IFI' ? 'district' : 'workroom', value: store.workroom_name }),
          react_default.a.createElement(ResourceDetailsCardElement, { title: 'region', value: store.region_name }),
          react_default.a.createElement(ResourceDetailsCardElement, { title: 'market', value: store.market_name }),
          react_default.a.createElement(ResourceDetailsCardElement, { title: 'division', value: store.division_name }),
          react_default.a.createElement(ResourceDetailsCardElement, { title: 'iso/ist', value: store.cpo_iso }),
          react_default.a.createElement(ResourceDetailsCardElement, { title: 'price patch number', value: pricePatch.name }),
          react_default.a.createElement(ResourceDetailsCardElement, { title: 'quickbooks id', value: store.quickbooks_ident }),
          react_default.a.createElement(ResourceDetailsCardElement, { title: 'time zone', value: store.timezone }),
          react_default.a.createElement(ResourceDetailsCardElement, { title: 'Disable IST Emails', value: store.disable_cpo_emails ? 'Yes' : 'No' }),
          react_default.a.createElement(ResourceDetailsCardElement, { title: 'Delivery Method', value: store.delivery_method }),
          react_default.a.createElement(ResourceDetailsCardElement, { title: 'Express Ship Days', value: store.express_ship_days }),
          react_default.a.createElement(
            ResourceDetailsCardElement,
            { title: 'covered zip codes' },
            react_default.a.createElement(
              'span',
              { className: resourceDetailsCard_default.a.viewableZips },
              (store.covered_zip_codes || []).sort(function (a, b) {
                return a - b;
              }).join(', ') || ' -- '
            )
          )
        )
      ),
      react_default.a.createElement('hr', { className: resourceDetailsCard_default.a.dividerLine }),
      react_default.a.createElement(storeDetailsCard_DetailsListingSection, { title: 'Store Contacts', items: storeContacts, theme: detailsSection_default.a }),
      showWeightsSection && react_default.a.createElement(
        'section',
        { className: detailsSection_default.a.section },
        react_default.a.createElement('hr', { className: resourceDetailsCard_default.a.dividerLine }),
        react_default.a.createElement(
          'span',
          { className: detailsSection_default.a.sectionTitle },
          'Installer Prioritization Weights'
        ),
        react_default.a.createElement(components_InstallerPrioritizationSliders, {
          weights: weights,
          installers: installers,
          surfaceTypes: surfaceTypes,
          onChange: function onChange() {},
          disabled: true
        })
      )
    )
  );
};

storeDetailsCard_StoreDetailsCard.propTypes = {
  store: types_store.isRequired,
  canEdit: prop_types_default.a.bool,
  pricePatch: types_pricePatch
};

/* harmony default export */ var storeDetailsCard = (storeDetailsCard_StoreDetailsCard);
// CONCATENATED MODULE: ./client/app/screens/main/screens/stores/storeDetails.jsx
var storeDetails__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function storeDetails__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function storeDetails__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function storeDetails__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var storeDetails_StoreDetails = function (_React$Component) {
  storeDetails__inherits(StoreDetails, _React$Component);

  function StoreDetails() {
    storeDetails__classCallCheck(this, StoreDetails);

    return storeDetails__possibleConstructorReturn(this, (StoreDetails.__proto__ || Object.getPrototypeOf(StoreDetails)).apply(this, arguments));
  }

  storeDetails__createClass(StoreDetails, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.requestStore(this.props.id);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.ui.successMessage) {
        this.props.updateUI('successMessage', '');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          loading = _props.loading,
          store = _props.store,
          canEdit = _props.canEdit,
          ui = _props.ui,
          pricePatch = _props.pricePatch;

      return react_default.a.createElement(
        'div',
        null,
        ui.successMessage ? react_default.a.createElement(MessageBox["a" /* default */], { message: ui.successMessage }) : null,
        loading ? react_default.a.createElement(components_Loading, null) : react_default.a.createElement(storeDetailsCard, {
          canEdit: canEdit,
          store: store,
          pricePatch: pricePatch
        })
      );
    }
  }]);

  return StoreDetails;
}(react_default.a.Component);

storeDetails_StoreDetails.propTypes = {
  loading: prop_types_default.a.bool,
  canEdit: prop_types_default.a.bool,
  store: prop_types_default.a.object,
  ui: prop_types_default.a.object,
  updateUI: prop_types_default.a.func,
  id: prop_types_default.a.number,
  requestStore: prop_types_default.a.func,
  pricePatch: prop_types_default.a.object
};

function storeDetails_mapStateToProps(state, ownProps) {
  var id = Number(ownProps.params.id);
  var store = Object(reducers["_14" /* getStoreById */])(state)(id);
  var loading = store ? store.loading : true;
  var pricePatch = loading ? null : Object(reducers["_9" /* getPricePatchById */])(state)(store.price_patch) || {};
  var role = Object(reducers["_12" /* getRole */])(state); // TODO: Obtain role from parent component
  return {
    id: id,
    store: store,
    canEdit: Object(services["a" /* can */])(role, 'update', 'store'),
    loading: loading,
    pricePatch: pricePatch
  };
}

var storeDetails_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    requestStore: function requestStore(id) {
      return dispatch(Object(actionCreators["_24" /* requestStore */])(id));
    }
  };
};

/* harmony default export */ var stores_storeDetails = (transpiled_default()()(Object(react_redux_es["connect"])(storeDetails_mapStateToProps, storeDetails_mapDispatchToProps)(storeDetails_StoreDetails)));
// EXTERNAL MODULE: ./client/app/shared/components/StyledSelect/styles.scss
var StyledSelect_styles = __webpack_require__("48oR");
var StyledSelect_styles_default = /*#__PURE__*/__webpack_require__.n(StyledSelect_styles);

// CONCATENATED MODULE: ./client/app/shared/components/StyledSelect/index.jsx
var StyledSelect__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var StyledSelect__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function StyledSelect__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function StyledSelect__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function StyledSelect__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function StyledSelect__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function StyledSelect__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function StyledSelect__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var StyledSelect_StyledSelect = function (_Component) {
  StyledSelect__inherits(StyledSelect, _Component);

  function StyledSelect(props) {
    StyledSelect__classCallCheck(this, StyledSelect);

    var _this = StyledSelect__possibleConstructorReturn(this, (StyledSelect.__proto__ || Object.getPrototypeOf(StyledSelect)).call(this, props));

    _this.getPlaceHolder = _this.getPlaceHolder.bind(_this);
    _this.onChange = _this.onChange.bind(_this);
    return _this;
  }

  StyledSelect__createClass(StyledSelect, [{
    key: 'onChange',
    value: function onChange(event) {
      this.props.onChange(event.target.value);
    }
  }, {
    key: 'getPlaceHolder',
    value: function getPlaceHolder(options) {
      if (!this.props.placeholder) {
        return options;
      }

      var placeholderArray = [{ value: '', label: this.props.placeholder }];
      placeholderArray.push.apply(placeholderArray, StyledSelect__toConsumableArray(options));
      return placeholderArray;
    }
  }, {
    key: 'render',
    value: function render() {
      var _cx, _cx2, _cx3, _cx4;

      var _props = this.props,
          _props$label = _props.label,
          label = _props$label === undefined ? '' : _props$label,
          options = _props.options,
          error = _props.error,
          otherProps = StyledSelect__objectWithoutProperties(_props, ['label', 'options', 'error']);

      var requiredText = this.props.required ? ' *' : '';
      var optionVals = this.getPlaceHolder(options);
      var errorText = error || '';

      var optionTags = optionVals.map(function (option) {
        return react_default.a.createElement(
          'option',
          { key: option.value, className: StyledSelect_styles_default.a.optionText, value: option.value },
          option.label
        );
      });

      var classNames = classnames_default()((_cx = {}, StyledSelect__defineProperty(_cx, StyledSelect_styles_default.a.dropDownWrapper, true), StyledSelect__defineProperty(_cx, this.props.className, this.props.className), _cx));

      var labelClassNames = classnames_default()((_cx2 = {}, StyledSelect__defineProperty(_cx2, StyledSelect_styles_default.a.dropDownLabel, true), StyledSelect__defineProperty(_cx2, StyledSelect_styles_default.a.errorText, errorText), _cx2));

      var dropDownClassNames = classnames_default()((_cx3 = {}, StyledSelect__defineProperty(_cx3, StyledSelect_styles_default.a.prettyDropDown, true), StyledSelect__defineProperty(_cx3, StyledSelect_styles_default.a.errored, errorText), StyledSelect__defineProperty(_cx3, StyledSelect_styles_default.a.empty, !this.props.value), _cx3));

      var errorMessageClassNames = classnames_default()((_cx4 = {}, StyledSelect__defineProperty(_cx4, StyledSelect_styles_default.a.errorText, errorText), StyledSelect__defineProperty(_cx4, StyledSelect_styles_default.a.errorMessage, errorText), _cx4));

      return react_default.a.createElement(
        'div',
        { className: classNames },
        react_default.a.createElement(
          'label',
          { htmlFor: 'select', className: labelClassNames },
          label,
          requiredText
        ),
        react_default.a.createElement(
          'select',
          StyledSelect__extends({}, otherProps, {
            className: dropDownClassNames,
            onChange: this.onChange,
            value: this.props.value
          }),
          optionTags
        ),
        react_default.a.createElement(
          'div',
          { className: errorMessageClassNames },
          react_default.a.createElement(
            'p',
            { className: StyledSelect_styles_default.a.errorText },
            errorText
          )
        )
      );
    }
  }]);

  return StyledSelect;
}(react["Component"]);

Object.defineProperty(StyledSelect_StyledSelect, 'propTypes', {
  enumerable: true,
  writable: true,
  value: {
    placeholder: prop_types_default.a.string,
    onChange: prop_types_default.a.func,
    required: prop_types_default.a.bool,
    error: prop_types_default.a.string,
    label: prop_types_default.a.string,
    options: prop_types_default.a.arrayOf(prop_types_default.a.shape({
      label: prop_types_default.a.string,
      value: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number])
    })),
    className: prop_types_default.a.string,
    value: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]),
    disabled: prop_types_default.a.bool
  }
});


/* harmony default export */ var components_StyledSelect = (StyledSelect_StyledSelect);
// EXTERNAL MODULE: ./client/app/shared/components/RadioButtons/styles.scss
var RadioButtons_styles = __webpack_require__("dZ0t");
var RadioButtons_styles_default = /*#__PURE__*/__webpack_require__.n(RadioButtons_styles);

// CONCATENATED MODULE: ./client/app/shared/components/RadioButtons/index.jsx







var RadioButtons_RadioButtons = function RadioButtons(_ref) {
  var label = _ref.label,
      text = _ref.text,
      onChange = _ref.onChange,
      className = _ref.className,
      errors = _ref.errors,
      selectedValue = _ref.selectedValue,
      radioButtons = _ref.radioButtons;

  var errorMsg = errors.join(', ');
  var wrapperStyles = errorMsg ? classnames_default()(input_default.a.errored, className) : className;
  var labelStyles = errorMsg ? classnames_default()(RadioButtons_styles_default.a.label, RadioButtons_styles_default.a.errorLabel) : RadioButtons_styles_default.a.label;
  var buttons = radioButtons.map(function (button) {
    return react_default.a.createElement(react_toolbox_lib["RadioButton"], { label: button.label, value: button.value, key: button.label });
  });
  return react_default.a.createElement(
    'div',
    { className: wrapperStyles },
    react_default.a.createElement(
      'h6',
      { className: labelStyles },
      label
    ),
    react_default.a.createElement(
      'p',
      { className: RadioButtons_styles_default.a.text },
      text
    ),
    react_default.a.createElement(
      react_toolbox_lib["RadioGroup"],
      { value: selectedValue, onChange: onChange },
      buttons
    ),
    errorMsg && react_default.a.createElement(
      'div',
      { className: input_default.a.error },
      react_default.a.createElement(
        'p',
        { className: RadioButtons_styles_default.a.errorMsg },
        errorMsg
      )
    )
  );
};

RadioButtons_RadioButtons.propTypes = {
  label: prop_types_default.a.string.isRequired,
  text: prop_types_default.a.string.isRequired,
  onChange: prop_types_default.a.func.isRequired,
  selectedValue: prop_types_default.a.string.isRequired,
  radioButtons: prop_types_default.a.arrayOf(prop_types_default.a.shape({
    label: prop_types_default.a.string.isRequired,
    value: prop_types_default.a.string.isRequired
  })).isRequired,
  errors: prop_types_default.a.array.isRequired,
  className: prop_types_default.a.string
};

RadioButtons_RadioButtons.defaultProps = {
  label: '',
  text: '',
  errors: []
};

/* harmony default export */ var components_RadioButtons = (RadioButtons_RadioButtons);
// EXTERNAL MODULE: ./node_modules/react-tagsinput/react-tagsinput.js
var react_tagsinput = __webpack_require__("VM0c");
var react_tagsinput_default = /*#__PURE__*/__webpack_require__.n(react_tagsinput);

// EXTERNAL MODULE: ./node_modules/react-tagsinput/react-tagsinput.css
var react_tagsinput_react_tagsinput = __webpack_require__("rLH0");
var react_tagsinput_react_tagsinput_default = /*#__PURE__*/__webpack_require__.n(react_tagsinput_react_tagsinput);

// EXTERNAL MODULE: ./client/app/shared/components/TaggedInput/styles.scss
var TaggedInput_styles = __webpack_require__("ucW6");
var TaggedInput_styles_default = /*#__PURE__*/__webpack_require__.n(TaggedInput_styles);

// CONCATENATED MODULE: ./client/app/shared/components/TaggedInput/index.jsx









var TaggedInput_pasteSplit = function pasteSplit(data) {
  return data.split(/[ ,]+/).map(function (d) {
    return d.trim();
  });
};

var TaggedInput_TaggedInput = function TaggedInput(_ref) {
  var label = _ref.label,
      id = _ref.id,
      values = _ref.values,
      onChange = _ref.onChange,
      placeholder = _ref.placeholder,
      errors = _ref.errors;

  var errorMsg = errors.join(', ');
  var wrapperStyles = errorMsg ? TaggedInput_styles_default.a.wrapper + ' ' + input_default.a.errored : TaggedInput_styles_default.a.wrapper;
  var labelStyles = errorMsg ? TaggedInput_styles_default.a.label + ' ' + TaggedInput_styles_default.a.errorLabel : TaggedInput_styles_default.a.label;
  var inputStyles = input_default.a.inputElement + ' ' + TaggedInput_styles_default.a.element;

  var errStyles = input_default.a.error + ' ' + TaggedInput_styles_default.a.error;

  return react_default.a.createElement(
    'div',
    { className: wrapperStyles },
    react_default.a.createElement(
      'label',
      { className: labelStyles, htmlFor: id },
      label
    ),
    react_default.a.createElement(react_tagsinput_default.a, {
      onlyUnique: true,
      id: id,
      value: values,
      onChange: onChange,
      addOnPaste: true,
      pasteSplit: TaggedInput_pasteSplit,
      className: inputStyles,
      focusedClassName: input_default.a.inputElement,
      tagProps: { className: TaggedInput_styles_default.a.tag, classNameRemove: 'react-tagsinput-remove' },
      inputProps: { placeholder: placeholder, className: TaggedInput_styles_default.a.input },
      validationRegex: /^[^\s]+(\s+[^\s]+)*$/
    }),
    errorMsg && react_default.a.createElement(
      'div',
      { className: errStyles },
      react_default.a.createElement(
        'p',
        { className: TaggedInput_styles_default.a.errorMsg },
        errorMsg
      )
    )
  );
};

TaggedInput_TaggedInput.propTypes = {
  label: prop_types_default.a.string.isRequired,
  id: prop_types_default.a.string.isRequired,
  values: prop_types_default.a.arrayOf(prop_types_default.a.string).isRequired,
  onChange: prop_types_default.a.func.isRequired,
  placeholder: prop_types_default.a.string,
  errors: prop_types_default.a.array.isRequired
};

TaggedInput_TaggedInput.defaultProps = {
  label: '',
  id: '',
  values: [],
  errors: [],
  placeholder: ''
};

/* harmony default export */ var components_TaggedInput = (TaggedInput_TaggedInput);
// CONCATENATED MODULE: ./client/app/screens/main/screens/stores/components/storeContactForm.jsx
function storeContactForm__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function storeContactForm__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function storeContactForm__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var storeContactForm_largeInput = classnames_default()(form_default.a.childInputs, form_default.a.largeInput);

var storeContactForm_StoreContactForm = function (_Component) {
  storeContactForm__inherits(StoreContactForm, _Component);

  function StoreContactForm(props) {
    storeContactForm__classCallCheck(this, StoreContactForm);

    var _this = storeContactForm__possibleConstructorReturn(this, (StoreContactForm.__proto__ || Object.getPrototypeOf(StoreContactForm)).call(this, props));

    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            errors = _this$props.errors,
            storeContact = _this$props.storeContact,
            index = _this$props.index,
            onDelete = _this$props.onDelete,
            role = _this$props.role;

        var canDeleteContact = Object(services["a" /* can */])(role, 'delete', 'store_contact');
        return react_default.a.createElement(
          'div',
          { className: form_default.a.childCard },
          react_default.a.createElement(
            flexbox_react_dist_default.a,
            { className: form_default.a.childDivider },
            react_default.a.createElement(react_toolbox_lib["Input"], {
              label: 'Name',
              value: storeContact.name,
              className: storeContactForm_largeInput,
              error: _this.showError('name', errors),
              required: true,
              onChange: _this.onNameChange
            }),
            react_default.a.createElement(PhoneType_PhoneInput, {
              label: 'Phone Number',
              type: 'tel',
              value: storeContact.phone_number,
              className: storeContactForm_largeInput,
              error: _this.showError('phone_number', errors),
              onChange: _this.onPhoneChange
            }),
            react_default.a.createElement(react_toolbox_lib["Input"], {
              label: 'Email Address',
              value: storeContact.email,
              className: storeContactForm_largeInput,
              error: 'emailError' in storeContact && storeContact.emailError ? 'Input Valid Email' : _this.showError('email', errors),
              required: true,
              onChange: _this.onEmailChange
            }),
            react_default.a.createElement(components_StyledSelect, {
              className: storeContactForm_largeInput,
              label: 'Position',
              placeholder: 'Select Position',
              options: constants["_37" /* STORE_CONTACT_POSITIONS */].map(function (scp) {
                return { value: scp, label: scp };
              }),
              value: storeContact.position,
              error: _this.showError('position', errors),
              onChange: _this.onPositionChange,
              required: true
            })
          ),
          react_default.a.createElement(
            'h5',
            { className: form_default.a.childTitle },
            'Report Preferences'
          ),
          react_default.a.createElement(
            flexbox_react_dist_default.a,
            { flex: '1' },
            react_default.a.createElement(react_toolbox_lib["Checkbox"], {
              checked: storeContact.installation_updates,
              label: 'Daily Installation Updates',
              onChange: _this.onInstallationUpdatesChange,
              className: form_default.a.checkboxListItem,
              theme: checkbox_default.a
            }),
            react_default.a.createElement(react_toolbox_lib["Checkbox"], {
              checked: storeContact.assessment_updates,
              label: 'Daily Assessment Updates',
              onChange: _this.onAssessmentUpdatesChange,
              className: form_default.a.checkboxListItem,
              theme: checkbox_default.a
            }),
            react_default.a.createElement(react_toolbox_lib["Checkbox"], {
              checked: storeContact.email_opt_in,
              label: 'Email Opt-In',
              onChange: _this.onEmailOptInChange,
              className: form_default.a.checkboxListItem,
              theme: checkbox_default.a
            })
          ),
          canDeleteContact && react_default.a.createElement(ColoredButton["a" /* default */], {
            className: form_default.a.deleteChildButton,
            color: 'red',
            label: 'Delete store contact',
            onClick: function onClick() {
              return onDelete(index);
            }
          })
        );
      }
    });

    _this.onNameChange = _this.props.onChange.bind(_this, 'name');
    _this.onPhoneChange = _this.props.onChange.bind(_this, 'phone_number');
    _this.onEmailChange = _this.props.onChange.bind(_this, 'email');
    _this.onPositionChange = _this.props.onChange.bind(_this, 'position');
    _this.onInstallationUpdatesChange = _this.props.onChange.bind(_this, 'installation_updates');
    _this.onAssessmentUpdatesChange = _this.props.onChange.bind(_this, 'assessment_updates');
    _this.onEmailOptInChange = _this.props.onChange.bind(_this, 'email_opt_in');
    _this.showError = utils["s" /* nestedError */].bind(_this, 'store_contacts', _this.props.index);
    return _this;
  }

  return StoreContactForm;
}(react["Component"]);

storeContactForm_StoreContactForm.propTypes = {
  onChange: prop_types_default.a.func.isRequired,
  onDelete: prop_types_default.a.func.isRequired,
  errors: prop_types_default.a.object,
  storeContact: prop_types_default.a.shape({
    name: prop_types_default.a.string,
    phone_number: prop_types_default.a.string,
    email: prop_types_default.a.string,
    position: prop_types_default.a.string,
    installation_updates: prop_types_default.a.bool,
    assessment_updates: prop_types_default.a.bool
  }),
  index: prop_types_default.a.number,
  role: prop_types_default.a.string.isRequired
};

/* harmony default export */ var storeContactForm = (storeContactForm_StoreContactForm);
// CONCATENATED MODULE: ./client/app/shared/types/division.js


var DivisionType = prop_types_default.a.shape({
  id: prop_types_default.a.number.isRequired,
  name: prop_types_default.a.string.isRequired
});

/* harmony default export */ var division = (DivisionType);
// CONCATENATED MODULE: ./client/app/shared/types/market.js


var MarketType = prop_types_default.a.shape({
  id: prop_types_default.a.number.isRequired,
  name: prop_types_default.a.string.isRequired
});

/* harmony default export */ var market = (MarketType);
// CONCATENATED MODULE: ./client/app/shared/types/region.js


var RegionType = prop_types_default.a.shape({
  id: prop_types_default.a.number.isRequired,
  name: prop_types_default.a.string.isRequired
});

/* harmony default export */ var region = (RegionType);
// CONCATENATED MODULE: ./client/app/screens/main/screens/stores/components/storeForm.jsx
var storeForm__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var storeForm__slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var storeForm__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function storeForm__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function storeForm__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function storeForm__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function storeForm__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function storeForm__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable no-underscore-dangle */

































var ISO_IST = ['ISO', 'IST Wilkesboro', 'IST Indianapolis'];

var extractWeight = function extractWeight(val) {
  if (val === null || val === undefined) return 0;
  if ((typeof val === 'undefined' ? 'undefined' : storeForm__typeof(val)) === 'object' && val.weight !== undefined) {
    return parseInt(val.weight, 10) || 0;
  }
  return parseInt(val, 10) || 0;
};

var getSurfaceTotal = function getSurfaceTotal(surfaceWeights) {
  if (!surfaceWeights || (typeof surfaceWeights === 'undefined' ? 'undefined' : storeForm__typeof(surfaceWeights)) !== 'object') return 0;
  return Object.values(surfaceWeights).reduce(function (sum, val) {
    return sum + extractWeight(val);
  }, 0);
};

var storeForm_largeInput = classnames_default()(form_default.a.inputs, form_default.a.largeInput);
var storeForm_mediumInput = classnames_default()(form_default.a.inputs, form_default.a.mediumInput);
var storeForm_smallInput = classnames_default()(form_default.a.inputs, form_default.a.smallInput);
var storeForm_cancelClass = classnames_default()([form_default.a.cancelButton, form_default.a.actionButton]);
var storeForm_titleStyle = classnames_default()([form_default.a.title, form_default.a.divider]);
var deliveryRadioBtns = classnames_default()([form_default.a.inputs, form_default.a.deliveryRadioBtns]);
var storeForm_theme = { RTInput: input_default.a, RTDropdown: dropdown_default.a, RTCard: styles_card_default.a };

var storeForm_StoreForm = function (_Component) {
  storeForm__inherits(StoreForm, _Component);

  function StoreForm(props) {
    storeForm__classCallCheck(this, StoreForm);

    var _this = storeForm__possibleConstructorReturn(this, (StoreForm.__proto__ || Object.getPrototypeOf(StoreForm)).call(this, props));

    storeForm__initialiseProps.call(_this);

    _this.handleSave = _this.handleSave.bind(_this);
    _this.handleActive = _this.handleChange.bind(_this, 'active');
    _this.handleRole = _this.handleChange.bind(_this, 'role');
    _this.handleCancel = _this.handleCancel.bind(_this);
    _this.statesSource = constants["_35" /* STATES */].map(function (state) {
      return { value: state, label: state };
    });
    _this.expressShipDaysSource = [{ value: 0, label: '0' }, { value: 10, label: '10' }, { value: 14, label: '14' }];
    _this.handleState = _this.handleChange.bind(_this, 'state');
    _this.handleExpressShipDays = _this.handleChange.bind(_this, 'express_ship_days');
    _this.timezonesSource = constants["_46" /* TIMEZONES */].map(function (tz) {
      return { value: tz, label: tz };
    });
    _this.handleTimezone = _this.handleChange.bind(_this, 'timezone');
    _this.handleWorkroom = _this.handleChange.bind(_this, 'workroom_id');
    _this.workroomsSource = Object(utils["j" /* generateSource */])(_this.props.workrooms);
    _this.handleMarket = _this.handleChange.bind(_this, 'market_id');
    _this.handleRegion = _this.handleRegion.bind(_this, 'region_id');
    _this.handleDivision = _this.handleDivision.bind(_this, 'division_id');
    _this.handleIsoIst = _this.handleChange.bind(_this, 'cpo_iso');
    _this.handlePricePatch = _this.handleChange.bind(_this, 'price_patch');
    _this.pricePatchesSource = Object(utils["j" /* generateSource */])(_this.props.pricePatches);
    _this.onNameChange = _this.handleChange.bind(_this, 'name');
    _this.onNumberChange = _this.handleChange.bind(_this, 'number');
    _this.onAddressChange = _this.handleChange.bind(_this, 'address');
    _this.onCityChange = _this.handleChange.bind(_this, 'city');
    _this.onZipChange = _this.handleChange.bind(_this, 'zip_code');
    _this.onPhoneChange = _this.handleChange.bind(_this, 'phone_number');
    _this.onQuickbooksChange = _this.handleChange.bind(_this, 'quickbooks_ident');
    _this.onFaxFlooringChange = _this.handleChange.bind(_this, 'fax_number_flooring');
    _this.onFaxSalesChange = _this.handleChange.bind(_this, 'fax_number_installed_sales');
    _this.onFaxReceivingChange = _this.handleChange.bind(_this, 'fax_number_receiving');
    _this.handleDisableIstEmails = _this.handleChange.bind(_this, 'disable_cpo_emails');
    _this.handleDeliveryType = _this.handleChange.bind(_this, 'delivery_method');
    _this.handleCoveredZipChange = _this.handleChange.bind(_this, 'covered_zip_codes');
    _this.handleVendor = _this.handleChange.bind(_this, 'vendor');
    _this.vendorsSource = constants["_51" /* VENDORS */].map(function (v) {
      return { value: v, label: v };
    });
    _this.addStoreContact = _this.addStoreContact.bind(_this);
    _this.confirmAndDelete = _this.confirmAndDelete.bind(_this);
    _this.handleCcsSchedulable = _this.handleChange.bind(_this, 'ccs_schedulable');
    _this.handlePrioritizationWeightsChange = _this.handlePrioritizationWeightsChange.bind(_this);

    var _ref = props.storeDetails || { price_patch: '', disable_cpo_emails: true },
        store_contacts = _ref.store_contacts,
        store = storeForm__objectWithoutProperties(_ref, ['store_contacts']);

    _this.state = { store: store, store_contacts: store_contacts || [], emailValidations: [] };
    return _this;
  }

  return StoreForm;
}(react["Component"]);

var storeForm__initialiseProps = function _initialiseProps() {
  var _this2 = this;

  Object.defineProperty(this, 'getWeightsValidationMessage', {
    enumerable: true,
    writable: true,
    value: function value() {
      var store = _this2.state.store;

      var weights = store.installer_prioritization_weights || {};

      var invalidSurfaces = Object.entries(weights).filter(function (_ref2) {
        var _ref3 = storeForm__slicedToArray(_ref2, 2),
            surfaceWeights = _ref3[1];

        var total = getSurfaceTotal(surfaceWeights);
        return total > 0 && total !== 100;
      }).map(function (_ref4) {
        var _ref5 = storeForm__slicedToArray(_ref4, 1),
            surfaceType = _ref5[0];

        return surfaceType;
      });

      if (invalidSurfaces.length === 0) return null;
      return 'Installer weights must total 100% for: ' + invalidSurfaces.join(', ');
    }
  });
  Object.defineProperty(this, 'handlePrioritizationWeightsChange', {
    enumerable: true,
    writable: true,
    value: function value(weights) {
      var store = storeForm__extends({}, _this2.state.store);
      store.installer_prioritization_weights = weights;
      _this2.setState({ store: store });
    }
  });
  Object.defineProperty(this, 'isInstallerWeightsInvalid', {
    enumerable: true,
    writable: true,
    value: function value() {
      var store = _this2.state.store;

      var weights = store.installer_prioritization_weights || {};

      return Object.values(weights).some(function (surfaceWeights) {
        var total = getSurfaceTotal(surfaceWeights);
        return total > 0 && total !== 100;
      });
    }
  });
  Object.defineProperty(this, 'confirmAndDelete', {
    enumerable: true,
    writable: true,
    value: function value(index) {
      var sc = storeForm__extends({}, _this2.state.store_contacts[index]);
      var name = sc.name && sc.name.trim() || 'the store contact';
      var message = 'Are you sure you want to delete ' + name + '?';
      Object(utils["a" /* confirm */])(message).then(function () {
        _this2.deleteStoreContact(index);
      });
    }
  });
  Object.defineProperty(this, 'deleteStoreContact', {
    enumerable: true,
    writable: true,
    value: function value(index) {
      var storeContacts = _this2.state.store_contacts;
      var storeContact = storeContacts[index];
      if (storeContact.id !== undefined) {
        storeContact._destroy = true;
        _this2.setState({ store_contacts: storeContacts });
      } else {
        _this2.setState({
          store_contacts: storeContacts.slice(0, index).concat(storeContacts.slice(index + 1))
        });
      }
      _this2.props.onRemoveNestedErrors(Object(utils["v" /* removeNestedError */])('store_contacts', index, _this2.props.errors));
    }
  });
  Object.defineProperty(this, 'addStoreContact', {
    enumerable: true,
    writable: true,
    value: function value() {
      var storeContacts = _this2.state.store_contacts;
      _this2.setState({ store_contacts: storeContacts.concat({
          assessment_updates: true,
          assessment_refigure: true,
          installation_updates: true
        }) });
    }
  });
  Object.defineProperty(this, 'handleDivision', {
    enumerable: true,
    writable: true,
    value: function value(key, _value) {
      _this2.props.onDivisionChange(_value);
      _this2.handleChange(key, _value);
      _this2.removeAttributeName('region');
      _this2.removeAttributeName('market');
    }
  });
  Object.defineProperty(this, 'removeAttributeName', {
    enumerable: true,
    writable: true,
    value: function value(attr) {
      _this2.handleChange(attr + '_id', null);
      _this2.handleChange(attr + '_name', null);
    }
  });
  Object.defineProperty(this, 'handleRegion', {
    enumerable: true,
    writable: true,
    value: function value(key, _value2) {
      _this2.props.onRegionChange(_value2);
      _this2.handleChange(key, _value2);
      _this2.removeAttributeName('market');
    }
  });
  Object.defineProperty(this, 'handleChange', {
    enumerable: true,
    writable: true,
    value: function value(key, _value3) {
      var store = _this2.state.store;
      store[key] = _value3;
      _this2.setState({ store: store });
    }
  });
  Object.defineProperty(this, 'handleSCChange', {
    enumerable: true,
    writable: true,
    value: function value(i, key, _value4) {
      var storeContacts = _this2.state.store_contacts;
      if (key === 'email') {
        var strippedVal = _value4.replaceAll(' ', '');
        storeContacts[i][key] = strippedVal;
        var regex = new RegExp(constants["I" /* EMAIL_VALIDATION_REGEX */]);
        if (regex.test(strippedVal)) storeContacts[i].emailError = false;else storeContacts[i].emailError = true;
      } else storeContacts[i][key] = _value4;
      _this2.setState({ store_contacts: storeContacts });
    }
  });
  Object.defineProperty(this, 'handleCancel', {
    enumerable: true,
    writable: true,
    value: function value() {
      return _this2.props.onCancel();
    }
  });
  Object.defineProperty(this, 'handleSave', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _state = _this2.state,
          store_contacts = _state.store_contacts,
          _state$store = _state.store,
          price_patch = _state$store.price_patch,
          store = storeForm__objectWithoutProperties(_state$store, ['price_patch']);

      var data = storeForm__extends({}, store, {
        price_patch_id: price_patch,
        store_contacts_attributes: store_contacts
      });
      _this2.props.onSave(data);
    }
  });
  Object.defineProperty(this, 'generateSource', {
    enumerable: true,
    writable: true,
    value: function value(array) {
      var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (defaultValue !== null && array.length === 0 && !!_this2.state.store.id) {
        array.push(defaultValue);
      }
      return Object(utils["j" /* generateSource */])(array);
    }
  });
  Object.defineProperty(this, 'validateStoreNumber', {
    enumerable: true,
    writable: true,
    value: function value() {
      var store = _this2.state.store;

      var number = store.number;
      var vendor = store.vendor || 'LHI';
      if (number == null || number === '') return 'Store number is required.';
      if (vendor == null || vendor === '') return 'Vendor is required.';
      switch (vendor) {
        case 'LHI':
        case 'IFI':
          if (!/^[0-9]{4}$/.test(number)) return 'LHI/IFI store number must be exactly 4 digits.';
          break;
        case 'RF':
          if (!/^RF[0-9]{4}$/.test(number)) return "RF store number must be 'RF' followed by 4 digits.";
          if (number.length !== 6) return 'RF store number must be exactly 6 characters.';
          break;
        case 'FD':
          if (!/^FD[0-9]{4}$/.test(number)) return "FD store number must be 'FD' followed by 4 digits.";
          if (number.length !== 6) return 'FD store number must be exactly 6 characters.';
          break;
        case 'AH':
          if (!/^AH[0-9]{5}$/.test(number)) return "AH store number must be 'AH' followed by 5 digits.";
          if (number.length !== 7) return 'AH store number must be exactly 7 characters.';
          break;
        case 'BJ':
          if (!/^BJ[0-9]{3}$/.test(number)) return "BJ store number must be 'BJ' followed by 3 digits.";
          if (number.length !== 5) return 'BJ store number must be exactly 5 characters.';
          break;
        case 'SAM':
          if (!/^SAM[0-9]{4}$/.test(number)) return "SAM store number must be 'SAM' followed by 4 digits.";
          if (number.length !== 7) return 'SAM store number must be exactly 7 characters.';
          break;
        case 'WAY':
          if (!/^WAY[0-9]{3}$/.test(number)) return "WAY store number must be 'WAY' followed by 3 digits.";
          if (number.length !== 6) return 'WAY store number must be exactly 6 characters.';
          break;
        default:
          return 'Unknown vendor.';
      }
      return null;
    }
  });
  Object.defineProperty(this, 'renderTitle', {
    enumerable: true,
    writable: true,
    value: function value(store, isEdit) {
      var _cx;

      var switchClassNames = classnames_default()((_cx = {}, storeForm__defineProperty(_cx, form_default.a.switchTitleAdd, !isEdit), storeForm__defineProperty(_cx, form_default.a.switchTitle, true), _cx));
      return react_default.a.createElement(
        flexbox_react_dist_default.a,
        { justifyContent: 'space-between', className: form_default.a.divider },
        react_default.a.createElement(
          'div',
          { className: storeForm_titleStyle },
          react_default.a.createElement(
            'h5',
            { className: form_default.a.cardTitle },
            isEdit ? 'Edit Store' : 'Add Store'
          ),
          react_default.a.createElement(
            'p',
            { className: form_default.a.cardSubtitle },
            'Please ensure that all fields contain accurate information'
          )
        ),
        react_default.a.createElement(
          'div',
          { style: { paddingTop: '24px' } },
          react_default.a.createElement(react_toolbox_lib["Switch"], {
            name: 'ccs_schedulable',
            label: 'CCS Schedulable',
            onChange: _this2.handleCcsSchedulable,
            className: switchClassNames,
            checked: store.ccs_schedulable
          })
        )
      );
    }
  });
  Object.defineProperty(this, 'renderPrioritization', {
    enumerable: true,
    writable: true,
    value: function value(store, canEditDetails) {
      var _props = _this2.props,
          installersForPrioritization = _props.installersForPrioritization,
          ifiSurfaceTypes = _props.ifiSurfaceTypes;

      return react_default.a.createElement(
        'div',
        { className: form_default.a.prioritizationSection },
        react_default.a.createElement(
          'h5',
          { className: form_default.a.childTitle },
          'Installer Prioritization Weights'
        ),
        react_default.a.createElement(components_InstallerPrioritizationSliders, {
          weights: store.installer_prioritization_weights || {},
          installers: installersForPrioritization || [],
          surfaceTypes: ifiSurfaceTypes || [],
          onChange: _this2.handlePrioritizationWeightsChange,
          disabled: !canEditDetails
        })
      );
    }
  });
  Object.defineProperty(this, 'render', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _state2 = _this2.state,
          store = _state2.store,
          _state2$store_contact = _state2.store_contacts,
          store_contacts = _state2$store_contact === undefined ? [] : _state2$store_contact;
      var _props2 = _this2.props,
          errors = _props2.errors,
          divisions = _props2.divisions,
          regions = _props2.regions,
          markets = _props2.markets,
          role = _props2.role,
          storeDetails = _props2.storeDetails,
          position = _props2.position,
          manageVendorWorkrooms = _props2.manageVendorWorkrooms;
      var vendor = store.vendor;

      var isEdit = !!store.id;
      var gError = Object(utils["c" /* error */])('global', errors);
      var canEditDetails = Object(services["a" /* can */])(role, 'update', 'store_details');
      var canEditContact = Object(services["a" /* can */])(role, 'update', 'store_contact');
      var canAddContact = Object(services["a" /* can */])(role, 'create', 'store_contact');
      var canManageVendors = Object(services["a" /* can */])(role, 'manage', 'manage_vendors');
      var contactError = store_contacts.length && store_contacts.some(function (c) {
        return 'emailError' in c && c.emailError;
      });
      var storeNumberError = _this2.validateStoreNumber();
      var isIfiVendorStore = storeDetails && storeDetails.vendor === 'IFI';
      var canManagePrioritizationWeights = Object(services["a" /* can */])(role, 'manage', 'installer_prioritization_weights', {
        position: position || '',
        manageVendorWorkrooms: manageVendorWorkrooms || {}
      });
      var showPrioritizationWeights = isIfiVendorStore && canManagePrioritizationWeights;
      var weightsInvalid = _this2.isInstallerWeightsInvalid();
      var weightsValidationMessage = showPrioritizationWeights ? _this2.getWeightsValidationMessage() : null;
      return react_default.a.createElement(
        react_css_themr_lib["ThemeProvider"],
        { theme: storeForm_theme },
        react_default.a.createElement(
          components_Card,
          null,
          _this2.renderTitle(store, isEdit),
          gError ? react_default.a.createElement(MessageBox["a" /* default */], { error: true, message: gError }) : null,
          storeNumberError && react_default.a.createElement(MessageBox["a" /* default */], { error: true, message: storeNumberError }),
          canEditDetails && react_default.a.createElement(
            'div',
            null,
            react_default.a.createElement(
              flexbox_react_dist_default.a,
              { flexWrap: 'wrap', className: form_default.a.divider },
              canManageVendors && react_default.a.createElement(components_StyledSelect, {
                className: storeForm_smallInput,
                label: 'Vendor',
                placeholder: 'Select Vendor',
                onChange: _this2.handleVendor,
                options: _this2.vendorsSource,
                value: store.vendor,
                error: Object(utils["c" /* error */])('vendor', errors),
                required: true
              }),
              react_default.a.createElement(react_toolbox_lib["Input"], {
                label: 'Store Name',
                className: storeForm_mediumInput,
                value: store.name,
                onChange: _this2.onNameChange,
                error: Object(utils["c" /* error */])('name', errors),
                required: true
              }),
              react_default.a.createElement(react_toolbox_lib["Input"], {
                label: 'Store Number',
                className: storeForm_smallInput,
                value: store.number,
                onChange: _this2.onNumberChange,
                error: Object(utils["c" /* error */])('number', errors),
                required: true
              }),
              react_default.a.createElement(react_toolbox_lib["Input"], {
                label: 'Street Address',
                className: storeForm_largeInput,
                value: store.address,
                onChange: _this2.onAddressChange,
                error: Object(utils["c" /* error */])('address', errors),
                required: true
              }),
              react_default.a.createElement(react_toolbox_lib["Input"], {
                label: 'City',
                className: storeForm_largeInput,
                value: store.city,
                onChange: _this2.onCityChange,
                error: Object(utils["c" /* error */])('city', errors),
                required: true
              }),
              react_default.a.createElement(components_StyledSelect, {
                className: storeForm_mediumInput,
                label: 'State',
                onChange: _this2.handleState,
                options: _this2.statesSource,
                value: store.state,
                placeholder: 'Select State',
                error: Object(utils["c" /* error */])('state', errors),
                required: true
              }),
              react_default.a.createElement(react_toolbox_lib["Input"], {
                label: 'Zip Code',
                className: storeForm_smallInput,
                value: store.zip_code,
                onChange: _this2.onZipChange,
                error: Object(utils["c" /* error */])('zip_code', errors),
                required: true
              }),
              react_default.a.createElement(PhoneType_PhoneInput, {
                label: 'Phone Number',
                type: 'tel',
                value: store.phone_number,
                className: storeForm_largeInput,
                onChange: _this2.onPhoneChange,
                error: Object(utils["c" /* error */])('phone_number', errors),
                required: true
              }),
              react_default.a.createElement(components_StyledSelect, {
                className: storeForm_largeInput,
                label: 'Time Zone',
                placeholder: 'Select Time Zone',
                onChange: _this2.handleTimezone,
                options: _this2.timezonesSource,
                value: store.timezone,
                error: Object(utils["c" /* error */])('timezone', errors),
                required: true
              }),
              react_default.a.createElement(react_select, {
                className: storeForm_largeInput,
                label: 'Price Patch Number',
                placeholder: 'Select Price Patch',
                onChange: _this2.handlePricePatch,
                options: _this2.pricePatchesSource,
                value: store.price_patch || '',
                error: Object(utils["c" /* error */])('price_patch', errors),
                simpleValue: true,
                required: true
              }),
              react_default.a.createElement(react_toolbox_lib["Input"], {
                label: 'Quickbooks ID',
                className: storeForm_largeInput,
                value: store.quickbooks_ident,
                onChange: _this2.onQuickbooksChange,
                error: Object(utils["c" /* error */])('quickbooks_ident', errors),
                required: true
              }),
              react_default.a.createElement(components_StyledSelect, {
                className: storeForm_largeInput,
                label: 'ISO/IST',
                placeholder: 'Select ISO/IST',
                onChange: _this2.handleIsoIst,
                options: ISO_IST.map(function (istIso) {
                  return { value: istIso, label: istIso };
                }),
                value: store.cpo_iso,
                error: Object(utils["c" /* error */])('cpo_iso', errors),
                required: true
              }),
              react_default.a.createElement(PhoneType_PhoneInput, {
                label: 'Fax Number: Flooring',
                type: 'tel',
                value: store.fax_number_flooring,
                className: storeForm_largeInput,
                onChange: _this2.onFaxFlooringChange,
                error: Object(utils["c" /* error */])('fax_number_flooring', errors)
              }),
              react_default.a.createElement(PhoneType_PhoneInput, {
                label: 'Fax Number: Installed Sales',
                type: 'tel',
                value: store.fax_number_installed_sales,
                className: storeForm_largeInput,
                onChange: _this2.onFaxSalesChange,
                error: Object(utils["c" /* error */])('fax_number_installed_sales', errors)
              }),
              react_default.a.createElement(PhoneType_PhoneInput, {
                label: 'Fax Number: Receiving',
                type: 'tel',
                value: store.fax_number_receiving,
                className: storeForm_largeInput,
                onChange: _this2.onFaxReceivingChange,
                error: Object(utils["c" /* error */])('fax_number_receiving', errors)
              }),
              react_default.a.createElement(components_StyledSelect, {
                className: storeForm_mediumInput,
                label: 'Express Ship Days',
                onChange: _this2.handleExpressShipDays,
                options: _this2.expressShipDaysSource,
                value: store.express_ship_days,
                placeholder: 'Select Express Ship Days',
                error: Object(utils["c" /* error */])('express_ship_days', errors),
                required: true
              })
            ),
            react_default.a.createElement(
              flexbox_react_dist_default.a,
              { flexWrap: 'wrap', className: form_default.a.divider },
              react_default.a.createElement(components_StyledSelect, {
                className: storeForm_largeInput,
                label: vendor === 'IFI' ? 'District' : 'Workroom',
                placeholder: vendor === 'IFI' ? 'Select District' : 'Select Workroom',
                onChange: _this2.handleWorkroom,
                options: _this2.workroomsSource,
                value: store.workroom_id,
                error: Object(utils["c" /* error */])('workroom_id', errors),
                required: true
              }),
              react_default.a.createElement(components_StyledSelect, {
                className: storeForm_largeInput,
                label: 'Division',
                placeholder: 'Select Division',
                onChange: _this2.handleDivision,
                options: Object(utils["j" /* generateSource */])(divisions),
                value: store.division_id,
                error: Object(utils["c" /* error */])('division_id', errors),
                required: true
              }),
              react_default.a.createElement(components_StyledSelect, {
                className: storeForm_largeInput,
                label: 'Region',
                placeholder: 'Select Region',
                onChange: _this2.handleRegion,
                options: _this2.generateSource(regions, { id: store.region_id, name: store.region_name }),
                value: store.region_id,
                error: Object(utils["c" /* error */])('region_id', errors),
                required: true
              }),
              react_default.a.createElement(components_StyledSelect, {
                className: storeForm_largeInput,
                label: 'Market',
                placeholder: 'Select Market',
                onChange: _this2.handleMarket,
                options: _this2.generateSource(markets, { id: store.market_id, name: store.market_name }),
                value: store.market_id,
                error: Object(utils["c" /* error */])('market_id', errors),
                required: true
              }),
              react_default.a.createElement('br', null),
              react_default.a.createElement(
                'div',
                { className: storeForm_largeInput },
                react_default.a.createElement(components_TaggedInput, {
                  label: 'Covered Zip Codes',
                  values: (store.covered_zip_codes || []).sort(function (a, b) {
                    return a - b;
                  }) || [],
                  onChange: _this2.handleCoveredZipChange,
                  errors: errors.covered_zip_codes || []
                })
              ),
              react_default.a.createElement(components_RadioButtons, {
                className: deliveryRadioBtns,
                label: 'Delivery Method',
                onChange: _this2.handleDeliveryType,
                selectedValue: store.delivery_method,
                radioButtons: [{ label: 'None', value: 'None' }, { label: 'Delivery', value: 'Delivery' }, { label: 'Pickup', value: 'Pickup' }],
                required: true
              })
            ),
            react_default.a.createElement(
              flexbox_react_dist_default.a,
              { flexWrap: 'wrap', className: form_default.a.divider },
              react_default.a.createElement(react_toolbox_lib["Checkbox"], {
                checked: store.disable_cpo_emails,
                label: 'Disable IST Emails',
                onChange: _this2.handleDisableIstEmails,
                className: form_default.a.checkboxListItem,
                theme: checkbox_default.a
              })
            )
          ),
          canEditContact && react_default.a.createElement(
            flexbox_react_dist_default.a,
            { flexWrap: 'wrap', className: form_default.a.divider },
            react_default.a.createElement(
              flexbox_react_dist_default.a,
              { justifyContent: 'space-between', flex: '1' },
              react_default.a.createElement(
                'h5',
                { className: form_default.a.childTitle },
                'Store Contacts'
              ),
              canAddContact && react_default.a.createElement(react_toolbox_lib["Button"], {
                className: form_default.a.addChildButton,
                onClick: _this2.addStoreContact,
                label: 'Add Store Contact'
              })
            ),
            store_contacts.map(function (contact, i) {
              return !contact._destroy ?
              /* eslint-disable react/jsx-no-bind */
              react_default.a.createElement(storeContactForm, {
                key: contact.id,
                storeContact: contact,
                errors: errors,
                onChange: _this2.handleSCChange.bind(_this2, i),
                index: i,
                onDelete: _this2.confirmAndDelete,
                role: role
              }) : null;
            })
          ),
          showPrioritizationWeights && _this2.renderPrioritization(store, canEditDetails),
          react_default.a.createElement(
            flexbox_react_dist_default.a,
            { justifyContent: 'flex-end', flexWrap: 'wrap', alignItems: 'center' },
            react_default.a.createElement(
              react_toolbox_lib["CardActions"],
              { className: form_default.a.actionsWrapper },
              weightsValidationMessage && react_default.a.createElement(
                'span',
                { className: form_default.a.weightsError },
                weightsValidationMessage
              ),
              react_default.a.createElement(ColoredButton["a" /* default */], {
                className: storeForm_cancelClass,
                responsive: true,
                color: 'gray',
                label: 'Cancel',
                onClick: _this2.handleCancel
              }),
              react_default.a.createElement(ColoredButton["a" /* default */], {
                className: form_default.a.actionButton,
                responsive: true,
                color: 'green',
                label: isEdit ? 'Save Changes' : 'Add store',
                onClick: _this2.handleSave,
                disabled: contactError || !!storeNumberError || weightsInvalid
              })
            )
          )
        )
      );
    }
  });
};

storeForm_StoreForm.propTypes = {
  dispatch: prop_types_default.a.func,
  workrooms: prop_types_default.a.arrayOf(types_workroom).isRequired,
  pricePatches: prop_types_default.a.arrayOf(types_pricePatch).isRequired,
  divisions: prop_types_default.a.arrayOf(division).isRequired,
  regions: prop_types_default.a.arrayOf(region).isRequired,
  markets: prop_types_default.a.arrayOf(market).isRequired,
  storeDetails: types_store,
  onRemoveNestedErrors: prop_types_default.a.func,
  onDivisionChange: prop_types_default.a.func,
  onRegionChange: prop_types_default.a.func,
  onCancel: prop_types_default.a.func,
  onSave: prop_types_default.a.func,
  errors: prop_types_default.a.object,
  role: prop_types_default.a.string.isRequired,
  position: prop_types_default.a.string,
  manageVendorWorkrooms: prop_types_default.a.object,
  installersForPrioritization: prop_types_default.a.arrayOf(prop_types_default.a.shape({
    id: prop_types_default.a.number.isRequired,
    name: prop_types_default.a.string.isRequired,
    phase_count: prop_types_default.a.number.isRequired
  })),
  ifiSurfaceTypes: prop_types_default.a.arrayOf(prop_types_default.a.string)
};

/* harmony default export */ var storeForm = (Object(react_redux_es["connect"])(function (state) {
  return {
    role: Object(reducers["_12" /* getRole */])(state),
    position: Object(reducers["_8" /* getPosition */])(state),
    manageVendorWorkrooms: Object(reducers["N" /* getManageVendorWorkrooms */])(state)
  };
})(storeForm_StoreForm));
// CONCATENATED MODULE: ./client/app/screens/main/screens/stores/storeNew.jsx
var storeNew__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function storeNew__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function storeNew__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function storeNew__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var storeNew_StoreNew = function (_Component) {
  storeNew__inherits(StoreNew, _Component);

  function StoreNew(props) {
    storeNew__classCallCheck(this, StoreNew);

    var _this = storeNew__possibleConstructorReturn(this, (StoreNew.__proto__ || Object.getPrototypeOf(StoreNew)).call(this, props));

    _this.handleSave = _this.handleSave.bind(_this);
    _this.handleDivisionChange = _this.handleDivisionChange.bind(_this);
    _this.handleRegionChange = _this.handleRegionChange.bind(_this);

    _this.handleCancel = function () {
      _this.props.dispatch(Object(actionCreators["O" /* navigate */])('/stores'));
    };
    _this.setSucessMessage = function (name, number) {
      _this.props.updateUI('successMessage', 'The store # ' + number + ' - ' + name + ' was successfully created.');
    };

    _this.state = {
      regionId: null,
      divisionId: null,
      allLoaded: false
    };
    return _this;
  }

  storeNew__createClass(StoreNew, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      Promise.all([this.props.dispatch(Object(actionCreators["W" /* requestDivisionList */])()), this.props.dispatch(Object(actionCreators["_20" /* requestPricePatchesList */])())]).then(function () {
        _this2.setState({ allLoaded: true });
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.dispatch(Object(actionCreators["k" /* clearValidationErrors */])('STORE'));
    }
  }, {
    key: 'handleDivisionChange',
    value: function handleDivisionChange(divisionId) {
      var dispatch = this.props.dispatch;

      dispatch(Object(actionCreators["_22" /* requestRegionList */])(divisionId));

      this.setState({
        divisionId: divisionId,
        regionId: null
      });
    }
  }, {
    key: 'handleRegionChange',
    value: function handleRegionChange(regionId) {
      var dispatch = this.props.dispatch;


      this.setState({ regionId: regionId });
      dispatch(Object(actionCreators["_12" /* requestMarketList */])(regionId));
    }
  }, {
    key: 'handleSave',
    value: function handleSave(store) {
      var dispatch = this.props.dispatch;

      dispatch(Object(actionCreators["u" /* createStore */])(store, this.setSucessMessage));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          errors = _props.errors,
          workrooms = _props.workrooms,
          markets = _props.markets,
          regions = _props.regions,
          divisions = _props.divisions,
          pricePatches = _props.pricePatches;
      var _state = this.state,
          divisionId = _state.divisionId,
          regionId = _state.regionId;

      var filteredRegions = regions.filter(Object(utils["e" /* filterByDivisionId */])(divisionId));
      var filteredMarkets = markets.filter(Object(utils["f" /* filterByRegionId */])(regionId));

      return react_default.a.createElement(
        react_responsive_default.a,
        { minWidth: constants["y" /* CUT_POINT */] },
        this.state.allLoaded ? react_default.a.createElement(storeForm, {
          errors: errors,
          onSave: this.handleSave,
          onCancel: this.handleCancel,
          onDivisionChange: this.handleDivisionChange,
          onRegionChange: this.handleRegionChange,
          workrooms: workrooms,
          markets: filteredMarkets,
          regions: filteredRegions,
          divisions: divisions,
          pricePatches: pricePatches
        }) : react_default.a.createElement(components_Loading, null)
      );
    }
  }]);

  return StoreNew;
}(react["Component"]);

storeNew_StoreNew.propTypes = {
  dispatch: prop_types_default.a.func,
  errors: prop_types_default.a.object,
  workrooms: prop_types_default.a.array,
  markets: prop_types_default.a.array,
  regions: prop_types_default.a.array,
  divisions: prop_types_default.a.array,
  updateUI: prop_types_default.a.func,
  pricePatches: prop_types_default.a.array
};

var storeNew_mapStateToProps = function mapStateToProps(state) {
  return {
    errors: Object(reducers["_15" /* getStoreErrors */])(state) || {},
    workrooms: Object(reducers["_37" /* getWorkroomList */])(state) || [],
    markets: Object(reducers["O" /* getMarketList */])(state),
    regions: Object(reducers["_11" /* getRegionList */])(state),
    divisions: Object(reducers["d" /* getDivisionList */])(state),
    pricePatches: Object(reducers["_10" /* getPricePatchesList */])(state)
  };
};

/* harmony default export */ var storeNew = (transpiled_default()()(Object(react_redux_es["connect"])(storeNew_mapStateToProps)(storeNew_StoreNew)));
// CONCATENATED MODULE: ./client/app/screens/main/screens/stores/storeEdit.jsx
var storeEdit__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function storeEdit__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function storeEdit__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function storeEdit__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var storeEdit_StoreEdit = function (_Component) {
  storeEdit__inherits(StoreEdit, _Component);

  function StoreEdit(props) {
    storeEdit__classCallCheck(this, StoreEdit);

    var _this = storeEdit__possibleConstructorReturn(this, (StoreEdit.__proto__ || Object.getPrototypeOf(StoreEdit)).call(this, props));

    _this.handleSave = _this.handleSave.bind(_this);
    _this.handleDivisionChange = _this.handleDivisionChange.bind(_this);
    _this.handleRegionChange = _this.handleRegionChange.bind(_this);
    _this.handleRemoveNestedErros = _this.handleRemoveNestedErros.bind(_this);

    _this.handleCancel = function () {
      _this.props.dispatch(Object(actionCreators["P" /* navigateBack */])());
    };
    _this.setSucessMessage = function () {
      _this.props.updateUI('successMessage', 'Changes have been saved');
    };

    _this.state = {
      regionId: null,
      divisionId: null,
      allLoaded: false
    };
    return _this;
  }

  storeEdit__createClass(StoreEdit, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var _props = this.props,
          dispatch = _props.dispatch,
          id = _props.id;

      Promise.all([dispatch(Object(actionCreators["W" /* requestDivisionList */])()), dispatch(Object(actionCreators["_20" /* requestPricePatchesList */])()), dispatch(Object(actionCreators["_24" /* requestStore */])(id))]).then(function () {
        _this2.setState({ allLoaded: true });
        dispatch(Object(actionCreators["z" /* fetchInstallersForPrioritization */])(id));
      });
      /*
        This can be improved by async loading the  divisions & price patches.
        Also take into account that this will fail if one of the promises rejects
        We need to change the convention of rejecting a thunk when
        a failure action is dispatched
      */
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _props2 = this.props,
          dispatch = _props2.dispatch,
          id = _props2.id;

      if (!prevProps.store && this.props.store) {
        dispatch(Object(actionCreators["z" /* fetchInstallersForPrioritization */])(id));
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var dispatch = this.props.dispatch;

      dispatch(Object(actionCreators["k" /* clearValidationErrors */])('STORE'));
      dispatch(Object(actionCreators["_37" /* resetInstallerPrioritization */])());
    }
  }, {
    key: 'handleRemoveNestedErros',
    value: function handleRemoveNestedErros(errors) {
      var dispatch = this.props.dispatch;

      dispatch(Object(actionCreators["k" /* clearValidationErrors */])('STORE', errors));
    }
  }, {
    key: 'handleDivisionChange',
    value: function handleDivisionChange(divisionId) {
      var dispatch = this.props.dispatch;

      dispatch(Object(actionCreators["_22" /* requestRegionList */])(divisionId));

      this.setState({
        divisionId: divisionId,
        regionId: null
      });
    }
  }, {
    key: 'handleRegionChange',
    value: function handleRegionChange(regionId) {
      var dispatch = this.props.dispatch;


      this.setState({ regionId: regionId });
      dispatch(Object(actionCreators["_12" /* requestMarketList */])(regionId));
    }
  }, {
    key: 'handleSave',
    value: function handleSave(store) {
      var _props3 = this.props,
          dispatch = _props3.dispatch,
          phaseId = _props3.phaseId;

      dispatch(Object(actionCreators["_71" /* updateStore */])(store, this.setSucessMessage));
      // Updates phase in fringe case of viewing phase back to back after editing store
      if (phaseId) dispatch(Object(actionCreators["G" /* loadPhase */])(phaseId));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          errors = _props4.errors,
          workrooms = _props4.workrooms,
          divisions = _props4.divisions,
          store = _props4.store,
          regions = _props4.regions,
          markets = _props4.markets,
          loadingStore = _props4.loadingStore,
          pricePatches = _props4.pricePatches,
          installerPrioritization = _props4.installerPrioritization;
      var _state = this.state,
          divisionId = _state.divisionId,
          regionId = _state.regionId;

      var filteredRegions = regions.filter(Object(utils["e" /* filterByDivisionId */])(divisionId));
      var filteredMarkets = markets.filter(Object(utils["f" /* filterByRegionId */])(regionId));

      return !loadingStore && this.state.allLoaded ? react_default.a.createElement(
        react_responsive_default.a,
        { minWidth: constants["y" /* CUT_POINT */] },
        react_default.a.createElement(storeForm, {
          storeDetails: store,
          errors: errors,
          onSave: this.handleSave,
          onCancel: this.handleCancel,
          onDivisionChange: this.handleDivisionChange,
          onRegionChange: this.handleRegionChange,
          onRemoveNestedErrors: this.handleRemoveNestedErros,
          workrooms: workrooms,
          markets: filteredMarkets,
          regions: filteredRegions,
          divisions: divisions,
          pricePatches: pricePatches,
          installersForPrioritization: installerPrioritization.installers,
          ifiSurfaceTypes: installerPrioritization.surfaceTypes
        })
      ) : react_default.a.createElement(
        'p',
        null,
        ' Loading...'
      );
    }
  }]);

  return StoreEdit;
}(react["Component"]);

storeEdit_StoreEdit.propTypes = {
  dispatch: prop_types_default.a.func,
  updateUI: prop_types_default.a.func,
  id: prop_types_default.a.number,
  phaseId: prop_types_default.a.number,
  store: prop_types_default.a.object,
  errors: prop_types_default.a.object,
  loadingStore: prop_types_default.a.bool,
  workrooms: prop_types_default.a.array,
  markets: prop_types_default.a.array,
  regions: prop_types_default.a.array,
  divisions: prop_types_default.a.array,
  pricePatches: prop_types_default.a.array,
  installerPrioritization: prop_types_default.a.shape({
    installers: prop_types_default.a.array,
    surfaceTypes: prop_types_default.a.array,
    loading: prop_types_default.a.bool
  })
};

var storeEdit_mapStateToProps = function mapStateToProps(state, ownProps) {
  var id = Number(ownProps.params.id);
  var store = Object(reducers["_14" /* getStoreById */])(state)(id);
  var phaseId = state.phase.details.id;

  return {
    id: id,
    store: store,
    phaseId: phaseId,
    errors: Object(reducers["_15" /* getStoreErrors */])(state) || {},
    loadingStore: store ? store.loading : true,
    workrooms: Object(reducers["_37" /* getWorkroomList */])(state) || [],
    markets: Object(reducers["O" /* getMarketList */])(state),
    regions: Object(reducers["_11" /* getRegionList */])(state),
    divisions: Object(reducers["d" /* getDivisionList */])(state),
    pricePatches: Object(reducers["_10" /* getPricePatchesList */])(state),
    installerPrioritization: Object(reducers["_17" /* getStoreInstallerPrioritization */])(state)
  };
};

/* harmony default export */ var storeEdit = (transpiled_default()()(Object(react_redux_es["connect"])(storeEdit_mapStateToProps)(storeEdit_StoreEdit)));
// CONCATENATED MODULE: ./client/app/screens/main/screens/stores/index.jsx
var stores__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var stores__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function stores__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function stores__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function stores__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var stores_Stores = function (_React$Component) {
  stores__inherits(Stores, _React$Component);

  function Stores(context, props) {
    stores__classCallCheck(this, Stores);

    var _this = stores__possibleConstructorReturn(this, (Stores.__proto__ || Object.getPrototypeOf(Stores)).call(this, context, props));

    Object.defineProperty(_this, 'onSearch', {
      enumerable: true,
      writable: true,
      value: function value(e, _value) {
        e.preventDefault();
        var filters = stores__extends({}, _this.props.filters);
        filters.query = _value;
        _this.props.setStoreFilters(filters);
      }
    });


    _this.toggleFilterDrawer = function () {
      _this.setState({ showFilterDrawer: !_this.state.showFilterDrawer });
    };
    _this.isIndexRoute = function () {
      return _this.props.location.pathname === _this.props.route.path;
    };

    _this.addStoreAction = _this.addStoreAction.bind(_this);
    _this.state = {
      showFilterDrawer: false
    };
    return _this;
  }

  stores__createClass(Stores, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.requestWorkroomList();
    }
  }, {
    key: 'addStoreAction',
    value: function addStoreAction() {
      this.props.navigate('/stores/new');
    }
  }, {
    key: 'render',
    value: function render() {
      var showFiltersDrawer = this.isIndexRoute();
      var searchText = 'Search for a store by name or number...';
      return react_default.a.createElement(
        'div',
        null,
        react_default.a.createElement(components_PageActionBar, {
          resource: 'store',
          role: this.props.role,
          hidesAddOnMobile: true,
          showFiltersBtn: showFiltersDrawer,
          addAction: this.addStoreAction,
          title: 'Store Management',
          searchText: searchText,
          toggleFilters: this.toggleFilterDrawer,
          onSearch: this.onSearch
        }),
        react_default.a.createElement(
          'div',
          { className: contentArea_default.a.contentAreaContainer },
          this.props.children,
          react_default.a.createElement(Filters_StoreFilters, {
            active: this.state.showFilterDrawer,
            onOverlayClick: this.toggleFilterDrawer,
            handleFilterChange: this.props.setStoreFilters,
            filters: this.props.filters,
            title: 'Estimators',
            reset: this.props.resetStoreFilters
          })
        )
      );
    }
  }]);

  return Stores;
}(react_default.a.Component);

Object.defineProperty(stores_Stores, 'propTypes', {
  enumerable: true,
  writable: true,
  value: {
    location: prop_types_default.a.shape({
      pathname: prop_types_default.a.string
    }),
    route: prop_types_default.a.shape({
      path: prop_types_default.a.string
    }),
    navigate: prop_types_default.a.func.isRequired,
    requestWorkroomList: prop_types_default.a.func.isRequired,
    role: prop_types_default.a.string,
    children: prop_types_default.a.node,
    filters: prop_types_default.a.object,
    resetStoreFilters: prop_types_default.a.func,
    setStoreFilters: prop_types_default.a.func
  }
});


function stores_mapStateToProps(state) {
  return {
    role: Object(reducers["_12" /* getRole */])(state),
    filters: Object(reducers["_16" /* getStoreFilters */])(state)
  };
}

/* harmony default export */ var screens_stores = (transpiled_default()({ key: 'stores', state: { successMessage: '' } })(Object(react_redux_es["connect"])(stores_mapStateToProps, {
  requestWorkroomList: actionCreators["_31" /* requestWorkroomList */],
  navigate: actionCreators["O" /* navigate */],
  navigateBack: actionCreators["P" /* navigateBack */],
  resetStoreFilters: actionCreators["_39" /* resetStoreFilters */],
  setStoreFilters: actionCreators["_51" /* setStoreFilters */],
  getStoreFilters: reducers["_16" /* getStoreFilters */]
})(stores_Stores)));


// CONCATENATED MODULE: ./client/app/screens/main/screens/estimators/components/estimatorCard.jsx






var estimatorCard_EstimatorCard = function EstimatorCard(_ref) {
  var estimator = _ref.estimator,
      workrooms = _ref.workrooms;
  return react_default.a.createElement(
    users_UserCard,
    { user: estimator, type: 'estimators' },
    react_default.a.createElement(ResourceCardElement, {
      title: 'Workroom(s)',
      size: 'medium',
      value: Object(utils["A" /* stringifyList */])(workrooms) || 'No Workroom'
    })
  );
};

estimatorCard_EstimatorCard.propTypes = { estimator: prop_types_default.a.object, workrooms: prop_types_default.a.array };

/* harmony default export */ var estimatorCard = (estimatorCard_EstimatorCard);
// CONCATENATED MODULE: ./client/app/screens/main/screens/estimators/estimatorList.jsx
var estimatorList__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function estimatorList__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function estimatorList__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function estimatorList__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function estimatorList__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var estimatorList_EstimatorList = function (_Component) {
  estimatorList__inherits(EstimatorList, _Component);

  function EstimatorList() {
    var _ref;

    var _temp, _this, _ret;

    estimatorList__classCallCheck(this, EstimatorList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = estimatorList__possibleConstructorReturn(this, (_ref = EstimatorList.__proto__ || Object.getPrototypeOf(EstimatorList)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'componentDidMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.requestEstimatorList();
      }
    }), Object.defineProperty(_this, 'componentWillUnmount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.updateUI('successMessage', '');
      }
    }), Object.defineProperty(_this, 'handleInfiniteLoad', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.needsMore && !_this.props.loading ? _this.props.requestEstimatorList() : null;
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            estimators = _this$props.estimators,
            loading = _this$props.loading,
            needsMore = _this$props.needsMore,
            workroomsByEstimator = _this$props.workroomsByEstimator;

        return react_default.a.createElement(
          'div',
          null,
          _this.props.ui.successMessage ? react_default.a.createElement(MessageBox["a" /* default */], {
            message: _this.props.ui.successMessage
          }) : null,
          react_default.a.createElement(
            components_ListView,
            {
              loading: loading,
              needsMore: needsMore,
              handleInfiniteLoad: _this.handleInfiniteLoad
            },
            estimators.map(function (estimator) {
              return react_default.a.createElement(estimatorCard, {
                key: estimator.id,
                estimator: estimator,
                workrooms: workroomsByEstimator[estimator.id]
              });
            })
          )
        );
      }
    }), _temp), estimatorList__possibleConstructorReturn(_this, _ret);
  }

  return EstimatorList;
}(react["Component"]);

estimatorList_EstimatorList.propTypes = {
  ui: prop_types_default.a.object,
  loading: prop_types_default.a.bool,
  needsMore: prop_types_default.a.bool,
  workroomsByEstimator: prop_types_default.a.object,
  estimators: prop_types_default.a.array,
  updateUI: prop_types_default.a.func,
  dispatch: prop_types_default.a.func,
  requestEstimatorList: prop_types_default.a.func
};

var estimatorList_mapStateToProps = function mapStateToProps(state) {
  var estimators = Object(reducers["t" /* getEstimatorList */])(state);
  var loading = Object(reducers["u" /* getEstimatorLoading */])(state);
  var workroomsByEstimator = estimators.reduce(function (acc, current) {
    var workroomIds = current.workrooms || [];
    return estimatorList__extends({}, acc, estimatorList__defineProperty({}, current.id, Object(reducers["_35" /* getWorkroomFilteredByIds */])(state)(workroomIds)));
  }, {});
  return {
    loading: loading,
    estimators: estimators,
    workroomsByEstimator: workroomsByEstimator,
    needsMore: Object(reducers["s" /* getEstimatorHasNextPage */])(state)
  };
};

/* harmony default export */ var estimatorList = (transpiled_default()()(Object(react_redux_es["connect"])(estimatorList_mapStateToProps, { requestEstimatorList: actionCreators["_0" /* requestEstimatorList */] })(estimatorList_EstimatorList)));
// EXTERNAL MODULE: ./client/app/assets/images/ic-history-black-24-px-copy-4.svg
var ic_history_black_24_px_copy_4 = __webpack_require__("dFE1");
var ic_history_black_24_px_copy_4_default = /*#__PURE__*/__webpack_require__.n(ic_history_black_24_px_copy_4);

// EXTERNAL MODULE: ./client/app/shared/styles/payRateHistory.scss
var payRateHistory = __webpack_require__("yHqj");
var payRateHistory_default = /*#__PURE__*/__webpack_require__.n(payRateHistory);

// CONCATENATED MODULE: ./client/app/shared/components/PayRateElement/index.jsx
var PayRateElement__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function PayRateElement__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









var PayRateElement_PayRateElement = function PayRateElement(props) {
  var handleHistory = props.handleHistory,
      theme = props.theme,
      rate = props.rate,
      component = props.component,
      rest = PayRateElement__objectWithoutProperties(props, ['handleHistory', 'theme', 'rate', 'component']);

  var iconClass = classnames_default()(theme.button, theme.detailsView);
  var localizedRate = Number(rate.replace('$', '')).toLocaleString('en-US', {
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
  var displayRate = '$' + localizedRate;
  var Component = component || ResourceDetailsCardElement;

  return react_default.a.createElement(
    Component,
    PayRateElement__extends({ theme: theme }, rest),
    react_default.a.createElement(
      'div',
      { className: payRateHistory_default.a.wrapper },
      react_default.a.createElement(
        'span',
        { className: theme.rateValue },
        displayRate
      ),
      react_default.a.createElement(
        'button',
        { onClick: handleHistory, className: iconClass },
        react_default.a.createElement('img', { src: ic_history_black_24_px_copy_4_default.a, alt: 'history', className: theme.historyIcon })
      )
    )
  );
};

PayRateElement_PayRateElement.defaultProps = {
  rate: '0'
};

PayRateElement_PayRateElement.propTypes = {
  handleHistory: prop_types_default.a.func,
  theme: prop_types_default.a.object,
  rate: prop_types_default.a.string,
  component: prop_types_default.a.any
};

/* harmony default export */ var components_PayRateElement = (Object(react_css_themr_lib["themr"])('PayRateElement', payRateHistory_default.a)(PayRateElement_PayRateElement));
// EXTERNAL MODULE: ./client/app/screens/main/screens/estimators/components/payRates.scss
var components_payRates = __webpack_require__("mI0T");
var payRates_default = /*#__PURE__*/__webpack_require__.n(components_payRates);

// CONCATENATED MODULE: ./client/app/shared/types/assignee.js


var AssigneeType = prop_types_default.a.shape({
  id: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]).isRequired,
  name: prop_types_default.a.string.isRequired,
  kind: prop_types_default.a.string.isRequired
});

/* harmony default export */ var types_assignee = (AssigneeType);
// CONCATENATED MODULE: ./client/app/shared/types/pto.js



var PTOType = prop_types_default.a.shape({
  id: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]).isRequired,
  start_date: prop_types_default.a.string,
  end_date: prop_types_default.a.string,
  reason: prop_types_default.a.string,
  assignee: types_assignee,
  conflict: prop_types_default.a.shape({ dates: prop_types_default.a.arrayOf(prop_types_default.a.string) })
});

/* harmony default export */ var types_pto = (PTOType);
// EXTERNAL MODULE: ./client/app/shared/actionCreators/ptos.js
var actionCreators_ptos = __webpack_require__("z2+H");

// EXTERNAL MODULE: ./client/app/shared/components/EditableTable/styles.scss
var EditableTable_styles = __webpack_require__("6BM6");
var EditableTable_styles_default = /*#__PURE__*/__webpack_require__.n(EditableTable_styles);

// CONCATENATED MODULE: ./client/app/shared/components/EditableTable/components/editableTableHeaders.jsx




var editableTableHeaders_EditableTableHeaders = function EditableTableHeaders(_ref, context) {
  var cells = _ref.cells,
      showDelete = _ref.showDelete,
      showSave = _ref.showSave;

  var headers = cells.filter(function (c) {
    return c.props.display;
  }).map(function (c) {
    return react_default.a.createElement(
      'th',
      { key: c.props.label, className: EditableTable_styles_default.a.cell },
      c.props.label
    );
  });

  if (context.isEditable && !context.hasCustomControls) {
    if (showDelete) headers.unshift(react_default.a.createElement('th', { key: 'deletectrl', className: EditableTable_styles_default.a.cell }));
    if (showSave) headers.push(react_default.a.createElement('th', { key: 'savectrl', className: EditableTable_styles_default.a.cell }));
  }

  return react_default.a.createElement(
    'tr',
    { className: EditableTable_styles_default.a.headerRow },
    headers
  );
};

editableTableHeaders_EditableTableHeaders.contextTypes = {
  isEditable: prop_types_default.a.bool,
  hasCustomControls: prop_types_default.a.bool
};

editableTableHeaders_EditableTableHeaders.propTypes = {
  cells: prop_types_default.a.arrayOf(prop_types_default.a.shape({
    props: prop_types_default.a.shape({
      display: prop_types_default.a.bool,
      label: prop_types_default.a.string
    })
  })).isRequired,
  showDelete: prop_types_default.a.bool.isRequired,
  showSave: prop_types_default.a.bool.isRequired
};

editableTableHeaders_EditableTableHeaders.defaultProps = {
  cells: []
};

/* harmony default export */ var editableTableHeaders = (editableTableHeaders_EditableTableHeaders);
// CONCATENATED MODULE: ./client/app/shared/components/EditableTable/components/editableTable.jsx
function editableTable__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function editableTable__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function editableTable__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var EMPTY_TABLE = react_default.a.createElement(
  'div',
  { className: EditableTable_styles_default.a.emptyTable },
  react_default.a.createElement(
    'h4',
    null,
    'There are currently no records in this table'
  )
);

var editableTable_EditableTable = function (_React$Component) {
  editableTable__inherits(EditableTable, _React$Component);

  function EditableTable(props) {
    editableTable__classCallCheck(this, EditableTable);

    var _this = editableTable__possibleConstructorReturn(this, (EditableTable.__proto__ || Object.getPrototypeOf(EditableTable)).call(this, props));

    Object.defineProperty(_this, 'getChildContext', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            isEditable = _this$props.isEditable,
            hasCustomControls = _this$props.hasCustomControls;

        return { isEditable: isEditable, hasCustomControls: hasCustomControls, registerHeaders: _this.registerHeaders };
      }
    });
    Object.defineProperty(_this, 'registerHeaders', {
      enumerable: true,
      writable: true,
      value: function value() {
        var headers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var showDelete = arguments[1];
        var showSave = arguments[2];

        if (Object(lodash["isEqual"])(headers, _this.state.headers)) return;
        _this.setState({ headers: headers, showDelete: showDelete, showSave: showSave });
      }
    });
    Object.defineProperty(_this, 'renderEmptyState', {
      enumerable: true,
      writable: true,
      value: function value(children) {
        var _this$props2 = _this.props,
            isEditable = _this$props2.isEditable,
            title = _this$props2.title,
            emptyNode = _this$props2.emptyNode,
            hasCreatableRow = _this$props2.hasCreatableRow;

        var ignoreLengthTitles = ['Warehouse Pads', 'Customer Satisfaction Survey', 'Leveler'];
        if (isEditable) return null;
        if (hasCreatableRow && children.length === 1 && !ignoreLengthTitles.includes(title) || children.length === 0) return emptyNode;
        return null;
      }
    });
    Object.defineProperty(_this, 'renderTable', {
      enumerable: true,
      writable: true,
      value: function value(children) {
        return react_default.a.createElement(
          'table',
          { className: EditableTable_styles_default.a.table, cellSpacing: '0' },
          react_default.a.createElement(
            'thead',
            { style: _this.props.makeSticky ? { position: 'sticky', top: '138px', zIndex: '5' } : {} },
            react_default.a.createElement(editableTableHeaders, {
              cells: _this.state.headers,
              showDelete: _this.state.showDelete,
              showSave: _this.state.showSave
            })
          ),
          react_default.a.createElement(
            'tbody',
            null,
            children
          )
        );
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var children = react_default.a.Children.toArray(_this.props.children);
        return react_default.a.createElement(
          'div',
          null,
          _this.renderTable(children),
          _this.renderEmptyState(children)
        );
      }
    });

    _this.state = { headers: [], showDelete: true, showSave: true };
    return _this;
  }

  return EditableTable;
}(react_default.a.Component);

editableTable_EditableTable.childContextTypes = {
  isEditable: prop_types_default.a.bool,
  hasCustomControls: prop_types_default.a.bool,
  registerHeaders: prop_types_default.a.func
};

editableTable_EditableTable.propTypes = {
  children: prop_types_default.a.node.isRequired,
  isEditable: prop_types_default.a.bool.isRequired,
  hasCustomControls: prop_types_default.a.bool.isRequired,
  emptyNode: prop_types_default.a.node,
  hasCreatableRow: prop_types_default.a.bool,
  title: prop_types_default.a.node,
  makeSticky: prop_types_default.a.bool
};

editableTable_EditableTable.defaultProps = {
  children: null,
  isEditable: false,
  hasCustomControls: false,
  emptyNode: EMPTY_TABLE,
  hasCreatableRow: true,
  makeSticky: false
};

/* harmony default export */ var editableTable = (editableTable_EditableTable);
// EXTERNAL MODULE: ./client/app/shared/components/ConfirmDialog/index.jsx
var ConfirmDialog = __webpack_require__("nAl5");

// EXTERNAL MODULE: ./node_modules/react-tooltip/dist/index.js
var react_tooltip_dist = __webpack_require__("Hh2+");
var react_tooltip_dist_default = /*#__PURE__*/__webpack_require__.n(react_tooltip_dist);

// CONCATENATED MODULE: ./client/app/shared/components/EditableTable/components/editableTableCell.jsx







var editableTableCell_EditableTableCell = function EditableTableCell(props, context) {
  var label = props.label,
      value = props.value,
      children = props.children,
      display = props.display,
      className = props.className,
      _onChange = props.onChange,
      error = props.error,
      cellReadOnly = props.cellReadOnly;

  if (!display) return null;
  var content = value;
  if (!context.disabled && context.isEditable && _onChange && !context.readOnly && !cellReadOnly) {
    var newProps = { onChange: function onChange(event) {
        context.onChange(event, _onChange);
      } };
    content = react_default.a.Children.map(children, function (child) {
      return child && react_default.a.cloneElement(child, newProps);
    });
  } else if (!context.disabled && context.isEditable && !context.readOnly && !cellReadOnly) {
    content = children;
  }
  var style = EditableTable_styles_default.a.cell + ' ' + className;
  var errWrapperStyles = input_default.a.errored + ' ' + EditableTable_styles_default.a.errored;
  var errStyles = input_default.a.error + ' ' + EditableTable_styles_default.a.error;
  var errorMsg = null;
  if (context.isEditable && error) {
    errorMsg = react_default.a.createElement(
      'div',
      { className: errWrapperStyles },
      react_default.a.createElement(
        'p',
        { className: errStyles },
        error
      )
    );
  }
  return react_default.a.createElement(
    'td',
    { className: style },
    react_default.a.createElement(
      react_responsive_default.a,
      { maxWidth: constants["y" /* CUT_POINT */] },
      function (match) {
        if (match) return react_default.a.createElement(
          'div',
          { className: EditableTable_styles_default.a.heading },
          label
        );
        return null;
      }
    ),
    content,
    errorMsg
  );
};

editableTableCell_EditableTableCell.contextTypes = {
  isEditable: prop_types_default.a.bool,
  onChange: prop_types_default.a.func,
  disabled: prop_types_default.a.bool,
  readOnly: prop_types_default.a.bool
};

editableTableCell_EditableTableCell.propTypes = {
  label: prop_types_default.a.string.isRequired,
  value: prop_types_default.a.node.isRequired,
  children: prop_types_default.a.node,
  display: prop_types_default.a.bool.isRequired,
  className: prop_types_default.a.string,
  onChange: prop_types_default.a.func,
  error: prop_types_default.a.string,
  cellReadOnly: prop_types_default.a.bool
};

editableTableCell_EditableTableCell.defaultProps = {
  label: '',
  value: '',
  children: null,
  display: true,
  className: '',
  error: '',
  cellReadOnly: false
};

/* harmony default export */ var editableTableCell = (editableTableCell_EditableTableCell);
// CONCATENATED MODULE: ./client/app/shared/components/EditableTable/components/editableTableRow.jsx
function editableTableRow__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function editableTableRow__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function editableTableRow__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function editableTableRow__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var editableTableRow_EditableTableRow = function (_React$Component) {
  editableTableRow__inherits(EditableTableRow, _React$Component);

  function EditableTableRow(props) {
    editableTableRow__classCallCheck(this, EditableTableRow);

    var _this = editableTableRow__possibleConstructorReturn(this, (EditableTableRow.__proto__ || Object.getPrototypeOf(EditableTableRow)).call(this, props));

    Object.defineProperty(_this, 'getChildContext', {
      enumerable: true,
      writable: true,
      value: function value() {
        return {
          onChange: _this.handleChange,
          disabled: _this.props.disabled,
          readOnly: _this.props.readOnly
        };
      }
    });
    Object.defineProperty(_this, 'componentDidMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            onSave = _this$props.onSave,
            onDelete = _this$props.onDelete;

        if (!_this.context.registerHeaders) return;
        var children = react_default.a.Children.toArray(_this.props.children).map(function (child) {
          return child && { props: { display: child.props.display, label: child.props.label } };
        });
        _this.context.registerHeaders(children, !!onDelete, !!onSave);
      }
    });
    Object.defineProperty(_this, 'componentWillReceiveProps', {
      enumerable: true,
      writable: true,
      value: function value(nextProps, nextContext) {
        var _this$props2 = _this.props,
            onSave = _this$props2.onSave,
            onDelete = _this$props2.onDelete;

        if (!_this.context.registerHeaders) return;
        var currentChildren = react_default.a.Children.toArray(_this.props.children).map(function (child) {
          return child && { props: { display: child.props.display, label: child.props.label } };
        });
        var nextChildren = react_default.a.Children.toArray(nextProps.children).map(function (child) {
          return child && { props: { display: child.props.display, label: child.props.label } };
        });
        if (!Object(lodash["isEqual"])(currentChildren, nextChildren)) {
          _this.context.registerHeaders(nextChildren, !!onDelete, !!onSave);
        }
        if (!nextContext.isEditable && _this.state.isDirty) _this.setState({ isDirty: false });
      }
    });
    Object.defineProperty(_this, 'handleChange', {
      enumerable: true,
      writable: true,
      value: function value(event, cb) {
        cb(event);
        _this.setState({ isDirty: true });
      }
    });
    Object.defineProperty(_this, 'handleSave', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.setState({ isDirty: false });
        if (!_this.props.onSave) return;
        _this.props.onSave();
      }
    });
    Object.defineProperty(_this, 'handleDelete', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props3 = _this.props,
            onDelete = _this$props3.onDelete,
            deleteDialog = _this$props3.deleteDialog;
        var renderDeleteDialog = _this.state.renderDeleteDialog;

        if (!onDelete) return;
        if (deleteDialog && !renderDeleteDialog) _this.showDeleteDialog();else _this.props.onDelete();
      }
    });
    Object.defineProperty(_this, 'hideDeleteDialog', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ renderDeleteDialog: false });
      }
    });
    Object.defineProperty(_this, 'showDeleteDialog', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ renderDeleteDialog: true });
      }
    });
    Object.defineProperty(_this, 'renderSaveButton', {
      enumerable: true,
      writable: true,
      value: function value() {
        var isDirty = _this.state.isDirty;
        var _this$props4 = _this.props,
            disabled = _this$props4.disabled,
            totalMismatch = _this$props4.totalMismatch,
            role = _this$props4.role,
            message = _this$props4.message,
            invalidNumber = _this$props4.invalidNumber,
            id = _this$props4.id;

        var totalDisabled = totalMismatch && role !== 'admin';
        var val = message && totalDisabled ? react_default.a.createElement(
          'span',
          { className: EditableTable_styles_default.a.message },
          message
        ) : react_default.a.createElement(
          'div',
          {
            'data-tip': true,
            'data-tip-disable': !invalidNumber,
            'data-for': id + 'InvalidNumberError'
          },
          react_default.a.createElement(ColoredButton["a" /* default */], {
            disabled: disabled || totalDisabled || invalidNumber || !isDirty,
            label: totalMismatch ? 'FORCE SAVE' : 'SAVE',
            onClick: _this.handleSave,
            color: totalMismatch ? 'red' : 'green'
          }),
          react_default.a.createElement(
            react_tooltip_dist_default.a,
            {
              id: id + 'InvalidNumberError',
              place: 'top',
              effect: 'solid'
            },
            'Invalid PO number. Please ensure the PO number is 9 digits or 8 digits prefixed by \'PR\' and is not the project number.'
          )
        );
        return react_default.a.createElement(
          editableTableCell,
          {
            key: 'save', value: val, className: EditableTable_styles_default.a.saveCell
          },
          val
        );
      }
    });
    Object.defineProperty(_this, 'renderDeleteButton', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props5 = _this.props,
            disabled = _this$props5.disabled,
            hideDelete = _this$props5.hideDelete;

        var isDisabled = disabled || hideDelete;
        var val = react_default.a.createElement(react_toolbox_lib["IconButton"], { disabled: isDisabled, icon: 'delete', onClick: _this.handleDelete });
        return react_default.a.createElement(
          editableTableCell,
          {
            key: 'deletectrl', value: val, className: EditableTable_styles_default.a.deleteCell
          },
          !_this.props.isNew && val
        );
      }
    });
    Object.defineProperty(_this, 'renderBlankCell', {
      enumerable: true,
      writable: true,
      value: function value() {
        return react_default.a.createElement('td', { className: EditableTable_styles_default.a.cell });
      }
    });
    Object.defineProperty(_this, 'renderCells', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props6 = _this.props,
            onDelete = _this$props6.onDelete,
            onSave = _this$props6.onSave,
            readOnly = _this$props6.readOnly;

        var children = react_default.a.Children.toArray(_this.props.children);
        if (!_this.context.isEditable || _this.context.hasCustomControls) return children;
        var cells = [].concat(editableTableRow__toConsumableArray(children));
        if (onDelete && !readOnly) cells.unshift(_this.renderDeleteButton());
        if (onDelete && readOnly) cells.unshift(_this.renderBlankCell());
        if (onSave && !readOnly) cells.push(_this.renderSaveButton());
        if (onSave && readOnly) cells.push(_this.renderBlankCell());
        return cells;
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props7 = _this.props,
            toggleLineItem = _this$props7.toggleLineItem,
            expandableRow = _this$props7.expandableRow,
            _this$props7$classNam = _this$props7.className,
            className = _this$props7$classNam === undefined ? '' : _this$props7$classNam;

        if (!_this.context.isEditable && _this.props.isNew) return null;
        var _this$props8 = _this.props,
            deleteDialog = _this$props8.deleteDialog,
            deleteError = _this$props8.deleteError;
        var renderDeleteDialog = _this.state.renderDeleteDialog;
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions

        return react_default.a.createElement(
          'tr',
          {
            id: _this.props.isNew ? 'installerPayTutorial3' : '',
            className: (expandableRow ? EditableTable_styles_default.a.expandableContentRow : EditableTable_styles_default.a.contentRow) + ' ' + className,
            style: _this.props.style,
            onClick: toggleLineItem
          },
          _this.renderCells(),
          deleteDialog && react_default.a.createElement(ConfirmDialog["a" /* default */], {
            show: renderDeleteDialog,
            confirmation: 'Are you sure you want to delete this record?',
            dismiss: _this.hideDeleteDialog,
            cancel: _this.hideDeleteDialog,
            proceed: _this.handleDelete,
            error: deleteError
          })
        );
      }
    });

    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleSave = _this.handleSave.bind(_this);
    _this.handleDelete = _this.handleDelete.bind(_this);
    _this.state = { isDirty: false, renderDeleteDialog: false };
    return _this;
  }

  return EditableTableRow;
}(react_default.a.Component);

editableTableRow_EditableTableRow.contextTypes = {
  isEditable: prop_types_default.a.bool,
  hasCustomControls: prop_types_default.a.bool,
  registerHeaders: prop_types_default.a.func
};

editableTableRow_EditableTableRow.childContextTypes = {
  onChange: prop_types_default.a.func,
  disabled: prop_types_default.a.bool,
  readOnly: prop_types_default.a.bool
};

editableTableRow_EditableTableRow.propTypes = {
  id: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]),
  invalidNumber: prop_types_default.a.bool,
  isNew: prop_types_default.a.bool,
  children: prop_types_default.a.node.isRequired,
  onSave: prop_types_default.a.func,
  onDelete: prop_types_default.a.func,
  toggleLineItem: prop_types_default.a.func,
  disabled: prop_types_default.a.bool,
  totalMismatch: prop_types_default.a.bool,
  role: prop_types_default.a.string,
  message: prop_types_default.a.string,
  className: prop_types_default.a.string,
  style: prop_types_default.a.object,
  deleteDialog: prop_types_default.a.bool,
  deleteError: prop_types_default.a.string,
  readOnly: prop_types_default.a.bool,
  hideDelete: prop_types_default.a.bool,
  expandableRow: prop_types_default.a.bool
};

editableTableRow_EditableTableRow.defaultProps = {
  id: 'new',
  isNew: false,
  children: null,
  disabled: false,
  invalidNumber: false,
  totalMismatch: false,
  message: '',
  className: '',
  style: {},
  deleteDialog: false,
  readOnly: false,
  hideDelete: false,
  expandableRow: false
};

/* harmony default export */ var editableTableRow = (editableTableRow_EditableTableRow);
// CONCATENATED MODULE: ./client/app/shared/components/EditableTable/components/editToggleButton.jsx





var editToggleButton_EditToggleButton = function EditToggleButton(_ref) {
  var isEditable = _ref.isEditable,
      onClick = _ref.onClick,
      className = _ref.className,
      actionLabel = _ref.actionLabel;
  return react_default.a.createElement(react_toolbox_lib["Button"], {
    label: isEditable ? 'Done' : actionLabel,
    className: EditableTable_styles_default.a.editToggleButton + ' ' + className,
    onClick: onClick,
    inverse: true
  });
};

editToggleButton_EditToggleButton.propTypes = {
  isEditable: prop_types_default.a.bool.isRequired,
  onClick: prop_types_default.a.func,
  className: prop_types_default.a.string,
  actionLabel: prop_types_default.a.string
};

editToggleButton_EditToggleButton.defaultProps = {
  isEditable: false,
  className: '',
  actionLabel: 'Edit'
};

/* harmony default export */ var editToggleButton = (editToggleButton_EditToggleButton);
// CONCATENATED MODULE: ./client/app/shared/components/EditableTable/index.jsx




// EXTERNAL MODULE: ./client/app/shared/components/TimeOffTable/styles.scss
var TimeOffTable_styles = __webpack_require__("hYGo");
var TimeOffTable_styles_default = /*#__PURE__*/__webpack_require__.n(TimeOffTable_styles);

// CONCATENATED MODULE: ./client/app/shared/components/TimeOffTable/components/timeOffTableRow.jsx
var timeOffTableRow__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function timeOffTableRow__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function timeOffTableRow__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function timeOffTableRow__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function timeOffTableRow__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var DATE_FORMAT = 'MM/DD/YYYY';
var INPUT_STYLE = input_default.a.inputElement + ' ' + TimeOffTable_styles_default.a.reasonInput;

var timeOffTableRow_TimeOffTableRow = function (_React$Component) {
  timeOffTableRow__inherits(TimeOffTableRow, _React$Component);

  function TimeOffTableRow(props) {
    timeOffTableRow__classCallCheck(this, TimeOffTableRow);

    var _this = timeOffTableRow__possibleConstructorReturn(this, (TimeOffTableRow.__proto__ || Object.getPrototypeOf(TimeOffTableRow)).call(this, props));

    Object.defineProperty(_this, 'componentWillReceiveProps', {
      enumerable: true,
      writable: true,
      value: function value(nextProps) {
        var pto = nextProps.pto;

        if (pto.id !== 'new' && Object(lodash["isEqual"])(pto, _this.props.pto)) return;
        _this.setState(_this.mapPTO(pto));
      }
    });
    Object.defineProperty(_this, 'mapPTO', {
      enumerable: true,
      writable: true,
      value: function value(pto) {
        var startDate = pto.start_date && moment_default()(pto.start_date).format(DATE_FORMAT);
        var endDate = pto.end_date && moment_default()(pto.end_date).format(DATE_FORMAT);
        var crew = (pto.assignee || {}).id || '';
        return timeOffTableRow__extends({ errors: {} }, pto, { start_date: startDate, end_date: endDate, crew: crew });
      }
    });
    Object.defineProperty(_this, 'validate', {
      enumerable: true,
      writable: true,
      value: function value() {
        var errors = {};
        if (_this.props.isCrew && !_this.state.crew) {
          errors.crew = 'Can\'t be blank';
          _this.setState({ errors: errors });
        }
        return Object.keys(errors).length === 0;
      }
    });
    Object.defineProperty(_this, 'isNew', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.state.id === 'new';
      }
    });
    Object.defineProperty(_this, 'handleChange', {
      enumerable: true,
      writable: true,
      value: function value(attr) {
        return function (val) {
          return _this.setState(timeOffTableRow__defineProperty({}, attr, val.target ? val.target.value : val));
        };
      }
    });
    Object.defineProperty(_this, 'handleSave', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.validate() && _this.whichSubmit();
      }
    });
    Object.defineProperty(_this, 'handleDelete', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.onDelete(_this.state);
      }
    });
    Object.defineProperty(_this, 'handleCrewChange', {
      enumerable: true,
      writable: true,
      value: _this.handleChange('crew')
    });
    Object.defineProperty(_this, 'handleStartDateChange', {
      enumerable: true,
      writable: true,
      value: _this.handleChange('start_date')
    });
    Object.defineProperty(_this, 'handleEndDateChange', {
      enumerable: true,
      writable: true,
      value: _this.handleChange('end_date')
    });
    Object.defineProperty(_this, 'handleReasonChange', {
      enumerable: true,
      writable: true,
      value: _this.handleChange('reason')
    });
    Object.defineProperty(_this, 'whichSubmit', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            parentObj = _this$props.parentObj,
            onSave = _this$props.onSave,
            handleModalOpen = _this$props.handleModalOpen;

        var conflicts = parentObj && (parentObj.type || '') === 'estimator' ? _this.estimatorConflicts(parentObj) : null;
        if (conflicts) {
          var stateCopy = timeOffTableRow__extends({}, _this.state);
          stateCopy.conflicts = conflicts;
          return handleModalOpen(stateCopy);
        }
        return onSave(_this.state);
      }
    });
    Object.defineProperty(_this, 'estimatorConflicts', {
      enumerable: true,
      writable: true,
      value: function value(parentObj) {
        var _this$state = _this.state,
            start_date = _this$state.start_date,
            end_date = _this$state.end_date;
        var _parentObj$appointmen = parentObj.appointments,
            appointments = _parentObj$appointmen === undefined ? [] : _parentObj$appointmen;

        var ptoStart = moment_default()(start_date, constants["E" /* DISPLAY_DATE */]);
        var ptoEnd = moment_default()(end_date, constants["E" /* DISPLAY_DATE */]);
        var conflicts = [];
        appointments.forEach(function (a) {
          var aStart = a.start_date,
              aEnd = a.end_date;

          var apptStart = moment_default()(aStart, constants["_19" /* RAILS_DATE */]);
          var apptEnd = moment_default()(aEnd, constants["_19" /* RAILS_DATE */]);
          if (apptStart.isBetween(ptoStart, ptoEnd, 'days', '[]') || apptEnd.isBetween(ptoStart, ptoEnd, 'days', '[]')) conflicts.push(a);
        });
        return conflicts.length ? conflicts.map(function (c) {
          return { start_date: c.start_date, end_date: c.end_date };
        }) : null;
      }
    });
    Object.defineProperty(_this, 'renderCrewCell', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$state2 = _this.state,
            assignee = _this$state2.assignee,
            errors = _this$state2.errors;
        var _this$props2 = _this.props,
            crews = _this$props2.crews,
            isCrew = _this$props2.isCrew;

        var options = crews.map(function (crew) {
          return { label: crew.name, value: crew.id };
        });
        var value = (assignee || {}).name;
        var error = errors.crew;
        var cellProps = { label: 'Crew', display: isCrew, onChange: _this.handleCrewChange, value: value, error: error };
        return react_default.a.createElement(
          editableTableCell,
          cellProps,
          react_default.a.createElement(components_StyledSelect, { options: options, value: _this.state.crew, className: TimeOffTable_styles_default.a.select, placeholder: ' ' })
        );
      }
    });
    Object.defineProperty(_this, 'renderDateTimeAddedCell', {
      enumerable: true,
      writable: true,
      value: function value() {
        return react_default.a.createElement(editableTableCell, {
          label: 'Date/Time Added',
          value: _this.isNew() ? 'N/A' : _this.props.pto.date_time_added,
          onChange: function onChange() {},
          cellReadOnly: true
        });
      }
    });
    Object.defineProperty(_this, 'renderAddedByCell', {
      enumerable: true,
      writable: true,
      value: function value() {
        return react_default.a.createElement(editableTableCell, {
          label: 'Added By',
          value: _this.props.pto.added_by || (_this.isNew() ? _this.props.user : 'N/A'),
          onChange: function onChange() {},
          cellReadOnly: true
        });
      }
    });
    Object.defineProperty(_this, 'renderDateCell', {
      enumerable: true,
      writable: true,
      value: function value(attr, label, onChange) {
        var pto = _this.props.pto;
        var errors = _this.state.errors;

        var value = pto[attr] && moment_default()(pto[attr]).format(DATE_FORMAT);
        var minDate = moment_default()().subtract(1, 'day').toDate();
        var error = (errors.base || errors[attr] || [{}])[0].error;
        return react_default.a.createElement(
          editableTableCell,
          { label: label, value: value, onChange: onChange, error: error },
          react_default.a.createElement(DatePicker, { value: _this.state[attr], minDate: minDate, className: TimeOffTable_styles_default.a.datepicker })
        );
      }
    });
    Object.defineProperty(_this, 'renderReasonCell', {
      enumerable: true,
      writable: true,
      value: function value() {
        return react_default.a.createElement(
          editableTableCell,
          {
            label: 'Comments', value: _this.props.pto.reason, onChange: _this.handleReasonChange
          },
          react_default.a.createElement('input', { type: 'text', value: _this.state.reason || '', className: INPUT_STYLE })
        );
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var disabled = moment_default()().isAfter(moment_default()(_this.state.end_date, DATE_FORMAT), 'day');
        var rowProps = {
          isNew: _this.isNew(), disabled: disabled, onSave: _this.handleSave, onDelete: _this.handleDelete
        };
        return react_default.a.createElement(
          editableTableRow,
          timeOffTableRow__extends({ className: _this.props.className }, rowProps),
          _this.renderCrewCell(),
          _this.renderDateTimeAddedCell(),
          _this.renderAddedByCell(),
          _this.renderDateCell('start_date', 'Start Date', _this.handleStartDateChange),
          _this.renderDateCell('end_date', 'End Date', _this.handleEndDateChange),
          _this.renderReasonCell()
        );
      }
    });

    _this.state = _this.mapPTO(_this.props.pto);
    return _this;
  }

  return TimeOffTableRow;
}(react_default.a.Component);

timeOffTableRow_TimeOffTableRow.contextTypes = { isEditable: prop_types_default.a.bool };

timeOffTableRow_TimeOffTableRow.propTypes = {
  pto: types_pto.isRequired,
  handleModalOpen: prop_types_default.a.func,
  onSave: prop_types_default.a.func.isRequired,
  onDelete: prop_types_default.a.func.isRequired,
  crews: prop_types_default.a.array,
  isCrew: prop_types_default.a.bool,
  className: prop_types_default.a.string,
  parentObj: prop_types_default.a.object,
  user: prop_types_default.a.string
};

timeOffTableRow_TimeOffTableRow.defaultProps = {
  crews: [],
  isCrew: false,
  className: '',
  parentObj: null,
  handleModalOpen: function handleModalOpen() {}
};

/* harmony default export */ var timeOffTableRow = (timeOffTableRow_TimeOffTableRow);
// CONCATENATED MODULE: ./client/app/shared/components/TimeOffTable/components/conflictingAppointmentModal.jsx








var conflictingAppointmentModal_ConflictingAppointmentModal = function ConflictingAppointmentModal(_ref) {
  var active = _ref.active,
      dates = _ref.dates,
      onClose = _ref.onClose,
      onSubmit = _ref.onSubmit,
      tempEntry = _ref.tempEntry;

  var whichDates = tempEntry ? tempEntry.conflicts : dates;

  var dateFormat = tempEntry ? constants["_19" /* RAILS_DATE */] : 'YYYY-MM-DD HH:mm:ss Z';

  var parsedDates = whichDates.map(function (d) {
    var start = tempEntry ? d.start_date : d;
    var startMoment = moment_default()(start, dateFormat);
    var end = tempEntry ? d.end_date : null;
    var endMoment = end ? moment_default()(end, dateFormat) : null;
    return react_default.a.createElement(
      'span',
      { key: d, className: TimeOffTable_styles_default.a.mdates },
      !endMoment || endMoment.isSame(startMoment, 'day') ? startMoment.format('MMMM Do YYYY') : startMoment.format('MMMM Do YYYY') + ' - ' + endMoment.format('MMMM Do YYYY')
    );
  });

  var confirmation = function confirmation() {
    var text1 = tempEntry ? 'There are appointments currently scheduled during this requested time off.' : 'This contractor has an appointment scheduled during the requested time off.';
    var text2 = tempEntry ? 'Please check the current schedule:' : 'Please remove the events for the following date(s) and try again:';
    return react_default.a.createElement(
      'p',
      null,
      text1,
      react_default.a.createElement('br', null),
      text2,
      react_default.a.createElement('br', null),
      react_default.a.createElement('br', null),
      react_default.a.createElement(
        'span',
        { className: TimeOffTable_styles_default.a.mheader },
        'Dates:'
      ),
      parsedDates
    );
  };

  var theActions = tempEntry ? ['OK', 'Cancel'] : ['OK'];

  return react_default.a.createElement(ConfirmDialog["a" /* default */], {
    show: active,
    title: tempEntry ? 'Conflicting Appointments' : 'Unable to mark time off',
    confirmation: confirmation(),
    theActions: theActions,
    okLabel: tempEntry ? 'Add Time Off Anyway' : 'OK',
    okColor: tempEntry ? 'yellow' : 'green',
    proceed: tempEntry ? onSubmit : onClose,
    dismiss: function dismiss() {},
    cancel: tempEntry ? onClose : function () {}
  });
};

conflictingAppointmentModal_ConflictingAppointmentModal.propTypes = {
  active: prop_types_default.a.bool,
  dates: prop_types_default.a.arrayOf(prop_types_default.a.string),
  onSubmit: prop_types_default.a.func,
  onClose: prop_types_default.a.func.isRequired,
  tempEntry: prop_types_default.a.object
};

conflictingAppointmentModal_ConflictingAppointmentModal.defaultProps = {
  active: false, dates: [], tempEntry: null, onSubmit: function onSubmit() {}
};

/* harmony default export */ var conflictingAppointmentModal = (conflictingAppointmentModal_ConflictingAppointmentModal);
// CONCATENATED MODULE: ./client/app/shared/components/TimeOffTable/index.jsx
var TimeOffTable__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function TimeOffTable__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function TimeOffTable__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function TimeOffTable__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var CONFLICT_RE = /^conflicting appointment\(s\)$/i;
var TimeOffTable_DATE_FORMAT = 'MM/DD/YYYY';
var TimeOffTable_EMPTY_TABLE = react_default.a.createElement(
  'div',
  { className: TimeOffTable_styles_default.a.emptyTable },
  react_default.a.createElement(
    'h4',
    null,
    'No time off requests found'
  )
);

var TimeOffTable_TimeOffTable = function (_React$Component) {
  TimeOffTable__inherits(TimeOffTable, _React$Component);

  function TimeOffTable(props) {
    TimeOffTable__classCallCheck(this, TimeOffTable);

    var _this = TimeOffTable__possibleConstructorReturn(this, (TimeOffTable.__proto__ || Object.getPrototypeOf(TimeOffTable)).call(this, props));

    Object.defineProperty(_this, 'checkForConflicts', {
      enumerable: true,
      writable: true,
      value: function value(id) {
        var pto = _this.props.ptos.find(function (p) {
          return p.id === id;
        });
        var err = (pto.errors || {}).base || [];
        var hasConflict = err.length > 0 && CONFLICT_RE.test(err[0].error);
        _this.setState({ hasConflict: hasConflict, conflict: hasConflict ? err[0] : {} });
      }
    });
    Object.defineProperty(_this, 'createPTO', {
      enumerable: true,
      writable: true,
      value: function value(pto) {
        var user = _this.props.user;
        var _this$props = _this.props,
            parentID = _this$props.parentID,
            parentKind = _this$props.parentKind;

        if (_this.props.isCrew) {
          parentID = pto.crew;
          parentKind = 'crews';
        }
        return _this.props.createPTO(parentID, parentKind, TimeOffTable__extends({}, pto, { added_by: user }));
      }
    });
    Object.defineProperty(_this, 'updatePTO', {
      enumerable: true,
      writable: true,
      value: function value(pto) {
        return _this.props.updatePTO(pto.id, pto);
      }
    });
    Object.defineProperty(_this, 'handleSave', {
      enumerable: true,
      writable: true,
      value: function value(pto) {
        var assignee = { id: pto.crew, name: '', kind: '' };
        var startDate = moment_default()(pto.start_date, TimeOffTable_DATE_FORMAT).format();
        var endDate = moment_default()(pto.end_date, TimeOffTable_DATE_FORMAT).format();
        var params = TimeOffTable__extends({ assignee: assignee }, pto, { start_date: startDate, end_date: endDate });
        var req = pto.id === 'new' ? _this.createPTO(params) : _this.updatePTO(params);
        if (_this.state.tempEntry) req.then(function () {
          return _this.handleModalClose();
        });else req.then(function () {
          return _this.checkForConflicts(pto.id);
        });
      }
    });
    Object.defineProperty(_this, 'handleDelete', {
      enumerable: true,
      writable: true,
      value: function value(pto) {
        return pto.id !== 'new' ? _this.props.deletePTO(pto.id) : null;
      }
    });
    Object.defineProperty(_this, 'handleModalOpen', {
      enumerable: true,
      writable: true,
      value: function value(pto) {
        return _this.setState({ hasConflict: true, tempEntry: pto });
      }
    });
    Object.defineProperty(_this, 'handleModalClose', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ hasConflict: false, tempEntry: null });
      }
    });
    Object.defineProperty(_this, 'renderRows', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props2 = _this.props,
            ptos = _this$props2.ptos,
            crews = _this$props2.crews,
            isCrew = _this$props2.isCrew,
            parentObj = _this$props2.parentObj,
            user = _this$props2.user;

        if (ptos.length === 0 || ptos[0].id !== 'new') {
          ptos.unshift({ id: 'new', start_date: '', end_date: '', reason: '', crew: '' });
        }
        return ptos.map(function (pto) {
          return react_default.a.createElement(timeOffTableRow, {
            key: pto.id,
            pto: pto,
            handleModalOpen: _this.handleModalOpen,
            onSave: _this.handleSave,
            onDelete: _this.handleDelete,
            crews: crews,
            isCrew: isCrew,
            parentObj: parentObj,
            user: user
          });
        });
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        return react_default.a.createElement(
          'div',
          { className: TimeOffTable_styles_default.a.timeOffTable },
          react_default.a.createElement(
            editableTable,
            { isEditable: _this.props.isEditable, emptyNode: TimeOffTable_EMPTY_TABLE },
            _this.renderRows()
          ),
          react_default.a.createElement(conflictingAppointmentModal, {
            active: _this.state.hasConflict,
            dates: _this.state.conflict.dates || [],
            tempEntry: _this.state.tempEntry,
            onSubmit: _this.props.parentKind === 'estimators' ? function () {
              return _this.handleSave(_this.state.tempEntry);
            } : function () {},
            onClose: _this.handleModalClose
          })
        );
      }
    });

    _this.handleSave = _this.handleSave.bind(_this);
    _this.handleModalOpen = _this.handleModalOpen.bind(_this);
    _this.state = { conflict: {}, hasConflict: false, tempEntry: null };
    return _this;
  }

  return TimeOffTable;
}(react_default.a.Component);

TimeOffTable_TimeOffTable.propTypes = {
  crews: prop_types_default.a.array,
  isCrew: prop_types_default.a.bool,
  isEditable: prop_types_default.a.bool,
  ptos: prop_types_default.a.arrayOf(types_pto),
  parentID: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]).isRequired,
  parentKind: prop_types_default.a.string.isRequired,
  parentObj: prop_types_default.a.object,
  createPTO: prop_types_default.a.func.isRequired,
  updatePTO: prop_types_default.a.func.isRequired,
  deletePTO: prop_types_default.a.func.isRequired,
  user: prop_types_default.a.object
};

TimeOffTable_TimeOffTable.defaultProps = {
  crews: [],
  isCrew: false,
  isEditable: false,
  ptos: [],
  parentObj: null
};

/* harmony default export */ var components_TimeOffTable = (Object(react_redux_es["connect"])(function (state) {
  return { user: state.user.name };
}, { createPTO: actionCreators_ptos["a" /* createPTO */], updatePTO: actionCreators_ptos["d" /* updatePTO */], deletePTO: actionCreators_ptos["b" /* deletePTO */] })(TimeOffTable_TimeOffTable));
// EXTERNAL MODULE: ./client/app/screens/main/screens/estimators/components/styles.scss
var components_styles = __webpack_require__("Gkd3");
var components_styles_default = /*#__PURE__*/__webpack_require__.n(components_styles);

// EXTERNAL MODULE: ./client/app/shared/actionCreators/estimators.js
var actionCreators_estimators = __webpack_require__("L1+g");

// CONCATENATED MODULE: ./client/app/screens/main/screens/estimators/components/estimatorListModal.jsx
function estimatorListModal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function estimatorListModal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function estimatorListModal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var estimatorListModal_EstimatorListModal = function (_React$Component) {
  estimatorListModal__inherits(EstimatorListModal, _React$Component);

  function EstimatorListModal() {
    var _ref;

    var _temp, _this, _ret;

    estimatorListModal__classCallCheck(this, EstimatorListModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = estimatorListModal__possibleConstructorReturn(this, (_ref = EstimatorListModal.__proto__ || Object.getPrototypeOf(EstimatorListModal)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'state', {
      enumerable: true,
      writable: true,
      value: { loading: true }
    }), Object.defineProperty(_this, 'componentDidMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.getEstimatorsForZipCode(_this.props.zipCode).finally(function () {
          return _this.setState({ loading: false });
        });
      }
    }), Object.defineProperty(_this, 'handleNavigate', {
      enumerable: true,
      writable: true,
      value: function value(id) {
        _this.props.dismiss();
        window.open(window.location.origin + '/estimators/' + id, '_blank', 'noopener,noreferrer');
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            show = _this$props.show,
            dismiss = _this$props.dismiss,
            zipCode = _this$props.zipCode,
            sharedEstimators = _this$props.sharedEstimators,
            estimator = _this$props.estimator;
        var loading = _this.state.loading;

        var filteredSharedEstimator = sharedEstimators.filter(function (est) {
          return est.id !== estimator.id;
        });
        return react_default.a.createElement(
          react_toolbox_lib["Dialog"],
          {
            active: show,
            onEscKeyDown: dismiss,
            onOverlayClick: dismiss,
            title: 'List of Estimators who share Zip code: ' + zipCode
          },
          loading ? react_default.a.createElement(components_Loading, null) : react_default.a.createElement(
            react["Fragment"],
            null,
            filteredSharedEstimator.map(function (est) {
              return react_default.a.createElement(
                'div',
                { key: est.id },
                react_default.a.createElement(
                  'button',
                  {
                    key: est.id,
                    className: components_styles_default.a.zipBtn,
                    type: 'button', onClick: function onClick() {
                      return _this.handleNavigate(est.id);
                    }
                  },
                  est.name
                )
              );
            }),
            react_default.a.createElement(ColoredButton["a" /* default */], { responsive: true, color: 'green', label: 'OK', onClick: dismiss })
          )
        );
      }
    }), _temp), estimatorListModal__possibleConstructorReturn(_this, _ret);
  }

  return EstimatorListModal;
}(react_default.a.Component);

estimatorListModal_EstimatorListModal.propTypes = {
  zipCode: prop_types_default.a.string.isRequired,
  estimator: prop_types_default.a.object,
  getEstimatorsForZipCode: prop_types_default.a.func,
  show: prop_types_default.a.bool,
  sharedEstimators: prop_types_default.a.array,
  dismiss: prop_types_default.a.func,
  error: prop_types_default.a.string
};

var estimatorListModal_mapStateToProps = function mapStateToProps(state) {
  return { sharedEstimators: state.estimators.forZipCode.data || [] };
};

/* harmony default export */ var estimatorListModal = (Object(react_redux_es["connect"])(estimatorListModal_mapStateToProps, { getEstimatorsForZipCode: actionCreators_estimators["c" /* getEstimatorsForZipCode */] })(estimatorListModal_EstimatorListModal));
// CONCATENATED MODULE: ./client/app/screens/main/screens/estimators/components/estimatorCoveredZips.jsx
function estimatorCoveredZips__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function estimatorCoveredZips__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function estimatorCoveredZips__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var estimatorCoveredZips_EstimatorCoveredZips = function (_React$Component) {
  estimatorCoveredZips__inherits(EstimatorCoveredZips, _React$Component);

  function EstimatorCoveredZips(props) {
    estimatorCoveredZips__classCallCheck(this, EstimatorCoveredZips);

    var _this = estimatorCoveredZips__possibleConstructorReturn(this, (EstimatorCoveredZips.__proto__ || Object.getPrototypeOf(EstimatorCoveredZips)).call(this, props));

    Object.defineProperty(_this, 'handleZipClick', {
      enumerable: true,
      writable: true,
      value: function value(zip) {
        return _this.setState({ modalActive: !_this.state.modalActive, chosenZip: zip });
      }
    });
    Object.defineProperty(_this, 'toggleModal', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ modalActive: !_this.state.modalActive });
      }
    });
    Object.defineProperty(_this, 'hasSharedZip', {
      enumerable: true,
      writable: true,
      value: function value(zip) {
        var shared_zip_map = _this.props.shared_zip_map;

        return shared_zip_map[zip] > 1;
      }
    });
    Object.defineProperty(_this, 'isEstimator', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.role === 'estimator';
      }
    });
    Object.defineProperty(_this, 'renderContent', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            _this$props$covered_z = _this$props.covered_zip_codes,
            covered_zip_codes = _this$props$covered_z === undefined ? [] : _this$props$covered_z,
            shared_zip_map = _this$props.shared_zip_map;

        if (!covered_zip_codes || !Array.isArray(covered_zip_codes) || !covered_zip_codes.length) return 'N/A';
        // Used in a hack to remove trailing comma
        var last = covered_zip_codes.length - 1;
        var content = covered_zip_codes.map(function (zip, i) {
          if (_this.hasSharedZip(zip)) {
            return react_default.a.createElement(
              'span',
              { key: zip, className: components_styles_default.a.zipWrapper },
              _this.isEstimator() ? zip : react_default.a.createElement(
                'button',
                {
                  key: zip,
                  'data-tip': true,
                  'data-for': 'zipToolTip_' + zip,
                  className: components_styles_default.a.zipBtn,
                  type: 'button',
                  onClick: function onClick() {
                    return _this.handleZipClick(zip);
                  }
                },
                zip
              ),
              i < last && ', ',
              react_default.a.createElement(
                react_responsive_default.a,
                { minWidth: 400 },
                react_default.a.createElement(
                  react_tooltip_dist_default.a,
                  { id: 'zipToolTip_' + zip, place: 'top', effect: 'solid' },
                  shared_zip_map[zip] - 1,
                  ' other estimator(s) cover this zip code.'
                )
              )
            );
          }
          return react_default.a.createElement(
            'span',
            { className: components_styles_default.a.zipWrapper, key: zip },
            zip,
            i < last && ', '
          );
        });
        return content;
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var estimator = _this.props.estimator;
        var _this$state = _this.state,
            chosenZip = _this$state.chosenZip,
            modalActive = _this$state.modalActive;

        return react_default.a.createElement(
          'div',
          { className: components_styles_default.a.zipContainer },
          _this.renderContent(),
          !_this.isEstimator() && modalActive && react_default.a.createElement(estimatorListModal, {
            estimator: estimator,
            zipCode: chosenZip,
            show: modalActive,
            cancel: _this.toggleModal,
            dismiss: _this.toggleModal
          })
        );
      }
    });

    _this.state = { modalActive: false, chosenZip: '' };
    return _this;
  }

  return EstimatorCoveredZips;
}(react_default.a.Component);

estimatorCoveredZips_EstimatorCoveredZips.propTypes = {
  covered_zip_codes: prop_types_default.a.array,
  shared_zip_map: prop_types_default.a.object,
  estimator: prop_types_default.a.object,
  role: prop_types_default.a.string
};

/* harmony default export */ var estimatorCoveredZips = (estimatorCoveredZips_EstimatorCoveredZips);
// CONCATENATED MODULE: ./client/app/screens/main/screens/estimators/components/estimatorDetailsCard.jsx
function estimatorDetailsCard__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function estimatorDetailsCard__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function estimatorDetailsCard__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



























var estimatorDetailsCard_detailsTheme = { RTTabs: tabs_default.a };

var estimatorDetailsCard_EstimatorDetailsCard = function (_Component) {
  estimatorDetailsCard__inherits(EstimatorDetailsCard, _Component);

  function EstimatorDetailsCard(props) {
    estimatorDetailsCard__classCallCheck(this, EstimatorDetailsCard);

    var _this = estimatorDetailsCard__possibleConstructorReturn(this, (EstimatorDetailsCard.__proto__ || Object.getPrototypeOf(EstimatorDetailsCard)).call(this, props));

    Object.defineProperty(_this, 'getStoreName', {
      enumerable: true,
      writable: true,
      value: function value(storeId) {
        var store = _this.props.allStores.find(function (s) {
          return s.id === storeId;
        });
        return store.name + ' - ' + store.number + ' Availability';
      }
    });
    Object.defineProperty(_this, 'getDaysString', {
      enumerable: true,
      writable: true,
      value: function value() {
        var period = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return period.length ? period.map(function (d) {
          return Object(lodash["capitalize"])(d);
        }).join(', ') : 'N/A';
      }
    });
    Object.defineProperty(_this, 'getAvailabilitiesByStore', {
      enumerable: true,
      writable: true,
      value: function value(availabilities) {
        return (availabilities || []).filter(function (a) {
          var _this$props$estimator = _this.props.estimator.covered_zip_codes,
              covered_zip_codes = _this$props$estimator === undefined ? [] : _this$props$estimator;

          var store = _this.props.allStores.find(function (s) {
            return s.id === a.assignee_availability.store_id;
          });
          var storeZips = store ? store.covered_zip_codes : [];
          return (storeZips || []).length && (covered_zip_codes || []).length && Object(lodash["intersection"])(storeZips, covered_zip_codes).length;
        }).map(function (a) {
          return a.assignee_availability;
        });
      }
    });
    Object.defineProperty(_this, 'handleEditToggle', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ isEditable: !_this.state.isEditable });
      }
    });
    Object.defineProperty(_this, 'isEstimator', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.role === 'estimator';
      }
    });
    Object.defineProperty(_this, 'renderTimeOffEditButton', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            role = _this$props.role,
            user = _this$props.user,
            estimator = _this$props.estimator;

        if (!Object(services["a" /* can */])(role, 'manage', 'pto', { user_id: user.id, obj_id: estimator.user_id })) return null;
        return react_default.a.createElement(editToggleButton, { actionLabel: 'Edit Time Off', isEditable: _this.state.isEditable, onClick: _this.handleEditToggle });
      }
    });
    Object.defineProperty(_this, 'renderAvailabilityByStore', {
      enumerable: true,
      writable: true,
      value: function value(stores) {
        if (!stores.length) return null;
        var filteredStores = [];
        Object(lodash["sortBy"])(stores, ['id']).forEach(function (s1) {
          if (!filteredStores.length || filteredStores.every(function (s2) {
            return s2.store_id !== s1.store_id;
          })) filteredStores.push(s1);
        });
        return filteredStores.map(function (s) {
          var id = s.id,
              store_id = s.store_id,
              morning = s.morning,
              afternoon = s.afternoon,
              evening = s.evening;

          return react_default.a.createElement(
            users_UserDetailsRow,
            { key: id, title: _this.getStoreName(store_id) },
            react_default.a.createElement(users_UserDetailsElement, {
              wrap: true,
              title: 'Morning',
              value: _this.getDaysString(morning)
            }),
            react_default.a.createElement(users_UserDetailsElement, {
              wrap: true,
              title: 'Afternoon',
              value: _this.getDaysString(afternoon)
            }),
            react_default.a.createElement(users_UserDetailsElement, {
              wrap: true,
              title: 'Evening',
              value: _this.getDaysString(evening)
            })
          );
        });
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props2 = _this.props,
            role = _this$props2.role,
            workrooms = _this$props2.workrooms,
            activeTab = _this$props2.activeTab,
            onTabChange = _this$props2.onTabChange,
            handleRateHistory = _this$props2.handleRateHistory,
            ptos = _this$props2.ptos,
            estimator = _this$props2.estimator,
            _this$props2$estimato = _this$props2.estimator,
            _this$props2$estimato2 = _this$props2$estimato.assignee_availabilities,
            assignee_availabilities = _this$props2$estimato2 === undefined ? [] : _this$props2$estimato2,
            _this$props2$estimato3 = _this$props2$estimato.address,
            address = _this$props2$estimato3 === undefined ? '' : _this$props2$estimato3,
            _this$props2$estimato4 = _this$props2$estimato.city,
            city = _this$props2$estimato4 === undefined ? '' : _this$props2$estimato4,
            _this$props2$estimato5 = _this$props2$estimato.state,
            state = _this$props2$estimato5 === undefined ? '' : _this$props2$estimato5,
            _this$props2$estimato6 = _this$props2$estimato.zip_code,
            zip_code = _this$props2$estimato6 === undefined ? '' : _this$props2$estimato6,
            _this$props2$estimato7 = _this$props2$estimato.covered_zip_codes,
            covered_zip_codes = _this$props2$estimato7 === undefined ? [] : _this$props2$estimato7,
            _this$props2$estimato8 = _this$props2$estimato.shared_zip_map,
            shared_zip_map = _this$props2$estimato8 === undefined ? {} : _this$props2$estimato8,
            _this$props2$estimato9 = _this$props2$estimato.floor_wizard_ident,
            floor_wizard_ident = _this$props2$estimato9 === undefined ? '' : _this$props2$estimato9,
            _this$props2$estimato10 = _this$props2$estimato.trusted,
            trusted = _this$props2$estimato10 === undefined ? false : _this$props2$estimato10,
            _this$props2$estimato11 = _this$props2$estimato.is_self_schedulable,
            is_self_schedulable = _this$props2$estimato11 === undefined ? false : _this$props2$estimato11,
            _this$props2$estimato12 = _this$props2$estimato.spig_employee,
            spig_employee = _this$props2$estimato12 === undefined ? false : _this$props2$estimato12,
            _this$props2$estimato13 = _this$props2$estimato.lrrp_training_expiration,
            lrrp_training_expiration = _this$props2$estimato13 === undefined ? '' : _this$props2$estimato13,
            _this$props2$estimato14 = _this$props2$estimato.workers_comp_expiration,
            workers_comp_expiration = _this$props2$estimato14 === undefined ? '' : _this$props2$estimato14,
            _this$props2$estimato15 = _this$props2$estimato.comments,
            comments = _this$props2$estimato15 === undefined ? '' : _this$props2$estimato15,
            _this$props2$estimato16 = _this$props2$estimato.assigned_supervisor,
            assigned_supervisor = _this$props2$estimato16 === undefined ? null : _this$props2$estimato16,
            _this$props2$estimato17 = _this$props2$estimato.supervisor_name,
            supervisor_name = _this$props2$estimato17 === undefined ? null : _this$props2$estimato17,
            _this$props2$estimato18 = _this$props2$estimato.liability_insurance_expiration,
            liability_insurance_expiration = _this$props2$estimato18 === undefined ? '' : _this$props2$estimato18,
            _this$props2$estimato19 = _this$props2$estimato.per_assessment_rate,
            per_assessment_rate = _this$props2$estimato19 === undefined ? '' : _this$props2$estimato19,
            _this$props2$estimato20 = _this$props2$estimato.mileage_rate,
            mileage_rate = _this$props2$estimato20 === undefined ? '' : _this$props2$estimato20,
            _this$props2$estimato21 = _this$props2$estimato.trainee_rate,
            trainee_rate = _this$props2$estimato21 === undefined ? '' : _this$props2$estimato21,
            _this$props2$estimato22 = _this$props2$estimato.training_bonus,
            training_bonus = _this$props2$estimato22 === undefined ? '' : _this$props2$estimato22,
            _this$props2$estimato23 = _this$props2$estimato.estimator_start_date,
            estimator_start_date = _this$props2$estimato23 === undefined ? '' : _this$props2$estimato23,
            _this$props2$estimato24 = _this$props2$estimato.estimator_end_date,
            estimator_end_date = _this$props2$estimato24 === undefined ? '' : _this$props2$estimato24,
            _this$props2$estimato25 = _this$props2$estimato.off_review_date,
            off_review_date = _this$props2$estimato25 === undefined ? '' : _this$props2$estimato25,
            _this$props2$estimato26 = _this$props2$estimato.morning_max_appts,
            morning_max_appts = _this$props2$estimato26 === undefined ? 0 : _this$props2$estimato26,
            _this$props2$estimato27 = _this$props2$estimato.afternoon_max_appts,
            afternoon_max_appts = _this$props2$estimato27 === undefined ? 0 : _this$props2$estimato27,
            _this$props2$estimato28 = _this$props2$estimato.evening_max_appts,
            evening_max_appts = _this$props2$estimato28 === undefined ? 0 : _this$props2$estimato28;

        var _ref = _this.props.user || {},
            _ref$position = _ref.position,
            position = _ref$position === undefined ? '' : _ref$position,
            _ref$manage_vendor_wo = _ref.manage_vendor_workrooms,
            mvw = _ref$manage_vendor_wo === undefined ? {} : _ref$manage_vendor_wo;

        var supervisorDisplayName = assigned_supervisor && assigned_supervisor.name || supervisor_name;
        var duration = estimator_end_date != null ? moment_default.a.duration(moment_default()(estimator_end_date).diff(moment_default()(estimator_start_date))) : moment_default.a.duration(moment_default()().diff(moment_default()(estimator_start_date)));
        /* eslint no-underscore-dangle: 0 */
        var years = duration._data.years;
        var months = duration._data.months;
        var days = duration._data.days;
        var userProps = {
          user: estimator,
          workrooms: workrooms,
          type: 'estimators',
          role: role,
          resource: 'estimator',
          editHandler: activeTab === _this.state.timeOffTab ? _this.renderTimeOffEditButton() : null
        };
        var stores = _this.getAvailabilitiesByStore(assignee_availabilities);
        return react_default.a.createElement(
          react_css_themr_lib["ThemeProvider"],
          { theme: estimatorDetailsCard_detailsTheme },
          react_default.a.createElement(
            users_UserDetailsCard,
            userProps,
            react_default.a.createElement(
              react_toolbox_lib["Tabs"],
              { index: activeTab, onChange: onTabChange, className: tabs_default.a.absoluteTabs },
              react_default.a.createElement(
                react_toolbox_lib["Tab"],
                { label: 'Basic Info' },
                react_default.a.createElement(users_UserDetailsBasicInfo, { user: estimator }),
                react_default.a.createElement(users_UserDetailsBadgeInfo, { user: estimator, type: 'estimator' }),
                react_default.a.createElement(
                  users_UserDetailsRow,
                  { title: 'Address' },
                  react_default.a.createElement(
                    users_UserDetailsElement,
                    { title: 'street address' },
                    react_default.a.createElement(components_DetailsAddress, {
                      address: address,
                      city: city,
                      state: state,
                      zipCode: zip_code
                    })
                  )
                ),
                react_default.a.createElement(
                  users_UserDetailsRow,
                  { title: 'Estimator Info' },
                  react_default.a.createElement(users_UserDetailsElement, {
                    wrap: true,
                    title: 'workroom(s)',
                    value: Object(utils["A" /* stringifyList */])(workrooms)
                  }),
                  react_default.a.createElement(
                    users_UserDetailsElement,
                    { wrap: true, title: 'zip codes' },
                    react_default.a.createElement(estimatorCoveredZips, {
                      covered_zip_codes: covered_zip_codes,
                      shared_zip_map: shared_zip_map,
                      estimator: estimator,
                      role: role
                    })
                  ),
                  !_this.isEstimator() && react_default.a.createElement(
                    react["Fragment"],
                    null,
                    react_default.a.createElement(users_UserDetailsElement, {
                      small: true,
                      title: 'floor wizard id',
                      value: floor_wizard_ident || 'N/A'
                    }),
                    react_default.a.createElement(users_UserDetailsElement, {
                      small: true,
                      title: 'Bypass Review, Send Directly to Store',
                      value: trusted ? 'Yes' : 'No'
                    }),
                    react_default.a.createElement(users_UserDetailsElement, {
                      small: true,
                      title: 'Self Schedulable',
                      value: is_self_schedulable ? 'Yes' : 'No'
                    }),
                    react_default.a.createElement(users_UserDetailsElement, {
                      small: true,
                      title: 'SPIG Employee',
                      value: spig_employee ? 'Yes' : 'No'
                    }),
                    react_default.a.createElement(users_UserDetailsElement, {
                      title: 'LRRP training expiration',
                      value: lrrp_training_expiration || 'N/A'
                    }),
                    react_default.a.createElement(users_UserDetailsElement, {
                      title: 'Off Review Date',
                      value: off_review_date || 'N/A'
                    }),
                    react_default.a.createElement(users_UserDetailsElement, {
                      title: 'Tenure',
                      value: (years ? years + ' years,' : '') + ' ' + (months ? months + ' months,' : '') + ' ' + (days ? days + ' days' : '')
                    })
                  )
                ),
                !_this.isEstimator() && react_default.a.createElement(
                  users_UserDetailsRow,
                  null,
                  react_default.a.createElement(users_UserDetailsElement, { title: 'Notes/Comments', value: comments || 'N/A' })
                ),
                react_default.a.createElement(
                  users_UserDetailsRow,
                  { title: 'Daily Appointment Limits' },
                  react_default.a.createElement(users_UserDetailsElement, { title: 'Morning', value: morning_max_appts }),
                  react_default.a.createElement(users_UserDetailsElement, { title: 'Afternoon', value: afternoon_max_appts }),
                  react_default.a.createElement(users_UserDetailsElement, { title: 'Evening', value: evening_max_appts })
                ),
                (workrooms || []).length && (assignee_availabilities || []).length && (stores || []).length ? _this.renderAvailabilityByStore(stores) : react_default.a.createElement(
                  users_UserDetailsRow,
                  { title: 'Availability By Store' },
                  'No Availabilities Set'
                ),
                react_default.a.createElement(
                  users_UserDetailsRow,
                  { title: 'Insurance' },
                  react_default.a.createElement(users_UserDetailsElement, {
                    title: 'worker\'s comp. expiration',
                    value: workers_comp_expiration
                  }),
                  react_default.a.createElement(users_UserDetailsElement, {
                    title: 'general liability insurance expiration',
                    value: liability_insurance_expiration
                  })
                ),
                Object(services["a" /* can */])(role, 'view', 'SUPERVISOR_INFO', { position: position, mvw: mvw }) && supervisorDisplayName &&
                // "Supervisor" is labeled as "Coordinator" in the UI since
                // that's more familiar to IFI users, but the value is still
                // stored as "supervisor_id" in the backend.
                react_default.a.createElement(
                  users_UserDetailsRow,
                  { title: 'Coordinator' },
                  react_default.a.createElement(users_UserDetailsElement, {
                    title: 'Assigned Coordinator',
                    value: supervisorDisplayName
                  })
                )
              ),
              Object(services["a" /* can */])(role, 'view', 'pay_rate') && react_default.a.createElement(
                react_toolbox_lib["Tab"],
                { label: 'Pay Rate' },
                react_default.a.createElement(
                  'div',
                  { className: payRates_default.a.payRateContainer },
                  react_default.a.createElement(components_PayRateElement, {
                    component: users_UserDetailsElement,
                    title: 'per assessment rate',
                    rate: per_assessment_rate,
                    handleHistory: function handleHistory() {
                      return handleRateHistory('per_assessment_rate');
                    }
                  }),
                  react_default.a.createElement(components_PayRateElement, {
                    component: users_UserDetailsElement,
                    title: 'mileage rate',
                    rate: mileage_rate,
                    handleHistory: function handleHistory() {
                      return handleRateHistory('mileage_rate');
                    }
                  }),
                  react_default.a.createElement(components_BreakLine, null)
                ),
                react_default.a.createElement(
                  'div',
                  { className: payRates_default.a.payRateContainer },
                  react_default.a.createElement(components_PayRateElement, {
                    component: users_UserDetailsElement,
                    title: 'trainee rate',
                    rate: trainee_rate,
                    handleHistory: function handleHistory() {
                      return handleRateHistory('trainee_rate');
                    },
                    mobile: '2x'
                  }),
                  react_default.a.createElement(components_PayRateElement, {
                    component: users_UserDetailsElement,
                    title: 'training bonus',
                    rate: training_bonus,
                    handleHistory: function handleHistory() {
                      return handleRateHistory('training_bonus');
                    },
                    mobile: '2x'
                  }),
                  react_default.a.createElement(components_BreakLine, null)
                )
              ) || react_default.a.createElement('div', null),
              react_default.a.createElement(
                react_toolbox_lib["Tab"],
                { label: 'Time Off' },
                react_default.a.createElement(components_TimeOffTable, {
                  isEditable: _this.state.isEditable,
                  ptos: ptos,
                  parentID: estimator.id,
                  parentKind: 'estimators',
                  parentObj: estimator
                })
              ),
              !_this.isEstimator() && react_default.a.createElement(
                react_toolbox_lib["Tab"],
                { label: 'History' },
                react_default.a.createElement(components_EmployableHistory, { employable: estimator, employableType: 'estimator' })
              )
            )
          )
        );
      }
    });

    _this.state = {
      isEditable: false,
      timeOffTab: Object(services["a" /* can */])(props.role, 'view', 'pay_rate') ? 2 : 1
    };
    return _this;
  }

  return EstimatorDetailsCard;
}(react["Component"]);

estimatorDetailsCard_EstimatorDetailsCard.propTypes = {
  estimator: types_user,
  role: prop_types_default.a.string,
  workrooms: prop_types_default.a.arrayOf(types_workroom).isRequired,
  allStores: prop_types_default.a.array,
  activeTab: prop_types_default.a.number,
  onTabChange: prop_types_default.a.func,
  onResend: prop_types_default.a.func,
  handleRateHistory: prop_types_default.a.func,
  ptos: prop_types_default.a.arrayOf(types_pto),
  user: RoleType
};

/* harmony default export */ var estimatorDetailsCard = (estimatorDetailsCard_EstimatorDetailsCard);
// EXTERNAL MODULE: ./client/app/shared/components/PayRateHistory/styles.scss
var PayRateHistory_styles = __webpack_require__("qia1");
var PayRateHistory_styles_default = /*#__PURE__*/__webpack_require__.n(PayRateHistory_styles);

// CONCATENATED MODULE: ./client/app/shared/components/PayRateHistory/index.jsx









var PayRateHistory_theme = {
  RTDialog: PayRateHistory_styles_default.a
};

var priceHeaderClasses = classnames_default()([PayRateHistory_styles_default.a.tableHeader, PayRateHistory_styles_default.a.priceColumn]);
var priceCellClasses = classnames_default()([PayRateHistory_styles_default.a.tableCell, PayRateHistory_styles_default.a.priceColumn]);

var PayRateHistory_PayRateHistory = function PayRateHistory(props) {
  var _props$payRates = props.payRates,
      payRates = _props$payRates === undefined ? [] : _props$payRates;


  var rateHistoryRows = payRates.map(function (rate) {
    return react_default.a.createElement(
      'tr',
      { key: rate.id },
      react_default.a.createElement(
        'td',
        { className: PayRateHistory_styles_default.a.tableCell },
        rate.who
      ),
      react_default.a.createElement(
        'td',
        { className: PayRateHistory_styles_default.a.tableCell },
        Object(dateUtils["l" /* getMinLocalDate */])(rate.created_at)
      ),
      react_default.a.createElement(
        'td',
        { className: priceCellClasses },
        rate.price
      )
    );
  });

  var content = props.loading ? react_default.a.createElement(components_Loading, null) : react_default.a.createElement(
    'table',
    { className: PayRateHistory_styles_default.a.historyTable },
    react_default.a.createElement(
      'thead',
      null,
      react_default.a.createElement(
        'tr',
        null,
        react_default.a.createElement(
          'th',
          { className: PayRateHistory_styles_default.a.tableHeader },
          'Name'
        ),
        react_default.a.createElement(
          'th',
          { className: PayRateHistory_styles_default.a.tableHeader },
          'Date Changed'
        ),
        react_default.a.createElement(
          'th',
          { className: priceHeaderClasses },
          'Price'
        )
      )
    ),
    react_default.a.createElement(
      'tbody',
      null,
      rateHistoryRows
    )
  );
  return react_default.a.createElement(
    react_css_themr_lib["ThemeProvider"],
    { theme: PayRateHistory_theme },
    react_default.a.createElement(
      react_toolbox_lib["Dialog"],
      { active: props.showHistory, onEscKeyDown: props.closeHistory },
      react_default.a.createElement(react_toolbox_lib["FontIcon"], { value: 'close', className: PayRateHistory_styles_default.a.closeIcon, onClick: props.closeHistory }),
      react_default.a.createElement(
        'div',
        { className: PayRateHistory_styles_default.a.rateName },
        props.rateName
      ),
      react_default.a.createElement(
        'div',
        { className: PayRateHistory_styles_default.a.tableContainer },
        content
      )
    )
  );
};

PayRateHistory_PayRateHistory.propTypes = {
  showHistory: prop_types_default.a.bool,
  closeHistory: prop_types_default.a.func,
  rateName: prop_types_default.a.string,
  loading: prop_types_default.a.bool,
  payRates: prop_types_default.a.array
};

/* harmony default export */ var components_PayRateHistory = (PayRateHistory_PayRateHistory);
// CONCATENATED MODULE: ./client/app/screens/main/screens/estimators/estimatorDetails.jsx
function estimatorDetails__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function estimatorDetails__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function estimatorDetails__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var estimatorDetails_EstimatorDetails = function (_Component) {
  estimatorDetails__inherits(EstimatorDetails, _Component);

  function EstimatorDetails() {
    var _ref;

    var _temp, _this, _ret;

    estimatorDetails__classCallCheck(this, EstimatorDetails);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = estimatorDetails__possibleConstructorReturn(this, (_ref = EstimatorDetails.__proto__ || Object.getPrototypeOf(EstimatorDetails)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'componentDidMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            dispatch = _this$props.dispatch,
            id = _this$props.id;

        dispatch(Object(actionCreators["U" /* requestAllStores */])());
        dispatch(Object(actionCreators["_31" /* requestWorkroomList */])());
        dispatch(Object(actionCreators["Z" /* requestEstimator */])(id));
        dispatch(Object(actionCreators["_13" /* requestPTOList */])(id, 'estimators'));
      }
    }), Object.defineProperty(_this, 'componentWillUnmount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.ui.successMessage ? _this.props.updateUI('successMessage', '') : null;
      }
    }), Object.defineProperty(_this, 'handleTabChange', {
      enumerable: true,
      writable: true,
      value: function value(index) {
        return _this.props.updateUI('activeTab', index);
      }
    }), Object.defineProperty(_this, 'closeHistory', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.dispatch(Object(actionCreators["C" /* hideHistoryScreen */])());
      }
    }), Object.defineProperty(_this, 'showRateHistory', {
      enumerable: true,
      writable: true,
      value: function value(rate) {
        var _this$props2 = _this.props,
            id = _this$props2.id,
            dispatch = _this$props2.dispatch;

        Promise.all([dispatch(Object(actionCreators["_53" /* showHistoryScreen */])(rate)), dispatch(Object(actionCreators["_14" /* requestPayRatesList */])(id, rate))]);
      }
    }), Object.defineProperty(_this, 'closeRateHistory', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.dispatch(Object(actionCreators["C" /* hideHistoryScreen */])());
      }
    }), Object.defineProperty(_this, 'estimatorCanView', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props3 = _this.props,
            role = _this$props3.role,
            _this$props3$user$emp = _this$props3.user.employable_id,
            employable_id = _this$props3$user$emp === undefined ? null : _this$props3$user$emp;

        var regex = /estimators\/(\d+)/g;
        var match = regex.exec(window.location.href) || null;
        return Object(services["a" /* can */])(role, 'view', 'estimator_details', { matching: parseInt(match[1], 10) === employable_id });
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props4 = _this.props,
            estimator = _this$props4.estimator,
            loading = _this$props4.loading,
            ui = _this$props4.ui,
            role = _this$props4.role,
            workrooms = _this$props4.workrooms,
            showHistory = _this$props4.showHistory,
            rateName = _this$props4.rateName,
            loadingRateHistory = _this$props4.loadingRateHistory,
            payRates = _this$props4.payRates,
            ptos = _this$props4.ptos,
            user = _this$props4.user,
            allStores = _this$props4.allStores;

        return react_default.a.createElement(
          'div',
          null,
          role !== 'estimator' || _this.estimatorCanView() ? react_default.a.createElement(
            react["Fragment"],
            null,
            ui.successMessage ? react_default.a.createElement(MessageBox["a" /* default */], { message: ui.successMessage }) : null,
            loading ? react_default.a.createElement(components_Loading, null) : react_default.a.createElement(estimatorDetailsCard, {
              activeTab: ui.activeTab,
              onTabChange: _this.handleTabChange,
              estimator: estimator,
              workrooms: workrooms,
              allStores: allStores,
              role: role,
              handleRateHistory: _this.showRateHistory,
              ptos: ptos,
              user: user
            }),
            react_default.a.createElement(components_PayRateHistory, {
              showHistory: showHistory,
              rateName: rateName,
              closeHistory: _this.closeRateHistory,
              loading: loadingRateHistory,
              payRates: payRates
            })
          ) : react_default.a.createElement(MessageBox["a" /* default */], { message: 'You do not have permission to view this page.' })
        );
      }
    }), _temp), estimatorDetails__possibleConstructorReturn(_this, _ret);
  }

  return EstimatorDetails;
}(react["Component"]);

estimatorDetails_EstimatorDetails.propTypes = {
  allStores: prop_types_default.a.array,
  id: prop_types_default.a.number,
  estimator: prop_types_default.a.object,
  workrooms: prop_types_default.a.array,
  loading: prop_types_default.a.bool,
  role: prop_types_default.a.string,
  dispatch: prop_types_default.a.func,
  updateUI: prop_types_default.a.func,
  showHistory: prop_types_default.a.bool,
  loadingRateHistory: prop_types_default.a.bool,
  rateName: prop_types_default.a.string,
  payRates: prop_types_default.a.array,
  ui: prop_types_default.a.object,
  ptos: prop_types_default.a.arrayOf(types_pto),
  user: RoleType,
  requestAllStores: prop_types_default.a.func,
  requestWorkroomList: prop_types_default.a.func
};

var estimatorDetails_mapStateToProps = function mapStateToProps(state, ownProps) {
  var id = Number(ownProps.params.id);
  var estimator = Object(reducers["p" /* getEstimatorById */])(state)(id);
  return {
    id: id,
    estimator: estimator,
    workrooms: estimator && estimator.workrooms ? estimator.workrooms.map(function (wrId) {
      return Object(reducers["_33" /* getWorkroomById */])(state)(wrId);
    }) : [],
    allStores: Object(reducers["_18" /* getStoreList */])(state),
    loading: estimator ? estimator.loading : true,
    showHistory: Object(reducers["S" /* getPayRateShowHistory */])(state),
    loadingRateHistory: Object(reducers["R" /* getPayRateLoading */])(state),
    rateName: Object(reducers["Q" /* getPayRateCurrentName */])(state),
    payRates: Object(reducers["P" /* getPayRateCurrentHistoryList */])(state),
    role: Object(reducers["_12" /* getRole */])(state),
    ptos: state.ptos.data,
    user: state.user
  };
};

/* harmony default export */ var estimatorDetails = (transpiled_default()()(Object(react_redux_es["connect"])(estimatorDetails_mapStateToProps, {
  requestAllStores: actionCreators["U" /* requestAllStores */], requestWorkroomList: actionCreators["_31" /* requestWorkroomList */]
})(estimatorDetails_EstimatorDetails)));
// EXTERNAL MODULE: ./client/app/shared/actionCreators/employees.js
var actionCreators_employees = __webpack_require__("1HIx");

// EXTERNAL MODULE: ./client/app/shared/components/CurrencyInput/styles.scss
var CurrencyInput_styles = __webpack_require__("IfL0");
var CurrencyInput_styles_default = /*#__PURE__*/__webpack_require__.n(CurrencyInput_styles);

// CONCATENATED MODULE: ./client/app/shared/components/CurrencyInput/index.jsx
var CurrencyInput__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var CurrencyInput__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function CurrencyInput__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function CurrencyInput__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function CurrencyInput__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var formatCurrency = function formatCurrency(value) {
  var num = value.split('').filter(function (c) {
    return c.match(/\d|\./);
  }).join('');
  var dotIndex = num.indexOf('.');
  if (dotIndex > 0) {
    num = num.slice(0, dotIndex + 3);
  }
  return num;
};

var CurrencyInput_CurrencyInput = function (_React$Component) {
  CurrencyInput__inherits(CurrencyInput, _React$Component);

  function CurrencyInput(props) {
    CurrencyInput__classCallCheck(this, CurrencyInput);

    var _this = CurrencyInput__possibleConstructorReturn(this, (CurrencyInput.__proto__ || Object.getPrototypeOf(CurrencyInput)).call(this, props));

    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }

  CurrencyInput__createClass(CurrencyInput, [{
    key: 'handleChange',
    value: function handleChange(value) {
      var newValue = formatCurrency(value);
      this.props.onChange(newValue);
    }
  }, {
    key: 'render',
    value: function render() {
      var newProps = CurrencyInput__extends({}, this.props, { onChange: this.handleChange });
      return react_default.a.createElement(
        react_toolbox_lib["Input"],
        newProps,
        react_default.a.createElement(
          'i',
          { className: CurrencyInput_styles_default.a.dollarSign },
          '$'
        )
      );
    }
  }]);

  return CurrencyInput;
}(react_default.a.Component);

CurrencyInput_CurrencyInput.propTypes = {
  onChange: prop_types_default.a.func
};

/* harmony default export */ var components_CurrencyInput = (CurrencyInput_CurrencyInput);
// CONCATENATED MODULE: ./client/app/screens/main/screens/estimators/components/estimatorForm.jsx
var estimatorForm__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var estimatorForm__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function estimatorForm__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function estimatorForm__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function estimatorForm__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function estimatorForm__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function estimatorForm__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





































var MAX_APPT_OPTIONS = [{ label: '0', value: 0 }, { label: '1', value: 1 }, { label: '2', value: 2 }, { label: '3', value: 3 }, { label: '4', value: 4 }, { label: '5', value: 5 }, { label: '6', value: 6 }];
var DAYS_OF_THE_WEEK = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
var PHONE_TYPES = ['mobile', 'desk', 'fax'];
var STATES_SOURCE = constants["_35" /* STATES */].map(function (state) {
  return { value: state, label: state };
});
var estimatorForm_TIMEZONE_SOURCE = constants["_46" /* TIMEZONES */].map(function (tz) {
  return { value: tz, label: tz };
});
var estimatorForm_theme = { RTInput: input_default.a, RTDropdown: dropdown_default.a, RTCard: styles_card_default.a, RTSwitch: switch_default.a, RTTabs: tabs_default.a };
var estimatorForm_largeInput = classnames_default()(form_default.a.inputs, form_default.a.largeInput);
var estimatorForm_mediumInput = classnames_default()(form_default.a.inputs, form_default.a.mediumInput);
var currencyInput = classnames_default()(estimatorForm_mediumInput, components_styles_default.a.currencyInput);
var estimatorForm_smallInput = classnames_default()(form_default.a.inputs, form_default.a.smallInput);
var estimatorForm_cancelClass = classnames_default()([form_default.a.cancelButton, form_default.a.actionButton]);

var EstimatorForm = function (_Component) {
  estimatorForm__inherits(EstimatorForm, _Component);

  function EstimatorForm(props) {
    estimatorForm__classCallCheck(this, EstimatorForm);

    var _this = estimatorForm__possibleConstructorReturn(this, (EstimatorForm.__proto__ || Object.getPrototypeOf(EstimatorForm)).call(this, props));

    estimatorForm__initialiseProps.call(_this);

    _this.handleSave = _this.handleSave.bind(_this);
    _this.handleCancel = _this.handleCancel.bind(_this);
    _this.handleActive = _this.handleChange.bind(_this, 'active');
    _this.handleSelfSchedulable = _this.handleChange.bind(_this, 'is_self_schedulable');
    _this.handlePrimaryType = _this.handleChange.bind(_this, 'primary_phone_type');
    _this.handleSecondaryType = _this.handleChange.bind(_this, 'secondary_phone_type');
    _this.handleState = _this.handleChange.bind(_this, 'state');
    _this.handleMorningMax = _this.handleChange.bind(_this, 'morning_max_appts');
    _this.handleAfternoonMax = _this.handleChange.bind(_this, 'afternoon_max_appts');
    _this.handleEveningMax = _this.handleChange.bind(_this, 'evening_max_appts');
    _this.handleName = _this.handleChange.bind(_this, 'name');
    _this.handleAddress = _this.handleChange.bind(_this, 'address');
    _this.handleCity = _this.handleChange.bind(_this, 'city');
    _this.handleZipCode = _this.handleChange.bind(_this, 'zip_code');
    _this.handleEmail = _this.handleChange.bind(_this, 'email');
    _this.handlePrimaryPhone = _this.handleChange.bind(_this, 'primary_phone');
    _this.handleSecondaryPhone = _this.handleChange.bind(_this, 'secondary_phone');
    _this.handleBadgeChange = _this.handleBadgeChange.bind(_this);
    _this.handleWorkersExp = _this.handleChange.bind(_this, 'workers_comp_expiration');
    _this.handleLiability = _this.handleChange.bind(_this, 'liability_insurance_expiration');
    _this.handleLrrpTraining = _this.handleChange.bind(_this, 'lrrp_training_expiration');
    _this.handleOffReviewDate = _this.handleChange.bind(_this, 'off_review_date');
    _this.handleFloorWizard = _this.handleChange.bind(_this, 'floor_wizard_ident');
    _this.handleTrustedChange = _this.handleChange.bind(_this, 'trusted');
    _this.handleSpigEmployeeChange = _this.handleChange.bind(_this, 'spig_employee');
    _this.handleTraineeRate = _this.handleChange.bind(_this, 'trainee_rate');
    _this.handleTrainingBonus = _this.handleChange.bind(_this, 'training_bonus');
    _this.handlePerAssessmentRate = _this.handleChange.bind(_this, 'per_assessment_rate');
    _this.handleMileageRate = _this.handleChange.bind(_this, 'mileage_rate');
    _this.handleHistory = function (type) {
      return _this.props.estimator && _this.props.estimator.id ? _this.props.handleRateHistory(type) : null;
    };
    _this.handleTraineeRateHistory = function () {
      return _this.handleHistory('trainee_rate');
    };
    _this.handleTrainingBonusHistory = function () {
      return _this.handleHistory('training_bonus');
    };
    _this.handlePerAssessmentRateHistory = function () {
      return _this.handleHistory('per_assessment_rate');
    };
    _this.handleMileageRateHistory = function () {
      return _this.handleHistory('mileage_rate');
    };
    _this.handleSelectChange = function (key, value) {
      return _this.handleChange(key, value.map(function (v) {
        return v.value;
      }));
    };
    _this.handleWorkrooms = _this.handleSelectChange.bind(_this, 'workrooms');
    _this.handleCoveredZipCodes = _this.handleChange.bind(_this, 'covered_zip_codes');
    _this.handleStartDate = _this.handleChange.bind(_this, 'estimator_start_date');
    _this.handleEndDate = _this.handleChange.bind(_this, 'estimator_end_date');
    _this.handleComments = _this.handleChange.bind(_this, 'comments');
    var estimator = _this.props.estimator;

    var stateEstimator = estimator && estimatorForm__extends({}, estimator) || {
      active: true, primary_phone_type: 'mobile', secondary_phone_type: 'mobile', workrooms: [], assignee_availabilities: []
    };
    _this.state = {
      invalidEmail: false,
      estimator: stateEstimator,
      assigneeAvailabilities: stateEstimator.assignee_availabilities && stateEstimator.assignee_availabilities.length ? _this.getAvailabilitiesFromExisting(stateEstimator.assignee_availabilities) : _this.getAvailabilities(stateEstimator)
    };
    return _this;
  }

  estimatorForm__createClass(EstimatorForm, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var prevIfiWorkroomIds = this.getIfiWorkroomIds(prevState.estimator.workrooms);
      var currentIfiWorkroomIds = this.getIfiWorkroomIds(this.state.estimator.workrooms);

      if (prevIfiWorkroomIds.length !== currentIfiWorkroomIds.length || !prevIfiWorkroomIds.every(function (id, idx) {
        return id === currentIfiWorkroomIds[idx];
      })) {
        this.fetchEmployees();
      }
    }
  }]);

  return EstimatorForm;
}(react["Component"]);

Object.defineProperty(EstimatorForm, 'tabs', {
  enumerable: true,
  writable: true,
  value: ['Basic Info', 'Pay Rate']
});

var estimatorForm__initialiseProps = function _initialiseProps() {
  var _this2 = this;

  Object.defineProperty(this, 'componentDidMount', {
    enumerable: true,
    writable: true,
    value: function value() {
      _this2.fetchEmployees();
    }
  });
  Object.defineProperty(this, 'componentWillReceiveProps', {
    enumerable: true,
    writable: true,
    value: function value(nextProps) {
      return nextProps.errors && Object.keys(nextProps.errors) && !Object(lodash["isEqual"])(_this2.props.errors, nextProps.errors) ? _this2.goToFirstErroredTab(nextProps) : null;
    }
  });
  Object.defineProperty(this, 'getIfiWorkroomIds', {
    enumerable: true,
    writable: true,
    value: function value() {
      var selectedWorkroomIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this2.state.estimator.workrooms;
      var _props$allWorkrooms = _this2.props.allWorkrooms,
          allWorkrooms = _props$allWorkrooms === undefined ? [] : _props$allWorkrooms;

      return (selectedWorkroomIds || []).filter(function (id) {
        return allWorkrooms.some(function (w) {
          return w.id === id && w.vendor === 'IFI';
        });
      });
    }
  });
  Object.defineProperty(this, 'getSupervisorOptions', {
    enumerable: true,
    writable: true,
    value: function value() {
      return (_this2.props.employees || []).map(function (employee) {
        return {
          value: employee.id,
          label: employee.name + ' - ' + (employee.position || 'Employee')
        };
      });
    }
  });
  Object.defineProperty(this, 'getSupervisorValue', {
    enumerable: true,
    writable: true,
    value: function value(options) {
      var _state$estimator = _this2.state.estimator,
          assigned_supervisor = _state$estimator.assigned_supervisor,
          supervisor_id = _state$estimator.supervisor_id;

      var supervisorId = assigned_supervisor && assigned_supervisor.id || supervisor_id;
      return supervisorId ? options.find(function (opt) {
        return opt.value === supervisorId;
      }) || null : null;
    }
  });
  Object.defineProperty(this, 'getStoresFromWorkroom', {
    enumerable: true,
    writable: true,
    value: function value(workroom) {
      return workroom.store_with_zips.map(function (ws) {
        return ws.store;
      });
    }
  });
  Object.defineProperty(this, 'getStoreList', {
    enumerable: true,
    writable: true,
    value: function value() {
      var workrooms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this2.state.estimator.workrooms;
      return Object(lodash["uniq"])(_this2.props.allWorkrooms.filter(function (w) {
        return workrooms.includes(w.id);
      }).map(function (w) {
        return _this2.getStoresFromWorkroom(w);
      }).flat());
    }
  });
  Object.defineProperty(this, 'getDayTimeChecked', {
    enumerable: true,
    writable: true,
    value: function value(day, days) {
      return days.includes(day);
    }
  });
  Object.defineProperty(this, 'getAvailabilitiesFromExisting', {
    enumerable: true,
    writable: true,
    value: function value(availabilities) {
      return _this2.handleDupedAvailabilities(availabilities.map(function (a) {
        return estimatorForm__extends({}, a.assignee_availability, { type: 'existing' });
      }));
    }
  });
  Object.defineProperty(this, 'getAvailabilities', {
    enumerable: true,
    writable: true,
    value: function value(estimator) {
      return estimator.workrooms.length ? _this2.getStoreList(estimator.workrooms).map(function (s) {
        return _this2.getNewAvailability(estimator.id || null, s.id);
      }) : [];
    }
  });
  Object.defineProperty(this, 'getNewAvailability', {
    enumerable: true,
    writable: true,
    value: function value(estimatorId, storeId) {
      var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'new';
      return {
        id: null,
        store_id: storeId,
        assignee_type: 'Estimator',
        assignee_id: estimatorId || -1,
        morning: DAYS_OF_THE_WEEK,
        afternoon: DAYS_OF_THE_WEEK,
        evening: DAYS_OF_THE_WEEK,
        type: type
      };
    }
  });
  Object.defineProperty(this, 'handleSupervisorChange', {
    enumerable: true,
    writable: true,
    value: function value(selectedOption) {
      var supervisorId = selectedOption ? selectedOption.value : null;
      _this2.handleChange('supervisor_id', supervisorId);
    }
  });
  Object.defineProperty(this, 'fetchEmployees', {
    enumerable: true,
    writable: true,
    value: function value() {
      var ifiWorkroomIds = _this2.getIfiWorkroomIds();
      if (!ifiWorkroomIds.length) {
        _this2.props.setEmployeeFilters({
          is_active: true,
          for_workrooms: [-1],
          for_positions: constants["O" /* IC_ISM_POSITIONS */]
        });
        return;
      }
      _this2.props.setEmployeeFilters({
        is_active: true,
        for_workrooms: ifiWorkroomIds,
        for_positions: constants["O" /* IC_ISM_POSITIONS */]
      });
    }
  });
  Object.defineProperty(this, 'handleDupedAvailabilities', {
    enumerable: true,
    writable: true,
    value: function value(availabilities) {
      return availabilities.map(function (a1) {
        var id = a1.id,
            store_id = a1.store_id;

        var dupedAvailabilities = availabilities.filter(function (a2) {
          return store_id === a2.store_id;
        });
        return dupedAvailabilities.some(function (dA) {
          return dA.id < id;
        }) ? estimatorForm__extends({}, a1, { type: 'delete' }) : a1;
      });
    }
  });
  Object.defineProperty(this, 'finalizeAvailabilities', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _state = _this2.state,
          _state$estimator2 = _state.estimator,
          _state$estimator2$id = _state$estimator2.id,
          id = _state$estimator2$id === undefined ? null : _state$estimator2$id,
          _state$estimator2$ass = _state$estimator2.assignee_availabilities,
          assignee_availabilities = _state$estimator2$ass === undefined ? [] : _state$estimator2$ass,
          _state$assigneeAvaila = _state.assigneeAvailabilities,
          assigneeAvailabilities = _state$assigneeAvaila === undefined ? [] : _state$assigneeAvaila;

      var flatAvailabilities = assignee_availabilities.map(function (a) {
        return a.assignee_availability;
      });
      var editedAvailabilities = assigneeAvailabilities;
      if (!id || !flatAvailabilities.length) return editedAvailabilities;
      if (editedAvailabilities.length) {
        editedAvailabilities = editedAvailabilities.map(function (a1) {
          return a1.type === 'new' && flatAvailabilities.some(function (a2) {
            return a1.store_id === a2.store_id;
          }) ? estimatorForm__extends({}, a1, { type: 'edit' }) : a1;
        });
      } else return flatAvailabilities.map(function (a) {
        return _this2.getNewAvailability(id, a.store_id, 'delete');
      });
      var removedAvailabilities = flatAvailabilities.filter(function (a1) {
        return editedAvailabilities.every(function (a2) {
          return a1.store_id !== a2.store_id;
        });
      });
      if (removedAvailabilities.length) {
        removedAvailabilities.forEach(function (a) {
          return editedAvailabilities.push(_this2.getNewAvailability(id, a.store_id, 'delete'));
        });
      }
      var finalAvailabilities = editedAvailabilities.filter(function (a) {
        return a.type !== 'existing';
      });
      return finalAvailabilities;
    }
  });
  Object.defineProperty(this, 'handleChange', {
    enumerable: true,
    writable: true,
    value: function value(key, _value) {
      var _props$updateDiff = _this2.props.updateDiff,
          updateDiff = _props$updateDiff === undefined ? null : _props$updateDiff;

      var stateObj = { estimator: _this2.state.estimator };
      if (key === 'workrooms') stateObj.assigneeAvailabilities = _this2.handleAvailabilityWorkroomEdit(_value);
      var emailChange = key === 'email';
      stateObj.estimator[key] = emailChange ? _value.replaceAll(' ', '') : _value;
      stateObj.invalidEmail = emailChange && !constants["I" /* EMAIL_VALIDATION_REGEX */].test(_value);
      if (updateDiff) updateDiff(key, _value);
      _this2.setState(stateObj);
    }
  });
  Object.defineProperty(this, 'handleAvailabilityWorkroomEdit', {
    enumerable: true,
    writable: true,
    value: function value(editedWorkrooms) {
      var _state2 = _this2.state,
          _state2$estimator = _state2.estimator,
          _state2$estimator$id = _state2$estimator.id,
          id = _state2$estimator$id === undefined ? null : _state2$estimator$id,
          workrooms = _state2$estimator.workrooms,
          assigneeAvailabilities = _state2.assigneeAvailabilities;

      var oldStores = _this2.getStoreList(workrooms);
      var newStores = _this2.getStoreList(editedWorkrooms);
      if (editedWorkrooms.length < workrooms.length) {
        return assigneeAvailabilities.filter(function (a) {
          return !Object(lodash["difference"])(oldStores, newStores).some(function (s) {
            return s.id === a.store_id;
          });
        });
      }
      Object(lodash["difference"])(newStores, oldStores).forEach(function (s) {
        return assigneeAvailabilities.push(_this2.getNewAvailability(id, s.id));
      });
      return assigneeAvailabilities;
    }
  });
  Object.defineProperty(this, 'handleBadgeChange', {
    enumerable: true,
    writable: true,
    value: function value(key, _value2) {
      var _props$updateDiff2 = _this2.props.updateDiff,
          updateDiff = _props$updateDiff2 === undefined ? null : _props$updateDiff2;

      var estimator = _this2.state.estimator;
      estimator.badge = estimator.badge || {};
      estimator.badge[key] = _value2;
      if (updateDiff) updateDiff(key.includes('badge_link') ? key : 'badge_' + key, _value2);
      _this2.setState({ estimator: estimator });
    }
  });
  Object.defineProperty(this, 'handleTimezone', {
    enumerable: true,
    writable: true,
    value: function value(option) {
      var _props$updateDiff3 = _this2.props.updateDiff,
          updateDiff = _props$updateDiff3 === undefined ? null : _props$updateDiff3;

      var estimator = _this2.state.estimator;
      estimator.timezone = option.value;
      if (updateDiff) updateDiff('timezone', option.value);
      _this2.setState({ estimator: estimator });
    }
  });
  Object.defineProperty(this, 'handleAvailabilityChange', {
    enumerable: true,
    writable: true,
    value: function value(storeId, day, period) {
      var assigneeAvailabilities = _this2.state.assigneeAvailabilities;

      var editedAvailabilities = assigneeAvailabilities.map(function (a) {
        var returnedAvailability = a;
        if (a.store_id === storeId) {
          returnedAvailability[period] = returnedAvailability[period].includes(day) ? returnedAvailability[period].filter(function (d) {
            return d !== day;
          }) : returnedAvailability[period].concat([day]);
          if (a.type === 'existing') returnedAvailability.type = 'edit';
        }
        return returnedAvailability;
      });
      _this2.setState({ assigneeAvailabilities: editedAvailabilities });
    }
  });
  Object.defineProperty(this, 'handleCancel', {
    enumerable: true,
    writable: true,
    value: function value() {
      return _this2.props.onCancel();
    }
  });
  Object.defineProperty(this, 'handleSave', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _state$estimator3 = _this2.state.estimator,
          workrooms = _state$estimator3.workrooms,
          user_id = _state$estimator3.user_id,
          badge = _state$estimator3.badge,
          active = _state$estimator3.active,
          name = _state$estimator3.name,
          email = _state$estimator3.email,
          primary_phone = _state$estimator3.primary_phone,
          primary_phone_type = _state$estimator3.primary_phone_type,
          secondary_phone = _state$estimator3.secondary_phone,
          secondary_phone_type = _state$estimator3.secondary_phone_type,
          timezone = _state$estimator3.timezone,
          workers_comp_expiration = _state$estimator3.workers_comp_expiration,
          liability_insurance_expiration = _state$estimator3.liability_insurance_expiration,
          lrrp_training_expiration = _state$estimator3.lrrp_training_expiration,
          estimator_start_date = _state$estimator3.estimator_start_date,
          estimator_end_date = _state$estimator3.estimator_end_date,
          off_review_date = _state$estimator3.off_review_date,
          morning_max_appts = _state$estimator3.morning_max_appts,
          afternoon_max_appts = _state$estimator3.afternoon_max_appts,
          evening_max_appts = _state$estimator3.evening_max_appts,
          comments = _state$estimator3.comments,
          estimator = estimatorForm__objectWithoutProperties(_state$estimator3, ['workrooms', 'user_id', 'badge', 'active', 'name', 'email', 'primary_phone', 'primary_phone_type', 'secondary_phone', 'secondary_phone_type', 'timezone', 'workers_comp_expiration', 'liability_insurance_expiration', 'lrrp_training_expiration', 'estimator_start_date', 'estimator_end_date', 'off_review_date', 'morning_max_appts', 'afternoon_max_appts', 'evening_max_appts', 'comments']);

      var finalAvailabilities = _this2.finalizeAvailabilities();
      _this2.props.onSave(estimatorForm__extends({}, estimator, {
        comments: comments,
        morning_max_appts: Object(lodash["parseInt"])(morning_max_appts),
        afternoon_max_appts: Object(lodash["parseInt"])(afternoon_max_appts),
        evening_max_appts: Object(lodash["parseInt"])(evening_max_appts),
        workers_comp_expiration: Object(dateUtils["o" /* handleDateSave */])(workers_comp_expiration),
        estimator_start_date: Object(dateUtils["o" /* handleDateSave */])(estimator_start_date),
        estimator_end_date: Object(dateUtils["o" /* handleDateSave */])(estimator_end_date),
        liability_insurance_expiration: Object(dateUtils["o" /* handleDateSave */])(liability_insurance_expiration),
        lrrp_training_expiration: Object(dateUtils["o" /* handleDateSave */])(lrrp_training_expiration),
        off_review_date: Object(dateUtils["o" /* handleDateSave */])(off_review_date),
        availabilities: finalAvailabilities,
        user_attributes: {
          id: user_id,
          active: active,
          name: name,
          email: email,
          primary_phone: primary_phone,
          primary_phone_type: primary_phone_type,
          secondary_phone: secondary_phone,
          secondary_phone_type: secondary_phone_type,
          timezone: timezone,
          workroom_ids: workrooms,
          badge_attributes: estimatorForm__extends({}, badge, { expiration: Object(dateUtils["o" /* handleDateSave */])((badge || {}).expiration) })
        }
      }));
    }
  });
  Object.defineProperty(this, 'goToFirstErroredTab', {
    enumerable: true,
    writable: true,
    value: function value() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this2.props;
      var errors = props.errors,
          activeTab = props.activeTab;

      if (!Object.keys(errors).length) return;
      var tabErrors = _this2.tabErrors(props);
      // if there are errors on this tab, do nothing
      if (tabErrors[EstimatorForm.tabs[activeTab]]) return;
      var firstErroredTab = EstimatorForm.tabs.indexOf(Object.keys(tabErrors).filter(function (t) {
        return tabErrors[t] > 0;
      })[0]);
      _this2.props.onTabChange(Math.max(firstErroredTab, 0));
    }
  });
  Object.defineProperty(this, 'tabErrors', {
    enumerable: true,
    writable: true,
    value: function value() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this2.props;
      var errors = props.errors;

      if (!Object.keys(errors).length) return {};
      var payRateErrors = Object(lodash["pick"])(errors, ['per_assessment_rate', 'mileage_rate', 'trainee_rate', 'training_bonus']);
      // Basic Info errors are all those that are not pay rate errors
      var basicInfoErrors = {};
      Object.keys(errors).forEach(function (e) {
        if (!payRateErrors[e]) basicInfoErrors[e] = errors[e];
      });
      return {
        'Basic Info': Object.keys(basicInfoErrors).length,
        'Pay Rate': Object.keys(payRateErrors).length
      };
    }
  });
  Object.defineProperty(this, 'sortEstimatorZips', {
    enumerable: true,
    writable: true,
    value: function value(zips) {
      return zips && zips.length > 0 ? zips.sort(function (a, b) {
        return a - b;
      }) : [];
    }
  });
  Object.defineProperty(this, 'filterStoreDisplay', {
    enumerable: true,
    writable: true,
    value: function value(availabilities) {
      return availabilities.filter(function (a) {
        if (a.type === 'delete') return false;
        var _state$estimator$cove = _this2.state.estimator.covered_zip_codes,
            covered_zip_codes = _state$estimator$cove === undefined ? [] : _state$estimator$cove;

        var store = _this2.getStoreList().find(function (s) {
          return s.id === a.store_id;
        });
        var storeZips = store ? store.covered_zip_codes : [];
        return storeZips.length && covered_zip_codes.length && Object(lodash["intersection"])(storeZips, covered_zip_codes).length;
      });
    }
  });
  Object.defineProperty(this, 'renderTitle', {
    enumerable: true,
    writable: true,
    value: function value(estimator, isEdit) {
      var _cx;

      var title = isEdit ? estimator.name + ' (' + estimator.id + ')' || 'Edit Estimator' : 'Add Estimator';
      var switchClassNames = classnames_default()((_cx = {}, estimatorForm__defineProperty(_cx, form_default.a.switchTitleAdd, !isEdit), estimatorForm__defineProperty(_cx, form_default.a.switchTitle, true), _cx));
      return react_default.a.createElement(
        'div',
        null,
        react_default.a.createElement(
          flexbox_react_dist_default.a,
          { justifyContent: 'space-between', className: form_default.a.divider },
          react_default.a.createElement(
            'div',
            null,
            react_default.a.createElement(
              'h5',
              { className: form_default.a.cardTitle },
              title
            ),
            react_default.a.createElement(
              'p',
              { className: form_default.a.cardSubtitle },
              'Please ensure that all fields contain accurate information'
            )
          ),
          react_default.a.createElement(react_toolbox_lib["Switch"], {
            name: 'active',
            label: 'Account Active',
            onChange: _this2.handleActive,
            className: switchClassNames,
            checked: estimator.active
          })
        )
      );
    }
  });
  Object.defineProperty(this, 'renderByTimePeriodAndDay', {
    enumerable: true,
    writable: true,
    value: function value(storeId, period, days) {
      return react_default.a.createElement(
        react["Fragment"],
        null,
        react_default.a.createElement(
          'h5',
          { className: form_default.a.cardSubtitle },
          period.toUpperCase()
        ),
        react_default.a.createElement(components_BreakLine, null),
        DAYS_OF_THE_WEEK.map(function (d) {
          return react_default.a.createElement(react_toolbox_lib["Checkbox"], {
            key: '' + storeId + period + d,
            checked: _this2.getDayTimeChecked(d, days),
            label: Object(lodash["capitalize"])(d),
            onChange: function onChange() {
              return _this2.handleAvailabilityChange(storeId, d, period);
            },
            className: form_default.a.checkboxListItem,
            theme: checkbox_default.a
          });
        }),
        react_default.a.createElement(components_BreakLine, null)
      );
    }
  });
  Object.defineProperty(this, 'renderAvailabilityDisplayName', {
    enumerable: true,
    writable: true,
    value: function value(availability) {
      var store = _this2.getStoreList().find(function (s) {
        return s.id === availability.store_id;
      });
      return store.name + ' - ' + store.number;
    }
  });
  Object.defineProperty(this, 'renderAvailabilityByStore', {
    enumerable: true,
    writable: true,
    value: function value(availabilities) {
      return react_default.a.createElement(
        react["Fragment"],
        null,
        (availabilities || []).length > 0 && _this2.filterStoreDisplay(availabilities).map(function (a) {
          return react_default.a.createElement(
            flexbox_react_dist_default.a,
            {
              key: a.store_id, flexWrap: 'wrap', className: form_default.a.divider
            },
            react_default.a.createElement(
              'h5',
              { className: form_default.a.cardTitle },
              _this2.renderAvailabilityDisplayName(a)
            ),
            react_default.a.createElement(components_BreakLine, null),
            _this2.renderByTimePeriodAndDay(a.store_id, 'morning', a.morning),
            _this2.renderByTimePeriodAndDay(a.store_id, 'afternoon', a.afternoon),
            _this2.renderByTimePeriodAndDay(a.store_id, 'evening', a.evening)
          );
        })
      );
    }
  });
  Object.defineProperty(this, 'render', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _state3 = _this2.state,
          estimator = _state3.estimator,
          assigneeAvailabilities = _state3.assigneeAvailabilities,
          invalidEmail = _state3.invalidEmail;
      var _props = _this2.props,
          role = _props.role,
          errors = _props.errors,
          allWorkrooms = _props.allWorkrooms,
          activeTab = _props.activeTab,
          onTabChange = _props.onTabChange,
          _props$position = _props.position,
          position = _props$position === undefined ? '' : _props$position,
          _props$mvw = _props.mvw,
          mvw = _props$mvw === undefined ? {} : _props$mvw;

      var isEdit = !!estimator.id;
      var gError = Object(utils["c" /* error */])('global', errors);
      var workroomOptions = Object(utils["j" /* generateSource */])(allWorkrooms);
      var tabErrors = _this2.tabErrors();
      var badge = estimator.badge || {};
      var hasIfiWorkrooms = _this2.getIfiWorkroomIds().length > 0;
      var canViewSupervisor = Object(services["a" /* can */])(role, 'view', 'SUPERVISOR_INFO', { position: position, mvw: mvw });
      var showSupervisorSelect = canViewSupervisor && hasIfiWorkrooms;
      var supervisorOptions = showSupervisorSelect ? _this2.getSupervisorOptions() : [];
      var supervisorValue = showSupervisorSelect ? _this2.getSupervisorValue(supervisorOptions) : null;
      return react_default.a.createElement(
        react_css_themr_lib["ThemeProvider"],
        { theme: estimatorForm_theme },
        react_default.a.createElement(
          components_Card,
          null,
          _this2.renderTitle(estimator, isEdit),
          gError ? react_default.a.createElement(MessageBox["a" /* default */], { error: true, message: gError }) : null,
          react_default.a.createElement(
            react_toolbox_lib["Tabs"],
            { index: activeTab, onChange: onTabChange, className: tabs_default.a.absoluteTabs },
            react_default.a.createElement(
              react_toolbox_lib["Tab"],
              {
                label: 'Basic Info',
                icon: tabErrors['Basic Info'] ? 'error' : '',
                className: '' + (tabErrors['Basic Info'] ? tabs_default.a.inError : '')
              },
              react_default.a.createElement(
                flexbox_react_dist_default.a,
                { flexWrap: 'wrap', className: form_default.a.divider },
                react_default.a.createElement(react_toolbox_lib["Input"], {
                  label: 'Name',
                  className: estimatorForm_largeInput,
                  value: estimator.name,
                  onChange: _this2.handleName,
                  error: Object(utils["c" /* error */])('user.name', errors),
                  required: true
                }),
                react_default.a.createElement(react_toolbox_lib["Input"], {
                  label: 'Street Address',
                  className: estimatorForm_largeInput,
                  value: estimator.address,
                  onChange: _this2.handleAddress,
                  error: Object(utils["c" /* error */])('address', errors),
                  required: true
                }),
                react_default.a.createElement(react_toolbox_lib["Input"], {
                  label: 'City',
                  className: estimatorForm_mediumInput,
                  value: estimator.city,
                  onChange: _this2.handleCity,
                  error: Object(utils["c" /* error */])('city', errors),
                  required: true
                }),
                react_default.a.createElement(components_StyledSelect, {
                  className: estimatorForm_largeInput,
                  label: 'State',
                  onChange: _this2.handleState,
                  options: STATES_SOURCE,
                  value: estimator.state,
                  placeholder: 'Select State',
                  error: Object(utils["c" /* error */])('state', errors),
                  required: true
                }),
                react_default.a.createElement(react_toolbox_lib["Input"], {
                  label: 'Zip Code',
                  className: estimatorForm_smallInput,
                  value: estimator.zip_code,
                  onChange: _this2.handleZipCode,
                  error: Object(utils["c" /* error */])('zip_code', errors),
                  required: true
                }),
                react_default.a.createElement(components_BreakLine, null),
                react_default.a.createElement(react_toolbox_lib["Input"], {
                  label: 'Email',
                  type: 'email',
                  value: estimator.email,
                  className: estimatorForm_largeInput,
                  onChange: _this2.handleEmail,
                  error: invalidEmail ? 'Invalid email address' : Object(utils["c" /* error */])('user.email', errors),
                  required: true
                }),
                react_default.a.createElement(
                  PhoneType_PhoneInput,
                  {
                    label: 'Primary Phone',
                    type: 'tel',
                    value: estimator.primary_phone,
                    className: estimatorForm_largeInput,
                    onChange: _this2.handlePrimaryPhone,
                    error: Object(utils["c" /* error */])('user.primary_phone', errors),
                    required: true
                  },
                  react_default.a.createElement(components_PhoneType, {
                    source: PHONE_TYPES,
                    value: estimator.primary_phone_type,
                    onChange: _this2.handlePrimaryType
                  })
                ),
                react_default.a.createElement(
                  PhoneType_PhoneInput,
                  {
                    label: 'Secondary Phone',
                    type: 'tel',
                    value: estimator.secondary_phone,
                    className: estimatorForm_largeInput,
                    onChange: _this2.handleSecondaryPhone,
                    error: Object(utils["c" /* error */])('user.secondary_phone', errors)
                  },
                  react_default.a.createElement(components_PhoneType, {
                    source: PHONE_TYPES,
                    value: estimator.secondary_phone_type,
                    onChange: _this2.handleSecondaryType
                  })
                ),
                react_default.a.createElement(react_select, {
                  className: estimatorForm_mediumInput,
                  label: 'Time Zone',
                  placeholder: 'Select Time Zone',
                  onChange: _this2.handleTimezone,
                  options: estimatorForm_TIMEZONE_SOURCE,
                  value: estimator.timezone,
                  error: Object(utils["c" /* error */])('timezone', errors),
                  required: true
                })
              ),
              react_default.a.createElement(
                flexbox_react_dist_default.a,
                { flexWrap: 'wrap', className: form_default.a.divider },
                react_default.a.createElement(react_toolbox_lib["Input"], {
                  label: 'Badge number',
                  className: estimatorForm_largeInput,
                  value: badge.number,
                  onChange: function onChange(v) {
                    return _this2.handleBadgeChange('number', v);
                  },
                  error: Object(utils["c" /* error */])('user.badge.number', errors),
                  required: true
                }),
                react_default.a.createElement(DatePicker, {
                  label: 'Badge expiration',
                  className: estimatorForm_largeInput,
                  value: badge.expiration,
                  onChange: function onChange(v) {
                    return _this2.handleBadgeChange('expiration', v);
                  },
                  error: Object(utils["c" /* error */])('user.badge.expiration', errors)
                }),
                react_default.a.createElement(react_toolbox_lib["Input"], {
                  label: 'Badge Link',
                  className: estimatorForm_largeInput,
                  value: badge.badge_link || '',
                  onChange: function onChange(v) {
                    return _this2.handleBadgeChange('badge_link', v);
                  },
                  error: Object(utils["c" /* error */])('badge_link', errors)
                }),
                react_default.a.createElement(DatePicker, {
                  label: 'Worker\'s comp. expiration',
                  className: estimatorForm_largeInput,
                  value: estimator.workers_comp_expiration,
                  onChange: _this2.handleWorkersExp,
                  error: Object(utils["c" /* error */])('workers_comp_expiration', errors)
                }),
                react_default.a.createElement(DatePicker, {
                  label: 'General liability insurance expiration',
                  className: estimatorForm_largeInput,
                  value: estimator.liability_insurance_expiration,
                  onChange: _this2.handleLiability,
                  error: Object(utils["c" /* error */])('liability_insurance_expiration', errors)
                }),
                react_default.a.createElement(DatePicker, {
                  label: 'LRRP training expiration',
                  className: estimatorForm_largeInput,
                  value: estimator.lrrp_training_expiration,
                  onChange: _this2.handleLrrpTraining,
                  error: Object(utils["c" /* error */])('lrrp_training_expiration', errors)
                }),
                react_default.a.createElement(DatePicker, {
                  label: 'Off Review Date',
                  className: estimatorForm_largeInput,
                  value: estimator.off_review_date,
                  onChange: _this2.handleOffReviewDate,
                  error: Object(utils["c" /* error */])('off_review_date', errors)
                }),
                react_default.a.createElement(react_toolbox_lib["Input"], {
                  label: 'Floorwizard id',
                  className: estimatorForm_largeInput,
                  value: estimator.floor_wizard_ident,
                  onChange: _this2.handleFloorWizard,
                  error: Object(utils["c" /* error */])('floor_wizard_ident', errors),
                  required: true
                }),
                react_default.a.createElement(DatePicker, {
                  label: 'Start Date',
                  className: estimatorForm_largeInput,
                  value: estimator.estimator_start_date,
                  onChange: _this2.handleStartDate,
                  error: Object(utils["c" /* error */])('estimator_start_date', errors)
                }),
                react_default.a.createElement(DatePicker, {
                  label: 'End Date',
                  className: estimatorForm_largeInput,
                  value: estimator.estimator_end_date,
                  onChange: _this2.handleEndDate,
                  error: Object(utils["c" /* error */])('estimator_end_date', errors)
                }),
                react_default.a.createElement(components_BreakLine, null),
                react_default.a.createElement(react_toolbox_lib["Checkbox"], {
                  checked: estimator.trusted,
                  label: 'Bypass Review, Send Assessments Directly to Store',
                  onChange: _this2.handleTrustedChange,
                  className: form_default.a.checkboxListItem,
                  theme: checkbox_default.a
                }),
                react_default.a.createElement(react_toolbox_lib["Checkbox"], {
                  checked: estimator.is_self_schedulable,
                  label: 'Self Schedulable',
                  onChange: _this2.handleSelfSchedulable,
                  className: form_default.a.checkboxListItem,
                  theme: checkbox_default.a
                }),
                react_default.a.createElement(react_toolbox_lib["Checkbox"], {
                  checked: estimator.spig_employee,
                  label: 'SPIG Employee',
                  onChange: _this2.handleSpigEmployeeChange,
                  className: form_default.a.checkboxListItem,
                  theme: checkbox_default.a
                })
              ),
              react_default.a.createElement(
                flexbox_react_dist_default.a,
                { flexWrap: 'wrap', className: form_default.a.divider },
                react_default.a.createElement(react_toolbox_lib["Input"], {
                  multiline: true,
                  label: 'Notes/Comments',
                  value: estimator.comments || '',
                  className: form_default.a.textArea,
                  error: Object(utils["c" /* error */])('comments', errors),
                  onChange: _this2.handleComments
                })
              ),
              react_default.a.createElement(
                flexbox_react_dist_default.a,
                { flexWrap: 'wrap', className: form_default.a.divider },
                react_default.a.createElement(components_StyledSelect, {
                  className: estimatorForm_mediumInput,
                  label: 'Morning Max Appts.',
                  onChange: _this2.handleMorningMax,
                  options: MAX_APPT_OPTIONS,
                  value: estimator.morning_max_appts,
                  placeholder: 'Select Max Appts.',
                  error: Object(utils["c" /* error */])('morning_max_appts', errors),
                  required: true
                }),
                react_default.a.createElement(components_StyledSelect, {
                  className: estimatorForm_mediumInput,
                  label: 'Afternoon Max Appts.',
                  onChange: _this2.handleAfternoonMax,
                  options: MAX_APPT_OPTIONS,
                  value: estimator.afternoon_max_appts,
                  placeholder: 'Select Max Appts.',
                  error: Object(utils["c" /* error */])('afternoon_max_appts', errors),
                  required: true
                }),
                react_default.a.createElement(components_StyledSelect, {
                  className: estimatorForm_mediumInput,
                  label: 'Evening Max Appts.',
                  onChange: _this2.handleEveningMax,
                  options: MAX_APPT_OPTIONS,
                  value: estimator.evening_max_appts,
                  placeholder: 'Select Max Appts.',
                  error: Object(utils["c" /* error */])('evening_max_appts', errors),
                  required: true
                })
              ),
              react_default.a.createElement(
                flexbox_react_dist_default.a,
                { flexWrap: 'wrap', className: form_default.a.divider },
                react_default.a.createElement(components_TaggedInput, {
                  label: 'Assign Zip Code(s) to Estimator',
                  id: 'covered_zip_codes',
                  values: _this2.sortEstimatorZips(estimator.covered_zip_codes),
                  onChange: _this2.handleCoveredZipCodes,
                  errors: errors.covered_zip_codes || []
                }),
                react_default.a.createElement(react_select, {
                  multi: true,
                  resetValue: [],
                  name: 'estimatorWorkrooms',
                  className: ReactSelect_styles_default.a.selectWrapper,
                  options: workroomOptions,
                  value: estimator.workrooms,
                  onChange: _this2.handleWorkrooms,
                  label: 'Assign workroom(s) to estimator',
                  placeholder: 'Select workroom(s)'
                }),
                showSupervisorSelect &&
                // "Supervisor" is labeled as "Coordinator" in the UI since
                // that's more familiar to IFI users, but the value is still
                // stored as "supervisor_id" in the backend.
                react_default.a.createElement(react_select, {
                  className: estimatorForm_largeInput,
                  label: 'Coordinator',
                  placeholder: 'Select Coordinator',
                  options: supervisorOptions,
                  value: supervisorValue,
                  onChange: _this2.handleSupervisorChange,
                  clearable: true,
                  isLoading: _this2.props.employeeLoading
                })
              ),
              assigneeAvailabilities.length > 0 && _this2.renderAvailabilityByStore(assigneeAvailabilities)
            ),
            Object(services["a" /* can */])(role, 'update', 'pay_rate') && react_default.a.createElement(
              react_toolbox_lib["Tab"],
              {
                label: 'Pay Rate',
                icon: tabErrors['Pay Rate'] ? 'error' : '',
                className: '' + (tabErrors['Pay Rate'] ? tabs_default.a.inError : '')
              },
              react_default.a.createElement(
                flexbox_react_dist_default.a,
                {
                  flexWrap: 'wrap',
                  className: form_default.a.divider,
                  style: { borderBottomWidth: 0 }
                },
                react_default.a.createElement(components_CurrencyInput, {
                  label: 'Per assessment rate',
                  className: currencyInput,
                  value: estimator.per_assessment_rate || '',
                  onChange: _this2.handlePerAssessmentRate,
                  error: Object(utils["c" /* error */])('per_assessment_rate', errors),
                  required: true
                }),
                react_default.a.createElement(components_CurrencyInput, {
                  label: 'Mileage rate',
                  className: currencyInput,
                  value: estimator.mileage_rate || '',
                  onChange: _this2.handleMileageRate,
                  error: Object(utils["c" /* error */])('mileage_rate', errors),
                  required: true
                })
              ),
              react_default.a.createElement(
                flexbox_react_dist_default.a,
                { flexWrap: 'wrap', className: form_default.a.divider },
                react_default.a.createElement(components_CurrencyInput, {
                  label: 'Trainee rate',
                  className: currencyInput,
                  value: estimator.trainee_rate || '',
                  onChange: _this2.handleTraineeRate,
                  error: Object(utils["c" /* error */])('trainee_rate', errors),
                  required: true
                }),
                react_default.a.createElement(components_CurrencyInput, {
                  label: 'Training bonus',
                  className: currencyInput,
                  value: estimator.training_bonus || '',
                  onChange: _this2.handleTrainingBonus,
                  error: Object(utils["c" /* error */])('training_bonus', errors),
                  required: true
                })
              )
            )
          ),
          react_default.a.createElement(
            flexbox_react_dist_default.a,
            { justifyContent: 'flex-end', flexWrap: 'wrap' },
            react_default.a.createElement(
              react_toolbox_lib["CardActions"],
              { className: form_default.a.actionsWrapper },
              react_default.a.createElement(ColoredButton["a" /* default */], {
                className: estimatorForm_cancelClass,
                responsive: true,
                color: 'gray',
                label: 'Cancel',
                onClick: _this2.handleCancel
              }),
              react_default.a.createElement(ColoredButton["a" /* default */], {
                className: form_default.a.actionButton,
                responsive: true,
                color: 'green',
                label: isEdit ? 'Save Changes' : 'Add estimator',
                onClick: _this2.handleSave,
                disabled: invalidEmail
              })
            )
          )
        )
      );
    }
  });
};

EstimatorForm.propTypes = {
  role: prop_types_default.a.string.isRequired,
  estimator: prop_types_default.a.object,
  onCancel: prop_types_default.a.func,
  onSave: prop_types_default.a.func,
  errors: prop_types_default.a.object,
  allWorkrooms: prop_types_default.a.array,
  employees: prop_types_default.a.array,
  employeeLoading: prop_types_default.a.bool,
  setEmployeeFilters: prop_types_default.a.func.isRequired,
  activeTab: prop_types_default.a.number,
  onTabChange: prop_types_default.a.func,
  handleRateHistory: prop_types_default.a.func,
  updateDiff: prop_types_default.a.func,
  position: prop_types_default.a.string,
  mvw: prop_types_default.a.object
};

var getEmployeeOptions = Object(reselect_lib["createSelector"])(reducers["m" /* getEmployeeList */], function (employees) {
  return employees || [];
});

var estimatorForm_mapStateToProps = function mapStateToProps(state) {
  return {
    employees: getEmployeeOptions(state),
    employeeLoading: Object(reducers["n" /* getEmployeeLoading */])(state)
  };
};

var estimatorForm_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setEmployeeFilters: function setEmployeeFilters(filters) {
      return dispatch(Object(actionCreators_employees["f" /* setEmployeeFilters */])(filters));
    }
  };
};

/* harmony default export */ var estimatorForm = (Object(react_redux_es["connect"])(estimatorForm_mapStateToProps, estimatorForm_mapDispatchToProps)(EstimatorForm));
// CONCATENATED MODULE: ./client/app/screens/main/screens/estimators/estimatorNew.jsx
function estimatorNew__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function estimatorNew__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function estimatorNew__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var estimatorNew_EstimatorNew = function (_Component) {
  estimatorNew__inherits(EstimatorNew, _Component);

  function EstimatorNew(props) {
    estimatorNew__classCallCheck(this, EstimatorNew);

    var _this = estimatorNew__possibleConstructorReturn(this, (EstimatorNew.__proto__ || Object.getPrototypeOf(EstimatorNew)).call(this, props));

    Object.defineProperty(_this, 'componentDidMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.listOfRequests([_this.props.requestWorkroomList(), _this.props.requestAllStores()]).then(function () {
          return _this.setState({ all_fetched: true });
        });
      }
    });
    Object.defineProperty(_this, 'componentWillUnmount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.clearValidationErrors('ESTIMATOR');
      }
    });
    Object.defineProperty(_this, 'handleSave', {
      enumerable: true,
      writable: true,
      value: function value(estimator) {
        return _this.props.createEstimator(estimator).then(function () {
          return _this.props.updateUI('successMessage', 'Estimator ' + estimator.user_attributes.name + ' has been created');
        });
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            errors = _this$props.errors,
            _this$props$allWorkro = _this$props.allWorkrooms,
            allWorkrooms = _this$props$allWorkro === undefined ? null : _this$props$allWorkro,
            ui = _this$props.ui,
            role = _this$props.role;

        var ready = _this.state.all_fetched && allWorkrooms;
        return ready ? react_default.a.createElement(estimatorForm, {
          errors: errors,
          onSave: _this.handleSave,
          onCancel: _this.handleCancel,
          allWorkrooms: allWorkrooms,
          activeTab: ui.activeTab,
          onTabChange: _this.handleTabChange,
          role: role,
          position: _this.props.position,
          mvw: _this.props.mvw
        }) : react_default.a.createElement(components_Loading, null);
      }
    });

    _this.handleSave = _this.handleSave.bind(_this);
    _this.handleCancel = function () {
      _this.props.navigate('/estimators');
    };
    _this.state = { all_fetched: false };
    _this.handleTabChange = function (index) {
      return _this.props.updateUI('activeTab', index);
    };
    return _this;
  }

  return EstimatorNew;
}(react["Component"]);

estimatorNew_EstimatorNew.propTypes = {
  navigate: prop_types_default.a.func,
  listOfRequests: prop_types_default.a.func,
  requestWorkroomList: prop_types_default.a.func,
  requestAllStores: prop_types_default.a.func,
  clearValidationErrors: prop_types_default.a.func,
  createEstimator: prop_types_default.a.func,
  updateUI: prop_types_default.a.func,
  allStores: prop_types_default.a.array,
  allWorkrooms: prop_types_default.a.array,
  errors: prop_types_default.a.object,
  ui: prop_types_default.a.object,
  role: prop_types_default.a.string,
  position: prop_types_default.a.string,
  mvw: prop_types_default.a.object
};

var estimatorNew_mapStateToProps = function mapStateToProps(state) {
  return {
    allWorkrooms: Object(reducers["_37" /* getWorkroomList */])(state),
    errors: Object(reducers["q" /* getEstimatorErrors */])(state) || {},
    role: Object(reducers["_12" /* getRole */])(state),
    position: Object(reducers["_8" /* getPosition */])(state),
    mvw: Object(reducers["N" /* getManageVendorWorkrooms */])(state)
  };
};

/* harmony default export */ var estimatorNew = (transpiled_default()()(Object(react_redux_es["connect"])(estimatorNew_mapStateToProps, {
  navigate: actionCreators["O" /* navigate */],
  createEstimator: actionCreators["o" /* createEstimator */],
  requestWorkroomList: actionCreators["_31" /* requestWorkroomList */],
  listOfRequests: actionCreators["F" /* listOfRequests */],
  clearValidationErrors: actionCreators["k" /* clearValidationErrors */],
  requestAllStores: actionCreators["U" /* requestAllStores */]
})(estimatorNew_EstimatorNew)));
// CONCATENATED MODULE: ./client/app/screens/main/screens/estimators/estimatorEdit.jsx
var estimatorEdit__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function estimatorEdit__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function estimatorEdit__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function estimatorEdit__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var estimatorEdit_EstimatorEdit = function (_Component) {
  estimatorEdit__inherits(EstimatorEdit, _Component);

  function EstimatorEdit(props) {
    estimatorEdit__classCallCheck(this, EstimatorEdit);

    var _this = estimatorEdit__possibleConstructorReturn(this, (EstimatorEdit.__proto__ || Object.getPrototypeOf(EstimatorEdit)).call(this, props));

    Object.defineProperty(_this, 'componentDidMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.props.updateUI('activeTab', 0);
        _this.props.listOfRequests([_this.props.requestEstimator(_this.props.id), _this.props.requestWorkroomList(), _this.props.requestAllStores()]).then(function () {
          return _this.setState({ all_fetched: true });
        });
      }
    });
    Object.defineProperty(_this, 'getAvailabilityChanges', {
      enumerable: true,
      writable: true,
      value: function value() {
        var oa = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var ca = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var oz = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        var cz = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
        var ow = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var cw = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var allStores = _this.props.allStores;

        var availabilityChanges = {};
        if (!oa && !ca) return availabilityChanges;
        /* eslint-disable no-nested-ternary */
        var store = oa ? allStores[oa.store_id] : ca ? allStores[ca.store_id] : null;
        var workroom = store.workroom_id,
            storeZips = store.covered_zip_codes;

        var number = store.number || null;
        var owHasStore = ow.includes(workroom);
        var cwHasStore = cw.includes(workroom);
        var ozHasZip = Object(lodash["intersection"])(storeZips, oz).length;
        var czHasZip = Object(lodash["intersection"])(storeZips, cz).length;
        if ((!ozHasZip || !owHasStore) && czHasZip && cwHasStore) availabilityChanges['Store ' + number + ' Availability'] = ['N/A', 'Added'];else if ((!czHasZip || !cwHasStore) && ozHasZip && owHasStore) availabilityChanges['Store ' + number + ' Availability'] = ['Added', 'N/A'];else if (owHasStore && cwHasStore && ozHasZip && czHasZip) {
          if (_this.didAvailabilityChange(oa, ca, 'morning')) {
            availabilityChanges['Store ' + number + '_morning'] = [oa ? oa.morning : [], ca ? ca.morning : []];
          }
          if (_this.didAvailabilityChange(oa, ca, 'afternoon')) {
            availabilityChanges['Store ' + number + '_afternoon'] = [oa ? oa.afternoon : [], ca ? ca.afternoon : []];
          }
          if (_this.didAvailabilityChange(oa, ca, 'evening')) {
            availabilityChanges['Store ' + number + '_evening'] = [oa ? oa.evening : [], ca ? ca.evening : []];
          }
        }
        return availabilityChanges;
      }
    });
    Object.defineProperty(_this, 'didAvailabilityChange', {
      enumerable: true,
      writable: true,
      value: function value(base, comparator, key) {
        return !base || !comparator || !Object(lodash["isEqual"])(base[key] || [], comparator[key] || []);
      }
    });
    Object.defineProperty(_this, 'updateEstimatorChanges', {
      enumerable: true,
      writable: true,
      value: function value(key, _value) {
        var newEstimatorChanges = Object.assign({}, _this.state.estimatorChanges);
        newEstimatorChanges[key] = _value;
        _this.setState({ estimatorChanges: newEstimatorChanges });
      }
    });
    Object.defineProperty(_this, 'handleKey', {
      enumerable: true,
      writable: true,
      value: function value(estimator, estimatorChanges, key) {
        var _this$props = _this.props,
            originalNumber = _this$props.originalNumber,
            originalExpiration = _this$props.originalExpiration,
            originalLink = _this$props.originalLink;

        var profileDiff = {};
        var oldVal = 'N/A';
        if (key.includes('badge_')) {
          if (key.includes('number')) oldVal = originalNumber;else if (key.includes('expiration')) oldVal = originalExpiration;else if (key.includes('link')) oldVal = originalLink;
        } else oldVal = key === 'workrooms' ? estimator.workrooms : estimator[key];
        var newVal = estimatorChanges[key];
        if (!Object(lodash["isEqual"])(oldVal, newVal)) profileDiff[key] = [oldVal, newVal];
        return profileDiff;
      }
    });
    Object.defineProperty(_this, 'createProfileDiff', {
      enumerable: true,
      writable: true,
      value: function value(_ref) {
        var _ref$availabilities = _ref.availabilities,
            changedAvailabilities = _ref$availabilities === undefined ? [] : _ref$availabilities,
            _ref$covered_zip_code = _ref.covered_zip_codes,
            changedZips = _ref$covered_zip_code === undefined ? [] : _ref$covered_zip_code,
            _ref$user_attributes$ = _ref.user_attributes.workroom_ids,
            changedWorkrooms = _ref$user_attributes$ === undefined ? [] : _ref$user_attributes$;
        var estimatorChanges = _this.state.estimatorChanges;
        var _this$props2 = _this.props,
            estimator = _this$props2.estimator,
            _this$props2$estimato = _this$props2.estimator,
            _this$props2$estimato2 = _this$props2$estimato.assignee_availabilities,
            oldAvailabilities = _this$props2$estimato2 === undefined ? [] : _this$props2$estimato2,
            _this$props2$estimato3 = _this$props2$estimato.covered_zip_codes,
            oldZips = _this$props2$estimato3 === undefined ? [] : _this$props2$estimato3,
            _this$props2$estimato4 = _this$props2$estimato.workrooms,
            oldWorkrooms = _this$props2$estimato4 === undefined ? [] : _this$props2$estimato4;

        var profileDiff = {};
        Object.keys(estimatorChanges).forEach(function (key) {
          Object.assign(profileDiff, _this.handleKey(estimator, estimatorChanges, key));
        });
        if (changedAvailabilities.length) {
          changedAvailabilities.forEach(function (ca) {
            var oldAvailability = oldAvailabilities.map(function (a) {
              return a.assignee_availability;
            }).find(function (oa) {
              return oa.store_id === ca.store_id;
            });
            var changes = _this.getAvailabilityChanges(oldAvailability, ca, oldZips, changedZips, oldWorkrooms, changedWorkrooms);
            if (!Object(lodash["isEmpty"])(changes)) profileDiff = estimatorEdit__extends({}, profileDiff, changes);
          });
        }
        return profileDiff;
      }
    });
    Object.defineProperty(_this, 'handleSave', {
      enumerable: true,
      writable: true,
      value: function value(estimator) {
        var profileDiff = _this.createProfileDiff(estimator);
        var eventProps = {
          name: 'Update Profile',
          kind: 'update_profile',
          data: { updates: profileDiff }
        };
        _this.props.updateEstimator(estimator).then(function () {
          return !Object(lodash["isEmpty"])(profileDiff) ? _this.props.addEventToEstimator(estimator.id, eventProps) : null;
        }).then(function () {
          return _this.props.updateUI('successMessage', 'Changes have been saved');
        });
      }
    });
    Object.defineProperty(_this, 'showRateHistory', {
      enumerable: true,
      writable: true,
      value: function value(rate) {
        return Promise.all([_this.props.showHistoryScreen(rate), _this.props.requestPayRatesList(_this.props.id, rate)]);
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props3 = _this.props,
            errors = _this$props3.errors,
            estimator = _this$props3.estimator,
            loading = _this$props3.loading,
            allWorkrooms = _this$props3.allWorkrooms,
            ui = _this$props3.ui,
            role = _this$props3.role,
            originalNumber = _this$props3.originalNumber,
            originalExpiration = _this$props3.originalExpiration,
            originalLink = _this$props3.originalLink,
            showHistory = _this$props3.showHistory,
            rateName = _this$props3.rateName,
            loadingRateHistory = _this$props3.loadingRateHistory,
            payRates = _this$props3.payRates;

        var ready = _this.state.all_fetched && allWorkrooms !== null && allWorkrooms !== undefined;
        return loading || !ready ? react_default.a.createElement(components_Loading, null) : react_default.a.createElement(
          'div',
          null,
          react_default.a.createElement(estimatorForm, {
            errors: errors,
            onSave: _this.handleSave,
            onCancel: _this.handleCancel,
            updateDiff: _this.updateEstimatorChanges,
            estimator: estimator,
            allWorkrooms: allWorkrooms,
            activeTab: ui.activeTab,
            onTabChange: _this.handleTabChange,
            handleRateHistory: _this.showRateHistory,
            originalNumber: originalNumber,
            originalExpiration: originalExpiration,
            originalLink: originalLink,
            role: role,
            position: _this.props.position,
            mvw: _this.props.mvw
          }),
          react_default.a.createElement(components_PayRateHistory, {
            showHistory: showHistory,
            rateName: rateName,
            closeHistory: _this.closeRateHistory,
            loading: loadingRateHistory,
            payRates: payRates
          })
        );
      }
    });

    _this.handleSave = _this.handleSave.bind(_this);
    _this.updateEstimatorChanges = _this.updateEstimatorChanges.bind(_this);
    _this.handleCancel = function () {
      return _this.props.navigateBack();
    };
    _this.handleTabChange = function (index) {
      return _this.props.updateUI('activeTab', index);
    };
    _this.closeRateHistory = function () {
      return _this.props.hideHistoryScreen();
    };
    _this.showRateHistory = _this.showRateHistory.bind(_this);
    _this.state = { all_fetched: false, estimatorChanges: {} };
    return _this;
  }

  return EstimatorEdit;
}(react["Component"]);

estimatorEdit_EstimatorEdit.propTypes = {
  estimator: prop_types_default.a.object.isRequired,
  loading: prop_types_default.a.bool,
  navigateBack: prop_types_default.a.func,
  listOfRequests: prop_types_default.a.func,
  requestWorkroomList: prop_types_default.a.func,
  requestAllStores: prop_types_default.a.func,
  requestEstimator: prop_types_default.a.func,
  updateEstimator: prop_types_default.a.func,
  addEventToEstimator: prop_types_default.a.func,
  updateUI: prop_types_default.a.func,
  allWorkrooms: prop_types_default.a.array,
  errors: prop_types_default.a.object,
  ui: prop_types_default.a.object,
  id: prop_types_default.a.number,
  showHistory: prop_types_default.a.bool,
  loadingRateHistory: prop_types_default.a.bool,
  rateName: prop_types_default.a.string,
  payRates: prop_types_default.a.array,
  showHistoryScreen: prop_types_default.a.func,
  requestPayRatesList: prop_types_default.a.func,
  hideHistoryScreen: prop_types_default.a.func,
  role: prop_types_default.a.string,
  allStores: prop_types_default.a.object,
  originalNumber: prop_types_default.a.string,
  originalExpiration: prop_types_default.a.string,
  originalLink: prop_types_default.a.string,
  position: prop_types_default.a.string,
  mvw: prop_types_default.a.object
};

var estimatorEdit_mapStateToProps = function mapStateToProps(state, ownProps) {
  var id = Number(ownProps.params.id);
  var estimator = Object(reducers["p" /* getEstimatorById */])(state)(id) || {};
  var loading = !estimator || estimator.loading;
  var _estimator$badge = estimator.badge,
      badge = _estimator$badge === undefined ? null : _estimator$badge;

  var setBadge = badge || {};
  return {
    id: id,
    loading: loading,
    estimator: estimator,
    allWorkrooms: Object(reducers["_37" /* getWorkroomList */])(state),
    errors: Object(reducers["q" /* getEstimatorErrors */])(state) || {},
    showHistory: Object(reducers["S" /* getPayRateShowHistory */])(state),
    loadingRateHistory: Object(reducers["R" /* getPayRateLoading */])(state),
    rateName: Object(reducers["Q" /* getPayRateCurrentName */])(state),
    payRates: Object(reducers["P" /* getPayRateCurrentHistoryList */])(state),
    role: Object(reducers["_12" /* getRole */])(state),
    position: Object(reducers["_8" /* getPosition */])(state),
    mvw: Object(reducers["N" /* getManageVendorWorkrooms */])(state),
    allStores: state.stores.byId,
    originalNumber: setBadge.number || 'N/A',
    originalExpiration: setBadge.expiration || 'N/A',
    originalLink: setBadge.badge_link || 'N/A'
  };
};

/* harmony default export */ var estimatorEdit = (transpiled_default()()(Object(react_redux_es["connect"])(estimatorEdit_mapStateToProps, {
  navigateBack: actionCreators["P" /* navigateBack */],
  updateEstimator: actionCreators["_62" /* updateEstimator */],
  requestEstimator: actionCreators["Z" /* requestEstimator */],
  listOfRequests: actionCreators["F" /* listOfRequests */],
  requestWorkroomList: actionCreators["_31" /* requestWorkroomList */],
  showHistoryScreen: actionCreators["_53" /* showHistoryScreen */],
  requestPayRatesList: actionCreators["_14" /* requestPayRatesList */],
  hideHistoryScreen: actionCreators["C" /* hideHistoryScreen */],
  addEventToEstimator: actionCreators["b" /* addEventToEstimator */],
  requestAllStores: actionCreators["U" /* requestAllStores */]
})(estimatorEdit_EstimatorEdit)));
// CONCATENATED MODULE: ./client/app/screens/main/screens/estimators/index.jsx
var estimators__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function estimators__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function estimators__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function estimators__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var estimators_searchText = 'Search for an estimator';

var estimators_Estimators = function (_Component) {
  estimators__inherits(Estimators, _Component);

  function Estimators(props) {
    estimators__classCallCheck(this, Estimators);

    var _this = estimators__possibleConstructorReturn(this, (Estimators.__proto__ || Object.getPrototypeOf(Estimators)).call(this, props));

    Object.defineProperty(_this, 'onSearch', {
      enumerable: true,
      writable: true,
      value: function value(e, _value) {
        e.preventDefault();
        var filters = estimators__extends({}, _this.props.filters);
        filters.query = _value;
        _this.handleFilterChange(filters);
      }
    });
    Object.defineProperty(_this, 'addAction', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.navigate('/estimators/new');
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            children = _this$props.children,
            role = _this$props.role,
            filters = _this$props.filters;

        return react_default.a.createElement(
          'div',
          null,
          react_default.a.createElement(components_PageActionBar, {
            hidesAddOnMobile: true,
            resource: 'estimator',
            role: role,
            addAction: _this.addAction,
            showFiltersBtn: _this.isIndexRoute(),
            title: 'Estimator Management',
            searchText: estimators_searchText + '...',
            toggleFilters: _this.toggleFilterDrawer,
            onSearch: _this.onSearch,
            path: _this.props.location.pathname
          }),
          react_default.a.createElement(
            'div',
            { className: contentArea_default.a.contentAreaContainer },
            children,
            react_default.a.createElement(Filters_UserFilters, {
              active: _this.state.showFilterDrawer,
              onOverlayClick: _this.toggleFilterDrawer,
              handleFilterChange: _this.handleFilterChange,
              filters: filters,
              title: 'Estimators',
              reset: _this.props.resetEstimatorFilters,
              role: _this.props.role,
              resource: 'estimator'
            })
          )
        );
      }
    });

    _this.addAction = _this.addAction.bind(_this);
    _this.state = { showFilterDrawer: false };
    _this.toggleFilterDrawer = function () {
      return _this.setState({
        showFilterDrawer: !_this.state.showFilterDrawer });
    };
    _this.handleFilterChange = function (filters) {
      return _this.props.setEstimatorFilters(filters);
    };
    _this.isIndexRoute = function () {
      return _this.props.location.pathname === _this.props.route.path;
    };
    return _this;
  }

  return Estimators;
}(react["Component"]);

estimators_Estimators.propTypes = {
  setEstimatorFilters: prop_types_default.a.func.isRequired,
  navigate: prop_types_default.a.func,
  location: prop_types_default.a.object,
  route: prop_types_default.a.object,
  role: prop_types_default.a.string,
  children: prop_types_default.a.oneOfType([prop_types_default.a.object, prop_types_default.a.array]),
  filters: prop_types_default.a.object,
  resetEstimatorFilters: prop_types_default.a.func.isRequired
};

var estimators_mapStateToProps = function mapStateToProps(state) {
  return { role: Object(reducers["_12" /* getRole */])(state), filters: Object(reducers["r" /* getEstimatorFilters */])(state) };
};

/* harmony default export */ var screens_estimators = (transpiled_default()({
  key: 'estimators', state: { successMessage: '', activeTab: 0 }
})(Object(react_redux_es["connect"])(estimators_mapStateToProps, {
  navigate: actionCreators["O" /* navigate */], setEstimatorFilters: actionCreators["_47" /* setEstimatorFilters */], resetEstimatorFilters: actionCreators["_34" /* resetEstimatorFilters */]
})(estimators_Estimators)));


// CONCATENATED MODULE: ./client/app/shared/types/iqm.js


var IQMType = prop_types_default.a.shape({
  id: prop_types_default.a.number.isRequired,
  email: prop_types_default.a.string.isRequired,
  name: prop_types_default.a.string.isRequired,
  picture_url: prop_types_default.a.string,
  position: prop_types_default.a.string,
  primary_phone: prop_types_default.a.string,
  primary_phone_type: prop_types_default.a.string,
  surface_type: prop_types_default.a.string,
  active: prop_types_default.a.bool.isRequired,
  pending: prop_types_default.a.bool,
  workrooms: prop_types_default.a.arrayOf(prop_types_default.a.shape({
    id: prop_types_default.a.number,
    name: prop_types_default.a.string
  })).isRequired
});

/* harmony default export */ var types_iqm = (IQMType);
// CONCATENATED MODULE: ./client/app/screens/main/screens/iqms/components/IQMCard.jsx






var IQMCard_IQMCard = function IQMCard(_ref) {
  var iqm = _ref.iqm;
  return react_default.a.createElement(
    users_UserCard,
    { user: iqm, type: 'iqms' },
    react_default.a.createElement(ResourceCardElement, {
      title: 'Workroom(s)',
      size: 'small',
      value: Object(utils["A" /* stringifyList */])(iqm.workrooms) || 'No Workroom'
    }),
    react_default.a.createElement(ResourceCardElement, {
      title: 'Surface Type(s)',
      size: 'small',
      value: Object(utils["A" /* stringifyList */])(iqm.surface_types) || 'No Surface Type'
    })
  );
};

IQMCard_IQMCard.propTypes = {
  iqm: types_iqm.isRequired
};

/* harmony default export */ var components_IQMCard = (IQMCard_IQMCard);
// CONCATENATED MODULE: ./client/app/screens/main/screens/iqms/IQMList.jsx
var IQMList__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function IQMList__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function IQMList__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function IQMList__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var IQMList_IQMList = function (_Component) {
  IQMList__inherits(IQMList, _Component);

  function IQMList() {
    var _ref;

    var _temp, _this, _ret;

    IQMList__classCallCheck(this, IQMList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = IQMList__possibleConstructorReturn(this, (_ref = IQMList.__proto__ || Object.getPrototypeOf(IQMList)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'handleInfiniteLoad', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.needsMore && !_this.props.loading ? _this.props.requestIQMList() : null;
      }
    }), _temp), IQMList__possibleConstructorReturn(_this, _ret);
  }

  IQMList__createClass(IQMList, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.requestIQMList();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.ui.successMessage) {
        this.props.updateUI('successMessage', '');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          iqms = _props.iqms,
          role = _props.role,
          needsMore = _props.needsMore,
          loading = _props.loading;


      return react_default.a.createElement(
        'div',
        null,
        this.props.ui.successMessage ? react_default.a.createElement(MessageBox["a" /* default */], { message: this.props.ui.successMessage }) : null,
        react_default.a.createElement(
          components_ListView,
          {
            loading: loading,
            needsMore: needsMore,
            handleInfiniteLoad: this.handleInfiniteLoad
          },
          iqms.map(function (iqm) {
            return react_default.a.createElement(components_IQMCard, {
              key: 'iqm-' + iqm.id,
              role: role,
              iqm: iqm
            });
          })
        )
      );
    }
  }]);

  return IQMList;
}(react["Component"]);

Object.defineProperty(IQMList_IQMList, 'propTypes', {
  enumerable: true,
  writable: true,
  value: {
    ui: prop_types_default.a.shape({
      successMessage: prop_types_default.a.string
    }),
    updateUI: prop_types_default.a.func.isRequired,
    needsMore: prop_types_default.a.bool,
    loading: prop_types_default.a.bool,
    iqms: prop_types_default.a.arrayOf(types_iqm).isRequired,
    role: prop_types_default.a.string,
    requestIQMList: prop_types_default.a.func.isRequired
  }
});


var IQMList_mapStateToProps = function mapStateToProps(state) {
  return {
    iqms: Object(reducers["K" /* getIqmsList */])(state),
    needsMore: Object(reducers["J" /* getIqmsHasNextPage */])(state),
    loading: Object(reducers["L" /* getIqmsLoading */])(state),
    role: Object(reducers["_12" /* getRole */])(state)
  };
};

/* harmony default export */ var iqms_IQMList = (transpiled_default()()(Object(react_redux_es["connect"])(IQMList_mapStateToProps, { requestIQMList: actionCreators["_4" /* requestIQMList */] })(IQMList_IQMList)));
// CONCATENATED MODULE: ./client/app/screens/main/screens/iqms/components/IQMDetailsCard.jsx
var IQMDetailsCard__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function IQMDetailsCard__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function IQMDetailsCard__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function IQMDetailsCard__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





















var IQMDetailsCard_detailsTheme = {
  RTTabs: tabs_default.a
};

var TIME_OFF_TAB = 1;

var IQMDetailsCard_IQMDetailsCard = function (_React$Component) {
  IQMDetailsCard__inherits(IQMDetailsCard, _React$Component);

  function IQMDetailsCard(props) {
    IQMDetailsCard__classCallCheck(this, IQMDetailsCard);

    var _this = IQMDetailsCard__possibleConstructorReturn(this, (IQMDetailsCard.__proto__ || Object.getPrototypeOf(IQMDetailsCard)).call(this, props));

    Object.defineProperty(_this, 'handleEditToggle', {
      enumerable: true,
      writable: true,
      value: function value() {
        var isEditable = !_this.state.isEditable;
        _this.setState({ isEditable: isEditable });
      }
    });
    Object.defineProperty(_this, 'renderTimeOffEditButton', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            role = _this$props.role,
            user = _this$props.user,
            iqm = _this$props.iqm;

        if (!Object(services["a" /* can */])(role, 'manage', 'pto', { user_id: user.id, obj_id: iqm.user_id })) return null;

        var isEditable = _this.state.isEditable;

        return react_default.a.createElement(editToggleButton, { actionLabel: 'Edit Time Off', isEditable: isEditable, onClick: _this.handleEditToggle });
      }
    });

    _this.state = { isEditable: false };
    return _this;
  }

  IQMDetailsCard__createClass(IQMDetailsCard, [{
    key: 'render',
    value: function render() {
      var isEditable = this.state.isEditable;
      var _props = this.props,
          iqm = _props.iqm,
          role = _props.role,
          ptos = _props.ptos,
          activeTab = _props.activeTab,
          onTabChange = _props.onTabChange;


      var userProps = {
        user: iqm,
        type: 'iqms',
        role: role,
        resource: 'iqm',
        editHandler: activeTab === TIME_OFF_TAB ? this.renderTimeOffEditButton() : null
      };

      return react_default.a.createElement(
        react_css_themr_lib["ThemeProvider"],
        { theme: IQMDetailsCard_detailsTheme },
        react_default.a.createElement(
          users_UserDetailsCard,
          userProps,
          react_default.a.createElement(
            react_toolbox_lib["Tabs"],
            { index: activeTab, onChange: onTabChange, className: tabs_default.a.absoluteTabs },
            react_default.a.createElement(
              react_toolbox_lib["Tab"],
              { label: 'Basic Info' },
              react_default.a.createElement(users_UserDetailsBasicInfo, { user: iqm, leadCertField: true, canDeliverField: true }),
              react_default.a.createElement(users_UserDetailsBadgeInfo, { user: iqm }),
              react_default.a.createElement(
                users_UserDetailsRow,
                { title: 'IQM Details' },
                react_default.a.createElement(users_UserDetailsElement, { title: 'Workroom(s)', value: Object(utils["A" /* stringifyList */])(iqm.workrooms) }),
                react_default.a.createElement(users_UserDetailsElement, {
                  title: 'Surface Types',
                  value: Object(utils["A" /* stringifyList */])(iqm.surface_types)
                })
              )
            ),
            react_default.a.createElement(
              react_toolbox_lib["Tab"],
              { label: 'Time Off' },
              react_default.a.createElement(components_TimeOffTable, { isEditable: isEditable, ptos: ptos, parentID: iqm.id, parentKind: 'iqms' })
            )
          )
        )
      );
    }
  }]);

  return IQMDetailsCard;
}(react_default.a.Component);

IQMDetailsCard_IQMDetailsCard.propTypes = {
  iqm: types_iqm.isRequired,
  role: prop_types_default.a.string,
  ptos: prop_types_default.a.arrayOf(types_pto),
  activeTab: prop_types_default.a.number,
  onTabChange: prop_types_default.a.func,
  user: RoleType
};

/* harmony default export */ var components_IQMDetailsCard = (IQMDetailsCard_IQMDetailsCard);
// CONCATENATED MODULE: ./client/app/screens/main/screens/iqms/IQMDetails.jsx
var IQMDetails__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function IQMDetails__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function IQMDetails__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function IQMDetails__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var IQMDetails_IQMDetails = function (_Component) {
  IQMDetails__inherits(IQMDetails, _Component);

  function IQMDetails() {
    var _ref;

    var _temp, _this, _ret;

    IQMDetails__classCallCheck(this, IQMDetails);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = IQMDetails__possibleConstructorReturn(this, (_ref = IQMDetails.__proto__ || Object.getPrototypeOf(IQMDetails)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'handleTabChange', {
      enumerable: true,
      writable: true,
      value: function value(index) {
        _this.props.updateUI('activeTab', index);
      }
    }), _temp), IQMDetails__possibleConstructorReturn(_this, _ret);
  }

  IQMDetails__createClass(IQMDetails, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.props.iqm) {
        this.props.requestIQM(this.props.id);
      }

      this.props.requestPTOList(this.props.id, 'iqms');
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.ui.successMessage) {
        this.props.updateUI('successMessage', '');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          iqm = _props.iqm,
          loading = _props.loading,
          ui = _props.ui,
          role = _props.role,
          ptos = _props.ptos,
          user = _props.user;


      var iqmCard = react_default.a.createElement(components_IQMDetailsCard, {
        iqm: iqm,
        role: role,
        ptos: ptos,
        activeTab: ui.activeTab,
        onTabChange: this.handleTabChange,
        user: user
      });

      var container = !loading ? iqmCard : react_default.a.createElement(
        'p',
        null,
        'Loading...'
      );

      return react_default.a.createElement(
        'div',
        null,
        ui.successMessage ? react_default.a.createElement(MessageBox["a" /* default */], { message: ui.successMessage }) : null,
        container
      );
    }
  }]);

  return IQMDetails;
}(react["Component"]);

Object.defineProperty(IQMDetails_IQMDetails, 'propTypes', {
  enumerable: true,
  writable: true,
  value: {
    updateUI: prop_types_default.a.func,
    requestIQM: prop_types_default.a.func,
    requestPTOList: prop_types_default.a.func,
    iqm: types_iqm,
    loading: prop_types_default.a.bool,
    ui: prop_types_default.a.object,
    role: prop_types_default.a.string,
    id: prop_types_default.a.number,
    ptos: prop_types_default.a.arrayOf(types_pto),
    user: RoleType
  }
});


var IQMDetails_mapStateToProps = function mapStateToProps(state, ownProps) {
  var id = Number(ownProps.params.id);
  var iqm = state.iqms.details.id === id ? state.iqms.details : null;
  return {
    id: id,
    iqm: iqm,
    loading: !iqm || state.iqms.common.loading,
    role: Object(reducers["_12" /* getRole */])(state),
    ptos: state.ptos.data,
    user: state.user
  };
};

/* harmony default export */ var iqms_IQMDetails = (transpiled_default()()(Object(react_redux_es["connect"])(IQMDetails_mapStateToProps, { requestIQM: actionCreators["_3" /* requestIQM */], requestPTOList: actionCreators["_13" /* requestPTOList */] })(IQMDetails_IQMDetails)));
// CONCATENATED MODULE: ./client/app/shared/components/users/UserForm/index.jsx
var UserForm__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var UserForm__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var UserForm__cx;

function UserForm__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function UserForm__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function UserForm__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function UserForm__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function UserForm__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }























var UserForm_theme = { RTInput: input_default.a, RTDropdown: dropdown_default.a, RTCard: styles_card_default.a, RTSwitch: switch_default.a };

var UserForm_mediumInput = classnames_default()((UserForm__cx = {}, UserForm__defineProperty(UserForm__cx, form_default.a.inputs, true), UserForm__defineProperty(UserForm__cx, form_default.a.largeInput, true), UserForm__cx));

var UserForm_TIMEZONE_SOURCE = constants["_46" /* TIMEZONES */].map(function (tz) {
  return { value: tz, label: tz };
});

var UserForm_UserForm = function (_Component) {
  UserForm__inherits(UserForm, _Component);

  function UserForm(props) {
    UserForm__classCallCheck(this, UserForm);

    var _this = UserForm__possibleConstructorReturn(this, (UserForm.__proto__ || Object.getPrototypeOf(UserForm)).call(this, props));

    UserForm__initialiseProps.call(_this);

    _this.handlePrimaryType = _this.handleChange.bind(_this, 'primary_phone_type');
    _this.handleSecondaryType = _this.handleChange.bind(_this, 'secondary_phone_type');
    _this.handleName = _this.handleChange.bind(_this, 'name');
    _this.handleEmail = _this.handleChange.bind(_this, 'email');
    _this.handleSecondaryPhone = _this.handleChange.bind(_this, 'secondary_phone');
    _this.handleLeadCertNumber = _this.handleChange.bind(_this, 'lead_cert_number');
    _this.handlePrimaryPhone = _this.handleChange.bind(_this, 'primary_phone');
    _this.handleBadgeNumber = _this.handleBadgeChange.bind(_this, 'number');
    _this.handleBadgeExpiration = _this.handleBadgeChange.bind(_this, 'expiration');
    _this.handleSelectChange = function (key, value) {
      return _this.handleChange(key, value.map(function (v) {
        return v.value;
      }));
    };
    _this.handleWorkrooms = _this.handleSelectChange.bind(_this, 'workroom_ids');

    var user = _this.props.user;

    _this.state = {
      user: user && UserForm__extends({}, props.user) || {
        active: true,
        primary_phone_type: 'mobile',
        secondary_phone_type: 'mobile',
        badge: {}
      }
    };
    return _this;
  }

  UserForm__createClass(UserForm, [{
    key: 'onChange',
    value: function onChange(user) {
      this.setState({ user: user });

      var _state$user = this.state.user,
          badge = _state$user.badge,
          userAttributes = UserForm__objectWithoutProperties(_state$user, ['badge']);

      var newBadge = badge || {};

      var expiration = newBadge.expiration,
          otherBadgeThings = UserForm__objectWithoutProperties(newBadge, ['expiration']);

      this.props.onChange(UserForm__extends({}, userAttributes, {
        id: user.user_id,
        badge_attributes: UserForm__extends({}, otherBadgeThings, {
          expiration: Object(dateUtils["o" /* handleDateSave */])(expiration)
        })
      }));
    }
  }, {
    key: 'handleChange',
    value: function handleChange(key, value) {
      var user = this.state.user;

      user[key] = key === 'email' ? value.replaceAll(' ', '') : value;
      this.onChange(user);
    }
  }, {
    key: 'handleBadgeChange',
    value: function handleBadgeChange(key, value) {
      var user = this.state.user;

      user.badge = user.badge || {};
      user.badge[key] = value;
      this.onChange(user);
    }
  }, {
    key: 'render',
    value: function render() {
      var user = this.state.user;
      var _props = this.props,
          errors = _props.errors,
          children = _props.children,
          leadCertField = _props.leadCertField;

      var badge = user.badge || {};

      return react_default.a.createElement(
        react_css_themr_lib["ThemeProvider"],
        { theme: UserForm_theme },
        react_default.a.createElement(
          'div',
          null,
          react_default.a.createElement(
            flexbox_react_dist_default.a,
            { flexWrap: 'wrap', className: form_default.a.divider },
            react_default.a.createElement(react_toolbox_lib["Input"], {
              label: 'Name',
              className: UserForm_mediumInput,
              value: user.name,
              onChange: this.handleName,
              error: Object(utils["c" /* error */])('user.name', errors),
              required: true
            }),
            children
          ),
          react_default.a.createElement(
            flexbox_react_dist_default.a,
            { flexWrap: 'wrap', className: form_default.a.divider },
            react_default.a.createElement(react_toolbox_lib["Input"], {
              label: 'Email',
              type: 'email',
              value: user.email,
              className: UserForm_mediumInput,
              onChange: this.handleEmail,
              error: Object(utils["c" /* error */])('user.email', errors),
              required: true
            }),
            react_default.a.createElement(
              PhoneType_PhoneInput,
              {
                label: 'Primary Phone',
                type: 'tel',
                value: user.primary_phone,
                className: UserForm_mediumInput,
                onChange: this.handlePrimaryPhone,
                error: Object(utils["c" /* error */])('user.primary_phone', errors),
                required: true
              },
              react_default.a.createElement(components_PhoneType, { value: user.primary_phone_type, onChange: this.handlePrimaryType })
            ),
            react_default.a.createElement(
              PhoneType_PhoneInput,
              {
                label: 'Secondary Phone',
                type: 'tel',
                value: user.secondary_phone,
                className: UserForm_mediumInput,
                onChange: this.handleSecondaryPhone,
                error: Object(utils["c" /* error */])('user.secondary_phone', errors)
              },
              react_default.a.createElement(components_PhoneType, {
                value: user.secondary_phone_type,
                onChange: this.handleSecondaryType
              })
            ),
            react_default.a.createElement(react_select, {
              className: UserForm_mediumInput,
              label: 'Time Zone',
              placeholder: 'Select Time Zone',
              onChange: this.handleTimezone,
              options: UserForm_TIMEZONE_SOURCE,
              value: user.timezone,
              error: Object(utils["c" /* error */])('timezone', errors),
              required: true
            }),
            leadCertField && react_default.a.createElement(react_toolbox_lib["Input"], {
              label: 'Lead Cert Number',
              value: user.lead_cert_number,
              className: UserForm_mediumInput,
              onChange: this.handleLeadCertNumber,
              error: Object(utils["c" /* error */])('user.lead_cert_number', errors)
            })
          ),
          react_default.a.createElement(
            flexbox_react_dist_default.a,
            { flexWrap: 'wrap', className: form_default.a.divider },
            react_default.a.createElement(react_toolbox_lib["Input"], {
              label: 'Badge number',
              className: UserForm_mediumInput,
              value: badge.number,
              onChange: this.handleBadgeNumber,
              error: Object(utils["c" /* error */])('user.badge.number', errors)
            }),
            react_default.a.createElement(DatePicker, {
              label: 'Badge expiration',
              className: UserForm_mediumInput,
              value: badge.expiration,
              onChange: this.handleBadgeExpiration,
              error: Object(utils["c" /* error */])('user.badge.expiration', errors)
            })
          ),
          react_default.a.createElement(
            flexbox_react_dist_default.a,
            { flexWrap: 'wrap', className: form_default.a.divider },
            react_default.a.createElement(formElements_WorkroomSelect, {
              value: user.workroom_ids,
              onChange: this.handleWorkrooms,
              placeholder: 'Select workroom(s)',
              className: ReactSelect_styles_default.a.selectWrapper
            })
          )
        )
      );
    }
  }]);

  return UserForm;
}(react["Component"]);

Object.defineProperty(UserForm_UserForm, 'propTypes', {
  enumerable: true,
  writable: true,
  value: {
    errors: prop_types_default.a.object,
    user: types_user,
    onChange: prop_types_default.a.func,
    children: prop_types_default.a.node,
    leadCertField: prop_types_default.a.bool
  }
});
Object.defineProperty(UserForm_UserForm, 'defaultProps', {
  enumerable: true,
  writable: true,
  value: { leadCertField: false }
});

var UserForm__initialiseProps = function _initialiseProps() {
  var _this2 = this;

  Object.defineProperty(this, 'handleTimezone', {
    enumerable: true,
    writable: true,
    value: function value(option) {
      var user = _this2.state.user;
      user.timezone = option.value;
      _this2.onChange(user);
    }
  });
};

/* harmony default export */ var users_UserForm = (UserForm_UserForm);
// EXTERNAL MODULE: ./client/app/shared/components/formElements/SurfaceTypesCheckbox/styles.scss
var SurfaceTypesCheckbox_styles = __webpack_require__("KWoV");
var SurfaceTypesCheckbox_styles_default = /*#__PURE__*/__webpack_require__.n(SurfaceTypesCheckbox_styles);

// CONCATENATED MODULE: ./client/app/shared/components/formElements/SurfaceTypesCheckbox/index.jsx
var SurfaceTypesCheckbox__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function SurfaceTypesCheckbox__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SurfaceTypesCheckbox__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function SurfaceTypesCheckbox__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var SurfaceTypesCheckbox_SurfaceTypesCheckbox = function (_React$Component) {
  SurfaceTypesCheckbox__inherits(SurfaceTypesCheckbox, _React$Component);

  function SurfaceTypesCheckbox() {
    var _ref;

    var _temp, _this, _ret;

    SurfaceTypesCheckbox__classCallCheck(this, SurfaceTypesCheckbox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = SurfaceTypesCheckbox__possibleConstructorReturn(this, (_ref = SurfaceTypesCheckbox.__proto__ || Object.getPrototypeOf(SurfaceTypesCheckbox)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'isChecked', {
      enumerable: true,
      writable: true,
      value: function value(st) {
        return _this.props.selectedSurfaceTypes.indexOf(st.id) > -1;
      }
    }), Object.defineProperty(_this, 'renderSurfaceType', {
      enumerable: true,
      writable: true,
      value: function value(st) {
        var _onChange = _this.props.onChange;


        return react_default.a.createElement(react_toolbox_lib["Checkbox"], {
          key: st.id,
          checked: _this.isChecked(st),
          label: st.name,
          theme: checkbox_default.a,
          className: form_default.a.checkboxListItem,
          onChange: function onChange(val) {
            return _onChange(st.id, val);
          }
        });
      }
    }), _temp), SurfaceTypesCheckbox__possibleConstructorReturn(_this, _ret);
  }

  SurfaceTypesCheckbox__createClass(SurfaceTypesCheckbox, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.props.loaded) {
        this.props.requestSurfaceTypesList();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          availableSurfaceTypes = _props.availableSurfaceTypes,
          required = _props.required,
          error = _props.error;


      var errorStyles = SurfaceTypesCheckbox_styles_default.a.error + ' ' + SurfaceTypesCheckbox_styles_default.a.errorText;
      var labelStyles = '\n      ' + SurfaceTypesCheckbox_styles_default.a.label + '\n      ' + form_default.a.formLabel + '\n      ' + form_default.a.checkboxListLabel + '\n      ' + (error && SurfaceTypesCheckbox_styles_default.a.errorText) + '\n    ';

      return react_default.a.createElement(
        'div',
        { className: form_default.a.formElementContainer },
        react_default.a.createElement(
          'span',
          { className: labelStyles },
          'Surface Types',
          required && ' *'
        ),
        availableSurfaceTypes.map(function (st) {
          return _this2.renderSurfaceType(st);
        }),
        react_default.a.createElement('br', { className: SurfaceTypesCheckbox_styles_default.a.clearFix }),
        error && react_default.a.createElement(
          'span',
          { className: errorStyles },
          error
        )
      );
    }
  }]);

  return SurfaceTypesCheckbox;
}(react_default.a.Component);

SurfaceTypesCheckbox_SurfaceTypesCheckbox.propTypes = {
  availableSurfaceTypes: prop_types_default.a.array,
  selectedSurfaceTypes: prop_types_default.a.array,
  loaded: prop_types_default.a.bool,
  required: prop_types_default.a.bool,
  error: prop_types_default.a.string,
  requestSurfaceTypesList: prop_types_default.a.func.isRequired,
  onChange: prop_types_default.a.func.isRequired
};

SurfaceTypesCheckbox_SurfaceTypesCheckbox.defaultProps = {
  availableSurfaceTypes: [],
  selectedSurfaceTypes: [],
  error: ''
};

/* harmony default export */ var formElements_SurfaceTypesCheckbox = (Object(react_redux_es["connect"])(function (state) {
  return {
    loaded: state.surfaceTypes.loaded,
    availableSurfaceTypes: Object(reducers["_22" /* getSurfaceTypeList */])(state) || []
  };
}, { requestSurfaceTypesList: actionCreators["_25" /* requestSurfaceTypesList */] })(SurfaceTypesCheckbox_SurfaceTypesCheckbox));
// CONCATENATED MODULE: ./client/app/screens/main/screens/iqms/components/IQMForm.jsx
var IQMForm__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var IQMForm__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function IQMForm__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function IQMForm__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function IQMForm__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function IQMForm__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function IQMForm__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





















var IQMForm_theme = { RTInput: input_default.a, RTDropdown: dropdown_default.a, RTCard: styles_card_default.a, RTSwitch: switch_default.a, RTTabs: tabs_default.a };

var IQMForm_cancelClass = classnames_default()([form_default.a.cancelButton, form_default.a.actionButton]);

var IQMForm_IQMForm = function (_Component) {
  IQMForm__inherits(IQMForm, _Component);

  function IQMForm(props) {
    IQMForm__classCallCheck(this, IQMForm);

    var _this = IQMForm__possibleConstructorReturn(this, (IQMForm.__proto__ || Object.getPrototypeOf(IQMForm)).call(this, props));

    IQMForm__initialiseProps.call(_this);

    var iqm = _this.props.iqm;

    _this.state = {
      iqm: iqm && IQMForm__extends({}, iqm, {
        workroom_ids: iqm.workrooms.map(function (w) {
          return w.id;
        }),
        surface_type_ids: iqm.surface_types.map(function (s) {
          return s.id;
        })
      }) || { surface_type_ids: [] },
      userAttributes: {}
    };
    _this.handleCanDeliver = _this.handleChange.bind(_this, 'can_deliver');
    return _this;
  }

  IQMForm__createClass(IQMForm, [{
    key: 'renderTitle',
    value: function renderTitle(iqm, active, isEdit) {
      var _cx;

      var name = iqm.name,
          can_deliver = iqm.can_deliver;

      var title = isEdit ? name || 'Edit IQM' : 'Add IQM';
      var switchClassNames = classnames_default()((_cx = {}, IQMForm__defineProperty(_cx, form_default.a.switchTitleAdd, !isEdit), IQMForm__defineProperty(_cx, form_default.a.switchTitle, true), _cx));
      return react_default.a.createElement(
        'div',
        null,
        react_default.a.createElement(
          flexbox_react_dist_default.a,
          { justifyContent: 'space-between', className: form_default.a.divider },
          react_default.a.createElement(
            'div',
            null,
            react_default.a.createElement(
              'h5',
              { className: form_default.a.cardTitle },
              title
            ),
            react_default.a.createElement(
              'p',
              { className: form_default.a.cardSubtitle },
              'Please ensure that all fields contain accurate information'
            )
          ),
          react_default.a.createElement(
            'div',
            null,
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              name: 'active',
              label: 'Account Active',
              onChange: this.handleActive,
              className: switchClassNames,
              checked: active
            }),
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              name: 'can_deliver',
              label: 'Can Deliver',
              onChange: this.handleCanDeliver,
              className: switchClassNames,
              checked: can_deliver
            })
          )
        )
      );
    }
  }]);

  return IQMForm;
}(react["Component"]);

var IQMForm__initialiseProps = function _initialiseProps() {
  var _this2 = this;

  Object.defineProperty(this, 'handleChange', {
    enumerable: true,
    writable: true,
    value: function value(key, _value) {
      var iqm = IQMForm__extends({}, _this2.state.iqm);
      iqm[key] = _value;
      _this2.setState({ iqm: iqm });
    }
  });
  Object.defineProperty(this, 'handleActive', {
    enumerable: true,
    writable: true,
    value: function value(val) {
      return _this2.handleUserChange({ active: val });
    }
  });
  Object.defineProperty(this, 'handleSurfaceType', {
    enumerable: true,
    writable: true,
    value: function value(sfID, checked) {
      var surfaceTypes = [].concat(IQMForm__toConsumableArray(_this2.state.iqm && _this2.state.iqm.surface_type_ids)) || [];
      var index = surfaceTypes.indexOf(sfID);
      // REMOVE if surface type is in the current IQM list but was deselected
      if (index > -1 && !checked) surfaceTypes.splice(index, 1);
      // ADD if surface type is NOT in the current IQM list and was selected
      else if (index < 0 && checked) surfaceTypes.push(sfID);
      _this2.handleChange('surface_type_ids', surfaceTypes);
    }
  });
  Object.defineProperty(this, 'handleUserChange', {
    enumerable: true,
    writable: true,
    value: function value(user) {
      return _this2.setState({ userAttributes: IQMForm__extends({}, _this2.state.userAttributes, user) });
    }
  });
  Object.defineProperty(this, 'handleCancel', {
    enumerable: true,
    writable: true,
    value: function value() {
      return _this2.props.onCancel();
    }
  });
  Object.defineProperty(this, 'handleSave', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _state$iqm = _this2.state.iqm,
          id = _state$iqm.id,
          surface_type_ids = _state$iqm.surface_type_ids,
          user_id = _state$iqm.user_id,
          can_deliver = _state$iqm.can_deliver;

      _this2.props.onSave({
        id: id,
        surface_type_ids: surface_type_ids,
        can_deliver: can_deliver,
        user_attributes: IQMForm__extends({}, _this2.state.userAttributes, { id: user_id })
      });
    }
  });
  Object.defineProperty(this, 'render', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _state = _this2.state,
          iqm = _state.iqm,
          userAttributes = _state.userAttributes;
      var _props = _this2.props,
          errors = _props.errors,
          activeTab = _props.activeTab,
          onTabChange = _props.onTabChange;

      var isEdit = !!iqm.id;
      var gError = Object(utils["c" /* error */])('global', errors);
      return react_default.a.createElement(
        react_css_themr_lib["ThemeProvider"],
        { theme: IQMForm_theme },
        react_default.a.createElement(
          components_Card,
          null,
          _this2.renderTitle(iqm, Object.prototype.hasOwnProperty.call(userAttributes, 'active') ? userAttributes.active : iqm.active, isEdit),
          gError ? react_default.a.createElement(MessageBox["a" /* default */], { error: true, message: gError }) : null,
          react_default.a.createElement(
            react_toolbox_lib["Tabs"],
            { index: activeTab, onChange: onTabChange, className: tabs_default.a.absoluteTabs },
            react_default.a.createElement(
              react_toolbox_lib["Tab"],
              { label: 'Basic Info' },
              react_default.a.createElement(
                users_UserForm,
                {
                  user: isEdit ? iqm : null,
                  errors: errors,
                  onChange: _this2.handleUserChange,
                  leadCertField: true
                },
                react_default.a.createElement(formElements_SurfaceTypesCheckbox, {
                  selectedSurfaceTypes: iqm.surface_type_ids,
                  error: Object(utils["c" /* error */])('surface_types', errors),
                  onChange: _this2.handleSurfaceType
                })
              )
            )
          ),
          react_default.a.createElement(
            flexbox_react_dist_default.a,
            { justifyContent: 'flex-end', flexWrap: 'wrap' },
            react_default.a.createElement(
              react_toolbox_lib["CardActions"],
              { className: form_default.a.actionsWrapper },
              react_default.a.createElement(ColoredButton["a" /* default */], {
                className: IQMForm_cancelClass,
                responsive: true,
                color: 'gray',
                label: 'Cancel',
                onClick: _this2.handleCancel
              }),
              react_default.a.createElement(ColoredButton["a" /* default */], {
                className: form_default.a.actionButton,
                responsive: true,
                color: 'green',
                label: isEdit ? 'Save Changes' : 'Add IQM',
                onClick: _this2.handleSave
              })
            )
          )
        )
      );
    }
  });
};

IQMForm_IQMForm.propTypes = {
  errors: prop_types_default.a.object,
  iqm: types_iqm,
  onCancel: prop_types_default.a.func,
  onSave: prop_types_default.a.func,
  activeTab: prop_types_default.a.number,
  onTabChange: prop_types_default.a.func
};

/* harmony default export */ var components_IQMForm = (IQMForm_IQMForm);
// CONCATENATED MODULE: ./client/app/screens/main/screens/iqms/IQMNew.jsx
var IQMNew__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function IQMNew__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function IQMNew__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function IQMNew__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var IQMNew_IQMNew = function (_Component) {
  IQMNew__inherits(IQMNew, _Component);

  function IQMNew() {
    var _ref;

    var _temp, _this, _ret;

    IQMNew__classCallCheck(this, IQMNew);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = IQMNew__possibleConstructorReturn(this, (_ref = IQMNew.__proto__ || Object.getPrototypeOf(IQMNew)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'handleCancel', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.navigate('/iqms');
      }
    }), Object.defineProperty(_this, 'handleSave', {
      enumerable: true,
      writable: true,
      value: function value(iqm) {
        _this.props.createIQM(iqm).then(function (res) {
          _this.props.navigate('/iqms');
          _this.props.updateUI('successMessage', res.payload.name + ' was added.\n          A confirmation email was sent to ' + res.payload.email + '. This email will expire in 7 days.');
        });
      }
    }), _temp), IQMNew__possibleConstructorReturn(_this, _ret);
  }

  IQMNew__createClass(IQMNew, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.requestWorkroomList();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.clearValidationErrors('IQM');
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          errors = _props.errors,
          workrooms = _props.workrooms;

      return react_default.a.createElement(components_IQMForm, {
        errors: errors,
        onSave: this.handleSave,
        onCancel: this.handleCancel,
        workrooms: workrooms
      });
    }
  }]);

  return IQMNew;
}(react["Component"]);

Object.defineProperty(IQMNew_IQMNew, 'propTypes', {
  enumerable: true,
  writable: true,
  value: {
    clearValidationErrors: prop_types_default.a.func.isRequired,
    createIQM: prop_types_default.a.func.isRequired,
    requestWorkroomList: prop_types_default.a.func.isRequired,
    navigate: prop_types_default.a.func.isRequired,
    updateUI: prop_types_default.a.func,
    errors: prop_types_default.a.object,
    workrooms: prop_types_default.a.array
  }
});


var IQMNew_mapStateToProps = function mapStateToProps(state) {
  return {
    errors: state.iqms.common.errors,
    workrooms: Object(reducers["_37" /* getWorkroomList */])(state)
  };
};

/* harmony default export */ var iqms_IQMNew = (transpiled_default()()(Object(react_redux_es["connect"])(IQMNew_mapStateToProps, { requestWorkroomList: actionCreators["_31" /* requestWorkroomList */], clearValidationErrors: actionCreators["k" /* clearValidationErrors */], createIQM: actionCreators["q" /* createIQM */], navigate: actionCreators["O" /* navigate */] })(IQMNew_IQMNew)));
// CONCATENATED MODULE: ./client/app/screens/main/screens/iqms/IQMEdit.jsx
var IQMEdit__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function IQMEdit__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function IQMEdit__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function IQMEdit__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var IQMEdit_IQMEdit = function (_Component) {
  IQMEdit__inherits(IQMEdit, _Component);

  function IQMEdit() {
    var _ref;

    var _temp, _this, _ret;

    IQMEdit__classCallCheck(this, IQMEdit);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = IQMEdit__possibleConstructorReturn(this, (_ref = IQMEdit.__proto__ || Object.getPrototypeOf(IQMEdit)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'handleTabChange', {
      enumerable: true,
      writable: true,
      value: function value(index) {
        _this.props.updateUI('activeTab', index);
      }
    }), Object.defineProperty(_this, 'handleSave', {
      enumerable: true,
      writable: true,
      value: function value(iqm) {
        return _this.props.updateIQM(iqm).then(_this.props.navigateBack);
      }
    }), Object.defineProperty(_this, 'handleCancel', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.navigateBack();
      }
    }), _temp), IQMEdit__possibleConstructorReturn(_this, _ret);
  }

  IQMEdit__createClass(IQMEdit, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.props.iqm) {
        this.props.requestIQM(this.props.id);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.clearValidationErrors('IQM');
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          ui = _props.ui,
          iqm = _props.iqm,
          errors = _props.errors,
          loading = _props.loading;

      return !loading ? react_default.a.createElement(components_IQMForm, {
        iqm: iqm,
        errors: errors,
        onSave: this.handleSave,
        onCancel: this.handleCancel,
        activeTab: ui.activeTab,
        onTabChange: this.handleTabChange
      }) : react_default.a.createElement(
        'p',
        null,
        'Loading...'
      );
    }
  }]);

  return IQMEdit;
}(react["Component"]);

Object.defineProperty(IQMEdit_IQMEdit, 'propTypes', {
  enumerable: true,
  writable: true,
  value: {
    id: prop_types_default.a.number,
    updateUI: prop_types_default.a.func,
    updateIQM: prop_types_default.a.func,
    navigateBack: prop_types_default.a.func,
    requestIQM: prop_types_default.a.func,
    clearValidationErrors: prop_types_default.a.func,
    loading: prop_types_default.a.bool,
    iqm: types_iqm,
    errors: prop_types_default.a.object,
    ui: prop_types_default.a.object
  }
});


var IQMEdit_mapStateToProps = function mapStateToProps(state, ownProps) {
  var id = Number(ownProps.params.id);
  var iqm = state.iqms.details.id === id ? state.iqms.details : null;
  return {
    id: id,
    iqm: iqm,
    loading: !iqm || state.iqms.common.loading,
    errors: state.iqms.common.errors
  };
};

/* harmony default export */ var iqms_IQMEdit = (transpiled_default()()(Object(react_redux_es["connect"])(IQMEdit_mapStateToProps, {
  requestIQM: actionCreators["_3" /* requestIQM */],
  clearValidationErrors: actionCreators["k" /* clearValidationErrors */],
  updateIQM: actionCreators["_63" /* updateIQM */],
  navigateBack: actionCreators["P" /* navigateBack */]
})(IQMEdit_IQMEdit)));
// CONCATENATED MODULE: ./client/app/screens/main/screens/iqms/index.jsx
var iqms__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function iqms__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function iqms__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function iqms__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var iqms_IQMs = function (_React$Component) {
  iqms__inherits(IQMs, _React$Component);

  function IQMs(context, props) {
    iqms__classCallCheck(this, IQMs);

    var _this = iqms__possibleConstructorReturn(this, (IQMs.__proto__ || Object.getPrototypeOf(IQMs)).call(this, context, props));

    Object.defineProperty(_this, 'onSearch', {
      enumerable: true,
      writable: true,
      value: function value(e, _value) {
        e.preventDefault();
        var filters = iqms__extends({}, _this.props.filters);
        filters.query = _value;
        _this.handleFilterChange(filters);
      }
    });
    Object.defineProperty(_this, 'addAction', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.navigate('/iqms/new');
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var showFiltersDrawer = _this.isIndexRoute();
        return react_default.a.createElement(
          'div',
          null,
          react_default.a.createElement(components_PageActionBar, {
            resource: 'iqm',
            role: _this.props.role,
            addAction: _this.addAction,
            showFiltersBtn: showFiltersDrawer,
            title: 'IQM Management',
            searchText: 'Search for an IQM...',
            toggleFilters: _this.toggleFilterDrawer,
            onSearch: _this.onSearch,
            path: _this.props.location.pathname
          }),
          react_default.a.createElement(
            'div',
            { className: contentArea_default.a.contentAreaContainer },
            _this.props.children,
            react_default.a.createElement(Filters_UserFilters, {
              active: _this.state.showFilterDrawer,
              onOverlayClick: _this.toggleFilterDrawer,
              handleFilterChange: _this.handleFilterChange,
              filters: _this.props.filters,
              title: 'IQMs',
              reset: _this.props.resetIQMFilters,
              role: _this.props.role,
              resource: 'iqm'
            })
          )
        );
      }
    });

    _this.toggleFilterDrawer = function () {
      _this.setState({ showFilterDrawer: !_this.state.showFilterDrawer });
    };
    _this.handleFilterChange = function (filters) {
      return _this.props.setIQMFilters(filters);
    };
    _this.state = {
      showFilterDrawer: false, canViewInactive: Object(services["a" /* can */])(_this.props.role, 'view', 'inactive')
    };
    _this.isIndexRoute = function () {
      return _this.props.location.pathname === _this.props.route.path;
    };
    return _this;
  }

  return IQMs;
}(react_default.a.Component);

iqms_IQMs.propTypes = {
  setIQMFilters: prop_types_default.a.func.isRequired,
  location: prop_types_default.a.shape({
    pathname: prop_types_default.a.string.isRequired
  }).isRequired,
  route: prop_types_default.a.shape({
    path: prop_types_default.a.string.isRequired
  }).isRequired,
  role: prop_types_default.a.string,
  navigate: prop_types_default.a.func.isRequired,
  children: prop_types_default.a.node.isRequired,
  resetIQMFilters: prop_types_default.a.func.isRequired,
  filters: prop_types_default.a.object
};

var iqms_mapStateToProps = function mapStateToProps(state) {
  return {
    role: Object(reducers["_12" /* getRole */])(state), filters: state.iqms.filters.data
  };
};

/* harmony default export */ var screens_iqms = (transpiled_default()({ key: 'iqms', state: { successMessage: '', activeTab: 0 } })(Object(react_redux_es["connect"])(iqms_mapStateToProps, { navigate: actionCreators["O" /* navigate */], setIQMFilters: actionCreators["_48" /* setIQMFilters */], resetIQMFilters: actionCreators["_35" /* resetIQMFilters */] })(iqms_IQMs)));


// CONCATENATED MODULE: ./client/app/screens/main/screens/installers/components/installerCard.jsx







var installerCard_InstallerCard = function InstallerCard(_ref) {
  var installer = _ref.installer,
      user = _ref.user,
      _ref$employee = _ref.employee,
      employee = _ref$employee === undefined ? {} : _ref$employee;
  return react_default.a.createElement(
    users_UserCard,
    {
      user: installer,
      role: user.role,
      workrooms: employee.workrooms || [],
      type: 'installers'
    },
    react_default.a.createElement(ResourceCardElement, {
      title: 'Workroom',
      size: 'small',
      value: (installer.workrooms || []).length > 0 ? installer.workrooms : 'No Workroom'
    }),
    react_default.a.createElement(ResourceCardElement, { title: 'Surface Types', size: 'small', value: installer.surface_types })
  );
};

installerCard_InstallerCard.propTypes = {
  installer: prop_types_default.a.object,
  user: prop_types_default.a.object,
  employee: prop_types_default.a.object
};

/* harmony default export */ var installerCard = (Object(react_redux_es["connect"])(function (state, ownProps) {
  return {
    employee: Object(reducers["i" /* getEmployeeById */])(state)[ownProps.user.employable_id]
  };
})(installerCard_InstallerCard));
// CONCATENATED MODULE: ./client/app/screens/main/screens/installers/installerList.jsx
function installerList__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function installerList__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function installerList__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var installerList_InstallerList = function (_Component) {
  installerList__inherits(InstallerList, _Component);

  function InstallerList() {
    var _ref;

    var _temp, _this, _ret;

    installerList__classCallCheck(this, InstallerList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = installerList__possibleConstructorReturn(this, (_ref = InstallerList.__proto__ || Object.getPrototypeOf(InstallerList)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'componentDidMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.props.requestInstallerList();
        _this.requestEmployeeById();
      }
    }), Object.defineProperty(_this, 'componentWillUnmount', {
      enumerable: true,
      writable: true,
      value: function value() {
        if (_this.props.ui.successMessage) _this.props.updateUI('successMessage', '');
      }
    }), Object.defineProperty(_this, 'requestEmployeeById', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.requestEmployee(_this.props.user.employable_id);
      }
    }), Object.defineProperty(_this, 'handleInfiniteLoad', {
      enumerable: true,
      writable: true,
      value: function value() {
        if (_this.props.needsMore) {
          _this.props.requestInstallerList();
          _this.requestEmployeeById();
        }
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            installers = _this$props.installers,
            needsMore = _this$props.needsMore,
            loading = _this$props.loading,
            user = _this$props.user;

        return react_default.a.createElement(
          'div',
          null,
          _this.props.ui.successMessage ? react_default.a.createElement(MessageBox["a" /* default */], { message: _this.props.ui.successMessage }) : null,
          react_default.a.createElement(
            components_ListView,
            {
              loading: loading,
              needsMore: needsMore,
              handleInfiniteLoad: _this.handleInfiniteLoad
            },
            installers.map(function (installer) {
              return react_default.a.createElement(installerCard, {
                key: 'installer-' + installer.id,
                installer: installer,
                user: user
              });
            })
          )
        );
      }
    }), _temp), installerList__possibleConstructorReturn(_this, _ret);
  }

  return InstallerList;
}(react["Component"]);

Object.defineProperty(installerList_InstallerList, 'propTypes', {
  enumerable: true,
  writable: true,
  value: {
    dispatch: prop_types_default.a.func,
    ui: prop_types_default.a.object,
    updateUI: prop_types_default.a.func,
    needsMore: prop_types_default.a.bool,
    installers: prop_types_default.a.array,
    loading: prop_types_default.a.bool,
    requestInstallerList: prop_types_default.a.func,
    requestEmployee: prop_types_default.a.func,
    user: prop_types_default.a.object
  }
});


var installerList_mapStateToProps = function mapStateToProps(state) {
  return {
    loading: Object(reducers["G" /* getInstallerLoading */])(state),
    installers: Object(reducers["F" /* getInstallerList */])(state),
    needsMore: Object(reducers["E" /* getInstallerHasNextPage */])(state),
    user: state.user
  };
};

/* harmony default export */ var installerList = (transpiled_default()()(Object(react_redux_es["connect"])(installerList_mapStateToProps, { requestInstallerList: actionCreators["_7" /* requestInstallerList */], requestEmployee: actionCreators["X" /* requestEmployee */] })(installerList_InstallerList)));
// EXTERNAL MODULE: ./client/app/shared/components/UploadsTable/styles.scss
var UploadsTable_styles = __webpack_require__("RRIK");
var UploadsTable_styles_default = /*#__PURE__*/__webpack_require__.n(UploadsTable_styles);

// EXTERNAL MODULE: ./client/app/shared/components/UploadsTable/iconButtonTheme.scss
var iconButtonTheme = __webpack_require__("Qt/D");
var iconButtonTheme_default = /*#__PURE__*/__webpack_require__.n(iconButtonTheme);

// CONCATENATED MODULE: ./client/app/shared/components/UploadsTable/uploadTableRow.jsx
function uploadTableRow__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function uploadTableRow__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function uploadTableRow__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var uploadTableRow_theme = { RTButton: iconButtonTheme_default.a };

var uploadTableRow_UploadTableRow = function (_Component) {
  uploadTableRow__inherits(UploadTableRow, _Component);

  function UploadTableRow(props) {
    uploadTableRow__classCallCheck(this, UploadTableRow);

    var _this = uploadTableRow__possibleConstructorReturn(this, (UploadTableRow.__proto__ || Object.getPrototypeOf(UploadTableRow)).call(this, props));

    Object.defineProperty(_this, 'toggleSummaryDialog', {
      enumerable: true,
      writable: true,
      value: function value(active) {
        return _this.setState({ summaryDialogIsActive: active });
      }
    });
    Object.defineProperty(_this, 'parseSummaryError', {
      enumerable: true,
      writable: true,
      value: function value(error) {
        if (!Object(lodash["isPlainObject"])(error)) return error;
        return Object.keys(error).map(function (key) {
          return error[key];
        }).join(' ');
      }
    });
    Object.defineProperty(_this, 'renderSummary', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props$rowData = _this.props.rowData,
            statusText = _this$props$rowData.statusText,
            summary = _this$props$rowData.summary;

        if (statusText === 'error') {
          var summaryObject = summary || {};
          return react_default.a.createElement(
            'div',
            null,
            _this.parseSummaryError(summaryObject.error)
          );
        }
        var summaryArray = summary || [];
        return summaryArray.map(function (action) {
          return react_default.a.createElement(
            'div',
            { key: action.action_type },
            action.action_type,
            ': ',
            action.value
          );
        });
      }
    });
    Object.defineProperty(_this, 'renderBelongsTo', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            crews = _this$props.crews,
            crewId = _this$props.rowData.crewId;

        return crewId ? 'Crew: ' + crews.find(function (c) {
          return c.id === crewId;
        }).name : 'Installer';
      }
    });
    Object.defineProperty(_this, 'renderSummaryButton', {
      enumerable: true,
      writable: true,
      value: function value(status) {
        return status === 'pending' ? null : react_default.a.createElement(
          react_css_themr_lib["ThemeProvider"],
          { theme: uploadTableRow_theme },
          react_default.a.createElement(react_toolbox_lib["IconButton"], {
            onClick: _this.openSummaryDialog,
            icon: 'announcement',
            className: UploadsTable_styles_default.a.summaryLink
          })
        );
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props2 = _this.props,
            rowData = _this$props2.rowData,
            canDownload = _this$props2.canDownload,
            crews = _this$props2.crews,
            isPayRate = _this$props2.isPayRate;

        var summary = _this.renderSummary();
        var summaryButton = _this.renderSummaryButton(rowData.statusText);
        var mobileUploadDate = rowData.uploadedOnMobile || rowData.uploadedOn;
        return react_default.a.createElement(
          'tr',
          {
            key: rowData.id,
            className: !isPayRate && rowData.active ? UploadsTable_styles_default.a.latestSuccess : null
          },
          canDownload && react_default.a.createElement(
            'td',
            { 'data-label': 'Download', className: UploadsTable_styles_default.a.downloadLink },
            rowData.uploadName
          ),
          crews && react_default.a.createElement(
            'td',
            { 'data-label': 'Belongs To' },
            _this.renderBelongsTo()
          ),
          react_default.a.createElement(
            'td',
            { 'data-label': 'Uploaded By' },
            rowData.uploadedBy
          ),
          react_default.a.createElement(
            'td',
            { 'data-label': 'Uploaded On' },
            react_default.a.createElement(
              'span',
              { className: UploadsTable_styles_default.a.desktopDate },
              rowData.uploadedOn
            ),
            react_default.a.createElement(
              'span',
              { className: UploadsTable_styles_default.a.mobileDate },
              mobileUploadDate
            )
          ),
          react_default.a.createElement(
            'td',
            { 'data-label': 'Status' },
            react_default.a.createElement(
              'span',
              { className: UploadsTable_styles_default.a.statusText },
              rowData.statusText
            ),
            summaryButton,
            react_default.a.createElement(
              react_toolbox_lib["Dialog"],
              {
                actions: _this.actions,
                active: _this.state.summaryDialogIsActive,
                title: 'Upload Summary',
                onEscKeyDown: _this.closeSummaryDialog,
                onOverlayClick: _this.closeSummaryDialog
              },
              summary
            )
          )
        );
      }
    });

    _this.state = { summaryDialogIsActive: false };
    _this.openSummaryDialog = _this.toggleSummaryDialog.bind(_this, true);
    _this.closeSummaryDialog = _this.toggleSummaryDialog.bind(_this, false);
    _this.renderSummary = _this.renderSummary.bind(_this);
    _this.renderSummaryButton = _this.renderSummaryButton.bind(_this);
    _this.actions = [{ label: 'OK', onClick: _this.closeSummaryDialog }];
    return _this;
  }

  return UploadTableRow;
}(react["Component"]);

uploadTableRow_UploadTableRow.defaultProps = { crews: null, isPayRate: false };

uploadTableRow_UploadTableRow.propTypes = {
  canDownload: prop_types_default.a.bool.isRequired,
  rowData: prop_types_default.a.object,
  crews: prop_types_default.a.array,
  isPayRate: prop_types_default.a.bool
};

/* harmony default export */ var uploadTableRow = (uploadTableRow_UploadTableRow);
// CONCATENATED MODULE: ./client/app/shared/components/UploadsTable/index.jsx







var UploadsTable_UploadsTable = function UploadsTable(props) {
  var canDownload = function canDownload() {
    return !props.isPayRate || Object(services["a" /* can */])(props.role, 'manage', 'pay_rate');
  };
  var rows = props.data.map(function (rowData) {
    return react_default.a.createElement(uploadTableRow, {
      key: rowData.id,
      rowData: rowData,
      canDownload: canDownload(),
      crews: props.crews,
      isPayRate: props.isPayRate
    });
  });
  var uploadFile = props.uploadText ? react_default.a.createElement(
    'div',
    { className: UploadsTable_styles_default.a.uploadFileWrapper },
    react_default.a.createElement(
      'button',
      { onClick: props.handleUpload, className: UploadsTable_styles_default.a.button },
      props.uploadText
    )
  ) : null;
  return react_default.a.createElement(
    components_Card,
    { className: UploadsTable_styles_default.a.uploadsTable },
    uploadFile,
    react_default.a.createElement(
      'table',
      null,
      react_default.a.createElement(
        'thead',
        null,
        react_default.a.createElement(
          'tr',
          null,
          canDownload() && react_default.a.createElement(
            'th',
            { className: UploadsTable_styles_default.a.downloadColumn },
            props.downloadColumnName
          ),
          props.crews && react_default.a.createElement(
            'th',
            null,
            'Belongs To'
          ),
          react_default.a.createElement(
            'th',
            null,
            'Uploaded By'
          ),
          react_default.a.createElement(
            'th',
            null,
            'Uploaded On'
          ),
          react_default.a.createElement(
            'th',
            null,
            'Status'
          )
        )
      ),
      react_default.a.createElement(
        'tbody',
        null,
        rows
      )
    )
  );
};

UploadsTable_UploadsTable.defaultProps = { isPayRate: false, crews: null };

UploadsTable_UploadsTable.propTypes = {
  role: prop_types_default.a.string.isRequired,
  data: prop_types_default.a.array,
  isPayRate: prop_types_default.a.bool,
  downloadColumnName: prop_types_default.a.string,
  uploadText: prop_types_default.a.string,
  handleUpload: prop_types_default.a.func,
  crews: prop_types_default.a.array
};

/* harmony default export */ var components_UploadsTable = (UploadsTable_UploadsTable);
// CONCATENATED MODULE: ./client/app/shared/components/UploadDialog/index.jsx
function UploadDialog__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function UploadDialog__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function UploadDialog__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var dialogTheme = { RTDialog: { dialog: form_default.a.dialogOverflowVisible } };

var UploadDialog_mediumInput = classnames_default()(form_default.a.inputs, form_default.a.mediumInput);

var UploadDialog_UploadDialog = function (_Component) {
  UploadDialog__inherits(UploadDialog, _Component);

  function UploadDialog(props) {
    UploadDialog__classCallCheck(this, UploadDialog);

    var _this = UploadDialog__possibleConstructorReturn(this, (UploadDialog.__proto__ || Object.getPrototypeOf(UploadDialog)).call(this, props));

    Object.defineProperty(_this, 'handleSubmit', {
      enumerable: true,
      writable: true,
      value: function value() {
        var formData = new FormData();
        if (_this.fileInput.files.length === 0) {
          _this.props.setErrorMessage({ asset: ['Please select a file.'] });
          return;
        }
        if (_this.fileInput.files[0].size > constants["Y" /* MAX_EXCEL_FILE_SIZE */]) {
          // 3MB
          _this.props.setErrorMessage({ asset: ['Please select a file smaller than 3MB.'] });
          return;
        }
        formData.append(_this.props.formDataKey, _this.fileInput.files[0]);
        _this.props.handleSubmit(formData);
      }
    });
    Object.defineProperty(_this, 'renderErrors', {
      enumerable: true,
      writable: true,
      value: function value() {
        var uploadError = Object.keys(_this.props.errors || {}).map(function (key) {
          return _this.props.errors[key];
        }).reduce(function (a, b) {
          return a.concat(b);
        }, []).join(', ');
        if (uploadError) return react_default.a.createElement(MessageBox["a" /* default */], { error: true, message: uploadError });
        return null;
      }
    });
    Object.defineProperty(_this, 'renderCrewSelect', {
      enumerable: true,
      writable: true,
      value: function value(crews, crewPayId) {
        var options = crews.map(function (c) {
          return { value: c.id, label: c.name };
        });
        options.unshift({ value: 'i', label: 'Installer' });
        return react_default.a.createElement(react_select, {
          className: UploadDialog_mediumInput,
          label: 'Belongs To',
          placeholder: 'Select Installer or Crew',
          onChange: _this.props.handleCrewPayId,
          options: options,
          value: crewPayId,
          required: true
        });
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            crews = _this$props.crews,
            crewPayId = _this$props.crewPayId;

        var errors = _this.renderErrors();
        var loadingStatus = _this.props.fileLoading ? react_default.a.createElement(components_Loading, null) : null;
        return react_default.a.createElement(
          react_css_themr_lib["ThemeProvider"],
          { theme: dialogTheme },
          react_default.a.createElement(
            react_toolbox_lib["Dialog"],
            {
              actions: _this.actions,
              active: _this.props.active,
              title: _this.props.title
            },
            react_default.a.createElement(
              'div',
              null,
              crews && _this.renderCrewSelect(crews, crewPayId),
              errors,
              loadingStatus,
              react_default.a.createElement('input', { type: 'file', placeholder: 'Select a file', ref: function ref(c) {
                  _this.fileInput = c;
                } })
            )
          )
        );
      }
    });

    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.actions = [{ label: 'Cancel', onClick: _this.props.handleToggle }, { label: 'Upload', onClick: _this.handleSubmit }];
    return _this;
  }

  return UploadDialog;
}(react["Component"]);

UploadDialog_UploadDialog.defaultProps = { crewPayId: null, crews: null, handleCrewPayId: function handleCrewPayId() {} };

UploadDialog_UploadDialog.propTypes = {
  active: prop_types_default.a.bool,
  title: prop_types_default.a.string,
  errors: prop_types_default.a.object,
  handleSubmit: prop_types_default.a.func,
  handleToggle: prop_types_default.a.func,
  fileLoading: prop_types_default.a.bool,
  setErrorMessage: prop_types_default.a.func.isRequired,
  formDataKey: prop_types_default.a.string,
  crews: prop_types_default.a.array,
  handleCrewPayId: prop_types_default.a.func,
  crewPayId: prop_types_default.a.oneOfType([prop_types_default.a.number, prop_types_default.a.string])
};

/* harmony default export */ var components_UploadDialog = (UploadDialog_UploadDialog);
// EXTERNAL MODULE: ./client/app/screens/main/screens/installers/components/crewForm.scss
var crewForm = __webpack_require__("Tokm");
var crewForm_default = /*#__PURE__*/__webpack_require__.n(crewForm);

// CONCATENATED MODULE: ./client/app/screens/main/screens/installers/components/conflictingAppointmentModal.jsx








var components_conflictingAppointmentModal_ConflictingAppointmentModal = function ConflictingAppointmentModal(_ref) {
  var active = _ref.active,
      appts = _ref.appts,
      onClose = _ref.onClose,
      source = _ref.source;

  var dateFormat = constants["_19" /* RAILS_DATE */];
  var parsedDates = typeof appts !== 'undefined' && appts && appts.length > 0 ? appts.map(function (a) {
    var start = a.start_date;
    var startMoment = moment_default()(start, dateFormat);
    var end = a.end_date;
    var endMoment = end ? moment_default()(end, dateFormat) : null;
    var prefix = source === 'installer' ? a.assignee + ': ' : '';
    return react_default.a.createElement(
      'span',
      { key: a.assignee, className: crewForm_default.a.mdates },
      !endMoment || endMoment.isSame(startMoment, 'day') ? '' + prefix + startMoment.format('MMMM Do YYYY') : '' + prefix + startMoment.format('MMMM Do YYYY') + ' - ' + endMoment.format('MMMM Do YYYY')
    );
  }) : null;

  var confirmation = function confirmation() {
    return react_default.a.createElement(
      'p',
      null,
      'Can not deactivate ',
      source,
      ' with active appointments.',
      react_default.a.createElement('br', null),
      'Please check the current schedule:',
      react_default.a.createElement('br', null),
      react_default.a.createElement('br', null),
      react_default.a.createElement(
        'span',
        { className: crewForm_default.a.mheader },
        'Dates:'
      ),
      parsedDates || 'No valid dates found'
    );
  };

  return react_default.a.createElement(ConfirmDialog["a" /* default */], {
    show: active,
    title: 'Unable to deactivate',
    confirmation: confirmation(),
    theActions: ['OK'],
    okLabel: 'OK',
    okColor: 'yellow',
    proceed: onClose,
    dismiss: function dismiss() {},
    cancel: onClose
  });
};

components_conflictingAppointmentModal_ConflictingAppointmentModal.propTypes = {
  active: prop_types_default.a.bool,
  appts: prop_types_default.a.arrayOf(prop_types_default.a.string),
  onClose: prop_types_default.a.func.isRequired,
  source: prop_types_default.a.string
};

components_conflictingAppointmentModal_ConflictingAppointmentModal.defaultProps = { active: false, dates: [], source: 'installer' };

/* harmony default export */ var components_conflictingAppointmentModal = (components_conflictingAppointmentModal_ConflictingAppointmentModal);
// CONCATENATED MODULE: ./client/app/screens/main/screens/installers/installerAllowedTabs.js



var installerAllowedTabs_hasIfiPermission = function hasIfiPermission(mvw) {
  return mvw && mvw.ifi === true;
};

function getAllowedInstallerTabs(role) {
  var mvw = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return constants["P" /* INSTALLER_TABS */].filter(function (tab) {
    if (tab.label === 'Millwork Certifications' && !installerAllowedTabs_hasIfiPermission(mvw)) {
      return false;
    }
    if (tab.fullInstallerUpdateOnly && !Object(services["a" /* can */])(role, 'update', 'installer')) {
      return false;
    }
    return Object(services["a" /* can */])(role, 'update', tab.ability) || Object(services["a" /* can */])(role, 'update_basic', tab.ability);
  });
}
// CONCATENATED MODULE: ./client/app/screens/main/screens/installers/components/installerBasicInfoForm.jsx
var installerBasicInfoForm__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var installerBasicInfoForm__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function installerBasicInfoForm__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function installerBasicInfoForm__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function installerBasicInfoForm__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function installerBasicInfoForm__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






















var installerBasicInfoForm_STATES_SOURCE = constants["_35" /* STATES */].map(function (state) {
  return { value: state, label: state };
});
var installerBasicInfoForm_TIMEZONE_SOURCE = constants["_46" /* TIMEZONES */].map(function (tz) {
  return { value: tz, label: tz };
});
var fullScreenInput = classnames_default()(form_default.a.inputs, form_default.a.fullScreenInput);
var installerBasicInfoForm_largeInput = classnames_default()(form_default.a.inputs, form_default.a.largeInput);
var installerBasicInfoForm_mediumInput = classnames_default()(form_default.a.inputs, form_default.a.mediumInput);
var installerBasicInfoForm_smallInput = classnames_default()(form_default.a.inputs, form_default.a.smallInput);

var InstallerBasicInfoForm = function (_Component) {
  installerBasicInfoForm__inherits(InstallerBasicInfoForm, _Component);

  function InstallerBasicInfoForm(props) {
    installerBasicInfoForm__classCallCheck(this, InstallerBasicInfoForm);

    var _this = installerBasicInfoForm__possibleConstructorReturn(this, (InstallerBasicInfoForm.__proto__ || Object.getPrototypeOf(InstallerBasicInfoForm)).call(this, props));

    installerBasicInfoForm__initialiseProps.call(_this);

    var onChange = _this.props.onChange;

    _this.onNameChange = onChange.bind(_this, 'name');
    _this.onStreetAddressChange = onChange.bind(_this, 'street');
    _this.onCityChange = onChange.bind(_this, 'city');
    _this.onStateChange = onChange.bind(_this, 'state');
    _this.onZipCodeChange = onChange.bind(_this, 'zip_code');
    _this.onEmailChange = onChange.bind(_this, 'email');
    _this.onPrimaryPhoneChange = onChange.bind(_this, 'primary_phone');
    _this.onPrimaryPhoneTypeChange = onChange.bind(_this, 'primary_phone_type');
    _this.onSecondaryPhoneChange = onChange.bind(_this, 'secondary_phone');
    _this.onSecondaryPhoneTypeChange = onChange.bind(_this, 'secondary_phone_type');
    _this.onWorkersCompChange = onChange.bind(_this, 'workers_comp_expiration');
    _this.onLiabilityInsuranceChange = onChange.bind(_this, 'liability_insurance_expiration');
    _this.onNetPayableExemptChange = onChange.bind(_this, 'net_payable_exempt');
    _this.onSelfSchedulableChange = onChange.bind(_this, 'is_self_schedulable');
    _this.onOverallPercentageChange = onChange.bind(_this, 'overall_percentage');
    _this.onCustomLaborPercentageChange = onChange.bind(_this, 'custom_labor_percentage');
    _this.onSupervisorChange = _this.handleSupervisorChange.bind(_this);
    return _this;
  }

  installerBasicInfoForm__createClass(InstallerBasicInfoForm, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var prevIfiWorkroomIds = this.getIfiWorkroomIds(prevProps);
      var currentIfiWorkroomIds = this.getIfiWorkroomIds(this.props);

      // Refetch if IFI workroom IDs changed
      if (prevIfiWorkroomIds.length !== currentIfiWorkroomIds.length || !prevIfiWorkroomIds.every(function (id, idx) {
        return id === currentIfiWorkroomIds[idx];
      })) {
        this.fetchEmployees();
      }
    }
  }]);

  return InstallerBasicInfoForm;
}(react["Component"]);

var installerBasicInfoForm__initialiseProps = function _initialiseProps() {
  var _this2 = this;

  Object.defineProperty(this, 'componentDidMount', {
    enumerable: true,
    writable: true,
    value: function value() {
      _this2.fetchEmployees();
    }
  });
  Object.defineProperty(this, 'getIfiWorkroomIds', {
    enumerable: true,
    writable: true,
    value: function value(props) {
      var _props$crews = props.crews,
          crews = _props$crews === undefined ? [] : _props$crews,
          _props$allWorkrooms = props.allWorkrooms,
          allWorkrooms = _props$allWorkrooms === undefined ? [] : _props$allWorkrooms;
      // Collect all unique workroom IDs from crews

      var crewWorkroomIds = [].concat(installerBasicInfoForm__toConsumableArray(new Set(crews.flatMap(function (crew) {
        return (crew.workrooms || []).map(function (wr) {
          return (typeof wr === 'undefined' ? 'undefined' : installerBasicInfoForm__typeof(wr)) === 'object' ? wr.id || wr.value || wr : wr;
        });
      }))));
      // Filter to only IFI workrooms that are in crewWorkroomIds
      return allWorkrooms.filter(function (w) {
        return w.vendor === 'IFI' && crewWorkroomIds.includes(w.id);
      }).map(function (w) {
        return w.id;
      });
    }
  });
  Object.defineProperty(this, 'getSupervisorOptions', {
    enumerable: true,
    writable: true,
    value: function value() {
      var employees = _this2.props.employees;

      return (employees || []).map(function (employee) {
        return {
          value: employee.id,
          label: employee.name + ' - ' + (employee.position || 'Employee')
        };
      });
    }
  });
  Object.defineProperty(this, 'getSupervisorValue', {
    enumerable: true,
    writable: true,
    value: function value(options) {
      var _props$installer = _this2.props.installer,
          assigned_supervisor = _props$installer.assigned_supervisor,
          supervisor_id = _props$installer.supervisor_id;

      var supervisorId = assigned_supervisor && assigned_supervisor.id || supervisor_id;
      if (supervisorId) {
        return options.find(function (opt) {
          return opt.value === supervisorId;
        }) || null;
      }
      return null;
    }
  });
  Object.defineProperty(this, 'fetchEmployees', {
    enumerable: true,
    writable: true,
    value: function value() {
      var ifiWorkroomIds = _this2.getIfiWorkroomIds(_this2.props);

      if (ifiWorkroomIds.length === 0) {
        return;
      }

      // Build filters for requestEmployeeList
      var filters = {
        is_active: true,
        for_workrooms: ifiWorkroomIds,
        for_positions: constants["O" /* IC_ISM_POSITIONS */]
      };

      // Set filters in state and request (setEmployeeFilters handles reset and request)
      _this2.props.setEmployeeFilters(filters);
    }
  });
  Object.defineProperty(this, 'handleSupervisorChange', {
    enumerable: true,
    writable: true,
    value: function value(selectedOption) {
      var supervisorId = selectedOption ? selectedOption.value : null;
      _this2.props.onChange('supervisor_id', supervisorId);
    }
  });
  Object.defineProperty(this, 'handleTimezone', {
    enumerable: true,
    writable: true,
    value: function value(option) {
      return _this2.props.onChange('timezone', option.value);
    }
  });
  Object.defineProperty(this, 'handleVisibility', {
    enumerable: true,
    writable: true,
    value: function value(option) {
      return _this2.props.onChange('visibility', option.value);
    }
  });
  Object.defineProperty(this, 'render', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _props = _this2.props,
          errors = _props.errors,
          invalidInstallerFieldsMsgs = _props.invalidInstallerFieldsMsgs,
          installer = _props.installer,
          role = _props.role,
          _props$position = _props.position,
          position = _props$position === undefined ? '' : _props$position,
          _props$mvw = _props.mvw,
          mvw = _props$mvw === undefined ? {} : _props$mvw,
          fieldError = _props.fieldError;

      var address = installer && installer.address || {};
      var canEdit = Object(services["a" /* can */])(role, 'update', 'installer');
      var canViewSupervisor = Object(services["a" /* can */])(role, 'view', 'SUPERVISOR_INFO', {
        position: position,
        mvw: mvw
      });
      var supervisorOptions = canViewSupervisor ? _this2.getSupervisorOptions() : [];
      var supervisorValue = canViewSupervisor ? _this2.getSupervisorValue(supervisorOptions) : null;
      return react_default.a.createElement(
        'div',
        null,
        react_default.a.createElement(
          flexbox_react_dist_default.a,
          { flexWrap: 'wrap', className: form_default.a.divider },
          react_default.a.createElement(react_toolbox_lib["Input"], {
            label: 'Company Name or Installer Name',
            className: fullScreenInput,
            value: installer.name,
            onChange: _this2.onNameChange,
            error: fieldError('name', invalidInstallerFieldsMsgs),
            required: true,
            disabled: !canEdit
          }),
          react_default.a.createElement(components_BreakLine, null),
          react_default.a.createElement(react_toolbox_lib["Input"], {
            label: 'Street Address',
            className: installerBasicInfoForm_largeInput,
            value: address.street,
            error: fieldError('street', invalidInstallerFieldsMsgs),
            onChange: _this2.onStreetAddressChange,
            required: true,
            disabled: !canEdit
          }),
          react_default.a.createElement(react_toolbox_lib["Input"], {
            label: 'City',
            className: installerBasicInfoForm_mediumInput,
            value: address.city,
            error: fieldError('city', invalidInstallerFieldsMsgs),
            onChange: _this2.onCityChange,
            required: true,
            disabled: !canEdit
          }),
          react_default.a.createElement(components_StyledSelect, {
            className: installerBasicInfoForm_largeInput,
            label: 'State',
            onChange: _this2.onStateChange,
            options: installerBasicInfoForm_STATES_SOURCE,
            value: address.state,
            placeholder: 'Select State',
            error: fieldError('state', invalidInstallerFieldsMsgs),
            required: true,
            disabled: !canEdit
          }),
          react_default.a.createElement(react_toolbox_lib["Input"], {
            label: 'Zip Code',
            className: installerBasicInfoForm_smallInput,
            value: address.zip_code,
            error: fieldError('zip_code', invalidInstallerFieldsMsgs),
            onChange: _this2.onZipCodeChange,
            required: true,
            disabled: !canEdit
          }),
          react_default.a.createElement(components_BreakLine, null),
          react_default.a.createElement(react_toolbox_lib["Input"], {
            label: 'Email',
            type: 'email',
            value: installer.email,
            className: installerBasicInfoForm_largeInput,
            onChange: _this2.onEmailChange,
            error: Object(utils["c" /* error */])('user.email', errors) || fieldError('email', invalidInstallerFieldsMsgs),
            required: true
          }),
          react_default.a.createElement(
            PhoneType_PhoneInput,
            {
              label: 'Primary Phone',
              type: 'tel',
              value: installer.primary_phone,
              className: installerBasicInfoForm_largeInput,
              onChange: _this2.onPrimaryPhoneChange,
              error: fieldError('primary_phone', invalidInstallerFieldsMsgs),
              required: true
            },
            react_default.a.createElement(components_PhoneType, {
              source: constants["_16" /* PHONE_TYPES_W_FAX */],
              value: installer.primary_phone_type,
              onChange: _this2.onPrimaryPhoneTypeChange
            })
          ),
          react_default.a.createElement(
            PhoneType_PhoneInput,
            {
              label: 'Secondary Phone',
              type: 'tel',
              value: installer.secondary_phone,
              className: installerBasicInfoForm_largeInput,
              onChange: _this2.onSecondaryPhoneChange,
              error: Object(utils["c" /* error */])('user.secondary_phone', errors)
            },
            react_default.a.createElement(components_PhoneType, {
              source: constants["_16" /* PHONE_TYPES_W_FAX */],
              value: installer.secondary_phone_type,
              onChange: _this2.onSecondaryPhoneTypeChange
            })
          ),
          react_default.a.createElement(react_select, {
            className: installerBasicInfoForm_mediumInput,
            label: 'Time Zone',
            placeholder: 'Select Time Zone',
            onChange: _this2.handleTimezone,
            options: installerBasicInfoForm_TIMEZONE_SOURCE,
            value: installer.timezone,
            error: fieldError('timezone', invalidInstallerFieldsMsgs),
            required: true
          })
        ),
        react_default.a.createElement(
          flexbox_react_dist_default.a,
          { flexWrap: 'wrap', className: form_default.a.divider },
          react_default.a.createElement(DatePicker, {
            label: 'Worker\'s comp. expiration',
            className: installerBasicInfoForm_largeInput,
            value: installer.workers_comp_expiration,
            onChange: _this2.onWorkersCompChange,
            error: Object(utils["c" /* error */])('workers_comp_expiration', errors),
            disabled: !canEdit
          }),
          react_default.a.createElement(DatePicker, {
            label: 'General liability insurance expiration',
            className: installerBasicInfoForm_largeInput,
            value: installer.liability_insurance_expiration,
            onChange: _this2.onLiabilityInsuranceChange,
            error: Object(utils["c" /* error */])('liability_insurance_expiration', errors),
            disabled: !canEdit
          }),
          react_default.a.createElement(components_BreakLine, null)
        ),
        react_default.a.createElement(
          flexbox_react_dist_default.a,
          { flexWrap: 'wrap', className: form_default.a.divider },
          react_default.a.createElement(react_toolbox_lib["Checkbox"], {
            checked: installer.net_payable_exempt,
            label: 'Exempt Net Payable Reduction',
            onChange: _this2.onNetPayableExemptChange,
            className: form_default.a.checkboxListItem,
            theme: checkbox_default.a,
            disabled: !canEdit
          }),
          react_default.a.createElement(react_toolbox_lib["Checkbox"], {
            checked: installer.is_self_schedulable,
            label: 'Self Schedulable',
            onChange: _this2.onSelfSchedulableChange,
            className: form_default.a.checkboxListItem,
            theme: checkbox_default.a,
            disabled: !canEdit
          }),
          react_default.a.createElement(components_BreakLine, null)
        ),
        react_default.a.createElement(
          flexbox_react_dist_default.a,
          { flexWrap: 'wrap', className: form_default.a.divider },
          react_default.a.createElement(react_select, {
            className: installerBasicInfoForm_mediumInput,
            label: 'Schedule Visibility',
            placeholder: 'Select Range',
            onChange: _this2.handleVisibility,
            options: constants["_56" /* VISIBILITY_RANGES */],
            value: installer.visibility,
            error: fieldError('visibility', invalidInstallerFieldsMsgs),
            required: true
          }),
          react_default.a.createElement(components_BreakLine, null)
        ),
        canViewSupervisor &&
        // "Supervisor" is labeled as "Coordinator" in the UI since
        // that's more familiar to IFI users, but the value is still
        // stored as "supervisor_id" in the backend.
        react_default.a.createElement(
          flexbox_react_dist_default.a,
          { flexWrap: 'wrap', className: form_default.a.divider },
          react_default.a.createElement(react_select, {
            className: fullScreenInput,
            label: 'Coordinator',
            placeholder: 'Select Coordinator',
            options: supervisorOptions,
            value: supervisorValue,
            onChange: _this2.onSupervisorChange,
            clearable: true,
            isLoading: _this2.props.employeeLoading,
            disabled: !canEdit
          }),
          react_default.a.createElement(components_BreakLine, null)
        ),
        mvw.ifi && react_default.a.createElement(
          flexbox_react_dist_default.a,
          { flexWrap: 'wrap', className: form_default.a.divider },
          react_default.a.createElement(react_toolbox_lib["Input"], {
            label: 'Overall % (IFI)',
            type: 'number',
            className: installerBasicInfoForm_mediumInput,
            value: installer.overall_percentage != null ? String(installer.overall_percentage) : '',
            onChange: _this2.onOverallPercentageChange,
            disabled: !canEdit
          }),
          react_default.a.createElement(react_toolbox_lib["Input"], {
            label: 'Custom Labor % (IFI)',
            type: 'number',
            className: installerBasicInfoForm_mediumInput,
            value: installer.custom_labor_percentage != null ? String(installer.custom_labor_percentage) : '',
            onChange: _this2.onCustomLaborPercentageChange,
            disabled: !canEdit
          }),
          react_default.a.createElement(components_BreakLine, null)
        )
      );
    }
  });
};

InstallerBasicInfoForm.propTypes = {
  onChange: prop_types_default.a.func,
  errors: prop_types_default.a.object,
  invalidInstallerFieldsMsgs: prop_types_default.a.array,
  installer: prop_types_default.a.object,
  crews: prop_types_default.a.array,
  allWorkrooms: prop_types_default.a.array,
  employees: prop_types_default.a.array,
  employeeLoading: prop_types_default.a.bool,
  setEmployeeFilters: prop_types_default.a.func.isRequired,
  role: prop_types_default.a.string.isRequired,
  position: prop_types_default.a.string,
  mvw: prop_types_default.a.object,
  fieldError: prop_types_default.a.func
};

var installerBasicInfoForm_getEmployeeOptions = Object(reselect_lib["createSelector"])(reducers["m" /* getEmployeeList */], function (employees) {
  return employees || [];
});

var installerBasicInfoForm_mapStateToProps = function mapStateToProps(state) {
  return {
    employees: installerBasicInfoForm_getEmployeeOptions(state),
    employeeLoading: Object(reducers["n" /* getEmployeeLoading */])(state)
  };
};

var installerBasicInfoForm_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setEmployeeFilters: function setEmployeeFilters(filters) {
      return dispatch(Object(actionCreators_employees["f" /* setEmployeeFilters */])(filters));
    }
  };
};

/* harmony default export */ var installerBasicInfoForm = (Object(react_redux_es["connect"])(installerBasicInfoForm_mapStateToProps, installerBasicInfoForm_mapDispatchToProps)(InstallerBasicInfoForm));
// CONCATENATED MODULE: ./client/app/screens/main/screens/installers/components/installerCertificationsForm.jsx










var installerCertificationsForm_largeInput = form_default.a.inputs + ' ' + form_default.a.largeInput;

var installerCertificationsForm_InstallerCertificationsForm = function InstallerCertificationsForm(_ref) {
  var installer = _ref.installer,
      onChange = _ref.onChange,
      role = _ref.role,
      errors = _ref.errors;

  var canEdit = Object(services["a" /* can */])(role, 'update', 'installer');
  var onFirmNumber = function onFirmNumber(e) {
    return onChange('installer_firm_certification_number', e);
  };
  var onFirmExpiration = function onFirmExpiration(v) {
    return onChange('installer_firm_certification_expiration', v);
  };
  var onRenovatorNumber = function onRenovatorNumber(e) {
    return onChange('assigned_renovator_certification_number', e);
  };
  var onRenovatorExpiration = function onRenovatorExpiration(v) {
    return onChange('assigned_renovator_certification_expiration', v);
  };

  return react_default.a.createElement(
    'div',
    null,
    react_default.a.createElement(
      flexbox_react_dist_default.a,
      { flexWrap: 'wrap', className: form_default.a.divider },
      react_default.a.createElement(
        'p',
        { className: form_default.a.cardSubtitle },
        'Firm and assigned renovator certification numbers and expirations. These values are used when generating IFI paperwork.'
      ),
      react_default.a.createElement(components_BreakLine, null),
      react_default.a.createElement(react_toolbox_lib["Input"], {
        label: 'Installer firm certification number',
        className: installerCertificationsForm_largeInput,
        value: installer.installer_firm_certification_number || '',
        onChange: onFirmNumber,
        error: Object(utils["c" /* error */])('installer_firm_certification_number', errors),
        disabled: !canEdit
      }),
      react_default.a.createElement(DatePicker, {
        label: 'Installer firm certification expiration',
        className: installerCertificationsForm_largeInput,
        value: installer.installer_firm_certification_expiration,
        onChange: onFirmExpiration,
        error: Object(utils["c" /* error */])('installer_firm_certification_expiration', errors),
        disabled: !canEdit
      }),
      react_default.a.createElement(components_BreakLine, null),
      react_default.a.createElement(react_toolbox_lib["Input"], {
        label: 'Assigned renovator certification number',
        className: installerCertificationsForm_largeInput,
        value: installer.assigned_renovator_certification_number || '',
        onChange: onRenovatorNumber,
        error: Object(utils["c" /* error */])('assigned_renovator_certification_number', errors),
        disabled: !canEdit
      }),
      react_default.a.createElement(DatePicker, {
        label: 'Assigned renovator certification expiration',
        className: installerCertificationsForm_largeInput,
        value: installer.assigned_renovator_certification_expiration,
        onChange: onRenovatorExpiration,
        error: Object(utils["c" /* error */])('assigned_renovator_certification_expiration', errors),
        disabled: !canEdit
      })
    )
  );
};

installerCertificationsForm_InstallerCertificationsForm.propTypes = {
  installer: prop_types_default.a.object.isRequired,
  onChange: prop_types_default.a.func.isRequired,
  role: prop_types_default.a.string.isRequired,
  errors: prop_types_default.a.object
};

installerCertificationsForm_InstallerCertificationsForm.defaultProps = {
  errors: {}
};

/* harmony default export */ var installerCertificationsForm = (installerCertificationsForm_InstallerCertificationsForm);
// EXTERNAL MODULE: ./client/app/shared/styles/common.scss
var common = __webpack_require__("Z5Js");
var common_default = /*#__PURE__*/__webpack_require__.n(common);

// CONCATENATED MODULE: ./client/app/screens/main/screens/installers/components/helperForm.jsx
function helperForm__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function helperForm__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function helperForm__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var removeButton = classnames_default()(form_default.a.deleteChildButton, form_default.a.cancelButton, common_default.a.floatLeft);

var helperForm_HelperForm = function (_Component) {
  helperForm__inherits(HelperForm, _Component);

  function HelperForm(props) {
    helperForm__classCallCheck(this, HelperForm);

    var _this = helperForm__possibleConstructorReturn(this, (HelperForm.__proto__ || Object.getPrototypeOf(HelperForm)).call(this, props));

    Object.defineProperty(_this, 'handleCheckboxChange', {
      enumerable: true,
      writable: true,
      value: function value(_value) {
        return _this.props.onChange('not_used', _value);
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            errors = _this$props.errors,
            helper = _this$props.helper,
            helperFieldWarnings = _this$props.helperFieldWarnings,
            fieldError = _this$props.fieldError;

        var largeInput = classnames_default()(form_default.a.childInputs, form_default.a.largeInput);
        var isSavedHelper = !Object(lodash["isString"])(helper.id) || helper.id.indexOf('new_') !== 0;
        return react_default.a.createElement(
          'div',
          { className: form_default.a.childCard },
          react_default.a.createElement(
            flexbox_react_dist_default.a,
            null,
            react_default.a.createElement(react_toolbox_lib["Input"], {
              label: 'Name',
              value: helper.name || '',
              className: largeInput,
              error: _this.showError('name', errors),
              required: true,
              onChange: _this.onNameChange
            }),
            react_default.a.createElement(
              PhoneType_PhoneInput,
              {
                label: 'Phone Number',
                type: 'tel',
                value: helper.phone_number || '',
                className: largeInput,
                error: _this.showError('phone_number', errors),
                onChange: _this.onPhoneNumberChange
              },
              react_default.a.createElement(components_PhoneType, {
                source: constants["_16" /* PHONE_TYPES_W_FAX */],
                value: helper.phone_number_type,
                onChange: _this.onPhoneNumberTypeChange
              })
            ),
            react_default.a.createElement(react_toolbox_lib["Input"], {
              label: 'Email Address',
              value: helper.email || '',
              className: largeInput,
              error: fieldError('email', helperFieldWarnings),
              onChange: _this.onEmailChange
            })
          ),
          react_default.a.createElement(
            flexbox_react_dist_default.a,
            null,
            react_default.a.createElement(react_toolbox_lib["Input"], {
              label: 'Badge Number',
              value: helper.badge_number || '',
              className: largeInput,
              error: _this.showError('badge_number', errors),
              required: true,
              onChange: _this.onBadgeNumberChange
            }),
            react_default.a.createElement(DatePicker, {
              label: 'Badge expiration',
              className: largeInput,
              value: helper.badge_expiration || '',
              onChange: _this.onBadgeExpirationChange,
              error: _this.showError('badge_expiration', errors),
              required: true
            }),
            react_default.a.createElement(react_toolbox_lib["Input"], {
              label: 'Badge Link',
              value: helper.badge_link || '',
              className: largeInput,
              error: _this.showError('badge_link', errors),
              required: true,
              onChange: _this.onBadgeLinkChange
            })
          ),
          react_default.a.createElement(
            flexbox_react_dist_default.a,
            { justifyContent: 'space-between' },
            react_default.a.createElement(react_toolbox_lib["Checkbox"], {
              checked: helper.not_used,
              label: 'Do not use',
              theme: checkbox_default.a,
              className: form_default.a.checkboxItem,
              onChange: _this.handleCheckboxChange
            }),
            react_default.a.createElement(
              'div',
              null,
              isSavedHelper ? null : react_default.a.createElement(ColoredButton["a" /* default */], {
                className: removeButton,
                color: 'red',
                label: 'Remove',
                onClick: _this.handleDelete
              }),
              react_default.a.createElement(ColoredButton["a" /* default */], {
                className: form_default.a.deleteChildButton,
                color: helper.disabled ? 'green' : 'darkGray',
                label: (helper.disabled ? 'Enable' : 'Disable').concat(' Helper'),
                onClick: _this.onDisable
              })
            )
          )
        );
      }
    });
    var _this$props2 = _this.props,
        onDisable = _this$props2.onDisable,
        index = _this$props2.index,
        onChange = _this$props2.onChange,
        onDelete = _this$props2.onDelete;

    _this.handleCheckboxChange = _this.handleCheckboxChange.bind(_this);
    _this.handleDelete = function () {
      return onDelete(_this.props.helper.id);
    };
    _this.showError = utils["s" /* nestedError */].bind(_this, 'helpers', index);
    _this.onDisable = onDisable.bind(_this);
    _this.onNameChange = onChange.bind(_this, 'name');
    _this.onPhoneNumberChange = onChange.bind(_this, 'phone_number');
    _this.onPhoneNumberTypeChange = onChange.bind(_this, 'phone_number_type');
    _this.onEmailChange = onChange.bind(_this, 'email');
    _this.onBadgeNumberChange = onChange.bind(_this, 'badge_number');
    _this.onBadgeLinkChange = onChange.bind(_this, 'badge_link');
    _this.onBadgeExpirationChange = onChange.bind(_this, 'badge_expiration');
    return _this;
  }

  return HelperForm;
}(react["Component"]);

helperForm_HelperForm.propTypes = {
  index: prop_types_default.a.number,
  onDelete: prop_types_default.a.func,
  onChange: prop_types_default.a.func,
  onDisable: prop_types_default.a.func,
  onSurfaceTypesChange: prop_types_default.a.func,
  errors: prop_types_default.a.object,
  helper: prop_types_default.a.object,
  helperFieldWarnings: prop_types_default.a.array,
  fieldError: prop_types_default.a.func
};

/* harmony default export */ var helperForm = (helperForm_HelperForm);
// EXTERNAL MODULE: ./client/app/shared/components/TimeInput/styles.scss
var TimeInput_styles = __webpack_require__("FLDy");
var TimeInput_styles_default = /*#__PURE__*/__webpack_require__.n(TimeInput_styles);

// CONCATENATED MODULE: ./client/app/shared/components/TimeInput/index.jsx
var TimeInput__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function TimeInput__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function TimeInput__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function TimeInput__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function TimeInput__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var TimeInput_TimeInput = function (_React$Component) {
  TimeInput__inherits(TimeInput, _React$Component);

  function TimeInput() {
    var _ref;

    var _temp, _this, _ret;

    TimeInput__classCallCheck(this, TimeInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = TimeInput__possibleConstructorReturn(this, (_ref = TimeInput.__proto__ || Object.getPrototypeOf(TimeInput)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'handleChange', {
      enumerable: true,
      writable: true,
      value: function value(elm) {
        var val = elm && elm.target && elm.target.value || '';
        _this.props.onChange(val);
      }
    }), Object.defineProperty(_this, 'renderLabel', {
      enumerable: true,
      writable: true,
      value: function value(lbl, errs) {
        var style = errs ? TimeInput_styles_default.a.label + ' ' + TimeInput_styles_default.a.errorLabel : TimeInput_styles_default.a.label;

        return react_default.a.createElement(
          'h6',
          { className: style },
          lbl
        );
      }
    }), Object.defineProperty(_this, 'renderInput', {
      enumerable: true,
      writable: true,
      value: function value(val, props) {
        var style = input_default.a.inputElement + ' ' + TimeInput_styles_default.a.input;

        return react_default.a.createElement('input', TimeInput__extends({}, props, {
          className: style,
          type: 'time',
          value: val,
          onChange: _this.handleChange
        }));
      }
    }), Object.defineProperty(_this, 'renderErrors', {
      enumerable: true,
      writable: true,
      value: function value(errs) {
        return react_default.a.createElement(
          'div',
          { className: input_default.a.error },
          react_default.a.createElement(
            'span',
            { className: TimeInput_styles_default.a.errorMsg },
            errs
          )
        );
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            label = _this$props.label,
            value = _this$props.value,
            errors = _this$props.errors,
            className = _this$props.className,
            props = TimeInput__objectWithoutProperties(_this$props, ['label', 'value', 'errors', 'className']);

        var errs = errors.join(', ');
        var style = errs ? className + ' ' + input_default.a.errored : className;

        return react_default.a.createElement(
          'div',
          { className: style },
          _this.renderLabel(label, errs),
          _this.renderInput(value, props),
          _this.renderErrors(errs)
        );
      }
    }), _temp), TimeInput__possibleConstructorReturn(_this, _ret);
  }

  return TimeInput;
}(react_default.a.Component);

TimeInput_TimeInput.propTypes = {
  label: prop_types_default.a.string.isRequired,
  value: prop_types_default.a.string.isRequired,
  onChange: prop_types_default.a.func.isRequired,
  errors: prop_types_default.a.arrayOf(prop_types_default.a.string).isRequired,
  className: prop_types_default.a.string
};

TimeInput_TimeInput.defaultProps = {
  label: '',
  value: '',
  errors: []
};

/* harmony default export */ var components_TimeInput = (TimeInput_TimeInput);
// EXTERNAL MODULE: ./client/app/shared/components/TaggedInput/CustomTaggedInput/StoresInput/SIStyles.scss
var SIStyles = __webpack_require__("sWbZ");
var SIStyles_default = /*#__PURE__*/__webpack_require__.n(SIStyles);

// CONCATENATED MODULE: ./client/app/shared/components/TaggedInput/CustomTaggedInput/StoresInput/SIIndex.jsx
/* eslint-disable jsx-a11y/no-static-element-interactions */





var SIIndex_StoresInput = function StoresInput(_ref) {
  var storeNumber = _ref.storeNumber,
      storeName = _ref.storeName,
      removeStoreZips = _ref.removeStoreZips,
      addStoreZips = _ref.addStoreZips;
  return react_default.a.createElement(
    'div',
    { className: SIStyles_default.a.tag },
    react_default.a.createElement(
      'div',
      null,
      storeNumber !== null ? storeName + ' -' : '' + storeName
    ),
    react_default.a.createElement(
      'div',
      { className: SIStyles_default.a.storeNumber },
      storeNumber
    ),
    react_default.a.createElement(
      'div',
      { className: SIStyles_default.a.add, onClick: function onClick() {
          return addStoreZips(storeName);
        } },
      react_default.a.createElement(
        'div',
        null,
        'Add Back'
      ),
      react_default.a.createElement(
        'div',
        null,
        '+'
      )
    ),
    react_default.a.createElement(
      'div',
      { className: SIStyles_default.a.remove, onClick: function onClick() {
          return removeStoreZips(storeName);
        } },
      react_default.a.createElement(
        'div',
        null,
        'Remove'
      ),
      react_default.a.createElement(
        'div',
        null,
        '-'
      )
    )
  );
};

SIIndex_StoresInput.propTypes = {
  storeNumber: prop_types_default.a.string,
  storeName: prop_types_default.a.string,
  removeStoreZips: prop_types_default.a.func,
  addStoreZips: prop_types_default.a.func
};

SIIndex_StoresInput.defaultProps = {
  storeNumber: '',
  storeName: ''
};

/* harmony default export */ var SIIndex = (SIIndex_StoresInput);
// EXTERNAL MODULE: ./client/app/shared/components/TaggedInput/CustomTaggedInput/ZipsInput/ZIStyles.scss
var ZIStyles = __webpack_require__("4cbU");
var ZIStyles_default = /*#__PURE__*/__webpack_require__.n(ZIStyles);

// CONCATENATED MODULE: ./client/app/shared/components/TaggedInput/CustomTaggedInput/ZipsInput/ZIIndex.jsx
/* eslint-disable jsx-a11y/no-static-element-interactions */





var ZIIndex_ZipsInput = function ZipsInput(_ref) {
  var value = _ref.value,
      removeZipCode = _ref.removeZipCode;
  return react_default.a.createElement(
    'div',
    { className: ZIStyles_default.a.tag },
    react_default.a.createElement(
      'div',
      null,
      value
    ),
    react_default.a.createElement(
      'div',
      {
        className: ZIStyles_default.a.remove,
        onClick: function onClick() {
          return removeZipCode(value);
        }
      },
      'x'
    )
  );
};

ZIIndex_ZipsInput.propTypes = {
  value: prop_types_default.a.string,
  removeZipCode: prop_types_default.a.func
};

ZIIndex_ZipsInput.defaultProps = { value: '' };

/* harmony default export */ var ZIIndex = (ZIIndex_ZipsInput);
// EXTERNAL MODULE: ./client/app/shared/components/TaggedInput/CustomTaggedInput/CTIStyles.scss
var CTIStyles = __webpack_require__("PgQY");
var CTIStyles_default = /*#__PURE__*/__webpack_require__.n(CTIStyles);

// CONCATENATED MODULE: ./client/app/shared/components/TaggedInput/CustomTaggedInput/CTIIndex.jsx
var CTIIndex__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function CTIIndex__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function CTIIndex__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function CTIIndex__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function CTIIndex__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable jsx-a11y/no-static-element-interactions */










var CTIIndex_CustomTaggedInput = function (_Component) {
  CTIIndex__inherits(CustomTaggedInput, _Component);

  function CustomTaggedInput(props) {
    CTIIndex__classCallCheck(this, CustomTaggedInput);

    var _this = CTIIndex__possibleConstructorReturn(this, (CustomTaggedInput.__proto__ || Object.getPrototypeOf(CustomTaggedInput)).call(this, props));

    Object.defineProperty(_this, 'componentDidMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        var storeZipsDict = _this.state.storeZipsDict;
        // If crew has a zip under a store that was removed by that store,-
        // remove the zip from that store in crew's zips (if not on any other store,-
        // move to 'Additional Zip Codes'

        _this.moveZipsRemovedFromStores();
        // If crew has zips in 'Additional Zip Codes' check if any relevant stores cover any of these-
        // zips and fill the stores in the ui
        if (storeZipsDict['Additional Zip Codes'].length > 0) {
          var updatedSZD = _this.filterAddZipsIntoStores(storeZipsDict);
          _this.updateState(updatedSZD);
        } else _this.updateState(storeZipsDict);
      }
    });
    Object.defineProperty(_this, 'componentDidUpdate', {
      enumerable: true,
      writable: true,
      value: function value(prevProps, prevState) {
        var storeZipsDict = _this.state.storeZipsDict;
        var workroomChange = _this.props.workroomChange;


        if (prevState.storeZipsDict !== storeZipsDict) {
          // Removes any zip from "Additional Zip Codes" that belongs to a store when store is populated
          _this.onStorePopulate(storeZipsDict);
        }

        // Handle removal and addition of workrooms
        if (workroomChange && prevProps.workroomChange !== workroomChange) {
          // Returns the new storeZipsDict object after workroom is removed
          var szd = _this.removeIrrelevantStores();
          // When a workroom is added and a zip in 'Additional Zip Codes' section belongs to a store-
          // that belongs to one of those workrooms, filter that zip into that store.
          var updatedSZD = _this.filterAddZipsIntoStores(szd);
          _this.updateState(updatedSZD);
        }
      }
    });
    Object.defineProperty(_this, 'onStorePopulate', {
      enumerable: true,
      writable: true,
      value: function value(storeZipsDict) {
        var storeZipsDictReplica = Object.assign({}, storeZipsDict);
        var storeZipCodesSet = new Set();
        Object.values(storeZipsDict).forEach(function (szdVal) {
          if (!Array.isArray(szdVal)) {
            szdVal.storeZips.forEach(function (zip) {
              return storeZipCodesSet.add(zip);
            });
          }
        });
        var storeZipCodesArr = Array.from(storeZipCodesSet);
        var additionalZipsCopy = storeZipsDict['Additional Zip Codes'].slice();
        var zipIncluded = false;
        storeZipsDict['Additional Zip Codes'].forEach(function (zip) {
          if (storeZipCodesArr.includes(zip)) {
            zipIncluded = true;
            additionalZipsCopy.splice(additionalZipsCopy.indexOf(zip), 1);
          }
        });
        storeZipsDictReplica['Additional Zip Codes'] = additionalZipsCopy;
        if (zipIncluded) _this.updateState(storeZipsDictReplica);
      }
    });
    Object.defineProperty(_this, 'onAddtlZipChange', {
      enumerable: true,
      writable: true,
      value: function value(additionalZips, targetZips) {
        // can be an array of multiple zips if copy/pasted
        var zipsToAdd = targetZips.filter(function (zip) {
          return additionalZips.includes(zip);
        });
        // if zip(s) is added, add to storeZipsDict object
        // else if zip is removed, remove from 'Additional Zips' section of storeZipsDict
        if (zipsToAdd.length > 0) _this.addToStoreZipsDict(zipsToAdd);else _this.removeFromStoreZipsDict(targetZips[0]);
      }
    });
    Object.defineProperty(_this, 'setStoreZips', {
      enumerable: true,
      writable: true,
      value: function value(storeZipsDict) {
        var storeZipsArr = [];
        var crewWorkrooms = _this.getRelevantWorkrooms();
        crewWorkrooms.forEach(function (w) {
          return w.store_with_zips.forEach(function (swz) {
            var store = swz.store;

            var matchedZips = storeZipsDict[store.name] ? storeZipsDict[store.name].storeZips : [];
            var uniqueMatchedZips = [].concat(CTIIndex__toConsumableArray(new Set(matchedZips)));
            storeZipsArr.push({
              storeNum: store.number,
              storeName: store.name,
              coveredZips: [].concat(CTIIndex__toConsumableArray(uniqueMatchedZips))
            });
          });
        });
        return storeZipsArr;
      }
    });
    Object.defineProperty(_this, 'getRelevantWorkrooms', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            crew = _this$props.crew,
            allWorkrooms = _this$props.allWorkrooms;

        var crewWorkrooms = [];
        if (typeof crew.workrooms[0] === 'number') {
          crewWorkrooms = allWorkrooms.filter(function (workroom) {
            return crew.workrooms.includes(workroom.id);
          });
        }
        // When adding/removing workrooms on form, workrooms come back as an object
        if (CTIIndex__typeof(crew.workrooms[0]) === 'object') {
          var workroomsArr = crew.workrooms.map(function (workroom) {
            return workroom.value;
          });
          crewWorkrooms = allWorkrooms.filter(function (workroom) {
            return workroomsArr.includes(workroom.id);
          });
        }
        return crewWorkrooms;
      }
    });
    Object.defineProperty(_this, 'moveZipsRemovedFromStores', {
      enumerable: true,
      writable: true,
      value: function value() {
        var storeZipsDict = _this.state.storeZipsDict;

        var szdReplica = Object.assign({}, storeZipsDict);
        var crewWorkrooms = _this.getRelevantWorkrooms();
        crewWorkrooms.forEach(function (w) {
          return w.store_with_zips.forEach(function (swz) {
            var store = swz.store;

            if (szdReplica[store.name]) {
              var zipsToRemoveFromStore = [];
              szdReplica[store.name].storeZips.forEach(function (zip) {
                if (!store.covered_zip_codes.includes(zip)) zipsToRemoveFromStore.push(zip);
              });
              var newStoreZips = szdReplica[store.name].storeZips.filter(function (zip) {
                return !zipsToRemoveFromStore.includes(zip);
              });
              szdReplica[store.name].storeZips = newStoreZips;
              _this.addToStoreZipsDict(zipsToRemoveFromStore);
            }
          });
        });
        _this.updateState(szdReplica);
      }
    });
    Object.defineProperty(_this, 'filterAddZipsIntoStores', {
      enumerable: true,
      writable: true,
      value: function value(storeZipsDict) {
        var zipsToRemoveFromAddZips = new Set();
        var storeZipsDictReplica = Object.assign({}, storeZipsDict);
        var additionalZips = storeZipsDictReplica['Additional Zip Codes'];
        var crewWorkrooms = _this.getRelevantWorkrooms();
        crewWorkrooms.forEach(function (w) {
          return w.store_with_zips.forEach(function (swz) {
            var store = swz.store;

            store.covered_zip_codes.forEach(function (zip) {
              var zipUsed = false;
              if (additionalZips.includes(zip)) {
                zipUsed = true;
                // create the entry in the storeZipsDict object if one doesn't already exist
                if (!storeZipsDictReplica[store.name]) {
                  storeZipsDictReplica[store.name] = {
                    storeNum: store.number,
                    storeZips: [zip]
                  };
                } else if (!storeZipsDictReplica[store.name].storeZips.includes(zip)) {
                  storeZipsDictReplica[store.name].storeZips.push(zip);
                  storeZipsDictReplica[store.name].storeZips.sort(function (a, b) {
                    return a - b;
                  });
                }
              }
              if (zipUsed === true) zipsToRemoveFromAddZips.add(zip);
            });
          });
        });
        // Remove the zips from "Additional Zip Code" section that belonged to other stores
        Array.from(zipsToRemoveFromAddZips).forEach(function (zip) {
          var idx = additionalZips.indexOf(zip);
          additionalZips.splice(idx, 1);
        });
        return storeZipsDictReplica;
      }
    });
    Object.defineProperty(_this, 'storeZipsEmpty', {
      enumerable: true,
      writable: true,
      value: function value(storeZipsDict) {
        var dictClone = Object.assign({}, storeZipsDict);
        delete dictClone['Additional Zip Codes'];
        return !Object.values(dictClone).some(function (s) {
          return (s.storeZips.length || []) > 0;
        });
      }
    });
    Object.defineProperty(_this, 'crewZipsEmpty', {
      enumerable: true,
      writable: true,
      value: function value(storeZipsDict) {
        return (Object.keys(storeZipsDict).length === 1 || _this.storeZipsEmpty(storeZipsDict)) && storeZipsDict['Additional Zip Codes'].length < 1;
      }
    });
    Object.defineProperty(_this, 'addChosenStoresZips', {
      enumerable: true,
      writable: true,
      value: function value(storeName) {
        var storeZipsDict = _this.state.storeZipsDict;

        var storeZipsDictReplica = Object.assign({}, storeZipsDict);
        var crewWorkrooms = _this.getRelevantWorkrooms();
        for (var i = 0; i < crewWorkrooms.length; i += 1) {
          var workroom = crewWorkrooms[i];
          for (var j = 0; j < workroom.store_with_zips.length; j += 1) {
            var stores = workroom.store_with_zips;
            if (stores[j].store.name === storeName) {
              var _stores$j$store = stores[j].store,
                  number = _stores$j$store.number,
                  covered_zip_codes = _stores$j$store.covered_zip_codes;

              var storesCoveredZipsCopy = covered_zip_codes.slice();
              if (storeZipsDictReplica[storeName]) {
                storeZipsDictReplica[storeName].storeZips = storesCoveredZipsCopy;
              } else {
                storeZipsDictReplica[storeName] = {
                  storeNum: number,
                  storeZips: storesCoveredZipsCopy
                };
              }
            }
          }
        }
        _this.updateState(storeZipsDictReplica);
      }
    });
    Object.defineProperty(_this, 'removeZipCode', {
      enumerable: true,
      writable: true,
      value: function value(zip) {
        var storeZipsDict = _this.state.storeZipsDict;

        var storeZipsDictReplica = Object.assign({}, storeZipsDict);
        Object.values(storeZipsDictReplica).forEach(function (szdVal) {
          if (!Array.isArray(szdVal) && szdVal.storeZips.includes(zip)) {
            var zipIndex = szdVal.storeZips.indexOf(zip);
            szdVal.storeZips.splice(zipIndex, 1);
          }
        });
        _this.updateState(storeZipsDictReplica);
      }
    });
    Object.defineProperty(_this, 'addToStoreZipsDict', {
      enumerable: true,
      writable: true,
      value: function value(zips) {
        var storeZipsDict = _this.state.storeZipsDict;

        var zipsArr = Array.isArray(zips) ? zips : [zips];
        var storeZipsDictReplica = Object.assign({}, storeZipsDict);
        var crewWorkrooms = _this.getRelevantWorkrooms();
        zipsArr.forEach(function (zip) {
          var zipBelongsToStore = false;
          crewWorkrooms.forEach(function (w) {
            return w.store_with_zips.forEach(function (swz) {
              var store = swz.store;
              // if zip belongs to a store, add it to one of the storeZipsDict store's entries

              if (store.covered_zip_codes.includes(zip)) {
                zipBelongsToStore = true;
                // create the entry in the storeZipsDict object if one doesn't already exist
                if (!storeZipsDictReplica[store.name]) {
                  storeZipsDictReplica[store.name] = {
                    storeNum: store.number,
                    storeZips: [zip]
                  };
                } else if (!storeZipsDictReplica[store.name].storeZips.includes(zip)) {
                  storeZipsDictReplica[store.name].storeZips.push(zip);
                  storeZipsDictReplica[store.name].storeZips.sort(function (a, b) {
                    return a - b;
                  });
                }
              }
            });
          });
          // if zip does not belong to a store, add to the 'Additional Zip Codes' section
          var szdrAddZips = storeZipsDictReplica['Additional Zip Codes'];
          if (!zipBelongsToStore && !szdrAddZips.includes(zip)) szdrAddZips.push(zip);
        });
        _this.updateState(storeZipsDictReplica);
      }
    });
    Object.defineProperty(_this, 'removeChosenStoresZips', {
      enumerable: true,
      writable: true,
      value: function value(storeName) {
        var storeZipsDict = _this.state.storeZipsDict;

        var storeZipsDictReplica = Object.assign({}, storeZipsDict);
        delete storeZipsDictReplica[storeName];
        _this.updateState(storeZipsDictReplica);
      }
    });
    Object.defineProperty(_this, 'updateState', {
      enumerable: true,
      writable: true,
      value: function value(newStoreZipsDict) {
        var zipsFromStoreZipsDictSet = new Set();
        Object.values(newStoreZipsDict).forEach(function (szdVal) {
          if (!Array.isArray(szdVal)) {
            szdVal.storeZips.forEach(function (zip) {
              return zipsFromStoreZipsDictSet.add(zip);
            });
          } else {
            szdVal.forEach(function (zip) {
              return zipsFromStoreZipsDictSet.add(zip);
            });
          }
        });
        var zipsFromStoreZipsDictArr = Array.from(zipsFromStoreZipsDictSet).sort(function (a, b) {
          return a - b;
        });
        var newStoreZips = _this.setStoreZips(newStoreZipsDict);
        _this.setState({
          storeZipsDict: newStoreZipsDict,
          storeZips: newStoreZips
        }, function () {
          var updateObj = { zipsFromStoreZipsDictArr: zipsFromStoreZipsDictArr, newStoreZipsDict: newStoreZipsDict };
          _this.props.onCrewZipChange('covered_zip_codes', updateObj);
        });
      }
    });
    Object.defineProperty(_this, 'removeFromStoreZipsDict', {
      enumerable: true,
      writable: true,
      value: function value(zip) {
        var storeZipsDict = _this.state.storeZipsDict;

        var storeZipsDictReplica = Object.assign({}, storeZipsDict);
        var targetZipIndex = storeZipsDictReplica['Additional Zip Codes'].indexOf(zip);
        storeZipsDictReplica['Additional Zip Codes'].splice(targetZipIndex, 1);
        _this.updateState(storeZipsDictReplica);
      }
    });
    Object.defineProperty(_this, 'removeIrrelevantStores', {
      enumerable: true,
      writable: true,
      value: function value() {
        var crewWorkrooms = _this.getRelevantWorkrooms();
        var allStores = [];
        crewWorkrooms.forEach(function (w) {
          return w.store_with_zips.forEach(function (swz) {
            allStores.push(swz.store.name);
          });
        });
        var storeZipsDictReplica = Object.assign({}, _this.state.storeZipsDict);
        var storeZipsDictStores = Object.keys(storeZipsDictReplica);
        storeZipsDictStores.forEach(function (szdStore) {
          if (!allStores.includes(szdStore) && szdStore !== 'Additional Zip Codes') delete storeZipsDictReplica[szdStore];
        });
        return storeZipsDictReplica;
      }
    });
    Object.defineProperty(_this, 'removeAllZips', {
      enumerable: true,
      writable: true,
      value: function value() {
        var emptySZD = { 'Additional Zip Codes': [] };
        _this.updateState(emptySZD);
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$state = _this.state,
            storeZipsDict = _this$state.storeZipsDict,
            storeZips = _this$state.storeZips;
        // TODO: Hiding TWD - Remove "eslint-disable-next-line" when Dev up to date
        // eslint-disable-next-line

        var _this$props2 = _this.props,
            label = _this$props2.label,
            id = _this$props2.id,
            placeholder = _this$props2.placeholder,
            error = _this$props2.error,
            _this$props2$crew$tra = _this$props2.crew.traveling_zip_codes,
            traveling_zip_codes = _this$props2$crew$tra === undefined ? [] : _this$props2$crew$tra;

        var wrapperStyles = error ? TaggedInput_styles_default.a.wrapper + ' ' + input_default.a.errored : TaggedInput_styles_default.a.wrapper;
        var labelStyles = error ? TaggedInput_styles_default.a.label + ' ' + TaggedInput_styles_default.a.errorLabel : TaggedInput_styles_default.a.label;
        var errStyles = input_default.a.error + ' ' + TaggedInput_styles_default.a.error;
        var inputStyles = input_default.a.inputElement + ' ' + TaggedInput_styles_default.a.element;
        var pasteSplit = function pasteSplit(data) {
          return data.split(/[ ,]+/).map(function (d) {
            return d.trim();
          });
        };
        return react_default.a.createElement(
          'div',
          { className: wrapperStyles },
          react_default.a.createElement(
            'label',
            { className: labelStyles, htmlFor: id },
            label
          ),
          react_default.a.createElement(
            'div',
            { className: CTIStyles_default.a.contentContainer },
            traveling_zip_codes.length > 0 && react_default.a.createElement(
              'div',
              { className: CTIStyles_default.a.additionalZipsContainer },
              react_default.a.createElement(
                'div',
                { className: CTIStyles_default.a.additionalZipsHeader },
                'Traveling Zip Codes'
              ),
              react_default.a.createElement(react_tagsinput_default.a, {
                disabled: true,
                onlyUnique: true,
                id: id,
                value: traveling_zip_codes.sort(),
                onChange: function onChange() {},
                className: inputStyles,
                tagProps: { className: TaggedInput_styles_default.a.tag, classNameRemove: 'react-tagsinput-remove' },
                inputProps: { placeholder: placeholder, className: TaggedInput_styles_default.a.input }
              })
            ),
            react_default.a.createElement(
              'div',
              { className: CTIStyles_default.a.additionalZipsContainer },
              react_default.a.createElement(
                'div',
                { className: CTIStyles_default.a.additionalZipsHeaderAndRemoveAll },
                react_default.a.createElement(
                  'div',
                  { className: CTIStyles_default.a.additionalZipsHeader },
                  'Additional Zip Codes'
                ),
                react_default.a.createElement(
                  'div',
                  {
                    className: CTIStyles_default.a.removeAll,
                    onClick: function onClick() {
                      return _this.removeAllZips();
                    }
                  },
                  'Remove All'
                )
              ),
              react_default.a.createElement(react_tagsinput_default.a, {
                onlyUnique: true,
                id: id,
                value: storeZipsDict['Additional Zip Codes'].sort(function (a, b) {
                  return a - b;
                }),
                onChange: _this.onAddtlZipChange,
                addOnPaste: true,
                pasteSplit: pasteSplit,
                className: inputStyles,
                focusedClassName: input_default.a.inputElement,
                tagProps: { className: TaggedInput_styles_default.a.tag, classNameRemove: 'react-tagsinput-remove' },
                inputProps: { placeholder: placeholder, className: TaggedInput_styles_default.a.input },
                validationRegex: /^[^\s]+(\s+[^\s]+)*$/
              })
            ),
            storeZips.map(function (storeWithZips) {
              return react_default.a.createElement(
                'div',
                { key: 'store_' + storeWithZips.storeNum },
                react_default.a.createElement(SIIndex, {
                  storeNumber: storeWithZips.storeNum,
                  storeName: storeWithZips.storeName,
                  removeStoreZips: _this.removeChosenStoresZips,
                  addStoreZips: _this.addChosenStoresZips
                }),
                react_default.a.createElement(
                  'div',
                  { className: CTIStyles_default.a.zipsContainer },
                  storeWithZips.coveredZips.length > 0 && storeWithZips.coveredZips.sort().map(function (zip) {
                    return react_default.a.createElement(ZIIndex, {
                      key: zip,
                      value: zip,
                      removeZipCode: _this.removeZipCode
                    });
                  })
                )
              );
            })
          ),
          error && react_default.a.createElement(
            'div',
            { className: errStyles },
            react_default.a.createElement(
              'p',
              { className: TaggedInput_styles_default.a.errors },
              error
            )
          )
        );
      }
    });

    _this.state = {
      storeZips: [],
      storeZipsDict: _this.props.crew.store_zips_dictionary || { 'Additional Zip Codes': [] }
    };
    return _this;
  }

  // Determines which function to call based on if a zip is added or removed from the-
  // "Additional Zips" section


  // Get all workrooms associated with the crew


  // Add back all of the chosen store's zips to storeZipsDict and crew.covered_zip_codes


  // Remove every occurence of a single zip code


  // When a zip is typed or copy/pasted into "Additional Zip Codes" section, it'll filter into the-
  // respective store, if the store has that zip in their covered_zip_codes, otherwise if no-
  // store has the zip, it gets added to "Additional Zips"


  // Remove all of the chosen store's zips from storeZipsDict by deleting entire entry


  // Grabs all the zip codes from the storeZipsDict read object and updates-
  // the crew's covered_zip_codes and storeZipsDict object in the state


  // Removes a zip from the "Additional Zips" section, thereby removing it from storeZipsDict-
  // and from crew.covered_zip_codes


  return CustomTaggedInput;
}(react["Component"]);

CTIIndex_CustomTaggedInput.propTypes = {
  label: prop_types_default.a.string.isRequired,
  id: prop_types_default.a.string.isRequired,
  onCrewZipChange: prop_types_default.a.func,
  placeholder: prop_types_default.a.string,
  errors: prop_types_default.a.oneOfType([prop_types_default.a.array, prop_types_default.a.string]),
  crew: prop_types_default.a.object,
  allWorkrooms: prop_types_default.a.array,
  workroomChange: prop_types_default.a.bool
};

CTIIndex_CustomTaggedInput.defaultProps = {
  label: '',
  id: '',
  errors: '',
  placeholder: ''
};

/* harmony default export */ var CTIIndex = (CTIIndex_CustomTaggedInput);
// CONCATENATED MODULE: ./client/app/screens/main/screens/installers/components/crewForm.jsx
function crewForm__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function crewForm__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function crewForm__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















// import RadioButtons from 'components/RadioButtons';







var crewForm_removeButton = classnames_default()(form_default.a.cancelButton, form_default.a.actionButton, common_default.a.floatRight, crewForm_default.a.removeButtonFloatFix);

var crewForm_CrewForm = function (_Component) {
  crewForm__inherits(CrewForm, _Component);

  function CrewForm(props) {
    crewForm__classCallCheck(this, CrewForm);

    var _this = crewForm__possibleConstructorReturn(this, (CrewForm.__proto__ || Object.getPrototypeOf(CrewForm)).call(this, props));

    crewForm__initialiseProps.call(_this);

    var _this$props = _this.props,
        onChange = _this$props.onChange,
        onSpecificChange = _this$props.onSpecificChange,
        onDelete = _this$props.onDelete,
        index = _this$props.index;

    _this.handleDelete = function () {
      return onDelete(index);
    };
    _this.showError = utils["s" /* nestedError */].bind(_this, 'crews', index);
    _this.onNameChange = onChange.bind(_this, 'name');
    _this.onPriorityChange = onChange.bind(_this, 'priority');
    _this.onActiveChange = onChange.bind(_this, 'active');
    _this.onUseInstallerPayChange = onChange.bind(_this, 'use_installer_pay');
    _this.onPOCNameChange = onChange.bind(_this, 'poc_name');
    _this.onPhoneNumberChange = onChange.bind(_this, 'phone_number');
    _this.onPhoneNumberTypeChange = onChange.bind(_this, 'phone_number_type');
    _this.onEmailChange = onChange.bind(_this, 'email');
    _this.onBadgeNumberChange = onChange.bind(_this, 'badge_number');
    _this.onBadgeExpirationChange = onChange.bind(_this, 'badge_expiration');
    _this.onBadgeLinkChange = onChange.bind(_this, 'badge_link');
    _this.onWorkroomsChange = onChange.bind(_this, 'workrooms');
    _this.onDefaultStartTimeChange = onChange.bind(_this, 'default_start_time');
    _this.onCommentsChange = onChange.bind(_this, 'comments');
    _this.onDeliveryChange = onChange.bind(_this, 'can_deliver');
    _this.onDeliveryDedicatedChange = onChange.bind(_this, 'delivery_dedicated');
    _this.onLoginableChange = onChange.bind(_this, 'loginable');
    _this.handleMaxTravelTime = onSpecificChange.bind(_this, 'max_travel_time');
    _this.handlePhoneCallNeeded = onSpecificChange.bind(_this, 'phone_call_needed');
    _this.handleHardwoodSfPerDay = onSpecificChange.bind(_this, 'hardwood_sf_per_day');
    _this.handleCarpetSfPerDay = onSpecificChange.bind(_this, 'carpet_sf_per_day');
    _this.handleTileSfPerDay = onSpecificChange.bind(_this, 'tile_sf_per_day');
    _this.handleLaminateSfPerDay = onSpecificChange.bind(_this, 'laminate_sf_per_day');
    _this.handleVinylSfPerDay = onSpecificChange.bind(_this, 'vinyl_sf_per_day');
    _this.handleVinylPlankSfPerDay = onSpecificChange.bind(_this, 'vinyl_plank_sf_per_day');
    // this.handleMillworkWindowPerDay = onSpecificChange.bind(this, 'millwork_window_per_day');
    // this.handleMillworkEntryDoorPerDay = onSpecificChange.bind(
    // this, 'millwork_entry_door_per_day');
    // this.handleMillworkSlidingDoorPerDay = onSpecificChange.bind(
    // this, 'millwork_sliding_door_per_day');
    // this.handleMillworkInteriorDoorPerDay = onSpecificChange.bind(
    // this, 'millwork_interior_door_per_day');
    _this.handleBacksplashSfPerDay = onSpecificChange.bind(_this, 'backsplash_sf_per_day');
    _this.handleCanSpeakEnglish = onSpecificChange.bind(_this, 'can_speak_english');
    _this.handleCanSpeakSpanish = onSpecificChange.bind(_this, 'can_speak_spanish');
    _this.handleCanMoveFurniture = onSpecificChange.bind(_this, 'can_move_furniture');
    _this.handleCanMoveFurnitureOversized = onSpecificChange.bind(_this, 'can_move_furniture_oversized');
    _this.handleCanMoveAppliances = onSpecificChange.bind(_this, 'can_move_appliances');
    _this.handleCanDoSubfloorPrep = onSpecificChange.bind(_this, 'can_do_subfloor_prep');
    _this.handleCanDoSubfloorReplacement = onSpecificChange.bind(_this, 'can_do_subfloor_replacement');
    _this.handleSameDayMultiSurface = onSpecificChange.bind(_this, 'same_day_multi_surface');
    _this.handleCanDoNaildownHardwood = onSpecificChange.bind(_this, 'can_do_naildown_hardwood');
    _this.handleCanDoGluedownHardwood = onSpecificChange.bind(_this, 'can_do_gluedown_hardwood');
    _this.handleCanDoFloatingHardwood = onSpecificChange.bind(_this, 'can_do_floating_hardwood');
    _this.handleCanDoCaliBambooHardwood = onSpecificChange.bind(_this, 'can_do_cali_bamboo_hardwood');
    _this.handleCanDoStepsHardwood = onSpecificChange.bind(_this, 'can_do_steps_hardwood');
    _this.handleCanDoStretchInCarpet = onSpecificChange.bind(_this, 'can_do_stretch_in_carpet');
    _this.handleCanDoGluedownCarpet = onSpecificChange.bind(_this, 'can_do_gluedown_carpet');
    _this.handleCanDoBindingCarpet = onSpecificChange.bind(_this, 'can_do_binding_carpet');
    _this.handleCanDoPatternMatchCarpet = onSpecificChange.bind(_this, 'can_do_pattern_match_carpet');
    _this.handleCanDoBerberCarpet = onSpecificChange.bind(_this, 'can_do_berber_carpet');
    _this.handleCanDoStepsCarpet = onSpecificChange.bind(_this, 'can_do_steps_carpet');
    _this.handleCanDoFloorTile = onSpecificChange.bind(_this, 'can_do_floor_tile');
    _this.handleCanDoBacksplashTile = onSpecificChange.bind(_this, 'can_do_backsplash_tile');
    _this.handleCanDoBacksplashGlass = onSpecificChange.bind(_this, 'can_do_backsplash_glass');
    _this.handleCanDoBacksplashBlocking = onSpecificChange.bind(_this, 'can_do_backsplash_blocking');
    _this.handleCanDoPatternsTile = onSpecificChange.bind(_this, 'can_do_patterns_tile');
    _this.handleCanDoLargeFormatTile = onSpecificChange.bind(_this, 'can_do_large_format_tile');
    _this.handleCanDoVinylSheet = onSpecificChange.bind(_this, 'can_do_vinyl_sheet');
    _this.handleCanDoVinylTile = onSpecificChange.bind(_this, 'can_do_vct_lvt');
    _this.handleCanDoGluedownVinylPlank = onSpecificChange.bind(_this, 'can_do_gluedown_vinyl_plank');
    _this.handleCanDoFloatingVinylPlank = onSpecificChange.bind(_this, 'can_do_floating_vinyl_plank');
    _this.handleCanRemoveReplaceToilet = onSpecificChange.bind(_this, 'can_remove_replace_toilet');
    _this.handleCanRemoveNaildownHardwood = onSpecificChange.bind(_this, 'can_remove_naildown_hardwood');
    _this.handleCanRemoveFloatingHardwood = onSpecificChange.bind(_this, 'can_remove_floating_hardwood');
    _this.handleCanRemoveGluedownHardwood = onSpecificChange.bind(_this, 'can_remove_gluedown_hardwood');
    _this.handleCanRemoveOverPadCarpet = onSpecificChange.bind(_this, 'can_remove_over_pad_carpet');
    _this.handleCanRemoveGluedownCarpet = onSpecificChange.bind(_this, 'can_remove_gluedown_carpet');
    _this.handleCanRemoveLaminate = onSpecificChange.bind(_this, 'can_remove_laminate');
    _this.handleCanRemoveTile = onSpecificChange.bind(_this, 'can_remove_tile');
    _this.handleCanRemoveGluedownVinyl = onSpecificChange.bind(_this, 'can_remove_gluedown_vinyl');
    _this.handleCanRemoveVinylPlank = onSpecificChange.bind(_this, 'can_remove_vinyl_plank');
    _this.handleCanRemoveBacksplash = onSpecificChange.bind(_this, 'can_remove_backsplash');
    _this.handleCoveredZipCodes = onChange.bind(_this, 'covered_zip_codes');
    _this.handleCanInstallBaseBoard = onSpecificChange.bind(_this, 'can_do_baseboard');
    _this.handleCanInstallHardsurfaceTransitions = onSpecificChange.bind(_this, 'can_install_hard_transitions');
    _this.state = { showApptWarningDialog: false };
    return _this;
  }

  return CrewForm;
}(react["Component"]);

var crewForm__initialiseProps = function _initialiseProps() {
  var _this2 = this;

  Object.defineProperty(this, 'getAvailabilityVal', {
    enumerable: true,
    writable: true,
    value: function value(day) {
      var _props$crew = _this2.props.crew,
          _props$crew$install_a = _props$crew.install_availability,
          install_availability = _props$crew$install_a === undefined ? [] : _props$crew$install_a,
          _props$crew$delivery_ = _props$crew.delivery_availability,
          delivery_availability = _props$crew$delivery_ === undefined ? [] : _props$crew$delivery_;

      if (install_availability.includes(day)) return day + '_install';
      if (delivery_availability.includes(day)) return day + '_delivery';
      return day + '_off';
    }
  });
  Object.defineProperty(this, 'dailyOptions', {
    enumerable: true,
    writable: true,
    value: function value() {
      // eslint-disable-next-line no-unused-vars
      var _props$crew2 = _this2.props.crew,
          _props$crew2$install_ = _props$crew2.install_availability,
          install_availability = _props$crew2$install_ === undefined ? [] : _props$crew2$install_,
          _props$crew2$delivery = _props$crew2.delivery_availability,
          delivery_availability = _props$crew2$delivery === undefined ? [] : _props$crew2$delivery;

      return [{ value: 1, label: 'Sunday' }, { value: 2, label: 'Monday' }, { value: 3, label: 'Tuesday' }, { value: 4, label: 'Wednesday' }, { value: 5, label: 'Thursday' }, { value: 6, label: 'Friday' }, { value: 7, label: 'Saturday' }];
      // not filter based on unused appt availability for now
      // .filter(o => install_availability.concat(delivery_availability).includes(o.value));
    }
  });
  Object.defineProperty(this, 'handleApptWarningModal', {
    enumerable: true,
    writable: true,
    value: function value(display) {
      return _this2.setState({ showApptWarningDialog: display });
    }
  });
  Object.defineProperty(this, 'render', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _props = _this2.props,
          errors = _props.errors,
          crew = _props.crew,
          onSurfaceTypesChange = _props.onSurfaceTypesChange,
          allWorkrooms = _props.allWorkrooms,
          canRemoveCrew = _props.canRemoveCrew,
          canEdit = _props.canEdit,
          canEditBasic = _props.canEditBasic,
          workroomChange = _props.workroomChange,
          onDailyChange = _props.onDailyChange,
          onChange = _props.onChange,
          onAvailabilityChange = _props.onAvailabilityChange,
          crewFieldWarnings = _props.crewFieldWarnings,
          fieldError = _props.fieldError;
      var showApptWarningDialog = _this2.state.showApptWarningDialog;

      var largeInput = classnames_default()(form_default.a.childInputs, form_default.a.largeInput);
      var mediumInput = classnames_default()(form_default.a.childInputs, form_default.a.mediumInput, form_default.a.smallPadding);
      var workroomOptions = Object(utils["j" /* generateSource */])(allWorkrooms);
      var shouldShowRemoveButton = (crew.id === null || crew.id === undefined) && canEdit && canRemoveCrew;
      var crewContainerStyles = classnames_default()([crewForm_default.a.crewContainer, form_default.a.childCard]);
      var crewSpecific = crew.crew_specific || {};
      var canEditSpecifics = canEdit || canEditBasic;
      var dailyAvailability = crew.daily_availability ? crew.daily_availability : { morning: [2, 3, 4, 5, 6], afternoon: [2, 3, 4, 5, 6] };
      return react_default.a.createElement(
        'div',
        { className: crewContainerStyles },
        react_default.a.createElement(
          'div',
          { className: crewForm_default.a.mobileHeaderContainer },
          react_default.a.createElement(
            flexbox_react_dist_default.a,
            null,
            react_default.a.createElement(react_toolbox_lib["Input"], {
              label: 'Crew Name',
              value: crew.name,
              className: mediumInput,
              error: fieldError('name', crewFieldWarnings),
              required: true,
              onChange: _this2.onNameChange,
              disabled: !canEdit
            }),
            react_default.a.createElement(components_StyledSelect, {
              name: 'priority',
              label: 'Delivery Priority',
              required: true,
              className: mediumInput,
              options: [{ value: 1, label: 1 }, { value: 2, label: 2 }, { value: 3, label: 3 }, { value: 4, label: 4 }, { value: 5, label: 5 }],
              value: crew.priority || 5,
              onChange: _this2.onPriorityChange,
              placeholder: 'Assign priority to crew',
              disabled: !canEdit,
              error: _this2.showError('priority', errors)
            })
          ),
          react_default.a.createElement(
            flexbox_react_dist_default.a,
            null,
            react_default.a.createElement(
              'div',
              { className: crewForm_default.a.switchStyling },
              react_default.a.createElement(react_toolbox_lib["Switch"], {
                name: 'active',
                label: 'Crew Active',
                onChange: ((crew || {}).appointments || []).length ? function () {
                  return _this2.handleApptWarningModal(true);
                } : _this2.onActiveChange,
                theme: crewForm_default.a,
                checked: crew.active || false,
                disabled: !canEdit
              }),
              react_default.a.createElement(react_toolbox_lib["Switch"], {
                name: 'active',
                label: 'Use Installer Pay',
                onChange: _this2.onUseInstallerPayChange,
                theme: crewForm_default.a,
                checked: crew.use_installer_pay,
                disabled: !canEdit
              }),
              react_default.a.createElement(react_toolbox_lib["Switch"], {
                name: 'delivery',
                label: 'Delivery',
                onChange: _this2.onDeliveryChange,
                theme: crewForm_default.a,
                checked: crew.can_deliver || false,
                disabled: !canEditBasic
              }),
              react_default.a.createElement(react_toolbox_lib["Switch"], {
                name: 'delivery_dedicated',
                label: 'Delivery Dedicated',
                onChange: _this2.onDeliveryDedicatedChange,
                theme: crewForm_default.a,
                checked: crew.delivery_dedicated || false,
                disabled: !canEditBasic
              }),
              react_default.a.createElement(react_toolbox_lib["Switch"], {
                name: 'loginable',
                label: 'Can Login',
                onChange: _this2.onLoginableChange,
                theme: crewForm_default.a,
                checked: crew.loginable,
                disabled: !canEditSpecifics
              })
            )
          ),
          react_default.a.createElement('br', null)
        ),
        react_default.a.createElement(
          'div',
          { className: crewForm_default.a.mobileInstallerInfoContainer },
          react_default.a.createElement(
            flexbox_react_dist_default.a,
            null,
            react_default.a.createElement(react_toolbox_lib["Input"], {
              label: 'Contact Name',
              value: crew.poc_name,
              className: largeInput,
              error: fieldError('poc_name', crewFieldWarnings),
              required: true,
              onChange: _this2.onPOCNameChange,
              disabled: !canEdit
            }),
            react_default.a.createElement(
              PhoneType_PhoneInput,
              {
                label: 'Phone Number',
                type: 'tel',
                value: crew.phone_number,
                className: largeInput,
                error: fieldError('phone_number', crewFieldWarnings),
                onChange: _this2.onPhoneNumberChange,
                required: true,
                disabled: !canEditSpecifics
              },
              react_default.a.createElement(components_PhoneType, {
                source: constants["_16" /* PHONE_TYPES_W_FAX */],
                value: crew.phone_number_type,
                onChange: _this2.onPhoneNumberTypeChange
              })
            ),
            react_default.a.createElement(react_toolbox_lib["Input"], {
              label: 'Email Address',
              value: crew.email,
              className: largeInput,
              error: _this2.showError('email', errors) || fieldError('email', crewFieldWarnings),
              onChange: _this2.onEmailChange,
              disabled: !canEditSpecifics
            })
          )
        ),
        react_default.a.createElement(
          'div',
          { className: crewForm_default.a.mobileInstallerInfoContainer },
          react_default.a.createElement(
            flexbox_react_dist_default.a,
            null,
            react_default.a.createElement(react_toolbox_lib["Input"], {
              label: 'Badge Number',
              value: crew.badge_number,
              className: largeInput,
              error: fieldError('badge_number', crewFieldWarnings),
              required: true,
              onChange: _this2.onBadgeNumberChange,
              disabled: !canEdit
            }),
            react_default.a.createElement(DatePicker, {
              label: 'Badge expiration',
              className: largeInput,
              value: crew.badge_expiration,
              onChange: _this2.onBadgeExpirationChange,
              error: fieldError('badge_expiration', crewFieldWarnings),
              required: true,
              disabled: !canEdit
            }),
            react_default.a.createElement(react_toolbox_lib["Input"], {
              label: 'Badge Link',
              value: crew.badge_link || '',
              className: largeInput,
              error: _this2.showError('badge_link', errors),
              onChange: _this2.onBadgeLinkChange,
              disabled: !canEdit
            })
          )
        ),
        react_default.a.createElement(
          flexbox_react_dist_default.a,
          null,
          react_default.a.createElement(
            'div',
            null,
            react_default.a.createElement(formElements_SurfaceTypesCheckbox, {
              selectedSurfaceTypes: crew.surface_types,
              error: fieldError('surface_types', crewFieldWarnings),
              onChange: onSurfaceTypesChange,
              required: true
            })
          ),
          react_default.a.createElement(
            'div',
            null,
            react_default.a.createElement(components_TimeInput, {
              label: 'Default Start Time',
              value: crew.default_start_time,
              onChange: _this2.onDefaultStartTimeChange,
              errors: errors.default_start_time
            })
          )
        ),
        react_default.a.createElement('br', null),
        react_default.a.createElement(
          flexbox_react_dist_default.a,
          null,
          react_default.a.createElement(
            'div',
            { className: form_default.a.formElementContainer },
            react_default.a.createElement(react_select, {
              multi: true,
              name: 'crewsWorkrooms',
              label: 'Workrooms',
              required: true,
              className: ReactSelect_styles_default.a.selectWrapper,
              options: workroomOptions,
              value: crew.workrooms,
              onChange: _this2.onWorkroomsChange,
              placeholder: 'Assign workroom(s) to crews',
              error: fieldError('workrooms', crewFieldWarnings)
            })
          ),
          react_default.a.createElement(CTIIndex, {
            label: 'Assign Zip Code(s) to Crew',
            id: 'covered_zip_codes',
            crew: crew,
            allWorkrooms: allWorkrooms,
            onCrewZipChange: onChange,
            workroomChange: workroomChange,
            error: fieldError('covered_zip_codes', crewFieldWarnings)
          })
        ),
        react_default.a.createElement(
          'div',
          { className: form_default.a.crewSpecsContainer },
          react_default.a.createElement(
            'h5',
            { className: form_default.a.childTitle },
            'Daily ',
            crew.delivery_dedicated ? 'Delivery' : '',
            ' Availabilities'
          )
        ),
        react_default.a.createElement('br', null),
        react_default.a.createElement(
          flexbox_react_dist_default.a,
          null,
          react_default.a.createElement(react_select, {
            multi: true,
            name: 'morningAvailability',
            label: (crew.delivery_dedicated ? 'Morning' : 'Installation') + ' Availability',
            required: true,
            className: ReactSelect_styles_default.a.selectWrapper,
            options: _this2.dailyOptions(),
            value: dailyAvailability.morning,
            onChange: function onChange(val) {
              return onDailyChange('morning', val.map(function (v) {
                return v.value;
              }));
            },
            placeholder: 'Assign daily ' + (crew.delivery_dedicated ? 'morning' : '') + ' availability to crews',
            error: _this2.showError('daily_availability', errors)
          }),
          crew.delivery_dedicated && react_default.a.createElement(react_select, {
            multi: true,
            name: 'afternoonAvailability',
            label: 'Afternoon Availability',
            required: true,
            className: ReactSelect_styles_default.a.selectWrapper,
            options: _this2.dailyOptions(),
            value: dailyAvailability.afternoon,
            onChange: function onChange(val) {
              return onDailyChange('afternoon', val.map(function (v) {
                return v.value;
              }));
            },
            placeholder: 'Assign daily afternoon availability to crews',
            error: _this2.showError('daily_availability', errors)
          })
        ),
        react_default.a.createElement(
          'div',
          { className: form_default.a.crewSpecsContainer },
          react_default.a.createElement(
            'h5',
            { className: form_default.a.childTitle },
            'Crew Specifics'
          )
        ),
        react_default.a.createElement('br', null),
        react_default.a.createElement(
          flexbox_react_dist_default.a,
          null,
          react_default.a.createElement(react_toolbox_lib["Input"], {
            label: 'Max Travel Time (mins)',
            value: crewSpecific.max_travel_time,
            className: mediumInput,
            error: _this2.showError('max_travel_time', errors),
            required: true,
            onChange: _this2.handleMaxTravelTime,
            disabled: !canEditSpecifics
          }),
          react_default.a.createElement(
            'div',
            { className: crewForm_default.a.crewActiveSwitch },
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              name: 'phoneCallNeeded',
              label: 'Phone Call Needed',
              onChange: _this2.handlePhoneCallNeeded,
              theme: crewForm_default.a,
              checked: crewSpecific.phone_call_needed,
              disabled: !canEditSpecifics
            })
          )
        ),
        react_default.a.createElement(
          flexbox_react_dist_default.a,
          null,
          react_default.a.createElement(react_toolbox_lib["Input"], {
            label: 'Hardwood SQFT Per Day',
            value: crewSpecific.hardwood_sf_per_day,
            className: mediumInput,
            error: _this2.showError('hardwood_sf_per_day', errors),
            required: true,
            onChange: _this2.handleHardwoodSfPerDay,
            disabled: !canEditSpecifics
          }),
          react_default.a.createElement(react_toolbox_lib["Input"], {
            label: 'Carpet SQFT Per Day',
            value: crewSpecific.carpet_sf_per_day,
            className: mediumInput,
            error: _this2.showError('carpet_sf_per_day', errors),
            required: true,
            onChange: _this2.handleCarpetSfPerDay,
            disabled: !canEditSpecifics
          }),
          react_default.a.createElement(react_toolbox_lib["Input"], {
            label: 'Tile SQFT Per Day',
            value: crewSpecific.tile_sf_per_day,
            className: mediumInput,
            error: _this2.showError('tile_sf_per_day', errors),
            required: true,
            onChange: _this2.handleTileSfPerDay,
            disabled: !canEditSpecifics
          }),
          react_default.a.createElement(react_toolbox_lib["Input"], {
            label: 'Laminate SQFT Per Day',
            value: crewSpecific.laminate_sf_per_day,
            className: mediumInput,
            error: _this2.showError('laminate_sf_per_day', errors),
            required: true,
            onChange: _this2.handleLaminateSfPerDay,
            disabled: !canEditSpecifics
          }),
          react_default.a.createElement(react_toolbox_lib["Input"], {
            label: 'Vinyl SQFT Per Day',
            value: crewSpecific.vinyl_sf_per_day,
            className: mediumInput,
            error: _this2.showError('vinyl_sf_per_day', errors),
            required: true,
            onChange: _this2.handleVinylSfPerDay,
            disabled: !canEditSpecifics
          }),
          react_default.a.createElement(react_toolbox_lib["Input"], {
            label: 'Vinyl Plank SQFT Per Day',
            value: crewSpecific.vinyl_plank_sf_per_day,
            className: mediumInput,
            error: _this2.showError('vinyl_plank_sf_per_day', errors),
            required: true,
            onChange: _this2.handleVinylPlankSfPerDay,
            disabled: !canEditSpecifics
          }),
          react_default.a.createElement(react_toolbox_lib["Input"], {
            label: 'Backsplash SQFT Per Day',
            value: crewSpecific.backsplash_sf_per_day,
            className: mediumInput,
            error: _this2.showError('backsplash_sf_per_day', errors),
            required: true,
            onChange: _this2.handleBacksplashSfPerDay,
            disabled: !canEditSpecifics
          })
        ),
        react_default.a.createElement(
          'div',
          { className: crewForm_default.a.crewSwitchContainer },
          react_default.a.createElement(
            flexbox_react_dist_default.a,
            null,
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              name: 'speakEnglish',
              label: 'Speak English',
              onChange: _this2.handleCanSpeakEnglish,
              theme: crewForm_default.a,
              checked: crewSpecific.can_speak_english,
              disabled: !canEditSpecifics
            }),
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              name: 'speakSpanish',
              label: 'Speak Spanish',
              onChange: _this2.handleCanSpeakSpanish,
              theme: crewForm_default.a,
              checked: crewSpecific.can_speak_spanish,
              disabled: !canEditSpecifics
            }),
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              name: 'canMoveFurniture',
              label: 'Move Furniture',
              onChange: _this2.handleCanMoveFurniture,
              theme: crewForm_default.a,
              checked: crewSpecific.can_move_furniture,
              disabled: !canEditSpecifics
            }),
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              name: 'canMoveFurnitureOversized',
              label: 'Move Oversized Furniture',
              onChange: _this2.handleCanMoveFurnitureOversized,
              theme: crewForm_default.a,
              checked: crewSpecific.can_move_furniture_oversized,
              disabled: !canEditSpecifics
            }),
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              name: 'canMoveAppliances',
              label: 'Move Appliances',
              onChange: _this2.handleCanMoveAppliances,
              theme: crewForm_default.a,
              checked: crewSpecific.can_move_appliances,
              disabled: !canEditSpecifics
            }),
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              name: 'canDoSubfloorPrep',
              label: 'Subfloor Prep',
              onChange: _this2.handleCanDoSubfloorPrep,
              theme: crewForm_default.a,
              checked: crewSpecific.can_do_subfloor_prep,
              disabled: !canEditSpecifics
            }),
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              name: 'canDoSubfloorReplacement',
              label: 'Subfloor Replacement',
              onChange: _this2.handleCanDoSubfloorReplacement,
              theme: crewForm_default.a,
              checked: crewSpecific.can_do_subfloor_replacement,
              disabled: !canEditSpecifics
            }),
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              name: 'canDoNaildownHardwood',
              label: 'Naildown Hardwood',
              onChange: _this2.handleCanDoNaildownHardwood,
              theme: crewForm_default.a,
              checked: crewSpecific.can_do_naildown_hardwood,
              disabled: !canEditSpecifics
            }),
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              name: 'canDoGluedownHardwood',
              label: 'Gluedown Hardwood',
              onChange: _this2.handleCanDoGluedownHardwood,
              theme: crewForm_default.a,
              checked: crewSpecific.can_do_gluedown_hardwood,
              disabled: !canEditSpecifics
            }),
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              name: 'canDoFloatingHardwood',
              label: 'Floating Hardwood',
              onChange: _this2.handleCanDoFloatingHardwood,
              theme: crewForm_default.a,
              checked: crewSpecific.can_do_floating_hardwood,
              disabled: !canEditSpecifics
            })
          ),
          react_default.a.createElement(
            flexbox_react_dist_default.a,
            null,
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              name: 'canDoCaliBambooHardwood',
              label: 'Cali Bamboo',
              onChange: _this2.handleCanDoCaliBambooHardwood,
              theme: crewForm_default.a,
              checked: crewSpecific.can_do_cali_bamboo_hardwood,
              disabled: !canEditSpecifics
            }),
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              name: 'canDoStepsHardwood',
              label: 'Hardwood Steps',
              onChange: _this2.handleCanDoStepsHardwood,
              theme: crewForm_default.a,
              checked: crewSpecific.can_do_steps_hardwood,
              disabled: !canEditSpecifics
            }),
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              name: 'canDoStretchInCarpet',
              label: 'Stretch In Carpet',
              onChange: _this2.handleCanDoStretchInCarpet,
              theme: crewForm_default.a,
              checked: crewSpecific.can_do_stretch_in_carpet,
              disabled: !canEditSpecifics
            }),
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              name: 'canDoGluedownCarpet',
              label: 'Gluedown Carpet',
              onChange: _this2.handleCanDoGluedownCarpet,
              theme: crewForm_default.a,
              checked: crewSpecific.can_do_gluedown_carpet,
              disabled: !canEditSpecifics
            }),
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              name: 'canDoBindingCarpet',
              label: 'Binding Carpet',
              onChange: _this2.handleCanDoBindingCarpet,
              theme: crewForm_default.a,
              checked: crewSpecific.can_do_binding_carpet,
              disabled: !canEditSpecifics
            }),
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              name: 'canDoPatternMatchCarpet',
              label: 'Pattern Match Carpet',
              onChange: _this2.handleCanDoPatternMatchCarpet,
              theme: crewForm_default.a,
              checked: crewSpecific.can_do_pattern_match_carpet,
              disabled: !canEditSpecifics
            }),
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              name: 'canDoBerberCarpet',
              label: 'Berber Carpet',
              onChange: _this2.handleCanDoBerberCarpet,
              theme: crewForm_default.a,
              checked: crewSpecific.can_do_berber_carpet,
              disabled: !canEditSpecifics
            }),
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              name: 'canDoStepsCarpet',
              label: 'Carpet Steps',
              onChange: _this2.handleCanDoStepsCarpet,
              theme: crewForm_default.a,
              checked: crewSpecific.can_do_steps_carpet,
              disabled: !canEditSpecifics
            }),
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              name: 'canDoFloorTile',
              label: 'Floor Tile',
              onChange: _this2.handleCanDoFloorTile,
              theme: crewForm_default.a,
              checked: crewSpecific.can_do_floor_tile,
              disabled: !canEditSpecifics
            }),
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              name: 'canDoTilePatterns',
              label: 'Tile Patterns',
              onChange: _this2.handleCanDoPatternsTile,
              theme: crewForm_default.a,
              checked: crewSpecific.can_do_patterns_tile,
              disabled: !canEditSpecifics
            })
          ),
          react_default.a.createElement(
            flexbox_react_dist_default.a,
            null,
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              name: 'canLargeFormatTile',
              label: 'Large Format Tile',
              onChange: _this2.handleCanDoLargeFormatTile,
              theme: crewForm_default.a,
              checked: crewSpecific.can_do_large_format_tile,
              disabled: !canEditSpecifics
            }),
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              name: 'canDoBacksplashTile',
              label: 'Backsplash Tile',
              onChange: _this2.handleCanDoBacksplashTile,
              theme: crewForm_default.a,
              checked: crewSpecific.can_do_backsplash_tile,
              disabled: !canEditSpecifics
            }),
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              name: 'canDoBacksplashGlass',
              label: 'Glass Backsplash',
              onChange: _this2.handleCanDoBacksplashGlass,
              theme: crewForm_default.a,
              checked: crewSpecific.can_do_backsplash_glass,
              disabled: !canEditSpecifics
            }),
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              name: 'canDoBacksplashBlocking',
              label: 'Backsplash Blocking',
              onChange: _this2.handleCanDoBacksplashBlocking,
              theme: crewForm_default.a,
              checked: crewSpecific.can_do_backsplash_blocking,
              disabled: !canEditSpecifics
            }),
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              name: 'canDoVinylSheet',
              label: 'Sheet Vinyl',
              onChange: _this2.handleCanDoVinylSheet,
              theme: crewForm_default.a,
              checked: crewSpecific.can_do_vinyl_sheet,
              disabled: !canEditSpecifics
            }),
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              name: 'canDoVctLvt',
              label: 'Vinyl Tile',
              onChange: _this2.handleCanDoVinylTile,
              theme: crewForm_default.a,
              checked: crewSpecific.can_do_vct_lvt,
              disabled: !canEditSpecifics
            }),
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              name: 'canDoGluedownVinylPlank',
              label: 'Gluedown VP',
              onChange: _this2.handleCanDoGluedownVinylPlank,
              theme: crewForm_default.a,
              checked: crewSpecific.can_do_gluedown_vinyl_plank,
              disabled: !canEditSpecifics
            }),
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              name: 'canDoFloatingVinylPlank',
              label: 'Floating VP',
              onChange: _this2.handleCanDoFloatingVinylPlank,
              theme: crewForm_default.a,
              checked: crewSpecific.can_do_floating_vinyl_plank,
              disabled: !canEditSpecifics
            }),
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              name: 'canRemoveReplaceToilet',
              label: 'Remove/Replace Toilet',
              onChange: _this2.handleCanRemoveReplaceToilet,
              theme: crewForm_default.a,
              checked: crewSpecific.can_remove_replace_toilet,
              disabled: !canEditSpecifics
            }),
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              name: 'canRemoveNaildownHardwood',
              label: 'Remove Naildown Hardwood',
              onChange: _this2.handleCanRemoveNaildownHardwood,
              theme: crewForm_default.a,
              checked: crewSpecific.can_remove_naildown_hardwood,
              disabled: !canEditSpecifics
            })
          ),
          react_default.a.createElement(
            flexbox_react_dist_default.a,
            null,
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              name: 'canRemoveFloatingHardwood',
              label: 'Remove Floating Hardwood',
              onChange: _this2.handleCanRemoveFloatingHardwood,
              theme: crewForm_default.a,
              checked: crewSpecific.can_remove_floating_hardwood,
              disabled: !canEditSpecifics
            }),
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              name: 'canRemoveGluedownHardwood',
              label: 'Remove Gluedown Hardwood',
              onChange: _this2.handleCanRemoveGluedownHardwood,
              theme: crewForm_default.a,
              checked: crewSpecific.can_remove_gluedown_hardwood,
              disabled: !canEditSpecifics
            }),
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              name: 'canRemoveOverPadCarpet',
              label: 'Remove Carpet Over Pad',
              onChange: _this2.handleCanRemoveOverPadCarpet,
              theme: crewForm_default.a,
              checked: crewSpecific.can_remove_over_pad_carpet,
              disabled: !canEditSpecifics
            }),
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              name: 'canRemoveGluedownCarpet',
              label: 'Remove Gluedown Carpet',
              onChange: _this2.handleCanRemoveGluedownCarpet,
              theme: crewForm_default.a,
              checked: crewSpecific.can_remove_gluedown_carpet,
              disabled: !canEditSpecifics
            }),
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              name: 'canRemoveLaminate',
              label: 'Remove Laminate',
              onChange: _this2.handleCanRemoveLaminate,
              theme: crewForm_default.a,
              checked: crewSpecific.can_remove_laminate,
              disabled: !canEditSpecifics
            }),
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              name: 'canRemoveTile',
              label: 'Remove Tile',
              onChange: _this2.handleCanRemoveTile,
              theme: crewForm_default.a,
              checked: crewSpecific.can_remove_tile,
              disabled: !canEditSpecifics
            }),
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              name: 'canRemoveGluedownVinyl',
              label: 'Remove Gluedown Vinyl',
              onChange: _this2.handleCanRemoveGluedownVinyl,
              theme: crewForm_default.a,
              checked: crewSpecific.can_remove_gluedown_vinyl,
              disabled: !canEditSpecifics
            }),
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              name: 'canRemoveVinylPlank',
              label: 'Remove Vinyl Plank',
              onChange: _this2.handleCanRemoveVinylPlank,
              theme: crewForm_default.a,
              checked: crewSpecific.can_remove_vinyl_plank,
              disabled: !canEditSpecifics
            }),
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              name: 'canRemoveBacksplash',
              label: 'Remove Backsplash',
              onChange: _this2.handleCanRemoveBacksplash,
              theme: crewForm_default.a,
              checked: crewSpecific.can_remove_backsplash,
              disabled: !canEditSpecifics
            }),
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              name: 'canInstallBaseBoard',
              label: 'Install Baseboard',
              onChange: _this2.handleCanInstallBaseBoard,
              theme: crewForm_default.a,
              checked: crewSpecific.can_do_baseboard,
              disabled: !canEditSpecifics
            })
          ),
          react_default.a.createElement(
            flexbox_react_dist_default.a,
            null,
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              name: 'canInstallHardSurfaceTransitions',
              label: 'Install Hard Surface Transitions',
              onChange: _this2.handleCanInstallHardsurfaceTransitions,
              theme: crewForm_default.a,
              checked: crewSpecific.can_install_hard_transitions,
              disabled: !canEditSpecifics
            })
          )
        ),
        react_default.a.createElement('br', null),
        react_default.a.createElement(
          'h5',
          { className: form_default.a.childTitle },
          'Notes/Comments'
        ),
        react_default.a.createElement(react_toolbox_lib["Input"], {
          multiline: true,
          theme: form_default.a,
          value: crew.comments || '',
          className: form_default.a.textArea,
          error: _this2.showError('comments', errors),
          required: true,
          onChange: _this2.onCommentsChange
        }),
        !shouldShowRemoveButton ? null : react_default.a.createElement(ColoredButton["a" /* default */], {
          className: crewForm_removeButton,
          responsive: true,
          color: 'red',
          label: 'Remove',
          onClick: _this2.handleDelete
        }),
        react_default.a.createElement(components_conflictingAppointmentModal, {
          active: showApptWarningDialog,
          appts: crew.appointments || [],
          source: 'crew',
          onClose: function onClose() {
            return _this2.handleApptWarningModal(false);
          }
        })
      );
    }
  });
};

crewForm_CrewForm.propTypes = {
  index: prop_types_default.a.number,
  onDelete: prop_types_default.a.func,
  onChange: prop_types_default.a.func,
  onSpecificChange: prop_types_default.a.func,
  onSurfaceTypesChange: prop_types_default.a.func,
  onAvailabilityChange: prop_types_default.a.func,
  onDailyChange: prop_types_default.a.func,
  errors: prop_types_default.a.object,
  crew: prop_types_default.a.object,
  allWorkrooms: prop_types_default.a.array,
  canRemoveCrew: prop_types_default.a.bool,
  canEdit: prop_types_default.a.bool,
  canEditBasic: prop_types_default.a.bool,
  workroomChange: prop_types_default.a.bool,
  crewFieldWarnings: prop_types_default.a.array,
  fieldError: prop_types_default.a.func
};

/* harmony default export */ var components_crewForm = (crewForm_CrewForm);
// CONCATENATED MODULE: ./client/app/screens/main/screens/installers/components/installerCrewForm.jsx








var installerCrewForm_InstallerCrewForm = function InstallerCrewForm(props) {
  var errors = props.errors,
      helpers = props.helpers,
      crews = props.crews,
      onHelperChange = props.onHelperChange,
      onCrewChange = props.onCrewChange,
      onCrewSpecificChange = props.onCrewSpecificChange,
      onAddHelper = props.onAddHelper,
      onAddCrew = props.onAddCrew,
      onRemoveCrew = props.onRemoveCrew,
      onDeleteHelper = props.onDeleteHelper,
      onDisableChange = props.onDisableChange,
      _onDailyChange = props.onDailyChange,
      _onSurfaceTypesChange = props.onSurfaceTypesChange,
      _onAvailabilityChange = props.onAvailabilityChange,
      allWorkrooms = props.allWorkrooms,
      workroomChange = props.workroomChange,
      role = props.role,
      invalidCrewFieldsMsgs = props.invalidCrewFieldsMsgs,
      invalidHelperFieldsMsgs = props.invalidHelperFieldsMsgs,
      fieldError = props.fieldError;

  var canEdit = Object(services["a" /* can */])(role, 'update', 'crew');
  var canEditBasic = Object(services["a" /* can */])(role, 'update_basic', 'crew');
  var scrollTo = function scrollTo() {
    var arrOfElement = document.getElementsByClassName('crewForm__crewContainer___1YwHM');
    if (!arrOfElement.length) return;
    var headerOffset = 160;
    var elementPos = arrOfElement[arrOfElement.length - 1].getBoundingClientRect().top;
    /* eslint no-mixed-operators: ["error", {"allowSamePrecedence": true}]*/
    var offsetPos = elementPos + window.pageYOffset - headerOffset;
    if (event.target.id === 'addNewCrew') window.scrollTo({ top: offsetPos, behavior: 'smooth' });
  };
  window.addEventListener('click', scrollTo);
  return react_default.a.createElement(
    'div',
    null,
    react_default.a.createElement(
      'div',
      { className: form_default.a.divider },
      react_default.a.createElement(
        'h5',
        { className: form_default.a.childTitle },
        'Crew Management',
        canEdit && react_default.a.createElement(react_toolbox_lib["Button"], {
          id: 'addNewCrew',
          className: form_default.a.addChildButton,
          onClick: onAddCrew,
          label: 'Add a Crew'
        })
      ),
      errors.crews && crews && crews.length === 0 && react_default.a.createElement(
        'div',
        { className: form_default.a.errorText },
        errors.crews[0]
      ),
      crews.map(function (crew, i) {
        return react_default.a.createElement(components_crewForm, {
          key: 'crew-'.concat(crew.id),
          crew: crew,
          errors: errors,
          crewFieldWarnings: invalidCrewFieldsMsgs.length ? invalidCrewFieldsMsgs.filter(function (m) {
            return m.id === crew.id;
          }) : [],
          allWorkrooms: allWorkrooms,
          onChange: function onChange(key, value) {
            return onCrewChange(crew.id, key, value);
          },
          onSpecificChange: function onSpecificChange(key, value) {
            return onCrewSpecificChange(crew.id, key, value);
          },
          onSurfaceTypesChange: function onSurfaceTypesChange(key, value) {
            return _onSurfaceTypesChange(crew.id, key, value);
          },
          onAvailabilityChange: function onAvailabilityChange(value) {
            return _onAvailabilityChange(crew.id, value);
          },
          onDailyChange: function onDailyChange(key, value) {
            return _onDailyChange(crew.id, key, value);
          },
          onDelete: onRemoveCrew,
          index: i,
          canRemoveCrew: crews.length > 1,
          canEdit: canEdit,
          canEditBasic: canEditBasic,
          workroomChange: workroomChange,
          fieldError: fieldError
        });
      }),
      canEdit && react_default.a.createElement(
        'div',
        null,
        react_default.a.createElement(
          'h5',
          { className: form_default.a.childTitle },
          'Helpers',
          react_default.a.createElement(react_toolbox_lib["Button"], { className: form_default.a.addChildButton, onClick: onAddHelper, label: 'Add a Helper' })
        ),
        helpers.map(function (helper, i) {
          return react_default.a.createElement(helperForm, {
            key: 'helper-'.concat(helper.id),
            helper: helper,
            errors: errors,
            onChange: function onChange(key, value) {
              return onHelperChange(helper.id, key, value);
            },
            index: i,
            onDelete: onDeleteHelper,
            onDisable: function onDisable(key, value) {
              return onDisableChange(helper.id, key, value);
            },
            helperFieldWarnings: invalidHelperFieldsMsgs.length ? invalidHelperFieldsMsgs.filter(function (m) {
              return m.id === helper.id;
            }) : [],
            fieldError: fieldError
          });
        })
      )
    )
  );
};

installerCrewForm_InstallerCrewForm.propTypes = {
  onDisableChange: prop_types_default.a.func,
  onAddHelper: prop_types_default.a.func,
  onAddCrew: prop_types_default.a.func,
  onRemoveCrew: prop_types_default.a.func,
  onDeleteHelper: prop_types_default.a.func,
  onSurfaceTypesChange: prop_types_default.a.func,
  onHelperChange: prop_types_default.a.func,
  onCrewChange: prop_types_default.a.func,
  onCrewSpecificChange: prop_types_default.a.func,
  onAvailabilityChange: prop_types_default.a.func,
  onDailyChange: prop_types_default.a.func,
  errors: prop_types_default.a.object,
  allWorkrooms: prop_types_default.a.array,
  helpers: prop_types_default.a.array,
  crews: prop_types_default.a.array,
  role: prop_types_default.a.string.isRequired,
  workroomChange: prop_types_default.a.bool,
  invalidCrewFieldsMsgs: prop_types_default.a.array,
  invalidHelperFieldsMsgs: prop_types_default.a.array,
  fieldError: prop_types_default.a.func
};

/* harmony default export */ var installerCrewForm = (installerCrewForm_InstallerCrewForm);
// CONCATENATED MODULE: ./client/app/screens/main/screens/installers/components/installerForm.jsx
var installerForm__slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var installerForm__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function installerForm__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function installerForm__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function installerForm__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function installerForm__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function installerForm__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


































var installerForm_theme = { RTInput: input_default.a, RTCard: styles_card_default.a, RTSwitch: switch_default.a, RTTabs: tabs_default.a };
var installerForm_cancelClass = classnames_default()([form_default.a.cancelButton, form_default.a.actionButton]);
var installerForm_isNew = function isNew(obj) {
  return Object(lodash["isString"])(obj.id) && obj.id.indexOf('new_') === 0;
};
var AddressDefault = {
  street: '',
  city: '',
  state: '',
  zip_code: ''
};
var CrewSpecificDefault = {
  hardwood_sf_per_day: 0,
  carpet_sf_per_day: 0,
  tile_sf_per_day: 0,
  laminate_sf_per_day: 0,
  vinyl_sf_per_day: 0,
  vinyl_plank_sf_per_day: 0,
  backsplash_sf_per_day: 0,
  can_speak_english: false,
  can_speak_spanish: false,
  can_move_furniture: false,
  can_move_furniture_oversized: false,
  can_move_appliances: false,
  can_do_subfloor_prep: false,
  can_do_subfloor_replacement: false,
  can_do_naildown_hardwood: false,
  can_do_gluedown_hardwood: false,
  can_do_floating_hardwood: false,
  can_do_cali_bamboo_hardwood: false,
  can_do_steps_hardwood: false,
  can_do_stretch_in_carpet: false,
  can_do_gluedown_carpet: false,
  can_do_binding_carpet: false,
  can_do_pattern_match_carpet: false,
  can_do_berber_carpet: false,
  can_do_steps_carpet: false,
  can_do_floor_tile: false,
  can_do_backsplash_tile: false,
  can_do_backsplash_glass: false,
  can_do_backsplash_blocking: false,
  can_do_patterns_tile: false,
  can_do_large_format_tile: false,
  can_do_vinyl_sheet: false,
  can_do_vct_lvt: false,
  can_do_gluedown_vinyl_plank: false,
  can_do_floating_vinyl_plank: false,
  can_remove_replace_toilet: false,
  can_remove_naildown_hardwood: false,
  can_remove_floating_hardwood: false,
  can_remove_gluedown_hardwood: false,
  can_remove_over_pad_carpet: false,
  can_remove_gluedown_carpet: false,
  can_remove_laminate: false,
  can_remove_tile: false,
  can_remove_gluedown_vinyl: false,
  can_remove_vinyl_plank: false,
  same_day_multi_surface: false,
  max_travel_time: 0,
  phone_call_needed: false
};
var crewValidations = ['name', 'email', 'badge_number', 'poc_name', 'badge_expiration', 'phone_number', 'workrooms', 'surface_types', 'covered_zip_codes'];
var installerValidations = ['name', 'email', 'primary_phone', 'timezone', 'visibility', 'address'];
var helperValidations = ['email'];

var installerForm_InstallerForm = function (_Component) {
  installerForm__inherits(InstallerForm, _Component);

  function InstallerForm(props) {
    installerForm__classCallCheck(this, InstallerForm);

    var _this = installerForm__possibleConstructorReturn(this, (InstallerForm.__proto__ || Object.getPrototypeOf(InstallerForm)).call(this, props));

    installerForm__initialiseProps.call(_this);

    _this.handleSave = _this.handleSave.bind(_this);
    _this.handleCancel = _this.handleCancel.bind(_this);
    _this.handleActive = _this.handleChange.bind(_this, 'active');
    _this.handlePrimaryType = _this.handleChange.bind(_this, 'primary_phone_type');
    _this.handleSecondaryType = _this.handleChange.bind(_this, 'secondary_phone_type');
    _this.handleState = _this.handleChange.bind(_this, 'state');
    _this.removeCrew = _this.removeCrew.bind(_this);
    _this.removeHelper = _this.removeHelper.bind(_this);
    _this.handleHelperChange = _this.handleHelperChange.bind(_this);
    _this.handleCrewChange = _this.handleCrewChange.bind(_this);
    _this.handleCrewSpecificChange = _this.handleCrewSpecificChange.bind(_this);
    _this.handleAvailabilityChange = _this.handleAvailabilityChange.bind(_this);
    _this.handleDailyChange = _this.handleDailyChange.bind(_this);
    _this.addHelper = _this.addHelper.bind(_this);
    _this.addCrew = _this.addCrew.bind(_this);
    _this.addSurfaceTypeToCrew = _this.addSurfaceTypeToCrew.bind(_this);
    _this.handleDisableChange = _this.handleDisableChange.bind(_this);
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleDialogSubmit = function (formData) {
      return _this.props.onPayRateUpload(formData);
    };
    _this.fieldError = _this.fieldError.bind(_this);
    var _this$props = _this.props,
        installer = _this$props.installer,
        helpers = _this$props.helpers,
        crews = _this$props.crews;

    _this.state = {
      showUploadDialog: false,
      showApptWarningDialog: false,
      workroomChange: false,
      installer: installer && installerForm__extends({}, installer) || {
        id: '',
        user_id: null,
        active: true,
        primary_phone_type: 'mobile',
        secondary_phone_type: 'mobile',
        address: AddressDefault
      },
      helpers: helpers || [],
      crews: crews || [{
        id: Object(lodash["uniqueId"])('new_'),
        active: false,
        name: 'Crew 1',
        phone_number_type: 'mobile',
        surface_types: [],
        default_start_time: '08:00',
        workrooms: [],
        covered_zip_codes: [],
        crew_specific: CrewSpecificDefault
      }],
      allowedTabs: getAllowedInstallerTabs(props.role, props.user && props.user.manage_vendor_workrooms || {}),
      errors: _this.props.errors || {}
    };
    return _this;
  }

  // helperSubmitDisabledMsgs = () => {
  //   const { helpers } = this.state;
  //   const msgArr = [];
  //   if (helpers.length) {
  //     helpers.forEach((h) => {

  return InstallerForm;
}(react["Component"]);

var installerForm__initialiseProps = function _initialiseProps() {
  var _this2 = this;

  Object.defineProperty(this, 'componentWillMount', {
    enumerable: true,
    writable: true,
    value: function value() {
      return _this2.props.onTabChange(0);
    }
  });
  Object.defineProperty(this, 'componentDidMount', {
    enumerable: true,
    writable: true,
    value: function value() {
      return _this2.props.requestEmployee(_this2.props.user.employable_id);
    }
  });
  Object.defineProperty(this, 'componentWillReceiveProps', {
    enumerable: true,
    writable: true,
    value: function value(nextProps) {
      if (nextProps.errors && Object.keys(nextProps.errors) && !Object(lodash["isEqual"])(_this2.props.errors, nextProps.errors)) {
        _this2.goToFirstErroredTab(nextProps);
        _this2.setState({ errors: nextProps.errors });
      }
    }
  });
  Object.defineProperty(this, 'handleChange', {
    enumerable: true,
    writable: true,
    value: function value(key, _value) {
      var installer = _this2.state.installer;
      if ({}.hasOwnProperty.call(AddressDefault, key)) {
        var currentAddress = installer.address || AddressDefault;
        installer.address = installerForm__extends({}, currentAddress, installerForm__defineProperty({}, key, _value));
      } else installer[key] = key === 'email' ? _value.replaceAll(' ', '') : _value;
      _this2.setState({ installer: installer });
      var isEdit = !!installer.id;
      var crews = _this2.state.crews;
      if (!isEdit && crews.length === 1 && ['name', 'primary_phone_type', 'primary_phone'].indexOf(key) > -1) {
        var attrMap = {
          name: 'poc_name',
          primary_phone_type: 'phone_number_type',
          primary_phone: 'phone_number'
        };
        crews[0][attrMap[key]] = _value;
        _this2.setState({ crews: crews });
      }
      if (key === 'active' && !_value) {
        for (var i = 0; i < crews.length; i += 1) {
          crews[i].active = false;
        }
        _this2.setState({ crews: crews });
      }
    }
  });
  Object.defineProperty(this, 'handleCancel', {
    enumerable: true,
    writable: true,
    value: function value() {
      return _this2.props.onCancel();
    }
  });
  Object.defineProperty(this, 'handleSave', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _state = _this2.state,
          installer = _state.installer,
          helpers = _state.helpers,
          crews = _state.crews;

      var address = installer.address,
          user_id = installer.user_id,
          name = installer.name,
          email = installer.email,
          primary_phone = installer.primary_phone,
          primary_phone_type = installer.primary_phone_type,
          secondary_phone = installer.secondary_phone,
          secondary_phone_type = installer.secondary_phone_type,
          timezone = installer.timezone,
          visibility = installer.visibility,
          active = installer.active,
          rest = installerForm__objectWithoutProperties(installer, ['address', 'user_id', 'name', 'email', 'primary_phone', 'primary_phone_type', 'secondary_phone', 'secondary_phone_type', 'timezone', 'visibility', 'active']);

      var data = installerForm__extends({}, rest, {
        workers_comp_expiration: Object(dateUtils["o" /* handleDateSave */])(installer.workers_comp_expiration),
        liability_insurance_expiration: Object(dateUtils["o" /* handleDateSave */])(installer.liability_insurance_expiration),
        installer_firm_certification_expiration: Object(dateUtils["o" /* handleDateSave */])(installer.installer_firm_certification_expiration),
        assigned_renovator_certification_expiration: Object(dateUtils["o" /* handleDateSave */])(installer.assigned_renovator_certification_expiration),
        visibility: visibility,
        user_attributes: {
          id: user_id,
          name: name,
          email: email,
          primary_phone: primary_phone,
          secondary_phone: secondary_phone,
          primary_phone_type: primary_phone_type,
          secondary_phone_type: secondary_phone_type,
          timezone: timezone,
          active: active
        },
        address_attributes: address,
        helpers_attributes: helpers.map(function (helper) {
          return installerForm__extends({}, helper, {
            id: installerForm_isNew(helper) ? undefined : helper.id,
            badge_expiration: Object(dateUtils["o" /* handleDateSave */])(helper.badge_expiration)
          });
        }),
        crews_attributes: crews.map(function (crew) {
          var dailyAvailability = crew.daily_availability ? crew.daily_availability : { morning: [2, 3, 4, 5, 6], afternoon: [2, 3, 4, 5, 6] };
          return installerForm__extends({}, crew, {
            id: installerForm_isNew(crew) ? undefined : crew.id,
            badge_expiration: Object(dateUtils["o" /* handleDateSave */])(crew.badge_expiration),
            surface_type_ids: crew.surface_types,
            workroom_ids: crew.workrooms.map(function (w) {
              return w.value || w;
            }),
            // temporarily auto filling if not dedicated
            daily_availability: {
              morning: dailyAvailability.morning,
              afternoon: crew.delivery_dedicated || false ? dailyAvailability.afternoon : dailyAvailability.morning
            },
            crew_specific_attributes: crew.crew_specific
          });
        })
      });
      _this2.props.onSave(data).then(function () {
        return _this2.props.onTabChange(0);
      }).then(function () {
        return window.location.reload();
      }).catch(function () {}); // validation failed: keep redux errors, no reload
    }
  });
  Object.defineProperty(this, 'handleApptWarningModal', {
    enumerable: true,
    writable: true,
    value: function value(display) {
      return _this2.setState({ showApptWarningDialog: display });
    }
  });
  Object.defineProperty(this, 'emailsTheSame', {
    enumerable: true,
    writable: true,
    value: function value() {
      var email1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var email2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      return email1.toLowerCase() === email2.toLowerCase();
    }
  });
  Object.defineProperty(this, 'addHelper', {
    enumerable: true,
    writable: true,
    value: function value() {
      return _this2.setState({ helpers: _this2.state.helpers.concat({ phone_number_type: 'mobile', id: Object(lodash["uniqueId"])('new_') }) });
    }
  });
  Object.defineProperty(this, 'addCrew', {
    enumerable: true,
    writable: true,
    value: function value() {
      var crews = _this2.state.crews;
      _this2.setState({
        crews: crews.concat({
          id: Object(lodash["uniqueId"])('new_'),
          active: false,
          phone_number_type: 'mobile',
          name: 'Crew '.concat(crews.length + 1),
          surface_types: [],
          workrooms: [],
          email: Object(utils["m" /* getRandomStr */])() + '@ChangeMe.com',
          covered_zip_codes: [],
          store_zips_dictionary: { 'Additional Zip Codes': [] },
          crew_specific: CrewSpecificDefault,
          install_availability: [],
          delivery_availability: [],
          appointments: [],
          daily_availability: { morning: [], afternoon: [] }
        })
      });
    }
  });
  Object.defineProperty(this, 'removeCrew', {
    enumerable: true,
    writable: true,
    value: function value(id) {
      return _this2.setState({
        crews: _this2.state.crews.filter(function (h) {
          return h.id !== id;
        })
      });
    }
  });
  Object.defineProperty(this, 'removeHelper', {
    enumerable: true,
    writable: true,
    value: function value(id) {
      return _this2.setState({
        helpers: _this2.state.helpers.filter(function (h) {
          return h.id !== id;
        })
      });
    }
  });
  Object.defineProperty(this, 'handleHelperChange', {
    enumerable: true,
    writable: true,
    value: function value(id, key, _value2) {
      var helpers = _this2.state.helpers;
      var helper = helpers.find(function (h) {
        return h.id === id;
      });
      if (helper) helper[key] = key === 'email' ? _value2.replaceAll(' ', '') : _value2;
      _this2.setState({ helpers: helpers });
    }
  });
  Object.defineProperty(this, 'handleCrewChange', {
    enumerable: true,
    writable: true,
    value: function value(id, key, _value3) {
      var _props = _this2.props,
          updateCrewChanges = _props.updateCrewChanges,
          installerFormType = _props.installerFormType;

      var isEdit = installerFormType === 'Edit';
      var crews = Object(lodash["cloneDeep"])(_this2.state.crews);
      var crew = crews.find(function (c) {
        return c.id === id;
      });
      if (!crew) return;
      if (key === 'covered_zip_codes') {
        crew[key] = _value3.zipsFromStoreZipsDictArr;
        crew.store_zips_dictionary = _value3.newStoreZipsDict;
        _this2.setState({ crews: crews, workroomChange: false });
      } else if (key === 'workrooms') {
        var wrkmVal = _value3.map(function (wrkm) {
          return wrkm.value;
        });
        crew[key] = wrkmVal;
        // Only adds history event if editing existing profile, not on creation (new)
        if (installerFormType === 'Edit') updateCrewChanges('workrooms', wrkmVal, crew.id);
        _this2.setState({ crews: crews, workroomChange: true });
      } else {
        if (key === 'can_deliver' && !_value3) {
          crew.delivery_dedicated = false;
          if (isEdit) updateCrewChanges('delivery_dedicated', false, crew.id);
        }
        if (key === 'delivery_dedicated' && _value3) {
          crew.can_deliver = true;
          if (isEdit) updateCrewChanges('can_deliver', true, crew.id);
        }
        crew[key] = key === 'email' ? _value3.replaceAll(' ', '') : _value3;
        if (isEdit) updateCrewChanges(key, _value3, crew.id);
        _this2.setState({ crews: crews });
      }
    }
  });
  Object.defineProperty(this, 'handleCrewSpecificChange', {
    enumerable: true,
    writable: true,
    value: function value(id, key, _value4) {
      var crews = _this2.state.crews;
      var crew = crews.find(function (c) {
        return c.id === id;
      });
      if (!crew) return;
      if (key === 'can_move_furniture_oversized' && _value4) crew.crew_specific.can_move_furniture = true;
      crew.crew_specific[key] = _value4;
      _this2.setState({ crews: crews });
    }
  });
  Object.defineProperty(this, 'handleDisableChange', {
    enumerable: true,
    writable: true,
    value: function value(id) {
      var helpers = _this2.state.helpers;
      var helper = helpers.find(function (h) {
        return h.id === id;
      });
      if (helper) helper.disabled = !helper.disabled;
      _this2.setState({ helpers: helpers });
    }
  });
  Object.defineProperty(this, 'addSurfaceTypeToCrew', {
    enumerable: true,
    writable: true,
    value: function value(id, surfaceTypeId, checked) {
      var _props2 = _this2.props,
          updateCrewChanges = _props2.updateCrewChanges,
          installerFormType = _props2.installerFormType;

      var crews = _this2.state.crews;
      var crew = crews.find(function (c) {
        return c.id === id;
      });
      var surfaceTypes = crew.surface_types || [];
      var index = surfaceTypes.indexOf(surfaceTypeId);
      if (!checked && index > -1) surfaceTypes.splice(index, 1);else if (checked && !(index > -1)) surfaceTypes.push(surfaceTypeId);
      if (installerFormType === 'Edit') updateCrewChanges('surface_types', surfaceTypes, crew.id);
      _this2.setState({ crews: crews });
    }
  });
  Object.defineProperty(this, 'handleAvailabilityChange', {
    enumerable: true,
    writable: true,
    value: function value(id, val) {
      var _props3 = _this2.props,
          updateCrewChanges = _props3.updateCrewChanges,
          installerFormType = _props3.installerFormType;

      var crews = _this2.state.crews;
      var crew = crews.find(function (c) {
        return c.id === id;
      });

      var _val$split = val.split('_'),
          _val$split2 = installerForm__slicedToArray(_val$split, 2),
          dayString = _val$split2[0],
          type = _val$split2[1];

      var day = parseInt(dayString, 10);
      if (type === 'off') {
        crew.install_availability = crew.install_availability.filter(function (d) {
          return d !== day;
        });
        crew.delivery_availability = crew.delivery_availability.filter(function (d) {
          return d !== day;
        });
      } else {
        crew[type + '_availability'].push(day);
        if (type === 'install' && crew.delivery_availability.includes(day)) {
          var index = crew.delivery_availability.indexOf(day);
          crew.delivery_availability.splice(index, 1);
        } else if (type === 'delivery' && crew.install_availability.includes(day)) {
          var _index = crew.install_availability.indexOf(day);
          crew.install_availability.splice(_index, 1);
        }
      }
      crew.install_availability = Object(lodash["uniq"])(crew.install_availability.sort());
      crew.delivery_availability = Object(lodash["uniq"])(crew.delivery_availability.sort());
      if (installerFormType === 'Edit') {
        updateCrewChanges('install_availability', crew.install_availability, crew.id);
        updateCrewChanges('delivery_availability', crew.delivery_availability, crew.id);
      }
      _this2.setState({ crews: crews });
    }
  });
  Object.defineProperty(this, 'handleDailyChange', {
    enumerable: true,
    writable: true,
    value: function value(id, label, val) {
      var _props4 = _this2.props,
          updateCrewChanges = _props4.updateCrewChanges,
          installerFormType = _props4.installerFormType;

      var crews = _this2.state.crews;
      var crew = crews.find(function (c) {
        return c.id === id;
      });
      if (crew.delivery_dedicated) crew.daily_availability[label] = val;else crew.daily_availability = { morning: val, afternoon: val };
      // hiding logic related to appt type availability for now
      // crew.daily_availability = this.filterDailyAvailability(
      //   crew.install_availability, crew.delivery_availability, crew.daily_availability,
      // );
      // adding logic to keep appt. type availability somewhat up to date for now
      crew.install_availability = crew.delivery_dedicated ? [] : val;
      crew.delivery_availability = crew.delivery_dedicated ? val : [];
      if (installerFormType === 'Edit') {
        updateCrewChanges('daily_availability', crew.daily_availability, crew.id);
      }
      _this2.setState({ crews: crews });
    }
  });
  Object.defineProperty(this, 'filterDailyAvailability', {
    enumerable: true,
    writable: true,
    value: function value(dedicated, installAvail, deliveryAvail, _ref) {
      var morning = _ref.morning,
          afternoon = _ref.afternoon;
      return dedicated ? {
        morning: _this2.filterTimeWindow(morning, installAvail, deliveryAvail),
        afternoon: _this2.filterTimeWindow(afternoon, installAvail, deliveryAvail)
      } : {
        morning: _this2.filterTimeWindow(morning, installAvail, deliveryAvail),
        afternoon: _this2.filterTimeWindow(afternoon, installAvail, deliveryAvail)
      };
    }
  });
  Object.defineProperty(this, 'filterTimeWindow', {
    enumerable: true,
    writable: true,
    value: function value(window, installAvail, deliveryAvail) {
      return window.filter(function (d) {
        return installAvail.concat(deliveryAvail).includes(d);
      });
    }
  });
  Object.defineProperty(this, 'goToFirstErroredTab', {
    enumerable: true,
    writable: true,
    value: function value() {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this2.state;
      var errors = state.errors,
          activeTab = state.activeTab;

      if (!Object.keys(errors).length) return;
      var tabErrors = _this2.tabErrors(state);
      // if there are errors on this tab, do nothing
      if (tabErrors[_this2.state.allowedTabs[activeTab].label]) return;
      var firstErroredTab = _this2.state.allowedTabs.map(function (t) {
        return t.label;
      }).indexOf(Object.keys(tabErrors).filter(function (t) {
        return tabErrors[t] > 0;
      })[0]);
      _this2.props.onTabChange(Math.max(firstErroredTab, 0));
    }
  });
  Object.defineProperty(this, 'tabErrors', {
    enumerable: true,
    writable: true,
    value: function value() {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this2.state;
      var errors = state.errors;

      if (!Object.keys(errors).length) return {};
      var helperErrors = Object(utils["g" /* filterTypes */])('helpers', errors);
      var crewErrors = Object(utils["g" /* filterTypes */])('crews', errors);
      var crewTabErrors = Object.assign(helperErrors, crewErrors);
      // Basic Info errors are all those that are not crew tab errors
      var basicInfoErrors = {};
      Object.keys(errors).forEach(function (e) {
        if (!crewTabErrors[e]) basicInfoErrors[e] = errors[e];
      });
      var certKeys = ['installer_firm_certification_number', 'installer_firm_certification_expiration', 'assigned_renovator_certification_number', 'assigned_renovator_certification_expiration'];
      var certErrorCount = certKeys.filter(function (k) {
        return basicInfoErrors[k];
      }).length;
      var basicInfoWithoutCerts = installerForm__extends({}, basicInfoErrors);
      certKeys.forEach(function (k) {
        delete basicInfoWithoutCerts[k];
      });
      var hasMillworkCertTab = _this2.state.allowedTabs.some(function (tab) {
        return tab.label === 'Millwork Certifications';
      });
      var basicInfoErrorCount = Object.keys(basicInfoWithoutCerts).length + (hasMillworkCertTab ? 0 : certErrorCount);

      return {
        'Basic Info': basicInfoErrorCount,
        'Millwork Certifications': hasMillworkCertTab ? certErrorCount : 0,
        Crew: Object.keys(crewTabErrors).length
      };
    }
  });
  Object.defineProperty(this, 'validateEmailInput', {
    enumerable: true,
    writable: true,
    value: function value(emailToCheck) {
      var crewOrHelper = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var forWho = 'for ' + (crewOrHelper ? crewOrHelper.name : 'installer');
      if (!emailToCheck) return !crewOrHelper || crewOrHelper.isCrew ? 'Input email ' + forWho : '';
      var regex = new RegExp(constants["I" /* EMAIL_VALIDATION_REGEX */]);
      if (!regex.test(emailToCheck)) return 'Input valid email ' + forWho;
      var _state$installer$emai = _this2.state.installer.email,
          email = _state$installer$emai === undefined ? null : _state$installer$emai;

      var emailArr = [];
      if (crewOrHelper && email) emailArr.push(email);
      emailArr = _this2.addEmailsFromCrewOrHelper(emailArr, crewOrHelper);
      if (emailArr.length && emailArr.some(function (e) {
        return e.toLowerCase() === emailToCheck.toLowerCase();
      })) {
        return 'Input unique email ' + forWho;
      }
      return '';
    }
  });
  Object.defineProperty(this, 'addEmailsFromCrewOrHelper', {
    enumerable: true,
    writable: true,
    value: function value(emailArr, crewOrHelper) {
      var _state2 = _this2.state,
          _state2$crews = _state2.crews,
          crews = _state2$crews === undefined ? [] : _state2$crews,
          _state2$helpers = _state2.helpers,
          helpers = _state2$helpers === undefined ? [] : _state2$helpers;

      var newEmailArr = emailArr || [];
      newEmailArr = _this2.addEmailsToArr(newEmailArr, crews, crewOrHelper);
      newEmailArr = _this2.addEmailsToArr(newEmailArr, helpers, crewOrHelper, false);
      return newEmailArr;
    }
  });
  Object.defineProperty(this, 'addEmailsToArr', {
    enumerable: true,
    writable: true,
    value: function value(emailArr, list, crewOrHelper) {
      var isCrewList = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

      if (!list.length) return emailArr;
      var newEmailArr = emailArr || [];
      list.forEach(function (l) {
        var _l$id = l.id,
            id = _l$id === undefined ? null : _l$id,
            _l$email = l.email,
            email = _l$email === undefined ? null : _l$email;

        if ((!crewOrHelper || id !== crewOrHelper.id || isCrewList && !crewOrHelper.isCrew || !isCrewList && crewOrHelper.isCrew) && email) newEmailArr.push(email);
      });
      return newEmailArr;
    }
  });
  Object.defineProperty(this, 'validateZip', {
    enumerable: true,
    writable: true,
    value: function value(zip) {
      if (!zip) return 'Input zip code';
      var regex = new RegExp(/(^\d{5}$)|(^\d{5}-\d{4}$)/);
      return regex.test(zip) ? '' : 'Input valid zip code';
    }
  });
  Object.defineProperty(this, 'validateAddress', {
    enumerable: true,
    writable: true,
    value: function value(address) {
      var safeAddress = address || AddressDefault;
      var addressKeys = Object.keys(safeAddress).filter(function (k) {
        return k !== 'id';
      });
      var addressArr = [];
      addressKeys.forEach(function (k) {
        var msgObj = { field: k, msg: '' };
        var fieldVal = safeAddress[k];
        if (k === 'zip_code') {
          var zipMsg = _this2.validateZip(fieldVal);
          if (zipMsg) msgObj.msg = zipMsg;
        } else if (!fieldVal) msgObj.msg = 'Input ' + k;
        if (msgObj.msg) addressArr.push(msgObj);
      });
      return addressArr;
    }
  });
  Object.defineProperty(this, 'installerSubmitDisabledMsgs', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _state3 = _this2.state,
          installer = _state3.installer,
          crews = _state3.crews;

      var msgArr = [];
      if (!crews.length) msgArr.push({ field: 'crews', msg: 'Add a crew' });
      installerValidations.forEach(function (v) {
        var msgObj = { field: v, msg: '' };
        var fieldVal = installer[v] || null;
        if (v === 'email') {
          var emailMsg = _this2.validateEmailInput(fieldVal);
          if (emailMsg) msgObj.msg = emailMsg;
        } else if (v === 'address') {
          var addressArr = _this2.validateAddress(fieldVal);
          if (addressArr.length) msgArr = msgArr.concat(addressArr);
        } else if (!fieldVal) msgObj.msg = 'Input ' + v.replace('_', ' ');
        if (msgObj.msg) msgArr.push(msgObj);
      });
      return msgArr;
    }
  });
  Object.defineProperty(this, 'crewHelperSubmitDisabledMsgs', {
    enumerable: true,
    writable: true,
    value: function value() {
      var isCrew = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var _state4 = _this2.state,
          _state4$crews = _state4.crews,
          crews = _state4$crews === undefined ? [] : _state4$crews,
          _state4$helpers = _state4.helpers,
          helpers = _state4$helpers === undefined ? [] : _state4$helpers;

      var contractorArr = isCrew ? crews : helpers;
      var validations = isCrew ? crewValidations : helperValidations;
      var msgArr = [];
      if (contractorArr.length) {
        contractorArr.forEach(function (c) {
          validations.forEach(function (v) {
            var msgObj = { id: c.id, field: v, msg: '' };
            var fieldVal = c[v] || null;
            if (v === 'email') {
              var emailMsg = _this2.validateEmailInput(fieldVal, installerForm__extends({}, c, { isCrew: isCrew }));
              if (emailMsg) msgObj.msg = emailMsg;
            } else if (!fieldVal || Array.isArray(fieldVal) && !fieldVal.length) {
              msgObj.msg = 'Input ' + (c.name || '' + (isCrew ? 'crew' : 'helper')) + ' ' + v.replace('_', ' ');
            }
            if (msgObj.msg) msgArr.push(msgObj);
          });
        });
      }
      return msgArr;
    }
  });
  Object.defineProperty(this, 'fieldError', {
    enumerable: true,
    writable: true,
    value: function value(field, warnings) {
      var fieldError = warnings.find(function (w) {
        return w.field === field;
      }) || null;
      return fieldError ? fieldError.msg : null;
    }
  });
  Object.defineProperty(this, 'crewsAppts', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _state$crews = _this2.state.crews,
          crews = _state$crews === undefined ? [] : _state$crews;

      if (!crews.length || !crews.some(function (c) {
        return c.appointments && c.appointments.length;
      })) return [];
      return crews.map(function (c) {
        return c.appointments;
      }).reduce(function (a, b) {
        return a.concat(b);
      }, []);
    }
  });
  Object.defineProperty(this, 'renderTabContent', {
    enumerable: true,
    writable: true,
    value: function value(isEdit, _ref2) {
      var invalidInstallerFieldsMsgs = _ref2.invalidInstallerFieldsMsgs,
          invalidCrewFieldsMsgs = _ref2.invalidCrewFieldsMsgs,
          invalidHelperFieldsMsgs = _ref2.invalidHelperFieldsMsgs;
      var _state5 = _this2.state,
          installer = _state5.installer,
          helpers = _state5.helpers,
          crews = _state5.crews,
          workroomChange = _state5.workroomChange,
          errors = _state5.errors;
      var _props5 = _this2.props,
          activeTab = _props5.activeTab,
          allWorkrooms = _props5.allWorkrooms,
          _props5$payRateUpload = _props5.payRateUploadsData,
          payRateUploadsData = _props5$payRateUpload === undefined ? [] : _props5$payRateUpload,
          role = _props5.role,
          handleCrewPayId = _props5.handleCrewPayId,
          crewPayId = _props5.crewPayId;

      switch ((_this2.state.allowedTabs[activeTab] || {}).label || '') {
        case 'Basic Info':
          return react_default.a.createElement(installerBasicInfoForm, {
            installer: installer,
            crews: crews,
            errors: errors,
            invalidInstallerFieldsMsgs: invalidInstallerFieldsMsgs,
            theme: installerForm_theme,
            onChange: _this2.handleChange,
            role: role,
            position: _this2.props.user && _this2.props.user.position || '',
            mvw: _this2.props.user && _this2.props.user.manage_vendor_workrooms || {},
            allWorkrooms: allWorkrooms,
            fieldError: _this2.fieldError
          });
        case 'Millwork Certifications':
          return react_default.a.createElement(installerCertificationsForm, {
            installer: installer,
            onChange: _this2.handleChange,
            role: role,
            errors: errors
          });
        case 'Pay Rates':
          return isEdit ? react_default.a.createElement(
            'div',
            { className: form_default.a.divider },
            react_default.a.createElement(components_UploadDialog, {
              active: _this2.props.showUploadDialog,
              title: 'Upload Pay Rates',
              formDataKey: 'labor_rate_upload[asset]',
              handleToggle: _this2.props.onUploadDialogToggle,
              handleSubmit: _this2.handleDialogSubmit,
              handleCrewPayId: handleCrewPayId,
              crewPayId: crewPayId,
              errors: _this2.props.uploadError,
              setErrorMessage: _this2.props.setUploadErrorMessage,
              fileLoading: _this2.props.fileLoading,
              crews: crews.length ? crews : null
            }),
            react_default.a.createElement(components_UploadsTable, {
              role: role,
              isPayRate: true,
              downloadColumnName: 'Download',
              uploadText: 'Upload pay rates',
              data: payRateUploadsData,
              handleUpload: _this2.props.onUploadDialogToggle,
              crews: crews.length ? crews : null
            })
          ) : null;
        case 'Crew':
          return react_default.a.createElement(installerCrewForm, {
            helpers: helpers,
            crews: crews,
            errors: errors,
            invalidCrewFieldsMsgs: invalidCrewFieldsMsgs || [],
            invalidHelperFieldsMsgs: invalidHelperFieldsMsgs || [],
            theme: installerForm_theme,
            onHelperChange: _this2.handleHelperChange,
            onCrewChange: _this2.handleCrewChange,
            onCrewSpecificChange: _this2.handleCrewSpecificChange,
            onAddHelper: _this2.addHelper,
            onAddCrew: _this2.addCrew,
            onSurfaceTypesChange: _this2.addSurfaceTypeToCrew,
            onAvailabilityChange: _this2.handleAvailabilityChange,
            onDailyChange: _this2.handleDailyChange,
            onRemoveCrew: _this2.removeCrew,
            onDeleteHelper: _this2.removeHelper,
            onDisableChange: _this2.handleDisableChange,
            allWorkrooms: allWorkrooms,
            workroomChange: workroomChange,
            role: role,
            fieldError: _this2.fieldError
          });
        default:
          return null;
      }
    }
  });
  Object.defineProperty(this, 'renderTitle', {
    enumerable: true,
    writable: true,
    value: function value(installer, isEdit) {
      var _cx;

      var title = isEdit ? installer.name + ' (' + installer.id + ')' || 'Edit Installer' : 'Add Installer';
      var switchClassNames = classnames_default()((_cx = {}, installerForm__defineProperty(_cx, form_default.a.switchTitleAdd, !isEdit), installerForm__defineProperty(_cx, form_default.a.switchTitle, true), _cx));
      var tabErrors = _this2.tabErrors();
      var canEdit = Object(services["a" /* can */])(_this2.props.role, 'update', 'installer');
      return react_default.a.createElement(
        'div',
        null,
        react_default.a.createElement(
          flexbox_react_dist_default.a,
          { justifyContent: 'space-between', className: form_default.a.headerDivider },
          react_default.a.createElement(
            flexbox_react_dist_default.a,
            { className: form_default.a.titleTabs },
            react_default.a.createElement(
              'div',
              { className: form_default.a.headerChildren },
              react_default.a.createElement(
                'h5',
                { className: form_default.a.cardTitle },
                title
              ),
              react_default.a.createElement(
                'p',
                { className: form_default.a.cardSubtitle },
                'Please ensure that all fields contain accurate information'
              )
            ),
            react_default.a.createElement(
              'div',
              { className: installerForm_theme.tabBar },
              react_default.a.createElement(
                react_toolbox_lib["Tabs"],
                {
                  index: _this2.props.activeTab,
                  onChange: _this2.props.onTabChange,
                  className: tabs_default.a.headerOnlyTabs
                },
                _this2.state.allowedTabs.filter(function (tab) {
                  return tab.editable;
                }).map(function (tab) {
                  return react_default.a.createElement(react_toolbox_lib["Tab"], {
                    key: tab.label,
                    label: tab.label,
                    icon: tabErrors[tab.label] ? 'error' : '',
                    className: (isEdit || tab.label !== 'Pay Rates' && tab.label !== 'Time Off' ? '' : form_default.a.doNotDisplay) + ' ' + (tabErrors[tab.label] ? tabs_default.a.inError : '')
                  });
                })
              )
            )
          ),
          react_default.a.createElement(
            'div',
            { className: form_default.a.headerChildren },
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              name: 'active',
              label: 'Account Active',
              onChange: _this2.crewsAppts().length ? function () {
                return _this2.handleApptWarningModal(true);
              } : _this2.handleActive,
              className: switchClassNames,
              checked: installer.active,
              disabled: !canEdit
            })
          )
        )
      );
    }
  });
  Object.defineProperty(this, 'render', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _state6 = _this2.state,
          installer = _state6.installer,
          showApptWarningDialog = _state6.showApptWarningDialog;
      var _props6 = _this2.props,
          role = _props6.role,
          workrooms = _props6.workrooms,
          _props6$employee = _props6.employee,
          employee = _props6$employee === undefined ? null : _props6$employee;

      var isEdit = !!installer.id;
      var invalidInstallerFieldsMsgs = _this2.installerSubmitDisabledMsgs();
      var invalidCrewFieldsMsgs = _this2.crewHelperSubmitDisabledMsgs();
      var invalidHelperFieldsMsgs = _this2.crewHelperSubmitDisabledMsgs(false);
      var fieldsMsgs = invalidInstallerFieldsMsgs.map(function (m) {
        return m.msg;
      }).concat(invalidCrewFieldsMsgs.map(function (m) {
        return m.msg;
      })).concat(invalidHelperFieldsMsgs.map(function (m) {
        return m.msg;
      }));
      var _state7 = _this2.state,
          errors = _state7.errors,
          crews = _state7.crews;

      var serverEmailMsgs = Object.keys(errors).filter(function (k) {
        return (/^crews\[\d+\]\.email$/.test(k)
        );
      }).map(function (k) {
        var idx = parseInt(k.match(/\d+/)[0], 10);
        var crew = crews[idx];
        return (crew ? crew.name : 'Crew ' + (idx + 1)) + ': ' + errors[k].join(', ');
      });
      return react_default.a.createElement(
        react_css_themr_lib["ThemeProvider"],
        { theme: installerForm_theme },
        !isEdit || permissionByWorkroomId(role, workrooms, employee) ? react_default.a.createElement(
          components_Card,
          null,
          _this2.renderTitle(installer, isEdit),
          _this2.renderTabContent(isEdit, {
            invalidInstallerFieldsMsgs: invalidInstallerFieldsMsgs,
            invalidCrewFieldsMsgs: invalidCrewFieldsMsgs,
            invalidHelperFieldsMsgs: invalidHelperFieldsMsgs
          }),
          react_default.a.createElement(
            flexbox_react_dist_default.a,
            { justifyContent: 'flex-end', flexWrap: 'wrap' },
            react_default.a.createElement(
              react_toolbox_lib["CardActions"],
              { className: form_default.a.actionsWrapper },
              react_default.a.createElement(ColoredButton["a" /* default */], {
                className: installerForm_cancelClass,
                responsive: true,
                color: 'gray',
                label: 'Cancel',
                onClick: _this2.handleCancel
              }),
              react_default.a.createElement(ColoredButton["a" /* default */], {
                className: form_default.a.actionButton,
                responsive: true,
                color: 'green',
                label: isEdit ? 'Save Changes' : 'Add installer',
                onClick: _this2.handleSave,
                disabled: fieldsMsgs.length
              })
            )
          ),
          fieldsMsgs.length > 0 && react_default.a.createElement(
            flexbox_react_dist_default.a,
            { justifyContent: 'flex-end', flexWrap: 'wrap' },
            react_default.a.createElement(
              'div',
              { className: form_default.a.invalidFieldsMsg },
              Object(lodash["uniq"])(fieldsMsgs).join(', ')
            )
          ),
          serverEmailMsgs.length > 0 && react_default.a.createElement(
            flexbox_react_dist_default.a,
            { justifyContent: 'flex-end', flexWrap: 'wrap' },
            react_default.a.createElement(
              'div',
              { className: form_default.a.invalidFieldsMsg },
              serverEmailMsgs.join(', ')
            )
          ),
          react_default.a.createElement(components_conflictingAppointmentModal, {
            active: showApptWarningDialog,
            appts: _this2.crewsAppts(),
            onClose: function onClose() {
              return _this2.handleApptWarningModal(false);
            }
          })
        ) : react_default.a.createElement(components_Unauthorized, { restrictedItem: 'installer' })
      );
    }
  });
};

installerForm_InstallerForm.propTypes = {
  activeTab: prop_types_default.a.number,
  onCancel: prop_types_default.a.func,
  onSave: prop_types_default.a.func,
  onTabChange: prop_types_default.a.func,
  errors: prop_types_default.a.object,
  installer: prop_types_default.a.object,
  helpers: prop_types_default.a.array,
  crews: prop_types_default.a.array,
  workrooms: prop_types_default.a.arrayOf(types_workroom),
  allWorkrooms: prop_types_default.a.array,
  uploadError: prop_types_default.a.object,
  setErrorMessage: prop_types_default.a.func,
  showUploadDialog: prop_types_default.a.bool,
  fileLoading: prop_types_default.a.bool,
  payRateUploadsData: prop_types_default.a.arrayOf(prop_types_default.a.shape({
    id: prop_types_default.a.oneOfType([prop_types_default.a.number, prop_types_default.a.string]),
    active: prop_types_default.a.bool,
    uploadName: prop_types_default.a.node,
    uploadedBy: prop_types_default.a.string,
    uploadedOn: prop_types_default.a.string,
    statusText: prop_types_default.a.string
  })),
  setUploadErrorMessage: prop_types_default.a.func,
  onPayRateUpload: prop_types_default.a.func,
  onUploadDialogToggle: prop_types_default.a.func,
  role: prop_types_default.a.string.isRequired,
  user: RoleType,
  employee: prop_types_default.a.object,
  requestEmployee: prop_types_default.a.func,
  updateCrewChanges: prop_types_default.a.func,
  installerFormType: prop_types_default.a.string,
  handleCrewPayId: prop_types_default.a.func,
  crewPayId: prop_types_default.a.oneOfType([prop_types_default.a.number, prop_types_default.a.string])
};

/* harmony default export */ var installerForm = (Object(react_redux_es["connect"])(function (state) {
  return {
    employee: Object(reducers["i" /* getEmployeeById */])(state)[state.user.employable_id]
  };
}, { requestEmployee: actionCreators["X" /* requestEmployee */] })(installerForm_InstallerForm));
// CONCATENATED MODULE: ./client/app/screens/main/screens/installers/installerNew.jsx
var installerNew__slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var installerNew__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function installerNew__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function installerNew__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function installerNew__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var installerNew_InstallerNew = function (_Component) {
  installerNew__inherits(InstallerNew, _Component);

  function InstallerNew(props) {
    installerNew__classCallCheck(this, InstallerNew);

    var _this = installerNew__possibleConstructorReturn(this, (InstallerNew.__proto__ || Object.getPrototypeOf(InstallerNew)).call(this, props));

    Object.defineProperty(_this, 'afterCompRenders', {
      enumerable: true,
      writable: true,
      value: function value() {
        setTimeout(function () {
          var tabs = getAllowedInstallerTabs(_this.props.role, _this.props.user && _this.props.user.manage_vendor_workrooms || {});
          var payRatesIdx = tabs.findIndex(function (tab) {
            return tab.label === 'Pay Rates';
          });
          _this.props.updateUI('activeTab', payRatesIdx >= 0 ? payRatesIdx : 0);
        }, 1000);
      }
    });

    _this.handleSave = _this.handleSave.bind(_this);
    _this.handleTabChange = _this.handleTabChange.bind(_this);
    _this.handleCancel = function () {
      _this.props.navigate('/installers');
    };
    return _this;
  }

  installerNew__createClass(InstallerNew, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.resetTab();
      this.props.requestWorkroomList();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.clearValidationErrors('INSTALLER');
    }
  }, {
    key: 'resetTab',
    value: function resetTab() {
      this.props.updateUI('activeTab', 0);
    }
  }, {
    key: 'handleSave',
    value: function handleSave(installer) {
      var _this2 = this;

      return this.props.createInstaller(installer).then(function (_ref) {
        var _ref2 = installerNew__slicedToArray(_ref, 2),
            json = _ref2[1];

        return Object(utils["a" /* confirm */])('Would you like to upload a pay rate document now?', { title: 'Installer Pay Rates', okLabel: 'Yes', cancelLabel: 'No' }).then(function () {
          if (json && {}.hasOwnProperty.call(json, 'id')) {
            _this2.afterCompRenders();
            _this2.props.navigate('/installers/' + json.id + '/edit');
          }
          return true;
        }).catch(function () {
          if (installer.user_attributes.name) {
            _this2.props.updateUI('successMessage', '"' + installer.user_attributes.name + '" was successfully added as an installer.');
            _this2.props.navigate('/installers');
          }
          return true;
        });
      });
    }
  }, {
    key: 'handleTabChange',
    value: function handleTabChange(tabIndex) {
      this.props.updateUI('activeTab', tabIndex);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          errors = _props.errors,
          allWorkrooms = _props.allWorkrooms,
          ui = _props.ui,
          uploadError = _props.uploadError,
          fileLoading = _props.fileLoading,
          role = _props.role,
          user = _props.user;


      return react_default.a.createElement(installerForm, {
        errors: errors,
        allWorkrooms: allWorkrooms,
        onSave: this.handleSave,
        onCancel: this.handleCancel,
        activeTab: ui.activeTab,
        onTabChange: this.handleTabChange,
        uploadError: uploadError,
        fileLoading: fileLoading,
        role: role,
        user: user,
        installerFormType: 'New'
      });
    }
  }]);

  return InstallerNew;
}(react["Component"]);

installerNew_InstallerNew.propTypes = {
  navigate: prop_types_default.a.func,
  clearValidationErrors: prop_types_default.a.func,
  updateUI: prop_types_default.a.func,
  requestWorkroomList: prop_types_default.a.func,
  createInstaller: prop_types_default.a.func,
  errors: prop_types_default.a.object,
  allWorkrooms: prop_types_default.a.array,
  ui: prop_types_default.a.object,
  uploadError: prop_types_default.a.string,
  fileLoading: prop_types_default.a.bool,
  role: prop_types_default.a.string.isRequired,
  user: prop_types_default.a.object
};

var installerNew_mapStateToProps = function mapStateToProps(state) {
  return {
    errors: Object(reducers["C" /* getInstallerErrors */])(state) || {},
    allWorkrooms: Object(reducers["_37" /* getWorkroomList */])(state),
    uploadError: Object(reducers["T" /* getPayRateUploadsError */])(state),
    fileLoading: Object(reducers["V" /* getPayRateUploadsLoading */])(state),
    role: Object(reducers["_12" /* getRole */])(state),
    user: state.user
  };
};

/* harmony default export */ var installerNew = (transpiled_default()()(Object(react_redux_es["connect"])(installerNew_mapStateToProps, {
  navigate: actionCreators["O" /* navigate */],
  createInstaller: actionCreators["r" /* createInstaller */],
  clearValidationErrors: actionCreators["k" /* clearValidationErrors */],
  requestWorkroomList: actionCreators["_31" /* requestWorkroomList */]
})(installerNew_InstallerNew)));
// EXTERNAL MODULE: ./client/app/screens/main/screens/installers/components/helperCard.scss
var helperCard = __webpack_require__("69gD");
var helperCard_default = /*#__PURE__*/__webpack_require__.n(helperCard);

// CONCATENATED MODULE: ./client/app/screens/main/screens/installers/components/crewListingSection.jsx
var crewListingSection__slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function crewListingSection__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }















var DAY_TRANSLATION = {
  1: 'Sunday',
  2: 'Monday',
  3: 'Tuesday',
  4: 'Wednesday',
  5: 'Thursday',
  6: 'Friday',
  7: 'Saturday'
};

var getDaysDisplay = function getDaysDisplay(days) {
  return days.length ? days.map(function (d) {
    return DAY_TRANSLATION[d];
  }).join(', ') : 'NOT AVAILABLE';
};

var crewListingSection_CrewListingSection = function CrewListingSection(props) {
  var title = props.title,
      theme = props.theme,
      crews = props.crews,
      crewsWorkrooms = props.crewsWorkrooms,
      crewsSurfaceTypes = props.crewsSurfaceTypes,
      role = props.role,
      updateUI = props.updateUI,
      parseBadgeLink = props.parseBadgeLink;

  var sectionTitle = classnames_default()([theme.sectionTitle, theme.bigTitle]);

  Object(react["useEffect"])(function () {
    return function () {
      if (props.ui.successMessage) props.updateUI('successMessage', '');
    };
  });

  var resendLink = function resendLink(crew) {
    return props.userResendLink(crew.user_id).then(updateUI('successMessage', 'The confirmation email was resent. This email will expire in 7 days.'));
  };

  return react_default.a.createElement(
    'section',
    { className: theme.section },
    react_default.a.createElement(
      'p',
      { className: sectionTitle },
      title
    ),
    crews.map(function (crew, index) {
      var _ref;

      var crewName = crew.name || 'Crew ' + index;
      var crewStatus = '(' + (crew.active ? 'Active' : 'Inactive') + ')';
      var crewPay = '(' + (crew.use_installer_pay ? 'Installer' : 'Crew') + ' Pay Rates)';
      var crewDeliveryStatus = crew.can_deliver ? 'Can Deliver' : null;
      var dedicatedDelivery = crew.delivery_dedicated ? 'Delivery Dedicated' : null;
      var crewLoginableStatus = crew.loginable ? 'Can Login' : null;
      var crewTitle = crewName + ' ' + crewStatus + ' ' + crewPay;
      var badgeDate = crew.badge_expiration.toString() || '';
      var isBadgeOverdue = false;
      if (badgeDate) {
        var dateObj = new Date(badgeDate);
        var dateISO = dateObj.toISOString();
        isBadgeOverdue = Object(dateUtils["p" /* isOverdue */])(dateISO);
      }
      var listItemClasses = classnames_default()([(_ref = {}, crewListingSection__defineProperty(_ref, theme.inactive, crew.disabled), crewListingSection__defineProperty(_ref, theme.sectionListItem, true), _ref)]);
      var zipCodes = (crew.covered_zip_codes || []).length > 0 ? crew.covered_zip_codes.sort(function (a, b) {
        return a - b;
      }).join(', ') : 'N/A';
      var crew_specific = crew.crew_specific,
          pending = crew.pending;

      var formatTo12Hour = function formatTo12Hour(time24) {
        var _time24$split = time24.split(':'),
            _time24$split2 = crewListingSection__slicedToArray(_time24$split, 2),
            hour = _time24$split2[0],
            minute = _time24$split2[1];

        var period = hour >= 12 ? 'PM' : 'AM';
        var formattedHour = hour % 12 || 12;
        return formattedHour + ':' + minute + ' ' + period;
      };
      // TODO: Hiding TWD - Enable no-unused-vars when Dev is up to date
      // eslint-disable-next-line no-unused-vars
      var travelingZipCodes = (crew.traveling_zip_codes || []).length > 0 ? crew.traveling_zip_codes.sort(function (a, b) {
        return a - b;
      }).join(', ') : 'N/A';
      return react_default.a.createElement(
        'div',
        { key: 'crew-' + crew.id, className: listItemClasses },
        react_default.a.createElement(
          'div',
          { className: crew.active ? null : theme.inactive },
          react_default.a.createElement(
            'div',
            { className: theme.innerSection },
            react_default.a.createElement(
              'div',
              { className: detailsSection_default.a.cardHeader },
              react_default.a.createElement(
                'div',
                { className: detailsSection_default.a.cardTitle },
                crewTitle
              ),
              Object(utils["y" /* roleNotInstallerBased */])(role) && react_default.a.createElement(
                react["Fragment"],
                null,
                react_default.a.createElement(
                  'div',
                  { className: crewDeliveryStatus ? detailsSection_default.a.cardDeliveryStatus : null },
                  dedicatedDelivery || crewDeliveryStatus
                ),
                crewDeliveryStatus && react_default.a.createElement(
                  'div',
                  { className: detailsSection_default.a.cardDeliveryStatus },
                  'Delivery Priority: ',
                  crew.priority
                ),
                react_default.a.createElement(
                  'div',
                  { className: crewLoginableStatus ? detailsSection_default.a.cardDeliveryStatus : null },
                  crewLoginableStatus
                ),
                react_default.a.createElement(
                  'div',
                  null,
                  pending && crew.loginable && Object(services["a" /* can */])(role, 'resend', 'installer') ? react_default.a.createElement(
                    flexbox_react_dist_default.a,
                    null,
                    react_default.a.createElement(
                      'button',
                      {
                        type: 'button',
                        className: detailsSection_default.a.userDetailsLink,
                        onClick: function onClick() {
                          return resendLink(crew);
                        }
                      },
                      'Resend activation email'
                    ),
                    react_default.a.createElement('div', { className: detailsSection_default.a.userDetailsLinkSeparator })
                  ) : null
                )
              )
            ),
            Object(utils["y" /* roleNotInstallerBased */])(role) && react_default.a.createElement(
              'div',
              { className: detailsSection_default.a.flexboxDiv },
              react_default.a.createElement(ResourceDetailsCardElement, {
                size: 'small',
                title: 'contact name',
                value: crew.poc_name
              }),
              react_default.a.createElement(ResourceDetailsCardElement, {
                size: 'small',
                title: 'phone number',
                value: crew.phone_number
              }),
              react_default.a.createElement(ResourceDetailsCardElement, {
                size: 'small',
                title: 'email',
                value: crew.email
              })
            ),
            react_default.a.createElement(
              'div',
              { className: detailsSection_default.a.flexboxDiv },
              react_default.a.createElement(ResourceDetailsCardElement, {
                size: 'small',
                title: 'badge number',
                value: crew.badge_number
              }),
              isBadgeOverdue ? react_default.a.createElement(
                ResourceDetailsCardElement,
                {
                  size: 'small',
                  title: 'badge expiration',
                  className: helperCard_default.a.overdue
                },
                badgeDate
              ) : react_default.a.createElement(ResourceDetailsCardElement, {
                size: 'small',
                title: 'badge expiration',
                value: badgeDate
              }),
              react_default.a.createElement(
                ResourceDetailsCardElement,
                {
                  size: 'small',
                  title: 'badge link',
                  value: crew.badge_link || 'N/A'
                },
                crew.badge_link ? react_default.a.createElement(
                  'a',
                  {
                    href: parseBadgeLink(crew.badge_link), target: '_blank', rel: 'noopener noreferrer'
                  },
                  crew.badge_link
                ) : 'N/A'
              )
            ),
            Object(utils["y" /* roleNotInstallerBased */])(role) && react_default.a.createElement(
              react["Fragment"],
              null,
              react_default.a.createElement(
                'div',
                { className: detailsSection_default.a.flexboxDiv },
                react_default.a.createElement(ResourceDetailsCardElement, {
                  size: 'small',
                  wrap: true,
                  title: 'workrooms',
                  value: Object(utils["A" /* stringifyList */])(crewsWorkrooms[crew.id]) || 'No workrooms'
                }),
                react_default.a.createElement(ResourceDetailsCardElement, {
                  size: 'medium',
                  wrap: true,
                  title: 'zip codes',
                  value: zipCodes
                }),
                react_default.a.createElement(ResourceDetailsCardElement, {
                  size: 'medium',
                  wrap: true,
                  title: 'Traveling Zip Codes',
                  value: travelingZipCodes
                })
              ),
              react_default.a.createElement(
                'div',
                { className: detailsSection_default.a.flexboxDiv },
                react_default.a.createElement(ResourceDetailsCardElement, {
                  size: 'small',
                  wrap: true,
                  title: 'Surface Types',
                  value: Object(utils["A" /* stringifyList */])(crewsSurfaceTypes[crew.id])
                }),
                react_default.a.createElement(ResourceDetailsCardElement, {
                  size: 'medium',
                  wrap: true,
                  title: 'Default Start Time',
                  value: formatTo12Hour(crew.default_start_time)
                })
              )
            ),
            role !== 'installer' && react_default.a.createElement(
              'div',
              { className: detailsSection_default.a.flexboxDiv },
              react_default.a.createElement(ResourceDetailsCardElement, {
                title: 'Notes/Comments',
                wrap: true,
                value: crew.comments || 'No comments'
              })
            ),
            react_default.a.createElement(
              react["Fragment"],
              null,
              react_default.a.createElement(
                'div',
                { className: detailsSection_default.a.cardTitle },
                'Suggestion Availabilities'
              ),
              react_default.a.createElement(
                'div',
                { className: detailsSection_default.a.flexboxDiv },
                react_default.a.createElement(ResourceDetailsCardElement, {
                  size: 'medium',
                  wrap: true,
                  title: (crew.delivery_dedicated ? 'Morning' : 'Daily') + ' Availability',
                  value: getDaysDisplay(crew.daily_availability.morning)
                }),
                crew.delivery_dedicated && react_default.a.createElement(ResourceDetailsCardElement, {
                  size: 'medium',
                  wrap: true,
                  title: 'Afternoon Availability',
                  value: getDaysDisplay(crew.daily_availability.afternoon)
                })
              )
            ),
            Object(services["a" /* can */])(role, 'view', 'crew_specifics') && react_default.a.createElement(
              react["Fragment"],
              null,
              react_default.a.createElement(
                'div',
                { className: detailsSection_default.a.cardTitle },
                'Crew Specifics'
              ),
              react_default.a.createElement(
                'div',
                { className: detailsSection_default.a.flexboxDiv },
                react_default.a.createElement(ResourceDetailsCardElement, {
                  size: 'small',
                  wrap: true,
                  title: 'Max Travel Time (mins)',
                  value: crew_specific.max_travel_time
                }),
                react_default.a.createElement(ResourceDetailsCardElement, {
                  size: 'small',
                  wrap: true,
                  title: 'Phone Call Needed',
                  value: crew_specific.phone_call_needed ? 'Yes' : 'No'
                }),
                react_default.a.createElement(ResourceDetailsCardElement, {
                  size: 'small',
                  wrap: true,
                  title: 'Hardwood SF Per Day',
                  value: crew_specific.hardwood_sf_per_day
                }),
                react_default.a.createElement(ResourceDetailsCardElement, {
                  size: 'small',
                  wrap: true,
                  title: 'Carpet SF Per Day',
                  value: crew_specific.carpet_sf_per_day
                }),
                react_default.a.createElement(ResourceDetailsCardElement, {
                  size: 'small',
                  wrap: true,
                  title: 'Tile SF Per Day',
                  value: crew_specific.tile_sf_per_day
                }),
                react_default.a.createElement(ResourceDetailsCardElement, {
                  size: 'small',
                  wrap: true,
                  title: 'Laminate SF Per Day',
                  value: crew_specific.laminate_sf_per_day
                })
              ),
              react_default.a.createElement(
                'div',
                { className: detailsSection_default.a.flexboxDiv },
                react_default.a.createElement(ResourceDetailsCardElement, {
                  size: 'small',
                  wrap: true,
                  title: 'Vinyl SF Per Day',
                  value: crew_specific.vinyl_sf_per_day
                }),
                react_default.a.createElement(ResourceDetailsCardElement, {
                  size: 'small',
                  wrap: true,
                  title: 'Vinyl Plank SF Per Day',
                  value: crew_specific.vinyl_plank_sf_per_day
                }),
                react_default.a.createElement(ResourceDetailsCardElement, {
                  size: 'small',
                  wrap: true,
                  title: 'Backsplash SF Per Day',
                  value: crew_specific.backsplash_sf_per_day
                }),
                react_default.a.createElement(ResourceDetailsCardElement, {
                  size: 'small',
                  wrap: true,
                  title: 'Speak English',
                  value: crew_specific.can_speak_english ? 'Yes' : 'No'
                }),
                react_default.a.createElement(ResourceDetailsCardElement, {
                  size: 'small',
                  wrap: true,
                  title: 'Speak Spanish',
                  value: crew_specific.can_speak_spanish ? 'Yes' : 'No'
                }),
                react_default.a.createElement(ResourceDetailsCardElement, {
                  size: 'small',
                  wrap: true,
                  title: 'Move Furniture',
                  value: crew_specific.can_move_furniture ? 'Yes' : 'No'
                })
              ),
              react_default.a.createElement(
                'div',
                { className: detailsSection_default.a.flexboxDiv },
                react_default.a.createElement(ResourceDetailsCardElement, {
                  size: 'small',
                  wrap: true,
                  title: 'Move Oversized Furniture',
                  value: crew_specific.can_move_furniture_oversized ? 'Yes' : 'No'
                }),
                react_default.a.createElement(ResourceDetailsCardElement, {
                  size: 'small',
                  wrap: true,
                  title: 'Move Appliances',
                  value: crew_specific.can_move_appliances ? 'Yes' : 'No'
                }),
                react_default.a.createElement(ResourceDetailsCardElement, {
                  size: 'small',
                  wrap: true,
                  title: 'Subfloor Prep',
                  value: crew_specific.can_do_subfloor_prep ? 'Yes' : 'No'
                }),
                react_default.a.createElement(ResourceDetailsCardElement, {
                  size: 'small',
                  wrap: true,
                  title: 'Subfloor Replacement',
                  value: crew_specific.can_do_subfloor_replacement ? 'Yes' : 'No'
                }),
                react_default.a.createElement(ResourceDetailsCardElement, {
                  size: 'small',
                  wrap: true,
                  title: 'Naildown Hardwood',
                  value: crew_specific.can_do_naildown_hardwood ? 'Yes' : 'No'
                }),
                react_default.a.createElement(ResourceDetailsCardElement, {
                  size: 'small',
                  wrap: true,
                  title: 'Gluedown Hardwood',
                  value: crew_specific.can_do_gluedown_hardwood ? 'Yes' : 'No'
                })
              ),
              react_default.a.createElement(
                'div',
                { className: detailsSection_default.a.flexboxDiv },
                react_default.a.createElement(ResourceDetailsCardElement, {
                  size: 'small',
                  wrap: true,
                  title: 'Floating Hardwood',
                  value: crew_specific.can_do_floating_hardwood ? 'Yes' : 'No'
                }),
                react_default.a.createElement(ResourceDetailsCardElement, {
                  size: 'small',
                  wrap: true,
                  title: 'Cali Bamboo',
                  value: crew_specific.can_do_cali_bamboo_hardwood ? 'Yes' : 'No'
                }),
                react_default.a.createElement(ResourceDetailsCardElement, {
                  size: 'small',
                  wrap: true,
                  title: 'Hardwood Steps',
                  value: crew_specific.can_do_steps_hardwood ? 'Yes' : 'No'
                }),
                react_default.a.createElement(ResourceDetailsCardElement, {
                  size: 'small',
                  wrap: true,
                  title: 'Stretch In Carpet',
                  value: crew_specific.can_do_stretch_in_carpet ? 'Yes' : 'No'
                }),
                react_default.a.createElement(ResourceDetailsCardElement, {
                  size: 'small',
                  wrap: true,
                  title: 'Gluedown Carpet',
                  value: crew_specific.can_do_gluedown_carpet ? 'Yes' : 'No'
                }),
                react_default.a.createElement(ResourceDetailsCardElement, {
                  size: 'small',
                  wrap: true,
                  title: 'Binding Carpet',
                  value: crew_specific.can_do_binding_carpet ? 'Yes' : 'No'
                })
              ),
              react_default.a.createElement(
                'div',
                { className: detailsSection_default.a.flexboxDiv },
                react_default.a.createElement(ResourceDetailsCardElement, {
                  size: 'small',
                  wrap: true,
                  title: 'Pattern Match Carpet',
                  value: crew_specific.can_do_pattern_match_carpet ? 'Yes' : 'No'
                }),
                react_default.a.createElement(ResourceDetailsCardElement, {
                  size: 'small',
                  wrap: true,
                  title: 'Berber Carpet',
                  value: crew_specific.can_do_berber_carpet ? 'Yes' : 'No'
                }),
                react_default.a.createElement(ResourceDetailsCardElement, {
                  size: 'small',
                  wrap: true,
                  title: 'Carpet Steps',
                  value: crew_specific.can_do_steps_carpet ? 'Yes' : 'No'
                }),
                react_default.a.createElement(ResourceDetailsCardElement, {
                  size: 'small',
                  wrap: true,
                  title: 'Floor Tile',
                  value: crew_specific.can_do_floor_tile ? 'Yes' : 'No'
                }),
                react_default.a.createElement(ResourceDetailsCardElement, {
                  size: 'small',
                  wrap: true,
                  title: 'Tile Patterns',
                  value: crew_specific.can_do_patterns_tile ? 'Yes' : 'No'
                }),
                react_default.a.createElement(ResourceDetailsCardElement, {
                  size: 'small',
                  wrap: true,
                  title: 'Large Format Tile',
                  value: crew_specific.can_do_large_format_tile ? 'Yes' : 'No'
                })
              ),
              react_default.a.createElement(
                'div',
                { className: detailsSection_default.a.flexboxDiv },
                react_default.a.createElement(ResourceDetailsCardElement, {
                  size: 'small',
                  wrap: true,
                  title: 'Backsplash Tile',
                  value: crew_specific.can_do_backsplash_tile ? 'Yes' : 'No'
                }),
                react_default.a.createElement(ResourceDetailsCardElement, {
                  size: 'small',
                  wrap: true,
                  title: 'Glass Backsplash',
                  value: crew_specific.can_do_backsplash_glass ? 'Yes' : 'No'
                }),
                react_default.a.createElement(ResourceDetailsCardElement, {
                  size: 'small',
                  wrap: true,
                  title: 'Backsplash Blocking',
                  value: crew_specific.can_do_backsplash_blocking ? 'Yes' : 'No'
                }),
                react_default.a.createElement(ResourceDetailsCardElement, {
                  size: 'small',
                  wrap: true,
                  title: 'Sheet Vinyl',
                  value: crew_specific.can_do_vinyl_sheet ? 'Yes' : 'No'
                }),
                react_default.a.createElement(ResourceDetailsCardElement, {
                  size: 'small',
                  wrap: true,
                  title: 'Vinyl Tile',
                  value: crew_specific.can_do_vct_lvt ? 'Yes' : 'No'
                }),
                react_default.a.createElement(ResourceDetailsCardElement, {
                  size: 'small',
                  wrap: true,
                  title: 'Gluedown VP',
                  value: crew_specific.can_do_gluedown_vinyl_plank ? 'Yes' : 'No'
                })
              ),
              react_default.a.createElement(
                'div',
                { className: detailsSection_default.a.flexboxDiv },
                react_default.a.createElement(ResourceDetailsCardElement, {
                  size: 'small',
                  wrap: true,
                  title: 'Floating VP',
                  value: crew_specific.can_do_floating_vinyl_plank ? 'Yes' : 'No'
                }),
                react_default.a.createElement(ResourceDetailsCardElement, {
                  size: 'small',
                  wrap: true,
                  title: 'Remove/Replace Toilet',
                  value: crew_specific.can_remove_replace_toilet ? 'Yes' : 'No'
                }),
                react_default.a.createElement(ResourceDetailsCardElement, {
                  size: 'small',
                  wrap: true,
                  title: 'Remove Naildown Hardwood',
                  value: crew_specific.can_remove_naildown_hardwood ? 'Yes' : 'No'
                }),
                react_default.a.createElement(ResourceDetailsCardElement, {
                  size: 'small',
                  wrap: true,
                  title: 'Remove Floating Hardwood',
                  value: crew_specific.can_remove_floating_hardwood ? 'Yes' : 'No'
                }),
                react_default.a.createElement(ResourceDetailsCardElement, {
                  size: 'small',
                  wrap: true,
                  title: 'Remove Gluedown Hardwood',
                  value: crew_specific.can_remove_gluedown_hardwood ? 'Yes' : 'No'
                }),
                react_default.a.createElement(ResourceDetailsCardElement, {
                  size: 'small',
                  wrap: true,
                  title: 'Remove Carpet Over Pad',
                  value: crew_specific.can_remove_over_pad_carpet ? 'Yes' : 'No'
                })
              ),
              react_default.a.createElement(
                'div',
                { className: detailsSection_default.a.flexboxDiv },
                react_default.a.createElement(ResourceDetailsCardElement, {
                  size: 'small',
                  wrap: true,
                  title: 'Remove Gluedown Carpet',
                  value: crew_specific.can_remove_gluedown_carpet ? 'Yes' : 'No'
                }),
                react_default.a.createElement(ResourceDetailsCardElement, {
                  size: 'small',
                  wrap: true,
                  title: 'Remove Laminate',
                  value: crew_specific.can_remove_laminate ? 'Yes' : 'No'
                }),
                react_default.a.createElement(ResourceDetailsCardElement, {
                  size: 'small',
                  wrap: true,
                  title: 'Remove Tile',
                  value: crew_specific.can_remove_tile ? 'Yes' : 'No'
                }),
                react_default.a.createElement(ResourceDetailsCardElement, {
                  size: 'small',
                  wrap: true,
                  title: 'Remove Gluedown Vinyl',
                  value: crew_specific.can_remove_gluedown_vinyl ? 'Yes' : 'No'
                }),
                react_default.a.createElement(ResourceDetailsCardElement, {
                  size: 'small',
                  wrap: true,
                  title: 'Remove Vinyl Plank',
                  value: crew_specific.can_remove_vinyl_plank ? 'Yes' : 'No'
                }),
                react_default.a.createElement(ResourceDetailsCardElement, {
                  size: 'small',
                  wrap: true,
                  title: 'Remove Backsplash',
                  value: crew_specific.can_remove_backsplash ? 'Yes' : 'No'
                })
              ),
              react_default.a.createElement(
                'div',
                { className: detailsSection_default.a.flexboxDiv },
                react_default.a.createElement(ResourceDetailsCardElement, {
                  size: 'small',
                  wrap: true,
                  title: 'Install Baseboard',
                  value: crew_specific.can_install_hard_transitions ? 'Yes' : 'No'
                }),
                react_default.a.createElement(ResourceDetailsCardElement, {
                  size: 'small',
                  wrap: true,
                  title: 'Install Hard Surface Transition',
                  value: crew_specific.can_do_baseboard ? 'Yes' : 'No'
                })
              )
            )
          )
        )
      );
    })
  );
};

crewListingSection_CrewListingSection.propTypes = {
  title: prop_types_default.a.string,
  crewsWorkrooms: prop_types_default.a.object,
  crewsSurfaceTypes: prop_types_default.a.object,
  theme: prop_types_default.a.object,
  crews: prop_types_default.a.array,
  role: prop_types_default.a.string,
  updateUI: prop_types_default.a.func,
  ui: prop_types_default.a.object,
  userResendLink: prop_types_default.a.func,
  parseBadgeLink: prop_types_default.a.func
};

/* harmony default export */ var crewListingSection = (transpiled_default()()(Object(react_redux_es["connect"])(null, { userResendLink: actionCreators["_78" /* userResendLink */] })(crewListingSection_CrewListingSection)));
// CONCATENATED MODULE: ./client/app/screens/main/screens/installers/components/installerCrewDetails.jsx
function installerCrewDetails__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }














var installerCrewDetails_detailsTheme = { ResourceDetailsCE: detailsCardElement_default.a };

var installerCrewDetails_sectionTitle = classnames_default()([detailsSection_default.a.sectionTitle, detailsSection_default.a.bigTitle]);

var installerCrewDetails_parseBadgeLink = function parseBadgeLink(url) {
  return (/^https?:\/\//.test(url) ? url : 'https://' + url
  );
};

var installerCrewDetails_InstallerCrewDetails = function InstallerCrewDetails(props) {
  var helpers = props.helpers,
      crews = props.crews,
      crewsWorkrooms = props.crewsWorkrooms,
      crewsSurfaceTypes = props.crewsSurfaceTypes,
      role = props.role;

  var helperDivs = helpers.map(function (helper) {
    var _ref;

    var badgeDate = helper.badge_expiration.toString() || '';
    var dateObj = new Date(badgeDate);
    var dateISO = dateObj.toISOString();
    var isBadgeOverdue = Object(dateUtils["p" /* isOverdue */])(dateISO);
    var cardStyle = classnames_default()([helperCard_default.a.helperCard, (_ref = {}, installerCrewDetails__defineProperty(_ref, helperCard_default.a.doNotUse, helper.not_used), installerCrewDetails__defineProperty(_ref, detailsSection_default.a.inactive, !helper.not_used && helper.disabled), _ref)]);
    return react_default.a.createElement(
      components_Card,
      { key: helper.id, className: cardStyle },
      react_default.a.createElement(
        'div',
        { className: detailsSection_default.a.flexboxDiv },
        react_default.a.createElement(ResourceDetailsCardElement, {
          size: 'small',
          title: 'name',
          value: helper.name
        }),
        Object(utils["y" /* roleNotInstallerBased */])(role) && react_default.a.createElement(
          react["Fragment"],
          null,
          react_default.a.createElement(ResourceDetailsCardElement, {
            size: 'small',
            title: 'phone number',
            value: helper.phone_number
          }),
          react_default.a.createElement(ResourceDetailsCardElement, {
            size: 'small',
            title: 'email',
            value: helper.email
          })
        ),
        react_default.a.createElement(ResourceDetailsCardElement, {
          size: 'small',
          title: 'badge number',
          value: helper.badge_number
        }),
        isBadgeOverdue ? react_default.a.createElement(
          ResourceDetailsCardElement,
          {
            size: 'small',
            title: 'badge expiration',
            className: helperCard_default.a.overdue
          },
          badgeDate
        ) : react_default.a.createElement(ResourceDetailsCardElement, {
          size: 'small',
          title: 'badge expiration',
          value: badgeDate
        }),
        react_default.a.createElement(
          ResourceDetailsCardElement,
          {
            size: 'small',
            title: 'badge link',
            value: helper.badge_link || 'N/A'
          },
          helper.badge_link ? react_default.a.createElement(
            'a',
            {
              href: installerCrewDetails_parseBadgeLink(helper.badge_link), target: '_blank', rel: 'noopener noreferrer'
            },
            helper.badge_link
          ) : 'N/A'
        )
      )
    );
  });

  return react_default.a.createElement(
    react_css_themr_lib["ThemeProvider"],
    { theme: installerCrewDetails_detailsTheme },
    react_default.a.createElement(
      'div',
      null,
      react_default.a.createElement(crewListingSection, {
        title: 'Crew Management',
        crews: crews,
        crewsWorkrooms: crewsWorkrooms,
        crewsSurfaceTypes: crewsSurfaceTypes,
        theme: detailsSection_default.a,
        parseBadgeLink: installerCrewDetails_parseBadgeLink,
        role: role
      }),
      react_default.a.createElement(
        'section',
        { className: detailsSection_default.a.section },
        react_default.a.createElement(
          'div',
          { className: installerCrewDetails_detailsTheme.innerSection },
          react_default.a.createElement(
            'div',
            { className: installerCrewDetails_sectionTitle },
            'Helpers'
          ),
          helperDivs
        )
      )
    )
  );
};

installerCrewDetails_InstallerCrewDetails.propTypes = {
  crewsSurfaceTypes: prop_types_default.a.object,
  crewsWorkrooms: prop_types_default.a.object,
  helpers: prop_types_default.a.array,
  crews: prop_types_default.a.array,
  role: prop_types_default.a.string
};

/* harmony default export */ var installerCrewDetails = (installerCrewDetails_InstallerCrewDetails);
// EXTERNAL MODULE: ./client/app/screens/main/screens/installers/components/installerBasicInfoDetails.scss
var installerBasicInfoDetails = __webpack_require__("QGgP");
var installerBasicInfoDetails_default = /*#__PURE__*/__webpack_require__.n(installerBasicInfoDetails);

// CONCATENATED MODULE: ./client/app/screens/main/screens/installers/components/installerBasicInfoDetails.jsx









var MINIMUM_LINE_ITEMS = [{ number: 227605, label: 'Minimum Charge - Tile' }, { number: 227614, label: 'Minimum Charge - Laminate' }, { number: 227637, label: 'Minimum Charge - Hardwood' }, { number: 227647, label: 'Minimum Charge - Vinyl' }, { number: 228214, label: 'Minimum Charge - Carpet' }, { number: 475371, label: 'Minimum Charge - Backsplash' }];
var EMPTY_DETAIL = { price_cents: ' -- ' };
var DEFAULT_ADDRESS = { street: '', city: '', state: '', zip_code: '' };

var installerBasicInfoDetails_InstallerBasicInfoDetails = function InstallerBasicInfoDetails(props) {
  var installer = props.installer,
      _props$installer = props.installer,
      _props$installer$addr = _props$installer.address,
      address = _props$installer$addr === undefined ? DEFAULT_ADDRESS : _props$installer$addr,
      _props$installer$work = _props$installer.workers_comp_expiration,
      workers_comp_expiration = _props$installer$work === undefined ? null : _props$installer$work,
      _props$installer$liab = _props$installer.liability_insurance_expiration,
      liability_insurance_expiration = _props$installer$liab === undefined ? null : _props$installer$liab,
      _props$installer$net_ = _props$installer.net_payable_exempt,
      net_payable_exempt = _props$installer$net_ === undefined ? null : _props$installer$net_,
      _props$installer$is_s = _props$installer.is_self_schedulable,
      is_self_schedulable = _props$installer$is_s === undefined ? false : _props$installer$is_s,
      _props$installer$pay_ = _props$installer.pay_details,
      pay_details = _props$installer$pay_ === undefined ? [] : _props$installer$pay_,
      _props$installer$visi = _props$installer.visibility,
      visibility = _props$installer$visi === undefined ? null : _props$installer$visi,
      _props$installer$assi = _props$installer.assigned_supervisor,
      assigned_supervisor = _props$installer$assi === undefined ? null : _props$installer$assi,
      _props$installer$supe = _props$installer.supervisor_name,
      supervisor_name = _props$installer$supe === undefined ? null : _props$installer$supe,
      _props$installer$over = _props$installer.overall_percentage,
      overall_percentage = _props$installer$over === undefined ? null : _props$installer$over,
      _props$installer$cust = _props$installer.custom_labor_percentage,
      custom_labor_percentage = _props$installer$cust === undefined ? null : _props$installer$cust,
      role = props.role,
      _props$position = props.position,
      position = _props$position === undefined ? '' : _props$position,
      _props$mvw = props.mvw,
      mvw = _props$mvw === undefined ? {} : _props$mvw;

  var safeAddress = address || DEFAULT_ADDRESS;

  var supervisorName = assigned_supervisor && assigned_supervisor.name || supervisor_name;

  var renderMinimums = function renderMinimums(payDetails) {
    return MINIMUM_LINE_ITEMS.map(function (lineItem) {
      var detail = payDetails.length ? payDetails.find(function (p) {
        return Number(p.item_number) === lineItem.number;
      }) || EMPTY_DETAIL : EMPTY_DETAIL;
      var convertCentsToDollars = isNaN(detail.price_cents) ? EMPTY_DETAIL.price_cents : detail.price_cents / 100;
      return react_default.a.createElement(users_UserDetailsElement, {
        key: lineItem.number,
        title: lineItem.label,
        value: convertCentsToDollars.toLocaleString('en-US', { style: 'currency', currency: 'USD' })
      });
    });
  };

  return react_default.a.createElement(
    'div',
    null,
    react_default.a.createElement(users_UserDetailsBasicInfo, { user: installer }),
    react_default.a.createElement(
      users_UserDetailsRow,
      { title: 'Company Details' },
      react_default.a.createElement(
        users_UserDetailsElement,
        { title: 'address' },
        react_default.a.createElement(components_DetailsAddress, {
          address: safeAddress.street,
          city: safeAddress.city,
          state: safeAddress.state,
          zipCode: safeAddress.zip_code
        })
      )
    ),
    react_default.a.createElement(
      users_UserDetailsRow,
      { title: 'Insurance' },
      react_default.a.createElement(users_UserDetailsElement, {
        title: 'workers comp. expiration',
        value: workers_comp_expiration
      }),
      react_default.a.createElement(users_UserDetailsElement, {
        title: 'general liability insurance expiration',
        value: liability_insurance_expiration
      })
    ),
    react_default.a.createElement(
      users_UserDetailsRow,
      { title: 'Payment Details' },
      react_default.a.createElement(users_UserDetailsElement, {
        title: 'Exempt Net Payable Reduction',
        value: net_payable_exempt ? 'Yes' : 'No'
      }),
      react_default.a.createElement(
        'div',
        { className: installerBasicInfoDetails_default.a.MinProjectPriceContainer },
        react_default.a.createElement(
          'div',
          { className: installerBasicInfoDetails_default.a.MinProjectPrice },
          renderMinimums(pay_details)
        )
      )
    ),
    react_default.a.createElement(
      users_UserDetailsRow,
      { title: 'Scheduling' },
      react_default.a.createElement(users_UserDetailsElement, {
        title: 'Self Schedulable',
        value: is_self_schedulable ? 'Yes' : 'No'
      })
    ),
    role !== 'installer' && react_default.a.createElement(
      users_UserDetailsRow,
      { title: 'Restrictions' },
      react_default.a.createElement(users_UserDetailsElement, {
        title: 'Schedule Visibility',
        value: (visibility || '1') + ' Day(s)'
      })
    ),
    mvw.ifi && react_default.a.createElement(
      users_UserDetailsRow,
      { title: 'IFI Pay' },
      react_default.a.createElement(users_UserDetailsElement, {
        title: 'Overall %',
        value: overall_percentage != null ? overall_percentage + '%' : '--'
      }),
      react_default.a.createElement(users_UserDetailsElement, {
        title: 'Custom Labor %',
        value: custom_labor_percentage != null ? custom_labor_percentage + '%' : '--'
      })
    ),
    Object(services["a" /* can */])(role, 'view', 'SUPERVISOR_INFO', {
      position: position,
      mvw: mvw
    }) && supervisorName &&
    // "Supervisor" is labeled as "Coordinator" in the UI since
    // that's more familiar to IFI users, but the value is still
    // stored as "supervisor_id" in the backend.
    react_default.a.createElement(
      users_UserDetailsRow,
      { title: 'Coordinator' },
      react_default.a.createElement(users_UserDetailsElement, {
        title: 'Assigned Coordinator',
        value: supervisorName
      })
    )
  );
};

installerBasicInfoDetails_InstallerBasicInfoDetails.propTypes = {
  installer: prop_types_default.a.object,
  role: prop_types_default.a.string,
  position: prop_types_default.a.string,
  mvw: prop_types_default.a.object
};

/* harmony default export */ var components_installerBasicInfoDetails = (installerBasicInfoDetails_InstallerBasicInfoDetails);
// CONCATENATED MODULE: ./client/app/screens/main/screens/installers/components/installerCertificationsDetails.jsx





var installerCertificationsDetails_InstallerCertificationsDetails = function InstallerCertificationsDetails(_ref) {
  var installer = _ref.installer;
  var _installer$installer_ = installer.installer_firm_certification_number,
      installer_firm_certification_number = _installer$installer_ === undefined ? null : _installer$installer_,
      _installer$installer_2 = installer.installer_firm_certification_expiration,
      installer_firm_certification_expiration = _installer$installer_2 === undefined ? null : _installer$installer_2,
      _installer$assigned_r = installer.assigned_renovator_certification_number,
      assigned_renovator_certification_number = _installer$assigned_r === undefined ? null : _installer$assigned_r,
      _installer$assigned_r2 = installer.assigned_renovator_certification_expiration,
      assigned_renovator_certification_expiration = _installer$assigned_r2 === undefined ? null : _installer$assigned_r2;


  return react_default.a.createElement(
    'div',
    null,
    react_default.a.createElement(
      users_UserDetailsRow,
      { title: 'Millwork certifications' },
      react_default.a.createElement(users_UserDetailsElement, {
        title: 'installer firm certification number',
        value: installer_firm_certification_number || '—'
      }),
      react_default.a.createElement(users_UserDetailsElement, {
        title: 'installer firm certification expiration',
        value: installer_firm_certification_expiration || '—'
      }),
      react_default.a.createElement(users_UserDetailsElement, {
        title: 'assigned renovator certification number',
        value: assigned_renovator_certification_number || '—'
      }),
      react_default.a.createElement(users_UserDetailsElement, {
        title: 'assigned renovator certification expiration',
        value: assigned_renovator_certification_expiration || '—'
      })
    )
  );
};

installerCertificationsDetails_InstallerCertificationsDetails.propTypes = {
  installer: prop_types_default.a.object.isRequired
};

/* harmony default export */ var installerCertificationsDetails = (installerCertificationsDetails_InstallerCertificationsDetails);
// CONCATENATED MODULE: ./client/app/screens/main/screens/installers/components/installerScore.jsx





var installerScore_InstallerScore = function InstallerScore(props) {
  var installer = props.installer;

  var installerScore = function installerScore(score) {
    return score ? score + '%' : 'N/A';
  };
  return react_default.a.createElement(
    users_UserDetailsRow,
    { title: 'All Time Average Score' },
    react_default.a.createElement(users_UserDetailsElement, {
      title: 'professionalism',
      value: installerScore(installer.professionalism)
    }),
    react_default.a.createElement(users_UserDetailsElement, {
      title: 'craftsmanship',
      value: installerScore(installer.craftsmanship)
    })
  );
};

installerScore_InstallerScore.propTypes = {
  installer: prop_types_default.a.object
};

/* harmony default export */ var components_installerScore = (installerScore_InstallerScore);
// EXTERNAL MODULE: ./client/app/shared/actionCreators/traveling_work_dates.js
var traveling_work_dates = __webpack_require__("Rq0V");

// EXTERNAL MODULE: ./client/app/shared/components/TravelingWorkTable/styles.scss
var TravelingWorkTable_styles = __webpack_require__("wMiq");
var TravelingWorkTable_styles_default = /*#__PURE__*/__webpack_require__.n(TravelingWorkTable_styles);

// CONCATENATED MODULE: ./client/app/shared/components/TravelingWorkTable/components/travelingWorkTableRow.jsx
var travelingWorkTableRow__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function travelingWorkTableRow__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function travelingWorkTableRow__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function travelingWorkTableRow__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function travelingWorkTableRow__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var travelingWorkTableRow_DATE_FORMAT = 'MM/DD/YYYY';
var BLANK_ERROR = 'Can\'t be blank';

var travelingWorkTableRow_TravelingWorkTableRow = function (_React$Component) {
  travelingWorkTableRow__inherits(TravelingWorkTableRow, _React$Component);

  function TravelingWorkTableRow(props) {
    travelingWorkTableRow__classCallCheck(this, TravelingWorkTableRow);

    var _this = travelingWorkTableRow__possibleConstructorReturn(this, (TravelingWorkTableRow.__proto__ || Object.getPrototypeOf(TravelingWorkTableRow)).call(this, props));

    Object.defineProperty(_this, 'componentWillReceiveProps', {
      enumerable: true,
      writable: true,
      value: function value(nextProps) {
        var twd = nextProps.twd;

        if (twd.id !== 'new' && Object(lodash["isEqual"])(twd, _this.props.twd)) return;
        _this.setState(_this.mapTWD(twd));
      }
    });
    Object.defineProperty(_this, 'mapTWD', {
      enumerable: true,
      writable: true,
      value: function value(twd) {
        var startDate = twd.start_date && moment_default()(twd.start_date).format(travelingWorkTableRow_DATE_FORMAT);
        var endDate = twd.end_date && moment_default()(twd.end_date).format(travelingWorkTableRow_DATE_FORMAT);
        var crew = (twd.assignee || {}).id || '';
        return travelingWorkTableRow__extends({ errors: {} }, twd, { start_date: startDate, end_date: endDate, crew: crew });
      }
    });
    Object.defineProperty(_this, 'validate', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$state = _this.state,
            crew = _this$state.crew,
            traveling_stores = _this$state.traveling_stores,
            start_date = _this$state.start_date,
            end_date = _this$state.end_date;

        var errors = {};
        if (!crew) errors.crew = BLANK_ERROR;
        if (!traveling_stores || traveling_stores.length < 1) errors.traveling_store = BLANK_ERROR;
        if (!start_date) errors.start_date = BLANK_ERROR;
        if (!end_date) errors.end_date = BLANK_ERROR;
        _this.setState({ errors: errors });
        return Object.keys(errors).length === 0;
      }
    });
    Object.defineProperty(_this, 'handleChange', {
      enumerable: true,
      writable: true,
      value: function value(attr) {
        return function (val) {
          if (attr === 'traveling_stores') {
            var storeIDs = val.map(function (store) {
              return store.value;
            });
            _this.setState(travelingWorkTableRow__defineProperty({}, attr, storeIDs));
          } else {
            _this.setState(travelingWorkTableRow__defineProperty({}, attr, val.target ? val.target.value : val));
          }
        };
      }
    });
    Object.defineProperty(_this, 'handleSave', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.validate() && _this.props.onSave(_this.state);
      }
    });
    Object.defineProperty(_this, 'handleDelete', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.onDelete(_this.state);
      }
    });
    Object.defineProperty(_this, 'handleCrewChange', {
      enumerable: true,
      writable: true,
      value: _this.handleChange('crew')
    });
    Object.defineProperty(_this, 'handleStartDateChange', {
      enumerable: true,
      writable: true,
      value: _this.handleChange('start_date')
    });
    Object.defineProperty(_this, 'handleEndDateChange', {
      enumerable: true,
      writable: true,
      value: _this.handleChange('end_date')
    });
    Object.defineProperty(_this, 'handleTravelingStoresChange', {
      enumerable: true,
      writable: true,
      value: _this.handleChange('traveling_stores')
    });
    Object.defineProperty(_this, 'renderCrewCell', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$state2 = _this.state,
            _this$state2$assignee = _this$state2.assignee,
            assignee = _this$state2$assignee === undefined ? {} : _this$state2$assignee,
            errors = _this$state2.errors;
        var _this$props = _this.props,
            crews = _this$props.crews,
            isCrew = _this$props.isCrew;

        var options = crews.map(function (crew) {
          return { label: crew.name, value: crew.id };
        });
        var value = (assignee || {}).name;
        var error = errors.crew;
        var cellProps = {
          label: 'Crew',
          display: isCrew,
          onChange: _this.handleCrewChange,
          value: value,
          error: error,
          cellReadOnly: !Object(lodash["isEmpty"])(assignee)
        };
        return react_default.a.createElement(
          editableTableCell,
          cellProps,
          react_default.a.createElement(components_StyledSelect, { options: options, value: _this.state.crew, className: TravelingWorkTable_styles_default.a.select, placeholder: ' ' })
        );
      }
    });
    Object.defineProperty(_this, 'renderDateCell', {
      enumerable: true,
      writable: true,
      value: function value(attr, label) {
        var twd = _this.props.twd;
        var errors = _this.state.errors;

        var value = twd[attr] && moment_default()(twd[attr]).format(travelingWorkTableRow_DATE_FORMAT);
        var minDate = moment_default()().subtract(1, 'day').toDate();
        return react_default.a.createElement(
          editableTableCell,
          {
            label: label,
            value: value,
            onChange: attr === 'start_date' ? _this.handleStartDateChange : _this.handleEndDateChange,
            error: errors[attr]
          },
          react_default.a.createElement(DatePicker, { value: _this.state[attr], minDate: minDate, className: TravelingWorkTable_styles_default.a.datepicker })
        );
      }
    });
    Object.defineProperty(_this, 'renderTravelingStoresCell', {
      enumerable: true,
      writable: true,
      value: function value(label) {
        var storeOptions = _this.props.storeOptions;
        var _this$state3 = _this.state,
            traveling_stores = _this$state3.traveling_stores,
            errors = _this$state3.errors;

        var sortedStoreOptions = storeOptions.slice().sort(function (a, b) {
          if (b.label < a.label) return 1;
          return -1;
        });
        var storeNames = [];
        (Object.values(storeOptions) || []).forEach(function (store) {
          if (traveling_stores.includes(store.value)) storeNames.push(store.label);
        });
        return react_default.a.createElement(
          editableTableCell,
          {
            label: label,
            value: storeNames.join(', ') || '',
            onChange: _this.handleTravelingStoresChange,
            error: errors.traveling_store
          },
          react_default.a.createElement(react_select, {
            multi: true,
            name: 'TravelingStores',
            className: ReactSelect_styles_default.a.selectWrapper,
            options: sortedStoreOptions,
            value: traveling_stores,
            placeholder: 'Select store(s)'
          })
        );
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var isNew = _this.state.id === 'new';
        var disabled = moment_default()().isAfter(moment_default()(_this.state.end_date, travelingWorkTableRow_DATE_FORMAT), 'day');
        var rowProps = { isNew: isNew, disabled: disabled, onSave: _this.handleSave, onDelete: _this.handleDelete };
        return react_default.a.createElement(
          editableTableRow,
          travelingWorkTableRow__extends({ className: _this.props.className }, rowProps),
          _this.renderCrewCell(),
          _this.renderDateCell('start_date', 'Start Date'),
          _this.renderDateCell('end_date', 'End Date'),
          _this.renderTravelingStoresCell('Traveling Stores')
        );
      }
    });

    _this.state = _this.mapTWD(_this.props.twd);
    return _this;
  }

  return TravelingWorkTableRow;
}(react_default.a.Component);

travelingWorkTableRow_TravelingWorkTableRow.contextTypes = {
  isEditable: prop_types_default.a.bool
};

travelingWorkTableRow_TravelingWorkTableRow.propTypes = {
  twd: prop_types_default.a.object.isRequired,
  onSave: prop_types_default.a.func.isRequired,
  onDelete: prop_types_default.a.func.isRequired,
  crews: prop_types_default.a.array,
  isCrew: prop_types_default.a.bool,
  storeOptions: prop_types_default.a.array,
  className: prop_types_default.a.string
};

travelingWorkTableRow_TravelingWorkTableRow.defaultProps = {
  crews: [],
  isCrew: false,
  className: ''
};

/* harmony default export */ var travelingWorkTableRow = (travelingWorkTableRow_TravelingWorkTableRow);
// CONCATENATED MODULE: ./client/app/shared/components/TravelingWorkTable/index.jsx
var TravelingWorkTable__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function TravelingWorkTable__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function TravelingWorkTable__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function TravelingWorkTable__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var TravelingWorkTable_DATE_FORMAT = 'MM/DD/YYYY';
var TravelingWorkTable_EMPTY_TABLE = react_default.a.createElement(
  'div',
  { className: TravelingWorkTable_styles_default.a.emptyTable },
  react_default.a.createElement(
    'h4',
    null,
    'No traveling work found'
  )
);

var TravelingWorkTable_TravelingWorkTable = function (_React$Component) {
  TravelingWorkTable__inherits(TravelingWorkTable, _React$Component);

  function TravelingWorkTable() {
    var _ref;

    var _temp, _this, _ret;

    TravelingWorkTable__classCallCheck(this, TravelingWorkTable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = TravelingWorkTable__possibleConstructorReturn(this, (_ref = TravelingWorkTable.__proto__ || Object.getPrototypeOf(TravelingWorkTable)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'state', {
      enumerable: true,
      writable: true,
      value: { conflict: {}, hasConflict: false }
    }), Object.defineProperty(_this, 'componentWillMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.requestWorkroomList();
      }
    }), Object.defineProperty(_this, 'getStores', {
      enumerable: true,
      writable: true,
      value: function value() {
        var workroomsArr = Object.values(_this.props.workrooms.byId);
        var workroomStores = [];
        workroomsArr.forEach(function (wrkrm) {
          return wrkrm.store_with_zips.forEach(function (szc) {
            return workroomStores.push(szc.store);
          });
        });
        var storeOptions = Object(utils["j" /* generateSource */])(workroomStores);
        return storeOptions;
      }
    }), Object.defineProperty(_this, 'createTravelingWorkDate', {
      enumerable: true,
      writable: true,
      value: function value(twd) {
        var _this$props = _this.props,
            parentID = _this$props.parentID,
            parentKind = _this$props.parentKind;

        if (_this.props.isCrew) {
          parentID = twd.crew;
          parentKind = 'crews';
        }
        return _this.props.createTravelingWorkDate(parentID, parentKind, twd);
      }
    }), Object.defineProperty(_this, 'updateTravelingWorkDate', {
      enumerable: true,
      writable: true,
      value: function value(twd) {
        return _this.props.updateTravelingWorkDate(twd.id, twd);
      }
    }), Object.defineProperty(_this, 'handleSave', {
      enumerable: true,
      writable: true,
      value: function value(twd) {
        var assignee = { id: twd.crew, name: '', kind: '' };
        var startDate = moment_default()(twd.start_date, TravelingWorkTable_DATE_FORMAT).format();
        var endDate = moment_default()(twd.end_date, TravelingWorkTable_DATE_FORMAT).format();
        var params = TravelingWorkTable__extends({ assignee: assignee }, twd, { start_date: startDate, end_date: endDate });
        if (twd.id === 'new') _this.createTravelingWorkDate(params);else _this.updateTravelingWorkDate(params);
      }
    }), Object.defineProperty(_this, 'handleDelete', {
      enumerable: true,
      writable: true,
      value: function value(twd) {
        if (twd.id !== 'new') _this.props.deleteTravelingWorkDate(twd.id);
      }
    }), Object.defineProperty(_this, 'handleModalClose', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ hasConflict: false });
      }
    }), Object.defineProperty(_this, 'renderRows', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props2 = _this.props,
            travelingWorkDates = _this$props2.travelingWorkDates,
            crews = _this$props2.crews,
            isCrew = _this$props2.isCrew;

        var storeOptions = _this.getStores();
        if (travelingWorkDates.length === 0 || travelingWorkDates[0].id !== 'new') {
          travelingWorkDates.unshift({ id: 'new', start_date: '', end_date: '', traveling_stores: [], crew: '' });
        }
        return travelingWorkDates.map(function (twd) {
          return react_default.a.createElement(travelingWorkTableRow, {
            key: twd.id,
            twd: twd,
            onSave: _this.handleSave,
            onDelete: _this.handleDelete,
            crews: crews,
            storeOptions: storeOptions,
            isCrew: isCrew
          });
        });
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        return react_default.a.createElement(
          'div',
          { className: TravelingWorkTable_styles_default.a.travelingWorkTable },
          react_default.a.createElement(
            editableTable,
            { isEditable: _this.props.isEditable, emptyNode: TravelingWorkTable_EMPTY_TABLE },
            _this.renderRows()
          )
        );
      }
    }), _temp), TravelingWorkTable__possibleConstructorReturn(_this, _ret);
  }

  return TravelingWorkTable;
}(react_default.a.Component);

TravelingWorkTable_TravelingWorkTable.propTypes = {
  crews: prop_types_default.a.array,
  isCrew: prop_types_default.a.bool,
  workrooms: prop_types_default.a.object,
  isEditable: prop_types_default.a.bool,
  travelingWorkDates: prop_types_default.a.array, // Should we create a TravelingWorkDateType?
  parentID: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]).isRequired,
  parentKind: prop_types_default.a.string.isRequired,
  requestWorkroomList: prop_types_default.a.func.isRequired,
  createTravelingWorkDate: prop_types_default.a.func.isRequired,
  updateTravelingWorkDate: prop_types_default.a.func.isRequired,
  deleteTravelingWorkDate: prop_types_default.a.func.isRequired
};

TravelingWorkTable_TravelingWorkTable.defaultProps = {
  crews: [],
  isCrew: false,
  isEditable: false,
  travelingWorkDates: []
};

var TravelingWorkTable_mapStateToProps = function mapStateToProps(state) {
  return {
    workrooms: state.workrooms
  };
};

/* harmony default export */ var components_TravelingWorkTable = (Object(react_redux_es["connect"])(
// () => ({ }),
TravelingWorkTable_mapStateToProps, { createTravelingWorkDate: traveling_work_dates["a" /* createTravelingWorkDate */],
  updateTravelingWorkDate: traveling_work_dates["d" /* updateTravelingWorkDate */],
  deleteTravelingWorkDate: traveling_work_dates["b" /* deleteTravelingWorkDate */],
  requestWorkroomList: actionCreators["_31" /* requestWorkroomList */] })(TravelingWorkTable_TravelingWorkTable));
// CONCATENATED MODULE: ./client/app/screens/main/screens/installers/components/installerDetailsCard.jsx
function installerDetailsCard__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function installerDetailsCard__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function installerDetailsCard__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















// import JobHistoryTable from 'components/JobHistoryTable';















var installerDetailsCard_detailsTheme = {
  RTCard: resourceDetailsCard_default.a, RTTabs: tabs_default.a, ResourceDetailsCE: detailsCardElement_default.a
};

var installerDetailsCard_InstallerDetails = function (_Component) {
  installerDetailsCard__inherits(InstallerDetails, _Component);

  function InstallerDetails(props) {
    installerDetailsCard__classCallCheck(this, InstallerDetails);

    var _this = installerDetailsCard__possibleConstructorReturn(this, (InstallerDetails.__proto__ || Object.getPrototypeOf(InstallerDetails)).call(this, props));

    installerDetailsCard__initialiseProps.call(_this);

    var role = props.role;

    var isInstallerSelf = role === 'installer';
    var hasIfiPermission = props.mvw && props.mvw.ifi === true || isInstallerSelf;
    _this.state = {
      isEditable: false,
      allowedTabs: constants["P" /* INSTALLER_TABS */].filter(function (tab) {
        if (tab.label === 'Millwork Certifications') {
          return hasIfiPermission && Object(services["a" /* can */])(role, 'view', tab.ability);
        }
        return tab.label === 'Crew' || Object(utils["y" /* roleNotInstallerBased */])(role) && Object(services["a" /* can */])(role, 'view', tab.ability);
      })
    };
    return _this;
  }

  return InstallerDetails;
}(react["Component"]);

var installerDetailsCard__initialiseProps = function _initialiseProps() {
  var _this2 = this;

  Object.defineProperty(this, 'componentDidMount', {
    enumerable: true,
    writable: true,
    value: function value() {
      return _this2.props.requestEmployee(_this2.props.user.employable_id);
    }
  });
  Object.defineProperty(this, 'handleEditToggle', {
    enumerable: true,
    writable: true,
    value: function value() {
      return _this2.setState({ isEditable: !_this2.state.isEditable });
    }
  });
  Object.defineProperty(this, 'renderCustomEditButton', {
    enumerable: true,
    writable: true,
    value: function value(tab) {
      var _props = _this2.props,
          role = _props.role,
          user = _props.user,
          installer = _props.installer;
      var isEditable = _this2.state.isEditable;

      if (!Object(services["a" /* can */])(role, 'manage', 'pto', { user_id: user.id, obj_id: installer.id })) return null;
      var label = void 0;
      var style = void 0;
      if (tab === 'Time Off') {
        label = 'Edit Time Off';
        style = helperCard_default.a.timeOffEditButton;
      } else {
        label = 'Edit Traveling Work';
        style = helperCard_default.a.timeOffEditButton;
      }
      return react_default.a.createElement(editToggleButton, {
        actionLabel: label,
        className: style,
        isEditable: isEditable,
        onClick: _this2.handleEditToggle
      });
    }
  });
  Object.defineProperty(this, 'renderTabContent', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _props2 = _this2.props,
          installer = _props2.installer,
          helpers = _props2.helpers,
          crews = _props2.crews,
          crewsWorkrooms = _props2.crewsWorkrooms,
          crewsSurfaceTypes = _props2.crewsSurfaceTypes,
          activeTab = _props2.activeTab,
          payRateUploadsData = _props2.payRateUploadsData,
          ptos = _props2.ptos,
          travelingWorkDates = _props2.travelingWorkDates,
          role = _props2.role;
      var _state = _this2.state,
          isEditable = _state.isEditable,
          allowedTabs = _state.allowedTabs;

      switch (allowedTabs[activeTab].label) {
        case 'Basic Info':
          return react_default.a.createElement(components_installerBasicInfoDetails, {
            installer: installer,
            theme: installerDetailsCard_detailsTheme,
            role: role,
            position: _this2.props.position,
            mvw: _this2.props.mvw
          });
        case 'Millwork Certifications':
          return react_default.a.createElement(installerCertificationsDetails, { installer: installer });
        case 'Scores':
          return react_default.a.createElement(components_installerScore, { installer: installer, theme: installerDetailsCard_detailsTheme });
        case 'Pay Rates':
          return react_default.a.createElement(
            'div',
            {
              style: {
                padding: '15px 24px 15px 24px',
                borderBottom: 'solid 1px $line-divider-grey'
              }
            },
            react_default.a.createElement(components_UploadsTable, {
              role: role,
              isPayRate: true,
              downloadColumnName: 'Download',
              data: payRateUploadsData,
              crews: crews.length ? crews : null
            })
          );
        case 'Crew':
          return react_default.a.createElement(installerCrewDetails, {
            helpers: helpers,
            crews: crews,
            crewsWorkrooms: crewsWorkrooms,
            crewsSurfaceTypes: crewsSurfaceTypes,
            role: role
          });
        case 'Time Off':
          return react_default.a.createElement(components_TimeOffTable, {
            isEditable: isEditable,
            ptos: ptos,
            parentID: installer.id,
            parentKind: 'installers',
            crews: crews,
            isCrew: true
          });
        case 'Traveling Work':
          return react_default.a.createElement(components_TravelingWorkTable, {
            isEditable: isEditable,
            travelingWorkDates: travelingWorkDates,
            parentID: installer.id,
            parentKind: 'installers',
            crews: crews,
            isCrew: true
          });
        case 'User Details History':
          return react_default.a.createElement(components_EmployableHistory, { employable: installer, employableType: 'installer' });
        default:
          return null;
      }
    }
  });
  Object.defineProperty(this, 'render', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _props3 = _this2.props,
          installer = _props3.installer,
          helpers = _props3.helpers,
          crews = _props3.crews,
          workrooms = _props3.workrooms,
          activeTab = _props3.activeTab,
          onTabChange = _props3.onTabChange,
          role = _props3.role,
          _props3$employee = _props3.employee,
          employee = _props3$employee === undefined ? null : _props3$employee;
      var allowedTabs = _this2.state.allowedTabs;

      var tabLabel = (allowedTabs[activeTab] || {}).label || '';
      var userProps = {
        user: installer,
        type: 'installers',
        role: role,
        workrooms: workrooms,
        resource: 'installer',
        editAction: 'update_basic',
        editHandler: ['Time Off', 'Traveling Work'].includes(tabLabel) ? _this2.renderCustomEditButton(tabLabel) : null
      };
      return react_default.a.createElement(
        react_css_themr_lib["ThemeProvider"],
        { theme: installerDetailsCard_detailsTheme },
        permissionByWorkroomId(role, workrooms, employee) ? react_default.a.createElement(
          users_UserDetailsCard,
          userProps,
          react_default.a.createElement(
            react_toolbox_lib["Tabs"],
            { index: activeTab, onChange: onTabChange, className: tabs_default.a.headerOnlyTabs },
            allowedTabs.map(function (tab) {
              return react_default.a.createElement(react_toolbox_lib["Tab"], { key: tab.label, label: tab.label });
            })
          ),
          _this2.renderTabContent(activeTab, installer, helpers, crews)
        ) : react_default.a.createElement(components_Unauthorized, { restrictedItem: 'installer' })
      );
    }
  });
};

installerDetailsCard_InstallerDetails.propTypes = {
  activeTab: prop_types_default.a.number,
  role: prop_types_default.a.string,
  canEdit: prop_types_default.a.bool,
  onTabChange: prop_types_default.a.func,
  onSurfaceTypesChange: prop_types_default.a.func,
  installer: prop_types_default.a.object,
  helpers: prop_types_default.a.array,
  crews: prop_types_default.a.array,
  workrooms: prop_types_default.a.arrayOf(types_workroom),
  crewsWorkrooms: prop_types_default.a.object,
  crewsSurfaceTypes: prop_types_default.a.object,
  payRateUploadsData: prop_types_default.a.array,
  ptos: prop_types_default.a.arrayOf(types_pto),
  travelingWorkDates: prop_types_default.a.array, // travelingWorkDates PropType?
  user: RoleType,
  requestEmployee: prop_types_default.a.func,
  employee: prop_types_default.a.object,
  position: prop_types_default.a.string,
  mvw: prop_types_default.a.object
};

/* harmony default export */ var installerDetailsCard = (Object(react_redux_es["connect"])(function (state) {
  return {
    employee: Object(reducers["i" /* getEmployeeById */])(state)[state.user.employable_id],
    position: state.user.position,
    mvw: state.user.manage_vendor_workrooms || {}
  };
}, { requestEmployee: actionCreators["X" /* requestEmployee */] })(installerDetailsCard_InstallerDetails));
// CONCATENATED MODULE: ./client/app/screens/main/screens/installers/payRateUploads.jsx





/* harmony default export */ var installers_payRateUploads = (function (state) {
  var payRateUploads = Object(reducers["U" /* getPayRateUploadsListData */])(state);
  return payRateUploads.map(function (upload) {
    var upload_copy = {
      id: upload.id,
      active: upload.active,
      uploadName: react_default.a.createElement(
        'a',
        { href: upload.expiring_download_url },
        react_default.a.createElement(react_toolbox_lib["FontIcon"], { style: { verticalAlign: 'middle' }, value: 'insert_drive_file' })
      ),
      uploadedBy: upload.user.name,
      uploadedOn: Object(dateUtils["k" /* getLocalDate */])(upload.created_at),
      uploadedOnMobile: Object(dateUtils["l" /* getMinLocalDate */])(upload.created_at),
      statusText: upload.status,
      summary: upload.summary
    };
    if ('crew_id' in upload) upload_copy.crewId = upload.crew_id;
    return upload_copy;
  });
});
// CONCATENATED MODULE: ./client/app/screens/main/screens/installers/installerDetails.jsx
function installerDetails__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function installerDetails__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function installerDetails__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var installerDetails_InstallerDetails = function (_React$Component) {
  installerDetails__inherits(InstallerDetails, _React$Component);

  function InstallerDetails(props) {
    installerDetails__classCallCheck(this, InstallerDetails);

    var _this = installerDetails__possibleConstructorReturn(this, (InstallerDetails.__proto__ || Object.getPrototypeOf(InstallerDetails)).call(this, props));

    Object.defineProperty(_this, 'componentDidMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return Promise.all([_this.props.requestInstaller(_this.props.id), _this.props.requestInstallerPayRateUploads(_this.props.id), _this.props.requestPTOList(_this.props.id, 'installers'), _this.props.requestTravelingWorkDatesList(_this.props.id, 'installers')]);
      }
    });
    Object.defineProperty(_this, 'componentWillUnmount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.ui.successMessage ? _this.props.updateUI('successMessage', '') : null;
      }
    });
    Object.defineProperty(_this, 'handleTabChange', {
      enumerable: true,
      writable: true,
      value: function value(tabIndex) {
        return _this.props.updateUI('activeTab', tabIndex);
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            loading = _this$props.loading,
            installer = _this$props.installer,
            canEdit = _this$props.canEdit,
            helpers = _this$props.helpers,
            crews = _this$props.crews,
            crewsSurfaceTypes = _this$props.crewsSurfaceTypes,
            crewsWorkrooms = _this$props.crewsWorkrooms,
            ui = _this$props.ui,
            payRateUploadsData = _this$props.payRateUploadsData,
            ptos = _this$props.ptos,
            role = _this$props.role,
            user = _this$props.user,
            workrooms = _this$props.workrooms,
            travelingWorkDates = _this$props.travelingWorkDates;

        return react_default.a.createElement(
          'div',
          null,
          ui.successMessage ? react_default.a.createElement(MessageBox["a" /* default */], { message: ui.successMessage }) : null,
          loading ? react_default.a.createElement(components_Loading, null) : react_default.a.createElement(installerDetailsCard, {
            role: role,
            canEdit: canEdit,
            installer: installer,
            helpers: helpers,
            crews: crews,
            workrooms: workrooms,
            crewsWorkrooms: crewsWorkrooms,
            crewsSurfaceTypes: crewsSurfaceTypes,
            activeTab: ui.activeTab,
            onTabChange: _this.handleTabChange,
            payRateUploadsData: payRateUploadsData,
            ptos: ptos,
            travelingWorkDates: travelingWorkDates,
            user: user
          })
        );
      }
    });

    _this.handleTabChange = _this.handleTabChange.bind(_this);
    return _this;
  }

  return InstallerDetails;
}(react_default.a.Component);

installerDetails_InstallerDetails.propTypes = {
  id: prop_types_default.a.number,
  requestInstaller: prop_types_default.a.func,
  ui: prop_types_default.a.object,
  updateUI: prop_types_default.a.func,
  loading: prop_types_default.a.bool,
  installer: prop_types_default.a.object,
  role: prop_types_default.a.string,
  user: RoleType,
  canEdit: prop_types_default.a.bool,
  crews: prop_types_default.a.array,
  helpers: prop_types_default.a.array,
  workrooms: prop_types_default.a.arrayOf(types_workroom),
  crewsWorkrooms: prop_types_default.a.objectOf(prop_types_default.a.arrayOf(types_workroom)),
  crewsSurfaceTypes: prop_types_default.a.object,
  requestInstallerPayRateUploads: prop_types_default.a.func,
  requestPTOList: prop_types_default.a.func,
  requestTravelingWorkDatesList: prop_types_default.a.func,
  ptos: prop_types_default.a.arrayOf(types_pto),
  travelingWorkDates: prop_types_default.a.array,
  payRateUploadsData: prop_types_default.a.arrayOf(prop_types_default.a.shape({
    id: prop_types_default.a.oneOfType([prop_types_default.a.number, prop_types_default.a.string]),
    active: prop_types_default.a.bool,
    uploadName: prop_types_default.a.node,
    uploadedBy: prop_types_default.a.string,
    uploadedOn: prop_types_default.a.string,
    statusText: prop_types_default.a.string
  }))
};

var installerDetails_mapStateToProps = function mapStateToProps(state, ownProps) {
  var id = Number(ownProps.params.id);
  var installer = Object(reducers["B" /* getInstallerById */])(state)[id];
  var helpers = installer && installer.helpers ? installer.helpers.map(function (helperId) {
    return Object(reducers["x" /* getHelperById */])(state)(helperId);
  }) : [];
  var crews = installer && installer.crews ? installer.crews.map(function (crewId) {
    return Object(reducers["c" /* getCrewById */])(state)(crewId);
  }) : [];
  var crewsWorkrooms = {};
  var crewsSurfaceTypes = {};
  crews.forEach(function (crew) {
    crewsWorkrooms[crew.id] = crew.workrooms.map(function (wrId) {
      return Object(reducers["_33" /* getWorkroomById */])(state)(wrId);
    });
    crewsSurfaceTypes[crew.id] = crew.surface_types.map(function (stId) {
      return Object(reducers["_21" /* getSurfaceTypeById */])(state)(stId);
    });
  });
  var workrooms = Object(lodash["uniq"])(Object(lodash["flatMap"])(crewsWorkrooms));
  var role = Object(reducers["_12" /* getRole */])(state); // TODO: Obtain role from parent component
  return {
    id: id,
    installer: installer,
    helpers: helpers,
    crews: crews,
    crewsWorkrooms: crewsWorkrooms,
    crewsSurfaceTypes: crewsSurfaceTypes,
    workrooms: workrooms,
    role: role,
    canEdit: Object(services["a" /* can */])(role, 'update', 'installer') || Object(services["a" /* can */])(role, 'update_basic', 'installer'),
    loading: installer ? installer.loading : true,
    payRateUploadsData: installers_payRateUploads(state, id),
    ptos: state.ptos.data,
    travelingWorkDates: state.travelingWorkDates.data,
    user: state.user
  };
};

/* harmony default export */ var installerDetails = (transpiled_default()()(Object(react_redux_es["connect"])(installerDetails_mapStateToProps, {
  requestInstaller: actionCreators["_6" /* requestInstaller */], requestInstallerPayRateUploads: actionCreators["_9" /* requestInstallerPayRateUploads */], requestPTOList: actionCreators["_13" /* requestPTOList */], requestTravelingWorkDatesList: actionCreators["_28" /* requestTravelingWorkDatesList */]
})(installerDetails_InstallerDetails)));
// CONCATENATED MODULE: ./client/app/screens/main/screens/installers/installerEdit.jsx
var installerEdit__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var installerEdit__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function installerEdit__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function installerEdit__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function installerEdit__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function installerEdit__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var installerEdit_InstallerEdit = function (_Component) {
  installerEdit__inherits(InstallerEdit, _Component);

  function InstallerEdit(props) {
    installerEdit__classCallCheck(this, InstallerEdit);

    var _this = installerEdit__possibleConstructorReturn(this, (InstallerEdit.__proto__ || Object.getPrototypeOf(InstallerEdit)).call(this, props));

    Object.defineProperty(_this, 'componentDidMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return Promise.all([_this.props.requestInstaller(_this.props.id), _this.props.requestInstallerPayRateUploads(_this.props.id)]);
      }
    });
    Object.defineProperty(_this, 'componentWillUnmount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.clearValidationErrors('INSTALLER');
      }
    });
    Object.defineProperty(_this, 'createCrewDiff', {
      enumerable: true,
      writable: true,
      value: function value(crew, crewChanges) {
        var crewDiff = {};
        var changedVals = Object.keys(crewChanges[crew.id]);
        changedVals.forEach(function (val) {
          var oldVal = crew[val];
          var newVal = Object(lodash["get"])(crewChanges, [crew.id, val], 'null');
          if (!Object(lodash["isEqual"])(oldVal, newVal)) crewDiff[val] = [oldVal, newVal];
        });
        return crewDiff;
      }
    });
    Object.defineProperty(_this, 'createProfileDiff', {
      enumerable: true,
      writable: true,
      value: function value() {
        var crewChanges = _this.state.crewChanges;
        var crews = _this.props.crews;

        var profileDiff = {};
        var changedCrews = Object.keys(crewChanges).map(function (crew_id) {
          return parseInt(crew_id, 10);
        });
        crews.forEach(function (crew) {
          if (changedCrews.includes(crew.id)) {
            var crewDiff = _this.createCrewDiff(crew, crewChanges);
            if (!Object(lodash["isEmpty"])(crewDiff)) {
              profileDiff.crew = installerEdit__extends({}, profileDiff.crew, installerEdit__defineProperty({}, crew.name, {}));
              profileDiff.crew[crew.name] = crewDiff;
            }
          }
        });
        return profileDiff;
      }
    });
    Object.defineProperty(_this, 'handleSave', {
      enumerable: true,
      writable: true,
      value: function value(installer) {
        var profileDiff = {};
        var eventProps = {};
        if (!Object(lodash["isEmpty"])(_this.state.crewChanges)) {
          profileDiff = _this.createProfileDiff();
          eventProps = {
            name: 'Update Profile',
            kind: 'update_profile',
            data: { updates: profileDiff }
          };
        }
        return _this.props.updateInstaller(installer).then(function () {
          if (!Object(lodash["isEmpty"])(profileDiff)) _this.props.addEventToInstaller(installer.id, eventProps);
          _this.props.updateUI('successMessage', 'Changes have been saved');
        }).catch(function (e) {
          throw e;
        });
      }
    });
    Object.defineProperty(_this, 'handleTabChange', {
      enumerable: true,
      writable: true,
      value: function value(tabIndex) {
        return _this.props.updateUI('activeTab', tabIndex);
      }
    });
    Object.defineProperty(_this, 'handlePayRateUpload', {
      enumerable: true,
      writable: true,
      value: function value(formData) {
        return _this.props.uploadInstallerPayRate(_this.props.id, formData, _this.state.crewPayId === 'i' ? null : _this.state.crewPayId);
      }
    });
    Object.defineProperty(_this, 'handleCrewPayId', {
      enumerable: true,
      writable: true,
      value: function value(val) {
        return _this.setState({ crewPayId: val.value });
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            errors = _this$props.errors,
            installer = _this$props.installer,
            loading = _this$props.loading,
            helpers = _this$props.helpers,
            crews = _this$props.crews,
            allWorkrooms = _this$props.allWorkrooms,
            ui = _this$props.ui,
            uploadError = _this$props.uploadError,
            fileLoading = _this$props.fileLoading,
            showUploadDialog = _this$props.showUploadDialog,
            payRateUploadsData = _this$props.payRateUploadsData,
            role = _this$props.role,
            user = _this$props.user,
            workrooms = _this$props.workrooms;

        return loading ? react_default.a.createElement(components_Loading, null) : react_default.a.createElement(installerForm, {
          errors: errors,
          onSave: _this.handleSave,
          updateCrewChanges: _this.updateCrewChanges,
          onCancel: _this.handleCancel,
          onPayRateUpload: _this.handlePayRateUpload,
          handleCrewPayId: _this.handleCrewPayId,
          installer: installer,
          helpers: helpers,
          crewPayId: _this.state.crewPayId,
          crews: crews,
          allWorkrooms: allWorkrooms,
          workrooms: workrooms,
          activeTab: ui.activeTab,
          onTabChange: _this.handleTabChange,
          payRateUploadsData: payRateUploadsData,
          uploadError: uploadError,
          fileLoading: fileLoading,
          showUploadDialog: showUploadDialog,
          onUploadDialogToggle: _this.props.toggleInstallerPayRateUploadDialog,
          setUploadErrorMessage: _this.props.setPayRateUploadErrorMessage,
          role: role,
          user: user,
          installerFormType: 'Edit'
        });
      }
    });

    _this.state = { crewChanges: {}, crewPayId: null };
    _this.handleSave = _this.handleSave.bind(_this);
    _this.handleTabChange = _this.handleTabChange.bind(_this);
    _this.handlePayRateUpload = _this.handlePayRateUpload.bind(_this);
    _this.updateCrewChanges = _this.updateCrewChanges.bind(_this);
    _this.handleCancel = function () {
      _this.props.navigateBack();
    };
    _this.handleCrewPayId = _this.handleCrewPayId.bind(_this);
    return _this;
  }

  installerEdit__createClass(InstallerEdit, [{
    key: 'updateCrewChanges',
    value: function updateCrewChanges(key, value, nestedFieldId) {
      var newCrewChanges = Object.assign({}, this.state.crewChanges);
      newCrewChanges[nestedFieldId] = installerEdit__extends({}, newCrewChanges[nestedFieldId], installerEdit__defineProperty({}, key, value));
      this.setState({ crewChanges: newCrewChanges });
    }
  }]);

  return InstallerEdit;
}(react["Component"]);

installerEdit_InstallerEdit.propTypes = {
  id: prop_types_default.a.number,
  navigateBack: prop_types_default.a.func,
  requestInstaller: prop_types_default.a.func,
  requestWorkroomList: prop_types_default.a.func,
  clearValidationErrors: prop_types_default.a.func,
  updateInstaller: prop_types_default.a.func,
  addEventToInstaller: prop_types_default.a.func,
  updateUI: prop_types_default.a.func,
  errors: prop_types_default.a.object,
  installer: prop_types_default.a.object,
  loading: prop_types_default.a.bool,
  helpers: prop_types_default.a.array,
  crews: prop_types_default.a.array,
  workrooms: prop_types_default.a.arrayOf(types_workroom),
  allWorkrooms: prop_types_default.a.array,
  ui: prop_types_default.a.object,
  uploadError: prop_types_default.a.object,
  fileLoading: prop_types_default.a.bool,
  uploadInstallerPayRate: prop_types_default.a.func,
  toggleInstallerPayRateUploadDialog: prop_types_default.a.func,
  showUploadDialog: prop_types_default.a.bool,
  payRateUploadsData: prop_types_default.a.array,
  requestInstallerPayRateUploads: prop_types_default.a.func,
  setPayRateUploadErrorMessage: prop_types_default.a.func,
  role: prop_types_default.a.string.isRequired,
  user: RoleType
};

var installerEdit_mapStateToProps = function mapStateToProps(state, ownProps) {
  var id = Number(ownProps.params.id);
  var installer = Object(reducers["B" /* getInstallerById */])(state)[id];
  var allWorkrooms = Object(reducers["_37" /* getWorkroomList */])(state);
  var loading = installer === undefined || installer.loading || allWorkrooms === undefined || allWorkrooms.length === 0;
  var helpers = installer && installer.helpers ? installer.helpers.map(function (helperId) {
    return Object(reducers["x" /* getHelperById */])(state)(helperId);
  }) : [];
  var crews = installer && installer.crews ? installer.crews.map(function (crewId) {
    return Object(reducers["c" /* getCrewById */])(state)(crewId);
  }) : [];
  var crewsWorkrooms = {};
  crews.forEach(function (crew) {
    crewsWorkrooms[crew.id] = crew.workrooms.map(function (wrId) {
      return Object(reducers["_33" /* getWorkroomById */])(state)(wrId);
    });
  });
  var workrooms = Object(lodash["uniq"])(Object(lodash["flatMap"])(crewsWorkrooms));
  return {
    id: id,
    loading: loading,
    installer: installer,
    errors: Object(reducers["C" /* getInstallerErrors */])(state) || {},
    helpers: helpers,
    crews: crews,
    workrooms: workrooms,
    allWorkrooms: allWorkrooms,
    uploadError: Object(reducers["T" /* getPayRateUploadsError */])(state),
    fileLoading: Object(reducers["V" /* getPayRateUploadsLoading */])(state),
    showUploadDialog: Object(reducers["W" /* getPayRateUploadsShowDialog */])(state),
    payRateUploadsData: installers_payRateUploads(state, id),
    role: Object(reducers["_12" /* getRole */])(state),
    user: state.user
  };
};

/* harmony default export */ var installerEdit = (transpiled_default()()(Object(react_redux_es["connect"])(installerEdit_mapStateToProps, {
  navigateBack: actionCreators["P" /* navigateBack */],
  updateInstaller: actionCreators["_64" /* updateInstaller */],
  clearValidationErrors: actionCreators["k" /* clearValidationErrors */],
  requestInstaller: actionCreators["_6" /* requestInstaller */],
  uploadInstallerPayRate: actionCreators["_76" /* uploadInstallerPayRate */],
  toggleInstallerPayRateUploadDialog: actionCreators["_59" /* toggleInstallerPayRateUploadDialog */],
  requestInstallerPayRateUploads: actionCreators["_9" /* requestInstallerPayRateUploads */],
  setPayRateUploadErrorMessage: actionCreators["_50" /* setPayRateUploadErrorMessage */],
  addEventToInstaller: actionCreators["c" /* addEventToInstaller */]
})(installerEdit_InstallerEdit)));
// CONCATENATED MODULE: ./client/app/screens/main/screens/installers/index.jsx
var installers__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function installers__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function installers__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function installers__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var installers_Installers = function (_React$Component) {
  installers__inherits(Installers, _React$Component);

  function Installers(context, props) {
    installers__classCallCheck(this, Installers);

    var _this = installers__possibleConstructorReturn(this, (Installers.__proto__ || Object.getPrototypeOf(Installers)).call(this, context, props));

    Object.defineProperty(_this, 'componentDidMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.props.requestWorkroomList();
        _this.props.requestSurfaceTypesList();
      }
    });
    Object.defineProperty(_this, 'onSearch', {
      enumerable: true,
      writable: true,
      value: function value(e, _value) {
        e.preventDefault();
        var filters = installers__extends({}, _this.props.filters);
        filters.query = _value;
        _this.handleFilterChange(filters);
      }
    });
    Object.defineProperty(_this, 'addAction', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.navigate('/installers/new');
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var showFiltersDrawer = _this.isIndexRoute();
        var searchText = 'Search for an installer...';
        return react_default.a.createElement(
          'div',
          null,
          react_default.a.createElement(components_PageActionBar, {
            resource: 'installer',
            role: _this.props.role,
            hidesAddOnMobile: true,
            addAction: _this.addAction,
            showFiltersBtn: showFiltersDrawer,
            title: 'Installer Management',
            subTitle: '(Subcontractor)',
            searchText: searchText,
            toggleFilters: _this.toggleFilterDrawer,
            onSearch: _this.onSearch,
            path: _this.props.location.pathname
          }),
          react_default.a.createElement(
            'div',
            { className: contentArea_default.a.contentAreaContainer },
            _this.props.children,
            react_default.a.createElement(Filters_UserFilters, {
              active: _this.state.showFilterDrawer,
              onOverlayClick: _this.toggleFilterDrawer,
              handleFilterChange: _this.handleFilterChange,
              filters: _this.props.filters,
              title: 'Installers',
              reset: _this.props.resetInstallerFilters,
              role: _this.props.role,
              resource: 'installer'
            })
          )
        );
      }
    });

    _this.addAction = _this.addAction.bind(_this);
    _this.toggleFilterDrawer = function () {
      _this.setState({ showFilterDrawer: !_this.state.showFilterDrawer });
    };
    _this.handleFilterChange = function (filters) {
      return _this.props.setInstallerFilters(filters);
    };
    _this.state = { showFilterDrawer: false };
    _this.isIndexRoute = function () {
      return _this.props.location.pathname === _this.props.route.path;
    };
    return _this;
  }

  return Installers;
}(react_default.a.Component);

installers_Installers.propTypes = {
  role: prop_types_default.a.string,
  location: prop_types_default.a.object,
  route: prop_types_default.a.object,
  navigate: prop_types_default.a.func,
  setInstallerFilters: prop_types_default.a.func,
  resetInstallerFilters: prop_types_default.a.func,
  children: prop_types_default.a.oneOfType([prop_types_default.a.object, prop_types_default.a.array]),
  filters: prop_types_default.a.object,
  requestWorkroomList: prop_types_default.a.func,
  requestSurfaceTypesList: prop_types_default.a.func
};

var installers_mapStateToProps = function mapStateToProps(state) {
  return {
    role: Object(reducers["_12" /* getRole */])(state), filters: Object(reducers["D" /* getInstallerFilters */])(state)
  };
};

/* harmony default export */ var screens_installers = (transpiled_default()({ key: 'installers', state: { successMessage: '', activeTab: 0 } })(Object(react_redux_es["connect"])(installers_mapStateToProps, {
  navigate: actionCreators["O" /* navigate */],
  navigateBack: actionCreators["P" /* navigateBack */],
  setInstallerFilters: actionCreators["_49" /* setInstallerFilters */],
  resetInstallerFilters: actionCreators["_36" /* resetInstallerFilters */],
  requestWorkroomList: actionCreators["_31" /* requestWorkroomList */],
  requestSurfaceTypesList: actionCreators["_25" /* requestSurfaceTypesList */]
})(installers_Installers)));


// CONCATENATED MODULE: ./client/app/shared/types/task.js


var task_TaskType = prop_types_default.a.shape({
  slug: prop_types_default.a.string.isRequired,
  name: prop_types_default.a.string.isRequired,
  status: prop_types_default.a.string.isRequired
});

/* harmony default export */ var types_task = (task_TaskType);
// CONCATENATED MODULE: ./client/app/shared/types/purchaseOrder.js


/* harmony default export */ var purchaseOrder = ({
  id: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]),
  total: prop_types_default.a.number,
  kind: prop_types_default.a.string,
  number: prop_types_default.a.string,
  billable_document_id: prop_types_default.a.number,
  billable_document_name: prop_types_default.a.string,
  signed_document_id: prop_types_default.a.number,
  signed_document_name: prop_types_default.a.string,
  invoice_status: prop_types_default.a.string,
  invoice_number: prop_types_default.a.string,
  errors: prop_types_default.a.shape({
    total: prop_types_default.a.array,
    kind: prop_types_default.a.array,
    number: prop_types_default.a.array
  })
});

var purchaseOrderOptionsType = prop_types_default.a.arrayOf(prop_types_default.a.shape({
  label: prop_types_default.a.string,
  value: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number])
}));


// CONCATENATED MODULE: ./client/app/shared/types/phase.js
var phase__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var Phase = {
  id: prop_types_default.a.number,
  type: prop_types_default.a.string,
  due_at: prop_types_default.a.string,
  effective_due_at: prop_types_default.a.string,
  customer_name: prop_types_default.a.string,
  lrrp_required: prop_types_default.a.bool,
  project_number: prop_types_default.a.string,
  purchase_orders: prop_types_default.a.arrayOf(prop_types_default.a.shape(purchaseOrder)),
  status_name: prop_types_default.a.string,
  street_address: prop_types_default.a.string,
  city: prop_types_default.a.string,
  state: prop_types_default.a.string,
  zip_code: prop_types_default.a.string,
  store: types_store,
  surface_type: prop_types_default.a.shape({
    id: prop_types_default.a.number,
    name: prop_types_default.a.string
  }),
  flags: prop_types_default.a.arrayOf(types_flag),
  phone_numbers: prop_types_default.a.arrayOf(prop_types_default.a.shape({
    number: prop_types_default.a.string,
    kind: prop_types_default.a.string,
    reached: prop_types_default.a.bool,
    ok_to_text: prop_types_default.a.bool
  })),
  related_po: prop_types_default.a.string
};

var phase_PhaseDetails = phase__extends({}, Phase, {
  email: prop_types_default.a.string,
  mode_of_contact: prop_types_default.a.string,
  date_sold: prop_types_default.a.string,
  associate: prop_types_default.a.string,
  contractor_notes: prop_types_default.a.string,
  additional_comments: prop_types_default.a.string,
  surface_information: prop_types_default.a.object,
  created_at: prop_types_default.a.string,
  status: prop_types_default.a.string,
  available_statuses: prop_types_default.a.arrayOf(prop_types_default.a.shape({
    value: prop_types_default.a.string,
    label: prop_types_default.a.string
  })),
  estimator_id: prop_types_default.a.number,
  installer_id: prop_types_default.a.number,
  year_built: prop_types_default.a.number,
  sqft: prop_types_default.a.number,
  haul_away: prop_types_default.a.string,
  additional_work: prop_types_default.a.string,
  events: prop_types_default.a.arrayOf(types_event),
  current_tasks: prop_types_default.a.arrayOf(types_task),
  verified_assessment_document_id: prop_types_default.a.number,
  net_square_footage: prop_types_default.a.number,
  floor_wizard_job: prop_types_default.a.shape({
    id: prop_types_default.a.number,
    floor_wizard_project_id: prop_types_default.a.string
  })
});

var PhaseIndexType = prop_types_default.a.shape(Phase);
var PhaseDetailsType = prop_types_default.a.shape(phase_PhaseDetails);

/* harmony default export */ var types_phase = (PhaseDetailsType);


// EXTERNAL MODULE: ./node_modules/redux-actions/lib/index.js
var redux_actions_lib = __webpack_require__("QFmZ");
var redux_actions_lib_default = /*#__PURE__*/__webpack_require__.n(redux_actions_lib);

// CONCATENATED MODULE: ./client/app/shared/actionCreators/flags.js



var _createActions = Object(redux_actions_lib["createActions"])('FLAGS_RESOURCE_SUCCESS', 'FLAGS_RESOURCE_FAILURE', 'FLAGS_RESOURCE_REQUEST'),
    flagsResourceSuccess = _createActions.flagsResourceSuccess,
    flagsResourceFailure = _createActions.flagsResourceFailure,
    flagsResourceRequest = _createActions.flagsResourceRequest;

var flags_requestFlagOptions = function requestFlagOptions() {
  return function (dispatch) {
    dispatch(flagsResourceRequest());
    return Object(services["h" /* request */])('flags').then(function (_ref) {
      var json = _ref.json;
      return dispatch(flagsResourceSuccess(json));
    }).catch(function (error) {
      return dispatch(flagsResourceFailure(error));
    });
  };
};

/* harmony default export */ var actionCreators_flags = (flags_requestFlagOptions);
// CONCATENATED MODULE: ./client/app/shared/components/formElements/TaskSelect/index.jsx
var TaskSelect__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var TaskSelect__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function TaskSelect__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function TaskSelect__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function TaskSelect__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function TaskSelect__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint no-unused-vars: ["error", { "ignoreRestSiblings": true }] */











var TaskSelect_TaskSelect = function (_Component) {
  TaskSelect__inherits(TaskSelect, _Component);

  function TaskSelect() {
    TaskSelect__classCallCheck(this, TaskSelect);

    return TaskSelect__possibleConstructorReturn(this, (TaskSelect.__proto__ || Object.getPrototypeOf(TaskSelect)).apply(this, arguments));
  }

  TaskSelect__createClass(TaskSelect, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.props.loaded) {
        this.props.requestTaskList();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          loaded = _props.loaded,
          props = TaskSelect__objectWithoutProperties(_props, ['className', 'loaded']);

      return react_default.a.createElement(react_select, TaskSelect__extends({
        multi: true,
        resetValue: [],
        name: 'task',
        className: classnames_default()(ReactSelect_styles_default.a, className),
        label: 'Tasks',
        placeholder: 'All Tasks'
      }, props));
    }
  }]);

  return TaskSelect;
}(react["Component"]);

TaskSelect_TaskSelect.propTypes = {
  taskOptions: prop_types_default.a.arrayOf(prop_types_default.a.shape({
    label: prop_types_default.a.string,
    value: prop_types_default.a.number
  })),
  value: prop_types_default.a.arrayOf(prop_types_default.a.string),
  className: prop_types_default.a.string,
  loaded: prop_types_default.a.bool.isRequired,
  requestTaskList: prop_types_default.a.func.isRequired
};

var getTaskOptions = Object(reselect_lib["createSelector"])(reducers["_23" /* getTaskList */], function (tasks) {
  return tasks.map(function (task) {
    return { value: task.slug, label: task.phase_type + ' - ' + task.name };
  });
});

/* harmony default export */ var formElements_TaskSelect = (Object(react_redux_es["connect"])(function (state) {
  return { loaded: state.tasks.loaded, options: getTaskOptions(state) };
}, { requestTaskList: actionCreators["_27" /* requestTaskList */] })(TaskSelect_TaskSelect));
// CONCATENATED MODULE: ./client/app/shared/components/UserSearch/index.jsx
var UserSearch__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function UserSearch__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function UserSearch__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function UserSearch__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var UserSearch_UserSearch = function (_React$Component) {
  UserSearch__inherits(UserSearch, _React$Component);

  function UserSearch() {
    var _ref;

    var _temp, _this, _ret;

    UserSearch__classCallCheck(this, UserSearch);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = UserSearch__possibleConstructorReturn(this, (_ref = UserSearch.__proto__ || Object.getPrototypeOf(UserSearch)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'state', {
      enumerable: true,
      writable: true,
      value: { options: [], isLoading: false }
    }), Object.defineProperty(_this, 'componentWillMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return Object.keys(_this.props.initialValues).length > 0 ? _this.loadInitialValues() : null;
      }
    }), Object.defineProperty(_this, 'onChange', {
      enumerable: true,
      writable: true,
      value: function value(_value) {
        var options = _value ? _this.state.options : [];
        _this.setState({ value: _value, options: options });
        if (_this.props.onChange) _this.props.onChange(_value);
      }
    }), Object.defineProperty(_this, 'loadInitialValues', {
      enumerable: true,
      writable: true,
      value: function value() {
        if (Object(lodash["isArray"])(_this.props.initialValues)) {
          _this.setInitialState(_this.props.initialValues);
        } else {
          var filters = qs_lib_default.a.stringify(_this.props.initialValues);
          Object(services["h" /* request */])('users?' + filters).then(function (_ref2) {
            var json = _ref2.json;
            return _this.setInitialState(json.users);
          });
        }
      }
    }), Object.defineProperty(_this, 'setInitialState', {
      enumerable: true,
      writable: true,
      value: function value(users) {
        var value = _this.buildOptions(users);
        if (!_this.props.multi) value = value[0];
        _this.setState({ value: value });
      }
    }), Object.defineProperty(_this, 'searchUsers', {
      enumerable: true,
      writable: true,
      value: Object(lodash["debounce"])(function (value) {
        if (value.length <= 2) return;
        var employableType = _this.props.employableType;

        _this.setState({ isLoading: true });
        var queryObject = { query: value };
        if (employableType) {
          queryObject.employable_type = employableType;
        }
        var queryString = qs_lib_default.a.stringify(queryObject, { arrayFormat: 'brackets' });
        Object(services["h" /* request */])('users?' + queryString).then(function (_ref3) {
          var json = _ref3.json;
          return _this.handleSearchResults(json.users);
        }).catch(function (error) {
          return _this.handleSearchError(error);
        });
      }, 300)
    }), Object.defineProperty(_this, 'handleSearchResults', {
      enumerable: true,
      writable: true,
      value: function value(users) {
        var employableType = _this.props.employableType;

        var filteredUsers = employableType && employableType.length > 0 ? users.filter(function (user) {
          return employableType.includes(user.employable_type);
        }) : users;
        _this.setState({
          isLoading: false,
          options: _this.buildOptions(filteredUsers)
        });
      }
    }), Object.defineProperty(_this, 'handleSearchError', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ isLoading: false, options: [] });
      }
    }), Object.defineProperty(_this, 'buildOptions', {
      enumerable: true,
      writable: true,
      value: function value(users) {
        return users.map(function (user) {
          return UserSearch__extends({}, user, {
            value: user.name + ' - ' + user.employable_type,
            label: user.name + ' - ' + user.employable_type
          });
        });
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$state = _this.state,
            value = _this$state.value,
            options = _this$state.options,
            isLoading = _this$state.isLoading;
        var _this$props = _this.props,
            defaultOptions = _this$props.defaultOptions,
            placeholder = _this$props.placeholder;

        var otherProps = Object(lodash["omit"])(_this.props, ['employableType', 'value']);
        return react_default.a.createElement(
          react_responsive_default.a,
          { minWidth: constants["y" /* CUT_POINT */] },
          function (matches) {
            return matches ? react_default.a.createElement(react_select, UserSearch__extends({}, otherProps, {
              autoSize: false,
              options: defaultOptions.concat(options),
              value: value,
              onInputChange: _this.searchUsers,
              matchProp: 'label',
              placeholder: placeholder,
              noResultsText: 'Type to search',
              clearable: true,
              onChange: _this.onChange,
              isLoading: isLoading
            })) : react_default.a.createElement(react_select, UserSearch__extends({}, otherProps, {
              options: defaultOptions.concat(options),
              value: value,
              onInputChange: _this.searchUsers,
              matchProp: 'label',
              placeholder: placeholder,
              noResultsText: 'Type to search',
              clearable: true,
              onChange: _this.onChange,
              isLoading: isLoading
            }));
          }
        );
      }
    }), _temp), UserSearch__possibleConstructorReturn(_this, _ret);
  }

  return UserSearch;
}(react_default.a.Component);

UserSearch_UserSearch.defaultProps = {
  defaultOptions: [],
  multi: false,
  initialValues: {},
  isAssigneeSelect: false
};

UserSearch_UserSearch.propTypes = {
  employableType: prop_types_default.a.arrayOf(prop_types_default.a.oneOf(['Employee', 'Estimator', 'Installer', 'IQM'])),
  onChange: prop_types_default.a.func,
  placeholder: prop_types_default.a.string,
  defaultOptions: prop_types_default.a.array,
  initialValues: prop_types_default.a.oneOfType([prop_types_default.a.shape({
    estimator: prop_types_default.a.arrayOf(prop_types_default.a.number),
    employee: prop_types_default.a.arrayOf(prop_types_default.a.number),
    installer: prop_types_default.a.arrayOf(prop_types_default.a.number),
    iqm: prop_types_default.a.arrayOf(prop_types_default.a.number)
  }), prop_types_default.a.arrayOf(types_user)]),
  multi: prop_types_default.a.bool.isRequired
};

/* harmony default export */ var components_UserSearch = (UserSearch_UserSearch);
// EXTERNAL MODULE: ./client/app/screens/main/screens/phases/phaseList/components/phaseFilters.scss
var components_phaseFilters = __webpack_require__("KuO2");
var phaseFilters_default = /*#__PURE__*/__webpack_require__.n(components_phaseFilters);

// CONCATENATED MODULE: ./client/app/shared/types/filter.js


var FilterType = prop_types_default.a.shape({
  task: prop_types_default.a.arrayOf(prop_types_default.a.string),
  phase: prop_types_default.a.arrayOf(prop_types_default.a.shape({
    type: prop_types_default.a.string.isRequired,
    status: prop_types_default.a.string
  })),
  flag: prop_types_default.a.arrayOf(prop_types_default.a.shape({
    name: prop_types_default.a.string.isRequired,
    suboption: prop_types_default.a.string
  })),
  surface_type: prop_types_default.a.arrayOf(prop_types_default.a.number)
});

var PhaseFilterLocationType = prop_types_default.a.shape({
  workroom: prop_types_default.a.arrayOf(prop_types_default.a.number),
  store: prop_types_default.a.arrayOf(prop_types_default.a.number),
  region: prop_types_default.a.arrayOf(prop_types_default.a.number),
  surface_type: prop_types_default.a.arrayOf(prop_types_default.a.number),
  product_type: prop_types_default.a.oneOfType([prop_types_default.a.number, prop_types_default.a.string])
});

var CalendarFilterType = prop_types_default.a.shape({
  workroom: prop_types_default.a.arrayOf(prop_types_default.a.number),
  assignee_type: prop_types_default.a.arrayOf(prop_types_default.a.string),
  surface_type: prop_types_default.a.arrayOf(prop_types_default.a.number),
  estimator: prop_types_default.a.shape({
    zip_code: prop_types_default.a.string,
    estimator_id: prop_types_default.a.number
  })
}).isRequired;

/* harmony default export */ var types_filter = (FilterType);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseList/components/PhaseFilters.jsx
var PhaseFilters__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function PhaseFilters__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function PhaseFilters__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function PhaseFilters__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function PhaseFilters__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

























var PhaseFilters_theme = { RTInput: input_default.a };
var selectStyles = ReactSelect_styles_default.a.selectWrapper + ' ' + phaseFilters_default.a.selectWrapper;

var STATUS_OPTIONS = Object(lodash["flatten"])(Object.keys(window.SPOT.phase_statuses).map(function (type) {
  return [{ label: type + ' - All Statuses', value: type, type: type }].concat(window.SPOT.phase_statuses[type].map(function (status) {
    var labelStatus = status[0] === 'provider hold' ? 'Provider Hold' : status[0];
    return { label: type + ' - ' + labelStatus, value: type + status[1], type: type, status: status[1] };
  }));
}));

var PhaseFilters_PhaseFilters = function (_Component) {
  PhaseFilters__inherits(PhaseFilters, _Component);

  function PhaseFilters(props) {
    PhaseFilters__classCallCheck(this, PhaseFilters);

    var _this = PhaseFilters__possibleConstructorReturn(this, (PhaseFilters.__proto__ || Object.getPrototypeOf(PhaseFilters)).call(this, props));

    Object.defineProperty(_this, 'componentDidMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.requestFlagOptions();
      }
    });
    Object.defineProperty(_this, 'updateFilters', {
      enumerable: true,
      writable: true,
      value: function value(newFilters) {
        return _this.props.onFilterChange(newFilters);
      }
    });
    Object.defineProperty(_this, 'handleSelectChange', {
      enumerable: true,
      writable: true,
      value: function value(key, values) {
        return _this.updateFilters(PhaseFilters__extends({}, _this.props.filters, PhaseFilters__defineProperty({}, key, values.map(function (v) {
          return v.value;
        }))));
      }
    });
    Object.defineProperty(_this, 'handleEstimators', {
      enumerable: true,
      writable: true,
      value: function value(values) {
        return _this.updateFilters(PhaseFilters__extends({}, _this.props.filters, {
          estimator: values.map(function (v) {
            return v.employable_id;
          })
        }));
      }
    });
    Object.defineProperty(_this, 'handleFlag', {
      enumerable: true,
      writable: true,
      value: function value(values) {
        return _this.updateFilters(PhaseFilters__extends({}, _this.props.filters, {
          flag: values.map(function (v) {
            return { name: v.name, suboption: v.suboption };
          })
        }));
      }
    });
    Object.defineProperty(_this, 'handleStatus', {
      enumerable: true,
      writable: true,
      value: function value(values) {
        return _this.updateFilters(PhaseFilters__extends({}, _this.props.filters, {
          phase: values.map(function (v) {
            return { type: v.type, status: v.status };
          })
        }));
      }
    });
    Object.defineProperty(_this, 'handleCancel', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.onStopEdit();
      }
    });
    Object.defineProperty(_this, 'handleSave', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        e.preventDefault();
        var _this$props = _this.props,
            filters = _this$props.filters,
            onStopEdit = _this$props.onStopEdit,
            savedFilterName = _this$props.savedFilterName;

        _this.props.createSavedFilter({ name: savedFilterName, filters: filters }).then(function (newFilter) {
          return onStopEdit(newFilter.payload);
        }).catch(function () {});
      }
    });
    Object.defineProperty(_this, 'handleUpdate', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        e.preventDefault();
        var _this$props2 = _this.props,
            filters = _this$props2.filters,
            currentFilter = _this$props2.currentFilter,
            onStopEdit = _this$props2.onStopEdit,
            savedFilterName = _this$props2.savedFilterName;

        var filterParams = { filters: filters, name: savedFilterName };
        _this.props.updateSavedFilter(filterParams, currentFilter.id).then(function (newFilter) {
          return onStopEdit(newFilter.payload);
        }).catch(function () {});
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        return react_default.a.createElement(
          react_css_themr_lib["ThemeProvider"],
          { theme: PhaseFilters_theme },
          react_default.a.createElement(
            'div',
            { className: phaseFilters_default.a.content },
            _this.props.filterErrors && _this.props.filterErrors.filters && react_default.a.createElement(MessageBox["a" /* default */], { error: true, message: Object(utils["c" /* error */])('filters', _this.props.filterErrors) }),
            react_default.a.createElement(react_select, {
              multi: true,
              resetValue: [],
              name: 'status',
              className: selectStyles,
              options: STATUS_OPTIONS,
              value: (_this.props.filters.phase || []).map(function (s) {
                return '' + s.type + (s.status || '');
              }),
              onChange: _this.handleStatus,
              label: 'Status',
              placeholder: 'All Statuses'
            }),
            react_default.a.createElement(formElements_TaskSelect, {
              value: _this.props.filters.task,
              onChange: _this.handleTasks,
              className: phaseFilters_default.a.selectWrapper
            }),
            react_default.a.createElement(react_select, {
              multi: true,
              resetValue: [],
              name: 'flag',
              className: selectStyles,
              options: _this.props.flagOptions,
              value: (_this.props.filters.flag || []).map(function (flag) {
                return '' + flag.name + (flag.suboption || '');
              }),
              onChange: _this.handleFlag,
              label: 'Flags',
              placeholder: 'Any Flag'
            }),
            react_default.a.createElement(components_UserSearch, {
              label: 'Estimators',
              multi: true,
              employableType: ['Estimator'],
              initialValues: Object(lodash["pick"])(_this.props.filters, ['estimator']),
              onChange: _this.handleEstimators,
              className: phaseFilters_default.a.selectWrapper
            }),
            react_default.a.createElement(
              'form',
              {
                onSubmit: !_this.props.currentFilter ? _this.handleSave : _this.handleUpdate,
                className: form_default.a.sidebarForm
              },
              react_default.a.createElement(react_toolbox_lib["Input"], {
                label: 'Filter Name',
                className: form_default.a.sidebarInput,
                theme: form_default.a,
                onChange: _this.props.handleFilterName,
                value: _this.props.savedFilterName,
                error: Object(utils["c" /* error */])('name', _this.props.filterErrors)
              }),
              react_default.a.createElement(ColoredButton["a" /* default */], {
                className: form_default.a.sidebarButton,
                responsive: true,
                color: 'blue',
                label: !_this.props.currentFilter ? 'Save Filter' : 'Update Filter',
                type: 'submit'
              }),
              react_default.a.createElement(ColoredButton["a" /* default */], {
                className: form_default.a.sidebarButton,
                responsive: true,
                color: 'gray',
                label: 'Cancel',
                onClick: _this.handleCancel
              })
            ),
            react_default.a.createElement(
              'a',
              { className: phaseFilters_default.a.filtersHelpLink, href: urls.filtersHelp(), target: '_blank', rel: 'noopener noreferrer' },
              'Need help setting up your filters?'
            )
          )
        );
      }
    });

    _this.handleTasks = _this.handleSelectChange.bind(_this, 'task');
    return _this;
  }

  return PhaseFilters;
}(react["Component"]);

var SelectOptionType = prop_types_default.a.shape({
  label: prop_types_default.a.string,
  value: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]).isRequired
});

PhaseFilters_PhaseFilters.propTypes = {
  filters: types_filter.isRequired,
  filterErrors: prop_types_default.a.object,
  currentFilter: types_filter,
  flagOptions: prop_types_default.a.arrayOf(SelectOptionType),
  requestFlagOptions: prop_types_default.a.func.isRequired,
  onFilterChange: prop_types_default.a.func.isRequired,
  createSavedFilter: prop_types_default.a.func.isRequired,
  updateSavedFilter: prop_types_default.a.func.isRequired,
  onStopEdit: prop_types_default.a.func.isRequired,
  savedFilterName: prop_types_default.a.string.isRequired,
  handleFilterName: prop_types_default.a.func.isRequired
};

PhaseFilters_PhaseFilters.defaultProps = {
  filters: { workroom: [], task: [], store: [], status: [], flag: [] }, flagOptions: []
};

var getFlagOptionsWithSuboptions = Object(reselect_lib["createSelector"])(reducers["w" /* getFlagOptions */], function (flags) {
  return flags.map(function (flag) {
    if (!flag.suboptions.length) return [{ label: flag.name, value: flag.name, name: flag.name }];
    return [{ label: flag.name + ' - All', value: flag.name, name: flag.name }].concat(flag.suboptions.map(function (option) {
      return { label: flag.name + ' - ' + option,
        value: '' + flag.name + option,
        name: flag.name,
        suboption: option
      };
    }));
  }).reduce(function (a, b) {
    return a.concat(b);
  }, []);
});

var PhaseFilters_mapStateToProps = function mapStateToProps(state) {
  return {
    filterErrors: state.savedFilters.errors, flagOptions: getFlagOptionsWithSuboptions(state)
  };
};

/* harmony default export */ var components_PhaseFilters = (Object(react_redux_es["connect"])(PhaseFilters_mapStateToProps, {
  resetPhasePagination: actionCreators["_38" /* resetPhasePagination */], requestFlagOptions: actionCreators_flags, createSavedFilter: actionCreators["t" /* createSavedFilter */], updateSavedFilter: actionCreators["_68" /* updateSavedFilter */], replace: react_router_redux_lib["replace"]
})(PhaseFilters_PhaseFilters));
// EXTERNAL MODULE: ./node_modules/react-confirm/lib/index.js
var react_confirm_lib = __webpack_require__("sfvs");
var react_confirm_lib_default = /*#__PURE__*/__webpack_require__.n(react_confirm_lib);

// EXTERNAL MODULE: ./client/app/shared/styles/exportModalInput.scss
var exportModalInput = __webpack_require__("nSBd");
var exportModalInput_default = /*#__PURE__*/__webpack_require__.n(exportModalInput);

// CONCATENATED MODULE: ./client/app/shared/components/ConfirmDialog/export.jsx
var export__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function export__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function export__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function export__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function export__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var export_cancelClass = classnames_default()([form_default.a.cancelButton, form_default.a.actionButton]);
var cardActionsClass = classnames_default()([form_default.a.actionsWrapper, form_default.a.rightDown]);
var inputClass = classnames_default()([form_default.a.inputArea, exportModalInput_default.a.export]);

var export_ExportDialog = function (_React$Component) {
  export__inherits(ExportDialog, _React$Component);

  function ExportDialog() {
    export__classCallCheck(this, ExportDialog);

    return export__possibleConstructorReturn(this, (ExportDialog.__proto__ || Object.getPrototypeOf(ExportDialog)).apply(this, arguments));
  }

  export__createClass(ExportDialog, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          show = _props.show,
          proceed = _props.proceed,
          dismiss = _props.dismiss,
          cancel = _props.cancel,
          confirmation = _props.confirmation,
          error = _props.error,
          options = export__objectWithoutProperties(_props, ['show', 'proceed', 'dismiss', 'cancel', 'confirmation', 'error']);

      var title = options.title,
          theActions = options.theActions;

      var actions = theActions || ['Cancel', 'OK'];

      return react_default.a.createElement(
        react_toolbox_lib["Dialog"],
        {
          active: show,
          onEscKeyDown: dismiss,
          onOverlayClick: dismiss,
          title: title || 'Export confirmation'
        },
        confirmation,
        react_default.a.createElement(
          'div',
          { className: inputClass },
          react_default.a.createElement('input', { type: 'text', ref: function ref(el) {
              return _this2.pageInput = el;
            }, placeholder: 'Default: Page 1' }),
          react_default.a.createElement('span', { className: 'highlight' }),
          react_default.a.createElement('span', { className: 'bar' })
        ),
        error && react_default.a.createElement(MessageBox["a" /* default */], { message: error, error: true }),
        react_default.a.createElement(
          react_toolbox_lib["CardActions"],
          { className: cardActionsClass },
          actions.indexOf('Cancel') > -1 ? react_default.a.createElement(ColoredButton["a" /* default */], {
            className: export_cancelClass,
            responsive: true,
            color: 'gray',
            label: options.cancelLabel || 'Cancel',
            onClick: cancel
          }) : null,
          actions.indexOf('OK') > -1 ? react_default.a.createElement(ColoredButton["a" /* default */], {
            className: form_default.a.actionButton,
            responsive: true,
            color: 'green',
            label: options.okLabel || 'OK',
            onClick: function onClick() {
              proceed(_this2.pageInput.value);
            }
          }) : null
        )
      );
    }
  }]);

  return ExportDialog;
}(react_default.a.Component);

export_ExportDialog.propTypes = {
  show: prop_types_default.a.bool,
  proceed: prop_types_default.a.func,
  dismiss: prop_types_default.a.func,
  cancel: prop_types_default.a.func,
  confirmation: prop_types_default.a.node,
  error: prop_types_default.a.string
};

/* harmony default export */ var ConfirmDialog_export = (Object(react_confirm_lib["confirmable"])(export_ExportDialog));
// EXTERNAL MODULE: ./node_modules/react-data-export/dist/index.js
var react_data_export_dist = __webpack_require__("20dQ");
var react_data_export_dist_default = /*#__PURE__*/__webpack_require__.n(react_data_export_dist);

// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseList/components/PhaseExcelSheet.jsx
function PhaseExcelSheet__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function PhaseExcelSheet__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function PhaseExcelSheet__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var DEFAULT = 'N/A';
var ExcelFile = react_data_export_dist_default.a.ExcelFile;
var ExcelSheet = react_data_export_dist_default.a.ExcelFile.ExcelSheet;
var ExcelColumn = react_data_export_dist_default.a.ExcelFile.ExcelColumn;

var PhaseExcelSheet_PhaseExcelSheet = function (_React$Component) {
  PhaseExcelSheet__inherits(PhaseExcelSheet, _React$Component);

  function PhaseExcelSheet() {
    var _ref;

    var _temp, _this, _ret;

    PhaseExcelSheet__classCallCheck(this, PhaseExcelSheet);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = PhaseExcelSheet__possibleConstructorReturn(this, (_ref = PhaseExcelSheet.__proto__ || Object.getPrototypeOf(PhaseExcelSheet)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'componentDidMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.Interval = setInterval(_this.props.unmountExcelSheet.bind(_this), 2500);
      }
    }), Object.defineProperty(_this, 'componentWillUnMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return clearInterval(_this.Interval);
      }
    }), Object.defineProperty(_this, 'buildExcelSheet', {
      enumerable: true,
      writable: true,
      value: function value(data, name) {
        var verifiedData = data && data.length ? data : [{ results: 'No Data Available' }];
        var allKeys = Array.from(new Set(data.flatMap(function (obj) {
          return Object.keys(obj);
        })));
        return react_default.a.createElement(
          ExcelFile,
          { hideElement: true },
          react_default.a.createElement(
            ExcelSheet,
            { data: verifiedData, name: name },
            allKeys.map(function (key) {
              return react_default.a.createElement(ExcelColumn, { key: key, label: Object(utils["B" /* titleize */])(key), value: key });
            })
          )
        );
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var simplifiedPhases = _this.props.phases.map(function (phase) {
          var _ref2 = phase || {},
              _ref2$customer_name = _ref2.customer_name,
              customerName = _ref2$customer_name === undefined ? '' : _ref2$customer_name,
              _ref2$created_at = _ref2.created_at,
              createdOn = _ref2$created_at === undefined ? '' : _ref2$created_at,
              _ref2$source = _ref2.source,
              source = _ref2$source === undefined ? '' : _ref2$source,
              _ref2$phone_numbers = _ref2.phone_numbers,
              phone_numbers = _ref2$phone_numbers === undefined ? [] : _ref2$phone_numbers,
              _ref2$email = _ref2.email,
              email = _ref2$email === undefined ? '' : _ref2$email,
              _ref2$project_number = _ref2.project_number,
              projectNumber = _ref2$project_number === undefined ? '' : _ref2$project_number,
              _ref2$type = _ref2.type,
              phaseType = _ref2$type === undefined ? '' : _ref2$type,
              _ref2$surface_name = _ref2.surface_name,
              surfaceType = _ref2$surface_name === undefined ? '' : _ref2$surface_name,
              _ref2$product_type = _ref2.product_type,
              productType = _ref2$product_type === undefined ? '' : _ref2$product_type,
              sqft = _ref2.sqft,
              _ref2$due_at = _ref2.due_at,
              dueDate = _ref2$due_at === undefined ? '' : _ref2$due_at,
              _ref2$status_name = _ref2.status_name,
              status_name = _ref2$status_name === undefined ? '' : _ref2$status_name,
              _ref2$last_assignee = _ref2.last_assignee,
              assignedTo = _ref2$last_assignee === undefined ? '' : _ref2$last_assignee,
              _ref2$last_appt_start = _ref2.last_appt_start,
              appointmentStartDate = _ref2$last_appt_start === undefined ? '' : _ref2$last_appt_start,
              _ref2$flags = _ref2.flags,
              phaseFlags = _ref2$flags === undefined ? [] : _ref2$flags,
              _ref2$last_event_time = _ref2.last_event_time,
              lastEventTime = _ref2$last_event_time === undefined ? '' : _ref2$last_event_time,
              _ref2$last_event_deta = _ref2.last_event_details,
              lastEventDetails = _ref2$last_event_deta === undefined ? '' : _ref2$last_event_deta,
              _ref2$recent_note = _ref2.recent_note,
              latestNote = _ref2$recent_note === undefined ? '' : _ref2$recent_note,
              _ref2$contractor_note = _ref2.contractor_notes,
              contractor_notes = _ref2$contractor_note === undefined ? '' : _ref2$contractor_note,
              _ref2$store_number = _ref2.store_number,
              storeNumber = _ref2$store_number === undefined ? '' : _ref2$store_number,
              _ref2$workroom_name = _ref2.workroom_name,
              workroom = _ref2$workroom_name === undefined ? '' : _ref2$workroom_name;

          var phoneNumber = (phone_numbers || [])[0] && phone_numbers[0].number || '';
          var address = Object(utils["i" /* fullAddress */])(phase);
          var mot = Object(dateUtils["f" /* getDaysStringFromDuration */])(Object(dateUtils["i" /* getDuration */])(phase));
          var status = Object(utils["b" /* deriveStatusName */])(status_name, { source: source, workroom: workroom });
          var contractorNotes = contractor_notes ? contractor_notes.replace(/\n\s*\n/g, ' | ') : contractor_notes;
          var flags = (phaseFlags || []).length ? phaseFlags.filter(function (f) {
            return f.name || false;
          }).map(function (f) {
            return f.name;
          }).join(', ') : '';
          return Object(utils["w" /* replaceFalsyObjVals */])({
            customerName: customerName,
            createdOn: createdOn,
            source: source,
            phoneNumber: phoneNumber,
            address: address,
            email: email,
            projectNumber: projectNumber,
            phaseType: phaseType,
            surfaceType: surfaceType,
            productType: productType,
            sqft: sqft,
            dueDate: dueDate,
            mot: mot,
            status: status,
            assignedTo: assignedTo,
            appointmentStartDate: appointmentStartDate,
            flags: flags,
            lastEventDetails: lastEventDetails,
            lastEventTime: lastEventTime,
            latestNote: latestNote,
            contractorNotes: contractorNotes,
            workroom: workroom,
            storeNumber: storeNumber
          }, DEFAULT);
        }) || [];
        return _this.buildExcelSheet(simplifiedPhases, 'Phase List');
      }
    }), _temp), PhaseExcelSheet__possibleConstructorReturn(_this, _ret);
  }

  return PhaseExcelSheet;
}(react_default.a.Component);

PhaseExcelSheet_PhaseExcelSheet.propTypes = { phases: prop_types_default.a.array, unmountExcelSheet: prop_types_default.a.func };

/* harmony default export */ var components_PhaseExcelSheet = (PhaseExcelSheet_PhaseExcelSheet);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseList/components/PhaseListHeader.jsx








// import { render } from 'react-dom';

var PhaseListHeader_PhaseListHeader = function PhaseListHeader(props) {
  var currentFilter = props.currentFilter,
      editFilter = props.editFilter,
      title = props.title,
      deleteFilter = props.deleteFilter,
      showConfirm = props.showConfirm,
      copyFilter = props.copyFilter,
      toggleModal = props.toggleModal,
      modalNumber = props.modalNumber,
      renderExcel = props.renderExcel,
      onProceed = props.onProceed,
      unmountExcelSheet = props.unmountExcelSheet,
      loading = props.loading,
      totalCount = props.totalCount,
      phases = props.phases;


  var formattedTitle = title + (!loading ? ' (' + totalCount + ')' : '');
  var modal = void 0;
  if (modalNumber === 1) {
    modal = react_default.a.createElement(ConfirmDialog["a" /* default */], {
      title: 'Are you sure you want to delete\n                      ' + (currentFilter && currentFilter.name ? currentFilter.name : 'this') + '\n                  filter?',
      okLabel: 'Delete Filter',
      cancelLabel: 'Cancel',
      show: showConfirm,
      dismiss: function dismiss() {},
      cancel: function cancel() {
        return toggleModal(1);
      },
      proceed: deleteFilter
    });
  } else if (modalNumber === 2) {
    modal = react_default.a.createElement(ConfirmDialog_export, {
      title: 'What page would you like to export (per 1000 entries)?',
      okLabel: 'Export',
      cancelLabel: 'Cancel',
      show: showConfirm,
      dismiss: function dismiss() {},
      cancel: function cancel() {
        return toggleModal(2);
      },
      proceed: onProceed
    });
  } else {
    modal = null;
  }

  return react_default.a.createElement(
    'div',
    null,
    react_default.a.createElement(Helmet_default.a, { title: formattedTitle }),
    react_default.a.createElement(
      'h2',
      { className: contentArea_default.a.contentAreaTitle },
      formattedTitle,
      currentFilter && react_default.a.createElement(
        'div',
        { className: contentArea_default.a.titleActions },
        renderExcel ? react_default.a.createElement(components_PhaseExcelSheet, { phases: phases, unmountExcelSheet: unmountExcelSheet }) : null,
        react_default.a.createElement(
          'button',
          { onClick: function onClick() {
              return toggleModal(2);
            }, className: contentArea_default.a.titleAction },
          react_default.a.createElement(react_toolbox_lib["FontIcon"], { value: 'get_app' })
        ),
        deleteFilter && react_default.a.createElement(
          'button',
          { onClick: function onClick() {
              return toggleModal(1);
            }, className: contentArea_default.a.titleAction },
          react_default.a.createElement(react_toolbox_lib["FontIcon"], { value: 'delete' })
        ),
        copyFilter && react_default.a.createElement(
          'button',
          { onClick: copyFilter, className: contentArea_default.a.titleAction },
          react_default.a.createElement(react_toolbox_lib["FontIcon"], { value: 'content_copy' })
        ),
        editFilter && react_default.a.createElement(
          'button',
          { onClick: editFilter, className: contentArea_default.a.titleAction },
          react_default.a.createElement(react_toolbox_lib["FontIcon"], { value: 'mode_edit' })
        )
      ),
      modal
    )
  );
};

PhaseListHeader_PhaseListHeader.propTypes = {
  editFilter: prop_types_default.a.func,
  copyFilter: prop_types_default.a.func,
  deleteFilter: prop_types_default.a.func,
  toggleModal: prop_types_default.a.func,
  modalNumber: prop_types_default.a.number,
  renderExcel: prop_types_default.a.bool.isRequired,
  onProceed: prop_types_default.a.func,
  unmountExcelSheet: prop_types_default.a.func,
  currentFilter: prop_types_default.a.object,
  showConfirm: prop_types_default.a.bool.isRequired,
  title: prop_types_default.a.string.isRequired,
  loading: prop_types_default.a.bool.isRequired,
  totalCount: prop_types_default.a.number,
  phases: prop_types_default.a.array.isRequired
};

/* harmony default export */ var components_PhaseListHeader = (PhaseListHeader_PhaseListHeader);
// EXTERNAL MODULE: ./node_modules/react-dnd/lib/index.js
var react_dnd_lib = __webpack_require__("EyLK");
var react_dnd_lib_default = /*#__PURE__*/__webpack_require__.n(react_dnd_lib);

// EXTERNAL MODULE: ./node_modules/react-dnd-html5-backend/lib/index.js
var react_dnd_html5_backend_lib = __webpack_require__("5NWm");
var react_dnd_html5_backend_lib_default = /*#__PURE__*/__webpack_require__.n(react_dnd_html5_backend_lib);

// EXTERNAL MODULE: ./client/app/screens/main/screens/phases/phaseList/components/savedFilters.scss
var components_savedFilters = __webpack_require__("Bypn");
var savedFilters_default = /*#__PURE__*/__webpack_require__.n(components_savedFilters);

// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseList/components/savedFilterItem.jsx
var savedFilterItem__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function savedFilterItem__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function savedFilterItem__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function savedFilterItem__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function savedFilterItem__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint "no-param-reassign": "off" */










var savedFilterItem_SavedFilterItem = function (_React$Component) {
  savedFilterItem__inherits(SavedFilterItem, _React$Component);

  function SavedFilterItem() {
    savedFilterItem__classCallCheck(this, SavedFilterItem);

    return savedFilterItem__possibleConstructorReturn(this, (SavedFilterItem.__proto__ || Object.getPrototypeOf(SavedFilterItem)).apply(this, arguments));
  }

  savedFilterItem__createClass(SavedFilterItem, [{
    key: 'render',
    value: function render() {
      var _this2 = this,
          _cx;

      var _props = this.props,
          item = _props.item,
          selected = _props.selected,
          onFilterSelect = _props.onFilterSelect,
          isDragging = _props.isDragging,
          connectDropTarget = _props.connectDropTarget,
          connectDragPreview = _props.connectDragPreview,
          connectDragSource = _props.connectDragSource;

      return connectDragPreview(connectDropTarget(connectDragSource(react_default.a.createElement(
        'li',
        {
          ref: function ref(li) {
            _this2.element = li;
          },
          className: classnames_default()(savedFilters_default.a.filter, (_cx = {}, savedFilterItem__defineProperty(_cx, savedFilters_default.a.selected, selected), savedFilterItem__defineProperty(_cx, savedFilters_default.a.beingDragged, isDragging), savedFilterItem__defineProperty(_cx, savedFilters_default.a.overdue, item.overdue), _cx))
        },
        react_default.a.createElement(
          'span',
          { className: savedFilters_default.a.dragHandle },
          react_default.a.createElement(react_toolbox_lib["FontIcon"], { value: 'drag_handle' })
        ),
        react_default.a.createElement(
          es["c" /* Link */],
          {
            to: urls.phases({ query: item.filters }),
            onClick: onFilterSelect
          },
          react_default.a.createElement(
            'span',
            { className: savedFilters_default.a.name },
            item.name
          ),
          react_default.a.createElement(
            'span',
            { className: savedFilters_default.a.count },
            item.overdue_count,
            '/',
            item.count
          )
        )
      ))));
    }
  }]);

  return SavedFilterItem;
}(react_default.a.Component);

savedFilterItem_SavedFilterItem.propTypes = {
  item: prop_types_default.a.shape({
    name: prop_types_default.a.string.isRequired,
    filters: prop_types_default.a.object,
    count: prop_types_default.a.number.isRequired,
    overdue_count: prop_types_default.a.number,
    overdue: prop_types_default.a.bool.isRequired,
    id: prop_types_default.a.number.isRequired
  }).isRequired,
  index: prop_types_default.a.number.isRequired,
  selected: prop_types_default.a.bool,
  onFilterSelect: prop_types_default.a.func.isRequired,
  beginDrag: prop_types_default.a.func.isRequired,
  endDrag: prop_types_default.a.func.isRequired,
  isDragging: prop_types_default.a.bool.isRequired,
  connectDropTarget: prop_types_default.a.func.isRequired,
  connectDragSource: prop_types_default.a.func.isRequired,
  connectDragPreview: prop_types_default.a.func.isRequired
};

var cardTarget = {

  hover: function hover(props, monitor, component) {
    var dragIndex = monitor.getItem().index;
    var hoverIndex = props.index;

    // Don't replace items with themselves
    if (dragIndex === hoverIndex) {
      return;
    }

    // Determine rectangle on screen
    var hoverBoundingRect = component.getDecoratedComponentInstance().element.getBoundingClientRect();

    // Get vertical middle
    var hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

    // Determine mouse position
    var clientOffset = monitor.getClientOffset();

    // Get pixels to the top
    var hoverClientY = clientOffset.y - hoverBoundingRect.top;

    // Only perform the move when the mouse has crossed half of the items height
    // When dragging downwards, only move when the cursor is below 50%
    // When dragging upwards, only move when the cursor is above 50%

    // Dragging downwards
    if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
      return;
    }

    // Dragging upwards
    if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
      return;
    }

    // Time to actually perform the action
    props.move(dragIndex, hoverIndex);

    // Note: we're mutating the monitor item here!
    // Generally it's better to avoid mutations,
    // but it's good here for the sake of performance
    // to avoid expensive index searches.
    monitor.getItem().index = hoverIndex;
  },

  drop: function drop(_ref) {
    var index = _ref.index,
        item = _ref.item,
        endDrag = _ref.endDrag;

    endDrag(item, index);
  }
};

var dragSource = {
  beginDrag: function beginDrag(_ref2) {
    var item = _ref2.item,
        index = _ref2.index,
        _beginDrag = _ref2.beginDrag;

    _beginDrag(item);
    return { index: index, item: item };
  }
};

/**
 * Specifies the props to inject into your component.
 */
function connectDrag(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging()
  };
}

var connectDrop = function connectDrop(connect) {
  return {
    connectDropTarget: connect.dropTarget()
  };
};

/* harmony default export */ var savedFilterItem = (Object(react_dnd_lib["DropTarget"])('SavedFilter', cardTarget, connectDrop)(Object(react_dnd_lib["DragSource"])('SavedFilter', dragSource, connectDrag)(savedFilterItem_SavedFilterItem)));
// EXTERNAL MODULE: ./client/app/screens/main/screens/phases/phaseList/components/assignedFilters.scss
var components_assignedFilters = __webpack_require__("NldF");
var assignedFilters_default = /*#__PURE__*/__webpack_require__.n(components_assignedFilters);

// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseList/components/assignedFilterItem.jsx
function assignedFilterItem__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function assignedFilterItem__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function assignedFilterItem__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function assignedFilterItem__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint "no-param-reassign": "off" */









var assignedFilterItem_AssignedFilterItem = function (_React$Component) {
  assignedFilterItem__inherits(AssignedFilterItem, _React$Component);

  function AssignedFilterItem() {
    var _ref;

    var _temp, _this, _ret;

    assignedFilterItem__classCallCheck(this, AssignedFilterItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = assignedFilterItem__possibleConstructorReturn(this, (_ref = AssignedFilterItem.__proto__ || Object.getPrototypeOf(AssignedFilterItem)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'componentWillMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.requestFilterCount(_this.props.item.id);
      }
    }), Object.defineProperty(_this, 'componentWillReceiveProps', {
      enumerable: true,
      writable: true,
      value: function value(nextProps) {
        var newRerun = nextProps.rerun;
        var _this$props = _this.props,
            rerun = _this$props.rerun,
            id = _this$props.item.id;

        if (newRerun && newRerun !== rerun) _this.props.requestFilterCount(id);
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _cx;

        var _this$props2 = _this.props,
            item = _this$props2.item,
            selected = _this$props2.selected,
            onFilterSelect = _this$props2.onFilterSelect,
            filterCounts = _this$props2.filterCounts;

        return react_default.a.createElement(
          'li',
          {
            ref: function ref(li) {
              _this.element = li;
            },
            className: classnames_default()(assignedFilters_default.a.filter, (_cx = {}, assignedFilterItem__defineProperty(_cx, assignedFilters_default.a.selected, selected), assignedFilterItem__defineProperty(_cx, assignedFilters_default.a.overdue, filterCounts.overdue), _cx))
          },
          react_default.a.createElement(
            es["c" /* Link */],
            {
              to: urls.phases({ query: item.filters }),
              onClick: onFilterSelect
            },
            react_default.a.createElement(
              'span',
              { className: assignedFilters_default.a.name },
              item.name
            ),
            react_default.a.createElement(
              'span',
              { className: assignedFilters_default.a.count },
              filterCounts.id ? filterCounts.overdue_count + '/' + filterCounts.count : 'Loading...'
            )
          )
        );
      }
    }), _temp), assignedFilterItem__possibleConstructorReturn(_this, _ret);
  }

  return AssignedFilterItem;
}(react_default.a.Component);

assignedFilterItem_AssignedFilterItem.propTypes = {
  item: prop_types_default.a.shape({
    name: prop_types_default.a.string.isRequired,
    filters: prop_types_default.a.object,
    id: prop_types_default.a.number.isRequired
  }).isRequired,
  rerun: prop_types_default.a.bool,
  filterCounts: prop_types_default.a.object,
  index: prop_types_default.a.number.isRequired,
  selected: prop_types_default.a.bool,
  onFilterSelect: prop_types_default.a.func.isRequired,
  requestFilterCount: prop_types_default.a.func.isRequired
};

var assignedFilterItem_mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    rerun: state.assignedFilters.loading,
    filterCounts: state.assignedFilters['filter' + ownProps.item.id + 'PhaseCounts'] || {
      id: null, count: 0, overdue_count: 0, overdue: false
    }
  };
};

/* harmony default export */ var assignedFilterItem = (Object(react_redux_es["connect"])(assignedFilterItem_mapStateToProps, { requestFilterCount: actionCreators["_2" /* requestFilterCount */] })(assignedFilterItem_AssignedFilterItem));
// CONCATENATED MODULE: ./client/app/shared/components/formElements/StoreSelect/index.jsx
var StoreSelect__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var StoreSelect__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function StoreSelect__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function StoreSelect__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function StoreSelect__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function StoreSelect__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint no-unused-vars: ["error", { "ignoreRestSiblings": true }] */











var StoreSelect_StoreSelect = function (_Component) {
  StoreSelect__inherits(StoreSelect, _Component);

  function StoreSelect() {
    StoreSelect__classCallCheck(this, StoreSelect);

    return StoreSelect__possibleConstructorReturn(this, (StoreSelect.__proto__ || Object.getPrototypeOf(StoreSelect)).apply(this, arguments));
  }

  StoreSelect__createClass(StoreSelect, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.props.loaded) {
        this.props.requestAllStores();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          loaded = _props.loaded,
          props = StoreSelect__objectWithoutProperties(_props, ['className', 'loaded']);

      return react_default.a.createElement(react_select, StoreSelect__extends({
        multi: true,
        resetValue: [],
        name: 'store',
        label: 'Stores',
        className: classnames_default()(ReactSelect_styles_default.a, className)
      }, props));
    }
  }]);

  return StoreSelect;
}(react["Component"]);

StoreSelect_StoreSelect.propTypes = {
  options: prop_types_default.a.arrayOf(prop_types_default.a.shape({
    label: prop_types_default.a.string,
    value: prop_types_default.a.number,
    vendor: prop_types_default.a.string
  })),
  value: prop_types_default.a.oneOfType([prop_types_default.a.arrayOf(prop_types_default.a.number), prop_types_default.a.number]),
  className: prop_types_default.a.string,
  loaded: prop_types_default.a.bool.isRequired,
  requestAllStores: prop_types_default.a.func.isRequired
};

var getStoreOptions = Object(reselect_lib["createSelector"])(reducers["_18" /* getStoreList */], function (stores) {
  return stores.map(function (store) {
    return {
      value: store.id,
      label: store.number + ' - ' + store.name,
      vendor: store.vendor
    };
  });
});

/* harmony default export */ var formElements_StoreSelect = (Object(react_redux_es["connect"])(function (state) {
  return { loaded: Object(reducers["_19" /* getStoreLoaded */])(state), options: getStoreOptions(state) };
}, { requestAllStores: actionCreators["U" /* requestAllStores */] })(StoreSelect_StoreSelect));
// CONCATENATED MODULE: ./client/app/shared/components/formElements/ProductTypeSelect/index.jsx
var ProductTypeSelect__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function ProductTypeSelect__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/* eslint no-unused-vars: ["error", { "ignoreRestSiblings": true }] */






var ProductTypeSelect_ProductTypeSelect = function ProductTypeSelect(_ref) {
  var className = _ref.className,
      props = ProductTypeSelect__objectWithoutProperties(_ref, ['className']);

  return react_default.a.createElement(react_select, ProductTypeSelect__extends({
    resetValue: [],
    name: 'produt_type',
    className: classnames_default()(ReactSelect_styles_default.a, className),
    label: 'Product Type',
    placeholder: 'STK or SOS',
    options: [{ value: 'SOS', label: 'SOS' }, { value: 'STK', label: 'STK' }]
  }, props));
};

ProductTypeSelect_ProductTypeSelect.propTypes = {
  value: prop_types_default.a.string,
  className: prop_types_default.a.string,
  onChange: prop_types_default.a.func
};

/* harmony default export */ var formElements_ProductTypeSelect = (ProductTypeSelect_ProductTypeSelect);
// CONCATENATED MODULE: ./client/app/shared/components/formElements/SurfaceTypeSelect/index.jsx
var SurfaceTypeSelect__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var SurfaceTypeSelect__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function SurfaceTypeSelect__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function SurfaceTypeSelect__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SurfaceTypeSelect__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function SurfaceTypeSelect__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint no-unused-vars: ["error", { "ignoreRestSiblings": true }] */













var SurfaceTypeSelect_SurfaceTypeSelect = function (_Component) {
  SurfaceTypeSelect__inherits(SurfaceTypeSelect, _Component);

  function SurfaceTypeSelect() {
    SurfaceTypeSelect__classCallCheck(this, SurfaceTypeSelect);

    return SurfaceTypeSelect__possibleConstructorReturn(this, (SurfaceTypeSelect.__proto__ || Object.getPrototypeOf(SurfaceTypeSelect)).apply(this, arguments));
  }

  SurfaceTypeSelect__createClass(SurfaceTypeSelect, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.props.loaded) {
        this.props.requestSurfaceTypesList();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          loaded = _props.loaded,
          props = SurfaceTypeSelect__objectWithoutProperties(_props, ['className', 'loaded']);

      return react_default.a.createElement(react_select, SurfaceTypeSelect__extends({
        multi: true,
        resetValue: [],
        name: 'surface_type',
        className: classnames_default()(ReactSelect_styles_default.a, className),
        label: 'Surface Type'
      }, props));
    }
  }]);

  return SurfaceTypeSelect;
}(react["Component"]);

SurfaceTypeSelect_SurfaceTypeSelect.propTypes = {
  options: prop_types_default.a.arrayOf(prop_types_default.a.shape({
    label: prop_types_default.a.string,
    value: prop_types_default.a.number
  })),
  value: prop_types_default.a.oneOfType([prop_types_default.a.arrayOf(prop_types_default.a.string), prop_types_default.a.number, prop_types_default.a.arrayOf(prop_types_default.a.number)]),
  className: prop_types_default.a.string,
  loaded: prop_types_default.a.bool.isRequired,
  requestSurfaceTypesList: prop_types_default.a.func.isRequired,
  vendor: prop_types_default.a.string
};

var getVendorProp = function getVendorProp(_, props) {
  return props.vendor;
};
var getValueProp = function getValueProp(_, props) {
  return props.value;
};

// No vendor passed (e.g. report/schedule/phase-list filters) means unfiltered, unchanged
// behavior. When a vendor is passed, IFI sees only the millwork surface types and every
// other vendor sees the rest. The currently selected value is always kept in the list even
// if it wouldn't otherwise pass the filter, so a pre-existing/legacy mismatch never renders
// as a blank, data-loss-looking dropdown.
var getSurfaceTypeOptions = Object(reselect_lib["createSelector"])(reducers["_22" /* getSurfaceTypeList */], getVendorProp, getValueProp, function (types, vendor, currentValue) {
  if (!vendor) return Object(utils["j" /* generateSource */])(types);
  var isIfi = vendor === 'IFI';
  var filtered = types.filter(function (type) {
    return constants["_1" /* MILLWORK_SURFACES */].includes(type.id) === isIfi;
  });
  if (currentValue && !filtered.some(function (type) {
    return type.id === currentValue;
  })) {
    var current = types.find(function (type) {
      return type.id === currentValue;
    });
    if (current) filtered = filtered.concat(current);
  }
  return Object(utils["j" /* generateSource */])(filtered);
});

/* harmony default export */ var formElements_SurfaceTypeSelect = (Object(react_redux_es["connect"])(function (state, ownProps) {
  return { loaded: state.surfaceTypes.loaded, options: getSurfaceTypeOptions(state, ownProps) };
}, { requestSurfaceTypesList: actionCreators["_25" /* requestSurfaceTypesList */] })(SurfaceTypeSelect_SurfaceTypeSelect));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseList/components/PhaseLocationFilters.jsx
var PhaseLocationFilters__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var PhaseLocationFilters__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function PhaseLocationFilters__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function PhaseLocationFilters__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function PhaseLocationFilters__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function PhaseLocationFilters__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var PhaseLocationFilters_selectStyles = ReactSelect_styles_default.a.selectWrapper + ' ' + phaseFilters_default.a.selectWrapper;

var PhaseLocationFilters_PhaseLocationFilters = function (_Component) {
  PhaseLocationFilters__inherits(PhaseLocationFilters, _Component);

  function PhaseLocationFilters(props) {
    PhaseLocationFilters__classCallCheck(this, PhaseLocationFilters);

    var _this = PhaseLocationFilters__possibleConstructorReturn(this, (PhaseLocationFilters.__proto__ || Object.getPrototypeOf(PhaseLocationFilters)).call(this, props));

    Object.defineProperty(_this, 'handleSelectChange', {
      enumerable: true,
      writable: true,
      value: function value(key, values) {
        return _this.props.updatePhaseFiltersLocation(PhaseLocationFilters__extends({}, _this.props.filters, PhaseLocationFilters__defineProperty({}, key, (values || []).map(function (v) {
          return v.value;
        }))));
      }
    });
    Object.defineProperty(_this, 'handleProductType', {
      enumerable: true,
      writable: true,
      value: function value(key, values) {
        return _this.props.updatePhaseFiltersLocation(PhaseLocationFilters__extends({}, _this.props.filters, PhaseLocationFilters__defineProperty({}, key, values ? values.value : undefined)));
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        return react_default.a.createElement(
          'div',
          { className: phaseFilters_default.a.content },
          !_this.props.hideWorkroomSelect && react_default.a.createElement(formElements_WorkroomSelect, {
            value: _this.props.filters.workroom,
            onChange: _this.handleWorkrooms,
            className: phaseFilters_default.a.selectWrapper
          }),
          react_default.a.createElement(formElements_StoreSelect, {
            className: PhaseLocationFilters_selectStyles,
            value: _this.props.filters.store,
            onChange: _this.handleStores,
            placeholder: 'All Stores'
          }),
          react_default.a.createElement(react_select, {
            key: 'regions',
            className: PhaseLocationFilters_selectStyles,
            label: 'Store Region',
            name: 'store-region',
            placeholder: 'All Regions',
            multi: true,
            options: Object(utils["j" /* generateSource */])(_this.props.regions),
            value: _this.props.filters.region,
            onChange: _this.handleRegions
          }),
          react_default.a.createElement(formElements_SurfaceTypeSelect, {
            multi: true,
            onChange: _this.handleSurfaceType,
            value: _this.props.filters.surface_type,
            className: PhaseLocationFilters_selectStyles,
            placeholder: 'All Surface Types'
          }),
          react_default.a.createElement(formElements_ProductTypeSelect, {
            className: PhaseLocationFilters_selectStyles,
            value: _this.props.filters.product_type,
            onChange: _this.handleProductType
          })
        );
      }
    });

    _this.handleWorkrooms = _this.handleSelectChange.bind(_this, 'workroom');
    _this.handleStores = _this.handleSelectChange.bind(_this, 'store');
    _this.handleRegions = _this.handleSelectChange.bind(_this, 'region');
    _this.handleSurfaceType = _this.handleSelectChange.bind(_this, 'surface_type');
    _this.handleProductType = _this.handleProductType.bind(_this, 'product_type');
    return _this;
  }

  PhaseLocationFilters__createClass(PhaseLocationFilters, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var regions = this.props.regions;

      if (!regions || regions.length === 0) {
        this.props.requestRegionList();
      }
    }
  }]);

  return PhaseLocationFilters;
}(react["Component"]);

PhaseLocationFilters_PhaseLocationFilters.defaultProps = {
  filters: {
    workroom: [],
    store: [],
    region: [],
    surface_type: []
  },
  hideWorkroomSelect: false,
  regions: []
};

PhaseLocationFilters_PhaseLocationFilters.propTypes = {
  filters: PhaseFilterLocationType.isRequired,
  updatePhaseFiltersLocation: prop_types_default.a.func.isRequired,
  requestRegionList: prop_types_default.a.func.isRequired,
  hideWorkroomSelect: prop_types_default.a.bool,
  regions: prop_types_default.a.arrayOf(prop_types_default.a.shape({
    id: prop_types_default.a.number.isRequired,
    name: prop_types_default.a.string.isRequired
  }))
};

var PhaseLocationFilters_mapStateToProps = function mapStateToProps(state) {
  return {
    filters: Object(reducers["_2" /* getPhaseFiltersLocation */])(state),
    regions: Object(reducers["_11" /* getRegionList */])(state)
  };
};

/* harmony default export */ var components_PhaseLocationFilters = (Object(react_redux_es["connect"])(PhaseLocationFilters_mapStateToProps, {
  updatePhaseFiltersLocation: actionCreators["_66" /* updatePhaseFiltersLocation */],
  requestRegionList: actionCreators["_22" /* requestRegionList */]
})(PhaseLocationFilters_PhaseLocationFilters));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseList/components/SupervisorQuickFilter.jsx
var SupervisorQuickFilter__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function SupervisorQuickFilter__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SupervisorQuickFilter__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function SupervisorQuickFilter__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var SupervisorQuickFilter_SupervisorQuickFilter = function (_Component) {
  SupervisorQuickFilter__inherits(SupervisorQuickFilter, _Component);

  function SupervisorQuickFilter() {
    var _ref;

    var _temp, _this, _ret;

    SupervisorQuickFilter__classCallCheck(this, SupervisorQuickFilter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = SupervisorQuickFilter__possibleConstructorReturn(this, (_ref = SupervisorQuickFilter.__proto__ || Object.getPrototypeOf(SupervisorQuickFilter)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'componentDidMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.fetchEmployees();
      }
    }), Object.defineProperty(_this, 'getOptions', {
      enumerable: true,
      writable: true,
      value: function value() {
        var employees = _this.props.employees;


        return (employees || []).map(function (employee) {
          return {
            value: employee.id,
            label: employee.name + ' - ' + (employee.position || 'Employee')
          };
        });
      }
    }), Object.defineProperty(_this, 'fetchEmployees', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            workroomFilters = _this$props.workroomFilters,
            workrooms = _this$props.workrooms;

        // Filter to only IFI workrooms

        var ifiWorkroomIds = (workrooms || []).filter(function (w) {
          return w.vendor === 'IFI' && workroomFilters.includes(w.id);
        }).map(function (w) {
          return w.id;
        });

        // Build filters for requestEmployeeList
        var filters = {
          is_active: true,
          for_workrooms: ifiWorkroomIds,
          for_positions: constants["O" /* IC_ISM_POSITIONS */]
        };

        // Set filters in state and request (setEmployeeFilters handles reset and request)
        _this.props.setEmployeeFilters(filters);
      }
    }), Object.defineProperty(_this, 'handleChange', {
      enumerable: true,
      writable: true,
      value: function value(selectedOption) {
        var employeeId = selectedOption ? selectedOption.value : null;
        if (_this.props.onChange) {
          _this.props.onChange(employeeId);
        }
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props2 = _this.props,
            className = _this$props2.className,
            loading = _this$props2.loading,
            filters = _this$props2.filters;


        var value = filters && filters.assigned_employee ? parseInt(filters.assigned_employee, 10) : null;
        var selectedValue = value ? _this.getOptions().find(function (opt) {
          return opt.value === value;
        }) : null;

        // "Supervisor" is labeled as "Coordinator" in the UI since
        // that's more familiar to IFI users, but the value is still
        // stored as "supervisor_id" in the backend.
        return react_default.a.createElement(react_select, {
          name: 'supervisor',
          className: classnames_default()(ReactSelect_styles_default.a, phaseFilters_default.a.selectWrapper, className),
          label: 'Coordinator (IFI)',
          placeholder: 'Select Coordinator',
          options: _this.getOptions(),
          value: selectedValue,
          onChange: _this.handleChange,
          clearable: true,
          isLoading: loading
        });
      }
    }), _temp), SupervisorQuickFilter__possibleConstructorReturn(_this, _ret);
  }

  SupervisorQuickFilter__createClass(SupervisorQuickFilter, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var prevWorkrooms = prevProps.workroomFilters || [];
      var currentWorkrooms = this.props.workroomFilters || [];

      // Refetch if workroom selection changed
      if (prevWorkrooms.length !== currentWorkrooms.length || !prevWorkrooms.every(function (id, idx) {
        return id === currentWorkrooms[idx];
      })) {
        this.fetchEmployees();
      }
    }
  }]);

  return SupervisorQuickFilter;
}(react["Component"]);

SupervisorQuickFilter_SupervisorQuickFilter.defaultProps = {
  workroomFilters: [],
  employees: [],
  loading: false,
  filters: {},
  workrooms: []
};

SupervisorQuickFilter_SupervisorQuickFilter.propTypes = {
  employees: prop_types_default.a.arrayOf(prop_types_default.a.shape({
    id: prop_types_default.a.number.isRequired,
    name: prop_types_default.a.string.isRequired,
    position: prop_types_default.a.string
  })),
  loading: prop_types_default.a.bool.isRequired,
  setEmployeeFilters: prop_types_default.a.func.isRequired,
  workroomFilters: prop_types_default.a.arrayOf(prop_types_default.a.number),
  workrooms: prop_types_default.a.arrayOf(prop_types_default.a.shape({
    id: prop_types_default.a.number.isRequired,
    vendor: prop_types_default.a.string
  })),
  filters: prop_types_default.a.shape({
    assigned_employee: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number])
  }),
  onChange: prop_types_default.a.func.isRequired,
  className: prop_types_default.a.string
};

var SupervisorQuickFilter_getEmployeeOptions = Object(reselect_lib["createSelector"])(reducers["m" /* getEmployeeList */], function (employees) {
  return employees || [];
});

var SupervisorQuickFilter_mapStateToProps = function mapStateToProps(state) {
  var phaseFilters = Object(reducers["_2" /* getPhaseFiltersLocation */])(state);
  var workroomFilters = phaseFilters.workroom || [];

  return {
    loading: Object(reducers["n" /* getEmployeeLoading */])(state),
    employees: SupervisorQuickFilter_getEmployeeOptions(state),
    workroomFilters: Array.isArray(workroomFilters) ? workroomFilters : [],
    workrooms: Object(reducers["_37" /* getWorkroomList */])(state)
  };
};

var SupervisorQuickFilter_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setEmployeeFilters: function setEmployeeFilters(filters) {
      return dispatch(Object(actionCreators["_45" /* setEmployeeFilters */])(filters));
    }
  };
};

/* harmony default export */ var components_SupervisorQuickFilter = (Object(react_redux_es["connect"])(SupervisorQuickFilter_mapStateToProps, SupervisorQuickFilter_mapDispatchToProps)(SupervisorQuickFilter_SupervisorQuickFilter));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseList/components/SavedFiltersList.jsx
function SavedFiltersList__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function SavedFiltersList__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SavedFiltersList__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function SavedFiltersList__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var SavedFiltersList_SavedFiltersList = function (_Component) {
  SavedFiltersList__inherits(SavedFiltersList, _Component);

  function SavedFiltersList() {
    var _ref;

    var _temp, _this, _ret;

    SavedFiltersList__classCallCheck(this, SavedFiltersList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = SavedFiltersList__possibleConstructorReturn(this, (_ref = SavedFiltersList.__proto__ || Object.getPrototypeOf(SavedFiltersList)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'state', {
      enumerable: true,
      writable: true,
      value: { isDragging: false }
    }), Object.defineProperty(_this, 'selectFilter', {
      enumerable: true,
      writable: true,
      value: function value(filter) {
        return function (e) {
          e.preventDefault();
          _this.props.onFilterSelect(filter);
        };
      }
    }), Object.defineProperty(_this, 'move', {
      enumerable: true,
      writable: true,
      value: function value(dragIndex, hoverIndex) {
        return _this.props.updateSavedFilterPosition(dragIndex, hoverIndex);
      }
    }), Object.defineProperty(_this, 'beginDrag', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ isDragging: true });
      }
    }), Object.defineProperty(_this, 'endDrag', {
      enumerable: true,
      writable: true,
      value: function value(item, index) {
        _this.props.updateSavedFilter({ position: index }, item.id);
        _this.setState({ isDragging: false });
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            ignoreLocationFilters = _this$props.ignoreLocationFilters,
            selected = _this$props.selected,
            all_phase_count = _this$props.all_phase_count,
            all_phase_overdue_count = _this$props.all_phase_overdue_count,
            assignedFilters = _this$props.assignedFilters,
            savedFilters = _this$props.savedFilters,
            hideSaved = _this$props.hideSaved,
            role = _this$props.role;

        return react_default.a.createElement(
          'div',
          null,
          ignoreLocationFilters ? react_default.a.createElement(
            'h2',
            { className: savedFilters_default.a.disabledHeader },
            react_default.a.createElement(react_toolbox_lib["FontIcon"], { value: 'report_problem' }),
            'Filters Disabled',
            react_default.a.createElement(react_toolbox_lib["FontIcon"], { value: 'report_problem' })
          ) : react_default.a.createElement(
            react["Fragment"],
            null,
            !['installer', 'estimator'].includes(role) && react_default.a.createElement(
              react["Fragment"],
              null,
              react_default.a.createElement(
                'h4',
                { className: savedFilters_default.a.header },
                'Quick Filters'
              ),
              react_default.a.createElement(components_PhaseLocationFilters, null),
              _this.props.canAccessSupervisorFilter && react_default.a.createElement(components_SupervisorQuickFilter, {
                filters: _this.props.filters,
                onChange: _this.props.onSupervisorChange
              })
            ),
            react_default.a.createElement(
              'h4',
              { className: savedFilters_default.a.header },
              'Default Filter'
            ),
            react_default.a.createElement(
              'div',
              { className: classnames_default()(savedFilters_default.a.filter, SavedFiltersList__defineProperty({}, savedFilters_default.a.selected, !selected)) },
              react_default.a.createElement(
                es["c" /* Link */],
                { to: '/phases' },
                react_default.a.createElement(
                  'span',
                  { className: savedFilters_default.a.name },
                  'All Phases'
                ),
                all_phase_count && react_default.a.createElement(
                  'span',
                  { className: savedFilters_default.a.count },
                  all_phase_overdue_count,
                  '/',
                  all_phase_count
                )
              )
            ),
            assignedFilters.length > 0 && react_default.a.createElement(
              'div',
              null,
              react_default.a.createElement(
                'h4',
                { className: savedFilters_default.a.header },
                'Assigned Filters'
              ),
              react_default.a.createElement(
                'ul',
                { className: savedFilters_default.a.list },
                assignedFilters.map(function (filter, i) {
                  return react_default.a.createElement(assignedFilterItem, {
                    key: filter.id,
                    item: filter,
                    index: i,
                    selected: filter.id === (selected && selected.type === 'assigned' && selected.id),
                    onFilterSelect: _this.selectFilter(filter)
                  });
                })
              )
            ),
            !hideSaved && react_default.a.createElement(
              react["Fragment"],
              null,
              react_default.a.createElement(
                'h4',
                { className: savedFilters_default.a.header },
                'Saved Filters'
              ),
              react_default.a.createElement(
                'ul',
                { className: classnames_default()(savedFilters_default.a.list, SavedFiltersList__defineProperty({}, savedFilters_default.a.dragging, _this.state.isDragging)) },
                savedFilters.map(function (filter, i) {
                  return react_default.a.createElement(savedFilterItem, {
                    key: filter.id,
                    item: filter,
                    index: i,
                    selected: filter.id === (selected && selected.type === 'saved' && selected.id),
                    beginDrag: _this.beginDrag,
                    endDrag: _this.endDrag,
                    onFilterSelect: _this.selectFilter(filter),
                    move: _this.move
                  });
                })
              )
            )
          )
        );
      }
    }), _temp), SavedFiltersList__possibleConstructorReturn(_this, _ret);
  }

  return SavedFiltersList;
}(react["Component"]);

SavedFiltersList_SavedFiltersList.propTypes = {
  savedFilters: prop_types_default.a.arrayOf(prop_types_default.a.shape({
    name: prop_types_default.a.string.isRequired,
    filters: prop_types_default.a.object,
    overdue_count: prop_types_default.a.number,
    count: prop_types_default.a.number.isRequired,
    id: prop_types_default.a.number.isRequired
  })).isRequired,
  assignedFilters: prop_types_default.a.arrayOf(prop_types_default.a.shape({
    name: prop_types_default.a.string.isRequired,
    filters: prop_types_default.a.object,
    id: prop_types_default.a.number
  })).isRequired,
  all_phase_count: prop_types_default.a.number,
  all_phase_overdue_count: prop_types_default.a.number,
  selected: prop_types_default.a.shape({
    id: prop_types_default.a.number.isRequired,
    type: prop_types_default.a.string.isRequired,
    name: prop_types_default.a.string.isRequired
  }),
  filters: prop_types_default.a.object,
  onFilterSelect: prop_types_default.a.func.isRequired,
  updateSavedFilterPosition: prop_types_default.a.func.isRequired,
  updateSavedFilter: prop_types_default.a.func.isRequired,
  ignoreLocationFilters: prop_types_default.a.bool,
  hideSaved: prop_types_default.a.bool,
  role: prop_types_default.a.string,
  onSupervisorChange: prop_types_default.a.func,
  canAccessSupervisorFilter: prop_types_default.a.bool
};

SavedFiltersList_SavedFiltersList.defaultProps = {
  filters: {},
  savedFilters: [],
  assignedFilters: [],
  canAccessSupervisorFilter: false
};

var SavedFiltersList_mapStateToProps = function mapStateToProps(state) {
  return {
    savedFilters: state.savedFilters.filters,
    assignedFilters: state.assignedFilters.filters,
    filters: state.phases.filters.data,
    all_phase_count: state.phases.pagination.all_phase_count,
    all_phase_overdue_count: state.phases.pagination.all_phase_overdue_count
  };
};

/* harmony default export */ var components_SavedFiltersList = (Object(react_dnd_lib["DragDropContext"])(react_dnd_html5_backend_lib_default.a)(Object(react_redux_es["connect"])(SavedFiltersList_mapStateToProps, {
  updateSavedFilterPosition: actionCreators["_69" /* updateSavedFilterPosition */], updateSavedFilter: actionCreators["_68" /* updateSavedFilter */]
})(SavedFiltersList_SavedFiltersList)));
// CONCATENATED MODULE: ./client/app/selectors/appointments.js
var appointments__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var getPhaseAppointmentsSelector = function getPhaseAppointmentsSelector(state) {
  return state.phase.details.appointments || [];
};

var appointments_momentizeAppointmentDates = function momentizeAppointmentDates(appointments) {
  return appointments.map(function (appointment) {
    var apptCopy = appointments__extends({}, appointment);
    apptCopy.start_moment = moment_default()(appointment.start_date + ' ' + appointment.arrival_start_time);
    apptCopy.end_moment = moment_default()(appointment.end_date + ' ' + appointment.arrival_end_time);
    if (appointment.appointment_confirmation_date) {
      apptCopy.appointment_confirmation_moment = moment_default()(appointment.appointment_confirmation_date);
    }
    if (appointment.product_confirmation_date) {
      apptCopy.product_confirmation_moment = moment_default()(appointment.product_confirmation_date);
    }
    if (appointment.pickup_date) {
      apptCopy.pickup_moment = moment_default()(appointment.pickup_date);
    }
    return apptCopy;
  });
};

var momentizePhaseAppointmentDates = Object(reselect_lib["createSelector"])(getPhaseAppointmentsSelector, appointments_momentizeAppointmentDates);

var sortAppointments = function sortAppointments(appointments) {
  return appointments.sort(function (a, b) {
    if (a.start_moment.isBefore(b.start_moment)) return -1;
    if (a.start_moment.isAfter(b.start_moment)) return 1;

    return 0;
  });
};

var sortPhaseAppointments = Object(reselect_lib["createSelector"])(momentizePhaseAppointmentDates, sortAppointments);
// EXTERNAL MODULE: ./client/app/shared/components/UserNote/styles.scss
var UserNote_styles = __webpack_require__("oh4S");
var UserNote_styles_default = /*#__PURE__*/__webpack_require__.n(UserNote_styles);

// CONCATENATED MODULE: ./client/app/shared/components/UserNote/index.jsx
var UserNote__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function UserNote__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






var UserNote_UserNote = function UserNote(_ref) {
  var children = _ref.children,
      className = _ref.className,
      props = UserNote__objectWithoutProperties(_ref, ['children', 'className']);

  return react_default.a.createElement(
    'pre',
    UserNote__extends({ className: classnames_default()(UserNote_styles_default.a.note, className) }, props),
    children
  );
};

UserNote_UserNote.propTypes = {
  children: prop_types_default.a.node,
  className: prop_types_default.a.string
};

/* harmony default export */ var components_UserNote = (UserNote_UserNote);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/styled.browser.esm.js + 2 modules
var styled_browser_esm = __webpack_require__("xRda");

// EXTERNAL MODULE: ./node_modules/@emotion/core/dist/core.browser.esm.js + 5 modules
var core_browser_esm = __webpack_require__("GylY");

// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseList/components/phaseCard/components/styledComponents.js
var _templateObject = _taggedTemplateLiteral(['\n0% {\n  transform: scale(1);\n}\n50% {\n  transform: scale(1.1);\n}\n100% {\n  transform: scale(1);\n}\n'], ['\n0% {\n  transform: scale(1);\n}\n50% {\n  transform: scale(1.1);\n}\n100% {\n  transform: scale(1);\n}\n']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }




var pulse = Object(core_browser_esm["keyframes"])(_templateObject);

var PhaseTypeSpan = styled_browser_esm["a" /* default */].span(function () {
  return {
    animation: pulse + ' 2500ms infinite'
  };
});

/* harmony default export */ var styledComponents = (PhaseTypeSpan);
// EXTERNAL MODULE: ./client/app/shared/components/DueDate/styles.scss
var DueDate_styles = __webpack_require__("lIXC");
var DueDate_styles_default = /*#__PURE__*/__webpack_require__.n(DueDate_styles);

// CONCATENATED MODULE: ./client/app/shared/components/DueDate/index.jsx
function DueDate__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









var DueDate_DueDate = function DueDate(_ref) {
  var date = _ref.date,
      showText = _ref.showText,
      className = _ref.className,
      isPhaseDetails = _ref.isPhaseDetails;

  var m = moment_default()(date);
  var overdue = Object(dateUtils["p" /* isOverdue */])(m);
  return react_default.a.createElement(
    'span',
    { className: classnames_default()(DueDate_styles_default.a.due, className, DueDate__defineProperty({}, DueDate_styles_default.a.overdue, overdue && isPhaseDetails)) },
    react_default.a.createElement(react_toolbox_lib["FontIcon"], { value: overdue ? 'notifications_active' : 'notifications_none' }),
    showText && 'Due: ',
    m.isValid() ? react_default.a.createElement(
      'time',
      { dateTime: m.toISOString() },
      m.calendar()
    ) : '--'
  );
};

DueDate_DueDate.propTypes = {
  date: prop_types_default.a.string,
  className: prop_types_default.a.string,
  showText: prop_types_default.a.bool,
  isPhaseDetails: prop_types_default.a.bool
};

DueDate_DueDate.defaultProps = {
  showText: true
};

/* harmony default export */ var components_DueDate = (DueDate_DueDate);
// EXTERNAL MODULE: ./node_modules/react-toolbox/lib/font_icon/index.js
var font_icon = __webpack_require__("OwJe");
var font_icon_default = /*#__PURE__*/__webpack_require__.n(font_icon);

// EXTERNAL MODULE: ./client/app/screens/main/screens/phases/shared/flagList.scss
var flagList = __webpack_require__("2UVg");
var flagList_default = /*#__PURE__*/__webpack_require__.n(flagList);

// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/components/removeFlagModal.jsx
var removeFlagModal__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function removeFlagModal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function removeFlagModal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function removeFlagModal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var DEFAULT_STATE = {
  note: '',
  removalReason: ''
};

var removeFlagModal_RemoveFlagModal = function (_React$Component) {
  removeFlagModal__inherits(RemoveFlagModal, _React$Component);

  function RemoveFlagModal(props) {
    removeFlagModal__classCallCheck(this, RemoveFlagModal);

    var _this = removeFlagModal__possibleConstructorReturn(this, (RemoveFlagModal.__proto__ || Object.getPrototypeOf(RemoveFlagModal)).call(this, props));

    _this.handleNoteChange = _this.handleNoteChange.bind(_this);
    _this.handleReasonChange = _this.handleReasonChange.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleCancel = _this.handleCancel.bind(_this);
    _this.handleClose = _this.handleClose.bind(_this);

    _this.state = DEFAULT_STATE;
    return _this;
  }

  removeFlagModal__createClass(RemoveFlagModal, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (newProps.active && !this.props.active) this.props.requestFlagOptions();
    }
  }, {
    key: 'removalReasons',
    value: function removalReasons() {
      var _props = this.props,
          flag = _props.flag,
          flagOptions = _props.flagOptions;

      if (!flag) return [];
      var option = (flagOptions || []).find(function (obj) {
        return obj.name === flag.name;
      });
      return option && option.removal_reasons || [];
    }
  }, {
    key: 'handleNoteChange',
    value: function handleNoteChange(e) {
      this.setState({
        note: e.target.value
      });
    }
  }, {
    key: 'handleReasonChange',
    value: function handleReasonChange(removalReason) {
      this.setState({ removalReason: removalReason });
    }
  }, {
    key: 'handleSubmit',
    value: function handleSubmit() {
      var _this2 = this;

      var _state = this.state,
          note = _state.note,
          removalReason = _state.removalReason;
      var flag = this.props.flag;

      var phaseID = flag.phase_id;

      var flagProps = {
        id: flag.id,
        note: note
      };
      if (this.removalReasons().length > 0) flagProps.removal_reason = removalReason;

      this.props.removeFlagFromPhase(phaseID, flagProps).then(function () {
        _this2.handleClose();
      }).catch(function () {}); // catching this to avoid console warnings...
    }
  }, {
    key: 'handleClose',
    value: function handleClose() {
      var errors = this.props.errors;


      if (Object.keys(errors).length === 0) {
        this.props.onClose();
        this.setState(DEFAULT_STATE);
      }
    }
  }, {
    key: 'handleCancel',
    value: function handleCancel() {
      this.props.clearValidation();
      this.handleClose();
    }
  }, {
    key: 'render',
    value: function render() {
      var _state2 = this.state,
          note = _state2.note,
          removalReason = _state2.removalReason;
      var _props2 = this.props,
          active = _props2.active,
          flag = _props2.flag,
          errors = _props2.errors;

      var flagName = flag ? flag.name : '';
      var removalReasons = this.removalReasons();

      return react_default.a.createElement(
        react_toolbox_lib["Dialog"],
        {
          active: active,
          className: modal_default.a.modal,
          type: 'fullscreen',
          onEscKeyDown: this.handleClose,
          onOverlayClick: this.handleClose
        },
        react_default.a.createElement(
          'div',
          { className: input_default.a.errored },
          Object.keys(errors).length > 0 && react_default.a.createElement(
            'span',
            { className: input_default.a.error },
            Object(utils["d" /* errorSummary */])(errors)
          )
        ),
        react_default.a.createElement(lib_button["IconButton"], {
          icon: 'close',
          className: modal_default.a.close,
          onClick: this.handleCancel,
          tabIndex: -1
        }),
        react_default.a.createElement(
          'h5',
          { className: modal_default.a.title },
          'Remove Flag - ',
          flagName
        ),
        removalReasons.length > 0 && react_default.a.createElement(components_StyledSelect, {
          label: 'Removal Reason',
          options: removalReasons.map(function (value) {
            return { value: value, label: value };
          }),
          onChange: this.handleReasonChange,
          value: removalReason,
          required: true,
          placeholder: 'Select a reason',
          error: Object(utils["c" /* error */])('removal_reason', errors)
        }),
        react_default.a.createElement(components_TextArea, {
          label: 'Notes *',
          value: note,
          errors: errors.note,
          onChange: this.handleNoteChange,
          autoFocus: true
        }),
        react_default.a.createElement(lib_button["Button"], {
          label: 'Remove Flag',
          flat: true, inverse: true, ripple: true,
          className: modal_default.a.submit,
          disabled: removalReasons.length > 0 && !removalReason,
          onClick: this.handleSubmit
        })
      );
    }
  }]);

  return RemoveFlagModal;
}(react_default.a.Component);

removeFlagModal_RemoveFlagModal.propTypes = {
  errors: prop_types_default.a.object,
  active: prop_types_default.a.bool.isRequired,
  removeFlagFromPhase: prop_types_default.a.func.isRequired,
  requestFlagOptions: prop_types_default.a.func.isRequired,
  onClose: prop_types_default.a.func.isRequired,
  clearValidation: prop_types_default.a.func.isRequired,
  flag: types_flag,
  flagOptions: prop_types_default.a.array
};

/* harmony default export */ var removeFlagModal = (Object(react_redux_es["connect"])(function (state) {
  return {
    errors: Object(reducers["Y" /* getPhaseErrors */])(state),
    flagOptions: Object(reducers["w" /* getFlagOptions */])(state)
  };
}, { removeFlagFromPhase: actionCreators_phase["m" /* removeFlagFromPhase */], clearValidation: actionCreators_phase["f" /* clearValidation */], requestFlagOptions: actionCreators_flags })(removeFlagModal_RemoveFlagModal));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/components/viewFlagModal.jsx
var viewFlagModal__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function viewFlagModal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function viewFlagModal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function viewFlagModal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var viewFlagModal_ViewFlagModal = function (_React$Component) {
  viewFlagModal__inherits(ViewFlagModal, _React$Component);

  function ViewFlagModal() {
    var _ref;

    var _temp, _this, _ret;

    viewFlagModal__classCallCheck(this, ViewFlagModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = viewFlagModal__possibleConstructorReturn(this, (_ref = ViewFlagModal.__proto__ || Object.getPrototypeOf(ViewFlagModal)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'handleClose', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.onClose();
      }
    }), _temp), viewFlagModal__possibleConstructorReturn(_this, _ret);
  }

  viewFlagModal__createClass(ViewFlagModal, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          flag = _props.flag,
          active = _props.active,
          deleteEnabled = _props.deleteEnabled;

      if (flag === null) return null;

      var flagTooltipText = this.props.flagTooltipText(flag);

      return react_default.a.createElement(
        react_toolbox_lib["Dialog"],
        {
          active: active,
          className: modal_default.a.modal,
          onEscKeyDown: this.handleClose,
          onOverlayClick: this.handleClose
        },
        react_default.a.createElement(lib_button["IconButton"], {
          icon: 'close',
          className: modal_default.a.close,
          onClick: this.handleClose
        }),
        react_default.a.createElement(
          'h5',
          { className: modal_default.a.title },
          flag.name
        ),
        react_default.a.createElement(
          'p',
          null,
          flagTooltipText
        ),
        react_default.a.createElement(
          'p',
          null,
          flag.user_name + ' on ' + Object(dateUtils["l" /* getMinLocalDate */])(flag.created_at)
        ),
        deleteEnabled && react_default.a.createElement(lib_button["Button"], {
          label: 'Remove Flag',
          flat: true, inverse: true, ripple: true,
          className: modal_default.a.submit,
          onClick: function onClick() {
            return _this2.props.onRemove();
          }
        })
      );
    }
  }]);

  return ViewFlagModal;
}(react_default.a.Component);

viewFlagModal_ViewFlagModal.propTypes = {
  active: prop_types_default.a.bool.isRequired,
  onClose: prop_types_default.a.func.isRequired,
  onRemove: prop_types_default.a.func.isRequired,
  deleteEnabled: prop_types_default.a.bool.isRequired,
  flagTooltipText: prop_types_default.a.func.isRequired,
  flag: prop_types_default.a.shape({
    id: prop_types_default.a.number.isRequired,
    name: prop_types_default.a.string.isRequired,
    suboption: prop_types_default.a.string,
    note: prop_types_default.a.string.isRequired,
    user_name: prop_types_default.a.string.isRequired,
    created_at: prop_types_default.a.string.isRequired
  })
};

viewFlagModal_ViewFlagModal.defaultProps = {
  active: false,
  deleteEnabled: false
};

/* harmony default export */ var viewFlagModal = (viewFlagModal_ViewFlagModal);
// EXTERNAL MODULE: ./node_modules/react-dropzone/dist/index.js
var react_dropzone_dist = __webpack_require__("KTM0");
var react_dropzone_dist_default = /*#__PURE__*/__webpack_require__.n(react_dropzone_dist);

// EXTERNAL MODULE: ./client/app/screens/main/screens/phases/shared/dropzoneStyles.scss
var dropzoneStyles = __webpack_require__("yWL5");
var dropzoneStyles_default = /*#__PURE__*/__webpack_require__.n(dropzoneStyles);

// CONCATENATED MODULE: ./client/app/shared/components/SimpleInput/index.jsx






var SimpleInput_SimpleInput = function SimpleInput(_ref) {
  var label = _ref.label,
      text = _ref.text,
      onChange = _ref.onChange,
      className = _ref.className,
      errors = _ref.errors;

  var errorMsg = errors.join(', ');
  var wrapperStyles = errorMsg ? classnames_default()(input_default.a.errored, className) : className;
  var textAreaStyles = classnames_default()(input_default.a.inputElement, form_default.a.inputArea);
  var labelStyles = errorMsg ? classnames_default()(form_default.a.label, form_default.a.errorLabel) : form_default.a.label;

  return react_default.a.createElement(
    'div',
    { className: wrapperStyles },
    react_default.a.createElement(
      'h6',
      { className: labelStyles },
      label
    ),
    react_default.a.createElement('input', {
      className: textAreaStyles,
      value: text,
      onChange: onChange
    }),
    errorMsg && react_default.a.createElement(
      'div',
      { className: input_default.a.error },
      react_default.a.createElement(
        'p',
        { className: form_default.a.errorMsg },
        errorMsg
      )
    )
  );
};

SimpleInput_SimpleInput.propTypes = {
  label: prop_types_default.a.string.isRequired,
  text: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]).isRequired,
  onChange: prop_types_default.a.func.isRequired,
  errors: prop_types_default.a.array.isRequired,
  className: prop_types_default.a.string
};

SimpleInput_SimpleInput.defaultProps = {
  label: '',
  text: '',
  errors: []
};

/* harmony default export */ var components_SimpleInput = (SimpleInput_SimpleInput);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/components/verifyBuildDateModal.jsx
var verifyBuildDateModal__slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var verifyBuildDateModal__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var verifyBuildDateModal__get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function verifyBuildDateModal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function verifyBuildDateModal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function verifyBuildDateModal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




















var verifyBuildDateModal_DEFAULT_STATE = {
  yearBuilt: '',
  file: null,
  errors: {}
};

var verifyBuildDateModal_VerifyBuildDateModal = function (_Resetter) {
  verifyBuildDateModal__inherits(VerifyBuildDateModal, _Resetter);

  function VerifyBuildDateModal() {
    var _ref;

    var _temp, _this, _ret;

    verifyBuildDateModal__classCallCheck(this, VerifyBuildDateModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = verifyBuildDateModal__possibleConstructorReturn(this, (_ref = VerifyBuildDateModal.__proto__ || Object.getPrototypeOf(VerifyBuildDateModal)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'componentWillReceiveProps', {
      enumerable: true,
      writable: true,
      value: function value(newProps) {
        return newProps.active && !_this.props.active ? _this.props.clearValidation() : null;
      }
    }), Object.defineProperty(_this, 'handleYearBuiltChange', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        return _this.setState({ yearBuilt: e.target.value });
      }
    }), Object.defineProperty(_this, 'handleDrop', {
      enumerable: true,
      writable: true,
      value: function value(files) {
        var _files = verifyBuildDateModal__slicedToArray(files, 1),
            file = _files[0];

        _this.setState({ file: file });
      }
    }), Object.defineProperty(_this, 'handleRemoveFile', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ file: null });
      }
    }), Object.defineProperty(_this, 'handleSubmit', {
      enumerable: true,
      writable: true,
      value: function value() {
        if (!_this.validate()) return;

        var flag = _this.props.flag;
        var _this$state = _this.state,
            yearBuilt = _this$state.yearBuilt,
            file = _this$state.file;

        var phaseID = flag.phase_id;

        var formData = new FormData();
        formData.append('document_upload[assets][][asset]', file);
        formData.append('document_upload[assets][][document_name]', 'Build Date Proof');
        formData.append('document_upload[assets][][document_type]', 'Misc');

        _this.props.uploadDocument(formData, phaseID).then(function () {
          return _this.props.updatePhase({ id: phaseID, year_built: yearBuilt }, {});
        }).then(function () {
          return _this.props.removeFlagFromPhase(phaseID, {
            id: flag.id,
            note: 'Year built verified'
          });
        }).then(function () {
          return _this.handleClose();
        }).catch(function () {}); // catching this to avoid console warnings...
      }
    }), Object.defineProperty(_this, 'handleCancel', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.handleClose();
      }
    }), _temp), verifyBuildDateModal__possibleConstructorReturn(_this, _ret);
  }

  // Clear out any leftover phase validation errors (e.g. from a failed task
  // completion elsewhere on the page) so they don't bleed into this modal.


  verifyBuildDateModal__createClass(VerifyBuildDateModal, [{
    key: 'handleClose',
    value: function handleClose() {
      this.props.clearValidation();
      verifyBuildDateModal__get(VerifyBuildDateModal.prototype.__proto__ || Object.getPrototypeOf(VerifyBuildDateModal.prototype), 'handleClose', this).call(this);
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          yearBuilt = _state.yearBuilt,
          file = _state.file,
          errors = _state.errors;
      var _props = this.props,
          active = _props.active,
          flag = _props.flag,
          phaseErrors = _props.phaseErrors,
          uploadError = _props.uploadError;

      var flagName = flag ? flag.name : '';

      return react_default.a.createElement(
        react_toolbox_lib["Dialog"],
        {
          active: active,
          className: modal_default.a.modal,
          type: 'fullscreen',
          onEscKeyDown: this.handleClose,
          onOverlayClick: this.handleClose
        },
        react_default.a.createElement(
          'div',
          { className: input_default.a.errored },
          Object.keys(phaseErrors).length > 0 && react_default.a.createElement(
            'span',
            { className: input_default.a.error },
            Object(utils["d" /* errorSummary */])(phaseErrors)
          ),
          uploadError && uploadError.document_uploads && react_default.a.createElement(
            'span',
            { className: input_default.a.error },
            uploadError.document_uploads.join(', ')
          )
        ),
        react_default.a.createElement(lib_button["IconButton"], {
          icon: 'close',
          className: modal_default.a.close,
          onClick: this.handleCancel,
          tabIndex: -1
        }),
        react_default.a.createElement(
          'h5',
          { className: modal_default.a.title },
          flagName
        ),
        react_default.a.createElement(components_SimpleInput, {
          label: 'Year Built *',
          text: yearBuilt,
          errors: errors.yearBuilt || [],
          onChange: this.handleYearBuiltChange
        }),
        react_default.a.createElement(
          react_dropzone_dist_default.a,
          { className: dropzoneStyles_default.a.uploadFile, onDrop: this.handleDrop },
          react_default.a.createElement(
            ColoredButton["a" /* default */],
            { color: 'blue' },
            file ? 'Replace document' : 'Upload year built proof'
          )
        ),
        errors.file && react_default.a.createElement(
          'span',
          { className: input_default.a.error },
          errors.file.join(', ')
        ),
        file && react_default.a.createElement(
          'p',
          null,
          file.name,
          react_default.a.createElement(lib_button["Button"], { label: 'Remove', flat: true, inverse: true, ripple: true, onClick: this.handleRemoveFile })
        ),
        react_default.a.createElement(lib_button["Button"], {
          label: 'Submit',
          flat: true, inverse: true, ripple: true,
          className: modal_default.a.submit,
          onClick: this.handleSubmit
        })
      );
    }
  }]);

  return VerifyBuildDateModal;
}(resetter(validator(react_default.a.Component)));

Object.defineProperty(verifyBuildDateModal_VerifyBuildDateModal, 'VALIDATIONS', {
  enumerable: true,
  writable: true,
  value: {
    yearBuilt: 'This field is required',
    file: 'A document is required'
  }
});
Object.defineProperty(verifyBuildDateModal_VerifyBuildDateModal, 'DEFAULT_STATE', {
  enumerable: true,
  writable: true,
  value: verifyBuildDateModal_DEFAULT_STATE
});


verifyBuildDateModal_VerifyBuildDateModal.propTypes = {
  active: prop_types_default.a.bool.isRequired,
  phaseErrors: prop_types_default.a.object,
  uploadError: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.object]),
  uploadDocument: prop_types_default.a.func.isRequired,
  updatePhase: prop_types_default.a.func.isRequired,
  removeFlagFromPhase: prop_types_default.a.func.isRequired,
  onClose: prop_types_default.a.func.isRequired,
  clearValidation: prop_types_default.a.func.isRequired,
  flag: types_flag
};

verifyBuildDateModal_VerifyBuildDateModal.defaultProps = { active: false };

/* harmony default export */ var verifyBuildDateModal = (Object(react_redux_es["connect"])(function (state) {
  return {
    phaseErrors: Object(reducers["Y" /* getPhaseErrors */])(state),
    uploadError: Object(reducers["e" /* getDocumentUploadError */])(state)
  };
}, { uploadDocument: actionCreators["_74" /* uploadDocument */], updatePhase: actionCreators["_65" /* updatePhase */], removeFlagFromPhase: actionCreators["R" /* removeFlagFromPhase */], clearValidation: actionCreators["j" /* clearValidation */] })(verifyBuildDateModal_VerifyBuildDateModal));
// CONCATENATED MODULE: ./client/app/utils/flagUtils.js


var flagUtils_isActionable = function isActionable(flag) {
  return constants["a" /* ACTIONABLE_KEYS */].includes(flag.name.toLowerCase());
};

var hasActionableFlag = function hasActionableFlag(phase) {
  return phase.flags.some(flagUtils_isActionable);
};

var flagUtils_isCssFlag = function isCssFlag(flag) {
  return constants["x" /* CSS_FLAG_KEYS */].includes(flag.name.toLowerCase());
};

var hasCssFlag = function hasCssFlag(phase) {
  return phase.flags.some(flagUtils_isCssFlag);
};
// EXTERNAL MODULE: ./client/app/shared/styles/tooltip.scss
var styles_tooltip = __webpack_require__("EwDC");
var tooltip_default = /*#__PURE__*/__webpack_require__.n(styles_tooltip);

// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/components/flagList.jsx
function flagList__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function flagList__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function flagList__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function flagList__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var flagList_DEFAULT_STATE = { activeModal: null, activeFlag: null };

var MINIMUM_WIDTH = 450;

var flagList_flagTooltipText = function flagTooltipText(flag) {
  return '' + (flag.suboption && flag.suboption + ' - ') + flag.note;
};

/** Applying css classes based on the flag name. */
var changeToClassName = function changeToClassName(str) {
  return 'flag' + str.replace(/\s/g, '');
};

var flagList_FlagList = function (_React$Component) {
  flagList__inherits(FlagList, _React$Component);

  function FlagList(props) {
    flagList__classCallCheck(this, FlagList);

    var _this = flagList__possibleConstructorReturn(this, (FlagList.__proto__ || Object.getPrototypeOf(FlagList)).call(this, props));

    Object.defineProperty(_this, 'handleClose', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ activeModal: null });
      }
    });
    Object.defineProperty(_this, 'handleClick', {
      enumerable: true,
      writable: true,
      value: function value(flag, action) {
        if (action === 'view' && flag.name === 'Welcome Call Needed' && _this.props.onFlagNavigate) {
          _this.props.onFlagNavigate(flag);
          return;
        }
        if (action === 'view' && flag.name === constants["_53" /* VERIFY_BUILD_DATE_FLAG */]) {
          _this.setState({ activeFlag: flag, activeModal: 'verifyBuildDate' });
          return;
        }
        // Flag text is not clickable if not in mobile view
        if (action === 'view' && window.outerWidth >= MINIMUM_WIDTH) return;
        _this.setState({ activeFlag: flag, activeModal: action });
      }
    });
    Object.defineProperty(_this, 'isValidPosition', {
      enumerable: true,
      writable: true,
      value: function value(flagName, position, role, name) {
        var isValid = true;
        if (role !== 'admin') {
          if (flagName === 'IME') return false;
          if (flagName === 'Welcome Call Needed') return false;
          // Workrooms own Holiday Promo resolution; CCS cannot remove it
          if (flagName === constants["N" /* HOLIDAY_PROMO_FLAG */] && position === 'Customer Care Specialist') return false;
          if (['Escalation', 'ECR', 'Claim'].includes(flagName)) {
            isValid = position === 'Customer Care Specialist' || ['Fatima Singletary', 'Kyle Reece', 'Jimmy Chestnut'].includes(name);
          }
        }
        return isValid;
      }
    });
    Object.defineProperty(_this, 'renderRemoveFlagModal', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ activeModal: 'remove' });
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            flags = _this$props.flags,
            deleteEnabled = _this$props.deleteEnabled,
            label = _this$props.label,
            tooltipEnabled = _this$props.tooltipEnabled,
            useHighContrast = _this$props.useHighContrast,
            position = _this$props.position,
            role = _this$props.role,
            name = _this$props.name;

        return react_default.a.createElement(
          'div',
          null,
          label && react_default.a.createElement(
            'h6',
            { className: classnames_default()(form_default.a.label, flagList_default.a.flaglabel) },
            label
          ),
          react_default.a.createElement(
            'div',
            { className: flagList_default.a.flagcontainer },
            flags.map(function (flag) {
              var _cx;

              /** Classes in the scss defined by the flag name.*/
              var flagClass = changeToClassName(flag.name);
              /**
               * Might want to change this to a switch case with some ternary
               * conditional for each case.
               */
              var tooltipStyle = void 0;
              if (flagUtils_isActionable(flag) && useHighContrast) tooltipStyle = 'tooltip-high-contrast-actionable';else if (useHighContrast && flagUtils_isActionable(flag) === false) tooltipStyle = 'tooltip-high-contrast-information';else tooltipStyle = '';
              return react_default.a.createElement(
                'div',
                {
                  key: flag.id,
                  className: classnames_default()((_cx = {}, flagList__defineProperty(_cx, flagList_default.a.actionable, flagUtils_isActionable(flag)), flagList__defineProperty(_cx, flagList_default.a[flagClass], flagUtils_isCssFlag(flag) || flag.name === 'Pro Direct'), flagList__defineProperty(_cx, flagList_default.a.priorityCustomer, flag.name === 'Priority Customer'), _cx), flagList_default.a.flag)
                },
                react_default.a.createElement(
                  'button',
                  {
                    className: classnames_default()(flagList_default.a.flagtext, flagList__defineProperty({}, flagList_default.a.navigable, flag.name === 'Welcome Call Needed' && _this.props.onFlagNavigate || flag.name === constants["_53" /* VERIFY_BUILD_DATE_FLAG */])),
                    'data-tip': true,
                    'data-for': 'flag' + flag.id,
                    onClick: function onClick() {
                      return _this.handleClick(flag, 'view');
                    }
                  },
                  flag.due_at && react_default.a.createElement(font_icon_default.a, {
                    className: 'notification',
                    value: 'notifications_active'
                  }),
                  flag.name
                ),
                tooltipEnabled && react_default.a.createElement(
                  react_responsive_default.a,
                  { minWidth: MINIMUM_WIDTH },
                  react_default.a.createElement(
                    react_tooltip_dist_default.a,
                    {
                      id: 'flag' + flag.id,
                      className: tooltip_default.a[tooltipStyle],
                      place: 'top',
                      effect: 'solid'
                    },
                    react_default.a.createElement(
                      'span',
                      { className: flagList_default.a.tooltipFlagNote },
                      flagList_flagTooltipText(flag)
                    ),
                    react_default.a.createElement(
                      'p',
                      null,
                      flag.user_name + ' on ' + Object(dateUtils["l" /* getMinLocalDate */])(flag.created_at)
                    )
                  )
                ),
                deleteEnabled && _this.isValidPosition(flag.name, position, role, name) && react_default.a.createElement(font_icon_default.a, {
                  value: 'close',
                  className: flagList_default.a.close,
                  onClick: function onClick() {
                    return _this.handleClick(flag, 'remove');
                  }
                })
              );
            })
          ),
          react_default.a.createElement(removeFlagModal, {
            active: _this.state.activeModal === 'remove',
            onClose: _this.handleClose,
            flag: _this.state.activeFlag
          }),
          react_default.a.createElement(viewFlagModal, {
            active: _this.state.activeModal === 'view',
            onClose: _this.handleClose,
            onRemove: _this.renderRemoveFlagModal,
            flag: _this.state.activeFlag,
            flagTooltipText: flagList_flagTooltipText,
            deleteEnabled: deleteEnabled && (!_this.state.activeFlag || _this.isValidPosition(_this.state.activeFlag.name, position, role, name))
          }),
          react_default.a.createElement(verifyBuildDateModal, {
            active: _this.state.activeModal === 'verifyBuildDate',
            onClose: _this.handleClose,
            flag: _this.state.activeFlag
          })
        );
      }
    });

    _this.handleClose = _this.handleClose.bind(_this);
    _this.renderRemoveFlagModal = _this.renderRemoveFlagModal.bind(_this);
    _this.state = flagList_DEFAULT_STATE;
    return _this;
  }

  return FlagList;
}(react_default.a.Component);

flagList_FlagList.propTypes = {
  flags: prop_types_default.a.array.isRequired,
  tooltipEnabled: prop_types_default.a.bool.isRequired,
  deleteEnabled: prop_types_default.a.bool.isRequired,
  label: prop_types_default.a.string,
  useHighContrast: prop_types_default.a.bool,
  role: prop_types_default.a.string,
  position: prop_types_default.a.string,
  name: prop_types_default.a.string,
  onFlagNavigate: prop_types_default.a.func
};

flagList_FlagList.defaultProps = {
  flags: [],
  deleteEnabled: false,
  tooltipEnabled: true
};

var flagList_mapStateToProps = function mapStateToProps(state) {
  var useHighContrast = state.settings.useHighContrast,
      _state$user = state.user,
      role = _state$user.role,
      position = _state$user.position,
      name = _state$user.name;

  return { useHighContrast: useHighContrast, role: role, position: position, name: name };
};

/* harmony default export */ var components_flagList = (Object(react_redux_es["connect"])(flagList_mapStateToProps)(flagList_FlagList));
// EXTERNAL MODULE: ./client/app/screens/main/screens/phases/phaseList/components/phaseCard/phaseCard.scss
var phaseCard = __webpack_require__("DB9+");
var phaseCard_default = /*#__PURE__*/__webpack_require__.n(phaseCard);

// EXTERNAL MODULE: ./client/app/assets/images/rf1.jpg
var rf1 = __webpack_require__("1CXG");
var rf1_default = /*#__PURE__*/__webpack_require__.n(rf1);

// EXTERNAL MODULE: ./client/app/assets/images/pf1.png
var pf1 = __webpack_require__("/Blj");
var pf1_default = /*#__PURE__*/__webpack_require__.n(pf1);

// EXTERNAL MODULE: ./client/app/assets/images/fd1.png
var fd1 = __webpack_require__("+uOv");
var fd1_default = /*#__PURE__*/__webpack_require__.n(fd1);

// EXTERNAL MODULE: ./client/app/assets/images/ifi1.png
var ifi1 = __webpack_require__("qN56");
var ifi1_default = /*#__PURE__*/__webpack_require__.n(ifi1);

// EXTERNAL MODULE: ./client/app/assets/images/ah1.png
var ah1 = __webpack_require__("8tYY");
var ah1_default = /*#__PURE__*/__webpack_require__.n(ah1);

// EXTERNAL MODULE: ./client/app/assets/images/lhi1.png
var lhi1 = __webpack_require__("rVfS");
var lhi1_default = /*#__PURE__*/__webpack_require__.n(lhi1);

// EXTERNAL MODULE: ./client/app/assets/images/bj1.png
var bj1 = __webpack_require__("F6G/");
var bj1_default = /*#__PURE__*/__webpack_require__.n(bj1);

// EXTERNAL MODULE: ./client/app/assets/images/sam1.png
var sam1 = __webpack_require__("jq96");
var sam1_default = /*#__PURE__*/__webpack_require__.n(sam1);

// EXTERNAL MODULE: ./client/app/assets/images/way1.png
var way1 = __webpack_require__("SfFG");
var way1_default = /*#__PURE__*/__webpack_require__.n(way1);

// CONCATENATED MODULE: ./client/app/shared/components/VendorLogo/index.jsx













var IMAGES = { rf: rf1_default.a, pft: pf1_default.a, fd: fd1_default.a, ifi: ifi1_default.a, ah: ah1_default.a, lhi: lhi1_default.a, bj: bj1_default.a, sam: sam1_default.a, way: way1_default.a };

var VendorLogo_VendorLogo = function VendorLogo(_ref) {
  var workroomName = _ref.workroomName,
      source = _ref.source,
      styling = _ref.styling,
      classMap = _ref.classMap;

  var vendor = source;
  if (workroomName && workroomName.includes('PFT-')) vendor = 'PFT';else if (!constants["f" /* ALL_SOURCES */].includes(vendor)) return null;else if (constants["V" /* LHI_SOURCES */].includes(vendor)) vendor = 'LHI';
  var lowerCaseVendor = vendor.toLowerCase();
  var imgSrc = IMAGES[lowerCaseVendor];
  if (!imgSrc) return null;
  var resolvedClass = classMap ? classMap[lowerCaseVendor + 'Img'] : styling;
  return react_default.a.createElement('img', { src: imgSrc, alt: vendor, className: resolvedClass });
};

VendorLogo_VendorLogo.propTypes = {
  workroomName: prop_types_default.a.string,
  source: prop_types_default.a.string,
  styling: prop_types_default.a.string,
  classMap: prop_types_default.a.object
};

VendorLogo_VendorLogo.defaultProps = {
  workroomName: '',
  source: '',
  styling: '',
  classMap: null
};

/* harmony default export */ var components_VendorLogo = (VendorLogo_VendorLogo);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseList/components/phaseCard/components/desktopPhaseCard.jsx
function desktopPhaseCard__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function desktopPhaseCard__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function desktopPhaseCard__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable jsx-a11y/no-static-element-interactions */





















var desktopPhaseCard_DesktopPhaseCard = function (_Component) {
  desktopPhaseCard__inherits(DesktopPhaseCard, _Component);

  function DesktopPhaseCard() {
    var _ref;

    var _temp, _this, _ret;

    desktopPhaseCard__classCallCheck(this, DesktopPhaseCard);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = desktopPhaseCard__possibleConstructorReturn(this, (_ref = DesktopPhaseCard.__proto__ || Object.getPrototypeOf(DesktopPhaseCard)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'onMouseDown', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        _this.startX = e.clientX;
        _this.startY = e.clientY;
        _this.distance = 0;
        _this.dragging = true;
      }
    }), Object.defineProperty(_this, 'onMouseMove', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        if (!_this.dragging) return;
        _this.distance = Math.sqrt(Math.pow(_this.startY - e.clientY, 2) + Math.pow(_this.startX - e.clientX, 2));
      }
    }), Object.defineProperty(_this, 'onMouseUp', {
      enumerable: true,
      writable: true,
      value: function value() {
        if (!_this.dragging) return;
        _this.dragging = false;
        _this.startX = 0;
        _this.startY = 0;
        if (_this.distance > 5) return;
        window.open(urls.phase(_this.props.phase), '_blank');
      }
    }), Object.defineProperty(_this, 'determineCanCcsSchedule', {
      enumerable: true,
      writable: true,
      value: function value(type, workroomSchedulable, phaseSchedulable, surfaceName) {
        return surfaceName !== 'Pro Direct' && (type === 'Assessment' || phaseSchedulable && type === 'Installation' && workroomSchedulable);
      }
    }), Object.defineProperty(_this, 'dragging', {
      enumerable: true,
      writable: true,
      value: false
    }), Object.defineProperty(_this, 'distance', {
      enumerable: true,
      writable: true,
      value: 0
    }), Object.defineProperty(_this, 'startX', {
      enumerable: true,
      writable: true,
      value: 0
    }), Object.defineProperty(_this, 'startY', {
      enumerable: true,
      writable: true,
      value: 0
    }), Object.defineProperty(_this, 'displayAssignedTo', {
      enumerable: true,
      writable: true,
      value: function value() {
        var appointment = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var _this$props$phase = _this.props.phase,
            type = _this$props$phase.type,
            _this$props$phase$ass = _this$props$phase.assigned_estimator_name,
            assigned_estimator_name = _this$props$phase$ass === undefined ? null : _this$props$phase$ass,
            _this$props$phase$ass2 = _this$props$phase.assigned_installer_name,
            assigned_installer_name = _this$props$phase$ass2 === undefined ? null : _this$props$phase$ass2;

        if (appointment) return appointment.assignee;
        if (type === 'Assessment') {
          var names = [assigned_estimator_name, assigned_installer_name].filter(Boolean);
          return names.length ? names.join(', ') : '--';
        }
        return assigned_installer_name || '--';
      }
    }), Object.defineProperty(_this, 'renderAppointmentDetails', {
      enumerable: true,
      writable: true,
      value: function value(appt, phase) {
        var zone = phase.workroom.timezone.includes('Central') ? ' CST ' : ' EST ';
        return react_default.a.createElement(
          'span',
          { key: appt.id },
          moment_default()(appt.start_date).format('MM/DD/YY'),
          appt.end_date !== appt.start_date && '-' + moment_default()(appt.end_date).format('MM/DD/YY'),
          ' ',
          moment_default()(appt.arrival_start_time, 'HH:mm').format('h:mma'),
          '-',
          moment_default()(appt.arrival_end_time, 'HH:mm').format('h:mma'),
          zone,
          appt.kind !== phase.type.toLowerCase() && !(appt.kind === 'repair' && phase.type === 'Workorder') && '(' + Object(utils["B" /* titleize */])(appt.kind) + ')'
        );
      }
    }), Object.defineProperty(_this, 'renderCcsSchedulable', {
      enumerable: true,
      writable: true,
      value: function value(type) {
        return react_default.a.createElement(
          'div',
          null,
          type,
          ' ',
          react_default.a.createElement(
            'span',
            { style: { color: 'red' } },
            'CCS Schedulable'
          )
        );
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            role = _this$props.role,
            surfaceName = _this$props.surfaceName,
            storeInfo = _this$props.storeInfo,
            cardColorCode = _this$props.cardColorCode,
            motColorCode = _this$props.motColorCode,
            motTitle = _this$props.motTitle,
            mot = _this$props.mot,
            phase = _this$props.phase,
            _this$props$phase2 = _this$props.phase,
            _this$props$phase2$ap = _this$props$phase2.appointments,
            appointments = _this$props$phase2$ap === undefined ? [] : _this$props$phase2$ap,
            _this$props$phase2$fl = _this$props$phase2.flags,
            phaseFlags = _this$props$phase2$fl === undefined ? [] : _this$props$phase2$fl,
            _this$props$phase2$co = _this$props$phase2.contractor_notes,
            contractor_notes = _this$props$phase2$co === undefined ? '' : _this$props$phase2$co,
            _this$props$phase2$wo = _this$props$phase2.workroom,
            workroom = _this$props$phase2$wo === undefined ? null : _this$props$phase2$wo,
            _this$props$phase2$re = _this$props$phase2.recent_note,
            recent_note = _this$props$phase2$re === undefined ? null : _this$props$phase2$re,
            _this$props$phase2$sq = _this$props$phase2.sqft,
            sqft = _this$props$phase2$sq === undefined ? null : _this$props$phase2$sq,
            _this$props$phase2$st = _this$props$phase2.store,
            store = _this$props$phase2$st === undefined ? null : _this$props$phase2$st,
            _this$props$phase2$cu = _this$props$phase2.customer_name,
            customer_name = _this$props$phase2$cu === undefined ? '' : _this$props$phase2$cu,
            _this$props$phase2$st2 = _this$props$phase2.street_address,
            street_address = _this$props$phase2$st2 === undefined ? '' : _this$props$phase2$st2,
            _this$props$phase2$ci = _this$props$phase2.city,
            city = _this$props$phase2$ci === undefined ? '' : _this$props$phase2$ci,
            _this$props$phase2$st3 = _this$props$phase2.state,
            state = _this$props$phase2$st3 === undefined ? '' : _this$props$phase2$st3,
            _this$props$phase2$zi = _this$props$phase2.zip_code,
            zip_code = _this$props$phase2$zi === undefined ? '' : _this$props$phase2$zi,
            _this$props$phase2$ph = _this$props$phase2.phone_numbers,
            phone_numbers = _this$props$phase2$ph === undefined ? [] : _this$props$phase2$ph,
            _this$props$phase2$pr = _this$props$phase2.product_type,
            product_type = _this$props$phase2$pr === undefined ? '' : _this$props$phase2$pr,
            _this$props$phase2$so = _this$props$phase2.source,
            source = _this$props$phase2$so === undefined ? '' : _this$props$phase2$so,
            _this$props$phase2$ef = _this$props$phase2.effective_due_at,
            effective_due_at = _this$props$phase2$ef === undefined ? '' : _this$props$phase2$ef,
            _this$props$phase2$du = _this$props$phase2.due_at,
            due_at = _this$props$phase2$du === undefined ? '' : _this$props$phase2$du,
            _this$props$phase2$ty = _this$props$phase2.type,
            type = _this$props$phase2$ty === undefined ? '' : _this$props$phase2$ty,
            _this$props$phase2$st4 = _this$props$phase2.status_name,
            status_name = _this$props$phase2$st4 === undefined ? '' : _this$props$phase2$st4,
            _this$props$phase2$pr2 = _this$props$phase2.project_number,
            project_number = _this$props$phase2$pr2 === undefined ? '' : _this$props$phase2$pr2,
            _this$props$phase2$cc = _this$props$phase2.ccs_schedulable,
            ccs_schedulable = _this$props$phase2$cc === undefined ? null : _this$props$phase2$cc;

        var workroomName = workroom ? workroom.name : '';
        var appts = sortAppointments(appointments_momentizeAppointmentDates(appointments));
        var appointmentIsPast = false;
        var appointment = appts.find(function (appt) {
          return appt.end_moment.isSameOrAfter(moment_default()().startOf('day'));
        });
        var contractorNotes = (contractor_notes || '--').substring(0, 70);
        var flags = phaseFlags;
        var extraFlagCount = 0;
        if (flags.length > 4) {
          extraFlagCount = flags.length - 4;
          flags.splice(0, extraFlagCount);
        }
        var flagsString = flags.join('');
        if (flagsString.length > 65) {
          flags.splice(0, 1);
          extraFlagCount += 1;
        }
        var flagTitle = extraFlagCount > 0 ? 'flags (+' + extraFlagCount + ')' : 'flags';
        if (!appointment) {
          appointment = Object(lodash["last"])(appts);
          appointmentIsPast = true;
        }
        var noteTitle = recent_note ? 'Latest Note - ' + Object(dateUtils["l" /* getMinLocalDate */])(recent_note.created_at) + ' By ' + recent_note.user : 'Latest Note';
        var surfaceString = sqft ? surfaceName + ' (' + sqft + 'sqft)' : surfaceName;
        var canCcsSchedule = _this.determineCanCcsSchedule(type, store.ccs_schedulable, ccs_schedulable, surfaceName);
        var assignedTo = _this.displayAssignedTo(appointment);
        return react_default.a.createElement(
          'article',
          {
            onMouseDown: _this.onMouseDown,
            onMouseMove: _this.onMouseMove,
            onMouseUp: _this.onMouseUp,
            onClick: _this.navigate,
            className: phaseCard_default.a.phaseLink
          },
          react_default.a.createElement(
            'div',
            {
              className: classnames_default()(resourceCard_default.a.aside, phaseCard_default.a.aside, phaseCard_default.a[cardColorCode])
            },
            react_default.a.createElement(
              ResourceCardElement,
              {
                wrap: true,
                title: 'Customer',
                size: 'full',
                theme: phaseCard_default.a,
                className: phaseCard_default.a.phaseCardAside
              },
              react_default.a.createElement(
                'h5',
                { className: phaseCard_default.a.title },
                customer_name
              ),
              react_default.a.createElement(
                'p',
                { className: classnames_default()(phaseCard_default.a.customerInfo, phaseCard_default.a.customerAddress) },
                street_address,
                react_default.a.createElement('br', null),
                city,
                ', ',
                state,
                ' ',
                zip_code
              ),
              phone_numbers[0] && react_default.a.createElement(
                'p',
                { className: phaseCard_default.a.customerInfo },
                Object(utils["h" /* formatTelephone */])(phone_numbers[0].number)
              ),
              react_default.a.createElement(
                'p',
                { className: phaseCard_default.a.productType },
                product_type
              )
            ),
            react_default.a.createElement(
              'div',
              { className: phaseCard_default.a.dueDate },
              react_default.a.createElement(components_DueDate, {
                date: effective_due_at,
                showText: false,
                isPhaseDetails: false
              }),
              due_at !== effective_due_at && react_default.a.createElement(
                'span',
                null,
                react_default.a.createElement(
                  'strong',
                  null,
                  ' - Flag Due'
                )
              ),
              react_default.a.createElement(components_VendorLogo, {
                workroomName: workroomName,
                source: source,
                styling: phaseCard_default.a.vendorSourceImg
              })
            )
          ),
          react_default.a.createElement(
            'div',
            { className: phaseCard_default.a.phaseRowFlex },
            react_default.a.createElement(
              'div',
              { className: phaseCard_default.a.phaseCardColumn },
              react_default.a.createElement(
                'div',
                { className: resourceCard_default.a.column },
                react_default.a.createElement(
                  styledComponents,
                  null,
                  react_default.a.createElement(
                    ResourceCardElement,
                    {
                      title: 'Phase Type',
                      size: 'small',
                      theme: phaseCard_default.a,
                      phaseType: type
                    },
                    canCcsSchedule ? _this.renderCcsSchedulable(type) : type
                  )
                )
              ),
              react_default.a.createElement(
                'div',
                { className: resourceCard_default.a.column },
                react_default.a.createElement(ResourceCardElement, {
                  title: 'Status',
                  size: 'medium',
                  value: Object(utils["b" /* deriveStatusName */])(status_name, { source: source, workroom: workroomName }),
                  theme: phaseCard_default.a
                }),
                react_default.a.createElement(ResourceCardElement, {
                  title: 'Store #',
                  size: 'medium',
                  theme: phaseCard_default.a,
                  value: storeInfo.number
                }),
                react_default.a.createElement(ResourceCardElement, {
                  title: 'Project #',
                  size: 'medium',
                  theme: phaseCard_default.a,
                  value: project_number
                })
              ),
              react_default.a.createElement(
                'div',
                { className: resourceCard_default.a.column },
                react_default.a.createElement(ResourceCardElement, {
                  title: motTitle,
                  size: 'small',
                  value: mot,
                  className: phaseCard_default.a[motColorCode],
                  theme: phaseCard_default.a
                }),
                react_default.a.createElement(ResourceCardElement, {
                  title: 'Surface Type',
                  size: 'small',
                  value: surfaceString,
                  theme: phaseCard_default.a
                }),
                react_default.a.createElement(
                  ResourceCardElement,
                  {
                    title: 'Assigned To',
                    size: 'small',
                    theme: phaseCard_default.a
                  },
                  assignedTo
                )
              ),
              react_default.a.createElement(
                'div',
                { className: resourceCard_default.a.column },
                react_default.a.createElement(
                  ResourceCardElement,
                  {
                    wrap: true,
                    title: appointmentIsPast ? 'Last Appointment' : 'Next Appointment',
                    size: 'small',
                    theme: phaseCard_default.a
                  },
                  appointment ? _this.renderAppointmentDetails(appointment, phase) : '--'
                ),
                phase.lrrp_required && react_default.a.createElement(
                  ResourceCardElement,
                  {
                    theme: phaseCard_default.a,
                    className: phaseCard_default.a.lrrpRequired
                  },
                  'LRRP Required'
                )
              )
            ),
            react_default.a.createElement(
              'div',
              { className: phaseCard_default.a.phaseCardColumn },
              react_default.a.createElement(
                'div',
                { className: phaseCard_default.a.phaseNoteContainer },
                role !== 'installer' && react_default.a.createElement(
                  ResourceCardElement,
                  {
                    wrap: true, noFlexMobile: true,
                    title: flagTitle,
                    size: 'large',
                    theme: phaseCard_default.a,
                    className: phaseCard_default.a.flagsCard
                  },
                  react_default.a.createElement(components_flagList, { flags: flags }),
                  flags.length === 0 && '--'
                ),
                react_default.a.createElement(
                  ResourceCardElement,
                  {
                    wrap: true, noFlexMobile: true,
                    title: 'Contractor Notes',
                    size: 'large',
                    theme: phaseCard_default.a,
                    className: phaseCard_default.a.noteCard
                  },
                  contractorNotes
                ),
                react_default.a.createElement(
                  ResourceCardElement,
                  {
                    wrap: true, noFlexMobile: true,
                    title: noteTitle,
                    size: 'large',
                    theme: phaseCard_default.a,
                    className: phaseCard_default.a.noteCard
                  },
                  recent_note ? react_default.a.createElement(
                    components_UserNote,
                    null,
                    recent_note.data.note
                  ) : '--'
                )
              )
            )
          )
        );
      }
    }), _temp), desktopPhaseCard__possibleConstructorReturn(_this, _ret);
  }

  return DesktopPhaseCard;
}(react["Component"]);

desktopPhaseCard_DesktopPhaseCard.propTypes = {
  role: prop_types_default.a.string,
  position: prop_types_default.a.string,
  phase: PhaseIndexType.isRequired,
  surfaceName: prop_types_default.a.string,
  storeInfo: prop_types_default.a.shape({
    number: prop_types_default.a.string
  }),
  cardColorCode: prop_types_default.a.string.isRequired,
  motColorCode: prop_types_default.a.string.isRequired,
  motTitle: prop_types_default.a.string.isRequired,
  mot: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]).isRequired,
  navigate: prop_types_default.a.func.isRequired
};

/* harmony default export */ var desktopPhaseCard = (Object(react_redux_es["connect"])(function () {
  return {};
}, { navigate: actionCreators["O" /* navigate */] })(desktopPhaseCard_DesktopPhaseCard));
// EXTERNAL MODULE: ./client/app/screens/main/screens/phases/phaseList/components/phaseCard/components/mobilePhaseCard.scss
var mobilePhaseCard = __webpack_require__("g2ib");
var mobilePhaseCard_default = /*#__PURE__*/__webpack_require__.n(mobilePhaseCard);

// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseList/components/phaseCard/components/mobilePhaseCard.jsx














var mobilePhaseCard_MobilePhaseCard = function MobilePhaseCard(props) {
  var surfaceName = props.surfaceName,
      cardColorCode = props.cardColorCode,
      motColorCode = props.motColorCode,
      motTitle = props.motTitle,
      mot = props.mot,
      storeInfo = props.storeInfo,
      _props$phase = props.phase,
      phase = _props$phase === undefined ? {} : _props$phase,
      _props$phase2 = props.phase;
  _props$phase2 = _props$phase2 === undefined ? {} : _props$phase2;
  var customer_name = _props$phase2.customer_name,
      product_type = _props$phase2.product_type,
      effective_due_at = _props$phase2.effective_due_at,
      due_at = _props$phase2.due_at,
      type = _props$phase2.type,
      project_number = _props$phase2.project_number;


  var statusName = function statusName() {
    var _ref = phase || {},
        _ref$status_name = _ref.status_name,
        status_name = _ref$status_name === undefined ? '' : _ref$status_name,
        _ref$workroom = _ref.workroom;

    _ref$workroom = _ref$workroom === undefined ? {} : _ref$workroom;
    var _ref$workroom$name = _ref$workroom.name,
        workroom = _ref$workroom$name === undefined ? '' : _ref$workroom$name,
        _ref$source = _ref.source,
        source = _ref$source === undefined ? '' : _ref$source;

    return Object(utils["b" /* deriveStatusName */])(status_name, { source: source, workroom: workroom });
  };

  return react_default.a.createElement(
    components_RouterLink,
    {
      to: urls.phase(phase), className: phaseCard_default.a.phaseLink
    },
    react_default.a.createElement(
      'div',
      {
        className: classnames_default()(resourceCard_default.a.aside, phaseCard_default.a['aside-ss'], phaseCard_default.a[cardColorCode])
      },
      react_default.a.createElement(
        ResourceCardElement,
        {
          wrap: true,
          halfMobile: true,
          title: 'Customer',
          size: 'full',
          theme: phaseCard_default.a
        },
        react_default.a.createElement(
          'h5',
          { className: phaseCard_default.a.title },
          customer_name
        ),
        react_default.a.createElement(
          'p',
          { className: phaseCard_default.a.productType },
          product_type
        )
      ),
      react_default.a.createElement(
        'div',
        { className: phaseCard_default.a.dueDate },
        react_default.a.createElement(components_DueDate, {
          date: effective_due_at,
          showText: false,
          isPhaseDetails: false
        }),
        due_at !== effective_due_at && react_default.a.createElement(
          'span',
          null,
          react_default.a.createElement(
            'strong',
            null,
            ' - Flag Due'
          )
        )
      )
    ),
    react_default.a.createElement(
      'div',
      { className: phaseCard_default.a.phaseColumnFlex },
      react_default.a.createElement(
        'div',
        { className: resourceCard_default.a.column },
        react_default.a.createElement(
          'div',
          { className: resourceCard_default.a.mobileColumn },
          react_default.a.createElement(
            styledComponents,
            null,
            react_default.a.createElement(ResourceCardElement, {
              halfMobile: true,
              title: 'Phase Type',
              size: 'large',
              value: type,
              theme: mobilePhaseCard_default.a,
              phaseType: type
            })
          )
        ),
        react_default.a.createElement(
          'div',
          { className: resourceCard_default.a.mobileColumn },
          react_default.a.createElement(ResourceCardElement, {
            halfMobile: true,
            title: 'Status',
            size: 'large',
            value: statusName(),
            theme: mobilePhaseCard_default.a
          })
        ),
        react_default.a.createElement(
          'div',
          { className: resourceCard_default.a.mobileColumn },
          react_default.a.createElement(ResourceCardElement, {
            halfMobile: true,
            title: 'Project #',
            size: 'small',
            value: project_number,
            theme: mobilePhaseCard_default.a
          }),
          react_default.a.createElement(ResourceCardElement, {
            halfMobile: true,
            title: 'Store #',
            size: 'small',
            theme: mobilePhaseCard_default.a,
            value: storeInfo.number
          }),
          react_default.a.createElement(ResourceCardElement, {
            halfMobile: true,
            title: 'Surface Type',
            size: 'small',
            value: surfaceName,
            theme: mobilePhaseCard_default.a
          }),
          react_default.a.createElement(ResourceCardElement, {
            halfMobile: true,
            title: motTitle,
            size: 'small',
            value: mot,
            className: phaseCard_default.a[motColorCode],
            theme: mobilePhaseCard_default.a
          })
        )
      ),
      react_default.a.createElement(
        'div',
        { className: resourceCard_default.a.column },
        react_default.a.createElement(ResourceCardElement, {
          wrap: true,
          noFlexMobile: true,
          title: 'address',
          size: 'large',
          value: Object(utils["i" /* fullAddress */])(phase),
          theme: mobilePhaseCard_default.a
        })
      )
    )
  );
};

mobilePhaseCard_MobilePhaseCard.propTypes = {
  role: prop_types_default.a.string,
  phase: PhaseIndexType.isRequired,
  surfaceName: prop_types_default.a.string,
  storeInfo: prop_types_default.a.shape({
    number: prop_types_default.a.string
  }),
  cardColorCode: prop_types_default.a.string.isRequired,
  motColorCode: prop_types_default.a.string.isRequired,
  motTitle: prop_types_default.a.string.isRequired,
  mot: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]).isRequired
};

/* harmony default export */ var components_mobilePhaseCard = (mobilePhaseCard_MobilePhaseCard);
// CONCATENATED MODULE: ./client/app/utils/motUtils.js
function determineUseActualMOT(type, appointments, complete) {
  var useActualMOT = true;

  if (type !== 'Installation' || !Array.isArray(appointments) || !appointments.length || complete) {
    return useActualMOT;
  }

  appointments.forEach(function (appointment) {
    if (appointment.kind === 'installation' || appointment.kind === 'installation_hold') {
      useActualMOT = false;
    }
  });

  return useActualMOT;
}

function determineComplete(phaseStatus, phaseTasks) {
  if (phaseStatus === 'canceled' || phaseStatus === 'completed') return true;

  var complete = false;
  if (Array.isArray(phaseTasks) && phaseTasks.length) {
    phaseTasks.forEach(function (phaseTask) {
      if (['install_complete', 'workorder_complete', 'measure'].includes(phaseTask.slug) && phaseTask.status === 'complete') {
        complete = true;
      }
    });
  }
  return complete;
}

function determineMOTTitle(type, useActualMOT) {
  var complete = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var motTitle = 'Projected MOT';

  if (type !== 'Installation') {
    motTitle = 'MOT';
  } else if (complete) {
    motTitle = 'Actual MOT';
  } else if (useActualMOT) {
    motTitle = 'Current MOT';
  }

  return motTitle;
}

function determineMOTColorCode(phase, useActualMOT) {
  var complete = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var assessmentDue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

  var limit = phase.product_type === 'STK' ? 21 : 28;
  var mot = useActualMOT ? phase.actual_mot : phase.projected_mot;

  if (!mot) {
    return 'motNotApplicable';
  }

  if (useActualMOT && !complete && mot >= 3 && assessmentDue.toLowerCase() === 'assessment_due') {
    return 'motWarningAssessmentDue';
  }

  if (useActualMOT && !complete && mot >= 3) {
    return 'motWarning';
  }

  return mot <= limit ? 'motOnTime' : 'motOverdue';
}

function determineMOT(phase, useActualMOT) {
  var mot = 'N/A';

  if (useActualMOT) {
    mot = phase.actual_mot ? phase.actual_mot + ' Days' : mot;
  } else {
    mot = phase.projected_mot ? phase.projected_mot + ' Days' : mot;
  }

  return mot;
}
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseList/components/phaseCard/index.jsx
var phaseCard__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function phaseCard__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }


















var phaseCard_getCardColorCode = function getCardColorCode(phase) {
  var now = moment_default()();
  var dueAt = moment_default()(phase.effective_due_at);
  var dueAtEod = dueAt.clone().endOf('day');
  var dueToday = dueAt.isSameOrBefore(now.clone().endOf('day'));
  var hasActionable = hasActionableFlag(phase);
  if (dueToday && now.isSameOrAfter(dueAtEod)) {
    if (hasActionable) return 'red';
    return 'orange';
  }
  if (dueToday && hasActionable) return 'yellow';
  if (dueToday && now.isSameOrBefore(dueAtEod)) return 'green';
  return 'normal';
};

var isUnlinkButton = function isUnlinkButton(button) {
  return button.text === 'Unlink Phase';
};

var isMergeButton = function isMergeButton(button) {
  return button.text === 'Merge Phase';
};

var mergeUnavailable = function mergeUnavailable(source, other) {
  return [source.type, other.type].some(function (t) {
    return ['Assessment', 'Installation'].includes(t);
  });
};

var isMerged = function isMerged(source, other) {
  return source.merged_phases.includes(other.id.toString());
};

var phaseCard_PhaseCard = function PhaseCard(props) {
  var role = props.role,
      position = props.position,
      phase = props.phase,
      surfaceType = props.surfaceType,
      actionButton = props.actionButton,
      actionButton2 = props.actionButton2,
      store = props.store,
      sourcePhase = props.sourcePhase,
      otherProps = phaseCard__objectWithoutProperties(props, ['role', 'position', 'phase', 'surfaceType', 'actionButton', 'actionButton2', 'store', 'sourcePhase']);

  var surfaceName = surfaceType ? surfaceType.name : '--';
  var overdue = Object(dateUtils["p" /* isOverdue */])(phase.effective_due_at);
  var cardColorCode = phaseCard_getCardColorCode(phase);
  var complete = determineComplete(phase.status, phase.phase_tasks);
  var useActualMOT = determineUseActualMOT(phase.type, phase.appointments, complete);
  var motTitle = determineMOTTitle(phase.type, useActualMOT, complete);
  var motColorCode = determineMOTColorCode(phase, useActualMOT, complete);
  var mot = determineMOT(phase, useActualMOT);
  return react_default.a.createElement(
    components_Card,
    { key: 'phase-' + phase.id, className: resourceCard_default.a.resourceCard },
    react_default.a.createElement(
      react_responsive_default.a,
      { minWidth: constants["y" /* CUT_POINT */] },
      function (isDesktop) {
        var Component = isDesktop ? desktopPhaseCard : components_mobilePhaseCard;
        return react_default.a.createElement(Component, phaseCard__extends({
          role: role,
          position: position,
          phase: phase,
          surfaceName: surfaceName,
          overdue: overdue,
          cardColorCode: cardColorCode,
          motColorCode: motColorCode,
          motTitle: motTitle,
          mot: mot,
          storeInfo: store,
          lrrp: phase.lrrp_required
        }, otherProps));
      }
    ),
    actionButton && react_default.a.createElement(
      'div',
      {
        className: classnames_default()(phaseCard_default.a.phaseColumnFlex, phaseCard_default.a.phaseCardActionModeRight)
      },
      react_default.a.createElement(ColoredButton["a" /* default */], {
        label: actionButton.text,
        onClick: actionButton.onClick,
        hidden: isUnlinkButton(actionButton) && sourcePhase && isMerged(sourcePhase, phase)
      })
    ),
    actionButton2 && react_default.a.createElement(
      'div',
      {
        className: classnames_default()(phaseCard_default.a.phaseColumnFlex, phaseCard_default.a.phaseCardActionModeRight)
      },
      react_default.a.createElement(ColoredButton["a" /* default */], {
        label: !isMergeButton(actionButton2) || !isMerged(sourcePhase, phase) ? actionButton2.text : 'Phase Merged',
        onClick: actionButton2.onClick,
        disabled: isMergeButton(actionButton2) && sourcePhase && isMerged(sourcePhase, phase),
        hidden: isMergeButton(actionButton2) && sourcePhase && mergeUnavailable(sourcePhase, phase)
      })
    )
  );
};

phaseCard_PhaseCard.defaultProps = { actionButton2: null, actionButton: null, sourcePhase: null };

phaseCard_PhaseCard.propTypes = {
  role: prop_types_default.a.string,
  position: prop_types_default.a.string,
  phase: PhaseIndexType.isRequired,
  sourcePhase: PhaseIndexType,
  surfaceType: prop_types_default.a.shape({
    name: prop_types_default.a.string
  }),
  store: prop_types_default.a.shape({
    number: prop_types_default.a.string
  }),
  actionButton: prop_types_default.a.shape({
    text: prop_types_default.a.string,
    onClick: prop_types_default.a.func
  }),
  actionButton2: prop_types_default.a.shape({
    text: prop_types_default.a.string,
    onClick: prop_types_default.a.func
  })
};

/* harmony default export */ var components_phaseCard = (phaseCard_PhaseCard);
// EXTERNAL MODULE: ./client/app/screens/main/screens/phases/components/noResults.scss
var noResults = __webpack_require__("p/vx");
var noResults_default = /*#__PURE__*/__webpack_require__.n(noResults);

// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/components/noResults.jsx



var noResults_NoResults = function NoResults() {
  return react_default.a.createElement(
    'hgroup',
    { className: noResults_default.a.noResultsContent },
    react_default.a.createElement(
      'h1',
      { className: noResults_default.a.noResultsTitle },
      'No results to show.'
    ),
    react_default.a.createElement(
      'h2',
      { className: noResults_default.a.noResultsSubTitle },
      'Edit filter criteria to the left to see results.'
    )
  );
};
/* harmony default export */ var components_noResults = (noResults_NoResults);
// EXTERNAL MODULE: ./client/app/shared/components/InfiniteLoading/styles.scss
var InfiniteLoading_styles = __webpack_require__("q+dO");
var InfiniteLoading_styles_default = /*#__PURE__*/__webpack_require__.n(InfiniteLoading_styles);

// CONCATENATED MODULE: ./client/app/shared/components/InfiniteLoading/index.jsx



var InfiniteLoading_InfiniteLoading = function InfiniteLoading() {
  return react_default.a.createElement(
    'div',
    { className: InfiniteLoading_styles_default.a.loadingLabel },
    'Loading additional results...'
  );
};

/* harmony default export */ var components_InfiniteLoading = (InfiniteLoading_InfiniteLoading);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseList/index.jsx
var phaseList__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function phaseList__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function phaseList__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function phaseList__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function phaseList__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






























// Quick filter keys that should not trigger the PhaseFilters drawer
var QUICK_FILTER_KEYS = ['assigned_employee'];

var phaseList_PhaseList = function (_Component) {
  phaseList__inherits(PhaseList, _Component);

  function PhaseList() {
    var _ref;

    var _temp, _this, _ret;

    phaseList__classCallCheck(this, PhaseList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = phaseList__possibleConstructorReturn(this, (_ref = PhaseList.__proto__ || Object.getPrototypeOf(PhaseList)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'state', {
      enumerable: true,
      writable: true,
      value: {
        canViewInactive: Object(services["a" /* can */])(_this.props.role, 'view', 'inactive'),
        currentFilter: null,
        editing: false,
        showConfirm: false,
        savedFilterName: '',
        sidebarOpen: false,
        modalNumber: 1,
        renderExcel: false
      }
    }), Object.defineProperty(_this, 'componentWillMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            position = _this$props.position,
            employableId = _this$props.employableId,
            employableType = _this$props.employableType;

        _this.requestFilters(position, true);
        if (employableType === 'employee') _this.props.requestEmployee(employableId);
      }
    }), Object.defineProperty(_this, 'componentDidMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props2 = _this.props,
            position = _this$props2.position,
            role = _this$props2.role,
            employableType = _this$props2.employableType;

        var validSavedFilterUser = _this.isValidFilterUser(employableType, role);
        if (['employee', 'iqm'].includes(employableType)) _this.setRefreshInterval('assigned');
        if (validSavedFilterUser && !_this.restrictFilters(position)) _this.setRefreshInterval('saved');
      }
    }), Object.defineProperty(_this, 'componentWillReceiveProps', {
      enumerable: true,
      writable: true,
      value: function value(newProps) {
        var _this$props3 = _this.props,
            position = _this$props3.position,
            location = _this$props3.location,
            workrooms = _this$props3.workrooms;
        var employableType = newProps.employableType;

        if (employableType === 'employee' && position !== newProps.position) _this.requestFilters(newProps.position, false, true, true);

        // Check if workroom filters changed and clear supervisor if no IFI workroom remains
        if (newProps.location.search !== location.search) {
          // Parse both old and new filters from URL to ensure accurate comparison
          var prevFilters = _this.parseUrlFilters(location.search);
          var newFilters = _this.parseUrlFilters(newProps.location.search);

          var prevWorkroomIds = _this.parseWorkroomIds(prevFilters);
          var newWorkroomIds = _this.parseWorkroomIds(newFilters);

          // Check if we had IFI workrooms before and don't have any now
          var prevHasIfi = _this.hasIfiWorkroom(workrooms, prevWorkroomIds);
          var newHasIfi = _this.hasIfiWorkroom(newProps.workrooms, newWorkroomIds);

          if (prevHasIfi && !newHasIfi && newFilters.assigned_employee) {
            // Clear the supervisor filter
            delete newFilters.assigned_employee;
            _this.updatePathWithFilters(newFilters, 'replace');
            return;
          }

          _this.updateFilters(newProps);
        }
        if (newProps.exportPhases !== _this.props.exportPhases) {
          _this.setState({ renderExcel: true });
          if (!_this.state.showConfirm) _this.toggleModal(3);
        }
      }
    }), Object.defineProperty(_this, 'componentWillUnmount', {
      enumerable: true,
      writable: true,
      value: function value() {
        if (_this.props.ui.successMessage) _this.props.updateUI('successMessage', '');
        if (_this.refreshSavedFiltersInterval) clearInterval(_this.refreshSavedFiltersInterval);
        if (_this.refreshAssignedFiltersInterval) clearInterval(_this.refreshAssignedFiltersInterval);
      }
    }), Object.defineProperty(_this, 'onSearch', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        e.preventDefault();
        _this.updatePathWithFilters({ query: e.target.query.value.trim() || undefined });
        if (_this.state.currentFilter) _this.setState({ currentFilter: null });
      }
    }), Object.defineProperty(_this, 'onFilterChange', {
      enumerable: true,
      writable: true,
      value: function value(newFilters) {
        return _this.updatePathWithFilters(newFilters, 'replace');
      }
    }), Object.defineProperty(_this, 'onSupervisorChange', {
      enumerable: true,
      writable: true,
      value: function value(employeeId) {
        // Parse current URL params to preserve existing filters
        var currentFilters = _this.parseUrlFilters(_this.props.location.search);

        var newFilters = phaseList__extends({}, currentFilters);
        if (employeeId) {
          newFilters.assigned_employee = employeeId;
        } else {
          delete newFilters.assigned_employee;
        }

        // Clear current filter selection when using quick filter
        _this.setState({ currentFilter: null, editing: false });
        _this.updatePathWithFilters(newFilters, 'replace');
      }
    }), Object.defineProperty(_this, 'onFilterSelect', {
      enumerable: true,
      writable: true,
      value: function value(filter) {
        _this.setState({ currentFilter: filter });
        _this.updatePathWithFilters(filter.filters);
      }
    }), Object.defineProperty(_this, 'onStopEdit', {
      enumerable: true,
      writable: true,
      value: function value(filter) {
        _this.setState({ editing: false, copiedFrom: null, savedFilterName: '' });
        _this.props.clearValidationErrors('SAVED_FILTER');
        if (filter) _this.onFilterSelect(filter);else if (_this.state.currentFilter) _this.onFilterSelect(_this.state.currentFilter);else if (_this.state.copiedFrom) _this.onFilterSelect(_this.state.copiedFrom);else _this.setCurrentFilter();
      }
    }), Object.defineProperty(_this, 'setRefreshInterval', {
      enumerable: true,
      writable: true,
      value: function value(filter) {
        if (filter === 'saved') {
          _this.refreshSavedFiltersInterval = setInterval(function () {
            return _this.props.requestSavedFilters();
          }, constants["_22" /* REFRESH_INTERVAL */]);
        } else {
          _this.refreshAssignedFiltersInterval = setInterval(function () {
            return _this.props.requestAssignedFilters();
          }, constants["_22" /* REFRESH_INTERVAL */]);
        }
      }
    }), Object.defineProperty(_this, 'setCurrentFilter', {
      enumerable: true,
      writable: true,
      value: function value() {
        if (_this.state.editing) return;
        var _this$props4 = _this.props,
            position = _this$props4.position,
            savedFilters = _this$props4.savedFilters,
            assignedFilters = _this$props4.assignedFilters,
            editableFilters = _this$props4.editableFilters;

        var restricted = _this.restrictFilters(position);

        // Exclude quick filter keys when checking if we should open editing mode
        // Quick filters (assigned_employee, supervisor) should not trigger the PhaseFilters drawer
        var nonQuickFilters = _this.getNonQuickFilters(editableFilters);

        // First, check if there's a matching saved/assigned filter
        var selected = restricted ? assignedFilters.filters.find(function (filter) {
          return Object(lodash["isEqual"])(filter.filters, editableFilters);
        }) : savedFilters.filters.find(function (filter) {
          return Object(lodash["isEqual"])(filter.filters, editableFilters);
        }) || assignedFilters.filters.find(function (filter) {
          return Object(lodash["isEqual"])(filter.filters, editableFilters);
        });

        if (selected) {
          _this.setState({ currentFilter: selected, editing: false });
          return;
        }

        // Don't open drawer if only quick filters are present (and no matching saved filter)
        if (!nonQuickFilters.length) {
          _this.setState({ currentFilter: null, editing: false });
          return;
        }

        // Open drawer if there are non-quick filters (user can create a new saved filter)
        _this.setState({ editing: true });
      }
    }), Object.defineProperty(_this, 'getNonQuickFilters', {
      enumerable: true,
      writable: true,
      value: function value(editableFilters) {
        return Object.keys(editableFilters).filter(function (key) {
          return !QUICK_FILTER_KEYS.includes(key);
        });
      }
    }), Object.defineProperty(_this, 'isValidFilterUser', {
      enumerable: true,
      writable: true,
      value: function value(employableType, role) {
        if (employableType === 'employee' || ['installer', 'estimator'].includes(role.toLowerCase())) return true;
        return false;
      }
    }), Object.defineProperty(_this, 'restrictFilters', {
      enumerable: true,
      writable: true,
      value: function value(position) {
        return constants["_29" /* RESTRICTED_FILTER_POSITIONS */].includes(position);
      }
    }), Object.defineProperty(_this, 'requestFilters', {
      enumerable: true,
      writable: true,
      value: function value(position) {
        var onWillMount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var setSavedRefresh = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var setAssignedRefresh = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        var _this$props5 = _this.props,
            savedFilters = _this$props5.savedFilters,
            assignedFilters = _this$props5.assignedFilters;

        var restricted = _this.restrictFilters(position);
        var loadedCondition = restricted ? assignedFilters.loaded : savedFilters.loaded && assignedFilters.loaded;
        if (setAssignedRefresh) _this.setRefreshInterval('assigned');
        if (setSavedRefresh && !restricted) _this.setRefreshInterval('saved');
        if (loadedCondition) {
          _this.initialLoad();
          if (!restricted || onWillMount) _this.props.requestSavedFilters();
          _this.props.requestAssignedFilters();
        } else if (!onWillMount && restricted) {
          Promise.all([_this.props.requestAssignedFilters()]).then(function () {
            return _this.initialLoad();
          });
        } else {
          Promise.all([_this.props.requestSavedFilters(), _this.props.requestAssignedFilters()]).then(function () {
            return _this.initialLoad();
          });
        }
      }
    }), Object.defineProperty(_this, 'IGNORE_LOCATION_FILTERS', {
      enumerable: true,
      writable: true,
      value: window.ignoreLocationFilters || false
    }), Object.defineProperty(_this, 'canAccessSupervisorFilter', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props6 = _this.props,
            manageVendorWorkrooms = _this$props6.manageVendorWorkrooms,
            role = _this$props6.role,
            position = _this$props6.position,
            workrooms = _this$props6.workrooms,
            phaseFiltersLocation = _this$props6.phaseFiltersLocation;

        // Must have at least one IFI workroom selected

        var selectedWorkroomIds = phaseFiltersLocation && phaseFiltersLocation.workroom || [];
        if (!_this.hasIfiWorkroom(workrooms, selectedWorkroomIds)) {
          return false;
        }

        // Check supervisor filter access using ability.js
        return Object(services["a" /* can */])(role, 'view', 'supervisor_filter', {
          manageVendorWorkrooms: manageVendorWorkrooms || {},
          position: position || ''
        });
      }
    }), Object.defineProperty(_this, 'hasIfiWorkroom', {
      enumerable: true,
      writable: true,
      value: function value(workrooms, workroomIds) {
        return workrooms && workroomIds.length > 0 && workrooms.some(function (w) {
          return w.vendor === 'IFI' && workroomIds.includes(w.id);
        });
      }
    }), Object.defineProperty(_this, 'parseUrlFilters', {
      enumerable: true,
      writable: true,
      value: function value(search) {
        return search ? qs_lib_default.a.parse(search.slice(1), { arrayLimit: 1000 }) : {};
      }
    }), Object.defineProperty(_this, 'parseWorkroomIds', {
      enumerable: true,
      writable: true,
      value: function value(filters) {
        return (filters.workroom || []).map(function (id) {
          return parseInt(id, 10);
        });
      }
    }), Object.defineProperty(_this, 'initialLoad', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props7 = _this.props,
            position = _this$props7.position,
            savedFilters = _this$props7.savedFilters,
            assignedFilters = _this$props7.assignedFilters,
            location = _this$props7.location;

        var restricted = _this.restrictFilters(position);
        var filterLengthCondition = restricted ? !assignedFilters.filters.length : !(savedFilters.filters.length || assignedFilters.filters.length);
        if (filterLengthCondition) {
          return _this.updateFilters(_this.props);
        } else if (location.search) {
          _this.setCurrentFilter();
          return _this.updateFilters(_this.props);
        } else if (assignedFilters.filters.length || restricted) {
          _this.setState({ currentFilter: assignedFilters.filters[0] });
          return _this.onFilterChange(assignedFilters.filters[0].filters);
        }
        _this.setState({ currentFilter: savedFilters.filters[0] });
        return _this.onFilterChange(savedFilters.filters[0].filters);
      }
    }), Object.defineProperty(_this, 'updatePathWithFilters', {
      enumerable: true,
      writable: true,
      value: function value(newFilters) {
        var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'navigate';
        return _this.props[method](urls.phases({ query: newFilters }));
      }
    }), Object.defineProperty(_this, 'updateFilters', {
      enumerable: true,
      writable: true,
      value: function value() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;
        var call = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        var promise = null;
        if (!props.location.search) {
          if (!_this.state.editing) _this.setState({ currentFilter: null });
          promise = _this.props.resetPhasePagination({});
        } else {
          var filterObject = _this.parseUrlFilters(props.location.search);
          ['workroom', 'store', 'region', 'surface_type', 'estimator'].forEach(function (prop) {
            if (filterObject[prop]) filterObject[prop] = filterObject[prop].map(function (id) {
              return parseInt(id, 10);
            });
          });
          if (filterObject.assigned_employee) {
            filterObject.assigned_employee = parseInt(filterObject.assigned_employee, 10);
          }
          promise = _this.props.resetPhasePagination(filterObject);
        }
        _this.setState({ sidebarOpen: false });
        if (call) {
          promise = _this.props.requestPhaseList(_this.IGNORE_LOCATION_FILTERS).then(_this.setCurrentFilter);
        }
        return promise || Promise.resolve();
      }
    }), Object.defineProperty(_this, 'addAction', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.navigate(urls.createPhase());
      }
    }), Object.defineProperty(_this, 'viewAction', {
      enumerable: true,
      writable: true,
      value: function value(id) {
        return _this.props.navigate(urls.phase({ id: id }));
      }
    }), Object.defineProperty(_this, 'newFilter', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.props.navigate(urls.phases());
        _this.setState({ currentFilter: null }, _this.editFilter);
      }
    }), Object.defineProperty(_this, 'toggleFilters', {
      enumerable: true,
      writable: true,
      value: Object(lodash["memoize"])(function (isDesktop) {
        return function () {
          if (_this.state.editing) _this.onStopEdit();else if (isDesktop) _this.newFilter();else _this.toggleMobileSidebar();
        };
      })
    }), Object.defineProperty(_this, 'toggleMobileSidebar', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ sidebarOpen: !_this.state.sidebarOpen });
      }
    }), Object.defineProperty(_this, 'deleteFilter', {
      enumerable: true,
      writable: true,
      value: function value() {
        var currentFilter = _this.state.currentFilter;

        if (currentFilter.type !== 'saved') return;
        _this.props.deleteSavedFilter(currentFilter.id).then(function () {
          _this.setState({ currentFilter: null, editing: false, showConfirm: false });
          _this.updatePathWithFilters({});
        });
      }
    }), Object.defineProperty(_this, 'handleFilterName', {
      enumerable: true,
      writable: true,
      value: function value(_value) {
        return _this.setState({ savedFilterName: _value });
      }
    }), Object.defineProperty(_this, 'copyFilter', {
      enumerable: true,
      writable: true,
      value: function value() {
        var copiedFrom = _this.state.currentFilter;
        _this.setState({ editing: true, copiedFrom: copiedFrom, currentFilter: null, savedFilterName: '' });
      }
    }), Object.defineProperty(_this, 'editFilter', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({
          editing: true, savedFilterName: _this.state.currentFilter ? _this.state.currentFilter.name : ''
        });
      }
    }), Object.defineProperty(_this, 'handleInfiniteLoad', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.needsMore && _this.props.savedFilters.loaded ? _this.props.requestPhaseList(_this.IGNORE_LOCATION_FILTERS) : null;
      }
    }), Object.defineProperty(_this, 'toggleModal', {
      enumerable: true,
      writable: true,
      value: function value(modalNumber) {
        return _this.setState({ showConfirm: !_this.state.showConfirm, modalNumber: modalNumber });
      }
    }), Object.defineProperty(_this, 'fetchExportPhases', {
      enumerable: true,
      writable: true,
      value: function value(page) {
        var pageNumber = 1;
        var n = parseInt(page, 10);
        if (n) pageNumber = n;
        _this.props.requestPhasesForExport(pageNumber);
        _this.toggleModal(3);
      }
    }), Object.defineProperty(_this, 'unmountExcelSheet', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ renderExcel: false });
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _cx;

        var _this$props8 = _this.props,
            phases = _this$props8.phases,
            exportPhases = _this$props8.exportPhases,
            role = _this$props8.role,
            position = _this$props8.position,
            employableType = _this$props8.employableType,
            needsMore = _this$props8.needsMore,
            loading = _this$props8.loading,
            editableFilters = _this$props8.editableFilters,
            filters = _this$props8.filters,
            totalCount = _this$props8.total_count;
        var _this$state = _this.state,
            editing = _this$state.editing,
            currentFilter = _this$state.currentFilter,
            showConfirm = _this$state.showConfirm,
            sidebarOpen = _this$state.sidebarOpen,
            modalNumber = _this$state.modalNumber,
            renderExcel = _this$state.renderExcel;

        var UI = _this.props.ui;
        var contentSidebar = classnames_default()((_cx = {}, phaseList__defineProperty(_cx, contentArea_default.a.contentSidebar, true), phaseList__defineProperty(_cx, contentArea_default.a.contentSidebarEditing, _this.state.editing), _cx));
        var hidePhaseFilters = !_this.isValidFilterUser(employableType, role) || _this.restrictFilters(position);
        var phaseList = phases.map(function (phase) {
          return react_default.a.createElement(components_phaseCard, {
            key: 'phase-' + phase.id,
            role: role,
            position: position,
            phase: phase,
            onSelect: _this.viewAction,
            surfaceType: phase.surface_type,
            store: phase.store
          });
        });
        if (!phaseList.length && !loading) phaseList = react_default.a.createElement(components_noResults, null);
        // Exclude quick filters when determining if we should show "New Filter"
        var nonQuickFilters = _this.getNonQuickFilters(editableFilters);
        var title = nonQuickFilters.length ? 'New Filter' : 'All Phases';
        if (filters && filters.query) title = 'Search Results';
        if (currentFilter) title = currentFilter.name;
        var isSavedCurrent = currentFilter && currentFilter.type === 'saved';
        return react_default.a.createElement(
          react_responsive_default.a,
          { minWidth: constants["y" /* CUT_POINT */] },
          function (isDesktop) {
            return react_default.a.createElement(
              'div',
              null,
              react_default.a.createElement(components_PageActionBar, {
                resource: 'phase',
                role: role,
                hidesAddOnMobile: true,
                addAction: _this.addAction,
                showFiltersBtn: !_this.IGNORE_LOCATION_FILTERS,
                userRestrictedFilters: isDesktop && hidePhaseFilters,
                toggleFilters: _this.toggleFilters(isDesktop),
                title: isDesktop ? 'Phase List' : title,
                banner: _this.IGNORE_LOCATION_FILTERS ? '(This window ignores location filters)' : '',
                searchText: isDesktop ? 'Search by customer name, PO number, project number, address, phone...' : 'Search Phases',
                searchValue: _this.props.filters.query,
                onSearch: _this.onSearch
              }),
              react_default.a.createElement(
                'div',
                { className: contentArea_default.a.containerWithSidebar },
                UI.successMessage && react_default.a.createElement(MessageBox["a" /* default */], { message: UI.successMessage }),
                isDesktop && react_default.a.createElement(
                  'div',
                  { className: contentArea_default.a.contentWithSidebar },
                  react_default.a.createElement(
                    'aside',
                    { className: contentSidebar },
                    !hidePhaseFilters && editing && react_default.a.createElement(components_PhaseFilters, {
                      filters: editableFilters,
                      onFilterChange: _this.onFilterChange,
                      savedFilterName: _this.state.savedFilterName,
                      onStopEdit: _this.onStopEdit,
                      currentFilter: currentFilter,
                      handleFilterName: _this.handleFilterName
                    }),
                    (!editing || hidePhaseFilters) && react_default.a.createElement(components_SavedFiltersList, {
                      selected: currentFilter,
                      onFilterSelect: _this.onFilterSelect,
                      ignoreLocationFilters: _this.IGNORE_LOCATION_FILTERS,
                      hideSaved: hidePhaseFilters,
                      role: role,
                      filters: filters,
                      onSupervisorChange: _this.onSupervisorChange,
                      canAccessSupervisorFilter: _this.canAccessSupervisorFilter()
                    })
                  ),
                  react_default.a.createElement(
                    'div',
                    { className: contentArea_default.a.contentAreaWrapper },
                    react_default.a.createElement(
                      'div',
                      { className: contentArea_default.a.contentArea },
                      react_default.a.createElement(components_PhaseListHeader, {
                        currentFilter: currentFilter,
                        deleteFilter: isSavedCurrent ? _this.deleteFilter : undefined,
                        editFilter: isSavedCurrent ? _this.editFilter : undefined,
                        copyFilter: isSavedCurrent ? _this.copyFilter : undefined,
                        toggleModal: _this.toggleModal,
                        modalNumber: modalNumber,
                        renderExcel: renderExcel,
                        onProceed: _this.fetchExportPhases,
                        unmountExcelSheet: _this.unmountExcelSheet,
                        handleEditStatus: _this.handleEditStatus,
                        showConfirm: showConfirm,
                        title: title,
                        loading: loading,
                        totalCount: totalCount,
                        phases: exportPhases || []
                      }),
                      modalNumber === 3 ? react_default.a.createElement(ConfirmDialog["a" /* default */], {
                        theActions: ['OK'],
                        title: 'Fetching export data from server...',
                        confirmation: 'This may take a minute...',
                        show: !showConfirm,
                        dismiss: function dismiss() {
                          return _this.toggleModal(3);
                        },
                        proceed: function proceed() {
                          return _this.toggleModal(3);
                        }
                      }) : null,
                      react_default.a.createElement(
                        react_infinite_default.a,
                        {
                          useWindowAsScrollContainer: true,
                          elementHeight: 163,
                          infiniteLoadBeginEdgeOffset: 0,
                          onInfiniteLoad: _this.handleInfiniteLoad,
                          isInfiniteLoading: loading
                        },
                        phaseList
                      ),
                      needsMore && react_default.a.createElement(components_InfiniteLoading, null)
                    )
                  )
                ),
                !isDesktop && react_default.a.createElement(
                  'div',
                  null,
                  react_default.a.createElement(
                    react_toolbox_lib["Drawer"],
                    { active: sidebarOpen, onOverlayClick: _this.toggleMobileSidebar },
                    react_default.a.createElement(components_SavedFiltersList, {
                      selected: currentFilter,
                      onFilterSelect: _this.onFilterSelect,
                      ignoreLocationFilters: _this.IGNORE_LOCATION_FILTERS,
                      hideSaved: hidePhaseFilters,
                      role: role
                    })
                  ),
                  react_default.a.createElement(
                    react_infinite_default.a,
                    {
                      useWindowAsScrollContainer: true,
                      elementHeight: 305,
                      infiniteLoadBeginEdgeOffset: 0,
                      onInfiniteLoad: _this.handleInfiniteLoad,
                      isInfiniteLoading: loading
                    },
                    phaseList
                  ),
                  needsMore && react_default.a.createElement(components_InfiniteLoading, null)
                )
              )
            );
          }
        );
      }
    }), _temp), phaseList__possibleConstructorReturn(_this, _ret);
  }

  return PhaseList;
}(react["Component"]);

phaseList_PhaseList.propTypes = {
  phases: prop_types_default.a.arrayOf(PhaseIndexType).isRequired,
  exportPhases: prop_types_default.a.array,
  total_count: prop_types_default.a.number.isRequired,
  filters: prop_types_default.a.shape({
    query: prop_types_default.a.string
  }),
  editableFilters: prop_types_default.a.object,
  savedFilters: prop_types_default.a.shape({
    loaded: prop_types_default.a.bool.isRequired,
    filters: prop_types_default.a.array.isRequired
  }).isRequired,
  assignedFilters: prop_types_default.a.shape({
    loaded: prop_types_default.a.bool.isRequired,
    filters: prop_types_default.a.array.isRequired
  }).isRequired,
  needsMore: prop_types_default.a.bool,
  role: prop_types_default.a.string,
  employableId: prop_types_default.a.number,
  employableType: prop_types_default.a.string,
  position: prop_types_default.a.string,
  manageVendorWorkrooms: prop_types_default.a.shape({
    ifi: prop_types_default.a.oneOfType([prop_types_default.a.bool, prop_types_default.a.string])
  }),
  workrooms: prop_types_default.a.arrayOf(prop_types_default.a.shape({
    id: prop_types_default.a.number.isRequired,
    vendor: prop_types_default.a.string
  })),
  phaseFiltersLocation: prop_types_default.a.shape({
    workroom: prop_types_default.a.arrayOf(prop_types_default.a.number),
    region: prop_types_default.a.arrayOf(prop_types_default.a.number)
  }),
  loading: prop_types_default.a.bool,
  ui: prop_types_default.a.shape({
    successMessage: prop_types_default.a.string
  }),
  updateUI: prop_types_default.a.func,
  resetPhasePagination: prop_types_default.a.func.isRequired,
  requestPhaseList: prop_types_default.a.func.isRequired,
  requestPhasesForExport: prop_types_default.a.func.isRequired,
  requestSavedFilters: prop_types_default.a.func.isRequired,
  requestAssignedFilters: prop_types_default.a.func.isRequired,
  requestEmployee: prop_types_default.a.func.isRequired,
  deleteSavedFilter: prop_types_default.a.func.isRequired,
  clearValidationErrors: prop_types_default.a.func.isRequired,
  navigate: prop_types_default.a.func.isRequired,
  replace: prop_types_default.a.func.isRequired,
  location: prop_types_default.a.shape({
    search: prop_types_default.a.string.isRequired
  }).isRequired
};

var getEditableFilters = Object(reselect_lib["createSelector"])(reducers["_1" /* getPhaseFiltersData */], function (filters) {
  return Object(lodash["omit"])(filters, ['query']);
});

var phaseList_mapStateToProps = function mapStateToProps(state) {
  var employableType = Object(reducers["h" /* getEmployableType */])(state).toLowerCase();
  var employableId = Object(reducers["g" /* getEmployableId */])(state);
  return {
    phases: state.phases.results,
    exportPhases: state.phases.exportResults,
    total_count: state.phases.pagination.total_count,
    filters: state.phases.filters.data,
    editableFilters: getEditableFilters(state),
    phaseFiltersLocation: Object(reducers["_2" /* getPhaseFiltersLocation */])(state),
    savedFilters: state.savedFilters,
    assignedFilters: state.assignedFilters,
    needsMore: Object(reducers["_5" /* getPhaseHasNextPage */])(state),
    loading: Object(reducers["_7" /* getPhasesLoading */])(state),
    role: Object(reducers["_12" /* getRole */])(state),
    position: Object(reducers["_8" /* getPosition */])(state),
    manageVendorWorkrooms: Object(reducers["N" /* getManageVendorWorkrooms */])(state),
    workrooms: Object(reducers["_37" /* getWorkroomList */])(state),
    employableType: employableType,
    employableId: employableId
  };
};

/* harmony default export */ var phases_phaseList = (transpiled_default()()(Object(react_redux_es["connect"])(phaseList_mapStateToProps, {
  resetPhasePagination: actionCreators["_38" /* resetPhasePagination */],
  requestPhaseList: actionCreators["_18" /* requestPhaseList */],
  requestPhasesForExport: actionCreators["_19" /* requestPhasesForExport */],
  requestSavedFilters: actionCreators["_23" /* requestSavedFilters */],
  requestAssignedFilters: actionCreators["V" /* requestAssignedFilters */],
  requestEmployee: actionCreators["X" /* requestEmployee */],
  navigate: actionCreators["O" /* navigate */],
  deleteSavedFilter: actionCreators["y" /* deleteSavedFilter */],
  clearValidationErrors: actionCreators["k" /* clearValidationErrors */],
  replace: react_router_redux_lib["replace"]
})(phaseList_PhaseList)));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseEdit/components/phaseBasicInfoForm.jsx
function phaseBasicInfoForm__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function phaseBasicInfoForm__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function phaseBasicInfoForm__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var phaseBasicInfoForm_STATES_SOURCE = constants["_35" /* STATES */].map(function (state) {
  return { value: state, label: state };
});
var phaseBasicInfoForm_largeInput = classnames_default()(form_default.a.inputs, form_default.a.largeInput);
var phaseBasicInfoForm_mediumInput = classnames_default()(form_default.a.inputs, form_default.a.mediumInput);
var phaseBasicInfoForm_smallInput = classnames_default()(form_default.a.inputs, form_default.a.smallInput);
var phaseBasicInfoForm_titleStyle = classnames_default()(form_default.a.bottomTitle, form_default.a.childTitle);
var phaseBasicInfoForm_determineStateValue = function determineStateValue(phaseState) {
  return constants["_35" /* STATES */].includes(phaseState) ? phaseState : constants["_36" /* STATES_WITH_ABBREV */][phaseState];
};

var phaseBasicInfoForm_PhaseBasicInfoForm = function (_Component) {
  phaseBasicInfoForm__inherits(PhaseBasicInfoForm, _Component);

  function PhaseBasicInfoForm(props) {
    phaseBasicInfoForm__classCallCheck(this, PhaseBasicInfoForm);

    var _this = phaseBasicInfoForm__possibleConstructorReturn(this, (PhaseBasicInfoForm.__proto__ || Object.getPrototypeOf(PhaseBasicInfoForm)).call(this, props));

    Object.defineProperty(_this, 'handleStore', {
      enumerable: true,
      writable: true,
      value: function value(option) {
        var selected = option && !Array.isArray(option) ? option : {};
        _this.props.onChange('store', selected.value, selected.vendor);
      }
    });
    Object.defineProperty(_this, 'handlePhoneNumber', {
      enumerable: true,
      writable: true,
      value: function value(index) {
        return _this.props.onChange.bind(_this, 'phone_numbers', index, 'number');
      }
    });
    Object.defineProperty(_this, 'handleOkToText', {
      enumerable: true,
      writable: true,
      value: function value(index) {
        return _this.props.onChange.bind(_this, 'phone_numbers', index, 'ok_to_text');
      }
    });
    Object.defineProperty(_this, 'handleSurfaceType', {
      enumerable: true,
      writable: true,
      value: function value(option) {
        return _this.props.onChange('surface_type', option.value, option.label);
      }
    });
    Object.defineProperty(_this, 'canEditYear', {
      enumerable: true,
      writable: true,
      value: function value(role, source) {
        return source !== 'IFI' ? true : role === 'admin' || role === 'regional';
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            phase = _this$props.phase,
            _onChange = _this$props.onChange,
            invalidEmail = _this$props.invalidEmail,
            role = _this$props.role,
            errors = _this$props.errors,
            _this$props$phase = _this$props.phase,
            _this$props$phase$pho = _this$props$phase.phone_numbers,
            phone_numbers = _this$props$phase$pho === undefined ? [] : _this$props$phase$pho,
            _this$props$phase$sou = _this$props$phase.source,
            source = _this$props$phase$sou === undefined ? '' : _this$props$phase$sou,
            _this$props$phase$wor = _this$props$phase.workroom;
        _this$props$phase$wor = _this$props$phase$wor === undefined ? {} : _this$props$phase$wor;
        var _this$props$phase$wor2 = _this$props$phase$wor.name,
            workroom = _this$props$phase$wor2 === undefined ? '' : _this$props$phase$wor2;

        var stateVal = phaseBasicInfoForm_determineStateValue(phase.state);
        var surfaceId = phase.surface_type ? phase.surface_type.id : '';
        var editYear = _this.canEditYear(role, source);
        var surfaceTypeDisabled = !phase.store.id;
        var surfaceTypePlaceholder = surfaceTypeDisabled ? 'Select a store first to enable Surface Type' : 'Select Surface Type';
        return react_default.a.createElement(
          'div',
          null,
          react_default.a.createElement(
            flexbox_react_dist_default.a,
            { flexWrap: 'wrap', className: form_default.a.divider },
            react_default.a.createElement(
              'h5',
              { className: phaseBasicInfoForm_titleStyle },
              'Basic Information'
            ),
            react_default.a.createElement(components_BreakLine, null),
            react_default.a.createElement(DatePicker, {
              label: 'Date sold/created',
              className: phaseBasicInfoForm_largeInput,
              value: phase.date_sold,
              maxDate: new Date(),
              onChange: _this.handleDateSold,
              error: Object(utils["c" /* error */])('date_sold', errors),
              required: true
            }),
            react_default.a.createElement(react_toolbox_lib["Input"], {
              label: 'Customer Name',
              className: phaseBasicInfoForm_largeInput,
              value: phase.customer_name,
              onChange: _this.handleCustomerName,
              error: Object(utils["c" /* error */])('customer_name', errors),
              required: true
            }),
            react_default.a.createElement(react_toolbox_lib["Input"], {
              label: (source && source !== 'Manual' ? Object(utils["E" /* vendorDisplayName */])(source, workroom) : 'Vendor') + ' Associate',
              className: phaseBasicInfoForm_largeInput,
              value: phase.associate || '',
              onChange: _this.handleAssociate,
              error: Object(utils["c" /* error */])('associate', errors)
            }),
            react_default.a.createElement(components_BreakLine, null),
            react_default.a.createElement(react_toolbox_lib["Input"], {
              label: 'Street Address',
              className: phaseBasicInfoForm_largeInput,
              value: phase.street_address,
              onChange: _this.handleStreetAddress,
              error: Object(utils["c" /* error */])('street_address', errors),
              required: true
            }),
            react_default.a.createElement(react_toolbox_lib["Input"], {
              label: 'City',
              className: phaseBasicInfoForm_largeInput,
              value: phase.city,
              onChange: _this.handleCity,
              error: Object(utils["c" /* error */])('city', errors),
              required: true
            }),
            react_default.a.createElement(components_StyledSelect, {
              className: phaseBasicInfoForm_largeInput,
              label: 'State',
              onChange: _this.handleState,
              options: phaseBasicInfoForm_STATES_SOURCE,
              value: stateVal,
              placeholder: 'Select State',
              error: Object(utils["c" /* error */])('state', errors),
              required: true
            }),
            react_default.a.createElement(react_toolbox_lib["Input"], {
              label: 'Zip Code',
              className: phaseBasicInfoForm_smallInput,
              value: phase.zip_code,
              onChange: _this.handleZipCode,
              error: Object(utils["c" /* error */])('zip_code', errors),
              required: true
            }),
            react_default.a.createElement(components_BreakLine, null),
            react_default.a.createElement(react_toolbox_lib["Input"], {
              label: 'Year Built',
              className: phaseBasicInfoForm_smallInput,
              value: phase.year_built || '',
              onChange: _this.handleYearBuilt,
              disabled: !editYear,
              error: Object(utils["c" /* error */])('year_built', errors)
            }),
            react_default.a.createElement(components_BreakLine, null),
            react_default.a.createElement(
              'h5',
              { className: phaseBasicInfoForm_titleStyle },
              'Contact Information'
            ),
            react_default.a.createElement(components_BreakLine, null),
            phone_numbers.map(function (phone, i) {
              return react_default.a.createElement(PhoneType_PhoneInput, {
                label: 'Phone Number ' + (i + 1),
                key: 'phone' + i // eslint-disable-line react/no-array-index-key
                , type: 'tel',
                value: phone.number,
                className: phaseBasicInfoForm_largeInput,
                onChange: _this.handlePhoneNumber(i),
                error: Object(utils["c" /* error */])('phone_numbers[' + i + '].number', errors),
                required: i === 0
              });
            }),
            react_default.a.createElement(react_toolbox_lib["Input"], {
              label: 'Email',
              type: 'email',
              value: phase.email || '',
              className: phaseBasicInfoForm_largeInput,
              onChange: _this.handleEmail,
              error: invalidEmail ? 'Input valid email' : Object(utils["c" /* error */])('email', errors)
            }),
            react_default.a.createElement(components_BreakLine, null),
            react_default.a.createElement(
              'div',
              null,
              react_default.a.createElement(
                'p',
                { className: form_default.a.inputTitle },
                ' OK to Text? '
              ),
              phone_numbers[0].number && react_default.a.createElement(react_toolbox_lib["Checkbox"], {
                checked: phone_numbers[0].ok_to_text,
                label: 'Phone Number 1',
                theme: checkbox_default.a,
                className: form_default.a.checkboxListItem,
                onChange: function onChange(value) {
                  return _onChange('phone_numbers', 0, 'ok_to_text', value);
                }
              }),
              phone_numbers[1].number && react_default.a.createElement(react_toolbox_lib["Checkbox"], {
                checked: phone_numbers[1].ok_to_text,
                label: 'Phone Number 2',
                theme: checkbox_default.a,
                className: form_default.a.checkboxListItem,
                onChange: function onChange(value) {
                  return _onChange('phone_numbers', 1, 'ok_to_text', value);
                }
              }),
              phone_numbers[2].number && react_default.a.createElement(react_toolbox_lib["Checkbox"], {
                checked: phone_numbers[2].ok_to_text,
                label: 'Phone Number 3',
                theme: checkbox_default.a,
                className: form_default.a.checkboxListItem,
                onChange: function onChange(value) {
                  return _onChange('phone_numbers', 2, 'ok_to_text', value);
                }
              })
            ),
            react_default.a.createElement(components_BreakLine, null),
            react_default.a.createElement(
              'div',
              null,
              react_default.a.createElement(
                'p',
                { className: form_default.a.inputTitle },
                ' Primary Mode of Contact '
              ),
              constants["_2" /* MODE_OF_CONTACT */].map(function (contact) {
                return react_default.a.createElement(react_toolbox_lib["Checkbox"], {
                  key: 'contact-' + contact,
                  checked: phase.mode_of_contact === contact,
                  label: contact,
                  theme: checkbox_default.a,
                  className: form_default.a.checkboxListItem,
                  onChange: function onChange(value) {
                    return _onChange('mode_of_contact', contact, value);
                  }
                });
              })
            ),
            react_default.a.createElement(components_BreakLine, null),
            react_default.a.createElement(
              'div',
              null,
              react_default.a.createElement(
                'p',
                { className: form_default.a.inputTitle },
                ' Automatic Communication Method '
              ),
              constants["o" /* AUTO_COMM_METHOD */].map(function (method) {
                return react_default.a.createElement(react_toolbox_lib["Checkbox"], {
                  key: 'method-' + method,
                  checked: (phase.communication_method || '') === method.toLowerCase(),
                  label: method,
                  theme: checkbox_default.a,
                  className: form_default.a.checkboxListItem,
                  onChange: function onChange(value) {
                    return _onChange('communication_method', method.toLowerCase(), value);
                  }
                });
              })
            ),
            react_default.a.createElement(components_BreakLine, null),
            react_default.a.createElement(
              'h5',
              { className: phaseBasicInfoForm_titleStyle },
              'Purchase Information'
            ),
            react_default.a.createElement(components_BreakLine, null),
            react_default.a.createElement(react_toolbox_lib["Input"], {
              label: 'Project number',
              value: phase.project_number,
              className: phaseBasicInfoForm_largeInput,
              onChange: _this.handleProjectNumber,
              error: Object(utils["c" /* error */])('project_number', errors),
              required: phase.type !== 'Workorder'
            }),
            react_default.a.createElement(formElements_StoreSelect, {
              multi: false,
              className: phaseBasicInfoForm_largeInput,
              onChange: _this.handleStore,
              value: phase.store.id,
              label: 'Store',
              placeholder: 'Select Store Number',
              error: Object(utils["c" /* error */])('store', errors),
              required: true
            }),
            phase.type !== 'Assessment' && react_default.a.createElement(
              react["Fragment"],
              null,
              react_default.a.createElement(react_toolbox_lib["Input"], {
                label: 'Product location',
                value: phase.product_location || '',
                className: phaseBasicInfoForm_mediumInput,
                onChange: _this.handleProductLocation,
                error: Object(utils["c" /* error */])('product_location', errors)
              }),
              react_default.a.createElement(DatePicker, {
                label: 'Vendor ETA',
                className: phaseBasicInfoForm_mediumInput,
                value: phase.vendor_eta,
                minDate: moment_default()().add(1, 'day').toDate(),
                onChange: _this.handleVendorEta,
                error: Object(utils["c" /* error */])('vendor_eta', errors)
              }),
              react_default.a.createElement(components_BreakLine, null),
              react_default.a.createElement(react_toolbox_lib["Switch"], {
                className: form_default.a.specificSwitch,
                name: 'spigDelivery',
                label: 'SPIG Delivery',
                onChange: _this.handleSpigDelivery,
                checked: phase.spig_delivery,
                disabled: false
              })
            ),
            phase.type === 'Workorder' && react_default.a.createElement(react_toolbox_lib["Input"], {
              label: 'Related Purchase Order',
              value: phase.related_po || '',
              className: phaseBasicInfoForm_largeInput,
              onChange: _this.handleRelatedPo,
              error: Object(utils["c" /* error */])('related_po', errors)
            }),
            react_default.a.createElement(components_BreakLine, null),
            react_default.a.createElement(
              'h5',
              { className: phaseBasicInfoForm_titleStyle },
              'Surface Information'
            ),
            react_default.a.createElement(components_BreakLine, null),
            react_default.a.createElement(formElements_SurfaceTypeSelect, {
              placeholder: surfaceTypePlaceholder,
              className: phaseBasicInfoForm_largeInput,
              multi: false,
              onChange: _this.handleSurfaceType,
              value: surfaceId,
              vendor: phase.store.vendor,
              disabled: surfaceTypeDisabled,
              error: Object(utils["c" /* error */])('surface_type', errors),
              required: true
            })
          )
        );
      }
    });

    _this.handleDateSold = _this.props.onChange.bind(_this, 'date_sold');
    _this.handleCustomerName = _this.props.onChange.bind(_this, 'customer_name');
    _this.handleAssociate = _this.props.onChange.bind(_this, 'associate');
    _this.handleStreetAddress = _this.props.onChange.bind(_this, 'street_address');
    _this.handleCity = _this.props.onChange.bind(_this, 'city');
    _this.handleState = _this.props.onChange.bind(_this, 'state');
    _this.handleZipCode = _this.props.onChange.bind(_this, 'zip_code');
    _this.handleYearBuilt = _this.props.onChange.bind(_this, 'year_built');
    _this.handleEmail = _this.props.onChange.bind(_this, 'email');
    _this.handleProjectNumber = _this.props.onChange.bind(_this, 'project_number');
    _this.handleProductLocation = _this.props.onChange.bind(_this, 'product_location');
    _this.handleVendorEta = _this.props.onChange.bind(_this, 'vendor_eta');
    _this.handleRelatedPo = _this.props.onChange.bind(_this, 'related_po');
    _this.handleSpigDelivery = _this.props.onChange.bind(_this, 'spig_delivery');
    return _this;
  }

  return PhaseBasicInfoForm;
}(react["Component"]);

phaseBasicInfoForm_PhaseBasicInfoForm.propTypes = {
  onChange: prop_types_default.a.func,
  errors: prop_types_default.a.object,
  phase: prop_types_default.a.object,
  role: prop_types_default.a.string.isRequired,
  invalidEmail: prop_types_default.a.bool
};

/* harmony default export */ var phaseBasicInfoForm = (phaseBasicInfoForm_PhaseBasicInfoForm);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseEdit/components/phaseSurfaceInfoForm.jsx
var phaseSurfaceInfoForm__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function phaseSurfaceInfoForm__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function phaseSurfaceInfoForm__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function phaseSurfaceInfoForm__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var phaseSurfaceInfoForm_largeInput = classnames_default()(form_default.a.inputs, form_default.a.largeInput);

var phaseSurfaceInfoForm_PhaseSurfaceInfoForm = function (_Component) {
  phaseSurfaceInfoForm__inherits(PhaseSurfaceInfoForm, _Component);

  function PhaseSurfaceInfoForm(props) {
    phaseSurfaceInfoForm__classCallCheck(this, PhaseSurfaceInfoForm);

    var _this = phaseSurfaceInfoForm__possibleConstructorReturn(this, (PhaseSurfaceInfoForm.__proto__ || Object.getPrototypeOf(PhaseSurfaceInfoForm)).call(this, props));

    _this.handleRooms = _this.props.onChange.bind(_this, 'rooms');
    _this.handleCarpetType = _this.props.onChange.bind(_this, 'carpet_type');
    _this.handleCarpetSize = _this.props.onChange.bind(_this, 'carpet_size');
    _this.handlePatternSize = _this.props.onChange.bind(_this, 'pattern_size');
    _this.handleComments = _this.props.onChange.bind(_this, 'comments');
    _this.handleJobType = _this.props.onChange.bind(_this, 'job_type');
    _this.handleVinylSizeChoices = _this.props.onChange.bind(_this, 'vinyl_size_choices');
    _this.handleVinylInstallType = _this.props.onChange.bind(_this, 'vinyl_install_type');
    _this.handleVinylPatternSize = _this.props.onChange.bind(_this, 'vinyl_pattern_size');
    _this.handleNewTileStyle = _this.props.onChange.bind(_this, 'new_tile_style');
    _this.handleTileSize = _this.props.onChange.bind(_this, 'tile_size');
    _this.handleTilePattern = _this.props.onChange.bind(_this, 'tile_pattern');
    _this.handleWoodFlooringType = _this.props.onChange.bind(_this, 'wood_flooring_type');
    _this.handleWoodInstallType = _this.props.onChange.bind(_this, 'wood_install_type');
    _this.handleTileStoneLocation = _this.props.onChange.bind(_this, 'tile_stone_location');
    _this.handleBacksplashJobType = _this.props.onChange.bind(_this, 'backsplash_job_type');
    _this.handleStoneStyle = _this.props.onChange.bind(_this, 'stone_style');
    _this.handleStoneSize = _this.props.onChange.bind(_this, 'stone_size');
    _this.handleStonePatternType = _this.props.onChange.bind(_this, 'stone_pattern_type');
    _this.handleSquareFeet = _this.props.onPhaseChange.bind(_this, 'sqft');
    _this.handleNetSquareFeet = _this.props.onPhaseChange.bind(_this, 'net_square_footage');
    return _this;
  }

  phaseSurfaceInfoForm__createClass(PhaseSurfaceInfoForm, [{
    key: 'renderCarpetForm',
    value: function renderCarpetForm() {
      var surfaceInfo = this.props.phase.surface_information;
      return react_default.a.createElement(
        flexbox_react_dist_default.a,
        { flexWrap: 'wrap' },
        react_default.a.createElement(components_StyledSelect, {
          className: phaseSurfaceInfoForm_largeInput,
          label: 'Job Type',
          onChange: this.handleJobType,
          options: Object(utils["k" /* generateStringsSource */])(constants["R" /* JOB_TYPES */]),
          value: surfaceInfo.job_type || '',
          placeholder: 'Select Job Type'
        }),
        react_default.a.createElement(react_toolbox_lib["Input"], {
          label: 'Rooms',
          className: phaseSurfaceInfoForm_largeInput,
          value: surfaceInfo.rooms || '',
          onChange: this.handleRooms
        }),
        react_default.a.createElement(components_StyledSelect, {
          className: phaseSurfaceInfoForm_largeInput,
          label: 'Carpet Type',
          onChange: this.handleCarpetType,
          options: Object(utils["k" /* generateStringsSource */])(constants["q" /* CARPET_TYPES */]),
          value: surfaceInfo.carpet_type || '',
          placeholder: 'Select Carpet Type'
        }),
        react_default.a.createElement(components_StyledSelect, {
          className: phaseSurfaceInfoForm_largeInput,
          label: 'Carpet Size',
          onChange: this.handleCarpetSize,
          options: Object(utils["k" /* generateStringsSource */])(constants["p" /* CARPET_SIZES */]),
          value: surfaceInfo.carpet_size || '',
          placeholder: 'Select Carpet Size'
        }),
        react_default.a.createElement(components_BreakLine, null),
        react_default.a.createElement(react_toolbox_lib["Input"], {
          label: 'Pattern Size',
          className: phaseSurfaceInfoForm_largeInput,
          value: surfaceInfo.pattern_size || '',
          onChange: this.handlePatternSize
        })
      );
    }
  }, {
    key: 'renderVinylForm',
    value: function renderVinylForm() {
      var surfaceInfo = this.props.phase.surface_information;

      return react_default.a.createElement(
        flexbox_react_dist_default.a,
        { flexWrap: 'wrap' },
        react_default.a.createElement(components_StyledSelect, {
          className: phaseSurfaceInfoForm_largeInput,
          label: 'Job Type',
          onChange: this.handleJobType,
          options: Object(utils["k" /* generateStringsSource */])(constants["R" /* JOB_TYPES */]),
          value: surfaceInfo.job_type || '',
          placeholder: 'Select Job Type'
        }),
        react_default.a.createElement(react_toolbox_lib["Input"], {
          label: 'Rooms',
          className: phaseSurfaceInfoForm_largeInput,
          value: surfaceInfo.rooms || '',
          onChange: this.handleRooms
        }),
        react_default.a.createElement(components_StyledSelect, {
          className: phaseSurfaceInfoForm_largeInput,
          label: 'Vinyl Size Choices',
          onChange: this.handleVinylSizeChoices,
          options: Object(utils["k" /* generateStringsSource */])(constants["_54" /* VINYL_SIZE_CHOICES */]),
          value: surfaceInfo.vinyl_size_choices || '',
          placeholder: 'Select Vinyl Install Type'
        }),
        react_default.a.createElement(components_StyledSelect, {
          className: phaseSurfaceInfoForm_largeInput,
          label: 'Vinyl Install Type',
          onChange: this.handleVinylInstallType,
          options: Object(utils["k" /* generateStringsSource */])(constants["_55" /* VINYL_TYPES */]),
          value: surfaceInfo.vinyl_install_type || '',
          placeholder: 'Select Vinyl Install Type'
        }),
        react_default.a.createElement(components_BreakLine, null),
        react_default.a.createElement(react_toolbox_lib["Input"], {
          label: 'Vinyl Pattern Size',
          className: phaseSurfaceInfoForm_largeInput,
          value: surfaceInfo.vinyl_pattern_size || '',
          onChange: this.handleVinylPatternSize
        })
      );
    }
  }, {
    key: 'renderLaminateForm',
    value: function renderLaminateForm() {
      var surfaceInfo = this.props.phase.surface_information;

      return react_default.a.createElement(
        flexbox_react_dist_default.a,
        { flexWrap: 'wrap' },
        react_default.a.createElement(components_StyledSelect, {
          className: phaseSurfaceInfoForm_largeInput,
          label: 'Job Type',
          onChange: this.handleJobType,
          options: Object(utils["k" /* generateStringsSource */])(constants["R" /* JOB_TYPES */]),
          value: surfaceInfo.job_type || '',
          placeholder: 'Select Job Type'
        }),
        react_default.a.createElement(react_toolbox_lib["Input"], {
          label: 'Rooms',
          className: phaseSurfaceInfoForm_largeInput,
          value: surfaceInfo.rooms || '',
          onChange: this.handleRooms
        })
      );
    }
  }, {
    key: 'renderTileForm',
    value: function renderTileForm() {
      var surfaceInfo = this.props.phase.surface_information;

      return react_default.a.createElement(
        flexbox_react_dist_default.a,
        { flexWrap: 'wrap' },
        react_default.a.createElement(components_StyledSelect, {
          className: phaseSurfaceInfoForm_largeInput,
          label: 'Job Type',
          onChange: this.handleJobType,
          options: Object(utils["k" /* generateStringsSource */])(constants["_38" /* TILE_JOB_TYPES */]),
          value: surfaceInfo.job_type || '',
          placeholder: 'Select Job Type'
        }),
        react_default.a.createElement(react_toolbox_lib["Input"], {
          label: 'Rooms',
          className: phaseSurfaceInfoForm_largeInput,
          value: surfaceInfo.rooms || '',
          onChange: this.handleRooms
        }),
        react_default.a.createElement(components_StyledSelect, {
          className: phaseSurfaceInfoForm_largeInput,
          label: 'New Tile Style',
          onChange: this.handleNewTileStyle,
          options: Object(utils["k" /* generateStringsSource */])(constants["_45" /* TILE_STYLES */]),
          value: surfaceInfo.new_tile_style || '',
          placeholder: 'Select New Tile Style'
        }),
        react_default.a.createElement(components_StyledSelect, {
          className: phaseSurfaceInfoForm_largeInput,
          label: 'Tile Size',
          onChange: this.handleTileSize,
          options: Object(utils["k" /* generateStringsSource */])(constants["_43" /* TILE_SIZES */]),
          value: surfaceInfo.tile_size || '',
          placeholder: 'Select Tile Size'
        }),
        react_default.a.createElement(components_StyledSelect, {
          className: phaseSurfaceInfoForm_largeInput,
          label: 'Tile Pattern',
          onChange: this.handleTilePattern,
          options: Object(utils["k" /* generateStringsSource */])(constants["_42" /* TILE_PATTERNS */]),
          value: surfaceInfo.tile_pattern || '',
          placeholder: 'Select Tile Pattern'
        })
      );
    }
  }, {
    key: 'renderHardwoodForm',
    value: function renderHardwoodForm() {
      var surfaceInfo = this.props.phase.surface_information;

      return react_default.a.createElement(
        flexbox_react_dist_default.a,
        { flexWrap: 'wrap' },
        react_default.a.createElement(components_StyledSelect, {
          className: phaseSurfaceInfoForm_largeInput,
          label: 'Job Type',
          onChange: this.handleJobType,
          options: Object(utils["k" /* generateStringsSource */])(constants["R" /* JOB_TYPES */]),
          value: surfaceInfo.job_type || '',
          placeholder: 'Select Job Type'
        }),
        react_default.a.createElement(react_toolbox_lib["Input"], {
          label: 'Rooms',
          className: phaseSurfaceInfoForm_largeInput,
          value: surfaceInfo.rooms || '',
          onChange: this.handleRooms
        }),
        react_default.a.createElement(components_StyledSelect, {
          className: phaseSurfaceInfoForm_largeInput,
          label: 'Wood Flooring Type',
          onChange: this.handleWoodFlooringType,
          options: Object(utils["k" /* generateStringsSource */])(constants["_59" /* WOOD_FLOORING_TYPES */]),
          value: surfaceInfo.wood_flooring_type || '',
          placeholder: 'Select Wood Flooring Type'
        }),
        react_default.a.createElement(components_StyledSelect, {
          className: phaseSurfaceInfoForm_largeInput,
          label: 'Wood Install Type',
          onChange: this.handleWoodInstallType,
          options: Object(utils["k" /* generateStringsSource */])(constants["_60" /* WOOD_INSTALL_TYPES */]),
          value: surfaceInfo.wood_install_type || '',
          placeholder: 'Select Wood Install Type'
        })
      );
    }
  }, {
    key: 'renderBacksplashForm',
    value: function renderBacksplashForm() {
      var surfaceInfo = this.props.phase.surface_information;

      return react_default.a.createElement(
        flexbox_react_dist_default.a,
        { flexWrap: 'wrap' },
        react_default.a.createElement(react_toolbox_lib["Input"], {
          label: 'Rooms',
          className: phaseSurfaceInfoForm_largeInput,
          value: surfaceInfo.rooms || '',
          onChange: this.handleRooms
        }),
        react_default.a.createElement(components_StyledSelect, {
          className: phaseSurfaceInfoForm_largeInput,
          label: 'Tile/Stone Location',
          onChange: this.handleTileStoneLocation,
          options: Object(utils["k" /* generateStringsSource */])(constants["_44" /* TILE_STONE_LOCATIONS */]),
          value: surfaceInfo.tile_stone_location || '',
          placeholder: 'Select Tile/Stone Location'
        }),
        react_default.a.createElement(components_StyledSelect, {
          className: phaseSurfaceInfoForm_largeInput,
          label: 'Backsplash/Wall Job Type',
          onChange: this.handleBacksplashJobType,
          options: Object(utils["k" /* generateStringsSource */])(constants["_57" /* WALL_JOB_TYPES */]),
          value: surfaceInfo.backsplash_job_type || '',
          placeholder: 'Select Backsplash/Wall Job Type'
        }),
        react_default.a.createElement(components_StyledSelect, {
          className: phaseSurfaceInfoForm_largeInput,
          label: 'Backsplash tile or stone style',
          onChange: this.handleStoneStyle,
          options: Object(utils["k" /* generateStringsSource */])(constants["_41" /* TILE_OR_STONE_STYLES */]),
          value: surfaceInfo.stone_style || '',
          placeholder: 'Select Backsplash tile or stone style'
        }),
        react_default.a.createElement(components_StyledSelect, {
          className: phaseSurfaceInfoForm_largeInput,
          label: 'Backsplash tile or stone size',
          onChange: this.handleStoneSize,
          options: Object(utils["k" /* generateStringsSource */])(constants["_40" /* TILE_OR_STONE_SIZES */]),
          value: surfaceInfo.stone_size || '',
          placeholder: 'Select Backsplash tile or stone size'
        }),
        react_default.a.createElement(components_StyledSelect, {
          className: phaseSurfaceInfoForm_largeInput,
          label: 'Backsplash Tile or Stone Pattern Type',
          onChange: this.handleStonePatternType,
          options: Object(utils["k" /* generateStringsSource */])(constants["_39" /* TILE_OR_STONE_PATTERN_TYPES */]),
          value: surfaceInfo.stone_pattern_type || '',
          placeholder: 'Select Tile or Stone Pattern Type'
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          phase = _props.phase,
          errors = _props.errors;

      var surfaceInfo = phase.surface_information;
      var surfaceType = phase.surface_type || {};
      var surfaceName = surfaceType.name || '';

      return react_default.a.createElement(
        'div',
        null,
        react_default.a.createElement(
          flexbox_react_dist_default.a,
          { flexWrap: 'wrap', className: form_default.a.divider },
          function () {
            switch (surfaceName) {
              case 'Carpet':
                return _this2.renderCarpetForm();
              case 'Vinyl':
                return _this2.renderVinylForm();
              case 'Laminate':
                return _this2.renderLaminateForm();
              case 'Tile':
                return _this2.renderTileForm();
              case 'Hardwood':
                return _this2.renderHardwoodForm();
              case 'Backsplash':
                return _this2.renderBacksplashForm();
              default:
                return null;
            }
          }(),
          react_default.a.createElement(components_BreakLine, null),
          react_default.a.createElement(react_toolbox_lib["Input"], {
            label: 'Project Square Feet',
            className: phaseSurfaceInfoForm_largeInput,
            value: phase.sqft || '',
            onChange: this.handleSquareFeet,
            error: Object(utils["c" /* error */])('sqft', errors)
          }),
          react_default.a.createElement(react_toolbox_lib["Input"], {
            label: 'Net Square Feet',
            className: phaseSurfaceInfoForm_largeInput,
            value: phase.net_square_footage || '',
            onChange: this.handleNetSquareFeet,
            error: Object(utils["c" /* error */])('net_square_footage', errors)
          }),
          react_default.a.createElement(react_toolbox_lib["Input"], {
            label: 'Comments',
            className: phaseSurfaceInfoForm_largeInput,
            value: surfaceInfo.comments || '',
            onChange: this.handleComments
          })
        )
      );
    }
  }]);

  return PhaseSurfaceInfoForm;
}(react["Component"]);

phaseSurfaceInfoForm_PhaseSurfaceInfoForm.propTypes = {
  onChange: prop_types_default.a.func.isRequired,
  onPhaseChange: prop_types_default.a.func.isRequired,
  phase: types_phase.isRequired,
  errors: prop_types_default.a.object
};

/* harmony default export */ var phaseSurfaceInfoForm = (phaseSurfaceInfoForm_PhaseSurfaceInfoForm);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseEdit/components/phaseSpecificInfoForm.jsx
function phaseSpecificInfoForm__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function phaseSpecificInfoForm__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function phaseSpecificInfoForm__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var phaseSpecificInfoForm_titleStyle = classnames_default()(form_default.a.bottomTitle, form_default.a.childTitle);
var phaseSpecificInfoForm_smallInput = classnames_default()(form_default.a.inputs, form_default.a.smallInput);

var phaseSpecificInfoForm_PhaseSpecificInfoForm = function (_Component) {
  phaseSpecificInfoForm__inherits(PhaseSpecificInfoForm, _Component);

  function PhaseSpecificInfoForm(props) {
    phaseSpecificInfoForm__classCallCheck(this, PhaseSpecificInfoForm);

    var _this = phaseSpecificInfoForm__possibleConstructorReturn(this, (PhaseSpecificInfoForm.__proto__ || Object.getPrototypeOf(PhaseSpecificInfoForm)).call(this, props));

    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props$phase = _this.props.phase,
            surfaceId = _this$props$phase.surface_type.id,
            phase_specific = _this$props$phase.phase_specific;

        return react_default.a.createElement(
          'div',
          null,
          react_default.a.createElement(
            flexbox_react_dist_default.a,
            { flexWrap: 'wrap', className: form_default.a.divider },
            react_default.a.createElement(
              'h5',
              { className: phaseSpecificInfoForm_titleStyle },
              'Specific Information - General'
            ),
            react_default.a.createElement(components_BreakLine, null),
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              className: form_default.a.specificSwitch,
              name: 'hasPower',
              label: 'Has Power',
              onChange: _this.handleHasPower,
              checked: phase_specific.customer_has_power,
              disabled: false
            }),
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              className: form_default.a.specificSwitch,
              name: 'hasClimateControl',
              label: 'Has Climate Control',
              onChange: _this.handleHasClimateControl,
              checked: phase_specific.customer_has_climate_control,
              disabled: false
            }),
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              className: form_default.a.specificSwitch,
              name: 'hasWater',
              label: 'Has Water',
              onChange: _this.handleHasWater,
              checked: phase_specific.customer_has_water,
              disabled: false
            }),
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              className: form_default.a.specificSwitch,
              name: 'needMoveFurniture',
              label: 'Moving Furniture',
              onChange: _this.handleNeedMoveFurniture,
              checked: phase_specific.need_move_furniture,
              disabled: false
            }),
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              className: form_default.a.specificSwitch,
              name: 'needMoveFurnitureOversized',
              label: 'Moving Oversized Furniture',
              onChange: _this.handleNeedMoveFurnitureOversized,
              checked: phase_specific.need_move_furniture_oversized,
              disabled: false
            }),
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              className: form_default.a.specificSwitch,
              name: 'needMoveAppliances',
              label: 'Moving Appliances',
              onChange: _this.handleNeedMoveAppliances,
              checked: phase_specific.need_move_appliances,
              disabled: false
            }),
            !constants["_1" /* MILLWORK_SURFACES */].includes(surfaceId) && react_default.a.createElement(
              react["Fragment"],
              null,
              react_default.a.createElement(react_toolbox_lib["Switch"], {
                className: form_default.a.specificSwitch,
                name: 'needSubfloorPrep',
                label: 'Subfloor Prep',
                onChange: _this.handleNeedSubfloorPrep,
                checked: phase_specific.need_subfloor_prep,
                disabled: false
              }),
              react_default.a.createElement(react_toolbox_lib["Switch"], {
                className: form_default.a.specificSwitch,
                name: 'needSubfloorReplacement',
                label: 'Subfloor Replacement',
                onChange: _this.handleNeedSubfloorReplacement,
                checked: phase_specific.need_subfloor_replacement,
                disabled: false
              }),
              react_default.a.createElement(react_toolbox_lib["Switch"], {
                className: form_default.a.specificSwitch,
                name: 'NeedInstallBaseboard',
                label: 'Installing Baseboard/Moulding',
                onChange: _this.handleNeedInstallBaseboard,
                checked: phase_specific.need_install_baseboard,
                disabled: false
              }),
              react_default.a.createElement(react_toolbox_lib["Switch"], {
                className: form_default.a.specificSwitch,
                name: 'needHardSurfaceTransitions',
                label: 'Installing Hard Surface Transitions',
                onChange: _this.handleNeedHardSurfaceTransitions,
                checked: phase_specific.need_hardsurface_transitions,
                disabled: false
              })
            )
          ),
          react_default.a.createElement(components_BreakLine, null),
          constants["_1" /* MILLWORK_SURFACES */].includes(surfaceId) ? react_default.a.createElement(
            flexbox_react_dist_default.a,
            { flexWrap: 'wrap', className: form_default.a.divider },
            react_default.a.createElement(
              'h5',
              { className: phaseSpecificInfoForm_titleStyle },
              'Specific Information - Millwork'
            ),
            react_default.a.createElement(components_BreakLine, null),
            react_default.a.createElement(react_toolbox_lib["Input"], {
              className: phaseSpecificInfoForm_smallInput,
              label: 'Number of Doors',
              onChange: _this.handleNumDoors,
              value: phase_specific.millwork_specifics.num_doors
            }),
            react_default.a.createElement(react_toolbox_lib["Input"], {
              className: phaseSpecificInfoForm_smallInput,
              label: 'Number of Windows',
              onChange: _this.handleNumWindows,
              value: phase_specific.millwork_specifics.num_windows
            }),
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              className: form_default.a.specificSwitch,
              name: 'permitRequired',
              label: 'Permit Required',
              onChange: _this.handlePermitRequired,
              checked: phase_specific.millwork_specifics.permit_required || false,
              disabled: false
            })
          ) : react_default.a.createElement(
            react["Fragment"],
            null,
            [1, 8, 9].includes(surfaceId) && react_default.a.createElement(
              react["Fragment"],
              null,
              react_default.a.createElement(
                flexbox_react_dist_default.a,
                { flexWrap: 'wrap', className: form_default.a.divider },
                react_default.a.createElement(
                  'h5',
                  { className: phaseSpecificInfoForm_titleStyle },
                  'Specific Information - Hardwood'
                ),
                react_default.a.createElement(components_BreakLine, null),
                react_default.a.createElement(react_toolbox_lib["Switch"], {
                  className: form_default.a.specificSwitch,
                  name: 'isNaildownHardwood',
                  label: 'Naildown Hardwood',
                  onChange: _this.handleIsNaildownHardwood,
                  checked: phase_specific.is_naildown_hardwood,
                  disabled: false
                }),
                react_default.a.createElement(react_toolbox_lib["Switch"], {
                  className: form_default.a.specificSwitch,
                  name: 'isGluedownHardwood',
                  label: 'Gluedown Hardwood',
                  onChange: _this.handleIsGluedownHardwood,
                  checked: phase_specific.is_gluedown_hardwood,
                  disabled: false
                }),
                react_default.a.createElement(react_toolbox_lib["Switch"], {
                  className: form_default.a.specificSwitch,
                  name: 'isFloatingHardwood',
                  label: 'Floating Hardwood',
                  onChange: _this.handleIsFloatingHardwood,
                  checked: phase_specific.is_floating_hardwood,
                  disabled: false
                }),
                react_default.a.createElement(react_toolbox_lib["Switch"], {
                  className: form_default.a.specificSwitch,
                  name: 'isCaliBambooHardwood',
                  label: 'Cali Bamboo',
                  onChange: _this.handleIsCaliBambooHardwood,
                  checked: phase_specific.is_cali_bamboo_hardwood,
                  disabled: false
                }),
                react_default.a.createElement(react_toolbox_lib["Switch"], {
                  className: form_default.a.specificSwitch,
                  name: 'isStepsHardwood',
                  label: 'Hardwood Steps',
                  onChange: _this.handleIsStepsHardwood,
                  checked: phase_specific.is_steps_hardwood,
                  disabled: false
                })
              ),
              react_default.a.createElement(components_BreakLine, null)
            ),
            [2, 8, 9].includes(surfaceId) && react_default.a.createElement(
              react["Fragment"],
              null,
              react_default.a.createElement(
                flexbox_react_dist_default.a,
                { flexWrap: 'wrap', className: form_default.a.divider },
                react_default.a.createElement(
                  'h5',
                  { className: phaseSpecificInfoForm_titleStyle },
                  'Specific Information - Carpet'
                ),
                react_default.a.createElement(components_BreakLine, null),
                react_default.a.createElement(react_toolbox_lib["Switch"], {
                  className: form_default.a.specificSwitch,
                  name: 'isStretchInCarpet',
                  label: 'Stretch In Carpet',
                  onChange: _this.handleIsStretchInCarpet,
                  checked: phase_specific.is_stretch_in_carpet,
                  disabled: false
                }),
                react_default.a.createElement(react_toolbox_lib["Switch"], {
                  className: form_default.a.specificSwitch,
                  name: 'isGluedownCarpet',
                  label: 'Gluedown Carpet',
                  onChange: _this.handleIsGluedownCarpet,
                  checked: phase_specific.is_gluedown_carpet,
                  disabled: false
                }),
                react_default.a.createElement(react_toolbox_lib["Switch"], {
                  className: form_default.a.specificSwitch,
                  name: 'isBindingCarpet',
                  label: 'Binding Carpet',
                  onChange: _this.handleIsBindingCarpet,
                  checked: phase_specific.is_binding_carpet,
                  disabled: false
                }),
                react_default.a.createElement(react_toolbox_lib["Switch"], {
                  className: form_default.a.specificSwitch,
                  name: 'isPatternMatchCarpet',
                  label: 'Pattern Match Carpet',
                  onChange: _this.handleIsPatternMatchCarpet,
                  checked: phase_specific.is_pattern_match_carpet,
                  disabled: false
                }),
                react_default.a.createElement(react_toolbox_lib["Switch"], {
                  className: form_default.a.specificSwitch,
                  name: 'isBerberCarpet',
                  label: 'Berber Carpet',
                  onChange: _this.handleIsBerberCarpet,
                  checked: phase_specific.is_berber_carpet,
                  disabled: false
                }),
                react_default.a.createElement(components_BreakLine, null),
                react_default.a.createElement(react_toolbox_lib["Switch"], {
                  className: form_default.a.specificSwitch,
                  name: 'isStepsCarpet',
                  label: 'Carpet Steps',
                  onChange: _this.handleIsStepsCarpet,
                  checked: phase_specific.is_steps_carpet,
                  disabled: false
                })
              ),
              react_default.a.createElement(components_BreakLine, null)
            ),
            [3, 7, 8, 9].includes(surfaceId) && react_default.a.createElement(
              react["Fragment"],
              null,
              react_default.a.createElement(
                flexbox_react_dist_default.a,
                { flexWrap: 'wrap', className: form_default.a.divider },
                react_default.a.createElement(
                  'h5',
                  { className: phaseSpecificInfoForm_titleStyle },
                  'Specific Information - Tile/Backsplash'
                ),
                react_default.a.createElement(components_BreakLine, null),
                react_default.a.createElement(react_toolbox_lib["Switch"], {
                  className: form_default.a.specificSwitch,
                  name: 'isFloorTile',
                  label: 'Floor Tile',
                  onChange: _this.handleIsFloorTile,
                  checked: phase_specific.is_floor_tile,
                  disabled: false
                }),
                react_default.a.createElement(react_toolbox_lib["Switch"], {
                  className: form_default.a.specificSwitch,
                  name: 'isBacksplashTile',
                  label: 'Backsplash Tile',
                  onChange: _this.handleIsBacksplashTile,
                  checked: phase_specific.is_backsplash_tile,
                  disabled: false
                }),
                react_default.a.createElement(react_toolbox_lib["Switch"], {
                  className: form_default.a.specificSwitch,
                  name: 'isBacksplashGlass',
                  label: 'Glass Backsplash',
                  onChange: _this.handleIsBacksplashGlass,
                  checked: phase_specific.is_backsplash_glass,
                  disabled: false
                }),
                react_default.a.createElement(react_toolbox_lib["Switch"], {
                  className: form_default.a.specificSwitch,
                  name: 'isBacksplashBlocking',
                  label: 'Backsplash Blocking',
                  onChange: _this.handleIsBacksplashBlocking,
                  checked: phase_specific.is_backsplash_blocking,
                  disabled: false
                }),
                react_default.a.createElement(react_toolbox_lib["Switch"], {
                  className: form_default.a.specificSwitch,
                  name: 'isPatternsTile',
                  label: 'Tile Patterns',
                  onChange: _this.handleIsPatternsTile,
                  checked: phase_specific.is_patterns_tile,
                  disabled: false
                }),
                react_default.a.createElement(react_toolbox_lib["Switch"], {
                  className: form_default.a.specificSwitch,
                  name: 'isLargeFormatTile',
                  label: 'Large Format Tile',
                  onChange: _this.handleIsLargeFormatTile,
                  checked: phase_specific.is_large_format_tile,
                  disabled: false
                })
              ),
              react_default.a.createElement(components_BreakLine, null)
            ),
            [5, 6, 8, 9].includes(surfaceId) && react_default.a.createElement(
              react["Fragment"],
              null,
              react_default.a.createElement(
                flexbox_react_dist_default.a,
                { flexWrap: 'wrap', className: form_default.a.divider },
                react_default.a.createElement(
                  'h5',
                  { className: phaseSpecificInfoForm_titleStyle },
                  'Specific Information - Vinyl/Plank'
                ),
                react_default.a.createElement(components_BreakLine, null),
                react_default.a.createElement(react_toolbox_lib["Switch"], {
                  className: form_default.a.specificSwitch,
                  name: 'isVinylSheet',
                  label: 'Sheet Vinyl',
                  onChange: _this.handleIsVinylSheet,
                  checked: phase_specific.is_vinyl_sheet,
                  disabled: false
                }),
                react_default.a.createElement(react_toolbox_lib["Switch"], {
                  className: form_default.a.specificSwitch,
                  name: 'isVctLvt',
                  label: 'Vinyl Tile',
                  onChange: _this.handleIsVinylTile,
                  checked: phase_specific.is_vct_lvt,
                  disabled: false
                }),
                react_default.a.createElement(react_toolbox_lib["Switch"], {
                  className: form_default.a.specificSwitch,
                  name: 'isGluedownVinylPlank',
                  label: 'Gluedown VP',
                  onChange: _this.handleIsGluedownVinylPlank,
                  checked: phase_specific.is_gluedown_vinyl_plank,
                  disabled: false
                }),
                react_default.a.createElement(components_BreakLine, null),
                react_default.a.createElement(react_toolbox_lib["Switch"], {
                  className: form_default.a.specificSwitch,
                  name: 'isFloatingVinylPlank',
                  label: 'Floating VP',
                  onChange: _this.handleIsFloatingVinylPlank,
                  checked: phase_specific.is_floating_vinyl_plank,
                  disabled: false
                })
              ),
              react_default.a.createElement(components_BreakLine, null)
            ),
            react_default.a.createElement(
              flexbox_react_dist_default.a,
              { flexWrap: 'wrap', className: form_default.a.divider },
              react_default.a.createElement(
                'h5',
                { className: phaseSpecificInfoForm_titleStyle },
                'Specific Information - Removal'
              ),
              react_default.a.createElement(components_BreakLine, null),
              react_default.a.createElement(react_toolbox_lib["Switch"], {
                className: form_default.a.specificSwitch,
                name: 'needRemoveReplaceToilet',
                label: 'Remove/Replace Toilet',
                onChange: _this.handleNeedRemoveReplaceToilet,
                checked: phase_specific.need_remove_replace_toilet,
                disabled: false
              }),
              react_default.a.createElement(react_toolbox_lib["Switch"], {
                className: form_default.a.specificSwitch,
                name: 'needRemoveNaildownHardwood',
                label: 'Removing Naildown Hardwood',
                onChange: _this.handleNeedRemoveNaildownHardwood,
                checked: phase_specific.need_remove_naildown_hardwood,
                disabled: false
              }),
              react_default.a.createElement(react_toolbox_lib["Switch"], {
                className: form_default.a.specificSwitch,
                name: 'needRemoveFloatingHardwood',
                label: 'Removing Floating Hardwood',
                onChange: _this.handleNeedRemoveFloatingHardwood,
                checked: phase_specific.need_remove_floating_hardwood,
                disabled: false
              }),
              react_default.a.createElement(react_toolbox_lib["Switch"], {
                className: form_default.a.specificSwitch,
                name: 'needRemoveGluedownHardwood',
                label: 'Removing Gluedown Hardwood',
                onChange: _this.handleNeedRemoveGluedownHardwood,
                checked: phase_specific.need_remove_gluedown_hardwood,
                disabled: false
              }),
              react_default.a.createElement(react_toolbox_lib["Switch"], {
                className: form_default.a.specificSwitch,
                name: 'needRemoveOverPadCarpet',
                label: 'Removing Carpet Over Pad',
                onChange: _this.handleNeedRemoveOverPadCarpet,
                checked: phase_specific.need_remove_over_pad_carpet,
                disabled: false
              }),
              react_default.a.createElement(react_toolbox_lib["Switch"], {
                className: form_default.a.specificSwitch,
                name: 'needRemoveGluedownCarpet',
                label: 'Removing Gluedown Carpet',
                onChange: _this.handleNeedRemoveGluedownCarpet,
                checked: phase_specific.need_remove_gluedown_carpet,
                disabled: false
              }),
              react_default.a.createElement(react_toolbox_lib["Switch"], {
                className: form_default.a.specificSwitch,
                name: 'needRemoveLaminate',
                label: 'Removing Laminate',
                onChange: _this.handleNeedRemoveLaminate,
                checked: phase_specific.need_remove_laminate,
                disabled: false
              }),
              react_default.a.createElement(react_toolbox_lib["Switch"], {
                className: form_default.a.specificSwitch,
                name: 'needRemoveTile',
                label: 'Removing Tile',
                onChange: _this.handleNeedRemoveTile,
                checked: phase_specific.need_remove_tile,
                disabled: false
              }),
              react_default.a.createElement(react_toolbox_lib["Switch"], {
                className: form_default.a.specificSwitch,
                name: 'needRemoveGluedownVinyl',
                label: 'Removing Gluedown Vinyl',
                onChange: _this.handleNeedRemoveGluedownVinyl,
                checked: phase_specific.need_remove_gluedown_vinyl,
                disabled: false
              }),
              react_default.a.createElement(components_BreakLine, null),
              react_default.a.createElement(react_toolbox_lib["Switch"], {
                className: form_default.a.specificSwitch,
                name: 'needRemoveVinylPlank',
                label: 'Removing Vinyl Plank',
                onChange: _this.handleNeedRemoveVinylPlank,
                checked: phase_specific.need_remove_vinyl_plank,
                disabled: false
              }),
              react_default.a.createElement(react_toolbox_lib["Switch"], {
                className: form_default.a.specificSwitch,
                name: 'needRemoveBacksplash',
                label: 'Removing Backsplash',
                onChange: _this.handleNeedRemoveBacksplash,
                checked: phase_specific.need_remove_backsplash,
                disabled: false
              })
            )
          )
        );
      }
    });
    var _this$props = _this.props,
        onChange = _this$props.onChange,
        onMillworkChange = _this$props.onMillworkChange,
        onMillworkBooleanChange = _this$props.onMillworkBooleanChange;


    _this.handleCustomerSpeaksEnglish = onChange.bind(_this, 'customer_speaks_english');
    _this.handleCustomerSpeaksSpanish = onChange.bind(_this, 'customer_speaks_spanish');
    _this.handleHasPower = onChange.bind(_this, 'customer_has_power');
    _this.handleHasWater = onChange.bind(_this, 'customer_has_water');
    _this.handleHasClimateControl = onChange.bind(_this, 'customer_has_climate_control');
    _this.handleNeedMoveFurniture = onChange.bind(_this, 'need_move_furniture');
    _this.handleNeedMoveFurnitureOversized = onChange.bind(_this, 'need_move_furniture_oversized');
    _this.handleNeedMoveAppliances = onChange.bind(_this, 'need_move_appliances');
    _this.handleNeedSubfloorPrep = onChange.bind(_this, 'need_subfloor_prep');
    _this.handleNeedSubfloorReplacement = onChange.bind(_this, 'need_subfloor_replacement');
    _this.handleIsNaildownHardwood = onChange.bind(_this, 'is_naildown_hardwood');
    _this.handleIsGluedownHardwood = onChange.bind(_this, 'is_gluedown_hardwood');
    _this.handleIsFloatingHardwood = onChange.bind(_this, 'is_floating_hardwood');
    _this.handleIsCaliBambooHardwood = onChange.bind(_this, 'is_cali_bamboo_hardwood');
    _this.handleIsStepsHardwood = onChange.bind(_this, 'is_steps_hardwood');
    _this.handleIsStretchInCarpet = onChange.bind(_this, 'is_stretch_in_carpet');
    _this.handleIsGluedownCarpet = onChange.bind(_this, 'is_gluedown_carpet');
    _this.handleIsBindingCarpet = onChange.bind(_this, 'is_binding_carpet');
    _this.handleIsPatternMatchCarpet = onChange.bind(_this, 'is_pattern_match_carpet');
    _this.handleIsBerberCarpet = onChange.bind(_this, 'is_berber_carpet');
    _this.handleIsStepsCarpet = onChange.bind(_this, 'is_steps_carpet');
    _this.handleIsFloorTile = onChange.bind(_this, 'is_floor_tile');
    _this.handleIsBacksplashTile = onChange.bind(_this, 'is_backsplash_tile');
    _this.handleIsBacksplashGlass = onChange.bind(_this, 'is_backsplash_glass');
    _this.handleIsBacksplashBlocking = onChange.bind(_this, 'is_backsplash_blocking');
    _this.handleIsPatternsTile = onChange.bind(_this, 'is_patterns_tile');
    _this.handleIsLargeFormatTile = onChange.bind(_this, 'is_large_format_tile');
    _this.handleIsVinylSheet = onChange.bind(_this, 'is_vinyl_sheet');
    _this.handleIsVinylTile = onChange.bind(_this, 'is_vct_lvt');
    _this.handleIsGluedownVinylPlank = onChange.bind(_this, 'is_gluedown_vinyl_plank');
    _this.handleIsFloatingVinylPlank = onChange.bind(_this, 'is_floating_vinyl_plank');
    _this.handleNeedRemoveReplaceToilet = onChange.bind(_this, 'need_remove_replace_toilet');
    _this.handleNeedRemoveNaildownHardwood = onChange.bind(_this, 'need_remove_naildown_hardwood');
    _this.handleNeedRemoveFloatingHardwood = onChange.bind(_this, 'need_remove_floating_hardwood');
    _this.handleNeedRemoveGluedownHardwood = onChange.bind(_this, 'need_remove_gluedown_hardwood');
    _this.handleNeedRemoveOverPadCarpet = onChange.bind(_this, 'need_remove_over_pad_carpet');
    _this.handleNeedRemoveGluedownCarpet = onChange.bind(_this, 'need_remove_gluedown_carpet');
    _this.handleNeedRemoveLaminate = onChange.bind(_this, 'need_remove_laminate');
    _this.handleNeedRemoveTile = onChange.bind(_this, 'need_remove_tile');
    _this.handleNeedRemoveGluedownVinyl = onChange.bind(_this, 'need_remove_gluedown_vinyl');
    _this.handleNeedRemoveVinylPlank = onChange.bind(_this, 'need_remove_vinyl_plank');
    _this.handleNeedRemoveBacksplash = onChange.bind(_this, 'need_remove_backsplash');
    _this.handleNeedInstallBaseboard = onChange.bind(_this, 'need_install_baseboard');
    _this.handleNeedHardSurfaceTransitions = onChange.bind(_this, 'need_hardsurface_transitions');
    _this.handleNumDoors = onMillworkChange.bind(_this, 'num_doors');
    _this.handleNumWindows = onMillworkChange.bind(_this, 'num_windows');
    _this.handlePermitRequired = onMillworkBooleanChange.bind(_this, 'permit_required');
    return _this;
  }

  return PhaseSpecificInfoForm;
}(react["Component"]);

phaseSpecificInfoForm_PhaseSpecificInfoForm.propTypes = {
  onChange: prop_types_default.a.func,
  onMillworkChange: prop_types_default.a.func,
  onMillworkBooleanChange: prop_types_default.a.func,
  errors: prop_types_default.a.object,
  phase: prop_types_default.a.object
};

/* harmony default export */ var phaseSpecificInfoForm = (phaseSpecificInfoForm_PhaseSpecificInfoForm);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseEdit/components/workorderInfoForm.jsx
var workorderInfoForm__templateObject = workorderInfoForm__taggedTemplateLiteral(['\n0% {\n    transform: translateY(-100%);\n    opacity: 0;\n  }\n\n100% {\n    transform: translateY(0);\n    opacity: 1;\n  }\n'], ['\n0% {\n    transform: translateY(-100%);\n    opacity: 0;\n  }\n\n100% {\n    transform: translateY(0);\n    opacity: 1;\n  }\n']),
    _templateObject2 = workorderInfoForm__taggedTemplateLiteral(['\noverflow: hidden;\n'], ['\noverflow: hidden;\n']);

function workorderInfoForm__taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }














var workorderInfoForm_largeInput = classnames_default()(form_default.a.inputs, form_default.a.largeInput);
var workorderInfoForm_titleStyle = classnames_default()(form_default.a.bottomTitle, form_default.a.childTitle);

var workorderInfoForm_expand = Object(core_browser_esm["keyframes"])(workorderInfoForm__templateObject);
/**
 * If phase has been created it will have a phase.id. When using the DropdownDiv component
 * you need to pass the phase.id if it exists, or an empty string using this format for the
 * DropdownDiv prop: phaseID={phase.id ? phase.id : ''}
 * Emotion will make the props passed to that component available to be used in styling it.
 * Here we are checking if the string is empty, indicating a new phase, therefore using the
 * animation. Otherwise no animation is set and the fields are visible from the start, which
 * is the desired behavior for existing phases being edited.
 */
var DropdownDiv = styled_browser_esm["a" /* default */].div(function (props) {
  return {
    animation: props.phaseID === '' ? workorderInfoForm_expand + ' 400ms ease-out' : ''
  };
});

var ContainerDiv = styled_browser_esm["a" /* default */].div(_templateObject2);

var workorderInfoForm_WorkorderInfoForm = function WorkorderInfoForm(props) {
  var errors = props.errors,
      phase = props.phase,
      _onChange = props.onChange;

  return react_default.a.createElement(
    ContainerDiv,
    null,
    react_default.a.createElement(
      DropdownDiv,
      { phaseID: phase.id ? phase.id : '' },
      react_default.a.createElement(
        flexbox_react_dist_default.a,
        { flexWrap: 'wrap', className: form_default.a.divider },
        react_default.a.createElement(
          'h5',
          { className: workorderInfoForm_titleStyle },
          'Workorder Source / Type'
        ),
        react_default.a.createElement(components_BreakLine, null),
        react_default.a.createElement(components_StyledSelect, {
          className: workorderInfoForm_largeInput,
          label: 'Workorder Source',
          onChange: function onChange(selection) {
            return _onChange('wo_source', selection);
          },
          options: Object(utils["F" /* woSourceOptions */])(phase),
          value: phase.wo_source,
          placeholder: 'Select Workorder Source',
          error: Object(utils["c" /* error */])('type', errors),
          required: true
        }),
        react_default.a.createElement(components_StyledSelect, {
          className: workorderInfoForm_largeInput,
          label: 'Workorder Type',
          onChange: function onChange(selection) {
            return _onChange('wo_type', selection);
          },
          options: constants["_61" /* WORKORDER_TYPE */].map(function (wt) {
            return { value: wt, label: wt };
          }),
          value: phase.wo_type,
          placeholder: 'Select Workorder Type',
          error: Object(utils["c" /* error */])('type', errors),
          required: true
        })
      )
    )
  );
};

workorderInfoForm_WorkorderInfoForm.propTypes = {
  onChange: prop_types_default.a.func,
  errors: prop_types_default.a.object,
  phase: prop_types_default.a.object,
  isEdit: prop_types_default.a.bool
};

/* harmony default export */ var workorderInfoForm = (workorderInfoForm_WorkorderInfoForm);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseEdit/components/phaseForm.jsx
var phaseForm__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function phaseForm__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function phaseForm__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function phaseForm__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function phaseForm__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function phaseForm__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }























var phaseForm_theme = { RTInput: input_default.a, RTDropdown: dropdown_default.a, RTCard: styles_card_default.a };
var phaseForm_largeInput = classnames_default()(form_default.a.inputs, form_default.a.largeInput);
var phaseForm_cancelClass = classnames_default()([form_default.a.cancelButton, form_default.a.actionButton]);
var phaseForm_titleStyle = classnames_default()([form_default.a.bottomTitle, form_default.a.childTitle]);

var DEFAULT_PHONE_NUMBER = {
  number: '',
  kind: 'mobile',
  ok_to_text: false,
  reached: false
};

var DEFAULT_PHASE_SPECIFICS = {
  customer_speaks_english: false,
  customer_speaks_spanish: false,
  customer_has_power: false,
  customer_has_water: false,
  customer_has_climate_control: false,
  need_move_furniture: false,
  need_move_furniture_oversized: false,
  need_move_appliances: false,
  need_subfloor_prep: false,
  need_subfloor_replacement: false,
  is_naildown_hardwood: false,
  is_gluedown_hardwood: false,
  is_floating_hardwood: false,
  is_cali_bamboo_hardwood: false,
  is_steps_hardwood: false,
  is_stretch_in_carpet: false,
  is_gluedown_carpet: false,
  is_binding_carpet: false,
  is_pattern_match_carpet: false,
  is_berber_carpet: false,
  is_steps_carpet: false,
  is_floor_tile: false,
  is_backsplash_tile: false,
  is_backsplash_glass: false,
  is_backsplash_blocking: false,
  is_patterns_tile: false,
  is_large_format_tile: false,
  is_vinyl_sheet: false,
  is_vct_lvt: false,
  need_remove_replace_toilet: false,
  need_remove_naildown_hardwood: false,
  need_remove_floating_hardwood: false,
  need_remove_gluedown_hardwood: false,
  need_remove_over_pad_carpet: false,
  need_remove_gluedown_carpet: false,
  need_remove_laminate: false,
  need_remove_tile: false,
  need_remove_gluedown_vinyl: false,
  need_remove_vinyl_plank: false,
  need_remove_backsplash: false,
  need_install_baseboard: false,
  need_hardsurface_transitions: false,
  millwork_specifics: { num_doors: 0, num_windows: 0, permit_required: false }
};

var LOCK_BLACKLISTED_ATTRIBUTES = ['summary', 'due_at'];

var phaseForm_renderTitle = function renderTitle(phase, isEdit) {
  return react_default.a.createElement(
    flexbox_react_dist_default.a,
    { className: form_default.a.divider },
    react_default.a.createElement(
      'div',
      null,
      react_default.a.createElement(
        'h5',
        { className: form_default.a.cardTitle },
        (isEdit ? 'Edit' : 'Create') + ' Phase'
      ),
      react_default.a.createElement(
        'p',
        { className: form_default.a.cardSubtitle },
        'Please ensure that all fields contain accurate information'
      )
    )
  );
};

var phaseForm_PhaseForm = function (_Component) {
  phaseForm__inherits(PhaseForm, _Component);

  function PhaseForm(props) {
    phaseForm__classCallCheck(this, PhaseForm);

    var _this = phaseForm__possibleConstructorReturn(this, (PhaseForm.__proto__ || Object.getPrototypeOf(PhaseForm)).call(this, props));

    Object.defineProperty(_this, 'handleChange', {
      enumerable: true,
      writable: true,
      value: function value(key, _value) {
        for (var _len = arguments.length, rest = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
          rest[_key - 2] = arguments[_key];
        }

        var phase = _this.state.phase;
        var emailChange = key === 'email';
        if (key === 'surface_type') {
          // When the surface types changes it should clear the old info
          phase.surface_information = {};
          phase.surface_type = {};
          phase.surface_type.id = _value;
          phase.surface_type.name = rest[0];
        } else if (key === 'store') {
          var vendor = rest[0];

          var wasIfi = phase.store.vendor === 'IFI';
          phase.store.id = _value;
          phase.store.vendor = vendor;
          if (wasIfi !== (vendor === 'IFI')) {
            // Crossing the IFI boundary invalidates the previously selected
            // surface type, same idiom as a direct surface_type change above.
            phase.surface_type = {};
            phase.surface_information = {};
          }
        } else if (key === 'phone_numbers') {
          var _ref = [_value].concat(rest),
              index = _ref[0],
              attr = _ref[1],
              val = _ref[2];

          phase.phone_numbers[index][attr] = val;
        } else if (key === 'floor_wizard_project_id') {
          phase.floor_wizard_job = phase.floor_wizard_job || {};
          phase.floor_wizard_job[key] = _value;
        } else {
          phase[key] = emailChange ? _value.replaceAll(' ', '') : _value;
        }
        _this.setState({ phase: phase, invalidEmail: emailChange && !constants["I" /* EMAIL_VALIDATION_REGEX */].test(_value) });
      }
    });
    Object.defineProperty(_this, 'handleSpecificChange', {
      enumerable: true,
      writable: true,
      value: function value(key, _value2) {
        var phase = _this.state.phase;
        if (key === 'need_move_furniture_oversized' && _value2) {
          phase.phase_specific.need_move_furniture = true;
        }
        phase.phase_specific[key] = _value2;
        _this.setState({ phase: phase });
      }
    });
    Object.defineProperty(_this, 'handleMillworkSpecificChange', {
      enumerable: true,
      writable: true,
      value: function value(key, _value3) {
        var num = Number(_value3);
        if (!Number.isFinite(num)) return;
        var phase = phaseForm__extends({}, _this.state.phase);
        phase.phase_specific = phaseForm__extends({}, phase.phase_specific);
        phase.phase_specific.millwork_specifics = phaseForm__extends({}, phase.phase_specific.millwork_specifics, phaseForm__defineProperty({}, key, num));
        _this.setState({ phase: phase });
      }
    });
    Object.defineProperty(_this, 'handleMillworkBooleanChange', {
      enumerable: true,
      writable: true,
      value: function value(key, _value4) {
        var phase = phaseForm__extends({}, _this.state.phase);
        phase.phase_specific = phaseForm__extends({}, phase.phase_specific);
        phase.phase_specific.millwork_specifics = phaseForm__extends({}, phase.phase_specific.millwork_specifics, phaseForm__defineProperty({}, key, _value4));
        _this.setState({ phase: phase });
      }
    });
    Object.defineProperty(_this, 'handleSurfaceInfoChange', {
      enumerable: true,
      writable: true,
      value: function value(key, _value5) {
        var phase = _this.state.phase;
        phase.surface_information = phase.surface_information || {};
        phase.surface_information[key] = _value5;
        _this.setState({ phase: phase });
      }
    });
    Object.defineProperty(_this, 'handleCancel', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.onCancel();
      }
    });
    Object.defineProperty(_this, 'handleSave', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        if (e) e.preventDefault();

        var _this$state$phase = _this.state.phase,
            store = _this$state$phase.store,
            surfaceType = _this$state$phase.surface_type,
            phone_numbers = _this$state$phase.phone_numbers,
            floor_wizard_job = _this$state$phase.floor_wizard_job,
            phase = phaseForm__objectWithoutProperties(_this$state$phase, ['store', 'surface_type', 'phone_numbers', 'floor_wizard_job']);

        var phoneNumbersAttributes = phone_numbers.map(function (phone, i) {
          if (phone.number.trim() === '') {
            if (!phone.id) return i > 0 ? null : phone;
            return phaseForm__extends({}, phone, { _destroy: true });
          }
          return phone;
        }).filter(function (n) {
          return !!n;
        });
        var data = phaseForm__extends({}, phase, {
          phase_specific_attributes: phase.phase_specific,
          phone_numbers_attributes: phoneNumbersAttributes,
          floor_wizard_job_attributes: floor_wizard_job,
          store_id: store.id,
          surface_type_id: surfaceType ? surfaceType.id : null,
          date_sold: Object(dateUtils["o" /* handleDateSave */])(phase.date_sold),
          vendor_eta: Object(dateUtils["o" /* handleDateSave */])(phase.vendor_eta)
        });
        _this.props.onSave(data);
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$state = _this.state,
            phase = _this$state.phase,
            invalidEmail = _this$state.invalidEmail;
        var errors = _this.props.errors;

        var isEdit = !!phase.id;
        var role = _this.props.role;
        var fwProjId = phase.floor_wizard_job ? phase.floor_wizard_job.floor_wizard_project_id : '';
        return react_default.a.createElement(
          react_css_themr_lib["ThemeProvider"],
          { theme: phaseForm_theme },
          react_default.a.createElement(
            components_Card,
            null,
            react_default.a.createElement(
              'form',
              { onSubmit: _this.handleSave, action: 'edit', method: 'POST' },
              phaseForm_renderTitle(phase, isEdit),
              !isEdit && react_default.a.createElement(
                'div',
                { className: form_default.a.divider },
                react_default.a.createElement(
                  'h5',
                  { className: phaseForm_titleStyle },
                  'Select a Phase Type'
                ),
                react_default.a.createElement(components_StyledSelect, {
                  className: phaseForm_largeInput,
                  label: 'Phase Type',
                  onChange: _this.handlePhaseType,
                  options: constants["_14" /* PHASE_TYPES */].map(function (pt) {
                    return { value: pt, label: pt };
                  }),
                  value: phase.type,
                  placeholder: 'Select Phase Type',
                  error: Object(utils["c" /* error */])('type', errors),
                  required: true
                })
              ),
              phase.type && phase.type === 'Workorder' && react_default.a.createElement(workorderInfoForm, {
                phase: phase,
                errors: errors,
                theme: phaseForm_theme,
                onChange: _this.handleChange
              }),
              react_default.a.createElement(phaseBasicInfoForm, {
                phase: phase,
                errors: errors,
                theme: phaseForm_theme,
                onChange: _this.handleChange,
                invalidEmail: invalidEmail,
                role: role
              }),
              !!phase.surface_type && !Object(lodash["isEmpty"])(phase.surface_type) && react_default.a.createElement(
                react["Fragment"],
                null,
                !constants["_1" /* MILLWORK_SURFACES */].includes(phase.surface_type.id) && react_default.a.createElement(phaseSurfaceInfoForm, {
                  phase: phase,
                  errors: errors,
                  theme: phaseForm_theme,
                  onChange: _this.handleSurfaceInfoChange,
                  onPhaseChange: _this.handleChange
                }),
                react_default.a.createElement(phaseSpecificInfoForm, {
                  phase: phase,
                  errors: errors,
                  theme: phaseForm_theme,
                  onChange: _this.handleSpecificChange,
                  onMillworkChange: _this.handleMillworkSpecificChange,
                  onMillworkBooleanChange: _this.handleMillworkBooleanChange
                })
              ),
              phase.type === 'Installation' && react_default.a.createElement(
                'div',
                { className: form_default.a.divider },
                react_default.a.createElement(react_toolbox_lib["Input"], {
                  multiline: true,
                  label: 'Additional Work',
                  theme: form_default.a,
                  value: phase.additional_work || '',
                  className: form_default.a.textArea,
                  error: Object(utils["c" /* error */])('additional_work', errors),
                  onChange: _this.handleAdditionalWork
                })
              ),
              phase.type === 'Installation' && react_default.a.createElement(
                'div',
                { className: form_default.a.divider },
                react_default.a.createElement(react_toolbox_lib["Input"], {
                  multiline: true,
                  label: 'Haul Away and Removal',
                  theme: form_default.a,
                  value: phase.haul_away || '',
                  className: form_default.a.textArea,
                  error: Object(utils["c" /* error */])('haul_away', errors),
                  onChange: _this.handleHaulAway
                })
              ),
              react_default.a.createElement(
                'div',
                { className: form_default.a.divider },
                react_default.a.createElement(react_toolbox_lib["Input"], {
                  multiline: true,
                  label: 'Additional comments',
                  theme: form_default.a,
                  value: phase.additional_comments || '',
                  className: form_default.a.textArea,
                  error: Object(utils["c" /* error */])('additional_comments', errors),
                  onChange: _this.handleAdditionalComments
                }),
                phase.type === 'Assessment' && react_default.a.createElement(react_toolbox_lib["Input"], {
                  label: 'Floor Wizard Project Id',
                  value: fwProjId || '',
                  className: phaseForm_largeInput,
                  onChange: _this.handleFWProjectId,
                  error: Object(utils["c" /* error */])('floor_wizard_job.floor_wizard_project_id', errors)
                })
              ),
              react_default.a.createElement(
                flexbox_react_dist_default.a,
                { justifyContent: 'flex-end', flexWrap: 'wrap' },
                react_default.a.createElement(
                  react_toolbox_lib["CardActions"],
                  { className: form_default.a.actionsWrapper },
                  react_default.a.createElement(ColoredButton["a" /* default */], {
                    className: phaseForm_cancelClass,
                    responsive: true,
                    color: 'gray',
                    label: 'Cancel',
                    onClick: _this.handleCancel
                  }),
                  react_default.a.createElement(ColoredButton["a" /* default */], {
                    type: 'submit',
                    className: form_default.a.actionButton,
                    responsive: true,
                    color: 'green',
                    label: isEdit ? 'Save Changes' : 'Create phase',
                    disabled: _this.props.loading || invalidEmail
                  })
                )
              )
            )
          )
        );
      }
    });

    _this.handleSave = _this.handleSave.bind(_this);
    _this.handleCancel = _this.handleCancel.bind(_this);
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleSurfaceInfoChange = _this.handleSurfaceInfoChange.bind(_this);
    _this.handlePhaseType = _this.handleChange.bind(_this, 'type');
    _this.handleAdditionalComments = _this.handleChange.bind(_this, 'additional_comments');
    _this.handleAdditionalWork = _this.handleChange.bind(_this, 'additional_work');
    _this.handleHaulAway = _this.handleChange.bind(_this, 'haul_away');
    _this.handleFWProjectId = _this.handleChange.bind(_this, 'floor_wizard_project_id');

    var editablePhase = Object(lodash["cloneDeep"])(Object(lodash["omit"])(_this.props.phase, LOCK_BLACKLISTED_ATTRIBUTES));
    [0, 1, 2].forEach(function (i) {
      if (!editablePhase.phone_numbers[i]) {
        editablePhase.phone_numbers[i] = Object(lodash["cloneDeep"])(DEFAULT_PHONE_NUMBER);
      }
    });
    if (editablePhase.phase_specific === undefined) {
      editablePhase.phase_specific = DEFAULT_PHASE_SPECIFICS;
    } else if (!editablePhase.phase_specific.millwork_specifics) {
      editablePhase.phase_specific.millwork_specifics = { num_doors: 0, num_windows: 0, permit_required: false };
    }
    _this.state = { phase: editablePhase, invalidEmail: false };
    return _this;
  }

  return PhaseForm;
}(react["Component"]);

phaseForm_PhaseForm.propTypes = {
  phase: prop_types_default.a.object,
  onCancel: prop_types_default.a.func,
  onSave: prop_types_default.a.func,
  errors: prop_types_default.a.object,
  role: prop_types_default.a.string,
  loading: prop_types_default.a.bool
};

phaseForm_PhaseForm.defaultProps = {
  phase: {
    phone_numbers: [],
    store: {},
    surface_type: {},
    mode_of_contact: constants["_2" /* MODE_OF_CONTACT */][0],
    surface_information: {}
  }
};

/* harmony default export */ var phaseForm = (phaseForm_PhaseForm);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseEdit/phaseNew.jsx
var phaseNew__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function phaseNew__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function phaseNew__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function phaseNew__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var phaseNew_PhaseNew = function (_Component) {
  phaseNew__inherits(PhaseNew, _Component);

  function PhaseNew(props) {
    phaseNew__classCallCheck(this, PhaseNew);

    var _this = phaseNew__possibleConstructorReturn(this, (PhaseNew.__proto__ || Object.getPrototypeOf(PhaseNew)).call(this, props));

    _this.handleSave = _this.handleSave.bind(_this);
    _this.handleCancel = function () {
      _this.props.navigate(urls.phases());
    };
    return _this;
  }

  phaseNew__createClass(PhaseNew, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.clearValidationErrors('PHASE');
    }
  }, {
    key: 'handleSave',
    value: function handleSave(phase) {
      var _this2 = this;

      this.props.createPhase(phase).then(function () {
        return _this2.props.navigate(urls.phaseLaborProductAccounting(_this2.props.phase));
      }).catch(function () {});
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          errors = _props.errors,
          phase = _props.phase,
          role = _props.role;


      return react_default.a.createElement(
        'div',
        null,
        react_default.a.createElement(
          flexbox_react_dist_default.a,
          null,
          react_default.a.createElement(Helmet_default.a, { title: 'New Phase' }),
          react_default.a.createElement(
            'div',
            { className: contentArea_default.a.contentAreaContainer },
            react_default.a.createElement(phaseForm, {
              errors: errors,
              onSave: this.handleSave,
              onCancel: this.handleCancel,
              loading: phase.loading,
              role: role
            })
          )
        )
      );
    }
  }]);

  return PhaseNew;
}(react["Component"]);

phaseNew_PhaseNew.propTypes = {
  phase: types_phase,
  navigate: prop_types_default.a.func,
  listOfRequests: prop_types_default.a.func,
  requestSurfaceTypesList: prop_types_default.a.func,
  clearValidationErrors: prop_types_default.a.func,
  createPhase: prop_types_default.a.func,
  errors: prop_types_default.a.object,
  role: prop_types_default.a.string
};

var phaseNew_mapStateToProps = function mapStateToProps(state) {
  var _state$user = state.user;
  _state$user = _state$user === undefined ? {} : _state$user;
  var _state$user$role = _state$user.role,
      role = _state$user$role === undefined ? '' : _state$user$role;

  return {
    phase: state.phase.details,
    errors: state.phase.details.errors || {},
    role: role
  };
};

/* harmony default export */ var phaseNew = (transpiled_default()()(Object(react_redux_es["connect"])(phaseNew_mapStateToProps, {
  navigate: actionCreators["O" /* navigate */],
  createPhase: actionCreators["s" /* createPhase */],
  clearValidationErrors: actionCreators["k" /* clearValidationErrors */],
  listOfRequests: actionCreators["F" /* listOfRequests */]
})(phaseNew_PhaseNew)));
// EXTERNAL MODULE: ./client/app/screens/main/screens/phases/components/phaseDetailsBar.scss
var phaseDetailsBar = __webpack_require__("U2Su");
var phaseDetailsBar_default = /*#__PURE__*/__webpack_require__.n(phaseDetailsBar);

// CONCATENATED MODULE: ./client/app/shared/components/StoreInfo/index.jsx






var formatParams = function formatParams(store) {
  return ((store.address || '') + '%2C%+' + (store.city || '') + '%2C+' + (store.state || '') + '+' + (store.zip_code || '')).replace(/\s+/g, '+');
};

var StoreInfo_StoreInfo = function StoreInfo(_ref) {
  var store = _ref.store,
      linkToMaps = _ref.linkToMaps;
  return react_default.a.createElement(
    react["Fragment"],
    null,
    linkToMaps ? react_default.a.createElement(
      'a',
      {
        href: 'https://www.google.com/maps/search/?api=1&query=' + formatParams(store),
        target: '_blank',
        rel: 'noopener noreferrer'
      },
      '#',
      store.number,
      react_default.a.createElement('br', null),
      store.name
    ) : react_default.a.createElement(
      es["c" /* Link */],
      { to: urls.store(store) },
      '#',
      store.number,
      react_default.a.createElement('br', null),
      store.name
    )
  );
};

StoreInfo_StoreInfo.defaultProps = { linkToMaps: false };

StoreInfo_StoreInfo.propTypes = { store: types_store.isRequired, linkToMaps: prop_types_default.a.bool };

/* harmony default export */ var components_StoreInfo = (StoreInfo_StoreInfo);
// EXTERNAL MODULE: ./client/app/shared/components/MOT/styles.scss
var MOT_styles = __webpack_require__("cufn");
var MOT_styles_default = /*#__PURE__*/__webpack_require__.n(MOT_styles);

// CONCATENATED MODULE: ./client/app/shared/components/MOT/index.jsx






var MOT_MOT = function MOT(_ref) {
  var phase = _ref.phase;

  var complete = determineComplete(phase.status, phase.phase_tasks);
  var useActualMOT = determineUseActualMOT(phase.type, phase.appointments, complete);
  var motTitle = determineMOTTitle(phase.type, useActualMOT, complete);
  var motColorCode = determineMOTColorCode(phase, useActualMOT, complete);
  var mot = determineMOT(phase, useActualMOT);

  return react_default.a.createElement(
    'span',
    { className: MOT_styles_default.a.mot },
    react_default.a.createElement(react_toolbox_lib["FontIcon"], { value: 'alarm' }),
    motTitle,
    ': ',
    react_default.a.createElement(
      'span',
      { className: MOT_styles_default.a[motColorCode] },
      mot
    )
  );
};

MOT_MOT.propTypes = {
  phase: prop_types_default.a.object
};

/* harmony default export */ var components_MOT = (MOT_MOT);
// CONCATENATED MODULE: ./client/app/selectors/phase.js
/* eslint-disable import/prefer-default-export */



var getPhaseRevenueSelector = function getPhaseRevenueSelector(phase) {
  return {
    revenue: phase.revenue,
    expenses: phase.expenses
  };
};

var getPhaseMarginProfit = Object(reselect_lib["createSelector"])(getPhaseRevenueSelector, function (_ref) {
  var revenue = _ref.revenue,
      expenses = _ref.expenses;
  return {
    profit: revenue - expenses,
    margin: revenue > 0 ? 100 * ((revenue - expenses) / revenue) : 0
  };
});
// EXTERNAL MODULE: ./client/app/assets/images/gold-medal.png
var gold_medal = __webpack_require__("6qfh");
var gold_medal_default = /*#__PURE__*/__webpack_require__.n(gold_medal);

// EXTERNAL MODULE: ./client/app/assets/images/silver-medal.png
var silver_medal = __webpack_require__("ljxu");
var silver_medal_default = /*#__PURE__*/__webpack_require__.n(silver_medal);

// EXTERNAL MODULE: ./client/app/assets/images/bronze-medal.png
var bronze_medal = __webpack_require__("OywE");
var bronze_medal_default = /*#__PURE__*/__webpack_require__.n(bronze_medal);

// EXTERNAL MODULE: ./client/app/shared/components/ProfitMargin/styles.scss
var ProfitMargin_styles = __webpack_require__("xqJT");
var ProfitMargin_styles_default = /*#__PURE__*/__webpack_require__.n(ProfitMargin_styles);

// CONCATENATED MODULE: ./client/app/shared/components/ProfitMargin/index.jsx
var ProfitMargin__templateObject = ProfitMargin__taggedTemplateLiteral(['\n0% {\n  transform: scale(1);\n}\n50% {\n  transform: scale(1.05);\n}\n100% {\n  transform: scale(1);\n}\n'], ['\n0% {\n  transform: scale(1);\n}\n50% {\n  transform: scale(1.05);\n}\n100% {\n  transform: scale(1);\n}\n']);

function ProfitMargin__taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }












var ProfitMargin_pulse = Object(core_browser_esm["keyframes"])(ProfitMargin__templateObject);

var LowMarginDiv = styled_browser_esm["a" /* default */].div(function () {
  return {
    animation: ProfitMargin_pulse + ' 2500ms infinite'
  };
});

var ProfitMargin_determineStatusMedal = function determineStatusMedal(phase, margin) {
  var _phase$mid_margin = phase.mid_margin,
      mid_margin = _phase$mid_margin === undefined ? 0 : _phase$mid_margin,
      _phase$high_margin = phase.high_margin,
      high_margin = _phase$high_margin === undefined ? 0 : _phase$high_margin;

  var src = gold_medal_default.a;
  if (margin < mid_margin) src = bronze_medal_default.a;else if (margin < high_margin) src = silver_medal_default.a;
  return react_default.a.createElement('img', { className: ProfitMargin_styles_default.a.medalImg, alt: 'Service Pros logo', src: src });
};

var ProfitMargin_ProfitMargin = function ProfitMargin(_ref) {
  var phase = _ref.phase,
      _ref$phase$low_margin = _ref.phase.low_margin,
      low_margin = _ref$phase$low_margin === undefined ? 0 : _ref$phase$low_margin;

  var _getPhaseMarginProfit = getPhaseMarginProfit(phase),
      margin = _getPhaseMarginProfit.margin;

  return react_default.a.createElement(
    'div',
    { className: ProfitMargin_styles_default.a.wrapper },
    margin < low_margin || low_margin === 0 ? react_default.a.createElement(
      LowMarginDiv,
      null,
      react_default.a.createElement(
        'span',
        { className: ProfitMargin_styles_default.a.content },
        react_default.a.createElement(react_toolbox_lib["FontIcon"], { value: 'attach_money' }),
        'Low Margin'
      )
    ) : react_default.a.createElement(
      'div',
      { className: ProfitMargin_styles_default.a.contentWrapper },
      ProfitMargin_determineStatusMedal(phase, margin)
    )
  );
};

ProfitMargin_ProfitMargin.propTypes = { phase: types_phase.isRequired };

/* harmony default export */ var components_ProfitMargin = (ProfitMargin_ProfitMargin);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/ifiUtils.js
var isIfiPhase = function isIfiPhase(_ref) {
  var source = _ref.source;
  return (source || '').toUpperCase() === 'IFI';
};

/* harmony default export */ var ifiUtils = (isIfiPhase);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/components/phaseDetailsBar.jsx
var phaseDetailsBar__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function phaseDetailsBar__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function phaseDetailsBar__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function phaseDetailsBar__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function phaseDetailsBar__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


























var phaseDetailsBar_PhaseDetailsBar = function (_Component) {
  phaseDetailsBar__inherits(PhaseDetailsBar, _Component);

  function PhaseDetailsBar(props) {
    phaseDetailsBar__classCallCheck(this, PhaseDetailsBar);

    var _this = phaseDetailsBar__possibleConstructorReturn(this, (PhaseDetailsBar.__proto__ || Object.getPrototypeOf(PhaseDetailsBar)).call(this, props));

    Object.defineProperty(_this, 'componentDidMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return window.addEventListener('scroll', _this.toggleScrollStatus, false);
      }
    });
    Object.defineProperty(_this, 'componentWillUnmount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return window.removeEventListener('scroll', _this.toggleScrollStatus, false);
      }
    });
    Object.defineProperty(_this, 'derivedStateFromProps', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _ref = _this.props.phase || {},
            _ref$created_at_defau = _ref.created_at_default,
            created_at_default = _ref$created_at_defau === undefined ? null : _ref$created_at_defau,
            _ref$product_type = _ref.product_type,
            product_type = _ref$product_type === undefined ? null : _ref$product_type,
            _ref$surface_type = _ref.surface_type;

        _ref$surface_type = _ref$surface_type === undefined ? {} : _ref$surface_type;
        var _ref$surface_type$nam = _ref$surface_type.name,
            surfaceType = _ref$surface_type$nam === undefined ? 'N/A' : _ref$surface_type$nam,
            _ref$phase_specific = _ref.phase_specific,
            phase_specific = _ref$phase_specific === undefined ? null : _ref$phase_specific,
            _ref$phase_line_items = _ref.phase_line_items,
            phase_line_items = _ref$phase_line_items === undefined ? [] : _ref$phase_line_items;

        var motDiff = product_type === 'STK' ? 21 : 28;
        return {
          targetMOTDate: created_at_default ? moment_default()(created_at_default).add(motDiff, 'days').format(constants["E" /* DISPLAY_DATE */]) : null,
          surfaceType: surfaceType,
          detectedSurfaces: constants["_33" /* SPECIAL_SURFACE_TYPES */].includes(surfaceType) ? _this.findMatchingSurfaces(phase_specific, phase_line_items) : []
        };
      }
    });
    Object.defineProperty(_this, 'theme', {
      enumerable: true,
      writable: true,
      value: { ResourceDetailsCE: phaseDetailsBar_default.a }
    });
    Object.defineProperty(_this, 'toggleScrollStatus', {
      enumerable: true,
      writable: true,
      value: function value() {
        return window.pageYOffset > 0 ? _this.setState({ scrolling: true }) : _this.setState({ scrolling: false });
      }
    });
    Object.defineProperty(_this, 'handleExpand', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ expand: !_this.state.expand });
      }
    });
    Object.defineProperty(_this, 'specificsSurfaceMatch', {
      enumerable: true,
      writable: true,
      value: function value(specifics, matchingSpecifics) {
        return specifics && matchingSpecifics.length > 0 && matchingSpecifics.some(function (s) {
          return specifics[s] === true;
        });
      }
    });
    Object.defineProperty(_this, 'lineItemSurfaceMatch', {
      enumerable: true,
      writable: true,
      value: function value(lineItems, itemNumbers, surface) {
        return lineItems.length > 0 && itemNumbers.length > 0 && lineItems.some(function (li) {
          return itemNumbers.includes(li.item_number) || (li.description || '').replace('_', ' ').toLowerCase().includes(surface.replace('_', ' ').toLowerCase());
        });
      }
    });
    Object.defineProperty(_this, 'findMatchingSurfaces', {
      enumerable: true,
      writable: true,
      value: function value(specifics, lineItems) {
        return Object.keys(constants["_4" /* MULTI_ITEM_AND_SPECIFIC_MAP */]).filter(function (key) {
          var _MULTI_ITEM_AND_SPECI = constants["_4" /* MULTI_ITEM_AND_SPECIFIC_MAP */][key],
              matchingSpecifics = _MULTI_ITEM_AND_SPECI.matchingSpecifics,
              itemNumbers = _MULTI_ITEM_AND_SPECI.itemNumbers;

          return _this.specificsSurfaceMatch(specifics, matchingSpecifics) || _this.lineItemSurfaceMatch(lineItems, itemNumbers, key);
        }).map(function (k) {
          return k.replace('_', ' ');
        });
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            _this$props$phase = _this$props.phase;
        _this$props$phase = _this$props$phase === undefined ? {} : _this$props$phase;
        var _this$props$phase$typ = _this$props$phase.type,
            type = _this$props$phase$typ === undefined ? null : _this$props$phase$typ,
            _this$props$phase$cus = _this$props$phase.customer_name,
            customer_name = _this$props$phase$cus === undefined ? null : _this$props$phase$cus,
            _this$props$phase$pho = _this$props$phase.phone_numbers,
            phone_numbers = _this$props$phase$pho === undefined ? null : _this$props$phase$pho,
            _this$props$phase$ema = _this$props$phase.email,
            email = _this$props$phase$ema === undefined ? null : _this$props$phase$ema,
            _this$props$phase$str = _this$props$phase.street_address,
            street_address = _this$props$phase$str === undefined ? null : _this$props$phase$str,
            _this$props$phase$cit = _this$props$phase.city,
            city = _this$props$phase$cit === undefined ? null : _this$props$phase$cit,
            _this$props$phase$sta = _this$props$phase.state,
            state = _this$props$phase$sta === undefined ? null : _this$props$phase$sta,
            _this$props$phase$zip = _this$props$phase.zip_code,
            zip_code = _this$props$phase$zip === undefined ? null : _this$props$phase$zip,
            _this$props$phase$sou = _this$props$phase.source,
            source = _this$props$phase$sou === undefined ? null : _this$props$phase$sou,
            _this$props$phase$pro = _this$props$phase.project_number,
            project_number = _this$props$phase$pro === undefined ? null : _this$props$phase$pro,
            _this$props$phase$sqf = _this$props$phase.sqft,
            sqft = _this$props$phase$sqf === undefined ? null : _this$props$phase$sqf,
            _this$props$phase$spi = _this$props$phase.spig_delivery,
            spig_delivery = _this$props$phase$spi === undefined ? null : _this$props$phase$spi,
            _this$props$phase$eff = _this$props$phase.effective_due_at,
            effective_due_at = _this$props$phase$eff === undefined ? null : _this$props$phase$eff,
            _this$props$phase$ccs = _this$props$phase.ccs_schedulable,
            ccs_schedulable = _this$props$phase$ccs === undefined ? null : _this$props$phase$ccs,
            _this$props$phase$ven = _this$props$phase.vendor_eta,
            vendor_eta = _this$props$phase$ven === undefined ? null : _this$props$phase$ven,
            _this$props$phase$con = _this$props$phase.contractor_notes,
            contractor_notes = _this$props$phase$con === undefined ? null : _this$props$phase$con,
            _this$props$phase$ims = _this$props$phase.ims_link,
            ims_link = _this$props$phase$ims === undefined ? null : _this$props$phase$ims,
            _this$props$phase$est = _this$props$phase.estimator,
            estimator = _this$props$phase$est === undefined ? null : _this$props$phase$est,
            _this$props$phase$sto = _this$props$phase.store,
            store = _this$props$phase$sto === undefined ? null : _this$props$phase$sto,
            _this$props$phase$sto2 = _this$props$phase.store;
        _this$props$phase$sto2 = _this$props$phase$sto2 === undefined ? {} : _this$props$phase$sto2;
        var _this$props$phase$sto3 = _this$props$phase$sto2.workroom_id,
            workroomId = _this$props$phase$sto3 === undefined ? '' : _this$props$phase$sto3,
            _this$props$phase$sto4 = _this$props$phase$sto2.workroom_name,
            workroomName = _this$props$phase$sto4 === undefined ? '' : _this$props$phase$sto4,
            _this$props$phase$sto5 = _this$props$phase$sto2.ccs_schedulable,
            storeCcsSchedulable = _this$props$phase$sto5 === undefined ? null : _this$props$phase$sto5,
            _this$props$phase$sto6 = _this$props$phase$sto2.vendor,
            storeVendor = _this$props$phase$sto6 === undefined ? null : _this$props$phase$sto6,
            _this$props$phase$res = _this$props$phase.responsible_persons;
        _this$props$phase$res = _this$props$phase$res === undefined ? {} : _this$props$phase$res;
        var _this$props$phase$res2 = _this$props$phase$res.installer_name,
            installer_name = _this$props$phase$res2 === undefined ? '' : _this$props$phase$res2,
            _this$props$phase$res3 = _this$props$phase$res.installer_supervisor_name,
            installer_supervisor_name = _this$props$phase$res3 === undefined ? '' : _this$props$phase$res3,
            _this$props$phase$res4 = _this$props$phase$res.estimator_supervisor_name,
            estimator_supervisor_name = _this$props$phase$res4 === undefined ? '' : _this$props$phase$res4,
            _this$props$phase2 = _this$props.phase,
            phase = _this$props$phase2 === undefined ? null : _this$props$phase2,
            role = _this$props.role,
            _this$props$position = _this$props.position,
            position = _this$props$position === undefined ? '' : _this$props$position,
            _this$props$mvw = _this$props.mvw,
            mvw = _this$props$mvw === undefined ? {} : _this$props$mvw,
            canViewWorkroom = _this$props.canViewWorkroom;
        var _this$state = _this.state,
            expand = _this$state.expand,
            targetMOTDate = _this$state.targetMOTDate,
            surfaceType = _this$state.surfaceType,
            detectedSurfaces = _this$state.detectedSurfaces;

        var supervisorNames = [installer_supervisor_name, estimator_supervisor_name].filter(Boolean).filter(function (name, idx, arr) {
          return arr.indexOf(name) === idx;
        });
        var supervisorDisplay = supervisorNames.length ? supervisorNames.join(', ') : '--';
        var hasMultiSurfaces = detectedSurfaces.length > 0;
        return react_default.a.createElement(
          react_css_themr_lib["ThemeProvider"],
          { theme: _this.theme },
          react_default.a.createElement(
            'div',
            {
              className: classnames_default()(phaseDetailsBar_default.a.phaseDetailsBar, phaseDetailsBar__defineProperty({}, phaseDetailsBar_default.a.scrolling, _this.state.scrolling))
            },
            react_default.a.createElement(
              react_responsive_default.a,
              { minWidth: constants["y" /* CUT_POINT */] },
              react_default.a.createElement(
                'div',
                { className: phaseDetailsBar_default.a.phaseDue },
                react_default.a.createElement(components_VendorLogo, {
                  workroomName: workroomName,
                  source: source,
                  classMap: phaseDetailsBar_default.a
                })
              )
            ),
            react_default.a.createElement(
              'div',
              {
                className: phaseDetailsBar_default.a.ResourceDetails + ' ' + (expand ? phaseDetailsBar_default.a['ResourceDetails-expanded'] : '')
              },
              react_default.a.createElement(
                ResourceDetailsCardElement,
                { wrap: true, title: '' + surfaceType + (hasMultiSurfaces ? ' - ' + detectedSurfaces.join(', ') : '') },
                react_default.a.createElement(
                  'h1',
                  { className: phaseDetailsBar_default.a.phaseType },
                  type
                ),
                sqft && sqft + ' sqft',
                react_default.a.createElement('br', null),
                spig_delivery && react_default.a.createElement(
                  'span',
                  { style: { color: 'red' } },
                  'SPIG DELIVERY'
                )
              ),
              react_default.a.createElement(
                ResourceDetailsCardElement,
                { wrap: true, title: 'Customer' },
                customer_name,
                react_default.a.createElement('br', null),
                phone_numbers.length && phone_numbers.map(function (phone) {
                  return react_default.a.createElement(components_PhoneLink, {
                    key: phone.number,
                    className: phaseDetailsBar_default.a.phone, number: phone.number
                  });
                })
              ),
              react_default.a.createElement(
                ResourceDetailsCardElement,
                { wrap: true, title: 'Address' },
                react_default.a.createElement(components_DetailsAddress, {
                  address: street_address,
                  city: city,
                  state: state,
                  zipCode: zip_code
                }),
                email && react_default.a.createElement(
                  'div',
                  null,
                  react_default.a.createElement(
                    components_EmailLink,
                    { email: email },
                    email
                  )
                )
              ),
              react_default.a.createElement(
                ResourceDetailsCardElement,
                { title: 'project number' },
                react_default.a.createElement(
                  'a',
                  { href: ims_link, target: '_blank', rel: 'noopener noreferrer' },
                  project_number
                ),
                surfaceType !== 'Pro Direct' && (type === 'Assessment' || ccs_schedulable && type === 'Installation' && storeCcsSchedulable) ? react_default.a.createElement(
                  'div',
                  { style: { color: 'red' } },
                  'Phase CCS Schedulable'
                ) : '',
                react_default.a.createElement('br', null),
                phase.lrrp_required && react_default.a.createElement(
                  'span',
                  { style: { color: '#cc0000' } },
                  'LRRP REQUIRED'
                )
              ),
              estimator && react_default.a.createElement(
                ResourceDetailsCardElement,
                { title: 'estimator' },
                react_default.a.createElement(
                  es["c" /* Link */],
                  {
                    className: phaseDetailsBar_default.a.viewLink,
                    to: '/estimators/' + estimator.id,
                    target: '_blank'
                  },
                  estimator.name
                )
              ),
              Object(services["a" /* can */])(role, 'view', 'SUPERVISOR_INFO', {
                position: position,
                mvw: mvw
              }) && storeVendor === 'IFI' && react_default.a.createElement(
                react["Fragment"],
                null,
                react_default.a.createElement(
                  ResourceDetailsCardElement,
                  { title: 'installer' },
                  installer_name || '--'
                ),
                react_default.a.createElement(
                  ResourceDetailsCardElement,
                  { title: 'coordinator' },
                  supervisorDisplay
                )
              ),
              targetMOTDate && react_default.a.createElement(
                ResourceDetailsCardElement,
                { title: 'Target MOT Date' },
                targetMOTDate
              ),
              store && react_default.a.createElement(
                ResourceDetailsCardElement,
                { title: source === 'IFI' ? 'District' : 'workroom' },
                canViewWorkroom ? react_default.a.createElement(
                  es["c" /* Link */],
                  {
                    className: phaseDetailsBar_default.a.viewLink,
                    to: urls.workroomFromPhaseDetails(workroomId),
                    target: '_blank'
                  },
                  workroomName
                ) : react_default.a.createElement(
                  'div',
                  null,
                  workroomName
                )
              ),
              react_default.a.createElement(
                ResourceDetailsCardElement,
                { wrap: true, title: 'Store Info' },
                store && react_default.a.createElement(components_StoreInfo, { store: store, linkToMaps: ['installer', 'crew'].includes(role) })
              ),
              type !== 'Assessment' && !ifiUtils({ source: source }) && react_default.a.createElement(
                ResourceDetailsCardElement,
                { wrap: true, title: 'Vendor ETA' },
                vendor_eta ? moment_default()(vendor_eta, constants["E" /* DISPLAY_DATE */]).format(constants["E" /* DISPLAY_DATE */]) : '--'
              ),
              react_default.a.createElement(
                ResourceDetailsCardElement,
                { wrap: true, title: 'Contractor Notes', className: phaseDetailsBar_default.a.notes },
                contractor_notes ? react_default.a.createElement(
                  components_UserNote,
                  { className: phaseDetailsBar_default.a.notesContainer },
                  contractor_notes
                ) : '--'
              ),
              react_default.a.createElement(
                react_toolbox_lib["Button"],
                { onClick: _this.handleExpand, className: phaseDetailsBar_default.a.expandButton },
                expand ? react_default.a.createElement(
                  react_toolbox_lib["FontIcon"],
                  null,
                  'keyboard_arrow_up'
                ) : react_default.a.createElement(
                  react_toolbox_lib["FontIcon"],
                  null,
                  'keyboard_arrow_down'
                )
              )
            ),
            react_default.a.createElement(
              react_responsive_default.a,
              { minWidth: constants["y" /* CUT_POINT */] },
              react_default.a.createElement(
                'div',
                { className: phaseDetailsBar_default.a.phaseDue },
                Object(services["a" /* can */])(role, 'view', 'due_date') && react_default.a.createElement(
                  'div',
                  { className: phaseDetailsBar_default.a.phaseDueLine },
                  react_default.a.createElement(components_DueDate, { date: effective_due_at, isPhaseDetails: true })
                ),
                Object(services["a" /* can */])(role, 'view', 'created_at_default') && react_default.a.createElement(
                  'div',
                  { className: phaseDetailsBar_default.a.phaseDueLine },
                  react_default.a.createElement(components_MOT, { phase: phase })
                ),
                type !== 'Assessment' && Object(services["a" /* can */])(role, 'view', 'profit_margin') && react_default.a.createElement(
                  'div',
                  { className: phaseDetailsBar_default.a.phaseDueLine },
                  react_default.a.createElement(components_ProfitMargin, { phase: phase })
                )
              )
            ),
            react_default.a.createElement(
              react_responsive_default.a,
              { maxWidth: constants["y" /* CUT_POINT */] - 1 },
              react_default.a.createElement(
                'div',
                { className: phaseDetailsBar_default.a.mobilePhaseDue },
                react_default.a.createElement(
                  'div',
                  { className: phaseDetailsBar_default.a.mobilePhaseDueContent },
                  Object(services["a" /* can */])(role, 'view', 'due_date') && react_default.a.createElement(
                    'div',
                    { className: phaseDetailsBar_default.a.phaseDueLine },
                    react_default.a.createElement(components_DueDate, { date: effective_due_at, isPhaseDetails: true })
                  ),
                  Object(services["a" /* can */])(role, 'view', 'created_at_default') && react_default.a.createElement(
                    'div',
                    { className: phaseDetailsBar_default.a.phaseDueLine },
                    react_default.a.createElement(components_MOT, { phase: phase })
                  )
                ),
                react_default.a.createElement(
                  'div',
                  { className: phaseDetailsBar_default.a.logoMobile },
                  react_default.a.createElement(components_VendorLogo, {
                    workroomName: workroomName,
                    source: source,
                    classMap: phaseDetailsBar_default.a
                  })
                )
              )
            )
          )
        );
      }
    });

    _this.handleExpand = _this.handleExpand.bind(_this);
    _this.toggleScrollStatus = _this.toggleScrollStatus.bind(_this);
    _this.state = phaseDetailsBar__extends({}, _this.derivedStateFromProps(), { expand: false, scrolling: false });
    return _this;
  }

  return PhaseDetailsBar;
}(react["Component"]);

/* harmony default export */ var components_phaseDetailsBar = (phaseDetailsBar_PhaseDetailsBar);


phaseDetailsBar_PhaseDetailsBar.propTypes = {
  phase: types_phase.isRequired,
  role: prop_types_default.a.string.isRequired,
  position: prop_types_default.a.string.isRequired,
  mvw: prop_types_default.a.object,
  canViewWorkroom: prop_types_default.a.bool
};
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseEdit/index.jsx
function phaseEdit__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function phaseEdit__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function phaseEdit__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var phaseEdit_PhaseEdit = function (_Component) {
  phaseEdit__inherits(PhaseEdit, _Component);

  function PhaseEdit() {
    var _ref;

    var _temp, _this, _ret;

    phaseEdit__classCallCheck(this, PhaseEdit);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = phaseEdit__possibleConstructorReturn(this, (_ref = PhaseEdit.__proto__ || Object.getPrototypeOf(PhaseEdit)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'componentDidMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        if (_this.props.phase.id !== _this.props.id) _this.props.loadPhase(_this.props.id);
      }
    }), Object.defineProperty(_this, 'componentWillUnmount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.clearValidationErrors('PHASE');
      }
    }), Object.defineProperty(_this, 'handleCancel', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.navigate(urls.phaseInfo(_this.props.phase));
      }
    }), Object.defineProperty(_this, 'handleSave', {
      enumerable: true,
      writable: true,
      value: function value(phase) {
        return _this.props.updatePhase(phase, {}).then(function () {
          return _this.props.navigate(urls.phaseInfo(_this.props.phase));
        }).catch(function () {});
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            errors = _this$props.errors,
            loaded = _this$props.loaded,
            phase = _this$props.phase,
            role = _this$props.role,
            position = _this$props.position;

        return loaded ? react_default.a.createElement(
          'div',
          null,
          react_default.a.createElement(Helmet_default.a, { title: phase.customer_name }),
          react_default.a.createElement(components_phaseDetailsBar, {
            phase: phase,
            role: role,
            position: position
          }),
          react_default.a.createElement(
            flexbox_react_dist_default.a,
            null,
            react_default.a.createElement(
              'div',
              { className: contentArea_default.a.contentAreaContainer },
              react_default.a.createElement(phaseForm, {
                phase: phase,
                errors: errors,
                onSave: _this.handleSave,
                onCancel: _this.handleCancel,
                role: role,
                loading: phase.loading
              })
            )
          )
        ) : react_default.a.createElement(components_Loading, null);
      }
    }), _temp), phaseEdit__possibleConstructorReturn(_this, _ret);
  }

  return PhaseEdit;
}(react["Component"]);

phaseEdit_PhaseEdit.propTypes = {
  phase: types_phase,
  id: prop_types_default.a.number,
  errors: prop_types_default.a.object,
  loaded: prop_types_default.a.bool,
  role: prop_types_default.a.string.isRequired,
  position: prop_types_default.a.string.isRequired,
  navigate: prop_types_default.a.func.isRequired,
  updatePhase: prop_types_default.a.func.isRequired,
  loadPhase: prop_types_default.a.func.isRequired,
  clearValidationErrors: prop_types_default.a.func.isRequired
};

var phaseEdit_mapStateToProps = function mapStateToProps(state, ownProps) {
  var _state$phase$details = state.phase.details,
      phase = _state$phase$details === undefined ? {} : _state$phase$details,
      _state$user = state.user;
  _state$user = _state$user === undefined ? {} : _state$user;
  var _state$user$role = _state$user.role,
      role = _state$user$role === undefined ? '' : _state$user$role,
      _state$user$position = _state$user.position,
      position = _state$user$position === undefined ? '' : _state$user$position;

  return {
    id: Number(ownProps.params.id),
    phase: phase,
    loaded: phase.loaded || false,
    errors: Object(reducers["Y" /* getPhaseErrors */])(state) || {},
    role: role,
    position: position
  };
};

/* harmony default export */ var phaseEdit = (transpiled_default()()(Object(react_redux_es["connect"])(phaseEdit_mapStateToProps, {
  navigate: actionCreators["O" /* navigate */], updatePhase: actionCreators["_65" /* updatePhase */], loadPhase: actionCreators["G" /* loadPhase */], clearValidationErrors: actionCreators["k" /* clearValidationErrors */]
})(phaseEdit_PhaseEdit)));
// EXTERNAL MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/phaseTaskBar.scss
var phaseTaskBar = __webpack_require__("ZNld");
var phaseTaskBar_default = /*#__PURE__*/__webpack_require__.n(phaseTaskBar);

// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/phaseStatus.jsx






var phaseStatus_PhaseStatus = function PhaseStatus(_ref) {
  var _ref$phase = _ref.phase,
      status_name = _ref$phase.status_name,
      source = _ref$phase.source,
      _ref$phase$workroom = _ref$phase.workroom;
  _ref$phase$workroom = _ref$phase$workroom === undefined ? {} : _ref$phase$workroom;
  var _ref$phase$workroom$n = _ref$phase$workroom.name,
      workroom = _ref$phase$workroom$n === undefined ? '' : _ref$phase$workroom$n;
  return react_default.a.createElement(
    'div',
    { className: phaseTaskBar_default.a.phaseTaskBar__status },
    react_default.a.createElement(
      'h5',
      null,
      'Current Status'
    ),
    react_default.a.createElement(
      'span',
      { className: phaseTaskBar_default.a.statusText },
      Object(utils["b" /* deriveStatusName */])(status_name, { source: source, workroom: workroom })
    )
  );
};

phaseStatus_PhaseStatus.propTypes = { phase: types_phase.isRequired };

/* harmony default export */ var components_phaseStatus = (Object(react_redux_es["connect"])(function (state) {
  return { phase: state.phase.details };
})(phaseStatus_PhaseStatus));
// CONCATENATED MODULE: ./client/app/shared/components/UpdateDueDate/index.jsx
var UpdateDueDate__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function UpdateDueDate__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function UpdateDueDate__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function UpdateDueDate__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var UpdateDueDate_UpdateDueDate = function (_React$Component) {
  UpdateDueDate__inherits(UpdateDueDate, _React$Component);

  function UpdateDueDate() {
    var _ref;

    var _temp, _this, _ret;

    UpdateDueDate__classCallCheck(this, UpdateDueDate);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = UpdateDueDate__possibleConstructorReturn(this, (_ref = UpdateDueDate.__proto__ || Object.getPrototypeOf(UpdateDueDate)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'state', {
      enumerable: true,
      writable: true,
      value: { dueDate: '', dueTime: '' }
    }), Object.defineProperty(_this, 'componentDidMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setDueDate();
      }
    }), Object.defineProperty(_this, 'componentWillReceiveProps', {
      enumerable: true,
      writable: true,
      value: function value(nextProps) {
        return nextProps.value !== !_this.props.value ? _this.setDueDate(nextProps) : null;
      }
    }), Object.defineProperty(_this, 'onBlur', {
      enumerable: true,
      writable: true,
      value: function value() {
        if (_this.props.onChange) {
          var _this$state = _this.state,
              dueDate = _this$state.dueDate,
              dueTime = _this$state.dueTime;

          var dueDateTime = moment_default()(dueDate + ' ' + dueTime, 'MM/DD/YYYY HH:mm');
          if (dueDateTime.isBefore(moment_default()(dueDate + ' 08:00', 'MM/DD/YYYY HH:mm'))) {
            dueDateTime = moment_default()(dueDate + ' 08:00', 'MM/DD/YYYY HH:mm');
          }
          _this.props.onChange(dueDateTime.toISOString());
        }
      }
    }), Object.defineProperty(_this, 'setDueNow', {
      enumerable: true,
      writable: true,
      value: function value() {
        var time = moment_default()().format('HH:mm');
        var date = moment_default()().format('MM/DD/YYYY');
        _this.setState({ dueDate: date, dueTime: time }, _this.onBlur);
      }
    }), Object.defineProperty(_this, 'setDueDate', {
      enumerable: true,
      writable: true,
      value: function value() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;

        var dueAt = moment_default()(props.value);
        if (!dueAt.isValid()) return;
        _this.setState({
          dueDate: dueAt.format('MM/DD/YYYY'),
          dueTime: dueAt.format('HH:mm')
        });
      }
    }), Object.defineProperty(_this, 'handleDateChange', {
      enumerable: true,
      writable: true,
      value: function value(dueDate) {
        _this.state = UpdateDueDate__extends({}, _this.state, { dueDate: dueDate });
        _this.setState(_this.state);
      }
    }), Object.defineProperty(_this, 'handleTimeChange', {
      enumerable: true,
      writable: true,
      value: function value(dueTime) {
        return _this.setState({ dueTime: dueTime });
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$state2 = _this.state,
            dueDate = _this$state2.dueDate,
            dueTime = _this$state2.dueTime;
        var _this$props = _this.props,
            dateLabel = _this$props.dateLabel,
            timeLabel = _this$props.timeLabel,
            required = _this$props.required,
            errors = _this$props.errors;

        return react_default.a.createElement(
          'div',
          null,
          moment_default()().isSameOrAfter(moment_default()().startOf('day').add(8, 'hours')) && react_default.a.createElement(react_toolbox_lib["Button"], {
            label: 'Due Now',
            className: form_default.a.sidebarButton,
            onClick: _this.setDueNow
          }),
          react_default.a.createElement(
            'div',
            { className: form_default.a.row },
            react_default.a.createElement(DatePicker, {
              label: dateLabel,
              value: dueDate,
              onChange: _this.handleDateChange,
              onBlur: _this.onBlur,
              className: input_default.a.datepicker,
              placeholder: 'Select Date',
              required: required,
              error: errors.due_at || errors.dueAt
            }),
            react_default.a.createElement(components_TimeInput, {
              label: timeLabel,
              value: dueTime,
              onChange: _this.handleTimeChange,
              onBlur: _this.onBlur,
              errors: errors.due_at,
              required: required,
              setMin: true
            })
          )
        );
      }
    }), _temp), UpdateDueDate__possibleConstructorReturn(_this, _ret);
  }

  return UpdateDueDate;
}(react_default.a.Component);

UpdateDueDate_UpdateDueDate.propTypes = {
  value: prop_types_default.a.string.isRequired,
  onChange: prop_types_default.a.func.isRequired,
  errors: prop_types_default.a.shape({
    due_at: prop_types_default.a.arrayOf(prop_types_default.a.string)
  }),
  dateLabel: prop_types_default.a.string.isRequired,
  timeLabel: prop_types_default.a.string.isRequired,
  required: prop_types_default.a.bool.isRequired
};

UpdateDueDate_UpdateDueDate.defaultProps = {
  dateLabel: 'Date',
  timeLabel: 'Time',
  required: true
};

/* harmony default export */ var components_UpdateDueDate = (UpdateDueDate_UpdateDueDate);
// EXTERNAL MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/tasks/components/ContactCustomerModal/styles.scss
var ContactCustomerModal_styles = __webpack_require__("Rurv");
var ContactCustomerModal_styles_default = /*#__PURE__*/__webpack_require__.n(ContactCustomerModal_styles);

// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/tasks/components/ContactCustomerModal/index.jsx
var ContactCustomerModal__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function ContactCustomerModal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ContactCustomerModal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ContactCustomerModal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

























var ContactCustomerModal_DEFAULT_STATE = {
  loading: false,
  outcomes: [],
  phase: { phone_numbers: [], status: null },
  note: '',
  dueAt: '',
  commMethod: '',
  nonResponsive: false,
  task: {},
  errors: {}
};

var RESULTS = ['Reached', 'Left Message', 'Texted', 'Wrong Number', 'No Answer', 'Voicemail Not Setup', 'Voicemail Full', 'Phone Disconnected', 'Other', 'Reached on other line'].map(function (value) {
  return { value: value, label: value };
});

var NON_RESPONSIVE_FLAG_OPTIONS = {
  name: 'Estimator Inquiry',
  suboption: 'Customer Unreachable'
};

var ContactCustomerModal_REQUIRED_ERROR_MSG = 'Can\'t be blank.';

var ContactCustomerModal = function (_React$Component) {
  ContactCustomerModal__inherits(ContactCustomerModal, _React$Component);

  function ContactCustomerModal(props) {
    ContactCustomerModal__classCallCheck(this, ContactCustomerModal);

    var _this = ContactCustomerModal__possibleConstructorReturn(this, (ContactCustomerModal.__proto__ || Object.getPrototypeOf(ContactCustomerModal)).call(this, props));

    ContactCustomerModal__initialiseProps.call(_this);

    _this.state = _this.defaultState();
    return _this;
  }

  return ContactCustomerModal;
}(react_default.a.Component);

var ContactCustomerModal__initialiseProps = function _initialiseProps() {
  var _this2 = this;

  Object.defineProperty(this, 'componentWillReceiveProps', {
    enumerable: true,
    writable: true,
    value: function value(newProps) {
      return newProps.active && !_this2.props.active ? _this2.setState(_this2.defaultState(newProps)) : null;
    }
  });
  Object.defineProperty(this, 'getPhaseParams', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _state = _this2.state,
          dueAt = _state.dueAt,
          commMethod = _state.commMethod,
          _state$phase = _state.phase,
          status = _state$phase.status,
          phone_numbers = _state$phase.phone_numbers;

      var phase = { phone_numbers_attributes: phone_numbers };
      if (dueAt) phase.due_at = dueAt;
      if (status) phase.status = status;
      if (commMethod) phase.communication_method = commMethod;
      return phase;
    }
  });
  Object.defineProperty(this, 'defaultState', {
    enumerable: true,
    writable: true,
    value: function value() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this2.props;

      var attempt = _this2.props.events.length + 1;
      return ContactCustomerModal__extends({}, ContactCustomerModal_DEFAULT_STATE, {
        phase: {
          id: props.phase.id,
          phone_numbers: Object(lodash["cloneDeep"])(props.phase.phone_numbers)
        },
        dueAt: moment_default()().add(1, 'day').toISOString(),
        commMethod: props.phase.communication_method || 'none',
        outcomes: props.phase.phone_numbers.map(function () {
          return { result: [] };
        }),
        nonResponsive: props.flags.length > 0,
        task: props.task,
        attempt: attempt,
        outcomeNote: ''
      });
    }
  });
  Object.defineProperty(this, 'noteRequired', {
    enumerable: true,
    writable: true,
    value: function value() {
      var other = _this2.state.outcomes.find(function (o) {
        return o.result.find(function (r) {
          return r === 'Other';
        });
      });
      return _this2.state.nonResponsive || Object(lodash["isObject"])(other);
    }
  });
  Object.defineProperty(this, 'validate', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _state2 = _this2.state,
          note = _state2.note,
          outcomes = _state2.outcomes;

      var errors = {};
      if (_this2.noteRequired() && note.trim() === '') errors.note = ContactCustomerModal_REQUIRED_ERROR_MSG;
      outcomes.forEach(function (outcome, i) {
        if (!outcome.result.length) errors['result[' + i + ']'] = ContactCustomerModal_REQUIRED_ERROR_MSG;
      });
      if (Object.keys(errors).length > 0) {
        _this2.setState({ errors: errors });
        return false;
      }
      return true;
    }
  });
  Object.defineProperty(this, 'handleAddEvent', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _props = _this2.props,
          id = _props.phase.id,
          slug = _props.task.slug;
      var _state3 = _this2.state,
          outcomeNote = _state3.outcomeNote,
          note = _state3.note,
          attempt = _state3.attempt,
          nonResponsive = _state3.nonResponsive,
          outcomes = _state3.outcomes,
          dueAt = _state3.dueAt,
          commMethod = _state3.commMethod,
          phone_numbers = _state3.phase.phone_numbers,
          status = _state3.task.status;

      return _this2.props.updatePhaseTask(id, slug, {
        event: {
          data: {
            note: outcomeNote + '\n' + note,
            attempt: attempt,
            non_responsive: nonResponsive,
            outcomes: outcomes.map(function (outcome, i) {
              return ContactCustomerModal__extends({}, outcome, {
                type: 'phone',
                source: phone_numbers[i].number,
                reached: phone_numbers[i].reached,
                voicemail_not_setup: phone_numbers[i].voicemail_not_setup,
                ok_to_text: phone_numbers[i].ok_to_text
              });
            }),
            due_at: dueAt,
            communication_method: commMethod
          }
        },
        phase: _this2.getPhaseParams(),
        task: { status: status }
      });
    }
  });
  Object.defineProperty(this, 'handleScheduleAndRecord', {
    enumerable: true,
    writable: true,
    value: function value() {
      if (!_this2.validate()) return;
      var phase = _this2.props.phase;

      var url = phase.type === 'Assessment' ? urls.phaseAppointments(phase) : urls.phaseLaborProductAccounting(phase);
      var newState = { task: ContactCustomerModal__extends({}, _this2.state.task, { status: 'complete' }), loading: true };
      _this2.setState(newState, function () {
        return _this2.handleAddEvent().then(function () {
          return _this2.handleClose();
        }).then(function () {
          return _this2.props.navigate(url);
        }).catch(function () {
          return _this2.setState({ loading: false });
        });
      });
    }
  });
  Object.defineProperty(this, 'handleRecord', {
    enumerable: true,
    writable: true,
    value: function value() {
      var newState = { loading: true };
      if (!_this2.validate()) return;
      _this2.setState(newState, function () {
        return _this2.handleAddEvent().then(function () {
          return _this2.handleClose();
        }).catch(function () {
          return _this2.setState({ loading: false });
        });
      });
    }
  });
  Object.defineProperty(this, 'handleClose', {
    enumerable: true,
    writable: true,
    value: function value() {
      _this2.setState({ loading: false });
      _this2.props.clearValidationErrors('PHASE');
      _this2.props.onClose();
    }
  });
  Object.defineProperty(this, 'handleNoteChange', {
    enumerable: true,
    writable: true,
    value: function value(e) {
      return _this2.setState({ note: e.target.value });
    }
  });
  Object.defineProperty(this, 'hasReachedResult', {
    enumerable: true,
    writable: true,
    value: function value() {
      return _this2.state.outcomes.find(function (o) {
        return o.result.find(function (r) {
          return r === 'Reached';
        });
      });
    }
  });
  Object.defineProperty(this, 'handleOutcomeChange', {
    enumerable: true,
    writable: true,
    value: function value(i, key) {
      return function (options) {
        var outcomes = _this2.state.outcomes;
        var nonResponsive = _this2.state.nonResponsive;

        outcomes[i][key] = options.map(function (o) {
          return o.value;
        });
        if (key === 'result' && _this2.hasReachedResult()) {
          nonResponsive = false;
        }
        _this2.setState({ outcomes: outcomes, nonResponsive: nonResponsive, outcomeNote: _this2.formatOutcomeNote(outcomes) });
      };
    }
  });
  Object.defineProperty(this, 'formatOutcomeNote', {
    enumerable: true,
    writable: true,
    value: function value(outcomes) {
      return outcomes.reduce(function (acc, curr, i) {
        return curr.result.length === 0 ? acc : acc + '\n' + _this2.state.phase.phone_numbers[i].number + ' - ' + curr.result.join(', ');
      }, 'Attempt #' + _this2.state.attempt);
    }
  });
  Object.defineProperty(this, 'handlePhoneChange', {
    enumerable: true,
    writable: true,
    value: function value(i, key) {
      return function (val) {
        var _state4 = _this2.state,
            phase = _state4.phase,
            outcomes = _state4.outcomes;

        if (key === 'reached' && val && !phase.phone_numbers[i].reached && !outcomes[i].result.find(function (r) {
          return r === 'Reached';
        })) {
          outcomes[i].result.push('Reached');
          phase.phone_numbers.forEach(function (f, index) {
            if (f !== phase.phone_numbers[i]) outcomes[index].result.push('Reached on other line');
          });
        }
        if (key === 'voicemail_not_setup' && val && !phase.phone_numbers[i].voicemail_not_setup && !outcomes[i].result.find(function (r) {
          return r === 'Voicemail Not Setup';
        })) {
          outcomes[i].result.push('Voicemail Not Setup');
        }
        phase.phone_numbers[i][key] = val;
        _this2.setState({ phase: phase, outcomes: outcomes });
      };
    }
  });
  Object.defineProperty(this, 'handleNonResponsiveChange', {
    enumerable: true,
    writable: true,
    value: function value(val) {
      return _this2.setState({ nonResponsive: val });
    }
  });
  Object.defineProperty(this, 'handleDueChange', {
    enumerable: true,
    writable: true,
    value: function value(dueAt) {
      return _this2.setState({ dueAt: dueAt });
    }
  });
  Object.defineProperty(this, 'handleCommMethodChange', {
    enumerable: true,
    writable: true,
    value: function value(commMethod) {
      return _this2.setState({ commMethod: commMethod });
    }
  });
  Object.defineProperty(this, 'render', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _props2 = _this2.props,
          active = _props2.active,
          serverErrors = _props2.serverErrors,
          showNonResponsive = _props2.showNonResponsive,
          isInstall = _props2.isInstall;
      var _state5 = _this2.state,
          phase = _state5.phase,
          outcomes = _state5.outcomes,
          note = _state5.note,
          errors = _state5.errors,
          loading = _state5.loading,
          nonResponsive = _state5.nonResponsive,
          dueAt = _state5.dueAt,
          attempt = _state5.attempt,
          outcomeNote = _state5.outcomeNote,
          commMethod = _state5.commMethod;

      return react_default.a.createElement(
        react_toolbox_lib["Dialog"],
        {
          active: active,
          className: modal_default.a.modal,
          type: 'fullscreen',
          onEscKeyDown: _this2.handleClose
        },
        react_default.a.createElement(
          'div',
          { className: input_default.a.errored },
          serverErrors && Object.keys(serverErrors).length > 0 && react_default.a.createElement(
            'span',
            { className: input_default.a.error },
            'This action could not be completed.'
          )
        ),
        react_default.a.createElement(lib_button["IconButton"], {
          icon: 'close',
          className: modal_default.a.close,
          onClick: _this2.handleClose,
          tabIndex: -1
        }),
        react_default.a.createElement(
          'h5',
          { className: modal_default.a.title },
          'Contact Customer - Attempt #',
          attempt
        ),
        phase.phone_numbers.map(function (phone, i) {
          return react_default.a.createElement(
            'div',
            {
              key: 'phone_number_' + i // eslint-disable-line react/no-array-index-key
              , className: modal_default.a.clear
            },
            react_default.a.createElement(
              'h6',
              { className: modal_default.a.subtitle },
              'Phone Number ',
              i + 1
            ),
            react_default.a.createElement(react_select, {
              className: 'grouped ' + modal_default.a.dropdown,
              label: phone.number,
              onChange: _this2.handleOutcomeChange(i, 'result'),
              options: RESULTS,
              multi: true,
              value: outcomes[i].result,
              error: errors['result[' + i + ']']
            }),
            react_default.a.createElement(
              'div',
              { className: form_default.a.formElementContainer },
              react_default.a.createElement(react_toolbox_lib["Checkbox"], {
                checked: phone.reached,
                label: 'Reached on this number',
                theme: checkbox_default.a,
                className: form_default.a.checkboxListItem + ' ' + modal_default.a.checkboxListItem,
                onChange: _this2.handlePhoneChange(i, 'reached')
              }),
              react_default.a.createElement(react_toolbox_lib["Checkbox"], {
                checked: phone.voicemail_not_setup,
                label: 'Voicemail Not Setup',
                theme: checkbox_default.a,
                className: form_default.a.checkboxListItem + ' ' + modal_default.a.checkboxListItem,
                onChange: _this2.handlePhoneChange(i, 'voicemail_not_setup')
              }),
              react_default.a.createElement(react_toolbox_lib["Checkbox"], {
                checked: phone.ok_to_text,
                label: 'OK To Text',
                theme: checkbox_default.a,
                className: form_default.a.checkboxListItem + ' ' + modal_default.a.checkboxListItem,
                onChange: _this2.handlePhoneChange(i, 'ok_to_text')
              })
            )
          );
        }),
        react_default.a.createElement(
          'div',
          { className: form_default.a.formElementContainer + ' ' + modal_default.a.clear },
          react_default.a.createElement(components_UpdateDueDate, {
            value: dueAt,
            onChange: _this2.handleDueChange,
            errors: errors,
            dateLabel: 'Update Due Date',
            timeLabel: 'Update Due Date Time',
            required: false
          })
        ),
        isInstall && react_default.a.createElement(components_RadioButtons, {
          label: 'Automatic Communication Method',
          required: true,
          onChange: _this2.handleCommMethodChange,
          selectedValue: commMethod,
          radioButtons: [{ label: 'Text', value: 'text' }, { label: 'Email', value: 'email' }, { label: 'None', value: 'none' }]
        }),
        react_default.a.createElement(
          'div',
          { className: form_default.a.formElementContainer + ' ' + modal_default.a.clear + ' ' + modal_default.a.subtitle },
          react_default.a.createElement(
            'span',
            { className: ContactCustomerModal_styles_default.a.label },
            'OUTCOME NOTES'
          ),
          react_default.a.createElement(
            components_UserNote,
            { className: ContactCustomerModal_styles_default.a.outcomeNote },
            outcomeNote
          )
        ),
        react_default.a.createElement(
          'div',
          { className: form_default.a.formElementContainer + ' ' + modal_default.a.clear },
          react_default.a.createElement(components_TextArea, {
            label: 'Additional Notes ' + (_this2.noteRequired() ? '*' : ''),
            value: note,
            errors: [errors.note],
            onChange: _this2.handleNoteChange
          })
        ),
        showNonResponsive && attempt > 2 && !_this2.hasReachedResult() && react_default.a.createElement(react_toolbox_lib["Checkbox"], {
          checked: nonResponsive,
          label: 'Customer is non-responsive',
          theme: checkbox_default.a,
          className: checkbox_default.a.large + ' ' + modal_default.a.element,
          onChange: _this2.handleNonResponsiveChange
        }),
        react_default.a.createElement(
          'div',
          { className: modal_default.a.actions },
          !nonResponsive && react_default.a.createElement(lib_button["Button"], {
            label: 'Continue Scheduling',
            flat: true, inverse: true, ripple: true,
            className: modal_default.a.smallAction,
            onClick: _this2.handleScheduleAndRecord,
            disabled: loading
          }),
          react_default.a.createElement(lib_button["Button"], {
            label: 'Record Attempt',
            flat: true, inverse: true, ripple: true,
            className: modal_default.a.smallAction,
            onClick: _this2.handleRecord,
            disabled: loading
          })
        )
      );
    }
  });
};

ContactCustomerModal.propTypes = {
  active: prop_types_default.a.bool.isRequired,
  clearValidationErrors: prop_types_default.a.func.isRequired,
  updatePhaseTask: prop_types_default.a.func.isRequired,
  navigate: prop_types_default.a.func.isRequired,
  onClose: prop_types_default.a.func.isRequired,
  phase: types_phase.isRequired,
  task: types_task.isRequired,
  events: prop_types_default.a.array.isRequired,
  serverErrors: prop_types_default.a.shape({}),
  showNonResponsive: prop_types_default.a.bool.isRequired,
  isInstall: prop_types_default.a.bool.isRequired
};

ContactCustomerModal.defaultProps = {
  active: false,
  showNonResponsive: true,
  isInstall: false
};

var ContactCustomerModal_getAttempts = function getAttempts(slug) {
  return Object(reselect_lib["createSelector"])(function (state) {
    return Object(reducers["Z" /* getPhaseEvents */])(state, slug);
  }, function (events) {
    return events.filter(function (e) {
      return e.data.attempt;
    });
  });
};

var getNonResponsiveFlags = Object(reselect_lib["createSelector"])(reducers["_4" /* getPhaseFlags */], function (flags) {
  return flags.filter(function (flag) {
    return flag.name === NON_RESPONSIVE_FLAG_OPTIONS.name && flag.suboption === NON_RESPONSIVE_FLAG_OPTIONS.suboption;
  });
});

/* harmony default export */ var components_ContactCustomerModal = (Object(react_redux_es["connect"])(function (state, ownProps) {
  return {
    serverErrors: Object(reducers["Y" /* getPhaseErrors */])(state),
    events: ContactCustomerModal_getAttempts(ownProps.task.slug)(state),
    flags: getNonResponsiveFlags(state)
  };
}, {
  navigate: actionCreators["O" /* navigate */],
  clearValidationErrors: actionCreators["k" /* clearValidationErrors */],
  updatePhaseTask: actionCreators["_67" /* updatePhaseTask */]
})(ContactCustomerModal));
// EXTERNAL MODULE: ./client/app/shared/components/MessageBox/styles.scss
var MessageBox_styles = __webpack_require__("Brzw");
var MessageBox_styles_default = /*#__PURE__*/__webpack_require__.n(MessageBox_styles);

// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/jobPaperworkTemplateTypes.js
// Centralized mapping for IFI Job Paperwork template types.
// This reduces drift between template dropdown options and warning display labels.

var JOB_PAPERWORK_TEMPLATE_LABELS = {
  window_worksheet: 'Window Worksheet',
  entry_door_worksheet: 'Entry Door Worksheet',
  storm_door_worksheet: 'Storm Door Worksheet',
  interior_door_worksheet: 'Interior Door Worksheet',
  workorder_inspection: 'Workorder Inspection'
};

var JOB_PAPERWORK_TEMPLATE_OPTIONS = {
  Assessment: [{ value: 'window_worksheet', label: JOB_PAPERWORK_TEMPLATE_LABELS.window_worksheet }, { value: 'entry_door_worksheet', label: JOB_PAPERWORK_TEMPLATE_LABELS.entry_door_worksheet }, { value: 'storm_door_worksheet', label: JOB_PAPERWORK_TEMPLATE_LABELS.storm_door_worksheet }, { value: 'interior_door_worksheet', label: JOB_PAPERWORK_TEMPLATE_LABELS.interior_door_worksheet }],
  Workorder: [{ value: 'workorder_inspection', label: JOB_PAPERWORK_TEMPLATE_LABELS.workorder_inspection }]
};
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/tasks/components/JobPaperworkWarning.jsx
var JobPaperworkWarning__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function JobPaperworkWarning__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function JobPaperworkWarning__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function JobPaperworkWarning__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var JobPaperworkWarning_JobPaperworkWarning = function (_React$Component) {
  JobPaperworkWarning__inherits(JobPaperworkWarning, _React$Component);

  function JobPaperworkWarning() {
    var _ref;

    var _temp, _this, _ret;

    JobPaperworkWarning__classCallCheck(this, JobPaperworkWarning);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = JobPaperworkWarning__possibleConstructorReturn(this, (_ref = JobPaperworkWarning.__proto__ || Object.getPrototypeOf(JobPaperworkWarning)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'handleMessage', {
      enumerable: true,
      writable: true,
      value: function value(taskSlug, permitRequired) {
        var validationError = JobPaperworkWarning.validate(_this.props.templates, taskSlug);
        if (validationError) return validationError;

        if (taskSlug === 'workorder_complete' && permitRequired) {
          return 'Please verify that all required permits were completed in vendor gateway.';
        }
        return '';
      }
    }), _temp), JobPaperworkWarning__possibleConstructorReturn(_this, _ret);
  }

  JobPaperworkWarning__createClass(JobPaperworkWarning, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          templates = _props.templates,
          taskSlug = _props.taskSlug,
          templatesLoaded = _props.templatesLoaded,
          templatesLoadError = _props.templatesLoadError;

      var defaultMessage = 'Please confirm that all required job paperwork (if any) is completed.';

      if (templatesLoaded === false) return null;

      if (templatesLoadError) {
        return react_default.a.createElement(MessageBox["a" /* default */], { error: true, message: 'Unable to load job paperwork templates. Please try again.' });
      }

      if (!templates) return null;

      var completedTemplates = templates.filter(function (t) {
        return t.document_upload_id && !t.not_use;
      });
      var permitRequired = this.props.permitRequired || false;

      var message = this.handleMessage(taskSlug, permitRequired);

      return react_default.a.createElement(
        MessageBox["a" /* default */],
        { message: message || defaultMessage },
        completedTemplates.length > 0 && react_default.a.createElement(
          'ul',
          { className: MessageBox_styles_default.a.completedList },
          completedTemplates.map(function (t) {
            return react_default.a.createElement(
              'li',
              { key: t.id },
              react_default.a.createElement(
                'strong',
                null,
                'Completed: ' + (JOB_PAPERWORK_TEMPLATE_LABELS[t.template_type] || t.template_type)
              )
            );
          })
        )
      );
    }
  }], [{
    key: 'validate',
    value: function validate(templates, taskSlug) {
      if (!Array.isArray(templates)) return null;

      var completedTemplates = templates.filter(function (t) {
        return t.document_upload_id && !t.not_use;
      });

      if (taskSlug === 'measure' && completedTemplates.length === 0) {
        return 'At least one completed template is required to complete the Measure task. Please complete a template using the IFI Template action button.';
      }
      return null;
    }
  }]);

  return JobPaperworkWarning;
}(react_default.a.Component);

/* harmony default export */ var components_JobPaperworkWarning = (JobPaperworkWarning_JobPaperworkWarning);


JobPaperworkWarning_JobPaperworkWarning.propTypes = {
  templates: prop_types_default.a.array,
  taskSlug: prop_types_default.a.string.isRequired,
  templatesLoaded: prop_types_default.a.bool,
  templatesLoadError: prop_types_default.a.bool,
  permitRequired: prop_types_default.a.bool
};

JobPaperworkWarning_JobPaperworkWarning.defaultProps = {
  templatesLoaded: false,
  templatesLoadError: false,
  permitRequired: false
};
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/tasks/components/CompleteTaskModal/index.jsx
var CompleteTaskModal__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var CompleteTaskModal__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function CompleteTaskModal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function CompleteTaskModal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function CompleteTaskModal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var CompleteTaskModal_CompleteTaskModal = function (_Resetter) {
  CompleteTaskModal__inherits(CompleteTaskModal, _Resetter);

  function CompleteTaskModal() {
    var _ref;

    var _temp, _this, _ret;

    CompleteTaskModal__classCallCheck(this, CompleteTaskModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = CompleteTaskModal__possibleConstructorReturn(this, (_ref = CompleteTaskModal.__proto__ || Object.getPrototypeOf(CompleteTaskModal)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'componentDidMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        if (_this.props.active && _this.shouldLoadTemplates()) _this.loadTemplates();
      }
    }), Object.defineProperty(_this, 'componentDidUpdate', {
      enumerable: true,
      writable: true,
      value: function value(prevProps) {
        var becameActive = !prevProps.active && _this.props.active;
        var _this$props = _this.props,
            phase = _this$props.phase,
            slug = _this$props.task.slug;

        var relevantPhaseChanged = prevProps.phase.id !== phase.id;
        var relevantTaskChanged = prevProps.task.slug !== slug;

        if (_this.props.active && (becameActive || relevantPhaseChanged || relevantTaskChanged) && _this.shouldLoadTemplates()) {
          _this.loadTemplates();
        }
      }
    }), Object.defineProperty(_this, 'shouldLoadTemplates', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props2 = _this.props,
            phase = _this$props2.phase,
            slug = _this$props2.task.slug;
        var type = phase.type;

        return (slug === 'workorder_complete' || slug === 'measure') && (type === 'Assessment' || type === 'Workorder') && ifiUtils(phase);
      }
    }), Object.defineProperty(_this, 'loadTemplates', {
      enumerable: true,
      writable: true,
      value: function value() {
        var phase = _this.props.phase;

        _this.setState({ templates: [], templatesLoaded: false, templatesLoadError: false });
        Object(actionCreators["_11" /* requestJobPaperworkTemplates */])(phase.id).then(function (_ref2) {
          var templates = _ref2.templates,
              error = _ref2.error;

          if (error) {
            _this.setState({ templatesLoaded: true, templatesLoadError: true });
            return;
          }
          _this.setState({
            templates: templates,
            templatesLoaded: true,
            templatesLoadError: false
          });
        });
      }
    }), Object.defineProperty(_this, 'phasePermitRequired', {
      enumerable: true,
      writable: true,
      value: function value() {
        var phase = _this.props.phase;

        return !!(phase && phase.phase_specific && phase.phase_specific.millwork_specifics && phase.phase_specific.millwork_specifics.permit_required);
      }
    }), Object.defineProperty(_this, 'data', {
      enumerable: true,
      writable: true,
      value: function value() {
        return { event: { data: { note: _this.state.note } } };
      }
    }), Object.defineProperty(_this, 'handleSubmit', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props3 = _this.props,
            phase = _this$props3.phase,
            slug = _this$props3.task.slug,
            updatePhaseTask = _this$props3.updatePhaseTask,
            childHandleTasksClose = _this$props3.childHandleTasksClose;

        if (!_this.validate()) return;

        var task = { status: 'complete' };

        var completeTask = function completeTask() {
          var data = _this.data();
          updatePhaseTask(phase.id, slug, CompleteTaskModal__extends({ task: task }, data)).then(function () {
            return childHandleTasksClose();
          }).then(function () {
            return _this.handleClose();
          }).catch(function (result) {
            return _this.setState({ sendError: true, errors: result.payload.errors });
          });
        };

        if (_this.shouldLoadTemplates()) {
          Object(actionCreators["_11" /* requestJobPaperworkTemplates */])(phase.id).then(function (_ref3) {
            var templates = _ref3.templates,
                error = _ref3.error;

            if (error) {
              _this.setState({
                sendError: true,
                errors: {
                  templates: ['Unable to load job paperwork templates. Please try again.']
                }
              });
              return;
            }

            _this.setState({ templates: templates, templatesLoaded: true, templatesLoadError: false });

            var validationError = components_JobPaperworkWarning.validate(templates, slug);
            if (validationError) {
              _this.setState({
                sendError: true,
                errors: {
                  templates: [validationError]
                }
              });
              return;
            }

            completeTask();
          });
          return;
        }

        completeTask();
      }
    }), Object.defineProperty(_this, 'handleNoteChange', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        return _this.setState({ note: e.target.value });
      }
    }), Object.defineProperty(_this, 'handlePermitCheckChange', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        return _this.setState({ checked: e.target.checked });
      }
    }), _temp), CompleteTaskModal__possibleConstructorReturn(_this, _ret);
  }

  CompleteTaskModal__createClass(CompleteTaskModal, [{
    key: 'render',
    value: function render() {
      var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var errorMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var phasePermitRequired = this.phasePermitRequired();
      var _props = this.props,
          active = _props.active,
          task = _props.task;
      var _state = this.state,
          note = _state.note,
          errors = _state.errors,
          sendError = _state.sendError;

      var noteLabel = this.constructor.NOTE_LABEL || 'Notes ' + (this.constructor.VALIDATIONS.note ? '*' : '');
      var shouldLoadTemplates = this.shouldLoadTemplates();
      return react_default.a.createElement(
        react_toolbox_lib["Dialog"],
        {
          active: active,
          className: modal_default.a.modal,
          type: 'fullscreen',
          onEscKeyDown: this.handleClose,
          onOverlayClick: this.handleClose
        },
        react_default.a.createElement(lib_button["IconButton"], {
          icon: 'close',
          className: modal_default.a.close,
          onClick: this.handleClose,
          tabIndex: -1
        }),
        react_default.a.createElement(
          'h5',
          { className: modal_default.a.title },
          'Complete Task: ',
          task.name
        ),
        (task.slug === 'workorder_complete' || task.slug === 'measure') && (this.props.phase.type === 'Assessment' || this.props.phase.type === 'Workorder') && ifiUtils(this.props.phase) && react_default.a.createElement(components_JobPaperworkWarning, {
          templates: this.state.templates,
          templatesLoaded: this.state.templatesLoaded,
          templatesLoadError: this.state.templatesLoadError,
          taskSlug: task.slug,
          permitRequired: phasePermitRequired
        }),
        shouldLoadTemplates && phasePermitRequired && task.slug !== 'measure' && react_default.a.createElement(
          react_default.a.Fragment,
          null,
          react_default.a.createElement('input', {
            type: 'checkbox',
            id: 'permit-uploaded-checkbox',
            name: 'permit-uploaded',
            value: 'yes',
            checked: this.state.checked,
            onChange: this.handlePermitCheckChange
          }),
          react_default.a.createElement(
            'label',
            {
              htmlFor: 'permit-uploaded-checkbox',
              className: modal_default.a.imsCheckboxLabel
            },
            'Permits were uploaded to IMS'
          ),
          react_default.a.createElement('br', null)
        ),
        react_default.a.createElement(components_TextArea, {
          label: noteLabel,
          value: note,
          errors: errors.note,
          onChange: this.handleNoteChange,
          autoFocus: true
        }),
        errorMessage && react_default.a.createElement(MessageBox["a" /* default */], { error: true, message: errorMessage }),
        sendError && !errorMessage && react_default.a.createElement(MessageBox["a" /* default */], { error: true, message: Object(utils["d" /* errorSummary */])(errors.templates || errors) }),
        task.name !== 'Complete Verification' && children,
        react_default.a.createElement(
          'div',
          { className: modal_default.a.actions },
          react_default.a.createElement(ColoredButton["a" /* default */], {
            color: 'green',
            responsive: true,
            label: 'Complete Task',
            className: modal_default.a.button,
            onClick: this.handleSubmit,
            disabled: shouldLoadTemplates && (!!components_JobPaperworkWarning.validate(this.state.templates, task.slug) || phasePermitRequired && !this.state.checked && task.slug !== 'measure')
          }),
          react_default.a.createElement(ColoredButton["a" /* default */], {
            color: 'darkGray',
            responsive: true,
            label: 'Cancel',
            className: modal_default.a.button,
            onClick: this.handleClose
          })
        )
      );
    }
  }]);

  return CompleteTaskModal;
}(resetter(validator(react_default.a.Component)));

Object.defineProperty(CompleteTaskModal_CompleteTaskModal, 'DEFAULT_STATE', {
  enumerable: true,
  writable: true,
  value: {
    note: '',
    errors: {},
    sendError: false,
    templates: [],
    templatesLoaded: false,
    templatesLoadError: false,
    checked: false
  }
});
Object.defineProperty(CompleteTaskModal_CompleteTaskModal, 'VALIDATIONS', {
  enumerable: true,
  writable: true,
  value: { note: 'This field is required' }
});


CompleteTaskModal_CompleteTaskModal.propTypes = {
  active: prop_types_default.a.bool.isRequired,
  phase: types_phase.isRequired,
  task: types_task.isRequired,
  onClose: prop_types_default.a.func.isRequired,
  updatePhaseTask: prop_types_default.a.func.isRequired,
  childHandleTasksClose: prop_types_default.a.func.isRequired
};

CompleteTaskModal_CompleteTaskModal.defaultProps = { active: false };

/* harmony default export */ var components_CompleteTaskModal = (CompleteTaskModal_CompleteTaskModal);
// EXTERNAL MODULE: ./client/app/shared/components/TaskIcon/styles.scss
var TaskIcon_styles = __webpack_require__("YV0Z");
var TaskIcon_styles_default = /*#__PURE__*/__webpack_require__.n(TaskIcon_styles);

// CONCATENATED MODULE: ./client/app/shared/components/TaskIcon/index.jsx






var TaskIcon_TaskIcon = function TaskIcon(_ref) {
  var status = _ref.status;

  switch (status) {
    case 'complete':
      return react_default.a.createElement(react_toolbox_lib["FontIcon"], { className: TaskIcon_styles_default.a.taskCheckedIcon, value: 'check_circle' });
    case 'pending':
      return react_default.a.createElement(components_Loading, { size: '24', radius: '10' });
    default:
      return react_default.a.createElement(react_toolbox_lib["FontIcon"], { className: TaskIcon_styles_default.a.taskClockIcon, value: 'access_time' });
  }
};

TaskIcon_TaskIcon.defaultProps = {
  status: 'incomplete'
};

TaskIcon_TaskIcon.propTypes = {
  status: prop_types_default.a.oneOf(['complete', 'pending', 'incomplete'])
};

/* harmony default export */ var components_TaskIcon = (TaskIcon_TaskIcon);
// EXTERNAL MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/phaseTask.scss
var phaseTask = __webpack_require__("u8j8");
var phaseTask_default = /*#__PURE__*/__webpack_require__.n(phaseTask);

// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/tasks/phase_task.jsx
function phase_task__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function phase_task__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function phase_task__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var phase_task_PhaseTask = function (_React$Component) {
  phase_task__inherits(PhaseTask, _React$Component);

  function PhaseTask() {
    var _ref;

    var _temp, _this, _ret;

    phase_task__classCallCheck(this, PhaseTask);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = phase_task__possibleConstructorReturn(this, (_ref = PhaseTask.__proto__ || Object.getPrototypeOf(PhaseTask)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'state', {
      enumerable: true,
      writable: true,
      value: { modalActive: false, errorModalActive: false }
    }), Object.defineProperty(_this, 'onClick', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ modalActive: true });
      }
    }), Object.defineProperty(_this, 'handleClose', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.props.handleTasksClose();
        _this.setState({ modalActive: false });
      }
    }), Object.defineProperty(_this, 'isDisabled', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.task.status !== 'incomplete';
      }
    }), Object.defineProperty(_this, 'determineIsMissingApptError', {
      enumerable: true,
      writable: true,
      value: function value(errorModalActive, errors, errorSources) {
        return errorModalActive && errorSources.length === 1 && errors[errorSources[0]].length === 1 && errors[errorSources[0]][0] === 'At least one appointment must be scheduled before completing this task';
      }
    }), Object.defineProperty(_this, 'determineIsBuildDateError', {
      enumerable: true,
      writable: true,
      value: function value(errorModalActive, errors, errorSources) {
        return errorModalActive && errorSources.length === 1 && errors[errorSources[0]].length === 1 && errors[errorSources[0]][0] === 'Verify build date flag is still present. Please resolve before completing this task.';
      }
    }), Object.defineProperty(_this, 'preSubmitMissingApptError', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            _this$props$phase$app = _this$props.phase.appointments,
            appointments = _this$props$phase$app === undefined ? [] : _this$props$phase$app,
            slug = _this$props.task.slug;

        return slug === 'installation_customer_review' && (!appointments.length || !appointments.some(function (a) {
          return a.kind === 'installation' && moment_default()(a.start_date, constants["_19" /* RAILS_DATE */]).isAfter(moment_default()());
        }));
      }
    }), Object.defineProperty(_this, 'toggleStatus', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.updatePhaseTask(_this.props.phase.id, _this.props.task.slug, { task: { status: _this.props.task.status === 'complete' ? 'incomplete' : 'complete' } });
      }
    }), Object.defineProperty(_this, 'completeTask', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.props.updatePhaseTask(_this.props.phase.id, _this.props.task.slug, { task: { status: 'complete' } }).catch(function () {
          return _this.setState({ errorModalActive: true });
        });
        _this.childHandleTasksClose();
      }
    }), Object.defineProperty(_this, 'childHandleTasksClose', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.handleTasksClose();
      }
    }), Object.defineProperty(_this, 'handleErrorClose', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.setState({ errorModalActive: false });
        _this.props.clearValidationErrors('PHASE');
      }
    }), Object.defineProperty(_this, 'renderErrorMessage', {
      enumerable: true,
      writable: true,
      value: function value(name, errors, errorSources) {
        return react_default.a.createElement(
          'h5',
          {
            className: modal_default.a.errorMessage
          },
          'Cannot complete ',
          name,
          ' task:',
          ' ',
          errorSources.map(function (resource) {
            return [].concat(errors[resource]).join(', ');
          }).join(', ')
        );
      }
    }), Object.defineProperty(_this, 'renderErrorDialog', {
      enumerable: true,
      writable: true,
      value: function value() {
        var errorModalActive = _this.state.errorModalActive;
        var _this$props2 = _this.props,
            phase = _this$props2.phase,
            errors = _this$props2.phase.errors,
            name = _this$props2.task.name;

        var errorSources = Object.keys(errors) || {};
        var isMissingApptError = _this.determineIsMissingApptError(errorModalActive, errors, errorSources);
        var isVerifyBuildDateError = _this.determineIsBuildDateError(errorModalActive, errors, errorSources);
        return react_default.a.createElement(
          react_toolbox_lib["Dialog"],
          {
            active: errorModalActive,
            className: modal_default.a.modal,
            type: 'fullscreen',
            onEscKeyDown: _this.handleErrorClose,
            onOverlayClick: _this.handleErrorClose
          },
          _this.renderErrorMessage(name, errors, errorSources),
          isMissingApptError && react_default.a.createElement(
            flexbox_react_dist_default.a,
            { justifyContent: 'center' },
            react_default.a.createElement(
              es["c" /* Link */],
              {
                to: urls.phaseAppointments(phase),
                className: modal_default.a.linkButton,
                onClick: _this.handleErrorClose
              },
              'Schedule Appointment'
            )
          ),
          isVerifyBuildDateError && react_default.a.createElement(
            flexbox_react_dist_default.a,
            { justifyContent: 'center' },
            react_default.a.createElement(react_toolbox_lib["Button"], {
              label: 'OK',
              flat: true, inverse: true, ripple: true,
              className: modal_default.a.action,
              onClick: _this.handleErrorClose
            })
          ),
          !isMissingApptError && !isVerifyBuildDateError && react_default.a.createElement(react_toolbox_lib["Button"], {
            label: 'OK',
            flat: true, inverse: true, ripple: true,
            className: modal_default.a.action,
            onClick: _this.handleErrorClose
          })
        );
      }
    }), Object.defineProperty(_this, 'renderChildren', {
      enumerable: true,
      writable: true,
      value: function value() {
        return react_default.a.createElement(components_CompleteTaskModal, {
          phase: _this.props.phase,
          task: _this.props.task,
          active: _this.state.modalActive,
          completeTask: _this.completeTask,
          onClose: _this.handleClose,
          updatePhaseTask: _this.props.updatePhaseTask,
          childHandleTasksClose: _this.childHandleTasksClose
        });
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props$task = _this.props.task,
            name = _this$props$task.name,
            status = _this$props$task.status;

        var preSubmitApptDisabled = _this.preSubmitMissingApptError();
        return react_default.a.createElement(
          'div',
          { className: phaseTask_default.a.taskContainer },
          react_default.a.createElement(components_TaskIcon, { status: status }),
          react_default.a.createElement(
            'button',
            {
              className: preSubmitApptDisabled ? phaseTask_default.a.taskButtonBlocked : phaseTask_default.a.taskButton,
              onClick: _this.onClick,
              disabled: preSubmitApptDisabled || _this.isDisabled()
            },
            '' + name + (preSubmitApptDisabled ? ' (Requires Pending Installation Appointment)' : '')
          ),
          _this.renderChildren(),
          _this.renderErrorDialog()
        );
      }
    }), _temp), phase_task__possibleConstructorReturn(_this, _ret);
  }

  return PhaseTask;
}(react_default.a.Component);

/* harmony default export */ var phase_task = (phase_task_PhaseTask);


phase_task_PhaseTask.propTypes = {
  phase: types_phase.isRequired,
  task: types_task.isRequired,
  updatePhaseTask: prop_types_default.a.func.isRequired,
  clearValidationErrors: prop_types_default.a.func.isRequired,
  handleTasksClose: prop_types_default.a.func.isRequired
};

var phase_task_phase_task = Object(react_redux_es["connect"])(function () {
  return {};
}, {
  updatePhaseTask: actionCreators["_67" /* updatePhaseTask */],
  clearValidationErrors: actionCreators["k" /* clearValidationErrors */]
})(phase_task_PhaseTask);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/tasks/contact_customer.jsx
function contact_customer__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function contact_customer__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function contact_customer__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var contact_customer_ContactCustomerPhaseTask = function (_PhaseTask) {
  contact_customer__inherits(ContactCustomerPhaseTask, _PhaseTask);

  function ContactCustomerPhaseTask() {
    var _ref;

    var _temp, _this, _ret;

    contact_customer__classCallCheck(this, ContactCustomerPhaseTask);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = contact_customer__possibleConstructorReturn(this, (_ref = ContactCustomerPhaseTask.__proto__ || Object.getPrototypeOf(ContactCustomerPhaseTask)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'isDisabled', {
      enumerable: true,
      writable: true,
      value: function value() {
        return false;
      }
    }), Object.defineProperty(_this, 'onClick', {
      enumerable: true,
      writable: true,
      value: function value() {
        if (_this.props.task.status === 'complete') {
          _this.toggleStatus();
        } else {
          _this.setState({ modalActive: true });
        }
      }
    }), Object.defineProperty(_this, 'renderChildren', {
      enumerable: true,
      writable: true,
      value: function value() {
        return react_default.a.createElement(components_ContactCustomerModal, {
          phase: _this.props.phase,
          task: _this.props.task,
          active: _this.state.modalActive,
          completeTask: _this.completeTask,
          onClose: _this.handleClose
        });
      }
    }), _temp), contact_customer__possibleConstructorReturn(_this, _ret);
  }

  return ContactCustomerPhaseTask;
}(phase_task);

contact_customer_ContactCustomerPhaseTask.propTypes = {
  phase: types_phase.isRequired,
  task: types_task.isRequired,
  updatePhaseTask: prop_types_default.a.func.isRequired
};

var contact_customer_contact_customer = Object(react_redux_es["connect"])(function () {
  return {};
}, { updatePhaseTask: actionCreators_phase["s" /* updatePhaseTask */] })(contact_customer_ContactCustomerPhaseTask);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/tasks/install_contact_customer.jsx
function install_contact_customer__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function install_contact_customer__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function install_contact_customer__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var install_contact_customer_InstallContactCustomerPhaseTask = function (_PhaseTask) {
  install_contact_customer__inherits(InstallContactCustomerPhaseTask, _PhaseTask);

  function InstallContactCustomerPhaseTask() {
    var _ref;

    var _temp, _this, _ret;

    install_contact_customer__classCallCheck(this, InstallContactCustomerPhaseTask);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = install_contact_customer__possibleConstructorReturn(this, (_ref = InstallContactCustomerPhaseTask.__proto__ || Object.getPrototypeOf(InstallContactCustomerPhaseTask)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'isDisabled', {
      enumerable: true,
      writable: true,
      value: function value() {
        return false;
      }
    }), Object.defineProperty(_this, 'onClick', {
      enumerable: true,
      writable: true,
      value: function value() {
        if (_this.props.task.status === 'complete') {
          _this.toggleStatus();
        } else {
          _this.setState({ modalActive: true });
        }
      }
    }), Object.defineProperty(_this, 'renderChildren', {
      enumerable: true,
      writable: true,
      value: function value() {
        return react_default.a.createElement(components_ContactCustomerModal, {
          phase: _this.props.phase,
          task: _this.props.task,
          active: _this.state.modalActive,
          completeTask: _this.completeTask,
          onClose: _this.handleClose,
          showNonResponsive: false,
          isInstall: true
        });
      }
    }), _temp), install_contact_customer__possibleConstructorReturn(_this, _ret);
  }

  return InstallContactCustomerPhaseTask;
}(phase_task);

install_contact_customer_InstallContactCustomerPhaseTask.propTypes = {
  phase: types_phase.isRequired,
  task: types_task.isRequired,
  updatePhaseTask: prop_types_default.a.func.isRequired
};

var install_contact_customer = Object(react_redux_es["connect"])(function () {
  return {};
}, {
  updatePhaseTask: actionCreators_phase["s" /* updatePhaseTask */]
})(install_contact_customer_InstallContactCustomerPhaseTask);


// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/tasks/schedule.jsx
function schedule__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function schedule__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function schedule__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var SchedulePhaseTask = function (_PhaseTask) {
  schedule__inherits(SchedulePhaseTask, _PhaseTask);

  function SchedulePhaseTask() {
    var _ref;

    var _temp, _this, _ret;

    schedule__classCallCheck(this, SchedulePhaseTask);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = schedule__possibleConstructorReturn(this, (_ref = SchedulePhaseTask.__proto__ || Object.getPrototypeOf(SchedulePhaseTask)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'onClick', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.completeTask();
      }
    }), _temp), schedule__possibleConstructorReturn(_this, _ret);
  }

  return SchedulePhaseTask;
}(phase_task);

var schedule_schedule = Object(react_redux_es["connect"])(function () {
  return {};
}, { updatePhaseTask: actionCreators["_67" /* updatePhaseTask */], clearValidationErrors: actionCreators["k" /* clearValidationErrors */] })(SchedulePhaseTask);

// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/tasks/reschedule_install.jsx
function reschedule_install__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function reschedule_install__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function reschedule_install__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var reschedule_install_RescheduleInstall = function (_PhaseTask) {
  reschedule_install__inherits(RescheduleInstall, _PhaseTask);

  function RescheduleInstall() {
    var _ref;

    var _temp, _this, _ret;

    reschedule_install__classCallCheck(this, RescheduleInstall);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = reschedule_install__possibleConstructorReturn(this, (_ref = RescheduleInstall.__proto__ || Object.getPrototypeOf(RescheduleInstall)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'isDisabled', {
      enumerable: true,
      writable: true,
      value: function value() {
        return false;
      }
    }), Object.defineProperty(_this, 'onClick', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.task.status !== 'complete' ? _this.props.navigate(urls.phaseAppointments(_this.props.phase)) : _this.toggleStatus();
      }
    }), _temp), reschedule_install__possibleConstructorReturn(_this, _ret);
  }

  return RescheduleInstall;
}(phase_task);

reschedule_install_RescheduleInstall.propTypes = {
  phase: types_phase.isRequired,
  task: types_task.isRequired,
  updatePhaseTask: prop_types_default.a.func.isRequired,
  navigate: prop_types_default.a.func.isRequired
};

var reschedule_install = Object(react_redux_es["connect"])(function () {
  return function (state) {
    return {
      user: state.user
    };
  };
}, { updatePhaseTask: actionCreators_phase["s" /* updatePhaseTask */], navigate: actionCreators["O" /* navigate */] })(reschedule_install_RescheduleInstall);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/tasks/send_to_floor_wizard.jsx
function send_to_floor_wizard__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function send_to_floor_wizard__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function send_to_floor_wizard__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var SendToFloorWizardPhaseTask = function (_PhaseTask) {
  send_to_floor_wizard__inherits(SendToFloorWizardPhaseTask, _PhaseTask);

  function SendToFloorWizardPhaseTask() {
    var _ref;

    var _temp, _this, _ret;

    send_to_floor_wizard__classCallCheck(this, SendToFloorWizardPhaseTask);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = send_to_floor_wizard__possibleConstructorReturn(this, (_ref = SendToFloorWizardPhaseTask.__proto__ || Object.getPrototypeOf(SendToFloorWizardPhaseTask)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'onClick', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.completeTask();
      }
    }), _temp), send_to_floor_wizard__possibleConstructorReturn(_this, _ret);
  }

  return SendToFloorWizardPhaseTask;
}(phase_task);

var send_to_floor_wizard = Object(react_redux_es["connect"])(function () {
  return {};
}, { updatePhaseTask: actionCreators["_67" /* updatePhaseTask */], clearValidationErrors: actionCreators["k" /* clearValidationErrors */] })(SendToFloorWizardPhaseTask);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/tasks/components/SignLrrpModal/lrrp_info.jsx
var lrrp_info__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function lrrp_info__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function lrrp_info__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function lrrp_info__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var lrrp_info_LrrpInfo = function (_Resetter) {
  lrrp_info__inherits(LrrpInfo, _Resetter);

  function LrrpInfo() {
    var _ref;

    var _temp, _this, _ret;

    lrrp_info__classCallCheck(this, LrrpInfo);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = lrrp_info__possibleConstructorReturn(this, (_ref = LrrpInfo.__proto__ || Object.getPrototypeOf(LrrpInfo)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'state', {
      enumerable: true,
      writable: true,
      value: {
        rooms: _this.props.rooms || [],
        isLeadPresent: _this.props.isLeadPresent || '',
        addRoom: false,
        newRoom: '',
        errors: {}
      }
    }), Object.defineProperty(_this, 'handleSubmit', {
      enumerable: true,
      writable: true,
      value: function value() {
        var checks = { isLeadPresent: true, rooms: true };
        if (!_this.validate(checks)) return;
        var _this$state = _this.state,
            isLeadPresent = _this$state.isLeadPresent,
            rooms = _this$state.rooms;

        _this.props.updateFormData({ isLeadPresent: isLeadPresent, rooms: rooms, tab: 2 });
      }
    }), Object.defineProperty(_this, 'handleIsLeadPresent', {
      enumerable: true,
      writable: true,
      value: function value(_value) {
        return _this.setState({ isLeadPresent: _value });
      }
    }), Object.defineProperty(_this, 'handleAddRoom', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        e.preventDefault();
        _this.setState({ addRoom: !_this.state.addRoom, newRoom: '' });
      }
    }), Object.defineProperty(_this, 'handleNewRoom', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        return _this.setState({ newRoom: e.target.value });
      }
    }), Object.defineProperty(_this, 'handleSaveRoom', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        e.preventDefault();
        var _this$state2 = _this.state,
            rooms = _this$state2.rooms,
            newRoom = _this$state2.newRoom;

        rooms.push(newRoom);
        _this.setState({ newRoom: '', rooms: rooms });
      }
    }), Object.defineProperty(_this, 'handleDelete', {
      enumerable: true,
      writable: true,
      value: function value(index) {
        return function (e) {
          e.preventDefault();
          var rooms = _this.state.rooms;
          rooms.splice(index, 1);
          _this.setState({ rooms: rooms });
        };
      }
    }), _temp), lrrp_info__possibleConstructorReturn(_this, _ret);
  }

  lrrp_info__createClass(LrrpInfo, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          rooms = _state.rooms,
          isLeadPresent = _state.isLeadPresent,
          newRoom = _state.newRoom,
          addRoom = _state.addRoom;

      var buttons = [{
        label: 'YES',
        value: 'yes'
      }, {
        label: 'NO',
        value: 'no'
      }];
      var noRooms = !rooms.length;
      var noRoomsText = 'Answer the question above to continue';
      if (isLeadPresent === 'yes') {
        noRoomsText = 'LRRP CHECKLIST MUST BE FILLED OUT MANUALLY';
      } else if (addRoom) {
        noRoomsText = 'Add a room below, then click "Save"';
      } else if (isLeadPresent === 'no') {
        noRoomsText = 'Click "ADD" to start adding rooms';
      }

      return react_default.a.createElement(
        'div',
        null,
        react_default.a.createElement(
          'h6',
          null,
          'LRRP Info'
        ),
        !this.props.leadCertNumber ? react_default.a.createElement(
          'h4',
          null,
          'You must have a lead cert number to complete this task'
        ) : react_default.a.createElement(
          'span',
          null,
          react_default.a.createElement(components_RadioButtons, {
            onChange: this.handleIsLeadPresent,
            selectedValue: isLeadPresent,
            radioButtons: buttons,
            text: 'Are lead safe practices needed?'
          }),
          !noRooms ? react_default.a.createElement(
            'table',
            { className: modal_default.a.table },
            react_default.a.createElement(
              'thead',
              null,
              react_default.a.createElement(
                'tr',
                { className: modal_default.a.headerRow },
                react_default.a.createElement(
                  'th',
                  { className: modal_default.a.cell },
                  'Room'
                ),
                react_default.a.createElement(
                  'th',
                  { className: modal_default.a.deleteCell },
                  'Delete'
                )
              )
            ),
            react_default.a.createElement(
              'tbody',
              null,
              rooms.map(function (room, index) {
                return react_default.a.createElement(
                  'tr',
                  { className: modal_default.a.contentRow, key: room },
                  react_default.a.createElement(
                    'td',
                    { className: modal_default.a.cell },
                    room
                  ),
                  react_default.a.createElement(
                    'td',
                    { className: modal_default.a.deleteCell },
                    react_default.a.createElement(react_toolbox_lib["IconButton"], {
                      icon: 'delete',
                      onClick: _this2.handleDelete(index)
                    })
                  )
                );
              })
            )
          ) : react_default.a.createElement(
            'div',
            { className: modal_default.a.emptyTable },
            react_default.a.createElement(
              'h4',
              null,
              noRoomsText
            )
          ),
          addRoom && react_default.a.createElement(
            'form',
            { onSubmit: this.handleSaveRoom },
            react_default.a.createElement(components_SimpleInput, {
              label: 'Room',
              text: newRoom,
              onChange: this.handleNewRoom
            }),
            react_default.a.createElement('input', { className: modal_default.a.save, type: 'submit', value: 'Save' })
          ),
          isLeadPresent === 'no' && react_default.a.createElement(
            'span',
            null,
            react_default.a.createElement(react_toolbox_lib["Button"], {
              className: addRoom ? modal_default.a.cancel : modal_default.a.add,
              label: addRoom ? 'Cancel' : 'Add',
              flat: true, inverse: true, ripple: true,
              onClick: this.handleAddRoom
            }),
            react_default.a.createElement(react_toolbox_lib["Button"], {
              label: 'Next',
              flat: true, inverse: true, ripple: true,
              disabled: noRooms,
              className: modal_default.a.submit,
              onClick: this.handleSubmit
            })
          )
        )
      );
    }
  }]);

  return LrrpInfo;
}(resetter(validator(react_default.a.Component)));

lrrp_info_LrrpInfo.propTypes = {
  isLeadPresent: prop_types_default.a.string,
  leadCertNumber: prop_types_default.a.string,
  rooms: prop_types_default.a.array,
  errors: prop_types_default.a.shape({
    isLeadPresent: prop_types_default.a.arrayOf(prop_types_default.a.string),
    rooms: prop_types_default.a.arrayOf(prop_types_default.a.string)
  })
};

/* harmony default export */ var lrrp_info = (Object(react_redux_es["connect"])(function (state) {
  return { errors: Object(reducers["Y" /* getPhaseErrors */])(state) };
}, {})(lrrp_info_LrrpInfo));
// EXTERNAL MODULE: ./node_modules/react-signature-canvas/build/index.js
var build = __webpack_require__("bs7M");
var build_default = /*#__PURE__*/__webpack_require__.n(build);

// CONCATENATED MODULE: ./client/app/shared/components/SignatureBox/index.jsx
var SignatureBox__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function SignatureBox__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function SignatureBox__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var SignatureBox_SignatureBox = function SignatureBox(_ref) {
  var label = _ref.label,
      value = _ref.value,
      onClear = _ref.onClear,
      className = _ref.className,
      errors = _ref.errors,
      _onEnd = _ref.onEnd,
      props = SignatureBox__objectWithoutProperties(_ref, ['label', 'value', 'onClear', 'className', 'errors', 'onEnd']);

  var errorMsg = errors.join(', ');
  var wrapperStyles = classnames_default()(className, form_default.a.formElementContainer, SignatureBox__defineProperty({}, input_default.a.errored, errorMsg));
  var textAreaStyles = classnames_default()(input_default.a.inputElement, form_default.a.inputArea, form_default.a.signature);
  var labelStyles = errorMsg ? classnames_default()(form_default.a.label, form_default.a.errorLabel) : form_default.a.label;
  var sigPad = {};

  return react_default.a.createElement(
    'div',
    { className: wrapperStyles },
    react_default.a.createElement(
      'h6',
      { className: labelStyles },
      label
    ),
    react_default.a.createElement(
      'div',
      { className: form_default.a.inputActions },
      react_default.a.createElement(
        'button',
        {
          onClick: function onClick() {
            onClear();
            sigPad.clear();
          }
        },
        'Clear'
      )
    ),
    value && react_default.a.createElement('img', { src: value, alt: 'Signature' }),
    !value && react_default.a.createElement(
      'div',
      { className: textAreaStyles },
      react_default.a.createElement(build_default.a
      // canvasProps passes props directly to the canvas element.
      , SignatureBox__extends({ canvasProps: { className: input_default.a.sigPad }
        /**
         * Storing the ref in the sigPad object. This is required to
         * be able to call the methods on the canvas
         */
        , ref: function ref(_ref2) {
          sigPad = _ref2;
        }
        /**
         * We need to bubble up the image created by sigPad, or else
         * the parent component receives the mouse events triggered
         * by the canvas instead.
         */
        , onEnd: function onEnd() {
          /**
           * When signing on a mobile device the image is much
           * larger than on a desktop. To get the signature to
           * be consistently the same size we need to check for
           * the width of the window, and if larger than a 800px
           * we need to resize that image. Since we save the image
           * as a base64 to store it in state as a string, we need
           * to use another canvas to resize the image when on a
           * desktop.
           */
          if (window.innerWidth > 900) {
            // New canvas that will increase the image size
            var resizedCanvas = document.createElement('canvas');
            var resizedContext = resizedCanvas.getContext('2d');
            // Through testing triple the size of the image on mobile
            // seems to be the best size for consistently saving images
            var tripleCanvasWidth = sigPad.getCanvas().width * 3;
            var tripleCanvasHeight = sigPad.getCanvas().height * 3;

            resizedCanvas.width = tripleCanvasWidth;
            resizedCanvas.height = tripleCanvasHeight;
            resizedContext.drawImage(sigPad.getCanvas(), // Current signature in the canvas
            0, 0, // X and Y coordinates of the origin
            tripleCanvasWidth, tripleCanvasHeight);

            var myResizedData = resizedCanvas.toDataURL('image/png');
            _onEnd(myResizedData);
          } else {
            // using mobile device
            _onEnd(sigPad.getTrimmedCanvas().toDataURL('image/png'));
          }
        },
        clearOnResize: false
      }, props))
    ),
    errorMsg && react_default.a.createElement(
      'div',
      { className: input_default.a.error },
      react_default.a.createElement(
        'p',
        { className: form_default.a.errorMsg },
        errorMsg
      )
    )
  );
};

SignatureBox_SignatureBox.propTypes = {
  label: prop_types_default.a.string.isRequired,
  value: prop_types_default.a.string,
  onEnd: prop_types_default.a.func.isRequired,
  onClear: prop_types_default.a.func.isRequired,
  errors: prop_types_default.a.array.isRequired,
  className: prop_types_default.a.string
};

SignatureBox_SignatureBox.defaultProps = {
  label: '',
  text: '',
  errors: []
};

/* harmony default export */ var components_SignatureBox = (SignatureBox_SignatureBox);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/tasks/components/SignLrrpModal/lrrp_signature.jsx
function lrrp_signature__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function lrrp_signature__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function lrrp_signature__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var lrrp_signature_LrrpSignature = function (_Resetter) {
  lrrp_signature__inherits(LrrpSignature, _Resetter);

  function LrrpSignature() {
    var _ref;

    var _temp, _this, _ret;

    lrrp_signature__classCallCheck(this, LrrpSignature);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = lrrp_signature__possibleConstructorReturn(this, (_ref = LrrpSignature.__proto__ || Object.getPrototypeOf(LrrpSignature)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'state', {
      enumerable: true,
      writable: true,
      value: {
        signature: _this.props.signature || '',
        clearSignature: 0,
        errors: {}
      }
    }), Object.defineProperty(_this, 'handleSubmit', {
      enumerable: true,
      writable: true,
      value: function value() {
        var checks = { signature: true };
        if (!_this.validate(checks)) return;
        _this.props.updateFormData({ signature: _this.state.signature, tab: 3 });
      }
    }), Object.defineProperty(_this, 'handlePrevious', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.props.updateFormData({
          signature: _this.state.signature, tab: 1
        });
      }
    }), Object.defineProperty(_this, 'handleSignature', {
      enumerable: true,
      writable: true,
      value: function value(data) {
        return _this.setState({ signature: data });
      }
    }), Object.defineProperty(_this, 'handleSignatureClear', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.setState({
          signature: '',
          clearSignature: _this.props.signature ? _this.state.clearSignature : Date.now()
        });
        _this.props.updateFormData({ signature: '' });
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$state = _this.state,
            errors = _this$state.errors,
            clearSignature = _this$state.clearSignature;


        return react_default.a.createElement(
          'div',
          null,
          react_default.a.createElement(
            'h6',
            null,
            'Installer Certification'
          ),
          react_default.a.createElement(
            'p',
            { className: modal_default.a.legalText },
            'I, the undersigned installer, certify under penalty of law that the above information is true and complete, and do hereby certify that I have complied with all requirements of the Lead Renovation, Repair, and Painting Rule (RRP RULE), 40 \xA7 745.80, et seq., or any applicable state laws or program regulating lead-based paint safe work practices, including compliance with all information distribution, notice requirements and work practice standards in performing this Renovation Project. I certify that I have provided the Customer with all documentation required to be supplied under the RRP Rule or state program, shall retain all records required by law for at least 3 years or longer if required by state law, and shall provide copies of all the records required to be retained by the RRP Rule or applicable state program upon request. If requested by the Customer, I have provided the Customer with a completed copy of this Renovation Recordkeeping Checklist.'
          ),
          react_default.a.createElement(components_SignatureBox, {
            label: 'Sign Name *',
            required: true,
            value: _this.props.signature,
            errors: errors.signature,
            clearTimestamp: clearSignature,
            onEnd: _this.handleSignature,
            onClear: _this.handleSignatureClear
          }),
          react_default.a.createElement(react_toolbox_lib["Button"], { label: 'Submit', flat: true, inverse: true, ripple: true, className: modal_default.a.submit, onClick: _this.handleSubmit }),
          react_default.a.createElement(react_toolbox_lib["Button"], { label: 'Previous', flat: true, inverse: true, ripple: true, className: modal_default.a.submit, onClick: _this.handlePrevious })
        );
      }
    }), _temp), lrrp_signature__possibleConstructorReturn(_this, _ret);
  }

  return LrrpSignature;
}(resetter(validator(react_default.a.Component)));

lrrp_signature_LrrpSignature.propTypes = {
  signature: prop_types_default.a.string,
  errors: prop_types_default.a.shape({
    signature: prop_types_default.a.arrayOf(prop_types_default.a.string)
  })
};

/* harmony default export */ var lrrp_signature = (Object(react_redux_es["connect"])(function (state) {
  return { errors: Object(reducers["Y" /* getPhaseErrors */])(state) };
}, {})(lrrp_signature_LrrpSignature));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/tasks/components/SignLrrpModal/index.jsx
function SignLrrpModal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SignLrrpModal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function SignLrrpModal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var SignLrrpModal_SignLrrpModal = function (_Resetter) {
  SignLrrpModal__inherits(SignLrrpModal, _Resetter);

  function SignLrrpModal() {
    var _ref;

    var _temp, _this, _ret;

    SignLrrpModal__classCallCheck(this, SignLrrpModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = SignLrrpModal__possibleConstructorReturn(this, (_ref = SignLrrpModal.__proto__ || Object.getPrototypeOf(SignLrrpModal)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'componentDidUpdate', {
      enumerable: true,
      writable: true,
      value: function value() {
        if (_this.props.active) {
          window.addEventListener('orientationchange', _this.checkOrientation, false);
          if (window.orientation !== 0 && _this.state.width === 0) {
            // eslint-disable-next-line react/no-did-update-set-state
            _this.setState({ width: 1 });
          } else if (window.orientation === 0 && _this.state.width !== 0) {
            // eslint-disable-next-line react/no-did-update-set-state
            _this.setState({ width: 0 });
          }
        } else {
          window.removeEventListener('orientationchange', _this.checkOrientation, false);
        }
      }
    }), Object.defineProperty(_this, 'handleClose', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.setState({ loading: false });
        _this.props.clearValidationErrors('PHASE');
        _this.props.onClose();
        window.location.reload();
      }
    }), Object.defineProperty(_this, 'updateFormData', {
      enumerable: true,
      writable: true,
      value: function value(lrrpData) {
        _this.setState(lrrpData, function () {
          if (lrrpData.tab === 3) {
            var _this$props$phase = _this.props.phase,
                id = _this$props$phase.id,
                customer_name = _this$props$phase.customer_name,
                project_number = _this$props$phase.project_number,
                street_address = _this$props$phase.street_address,
                city = _this$props$phase.city,
                state = _this$props$phase.state,
                zip_code = _this$props$phase.zip_code;
            var _this$state = _this.state,
                signature = _this$state.signature,
                rooms = _this$state.rooms,
                isLeadPresent = _this$state.isLeadPresent;

            _this.props.lrrpCreate({
              signature: signature,
              rooms: rooms,
              customer_name: customer_name,
              street_address: street_address,
              city: city,
              zip_code: zip_code,
              state: Object(lodash["invert"])(constants["_36" /* STATES_WITH_ABBREV */])[state],
              contract_number: project_number,
              firm_name: constants["L" /* FIRM_NAME */],
              certification_number: constants["r" /* CERTIFICATION_NUMBER */],
              description: constants["W" /* LRRP_DESCRIPTION */],
              written_determination: constants["_63" /* WRITTEN_DETERMINATION */],
              certified_kits_used: constants["s" /* CERTIFIED_KITS_USED */],
              is_lead_present: isLeadPresent,
              test_kit: constants["T" /* LEAD_TEST_KIT */],
              test_result: constants["U" /* LEAD_TEST_RESULT */],
              phase_id: id
            }).then(function () {
              _this.props.updatePhaseTask(id, 'sign_lrrp', { task: { status: 'complete' } });
            }).then(function () {
              _this.handleClose();
            }).catch(function () {});
          }
        });
      }
    }), Object.defineProperty(_this, 'showTab', {
      enumerable: true,
      writable: true,
      value: function value() {
        setTimeout(function () {
          if (_this.state.tab <= 1) _this.setState({ tab: 1 });
        }, 600);
        var _this$props = _this.props,
            phase = _this$props.phase,
            leadCertNumber = _this$props.leadCertNumber;
        var _this$state2 = _this.state,
            signature = _this$state2.signature,
            rooms = _this$state2.rooms,
            isLeadPresent = _this$state2.isLeadPresent;

        switch (_this.state.tab) {
          case 1:
            return react_default.a.createElement(lrrp_info, {
              phase: phase,
              updateFormData: _this.updateFormData,
              leadCertNumber: leadCertNumber,
              isLeadPresent: isLeadPresent,
              rooms: rooms
            });
          case 2:
            return react_default.a.createElement(lrrp_signature, {
              phase: phase,
              updateFormData: _this.updateFormData,
              signature: signature
            });
          default:
            return react_default.a.createElement(components_Loading, null);
        }
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props2 = _this.props,
            active = _this$props2.active,
            serverErrors = _this$props2.errors;

        return react_default.a.createElement(
          react_toolbox_lib["Dialog"],
          {
            active: active, className: modal_default.a.modal, type: 'fullscreen',
            onEscKeyDown: _this.handleClose, onOverlayClick: _this.handleClose
          },
          react_default.a.createElement(
            'div',
            { className: input_default.a.errored },
            Object.keys(serverErrors).length > 0 && react_default.a.createElement(
              'span',
              { className: input_default.a.error },
              'This action could not be completed.'
            )
          ),
          react_default.a.createElement(react_toolbox_lib["IconButton"], { icon: 'close', className: modal_default.a.close, onClick: _this.handleClose }),
          react_default.a.createElement(
            'h5',
            null,
            'Sign LRRP'
          ),
          _this.showTab()
        );
      }
    }), _temp), SignLrrpModal__possibleConstructorReturn(_this, _ret);
  }

  return SignLrrpModal;
}(resetter(validator(react_default.a.Component)));

Object.defineProperty(SignLrrpModal_SignLrrpModal, 'DEFAULT_STATE', {
  enumerable: true,
  writable: true,
  value: {
    isLeadPresent: '',
    signature: '',
    rooms: [],
    errors: {},
    tab: 0
  }
});
Object.defineProperty(SignLrrpModal_SignLrrpModal, 'VALIDATIONS', {
  enumerable: true,
  writable: true,
  value: {
    signature: true,
    rooms: true
  }
});


SignLrrpModal_SignLrrpModal.propTypes = {
  active: prop_types_default.a.bool.isRequired,
  clearValidation: prop_types_default.a.func.isRequired,
  clearValidationErrors: prop_types_default.a.func.isRequired,
  lrrpCreate: prop_types_default.a.func.isRequired,
  updatePhaseTask: prop_types_default.a.func.isRequired,
  onClose: prop_types_default.a.func.isRequired,
  phase: types_phase.isRequired,
  userName: prop_types_default.a.string.isRequired,
  leadCertNumber: prop_types_default.a.string,
  task: types_task.isRequired,
  serverErrors: prop_types_default.a.shape({}),
  errors: prop_types_default.a.shape({
    signature: prop_types_default.a.arrayOf(prop_types_default.a.string),
    description: prop_types_default.a.arrayOf(prop_types_default.a.string)
  })
};

SignLrrpModal_SignLrrpModal.defaultProps = {
  active: false
};

/* harmony default export */ var components_SignLrrpModal = (Object(react_redux_es["connect"])(function (state) {
  return {
    errors: state.walkthroughs.uploadError
  };
}, {
  clearValidation: actionCreators["j" /* clearValidation */],
  clearValidationErrors: actionCreators["k" /* clearValidationErrors */],
  lrrpCreate: actionCreators["M" /* lrrpCreate */],
  updatePhaseTask: actionCreators["_67" /* updatePhaseTask */]
})(SignLrrpModal_SignLrrpModal));
// EXTERNAL MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/phaseActionMenu/ifiLrrpModal.scss
var ifiLrrpModal = __webpack_require__("D1D2");
var ifiLrrpModal_default = /*#__PURE__*/__webpack_require__.n(ifiLrrpModal);

// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/phaseActionMenu/ifiLrrpModal.jsx
var ifiLrrpModal__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ifiLrrpModal__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function ifiLrrpModal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ifiLrrpModal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ifiLrrpModal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var ifiLrrpModal_STATUS_OPTIONS = ['yes', 'no', 'na'];
var LEAD_TEST_RESULT_OPTIONS = ['', 'negative', 'positive', 'presumed'];

var formatAddress = function formatAddress(phase) {
  var parts = [phase.street_address, phase.city, phase.state, phase.zip_code];
  return parts.filter(Boolean).join(', ');
};

var ifiLrrpModal_IfiLrrpModal = function (_React$Component) {
  ifiLrrpModal__inherits(IfiLrrpModal, _React$Component);

  function IfiLrrpModal(props) {
    ifiLrrpModal__classCallCheck(this, IfiLrrpModal);

    var _this = ifiLrrpModal__possibleConstructorReturn(this, (IfiLrrpModal.__proto__ || Object.getPrototypeOf(IfiLrrpModal)).call(this, props));

    Object.defineProperty(_this, 'extractErrorMessage', {
      enumerable: true,
      writable: true,
      value: function value(error) {
        var messageFromErrorsArray = (((error || {}).errors || {}).messages || [])[0];
        var fullMessages = (((error || {}).errors || {}).full_messages || [])[0];
        var fieldErrors = (error || {}).errors || {};
        var firstFieldError = Object.keys(fieldErrors).reduce(function (result, field) {
          if (result) return result;
          var fieldValue = fieldErrors[field];
          if (Array.isArray(fieldValue) && fieldValue.length > 0) {
            return field + ' ' + fieldValue[0];
          }
          if (typeof fieldValue === 'string' && fieldValue.trim()) {
            return field + ' ' + fieldValue;
          }
          return result;
        }, '');
        var topLevelMessage = (error || {}).message;
        return messageFromErrorsArray || fullMessages || firstFieldError || topLevelMessage || '';
      }
    });
    Object.defineProperty(_this, 'defaultState', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            phase = _this$props.phase,
            userName = _this$props.userName,
            userLeadCertNumber = _this$props.userLeadCertNumber;

        var phaseAddress = formatAddress(phase);
        return {
          loading: false,
          errorMessage: '',
          currentPage: 1,
          customer_name: phase.customer_name || '',
          contract_number: phase.project_number || '',
          customer_address: phaseAddress,
          installation_address: phaseAddress,
          installer_firm_name: '',
          installer_firm_certification_number: '',
          assigned_renovator_name: userName || '',
          assigned_renovator_certification_number: userLeadCertNumber || '',
          renovation_project_description: '',
          installer_name_and_title: userName || '',
          installer_certification_date: moment_default()().format('YYYY-MM-DD'),
          installer_signature: userName || '',
          written_determination_status: 'na',
          lead_testing_status: 'no',
          certified_renovator_name: userName || '',
          certified_renovator_certification_number: userLeadCertNumber || '',
          was_area_presumed_lead_status: 'no',
          notification_records_status: 'na',
          warning_signs_posted_status: 'yes',
          prohibited_practices_status: 'yes',
          waste_contained_status: 'yes',
          worksite_cleaned_status: 'yes',
          dust_clearance_testing_status: 'na',
          wet_cloths_used: '',
          dry_cloths_used: '',
          lead_response_explanation: '',
          post_renovation_cleaning_verification: '',
          emergency_renovation_description: '',
          lead_test_result: '',
          lead_test_kit_manufacturer_model: '',
          lead_test_component_location_tested: '',
          lead_test_kit_lot_number: '',
          dust_sampling_technician_names_text: '',
          workers_trained_names_text: '',
          workers_trained_activities_text: '',
          notification_records_details: ''
        };
      }
    });
    Object.defineProperty(_this, 'handleChange', {
      enumerable: true,
      writable: true,
      value: function value(field) {
        return function (e) {
          var value = e.target.value;

          if (field === 'lead_testing_status' && value !== 'yes') {
            _this.setState({
              lead_testing_status: value,
              lead_test_result: '',
              lead_test_kit_manufacturer_model: '',
              lead_test_component_location_tested: '',
              lead_test_kit_lot_number: ''
            });
            return;
          }

          if (field === 'lead_test_result' && !['positive', 'negative'].includes(value)) {
            _this.setState({
              lead_test_result: value,
              lead_test_kit_manufacturer_model: '',
              lead_test_component_location_tested: '',
              lead_test_kit_lot_number: ''
            });
            return;
          }

          _this.setState(ifiLrrpModal__defineProperty({}, field, value));
        };
      }
    });
    Object.defineProperty(_this, 'handleClose', {
      enumerable: true,
      writable: true,
      value: function value() {
        if (!_this.state.loading) _this.props.onClose();
      }
    });
    Object.defineProperty(_this, 'parseCommaSeparated', {
      enumerable: true,
      writable: true,
      value: function value(_value) {
        return _value.split(',').map(function (item) {
          return item.trim();
        }).filter(Boolean);
      }
    });
    Object.defineProperty(_this, 'parseNotificationRecords', {
      enumerable: true,
      writable: true,
      value: function value(details) {
        if (!details.trim()) return {};

        return details.split('\n').map(function (line) {
          return line.trim();
        }).filter(Boolean).reduce(function (acc, line) {
          var colonIndex = line.indexOf(':');
          if (colonIndex === -1) {
            acc[line] = 'yes';
            return acc;
          }

          var key = line.slice(0, colonIndex).trim();
          var value = line.slice(colonIndex + 1).trim();
          if (key) acc[key] = value || 'yes';
          return acc;
        }, {});
      }
    });
    Object.defineProperty(_this, 'leadPositiveOrPresumed', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$state = _this.state,
            was_area_presumed_lead_status = _this$state.was_area_presumed_lead_status,
            lead_test_result = _this$state.lead_test_result;

        if (was_area_presumed_lead_status === 'yes') return true;

        var normalizedResult = (lead_test_result || '').toLowerCase();
        return normalizedResult.includes('positive') || normalizedResult.includes('presum');
      }
    });
    Object.defineProperty(_this, 'requiresExtendedLrrpPages', {
      enumerable: true,
      writable: true,
      value: function value() {
        // "Detail" (Assessment) only requires pages 1-2 and 6.
        if (_this.props.phase.type === 'Assessment') return false;
        return _this.leadPositiveOrPresumed();
      }
    });
    Object.defineProperty(_this, 'leadTestedPositiveOrNegative', {
      enumerable: true,
      writable: true,
      value: function value() {
        var normalizedResult = (_this.state.lead_test_result || '').toLowerCase();
        return normalizedResult.includes('positive') || normalizedResult.includes('negative');
      }
    });
    Object.defineProperty(_this, 'visiblePages', {
      enumerable: true,
      writable: true,
      value: function value() {
        var pages = [1, 2];
        if (_this.requiresExtendedLrrpPages()) pages.push(3, 4, 5);
        pages.push(6);
        return pages;
      }
    });
    Object.defineProperty(_this, 'currentVisiblePage', {
      enumerable: true,
      writable: true,
      value: function value() {
        var pages = _this.visiblePages();
        var currentPage = _this.state.currentPage;


        if (pages.includes(currentPage)) return currentPage;

        // If extended pages are no longer required while user is on 3-5,
        // return to page 2 instead of jumping to the last page.
        if (!_this.requiresExtendedLrrpPages() && currentPage >= 3 && currentPage <= 5) {
          return 2;
        }

        return pages[pages.length - 1];
      }
    });
    Object.defineProperty(_this, 'goToNextPage', {
      enumerable: true,
      writable: true,
      value: function value() {
        var pages = _this.visiblePages();
        var currentPage = _this.currentVisiblePage();
        var currentIndex = pages.indexOf(currentPage);
        var nextPage = pages[currentIndex + 1];
        if (nextPage) _this.setState({ currentPage: nextPage });
      }
    });
    Object.defineProperty(_this, 'goToPreviousPage', {
      enumerable: true,
      writable: true,
      value: function value() {
        var pages = _this.visiblePages();
        var currentPage = _this.currentVisiblePage();
        var currentIndex = pages.indexOf(currentPage);
        var previousPage = pages[currentIndex - 1];
        if (previousPage) _this.setState({ currentPage: previousPage });
      }
    });
    Object.defineProperty(_this, 'validateForm', {
      enumerable: true,
      writable: true,
      value: function value() {
        var requiredFields = ['installer_name_and_title', 'installer_certification_date', 'installer_signature'];

        var missingField = requiredFields.find(function (field) {
          return !_this.state[field];
        });
        if (missingField) {
          _this.setState({ errorMessage: 'Installer name/title, certification date, and signature are required.' });
          return false;
        }

        var workersTrainedActivities = _this.parseCommaSeparated(_this.state.workers_trained_activities_text);
        var workersTrainedNames = _this.parseCommaSeparated(_this.state.workers_trained_names_text);
        if (workersTrainedActivities.length > 0 && workersTrainedNames.length === 0) {
          _this.setState({ errorMessage: 'Worker names are required when trained activities are listed.' });
          return false;
        }
        if (workersTrainedNames.length > 0 && workersTrainedActivities.length === 0) {
          _this.setState({ errorMessage: 'Trained activities are required when worker names are listed.' });
          return false;
        }

        if (_this.state.lead_testing_status === 'yes' && !_this.state.lead_test_result) {
          _this.setState({ errorMessage: 'Lead test result is required when lead testing is marked YES.' });
          return false;
        }

        if (_this.leadTestedPositiveOrNegative()) {
          var missingTestKitInfo = ['lead_test_kit_manufacturer_model', 'lead_test_component_location_tested', 'lead_test_kit_lot_number'].some(function (field) {
            return !_this.state[field];
          });
          if (missingTestKitInfo) {
            _this.setState({
              errorMessage: 'Test kit manufacturer/model, component location tested, and lot number are required for positive/negative results.'
            });
            return false;
          }
        }

        if (_this.requiresExtendedLrrpPages()) {
          if (!_this.state.lead_response_explanation.trim()) {
            _this.setState({ errorMessage: 'Lead response explanation is required when lead is positive or presumed.' });
            return false;
          }

          if (_this.state.notification_records_status === 'na') {
            _this.setState({ errorMessage: 'Notification records status must be completed when lead is positive or presumed.' });
            return false;
          }

          var notificationRecordsDetails = String(_this.state.notification_records_details || '').trim();
          var dustSamplingTechnicianNamesText = String(_this.state.dust_sampling_technician_names_text || '').trim();
          if (!notificationRecordsDetails && !dustSamplingTechnicianNamesText) {
            _this.setState({
              errorMessage: 'Either notification records details or dust sampling technician names are required when lead is positive or presumed.'
            });
            return false;
          }

          var requiredStatuses = ['warning_signs_posted_status', 'prohibited_practices_status', 'waste_contained_status', 'worksite_cleaned_status', 'dust_clearance_testing_status'];
          var missingStatus = requiredStatuses.find(function (field) {
            return _this.state[field] === 'na';
          });
          if (missingStatus) {
            _this.setState({
              errorMessage: 'All required status fields on pages 3-5 must be answered when lead is positive or presumed.'
            });
            return false;
          }

          if (!_this.state.post_renovation_cleaning_verification.trim()) {
            _this.setState({
              errorMessage: 'Post-renovation cleaning verification is required when lead is positive or presumed.'
            });
            return false;
          }

          var wetClothsUsed = String(_this.state.wet_cloths_used || '').trim();
          var dryClothsUsed = String(_this.state.dry_cloths_used || '').trim();
          if (!wetClothsUsed || !dryClothsUsed) {
            _this.setState({
              errorMessage: 'Number of wet and dry cloths used is required when lead is positive or presumed.'
            });
            return false;
          }

          if (!/^\d+$/.test(wetClothsUsed) || !/^\d+$/.test(dryClothsUsed)) {
            _this.setState({ errorMessage: 'Wet and dry cloth values must be whole numbers.' });
            return false;
          }

          // Keep non-red optional fields optional for the presumed/positive path.
        }

        return true;
      }
    });
    Object.defineProperty(_this, 'buildPayload', {
      enumerable: true,
      writable: true,
      value: function value() {
        var leadTestInfo = [];
        if (_this.state.lead_test_result) {
          leadTestInfo.push({
            result: _this.state.lead_test_result,
            test_kit_manufacturer_model: _this.state.lead_test_kit_manufacturer_model,
            component_location_tested: _this.state.lead_test_component_location_tested,
            test_kit_lot_number: _this.state.lead_test_kit_lot_number
          });
        }
        var dustSamplingTechnicians = _this.parseCommaSeparated(_this.state.dust_sampling_technician_names_text);
        var workersTrainedNames = _this.parseCommaSeparated(_this.state.workers_trained_names_text);
        var workersTrainedActivities = _this.parseCommaSeparated(_this.state.workers_trained_activities_text);
        var notificationRecords = _this.parseNotificationRecords(_this.state.notification_records_details);

        return {
          phase_id: _this.props.phase.id,
          customer_name: _this.state.customer_name,
          contract_number: _this.state.contract_number,
          customer_address: _this.state.customer_address,
          installation_address: _this.state.installation_address,
          installer_firm_name: _this.state.installer_firm_name,
          installer_firm_certification_number: _this.state.installer_firm_certification_number,
          assigned_renovator_name: _this.state.assigned_renovator_name,
          assigned_renovator_certification_number: _this.state.assigned_renovator_certification_number,
          renovation_project_description: _this.state.renovation_project_description,
          installer_name_and_title: _this.state.installer_name_and_title,
          installer_certification_date: _this.state.installer_certification_date,
          installer_signature: _this.state.installer_signature,
          written_determination_status: _this.state.written_determination_status,
          lead_testing_status: _this.state.lead_testing_status,
          certified_renovator_name: _this.state.certified_renovator_name,
          certified_renovator_certification_number: _this.state.certified_renovator_certification_number,
          was_area_presumed_lead_status: _this.state.was_area_presumed_lead_status,
          notification_records_status: _this.state.notification_records_status,
          warning_signs_posted_status: _this.state.warning_signs_posted_status,
          prohibited_practices_status: _this.state.prohibited_practices_status,
          waste_contained_status: _this.state.waste_contained_status,
          worksite_cleaned_status: _this.state.worksite_cleaned_status,
          dust_clearance_testing_status: _this.state.dust_clearance_testing_status,
          wet_cloths_used: _this.state.wet_cloths_used,
          dry_cloths_used: _this.state.dry_cloths_used,
          lead_response_explanation: _this.state.lead_response_explanation,
          post_renovation_cleaning_verification: _this.state.post_renovation_cleaning_verification,
          emergency_renovation_description: _this.state.emergency_renovation_description,
          lead_test_info: leadTestInfo,
          dust_sampling_technician_names: dustSamplingTechnicians,
          workers_trained_names: workersTrainedNames,
          workers_trained_activities: workersTrainedActivities,
          work_area_containment_items: [],
          notification_records: notificationRecords,
          metadata: {}
        };
      }
    });
    Object.defineProperty(_this, 'buildTaskCompletionPayload', {
      enumerable: true,
      writable: true,
      value: function value() {
        if (_this.props.taskSlug !== 'lead_assessment') {
          return { task: { status: 'complete' } };
        }

        var disruptingLead = _this.leadPositiveOrPresumed() ? 'yes' : 'no';
        var commNote = String(_this.state.lead_response_explanation || _this.state.renovation_project_description || 'IFI LRRP completed').trim();

        return {
          task: { status: 'complete' },
          data: {
            disrupting_lead: disruptingLead,
            comm_note: commNote
          }
        };
      }
    });
    Object.defineProperty(_this, 'submit', {
      enumerable: true,
      writable: true,
      value: function value() {
        if (!_this.validateForm()) return;

        _this.setState({ loading: true, errorMessage: '' });
        _this.props.ifiLrrpCreate(_this.buildPayload()).then(function () {
          var _this$props2 = _this.props,
              phase = _this$props2.phase,
              taskSlug = _this$props2.taskSlug;

          if (!taskSlug) return null;
          return _this.props.updatePhaseTask(phase.id, taskSlug, _this.buildTaskCompletionPayload()).then(function (action) {
            if (action && action.type === 'UPDATE_PHASE_TASK_FAILURE') {
              var error = new Error('Unable to mark phase task as complete.');
              error.action = action;
              throw error;
            }
            return action;
          });
        }).then(function () {
          _this.setState({ loading: false, errorMessage: '' });
          _this.props.onClose();
          if (typeof window !== 'undefined' && window.location && typeof window.location.reload === 'function') {
            window.location.reload();
          }
        }).catch(function (error) {
          var serverError = _this.extractErrorMessage(error);
          var taskCompletionError = error && error.message === 'Unable to mark phase task as complete.';
          _this.setState({
            loading: false,
            errorMessage: taskCompletionError ? 'IFI LRRP was created, but we could not mark the task complete. Please refresh the page.' : serverError || 'Unable to create IFI LRRP. Please review the form and retry.'
          });
        });
      }
    });
    Object.defineProperty(_this, 'renderStatusSelect', {
      enumerable: true,
      writable: true,
      value: function value(field, label) {
        return react_default.a.createElement(
          'div',
          { className: ifiLrrpModal_default.a.row },
          react_default.a.createElement(
            'label',
            { className: ifiLrrpModal_default.a.label, htmlFor: field },
            label
          ),
          react_default.a.createElement(
            'select',
            {
              id: field,
              className: ifiLrrpModal_default.a.select,
              value: _this.state[field],
              onChange: _this.handleChange(field)
            },
            ifiLrrpModal_STATUS_OPTIONS.map(function (option) {
              return react_default.a.createElement(
                'option',
                { key: option, value: option },
                option.toUpperCase()
              );
            })
          )
        );
      }
    });
    Object.defineProperty(_this, 'renderPageFields', {
      enumerable: true,
      writable: true,
      value: function value(currentPage) {
        if (currentPage === 1) {
          return react_default.a.createElement(
            'div',
            null,
            react_default.a.createElement(
              'div',
              { className: ifiLrrpModal_default.a.row },
              react_default.a.createElement(
                'label',
                { className: ifiLrrpModal_default.a.label, htmlFor: 'customer_name' },
                'Customer Name'
              ),
              react_default.a.createElement('input', {
                id: 'customer_name', className: ifiLrrpModal_default.a.input, value: _this.state.customer_name,
                onChange: _this.handleChange('customer_name')
              })
            ),
            react_default.a.createElement(
              'div',
              { className: ifiLrrpModal_default.a.row },
              react_default.a.createElement(
                'label',
                { className: ifiLrrpModal_default.a.label, htmlFor: 'contract_number' },
                'Contract Number'
              ),
              react_default.a.createElement('input', {
                id: 'contract_number', className: ifiLrrpModal_default.a.input, value: _this.state.contract_number,
                onChange: _this.handleChange('contract_number')
              })
            ),
            react_default.a.createElement(
              'div',
              { className: ifiLrrpModal_default.a.row },
              react_default.a.createElement(
                'label',
                { className: ifiLrrpModal_default.a.label, htmlFor: 'customer_address' },
                'Customer Address'
              ),
              react_default.a.createElement('input', {
                id: 'customer_address', className: ifiLrrpModal_default.a.input, value: _this.state.customer_address,
                onChange: _this.handleChange('customer_address')
              })
            ),
            react_default.a.createElement(
              'div',
              { className: ifiLrrpModal_default.a.row },
              react_default.a.createElement(
                'label',
                { className: ifiLrrpModal_default.a.label, htmlFor: 'installation_address' },
                'Installation Address'
              ),
              react_default.a.createElement('input', {
                id: 'installation_address', className: ifiLrrpModal_default.a.input, value: _this.state.installation_address,
                onChange: _this.handleChange('installation_address')
              })
            ),
            react_default.a.createElement(
              'div',
              { className: ifiLrrpModal_default.a.row },
              react_default.a.createElement(
                'label',
                { className: ifiLrrpModal_default.a.label, htmlFor: 'installer_firm_name' },
                'Installer Firm Name'
              ),
              react_default.a.createElement('input', {
                id: 'installer_firm_name',
                className: ifiLrrpModal_default.a.input,
                value: _this.state.installer_firm_name,
                onChange: _this.handleChange('installer_firm_name')
              })
            ),
            react_default.a.createElement(
              'div',
              { className: ifiLrrpModal_default.a.row },
              react_default.a.createElement(
                'label',
                { className: ifiLrrpModal_default.a.label, htmlFor: 'installer_firm_certification_number' },
                'Installer Firm Certification Number'
              ),
              react_default.a.createElement('input', {
                id: 'installer_firm_certification_number',
                className: ifiLrrpModal_default.a.input,
                value: _this.state.installer_firm_certification_number,
                onChange: _this.handleChange('installer_firm_certification_number')
              })
            ),
            react_default.a.createElement(
              'div',
              { className: ifiLrrpModal_default.a.row },
              react_default.a.createElement(
                'label',
                { className: ifiLrrpModal_default.a.label, htmlFor: 'assigned_renovator_name' },
                'Assigned Renovator Name'
              ),
              react_default.a.createElement('input', {
                id: 'assigned_renovator_name',
                className: ifiLrrpModal_default.a.input,
                value: _this.state.assigned_renovator_name,
                onChange: _this.handleChange('assigned_renovator_name')
              })
            ),
            react_default.a.createElement(
              'div',
              { className: ifiLrrpModal_default.a.row },
              react_default.a.createElement(
                'label',
                { className: ifiLrrpModal_default.a.label, htmlFor: 'assigned_renovator_certification_number' },
                'Assigned Renovator Certification Number'
              ),
              react_default.a.createElement('input', {
                id: 'assigned_renovator_certification_number',
                className: ifiLrrpModal_default.a.input,
                value: _this.state.assigned_renovator_certification_number,
                onChange: _this.handleChange('assigned_renovator_certification_number')
              })
            ),
            react_default.a.createElement(
              'div',
              { className: ifiLrrpModal_default.a.row },
              react_default.a.createElement(
                'label',
                { className: ifiLrrpModal_default.a.label, htmlFor: 'renovation_project_description' },
                'Project Description'
              ),
              react_default.a.createElement('textarea', {
                id: 'renovation_project_description', className: ifiLrrpModal_default.a.textarea,
                value: _this.state.renovation_project_description,
                onChange: _this.handleChange('renovation_project_description')
              })
            )
          );
        }

        if (currentPage === 2) {
          return react_default.a.createElement(
            'div',
            null,
            _this.renderStatusSelect('written_determination_status', 'Written Determination'),
            _this.renderStatusSelect('lead_testing_status', 'Lead Testing'),
            react_default.a.createElement(
              'div',
              { className: ifiLrrpModal_default.a.row },
              react_default.a.createElement(
                'label',
                { className: ifiLrrpModal_default.a.label, htmlFor: 'certified_renovator_name' },
                'Certified Renovator Name'
              ),
              react_default.a.createElement('input', {
                id: 'certified_renovator_name',
                className: ifiLrrpModal_default.a.input,
                value: _this.state.certified_renovator_name,
                onChange: _this.handleChange('certified_renovator_name')
              })
            ),
            react_default.a.createElement(
              'div',
              { className: ifiLrrpModal_default.a.row },
              react_default.a.createElement(
                'label',
                { className: ifiLrrpModal_default.a.label, htmlFor: 'certified_renovator_certification_number' },
                'Certified Renovator Certification Number'
              ),
              react_default.a.createElement('input', {
                id: 'certified_renovator_certification_number',
                className: ifiLrrpModal_default.a.input,
                value: _this.state.certified_renovator_certification_number,
                onChange: _this.handleChange('certified_renovator_certification_number')
              })
            ),
            _this.renderStatusSelect('was_area_presumed_lead_status', 'Area Presumed Lead'),
            _this.state.lead_testing_status === 'yes' && react_default.a.createElement(
              'div',
              { className: ifiLrrpModal_default.a.row },
              react_default.a.createElement(
                'label',
                { className: ifiLrrpModal_default.a.label, htmlFor: 'lead_test_result' },
                'Lead Test Result'
              ),
              react_default.a.createElement(
                'select',
                {
                  id: 'lead_test_result', className: ifiLrrpModal_default.a.select, value: _this.state.lead_test_result,
                  onChange: _this.handleChange('lead_test_result'),
                  required: true,
                  'aria-required': 'true'
                },
                LEAD_TEST_RESULT_OPTIONS.map(function (option) {
                  return react_default.a.createElement(
                    'option',
                    { key: option || 'blank', value: option },
                    option ? option.toUpperCase() : 'NONE'
                  );
                })
              )
            ),
            _this.leadTestedPositiveOrNegative() && react_default.a.createElement(
              'div',
              null,
              react_default.a.createElement(
                'div',
                { className: ifiLrrpModal_default.a.row },
                react_default.a.createElement(
                  'label',
                  { className: ifiLrrpModal_default.a.label, htmlFor: 'lead_test_kit_manufacturer_model' },
                  'Test Kit Manufacturer / Model'
                ),
                react_default.a.createElement('input', {
                  id: 'lead_test_kit_manufacturer_model', className: ifiLrrpModal_default.a.input,
                  value: _this.state.lead_test_kit_manufacturer_model,
                  onChange: _this.handleChange('lead_test_kit_manufacturer_model'),
                  required: true,
                  'aria-required': 'true'
                })
              ),
              react_default.a.createElement(
                'div',
                { className: ifiLrrpModal_default.a.row },
                react_default.a.createElement(
                  'label',
                  { className: ifiLrrpModal_default.a.label, htmlFor: 'lead_test_component_location_tested' },
                  'Component Location Tested'
                ),
                react_default.a.createElement('input', {
                  id: 'lead_test_component_location_tested', className: ifiLrrpModal_default.a.input,
                  value: _this.state.lead_test_component_location_tested,
                  onChange: _this.handleChange('lead_test_component_location_tested'),
                  required: true,
                  'aria-required': 'true'
                })
              ),
              react_default.a.createElement(
                'div',
                { className: ifiLrrpModal_default.a.row },
                react_default.a.createElement(
                  'label',
                  { className: ifiLrrpModal_default.a.label, htmlFor: 'lead_test_kit_lot_number' },
                  'Test Kit Lot Number'
                ),
                react_default.a.createElement('input', {
                  id: 'lead_test_kit_lot_number', className: ifiLrrpModal_default.a.input,
                  value: _this.state.lead_test_kit_lot_number,
                  onChange: _this.handleChange('lead_test_kit_lot_number'),
                  required: true,
                  'aria-required': 'true'
                })
              )
            )
          );
        }

        if (currentPage === 3) {
          return react_default.a.createElement(
            'div',
            null,
            _this.renderStatusSelect('notification_records_status', 'Notification Records'),
            react_default.a.createElement(
              'div',
              { className: ifiLrrpModal_default.a.row },
              react_default.a.createElement(
                'label',
                { className: ifiLrrpModal_default.a.label, htmlFor: 'notification_records_details' },
                'Notification Record Details (one per line, optional `name: value`)'
              ),
              react_default.a.createElement('textarea', {
                id: 'notification_records_details', className: ifiLrrpModal_default.a.textarea,
                value: _this.state.notification_records_details,
                onChange: _this.handleChange('notification_records_details')
              })
            ),
            react_default.a.createElement(
              'div',
              { className: ifiLrrpModal_default.a.row },
              react_default.a.createElement(
                'label',
                { className: ifiLrrpModal_default.a.label, htmlFor: 'dust_sampling_technician_names_text' },
                'Dust Sampling Technician Names (comma-separated)'
              ),
              react_default.a.createElement('input', {
                id: 'dust_sampling_technician_names_text', className: ifiLrrpModal_default.a.input,
                value: _this.state.dust_sampling_technician_names_text,
                onChange: _this.handleChange('dust_sampling_technician_names_text')
              })
            ),
            react_default.a.createElement(
              'div',
              { className: ifiLrrpModal_default.a.row },
              react_default.a.createElement(
                'label',
                { className: ifiLrrpModal_default.a.label, htmlFor: 'lead_response_explanation' },
                'Lead Response Explanation'
              ),
              react_default.a.createElement('textarea', {
                id: 'lead_response_explanation', className: ifiLrrpModal_default.a.textarea,
                value: _this.state.lead_response_explanation,
                onChange: _this.handleChange('lead_response_explanation')
              })
            )
          );
        }

        if (currentPage === 4) {
          return react_default.a.createElement(
            'div',
            null,
            _this.renderStatusSelect('warning_signs_posted_status', 'Warning Signs Posted'),
            _this.renderStatusSelect('prohibited_practices_status', 'Prohibited Practices'),
            _this.renderStatusSelect('waste_contained_status', 'Waste Contained'),
            _this.renderStatusSelect('worksite_cleaned_status', 'Worksite Cleaned'),
            _this.renderStatusSelect('dust_clearance_testing_status', 'Dust Clearance Testing'),
            react_default.a.createElement(
              'div',
              { className: ifiLrrpModal_default.a.row },
              react_default.a.createElement(
                'label',
                { className: ifiLrrpModal_default.a.label, htmlFor: 'post_renovation_cleaning_verification' },
                'Post Renovation Cleaning Verification'
              ),
              react_default.a.createElement('textarea', {
                id: 'post_renovation_cleaning_verification', className: ifiLrrpModal_default.a.textarea,
                value: _this.state.post_renovation_cleaning_verification,
                onChange: _this.handleChange('post_renovation_cleaning_verification')
              })
            ),
            react_default.a.createElement(
              'div',
              { className: ifiLrrpModal_default.a.row },
              react_default.a.createElement(
                'label',
                { className: ifiLrrpModal_default.a.label, htmlFor: 'wet_cloths_used' },
                'Number of Wet Cloths Used'
              ),
              react_default.a.createElement('input', {
                id: 'wet_cloths_used',
                className: ifiLrrpModal_default.a.input,
                value: _this.state.wet_cloths_used,
                onChange: _this.handleChange('wet_cloths_used')
              })
            ),
            react_default.a.createElement(
              'div',
              { className: ifiLrrpModal_default.a.row },
              react_default.a.createElement(
                'label',
                { className: ifiLrrpModal_default.a.label, htmlFor: 'dry_cloths_used' },
                'Number of Dry Cloths Used'
              ),
              react_default.a.createElement('input', {
                id: 'dry_cloths_used',
                className: ifiLrrpModal_default.a.input,
                value: _this.state.dry_cloths_used,
                onChange: _this.handleChange('dry_cloths_used')
              })
            )
          );
        }

        if (currentPage === 5) {
          return react_default.a.createElement(
            'div',
            null,
            react_default.a.createElement(
              'div',
              { className: ifiLrrpModal_default.a.row },
              react_default.a.createElement(
                'label',
                { className: ifiLrrpModal_default.a.label, htmlFor: 'workers_trained_activities_text' },
                'Workers Trained Activities (comma-separated)'
              ),
              react_default.a.createElement('input', {
                id: 'workers_trained_activities_text', className: ifiLrrpModal_default.a.input,
                value: _this.state.workers_trained_activities_text,
                onChange: _this.handleChange('workers_trained_activities_text')
              })
            ),
            react_default.a.createElement(
              'div',
              { className: ifiLrrpModal_default.a.row },
              react_default.a.createElement(
                'label',
                { className: ifiLrrpModal_default.a.label, htmlFor: 'workers_trained_names_text' },
                'Workers Trained Names (comma-separated)'
              ),
              react_default.a.createElement('input', {
                id: 'workers_trained_names_text', className: ifiLrrpModal_default.a.input,
                value: _this.state.workers_trained_names_text,
                onChange: _this.handleChange('workers_trained_names_text')
              })
            ),
            react_default.a.createElement(
              'div',
              { className: ifiLrrpModal_default.a.row },
              react_default.a.createElement(
                'label',
                { className: ifiLrrpModal_default.a.label, htmlFor: 'emergency_renovation_description' },
                'Emergency Renovation Description'
              ),
              react_default.a.createElement('textarea', {
                id: 'emergency_renovation_description', className: ifiLrrpModal_default.a.textarea,
                value: _this.state.emergency_renovation_description,
                onChange: _this.handleChange('emergency_renovation_description')
              })
            )
          );
        }

        return react_default.a.createElement(
          'div',
          null,
          react_default.a.createElement(
            'div',
            { className: ifiLrrpModal_default.a.row },
            react_default.a.createElement(
              'label',
              { className: ifiLrrpModal_default.a.label, htmlFor: 'installer_name_and_title' },
              'Installer Name and Title *'
            ),
            react_default.a.createElement('input', {
              id: 'installer_name_and_title', className: ifiLrrpModal_default.a.input, required: true, 'aria-required': 'true',
              value: _this.state.installer_name_and_title,
              onChange: _this.handleChange('installer_name_and_title')
            })
          ),
          react_default.a.createElement(
            'div',
            { className: ifiLrrpModal_default.a.row },
            react_default.a.createElement(
              'label',
              { className: ifiLrrpModal_default.a.label, htmlFor: 'installer_certification_date' },
              'Installer Certification Date *'
            ),
            react_default.a.createElement('input', {
              id: 'installer_certification_date', className: ifiLrrpModal_default.a.input, type: 'date', required: true, 'aria-required': 'true',
              value: _this.state.installer_certification_date,
              onChange: _this.handleChange('installer_certification_date')
            })
          ),
          react_default.a.createElement(
            'div',
            { className: ifiLrrpModal_default.a.row },
            react_default.a.createElement(
              'label',
              { className: ifiLrrpModal_default.a.label, htmlFor: 'installer_signature' },
              'Installer Signature *'
            ),
            react_default.a.createElement('input', {
              id: 'installer_signature', className: ifiLrrpModal_default.a.input, required: true, 'aria-required': 'true',
              value: _this.state.installer_signature,
              onChange: _this.handleChange('installer_signature')
            })
          )
        );
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var visiblePages = _this.visiblePages();
        var currentPage = _this.currentVisiblePage();
        var currentIndex = visiblePages.indexOf(currentPage);
        var atFirstPage = currentIndex === 0;
        var atLastPage = currentIndex === visiblePages.length - 1;

        return react_default.a.createElement(
          react_toolbox_lib["Dialog"],
          {
            active: _this.props.active,
            className: modal_default.a.modal,
            onEscKeyDown: _this.handleClose,
            onOverlayClick: _this.handleClose
          },
          react_default.a.createElement(react_toolbox_lib["IconButton"], { icon: 'close', className: modal_default.a.close, onClick: _this.handleClose }),
          react_default.a.createElement(
            'h5',
            null,
            'Create IFI LRRP'
          ),
          react_default.a.createElement(
            'p',
            null,
            'This action creates the IFI LRRP record and uploads the generated LRRP document.'
          ),
          react_default.a.createElement(
            'div',
            { className: ifiLrrpModal_default.a.pageHeader },
            react_default.a.createElement(
              'span',
              null,
              'Page ',
              currentIndex + 1,
              ' of ',
              visiblePages.length
            ),
            react_default.a.createElement(
              'span',
              { className: ifiLrrpModal_default.a.pageSeparator },
              '|'
            ),
            react_default.a.createElement(
              'span',
              null,
              _this.requiresExtendedLrrpPages() ? 'Presumed/Positive path' : 'Standard path'
            )
          ),
          _this.state.errorMessage && react_default.a.createElement(
            'div',
            { className: ifiLrrpModal_default.a.error, role: 'alert', 'aria-live': 'assertive' },
            _this.state.errorMessage
          ),
          react_default.a.createElement(
            'div',
            { className: ifiLrrpModal_default.a.form },
            _this.renderPageFields(currentPage)
          ),
          react_default.a.createElement(
            'div',
            { className: ifiLrrpModal_default.a.actions },
            react_default.a.createElement(react_toolbox_lib["Button"], { label: 'Cancel', flat: true, onClick: _this.handleClose, disabled: _this.state.loading }),
            !atFirstPage && react_default.a.createElement(react_toolbox_lib["Button"], { label: 'Back', flat: true, onClick: _this.goToPreviousPage, disabled: _this.state.loading }),
            !atLastPage && react_default.a.createElement(react_toolbox_lib["Button"], { label: 'Next', primary: true, raised: true, onClick: _this.goToNextPage, disabled: _this.state.loading }),
            atLastPage && react_default.a.createElement(react_toolbox_lib["Button"], {
              label: _this.state.loading ? 'Saving...' : 'Create IFI LRRP',
              primary: true,
              raised: true,
              onClick: _this.submit,
              disabled: _this.state.loading
            })
          )
        );
      }
    });

    _this.state = _this.defaultState();
    return _this;
  }

  ifiLrrpModal__createClass(IfiLrrpModal, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var justOpened = this.props.active && !prevProps.active;
      if (justOpened) {
        // Reset form state each time the modal opens.
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState(this.defaultState());
      }
    }
  }]);

  return IfiLrrpModal;
}(react_default.a.Component);

ifiLrrpModal_IfiLrrpModal.propTypes = {
  active: prop_types_default.a.bool.isRequired,
  onClose: prop_types_default.a.func.isRequired,
  // phase.type is expected to be one of: 'Assessment', 'Installation', or 'Workorder'.
  phase: types_phase.isRequired,
  userName: prop_types_default.a.string,
  userLeadCertNumber: prop_types_default.a.string,
  ifiLrrpCreate: prop_types_default.a.func.isRequired,
  updatePhaseTask: prop_types_default.a.func.isRequired,
  taskSlug: prop_types_default.a.string
};

ifiLrrpModal_IfiLrrpModal.defaultProps = {
  userName: '',
  userLeadCertNumber: '',
  taskSlug: null
};

/* harmony default export */ var phaseActionMenu_ifiLrrpModal = (Object(react_redux_es["connect"])(function (state) {
  return {
    userName: state.user.name,
    userLeadCertNumber: state.user.lead_cert_number
  };
}, { ifiLrrpCreate: actionCreators["D" /* ifiLrrpCreate */], updatePhaseTask: actionCreators["_67" /* updatePhaseTask */] })(ifiLrrpModal_IfiLrrpModal));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/tasks/sign_lrrp.jsx
function sign_lrrp__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function sign_lrrp__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function sign_lrrp__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var sign_lrrp_SignLrrp = function (_PhaseTask) {
  sign_lrrp__inherits(SignLrrp, _PhaseTask);

  function SignLrrp() {
    var _ref;

    var _temp, _this, _ret;

    sign_lrrp__classCallCheck(this, SignLrrp);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = sign_lrrp__possibleConstructorReturn(this, (_ref = SignLrrp.__proto__ || Object.getPrototypeOf(SignLrrp)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'isDisabled', {
      enumerable: true,
      writable: true,
      value: function value() {
        return false;
      }
    }), Object.defineProperty(_this, 'onClick', {
      enumerable: true,
      writable: true,
      value: function value() {
        if (_this.props.task.status === 'complete') {
          _this.toggleStatus();
        } else {
          _this.setState({ modalActive: true });
        }
      }
    }), Object.defineProperty(_this, 'renderChildren', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            phase = _this$props.phase,
            task = _this$props.task,
            _this$props$user = _this$props.user,
            name = _this$props$user.name,
            lead_cert_number = _this$props$user.lead_cert_number;

        if (phase.type === 'Installation' && ifiUtils(phase)) {
          return react_default.a.createElement(phaseActionMenu_ifiLrrpModal, {
            phase: phase,
            taskSlug: 'sign_lrrp',
            active: _this.state.modalActive,
            onClose: _this.handleClose
          });
        }

        return react_default.a.createElement(components_SignLrrpModal, {
          phase: phase,
          userName: name,
          leadCertNumber: lead_cert_number,
          task: task,
          active: _this.state.modalActive,
          completeTask: _this.completeTask,
          onClose: _this.handleClose
        });
      }
    }), _temp), sign_lrrp__possibleConstructorReturn(_this, _ret);
  }

  return SignLrrp;
}(phase_task);

sign_lrrp_SignLrrp.propTypes = {
  phase: types_phase.isRequired,
  task: types_task.isRequired,
  updatePhaseTask: prop_types_default.a.func.isRequired
};

var sign_lrrp = Object(react_redux_es["connect"])(function () {
  return function (state) {
    return {
      user: state.user
    };
  };
}, { updatePhaseTask: actionCreators_phase["s" /* updatePhaseTask */] })(sign_lrrp_SignLrrp);
// CONCATENATED MODULE: ./client/app/shared/types/documentUpload.js


var DocumentUploadType = prop_types_default.a.shape({
  id: prop_types_default.a.number.isRequired,
  created_at: prop_types_default.a.string.isRequired,
  document_name: prop_types_default.a.string.isRequired,
  document_type: prop_types_default.a.string.isRequired,
  expiring_download_url: prop_types_default.a.string.isRequired,
  not_use: prop_types_default.a.bool.isRequired,
  user_name: prop_types_default.a.string.isRequired
});

/* harmony default export */ var documentUpload = (DocumentUploadType);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/tasks/uploaded_to_ims.jsx
var uploaded_to_ims__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var uploaded_to_ims__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function uploaded_to_ims__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function uploaded_to_ims__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function uploaded_to_ims__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var UploadedToImsPhaseTask = function (_PhaseTask) {
  uploaded_to_ims__inherits(UploadedToImsPhaseTask, _PhaseTask);

  function UploadedToImsPhaseTask() {
    var _ref;

    var _temp, _this, _ret;

    uploaded_to_ims__classCallCheck(this, UploadedToImsPhaseTask);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = uploaded_to_ims__possibleConstructorReturn(this, (_ref = UploadedToImsPhaseTask.__proto__ || Object.getPrototypeOf(UploadedToImsPhaseTask)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'onClick', {
      enumerable: true,
      writable: true,
      value: function value() {
        var data = _this.data();

        var task = {
          status: 'complete'
        };
        _this.props.updatePhaseTask(_this.props.phase.id, _this.props.task.slug, uploaded_to_ims__extends({ task: task }, data)).catch(function () {
          return _this.setState({ errorModalActive: true });
        });
        _this.childHandleTasksClose();
      }
    }), _temp), uploaded_to_ims__possibleConstructorReturn(_this, _ret);
  }

  uploaded_to_ims__createClass(UploadedToImsPhaseTask, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var phase = this.props.phase;


      this.props.fetchPhaseDocuments(phase.id);
    }
  }, {
    key: 'data',
    value: function data() {
      var documents = this.props.documents;

      var docOptions = documents.data.filter(function (doc) {
        return doc.document_type === 'Assessment/Refigure';
      }).map(function (doc) {
        return {
          value: doc.id,
          label: '' + doc.document_name
        };
      });
      return {
        data: { documents: docOptions.map(function (n) {
            return n.value;
          }) }
      };
    }
  }]);

  return UploadedToImsPhaseTask;
}(phase_task);

UploadedToImsPhaseTask.propTypes = {
  phase: types_phase.isRequired,
  task: types_task.isRequired,
  updatePhaseTask: prop_types_default.a.func.isRequired,
  fetchPhaseDocuments: prop_types_default.a.func.isRequired,
  clearValidationErrors: prop_types_default.a.func.isRequired,
  documents: prop_types_default.a.shape({
    loaded: prop_types_default.a.bool.isRequired,
    data: prop_types_default.a.arrayOf(documentUpload).isRequired
  })
};

var uploadedToImsPhaseTask = Object(react_redux_es["connect"])(function (state) {
  return {
    documents: state.phase.documents
  };
}, {
  updatePhaseTask: actionCreators["_67" /* updatePhaseTask */], fetchPhaseDocuments: actionCreators["A" /* fetchPhaseDocuments */], clearValidationErrors: actionCreators["k" /* clearValidationErrors */] })(UploadedToImsPhaseTask);


// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/tasks/verify_contract/components/VerifyContractModal.jsx
var VerifyContractModal__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var VerifyContractModal__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var VerifyContractModal__get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function VerifyContractModal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function VerifyContractModal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function VerifyContractModal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var ALLOWED_STATUSES = ['scheduling', 'hold', 'waiting_for_product'];

var VerifyContractModal_VerifyContractModal = function (_CompleteTaskModal) {
  VerifyContractModal__inherits(VerifyContractModal, _CompleteTaskModal);

  function VerifyContractModal() {
    var _ref;

    var _temp, _this, _ret;

    VerifyContractModal__classCallCheck(this, VerifyContractModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = VerifyContractModal__possibleConstructorReturn(this, (_ref = VerifyContractModal.__proto__ || Object.getPrototypeOf(VerifyContractModal)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'handleSelectChange', {
      enumerable: true,
      writable: true,
      value: function value(option) {
        _this.setState({ phaseStatus: option.value });
      }
    }), _temp), VerifyContractModal__possibleConstructorReturn(_this, _ret);
  }

  VerifyContractModal__createClass(VerifyContractModal, [{
    key: 'data',
    value: function data() {
      return VerifyContractModal__extends({}, VerifyContractModal__get(VerifyContractModal.prototype.__proto__ || Object.getPrototypeOf(VerifyContractModal.prototype), 'data', this).call(this), {
        phase: { status: 'waiting_for_product' }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          errors = _state.errors,
          phaseStatus = _state.phaseStatus;
      var phase = this.props.phase;

      var availableStatuses = phase.available_statuses || [];
      var statuses = availableStatuses.filter(function (s) {
        return ALLOWED_STATUSES.includes(s.value);
      });
      // Remove 'waiting_for_product' from statuses if the store doesn't deliver
      if (phase.store.delivery_method === 'None') {
        statuses = statuses.filter(function (s) {
          return s.value !== 'waiting_for_product';
        });
      }

      return VerifyContractModal__get(VerifyContractModal.prototype.__proto__ || Object.getPrototypeOf(VerifyContractModal.prototype), 'render', this).call(this, react_default.a.createElement(react_select, {
        className: [modal_default.a.select, modal_default.a.largerModal].join(' '),
        label: 'Select Status',
        required: true,
        onChange: this.handleSelectChange,
        options: statuses,
        resetValue: [],
        value: phaseStatus,
        error: Object(utils["c" /* error */])('phaseStatus', errors)
      }), Object(utils["c" /* error */])('status', errors));
    }
  }]);

  return VerifyContractModal;
}(components_CompleteTaskModal);

Object.defineProperty(VerifyContractModal_VerifyContractModal, 'VALIDATIONS', {
  enumerable: true,
  writable: true,
  value: { note: 'This field is required.', phaseStatus: 'Please select a status.' }
});
Object.defineProperty(VerifyContractModal_VerifyContractModal, 'DEFAULT_STATE', {
  enumerable: true,
  writable: true,
  value: {
    phaseStatus: 'scheduling',
    note: '',
    errors: {},
    sendError: false
  }
});


VerifyContractModal_VerifyContractModal.propTypes = {
  active: prop_types_default.a.bool.isRequired,
  phase: types_phase.isRequired,
  task: types_task.isRequired,
  onClose: prop_types_default.a.func.isRequired,
  updatePhaseTask: prop_types_default.a.func.isRequired
};

VerifyContractModal_VerifyContractModal.defaultProps = {
  active: false
};

/* harmony default export */ var components_VerifyContractModal = (VerifyContractModal_VerifyContractModal);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/tasks/verify_contract/index.jsx
function verify_contract__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function verify_contract__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function verify_contract__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var verify_contract_VerifyContract = function (_PhaseTask) {
  verify_contract__inherits(VerifyContract, _PhaseTask);

  function VerifyContract() {
    var _ref;

    var _temp, _this, _ret;

    verify_contract__classCallCheck(this, VerifyContract);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = verify_contract__possibleConstructorReturn(this, (_ref = VerifyContract.__proto__ || Object.getPrototypeOf(VerifyContract)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'renderChildren', {
      enumerable: true,
      writable: true,
      value: function value() {
        return react_default.a.createElement(components_VerifyContractModal, {
          phase: _this.props.phase,
          task: _this.props.task,
          active: _this.state.modalActive,
          completeTask: _this.completeTask,
          onClose: _this.handleClose,
          updatePhaseTask: _this.props.updatePhaseTask
        });
      }
    }), _temp), verify_contract__possibleConstructorReturn(_this, _ret);
  }

  return VerifyContract;
}(phase_task);

verify_contract_VerifyContract.propTypes = {
  phase: types_phase.isRequired,
  task: types_task.isRequired,
  updatePhaseTask: prop_types_default.a.func.isRequired
};

var verify_contract = Object(react_redux_es["connect"])(function () {
  return {};
}, { updatePhaseTask: actionCreators_phase["s" /* updatePhaseTask */] })(verify_contract_VerifyContract);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/tasks/generic_one_click.jsx
function generic_one_click__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function generic_one_click__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function generic_one_click__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * These generate a new phaseTask component based on the
 * slugs for the tasks.
 * The base component for these is located here:
 * client/app/screens/main/screens/phases/phaseShow/components/tasks/phase_task.jsx
 *
 * GenericOneClickTask simply overrides the onClick event for
 * PhaseTask.
 *
 * The component that calls GenericOneClickTasks to generate a
 * task that can be advanced by clicking is here:
 * client/app/screens/main/screens/phases/phaseShow/components/phaseTasks.jsx
 * */





var GenericOneClick = function (_PhaseTask) {
  generic_one_click__inherits(GenericOneClick, _PhaseTask);

  function GenericOneClick() {
    var _ref;

    var _temp, _this, _ret;

    generic_one_click__classCallCheck(this, GenericOneClick);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = generic_one_click__possibleConstructorReturn(this, (_ref = GenericOneClick.__proto__ || Object.getPrototypeOf(GenericOneClick)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'onClick', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.completeTask();
      }
    }), _temp), generic_one_click__possibleConstructorReturn(_this, _ret);
  }

  return GenericOneClick;
}(phase_task);

var generic_one_click = Object(react_redux_es["connect"])(function () {
  return {};
}, { updatePhaseTask: actionCreators["_67" /* updatePhaseTask */], clearValidationErrors: actionCreators["k" /* clearValidationErrors */] })(GenericOneClick);


// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/tasks/customer_review.jsx
function customer_review__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function customer_review__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function customer_review__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var customer_review_CustomerReview = function (_PhaseTask) {
  customer_review__inherits(CustomerReview, _PhaseTask);

  function CustomerReview() {
    var _ref;

    var _temp, _this, _ret;

    customer_review__classCallCheck(this, CustomerReview);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = customer_review__possibleConstructorReturn(this, (_ref = CustomerReview.__proto__ || Object.getPrototypeOf(CustomerReview)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'isDisabled', {
      enumerable: true,
      writable: true,
      value: function value() {
        return false;
      }
    }), Object.defineProperty(_this, 'onClick', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.task.status !== 'complete' ? _this.props.navigate(urls.phaseCommunications(_this.props.phase)) : _this.toggleStatus();
      }
    }), _temp), customer_review__possibleConstructorReturn(_this, _ret);
  }

  return CustomerReview;
}(phase_task);

customer_review_CustomerReview.propTypes = {
  phase: types_phase.isRequired,
  task: types_task.isRequired,
  updatePhaseTask: prop_types_default.a.func.isRequired,
  navigate: prop_types_default.a.func.isRequired
};

var customer_review = Object(react_redux_es["connect"])(function () {
  return function (state) {
    return { user: state.user };
  };
}, { updatePhaseTask: actionCreators_phase["s" /* updatePhaseTask */], navigate: actionCreators["O" /* navigate */] })(customer_review_CustomerReview);


// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/tasks/in_progress_call.jsx
var in_progress_call__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function in_progress_call__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function in_progress_call__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function in_progress_call__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var in_progress_call_InProgressCall = function (_PhaseTask) {
  in_progress_call__inherits(InProgressCall, _PhaseTask);

  function InProgressCall() {
    var _ref;

    var _temp, _this, _ret;

    in_progress_call__classCallCheck(this, InProgressCall);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = in_progress_call__possibleConstructorReturn(this, (_ref = InProgressCall.__proto__ || Object.getPrototypeOf(InProgressCall)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'isDisabled', {
      enumerable: true,
      writable: true,
      value: function value() {
        return false;
      }
    }), Object.defineProperty(_this, 'componentDidMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            phase = _this$props.phase,
            _this$props$task = _this$props.task,
            slug = _this$props$task.slug,
            status = _this$props$task.status;


        if (phase.type !== 'Workorder' || slug !== 'workorder_in_progress_call' || status !== 'incomplete') {
          return;
        }

        var _phase$appointments = phase.appointments,
            appointments = _phase$appointments === undefined ? [] : _phase$appointments;

        var notAutoAppts = ['stack_cali_bamboo', 'repair'];
        var today = moment_default()();

        var autoAppt = appointments.some(function (appt) {
          var startDate = moment_default()(appt.start_date);
          var endDate = moment_default()(appt.end_date);
          return today.isBetween(startDate, endDate) && !notAutoAppts.includes(appt.kind);
        });

        if (!autoAppt) return;

        var task = { status: 'complete' };
        var autocompleteNote = 'Autocompleted because appointment type is not a "Repair" or "Stack Cali Bamboo"';
        var data = { event: { data: { note: autocompleteNote } } };

        _this.props.updatePhaseTask(phase.id, slug, in_progress_call__extends({ task: task }, data));
      }
    }), Object.defineProperty(_this, 'onClick', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props2 = _this.props,
            task = _this$props2.task,
            phase = _this$props2.phase;

        if (phase.source === 'RF') return _this.completeTask();
        return task.status !== 'complete' ? _this.props.navigate(urls.phaseCommunications(phase)) : _this.toggleStatus();
      }
    }), _temp), in_progress_call__possibleConstructorReturn(_this, _ret);
  }

  return InProgressCall;
}(phase_task);

in_progress_call_InProgressCall.propTypes = {
  phase: types_phase.isRequired,
  task: types_task.isRequired,
  updatePhaseTask: prop_types_default.a.func.isRequired,
  navigate: prop_types_default.a.func.isRequired
};

var in_progress_call = Object(react_redux_es["connect"])(function () {
  return function (state) {
    return { user: state.user };
  };
}, { updatePhaseTask: actionCreators_phase["s" /* updatePhaseTask */], navigate: actionCreators["O" /* navigate */] })(in_progress_call_InProgressCall);


// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/tasks/follow_up_call.jsx
function follow_up_call__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function follow_up_call__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function follow_up_call__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var follow_up_call_FollowUpCall = function (_PhaseTask) {
  follow_up_call__inherits(FollowUpCall, _PhaseTask);

  function FollowUpCall() {
    var _ref;

    var _temp, _this, _ret;

    follow_up_call__classCallCheck(this, FollowUpCall);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = follow_up_call__possibleConstructorReturn(this, (_ref = FollowUpCall.__proto__ || Object.getPrototypeOf(FollowUpCall)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'isDisabled', {
      enumerable: true,
      writable: true,
      value: function value() {
        return false;
      }
    }), Object.defineProperty(_this, 'onClick', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.task.status !== 'complete' ? _this.props.navigate(urls.phaseCommunications(_this.props.phase)) : _this.toggleStatus();
      }
    }), _temp), follow_up_call__possibleConstructorReturn(_this, _ret);
  }

  return FollowUpCall;
}(phase_task);

follow_up_call_FollowUpCall.propTypes = {
  phase: types_phase.isRequired,
  task: types_task.isRequired,
  updatePhaseTask: prop_types_default.a.func.isRequired,
  navigate: prop_types_default.a.func.isRequired
};

var follow_up_call = Object(react_redux_es["connect"])(function () {
  return function (state) {
    return { user: state.user };
  };
}, { updatePhaseTask: actionCreators_phase["s" /* updatePhaseTask */], navigate: actionCreators["O" /* navigate */] })(follow_up_call_FollowUpCall);


// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/tasks/follow_up_delivery_call.jsx
function follow_up_delivery_call__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function follow_up_delivery_call__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function follow_up_delivery_call__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var follow_up_delivery_call_FollowUpDeliveryCall = function (_PhaseTask) {
  follow_up_delivery_call__inherits(FollowUpDeliveryCall, _PhaseTask);

  function FollowUpDeliveryCall() {
    var _ref;

    var _temp, _this, _ret;

    follow_up_delivery_call__classCallCheck(this, FollowUpDeliveryCall);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = follow_up_delivery_call__possibleConstructorReturn(this, (_ref = FollowUpDeliveryCall.__proto__ || Object.getPrototypeOf(FollowUpDeliveryCall)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'isDisabled', {
      enumerable: true,
      writable: true,
      value: function value() {
        return false;
      }
    }), Object.defineProperty(_this, 'onClick', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.task.status !== 'complete' ? _this.props.navigate(urls.phaseCommunications(_this.props.phase)) : _this.toggleStatus();
      }
    }), _temp), follow_up_delivery_call__possibleConstructorReturn(_this, _ret);
  }

  return FollowUpDeliveryCall;
}(phase_task);

follow_up_delivery_call_FollowUpDeliveryCall.propTypes = {
  phase: types_phase.isRequired,
  task: types_task.isRequired,
  updatePhaseTask: prop_types_default.a.func.isRequired,
  navigate: prop_types_default.a.func.isRequired
};

var follow_up_delivery_call = Object(react_redux_es["connect"])(function () {
  return function (state) {
    return { user: state.user };
  };
}, { updatePhaseTask: actionCreators_phase["s" /* updatePhaseTask */], navigate: actionCreators["O" /* navigate */] })(follow_up_delivery_call_FollowUpDeliveryCall);


// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/tasks/cv_checklist.jsx
function cv_checklist__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function cv_checklist__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function cv_checklist__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var cv_checklist_ContractVerificationChecklist = function (_PhaseTask) {
  cv_checklist__inherits(ContractVerificationChecklist, _PhaseTask);

  function ContractVerificationChecklist() {
    var _ref;

    var _temp, _this, _ret;

    cv_checklist__classCallCheck(this, ContractVerificationChecklist);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = cv_checklist__possibleConstructorReturn(this, (_ref = ContractVerificationChecklist.__proto__ || Object.getPrototypeOf(ContractVerificationChecklist)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'isDisabled', {
      enumerable: true,
      writable: true,
      value: function value() {
        return false;
      }
    }), Object.defineProperty(_this, 'onClick', {
      enumerable: true,
      writable: true,
      value: function value() {
        if (_this.props.task.status !== 'complete') _this.props.navigate(urls.phaseCvChecklist(_this.props.phase));
      }
    }), _temp), cv_checklist__possibleConstructorReturn(_this, _ret);
  }

  return ContractVerificationChecklist;
}(phase_task);

cv_checklist_ContractVerificationChecklist.propTypes = {
  phase: types_phase.isRequired,
  task: types_task.isRequired,
  updatePhaseTask: prop_types_default.a.func.isRequired,
  navigate: prop_types_default.a.func.isRequired
};

var cv_checklist = Object(react_redux_es["connect"])(function () {
  return function (state) {
    return {
      user: state.user
    };
  };
}, { updatePhaseTask: actionCreators_phase["s" /* updatePhaseTask */], navigate: actionCreators["O" /* navigate */] })(cv_checklist_ContractVerificationChecklist);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/tasks/scheduling_checklist.jsx
function scheduling_checklist__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function scheduling_checklist__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function scheduling_checklist__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var scheduling_checklist_SchedulingChecklist = function (_PhaseTask) {
  scheduling_checklist__inherits(SchedulingChecklist, _PhaseTask);

  function SchedulingChecklist() {
    var _ref;

    var _temp, _this, _ret;

    scheduling_checklist__classCallCheck(this, SchedulingChecklist);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = scheduling_checklist__possibleConstructorReturn(this, (_ref = SchedulingChecklist.__proto__ || Object.getPrototypeOf(SchedulingChecklist)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'isDisabled', {
      enumerable: true,
      writable: true,
      value: function value() {
        return false;
      }
    }), Object.defineProperty(_this, 'onClick', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.task.status !== 'complete' ? _this.props.navigate(urls.phaseSchedulingChecklist(_this.props.phase)) : _this.toggleStatus();
      }
    }), _temp), scheduling_checklist__possibleConstructorReturn(_this, _ret);
  }

  return SchedulingChecklist;
}(phase_task);

scheduling_checklist_SchedulingChecklist.propTypes = {
  phase: types_phase.isRequired,
  task: types_task.isRequired,
  updatePhaseTask: prop_types_default.a.func.isRequired,
  navigate: prop_types_default.a.func.isRequired
};

var scheduling_checklist = Object(react_redux_es["connect"])(function () {
  return function (state) {
    return {
      user: state.user
    };
  };
}, { updatePhaseTask: actionCreators_phase["s" /* updatePhaseTask */], navigate: actionCreators["O" /* navigate */] })(scheduling_checklist_SchedulingChecklist);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/materialsRequestedModal.jsx
var materialsRequestedModal__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var materialsRequestedModal__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var materialsRequestedModal__get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function materialsRequestedModal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function materialsRequestedModal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function materialsRequestedModal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



















var materialsRequestedModal_MaterialsRequestedModal = function (_Resetter) {
  materialsRequestedModal__inherits(MaterialsRequestedModal, _Resetter);

  function MaterialsRequestedModal() {
    var _ref;

    var _temp, _this, _ret;

    materialsRequestedModal__classCallCheck(this, MaterialsRequestedModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = materialsRequestedModal__possibleConstructorReturn(this, (_ref = MaterialsRequestedModal.__proto__ || Object.getPrototypeOf(MaterialsRequestedModal)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'componentDidUpdate', {
      enumerable: true,
      writable: true,
      value: function value(prevProps) {
        if (prevProps.chargebackPresent !== _this.props.chargebackPresent) {
          _this.setState({ chargebackPresent: _this.props.chargebackPresent });
        }
      }
    }), Object.defineProperty(_this, 'handleNoteChange', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        return _this.setState({ note: e.target.value });
      }
    }), Object.defineProperty(_this, 'data', {
      enumerable: true,
      writable: true,
      value: function value() {
        return { event: { data: { note: _this.state.note } } };
      }
    }), Object.defineProperty(_this, 'handleSubmit', {
      enumerable: true,
      writable: true,
      value: function value() {
        var cbError = false;
        if (!_this.props.chargebackPresent) {
          _this.setState({ chargebackError: true });
          cbError = true;
        } else _this.setState({ chargebackError: false });
        if (!_this.validate() || cbError === true) return;
        _this.addFlagIfLar();
        _this.phaseTaskUpdate();
      }
    }), Object.defineProperty(_this, 'addFlagIfLar', {
      enumerable: true,
      writable: true,
      value: function value() {
        if (_this.state.isLar === 'yes') {
          var flagProps = {
            name: 'Materials Requested',
            note: _this.state.note
          };
          _this.props.addFlagToPhase(_this.props.phase.id, flagProps).catch(function (result) {
            return _this.setState({ sendError: true, errors: result.payload.errors });
          });
        }
      }
    }), Object.defineProperty(_this, 'phaseTaskUpdate', {
      enumerable: true,
      writable: true,
      value: function value() {
        var task = { status: 'complete' };
        var data = _this.data();
        _this.props.updatePhaseTask(_this.props.phase.id, _this.props.task.slug, materialsRequestedModal__extends({ task: task }, data)).then(function () {
          return _this.handleClose();
        }).catch(function (result) {
          return _this.setState({
            sendError: true, errors: result.payload.errors
          });
        });
      }
    }), Object.defineProperty(_this, 'handleIsLarChange', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        return _this.setState({ isLar: e });
      }
    }), _temp), materialsRequestedModal__possibleConstructorReturn(_this, _ret);
  }
  // Since chargebacks aren't determined by the state in the form, we're
  // setting whether the chargeback is present or not in state here for validation


  materialsRequestedModal__createClass(MaterialsRequestedModal, [{
    key: 'handleClose',
    value: function handleClose() {
      var reload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      materialsRequestedModal__get(MaterialsRequestedModal.prototype.__proto__ || Object.getPrototypeOf(MaterialsRequestedModal.prototype), 'handleClose', this).call(this);
      this.props.clearValidation();
      if (reload) document.location.reload();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          note = _state.note,
          errors = _state.errors,
          isLar = _state.isLar,
          chargebackError = _state.chargebackError;
      var _props = this.props,
          phase = _props.phase,
          active = _props.active;

      return react_default.a.createElement(
        react_toolbox_lib["Dialog"],
        {
          active: active, className: modal_default.a.modal, type: 'fullscreen',
          onEscKeyDown: this.handleClose, onOverlayClick: this.handleClose
        },
        react_default.a.createElement(react_toolbox_lib["IconButton"], { icon: 'close', className: modal_default.a.close, onClick: this.handleClose }),
        react_default.a.createElement(
          'h5',
          null,
          'Materials Requested'
        ),
        react_default.a.createElement(components_RadioButtons, {
          text: 'Is an LAR purchase required?',
          required: true,
          selectedValue: isLar,
          onChange: this.handleIsLarChange,
          radioButtons: MaterialsRequestedModal.OPTIONS
        }),
        react_default.a.createElement(components_TextArea, {
          label: 'Notes',
          value: note,
          errors: errors.note,
          onChange: this.handleNoteChange
        }),
        chargebackError && react_default.a.createElement(
          'div',
          { className: input_default.a.errored },
          react_default.a.createElement(
            'div',
            { className: input_default.a.chargebackError },
            'A chargeback must be added before this task can be complete. Add chargeback ',
            react_default.a.createElement(
              es["c" /* Link */],
              {
                to: '/phases/' + phase.id + '/labor-product-accounting/chargeback',
                onClick: function onClick() {
                  return _this2.handleClose(false);
                }
              },
              'Here'
            )
          )
        ),
        react_default.a.createElement(
          'div',
          { className: modal_default.a.actions },
          react_default.a.createElement(ColoredButton["a" /* default */], {
            color: 'green',
            responsive: true,
            label: 'Complete Task',
            className: modal_default.a.button,
            onClick: this.handleSubmit
          }),
          react_default.a.createElement(ColoredButton["a" /* default */], {
            color: 'darkGray',
            responsive: true,
            label: 'Cancel',
            className: modal_default.a.button,
            onClick: this.handleClose
          })
        )
      );
    }
  }]);

  return MaterialsRequestedModal;
}(resetter(validator(react_default.a.Component)));

Object.defineProperty(materialsRequestedModal_MaterialsRequestedModal, 'DEFAULT_STATE', {
  enumerable: true,
  writable: true,
  value: {
    note: '',
    errors: {},
    sendError: false,
    isLar: 'no',
    chargebackPresent: false,
    chargebackError: false
  }
});
Object.defineProperty(materialsRequestedModal_MaterialsRequestedModal, 'VALIDATIONS', {
  enumerable: true,
  writable: true,
  value: { note: 'This field is required' }
});
Object.defineProperty(materialsRequestedModal_MaterialsRequestedModal, 'OPTIONS', {
  enumerable: true,
  writable: true,
  value: [{ label: 'No', value: 'no' }, { label: 'Yes', value: 'yes' }]
});


materialsRequestedModal_MaterialsRequestedModal.propTypes = {
  active: prop_types_default.a.bool.isRequired,
  phase: types_phase.isRequired,
  task: types_task.isRequired,
  onClose: prop_types_default.a.func.isRequired,
  updatePhaseTask: prop_types_default.a.func.isRequired,
  addFlagToPhase: prop_types_default.a.func.isRequired
};

materialsRequestedModal_MaterialsRequestedModal.defaultProps = { active: false };

/* harmony default export */ var materialsRequestedModal = (Object(react_redux_es["connect"])(function (state) {
  return { errors: Object(reducers["Y" /* getPhaseErrors */])(state) };
}, {
  clearValidation: actionCreators["j" /* clearValidation */],
  updatePhaseTask: actionCreators["_67" /* updatePhaseTask */],
  addFlagToPhase: actionCreators_phase["b" /* addFlagToPhase */]
})(materialsRequestedModal_MaterialsRequestedModal));
// EXTERNAL MODULE: ./client/app/shared/actionCreators/phase_items.js
var phase_items = __webpack_require__("PMQ5");

// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/tasks/materials_requested.jsx
function materials_requested__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function materials_requested__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function materials_requested__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var materials_requested_MaterialsRequested = function (_PhaseTask) {
  materials_requested__inherits(MaterialsRequested, _PhaseTask);

  function MaterialsRequested() {
    var _ref;

    var _temp, _this, _ret;

    materials_requested__classCallCheck(this, MaterialsRequested);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = materials_requested__possibleConstructorReturn(this, (_ref = MaterialsRequested.__proto__ || Object.getPrototypeOf(MaterialsRequested)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'onClick', {
      enumerable: true,
      writable: true,
      value: function value() {
        if (_this.props.task.status === 'complete') _this.toggleStatus();else _this.setState({ modalActive: true });
      }
    }), Object.defineProperty(_this, 'renderChildren', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            phase = _this$props.phase,
            task = _this$props.task,
            _this$props$user = _this$props.user,
            name = _this$props$user.name,
            role = _this$props$user.role,
            chargebackLineItems = _this$props.chargebackLineItems;

        var chargebackItems = chargebackLineItems.filter(function (cb) {
          return cb.id > 0;
        });
        var chargebackPresent = chargebackItems.length > 0;
        return react_default.a.createElement(materialsRequestedModal, {
          phase: phase,
          userName: name,
          role: role,
          task: task,
          chargebackPresent: chargebackPresent,
          active: _this.state.modalActive,
          completeTask: _this.completeTask,
          onClose: _this.handleClose
        });
      }
    }), _temp), materials_requested__possibleConstructorReturn(_this, _ret);
  }

  return MaterialsRequested;
}(phase_task);

materials_requested_MaterialsRequested.propTypes = {
  phase: types_phase.isRequired,
  task: types_task.isRequired,
  updatePhaseTask: prop_types_default.a.func.isRequired
};

var workorder_materials_requested = Object(react_redux_es["connect"])(function () {
  return function (state) {
    return {
      user: state.user,
      chargebackLineItems: state.phase.contractorChargebackItems.items
    };
  };
}, { updatePhaseTask: actionCreators_phase["s" /* updatePhaseTask */], requestPhaseItems: phase_items["i" /* requestPhaseItems */] })(materials_requested_MaterialsRequested);
// EXTERNAL MODULE: ./node_modules/moment-business-days/index.js
var moment_business_days = __webpack_require__("w4Cw");
var moment_business_days_default = /*#__PURE__*/__webpack_require__.n(moment_business_days);

// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/materialsOrderedModal.jsx
var materialsOrderedModal__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var materialsOrderedModal__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var materialsOrderedModal__get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function materialsOrderedModal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function materialsOrderedModal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function materialsOrderedModal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var materialsOrderedModal_MaterialsOrderedModal = function (_Resetter) {
  materialsOrderedModal__inherits(MaterialsOrderedModal, _Resetter);

  function MaterialsOrderedModal() {
    var _ref;

    var _temp, _this, _ret;

    materialsOrderedModal__classCallCheck(this, MaterialsOrderedModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = materialsOrderedModal__possibleConstructorReturn(this, (_ref = MaterialsOrderedModal.__proto__ || Object.getPrototypeOf(MaterialsOrderedModal)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'handleEtaChange', {
      enumerable: true,
      writable: true,
      value: function value(eta) {
        return _this.setState({ eta: eta });
      }
    }), Object.defineProperty(_this, 'handleNoteChange', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        return _this.setState({ note: e.target.value });
      }
    }), Object.defineProperty(_this, 'data', {
      enumerable: true,
      writable: true,
      value: function value() {
        return { event: { data: {
              note: 'ETA: ' + _this.state.eta + '\n' + _this.state.note
            } } };
      }
    }), Object.defineProperty(_this, 'handleSubmit', {
      enumerable: true,
      writable: true,
      value: function value() {
        if (!_this.validate()) return;
        var task = { status: 'complete' };
        var data = _this.data();
        _this.props.updatePhaseTask(_this.props.phase.id, _this.props.task.slug, materialsOrderedModal__extends({ task: task }, data)).then(function () {
          return _this.handleClose();
        }).catch(function (result) {
          return _this.setState({
            sendError: true, errors: result.payload.errors
          });
        });
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$state = _this.state,
            eta = _this$state.eta,
            note = _this$state.note,
            errors = _this$state.errors;

        return react_default.a.createElement(
          react_toolbox_lib["Dialog"],
          {
            active: _this.props.active, className: modal_default.a.modal, type: 'fullscreen',
            onEscKeyDown: _this.handleClose, onOverlayClick: _this.handleClose
          },
          react_default.a.createElement(react_toolbox_lib["IconButton"], { icon: 'close', className: modal_default.a.close, onClick: _this.handleClose }),
          react_default.a.createElement(
            'h5',
            null,
            'Materials Ordered'
          ),
          react_default.a.createElement('br', null),
          react_default.a.createElement(DatePicker, {
            label: 'Designate an ETA',
            minDate: moment_business_days_default()().toDate(),
            value: eta,
            onChange: _this.handleEtaChange,
            className: modal_default.a.datePicker,
            placeholder: 'Select Date',
            error: errors.eta
          }),
          react_default.a.createElement(components_TextArea, {
            label: 'Notes',
            value: note,
            errors: errors.note,
            onChange: _this.handleNoteChange
          }),
          react_default.a.createElement(
            'div',
            { className: modal_default.a.actions },
            react_default.a.createElement(ColoredButton["a" /* default */], {
              color: 'green',
              responsive: true,
              label: 'Complete Task',
              className: modal_default.a.button,
              onClick: _this.handleSubmit
            }),
            react_default.a.createElement(ColoredButton["a" /* default */], {
              color: 'darkGray',
              responsive: true,
              label: 'Cancel',
              className: modal_default.a.button,
              onClick: _this.handleClose
            })
          )
        );
      }
    }), _temp), materialsOrderedModal__possibleConstructorReturn(_this, _ret);
  }

  materialsOrderedModal__createClass(MaterialsOrderedModal, [{
    key: 'handleClose',
    value: function handleClose() {
      materialsOrderedModal__get(MaterialsOrderedModal.prototype.__proto__ || Object.getPrototypeOf(MaterialsOrderedModal.prototype), 'handleClose', this).call(this);
      this.props.clearValidation();
      document.location.reload();
    }
  }]);

  return MaterialsOrderedModal;
}(resetter(validator(react_default.a.Component)));

Object.defineProperty(materialsOrderedModal_MaterialsOrderedModal, 'DEFAULT_STATE', {
  enumerable: true,
  writable: true,
  value: {
    eta: '',
    note: '',
    errors: {},
    sendError: false
  }
});
Object.defineProperty(materialsOrderedModal_MaterialsOrderedModal, 'VALIDATIONS', {
  enumerable: true,
  writable: true,
  value: {
    eta: true,
    note: true
  }
});


materialsOrderedModal_MaterialsOrderedModal.propTypes = {
  active: prop_types_default.a.bool.isRequired,
  phase: types_phase.isRequired,
  task: types_task.isRequired,
  onClose: prop_types_default.a.func.isRequired,
  updatePhaseTask: prop_types_default.a.func.isRequired,
  addFlagToPhase: prop_types_default.a.func.isRequired
};

materialsOrderedModal_MaterialsOrderedModal.defaultProps = { active: false };

/* harmony default export */ var materialsOrderedModal = (Object(react_redux_es["connect"])(function (state) {
  return { errors: Object(reducers["Y" /* getPhaseErrors */])(state) };
}, {
  clearValidation: actionCreators["j" /* clearValidation */],
  updatePhaseTask: actionCreators["_67" /* updatePhaseTask */]
})(materialsOrderedModal_MaterialsOrderedModal));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/tasks/materials_ordered.jsx
function materials_ordered__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function materials_ordered__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function materials_ordered__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var materials_ordered_MaterialsOrdered = function (_PhaseTask) {
  materials_ordered__inherits(MaterialsOrdered, _PhaseTask);

  function MaterialsOrdered() {
    var _ref;

    var _temp, _this, _ret;

    materials_ordered__classCallCheck(this, MaterialsOrdered);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = materials_ordered__possibleConstructorReturn(this, (_ref = MaterialsOrdered.__proto__ || Object.getPrototypeOf(MaterialsOrdered)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'onClick', {
      enumerable: true,
      writable: true,
      value: function value() {
        if (_this.props.task.status === 'complete') _this.toggleStatus();else _this.setState({ modalActive: true });
      }
    }), Object.defineProperty(_this, 'renderChildren', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            phase = _this$props.phase,
            task = _this$props.task,
            _this$props$user = _this$props.user,
            name = _this$props$user.name,
            role = _this$props$user.role;

        return react_default.a.createElement(materialsOrderedModal, {
          phase: phase,
          userName: name,
          role: role,
          task: task,
          active: _this.state.modalActive,
          completeTask: _this.completeTask,
          onClose: _this.handleClose
        });
      }
    }), _temp), materials_ordered__possibleConstructorReturn(_this, _ret);
  }

  return MaterialsOrdered;
}(phase_task);

materials_ordered_MaterialsOrdered.propTypes = {
  phase: types_phase.isRequired,
  task: types_task.isRequired,
  updatePhaseTask: prop_types_default.a.func.isRequired
};

var workorder_materials_ordered = Object(react_redux_es["connect"])(function () {
  return function (state) {
    return { user: state.user };
  };
}, { updatePhaseTask: actionCreators_phase["s" /* updatePhaseTask */] })(materials_ordered_MaterialsOrdered);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/departedModal.jsx
var departedModal__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var departedModal__get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function departedModal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function departedModal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function departedModal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var departedModal_DepartedModal = function (_Resetter) {
  departedModal__inherits(DepartedModal, _Resetter);

  function DepartedModal() {
    var _ref;

    var _temp, _this, _ret;

    departedModal__classCallCheck(this, DepartedModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = departedModal__possibleConstructorReturn(this, (_ref = DepartedModal.__proto__ || Object.getPrototypeOf(DepartedModal)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'DISPOSITION_OPTIONS', {
      enumerable: true,
      writable: true,
      value: [{ value: 'no_product_selected', label: 'No product selected' }, { value: 'product_out_of_scope', label: 'Product is out of scope (Tile, Sheet Vinyl, Backsplash, Commercial)' }, { value: 'no_service_offline', label: 'No service/offline' }, { value: 'technical_issue', label: 'Not able to quote due to a technical issue' }, { value: 'customer_not_ready', label: 'Customer is not ready' }, { value: 'tech_not_trained', label: 'Tech not trained' }, { value: 'quote_presented', label: 'Quote Presented' }]
    }), Object.defineProperty(_this, 'state', {
      enumerable: true,
      writable: true,
      value: {
        isSpanish: false,
        excessMaterials: _this.props.excessMaterials || 'NO_EXCESS_MATERIALS',
        disposition: '',
        errors: {}
      }
    }), Object.defineProperty(_this, 'handleLanguageChange', {
      enumerable: true,
      writable: true,
      value: function value(val) {
        return _this.setState({ isSpanish: val });
      }
    }), Object.defineProperty(_this, 'handleSubmit', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            phase = _this$props.phase,
            task = _this$props.task;

        var excessMaterials = _this.state.excessMaterials;
        var disposition = _this.state.disposition;
        var isIhq = _this.isIhqWorkroom();
        var isAssessment = phase.type === 'Assessment';
        var taskSlug = task.slug || (isAssessment ? 'departed_from_appointment' : 'departed');

        var updateData = isAssessment && isIhq ? { id: phase.id, disposition: disposition } : { id: phase.id, excess_materials: excessMaterials };

        _this.props.updatePhase(updateData, {}).then(function () {
          var taskParams = isAssessment && isIhq ? {
            task: { status: 'complete' },
            data: { disposition: disposition }
          } : { task: { status: 'complete' } };

          _this.props.updatePhaseTask(phase.id, taskSlug, taskParams).then(function () {
            return _this.handleClose();
          }).catch(function (result) {
            return _this.setState({ sendError: true, errors: result.payload.errors });
          });
        });
      }
    }), Object.defineProperty(_this, 'handleExcessMaterialsChange', {
      enumerable: true,
      writable: true,
      value: function value(_value) {
        return _this.setState({ excessMaterials: _value });
      }
    }), Object.defineProperty(_this, 'handleDispositionChange', {
      enumerable: true,
      writable: true,
      value: function value(_value2) {
        return _this.setState({ disposition: _value2 });
      }
    }), Object.defineProperty(_this, 'isIhqWorkroom', {
      enumerable: true,
      writable: true,
      value: function value() {
        var phase = _this.props.phase;

        return phase && phase.workroom && (phase.workroom.ihq === true || phase.workroom.ihq === 'true');
      }
    }), _temp), departedModal__possibleConstructorReturn(_this, _ret);
  }

  departedModal__createClass(DepartedModal, [{
    key: 'handleClose',
    value: function handleClose() {
      departedModal__get(DepartedModal.prototype.__proto__ || Object.getPrototypeOf(DepartedModal.prototype), 'handleClose', this).call(this);
      this.props.clearValidation();
      document.location.reload();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          active = _props.active,
          phase = _props.phase;
      var _state = this.state,
          isSpanish = _state.isSpanish,
          disposition = _state.disposition;

      var isIhq = this.isIhqWorkroom();
      var isAssessment = phase.type === 'Assessment';
      var radioButtons = [{
        label: isSpanish ? 'No hubo exceso de materiales' : 'There were no excess materials',
        value: 'NO_EXCESS_MATERIALS'
      }, {
        label: isSpanish ? 'Cliente dispuesto a mantener el exceso de materiales' : 'Customer willing to keep excess materials',
        value: 'CUSTOMER_WILLING_TO_KEEP_EXCESS'
      }, {
        label: isSpanish ? 'El cliente debe regresar a la tienda para obtener un reembolso' : 'Customer to return to store for a refund',
        value: 'CUSTOMER_RETURN_TO_STORE_FOR_REFUND'
      }, {
        label: isSpanish ? "Regreso a la tienda: Programe la recogida de Lowe's" : "Return to store: Schedule Lowe's pick-up",
        value: 'RETURN_TO_STORE_SCHEDULE_LOWES_PICKUP'
      }];

      // For Assessments: show disposition if IHQ enabled, otherwise nothing (shouldn't show modal)
      // For Installations: show excess materials
      var showDisposition = isAssessment && isIhq;
      var showExcessMaterials = !isAssessment;

      return react_default.a.createElement(
        react_toolbox_lib["Dialog"],
        {
          active: active, className: modal_default.a.modal, type: 'fullscreen',
          onEscKeyDown: this.handleClose, onOverlayClick: this.handleClose
        },
        react_default.a.createElement(react_toolbox_lib["IconButton"], {
          icon: 'close',
          className: modal_default.a.close,
          onClick: this.handleClose
        }),
        react_default.a.createElement(react_toolbox_lib["Switch"], {
          checked: isSpanish,
          label: '\xBFEn espa\xF1ol?',
          onChange: this.handleLanguageChange
        }),
        showDisposition && react_default.a.createElement(
          'div',
          null,
          react_default.a.createElement(
            'h6',
            { className: modal_default.a.signatureTitle },
            isSpanish ? 'Disposición' : 'Disposition'
          ),
          react_default.a.createElement(components_StyledSelect, {
            label: isSpanish ? 'Por favor seleccione una disposición:' : 'Please select a disposition:',
            onChange: this.handleDispositionChange,
            options: this.DISPOSITION_OPTIONS,
            value: disposition,
            placeholder: isSpanish ? 'Seleccionar disposición' : 'Select disposition',
            required: true,
            error: !disposition && this.state.errors && this.state.errors.disposition
          })
        ),
        showExcessMaterials && react_default.a.createElement(
          'div',
          null,
          react_default.a.createElement(
            'h6',
            { className: modal_default.a.signatureTitle },
            isSpanish ? 'Exceso de Materiales' : 'Excess Materials'
          ),
          react_default.a.createElement(components_RadioButtons, {
            required: true,
            onChange: this.handleExcessMaterialsChange,
            selectedValue: this.state.excessMaterials,
            radioButtons: radioButtons,
            text: isSpanish ? 'Por favor, seleccione qué se debe hacer con el exceso de material restante:' : 'Please select what should be done with remaining excess materials:'
          })
        ),
        react_default.a.createElement(react_toolbox_lib["Button"], {
          label: isSpanish ? 'Enviar' : 'Submit',
          flat: true, inverse: true, ripple: true,
          className: modal_default.a.submit,
          onClick: this.handleSubmit,
          disabled: showDisposition && !disposition
        }),
        react_default.a.createElement(react_toolbox_lib["Button"], {
          label: isSpanish ? 'Cancelar' : 'Cancel',
          flat: true, inverse: true, ripple: true,
          className: modal_default.a.submit,
          onClick: this.handleClose
        })
      );
    }
  }]);

  return DepartedModal;
}(resetter(validator(react_default.a.Component)));

departedModal_DepartedModal.propTypes = {
  isSpanish: prop_types_default.a.bool,
  active: prop_types_default.a.bool.isRequired,
  phase: types_phase.isRequired,
  updatePhase: prop_types_default.a.func.isRequired,
  clearValidation: prop_types_default.a.func.isRequired
};

/* harmony default export */ var departedModal = (Object(react_redux_es["connect"])(function (state) {
  return { errors: Object(reducers["Y" /* getPhaseErrors */])(state) };
}, {
  clearValidation: actionCreators_phase["f" /* clearValidation */],
  updatePhase: actionCreators_phase["r" /* updatePhase */],
  updatePhaseTask: actionCreators["_67" /* updatePhaseTask */]
})(departedModal_DepartedModal));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/tasks/departed.jsx
function departed__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function departed__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function departed__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var departed_Departed = function (_PhaseTask) {
  departed__inherits(Departed, _PhaseTask);

  function Departed() {
    var _ref;

    var _temp, _this, _ret;

    departed__classCallCheck(this, Departed);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = departed__possibleConstructorReturn(this, (_ref = Departed.__proto__ || Object.getPrototypeOf(Departed)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'onClick', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            phase = _this$props.phase,
            task = _this$props.task;

        if (!phase || !task) return;

        var isInstallation = phase.type === 'Installation';

        if (task.status === 'complete') {
          _this.toggleStatus();
        } else if (isInstallation) {
          _this.completeTask();
        } else if (_this.shouldShowModal()) {
          _this.setState({ modalActive: true });
        } else {
          _this.completeTask();
        }
      }
    }), Object.defineProperty(_this, 'isIhqWorkroom', {
      enumerable: true,
      writable: true,
      value: function value() {
        var phase = _this.props.phase;

        return phase && phase.workroom && (phase.workroom.ihq === true || phase.workroom.ihq === 'true');
      }
    }), Object.defineProperty(_this, 'isInstallation', {
      enumerable: true,
      writable: true,
      value: function value() {
        var phase = _this.props.phase;

        return phase && phase.type === 'Installation';
      }
    }), Object.defineProperty(_this, 'shouldShowModal', {
      enumerable: true,
      writable: true,
      value: function value() {
        var phase = _this.props.phase;

        if (!phase || !phase.type) return false;

        if (phase.type === 'Installation') {
          return false;
        }
        var isAssessment = phase.type === 'Assessment';
        var isIhq = _this.isIhqWorkroom();

        // For Assessments: show modal only if IHQ is enabled (to show disposition)
        // For Installations: always show modal (to show excess materials)
        return isAssessment && isIhq || _this.isInstallation();
      }
    }), Object.defineProperty(_this, 'renderChildren', {
      enumerable: true,
      writable: true,
      value: function value() {
        var phase = _this.props.phase;

        if (!phase || !phase.type) return null;

        if (phase.type === 'Installation') {
          return null;
        }
        if (!_this.shouldShowModal()) {
          return null;
        }
        return react_default.a.createElement(departedModal, {
          phase: _this.props.phase,
          task: _this.props.task,
          active: _this.state.modalActive,
          completeTask: _this.completeTask,
          onClose: _this.handleClose
        });
      }
    }), _temp), departed__possibleConstructorReturn(_this, _ret);
  }

  return Departed;
}(phase_task);

departed_Departed.propTypes = {
  phase: types_phase.isRequired,
  task: types_task.isRequired,
  updatePhaseTask: prop_types_default.a.func.isRequired
};

var departed = Object(react_redux_es["connect"])(function () {
  return {};
}, { updatePhaseTask: actionCreators["_67" /* updatePhaseTask */], clearValidationErrors: actionCreators["k" /* clearValidationErrors */] })(departed_Departed);
var departed_departed_from_appointment = departed;
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/installCompleteModal.jsx
var installCompleteModal__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function installCompleteModal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function installCompleteModal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function installCompleteModal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var installCompleteModal_InstallCompleteModal = function (_Resetter) {
  installCompleteModal__inherits(InstallCompleteModal, _Resetter);

  function InstallCompleteModal() {
    var _ref;

    var _temp, _this, _ret;

    installCompleteModal__classCallCheck(this, InstallCompleteModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = installCompleteModal__possibleConstructorReturn(this, (_ref = InstallCompleteModal.__proto__ || Object.getPrototypeOf(InstallCompleteModal)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'handleSubmit', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            phase = _this$props.phase,
            slug = _this$props.task.slug,
            updatePhaseTask = _this$props.updatePhaseTask,
            childHandleTasksClose = _this$props.childHandleTasksClose;

        var task = { status: 'complete' };
        updatePhaseTask(phase.id, slug, { task: task }).then(function () {
          return childHandleTasksClose();
        }).then(function () {
          return _this.handleClose();
        }).catch(function (result) {
          return _this.setState({ sendError: true, errors: result.payload.errors });
        });
      }
    }), Object.defineProperty(_this, 'handleNoteChange', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        return _this.setState({ note: e.target.value });
      }
    }), _temp), installCompleteModal__possibleConstructorReturn(_this, _ret);
  }

  installCompleteModal__createClass(InstallCompleteModal, [{
    key: 'render',
    value: function render() {
      var errorMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var _props = this.props,
          active = _props.active,
          phase = _props.phase;
      var _state = this.state,
          errors = _state.errors,
          sendError = _state.sendError;


      return react_default.a.createElement(
        react_toolbox_lib["Dialog"],
        {
          active: active,
          className: modal_default.a.modal,
          type: 'fullscreen',
          onEscKeyDown: this.handleClose,
          onOverlayClick: this.handleClose
        },
        errorMessage && react_default.a.createElement(MessageBox["a" /* default */], { error: true, message: errorMessage }),
        sendError && !errorMessage && react_default.a.createElement(MessageBox["a" /* default */], { error: true, message: Object(utils["d" /* errorSummary */])(errors) }),
        react_default.a.createElement(lib_button["IconButton"], {
          icon: 'close',
          className: modal_default.a.close,
          onClick: this.handleClose,
          tabIndex: -1
        }),
        react_default.a.createElement(
          'h5',
          { className: modal_default.a.title },
          'Correct Labor Sheet'
        ),
        react_default.a.createElement(
          'h5',
          { className: modal_default.a.text },
          'There must not be a labor sheet with $0.00 unless it\'s already marked \'Not Payable\'. Correct\xA0',
          react_default.a.createElement(
            es["c" /* Link */],
            {
              className: modal_default.a.text,
              to: '/phases/' + phase.id + '/labor-product-accounting/laborsheet',
              target: '_blank'
            },
            'here'
          ),
          '.'
        ),
        react_default.a.createElement(
          'div',
          { className: modal_default.a.actions },
          react_default.a.createElement(ColoredButton["a" /* default */], {
            color: 'green',
            responsive: true,
            label: 'Complete Task',
            className: modal_default.a.button,
            onClick: this.handleSubmit
          }),
          react_default.a.createElement(ColoredButton["a" /* default */], {
            color: 'darkGray',
            responsive: true,
            label: 'Cancel',
            className: modal_default.a.button,
            onClick: this.handleClose
          })
        )
      );
    }
  }]);

  return InstallCompleteModal;
}(resetter(validator(react_default.a.Component)));

/* harmony default export */ var installCompleteModal = (installCompleteModal_InstallCompleteModal);


installCompleteModal_InstallCompleteModal.propTypes = {
  active: prop_types_default.a.bool.isRequired,
  phase: types_phase.isRequired,
  task: types_task.isRequired,
  onClose: prop_types_default.a.func.isRequired,
  updatePhaseTask: prop_types_default.a.func.isRequired,
  addFlagToPhase: prop_types_default.a.func.isRequired
};

installCompleteModal_InstallCompleteModal.defaultProps = { active: false };
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/tasks/install_complete.jsx
function install_complete__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function install_complete__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function install_complete__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var install_complete_MINIMUM_WIDTH = 450;

var install_complete_InstallComplete = function (_PhaseTask) {
  install_complete__inherits(InstallComplete, _PhaseTask);

  function InstallComplete() {
    var _ref;

    var _temp, _this, _ret;

    install_complete__classCallCheck(this, InstallComplete);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = install_complete__possibleConstructorReturn(this, (_ref = InstallComplete.__proto__ || Object.getPrototypeOf(InstallComplete)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'state', {
      enumerable: true,
      writable: true,
      value: { incorrectLabSheets: [] }
    }), Object.defineProperty(_this, 'onClick', {
      enumerable: true,
      writable: true,
      value: function value() {
        var status = _this.props.task.status;

        var incorrectLaborSheets = _this.getIncorrectLaborSheets();
        if (status === 'complete') _this.toggleStatus();else if (incorrectLaborSheets.length === 0 && status === 'incomplete') _this.completeTask();else _this.setState({ modalActive: true });
      }
    }), Object.defineProperty(_this, 'getIncorrectLaborSheets', {
      enumerable: true,
      writable: true,
      value: function value() {
        var labSheets = _this.props.laborSheets.filter(function (ls) {
          return ls.status !== 'Not Payable' && ls.total === 0;
        });
        if (labSheets.length !== 0) _this.setState({ incorrectLabSheets: labSheets });
        return labSheets;
      }
    }), Object.defineProperty(_this, 'whichVendor', {
      enumerable: true,
      writable: true,
      value: function value(tag, workroom) {
        return ['IMS', 'IME'].includes(tag) ? tag : Object(utils["E" /* vendorDisplayName */])(tag, workroom);
      }
    }), Object.defineProperty(_this, 'renderToolTip', {
      enumerable: true,
      writable: true,
      value: function value(phase) {
        var _ref2 = phase || {},
            source = _ref2.source,
            _ref2$workroom = _ref2.workroom;

        _ref2$workroom = _ref2$workroom === undefined ? {} : _ref2$workroom;
        var _ref2$workroom$name = _ref2$workroom.name,
            workroom = _ref2$workroom$name === undefined ? '' : _ref2$workroom$name;

        var vendorTag = source;
        if (constants["V" /* LHI_SOURCES */].includes(source) || source === 'IFI') vendorTag = source === 'IME' ? 'IME' : 'IMS';else if (vendorTag !== 'RF') vendorTag = '';
        var vendorDisplay = vendorTag ? _this.whichVendor(vendorTag, workroom) : '';
        return react_default.a.createElement(
          react_tooltip_dist_default.a,
          { id: 'installToolTip', place: 'top', effect: 'solid' },
          react_default.a.createElement(
            'span',
            { className: flagList_default.a.tooltipFlagNote },
            'By clicking this task I am confirming that communication has been made with the installer to ensure the installation is complete.',
            !!vendorDisplay && react_default.a.createElement(
              react["Fragment"],
              null,
              'I also understand this will complete the installation in ',
              vendorDisplay,
              '.'
            )
          )
        );
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            phase = _this$props.phase,
            updateTask = _this$props.updatePhaseTask,
            task = _this$props.task,
            _this$props$task = _this$props.task;
        _this$props$task = _this$props$task === undefined ? {} : _this$props$task;
        var _this$props$task$name = _this$props$task.name,
            taskName = _this$props$task$name === undefined ? '' : _this$props$task$name,
            _this$props$task$stat = _this$props$task.status,
            taskStatus = _this$props$task$stat === undefined ? '' : _this$props$task$stat;

        return react_default.a.createElement(
          'div',
          { className: phaseTask_default.a.taskContainer },
          react_default.a.createElement(components_TaskIcon, { status: taskStatus }),
          react_default.a.createElement(
            'button',
            {
              className: phaseTask_default.a.taskButton,
              'data-tip': true,
              'data-for': 'installToolTip',
              onClick: _this.onClick,
              disabled: _this.isDisabled()
            },
            taskName
          ),
          react_default.a.createElement(
            react_responsive_default.a,
            { minWidth: install_complete_MINIMUM_WIDTH },
            _this.renderToolTip(phase)
          ),
          react_default.a.createElement(installCompleteModal, {
            phase: phase,
            task: task,
            active: _this.state.modalActive,
            completeTask: _this.completeTask,
            onClose: _this.handleClose,
            updatePhaseTask: updateTask,
            childHandleTasksClose: _this.childHandleTasksClose
          })
        );
      }
    }), _temp), install_complete__possibleConstructorReturn(_this, _ret);
  }

  return InstallComplete;
}(phase_task);

install_complete_InstallComplete.propTypes = {
  phase: types_phase.isRequired,
  task: types_task.isRequired,
  updatePhaseTask: prop_types_default.a.func.isRequired,
  laborSheets: prop_types_default.a.array
};

install_complete_InstallComplete.defaultProps = { laborSheets: [] };

var install_complete = Object(react_redux_es["connect"])(function (state) {
  return { laborSheets: state.phase.laborSheets.items };
}, { updatePhaseTask: actionCreators["_67" /* updatePhaseTask */], clearValidationErrors: actionCreators["k" /* clearValidationErrors */] })(install_complete_InstallComplete);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/tasks/components/SubmitDocumentsModal/index.jsx
function SubmitDocumentsModal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SubmitDocumentsModal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function SubmitDocumentsModal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var BUTTONS = [{
  label: 'Yes, I certify that a permit or other documentation is required',
  value: 'yes'
}, {
  label: 'No, I certify that a permit or other documentation is NOT required',
  value: 'no'
}];

var SubmitDocumentsModal_SubmitDocumentsModal = function (_Resetter) {
  SubmitDocumentsModal__inherits(SubmitDocumentsModal, _Resetter);

  function SubmitDocumentsModal() {
    var _ref;

    var _temp, _this, _ret;

    SubmitDocumentsModal__classCallCheck(this, SubmitDocumentsModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = SubmitDocumentsModal__possibleConstructorReturn(this, (_ref = SubmitDocumentsModal.__proto__ || Object.getPrototypeOf(SubmitDocumentsModal)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'handleSubmit', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$state = _this.state,
            workOrderExplanation = _this$state.workOrderExplanation,
            isDocumentRequired = _this$state.isDocumentRequired;
        var _this$props = _this.props,
            phase = _this$props.phase,
            slug = _this$props.task.slug,
            updatePhaseTask = _this$props.updatePhaseTask;

        updatePhaseTask(phase.id, slug, {
          task: { status: 'complete' },
          data: {
            workorder_explanation: workOrderExplanation, document_required: isDocumentRequired
          }
        }).then(function () {
          return _this.handleClose();
        }).catch(function () {});
      }
    }), Object.defineProperty(_this, 'handleWorkOrderExplanation', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        return _this.setState({ workOrderExplanation: e.target.value });
      }
    }), Object.defineProperty(_this, 'handleIsDocumentRequired', {
      enumerable: true,
      writable: true,
      value: function value(_value) {
        return _this.setState({ isDocumentRequired: _value });
      }
    }), Object.defineProperty(_this, 'missingFieldsMessage', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$state2 = _this.state,
            workOrderExplanation = _this$state2.workOrderExplanation,
            isDocumentRequired = _this$state2.isDocumentRequired;

        var message = '';
        if (!workOrderExplanation) message = 'Explanation Needed';
        if (!isDocumentRequired) {
          var docRequired = 'Confirm Documentation Required';
          message = message ? message.concat(', ', docRequired) : docRequired;
        }
        return message;
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props2 = _this.props,
            active = _this$props2.active,
            task = _this$props2.task;
        var _this$state3 = _this.state,
            workOrderExplanation = _this$state3.workOrderExplanation,
            isDocumentRequired = _this$state3.isDocumentRequired;

        var submitDisabled = !workOrderExplanation || !isDocumentRequired;
        return react_default.a.createElement(
          react_toolbox_lib["Dialog"],
          {
            active: active,
            className: modal_default.a.modal,
            type: 'fullscreen',
            onEscKeyDown: _this.handleClose,
            onOverlayClick: _this.handleClose
          },
          react_default.a.createElement(lib_button["IconButton"], {
            icon: 'close',
            className: modal_default.a.close,
            onClick: _this.handleClose,
            tabIndex: -1
          }),
          react_default.a.createElement(
            'h5',
            { className: modal_default.a.title },
            'Complete Task: ',
            task.name
          ),
          react_default.a.createElement(components_TextArea, {
            label: 'Please explain the actions taken or support needed to resolve the Work Order',
            value: workOrderExplanation,
            onChange: _this.handleWorkOrderExplanation,
            autoFocus: true
          }),
          react_default.a.createElement('br', null),
          react_default.a.createElement(
            'p',
            null,
            'Is a permit or other documentation required for this Work Order?'
          ),
          react_default.a.createElement(components_RadioButtons, {
            onChange: _this.handleIsDocumentRequired,
            selectedValue: isDocumentRequired,
            radioButtons: BUTTONS,
            text: 'Examples of applicable documentation include permits, permit extensions, passed inspections, engineered drawings, customer punch lists, etc.'
          }),
          react_default.a.createElement(
            'div',
            { className: modal_default.a.actions },
            submitDisabled && react_default.a.createElement(
              'p',
              { className: modal_default.a.missingFieldsMessage },
              _this.missingFieldsMessage()
            ),
            react_default.a.createElement(ColoredButton["a" /* default */], {
              color: 'green',
              responsive: true,
              label: 'Complete Task',
              className: modal_default.a.button,
              onClick: _this.handleSubmit,
              disabled: submitDisabled
            }),
            react_default.a.createElement(ColoredButton["a" /* default */], {
              color: 'darkGray',
              responsive: true,
              label: 'Cancel',
              className: modal_default.a.button,
              onClick: _this.handleClose
            })
          )
        );
      }
    }), _temp), SubmitDocumentsModal__possibleConstructorReturn(_this, _ret);
  }

  return SubmitDocumentsModal;
}(resetter(validator(react_default.a.Component)));

Object.defineProperty(SubmitDocumentsModal_SubmitDocumentsModal, 'DEFAULT_STATE', {
  enumerable: true,
  writable: true,
  value: { workOrderExplanation: '', isDocumentRequired: '' }
});
/* harmony default export */ var components_SubmitDocumentsModal = (SubmitDocumentsModal_SubmitDocumentsModal);


SubmitDocumentsModal_SubmitDocumentsModal.propTypes = {
  active: prop_types_default.a.bool.isRequired,
  phase: types_phase.isRequired,
  task: types_task.isRequired,
  onClose: prop_types_default.a.func.isRequired,
  updatePhaseTask: prop_types_default.a.func.isRequired
};

SubmitDocumentsModal_SubmitDocumentsModal.defaultProps = { active: false };
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/tasks/workorder_upload_docs.jsx
function workorder_upload_docs__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function workorder_upload_docs__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function workorder_upload_docs__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var workorder_upload_docs_SubmitDocuments = function (_PhaseTask) {
  workorder_upload_docs__inherits(SubmitDocuments, _PhaseTask);

  function SubmitDocuments() {
    var _ref;

    var _temp, _this, _ret;

    workorder_upload_docs__classCallCheck(this, SubmitDocuments);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = workorder_upload_docs__possibleConstructorReturn(this, (_ref = SubmitDocuments.__proto__ || Object.getPrototypeOf(SubmitDocuments)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'onClick', {
      enumerable: true,
      writable: true,
      value: function value() {
        if (_this.props.task.status === 'complete') _this.toggleStatus();else _this.setState({ modalActive: true });
      }
    }), Object.defineProperty(_this, 'renderChildren', {
      enumerable: true,
      writable: true,
      value: function value() {
        return react_default.a.createElement(components_SubmitDocumentsModal, {
          phase: _this.props.phase,
          task: _this.props.task,
          active: _this.state.modalActive,
          updatePhaseTask: _this.props.updatePhaseTask,
          onClose: _this.handleClose
        });
      }
    }), _temp), workorder_upload_docs__possibleConstructorReturn(_this, _ret);
  }

  return SubmitDocuments;
}(phase_task);

workorder_upload_docs_SubmitDocuments.propTypes = {
  phase: types_phase.isRequired,
  task: types_task.isRequired,
  updatePhaseTask: prop_types_default.a.func.isRequired
};

var workorder_upload_docs = Object(react_redux_es["connect"])(function () {
  return {};
}, { updatePhaseTask: actionCreators_phase["s" /* updatePhaseTask */] })(workorder_upload_docs_SubmitDocuments);


// EXTERNAL MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/tasks/components/DeliveredModal/displayFeedStyling.css
var displayFeedStyling = __webpack_require__("XEfE");
var displayFeedStyling_default = /*#__PURE__*/__webpack_require__.n(displayFeedStyling);

// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/tasks/components/DeliveredModal/index.jsx
function DeliveredModal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function DeliveredModal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function DeliveredModal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var DeliveredModal_DeliveredModal = function (_Resetter) {
  DeliveredModal__inherits(DeliveredModal, _Resetter);

  function DeliveredModal(props) {
    DeliveredModal__classCallCheck(this, DeliveredModal);

    var _this = DeliveredModal__possibleConstructorReturn(this, (DeliveredModal.__proto__ || Object.getPrototypeOf(DeliveredModal)).call(this, props));

    Object.defineProperty(_this, 'handlePhotoSubmit', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            id = _this$props.phase.id,
            slug = _this$props.task.slug;

        if (_this.state.imgsTaken.length === 0) _this.setState({ errorMessage: true });else {
          var preppedImg = _this.state.imgsTaken;
          if (!_this.validate()) return;
          var formData = new FormData();
          preppedImg.map(function (img) {
            formData.append('document_upload[assets][][asset]', img);
            formData.append('document_upload[assets][][document_name]', 'DeliveryCompletePhoto' + img.lastModified);
            formData.append('document_upload[assets][][document_type]', img.type);
            return null;
          });
          _this.props.uploadDocument(formData, id).then(function () {
            return _this.props.updatePhaseTask(id, slug, { task: { status: 'complete' } });
          }).then(function () {
            return _this.handleClose();
          }).then(function () {
            return window.location.reload();
          }).catch(function (result) {
            return _this.setState({ sendError: true, errors: result.payload.errors });
          });
        }
      }
    });
    Object.defineProperty(_this, 'handleClearPhotos', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ imgsTaken: [] });
      }
    });
    Object.defineProperty(_this, 'onDrop', {
      enumerable: true,
      writable: true,
      value: function value(files) {
        var stateArr = _this.state.imgsTaken;
        for (var index = 0; index < files.length; index += 1) {
          var element = files[index];
          stateArr.push(element);
        }
        _this.setState({ imgsTaken: stateArr });
      }
    });
    Object.defineProperty(_this, 'mapUploadedPhoto', {
      enumerable: true,
      writable: true,
      value: function value(file, index) {
        return react_default.a.createElement(
          'a',
          { target: '_blank', rel: 'noopener noreferrer', key: index, href: file.preview },
          react_default.a.createElement('img', { style: { width: '100%' }, src: file.preview, key: file.preview, alt: file.name })
        );
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props2 = _this.props,
            active = _this$props2.active,
            serverErrors = _this$props2.errors;

        return react_default.a.createElement(
          react_toolbox_lib["Dialog"],
          {
            active: active, className: modal_default.a.modal, type: 'fullscreen',
            onEscKeyDown: _this.handleClose, onOverlayClick: _this.handleClose
          },
          react_default.a.createElement(
            'div',
            { className: input_default.a.errored },
            Object.keys(serverErrors).length > 0 && react_default.a.createElement(
              'span',
              { className: input_default.a.error },
              'This action could not be completed.'
            )
          ),
          react_default.a.createElement(react_toolbox_lib["IconButton"], { icon: 'close', className: modal_default.a.close, onClick: _this.handleClose }),
          react_default.a.createElement(
            'h5',
            null,
            'Delivery Picture'
          ),
          react_default.a.createElement(
            'div',
            null,
            react_default.a.createElement(
              'h6',
              null,
              'A picture is required upon delivery'
            ),
            react_default.a.createElement('br', null),
            react_default.a.createElement(
              react_dropzone_dist_default.a,
              { className: dropzoneStyles_default.a.uploadFile, onDrop: _this.onDrop },
              react_default.a.createElement(
                ColoredButton["a" /* default */],
                {
                  color: 'blue'
                },
                _this.state.imgsTaken.length > 0 ? 'Upload another photo' : 'Upload a photo'
              )
            ),
            react_default.a.createElement(
              'div',
              null,
              _this.state.imgsTaken.length > 0 ? _this.state.imgsTaken.map(function (file) {
                return _this.mapUploadedPhoto(file);
              }) : ''
            ),
            react_default.a.createElement(
              'div',
              { className: modal_default.a.btnContainer },
              _this.state.imgsTaken.length > 0 ? react_default.a.createElement(
                'div',
                null,
                react_default.a.createElement(ColoredButton["a" /* default */], {
                  style: { marginRight: '5px' },
                  color: 'red',
                  responsive: true,
                  label: 'Clear',
                  onClick: _this.handleClearPhotos
                }),
                react_default.a.createElement(ColoredButton["a" /* default */], {
                  color: 'blue',
                  responsive: true,
                  label: 'Submit',
                  onClick: _this.handlePhotoSubmit
                })
              ) : null,
              _this.state.errorMessage ? react_default.a.createElement(
                'h3',
                {
                  className: 'errorMsg', style: { color: 'red', textAlign: 'center', fontSize: '20px' }
                },
                'Please take a photo before submitting'
              ) : null
            )
          )
        );
      }
    });

    _this.state = { imgsTaken: [], errorMessage: false };
    return _this;
  }

  return DeliveredModal;
}(resetter(validator(react_default.a.Component)));

Object.defineProperty(DeliveredModal_DeliveredModal, 'VALIDATIONS', {
  enumerable: true,
  writable: true,
  value: { imgsTaken: 'This field is required' }
});


DeliveredModal_DeliveredModal.propTypes = {
  active: prop_types_default.a.bool.isRequired,
  clearValidation: prop_types_default.a.func.isRequired,
  clearValidationErrors: prop_types_default.a.func.isRequired,
  lrrpCreate: prop_types_default.a.func.isRequired,
  updatePhaseTask: prop_types_default.a.func.isRequired,
  uploadDocument: prop_types_default.a.func.isRequired,
  onClose: prop_types_default.a.func.isRequired,
  phase: types_phase.isRequired,
  leadCertNumber: prop_types_default.a.number,
  task: types_task.isRequired,
  serverErrors: prop_types_default.a.shape({}),
  errors: prop_types_default.a.shape({
    signature: prop_types_default.a.arrayOf(prop_types_default.a.string),
    description: prop_types_default.a.arrayOf(prop_types_default.a.string)
  })
};

DeliveredModal_DeliveredModal.defaultProps = { active: false };

/* harmony default export */ var components_DeliveredModal = (Object(react_redux_es["connect"])(function (state) {
  return { errors: state.walkthroughs.uploadError };
}, {
  clearValidation: actionCreators["j" /* clearValidation */],
  clearValidationErrors: actionCreators["k" /* clearValidationErrors */],
  lrrpCreate: actionCreators["M" /* lrrpCreate */],
  updatePhaseTask: actionCreators["_67" /* updatePhaseTask */],
  uploadDocument: actionCreators["_74" /* uploadDocument */]
})(DeliveredModal_DeliveredModal));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/tasks/delivered.jsx
function delivered__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function delivered__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function delivered__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var delivered_Delivered = function (_PhaseTask) {
  delivered__inherits(Delivered, _PhaseTask);

  function Delivered() {
    var _ref;

    var _temp, _this, _ret;

    delivered__classCallCheck(this, Delivered);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = delivered__possibleConstructorReturn(this, (_ref = Delivered.__proto__ || Object.getPrototypeOf(Delivered)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'isDisabled', {
      enumerable: true,
      writable: true,
      value: function value() {
        return false;
      }
    }), Object.defineProperty(_this, 'onClick', {
      enumerable: true,
      writable: true,
      value: function value() {
        if (_this.props.task.status === 'complete') _this.toggleStatus();else _this.setState({ modalActive: true });
      }
    }), Object.defineProperty(_this, 'renderChildren', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            phase = _this$props.phase,
            task = _this$props.task;

        return react_default.a.createElement(components_DeliveredModal, {
          phase: phase,
          leadCertNumber: 123456,
          task: task,
          active: _this.state.modalActive,
          completeTask: _this.completeTask,
          onClose: _this.handleClose
        });
      }
    }), _temp), delivered__possibleConstructorReturn(_this, _ret);
  }

  return Delivered;
}(phase_task);

delivered_Delivered.propTypes = {
  phase: types_phase.isRequired,
  task: types_task.isRequired,
  updatePhaseTask: prop_types_default.a.func.isRequired
};

var delivered = Object(react_redux_es["connect"])(function () {
  return {};
}, { updatePhaseTask: actionCreators["_67" /* updatePhaseTask */], clearValidationErrors: actionCreators["k" /* clearValidationErrors */] })(delivered_Delivered);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/tasks/check_out_of_store.jsx
function check_out_of_store__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function check_out_of_store__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function check_out_of_store__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var check_out_of_store_CheckOutOFStore = function (_PhaseTask) {
  check_out_of_store__inherits(CheckOutOFStore, _PhaseTask);

  function CheckOutOFStore() {
    var _ref;

    var _temp, _this, _ret;

    check_out_of_store__classCallCheck(this, CheckOutOFStore);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = check_out_of_store__possibleConstructorReturn(this, (_ref = CheckOutOFStore.__proto__ || Object.getPrototypeOf(CheckOutOFStore)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'isDisabled', {
      enumerable: true,
      writable: true,
      value: function value() {
        return false;
      }
    }), Object.defineProperty(_this, 'onClick', {
      enumerable: true,
      writable: true,
      value: function value() {
        if (_this.props.task.status !== 'complete') {
          _this.handleClose();
          _this.props.navigate(urls.phaseMaterialsChecklist(_this.props.phase));
        } else _this.toggleStatus();
      }
    }), _temp), check_out_of_store__possibleConstructorReturn(_this, _ret);
  }

  return CheckOutOFStore;
}(phase_task);

check_out_of_store_CheckOutOFStore.propTypes = {
  phase: types_phase.isRequired,
  task: types_task.isRequired,
  updatePhaseTask: prop_types_default.a.func.isRequired,
  navigate: prop_types_default.a.func.isRequired
};

var check_out_of_store = Object(react_redux_es["connect"])(function () {
  return function (state) {
    return { user: state.user };
  };
}, { updatePhaseTask: actionCreators_phase["s" /* updatePhaseTask */], navigate: actionCreators["O" /* navigate */] })(check_out_of_store_CheckOutOFStore);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/tasks/components/LeadAssessmentModal/index.jsx
var LeadAssessmentModal__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function LeadAssessmentModal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function LeadAssessmentModal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function LeadAssessmentModal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var LeadAssessmentModal_BUTTONS = [{ label: 'YES', value: 'yes' }, { label: 'NO', value: 'no' }];

var LeadAssessmentModal = function (_Resetter) {
  LeadAssessmentModal__inherits(LeadAssessmentModal, _Resetter);

  function LeadAssessmentModal(props) {
    LeadAssessmentModal__classCallCheck(this, LeadAssessmentModal);

    var _this = LeadAssessmentModal__possibleConstructorReturn(this, (LeadAssessmentModal.__proto__ || Object.getPrototypeOf(LeadAssessmentModal)).call(this, props));

    LeadAssessmentModal__initialiseProps.call(_this);

    var year_built = _this.props.phase.year_built;

    _this.state = {
      disruptingLead: _this.noAssessmentRequired(year_built) ? 'no' : '',
      note: '',
      status: null
    };
    return _this;
  }

  return LeadAssessmentModal;
}(resetter(validator(react_default.a.Component)));

var LeadAssessmentModal__initialiseProps = function _initialiseProps() {
  var _this2 = this;

  Object.defineProperty(this, 'noAssessmentRequired', {
    enumerable: true,
    writable: true,
    value: function value(year_built) {
      return year_built >= 1978;
    }
  });
  Object.defineProperty(this, 'handleSubmit', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _state = _this2.state,
          disruptingLead = _state.disruptingLead,
          status = _state.status,
          note = _state.note;
      var _props = _this2.props,
          id = _props.phase.id,
          slug = _props.task.slug,
          updatePhaseTask = _props.updatePhaseTask;

      updatePhaseTask(id, slug, {
        task: { status: 'complete' },
        data: { disrupting_lead: disruptingLead, comm_note: note }
      }).then(function () {
        return _this2.handleClose();
      }).catch(function () {});
      if (status) {
        var phaseProps = { phase: { status: status }, event: { data: { note: '' } } };
        _this2.props.overridePhaseStatus(id, phaseProps, { source: 'lead assessment', delete_appointments: 'no' });
      }
    }
  });
  Object.defineProperty(this, 'handleDisruptingLead', {
    enumerable: true,
    writable: true,
    value: function value(_value) {
      return _this2.setState({ disruptingLead: _value });
    }
  });
  Object.defineProperty(this, 'handleStatus', {
    enumerable: true,
    writable: true,
    value: function value(_value2) {
      return _this2.setState({ status: _value2 });
    }
  });
  Object.defineProperty(this, 'handleNoteChange', {
    enumerable: true,
    writable: true,
    value: function value(e) {
      return _this2.setState({ note: e.target.value });
    }
  });
  Object.defineProperty(this, 'missingFieldsMessage', {
    enumerable: true,
    writable: true,
    value: function value(disruptingLead, note) {
      var fieldArr = [];
      if (!disruptingLead) fieldArr.push('Answer Needed');
      if (!note) fieldArr.push('Note Needed');
      return fieldArr.join(', ');
    }
  });
  Object.defineProperty(this, 'render', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _props2 = _this2.props,
          active = _props2.active,
          task = _props2.task,
          _props2$phase = _props2.phase,
          phaseStatus = _props2$phase.status,
          available_statuses = _props2$phase.available_statuses,
          year_built = _props2$phase.year_built,
          source = _props2$phase.source,
          workroom = _props2$phase.workroom.name;
      var _state2 = _this2.state,
          disruptingLead = _state2.disruptingLead,
          status = _state2.status,
          note = _state2.note;

      var blockedStatuses = ['completed', 'canceled', phaseStatus];
      var statuses = available_statuses.map(function (s) {
        return LeadAssessmentModal__extends({}, s, { label: Object(utils["b" /* deriveStatusName */])(s.label, { source: source, workroom: workroom }) });
      }).filter(function (s) {
        return !blockedStatuses.includes(s.value);
      });
      var disabled = !note || !disruptingLead;
      return react_default.a.createElement(
        react_toolbox_lib["Dialog"],
        {
          active: active,
          className: modal_default.a.modal,
          type: 'fullscreen',
          onEscKeyDown: _this2.handleClose,
          onOverlayClick: _this2.handleClose
        },
        react_default.a.createElement(lib_button["IconButton"], {
          icon: 'close',
          className: modal_default.a.close,
          onClick: _this2.handleClose,
          tabIndex: -1
        }),
        react_default.a.createElement(
          'h5',
          { className: modal_default.a.title },
          'Complete Task: ',
          task.name
        ),
        _this2.noAssessmentRequired(year_built) ? react_default.a.createElement(
          react["Fragment"],
          null,
          react_default.a.createElement(
            'div',
            null,
            'Structure was built after 1977, no lead inspection required'
          ),
          react_default.a.createElement('br', null)
        ) : react_default.a.createElement(components_RadioButtons, {
          onChange: _this2.handleDisruptingLead,
          selectedValue: disruptingLead,
          radioButtons: LeadAssessmentModal_BUTTONS,
          text: 'During inspection, was it determined that we would disrupt more than 6 sqft. of potential lead?'
        }),
        react_default.a.createElement(components_StyledSelect, {
          className: ComposeWindow_styles_default.a.select,
          label: 'Override to Status',
          onChange: _this2.handleStatus,
          options: statuses,
          value: status,
          placeholder: 'Select'
        }),
        react_default.a.createElement(components_TextArea, {
          label: 'Notes *',
          value: note,
          onChange: _this2.handleNoteChange,
          autoFocus: true
        }),
        react_default.a.createElement(
          'div',
          { className: modal_default.a.actions },
          disabled && react_default.a.createElement(
            'p',
            { className: modal_default.a.missingFieldsMessage },
            _this2.missingFieldsMessage(disruptingLead, note)
          ),
          react_default.a.createElement(ColoredButton["a" /* default */], {
            color: 'green',
            responsive: true,
            label: 'Complete Task',
            className: modal_default.a.button,
            onClick: _this2.handleSubmit,
            disabled: disabled
          }),
          react_default.a.createElement(ColoredButton["a" /* default */], {
            color: 'darkGray',
            responsive: true,
            label: 'Cancel',
            className: modal_default.a.button,
            onClick: _this2.handleClose
          })
        )
      );
    }
  });
};

/* harmony default export */ var components_LeadAssessmentModal = (LeadAssessmentModal);


LeadAssessmentModal.propTypes = {
  active: prop_types_default.a.bool.isRequired,
  phase: types_phase.isRequired,
  task: types_task.isRequired,
  onClose: prop_types_default.a.func.isRequired,
  updatePhaseTask: prop_types_default.a.func.isRequired,
  overridePhaseStatus: prop_types_default.a.func.isRequired
};

LeadAssessmentModal.defaultProps = { active: false };
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/tasks/lead_assessment.jsx
function lead_assessment__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function lead_assessment__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function lead_assessment__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var lead_assessment_LeadAssessment = function (_PhaseTask) {
  lead_assessment__inherits(LeadAssessment, _PhaseTask);

  function LeadAssessment() {
    var _ref;

    var _temp, _this, _ret;

    lead_assessment__classCallCheck(this, LeadAssessment);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = lead_assessment__possibleConstructorReturn(this, (_ref = LeadAssessment.__proto__ || Object.getPrototypeOf(LeadAssessment)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'isDisabled', {
      enumerable: true,
      writable: true,
      value: function value() {
        return false;
      }
    }), Object.defineProperty(_this, 'onClick', {
      enumerable: true,
      writable: true,
      value: function value() {
        if (_this.props.task.status === 'complete') _this.toggleStatus();else _this.setState({ modalActive: true });
      }
    }), Object.defineProperty(_this, 'renderChildren', {
      enumerable: true,
      writable: true,
      value: function value() {
        var phase = _this.props.phase;

        if (phase.type === 'Workorder' && ifiUtils(phase)) {
          return react_default.a.createElement(phaseActionMenu_ifiLrrpModal, {
            phase: phase,
            taskSlug: 'lead_assessment',
            active: _this.state.modalActive,
            onClose: _this.handleClose
          });
        }

        return react_default.a.createElement(components_LeadAssessmentModal, {
          phase: _this.props.phase,
          task: _this.props.task,
          active: _this.state.modalActive,
          updatePhaseTask: _this.props.updatePhaseTask,
          overridePhaseStatus: _this.props.overridePhaseStatus,
          onClose: _this.handleClose
        });
      }
    }), _temp), lead_assessment__possibleConstructorReturn(_this, _ret);
  }

  return LeadAssessment;
}(phase_task);

lead_assessment_LeadAssessment.propTypes = {
  phase: types_phase.isRequired,
  task: types_task.isRequired,
  updatePhaseTask: prop_types_default.a.func.isRequired
};

var lead_assessment = Object(react_redux_es["connect"])(function () {
  return {};
}, { updatePhaseTask: actionCreators_phase["s" /* updatePhaseTask */], overridePhaseStatus: actionCreators_phase["l" /* overridePhaseStatus */] })(lead_assessment_LeadAssessment);


// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/receivedETAModal.jsx
var receivedETAModal__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var receivedETAModal__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var receivedETAModal__get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function receivedETAModal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function receivedETAModal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function receivedETAModal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var receivedETAModal_ReceivedETAModal = function (_Resetter) {
  receivedETAModal__inherits(ReceivedETAModal, _Resetter);

  function ReceivedETAModal(props) {
    receivedETAModal__classCallCheck(this, ReceivedETAModal);

    var _this = receivedETAModal__possibleConstructorReturn(this, (ReceivedETAModal.__proto__ || Object.getPrototypeOf(ReceivedETAModal)).call(this, props));

    Object.defineProperty(_this, 'handleEtaChange', {
      enumerable: true,
      writable: true,
      value: function value(date) {
        var isDateString = !!date.match(/^\d{2}\/\d{2}\/\d{4}$/);
        if (!isDateString) _this.setState({ errorMessage: true });else _this.setState({ vendorEta: date, errorMessage: false });
      }
    });
    Object.defineProperty(_this, 'data', {
      enumerable: true,
      writable: true,
      value: function value() {
        return { event: { data: {
              note: 'ETA: ' + _this.state.vendorEta,
              vendor_eta: Object(dateUtils["o" /* handleDateSave */])(_this.state.vendorEta)
            } } };
      }
    });
    Object.defineProperty(_this, 'handleSubmit', {
      enumerable: true,
      writable: true,
      value: function value() {
        if (_this.state.vendorEta === '') {
          _this.setState({ errorMessage: true });
        } else {
          if (!_this.validate()) return;
          var task = { status: 'complete' };
          var data = _this.data();
          _this.props.updatePhaseTask(_this.props.phase.id, _this.props.task.slug, receivedETAModal__extends({ task: task }, data)).then(function () {
            return _this.handleClose();
          }).catch(function (result) {
            return _this.setState({
              errorMessage: true, errors: result.payload.errors
            });
          });
        }
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$state = _this.state,
            vendorEta = _this$state.vendorEta,
            errorMessage = _this$state.errorMessage;

        return react_default.a.createElement(
          react_toolbox_lib["Dialog"],
          {
            active: _this.props.active, className: modal_default.a.modal, type: 'fullscreen',
            onEscKeyDown: _this.handleClose, onOverlayClick: _this.handleClose
          },
          react_default.a.createElement(react_toolbox_lib["IconButton"], { icon: 'close', className: modal_default.a.close, onClick: _this.handleClose }),
          react_default.a.createElement(
            'h5',
            { style: { textAlign: 'center' } },
            'Vendor ETA'
          ),
          react_default.a.createElement('br', null),
          react_default.a.createElement(DatePicker, {
            label: 'Designate an ETA',
            minDate: moment_business_days_default()().toDate(),
            value: vendorEta,
            onChange: function onChange(event) {
              return _this.handleEtaChange(event);
            },
            className: modal_default.a.datePicker,
            placeholder: 'Click the calendar icon to select date',
            error: errorMessage.vendorEta
          }),
          errorMessage ? react_default.a.createElement(
            'h3',
            {
              className: 'errorMsg',
              style: { color: 'red', textAlign: 'center', fontSize: '15px' }
            },
            'Please select a valid date before submitting. Use the following format: MM/DD/YYYY'
          ) : null,
          react_default.a.createElement(
            'div',
            { className: modal_default.a.actions },
            react_default.a.createElement(ColoredButton["a" /* default */], {
              color: 'green',
              responsive: true,
              disabled: errorMessage,
              label: 'Complete Task',
              className: modal_default.a.button,
              onClick: _this.handleSubmit
            }),
            react_default.a.createElement(ColoredButton["a" /* default */], {
              color: 'darkGray',
              responsive: true,
              label: 'Cancel',
              className: modal_default.a.button,
              onClick: _this.handleClose
            })
          )
        );
      }
    });

    _this.state = { vendorEta: '', errorMessage: false };
    return _this;
  }

  receivedETAModal__createClass(ReceivedETAModal, [{
    key: 'handleClose',
    value: function handleClose() {
      receivedETAModal__get(ReceivedETAModal.prototype.__proto__ || Object.getPrototypeOf(ReceivedETAModal.prototype), 'handleClose', this).call(this);
      this.props.clearValidation();
      document.location.reload();
    }
  }]);

  return ReceivedETAModal;
}(resetter(validator(react_default.a.Component)));

Object.defineProperty(receivedETAModal_ReceivedETAModal, 'VALIDATIONS', {
  enumerable: true,
  writable: true,
  value: { vendorEta: true }
});


receivedETAModal_ReceivedETAModal.propTypes = {
  active: prop_types_default.a.bool.isRequired,
  phase: types_phase.isRequired,
  task: types_task.isRequired,
  onClose: prop_types_default.a.func.isRequired,
  updatePhaseTask: prop_types_default.a.func.isRequired,
  clearValidation: prop_types_default.a.func.isRequired
};

receivedETAModal_ReceivedETAModal.defaultProps = {
  active: false
};

/* harmony default export */ var receivedETAModal = (Object(react_redux_es["connect"])(function (state) {
  return {
    errors: state.walkthroughs.uploadError
  };
}, {
  clearValidation: actionCreators["j" /* clearValidation */],
  updatePhaseTask: actionCreators["_67" /* updatePhaseTask */]
})(receivedETAModal_ReceivedETAModal));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/tasks/received_eta.jsx
function received_eta__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function received_eta__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function received_eta__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var received_eta_ReceivedEta = function (_PhaseTask) {
  received_eta__inherits(ReceivedEta, _PhaseTask);

  function ReceivedEta() {
    var _ref;

    var _temp, _this, _ret;

    received_eta__classCallCheck(this, ReceivedEta);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = received_eta__possibleConstructorReturn(this, (_ref = ReceivedEta.__proto__ || Object.getPrototypeOf(ReceivedEta)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'onClick', {
      enumerable: true,
      writable: true,
      value: function value() {
        if (_this.props.task.status !== 'complete') _this.setState({ modalActive: true });
      }
    }), Object.defineProperty(_this, 'renderChildren', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            phase = _this$props.phase,
            task = _this$props.task;

        return react_default.a.createElement(receivedETAModal, {
          phase: phase,
          userName: name,
          task: task,
          active: _this.state.modalActive,
          completeTask: _this.completeTask,
          onClose: _this.handleClose
        });
      }
    }), _temp), received_eta__possibleConstructorReturn(_this, _ret);
  }

  return ReceivedEta;
}(phase_task);

received_eta_ReceivedEta.propTypes = {
  phase: types_phase.isRequired,
  task: types_task.isRequired,
  updatePhaseTask: prop_types_default.a.func.isRequired
};

var received_eta = Object(react_redux_es["connect"])(function () {
  return {};
}, {
  updatePhaseTask: actionCreators["_67" /* updatePhaseTask */], clearValidationErrors: actionCreators["k" /* clearValidationErrors */] })(received_eta_ReceivedEta);


// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/tasks/components/BeforeAndAfterModal/index.jsx
function BeforeAndAfterModal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function BeforeAndAfterModal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function BeforeAndAfterModal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var BeforeAndAfterModal_BeforeAndAfterPhotosTaskModal = function (_Resetter) {
  BeforeAndAfterModal__inherits(BeforeAndAfterPhotosTaskModal, _Resetter);

  function BeforeAndAfterPhotosTaskModal(props) {
    BeforeAndAfterModal__classCallCheck(this, BeforeAndAfterPhotosTaskModal);

    var _this = BeforeAndAfterModal__possibleConstructorReturn(this, (BeforeAndAfterPhotosTaskModal.__proto__ || Object.getPrototypeOf(BeforeAndAfterPhotosTaskModal)).call(this, props));

    Object.defineProperty(_this, 'handlePhotoSubmit', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            id = _this$props.phase.id,
            slug = _this$props.task.slug;

        if (_this.state.imgsTaken.length === 0) _this.setState({ errorMessage: true });else {
          var preppedImg = _this.state.imgsTaken;
          if (!_this.validate()) return;
          var formData = new FormData();
          preppedImg.map(function (img) {
            formData.append('document_upload[assets][][asset]', img);
            formData.append('document_upload[assets][][document_name]', _this.props.task.slug === 'before_photos' ? 'BeforePhoto' + img.lastModified : 'AfterPhoto' + img.lastModified);
            formData.append('document_upload[assets][][document_type]', _this.props.task.slug === 'before_photos' ? 'Before Photos' : 'After Photos');
            return null;
          });
          _this.props.uploadDocument(formData, id).then(function () {
            return _this.props.updatePhaseTask(id, slug, { task: { status: 'complete' } });
          }).then(function () {
            return _this.handleClose();
          }).then(function () {
            return window.location.reload();
          }).catch(function (result) {
            return _this.setState({ sendError: true, errors: result.payload.errors });
          });
        }
      }
    });
    Object.defineProperty(_this, 'handleClearPhotos', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ imgsTaken: [] });
      }
    });
    Object.defineProperty(_this, 'onDrop', {
      enumerable: true,
      writable: true,
      value: function value(files) {
        var stateArr = _this.state.imgsTaken;
        for (var index = 0; index < files.length; index += 1) {
          var element = files[index];
          stateArr.push(element);
        }
        _this.setState({ imgsTaken: stateArr });
      }
    });
    Object.defineProperty(_this, 'mapUploadedPhoto', {
      enumerable: true,
      writable: true,
      value: function value(file, index) {
        return react_default.a.createElement(
          'a',
          { target: '_blank', rel: 'noopener noreferrer', key: index, href: file.preview },
          react_default.a.createElement('img', { style: { width: '100%' }, src: file.preview, key: file.preview, alt: file.name })
        );
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props2 = _this.props,
            active = _this$props2.active,
            serverErrors = _this$props2.errors;

        return react_default.a.createElement(
          react_toolbox_lib["Dialog"],
          {
            active: active, className: modal_default.a.modal, type: 'fullscreen',
            onEscKeyDown: _this.handleClose, onOverlayClick: _this.handleClose
          },
          react_default.a.createElement(
            'div',
            { className: input_default.a.errored },
            Object.keys(serverErrors).length > 0 && react_default.a.createElement(
              'span',
              { className: input_default.a.error },
              'This action could not be completed.'
            )
          ),
          react_default.a.createElement(react_toolbox_lib["IconButton"], { icon: 'close', className: modal_default.a.close, onClick: _this.handleClose }),
          react_default.a.createElement(
            'h5',
            null,
            _this.props.task.slug === 'before_photos' ? 'Before Photos' : 'After Photos'
          ),
          react_default.a.createElement(
            'div',
            null,
            react_default.a.createElement(
              'h6',
              null,
              'Please upload ',
              react_default.a.createElement(
                'strong',
                null,
                _this.props.task.slug === 'before_photos' ? 'before' : 'after'
              ),
              ' photos prior to install'
            ),
            react_default.a.createElement('br', null),
            react_default.a.createElement(
              react_dropzone_dist_default.a,
              { className: dropzoneStyles_default.a.uploadFile, onDrop: _this.onDrop },
              react_default.a.createElement(
                ColoredButton["a" /* default */],
                {
                  color: 'blue'
                },
                _this.state.imgsTaken.length > 0 ? 'Upload another photo' : 'Upload a photo'
              )
            ),
            react_default.a.createElement(
              'div',
              null,
              _this.state.imgsTaken.length > 0 ? _this.state.imgsTaken.map(function (file) {
                return _this.mapUploadedPhoto(file);
              }) : ''
            ),
            react_default.a.createElement(
              'div',
              { className: modal_default.a.btnContainer },
              _this.state.imgsTaken.length > 0 ? react_default.a.createElement(
                'div',
                null,
                react_default.a.createElement(ColoredButton["a" /* default */], {
                  style: { marginRight: '5px' },
                  color: 'red',
                  responsive: true,
                  label: 'Clear',
                  onClick: _this.handleClearPhotos
                }),
                react_default.a.createElement(ColoredButton["a" /* default */], {
                  color: 'blue',
                  responsive: true,
                  label: 'Submit',
                  onClick: _this.handlePhotoSubmit
                })
              ) : null,
              _this.state.errorMessage ? react_default.a.createElement(
                'h3',
                {
                  className: 'errorMsg', style: { color: 'red', textAlign: 'center', fontSize: '20px' }
                },
                'Please take a photo before submitting'
              ) : null
            )
          )
        );
      }
    });

    _this.state = { imgsTaken: [], errorMessage: false };
    return _this;
  }

  return BeforeAndAfterPhotosTaskModal;
}(resetter(validator(react_default.a.Component)));

Object.defineProperty(BeforeAndAfterModal_BeforeAndAfterPhotosTaskModal, 'VALIDATIONS', {
  enumerable: true,
  writable: true,
  value: { imgsTaken: 'This field is required' }
});


BeforeAndAfterModal_BeforeAndAfterPhotosTaskModal.propTypes = {
  active: prop_types_default.a.bool.isRequired,
  clearValidation: prop_types_default.a.func.isRequired,
  clearValidationErrors: prop_types_default.a.func.isRequired,
  lrrpCreate: prop_types_default.a.func.isRequired,
  updatePhaseTask: prop_types_default.a.func.isRequired,
  uploadDocument: prop_types_default.a.func.isRequired,
  onClose: prop_types_default.a.func.isRequired,
  phase: types_phase.isRequired,
  leadCertNumber: prop_types_default.a.number,
  task: types_task.isRequired,
  serverErrors: prop_types_default.a.shape({}),
  errors: prop_types_default.a.shape({
    signature: prop_types_default.a.arrayOf(prop_types_default.a.string),
    description: prop_types_default.a.arrayOf(prop_types_default.a.string)
  })
};

BeforeAndAfterModal_BeforeAndAfterPhotosTaskModal.defaultProps = { active: false };

/* harmony default export */ var BeforeAndAfterModal = (Object(react_redux_es["connect"])(function (state) {
  return { errors: state.walkthroughs.uploadError };
}, {
  clearValidation: actionCreators["j" /* clearValidation */],
  clearValidationErrors: actionCreators["k" /* clearValidationErrors */],
  lrrpCreate: actionCreators["M" /* lrrpCreate */],
  updatePhaseTask: actionCreators["_67" /* updatePhaseTask */],
  uploadDocument: actionCreators["_74" /* uploadDocument */]
})(BeforeAndAfterModal_BeforeAndAfterPhotosTaskModal));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/tasks/before_photos.jsx
function before_photos__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function before_photos__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function before_photos__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var before_photos_BeforePhotos = function (_PhaseTask) {
  before_photos__inherits(BeforePhotos, _PhaseTask);

  function BeforePhotos() {
    var _ref;

    var _temp, _this, _ret;

    before_photos__classCallCheck(this, BeforePhotos);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = before_photos__possibleConstructorReturn(this, (_ref = BeforePhotos.__proto__ || Object.getPrototypeOf(BeforePhotos)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'isDisabled', {
      enumerable: true,
      writable: true,
      value: function value() {
        return false;
      }
    }), Object.defineProperty(_this, 'onClick', {
      enumerable: true,
      writable: true,
      value: function value() {
        if (_this.props.task.status === 'complete') _this.toggleStatus();else _this.setState({ modalActive: true });
      }
    }), Object.defineProperty(_this, 'renderChildren', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            phase = _this$props.phase,
            task = _this$props.task;

        return react_default.a.createElement(BeforeAndAfterModal, {
          phase: phase,
          leadCertNumber: 123456,
          task: task,
          active: _this.state.modalActive,
          completeTask: _this.completeTask,
          onClose: _this.handleClose
        });
      }
    }), _temp), before_photos__possibleConstructorReturn(_this, _ret);
  }

  return BeforePhotos;
}(phase_task);

before_photos_BeforePhotos.propTypes = {
  phase: types_phase.isRequired,
  task: types_task.isRequired,
  updatePhaseTask: prop_types_default.a.func.isRequired
};

var before_photos = Object(react_redux_es["connect"])(function () {
  return {};
}, { updatePhaseTask: actionCreators["_67" /* updatePhaseTask */], clearValidationErrors: actionCreators["k" /* clearValidationErrors */] })(before_photos_BeforePhotos);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/tasks/after_photos.jsx
function after_photos__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function after_photos__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function after_photos__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var after_photos_AfterPhotos = function (_PhaseTask) {
  after_photos__inherits(AfterPhotos, _PhaseTask);

  function AfterPhotos() {
    var _ref;

    var _temp, _this, _ret;

    after_photos__classCallCheck(this, AfterPhotos);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = after_photos__possibleConstructorReturn(this, (_ref = AfterPhotos.__proto__ || Object.getPrototypeOf(AfterPhotos)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'isDisabled', {
      enumerable: true,
      writable: true,
      value: function value() {
        return false;
      }
    }), Object.defineProperty(_this, 'onClick', {
      enumerable: true,
      writable: true,
      value: function value() {
        if (_this.props.task.status === 'complete') _this.toggleStatus();else _this.setState({ modalActive: true });
      }
    }), Object.defineProperty(_this, 'renderChildren', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            phase = _this$props.phase,
            task = _this$props.task;

        return react_default.a.createElement(BeforeAndAfterModal, {
          phase: phase,
          leadCertNumber: 123456,
          task: task,
          active: _this.state.modalActive,
          completeTask: _this.completeTask,
          onClose: _this.handleClose
        });
      }
    }), _temp), after_photos__possibleConstructorReturn(_this, _ret);
  }

  return AfterPhotos;
}(phase_task);

after_photos_AfterPhotos.propTypes = {
  phase: types_phase.isRequired,
  task: types_task.isRequired,
  updatePhaseTask: prop_types_default.a.func.isRequired
};

var after_photos = Object(react_redux_es["connect"])(function () {
  return {};
}, { updatePhaseTask: actionCreators["_67" /* updatePhaseTask */], clearValidationErrors: actionCreators["k" /* clearValidationErrors */] })(after_photos_AfterPhotos);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/tasks/index.js


// export * from './install_pl';




// export * from './send_to_store';





















// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/phaseTasks.jsx









var SCHEDULING_TASKS = ['schedule_install', 'scheduling_checklist'];

var phaseTasks_tasksFilter = function tasksFilter(_ref, _ref2, role) {
  var status = _ref.status,
      type = _ref.type;
  var slug = _ref2.slug;

  if (!Object(services["a" /* can */])(role, 'update', 'phase_task', { status: status, slug: slug })) return false;
  if (type === 'Installation' && status === 'scheduling') return SCHEDULING_TASKS.includes(slug);
  return true;
};

var phaseTasks_filterByLRRP = function filterByLRRP(phase, _ref3) {
  var slug = _ref3.slug;
  var lead_practices_required = phase.lead_practices_required,
      year_built = phase.year_built,
      source = phase.source,
      name = phase.workroom.name;
  // For non-LRRP tasks, always allow

  if (slug !== 'sign_lrrp' && slug !== 'lead_assessment') return true;

  // Hide LRRP tasks for IFI Installation/Workorder phases (use action button instead)
  if (ifiUtils(phase) && (phase.type === 'Installation' || phase.type === 'Workorder')) {
    return false;
  }

  // Check if LRRP is required based on phase properties
  var lrrpRequired = slug === 'sign_lrrp' && lead_practices_required && (year_built || 0) <= 1977 && (
  // IFI is a non-LHI source that still requires LRRP documentation.
  ifiUtils(phase) || !constants["_8" /* NON_LHI_SOURCES */].includes(source)) && !name.includes('PFT-');

  // For all remaining LRRP tasks, use the standard LRRP requirement check
  return lrrpRequired || slug === 'lead_assessment';
};

var tasksByVendor = function tasksByVendor(_ref4, _ref5) {
  var source = _ref4.source;
  var slug = _ref5.slug;
  return !['before_photos', 'after_photos'].includes(slug) || source === 'RF';
};

var tasksByRocky = function tasksByRocky(_ref6, _ref7) {
  var rockyManaged = _ref6.rocky_managed;
  var slug = _ref7.slug;
  return !(rockyManaged && slug === 'send_to_floor_wizard');
};

var phaseTasks_PhaseTasks = function PhaseTasks(_ref8) {
  var phase = _ref8.phase,
      role = _ref8.role,
      employeeType = _ref8.employeeType,
      currentTasks = _ref8.phase.current_tasks,
      handleTasksClose = _ref8.handleTasksClose;
  return react_default.a.createElement(
    'div',
    { className: phaseTaskBar_default.a.phaseTaskBar__taskContainer },
    currentTasks.filter(function (task) {
      return tasksByVendor(phase, task);
    }).filter(function (task) {
      return tasksByRocky(phase, task);
    }).filter(function (task) {
      return phaseTasks_filterByLRRP(phase, task);
    }).filter(function (task) {
      return phaseTasks_tasksFilter(phase, task, role);
    }).map(function (task) {
      var TaskType = tasks_namespaceObject[task.slug] || phase_task_phase_task;
      var cloneTask = Object.assign({}, task);
      if (phase.type !== 'Assessment' && employeeType === 'Employee' && task.name === 'En Route') cloneTask.name = 'Dispatch';
      return react_default.a.createElement(TaskType, {
        key: task.slug, phase: phase, task: cloneTask, handleTasksClose: handleTasksClose
      });
    })
  );
};

phaseTasks_PhaseTasks.propTypes = {
  phase: types_phase.isRequired,
  role: prop_types_default.a.string.isRequired,
  handleTasksClose: prop_types_default.a.func.isRequired,
  employeeType: prop_types_default.a.string
};

/* harmony default export */ var components_phaseTasks = (phaseTasks_PhaseTasks);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/phaseTaskBar.jsx
function phaseTaskBar__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function phaseTaskBar__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function phaseTaskBar__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var phaseTaskBar_MINIMUM_WIDTH = 920;

var phaseTaskBar_PhaseTaskBar = function (_React$Component) {
  phaseTaskBar__inherits(PhaseTaskBar, _React$Component);

  function PhaseTaskBar(props) {
    phaseTaskBar__classCallCheck(this, PhaseTaskBar);

    var _this = phaseTaskBar__possibleConstructorReturn(this, (PhaseTaskBar.__proto__ || Object.getPrototypeOf(PhaseTaskBar)).call(this, props));

    Object.defineProperty(_this, 'state', {
      enumerable: true,
      writable: true,
      value: { taskModalOpen: false, flagModalOpen: false }
    });
    Object.defineProperty(_this, 'componentWillMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props$phase = _this.props.phase,
            type = _this$props$phase.type,
            status = _this$props$phase.status,
            phaseId = _this$props$phase.id;

        return type === 'Installation' && status === 'installing' ? Object(actionCreators["_17" /* requestPhaseItems */])(phaseId, 'laborSheets') : null;
      }
    });
    Object.defineProperty(_this, 'phaseTasksAvailable', {
      enumerable: true,
      writable: true,
      value: function value(role, status) {
        return Object(services["a" /* can */])(role, 'update', 'phase_task', { status: status });
      }
    });
    Object.defineProperty(_this, 'handleTasksOpen', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ taskModalOpen: true });
      }
    });
    Object.defineProperty(_this, 'handleTasksClose', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ taskModalOpen: false });
      }
    });
    Object.defineProperty(_this, 'handleFlagsOpen', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ flagModalOpen: true });
      }
    });
    Object.defineProperty(_this, 'handleFlagsClose', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ flagModalOpen: false });
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            phase = _this$props.phase,
            role = _this$props.role,
            employeeType = _this$props.employeeType;

        return react_default.a.createElement(
          'div',
          { className: phaseTaskBar_default.a.phaseTaskBar },
          react_default.a.createElement(components_phaseStatus, { phase: phase }),
          phase.pending_quick_schedule_response && react_default.a.createElement(
            'span',
            { className: phaseTaskBar_default.a.pendingQuickScheduleBadge },
            'Pending Customer Confirmation'
          ),
          react_default.a.createElement(
            react_responsive_default.a,
            { minWidth: phaseTaskBar_MINIMUM_WIDTH },
            react_default.a.createElement(
              'div',
              { className: phaseTaskBar_default.a.phaseTaskBar__infoContainer },
              _this.phaseTasksAvailable(role, phase.status) && react_default.a.createElement(components_phaseTasks, {
                phase: phase, role: role, handleTasksClose: _this.handleTasksClose,
                employeeType: employeeType
              }),
              Object(services["a" /* can */])(role, 'view', 'flag') && react_default.a.createElement(
                ResourceDetailsCardElement,
                {
                  title: 'Flags', wrap: true, className: phaseTaskBar_default.a.phaseTaskBar__flagsContainer
                },
                react_default.a.createElement(components_flagList, {
                  flags: phase.flags,
                  deleteEnabled: Object(services["a" /* can */])(role, 'delete', 'flag'),
                  onFlagNavigate: function onFlagNavigate() {
                    return _this.props.navigate(urls.phaseCommunications(phase));
                  }
                }),
                phase.flags.length === 0 && '--'
              )
            )
          ),
          react_default.a.createElement(
            react_responsive_default.a,
            { maxWidth: phaseTaskBar_MINIMUM_WIDTH - 1 },
            react_default.a.createElement(
              'span',
              null,
              _this.phaseTasksAvailable(role, phase.status) && react_default.a.createElement(
                ColoredButton["a" /* default */],
                {
                  onClick: _this.handleTasksOpen, color: 'blue'
                },
                'View Current Tasks'
              ),
              ' ',
              Object(services["a" /* can */])(role, 'view', 'flag') && react_default.a.createElement(
                ColoredButton["a" /* default */],
                {
                  onClick: _this.handleFlagsOpen, color: 'blue'
                },
                'View Flags'
              )
            ),
            react_default.a.createElement(
              react_toolbox_lib["Dialog"],
              {
                active: _this.state.taskModalOpen,
                className: modal_default.a.modal,
                onEscKeyDown: _this.handleTasksClose,
                onOverlayClick: _this.handleTasksClose
              },
              react_default.a.createElement(react_toolbox_lib["IconButton"], {
                icon: 'close',
                className: modal_default.a.close,
                onClick: _this.handleTasksClose
              }),
              react_default.a.createElement(
                'h2',
                { className: modal_default.a.title },
                'Current Tasks'
              ),
              react_default.a.createElement(components_phaseTasks, {
                phase: phase,
                role: role,
                handleTasksClose: _this.handleTasksClose,
                employeeType: employeeType
              })
            ),
            react_default.a.createElement(
              react_toolbox_lib["Dialog"],
              {
                active: _this.state.flagModalOpen,
                className: modal_default.a.modal,
                onEscKeyDown: _this.handleFlagsClose,
                onOverlayClick: _this.handleFlagsClose
              },
              react_default.a.createElement(react_toolbox_lib["IconButton"], {
                icon: 'close',
                className: modal_default.a.close,
                onClick: _this.handleFlagsClose
              }),
              react_default.a.createElement(
                'h2',
                { className: modal_default.a.title },
                'Flags'
              ),
              react_default.a.createElement(components_flagList, {
                flags: phase.flags,
                deleteEnabled: Object(services["a" /* can */])(role, 'delete', 'flag'),
                onFlagNavigate: function onFlagNavigate() {
                  return _this.props.navigate(urls.phaseCommunications(phase));
                }
              })
            )
          )
        );
      }
    });

    _this.handleTasksClose = _this.handleTasksClose.bind(_this);
    return _this;
  }

  return PhaseTaskBar;
}(react_default.a.Component);

phaseTaskBar_PhaseTaskBar.propTypes = {
  phase: types_phase.isRequired,
  role: prop_types_default.a.string.isRequired,
  employeeType: prop_types_default.a.string,
  navigate: prop_types_default.a.func.isRequired
};

var phaseTaskBar_mapStateToProps = function mapStateToProps() {
  return {};
};

/* harmony default export */ var components_phaseTaskBar = (Object(react_redux_es["connect"])(phaseTaskBar_mapStateToProps, { requestPhaseItems: actionCreators["_17" /* requestPhaseItems */], navigate: actionCreators["O" /* navigate */] })(phaseTaskBar_PhaseTaskBar));
// EXTERNAL MODULE: ./node_modules/react-toolbox/lib/menu/index.js
var lib_menu = __webpack_require__("lrpO");
var menu_default = /*#__PURE__*/__webpack_require__.n(lib_menu);

// EXTERNAL MODULE: ./client/app/shared/actionCreators/ims_actions.js
var ims_actions = __webpack_require__("+GGQ");

// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/addCommunicationModal.jsx
var addCommunicationModal__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var addCommunicationModal__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var addCommunicationModal__get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var addCommunicationModal__templateObject = addCommunicationModal__taggedTemplateLiteral(['\n0% {\n    transform: translateY(-100%);\n    opacity: 0;\n  }\n\n100% {\n    transform: translateY(0);\n    opacity: 1;\n  }\n'], ['\n0% {\n    transform: translateY(-100%);\n    opacity: 0;\n  }\n\n100% {\n    transform: translateY(0);\n    opacity: 1;\n  }\n']),
    addCommunicationModal__templateObject2 = addCommunicationModal__taggedTemplateLiteral(['\noverflow: hidden;\n'], ['\noverflow: hidden;\n']);

function addCommunicationModal__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function addCommunicationModal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function addCommunicationModal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function addCommunicationModal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function addCommunicationModal__taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }


























var displayDeleteAppt = function displayDeleteAppt(status) {
  return ['hold', 'rescheduling', 'customer_not_ready'].includes(status);
};

var addCommunicationModal_expand = Object(core_browser_esm["keyframes"])(addCommunicationModal__templateObject);

var addCommunicationModal_DropdownDiv = styled_browser_esm["a" /* default */].div(function (_ref) {
  var status = _ref.status;
  return {
    animation: displayDeleteAppt(status) ? addCommunicationModal_expand + ' 400ms ease-out' : ''
  };
});

var addCommunicationModal_ContainerDiv = styled_browser_esm["a" /* default */].div(addCommunicationModal__templateObject2);

var addCommunicationModal_AddCommunicationModal = function (_Resetter) {
  addCommunicationModal__inherits(AddCommunicationModal, _Resetter);

  function AddCommunicationModal(props) {
    addCommunicationModal__classCallCheck(this, AddCommunicationModal);

    var _this = addCommunicationModal__possibleConstructorReturn(this, (AddCommunicationModal.__proto__ || Object.getPrototypeOf(AddCommunicationModal)).call(this, props));

    addCommunicationModal__initialiseProps.call(_this);

    var _props$phase = props.phase,
        phase = _props$phase === undefined ? {} : _props$phase;
    var _phase$source = phase.source,
        source = _phase$source === undefined ? '' : _phase$source;

    var isContractor = constants["v" /* CONTRACTOR_ROLES */].includes((props.role || '').toLowerCase());
    var isLhi = Object(utils["D" /* validateSource */])(source);
    var eligibleImsVendor = isLhi && source !== 'IME' || source === 'IFI';
    var eligibleVendor = eligibleImsVendor || source === 'RF';
    _this.state = {
      isContractor: isContractor,
      isLhi: isLhi,
      eligibleImsVendor: eligibleImsVendor,
      eligibleVendor: eligibleVendor,
      vendorTag: eligibleImsVendor ? 'IMS' : source,
      status: '',
      note: '',
      dueAt: '',
      errors: {},
      modalActive: false,
      deleteAppts: false,
      statusOptions: _this.buildStatusOptions(isContractor, phase)
    };
    return _this;
  }

  addCommunicationModal__createClass(AddCommunicationModal, [{
    key: 'handleClose',
    value: function handleClose() {
      addCommunicationModal__get(AddCommunicationModal.prototype.__proto__ || Object.getPrototypeOf(AddCommunicationModal.prototype), 'handleClose', this).call(this);
      this.props.clearValidation();
    }
  }]);

  return AddCommunicationModal;
}(resetter(validator(react_default.a.Component)));

Object.defineProperty(addCommunicationModal_AddCommunicationModal, 'VALIDATIONS', {
  enumerable: true,
  writable: true,
  value: { who: true, method: true, result: true, note: true }
});

var addCommunicationModal__initialiseProps = function _initialiseProps() {
  var _this2 = this;

  Object.defineProperty(this, 'toggleModalActive', {
    enumerable: true,
    writable: true,
    value: function value() {
      return _this2.setState({ modalActive: !_this2.state.modalActive });
    }
  });
  Object.defineProperty(this, 'toggleDeleteAppts', {
    enumerable: true,
    writable: true,
    value: function value() {
      return _this2.setState({ deleteAppts: !_this2.state.deleteAppts });
    }
  });
  Object.defineProperty(this, 'toggleCnrCheckbox', {
    enumerable: true,
    writable: true,
    value: function value() {
      return _this2.setState({ cnrCheckbox: !_this2.state.cnrCheckbox }, function () {
        return _this2.state.cnrCheckbox ? _this2.setState({ reschedCheckbox: false }) : null;
      });
    }
  });
  Object.defineProperty(this, 'toggleReschedCheckbox', {
    enumerable: true,
    writable: true,
    value: function value() {
      return _this2.setState({ reschedCheckbox: !_this2.state.reschedCheckbox }, function () {
        return _this2.state.reschedCheckbox ? _this2.setState({ cnrCheckbox: false }) : null;
      });
    }
  });
  Object.defineProperty(this, 'callUpdatePhase', {
    enumerable: true,
    writable: true,
    value: function value(id, dueAt) {
      return dueAt ? _this2.props.updatePhase({ id: id, due_at: dueAt }, { actionType: 'update_due_at' }) : Promise.resolve();
    }
  });
  Object.defineProperty(this, 'callOverride', {
    enumerable: true,
    writable: true,
    value: function value() {
      var dueAt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var _props = _this2.props,
          override = _props.overridePhaseStatus,
          id = _props.phase.id;
      var _state = _this2.state,
          status = _state.status,
          deleteAppts = _state.deleteAppts;

      var phaseProps = { phase: { status: status }, event: { data: { note: '' } } };
      var delete_appointments = deleteAppts ? 'yes' : 'no';
      return override(id, phaseProps, { source: 'add communication', delete_appointments: delete_appointments }).then(function () {
        return _this2.callUpdatePhase(id, dueAt);
      });
    }
  });
  Object.defineProperty(this, 'callIms', {
    enumerable: true,
    writable: true,
    value: function value(id, due_at, params) {
      var ims_type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'follow_up';
      var _props2 = _this2.props,
          stdUpdate = _props2.updateIMS,
          noteUpdate = _props2.updateIMSNote;

      return due_at ? stdUpdate(id, addCommunicationModal__extends({}, params, { ims_type: ims_type, due_at: due_at })) : noteUpdate(id, params);
    }
  });
  Object.defineProperty(this, 'handleSubmit', {
    enumerable: true,
    writable: true,
    value: function value() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Internal';
      var _state2 = _this2.state,
          cnrCheckbox = _state2.cnrCheckbox,
          reschedCheckbox = _state2.reschedCheckbox;

      var note = _this2.textAreaComponentRef.textAreaRef.value;
      var validations = addCommunicationModal__extends({ note: true }, (cnrCheckbox || reschedCheckbox) && { dueAt: true });
      _this2.setState({ note: note }, function () {
        var _props3 = _this2.props,
            addEvent = _props3.addEventToPhase,
            _props3$phase = _props3.phase;
        _props3$phase = _props3$phase === undefined ? {} : _props3$phase;
        var id = _props3$phase.id;
        var _state3 = _this2.state,
            dueAt = _state3.dueAt,
            status = _state3.status,
            eligibleImsVendor = _state3.eligibleImsVendor;

        if (!_this2.validate(validations)) return;
        var noteProps = {
          name: type + ' Communication',
          kind: 'communication',
          data: { note: note, new_due_date: dueAt || null }
        };
        var validExternal = eligibleImsVendor && type === 'External';
        (status ? _this2.callOverride(dueAt) : _this2.callUpdatePhase(id, dueAt)).then(function () {
          return addEvent(id, noteProps);
        }).then(function () {
          return validExternal ? _this2.callIms(id, dueAt, { note: note }) : Promise.resolve();
        }).then(function () {
          return _this2.handleClose();
        }).catch(function () {});
      });
    }
  });
  Object.defineProperty(this, 'handleChange', {
    enumerable: true,
    writable: true,
    value: function value(prop) {
      return function (val) {
        return _this2.setState(addCommunicationModal__defineProperty({}, prop, val));
      };
    }
  });
  Object.defineProperty(this, 'handleDueChange', {
    enumerable: true,
    writable: true,
    value: function value(dueAt) {
      return _this2.setState({ dueAt: dueAt });
    }
  });
  Object.defineProperty(this, 'buildStatusOptions', {
    enumerable: true,
    writable: true,
    value: function value(isContractor) {
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          type = _ref2.type,
          status = _ref2.status,
          source = _ref2.source,
          _ref2$available_statu = _ref2.available_statuses,
          statuses = _ref2$available_statu === undefined ? [] : _ref2$available_statu,
          _ref2$appointments = _ref2.appointments,
          appts = _ref2$appointments === undefined ? [] : _ref2$appointments,
          _ref2$workroom = _ref2.workroom;

      _ref2$workroom = _ref2$workroom === undefined ? {} : _ref2$workroom;
      var _ref2$workroom$name = _ref2$workroom.name,
          workroom = _ref2$workroom$name === undefined ? '' : _ref2$workroom$name;

      var blockedStatuses = ['canceled', status];
      if (!appts.length) blockedStatuses.push('awaiting_install');
      if (!isContractor && type !== 'Assessment') blockedStatuses.push('completed');
      if (type === 'Installation' && ['installing', 'follow_up', 'completed', 'canceled'].includes(status)) {
        blockedStatuses.push('waiting_for_product');
      }
      return statuses.map(function (aS) {
        return addCommunicationModal__extends({}, aS, { label: Object(utils["b" /* deriveStatusName */])(aS.label, { source: source, workroom: workroom })
        });
      }).filter(function (s) {
        return !blockedStatuses.includes(s.value);
      });
    }
  });
  Object.defineProperty(this, 'noteWarning', {
    enumerable: true,
    writable: true,
    value: function value() {
      return 'Notes that are written here will be uploaded to ' + _this2.state.vendorTag + ' if external.';
    }
  });
  Object.defineProperty(this, 'canShowExternalButton', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _props$phase2 = _this2.props.phase,
          phase = _props$phase2 === undefined ? {} : _props$phase2;
      var source = phase.source,
          type = phase.type,
          wo_source = phase.wo_source;

      if (type !== 'Workorder') return true;
      if (source !== 'RF') return true;
      // If the phase is a workorder of source "RF", don't show the External button unless wo_source
      // is present & not "SPIG generated"
      return !!wo_source && wo_source !== 'SPIG generated';
    }
  });
  Object.defineProperty(this, 'render', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _props4 = _this2.props,
          active = _props4.active,
          serverErrors = _props4.serverErrors,
          _props4$phase = _props4.phase,
          type = _props4$phase.type,
          phaseStatus = _props4$phase.status;
      var _state4 = _this2.state,
          status = _state4.status,
          dueAt = _state4.dueAt,
          errors = _state4.errors,
          modalActive = _state4.modalActive,
          deleteAppts = _state4.deleteAppts,
          isContractor = _state4.isContractor,
          vendorTag = _state4.vendorTag,
          statusOptions = _state4.statusOptions,
          eligibleVendor = _state4.eligibleVendor,
          eligibleImsVendor = _state4.eligibleImsVendor;

      return react_default.a.createElement(
        components_ComposeWindow,
        { active: active, title: 'Add Communication', onClose: _this2.handleClose },
        react_default.a.createElement(
          'div',
          { className: input_default.a.errored },
          serverErrors && Object.keys(serverErrors).length > 0 && react_default.a.createElement(
            'span',
            { className: input_default.a.error },
            Object(utils["d" /* errorSummary */])(serverErrors)
          )
        ),
        modalActive && react_default.a.createElement(ConfirmDialog["a" /* default */], {
          title: '' + (dueAt ? 'This sends a Follow Up Date change to ' + vendorTag + ' for the selected date' : 'This sends a note to ' + vendorTag),
          okLabel: 'Yes',
          cancelLabel: 'Cancel',
          cancel: _this2.toggleModalActive,
          dismiss: _this2.toggleModalActive,
          proceed: function proceed() {
            return _this2.handleSubmit('External');
          }
        }),
        react_default.a.createElement(components_TextArea, {
          label: _this2.noteWarning(),
          defaultValue: '',
          errors: errors.note,
          autoFocus: true,
          ref: function ref(comp) {
            _this2.textAreaComponentRef = comp;
          }
        }),
        !['canceled', 'completed'].includes(phaseStatus) && !isContractor && react_default.a.createElement(components_UpdateDueDate, {
          value: dueAt,
          onChange: _this2.handleDueChange,
          errors: errors,
          dateLabel: 'Update Due Date',
          timeLabel: 'Update Due Date Time',
          required: false
        }),
        react_default.a.createElement(components_StyledSelect, {
          className: ComposeWindow_styles_default.a.select,
          label: 'Override to Status',
          onChange: _this2.handleChange('status'),
          options: statusOptions,
          value: status,
          placeholder: 'Select',
          error: Object(utils["c" /* error */])('status', errors)
        }),
        displayDeleteAppt(status) && react_default.a.createElement(
          addCommunicationModal_ContainerDiv,
          null,
          react_default.a.createElement(
            addCommunicationModal_DropdownDiv,
            { status: status },
            react_default.a.createElement(
              'div',
              { className: form_default.a.statusCheckboxRow },
              react_default.a.createElement(react_toolbox_lib["Checkbox"], {
                checked: deleteAppts,
                label: 'Delete future appointments due to reschedule status?',
                theme: checkbox_default.a,
                className: form_default.a.checkboxListItem,
                onChange: _this2.toggleDeleteAppts
              })
            )
          )
        ),
        !isContractor && react_default.a.createElement(
          'div',
          { className: form_default.a.row },
          react_default.a.createElement(
            'span',
            null,
            'Due Date Times earlier than 8am will be set to 8am'
          )
        ),
        react_default.a.createElement(
          'div',
          { className: form_default.a.row },
          react_default.a.createElement(react_toolbox_lib["Button"], {
            label: 'Internal',
            primary: true,
            flat: true,
            ripple: true,
            className: ComposeWindow_styles_default.a.submit,
            onClick: function onClick() {
              return _this2.handleSubmit('Internal');
            }
          }),
          !isContractor && eligibleVendor && _this2.canShowExternalButton() && react_default.a.createElement(react_toolbox_lib["Button"], {
            label: 'External',
            primary: true,
            flat: true,
            ripple: true,
            className: ComposeWindow_styles_default.a.submit,
            onClick: _this2.toggleModalActive
          })
        ),
        eligibleImsVendor && type === 'Workorder' && react_default.a.createElement(
          react["Fragment"],
          null,
          react_default.a.createElement(components_BreakLine, null),
          react_default.a.createElement(
            'div',
            { className: form_default.a.addCommWarning },
            'If External, it will need to be manually updated in IMS'
          )
        )
      );
    }
  });
};

addCommunicationModal_AddCommunicationModal.propTypes = {
  active: prop_types_default.a.bool.isRequired,
  role: prop_types_default.a.string,
  addEventToPhase: prop_types_default.a.func.isRequired,
  updatePhase: prop_types_default.a.func.isRequired,
  overridePhaseStatus: prop_types_default.a.func.isRequired,
  clearValidation: prop_types_default.a.func.isRequired,
  onClose: prop_types_default.a.func.isRequired,
  phase: types_phase.isRequired,
  serverErrors: prop_types_default.a.shape({})
};

addCommunicationModal_AddCommunicationModal.defaultProps = { active: false };

/* harmony default export */ var addCommunicationModal = (Object(react_redux_es["connect"])(function (state) {
  return {
    serverErrors: Object(reducers["Y" /* getPhaseErrors */])(state),
    role: state.user.role
  };
}, { addEventToPhase: actionCreators_phase["a" /* addEventToPhase */], updatePhase: actionCreators_phase["r" /* updatePhase */], clearValidation: actionCreators_phase["f" /* clearValidation */], updateIMS: ims_actions["a" /* updateIMS */], updateIMSNote: ims_actions["b" /* updateIMSNote */], overridePhaseStatus: actionCreators_phase["l" /* overridePhaseStatus */] })(addCommunicationModal_AddCommunicationModal));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/addNoteModal.jsx
var addNoteModal__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var addNoteModal__get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function addNoteModal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function addNoteModal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function addNoteModal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var addNoteModal_AddNoteModal = function (_Resetter) {
  addNoteModal__inherits(AddNoteModal, _Resetter);

  function AddNoteModal() {
    var _ref;

    var _temp, _this, _ret;

    addNoteModal__classCallCheck(this, AddNoteModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = addNoteModal__possibleConstructorReturn(this, (_ref = AddNoteModal.__proto__ || Object.getPrototypeOf(AddNoteModal)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'handleSubmit', {
      enumerable: true,
      writable: true,
      value: function value() {
        var note = _this.textAreaComponentRef.textAreaRef.value;
        _this.setState({ note: note }, function () {
          if (!_this.validate()) return;
          var phaseID = _this.props.phase.id;

          var noteProps = {
            name: 'Note',
            kind: 'note',
            data: { note: note }
          };

          _this.props.addEventToPhase(phaseID, noteProps).then(function () {
            _this.handleClose();
          }).catch(function () {}); // catching this to avoid console warnings...
        });
      }
    }), _temp), addNoteModal__possibleConstructorReturn(_this, _ret);
  }

  addNoteModal__createClass(AddNoteModal, [{
    key: 'handleClose',
    value: function handleClose() {
      addNoteModal__get(AddNoteModal.prototype.__proto__ || Object.getPrototypeOf(AddNoteModal.prototype), 'handleClose', this).call(this);
      this.props.clearValidation();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var errors = this.state.errors;

      var active = this.props.active;

      return react_default.a.createElement(
        components_ComposeWindow,
        {
          active: active,
          title: 'Add Note',
          onClose: this.handleClose
        },
        react_default.a.createElement(components_TextArea, {
          label: 'Notes *',
          defaultValue: '',
          className: ComposeWindow_styles_default.a.compose,
          errors: errors.note,
          autoFocus: true,
          ref: function ref(comp) {
            _this2.textAreaComponentRef = comp;
          }
        }),
        react_default.a.createElement(
          'div',
          { className: ComposeWindow_styles_default.a.actions },
          react_default.a.createElement(lib_button["Button"], {
            label: 'Add Note',
            primary: true, flat: true, ripple: true,
            className: ComposeWindow_styles_default.a.submit,
            onClick: this.handleSubmit
          })
        )
      );
    }
  }]);

  return AddNoteModal;
}(resetter(validator(react_default.a.Component)));

Object.defineProperty(addNoteModal_AddNoteModal, 'DEFAULT_STATE', {
  enumerable: true,
  writable: true,
  value: {
    note: '',
    errors: {}
  }
});
Object.defineProperty(addNoteModal_AddNoteModal, 'VALIDATIONS', {
  enumerable: true,
  writable: true,
  value: { note: true }
});


addNoteModal_AddNoteModal.propTypes = {
  active: prop_types_default.a.bool.isRequired,
  addEventToPhase: prop_types_default.a.func.isRequired,
  clearValidation: prop_types_default.a.func.isRequired,
  onClose: prop_types_default.a.func.isRequired,
  phase: types_phase.isRequired,
  errors: prop_types_default.a.shape({
    note: prop_types_default.a.arrayOf(prop_types_default.a.string)
  })
};

addNoteModal_AddNoteModal.defaultProps = {
  active: false
};

/* harmony default export */ var addNoteModal = (Object(react_redux_es["connect"])(function (state) {
  return { errors: Object(reducers["Y" /* getPhaseErrors */])(state) };
}, { addEventToPhase: actionCreators_phase["a" /* addEventToPhase */], clearValidation: actionCreators_phase["f" /* clearValidation */] })(addNoteModal_AddNoteModal));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/addContractorNoteModal.jsx
var addContractorNoteModal__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function addContractorNoteModal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function addContractorNoteModal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function addContractorNoteModal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var addContractorNoteModal_AddContractorNoteModal = function (_React$Component) {
  addContractorNoteModal__inherits(AddContractorNoteModal, _React$Component);

  function AddContractorNoteModal() {
    var _ref;

    var _temp, _this, _ret;

    addContractorNoteModal__classCallCheck(this, AddContractorNoteModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = addContractorNoteModal__possibleConstructorReturn(this, (_ref = AddContractorNoteModal.__proto__ || Object.getPrototypeOf(AddContractorNoteModal)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'handleSubmit', {
      enumerable: true,
      writable: true,
      value: function value() {
        var phaseID = _this.props.phase.id;
        var note = _this.textAreaComponentRef.textAreaRef.value;

        var noteProps = {
          name: 'Contractor Note',
          kind: 'note',
          data: { note: note }
        };

        _this.props.updatePhase({ id: phaseID, contractor_notes: note }, { actionType: 'update_contractor_notes' }).then(function () {
          return _this.props.addEventToPhase(phaseID, noteProps).then(function () {
            _this.handleClose();
          });
        }).catch(function () {}); // catching this to avoid console warnings...
      }
    }), Object.defineProperty(_this, 'handleClose', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.props.clearValidation();
        _this.props.onClose();
      }
    }), _temp), addContractorNoteModal__possibleConstructorReturn(_this, _ret);
  }

  addContractorNoteModal__createClass(AddContractorNoteModal, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.active && !this.props.active) {
        this.setState({ note: nextProps.phase.contractor_notes });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          active = _props.active,
          errors = _props.errors;


      return react_default.a.createElement(
        components_ComposeWindow,
        {
          active: active,
          title: 'Contractor Notes',
          onClose: this.handleClose
        },
        react_default.a.createElement(components_TextArea, {
          defaultValue: this.props.phase.contractor_notes,
          label: 'Notes *',
          className: ComposeWindow_styles_default.a.compose,
          errors: errors.contractor_notes,
          autoFocus: true,
          ref: function ref(comp) {
            _this2.textAreaComponentRef = comp;
          }
        }),
        react_default.a.createElement(
          'div',
          { className: ComposeWindow_styles_default.a.actions },
          react_default.a.createElement(lib_button["Button"], {
            label: 'Save Note',
            primary: true, flat: true, ripple: true,
            className: ComposeWindow_styles_default.a.submit,
            onClick: this.handleSubmit
          })
        )
      );
    }
  }]);

  return AddContractorNoteModal;
}(react_default.a.Component);

addContractorNoteModal_AddContractorNoteModal.propTypes = {
  active: prop_types_default.a.bool.isRequired,
  updatePhase: prop_types_default.a.func.isRequired,
  addEventToPhase: prop_types_default.a.func.isRequired,
  clearValidation: prop_types_default.a.func.isRequired,
  onClose: prop_types_default.a.func.isRequired,
  phase: types_phase.isRequired,
  errors: prop_types_default.a.shape({
    contractor_notes: prop_types_default.a.arrayOf(prop_types_default.a.string)
  })
};

addContractorNoteModal_AddContractorNoteModal.defaultProps = {
  active: false,
  errors: {}
};

/* harmony default export */ var addContractorNoteModal = (Object(react_redux_es["connect"])(function (state) {
  return { errors: Object(reducers["Y" /* getPhaseErrors */])(state) };
}, { updatePhase: actionCreators_phase["r" /* updatePhase */], addEventToPhase: actionCreators_phase["a" /* addEventToPhase */], clearValidation: actionCreators_phase["f" /* clearValidation */] })(addContractorNoteModal_AddContractorNoteModal));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/setDueTomorrowModal.jsx
var setDueTomorrowModal__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var setDueTomorrowModal__get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function setDueTomorrowModal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function setDueTomorrowModal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function setDueTomorrowModal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var setDueTomorrowModal_SetDueTomorrowModal = function (_Resetter) {
  setDueTomorrowModal__inherits(SetDueTomorrowModal, _Resetter);

  function SetDueTomorrowModal() {
    var _ref;

    var _temp, _this, _ret;

    setDueTomorrowModal__classCallCheck(this, SetDueTomorrowModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = setDueTomorrowModal__possibleConstructorReturn(this, (_ref = SetDueTomorrowModal.__proto__ || Object.getPrototypeOf(SetDueTomorrowModal)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'handleConfirm', {
      enumerable: true,
      writable: true,
      value: function value() {
        var phase = _this.props.phase;

        var tomorrow = moment_default()().add(1, 'days').hour(8);
        var dueAt = tomorrow.toISOString();
        var mmddyyyy = tomorrow.format('MM/DD/YYYY');
        _this.props.addEventToPhase(phase.id, {
          name: 'Due Date Updated',
          kind: 'note',
          data: { note: 'Due date set to tomorrow (' + mmddyyyy + ') via quick action.' }
        }).then(function () {
          _this.handleClose();
        });
        _this.props.updatePhase({ id: phase.id, due_at: dueAt }, { actionType: 'update_due_at' });
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        return react_default.a.createElement(
          components_ComposeWindow,
          { active: _this.props.active, title: 'Set Due Date to Tomorrow', onClose: _this.handleClose },
          react_default.a.createElement(
            'div',
            { className: input_default.a.row, style: { marginBottom: 20 } },
            'Are you sure you want to set the phase due date to tomorrow?'
          ),
          react_default.a.createElement(
            'div',
            { className: input_default.a.row, style: { display: 'flex', justifyContent: 'center', gap: '16px' } },
            react_default.a.createElement(react_toolbox_lib["Button"], { label: 'No', flat: true, ripple: true, onClick: _this.handleClose }),
            react_default.a.createElement(react_toolbox_lib["Button"], { label: 'Yes', primary: true, flat: true, ripple: true, onClick: _this.handleConfirm })
          )
        );
      }
    }), _temp), setDueTomorrowModal__possibleConstructorReturn(_this, _ret);
  }

  setDueTomorrowModal__createClass(SetDueTomorrowModal, [{
    key: 'handleClose',
    value: function handleClose() {
      setDueTomorrowModal__get(SetDueTomorrowModal.prototype.__proto__ || Object.getPrototypeOf(SetDueTomorrowModal.prototype), 'handleClose', this).call(this);
    }
  }]);

  return SetDueTomorrowModal;
}(resetter(validator(react_default.a.Component)));

setDueTomorrowModal_SetDueTomorrowModal.propTypes = {
  active: prop_types_default.a.bool.isRequired,
  phase: prop_types_default.a.object.isRequired,
  onClose: prop_types_default.a.func.isRequired,
  updatePhase: prop_types_default.a.func.isRequired,
  addEventToPhase: prop_types_default.a.func.isRequired
};

/* harmony default export */ var setDueTomorrowModal = (Object(react_redux_es["connect"])(null, { updatePhase: actionCreators_phase["r" /* updatePhase */], addEventToPhase: actionCreators_phase["a" /* addEventToPhase */] })(setDueTomorrowModal_SetDueTomorrowModal));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/cancelPhaseModal.jsx
var cancelPhaseModal__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var cancelPhaseModal__get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function cancelPhaseModal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function cancelPhaseModal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function cancelPhaseModal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





















var CANCEL_MESSAGE = 'Are you sure you want to cancel?';

var cancelPhaseModal_CancelPhaseModal = function (_Resetter) {
  cancelPhaseModal__inherits(CancelPhaseModal, _Resetter);

  function CancelPhaseModal() {
    var _ref;

    var _temp, _this, _ret;

    cancelPhaseModal__classCallCheck(this, CancelPhaseModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = cancelPhaseModal__possibleConstructorReturn(this, (_ref = CancelPhaseModal.__proto__ || Object.getPrototypeOf(CancelPhaseModal)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'handleWhoChange', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        return _this.setState({ who: e });
      }
    }), Object.defineProperty(_this, 'handleReasonChange', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        return _this.setState({ reason: e.target.value });
      }
    }), Object.defineProperty(_this, 'handleSubmit', {
      enumerable: true,
      writable: true,
      value: function value() {
        // We need to run local validation because the client will always send a
        // note and a name to the API, which are the only two required params. `who`
        // and `reason` are used to compose the note, so they need to be checked by
        // the client. This allows the same API endpoint to be used for multiple
        // actions.
        if (!_this.validate()) return;
        _this.setState({ showConfirm: true });
      }
    }), Object.defineProperty(_this, 'handleConfirmSubmit', {
      enumerable: true,
      writable: true,
      value: function value() {
        if (!_this.validate()) return;
        var phase = _this.props.phase;
        var who = _this.state.who;
        var reason = _this.state.reason;
        var phaseProps = {
          event: {
            name: 'Canceled',
            kind: 'phase_canceled',
            data: {
              who: who,
              from_status: phase.status_name,
              note: reason
            }
          }
        };
        _this.props.cancelPhase(phase.id, phaseProps).then(function () {
          _this.handleClose();
        }).catch(function () {
          _this.setState({ showConfirm: false });
        });
      }
    }), Object.defineProperty(_this, 'handleConfirmClose', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.handleClose();
      }
    }), Object.defineProperty(_this, 'options', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props$phase = _this.props.phase,
            source = _this$props$phase.source,
            name = _this$props$phase.workroom.name;

        var vendorOption = Object(utils["E" /* vendorDisplayName */])(source, name);
        var baseOptions = ['Customer', 'SPIG', 'Duplicate', 'Contractor', 'Out of Scope', 'Customer Not Requested', vendorOption];
        return (vendorOption !== 'Refloor' ? baseOptions : [].concat(baseOptions, [Object(utils["E" /* vendorDisplayName */])('PFT', null, true)])).map(function (o) {
          return { value: o, label: o };
        });
      }
    }), Object.defineProperty(_this, 'futureApptExists', {
      enumerable: true,
      writable: true,
      value: function value() {
        return (_this.props.phase.appointments || []).some(function (appt) {
          return moment_default()(appt.start_date, constants["_19" /* RAILS_DATE */]).isAfter(moment_default()());
        });
      }
    }), Object.defineProperty(_this, 'determineCancelMessage', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.futureApptExists() ? CANCEL_MESSAGE + ' There are future appointments scheduled for this phase.' : CANCEL_MESSAGE + ' Please confirm there are no outstanding exceptions open on L/P & Accounting.';
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            active = _this$props.active,
            serverErrors = _this$props.serverErrors;
        var _this$state = _this.state,
            who = _this$state.who,
            reason = _this$state.reason,
            showConfirm = _this$state.showConfirm,
            errors = _this$state.errors;

        return react_default.a.createElement(
          react_toolbox_lib["Dialog"],
          {
            active: active,
            className: modal_default.a.modal,
            type: 'fullscreen',
            onEscKeyDown: _this.handleClose,
            onOverlayClick: _this.handleClose
          },
          react_default.a.createElement(
            'div',
            { className: input_default.a.errored },
            Object.keys(serverErrors).length > 0 && react_default.a.createElement(
              'span',
              { className: input_default.a.error },
              Object(utils["d" /* errorSummary */])(serverErrors)
            )
          ),
          react_default.a.createElement(lib_button["IconButton"], {
            icon: 'close',
            className: modal_default.a.close,
            onClick: _this.handleClose,
            tabIndex: -1
          }),
          react_default.a.createElement(
            'h5',
            { className: modal_default.a.title },
            'Cancel Phase'
          ),
          react_default.a.createElement(components_StyledSelect, {
            className: modal_default.a.select,
            label: 'Who canceled? *',
            onChange: _this.handleWhoChange,
            options: _this.options(),
            value: who,
            placeholder: 'Select',
            error: Object(utils["c" /* error */])('who', errors)
          }),
          react_default.a.createElement(components_TextArea, {
            label: 'Reason *',
            value: reason,
            errors: errors.reason,
            onChange: _this.handleReasonChange
          }),
          react_default.a.createElement(lib_button["Button"], {
            label: 'Cancel Phase',
            flat: true, inverse: true, ripple: true,
            className: modal_default.a.submit,
            onClick: _this.handleSubmit
          }),
          react_default.a.createElement(ConfirmDialog["a" /* default */], {
            title: _this.determineCancelMessage(),
            okLabel: 'Yes, Cancel the Phase',
            cancelLabel: 'No',
            show: showConfirm,
            cancel: _this.handleConfirmClose,
            dismiss: _this.handleConfirmClose,
            proceed: _this.handleConfirmSubmit
          })
        );
      }
    }), _temp), cancelPhaseModal__possibleConstructorReturn(_this, _ret);
  }

  cancelPhaseModal__createClass(CancelPhaseModal, [{
    key: 'handleClose',
    value: function handleClose() {
      cancelPhaseModal__get(CancelPhaseModal.prototype.__proto__ || Object.getPrototypeOf(CancelPhaseModal.prototype), 'handleClose', this).call(this);
      this.props.clearValidation();
    }

    // Until we make PFT its own vendor, we have to make special consideration
    // TODO: Remove this function when PFT is a vendor

  }]);

  return CancelPhaseModal;
}(resetter(validator(react_default.a.Component)));

Object.defineProperty(cancelPhaseModal_CancelPhaseModal, 'DEFAULT_STATE', {
  enumerable: true,
  writable: true,
  value: {
    who: '',
    reason: '',
    showConfirm: false,
    errors: {}
  }
});
Object.defineProperty(cancelPhaseModal_CancelPhaseModal, 'VALIDATIONS', {
  enumerable: true,
  writable: true,
  value: { who: true, reason: true }
});


cancelPhaseModal_CancelPhaseModal.propTypes = {
  active: prop_types_default.a.bool.isRequired,
  cancelPhase: prop_types_default.a.func.isRequired,
  clearValidation: prop_types_default.a.func.isRequired,
  onClose: prop_types_default.a.func.isRequired,
  phase: types_phase.isRequired,
  serverErrors: prop_types_default.a.shape({})
};

cancelPhaseModal_CancelPhaseModal.defaultProps = { active: false };

/* harmony default export */ var cancelPhaseModal = (Object(react_redux_es["connect"])(function (state) {
  return { serverErrors: Object(reducers["Y" /* getPhaseErrors */])(state) };
}, { cancelPhase: actionCreators_phase["e" /* cancelPhase */], clearValidation: actionCreators_phase["f" /* clearValidation */] })(cancelPhaseModal_CancelPhaseModal));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/addFlagModal.jsx
function addFlagModal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function addFlagModal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function addFlagModal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



















var hasDueTime = function hasDueTime(flag) {
  return flag.due_time !== undefined && flag.due_time !== null;
};

var addFlagModal_convertDateForSaving = function convertDateForSaving(date, dueChanged) {
  var dueDate = moment_default()(date, constants["z" /* DATE_FORMAT */]);
  if (dueChanged) {
    return dueDate.set({ hours: moment_default()().hour(), minutes: moment_default()().minutes() }).format(constants["_21" /* RAILS_DATE_TIME */]);
  }
  return dueDate.format(constants["_21" /* RAILS_DATE_TIME */]);
};

var addFlagModal_AddFlagModal = function (_Resetter) {
  addFlagModal__inherits(AddFlagModal, _Resetter);

  function AddFlagModal() {
    var _ref;

    var _temp, _this, _ret;

    addFlagModal__classCallCheck(this, AddFlagModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = addFlagModal__possibleConstructorReturn(this, (_ref = AddFlagModal.__proto__ || Object.getPrototypeOf(AddFlagModal)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'componentWillReceiveProps', {
      enumerable: true,
      writable: true,
      value: function value(newProps) {
        return newProps.active && !_this.props.active ? _this.props.requestFlagOptions() : null;
      }
    }), Object.defineProperty(_this, 'filterNoRepeatFlags', {
      enumerable: true,
      writable: true,
      value: function value() {
        var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var events = _this.props.phase.events;

        var noRepeatList = ['Welcome Call']; // Flags we don't want to show if prev added
        var prevAddedFlags = []; // programatically generated
        for (var i = 0; i < events.length; i += 1) {
          if (noRepeatList.length === 0) break; // Breaks out of loop if noRepeatList is empty
          if (events[i].kind === 'flag_added' && noRepeatList.includes(events[i].data.name)) {
            var noRepeatInd = noRepeatList.indexOf(events[i].data.name);
            prevAddedFlags.push(events[i].data.name); // adds to be removed from list to prevAddedFlags
            noRepeatList.splice(noRepeatInd, 1); // removes flag name from noRepeatList
          }
        }
        return list.filter(function (flag) {
          return !prevAddedFlags.includes(flag.name);
        });
      }
    }), Object.defineProperty(_this, 'mappedFlagOptionsToLabelsValues', {
      enumerable: true,
      writable: true,
      value: function value() {
        var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var _this$props = _this.props,
            position = _this$props.position,
            _this$props$phase = _this$props.phase,
            type = _this$props$phase.type,
            source = _this$props$phase.source,
            employableType = _this$props.employableType;

        var newList = list.length === 0 ? list : _this.filterNoRepeatFlags(list);
        if (source === 'IFI' && employableType === 'Installer') {
          newList = newList.filter(function (obj) {
            return obj.name === 'Installer Inquiry';
          });
        }
        return newList.filter(function (obj) {
          return obj.selectable;
        }).filter(function (obj) {
          return obj.name !== 'Estimator Inquiry' || position !== 'Customer Care Specialist';
        }).filter(function (obj) {
          return obj.name !== 'Revisit' || type === 'Assessment';
        }).filter(function (obj) {
          return obj.name !== 'Ready to Schedule' || type === 'Assessment' && source === 'IFI';
        }).filter(function (obj) {
          return obj.name !== 'Installer Inquiry' || source === 'IFI' && employableType === 'Installer';
        }).filter(function (obj) {
          return obj.name !== 'Out For Delivery' || source !== 'IFI';
        }).filter(function (obj) {
          return obj.name !== 'IME' || source !== 'IFI';
        }).filter(function (obj) {
          return obj.name !== 'Extended ETA' || source !== 'IFI';
        }).filter(function (obj) {
          return obj.name !== 'Express Job' || source !== 'IFI';
        }).filter(function (obj) {
          return obj.name !== 'Commercial' || source !== 'IFI';
        }).map(function (obj) {
          return {
            value: obj.name,
            label: obj.name,
            suboptions: obj.suboptions.map(function (value) {
              return { value: value, label: value };
            }),
            dueAt: hasDueTime(obj) ? moment_default()().add(obj.due_time, 'seconds').format(constants["z" /* DATE_FORMAT */]) : obj.due_time
          };
        });
      }
    }), Object.defineProperty(_this, 'handleFlagChange', {
      enumerable: true,
      writable: true,
      value: function value(flagName, options) {
        var flag = options.find(function (obj) {
          return obj.label === flagName;
        });
        if (flag) {
          var suboption = flag.suboptions.length ? flag.suboptions[0].value : '';
          var dueAt = flag.dueAt;
          _this.setState({
            flag: {
              name: flagName,
              suboptions: flag.suboptions,
              dueAt: dueAt
            },
            suboption: suboption,
            dueAt: dueAt
          });
        } else _this.setState(_this.constructor.DEFAULT_STATE);
      }
    }), Object.defineProperty(_this, 'handleSuboptionChange', {
      enumerable: true,
      writable: true,
      value: function value(suboption) {
        return _this.setState({ suboption: suboption });
      }
    }), Object.defineProperty(_this, 'handleDueChange', {
      enumerable: true,
      writable: true,
      value: function value(dueAt) {
        return _this.setState({ dueAt: dueAt, dueChanged: true });
      }
    }), Object.defineProperty(_this, 'handleSubmit', {
      enumerable: true,
      writable: true,
      value: function value() {
        var phaseID = _this.props.phase.id;
        var _this$state = _this.state,
            flag = _this$state.flag,
            suboption = _this$state.suboption,
            dueAt = _this$state.dueAt,
            dueChanged = _this$state.dueChanged;

        var note = _this.textAreaComponentRef.textAreaRef.value;
        var flagProps = {
          name: flag.name,
          note: note,
          suboption: suboption,
          due_at: dueAt ? addFlagModal_convertDateForSaving(dueAt, dueChanged) : null
        };

        _this.props.addFlagToPhase(phaseID, flagProps).then(function () {
          _this.handleClose();
        }).catch(function () {}); // catching this to avoid console warnings...
      }
    }), Object.defineProperty(_this, 'handleCancel', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.props.clearValidation();
        _this.handleClose();
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$state2 = _this.state,
            flag = _this$state2.flag,
            suboption = _this$state2.suboption,
            dueAt = _this$state2.dueAt;
        var _this$props2 = _this.props,
            active = _this$props2.active,
            errors = _this$props2.errors,
            flags = _this$props2.flags,
            source = _this$props2.phase.source;
        // To revert Lowe's Services Lead flag:
        // const flagOptions = this.mappedFlagOptionsToLabelsValues(flags); <- restore this
        // Remove the following two assignments: mappedFlagOptions and flagOptions

        var _this$props$phase2 = _this.props.phase,
            type = _this$props$phase2.type,
            region_name = _this$props$phase2.store.region_name;

        var flagOptions = _this.mappedFlagOptionsToLabelsValues(flags).reduce(function (acc, curr) {
          var flagName = 'Lowe\'s Services Lead';
          if (!constants["_8" /* NON_LHI_SOURCES */].includes(source) && curr.value === flagName && region_name === '02' && type === 'Assessment' || curr.value !== flagName) acc.push(curr);
          return acc;
        }, []);
        return react_default.a.createElement(
          components_ComposeWindow,
          {
            active: active,
            title: 'Add Flag',
            onClose: _this.handleCancel
          },
          react_default.a.createElement(components_StyledSelect, {
            label: 'Flag Name',
            className: ComposeWindow_styles_default.a.select,
            options: flagOptions,
            onChange: function onChange(flagName) {
              return _this.handleFlagChange(flagName, flagOptions);
            },
            value: flag.name,
            required: true,
            placeholder: 'Select a flag',
            error: Object(utils["c" /* error */])('name', errors)
          }),
          flag.suboptions.length > 0 && react_default.a.createElement(components_StyledSelect, {
            label: 'Suboptions',
            className: ComposeWindow_styles_default.a.select,
            options: flag.suboptions,
            onChange: _this.handleSuboptionChange,
            value: suboption,
            required: true,
            error: Object(utils["c" /* error */])('suboption', errors)
          }),
          flag.dueAt && react_default.a.createElement(DatePicker, {
            label: 'Due Date',
            className: ComposeWindow_styles_default.a.select,
            onChange: _this.handleDueChange,
            value: moment_default()(dueAt, constants["z" /* DATE_FORMAT */]).format(constants["E" /* DISPLAY_DATE */]),
            error: Object(utils["c" /* error */])('due_at', errors),
            required: true
          }),
          react_default.a.createElement(components_TextArea, {
            defaultValue: '',
            label: 'Notes *',
            errors: errors.note,
            ref: function ref(comp) {
              _this.textAreaComponentRef = comp;
            }
          }),
          react_default.a.createElement(
            'div',
            { className: ComposeWindow_styles_default.a.actions },
            react_default.a.createElement(react_toolbox_lib["Button"], {
              label: 'Add Flag',
              primary: true, flat: true, ripple: true,
              className: ComposeWindow_styles_default.a.submit,
              onClick: _this.handleSubmit
            })
          )
        );
      }
    }), _temp), addFlagModal__possibleConstructorReturn(_this, _ret);
  }

  return AddFlagModal;
}(resetter(react_default.a.Component));

Object.defineProperty(addFlagModal_AddFlagModal, 'DEFAULT_STATE', {
  enumerable: true,
  writable: true,
  value: {
    flag: { name: '', suboptions: [] },
    suboption: '',
    dueAt: null
  }
});


addFlagModal_AddFlagModal.propTypes = {
  active: prop_types_default.a.bool.isRequired,
  addFlagToPhase: prop_types_default.a.func.isRequired,
  clearValidation: prop_types_default.a.func.isRequired,
  requestFlagOptions: prop_types_default.a.func.isRequired,
  phase: types_phase.isRequired,
  errors: prop_types_default.a.object,
  flags: prop_types_default.a.array,
  onClose: prop_types_default.a.func.isRequired,
  position: prop_types_default.a.string.isRequired,
  employableType: prop_types_default.a.string.isRequired
};

/* harmony default export */ var addFlagModal = (Object(react_redux_es["connect"])(function (state) {
  return {
    position: Object(reducers["_8" /* getPosition */])(state),
    errors: Object(reducers["Y" /* getPhaseErrors */])(state),
    flags: Object(reducers["w" /* getFlagOptions */])(state),
    employableType: state.user.employable_type
  };
}, { addFlagToPhase: actionCreators_phase["b" /* addFlagToPhase */], clearValidation: actionCreators_phase["f" /* clearValidation */], requestFlagOptions: actionCreators_flags })(addFlagModal_AddFlagModal));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/assignEstimatorModal.jsx
var assignEstimatorModal__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function assignEstimatorModal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function assignEstimatorModal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function assignEstimatorModal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var assignEstimatorModal_REQUIRED_ERROR_MSG = 'Can\'t be blank.';
var assignEstimatorModal_DEFAULT_STATE = {
  selectedWorkroom: '',
  selectedEstimator: '',
  loading: false,
  errors: {}
};
var DAY_MAP = {
  0: 'sunday',
  1: 'monday',
  2: 'tuesday',
  3: 'wednesday',
  4: 'thursday',
  5: 'friday',
  6: 'saturday'
};
var BASE_AVAILABILITY_WARNING = 'no availability for the phase store';

var dayExcluded = function dayExcluded(timeArr, day) {
  return !timeArr.includes(day.toLowerCase());
};

var assignEstimatorModal_AssignEstimatorModal = function (_React$Component) {
  assignEstimatorModal__inherits(AssignEstimatorModal, _React$Component);

  function AssignEstimatorModal(props) {
    assignEstimatorModal__classCallCheck(this, AssignEstimatorModal);

    var _this = assignEstimatorModal__possibleConstructorReturn(this, (AssignEstimatorModal.__proto__ || Object.getPrototypeOf(AssignEstimatorModal)).call(this, props));

    Object.defineProperty(_this, 'componentWillReceiveProps', {
      enumerable: true,
      writable: true,
      value: function value(nextProps) {
        if (nextProps.active && !_this.state.active && nextProps.active !== _this.props.active) {
          _this.props.requestWorkroomList();
          if (_this.state.selectedWorkroom) {
            _this.props.requestEstimatorListByWorkroom(_this.state.selectedWorkroom);
          }
        }
      }
    });
    Object.defineProperty(_this, 'getDateFromNotes', {
      enumerable: true,
      writable: true,
      value: function value(notes) {
        if (!notes) return null;
        // Matches YYYY-M-D, YYYY-MM-DD, MM/DD/YYYY, M/D/YYYY
        var regex = /(\d{4}-\d{1,2}-\d{1,2})|(\d{1,2}\/\d{1,2}\/\d{2,4})/m;
        var match = notes.match(regex);
        return match ? match[0] : null;
      }
    });
    Object.defineProperty(_this, 'getMoment', {
      enumerable: true,
      writable: true,
      value: function value(date, format) {
        return moment_default()(date, format).startOf('day');
      }
    });
    Object.defineProperty(_this, 'getNoteMoment', {
      enumerable: true,
      writable: true,
      value: function value(notes) {
        var noteDate = _this.getDateFromNotes(notes);
        if (noteDate) {
          return _this.getMoment(noteDate, [constants["_30" /* SCHEDULE_DATE */], constants["E" /* DISPLAY_DATE */], constants["_19" /* RAILS_DATE */], constants["_20" /* RAILS_DATE_ALT */]]);
        }
        return null;
      }
    });
    Object.defineProperty(_this, 'getFormattedDate', {
      enumerable: true,
      writable: true,
      value: function value(momentObj) {
        return momentObj.format(constants["E" /* DISPLAY_DATE */]);
      }
    });
    Object.defineProperty(_this, 'getAvailabilityWarningByDay', {
      enumerable: true,
      writable: true,
      value: function value(notes, noteMoment, availability) {
        var unavailable = false;
        var day = DAY_MAP[noteMoment.day()];
        var noteTime = (notes.match(/morning|afternoon|evening/im) || [''])[0].toLowerCase();
        if (noteTime) {
          var availabilityByTime = availability[noteTime] || [];
          if (dayExcluded(availabilityByTime, day)) unavailable = true;
        } else {
          var _availability$morning = availability.morning,
              morning = _availability$morning === undefined ? [] : _availability$morning,
              _availability$afterno = availability.afternoon,
              afternoon = _availability$afterno === undefined ? [] : _availability$afterno,
              _availability$evening = availability.evening,
              evening = _availability$evening === undefined ? [] : _availability$evening;

          unavailable = dayExcluded(morning, day) && dayExcluded(afternoon, day) && dayExcluded(evening, day);
        }
        return unavailable ? BASE_AVAILABILITY_WARNING + ' on ' + _this.getFormattedDate(noteMoment) : null;
      }
    });
    Object.defineProperty(_this, 'getAvailabilityWarningByPto', {
      enumerable: true,
      writable: true,
      value: function value(noteMoment, ptos) {
        return ptos.length && ptos.some(function (p) {
          return noteMoment.isSameOrAfter(_this.getMoment(p.start_date, constants["_19" /* RAILS_DATE */])) && noteMoment.isSameOrBefore(_this.getMoment(p.end_date, constants["_19" /* RAILS_DATE */]));
        }) ? 'scheduled time off on ' + _this.getFormattedDate(noteMoment) : null;
      }
    });
    Object.defineProperty(_this, 'getAvailabilityWarning', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            estimators = _this$props.estimators,
            _this$props$phase = _this$props.phase,
            _this$props$phase$con = _this$props$phase.contractor_notes,
            contractor_notes = _this$props$phase$con === undefined ? '' : _this$props$phase$con,
            storeId = _this$props$phase.store.id;
        var selectedEstimator = _this.state.selectedEstimator;

        var notes = !contractor_notes || contractor_notes === null ? '' : contractor_notes;
        var noteMoment = _this.getNoteMoment(notes);
        var warnWitoutDisable = false;
        if (selectedEstimator && noteMoment) {
          var warnings = [];

          var _ref = estimators.find(function (e) {
            return e.id === selectedEstimator;
          }) || {},
              _ref$ptos = _ref.ptos,
              ptos = _ref$ptos === undefined ? [] : _ref$ptos,
              _ref$assignee_availab = _ref.assignee_availabilities,
              assignee_availabilities = _ref$assignee_availab === undefined ? [] : _ref$assignee_availab;

          var availability = assignee_availabilities.map(function (a) {
            return a.assignee_availability;
          }).find(function (a) {
            return a.store_id === storeId;
          }) || null;
          if (!availability) {
            warnings.push(BASE_AVAILABILITY_WARNING);
            warnWitoutDisable = true;
          } else {
            var dayWarning = _this.getAvailabilityWarningByDay(notes, noteMoment, availability);
            if (dayWarning) {
              warnings.push(dayWarning);
              warnWitoutDisable = true;
            }
          }
          var ptoWarning = _this.getAvailabilityWarningByPto(noteMoment, ptos);
          if (ptoWarning) warnings.push(ptoWarning);
          if (warnings.length) {
            return {
              warning: 'Selected Estimator: ' + warnings.join(', '),
              warnWitoutDisable: warnWitoutDisable
            };
          }
        }
        return '';
      }
    });
    Object.defineProperty(_this, 'defaultState', {
      enumerable: true,
      writable: true,
      value: function value() {
        return assignEstimatorModal__extends({}, assignEstimatorModal_DEFAULT_STATE, {
          selectedWorkroom: _this.props.phase.store.workroom_id,
          selectedEstimator: _this.props.phase.estimator_id
        });
      }
    });
    Object.defineProperty(_this, 'validate', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$state = _this.state,
            selectedEstimator = _this$state.selectedEstimator,
            selectedWorkroom = _this$state.selectedWorkroom;

        var errors = {};
        if (!selectedWorkroom || selectedWorkroom.toString().trim() === '') {
          errors.workroom = assignEstimatorModal_REQUIRED_ERROR_MSG;
        }
        if (!selectedEstimator || selectedEstimator.toString().trim() === '') {
          errors.estimator = assignEstimatorModal_REQUIRED_ERROR_MSG;
        }
        if (Object.keys(errors).length > 0) {
          _this.setState({ errors: errors });
          return false;
        }
        return true;
      }
    });
    Object.defineProperty(_this, 'handleWorkroomChange', {
      enumerable: true,
      writable: true,
      value: function value(option) {
        _this.setState({ selectedWorkroom: option.value, selectedEstimator: '' });
        if (!(typeof option === 'string')) {
          _this.props.requestEstimatorListByWorkroom(((option || {}).value || null).toString());
        }
      }
    });
    Object.defineProperty(_this, 'handleEstimatorChange', {
      enumerable: true,
      writable: true,
      value: function value(option) {
        return _this.setState({ selectedEstimator: option.value });
      }
    });
    Object.defineProperty(_this, 'handleSubmit', {
      enumerable: true,
      writable: true,
      value: function value() {
        if (!_this.validate()) return;
        var phase = _this.props.phase;
        var selectedEstimator = _this.state.selectedEstimator;

        _this.setState({ loading: true });
        _this.props.assignPhaseEstimator(phase.id, { estimator_id: selectedEstimator }).then(function () {
          return _this.handleClose();
        }).catch(function () {
          return _this.setState({ loading: false });
        });
      }
    });
    Object.defineProperty(_this, 'handleClose', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.setState(_this.defaultState());
        _this.props.clearValidationErrors('PHASE');
        _this.props.onClose();
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props2 = _this.props,
            active = _this$props2.active,
            workrooms = _this$props2.workrooms,
            estimators = _this$props2.estimators,
            serverErrors = _this$props2.serverErrors;
        var _this$state2 = _this.state,
            errors = _this$state2.errors,
            loading = _this$state2.loading,
            selectedWorkroom = _this$state2.selectedWorkroom,
            selectedEstimator = _this$state2.selectedEstimator;

        var workroomOptions = Object(utils["j" /* generateSource */])(workrooms);
        var estimatorOptions = Object(utils["j" /* generateSource */])(estimators);

        var _ref2 = (estimators || []).length ? _this.getAvailabilityWarning() : { warning: '', warnWitoutDisable: false },
            availabilityWarning = _ref2.warning,
            warnWitoutDisable = _ref2.warnWitoutDisable;

        return react_default.a.createElement(
          react_toolbox_lib["Dialog"],
          {
            active: active,
            className: modal_default.a.modal,
            type: 'fullscreen',
            onEscKeyDown: _this.handleClose
          },
          react_default.a.createElement(
            'div',
            { className: input_default.a.errored },
            serverErrors && Object.keys(serverErrors).length > 0 && react_default.a.createElement(
              'span',
              { className: input_default.a.error },
              'This action could not be completed.'
            )
          ),
          react_default.a.createElement(lib_button["IconButton"], {
            icon: 'close',
            className: modal_default.a.close,
            onClick: _this.handleClose,
            tabIndex: -1
          }),
          react_default.a.createElement(
            'h5',
            { className: modal_default.a.title },
            'Assign Estimator'
          ),
          react_default.a.createElement(react_select, {
            className: modal_default.a.commSelect,
            label: 'Workroom *',
            onChange: _this.handleWorkroomChange,
            options: workroomOptions,
            value: selectedWorkroom,
            error: errors.workroom
          }),
          react_default.a.createElement(react_select, {
            className: modal_default.a.commSelect,
            placeholder: 'Not Assigned',
            label: 'Estimator Name *',
            onChange: _this.handleEstimatorChange,
            options: estimatorOptions,
            value: selectedEstimator,
            error: errors.estimator
          }),
          react_default.a.createElement(
            'div',
            { className: modal_default.a.singleAction },
            availabilityWarning && react_default.a.createElement(
              'p',
              { className: modal_default.a.missingFieldsMessage },
              availabilityWarning
            ),
            react_default.a.createElement(lib_button["Button"], {
              label: 'Assign Estimator',
              flat: true, inverse: true, ripple: true,
              className: modal_default.a.action,
              onClick: _this.handleSubmit,
              disabled: loading || !!availabilityWarning && !warnWitoutDisable
            })
          )
        );
      }
    });

    _this.state = _this.defaultState();
    return _this;
  }

  return AssignEstimatorModal;
}(react_default.a.Component);

assignEstimatorModal_AssignEstimatorModal.propTypes = {
  active: prop_types_default.a.bool.isRequired,
  requestWorkroomList: prop_types_default.a.func.isRequired,
  requestEstimatorListByWorkroom: prop_types_default.a.func.isRequired,
  clearValidationErrors: prop_types_default.a.func.isRequired,
  assignPhaseEstimator: prop_types_default.a.func.isRequired,
  onClose: prop_types_default.a.func.isRequired,
  phase: types_phase.isRequired,
  workrooms: prop_types_default.a.array.isRequired,
  estimators: prop_types_default.a.array.isRequired,
  serverErrors: prop_types_default.a.shape({})
};

assignEstimatorModal_AssignEstimatorModal.defaultProps = { active: false };

/* harmony default export */ var assignEstimatorModal = (Object(react_redux_es["connect"])(function (state) {
  return {
    serverErrors: Object(reducers["Y" /* getPhaseErrors */])(state),
    workrooms: Object(reducers["_37" /* getWorkroomList */])(state),
    estimators: state.phase.details.estimatorsByWorkroom || []
  };
}, {
  assignPhaseEstimator: actionCreators["d" /* assignPhaseEstimator */],
  requestWorkroomList: actionCreators["_31" /* requestWorkroomList */],
  requestEstimatorListByWorkroom: actionCreators["_1" /* requestEstimatorListByWorkroom */],
  clearValidationErrors: actionCreators["k" /* clearValidationErrors */]
})(assignEstimatorModal_AssignEstimatorModal));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/assignInstallerModal.jsx
var assignInstallerModal__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var assignInstallerModal__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function assignInstallerModal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function assignInstallerModal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function assignInstallerModal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var assignInstallerModal_REQUIRED_ERROR_MSG = 'Can\'t be blank.';
var assignInstallerModal_DEFAULT_STATE = {
  selectedInstaller: '',
  loading: false,
  errors: {}
};

var assignInstallerModal_AssignInstallerModal = function (_React$Component) {
  assignInstallerModal__inherits(AssignInstallerModal, _React$Component);

  function AssignInstallerModal(props) {
    assignInstallerModal__classCallCheck(this, AssignInstallerModal);

    var _this = assignInstallerModal__possibleConstructorReturn(this, (AssignInstallerModal.__proto__ || Object.getPrototypeOf(AssignInstallerModal)).call(this, props));

    Object.defineProperty(_this, 'defaultState', {
      enumerable: true,
      writable: true,
      value: function value() {
        return assignInstallerModal__extends({}, assignInstallerModal_DEFAULT_STATE, {
          selectedInstaller: _this.props.phase.installer_id
        });
      }
    });
    Object.defineProperty(_this, 'validate', {
      enumerable: true,
      writable: true,
      value: function value() {
        var errors = {};
        var selectedInstaller = _this.state.selectedInstaller;

        if (!selectedInstaller) {
          errors.installer = assignInstallerModal_REQUIRED_ERROR_MSG;
        }
        if (Object.keys(errors).length > 0) {
          _this.setState({ errors: errors });
          return false;
        }
        return true;
      }
    });
    Object.defineProperty(_this, 'handleInstallerChange', {
      enumerable: true,
      writable: true,
      value: function value(_value) {
        _this.setState({ selectedInstaller: _value });
      }
    });
    Object.defineProperty(_this, 'handleSubmit', {
      enumerable: true,
      writable: true,
      value: function value() {
        if (!_this.validate()) return;
        var phase = _this.props.phase;
        var selectedInstaller = _this.state.selectedInstaller;

        _this.setState({ loading: true });
        _this.props.assignPhaseInstaller(phase.id, { installer_id: selectedInstaller.value }).then(function () {
          return _this.handleClose();
        }).catch(function () {
          return _this.setState({ loading: false });
        });
      }
    });
    Object.defineProperty(_this, 'handleClose', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.props.clearValidationErrors('PHASE');
        _this.setState(_this.defaultState());
        _this.props.onClose();
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            active = _this$props.active,
            installers = _this$props.installers,
            serverErrors = _this$props.serverErrors,
            installer_id = _this$props.phase.installer_id;
        var _this$state = _this.state,
            selectedInstaller = _this$state.selectedInstaller,
            errors = _this$state.errors,
            loading = _this$state.loading;

        var installerOptions = Object(utils["j" /* generateSource */])(installers);
        var label = installer_id > 0 ? 'Reassign Installer' : 'Assign Installer';
        return react_default.a.createElement(
          react_toolbox_lib["Dialog"],
          {
            active: active,
            className: modal_default.a.modal,
            type: 'fullscreen',
            onEscKeyDown: _this.handleClose
          },
          serverErrors && Object.keys(serverErrors).length > 0 && react_default.a.createElement(
            'div',
            { className: input_default.a.errored },
            react_default.a.createElement(
              'span',
              { className: input_default.a.error },
              'This action could not be completed.'
            ),
            react_default.a.createElement(
              'span',
              null,
              errors.assign_installer
            )
          ),
          react_default.a.createElement(lib_button["IconButton"], {
            icon: 'close',
            className: modal_default.a.close,
            onClick: _this.handleClose,
            tabIndex: -1
          }),
          react_default.a.createElement(
            'h5',
            { className: modal_default.a.title },
            label
          ),
          react_default.a.createElement(react_select, {
            className: modal_default.a.commSelect,
            placeholder: 'Not Assigned',
            label: 'Installer Name *',
            onChange: _this.handleInstallerChange,
            options: installerOptions,
            value: selectedInstaller,
            error: errors.installer
          }),
          react_default.a.createElement(
            'div',
            { className: modal_default.a.singleAction },
            react_default.a.createElement(lib_button["Button"], {
              label: label,
              flat: true, inverse: true, ripple: true,
              className: modal_default.a.action,
              onClick: _this.handleSubmit,
              disabled: loading
            })
          )
        );
      }
    });

    _this.state = _this.defaultState();
    return _this;
  }

  assignInstallerModal__createClass(AssignInstallerModal, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.active && !this.state.active && nextProps.active !== this.props.active) {
        this.props.requestInstallersForAssignment(this.props.phase.workroom.id, this.props.phase.zip_code);
      }
    }
  }]);

  return AssignInstallerModal;
}(react_default.a.Component);

assignInstallerModal_AssignInstallerModal.propTypes = {
  active: prop_types_default.a.bool.isRequired,
  phase: types_phase.isRequired,
  installers: prop_types_default.a.array.isRequired,
  serverErrors: prop_types_default.a.shape({}),
  clearValidationErrors: prop_types_default.a.func.isRequired,
  onClose: prop_types_default.a.func.isRequired,
  requestInstallersForAssignment: prop_types_default.a.func.isRequired,
  assignPhaseInstaller: prop_types_default.a.func.isRequired
};

assignInstallerModal_AssignInstallerModal.defaultProps = { active: false };

/* harmony default export */ var assignInstallerModal = (Object(react_redux_es["connect"])(function (state) {
  return {
    serverErrors: Object(reducers["Y" /* getPhaseErrors */])(state),
    installers: state.phase.details.installersForAssignment || []
  };
}, {
  clearValidationErrors: actionCreators["k" /* clearValidationErrors */],
  requestInstallersForAssignment: actionCreators["_10" /* requestInstallersForAssignment */],
  assignPhaseInstaller: actionCreators["e" /* assignPhaseInstaller */]
})(assignInstallerModal_AssignInstallerModal));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/workorderModal.jsx
var workorderModal__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var workorderModal__get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function workorderModal__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function workorderModal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function workorderModal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function workorderModal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




















var workorderModal_largeInput = classnames_default()(input_default.a.inputs, input_default.a.largeInput);
var workorderModal_titleStyle = classnames_default()(input_default.a.bottomTitle, input_default.a.childTitle);

var workorderModal_WorkorderModal = function (_Resetter) {
  workorderModal__inherits(WorkorderModal, _Resetter);

  function WorkorderModal() {
    var _ref;

    var _temp, _this, _ret;

    workorderModal__classCallCheck(this, WorkorderModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = workorderModal__possibleConstructorReturn(this, (_ref = WorkorderModal.__proto__ || Object.getPrototypeOf(WorkorderModal)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'handleSubmit', {
      enumerable: true,
      writable: true,
      value: function value() {
        if (!_this.validate()) {
          return;
        }
        var phase = _this.props.phase;
        var _this$state = _this.state,
            note = _this$state.note,
            wo_source = _this$state.wo_source,
            wo_type = _this$state.wo_type;

        _this.props.copyPhase(phase.id, { note: note, wo_source: wo_source, wo_type: wo_type }).then(function () {
          return _this.handleClose();
        }).then(function () {
          return _this.props.navigate(urls.phaseLaborProductAccounting(_this.props.phase));
        }).catch(function () {});
      }
    }), Object.defineProperty(_this, 'handleNoteChange', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        return _this.setState({ note: e.target.value });
      }
    }), Object.defineProperty(_this, 'handleWorkorderInfo', {
      enumerable: true,
      writable: true,
      value: function value(key, _value) {
        return _this.setState(workorderModal__defineProperty({}, key, _value));
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$state2 = _this.state,
            note = _this$state2.note,
            errors = _this$state2.errors;
        var _this$props = _this.props,
            phase = _this$props.phase,
            active = _this$props.active,
            serverErrors = _this$props.errors;

        return react_default.a.createElement(
          react_toolbox_lib["Dialog"],
          {
            active: active, className: modal_default.a.modal, type: 'fullscreen',
            onEscKeyDown: _this.handleClose, onOverlayClick: _this.handleClose
          },
          react_default.a.createElement(
            'div',
            { className: input_default.a.errored },
            Object.keys(serverErrors).length > 0 && react_default.a.createElement(
              'span',
              { className: input_default.a.error },
              'This action could not be completed.'
            )
          ),
          react_default.a.createElement(react_toolbox_lib["IconButton"], {
            icon: 'close',
            className: modal_default.a.close,
            onClick: _this.handleClose,
            tabIndex: -1
          }),
          react_default.a.createElement(
            'h5',
            { className: modal_default.a.title },
            'Create Workorder'
          ),
          react_default.a.createElement(
            'h5',
            { className: workorderModal_titleStyle },
            'Workorder Source / Type'
          ),
          react_default.a.createElement('br', null),
          react_default.a.createElement(components_StyledSelect, {
            className: workorderModal_largeInput,
            label: 'Workorder Source',
            onChange: function onChange(selection) {
              return _this.handleWorkorderInfo('wo_source', selection);
            },
            options: Object(utils["F" /* woSourceOptions */])(phase),
            value: _this.state.wo_source,
            placeholder: 'Select Workorder Source',
            required: true,
            autoFocus: true,
            error: errors.wo_source
          }),
          react_default.a.createElement(components_StyledSelect, {
            className: workorderModal_largeInput,
            label: 'Workorder Type',
            onChange: function onChange(selection) {
              return _this.handleWorkorderInfo('wo_type', selection);
            },
            options: constants["_61" /* WORKORDER_TYPE */].map(function (wt) {
              return { value: wt, label: wt };
            }),
            value: _this.state.wo_type,
            placeholder: 'Select Workorder Type',
            required: true,
            error: errors.wo_type
          }),
          react_default.a.createElement(components_TextArea, {
            label: 'Reason *',
            required: true,
            value: note,
            errors: errors.note,
            onChange: _this.handleNoteChange
          }),
          react_default.a.createElement(react_toolbox_lib["Button"], { label: 'Create', flat: true, inverse: true, ripple: true, className: modal_default.a.submit, onClick: _this.handleSubmit })
        );
      }
    }), _temp), workorderModal__possibleConstructorReturn(_this, _ret);
  }

  workorderModal__createClass(WorkorderModal, [{
    key: 'handleClose',
    value: function handleClose() {
      workorderModal__get(WorkorderModal.prototype.__proto__ || Object.getPrototypeOf(WorkorderModal.prototype), 'handleClose', this).call(this);
      this.props.clearValidation();
    }
  }]);

  return WorkorderModal;
}(resetter(validator(react_default.a.Component)));

Object.defineProperty(workorderModal_WorkorderModal, 'DEFAULT_STATE', {
  enumerable: true,
  writable: true,
  value: { note: '', errors: {}, wo_source: '', wo_type: '' }
});
Object.defineProperty(workorderModal_WorkorderModal, 'VALIDATIONS', {
  enumerable: true,
  writable: true,
  value: { note: true, wo_source: true, wo_type: true }
});


workorderModal_WorkorderModal.propTypes = {
  active: prop_types_default.a.bool.isRequired,
  copyPhase: prop_types_default.a.func,
  navigate: prop_types_default.a.func.isRequired,
  clearValidation: prop_types_default.a.func.isRequired,
  onClose: prop_types_default.a.func.isRequired,
  phase: types_phase.isRequired,
  errors: prop_types_default.a.shape({
    note: prop_types_default.a.arrayOf(prop_types_default.a.string),
    due_at: prop_types_default.a.arrayOf(prop_types_default.a.string)
  })
};

workorderModal_WorkorderModal.defaultProps = { active: false };

/* harmony default export */ var workorderModal = (Object(react_redux_es["connect"])(function (state) {
  return { errors: Object(reducers["Y" /* getPhaseErrors */])(state) };
}, { clearValidation: actionCreators_phase["f" /* clearValidation */], copyPhase: actionCreators_phase["g" /* copyPhase */], navigate: actionCreators["O" /* navigate */] })(workorderModal_WorkorderModal));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/checkinModal.jsx
var checkinModal__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var checkinModal__get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function checkinModal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function checkinModal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function checkinModal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var checkinModal_CheckinModal = function (_Resetter) {
  checkinModal__inherits(CheckinModal, _Resetter);

  function CheckinModal() {
    var _ref;

    var _temp, _this, _ret;

    checkinModal__classCallCheck(this, CheckinModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = checkinModal__possibleConstructorReturn(this, (_ref = CheckinModal.__proto__ || Object.getPrototypeOf(CheckinModal)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'handleKindChange', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        _this.setState({
          kind: e
        });
      }
    }), Object.defineProperty(_this, 'handleNoteChange', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        _this.setState({
          note: e.target.value
        });
      }
    }), Object.defineProperty(_this, 'handleSubmit', {
      enumerable: true,
      writable: true,
      value: function value() {
        if (!_this.validate()) return;
        var phase = _this.props.phase;
        var _this$state = _this.state,
            kind = _this$state.kind,
            note = _this$state.note;


        var noteProps = {
          name: kind === 'arrived' ? 'Installer On Jobsite' : 'Installer Left Jobsite',
          kind: 'checkin',
          data: { kind: kind, note: note }
        };

        _this.props.addEventToPhase(phase.id, noteProps).then(function () {
          _this.handleClose();
        });
      }
    }), Object.defineProperty(_this, 'handleConfirmClose', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.handleClose();
      }
    }), _temp), checkinModal__possibleConstructorReturn(_this, _ret);
  }

  checkinModal__createClass(CheckinModal, [{
    key: 'handleClose',
    value: function handleClose() {
      checkinModal__get(CheckinModal.prototype.__proto__ || Object.getPrototypeOf(CheckinModal.prototype), 'handleClose', this).call(this);
      this.props.clearValidation();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          active = _props.active,
          serverErrors = _props.serverErrors;
      var _state = this.state,
          kind = _state.kind,
          note = _state.note,
          errors = _state.errors;


      return react_default.a.createElement(
        react_toolbox_lib["Dialog"],
        {
          active: active,
          className: modal_default.a.modal,
          type: 'fullscreen',
          onEscKeyDown: this.handleClose,
          onOverlayClick: this.handleClose
        },
        react_default.a.createElement(
          'div',
          { className: input_default.a.errored },
          Object.keys(serverErrors).length > 0 && react_default.a.createElement(
            'span',
            { className: input_default.a.error },
            'This action could not be completed.'
          )
        ),
        react_default.a.createElement(lib_button["IconButton"], {
          icon: 'close',
          className: modal_default.a.close,
          onClick: this.handleClose,
          tabIndex: -1
        }),
        react_default.a.createElement(
          'h5',
          { className: modal_default.a.title },
          'Check In/Out'
        ),
        react_default.a.createElement(components_RadioButtons, {
          text: 'Please select if you\'ve arrived or are leaving the jobsite. If\n            performing a multiple day installation, please repeat each day.\n            Include any important notes about the jobsite.',
          required: true,
          onChange: this.handleKindChange,
          selectedValue: kind,
          radioButtons: CheckinModal.OPTIONS
        }),
        react_default.a.createElement(components_TextArea, {
          label: 'Notes about Jobsite',
          value: note,
          errors: errors.note,
          onChange: this.handleNoteChange
        }),
        react_default.a.createElement(lib_button["Button"], {
          label: 'Submit',
          flat: true, inverse: true, ripple: true,
          className: modal_default.a.submit,
          onClick: this.handleSubmit
        })
      );
    }
  }]);

  return CheckinModal;
}(resetter(validator(react_default.a.Component)));

Object.defineProperty(checkinModal_CheckinModal, 'OPTIONS', {
  enumerable: true,
  writable: true,
  value: [{
    label: 'I\'ve arrived at the Jobsite',
    value: 'arrived'
  }, {
    label: 'I\'ve left the Jobsite',
    value: 'left'
  }]
});
Object.defineProperty(checkinModal_CheckinModal, 'DEFAULT_STATE', {
  enumerable: true,
  writable: true,
  value: {
    kind: 'arrived',
    note: '',
    errors: {}
  }
});
Object.defineProperty(checkinModal_CheckinModal, 'VALIDATIONS', {
  enumerable: true,
  writable: true,
  value: { kind: true }
});


checkinModal_CheckinModal.propTypes = {
  active: prop_types_default.a.bool.isRequired,
  addEventToPhase: prop_types_default.a.func.isRequired,
  clearValidation: prop_types_default.a.func.isRequired,
  onClose: prop_types_default.a.func.isRequired,
  phase: types_phase.isRequired,
  serverErrors: prop_types_default.a.shape({})
};

checkinModal_CheckinModal.defaultProps = {
  active: false
};

/* harmony default export */ var checkinModal = (Object(react_redux_es["connect"])(function (state) {
  return { serverErrors: Object(reducers["Y" /* getPhaseErrors */])(state) };
}, { addEventToPhase: actionCreators_phase["a" /* addEventToPhase */], clearValidation: actionCreators_phase["f" /* clearValidation */] })(checkinModal_CheckinModal));
// CONCATENATED MODULE: ./client/app/shared/components/CheckBox/index.jsx







var CheckBox_CheckBox = function CheckBox(_ref) {
  var label = _ref.label,
      text = _ref.text,
      onChange = _ref.onChange,
      className = _ref.className,
      errors = _ref.errors,
      checked = _ref.checked;

  var errorMsg = errors.join(', ');
  var wrapperStyles = errorMsg ? classnames_default()(input_default.a.errored, className) : className;
  var labelStyles = errorMsg ? classnames_default()(form_default.a.label, form_default.a.errorLabel) : form_default.a.label;

  return react_default.a.createElement(
    'div',
    { className: wrapperStyles },
    react_default.a.createElement(
      'h6',
      { className: labelStyles },
      label
    ),
    react_default.a.createElement(react_toolbox_lib["Checkbox"], {
      checked: checked,
      label: text,
      onChange: onChange
    }),
    errorMsg && react_default.a.createElement(
      'div',
      { className: input_default.a.error },
      react_default.a.createElement(
        'p',
        { className: form_default.a.errorMsg },
        errorMsg
      )
    )
  );
};

CheckBox_CheckBox.propTypes = {
  label: prop_types_default.a.string.isRequired,
  text: prop_types_default.a.string.isRequired,
  onChange: prop_types_default.a.func.isRequired,
  checked: prop_types_default.a.bool.isRequired,
  errors: prop_types_default.a.array.isRequired,
  className: prop_types_default.a.string
};

CheckBox_CheckBox.defaultProps = {
  label: '',
  text: '',
  errors: []
};

/* harmony default export */ var components_CheckBox = (CheckBox_CheckBox);
// EXTERNAL MODULE: ./client/app/shared/components/LineItemTable/itemNote.scss
var itemNote = __webpack_require__("PVeh");
var itemNote_default = /*#__PURE__*/__webpack_require__.n(itemNote);

// EXTERNAL MODULE: ./client/app/shared/styles/table.scss
var table = __webpack_require__("8258");
var table_default = /*#__PURE__*/__webpack_require__.n(table);

// CONCATENATED MODULE: ./client/app/shared/components/LineItemTable/inputNote.jsx







var inputNote_InputNote = function InputNote(_ref) {
  var value = _ref.value,
      label = _ref.label,
      onChange = _ref.onChange,
      cellValue = _ref.cellValue,
      type = _ref.type,
      className = _ref.className,
      cellReadOnly = _ref.cellReadOnly;

  var cellVal = value === null || cellValue === null ? '' : cellValue || value;
  var cellProps = { label: label, onChange: onChange, value: cellVal, cellReadOnly: cellReadOnly };
  return react_default.a.createElement(
    editableTableCell,
    cellProps,
    react_default.a.createElement('input', {
      type: type,
      value: value === null ? '' : value,
      className: classnames_default()(input_default.a.inputElement, table_default.a.input, className)
    })
  );
};

inputNote_InputNote.defaultProps = {
  cellValue: '',
  display: true,
  type: 'text',
  className: '',
  cellReadOnly: false
};

inputNote_InputNote.propTypes = {
  display: prop_types_default.a.bool,
  value: prop_types_default.a.string,
  label: prop_types_default.a.string.isRequired,
  onChange: prop_types_default.a.func.isRequired,
  cellValue: prop_types_default.a.node,
  type: prop_types_default.a.string,
  className: prop_types_default.a.string,
  cellReadOnly: prop_types_default.a.bool
};

/* harmony default export */ var inputNote = (inputNote_InputNote);
// CONCATENATED MODULE: ./client/app/shared/components/LineItemTable/itemNote.jsx
var itemNote__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function itemNote__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function itemNote__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function itemNote__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var itemNote_errStyles = input_default.a.error + ' ' + itemNote_default.a.error;
var itemNote_errWrapperStyles = input_default.a.errored + ' ' + itemNote_default.a.errored;

var itemNote_ItemNote = function (_Component) {
  itemNote__inherits(ItemNote, _Component);

  function ItemNote() {
    var _ref;

    var _temp, _this, _ret;

    itemNote__classCallCheck(this, ItemNote);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = itemNote__possibleConstructorReturn(this, (_ref = ItemNote.__proto__ || Object.getPrototypeOf(ItemNote)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'state', {
      enumerable: true,
      writable: true,
      value: { active: false }
    }), Object.defineProperty(_this, 'toggleActive', {
      enumerable: true,
      writable: true,
      value: function value() {
        var active = !_this.state.active;
        _this.setState({ active: active });
      }
    }), Object.defineProperty(_this, 'handleChange', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        return _this.context.onChange(e, _this.props.onChange);
      }
    }), Object.defineProperty(_this, 'renderItemNoteDesktop', {
      enumerable: true,
      writable: true,
      value: function value() {
        var isEditable = _this.context.isEditable;
        var active = _this.state.active;
        var _this$props = _this.props,
            id = _this$props.id,
            kind = _this$props.kind,
            note = _this$props.note,
            errors = _this$props.errors,
            readOnly = _this$props.readOnly;

        var emptyNoteClass = note ? '' : itemNote_default.a.no_content;
        var error = errors.note && Object(utils["c" /* error */])('note', errors);
        return react_default.a.createElement(
          'td',
          { className: itemNote_default.a.container },
          (isEditable || note) && react_default.a.createElement(react_toolbox_lib["FontIcon"], { value: 'note', 'data-tip': true, 'data-for': '' + kind + id, className: itemNote_default.a.note_icon + ' ' + emptyNoteClass, onClick: _this.toggleActive }),
          error && react_default.a.createElement(
            'div',
            { className: itemNote_errWrapperStyles },
            react_default.a.createElement(
              'p',
              { className: itemNote_errStyles },
              error
            )
          ),
          note && react_default.a.createElement(
            react_tooltip_dist_default.a,
            { id: '' + kind + id, place: 'left', effect: 'solid' },
            react_default.a.createElement(
              components_UserNote,
              { className: itemNote_default.a.tooltipText },
              note
            )
          ),
          active && react_default.a.createElement(
            react_css_themr_lib["ThemeProvider"],
            null,
            react_default.a.createElement(
              react_toolbox_lib["Dialog"],
              { title: 'Note', active: active, onEscKeyDown: _this.toggleActive, onOverlayClick: _this.toggleActive },
              react_default.a.createElement(react_toolbox_lib["FontIcon"], { value: 'close', className: itemNote_default.a.close_icon, onClick: _this.toggleActive }),
              isEditable && !readOnly && react_default.a.createElement('textarea', { className: itemNote_default.a.textarea, value: note, onChange: _this.handleChange }),
              (!isEditable || readOnly) && react_default.a.createElement(
                components_UserNote,
                { className: itemNote_default.a.text },
                note
              )
            )
          )
        );
      }
    }), Object.defineProperty(_this, 'renderItemNoteMobile', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props2 = _this.props,
            note = _this$props2.note,
            errors = _this$props2.errors;

        var error = errors.note && Object(utils["c" /* error */])('note', errors);
        return react_default.a.createElement(
          react_default.a.Fragment,
          null,
          react_default.a.createElement(inputNote, { type: 'text', attr: 'note', label: 'Note', value: note, onChange: _this.handleChange }),
          error && react_default.a.createElement(
            'div',
            { className: itemNote_errWrapperStyles },
            react_default.a.createElement(
              'p',
              { className: itemNote_errStyles },
              error
            )
          )
        );
      }
    }), _temp), itemNote__possibleConstructorReturn(_this, _ret);
  }

  itemNote__createClass(ItemNote, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return react_default.a.createElement(
        react_responsive_default.a,
        { minWidth: constants["y" /* CUT_POINT */] },
        function (matches) {
          if (matches) {
            return _this2.renderItemNoteDesktop();
          }
          return _this2.renderItemNoteMobile();
        }
      );
    }
  }]);

  return ItemNote;
}(react["Component"]);

itemNote_ItemNote.contextTypes = {
  onChange: prop_types_default.a.func,
  isEditable: prop_types_default.a.bool
};

itemNote_ItemNote.defaultProps = {
  note: '',
  errors: {},
  kind: 'note',
  readOnly: false
};

itemNote_ItemNote.propTypes = {
  display: prop_types_default.a.bool.isRequired,
  note: prop_types_default.a.string,
  errors: prop_types_default.a.object,
  label: prop_types_default.a.string.isRequired,
  kind: prop_types_default.a.string.isRequired,
  id: prop_types_default.a.number,
  onChange: prop_types_default.a.func.isRequired,
  readOnly: prop_types_default.a.bool
};

/* harmony default export */ var LineItemTable_itemNote = (itemNote_ItemNote);
// EXTERNAL MODULE: ./client/app/utils/lineItemUtils.js
var lineItemUtils = __webpack_require__("bEtk");

// CONCATENATED MODULE: ./client/app/selectors/phaseLineItem.js



var getPhaseLineItemsSelector = function getPhaseLineItemsSelector(state) {
  return state.phase.phaseLineItems.items;
};

var getPhaseLineItemsWithTotal = Object(reselect_lib["createSelector"])(getPhaseLineItemsSelector, function (items) {
  return items.map(function (item) {
    var itemWithTotal = item;
    itemWithTotal.calculatedTotal = Object(lineItemUtils["c" /* calculateTotal */])(item.price, item.quantity);
    return itemWithTotal;
  });
});

var getPricePatchItems = function getPricePatchItems(state) {
  return state.pricePatchLineItems.data;
};
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/createException/poDetails.jsx
function poDetails__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function poDetails__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function poDetails__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function poDetails__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var DISPLAY_KEYS = ['Number - Description', 'QTY', 'Unit Price', 'Total', 'Not Payable', 'Note', 'Delete'];

var PoDetails = function (_Resetter) {
  poDetails__inherits(PoDetails, _Resetter);

  function PoDetails(props) {
    poDetails__classCallCheck(this, PoDetails);

    var _this = poDetails__possibleConstructorReturn(this, (PoDetails.__proto__ || Object.getPrototypeOf(PoDetails)).call(this, props));

    poDetails__initialiseProps.call(_this);

    var _this$props = _this.props,
        _this$props$number = _this$props.number,
        number = _this$props$number === undefined ? '' : _this$props$number,
        _this$props$phase = _this$props.phase,
        phase = _this$props$phase === undefined ? {} : _this$props$phase,
        _this$props$total = _this$props.total,
        total = _this$props$total === undefined ? 0 : _this$props$total,
        _this$props$lineItems = _this$props.lineItems,
        lineItems = _this$props$lineItems === undefined ? [] : _this$props$lineItems,
        _this$props$reason = _this$props.reason,
        reason = _this$props$reason === undefined ? '' : _this$props$reason,
        _this$props$contact = _this$props.contact,
        contact = _this$props$contact === undefined ? '' : _this$props$contact;

    _this.state = {
      number: number,
      phase: phase,
      total: total,
      lineItems: lineItems,
      addRow: false,
      lineItemId: '',
      kind: '',
      quantity: 0,
      pricePatch: 0,
      lineItemTotal: 0,
      payable: true,
      note: '',
      reason: reason,
      contact: contact,
      errors: {}
    };
    return _this;
  }

  // TODO: Will be deprecated in React 17


  return PoDetails;
}(resetter(validator(react_default.a.Component)));

var poDetails__initialiseProps = function _initialiseProps() {
  var _this2 = this;

  Object.defineProperty(this, 'componentWillMount', {
    enumerable: true,
    writable: true,
    value: function value() {
      return _this2.props.setPoDetailsMounted(true);
    }
  });
  Object.defineProperty(this, 'componentWillUnmount', {
    enumerable: true,
    writable: true,
    value: function value() {
      return _this2.props.setPoDetailsMounted(false);
    }
  });
  Object.defineProperty(this, 'sanitize', {
    enumerable: true,
    writable: true,
    value: function value(attr, val) {
      var value = Object(lodash["has"])(val, 'target') ? val.target.value : val;
      if (attr === 'lineItemTotal') value = value ? parseFloat(value) : '';
      return value;
    }
  });
  Object.defineProperty(this, 'getSelectedItem', {
    enumerable: true,
    writable: true,
    value: function value(val) {
      return Object(lodash["find"])(_this2.props.lineItemOptions, function (o) {
        return o.value === val;
      }) || {};
    }
  });
  Object.defineProperty(this, 'getInitialId', {
    enumerable: true,
    writable: true,
    value: function value(lineItems) {
      var ids = [];
      lineItems.forEach(function (i) {
        return ids.push(i.id);
      });
      var id = Object(lineItemUtils["i" /* getRandomNegativeInt */])();
      if (Object(lodash["isEmpty"])(ids)) return id;
      while (ids.includes(id)) {
        id = Object(lineItemUtils["i" /* getRandomNegativeInt */])();
      }return id;
    }
  });
  Object.defineProperty(this, 'validateNumber', {
    enumerable: true,
    writable: true,
    value: function value(number) {
      var regex = /^(?!00)\d{9}$|^PR\d{8}$|^\d{8}[AIW]$|^PRJ\d+$/;
      var ime_regex = /^\d{8}[AIW]$/;
      var rf_regex = /^PRJ\d+$/;
      var isProjectNumber = _this2.props.projectNumber === number && !_this2.props.projectNumber.match(ime_regex) && !_this2.props.projectNumber.match(rf_regex);
      return (number === null || number === '' || regex.test(number)) && !isProjectNumber;
    }
  });
  Object.defineProperty(this, 'getPhaseLineItemTotal', {
    enumerable: true,
    writable: true,
    value: function value(lineItems) {
      return parseFloat((lineItems.reduce(function (a, b) {
        return a + b.total;
      }, 0) || 0).toFixed(2));
    }
  });
  Object.defineProperty(this, 'handleSubmit', {
    enumerable: true,
    writable: true,
    value: function value() {
      if (!_this2.validate({ total: true, lineItems: true })) return;
      var _state = _this2.state,
          number = _state.number,
          total = _state.total,
          lineItems = _state.lineItems,
          reason = _state.reason,
          contact = _state.contact;

      var finalLineItems = [];
      lineItems.forEach(function (i) {
        var editedItem = i;
        editedItem.status = number ? 'Exception - Resolved' : 'Not Reviewed';
        finalLineItems.push(editedItem);
      });
      _this2.props.updateFormData({
        number: number,
        total: total,
        reason: reason,
        contact: contact,
        lineItems: finalLineItems
      });
    }
  });
  Object.defineProperty(this, 'handleAddRow', {
    enumerable: true,
    writable: true,
    value: function value(e) {
      e.preventDefault();
      _this2.setState({
        addRow: !_this2.state.addRow,
        lineItemId: '',
        kind: '',
        quantity: 0,
        pricePatch: 0,
        lineItemTotal: 0,
        payable: true,
        note: ''
      });
    }
  });
  Object.defineProperty(this, 'handleChange', {
    enumerable: true,
    writable: true,
    value: function value(attr) {
      return function (val) {
        var _this2$setState;

        var _state2 = _this2.state,
            pricePatch = _state2.pricePatch,
            quantity = _state2.quantity;

        var value = _this2.sanitize(attr, val);
        if (attr === 'payable') value = !value;
        var price = attr === 'pricePatch' ? value : pricePatch;
        var qty = attr === 'quantity' ? value : quantity;
        var lineItemTotal = Object(lineItemUtils["c" /* calculateTotal */])(price, qty);
        _this2.setState((_this2$setState = {}, poDetails__defineProperty(_this2$setState, attr, value), poDetails__defineProperty(_this2$setState, 'lineItemTotal', lineItemTotal), _this2$setState));
      };
    }
  });
  Object.defineProperty(this, 'handleNumberChange', {
    enumerable: true,
    writable: true,
    value: this.handleChange('number')
  });
  Object.defineProperty(this, 'handlePriceChange', {
    enumerable: true,
    writable: true,
    value: this.handleChange('pricePatch')
  });
  Object.defineProperty(this, 'handleQuantityChange', {
    enumerable: true,
    writable: true,
    value: this.handleChange('quantity')
  });
  Object.defineProperty(this, 'handlePayableChange', {
    enumerable: true,
    writable: true,
    value: this.handleChange('payable')
  });
  Object.defineProperty(this, 'handleNoteChange', {
    enumerable: true,
    writable: true,
    value: this.handleChange('note')
  });
  Object.defineProperty(this, 'handleReasonChange', {
    enumerable: true,
    writable: true,
    value: this.handleChange('reason')
  });
  Object.defineProperty(this, 'handleContactChange', {
    enumerable: true,
    writable: true,
    value: this.handleChange('contact')
  });
  Object.defineProperty(this, 'handleNumberChange', {
    enumerable: true,
    writable: true,
    value: function value(e) {
      return _this2.setState({ number: e.target.value });
    }
  });
  Object.defineProperty(this, 'handleDescriptionChange', {
    enumerable: true,
    writable: true,
    value: function value(selection) {
      var value = selection.value,
          price = selection.price,
          payable = selection.payable,
          kind = selection.kind;

      var lineItemTotal = Object(lineItemUtils["c" /* calculateTotal */])(price, _this2.state.quantity) || 0;
      _this2.setState({ lineItemId: value, pricePatch: price, payable: payable, lineItemTotal: lineItemTotal, kind: kind });
    }
  });
  Object.defineProperty(this, 'handleSave', {
    enumerable: true,
    writable: true,
    value: function value(e) {
      e.preventDefault();
      var _state3 = _this2.state,
          lineItems = _state3.lineItems,
          lineItemId = _state3.lineItemId,
          kind = _state3.kind,
          quantity = _state3.quantity,
          pricePatch = _state3.pricePatch,
          lineItemTotal = _state3.lineItemTotal,
          payable = _state3.payable,
          note = _state3.note;

      lineItems.push({
        line_item_id: lineItemId,
        description: _this2.getSelectedItem(lineItemId).label,
        price: pricePatch,
        total: lineItemTotal,
        quantity: Math.trunc(quantity),
        kind: kind,
        payable: payable,
        note: note
      });
      var id = _this2.getInitialId(lineItems);
      var total = lineItems.length > 0 ? _this2.getPhaseLineItemTotal(lineItems) : 0;
      _this2.setState({
        id: id,
        total: total,
        lineItems: lineItems,
        lineItemId: '',
        kind: '',
        quantity: 0,
        pricePatch: 0,
        lineItemTotal: 0,
        payable: true,
        note: ''
      });
    }
  });
  Object.defineProperty(this, 'handleDelete', {
    enumerable: true,
    writable: true,
    value: function value(itemNumber) {
      return function (e) {
        e.preventDefault();
        var lineItems = _this2.state.lineItems;
        var filteredItems = Object(lodash["filter"])(lineItems, function (item) {
          return item.line_item_id !== itemNumber;
        });
        var total = filteredItems.length > 0 ? _this2.getPhaseLineItemTotal(filteredItems) : 0;
        _this2.setState({ total: total, lineItems: filteredItems });
      };
    }
  });
  Object.defineProperty(this, 'renderTableHead', {
    enumerable: true,
    writable: true,
    value: function value() {
      return react_default.a.createElement(
        'thead',
        null,
        react_default.a.createElement(
          'tr',
          null,
          DISPLAY_KEYS.map(function (key) {
            return react_default.a.createElement(
              'th',
              {
                key: key, className: key === 'Delete' ? modal_default.a.deleteCell : modal_default.a.cell
              },
              key
            );
          })
        )
      );
    }
  });
  Object.defineProperty(this, 'renderTableBody', {
    enumerable: true,
    writable: true,
    value: function value(lineItems) {
      return react_default.a.createElement(
        'tbody',
        null,
        lineItems.map(function (item) {
          return react_default.a.createElement(
            'tr',
            { className: modal_default.a.contentRow, key: item.line_item_id },
            _this2.renderLabel(item.line_item_id),
            react_default.a.createElement(
              'td',
              { className: modal_default.a.cell },
              item.quantity
            ),
            react_default.a.createElement(
              'td',
              { className: modal_default.a.cell },
              Object(lineItemUtils["g" /* formatDollars */])(item.price)
            ),
            react_default.a.createElement(
              'td',
              { className: modal_default.a.cell },
              Object(lineItemUtils["g" /* formatDollars */])(item.total)
            ),
            _this2.renderPayable(item.payable),
            _this2.renderNote(item),
            _this2.renderDelete(item.line_item_id)
          );
        })
      );
    }
  });
  Object.defineProperty(this, 'renderLabel', {
    enumerable: true,
    writable: true,
    value: function value(lineItemId) {
      return react_default.a.createElement(
        'td',
        { className: modal_default.a.cell },
        _this2.getSelectedItem(lineItemId).label
      );
    }
  });
  Object.defineProperty(this, 'renderPayable', {
    enumerable: true,
    writable: true,
    value: function value(payable) {
      return react_default.a.createElement(
        'td',
        { className: modal_default.a.cell },
        react_default.a.createElement(react_toolbox_lib["FontIcon"], { value: payable ? 'check_box_outline_blank' : 'check_box' })
      );
    }
  });
  Object.defineProperty(this, 'renderNote', {
    enumerable: true,
    writable: true,
    value: function value(item) {
      return react_default.a.createElement(LineItemTable_itemNote, {
        display: true,
        label: 'Note',
        onChange: _this2.handleNoteChange,
        note: item.note,
        id: item.line_item_id,
        kind: 'lineItem'
      });
    }
  });
  Object.defineProperty(this, 'renderDelete', {
    enumerable: true,
    writable: true,
    value: function value(lineItemId) {
      return react_default.a.createElement(
        'td',
        { className: modal_default.a.deleteCell },
        react_default.a.createElement(react_toolbox_lib["IconButton"], { icon: 'delete', onClick: _this2.handleDelete(lineItemId) })
      );
    }
  });
  Object.defineProperty(this, 'render', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _state4 = _this2.state,
          number = _state4.number,
          reason = _state4.reason,
          contact = _state4.contact,
          total = _state4.total,
          lineItems = _state4.lineItems,
          addRow = _state4.addRow,
          lineItemId = _state4.lineItemId,
          phase = _state4.phase,
          quantity = _state4.quantity,
          pricePatch = _state4.pricePatch,
          lineItemTotal = _state4.lineItemTotal,
          payable = _state4.payable,
          note = _state4.note,
          errors = _state4.errors;
      var lineItemOptions = _this2.props.lineItemOptions;

      var noTableText = addRow ? 'Fill in data below, then click "Save"' : 'Click "ADD ITEM" to start adding line items';
      var invalidNumber = !_this2.validateNumber(number);
      var disabled = !Array.isArray(lineItems) || !lineItems.length || invalidNumber;
      var message = "Invalid PO Number. If a PO Number is entered, please ensure it is 9 digits or 8 digits prefixed by 'PR' and is not the project number.";
      var submitButton = invalidNumber ? react_default.a.createElement(
        'div',
        { className: modal_default.a.message },
        message
      ) : react_default.a.createElement(react_toolbox_lib["Button"], { label: 'Complete', flat: true, inverse: true, ripple: true, className: modal_default.a.submit, onClick: _this2.handleSubmit, disabled: disabled });
      return react_default.a.createElement(
        'div',
        null,
        react_default.a.createElement(components_SimpleInput, {
          label: 'PO Number (NOT REQUIRED)',
          text: number,
          onChange: _this2.handleNumberChange
        }),
        react_default.a.createElement(components_SimpleInput, {
          label: 'Reason for additional money',
          text: reason,
          onChange: _this2.handleReasonChange
        }),
        react_default.a.createElement(components_SimpleInput, {
          label: 'ISO/IST Contact',
          text: contact,
          onChange: _this2.handleContactChange
        }),
        lineItems.length > 0 ? react_default.a.createElement(
          'div',
          null,
          react_default.a.createElement(
            'table',
            { className: modal_default.a.table },
            _this2.renderTableHead(),
            _this2.renderTableBody(lineItems)
          ),
          react_default.a.createElement(
            'h6',
            { className: modal_default.a.poTotal },
            'PO Total: ',
            Object(lineItemUtils["g" /* formatDollars */])(total)
          )
        ) : react_default.a.createElement(
          'div',
          { className: modal_default.a.emptyTable },
          react_default.a.createElement(
            'h4',
            null,
            noTableText
          )
        ),
        addRow && react_default.a.createElement(
          'form',
          { onSubmit: _this2.handleSave },
          react_default.a.createElement(react_select, {
            label: 'Number - Description',
            placeholder: 'Select...',
            onChange: _this2.handleDescriptionChange,
            options: Object(lineItemUtils["f" /* filterByVendor */])(lineItemOptions, phase.source),
            value: lineItemId
          }),
          react_default.a.createElement(components_SimpleInput, {
            label: 'QTY',
            text: quantity,
            onChange: _this2.handleQuantityChange,
            errors: errors.quantity
          }),
          react_default.a.createElement(components_SimpleInput, {
            label: 'Unit Price',
            text: pricePatch,
            onChange: _this2.handlePriceChange,
            errors: errors.pricePatch
          }),
          lineItemTotal > 0 && react_default.a.createElement(
            'div',
            null,
            react_default.a.createElement(
              'h6',
              null,
              'Total: ' + Object(lineItemUtils["g" /* formatDollars */])(lineItemTotal)
            ),
            react_default.a.createElement('br', null)
          ),
          react_default.a.createElement(components_SimpleInput, {
            label: 'Note',
            text: note,
            onChange: _this2.handleNoteChange,
            errors: errors.note
          }),
          react_default.a.createElement(components_CheckBox, {
            required: true,
            text: 'Not Payable',
            errors: errors.payable,
            onChange: _this2.handlePayableChange,
            checked: !payable
          }),
          react_default.a.createElement('input', { className: modal_default.a.save, type: 'submit', value: 'Add' })
        ),
        react_default.a.createElement(react_toolbox_lib["Button"], { className: addRow ? modal_default.a.cancel : modal_default.a.add, label: addRow ? 'Cancel' : 'Add Item', flat: true, inverse: true, ripple: true, onClick: _this2.handleAddRow }),
        submitButton
      );
    }
  });
};

PoDetails.propTypes = {
  phase: types_phase.isRequired,
  number: prop_types_default.a.string,
  lineItems: prop_types_default.a.array,
  total: prop_types_default.a.number,
  reason: prop_types_default.a.string,
  contact: prop_types_default.a.string,
  errors: prop_types_default.a.shape({
    lineItems: prop_types_default.a.arrayOf(prop_types_default.a.array),
    total: prop_types_default.a.arrayOf(prop_types_default.a.number),
    lineItemId: prop_types_default.a.arrayOf(prop_types_default.a.number),
    quantity: prop_types_default.a.arrayOf(prop_types_default.a.number),
    pricePatch: prop_types_default.a.arrayOf(prop_types_default.a.number),
    lineItemTotal: prop_types_default.a.arrayOf(prop_types_default.a.number),
    payable: prop_types_default.a.arrayOf(prop_types_default.a.bool),
    note: prop_types_default.a.arrayOf(prop_types_default.a.string)
  })
};

PoDetails.defaultProps = { lineItemOptions: [] };

var poDetails_mapStateToProps = function mapStateToProps(state) {
  return {
    errors: Object(reducers["Y" /* getPhaseErrors */])(state), lineItemOptions: getPricePatchItems(state)
  };
};

/* harmony default export */ var poDetails = (Object(react_redux_es["connect"])(poDetails_mapStateToProps, {})(PoDetails));
// EXTERNAL MODULE: ./client/app/shared/actionCreators/dropdown_lists.js
var dropdown_lists = __webpack_require__("WWCX");

// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/createExceptionModal.jsx
var createExceptionModal__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var createExceptionModal__get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function createExceptionModal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function createExceptionModal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function createExceptionModal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var createExceptionModal_CreateExceptionModal = function (_Resetter) {
  createExceptionModal__inherits(CreateExceptionModal, _Resetter);

  function CreateExceptionModal(props) {
    createExceptionModal__classCallCheck(this, CreateExceptionModal);

    var _this = createExceptionModal__possibleConstructorReturn(this, (CreateExceptionModal.__proto__ || Object.getPrototypeOf(CreateExceptionModal)).call(this, props));

    Object.defineProperty(_this, 'componentWillUpdate', {
      enumerable: true,
      writable: true,
      value: function value(nextProps, nextState) {
        return nextProps.active && nextState.poDetailsMounted ? _this.props.requestPricePatchLineItemList(_this.props.phase.id) : null;
      }
    });
    Object.defineProperty(_this, 'setPoDetailsMounted', {
      enumerable: true,
      writable: true,
      value: function value(isMounted) {
        return _this.setState({ poDetailsMounted: isMounted });
      }
    });
    Object.defineProperty(_this, 'updateFormData', {
      enumerable: true,
      writable: true,
      value: function value(data) {
        return _this.setState(data, function () {
          if (!_this.validate()) return;
          var _this$state = _this.state,
              number = _this$state.number,
              total = _this$state.total,
              message = _this$state.message,
              lineItems = _this$state.lineItems,
              reason = _this$state.reason,
              contact = _this$state.contact;

          _this.props.createExceptionItem({
            number: number,
            kind: 'Exception',
            invoice_status: 'Not Invoiced',
            total: total,
            message: message,
            line_items: lineItems,
            phase_id: _this.props.phase.id,
            reason: reason,
            contact: contact
          }).then(function () {
            return _this.handleClose();
          });
        });
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            phase = _this$props.phase,
            active = _this$props.active,
            serverErrors = _this$props.errors;
        var _this$state2 = _this.state,
            number = _this$state2.number,
            total = _this$state2.total,
            lineItems = _this$state2.lineItems,
            reason = _this$state2.reason,
            contact = _this$state2.contact;

        return react_default.a.createElement(
          react_toolbox_lib["Dialog"],
          {
            active: active, className: modal_default.a.modal, type: 'fullscreen',
            onEscKeyDown: _this.handleClose, onOverlayClick: _this.handleClose
          },
          react_default.a.createElement(
            'div',
            { className: input_default.a.errored },
            Object.keys(serverErrors).length > 0 && react_default.a.createElement(
              'span',
              { className: input_default.a.error },
              'This action could not be completed.'
            )
          ),
          react_default.a.createElement(react_toolbox_lib["IconButton"], { icon: 'close', className: modal_default.a.close, onClick: _this.handleClose }),
          react_default.a.createElement(
            'h5',
            null,
            'Create Exception'
          ),
          react_default.a.createElement(poDetails, {
            phase: phase,
            number: number,
            setPoDetailsMounted: _this.setPoDetailsMounted,
            updateFormData: _this.updateFormData,
            total: total,
            lineItems: lineItems,
            reason: reason,
            contact: contact
          })
        );
      }
    });

    _this.setPoDetailsMounted = _this.setPoDetailsMounted.bind(_this);
    _this.state = {
      number: '',
      total: 0,
      lineItems: [],
      message: 'Exception created through the Action Button',
      errors: {},
      poDetailsMounted: false,
      contact: '',
      reason: ''
    };
    return _this;
  }

  createExceptionModal__createClass(CreateExceptionModal, [{
    key: 'handleClose',
    value: function handleClose() {
      createExceptionModal__get(CreateExceptionModal.prototype.__proto__ || Object.getPrototypeOf(CreateExceptionModal.prototype), 'handleClose', this).call(this);
      this.props.clearValidation();
      document.location.reload();
    }
  }]);

  return CreateExceptionModal;
}(resetter(validator(react_default.a.Component)));

Object.defineProperty(createExceptionModal_CreateExceptionModal, 'VALIDATIONS', {
  enumerable: true,
  writable: true,
  value: { total: true, lineItems: true }
});


createExceptionModal_CreateExceptionModal.propTypes = {
  active: prop_types_default.a.bool.isRequired,
  clearValidation: prop_types_default.a.func.isRequired,
  createExceptionItem: prop_types_default.a.func.isRequired,
  requestPhaseItems: prop_types_default.a.func.isRequired,
  requestPricePatchLineItemList: prop_types_default.a.func.isRequired,
  onClose: prop_types_default.a.func.isRequired,
  phase: types_phase.isRequired,
  errors: prop_types_default.a.shape({
    name: prop_types_default.a.arrayOf(prop_types_default.a.string)
  })
};

createExceptionModal_CreateExceptionModal.defaultProps = { active: false };

/* harmony default export */ var createExceptionModal = (Object(react_redux_es["connect"])(function (state) {
  return { errors: Object(reducers["Y" /* getPhaseErrors */])(state) };
}, {
  clearValidation: actionCreators["j" /* clearValidation */],
  createExceptionItem: actionCreators["p" /* createExceptionItem */],
  updatePhaseTask: actionCreators["_67" /* updatePhaseTask */],
  requestPhaseItems: phase_items["i" /* requestPhaseItems */],
  requestPricePatchLineItemList: dropdown_lists["d" /* requestPricePatchLineItemList */]
})(createExceptionModal_CreateExceptionModal));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/cocSignature/installation_completion.jsx
var installation_completion__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function installation_completion__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function installation_completion__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function installation_completion__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var AGREEMENT = 'I, the Customer, certify that the Installers/Independent Contractors\nor their sub-contractors, have furnished all Goods and/or services, that installation,\nrepairs and alterations or improvements (\'the installation services\') have been completed\nas set forth in my/our contract with Lowe\'s, and that I have been offered the opportunity\nto request that Lowe\'s allow me to retain some or all of any unused, receipted surplus\nmaterials rather than have such surplus materials remain the property of Lowe\'s.';

var installation_completion_InstallationCompletion = function (_Resetter) {
  installation_completion__inherits(InstallationCompletion, _Resetter);

  function InstallationCompletion() {
    var _ref;

    var _temp, _this, _ret;

    installation_completion__classCallCheck(this, InstallationCompletion);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = installation_completion__possibleConstructorReturn(this, (_ref = InstallationCompletion.__proto__ || Object.getPrototypeOf(InstallationCompletion)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'state', {
      enumerable: true,
      writable: true,
      value: {
        customerName: _this.props.customerName || '',
        errors: {}
      }
    }), Object.defineProperty(_this, 'handleSubmit', {
      enumerable: true,
      writable: true,
      value: function value() {
        if (!_this.validate()) {
          return;
        }
        _this.props.updateFormData({
          customerName: _this.state.customerName,
          tab: 2
        });
      }
    }), Object.defineProperty(_this, 'handleNameChange', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        _this.setState({ customerName: e.target.value });
      }
    }), _temp), installation_completion__possibleConstructorReturn(_this, _ret);
  }

  installation_completion__createClass(InstallationCompletion, [{
    key: 'render',
    value: function render() {
      var _state = this.state,
          customerName = _state.customerName,
          errors = _state.errors;


      return react_default.a.createElement(
        'div',
        null,
        react_default.a.createElement(
          'h6',
          { className: modal_default.a.signatureTitle },
          'Part 1 - Completion of Installation'
        ),
        react_default.a.createElement(
          'p',
          { className: modal_default.a.signatureText },
          AGREEMENT
        ),
        react_default.a.createElement(components_SimpleInput, {
          required: true,
          label: 'Print Customer\'s Name *',
          text: customerName,
          errors: errors.customerName,
          onChange: this.handleNameChange
        }),
        react_default.a.createElement(react_toolbox_lib["Button"], { label: 'Next', flat: true, inverse: true, ripple: true, className: modal_default.a.submit, onClick: this.handleSubmit })
      );
    }
  }]);

  return InstallationCompletion;
}(resetter(validator(react_default.a.Component)));

Object.defineProperty(installation_completion_InstallationCompletion, 'VALIDATIONS', {
  enumerable: true,
  writable: true,
  value: {
    customerName: true
  }
});


installation_completion_InstallationCompletion.propTypes = {
  copyPhase: prop_types_default.a.func,
  phase: types_phase.isRequired,
  errors: prop_types_default.a.shape({
    customerName: prop_types_default.a.arrayOf(prop_types_default.a.string)
  })
};

/* harmony default export */ var installation_completion = (Object(react_redux_es["connect"])(function (state) {
  return { errors: Object(reducers["Y" /* getPhaseErrors */])(state) };
}, {})(installation_completion_InstallationCompletion));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/cocSignature/customer_signature.jsx
var customer_signature__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function customer_signature__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function customer_signature__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function customer_signature__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var customer_signature_CustomerSignature = function (_Resetter) {
  customer_signature__inherits(CustomerSignature, _Resetter);

  function CustomerSignature() {
    var _ref;

    var _temp, _this, _ret;

    customer_signature__classCallCheck(this, CustomerSignature);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = customer_signature__possibleConstructorReturn(this, (_ref = CustomerSignature.__proto__ || Object.getPrototypeOf(CustomerSignature)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'state', {
      enumerable: true,
      writable: true,
      value: {
        customerSignature: _this.props.customerSignature || '',
        errors: {},
        clearSignature: 0
      }
    }), Object.defineProperty(_this, 'handleSubmit', {
      enumerable: true,
      writable: true,
      value: function value() {
        if (!_this.validate()) {
          return;
        }
        _this.props.updateFormData({
          customerSignature: _this.state.customerSignature,
          tab: 3
        });
      }
    }), Object.defineProperty(_this, 'handlePrevious', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.props.updateFormData({
          customerSignature: _this.state.customerSignature,
          tab: 1
        });
      }
    }), Object.defineProperty(_this, 'handleSignatureChange', {
      enumerable: true,
      writable: true,
      value: function value(data) {
        _this.setState({ customerSignature: data });
      }
    }), Object.defineProperty(_this, 'handleClear', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.setState({
          customerSignature: '',
          clearSignature: _this.props.customerSignature ? _this.state.clearSignature : Date.now()
        });
        _this.props.updateFormData({ customerSignature: '' });
      }
    }), _temp), customer_signature__possibleConstructorReturn(_this, _ret);
  }

  customer_signature__createClass(CustomerSignature, [{
    key: 'render',
    value: function render() {
      var _state = this.state,
          errors = _state.errors,
          clearSignature = _state.clearSignature;


      return react_default.a.createElement(
        'div',
        null,
        react_default.a.createElement(
          'h6',
          { className: modal_default.a.signatureTitle },
          'Part 2 - Customer Signature'
        ),
        react_default.a.createElement(components_SignatureBox, {
          required: true,
          value: this.props.customerSignature,
          label: 'Sign Customer\'s Name *',
          errors: errors.customerSignature,
          clearTimestamp: clearSignature,
          onEnd: this.handleSignatureChange,
          onClear: this.handleClear
        }),
        react_default.a.createElement(react_toolbox_lib["Button"], { label: 'Next', flat: true, inverse: true, ripple: true, className: modal_default.a.submit, onClick: this.handleSubmit }),
        react_default.a.createElement(react_toolbox_lib["Button"], { label: 'Previous', flat: true, inverse: true, ripple: true, className: modal_default.a.submit, onClick: this.handlePrevious })
      );
    }
  }]);

  return CustomerSignature;
}(resetter(validator(react_default.a.Component)));

Object.defineProperty(customer_signature_CustomerSignature, 'VALIDATIONS', {
  enumerable: true,
  writable: true,
  value: {
    customerSignature: true
  }
});


customer_signature_CustomerSignature.propTypes = {
  copyPhase: prop_types_default.a.func,
  phase: types_phase.isRequired,
  errors: prop_types_default.a.shape({
    customerSignature: prop_types_default.a.arrayOf(prop_types_default.a.string)
  })
};

/* harmony default export */ var customer_signature = (Object(react_redux_es["connect"])(function (state) {
  return { errors: Object(reducers["Y" /* getPhaseErrors */])(state) };
}, {})(customer_signature_CustomerSignature));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/cocSignature/surplus_material.jsx
var surplus_material__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function surplus_material__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function surplus_material__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function surplus_material__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var surplus_material_SurplusMaterial = function (_Resetter) {
  surplus_material__inherits(SurplusMaterial, _Resetter);

  function SurplusMaterial() {
    var _ref;

    var _temp, _this, _ret;

    surplus_material__classCallCheck(this, SurplusMaterial);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = surplus_material__possibleConstructorReturn(this, (_ref = SurplusMaterial.__proto__ || Object.getPrototypeOf(SurplusMaterial)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'state', {
      enumerable: true,
      writable: true,
      value: {
        surplusMaterials: _this.props.surplusMaterials || '',
        customerInitials: _this.props.customerInitials || '',
        errors: {}
      }
    }), Object.defineProperty(_this, 'surplusMaterialsRef', {
      enumerable: true,
      writable: true,
      value: react_default.a.createRef()
    }), Object.defineProperty(_this, 'handleSubmit', {
      enumerable: true,
      writable: true,
      value: function value() {
        if (!_this.validate()) {
          return;
        }
        _this.props.updateFormData({
          surplusMaterials: _this.state.surplusMaterials,
          customerInitials: _this.state.customerInitials,
          tab: 4
        });
      }
    }), Object.defineProperty(_this, 'handlePrevious', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.props.updateFormData({
          surplusMaterials: _this.state.surplusMaterials,
          customerInitials: _this.state.customerInitials,
          tab: 2
        });
      }
    }), Object.defineProperty(_this, 'handleSurplusMaterialChange', {
      enumerable: true,
      writable: true,
      value: function value(_value) {
        _this.setState({ surplusMaterials: _value });
      }
    }), Object.defineProperty(_this, 'handleCustomerInitialsChange', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        _this.setState({ customerInitials: e.target.value });
      }
    }), _temp), surplus_material__possibleConstructorReturn(_this, _ret);
  }

  surplus_material__createClass(SurplusMaterial, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.surplusMaterialsRef.current.scrollIntoView(false);
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          customerInitials = _state.customerInitials,
          errors = _state.errors;

      var radioButtons = [{
        label: 'There were no such surplus materials.',
        value: 'opt1'
      }, {
        label: 'I accepted all surplus materials I wanted.',
        value: 'opt2'
      }, {
        label: 'I declined to receive any surplus materials.',
        value: 'opt3'
      }];

      return react_default.a.createElement(
        'div',
        { ref: this.surplusMaterialsRef },
        react_default.a.createElement(
          'h6',
          { className: modal_default.a.signatureTitle },
          'Part 3 - Surplus Materials'
        ),
        react_default.a.createElement(components_RadioButtons, {
          label: 'Customer Selects One*', required: true,
          onChange: this.handleSurplusMaterialChange,
          selectedValue: this.state.surplusMaterials,
          radioButtons: radioButtons,
          text: 'Please select what should be done with remaining surplus materials:'
        }),
        react_default.a.createElement(components_SimpleInput, { label: 'Customer Initials*', required: true, text: customerInitials, errors: errors.customerInitials, onChange: this.handleCustomerInitialsChange }),
        react_default.a.createElement(react_toolbox_lib["Button"], { label: 'Next', flat: true, inverse: true, ripple: true, className: modal_default.a.submit, onClick: this.handleSubmit }),
        react_default.a.createElement(react_toolbox_lib["Button"], { label: 'Previous', flat: true, inverse: true, ripple: true, className: modal_default.a.submit, onClick: this.handlePrevious })
      );
    }
  }]);

  return SurplusMaterial;
}(resetter(validator(react_default.a.Component)));

Object.defineProperty(surplus_material_SurplusMaterial, 'VALIDATIONS', {
  enumerable: true,
  writable: true,
  value: {
    customerInitials: true
  }
});


surplus_material_SurplusMaterial.propTypes = {
  phase: types_phase.isRequired,
  errors: prop_types_default.a.shape({
    signature: prop_types_default.a.arrayOf(prop_types_default.a.string),
    name: prop_types_default.a.arrayOf(prop_types_default.a.string)
  })
};

/* harmony default export */ var surplus_material = (Object(react_redux_es["connect"])(function (state) {
  return { errors: Object(reducers["Y" /* getPhaseErrors */])(state) };
}, {})(surplus_material_SurplusMaterial));
// EXTERNAL MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/cocSignature/coc.jpg
var coc = __webpack_require__("ZyHx");
var coc_default = /*#__PURE__*/__webpack_require__.n(coc);

// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/cocSignature/contractor_confirmation.jsx
var contractor_confirmation__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function contractor_confirmation__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function contractor_confirmation__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function contractor_confirmation__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var contractor_confirmation_ContractorConfirmation = function (_Resetter) {
  contractor_confirmation__inherits(ContractorConfirmation, _Resetter);

  function ContractorConfirmation() {
    var _ref;

    var _temp, _this, _ret;

    contractor_confirmation__classCallCheck(this, ContractorConfirmation);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = contractor_confirmation__possibleConstructorReturn(this, (_ref = ContractorConfirmation.__proto__ || Object.getPrototypeOf(ContractorConfirmation)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'state', {
      enumerable: true,
      writable: true,
      value: {
        approveTerms: _this.props.approveTerms || false,
        contractorName: _this.props.contractorName || '',
        errors: {}
      }
    }), Object.defineProperty(_this, 'contractorConfirmationRef', {
      enumerable: true,
      writable: true,
      value: react_default.a.createRef()
    }), Object.defineProperty(_this, 'handleSubmit', {
      enumerable: true,
      writable: true,
      value: function value() {
        if (!_this.validate()) {
          return;
        }
        _this.props.updateFormData({
          contractorName: _this.state.contractorName,
          approveTerms: _this.state.approveTerms,
          tab: 5
        });
      }
    }), Object.defineProperty(_this, 'handlePrevious', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.props.updateFormData({
          contractorName: _this.state.contractorName,
          approveTerms: _this.state.approveTerms,
          tab: 3
        });
      }
    }), Object.defineProperty(_this, 'handleNameChange', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        _this.setState({ contractorName: e.target.value });
      }
    }), Object.defineProperty(_this, 'handleApproveTermsChange', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.setState({ approveTerms: !_this.state.approveTerms });
      }
    }), _temp), contractor_confirmation__possibleConstructorReturn(_this, _ret);
  }

  contractor_confirmation__createClass(ContractorConfirmation, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.contractorConfirmationRef.current.scrollIntoView(true);
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          contractorName = _state.contractorName,
          errors = _state.errors;


      return react_default.a.createElement(
        'div',
        { ref: this.contractorConfirmationRef },
        react_default.a.createElement(
          'h6',
          null,
          'Part 4 - Contractor Confirmation'
        ),
        react_default.a.createElement(components_CheckBox, {
          label: 'Approve Terms *',
          required: true,
          text: 'I confirm I\'ve read and approve the linked document and its terms.',
          errors: errors.approveTerms, onChange: this.handleApproveTermsChange,
          checked: this.state.approveTerms
        }),
        react_default.a.createElement(
          'a',
          { href: coc_default.a, target: '_blank', rel: 'noopener noreferrer', className: modal_default.a.cocLink },
          'Link to COC Agreement'
        ),
        react_default.a.createElement(components_SimpleInput, {
          label: 'Print Contractor\'s Name *',
          required: true,
          text: contractorName,
          errors: errors.contractorName,
          onChange: this.handleNameChange
        }),
        react_default.a.createElement(react_toolbox_lib["Button"], { label: 'Next', flat: true, inverse: true, ripple: true, className: modal_default.a.submit, onClick: this.handleSubmit }),
        react_default.a.createElement(react_toolbox_lib["Button"], { label: 'Previous', flat: true, inverse: true, ripple: true, className: modal_default.a.submit, onClick: this.handlePrevious })
      );
    }
  }]);

  return ContractorConfirmation;
}(resetter(validator(react_default.a.Component)));

Object.defineProperty(contractor_confirmation_ContractorConfirmation, 'VALIDATIONS', {
  enumerable: true,
  writable: true,
  value: {
    contractorName: true,
    approveTerms: true
  }
});


contractor_confirmation_ContractorConfirmation.propTypes = {
  errors: prop_types_default.a.shape({
    contractorName: prop_types_default.a.arrayOf(prop_types_default.a.string)
  })
};

/* harmony default export */ var contractor_confirmation = (Object(react_redux_es["connect"])(function (state) {
  return { errors: Object(reducers["Y" /* getPhaseErrors */])(state) };
}, {})(contractor_confirmation_ContractorConfirmation));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/cocSignature/contractor_signature.jsx
var contractor_signature__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function contractor_signature__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function contractor_signature__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function contractor_signature__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var contractor_signature_ContractorSignature = function (_Resetter) {
  contractor_signature__inherits(ContractorSignature, _Resetter);

  function ContractorSignature() {
    var _ref;

    var _temp, _this, _ret;

    contractor_signature__classCallCheck(this, ContractorSignature);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = contractor_signature__possibleConstructorReturn(this, (_ref = ContractorSignature.__proto__ || Object.getPrototypeOf(ContractorSignature)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'state', {
      enumerable: true,
      writable: true,
      value: {
        contractorSignature: _this.props.contractorSignature || '',
        clearSignature: 0,
        errors: {}
      }
    }), Object.defineProperty(_this, 'contractorSignatureRef', {
      enumerable: true,
      writable: true,
      value: react_default.a.createRef()
    }), Object.defineProperty(_this, 'handleSubmit', {
      enumerable: true,
      writable: true,
      value: function value() {
        if (!_this.validate()) {
          return;
        }
        _this.props.updateFormData({
          contractorSignature: _this.state.contractorSignature,
          tab: 6
        });
      }
    }), Object.defineProperty(_this, 'handlePrevious', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.props.updateFormData({
          contractorSignature: _this.state.contractorSignature,
          tab: 4
        });
      }
    }), Object.defineProperty(_this, 'handleSignatureChange', {
      enumerable: true,
      writable: true,
      value: function value(data) {
        _this.setState({ contractorSignature: data });
      }
    }), Object.defineProperty(_this, 'handleClear', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.setState({
          contractorSignature: '',
          clearSignature: _this.props.contractorSignature ? _this.state.clearSignature : Date.now()
        });
        _this.props.updateFormData({ contractorSignature: '' });
      }
    }), _temp), contractor_signature__possibleConstructorReturn(_this, _ret);
  }

  contractor_signature__createClass(ContractorSignature, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.contractorSignatureRef.current.scrollIntoView(true);
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          errors = _state.errors,
          clearSignature = _state.clearSignature;


      return react_default.a.createElement(
        'div',
        { ref: this.contractorSignatureRef },
        react_default.a.createElement(
          'h6',
          null,
          'Part 5 - Contractor Signature'
        ),
        react_default.a.createElement(components_SignatureBox, {
          label: 'Sign Contractor\'s Name *',
          required: true,
          value: this.props.contractorSignature,
          errors: errors.contractorSignature,
          clearTimestamp: clearSignature,
          onEnd: this.handleSignatureChange,
          onClear: this.handleClear
        }),
        react_default.a.createElement(react_toolbox_lib["Button"], { label: 'Complete', flat: true, inverse: true, ripple: true, className: modal_default.a.submit, onClick: this.handleSubmit }),
        react_default.a.createElement(react_toolbox_lib["Button"], { label: 'Previous', flat: true, inverse: true, ripple: true, className: modal_default.a.submit, onClick: this.handlePrevious })
      );
    }
  }]);

  return ContractorSignature;
}(resetter(validator(react_default.a.Component)));

Object.defineProperty(contractor_signature_ContractorSignature, 'VALIDATIONS', {
  enumerable: true,
  writable: true,
  value: {
    contractorSignature: true
  }
});


contractor_signature_ContractorSignature.propTypes = {
  errors: prop_types_default.a.shape({
    contractorSignature: prop_types_default.a.arrayOf(prop_types_default.a.string)
  })
};

/* harmony default export */ var contractor_signature = (Object(react_redux_es["connect"])(function (state) {
  return { errors: Object(reducers["Y" /* getPhaseErrors */])(state) };
}, {})(contractor_signature_ContractorSignature));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/cocModal.jsx
var cocModal__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var cocModal__get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function cocModal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function cocModal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function cocModal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var cocModal_CocModal = function (_Resetter) {
  cocModal__inherits(CocModal, _Resetter);

  function CocModal() {
    var _ref;

    var _temp, _this, _ret;

    cocModal__classCallCheck(this, CocModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = cocModal__possibleConstructorReturn(this, (_ref = CocModal.__proto__ || Object.getPrototypeOf(CocModal)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'updateFormData', {
      enumerable: true,
      writable: true,
      value: function value(cocData) {
        _this.setState(cocData, function () {
          if (cocData.tab === 6) {
            _this.props.cocCreate({
              contractor_name: _this.state.contractorName,
              contractor_signature: _this.state.contractorSignature,
              customer_initials: _this.state.customerInitials,
              customer_name: _this.state.customerName,
              customer_signature: _this.state.customerSignature,
              surplus_materials: _this.state.surplusMaterials,
              phase_id: _this.props.phase.id
            }).then(function () {
              _this.handleClose();
            }).catch(function () {});
          }
        });
      }
    }), Object.defineProperty(_this, 'showTab', {
      enumerable: true,
      writable: true,
      value: function value() {
        switch (_this.state.tab) {
          case 1:
            return react_default.a.createElement(installation_completion, {
              phase: _this.props.phase,
              updateFormData: _this.updateFormData,
              customerName: _this.state.customerName
            });
          case 2:
            return react_default.a.createElement(customer_signature, {
              phase: _this.props.phase,
              updateFormData: _this.updateFormData,
              customerSignature: _this.state.customerSignature
            });
          case 3:
            return react_default.a.createElement(surplus_material, {
              phase: _this.props.phase,
              updateFormData: _this.updateFormData,
              surplusMaterials: _this.state.surplusMaterials,
              customerInitials: _this.state.customerInitials
            });
          case 4:
            return react_default.a.createElement(contractor_confirmation, {
              updateFormData: _this.updateFormData,
              approveTerms: _this.state.approveTerms,
              contractorName: _this.state.contractorName
            });
          case 5:
            return react_default.a.createElement(contractor_signature, {
              updateFormData: _this.updateFormData,
              contractorSignature: _this.state.contractorSignature
            });
          default:
            return react_default.a.createElement(components_Loading, null);
        }
      }
    }), _temp), cocModal__possibleConstructorReturn(_this, _ret);
  }

  cocModal__createClass(CocModal, [{
    key: 'handleClose',
    value: function handleClose() {
      cocModal__get(CocModal.prototype.__proto__ || Object.getPrototypeOf(CocModal.prototype), 'handleClose', this).call(this);
      this.props.clearValidation();
      document.location.reload();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          active = _props.active,
          serverErrors = _props.errors;

      return react_default.a.createElement(
        react_toolbox_lib["Dialog"],
        {
          active: active, className: modal_default.a.modal, type: 'fullscreen',
          onEscKeyDown: this.handleClose, onOverlayClick: this.handleClose
        },
        react_default.a.createElement(
          'div',
          { className: input_default.a.errored },
          Object.keys(serverErrors).length > 0 && react_default.a.createElement(
            'span',
            { className: input_default.a.error },
            'This action could not be completed.'
          )
        ),
        react_default.a.createElement(react_toolbox_lib["IconButton"], { icon: 'close', className: modal_default.a.close, onClick: this.handleClose }),
        react_default.a.createElement(
          'h5',
          null,
          'Sign Certificate of Completion'
        ),
        this.showTab()
      );
    }
  }]);

  return CocModal;
}(resetter(validator(react_default.a.Component)));

Object.defineProperty(cocModal_CocModal, 'DEFAULT_STATE', {
  enumerable: true,
  writable: true,
  value: {
    customerSignature: '',
    customerName: '',
    surplusMaterials: 'opt1',
    customerInitials: '',
    approveTerms: '',
    contractorSignature: '',
    contractorName: '',
    errors: {},
    tab: 1
  }
});
Object.defineProperty(cocModal_CocModal, 'VALIDATIONS', {
  enumerable: true,
  writable: true,
  value: {
    signature: true,
    name: true
  }
});


cocModal_CocModal.propTypes = {
  active: prop_types_default.a.bool.isRequired,
  clearValidation: prop_types_default.a.func.isRequired,
  cocCreate: prop_types_default.a.func.isRequired,
  onClose: prop_types_default.a.func.isRequired,
  phase: types_phase.isRequired,
  errors: prop_types_default.a.shape({
    signature: prop_types_default.a.arrayOf(prop_types_default.a.string),
    name: prop_types_default.a.arrayOf(prop_types_default.a.string)
  })
};

cocModal_CocModal.defaultProps = {
  active: false
};

/* harmony default export */ var cocModal = (Object(react_redux_es["connect"])(function (state) {
  return { errors: state.cocs.uploadError };
}, {
  clearValidation: actionCreators["j" /* clearValidation */],
  cocCreate: actionCreators["m" /* cocCreate */],
  updatePhaseTask: actionCreators["_67" /* updatePhaseTask */]
})(cocModal_CocModal));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/tasks/components/WalkthroughModal/initialInfo.jsx
function initialInfo__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function initialInfo__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function initialInfo__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var initialInfo_InitialInfo = function (_Resetter) {
  initialInfo__inherits(InitialInfo, _Resetter);

  function InitialInfo() {
    var _ref;

    var _temp, _this, _ret;

    initialInfo__classCallCheck(this, InitialInfo);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = initialInfo__possibleConstructorReturn(this, (_ref = InitialInfo.__proto__ || Object.getPrototypeOf(InitialInfo)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'state', {
      enumerable: true,
      writable: true,
      value: {
        customerInitials: _this.props.customerInitials || '',
        installerInitials: _this.props.installerInitials || '',
        customerName: _this.props.customerInitials || '',
        installerName: _this.props.installerInitials || '',
        surfaceType: _this.props.surfaceType || '',
        step: _this.props.step || '',
        errors: {}
      }
    }), Object.defineProperty(_this, 'handleSubmit', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$state = _this.state,
            step = _this$state.step,
            customerInitials = _this$state.customerInitials,
            customerName = _this$state.customerName,
            installerInitials = _this$state.installerInitials,
            installerName = _this$state.installerName;

        if (!_this.validate()) return;
        var tab = step === 'post' && _this.props.surfaceType !== 'carpet' ? 3 : 2;
        _this.props.updateFormData({
          customerInitials: customerInitials,
          customerName: customerName,
          installerInitials: installerInitials,
          installerName: installerName,
          step: step,
          tab: tab
        });
      }
    }), Object.defineProperty(_this, 'handleInstallerInitials', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        return _this.setState({ installerInitials: e.target.value });
      }
    }), Object.defineProperty(_this, 'handleInstallerName', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        return _this.setState({ installerName: e.target.value });
      }
    }), Object.defineProperty(_this, 'handleCustomerInitials', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        return _this.setState({ customerInitials: e.target.value });
      }
    }), Object.defineProperty(_this, 'handleCustomerName', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        return _this.setState({ customerName: e.target.value });
      }
    }), Object.defineProperty(_this, 'handleStep', {
      enumerable: true,
      writable: true,
      value: function value(_value) {
        return _this.setState({ step: _value });
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var isSpanish = _this.props.isSpanish;
        var _this$state2 = _this.state,
            customerInitials = _this$state2.customerInitials,
            customerName = _this$state2.customerName,
            installerInitials = _this$state2.installerInitials,
            installerName = _this$state2.installerName,
            errors = _this$state2.errors,
            step = _this$state2.step;


        var stepButtons = [{ label: '' + (isSpanish ? 'Ante' : 'Pre'), value: 'pre' }, { label: '' + (isSpanish ? 'Después' : 'Post'), value: 'post' }];

        return react_default.a.createElement(
          'div',
          null,
          react_default.a.createElement(
            'h6',
            null,
            isSpanish ? 'Información Inicial' : 'Initial Info'
          ),
          react_default.a.createElement(components_RadioButtons, {
            label: isSpanish ? 'Seleccionar Tipo de Formulario*' : 'Select Form Type*',
            required: true,
            onChange: _this.handleStep,
            selectedValue: step,
            radioButtons: stepButtons,
            text: isSpanish ? '¿Es esto antes o después de la instalación?' : 'Is this a pre- or post- walkthrough?'
          }),
          react_default.a.createElement(components_SimpleInput, {
            label: isSpanish ? 'Escriba el nombre del instalador*' : 'Print Installer\'s Name*',
            required: true,
            text: installerName,
            errors: errors.installerName,
            onChange: _this.handleInstallerName
          }),
          react_default.a.createElement(components_SimpleInput, {
            label: isSpanish ? 'Iniciales de instalador*' : 'Installer Initials*',
            required: true,
            text: installerInitials,
            errors: errors.installerInitials,
            onChange: _this.handleInstallerInitials
          }),
          react_default.a.createElement(components_SimpleInput, {
            label: isSpanish ? 'Escriba el nombre del cliente*' : 'Print Customer\'s Name*',
            required: true,
            text: customerName,
            errors: errors.customerName,
            onChange: _this.handleCustomerName
          }),
          react_default.a.createElement(components_SimpleInput, {
            label: isSpanish ? 'Iniciales del cliente*' : 'Customer Initials*',
            required: true,
            text: customerInitials,
            errors: errors.customerInitials,
            onChange: _this.handleCustomerInitials
          }),
          react_default.a.createElement(react_toolbox_lib["Button"], {
            label: isSpanish ? 'Próximo' : 'Next',
            flat: true, inverse: true, ripple: true,
            className: modal_default.a.submit,
            onClick: _this.handleSubmit
          }),
          react_default.a.createElement(react_toolbox_lib["Button"], {
            label: isSpanish ? 'Anterior' : 'Previous',
            flat: true, inverse: true, ripple: true,
            className: modal_default.a.submit,
            onClick: _this.handlePrevious
          })
        );
      }
    }), _temp), initialInfo__possibleConstructorReturn(_this, _ret);
  }

  return InitialInfo;
}(resetter(validator(react_default.a.Component)));

Object.defineProperty(initialInfo_InitialInfo, 'VALIDATIONS', {
  enumerable: true,
  writable: true,
  value: {
    customerInitials: true,
    customerName: true,
    installerInitials: true,
    installerName: true,
    step: true
  }
});


initialInfo_InitialInfo.propTypes = {
  isSpanish: prop_types_default.a.bool,
  phase: types_phase.isRequired,
  customerInitials: prop_types_default.a.string,
  installerInitials: prop_types_default.a.string,
  customerName: prop_types_default.a.string,
  installerName: prop_types_default.a.string,
  surfaceType: prop_types_default.a.string,
  step: prop_types_default.a.string,
  errors: prop_types_default.a.shape({
    installerInitials: prop_types_default.a.arrayOf(prop_types_default.a.string),
    customerInitials: prop_types_default.a.arrayOf(prop_types_default.a.string),
    installerName: prop_types_default.a.arrayOf(prop_types_default.a.string),
    customerName: prop_types_default.a.arrayOf(prop_types_default.a.string),
    surfaceType: prop_types_default.a.arrayOf(prop_types_default.a.string),
    step: prop_types_default.a.arrayOf(prop_types_default.a.string)
  })
};

/* harmony default export */ var initialInfo = (Object(react_redux_es["connect"])(function (state) {
  return { errors: Object(reducers["Y" /* getPhaseErrors */])(state) };
}, {})(initialInfo_InitialInfo));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/tasks/components/WalkthroughModal/pre/installerPreWalkthrough.jsx
function installerPreWalkthrough__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function installerPreWalkthrough__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function installerPreWalkthrough__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var installerPreWalkthrough_InstallerPreWalkthrough = function (_Resetter) {
  installerPreWalkthrough__inherits(InstallerPreWalkthrough, _Resetter);

  function InstallerPreWalkthrough() {
    var _ref;

    var _temp, _this, _ret;

    installerPreWalkthrough__classCallCheck(this, InstallerPreWalkthrough);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = installerPreWalkthrough__possibleConstructorReturn(this, (_ref = InstallerPreWalkthrough.__proto__ || Object.getPrototypeOf(InstallerPreWalkthrough)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'state', {
      enumerable: true,
      writable: true,
      value: {
        installerParkedInStreet: _this.props.installerParkedInStreet || false,
        installerDrivewayPermission: _this.props.installerDrivewayPermission || false,
        installerProtectFromOil: _this.props.installerProtectFromOil || false,
        installerCarpetSeamPlacement: _this.props.installerCarpetSeamPlacement || false,
        installerCarpetSeamVisibility: _this.props.installerCarpetSeamVisibility || false,
        installerHardSurfaceMoistureReadings: _this.props.installerHardSurfaceMoistureReadings || false,
        installerActualReading: _this.props.installerActualReading || '',
        errors: {}
      }
    }), Object.defineProperty(_this, 'installerPreWalkthroughRef', {
      enumerable: true,
      writable: true,
      value: react_default.a.createRef()
    }), Object.defineProperty(_this, 'componentDidMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.installerPreWalkthroughRef.current.scrollIntoView(false);
      }
    }), Object.defineProperty(_this, 'handleSubmit', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$state = _this.state,
            installerParkedInStreet = _this$state.installerParkedInStreet,
            installerDrivewayPermission = _this$state.installerDrivewayPermission,
            installerProtectFromOil = _this$state.installerProtectFromOil,
            installerCarpetSeamPlacement = _this$state.installerCarpetSeamPlacement,
            installerCarpetSeamVisibility = _this$state.installerCarpetSeamVisibility,
            installerHardSurfaceMoistureReadings = _this$state.installerHardSurfaceMoistureReadings,
            installerActualReading = _this$state.installerActualReading;

        _this.props.updateFormData({
          installerParkedInStreet: installerParkedInStreet,
          installerDrivewayPermission: installerDrivewayPermission,
          installerProtectFromOil: installerProtectFromOil,
          installerCarpetSeamPlacement: installerCarpetSeamPlacement,
          installerCarpetSeamVisibility: installerCarpetSeamVisibility,
          installerHardSurfaceMoistureReadings: installerHardSurfaceMoistureReadings,
          installerActualReading: installerActualReading,
          tab: 3
        });
      }
    }), Object.defineProperty(_this, 'handlePrevious', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$state2 = _this.state,
            installerParkedInStreet = _this$state2.installerParkedInStreet,
            installerDrivewayPermission = _this$state2.installerDrivewayPermission,
            installerProtectFromOil = _this$state2.installerProtectFromOil,
            installerCarpetSeamPlacement = _this$state2.installerCarpetSeamPlacement,
            installerCarpetSeamVisibility = _this$state2.installerCarpetSeamVisibility,
            installerHardSurfaceMoistureReadings = _this$state2.installerHardSurfaceMoistureReadings,
            installerActualReading = _this$state2.installerActualReading;

        _this.props.updateFormData({
          installerParkedInStreet: installerParkedInStreet,
          installerDrivewayPermission: installerDrivewayPermission,
          installerProtectFromOil: installerProtectFromOil,
          installerCarpetSeamPlacement: installerCarpetSeamPlacement,
          installerCarpetSeamVisibility: installerCarpetSeamVisibility,
          installerHardSurfaceMoistureReadings: installerHardSurfaceMoistureReadings,
          installerActualReading: installerActualReading,
          tab: 1
        });
      }
    }), Object.defineProperty(_this, 'handleInstallerParkedInStreet', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ installerParkedInStreet: !_this.state.installerParkedInStreet });
      }
    }), Object.defineProperty(_this, 'handleInstallerDrivewayPermission', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ installerDrivewayPermission: !_this.state.installerDrivewayPermission });
      }
    }), Object.defineProperty(_this, 'handleInstallerProtectFromOil', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ installerProtectFromOil: !_this.state.installerProtectFromOil });
      }
    }), Object.defineProperty(_this, 'handleInstallerCarpetSeamPlacement', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ installerCarpetSeamPlacement: !_this.state.installerCarpetSeamPlacement });
      }
    }), Object.defineProperty(_this, 'handleInstallerCarpetSeamVisibility', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ installerCarpetSeamVisibility: !_this.state.installerCarpetSeamVisibility });
      }
    }), Object.defineProperty(_this, 'handleInstallerHardSurfaceMoistureReadings', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({
          installerHardSurfaceMoistureReadings: !_this.state.installerHardSurfaceMoistureReadings
        });
      }
    }), Object.defineProperty(_this, 'handleInstallerActualReading', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        return _this.setState({ installerActualReading: e.target.value });
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var isSpanish = _this.props.isSpanish;
        var _this$state3 = _this.state,
            installerParkedInStreet = _this$state3.installerParkedInStreet,
            installerDrivewayPermission = _this$state3.installerDrivewayPermission,
            installerProtectFromOil = _this$state3.installerProtectFromOil,
            installerCarpetSeamPlacement = _this$state3.installerCarpetSeamPlacement,
            installerCarpetSeamVisibility = _this$state3.installerCarpetSeamVisibility,
            installerHardSurfaceMoistureReadings = _this$state3.installerHardSurfaceMoistureReadings,
            installerActualReading = _this$state3.installerActualReading,
            errors = _this$state3.errors;


        return react_default.a.createElement(
          'div',
          null,
          react_default.a.createElement(
            'h6',
            { ref: _this.installerPreWalkthroughRef },
            isSpanish ? 'Lista de Verificación del Instalador' : 'Installer Checklist'
          ),
          react_default.a.createElement(components_CheckBox, {
            required: true,
            text: isSpanish ? 'Estacioné en la calle' : 'I parked in the street',
            errors: errors.installerParkedInStreet,
            onChange: _this.handleInstallerParkedInStreet,
            checked: installerParkedInStreet
          }),
          react_default.a.createElement(components_CheckBox, {
            required: true,
            text: isSpanish ? 'Pedí permiso para usar la entrada' : 'I asked permission to use the driveway',
            errors: errors.installerDrivewayPermission,
            onChange: _this.handleInstallerDrivewayPermission,
            checked: installerDrivewayPermission
          }),
          react_default.a.createElement(components_CheckBox, {
            required: true,
            text: isSpanish ? 'Protegí el camino de entrada del petróleo' : 'I protected the driveway from oil',
            errors: errors.installerProtectFromOil,
            onChange: _this.handleInstallerProtectFromOil,
            checked: installerProtectFromOil
          }),
          _this.props.surfaceType && _this.props.surfaceType.toLowerCase() === 'carpet' ? react_default.a.createElement(
            'span',
            null,
            react_default.a.createElement(components_CheckBox, {
              required: true,
              text: isSpanish ? 'He revisado la colocación de la costura con el cliente' : 'I have reviewed seam placement with the customer',
              errors: errors.installerCarpetSeamPlacement,
              onChange: _this.handleInstallerCarpetSeamPlacement,
              checked: installerCarpetSeamPlacement
            }),
            react_default.a.createElement(components_CheckBox, {
              required: true,
              text: isSpanish ? 'He discutido la visibilidad de la costura' : 'I have discussed seam visibility',
              errors: errors.installerCarpetSeamVisibility,
              onChange: _this.handleInstallerCarpetSeamVisibility,
              checked: installerCarpetSeamVisibility
            })
          ) : react_default.a.createElement(components_CheckBox, {
            required: true,
            text: isSpanish ? 'He tomado medido de humedad' : 'I have taken moisture readings',
            errors: errors.installerHardSurfaceMoistureReadings,
            onChange: _this.handleInstallerHardSurfaceMoistureReadings,
            checked: installerHardSurfaceMoistureReadings
          }),
          installerHardSurfaceMoistureReadings && react_default.a.createElement(components_SimpleInput, {
            label: isSpanish ? 'Medición de Humedad' : 'Moisture Reading',
            required: true,
            text: installerActualReading,
            errors: errors.installerActualReading,
            onChange: _this.handleInstallerActualReading
          }),
          react_default.a.createElement(react_toolbox_lib["Button"], {
            label: isSpanish ? 'Próximo' : 'Next',
            flat: true, inverse: true, ripple: true,
            className: modal_default.a.submit,
            onClick: _this.handleSubmit
          }),
          react_default.a.createElement(react_toolbox_lib["Button"], {
            label: isSpanish ? 'Anterior' : 'Previous',
            flat: true, inverse: true, ripple: true,
            className: modal_default.a.submit,
            onClick: _this.handlePrevious
          })
        );
      }
    }), _temp), installerPreWalkthrough__possibleConstructorReturn(_this, _ret);
  }

  return InstallerPreWalkthrough;
}(resetter(validator(react_default.a.Component)));

installerPreWalkthrough_InstallerPreWalkthrough.propTypes = {
  isSpanish: prop_types_default.a.bool,
  phase: types_phase.isRequired,
  surfaceType: prop_types_default.a.string,
  installerParkedInStreet: prop_types_default.a.bool,
  installerDrivewayPermission: prop_types_default.a.bool,
  installerProtectFromOil: prop_types_default.a.bool,
  installerCarpetSeamPlacement: prop_types_default.a.bool,
  installerCarpetSeamVisibility: prop_types_default.a.bool,
  installerHardSurfaceMoistureReadings: prop_types_default.a.bool,
  installerActualReading: prop_types_default.a.string,
  errors: prop_types_default.a.shape({
    installerParkedInStreet: prop_types_default.a.arrayOf(prop_types_default.a.string),
    installerDrivewayPermission: prop_types_default.a.arrayOf(prop_types_default.a.string),
    installerProtectFromOil: prop_types_default.a.arrayOf(prop_types_default.a.string),
    installerCarpetSeamPlacement: prop_types_default.a.arrayOf(prop_types_default.a.string),
    installerCarpetSeamVisibility: prop_types_default.a.arrayOf(prop_types_default.a.string),
    installerHardSurfaceMoistureReadings: prop_types_default.a.arrayOf(prop_types_default.a.string),
    installerActualReading: prop_types_default.a.arrayOf(prop_types_default.a.string)
  })
};

/* harmony default export */ var installerPreWalkthrough = (Object(react_redux_es["connect"])(function (state) {
  return { errors: Object(reducers["Y" /* getPhaseErrors */])(state) };
}, {})(installerPreWalkthrough_InstallerPreWalkthrough));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/tasks/components/WalkthroughModal/post/installerPostWalkthrough.jsx
function installerPostWalkthrough__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function installerPostWalkthrough__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function installerPostWalkthrough__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var installerPostWalkthrough_InstallerPostWalkthrough = function (_Resetter) {
  installerPostWalkthrough__inherits(InstallerPostWalkthrough, _Resetter);

  function InstallerPostWalkthrough() {
    var _ref;

    var _temp, _this, _ret;

    installerPostWalkthrough__classCallCheck(this, InstallerPostWalkthrough);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = installerPostWalkthrough__possibleConstructorReturn(this, (_ref = InstallerPostWalkthrough.__proto__ || Object.getPrototypeOf(InstallerPostWalkthrough)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'state', {
      enumerable: true,
      writable: true,
      value: {
        installerCarpetAllSeamsSealed: _this.props.installerCarpetAllSeamsSealed || false,
        installerCarpetPowerStretched: _this.props.installerCarpetPowerStretched || false,
        installerCarpetVacuumed: _this.props.installerCarpetVacuumed || false,
        installerCarpetCleanedUp: _this.props.installerCarpetCleanedUp || false,
        errors: {}
      }
    }), Object.defineProperty(_this, 'installerPostWalkthroughRef', {
      enumerable: true,
      writable: true,
      value: react_default.a.createRef()
    }), Object.defineProperty(_this, 'componentDidMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.installerPostWalkthroughRef.current.scrollIntoView(false);
      }
    }), Object.defineProperty(_this, 'handleSubmit', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$state = _this.state,
            installerCarpetAllSeamsSealed = _this$state.installerCarpetAllSeamsSealed,
            installerCarpetPowerStretched = _this$state.installerCarpetPowerStretched,
            installerCarpetVacuumed = _this$state.installerCarpetVacuumed,
            installerCarpetCleanedUp = _this$state.installerCarpetCleanedUp;

        _this.props.updateFormData({
          installerCarpetAllSeamsSealed: installerCarpetAllSeamsSealed,
          installerCarpetPowerStretched: installerCarpetPowerStretched,
          installerCarpetVacuumed: installerCarpetVacuumed,
          installerCarpetCleanedUp: installerCarpetCleanedUp,
          tab: 3
        });
      }
    }), Object.defineProperty(_this, 'handlePrevious', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$state2 = _this.state,
            installerCarpetAllSeamsSealed = _this$state2.installerCarpetAllSeamsSealed,
            installerCarpetPowerStretched = _this$state2.installerCarpetPowerStretched,
            installerCarpetVacuumed = _this$state2.installerCarpetVacuumed,
            installerCarpetCleanedUp = _this$state2.installerCarpetCleanedUp;

        _this.props.updateFormData({
          installerCarpetAllSeamsSealed: installerCarpetAllSeamsSealed,
          installerCarpetPowerStretched: installerCarpetPowerStretched,
          installerCarpetVacuumed: installerCarpetVacuumed,
          installerCarpetCleanedUp: installerCarpetCleanedUp,
          tab: 1
        });
      }
    }), Object.defineProperty(_this, 'handleInstallerCarpetAllSeamsSealed', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ installerCarpetAllSeamsSealed: !_this.state.installerCarpetAllSeamsSealed });
      }
    }), Object.defineProperty(_this, 'handleInstallerCarpetPowerStretched', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ installerCarpetPowerStretched: !_this.state.installerCarpetPowerStretched });
      }
    }), Object.defineProperty(_this, 'handleInstallerCarpetVacuumed', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ installerCarpetVacuumed: !_this.state.installerCarpetVacuumed });
      }
    }), Object.defineProperty(_this, 'handleInstallerCarpetCleanedUp', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ installerCarpetCleanedUp: !_this.state.installerCarpetCleanedUp });
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var isSpanish = _this.props.isSpanish;
        var _this$state3 = _this.state,
            installerCarpetAllSeamsSealed = _this$state3.installerCarpetAllSeamsSealed,
            installerCarpetPowerStretched = _this$state3.installerCarpetPowerStretched,
            installerCarpetVacuumed = _this$state3.installerCarpetVacuumed,
            installerCarpetCleanedUp = _this$state3.installerCarpetCleanedUp,
            errors = _this$state3.errors;


        return react_default.a.createElement(
          'div',
          { ref: _this.installerPostWalkthroughRef },
          react_default.a.createElement(
            'h6',
            null,
            isSpanish ? 'Lista de Verificación del Instalador' : 'Installer Checklist'
          ),
          react_default.a.createElement(components_CheckBox, {
            required: true,
            text: isSpanish ? 'Todas las costuras han sido selladas' : 'All seams have been sealed',
            errors: errors.installerCarpetAllSeamsSealed,
            onChange: _this.handleInstallerCarpetAllSeamsSealed,
            checked: installerCarpetAllSeamsSealed
          }),
          react_default.a.createElement(components_CheckBox, {
            required: true,
            text: isSpanish ? 'La alfombra ha sido estirada' : 'Carpet has been power stretched',
            errors: errors.installerCarpetPowerStretched,
            onChange: _this.handleInstallerCarpetPowerStretched,
            checked: installerCarpetPowerStretched
          }),
          react_default.a.createElement(components_CheckBox, {
            required: true,
            text: isSpanish ? 'La alfombra ha sido aspirada' : 'Carpet has been vacuumed',
            errors: errors.installerCarpetVacuumed,
            onChange: _this.handleInstallerCarpetVacuumed,
            checked: installerCarpetVacuumed
          }),
          react_default.a.createElement(components_CheckBox, {
            required: true,
            text: isSpanish ? 'He limpiado el patio, el garaje y / o el camino de entrada donde se cortó el material' : 'I have cleaned up the yard, garage, and/or driveway where the material was cut',
            errors: errors.installerCarpetCleanedUp,
            onChange: _this.handleInstallerCarpetCleanedUp,
            checked: installerCarpetCleanedUp
          }),
          react_default.a.createElement(react_toolbox_lib["Button"], {
            label: isSpanish ? 'Próximo' : 'Next',
            flat: true, inverse: true, ripple: true,
            className: modal_default.a.submit,
            onClick: _this.handleSubmit
          }),
          react_default.a.createElement(react_toolbox_lib["Button"], {
            label: isSpanish ? 'Anterior' : 'Previous',
            flat: true, inverse: true, ripple: true,
            className: modal_default.a.submit,
            onClick: _this.handlePrevious
          })
        );
      }
    }), _temp), installerPostWalkthrough__possibleConstructorReturn(_this, _ret);
  }

  return InstallerPostWalkthrough;
}(resetter(validator(react_default.a.Component)));

installerPostWalkthrough_InstallerPostWalkthrough.propTypes = {
  isSpanish: prop_types_default.a.bool,
  phase: types_phase.isRequired,
  installerCarpetAllSeamsSealed: prop_types_default.a.bool,
  installerCarpetPowerStretched: prop_types_default.a.bool,
  installerCarpetVacuumed: prop_types_default.a.bool,
  installerCarpetCleanedUp: prop_types_default.a.bool,
  errors: prop_types_default.a.shape({
    installerCarpetAllSeamsSealed: prop_types_default.a.arrayOf(prop_types_default.a.string),
    installerCarpetPowerStretched: prop_types_default.a.arrayOf(prop_types_default.a.string),
    installerCarpetVacuumed: prop_types_default.a.arrayOf(prop_types_default.a.string),
    installerCarpetCleanedUp: prop_types_default.a.arrayOf(prop_types_default.a.string)
  })
};

/* harmony default export */ var installerPostWalkthrough = (Object(react_redux_es["connect"])(function (state) {
  return { errors: Object(reducers["Y" /* getPhaseErrors */])(state) };
}, {})(installerPostWalkthrough_InstallerPostWalkthrough));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/tasks/components/WalkthroughModal/pre/customerPreWalkthrough.jsx
function customerPreWalkthrough__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function customerPreWalkthrough__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function customerPreWalkthrough__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var customerPreWalkthrough_CustomerPreWalkthrough = function (_Resetter) {
  customerPreWalkthrough__inherits(CustomerPreWalkthrough, _Resetter);

  function CustomerPreWalkthrough() {
    var _ref;

    var _temp, _this, _ret;

    customerPreWalkthrough__classCallCheck(this, CustomerPreWalkthrough);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = customerPreWalkthrough__possibleConstructorReturn(this, (_ref = CustomerPreWalkthrough.__proto__ || Object.getPrototypeOf(CustomerPreWalkthrough)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'state', {
      enumerable: true,
      writable: true,
      value: {
        customerMaterialsAndColor: _this.props.customerMaterialsAndColor || false,
        customerClimateControl: _this.props.customerClimateControl || false,
        customerCarpetSeamPlacement: _this.props.customerCarpetSeamPlacement || false,
        customerCarpetRoomsToBeInstalled: _this.props.customerCarpetRoomsToBeInstalled || false,
        customerCarpetScuffs: _this.props.customerCarpetScuffs || false,
        customerHardSurfaceRoomsAndMoisture: _this.props.customerHardSurfaceRoomsAndMoisture || false,
        customerHardSurfaceMoistureBarrier: _this.props.customerHardSurfaceMoistureBarrier || false,
        errors: {}
      }
    }), Object.defineProperty(_this, 'customerPreWalkthroughRef', {
      enumerable: true,
      writable: true,
      value: react_default.a.createRef()
    }), Object.defineProperty(_this, 'componentDidMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.customerPreWalkthroughRef.current.scrollIntoView(false);
      }
    }), Object.defineProperty(_this, 'handleSubmit', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$state = _this.state,
            customerMaterialsAndColor = _this$state.customerMaterialsAndColor,
            customerClimateControl = _this$state.customerClimateControl,
            customerCarpetSeamPlacement = _this$state.customerCarpetSeamPlacement,
            customerCarpetRoomsToBeInstalled = _this$state.customerCarpetRoomsToBeInstalled,
            customerCarpetScuffs = _this$state.customerCarpetScuffs,
            customerHardSurfaceRoomsAndMoisture = _this$state.customerHardSurfaceRoomsAndMoisture,
            customerHardSurfaceMoistureBarrier = _this$state.customerHardSurfaceMoistureBarrier;

        _this.props.updateFormData({
          customerMaterialsAndColor: customerMaterialsAndColor,
          customerClimateControl: customerClimateControl,
          customerCarpetSeamPlacement: customerCarpetSeamPlacement,
          customerCarpetRoomsToBeInstalled: customerCarpetRoomsToBeInstalled,
          customerCarpetScuffs: customerCarpetScuffs,
          customerHardSurfaceRoomsAndMoisture: customerHardSurfaceRoomsAndMoisture,
          customerHardSurfaceMoistureBarrier: customerHardSurfaceMoistureBarrier,
          tab: 5
        });
      }
    }), Object.defineProperty(_this, 'handlePrevious', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$state2 = _this.state,
            customerMaterialsAndColor = _this$state2.customerMaterialsAndColor,
            customerClimateControl = _this$state2.customerClimateControl,
            customerCarpetSeamPlacement = _this$state2.customerCarpetSeamPlacement,
            customerCarpetRoomsToBeInstalled = _this$state2.customerCarpetRoomsToBeInstalled,
            customerCarpetScuffs = _this$state2.customerCarpetScuffs,
            customerHardSurfaceRoomsAndMoisture = _this$state2.customerHardSurfaceRoomsAndMoisture,
            customerHardSurfaceMoistureBarrier = _this$state2.customerHardSurfaceMoistureBarrier;

        _this.props.updateFormData({
          customerMaterialsAndColor: customerMaterialsAndColor,
          customerClimateControl: customerClimateControl,
          customerCarpetSeamPlacement: customerCarpetSeamPlacement,
          customerCarpetRoomsToBeInstalled: customerCarpetRoomsToBeInstalled,
          customerCarpetScuffs: customerCarpetScuffs,
          customerHardSurfaceRoomsAndMoisture: customerHardSurfaceRoomsAndMoisture,
          customerHardSurfaceMoistureBarrier: customerHardSurfaceMoistureBarrier,
          tab: 2
        });
      }
    }), Object.defineProperty(_this, 'handleCustomerMaterialsAndColor', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ customerMaterialsAndColor: !_this.state.customerMaterialsAndColor });
      }
    }), Object.defineProperty(_this, 'handleCustomerClimateControl', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ customerClimateControl: !_this.state.customerClimateControl });
      }
    }), Object.defineProperty(_this, 'handleCustomerCarpetSeamPlacement', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ customerCarpetSeamPlacement: !_this.state.customerCarpetSeamPlacement });
      }
    }), Object.defineProperty(_this, 'handleCustomerCarpetRoomsToBeInstalled', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({
          customerCarpetRoomsToBeInstalled: !_this.state.customerCarpetRoomsToBeInstalled
        });
      }
    }), Object.defineProperty(_this, 'handleCustomerCarpetScuffs', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ customerCarpetScuffs: !_this.state.customerCarpetScuffs });
      }
    }), Object.defineProperty(_this, 'handleCustomerHardSurfaceRoomsAndMoisture', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({
          customerHardSurfaceRoomsAndMoisture: !_this.state.customerHardSurfaceRoomsAndMoisture
        });
      }
    }), Object.defineProperty(_this, 'handleCustomerHardSurfaceMoistureBarrier', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({
          customerHardSurfaceMoistureBarrier: !_this.state.customerHardSurfaceMoistureBarrier
        });
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var isSpanish = _this.props.isSpanish;
        var _this$state3 = _this.state,
            customerMaterialsAndColor = _this$state3.customerMaterialsAndColor,
            customerClimateControl = _this$state3.customerClimateControl,
            customerCarpetSeamPlacement = _this$state3.customerCarpetSeamPlacement,
            customerCarpetRoomsToBeInstalled = _this$state3.customerCarpetRoomsToBeInstalled,
            customerCarpetScuffs = _this$state3.customerCarpetScuffs,
            customerHardSurfaceRoomsAndMoisture = _this$state3.customerHardSurfaceRoomsAndMoisture,
            customerHardSurfaceMoistureBarrier = _this$state3.customerHardSurfaceMoistureBarrier,
            errors = _this$state3.errors;


        return react_default.a.createElement(
          'div',
          { ref: _this.customerPreWalkthroughRef },
          react_default.a.createElement(
            'h6',
            null,
            isSpanish ? 'Lista de Verificación del Cliente' : 'Customer Checklist'
          ),
          react_default.a.createElement(components_CheckBox, {
            required: true,
            text: isSpanish ? 'He verificado materiales y color' : 'I have verified the materials and color',
            errors: errors.customerMaterialsAndColor,
            onChange: _this.handleCustomerMaterialsAndColor,
            checked: customerMaterialsAndColor
          }),
          react_default.a.createElement(components_CheckBox, {
            required: true,
            text: isSpanish ? 'El control climático ha estado encendido durante 72 horas' : 'Climate control has been on for 72 hours',
            errors: errors.customerClimateControl,
            onChange: _this.handleCustomerClimateControl,
            checked: customerClimateControl
          }),
          _this.props.surfaceType.toLowerCase() === 'carpet' ? react_default.a.createElement(
            'span',
            null,
            react_default.a.createElement(components_CheckBox, {
              required: true,
              text: isSpanish ? 'Aprobé la colocación de la costura' : 'I approved the seam placement',
              errors: errors.customerCarpetSeamPlacement,
              onChange: _this.handleCustomerCarpetSeamPlacement,
              checked: customerCarpetSeamPlacement
            }),
            react_default.a.createElement(components_CheckBox, {
              required: true,
              text: isSpanish ? 'He verificado las habitaciones a instalar' : 'I have verified the rooms to be installed',
              errors: errors.customerCarpetRoomsToBeInstalled,
              onChange: _this.handleCustomerCarpetRoomsToBeInstalled,
              checked: customerCarpetRoomsToBeInstalled
            }),
            react_default.a.createElement(components_CheckBox, {
              required: true,
              text: isSpanish ? 'Entiendo que las paredes y los zócalos se pueden raspar durante la instalación estándar' : 'I understand the walls and baseboards can be scuffed during standard installation',
              errors: errors.customerCarpetScuffs,
              onChange: _this.handleCustomerCarpetScuffs,
              checked: customerCarpetScuffs
            })
          ) : react_default.a.createElement(
            'span',
            null,
            react_default.a.createElement(components_CheckBox, {
              required: true,
              text: isSpanish ? 'He verificado las habitaciones a instalar y las lecturas de humedad' : 'I have verified the rooms to be installed and moisture readings',
              errors: errors.customerHardSurfaceRoomsAndMoisture,
              onChange: _this.handleCustomerHardSurfaceRoomsAndMoisture,
              checked: customerHardSurfaceRoomsAndMoisture
            }),
            react_default.a.createElement(components_CheckBox, {
              required: true,
              text: isSpanish ? 'El hogar tiene una barrera de humedad aprobada para gatear' : 'Home has an approved crawlspace moisture barrier',
              errors: errors.customerHardSurfaceMoistureBarrier,
              onChange: _this.handleCustomerHardSurfaceMoistureBarrier,
              checked: customerHardSurfaceMoistureBarrier
            })
          ),
          react_default.a.createElement(react_toolbox_lib["Button"], {
            label: isSpanish ? 'Próximo' : 'Next',
            flat: true, inverse: true, ripple: true,
            className: modal_default.a.submit,
            onClick: _this.handleSubmit
          }),
          react_default.a.createElement(react_toolbox_lib["Button"], {
            label: isSpanish ? 'Anterior' : 'Previous',
            flat: true, inverse: true, ripple: true,
            className: modal_default.a.submit,
            onClick: _this.handlePrevious
          })
        );
      }
    }), _temp), customerPreWalkthrough__possibleConstructorReturn(_this, _ret);
  }

  return CustomerPreWalkthrough;
}(resetter(validator(react_default.a.Component)));

customerPreWalkthrough_CustomerPreWalkthrough.propTypes = {
  isSpanish: prop_types_default.a.bool,
  phase: types_phase.isRequired,
  surfaceType: prop_types_default.a.string,
  customerMaterialsAndColor: prop_types_default.a.bool,
  customerClimateControl: prop_types_default.a.bool,
  customerCarpetSeamPlacement: prop_types_default.a.bool,
  customerCarpetRoomsToBeInstalled: prop_types_default.a.bool,
  customerCarpetScuffs: prop_types_default.a.bool,
  customerHardSurfaceRoomsAndMoisture: prop_types_default.a.bool,
  customerHardSurfaceMoistureBarrier: prop_types_default.a.bool,
  errors: prop_types_default.a.shape({
    customerMaterialsAndColor: prop_types_default.a.arrayOf(prop_types_default.a.string),
    customerClimateControl: prop_types_default.a.arrayOf(prop_types_default.a.string),
    customerCarpetSeamPlacement: prop_types_default.a.arrayOf(prop_types_default.a.string),
    customerCarpetRoomsToBeInstalled: prop_types_default.a.arrayOf(prop_types_default.a.string),
    customerCarpetScuffs: prop_types_default.a.arrayOf(prop_types_default.a.string),
    customerHardSurfaceRoomsAndMoisture: prop_types_default.a.arrayOf(prop_types_default.a.string),
    customerHardSurfaceMoistureBarrier: prop_types_default.a.arrayOf(prop_types_default.a.string)
  })
};

/* harmony default export */ var customerPreWalkthrough = (Object(react_redux_es["connect"])(function (state) {
  return { errors: Object(reducers["Y" /* getPhaseErrors */])(state) };
}, {})(customerPreWalkthrough_CustomerPreWalkthrough));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/tasks/components/WalkthroughModal/post/customerPostWalkthrough.jsx
function customerPostWalkthrough__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function customerPostWalkthrough__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function customerPostWalkthrough__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var customerPostWalkthrough_CustomerPostWalkthrough = function (_Resetter) {
  customerPostWalkthrough__inherits(CustomerPostWalkthrough, _Resetter);

  function CustomerPostWalkthrough() {
    var _ref;

    var _temp, _this, _ret;

    customerPostWalkthrough__classCallCheck(this, CustomerPostWalkthrough);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = customerPostWalkthrough__possibleConstructorReturn(this, (_ref = CustomerPostWalkthrough.__proto__ || Object.getPrototypeOf(CustomerPostWalkthrough)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'state', {
      enumerable: true,
      writable: true,
      value: {
        customerCarpetSeamAndExcess: _this.props.customerCarpetSeamAndExcess || false,
        customerHardSurfaceTransition: _this.props.customerHardSurfaceTransition || false,
        customerHardSurfaceMolding: _this.props.customerHardSurfaceMolding || false,
        customerHardSurfaceMaterial: _this.props.customerHardSurfaceMaterial || false,
        customerHardSurfaceFloorHeight: _this.props.customerHardSurfaceFloorHeight || false,
        customerHardSurfaceDoorCuts: _this.props.customerHardSurfaceDoorCuts || false,
        customerHardSurfaceWaste: _this.props.customerHardSurfaceWaste || false,
        errors: {}
      }
    }), Object.defineProperty(_this, 'customerPostWalkthroughRef', {
      enumerable: true,
      writable: true,
      value: react_default.a.createRef()
    }), Object.defineProperty(_this, 'componentDidMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.customerPostWalkthroughRef.current.scrollIntoView(false);
      }
    }), Object.defineProperty(_this, 'handleSubmit', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$state = _this.state,
            customerCarpetSeamAndExcess = _this$state.customerCarpetSeamAndExcess,
            customerHardSurfaceTransition = _this$state.customerHardSurfaceTransition,
            customerHardSurfaceMolding = _this$state.customerHardSurfaceMolding,
            customerHardSurfaceMaterial = _this$state.customerHardSurfaceMaterial,
            customerHardSurfaceFloorHeight = _this$state.customerHardSurfaceFloorHeight,
            customerHardSurfaceDoorCuts = _this$state.customerHardSurfaceDoorCuts,
            customerHardSurfaceWaste = _this$state.customerHardSurfaceWaste;

        _this.props.updateFormData({
          customerCarpetSeamAndExcess: customerCarpetSeamAndExcess,
          customerHardSurfaceTransition: customerHardSurfaceTransition,
          customerHardSurfaceMolding: customerHardSurfaceMolding,
          customerHardSurfaceMaterial: customerHardSurfaceMaterial,
          customerHardSurfaceFloorHeight: customerHardSurfaceFloorHeight,
          customerHardSurfaceDoorCuts: customerHardSurfaceDoorCuts,
          customerHardSurfaceWaste: customerHardSurfaceWaste,
          tab: 4
        });
      }
    }), Object.defineProperty(_this, 'handlePrevious', {
      enumerable: true,
      writable: true,
      value: function value() {
        var tab = _this.props.surfaceType === 'hard_surface' ? 1 : 2;
        var _this$state2 = _this.state,
            customerCarpetSeamAndExcess = _this$state2.customerCarpetSeamAndExcess,
            customerHardSurfaceTransition = _this$state2.customerHardSurfaceTransition,
            customerHardSurfaceMolding = _this$state2.customerHardSurfaceMolding,
            customerHardSurfaceMaterial = _this$state2.customerHardSurfaceMaterial,
            customerHardSurfaceFloorHeight = _this$state2.customerHardSurfaceFloorHeight,
            customerHardSurfaceDoorCuts = _this$state2.customerHardSurfaceDoorCuts,
            customerHardSurfaceWaste = _this$state2.customerHardSurfaceWaste;

        _this.props.updateFormData({
          customerCarpetSeamAndExcess: customerCarpetSeamAndExcess,
          customerHardSurfaceTransition: customerHardSurfaceTransition,
          customerHardSurfaceMolding: customerHardSurfaceMolding,
          customerHardSurfaceMaterial: customerHardSurfaceMaterial,
          customerHardSurfaceFloorHeight: customerHardSurfaceFloorHeight,
          customerHardSurfaceDoorCuts: customerHardSurfaceDoorCuts,
          customerHardSurfaceWaste: customerHardSurfaceWaste,
          tab: tab
        });
      }
    }), Object.defineProperty(_this, 'handleCustomerCarpetSeamAndExcess', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ customerCarpetSeamAndExcess: !_this.state.customerCarpetSeamAndExcess });
      }
    }), Object.defineProperty(_this, 'handleCustomerHardSurfaceTransition', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ customerHardSurfaceTransition: !_this.state.customerHardSurfaceTransition });
      }
    }), Object.defineProperty(_this, 'handleCustomerHardSurfaceMolding', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ customerHardSurfaceMolding: !_this.state.customerHardSurfaceMolding });
      }
    }), Object.defineProperty(_this, 'handleCustomerHardSurfaceMaterial', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ customerHardSurfaceMaterial: !_this.state.customerHardSurfaceMaterial });
      }
    }), Object.defineProperty(_this, 'handleCustomerHardSurfaceFloorHeight', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ customerHardSurfaceFloorHeight: !_this.state.customerHardSurfaceFloorHeight });
      }
    }), Object.defineProperty(_this, 'handleCustomerHardSurfaceDoorCuts', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ customerHardSurfaceDoorCuts: !_this.state.customerHardSurfaceDoorCuts });
      }
    }), Object.defineProperty(_this, 'handleCustomerHardSurfaceWaste', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ customerHardSurfaceWaste: !_this.state.customerHardSurfaceWaste });
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var isSpanish = _this.props.isSpanish;
        var _this$state3 = _this.state,
            customerCarpetSeamAndExcess = _this$state3.customerCarpetSeamAndExcess,
            customerHardSurfaceTransition = _this$state3.customerHardSurfaceTransition,
            customerHardSurfaceMolding = _this$state3.customerHardSurfaceMolding,
            customerHardSurfaceMaterial = _this$state3.customerHardSurfaceMaterial,
            customerHardSurfaceFloorHeight = _this$state3.customerHardSurfaceFloorHeight,
            customerHardSurfaceDoorCuts = _this$state3.customerHardSurfaceDoorCuts,
            customerHardSurfaceWaste = _this$state3.customerHardSurfaceWaste,
            errors = _this$state3.errors;


        return react_default.a.createElement(
          'div',
          { ref: _this.customerPostWalkthroughRef },
          react_default.a.createElement(
            'h6',
            null,
            isSpanish ? 'Lista de Verificación del Cliente' : 'Customer Checklist'
          ),
          _this.props.surfaceType.toLowerCase() === 'carpet' ? react_default.a.createElement(
            'span',
            null,
            react_default.a.createElement(components_CheckBox, {
              required: true,
              text: isSpanish ? 'Apruebo la nueva ubicación de la costura y el exceso de alfombra' : 'I approve new seam location and excess carpet (if applicable)',
              errors: errors.customerCarpetSeamAndExcess,
              onChange: _this.handleCustomerCarpetSeamAndExcess,
              checked: customerCarpetSeamAndExcess
            })
          ) : react_default.a.createElement(
            'span',
            null,
            react_default.a.createElement(components_CheckBox, {
              required: true,
              text: isSpanish ? 'El color y el estilo de transición son para mi satisfacción' : 'Transition color and style is to my satisfaction',
              errors: errors.customerHardSurfaceTransition,
              onChange: _this.handleCustomerHardSurfaceTransition,
              checked: customerHardSurfaceTransition
            }),
            react_default.a.createElement(components_CheckBox, {
              required: true,
              text: isSpanish ? 'Moldear color y estilo es para mi satisfacción' : 'Molding color and style is to my satisfaction',
              errors: errors.customerHardSurfaceMolding,
              onChange: _this.handleCustomerHardSurfaceMolding,
              checked: customerHardSurfaceMolding
            }),
            react_default.a.createElement(components_CheckBox, {
              required: true,
              text: isSpanish ? 'El color y el estilo del material son para mi satisfacción' : 'Material color and style is to my satisfaction',
              errors: errors.customerHardSurfaceMaterial,
              onChange: _this.handleCustomerHardSurfaceMaterial,
              checked: customerHardSurfaceMaterial
            }),
            react_default.a.createElement(components_CheckBox, {
              required: true,
              text: isSpanish ? 'La altura del piso es para mi satisfacción' : 'Floor height is to my satisfaction',
              errors: errors.customerHardSurfaceFloorHeight,
              onChange: _this.handleCustomerHardSurfaceFloorHeight,
              checked: customerHardSurfaceFloorHeight
            }),
            react_default.a.createElement(components_CheckBox, {
              required: true,
              text: isSpanish ? 'Los cortes de puerta son para mi satisfacción' : 'Door cuts are to my satisfaction',
              errors: errors.customerHardSurfaceDoorCuts,
              onChange: _this.handleCustomerHardSurfaceDoorCuts,
              checked: customerHardSurfaceDoorCuts
            }),
            react_default.a.createElement(components_CheckBox, {
              required: true,
              text: isSpanish ? 'Se ofreció desperdicio' : 'Waste was offered',
              errors: errors.customerHardSurfaceWaste,
              onChange: _this.handleCustomerHardSurfaceWaste,
              checked: customerHardSurfaceWaste
            })
          ),
          react_default.a.createElement(react_toolbox_lib["Button"], {
            label: isSpanish ? 'Próximo' : 'Next',
            flat: true, inverse: true, ripple: true,
            className: modal_default.a.submit,
            onClick: _this.handleSubmit
          }),
          react_default.a.createElement(react_toolbox_lib["Button"], {
            label: isSpanish ? 'Anterior' : 'Previous',
            flat: true, inverse: true, ripple: true,
            className: modal_default.a.submit,
            onClick: _this.handlePrevious
          })
        );
      }
    }), _temp), customerPostWalkthrough__possibleConstructorReturn(_this, _ret);
  }

  return CustomerPostWalkthrough;
}(resetter(validator(react_default.a.Component)));

customerPostWalkthrough_CustomerPostWalkthrough.propTypes = {
  isSpanish: prop_types_default.a.bool,
  phase: types_phase.isRequired,
  surfaceType: prop_types_default.a.string,
  customerCarpetSeamAndExcess: prop_types_default.a.bool,
  customerHardSurfaceTransition: prop_types_default.a.bool,
  customerHardSurfaceMolding: prop_types_default.a.bool,
  customerHardSurfaceMaterial: prop_types_default.a.bool,
  customerHardSurfaceFloorHeight: prop_types_default.a.bool,
  customerHardSurfaceDoorCuts: prop_types_default.a.bool,
  customerHardSurfaceWaste: prop_types_default.a.bool,
  errors: prop_types_default.a.shape({
    customerCarpetSeamAndExcess: prop_types_default.a.arrayOf(prop_types_default.a.string),
    customerHardSurfaceTransition: prop_types_default.a.arrayOf(prop_types_default.a.string),
    customerHardSurfaceMolding: prop_types_default.a.arrayOf(prop_types_default.a.string),
    customerHardSurfaceMaterial: prop_types_default.a.arrayOf(prop_types_default.a.string),
    customerHardSurfaceFloorHeight: prop_types_default.a.arrayOf(prop_types_default.a.string),
    customerHardSurfaceDoorCuts: prop_types_default.a.arrayOf(prop_types_default.a.string),
    customerHardSurfaceWaste: prop_types_default.a.arrayOf(prop_types_default.a.string)
  })
};

/* harmony default export */ var customerPostWalkthrough = (Object(react_redux_es["connect"])(function (state) {
  return { errors: Object(reducers["Y" /* getPhaseErrors */])(state) };
}, {})(customerPostWalkthrough_CustomerPostWalkthrough));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/tasks/components/SignCocModal/surplus_material.jsx
var SignCocModal_surplus_material__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function SignCocModal_surplus_material__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SignCocModal_surplus_material__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function SignCocModal_surplus_material__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var SignCocModal_surplus_material_SurplusMaterial = function (_Resetter) {
  SignCocModal_surplus_material__inherits(SurplusMaterial, _Resetter);

  function SurplusMaterial() {
    var _ref;

    var _temp, _this, _ret;

    SignCocModal_surplus_material__classCallCheck(this, SurplusMaterial);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = SignCocModal_surplus_material__possibleConstructorReturn(this, (_ref = SurplusMaterial.__proto__ || Object.getPrototypeOf(SurplusMaterial)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'state', {
      enumerable: true,
      writable: true,
      value: {
        excessMaterials: _this.props.excessMaterials || 'NO_EXCESS_MATERIALS',
        errors: {}
      }
    }), Object.defineProperty(_this, 'surplusMaterialsRef', {
      enumerable: true,
      writable: true,
      value: react_default.a.createRef()
    }), Object.defineProperty(_this, 'handleSubmit', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.props.updateFormData({
          excessMaterials: _this.state.excessMaterials,
          tab: 6
        });
      }
    }), Object.defineProperty(_this, 'handlePrevious', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.props.updateFormData({
          excessMaterials: _this.state.excessMaterials,
          tab: 3
        });
      }
    }), Object.defineProperty(_this, 'handleExcessMaterialsChange', {
      enumerable: true,
      writable: true,
      value: function value(_value) {
        return _this.setState({ excessMaterials: _value });
      }
    }), _temp), SignCocModal_surplus_material__possibleConstructorReturn(_this, _ret);
  }

  SignCocModal_surplus_material__createClass(SurplusMaterial, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.surplusMaterialsRef.current.scrollIntoView(false);
    }
  }, {
    key: 'render',
    value: function render() {
      var isSpanish = this.props.isSpanish;

      var radioButtons = [{
        label: isSpanish ? 'No hubo exceso de materiales' : 'There were no excess materials',
        value: 'NO_EXCESS_MATERIALS'
      }, {
        label: isSpanish ? 'Cliente dispuesto a mantener el exceso de materiales' : 'Customer willing to keep excess materials',
        value: 'CUSTOMER_WILLING_TO_KEEP_EXCESS'
      }, {
        label: isSpanish ? 'El cliente debe regresar a la tienda para obtener un reembolso' : 'Customer to return to store for a refund',
        value: 'CUSTOMER_RETURN_TO_STORE_FOR_REFUND'
      }, {
        label: isSpanish ? "Regreso a la tienda: Programe la recogida de Lowe's" : "Return to store: Schedule Lowe's pick-up",
        value: 'RETURN_TO_STORE_SCHEDULE_LOWES_PICKUP'
      }];

      return react_default.a.createElement(
        'div',
        { ref: this.surplusMaterialsRef },
        react_default.a.createElement(
          'h6',
          { className: modal_default.a.signatureTitle },
          isSpanish ? 'Exceso de Materiales' : 'Excess Materials'
        ),
        react_default.a.createElement(components_RadioButtons, {
          required: true,
          onChange: this.handleExcessMaterialsChange,
          selectedValue: this.state.excessMaterials,
          radioButtons: radioButtons,
          text: isSpanish ? 'Por favor, seleccione qué se debe hacer con el exceso de material restante:' : 'Please select what should be done with remaining excess materials:'
        }),
        react_default.a.createElement(react_toolbox_lib["Button"], {
          label: isSpanish ? 'Próximo' : 'Next',
          flat: true, inverse: true, ripple: true,
          className: modal_default.a.submit,
          onClick: this.handleSubmit
        }),
        react_default.a.createElement(react_toolbox_lib["Button"], {
          label: isSpanish ? 'Anterior' : 'Previous',
          flat: true, inverse: true, ripple: true,
          className: modal_default.a.submit,
          onClick: this.handlePrevious
        })
      );
    }
  }]);

  return SurplusMaterial;
}(resetter(validator(react_default.a.Component)));

SignCocModal_surplus_material_SurplusMaterial.propTypes = {
  isSpanish: prop_types_default.a.bool,
  phase: types_phase.isRequired,
  errors: prop_types_default.a.shape({
    signature: prop_types_default.a.arrayOf(prop_types_default.a.string),
    name: prop_types_default.a.arrayOf(prop_types_default.a.string)
  })
};

/* harmony default export */ var SignCocModal_surplus_material = (Object(react_redux_es["connect"])(function (state) {
  return { errors: Object(reducers["Y" /* getPhaseErrors */])(state) };
}, {})(SignCocModal_surplus_material_SurplusMaterial));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/tasks/components/WalkthroughModal/finalChecks.jsx
function finalChecks__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function finalChecks__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function finalChecks__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var finalChecks_FinalChecks = function (_Resetter) {
  finalChecks__inherits(FinalChecks, _Resetter);

  function FinalChecks() {
    var _ref;

    var _temp, _this, _ret;

    finalChecks__classCallCheck(this, FinalChecks);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = finalChecks__possibleConstructorReturn(this, (_ref = FinalChecks.__proto__ || Object.getPrototypeOf(FinalChecks)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'state', {
      enumerable: true,
      writable: true,
      value: {
        hardSurfaceHomeTemp: _this.props.hardSurfaceHomeTemp || '',
        hardSurfaceAllMaterialsOnsite: _this.props.hardSurfaceAllMaterialsOnsite || '',
        hardSurfaceMaterialDamage: _this.props.hardSurfaceMaterialDamage || '',
        hardSurfaceMaterialDamageDetails: _this.props.hardSurfaceMaterialDamageDetails || 'No damage to product',
        siteDamageInstaller: _this.props.siteDamageInstaller,
        siteDamageCustomer: _this.props.siteDamageCustomer,
        siteDamageDetails: _this.props.siteDamageDetails || 'No existing damage',
        errors: {}
      }
    }), Object.defineProperty(_this, 'finalChecksRef', {
      enumerable: true,
      writable: true,
      value: react_default.a.createRef()
    }), Object.defineProperty(_this, 'componentDidMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.finalChecksRef.current.scrollIntoView(false);
      }
    }), Object.defineProperty(_this, 'handleSubmit', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$state = _this.state,
            hardSurfaceHomeTemp = _this$state.hardSurfaceHomeTemp,
            hardSurfaceAllMaterialsOnsite = _this$state.hardSurfaceAllMaterialsOnsite,
            hardSurfaceMaterialDamage = _this$state.hardSurfaceMaterialDamage,
            hardSurfaceMaterialDamageDetails = _this$state.hardSurfaceMaterialDamageDetails,
            siteDamageInstaller = _this$state.siteDamageInstaller,
            siteDamageCustomer = _this$state.siteDamageCustomer,
            siteDamageDetails = _this$state.siteDamageDetails;

        _this.props.updateFormData({
          hardSurfaceHomeTemp: hardSurfaceHomeTemp,
          hardSurfaceAllMaterialsOnsite: hardSurfaceAllMaterialsOnsite,
          hardSurfaceMaterialDamage: hardSurfaceMaterialDamage,
          hardSurfaceMaterialDamageDetails: hardSurfaceMaterialDamageDetails,
          siteDamageInstaller: siteDamageInstaller,
          siteDamageCustomer: siteDamageCustomer,
          siteDamageDetails: siteDamageDetails,
          tab: 6
        });
      }
    }), Object.defineProperty(_this, 'handlePrevious', {
      enumerable: true,
      writable: true,
      value: function value() {
        var tab = _this.props.step === 'pre' ? 3 : 4;
        var _this$state2 = _this.state,
            hardSurfaceHomeTemp = _this$state2.hardSurfaceHomeTemp,
            hardSurfaceAllMaterialsOnsite = _this$state2.hardSurfaceAllMaterialsOnsite,
            hardSurfaceMaterialDamage = _this$state2.hardSurfaceMaterialDamage,
            hardSurfaceMaterialDamageDetails = _this$state2.hardSurfaceMaterialDamageDetails,
            siteDamageInstaller = _this$state2.siteDamageInstaller,
            siteDamageCustomer = _this$state2.siteDamageCustomer,
            siteDamageDetails = _this$state2.siteDamageDetails;

        _this.props.updateFormData({
          hardSurfaceHomeTemp: hardSurfaceHomeTemp,
          hardSurfaceAllMaterialsOnsite: hardSurfaceAllMaterialsOnsite,
          hardSurfaceMaterialDamage: hardSurfaceMaterialDamage,
          hardSurfaceMaterialDamageDetails: hardSurfaceMaterialDamageDetails,
          siteDamageInstaller: siteDamageInstaller,
          siteDamageCustomer: siteDamageCustomer,
          siteDamageDetails: siteDamageDetails,
          tab: tab
        });
      }
    }), Object.defineProperty(_this, 'handleHardSurfaceHomeTemp', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        return _this.setState({ hardSurfaceHomeTemp: e.target.value });
      }
    }), Object.defineProperty(_this, 'handleHardSurfaceAllMaterialsOnsite', {
      enumerable: true,
      writable: true,
      value: function value(_value) {
        return _this.setState({ hardSurfaceAllMaterialsOnsite: _value });
      }
    }), Object.defineProperty(_this, 'handleHardSurfaceMaterialDamage', {
      enumerable: true,
      writable: true,
      value: function value(_value2) {
        return _this.setState({ hardSurfaceMaterialDamage: _value2 });
      }
    }), Object.defineProperty(_this, 'handleHardSurfaceMaterialDamageDetails', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        return _this.setState({ hardSurfaceMaterialDamageDetails: e.target.value });
      }
    }), Object.defineProperty(_this, 'handleSiteDamageDetails', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        return _this.setState({ siteDamageDetails: e.target.value });
      }
    }), Object.defineProperty(_this, 'handleSiteDamageInstaller', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ siteDamageInstaller: !_this.state.siteDamageInstaller });
      }
    }), Object.defineProperty(_this, 'handleSiteDamageCustomer', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ siteDamageCustomer: !_this.state.siteDamageCustomer });
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            isSpanish = _this$props.isSpanish,
            step = _this$props.step,
            surfaceType = _this$props.surfaceType;
        var _this$state3 = _this.state,
            errors = _this$state3.errors,
            siteDamageInstaller = _this$state3.siteDamageInstaller,
            siteDamageCustomer = _this$state3.siteDamageCustomer,
            siteDamageDetails = _this$state3.siteDamageDetails,
            hardSurfaceHomeTemp = _this$state3.hardSurfaceHomeTemp,
            hardSurfaceAllMaterialsOnsite = _this$state3.hardSurfaceAllMaterialsOnsite,
            hardSurfaceMaterialDamage = _this$state3.hardSurfaceMaterialDamage,
            hardSurfaceMaterialDamageDetails = _this$state3.hardSurfaceMaterialDamageDetails;


        var buttons = [{
          label: '' + (isSpanish ? 'SI' : 'YES'),
          value: 'yes'
        }, {
          label: 'NO',
          value: 'no'
        }];

        return react_default.a.createElement(
          'div',
          { ref: _this.finalChecksRef },
          react_default.a.createElement(
            'h6',
            null,
            isSpanish ? 'Controles Finales y Firmas' : 'Final Checks and Signatures'
          ),
          step === 'pre' && surfaceType === 'hard_surface' && react_default.a.createElement(
            'span',
            null,
            react_default.a.createElement(components_SimpleInput, {
              label: isSpanish ? 'Temperatura a la llegada' : 'Temperature Upon Arrival',
              required: true,
              text: hardSurfaceHomeTemp,
              errors: errors.hardSurfaceHomeTemp,
              onChange: _this.handleHardSurfaceHomeTemp
            }),
            react_default.a.createElement(components_RadioButtons, {
              onChange: _this.handleHardSurfaceAllMaterialsOnsite,
              selectedValue: hardSurfaceAllMaterialsOnsite,
              radioButtons: buttons,
              text: isSpanish ? '¿TODO el material está en el sitio para completar el trabajo?' : 'Is ALL material onsite to complete the job?'
            }),
            react_default.a.createElement(components_RadioButtons, {
              onChange: _this.handleHardSurfaceMaterialDamage,
              selectedValue: hardSurfaceMaterialDamage,
              radioButtons: buttons,
              text: isSpanish ? '¿Hay algún daño en los materiales?' : 'Is there any damage to the materials?'
            }),
            react_default.a.createElement(components_TextArea, {
              label: isSpanish ? 'Detalles de daños materiales' : 'Material Damage Details',
              value: hardSurfaceMaterialDamageDetails,
              errors: errors.hardSurfaceMaterialDamageDetails,
              onChange: _this.handleHardSurfaceMaterialDamageDetails,
              autoFocus: true
            })
          ),
          step === 'pre' ? react_default.a.createElement(
            'span',
            null,
            react_default.a.createElement(components_TextArea, {
              label: isSpanish ? '¿Daños en muebles, paredes, zócalos, escaleras, etc.?' : 'Damage to furniture, walls, baseboards, stairs, etc?',
              value: siteDamageDetails,
              errors: errors.siteDamageDetails,
              onChange: _this.handleSiteDamageDetails,
              autoFocus: true
            }),
            react_default.a.createElement(components_CheckBox, {
              required: true,
              text: isSpanish ? 'El instalador confirmó el daño existente' : 'Installer confirmed existing damage',
              errors: errors.siteDamageInstaller,
              onChange: _this.handleSiteDamageInstaller,
              checked: siteDamageInstaller
            }),
            react_default.a.createElement(components_CheckBox, {
              required: true,
              text: isSpanish ? 'El cliente confirmó el daño existente' : 'Customer confirmed existing damage',
              errors: errors.siteDamageCustomer,
              onChange: _this.handleSiteDamageCustomer,
              checked: siteDamageCustomer
            })
          ) : react_default.a.createElement(
            'h4',
            { className: modal_default.a.emptyModal },
            isSpanish ? 'No se necesita información adicional, continúe con las firmas' : 'No additional info needed, continue on to signatures'
          ),
          react_default.a.createElement(react_toolbox_lib["Button"], {
            label: isSpanish ? 'Próximo' : 'Next',
            flat: true, inverse: true, ripple: true,
            className: modal_default.a.submit,
            onClick: _this.handleSubmit
          }),
          react_default.a.createElement(react_toolbox_lib["Button"], {
            label: isSpanish ? 'Anterior' : 'Previous',
            flat: true, inverse: true, ripple: true,
            className: modal_default.a.submit,
            onClick: _this.handlePrevious
          })
        );
      }
    }), _temp), finalChecks__possibleConstructorReturn(_this, _ret);
  }

  return FinalChecks;
}(resetter(validator(react_default.a.Component)));

finalChecks_FinalChecks.propTypes = {
  isSpanish: prop_types_default.a.bool,
  step: prop_types_default.a.string,
  surfaceType: prop_types_default.a.string,
  hardSurfaceHomeTemp: prop_types_default.a.string,
  hardSurfaceAllMaterialsOnsite: prop_types_default.a.string,
  hardSurfaceMaterialDamage: prop_types_default.a.string,
  hardSurfaceMaterialDamageDetails: prop_types_default.a.string,
  siteDamageInstaller: prop_types_default.a.bool,
  siteDamageCustomer: prop_types_default.a.bool,
  siteDamageDetails: prop_types_default.a.string,
  errors: prop_types_default.a.shape({
    hardSurfaceAllMaterialsOnsite: prop_types_default.a.arrayOf(prop_types_default.a.string),
    hardSurfaceMaterialDamage: prop_types_default.a.arrayOf(prop_types_default.a.string),
    hardSurfaceMaterialDamageDetails: prop_types_default.a.arrayOf(prop_types_default.a.string),
    siteDamageInstaller: prop_types_default.a.arrayOf(prop_types_default.a.string),
    siteDamageCustomer: prop_types_default.a.arrayOf(prop_types_default.a.string),
    siteDamageDetails: prop_types_default.a.arrayOf(prop_types_default.a.string)
  })
};

/* harmony default export */ var finalChecks = (Object(react_redux_es["connect"])(function (state) {
  return { errors: Object(reducers["Y" /* getPhaseErrors */])(state) };
}, {})(finalChecks_FinalChecks));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/tasks/components/WalkthroughModal/installerSignature.jsx
function installerSignature__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function installerSignature__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function installerSignature__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var installerSignature_InstallerSignature = function (_Resetter) {
  installerSignature__inherits(InstallerSignature, _Resetter);

  function InstallerSignature() {
    var _ref;

    var _temp, _this, _ret;

    installerSignature__classCallCheck(this, InstallerSignature);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = installerSignature__possibleConstructorReturn(this, (_ref = InstallerSignature.__proto__ || Object.getPrototypeOf(InstallerSignature)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'state', {
      enumerable: true,
      writable: true,
      value: {
        installerSignature: _this.props.installerSignature || '',
        clearInstallerSignature: 0,
        errors: {}
      }
    }), Object.defineProperty(_this, 'installerSignatureRef', {
      enumerable: true,
      writable: true,
      value: react_default.a.createRef()
    }), Object.defineProperty(_this, 'componentDidMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.installerSignatureRef.current.scrollIntoView(false);
      }
    }), Object.defineProperty(_this, 'handleSubmit', {
      enumerable: true,
      writable: true,
      value: function value() {
        var checks = {
          installerSignature: true
        };
        if (!_this.validate(checks)) {
          return;
        }

        var installerSignature = _this.state.installerSignature;

        _this.props.updateFormData({
          installerSignature: installerSignature, tab: 7
        });
      }
    }), Object.defineProperty(_this, 'handlePrevious', {
      enumerable: true,
      writable: true,
      value: function value() {
        var tab = _this.props.step === 'pre' ? 5 : 4;
        var installerSignature = _this.state.installerSignature;

        _this.props.updateFormData({
          installerSignature: installerSignature, tab: tab
        });
      }
    }), Object.defineProperty(_this, 'handleInstallerSignature', {
      enumerable: true,
      writable: true,
      value: function value(data) {
        return _this.setState({ installerSignature: data });
      }
    }), Object.defineProperty(_this, 'handleInstallerClear', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.setState({
          installerSignature: '',
          clearInstallerSignature: _this.props.installerSignature ? _this.state.clearInstallerSignature : Date.now()
        });
        _this.props.updateFormData({ installerSignature: '' });
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            isSpanish = _this$props.isSpanish,
            installerSignature = _this$props.installerSignature;
        var _this$state = _this.state,
            errors = _this$state.errors,
            clearInstallerSignature = _this$state.clearInstallerSignature;


        return react_default.a.createElement(
          'div',
          { ref: _this.installerSignatureRef },
          react_default.a.createElement(
            'h6',
            null,
            isSpanish ? 'Firma del instalador' : 'Installer Signature'
          ),
          react_default.a.createElement(components_SignatureBox, {
            label: isSpanish ? 'Firmar el nombre del instalador*' : 'Sign Installer\'s Name*',
            required: true,
            value: installerSignature,
            errors: errors.installerSignature,
            clearTimestamp: clearInstallerSignature,
            onEnd: _this.handleInstallerSignature,
            onClear: _this.handleInstallerClear
          }),
          react_default.a.createElement(react_toolbox_lib["Button"], {
            label: isSpanish ? 'Próximo' : 'Next',
            flat: true, inverse: true, ripple: true,
            className: modal_default.a.submit,
            onClick: _this.handleSubmit
          }),
          react_default.a.createElement(react_toolbox_lib["Button"], {
            label: isSpanish ? 'Anterior' : 'Previous',
            flat: true, inverse: true, ripple: true,
            className: modal_default.a.submit,
            onClick: _this.handlePrevious
          })
        );
      }
    }), _temp), installerSignature__possibleConstructorReturn(_this, _ret);
  }

  return InstallerSignature;
}(resetter(validator(react_default.a.Component)));

installerSignature_InstallerSignature.propTypes = {
  step: prop_types_default.a.bool,
  isSpanish: prop_types_default.a.bool,
  installerSignature: prop_types_default.a.string,
  errors: prop_types_default.a.shape({
    installerSignature: prop_types_default.a.arrayOf(prop_types_default.a.string)
  })
};

/* harmony default export */ var WalkthroughModal_installerSignature = (Object(react_redux_es["connect"])(function (state) {
  return { errors: Object(reducers["Y" /* getPhaseErrors */])(state) };
}, {})(installerSignature_InstallerSignature));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/tasks/components/WalkthroughModal/customerSignature.jsx
function customerSignature__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function customerSignature__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function customerSignature__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var customerSignature_CustomerSignature = function (_Resetter) {
  customerSignature__inherits(CustomerSignature, _Resetter);

  function CustomerSignature() {
    var _ref;

    var _temp, _this, _ret;

    customerSignature__classCallCheck(this, CustomerSignature);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = customerSignature__possibleConstructorReturn(this, (_ref = CustomerSignature.__proto__ || Object.getPrototypeOf(CustomerSignature)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'state', {
      enumerable: true,
      writable: true,
      value: {
        customerSignature: _this.props.customerSignature || '',
        clearCustomerSignature: 0,
        errors: {},
        customerApprovedSignature: _this.props.customerApprovedSignature || false
      }
    }), Object.defineProperty(_this, 'customerSignatureRef', {
      enumerable: true,
      writable: true,
      value: react_default.a.createRef()
    }), Object.defineProperty(_this, 'componentDidMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.customerSignatureRef.current.scrollIntoView(false);
      }
    }), Object.defineProperty(_this, 'handleSubmit', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$state = _this.state,
            customerSignature = _this$state.customerSignature,
            customerApprovedSignature = _this$state.customerApprovedSignature;

        _this.props.updateFormData({
          customerSignature: customerSignature,
          customerApprovedSignature: customerApprovedSignature,
          tab: 8
        });
      }
    }), Object.defineProperty(_this, 'handlePrevious', {
      enumerable: true,
      writable: true,
      value: function value() {
        var customerSignature = _this.state.customerSignature;

        _this.props.updateFormData({
          customerSignature: customerSignature,
          customerApprovedSignature: _this.state.customerApprovedSignature,
          tab: 6
        });
      }
    }), Object.defineProperty(_this, 'handleCustomerSignature', {
      enumerable: true,
      writable: true,
      value: function value(data) {
        return _this.setState({ customerSignature: data });
      }
    }), Object.defineProperty(_this, 'handleCustomerClear', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.setState({
          customerSignature: '',
          clearCustomerSignature: _this.props.customerSignature ? _this.state.clearCustomerSignature : Date.now()
        });
        _this.props.updateFormData({ contractorSignature: '' });
      }
    }), Object.defineProperty(_this, 'handleCustomerApprovedSignature', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({
          customerApprovedSignature: !_this.state.customerApprovedSignature, customerSignature: ''
        });
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            isSpanish = _this$props.isSpanish,
            customerSignature = _this$props.customerSignature;
        var _this$state2 = _this.state,
            errors = _this$state2.errors,
            clearCustomerSignature = _this$state2.clearCustomerSignature,
            customerApprovedSignature = _this$state2.customerApprovedSignature;


        return react_default.a.createElement(
          'div',
          { ref: _this.customerSignatureRef },
          react_default.a.createElement(
            'h6',
            null,
            isSpanish ? 'Firma del cliente' : 'Customer Signature'
          ),
          react_default.a.createElement(components_CheckBox, {
            label: 'Customer Approved Signature',
            required: true,
            text: 'Customer verified complete, no signature due to COVID-19',
            errors: errors.approveTerms,
            onChange: _this.handleCustomerApprovedSignature,
            checked: _this.state.customerApprovedSignature
          }),
          !customerApprovedSignature && react_default.a.createElement(components_SignatureBox, {
            label: isSpanish ? 'Firmar el nombre del cliente*' : 'Sign Customer\'s Name*',
            required: true,
            value: customerSignature,
            errors: errors.customerSignature,
            clearTimestamp: clearCustomerSignature,
            onEnd: _this.handleCustomerSignature,
            onClear: _this.handleCustomerClear
          }),
          react_default.a.createElement(react_toolbox_lib["Button"], {
            label: isSpanish ? 'Completar' : 'Complete',
            flat: true, inverse: true, ripple: true,
            className: modal_default.a.submit,
            onClick: _this.handleSubmit
          }),
          react_default.a.createElement(react_toolbox_lib["Button"], {
            label: isSpanish ? 'Anterior' : 'Previous',
            flat: true, inverse: true, ripple: true,
            className: modal_default.a.submit,
            onClick: _this.handlePrevious
          })
        );
      }
    }), _temp), customerSignature__possibleConstructorReturn(_this, _ret);
  }

  return CustomerSignature;
}(resetter(validator(react_default.a.Component)));

customerSignature_CustomerSignature.propTypes = {
  isSpanish: prop_types_default.a.bool,
  customerSignature: prop_types_default.a.string,
  errors: prop_types_default.a.shape({
    customerSignature: prop_types_default.a.arrayOf(prop_types_default.a.string)
  })
};

/* harmony default export */ var WalkthroughModal_customerSignature = (Object(react_redux_es["connect"])(function (state) {
  return { errors: Object(reducers["Y" /* getPhaseErrors */])(state) };
}, {})(customerSignature_CustomerSignature));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/tasks/components/WalkthroughModal/index.jsx
var WalkthroughModal__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var WalkthroughModal__get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function WalkthroughModal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function WalkthroughModal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function WalkthroughModal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }























var WalkthroughModal_WalkthroughModal = function (_Resetter) {
  WalkthroughModal__inherits(WalkthroughModal, _Resetter);

  function WalkthroughModal() {
    var _ref;

    var _temp, _this, _ret;

    WalkthroughModal__classCallCheck(this, WalkthroughModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = WalkthroughModal__possibleConstructorReturn(this, (_ref = WalkthroughModal.__proto__ || Object.getPrototypeOf(WalkthroughModal)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'updateFormData', {
      enumerable: true,
      writable: true,
      value: function value(walkthroughData) {
        var _this$props = _this.props,
            phase = _this$props.phase,
            id = _this$props.phase.id;

        _this.setState(walkthroughData, function () {
          if (walkthroughData.tab === 8) {
            var _this$state = _this.state,
                installerInitials = _this$state.installerInitials,
                customerInitials = _this$state.customerInitials,
                installerParkedInStreet = _this$state.installerParkedInStreet,
                installerDrivewayPermission = _this$state.installerDrivewayPermission,
                installerProtectFromOil = _this$state.installerProtectFromOil,
                installerCarpetSeamPlacement = _this$state.installerCarpetSeamPlacement,
                installerCarpetSeamVisibility = _this$state.installerCarpetSeamVisibility,
                installerHardSurfaceMoistureReadings = _this$state.installerHardSurfaceMoistureReadings,
                installerActualReading = _this$state.installerActualReading,
                installerCarpetAllSeamsSealed = _this$state.installerCarpetAllSeamsSealed,
                installerCarpetVacuumed = _this$state.installerCarpetVacuumed,
                installerCarpetCleanedUp = _this$state.installerCarpetCleanedUp,
                customerMaterialsAndColor = _this$state.customerMaterialsAndColor,
                customerClimateControl = _this$state.customerClimateControl,
                customerCarpetSeamPlacement = _this$state.customerCarpetSeamPlacement,
                customerCarpetScuffs = _this$state.customerCarpetScuffs,
                customerHardSurfaceRoomsAndMoisture = _this$state.customerHardSurfaceRoomsAndMoisture,
                customerHardSurfaceMoistureBarrier = _this$state.customerHardSurfaceMoistureBarrier,
                customerCarpetSeamAndExcess = _this$state.customerCarpetSeamAndExcess,
                customerHardSurfaceTransition = _this$state.customerHardSurfaceTransition,
                customerHardSurfaceMaterial = _this$state.customerHardSurfaceMaterial,
                customerHardSurfaceFloorHeight = _this$state.customerHardSurfaceFloorHeight,
                customerHardSurfaceDoorCuts = _this$state.customerHardSurfaceDoorCuts,
                customerHardSurfaceWaste = _this$state.customerHardSurfaceWaste,
                hardSurfaceHomeTemp = _this$state.hardSurfaceHomeTemp,
                hardSurfaceAllMaterialsOnsite = _this$state.hardSurfaceAllMaterialsOnsite,
                hardSurfaceMaterialDamage = _this$state.hardSurfaceMaterialDamage,
                hardSurfaceMaterialDamageDetails = _this$state.hardSurfaceMaterialDamageDetails,
                siteDamageInstaller = _this$state.siteDamageInstaller,
                siteDamageCustomer = _this$state.siteDamageCustomer,
                siteDamageDetails = _this$state.siteDamageDetails,
                installerName = _this$state.installerName,
                installerSignature = _this$state.installerSignature,
                customerName = _this$state.customerName,
                customerSignature = _this$state.customerSignature,
                installerCarpetPowerStretched = _this$state.installerCarpetPowerStretched,
                customerCarpetRoomsToBeInstalled = _this$state.customerCarpetRoomsToBeInstalled,
                customerHardSurfaceMolding = _this$state.customerHardSurfaceMolding,
                customerApprovedSignature = _this$state.customerApprovedSignature,
                leadResponseReason = _this$state.leadResponseReason,
                leadPracticesReq = _this$state.leadPracticesReq,
                excessMaterials = _this$state.excessMaterials,
                step = _this$state.step;


            _this.props.walkthroughCreate({
              installer_initials: installerInitials,
              installer_name: installerName,
              installer_signature: installerSignature,

              installer_parked_in_street: installerParkedInStreet,
              installer_driveway_permission: installerDrivewayPermission,
              installer_protect_from_oil: installerProtectFromOil,
              installer_carpet_seam_placement: installerCarpetSeamPlacement,
              installer_carpet_seam_visibility: installerCarpetSeamVisibility,
              installer_hard_surface_moisture_readings: installerHardSurfaceMoistureReadings,
              installer_actual_reading: installerActualReading,

              installer_carpet_all_seams_sealed: installerCarpetAllSeamsSealed,
              installer_carpet_power_stretched: installerCarpetPowerStretched,
              installer_carpet_vacuumed: installerCarpetVacuumed,
              installer_carpet_cleaned_up: installerCarpetCleanedUp,

              customer_initials: customerInitials,
              customer_name: customerName,
              customer_signature: customerSignature,
              customer_approved_signature: customerApprovedSignature,

              customer_materials_and_color: customerMaterialsAndColor,
              customer_climate_control: customerClimateControl,
              customer_carpet_seam_placement: customerCarpetSeamPlacement,
              customer_carpet_rooms_to_be_installed: customerCarpetRoomsToBeInstalled,
              customer_carpet_scuffs: customerCarpetScuffs,
              customer_hard_surface_rooms_and_moisture: customerHardSurfaceRoomsAndMoisture,
              customer_hard_surface_moisture_barrier: customerHardSurfaceMoistureBarrier,

              customer_carpet_seam_and_excess: customerCarpetSeamAndExcess,
              customer_hard_surface_transition: customerHardSurfaceTransition,
              customer_hard_surface_molding: customerHardSurfaceMolding,
              customer_hard_surface_material: customerHardSurfaceMaterial,
              customer_hard_surface_floor_height: customerHardSurfaceFloorHeight,
              customer_hard_surface_door_cuts: customerHardSurfaceDoorCuts,
              customer_hard_surface_waste: customerHardSurfaceWaste,

              hard_surface_home_temp: hardSurfaceHomeTemp,
              hard_surface_all_materials_onsite: hardSurfaceAllMaterialsOnsite,
              hard_surface_material_damage: hardSurfaceMaterialDamage,
              hard_surface_material_damage_details: hardSurfaceMaterialDamageDetails,
              site_damage_details: siteDamageDetails,
              site_damage_installer: siteDamageInstaller,
              site_damage_customer: siteDamageCustomer,

              lead_response_reason: leadResponseReason,
              lead_practices_required: leadPracticesReq,

              excess_materials: excessMaterials,

              surface_type: _this.determineSurfaceType(phase),
              step: step,
              phase_id: id,
              is_walkthrough: true
            }).then(function () {
              _this.handleClose();
            }).catch(function () {});
          }
        });
      }
    }), Object.defineProperty(_this, 'handleLanguageChange', {
      enumerable: true,
      writable: true,
      value: function value(val) {
        return _this.setState({ isSpanish: val });
      }
    }), Object.defineProperty(_this, 'determineSurfaceType', {
      enumerable: true,
      writable: true,
      value: function value(phase) {
        if (Object(lodash["isUndefined"])(phase.surface_type) || Object(lodash["isNull"])(phase.surface_type)) return '';
        return phase.surface_type.name.toLowerCase() === 'carpet' ? 'carpet' : 'hard_surface';
      }
    }), Object.defineProperty(_this, 'determineSurfaceTypeTitle', {
      enumerable: true,
      writable: true,
      value: function value(surfaceType) {
        if (!surfaceType) return ' ';
        return surfaceType.toLowerCase() === 'carpet' ? ' Carpet ' : ' Hard Surface ';
      }
    }), Object.defineProperty(_this, 'showTab', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props2 = _this.props,
            phase = _this$props2.phase,
            showLeadQuestion = _this$props2.showLeadQuestion;
        var _this$state2 = _this.state,
            step = _this$state2.step,
            isSpanish = _this$state2.isSpanish,
            installerInitials = _this$state2.installerInitials,
            customerInitials = _this$state2.customerInitials,
            installerParkedInStreet = _this$state2.installerParkedInStreet,
            installerDrivewayPermission = _this$state2.installerDrivewayPermission,
            installerProtectFromOil = _this$state2.installerProtectFromOil,
            installerCarpetSeamPlacement = _this$state2.installerCarpetSeamPlacement,
            installerCarpetSeamVisibility = _this$state2.installerCarpetSeamVisibility,
            installerHardSurfaceMoistureReadings = _this$state2.installerHardSurfaceMoistureReadings,
            installerActualReading = _this$state2.installerActualReading,
            installerCarpetAllSeamsSealed = _this$state2.installerCarpetAllSeamsSealed,
            installerCarpetPowerStretched = _this$state2.installerCarpetPowerStretched,
            installerCarpetVacuumed = _this$state2.installerCarpetVacuumed,
            installerCarpetCleanedUp = _this$state2.installerCarpetCleanedUp,
            customerMaterialsAndColor = _this$state2.customerMaterialsAndColor,
            customerClimateControl = _this$state2.customerClimateControl,
            customerCarpetSeamPlacement = _this$state2.customerCarpetSeamPlacement,
            customerCarpetRoomsToBeInstalled = _this$state2.customerCarpetRoomsToBeInstalled,
            customerCarpetScuffs = _this$state2.customerCarpetScuffs,
            customerHardSurfaceRoomsAndMoisture = _this$state2.customerHardSurfaceRoomsAndMoisture,
            customerHardSurfaceMoistureBarrier = _this$state2.customerHardSurfaceMoistureBarrier,
            customerCarpetSeamAndExcess = _this$state2.customerCarpetSeamAndExcess,
            customerHardSurfaceTransition = _this$state2.customerHardSurfaceTransition,
            customerHardSurfaceMolding = _this$state2.customerHardSurfaceMolding,
            customerHardSurfaceMaterial = _this$state2.customerHardSurfaceMaterial,
            customerHardSurfaceFloorHeight = _this$state2.customerHardSurfaceFloorHeight,
            customerHardSurfaceDoorCuts = _this$state2.customerHardSurfaceDoorCuts,
            customerHardSurfaceWaste = _this$state2.customerHardSurfaceWaste,
            hardSurfaceHomeTemp = _this$state2.hardSurfaceHomeTemp,
            hardSurfaceAllMaterialsOnsite = _this$state2.hardSurfaceAllMaterialsOnsite,
            hardSurfaceMaterialDamage = _this$state2.hardSurfaceMaterialDamage,
            hardSurfaceMaterialDamageDetails = _this$state2.hardSurfaceMaterialDamageDetails,
            siteDamageInstaller = _this$state2.siteDamageInstaller,
            siteDamageCustomer = _this$state2.siteDamageCustomer,
            siteDamageDetails = _this$state2.siteDamageDetails,
            installerName = _this$state2.installerName,
            installerSignature = _this$state2.installerSignature,
            customerName = _this$state2.customerName,
            customerSignature = _this$state2.customerSignature,
            sixSquareFeetRemoved = _this$state2.sixSquareFeetRemoved,
            homeOlderThan1978 = _this$state2.homeOlderThan1978,
            tab = _this$state2.tab,
            leadResponseReason = _this$state2.leadResponseReason,
            leadPracticesReq = _this$state2.leadPracticesReq,
            excessMaterials = _this$state2.excessMaterials;

        var surfaceType = _this.determineSurfaceType(phase);
        if (!surfaceType) return _this.renderNoSurfaceTypeMessage();
        switch (tab) {
          case 1:
            return react_default.a.createElement(initialInfo, {
              isSpanish: isSpanish,
              phase: phase,
              updateFormData: _this.updateFormData,
              installerInitials: installerInitials,
              customerName: customerName,
              customerInitials: customerInitials,
              installerName: installerName,
              surfaceType: surfaceType,
              step: step
            });
          case 2:
            if (step === 'pre') {
              return react_default.a.createElement(installerPreWalkthrough, {
                isSpanish: isSpanish,
                phase: phase,
                updateFormData: _this.updateFormData,
                surfaceType: surfaceType,
                installerParkedInStreet: installerParkedInStreet,
                installerDrivewayPermission: installerDrivewayPermission,
                installerProtectFromOil: installerProtectFromOil,
                installerCarpetSeamPlacement: installerCarpetSeamPlacement,
                installerCarpetSeamVisibility: installerCarpetSeamVisibility,
                installerHardSurfaceMoistureReadings: installerHardSurfaceMoistureReadings,
                installerActualReading: installerActualReading
              });
            }
            return react_default.a.createElement(installerPostWalkthrough, {
              isSpanish: isSpanish,
              phase: phase,
              updateFormData: _this.updateFormData,
              installerCarpetAllSeamsSealed: installerCarpetAllSeamsSealed,
              installerCarpetPowerStretched: installerCarpetPowerStretched,
              installerCarpetVacuumed: installerCarpetVacuumed,
              installerCarpetCleanedUp: installerCarpetCleanedUp
            });
          case 3:
            if (step === 'pre') {
              return react_default.a.createElement(customerPreWalkthrough, {
                isSpanish: isSpanish,
                phase: phase,
                updateFormData: _this.updateFormData,
                surfaceType: surfaceType,
                customerMaterialsAndColor: customerMaterialsAndColor,
                customerClimateControl: customerClimateControl,
                customerCarpetSeamPlacement: customerCarpetSeamPlacement,
                customerCarpetRoomsToBeInstalled: customerCarpetRoomsToBeInstalled,
                customerCarpetScuffs: customerCarpetScuffs,
                customerHardSurfaceRoomsAndMoisture: customerHardSurfaceRoomsAndMoisture,
                customerHardSurfaceMoistureBarrier: customerHardSurfaceMoistureBarrier
              });
            }
            return react_default.a.createElement(customerPostWalkthrough, {
              isSpanish: isSpanish,
              phase: phase,
              updateFormData: _this.updateFormData,
              surfaceType: surfaceType,
              customerCarpetSeamAndExcess: customerCarpetSeamAndExcess,
              customerHardSurfaceTransition: customerHardSurfaceTransition,
              customerHardSurfaceMolding: customerHardSurfaceMolding,
              customerHardSurfaceMaterial: customerHardSurfaceMaterial,
              customerHardSurfaceFloorHeight: customerHardSurfaceFloorHeight,
              customerHardSurfaceDoorCuts: customerHardSurfaceDoorCuts,
              customerHardSurfaceWaste: customerHardSurfaceWaste
            });
          case 4:
            return react_default.a.createElement(SignCocModal_surplus_material, {
              isSpanish: isSpanish,
              phase: phase,
              updateFormData: _this.updateFormData,
              excessMaterials: excessMaterials
            });
          case 5:
            return react_default.a.createElement(finalChecks, {
              isSpanish: isSpanish,
              phase: phase,
              updateFormData: _this.updateFormData,
              step: step,
              showLeadQuestion: showLeadQuestion,
              sixSquareFeetRemoved: sixSquareFeetRemoved,
              homeOlderThan1978: homeOlderThan1978,
              surfaceType: surfaceType,
              hardSurfaceHomeTemp: hardSurfaceHomeTemp,
              hardSurfaceAllMaterialsOnsite: hardSurfaceAllMaterialsOnsite,
              hardSurfaceMaterialDamage: hardSurfaceMaterialDamage,
              hardSurfaceMaterialDamageDetails: hardSurfaceMaterialDamageDetails,
              siteDamageInstaller: siteDamageInstaller,
              siteDamageCustomer: siteDamageCustomer,
              siteDamageDetails: siteDamageDetails,
              leadResponseReason: leadResponseReason,
              leadPracticesReq: leadPracticesReq
            });
          case 6:
            return react_default.a.createElement(WalkthroughModal_installerSignature, {
              isSpanish: isSpanish,
              phase: phase,
              step: step,
              updateFormData: _this.updateFormData,
              installerSignature: installerSignature
            });
          case 7:
            return react_default.a.createElement(WalkthroughModal_customerSignature, {
              isSpanish: isSpanish,
              phase: phase,
              updateFormData: _this.updateFormData,
              customerSignature: customerSignature
            });
          default:
            return react_default.a.createElement(components_Loading, null);
        }
      }
    }), Object.defineProperty(_this, 'renderNoSurfaceTypeMessage', {
      enumerable: true,
      writable: true,
      value: function value() {
        return react_default.a.createElement(
          'div',
          { className: modal_default.a.emptyModal },
          'This phase requires a surface type to complete a walkthrough'
        );
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props3 = _this.props,
            active = _this$props3.active,
            serverErrors = _this$props3.errors,
            phase = _this$props3.phase;
        var _this$state3 = _this.state,
            isSpanish = _this$state3.isSpanish,
            step = _this$state3.step;

        var surfaceType = _this.determineSurfaceType(phase);
        var surfaceTypeTitle = _this.determineSurfaceTypeTitle(surfaceType);

        return react_default.a.createElement(
          react_toolbox_lib["Dialog"],
          {
            active: active, className: modal_default.a.modal, type: 'fullscreen',
            onEscKeyDown: _this.handleClose, onOverlayClick: _this.handleClose
          },
          react_default.a.createElement(
            'div',
            { className: input_default.a.errored },
            Object.keys(serverErrors).length > 0 && react_default.a.createElement(
              'span',
              { className: input_default.a.error },
              'This action could not be completed.'
            )
          ),
          react_default.a.createElement(react_toolbox_lib["IconButton"], { icon: 'close', className: modal_default.a.close, onClick: _this.handleClose }),
          react_default.a.createElement(
            'h5',
            null,
            'Sign',
            surfaceTypeTitle,
            step ? Object(lodash["upperFirst"])(step) + '-Walkthrough ' : 'Walkthrough ',
            'Form'
          ),
          react_default.a.createElement(react_toolbox_lib["Switch"], {
            checked: isSpanish,
            label: '\xBFEn espa\xF1ol?',
            onChange: _this.handleLanguageChange
          }),
          _this.showTab()
        );
      }
    }), _temp), WalkthroughModal__possibleConstructorReturn(_this, _ret);
  }

  WalkthroughModal__createClass(WalkthroughModal, [{
    key: 'handleClose',
    value: function handleClose() {
      WalkthroughModal__get(WalkthroughModal.prototype.__proto__ || Object.getPrototypeOf(WalkthroughModal.prototype), 'handleClose', this).call(this);
      this.props.clearValidation();
      document.location.reload();
    }
  }]);

  return WalkthroughModal;
}(resetter(validator(react_default.a.Component)));

Object.defineProperty(WalkthroughModal_WalkthroughModal, 'DEFAULT_STATE', {
  enumerable: true,
  writable: true,
  value: {
    installerInitials: '',
    installerName: '',
    installerSignature: '',

    installerParkedInStreet: false,
    installerDrivewayPermission: false,
    installerProtectFromOil: false,
    installerCarpetSeamPlacement: false,
    installerCarpetSeamVisibility: false,
    installerHardSurfaceMoistureReadings: false,
    installerActualReading: '',

    installerCarpetAllSeamsSealed: false,
    installerCarpetPowerStretched: false,
    installerCarpetVacuumed: false,
    installerCarpetCleanedUp: false,

    customerInitials: '',
    customerName: '',
    customerSignature: '',
    customerApprovedSignature: false,

    customerMaterialsAndColor: false,
    customerClimateControl: false,
    customerCarpetSeamPlacement: false,
    customerCarpetRoomsToBeInstalled: false,
    customerCarpetScuffs: false,
    customerHardSurfaceRoomsAndMoisture: false,
    customerHardSurfaceMoistureBarrier: false,

    customerCarpetSeamAndExcess: false,
    customerHardSurfaceTransition: false,
    customerHardSurfaceMolding: false,
    customerHardSurfaceMaterial: false,
    customerHardSurfaceFloorHeight: false,
    customerHardSurfaceDoorCuts: false,
    customerHardSurfaceWaste: false,

    hardSurfaceHomeTemp: '',
    hardSurfaceAllMaterialsOnsite: '',
    hardSurfaceMaterialDamage: '',
    hardSurfaceMaterialDamageDetails: '',
    siteDamageInstaller: false,
    siteDamageCustomer: false,
    siteDamageDetails: '',
    sixSquareFeetRemoved: '',
    homeOlderThan1978: '',
    leadResponseReason: '',
    leadPracticesReq: false,

    excessMaterials: 'NO_EXCESS_MATERIALS',

    errors: {},
    tab: 1,
    isSpanish: false,
    step: ''
  }
});
Object.defineProperty(WalkthroughModal_WalkthroughModal, 'VALIDATIONS', {
  enumerable: true,
  writable: true,
  value: {
    installerInitials: true,
    installerName: true,
    installerSignature: true
  }
});


WalkthroughModal_WalkthroughModal.propTypes = {
  active: prop_types_default.a.bool.isRequired,
  clearValidation: prop_types_default.a.func.isRequired,
  walkthroughCreate: prop_types_default.a.func.isRequired,
  onClose: prop_types_default.a.func.isRequired,
  phase: types_phase.isRequired,
  showLeadQuestion: prop_types_default.a.bool,
  errors: prop_types_default.a.shape({
    signature: prop_types_default.a.arrayOf(prop_types_default.a.string),
    name: prop_types_default.a.arrayOf(prop_types_default.a.string)
  })
};

WalkthroughModal_WalkthroughModal.defaultProps = {
  active: false,
  showLeadQuestion: false
};

/* harmony default export */ var components_WalkthroughModal = (Object(react_redux_es["connect"])(function (state) {
  return { errors: state.walkthroughs.uploadError };
}, {
  clearValidation: actionCreators["j" /* clearValidation */],
  walkthroughCreate: actionCreators["_81" /* walkthroughCreate */]
})(WalkthroughModal_WalkthroughModal));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/repairInspection/locationInfo.jsx
function locationInfo__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function locationInfo__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function locationInfo__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var locationInfo_LocationInfo = function (_Resetter) {
  locationInfo__inherits(LocationInfo, _Resetter);

  function LocationInfo(props) {
    locationInfo__classCallCheck(this, LocationInfo);

    var _this = locationInfo__possibleConstructorReturn(this, (LocationInfo.__proto__ || Object.getPrototypeOf(LocationInfo)).call(this, props));

    locationInfo__initialiseProps.call(_this);

    var _this$props = _this.props,
        _this$props$inspectio = _this$props.inspectionType,
        inspectionType = _this$props$inspectio === undefined ? '' : _this$props$inspectio,
        _this$props$subfloorT = _this$props.subfloorType,
        subfloorType = _this$props$subfloorT === undefined ? '' : _this$props$subfloorT,
        _this$props$moisture = _this$props.moisture,
        moisture = _this$props$moisture === undefined ? 'N/A' : _this$props$moisture,
        _this$props$petsPrese = _this$props.petsPresent,
        petsPresent = _this$props$petsPrese === undefined ? 'N/A' : _this$props$petsPrese,
        _this$props$cleaningP = _this$props.cleaningPractices,
        cleaningPractices = _this$props$cleaningP === undefined ? 'N/A' : _this$props$cleaningP;

    _this.state = {
      inspectionType: inspectionType,
      subfloorType: subfloorType,
      moisture: moisture,
      petsPresent: petsPresent,
      cleaningPractices: cleaningPractices,
      errors: {}
    };
    return _this;
  }

  return LocationInfo;
}(resetter(validator(react_default.a.Component)));

Object.defineProperty(locationInfo_LocationInfo, 'VALIDATIONS', {
  enumerable: true,
  writable: true,
  value: {
    inspectionType: true,
    subfloorType: true,
    moisture: true,
    petsPresent: true,
    cleaningPractices: true
  }
});

var locationInfo__initialiseProps = function _initialiseProps() {
  var _this2 = this;

  Object.defineProperty(this, 'handleSubmit', {
    enumerable: true,
    writable: true,
    value: function value() {
      if (!_this2.validate()) {
        return;
      }
      var _state = _this2.state,
          inspectionType = _state.inspectionType,
          subfloorType = _state.subfloorType,
          moisture = _state.moisture,
          petsPresent = _state.petsPresent,
          cleaningPractices = _state.cleaningPractices;

      _this2.props.updateFormData({
        inspectionType: inspectionType, subfloorType: subfloorType, moisture: moisture, petsPresent: petsPresent, cleaningPractices: cleaningPractices, tab: 2
      });
    }
  });
  Object.defineProperty(this, 'handleInspectionType', {
    enumerable: true,
    writable: true,
    value: function value(_value) {
      return _this2.setState({ inspectionType: _value });
    }
  });
  Object.defineProperty(this, 'handleSubfloorType', {
    enumerable: true,
    writable: true,
    value: function value(_value2) {
      return _this2.setState({ subfloorType: _value2 });
    }
  });
  Object.defineProperty(this, 'handleMoisture', {
    enumerable: true,
    writable: true,
    value: function value(e) {
      return _this2.setState({ moisture: e.target.value });
    }
  });
  Object.defineProperty(this, 'handlePetsPresent', {
    enumerable: true,
    writable: true,
    value: function value(e) {
      return _this2.setState({ petsPresent: e.target.value });
    }
  });
  Object.defineProperty(this, 'handleCleaningPractices', {
    enumerable: true,
    writable: true,
    value: function value(e) {
      return _this2.setState({ cleaningPractices: e.target.value });
    }
  });
  Object.defineProperty(this, 'render', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _state2 = _this2.state,
          inspectionType = _state2.inspectionType,
          subfloorType = _state2.subfloorType,
          moisture = _state2.moisture,
          petsPresent = _state2.petsPresent,
          cleaningPractices = _state2.cleaningPractices,
          errors = _state2.errors;

      var subfloorOptions = [{ value: 'Wood', label: 'Wood' }, { value: 'Concrete', label: 'Concrete' }, { value: 'Combination', label: 'Combination' }, { value: 'Other', label: 'Other' }];
      return react_default.a.createElement(
        'div',
        null,
        react_default.a.createElement(
          'h6',
          { className: modal_default.a.signatureTitle },
          'Location Info'
        ),
        react_default.a.createElement(components_RadioButtons, {
          text: 'Is the inspection onsite or virtual?',
          required: true,
          selectedValue: inspectionType,
          onChange: _this2.handleInspectionType,
          radioButtons: [{ label: 'Onsite', value: 'Onsite' }, { label: 'Virtual', value: 'Virtual' }]
        }),
        react_default.a.createElement(components_StyledSelect, {
          className: modal_default.a.select,
          label: 'Subfloor Type',
          onChange: _this2.handleSubfloorType,
          options: subfloorOptions,
          value: subfloorType,
          placeholder: 'Select',
          error: errors.subfloorType,
          required: true
        }),
        react_default.a.createElement(components_SimpleInput, {
          label: 'Moisture*',
          required: true,
          text: moisture,
          errors: errors.moisture,
          onChange: _this2.handleMoisture
        }),
        react_default.a.createElement(components_SimpleInput, {
          label: 'Pets Present*',
          required: true,
          text: petsPresent,
          errors: errors.petsPresent,
          onChange: _this2.handlePetsPresent
        }),
        react_default.a.createElement(components_SimpleInput, {
          label: 'Cleaning Practices*',
          required: true,
          text: cleaningPractices,
          errors: errors.cleaningPractices,
          onChange: _this2.handleCleaningPractices
        }),
        react_default.a.createElement(react_toolbox_lib["Button"], { label: 'Next', flat: true, inverse: true, ripple: true, className: modal_default.a.submit, onClick: _this2.handleSubmit })
      );
    }
  });
};

locationInfo_LocationInfo.propTypes = {
  subfloorType: prop_types_default.a.string,
  moisture: prop_types_default.a.string,
  petsPresent: prop_types_default.a.string,
  cleaningPractices: prop_types_default.a.string,
  errors: prop_types_default.a.shape({
    subfloorType: prop_types_default.a.arrayOf(prop_types_default.a.string),
    moisture: prop_types_default.a.arrayOf(prop_types_default.a.string),
    petsPresent: prop_types_default.a.arrayOf(prop_types_default.a.string),
    cleaningPractices: prop_types_default.a.arrayOf(prop_types_default.a.string)
  })
};

/* harmony default export */ var locationInfo = (Object(react_redux_es["connect"])(function (state) {
  return { errors: Object(reducers["Y" /* getPhaseErrors */])(state) };
}, {})(locationInfo_LocationInfo));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/repairInspection/concernsAndResults.jsx
function concernsAndResults__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function concernsAndResults__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function concernsAndResults__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var ConcernsAndResults = function (_Resetter) {
  concernsAndResults__inherits(ConcernsAndResults, _Resetter);

  function ConcernsAndResults(props) {
    concernsAndResults__classCallCheck(this, ConcernsAndResults);

    var _this = concernsAndResults__possibleConstructorReturn(this, (ConcernsAndResults.__proto__ || Object.getPrototypeOf(ConcernsAndResults)).call(this, props));

    concernsAndResults__initialiseProps.call(_this);

    var _this$props = _this.props,
        _this$props$customerC = _this$props.customerConcerns,
        customerConcerns = _this$props$customerC === undefined ? 'N/A' : _this$props$customerC,
        _this$props$inspector = _this$props.inspectorName,
        inspectorName = _this$props$inspector === undefined ? '' : _this$props$inspector,
        _this$props$installer = _this$props.installerName,
        installerName = _this$props$installer === undefined ? '' : _this$props$installer,
        _this$props$inspectio = _this$props.inspectionResults,
        inspectionResults = _this$props$inspectio === undefined ? 'N/A' : _this$props$inspectio,
        _this$props$locationO = _this$props.locationOfConcern,
        locationOfConcern = _this$props$locationO === undefined ? '' : _this$props$locationO,
        _this$props$materials = _this$props.materialsLeftOver,
        materialsLeftOver = _this$props$materials === undefined ? '' : _this$props$materials;

    _this.state = {
      customerConcerns: customerConcerns,
      inspectorName: inspectorName,
      installerName: installerName,
      inspectionResults: inspectionResults,
      locationOfConcern: locationOfConcern,
      materialsLeftOver: materialsLeftOver,
      errors: {}
    };
    return _this;
  }

  return ConcernsAndResults;
}(resetter(validator(react_default.a.Component)));

Object.defineProperty(ConcernsAndResults, 'VALIDATIONS', {
  enumerable: true,
  writable: true,
  value: {
    customerConcerns: true,
    inspectorName: true,
    installerName: true,
    inspectionResults: true,
    locationOfConcern: true,
    materialsLeftOver: true
  }
});

var concernsAndResults__initialiseProps = function _initialiseProps() {
  var _this2 = this;

  Object.defineProperty(this, 'handleSubmit', {
    enumerable: true,
    writable: true,
    value: function value(tab) {
      if (tab === 3 && !_this2.validate()) return;
      var _state = _this2.state,
          customerConcerns = _state.customerConcerns,
          inspectorName = _state.inspectorName,
          installerName = _state.installerName,
          inspectionResults = _state.inspectionResults,
          locationOfConcern = _state.locationOfConcern,
          materialsLeftOver = _state.materialsLeftOver;

      _this2.props.updateFormData({
        customerConcerns: customerConcerns,
        inspectorName: inspectorName,
        installerName: installerName,
        inspectionResults: inspectionResults,
        locationOfConcern: locationOfConcern,
        materialsLeftOver: materialsLeftOver,
        tab: tab
      });
    }
  });
  Object.defineProperty(this, 'handleNext', {
    enumerable: true,
    writable: true,
    value: function value() {
      return _this2.handleSubmit(3);
    }
  });
  Object.defineProperty(this, 'handlePrevious', {
    enumerable: true,
    writable: true,
    value: function value() {
      return _this2.handleSubmit(1);
    }
  });
  Object.defineProperty(this, 'handleCustomerConcerns', {
    enumerable: true,
    writable: true,
    value: function value(e) {
      return _this2.setState({ customerConcerns: e.target.value });
    }
  });
  Object.defineProperty(this, 'handleInspectorName', {
    enumerable: true,
    writable: true,
    value: function value(e) {
      return _this2.setState({ inspectorName: e.target.value });
    }
  });
  Object.defineProperty(this, 'handleInstallerName', {
    enumerable: true,
    writable: true,
    value: function value(e) {
      return _this2.setState({ installerName: e.target.value });
    }
  });
  Object.defineProperty(this, 'handleInspectionResults', {
    enumerable: true,
    writable: true,
    value: function value(e) {
      return _this2.setState({ inspectionResults: e.target.value });
    }
  });
  Object.defineProperty(this, 'handleLocationOfConcern', {
    enumerable: true,
    writable: true,
    value: function value(e) {
      return _this2.setState({ locationOfConcern: e.target.value });
    }
  });
  Object.defineProperty(this, 'handleMaterialsLeftOver', {
    enumerable: true,
    writable: true,
    value: function value(e) {
      return _this2.setState({ materialsLeftOver: e.target.value });
    }
  });
  Object.defineProperty(this, 'render', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _state2 = _this2.state,
          customerConcerns = _state2.customerConcerns,
          inspectorName = _state2.inspectorName,
          installerName = _state2.installerName,
          inspectionResults = _state2.inspectionResults,
          locationOfConcern = _state2.locationOfConcern,
          materialsLeftOver = _state2.materialsLeftOver,
          errors = _state2.errors;

      return react_default.a.createElement(
        'div',
        null,
        react_default.a.createElement(
          'h6',
          { className: modal_default.a.signatureTitle },
          'Concerns & Results'
        ),
        react_default.a.createElement(components_TextArea, {
          label: 'Customer Concerns *',
          value: customerConcerns,
          errors: errors.customerConcerns,
          onChange: _this2.handleCustomerConcerns,
          autoFocus: true
        }),
        react_default.a.createElement(components_TextArea, {
          label: 'Location Of The Concern *',
          value: locationOfConcern,
          errors: errors.locationOfConcern,
          onChange: _this2.handleLocationOfConcern,
          autoFocus: true
        }),
        react_default.a.createElement(components_TextArea, {
          label: 'List any materials left over from the installation that can be used for the repair *',
          value: materialsLeftOver,
          errors: errors.materialsLeftOver,
          onChange: _this2.handleMaterialsLeftOver,
          autoFocus: true
        }),
        react_default.a.createElement(components_SimpleInput, {
          label: 'Inspector Name*',
          required: true,
          text: inspectorName,
          errors: errors.inspectorName,
          onChange: _this2.handleInspectorName
        }),
        react_default.a.createElement(components_SimpleInput, {
          label: 'Installer Name*',
          required: true,
          text: installerName,
          errors: errors.installerName,
          onChange: _this2.handleInstallerName
        }),
        react_default.a.createElement(components_TextArea, {
          label: 'Inspection Results*',
          value: inspectionResults,
          errors: errors.inspectionResults,
          onChange: _this2.handleInspectionResults,
          autoFocus: true
        }),
        react_default.a.createElement(react_toolbox_lib["Button"], { label: 'Next', flat: true, inverse: true, ripple: true, className: modal_default.a.submit, onClick: _this2.handleNext }),
        react_default.a.createElement(react_toolbox_lib["Button"], { label: 'Previous', flat: true, inverse: true, ripple: true, className: modal_default.a.submit, onClick: _this2.handlePrevious })
      );
    }
  });
};

ConcernsAndResults.propTypes = {
  customerConcerns: prop_types_default.a.string,
  inspectorName: prop_types_default.a.string,
  locationOfConcern: prop_types_default.a.string,
  materialsLeftOver: prop_types_default.a.string,
  installerName: prop_types_default.a.string,
  inspectionResults: prop_types_default.a.string,
  errors: prop_types_default.a.shape({
    customerConcerns: prop_types_default.a.arrayOf(prop_types_default.a.string),
    inspectorName: prop_types_default.a.arrayOf(prop_types_default.a.string),
    installerName: prop_types_default.a.arrayOf(prop_types_default.a.string),
    inspectionResults: prop_types_default.a.arrayOf(prop_types_default.a.string),
    locationOfConcern: prop_types_default.a.arrayOf(prop_types_default.a.string),
    materialsLeftOver: prop_types_default.a.arrayOf(prop_types_default.a.string)
  })
};

/* harmony default export */ var concernsAndResults = (Object(react_redux_es["connect"])(function (state) {
  return { errors: Object(reducers["Y" /* getPhaseErrors */])(state) };
}, {})(ConcernsAndResults));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/repairInspection/materialsNeeded.jsx
function materialsNeeded__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function materialsNeeded__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function materialsNeeded__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var materialsNeeded_MaterialsNeeded = function (_Resetter) {
  materialsNeeded__inherits(MaterialsNeeded, _Resetter);

  function MaterialsNeeded(props) {
    materialsNeeded__classCallCheck(this, MaterialsNeeded);

    var _this = materialsNeeded__possibleConstructorReturn(this, (MaterialsNeeded.__proto__ || Object.getPrototypeOf(MaterialsNeeded)).call(this, props));

    Object.defineProperty(_this, 'handleSubmit', {
      enumerable: true,
      writable: true,
      value: function value(tab) {
        return _this.props.updateFormData({
          materialsNeeded: _this.state.materialsNeeded, tab: tab
        });
      }
    });
    Object.defineProperty(_this, 'handleFinish', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.handleSubmit(4);
      }
    });
    Object.defineProperty(_this, 'handlePrevious', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.handleSubmit(2);
      }
    });
    Object.defineProperty(_this, 'handleAddRow', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        e.preventDefault();
        _this.setState({
          addRow: !_this.state.addRow,
          itemNumber: '',
          itemDescription: '',
          itemQuantity: ''
        });
      }
    });
    Object.defineProperty(_this, 'handleCustomerInitials', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        return _this.setState({ customerInitials: e.target.value });
      }
    });
    Object.defineProperty(_this, 'handleItemNumber', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        return _this.setState({ itemNumber: e.target.value });
      }
    });
    Object.defineProperty(_this, 'handleItemDescription', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        return _this.setState({ itemDescription: e.target.value });
      }
    });
    Object.defineProperty(_this, 'handleItemQuantity', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        return _this.setState({ itemQuantity: e.target.value });
      }
    });
    Object.defineProperty(_this, 'handleSave', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        e.preventDefault();
        var _this$state = _this.state,
            materialsNeeded = _this$state.materialsNeeded,
            itemNumber = _this$state.itemNumber,
            itemDescription = _this$state.itemDescription,
            itemQuantity = _this$state.itemQuantity;

        materialsNeeded.push({
          item_number: itemNumber,
          item_description: itemDescription,
          item_quantity: itemQuantity
        });
        _this.setState({
          itemNumber: '',
          itemDescription: '',
          itemQuantity: '',
          materialsNeeded: materialsNeeded
        });
      }
    });
    Object.defineProperty(_this, 'handleDelete', {
      enumerable: true,
      writable: true,
      value: function value(itemNumber) {
        return function (e) {
          e.preventDefault();
          var materialsNeeded = _this.state.materialsNeeded;
          var filteredMaterials = Object(lodash["filter"])(materialsNeeded, function (material) {
            return material.item_number !== itemNumber;
          });
          _this.setState({ materialsNeeded: filteredMaterials });
        };
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$state2 = _this.state,
            materialsNeeded = _this$state2.materialsNeeded,
            addRow = _this$state2.addRow,
            itemNumber = _this$state2.itemNumber,
            itemDescription = _this$state2.itemDescription,
            itemQuantity = _this$state2.itemQuantity;

        var noTableText = addRow ? 'Fill in data below, then click "Save"' : 'Click "ADD" to start adding materials';
        return react_default.a.createElement(
          'div',
          null,
          react_default.a.createElement(
            'h6',
            { className: modal_default.a.signatureTitle },
            'Materials Needed'
          ),
          materialsNeeded.length > 0 ? react_default.a.createElement(
            'table',
            { className: modal_default.a.table },
            react_default.a.createElement(
              'thead',
              null,
              react_default.a.createElement(
                'tr',
                { className: modal_default.a.headerRow },
                react_default.a.createElement(
                  'th',
                  { className: modal_default.a.cell },
                  'Item Number'
                ),
                react_default.a.createElement(
                  'th',
                  { className: modal_default.a.cell },
                  'Item Description'
                ),
                react_default.a.createElement(
                  'th',
                  { className: modal_default.a.cell },
                  'Item Quantity'
                ),
                react_default.a.createElement(
                  'th',
                  { className: modal_default.a.deleteCell },
                  'Delete'
                )
              )
            ),
            react_default.a.createElement(
              'tbody',
              null,
              materialsNeeded.map(function (material) {
                return react_default.a.createElement(
                  'tr',
                  { className: modal_default.a.contentRow, key: material.item_number },
                  react_default.a.createElement(
                    'td',
                    { className: modal_default.a.cell },
                    material.item_number
                  ),
                  react_default.a.createElement(
                    'td',
                    { className: modal_default.a.cell },
                    material.item_description
                  ),
                  react_default.a.createElement(
                    'td',
                    { className: modal_default.a.cell },
                    material.item_quantity
                  ),
                  react_default.a.createElement(
                    'td',
                    { className: modal_default.a.deleteCell },
                    react_default.a.createElement(react_toolbox_lib["IconButton"], {
                      icon: 'delete',
                      onClick: _this.handleDelete(material.item_number)
                    })
                  )
                );
              })
            )
          ) : react_default.a.createElement(
            'div',
            { className: modal_default.a.emptyTable },
            react_default.a.createElement(
              'h4',
              null,
              noTableText
            )
          ),
          addRow && react_default.a.createElement(
            'form',
            { onSubmit: _this.handleSave },
            react_default.a.createElement(components_SimpleInput, {
              label: 'Item Number',
              text: itemNumber,
              onChange: _this.handleItemNumber
            }),
            react_default.a.createElement(components_SimpleInput, {
              label: 'Item Description',
              text: itemDescription,
              onChange: _this.handleItemDescription
            }),
            react_default.a.createElement(components_SimpleInput, {
              label: 'Item Quantity',
              text: itemQuantity,
              onChange: _this.handleItemQuantity
            }),
            react_default.a.createElement('input', { className: modal_default.a.save, type: 'submit', value: 'Save' })
          ),
          react_default.a.createElement(react_toolbox_lib["Button"], {
            className: addRow ? modal_default.a.cancel : modal_default.a.add,
            label: addRow ? 'Cancel' : 'Add',
            flat: true, inverse: true, ripple: true,
            onClick: _this.handleAddRow
          }),
          react_default.a.createElement(react_toolbox_lib["Button"], {
            label: 'Complete',
            flat: true, inverse: true, ripple: true,
            className: modal_default.a.submit,
            onClick: _this.handleFinish
          }),
          react_default.a.createElement(react_toolbox_lib["Button"], {
            label: 'Previous',
            flat: true, inverse: true, ripple: true,
            className: modal_default.a.submit,
            onClick: _this.handlePrevious
          })
        );
      }
    });

    _this.state = {
      materialsNeeded: _this.props.materialsNeeded || [],
      addRow: false,
      itemNumber: '',
      itemDescription: '',
      itemQuantity: '',
      errors: {}
    };
    return _this;
  }

  return MaterialsNeeded;
}(resetter(validator(react_default.a.Component)));

materialsNeeded_MaterialsNeeded.propTypes = {
  materialsNeeded: prop_types_default.a.array,
  errors: prop_types_default.a.shape({
    materialsNeeded: prop_types_default.a.arrayOf(prop_types_default.a.array)
  })
};

/* harmony default export */ var repairInspection_materialsNeeded = (Object(react_redux_es["connect"])(function (state) {
  return { errors: Object(reducers["Y" /* getPhaseErrors */])(state) };
}, {})(materialsNeeded_MaterialsNeeded));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/repairInspectionModal.jsx
var repairInspectionModal__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var repairInspectionModal__get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function repairInspectionModal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function repairInspectionModal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function repairInspectionModal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var repairInspectionModal_RepairInspectionModal = function (_Resetter) {
  repairInspectionModal__inherits(RepairInspectionModal, _Resetter);

  function RepairInspectionModal() {
    var _ref;

    var _temp, _this, _ret;

    repairInspectionModal__classCallCheck(this, RepairInspectionModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = repairInspectionModal__possibleConstructorReturn(this, (_ref = RepairInspectionModal.__proto__ || Object.getPrototypeOf(RepairInspectionModal)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'updateFormData', {
      enumerable: true,
      writable: true,
      value: function value(repairInspectionData) {
        var _this$state = _this.state,
            inspectionType = _this$state.inspectionType,
            subfloorType = _this$state.subfloorType,
            moisture = _this$state.moisture,
            petsPresent = _this$state.petsPresent,
            cleaningPractices = _this$state.cleaningPractices,
            customerConcerns = _this$state.customerConcerns,
            inspectorName = _this$state.inspectorName,
            installerName = _this$state.installerName,
            inspectionResults = _this$state.inspectionResults,
            locationOfConcern = _this$state.locationOfConcern,
            materialsLeftOver = _this$state.materialsLeftOver,
            materialsNeeded = _this$state.materialsNeeded;
        var _this$props$phase = _this.props.phase,
            id = _this$props$phase.id,
            customer_name = _this$props$phase.customer_name,
            name = _this$props$phase.surface_type.name,
            number = _this$props$phase.store.number,
            project_number = _this$props$phase.project_number,
            _this$props$phase$wo_ = _this$props$phase.wo_source,
            wo_source = _this$props$phase$wo_ === undefined ? '' : _this$props$phase$wo_;

        _this.setState(repairInspectionData, function () {
          if (repairInspectionData.tab === 4) {
            _this.props.repairInspectionReportCreate({
              installer_name: installerName,
              inspector_name: inspectorName,
              inspection_type: inspectionType,
              subfloor_type: subfloorType,
              moisture: moisture,
              pets_present: petsPresent,
              cleaning_practices: cleaningPractices,
              customer_concerns: customerConcerns,
              inspection_results: inspectionResults,
              location_of_concern: locationOfConcern,
              materials_left_over: materialsLeftOver,
              materials_needed: materialsNeeded,
              customer_name: customer_name,
              surface_type: name,
              store_number: number,
              project_number: project_number,
              phase_id: id,
              work_order_type: wo_source || 'N/A'
            }).then(function () {
              return _this.handleClose();
            }).catch(function () {});
          }
        });
      }
    }), Object.defineProperty(_this, 'showTab', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$state2 = _this.state,
            inspectionType = _this$state2.inspectionType,
            subfloorType = _this$state2.subfloorType,
            moisture = _this$state2.moisture,
            petsPresent = _this$state2.petsPresent,
            cleaningPractices = _this$state2.cleaningPractices,
            customerConcerns = _this$state2.customerConcerns,
            inspectorName = _this$state2.inspectorName,
            installerName = _this$state2.installerName,
            inspectionResults = _this$state2.inspectionResults,
            locationOfConcern = _this$state2.locationOfConcern,
            materialsLeftOver = _this$state2.materialsLeftOver,
            materialsNeeded = _this$state2.materialsNeeded,
            tab = _this$state2.tab;

        switch (tab) {
          case 1:
            return react_default.a.createElement(locationInfo, {
              updateFormData: _this.updateFormData,
              inspectionType: inspectionType,
              subfloorType: subfloorType,
              moisture: moisture,
              petsPresent: petsPresent,
              cleaningPractices: cleaningPractices
            });
          case 2:
            return react_default.a.createElement(concernsAndResults, {
              updateFormData: _this.updateFormData,
              customerConcerns: customerConcerns,
              inspectorName: inspectorName,
              installerName: installerName,
              inspectionResults: inspectionResults,
              locationOfConcern: locationOfConcern,
              materialsLeftOver: materialsLeftOver
            });
          case 3:
            return react_default.a.createElement(repairInspection_materialsNeeded, {
              updateFormData: _this.updateFormData,
              materialsNeeded: materialsNeeded
            });
          default:
            return react_default.a.createElement(components_Loading, null);
        }
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        return react_default.a.createElement(
          react_toolbox_lib["Dialog"],
          {
            active: _this.props.active, className: modal_default.a.modal, type: 'fullscreen',
            onEscKeyDown: _this.handleClose, onOverlayClick: _this.handleClose
          },
          react_default.a.createElement(
            'div',
            { className: input_default.a.errored },
            Object.keys(_this.props.errors).length > 0 && react_default.a.createElement(
              'span',
              { className: input_default.a.error },
              'This action could not be completed.'
            )
          ),
          react_default.a.createElement(react_toolbox_lib["IconButton"], { icon: 'close', className: modal_default.a.close, onClick: _this.handleClose }),
          react_default.a.createElement(
            'h5',
            null,
            'Workorder Inspection Report'
          ),
          _this.showTab()
        );
      }
    }), _temp), repairInspectionModal__possibleConstructorReturn(_this, _ret);
  }

  repairInspectionModal__createClass(RepairInspectionModal, [{
    key: 'handleClose',
    value: function handleClose() {
      repairInspectionModal__get(RepairInspectionModal.prototype.__proto__ || Object.getPrototypeOf(RepairInspectionModal.prototype), 'handleClose', this).call(this);
      this.props.clearValidation();
      document.location.reload();
    }
  }]);

  return RepairInspectionModal;
}(resetter(validator(react_default.a.Component)));

Object.defineProperty(repairInspectionModal_RepairInspectionModal, 'DEFAULT_STATE', {
  enumerable: true,
  writable: true,
  value: {
    installerName: '',
    inspectorName: '',
    inspectionType: '',
    subfloorType: '',
    moisture: '',
    petsPresent: '',
    cleaningPractices: '',
    customerConcerns: '',
    inspectionResults: '',
    locationOfConcern: '',
    materialsLeftOver: '',
    materialsNeeded: [],
    errors: {},
    tab: 1
  }
});
Object.defineProperty(repairInspectionModal_RepairInspectionModal, 'VALIDATIONS', {
  enumerable: true,
  writable: true,
  value: { installerName: true, customerName: true, inspectorName: true }
});


repairInspectionModal_RepairInspectionModal.propTypes = {
  active: prop_types_default.a.bool.isRequired,
  clearValidation: prop_types_default.a.func.isRequired,
  repairInspectionReportCreate: prop_types_default.a.func.isRequired,
  onClose: prop_types_default.a.func.isRequired,
  phase: types_phase.isRequired,
  errors: prop_types_default.a.shape({
    name: prop_types_default.a.arrayOf(prop_types_default.a.string)
  })
};

repairInspectionModal_RepairInspectionModal.defaultProps = { active: false };

/* harmony default export */ var repairInspectionModal = (Object(react_redux_es["connect"])(function (state) {
  return { errors: state.repairInspectionReport.uploadError };
}, {
  clearValidation: actionCreators["j" /* clearValidation */], repairInspectionReportCreate: actionCreators["S" /* repairInspectionReportCreate */], updatePhaseTask: actionCreators["_67" /* updatePhaseTask */]
})(repairInspectionModal_RepairInspectionModal));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/crewInspection/locationInfo.jsx
function crewInspection_locationInfo__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function crewInspection_locationInfo__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function crewInspection_locationInfo__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var crewInspection_locationInfo_LocationInfo = function (_Resetter) {
  crewInspection_locationInfo__inherits(LocationInfo, _Resetter);

  function LocationInfo(props) {
    crewInspection_locationInfo__classCallCheck(this, LocationInfo);

    var _this = crewInspection_locationInfo__possibleConstructorReturn(this, (LocationInfo.__proto__ || Object.getPrototypeOf(LocationInfo)).call(this, props));

    crewInspection_locationInfo__initialiseProps.call(_this);

    var _this$props = _this.props,
        _this$props$installer = _this$props.installerType,
        installerType = _this$props$installer === undefined ? '' : _this$props$installer,
        _this$props$subfloorT = _this$props.subfloorType,
        subfloorType = _this$props$subfloorT === undefined ? '' : _this$props$subfloorT,
        _this$props$helpers = _this$props.helpers,
        helpers = _this$props$helpers === undefined ? 'N/A' : _this$props$helpers,
        _this$props$crewId = _this$props.crewId,
        crewId = _this$props$crewId === undefined ? '' : _this$props$crewId,
        _this$props$phase$app = _this$props.phase.appointments,
        appointments = _this$props$phase$app === undefined ? [] : _this$props$phase$app;

    _this.state = {
      installerType: installerType,
      subfloorType: subfloorType,
      helpers: helpers,
      eligibleCrews: Object(lodash["uniqBy"])(appointments.filter(function (_ref) {
        var assignee_type = _ref.assignee_type;
        return assignee_type === 'Crew';
      }).map(function (_ref2) {
        var assignee_id = _ref2.assignee_id,
            assignee = _ref2.assignee;
        return { label: assignee, value: assignee_id };
      }), 'value'),
      crewId: crewId,
      errors: {}
    };
    return _this;
  }

  return LocationInfo;
}(resetter(validator(react_default.a.Component)));

Object.defineProperty(crewInspection_locationInfo_LocationInfo, 'VALIDATIONS', {
  enumerable: true,
  writable: true,
  value: {
    crewId: true,
    installerType: true,
    subfloorType: true,
    helpers: true
  }
});

var crewInspection_locationInfo__initialiseProps = function _initialiseProps() {
  var _this2 = this;

  Object.defineProperty(this, 'handleSubmit', {
    enumerable: true,
    writable: true,
    value: function value() {
      if (!_this2.validate()) return;
      var _state = _this2.state,
          installerType = _state.installerType,
          subfloorType = _state.subfloorType,
          helpers = _state.helpers,
          crewId = _state.crewId;

      _this2.props.updateFormData({ installerType: installerType, subfloorType: subfloorType, helpers: helpers, crewId: crewId, tab: 2 });
    }
  });
  Object.defineProperty(this, 'handleCrewId', {
    enumerable: true,
    writable: true,
    value: function value(_value) {
      return _this2.setState({ crewId: _value.toString() });
    }
  });
  Object.defineProperty(this, 'handleInstallerType', {
    enumerable: true,
    writable: true,
    value: function value(_value2) {
      return _this2.setState({ installerType: _value2 });
    }
  });
  Object.defineProperty(this, 'handleSubfloorType', {
    enumerable: true,
    writable: true,
    value: function value(_value3) {
      return _this2.setState({ subfloorType: _value3 });
    }
  });
  Object.defineProperty(this, 'handleHelpers', {
    enumerable: true,
    writable: true,
    value: function value(e) {
      return _this2.setState({ helpers: e.target.value });
    }
  });
  Object.defineProperty(this, 'render', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _state2 = _this2.state,
          crewId = _state2.crewId,
          installerType = _state2.installerType,
          subfloorType = _state2.subfloorType,
          helpers = _state2.helpers,
          eligibleCrews = _state2.eligibleCrews,
          errors = _state2.errors;

      var installerTypeButtons = [{ label: 'New Crew', value: 'New Crew' }, { label: 'Existing Crew', value: 'Existing Crew' }];
      var subfloorOptions = [{ value: 'Wood', label: 'Wood' }, { value: 'Concrete', label: 'Concrete' }, { value: 'Combination', label: 'Combination' }, { value: 'Other', label: 'Other' }];
      return react_default.a.createElement(
        'div',
        null,
        react_default.a.createElement(
          'h6',
          { className: modal_default.a.signatureTitle },
          'Location Info'
        ),
        react_default.a.createElement(components_StyledSelect, {
          className: modal_default.a.select,
          label: 'Crew Name',
          onChange: _this2.handleCrewId,
          options: eligibleCrews,
          value: crewId,
          placeholder: 'Select Crew',
          error: errors.crewId,
          required: true
        }),
        react_default.a.createElement(components_RadioButtons, {
          label: 'Crew Type*',
          onChange: _this2.handleInstallerType,
          selectedValue: installerType,
          radioButtons: installerTypeButtons,
          text: 'Is this a new or existing crew?',
          required: true
        }),
        react_default.a.createElement(components_StyledSelect, {
          className: modal_default.a.select,
          label: 'Subfloor Type',
          onChange: _this2.handleSubfloorType,
          options: subfloorOptions,
          value: subfloorType,
          placeholder: 'Select',
          error: errors.subfloorType,
          required: true
        }),
        react_default.a.createElement(components_SimpleInput, {
          label: 'Helper(s)*',
          text: helpers,
          errors: errors.helpers,
          onChange: _this2.handleHelpers,
          required: true
        }),
        react_default.a.createElement(react_toolbox_lib["Button"], { label: 'Next', flat: true, inverse: true, ripple: true, className: modal_default.a.submit, onClick: _this2.handleSubmit }),
        react_default.a.createElement(react_toolbox_lib["Button"], { label: 'Previous', flat: true, inverse: true, ripple: true, className: modal_default.a.submit, onClick: _this2.handlePrevious })
      );
    }
  });
};

crewInspection_locationInfo_LocationInfo.propTypes = {
  phase: types_phase.isRequired,
  crewId: prop_types_default.a.string,
  installerType: prop_types_default.a.string,
  subfloorType: prop_types_default.a.string,
  helpers: prop_types_default.a.string,
  errors: prop_types_default.a.shape({
    installerType: prop_types_default.a.arrayOf(prop_types_default.a.string),
    subfloorType: prop_types_default.a.arrayOf(prop_types_default.a.string),
    helpers: prop_types_default.a.arrayOf(prop_types_default.a.string)
  })
};

/* harmony default export */ var crewInspection_locationInfo = (Object(react_redux_es["connect"])(function (state) {
  return { errors: Object(reducers["Y" /* getPhaseErrors */])(state) };
}, {})(crewInspection_locationInfo_LocationInfo));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/crewInspection/yesAndNo.jsx
function yesAndNo__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function yesAndNo__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function yesAndNo__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var YesAndNo = function (_Resetter) {
  yesAndNo__inherits(YesAndNo, _Resetter);

  function YesAndNo(props) {
    yesAndNo__classCallCheck(this, YesAndNo);

    var _this = yesAndNo__possibleConstructorReturn(this, (YesAndNo.__proto__ || Object.getPrototypeOf(YesAndNo)).call(this, props));

    yesAndNo__initialiseProps.call(_this);

    var _this$props = _this.props,
        _this$props$badge = _this$props.badge,
        badge = _this$props$badge === undefined ? '' : _this$props$badge,
        _this$props$badgeWhy = _this$props.badgeWhy,
        badgeWhy = _this$props$badgeWhy === undefined ? '' : _this$props$badgeWhy,
        _this$props$uniform = _this$props.uniform,
        uniform = _this$props$uniform === undefined ? '' : _this$props$uniform,
        _this$props$uniformWh = _this$props.uniformWhy,
        uniformWhy = _this$props$uniformWh === undefined ? '' : _this$props$uniformWh,
        _this$props$yardSign = _this$props.yardSign,
        yardSign = _this$props$yardSign === undefined ? '' : _this$props$yardSign,
        _this$props$yardSignW = _this$props.yardSignWhy,
        yardSignWhy = _this$props$yardSignW === undefined ? '' : _this$props$yardSignW,
        _this$props$oilShield = _this$props.oilShield,
        oilShield = _this$props$oilShield === undefined ? '' : _this$props$oilShield,
        _this$props$oilShield2 = _this$props.oilShieldWhy,
        oilShieldWhy = _this$props$oilShield2 === undefined ? '' : _this$props$oilShield2,
        _this$props$tarp = _this$props.tarp,
        tarp = _this$props$tarp === undefined ? '' : _this$props$tarp,
        _this$props$tarpWhy = _this$props.tarpWhy,
        tarpWhy = _this$props$tarpWhy === undefined ? '' : _this$props$tarpWhy,
        _this$props$properToo = _this$props.properTools,
        properTools = _this$props$properToo === undefined ? '' : _this$props$properToo,
        _this$props$properToo2 = _this$props.properToolsWhy,
        properToolsWhy = _this$props$properToo2 === undefined ? '' : _this$props$properToo2;

    _this.state = {
      badge: badge,
      badgeWhy: badgeWhy,
      uniform: uniform,
      uniformWhy: uniformWhy,
      yardSign: yardSign,
      yardSignWhy: yardSignWhy,
      oilShield: oilShield,
      oilShieldWhy: oilShieldWhy,
      tarp: tarp,
      tarpWhy: tarpWhy,
      properTools: properTools,
      properToolsWhy: properToolsWhy,
      errors: {}
    };
    return _this;
  }

  return YesAndNo;
}(resetter(validator(react_default.a.Component)));

Object.defineProperty(YesAndNo, 'VALIDATIONS', {
  enumerable: true,
  writable: true,
  value: {
    badge: true,
    uniform: true,
    yardSign: true,
    oilShield: true,
    tarp: true,
    properTools: true
  }
});

var yesAndNo__initialiseProps = function _initialiseProps() {
  var _this2 = this;

  Object.defineProperty(this, 'handleSubmit', {
    enumerable: true,
    writable: true,
    value: function value() {
      if (!_this2.validate()) {
        return;
      }
      var _state = _this2.state,
          badge = _state.badge,
          badgeWhy = _state.badgeWhy,
          uniform = _state.uniform,
          uniformWhy = _state.uniformWhy,
          yardSign = _state.yardSign,
          yardSignWhy = _state.yardSignWhy,
          oilShield = _state.oilShield,
          oilShieldWhy = _state.oilShieldWhy,
          tarp = _state.tarp,
          tarpWhy = _state.tarpWhy,
          properTools = _state.properTools,
          properToolsWhy = _state.properToolsWhy;

      _this2.props.updateFormData({
        badge: badge,
        badgeWhy: badgeWhy,
        uniform: uniform,
        uniformWhy: uniformWhy,
        yardSign: yardSign,
        yardSignWhy: yardSignWhy,
        oilShield: oilShield,
        oilShieldWhy: oilShieldWhy,
        tarp: tarp,
        tarpWhy: tarpWhy,
        properTools: properTools,
        properToolsWhy: properToolsWhy,
        tab: 3
      });
    }
  });
  Object.defineProperty(this, 'handlePrevious', {
    enumerable: true,
    writable: true,
    value: function value() {
      return _this2.props.updateFormData({
        badge: _this2.state.badge,
        badgeWhy: _this2.state.badgeWhy,
        uniform: _this2.state.uniform,
        uniformWhy: _this2.state.uniformWhy,
        yardSign: _this2.state.yardSign,
        yardSignWhy: _this2.state.yardSignWhy,
        oilShield: _this2.state.oilShield,
        oilShieldWhy: _this2.state.oilShieldWhy,
        tarp: _this2.state.tarp,
        tarpWhy: _this2.state.tarpWhy,
        properTools: _this2.state.properTools,
        properToolsWhy: _this2.state.properToolsWhy,
        tab: 1
      });
    }
  });
  Object.defineProperty(this, 'handleBadge', {
    enumerable: true,
    writable: true,
    value: function value(_value) {
      return _this2.setState({ badge: _value });
    }
  });
  Object.defineProperty(this, 'handleBadgeWhy', {
    enumerable: true,
    writable: true,
    value: function value(e) {
      return _this2.setState({ badgeWhy: e.target.value });
    }
  });
  Object.defineProperty(this, 'handleUniform', {
    enumerable: true,
    writable: true,
    value: function value(_value2) {
      return _this2.setState({ uniform: _value2 });
    }
  });
  Object.defineProperty(this, 'handleUniformWhy', {
    enumerable: true,
    writable: true,
    value: function value(e) {
      return _this2.setState({ uniformWhy: e.target.value });
    }
  });
  Object.defineProperty(this, 'handleYardSign', {
    enumerable: true,
    writable: true,
    value: function value(_value3) {
      return _this2.setState({ yardSign: _value3 });
    }
  });
  Object.defineProperty(this, 'handleYardSignWhy', {
    enumerable: true,
    writable: true,
    value: function value(e) {
      return _this2.setState({ yardSignWhy: e.target.value });
    }
  });
  Object.defineProperty(this, 'handleOilShield', {
    enumerable: true,
    writable: true,
    value: function value(_value4) {
      return _this2.setState({ oilShield: _value4 });
    }
  });
  Object.defineProperty(this, 'handleOilShieldWhy', {
    enumerable: true,
    writable: true,
    value: function value(e) {
      return _this2.setState({ oilShieldWhy: e.target.value });
    }
  });
  Object.defineProperty(this, 'handleTarp', {
    enumerable: true,
    writable: true,
    value: function value(_value5) {
      return _this2.setState({ tarp: _value5 });
    }
  });
  Object.defineProperty(this, 'handleTarpWhy', {
    enumerable: true,
    writable: true,
    value: function value(e) {
      return _this2.setState({ tarpWhy: e.target.value });
    }
  });
  Object.defineProperty(this, 'handleProperTools', {
    enumerable: true,
    writable: true,
    value: function value(_value6) {
      return _this2.setState({ properTools: _value6 });
    }
  });
  Object.defineProperty(this, 'handleProperToolsWhy', {
    enumerable: true,
    writable: true,
    value: function value(e) {
      return _this2.setState({ properToolsWhy: e.target.value });
    }
  });
  Object.defineProperty(this, 'render', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _state2 = _this2.state,
          badge = _state2.badge,
          badgeWhy = _state2.badgeWhy,
          uniform = _state2.uniform,
          uniformWhy = _state2.uniformWhy,
          yardSign = _state2.yardSign,
          yardSignWhy = _state2.yardSignWhy,
          oilShield = _state2.oilShield,
          oilShieldWhy = _state2.oilShieldWhy,
          tarp = _state2.tarp,
          tarpWhy = _state2.tarpWhy,
          properTools = _state2.properTools,
          properToolsWhy = _state2.properToolsWhy,
          errors = _state2.errors;

      var buttons = [{ label: 'YES', value: 'YES' }, { label: 'NO', value: 'NO' }];
      return react_default.a.createElement(
        'div',
        null,
        react_default.a.createElement(
          'h6',
          { className: modal_default.a.signatureTitle },
          'Yes Or No'
        ),
        react_default.a.createElement(components_RadioButtons, {
          label: 'Badge*',
          required: true,
          onChange: _this2.handleBadge,
          selectedValue: badge,
          radioButtons: buttons
        }),
        badge === 'NO' && react_default.a.createElement(components_SimpleInput, {
          label: 'Why No Badge?*',
          required: true,
          text: badgeWhy,
          errors: errors.badgeWhy,
          onChange: _this2.handleBadgeWhy
        }),
        react_default.a.createElement(components_RadioButtons, {
          label: 'Uniform*',
          required: true,
          onChange: _this2.handleUniform,
          selectedValue: uniform,
          radioButtons: buttons
        }),
        uniform === 'NO' && react_default.a.createElement(components_SimpleInput, {
          label: 'Why No Uniform?*',
          required: true,
          text: uniformWhy,
          errors: errors.uniformWhy,
          onChange: _this2.handleUniformWhy
        }),
        react_default.a.createElement(components_RadioButtons, {
          label: 'Yard Sign*',
          required: true,
          onChange: _this2.handleYardSign,
          selectedValue: yardSign,
          radioButtons: buttons
        }),
        yardSign === 'NO' && react_default.a.createElement(components_SimpleInput, {
          label: 'Why No Yard Sign?*',
          required: true,
          text: yardSignWhy,
          errors: errors.yardSignWhy,
          onChange: _this2.handleYardSignWhy
        }),
        react_default.a.createElement(components_RadioButtons, {
          label: 'Oil Shield*',
          required: true,
          onChange: _this2.handleOilShield,
          selectedValue: oilShield,
          radioButtons: buttons
        }),
        oilShield === 'NO' && react_default.a.createElement(components_SimpleInput, {
          label: 'Why No Oil Shield?*',
          required: true,
          text: oilShieldWhy,
          errors: errors.oilShieldWhy,
          onChange: _this2.handleOilShieldWhy
        }),
        react_default.a.createElement(components_RadioButtons, {
          label: 'Tarp*',
          required: true,
          onChange: _this2.handleTarp,
          selectedValue: tarp,
          radioButtons: buttons
        }),
        tarp === 'NO' && react_default.a.createElement(components_SimpleInput, {
          label: 'Why No Tarp?*',
          required: true,
          text: tarpWhy,
          errors: errors.tarpWhy,
          onChange: _this2.handleTarpWhy
        }),
        react_default.a.createElement(components_RadioButtons, {
          label: 'Proper Tools*',
          required: true,
          onChange: _this2.handleProperTools,
          selectedValue: properTools,
          radioButtons: buttons
        }),
        properTools === 'NO' && react_default.a.createElement(components_SimpleInput, {
          label: 'Why No Proper Tools?*',
          required: true,
          text: properToolsWhy,
          errors: errors.properToolsWhy,
          onChange: _this2.handleProperToolsWhy
        }),
        react_default.a.createElement(react_toolbox_lib["Button"], { label: 'Next', flat: true, inverse: true, ripple: true, className: modal_default.a.submit, onClick: _this2.handleSubmit }),
        react_default.a.createElement(react_toolbox_lib["Button"], { label: 'Previous', flat: true, inverse: true, ripple: true, className: modal_default.a.submit, onClick: _this2.handlePrevious })
      );
    }
  });
};

YesAndNo.propTypes = {
  phase: types_phase.isRequired,
  badge: prop_types_default.a.string,
  badgeWhy: prop_types_default.a.string,
  uniform: prop_types_default.a.string,
  uniformWhy: prop_types_default.a.string,
  yardSign: prop_types_default.a.string,
  yardSignWhy: prop_types_default.a.string,
  oilShield: prop_types_default.a.string,
  oilShieldWhy: prop_types_default.a.string,
  tarp: prop_types_default.a.string,
  tarpWhy: prop_types_default.a.string,
  properTools: prop_types_default.a.string,
  properToolsWhy: prop_types_default.a.string,
  errors: prop_types_default.a.shape({
    badge: prop_types_default.a.arrayOf(prop_types_default.a.string),
    badgeWhy: prop_types_default.a.arrayOf(prop_types_default.a.string),
    uniform: prop_types_default.a.arrayOf(prop_types_default.a.string),
    uniformWhy: prop_types_default.a.arrayOf(prop_types_default.a.string),
    yardSign: prop_types_default.a.arrayOf(prop_types_default.a.string),
    yardSignWhy: prop_types_default.a.arrayOf(prop_types_default.a.string),
    oilShield: prop_types_default.a.arrayOf(prop_types_default.a.string),
    oilShieldWhy: prop_types_default.a.arrayOf(prop_types_default.a.string),
    tarp: prop_types_default.a.arrayOf(prop_types_default.a.string),
    tarpWhy: prop_types_default.a.arrayOf(prop_types_default.a.string),
    properTools: prop_types_default.a.arrayOf(prop_types_default.a.string),
    properToolsWhy: prop_types_default.a.arrayOf(prop_types_default.a.string)
  })
};

/* harmony default export */ var yesAndNo = (Object(react_redux_es["connect"])(function (state) {
  return { errors: Object(reducers["Y" /* getPhaseErrors */])(state) };
}, {})(YesAndNo));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/crewInspection/assessment.jsx
function assessment__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function assessment__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function assessment__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var assessment_Assessment = function (_Resetter) {
  assessment__inherits(Assessment, _Resetter);

  function Assessment() {
    var _ref;

    var _temp, _this, _ret;

    assessment__classCallCheck(this, Assessment);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = assessment__possibleConstructorReturn(this, (_ref = Assessment.__proto__ || Object.getPrototypeOf(Assessment)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'state', {
      enumerable: true,
      writable: true,
      value: {
        // it seems like validators from other classes that use 'installerName'
        // in local state are affecting this. giving it some sort of value for now
        installerName: 'N/A',
        auditorName: _this.props.auditorName || '',
        overallAssessment: _this.props.overallAssessment || '',
        errors: {}
      }
    }), Object.defineProperty(_this, 'handleSubmit', {
      enumerable: true,
      writable: true,
      value: function value() {
        if (!_this.validate()) return;
        _this.props.updateFormData({
          installerName: _this.state.installerName,
          auditorName: _this.state.auditorName,
          overallAssessment: _this.state.overallAssessment,
          tab: 4
        });
      }
    }), Object.defineProperty(_this, 'handlePrevious', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.updateFormData({
          installerName: _this.state.installerName,
          auditorName: _this.state.auditorName,
          overallAssessment: _this.state.overallAssessment,
          tab: 2
        });
      }
    }), Object.defineProperty(_this, 'handleAuditorName', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        return _this.setState({ auditorName: e.target.value });
      }
    }), Object.defineProperty(_this, 'handleOverallAssessment', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        return _this.setState({ overallAssessment: e.target.value });
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$state = _this.state,
            auditorName = _this$state.auditorName,
            overallAssessment = _this$state.overallAssessment,
            errors = _this$state.errors;

        return react_default.a.createElement(
          'div',
          null,
          react_default.a.createElement(
            'h6',
            { className: modal_default.a.signatureTitle },
            'Assessment'
          ),
          react_default.a.createElement(components_SimpleInput, {
            label: 'Auditor Name*',
            required: true,
            text: auditorName,
            errors: errors.auditorName,
            onChange: _this.handleAuditorName
          }),
          react_default.a.createElement(components_TextArea, {
            label: 'Overall Assessment*',
            value: overallAssessment,
            errors: errors.overallAssessment,
            onChange: _this.handleOverallAssessment,
            autoFocus: true
          }),
          react_default.a.createElement(react_toolbox_lib["Button"], { label: 'Complete', flat: true, inverse: true, ripple: true, className: modal_default.a.submit, onClick: _this.handleSubmit }),
          react_default.a.createElement(react_toolbox_lib["Button"], { label: 'Previous', flat: true, inverse: true, ripple: true, className: modal_default.a.submit, onClick: _this.handlePrevious })
        );
      }
    }), _temp), assessment__possibleConstructorReturn(_this, _ret);
  }

  return Assessment;
}(resetter(validator(react_default.a.Component)));

Object.defineProperty(assessment_Assessment, 'VALIDATIONS', {
  enumerable: true,
  writable: true,
  value: {
    installerName: true,
    auditorName: true,
    overallAssessment: true
  }
});


assessment_Assessment.propTypes = {
  phase: types_phase.isRequired,
  auditorName: prop_types_default.a.string,
  overallAssessment: prop_types_default.a.string,
  errors: prop_types_default.a.shape({
    auditorName: prop_types_default.a.arrayOf(prop_types_default.a.string),
    overallAssessment: prop_types_default.a.arrayOf(prop_types_default.a.string)
  })
};

/* harmony default export */ var assessment = (Object(react_redux_es["connect"])(function (state) {
  return { errors: Object(reducers["Y" /* getPhaseErrors */])(state) };
}, {})(assessment_Assessment));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/crewInspectionModal.jsx
var crewInspectionModal__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var crewInspectionModal__get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function crewInspectionModal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function crewInspectionModal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function crewInspectionModal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var crewInspectionModal_CrewInspectionModal = function (_Resetter) {
  crewInspectionModal__inherits(CrewInspectionModal, _Resetter);

  function CrewInspectionModal() {
    var _ref;

    var _temp, _this, _ret;

    crewInspectionModal__classCallCheck(this, CrewInspectionModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = crewInspectionModal__possibleConstructorReturn(this, (_ref = CrewInspectionModal.__proto__ || Object.getPrototypeOf(CrewInspectionModal)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'updateFormData', {
      enumerable: true,
      writable: true,
      value: function value(crewInspectionData) {
        var _this$props$phase = _this.props.phase,
            id = _this$props$phase.id,
            project_number = _this$props$phase.project_number,
            name = _this$props$phase.surface_type.name;

        _this.setState(crewInspectionData, function () {
          if (crewInspectionData.tab === 4) {
            var _this$state = _this.state,
                installerType = _this$state.installerType,
                subfloorType = _this$state.subfloorType,
                helpers = _this$state.helpers,
                badge = _this$state.badge,
                badgeWhy = _this$state.badgeWhy,
                uniform = _this$state.uniform,
                uniformWhy = _this$state.uniformWhy,
                yardSign = _this$state.yardSign,
                yardSignWhy = _this$state.yardSignWhy,
                oilShield = _this$state.oilShield,
                oilShieldWhy = _this$state.oilShieldWhy,
                tarp = _this$state.tarp,
                tarpWhy = _this$state.tarpWhy,
                properTools = _this$state.properTools,
                properToolsWhy = _this$state.properToolsWhy,
                crewId = _this$state.crewId;

            _this.props.crewInspectionCreate({
              auditor_name: _this.state.auditorName,
              installer_type: installerType,
              subfloor_type: subfloorType,
              helpers: helpers,
              badge: badge,
              badge_why: badgeWhy,
              uniform: uniform,
              uniform_why: uniformWhy,
              yard_sign: yardSign,
              yard_sign_why: yardSignWhy,
              oil_shield: oilShield,
              oil_shield_why: oilShieldWhy,
              tarp: tarp,
              tarp_why: tarpWhy,
              proper_tools: properTools,
              proper_tools_why: properToolsWhy,
              overall_assessment: _this.state.overallAssessment,
              surface_type: name,
              project_number: project_number,
              phase_id: id,
              crew_id: crewId
            }).then(function () {
              _this.handleClose();
            }).catch(function () {});
          }
        });
      }
    }), Object.defineProperty(_this, 'showTab', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$state2 = _this.state,
            tab = _this$state2.tab,
            auditorName = _this$state2.auditorName,
            installerType = _this$state2.installerType,
            subfloorType = _this$state2.subfloorType,
            helpers = _this$state2.helpers,
            badge = _this$state2.badge,
            badgeWhy = _this$state2.badgeWhy,
            uniform = _this$state2.uniform,
            uniformWhy = _this$state2.uniformWhy,
            yardSign = _this$state2.yardSign,
            yardSignWhy = _this$state2.yardSignWhy,
            oilShield = _this$state2.oilShield,
            oilShieldWhy = _this$state2.oilShieldWhy,
            tarp = _this$state2.tarp,
            tarpWhy = _this$state2.tarpWhy,
            properTools = _this$state2.properTools,
            properToolsWhy = _this$state2.properToolsWhy,
            overallAssessment = _this$state2.overallAssessment,
            crewId = _this$state2.crewId;
        var phase = _this.props.phase;

        switch (tab) {
          case 1:
            return react_default.a.createElement(crewInspection_locationInfo, {
              phase: phase,
              updateFormData: _this.updateFormData,
              crewId: crewId,
              installerType: installerType,
              subfloorType: subfloorType,
              helpers: helpers
            });
          case 2:
            return react_default.a.createElement(yesAndNo, {
              phase: phase,
              updateFormData: _this.updateFormData,
              badge: badge,
              badgeWhy: badgeWhy,
              uniform: uniform,
              uniformWhy: uniformWhy,
              yardSign: yardSign,
              yardSignWhy: yardSignWhy,
              oilShield: oilShield,
              oilShieldWhy: oilShieldWhy,
              tarp: tarp,
              tarpWhy: tarpWhy,
              properTools: properTools,
              properToolsWhy: properToolsWhy
            });
          case 3:
            return react_default.a.createElement(assessment, {
              phase: phase,
              updateFormData: _this.updateFormData,
              auditorName: auditorName,
              overallAssessment: overallAssessment
            });
          default:
            return react_default.a.createElement(components_Loading, null);
        }
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            active = _this$props.active,
            serverErrors = _this$props.errors;

        return react_default.a.createElement(
          react_toolbox_lib["Dialog"],
          {
            active: active, className: modal_default.a.modal, type: 'fullscreen',
            onEscKeyDown: _this.handleClose, onOverlayClick: _this.handleClose
          },
          react_default.a.createElement(
            'div',
            { className: input_default.a.errored },
            Object.keys(serverErrors).length > 0 && react_default.a.createElement(
              'span',
              { className: input_default.a.error },
              'This action could not be completed.'
            )
          ),
          react_default.a.createElement(react_toolbox_lib["IconButton"], { icon: 'close', className: modal_default.a.close, onClick: _this.handleClose }),
          react_default.a.createElement(
            'h5',
            null,
            'Crew Inspection Report'
          ),
          _this.showTab()
        );
      }
    }), _temp), crewInspectionModal__possibleConstructorReturn(_this, _ret);
  }

  crewInspectionModal__createClass(CrewInspectionModal, [{
    key: 'handleClose',
    value: function handleClose() {
      crewInspectionModal__get(CrewInspectionModal.prototype.__proto__ || Object.getPrototypeOf(CrewInspectionModal.prototype), 'handleClose', this).call(this);
      this.props.clearValidation();
      document.location.reload();
    }
  }]);

  return CrewInspectionModal;
}(resetter(validator(react_default.a.Component)));

Object.defineProperty(crewInspectionModal_CrewInspectionModal, 'DEFAULT_STATE', {
  enumerable: true,
  writable: true,
  value: {
    auditorName: '',
    crewId: '',
    installerType: '',
    subfloorType: '',
    helpers: '',
    badge: '',
    badgeWhy: '',
    uniform: '',
    uniformWhy: '',
    yardSign: '',
    yardSignWhy: '',
    oilShield: '',
    oilShieldWhy: '',
    tarp: '',
    tarpWhy: '',
    properTools: '',
    properToolsWhy: '',
    overallAssessment: '',
    errors: {},
    tab: 1
  }
});
Object.defineProperty(crewInspectionModal_CrewInspectionModal, 'VALIDATIONS', {
  enumerable: true,
  writable: true,
  value: {
    crewId: true,
    auditorName: true,
    overallAssessment: true
  }
});


crewInspectionModal_CrewInspectionModal.propTypes = {
  active: prop_types_default.a.bool.isRequired,
  clearValidation: prop_types_default.a.func.isRequired,
  crewInspectionCreate: prop_types_default.a.func.isRequired,
  onClose: prop_types_default.a.func.isRequired,
  phase: types_phase.isRequired,
  errors: prop_types_default.a.shape({
    name: prop_types_default.a.arrayOf(prop_types_default.a.string)
  })
};

crewInspectionModal_CrewInspectionModal.defaultProps = { active: false };

/* harmony default export */ var crewInspectionModal = (Object(react_redux_es["connect"])(function (state) {
  return { errors: state.crewInspection.uploadError };
}, {
  clearValidation: actionCreators["j" /* clearValidation */],
  crewInspectionCreate: actionCreators["w" /* crewInspectionCreate */],
  updatePhaseTask: actionCreators["_67" /* updatePhaseTask */]
})(crewInspectionModal_CrewInspectionModal));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/printInstallerPaperworkModal.jsx
function printInstallerPaperworkModal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function printInstallerPaperworkModal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function printInstallerPaperworkModal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var printInstallerPaperworkModal_PrintInstallerPaperworkModal = function (_React$Component) {
  printInstallerPaperworkModal__inherits(PrintInstallerPaperworkModal, _React$Component);

  function PrintInstallerPaperworkModal(props) {
    printInstallerPaperworkModal__classCallCheck(this, PrintInstallerPaperworkModal);

    var _this = printInstallerPaperworkModal__possibleConstructorReturn(this, (PrintInstallerPaperworkModal.__proto__ || Object.getPrototypeOf(PrintInstallerPaperworkModal)).call(this, props));

    Object.defineProperty(_this, 'onHideCostsChange', {
      enumerable: true,
      writable: true,
      value: function value(_value) {
        return _this.setState({ hideCosts: _value });
      }
    });
    Object.defineProperty(_this, 'onInstallerChange', {
      enumerable: true,
      writable: true,
      value: function value(_value2) {
        return _this.setState({
          installerId: _value2.employable_id, crews: _value2.user_crews || [] });
      }
    });
    Object.defineProperty(_this, 'handleSubmit', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$state = _this.state,
            hideCosts = _this$state.hideCosts,
            installerId = _this$state.installerId,
            crewId = _this$state.crewId;
        var _this$props = _this.props,
            appointment = _this$props.appointment,
            selectInstaller = _this$props.selectInstaller,
            phaseId = _this$props.phaseId;

        var query = {};
        if (selectInstaller && !installerId) return _this.setState({ errors: { installerId: 'Please select an installer' } });
        if (appointment) query.appointment_id = appointment.id;
        if (hideCosts) query.hide_costs = hideCosts;
        if (installerId) query.installer_id = installerId;
        if (phaseId) query.phase_id = phaseId;
        if (crewId) query.crew_id = crewId || '';
        _this.props.onClose();
        return window.open(urls.installerPaperwork({ query: query }));
      }
    });
    Object.defineProperty(_this, 'handleWhichPayRate', {
      enumerable: true,
      writable: true,
      value: function value(val) {
        return _this.setState({ crewId: val.value });
      }
    });
    Object.defineProperty(_this, 'handlePayId', {
      enumerable: true,
      writable: true,
      value: function value(val) {
        return _this.setState({ crewId: val.value === 'i' ? null : val.value });
      }
    });
    Object.defineProperty(_this, 'renderCrewSelect', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$state2 = _this.state,
            crews = _this$state2.crews,
            crewId = _this$state2.crewId;

        var options = crews.map(function (c) {
          return { value: c.id, label: c.name };
        });
        options.unshift({ value: 'i', label: 'Installer' });
        return react_default.a.createElement(react_select, {
          label: 'Which Pay Rate Doc To Use',
          placeholder: 'Select Installer or Crew',
          onChange: _this.handlePayId,
          options: options,
          value: crewId || 'i',
          required: true
        });
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$state3 = _this.state,
            errors = _this$state3.errors,
            installerId = _this$state3.installerId,
            crews = _this$state3.crews;
        var _this$props2 = _this.props,
            active = _this$props2.active,
            onClose = _this$props2.onClose,
            selectInstaller = _this$props2.selectInstaller,
            role = _this$props2.role;

        var titleText = selectInstaller ? 'Installer' : 'Appointment';
        return react_default.a.createElement(
          react_toolbox_lib["Dialog"],
          {
            active: active,
            className: modal_default.a.modal,
            type: 'fullscreen',
            onEscKeyDown: onClose,
            onOverlayClick: onClose
          },
          react_default.a.createElement(lib_button["IconButton"], {
            icon: 'close',
            className: modal_default.a.close,
            onClick: onClose
          }),
          react_default.a.createElement(
            'h5',
            { className: modal_default.a.title },
            'Preview Paperwork for ',
            titleText
          ),
          selectInstaller && react_default.a.createElement(components_UserSearch, {
            label: 'Installer',
            employableType: ['Installer'],
            required: true,
            onChange: _this.onInstallerChange,
            error: errors.installerId
          }),
          installerId && crews.length && crews.some(function (c) {
            return !c.use_installer_pay;
          }) && _this.renderCrewSelect(),
          role !== 'crew' ? react_default.a.createElement(react_toolbox_lib["Checkbox"], {
            checked: _this.state.hideCosts,
            label: 'Hide Costs',
            onChange: _this.onHideCostsChange,
            theme: checkbox_default.a
          }) : null,
          react_default.a.createElement(lib_button["Button"], {
            label: 'Preview',
            flat: true, inverse: true, ripple: true,
            className: modal_default.a.submit,
            onClick: _this.handleSubmit
          })
        );
      }
    });

    _this.onInstallerChange = _this.onInstallerChange.bind(_this);
    _this.handleWhichPayRate = _this.handleWhichPayRate.bind(_this);
    _this.state = {
      installerId: null,
      crewId: null,
      crews: [],
      errors: {},
      hideCosts: true
    };
    return _this;
  }

  return PrintInstallerPaperworkModal;
}(react_default.a.Component);

printInstallerPaperworkModal_PrintInstallerPaperworkModal.propTypes = {
  active: prop_types_default.a.bool.isRequired,
  onSubmit: prop_types_default.a.func,
  onClose: prop_types_default.a.func,
  appointment: prop_types_default.a.object,
  selectInstaller: prop_types_default.a.bool,
  phaseId: prop_types_default.a.number,
  role: prop_types_default.a.string.isRequired
};

printInstallerPaperworkModal_PrintInstallerPaperworkModal.defaultProps = {
  active: false,
  onClose: function onClose() {},
  appointment: null,
  selectInstaller: false,
  phaseId: null
};

/* harmony default export */ var printInstallerPaperworkModal = (printInstallerPaperworkModal_PrintInstallerPaperworkModal);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/sendToFloorWizardModal.jsx
var sendToFloorWizardModal__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var sendToFloorWizardModal__get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function sendToFloorWizardModal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function sendToFloorWizardModal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function sendToFloorWizardModal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var sendToFloorWizardModal_SendToFloorWizardModal = function (_Resetter) {
  sendToFloorWizardModal__inherits(SendToFloorWizardModal, _Resetter);

  function SendToFloorWizardModal() {
    var _ref;

    var _temp, _this, _ret;

    sendToFloorWizardModal__classCallCheck(this, SendToFloorWizardModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = sendToFloorWizardModal__possibleConstructorReturn(this, (_ref = SendToFloorWizardModal.__proto__ || Object.getPrototypeOf(SendToFloorWizardModal)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'handleSubmit', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.updatePhaseTask(_this.props.phaseId, 'send_to_floor_wizard', { task: { status: 'n/a' } }).then(function (res) {
          if (res.type === 'UPDATE_PHASE_TASK_SUCCESS') {
            _this.props.addEventToPhase(_this.props.phaseId, {
              name: 'Send Information to Floor Wizard',
              kind: 'floor_wizard',
              data: { note: 'Project resent to floorwizard from the action button', success: true }
            });
          }
        }).then(function () {
          return _this.handleClose();
        });
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            active = _this$props.active,
            serverErrors = _this$props.serverErrors;

        return react_default.a.createElement(
          react_toolbox_lib["Dialog"],
          {
            active: active,
            className: modal_default.a.modal,
            type: 'fullscreen',
            onEscKeyDown: _this.handleClose,
            onOverlayClick: _this.handleClose
          },
          react_default.a.createElement(
            'div',
            { className: input_default.a.errored },
            serverErrors && Object.keys(serverErrors).length > 0 && react_default.a.createElement(
              'span',
              { className: input_default.a.error },
              Object(utils["d" /* errorSummary */])(serverErrors)
            )
          ),
          react_default.a.createElement(lib_button["IconButton"], {
            icon: 'close',
            className: modal_default.a.close,
            onClick: _this.handleClose,
            tabIndex: -1
          }),
          react_default.a.createElement(
            'h5',
            { className: modal_default.a.title },
            'Send Phase To Floor Wizard'
          ),
          react_default.a.createElement(
            'p',
            { className: modal_default.a.text },
            'Verify you want to do so, then click ',
            '\'SEND\'',
            ' to re-send this phase to Floor Wizard'
          ),
          react_default.a.createElement(lib_button["Button"], {
            label: 'Send',
            flat: true, inverse: true, ripple: true,
            className: modal_default.a.submit,
            onClick: _this.handleSubmit
          })
        );
      }
    }), _temp), sendToFloorWizardModal__possibleConstructorReturn(_this, _ret);
  }

  sendToFloorWizardModal__createClass(SendToFloorWizardModal, [{
    key: 'handleClose',
    value: function handleClose() {
      sendToFloorWizardModal__get(SendToFloorWizardModal.prototype.__proto__ || Object.getPrototypeOf(SendToFloorWizardModal.prototype), 'handleClose', this).call(this);
    }
  }]);

  return SendToFloorWizardModal;
}(resetter(validator(react_default.a.Component)));

Object.defineProperty(sendToFloorWizardModal_SendToFloorWizardModal, 'DEFAULT_STATE', {
  enumerable: true,
  writable: true,
  value: {
    errors: {}
  }
});
Object.defineProperty(sendToFloorWizardModal_SendToFloorWizardModal, 'VALIDATIONS', {
  enumerable: true,
  writable: true,
  value: { status: true, note: true }
});


sendToFloorWizardModal_SendToFloorWizardModal.propTypes = {
  active: prop_types_default.a.bool.isRequired,
  updatePhaseTask: prop_types_default.a.func.isRequired,
  addEventToPhase: prop_types_default.a.func.isRequired,
  onClose: prop_types_default.a.func.isRequired,
  phaseId: prop_types_default.a.number.isRequired,
  serverErrors: prop_types_default.a.shape({})
};

sendToFloorWizardModal_SendToFloorWizardModal.defaultProps = { active: false };

/* harmony default export */ var sendToFloorWizardModal = (Object(react_redux_es["connect"])(function (state) {
  return { serverErrors: Object(reducers["Y" /* getPhaseErrors */])(state) };
}, { updatePhaseTask: actionCreators_phase["s" /* updatePhaseTask */], addEventToPhase: actionCreators_phase["a" /* addEventToPhase */] })(sendToFloorWizardModal_SendToFloorWizardModal));
// EXTERNAL MODULE: ./client/app/shared/components/CalendarActionBar/calendarActionBar.scss
var calendarActionBar = __webpack_require__("mIoA");
var calendarActionBar_default = /*#__PURE__*/__webpack_require__.n(calendarActionBar);

// CONCATENATED MODULE: ./client/app/utils/mobileUtils.js
var getMobileOperatingSystem = function getMobileOperatingSystem() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

  if (/windows phone/i.test(userAgent)) {
    return 'Windows Phone';
  }

  if (/android/i.test(userAgent)) {
    return 'Android';
  }

  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'iOS';
  }

  return 'unknown';
};

/* harmony default export */ var mobileUtils = (getMobileOperatingSystem);
// CONCATENATED MODULE: ./client/app/shared/components/CalendarActionBar/index.jsx
var CalendarActionBar__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function CalendarActionBar__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function CalendarActionBar__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function CalendarActionBar__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function CalendarActionBar__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var CalendarActionBar_CalendarActionBar = function (_React$Component) {
  CalendarActionBar__inherits(CalendarActionBar, _React$Component);

  function CalendarActionBar(props) {
    CalendarActionBar__classCallCheck(this, CalendarActionBar);

    var _this = CalendarActionBar__possibleConstructorReturn(this, (CalendarActionBar.__proto__ || Object.getPrototypeOf(CalendarActionBar)).call(this, props));

    _this.state = {
      currentPage: '',
      currentTab: '',
      isMobile: ''
    };
    return _this;
  }

  CalendarActionBar__createClass(CalendarActionBar, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setPath();
    }
  }, {
    key: 'setPath',
    value: function setPath() {
      this.setState({
        currentPage: document.URL.split('/')[3],
        currentTab: document.URL.split('/')[5],
        isMobile: mobileUtils() !== 'unknown'
      });
    }
  }, {
    key: 'renderFilterBtn',
    value: function renderFilterBtn() {
      var _props = this.props,
          showFiltersBtn = _props.showFiltersBtn,
          toggleFilters = _props.toggleFilters,
          userRestrictedFilters = _props.userRestrictedFilters,
          role = _props.role;


      return !['installer', 'estimator'].includes(role) && showFiltersBtn && !userRestrictedFilters ? react_default.a.createElement(components_PageActionButton, {
        actionText: 'Filter',
        actionIcon: 'filter_list',
        action: toggleFilters,
        actionColor: 'orange'
      }) : null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _cx;

      var _props2 = this.props,
          title = _props2.title,
          banner = _props2.banner,
          subTitle = _props2.subTitle,
          children = _props2.children,
          currentPage = _props2.currentPage,
          currentTab = _props2.currentTab;

      return react_default.a.createElement(
        'div',
        {
          className: classnames_default()(calendarActionBar_default.a.calendarActionBarContainer, (_cx = {}, CalendarActionBar__defineProperty(_cx, calendarActionBar_default.a.mobile, this.state.isMobile && currentTab === 'appointments'), CalendarActionBar__defineProperty(_cx, calendarActionBar_default.a.inAppointments, currentTab === 'appointments'), CalendarActionBar__defineProperty(_cx, calendarActionBar_default.a.inSchedule, currentPage === 'schedule'), _cx))
        },
        react_default.a.createElement(Helmet_default.a, { title: title }),
        this.renderFilterBtn(),
        react_default.a.createElement(
          'div',
          { className: calendarActionBar_default.a.title },
          react_default.a.createElement(
            'div',
            null,
            title,
            react_default.a.createElement(
              'span',
              { className: calendarActionBar_default.a.banner },
              banner
            ),
            react_default.a.createElement(
              'div',
              { className: calendarActionBar_default.a.subTitle },
              subTitle
            )
          )
        ),
        children || react_default.a.createElement('div', { className: calendarActionBar_default.a.middle })
      );
    }
  }]);

  return CalendarActionBar;
}(react_default.a.Component);

CalendarActionBar_CalendarActionBar.propTypes = {
  showFiltersBtn: prop_types_default.a.bool,
  userRestrictedFilters: prop_types_default.a.bool,
  toggleFilters: prop_types_default.a.func,
  title: prop_types_default.a.string,
  subTitle: prop_types_default.a.string,
  banner: prop_types_default.a.string,
  children: prop_types_default.a.node,
  currentTab: prop_types_default.a.string,
  currentPage: prop_types_default.a.string,
  role: prop_types_default.a.string
};

CalendarActionBar_CalendarActionBar.defaultProps = {
  showFiltersBtn: true,
  userRestrictedFilters: false
};

/* harmony default export */ var components_CalendarActionBar = (CalendarActionBar_CalendarActionBar);
// EXTERNAL MODULE: ./client/app/screens/main/screens/schedule/components/calendar.scss
var calendar = __webpack_require__("hZAV");
var calendar_default = /*#__PURE__*/__webpack_require__.n(calendar);

// CONCATENATED MODULE: ./client/app/screens/main/screens/schedule/components/calendarLegend.jsx





var calendarLegend_CalendarLegend = function CalendarLegend() {
  return react_default.a.createElement(
    'div',
    { className: calendar_default.a.legend },
    react_default.a.createElement(
      'div',
      { className: classnames_default()(calendar_default.a.legendItem, calendar_default.a.legendItemFlex) },
      react_default.a.createElement(react_toolbox_lib["FontIcon"], { className: calendar_default.a.legendIcon, value: 'priority_high' }),
      'Priority Customer'
    ),
    react_default.a.createElement(
      'div',
      { className: calendar_default.a.legendItem },
      react_default.a.createElement('span', { className: classnames_default()(calendar_default.a.legendSwatch, calendar_default.a.fd_install) }),
      'FD Install/Hold'
    ),
    react_default.a.createElement(
      'div',
      { className: calendar_default.a.legendItem },
      react_default.a.createElement('span', { className: classnames_default()(calendar_default.a.legendSwatch, calendar_default.a.fd_repair) }),
      'FD Repair/Hold'
    ),
    react_default.a.createElement(
      'div',
      { className: calendar_default.a.legendItem },
      react_default.a.createElement('span', { className: classnames_default()(calendar_default.a.legendSwatch, calendar_default.a.assessment) }),
      'Assessment'
    ),
    react_default.a.createElement(
      'div',
      { className: calendar_default.a.legendItem },
      react_default.a.createElement('span', { className: classnames_default()(calendar_default.a.legendSwatch, calendar_default.a.stack_cali_bamboo) }),
      'Stack Cali Bamboo'
    ),
    react_default.a.createElement(
      'div',
      { className: calendar_default.a.legendItem },
      react_default.a.createElement('span', { className: classnames_default()(calendar_default.a.legendSwatch, calendar_default.a.stk_installation) }),
      'STK Installation'
    ),
    react_default.a.createElement(
      'div',
      { className: calendar_default.a.legendItem },
      react_default.a.createElement('span', { className: classnames_default()(calendar_default.a.legendSwatch, calendar_default.a.sos_installation) }),
      'SOS Installation'
    ),
    react_default.a.createElement(
      'div',
      { className: calendar_default.a.legendItem },
      react_default.a.createElement('span', { className: classnames_default()(calendar_default.a.legendSwatch, calendar_default.a.inspection) }),
      'WO Inspection'
    ),
    react_default.a.createElement(
      'div',
      { className: calendar_default.a.legendItem },
      react_default.a.createElement('span', { className: classnames_default()(calendar_default.a.legendSwatch, calendar_default.a.crew_and_repair) }),
      'Crew Inspection/Repair/Workorder Hold'
    ),
    react_default.a.createElement(
      'div',
      { className: calendar_default.a.legendItem },
      react_default.a.createElement('span', { className: classnames_default()(calendar_default.a.legendSwatch, calendar_default.a.delivery) }),
      'Delivery/Hold'
    ),
    react_default.a.createElement(
      'div',
      { className: calendar_default.a.legendItem },
      react_default.a.createElement('span', { className: classnames_default()(calendar_default.a.legendSwatch, calendar_default.a.deliver_stack_cali_bamboo) }),
      'D/S Cali Bamboo'
    )
  );
};

/* harmony default export */ var calendarLegend = (calendarLegend_CalendarLegend);
// CONCATENATED MODULE: ./client/app/screens/main/screens/schedule/components/calendarRow.jsx




var calendarRow_CalendarRow = function CalendarRow(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return react_default.a.createElement(
    'div',
    { className: calendar_default.a.row + ' ' + (className || '') },
    children
  );
};

calendarRow_CalendarRow.propTypes = {
  children: prop_types_default.a.node.isRequired,
  className: prop_types_default.a.string
};

/* harmony default export */ var calendarRow = (calendarRow_CalendarRow);
// CONCATENATED MODULE: ./client/app/screens/main/screens/schedule/components/calendarDayCell.jsx
function calendarDayCell__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






/* eslint-disable jsx-a11y/no-static-element-interactions */
var calendarDayCell_CalendarDayCell = function CalendarDayCell(_ref) {
  var _cx;

  var children = _ref.children,
      className = _ref.className,
      onSelect = _ref.onSelect,
      selectedRow = _ref.selectedRow,
      selectedCol = _ref.selectedCol,
      selectable = _ref.selectable;
  return react_default.a.createElement(
    'div',
    {
      onClick: onSelect,
      className: classnames_default()(calendar_default.a.dayCell, className, (_cx = {}, calendarDayCell__defineProperty(_cx, calendar_default.a.selectedRow, selectedRow), calendarDayCell__defineProperty(_cx, calendar_default.a.selectedCol, selectedCol), calendarDayCell__defineProperty(_cx, calendar_default.a.selectable, selectable), _cx))
    },
    children
  );
};

calendarDayCell_CalendarDayCell.propTypes = {
  children: prop_types_default.a.node.isRequired,
  className: prop_types_default.a.string,
  onSelect: prop_types_default.a.func.isRequired,
  selectedRow: prop_types_default.a.bool,
  selectedCol: prop_types_default.a.bool,
  selectable: prop_types_default.a.bool
};

calendarDayCell_CalendarDayCell.defaultProps = { onSelect: function onSelect() {} };

/* harmony default export */ var calendarDayCell = (calendarDayCell_CalendarDayCell);
// CONCATENATED MODULE: ./client/app/screens/main/screens/schedule/components/calendarLegendCell.jsx




var calendarLegendCell_CalendarLegendCell = function CalendarLegendCell(_ref) {
  var children = _ref.children;
  return react_default.a.createElement(
    'div',
    { className: calendar_default.a.legendCell },
    children
  );
};

calendarLegendCell_CalendarLegendCell.propTypes = {
  children: prop_types_default.a.node
};

/* harmony default export */ var calendarLegendCell = (calendarLegendCell_CalendarLegendCell);
// CONCATENATED MODULE: ./client/app/screens/main/screens/schedule/components/calendarNavigationButton.jsx








var calendarNavigationButton_CalendarNavigationButton = function CalendarNavigationButton(_ref) {
  var startDate = _ref.startDate,
      increment = _ref.increment,
      className = _ref.className,
      icon = _ref.icon,
      filters = _ref.filters,
      navigate = _ref.navigate;

  var nextDate = moment_default()(startDate).add(increment, 'days');
  var options = {};
  if (Object.keys(filters).length) options.query = filters;

  var content = react_default.a.createElement(react_toolbox_lib["FontIcon"], { value: icon });

  return navigate ? react_default.a.createElement(
    'a',
    { className: className, onClick: navigate, tabIndex: '0' },
    content
  ) : react_default.a.createElement(
    es["c" /* Link */],
    { className: className, to: urls.schedule(nextDate, options) },
    content
  );
};

calendarNavigationButton_CalendarNavigationButton.propTypes = {
  startDate: prop_types_default.a.string.isRequired,
  increment: prop_types_default.a.number.isRequired,
  className: prop_types_default.a.string,
  icon: prop_types_default.a.string,
  filters: prop_types_default.a.object,
  navigate: prop_types_default.a.func
};

/* harmony default export */ var calendarNavigationButton = (Object(react_redux_es["connect"])(function (state) {
  return { startDate: state.schedule.startDate, filters: state.schedule.filters };
})(calendarNavigationButton_CalendarNavigationButton));
// CONCATENATED MODULE: ./client/app/screens/main/screens/schedule/components/calendarHeader.jsx
function calendarHeader__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function calendarHeader__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function calendarHeader__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










__webpack_require__("l5j/");

var calendarHeader_CalendarHeader = function (_Component) {
  calendarHeader__inherits(CalendarHeader, _Component);

  function CalendarHeader(props) {
    calendarHeader__classCallCheck(this, CalendarHeader);

    var _this = calendarHeader__possibleConstructorReturn(this, (CalendarHeader.__proto__ || Object.getPrototypeOf(CalendarHeader)).call(this, props));

    Object.defineProperty(_this, 'renderDay', {
      enumerable: true,
      writable: true,
      value: function value(date, i, total, navigatePast, navigateFuture) {
        var m = date.startOf('day');
        return react_default.a.createElement(
          calendarDayCell,
          {
            key: date.toString(),
            className: calendar_default.a.headerCell + ' ' + (moment_default()().startOf('day').isSame(m) ? calendar_default.a.today : '')
          },
          i === 0 && react_default.a.createElement(calendarNavigationButton, {
            increment: 0 - total,
            className: calendar_default.a.prevButton,
            icon: 'navigate_before',
            navigate: navigatePast
          }),
          m.format('ddd MM/DD'),
          i === total - 1 && react_default.a.createElement(calendarNavigationButton, {
            increment: total,
            className: calendar_default.a.nextButton,
            icon: 'navigate_next',
            navigate: navigateFuture
          })
        );
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            dates = _this$props.dates,
            navigatePast = _this$props.navigatePast,
            navigateFuture = _this$props.navigateFuture,
            className = _this$props.className;

        return react_default.a.createElement(
          calendarRow,
          { className: className + ' ' + calendar_default.a.headerRow },
          react_default.a.createElement('div', { ref: _this.calendarHeaderRef }),
          react_default.a.createElement(calendarLegendCell, null),
          dates.map(function (day, i) {
            return _this.renderDay(day, i, dates.length, navigatePast, navigateFuture);
          })
        );
      }
    });

    _this.calendarHeaderRef = Object(react["createRef"])();
    return _this;
  }

  return CalendarHeader;
}(react["Component"]);

calendarHeader_CalendarHeader.propTypes = {
  dates: prop_types_default.a.arrayOf(prop_types_default.a.instanceOf(moment_default.a)).isRequired,
  navigatePast: prop_types_default.a.func,
  navigateFuture: prop_types_default.a.func,
  className: prop_types_default.a.string
};

calendarHeader_CalendarHeader.defaultProps = { className: '' };

/* harmony default export */ var calendarHeader = (calendarHeader_CalendarHeader);
// CONCATENATED MODULE: ./client/app/screens/main/screens/schedule/components/calendarFilters.jsx
function calendarFilters__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function calendarFilters__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function calendarFilters__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var calendarFilters_CalendarFilters = function (_React$Component) {
  calendarFilters__inherits(CalendarFilters, _React$Component);

  function CalendarFilters() {
    var _ref;

    var _temp, _this, _ret;

    calendarFilters__classCallCheck(this, CalendarFilters);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = calendarFilters__possibleConstructorReturn(this, (_ref = CalendarFilters.__proto__ || Object.getPrototypeOf(CalendarFilters)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'handleWorkrooms', {
      enumerable: true,
      writable: true,
      value: function value(values) {
        return _this.props.onFilterChange('workroom', values.map(function (v) {
          return v.value;
        }));
      }
    }), Object.defineProperty(_this, 'handleAssigneeType', {
      enumerable: true,
      writable: true,
      value: function value(values) {
        return _this.props.onFilterChange('assignee_type', values.map(function (v) {
          return v.value;
        }));
      }
    }), Object.defineProperty(_this, 'handleSurfaceType', {
      enumerable: true,
      writable: true,
      value: function value(values) {
        return _this.props.onFilterChange('surface_type', values.map(function (v) {
          return v.value;
        }));
      }
    }), Object.defineProperty(_this, 'handleIncludeInactive', {
      enumerable: true,
      writable: true,
      value: function value(_value) {
        return _this.props.onFilterChange(' ', _value);
      }
    }), Object.defineProperty(_this, 'toggleDeliveryValidation', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.handleDeliveryValidation();
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            active = _this$props.active,
            filters = _this$props.filters,
            className = _this$props.className,
            theme = _this$props.theme,
            onClose = _this$props.onClose,
            role = _this$props.role,
            phaseType = _this$props.phaseType,
            phaseSource = _this$props.phaseSource,
            showMismatchedCrews = _this$props.showMismatchedCrews,
            onShowMismatchedCrewsClick = _this$props.onShowMismatchedCrewsClick,
            showSsFilters = _this$props.showSsFilters;

        var mismatchLabel = phaseType === 'Assessment' && phaseSource === 'IFI' ? 'Show Mismatched Estimators/Crews' : 'Show Mismatched Crews';
        return react_default.a.createElement(
          components_FiltersDrawer,
          {
            title: 'Schedule',
            active: active,
            toggle: onClose,
            theme: theme,
            className: className
          },
          react_default.a.createElement(formElements_WorkroomSelect, {
            key: 'workroom',
            value: filters.workroom || [],
            onChange: _this.handleWorkrooms,
            oneRequired: !['estimator', 'installer'].includes(role)
          }),
          react_default.a.createElement(react_select, {
            key: 'assignee',
            multi: true,
            resetValue: [],
            name: 'assignee_type',
            className: classnames_default()(ReactSelect_styles_default.a, calendar_default.a.filterSelect),
            options: constants["m" /* ASSIGNEE_OPTIONS */],
            value: filters.assignee_type || [],
            onChange: _this.handleAssigneeType,
            label: 'Position Type',
            placeholder: 'All Workers'
          }),
          react_default.a.createElement(formElements_SurfaceTypeSelect, {
            key: 'surface_type',
            className: calendar_default.a.filterSelect,
            value: filters.surface_type || [],
            onChange: _this.handleSurfaceType,
            placeholder: 'All Surface Types'
          }),
          showSsFilters && react_default.a.createElement(react_toolbox_lib["Switch"], {
            name: 'showMismatchedCrews',
            label: mismatchLabel,
            onChange: onShowMismatchedCrewsClick,
            checked: showMismatchedCrews
          })
        );
      }
    }), _temp), calendarFilters__possibleConstructorReturn(_this, _ret);
  }

  return CalendarFilters;
}(react_default.a.Component);

calendarFilters_CalendarFilters.propTypes = {
  active: prop_types_default.a.bool.isRequired,
  onFilterChange: prop_types_default.a.func.isRequired,
  filters: CalendarFilterType,
  className: prop_types_default.a.string,
  onClose: prop_types_default.a.func.isRequired,
  theme: prop_types_default.a.shape({
    RTDrawer: prop_types_default.a.string,
    RTList: prop_types_default.a.string,
    RTOverlay: prop_types_default.a.string
  }),
  handleDeliveryValidation: prop_types_default.a.func,
  role: prop_types_default.a.string,
  phaseType: prop_types_default.a.string,
  phaseSource: prop_types_default.a.string,
  showSsFilters: prop_types_default.a.bool,
  showMismatchedCrews: prop_types_default.a.bool,
  onShowMismatchedCrewsClick: prop_types_default.a.func
};

calendarFilters_CalendarFilters.defaultProps = {
  active: false,
  onWorkroomChange: function onWorkroomChange() {},
  onAssigneeChange: function onAssigneeChange() {},
  onSurfaceTypeChange: function onSurfaceTypeChange() {},
  filters: {},
  onClose: function onClose() {},
  theme: {},
  phaseType: '',
  phaseSource: '',
  onShowMismatchedCrewsClick: function onShowMismatchedCrewsClick() {}
};

/* harmony default export */ var calendarFilters = (calendarFilters_CalendarFilters);
// CONCATENATED MODULE: ./client/app/shared/types/scheduleMember.js


var ScheduleMemberType = prop_types_default.a.shape({});

/* harmony default export */ var scheduleMember = (ScheduleMemberType);
// CONCATENATED MODULE: ./client/app/shared/types/schedule.js



var ScheduleType = prop_types_default.a.shape({
  members: prop_types_default.a.arrayOf(scheduleMember).isRequired,
  suggestions: prop_types_default.a.arrayOf(prop_types_default.a.arrayOf(prop_types_default.a.object))
});

/* harmony default export */ var types_schedule = (ScheduleType);
// CONCATENATED MODULE: ./client/app/shared/types/appointment.js


var CalendarAppointmentType = prop_types_default.a.shape({});

var Appointment = prop_types_default.a.shape({
  id: prop_types_default.a.number,
  arrivalStart: prop_types_default.a.string,
  arrivalEnd: prop_types_default.a.string,
  confirmationDate: prop_types_default.a.string,
  productConfirmation: prop_types_default.a.string,
  startDate: prop_types_default.a.string,
  endDate: prop_types_default.a.string,
  pickupDate: prop_types_default.a.string,
  selectedAssignee: prop_types_default.a.shape({
    alt: prop_types_default.a.bool,
    onSelect: prop_types_default.a.func,
    name: prop_types_default.a.string,
    jobs: prop_types_default.a.number,
    kind: prop_types_default.a.string,
    rating: prop_types_default.a.string,
    appointments: prop_types_default.a.array
  }),
  apptType: prop_types_default.a.string
});

var AppointmentType = prop_types_default.a.shape({
  id: prop_types_default.a.number,
  start_date: prop_types_default.a.string,
  end_date: prop_types_default.a.string,
  arrival_start_time: prop_types_default.a.string,
  arrival_end_time: prop_types_default.a.string,
  appointment_confirmation_date: prop_types_default.a.string,
  product_confirmation_date: prop_types_default.a.string,
  kind: prop_types_default.a.string,
  note: prop_types_default.a.string,
  created_at: prop_types_default.a.string
});

/* harmony default export */ var types_appointment = (CalendarAppointmentType);
// CONCATENATED MODULE: ./client/app/screens/main/screens/schedule/components/calendarAssigneeInfo.jsx









var isTraveling = function isTraveling(assignee, zip) {
  var covered_zip_codes = assignee.covered_zip_codes,
      traveling_zip_codes = assignee.traveling_zip_codes;

  return !covered_zip_codes.includes(zip) && traveling_zip_codes.includes(zip);
};

var calendarAssigneeInfo_CalendarAssigneeInfo = function CalendarAssigneeInfo(_ref) {
  var assignee = _ref.assignee,
      role = _ref.role,
      showProjectedTime = _ref.showProjectedTime,
      projectedJobDays = _ref.projectedJobDays,
      onOpeningClick = _ref.onOpeningClick,
      showIfTraveling = _ref.showIfTraveling,
      projectedJobLength = _ref.projectedJobLength,
      projectedCompletion = _ref.projectedCompletion,
      nextOpening = _ref.nextOpening,
      selectedAssignee = _ref.selectedAssignee,
      phaseZip = _ref.phaseZip;
  return react_default.a.createElement(
    'div',
    { className: calendar_default.a.assigneeInfo },
    react_default.a.createElement(
      'div',
      { className: calendar_default.a.assigneeDetails },
      react_default.a.createElement(
        'span',
        { className: calendar_default.a.assigneeText },
        react_default.a.createElement(
          es["c" /* Link */],
          {
            className: calendar_default.a.assigneeLink,
            to: linkTo(assignee),
            target: '_blank',
            'data-tip': assignee.notes || 'No Notes',
            'data-for': 'assignee' + (assignee.kind + assignee.id)
          },
          assignee.name,
          ' (',
          assignee.kind,
          ')'
        ),
        (assignee.delivery_dedicated || false) && react_default.a.createElement(
          'span',
          { className: calendar_default.a.notice },
          'DELIVERY DEDICATED'
        ),
        !assignee.delivery_dedicated && showIfTraveling && isTraveling(assignee, phaseZip) && react_default.a.createElement(
          'span',
          { className: calendar_default.a.notice },
          'TRAVELING CREW'
        ),
        showProjectedTime && !assignee.specificMismatch && react_default.a.createElement(
          react["Fragment"],
          null,
          react_default.a.createElement('br', null),
          react_default.a.createElement('br', null),
          'Time Needed: ',
          projectedJobLength,
          ' hours (',
          projectedJobDays,
          ' day',
          projectedJobLength > 1 ? 's' : '',
          ')',
          selectedAssignee && react_default.a.createElement(
            react["Fragment"],
            null,
            react_default.a.createElement('br', null),
            'Est. Complete: ',
            (moment_default()(projectedCompletion, [constants["F" /* DISPLAY_DATE_TIME */], constants["_21" /* RAILS_DATE_TIME */]], true).isValid() ? moment_default()(projectedCompletion, [constants["F" /* DISPLAY_DATE_TIME */], constants["_21" /* RAILS_DATE_TIME */]], true) : moment_default()(projectedCompletion, moment_default.a.ISO_8601, true)).format(constants["F" /* DISPLAY_DATE_TIME */]),
            react_default.a.createElement('br', null),
            react_default.a.createElement(
              'option',
              {
                className: calendar_default.a.assigneeLink,
                onClick: onOpeningClick
              },
              'Next Opening: ',
              nextOpening
            )
          )
        ),
        role !== 'installer' && react_default.a.createElement(react_tooltip_dist_default.a, {
          id: 'assignee' + (assignee.kind + assignee.id),
          className: calendar_default.a.tooltip,
          multiline: true, place: 'top',
          effect: 'solid'
        })
      )
    )
  );
};

calendarAssigneeInfo_CalendarAssigneeInfo.propTypes = {
  selectedAssignee: prop_types_default.a.object,
  assignee: prop_types_default.a.shape({
    name: prop_types_default.a.string,
    type: prop_types_default.a.oneOf(['estimator', 'installer', 'employee'])
  }).isRequired,
  showProjectedTime: prop_types_default.a.bool,
  showIfTraveling: prop_types_default.a.bool,
  projectedJobDays: prop_types_default.a.number,
  projectedJobLength: prop_types_default.a.number,
  projectedCompletion: prop_types_default.a.string,
  nextOpening: prop_types_default.a.string,
  role: prop_types_default.a.string,
  onOpeningClick: prop_types_default.a.func,
  phaseZip: prop_types_default.a.string
};

calendarAssigneeInfo_CalendarAssigneeInfo.defaultProps = {
  selectedAssignee: null,
  showProjectedTime: false,
  onOpeningClick: function onOpeningClick() {}
};

/* harmony default export */ var calendarAssigneeInfo = (calendarAssigneeInfo_CalendarAssigneeInfo);
// EXTERNAL MODULE: ./client/app/screens/main/screens/schedule/components/appointment.scss
var components_appointment = __webpack_require__("tOYP");
var appointment_default = /*#__PURE__*/__webpack_require__.n(components_appointment);

// CONCATENATED MODULE: ./client/app/screens/main/screens/schedule/components/appointmentNote.jsx
var appointmentNote__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function appointmentNote__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function appointmentNote__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function appointmentNote__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var appointmentNote_AppointmentNote = function (_Component) {
  appointmentNote__inherits(AppointmentNote, _Component);

  function AppointmentNote() {
    var _ref;

    var _temp, _this, _ret;

    appointmentNote__classCallCheck(this, AppointmentNote);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = appointmentNote__possibleConstructorReturn(this, (_ref = AppointmentNote.__proto__ || Object.getPrototypeOf(AppointmentNote)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'state', {
      enumerable: true,
      writable: true,
      value: {
        active: false
      }
    }), Object.defineProperty(_this, 'toggleActive', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ active: !_this.state.active });
      }
    }), _temp), appointmentNote__possibleConstructorReturn(_this, _ret);
  }

  appointmentNote__createClass(AppointmentNote, [{
    key: 'render',
    value: function render() {
      var active = this.state.active;
      var _props = this.props,
          note = _props.note,
          customer = _props.customer;

      return react_default.a.createElement(
        'span',
        null,
        react_default.a.createElement(react_toolbox_lib["FontIcon"], { className: appointment_default.a.noteIcon, value: 'note', onClick: this.toggleActive }),
        active && react_default.a.createElement(
          react_toolbox_lib["Dialog"],
          { title: customer + ' Appointment Notes', active: active, onEscKeyDown: this.toggleActive, onOverlayClick: this.toggleActive },
          react_default.a.createElement(react_toolbox_lib["FontIcon"], { value: 'close', className: appointment_default.a.closeIcon, onClick: this.toggleActive }),
          react_default.a.createElement(
            components_UserNote,
            null,
            note
          )
        )
      );
    }
  }]);

  return AppointmentNote;
}(react["Component"]);

appointmentNote_AppointmentNote.propTypes = {
  note: prop_types_default.a.string.isRequired,
  customer: prop_types_default.a.string.isRequired
};

/* harmony default export */ var appointmentNote = (appointmentNote_AppointmentNote);
// EXTERNAL MODULE: ./client/app/utils/schedulingUtils.js
var schedulingUtils = __webpack_require__("5nhd");

// CONCATENATED MODULE: ./client/app/screens/main/screens/schedule/components/calendarAppointment.jsx
function calendarAppointment__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function calendarAppointment__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function calendarAppointment__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function calendarAppointment__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }























var calendarAppointment_CalendarAppointment = function (_Component) {
  calendarAppointment__inherits(CalendarAppointment, _Component);

  function CalendarAppointment() {
    var _ref;

    var _temp, _this, _ret;

    calendarAppointment__classCallCheck(this, CalendarAppointment);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = calendarAppointment__possibleConstructorReturn(this, (_ref = CalendarAppointment.__proto__ || Object.getPrototypeOf(CalendarAppointment)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'componentDidUpdate', {
      enumerable: true,
      writable: true,
      value: function value(prevProps) {
        var _this$props = _this.props,
            applySsFeatures = _this$props.applySsFeatures,
            selectedCell = _this$props.selectedCell,
            setDelayedField = _this$props.setDelayedField,
            _this$props$appointme = _this$props.appointment,
            id = _this$props$appointme.id,
            _this$props$appointme2 = _this$props$appointme.mapMatrix,
            mapMatrix = _this$props$appointme2 === undefined ? { duration: 0 } : _this$props$appointme2;
        var duration = mapMatrix.duration;

        var prevDuration = ((prevProps.appointment || {}).mapMatrix || {}).duration || 0;
        if (applySsFeatures && selectedCell && id > 0 && duration > 0 && duration !== prevDuration) setDelayedField('timeBetween', duration);
      }
    }), Object.defineProperty(_this, 'getAppointmentLink', {
      enumerable: true,
      writable: true,
      value: function value(phase) {
        return phase.type === 'Assessment' ? urls.phaseHistory(phase) : urls.phaseLaborProductAccounting(phase);
      }
    }), Object.defineProperty(_this, 'determineAptCompletedRibbon', {
      enumerable: true,
      writable: true,
      value: function value(phaseStatus, phaseTasks) {
        if (phaseStatus === 'canceled' || phaseStatus === 'completed') return true;

        var complete = false;
        if (Array.isArray(phaseTasks) && phaseTasks.length) {
          phaseTasks.forEach(function (phaseTask) {
            if (['install_complete', 'workorder_complete'].includes(phaseTask.slug) && phaseTask.status === 'complete') {
              complete = true;
            }
          });
        }
        return complete;
      }
    }), Object.defineProperty(_this, 'altVendorColorCode', {
      enumerable: true,
      writable: true,
      value: function value(phaseSource, apptKind) {
        if (phaseSource === 'FD') {
          if (['installation', 'bust_day'].includes(apptKind)) return 'fd_install';
          if (apptKind === 'installation_hold') return 'fd_install_hold';
          if (['repair', 'repair_inspection'].includes(apptKind)) return 'fd_repair';
          if (['crew_inspection', 'jobsite_inspection', 'workorder_hold'].includes(apptKind)) return 'fd_workorder_hold';
        }
        return null;
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _cx, _cx2, _cx3, _cx4;

        var _this$props2 = _this.props,
            key = _this$props2.key,
            date = _this$props2.date,
            highlight = _this$props2.highlight,
            selectable = _this$props2.selectable,
            onReschedule = _this$props2.onReschedule,
            pendingId = _this$props2.pendingId,
            user = _this$props2.user,
            useHighContrast = _this$props2.useHighContrast,
            applySsFeatures = _this$props2.applySsFeatures,
            appt = _this$props2.appointment,
            relatedPhases = _this$props2.relatedPhases,
            _this$props2$appointm = _this$props2.appointment,
            user_id = _this$props2$appointm.user_id,
            arrivalStart = _this$props2$appointm.arrival_start_time,
            arrivalEnd = _this$props2$appointm.arrival_end_time,
            startDate = _this$props2$appointm.start_date,
            endDate = _this$props2$appointm.end_date,
            projectedCompletion = _this$props2$appointm.projected_completion,
            _this$props2$appointm2 = _this$props2$appointm.mapMatrix,
            mapMatrix = _this$props2$appointm2 === undefined ? { duration: 0, duration_display: '0' } : _this$props2$appointm2,
            note = _this$props2$appointm.note,
            kind = _this$props2$appointm.kind,
            phase = _this$props2$appointm.phase,
            _this$props2$appointm3 = _this$props2$appointm.phase,
            workroom = _this$props2$appointm3.workroom,
            flags = _this$props2$appointm3.flags,
            product_type = _this$props2$appointm3.product_type,
            type = _this$props2$appointm3.type,
            phase_tasks = _this$props2$appointm3.phase_tasks,
            status = _this$props2$appointm3.status,
            appointments = _this$props2$appointm3.appointments,
            surface_type = _this$props2$appointm3.surface_type,
            sqft = _this$props2$appointm3.sqft,
            customer_name = _this$props2$appointm3.customer_name,
            city = _this$props2$appointm3.city,
            store_number = _this$props2$appointm3.store_number,
            store = _this$props2$appointm3.store,
            phone_numbers = _this$props2$appointm3.phone_numbers,
            street_address = _this$props2$appointm3.street_address,
            state = _this$props2$appointm3.state,
            zip_code = _this$props2$appointm3.zip_code,
            _this$props2$appointm4 = _this$props2$appointm3.source,
            phaseSource = _this$props2$appointm4 === undefined ? '' : _this$props2$appointm4,
            _this$props2$assignee = _this$props2.assignee,
            name = _this$props2$assignee.name,
            _this$props2$assignee2 = _this$props2$assignee.crew_specific,
            crew_specific = _this$props2$assignee2 === undefined ? {} : _this$props2$assignee2;

        var zone = workroom.timezone.includes('Central') ? 'CST' : 'EST';
        var currentDay = void 0;
        var totalDays = void 0;
        if (startDate !== endDate) {
          var startMoment = moment_default()(startDate);
          currentDay = date.diff(startMoment, 'days') + 1;
          totalDays = moment_default()(endDate).diff(startMoment, 'days') + 1;
        }
        var canAttrs = user.role === 'iqm' ? { user_name: user.name, obj_name: name } : { user_id: user.id, obj_id: user_id };
        var canReschedule = Object(services["a" /* can */])(user.role, 'update', 'appointment_form', canAttrs);
        var priority = flags.find(function (flag) {
          return flag.name === 'Priority Customer';
        });
        var colorCoding = _this.altVendorColorCode(phaseSource, kind) || (kind || '').toLowerCase();
        if (colorCoding === 'installation' || colorCoding === 'bust_day') {
          colorCoding = (product_type || 'stk').toLowerCase();
        } else if (colorCoding === 'installation_hold') {
          colorCoding = (product_type || 'stk').toLowerCase() + '_hold';
        } else if (type.toLowerCase() === 'assessment') {
          /**
           * Constant declaration has to be in the IF/THEN block since it will only
           * run if the phase type is of "assessment" and departed_from_appointment
           * is only available for assessment phases.
           */
          var hasDepartedTask = phase_tasks.find(function (task) {
            return task.slug === 'departed_from_appointment';
          }) || { status: '' };
          var hasArrivedTask = phase_tasks.find(function (task) {
            return task.slug === 'arrived_at_appointment';
          }) || { status: '' };
          var isAppointmentToday = moment_default()(endDate).diff(moment_default()().startOf('day'), 'days') === 0;
          var isAppointmentOnTime = moment_default()(arrivalEnd, 'HH:mm').isAfter(moment_default()());
          var isArrivedComplete = hasArrivedTask.status === 'complete';
          var isDepartedComplete = hasDepartedTask.status === 'complete';
          if (isAppointmentToday && !isArrivedComplete && !isAppointmentOnTime) colorCoding = 'assessment_due';else if (colorCoding === 'delivery') colorCoding = 'delivery';else if (colorCoding === 'delivery_hold') colorCoding = 'delivery_hold';else if (colorCoding === 'assessment_hold') colorCoding = 'assessment_hold';else colorCoding = isDepartedComplete ? '' : 'assessment';
        }
        var complete = determineComplete(status, phase_tasks);
        var showAptCompletedRibbon = _this.determineAptCompletedRibbon(status, phase_tasks);
        var useActualMOT = determineUseActualMOT(type, appointments, complete);
        var motTitle = determineMOTTitle(type, useActualMOT, complete);
        var motColorCode = determineMOTColorCode(phase, useActualMOT, complete, colorCoding);
        var mot = determineMOT(phase, useActualMOT);
        var duration = mapMatrix.duration,
            duration_display = mapMatrix.duration_display;

        return react_default.a.createElement(
          'article',
          { className: appointment_default.a.appointment + ' ' + appointment_default.a[colorCoding] + ' ' + (highlight ? appointment_default.a.highlight : '') },
          react_default.a.createElement(
            es["c" /* Link */],
            {
              to: _this.getAppointmentLink(phase),
              target: '_blank',
              className: classnames_default()((_cx = {}, calendarAppointment__defineProperty(_cx, appointment_default.a.link, colorCoding !== 'assessment_due'), calendarAppointment__defineProperty(_cx, appointment_default.a.linkAssessmentDue, colorCoding === 'assessment_due'), _cx)),
              onClick: function onClick() {
                return selectable;
              }
            },
            react_default.a.createElement(
              'header',
              { className: appointment_default.a.title },
              showAptCompletedRibbon && react_default.a.createElement(
                'div',
                { className: appointment_default.a.ribbon },
                react_default.a.createElement(
                  'span',
                  null,
                  'Completed'
                )
              ),
              react_default.a.createElement(
                'span',
                { className: appointment_default.a.time },
                react_default.a.createElement(
                  'time',
                  { dateTime: arrivalStart },
                  moment_default()(arrivalStart, 'HH:mm').format('h:mma')
                ),
                ' - ',
                react_default.a.createElement(
                  'time',
                  { dateTime: arrivalEnd },
                  moment_default()(arrivalEnd, 'HH:mm').format('h:mma'),
                  ' ',
                  zone
                )
              ),
              totalDays && react_default.a.createElement(
                'span',
                { className: appointment_default.a.sequence },
                currentDay,
                '/',
                totalDays
              )
            ),
            applySsFeatures && key > 0 && Object(schedulingUtils["e" /* existingApptsRelate */])(pendingId, [appt], relatedPhases) && react_default.a.createElement(
              'div',
              { className: appointment_default.a.related },
              'Related To This Phase'
            ),
            react_default.a.createElement(
              'div',
              { className: appointment_default.a.customer },
              customer_name
            ),
            react_default.a.createElement(
              'div',
              { className: appointment_default.a.surfaceInfo },
              surface_type && surface_type.name,
              sqft && ' - ' + sqft + 'sqft'
            ),
            react_default.a.createElement(
              'div',
              { className: appointment_default.a.city },
              city,
              ', ',
              state
            ),
            Object(services["a" /* can */])(user.role, 'view', 'created_at_default') && react_default.a.createElement(
              'div',
              { className: appointment_default.a.mot },
              motTitle,
              ': ',
              react_default.a.createElement(
                'span',
                { className: appointment_default.a[motColorCode] },
                mot
              )
            ),
            projectedCompletion && phaseSource !== 'IFI' && react_default.a.createElement(
              'div',
              { className: appointment_default.a.estCompletion },
              'Est. Complete: ',
              (moment_default()(projectedCompletion, [constants["F" /* DISPLAY_DATE_TIME */], constants["_21" /* RAILS_DATE_TIME */]], true).isValid() ? moment_default()(projectedCompletion, [constants["F" /* DISPLAY_DATE_TIME */], constants["_21" /* RAILS_DATE_TIME */]], true) : moment_default()(projectedCompletion, moment_default.a.ISO_8601, true)).format(constants["F" /* DISPLAY_DATE_TIME */]),
              ' ' + zone
            ),
            applySsFeatures && duration > 0 && react_default.a.createElement(
              'div',
              {
                className: Object(schedulingUtils["j" /* maxDistanceExceeded */])(duration, crew_specific.max_travel_time) > 0 ? appointment_default.a.ssWarning : appointment_default.a.duration
              },
              duration_display,
              ' away'
            ),
            react_default.a.createElement(
              'div',
              { className: appointment_default.a.store },
              '#',
              store_number || store && store.number
            )
          ),
          react_default.a.createElement(
            'div',
            {
              className: classnames_default()(appointment_default.a.actions, (_cx2 = {}, calendarAppointment__defineProperty(_cx2, appointment_default.a.actionsButtons, colorCoding !== 'assessment_due'), calendarAppointment__defineProperty(_cx2, appointment_default.a.actionsButtonsAssessmentDue, colorCoding === 'assessment_due'), _cx2))
            },
            note && react_default.a.createElement(appointmentNote, { note: note, customer: customer_name }),
            phone_numbers && phone_numbers[0] && react_default.a.createElement(
              components_PhoneLink,
              { number: phone_numbers[0].number },
              react_default.a.createElement(react_toolbox_lib["FontIcon"], { value: 'phone' })
            ),
            react_default.a.createElement(
              components_MapLink,
              { address: street_address, city: city, state: state, zipCode: zip_code },
              react_default.a.createElement(react_toolbox_lib["FontIcon"], { value: 'directions' })
            ),
            !selectable && canReschedule && react_default.a.createElement(
              'a',
              { href: '/phases/' + phase.id + '/appointments/' + appt.id + '/edit/' + appt.kind },
              react_default.a.createElement(react_toolbox_lib["FontIcon"], { value: 'mode_edit' })
            )
          ),
          !selectable && canReschedule && react_default.a.createElement(
            react_responsive_default.a,
            { minWidth: constants["y" /* CUT_POINT */] },
            react_default.a.createElement(react_toolbox_lib["IconButton"], {
              icon: 'mode_edit',
              onClick: function onClick() {
                return onReschedule(appt);
              },
              className: classnames_default()(appointment_default.a.editButton, (_cx3 = {}, calendarAppointment__defineProperty(_cx3, appointment_default.a.editMulti, totalDays), calendarAppointment__defineProperty(_cx3, appointment_default.a.editButtonAssessmentDue, colorCoding === 'assessment_due'), _cx3))
            })
          ),
          selectable && react_default.a.createElement(
            es["c" /* Link */],
            { to: urls.phaseLaborProductAccounting(phase), target: '_blank' },
            react_default.a.createElement(react_toolbox_lib["IconButton"], {
              icon: 'launch',
              className: classnames_default()(appointment_default.a.editButton, (_cx4 = {}, calendarAppointment__defineProperty(_cx4, appointment_default.a.editMulti, totalDays), calendarAppointment__defineProperty(_cx4, appointment_default.a.editButtonAssessmentDue, colorCoding === 'assessment_due'), _cx4))
            })
          ),
          priority && react_default.a.createElement(
            'span',
            { className: appointment_default.a.priorityFlag },
            react_default.a.createElement(react_toolbox_lib["FontIcon"], { 'data-tip': true, 'data-for': 'flag-' + priority.id, value: 'priority_high' }),
            react_default.a.createElement(
              react_tooltip_dist_default.a,
              {
                className: classnames_default()(appointment_default.a.tooltip, calendarAppointment__defineProperty({}, appointment_default.a.tooltip_high_contrast, useHighContrast)),
                id: 'flag-' + priority.id,
                place: 'left',
                effect: 'solid'
              },
              priority.note
            )
          )
        );
      }
    }), _temp), calendarAppointment__possibleConstructorReturn(_this, _ret);
  }

  /* This is the same function as in motUtils.js - determineComplete
  but for calendar appointments we need to modify the logic slightly
  for Assessments. we want to show the complete status if the phase is complete
  Since this isn't MOT related, and a function that is used only in this component
  it made sense to leave this where it is used. */


  return CalendarAppointment;
}(react["Component"]);

calendarAppointment_CalendarAppointment.propTypes = {
  appointment: types_appointment.isRequired,
  date: prop_types_default.a.instanceOf(moment_default.a).isRequired,
  highlight: prop_types_default.a.bool,
  selectable: prop_types_default.a.bool,
  onReschedule: prop_types_default.a.func.isRequired,
  setDelayedField: prop_types_default.a.func,
  user: RoleType,
  navigate: prop_types_default.a.func.isRequired,
  useHighContrast: prop_types_default.a.bool,
  assignee: prop_types_default.a.object,
  applySsFeatures: prop_types_default.a.bool,
  relatedPhases: prop_types_default.a.array,
  pendingId: prop_types_default.a.number,
  selectedCell: prop_types_default.a.bool,
  key: prop_types_default.a.number
};

calendarAppointment_CalendarAppointment.defaultProps = {
  onReschedule: function onReschedule() {},
  setDelayedField: function setDelayedField() {},
  applySsFeatures: false,
  selectedCell: false
};

/* harmony default export */ var calendarAppointment = (Object(react_redux_es["connect"])(function (state) {
  return {
    user: state.user,
    useHighContrast: state.settings.useHighContrast
  };
}, { navigate: actionCreators["O" /* navigate */] })(calendarAppointment_CalendarAppointment));
// CONCATENATED MODULE: ./client/app/screens/main/screens/schedule/components/calendarBlock.jsx




var calendarBlock_CalendarBlock = function CalendarBlock(_ref) {
  var reason = _ref.reason,
      onSelect = _ref.onSelect,
      adjustedStartTime = _ref.adjustedStartTime;
  return react_default.a.createElement(
    'div',
    { className: calendar_default.a.ssBlock },
    react_default.a.createElement(
      'p',
      null,
      reason
    ),
    adjustedStartTime && react_default.a.createElement(
      'p',
      { // eslint-disable-line jsx-a11y/no-static-element-interactions
        className: calendar_default.a.assigneeLink,
        onClick: onSelect
      },
      'Schedule at ',
      adjustedStartTime
    )
  );
};

calendarBlock_CalendarBlock.propTypes = {
  reason: prop_types_default.a.string.isRequired,
  adjustedStartTime: prop_types_default.a.string,
  onSelect: prop_types_default.a.func
};

/* harmony default export */ var calendarBlock = (calendarBlock_CalendarBlock);
// CONCATENATED MODULE: ./client/app/screens/main/screens/schedule/components/calendarPTO.jsx
function calendarPTO__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }











var calendarPTO_CalendarPTO = function CalendarPTO(_ref) {
  var _cx;

  var date = _ref.date,
      assignee = _ref.assignee,
      pto = _ref.pto,
      availabilityArgs = _ref.availabilityArgs,
      disablePto = _ref.disablePto;

  var tooltipId = pto ? pto.id : date.clone().format(constants["E" /* DISPLAY_DATE */]) + '-' + assignee.id;

  var tooltipReason = function tooltipReason() {
    var reasonArr = ['Check ' + assignee.kind + ' Availability/Time Off'];
    if (pto && (pto.reason || null)) reasonArr.unshift(pto.reason);
    return reasonArr.join('--');
  };

  var hasDay = function hasDay() {
    var when = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var start = date.startOf('day');
    if (when === 'after') {
      return pto && !start.isSame(moment_default()(pto.end_date)) || availabilityArgs && availabilityArgs.unavailableAfter;
    }
    return pto && !start.isSame(moment_default()(pto.start_date)) || availabilityArgs && availabilityArgs.unavailableBefore;
  };

  return react_default.a.createElement(
    'article',
    {
      'data-tip': true, 'data-for': 'pto-' + tooltipId,
      className: classnames_default()(calendar_default.a.pto, (_cx = {}, calendarPTO__defineProperty(_cx, calendar_default.a.hasNextDay, hasDay('after')), calendarPTO__defineProperty(_cx, calendar_default.a.hasPreviousDay, hasDay()), _cx)),
      style: { position: 'relative' }
    },
    (availabilityArgs || pto && pto.reason) && react_default.a.createElement(
      react_tooltip_dist_default.a,
      {
        id: 'pto-' + tooltipId, place: 'top', effect: 'solid'
      },
      react_default.a.createElement(
        'span',
        null,
        tooltipReason()
      )
    ),
    react_default.a.createElement(
      es["c" /* Link */],
      { to: linkTo(assignee), className: calendar_default.a.link },
      'Unavailable'
    ),
    disablePto && react_default.a.createElement('div', {
      style: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 2,
        background: 'transparent',
        pointerEvents: 'all'
      }
    })
  );
};

calendarPTO_CalendarPTO.defaultProps = { disablePto: false };

calendarPTO_CalendarPTO.propTypes = {
  date: prop_types_default.a.instanceOf(moment_default.a).isRequired,
  assignee: prop_types_default.a.shape({
    id: prop_types_default.a.number.isRequired,
    kind: prop_types_default.a.oneOf(['Estimator', 'Crew', 'IQM']).isRequired
  }).isRequired,
  pto: prop_types_default.a.shape({
    id: prop_types_default.a.number.isRequired,
    start_date: prop_types_default.a.string.isRequired,
    end_date: prop_types_default.a.string.isRequired,
    reason: prop_types_default.a.string
  }).isRequired,
  availabilityArgs: prop_types_default.a.bool,
  disablePto: prop_types_default.a.bool
};

/* harmony default export */ var calendarPTO = (calendarPTO_CalendarPTO);
// CONCATENATED MODULE: ./client/app/screens/main/screens/schedule/components/calendarTWD.jsx
function calendarTWD__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var calendarTWD_CalendarTWD = function CalendarTWD(_ref) {
  var _cx;

  var date = _ref.date,
      _ref$twd = _ref.twd,
      twd = _ref$twd === undefined ? {} : _ref$twd;
  return react_default.a.createElement(
    'article',
    {
      className: classnames_default()(calendar_default.a.pto, (_cx = {}, calendarTWD__defineProperty(_cx, calendar_default.a.hasNextDay, !Object(lodash["isEmpty"])(twd) && !date.startOf('day').isSame(moment_default()(twd.end_date))), calendarTWD__defineProperty(_cx, calendar_default.a.hasPreviousDay, !Object(lodash["isEmpty"])(twd) && !date.startOf('day').isSame(moment_default()(twd.start_date))), _cx))
    },
    'Traveling Work Block'
  );
};

calendarTWD_CalendarTWD.propTypes = {
  date: prop_types_default.a.instanceOf(moment_default.a).isRequired,
  assignee: prop_types_default.a.shape({
    id: prop_types_default.a.number.isRequired,
    kind: prop_types_default.a.oneOf(['Estimator', 'Crew', 'IQM']).isRequired
  }).isRequired,
  twd: prop_types_default.a.shape({
    id: prop_types_default.a.number.isRequired,
    start_date: prop_types_default.a.string.isRequired,
    end_date: prop_types_default.a.string.isRequired,
    reason: prop_types_default.a.string
  })
};

/* harmony default export */ var calendarTWD = (calendarTWD_CalendarTWD);
// CONCATENATED MODULE: ./client/app/screens/main/screens/schedule/components/vendorBlock.jsx








var vendorBlock_VendorBlock = function VendorBlock(_ref) {
  var date = _ref.date,
      assignee = _ref.assignee;

  var tooltipId = date.clone().format(constants["E" /* DISPLAY_DATE */]) + '-' + assignee.id;
  return react_default.a.createElement(
    'article',
    { 'data-tip': true, 'data-for': 'vendorBlock-' + tooltipId, className: classnames_default()(calendar_default.a.pto) },
    react_default.a.createElement(
      react_tooltip_dist_default.a,
      { id: 'vendorBlock-' + tooltipId, place: 'top', effect: 'solid' },
      react_default.a.createElement(
        'span',
        null,
        'Assignee has an appt. scheduled outside of your service area'
      )
    ),
    'Unavailable'
  );
};

vendorBlock_VendorBlock.propTypes = {
  date: prop_types_default.a.instanceOf(moment_default.a).isRequired,
  assignee: prop_types_default.a.shape({ id: prop_types_default.a.number.isRequired }).isRequired
};

/* harmony default export */ var components_vendorBlock = (vendorBlock_VendorBlock);
// CONCATENATED MODULE: ./client/app/screens/main/screens/schedule/components/calendarAssigneeRow.jsx
var calendarAssigneeRow__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function calendarAssigneeRow__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function calendarAssigneeRow__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function calendarAssigneeRow__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function calendarAssigneeRow__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }























var calendarAssigneeRow_CalendarAssigneeRow = function (_Component) {
  calendarAssigneeRow__inherits(CalendarAssigneeRow, _Component);

  function CalendarAssigneeRow() {
    var _ref;

    var _temp, _this, _ret;

    calendarAssigneeRow__classCallCheck(this, CalendarAssigneeRow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = calendarAssigneeRow__possibleConstructorReturn(this, (_ref = CalendarAssigneeRow.__proto__ || Object.getPrototypeOf(CalendarAssigneeRow)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'state', {
      enumerable: true,
      writable: true,
      value: { expanded: _this.props.expand || true }
    }), Object.defineProperty(_this, 'componentWillReceiveProps', {
      enumerable: true,
      writable: true,
      value: function value(nextProps) {
        if (nextProps.expand !== _this.props.expand) _this.setState({ expanded: nextProps.expand });
      }
    }), Object.defineProperty(_this, 'onSelect', {
      enumerable: true,
      writable: true,
      value: function value(date, adjustedStartTime, ssBlockage) {
        return function () {
          return _this.props.onSelect && _this.props.onSelect(date, _this.props.member, adjustedStartTime, ssBlockage);
        };
      }
    }), Object.defineProperty(_this, 'onOpeningClick', {
      enumerable: true,
      writable: true,
      value: function value(nextOpening) {
        return _this.props.onOpeningClick && _this.props.onOpeningClick(nextOpening, _this.props.member);
      }
    }), Object.defineProperty(_this, 'getAllScheduled', {
      enumerable: true,
      writable: true,
      value: function value(ssAvailability) {
        if (Object(lodash["isEmpty"])(ssAvailability)) return [];
        var appts = ssAvailability.appts,
            pto = ssAvailability.pto;

        return appts.concat(pto);
      }
    }), Object.defineProperty(_this, 'getExistingAppts', {
      enumerable: true,
      writable: true,
      value: function value() {
        var appts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return appts.filter(function (a) {
          return a.id > 0;
        }) || [];
      }
    }), Object.defineProperty(_this, 'getAvailabilityArgs', {
      enumerable: true,
      writable: true,
      value: function value(date, availability) {
        return {
          unavailableBefore: !Object(schedulingUtils["h" /* isAvailableForDay */])(date.clone().subtract(1, 'day'), availability),
          unavailableAfter: !Object(schedulingUtils["h" /* isAvailableForDay */])(date.clone().add(1, 'day'), availability)
        };
      }
    }), Object.defineProperty(_this, 'getDailyAvailabilityFromAssignee', {
      enumerable: true,
      writable: true,
      value: function value(assigneeAvailabilities) {
        var allDays = [1, 2, 3, 4, 5, 6, 7];
        if (!assigneeAvailabilities.length) return { morning: allDays, afternoon: allDays };
        var dailyAvailabilities = assigneeAvailabilities.map(function (aA) {
          return aA.assignee_availability;
        }).filter(function (aA) {
          return aA.store_id === _this.props.pendingAppointment.phase.store.id;
        }).map(function (aA) {
          var _aA$morning = aA.morning,
              morning = _aA$morning === undefined ? [] : _aA$morning,
              _aA$afternoon = aA.afternoon,
              afternoon = _aA$afternoon === undefined ? [] : _aA$afternoon,
              _aA$evening = aA.evening,
              evening = _aA$evening === undefined ? [] : _aA$evening;

          var availabilityArr = Object(lodash["uniq"])(morning.concat(afternoon, evening)).map(function (i) {
            switch (i) {
              case 'sunday':
                return 1;
              case 'monday':
                return 2;
              case 'tuesday':
                return 3;
              case 'wednesday':
                return 4;
              case 'thursday':
                return 5;
              case 'friday':
                return 6;
              case 'saturday':
                return 7;
              default:
                return 0;
            }
          });
          return { morning: availabilityArr, afternoon: availabilityArr };
        });
        return dailyAvailabilities.length ? dailyAvailabilities[0] : { morning: [], afternoon: [] };
      }
    }), Object.defineProperty(_this, 'expand', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ expanded: true });
      }
    }), Object.defineProperty(_this, 'contract', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ expanded: false });
      }
    }), Object.defineProperty(_this, 'apptsOnDay', {
      enumerable: true,
      writable: true,
      value: function value(date, appts) {
        return appts.filter(function (a) {
          return moment_default.a.range(moment_default()(a.start_date), moment_default()(a.end_date)).contains(date);
        });
      }
    }), Object.defineProperty(_this, 'ptoOnDay', {
      enumerable: true,
      writable: true,
      value: function value(date, pto) {
        return pto.find(function (p) {
          return moment_default.a.range(moment_default()(p.start_date), moment_default()(p.end_date)).contains(date);
        });
      }
    }), Object.defineProperty(_this, 'twdOnDay', {
      enumerable: true,
      writable: true,
      value: function value(date, twd) {
        return twd.find(function (t) {
          return moment_default.a.range(moment_default()(t.start_date), moment_default()(t.end_date)).contains(date);
        });
      }
    }), Object.defineProperty(_this, 'isTWDBlocked', {
      enumerable: true,
      writable: true,
      value: function value(twd, phase, twdZip, coveredZips) {
        return !Object(lodash["isEmpty"])(phase) && (!Object(lodash["isEmpty"])(twd) && !twd.traveling_zip_codes.includes(phase.zip_code) || Object(lodash["isEmpty"])(twd) && twdZip && !coveredZips.includes(phase.zip_code));
      }
    }), Object.defineProperty(_this, 'isTWDZip', {
      enumerable: true,
      writable: true,
      value: function value(phaseZip, travelZips) {
        return travelZips.length < 1 ? false : travelZips.includes(phaseZip);
      }
    }), Object.defineProperty(_this, 'matchesSelectedAssignee', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            selectedAssignee = _this$props.selectedAssignee,
            assignee = _this$props.member.assignee;

        return selectedAssignee && assignee.id === selectedAssignee.id && assignee.kind === selectedAssignee.kind;
      }
    }), Object.defineProperty(_this, 'matchesSelectedDay', {
      enumerable: true,
      writable: true,
      value: function value(date) {
        var _this$props2 = _this.props,
            selectedDayStart = _this$props2.selectedDayStart,
            selectedDayEnd = _this$props2.selectedDayEnd,
            selectedAssignee = _this$props2.selectedAssignee;

        return selectedAssignee && selectedDayStart && selectedDayEnd && moment_default.a.range(selectedDayStart, selectedDayEnd).contains(date);
      }
    }), Object.defineProperty(_this, 'userHasVendorPerms', {
      enumerable: true,
      writable: true,
      value: function value(source) {
        var mvw = _this.props.manageVendorWorkrooms;

        return Object(utils["D" /* validateSource */])(source) ? mvw.lhi || false : mvw[source.toLowerCase()] || false;
      }
    }), Object.defineProperty(_this, 'isVendorBlocked', {
      enumerable: true,
      writable: true,
      value: function value(appts) {
        var _this$props3 = _this.props,
            isScheduleBoard = _this$props3.isScheduleBoard,
            phaseSource = _this$props3.phaseSource,
            phaseType = _this$props3.phaseType;

        var isEmployee = _this.isUserEmployee();
        if (isScheduleBoard) {
          return isEmployee && (appts || []).some(function (a) {
            return !_this.userHasVendorPerms(a.phase.source);
          });
        }
        return isEmployee && (!_this.userHasVendorPerms(phaseSource) || (appts || []).some(function (a) {
          var apptSource = a.phase.source;
          return !_this.userHasVendorPerms(apptSource) || phaseType !== 'Assessment' && (Object(utils["D" /* validateSource */])(phaseSource) ? !Object(utils["D" /* validateSource */])(a.phase.source) : phaseSource !== a.phase.source);
        }));
      }
    }), Object.defineProperty(_this, 'filterApptsByVendor', {
      enumerable: true,
      writable: true,
      value: function value(appts) {
        return appts.filter(function (a) {
          return !_this.isUserEmployee() || _this.userHasVendorPerms(a.phase.source);
        });
      }
    }), Object.defineProperty(_this, 'isSelected', {
      enumerable: true,
      writable: true,
      value: function value(date) {
        return _this.matchesSelectedDay(date) && _this.matchesSelectedAssignee();
      }
    }), Object.defineProperty(_this, 'isCrew', {
      enumerable: true,
      writable: true,
      value: function value(kind) {
        return kind === 'Crew';
      }
    }), Object.defineProperty(_this, 'isUserEmployee', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.employableType === 'Employee';
      }
    }), Object.defineProperty(_this, 'renderDay', {
      enumerable: true,
      writable: true,
      value: function value(date, appts, pto, applySsFeatures, twdData) {
        var allScheduled = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var expanded = _this.state.expanded;
        var _this$props4 = _this.props,
            selectable = _this$props4.selectable,
            onReschedule = _this$props4.onReschedule,
            relatedPhases = _this$props4.relatedPhases,
            _this$props4$pendingA = _this$props4.pendingAppointment,
            pendingAppointment = _this$props4$pendingA === undefined ? {} : _this$props4$pendingA,
            _this$props4$member = _this$props4.member,
            assignee = _this$props4$member.assignee,
            projectedCompletion = _this$props4$member.projectedCompletion,
            projectedJobLength = _this$props4$member.projectedJobLength,
            projectedJobDays = _this$props4$member.projectedJobDays,
            setDelayedField = _this$props4$member.setDelayedField,
            _this$props4$member$a = _this$props4$member.assignee,
            _this$props4$member$a2 = _this$props4$member$a.default_start_time,
            default_start_time = _this$props4$member$a2 === undefined ? '' : _this$props4$member$a2,
            _this$props4$member$a3 = _this$props4$member$a.covered_zip_codes,
            covered_zip_codes = _this$props4$member$a3 === undefined ? [] : _this$props4$member$a3,
            _this$props4$member$a4 = _this$props4$member$a.daily_availability,
            daily_availability = _this$props4$member$a4 === undefined ? {
          morning: [], afternoon: [] } : _this$props4$member$a4,
            _this$props4$member$a5 = _this$props4$member$a.kind,
            kind = _this$props4$member$a5 === undefined ? '' : _this$props4$member$a5,
            _this$props4$member$a6 = _this$props4$member$a.assignee_availabilities,
            assignee_availabilities = _this$props4$member$a6 === undefined ? [] : _this$props4$member$a6,
            isCcs = _this$props4.isCcs,
            isScheduleBoard = _this$props4.isScheduleBoard,
            employableType = _this$props4.employableType;

        var availabilityArgs = {};
        if (_this.isCrew(kind)) {
          availabilityArgs = _this.getAvailabilityArgs(date, daily_availability);
        } else if (kind === 'Estimator' && !isScheduleBoard) {
          var dailyAvailability = _this.getDailyAvailabilityFromAssignee(assignee_availabilities);
          availabilityArgs = _this.getAvailabilityArgs(date, dailyAvailability);
        }
        var twd = twdData.twd,
            twdZip = twdData.twdZip;

        var pendingAppt = calendarAssigneeRow__extends({}, pendingAppointment, { relatedPhases: relatedPhases });
        var daySched = { appts: appts, pto: pto };
        var ssBlockage = '';
        var adjustedStartTime = default_start_time;
        if (applySsFeatures) {
          var crew = calendarAssigneeRow__extends({}, assignee, { projectedCompletion: projectedCompletion, projectedJobLength: projectedJobLength, projectedJobDays: projectedJobDays });
          ssBlockage = Object(schedulingUtils["b" /* determineCellBlock */])(date, daySched, crew, pendingAppt, twdData, allScheduled, isCcs) || '';
          adjustedStartTime = _this.getExistingAppts(appts).length === 1 ? Object(schedulingUtils["a" /* determineAdjustedStartTime */])(_this.getExistingAppts(appts)[0], crew) : adjustedStartTime;
        }
        var vendorBlock = _this.isVendorBlocked(appts.filter(function (a) {
          return a.id > 0;
        }));
        var disablePto = ['Crew', 'Estimator', 'Installer'].includes(employableType);
        return react_default.a.createElement(
          react["Fragment"],
          null,
          react_default.a.createElement(
            calendarDayCell,
            {
              onSelect: ssBlockage && isCcs || vendorBlock ? function () {} : _this.onSelect(date, adjustedStartTime, ssBlockage),
              selectedRow: _this.matchesSelectedAssignee(),
              selectedCol: _this.matchesSelectedDay(date),
              key: date,
              className: calendar_default.a.day,
              expanded: expanded,
              selectable: selectable
            },
            vendorBlock ? react_default.a.createElement(components_vendorBlock, { date: date, assignee: assignee }) : react_default.a.createElement(
              react["Fragment"],
              null,
              ssBlockage && react_default.a.createElement(calendarBlock, {
                reason: ssBlockage,
                onSelect: _this.onSelect(date, adjustedStartTime, ssBlockage),
                adjustedStartTime: adjustedStartTime !== default_start_time && Object(schedulingUtils["i" /* isTimeBlocked */])(ssBlockage) ? moment_default()(appts[0].start_date + ' ' + adjustedStartTime).format(constants["G" /* DISPLAY_TIME */]) : ''
              }),
              (pto || !Object(lodash["isEmpty"])(availabilityArgs) && (!kind === 'Estimator' || !isScheduleBoard) && !Object(schedulingUtils["h" /* isAvailableForDay */])(date.clone(), _this.isCrew(kind) ? daily_availability : _this.getDailyAvailabilityFromAssignee(assignee_availabilities))) && react_default.a.createElement(calendarPTO, {
                pto: pto || null, date: date, assignee: assignee,
                availabilityArgs: !Object(lodash["isEmpty"])(availabilityArgs) ? availabilityArgs : null,
                disablePto: disablePto
              }),
              _this.isTWDBlocked(twd || {}, pendingAppointment.phase || {}, twdZip, covered_zip_codes) && react_default.a.createElement(calendarTWD, { twd: twd, date: date })
            ),
            react_default.a.createElement(
              'div',
              { className: calendar_default.a.appointmentsContainer },
              react_default.a.createElement(
                'div',
                { className: calendar_default.a.appointments },
                _this.filterApptsByVendor(appts).map(function (appointment, i) {
                  return expanded || i < 2 ? react_default.a.createElement(calendarAppointment, {
                    key: appointment.id,
                    selectedCell: (appts || []).length > 1 && appts.some(function (a) {
                      return a.id < 0;
                    }),
                    appointment: appointment,
                    date: date,
                    highlight: appointment.selected,
                    selectable: selectable,
                    onReschedule: onReschedule,
                    assignee: assignee,
                    applySsFeatures: applySsFeatures,
                    relatedPhases: relatedPhases,
                    pendingId: (pendingAppointment.phase || {}).id,
                    setDelayedField: setDelayedField
                  }) : null;
                })
              ),
              appts.length > 2 && !expanded && react_default.a.createElement(
                'div',
                { className: calendar_default.a.dayTotal },
                appts.length
              )
            )
          ),
          selectable && !vendorBlock && !(ssBlockage && isCcs) && react_default.a.createElement(
            react_responsive_default.a,
            { maxWidth: constants["y" /* CUT_POINT */] - 1 },
            function (isMobile) {
              return isMobile ? react_default.a.createElement(
                'button',
                {
                  onClick: _this.onSelect(date, adjustedStartTime, ssBlockage),
                  className: calendar_default.a.expand
                },
                react_default.a.createElement(
                  'span',
                  { className: calendar_default.a.label },
                  'Select Day'
                ),
                react_default.a.createElement(react_toolbox_lib["FontIcon"], { value: 'add' })
              ) : null;
            }
          )
        );
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props5 = _this.props,
            dates = _this$props5.dates,
            expand = _this$props5.expand,
            _this$props5$pendingA = _this$props5.pendingAppointment,
            pendingAppointment = _this$props5$pendingA === undefined ? {} : _this$props5$pendingA,
            role = _this$props5.role,
            phaseZip = _this$props5.phaseZip,
            applySmartScheduling = _this$props5.applySmartScheduling,
            isScheduleBoard = _this$props5.isScheduleBoard,
            _this$props5$selected = _this$props5.selectedAssignee,
            selectedAssignee = _this$props5$selected === undefined ? null : _this$props5$selected,
            phaseInstallerId = _this$props5.phaseInstallerId,
            phaseEstimatorId = _this$props5.phaseEstimatorId,
            _this$props5$member = _this$props5.member,
            _this$props5$member$a = _this$props5$member.assignee,
            id = _this$props5$member$a.id,
            kind = _this$props5$member$a.kind,
            _this$props5$member$a2 = _this$props5$member$a.specificMismatch,
            specificMismatch = _this$props5$member$a2 === undefined ? false : _this$props5$member$a2,
            _this$props5$member$a3 = _this$props5$member$a.traveling_zip_codes,
            traveling_zip_codes = _this$props5$member$a3 === undefined ? [] : _this$props5$member$a3,
            installer_id = _this$props5$member$a.installer_id,
            assignee = _this$props5$member.assignee,
            _this$props5$member$p = _this$props5$member.pto,
            pto = _this$props5$member$p === undefined ? [] : _this$props5$member$p,
            _this$props5$member$t = _this$props5$member.twd,
            twd = _this$props5$member$t === undefined ? [] : _this$props5$member$t,
            _this$props5$member$n = _this$props5$member.nextOpening,
            nextOpening = _this$props5$member$n === undefined ? '' : _this$props5$member$n,
            _this$props5$member$a4 = _this$props5$member.appointments,
            appointments = _this$props5$member$a4 === undefined ? [] : _this$props5$member$a4,
            _this$props5$member$s = _this$props5$member.ss_availability,
            ss_availability = _this$props5$member$s === undefined ? {} : _this$props5$member$s,
            _this$props5$member$p2 = _this$props5$member.projectedJobDays,
            projectedJobDays = _this$props5$member$p2 === undefined ? 0 : _this$props5$member$p2,
            _this$props5$member$p3 = _this$props5$member.projectedJobLength,
            projectedJobLength = _this$props5$member$p3 === undefined ? 0 : _this$props5$member$p3,
            _this$props5$member$p4 = _this$props5$member.projectedCompletion,
            projectedCompletion = _this$props5$member$p4 === undefined ? '' : _this$props5$member$p4;
        var expanded = _this.state.expanded;

        var appts = appointments.filter(function (a) {
          return !pendingAppointment || a.id !== pendingAppointment.id;
        });
        if (_this.matchesSelectedAssignee()) appts = [].concat(calendarAssigneeRow__toConsumableArray(appts), [calendarAssigneeRow__extends({}, pendingAppointment)]);
        var apptsByDay = dates.map(function (date) {
          return _this.apptsOnDay(date, appts);
        });
        var ptoByDay = dates.map(function (date) {
          return _this.ptoOnDay(date, pto);
        });
        var twdByDay = dates.map(function (date) {
          return _this.twdOnDay(date, twd);
        });
        var expandable = apptsByDay.some(function (day) {
          return day.length > 2;
        }) && !expand;
        var isIfi = _this.props.phaseSource === 'IFI';
        var isPreferredCrew = pendingAppointment && applySmartScheduling && _this.isCrew(kind) && !specificMismatch;
        var applySsFeatures = !isScheduleBoard && isPreferredCrew && !isIfi;
        // For IFI, the green "preferred" row means the phase's assigned installer's crew
        // (or assigned estimator) — the rows shown by default. Revealed "mismatched" rows stay white.
        var ifiMatchedRow = isIfi && !isScheduleBoard && (_this.isCrew(kind) && !!phaseInstallerId && installer_id === phaseInstallerId || kind === 'Estimator' && !!phaseEstimatorId && id === phaseEstimatorId);
        var highlightRow = isIfi ? ifiMatchedRow : isPreferredCrew && applySmartScheduling;
        var allScheduled = (applySsFeatures ? _this.getAllScheduled(ss_availability) : appts.concat(pto)) || [];
        var twdZip = _this.isTWDZip((pendingAppointment.phase || {}).zip_code || '', traveling_zip_codes || []);
        return react_default.a.createElement(
          calendarRow,
          {
            key: '' + (kind + id),
            className: highlightRow ? calendar_default.a.crewSpecificMatchRow : calendar_default.a.memberRow
          },
          react_default.a.createElement(
            calendarLegendCell,
            { className: calendar_default.a.assignee },
            react_default.a.createElement(calendarAssigneeInfo, {
              assignee: assignee,
              selectedAssignee: selectedAssignee,
              role: role,
              showProjectedTime: applySsFeatures,
              showIfTraveling: !isScheduleBoard && _this.isCrew(kind),
              projectedJobDays: projectedJobDays || 0,
              projectedJobLength: Math.round((projectedJobLength || 0) * 100) / 100,
              projectedCompletion: projectedCompletion,
              nextOpening: nextOpening || '',
              onOpeningClick: function onOpeningClick() {
                return _this.onOpeningClick(nextOpening || '');
              },
              phaseZip: phaseZip
            })
          ),
          dates.map(function (date, i) {
            return _this.renderDay(date, apptsByDay[i], ptoByDay[i], applySsFeatures, {
              twd: twdByDay[i], twdZip: twdZip
            }, allScheduled);
          }),
          expandable && !expanded && react_default.a.createElement(
            'button',
            { onClick: _this.expand, className: calendar_default.a.expand },
            react_default.a.createElement(
              'span',
              { className: calendar_default.a.label },
              'Expand Row'
            ),
            react_default.a.createElement(react_toolbox_lib["FontIcon"], { value: 'arrow_drop_down' })
          ),
          expandable && expanded && react_default.a.createElement(
            'button',
            { onClick: _this.contract, className: calendar_default.a.contract },
            react_default.a.createElement(
              'span',
              { className: calendar_default.a.label },
              'Close'
            ),
            react_default.a.createElement(react_toolbox_lib["FontIcon"], { value: 'arrow_drop_up' })
          )
        );
      }
    }), _temp), calendarAssigneeRow__possibleConstructorReturn(_this, _ret);
  }

  return CalendarAssigneeRow;
}(react["Component"]);

calendarAssigneeRow_CalendarAssigneeRow.propTypes = {
  dates: prop_types_default.a.arrayOf(prop_types_default.a.instanceOf(moment_default.a)).isRequired,
  member: scheduleMember.isRequired,
  expand: prop_types_default.a.bool,
  onSelect: prop_types_default.a.func,
  selectedDayStart: prop_types_default.a.instanceOf(moment_default.a),
  selectedDayEnd: prop_types_default.a.instanceOf(moment_default.a),
  selectedAssignee: prop_types_default.a.shape({
    id: prop_types_default.a.number,
    kind: prop_types_default.a.string
  }),
  pendingAppointment: AppointmentType,
  selectable: prop_types_default.a.bool,
  onReschedule: prop_types_default.a.func,
  role: prop_types_default.a.string,
  isScheduleBoard: prop_types_default.a.bool,
  applySmartScheduling: prop_types_default.a.bool,
  onOpeningClick: prop_types_default.a.func,
  relatedPhases: prop_types_default.a.array,
  setDelayedField: prop_types_default.a.func,
  isCcs: prop_types_default.a.bool,
  manageVendorWorkrooms: prop_types_default.a.object,
  employableType: prop_types_default.a.string,
  phaseSource: prop_types_default.a.string,
  phaseZip: prop_types_default.a.string,
  phaseType: prop_types_default.a.string,
  phaseInstallerId: prop_types_default.a.number,
  phaseEstimatorId: prop_types_default.a.number
};

/* harmony default export */ var calendarAssigneeRow = (calendarAssigneeRow_CalendarAssigneeRow);
// CONCATENATED MODULE: ./client/app/screens/main/screens/schedule/components/schedulingCalendar.jsx
function schedulingCalendar__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function schedulingCalendar__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function schedulingCalendar__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function schedulingCalendar__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function schedulingCalendar__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















__webpack_require__("l5j/");

var schedulingCalendar_SchedulingCalendar = function (_Component) {
  schedulingCalendar__inherits(SchedulingCalendar, _Component);

  function SchedulingCalendar() {
    var _ref;

    var _temp, _this, _ret;

    schedulingCalendar__classCallCheck(this, SchedulingCalendar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = schedulingCalendar__possibleConstructorReturn(this, (_ref = SchedulingCalendar.__proto__ || Object.getPrototypeOf(SchedulingCalendar)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'onSelect', {
      enumerable: true,
      writable: true,
      value: function value(selectedDay, selectedMember, adjustedStartTime, ssBlockage) {
        return _this.props.onSelect && _this.props.onSelect(selectedDay, selectedMember, adjustedStartTime, ssBlockage);
      }
    }), Object.defineProperty(_this, 'onOpeningClick', {
      enumerable: true,
      writable: true,
      value: function value(nextOpening, selectedMember) {
        return _this.props.onOpeningClick && _this.props.onOpeningClick(nextOpening, selectedMember);
      }
    }), Object.defineProperty(_this, 'handleReschedule', {
      enumerable: true,
      writable: true,
      value: function value(appt) {
        return _this.props.navigate('/phases/' + appt.phase.id + '/appointments/' + appt.id + '/edit/' + appt.kind);
      }
    }), Object.defineProperty(_this, 'isAssignedInstallerCrew', {
      enumerable: true,
      writable: true,
      value: function value(assignee) {
        return _this.props.phaseSource === 'IFI' && !!_this.props.phaseInstallerId && assignee.installer_id === _this.props.phaseInstallerId;
      }
    }), Object.defineProperty(_this, 'isAssignedEstimator', {
      enumerable: true,
      writable: true,
      value: function value(assignee) {
        return _this.props.phaseSource === 'IFI' && !!_this.props.phaseEstimatorId && assignee.id === _this.props.phaseEstimatorId;
      }
    }), Object.defineProperty(_this, 'isIfiMatched', {
      enumerable: true,
      writable: true,
      value: function value(assignee) {
        if (assignee.kind === 'Crew') return _this.isAssignedInstallerCrew(assignee);
        if (assignee.kind === 'Estimator') return _this.isAssignedEstimator(assignee);
        return false;
      }
    }), Object.defineProperty(_this, 'sortAssignedFirst', {
      enumerable: true,
      writable: true,
      value: function value(members) {
        return _this.props.phaseSource !== 'IFI' ? members : [].concat(schedulingCalendar__toConsumableArray(members.filter(function (m) {
          return _this.isIfiMatched(m.assignee);
        })), schedulingCalendar__toConsumableArray(members.filter(function (m) {
          return !_this.isIfiMatched(m.assignee);
        })));
      }
    }), Object.defineProperty(_this, 'membersCoverPhaseZip', {
      enumerable: true,
      writable: true,
      value: function value(members, zip) {
        return members.filter(function (m) {
          return m.assignee.kind !== 'Crew' || m.assignee.covered_zip_codes.includes(zip) || m.assignee.traveling_zip_codes.includes(zip) || _this.isAssignedInstallerCrew(m.assignee);
        });
      }
    }), Object.defineProperty(_this, 'membersMatchPhase', {
      enumerable: true,
      writable: true,
      value: function value(members, applySsFilters, showMismatchedCrews) {
        return members.filter(function (m) {
          return !applySsFilters || showMismatchedCrews || m.assignee.kind !== 'Crew' || !m.assignee.specificMismatch;
        });
      }
    }), Object.defineProperty(_this, 'filteredMembers', {
      enumerable: true,
      writable: true,
      value: function value(members, phaseZip) {
        var _this$props = _this.props,
            applySsFilters = _this$props.applySsFilters,
            showMismatchedCrews = _this$props.showMismatchedCrews,
            phaseSource = _this$props.phaseSource,
            phaseEstimatorId = _this$props.phaseEstimatorId,
            phaseInstallerId = _this$props.phaseInstallerId;

        var membersByZip = _this.membersCoverPhaseZip(members, phaseZip);
        var byPhaseMatch = _this.membersMatchPhase(membersByZip, applySsFilters, showMismatchedCrews);
        var byAssignment = Object(schedulingUtils["l" /* membersMatchAssignment */])(byPhaseMatch, phaseSource, showMismatchedCrews, phaseEstimatorId, phaseInstallerId);
        return _this.sortAssignedFirst(byAssignment);
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _cx;

        var _this$props2 = _this.props,
            _this$props2$schedule = _this$props2.schedule,
            loading = _this$props2$schedule.loading,
            filters = _this$props2$schedule.filters,
            members = _this$props2$schedule.members,
            dates = _this$props2.dates,
            role = _this$props2.role,
            isCcs = _this$props2.isCcs,
            selectedDayStart = _this$props2.selectedDayStart,
            selectedDayEnd = _this$props2.selectedDayEnd,
            pendingAppointment = _this$props2.pendingAppointment,
            phaseZip = _this$props2.phaseZip,
            selectedAssignee = _this$props2.selectedAssignee,
            selectable = _this$props2.selectable,
            isScheduleBoard = _this$props2.isScheduleBoard,
            employableType = _this$props2.employableType,
            applySmartScheduling = _this$props2.applySmartScheduling,
            relatedPhases = _this$props2.relatedPhases,
            setDelayedField = _this$props2.setDelayedField,
            phaseSource = _this$props2.phaseSource,
            emptyResultsMsg = _this$props2.emptyResultsMsg,
            manageVendorWorkrooms = _this$props2.manageVendorWorkrooms,
            phaseType = _this$props2.phaseType,
            phaseEstimatorId = _this$props2.phaseEstimatorId,
            phaseInstallerId = _this$props2.phaseInstallerId;

        var filteredMembers = isScheduleBoard ? members : _this.filteredMembers(members, phaseZip);
        var className = classnames_default()((_cx = {}, schedulingCalendar__defineProperty(_cx, calendar_default.a.calendar, true), schedulingCalendar__defineProperty(_cx, calendar_default.a.loading, loading), _cx), _this.props.className);
        return react_default.a.createElement(
          'div',
          { className: className },
          _this.props.children,
          loading && react_default.a.createElement(components_Loading, { className: calendar_default.a.spinner }),
          filteredMembers.length === 0 && !loading && react_default.a.createElement(
            'div',
            { className: calendar_default.a.empty },
            Object(lodash["isEmpty"])(filters) ? 'No Appointments Scheduled For This Time Period' : emptyResultsMsg
          ),
          !loading && filteredMembers.map(function (m) {
            return react_default.a.createElement(calendarAssigneeRow, {
              key: '' + m.assignee.kind + m.assignee.id,
              member: m,
              onSelect: _this.onSelect,
              dates: dates,
              expand: filteredMembers.length < 2,
              selectedDayStart: selectedDayStart,
              selectedDayEnd: selectedDayEnd,
              selectedAssignee: selectedAssignee,
              pendingAppointment: pendingAppointment,
              selectable: selectable,
              onReschedule: _this.handleReschedule,
              role: role,
              isScheduleBoard: isScheduleBoard,
              applySmartScheduling: applySmartScheduling,
              onOpeningClick: _this.onOpeningClick,
              relatedPhases: relatedPhases,
              setDelayedField: setDelayedField,
              isCcs: isCcs,
              phaseZip: phaseZip,
              phaseType: phaseType,
              phaseSource: phaseSource,
              phaseEstimatorId: phaseEstimatorId,
              phaseInstallerId: phaseInstallerId,
              manageVendorWorkrooms: manageVendorWorkrooms,
              employableType: employableType
            });
          })
        );
      }
    }), _temp), schedulingCalendar__possibleConstructorReturn(_this, _ret);
  }

  // For IFI, keep the assigned (green) estimator/installer crews at the top of the list.


  return SchedulingCalendar;
}(react["Component"]);

schedulingCalendar_SchedulingCalendar.propTypes = {
  children: prop_types_default.a.node,
  navigate: prop_types_default.a.func.isRequired,
  className: prop_types_default.a.string,
  dates: prop_types_default.a.arrayOf(prop_types_default.a.instanceOf(moment_default.a)).isRequired,
  days: prop_types_default.a.number.isRequired,
  selectable: prop_types_default.a.bool,
  selectedDayStart: prop_types_default.a.instanceOf(moment_default.a),
  selectedDayEnd: prop_types_default.a.instanceOf(moment_default.a),
  selectedAssignee: prop_types_default.a.shape({
    id: prop_types_default.a.number,
    kind: prop_types_default.a.string
  }),
  onSelect: prop_types_default.a.func,
  pendingAppointment: AppointmentType,
  role: prop_types_default.a.string,
  isScheduleBoard: prop_types_default.a.bool,
  applySmartScheduling: prop_types_default.a.bool,
  onOpeningClick: prop_types_default.a.func,
  relatedPhases: prop_types_default.a.array,
  schedule: types_schedule.isRequired,
  setDelayedField: prop_types_default.a.func,
  phaseZip: prop_types_default.a.string,
  phaseType: prop_types_default.a.string,
  phaseSource: prop_types_default.a.string,
  phaseEstimatorId: prop_types_default.a.number,
  phaseInstallerId: prop_types_default.a.number,
  isCcs: prop_types_default.a.bool,
  emptyResultsMsg: prop_types_default.a.string,
  manageVendorWorkrooms: prop_types_default.a.object,
  employableType: prop_types_default.a.string,
  applySsFilters: prop_types_default.a.bool,
  showMismatchedCrews: prop_types_default.a.bool
};

schedulingCalendar_SchedulingCalendar.defaultProps = {
  filters: {},
  className: '',
  isScheduleBoard: false,
  relatedPhases: []
};

/* harmony default export */ var schedulingCalendar = (Object(react_redux_es["connect"])(function () {
  return {};
}, { navigate: actionCreators["O" /* navigate */] })(schedulingCalendar_SchedulingCalendar));
// CONCATENATED MODULE: ./client/app/screens/main/screens/schedule/components/calendarJumpDate.jsx
var calendarJumpDate__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function calendarJumpDate__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function calendarJumpDate__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function calendarJumpDate__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var calendarJumpDate_CalendarJumpDate = function (_Component) {
  calendarJumpDate__inherits(CalendarJumpDate, _Component);

  function CalendarJumpDate() {
    var _ref;

    var _temp, _this, _ret;

    calendarJumpDate__classCallCheck(this, CalendarJumpDate);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = calendarJumpDate__possibleConstructorReturn(this, (_ref = CalendarJumpDate.__proto__ || Object.getPrototypeOf(CalendarJumpDate)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'handleJumpDate', {
      enumerable: true,
      writable: true,
      value: function value(date) {
        var filters = _this.props.filters;

        var options = {};
        var jumpDate = moment_default()(date, 'MM-DD-YYYY');
        if (Object.keys(filters).length) options.query = filters;
        if (_this.props.handleJumpDate) {
          _this.props.handleJumpDate(jumpDate);
        } else {
          _this.props.navigate(urls.schedule(jumpDate, options));
        }
      }
    }), _temp), calendarJumpDate__possibleConstructorReturn(_this, _ret);
  }

  calendarJumpDate__createClass(CalendarJumpDate, [{
    key: 'render',
    value: function render() {
      return react_default.a.createElement(DatePicker, {
        placeholder: 'Jump To Date',
        onChange: this.handleJumpDate,
        className: calendar_default.a.datePicker
      });
    }
  }]);

  return CalendarJumpDate;
}(react["Component"]);

calendarJumpDate_CalendarJumpDate.propTypes = {
  filters: CalendarFilterType,
  handleJumpDate: prop_types_default.a.func,
  navigate: prop_types_default.a.func.isRequired
};

/* harmony default export */ var calendarJumpDate = (transpiled_default()()(Object(react_redux_es["connect"])(function () {
  return {};
}, { navigate: actionCreators["O" /* navigate */] })(calendarJumpDate_CalendarJumpDate)));
// CONCATENATED MODULE: ./client/app/screens/main/screens/schedule/components/calendarContainer.jsx
var calendarContainer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function calendarContainer__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function calendarContainer__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function calendarContainer__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function calendarContainer__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






















var CalendarContainer = function (_Component) {
  calendarContainer__inherits(CalendarContainer, _Component);

  function CalendarContainer(props) {
    calendarContainer__classCallCheck(this, CalendarContainer);

    var _this = calendarContainer__possibleConstructorReturn(this, (CalendarContainer.__proto__ || Object.getPrototypeOf(CalendarContainer)).call(this, props));

    calendarContainer__initialiseProps.call(_this);

    _this.onShowMismatchedCrewsClick = _this.onShowMismatchedCrewsClick.bind(_this);
    var _this$props = _this.props,
        filters = _this$props.filters,
        role = _this$props.role,
        isScheduleBoard = _this$props.isScheduleBoard,
        applySmartScheduling = _this$props.applySmartScheduling;

    _this.state = {
      showSsFilters: applySmartScheduling && !isScheduleBoard,
      showMismatchedCrews: false,
      stateFilters: filters,
      emptyResultsMsg: !['installer', 'estimator'].includes(role) && isScheduleBoard ? "Check filters then click 'Load Schedule' button for results." : 'There are no appointments listed for the filter you have applied.'
    };
    return _this;
  }

  return CalendarContainer;
}(react["Component"]);

var calendarContainer__initialiseProps = function _initialiseProps() {
  var _this2 = this;

  Object.defineProperty(this, 'componentWillMount', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _props = _this2.props,
          startDate = _props.startDate,
          days = _props.days,
          filters = _props.filters,
          isScheduleBoard = _props.isScheduleBoard,
          isCcs = _props.isCcs,
          _props$defaultCalStar = _props.defaultCalStart,
          defaultCalStart = _props$defaultCalStar === undefined ? null : _props$defaultCalStar,
          _props$employableId = _props.employableId,
          employableId = _props$employableId === undefined ? null : _props$employableId,
          _props$role = _props.role,
          role = _props$role === undefined ? '' : _props$role,
          _props$username = _props.username,
          username = _props$username === undefined ? '' : _props$username,
          _props$pendingAppoint = _props.pendingAppointment,
          pendingAppointment = _props$pendingAppoint === undefined ? null : _props$pendingAppoint,
          applySmartScheduling = _props.applySmartScheduling,
          phaseSource = _props.phaseSource;

      var calendarArgs = { days: days, isScheduleBoard: isScheduleBoard };
      if (!['installer', 'estimator'].includes(role) && isScheduleBoard) {
        _this2.loadMembers(startDate, filters, {}, { emptyMembers: true });
      }
      if (!['installer', 'estimator', 'iqm'].includes(role)) {
        _this2.props.requestEmployee(employableId).then(function () {
          if ((filters.workroom.length || []).length === 0) _this2.determineWorkroomStateValue();
        });
      }
      if (role === 'iqm') {
        _this2.props.requestIQM(employableId).then(function () {
          if ((filters.workroom.length || []).length === 0) _this2.determineWorkroomStateValue();
        });
      }
      if (!isScheduleBoard) {
        _this2.loadMembers(startDate || new Date(), filters, calendarArgs, {
          defaultCalStart: defaultCalStart,
          role: role,
          username: username,
          pendingAppointment: pendingAppointment,
          applySmartScheduling: applySmartScheduling,
          isCcs: isCcs,
          phaseSource: phaseSource
        });
      }
      if (isScheduleBoard && ['installer', 'estimator'].includes(role)) {
        _this2.loadMembers(startDate || new Date(), filters, calendarArgs, { defaultCalStart: defaultCalStart, role: role, username: username, pendingAppointment: pendingAppointment });
      }
    }
  });
  Object.defineProperty(this, 'componentWillReceiveProps', {
    enumerable: true,
    writable: true,
    value: function value(newProps) {
      var startDate = newProps.startDate,
          days = newProps.days,
          filters = newProps.filters,
          isScheduleBoard = newProps.isScheduleBoard,
          selectedDayStart = newProps.selectedDayStart;

      if (!Object(lodash["isEqual"])(_this2.props.filters, filters) || _this2.props.startDate.getTime() !== startDate.getTime() || _this2.props.days !== days || !isScheduleBoard && selectedDayStart !== _this2.props.selectedDayStart) {
        var calendarArgs = { days: days, isScheduleBoard: isScheduleBoard };
        var addtlArgs = {};
        if (!isScheduleBoard) {
          var defaultCalStart = newProps.defaultCalStart,
              role = newProps.role,
              username = newProps.username,
              pendingAppointment = newProps.pendingAppointment,
              applySmartScheduling = newProps.applySmartScheduling,
              isCcs = newProps.isCcs,
              phaseSource = newProps.phaseSource;

          addtlArgs = {
            defaultCalStart: defaultCalStart,
            role: role,
            username: username,
            pendingAppointment: pendingAppointment,
            applySmartScheduling: applySmartScheduling,
            isCcs: isCcs,
            phaseSource: phaseSource
          };
        }
        if (!Object(lodash["isEqual"])(_this2.props.startDate, startDate) || !isScheduleBoard && !Object(lodash["isEqual"])(_this2.props.filters, filters)) {
          _this2.loadMembers(startDate, filters, calendarArgs, addtlArgs);
        }
      }
    }
  });
  Object.defineProperty(this, 'onLoadScheduleClick', {
    enumerable: true,
    writable: true,
    value: function value(newFilters) {
      var _props2 = _this2.props,
          updateScheduleFilters = _props2.updateScheduleFilters,
          updateFilters = _props2.updateFilters,
          startDate = _props2.startDate,
          days = _props2.days,
          isScheduleBoard = _props2.isScheduleBoard;

      var calendarArgs = { days: days, isScheduleBoard: isScheduleBoard };
      updateScheduleFilters(newFilters).then(function () {
        return _this2.loadMembers(startDate, newFilters, calendarArgs, {});
      }).then(function () {
        return _this2.state.emptyResultsMsg.includes('Load Schedule') ? _this2.setState({ emptyResultsMsg: 'There are no appointments listed for the filter you have applied.' }, function () {
          return updateFilters(newFilters);
        }) : updateFilters(newFilters);
      });
    }
  });
  Object.defineProperty(this, 'onShowMismatchedCrewsClick', {
    enumerable: true,
    writable: true,
    value: function value() {
      return _this2.setState({ showMismatchedCrews: !_this2.state.showMismatchedCrews });
    }
  });
  Object.defineProperty(this, 'handleScheduleFilterChange', {
    enumerable: true,
    writable: true,
    value: function value(key, values) {
      return _this2.setState({ stateFilters: calendarContainer__extends({}, _this2.state.stateFilters, calendarContainer__defineProperty({}, key, values)) });
    }
  });
  Object.defineProperty(this, 'determineWorkroomStateValue', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _props3 = _this2.props,
          employee = _props3.employee,
          iqm = _props3.iqm;

      if (!Object(lodash["isEmpty"])(employee)) {
        _this2.handleScheduleFilterChange('workroom', employee.workrooms.map(function (w) {
          return w.id;
        }));
      }
      if (!Object(lodash["isEmpty"])(iqm)) {
        _this2.handleScheduleFilterChange('workroom', iqm.workrooms.map(function (w) {
          return w.id;
        }));
      }
    }
  });
  Object.defineProperty(this, 'loadMembers', {
    enumerable: true,
    writable: true,
    value: function value(startDate, filters, calendarArgs, addtlArgs) {
      return _this2.props.loadSchedule(startDate, filters, true, calendarArgs, addtlArgs);
    }
  });
  Object.defineProperty(this, 'render', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _cx, _cx2;

      var _props4 = _this2.props,
          isDesktop = _props4.isDesktop,
          navigatePast = _props4.navigatePast,
          navigateFuture = _props4.navigateFuture,
          scrolling = _props4.scrolling,
          title = _props4.title,
          toggleFilters = _props4.toggleFilters,
          currentPage = _props4.currentPage,
          currentTab = _props4.currentTab,
          filters = _props4.filters,
          handleJumpDate = _props4.handleJumpDate,
          dates = _props4.dates,
          calDates = _props4.calDates,
          headerClassName = _props4.headerClassName,
          active = _props4.active,
          onFilterChange = _props4.onFilterChange,
          filterClassName = _props4.filterClassName,
          onClose = _props4.onClose,
          theme = _props4.theme,
          isScheduleBoard = _props4.isScheduleBoard,
          handleDeliveryValidation = _props4.handleDeliveryValidation,
          schedule = _props4.schedule,
          setDelayedField = _props4.setDelayedField,
          applySmartScheduling = _props4.applySmartScheduling,
          startDate = _props4.startDate,
          days = _props4.days,
          selectable = _props4.selectable,
          selectedDayStart = _props4.selectedDayStart,
          selectedDayEnd = _props4.selectedDayEnd,
          selectedAssignee = _props4.selectedAssignee,
          onSelect = _props4.onSelect,
          pendingAppointment = _props4.pendingAppointment,
          role = _props4.role,
          onOpeningClick = _props4.onOpeningClick,
          relatedPhases = _props4.relatedPhases,
          phaseSource = _props4.phaseSource,
          phaseZip = _props4.phaseZip,
          calRef = _props4.calRef,
          isCcs = _props4.isCcs,
          manageVendorWorkrooms = _props4.manageVendorWorkrooms,
          employableType = _props4.employableType,
          phaseType = _props4.phaseType,
          phaseEstimatorId = _props4.phaseEstimatorId,
          phaseInstallerId = _props4.phaseInstallerId,
          loading = _props4.schedule.loading;
      var _state = _this2.state,
          stateFilters = _state.stateFilters,
          emptyResultsMsg = _state.emptyResultsMsg,
          showSsFilters = _state.showSsFilters,
          showMismatchedCrews = _state.showMismatchedCrews;
      // IFI phase scheduling gets the mismatch toggle too (it never had it for
      // Assessment/Workorder before), but specificMismatch filtering must NOT apply to IFI —
      // IFI visibility is governed solely by the assigned estimator/installer match.

      var isIfiPhaseSchedule = phaseSource === 'IFI' && !isScheduleBoard && ['Assessment', 'Installation', 'Workorder'].includes(phaseType);
      var showMismatchToggle = showSsFilters || isIfiPhaseSchedule;
      var applySsFilters = showSsFilters && phaseSource !== 'IFI';
      return react_default.a.createElement(
        'div',
        null,
        react_default.a.createElement(
          components_CalendarActionBar,
          {
            showAdd: false,
            title: title,
            toggleFilters: loading ? function () {} : toggleFilters,
            currentPage: currentPage,
            currentTab: currentTab,
            role: role
          },
          react_default.a.createElement(calendarJumpDate, {
            filters: filters,
            handleJumpDate: loading ? function () {} : handleJumpDate
          }),
          isScheduleBoard && !['installer', 'estimator'].includes(role) && react_default.a.createElement(ColoredButton["a" /* default */], {
            className: calendar_default.a.loadButton,
            responsive: true,
            color: 'green',
            label: 'Load Schedule',
            disabled: (stateFilters.workroom || []).length === 0,
            onClick: isScheduleBoard ? function () {
              return _this2.onLoadScheduleClick(stateFilters);
            } : function () {
              return _this2.loadMembers(startDate, stateFilters, { days: days, isScheduleBoard: isScheduleBoard }, {});
            }
          }),
          isDesktop ? react_default.a.createElement(calendarLegend, null) : react_default.a.createElement(calendarHeader, {
            currentPage: currentPage,
            dates: dates.slice(0, constants["_10" /* NUM_DAYS_MOBILE */]),
            navigatePast: loading ? function () {} : navigatePast(constants["_10" /* NUM_DAYS_MOBILE */]),
            navigateFuture: loading ? function () {} : navigateFuture(constants["_10" /* NUM_DAYS_MOBILE */]),
            className: classnames_default()(headerClassName, (_cx = {}, calendarContainer__defineProperty(_cx, calendar_default.a.inAppointments, currentTab === 'appointments'), calendarContainer__defineProperty(_cx, calendar_default.a.inSchedule, currentPage === 'schedule'), calendarContainer__defineProperty(_cx, calendar_default.a.scrolling, scrolling), _cx))
          })
        ),
        react_default.a.createElement(calendarFilters, {
          role: role,
          active: active,
          phaseType: phaseType,
          phaseSource: phaseSource,
          onFilterChange: isScheduleBoard ? _this2.handleScheduleFilterChange : onFilterChange,
          filters: isScheduleBoard ? stateFilters : filters,
          className: filterClassName,
          onClose: loading ? function () {} : onClose,
          theme: theme,
          handleDeliveryValidation: handleDeliveryValidation,
          showSsFilters: showMismatchToggle,
          showMismatchedCrews: showMismatchedCrews,
          onShowMismatchedCrewsClick: _this2.onShowMismatchedCrewsClick
        }),
        react_default.a.createElement(
          schedulingCalendar,
          {
            dates: calDates,
            emptyResultsMsg: emptyResultsMsg,
            startDate: startDate,
            days: days,
            selectable: selectable,
            selectedDayStart: selectedDayStart,
            selectedDayEnd: selectedDayEnd,
            selectedAssignee: selectedAssignee,
            onSelect: onSelect,
            pendingAppointment: pendingAppointment,
            role: role,
            isScheduleBoard: isScheduleBoard,
            applySmartScheduling: applySmartScheduling,
            onOpeningClick: onOpeningClick,
            relatedPhases: relatedPhases,
            schedule: schedule,
            setDelayedField: setDelayedField,
            phaseZip: phaseZip,
            phaseType: phaseType,
            phaseSource: phaseSource,
            phaseEstimatorId: phaseEstimatorId,
            phaseInstallerId: phaseInstallerId,
            isCcs: isCcs,
            manageVendorWorkrooms: manageVendorWorkrooms,
            employableType: employableType,
            applySsFilters: applySsFilters,
            showMismatchedCrews: showMismatchedCrews
          },
          isDesktop && react_default.a.createElement(calendarHeader, {
            ref: calRef,
            dates: dates.slice(0, constants["_9" /* NUM_DAYS_DESKTOP */]),
            navigatePast: loading ? function () {} : navigatePast(constants["_9" /* NUM_DAYS_DESKTOP */]),
            navigateFuture: loading ? function () {} : navigateFuture(constants["_9" /* NUM_DAYS_DESKTOP */]),
            className: classnames_default()(headerClassName, (_cx2 = {}, calendarContainer__defineProperty(_cx2, calendar_default.a.inAppointments, currentTab === 'appointments'), calendarContainer__defineProperty(_cx2, calendar_default.a.inSchedule, currentPage === 'schedule'), calendarContainer__defineProperty(_cx2, calendar_default.a.scrolling, scrolling), _cx2))
          })
        )
      );
    }
  });
};

CalendarContainer.propTypes = {
  canLoadSchedule: prop_types_default.a.bool,
  setCanLoadSchedule: prop_types_default.a.func,
  loadSchedule: prop_types_default.a.func.isRequired,
  schedule: types_schedule.isRequired,
  isDesktop: prop_types_default.a.bool,
  navigatePast: prop_types_default.a.func.isRequired,
  navigateFuture: prop_types_default.a.func.isRequired,
  scrolling: prop_types_default.a.string,
  title: prop_types_default.a.string,
  toggleFilters: prop_types_default.a.func,
  currentPage: prop_types_default.a.string,
  currentTab: prop_types_default.a.string,
  filters: CalendarFilterType,
  handleJumpDate: prop_types_default.a.func,
  dates: prop_types_default.a.arrayOf(prop_types_default.a.instanceOf(moment_default.a)).isRequired,
  headerClassName: prop_types_default.a.string,
  active: prop_types_default.a.bool.isRequired,
  onFilterChange: prop_types_default.a.func.isRequired,
  filterClassName: prop_types_default.a.string,
  onClose: prop_types_default.a.func.isRequired,
  theme: prop_types_default.a.shape({
    RTDrawer: prop_types_default.a.string,
    RTList: prop_types_default.a.string,
    RTOverlay: prop_types_default.a.string
  }),
  isScheduleBoard: prop_types_default.a.bool,
  applySmartScheduling: prop_types_default.a.bool,
  handleDeliveryValidation: prop_types_default.a.func,
  calDates: prop_types_default.a.arrayOf(prop_types_default.a.instanceOf(moment_default.a)).isRequired,
  startDate: prop_types_default.a.instanceOf(Date).isRequired,
  defaultCalStart: prop_types_default.a.instanceOf(Date),
  days: prop_types_default.a.number.isRequired,
  selectable: prop_types_default.a.bool,
  selectedDayStart: prop_types_default.a.instanceOf(moment_default.a),
  selectedDayEnd: prop_types_default.a.instanceOf(moment_default.a),
  selectedAssignee: prop_types_default.a.shape({
    id: prop_types_default.a.number,
    kind: prop_types_default.a.string
  }),
  onSelect: prop_types_default.a.func,
  pendingAppointment: AppointmentType,
  role: prop_types_default.a.string,
  username: prop_types_default.a.string,
  employableId: prop_types_default.a.number,
  onOpeningClick: prop_types_default.a.func,
  relatedPhases: prop_types_default.a.array,
  calRef: prop_types_default.a.oneOfType([prop_types_default.a.func, prop_types_default.a.shape({ current: prop_types_default.a.any })]),
  setDelayedField: prop_types_default.a.func,
  phaseZip: prop_types_default.a.string,
  phaseType: prop_types_default.a.string,
  phaseSource: prop_types_default.a.string,
  phaseEstimatorId: prop_types_default.a.number,
  phaseInstallerId: prop_types_default.a.number,
  isCcs: prop_types_default.a.bool,
  requestEmployee: prop_types_default.a.func,
  requestIQM: prop_types_default.a.func,
  employee: prop_types_default.a.object,
  iqm: prop_types_default.a.object,
  onLoadScheduleClick: prop_types_default.a.func,
  updateScheduleFilters: prop_types_default.a.func,
  updateFilters: prop_types_default.a.func,
  manageVendorWorkrooms: prop_types_default.a.object,
  employableType: prop_types_default.a.string
};

CalendarContainer.defaultProps = {
  title: 'Calendar',
  dates: [],
  date: new Date(),
  onFilterChange: function onFilterChange() {},
  filters: {},
  navigatePast: function navigatePast() {},
  navigateFuture: function navigateFuture() {},
  selectable: false,
  isScheduleBoard: false,
  relatedPhases: [],
  manageVendorWorkrooms: constants["B" /* DEFAULT_MVW */]
};

var calendarContainer_mapStateToProps = function mapStateToProps(state, ownProps) {
  var role = ownProps.role,
      employableId = ownProps.employableId;

  var employee = role && !['Estimator', 'Installer', 'iqm'].includes(role) ? Object(reducers["i" /* getEmployeeById */])(state)[Number(employableId)] : {};
  var iqm = role && role === 'iqm' ? state.iqms.details : {};
  return {
    schedule: state.schedule,
    manageVendorWorkrooms: Object(reducers["N" /* getManageVendorWorkrooms */])(state),
    employableType: state.user.employable_type,
    employee: employee,
    iqm: iqm
  };
};

/* harmony default export */ var calendarContainer = (Object(react_redux_es["connect"])(calendarContainer_mapStateToProps, {
  loadSchedule: actionCreators["I" /* loadSchedule */],
  requestEmployee: actionCreators["X" /* requestEmployee */],
  requestIQM: actionCreators["_3" /* requestIQM */]
})(CalendarContainer));
// CONCATENATED MODULE: ./client/app/screens/main/screens/schedule/components/calendar.jsx
function calendar__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function calendar__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function calendar__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function calendar__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var calendar_Calendar = function (_Component) {
  calendar__inherits(Calendar, _Component);

  function Calendar(props) {
    calendar__classCallCheck(this, Calendar);

    var _this = calendar__possibleConstructorReturn(this, (Calendar.__proto__ || Object.getPrototypeOf(Calendar)).call(this, props));

    Object.defineProperty(_this, 'componentDidMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.setPath();
        if (_this.state.currentTab === 'appointments' || _this.state.currentPage === 'schedule') {
          window.addEventListener('scroll', _this.toggleScrollStatus, false);
        }
      }
    });
    Object.defineProperty(_this, 'componentWillUnmount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return window.removeEventListener('scroll', _this.toggleScrollStatus, false);
      }
    });
    Object.defineProperty(_this, 'setPath', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({
          currentPage: document.URL.split('/')[3],
          currentTab: document.URL.split('/')[5]
        });
      }
    });
    Object.defineProperty(_this, 'calendarRef', {
      enumerable: true,
      writable: true,
      value: Object(react["createRef"])()
    });
    Object.defineProperty(_this, 'toggleScrollStatus', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$state = _this.state,
            currentPage = _this$state.currentPage,
            currentTab = _this$state.currentTab;

        var topBasedOnLocation = function topBasedOnLocation() {
          if (currentPage === 'schedule') return 168;
          if (currentTab === 'appointments') return 231;
          return 0;
        };
        var threshold = topBasedOnLocation();
        var calendarHeaderRef = _this.calendarRef.current && _this.calendarRef.current.calendarHeaderRef.current;
        var topReached = calendarHeaderRef && calendarHeaderRef.getBoundingClientRect().top <= threshold;
        var containerBottom = _this.wrapperRef.current ? _this.wrapperRef.current.getBoundingClientRect().bottom : Infinity;
        var pastBottom = !!topReached && containerBottom <= threshold;
        if (window.pageYOffset > 0 && topReached && !pastBottom) {
          _this.setState({ scrolling: true, pastBottom: false });
        } else {
          _this.setState({ scrolling: false, pastBottom: pastBottom });
        }
      }
    });
    Object.defineProperty(_this, 'toggleFilterDrawer', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ showFilterDrawer: !_this.state.showFilterDrawer });
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            dates = _this$props.dates,
            date = _this$props.date,
            onFilterChange = _this$props.onFilterChange,
            filters = _this$props.filters,
            title = _this$props.title,
            navigatePast = _this$props.navigatePast,
            isCcs = _this$props.isCcs,
            navigateFuture = _this$props.navigateFuture,
            selectable = _this$props.selectable,
            onSelect = _this$props.onSelect,
            selectedDayStart = _this$props.selectedDayStart,
            selectedDayEnd = _this$props.selectedDayEnd,
            selectedAssignee = _this$props.selectedAssignee,
            pendingAppointment = _this$props.pendingAppointment,
            headerClassName = _this$props.headerClassName,
            filterClassName = _this$props.filterClassName,
            filterTheme = _this$props.filterTheme,
            role = _this$props.role,
            username = _this$props.username,
            isScheduleBoard = _this$props.isScheduleBoard,
            onOpeningClick = _this$props.onOpeningClick,
            defaultCalStart = _this$props.defaultCalStart,
            applySmartScheduling = _this$props.applySmartScheduling,
            relatedPhases = _this$props.relatedPhases,
            handleDeliveryValidation = _this$props.handleDeliveryValidation,
            phaseType = _this$props.phaseType,
            setDelayedField = _this$props.setDelayedField,
            phaseZip = _this$props.phaseZip,
            employableId = _this$props.employableId,
            updateScheduleFilters = _this$props.updateScheduleFilters,
            updateFilters = _this$props.updateFilters,
            handleShowAssessmentSuggestions = _this$props.handleShowAssessmentSuggestions,
            phaseSource = _this$props.phaseSource,
            phaseEstimatorId = _this$props.phaseEstimatorId,
            phaseInstallerId = _this$props.phaseInstallerId;
        var _this$state2 = _this.state,
            currentPage = _this$state2.currentPage,
            currentTab = _this$state2.currentTab,
            scrolling = _this$state2.scrolling;

        return react_default.a.createElement(
          react_responsive_default.a,
          { minWidth: constants["y" /* CUT_POINT */] },
          function (isDesktop) {
            var _cx;

            return react_default.a.createElement(
              react["Fragment"],
              null,
              !isScheduleBoard && phaseType === 'Assessment' && role !== 'estimator' && phaseSource !== 'IFI' && react_default.a.createElement(
                'div',
                { className: calendar_default.a.overrideBtnContainer },
                react_default.a.createElement(ColoredButton["a" /* default */], {
                  label: 'Switch to Suggestion View',
                  color: 'blue',
                  onClick: function onClick() {
                    return handleShowAssessmentSuggestions(true);
                  },
                  disabled: false
                })
              ),
              react_default.a.createElement(
                'div',
                { ref: _this.wrapperRef },
                react_default.a.createElement(calendarContainer, {
                  isDesktop: isDesktop,
                  navigatePast: navigatePast,
                  navigateFuture: navigateFuture,
                  title: title,
                  toggleFilters: _this.toggleFilterDrawer,
                  currentPage: currentPage,
                  currentTab: currentTab,
                  filters: filters,
                  handleJumpDate: _this.props.handleJumpDate,
                  dates: dates,
                  headerClassName: classnames_default()(headerClassName, (_cx = {}, calendar__defineProperty(_cx, calendar_default.a.inAppointments, currentTab === 'appointments'), calendar__defineProperty(_cx, calendar_default.a.inSchedule, currentPage === 'schedule'), calendar__defineProperty(_cx, calendar_default.a.scrolling, scrolling), calendar__defineProperty(_cx, calendar_default.a.noSticky, _this.state.pastBottom || currentTab !== 'appointments' && currentPage !== 'schedule'), _cx)),
                  active: _this.state.showFilterDrawer,
                  onFilterChange: onFilterChange,
                  updateScheduleFilters: updateScheduleFilters,
                  updateFilters: updateFilters,
                  filterClassName: filterClassName,
                  onClose: _this.toggleFilterDrawer,
                  theme: filterTheme,
                  isScheduleBoard: isScheduleBoard,
                  applySmartScheduling: applySmartScheduling,
                  handleDeliveryValidation: handleDeliveryValidation,
                  calDates: dates.slice(0, isDesktop ? constants["_9" /* NUM_DAYS_DESKTOP */] : constants["_10" /* NUM_DAYS_MOBILE */]),
                  startDate: date,
                  defaultCalStart: defaultCalStart,
                  days: isDesktop ? constants["_9" /* NUM_DAYS_DESKTOP */] : constants["_10" /* NUM_DAYS_MOBILE */],
                  selectable: selectable,
                  selectedDayStart: selectedDayStart,
                  selectedDayEnd: selectedDayEnd,
                  selectedAssignee: selectedAssignee,
                  onSelect: onSelect,
                  pendingAppointment: pendingAppointment,
                  role: role,
                  username: username,
                  employableId: employableId,
                  onOpeningClick: onOpeningClick,
                  relatedPhases: relatedPhases,
                  calRef: _this.calendarRef,
                  setDelayedField: setDelayedField,
                  phaseZip: phaseZip,
                  phaseType: phaseType,
                  phaseSource: phaseSource,
                  phaseEstimatorId: phaseEstimatorId,
                  phaseInstallerId: phaseInstallerId,
                  isCcs: isCcs
                })
              )
            );
          }
        );
      }
    });

    _this.workroomName = props.workroom && props.workroom.name;
    _this.state = {
      showFilterDrawer: false,
      scrolling: false,
      pastBottom: false,
      currentPage: document.URL.split('/')[3],
      currentTab: document.URL.split('/')[5]
    };
    _this.calendarRef = Object(react["createRef"])();
    _this.wrapperRef = Object(react["createRef"])();
    _this.toggleScrollStatus = _this.toggleScrollStatus.bind(_this);
    return _this;
  }

  return Calendar;
}(react["Component"]);

calendar_Calendar.propTypes = {
  title: prop_types_default.a.string,
  role: prop_types_default.a.string,
  username: prop_types_default.a.string,
  employableId: prop_types_default.a.number,
  dates: prop_types_default.a.arrayOf(prop_types_default.a.instanceOf(moment_default.a)).isRequired,
  date: prop_types_default.a.instanceOf(Date).isRequired,
  defaultCalStart: prop_types_default.a.instanceOf(Date),
  onFilterChange: prop_types_default.a.func.isRequired,
  filters: CalendarFilterType,
  navigatePast: prop_types_default.a.func.isRequired,
  navigateFuture: prop_types_default.a.func.isRequired,
  selectable: prop_types_default.a.bool,
  selectedDayStart: prop_types_default.a.instanceOf(moment_default.a),
  selectedDayEnd: prop_types_default.a.instanceOf(moment_default.a),
  selectedAssignee: prop_types_default.a.shape({
    id: prop_types_default.a.number,
    kind: prop_types_default.a.string
  }),
  onSelect: prop_types_default.a.func,
  pendingAppointment: AppointmentType,
  headerClassName: prop_types_default.a.string,
  filterClassName: prop_types_default.a.string,
  filterTheme: prop_types_default.a.shape({
    RTDrawer: prop_types_default.a.string,
    RTList: prop_types_default.a.string,
    RTOverlay: prop_types_default.a.string
  }),
  workroom: prop_types_default.a.shape({
    name: prop_types_default.a.string
  }),
  phaseZip: prop_types_default.a.string,
  phaseType: prop_types_default.a.string,
  phaseSource: prop_types_default.a.string,
  phaseEstimatorId: prop_types_default.a.number,
  phaseInstallerId: prop_types_default.a.number,
  handleJumpDate: prop_types_default.a.func,
  isScheduleBoard: prop_types_default.a.bool,
  onOpeningClick: prop_types_default.a.func,
  applySmartScheduling: prop_types_default.a.bool,
  handleDeliveryValidation: prop_types_default.a.func,
  relatedPhases: prop_types_default.a.array,
  setDelayedField: prop_types_default.a.func,
  isCcs: prop_types_default.a.bool,
  updateScheduleFilters: prop_types_default.a.func,
  updateFilters: prop_types_default.a.func,
  handleShowAssessmentSuggestions: prop_types_default.a.func
};

calendar_Calendar.defaultProps = {
  title: 'Calendar',
  dates: [],
  date: new Date(),
  onFilterChange: function onFilterChange() {},
  filters: {},
  navigatePast: function navigatePast() {},
  navigateFuture: function navigateFuture() {},
  selectable: false,
  isScheduleBoard: false,
  applySmartScheduling: false,
  relatedPhases: [],
  setDelayedField: function setDelayedField() {},
  phaseZip: '',
  phaseType: '',
  phaseSource: '',
  phaseEstimatorId: null,
  phaseInstallerId: null,
  isCcs: false,
  handleShowAssessmentSuggestions: function handleShowAssessmentSuggestions() {}
};

/* harmony default export */ var components_calendar = (calendar_Calendar);
// EXTERNAL MODULE: ./client/app/shared/components/Pagination/styles.scss
var Pagination_styles = __webpack_require__("wGVS");
var Pagination_styles_default = /*#__PURE__*/__webpack_require__.n(Pagination_styles);

// CONCATENATED MODULE: ./client/app/shared/components/Pagination/index.jsx
function Pagination__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Pagination__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Pagination__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var Pagination_Paginate = function (_Component) {
  Pagination__inherits(Paginate, _Component);

  function Paginate() {
    var _ref;

    var _temp, _this, _ret;

    Pagination__classCallCheck(this, Paginate);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = Pagination__possibleConstructorReturn(this, (_ref = Paginate.__proto__ || Object.getPrototypeOf(Paginate)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'getNumOfPages', {
      enumerable: true,
      writable: true,
      value: function value() {
        return Math.ceil(_this.props.totalCount / _this.props.denominator);
      }
    }), Object.defineProperty(_this, 'changePage', {
      enumerable: true,
      writable: true,
      value: function value(page) {
        return _this.props.getListPage(page);
      }
    }), Object.defineProperty(_this, 'isActive', {
      enumerable: true,
      writable: true,
      value: function value(num) {
        return _this.props.currentPage === num ? Pagination_styles_default.a.active : '';
      }
    }), Object.defineProperty(_this, 'prevNextPage', {
      enumerable: true,
      writable: true,
      value: function value(next) {
        var currentPage = _this.props.currentPage;

        if (next && currentPage < _this.getNumOfPages()) _this.changePage(currentPage + 1);else if (!next && currentPage > 1) _this.changePage(currentPage - 1);
      }
    }), Object.defineProperty(_this, 'displayPageItems', {
      enumerable: true,
      writable: true,
      value: function value() {
        var html = [];
        var numOfPages = _this.getNumOfPages();
        var outOfRange = false;

        var _loop = function _loop(i) {
          // Show the first page, last page, current page and 2 pages in front and behind current page
          if (i <= 1 || i >= numOfPages || Math.abs(i - _this.props.currentPage) <= 2) {
            outOfRange = false;
            html.push(react_default.a.createElement(react_toolbox_lib["Button"], {
              key: i,
              type: 'button',
              className: Pagination_styles_default.a[_this.props.buttonStyle] + ' ' + _this.isActive(i),
              label: i.toString(),
              onClick: function onClick() {
                return _this.changePage(i);
              }
            }));
          } else if (!outOfRange) {
            html.push(react_default.a.createElement(react_toolbox_lib["Button"], {
              key: i,
              type: 'button',
              className: Pagination_styles_default.a[_this.props.buttonStyle] + ' ' + _this.isActive(i),
              label: '...'
            }));
            outOfRange = true;
          }
        };

        for (var i = 1; i <= numOfPages; i += 1) {
          _loop(i);
        }
        return html;
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        return react_default.a.createElement(
          'div',
          { className: Pagination_styles_default.a.paginationContainer },
          react_default.a.createElement(react_toolbox_lib["Button"], {
            type: 'button',
            className: Pagination_styles_default.a[_this.props.buttonStyle],
            label: 'Previous',
            onClick: function onClick() {
              return _this.prevNextPage(false);
            }
          }),
          _this.displayPageItems(),
          react_default.a.createElement(react_toolbox_lib["Button"], {
            type: 'button',
            className: Pagination_styles_default.a[_this.props.buttonStyle],
            label: 'Next',
            onClick: function onClick() {
              return _this.prevNextPage(true);
            }
          })
        );
      }
    }), _temp), Pagination__possibleConstructorReturn(_this, _ret);
  }

  return Paginate;
}(react["Component"]);

Pagination_Paginate.defaultProps = { denominator: 10, buttonStyle: 'tablePageButton' };

Pagination_Paginate.propTypes = {
  currentPage: prop_types_default.a.number,
  totalCount: prop_types_default.a.number,
  getListPage: prop_types_default.a.func,
  list: prop_types_default.a.object,
  denominator: prop_types_default.a.number,
  buttonStyle: prop_types_default.a.string
};

/* harmony default export */ var Pagination = (Pagination_Paginate);
// EXTERNAL MODULE: ./client/app/screens/main/screens/schedule/components/suggestions.scss
var components_suggestions = __webpack_require__("o2wf");
var suggestions_default = /*#__PURE__*/__webpack_require__.n(components_suggestions);

// CONCATENATED MODULE: ./client/app/screens/main/screens/schedule/components/assessmentSuggestionsButtons.jsx







var assessmentSuggestionsButtons_AssessmentSuggestionsButtons = function AssessmentSuggestionsButtons(_ref) {
  var queryStart = _ref.queryStart,
      handleQueryStartChange = _ref.handleQueryStartChange,
      errors = _ref.errors,
      handleSuggestionSubmit = _ref.handleSuggestionSubmit,
      suggestionKey = _ref.suggestionKey,
      isCcs = _ref.isCcs,
      handleShowAssessmentSuggestions = _ref.handleShowAssessmentSuggestions,
      loadNewSuggestions = _ref.loadNewSuggestions,
      isAfternoon = _ref.isAfternoon;

  var minDate = isAfternoon ? moment_business_days_default()().add(1, 'day') : moment_business_days_default()();
  var maxDate = minDate.clone().add(2, 'months');

  return react_default.a.createElement(
    react["Fragment"],
    null,
    react_default.a.createElement(
      'div',
      { className: suggestions_default.a.stdBtnsContainer },
      react_default.a.createElement(
        'div',
        { className: suggestions_default.a.datePickerContainer },
        react_default.a.createElement(DatePicker, {
          label: 'Suggestion Search Start',
          minDate: minDate.toDate(),
          maxDate: maxDate.toDate(),
          value: queryStart,
          onChange: handleQueryStartChange,
          className: suggestions_default.a.datePicker,
          placeholder: 'Select Date',
          error: errors.startDate
        }),
        react_default.a.createElement(ColoredButton["a" /* default */], {
          label: 'Search From Selected Date',
          color: 'blue',
          onClick: loadNewSuggestions
        })
      ),
      react_default.a.createElement(
        'div',
        { className: suggestions_default.a.saveBtnContainer },
        react_default.a.createElement(ColoredButton["a" /* default */], {
          className: suggestions_default.a.mainSubmitButton,
          label: 'Save Assessment',
          onClick: handleSuggestionSubmit,
          disabled: !suggestionKey,
          color: 'green'
        }),
        !isCcs && react_default.a.createElement(ColoredButton["a" /* default */], {
          label: 'Switch to Calendar View',
          color: 'blue',
          onClick: function onClick() {
            return handleShowAssessmentSuggestions(false);
          },
          disabled: false
        })
      )
    )
  );
};

assessmentSuggestionsButtons_AssessmentSuggestionsButtons.defaultProps = { suggestionKey: null, schedulingReason: '', isDeliveryList: false };

assessmentSuggestionsButtons_AssessmentSuggestionsButtons.propTypes = {
  isCcs: prop_types_default.a.bool,
  queryStart: prop_types_default.a.string,
  handleQueryStartChange: prop_types_default.a.func,
  errors: prop_types_default.a.object,
  loadNewSuggestions: prop_types_default.a.func,
  handleSuggestionSubmit: prop_types_default.a.func,
  handleShowAssessmentSuggestions: prop_types_default.a.func,
  suggestionKey: prop_types_default.a.string,
  isAfternoon: prop_types_default.a.bool
};

/* harmony default export */ var assessmentSuggestionsButtons = (assessmentSuggestionsButtons_AssessmentSuggestionsButtons);
// CONCATENATED MODULE: ./client/app/screens/main/screens/schedule/components/assessmentSuggestionsList.jsx
function assessmentSuggestionsList__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function assessmentSuggestionsList__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function assessmentSuggestionsList__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable jsx-a11y/no-static-element-interactions */












var AssessmentSuggestionsList = function (_Component) {
  assessmentSuggestionsList__inherits(AssessmentSuggestionsList, _Component);

  function AssessmentSuggestionsList(props) {
    assessmentSuggestionsList__classCallCheck(this, AssessmentSuggestionsList);

    var _this = assessmentSuggestionsList__possibleConstructorReturn(this, (AssessmentSuggestionsList.__proto__ || Object.getPrototypeOf(AssessmentSuggestionsList)).call(this, props));

    assessmentSuggestionsList__initialiseProps.call(_this);

    var _this$props = _this.props,
        suggestions = _this$props.suggestions,
        totalCount = _this$props.totalCount,
        _this$props$suggestio = _this$props.suggestionKey,
        suggestionKey = _this$props$suggestio === undefined ? null : _this$props$suggestio;

    var propSuggestions = suggestions || [[]];
    var currentPage = suggestionKey ? _this.findPageFromKey(suggestionKey, propSuggestions) : 1;
    _this.state = {
      suggestions: propSuggestions,
      totalCount: totalCount,
      currentPage: currentPage,
      apptsByPage: propSuggestions[currentPage - 1] || []
    };
    _this.getApptsByPage = _this.getApptsByPage.bind(_this);
    return _this;
  }

  return AssessmentSuggestionsList;
}(react["Component"]);

var assessmentSuggestionsList__initialiseProps = function _initialiseProps() {
  var _this2 = this;

  Object.defineProperty(this, 'getApptsByPage', {
    enumerable: true,
    writable: true,
    value: function value(page) {
      return _this2.setState({
        currentPage: page, apptsByPage: _this2.state.suggestions[page - 1]
      });
    }
  });
  Object.defineProperty(this, 'resetState', {
    enumerable: true,
    writable: true,
    value: function value(suggestions, totalCount) {
      return _this2.setState({
        suggestions: suggestions,
        totalCount: totalCount,
        currentPage: 1,
        apptsByPage: suggestions[0] || []
      });
    }
  });
  Object.defineProperty(this, 'findPageFromKey', {
    enumerable: true,
    writable: true,
    value: function value(key, propSuggestions) {
      var currentPage = 1;
      if (propSuggestions[0].length < 1) return currentPage;
      propSuggestions.forEach(function (page, i) {
        page.forEach(function (appt) {
          if (appt.key === key) currentPage = i + 1;
        });
      });
      return currentPage;
    }
  });
  Object.defineProperty(this, 'formattedTimeWindow', {
    enumerable: true,
    writable: true,
    value: function value(startTime, endTime) {
      return startTime && endTime ? Object(dateUtils["h" /* getDisplayTime */])(startTime) + ' - ' + Object(dateUtils["h" /* getDisplayTime */])(endTime) + ' ' + _this2.props.zone : 'N/A';
    }
  });
  Object.defineProperty(this, 'renderSuggestionList', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _state = _this2.state,
          apptsByPage = _state.apptsByPage,
          currentPage = _state.currentPage,
          totalCount = _state.totalCount;

      return react_default.a.createElement(
        'div',
        { className: suggestions_default.a.suggestionCard__container },
        react_default.a.createElement(
          'section',
          { className: suggestions_default.a.suggestionCard },
          _this2.renderButtons(),
          totalCount > 0 ? react_default.a.createElement(
            react["Fragment"],
            null,
            react_default.a.createElement(
              'div',
              { className: suggestions_default.a.suggestionCard__title },
              react_default.a.createElement(
                'span',
                null,
                'Available Assessments'
              )
            ),
            react_default.a.createElement(
              'div',
              { className: suggestions_default.a.suggestionCard__content },
              apptsByPage.map(function (appt) {
                return _this2.renderSuggestion(appt);
              })
            ),
            react_default.a.createElement('br', null),
            react_default.a.createElement(
              'div',
              { className: suggestions_default.a.paginationContainer },
              react_default.a.createElement(Pagination, {
                denominator: 5,
                currentPage: currentPage,
                totalCount: totalCount,
                getListPage: function getListPage(page) {
                  return _this2.getApptsByPage(page);
                },
                buttonStyle: 'listPageButton'
              })
            )
          ) : react_default.a.createElement(
            'div',
            null,
            'No suggestions available. Please check estimator max appointment limits and existing schedule.'
          )
        )
      );
    }
  });
  Object.defineProperty(this, 'renderSuggestion', {
    enumerable: true,
    writable: true,
    value: function value(appt) {
      var _props = _this2.props,
          suggestionKey = _props.suggestionKey,
          handleSelect = _props.handleSelect;
      var key = appt.key,
          name = appt.name,
          arrival_start_time = appt.arrival_start_time,
          arrival_end_time = appt.arrival_end_time,
          start_date = appt.start_date;

      var selected = suggestionKey === key;
      return react_default.a.createElement(
        components_Card,
        {
          key: key,
          id: 'appointment' + key,
          className: resourceCard_default.a.selectableCard,
          altColor: selected,
          onClick: selected ? function () {} : function () {
            return handleSelect(appt);
          }
        },
        react_default.a.createElement(ResourceCardElement, {
          title: 'Name',
          value: name,
          size: 'medium',
          theme: suggestions_default.a
        }),
        react_default.a.createElement(ResourceCardElement, {
          title: ' Date',
          value: start_date,
          size: 'medium',
          theme: suggestions_default.a
        }),
        react_default.a.createElement(ResourceCardElement, {
          title: 'Arrival Window',
          value: _this2.formattedTimeWindow(arrival_start_time, arrival_end_time),
          size: 'medium',
          theme: suggestions_default.a
        }),
        react_default.a.createElement(
          'div',
          { className: suggestions_default.a.checkboxContainer },
          react_default.a.createElement(
            ResourceCardElement,
            { size: 'full' },
            react_default.a.createElement(react_toolbox_lib["FontIcon"], {
              className: selected ? suggestions_default.a.selectedCheckbox : suggestions_default.a.emptyCheckbox,
              value: selected ? 'check_box' : 'check_box_outline_blank'
            })
          )
        )
      );
    }
  });
  Object.defineProperty(this, 'renderButtons', {
    enumerable: true,
    writable: true,
    value: function value() {
      return react_default.a.createElement(assessmentSuggestionsButtons, {
        isCcs: _this2.props.isCcs,
        queryStart: _this2.props.queryStart,
        handleQueryStartChange: _this2.props.handleQueryStartChange,
        errors: _this2.props.errors,
        loadNewSuggestions: _this2.props.rerunLoadSuggestions,
        handleSuggestionSubmit: _this2.props.handleSubmit,
        handleShowAssessmentSuggestions: _this2.props.handleShowAssessmentSuggestions,
        suggestionKey: _this2.props.suggestionKey,
        isAfternoon: _this2.props.isAfternoon
      });
    }
  });
  Object.defineProperty(this, 'renderNoAppointmentsMsg', {
    enumerable: true,
    writable: true,
    value: function value() {
      return react_default.a.createElement(
        components_Card,
        { className: suggestions_default.a.msgCard },
        react_default.a.createElement(
          'h5',
          null,
          'No assessment suggestions.'
        ),
        _this2.renderButtons()
      );
    }
  });
  Object.defineProperty(this, 'render', {
    enumerable: true,
    writable: true,
    value: function value() {
      return react_default.a.createElement(
        'section',
        null,
        _this2.state.suggestions[0].length > 0 ? _this2.renderSuggestionList() : _this2.renderNoAppointmentsMsg()
      );
    }
  });
};

AssessmentSuggestionsList.defaultProps = { suggestionKey: null };

AssessmentSuggestionsList.propTypes = {
  isCcs: prop_types_default.a.bool,
  zone: prop_types_default.a.string,
  suggestions: prop_types_default.a.array.isRequired,
  totalCount: prop_types_default.a.number.isRequired,
  suggestionKey: prop_types_default.a.string,
  queryStart: prop_types_default.a.string.isRequired,
  handleSelect: prop_types_default.a.func.isRequired,
  handleSubmit: prop_types_default.a.func.isRequired,
  handleQueryStartChange: prop_types_default.a.func.isRequired,
  handleShowAssessmentSuggestions: prop_types_default.a.func,
  rerunLoadSuggestions: prop_types_default.a.func.isRequired,
  isAfternoon: prop_types_default.a.bool,
  errors: prop_types_default.a.object
};

/* harmony default export */ var assessmentSuggestionsList = (Object(react_redux_es["connect"])(function () {
  return {};
}, {})(AssessmentSuggestionsList));
// CONCATENATED MODULE: ./client/app/screens/main/screens/schedule/components/assessmentSuggestions.jsx
function assessmentSuggestions__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function assessmentSuggestions__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function assessmentSuggestions__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var AssessmentSuggestions = function (_Component) {
  assessmentSuggestions__inherits(AssessmentSuggestions, _Component);

  function AssessmentSuggestions(props) {
    assessmentSuggestions__classCallCheck(this, AssessmentSuggestions);

    var _this = assessmentSuggestions__possibleConstructorReturn(this, (AssessmentSuggestions.__proto__ || Object.getPrototypeOf(AssessmentSuggestions)).call(this, props));

    assessmentSuggestions__initialiseProps.call(_this);

    var queryStart = _this.props.date;

    _this.state = { queryStart: queryStart };
    _this.getSuggestions = _this.getSuggestions.bind(_this);
    _this.handleQueryStartChange = _this.handleQueryStartChange.bind(_this);
    return _this;
  }

  return AssessmentSuggestions;
}(react["Component"]);

var assessmentSuggestions__initialiseProps = function _initialiseProps() {
  var _this2 = this;

  Object.defineProperty(this, 'componentDidMount', {
    enumerable: true,
    writable: true,
    value: function value() {
      return _this2.getSuggestions();
    }
  });
  Object.defineProperty(this, 'getSuggestions', {
    enumerable: true,
    writable: true,
    value: function value() {
      var persist = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var queryStart = _this2.state.queryStart;
      var _props = _this2.props,
          phaseId = _props.phaseId,
          phaseType = _props.phaseType,
          isCcs = _props.isCcs;

      var start = moment_business_days_default()(queryStart, constants["_30" /* SCHEDULE_DATE */]).toDate() || new Date();
      if (!persist) _this2.props.clearAssessmentSuggestion();
      _this2.props.loadSuggestions(phaseId, phaseType, start, isCcs);
    }
  });
  Object.defineProperty(this, 'handleQueryStartChange', {
    enumerable: true,
    writable: true,
    value: function value(date) {
      return _this2.setState({ queryStart: date });
    }
  });
  Object.defineProperty(this, 'render', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _props2 = _this2.props,
          onSelect = _props2.onSelect,
          zone = _props2.zone,
          suggestionKey = _props2.suggestionKey,
          handleSubmit = _props2.handleSubmit,
          isCcs = _props2.isCcs,
          handleShowAssessmentSuggestions = _props2.handleShowAssessmentSuggestions,
          errors = _props2.errors,
          isAfternoon = _props2.isAfternoon,
          _props2$schedule = _props2.schedule,
          _props2$schedule$load = _props2$schedule.loading,
          loading = _props2$schedule$load === undefined ? true : _props2$schedule$load,
          suggestions = _props2$schedule.suggestions;
      var queryStart = _this2.state.queryStart;

      var totalCount = suggestions.length;
      return loading ? react_default.a.createElement(components_Loading, { className: suggestions_default.a.spinner }) : react_default.a.createElement(
        react["Fragment"],
        null,
        react_default.a.createElement(assessmentSuggestionsList, {
          isCcs: isCcs,
          suggestions: totalCount ? Object(schedulingUtils["g" /* groupSuggestionsByPage */])(suggestions) : [[]],
          totalCount: totalCount,
          zone: zone,
          suggestionKey: suggestionKey,
          queryStart: queryStart,
          handleSelect: function handleSelect(v) {
            return onSelect(v, 'assessment');
          },
          handleSubmit: handleSubmit,
          handleQueryStartChange: _this2.handleQueryStartChange,
          handleShowAssessmentSuggestions: handleShowAssessmentSuggestions,
          rerunLoadSuggestions: _this2.getSuggestions,
          isAfternoon: isAfternoon,
          errors: errors
        })
      );
    }
  });
};

AssessmentSuggestions.propTypes = {
  isCcs: prop_types_default.a.bool,
  zone: prop_types_default.a.string,
  loadSuggestions: prop_types_default.a.func.isRequired,
  schedule: types_schedule.isRequired,
  date: prop_types_default.a.string,
  onSelect: prop_types_default.a.func.isRequired,
  handleSubmit: prop_types_default.a.func.isRequired,
  phaseId: prop_types_default.a.number,
  phaseType: prop_types_default.a.string,
  suggestionKey: prop_types_default.a.string,
  handleShowAssessmentSuggestions: prop_types_default.a.func,
  clearAssessmentSuggestion: prop_types_default.a.func,
  isAfternoon: prop_types_default.a.bool,
  errors: prop_types_default.a.object
};

AssessmentSuggestions.defaultProps = { date: new Date() };

/* harmony default export */ var assessmentSuggestions = (Object(react_redux_es["connect"])(function (state) {
  return { schedule: state.schedule };
}, { loadSuggestions: actionCreators["J" /* loadSuggestions */] })(AssessmentSuggestions));
// CONCATENATED MODULE: ./client/app/screens/main/screens/schedule/components/installSuggestionsButtons.jsx
/* eslint-disable no-unused-vars */










var installSuggestionsButtons_InstallSuggestionsButtons = function InstallSuggestionsButtons(_ref) {
  var position = _ref.position,
      queryStart = _ref.queryStart,
      handleQueryStartChange = _ref.handleQueryStartChange,
      errors = _ref.errors,
      loadCrews = _ref.loadCrews,
      handleSuggestionAltSub = _ref.handleSuggestionAltSub,
      handleSuggestionSubmit = _ref.handleSuggestionSubmit,
      overrideToCal = _ref.overrideToCal,
      handleSchedulingReasonChange = _ref.handleSchedulingReasonChange,
      suggestionDisableReason = _ref.suggestionDisableReason,
      schedulingReason = _ref.schedulingReason,
      suggestionKey = _ref.suggestionKey,
      onlyOverride = _ref.onlyOverride,
      isDeliveryList = _ref.isDeliveryList,
      needDelivery = _ref.needDelivery,
      surfaceType = _ref.surfaceType;

  var minDate = moment_business_days_default()().add(needDelivery || surfaceType === 'Carpet' ? 1 : 0, 'days');
  var maxDate = minDate.clone().add(2, 'months');

  return react_default.a.createElement(
    react["Fragment"],
    null,
    react_default.a.createElement(
      'div',
      { className: suggestions_default.a.stdBtnsContainer },
      (!needDelivery || isDeliveryList) && react_default.a.createElement(
        'div',
        { className: suggestions_default.a.datePickerContainer },
        react_default.a.createElement(DatePicker, {
          label: 'Suggestion Search Start',
          minDate: minDate.toDate(),
          maxDate: maxDate.toDate(),
          value: queryStart,
          onChange: handleQueryStartChange,
          className: suggestions_default.a.datePicker,
          placeholder: 'Select Date',
          error: errors.startDate
        }),
        react_default.a.createElement(ColoredButton["a" /* default */], {
          label: 'Search From Selected Date',
          color: 'blue',
          onClick: loadCrews
        })
      ),
      !isDeliveryList && !onlyOverride && react_default.a.createElement(
        'div',
        { className: suggestions_default.a.saveBtnContainer },
        react_default.a.createElement(react_select, {
          label: 'Scheduling Reason',
          className: suggestions_default.a.schedulingReason,
          placeholder: 'Select Reason',
          onChange: handleSchedulingReasonChange,
          options: constants["_31" /* SCHEDULING_REASONS */],
          value: schedulingReason,
          error: errors.schedulingReason,
          required: true
        }),
        react_default.a.createElement(ColoredButton["a" /* default */], {
          className: suggestions_default.a.mainSubmitButton,
          label: 'Save As Installation',
          onClick: handleSuggestionSubmit,
          disabled: !suggestionKey || !schedulingReason || !!suggestionDisableReason,
          color: 'green'
        }),
        react_default.a.createElement(ColoredButton["a" /* default */], {
          label: 'Save As Hold',
          color: 'blue',
          onClick: handleSuggestionAltSub,
          disabled: !suggestionKey || !schedulingReason || !!suggestionDisableReason
        })
      )
    ),
    !isDeliveryList && suggestionDisableReason && react_default.a.createElement(
      'div',
      { className: suggestions_default.a.fieldsWarning },
      suggestionDisableReason
    )
  );
};

installSuggestionsButtons_InstallSuggestionsButtons.defaultProps = { suggestionKey: null, schedulingReason: '', isDeliveryList: false };

installSuggestionsButtons_InstallSuggestionsButtons.propTypes = {
  position: prop_types_default.a.string,
  queryStart: prop_types_default.a.string,
  handleQueryStartChange: prop_types_default.a.func,
  errors: prop_types_default.a.object,
  loadCrews: prop_types_default.a.func,
  handleSchedulingReasonChange: prop_types_default.a.func,
  handleSuggestionSubmit: prop_types_default.a.func,
  handleSuggestionAltSub: prop_types_default.a.func,
  overrideToCal: prop_types_default.a.func,
  isInstall: prop_types_default.a.bool,
  suggestionDisableReason: prop_types_default.a.string,
  schedulingReason: prop_types_default.a.string,
  suggestionKey: prop_types_default.a.string,
  onlyOverride: prop_types_default.a.bool,
  isDeliveryList: prop_types_default.a.bool,
  needDelivery: prop_types_default.a.bool,
  surfaceType: prop_types_default.a.string
};

/* harmony default export */ var installSuggestionsButtons = (installSuggestionsButtons_InstallSuggestionsButtons);
// CONCATENATED MODULE: ./client/app/screens/main/screens/schedule/components/installSuggestionsList.jsx
function installSuggestionsList__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function installSuggestionsList__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function installSuggestionsList__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable jsx-a11y/no-static-element-interactions */












var InstallSuggestionsList = function (_Component) {
  installSuggestionsList__inherits(InstallSuggestionsList, _Component);

  function InstallSuggestionsList(props) {
    installSuggestionsList__classCallCheck(this, InstallSuggestionsList);

    var _this = installSuggestionsList__possibleConstructorReturn(this, (InstallSuggestionsList.__proto__ || Object.getPrototypeOf(InstallSuggestionsList)).call(this, props));

    installSuggestionsList__initialiseProps.call(_this);

    var _this$props = _this.props,
        suggestions = _this$props.suggestions,
        totalCount = _this$props.totalCount;

    var propSuggestions = suggestions || [[]];
    _this.state = {
      suggestions: propSuggestions,
      totalCount: totalCount,
      currentPage: 1,
      apptsByPage: propSuggestions[0],
      retryRun: false
    };
    _this.getApptsByPage = _this.getApptsByPage.bind(_this);
    return _this;
  }

  return InstallSuggestionsList;
}(react["Component"]);

var installSuggestionsList__initialiseProps = function _initialiseProps() {
  var _this2 = this;

  Object.defineProperty(this, 'componentWillReceiveProps', {
    enumerable: true,
    writable: true,
    value: function value(nextProps) {
      var suggestions = nextProps.suggestions,
          _nextProps$totalCount = nextProps.totalCount,
          totalCount = _nextProps$totalCount === undefined ? 0 : _nextProps$totalCount;

      var propSuggestions = suggestions || [[]];
      var oldSuggestions = _this2.props.suggestions || [[]];
      var noPropSuggestions = !propSuggestions[0].length;
      var noOldSuggestions = !oldSuggestions[0].length;
      var resetWithArgs = function resetWithArgs() {
        return _this2.resetState(propSuggestions, totalCount);
      };
      if (!(noOldSuggestions && noPropSuggestions)) {
        if (!noOldSuggestions && noPropSuggestions || noOldSuggestions && !noPropSuggestions) {
          resetWithArgs();
        } else if (_this2.props.suggestions[0][0].opening !== propSuggestions[0][0].opening) {
          resetWithArgs();
        }
      }
    }
  });
  Object.defineProperty(this, 'componentDidUpdate', {
    enumerable: true,
    writable: true,
    value: function value(prevProps, prevState) {
      return !prevState.retryRun && (prevProps.suggestions.length < 1 || prevState.suggestions.length < 1) ? _this2.setState({ retryRun: true }, function () {
        return _this2.props.rerunLoadSuggestions();
      }) : null;
    }
  });
  Object.defineProperty(this, 'getApptsByPage', {
    enumerable: true,
    writable: true,
    value: function value(page) {
      return _this2.setState({
        currentPage: page, apptsByPage: _this2.state.suggestions[page - 1]
      });
    }
  });
  Object.defineProperty(this, 'resetState', {
    enumerable: true,
    writable: true,
    value: function value(suggestions, totalCount) {
      return _this2.setState({
        suggestions: suggestions,
        totalCount: totalCount,
        currentPage: 1,
        apptsByPage: suggestions[0] || []
      });
    }
  });
  Object.defineProperty(this, 'formattedTimeWindow', {
    enumerable: true,
    writable: true,
    value: function value(startTime, endTime) {
      return Object(dateUtils["h" /* getDisplayTime */])(startTime) + ' - ' + Object(dateUtils["h" /* getDisplayTime */])(endTime) + ' ' + _this2.props.zone;
    }
  });
  Object.defineProperty(this, 'renderSuggestionList', {
    enumerable: true,
    writable: true,
    value: function value() {
      var isDeliveryList = _this2.props.isDeliveryList;
      var _state = _this2.state,
          apptsByPage = _state.apptsByPage,
          currentPage = _state.currentPage,
          totalCount = _state.totalCount;

      return react_default.a.createElement(
        'div',
        { className: suggestions_default.a.suggestionCard__container },
        react_default.a.createElement(
          'section',
          { className: suggestions_default.a.suggestionCard },
          isDeliveryList && _this2.renderButtons(),
          react_default.a.createElement(
            'div',
            { className: suggestions_default.a.suggestionCard__title },
            react_default.a.createElement(
              'span',
              null,
              'Available ',
              isDeliveryList ? 'Deliveries' : 'Installations'
            )
          ),
          react_default.a.createElement(
            'div',
            { className: suggestions_default.a.suggestionCard__content },
            apptsByPage.map(function (appt) {
              return _this2.renderSuggestion(appt);
            })
          ),
          react_default.a.createElement('br', null),
          react_default.a.createElement(
            'div',
            { className: suggestions_default.a.paginationContainer },
            react_default.a.createElement(Pagination, {
              denominator: 5,
              currentPage: currentPage,
              totalCount: totalCount,
              getListPage: function getListPage(page) {
                return _this2.getApptsByPage(page);
              },
              buttonStyle: 'listPageButton'
            })
          ),
          !isDeliveryList && _this2.renderButtons()
        )
      );
    }
  });
  Object.defineProperty(this, 'renderSuggestion', {
    enumerable: true,
    writable: true,
    value: function value(appt) {
      var _props = _this2.props,
          suggestionKey = _props.suggestionKey,
          selectedDeliverySuggestion = _props.selectedDeliverySuggestion,
          handleSelect = _props.handleSelect,
          isDeliveryList = _props.isDeliveryList;
      var key = appt.key,
          startTime = appt.startTime,
          endTime = appt.endTime,
          opening = appt.opening,
          projectedJobLength = appt.projectedJobLength,
          projectedJobDays = appt.projectedJobDays,
          _appt$assignee = appt.assignee,
          assignee = _appt$assignee === undefined ? { name: '' } : _appt$assignee;

      var selected = (isDeliveryList ? selectedDeliverySuggestion : suggestionKey) === key;
      return react_default.a.createElement(
        components_Card,
        {
          key: key,
          id: 'appointment' + key,
          className: resourceCard_default.a.selectableCard,
          altColor: selected,
          onClick: selected ? function () {} : function () {
            return handleSelect(appt);
          }
        },
        react_default.a.createElement(ResourceCardElement, {
          title: 'Name',
          value: assignee.name,
          size: 'medium',
          theme: suggestions_default.a
        }),
        react_default.a.createElement(ResourceCardElement, {
          title: 'Start Date',
          value: opening,
          size: 'medium',
          theme: suggestions_default.a
        }),
        react_default.a.createElement(ResourceCardElement, {
          title: 'Arrival Window',
          value: _this2.formattedTimeWindow(startTime, endTime),
          size: 'medium',
          theme: suggestions_default.a
        }),
        !isDeliveryList && react_default.a.createElement(ResourceCardElement, {
          title: 'Estimated Job Length',
          value: projectedJobLength + ' hours - ' + projectedJobDays + ' day(s)',
          size: 'medium',
          theme: suggestions_default.a
        }),
        react_default.a.createElement(
          'div',
          { className: suggestions_default.a.checkboxContainer },
          react_default.a.createElement(
            ResourceCardElement,
            { size: 'full' },
            react_default.a.createElement(react_toolbox_lib["FontIcon"], {
              className: selected ? suggestions_default.a.selectedCheckbox : suggestions_default.a.emptyCheckbox,
              value: selected ? 'check_box' : 'check_box_outline_blank'
            })
          )
        )
      );
    }
  });
  Object.defineProperty(this, 'renderButtons', {
    enumerable: true,
    writable: true,
    value: function value() {
      var onlyOverride = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return react_default.a.createElement(installSuggestionsButtons, {
        position: _this2.props.position,
        queryStart: _this2.props.queryStart,
        suggestionDisableReason: _this2.props.suggestionDisableReason,
        handleQueryStartChange: _this2.props.handleQueryStartChange,
        errors: _this2.props.errors,
        loadCrews: _this2.props.rerunLoadSuggestions,
        handleSchedulingReasonChange: _this2.props.handleSchedulingReasonChange,
        handleSuggestionSubmit: _this2.props.handleSubmit,
        handleSuggestionAltSub: _this2.props.handleAltSub,
        overrideToCal: _this2.props.overrideToCal,
        schedulingReason: _this2.props.schedulingReason,
        suggestionKey: _this2.props.suggestionKey,
        onlyOverride: onlyOverride,
        isDeliveryList: _this2.props.isDeliveryList,
        needDelivery: _this2.props.needDelivery,
        surfaceType: _this2.props.surfaceType
      });
    }
  });
  Object.defineProperty(this, 'renderNoAppointmentsMsg', {
    enumerable: true,
    writable: true,
    value: function value() {
      return react_default.a.createElement(
        components_Card,
        { className: suggestions_default.a.msgCard },
        react_default.a.createElement(
          'h5',
          null,
          'No ',
          _this2.props.isDeliveryList ? 'delivery' : 'install',
          ' suggestions.'
        ),
        _this2.renderButtons(true)
      );
    }
  });
  Object.defineProperty(this, 'render', {
    enumerable: true,
    writable: true,
    value: function value() {
      return react_default.a.createElement(
        'section',
        null,
        _this2.state.suggestions[0].length > 0 ? _this2.renderSuggestionList() : _this2.renderNoAppointmentsMsg()
      );
    }
  });
};

InstallSuggestionsList.defaultProps = {
  selectedDeliverySuggestion: null, suggestionKey: null, schedulingReason: '', isDeliveryList: false
};

InstallSuggestionsList.propTypes = {
  position: prop_types_default.a.string.isRequired,
  zone: prop_types_default.a.string,
  suggestions: prop_types_default.a.array.isRequired,
  totalCount: prop_types_default.a.number.isRequired,
  suggestionKey: prop_types_default.a.string,
  selectedDeliverySuggestion: prop_types_default.a.string,
  schedulingReason: prop_types_default.a.string,
  queryStart: prop_types_default.a.string.isRequired,
  suggestionDisableReason: prop_types_default.a.string.isRequired,
  handleSelect: prop_types_default.a.func.isRequired,
  handleSubmit: prop_types_default.a.func.isRequired,
  handleAltSub: prop_types_default.a.func.isRequired,
  handleSchedulingReasonChange: prop_types_default.a.func.isRequired,
  handleQueryStartChange: prop_types_default.a.func.isRequired,
  rerunLoadSuggestions: prop_types_default.a.func.isRequired,
  overrideToCal: prop_types_default.a.func.isRequired,
  isDeliveryList: prop_types_default.a.bool,
  needDelivery: prop_types_default.a.bool,
  surfaceType: prop_types_default.a.string,
  errors: prop_types_default.a.object
};

/* harmony default export */ var installSuggestionsList = (Object(react_redux_es["connect"])(function () {
  return {};
}, {})(InstallSuggestionsList));
// CONCATENATED MODULE: ./client/app/screens/main/screens/schedule/components/installSuggestions.jsx
function installSuggestions__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function installSuggestions__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function installSuggestions__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var InstallSuggestions = function (_Component) {
  installSuggestions__inherits(InstallSuggestions, _Component);

  function InstallSuggestions(props) {
    installSuggestions__classCallCheck(this, InstallSuggestions);

    var _this = installSuggestions__possibleConstructorReturn(this, (InstallSuggestions.__proto__ || Object.getPrototypeOf(InstallSuggestions)).call(this, props));

    installSuggestions__initialiseProps.call(_this);

    var _this$props = _this.props,
        date = _this$props.date,
        _this$props$phase = _this$props.phase,
        zip_code = _this$props$phase.zip_code,
        surfaceId = _this$props$phase.surface_type.id,
        id = _this$props$phase.workroom.id,
        isCaliBamboo = _this$props$phase.phase_specific.is_cali_bamboo_hardwood;

    _this.state = {
      filters: {
        assignee_type: ['Crew'],
        crew: { zip_code: zip_code },
        surface_type: [surfaceId],
        workroom: [id]
      },
      surfaceId: surfaceId,
      isCaliBamboo: isCaliBamboo,
      queryStart: date
    };
    _this.loadSuggestions = _this.loadSuggestions.bind(_this);
    _this.handleQueryStartChange = _this.handleQueryStartChange.bind(_this);
    return _this;
  }

  return InstallSuggestions;
}(react["Component"]);

var installSuggestions__initialiseProps = function _initialiseProps() {
  var _this2 = this;

  Object.defineProperty(this, 'componentDidMount', {
    enumerable: true,
    writable: true,
    value: function value() {
      return _this2.loadSuggestions();
    }
  });
  Object.defineProperty(this, 'loadSuggestions', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _state = _this2.state,
          queryStart = _state.queryStart,
          filters = _state.filters;
      var _props = _this2.props,
          phase = _props.phase,
          relatedPhases = _props.relatedPhases;

      var startDate = moment_business_days_default()(queryStart, constants["_30" /* SCHEDULE_DATE */]).toDate() || new Date();
      _this2.props.loadSchedule(startDate, filters, false, {}, { phase: phase, relatedPhases: relatedPhases });
    }
  });
  Object.defineProperty(this, 'handleQueryStartChange', {
    enumerable: true,
    writable: true,
    value: function value(date) {
      return _this2.setState({ queryStart: date });
    }
  });
  Object.defineProperty(this, 'filterInstallsByDeliveryDate', {
    enumerable: true,
    writable: true,
    value: function value(suggestions, deliveryStartDate) {
      var _state2 = _this2.state,
          surfaceId = _state2.surfaceId,
          isCaliBamboo = _state2.isCaliBamboo;

      var viableSuggestions = suggestions;
      var buffer = 0;
      if (surfaceId === 1) {
        buffer = isCaliBamboo ? constants["C" /* DELIVERY_BUFFERS */][surfaceId][1] : constants["C" /* DELIVERY_BUFFERS */][surfaceId][0];
      } else buffer = constants["C" /* DELIVERY_BUFFERS */][surfaceId][0];
      if (deliveryStartDate) {
        var optimalMoment = moment_business_days_default()(deliveryStartDate, constants["E" /* DISPLAY_DATE */]).add(buffer, 'days');
        return viableSuggestions.filter(function (s) {
          var openingMoment = moment_business_days_default()(s.opening, constants["E" /* DISPLAY_DATE */]);
          return openingMoment.isSameOrAfter(optimalMoment, 'day');
        });
      }
      return viableSuggestions;
    }
  });
  Object.defineProperty(this, 'paginateSuggestions', {
    enumerable: true,
    writable: true,
    value: function value(suggestions) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'install';
      return Object(schedulingUtils["g" /* groupSuggestionsByPage */])(Object(schedulingUtils["n" /* sortSuggestions */])(suggestions, type));
    }
  });
  Object.defineProperty(this, 'renderNoDelivery', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _props$deliveryArgs = _this2.props.deliveryArgs,
          surfaceType = _props$deliveryArgs.surfaceType,
          deliveryMethod = _props$deliveryArgs.deliveryMethod,
          spigDelivery = _props$deliveryArgs.spigDelivery;

      var noDeliveryArr = [];
      if (surfaceType === 'Carpet') noDeliveryArr.push('surface type is carpet');
      if (deliveryMethod === 'None') noDeliveryArr.push('store has no delivery method');
      if (!spigDelivery) noDeliveryArr.push('delivery not purchased');
      return react_default.a.createElement(
        'div',
        { className: suggestions_default.a.suggestionCard__container, style: { color: 'red' } },
        react_default.a.createElement(
          'section',
          { className: suggestions_default.a.suggestionCard },
          'Delivery not needed due to: ',
          noDeliveryArr.join(', ')
        )
      );
    }
  });
  Object.defineProperty(this, 'render', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _props2 = _this2.props,
          onSelect = _props2.onSelect,
          zone = _props2.zone,
          suggestionKey = _props2.suggestionKey,
          schedulingReason = _props2.schedulingReason,
          handleSchedulingReasonChange = _props2.handleSchedulingReasonChange,
          errors = _props2.errors,
          handleSubmit = _props2.handleSubmit,
          handleAltSub = _props2.handleAltSub,
          position = _props2.position,
          overrideToCal = _props2.overrideToCal,
          needDelivery = _props2.needDelivery,
          suggestionDisableReason = _props2.suggestionDisableReason,
          deliveryStartDate = _props2.deliveryStartDate,
          _props2$selectedDeliv = _props2.selectedDeliverySuggestion,
          selectedDeliverySuggestion = _props2$selectedDeliv === undefined ? null : _props2$selectedDeliv,
          surfaceType = _props2.deliveryArgs.surfaceType,
          _props2$schedule = _props2.schedule,
          _props2$schedule$load = _props2$schedule.loading,
          loading = _props2$schedule$load === undefined ? true : _props2$schedule$load,
          _props2$schedule$deli = _props2$schedule.deliverySuggestions,
          deliverySuggestions = _props2$schedule$deli === undefined ? [] : _props2$schedule$deli,
          _props2$schedule$deli2 = _props2$schedule.deliveryCount,
          deliveryCount = _props2$schedule$deli2 === undefined ? 0 : _props2$schedule$deli2,
          _props2$schedule$sugg = _props2$schedule.suggestions,
          suggestions = _props2$schedule$sugg === undefined ? [] : _props2$schedule$sugg;
      var queryStart = _this2.state.queryStart;

      var installSuggestions = _this2.filterInstallsByDeliveryDate(suggestions, deliveryStartDate);
      return loading ? react_default.a.createElement(components_Loading, { className: suggestions_default.a.spinner }) : react_default.a.createElement(
        react["Fragment"],
        null,
        needDelivery ? react_default.a.createElement(
          react["Fragment"],
          null,
          react_default.a.createElement(installSuggestionsList, {
            isDeliveryList: true,
            position: position,
            suggestions: deliverySuggestions.length ? _this2.paginateSuggestions(deliverySuggestions, 'delivery') : [[]],
            totalCount: deliveryCount,
            zone: zone,
            suggestionKey: suggestionKey,
            selectedDeliverySuggestion: selectedDeliverySuggestion,
            schedulingReason: schedulingReason,
            queryStart: queryStart,
            suggestionDisableReason: suggestionDisableReason,
            handleSelect: function handleSelect(v) {
              return onSelect(v, 'delivery');
            },
            handleSubmit: handleSubmit,
            handleAltSub: handleAltSub,
            handleSchedulingReasonChange: handleSchedulingReasonChange,
            handleQueryStartChange: _this2.handleQueryStartChange,
            rerunLoadSuggestions: _this2.loadSuggestions,
            overrideToCal: overrideToCal,
            needDelivery: needDelivery,
            surfaceType: surfaceType,
            errors: errors
          }),
          react_default.a.createElement('br', null)
        ) : react_default.a.createElement(
          'div',
          null,
          _this2.renderNoDelivery()
        ),
        (!needDelivery || selectedDeliverySuggestion) && react_default.a.createElement(installSuggestionsList, {
          position: position,
          suggestions: installSuggestions.length ? _this2.paginateSuggestions(installSuggestions) : [[]],
          totalCount: installSuggestions.length,
          zone: zone,
          suggestionKey: suggestionKey,
          selectedDeliverySuggestion: selectedDeliverySuggestion,
          schedulingReason: schedulingReason,
          queryStart: queryStart,
          suggestionDisableReason: suggestionDisableReason,
          handleSelect: onSelect,
          handleSubmit: handleSubmit,
          handleAltSub: handleAltSub,
          handleSchedulingReasonChange: handleSchedulingReasonChange,
          handleQueryStartChange: _this2.handleQueryStartChange,
          rerunLoadSuggestions: _this2.loadSuggestions,
          overrideToCal: overrideToCal,
          needDelivery: needDelivery,
          surfaceType: surfaceType,
          errors: errors
        })
      );
    }
  });
};

InstallSuggestions.propTypes = {
  zone: prop_types_default.a.string,
  loadSchedule: prop_types_default.a.func.isRequired,
  schedule: types_schedule.isRequired,
  position: prop_types_default.a.string,
  date: prop_types_default.a.string,
  suggestionDisableReason: prop_types_default.a.string.isRequired,
  onSelect: prop_types_default.a.func.isRequired,
  handleSubmit: prop_types_default.a.func.isRequired,
  handleAltSub: prop_types_default.a.func.isRequired,
  handleSchedulingReasonChange: prop_types_default.a.func.isRequired,
  overrideToCal: prop_types_default.a.func.isRequired,
  pendingAppointment: AppointmentType,
  phase: types_phase,
  relatedPhases: prop_types_default.a.array,
  suggestionKey: prop_types_default.a.string,
  selectedDeliverySuggestion: prop_types_default.a.string,
  schedulingReason: prop_types_default.a.string,
  needDelivery: prop_types_default.a.bool,
  deliveryStartDate: prop_types_default.a.string,
  deliveryArgs: prop_types_default.a.object,
  errors: prop_types_default.a.object
};

InstallSuggestions.defaultProps = { date: new Date(), filters: {}, relatedPhases: [] };

/* harmony default export */ var components_installSuggestions = (Object(react_redux_es["connect"])(function (state) {
  return { schedule: state.schedule };
}, { loadSchedule: actionCreators["I" /* loadSchedule */] })(InstallSuggestions));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseAppointments/components/rescheduleAppointmentModal.jsx
var rescheduleAppointmentModal__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function rescheduleAppointmentModal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function rescheduleAppointmentModal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function rescheduleAppointmentModal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var rescheduleAppointmentModal_DEFAULT_STATE = {
  reason: '',
  note: '',
  errors: {}
};

var rescheduleAppointmentModal_RescheduleAppointmentModal = function (_Resetter) {
  rescheduleAppointmentModal__inherits(RescheduleAppointmentModal, _Resetter);

  function RescheduleAppointmentModal() {
    var _ref;

    var _temp, _this, _ret;

    rescheduleAppointmentModal__classCallCheck(this, RescheduleAppointmentModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = rescheduleAppointmentModal__possibleConstructorReturn(this, (_ref = RescheduleAppointmentModal.__proto__ || Object.getPrototypeOf(RescheduleAppointmentModal)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'state', {
      enumerable: true,
      writable: true,
      value: rescheduleAppointmentModal_DEFAULT_STATE
    }), Object.defineProperty(_this, 'componentWillReceiveProps', {
      enumerable: true,
      writable: true,
      value: function value(nextProps) {
        return _this.setState({ errors: nextProps.errors });
      }
    }), Object.defineProperty(_this, 'handleReasonChange', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        return _this.setState({ reason: e });
      }
    }), Object.defineProperty(_this, 'handleNoteChange', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        return _this.setState({ note: e.target.value });
      }
    }), Object.defineProperty(_this, 'handleSubmit', {
      enumerable: true,
      writable: true,
      value: function value() {
        if (!_this.validate()) return;
        var _this$state = _this.state,
            reason = _this$state.reason,
            note = _this$state.note;
        var _this$props = _this.props,
            ssBlockage = _this$props.ssBlockage,
            onSubmit = _this$props.onSubmit;

        var event = {
          kind: 'reschedule',
          rescheduled: { reason: reason },
          note: ssBlockage ? note + '\n' + ssBlockage : note
        };
        onSubmit(event);
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props2 = _this.props,
            type = _this$props2.type,
            active = _this$props2.active;
        var _this$state2 = _this.state,
            reason = _this$state2.reason,
            note = _this$state2.note,
            errors = _this$state2.errors;

        return react_default.a.createElement(
          react_toolbox_lib["Dialog"],
          {
            active: active,
            className: modal_default.a.modal,
            type: 'fullscreen',
            onEscKeyDown: _this.handleClose,
            onOverlayClick: _this.handleClose
          },
          react_default.a.createElement(lib_button["IconButton"], {
            icon: 'close',
            className: modal_default.a.close,
            onClick: _this.handleClose
          }),
          react_default.a.createElement(
            'h5',
            { className: modal_default.a.title },
            'Reschedule Appointment'
          ),
          react_default.a.createElement(components_StyledSelect, {
            className: modal_default.a.select,
            label: 'Reason *',
            onChange: _this.handleReasonChange,
            options: type === 'Assessment' ? constants["l" /* ASSESSMENT_RESCHEDULE_REASONS */] : constants["_28" /* RESCHEDULE_REASONS */],
            value: reason,
            placeholder: 'Select reason',
            error: errors.reason
          }),
          react_default.a.createElement(components_TextArea, {
            label: 'Note *',
            value: note,
            onChange: _this.handleNoteChange,
            errors: errors.note
          }),
          errors.assignee && react_default.a.createElement(MessageBox["a" /* default */], { error: true, message: errors.assignee }),
          react_default.a.createElement(lib_button["Button"], {
            label: 'Reschedule',
            flat: true, inverse: true, ripple: true,
            className: modal_default.a.submit,
            onClick: _this.handleSubmit
          })
        );
      }
    }), _temp), rescheduleAppointmentModal__possibleConstructorReturn(_this, _ret);
  }

  rescheduleAppointmentModal__createClass(RescheduleAppointmentModal, [{
    key: 'valuesForValidation',
    get: function get() {
      return { note: this.state.note, reason: this.state.reason };
    }
  }]);

  return RescheduleAppointmentModal;
}(resetter(validator(react_default.a.Component)));

Object.defineProperty(rescheduleAppointmentModal_RescheduleAppointmentModal, 'VALIDATIONS', {
  enumerable: true,
  writable: true,
  value: { note: true, reason: true }
});
Object.defineProperty(rescheduleAppointmentModal_RescheduleAppointmentModal, 'DEFAULT_STATE', {
  enumerable: true,
  writable: true,
  value: { reason: '', note: '', errors: {} }
});


rescheduleAppointmentModal_RescheduleAppointmentModal.propTypes = {
  type: prop_types_default.a.string.isRequired,
  active: prop_types_default.a.bool.isRequired,
  onSubmit: prop_types_default.a.func,
  onClose: prop_types_default.a.func,
  ssBlockage: prop_types_default.a.string
};

rescheduleAppointmentModal_RescheduleAppointmentModal.defaultProps = {
  active: false,
  onClose: function onClose() {},
  onSubmit: function onSubmit() {}
};

/* harmony default export */ var rescheduleAppointmentModal = (rescheduleAppointmentModal_RescheduleAppointmentModal);
// CONCATENATED MODULE: ./client/app/shared/actionCreators/appointments.js



var appointments__createActions = Object(redux_actions_lib["createActions"])({
  REQUEST_APPOINTMENT_SUCCESS: function REQUEST_APPOINTMENT_SUCCESS(json, appointmentId) {
    return {
      appointment: json.appointment,
      appointmentId: appointmentId
    };
  }
}, 'REQUEST_APPOINTMENT_REQUEST', 'REQUEST_APPOINTMENT_FAILURE'),
    requestAppointmentRequest = appointments__createActions.requestAppointmentRequest,
    requestAppointmentSuccess = appointments__createActions.requestAppointmentSuccess,
    requestAppointmentFailure = appointments__createActions.requestAppointmentFailure;

function requestAppointment(appointmentId) {
  return function (dispatch) {
    dispatch(requestAppointmentRequest());

    return Object(services["h" /* request */])('appointments/' + appointmentId).then(function (_ref) {
      var json = _ref.json;
      return dispatch(requestAppointmentSuccess(json, appointmentId));
    }).catch(function (error) {
      return dispatch(requestAppointmentFailure(error));
    });
  };
}

var _createActions2 = Object(redux_actions_lib["createActions"])({
  PHASE_APPOINTMENT_CREATE_SUCCESS: function PHASE_APPOINTMENT_CREATE_SUCCESS(json) {
    return {
      appointment: json.appointment,
      phase: json.appointment.phase,
      inspection_required: json.meta && json.meta.inspection_required || false
    };
  }
}, 'PHASE_APPOINTMENT_CREATE_REQUEST', 'PHASE_APPOINTMENT_CREATE_FAILURE'),
    phaseAppointmentCreateRequest = _createActions2.phaseAppointmentCreateRequest,
    phaseAppointmentCreateSuccess = _createActions2.phaseAppointmentCreateSuccess,
    phaseAppointmentCreateFailure = _createActions2.phaseAppointmentCreateFailure;

function createPhaseAppointment(phaseID, params, ssData) {
  var event = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  return function (dispatch) {
    dispatch(phaseAppointmentCreateRequest());
    var source = ssData.source,
        ignoredWarnings = ssData.ignoredWarnings;

    var req = { method: 'POST', body: { appointment: params, source: source, ignored_warnings: ignoredWarnings, event: event } };
    return Object(services["h" /* request */])('phases/' + phaseID + '/appointments', req).then(function (_ref2) {
      var json = _ref2.json;
      return dispatch(phaseAppointmentCreateSuccess(json));
    }).catch(function (error) {
      return dispatch(phaseAppointmentCreateFailure(error));
    });
  };
}

var _createActions3 = Object(redux_actions_lib["createActions"])({
  PHASE_APPOINTMENT_EDIT_SUCCESS: function PHASE_APPOINTMENT_EDIT_SUCCESS(json) {
    return {
      appointment: json.appointment,
      phase: json.appointment.phase,
      inspection_required: json.meta && json.meta.inspection_required || false
    };
  }
}, 'PHASE_APPOINTMENT_EDIT_REQUEST', 'PHASE_APPOINTMENT_EDIT_FAILURE'),
    phaseAppointmentEditRequest = _createActions3.phaseAppointmentEditRequest,
    phaseAppointmentEditSuccess = _createActions3.phaseAppointmentEditSuccess,
    phaseAppointmentEditFailure = _createActions3.phaseAppointmentEditFailure;

function editPhaseAppointment(apptID, phaseID, params, ssData) {
  var event = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

  return function (dispatch) {
    dispatch(phaseAppointmentEditRequest());
    var source = ssData.source,
        ignoredWarnings = ssData.ignoredWarnings;

    var req = { method: 'PUT', body: { appointment: params, source: source, ignored_warnings: ignoredWarnings, event: event } };
    return Object(services["h" /* request */])('phases/' + phaseID + '/appointments/' + apptID, req).then(function (_ref3) {
      var json = _ref3.json;
      return dispatch(phaseAppointmentEditSuccess(json));
    }).catch(function (error) {
      return dispatch(phaseAppointmentEditFailure(error));
    });
  };
}

var _createActions4 = Object(redux_actions_lib["createActions"])({
  PHASE_APPOINTMENT_DELETE_SUCCESS: function PHASE_APPOINTMENT_DELETE_SUCCESS(appointmentID, json) {
    return {
      appointmentID: appointmentID,
      event: json.event
    };
  }
}, 'PHASE_APPOINTMENT_DELETE_REQUEST', 'PHASE_APPOINTMENT_DELETE_FAILURE'),
    phaseAppointmentDeleteRequest = _createActions4.phaseAppointmentDeleteRequest,
    phaseAppointmentDeleteSuccess = _createActions4.phaseAppointmentDeleteSuccess,
    phaseAppointmentDeleteFailure = _createActions4.phaseAppointmentDeleteFailure;

function deletePhaseAppointment(appointmentID, event) {
  return function (dispatch) {
    dispatch(phaseAppointmentDeleteRequest());

    var req = { method: 'DELETE', body: { event: event } };
    return Object(services["h" /* request */])('appointments/' + appointmentID, req).then(function (_ref4) {
      var json = _ref4.json;
      return dispatch(phaseAppointmentDeleteSuccess(appointmentID, json));
    }).catch(function (error) {
      return dispatch(phaseAppointmentDeleteFailure(error));
    });
  };
}

var _createActions5 = Object(redux_actions_lib["createActions"])('PHASE_APPOINTMENT_ADD_VALIDATION'),
    phaseAppointmentAddValidation = _createActions5.phaseAppointmentAddValidation;

function addValidationErrors(errors) {
  return function (dispatch) {
    return dispatch(phaseAppointmentAddValidation({ errors: errors }));
  };
}

var phaseAppointmentClearValidation = Object(redux_actions_lib["createAction"])('PHASE_APPOINTMENT_CLEAR_VALIDATION');
// CONCATENATED MODULE: ./client/app/shared/actionCreators/related_phases.js



var related_phases__createActions = Object(redux_actions_lib["createActions"])({
  REQUEST_RELATED_PHASES_SUCCESS: function REQUEST_RELATED_PHASES_SUCCESS(json, phaseId) {
    return {
      relatedPhases: json.related_phases,
      phaseId: phaseId
    };
  }
}, 'REQUEST_RELATED_PHASES_REQUEST', 'REQUEST_RELATED_PHASES_FAILURE'),
    requestRelatedPhasesRequest = related_phases__createActions.requestRelatedPhasesRequest,
    requestRelatedPhasesSuccess = related_phases__createActions.requestRelatedPhasesSuccess,
    requestRelatedPhasesFailure = related_phases__createActions.requestRelatedPhasesFailure;

function requestRelatedPhases(phaseId) {
  return function (dispatch) {
    dispatch(requestRelatedPhasesRequest());

    return Object(services["h" /* request */])('phases/' + phaseId + '/related_phases').then(function (_ref) {
      var json = _ref.json;
      return dispatch(requestRelatedPhasesSuccess(json, phaseId));
    }).catch(function (error) {
      return dispatch(requestRelatedPhasesFailure(error));
    });
  };
}

var related_phases__createActions2 = Object(redux_actions_lib["createActions"])({
  CREATE_RELATED_PHASE_SUCCESS: function CREATE_RELATED_PHASE_SUCCESS(json, phaseId) {
    return {
      relatedPhase: json.related_phase,
      phase: json.meta.phase,
      phaseId: phaseId
    };
  }
}, 'CREATE_RELATED_PHASE_REQUEST', 'CREATE_RELATED_PHASE_FAILURE'),
    createRelatedPhaseRequest = related_phases__createActions2.createRelatedPhaseRequest,
    createRelatedPhaseSuccess = related_phases__createActions2.createRelatedPhaseSuccess,
    createRelatedPhaseFailure = related_phases__createActions2.createRelatedPhaseFailure;

function createRelatedPhase(phaseId, relatedPhaseId) {
  return function (dispatch) {
    dispatch(createRelatedPhaseRequest());

    var req = { method: 'POST', body: { related_phase_id: relatedPhaseId } };
    return Object(services["h" /* request */])('phases/' + phaseId + '/related_phases', req).then(function (_ref2) {
      var json = _ref2.json;
      return dispatch(createRelatedPhaseSuccess(json, phaseId));
    }).catch(function (error) {
      return dispatch(createRelatedPhaseFailure(error));
    });
  };
}

var related_phases__createActions3 = Object(redux_actions_lib["createActions"])({
  REMOVE_RELATED_PHASE_SUCCESS: function REMOVE_RELATED_PHASE_SUCCESS(json, relatedPhaseId) {
    return {
      message: json.message,
      relatedPhaseId: relatedPhaseId
    };
  }
}, 'REMOVE_RELATED_PHASE_REQUEST', 'REMOVE_RELATED_PHASE_FAILURE'),
    removeRelatedPhaseRequest = related_phases__createActions3.removeRelatedPhaseRequest,
    removeRelatedPhaseSuccess = related_phases__createActions3.removeRelatedPhaseSuccess,
    removeRelatedPhaseFailure = related_phases__createActions3.removeRelatedPhaseFailure;

function removeRelatedPhase(phaseId, relatedPhaseId) {
  return function (dispatch) {
    dispatch(removeRelatedPhaseRequest());

    var req = { method: 'DELETE' };
    return Object(services["h" /* request */])('phases/' + phaseId + '/related_phases/' + relatedPhaseId, req).then(function (_ref3) {
      var json = _ref3.json;
      return dispatch(removeRelatedPhaseSuccess(json, relatedPhaseId));
    }).catch(function (error) {
      return dispatch(removeRelatedPhaseFailure(error));
    });
  };
}
// EXTERNAL MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseAppointments/styles.scss
var phaseAppointments_styles = __webpack_require__("RMfO");
var phaseAppointments_styles_default = /*#__PURE__*/__webpack_require__.n(phaseAppointments_styles);

// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseAppointments/components/schedulePhaseAppointment.jsx
var schedulePhaseAppointment__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function schedulePhaseAppointment__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function schedulePhaseAppointment__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function schedulePhaseAppointment__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function schedulePhaseAppointment__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
































var APPT_CONFIRMATION_DIFF = 1;
var schedulePhaseAppointment_DEFAULT_STATE = {
  projectedJobDays: 0,
  projectedJobLength: 0,
  projectedCompletion: '',
  note: '',
  confirmationDate: null,
  showRescheduleModal: false,
  showDialog: false,
  showDeliveryDialog: false,
  overrideReschedule: false,
  schedulingReason: '',
  suggestionKey: null,
  assessmentSuggestion: null,
  selectedDeliverySuggestion: null,
  ssBlockage: ''
};
var IS_AFTERNOON = moment_business_days_default()().isSameOrAfter(moment_business_days_default()().hours(12));

var schedulePhaseAppointment_SchedulePhaseAppointment = function (_Component) {
  schedulePhaseAppointment__inherits(SchedulePhaseAppointment, _Component);

  function SchedulePhaseAppointment(props) {
    schedulePhaseAppointment__classCallCheck(this, SchedulePhaseAppointment);

    var _this = schedulePhaseAppointment__possibleConstructorReturn(this, (SchedulePhaseAppointment.__proto__ || Object.getPrototypeOf(SchedulePhaseAppointment)).call(this, props));

    Object.defineProperty(_this, 'componentWillMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.requestRelatedPhases(_this.props.phase.id);
      }
    });
    Object.defineProperty(_this, 'getDefaultDate', {
      enumerable: true,
      writable: true,
      value: function value(diff) {
        return moment_business_days_default()().businessSubtract(diff).format(constants["E" /* DISPLAY_DATE */]);
      }
    });
    Object.defineProperty(_this, 'getDefaultEndTime', {
      enumerable: true,
      writable: true,
      value: function value(start, apptType) {
        return _this.defaultArrivalWindow(start, apptType);
      }
    });
    Object.defineProperty(_this, 'getSubtractedDate', {
      enumerable: true,
      writable: true,
      value: function value(date, diff) {
        var businessSub = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        if (businessSub) return date.clone().businessSubtract(diff, 'days').format(constants["E" /* DISPLAY_DATE */]);
        return date.clone().subtract(diff, 'days').format(constants["E" /* DISPLAY_DATE */]);
      }
    });
    Object.defineProperty(_this, 'getApptIndex', {
      enumerable: true,
      writable: true,
      value: function value(apptTypes) {
        var phaseType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

        var isIQM = _this.props.role === 'iqm';
        if (!isIQM) return 0;
        var lastIndex = apptTypes.length - 1;
        if (phaseType) return ['Installation', 'Workorder'].includes(phaseType) ? lastIndex : 0;
        return lastIndex;
      }
    });
    Object.defineProperty(_this, 'getDateFromDifferential', {
      enumerable: true,
      writable: true,
      value: function value(momentArrivalStart, targetDate) {
        var newArrivalStartMoment = momentArrivalStart.clone();
        var startMoment = moment_business_days_default()(_this.state.startDate, constants["E" /* DISPLAY_DATE */]);
        var endMoment = moment_business_days_default()(targetDate, constants["E" /* DISPLAY_DATE */]);
        var endDate = targetDate;
        if (startMoment.isValid() && endMoment.isValid()) {
          endDate = newArrivalStartMoment.add(endMoment.diff(startMoment, 'days'), 'days').format(constants["E" /* DISPLAY_DATE */]);
        }
        return endDate;
      }
    });
    Object.defineProperty(_this, 'getEarlierBusinessDate', {
      enumerable: true,
      writable: true,
      value: function value(date, diff) {
        return date.clone().businessSubtract(diff).format(constants["E" /* DISPLAY_DATE */]);
      }
    });
    Object.defineProperty(_this, 'getSaveableDate', {
      enumerable: true,
      writable: true,
      value: function value(date) {
        return date && moment_business_days_default()(date, constants["E" /* DISPLAY_DATE */]).format(constants["_19" /* RAILS_DATE */]);
      }
    });
    Object.defineProperty(_this, 'getDefaultCalStart', {
      enumerable: true,
      writable: true,
      value: function value(suggestion) {
        var needDelivery = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var _this$props$phase = _this.props.phase,
            vendor_eta = _this$props$phase.vendor_eta,
            id = _this$props$phase.surface_type.id;

        if (suggestion) {
          if (vendor_eta) return moment_business_days_default()(vendor_eta).add(3, 'days');
          if (needDelivery || id === 2) return moment_business_days_default()().add(2, 'days');
          if (id !== 2) return moment_business_days_default()().add(4, 'days');
        }
        return moment_business_days_default()().add(_this.isAssessment() && IS_AFTERNOON ? 2 : 1, 'days');
      }
    });
    Object.defineProperty(_this, 'getStateObj', {
      enumerable: true,
      writable: true,
      value: function value() {
        var overrideToCal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var _this$props = _this.props,
            appointment = _this$props.appointment,
            isEdit = _this$props.isEdit,
            originalStart = _this$props.originalStart,
            originalEnd = _this$props.originalEnd,
            _this$props$phase2 = _this$props.phase,
            estimator = _this$props$phase2.estimator,
            zip_code = _this$props$phase2.zip_code,
            estimator_id = _this$props$phase2.estimator_id,
            installer_id = _this$props$phase2.installer_id,
            surface_type = _this$props$phase2.surface_type,
            store = _this$props$phase2.store,
            type = _this$props$phase2.type,
            spig_delivery = _this$props$phase2.spig_delivery,
            _this$props$phase2$su = _this$props$phase2.surface_type,
            id = _this$props$phase2$su.id,
            name = _this$props$phase2$su.name,
            _this$props$phase2$st = _this$props$phase2.store,
            workroom_id = _this$props$phase2$st.workroom_id,
            delivery_method = _this$props$phase2$st.delivery_method,
            timezone = _this$props$phase2.workroom.timezone,
            role = _this$props.role;

        var query = window.location.href;
        var apptType = _this.props.quickSchedule && _this.props.quickSchedule.forceKind || window.location.href.split(query.includes('new/') ? 'new/' : 'edit/')[1] || '';
        var arrivalTimes = isEdit ? { arrivalStart: originalStart, arrivalEnd: originalEnd } : { arrivalStart: '08:00', arrivalEnd: _this.getDefaultEndTime('08:00', apptType) };
        var selectedAssignee = _this.isAssessment(apptType) && estimator ? schedulePhaseAppointment__extends({}, estimator, { kind: 'Estimator' }) : null;
        var smartSchedulable = _this.isInstallApptType(apptType);
        var showInstallSuggestions = _this.isCcs() && smartSchedulable && !overrideToCal && !_this.isIfi();
        var needDelivery = Object(utils["o" /* isDeliveryPhase */])(type, name, delivery_method, spig_delivery);
        var defaultCalStart = _this.getDefaultCalStart(showInstallSuggestions, needDelivery);
        var scheduleStart = appointment ? moment_business_days_default()(appointment.startDate, constants["E" /* DISPLAY_DATE */]).toDate() : defaultCalStart.toDate();
        var defaultDates = {};
        if (_this.hasConfirmationAndPickup(apptType)) {
          var apptConfDate = _this.getSubtractedDate(defaultCalStart, APPT_CONFIRMATION_DIFF, true);
          var pickupDiff = name.toLowerCase() === 'carpet' || name === 'Backsplash' ? 0 : 3;
          defaultDates.confirmationDate = apptConfDate;
          defaultDates.pickupDate = _this.getDefaultDate(pickupDiff);
        }
        var apptDate = defaultCalStart.format(constants["E" /* DISPLAY_DATE */]).toString();
        var zone = timezone.includes('Central') ? 'CST' : 'EST';
        return schedulePhaseAppointment__extends({
          zone: zone
        }, schedulePhaseAppointment_DEFAULT_STATE, {
          startDate: apptDate,
          endDate: apptDate,
          defaultCalStart: defaultCalStart,
          apptType: apptType,
          showInstallSuggestions: showInstallSuggestions
        }, arrivalTimes, {
          selectedAssignee: selectedAssignee,
          workroom: store ? [workroom_id] : [],
          assignee_type: _this.contractorType(apptType),
          surface_type: surface_type ? [id] : [],
          estimator: schedulePhaseAppointment__extends({ zip_code: zip_code, estimator_id: estimator_id }, _this.isIfi() ? { ifi: true } : {}),
          crew: schedulePhaseAppointment__extends({ zip_code: zip_code }, _this.isIfi() ? { installer_id: installer_id, ifi: true } : {}),
          scheduleStart: scheduleStart
        }, defaultDates, appointment || {}, {
          smartSchedulable: smartSchedulable,
          needDelivery: needDelivery,
          applyDeliveryValidation: needDelivery,
          showAssessmentSuggestions: _this.isAssessment() && role !== 'estimator' && !_this.isIfi()
        });
      }
    });
    Object.defineProperty(_this, 'setDelayedField', {
      enumerable: true,
      writable: true,
      value: function value(field, val) {
        return _this.setState(schedulePhaseAppointment__defineProperty({}, field, val));
      }
    });
    Object.defineProperty(_this, 'normalizeProjectedCompletion', {
      enumerable: true,
      writable: true,
      value: function value(_value) {
        return _this.isProjectedCompletionEmpty(_value) ? null : _value;
      }
    });
    Object.defineProperty(_this, 'resetState', {
      enumerable: true,
      writable: true,
      value: function value(overrideToCal) {
        return _this.setState(_this.getStateObj(overrideToCal));
      }
    });
    Object.defineProperty(_this, 'clearAssessmentSuggestion', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ suggestionKey: null, assessmentSuggestion: null });
      }
    });
    Object.defineProperty(_this, 'isInstallApptType', {
      enumerable: true,
      writable: true,
      value: function value() {
        var apptType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        return ['installation', 'installation_hold'].includes(apptType || _this.state && _this.state.apptType || '');
      }
    });
    Object.defineProperty(_this, 'isAssessment', {
      enumerable: true,
      writable: true,
      value: function value() {
        var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props.phase && _this.props.phase.type || '';
        return type.toLowerCase() === 'assessment';
      }
    });
    Object.defineProperty(_this, 'isCcs', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.position === 'Customer Care Specialist';
      }
    });
    Object.defineProperty(_this, 'isEmployee', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.employableType === 'Employee';
      }
    });
    Object.defineProperty(_this, 'isIfi', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.phase && _this.props.phase.source === 'IFI';
      }
    });
    Object.defineProperty(_this, 'assigneeSmartSchedulable', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.state.selectedAssignee && (_this.state.selectedAssignee.kind || '') === 'Crew' && !_this.state.selectedAssignee.specificMismatch;
      }
    });
    Object.defineProperty(_this, 'isDeliveryAppt', {
      enumerable: true,
      writable: true,
      value: function value() {
        var apptType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        return ['delivery', 'deliver_stack_cali_bamboo', 'delivery_hold'].includes(apptType || _this.state.apptType);
      }
    });
    Object.defineProperty(_this, 'handleDeliveryValidation', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ applyDeliveryValidation: !_this.state.applyDeliveryValidation });
      }
    });
    Object.defineProperty(_this, 'handleShowAssessmentSuggestions', {
      enumerable: true,
      writable: true,
      value: function value() {
        var bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        return _this.setState({ showAssessmentSuggestions: bool });
      }
    });
    Object.defineProperty(_this, 'toggleFilterDrawer', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ showFilterDrawer: !_this.state.showFilterDrawer });
      }
    });
    Object.defineProperty(_this, 'defaultArrivalWindow', {
      enumerable: true,
      writable: true,
      value: function value(startTime, apptType) {
        var start = moment_business_days_default()(startTime, 'HH:mm');
        if (!start.isValid()) return startTime;
        return start.add(constants["A" /* DEFAULT_ARRIVAL_WINDOW_HOURS */][apptType] || constants["A" /* DEFAULT_ARRIVAL_WINDOW_HOURS */].default, 'h').format('HH:mm');
      }
    });
    Object.defineProperty(_this, 'deselectAssignee', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ selectedAssignee: null });
      }
    });
    Object.defineProperty(_this, 'apptTypeOptions', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props2 = _this.props,
            phase = _this$props2.phase,
            role = _this$props2.role;

        if (role === 'iqm') return [constants["i" /* APPT_TYPES */][constants["i" /* APPT_TYPES */].length - 1]];
        var values = constants["_12" /* PHASE_APPOINTMENT_TYPES */][phase.type];
        if (!values) return constants["i" /* APPT_TYPES */];
        return constants["i" /* APPT_TYPES */].filter(function (o) {
          return _this.apptTypeOptionsFilter(o, values);
        });
      }
    });
    Object.defineProperty(_this, 'apptTypeOptionsFilter', {
      enumerable: true,
      writable: true,
      value: function value(apptType, values) {
        var applyDeliveryValidation = _this.state.applyDeliveryValidation;
        var _this$props$phase3 = _this.props.phase,
            store = _this$props$phase3.store,
            wood_flooring_type = _this$props$phase3.surface_information.wood_flooring_type;
        var value = apptType.value;
        // Remove 'Delivery' and 'Deliver/Stack Cali Bamboo' option from appts drop down if
        // store doesn't deliver

        if (_this.isDeliveryAppt(value) && store.delivery_method === 'None') return false;
        // Don't show 'Deliver/Stack Cali Bamboo' as an option if Phase surface type isn't Cali Bamboo
        // or Delivery Validation is off
        if (value === 'deliver_stack_cali_bamboo' && (wood_flooring_type !== 'Cali Bamboo' || !applyDeliveryValidation)) return false;
        // Show 'Delivery/Stack Cali Bamboo' and remove 'Delivery' and 'Stack Cali Bamboo'
        // if Delivery Validation is on and phase surface type is Cali Bamboo
        if (applyDeliveryValidation && wood_flooring_type === 'Cali Bamboo' && _this.isDeliveryAppt(value)) return false;
        return values.includes(value);
      }
    });
    Object.defineProperty(_this, 'handleAppointmentTypeChange', {
      enumerable: true,
      writable: true,
      value: function value(apptType, overrideReschedule) {
        return _this.setState({
          apptType: apptType,
          assignee_type: _this.contractorType(apptType),
          arrivalEnd: _this.defaultArrivalWindow(_this.state.arrivalStart, apptType),
          overrideReschedule: overrideReschedule,
          smartSchedulable: _this.isInstallApptType(apptType)
        });
      }
    });
    Object.defineProperty(_this, 'handleArrivalStartChange', {
      enumerable: true,
      writable: true,
      value: function value(time) {
        var clearAssignee = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var _this$state = _this.state,
            smartSchedulable = _this$state.smartSchedulable,
            arrivalStart = _this$state.arrivalStart,
            arrivalEnd = _this$state.arrivalEnd;

        var applySsFeatures = smartSchedulable && _this.assigneeSmartSchedulable();
        var arrivalStartMoment = moment_business_days_default()(arrivalStart, 'HH:mm');
        var newArrivalStartMoment = moment_business_days_default()(time, 'HH:mm');
        var arrivalEndMoment = moment_business_days_default()(arrivalEnd, 'HH:mm');
        var newArrivalEnd = arrivalEnd;
        if (arrivalStartMoment.isValid() && newArrivalStartMoment.isValid() && arrivalEndMoment.isValid()) {
          newArrivalEnd = newArrivalStartMoment.add(arrivalEndMoment.diff(arrivalStartMoment, 'seconds'), 'seconds').format('HH:mm');
        }
        var newState = { arrivalStart: time, arrivalEnd: newArrivalEnd };
        if (applySsFeatures && clearAssignee) {
          newState.selectedAssignee = null;
          _this.setState(newState);
        } else _this.setState(newState, function () {
          return _this.handleProjectedCompletionChange();
        });
      }
    });
    Object.defineProperty(_this, 'handleArrivalEndChange', {
      enumerable: true,
      writable: true,
      value: function value(time) {
        var clearAssignee = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        var applySsFeatures = _this.state.smartSchedulable && _this.assigneeSmartSchedulable();
        var newState = { arrivalEnd: time };
        if (applySsFeatures && clearAssignee) newState.selectedAssignee = null;
        _this.setState(newState);
      }
    });
    Object.defineProperty(_this, 'handleNoteChange', {
      enumerable: true,
      writable: true,
      value: function value(event) {
        return _this.setState({ note: event.target.value });
      }
    });
    Object.defineProperty(_this, 'handleConfirmationDateChange', {
      enumerable: true,
      writable: true,
      value: function value(kind) {
        return function (date) {
          return _this.setState(schedulePhaseAppointment__defineProperty({}, kind, date));
        };
      }
    });
    Object.defineProperty(_this, 'hasConfirmationAndPickup', {
      enumerable: true,
      writable: true,
      value: function value() {
        var kind = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.apptType;
        return ['installation', 'installation_hold', 'repair'].includes(kind);
      }
    });
    Object.defineProperty(_this, 'handlePickupDateChange', {
      enumerable: true,
      writable: true,
      value: function value(date) {
        return _this.setState({ pickupDate: date });
      }
    });
    Object.defineProperty(_this, 'handleProjectedCompletionChange', {
      enumerable: true,
      writable: true,
      value: function value() {
        var isSuggestion = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var _this$state2 = _this.state,
            smartSchedulable = _this$state2.smartSchedulable,
            projectedJobLength = _this$state2.projectedJobLength,
            projectedJobDays = _this$state2.projectedJobDays,
            startDate = _this$state2.startDate,
            arrivalStart = _this$state2.arrivalStart,
            selectedAssignee = _this$state2.selectedAssignee;

        if (isSuggestion || smartSchedulable && _this.assigneeSmartSchedulable()) {
          var projectedCompletion = moment_business_days_default()(Object(schedulingUtils["c" /* determineProjectedCompletion */])(projectedJobLength, projectedJobDays, startDate, arrivalStart, selectedAssignee.suggestedStartTime || ''), constants["F" /* DISPLAY_DATE_TIME */], true).format(constants["_21" /* RAILS_DATE_TIME */]);
          _this.setState({ projectedCompletion: projectedCompletion });
        }
      }
    });
    Object.defineProperty(_this, 'handleSuggestionDates', {
      enumerable: true,
      writable: true,
      value: function value(date) {
        var name = _this.props.phase.surface_type.name;
        var projectedJobDays = _this.state.projectedJobDays;

        var startMoment = Object(dateUtils["r" /* parseDateStrict */])(date, constants["E" /* DISPLAY_DATE */]);
        var startDate = startMoment.clone().format(constants["E" /* DISPLAY_DATE */]);
        var apptConfDate = _this.getSubtractedDate(startMoment, APPT_CONFIRMATION_DIFF, true);
        _this.setState({
          startDate: startDate,
          endDate: startMoment.clone().add(projectedJobDays - 1, 'days').format(constants["E" /* DISPLAY_DATE */]),
          confirmationDate: apptConfDate,
          pickupDate: _this.getEarlierBusinessDate(startMoment, ['Carpet', 'Backsplash'].includes(name) ? 0 : 3),
          scheduleStart: moment_business_days_default()(startDate, constants["E" /* DISPLAY_DATE */], true).toDate()
        });
      }
    });
    Object.defineProperty(_this, 'handleStartDateChange', {
      enumerable: true,
      writable: true,
      value: function value(date) {
        var clearAssignee = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var surface_type = _this.props.phase.surface_type;
        var _this$state3 = _this.state,
            smartSchedulable = _this$state3.smartSchedulable,
            _this$state3$selected = _this$state3.selectedAssignee,
            selectedAssignee = _this$state3$selected === undefined ? {} : _this$state3$selected,
            projectedJobDays = _this$state3.projectedJobDays,
            endDate = _this$state3.endDate;

        var ssAssignee = _this.assigneeSmartSchedulable();
        var applySsFeatures = smartSchedulable && ssAssignee;
        var newArrivalStartMoment = moment_business_days_default.a.isMoment(date) ? date : moment_business_days_default()(date, constants["E" /* DISPLAY_DATE */], true);
        if (newArrivalStartMoment.isValid()) {
          var newState = {
            startDate: newArrivalStartMoment.format(constants["E" /* DISPLAY_DATE */]),
            endDate: applySsFeatures ? newArrivalStartMoment.clone().add(Math.max(projectedJobDays, 1) - 1, 'days').format(constants["E" /* DISPLAY_DATE */]) : _this.getDateFromDifferential(newArrivalStartMoment, endDate)
          };
          if (_this.hasConfirmationAndPickup()) {
            var startMoment = moment_business_days_default()(newState.startDate, constants["E" /* DISPLAY_DATE */], true);
            var pickupDiff = surface_type.name.toLowerCase() === 'carpet' || surface_type.name === 'Backsplash' ? 0 : 3;
            newState.confirmationDate = _this.getSubtractedDate(startMoment, APPT_CONFIRMATION_DIFF, true);
            newState.pickupDate = _this.getSubtractedDate(startMoment, pickupDiff, true);
          }
          if (clearAssignee && applySsFeatures) {
            newState.selectedAssignee = null;
            _this.setState(newState);
          } else if (applySsFeatures) {
            newState.scheduleStart = moment_business_days_default()(newState.startDate, constants["E" /* DISPLAY_DATE */], true).toDate();
            _this.setState(newState, function () {
              return _this.handleArrivalStartChange(selectedAssignee.suggestedStartTime || '08:00', false);
            });
          } else _this.setState(newState);
        }
      }
    });
    Object.defineProperty(_this, 'handleEndDateChange', {
      enumerable: true,
      writable: true,
      value: function value(date) {
        var clearAssignee = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        var applySsFeatures = _this.state.smartSchedulable && _this.assigneeSmartSchedulable();
        if (moment_business_days_default()(date, constants["E" /* DISPLAY_DATE */], true).isValid()) {
          var newState = { endDate: date };
          if (applySsFeatures && clearAssignee) newState.selectedAssignee = null;
          _this.setState(newState);
        }
      }
    });
    Object.defineProperty(_this, 'handleSchedulingReasonChange', {
      enumerable: true,
      writable: true,
      value: function value(option) {
        return _this.setState({ schedulingReason: option.value });
      }
    });
    Object.defineProperty(_this, 'handleDeliverySuggestionSelected', {
      enumerable: true,
      writable: true,
      value: function value(suggestionData) {
        var key = suggestionData.key,
            assignee = suggestionData.assignee,
            opening = suggestionData.opening,
            startTime = suggestionData.startTime,
            endTime = suggestionData.endTime;

        _this.setState({
          selectedDeliverySuggestion: key,
          selectedDeliveryAssignee: schedulePhaseAppointment__extends({}, assignee, { suggestedStartTime: startTime }),
          deliveryStartDate: opening,
          deliveryArrivalStart: startTime,
          deliveryArrivalEnd: endTime,
          suggestionKey: null,
          selectedAssignee: null,
          arrivalStart: null,
          arrivalEnd: null,
          projectedJobDays: null,
          projectedJobLength: null,
          projectedCompletion: null,
          startDate: null,
          endDate: null,
          confirmationDate: null,
          pickupDate: null
        });
      }
    });
    Object.defineProperty(_this, 'handleInstallSuggestionSelected', {
      enumerable: true,
      writable: true,
      value: function value(suggestionData) {
        var key = suggestionData.key,
            assignee = suggestionData.assignee,
            opening = suggestionData.opening,
            projectedJobDays = suggestionData.projectedJobDays,
            projectedJobLength = suggestionData.projectedJobLength,
            projectedCompletion = suggestionData.projectedCompletion,
            startTime = suggestionData.startTime,
            endTime = suggestionData.endTime;

        var normalizedCompletion = projectedCompletion;
        if (projectedCompletion) {
          var completionMoment = Object(dateUtils["r" /* parseDateStrict */])(projectedCompletion, constants["F" /* DISPLAY_DATE_TIME */]);
          if (completionMoment.isValid()) {
            normalizedCompletion = completionMoment.format(constants["_21" /* RAILS_DATE_TIME */]);
          }
        }
        _this.setState({
          suggestionKey: key,
          selectedAssignee: schedulePhaseAppointment__extends({}, assignee, { suggestedStartTime: startTime }),
          arrivalStart: startTime,
          arrivalEnd: endTime,
          projectedJobDays: projectedJobDays,
          projectedJobLength: projectedJobLength,
          projectedCompletion: normalizedCompletion
        }, function () {
          return _this.handleSuggestionDates(opening);
        });
      }
    });
    Object.defineProperty(_this, 'handleAssessmentSuggestionSelected', {
      enumerable: true,
      writable: true,
      value: function value(suggestionData) {
        var key = suggestionData.key;

        _this.setState({
          suggestionKey: key,
          assessmentSuggestion: suggestionData
        });
      }
    });
    Object.defineProperty(_this, 'handleSuggestionSelected', {
      enumerable: true,
      writable: true,
      value: function value(suggestionData) {
        var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'install';

        switch (type) {
          case 'assessment':
            _this.handleAssessmentSuggestionSelected(suggestionData);
            break;
          case 'delivery':
            _this.handleDeliverySuggestionSelected(suggestionData);
            break;
          default:
            _this.handleInstallSuggestionSelected(suggestionData);
        }
      }
    });
    Object.defineProperty(_this, 'handleScheduleSelect', {
      enumerable: true,
      writable: true,
      value: function value(date, _ref, adjustedStartTime, ssBlockage) {
        var appointments = _ref.appointments,
            assignee = _ref.assignee,
            _ref$projectedJobDays = _ref.projectedJobDays,
            projectedJobDays = _ref$projectedJobDays === undefined ? 0 : _ref$projectedJobDays,
            _ref$projectedJobLeng = _ref.projectedJobLength,
            projectedJobLength = _ref$projectedJobLeng === undefined ? 0 : _ref$projectedJobLeng;
        return _this.setState({
          selectedAssignee: schedulePhaseAppointment__extends({}, assignee, {
            appointments: appointments,
            suggestedStartTime: adjustedStartTime || assignee.default_start_time || ''
          }),
          ssBlockage: ssBlockage,
          projectedJobDays: projectedJobDays || 0,
          projectedJobLength: projectedJobLength || 0
        }, function () {
          return _this.handleStartDateChange(date, false);
        });
      }
    });
    Object.defineProperty(_this, 'handleOpeningClick', {
      enumerable: true,
      writable: true,
      value: function value(nextOpening, member) {
        return _this.handleScheduleSelect(nextOpening, member, (member.assignee.crew_specific || {}).default_start_time || '');
      }
    });
    Object.defineProperty(_this, 'handleRescheduleClose', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ showRescheduleModal: false });
      }
    });
    Object.defineProperty(_this, 'handleSubmit', {
      enumerable: true,
      writable: true,
      value: function value() {
        var newApptType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

        if (!_this.validate()) return;
        if (_this.props.quickSchedule) {
          _this.submitQuickSchedule(newApptType);
          return;
        }
        if (_this.isReschedule()) _this.setState({ showRescheduleModal: true });else if (_this.state.showInstallSuggestions) _this.submitInstallSuggestionAppt({}, newApptType);else _this.submitAppointment({}, newApptType);
      }
    });
    Object.defineProperty(_this, 'submitQuickSchedule', {
      enumerable: true,
      writable: true,
      value: function value() {
        var newApptType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var _this$state4 = _this.state,
            apptType = _this$state4.apptType,
            selectedAssignee = _this$state4.selectedAssignee,
            startDate = _this$state4.startDate,
            endDate = _this$state4.endDate,
            arrivalStart = _this$state4.arrivalStart,
            arrivalEnd = _this$state4.arrivalEnd,
            confirmationDate = _this$state4.confirmationDate,
            note = _this$state4.note,
            pickupDate = _this$state4.pickupDate,
            schedulingReason = _this$state4.schedulingReason;

        var effectiveKind = newApptType || apptType;
        var params = schedulePhaseAppointment__extends({}, _this.buildBaseParams({
          kind: effectiveKind,
          startDate: startDate,
          endDate: endDate,
          arrivalStart: arrivalStart,
          arrivalEnd: arrivalEnd,
          confirmationDate: confirmationDate,
          note: note || '',
          pickupDate: pickupDate,
          schedulingReason: schedulingReason
        }), {
          assignee_id: selectedAssignee && selectedAssignee.id || null,
          assignee_type: selectedAssignee && selectedAssignee.kind || null
        });
        return _this.props.quickSchedule.onSubmit(_this.props.phase.id, params);
      }
    });
    Object.defineProperty(_this, 'handleCancel', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.navigate(urls.phaseAppointments(_this.props.phase));
      }
    });
    Object.defineProperty(_this, 'handleFilterChange', {
      enumerable: true,
      writable: true,
      value: function value(key, _value2) {
        return _this.setState(schedulePhaseAppointment__defineProperty({}, key, _value2));
      }
    });
    Object.defineProperty(_this, 'isReschedule', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$state5 = _this.state,
            arrivalStart = _this$state5.arrivalStart,
            arrivalEnd = _this$state5.arrivalEnd,
            startDate = _this$state5.startDate,
            endDate = _this$state5.endDate,
            selectedAssignee = _this$state5.selectedAssignee,
            overrideReschedule = _this$state5.overrideReschedule,
            apptType = _this$state5.apptType,
            showInstallSuggestions = _this$state5.showInstallSuggestions;
        var _this$props3 = _this.props,
            appointment = _this$props3.appointment,
            isEdit = _this$props3.isEdit;

        if (showInstallSuggestions) return isEdit;
        if (!(appointment && appointment.id) || overrideReschedule) return false;
        return appointment.apptType !== apptType || appointment.arrivalStart !== arrivalStart || appointment.arrivalEnd !== arrivalEnd || appointment.startDate !== startDate || appointment.endDate !== endDate || appointment.selectedAssignee.id !== selectedAssignee.id || appointment.selectedAssignee.kind !== selectedAssignee.kind;
      }
    });
    Object.defineProperty(_this, 'warningArray', {
      enumerable: true,
      writable: true,
      value: function value() {
        var ssBlockage = _this.state.ssBlockage;

        if (!ssBlockage) return [];
        var strippedBlockage = ssBlockage.replace('WARNING: ', '');
        if (!strippedBlockage.includes(',')) return [strippedBlockage];
        return strippedBlockage.split(', ');
      }
    });
    Object.defineProperty(_this, 'submitSuggestionInstall', {
      enumerable: true,
      writable: true,
      value: function value(phaseId, params, submitArgs, event, phase) {
        return _this.props.onSubmit(phaseId, params, submitArgs, event || {}).then(function (data) {
          if (data.payload.inspection_required && !_this.isIfi()) _this.toggleConfirmDialog();else _this.props.navigate(urls.phaseAppointments(phase));
        }).catch(function () {});
      }
    });
    Object.defineProperty(_this, 'submitAssessmentSuggestionAppt', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props4 = _this.props,
            phaseId = _this$props4.phase.id,
            userName = _this$props4.userName,
            isEdit = _this$props4.isEdit;
        var _this$state$assessmen = _this.state.assessmentSuggestion,
            kind = _this$state$assessmen.kind,
            start_date = _this$state$assessmen.start_date,
            end_date = _this$state$assessmen.end_date,
            arrival_start_time = _this$state$assessmen.arrival_start_time,
            arrival_end_time = _this$state$assessmen.arrival_end_time,
            assignee_id = _this$state$assessmen.assignee_id,
            assignee_type = _this$state$assessmen.assignee_type;

        var params = {
          kind: kind,
          start_date: _this.getSaveableDate(start_date),
          end_date: _this.getSaveableDate(end_date),
          arrival_start_time: arrival_start_time,
          arrival_end_time: arrival_end_time,
          appointment_confirmation_date: null,
          note: isEdit ? 'Assessment edited via Smart Scheduling by ' + userName : 'Smart Scheduling-generated assessment saved by ' + userName,
          scheduling_reason: '',
          assignee_id: assignee_id,
          assignee_type: assignee_type
        };
        var submitArgs = { source: 'suggestion', ignoredWarnings: [] };
        return _this.props.onSubmit(phaseId, params, submitArgs, {}).then(function () {
          _this.props.navigate(urls.phaseAppointments(_this.props.phase));
        }).catch(function () {});
      }
    });
    Object.defineProperty(_this, 'isProjectedCompletionEmpty', {
      enumerable: true,
      writable: true,
      value: function value(_value3) {
        return !_value3 || typeof _value3 === 'string' && _value3.trim() === '';
      }
    });
    Object.defineProperty(_this, 'buildBaseParams', {
      enumerable: true,
      writable: true,
      value: function value(_ref2) {
        var kind = _ref2.kind,
            startDate = _ref2.startDate,
            endDate = _ref2.endDate,
            arrivalStart = _ref2.arrivalStart,
            arrivalEnd = _ref2.arrivalEnd,
            confirmationDate = _ref2.confirmationDate,
            note = _ref2.note,
            pickupDate = _ref2.pickupDate,
            schedulingReason = _ref2.schedulingReason;
        return {
          kind: kind,
          start_date: _this.getSaveableDate(startDate),
          end_date: _this.getSaveableDate(endDate),
          arrival_start_time: arrivalStart,
          arrival_end_time: arrivalEnd,
          appointment_confirmation_date: _this.getSaveableDate(confirmationDate),
          note: note,
          pickup_date: _this.getSaveableDate(pickupDate),
          scheduling_reason: schedulingReason
        };
      }
    });
    Object.defineProperty(_this, 'computeProjCompletion', {
      enumerable: true,
      writable: true,
      value: function value(_ref3) {
        var startDate = _ref3.startDate,
            arrivalStart = _ref3.arrivalStart,
            projectedJobLength = _ref3.projectedJobLength,
            projectedJobDays = _ref3.projectedJobDays,
            selectedAssignee = _ref3.selectedAssignee;

        var suggested = selectedAssignee && (selectedAssignee.suggestedStartTime || selectedAssignee.default_start_time) || '';
        if (projectedJobLength > 0 && projectedJobDays > 0) {
          var value = Object(schedulingUtils["c" /* determineProjectedCompletion */])(projectedJobLength, projectedJobDays, startDate, arrivalStart, suggested);
          if (value && moment_business_days_default()(value, constants["F" /* DISPLAY_DATE_TIME */], true).isValid()) {
            return moment_business_days_default()(value, constants["F" /* DISPLAY_DATE_TIME */], true).format(constants["_21" /* RAILS_DATE_TIME */]);
          }
          return '';
        }
        // Fallback: end of the arrival window on the start day using default window size
        var startT = arrivalStart || '08:00';
        var endT = Object(dateUtils["j" /* getEndTimeString */])(startT, false);
        if (startDate) {
          var fallbackMoment = Object(dateUtils["r" /* parseDateStrict */])(startDate + ' ' + endT, constants["E" /* DISPLAY_DATE */] + ' ' + constants["_3" /* MOMENT_TIME */]);
          if (fallbackMoment.isValid()) {
            return fallbackMoment.format(constants["_21" /* RAILS_DATE_TIME */]);
          }
        }
        return '';
      }
    });
    Object.defineProperty(_this, 'submitInstallSuggestionAppt', {
      enumerable: true,
      writable: true,
      value: function value(event) {
        var newApptType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        var _this$props5 = _this.props,
            phase = _this$props5.phase,
            phaseId = _this$props5.phase.id,
            userName = _this$props5.userName;
        var _this$state6 = _this.state,
            apptType = _this$state6.apptType,
            startDate = _this$state6.startDate,
            endDate = _this$state6.endDate,
            arrivalStart = _this$state6.arrivalStart,
            arrivalEnd = _this$state6.arrivalEnd,
            confirmationDate = _this$state6.confirmationDate,
            pickupDate = _this$state6.pickupDate,
            schedulingReason = _this$state6.schedulingReason,
            projectedCompletion = _this$state6.projectedCompletion,
            projectedJobLength = _this$state6.projectedJobLength,
            _this$state6$selected = _this$state6.selectedAssignee,
            installerId = _this$state6$selected.id,
            kind = _this$state6$selected.kind,
            _this$state6$selected2 = _this$state6.selectedDeliveryAssignee,
            selectedDeliveryAssignee = _this$state6$selected2 === undefined ? null : _this$state6$selected2,
            _this$state6$delivery = _this$state6.deliveryStartDate,
            deliveryStartDate = _this$state6$delivery === undefined ? null : _this$state6$delivery,
            _this$state6$delivery2 = _this$state6.deliveryArrivalStart,
            deliveryArrivalStart = _this$state6$delivery2 === undefined ? null : _this$state6$delivery2,
            _this$state6$delivery3 = _this$state6.deliveryArrivalEnd,
            deliveryArrivalEnd = _this$state6$delivery3 === undefined ? null : _this$state6$delivery3,
            _this$state6$needDeli = _this$state6.needDelivery,
            needDelivery = _this$state6$needDeli === undefined ? false : _this$state6$needDeli;

        var apptKind = newApptType || apptType;

        var projCompletion = projectedCompletion;
        if (_this.isProjectedCompletionEmpty(projCompletion) && _this.isInstallApptType(apptKind) && startDate && arrivalStart) {
          // Use days inferred from length when suggestions are active.
          var inferredDays = Math.max(1, Math.ceil(projectedJobLength / constants["_62" /* WORK_DAY_HOURS */]));
          projCompletion = _this.computeProjCompletion({
            startDate: startDate,
            arrivalStart: arrivalStart,
            projectedJobLength: projectedJobLength,
            projectedJobDays: inferredDays,
            selectedAssignee: _this.state.selectedAssignee
          });
        }
        var params = schedulePhaseAppointment__extends({}, _this.buildBaseParams({
          kind: apptKind,
          startDate: startDate,
          endDate: endDate,
          arrivalStart: arrivalStart,
          arrivalEnd: arrivalEnd,
          confirmationDate: confirmationDate,
          note: 'Smart Scheduling-generated appt. ' + (newApptType ? 'edited' : 'saved') + ' by ' + userName,
          pickupDate: needDelivery ? deliveryStartDate : pickupDate,
          schedulingReason: schedulingReason
        }), {
          projected_completion: _this.normalizeProjectedCompletion(projCompletion),
          projected_job_length: projectedJobLength,
          assignee_id: installerId,
          assignee_type: kind
        });
        var submitArgs = { source: 'suggestion', ignoredWarnings: [] };
        if (needDelivery) {
          var apptDate = _this.getSaveableDate(deliveryStartDate);
          var deliveryKind = 'delivery' + (apptKind.includes('hold') ? '_hold' : '');
          var deliveryParams = {
            kind: deliveryKind,
            start_date: apptDate,
            end_date: apptDate,
            arrival_start_time: deliveryArrivalStart,
            arrival_end_time: deliveryArrivalEnd,
            note: 'Smart Scheduling-generated delivery ' + (deliveryKind.includes('hold') ? 'hold' : '') + ' saved by ' + userName,
            scheduling_reason: schedulingReason,
            assignee_id: selectedDeliveryAssignee.id || null,
            assignee_type: selectedDeliveryAssignee.kind || null
          };
          return _this.props.onSubmit(phaseId, deliveryParams, submitArgs, {}).then(function () {
            return _this.submitSuggestionInstall(phaseId, params, submitArgs, event || {}, phase);
          });
        }
        return _this.submitSuggestionInstall(phaseId, params, submitArgs, event || {}, phase);
      }
    });
    Object.defineProperty(_this, 'submitAppointment', {
      enumerable: true,
      writable: true,
      value: function value(event) {
        var newApptType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        var _this$state7 = _this.state,
            apptType = _this$state7.apptType,
            selectedAssignee = _this$state7.selectedAssignee,
            startDate = _this$state7.startDate,
            endDate = _this$state7.endDate,
            arrivalStart = _this$state7.arrivalStart,
            arrivalEnd = _this$state7.arrivalEnd,
            confirmationDate = _this$state7.confirmationDate,
            note = _this$state7.note,
            pickupDate = _this$state7.pickupDate,
            showRescheduleModal = _this$state7.showRescheduleModal,
            overrideReschedule = _this$state7.overrideReschedule,
            schedulingReason = _this$state7.schedulingReason,
            projectedCompletion = _this$state7.projectedCompletion,
            _this$state7$projecte = _this$state7.projectedJobLength,
            projectedJobLength = _this$state7$projecte === undefined ? 0 : _this$state7$projecte,
            _this$state7$projecte2 = _this$state7.projectedJobDays,
            projectedJobDays = _this$state7$projecte2 === undefined ? 0 : _this$state7$projecte2;

        var effectiveKind = newApptType || apptType;

        var projCompletion = projectedCompletion;
        if (_this.isProjectedCompletionEmpty(projCompletion) && _this.isInstallApptType(effectiveKind) && startDate && arrivalStart) {
          projCompletion = _this.computeProjCompletion({
            startDate: startDate,
            arrivalStart: arrivalStart,
            projectedJobLength: projectedJobLength,
            projectedJobDays: projectedJobDays,
            selectedAssignee: selectedAssignee
          });
        }
        var params = schedulePhaseAppointment__extends({}, _this.buildBaseParams({
          kind: effectiveKind,
          startDate: startDate,
          endDate: endDate,
          arrivalStart: arrivalStart,
          arrivalEnd: arrivalEnd,
          confirmationDate: confirmationDate,
          note: note || '',
          pickupDate: pickupDate,
          schedulingReason: schedulingReason
        }), {
          projected_completion: _this.normalizeProjectedCompletion(projCompletion)
        });
        if (selectedAssignee && selectedAssignee.id) {
          params.assignee_id = selectedAssignee.id;
          params.assignee_type = selectedAssignee.kind;
        } else {
          params.assignee_id = null;
          params.assignee_type = null;
        }
        var phase = _this.props.phase;
        var ignoredWarnings = _this.warningArray();
        if (_this.props.isEdit && overrideReschedule) {
          return _this.props.onSubmit(phase.id, params, { source: 'calendar', ignoredWarnings: ignoredWarnings }, event, overrideReschedule).then(function (data) {
            if (data.payload.inspection_required) _this.handleCrewInspection(true);else _this.props.navigate(urls.phaseAppointments(phase));
          }).catch(function () {});
        }
        return _this.props.onSubmit(phase.id, params, { source: 'calendar', ignoredWarnings: ignoredWarnings }, event).then(function (data) {
          var kind = data.payload.appointment.kind;

          if (showRescheduleModal) _this.handleRescheduleClose();
          if (data.payload.inspection_required) _this.handleCrewInspection(showRescheduleModal);else if (_this.isDeliveryAppt(kind)) {
            _this.toggleConfirmDeliveryDialog();
          } else _this.props.navigate(urls.phaseAppointments(phase));
        }).catch(function () {});
      }
    });
    Object.defineProperty(_this, 'handleCrewInspection', {
      enumerable: true,
      writable: true,
      value: function value(overrideReschedule) {
        if (_this.isIfi()) {
          _this.props.navigate(urls.phaseAppointments(_this.props.phase));
        } else {
          _this.handleAppointmentTypeChange('crew_inspection', overrideReschedule);
          _this.toggleConfirmDialog();
        }
      }
    });
    Object.defineProperty(_this, 'toggleConfirmDialog', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ showDialog: !_this.state.showDialog });
      }
    });
    Object.defineProperty(_this, 'toggleConfirmDeliveryDialog', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ showDeliveryDialog: !_this.state.showDeliveryDialog });
      }
    });
    Object.defineProperty(_this, 'handleDeliveryApptSuccess', {
      enumerable: true,
      writable: true,
      value: function value(apptType) {
        var startDate = _this.state.startDate;

        var deliveryApptDay = moment_business_days_default()(startDate);
        var deliveryApptDayClone = deliveryApptDay.clone();
        if (['delivery', 'delivery_hold'].includes(apptType)) {
          var threeDaysLater = deliveryApptDayClone.add(3, 'days');
          _this.handleStartDateChange(threeDaysLater);
        } else if (apptType === 'deliver_stack_cali_bamboo') {
          var sevenDaysLater = deliveryApptDayClone.add(7, 'days');
          _this.handleStartDateChange(sevenDaysLater, false);
        }
        _this.handleAppointmentTypeChange(apptType === 'delivery_hold' ? 'installation_hold' : 'installation', true);
        _this.toggleConfirmDeliveryDialog();
      }
    });
    Object.defineProperty(_this, 'validate', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$state8 = _this.state,
            arrivalStart = _this$state8.arrivalStart,
            arrivalEnd = _this$state8.arrivalEnd,
            startDate = _this$state8.startDate,
            endDate = _this$state8.endDate,
            confirmationDate = _this$state8.confirmationDate,
            pickupDate = _this$state8.pickupDate;

        var errors = _this.state.errors || {};
        if (Object.keys(errors).length === 0) {
          var as = moment_business_days_default.a.duration(arrivalStart).asSeconds();
          var ae = moment_business_days_default.a.duration(arrivalEnd).asSeconds();
          if (as > ae) errors.arrivalStart = ['Must be earlier than end time'];
        }
        var startMoment = moment_business_days_default()(startDate, constants["E" /* DISPLAY_DATE */]);
        errors.startDate = _this.validateDate(startDate, null, null, true);
        errors.endDate = _this.validateDate(endDate, startMoment, 'gte', true);
        errors.confirmationDate = _this.validateDate(confirmationDate, startMoment, 'lt');
        errors.pickupDate = _this.validateDate(pickupDate, startMoment, 'lte');
        var hasErrors = Object.values(errors).some(function (error) {
          return error;
        });
        if (hasErrors) _this.props.addValidationErrors(errors);
        return !hasErrors;
      }
    });
    Object.defineProperty(_this, 'validateDate', {
      enumerable: true,
      writable: true,
      value: function value(date, comparisonDate, comparison) {
        var required = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

        var invalidDate = ['Please enter a valid date'];
        if (!date || date.toString().trim() === '') return required ? invalidDate : null;
        var momentDate = moment_business_days_default()(date, constants["E" /* DISPLAY_DATE */]);
        if (!momentDate.isValid()) return invalidDate;
        if (comparison === 'lt' && momentDate.isSameOrAfter(comparisonDate, 'day')) {
          return ['Date must be before appointment date.'];
        }
        if (comparison === 'lte' && momentDate.isAfter(comparisonDate, 'day')) {
          return ['Date cannot be after appointment date.'];
        }
        if (comparison === 'gte' && momentDate.isBefore(comparisonDate, 'day')) {
          return ['Date cannot be before appointment date.'];
        }
        return null;
      }
    });
    Object.defineProperty(_this, 'nextSchedule', {
      enumerable: true,
      writable: true,
      value: function value(numDays) {
        return function () {
          return _this.setState({
            scheduleStart: moment_business_days_default()(_this.state.scheduleStart).add(numDays, 'days').toDate()
          });
        };
      }
    });
    Object.defineProperty(_this, 'lastSchedule', {
      enumerable: true,
      writable: true,
      value: function value(numDays) {
        return function () {
          return _this.setState({
            scheduleStart: moment_business_days_default()(_this.state.scheduleStart).subtract(numDays, 'days').toDate()
          });
        };
      }
    });
    Object.defineProperty(_this, 'handleJumpDate', {
      enumerable: true,
      writable: true,
      value: function value(date) {
        return _this.setState({ scheduleStart: date.toDate() });
      }
    });
    Object.defineProperty(_this, 'pendingAppointment', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props6 = _this.props,
            phase = _this$props6.phase,
            appointment = _this$props6.appointment;
        var _this$state9 = _this.state,
            apptType = _this$state9.apptType,
            arrivalStart = _this$state9.arrivalStart,
            arrivalEnd = _this$state9.arrivalEnd,
            startDate = _this$state9.startDate,
            endDate = _this$state9.endDate,
            projectedCompletion = _this$state9.projectedCompletion;

        return {
          id: appointment && appointment.id || -1,
          start_date: moment_business_days_default()(startDate, constants["E" /* DISPLAY_DATE */], true).format(constants["_19" /* RAILS_DATE */]),
          end_date: moment_business_days_default()(endDate, constants["E" /* DISPLAY_DATE */], true).format(constants["_19" /* RAILS_DATE */]),
          arrival_start_time: arrivalStart,
          arrival_end_time: arrivalEnd,
          projected_completion: projectedCompletion,
          kind: apptType,
          phase: phase,
          selected: true
        };
      }
    });
    Object.defineProperty(_this, 'contractorType', {
      enumerable: true,
      writable: true,
      value: function value(apptType) {
        switch (apptType) {
          case 'assessment':
          case 'assessment_hold':
            return _this.isIfi() ? ['Estimator', 'Crew'] : ['Estimator', 'Employee'];
          case 'installation':
          case 'installation_hold':
          case 'bust_day':
            return ['Crew'];
          case 'delivery':
          case 'delivery_hold':
          case 'deliver_stack_cali_bamboo':
            return ['Crew', 'Employee', 'IQM'];
          case 'stack_cali_bamboo':
          case 'repair':
          case 'repair_inspection':
            return ['Crew', 'IQM', 'Employee'];
          case 'crew_inspection':
          case 'jobsite_inspection':
            return ['IQM', 'Employee'];
          default:
            return [];
        }
      }
    });
    Object.defineProperty(_this, 'schedInstallAfterDeliveryWarning', {
      enumerable: true,
      writable: true,
      value: function value(appointments) {
        var startDate = _this.state.startDate;

        var chosenDate = moment_business_days_default()(startDate);
        var chosenDateClone1 = chosenDate.clone();
        var chosenDateClone2 = chosenDate.clone();
        var threeDaysBefore = chosenDateClone1.subtract(3, 'days');
        var sevenDaysBefore = chosenDateClone2.subtract(7, 'days');
        var warning = '';
        appointments.forEach(function (appt) {
          var deliveryAppt = moment_business_days_default()(appt.start_date);
          // Test having both a delivery and delivery_stack_cali bamboo case
          if (appt.kind === 'delivery' && (deliveryAppt.isBetween(threeDaysBefore, chosenDate) || deliveryAppt.isSame(chosenDate) || chosenDate.isBefore(deliveryAppt))) {
            warning = 'Installation appointment must be at least 3 days after Delivery\n                   appointment on ' + moment_business_days_default()(deliveryAppt).format('MM/DD/YYYY');
          } else if (appt.kind === 'deliver_stack_cali_bamboo' && (deliveryAppt.isBetween(sevenDaysBefore, chosenDate) || deliveryAppt.isSame(chosenDate) || chosenDate.isBefore(deliveryAppt))) {
            warning = 'Installation appointment must be at least 7 days after Cali Bamboo Delivery\n                   appointment on ' + moment_business_days_default()(deliveryAppt).format(constants["E" /* DISPLAY_DATE */]);
          }
        });
        return warning;
      }
    });
    Object.defineProperty(_this, 'findSuggestionDisableReason', {
      enumerable: true,
      writable: true,
      value: function value(phase) {
        var selectedAssignee = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        if (!selectedAssignee) return '';
        var zip_code = phase.zip_code,
            phaseWorkroom = phase.workroom.id;
        var _selectedAssignee$kin = selectedAssignee.kind,
            kind = _selectedAssignee$kin === undefined ? '' : _selectedAssignee$kin,
            _selectedAssignee$cov = selectedAssignee.covered_zip_codes,
            covered_zip_codes = _selectedAssignee$cov === undefined ? [] : _selectedAssignee$cov,
            _selectedAssignee$tra = selectedAssignee.traveling_zip_codes,
            traveling_zip_codes = _selectedAssignee$tra === undefined ? [] : _selectedAssignee$tra,
            _selectedAssignee$wor = selectedAssignee.workrooms,
            assigneeWorkrooms = _selectedAssignee$wor === undefined ? [] : _selectedAssignee$wor;

        if (kind !== 'Crew') return 'Selected assignee is not a crew';
        if (!assigneeWorkrooms.length || !assigneeWorkrooms.some(function (w) {
          return w.workroom.id === phaseWorkroom;
        })) return 'Selected assignee is not assigned to phase workroom';
        if ((!covered_zip_codes.length || !covered_zip_codes.includes(zip_code)) && (!traveling_zip_codes.length || !traveling_zip_codes.includes(zip_code))) return 'Selected assignee is not assigned to phase zip code';
        return '';
      }
    });
    Object.defineProperty(_this, 'blockedByUserVendorPerms', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props7 = _this.props,
            _this$props7$mvw = _this$props7.mvw,
            mvw = _this$props7$mvw === undefined ? null : _this$props7$mvw,
            _this$props7$phase$so = _this$props7.phase.source,
            source = _this$props7$phase$so === undefined ? '' : _this$props7$phase$so;

        if (!_this.isEmployee()) return false;
        var vendorToCheck = Object(utils["u" /* normalizeSource */])(source).toLowerCase();
        return mvw && mvw[vendorToCheck] === false;
      }
    });
    Object.defineProperty(_this, 'blockedByVendor', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props8 = _this.props,
            source = _this$props8.phase.source,
            _this$props8$mvw = _this$props8.mvw,
            mvw = _this$props8$mvw === undefined ? null : _this$props8$mvw;
        var _this$state10 = _this.state,
            _this$state10$selecte = _this$state10.selectedAssignee,
            selectedAssignee = _this$state10$selecte === undefined ? null : _this$state10$selecte,
            startDate = _this$state10.startDate,
            endDate = _this$state10.endDate;

        var normalizedSource = Object(utils["u" /* normalizeSource */])(source);
        if (_this.blockedByUserVendorPerms()) return 'User lacks scheduling permissions for phase vendor';
        if (!selectedAssignee || !(selectedAssignee.appointments || []).length) return false;
        var selectedMemberSameDayAppts = selectedAssignee.appointments.filter(function (a) {
          var start_date = a.start_date,
              end_date = a.end_date;

          var apptRange = moment_default.a.range(moment_default()(start_date, constants["_19" /* RAILS_DATE */]), moment_default()(end_date, constants["_19" /* RAILS_DATE */]));
          return apptRange.contains(moment_default()(startDate, constants["E" /* DISPLAY_DATE */])) || apptRange.contains(moment_default()(endDate, constants["E" /* DISPLAY_DATE */]));
        });
        if (selectedMemberSameDayAppts.length === 0) return false;
        return _this.isEmployee() && selectedMemberSameDayAppts.some(function (a) {
          var apptSource = a.phase.source;

          var vendorToMatch = Object(utils["u" /* normalizeSource */])(apptSource);
          return !(mvw[vendorToMatch.toLowerCase()] || false) || !_this.isAssessment() && vendorToMatch !== normalizedSource;
        });
      }
    });
    Object.defineProperty(_this, 'renderDeliveryValidationWarning', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$state11 = _this.state,
            applyDeliveryValidation = _this$state11.applyDeliveryValidation,
            apptType = _this$state11.apptType;
        var appointments = _this.props.phase.appointments;

        var warning = '';
        if (applyDeliveryValidation && apptType === 'installation') {
          var deliveryScheduled = appointments.some(function (appt) {
            return _this.isDeliveryAppt(appt.kind);
          });
          // if a delivery has not been scheduled, render warning and don't allow save
          if (deliveryScheduled === false) return 'Must schedule Delivery before Installation';
          // Before installation appointment make sure delivery appt is at least
          // 3 days prior while cali bamboo delivery is at least 7 days prior
          warning = _this.schedInstallAfterDeliveryWarning(appointments);
        }
        return warning;
      }
    });
    Object.defineProperty(_this, 'renderWarning', {
      enumerable: true,
      writable: true,
      value: function value() {
        var warning = _this.renderFieldsWarning();
        if (!_this.isIfi() && !warning && _this.state.apptType === 'installation' && _this.state.applyDeliveryValidation) warning = _this.renderDeliveryValidationWarning();
        return warning;
      }
    });
    Object.defineProperty(_this, 'renderFieldsWarning', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$state12 = _this.state,
            startDate = _this$state12.startDate,
            arrivalStart = _this$state12.arrivalStart,
            smartSchedulable = _this$state12.smartSchedulable,
            _this$state12$selecte = _this$state12.selectedAssignee,
            assignee = _this$state12$selecte === undefined ? {} : _this$state12$selecte;

        var applySsFeatures = smartSchedulable && _this.assigneeSmartSchedulable();
        var _this$props9 = _this.props,
            originalDate = _this$props9.originalDate,
            originalStart = _this$props9.originalStart,
            _this$props9$phase = _this$props9.phase,
            id = _this$props9$phase.id,
            communication_method = _this$props9$phase.communication_method,
            type = _this$props9$phase.type,
            relatedPhases = _this$props9.relatedPhases;

        var apptMoment = moment_business_days_default()(originalDate + ' ' + originalStart, constants["E" /* DISPLAY_DATE */] + ' HH:mm', true);
        var nowMoment = moment_business_days_default()();
        var dateTimeChanged = (originalDate || originalStart) && (originalDate !== startDate || originalStart !== arrivalStart);
        var apptInPast = moment_business_days_default()(apptMoment).isBefore(nowMoment);
        var autoComm = communication_method && communication_method.toLowerCase() !== 'none';
        var canBeSSBlocked = !_this.isIfi() && applySsFeatures && !Object(lodash["isEmpty"])(assignee) && (assignee.apptsOnDay || []).length && !Object(schedulingUtils["e" /* existingApptsRelate */])(id, assignee.apptsOnDay || [], relatedPhases);
        var warning = '';
        var vendorBlocked = _this.blockedByVendor();
        if (typeof vendorBlocked === 'string') warning = vendorBlocked;else if (vendorBlocked) {
          warning = 'Assignee has appts. scheduled outside of your service area';
        } else if (canBeSSBlocked && Object(schedulingUtils["d" /* doTimesOverlap */])(_this.pendingAppointment(), assignee.apptsOnDay[0])) {
          warning = 'Times overlap, please change the start time';
        } else {
          var requiredFields = Object.keys(constants["_25" /* REQUIRED_APPT_FIELDS */]);
          requiredFields.forEach(function (field) {
            if (!((['Assessment', 'Workorder'].includes(type) || _this.state.apptType.includes('inspection')) && field === 'schedulingReason') && !_this.state[field]) {
              warning += warning ? ', ' + constants["_25" /* REQUIRED_APPT_FIELDS */][field] : 'Please select a(n) ' + constants["_25" /* REQUIRED_APPT_FIELDS */][field];
            }
          });
        }
        if (!warning && dateTimeChanged && autoComm && !apptInPast) warning = constants["n" /* AUTO_COMM_MESSAGE */];
        return warning;
      }
    });
    Object.defineProperty(_this, 'renderDeliveryDialog', {
      enumerable: true,
      writable: true,
      value: function value(apptType) {
        if (apptType === 'delivery') {
          return 'An installation appointment should be scheduled 3-5 days after the delivery';
        } else if (apptType === 'delivery_hold') {
          return 'An installation hold should be scheduled 3-5 days after the delivery hold';
        } else if (apptType === 'deliver_stack_cali_bamboo') {
          return 'An installation appointment should be scheduled at least 7 days after the Cali Bamboo is delivered and stacked';
        }
        return '';
      }
    });
    Object.defineProperty(_this, 'renderApptTypeBtns', {
      enumerable: true,
      writable: true,
      value: function value() {
        var apptType = _this.state.apptType;

        var btnArray = [];
        var isInstall = apptType === 'installation';
        var isHold = apptType === 'installation_hold' || apptType === 'delivery_hold';
        var isAssessmentHold = apptType === 'assessment_hold';
        var isBust = apptType === 'bust_day';
        if (isAssessmentHold) {
          btnArray.push(react_default.a.createElement(ColoredButton["a" /* default */], {
            className: phaseAppointments_styles_default.a.apptTypeBtn,
            label: 'Convert Appt. To Assessment',
            onClick: function onClick() {
              return _this.submitAppointment({}, 'assessment');
            },
            color: 'green'
          }));
        }
        if (isHold || isBust) {
          btnArray.push(react_default.a.createElement(ColoredButton["a" /* default */], {
            className: phaseAppointments_styles_default.a.apptTypeBtn,
            label: 'Convert Appt. To Installation',
            onClick: _this.isCcs() ? function () {
              return _this.submitInstallSuggestionAppt({}, 'installation');
            } : function () {
              return _this.submitAppointment({}, 'installation');
            },
            color: 'green'
          }));
        }
        if (isInstall || isBust) {
          btnArray.push(react_default.a.createElement(ColoredButton["a" /* default */], {
            className: phaseAppointments_styles_default.a.apptTypeBtn,
            label: 'Convert Appt. To Installation Hold',
            onClick: _this.isCcs() ? function () {
              return _this.submitInstallSuggestionAppt({}, 'installation_hold');
            } : function () {
              return _this.submitAppointment({}, 'installation_hold');
            },
            color: 'blue'
          }));
        }
        if (!_this.isCcs() && (isInstall || isHold)) {
          btnArray.push(react_default.a.createElement(ColoredButton["a" /* default */], {
            className: phaseAppointments_styles_default.a.apptTypeBtn,
            label: 'Bust Appt.',
            onClick: function onClick() {
              return _this.submitAppointment({}, 'bust_day');
            },
            color: 'red'
          }));
        }
        /* We may want to re-ad buttons to flip back and forth between install suggestions/calendar */
        // if (!this.isCcs() && this.isInstallApptType()) {
        //   btnArray.push(<ColoredButton
        //     className={styles.apptTypeBtn}
        //     label="Revert to Appt. Suggestions"
        //     onClick={() => this.resetState(false)}
        //     color="red"
        //   />);
        // }
        return btnArray.length > 0 && react_default.a.createElement(
          'div',
          { className: phaseAppointments_styles_default.a.apptTypeBtnContainer },
          btnArray.map(function (b) {
            return b;
          })
        );
      }
    });
    Object.defineProperty(_this, 'renderAppointmentForm', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$state13 = _this.state,
            apptType = _this$state13.apptType,
            startDate = _this$state13.startDate,
            endDate = _this$state13.endDate,
            arrivalStart = _this$state13.arrivalStart,
            arrivalEnd = _this$state13.arrivalEnd,
            note = _this$state13.note,
            confirmationDate = _this$state13.confirmationDate,
            pickupDate = _this$state13.pickupDate,
            zone = _this$state13.zone,
            schedulingReason = _this$state13.schedulingReason,
            smartSchedulable = _this$state13.smartSchedulable;
        var _this$props10 = _this.props,
            errors = _this$props10.errors,
            phase = _this$props10.phase,
            isEdit = _this$props10.isEdit;

        var momentDate = moment_business_days_default()(startDate, constants["E" /* DISPLAY_DATE */]);
        var showSchedulingReason = phase.type === 'Installation' && !apptType.includes('inspection');
        var ssDisabled = _this.isCcs() && smartSchedulable;
        return react_default.a.createElement(
          'div',
          null,
          react_default.a.createElement(
            'div',
            { className: phaseAppointments_styles_default.a.ResourceDetails },
            react_default.a.createElement(
              ResourceCardElement,
              { size: 'small', wrap: true },
              react_default.a.createElement(DatePicker, {
                label: 'Start Date',
                value: startDate,
                onChange: _this.handleStartDateChange,
                className: phaseAppointments_styles_default.a.datepicker,
                placeholder: 'Select Date',
                required: true,
                disabled: ssDisabled,
                error: errors.startDate
              })
            ),
            react_default.a.createElement(
              ResourceCardElement,
              { size: 'small', wrap: true },
              react_default.a.createElement(DatePicker, {
                label: 'End Date',
                value: endDate,
                onChange: _this.handleEndDateChange,
                className: phaseAppointments_styles_default.a.datepicker,
                placeholder: 'Select Date',
                disabled: ssDisabled,
                required: true,
                error: errors.endDate
              })
            ),
            react_default.a.createElement(
              ResourceCardElement,
              { size: 'small', wrap: true },
              react_default.a.createElement(components_TimeInput, {
                label: 'Arrival Start Time (' + zone + ') *',
                value: arrivalStart,
                onChange: _this.handleArrivalStartChange,
                disabled: !isEdit && ssDisabled,
                errors: errors.arrivalStart
              })
            ),
            react_default.a.createElement(
              ResourceCardElement,
              { size: 'small', wrap: true },
              react_default.a.createElement(components_TimeInput, {
                label: 'Arrival End Time (' + zone + ') *',
                value: arrivalEnd,
                onChange: _this.handleArrivalEndChange,
                disabled: !isEdit && ssDisabled,
                errors: errors.arrivalEnd
              })
            )
          ),
          react_default.a.createElement(
            'div',
            { className: phaseAppointments_styles_default.a.ResourceDetails },
            !['installation', 'repair'].includes(apptType) && react_default.a.createElement(
              ResourceCardElement,
              { size: 'small', wrap: true, className: phaseAppointments_styles_default.a.confirmationDate },
              react_default.a.createElement(DatePicker, {
                label: 'Appt. Confirmation Date',
                placeholder: 'Select Date',
                value: confirmationDate,
                maxDate: momentDate.toDate(),
                className: phaseAppointments_styles_default.a.datepicker,
                onChange: _this.handleConfirmationDateChange('confirmationDate'),
                error: errors.confirmationDate
              })
            ),
            react_default.a.createElement(
              ResourceCardElement,
              { size: 'small', wrap: true, className: phaseAppointments_styles_default.a.confirmationDate },
              react_default.a.createElement(DatePicker, {
                label: 'Pickup Date',
                value: pickupDate,
                maxDate: momentDate.toDate(),
                onChange: _this.handlePickupDateChange,
                className: phaseAppointments_styles_default.a.datepicker,
                placeholder: 'Select Date',
                error: errors.pickupDate
              })
            ),
            showSchedulingReason && react_default.a.createElement(
              ResourceCardElement,
              { size: 'small', wrap: true },
              react_default.a.createElement(react_select, {
                label: 'Scheduling Reason',
                placeholder: 'Select Reason',
                onChange: _this.handleSchedulingReasonChange,
                options: constants["_31" /* SCHEDULING_REASONS */],
                value: schedulingReason,
                error: errors.schedulingReason,
                required: true
              })
            )
          ),
          react_default.a.createElement(
            'div',
            { className: phaseAppointments_styles_default.a.formPadding },
            react_default.a.createElement(components_SimpleInput, {
              label: 'Notes',
              text: note.includes('WARNING:') ? note.split('WARNING:')[0] : note,
              errors: errors.note,
              onChange: _this.handleNoteChange
            })
          )
        );
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props11 = _this.props,
            userName = _this$props11.userName,
            role = _this$props11.role,
            employableId = _this$props11.employableId,
            position = _this$props11.position,
            relatedPhases = _this$props11.relatedPhases,
            isEdit = _this$props11.isEdit,
            errors = _this$props11.errors,
            quickSchedule = _this$props11.quickSchedule,
            phase = _this$props11.phase,
            _this$props11$phase = _this$props11.phase,
            phaseId = _this$props11$phase.id,
            zip_code = _this$props11$phase.zip_code,
            type = _this$props11$phase.type,
            name = _this$props11$phase.surface_type.name,
            delivery_method = _this$props11$phase.store.delivery_method,
            spig_delivery = _this$props11$phase.spig_delivery,
            source = _this$props11$phase.source,
            estimator_id = _this$props11$phase.estimator_id,
            installer_id = _this$props11$phase.installer_id;
        var _this$state14 = _this.state,
            zone = _this$state14.zone,
            scheduleStart = _this$state14.scheduleStart,
            assignee_type = _this$state14.assignee_type,
            workroom = _this$state14.workroom,
            surface_type = _this$state14.surface_type,
            estimator = _this$state14.estimator,
            startDate = _this$state14.startDate,
            endDate = _this$state14.endDate,
            selectedAssignee = _this$state14.selectedAssignee,
            showRescheduleModal = _this$state14.showRescheduleModal,
            showDialog = _this$state14.showDialog,
            showDeliveryDialog = _this$state14.showDeliveryDialog,
            crew = _this$state14.crew,
            defaultCalStart = _this$state14.defaultCalStart,
            smartSchedulable = _this$state14.smartSchedulable,
            applyDeliveryValidation = _this$state14.applyDeliveryValidation,
            ssBlockage = _this$state14.ssBlockage,
            showInstallSuggestions = _this$state14.showInstallSuggestions,
            suggestionKey = _this$state14.suggestionKey,
            selectedDeliverySuggestion = _this$state14.selectedDeliverySuggestion,
            schedulingReason = _this$state14.schedulingReason,
            apptType = _this$state14.apptType,
            _this$state14$deliver = _this$state14.deliveryStartDate,
            deliveryStartDate = _this$state14$deliver === undefined ? '' : _this$state14$deliver,
            needDelivery = _this$state14.needDelivery,
            showAssessmentSuggestions = _this$state14.showAssessmentSuggestions;

        var startMoment = moment_business_days_default()(scheduleStart);
        var endMoment = moment_business_days_default()(scheduleStart).add(7, 'days');
        var dates = moment_business_days_default.a.range(startMoment, endMoment).toArray('days', true);
        var pAppt = _this.pendingAppointment();
        var scheduleFilters = { assignee_type: assignee_type, workroom: workroom, surface_type: surface_type, estimator: estimator, crew: crew };
        if (!showInstallSuggestions && _this.isDeliveryAppt(apptType)) scheduleFilters.surface_type = [];
        var warningDisplay = _this.renderWarning();
        var disableButtonIfWarning = warningDisplay.length && warningDisplay !== constants["n" /* AUTO_COMM_MESSAGE */];
        var closeInspectionModal = showInstallSuggestions ? function () {
          return _this.props.navigate(urls.phaseAppointments(phase));
        } : _this.toggleConfirmDialog;
        return react_default.a.createElement(
          'section',
          null,
          isEdit && _this.renderApptTypeBtns(),
          showInstallSuggestions ? react_default.a.createElement(
            components_Card,
            { className: phaseAppointments_styles_default.a.scheduleCard },
            react_default.a.createElement(components_installSuggestions, {
              position: position,
              zone: zone,
              date: startDate,
              phase: phase,
              suggestionKey: suggestionKey,
              selectedDeliverySuggestion: selectedDeliverySuggestion,
              deliveryStartDate: deliveryStartDate,
              schedulingReason: schedulingReason,
              relatedPhases: relatedPhases,
              suggestionDisableReason: _this.findSuggestionDisableReason(phase, selectedAssignee),
              onSelect: _this.handleSuggestionSelected,
              handleSubmit: function handleSubmit() {
                return _this.handleSubmit('installation');
              },
              handleAltSub: function handleAltSub() {
                return _this.handleSubmit('installation_hold');
              },
              handleSchedulingReasonChange: _this.handleSchedulingReasonChange,
              overrideToCal: function overrideToCal() {
                return _this.resetState(true);
              },
              needDelivery: needDelivery,
              deliveryArgs: {
                surfaceType: name, deliveryMethod: delivery_method, spigDelivery: spig_delivery
              },
              errors: errors
            })
          ) : react_default.a.createElement(
            react["Fragment"],
            null,
            showAssessmentSuggestions ? react_default.a.createElement(
              components_Card,
              { className: phaseAppointments_styles_default.a.scheduleCard },
              react_default.a.createElement(assessmentSuggestions, {
                isCcs: _this.isCcs(),
                zone: zone,
                date: startDate,
                phaseId: phaseId,
                phaseType: type,
                suggestionKey: suggestionKey,
                schedulingReason: schedulingReason,
                onSelect: _this.handleSuggestionSelected,
                handleSubmit: _this.submitAssessmentSuggestionAppt,
                handleShowAssessmentSuggestions: _this.handleShowAssessmentSuggestions,
                clearAssessmentSuggestion: _this.clearAssessmentSuggestion,
                isAfternoon: IS_AFTERNOON,
                errors: errors
              })
            ) : react_default.a.createElement(
              react["Fragment"],
              null,
              react_default.a.createElement(
                components_Card,
                { className: phaseAppointments_styles_default.a.scheduleCard },
                react_default.a.createElement(components_calendar, {
                  title: 'Select Assignee & Date',
                  date: scheduleStart,
                  defaultCalStart: defaultCalStart.toDate(),
                  dates: dates,
                  filters: scheduleFilters,
                  onFilterChange: _this.handleFilterChange,
                  navigatePast: _this.lastSchedule,
                  navigateFuture: _this.nextSchedule,
                  selectable: true,
                  selectedDayStart: moment_business_days_default()(startDate, constants["E" /* DISPLAY_DATE */], true),
                  selectedDayEnd: moment_business_days_default()(endDate, constants["E" /* DISPLAY_DATE */], true),
                  selectedAssignee: selectedAssignee,
                  onSelect: _this.handleScheduleSelect,
                  pendingAppointment: pAppt,
                  headerClassName: phaseAppointments_styles_default.a.scheduleHeader,
                  filterClassName: phaseAppointments_styles_default.a.filters,
                  filterTheme: constants["K" /* FILTER_THEME */],
                  handleJumpDate: _this.handleJumpDate,
                  role: role,
                  username: userName,
                  onOpeningClick: _this.handleOpeningClick,
                  applySmartScheduling: smartSchedulable,
                  handleDeliveryValidation: _this.handleDeliveryValidation,
                  relatedPhases: relatedPhases,
                  setDelayedField: _this.setDelayedField,
                  isCcs: _this.isCcs(),
                  employableId: employableId,
                  phaseZip: zip_code,
                  phaseType: type,
                  phaseSource: source,
                  phaseEstimatorId: estimator_id,
                  phaseInstallerId: installer_id,
                  handleShowAssessmentSuggestions: _this.handleShowAssessmentSuggestions
                })
              ),
              react_default.a.createElement(
                components_Card,
                { className: phaseAppointments_styles_default.a.contentArea },
                react_default.a.createElement(
                  'div',
                  { className: phaseAppointments_styles_default.a.headerContainer },
                  react_default.a.createElement(
                    'div',
                    { className: phaseAppointments_styles_default.a.sectionTitle },
                    'Schedule An Appointment'
                  ),
                  needDelivery && react_default.a.createElement(react_toolbox_lib["Switch"], {
                    name: 'Validate Delivery',
                    label: 'Validate Delivery',
                    onChange: _this.handleDeliveryValidation,
                    checked: applyDeliveryValidation
                  })
                ),
                _this.renderAppointmentForm(),
                react_default.a.createElement(
                  'div',
                  { className: phaseAppointments_styles_default.a.workerContainer },
                  react_default.a.createElement(
                    'div',
                    { className: phaseAppointments_styles_default.a.saveButtonContainer },
                    react_default.a.createElement(ColoredButton["a" /* default */], {
                      className: phaseAppointments_styles_default.a.mainSubmitButton,
                      label: 'Cancel',
                      onClick: _this.handleCancel,
                      color: 'gray'
                    }),
                    quickSchedule && react_default.a.createElement(ColoredButton["a" /* default */], {
                      className: phaseAppointments_styles_default.a.mainSubmitButton,
                      label: quickSchedule.label || 'Send Quick Schedule',
                      onClick: function onClick() {
                        return _this.handleSubmit(quickSchedule.forceKind || '');
                      },
                      disabled: disableButtonIfWarning,
                      color: 'green'
                    }),
                    !quickSchedule && (!isEdit && _this.isInstallApptType() ? react_default.a.createElement(
                      react["Fragment"],
                      null,
                      react_default.a.createElement(ColoredButton["a" /* default */], {
                        className: phaseAppointments_styles_default.a.mainSubmitButton,
                        label: 'Save As Installation',
                        onClick: function onClick() {
                          return _this.handleSubmit('installation');
                        },
                        disabled: disableButtonIfWarning || apptType === 'installation_hold',
                        color: 'green'
                      }),
                      react_default.a.createElement(ColoredButton["a" /* default */], {
                        label: 'Save As Hold',
                        onClick: function onClick() {
                          return _this.handleSubmit('installation_hold');
                        },
                        disabled: disableButtonIfWarning,
                        color: 'blue'
                      })
                    ) : react_default.a.createElement(ColoredButton["a" /* default */], {
                      className: phaseAppointments_styles_default.a.mainSubmitButton,
                      label: 'Save Appointment',
                      onClick: function onClick() {
                        return _this.handleSubmit();
                      },
                      disabled: disableButtonIfWarning
                    }))
                  ),
                  warningDisplay && react_default.a.createElement(
                    'div',
                    { className: phaseAppointments_styles_default.a.fieldsWarning },
                    warningDisplay
                  )
                )
              )
            )
          ),
          react_default.a.createElement(rescheduleAppointmentModal, {
            type: type,
            active: showRescheduleModal,
            onSubmit: showInstallSuggestions ? _this.submitInstallSuggestionAppt : _this.submitAppointment,
            onClose: _this.handleRescheduleClose,
            ssBlockage: ssBlockage,
            errors: errors
          }),
          showDialog && react_default.a.createElement(ConfirmDialog["a" /* default */], {
            theActions: ['OK'],
            title: 'Schedule Crew Inspection',
            confirmation: 'The scheduled crew has less than 5 completed appointments.',
            dismiss: closeInspectionModal,
            proceed: closeInspectionModal
          }),
          showDeliveryDialog && react_default.a.createElement(ConfirmDialog["a" /* default */], {
            theActions: ['OK'],
            title: apptType === 'delivery_hold' ? 'Schedule Installation Hold' : 'Schedule Installation',
            confirmation: _this.renderDeliveryDialog(apptType),
            dismiss: function dismiss() {
              return _this.handleDeliveryApptSuccess(apptType);
            },
            proceed: function proceed() {
              return _this.handleDeliveryApptSuccess(apptType);
            }
          })
        );
      }
    });

    _this.state = _this.getStateObj();
    _this.resetState = _this.resetState.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleDeliverySuggestionSelected = _this.handleDeliverySuggestionSelected.bind(_this);
    _this.handleInstallSuggestionSelected = _this.handleInstallSuggestionSelected.bind(_this);
    _this.handleAssessmentSuggestionSelected = _this.handleAssessmentSuggestionSelected.bind(_this);
    _this.handleSuggestionSelected = _this.handleSuggestionSelected.bind(_this);
    _this.handleSchedulingReasonChange = _this.handleSchedulingReasonChange.bind(_this);
    _this.setDelayedField = _this.setDelayedField.bind(_this);
    _this.clearAssessmentSuggestion = _this.clearAssessmentSuggestion.bind(_this);
    _this.submitAssessmentSuggestionAppt = _this.submitAssessmentSuggestionAppt.bind(_this);
    _this.handleShowAssessmentSuggestions = _this.handleShowAssessmentSuggestions.bind(_this);
    return _this;
  }

  // Helper: determines whether a projected completion value is effectively empty


  // Builds common appointment params (formats dates once, ensures consistent keys)


  return SchedulePhaseAppointment;
}(react["Component"]);

schedulePhaseAppointment_SchedulePhaseAppointment.defaultProps = {
  originalDate: null,
  originalStart: '',
  originalEnd: '',
  isEdit: false,
  errors: {}
};

schedulePhaseAppointment_SchedulePhaseAppointment.propTypes = {
  phase: types_phase.isRequired,
  navigate: prop_types_default.a.func.isRequired,
  requestPhaseItems: prop_types_default.a.func,
  onSubmit: prop_types_default.a.func,
  addValidationErrors: prop_types_default.a.func.isRequired,
  requestRelatedPhases: prop_types_default.a.func.isRequired,
  appointment: Appointment,
  errors: prop_types_default.a.object,
  userName: prop_types_default.a.string,
  role: prop_types_default.a.string,
  employableId: prop_types_default.a.number,
  employableType: prop_types_default.a.string,
  position: prop_types_default.a.string,
  originalDate: prop_types_default.a.string,
  originalStart: prop_types_default.a.string,
  originalEnd: prop_types_default.a.string,
  isEdit: prop_types_default.a.bool,
  relatedPhases: prop_types_default.a.array,
  mvw: prop_types_default.a.object,
  quickSchedule: prop_types_default.a.shape({
    onSubmit: prop_types_default.a.func.isRequired,
    label: prop_types_default.a.string,
    forceKind: prop_types_default.a.string
  })
};

var schedulePhaseAppointment_mapStateToProps = function mapStateToProps(state) {
  var _state$phase = state.phase,
      details = _state$phase.details,
      data = _state$phase.related.data,
      _state$user = state.user,
      name = _state$user.name,
      role = _state$user.role,
      position = _state$user.position,
      employable_id = _state$user.employable_id,
      employable_type = _state$user.employable_type,
      manage_vendor_workrooms = _state$user.manage_vendor_workrooms;

  return {
    phase: details,
    relatedPhases: data,
    userName: name,
    employableId: employable_id,
    employableType: employable_type,
    mvw: manage_vendor_workrooms,
    role: role,
    position: position
  };
};

/* harmony default export */ var schedulePhaseAppointment = (Object(react_redux_es["connect"])(schedulePhaseAppointment_mapStateToProps, { navigate: actionCreators["O" /* navigate */], requestRelatedPhases: requestRelatedPhases, addValidationErrors: addValidationErrors })(schedulePhaseAppointment_SchedulePhaseAppointment));
// EXTERNAL MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/phaseActionMenu/quickScheduleModal.scss
var quickScheduleModal = __webpack_require__("vhgL");
var quickScheduleModal_default = /*#__PURE__*/__webpack_require__.n(quickScheduleModal);

// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/phaseActionMenu/quickScheduleModal.jsx
function quickScheduleModal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function quickScheduleModal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function quickScheduleModal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var quickScheduleModal_QuickScheduleModal = function (_React$Component) {
  quickScheduleModal__inherits(QuickScheduleModal, _React$Component);

  function QuickScheduleModal() {
    var _ref;

    var _temp, _this, _ret;

    quickScheduleModal__classCallCheck(this, QuickScheduleModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = quickScheduleModal__possibleConstructorReturn(this, (_ref = QuickScheduleModal.__proto__ || Object.getPrototypeOf(QuickScheduleModal)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'handleSubmit', {
      enumerable: true,
      writable: true,
      value: function value(phaseId, apptParams) {
        return _this.props.sendQuickScheduleMessage(phaseId, apptParams).then(function (action) {
          if (action && action.type === 'SEND_QUICK_SCHEDULE_MESSAGE_SUCCESS') {
            _this.props.onClose();
          }
          return action;
        });
      }
    }), Object.defineProperty(_this, 'apptTypeForPhase', {
      enumerable: true,
      writable: true,
      value: function value() {
        var type = _this.props.phase.type;

        if (type === 'Assessment') return 'assessment_hold';
        if (type === 'Workorder') return 'workorder_hold';
        return 'installation_hold';
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        return react_default.a.createElement(
          react_toolbox_lib["Dialog"],
          {
            active: _this.props.active,
            className: modal_default.a.modal + ' ' + quickScheduleModal_default.a.wideModal,
            onEscKeyDown: _this.props.onClose,
            onOverlayClick: _this.props.onClose
          },
          react_default.a.createElement(react_toolbox_lib["IconButton"], { icon: 'close', className: modal_default.a.close, onClick: _this.props.onClose }),
          react_default.a.createElement(
            'h5',
            null,
            'Quick Schedule'
          ),
          react_default.a.createElement(
            'p',
            null,
            'Schedule a hold and text the customer to confirm.'
          ),
          _this.props.active && react_default.a.createElement(schedulePhaseAppointment, {
            quickSchedule: {
              onSubmit: _this.handleSubmit,
              label: 'Send Quick Schedule',
              forceKind: _this.apptTypeForPhase()
            }
          })
        );
      }
    }), _temp), quickScheduleModal__possibleConstructorReturn(_this, _ret);
  }

  return QuickScheduleModal;
}(react_default.a.Component);

quickScheduleModal_QuickScheduleModal.propTypes = {
  active: prop_types_default.a.bool.isRequired,
  onClose: prop_types_default.a.func.isRequired,
  phase: types_phase.isRequired,
  sendQuickScheduleMessage: prop_types_default.a.func.isRequired
};

/* harmony default export */ var phaseActionMenu_quickScheduleModal = (Object(react_redux_es["connect"])(null, { sendQuickScheduleMessage: actionCreators["_44" /* sendQuickScheduleMessage */] })(quickScheduleModal_QuickScheduleModal));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/phaseActionMenu/customLaborSheetModal.jsx
var customLaborSheetModal__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function customLaborSheetModal__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function customLaborSheetModal__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function customLaborSheetModal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function customLaborSheetModal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function customLaborSheetModal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var customLaborSheetModal_CustomLaborSheetModal = function (_Component) {
  customLaborSheetModal__inherits(CustomLaborSheetModal, _Component);

  function CustomLaborSheetModal() {
    var _ref;

    var _temp, _this, _ret;

    customLaborSheetModal__classCallCheck(this, CustomLaborSheetModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = customLaborSheetModal__possibleConstructorReturn(this, (_ref = CustomLaborSheetModal.__proto__ || Object.getPrototypeOf(CustomLaborSheetModal)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'state', {
      enumerable: true,
      writable: true,
      value: {
        errorMessage: '',
        lineItems: [{ uid: 0, line_item_id: '', quantity: 1 }]
      }
    }), Object.defineProperty(_this, 'getOptionById', {
      enumerable: true,
      writable: true,
      value: function value(lineItemId) {
        return _this.lineItemOptionsList().find(function (option) {
          return String(option.value) === String(lineItemId);
        });
      }
    }), Object.defineProperty(_this, 'lineItemOptionsList', {
      enumerable: true,
      writable: true,
      value: function value() {
        return Object(lineItemUtils["j" /* normalizePayRateLineItemOptions */])(_this.props.lineItemOptions, _this.props.laborSheets);
      }
    }), Object.defineProperty(_this, 'lineItemUid', {
      enumerable: true,
      writable: true,
      value: 1
    }), Object.defineProperty(_this, 'handleLineItemChange', {
      enumerable: true,
      writable: true,
      value: function value(idx, attr) {
        return function (event) {
          var value = event && event.target ? event.target.value : event;
          _this.setState({
            lineItems: _this.state.lineItems.map(function (item, itemIdx) {
              return itemIdx === idx ? customLaborSheetModal__extends({}, item, customLaborSheetModal__defineProperty({}, attr, value)) : item;
            })
          });
        };
      }
    }), Object.defineProperty(_this, 'addLineItem', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.setState({
          lineItems: [].concat(customLaborSheetModal__toConsumableArray(_this.state.lineItems), [{
            uid: _this.lineItemUid,
            line_item_id: '',
            quantity: 1
          }])
        });
        _this.lineItemUid += 1;
      }
    }), Object.defineProperty(_this, 'removeLineItem', {
      enumerable: true,
      writable: true,
      value: function value(idx) {
        if (_this.state.lineItems.length === 1) {
          _this.setState({ lineItems: [{ uid: 0, line_item_id: '', quantity: 1 }] });
          return;
        }
        _this.setState({ lineItems: _this.state.lineItems.filter(function (_, itemIdx) {
            return itemIdx !== idx;
          }) });
      }
    }), Object.defineProperty(_this, 'buildContractorLineItems', {
      enumerable: true,
      writable: true,
      value: function value(laborSheetId) {
        return _this.state.lineItems.map(function (item) {
          var option = _this.getOptionById(item.line_item_id);
          var quantity = Number(item.quantity);
          if (!option || !quantity || quantity <= 0) return null;
          return {
            labor_sheet_id: laborSheetId,
            line_item_id: option.value,
            quantity: quantity,
            price: option.price
          };
        }).filter(Boolean);
      }
    }), Object.defineProperty(_this, 'handleSubmit', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            phase = _this$props.phase,
            laborSheets = _this$props.laborSheets;

        var hasLaborSheet = (laborSheets || []).some(function (sheet) {
          return sheet && sheet.id > 0;
        });
        if (hasLaborSheet) {
          _this.props.onClose();
          _this.props.navigate('/phases/' + phase.id + '/labor-product-accounting/laborsheet');
          return;
        }

        var appointment = (phase.appointments || [])[0];
        var laborSheet = appointment ? { appointment_id: appointment.id } : {};
        _this.props.createPhaseItem(phase.id, laborSheet, 'laborSheets').then(function (action) {
          if (action && action.type === 'CREATE_PHASE_ITEMS_SUCCESS') {
            var createdLaborSheet = action.line_item;
            var contractorLineItems = _this.buildContractorLineItems(createdLaborSheet.id);
            if (!contractorLineItems.length) {
              _this.setState({ errorMessage: '' });
              _this.props.onClose();
              _this.props.navigate('/phases/' + phase.id + '/labor-product-accounting/laborsheet');
              return;
            }
            Promise.all(contractorLineItems.map(function (lineItem) {
              return _this.props.createPhaseItem(phase.id, lineItem, 'contractorLineItems');
            })).then(function (results) {
              var failed = results.some(function (result) {
                return !result || result.type !== 'CREATE_PHASE_ITEMS_SUCCESS';
              });
              if (failed) {
                _this.setState({ errorMessage: 'Labor sheet created, but some line items failed to save.' });
                return;
              }
              _this.setState({ errorMessage: '' });
              _this.props.onClose();
              _this.props.navigate('/phases/' + phase.id + '/labor-product-accounting/laborsheet');
            });
            return;
          }
          _this.setState({ errorMessage: 'Failed to create Custom Labor Sheet.' });
        });
      }
    }), Object.defineProperty(_this, 'renderLineItemsEditor', {
      enumerable: true,
      writable: true,
      value: function value() {
        return react_default.a.createElement(
          'div',
          null,
          react_default.a.createElement(
            'p',
            { className: modal_default.a.text },
            'Optional: add line items before creating.'
          ),
          _this.state.lineItems.map(function (lineItem, idx) {
            var option = _this.getOptionById(lineItem.line_item_id);
            var price = option ? Number(option.price || 0) : 0;
            var quantity = Number(lineItem.quantity || 0);
            var subtotal = price * quantity;
            return react_default.a.createElement(
              'div',
              { key: lineItem.uid },
              react_default.a.createElement(
                'div',
                null,
                react_default.a.createElement(
                  'label',
                  { htmlFor: 'item-select-' + idx },
                  'Item'
                ),
                react_default.a.createElement(
                  'select',
                  {
                    id: 'item-select-' + idx,
                    value: lineItem.line_item_id,
                    onChange: _this.handleLineItemChange(idx, 'line_item_id')
                  },
                  react_default.a.createElement(
                    'option',
                    { value: '' },
                    'Select item'
                  ),
                  _this.lineItemOptionsList().map(function (optionItem) {
                    return react_default.a.createElement(
                      'option',
                      { key: optionItem.value, value: optionItem.value },
                      optionItem.label
                    );
                  })
                )
              ),
              react_default.a.createElement(
                'div',
                null,
                react_default.a.createElement(
                  'label',
                  { htmlFor: 'item-qty-' + idx },
                  'Quantity'
                ),
                react_default.a.createElement('input', {
                  id: 'item-qty-' + idx,
                  type: 'number',
                  min: '1',
                  value: lineItem.quantity,
                  onChange: _this.handleLineItemChange(idx, 'quantity')
                })
              ),
              react_default.a.createElement(
                'div',
                null,
                react_default.a.createElement(
                  'strong',
                  null,
                  'Description:'
                ),
                ' ',
                option ? option.label : '-'
              ),
              react_default.a.createElement(
                'div',
                null,
                react_default.a.createElement(
                  'strong',
                  null,
                  'Cost:'
                ),
                ' $',
                price.toFixed(2)
              ),
              react_default.a.createElement(
                'div',
                null,
                react_default.a.createElement(
                  'strong',
                  null,
                  'Subtotal:'
                ),
                ' $',
                subtotal.toFixed(2)
              ),
              react_default.a.createElement(lib_button["Button"], {
                label: 'Remove',
                flat: true,
                onClick: function onClick() {
                  return _this.removeLineItem(idx);
                }
              })
            );
          }),
          react_default.a.createElement(lib_button["Button"], { label: 'Add Line Item', flat: true, onClick: _this.addLineItem })
        );
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props2 = _this.props,
            active = _this$props2.active,
            onClose = _this$props2.onClose;
        var errorMessage = _this.state.errorMessage;

        return react_default.a.createElement(
          react_toolbox_lib["Dialog"],
          {
            active: active,
            className: modal_default.a.modal,
            type: 'fullscreen',
            onEscKeyDown: onClose,
            onOverlayClick: onClose
          },
          errorMessage && react_default.a.createElement(MessageBox["a" /* default */], { error: true, message: errorMessage }),
          react_default.a.createElement(lib_button["IconButton"], {
            icon: 'close',
            className: modal_default.a.close,
            onClick: onClose,
            tabIndex: -1
          }),
          react_default.a.createElement(
            'h5',
            { className: modal_default.a.title },
            'Create Custom Labor Sheet'
          ),
          react_default.a.createElement(
            'p',
            { className: modal_default.a.text },
            'Confirm to create a custom labor sheet now. You can continue and add labor line items after creation.'
          ),
          _this.renderLineItemsEditor(),
          react_default.a.createElement(lib_button["Button"], {
            label: 'Create',
            flat: true, inverse: true, ripple: true,
            className: modal_default.a.submit,
            onClick: _this.handleSubmit
          })
        );
      }
    }), _temp), customLaborSheetModal__possibleConstructorReturn(_this, _ret);
  }

  return CustomLaborSheetModal;
}(react["Component"]);

customLaborSheetModal_CustomLaborSheetModal.propTypes = {
  active: prop_types_default.a.bool.isRequired,
  onClose: prop_types_default.a.func.isRequired,
  phase: prop_types_default.a.object.isRequired,
  laborSheets: prop_types_default.a.array,
  lineItemOptions: prop_types_default.a.oneOfType([prop_types_default.a.array, prop_types_default.a.object]),
  createPhaseItem: prop_types_default.a.func.isRequired,
  navigate: prop_types_default.a.func.isRequired
};

customLaborSheetModal_CustomLaborSheetModal.defaultProps = {
  laborSheets: [],
  lineItemOptions: []
};

/* harmony default export */ var customLaborSheetModal = (customLaborSheetModal_CustomLaborSheetModal);
// EXTERNAL MODULE: ./node_modules/react-toolbox/lib/dropdown/index.js
var lib_dropdown = __webpack_require__("Bj6J");
var lib_dropdown_default = /*#__PURE__*/__webpack_require__.n(lib_dropdown);

// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/createSupportRequestModal.jsx
var createSupportRequestModal__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var createSupportRequestModal__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function createSupportRequestModal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function createSupportRequestModal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function createSupportRequestModal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var CATEGORY_OPTIONS = [{ value: 'LABOR', label: 'Labor' }, { value: 'PRODUCTS', label: 'Products' }, { value: 'REFUNDS', label: 'Refunds' }, { value: 'MISSING_DOCUMENTS', label: 'Missing Documents' }, { value: 'CUSTOMERS', label: 'Customer' }, { value: 'PERMITS', label: 'Permits' }];

var TYPE_OPTIONS_BY_CATEGORY = {
  Installation: {
    LABOR: ['MILEAGE', 'TRIP_FEE', 'MISSING_OR_INCORRECT_LABOR'],
    PRODUCTS: ['PRODUCT_NOT_READY_AT_JOBSITE', 'PRODUCT_NOT_READY_AT_STORE', 'DAMAGED_PRODUCT', 'MISSING_OR_INCORRECT_PRODUCT'],
    REFUNDS: ['FULL_REFUND', 'PARTIAL_REFUND', 'PERMIT_REFUND'],
    MISSING_DOCUMENTS: ['PROVIDE_DESIGNS', 'PROVIDE_PROPOSALS', 'PROVIDE_CONTRACT'],
    CUSTOMERS: ['UNABLE_TO_CONTACT_CUSTOMER', 'INCORRECT_CONTACT_INFORMATION'],
    PERMITS: ['ADD_PERMIT', 'EXTEND_PERMIT']
  },
  Assessment: {
    LABOR: ['MILEAGE', 'TRIP_FEE', 'MISSING_OR_INCORRECT_LABOR'],
    PRODUCTS: [],
    REFUNDS: ['FULL_REFUND', 'PARTIAL_REFUND'],
    MISSING_DOCUMENTS: ['PROVIDE_DESIGNS', 'PROVIDE_PROPOSALS'],
    CUSTOMERS: ['UNABLE_TO_CONTACT_CUSTOMER', 'INCORRECT_CONTACT_INFORMATION'],
    PERMITS: []
  },
  Workorder: {
    LABOR: ['MILEAGE', 'TRIP_FEE', 'MISSING_OR_INCORRECT_LABOR'],
    PRODUCTS: ['PRODUCT_NOT_READY_AT_JOBSITE', 'PRODUCT_NOT_READY_AT_STORE', 'DAMAGED_PRODUCT', 'MISSING_OR_INCORRECT_PRODUCT'],
    REFUNDS: ['PERMIT_REFUND'],
    MISSING_DOCUMENTS: ['PROVIDE_DESIGNS', 'PROVIDE_PROPOSALS', 'PROVIDE_CONTRACT'],
    CUSTOMERS: ['UNABLE_TO_CONTACT_CUSTOMER', 'INCORRECT_CONTACT_INFORMATION'],
    PERMITS: ['ADD_PERMIT', 'EXTEND_PERMIT']
  }
};

var PAYMENT_TYPE_OPTIONS = [{ value: 'TRIP_FEE', label: 'Trip Fee' }, { value: 'TRIP_FEE_AND_WAIT_FEE', label: 'Trip and Wait Fee' }, { value: 'WAIT_FEE', label: 'Wait Fee' }, { value: 'NONE', label: 'None' }];

var MAX_DESCRIPTION_LENGTH = 250;

var requiresPaymentType = function requiresPaymentType(supportCategory) {
  return supportCategory === 'PRODUCTS';
};

// Converts snake_case or UPPER_CASE strings into Title Case for display.
var toTitleCase = function toTitleCase(value) {
  return value.replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, function (c) {
    return c.toUpperCase();
  });
};

var friendlyLabel = function friendlyLabel(value) {
  return toTitleCase(value);
};

var createSupportRequestModal_CreateSupportRequestModal = function (_Resetter) {
  createSupportRequestModal__inherits(CreateSupportRequestModal, _Resetter);

  function CreateSupportRequestModal() {
    var _ref;

    var _temp, _this, _ret;

    createSupportRequestModal__classCallCheck(this, CreateSupportRequestModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = createSupportRequestModal__possibleConstructorReturn(this, (_ref = CreateSupportRequestModal.__proto__ || Object.getPrototypeOf(CreateSupportRequestModal)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'handleSubmit', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.setState({ submitting: true }, function () {
          var baseValid = _this.validate();
          var needsPaymentType = requiresPaymentType(_this.state.supportCategory) && !_this.state.exceptionPaymentType;

          if (!baseValid || needsPaymentType) {
            if (needsPaymentType) {
              _this.setState(function (_ref2) {
                var errors = _ref2.errors;
                return {
                  errors: createSupportRequestModal__extends({}, errors, { exceptionPaymentType: ['Required'] }),
                  submitting: false
                };
              });
              return;
            }
            _this.setState({ submitting: false });
            return;
          }

          var _this$state = _this.state,
              supportCategory = _this$state.supportCategory,
              supportType = _this$state.supportType,
              supportDescription = _this$state.supportDescription,
              exceptionPaymentType = _this$state.exceptionPaymentType;

          var payload = {
            supportCategory: supportCategory,
            supportType: supportType,
            supportDescription: supportDescription,
            exceptionPaymentType: exceptionPaymentType
          };

          if (requiresPaymentType(supportCategory)) {
            payload.exceptionPaymentType = exceptionPaymentType;
          }

          _this.props.createSupportRequest(_this.props.phase.id, payload).then(function () {
            _this.handleClose();
          }).catch(function () {
            _this.setState({ submitting: false });
          });
        });
      }
    }), Object.defineProperty(_this, 'handleClose', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.setState(CreateSupportRequestModal.DEFAULT_STATE);
        _this.props.onClose();
      }
    }), Object.defineProperty(_this, 'handleCategoryChange', {
      enumerable: true,
      writable: true,
      value: function value(_value) {
        _this.setState({
          supportCategory: _value,
          supportType: '',
          exceptionPaymentType: ''
        });
      }
    }), Object.defineProperty(_this, 'handleSupportTypeChange', {
      enumerable: true,
      writable: true,
      value: function value(_value2) {
        _this.setState({
          supportType: _value2,
          exceptionPaymentType: ''
        });
      }
    }), _temp), createSupportRequestModal__possibleConstructorReturn(_this, _ret);
  }

  createSupportRequestModal__createClass(CreateSupportRequestModal, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          active = _props.active,
          phase = _props.phase;
      var _state = this.state,
          supportCategory = _state.supportCategory,
          supportType = _state.supportType,
          exceptionPaymentType = _state.exceptionPaymentType,
          errors = _state.errors,
          submitting = _state.submitting;


      var typeOptions = TYPE_OPTIONS_BY_CATEGORY[phase.type] || {};
      var supportTypeOptions = (typeOptions[supportCategory] || []).map(function (value) {
        return {
          value: value,
          label: friendlyLabel(value)
        };
      });

      return react_default.a.createElement(
        components_ComposeWindow,
        {
          active: active,
          title: 'Create Support Request',
          onClose: this.handleClose
        },
        react_default.a.createElement(lib_dropdown_default.a, {
          label: 'Choose a topic *',
          source: CATEGORY_OPTIONS,
          value: supportCategory,
          onChange: this.handleCategoryChange,
          error: (errors.supportCategory || [])[0]
        }),
        react_default.a.createElement(lib_dropdown_default.a, {
          label: 'What do you need help with? *',
          source: supportTypeOptions,
          value: supportType,
          onChange: this.handleSupportTypeChange,
          error: (errors.supportType || [])[0],
          disabled: !supportCategory
        }),
        react_default.a.createElement(components_TextArea, {
          label: 'Describe your issue *',
          value: this.state.supportDescription
          // Defensive: handle both string and event
          , onChange: function onChange(e) {
            return _this2.setState({ supportDescription: e.target ? e.target.value : e });
          },
          className: ComposeWindow_styles_default.a.compose,
          errors: errors.supportDescription,
          maxLength: MAX_DESCRIPTION_LENGTH,
          autoFocus: true,
          ref: function ref(comp) {
            _this2.textAreaComponentRef = comp;
          }
        }),
        requiresPaymentType(supportCategory) && react_default.a.createElement(lib_dropdown_default.a, {
          label: 'Exception payment type *',
          source: PAYMENT_TYPE_OPTIONS,
          value: exceptionPaymentType,
          onChange: function onChange(value) {
            return _this2.setState({ exceptionPaymentType: value });
          },
          error: (errors.exceptionPaymentType || [])[0]
        }),
        react_default.a.createElement(
          'div',
          { className: ComposeWindow_styles_default.a.actions },
          react_default.a.createElement(lib_button["Button"], {
            label: 'Create Support Request',
            primary: true,
            flat: true,
            ripple: true,
            disabled: submitting,
            className: ComposeWindow_styles_default.a.submit,
            onClick: this.handleSubmit
          })
        )
      );
    }
  }]);

  return CreateSupportRequestModal;
}(resetter(validator(react_default.a.Component)));

Object.defineProperty(createSupportRequestModal_CreateSupportRequestModal, 'DEFAULT_STATE', {
  enumerable: true,
  writable: true,
  value: {
    supportCategory: '',
    supportType: '',
    supportDescription: '',
    exceptionPaymentType: '',
    errors: {},
    submitting: false
  }
});
Object.defineProperty(createSupportRequestModal_CreateSupportRequestModal, 'VALIDATIONS', {
  enumerable: true,
  writable: true,
  value: {
    supportCategory: true,
    supportType: true,
    supportDescription: true
  }
});


createSupportRequestModal_CreateSupportRequestModal.propTypes = {
  active: prop_types_default.a.bool.isRequired,
  phase: types_phase.isRequired,
  onClose: prop_types_default.a.func.isRequired,
  createSupportRequest: prop_types_default.a.func.isRequired
};

/* harmony default export */ var createSupportRequestModal = (Object(react_redux_es["connect"])(function (state) {
  return { errors: Object(reducers["Y" /* getPhaseErrors */])(state) };
}, { createSupportRequest: actionCreators_phase["i" /* createSupportRequest */] })(createSupportRequestModal_CreateSupportRequestModal));
// EXTERNAL MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/phaseActionMenu/styles.scss
var phaseActionMenu_styles = __webpack_require__("Q6F6");
var phaseActionMenu_styles_default = /*#__PURE__*/__webpack_require__.n(phaseActionMenu_styles);

// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/phaseActionMenu/index.jsx
function phaseActionMenu__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function phaseActionMenu__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function phaseActionMenu__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function phaseActionMenu__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function phaseActionMenu__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






































// Hiding Add Installer Pay button in case it required again



var CancelPhaseItem = Auth_visibleFor('cancel', 'phase', function (_ref) {
  var onClick = _ref.onClick,
      disabled = _ref.disabled;
  return react_default.a.createElement(lib_menu["MenuItem"], {
    className: phaseActionMenu_styles_default.a.item,
    caption: 'Cancel Phase',
    onClick: onClick,
    disabled: disabled
  });
});

/**
 * We get PropType errors due to passing jsx tags as captions.
 * The caption prop expects a string only. We might need to
 * figure out a different approach for these, or ignore the
 * errors, but this is why they happen.
 */

var phaseActionMenu_CreateFlagItem = function CreateFlagItem(_ref2) {
  var onClick = _ref2.onClick;
  return react_default.a.createElement(lib_menu["MenuItem"], {
    className: phaseActionMenu_styles_default.a.item,
    caption: react_default.a.createElement(
      'span',
      null,
      'Add ',
      react_default.a.createElement(
        'u',
        null,
        'F'
      ),
      'lag'
    ),
    onClick: onClick
  });
};

var CreateEventItem = Auth_visibleFor('create', 'event', function (_ref3) {
  var label = _ref3.label,
      onClick = _ref3.onClick;
  return react_default.a.createElement(lib_menu["MenuItem"], {
    className: phaseActionMenu_styles_default.a.item,
    caption: label,
    onClick: onClick
  });
});

var UpdateContractorNotePhaseItem = Auth_visibleFor('update_contractor_notes', 'phase', function (_ref4) {
  var label = _ref4.label,
      onClick = _ref4.onClick;
  return react_default.a.createElement(lib_menu["MenuItem"], {
    className: phaseActionMenu_styles_default.a.item,
    caption: label,
    onClick: onClick
  });
});

var AssignPhaseItem = Auth_visibleFor('assign', 'estimator', function (_ref5) {
  var label = _ref5.label,
      onClick = _ref5.onClick;
  return react_default.a.createElement(lib_menu["MenuItem"], {
    className: phaseActionMenu_styles_default.a.item,
    caption: label,
    onClick: onClick
  });
});

var AssignInstallerItem = Auth_visibleFor('assign', 'installer', function (_ref6) {
  var label = _ref6.label,
      onClick = _ref6.onClick;
  return react_default.a.createElement(lib_menu["MenuItem"], {
    className: phaseActionMenu_styles_default.a.item,
    caption: label,
    onClick: onClick
  });
});

var CreateWorkorderItem = Auth_visibleFor('copy', 'phase', function (_ref7) {
  var label = _ref7.label,
      onClick = _ref7.onClick;
  return react_default.a.createElement(lib_menu["MenuItem"], {
    className: phaseActionMenu_styles_default.a.item,
    caption: label,
    onClick: onClick
  });
});

var CreateExceptionItem = Auth_visibleFor('update', 'create_exception', function (_ref8) {
  var label = _ref8.label,
      onClick = _ref8.onClick;
  return react_default.a.createElement(lib_menu["MenuItem"], {
    className: phaseActionMenu_styles_default.a.item,
    caption: label,
    onClick: onClick
  });
});

var CreateWalkthroughItem = Auth_visibleFor('update', 'walkthrough', function (_ref9) {
  var label = _ref9.label,
      onClick = _ref9.onClick;
  return react_default.a.createElement(lib_menu["MenuItem"], {
    className: phaseActionMenu_styles_default.a.item,
    caption: label,
    onClick: onClick
  });
});

var CreateRepairInspectionItem = Auth_visibleFor('update', 'repair_inspection_report', function (_ref10) {
  var label = _ref10.label,
      onClick = _ref10.onClick;
  return react_default.a.createElement(lib_menu["MenuItem"], {
    className: phaseActionMenu_styles_default.a.item,
    caption: label,
    onClick: onClick
  });
});

var CreateCrewInspectionItem = Auth_visibleFor('update', 'crew_inspection', function (_ref11) {
  var label = _ref11.label,
      onClick = _ref11.onClick;
  return react_default.a.createElement(lib_menu["MenuItem"], {
    className: phaseActionMenu_styles_default.a.item,
    caption: label,
    onClick: onClick
  });
});

var InstallationsPaperworkItem = Auth_visibleFor('view', 'installations_paperwork', function (_ref12) {
  var label = _ref12.label,
      onClick = _ref12.onClick;
  return react_default.a.createElement(lib_menu["MenuItem"], {
    className: phaseActionMenu_styles_default.a.item,
    caption: label,
    onClick: onClick
  });
});

// Hiding Add Installer Pay button in case it required again
// const AddInstallerPayItem = visibleFor('view', 'accounting', ({ label, onClick, disabled }) =>
//   <MenuItem
//     className={styles.item}
//     caption={label}
//     onClick={onClick}
//     disabled={disabled}
//   />,
// );

var SendToFloorWizardItem = Auth_visibleFor('update', 'floor_wizard', function (_ref13) {
  var label = _ref13.label,
      onClick = _ref13.onClick;
  return react_default.a.createElement(lib_menu["MenuItem"], {
    className: phaseActionMenu_styles_default.a.item,
    caption: label,
    onClick: onClick
  });
});

var phaseActionMenu_PhaseActionMenu = function (_Shortcutter) {
  phaseActionMenu__inherits(PhaseActionMenu, _Shortcutter);

  function PhaseActionMenu() {
    var _ref14;

    var _temp, _this, _ret;

    phaseActionMenu__classCallCheck(this, PhaseActionMenu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = phaseActionMenu__possibleConstructorReturn(this, (_ref14 = PhaseActionMenu.__proto__ || Object.getPrototypeOf(PhaseActionMenu)).call.apply(_ref14, [this].concat(args))), _this), Object.defineProperty(_this, 'state', {
      enumerable: true,
      writable: true,
      value: { menuActive: false, active: [] }
    }), Object.defineProperty(_this, 'componentWillMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.requestPhaseItems(_this.props.phase.id, 'contractorLineItems');
      }
    }), Object.defineProperty(_this, 'handleClick', {
      enumerable: true,
      writable: true,
      value: function value(target) {
        return _this.setState({
          menuActive: false,
          active: [].concat(phaseActionMenu__toConsumableArray(_this.state.active), [target])
        });
      }
    }), Object.defineProperty(_this, 'handleShortcut', {
      enumerable: true,
      writable: true,
      value: function value(target, e) {
        e.preventDefault();
        _this.handleClick(target);
      }
    }), Object.defineProperty(_this, 'handleClose', {
      enumerable: true,
      writable: true,
      value: function value(target) {
        return _this.setState({
          active: _this.state.active.filter(function (a) {
            return a !== target;
          })
        });
      }
    }), Object.defineProperty(_this, 'handleNoteClick', {
      enumerable: true,
      writable: true,
      value: _this.handleClick.bind(_this, 'note')
    }), Object.defineProperty(_this, 'handleNoteClose', {
      enumerable: true,
      writable: true,
      value: _this.handleClose.bind(_this, 'note')
    }), Object.defineProperty(_this, 'handleContractorNoteClick', {
      enumerable: true,
      writable: true,
      value: _this.handleClick.bind(_this, 'contractor_notes')
    }), Object.defineProperty(_this, 'handleContractorNoteShortcut', {
      enumerable: true,
      writable: true,
      value: _this.handleShortcut.bind(_this, 'contractor_notes')
    }), Object.defineProperty(_this, 'handleContractorNoteClose', {
      enumerable: true,
      writable: true,
      value: _this.handleClose.bind(_this, 'contractor_notes')
    }), Object.defineProperty(_this, 'handleCommunicationClick', {
      enumerable: true,
      writable: true,
      value: _this.handleClick.bind(_this, 'communication')
    }), Object.defineProperty(_this, 'handleSetDueTomorrowClick', {
      enumerable: true,
      writable: true,
      value: _this.handleClick.bind(_this, 'set_due_tomorrow')
    }), Object.defineProperty(_this, 'handleSetDueTomorrowClose', {
      enumerable: true,
      writable: true,
      value: _this.handleClose.bind(_this, 'set_due_tomorrow')
    }), Object.defineProperty(_this, 'handleCommunicationShortcut', {
      enumerable: true,
      writable: true,
      value: _this.handleShortcut.bind(_this, 'communication')
    }), Object.defineProperty(_this, 'handleCommunicationClose', {
      enumerable: true,
      writable: true,
      value: _this.handleClose.bind(_this, 'communication')
    }), Object.defineProperty(_this, 'handleFlagClick', {
      enumerable: true,
      writable: true,
      value: _this.handleClick.bind(_this, 'flag')
    }), Object.defineProperty(_this, 'handleFlagShortcut', {
      enumerable: true,
      writable: true,
      value: _this.handleShortcut.bind(_this, 'flag')
    }), Object.defineProperty(_this, 'handleFlagClose', {
      enumerable: true,
      writable: true,
      value: _this.handleClose.bind(_this, 'flag')
    }), Object.defineProperty(_this, 'handleStatusClick', {
      enumerable: true,
      writable: true,
      value: _this.handleClick.bind(_this, 'status')
    }), Object.defineProperty(_this, 'handleStatusClose', {
      enumerable: true,
      writable: true,
      value: _this.handleClose.bind(_this, 'status')
    }), Object.defineProperty(_this, 'handleCancelClick', {
      enumerable: true,
      writable: true,
      value: _this.handleClick.bind(_this, 'cancel')
    }), Object.defineProperty(_this, 'handleCancelClose', {
      enumerable: true,
      writable: true,
      value: _this.handleClose.bind(_this, 'cancel')
    }), Object.defineProperty(_this, 'handleAssignClick', {
      enumerable: true,
      writable: true,
      value: _this.handleClick.bind(_this, 'assign_estimator')
    }), Object.defineProperty(_this, 'handleAssignClose', {
      enumerable: true,
      writable: true,
      value: _this.handleClose.bind(_this, 'assign_estimator')
    }), Object.defineProperty(_this, 'handleInstallerAssignClick', {
      enumerable: true,
      writable: true,
      value: _this.handleClick.bind(_this, 'assign_installer')
    }), Object.defineProperty(_this, 'handleInstallerAssignClose', {
      enumerable: true,
      writable: true,
      value: _this.handleClose.bind(_this, 'assign_installer')
    }), Object.defineProperty(_this, 'handleWorkorderClick', {
      enumerable: true,
      writable: true,
      value: _this.handleClick.bind(_this, 'workorder')
    }), Object.defineProperty(_this, 'handleWorkorderClose', {
      enumerable: true,
      writable: true,
      value: _this.handleClose.bind(_this, 'workorder')
    }), Object.defineProperty(_this, 'handleCheckInClick', {
      enumerable: true,
      writable: true,
      value: _this.handleClick.bind(_this, 'checkin')
    }), Object.defineProperty(_this, 'handleCheckinClose', {
      enumerable: true,
      writable: true,
      value: _this.handleClose.bind(_this, 'checkin')
    }), Object.defineProperty(_this, 'handleCreateExceptionClick', {
      enumerable: true,
      writable: true,
      value: _this.handleClick.bind(_this, 'create_exception')
    }), Object.defineProperty(_this, 'handleCreateExceptionClose', {
      enumerable: true,
      writable: true,
      value: _this.handleClose.bind(_this, 'create_exception')
    }), Object.defineProperty(_this, 'handleCOCClick', {
      enumerable: true,
      writable: true,
      value: _this.handleClick.bind(_this, 'coc')
    }), Object.defineProperty(_this, 'handleCOCClose', {
      enumerable: true,
      writable: true,
      value: _this.handleClose.bind(_this, 'coc')
    }), Object.defineProperty(_this, 'handleWalkThroughClick', {
      enumerable: true,
      writable: true,
      value: _this.handleClick.bind(_this, 'walkthrough')
    }), Object.defineProperty(_this, 'handleWalkThroughClose', {
      enumerable: true,
      writable: true,
      value: _this.handleClose.bind(_this, 'walkthrough')
    }), Object.defineProperty(_this, 'handleRepairInspectionClick', {
      enumerable: true,
      writable: true,
      value: _this.handleClick.bind(_this, 'repair_inspection_report')
    }), Object.defineProperty(_this, 'handleRepairInspectionClose', {
      enumerable: true,
      writable: true,
      value: _this.handleClose.bind(_this, 'repair_inspection_report')
    }), Object.defineProperty(_this, 'handleCrewInspectionClick', {
      enumerable: true,
      writable: true,
      value: _this.handleClick.bind(_this, 'crew_inspection')
    }), Object.defineProperty(_this, 'handleCrewInspectionClose', {
      enumerable: true,
      writable: true,
      value: _this.handleClose.bind(_this, 'crew_inspection')
    }), Object.defineProperty(_this, 'handlePaperworkClick', {
      enumerable: true,
      writable: true,
      value: _this.handleClick.bind(_this, 'paperwork')
    }), Object.defineProperty(_this, 'handlePaperworkClose', {
      enumerable: true,
      writable: true,
      value: _this.handleClose.bind(_this, 'paperwork')
    }), Object.defineProperty(_this, 'handleFloorWizardClick', {
      enumerable: true,
      writable: true,
      value: _this.handleClick.bind(_this, 'floor_wizard')
    }), Object.defineProperty(_this, 'handleFloorWizardClose', {
      enumerable: true,
      writable: true,
      value: _this.handleClose.bind(_this, 'floor_wizard')
    }), Object.defineProperty(_this, 'handleIfiLrrpClick', {
      enumerable: true,
      writable: true,
      value: _this.handleClick.bind(_this, 'ifi_lrrp')
    }), Object.defineProperty(_this, 'handleIfiLrrpClose', {
      enumerable: true,
      writable: true,
      value: _this.handleClose.bind(_this, 'ifi_lrrp')
    }), Object.defineProperty(_this, 'handleIfiTemplateNavigate', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.handleMenuHide();
        _this.props.navigate(urls.phaseIfiTemplate(_this.props.phase));
      }
    }), Object.defineProperty(_this, 'handleCustomLaborSheetClick', {
      enumerable: true,
      writable: true,
      value: _this.handleClick.bind(_this, 'custom_labor_sheet')
    }), Object.defineProperty(_this, 'handleCustomLaborSheetClose', {
      enumerable: true,
      writable: true,
      value: _this.handleClose.bind(_this, 'custom_labor_sheet')
    }), Object.defineProperty(_this, 'handleQuickScheduleClick', {
      enumerable: true,
      writable: true,
      value: _this.handleClick.bind(_this, 'quick_schedule')
    }), Object.defineProperty(_this, 'handleQuickScheduleClose', {
      enumerable: true,
      writable: true,
      value: _this.handleClose.bind(_this, 'quick_schedule')
    }), Object.defineProperty(_this, 'handleSupportRequestClick', {
      enumerable: true,
      writable: true,
      value: _this.handleClick.bind(_this, 'support_request')
    }), Object.defineProperty(_this, 'handleSupportRequestClose', {
      enumerable: true,
      writable: true,
      value: _this.handleClose.bind(_this, 'support_request')
    }), Object.defineProperty(_this, 'handleButtonClick', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ menuActive: !_this.state.menuActive });
      }
    }), Object.defineProperty(_this, 'handleMenuHide', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ menuActive: false });
      }
    }), Object.defineProperty(_this, 'handleAddInstallerPay', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.handleMenuHide();
        _this.props.navigate('/phases/' + _this.props.phase.id + '/labor-product-accounting/walkthrough');
        setTimeout(function () {
          return document.getElementById('tutorialRestartBtn').click();
        }, 1000);
      }
    }), Object.defineProperty(_this, 'disableAddInstallerPay', {
      enumerable: true,
      writable: true,
      value: function value(laborSheets) {
        var editableSheets = laborSheets.filter(function (sheet) {
          return sheet.id > 0 && sheet.status === 'Pending Review';
        });
        return editableSheets.length < 1;
      }
    }), Object.defineProperty(_this, 'canAccessIfiLrrp', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            phase = _this$props.phase,
            role = _this$props.role,
            position = _this$props.position,
            mvw = _this$props.mvw,
            employableId = _this$props.employableId;

        if (!ifiUtils(phase)) return false;

        return Object(services["a" /* can */])(role, 'manage', 'ifi_lrrp', {
          position: position,
          mvw: mvw,
          phase_installer_id: phase.installer_id,
          employable_id: employableId
        });
      }
    }), Object.defineProperty(_this, 'canQuickSchedule', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props2 = _this.props,
            phase = _this$props2.phase,
            role = _this$props2.role,
            employableId = _this$props2.employableId,
            isSelfSchedulable = _this$props2.isSelfSchedulable;

        if (!ifiUtils(phase)) return false;
        if (phase.pending_quick_schedule_response) return false;

        return Object(services["a" /* can */])(role, 'quick_schedule', 'PHASE', {
          source: phase.source,
          phase_type: phase.type,
          phase_estimator_id: phase.estimator_id,
          phase_installer_id: phase.installer_id,
          employable_id: employableId,
          is_self_schedulable: isSelfSchedulable
        });
      }
    }), Object.defineProperty(_this, 'canCreateSupportRequest', {
      enumerable: true,
      writable: true,
      value: function value() {
        var role = _this.props.role;

        return Object(services["a" /* can */])(role, 'create', 'support_request');
      }
    }), Object.defineProperty(_this, 'canCreateIfiTemplate', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props3 = _this.props,
            phase = _this$props3.phase,
            role = _this$props3.role;

        return Object(services["c" /* canAccessIfiTemplate */])({ role: role, phase_type: phase.type, phase_source: phase.source });
      }
    }), Object.defineProperty(_this, 'flagPermissionCheck', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props4 = _this.props,
            phase = _this$props4.phase,
            role = _this$props4.role,
            position = _this$props4.position,
            mvw = _this$props4.mvw,
            employableId = _this$props4.employableId;


        if (role === 'installer') {
          return Object(services["a" /* can */])(role, 'create', 'flag', {
            position: position,
            mvw: mvw,
            phase_installer_id: phase.installer_id,
            employable_id: employableId
          });
        }
        return Object(services["a" /* can */])(role, 'create', 'flag');
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        // Hiding Add Installer Pay button in case it required again
        // eslint-disable-next-line no-unused-vars
        var _this$props5 = _this.props,
            phase = _this$props5.phase,
            role = _this$props5.role,
            laborSheets = _this$props5.laborSheets,
            contractorTableApproved = _this$props5.contractorTableApproved,
            position = _this$props5.position,
            mvw = _this$props5.mvw;

        var status = phase.status;
        var _this$state = _this.state,
            menuActive = _this$state.menuActive,
            active = _this$state.active;

        var canCreateFlag = _this.flagPermissionCheck();
        var canCreateIfiLrrp = _this.canAccessIfiLrrp();
        var canQuickSchedule = _this.canQuickSchedule();
        var canCreateSupportRequest = _this.canCreateSupportRequest();
        var canCreateIfiTemplate = _this.canCreateIfiTemplate();
        var canCreateCustomLaborSheet = Object(services["b" /* canAccessCustomLaborSheet */])({
          role: role,
          phase_source: phase.source,
          mvw: mvw
        });
        return react_default.a.createElement(
          'div',
          null,
          react_default.a.createElement(
            'div',
            { className: classnames_default()(phaseActionMenu_styles_default.a.container, phaseActionMenu__defineProperty({}, phaseActionMenu_styles_default.a.isComposeOpen, active.length)) },
            react_default.a.createElement(lib_button["Button"], {
              theme: phaseActionMenu_styles_default.a,
              icon: 'add',
              floating: true, ripple: true, primary: true,
              onClick: _this.handleButtonClick
            }),
            react_default.a.createElement(
              lib_menu["Menu"],
              {
                active: menuActive,
                onHide: _this.handleMenuHide,
                position: 'bottomRight',
                ripple: true
              },
              Object(utils["y" /* roleNotInstallerBased */])(role) && role !== 'estimator' && react_default.a.createElement(lib_menu["MenuItem"], {
                className: phaseActionMenu_styles_default.a.item,
                caption: 'Due Tomorrow',
                onClick: _this.handleSetDueTomorrowClick
              }),
              status !== 'canceled' && react_default.a.createElement(CancelPhaseItem, {
                onClick: _this.handleCancelClick,
                label: 'Cancel Phase'
              }),
              canCreateFlag && react_default.a.createElement(phaseActionMenu_CreateFlagItem, { onClick: _this.handleFlagClick }),
              Object(services["a" /* can */])(role, 'override', 'phase') && react_default.a.createElement(CreateEventItem, {
                label: react_default.a.createElement(
                  'span',
                  null,
                  react_default.a.createElement(
                    'u',
                    null,
                    'A'
                  ),
                  'dd Communication'
                ),
                onClick: _this.handleCommunicationClick
              }),
              role === 'installer' && react_default.a.createElement(CreateEventItem, {
                label: 'Check In/Out',
                onClick: _this.handleCheckInClick
              }),
              canCreateCustomLaborSheet && react_default.a.createElement(lib_menu["MenuItem"], {
                className: phaseActionMenu_styles_default.a.item,
                caption: 'Custom Labor Sheet',
                onClick: _this.handleCustomLaborSheetClick
              }),
              react_default.a.createElement(UpdateContractorNotePhaseItem, {
                label: react_default.a.createElement(
                  'span',
                  null,
                  react_default.a.createElement(
                    'u',
                    null,
                    'C'
                  ),
                  'ontractor Notes'
                ),
                onClick: _this.handleContractorNoteClick
              }),
              ['installer', 'estimator'].includes(role) && react_default.a.createElement(CreateEventItem, {
                label: react_default.a.createElement(
                  'span',
                  null,
                  'Add ',
                  react_default.a.createElement(
                    'u',
                    null,
                    'N'
                  ),
                  'ote'
                ),
                onClick: _this.handleNoteClick
              }),
              phase.type === 'Assessment' && react_default.a.createElement(
                react["Fragment"],
                null,
                react_default.a.createElement(AssignPhaseItem, {
                  label: 'Assign Estimator',
                  onClick: _this.handleAssignClick
                }),
                !phase.rocky_managed && react_default.a.createElement(SendToFloorWizardItem, {
                  label: 'Send Phase To Floor Wizard',
                  onClick: _this.handleFloorWizardClick
                })
              ),
              phase.source === 'IFI' && Object(services["a" /* can */])(role, 'manage', 'assign_installer', { position: position, mvw: mvw }) && react_default.a.createElement(AssignInstallerItem, {
                label: 'Assign Installer',
                onClick: _this.handleInstallerAssignClick
              }),
              Object(utils["y" /* roleNotInstallerBased */])(role) && react_default.a.createElement(CreateExceptionItem, {
                label: 'Create Exception',
                onClick: _this.handleCreateExceptionClick
              }),
              react_default.a.createElement(CreateWorkorderItem, {
                label: 'Create Workorder',
                onClick: _this.handleWorkorderClick
              }),
              phase.type === 'Installation' && react_default.a.createElement(CreateWalkthroughItem, {
                label: 'Walkthrough Forms',
                onClick: _this.handleWalkThroughClick
              }),
              phase.type !== 'Assessment' && Object(utils["y" /* roleNotInstallerBased */])(role) && react_default.a.createElement(
                react["Fragment"],
                null,
                react_default.a.createElement(CreateCrewInspectionItem, {
                  label: 'Crew Inspection',
                  onClick: _this.handleCrewInspectionClick
                }),
                phase.type === 'Workorder' && phase.source !== 'IFI' && react_default.a.createElement(CreateRepairInspectionItem, {
                  label: 'Workorder Inspection',
                  onClick: _this.handleRepairInspectionClick
                })
              ),
              phase.type !== 'Assessment' && react_default.a.createElement(InstallationsPaperworkItem, {
                label: 'Preview Paperwork',
                onClick: _this.handlePaperworkClick
              }),
              canCreateIfiLrrp && react_default.a.createElement(lib_menu["MenuItem"], {
                className: phaseActionMenu_styles_default.a.item,
                caption: 'Create IFI LRRP',
                onClick: _this.handleIfiLrrpClick
              }),
              canCreateIfiTemplate && react_default.a.createElement(lib_menu["MenuItem"], {
                className: phaseActionMenu_styles_default.a.item,
                caption: 'IFI Template',
                onClick: _this.handleIfiTemplateNavigate
              }),
              canQuickSchedule && react_default.a.createElement(lib_menu["MenuItem"], {
                className: phaseActionMenu_styles_default.a.item,
                caption: 'Quick Schedule',
                onClick: _this.handleQuickScheduleClick
              }),
              canCreateSupportRequest && react_default.a.createElement(lib_menu["MenuItem"], {
                className: phaseActionMenu_styles_default.a.item,
                caption: 'Create Support Request',
                onClick: _this.handleSupportRequestClick
              })
            )
          ),
          react_default.a.createElement(
            'div',
            { className: ComposeWindow_styles_default.a.container },
            react_default.a.createElement(addNoteModal, {
              phase: phase,
              active: active.includes('note'),
              onClose: _this.handleNoteClose
            }),
            react_default.a.createElement(addContractorNoteModal, {
              phase: phase,
              active: active.includes('contractor_notes'),
              onClose: _this.handleContractorNoteClose
            }),
            react_default.a.createElement(addCommunicationModal, {
              phase: phase,
              active: active.includes('communication'),
              onClose: _this.handleCommunicationClose
            }),
            react_default.a.createElement(addFlagModal, {
              phase: phase,
              active: active.includes('flag'),
              onClose: _this.handleFlagClose
            }),
            react_default.a.createElement(createSupportRequestModal, {
              phase: phase,
              active: active.includes('support_request'),
              onClose: _this.handleSupportRequestClose
            })
          ),
          react_default.a.createElement(setDueTomorrowModal, {
            phase: phase,
            active: active.includes('set_due_tomorrow'),
            onClose: _this.handleSetDueTomorrowClose
          }),
          react_default.a.createElement(cancelPhaseModal, {
            phase: phase,
            active: active.includes('cancel'),
            onClose: _this.handleCancelClose
          }),
          react_default.a.createElement(assignEstimatorModal, {
            phase: phase,
            active: active.includes('assign_estimator'),
            onClose: _this.handleAssignClose
          }),
          react_default.a.createElement(assignInstallerModal, {
            phase: phase,
            active: active.includes('assign_installer'),
            onClose: _this.handleInstallerAssignClose
          }),
          react_default.a.createElement(workorderModal, {
            phase: phase,
            active: active.includes('workorder'),
            onClose: _this.handleWorkorderClose
          }),
          react_default.a.createElement(checkinModal, {
            phase: phase,
            active: active.includes('checkin'),
            onClose: _this.handleCheckinClose
          }),
          react_default.a.createElement(createExceptionModal, {
            phase: phase,
            active: active.includes('create_exception'),
            onClose: _this.handleCreateExceptionClose
          }),
          react_default.a.createElement(cocModal, {
            phase: phase,
            active: active.includes('coc'),
            onClose: _this.handleCOCClose
          }),
          react_default.a.createElement(components_WalkthroughModal, {
            phase: phase,
            active: active.includes('walkthrough'),
            onClose: _this.handleWalkThroughClose
          }),
          react_default.a.createElement(repairInspectionModal, {
            phase: phase,
            active: active.includes('repair_inspection_report'),
            onClose: _this.handleRepairInspectionClose
          }),
          react_default.a.createElement(crewInspectionModal, {
            phase: phase,
            active: active.includes('crew_inspection'),
            onClose: _this.handleCrewInspectionClose
          }),
          react_default.a.createElement(printInstallerPaperworkModal, {
            active: active.includes('paperwork'),
            onClose: _this.handlePaperworkClose,
            selectInstaller: true,
            phaseId: phase.id,
            role: role
          }),
          react_default.a.createElement(sendToFloorWizardModal, {
            active: active.includes('floor_wizard'),
            onClose: _this.handleFloorWizardClose,
            phaseId: phase.id
          }),
          react_default.a.createElement(phaseActionMenu_ifiLrrpModal, {
            phase: phase,
            active: active.includes('ifi_lrrp'),
            onClose: _this.handleIfiLrrpClose
          }),
          react_default.a.createElement(phaseActionMenu_quickScheduleModal, {
            phase: phase,
            active: active.includes('quick_schedule'),
            onClose: _this.handleQuickScheduleClose
          }),
          react_default.a.createElement(customLaborSheetModal, {
            active: active.includes('custom_labor_sheet'),
            onClose: _this.handleCustomLaborSheetClose,
            phase: phase,
            laborSheets: laborSheets,
            lineItemOptions: _this.props.lineItemOptions,
            createPhaseItem: _this.props.createPhaseItem,
            navigate: _this.props.navigate
          })
        );
      }
    }), _temp), phaseActionMenu__possibleConstructorReturn(_this, _ret);
  }

  return PhaseActionMenu;
}(mixins_shortcuts(react_default.a.Component, [{ key: 'c', func: 'handleContractorNoteShortcut' }, { key: 'f', func: 'handleFlagShortcut' }, { key: 'a', func: 'handleCommunicationShortcut' }]));

phaseActionMenu_PhaseActionMenu.propTypes = {
  phase: types_phase.isRequired,
  role: prop_types_default.a.string.isRequired,
  navigate: prop_types_default.a.func,
  location: prop_types_default.a.object,
  laborSheets: prop_types_default.a.array,
  lineItemOptions: prop_types_default.a.array,
  contractorTableApproved: prop_types_default.a.bool,
  requestPhaseItems: prop_types_default.a.func.isRequired,
  createPhaseItem: prop_types_default.a.func.isRequired,
  position: prop_types_default.a.string.isRequired,
  mvw: prop_types_default.a.shape({
    ifi: prop_types_default.a.bool
  }).isRequired,
  employableId: prop_types_default.a.number,
  isSelfSchedulable: prop_types_default.a.bool
};

phaseActionMenu_CreateFlagItem.propTypes = {
  onClick: prop_types_default.a.func.isRequired
};

var phaseActionMenu_mapStateToProps = function mapStateToProps(state) {
  var user = state.user,
      employees = state.employees;

  var employableType = state.user.employable_type.toLowerCase() || '';
  var contractorTableApproved = employableType === 'employee' ? (employees.byId[user.employable_id] || {}).contractor_table_approved || false : false;
  var laborSheets = state.phase.laborSheets.items;
  return {
    laborSheets: laborSheets,
    lineItemOptions: Object(lineItemUtils["j" /* normalizePayRateLineItemOptions */])(state.payRateLineItems.data, laborSheets),
    contractorTableApproved: contractorTableApproved,
    position: user.position,
    mvw: user.manage_vendor_workrooms || {},
    employableId: state.user.employable_id,
    isSelfSchedulable: !!state.user.is_self_schedulable
  };
};

/* harmony default export */ var phaseActionMenu = (Object(react_redux_es["connect"])(phaseActionMenu_mapStateToProps, { navigate: actionCreators["O" /* navigate */], requestPhaseItems: actionCreators["_17" /* requestPhaseItems */], createPhaseItem: phase_items["d" /* createPhaseItem */] })(phaseActionMenu_PhaseActionMenu));
// EXTERNAL MODULE: ./client/app/shared/components/CardTitle/styles.scss
var CardTitle_styles = __webpack_require__("+SaK");
var CardTitle_styles_default = /*#__PURE__*/__webpack_require__.n(CardTitle_styles);

// CONCATENATED MODULE: ./client/app/shared/components/CardTitle/index.jsx




var CardTitle_CardTitle = function CardTitle(props) {
  return react_default.a.createElement(
    'div',
    null,
    react_default.a.createElement(
      'section',
      { className: CardTitle_styles_default.a.section },
      react_default.a.createElement(
        'div',
        { className: CardTitle_styles_default.a.titleContainer },
        react_default.a.createElement(
          'div',
          null,
          react_default.a.createElement(
            'div',
            { className: CardTitle_styles_default.a.mainTitle },
            react_default.a.createElement(
              'span',
              { className: CardTitle_styles_default.a.boldWord },
              props.title
            )
          ),
          react_default.a.createElement(
            'span',
            { className: CardTitle_styles_default.a.mainSubtitle },
            props.subtitle
          )
        ),
        props.children
      )
    ),
    props.divider && react_default.a.createElement('hr', { className: CardTitle_styles_default.a.dividerLine })
  );
};

CardTitle_CardTitle.propTypes = {
  title: prop_types_default.a.string.isRequired,
  subtitle: prop_types_default.a.string,
  children: prop_types_default.a.element,
  divider: prop_types_default.a.bool
};

/* harmony default export */ var components_CardTitle = (CardTitle_CardTitle);
// EXTERNAL MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseDetails/components/phaseDetailsCard.scss
var phaseDetailsCard = __webpack_require__("SObt");
var phaseDetailsCard_default = /*#__PURE__*/__webpack_require__.n(phaseDetailsCard);

// EXTERNAL MODULE: ./client/app/shared/components/PurchaseOrders/styles.scss
var PurchaseOrders_styles = __webpack_require__("vMT/");
var PurchaseOrders_styles_default = /*#__PURE__*/__webpack_require__.n(PurchaseOrders_styles);

// CONCATENATED MODULE: ./client/app/shared/components/PurchaseOrders/index.jsx





var PurchaseOrders_renderAll = function renderAll(purchaseOrders, className) {
  return react_default.a.createElement(
    'span',
    null,
    purchaseOrders.map(function (po) {
      return react_default.a.createElement(
        'div',
        { className: className, key: po.id },
        po.kind,
        ': ',
        po.number
      );
    })
  );
};

var PurchaseOrders_PurchaseOrders = function PurchaseOrders(_ref) {
  var purchaseOrders = _ref.purchaseOrders,
      all = _ref.all,
      type = _ref.type,
      className = _ref.className;

  var cn = PurchaseOrders_styles_default.a.PurchaseOrder + ' ' + className;
  if (all) return PurchaseOrders_renderAll(purchaseOrders.filter(function (po) {
    return po.id >= 0;
  }), cn);
  var po = purchaseOrders.find(function (p) {
    return p.kind === type;
  });
  return react_default.a.createElement(
    'span',
    { className: cn },
    po && po.number
  );
};

PurchaseOrders_PurchaseOrders.defaultProps = {
  all: false,
  type: 'Original',
  className: ''
};

PurchaseOrders_PurchaseOrders.propTypes = {
  all: prop_types_default.a.bool,
  type: prop_types_default.a.string,
  purchaseOrders: prop_types_default.a.arrayOf(prop_types_default.a.shape(purchaseOrder)).isRequired,
  className: prop_types_default.a.string
};

/* harmony default export */ var components_PurchaseOrders = (PurchaseOrders_PurchaseOrders);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseDetails/index.jsx
function phaseDetails__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }




























var phaseDetails_detailsTheme = {
  RTCard: resourceDetailsCard_default.a,
  ResourceDetailsCE: detailsCardElement_default.a
};

var emptyFieldValue = '----';

var phaseDetails_sectionTitle = classnames_default()([detailsSection_default.a.sectionTitle, detailsSection_default.a.mediumTitle]);

var determineBacksplashFieldName = function determineBacksplashFieldName(key) {
  switch (key) {
    case 'tile_stone_location':
      return 'Tile/Stone Location';
    case 'stone_size':
      return 'Backsplash Tile Or Stone Size';
    case 'backsplash_job_type':
      return 'Backsplash/Wall Job Type';
    case 'stone_style':
      return 'Backsplash Tile Or Stone Style';
    case 'stone_pattern_type':
      return 'Backsplash Tile Or Stone Pattern Type';
    default:
      return key.replace(/_/g, ' ');
  }
};

var determineSurfaceDisplayValue = function determineSurfaceDisplayValue(val) {
  return val || emptyFieldValue;
};

var phaseDetails_renderAddtlSurfaceInfo = function renderAddtlSurfaceInfo(materials) {
  return materials.map(function (material, index) {
    return react_default.a.createElement(
      react["Fragment"],
      {
        key: material.modelId
      },
      react_default.a.createElement('hr', { className: resourceDetailsCard_default.a.dividerLine }),
      react_default.a.createElement(components_BreakLine, null),
      react_default.a.createElement(
        'h9',
        null,
        'Material ',
        index + 1
      ),
      react_default.a.createElement(components_BreakLine, null),
      react_default.a.createElement(ResourceDetailsCardElement, {
        title: 'Item Number', value: react_default.a.createElement(
          'a',
          { style: { color: 'blue' }, href: urls.lowesItem(material.itemNumber), target: '_blank', rel: 'noopener noreferrer' },
          material.itemNumber
        )
      }),
      react_default.a.createElement(ResourceDetailsCardElement, { title: 'model id', value: material.modelId }),
      react_default.a.createElement(ResourceDetailsCardElement, { title: 'description', value: material.materialDesc })
    );
  });
};

var phaseDetails_renderRfInfo = function renderRfInfo(rfLaborComments) {
  var allTypes = [];
  rfLaborComments.forEach(function (_ref) {
    var applicable_types = _ref.applicable_types;
    return allTypes.push(applicable_types);
  });
  return react_default.a.createElement(
    react["Fragment"],
    null,
    Object(lodash["uniq"])(allTypes.flat()).map(function (type, index) {
      return react_default.a.createElement(
        react["Fragment"],
        { key: 'master' + type + (index + 1) },
        react_default.a.createElement('hr', { className: resourceDetailsCard_default.a.dividerLine }),
        react_default.a.createElement(
          'h5',
          { className: phaseDetails_sectionTitle },
          type
        ),
        react_default.a.createElement(
          'ul',
          { className: phaseDetailsCard_default.a.surfaceInfoList },
          rfLaborComments.filter(function (_ref2) {
            var applicable_types = _ref2.applicable_types;
            return applicable_types.includes(type);
          }).map(function (_ref3, index2) {
            var comment = _ref3.comment;
            return react_default.a.createElement(
              'li',
              { key: '' + type + (index2 + 1) },
              comment
            );
          })
        ),
        react_default.a.createElement('br', null)
      );
    })
  );
};

var phaseDetails_renderSurfaceInfo = function renderSurfaceInfo(phase, surfaceName, surfaceInfo) {
  var _phase$sqft = phase.sqft,
      sqft = _phase$sqft === undefined ? null : _phase$sqft,
      _phase$net_square_foo = phase.net_square_footage,
      net_square_footage = _phase$net_square_foo === undefined ? null : _phase$net_square_foo;
  var _surfaceInfo$interest = surfaceInfo.interested_materials,
      interestedMaterials = _surfaceInfo$interest === undefined ? [] : _surfaceInfo$interest,
      _surfaceInfo$rf_labor = surfaceInfo.rf_labor_comments,
      rfLaborComments = _surfaceInfo$rf_labor === undefined ? [] : _surfaceInfo$rf_labor;

  var materials = interestedMaterials.length ? interestedMaterials : null;
  return react_default.a.createElement(
    components_Card,
    { className: resourceDetailsCard_default.a.detailsElementContainer },
    react_default.a.createElement(
      react["Fragment"],
      null,
      react_default.a.createElement(
        'h5',
        { className: phaseDetails_sectionTitle },
        'Surface Information'
      ),
      react_default.a.createElement(components_BreakLine, null),
      react_default.a.createElement(
        'div',
        { className: phaseDetailsCard_default.a.detailsCardContainer },
        react_default.a.createElement(ResourceDetailsCardElement, { title: 'surface type', value: surfaceName }),
        react_default.a.createElement(
          react["Fragment"],
          null,
          react_default.a.createElement(ResourceDetailsCardElement, { title: 'Project Sq Ft', value: sqft || emptyFieldValue }),
          react_default.a.createElement(ResourceDetailsCardElement, { title: 'Net Sq Ft', value: net_square_footage || emptyFieldValue }),
          !Object(lodash["isEmpty"])(surfaceInfo) && react_default.a.createElement(
            react["Fragment"],
            null,
            react_default.a.createElement('hr', { className: resourceDetailsCard_default.a.dividerLine }),
            react_default.a.createElement(components_BreakLine, null),
            Object.keys(surfaceInfo).filter(function (key) {
              return !['interested_materials', 'rf_labor_comments'].includes(key);
            }).map(function (infoKey) {
              var title = surfaceName === 'Backsplash' ? determineBacksplashFieldName(infoKey) : infoKey.replace(/_/g, ' ');
              return react_default.a.createElement(ResourceDetailsCardElement, {
                key: infoKey,
                title: title,
                value: determineSurfaceDisplayValue(surfaceInfo[infoKey]),
                className: phaseDetailsCard_default.a.resourceDetails
              });
            }),
            materials && phaseDetails_renderAddtlSurfaceInfo(materials)
          )
        )
      )
    ),
    rfLaborComments.length ? phaseDetails_renderRfInfo(rfLaborComments) : null
  );
};

var phaseDetails_renderPhoneNumberDisplay = function renderPhoneNumberDisplay(phoneNumber) {
  var display = react_default.a.createElement(components_PhoneLink, { number: phoneNumber.number });
  if (phoneNumber.ok_to_text) return react_default.a.createElement(
    'div',
    null,
    display,
    ' - OK to Text'
  );
  return display;
};

var phaseDetails_PhaseDetails = function PhaseDetails(_ref4) {
  var phase = _ref4.phase,
      canEdit = _ref4.canEdit,
      role = _ref4.role,
      surfaceType = _ref4.surfaceType,
      store = _ref4.store,
      purchaseOrders = _ref4.purchaseOrders;

  var surfaceName = surfaceType ? surfaceType.name : '----------';
  var editAction = react_default.a.createElement(
    components_RouterLink,
    { className: resourceDetailsCard_default.a.detailsLink, to: '/phases/' + phase.id + '/edit' },
    react_default.a.createElement(
      'span',
      { className: resourceDetailsCard_default.a.editText },
      'Edit phase'
    )
  );
  var surfaceInfo = phase.surface_information || {};
  var purchaseOrdersCopy = [].concat(phaseDetails__toConsumableArray(purchaseOrders)).filter(function (po) {
    return po.id >= 0;
  });
  if (phase.type === 'Workorder') {
    purchaseOrdersCopy.push({
      id: '0',
      kind: 'Related',
      number: phase.related_po
    });
  }
  var fwProjId = phase.floor_wizard_job ? phase.floor_wizard_job.floor_wizard_project_id : null;
  var commMethod = phase.communication_method || emptyFieldValue;
  var phaseSpecifics = phase.phase_specific;
  return react_default.a.createElement(
    react_css_themr_lib["ThemeProvider"],
    { theme: phaseDetails_detailsTheme },
    react_default.a.createElement(
      components_Card,
      null,
      react_default.a.createElement(
        components_CardTitle,
        {
          title: phase.type,
          subtitle: 'Created on ' + phase.created_at,
          divider: true
        },
        canEdit ? editAction : null
      ),
      react_default.a.createElement(
        'section',
        { className: detailsSection_default.a.section },
        react_default.a.createElement(
          components_Card,
          { className: resourceDetailsCard_default.a.detailsElementContainer },
          react_default.a.createElement(
            'h5',
            { className: phaseDetails_sectionTitle },
            'Basic Information'
          ),
          react_default.a.createElement(components_BreakLine, null),
          react_default.a.createElement(
            'div',
            { className: phaseDetailsCard_default.a.detailsCardContainer },
            react_default.a.createElement(ResourceDetailsCardElement, { title: 'date sold', value: phase.date_sold }),
            react_default.a.createElement(ResourceDetailsCardElement, { title: 'customer name', value: phase.customer_name }),
            react_default.a.createElement(ResourceDetailsCardElement, {
              title: Object(utils["E" /* vendorDisplayName */])(phase.source, phase.workroom.name) + ' associate',
              value: phase.associate || '----'
            }),
            react_default.a.createElement(
              ResourceDetailsCardElement,
              { title: 'street address' },
              react_default.a.createElement(components_DetailsAddress, {
                address: phase.street_address,
                city: phase.city,
                state: phase.state,
                zipCode: phase.zip_code
              })
            ),
            react_default.a.createElement(ResourceDetailsCardElement, {
              title: 'Year Built',
              value: phase.year_built || emptyFieldValue
            }),
            phase.rocky_managed && react_default.a.createElement(ResourceDetailsCardElement, {
              title: 'Measure Vendor',
              value: 'Rocky (Lowe\'s direct)'
            }),
            phase.type === 'Workorder' && react_default.a.createElement(
              react["Fragment"],
              null,
              react_default.a.createElement(ResourceDetailsCardElement, {
                title: 'Workorder Source',
                value: phase.wo_source || emptyFieldValue
              }),
              react_default.a.createElement(ResourceDetailsCardElement, {
                title: 'Workorder Type',
                value: phase.wo_type || emptyFieldValue
              }),
              react_default.a.createElement(ResourceDetailsCardElement, null)
            )
          )
        ),
        react_default.a.createElement('br', null),
        react_default.a.createElement(
          components_Card,
          { className: resourceDetailsCard_default.a.detailsElementContainer },
          react_default.a.createElement(
            'h5',
            { className: phaseDetails_sectionTitle },
            'Contact Information'
          ),
          react_default.a.createElement(components_BreakLine, null),
          react_default.a.createElement(
            'div',
            { className: phaseDetailsCard_default.a.detailsCardContainer },
            react_default.a.createElement(ResourceDetailsCardElement, {
              title: 'Phone Number 1',
              value: phase.phone_numbers[0] ? phaseDetails_renderPhoneNumberDisplay(phase.phone_numbers[0]) : emptyFieldValue
            }),
            react_default.a.createElement(ResourceDetailsCardElement, {
              title: 'Phone Number 2',
              value: phase.phone_numbers[1] ? phaseDetails_renderPhoneNumberDisplay(phase.phone_numbers[1]) : emptyFieldValue
            }),
            react_default.a.createElement(ResourceDetailsCardElement, {
              title: 'Phone Number 3',
              value: phase.phone_numbers[2] ? phaseDetails_renderPhoneNumberDisplay(phase.phone_numbers[2]) : emptyFieldValue
            }),
            react_default.a.createElement(
              ResourceDetailsCardElement,
              { title: 'email address' },
              phase.email ? react_default.a.createElement(
                components_EmailLink,
                { email: phase.email },
                phase.email
              ) : emptyFieldValue
            ),
            react_default.a.createElement(ResourceDetailsCardElement, { title: 'primary mode of contact', value: phase.mode_of_contact }),
            react_default.a.createElement(ResourceDetailsCardElement, {
              title: 'automatic communication method',
              value: commMethod.charAt(0).toUpperCase() + commMethod.slice(1)
            })
          )
        ),
        react_default.a.createElement('br', null),
        react_default.a.createElement(
          components_Card,
          { className: resourceDetailsCard_default.a.detailsElementContainer },
          react_default.a.createElement(
            'h5',
            { className: phaseDetails_sectionTitle },
            'Purchase Information'
          ),
          react_default.a.createElement(components_BreakLine, null),
          react_default.a.createElement(
            'div',
            { className: phaseDetailsCard_default.a.detailsCardContainer },
            react_default.a.createElement(ResourceDetailsCardElement, { title: 'project number', value: phase.project_number || emptyFieldValue }),
            react_default.a.createElement(
              ResourceDetailsCardElement,
              { title: 'P.O. numbers' },
              purchaseOrdersCopy.length ? react_default.a.createElement(components_PurchaseOrders, { all: true, purchaseOrders: purchaseOrdersCopy }) : '----'
            ),
            react_default.a.createElement(ResourceDetailsCardElement, { title: 'store number', value: store.number }),
            react_default.a.createElement(ResourceDetailsCardElement, { title: 'spig delivery', value: phase.spig_delivery ? 'Yes' : '----' }),
            phase.type === 'Installation' && react_default.a.createElement(ResourceDetailsCardElement, {
              title: 'Product Location',
              value: phase.product_location || emptyFieldValue
            }),
            phase.type !== 'Assessment' && react_default.a.createElement(ResourceDetailsCardElement, {
              title: 'Vendor ETA',
              value: phase.vendor_eta || emptyFieldValue
            })
          )
        ),
        react_default.a.createElement('br', null),
        phaseDetails_renderSurfaceInfo(phase, surfaceName, surfaceInfo, (surfaceType || {}).id || null),
        react_default.a.createElement('br', null),
        Object(services["a" /* can */])(role, 'view', 'phase_specifics') && react_default.a.createElement(
          components_Card,
          { className: resourceDetailsCard_default.a.detailsElementContainer },
          react_default.a.createElement(
            'h5',
            { className: phaseDetails_sectionTitle },
            'Phase Specifics - General'
          ),
          react_default.a.createElement(components_BreakLine, null),
          react_default.a.createElement(
            'div',
            { className: phaseDetailsCard_default.a.detailsCardContainer },
            react_default.a.createElement(ResourceDetailsCardElement, {
              title: 'Customer Has Power',
              value: phaseSpecifics.customer_has_power ? 'Yes' : 'No'
            }),
            react_default.a.createElement(ResourceDetailsCardElement, {
              title: 'Customer Has Climate Control',
              value: phaseSpecifics.customer_has_climate_control ? 'Yes' : 'No'
            }),
            react_default.a.createElement(ResourceDetailsCardElement, {
              title: 'Customer Has Water',
              value: phaseSpecifics.customer_has_water ? 'Yes' : 'No'
            }),
            react_default.a.createElement(ResourceDetailsCardElement, {
              title: 'Moving Furniture',
              value: phaseSpecifics.need_move_furniture ? 'Yes' : 'No'
            }),
            react_default.a.createElement(ResourceDetailsCardElement, {
              title: 'Moving Oversized Furniture',
              value: phaseSpecifics.need_move_furniture_oversized ? 'Yes' : 'No'
            }),
            react_default.a.createElement(ResourceDetailsCardElement, {
              title: 'Moving Appliances',
              value: phaseSpecifics.need_move_appliances ? 'Yes' : 'No'
            }),
            !constants["_1" /* MILLWORK_SURFACES */].includes(phase.surface_type.id) && react_default.a.createElement(
              react["Fragment"],
              null,
              react_default.a.createElement(ResourceDetailsCardElement, {
                title: 'Subfloor Prep',
                value: phaseSpecifics.need_subfloor_prep ? 'Yes' : 'No'
              }),
              react_default.a.createElement(ResourceDetailsCardElement, {
                title: 'Subfloor Replacement',
                value: phaseSpecifics.need_subfloor_replacement ? 'Yes' : 'No'
              }),
              react_default.a.createElement(ResourceDetailsCardElement, {
                title: 'Installing Baseboard/Moulding',
                value: phaseSpecifics.need_install_baseboard ? 'Yes' : 'No'
              }),
              react_default.a.createElement(ResourceDetailsCardElement, {
                title: 'Installing Hard Surface Transitions',
                value: phaseSpecifics.need_hardsurface_transitions ? 'Yes' : 'No'
              })
            )
          ),
          react_default.a.createElement(components_BreakLine, null),
          !!surfaceType && react_default.a.createElement(
            react["Fragment"],
            null,
            constants["_1" /* MILLWORK_SURFACES */].includes(phase.surface_type.id) ? react_default.a.createElement(
              'span',
              null,
              react_default.a.createElement(
                'h5',
                { className: phaseDetails_sectionTitle },
                'Phase Specifics - Millwork'
              ),
              react_default.a.createElement(components_BreakLine, null),
              react_default.a.createElement(
                'div',
                { className: phaseDetailsCard_default.a.detailsCardContainer },
                react_default.a.createElement(ResourceDetailsCardElement, {
                  title: 'Number of Doors',
                  value: phaseSpecifics.millwork_specifics.num_doors
                }),
                react_default.a.createElement(ResourceDetailsCardElement, {
                  title: 'Number of Windows',
                  value: phaseSpecifics.millwork_specifics.num_windows
                }),
                react_default.a.createElement(ResourceDetailsCardElement, {
                  title: 'Permit Required',
                  value: phaseSpecifics.millwork_specifics.permit_required ? 'Yes' : 'No'
                })
              )
            ) : react_default.a.createElement(
              react["Fragment"],
              null,
              surfaceName === 'Hardwood' && react_default.a.createElement(
                'span',
                null,
                react_default.a.createElement(
                  'h5',
                  { className: phaseDetails_sectionTitle },
                  'Phase Specifics - Hardwood'
                ),
                react_default.a.createElement(components_BreakLine, null),
                react_default.a.createElement(
                  'div',
                  { className: phaseDetailsCard_default.a.detailsCardContainer },
                  react_default.a.createElement(ResourceDetailsCardElement, {
                    title: 'Naildown Hardwood',
                    value: phaseSpecifics.is_naildown_hardwood ? 'Yes' : 'No'
                  }),
                  react_default.a.createElement(ResourceDetailsCardElement, {
                    title: 'Gluedown Hardwood',
                    value: phaseSpecifics.is_gluedown_hardwood ? 'Yes' : 'No'
                  }),
                  react_default.a.createElement(ResourceDetailsCardElement, {
                    title: 'Floating Hardwood',
                    value: phaseSpecifics.is_floating_hardwood ? 'Yes' : 'No'
                  }),
                  react_default.a.createElement(ResourceDetailsCardElement, {
                    title: 'Cali Bamboo',
                    value: phaseSpecifics.is_cali_bamboo_hardwood ? 'Yes' : 'No'
                  }),
                  react_default.a.createElement(ResourceDetailsCardElement, {
                    title: 'Hardwood Steps',
                    value: phaseSpecifics.is_steps_hardwood ? 'Yes' : 'No'
                  })
                ),
                react_default.a.createElement(components_BreakLine, null)
              ),
              surfaceName === 'Carpet' && react_default.a.createElement(
                'span',
                null,
                react_default.a.createElement(
                  'h5',
                  { className: phaseDetails_sectionTitle },
                  'Phase Specifics - Carpet'
                ),
                react_default.a.createElement(components_BreakLine, null),
                react_default.a.createElement(
                  'div',
                  { className: phaseDetailsCard_default.a.detailsCardContainer },
                  react_default.a.createElement(ResourceDetailsCardElement, {
                    title: 'Stretch In Carpet',
                    value: phaseSpecifics.is_stretch_in_carpet ? 'Yes' : 'No'
                  }),
                  react_default.a.createElement(ResourceDetailsCardElement, {
                    title: 'Gluedown Carpet',
                    value: phaseSpecifics.is_gluedown_carpet ? 'Yes' : 'No'
                  }),
                  react_default.a.createElement(ResourceDetailsCardElement, {
                    title: 'Binding Carpet',
                    value: phaseSpecifics.is_binding_carpet ? 'Yes' : 'No'
                  }),
                  react_default.a.createElement(ResourceDetailsCardElement, {
                    title: 'Pattern Match Carpet',
                    value: phaseSpecifics.is_pattern_match_carpet ? 'Yes' : 'No'
                  }),
                  react_default.a.createElement(ResourceDetailsCardElement, {
                    title: 'Berber Carpet',
                    value: phaseSpecifics.is_berber_carpet ? 'Yes' : 'No'
                  }),
                  react_default.a.createElement(ResourceDetailsCardElement, {
                    title: 'Carpet Steps',
                    value: phaseSpecifics.is_steps_carpet ? 'Yes' : 'No'
                  })
                ),
                react_default.a.createElement(components_BreakLine, null)
              ),
              ['Tile', 'Backsplash'].includes(surfaceName) && react_default.a.createElement(
                'span',
                null,
                react_default.a.createElement(
                  'h5',
                  { className: phaseDetails_sectionTitle },
                  'Phase Specifics - Tile/Backsplash'
                ),
                react_default.a.createElement(components_BreakLine, null),
                react_default.a.createElement(
                  'div',
                  { className: phaseDetailsCard_default.a.detailsCardContainer },
                  react_default.a.createElement(ResourceDetailsCardElement, {
                    title: 'Floor Tile',
                    value: phaseSpecifics.is_floor_tile ? 'Yes' : 'No'
                  }),
                  react_default.a.createElement(ResourceDetailsCardElement, {
                    title: 'Patterns Tile',
                    value: phaseSpecifics.is_patterns_tile ? 'Yes' : 'No'
                  }),
                  react_default.a.createElement(ResourceDetailsCardElement, {
                    title: 'Large Format Tile',
                    value: phaseSpecifics.is_large_format_tile ? 'Yes' : 'No'
                  }),
                  react_default.a.createElement(ResourceDetailsCardElement, {
                    title: 'Backsplash Tile',
                    value: phaseSpecifics.is_backsplash_tile ? 'Yes' : 'No'
                  }),
                  react_default.a.createElement(ResourceDetailsCardElement, {
                    title: 'Glass Backsplash',
                    value: phaseSpecifics.is_backsplash_glass ? 'Yes' : 'No'
                  }),
                  react_default.a.createElement(ResourceDetailsCardElement, {
                    title: 'Backsplash Blocking',
                    value: phaseSpecifics.is_backsplash_blocking ? 'Yes' : 'No'
                  })
                ),
                react_default.a.createElement(components_BreakLine, null)
              ),
              ['Vinyl', 'Vinyl Plank'].includes(surfaceName) && react_default.a.createElement(
                'span',
                null,
                react_default.a.createElement(
                  'h5',
                  { className: phaseDetails_sectionTitle },
                  'Phase Specifics - Vinyl'
                ),
                react_default.a.createElement(components_BreakLine, null),
                react_default.a.createElement(
                  'div',
                  { className: phaseDetailsCard_default.a.detailsCardContainer },
                  react_default.a.createElement(ResourceDetailsCardElement, {
                    title: 'Sheet Vinyl',
                    value: phaseSpecifics.is_vinyl_sheet ? 'Yes' : 'No'
                  }),
                  react_default.a.createElement(ResourceDetailsCardElement, {
                    title: 'Vinyl Tile',
                    value: phaseSpecifics.is_vct_lvt ? 'Yes' : 'No'
                  }),
                  react_default.a.createElement(ResourceDetailsCardElement, {
                    title: 'Gluedown VP',
                    value: phaseSpecifics.is_gluedown_vinyl_plank ? 'Yes' : 'No'
                  }),
                  react_default.a.createElement(ResourceDetailsCardElement, {
                    title: 'Floating VP',
                    value: phaseSpecifics.is_floating_vinyl_plank ? 'Yes' : 'No'
                  })
                ),
                react_default.a.createElement(components_BreakLine, null)
              ),
              react_default.a.createElement(
                'h5',
                { className: phaseDetails_sectionTitle },
                'Phase Specifics - Removal'
              ),
              react_default.a.createElement(components_BreakLine, null),
              react_default.a.createElement(
                'div',
                { className: phaseDetailsCard_default.a.detailsCardContainer },
                react_default.a.createElement(ResourceDetailsCardElement, {
                  title: 'Removing/Replacing Toilet',
                  value: phaseSpecifics.need_remove_replace_toilet ? 'Yes' : 'No'
                }),
                react_default.a.createElement(ResourceDetailsCardElement, {
                  title: 'Removing Naildown Hardwood',
                  value: phaseSpecifics.need_remove_naildown_hardwood ? 'Yes' : 'No'
                }),
                react_default.a.createElement(ResourceDetailsCardElement, {
                  title: 'Removing Floating Hardwood',
                  value: phaseSpecifics.need_remove_floating_hardwood ? 'Yes' : 'No'
                }),
                react_default.a.createElement(ResourceDetailsCardElement, {
                  title: 'Removing Gluedown Hardwood',
                  value: phaseSpecifics.need_remove_gluedown_hardwood ? 'Yes' : 'No'
                }),
                react_default.a.createElement(ResourceDetailsCardElement, {
                  title: 'Removing Carpet Over Pad',
                  value: phaseSpecifics.need_remove_over_pad_carpet ? 'Yes' : 'No'
                }),
                react_default.a.createElement(ResourceDetailsCardElement, {
                  title: 'Removing Gluedown Carpet',
                  value: phaseSpecifics.need_remove_gluedown_carpet ? 'Yes' : 'No'
                }),
                react_default.a.createElement(ResourceDetailsCardElement, {
                  title: 'Removing Laminate',
                  value: phaseSpecifics.need_remove_laminate ? 'Yes' : 'No'
                }),
                react_default.a.createElement(ResourceDetailsCardElement, {
                  title: 'Removing Tile',
                  value: phaseSpecifics.need_remove_tile ? 'Yes' : 'No'
                }),
                react_default.a.createElement(ResourceDetailsCardElement, {
                  title: 'Removing Gluedown Vinyl',
                  value: phaseSpecifics.need_remove_gluedown_vinyl ? 'Yes' : 'No'
                }),
                react_default.a.createElement(ResourceDetailsCardElement, {
                  title: 'Removing Vinyl Plank',
                  value: phaseSpecifics.need_remove_vinyl_plank ? 'Yes' : 'No'
                }),
                react_default.a.createElement(ResourceDetailsCardElement, {
                  title: 'Remove Backsplash',
                  value: phaseSpecifics.need_remove_backsplash ? 'Yes' : 'No'
                })
              )
            )
          )
        ),
        react_default.a.createElement('br', null),
        role !== 'installer' && react_default.a.createElement(
          components_Card,
          { className: resourceDetailsCard_default.a.detailsElementContainer },
          react_default.a.createElement(
            'h5',
            { className: phaseDetails_sectionTitle },
            'Additional Information'
          ),
          react_default.a.createElement(components_BreakLine, null),
          react_default.a.createElement(
            'div',
            { className: phaseDetailsCard_default.a.detailsCardContainer },
            phase.type === 'Installation' && react_default.a.createElement(ResourceDetailsCardElement, {
              title: 'Haul Away and Removal',
              className: phaseDetailsCard_default.a.additionalComments,
              value: phase.haul_away || emptyFieldValue,
              columns: 'desktop-1x'
            }),
            phase.type === 'Installation' && react_default.a.createElement(ResourceDetailsCardElement, {
              title: 'Additional Work',
              className: phaseDetailsCard_default.a.additionalComments,
              value: phase.additional_work || emptyFieldValue,
              columns: 'desktop-1x'
            }),
            react_default.a.createElement(ResourceDetailsCardElement, {
              title: 'Additional Comments',
              className: phaseDetailsCard_default.a.additionalComments,
              value: phase.additional_comments || emptyFieldValue,
              columns: 'desktop-1x'
            }),
            phase.type === 'Assessment' && react_default.a.createElement(ResourceDetailsCardElement, {
              title: 'Floor Wizard Project ID',
              className: phaseDetailsCard_default.a.additionalComments,
              value: fwProjId || emptyFieldValue,
              columns: 'desktop-1x'
            })
          )
        )
      )
    )
  );
};

phaseDetails_PhaseDetails.propTypes = {
  phase: types_phase.isRequired,
  canEdit: prop_types_default.a.bool.isRequired,
  role: prop_types_default.a.string.isRequired,
  surfaceType: prop_types_default.a.shape({ name: prop_types_default.a.string }),
  store: prop_types_default.a.shape({ number: prop_types_default.a.string }),
  purchaseOrders: prop_types_default.a.arrayOf(prop_types_default.a.shape(purchaseOrder))
};

var phaseDetails_mapStateToProps = function mapStateToProps(state) {
  var phase = state.phase;
  var surfaceType = phase.details && phase.details.surface_type || {};
  var store = phase.details && phase.details.store;
  return {
    purchaseOrders: phase.purchaseOrders.items,
    phase: phase.details,
    store: store,
    surfaceType: surfaceType,
    canEdit: Object(services["a" /* can */])(Object(reducers["_12" /* getRole */])(state), 'update', 'phase'),
    role: Object(reducers["_12" /* getRole */])(state)
  };
};

/* harmony default export */ var tabs_phaseDetails = (Object(react_redux_es["connect"])(phaseDetails_mapStateToProps)(phaseDetails_PhaseDetails));
// EXTERNAL MODULE: ./node_modules/react-sanfona/dist-modules/index.js
var dist_modules = __webpack_require__("PEaj");
var dist_modules_default = /*#__PURE__*/__webpack_require__.n(dist_modules);

// EXTERNAL MODULE: ./client/app/shared/components/DocumentsTable/documentStyles.scss
var documentStyles = __webpack_require__("kYTj");
var documentStyles_default = /*#__PURE__*/__webpack_require__.n(documentStyles);

// CONCATENATED MODULE: ./client/app/shared/components/DocumentsTable/documentLink.jsx




var documentLink_DocumentLink = function DocumentLink(props) {
  var children = props.children,
      href = props.href;

  return react_default.a.createElement(
    'a',
    {
      href: href,
      className: documentStyles_default.a.documentNameLink,
      target: '_blank',
      rel: 'noopener noreferrer'
    },
    children
  );
};

documentLink_DocumentLink.propTypes = {
  children: prop_types_default.a.node,
  href: prop_types_default.a.string
};

/* harmony default export */ var documentLink = (documentLink_DocumentLink);
// EXTERNAL MODULE: ./client/app/shared/components/DocumentsTable/photoCarouselStyling.scss
var photoCarouselStyling = __webpack_require__("zWSg");
var photoCarouselStyling_default = /*#__PURE__*/__webpack_require__.n(photoCarouselStyling);

// EXTERNAL MODULE: ./client/app/shared/components/DocumentsTable/Images/arrow_forward.png
var arrow_forward = __webpack_require__("WTkQ");
var arrow_forward_default = /*#__PURE__*/__webpack_require__.n(arrow_forward);

// EXTERNAL MODULE: ./client/app/shared/components/DocumentsTable/Images/arrow_back.png
var arrow_back = __webpack_require__("ZOQn");
var arrow_back_default = /*#__PURE__*/__webpack_require__.n(arrow_back);

// CONCATENATED MODULE: ./client/app/shared/components/DocumentsTable/carousel.jsx
var carousel__slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();







var carousel_DocumentCarousel = function DocumentCarousel(_ref) {
  var idx = _ref.idx,
      src = _ref.src;

  var _useState = Object(react["useState"])(0),
      _useState2 = carousel__slicedToArray(_useState, 2),
      activeIdx = _useState2[0],
      setActiveIdx = _useState2[1];

  var arrOfFiles = src.Photos;
  var idxOfFile = idx;
  var findIndex = arrOfFiles.findIndex(function (item) {
    return item.id === idxOfFile;
  });

  Object(react["useEffect"])(function () {
    setActiveIdx(idx ? findIndex : 0);
    document.getElementById('imgId_' + arrOfFiles[0].id).style.border = '2px solid red';
  }, []);

  var updateIdx = function updateIdx(newIdx) {
    var getAllElements = document.querySelectorAll("[id^='imgId_']");
    var index = newIdx;
    if (index < 0) index = 0;else if (index >= arrOfFiles.length) index = arrOfFiles.length - 1;
    setActiveIdx(index);

    getAllElements.forEach(function (img) {
      var i = img;
      i.style.border = '';
    });
    document.getElementById('imgId_' + arrOfFiles[newIdx].id).style.border = '2px solid red';
  };

  var goToSlide = function goToSlide(id) {
    var newidx = arrOfFiles.findIndex(function (file) {
      return file.id === id;
    });
    var getAllElements = document.querySelectorAll("[id^='imgId_']");
    setActiveIdx(newidx);

    getAllElements.forEach(function (img) {
      var i = img;
      i.style.border = '';
    });
    document.getElementById('imgId_' + id).style.border = '2px solid red';
  };

  return react_default.a.createElement(
    'div',
    { className: photoCarouselStyling_default.a.container },
    react_default.a.createElement('img', { alt: 'left_arrow', src: arrow_back_default.a, className: photoCarouselStyling_default.a.leftButton, onClick: function onClick() {
        updateIdx(activeIdx - 1);
      } }),
    react_default.a.createElement('img', { alt: 'right_arrow', src: arrow_forward_default.a, className: photoCarouselStyling_default.a.rightButton, onClick: function onClick() {
        updateIdx(activeIdx + 1);
      } }),
    react_default.a.createElement(
      'h4',
      { className: photoCarouselStyling_default.a.docName },
      arrOfFiles[activeIdx].document_name
    ),
    react_default.a.createElement('div', {
      className: photoCarouselStyling_default.a.backgroundImg,
      style: {
        backgroundImage: 'url(' + arrOfFiles[activeIdx].expiring_download_url + ')'
      }
    }),
    react_default.a.createElement(
      'div',
      { style: { textAlign: 'center', paddingTop: '10px', display: 'flex', overflow: 'auto', justifyContent: 'center' } },
      arrOfFiles.map(function (file) {
        return react_default.a.createElement('img', { id: 'imgId_' + file.id, key: file.id, className: photoCarouselStyling_default.a.bottomCarousel, onClick: function onClick() {
            return goToSlide(file.id);
          }, src: file.expiring_download_url, alt: 'unchecked' });
      })
    )
  );
};

carousel_DocumentCarousel.propTypes = {
  idx: prop_types_default.a.number.isRequired,
  src: prop_types_default.a.object.isRequired
};

/* harmony default export */ var carousel = (carousel_DocumentCarousel);
// CONCATENATED MODULE: ./client/app/shared/components/DocumentsTable/Images/videoModal.jsx



var videoModal_VideoModal = function VideoModal(props) {
  return react_default.a.createElement(
    'div',
    null,
    react_default.a.createElement(
      'h4',
      { style: { textAlign: 'center', paddingBottom: '5px' } },
      props.src.document_name
    ),
    react_default.a.createElement(
      'video',
      { width: '390', height: '844', autoPlay: true },
      react_default.a.createElement('source', { src: props.src.expiring_download_url, type: 'video/mp4' })
    )
  );
};

videoModal_VideoModal.propTypes = {
  src: prop_types_default.a.object.isRequired
};

/* harmony default export */ var videoModal = (videoModal_VideoModal);
// CONCATENATED MODULE: ./client/app/shared/components/DocumentsTable/index.jsx
var DocumentsTable__slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function DocumentsTable__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




















var DocumentsTable_DocumentsTable = function DocumentsTable(props) {
  var _useState = Object(react["useState"])(false),
      _useState2 = DocumentsTable__slicedToArray(_useState, 2),
      active = _useState2[0],
      setActive = _useState2[1];

  var _useState3 = Object(react["useState"])(0),
      _useState4 = DocumentsTable__slicedToArray(_useState3, 2),
      file = _useState4[0],
      setActiveFile = _useState4[1];

  var _useState5 = Object(react["useState"])({}),
      _useState6 = DocumentsTable__slicedToArray(_useState5, 2),
      videoFile = _useState6[0],
      setActiveVideoFile = _useState6[1];

  var folders = props.folders,
      activeFolders = props.activeFolders,
      onFolderOpen = props.onFolderOpen,
      onFolderClose = props.onFolderClose,
      canModifyDoc = props.canModifyDoc;


  var folderNames = Object.keys(folders).sort(function (folderA, folderB) {
    return constants["H" /* DOCUMENT_TYPES */].indexOf(folderA) - constants["H" /* DOCUMENT_TYPES */].indexOf(folderB);
  });

  var titleStyle = classnames_default()([documentStyles_default.a.row, documentStyles_default.a.title]);
  var rowTextStyle = classnames_default()([documentStyles_default.a.row, documentStyles_default.a.textRow]);
  var folderStyle = classnames_default()([documentStyles_default.a.row, documentStyles_default.a.folder]);

  var handleThumbnailClick = function handleThumbnailClick(val) {
    setActive(true);setActiveFile(val);
  };

  var handleViewVideo = function handleViewVideo(val) {
    setActive(true);
    setActiveVideoFile(val);
  };

  var handleShowCarousel = function handleShowCarousel() {
    return setActive(true);
  };

  var handleClose = function handleClose() {
    setActive(false);
  };

  var desktopRow = function desktopRow(doc) {
    return react_default.a.createElement(
      'div',
      { className: classnames_default()([documentStyles_default.a.row, documentStyles_default.a.firstRowDoc]) },
      react_default.a.createElement(
        'div',
        { className: documentStyles_default.a.subRowDoc },
        react_default.a.createElement(
          'div',
          { className: documentStyles_default.a.thumbnailImage },
          Object(utils["q" /* isImage */])(doc.expiring_download_url) ?
          /* eslint jsx-a11y/no-static-element-interactions: 0 */
          react_default.a.createElement('img', {
            onClick: function onClick() {
              return handleThumbnailClick(doc.id);
            },
            role: 'button',
            tabIndex: doc.id,
            key: doc.id,
            className: documentStyles_default.a.preview,
            src: doc.expiring_download_url, alt: 'file'
          }) : react_default.a.createElement(react_toolbox_lib["FontIcon"], {
            onClick: function onClick() {
              return handleViewVideo(doc);
            },
            style: { cursor: 'pointer' },
            className: documentStyles_default.a.centerDoc,
            value: 'insert_drive_file'
          })
        ),
        react_default.a.createElement(
          'p',
          { className: documentStyles_default.a.nameRowDoc },
          doc.document_name
        )
      )
    );
  };

  var confirmAndNotUse = function confirmAndNotUse(doc) {
    var message = doc.not_use ? 'Are you sure you want to activate this document again?' : 'Are you sure you want to mark this document as do not use?';
    Object(utils["a" /* confirm */])(message, { title: 'Confirm' }).then(function () {
      return props.onNotUseTap(doc);
    }, function () {
      return null;
    });
  };

  var mobileRow = function mobileRow(doc) {
    return react_default.a.createElement(
      'div',
      { className: classnames_default()([documentStyles_default.a.subRowDoc, documentStyles_default.a.mobileRow]) },
      Object(utils["q" /* isImage */])(doc.expiring_download_url) ? react_default.a.createElement('img', { onClick: function onClick() {
          return handleThumbnailClick(doc.id);
        }, className: documentStyles_default.a.preview, src: doc.expiring_download_url, alt: 'file' }) : react_default.a.createElement(react_toolbox_lib["FontIcon"], { className: documentStyles_default.a.centerDoc, value: 'insert_drive_file' }),
      react_default.a.createElement(
        'div',
        { className: documentStyles_default.a.mobileInfo },
        react_default.a.createElement(
          'p',
          { className: documentStyles_default.a.nameRowDoc },
          react_default.a.createElement(
            documentLink,
            { href: doc.expiring_download_url },
            doc.document_name
          )
        ),
        react_default.a.createElement(
          'p',
          { className: documentStyles_default.a.subInfo },
          'Uploaded by ' + doc.user_name + ' on ' + Object(dateUtils["l" /* getMinLocalDate */])(doc.created_at)
        )
      ),
      react_default.a.createElement(react_toolbox_lib["FontIcon"], {
        className: classnames_default()(documentStyles_default.a.lockIcon, DocumentsTable__defineProperty({}, documentStyles_default.a.locked, doc.not_use)),
        value: 'not_interested',
        onClick: function onClick() {
          return confirmAndNotUse(doc);
        }
      })
    );
  };

  var titleContainer = function titleContainer(folderName) {
    return react_default.a.createElement(
      'div',
      { style: { display: ' inline-flex', width: '100%' } },
      react_default.a.createElement(
        'div',
        { className: folderStyle },
        react_default.a.createElement(react_toolbox_lib["FontIcon"], { value: 'folder_open' }),
        react_default.a.createElement(
          'span',
          { className: documentStyles_default.a.folderTitleText },
          folderName
        )
      ),
      react_default.a.createElement(
        'div',
        { style: { width: '50%', margin: '9px' } },
        folderName === 'Photos' ? react_default.a.createElement(
          ColoredButton["a" /* default */],
          { onClick: handleShowCarousel },
          'Open Carousel'
        ) : null
      )
    );
  };

  return react_default.a.createElement(
    'div',
    null,
    react_default.a.createElement(
      flexbox_react_dist_default.a,
      null,
      react_default.a.createElement(
        'p',
        { className: titleStyle },
        'Document Name'
      ),
      react_default.a.createElement(
        'p',
        { className: titleStyle },
        'Uploaded By'
      ),
      react_default.a.createElement(
        'p',
        { className: titleStyle },
        'Uploaded On'
      )
    ),
    react_default.a.createElement(
      dist_modules["Accordion"],
      { allowMultiple: true, activeItems: activeFolders },
      folderNames.map(function (folderName) {
        var folderDocs = folders[folderName];
        return react_default.a.createElement(
          dist_modules["AccordionItem"],
          {
            titleClassName: documentStyles_default.a.titleClassName,
            title: titleContainer(folderName),
            slug: folderName,
            key: folderName,
            onExpand: function onExpand() {
              return onFolderOpen(folderName);
            },
            onClose: function onClose() {
              return onFolderClose(folderName);
            }
          },
          folderDocs.map(function (doc) {
            return react_default.a.createElement(
              flexbox_react_dist_default.a,
              { key: doc.id, className: doc.not_use ? documentStyles_default.a.rowLocked : null },
              react_default.a.createElement(
                react_responsive_default.a,
                { minWidth: constants["y" /* CUT_POINT */] },
                desktopRow(doc)
              ),
              react_default.a.createElement(
                react_responsive_default.a,
                { maxWidth: constants["y" /* CUT_POINT */] - 1 },
                mobileRow(doc)
              ),
              react_default.a.createElement(
                'div',
                { className: rowTextStyle },
                doc.user_name
              ),
              react_default.a.createElement(
                flexbox_react_dist_default.a,
                { justifyContent: 'space-between', className: rowTextStyle },
                react_default.a.createElement(
                  'div',
                  null,
                  Object(dateUtils["l" /* getMinLocalDate */])(doc.created_at)
                ),
                react_default.a.createElement(
                  'div',
                  null,
                  react_default.a.createElement(
                    documentLink,
                    { href: doc.expiring_download_url },
                    react_default.a.createElement(react_toolbox_lib["FontIcon"], { className: documentStyles_default.a.downloadIcon, value: 'launch' })
                  ),
                  canModifyDoc && react_default.a.createElement(react_toolbox_lib["FontIcon"], {
                    className: classnames_default()(documentStyles_default.a.lockIcon, DocumentsTable__defineProperty({}, documentStyles_default.a.locked, doc.not_use)),
                    value: 'not_interested',
                    onClick: function onClick() {
                      return confirmAndNotUse(doc);
                    }
                  })
                )
              )
            );
          })
        );
      })
    ),
    react_default.a.createElement(
      react_toolbox_lib["Dialog"],
      {
        active: active,
        className: photoCarouselStyling_default.a.modal, type: 'fullscreen',
        onEscKeyDown: handleClose, onOverlayClick: handleClose
      },
      react_default.a.createElement(lib_button["IconButton"], {
        icon: 'close',
        className: modal_default.a.close,
        onClick: handleClose
      }),
      react_default.a.createElement(
        'div',
        {
          className: photoCarouselStyling_default.a.carouselContainer
        },
        videoFile.document_type === 'Videos' ? react_default.a.createElement(videoModal, { src: videoFile }) : react_default.a.createElement(carousel, { src: folders, idx: file })
      )
    )
  );
};

DocumentsTable_DocumentsTable.propTypes = {
  folders: prop_types_default.a.object.isRequired,
  onNotUseTap: prop_types_default.a.func.isRequired,
  onFolderOpen: prop_types_default.a.func.isRequired,
  onFolderClose: prop_types_default.a.func.isRequired,
  activeFolders: prop_types_default.a.array.isRequired,
  canModifyDoc: prop_types_default.a.bool.isRequired
};

/* harmony default export */ var components_DocumentsTable = (DocumentsTable_DocumentsTable);
// EXTERNAL MODULE: ./client/app/shared/components/DocumentsUpload/documentUploadStyles.scss
var documentUploadStyles = __webpack_require__("7hD4");
var documentUploadStyles_default = /*#__PURE__*/__webpack_require__.n(documentUploadStyles);

// CONCATENATED MODULE: ./client/app/shared/components/DocumentsUpload/index.jsx
function DocumentsUpload__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function DocumentsUpload__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function DocumentsUpload__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



















var DocumentsUpload_theme = { RTInput: input_default.a, RTDropdown: dropdown_default.a };
var DocumentsUpload_largeInput = classnames_default()(form_default.a.inputs, form_default.a.largeInput);
var DocumentsUpload_cancelClass = classnames_default()([documentUploadStyles_default.a.modalButton, form_default.a.cancelButton, form_default.a.actionButton]);
var uploadClass = classnames_default()([documentUploadStyles_default.a.modalButton, form_default.a.actionButton]);
var errorTextClass = classnames_default()([documentUploadStyles_default.a.errorText, documentUploadStyles_default.a.text]);
var BYTES_PER_MB = 1000000;
var DOCUMENT_OPTIONS = constants["H" /* DOCUMENT_TYPES */].sort().map(function (DocumentType) {
  return {
    value: DocumentType, label: DocumentType
  };
});

var DocumentsUpload_DocumentsUpload = function (_React$Component) {
  DocumentsUpload__inherits(DocumentsUpload, _React$Component);

  function DocumentsUpload(props) {
    DocumentsUpload__classCallCheck(this, DocumentsUpload);

    var _this = DocumentsUpload__possibleConstructorReturn(this, (DocumentsUpload.__proto__ || Object.getPrototypeOf(DocumentsUpload)).call(this, props));

    DocumentsUpload__initialiseProps.call(_this);

    var filesTotalBytes = _this.getFilesTotalBytes(_this.props.files);
    _this.state = {
      theFiles: _this.props.files.map(function (file) {
        var adjustedFile = file;
        adjustedFile.extension = file.name.split('.').pop();
        adjustedFile.sizeInMb = (file.size / BYTES_PER_MB).toFixed(3);
        adjustedFile.tooLarge = file.size > constants["Z" /* MAX_FILE_SIZE */];
        return adjustedFile;
      }),
      errors: _this.props.files.map(function () {
        return {};
      }),
      filesTotalBytes: _this.getFilesTotalBytes(_this.props.files),
      filesTotalMB: (filesTotalBytes / BYTES_PER_MB).toFixed(3)
    };
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    return _this;
  }

  return DocumentsUpload;
}(react_default.a.Component);

var DocumentsUpload__initialiseProps = function _initialiseProps() {
  var _this2 = this;

  Object.defineProperty(this, 'getFilesTotalBytes', {
    enumerable: true,
    writable: true,
    value: function value(files) {
      return files.reduce(function (total, file) {
        return total + file.size;
      }, 0);
    }
  });
  Object.defineProperty(this, 'handleSubmit', {
    enumerable: true,
    writable: true,
    value: function value() {
      var theFiles = _this2.state.theFiles;

      var errors = _this2.handleErrors();
      if (errors) return;
      var formData = new FormData();
      theFiles.map(function (file) {
        var documentName = file.document_name || file.name.replace(/\.[^/.]+$/, '');
        formData.append('document_upload[assets][][asset]', file);
        formData.append('document_upload[assets][][document_name]', documentName);
        formData.append('document_upload[assets][][document_type]', file.document_type);
        return null;
      });
      _this2.props.onSubmit(formData);
    }
  });
  Object.defineProperty(this, 'handleErrors', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _state = _this2.state,
          theFiles = _state.theFiles,
          errors = _state.errors;

      var shouldReturn = false;
      var errorText = "This field can't be blank";
      theFiles.map(function (file, i) {
        errors[i] = {};
        if (!file.document_type) {
          errors[i].document_type = errorText;
          shouldReturn = true;
        }
        var fileExtension = file.name.split('.').pop();
        if (constants["_50" /* VALID_DOC_FILE_UPLOADS */].indexOf(fileExtension.toLowerCase()) === -1) {
          if (errors[i].fileValidation && errors[i].fileValidation.length) {
            errors[i].fileValidation += ', ';
          } else {
            errors[i].fileValidation = '';
          }
          errors[i].fileValidation += 'File extension is not currently supported. Please select another file.';
          shouldReturn = true;
        }
        return null;
      });
      _this2.setState({ errors: errors });
      return shouldReturn;
    }
  });
  Object.defineProperty(this, 'deleteFile', {
    enumerable: true,
    writable: true,
    value: function value(index) {
      var _state2 = _this2.state,
          theFiles = _state2.theFiles,
          errors = _state2.errors;

      theFiles.splice(index, 1);
      errors.splice(index, 1);
      if (theFiles.length === 0) {
        _this2.props.onCancel();
      } else {
        var filesTotalBytes = _this2.getFilesTotalBytes(theFiles);
        var filesTotalMB = (filesTotalBytes / BYTES_PER_MB).toFixed(3);
        _this2.setState({ theFiles: theFiles, errors: errors, filesTotalBytes: filesTotalBytes, filesTotalMB: filesTotalMB });
      }
    }
  });
  Object.defineProperty(this, 'handleChange', {
    enumerable: true,
    writable: true,
    value: function value(key, _value, index) {
      var files = _this2.state.theFiles;
      var file = files[index];
      file[key] = _value;
      _this2.setState({ theFiles: files });
    }
  });
  Object.defineProperty(this, 'renderErrors', {
    enumerable: true,
    writable: true,
    value: function value() {
      var globalError = _this2.props.uploadError && _this2.props.uploadError.document_uploads;
      if (_this2.props.uploadError && _this2.props.uploadError.document_uploads) {
        return react_default.a.createElement(
          'div',
          { className: documentUploadStyles_default.a.errorContainer },
          react_default.a.createElement(MessageBox["a" /* default */], { error: true, message: globalError.join(', ') })
        );
      }
      return null;
    }
  });
  Object.defineProperty(this, 'render', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _props = _this2.props,
          onCancel = _props.onCancel,
          uploadingDocuments = _props.uploadingDocuments,
          role = _props.role,
          cv = _props.cv;
      var _state3 = _this2.state,
          theFiles = _state3.theFiles,
          errors = _state3.errors,
          filesTotalBytes = _state3.filesTotalBytes,
          filesTotalMB = _state3.filesTotalMB;

      var theUploadErrors = _this2.renderErrors();
      var singleFileTooLarge = theFiles.findIndex(function (file) {
        return file.tooLarge;
      }) > -1;
      var exceedsMaxUploadSize = filesTotalBytes > constants["Z" /* MAX_FILE_SIZE */];
      var hasSizeErrors = singleFileTooLarge || exceedsMaxUploadSize;
      var docOptions = DOCUMENT_OPTIONS;
      if (cv) {
        docOptions = Object(lodash["filter"])(docOptions, function (o) {
          return ['Floor Plan'].includes(o.value);
        });
      }
      if (['installer', 'crew'].includes(role)) {
        docOptions = Object(lodash["filter"])(docOptions, function (o) {
          return ['Bill of Lading', 'Blank COC', 'Floor Plan', 'Photos', 'Signed Documents'].includes(o.value);
        });
      }
      return react_default.a.createElement(
        react_css_themr_lib["ThemeProvider"],
        { theme: DocumentsUpload_theme },
        react_default.a.createElement(
          'div',
          { className: documentUploadStyles_default.a.back },
          react_default.a.createElement(
            'div',
            { className: documentUploadStyles_default.a.container },
            react_default.a.createElement(
              'p',
              { className: documentUploadStyles_default.a.title },
              'Document Upload'
            ),
            react_default.a.createElement(
              'p',
              { className: documentUploadStyles_default.a.text },
              'Total Upload Size: ',
              filesTotalMB,
              'MB.'
            ),
            exceedsMaxUploadSize && react_default.a.createElement(
              'p',
              { className: documentUploadStyles_default.a.text + ' ' + documentUploadStyles_default.a.warningText },
              'Your upload exceeds maximum size of ',
              constants["Z" /* MAX_FILE_SIZE */] / BYTES_PER_MB,
              'GB.'
            ),
            uploadingDocuments && react_default.a.createElement(
              'div',
              { className: documentUploadStyles_default.a.loadingNotificationContainer },
              react_default.a.createElement(
                'div',
                { className: documentUploadStyles_default.a.loadingSpinner },
                react_default.a.createElement(components_Loading, null)
              ),
              react_default.a.createElement(
                'p',
                { className: documentUploadStyles_default.a.text },
                'Upload has started. Large documents may take up to a minute.'
              )
            ),
            react_default.a.createElement(
              'div',
              { className: documentUploadStyles_default.a.errorMessage },
              theUploadErrors
            ),
            react_default.a.createElement(
              'div',
              { className: documentUploadStyles_default.a.filesContainer },
              theFiles.map(function (file, i) {
                return react_default.a.createElement(
                  'div',
                  {
                    className: documentUploadStyles_default.a.fileContainer,
                    key: '' + file.name + file.lastModified
                  },
                  Object(utils["q" /* isImage */])(file.type) ? react_default.a.createElement('img', {
                    className: classnames_default()([documentUploadStyles_default.a.preview, documentUploadStyles_default.a.center]),
                    src: file.preview,
                    alt: file.name
                  }) : react_default.a.createElement(react_toolbox_lib["FontIcon"], {
                    className: documentUploadStyles_default.a.center,
                    value: 'insert_drive_file'
                  }),
                  react_default.a.createElement(
                    'span',
                    { className: documentUploadStyles_default.a.text },
                    file.name
                  ),
                  react_default.a.createElement(
                    'span',
                    null,
                    ' ',
                    file.sizeInMb,
                    'MB'
                  ),
                  file.tooLarge && react_default.a.createElement(
                    'span',
                    { className: errorTextClass },
                    'exceeds the maximum file size limit of 20MB'
                  ),
                  react_default.a.createElement(
                    'button',
                    {
                      className: documentUploadStyles_default.a.deleteButton,
                      onClick: function onClick() {
                        return _this2.deleteFile(i);
                      }
                    },
                    react_default.a.createElement(react_toolbox_lib["FontIcon"], { className: documentUploadStyles_default.a.deleteIcon, value: 'delete' })
                  ),
                  react_default.a.createElement(
                    flexbox_react_dist_default.a,
                    { className: documentUploadStyles_default.a.inputs },
                    react_default.a.createElement(components_StyledSelect, {
                      className: DocumentsUpload_largeInput,
                      label: 'Document type',
                      onChange: function onChange(value) {
                        return _this2.handleChange('document_type', value, i);
                      },
                      options: docOptions,
                      value: file.document_type,
                      placeholder: 'Select Document Type',
                      error: errors[i].document_type || '',
                      required: true
                    }),
                    react_default.a.createElement(react_toolbox_lib["Input"], {
                      label: 'File Name',
                      className: DocumentsUpload_largeInput,
                      value: file.document_name,
                      onChange: function onChange(value) {
                        return _this2.handleChange('document_name', value, i);
                      },
                      error: errors[i].document_name || '',
                      placeholder: file.name.replace(/\.[^/.]+$/, ''),
                      required: true
                    })
                  ),
                  react_default.a.createElement(
                    'span',
                    { className: errorTextClass },
                    errors[i].fileValidation
                  )
                );
              })
            ),
            react_default.a.createElement(
              'div',
              { className: documentUploadStyles_default.a.actionButtons },
              react_default.a.createElement(ColoredButton["a" /* default */], {
                className: uploadClass,
                color: 'blue',
                disabled: hasSizeErrors,
                label: 'Upload',
                onClick: function onClick() {
                  return _this2.handleSubmit();
                }
              }),
              react_default.a.createElement(ColoredButton["a" /* default */], {
                className: DocumentsUpload_cancelClass,
                color: 'gray',
                label: 'Cancel',
                onClick: onCancel
              })
            ),
            react_default.a.createElement('div', { className: uploadingDocuments && documentUploadStyles_default.a.loadingOverlay })
          )
        )
      );
    }
  });
};

DocumentsUpload_DocumentsUpload.propTypes = {
  onCancel: prop_types_default.a.func,
  onSubmit: prop_types_default.a.func,
  files: prop_types_default.a.array,
  uploadError: prop_types_default.a.string,
  uploadingDocuments: prop_types_default.a.bool,
  role: prop_types_default.a.string,
  cv: prop_types_default.a.bool
};

/* harmony default export */ var components_DocumentsUpload = (DocumentsUpload_DocumentsUpload);
// EXTERNAL MODULE: ./node_modules/sweetalert/dist/sweetalert.min.js
var sweetalert_min = __webpack_require__("thjQ");
var sweetalert_min_default = /*#__PURE__*/__webpack_require__.n(sweetalert_min);

// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseDocuments/index.jsx
function phaseDocuments__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function phaseDocuments__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function phaseDocuments__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function phaseDocuments__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var phaseDocuments_PhaseDocuments = function (_Component) {
  phaseDocuments__inherits(PhaseDocuments, _Component);

  function PhaseDocuments(props) {
    phaseDocuments__classCallCheck(this, PhaseDocuments);

    var _this = phaseDocuments__possibleConstructorReturn(this, (PhaseDocuments.__proto__ || Object.getPrototypeOf(PhaseDocuments)).call(this, props));

    Object.defineProperty(_this, 'componentWillMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return !_this.hasParentDocs() ? _this.fetchDocs() : _this.setFoldersOpen();
      }
    });
    Object.defineProperty(_this, 'onFolderOpen', {
      enumerable: true,
      writable: true,
      value: function value(folderName) {
        var activeFolders = _this.state.activeFolders;

        if (activeFolders.indexOf(folderName) === -1) {
          activeFolders.push(folderName);
          _this.setState({ activeFolders: activeFolders });
        }
      }
    });
    Object.defineProperty(_this, 'onFolderClose', {
      enumerable: true,
      writable: true,
      value: function value(folderName) {
        var activeFolders = _this.state.activeFolders;

        var folderIndex = activeFolders.indexOf(folderName);
        if (folderIndex > -1) {
          activeFolders.splice(folderIndex, 1);
          _this.setState({ activeFolders: activeFolders });
        }
      }
    });
    Object.defineProperty(_this, 'onDrop', {
      enumerable: true,
      writable: true,
      value: function value(files) {
        return _this.setState({ showDropHere: false, filesToUpload: files });
      }
    });
    Object.defineProperty(_this, 'onDragEnter', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ showDropHere: true });
      }
    });
    Object.defineProperty(_this, 'onDragLeave', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ showDropHere: false });
      }
    });
    Object.defineProperty(_this, 'onSuccessUpload', {
      enumerable: true,
      writable: true,
      value: function value(files) {
        _this.documentUpload(files).then(_this.fetchDocs()).then(function () {
          return _this.setState({ filesToUpload: [] });
        }).then(function () {
          return _this.showSuccessAlert();
        }).catch(function () {});
      }
    });
    Object.defineProperty(_this, 'onUploadCancel', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ filesToUpload: [] });
      }
    });
    Object.defineProperty(_this, 'onNotUseTap', {
      enumerable: true,
      writable: true,
      value: function value(doc) {
        return _this.props.updateDocument(doc.phase_id, { id: doc.id, not_use: !doc.not_use });
      }
    });
    Object.defineProperty(_this, 'setFoldersOpen', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ activeFolders: Object.keys(_this.props.documents).filter(function (f) {
            return _this.contractVerificationFilter(f) && !_this.hideFloorPlanFolder(f);
          }) });
      }
    });
    Object.defineProperty(_this, 'showSuccessAlert', {
      enumerable: true,
      writable: true,
      value: function value() {
        return sweetalert_min_default()({
          title: 'Success!',
          text: 'Your file was successfully uploaded!',
          icon: 'success',
          buttons: false,
          timer: 3000
        });
      }
    });
    Object.defineProperty(_this, 'fetchDocs', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.fetchPhaseDocuments(_this.props.phaseId).then(function () {
          return _this.setFoldersOpen();
        });
      }
    });
    Object.defineProperty(_this, 'hasParentDocs', {
      enumerable: true,
      writable: true,
      value: function value() {
        return !Object(lodash["isEmpty"])(_this.props.parentDocs || {});
      }
    });
    Object.defineProperty(_this, 'contractVerificationFilter', {
      enumerable: true,
      writable: true,
      value: function value(folder) {
        return !_this.props.cv || ['Floor Plan'].includes(folder);
      }
    });
    Object.defineProperty(_this, 'hideFloorPlanFolder', {
      enumerable: true,
      writable: true,
      value: function value(folder) {
        return ifiUtils({ source: _this.props.source }) && !_this.props.cv && ['Floor Plan'].includes(folder);
      }
    });
    Object.defineProperty(_this, 'documentUpload', {
      enumerable: true,
      writable: true,
      value: function value(formData) {
        return _this.props.uploadDocument(formData, _this.props.phaseId);
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            documents = _this$props.documents,
            uploadingDocuments = _this$props.uploadingDocuments,
            uploadError = _this$props.uploadError,
            role = _this$props.role,
            canModifyDoc = _this$props.canModifyDoc,
            cv = _this$props.cv;
        var _this$state = _this.state,
            showDropHere = _this$state.showDropHere,
            filesToUpload = _this$state.filesToUpload,
            activeFolders = _this$state.activeFolders;

        var folderNames = Object.keys(documents).filter(function (f) {
          return _this.contractVerificationFilter(f) && !_this.hideFloorPlanFolder(f);
        });
        var visibleDocuments = folderNames.reduce(function (acc, f) {
          acc[f] = documents[f];
          return acc;
        }, {});
        var emptyDocs = react_default.a.createElement(
          'div',
          {
            className: classnames_default()([dropzoneStyles_default.a.placeholder], phaseDocuments__defineProperty({}, dropzoneStyles_default.a.opaque, showDropHere))
          },
          react_default.a.createElement(
            'h4',
            null,
            'It looks like you haven',
            '\'',
            't uploaded ',
            cv ? 'a Floor Plan' : 'anything',
            ', yet!'
          ),
          react_default.a.createElement(
            'h6',
            null,
            'Drag your ',
            cv ? 'Floor Plan file' : 'files',
            ' into this box to upload.',
            react_default.a.createElement(
              'span',
              { className: dropzoneStyles_default.a.button },
              'Or click here'
            ),
            '.'
          )
        );
        var dropHere = react_default.a.createElement(
          'div',
          { className: dropzoneStyles_default.a.dropHere },
          react_default.a.createElement(
            'h4',
            null,
            'Drag your ',
            cv ? 'Floor Plan file' : 'files',
            ' into this area to upload them.'
          )
        );
        return react_default.a.createElement(
          'div',
          { className: dropzoneStyles_default.a.whiteBack },
          showDropHere ? dropHere : null,
          react_default.a.createElement(
            react_dropzone_dist_default.a,
            {
              onDrop: _this.onDrop,
              onDragEnter: _this.onDragEnter,
              onDragLeave: _this.onDragLeave,
              className: classnames_default()([dropzoneStyles_default.a.dropzone], phaseDocuments__defineProperty({}, dropzoneStyles_default.a.empty, folderNames.length === 0)),
              disableClick: folderNames.length > 0
            },
            folderNames.length > 0 ? react_default.a.createElement(
              components_Card,
              {
                className: classnames_default()([dropzoneStyles_default.a.card], phaseDocuments__defineProperty({}, dropzoneStyles_default.a.opaque, showDropHere))
              },
              react_default.a.createElement(
                react_dropzone_dist_default.a,
                { className: dropzoneStyles_default.a.uploadFile, onDrop: _this.onDrop },
                react_default.a.createElement(
                  'p',
                  { className: dropzoneStyles_default.a.uploadText },
                  'Upload a ',
                  cv ? 'Floor Plan' : 'file'
                )
              ),
              react_default.a.createElement(components_DocumentsTable, {
                folders: visibleDocuments,
                onNotUseTap: _this.onNotUseTap,
                activeFolders: activeFolders,
                onFolderOpen: _this.onFolderOpen,
                onFolderClose: _this.onFolderClose,
                canModifyDoc: canModifyDoc
              })
            ) : emptyDocs
          ),
          filesToUpload.length > 0 || uploadingDocuments ? react_default.a.createElement(components_DocumentsUpload, {
            cv: cv,
            files: filesToUpload,
            onCancel: _this.onUploadCancel,
            onSubmit: _this.onSuccessUpload,
            uploadingDocuments: uploadingDocuments,
            uploadError: uploadError,
            role: role,
            fetchDocs: _this.fetchDocs
          }) : null
        );
      }
    });

    _this.onDrop = _this.onDrop.bind(_this);
    _this.onDragEnter = _this.onDragEnter.bind(_this);
    _this.onDragLeave = _this.onDragLeave.bind(_this);
    _this.onUploadCancel = _this.onUploadCancel.bind(_this);
    _this.onSuccessUpload = _this.onSuccessUpload.bind(_this);
    _this.state = {
      showDropHere: false,
      filesToUpload: [],
      activeFolders: []
    };
    return _this;
  }

  return PhaseDocuments;
}(react["Component"]);

phaseDocuments_PhaseDocuments.defaultProps = { parentId: null, parentDocs: {}, cv: false };

phaseDocuments_PhaseDocuments.propTypes = {
  params: prop_types_default.a.shape({
    id: prop_types_default.a.string
  }),
  cv: prop_types_default.a.bool,
  phaseId: prop_types_default.a.number,
  parentId: prop_types_default.a.number,
  canEdit: prop_types_default.a.bool,
  role: prop_types_default.a.string,
  canModifyDoc: prop_types_default.a.bool,
  parentDocs: prop_types_default.a.object,
  documents: prop_types_default.a.object,
  uploadError: prop_types_default.a.string,
  uploadingDocuments: prop_types_default.a.bool,
  uploadDocument: prop_types_default.a.func.isRequired,
  updateDocument: prop_types_default.a.func.isRequired,
  fetchPhaseDocuments: prop_types_default.a.func.isRequired,
  source: prop_types_default.a.string
};

var phaseDocuments_mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    canEdit: Object(services["a" /* can */])(Object(reducers["_12" /* getRole */])(state), 'edit', 'phase'),
    canModifyDoc: Object(services["a" /* can */])(Object(reducers["_12" /* getRole */])(state), 'edit', 'document'),
    role: Object(reducers["_12" /* getRole */])(state),
    phaseId: ownProps.parentId || ownProps.params.id,
    uploadingDocuments: Object(reducers["f" /* getDocumentUploadLoading */])(state),
    uploadError: Object(reducers["e" /* getDocumentUploadError */])(state),
    documents: !Object(lodash["isEmpty"])(ownProps.parentDocs || {}) ? ownProps.parentDocs : Object(reducers["X" /* getPhaseDocuments */])(state),
    source: state.phase.details.source
  };
};

/* harmony default export */ var phaseDocuments = (Object(react_redux_es["connect"])(phaseDocuments_mapStateToProps, {
  uploadDocument: actionCreators["_74" /* uploadDocument */],
  updateDocument: actionCreators["_60" /* updateDocument */],
  fetchPhaseDocuments: actionCreators["A" /* fetchPhaseDocuments */]
})(phaseDocuments_PhaseDocuments));
// CONCATENATED MODULE: ./client/app/shared/components/PhaseHistoryCard/phaseEvents/appointment_deleted.jsx





var appointment_deleted_appointment_deleted = function appointment_deleted(_ref) {
  var _ref$event = _ref.event,
      kind = _ref$event.kind,
      data = _ref$event.data;
  var appointment_type = data.appointment_type,
      appointment_date = data.appointment_date,
      who = data.who,
      cancelled = data.cancelled;

  var date = moment_default()(appointment_date).local().format('MM/DD/YYYY');
  var apptType = appointment_type === 'Repair Inspection' ? 'Workorder Inspection' : appointment_type;
  var name = apptType + ' appointment';
  var cMsg = name + ' scheduled for ' + date + ' was deleted because the phase was cancelled';
  var oMsg = who + ' requested to delete the ' + name + ' scheduled for ' + date;
  return react_default.a.createElement(
    'div',
    { className: kind },
    cancelled && cMsg || oMsg
  );
};

appointment_deleted_appointment_deleted.propTypes = {
  event: prop_types_default.a.shape({
    kind: prop_types_default.a.string.isRequired,
    data: prop_types_default.a.shape({
      appointment_type: prop_types_default.a.string.isRequired,
      appointment_date: prop_types_default.a.string.isRequired,
      who: prop_types_default.a.string
    }).isRequired
  }).isRequired,
  phase: types_phase
};
// CONCATENATED MODULE: ./client/app/shared/components/PhaseHistoryCard/phaseEvents/appointment_rescheduled.jsx





var appointment_rescheduled_appointment_rescheduled = function appointment_rescheduled(_ref) {
  var _ref$event = _ref.event,
      kind = _ref$event.kind,
      data = _ref$event.data;
  var start_date = data.start_date,
      end_date = data.end_date,
      arrival_start_time = data.arrival_start_time,
      arrival_end_time = data.arrival_end_time,
      assignee = data.assignee,
      rescheduled = data.rescheduled,
      scheduling_reason = data.scheduling_reason,
      _data$source = data.source,
      source = _data$source === undefined ? '' : _data$source,
      _data$ignored_warning = data.ignored_warnings,
      ignored_warnings = _data$ignored_warning === undefined ? [] : _data$ignored_warning;

  var arrivalStartTime = arrival_start_time.substr(0, arrival_start_time.length - 6);
  var arrivalEndTime = arrival_end_time.substr(0, arrival_end_time.length - 6);
  var date = moment_default()(start_date).format('MM/DD/YYYY');
  if (end_date !== start_date) date += '\u2014' + moment_default()(end_date).format('MM/DD/YYYY');
  var start = moment_default()(arrivalStartTime).format('h:mm a');
  var end = moment_default()(arrivalEndTime).format('h:mm a');
  return react_default.a.createElement(
    'div',
    { className: kind },
    react_default.a.createElement(
      'p',
      null,
      react_default.a.createElement(
        'strong',
        null,
        'Reschedule Reason:'
      ),
      ' ',
      rescheduled.reason
    ),
    react_default.a.createElement(
      'p',
      null,
      react_default.a.createElement(
        'strong',
        null,
        'Scheduling Reason:'
      ),
      ' ',
      scheduling_reason || 'N/A'
    ),
    source === 'suggestion' && react_default.a.createElement(
      'p',
      null,
      'Scheduled using appt. suggestions.'
    ),
    (ignored_warnings || []).length > 0 && react_default.a.createElement(
      'p',
      null,
      react_default.a.createElement(
        'strong',
        null,
        'WARNING:'
      ),
      ' ',
      ignored_warnings.join(', '),
      '.'
    ),
    assignee,
    ' scheduled for ',
    date,
    ' with arrival between ',
    start,
    ' and ',
    end,
    '.'
  );
};

appointment_rescheduled_appointment_rescheduled.propTypes = {
  event: prop_types_default.a.shape({
    kind: prop_types_default.a.string.isRequired,
    data: prop_types_default.a.shape({
      appointment_type: prop_types_default.a.string.isRequired,
      start_date: prop_types_default.a.string.isRequired,
      end_date: prop_types_default.a.string.isRequired,
      arrival_start_time: prop_types_default.a.string.isRequired,
      arrival_end_time: prop_types_default.a.string.isRequired,
      assignee: prop_types_default.a.string.isRequired,
      scheduling_reason: prop_types_default.a.string.isRequired,
      rescheduled: prop_types_default.a.shape({ reason: prop_types_default.a.string })
    }).isRequired
  }).isRequired,
  phase: types_phase
};
// CONCATENATED MODULE: ./client/app/shared/components/PhaseHistoryCard/phaseEvents/appointment_scheduled.jsx





var appointment_scheduled_appointment_scheduled = function appointment_scheduled(_ref) {
  var _ref$event = _ref.event,
      kind = _ref$event.kind,
      data = _ref$event.data;
  var start_date = data.start_date,
      end_date = data.end_date,
      arrival_start_time = data.arrival_start_time,
      arrival_end_time = data.arrival_end_time,
      assignee = data.assignee,
      scheduling_reason = data.scheduling_reason,
      _data$source = data.source,
      source = _data$source === undefined ? '' : _data$source,
      _data$ignored_warning = data.ignored_warnings,
      ignored_warnings = _data$ignored_warning === undefined ? [] : _data$ignored_warning;

  var arrivalStartTime = arrival_start_time.substr(0, arrival_start_time.length - 6);
  var arrivalEndTime = arrival_end_time.substr(0, arrival_end_time.length - 6);
  var date = moment_default()(start_date).format('MM/DD/YYYY');
  if (end_date !== start_date) date += '\u2014' + moment_default()(end_date).format('MM/DD/YYYY');
  var start = moment_default()(arrivalStartTime).format('h:mm a');
  var end = moment_default()(arrivalEndTime).format('h:mm a');
  return react_default.a.createElement(
    'div',
    { className: kind },
    react_default.a.createElement(
      'p',
      null,
      react_default.a.createElement(
        'strong',
        null,
        'Scheduling Reason:'
      ),
      ' ',
      scheduling_reason || 'N/A'
    ),
    source === 'suggestion' && react_default.a.createElement(
      'p',
      null,
      'Scheduled using appt. suggestions.'
    ),
    (ignored_warnings || []).length > 0 && react_default.a.createElement(
      'p',
      null,
      react_default.a.createElement(
        'strong',
        null,
        'WARNING:'
      ),
      ' ',
      ignored_warnings.join(', '),
      '.'
    ),
    assignee,
    ' scheduled for ',
    date,
    ' with arrival between ',
    start,
    ' and ',
    end,
    '.'
  );
};

appointment_scheduled_appointment_scheduled.propTypes = {
  event: prop_types_default.a.shape({
    kind: prop_types_default.a.string.isRequired,
    data: prop_types_default.a.shape({
      appointment_type: prop_types_default.a.string.isRequired,
      start_date: prop_types_default.a.string.isRequired,
      end_date: prop_types_default.a.string.isRequired,
      arrival_start_time: prop_types_default.a.string.isRequired,
      arrival_end_time: prop_types_default.a.string.isRequired,
      assignee: prop_types_default.a.string.isRequired,
      scheduling_reason: prop_types_default.a.string
    }).isRequired
  }).isRequired,
  phase: types_phase
};
// CONCATENATED MODULE: ./client/app/shared/components/PhaseHistoryCard/phaseEvents/appointment_started.jsx




var appointment_started_appointment_started = function appointment_started(_ref) {
  var _ref$event = _ref.event,
      kind = _ref$event.kind,
      auto = _ref$event.data.auto;
  return react_default.a.createElement(
    'div',
    { className: kind },
    auto && 'Appointment Date reached. System has autocompleted task.'
  );
};

appointment_started_appointment_started.propTypes = {
  event: prop_types_default.a.shape({
    kind: prop_types_default.a.string.isRequired,
    data: prop_types_default.a.shape({
      auto: prop_types_default.a.bool
    }).isRequired
  }).isRequired,
  phase: types_phase
};


// CONCATENATED MODULE: ./client/app/shared/components/PhaseHistoryCard/phaseEvents/appointment_updated.jsx






var appointment_updated_appointment_updated = function appointment_updated(_ref) {
  var _ref$event = _ref.event,
      kind = _ref$event.kind,
      data = _ref$event.data;
  var start_date = data.start_date,
      end_date = data.end_date,
      arrival_start_time = data.arrival_start_time,
      arrival_end_time = data.arrival_end_time,
      assignee = data.assignee,
      note = data.note,
      scheduling_reason = data.scheduling_reason;


  var date = moment_default()(start_date).format('MM/DD/YYYY');
  if (end_date !== start_date) {
    date += '\u2014' + moment_default()(end_date).format('MM/DD/YYYY');
  }
  var start = moment_default()(arrival_start_time).format('h:mm a');
  var end = moment_default()(arrival_end_time).format('h:mm a');

  return react_default.a.createElement(
    'div',
    { className: kind },
    react_default.a.createElement(
      'p',
      null,
      react_default.a.createElement(
        'strong',
        null,
        'Scheduling Reason:'
      ),
      ' ',
      scheduling_reason || 'N/A'
    ),
    assignee,
    ' scheduled for ',
    date,
    ' with arrival between ',
    start,
    ' and ',
    end,
    '.',
    react_default.a.createElement(
      components_UserNote,
      null,
      note
    )
  );
};

appointment_updated_appointment_updated.propTypes = {
  event: prop_types_default.a.shape({
    kind: prop_types_default.a.string.isRequired,
    data: prop_types_default.a.shape({
      appointment_type: prop_types_default.a.string.isRequired,
      start_date: prop_types_default.a.string.isRequired,
      end_date: prop_types_default.a.string.isRequired,
      arrival_start_time: prop_types_default.a.string.isRequired,
      arrival_end_time: prop_types_default.a.string.isRequired,
      assignee: prop_types_default.a.string.isRequired,
      scheduling_reason: prop_types_default.a.string,
      note: prop_types_default.a.string
    }).isRequired
  }).isRequired,
  phase: types_phase
};
// CONCATENATED MODULE: ./client/app/shared/components/PhaseHistoryCard/phaseEvents/assign_estimator.jsx




var assign_estimator_assign_estimator = function assign_estimator(_ref) {
  var _ref$event = _ref.event,
      user = _ref$event.user,
      kind = _ref$event.kind,
      estimator_name = _ref$event.data.estimator_name;
  return react_default.a.createElement(
    'div',
    { className: kind },
    estimator_name,
    ' was assigned by ',
    user
  );
};

assign_estimator_assign_estimator.propTypes = {
  event: prop_types_default.a.shape({
    user: prop_types_default.a.string.isRequired,
    kind: prop_types_default.a.string.isRequired,
    data: prop_types_default.a.shape({
      estimator_name: prop_types_default.a.string.isRequired
    }).isRequired
  }).isRequired,
  phase: types_phase
};
// CONCATENATED MODULE: ./client/app/shared/components/PhaseHistoryCard/phaseEvents/assign_installer.jsx




var assign_installer_assign_installer = function assign_installer(_ref) {
  var _ref$event = _ref.event,
      user = _ref$event.user,
      kind = _ref$event.kind,
      _ref$event$data = _ref$event.data,
      installer_name = _ref$event$data.installer_name,
      previous_installer_name = _ref$event$data.previous_installer_name;
  return react_default.a.createElement(
    'div',
    { className: kind },
    previous_installer_name ? react_default.a.createElement(
      'span',
      null,
      previous_installer_name,
      ' was replaced with ',
      installer_name
    ) : react_default.a.createElement(
      'span',
      null,
      installer_name,
      ' was assigned'
    ),
    ' ',
    'by ',
    user
  );
};

assign_installer_assign_installer.propTypes = {
  event: prop_types_default.a.shape({
    user: prop_types_default.a.string.isRequired,
    kind: prop_types_default.a.string.isRequired,
    data: prop_types_default.a.shape({
      installer_name: prop_types_default.a.string.isRequired,
      previous_installer_name: prop_types_default.a.string
    }).isRequired
  }).isRequired,
  phase: types_phase
};
// CONCATENATED MODULE: ./client/app/shared/components/PhaseHistoryCard/phaseEvents/auto_note.jsx




var auto_note_autoNote = function autoNote(message) {
  var component = function component(_ref) {
    var _ref$event = _ref.event,
        kind = _ref$event.kind,
        auto = _ref$event.data.auto;
    return react_default.a.createElement(
      'div',
      { className: kind },
      auto && message
    );
  };

  component.propTypes = {
    event: prop_types_default.a.shape({
      kind: prop_types_default.a.string.isRequired,
      data: prop_types_default.a.shape({
        auto: prop_types_default.a.bool
      }).isRequired
    }).isRequired,
    phase: types_phase
  };

  return component;
};

var review_assessment = auto_note_autoNote('Assessment was sent directly to store. No review required.');
var materials_ready = auto_note_autoNote('Material notification has been received from store');
// CONCATENATED MODULE: ./client/app/shared/components/PhaseHistoryCard/phaseEvents/check_in_measurement.jsx




var check_in_measurement_check_in_measurement = function check_in_measurement(_ref) {
  var kind = _ref.event.kind;
  return react_default.a.createElement(
    'div',
    { className: kind },
    'Information has been checked in from Floor Wizard.'
  );
};

check_in_measurement_check_in_measurement.propTypes = {
  event: prop_types_default.a.shape({
    kind: prop_types_default.a.string.isRequired
  }).isRequired,
  phase: types_phase
};
// CONCATENATED MODULE: ./client/app/shared/components/PhaseHistoryCard/phaseEvents/checkin.jsx




var checkin_checkin = function checkin(_ref) {
  var kind = _ref.event.data.kind;
  return react_default.a.createElement(
    'div',
    { className: kind },
    'Installer has ',
    kind === 'arrived' ? 'arrived at' : 'left',
    ' Jobsite'
  );
};

checkin_checkin.propTypes = {
  event: prop_types_default.a.shape({
    kind: prop_types_default.a.string.isRequired,
    data: prop_types_default.a.shape({
      kind: prop_types_default.a.string.isRequired
    }).isRequired
  }).isRequired,
  phase: types_phase
};
// CONCATENATED MODULE: ./client/app/shared/components/PhaseHistoryCard/phaseEvents/coc_signed.jsx




var coc_signed_coc_signed = function coc_signed(_ref) {
  var _ref$event = _ref.event,
      kind = _ref$event.kind,
      data = _ref$event.data;
  return react_default.a.createElement(
    'div',
    { className: kind },
    'COC signed by ',
    data.signee
  );
};

coc_signed_coc_signed.propTypes = {
  event: prop_types_default.a.shape({
    kind: prop_types_default.a.string.isRequired,
    data: prop_types_default.a.shape({}).isRequired
  }).isRequired,
  phase: types_phase
};
// CONCATENATED MODULE: ./client/app/shared/components/PhaseHistoryCard/phaseEvents/communication.jsx





var communication_communication = function communication(_ref) {
  var _ref$event = _ref.event,
      kind = _ref$event.kind,
      _ref$event$data = _ref$event.data,
      note = _ref$event$data.note,
      new_due_date = _ref$event$data.new_due_date;
  return react_default.a.createElement(
    'div',
    { className: kind },
    note && react_default.a.createElement(
      'div',
      null,
      note
    ),
    new_due_date && react_default.a.createElement(
      'div',
      null,
      'Due date updated to ',
      moment_default()(new_due_date).local().format('MM/DD/YYYY h:mm a')
    )
  );
};

communication_communication.propTypes = {
  event: prop_types_default.a.shape({
    kind: prop_types_default.a.string.isRequired,
    data: prop_types_default.a.shape({
      new_due_date: prop_types_default.a.string,
      note: prop_types_default.a.string
    }).isRequired
  }).isRequired,
  phase: types_phase
};
// CONCATENATED MODULE: ./client/app/shared/components/PhaseHistoryCard/phaseEvents/complete_repair.jsx





var complete_repair_complete_repair = function complete_repair(_ref) {
  var phase = _ref.phase,
      _ref$event = _ref.event,
      kind = _ref$event.kind,
      next_status = _ref$event.data.next_status;
  return react_default.a.createElement(
    'div',
    { className: kind },
    'Next Status: ',
    phaseEvents_getStatusUsingWindow(phase, next_status)
  );
};

complete_repair_complete_repair.defaultProps = { phase: null };

complete_repair_complete_repair.propTypes = {
  event: prop_types_default.a.shape({
    user: prop_types_default.a.string.isRequired,
    kind: prop_types_default.a.string.isRequired,
    data: prop_types_default.a.shape({
      next_status: prop_types_default.a.string.isRequired
    }).isRequired
  }).isRequired,
  phase: types_phase
};
// CONCATENATED MODULE: ./client/app/shared/components/PhaseHistoryCard/phaseEvents/contact_customer.jsx





var phaseEvents_contact_customer_contact_customer = function contact_customer(_ref) {
  var _ref$event = _ref.event,
      kind = _ref$event.kind,
      _ref$event$data = _ref$event.data,
      attempt = _ref$event$data.attempt,
      outcomes = _ref$event$data.outcomes,
      due_at = _ref$event$data.due_at,
      communication_method = _ref$event$data.communication_method;
  return react_default.a.createElement(
    'div',
    { className: kind },
    attempt && react_default.a.createElement(
      'p',
      null,
      'ATTEMPT #',
      attempt
    ),
    outcomes && outcomes.map(function (outcome, i) {
      return react_default.a.createElement(
        'p',
        { key: i },
        outcome.source,
        ' - ',
        outcome.result.join(', ')
      );
    }),
    due_at && react_default.a.createElement(
      'p',
      null,
      'Due date updated to: ',
      Object(dateUtils["l" /* getMinLocalDate */])(due_at)
    ),
    communication_method && react_default.a.createElement(
      'p',
      null,
      'Automatic communication method: ',
      communication_method.toUpperCase() || 'N/A'
    )
  );
};

phaseEvents_contact_customer_contact_customer.propTypes = {
  event: prop_types_default.a.shape({
    kind: prop_types_default.a.string.isRequired,
    data: prop_types_default.a.shape({
      outcomes: prop_types_default.a.arrayOf(prop_types_default.a.shape({
        source: prop_types_default.a.string.isRequired,
        result: prop_types_default.a.arrayOf(prop_types_default.a.string).isRequired,
        ok_to_text: prop_types_default.a.bool,
        reached: prop_types_default.a.bool
      })),
      attempt: prop_types_default.a.number,
      due_at: prop_types_default.a.string
    }).isRequired
  }).isRequired,
  phase: types_phase
};


// CONCATENATED MODULE: ./client/app/shared/types/survey.js


var SurveyID = prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]).isRequired;

var SurveyValue = prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]);

var SurveyAnswerType = prop_types_default.a.shape({
  id: SurveyID,
  label: prop_types_default.a.string.isRequired,
  value: SurveyValue
});

var SurveyQuestionType = prop_types_default.a.shape({
  id: SurveyID,
  label: prop_types_default.a.string.isRequired,
  content: prop_types_default.a.string.isRequired,
  answers: prop_types_default.a.arrayOf(SurveyAnswerType).isRequired
});

var SurveyType = prop_types_default.a.shape({
  questions: prop_types_default.a.arrayOf(SurveyQuestionType).isRequired,
  comment: prop_types_default.a.string,
  installer: prop_types_default.a.shape({
    name: prop_types_default.a.string
  }),
  resolution: prop_types_default.a.string
});

/* harmony default export */ var survey = (SurveyType);
// CONCATENATED MODULE: ./client/app/shared/components/PhaseHistoryCard/phaseEvents/customer_survey_updated.jsx





var customer_survey_updated_customer_survey_updated = function customer_survey_updated(_ref) {
  var _ref$event = _ref.event,
      kind = _ref$event.kind,
      _ref$event$data = _ref$event.data,
      comment = _ref$event$data.comment,
      questions = _ref$event$data.questions;
  return react_default.a.createElement(
    'div',
    { className: kind },
    questions.map(function (q) {
      var answers = q.answers.map(function (a) {
        return react_default.a.createElement(
          'span',
          { key: a.id },
          a.label,
          ': ',
          a.value || '\u2014',
          ' '
        );
      });
      return react_default.a.createElement(
        'p',
        { key: q.id },
        react_default.a.createElement(
          'strong',
          null,
          q.label
        ),
        react_default.a.createElement('br', null),
        answers
      );
    }),
    react_default.a.createElement(
      'p',
      null,
      react_default.a.createElement(
        'strong',
        null,
        'Additional Comments:'
      ),
      react_default.a.createElement('br', null),
      comment
    )
  );
};

customer_survey_updated_customer_survey_updated.propTypes = {
  event: prop_types_default.a.shape({
    kind: prop_types_default.a.string.isRequired,
    data: survey.isRequired
  }).isRequired,
  phase: types_phase
};
// CONCATENATED MODULE: ./client/app/shared/components/PhaseHistoryCard/phaseEvents/due_date_updated.jsx






var due_date_updated_due_date_updated = function due_date_updated(_ref) {
  var phase = _ref.phase,
      _ref$event = _ref.event,
      kind = _ref$event.kind,
      data = _ref$event.data,
      status = _ref$event.status;

  var date = moment_default()(data.new_due_date).local().format('MM/DD/YYYY h:mm a');
  return react_default.a.createElement(
    'div',
    { className: kind },
    'Due Date Updated for ',
    phaseEvents_getStatusUsingWindow(phase, status),
    ' Status.',
    react_default.a.createElement('br', null),
    'Set to ',
    date,
    '.'
  );
};

due_date_updated_due_date_updated.defaultProps = { phase: {} };

due_date_updated_due_date_updated.propTypes = {
  event: prop_types_default.a.shape({
    kind: prop_types_default.a.string.isRequired,
    data: prop_types_default.a.shape({
      new_due_date: prop_types_default.a.string.isRequired
    }).isRequired
  }).isRequired,
  phase: types_phase
};
// CONCATENATED MODULE: ./client/app/shared/components/PhaseHistoryCard/phaseEvents/flag_added.jsx




var flag_added_flag_note = function flag_note(_ref) {
  var _ref$event = _ref.event,
      kind = _ref$event.kind,
      _ref$event$data = _ref$event.data,
      name = _ref$event$data.name,
      suboption = _ref$event$data.suboption;
  return react_default.a.createElement(
    'div',
    { className: kind },
    name,
    suboption && ' - ' + suboption
  );
};

flag_added_flag_note.propTypes = {
  event: prop_types_default.a.shape({
    kind: prop_types_default.a.string.isRequired,
    data: prop_types_default.a.shape({
      name: prop_types_default.a.string.isRequired,
      suboption: prop_types_default.a.string.isRequired
    }).isRequired
  }).isRequired,
  phase: types_phase
};


// CONCATENATED MODULE: ./client/app/shared/components/PhaseHistoryCard/phaseEvents/floor_wizard.jsx




var floor_wizard_floor_wizard = function floor_wizard(_ref) {
  var _ref$event = _ref.event,
      kind = _ref$event.kind,
      success = _ref$event.data.success;
  return react_default.a.createElement(
    'div',
    { className: kind },
    success && 'Phase information was successfully sent to Floor Wizard',
    !success && 'Phase information was not sent to Floor Wizard'
  );
};

floor_wizard_floor_wizard.propTypes = {
  event: prop_types_default.a.shape({
    kind: prop_types_default.a.string.isRequired,
    data: prop_types_default.a.shape({
      success: prop_types_default.a.bool
    }).isRequired
  }).isRequired,
  phase: types_phase
};
// CONCATENATED MODULE: ./client/app/shared/components/PhaseHistoryCard/phaseEvents/laborsheet_approved.jsx





var laborsheet_approved_laborsheet_approved = function laborsheet_approved(_ref) {
  var _ref$event = _ref.event,
      kind = _ref$event.kind,
      _ref$event$data = _ref$event.data,
      name = _ref$event$data.name,
      date = _ref$event$data.date;
  return react_default.a.createElement(
    'div',
    { className: kind },
    name,
    ' has approved the labor sheet dated ',
    moment_default()(date).local().format('MM/DD/YYYY'),
    '.'
  );
};

laborsheet_approved_laborsheet_approved.propTypes = {
  event: prop_types_default.a.shape({
    kind: prop_types_default.a.string.isRequired,
    data: prop_types_default.a.shape({
      name: prop_types_default.a.string.isRequired,
      date: prop_types_default.a.string.isRequired
    }).isRequired
  }).isRequired,
  phase: types_phase
};
// CONCATENATED MODULE: ./client/app/shared/components/PhaseHistoryCard/phaseEvents/lowes_invoiced.jsx




var lowes_invoiced_lowes_invoiced = function lowes_invoiced(_ref) {
  var _ref$event = _ref.event,
      kind = _ref$event.kind,
      invoice_number = _ref$event.data.invoice_number;
  return react_default.a.createElement(
    'div',
    { className: kind },
    'Invoice created in quickbooks with invoice number: ',
    invoice_number
  );
};

lowes_invoiced_lowes_invoiced.propTypes = {
  event: prop_types_default.a.shape({
    kind: prop_types_default.a.string.isRequired,
    data: prop_types_default.a.shape({
      invoice_number: prop_types_default.a.string.isRequired
    }).isRequired
  }).isRequired,
  phase: types_phase
};
// CONCATENATED MODULE: ./client/app/shared/components/PhaseHistoryCard/phaseEvents/note.jsx





var phaseEvents_note_note = function note(_ref) {
  var _ref$phase = _ref.phase,
      phase = _ref$phase === undefined ? {} : _ref$phase,
      _ref$event = _ref.event,
      _ref$event$kind = _ref$event.kind,
      kind = _ref$event$kind === undefined ? '' : _ref$event$kind,
      _ref$event$data = _ref$event.data;
  _ref$event$data = _ref$event$data === undefined ? {} : _ref$event$data;
  var _ref$event$data$task = _ref$event$data.task,
      task = _ref$event$data$task === undefined ? '' : _ref$event$data$task,
      _ref$event$data$statu = _ref$event$data.status,
      status = _ref$event$data$statu === undefined ? '' : _ref$event$data$statu;
  return react_default.a.createElement(
    'div',
    { className: kind },
    task && status && task + ' ' + phaseEvents_getStatusUsingWindow(phase, status)
  );
};

phaseEvents_note_note.defaultProps = { phase: {} };

phaseEvents_note_note.propTypes = {
  event: prop_types_default.a.shape({
    kind: prop_types_default.a.string.isRequired,
    data: prop_types_default.a.shape({
      task: prop_types_default.a.string,
      status: prop_types_default.a.string
    }).isRequired
  }).isRequired,
  phase: types_phase
};
// CONCATENATED MODULE: ./client/app/shared/components/PhaseHistoryCard/phaseEvents/override_status.jsx





var override_status_getMsg = function getMsg(phase, from, to) {
  var getStatus = function getStatus(status) {
    return phaseEvents_getStatusUsingWindow(phase, status);
  };
  return 'Status was changed from ' + getStatus(from) + ' status to ' + getStatus(to) + ' status.';
};

var override_status_override_status = function override_status(_ref) {
  var _ref$event = _ref.event,
      kind = _ref$event.kind,
      _ref$event$data = _ref$event.data,
      from_status = _ref$event$data.from_status,
      to_status = _ref$event$data.to_status,
      phase = _ref$event.phase;
  return react_default.a.createElement(
    'div',
    { className: kind },
    override_status_getMsg(phase, from_status, to_status)
  );
};

override_status_override_status.defaultProps = { phase: {} };

override_status_override_status.propTypes = {
  event: prop_types_default.a.shape({
    kind: prop_types_default.a.string.isRequired,
    data: prop_types_default.a.shape({
      from_status: prop_types_default.a.string.isRequired,
      to_status: prop_types_default.a.string.isRequired
    }).isRequired
  }).isRequired,
  phase: types_phase
};
// CONCATENATED MODULE: ./client/app/shared/components/PhaseHistoryCard/phaseEvents/phase_canceled.jsx





var phase_canceled_phase_canceled = function phase_canceled(_ref) {
  var _ref$phase = _ref.phase;
  _ref$phase = _ref$phase === undefined ? {} : _ref$phase;
  var source = _ref$phase.source,
      _ref$phase$workroom_n = _ref$phase.workroom_name,
      workroom = _ref$phase$workroom_n === undefined ? '' : _ref$phase$workroom_n,
      _ref$event = _ref.event,
      kind = _ref$event.kind,
      _ref$event$data = _ref$event.data,
      from_status = _ref$event$data.from_status,
      who = _ref$event$data.who,
      reason = _ref$event$data.reason;
  return react_default.a.createElement(
    'div',
    { className: kind },
    'The phase was canceled due to ',
    who === 'Duplicate' ? 'SPIG ' : who + ' ',
    'while in the ',
    Object(utils["b" /* deriveStatusName */])(from_status, { source: source, workroom: workroom }),
    ' status.',
    reason && 'Reason: ' + reason
  );
};

phase_canceled_phase_canceled.propTypes = {
  event: prop_types_default.a.shape({
    kind: prop_types_default.a.string.isRequired,
    data: prop_types_default.a.shape({
      from_status: prop_types_default.a.string.isRequired,
      who: prop_types_default.a.string.isRequired,
      reason: prop_types_default.a.string
    }).isRequired
  }).isRequired,
  phase: types_phase
};
// CONCATENATED MODULE: ./client/app/shared/components/PhaseHistoryCard/phaseEvents/phase_completed.jsx




var phase_completed_phase_completed = function phase_completed(_ref) {
  var _ref$event = _ref.event,
      kind = _ref$event.kind,
      phase_type = _ref$event.data.phase_type;
  return react_default.a.createElement(
    'div',
    { className: kind },
    react_default.a.createElement(
      'span',
      { style: { textTransform: 'capitalize' } },
      phase_type
    ),
    ' Phase was Completed'
  );
};

phase_completed_phase_completed.propTypes = {
  event: prop_types_default.a.shape({
    kind: prop_types_default.a.string.isRequired,
    data: prop_types_default.a.shape({
      phase_type: prop_types_default.a.string.isRequired
    }).isRequired
  }).isRequired,
  phase: types_phase
};
// CONCATENATED MODULE: ./client/app/shared/components/PhaseHistoryCard/phaseEvents/phase_created.jsx




var phase_created_phase_created = function phase_created(_ref) {
  var kind = _ref.event.kind;
  return react_default.a.createElement(
    'div',
    { className: kind },
    'Phase Created'
  );
};

phase_created_phase_created.propTypes = {
  event: prop_types_default.a.shape({
    kind: prop_types_default.a.string.isRequired,
    data: prop_types_default.a.shape({}).isRequired
  }).isRequired,
  phase: types_phase
};
// CONCATENATED MODULE: ./client/app/shared/components/PhaseHistoryCard/phaseEvents/refigure_request.jsx





var refigure_request_specialOptionsRender = function specialOptionsRender(specialOptions) {
  var rushRequestNote = specialOptions.rushRequestNote,
      commercialRefigure = specialOptions.commercialRefigure,
      rushRequest = specialOptions.rushRequest;

  return react_default.a.createElement(
    'div',
    null,
    rushRequest && react_default.a.createElement(
      'span',
      null,
      react_default.a.createElement(
        'strong',
        null,
        'Rush Request'
      )
    ),
    commercialRefigure && react_default.a.createElement(
      'span',
      null,
      ' ',
      react_default.a.createElement(
        'strong',
        null,
        'Commercial Refigure'
      )
    ),
    rushRequest && react_default.a.createElement(
      components_UserNote,
      null,
      react_default.a.createElement(
        'strong',
        null,
        'Reason:'
      ),
      ' ',
      rushRequestNote
    )
  );
};

var refigure_request_storeInfoRender = function storeInfoRender(storeInfo) {
  return react_default.a.createElement(
    'div',
    null,
    react_default.a.createElement(
      'div',
      null,
      react_default.a.createElement(
        'strong',
        null,
        'Request by:'
      ),
      ' ',
      storeInfo.associateName
    ),
    react_default.a.createElement(
      'div',
      null,
      react_default.a.createElement(
        'strong',
        null,
        'Email:'
      ),
      ' ',
      storeInfo.associateEmail
    )
  );
};

var refigure_request_refigureDetailsRender = function refigureDetailsRender(refigureDetails) {
  return refigureDetails.map(function (detail) {
    return react_default.a.createElement(
      'div',
      { key: detail.id },
      react_default.a.createElement('br', null),
      react_default.a.createElement(
        'div',
        null,
        react_default.a.createElement(
          'strong',
          null,
          'Surface Type:'
        ),
        ' ',
        detail.surface_type.value
      ),
      react_default.a.createElement(
        'div',
        null,
        react_default.a.createElement(
          'strong',
          null,
          'Project SqFt:'
        ),
        ' ',
        detail.sqft
      ),
      Object.keys(detail.surface_information).sort().map(function (key) {
        return react_default.a.createElement(
          'div',
          { key: key },
          react_default.a.createElement(
            'strong',
            { style: { textTransform: 'capitalize' } },
            key.replace(/_/g, ' '),
            ': '
          ),
          detail.surface_information[key]
        );
      }),
      detail.roomName && react_default.a.createElement(
        'div',
        null,
        react_default.a.createElement(
          'strong',
          null,
          'Room Name:'
        ),
        ' ',
        detail.roomName
      ),
      detail.specialInstructions && react_default.a.createElement(
        'div',
        null,
        react_default.a.createElement(
          'strong',
          null,
          'Special Instructions:'
        ),
        ' ',
        detail.specialInstructions
      )
    );
  });
};

var refigure_request_refigure_request = function refigure_request(_ref) {
  var _ref$event = _ref.event,
      kind = _ref$event.kind,
      _ref$event$data = _ref$event.data,
      refigureDetails = _ref$event$data.refigureDetails,
      specialOptions = _ref$event$data.specialOptions,
      storeInfo = _ref$event$data.storeInfo;
  return react_default.a.createElement(
    'div',
    { className: kind },
    refigure_request_specialOptionsRender(specialOptions),
    refigure_request_storeInfoRender(storeInfo),
    refigure_request_refigureDetailsRender(refigureDetails)
  );
};

refigure_request_refigure_request.propTypes = {
  event: prop_types_default.a.shape({
    kind: prop_types_default.a.string.isRequired,
    data: prop_types_default.a.shape({
      refigureDetails: prop_types_default.a.object.isRequired,
      specialOptions: prop_types_default.a.object.isRequired,
      storeInfo: prop_types_default.a.object.isRequired
    }).isRequired
  }).isRequired,
  phase: types_phase
};
// CONCATENATED MODULE: ./client/app/shared/components/PhaseHistoryCard/phaseEvents/rocky.jsx




var rocky_rocky = function rocky(_ref) {
  var _ref$event = _ref.event,
      kind = _ref$event.kind,
      _ref$event$data = _ref$event.data,
      data = _ref$event$data === undefined ? {} : _ref$event$data;
  return react_default.a.createElement(
    'div',
    { className: kind },
    data.placeholder ? 'Rocky placeholder: phase would be sent to Lowe\'s Rocky' : 'Phase information sent to Rocky'
  );
};

rocky_rocky.propTypes = {
  event: prop_types_default.a.shape({
    kind: prop_types_default.a.string.isRequired,
    data: prop_types_default.a.shape({
      placeholder: prop_types_default.a.bool
    })
  }).isRequired,
  phase: types_phase
};
// CONCATENATED MODULE: ./client/app/shared/components/PhaseHistoryCard/phaseEvents/select_assessment.jsx




var select_assessment_select_assessment = function select_assessment(_ref) {
  var _ref$event = _ref.event,
      kind = _ref$event.kind,
      document_name = _ref$event.data.document_name;
  return react_default.a.createElement(
    'div',
    { className: kind },
    document_name && document_name + ' verified.'
  );
};

select_assessment_select_assessment.propTypes = {
  event: prop_types_default.a.shape({
    kind: prop_types_default.a.string.isRequired,
    data: prop_types_default.a.shape({
      document_name: prop_types_default.a.string
    }).isRequired
  }).isRequired,
  phase: types_phase
};
// CONCATENATED MODULE: ./client/app/shared/components/PhaseHistoryCard/phaseEvents/send_to_store.jsx




var send_to_store_SendToStore = function SendToStore(_ref) {
  var kind = _ref.event.kind;
  return react_default.a.createElement(
    'div',
    { className: kind },
    'Assessment/Refigure was uploaded to IMS.'
  );
};

// Original: References documents which we don't need right now, but will.

// const SendToStore = ({ event: { kind, data: { documents } } }) => {
//   const documentsString = documents.map(
//  doc => `${doc.document_type} ${doc.document_name}`).join(', ');
//   return (
//     <div className={kind}>
//       {documentsString} assessment(s) was uploaded to IMS.
//     </div>
//   );
// };

send_to_store_SendToStore.propTypes = {
  event: prop_types_default.a.shape({
    kind: prop_types_default.a.string.isRequired,
    data: prop_types_default.a.shape({
      documents: prop_types_default.a.array.isRequired
    }).isRequired
  }).isRequired,
  phase: types_phase
};


// CONCATENATED MODULE: ./client/app/shared/components/PhaseHistoryCard/phaseEvents/communication_sent.jsx




var communication_sent_communication_sent = function communication_sent(_ref) {
  var _ref$event = _ref.event,
      kind = _ref$event.kind,
      _ref$event$data = _ref$event.data,
      recipients = _ref$event$data.recipients,
      message = _ref$event$data.message;
  return react_default.a.createElement(
    'div',
    { className: kind },
    'Communication sent to customer at: ',
    recipients,
    '.',
    react_default.a.createElement('br', null),
    'Message Content: ',
    message
  );
};

communication_sent_communication_sent.propTypes = {
  event: prop_types_default.a.shape({
    kind: prop_types_default.a.string.isRequired,
    data: prop_types_default.a.shape({
      recipients: prop_types_default.a.string.isRequired,
      message: prop_types_default.a.string.isRequired
    }).isRequired
  }).isRequired,
  phase: types_phase
};
// CONCATENATED MODULE: ./client/app/shared/components/PhaseHistoryCard/phaseEvents/communication_error.jsx




var communication_error_communication_error = function communication_error(_ref) {
  var _ref$event = _ref.event,
      kind = _ref$event.kind,
      _ref$event$data = _ref$event.data,
      phone_number = _ref$event$data.phone_number,
      message = _ref$event$data.message;
  return react_default.a.createElement(
    'div',
    { className: kind },
    phone_number && 'Error sending text to number: ' + phone_number + '.',
    phone_number && react_default.a.createElement('br', null),
    message && 'Error Message: ' + message
  );
};

communication_error_communication_error.propTypes = {
  event: prop_types_default.a.shape({
    kind: prop_types_default.a.string.isRequired,
    data: prop_types_default.a.shape({
      phone_number: prop_types_default.a.string.isRequired,
      message: prop_types_default.a.string.isRequired
    }).isRequired
  }).isRequired,
  phase: types_phase
};
// CONCATENATED MODULE: ./client/app/shared/components/PhaseHistoryCard/phaseEvents/communication_received.jsx




var communication_received_communication_received = function communication_received(_ref) {
  var _ref$event = _ref.event,
      kind = _ref$event.kind,
      _ref$event$data = _ref$event.data,
      sender = _ref$event$data.sender,
      customer_answer = _ref$event$data.customer_answer;
  return react_default.a.createElement(
    'div',
    { className: kind },
    'Communication received from customer from number: ',
    sender,
    '.',
    react_default.a.createElement('br', null),
    'Ready to schedule: ',
    customer_answer
  );
};

communication_received_communication_received.propTypes = {
  event: prop_types_default.a.shape({
    kind: prop_types_default.a.string.isRequired,
    data: prop_types_default.a.shape({
      sender: prop_types_default.a.string.isRequired,
      customer_answer: prop_types_default.a.string.isRequired
    }).isRequired
  }).isRequired,
  phase: types_phase
};
// CONCATENATED MODULE: ./client/app/shared/components/PhaseHistoryCard/phaseEvents/force_to_scheduling.jsx




var force_to_scheduling_force_to_scheduling = function force_to_scheduling(_ref) {
  var _ref$event = _ref.event,
      kind = _ref$event.kind,
      explanation = _ref$event.data.explanation;
  return react_default.a.createElement(
    'div',
    { className: kind },
    explanation
  );
};

force_to_scheduling_force_to_scheduling.propTypes = {
  event: prop_types_default.a.shape({
    kind: prop_types_default.a.string.isRequired,
    data: prop_types_default.a.shape({
      explanation: prop_types_default.a.string.isRequired
    }).isRequired
  }).isRequired,
  phase: types_phase
};
// CONCATENATED MODULE: ./client/app/shared/components/PhaseHistoryCard/phaseEvents/departed_from_appointment.jsx




var departed_from_appointment_departed_from_appointment = function departed_from_appointment(_ref) {
  var _ref$event = _ref.event,
      kind = _ref$event.kind,
      disposition = _ref$event.data.disposition;
  return react_default.a.createElement(
    'div',
    { className: kind },
    'Disposition: ',
    disposition ? disposition.replace(/_/g, ' ') : 'N/A'
  );
};

departed_from_appointment_departed_from_appointment.defaultProps = { phase: null };

departed_from_appointment_departed_from_appointment.propTypes = {
  event: prop_types_default.a.shape({
    kind: prop_types_default.a.string.isRequired,
    data: prop_types_default.a.shape({
      disposition: prop_types_default.a.string
    }).isRequired
  }).isRequired,
  phase: types_phase
};
// CONCATENATED MODULE: ./client/app/shared/components/PhaseHistoryCard/phaseEvents/customer_callback_migration.jsx




var customer_callback_migration_customer_callback_migration = function customer_callback_migration(_ref) {
  var _ref$event = _ref.event,
      kind = _ref$event.kind,
      original_name = _ref$event.data.original_name;
  return react_default.a.createElement(
    'div',
    { className: kind },
    original_name,
    ' was updated to Customer Callback for this phase.'
  );
};

customer_callback_migration_customer_callback_migration.propTypes = {
  event: prop_types_default.a.shape({
    kind: prop_types_default.a.string.isRequired,
    data: prop_types_default.a.shape({
      flag_id: prop_types_default.a.number,
      original_name: prop_types_default.a.string.isRequired
    }).isRequired
  }).isRequired,
  phase: types_phase
};
// CONCATENATED MODULE: ./client/app/shared/components/PhaseHistoryCard/phaseEvents/index.js






































var phaseEvents_getStatusUsingWindow = function getStatusUsingWindow(phase, status) {
  var _ref = phase || {},
      _ref$type = _ref.type,
      type = _ref$type === undefined ? '' : _ref$type,
      _ref$source = _ref.source,
      source = _ref$source === undefined ? '' : _ref$source,
      _ref$workroom_name = _ref.workroom_name,
      phaseWorkroom = _ref$workroom_name === undefined ? '' : _ref$workroom_name,
      _ref$workroom = _ref.workroom;

  _ref$workroom = _ref$workroom === undefined ? {} : _ref$workroom;
  var _ref$workroom$name = _ref$workroom.name,
      workroom = _ref$workroom$name === undefined ? '' : _ref$workroom$name;

  var statusName = (window.SPOT.status_titles[type.toLowerCase()].status[status.toLowerCase()] || status || '').toLowerCase();
  return Object(utils["b" /* deriveStatusName */])(statusName, { source: source, workroom: phaseWorkroom || workroom });
};
// EXTERNAL MODULE: ./client/app/shared/components/PhaseHistoryCard/phaseHistoryCard.scss
var phaseHistoryCard = __webpack_require__("s3iu");
var phaseHistoryCard_default = /*#__PURE__*/__webpack_require__.n(phaseHistoryCard);

// CONCATENATED MODULE: ./client/app/shared/components/PhaseHistoryCard/phaseEventList.jsx
function phaseEventList__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

















var translateRepair = function translateRepair(str) {
  return str.replace(/repair/gi, 'Workorder');
};

var phaseEventList_getStatusDisplay = function getStatusDisplay(phase, status, eventName) {
  if (eventName.toLowerCase() === 'canceled') return 'Phase Canceled';

  var _ref = phase || {},
      _ref$source = _ref.source,
      source = _ref$source === undefined ? '' : _ref$source,
      _ref$workroom_name = _ref.workroom_name,
      phaseWorkroom = _ref$workroom_name === undefined ? '' : _ref$workroom_name,
      _ref$workroom = _ref.workroom;

  _ref$workroom = _ref$workroom === undefined ? {} : _ref$workroom;
  var _ref$workroom$name = _ref$workroom.name,
      workroom = _ref$workroom$name === undefined ? '' : _ref$workroom$name;

  var workroomName = phaseWorkroom || workroom;
  var statusName = Object(utils["b" /* deriveStatusName */])(status, { source: source, workroom: workroomName });
  return translateRepair(statusName + ' - ' + Object(utils["B" /* titleize */])(eventName));
};

var phaseEventList_PhaseEventList = function PhaseEventList(_ref2) {
  var events = _ref2.events,
      phase = _ref2.phase,
      isPhaseHistoryTab = _ref2.isPhaseHistoryTab;

  var eventList = events.map(function (event, i) {
    var _cx;

    var _ref3 = event || {},
        _ref3$name = _ref3.name,
        name = _ref3$name === undefined ? '' : _ref3$name,
        _ref3$status = _ref3.status,
        status = _ref3$status === undefined ? '' : _ref3$status,
        _ref3$phase = _ref3.phase,
        eventPhase = _ref3$phase === undefined ? null : _ref3$phase,
        _ref3$kind = _ref3.kind,
        kind = _ref3$kind === undefined ? '' : _ref3$kind,
        _ref3$bot = _ref3.bot,
        bot = _ref3$bot === undefined ? null : _ref3$bot,
        _ref3$data = _ref3.data;

    _ref3$data = _ref3$data === undefined ? {} : _ref3$data;
    var _ref3$data$note = _ref3$data.note,
        note = _ref3$data$note === undefined ? '' : _ref3$data$note;

    var phaseToUse = !eventPhase ? phase || null : eventPhase;
    var eventTitle = phaseEventList_getStatusDisplay(phaseToUse, status, name);
    var showPhaseLink = !isPhaseHistoryTab && !!phaseToUse;
    var hasNote = !!note;
    var hasUserNote = hasNote && !bot;
    var EventType = phaseEvents_namespaceObject[kind] ? phaseEvents_namespaceObject[kind] : phaseEvents_note_note;
    var card = react_default.a.createElement(
      components_Card,
      { className: classnames_default()(resourceCard_default.a.resourceCard, phaseHistoryCard_default.a.resourceCard), altColor: i % 2 !== 0 },
      showPhaseLink && react_default.a.createElement(
        'div',
        {
          className: classnames_default()(resourceCard_default.a.resourceCardColumn, phaseHistoryCard_default.a.phaseHistoryPhaseInfo)
        },
        react_default.a.createElement(ResourceCardElement, {
          title: 'Customer',
          value: phaseToUse.customer_name,
          size: 'large',
          theme: phaseHistoryCard_default.a,
          wrap: true
        })
      ),
      react_default.a.createElement(
        'div',
        { className: classnames_default()(resourceCard_default.a.resourceCardColumn, phaseHistoryCard_default.a.phaseHistoryAside) },
        react_default.a.createElement(
          'div',
          { className: resourceCard_default.a.column },
          react_default.a.createElement(ResourceCardElement, {
            title: 'Task/Event',
            value: eventTitle,
            size: 'large',
            theme: phaseHistoryCard_default.a,
            wrap: true
          }),
          react_default.a.createElement(ResourceCardElement, {
            title: event.user_type,
            value: event.user,
            size: 'large',
            theme: phaseHistoryCard_default.a,
            wrap: true
          })
        ),
        react_default.a.createElement(
          'div',
          { className: resourceCard_default.a.column },
          react_default.a.createElement(
            ResourceCardElement,
            {
              title: 'Info',
              size: 'large',
              theme: phaseHistoryCard_default.a,
              wrap: true
            },
            EventType && react_default.a.createElement(EventType, { event: event, phase: phaseToUse }),
            hasNote && bot && react_default.a.createElement(
              components_UserNote,
              null,
              note
            )
          ),
          react_default.a.createElement(ResourceCardElement, {
            title: 'Recorded On',
            value: moment_default()(event.created_at).local().format('dddd, MM/DD/YYYY, h:mm a').toString(),
            size: 'large',
            theme: phaseHistoryCard_default.a
          })
        )
      ),
      hasUserNote && react_default.a.createElement(
        'div',
        { className: classnames_default()(resourceCard_default.a.resourceCardColumn, phaseHistoryCard_default.a.phaseHistoryNotes) },
        react_default.a.createElement(
          ResourceCardElement,
          { size: 'large', title: 'Note', theme: phaseHistoryCard_default.a },
          react_default.a.createElement(
            components_UserNote,
            null,
            event.data.note
          )
        )
      )
    );
    return react_default.a.createElement(
      'div',
      {
        key: event.id,
        className: classnames_default()(phaseHistoryCard_default.a.phaseEventCard, (_cx = {}, phaseEventList__defineProperty(_cx, phaseHistoryCard_default.a.withNote, hasUserNote), phaseEventList__defineProperty(_cx, phaseHistoryCard_default.a.withPhase, showPhaseLink), _cx))
      },
      showPhaseLink ? react_default.a.createElement(
        es["c" /* Link */],
        {
          className: resourceCard_default.a.viewLink, to: urls.phase(phaseToUse)
        },
        card
      ) : card
    );
  });
  return react_default.a.createElement(
    'section',
    null,
    (eventList || []).length > 0 ? eventList : react_default.a.createElement(
      'i',
      null,
      'No events'
    )
  );
};

phaseEventList_PhaseEventList.propTypes = {
  events: prop_types_default.a.arrayOf(types_event).isRequired,
  isSortByDateTime: prop_types_default.a.bool,
  phase: types_phase,
  isPhaseHistoryTab: prop_types_default.a.bool
};

/* harmony default export */ var phaseEventList = (phaseEventList_PhaseEventList);
// CONCATENATED MODULE: ./client/app/shared/components/PhaseHistoryCard/index.jsx
function PhaseHistoryCard__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function PhaseHistoryCard__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function PhaseHistoryCard__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var PhaseHistoryCard_PhaseHistoryCard = function (_React$Component) {
  PhaseHistoryCard__inherits(PhaseHistoryCard, _React$Component);

  function PhaseHistoryCard(props) {
    PhaseHistoryCard__classCallCheck(this, PhaseHistoryCard);

    var _this = PhaseHistoryCard__possibleConstructorReturn(this, (PhaseHistoryCard.__proto__ || Object.getPrototypeOf(PhaseHistoryCard)).call(this, props));

    Object.defineProperty(_this, 'componentDidMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.contentWrapper !== null ? _this.setState({ clientHeight: _this.contentWrapper.clientHeight }) : null;
      }
    });
    Object.defineProperty(_this, 'handleClick', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({
          collapsed: !_this.state.collapsed, icon: _this.state.collapsed ? 'up' : 'down'
        });
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$state = _this.state,
            collapsed = _this$state.collapsed,
            clientHeight = _this$state.clientHeight;
        var _this$props = _this.props,
            events = _this$props.events,
            name = _this$props.name,
            isSortByDateTime = _this$props.isSortByDateTime,
            phase = _this$props.phase,
            isPhaseHistoryTab = _this$props.isPhaseHistoryTab;

        var icon = 'arrow_drop_' + _this.state.icon;
        var iconStyle = phaseHistoryCard_default.a.phaseHistoryCard__collapseToggle;
        var heightStyle = {};
        if (collapsed) heightStyle.maxHeight = 0;else {
          heightStyle.maxHeight = (clientHeight || 0) + 500;
        }
        return react_default.a.createElement(
          components_Card,
          { className: phaseHistoryCard_default.a.phaseHistoryCard__container + ' ' + contentArea_default.a.contentArea },
          react_default.a.createElement(
            'section',
            { className: phaseHistoryCard_default.a.phaseHistoryCard },
            react_default.a.createElement(
              'div',
              { className: phaseHistoryCard_default.a.phaseHistoryCard__title },
              react_default.a.createElement(
                'span',
                null,
                name
              ),
              react_default.a.createElement(react_toolbox_lib["FontIcon"], { value: icon, onClick: _this.handleClick, className: iconStyle })
            ),
            react_default.a.createElement(
              'div',
              { className: phaseHistoryCard_default.a.phaseHistoryCard__content, style: heightStyle },
              react_default.a.createElement(
                'div',
                { ref: function ref(wrapper) {
                    _this.contentWrapper = wrapper;
                  } },
                react_default.a.createElement(phaseEventList, {
                  events: events,
                  isSortByDateTime: isSortByDateTime,
                  phase: phase,
                  isPhaseHistoryTab: isPhaseHistoryTab
                })
              )
            )
          )
        );
      }
    });

    _this.state = {
      collapsed: props.collapsed,
      icon: props.collapsed ? 'down' : 'up',
      clientHeight: 0
    };
    return _this;
  }

  // On the first render, the component has no reference to the contentWrapper
  // and its height. We need to trigger another render if the component is
  // initially expanded so that it displays properly.


  return PhaseHistoryCard;
}(react_default.a.Component);

PhaseHistoryCard_PhaseHistoryCard.defaultProps = { isPhaseHistoryTab: false, phase: null };

PhaseHistoryCard_PhaseHistoryCard.propTypes = {
  name: prop_types_default.a.string,
  collapsed: prop_types_default.a.bool,
  events: prop_types_default.a.arrayOf(prop_types_default.a.object),
  isSortByDateTime: prop_types_default.a.bool,
  phase: types_phase,
  isPhaseHistoryTab: prop_types_default.a.bool
};

/* harmony default export */ var components_PhaseHistoryCard = (PhaseHistoryCard_PhaseHistoryCard);
// EXTERNAL MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/phaseHistory.scss
var phaseHistory = __webpack_require__("Z8kv");
var phaseHistory_default = /*#__PURE__*/__webpack_require__.n(phaseHistory);

// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/components/historyFilters.jsx
var historyFilters__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function historyFilters__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function historyFilters__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function historyFilters__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var historyFilters_HistoryFilters = function (_Component) {
  historyFilters__inherits(HistoryFilters, _Component);

  function HistoryFilters(props) {
    historyFilters__classCallCheck(this, HistoryFilters);

    var _this = historyFilters__possibleConstructorReturn(this, (HistoryFilters.__proto__ || Object.getPrototypeOf(HistoryFilters)).call(this, props));

    Object.defineProperty(_this, 'changeSortOrder', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({
          isSortByDateTime: !_this.state.isSortByDateTime
        }, function () {
          return _this.props.toggleSortByDateTime();
        });
      }
    });
    Object.defineProperty(_this, 'changeShowSpotBot', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$state = _this.state,
            onlyComms = _this$state.onlyComms,
            showSpotBot = _this$state.showSpotBot;

        var checkBoxes = { showSpotBot: !showSpotBot };

        if (onlyComms && showSpotBot) checkBoxes.onlyComms = false;

        _this.setState(checkBoxes, _this.props.toggleEventFilters(checkBoxes));
      }
    });
    Object.defineProperty(_this, 'changeOnlyComms', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$state2 = _this.state,
            onlyComms = _this$state2.onlyComms,
            showSpotBot = _this$state2.showSpotBot;

        var checkBoxes = { onlyComms: !onlyComms };

        if (!onlyComms && !showSpotBot) checkBoxes.showSpotBot = true;

        _this.setState(checkBoxes, _this.props.toggleEventFilters(checkBoxes));
      }
    });


    _this.state = {
      isSortByDateTime: true,
      showSpotBot: true,
      onlyComms: false
    };
    return _this;
  }

  historyFilters__createClass(HistoryFilters, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return react_default.a.createElement(
        'div',
        { className: phaseHistory_default.a.phaseHistorySortContainer },
        react_default.a.createElement(
          'div',
          { className: phaseHistory_default.a.phaseHistorySortDirection },
          'Group By Status ',
          react_default.a.createElement('input', {
            type: 'checkbox',
            className: checkbox_default.a.check,
            checked: !this.state.isSortByDateTime,
            onChange: function onChange() {
              return _this2.changeSortOrder();
            }
          })
        ),
        react_default.a.createElement(
          'div',
          { className: phaseHistory_default.a.phaseHistorySortDirection },
          'Remove Spotbot Events ',
          react_default.a.createElement('input', {
            type: 'checkbox',
            className: checkbox_default.a.check,
            checked: !this.state.showSpotBot,
            onChange: function onChange() {
              return _this2.changeShowSpotBot();
            }
          })
        ),
        react_default.a.createElement(
          'div',
          { className: phaseHistory_default.a.phaseHistorySortDirection },
          'Show Only Communication Events ',
          react_default.a.createElement('input', {
            type: 'checkbox',
            className: checkbox_default.a.check,
            checked: this.state.onlyComms,
            onChange: function onChange() {
              return _this2.changeOnlyComms();
            }
          })
        )
      );
    }
  }]);

  return HistoryFilters;
}(react["Component"]);

historyFilters_HistoryFilters.propTypes = {
  toggleSortByDateTime: prop_types_default.a.func,
  toggleEventFilters: prop_types_default.a.func
};

/* harmony default export */ var historyFilters = (historyFilters_HistoryFilters);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseHistory/index.jsx
function phaseHistory__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function phaseHistory__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function phaseHistory__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var phaseHistory_PhaseHistory = function (_Component) {
  phaseHistory__inherits(PhaseHistory, _Component);

  function PhaseHistory(props) {
    phaseHistory__classCallCheck(this, PhaseHistory);

    var _this = phaseHistory__possibleConstructorReturn(this, (PhaseHistory.__proto__ || Object.getPrototypeOf(PhaseHistory)).call(this, props));

    Object.defineProperty(_this, 'toggleSortByDateTime', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({
          isSortByDateTime: !_this.state.isSortByDateTime
        });
      }
    });
    Object.defineProperty(_this, 'toggleEventFilters', {
      enumerable: true,
      writable: true,
      value: function value(filters) {
        return _this.setState(filters, function () {
          return _this.filterEventsList();
        });
      }
    });
    Object.defineProperty(_this, 'filterEventsList', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$state = _this.state,
            onlyComms = _this$state.onlyComms,
            showSpotBot = _this$state.showSpotBot;
        var events = _this.props.phase.events;

        var filteredEvents = [];
        if (onlyComms && showSpotBot) {
          filteredEvents = events.filter(function (event) {
            return event.kind.includes('communication');
          });
        } else if (!onlyComms && !showSpotBot) {
          filteredEvents = events.filter(function (event) {
            return event.user !== 'SPOTBOT';
          });
        } else {
          filteredEvents = events;
        }
        filteredEvents = filteredEvents.filter(function (event) {
          return event.kind !== 'api';
        });
        return filteredEvents;
      }
    });
    Object.defineProperty(_this, 'groupEvents', {
      enumerable: true,
      writable: true,
      value: function value() {
        var scopedEvents = {};
        var events = _this.filterEventsList();
        if (_this.state.isSortByDateTime) {
          scopedEvents['All Statuses'] = events;
          return scopedEvents;
        }
        events.forEach(function (event) {
          var scopeName = event.status;
          if (!scopedEvents[scopeName]) scopedEvents[scopeName] = [];
          scopedEvents[scopeName].push(event);
        });
        return scopedEvents;
      }
    });
    Object.defineProperty(_this, 'renderHistoryList', {
      enumerable: true,
      writable: true,
      value: function value() {
        var scopedEvents = _this.groupEvents();
        return Object.keys(scopedEvents).map(function (name, i) {
          return react_default.a.createElement(
            'div',
            { key: name },
            react_default.a.createElement(components_PhaseHistoryCard, {
              name: name,
              events: scopedEvents[name],
              collapsed: i > 0,
              isSortByDateTime: _this.state.isSortByDateTime,
              phase: _this.props.phase,
              isPhaseHistoryTab: true
            })
          );
        });
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        return react_default.a.createElement(
          'section',
          { className: phaseHistory_default.a.phaseHistoryContainer },
          react_default.a.createElement(historyFilters, {
            toggleSortByDateTime: _this.toggleSortByDateTime,
            toggleEventFilters: _this.toggleEventFilters
          }),
          _this.renderHistoryList()
        );
      }
    });

    _this.state = {
      isSortByDateTime: true,
      showSpotBot: true,
      onlyComms: false
    };
    _this.toggleSortByDateTime = _this.toggleSortByDateTime.bind(_this);
    _this.toggleEventFilters = _this.toggleEventFilters.bind(_this);
    return _this;
  }

  return PhaseHistory;
}(react["Component"]);

phaseHistory_PhaseHistory.defaultProps = { phase: {} };

phaseHistory_PhaseHistory.propTypes = { phase: types_phase.isRequired };

var phaseHistory_mapStateToProps = function mapStateToProps(state) {
  return { phase: state.phase.details };
};

/* harmony default export */ var tabs_phaseHistory = (Object(react_redux_es["connect"])(phaseHistory_mapStateToProps)(phaseHistory_PhaseHistory));
// EXTERNAL MODULE: ./client/app/shared/components/CollapsableCard/styles.scss
var CollapsableCard_styles = __webpack_require__("2QBa");
var CollapsableCard_styles_default = /*#__PURE__*/__webpack_require__.n(CollapsableCard_styles);

// CONCATENATED MODULE: ./client/app/shared/components/CollapsableCard/index.jsx
function CollapsableCard__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function CollapsableCard__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function CollapsableCard__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var CollapsableCard_CollapsableCard = function (_Component) {
  CollapsableCard__inherits(CollapsableCard, _Component);

  function CollapsableCard(props) {
    CollapsableCard__classCallCheck(this, CollapsableCard);

    var _this = CollapsableCard__possibleConstructorReturn(this, (CollapsableCard.__proto__ || Object.getPrototypeOf(CollapsableCard)).call(this, props));

    Object.defineProperty(_this, 'toggleExpand', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ isExpanded: !_this.state.isExpanded });
      }
    });
    Object.defineProperty(_this, 'renderActions', {
      enumerable: true,
      writable: true,
      value: function value() {
        /**
         * Sorting to guarantee the order of actions doesn't
         * change based on which are avialable
         */
        var actions = Object(lodash["sortBy"])(_this.props.actions, ['text']);
        return actions.map(function (action) {
          var text = action.text,
              icon = action.icon,
              toolTipMessage = action.toolTipMessage,
              onClick = action.onClick,
              _action$className = action.className,
              className = _action$className === undefined ? '' : _action$className;

          if (!['Approve', 'edit', 'done', 'Copy Labor Lines', 'Merge to Original'].includes(text)) {
            return react_default.a.createElement(
              'div',
              {
                key: icon,
                className: classnames_default()(CollapsableCard_styles_default.a.disabledButton, CollapsableCard_styles_default.a[icon], className)
              },
              react_default.a.createElement(react_toolbox_lib["FontIcon"], {
                key: icon,
                value: icon,
                className: CollapsableCard_styles_default.a.cardIcon
              }),
              toolTipMessage ? react_default.a.createElement(
                'span',
                { 'data-tip': true, 'data-for': 'anchor-element', className: CollapsableCard_styles_default.a.actionText + ' ' + CollapsableCard_styles_default.a.disabledText },
                text
              ) : react_default.a.createElement(
                'span',
                { className: CollapsableCard_styles_default.a.actionText + ' ' + CollapsableCard_styles_default.a.disabledText },
                text
              ),
              react_default.a.createElement(
                react_tooltip_dist_default.a,
                { id: 'anchor-element' },
                react_default.a.createElement(
                  'span',
                  null,
                  toolTipMessage
                )
              )
            );
          }
          return react_default.a.createElement(
            'button',
            {
              id: '' + _this.props.actionBtnPrefix + text,
              key: icon,
              className: classnames_default()(CollapsableCard_styles_default.a.cardButton, CollapsableCard_styles_default.a[icon], _this.props.theme.cardAction, className),
              onClick: onClick
            },
            react_default.a.createElement(react_toolbox_lib["FontIcon"], {
              key: icon,
              value: icon,
              className: CollapsableCard_styles_default.a.cardIcon
            }),
            react_default.a.createElement(
              'span',
              { className: CollapsableCard_styles_default.a.actionText },
              text
            )
          );
        });
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            title = _this$props.title,
            titleNote = _this$props.titleNote,
            startsExpanded = _this$props.startsExpanded,
            headerStyles = _this$props.headerStyles,
            theme = _this$props.theme;

        var icon = _this.state.isExpanded && startsExpanded ? 'arrow_drop_up' : 'arrow_drop_down';
        var headerClass = classnames_default()(CollapsableCard_styles_default.a.cardContentPadding, theme.cardHeader, headerStyles);
        return react_default.a.createElement(
          components_Card,
          { className: theme.cardContainer },
          react_default.a.createElement(
            'div',
            { className: headerClass },
            react_default.a.createElement(
              'span',
              { className: theme.cardTitle },
              title
            ),
            react_default.a.createElement(
              'span',
              { className: CollapsableCard_styles_default.a.cardTitleNote },
              titleNote
            ),
            react_default.a.createElement(
              'div',
              { className: CollapsableCard_styles_default.a.receiveReleaseEdit },
              react_default.a.createElement(
                react_responsive_default.a,
                { minWidth: constants["y" /* CUT_POINT */] },
                function (matches) {
                  if (matches) return _this.renderActions();
                  return react_default.a.createElement(
                    'div',
                    { className: CollapsableCard_styles_default.a.actionWrapper },
                    _this.renderActions()
                  );
                }
              )
            ),
            react_default.a.createElement(react_toolbox_lib["FontIcon"], { value: icon, className: theme.cardPointer, onClick: _this.toggleExpand })
          ),
          _this.state.isExpanded && react_default.a.createElement(
            'div',
            { className: theme.cardContentContainer },
            _this.props.children
          )
        );
      }
    });

    _this.state = { isExpanded: true };
    return _this;
  }

  return CollapsableCard;
}(react["Component"]);

CollapsableCard_CollapsableCard.defaultProps = {
  title: 'Title',
  titleNote: '',
  actions: [],
  startsExpanded: true
};

CollapsableCard_CollapsableCard.propTypes = {
  startsExpanded: prop_types_default.a.bool,
  title: prop_types_default.a.node,
  titleNote: prop_types_default.a.string,
  children: prop_types_default.a.node,
  headerStyles: prop_types_default.a.string,
  actionBtnPrefix: prop_types_default.a.string,
  actions: prop_types_default.a.arrayOf(prop_types_default.a.shape({
    icon: prop_types_default.a.string,
    onClick: prop_types_default.a.func
  })),
  theme: prop_types_default.a.shape({
    cardContainer: prop_types_default.a.string,
    cardTitle: prop_types_default.a.string,
    cardHeader: prop_types_default.a.string,
    cardAction: prop_types_default.a.string,
    cardPointer: prop_types_default.a.string,
    cardContentContainer: prop_types_default.a.string
  })
};

/* harmony default export */ var components_CollapsableCard = (Object(react_css_themr_lib["themr"])('CollapsableCard', CollapsableCard_styles_default.a)(CollapsableCard_CollapsableCard));
// CONCATENATED MODULE: ./client/app/shared/components/LineItemTable/index.jsx
function LineItemTable__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function LineItemTable__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function LineItemTable__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var LineItemTable_LineItemTable = function (_Component) {
  LineItemTable__inherits(LineItemTable, _Component);

  function LineItemTable(props) {
    LineItemTable__classCallCheck(this, LineItemTable);

    var _this = LineItemTable__possibleConstructorReturn(this, (LineItemTable.__proto__ || Object.getPrototypeOf(LineItemTable)).call(this, props));

    Object.defineProperty(_this, 'onEditClick', {
      enumerable: true,
      writable: true,
      value: function value(event) {
        event.stopPropagation();
        var _this$props = _this.props,
            requestLineItemList = _this$props.requestLineItemList,
            _this$props$toggleEdi = _this$props.toggleEditMode,
            toggleEditMode = _this$props$toggleEdi === undefined ? null : _this$props$toggleEdi;

        if (requestLineItemList) _this.props.requestLineItemList();
        if (toggleEditMode !== null) toggleEditMode(true);
        _this.runLPAStep3();
        _this.setState({
          isInEditMode: true,
          actions: [{ icon: 'done', text: 'done', onClick: _this.onDoneClick }]
        });
      }
    });
    Object.defineProperty(_this, 'onDoneClick', {
      enumerable: true,
      writable: true,
      value: function value(event) {
        var _this$props2 = _this.props,
            _this$props2$toggleEd = _this$props2.toggleEditMode,
            toggleEditMode = _this$props2$toggleEd === undefined ? null : _this$props2$toggleEd,
            cv = _this$props2.cv;

        event.stopPropagation();
        if (toggleEditMode !== null) toggleEditMode(false);
        _this.setState({
          isInEditMode: false,
          actions: [{ icon: 'mode_edit', text: 'edit', onClick: _this.onEditClick }]
        });
        _this.props.refreshList();
        /*
         * This is needed for now because sometimes a given table is updated even
         * if the props are not, so displayed values are not what they should be.
         */
        if (!cv) window.location.reload();
      }
    });
    Object.defineProperty(_this, 'runLPAStep3', {
      enumerable: true,
      writable: true,
      value: function value() {
        var step3Btn = document.getElementById('runStep3Btn');
        if (step3Btn) step3Btn.click();
      }
    });
    Object.defineProperty(_this, 'createNewChildren', {
      enumerable: true,
      writable: true,
      value: function value() {
        var newChildren = [];
        _this.props.children.forEach(function (child) {
          return child.props.children.forEach(function (ch) {
            return newChildren.push(ch);
          });
        });
        return newChildren;
      }
    });
    Object.defineProperty(_this, 'handleScroll', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.accountingTable ? null : _this.setState({ makeSticky: true });
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$state = _this.state,
            isInEditMode = _this$state.isInEditMode,
            stateActions = _this$state.actions,
            makeSticky = _this$state.makeSticky;
        var _this$props3 = _this.props,
            total = _this$props3.total,
            title = _this$props3.title,
            titleNote = _this$props3.titleNote,
            children = _this$props3.children,
            readOnly = _this$props3.readOnly,
            editableOnly = _this$props3.editableOnly,
            actions = _this$props3.actions,
            editableActions = _this$props3.editableActions,
            footer = _this$props3.footer,
            canViewTotal = _this$props3.canViewTotal,
            hasCreatableRow = _this$props3.hasCreatableRow,
            diffChildren = _this$props3.diffChildren,
            actionBtnPrefix = _this$props3.actionBtnPrefix,
            adminTable = _this$props3.adminTable;

        window.onscroll = _this.handleScroll;
        var noShowEdit = readOnly || editableOnly;
        var cardActions = noShowEdit ? [] : stateActions;
        cardActions = cardActions.concat(isInEditMode ? editableActions : actions);
        var displayedTotal = total > 0 ? total.toFixed(2) : '0.00';
        return react_default.a.createElement(
          components_CollapsableCard,
          {
            actionBtnPrefix: actionBtnPrefix,
            title: title,
            titleNote: titleNote,
            actions: cardActions
          },
          react_default.a.createElement(
            'div',
            { id: 'tableWrapper', className: table_default.a.tableWrapper },
            react_default.a.createElement(
              editableTable,
              {
                isEditable: isInEditMode,
                hasCreatableRow: hasCreatableRow,
                title: title,
                makeSticky: makeSticky
              },
              diffChildren ? _this.createNewChildren() : children
            ),
            !adminTable && canViewTotal && react_default.a.createElement(
              'div',
              { className: table_default.a.totalContainer },
              react_default.a.createElement(
                'div',
                { className: table_default.a.total },
                'Total: $',
                displayedTotal
              )
            ),
            footer && footer
          )
        );
      }
    });

    _this.state = {
      isInEditMode: _this.props.editableOnly,
      actions: [{ icon: 'mode_edit', text: 'edit', onClick: _this.onEditClick }],
      makeSticky: false
    };
    return _this;
  }

  return LineItemTable;
}(react["Component"]);

LineItemTable_LineItemTable.defaultProps = {
  total: 0,
  readOnly: false,
  editableOnly: false,
  hasCreatableRow: true,
  editableActions: [],
  actions: [],
  canViewTotal: true,
  cv: false,
  accountingTable: false,
  adminTable: false
};

LineItemTable_LineItemTable.propTypes = {
  children: prop_types_default.a.node.isRequired,
  title: prop_types_default.a.node,
  titleNote: prop_types_default.a.string,
  requestLineItemList: prop_types_default.a.func,
  refreshList: prop_types_default.a.func,
  toggleEditMode: prop_types_default.a.func,
  total: prop_types_default.a.number,
  readOnly: prop_types_default.a.bool,
  editableOnly: prop_types_default.a.bool,
  hasCreatableRow: prop_types_default.a.bool,
  editableActions: prop_types_default.a.array,
  actions: prop_types_default.a.array,
  footer: prop_types_default.a.node,
  canViewTotal: prop_types_default.a.bool,
  diffChildren: prop_types_default.a.bool,
  actionBtnPrefix: prop_types_default.a.string,
  cv: prop_types_default.a.bool,
  accountingTable: prop_types_default.a.bool,
  adminTable: prop_types_default.a.bool
};

/* harmony default export */ var components_LineItemTable = (LineItemTable_LineItemTable);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/components/lineItemStatus.jsx
function lineItemStatus__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function lineItemStatus__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function lineItemStatus__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var lineItemStatus_LineItemStatus = function (_Component) {
  lineItemStatus__inherits(LineItemStatus, _Component);

  function LineItemStatus() {
    var _ref;

    var _temp, _this, _ret;

    lineItemStatus__classCallCheck(this, LineItemStatus);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = lineItemStatus__possibleConstructorReturn(this, (_ref = LineItemStatus.__proto__ || Object.getPrototypeOf(LineItemStatus)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'handleStatusChange', {
      enumerable: true,
      writable: true,
      value: function value(option) {
        var lineItem = _this.props.lineItem;
        lineItem.status = option.value;
        _this.props.onChange(lineItem);
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            lineItem = _this$props.lineItem,
            options = _this$props.options,
            cellReadOnly = _this$props.cellReadOnly;

        var selectOptions = options.map(function (option) {
          return { value: option, label: option };
        });
        return cellReadOnly ? react_default.a.createElement(
          react["Fragment"],
          null,
          lineItem.status
        ) : react_default.a.createElement(Select_default.a, {
          autoSize: false,
          onChange: _this.handleStatusChange,
          options: selectOptions,
          className: '' + react_select_styles_default.a.prettyDropDown,
          value: lineItem.status,
          clearable: false
        });
      }
    }), _temp), lineItemStatus__possibleConstructorReturn(_this, _ret);
  }

  return LineItemStatus;
}(react["Component"]);

lineItemStatus_LineItemStatus.defaultProps = { cellReadOnly: false };

lineItemStatus_LineItemStatus.propTypes = {
  lineItem: prop_types_default.a.object,
  onChange: prop_types_default.a.func,
  options: prop_types_default.a.arrayOf(prop_types_default.a.string),
  cellReadOnly: prop_types_default.a.bool
};

/* harmony default export */ var lineItemStatus = (lineItemStatus_LineItemStatus);
// CONCATENATED MODULE: ./client/app/shared/components/LineItemTable/inputCell.jsx








var inputCell_InputCell = function InputCell(_ref) {
  var lineItem = _ref.lineItem,
      attr = _ref.attr,
      label = _ref.label,
      onChange = _ref.onChange,
      cellValue = _ref.cellValue,
      type = _ref.type,
      className = _ref.className,
      cellReadOnly = _ref.cellReadOnly;

  var value = lineItem[attr];
  var error = lineItem.errors && lineItem.errors[attr] && Object(utils["c" /* error */])(attr, lineItem.errors);
  var cellVal = value === null || cellValue === null ? '' : cellValue || value;
  var cellProps = { label: label, onChange: onChange, error: error, value: cellVal, cellReadOnly: cellReadOnly };
  return react_default.a.createElement(
    editableTableCell,
    cellProps,
    react_default.a.createElement('input', {
      type: type,
      value: value === null ? '' : value,
      className: classnames_default()(input_default.a.inputElement, table_default.a.input, className)
    })
  );
};

inputCell_InputCell.defaultProps = {
  cellValue: '',
  display: true,
  type: 'text',
  className: '',
  cellReadOnly: false
};

inputCell_InputCell.propTypes = {
  lineItem: prop_types_default.a.object.isRequired,
  display: prop_types_default.a.bool,
  attr: prop_types_default.a.string.isRequired,
  label: prop_types_default.a.string.isRequired,
  onChange: prop_types_default.a.func.isRequired,
  cellValue: prop_types_default.a.node,
  type: prop_types_default.a.string,
  className: prop_types_default.a.string,
  cellReadOnly: prop_types_default.a.bool
};

/* harmony default export */ var inputCell = (inputCell_InputCell);
// EXTERNAL MODULE: ./client/app/shared/components/LineItemTable/components/eventTable.scss
var eventTable = __webpack_require__("fyNL");
var eventTable_default = /*#__PURE__*/__webpack_require__.n(eventTable);

// CONCATENATED MODULE: ./client/app/shared/components/LineItemTable/components/eventTable.jsx








var eventTable_formatValue = function formatValue(value) {
  if (Object(dateUtils["q" /* isValidDate */])(value)) return Object(dateUtils["m" /* getSimpleLocalDate */])(value);
  return value.toString();
};

var eventTable_parseValue = function parseValue(value, keys) {
  if (Object(lodash["isNil"])(value)) return '';
  if (!Object(lodash["isObject"])(value) || keys.length === 1) return eventTable_formatValue(value);
  if (!Object(lodash["has"])(value, keys[1])) return '';
  return parseValue(value[keys[1]], keys.slice(1));
};

var getValue = function getValue(data, key) {
  var keys = key.split('.');
  return eventTable_parseValue(data[keys[0]], keys);
};

var eventTable_EventTable = function EventTable(_ref) {
  var events = _ref.events,
      dataKeys = _ref.dataKeys;
  return react_default.a.createElement(
    'table',
    { className: eventTable_default.a.table },
    react_default.a.createElement(
      'thead',
      null,
      react_default.a.createElement(
        'tr',
        null,
        react_default.a.createElement(
          'th',
          { className: eventTable_default.a.header },
          'User'
        ),
        react_default.a.createElement(
          'th',
          { className: eventTable_default.a.header },
          'Updated'
        ),
        dataKeys.map(function (key) {
          return react_default.a.createElement(
            'th',
            { className: eventTable_default.a.header, key: key },
            Object(utils["B" /* titleize */])(key)
          );
        })
      )
    ),
    react_default.a.createElement(
      'tbody',
      null,
      events.map(function (event) {
        return react_default.a.createElement(
          'tr',
          { key: event.id },
          react_default.a.createElement(
            'td',
            { className: eventTable_default.a.data },
            event.user
          ),
          react_default.a.createElement(
            'td',
            { className: eventTable_default.a.data },
            Object(dateUtils["l" /* getMinLocalDate */])(event.created_at)
          ),
          dataKeys.map(function (key) {
            return react_default.a.createElement(
              'td',
              { className: eventTable_default.a.data, key: key },
              getValue(event.data, key)
            );
          })
        );
      })
    )
  );
};

eventTable_EventTable.defaultProps = { dataKeys: [], events: [] };

eventTable_EventTable.propTypes = {
  dataKeys: prop_types_default.a.arrayOf(prop_types_default.a.string).isRequired,
  events: prop_types_default.a.arrayOf(types_event).isRequired,
  levelerEvents: prop_types_default.a.bool.isRequired
};

/* harmony default export */ var components_eventTable = (eventTable_EventTable);
// EXTERNAL MODULE: ./client/app/shared/components/LineItemTable/itemEvents.scss
var LineItemTable_itemEvents = __webpack_require__("NAgv");
var itemEvents_default = /*#__PURE__*/__webpack_require__.n(LineItemTable_itemEvents);

// CONCATENATED MODULE: ./client/app/shared/components/LineItemTable/itemEvents.jsx
var itemEvents__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function itemEvents__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function itemEvents__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function itemEvents__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var itemEvents_theme = { RTDialog: itemEvents_default.a };

var itemEvents_ItemEvents = function (_Component) {
  itemEvents__inherits(ItemEvents, _Component);

  function ItemEvents() {
    var _ref;

    var _temp, _this, _ret;

    itemEvents__classCallCheck(this, ItemEvents);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = itemEvents__possibleConstructorReturn(this, (_ref = ItemEvents.__proto__ || Object.getPrototypeOf(ItemEvents)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'state', {
      enumerable: true,
      writable: true,
      value: { active: false }
    }), Object.defineProperty(_this, 'toggleActive', {
      enumerable: true,
      writable: true,
      value: function value() {
        var active = !_this.state.active;
        if (!_this.props.levelerEvents) _this.loadEvents();
        _this.setState({ active: active });
      }
    }), Object.defineProperty(_this, 'loadEvents', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.requestPhaseItemEventList(_this.props.itemType, _this.props.lineItem);
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var active = _this.state.active;
        var _this$props = _this.props,
            display = _this$props.display,
            lineItem = _this$props.lineItem,
            levelerItem = _this$props.levelerItem,
            loading = _this$props.loading,
            dataKeys = _this$props.dataKeys,
            canView = _this$props.canView,
            levelerEvents = _this$props.levelerEvents;

        if (!display) return null;
        if (!canView) return react_default.a.createElement('td', { className: itemEvents_default.a.container });
        var itemEvents = [];
        var events = [];
        if (levelerEvents) {
          itemEvents = levelerItem.events || [];
          events = itemEvents || [];
        } else {
          itemEvents = lineItem.events || [];
          events = itemEvents || [];
        }
        if (dataKeys.includes('cut_quantity')) {
          itemEvents.forEach(function (event, index) {
            if (event.data && event.data.cut_quantity) {
              var newEvent = itemEvents__extends({}, event, {
                data: itemEvents__extends({}, event.data, {
                  cut_quantity: Object(lineItemUtils["d" /* cutQuantityString */])(event.data.warehouse_quantity)
                })
              });
              events[index] = newEvent; // Replace the event in the same index
            }
          });
        }
        return react_default.a.createElement(
          'td',
          { className: itemEvents_default.a.container },
          react_default.a.createElement(react_toolbox_lib["FontIcon"], { value: 'ic_history', className: itemEvents_default.a.history_icon, onClick: _this.toggleActive }),
          active && react_default.a.createElement(
            react_css_themr_lib["ThemeProvider"],
            { theme: itemEvents_theme },
            react_default.a.createElement(
              react_toolbox_lib["Dialog"],
              { active: active, onEscKeyDown: _this.toggleActive },
              react_default.a.createElement(react_toolbox_lib["FontIcon"], { value: 'close', className: itemEvents_default.a.close_icon, onClick: _this.toggleActive }),
              loading && react_default.a.createElement(components_Loading, null),
              !loading && react_default.a.createElement(components_eventTable, {
                events: events,
                dataKeys: dataKeys
              })
            )
          )
        );
      }
    }), _temp), itemEvents__possibleConstructorReturn(_this, _ret);
  }

  return ItemEvents;
}(react["Component"]);

itemEvents_ItemEvents.defaultProps = {
  dataKeys: [],
  levelerEvents: false,
  lineItem: null,
  levelerItem: null
};

itemEvents_ItemEvents.propTypes = {
  display: prop_types_default.a.bool.isRequired,
  itemType: prop_types_default.a.string.isRequired,
  lineItem: prop_types_default.a.object,
  levelerItem: prop_types_default.a.object,
  label: prop_types_default.a.string.isRequired,
  requestPhaseItemEventList: prop_types_default.a.func.isRequired,
  loading: prop_types_default.a.bool.isRequired,
  dataKeys: prop_types_default.a.arrayOf(prop_types_default.a.string).isRequired,
  canView: prop_types_default.a.bool.isRequired,
  levelerEvents: prop_types_default.a.bool
};

/* harmony default export */ var components_LineItemTable_itemEvents = (Object(react_redux_es["connect"])(function (state, ownProps) {
  return {
    loading: state.phase[ownProps.itemType].loading,
    canView: Object(services["a" /* can */])(Object(reducers["_12" /* getRole */])(state), 'view', 'event')
  };
}, { requestPhaseItemEventList: actionCreators["_16" /* requestPhaseItemEventList */] })(itemEvents_ItemEvents));
// CONCATENATED MODULE: ./client/app/shared/components/LineItemTable/dropDownCell.jsx
var dropDownCell__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };









var dropDownCell_DropdownCell = function DropdownCell(props) {
  var lineItem = props.lineItem,
      attr = props.attr,
      label = props.label,
      options = props.options,
      onChange = props.onChange,
      cellValue = props.cellValue,
      display = props.display,
      isIdAttr = props.isIdAttr,
      clearable = props.clearable,
      children = props.children;

  var valueAttr = isIdAttr ? attr + '_id' : attr;
  var selectValue = lineItem[valueAttr] || '';
  var value = cellValue || children || selectValue;
  var error = lineItem.errors && lineItem.errors[attr] && Object(utils["c" /* error */])(attr, lineItem.errors);
  var cellProps = { display: display, label: label, value: value, error: error };
  return react_default.a.createElement(
    editableTableCell,
    dropDownCell__extends({}, cellProps, {
      onChange: onChange,
      className: table_default.a.largeColumn
    }),
    react_default.a.createElement(Select_default.a, {
      autoSize: false,
      options: options,
      value: selectValue,
      simpleValue: true,
      matchProp: 'label',
      className: react_select_styles_default.a.prettyDropDown,
      clearable: clearable,
      backspaceRemoves: clearable,
      deleteRemoves: clearable
    })
  );
};

dropDownCell_DropdownCell.defaultProps = {
  cellValue: '',
  display: true,
  isIdAttr: false,
  clearable: false
};

dropDownCell_DropdownCell.propTypes = {
  lineItem: prop_types_default.a.object.isRequired,
  display: prop_types_default.a.bool,
  attr: prop_types_default.a.string.isRequired,
  label: prop_types_default.a.string.isRequired,
  onChange: prop_types_default.a.func.isRequired,
  cellValue: prop_types_default.a.node,
  options: prop_types_default.a.arrayOf(prop_types_default.a.object).isRequired,
  isIdAttr: prop_types_default.a.bool,
  clearable: prop_types_default.a.bool,
  children: prop_types_default.a.node
};

/* harmony default export */ var dropDownCell = (dropDownCell_DropdownCell);
// EXTERNAL MODULE: ./client/app/shared/components/LineItemTable/documentLink.scss
var LineItemTable_documentLink = __webpack_require__("ewgj");
var documentLink_default = /*#__PURE__*/__webpack_require__.n(LineItemTable_documentLink);

// CONCATENATED MODULE: ./client/app/shared/components/LineItemTable/documentLink.jsx





var LineItemTable_documentLink_DocumentLink = function DocumentLink(_ref) {
  var documents = _ref.documents,
      id = _ref.id;

  var document = documents.find(function (doc) {
    return doc.id === id;
  });
  if (!document) return null;
  return react_default.a.createElement(
    'a',
    { target: '_blank', rel: 'noopener noreferrer', href: document.expiring_download_url },
    document.document_name,
    document.not_use && react_default.a.createElement(
      'span',
      { className: documentLink_default.a.notUse },
      ' (Do not use)'
    )
  );
};

LineItemTable_documentLink_DocumentLink.propTypes = {
  documents: prop_types_default.a.arrayOf(documentUpload).isRequired,
  id: prop_types_default.a.string
};

/* harmony default export */ var components_LineItemTable_documentLink = (LineItemTable_documentLink_DocumentLink);
// CONCATENATED MODULE: ./client/app/shared/types/contractorChargebackItem.js


/* harmony default export */ var contractorChargebackItem = ({
  id: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]),
  total: prop_types_default.a.number,
  assignee_name: prop_types_default.a.string,
  assignee_id: prop_types_default.a.number,
  assignee_type: prop_types_default.a.string,
  note: prop_types_default.a.string,
  status: prop_types_default.a.string,
  kind: prop_types_default.a.string,
  created_at: prop_types_default.a.string,
  errors: prop_types_default.a.shape({
    total: prop_types_default.a.array,
    note: prop_types_default.a.array,
    status: prop_types_default.a.array,
    kind: prop_types_default.a.array
  })
});
// CONCATENATED MODULE: ./client/app/utils/documents.js
var getCanUseDocumentOptions = function getCanUseDocumentOptions(documents, types) {
  return documents.filter(function (d) {
    return types.indexOf(d.document_type) > -1 && !d.not_use;
  }).map(function (fd) {
    return { label: fd.document_name, value: fd.id };
  });
};

/* harmony default export */ var utils_documents = (getCanUseDocumentOptions);
// CONCATENATED MODULE: ./client/app/shared/mixins/editable.js
var editable__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var editable__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function editable__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function editable__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function editable__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var editable_editableMixin = function editableMixin(Base) {
  return function (_Base) {
    editable__inherits(_class2, _Base);

    function _class2() {
      var _ref;

      var _temp, _this, _ret;

      editable__classCallCheck(this, _class2);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = editable__possibleConstructorReturn(this, (_ref = _class2.__proto__ || Object.getPrototypeOf(_class2)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'sanatize', {
        enumerable: true,
        writable: true,
        value: function value(attr, val) {
          var value = Object(lodash["has"])(val, 'target') ? val.target.value : val;
          if (attr === 'total') value = value ? parseFloat(value) : '';
          return value;
        }
      }), _temp), editable__possibleConstructorReturn(_this, _ret);
    }

    editable__createClass(_class2, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps, nextContext) {
        var errors = (nextProps.lineItem || null) && Object(lodash["has"])(nextProps.lineItem || nextProps.levelerItem, 'errors') ? editable__extends({}, nextProps.lineItem.errors) : {};
        if (nextContext.isEditable && !Object(lodash["isEqual"])(this.state.errors, nextProps.lineItem)) {
          this.setState({ errors: errors });
        } else if (!nextContext.isEditable && !Object(lodash["isEqual"])(this.state, nextProps.lineItem)) {
          this.setState(editable__extends({}, nextProps.lineItem, { errors: errors }));
        }
      }
    }]);

    return _class2;
  }(Base);
};

/* harmony default export */ var mixins_editable = (editable_editableMixin);
// EXTERNAL MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseAccounting/components/laborTables.scss
var laborTables = __webpack_require__("G/CU");
var laborTables_default = /*#__PURE__*/__webpack_require__.n(laborTables);

// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseAccounting/components/contractorChargebackRow.jsx
var contractorChargebackRow__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function contractorChargebackRow__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function contractorChargebackRow__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function contractorChargebackRow__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function contractorChargebackRow__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }























var CHARGEBACK_STATUSES = ['Pending Review', 'Ready for Accounting', 'Recorded', 'Uncollectable - Reviewed'];
var RESTRICTED_CHARGEBACK_STATUSES = ['Pending Review', 'Ready for Accounting'];
var SIGNED_DOCUMENT_TYPES = ['Signed Documents'];
var CHARGEBACK_REASONS = [{ label: 'Vendor Debit', value: 'Vendor Debit' }, { label: 'Compliance', value: 'Compliance' }, { label: 'Property Damage', value: 'Property Damage' }, { label: 'Poor Craftsmanship', value: 'Poor Craftsmanship' }, { label: 'Customer Compensation', value: 'Customer Compensation' }, { label: 'Estimator Error', value: 'Estimator Error' }, { label: 'SPIG', value: 'SPIG' }];

var contractorChargebackRow_ContractorChargebackRow = function (_Editable) {
  contractorChargebackRow__inherits(ContractorChargebackRow, _Editable);

  function ContractorChargebackRow() {
    var _ref;

    var _temp, _this, _ret;

    contractorChargebackRow__classCallCheck(this, ContractorChargebackRow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = contractorChargebackRow__possibleConstructorReturn(this, (_ref = ContractorChargebackRow.__proto__ || Object.getPrototypeOf(ContractorChargebackRow)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'state', {
      enumerable: true,
      writable: true,
      value: contractorChargebackRow__extends({}, _this.props.lineItem)
    }), Object.defineProperty(_this, 'handleChange', {
      enumerable: true,
      writable: true,
      value: function value(attr) {
        return function (val) {
          return _this.setState(contractorChargebackRow__defineProperty({}, attr, _this.sanatize(attr, val)));
        };
      }
    }), Object.defineProperty(_this, 'handleTotalChange', {
      enumerable: true,
      writable: true,
      value: _this.handleChange('total')
    }), Object.defineProperty(_this, 'handleNoteChange', {
      enumerable: true,
      writable: true,
      value: _this.handleChange('note')
    }), Object.defineProperty(_this, 'handlePaymentPlanChange', {
      enumerable: true,
      writable: true,
      value: _this.handleChange('payment_plan')
    }), Object.defineProperty(_this, 'handleSignedDocumentChange', {
      enumerable: true,
      writable: true,
      value: _this.handleChange('signed_document_id')
    }), Object.defineProperty(_this, 'handleReasonChange', {
      enumerable: true,
      writable: true,
      value: _this.handleChange('reason')
    }), Object.defineProperty(_this, 'handleAssigneeChange', {
      enumerable: true,
      writable: true,
      value: function value(val) {
        return _this.setState({
          assignee_id: _this.getAssigneeChangeValue(val, 'employable_id'),
          assignee_type: _this.getAssigneeChangeValue(val, 'employable_type')
        });
      }
    }), Object.defineProperty(_this, 'getAssigneeChangeValue', {
      enumerable: true,
      writable: true,
      value: function value(val, key) {
        return val ? val[key] : null;
      }
    }), Object.defineProperty(_this, 'getIsAccOrAdmin', {
      enumerable: true,
      writable: true,
      value: function value() {
        return ['accounting', 'admin'].includes(_this.props.role);
      }
    }), Object.defineProperty(_this, 'getLineItemStatusVal', {
      enumerable: true,
      writable: true,
      value: function value() {
        var lineItem = _this.state;
        var onSave = _this.props.onSave;

        var isAccOrAdmin = _this.getIsAccOrAdmin();
        var isPendingOrReady = RESTRICTED_CHARGEBACK_STATUSES.indexOf(lineItem.status) !== -1;
        var cellReadOnly = _this.statusReadOnly(_this.props.readOnly, lineItem.status);
        if (isAccOrAdmin) {
          return react_default.a.createElement(lineItemStatus, {
            onChange: onSave,
            lineItem: lineItem,
            options: CHARGEBACK_STATUSES,
            cellReadOnly: cellReadOnly
          });
        } else if (!isAccOrAdmin && isPendingOrReady) {
          return react_default.a.createElement(lineItemStatus, {
            onChange: onSave,
            lineItem: lineItem,
            options: RESTRICTED_CHARGEBACK_STATUSES,
            cellReadOnly: cellReadOnly
          });
        }
        return lineItem.status;
      }
    }), Object.defineProperty(_this, 'handleSave', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.onSave(_this.state);
      }
    }), Object.defineProperty(_this, 'handleDelete', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.onDelete(_this.state.id);
      }
    }), Object.defineProperty(_this, 'formatOptions', {
      enumerable: true,
      writable: true,
      value: function value(options) {
        return options.map(function (option) {
          return { value: option, label: option };
        });
      }
    }), Object.defineProperty(_this, 'statusReadOnly', {
      enumerable: true,
      writable: true,
      value: function value(propReadOnly, status) {
        return propReadOnly || !_this.getIsAccOrAdmin() && status === 'Ready for Accounting';
      }
    }), Object.defineProperty(_this, 'renderAssigneeCell', {
      enumerable: true,
      writable: true,
      value: function value() {
        var lineItem = _this.state;
        var cellValue = lineItem.assignee_id ? lineItem.assignee_name + ' - ' + lineItem.assignee_type : 'In House';
        var initialValues = lineItem.assignee_id ? contractorChargebackRow__defineProperty({}, '' + lineItem.assignee_type.toLowerCase(), [lineItem.assignee_id]) : {};
        var err = lineItem.errors && lineItem.errors.assignee && Object(utils["c" /* error */])('assignee', lineItem.errors);
        var cellProps = { label: 'Company to be Charged', value: cellValue, error: err };
        return react_default.a.createElement(
          editableTableCell,
          contractorChargebackRow__extends({}, cellProps, {
            onChange: _this.handleAssigneeChange,
            className: table_default.a.largeColumn
          }),
          react_default.a.createElement(components_UserSearch, {
            placeholder: 'Type to search',
            defaultOptions: [{ value: null, label: 'In House' }],
            employableType: ['Estimator', 'Installer', 'IQM'],
            initialValues: initialValues,
            className: table_default.a.lineItemSelect
          })
        );
      }
    }), Object.defineProperty(_this, 'renderStatusCell', {
      enumerable: true,
      writable: true,
      value: function value() {
        return react_default.a.createElement(editableTableCell, {
          display: !_this.context.isEditable,
          label: 'Status',
          value: _this.getLineItemStatusVal(),
          className: table_default.a.largeColumn,
          cellReadOnly: _this.statusReadOnly(_this.props.readOnly, _this.state.status)
        });
      }
    }), Object.defineProperty(_this, 'renderTableDesktop', {
      enumerable: true,
      writable: true,
      value: function value() {
        var lineItem = _this.state;
        var _this$props = _this.props,
            documents = _this$props.documents,
            readOnly = _this$props.readOnly;

        var rowProps = {
          isNew: lineItem.id < 0,
          onSave: _this.handleSave,
          onDelete: _this.handleDelete,
          readOnly: _this.statusReadOnly(readOnly, lineItem.status)
        };
        var documentOptions = utils_documents(documents, SIGNED_DOCUMENT_TYPES);
        return react_default.a.createElement(
          editableTableRow,
          contractorChargebackRow__extends({ key: lineItem.id, id: lineItem.id, deleteDialog: true }, rowProps),
          react_default.a.createElement(components_LineItemTable_itemEvents, {
            display: !_this.context.isEditable,
            label: '',
            itemType: 'contractorChargebackItems',
            lineItem: lineItem,
            dataKeys: ['assignee_name', 'assignee_type', 'note', 'total', 'status', 'reason']
          }),
          _this.renderAssigneeCell(),
          react_default.a.createElement(
            dropDownCell,
            {
              attr: 'signed_document',
              isIdAttr: true,
              label: 'Signed Document',
              lineItem: lineItem,
              options: documentOptions,
              onChange: _this.handleSignedDocumentChange,
              clearable: true
            },
            react_default.a.createElement(components_LineItemTable_documentLink, { documents: documents, id: lineItem.signed_document_id })
          ),
          react_default.a.createElement(dropDownCell, {
            attr: 'reason',
            label: 'Chargeback Reason',
            lineItem: lineItem,
            options: CHARGEBACK_REASONS,
            onChange: _this.handleReasonChange,
            clearable: true
          }),
          react_default.a.createElement(inputCell, { type: 'number', attr: 'payment_plan', label: 'Payment Plan', lineItem: lineItem, onChange: _this.handlePaymentPlanChange, cellValue: Object(lineItemUtils["g" /* formatDollars */])(lineItem.payment_plan) }),
          react_default.a.createElement(inputCell, { type: 'number', attr: 'total', label: 'Total', lineItem: lineItem, onChange: _this.handleTotalChange, cellValue: Object(lineItemUtils["g" /* formatDollars */])(lineItem.total) }),
          _this.renderStatusCell(),
          react_default.a.createElement(editableTableCell, { display: !_this.context.isEditable, label: 'Created', value: Object(dateUtils["m" /* getSimpleLocalDate */])(lineItem.created_at) }),
          react_default.a.createElement(LineItemTable_itemNote, { display: true, label: 'Note', onChange: _this.handleNoteChange, note: lineItem.note, errors: lineItem.errors, id: lineItem.id, readOnly: readOnly })
        );
      }
    }), Object.defineProperty(_this, 'renderTableMobile', {
      enumerable: true,
      writable: true,
      value: function value() {
        var lineItem = _this.state;
        var _this$props2 = _this.props,
            documents = _this$props2.documents,
            readOnly = _this$props2.readOnly;

        var rowProps = {
          isNew: lineItem.id < 0,
          onSave: _this.handleSave,
          onDelete: _this.handleDelete,
          readOnly: _this.statusReadOnly(readOnly, lineItem.status)
        };
        var documentOptions = utils_documents(documents, SIGNED_DOCUMENT_TYPES);
        return react_default.a.createElement(
          editableTableRow,
          contractorChargebackRow__extends({ key: lineItem.id, id: lineItem.id, deleteDialog: true }, rowProps),
          _this.renderAssigneeCell(),
          react_default.a.createElement(
            dropDownCell,
            {
              attr: 'signed_document',
              isIdAttr: true,
              label: 'Signed Document',
              lineItem: lineItem,
              options: documentOptions,
              onChange: _this.handleSignedDocumentChange,
              clearable: true
            },
            react_default.a.createElement(components_LineItemTable_documentLink, { documents: documents, id: lineItem.signed_document_id })
          ),
          react_default.a.createElement(dropDownCell, {
            attr: 'reason',
            label: 'Chargeback Reason',
            lineItem: lineItem,
            options: CHARGEBACK_REASONS,
            onChange: _this.handleReasonChange,
            clearable: true
          }),
          react_default.a.createElement(inputCell, { type: 'number', attr: 'payment_plan', label: 'Payment Plan', lineItem: lineItem, onChange: _this.handlePaymentPlanChange, cellValue: Object(lineItemUtils["g" /* formatDollars */])(lineItem.payment_plan) }),
          react_default.a.createElement(inputCell, { type: 'number', attr: 'total', label: 'Total', lineItem: lineItem, onChange: _this.handleTotalChange, cellValue: Object(lineItemUtils["g" /* formatDollars */])(lineItem.total) }),
          _this.renderStatusCell(),
          react_default.a.createElement(editableTableCell, { display: !_this.context.isEditable, label: 'Created', value: Object(dateUtils["m" /* getSimpleLocalDate */])(lineItem.created_at) }),
          react_default.a.createElement(LineItemTable_itemNote, { display: true, label: 'Note', onChange: _this.handleNoteChange, note: lineItem.note, errors: lineItem.errors, id: lineItem.id, readOnly: readOnly }),
          react_default.a.createElement(
            'td',
            null,
            react_default.a.createElement(
              'div',
              null,
              react_default.a.createElement(
                'table',
                { className: laborTables_default.a.inlineTableItem },
                react_default.a.createElement(
                  'tbody',
                  { className: laborTables_default.a.inlineTableItem },
                  react_default.a.createElement(
                    'tr',
                    { className: laborTables_default.a.iconWrapper },
                    react_default.a.createElement(components_LineItemTable_itemEvents, {
                      display: !_this.context.isEditable,
                      label: '',
                      itemType: 'contractorChargebackItems',
                      lineItem: lineItem,
                      dataKeys: ['assignee_name', 'assignee_type', 'note', 'total', 'status', 'reason']
                    })
                  )
                )
              )
            )
          )
        );
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        return react_default.a.createElement(
          react_responsive_default.a,
          { minWidth: constants["y" /* CUT_POINT */] },
          function (matches) {
            return matches ? _this.renderTableDesktop() : _this.renderTableMobile();
          }
        );
      }
    }), _temp), contractorChargebackRow__possibleConstructorReturn(_this, _ret);
  }

  return ContractorChargebackRow;
}(mixins_editable(react_default.a.Component));

contractorChargebackRow_ContractorChargebackRow.contextTypes = { isEditable: prop_types_default.a.bool };

contractorChargebackRow_ContractorChargebackRow.propTypes = {
  lineItem: prop_types_default.a.shape(contractorChargebackItem),
  onSave: prop_types_default.a.func,
  onDelete: prop_types_default.a.func,
  onChange: prop_types_default.a.func,
  documents: prop_types_default.a.arrayOf(documentUpload).isRequired,
  readOnly: prop_types_default.a.bool,
  role: prop_types_default.a.string
};

contractorChargebackRow_ContractorChargebackRow.defaultProps = {
  lineItem: {},
  assignees: [],
  documents: [],
  readOnly: false
};

/* harmony default export */ var contractorChargebackRow = (contractorChargebackRow_ContractorChargebackRow);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseAccounting/components/contractorChargebackTable.jsx
var contractorChargebackTable__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function contractorChargebackTable__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function contractorChargebackTable__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function contractorChargebackTable__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var LINE_ITEM_TYPE = 'contractorChargebackItems';
var FLAG = {
  name: 'Chargeback to be Reviewed',
  note: 'Chargeback has been entered for review.'
};

var contractorChargebackTable_ContractorChargebackTable = function (_Component) {
  contractorChargebackTable__inherits(ContractorChargebackTable, _Component);

  function ContractorChargebackTable() {
    var _ref;

    var _temp, _this, _ret;

    contractorChargebackTable__classCallCheck(this, ContractorChargebackTable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = contractorChargebackTable__possibleConstructorReturn(this, (_ref = ContractorChargebackTable.__proto__ || Object.getPrototypeOf(ContractorChargebackTable)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'updateFlags', {
      enumerable: true,
      writable: true,
      value: function value(res, lineItem) {
        if (!(res.type.indexOf('_SUCCESS') > -1)) return;

        if (!lineItem.status) {
          var phaseId = _this.props.phaseId;

          _this.props.addFlagToPhase(phaseId, FLAG);
        } else if (lineItem.status === 'Ready for Accounting') {
          var _this$props = _this.props,
              _phaseId = _this$props.phaseId,
              flags = _this$props.flags;

          var oldFlag = flags.find(function (flag) {
            return flag.name === FLAG.name && flag.note === FLAG.note;
          });

          if (oldFlag) _this.props.removeFlagFromPhase(_phaseId, oldFlag);
        }
      }
    }), Object.defineProperty(_this, 'refreshLineItemList', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.props.requestPhaseItems(_this.props.phaseId, LINE_ITEM_TYPE);
      }
    }), Object.defineProperty(_this, 'handleDelete', {
      enumerable: true,
      writable: true,
      value: function value(lineItemId) {
        _this.props.deletePhaseItem(_this.props.phaseId, { id: lineItemId }, LINE_ITEM_TYPE);
      }
    }), Object.defineProperty(_this, 'handleSave', {
      enumerable: true,
      writable: true,
      value: function value(lineItem) {
        _this.props.savePhaseItem(_this.props.phaseId, lineItem, LINE_ITEM_TYPE).then(function (res) {
          _this.updateFlags(res, lineItem);
        });
      }
    }), _temp), contractorChargebackTable__possibleConstructorReturn(_this, _ret);
  }

  contractorChargebackTable__createClass(ContractorChargebackTable, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.refreshLineItemList();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          lineItems = _props.lineItems,
          documents = _props.documents,
          editable = _props.editable,
          role = _props.role;

      var total = lineItems.reduce(function (curr, next) {
        return curr + (next.total || 0);
      }, 0);
      return react_default.a.createElement(
        components_LineItemTable,
        {
          title: 'Chargebacks',
          refreshList: this.refreshLineItemList,
          total: total,
          readOnly: !editable,
          accountingTable: true
        },
        lineItems.map(function (item) {
          return react_default.a.createElement(contractorChargebackRow, {
            key: item.id,
            onSave: _this2.handleSave,
            onDelete: _this2.handleDelete,
            lineItem: item,
            documents: documents,
            hasCreatableRow: editable,
            readOnly: !Object(services["a" /* can */])(role, 'update', 'chargeback', { obj_status: item.status }),
            role: role
          });
        })
      );
    }
  }]);

  return ContractorChargebackTable;
}(react["Component"]);

contractorChargebackTable_ContractorChargebackTable.defaultProps = {
  lineItems: []
};

contractorChargebackTable_ContractorChargebackTable.propTypes = {
  phaseId: prop_types_default.a.string,
  requestPhaseItems: prop_types_default.a.func,
  savePhaseItem: prop_types_default.a.func,
  deletePhaseItem: prop_types_default.a.func,
  lineItems: prop_types_default.a.arrayOf(prop_types_default.a.shape(contractorChargebackItem)),
  documents: prop_types_default.a.arrayOf(documentUpload).isRequired,
  addFlagToPhase: prop_types_default.a.func.isRequired,
  removeFlagFromPhase: prop_types_default.a.func.isRequired,
  editable: prop_types_default.a.bool.isRequired,
  role: prop_types_default.a.string,
  flags: prop_types_default.a.arrayOf(types_flag)
};

/* harmony default export */ var contractorChargebackTable = (Object(react_redux_es["connect"])(function (state) {
  return {
    editable: Object(services["a" /* can */])(Object(reducers["_12" /* getRole */])(state), 'editable', 'chargeback'),
    role: Object(reducers["_12" /* getRole */])(state),
    flags: state.phase.details.flags
  };
}, {
  savePhaseItem: phase_items["k" /* savePhaseItem */],
  deletePhaseItem: phase_items["e" /* deletePhaseItem */],
  requestPhaseItems: phase_items["i" /* requestPhaseItems */],
  addFlagToPhase: actionCreators_phase["b" /* addFlagToPhase */],
  removeFlagFromPhase: actionCreators_phase["m" /* removeFlagFromPhase */]
})(contractorChargebackTable_ContractorChargebackTable));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseAccounting/components/purchaseOrderRow.jsx
var purchaseOrderRow__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var purchaseOrderRow__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function purchaseOrderRow__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function purchaseOrderRow__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function purchaseOrderRow__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function purchaseOrderRow__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var INVOICE_STATUSES = ['Not Billable', 'Not Invoiced', 'Ready for Accounting', 'Recorded', 'Invoiced', 'Paid'];
var WR_INVOICE_STATUSES = ['Not Billable', 'Not Invoiced', 'Ready for Accounting'];
var purchaseOrderRow_SIGNED_DOCUMENT_TYPES = ['Signed Documents'];
var BILLABLE_DOCUMENT_TYPES = ['PO', 'Work Order'];

var purchaseOrderRow_PurchaseOrderRow = function (_Editable) {
  purchaseOrderRow__inherits(PurchaseOrderRow, _Editable);

  function PurchaseOrderRow() {
    var _ref;

    var _temp, _this, _ret;

    purchaseOrderRow__classCallCheck(this, PurchaseOrderRow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = purchaseOrderRow__possibleConstructorReturn(this, (_ref = PurchaseOrderRow.__proto__ || Object.getPrototypeOf(PurchaseOrderRow)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'state', {
      enumerable: true,
      writable: true,
      value: purchaseOrderRow__extends({}, _this.props.lineItem, {
        number: _this.props.lineItem.number || ''
      })
    }), Object.defineProperty(_this, 'handleChange', {
      enumerable: true,
      writable: true,
      value: function value(attr) {
        return function (val) {
          var value = _this.sanatize(attr, val);
          _this.setState(purchaseOrderRow__defineProperty({}, attr, value));

          if (val && attr === 'signed_document_id' && (_this.state.invoice_status === 'Not Invoiced' || !_this.state.invoice_status)) {
            _this.setState({ invoice_status: 'Ready for Accounting' });
          }
        };
      }
    }), Object.defineProperty(_this, 'handleNumberChange', {
      enumerable: true,
      writable: true,
      value: _this.handleChange('number')
    }), Object.defineProperty(_this, 'handleTotalChange', {
      enumerable: true,
      writable: true,
      value: _this.handleChange('total')
    }), Object.defineProperty(_this, 'handleInvoiceChange', {
      enumerable: true,
      writable: true,
      value: _this.handleChange('invoice_number')
    }), Object.defineProperty(_this, 'handleKindChange', {
      enumerable: true,
      writable: true,
      value: _this.handleChange('kind')
    }), Object.defineProperty(_this, 'handleSignedDocumentChange', {
      enumerable: true,
      writable: true,
      value: _this.handleChange('signed_document_id')
    }), Object.defineProperty(_this, 'handleBillableDocumentChange', {
      enumerable: true,
      writable: true,
      value: _this.handleChange('billable_document_id')
    }), Object.defineProperty(_this, 'handleInvoiceStatusChange', {
      enumerable: true,
      writable: true,
      value: _this.handleChange('invoice_status')
    }), Object.defineProperty(_this, 'handleSave', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.props.onSave(_this.state);
      }
    }), Object.defineProperty(_this, 'handleDelete', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.props.onDelete(_this.state.id);
      }
    }), Object.defineProperty(_this, 'formatOptions', {
      enumerable: true,
      writable: true,
      value: function value(options) {
        return options.map(function (option) {
          return { value: option, label: option };
        });
      }
    }), Object.defineProperty(_this, 'getPurchaseOrderLabel', {
      enumerable: true,
      writable: true,
      value: function value(id) {
        return _this.props.purchaseOrderOptions.find(function (po) {
          return po.value === id;
        }) || {};
      }
    }), Object.defineProperty(_this, 'validateNumber', {
      enumerable: true,
      writable: true,
      value: function value(number) {
        var regex = /^(?!00)\d{9}$|^PR\d{8}$|^\d{8}[AIW]$|^PRJ\d+$/;
        var ime_regex = /^\d{8}[AIW]$/;
        var rf_regex = /^PRJ\d+$/;
        var isProjectNumber = _this.props.projectNumber === number && !_this.props.projectNumber.match(ime_regex) && !_this.props.projectNumber.match(rf_regex);
        return (number === null || number === '' || regex.test(number)) && !isProjectNumber;
      }
    }), Object.defineProperty(_this, 'invalidNumber', {
      enumerable: true,
      writable: true,
      value: function value(lineItem) {
        return !_this.validateNumber(lineItem.number) && lineItem.kind !== 'Special Order' && lineItem.invoice_status !== 'Not Billable';
      }
    }), Object.defineProperty(_this, 'getPhaseLineItemTotal', {
      enumerable: true,
      writable: true,
      value: function value(id) {
        return _this.props.phaseLineItems.filter(function (i) {
          return i.purchase_order_id === id;
        }).reduce(function (a, b) {
          return a + b.total;
        }, 0) || 0;
      }
    }), Object.defineProperty(_this, 'renderTableDesktop', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            readOnly = _this$props.readOnly,
            documents = _this$props.documents,
            role = _this$props.role,
            originalExists = _this$props.originalExists,
            toggleLineItem = _this$props.toggleLineItem,
            expandableRow = _this$props.expandableRow;

        var lineItem = _this.state;
        var deleteError = lineItem.errors && lineItem.errors.base && Object(utils["c" /* error */])('base', lineItem.errors);
        var invoiceStatuses = role !== 'workroom' ? INVOICE_STATUSES : WR_INVOICE_STATUSES;
        var status = lineItem.invoice_status;
        var hideDelete = role !== 'admin' && (status === 'Recorded' || status === 'Invoiced' || status === 'Paid');
        var rowProps = {
          isNew: lineItem.id < 0,
          onSave: _this.handleSave,
          onDelete: _this.handleDelete,
          deleteError: deleteError,
          readOnly: readOnly
        };
        var poTypes = ['Original', 'Additional', 'Exception', 'Refund Rebill', 'Special Order'];
        if (originalExists && lineItem.kind !== 'Original') poTypes.shift();
        var phaseLineItemTotal = _this.getPhaseLineItemTotal(lineItem.id) || 0;
        var totalMismatch = status === 'Ready for Accounting' && lineItem.total !== parseFloat((phaseLineItemTotal || 0).toFixed(2));
        var message = totalMismatch ? 'PO & Line-Item totals don\'t match' : '';
        return react_default.a.createElement(
          editableTableRow,
          purchaseOrderRow__extends({
            key: lineItem.id,
            id: lineItem.id,
            hideDelete: hideDelete,
            totalMismatch: totalMismatch,
            role: role,
            invalidNumber: _this.invalidNumber(lineItem),
            message: message,
            deleteDialog: true
          }, rowProps, {
            toggleLineItem: toggleLineItem,
            expandableRow: expandableRow
          }),
          react_default.a.createElement(components_LineItemTable_itemEvents, {
            display: !_this.context.isEditable,
            label: '',
            itemType: 'purchaseOrders',
            lineItem: lineItem,
            dataKeys: ['number', 'kind', 'signed_document_name', 'billable_document_name', 'invoice_status', 'total', 'invoice_number']
          }),
          react_default.a.createElement(inputCell, {
            attr: 'number',
            label: 'PO #',
            lineItem: lineItem,
            onChange: _this.handleNumberChange,
            cellValue: _this.getPurchaseOrderLabel(lineItem.id).label
          }),
          react_default.a.createElement(dropDownCell, {
            attr: 'kind',
            label: 'Type',
            lineItem: lineItem,
            options: _this.formatOptions(poTypes),
            onChange: _this.handleKindChange
          }),
          react_default.a.createElement(
            dropDownCell,
            {
              attr: 'signed_document',
              isIdAttr: true,
              label: 'Signed Document',
              lineItem: lineItem,
              options: utils_documents(documents, purchaseOrderRow_SIGNED_DOCUMENT_TYPES),
              onChange: _this.handleSignedDocumentChange,
              clearable: true
            },
            react_default.a.createElement(components_LineItemTable_documentLink, { documents: documents, id: lineItem.signed_document_id })
          ),
          react_default.a.createElement(
            dropDownCell,
            {
              attr: 'billable_document',
              isIdAttr: true,
              label: 'Billable Document',
              lineItem: lineItem,
              options: utils_documents(documents, BILLABLE_DOCUMENT_TYPES),
              onChange: _this.handleBillableDocumentChange
            },
            react_default.a.createElement(components_LineItemTable_documentLink, { documents: documents, id: lineItem.billable_document_id })
          ),
          react_default.a.createElement(dropDownCell, {
            attr: 'invoice_status',
            label: 'Invoice Status',
            lineItem: lineItem,
            options: _this.formatOptions(invoiceStatuses),
            onChange: _this.handleInvoiceStatusChange
          }),
          react_default.a.createElement(inputCell, { type: 'number', attr: 'total', label: 'Total', lineItem: lineItem, onChange: _this.handleTotalChange, cellValue: Object(lineItemUtils["g" /* formatDollars */])(lineItem.total) }),
          react_default.a.createElement(inputCell, { attr: 'invoice_number', label: 'QB Invoice', lineItem: lineItem, onChange: _this.handleInvoiceChange })
        );
      }
    }), Object.defineProperty(_this, 'renderTableMobile', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props2 = _this.props,
            readOnly = _this$props2.readOnly,
            documents = _this$props2.documents,
            role = _this$props2.role,
            originalExists = _this$props2.originalExists,
            toggleLineItem = _this$props2.toggleLineItem;

        var lineItem = _this.state;
        var deleteError = lineItem.errors && lineItem.errors.base && Object(utils["c" /* error */])('base', lineItem.errors);
        var invoiceStatuses = role !== 'workroom' ? INVOICE_STATUSES : WR_INVOICE_STATUSES;
        var status = lineItem.invoice_status;
        var hideDelete = role !== 'admin' && (status === 'Recorded' || status === 'Invoiced' || status === 'Paid');
        var rowProps = {
          isNew: lineItem.id < 0,
          onSave: _this.handleSave,
          onDelete: _this.handleDelete,
          deleteError: deleteError,
          readOnly: readOnly
        };
        var poTypes = ['Original', 'Additional', 'Exception', 'Refund Rebill', 'Special Order'];
        if (originalExists && lineItem.kind !== 'Original') poTypes.shift();
        var phaseLineItemTotal = _this.getPhaseLineItemTotal(lineItem.id) || 0;
        var totalMismatch = status === 'Ready for Accounting' && lineItem.total !== parseFloat((phaseLineItemTotal || 0).toFixed(2));
        var message = totalMismatch ? 'PO & Line-Item totals don\'t match' : '';
        return react_default.a.createElement(
          editableTableRow,
          purchaseOrderRow__extends({
            key: lineItem.id,
            id: lineItem.id,
            invalidNumber: _this.invalidNumber(lineItem),
            hideDelete: hideDelete,
            totalMismatch: totalMismatch,
            role: role,
            message: message,
            deleteDialog: true,
            toggleLineItem: toggleLineItem
          }, rowProps),
          react_default.a.createElement(inputCell, { attr: 'number', label: 'PO #', lineItem: lineItem, onChange: _this.handleNumberChange, cellValue: _this.getPurchaseOrderLabel(lineItem.id).label }),
          react_default.a.createElement(dropDownCell, {
            attr: 'kind',
            label: 'Type',
            lineItem: lineItem,
            options: _this.formatOptions(poTypes),
            onChange: _this.handleKindChange
          }),
          react_default.a.createElement(
            dropDownCell,
            {
              attr: 'signed_document',
              isIdAttr: true,
              label: 'Signed Document',
              lineItem: lineItem,
              options: utils_documents(documents, purchaseOrderRow_SIGNED_DOCUMENT_TYPES),
              onChange: _this.handleSignedDocumentChange,
              clearable: true
            },
            react_default.a.createElement(components_LineItemTable_documentLink, { documents: documents, id: lineItem.signed_document_id })
          ),
          react_default.a.createElement(
            dropDownCell,
            {
              attr: 'billable_document',
              isIdAttr: true,
              label: 'Billable Document',
              lineItem: lineItem,
              options: utils_documents(documents, BILLABLE_DOCUMENT_TYPES),
              onChange: _this.handleBillableDocumentChange
            },
            react_default.a.createElement(components_LineItemTable_documentLink, { documents: documents, id: lineItem.billable_document_id })
          ),
          react_default.a.createElement(dropDownCell, {
            attr: 'invoice_status',
            label: 'Invoice Status',
            lineItem: lineItem,
            options: _this.formatOptions(invoiceStatuses),
            onChange: _this.handleInvoiceStatusChange
          }),
          react_default.a.createElement(inputCell, { type: 'number', attr: 'total', label: 'Total', lineItem: lineItem, onChange: _this.handleTotalChange, cellValue: Object(lineItemUtils["g" /* formatDollars */])(lineItem.total) }),
          react_default.a.createElement(inputCell, { attr: 'invoice_number', label: 'QB Invoice', lineItem: lineItem, onChange: _this.handleInvoiceChange }),
          react_default.a.createElement(
            'td',
            null,
            react_default.a.createElement(
              'div',
              null,
              react_default.a.createElement(
                'table',
                { className: laborTables_default.a.inlineTableItem },
                react_default.a.createElement(
                  'tbody',
                  { className: laborTables_default.a.inlineTableItem },
                  react_default.a.createElement(
                    'tr',
                    { className: laborTables_default.a.iconWrapper },
                    react_default.a.createElement(components_LineItemTable_itemEvents, {
                      display: !_this.context.isEditable,
                      label: '',
                      itemType: 'purchaseOrders',
                      lineItem: lineItem,
                      dataKeys: ['number', 'kind', 'signed_document_name', 'billable_document_name', 'invoice_status', 'total', 'invoice_number']
                    })
                  )
                )
              )
            )
          )
        );
      }
    }), _temp), purchaseOrderRow__possibleConstructorReturn(_this, _ret);
  }

  purchaseOrderRow__createClass(PurchaseOrderRow, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return react_default.a.createElement(
        react_responsive_default.a,
        { minWidth: constants["y" /* CUT_POINT */] },
        function (matches) {
          if (matches) {
            return _this2.renderTableDesktop();
          }
          return _this2.renderTableMobile();
        }
      );
    }
  }]);

  return PurchaseOrderRow;
}(mixins_editable(react_default.a.Component));

purchaseOrderRow_PurchaseOrderRow.contextTypes = {
  isEditable: prop_types_default.a.bool
};

purchaseOrderRow_PurchaseOrderRow.defaultProps = {
  readOnly: false,
  purchaseOrderOptions: [],
  phaseLineItems: [],
  projectNumber: '',
  role: ''
};

purchaseOrderRow_PurchaseOrderRow.propTypes = {
  projectNumber: prop_types_default.a.string,
  role: prop_types_default.a.string,
  lineItem: prop_types_default.a.shape(purchaseOrder).isRequired,
  originalExists: prop_types_default.a.bool.isRequired,
  onSave: prop_types_default.a.func.isRequired,
  onDelete: prop_types_default.a.func.isRequired,
  documents: prop_types_default.a.arrayOf(documentUpload).isRequired,
  readOnly: prop_types_default.a.bool,
  purchaseOrderOptions: purchaseOrderOptionsType,
  phaseLineItems: prop_types_default.a.arrayOf(prop_types_default.a.object)
};

/* harmony default export */ var purchaseOrderRow = (purchaseOrderRow_PurchaseOrderRow);
// CONCATENATED MODULE: ./client/app/selectors/purchaseOrderOptions.js
var purchaseOrderOptions__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var getPurchaseOrderSelector = function getPurchaseOrderSelector(state) {
  return state.phase.purchaseOrders.items;
};

var getPurchaseOrdersWithLabel = Object(reselect_lib["createSelector"])(getPurchaseOrderSelector, function (items) {
  var counter = {};
  return items.map(function (item) {
    var label = item.number;
    if (!counter[item.kind]) counter[item.kind] = 0;
    if (!item.number && item.id >= 0) {
      counter[item.kind] += 1;
      label = item.kind + ' ' + counter[item.kind];
    }
    return purchaseOrderOptions__extends({}, item, { label: label, value: item.id >= 0 ? item.id : '' });
  });
});

/* harmony default export */ var selectors_purchaseOrderOptions = (getPurchaseOrdersWithLabel);
// CONCATENATED MODULE: ./client/app/shared/types/lineItemPropType.js


/* harmony default export */ var lineItemPropType = ({
  id: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]),
  item_number: prop_types_default.a.string,
  description: prop_types_default.a.string,
  price: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]),
  quantity: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]),
  total: prop_types_default.a.number,
  errors: prop_types_default.a.shape({
    price: prop_types_default.a.array,
    quantity: prop_types_default.a.array,
    line_item: prop_types_default.a.array,
    note: prop_types_default.a.array
  }),
  status: prop_types_default.a.string,
  po_number: prop_types_default.a.string,
  phase_line_item_id: prop_types_default.a.number,
  warehouse_quantity: prop_types_default.a.shape({
    remainder: prop_types_default.a.number,
    packages: prop_types_default.a.number
  }),
  warehouse_status: prop_types_default.a.string,
  payable: prop_types_default.a.bool,
  note: prop_types_default.a.string,
  net_quantity: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number])
});
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/components/laborTableRow.jsx
var laborTableRow__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function laborTableRow__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function laborTableRow__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function laborTableRow__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function laborTableRow__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }























var EDITABLE_KEYS = ['status', 'line_item_id', 'payable', 'price', 'kind', 'quantity', 'total', 'purchase_order_id', 'note'];

var laborTableRow_LaborTableRow = function (_Editable) {
  laborTableRow__inherits(LaborTableRow, _Editable);

  function LaborTableRow() {
    var _ref;

    var _temp, _this, _ret;

    laborTableRow__classCallCheck(this, LaborTableRow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = laborTableRow__possibleConstructorReturn(this, (_ref = LaborTableRow.__proto__ || Object.getPrototypeOf(LaborTableRow)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'state', {
      enumerable: true,
      writable: true,
      value: laborTableRow__extends({}, _this.props.lineItem, { purchase_order_id: _this.props.purchaseOrderId })
    }), Object.defineProperty(_this, 'getPurchaseOrderLabel', {
      enumerable: true,
      writable: true,
      value: function value(id) {
        return _this.props.purchaseOrderOptions.find(function (po) {
          return po.value === id;
        }) || {};
      }
    }), Object.defineProperty(_this, 'handleSave', {
      enumerable: true,
      writable: true,
      value: function value() {
        var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EDITABLE_KEYS;
        return _this.props.onSave(Object(lodash["pick"])(_this.state, keys.concat(['id'])));
      }
    }), Object.defineProperty(_this, 'handleDelete', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.onDelete(_this.state.id);
      }
    }), Object.defineProperty(_this, 'handleChange', {
      enumerable: true,
      writable: true,
      value: function value(attr) {
        return function (val) {
          var _this$setState;

          var lineItem = _this.state;
          var value = _this.sanatize(attr, val);
          if (attr === 'payable') value = !value;
          var price = attr === 'price' ? value : lineItem.price;
          var qty = attr === 'quantity' ? value : lineItem.quantity;
          var calculatedTotal = Object(lineItemUtils["c" /* calculateTotal */])(price, qty);
          _this.setState((_this$setState = {}, laborTableRow__defineProperty(_this$setState, attr, value), laborTableRow__defineProperty(_this$setState, 'calculatedTotal', calculatedTotal), _this$setState));
        };
      }
    }), Object.defineProperty(_this, 'handleStatusChange', {
      enumerable: true,
      writable: true,
      value: function value(_ref2) {
        var status = _ref2.status;
        return _this.setState({ status: status }, function () {
          if (!_this.context.isEditable) _this.handleSave(['status']);
        });
      }
    }), Object.defineProperty(_this, 'handleDescriptionChange', {
      enumerable: true,
      writable: true,
      value: function value(val) {
        var lineItem = _this.state;
        var lineItemOptions = _this.props.lineItemOptions;

        var option = lineItemOptions.find(function (o) {
          return o.value === val;
        });
        var price = option.price,
            payable = option.payable,
            kind = option.kind;

        var calculatedTotal = Object(lineItemUtils["c" /* calculateTotal */])(price, lineItem.quantity);
        _this.setState({ line_item_id: val, payable: payable, calculatedTotal: calculatedTotal, price: price, kind: kind });
      }
    }), Object.defineProperty(_this, 'handlePOChange', {
      enumerable: true,
      writable: true,
      value: _this.handleChange('purchase_order_id')
    }), Object.defineProperty(_this, 'handlePriceChange', {
      enumerable: true,
      writable: true,
      value: _this.handleChange('price')
    }), Object.defineProperty(_this, 'handleQuantityChange', {
      enumerable: true,
      writable: true,
      value: _this.handleChange('quantity')
    }), Object.defineProperty(_this, 'handleTotalChange', {
      enumerable: true,
      writable: true,
      value: _this.handleChange('total')
    }), Object.defineProperty(_this, 'handlePayableChange', {
      enumerable: true,
      writable: true,
      value: _this.handleChange('payable')
    }), Object.defineProperty(_this, 'handleNoteChange', {
      enumerable: true,
      writable: true,
      value: _this.handleChange('note')
    }), Object.defineProperty(_this, 'handlePayableSave', {
      enumerable: true,
      writable: true,
      value: function value(val) {
        return _this.setState({ payable: !val }, function () {
          _this.handleSave(['payable']);
        });
      }
    }), Object.defineProperty(_this, 'blockItemCellEdit', {
      enumerable: true,
      writable: true,
      value: function value(options, item) {
        return _this.props.phaseType === 'Assessment' && !options.some(function (o) {
          return o.label.includes(item.item_number) || o.label.includes(item.description);
        });
      }
    }), Object.defineProperty(_this, 'renderStatusCell', {
      enumerable: true,
      writable: true,
      value: function value() {
        var lineItem = _this.state;
        var readOnly = _this.props.readOnly;

        var statuses = lineItem.kind === 'Labor' ? constants["S" /* LABOR_VERIFICATION_STATUSES */] : constants["_18" /* PRODUCT_VERIFICATION_STATUSES */];
        var val = readOnly ? lineItem.status : react_default.a.createElement(lineItemStatus, {
          onChange: _this.handleStatusChange, lineItem: lineItem, options: statuses
        });
        return react_default.a.createElement(
          editableTableCell,
          {
            onChange: _this.handleStatusChange, label: 'Status', value: val, className: table_default.a.largeColumn
          },
          val
        );
      }
    }), Object.defineProperty(_this, 'renderPayable', {
      enumerable: true,
      writable: true,
      value: function value() {
        var checked = Object(lodash["has"])(_this.state, 'payable') ? !_this.state.payable : false;
        var value = react_default.a.createElement(react_toolbox_lib["Checkbox"], {
          checked: checked,
          onChange: _this.handlePayableSave,
          className: form_default.a.checkboxListItem,
          theme: checkbox_default.a
        });
        return react_default.a.createElement(
          editableTableCell,
          {
            label: 'Not Payable', value: value, onChange: _this.handlePayableChange
          },
          value
        );
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var lineItem = _this.state;
        var _this$props = _this.props,
            purchaseOrderOptions = _this$props.purchaseOrderOptions,
            lineItemOptions = _this$props.lineItemOptions,
            role = _this$props.role,
            filterLineItems = _this$props.filterLineItems,
            surfaceType = _this$props.surfaceType,
            phaseSource = _this$props.phaseSource;
        var isEditable = _this.context.isEditable;

        var style = {
          background: constants["w" /* CONTRACT_VERIFICATION_STATUS_COLORS */][lineItem.status]
        };
        var pricePatchCellReadOnly = role !== 'admin';
        var rowProps = {
          isNew: lineItem.id < 0, style: style, onSave: _this.handleSave, onDelete: _this.handleDelete
        };
        var calculatedTotalValue = react_default.a.createElement(
          'span',
          { className: table_default.a.iconContainer },
          Object(lineItemUtils["g" /* formatDollars */])(lineItem.calculatedTotal),
          lineItem.total !== lineItem.calculatedTotal && react_default.a.createElement(react_toolbox_lib["FontIcon"], {
            'data-tip': true, 'data-for': lineItem.id + 'lineItemCalculatedTotalError',
            value: 'ic_warning',
            className: table_default.a.calculatedTotalIcon
          }),
          lineItem.total !== lineItem.calculatedTotal && react_default.a.createElement(
            react_tooltip_dist_default.a,
            {
              id: lineItem.id + 'lineItemCalculatedTotalError', place: 'top', effect: 'solid'
            },
            'Calculated total and PO line item total do not match.'
          )
        );
        var optionsByVendor = Object(lineItemUtils["f" /* filterByVendor */])(lineItemOptions, phaseSource);
        return react_default.a.createElement(
          editableTableRow,
          laborTableRow__extends({ key: lineItem.id, id: lineItem.id }, rowProps),
          react_default.a.createElement(components_LineItemTable_itemEvents, {
            display: !isEditable,
            label: '',
            itemType: 'phaseLineItems',
            lineItem: lineItem,
            dataKeys: ['status', 'po_number', 'item_number', 'description', 'quantity', 'price', 'total', 'payable', 'note']
          }),
          _this.renderStatusCell(),
          react_default.a.createElement(dropDownCell, {
            attr: 'purchase_order',
            display: isEditable,
            isIdAttr: true,
            label: 'PO Number',
            lineItem: lineItem,
            options: purchaseOrderOptions,
            cellValue: _this.getPurchaseOrderLabel(lineItem.purchase_order_id).label,
            onChange: _this.handlePOChange
          }),
          react_default.a.createElement(editableTableCell, { display: !isEditable, value: lineItem.kind, label: 'Kind' }),
          react_default.a.createElement(editableTableCell, { display: !isEditable, value: lineItem.item_number, label: 'Item Number' }),
          react_default.a.createElement(editableTableCell, { display: !isEditable, value: lineItem.description, label: 'Description' }),
          _this.blockItemCellEdit(lineItemOptions, lineItem) && lineItem.id >= 0 ? react_default.a.createElement(
            editableTableCell,
            {
              value: lineItem.item_number,
              display: isEditable,
              label: 'Item Number - Description'
            },
            lineItem.item_number,
            ' - ',
            lineItem.description
          ) : react_default.a.createElement(dropDownCell, {
            attr: 'line_item',
            isIdAttr: true,
            label: 'Item Number - Description',
            display: isEditable,
            lineItem: lineItem,
            options: !filterLineItems ? optionsByVendor : optionsByVendor.filter(function (o) {
              return !o.surface_type || o.label.includes(lineItem.item_number || null) || [surfaceType, 'Multi', 'All'].includes(o.surface_type);
            }),
            onChange: _this.handleDescriptionChange
          }),
          react_default.a.createElement(inputCell, {
            attr: 'quantity',
            label: 'QTY',
            lineItem: lineItem,
            onChange: _this.handleQuantityChange
          }),
          react_default.a.createElement(inputCell, {
            attr: 'price',
            label: 'Price Patch',
            lineItem: lineItem,
            onChange: _this.handlePriceChange,
            cellValue: Object(lineItemUtils["g" /* formatDollars */])(lineItem.price),
            cellReadOnly: pricePatchCellReadOnly
          }),
          react_default.a.createElement(
            editableTableCell,
            { className: table_default.a.calculatedTotalColumn, value: calculatedTotalValue, label: 'Calculated Total' },
            calculatedTotalValue
          ),
          react_default.a.createElement(inputCell, {
            attr: 'total',
            type: 'number',
            label: 'PO Line Item Total',
            lineItem: lineItem,
            onChange: _this.handleTotalChange,
            cellValue: Object(lineItemUtils["g" /* formatDollars */])(lineItem.total)
          }),
          _this.renderPayable(),
          react_default.a.createElement(LineItemTable_itemNote, { display: true, label: 'Note', onChange: _this.handleNoteChange, note: lineItem.note, id: lineItem.id, kind: 'lineItem' })
        );
      }
    }), _temp), laborTableRow__possibleConstructorReturn(_this, _ret);
  }

  return LaborTableRow;
}(mixins_editable(react_default.a.Component));

laborTableRow_LaborTableRow.contextTypes = { isEditable: prop_types_default.a.bool };

laborTableRow_LaborTableRow.propTypes = {
  lineItem: prop_types_default.a.shape(lineItemPropType),
  onSave: prop_types_default.a.func,
  onDelete: prop_types_default.a.func,
  lineItemOptions: prop_types_default.a.array,
  purchaseOrderOptions: purchaseOrderOptionsType,
  purchaseOrderId: prop_types_default.a.number,
  readOnly: prop_types_default.a.bool,
  role: prop_types_default.a.string,
  phaseType: prop_types_default.a.string,
  filterLineItems: prop_types_default.a.bool,
  phaseSource: prop_types_default.a.string
};

laborTableRow_LaborTableRow.defaultProps = {
  lineItem: {},
  lineItemOptions: [],
  itemType: 'Product',
  purchaseOrderId: null,
  filterLineItems: false
};

var getItemNumberFromLabel = function getItemNumberFromLabel(_ref3) {
  var label = _ref3.label;
  return label.substring(0, label.indexOf(' - '));
};

var laborTableRow_mapStateToProps = function mapStateToProps(state) {
  var _state$phase$details = state.phase.details,
      type = _state$phase$details.type,
      source = _state$phase$details.source,
      name = _state$phase$details.surface_type.name;

  return {
    lineItemOptions: type !== 'Assessment' ? getPricePatchItems(state) : getPricePatchItems(state).filter(function (i) {
      return constants["k" /* ASSESSMENT_LABOR_ITEMS */].includes(getItemNumberFromLabel(i)) || constants["b" /* ADDTL_MILEAGE_ITEMS */].includes(getItemNumberFromLabel(i)) || constants["j" /* ASSESSMENT_DETAIL_ITEMS */].includes(getItemNumberFromLabel(i));
    }),
    phaseType: type,
    phaseSource: source,
    surfaceType: name
  };
};

/* harmony default export */ var laborTableRow = (Object(react_redux_es["connect"])(laborTableRow_mapStateToProps)(laborTableRow_LaborTableRow));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/components/phaseLineItemTables.jsx
var phaseLineItemTables__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function phaseLineItemTables__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function phaseLineItemTables__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function phaseLineItemTables__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function phaseLineItemTables__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }























var phaseLineItemTables_LINE_ITEM_TYPE = 'phaseLineItems';
var EXCEPTION_MESSAGE = 'Please verify installer pay after adding exceptions!';

var phaseLineItemTables_PhaseLineItemTables = function (_Component) {
  phaseLineItemTables__inherits(PhaseLineItemTables, _Component);

  function PhaseLineItemTables() {
    var _ref;

    var _temp, _this, _ret;

    phaseLineItemTables__classCallCheck(this, PhaseLineItemTables);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = phaseLineItemTables__possibleConstructorReturn(this, (_ref = PhaseLineItemTables.__proto__ || Object.getPrototypeOf(PhaseLineItemTables)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'state', {
      enumerable: true,
      writable: true,
      value: { tableMessages: {} }
    }), Object.defineProperty(_this, 'componentWillMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.refreshLineItemList();
      }
    }), Object.defineProperty(_this, 'refreshLineItemList', {
      enumerable: true,
      writable: true,
      value: function value() {
        var poId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var removeTableMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        _this.props.requestPhaseItems(_this.props.phaseId, phaseLineItemTables_LINE_ITEM_TYPE);
        // This is just fetching the POs and not doing anything with them,
        // just so that they're available for the isClosed check.
        _this.props.requestPhaseItems(_this.props.phaseId, 'purchaseOrders');
        if (removeTableMessage) {
          _this.setState({
            tableMessages: phaseLineItemTables__extends({}, _this.state.tableMessages, phaseLineItemTables__defineProperty({}, poId, ''))
          });
        }
      }
    }), Object.defineProperty(_this, 'handleDelete', {
      enumerable: true,
      writable: true,
      value: function value(lineItemId) {
        return _this.props.deletePhaseItem(_this.props.phaseId, { id: lineItemId }, phaseLineItemTables_LINE_ITEM_TYPE);
      }
    }), Object.defineProperty(_this, 'handleSave', {
      enumerable: true,
      writable: true,
      value: function value(lineItem) {
        return _this.props.savePhaseItem(_this.props.phaseId, lineItem, phaseLineItemTables_LINE_ITEM_TYPE).then(function () {
          return lineItem.id < 0 && lineItem.status === 'Exception' ? _this.setState({ tableMessages: phaseLineItemTables__extends({}, _this.state.tableMessages, phaseLineItemTables__defineProperty({}, lineItem.purchase_order_id, EXCEPTION_MESSAGE)) }) : null;
        });
      }
    }), Object.defineProperty(_this, 'requestLineItemOptions', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.requestPricePatchLineItemList(_this.props.phaseId);
      }
    }), Object.defineProperty(_this, 'isClosed', {
      enumerable: true,
      writable: true,
      value: function value(purchaseOrder) {
        return purchaseOrder && (purchaseOrder.invoice_status === 'Invoiced' || purchaseOrder.invoice_status === 'Recorded' || purchaseOrder.invoice_status === 'Paid');
      }
    }), Object.defineProperty(_this, 'handleMergeToOriginal', {
      enumerable: true,
      writable: true,
      value: function value(poId) {
        var onMergeToOriginal = _this.props.onMergeToOriginal;

        if (!onMergeToOriginal) return;
        sweetalert_min_default()({
          title: 'Merge Exception PO?',
          text: 'All line items will be moved to the Original PO and this Exception will be marked as resolved.',
          icon: 'warning',
          buttons: ['Cancel', 'Merge'],
          dangerMode: true
        }).then(function (shouldMerge) {
          if (!shouldMerge) return;
          var result = onMergeToOriginal(poId);
          Promise.resolve(result).catch(function (error) {
            sweetalert_min_default()('Error', Object(utils["c" /* error */])(error), 'error');
          });
        });
      }
    }), Object.defineProperty(_this, 'renderLaborTable', {
      enumerable: true,
      writable: true,
      value: function value(_ref2) {
        var items = _ref2.items,
            po = _ref2.po,
            label = _ref2.label,
            total = _ref2.total;
        var tableMessages = _this.state.tableMessages;
        var _this$props = _this.props,
            displayType = _this$props.displayType,
            purchaseOrderOptions = _this$props.purchaseOrderOptions,
            role = _this$props.role,
            cv = _this$props.cv,
            filterLineItems = _this$props.filterLineItems,
            onMergeToOriginal = _this$props.onMergeToOriginal,
            canMergeToOriginal = _this$props.canMergeToOriginal;

        var editable = Object(services["a" /* can */])(role, 'update', 'labor');
        var titleNote = po && po.invoice_status && po.invoice_status === 'Not Billable' ? 'NOT BILLABLE' : '';
        var poTotal = po && po.total ? Object(lineItemUtils["g" /* formatDollars */])(po.total) : 0;
        var liTotal = total ? Object(lineItemUtils["g" /* formatDollars */])(total) : 0;
        var footer = react_default.a.createElement(
          'div',
          { className: table_default.a.totalContainer },
          po && liTotal !== poTotal && react_default.a.createElement(
            'div',
            { className: table_default.a.totalWarning },
            'PO & Line-Item totals don\'t match'
          ),
          po && react_default.a.createElement(
            'div',
            { className: table_default.a.total },
            'PO Total: ',
            poTotal
          ),
          react_default.a.createElement(
            'div',
            { className: table_default.a.total },
            'PO Line Item Total: ',
            liTotal
          )
        );
        var tableMessageKey = po ? po.value : null;
        var shouldShowMergeButton = po && po.kind === 'Exception' && canMergeToOriginal && onMergeToOriginal;
        var mergeAction = shouldShowMergeButton ? [{
          icon: 'call_merge',
          text: 'Merge to Original',
          onClick: function onClick() {
            return _this.handleMergeToOriginal(po.value);
          }
        }] : [];
        return react_default.a.createElement(
          'div',
          { key: po ? po.value : -1 },
          tableMessages[tableMessageKey] && react_default.a.createElement(MessageBox["a" /* default */], {
            error: true, message: tableMessages[tableMessageKey]
          }),
          react_default.a.createElement(
            components_LineItemTable,
            {
              title: label,
              titleNote: titleNote,
              requestLineItemList: _this.requestLineItemOptions,
              refreshList: function refreshList() {
                return _this.refreshLineItemList(tableMessageKey, true);
              },
              readOnly: _this.isClosed(po) || !editable,
              footer: footer,
              cv: cv,
              canViewTotal: false,
              accountingTable: true,
              actions: mergeAction
            },
            items.map(function (item) {
              return react_default.a.createElement(laborTableRow, {
                key: item.id,
                onSave: _this.handleSave,
                onDelete: _this.handleDelete,
                lineItem: item,
                displayType: displayType,
                purchaseOrderOptions: purchaseOrderOptions.filter(function (purchaseOrderOption) {
                  return purchaseOrderOption.number;
                }),
                purchaseOrderId: po ? po.value : null,
                readOnly: _this.isClosed(po) || !editable,
                role: role,
                filterLineItems: filterLineItems
              });
            })
          )
        );
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props2 = _this.props,
            poId = _this$props2.poId,
            lineItemsByPo = _this$props2.lineItemsByPo,
            cv = _this$props2.cv;

        if (cv) return react_default.a.createElement(
          'div',
          null,
          lineItemsByPo.map(_this.renderLaborTable)
        );
        var singleLineItem = void 0;
        if (poId > 0) {
          singleLineItem = _this.props.lineItemsByPo.filter(function (i) {
            return i.po && i.po.id === poId;
          });
        }
        var lineItems = poId > 0 ? singleLineItem.map(_this.renderLaborTable) : lineItemsByPo.map(_this.renderLaborTable);
        return react_default.a.createElement(
          react_responsive_default.a,
          { minWidth: constants["y" /* CUT_POINT */] },
          function (matches) {
            if (matches) {
              return react_default.a.createElement(
                'tr',
                null,
                react_default.a.createElement('td', { className: table_default.a.tdIndention }),
                react_default.a.createElement(
                  'td',
                  { className: table_default.a.tdIndention, colSpan: '7' },
                  lineItems
                )
              );
            }
            return react_default.a.createElement(
              'tr',
              null,
              react_default.a.createElement(
                'td',
                { colSpan: '8' },
                lineItems
              )
            );
          }
        );
      }
    }), _temp), phaseLineItemTables__possibleConstructorReturn(_this, _ret);
  }

  return PhaseLineItemTables;
}(react["Component"]);

phaseLineItemTables_PhaseLineItemTables.defaultProps = {
  lineItemsByPo: [],
  poId: null,
  cv: false,
  filterLineItems: false,
  onMergeToOriginal: null,
  canMergeToOriginal: false
};

phaseLineItemTables_PhaseLineItemTables.propTypes = {
  phaseId: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]),
  poId: prop_types_default.a.number,
  lineItemsByPo: prop_types_default.a.arrayOf(prop_types_default.a.shape({
    po: prop_types_default.a.shape(purchaseOrder),
    label: prop_types_default.a.string.isRequired,
    items: prop_types_default.a.arrayOf(prop_types_default.a.shape(lineItemPropType))
  })),
  requestPhaseItems: prop_types_default.a.func,
  savePhaseItem: prop_types_default.a.func,
  deletePhaseItem: prop_types_default.a.func,
  requestPricePatchLineItemList: prop_types_default.a.func,
  displayType: prop_types_default.a.oneOf(['Contract', 'Accounting']),
  purchaseOrderOptions: purchaseOrderOptionsType,
  role: prop_types_default.a.string.isRequired,
  cv: prop_types_default.a.bool,
  filterLineItems: prop_types_default.a.bool,
  onMergeToOriginal: prop_types_default.a.func,
  canMergeToOriginal: prop_types_default.a.bool
};

var getItemsForPo = function getItemsForPo(lineItems) {
  var po = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var items = lineItems.filter(function (item) {
    return item.purchase_order_id === (po ? po.value : null) || item.id < 0;
  });
  var total = items.reduce(function (memo, lineItem) {
    return memo + (lineItem.total || 0);
  }, 0);
  return { items: items, total: total };
};

var getPhaseLineItemsByPo = Object(reselect_lib["createSelector"])(getPhaseLineItemsWithTotal, selectors_purchaseOrderOptions, function (lineItems, purchaseOrders) {
  var lineItemsByPo = purchaseOrders.filter(function (po) {
    return po.value > 0;
  }).map(function (po) {
    return phaseLineItemTables__extends({}, getItemsForPo(lineItems, po), { po: po, label: 'PO: ' + po.label });
  });
  if (lineItems.some(function (item) {
    return item.purchase_order_id === null;
  })) {
    lineItemsByPo.push(phaseLineItemTables__extends({}, getItemsForPo(lineItems), { label: 'No PO' }));
  }
  return lineItemsByPo;
});

/* harmony default export */ var phaseLineItemTables = (Object(react_redux_es["connect"])(function (state) {
  return {
    lineItemsByPo: getPhaseLineItemsByPo(state),
    purchaseOrderOptions: selectors_purchaseOrderOptions(state),
    role: Object(reducers["_12" /* getRole */])(state)
  };
}, {
  requestPhaseItems: phase_items["i" /* requestPhaseItems */],
  savePhaseItem: phase_items["k" /* savePhaseItem */],
  deletePhaseItem: phase_items["e" /* deletePhaseItem */],
  requestPricePatchLineItemList: dropdown_lists["d" /* requestPricePatchLineItemList */]
})(phaseLineItemTables_PhaseLineItemTables));
// CONCATENATED MODULE: ./client/app/selectors/lineItemTotal.js


var lineItemTotal_lineItems = function lineItems(items) {
  return items;
};

var getLineItemTotal = Object(reselect_lib["createSelector"])(lineItemTotal_lineItems, function (items) {
  return items.reduce(function (curr, next) {
    return curr + (next.total || 0);
  }, 0);
});

/* harmony default export */ var selectors_lineItemTotal = (getLineItemTotal);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseAccounting/components/purchaseOrderTable.jsx
function purchaseOrderTable__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function purchaseOrderTable__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function purchaseOrderTable__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var purchaseOrderTable_LINE_ITEM_TYPE = 'purchaseOrders';

var purchaseOrderTable_PurchaseOrderTable = function (_Component) {
  purchaseOrderTable__inherits(PurchaseOrderTable, _Component);

  function PurchaseOrderTable(props) {
    purchaseOrderTable__classCallCheck(this, PurchaseOrderTable);

    var _this = purchaseOrderTable__possibleConstructorReturn(this, (PurchaseOrderTable.__proto__ || Object.getPrototypeOf(PurchaseOrderTable)).call(this, props));

    Object.defineProperty(_this, 'componentWillMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.refreshLineItemList();
      }
    });
    Object.defineProperty(_this, 'componentDidMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.showLineItems ? _this.togglePoLineItems(_this.getAllItemIds(), true) : null;
      }
    });
    Object.defineProperty(_this, 'componentDidUpdate', {
      enumerable: true,
      writable: true,
      value: function value(prevProps, prevState) {
        var _this$props = _this.props,
            showLineItems = _this$props.showLineItems,
            tableName = _this$props.tableName,
            toggleShowHide = _this$props.toggleShowHide,
            cv = _this$props.cv;
        var poIds = _this.state.poIds;

        var itemIds = _this.getAllItemIds();
        if (prevProps !== _this.props && showLineItems && poIds.length !== itemIds.length) {
          _this.togglePoLineItems(itemIds, true);
        }
        if (prevProps.showLineItems !== showLineItems) {
          if (showLineItems) _this.togglePoLineItems(itemIds, true);
          if (!showLineItems) _this.togglePoLineItems([], true);
        }
        if (prevState.poIds.length !== poIds.length && poIds.length === 0 && !cv) {
          toggleShowHide(tableName, false);
        } else if (prevState.poIds.length !== poIds.length && poIds.length === itemIds.length && !cv) {
          toggleShowHide(tableName, true);
        }
      }
    });
    Object.defineProperty(_this, 'getAllItemIds', {
      enumerable: true,
      writable: true,
      value: function value() {
        var lineItems = _this.props.lineItems;

        var newLineItems = [];
        lineItems.forEach(function (li) {
          if (li.id > 0) newLineItems.push(li.id);
        });
        return newLineItems;
      }
    });
    Object.defineProperty(_this, 'handleMergeToOriginal', {
      enumerable: true,
      writable: true,
      value: function value(purchaseOrderId) {
        return _this.props.mergePurchaseOrderToOriginal(_this.props.phaseId, purchaseOrderId);
      }
    });
    Object.defineProperty(_this, 'refreshLineItemList', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.props.requestPhaseItems(_this.props.phaseId, purchaseOrderTable_LINE_ITEM_TYPE);
        _this.props.requestPhaseItems(_this.props.phaseId, 'phaseLineItems');
      }
    });
    Object.defineProperty(_this, 'handleDelete', {
      enumerable: true,
      writable: true,
      value: function value(lineItemId) {
        return _this.props.deletePhaseItem(_this.props.phaseId, { id: lineItemId }, purchaseOrderTable_LINE_ITEM_TYPE);
      }
    });
    Object.defineProperty(_this, 'handleSave', {
      enumerable: true,
      writable: true,
      value: function value(lineItem) {
        return _this.props.savePhaseItem(_this.props.phaseId, lineItem, purchaseOrderTable_LINE_ITEM_TYPE);
      }
    });
    Object.defineProperty(_this, 'determineOriginalExists', {
      enumerable: true,
      writable: true,
      value: function value(lineItems) {
        var exists = false;
        lineItems.forEach(function (lineItem) {
          if (lineItem.kind === 'Original') exists = true;
        });
        return exists;
      }
    });
    Object.defineProperty(_this, 'togglePoLineItems', {
      enumerable: true,
      writable: true,
      value: function value(itemIds) {
        var toggleAll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var poIds = _this.state.poIds;

        var newPoIdsArr = poIds.slice();
        if (toggleAll) {
          // add all line items to poIds
          _this.setState({ poIds: itemIds });
        } else {
          // add single line Item to poIds
          if (!newPoIdsArr.includes(itemIds)) {
            newPoIdsArr.push(itemIds);
          } else {
            // remove single line item from poIds
            var itemIdInd = newPoIdsArr.indexOf(itemIds);
            newPoIdsArr.splice(itemIdInd, 1);
          }
          _this.setState({ poIds: newPoIdsArr });
        }
      }
    });
    Object.defineProperty(_this, 'toggleEditMode', {
      enumerable: true,
      writable: true,
      value: function value(bool) {
        return _this.setState({ isInEditMode: bool });
      }
    });
    Object.defineProperty(_this, 'renderRow', {
      enumerable: true,
      writable: true,
      value: function value(item, originalExists) {
        var _this$props2 = _this.props,
            documents = _this$props2.documents,
            lpa = _this$props2.lpa,
            role = _this$props2.role,
            purchaseOrderOptions = _this$props2.purchaseOrderOptions,
            phaseLineItems = _this$props2.phaseLineItems,
            expandableRow = _this$props2.expandableRow,
            projectNumber = _this$props2.projectNumber;

        return react_default.a.createElement(purchaseOrderRow, {
          key: item.id,
          projectNumber: projectNumber,
          role: role,
          onSave: _this.handleSave,
          onDelete: _this.handleDelete,
          lineItem: item,
          originalExists: originalExists,
          documents: documents,
          readOnly: !lpa && !Object(services["a" /* can */])(role, 'update', 'purchase_order', { obj_status: item.invoice_status }),
          purchaseOrderOptions: purchaseOrderOptions,
          phaseLineItems: phaseLineItems,
          toggleLineItem: _this.state.isInEditMode ? null : function () {
            return _this.togglePoLineItems(item.id);
          },
          expandableRow: expandableRow
        });
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props3 = _this.props,
            lineItems = _this$props3.lineItems,
            total = _this$props3.total,
            editable = _this$props3.editable,
            phaseId = _this$props3.phaseId,
            cv = _this$props3.cv,
            filterLineItems = _this$props3.filterLineItems,
            role = _this$props3.role;
        var poIds = _this.state.poIds;

        var originalExists = _this.determineOriginalExists(lineItems);
        return react_default.a.createElement(
          'div',
          null,
          react_default.a.createElement(
            components_LineItemTable,
            {
              title: 'Purchase Orders',
              refreshList: _this.refreshLineItemList,
              total: total,
              hasCreatableRow: editable,
              readOnly: !editable,
              toggleEditMode: _this.toggleEditMode,
              diffChildren: !cv,
              cv: cv,
              accountingTable: true
            },
            lineItems.map(function (item) {
              return cv ? _this.renderRow(item, originalExists) : react_default.a.createElement(
                'div',
                { key: item.id },
                _this.renderRow(item, originalExists),
                !cv && poIds.includes(item.id) && react_default.a.createElement(phaseLineItemTables, {
                  poNumber: item.number,
                  poId: item.id,
                  phaseId: phaseId,
                  filterLineItems: filterLineItems,
                  onMergeToOriginal: _this.handleMergeToOriginal,
                  canMergeToOriginal: Object(services["a" /* can */])(role, 'merge_to_original', 'purchase_order') && originalExists
                })
              );
            })
          )
        );
      }
    });

    _this.state = { poIds: [], isInEditMode: false };
    return _this;
  }

  return PurchaseOrderTable;
}(react["Component"]);

purchaseOrderTable_PurchaseOrderTable.defaultProps = {
  parentLineItems: [],
  lineItems: [],
  documents: [],
  cv: false,
  showLineItems: false,
  expandableRow: false,
  filterLineItems: false
};

purchaseOrderTable_PurchaseOrderTable.propTypes = {
  projectNumber: prop_types_default.a.string,
  phaseId: prop_types_default.a.string,
  tableName: prop_types_default.a.string,
  toggleShowHide: prop_types_default.a.func,
  requestPhaseItems: prop_types_default.a.func.isRequired,
  savePhaseItem: prop_types_default.a.func.isRequired,
  deletePhaseItem: prop_types_default.a.func.isRequired,
  lineItems: prop_types_default.a.arrayOf(prop_types_default.a.shape(purchaseOrder)),
  parentLineItems: prop_types_default.a.arrayOf(prop_types_default.a.shape(purchaseOrder)),
  documents: prop_types_default.a.arrayOf(documentUpload).isRequired,
  total: prop_types_default.a.number,
  editable: prop_types_default.a.bool,
  lpa: prop_types_default.a.bool,
  showLineItems: prop_types_default.a.bool,
  role: prop_types_default.a.string,
  purchaseOrderOptions: purchaseOrderOptionsType,
  phaseLineItems: prop_types_default.a.arrayOf(prop_types_default.a.object),
  cv: prop_types_default.a.bool,
  expandableRow: prop_types_default.a.bool,
  filterLineItems: prop_types_default.a.bool,
  mergePurchaseOrderToOriginal: prop_types_default.a.func.isRequired
};

var purchaseOrderTable_mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    projectNumber: state.phase.details.project_number,
    purchaseOrderOptions: selectors_purchaseOrderOptions(state),
    phaseLineItems: getPhaseLineItemsWithTotal(state),
    lineItems: (ownProps.parentLineItems || []).length > 0 ? ownProps.parentLineItems : state.phase.purchaseOrders.items,
    total: selectors_lineItemTotal(state.phase.purchaseOrders.items),
    editable: Object(services["a" /* can */])(Object(reducers["_12" /* getRole */])(state), 'editable', 'purchase_order'),
    lpa: Object(services["a" /* can */])(Object(reducers["_12" /* getRole */])(state), 'update', 'LPA'),
    role: Object(reducers["_12" /* getRole */])(state)
  };
};

/* harmony default export */ var purchaseOrderTable = (Object(react_redux_es["connect"])(purchaseOrderTable_mapStateToProps, {
  savePhaseItem: actionCreators["_41" /* savePhaseItem */],
  deletePhaseItem: actionCreators["x" /* deletePhaseItem */],
  requestPhaseItems: actionCreators["_17" /* requestPhaseItems */],
  mergePurchaseOrderToOriginal: actionCreators["N" /* mergePurchaseOrderToOriginal */]
})(purchaseOrderTable_PurchaseOrderTable));
// CONCATENATED MODULE: ./client/app/shared/types/contractorLineItem.js


var ContractorLineItemType = prop_types_default.a.shape({
  description: prop_types_default.a.string,
  id: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]),
  item_number: prop_types_default.a.string,
  line_item_id: prop_types_default.a.number,
  price: prop_types_default.a.number,
  quantity: prop_types_default.a.number,
  labor_sheet_id: prop_types_default.a.number,
  note: prop_types_default.a.string
});

/* harmony default export */ var contractorLineItem = (ContractorLineItemType);
// CONCATENATED MODULE: ./client/app/shared/types/laborSheet.js






var LaborSheetType = prop_types_default.a.shape({
  id: prop_types_default.a.number,
  quickbooks_reference: prop_types_default.a.string,
  signed_document: documentUpload,
  status: prop_types_default.a.string,
  total: prop_types_default.a.number,
  line_items: prop_types_default.a.arrayOf(contractorLineItem),
  assignee: types_assignee,
  appointment: AppointmentType
});

/* harmony default export */ var types_laborSheet = (LaborSheetType);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseAccounting/components/laborSheetRow.jsx
var laborSheetRow__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var laborSheetRow__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function laborSheetRow__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function laborSheetRow__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function laborSheetRow__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function laborSheetRow__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





















var STATUSES = ['Pending Review', 'Ready for Accounting', 'Approved by Contractor', 'Recorded', 'Not Payable'];
var RESTRICTED_STATUSES = ['Pending Review', 'Ready for Accounting', 'Approved by Contractor', 'Not Payable'];
var laborSheetRow_SIGNED_DOCUMENT_TYPES = ['Signed Documents'];
var READY_FOR_ACCOUNTING = 'Ready for Accounting';

var laborSheetRow_LaborSheetRow = function (_Editable) {
  laborSheetRow__inherits(LaborSheetRow, _Editable);

  function LaborSheetRow() {
    var _ref;

    var _temp, _this, _ret;

    laborSheetRow__classCallCheck(this, LaborSheetRow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = laborSheetRow__possibleConstructorReturn(this, (_ref = LaborSheetRow.__proto__ || Object.getPrototypeOf(LaborSheetRow)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'state', {
      enumerable: true,
      writable: true,
      value: laborSheetRow__extends({ originalStatus: _this.props.lineItem.status }, _this.props.lineItem)
    }), Object.defineProperty(_this, 'handleChange', {
      enumerable: true,
      writable: true,
      value: function value(attr) {
        return function (val) {
          var value = _this.sanatize(attr, val);
          _this.setState(laborSheetRow__defineProperty({}, attr, value));
        };
      }
    }), Object.defineProperty(_this, 'handleReferenceChange', {
      enumerable: true,
      writable: true,
      value: _this.handleChange('quickbooks_reference')
    }), Object.defineProperty(_this, 'handleSignedDocumentChange', {
      enumerable: true,
      writable: true,
      value: _this.handleChange('signed_document_id')
    }), Object.defineProperty(_this, 'handleStatusChange', {
      enumerable: true,
      writable: true,
      value: _this.handleChange('status')
    }), Object.defineProperty(_this, 'handleSave', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.props.onSave(_this.state);
      }
    }), Object.defineProperty(_this, 'formatOptions', {
      enumerable: true,
      writable: true,
      value: function value(options) {
        return options.map(function (option) {
          return { value: option, label: option };
        });
      }
    }), Object.defineProperty(_this, 'isQualifiedForLrrp', {
      enumerable: true,
      writable: true,
      value: function value() {
        var phase = _this.props.phase;

        if (!phase) return false;
        var lead_practices_required = phase.lead_practices_required,
            year_built = phase.year_built,
            source = phase.source,
            workroom = phase.workroom;

        if (!lead_practices_required) return false;
        if (year_built && year_built > 1977) return false;
        var noLrrpVendorsExceptIfi = constants["_8" /* NON_LHI_SOURCES */].filter(function (v) {
          return v !== 'IFI';
        });
        if (noLrrpVendorsExceptIfi.includes(source)) return false;
        // Use naming convention to match backend PFT workrooms (all start with 'PFT-')
        // This avoids hardcoding the list and matches existing client code patterns
        if (workroom && workroom.name && workroom.name.startsWith('PFT-')) return false;
        return true;
      }
    }), Object.defineProperty(_this, 'isLrrpCompleted', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            phase = _this$props.phase,
            documents = _this$props.documents;

        if (!phase) return false;

        // Check for completed LRRP task when applicable
        // Prefer phase_tasks (full task history) over current_tasks (only tasks for current status)
        // This ensures we detect completed tasks even after phase moves to a different status
        // Only Installation and Workorder phases have LRRP tasks (matches backend logic)
        var lrrpTaskSlug = null;
        if (phase.type === 'Installation') {
          lrrpTaskSlug = 'sign_lrrp';
        } else if (phase.type === 'Workorder') {
          lrrpTaskSlug = 'lead_assessment';
        }

        if (lrrpTaskSlug) {
          var allTasks = phase.phase_tasks && Array.isArray(phase.phase_tasks) ? phase.phase_tasks : phase.current_tasks || [];
          var lrrpTask = allTasks.find(function (task) {
            return task && task.slug === lrrpTaskSlug && task.status === 'complete';
          });
          if (lrrpTask) return true;
        }

        // Check for LRRP document
        var lrrpDocument = documents && documents.find(function (doc) {
          return doc.document_type === 'LRRP Checklists' && !doc.not_use;
        });
        if (lrrpDocument) return true;

        return false;
      }
    }), Object.defineProperty(_this, 'hasBuildDate', {
      enumerable: true,
      writable: true,
      value: function value() {
        var phase = _this.props.phase;

        return phase && phase.year_built != null;
      }
    }), Object.defineProperty(_this, 'shouldBlockReadyForAccounting', {
      enumerable: true,
      writable: true,
      value: function value() {
        if (!_this.isQualifiedForLrrp()) return false;
        return !(_this.hasBuildDate() && _this.isLrrpCompleted());
      }
    }), Object.defineProperty(_this, 'determineStatusChoices', {
      enumerable: true,
      writable: true,
      value: function value(status) {
        var statuses = void 0;
        if (['admin', 'accounting'].includes(_this.props.role)) {
          statuses = STATUSES;
        } else if (RESTRICTED_STATUSES.includes(status)) {
          statuses = RESTRICTED_STATUSES;
        } else {
          statuses = RESTRICTED_STATUSES.concat([status]);
        }

        // Filter out "Ready for Accounting" if LRRP requirements aren't met,
        // but keep it if it's already the current status so the dropdown
        // can still display the existing value.
        if (_this.shouldBlockReadyForAccounting() && status !== READY_FOR_ACCOUNTING) {
          statuses = statuses.filter(function (s) {
            return s !== READY_FOR_ACCOUNTING;
          });
        }

        return statuses;
      }
    }), Object.defineProperty(_this, 'determineAppproved', {
      enumerable: true,
      writable: true,
      value: function value(lineItem) {
        var status = lineItem.status,
            signed_document_id = lineItem.signed_document_id;

        if (status === 'Approved by Contractor' && signed_document_id || status !== 'Approved by Contractor' && status !== 'Not Payable' && status !== 'Pending Review') {
          return true;
        }
        return false;
      }
    }), Object.defineProperty(_this, 'determineBlockedByApproved', {
      enumerable: true,
      writable: true,
      value: function value(approved, role) {
        if (approved && !Object(services["a" /* can */])(role, 'manage', 'approved_labor')) {
          return true;
        }
        return false;
      }
    }), Object.defineProperty(_this, 'determineCanEdit', {
      enumerable: true,
      writable: true,
      value: function value(readOnly, blockedByApproved) {
        var tempLineItem = { status: _this.state.originalStatus, signed_document_id: null };
        if (!readOnly && (!blockedByApproved || blockedByApproved && !_this.determineAppproved(tempLineItem))) {
          return true;
        }
        return false;
      }
    }), Object.defineProperty(_this, 'renderAppointmentLink', {
      enumerable: true,
      writable: true,
      value: function value() {
        var appointment = _this.state.appointment;

        var appointmentUrlObject = laborSheetRow__extends({}, appointment);
        appointmentUrlObject.phase = { id: _this.props.phaseId };
        return react_default.a.createElement(
          es["c" /* Link */],
          { to: urls.appointment(appointmentUrlObject) },
          Object(dateUtils["m" /* getSimpleLocalDate */])(appointment.end_date)
        );
      }
    }), Object.defineProperty(_this, 'renderTableDesktop', {
      enumerable: true,
      writable: true,
      value: function value() {
        var lineItem = _this.state;
        var _this$props2 = _this.props,
            documents = _this$props2.documents,
            index = _this$props2.index,
            readOnly = _this$props2.readOnly,
            role = _this$props2.role,
            canViewTotal = _this$props2.canViewTotal,
            toggleLineItem = _this$props2.toggleLineItem;

        var documentOptions = utils_documents(documents, laborSheetRow_SIGNED_DOCUMENT_TYPES);
        var total = Object(lineItemUtils["g" /* formatDollars */])(lineItem.total);
        var appointmentLink = _this.renderAppointmentLink();
        var assigneeLink = react_default.a.createElement(
          es["c" /* Link */],
          { to: linkTo(lineItem.assignee), target: '_blank' },
          lineItem.assignee.name
        );
        var approved = _this.determineAppproved(lineItem);
        var blockedByApproved = _this.determineBlockedByApproved(approved, role);
        var canEdit = _this.determineCanEdit(readOnly, blockedByApproved);
        var rowProps = { isNew: lineItem.id < 0, onSave: _this.handleSave, readOnly: !canEdit };

        return react_default.a.createElement(
          editableTableRow,
          laborSheetRow__extends({
            key: lineItem.id,
            id: lineItem.id,
            deleteDialog: true
          }, rowProps, {
            toggleLineItem: toggleLineItem,
            expandableRow: true
          }),
          react_default.a.createElement(components_LineItemTable_itemEvents, {
            display: !_this.context.isEditable,
            label: '',
            itemType: 'laborSheets',
            lineItem: lineItem,
            dataKeys: ['assignee.name', 'signed_document.document_name', 'status', 'total', 'quickbooks_reference']
          }),
          react_default.a.createElement(
            editableTableCell,
            { value: index, label: 'Id' },
            index
          ),
          react_default.a.createElement(
            editableTableCell,
            { value: assigneeLink, label: 'Contractor' },
            assigneeLink
          ),
          react_default.a.createElement(
            editableTableCell,
            { value: appointmentLink, label: 'Appointment End' },
            appointmentLink
          ),
          react_default.a.createElement(
            dropDownCell,
            {
              attr: 'signed_document',
              isIdAttr: true,
              label: 'Signed Document',
              lineItem: lineItem,
              options: documentOptions,
              onChange: _this.handleSignedDocumentChange,
              clearable: true
            },
            react_default.a.createElement(components_LineItemTable_documentLink, { documents: documents, id: lineItem.signed_document_id })
          ),
          react_default.a.createElement(dropDownCell, {
            attr: 'status',
            label: 'Payment Status',
            lineItem: lineItem,
            options: _this.formatOptions(_this.determineStatusChoices(lineItem.status)),
            onChange: _this.handleStatusChange
          }),
          canViewTotal && react_default.a.createElement(
            editableTableCell,
            { value: total, label: 'Total' },
            total
          ),
          react_default.a.createElement(inputCell, { attr: 'quickbooks_reference', label: 'QB Reference', lineItem: lineItem, onChange: _this.handleReferenceChange })
        );
      }
    }), Object.defineProperty(_this, 'renderTableMobile', {
      enumerable: true,
      writable: true,
      value: function value() {
        var lineItem = _this.state;
        var _this$props3 = _this.props,
            documents = _this$props3.documents,
            index = _this$props3.index,
            readOnly = _this$props3.readOnly,
            role = _this$props3.role,
            canViewTotal = _this$props3.canViewTotal,
            toggleLineItem = _this$props3.toggleLineItem;

        var documentOptions = utils_documents(documents, laborSheetRow_SIGNED_DOCUMENT_TYPES);
        var total = Object(lineItemUtils["g" /* formatDollars */])(lineItem.total);
        var appointmentLink = _this.renderAppointmentLink();
        var assigneeLink = react_default.a.createElement(
          es["c" /* Link */],
          { to: linkTo(lineItem.assignee), target: '_blank' },
          lineItem.assignee.name
        );
        var approved = _this.determineAppproved(lineItem);
        var blockedByApproved = _this.determineBlockedByApproved(approved, role);
        var canEdit = _this.determineCanEdit(readOnly, blockedByApproved);
        var rowProps = { isNew: lineItem.id < 0, onSave: _this.handleSave, readOnly: !canEdit };

        return react_default.a.createElement(
          editableTableRow,
          laborSheetRow__extends({
            key: lineItem.id,
            id: lineItem.id,
            deleteDialog: true,
            toggleLineItem: toggleLineItem
          }, rowProps),
          react_default.a.createElement(
            editableTableCell,
            { value: index, label: 'Id' },
            index
          ),
          react_default.a.createElement(
            editableTableCell,
            { value: assigneeLink, label: 'Contractor' },
            assigneeLink
          ),
          react_default.a.createElement(
            editableTableCell,
            { value: appointmentLink, label: 'Appointment End' },
            appointmentLink
          ),
          react_default.a.createElement(
            dropDownCell,
            {
              attr: 'signed_document',
              isIdAttr: true,
              label: 'Signed Document',
              lineItem: lineItem,
              options: documentOptions,
              onChange: _this.handleSignedDocumentChange,
              clearable: true
            },
            react_default.a.createElement(components_LineItemTable_documentLink, { documents: documents, id: lineItem.signed_document_id })
          ),
          react_default.a.createElement(dropDownCell, {
            attr: 'status',
            label: 'Payment Status',
            lineItem: lineItem,
            options: _this.formatOptions(_this.determineStatusChoices(lineItem.status)),
            onChange: _this.handleStatusChange
          }),
          canViewTotal && react_default.a.createElement(
            editableTableCell,
            { value: total, label: 'Total' },
            total
          ),
          react_default.a.createElement(inputCell, { attr: 'quickbooks_reference', label: 'QB Reference', lineItem: lineItem, onChange: _this.handleReferenceChange }),
          react_default.a.createElement(
            'td',
            null,
            react_default.a.createElement(
              'div',
              null,
              react_default.a.createElement(
                'table',
                { className: laborTables_default.a.inlineTableItem },
                react_default.a.createElement(
                  'tbody',
                  { className: laborTables_default.a.inlineTableItem },
                  react_default.a.createElement(
                    'tr',
                    { className: laborTables_default.a.iconWrapper },
                    react_default.a.createElement(components_LineItemTable_itemEvents, {
                      display: !_this.context.isEditable,
                      label: '',
                      itemType: 'laborSheets',
                      lineItem: lineItem,
                      dataKeys: ['assignee.name', 'signed_document.document_name', 'status', 'total', 'quickbooks_reference']
                    })
                  )
                )
              )
            )
          )
        );
      }
    }), _temp), laborSheetRow__possibleConstructorReturn(_this, _ret);
  }

  // Check if phase is qualified for LRRP (would normally require LRRP)


  // Check if LRRP paperwork is completed


  // Check if phase has build date


  // Check if "Ready for Accounting" should be blocked


  /*
   * This is using the same logic used to generate the Approve/Approved
   * button on a given labor table to maintain consistency.
   */


  /*
   * As long as the given role isn't readOnly in the first place and
   * the original status (before changing and saving in edit mode),
   * we can edit the line item. This allows certain roles to change
   * to a 'forbidden status' and save the change, waiting until
   * after they make their allowed changes to block them from editing.
   */


  laborSheetRow__createClass(LaborSheetRow, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return react_default.a.createElement(
        react_responsive_default.a,
        { minWidth: constants["y" /* CUT_POINT */] },
        function (matches) {
          if (matches) {
            return _this2.renderTableDesktop();
          }
          return _this2.renderTableMobile();
        }
      );
    }
  }]);

  return LaborSheetRow;
}(mixins_editable(react_default.a.Component));

laborSheetRow_LaborSheetRow.contextTypes = {
  isEditable: prop_types_default.a.bool
};

laborSheetRow_LaborSheetRow.propTypes = {
  role: prop_types_default.a.string,
  lineItem: types_laborSheet.isRequired,
  onSave: prop_types_default.a.func.isRequired,
  documents: prop_types_default.a.arrayOf(documentUpload).isRequired,
  index: prop_types_default.a.number,
  phaseId: prop_types_default.a.string,
  readOnly: prop_types_default.a.bool,
  canViewTotal: prop_types_default.a.bool,
  phase: prop_types_default.a.object
};

/* harmony default export */ var laborSheetRow = (laborSheetRow_LaborSheetRow);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseAccounting/components/contractorLaborRow.jsx
var contractorLaborRow__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function contractorLaborRow__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function contractorLaborRow__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function contractorLaborRow__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function contractorLaborRow__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var contractorLaborRow_ContractorLaborRow = function (_Editable) {
  contractorLaborRow__inherits(ContractorLaborRow, _Editable);

  function ContractorLaborRow() {
    var _ref;

    var _temp, _this, _ret;

    contractorLaborRow__classCallCheck(this, ContractorLaborRow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = contractorLaborRow__possibleConstructorReturn(this, (_ref = ContractorLaborRow.__proto__ || Object.getPrototypeOf(ContractorLaborRow)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'state', {
      enumerable: true,
      writable: true,
      value: contractorLaborRow__extends({}, _this.props.lineItem, {
        original_item: _this.props.lineItem.item_number || null,
        errors: {}
      })
    }), Object.defineProperty(_this, 'handleSave', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.onSave(_this.state);
      }
    }), Object.defineProperty(_this, 'handleDelete', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.onDelete(_this.state.id);
      }
    }), Object.defineProperty(_this, 'handleChange', {
      enumerable: true,
      writable: true,
      value: function value(attr) {
        return function (val) {
          var _this$state = _this.state,
              _this$state$fixedTota = _this$state.fixedTotal,
              fixedTotal = _this$state$fixedTota === undefined ? false : _this$state$fixedTota,
              _this$state$fixedPric = _this$state.fixedPrice,
              fixedPrice = _this$state$fixedPric === undefined ? false : _this$state$fixedPric,
              statePrice = _this$state.price,
              quantity = _this$state.quantity;

          var value = val.target ? val.target.value : val;
          var price = attr === 'price' ? value : statePrice;
          var qty = attr === 'quantity' ? value : quantity;
          if (!fixedTotal && !fixedPrice) {
            var _this$setState;

            var total = Object(lineItemUtils["c" /* calculateTotal */])(price, qty);
            _this.setState((_this$setState = {}, contractorLaborRow__defineProperty(_this$setState, attr, value), contractorLaborRow__defineProperty(_this$setState, 'total', total), _this$setState));
          } else if (!fixedTotal) {
            var _this$setState2;

            var _total = Object(lineItemUtils["c" /* calculateTotal */])(statePrice, qty);
            _this.setState((_this$setState2 = {}, contractorLaborRow__defineProperty(_this$setState2, attr, attr === 'price' ? statePrice : value), contractorLaborRow__defineProperty(_this$setState2, 'total', _total), _this$setState2));
          } else if (attr === 'note') _this.setState(contractorLaborRow__defineProperty({}, attr, value));
        };
      }
    }), Object.defineProperty(_this, 'handleDescriptionChange', {
      enumerable: true,
      writable: true,
      value: function value(val) {
        var lineItem = _this.state;
        var lineItemOptions = _this.props.lineItemOptions;

        var option = lineItemOptions.find(function (o) {
          return o.value === val;
        });
        var label = option.label,
            price = option.price,
            _option$fixedPrice = option.fixedPrice,
            fixedPrice = _option$fixedPrice === undefined ? false : _option$fixedPrice,
            _option$total = option.total,
            configTotal = _option$total === undefined ? null : _option$total,
            _option$fixedTotal = option.fixedTotal,
            fixedTotal = _option$fixedTotal === undefined ? false : _option$fixedTotal;

        var itemNumber = label.split(' ')[0];
        var total = configTotal || Object(lineItemUtils["c" /* calculateTotal */])(price, lineItem.quantity);
        _this.setState({
          line_item_id: val,
          total: total,
          price: price,
          item_number: itemNumber,
          fixedPrice: fixedPrice,
          fixedTotal: fixedTotal,
          quantity: configTotal ? '1' : null
        });
      }
    }), Object.defineProperty(_this, 'getItemNumberFromLabel', {
      enumerable: true,
      writable: true,
      value: function value(_ref2) {
        var label = _ref2.label;
        return label.substring(0, label.indexOf(' - '));
      }
    }), Object.defineProperty(_this, 'filterItemSelection', {
      enumerable: true,
      writable: true,
      value: function value(options) {
        var original_item = _this.state.original_item;
        var _this$props = _this.props,
            phaseType = _this$props.phaseType,
            surfaceType = _this$props.surfaceType,
            filterLineItems = _this$props.filterLineItems,
            phaseSource = _this$props.phaseSource;

        var filteredOptions = options;
        if (filterLineItems) {
          filteredOptions = options.filter(function (o) {
            return !o.surface_type || o.label.includes(original_item) || [surfaceType, 'Multi', 'All'].includes(o.surface_type);
          });
        }
        filteredOptions = Object(lineItemUtils["f" /* filterByVendor */])(filteredOptions, phaseSource);
        return phaseType !== 'Assessment' ? filteredOptions : filteredOptions.filter(function (i) {
          return constants["k" /* ASSESSMENT_LABOR_ITEMS */].includes(_this.getItemNumberFromLabel(i)) || constants["b" /* ADDTL_MILEAGE_ITEMS */].includes(_this.getItemNumberFromLabel(i)) || constants["j" /* ASSESSMENT_DETAIL_ITEMS */].includes(_this.getItemNumberFromLabel(i));
        });
      }
    }), Object.defineProperty(_this, 'blockItemCellEdit', {
      enumerable: true,
      writable: true,
      value: function value(options, item) {
        return _this.props.phaseType === 'Assessment' && !_this.filterItemSelection(options).some(function (o) {
          return o.label.includes(item.item_number) || o.label.includes(item.description);
        });
      }
    }), Object.defineProperty(_this, 'renderPayRate', {
      enumerable: true,
      writable: true,
      value: function value(lineItem, lpa) {
        return lpa || _this.props.isCustom(lineItem.item_number) ? react_default.a.createElement(inputCell, {
          attr: 'price',
          label: 'Pay Rate',
          lineItem: lineItem,
          onChange: _this.handlePriceChange,
          cellValue: Object(lineItemUtils["g" /* formatDollars */])(lineItem.price)
        }) : react_default.a.createElement(
          editableTableCell,
          {
            value: Object(lineItemUtils["g" /* formatDollars */])(lineItem.price), label: 'Pay Rate'
          },
          Object(lineItemUtils["g" /* formatDollars */])(lineItem.price)
        );
      }
    }), Object.defineProperty(_this, 'renderNote', {
      enumerable: true,
      writable: true,
      value: function value(lineItem, isEditable) {
        var errors = {};
        var val = void 0;
        if (_this.props.isCustom(lineItem.item_number) && isEditable && (lineItem.note == null || lineItem.note === '')) {
          errors.note = ['Required'];
          val = react_default.a.createElement(LineItemTable_itemNote, {
            errors: errors,
            display: true, label: 'Note',
            onChange: _this.handleNoteChange,
            note: lineItem.note,
            id: lineItem.id,
            kind: 'contractorLineItem'
          });
        } else {
          val = react_default.a.createElement(LineItemTable_itemNote, {
            display: true, label: 'Note',
            onChange: _this.handleNoteChange,
            note: lineItem.note,
            id: lineItem.id,
            kind: 'contractorLineItem'
          });
        }
        return val;
      }
    }), Object.defineProperty(_this, 'renderItem', {
      enumerable: true,
      writable: true,
      value: function value(lineItem, isEditable, lineItemOptions, lpa) {
        var val = void 0;
        if (lpa && !_this.blockItemCellEdit(lineItemOptions, lineItem) || lineItem.id < 0) {
          val = react_default.a.createElement(dropDownCell, {
            attr: 'line_item_id',
            label: 'Item Number - Description',
            display: isEditable,
            lineItem: lineItem,
            options: _this.filterItemSelection(lineItemOptions),
            onChange: _this.handleDescriptionChange
          });
        } else {
          val = react_default.a.createElement(
            editableTableCell,
            {
              value: lineItem.item_number,
              display: isEditable,
              label: 'Item Number - Description'
            },
            lineItem.item_number,
            ' - ',
            lineItem.description
          );
        }
        return val;
      }
    }), Object.defineProperty(_this, 'handlePriceChange', {
      enumerable: true,
      writable: true,
      value: _this.handleChange('price')
    }), Object.defineProperty(_this, 'handleQuantityChange', {
      enumerable: true,
      writable: true,
      value: _this.handleChange('quantity')
    }), Object.defineProperty(_this, 'handleTotalChange', {
      enumerable: true,
      writable: true,
      value: _this.handleChange('total')
    }), Object.defineProperty(_this, 'handleNoteChange', {
      enumerable: true,
      writable: true,
      value: _this.handleChange('note')
    }), Object.defineProperty(_this, 'renderTableDesktop', {
      enumerable: true,
      writable: true,
      value: function value() {
        var lineItem = _this.state;
        var _this$props2 = _this.props,
            lineItemOptions = _this$props2.lineItemOptions,
            lpa = _this$props2.lpa,
            role = _this$props2.role,
            isApproved = _this$props2.isApproved,
            canViewTotal = _this$props2.canViewTotal;
        var isEditable = _this.context.isEditable;

        var rowProps = {
          isNew: lineItem.id < 0, onSave: _this.handleSave, onDelete: _this.handleDelete
        };
        var totalValue = Object(lineItemUtils["g" /* formatDollars */])(lineItem.total);
        var hideDelete = isApproved && role !== 'admin';
        return react_default.a.createElement(
          editableTableRow,
          contractorLaborRow__extends({
            key: lineItem.id, id: lineItem.id, hideDelete: hideDelete }, rowProps),
          react_default.a.createElement(components_LineItemTable_itemEvents, {
            display: !_this.context.isEditable,
            label: '',
            itemType: 'contractorLineItems',
            lineItem: lineItem,
            dataKeys: ['item_number', 'description', 'quantity', 'price', 'note']
          }),
          react_default.a.createElement(editableTableCell, { display: !isEditable, value: lineItem.item_number, label: 'Item Number' }),
          react_default.a.createElement(editableTableCell, { display: !isEditable, value: lineItem.description, label: 'Description' }),
          _this.renderItem(lineItem, isEditable, lineItemOptions, lpa),
          react_default.a.createElement(inputCell, {
            attr: 'quantity',
            label: 'QTY',
            lineItem: lineItem,
            onChange: _this.handleQuantityChange
          }),
          canViewTotal && _this.renderPayRate(lineItem, lpa),
          canViewTotal && react_default.a.createElement(
            editableTableCell,
            { value: totalValue, label: 'Total' },
            totalValue
          ),
          _this.renderNote(lineItem, isEditable)
        );
      }
    }), Object.defineProperty(_this, 'renderTableMobile', {
      enumerable: true,
      writable: true,
      value: function value() {
        var lineItem = _this.state;
        var _this$props3 = _this.props,
            lineItemOptions = _this$props3.lineItemOptions,
            lpa = _this$props3.lpa,
            role = _this$props3.role,
            isApproved = _this$props3.isApproved,
            canViewTotal = _this$props3.canViewTotal;
        var isEditable = _this.context.isEditable;

        var rowProps = { isNew: lineItem.id < 0, onSave: _this.handleSave, onDelete: _this.handleDelete };
        var totalValue = Object(lineItemUtils["g" /* formatDollars */])(lineItem.total);
        var hideDelete = isApproved && role !== 'admin';
        return react_default.a.createElement(
          editableTableRow,
          contractorLaborRow__extends({
            key: lineItem.id, id: lineItem.id, hideDelete: hideDelete }, rowProps),
          react_default.a.createElement(editableTableCell, { display: !isEditable, value: lineItem.item_number, label: 'Item Number' }),
          react_default.a.createElement(editableTableCell, { display: !isEditable, value: lineItem.description, label: 'Description' }),
          _this.renderItem(lineItem, isEditable, lineItemOptions, lpa),
          react_default.a.createElement(inputCell, {
            attr: 'quantity',
            label: 'QTY',
            lineItem: lineItem,
            onChange: _this.handleQuantityChange
          }),
          canViewTotal && _this.renderPayRate(lineItem, lpa),
          canViewTotal && react_default.a.createElement(
            editableTableCell,
            { value: totalValue, label: 'Total' },
            totalValue
          ),
          _this.renderNote(lineItem, isEditable),
          react_default.a.createElement(
            'td',
            null,
            react_default.a.createElement(
              'div',
              null,
              react_default.a.createElement(
                'table',
                { className: laborTables_default.a.inlineTableItem },
                react_default.a.createElement(
                  'tbody',
                  { className: laborTables_default.a.inlineTableItem },
                  react_default.a.createElement(
                    'tr',
                    { className: laborTables_default.a.iconWrapper },
                    react_default.a.createElement(components_LineItemTable_itemEvents, {
                      display: !_this.context.isEditable,
                      label: '',
                      itemType: 'contractorLineItems',
                      lineItem: lineItem,
                      dataKeys: ['item_number', 'description', 'quantity', 'price', 'note']
                    })
                  )
                )
              )
            )
          )
        );
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        return react_default.a.createElement(
          react_responsive_default.a,
          { minWidth: constants["y" /* CUT_POINT */] },
          function (matches) {
            return matches ? _this.renderTableDesktop() : _this.renderTableMobile();
          }
        );
      }
    }), _temp), contractorLaborRow__possibleConstructorReturn(_this, _ret);
  }

  return ContractorLaborRow;
}(mixins_editable(react_default.a.Component));

contractorLaborRow_ContractorLaborRow.contextTypes = {
  isEditable: prop_types_default.a.bool, surfaceType: '', filterLineItems: false
};

contractorLaborRow_ContractorLaborRow.propTypes = {
  lineItem: contractorLineItem,
  onSave: prop_types_default.a.func,
  onDelete: prop_types_default.a.func,
  lineItemOptions: prop_types_default.a.array,
  lpa: prop_types_default.a.bool,
  isCustom: prop_types_default.a.func,
  role: prop_types_default.a.string,
  isApproved: prop_types_default.a.bool,
  canViewTotal: prop_types_default.a.bool,
  phaseType: prop_types_default.a.string,
  surfaceType: prop_types_default.a.string,
  filterLineItems: prop_types_default.a.bool,
  phaseSource: prop_types_default.a.string
};

contractorLaborRow_ContractorLaborRow.defaultProps = { lineItem: {}, lineItemOptions: [] };

/* harmony default export */ var contractorLaborRow = (contractorLaborRow_ContractorLaborRow);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseAccounting/components/approveLabor/approvalSignature.jsx
var approvalSignature__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function approvalSignature__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function approvalSignature__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function approvalSignature__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var approvalSignature_ApprovalSignature = function (_Resetter) {
  approvalSignature__inherits(ApprovalSignature, _Resetter);

  function ApprovalSignature() {
    var _ref;

    var _temp, _this, _ret;

    approvalSignature__classCallCheck(this, ApprovalSignature);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = approvalSignature__possibleConstructorReturn(this, (_ref = ApprovalSignature.__proto__ || Object.getPrototypeOf(ApprovalSignature)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'state', {
      enumerable: true,
      writable: true,
      value: {
        contractorSignature: _this.props.contractorSignature || '',
        clearSignature: 0,
        errors: {}
      }
    }), Object.defineProperty(_this, 'handleSubmit', {
      enumerable: true,
      writable: true,
      value: function value() {
        if (!_this.validate()) {
          return;
        }
        _this.props.updateFormData({
          contractorSignature: _this.state.contractorSignature,
          tab: 3
        });
      }
    }), Object.defineProperty(_this, 'handlePrevious', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.props.updateFormData({
          contractorSignature: _this.state.contractorSignature,
          tab: 1
        });
      }
    }), Object.defineProperty(_this, 'handleSignatureChange', {
      enumerable: true,
      writable: true,
      value: function value(data) {
        _this.setState({ contractorSignature: data });
      }
    }), Object.defineProperty(_this, 'handleClear', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.setState({
          contractorSignature: '',
          clearSignature: Date.now()
        });
      }
    }), _temp), approvalSignature__possibleConstructorReturn(_this, _ret);
  }

  approvalSignature__createClass(ApprovalSignature, [{
    key: 'render',
    value: function render() {
      var _state = this.state,
          clearSignature = _state.clearSignature,
          errors = _state.errors;

      return react_default.a.createElement(
        react["Fragment"],
        null,
        react_default.a.createElement(components_SignatureBox, {
          required: true,
          label: 'Sign Contractor\'s Name *',
          clearTimestamp: clearSignature,
          errors: errors.contractorSignature,
          onEnd: this.handleSignatureChange,
          onClear: this.handleClear
        }),
        react_default.a.createElement(react_toolbox_lib["Button"], { label: 'Approve', flat: true, inverse: true, ripple: true, className: modal_default.a.submit, onClick: this.handleSubmit }),
        react_default.a.createElement(react_toolbox_lib["Button"], { label: 'Previous', flat: true, inverse: true, ripple: true, className: modal_default.a.submit, onClick: this.handlePrevious })
      );
    }
  }]);

  return ApprovalSignature;
}(resetter(validator(react_default.a.Component)));

Object.defineProperty(approvalSignature_ApprovalSignature, 'VALIDATIONS', {
  enumerable: true,
  writable: true,
  value: {
    contractorSignature: true
  }
});


approvalSignature_ApprovalSignature.propTypes = {
  errors: prop_types_default.a.shape({
    contractorSignature: prop_types_default.a.arrayOf(prop_types_default.a.string)
  })
};

/* harmony default export */ var approvalSignature = (Object(react_redux_es["connect"])(function (state) {
  return { errors: state.phase.laborSheets.errors };
}, {})(approvalSignature_ApprovalSignature));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseAccounting/components/approveLabor/termsAndName.jsx
var termsAndName__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function termsAndName__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function termsAndName__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function termsAndName__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var termsAndName_TermsAndName = function (_Resetter) {
  termsAndName__inherits(TermsAndName, _Resetter);

  function TermsAndName() {
    var _ref;

    var _temp, _this, _ret;

    termsAndName__classCallCheck(this, TermsAndName);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = termsAndName__possibleConstructorReturn(this, (_ref = TermsAndName.__proto__ || Object.getPrototypeOf(TermsAndName)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'state', {
      enumerable: true,
      writable: true,
      value: {
        approveTerms: _this.props.approveTerms || false,
        contractorName: _this.props.contractorName || '',
        errors: {}
      }
    }), Object.defineProperty(_this, 'handleSubmit', {
      enumerable: true,
      writable: true,
      value: function value() {
        if (!_this.validate()) {
          return;
        }
        _this.props.updateFormData({
          contractorName: _this.state.contractorName,
          approveTerms: _this.state.approveTerms,
          tab: 2
        });
      }
    }), Object.defineProperty(_this, 'handleNameChange', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        _this.setState({ contractorName: e.target.value });
      }
    }), Object.defineProperty(_this, 'handleApproveTermsChange', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.setState({ approveTerms: !_this.state.approveTerms });
      }
    }), _temp), termsAndName__possibleConstructorReturn(_this, _ret);
  }

  termsAndName__createClass(TermsAndName, [{
    key: 'render',
    value: function render() {
      var _state = this.state,
          contractorName = _state.contractorName,
          errors = _state.errors;

      return react_default.a.createElement(
        react["Fragment"],
        null,
        react_default.a.createElement(components_CheckBox, {
          label: 'Approve Terms *',
          required: true,
          text: 'I confirm I\'ve read and agree with the payment terms.',
          errors: errors.approveTerms, onChange: this.handleApproveTermsChange,
          checked: this.state.approveTerms
        }),
        react_default.a.createElement(components_SimpleInput, {
          label: 'Print Contractor\'s Name *',
          required: true,
          text: contractorName,
          errors: errors.contractorName,
          onChange: this.handleNameChange
        }),
        react_default.a.createElement(react_toolbox_lib["Button"], { label: 'Next', flat: true, inverse: true, ripple: true, className: modal_default.a.submit, onClick: this.handleSubmit })
      );
    }
  }]);

  return TermsAndName;
}(resetter(validator(react_default.a.Component)));

Object.defineProperty(termsAndName_TermsAndName, 'VALIDATIONS', {
  enumerable: true,
  writable: true,
  value: {
    contractorName: true,
    approveTerms: true
  }
});


termsAndName_TermsAndName.propTypes = {
  errors: prop_types_default.a.shape({
    approveTerms: prop_types_default.a.arrayOf(prop_types_default.a.string),
    contractorName: prop_types_default.a.arrayOf(prop_types_default.a.string)
  })
};

/* harmony default export */ var termsAndName = (Object(react_redux_es["connect"])(function (state) {
  return { errors: state.phase.laborSheets.errors };
}, {})(termsAndName_TermsAndName));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseAccounting/components/approveLaborModal.jsx
var approveLaborModal__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var approveLaborModal__get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function approveLaborModal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function approveLaborModal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function approveLaborModal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var approveLaborModal_ApproveLaborModal = function (_Resetter) {
  approveLaborModal__inherits(ApproveLaborModal, _Resetter);

  function ApproveLaborModal() {
    var _ref;

    var _temp, _this, _ret;

    approveLaborModal__classCallCheck(this, ApproveLaborModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = approveLaborModal__possibleConstructorReturn(this, (_ref = ApproveLaborModal.__proto__ || Object.getPrototypeOf(ApproveLaborModal)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'updateFormData', {
      enumerable: true,
      writable: true,
      value: function value(approveLaborData) {
        _this.setState(approveLaborData, function () {
          if (approveLaborData.tab === 3) {
            var _this$state = _this.state,
                name = _this$state.contractorName,
                signature = _this$state.contractorSignature;

            _this.props.approveLaborSheet(_this.props.phaseId, _this.props.laborSheetId, { name: name, signature: signature }).then(function () {
              _this.handleClose();
            }).catch(function () {});
          }
        });
      }
    }), Object.defineProperty(_this, 'showTab', {
      enumerable: true,
      writable: true,
      value: function value() {
        switch (_this.state.tab) {
          case 1:
            return react_default.a.createElement(termsAndName, {
              phase: _this.props.phase,
              updateFormData: _this.updateFormData,
              approveTerms: _this.state.approveTerms,
              contractorName: _this.state.customerName
            });
          case 2:
            return react_default.a.createElement(approvalSignature, {
              phase: _this.props.phase,
              updateFormData: _this.updateFormData,
              contractorSignature: _this.state.contractorSignature
            });
          default:
            return react_default.a.createElement(components_Loading, null);
        }
      }
    }), _temp), approveLaborModal__possibleConstructorReturn(_this, _ret);
  }

  approveLaborModal__createClass(ApproveLaborModal, [{
    key: 'handleClose',
    value: function handleClose() {
      approveLaborModal__get(ApproveLaborModal.prototype.__proto__ || Object.getPrototypeOf(ApproveLaborModal.prototype), 'handleClose', this).call(this);
      this.props.clearValidation();
      document.location.reload();
    }
  }, {
    key: 'render',
    value: function render() {
      return react_default.a.createElement(
        react_toolbox_lib["Dialog"],
        {
          active: this.props.active,
          className: modal_default.a.modal,
          type: 'fullscreen',
          onEscKeyDown: this.handleClose
        },
        react_default.a.createElement(
          'div',
          { className: input_default.a.errored },
          this.props.errors && Object.keys(this.props.errors).length > 0 && react_default.a.createElement(
            'span',
            { className: input_default.a.error },
            'This action could not be completed.'
          )
        ),
        react_default.a.createElement(react_toolbox_lib["IconButton"], {
          icon: 'close',
          className: modal_default.a.close,
          onClick: this.handleClose,
          tabIndex: -1
        }),
        react_default.a.createElement(
          'h5',
          { className: modal_default.a.title },
          'Approve Labor'
        ),
        this.showTab()
      );
    }
  }]);

  return ApproveLaborModal;
}(resetter(validator(react_default.a.Component)));

Object.defineProperty(approveLaborModal_ApproveLaborModal, 'DEFAULT_STATE', {
  enumerable: true,
  writable: true,
  value: {
    approveTerms: false,
    contractorSignature: '',
    contractorName: '',
    errors: {},
    tab: 1
  }
});
Object.defineProperty(approveLaborModal_ApproveLaborModal, 'VALIDATIONS', {
  enumerable: true,
  writable: true,
  value: {
    contractorSignature: true,
    contractorName: true,
    approveTerms: true
  }
});


approveLaborModal_ApproveLaborModal.propTypes = {
  phaseId: prop_types_default.a.number.isRequired,
  laborSheetId: prop_types_default.a.number.isRequired,
  approveLaborSheet: prop_types_default.a.func.isRequired,
  onClose: prop_types_default.a.func.isRequired,
  errors: prop_types_default.a.object
};

/* harmony default export */ var approveLaborModal = (Object(react_redux_es["connect"])(function (state) {
  return { errors: state.phase.laborSheets.errors };
}, {
  approveLaborSheet: phase_items["a" /* approveLaborSheet */],
  updatePhaseTask: actionCreators_phase["s" /* updatePhaseTask */],
  clearValidation: actionCreators["j" /* clearValidation */]
})(approveLaborModal_ApproveLaborModal));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseAccounting/components/contractorLaborTable.jsx
var contractorLaborTable__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function contractorLaborTable__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function contractorLaborTable__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function contractorLaborTable__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






















var contractorLaborTable_LINE_ITEM_TYPE = 'contractorLineItems';

var contractorLaborTable_theme = { CollapsableCard: laborTables_default.a };

var contractorLaborTable_ContractorLaborTable = function (_Component) {
  contractorLaborTable__inherits(ContractorLaborTable, _Component);

  function ContractorLaborTable() {
    var _ref;

    var _temp, _this, _ret;

    contractorLaborTable__classCallCheck(this, ContractorLaborTable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = contractorLaborTable__possibleConstructorReturn(this, (_ref = ContractorLaborTable.__proto__ || Object.getPrototypeOf(ContractorLaborTable)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'state', {
      enumerable: true,
      writable: true,
      value: { approveModalActive: false, errors: {} }
    }), Object.defineProperty(_this, 'setLPATutorialId', {
      enumerable: true,
      writable: true,
      value: function value(status) {
        return ['Pending Review', 'Not Payable'].includes(status) ? 'installerPayTutorial2' : '';
      }
    }), Object.defineProperty(_this, 'getNewLineItem', {
      enumerable: true,
      writable: true,
      value: function value() {
        return {
          id: -1,
          line_item_id: null,
          item_number: '',
          description: '',
          quantity: 1,
          price: 0,
          total: 0,
          note: ''
        };
      }
    }), Object.defineProperty(_this, 'handleDelete', {
      enumerable: true,
      writable: true,
      value: function value(lineItemId) {
        return _this.props.deletePhaseItem(_this.props.phaseId, {
          id: lineItemId,
          labor_sheet_id: _this.props.laborSheet.id
        }, contractorLaborTable_LINE_ITEM_TYPE);
      }
    }), Object.defineProperty(_this, 'handleSave', {
      enumerable: true,
      writable: true,
      value: function value(lineItem) {
        var errors = {};
        if (_this.isCustom(lineItem.item_number) && (lineItem.note == null || lineItem.note === '')) {
          errors.note = ["Note can't be blank on a custom item"];
          Object.assign(errors);
          _this.setState({ errors: errors });
          return;
        }
        _this.setState({ errors: errors });
        var newLineItem = contractorLaborTable__extends({}, lineItem);
        if (!Object.prototype.hasOwnProperty.call(lineItem, 'labor_sheet_id')) {
          newLineItem.labor_sheet_id = _this.props.laborSheet.id;
        }
        _this.props.savePhaseItem(_this.props.phaseId, newLineItem, contractorLaborTable_LINE_ITEM_TYPE);
      }
    }), Object.defineProperty(_this, 'requestLineItemOptions', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            laborSheet = _this$props.laborSheet,
            assignee = _this$props.laborSheet.assignee;

        _this.props.requestPayRateLineItemList(assignee.kind, assignee.id, laborSheet.id);
      }
    }), Object.defineProperty(_this, 'copyLaborItems', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.copyLaborItemsToLaborSheet(_this.props.phaseId, _this.props.laborSheet.id);
      }
    }), Object.defineProperty(_this, 'isCustom', {
      enumerable: true,
      writable: true,
      value: function value(val) {
        return window.SPOT.custom_items.includes(val) || false;
      }
    }), Object.defineProperty(_this, 'isClosed', {
      enumerable: true,
      writable: true,
      value: function value(laborSheet) {
        return !Object(services["a" /* can */])(_this.props.role, 'manage_closed', 'labor_sheet') && (laborSheet.status === 'Approved by Contractor' && _this.props.phaseType !== 'Assessment' || laborSheet.status === 'Recorded') || false;
      }
    }), Object.defineProperty(_this, 'isApproved', {
      enumerable: true,
      writable: true,
      value: function value(laborSheet) {
        return laborSheet.status === 'Approved by Contractor' || laborSheet.status === 'Recorded' || false;
      }
    }), Object.defineProperty(_this, 'determineCanViewTotal', {
      enumerable: true,
      writable: true,
      value: function value() {
        return Object(services["a" /* can */])(_this.props.role, 'view', 'labor_total');
      }
    }), Object.defineProperty(_this, 'handleApproveClick', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ approveModalActive: true });
      }
    }), Object.defineProperty(_this, 'handleApproveClose', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ approveModalActive: false });
      }
    }), Object.defineProperty(_this, 'handleFixedOptions', {
      enumerable: true,
      writable: true,
      value: function value(options) {
        return (options || []).map(function (o) {
          var editedOption = o;
          var pricedItem = constants["M" /* FIXED_LINE_ITEMS */].find(function (i) {
            return i.label === o.label;
          }) || null;
          if (pricedItem) {
            editedOption.price = pricedItem.price;
            editedOption.fixedPrice = true;
            if (pricedItem.total) {
              editedOption.total = pricedItem.total;
              editedOption.fixedTotal = true;
            }
          }
          return editedOption;
        });
      }
    }), Object.defineProperty(_this, 'handleFixedItem', {
      enumerable: true,
      writable: true,
      value: function value(item) {
        var editedItem = contractorLaborTable__extends({}, item);
        var fixedItem = constants["M" /* FIXED_LINE_ITEMS */].find(function (i) {
          return i.label === item.item_number.concat(' - ', item.description);
        }) || null;
        if (fixedItem) {
          editedItem.fixedPrice = true;
          if (fixedItem.total) editedItem.fixedTotal = true;
        }
        return editedItem;
      }
    }), Object.defineProperty(_this, 'determineAction', {
      enumerable: true,
      writable: true,
      value: function value(target, icon, text) {
        var className = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

        var source = { icon: icon, text: text, toolTipMessage: text === 'Not Yet Approvable' ? 'Cannot approve before appointment starts' : '' };
        if (className) source.className = className;
        return Object.assign(target, source);
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props2 = _this.props,
            laborSheet = _this$props2.laborSheet,
            lineItemOptions = _this$props2.lineItemOptions,
            refreshList = _this$props2.refreshList,
            total = _this$props2.total,
            index = _this$props2.index,
            phaseType = _this$props2.phaseType,
            filterLineItems = _this$props2.filterLineItems,
            surfaceType = _this$props2.surfaceType,
            editable = _this$props2.editable,
            lpa = _this$props2.lpa,
            phaseSource = _this$props2.phaseSource,
            phaseId = _this$props2.phaseId,
            role = _this$props2.role,
            contractorTableApproved = _this$props2.contractorTableApproved,
            appointmentStartDate = _this$props2.appointmentStartDate;

        var editableActions = [];
        var formError = Object.keys(_this.state.errors).length > 0;
        if (laborSheet.payable) {
          editableActions.push({ icon: 'content_copy', text: 'Copy Labor Lines', onClick: _this.copyLaborItems });
        }
        var readOnly = !editable || !contractorTableApproved && phaseType !== 'Assessment' || _this.isClosed(laborSheet, lpa);
        var isApproved = _this.isApproved(laborSheet);
        var actions = [{ onClick: _this.handleApproveClick }];
        if (laborSheet.status === 'Approved by Contractor' && laborSheet.signed_document_id || laborSheet.status !== 'Approved by Contractor' && laborSheet.status !== 'Not Payable' && laborSheet.status !== 'Pending Review') {
          actions[0] = _this.determineAction(actions[0], 'assignment_turned_in', 'Approved');
          readOnly = true;
        } else if (laborSheet.status === 'Not Payable') {
          actions[0] = _this.determineAction(actions[0], 'assignment_late', 'Not Payable');
        } else if (moment_default()().isBefore(moment_default()(appointmentStartDate, 'YYYY/MM/DD'), 'day')) {
          actions[0] = _this.determineAction(actions[0], 'assignment_late', 'Not Yet Approvable');
        } else {
          actions[0] = _this.determineAction(actions[0], 'assignment', 'Approve', CollapsableCard_styles_default.a.save);
        }
        var title = react_default.a.createElement(
          es["c" /* Link */],
          {
            to: linkTo(laborSheet.assignee),
            className: laborTables_default.a.cardLink,
            target: '_blank'
          },
          'Labor ',
          index,
          ': ',
          laborSheet.assignee.name
        );
        var canViewTotal = _this.determineCanViewTotal();
        var lineItems = laborSheet.line_items || [];
        var hasExistingLineItems = lineItems.length > 0;
        var isIfiAssessmentCustomLaborFlow = phaseType === 'Assessment' && phaseSource === 'IFI';
        var shouldShowPlaceholderRow = isIfiAssessmentCustomLaborFlow && !readOnly;
        var lineItemsForTable = hasExistingLineItems || !shouldShowPlaceholderRow ? lineItems : [_this.getNewLineItem()];
        return react_default.a.createElement(
          react_css_themr_lib["ThemeProvider"],
          { theme: contractorLaborTable_theme },
          react_default.a.createElement(
            'div',
            { id: _this.setLPATutorialId(laborSheet.status) },
            react_default.a.createElement(approveLaborModal, {
              phaseId: Number(phaseId),
              laborSheetId: laborSheet.id,
              active: _this.state.approveModalActive,
              onClose: _this.handleApproveClose
            }),
            react_default.a.createElement(
              components_LineItemTable,
              {
                actionBtnPrefix: 'laborSheet_',
                title: title,
                requestLineItemList: _this.requestLineItemOptions,
                refreshList: refreshList,
                total: total,
                actions: actions,
                editableActions: editableActions,
                hasCreatableRow: editable,
                readOnly: readOnly,
                canViewTotal: canViewTotal,
                accountingTable: true
              },
              lineItemsForTable.map(function (item) {
                return react_default.a.createElement(contractorLaborRow, {
                  key: item.id,
                  onSave: _this.handleSave,
                  onDelete: _this.handleDelete,
                  isCustom: _this.isCustom,
                  lineItem: item.id > 0 ? _this.handleFixedItem(item) : item,
                  lineItemOptions: _this.handleFixedOptions(lineItemOptions[laborSheet.id]),
                  lpa: lpa,
                  role: role,
                  isApproved: isApproved,
                  canViewTotal: canViewTotal,
                  phaseType: phaseType,
                  surfaceType: surfaceType,
                  filterLineItems: filterLineItems,
                  phaseSource: phaseSource
                });
              })
            ),
            formError && react_default.a.createElement(MessageBox["a" /* default */], { error: true, message: _this.state.errors.note.toString() })
          )
        );
      }
    }), _temp), contractorLaborTable__possibleConstructorReturn(_this, _ret);
  }

  return ContractorLaborTable;
}(react["Component"]);

contractorLaborTable_ContractorLaborTable.defaultProps = { lineItemOptions: {}, filterLineItems: false };

contractorLaborTable_ContractorLaborTable.propTypes = {
  phaseId: prop_types_default.a.string,
  appointmentStartDate: prop_types_default.a.string,
  laborSheet: types_laborSheet,
  employableType: prop_types_default.a.string,
  lineItemOptions: prop_types_default.a.object,
  refreshList: prop_types_default.a.func.isRequired,
  savePhaseItem: prop_types_default.a.func.isRequired,
  deletePhaseItem: prop_types_default.a.func.isRequired,
  requestPayRateLineItemList: prop_types_default.a.func.isRequired,
  copyLaborItemsToLaborSheet: prop_types_default.a.func.isRequired,
  total: prop_types_default.a.number,
  index: prop_types_default.a.number,
  editable: prop_types_default.a.bool,
  approvable: prop_types_default.a.bool,
  lpa: prop_types_default.a.bool,
  role: prop_types_default.a.string,
  contractorTableApproved: prop_types_default.a.bool,
  phaseType: prop_types_default.a.string,
  surfaceType: prop_types_default.a.string,
  filterLineItems: prop_types_default.a.bool,
  phaseSource: prop_types_default.a.string
};

var contractorLaborTable_mapStateToProps = function mapStateToProps(state, ownProps) {
  var employees = state.employees,
      user = state.user,
      _state$phase$details = state.phase.details,
      type = _state$phase$details.type,
      source = _state$phase$details.source,
      name = _state$phase$details.surface_type.name;

  var contractorTableApproved = ownProps.employableType === 'employee' ? employees.byId[user.employable_id].contractor_table_approved : false;
  return {
    lineItemOptions: state.payRateLineItems.data,
    total: selectors_lineItemTotal(ownProps.laborSheet.line_items || []),
    editable: Object(services["a" /* can */])(Object(reducers["_12" /* getRole */])(state), 'update', 'contractor_line_item'),
    approvable: Object(services["a" /* can */])(Object(reducers["_12" /* getRole */])(state), 'approve', 'labor_sheet'),
    lpa: Object(services["a" /* can */])(Object(reducers["_12" /* getRole */])(state), 'update', 'LPA'),
    role: Object(reducers["_12" /* getRole */])(state),
    contractorTableApproved: contractorTableApproved,
    phaseType: type,
    phaseSource: source,
    surfaceType: name
  };
};

/* harmony default export */ var contractorLaborTable = (Object(react_redux_es["connect"])(contractorLaborTable_mapStateToProps, {
  savePhaseItem: phase_items["k" /* savePhaseItem */],
  deletePhaseItem: phase_items["e" /* deletePhaseItem */],
  requestPayRateLineItemList: dropdown_lists["c" /* requestPayRateLineItemList */],
  copyLaborItemsToLaborSheet: phase_items["b" /* copyLaborItemsToLaborSheet */]
})(contractorLaborTable_ContractorLaborTable));
// CONCATENATED MODULE: ./client/app/selectors/contractorLineItem.js



var getContractorLineItemsSelector = function getContractorLineItemsSelector(state) {
  return state.phase.contractorLineItems.items;
};

var contractorLineItem_getPhaseLineItemsWithTotal = Object(reselect_lib["createSelector"])(getContractorLineItemsSelector, function (laborSheets) {
  return laborSheets.map(function (sheet) {
    var newSheet = sheet;
    newSheet.line_items = newSheet.line_items.map(function (item) {
      var itemWithTotal = item;
      itemWithTotal.total = Object(lineItemUtils["c" /* calculateTotal */])(item.price, item.quantity);
      return itemWithTotal;
    });
    return newSheet;
  });
});

/* harmony default export */ var selectors_contractorLineItem = (contractorLineItem_getPhaseLineItemsWithTotal);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseAccounting/components/contractorLaborTables.jsx











var contractorLaborTables_ContractorLaborTables = function ContractorLaborTables(props) {
  var lineItems = props.lineItems,
      phaseId = props.phaseId,
      refreshLineItemList = props.refreshLineItemList,
      employableType = props.employableType,
      lineItemId = props.lineItemId,
      appointmentStartDate = props.appointmentStartDate,
      filterLineItems = props.filterLineItems;

  var singleLineItem = void 0;
  if (lineItemId !== null) singleLineItem = lineItems.filter(function (i) {
    return i.id >= 0 && i.id === lineItemId;
  });
  var newLineItems = lineItemId !== null ? singleLineItem : lineItems;
  var mappedLineItems = newLineItems.map(function (laborSheet, index) {
    return react_default.a.createElement(contractorLaborTable, {
      key: laborSheet.id,
      laborSheet: laborSheet,
      employableType: employableType,
      phaseId: phaseId,
      refreshList: refreshLineItemList,
      index: index + 1,
      appointmentStartDate: appointmentStartDate,
      filterLineItems: filterLineItems
    });
  });
  return react_default.a.createElement(
    react_responsive_default.a,
    { minWidth: constants["y" /* CUT_POINT */] },
    function (matches) {
      return matches ? react_default.a.createElement(
        'tr',
        null,
        react_default.a.createElement('td', { className: laborTables_default.a.tdIndention }),
        react_default.a.createElement(
          'td',
          { className: laborTables_default.a.tdIndention, colSpan: '7' },
          mappedLineItems
        )
      ) : react_default.a.createElement(
        'tr',
        null,
        react_default.a.createElement(
          'td',
          { colSpan: '8' },
          mappedLineItems
        )
      );
    }
  );
};

contractorLaborTables_ContractorLaborTables.defaultProps = { lineItems: [], filterLineItems: false };

contractorLaborTables_ContractorLaborTables.propTypes = {
  lineItemId: prop_types_default.a.number,
  appointmentStartDate: prop_types_default.a.string,
  phaseId: prop_types_default.a.string,
  lineItems: prop_types_default.a.arrayOf(types_laborSheet),
  employableType: prop_types_default.a.string,
  requestPhaseItems: prop_types_default.a.func,
  refreshLineItemList: prop_types_default.a.func.isRequired,
  filterLineItems: prop_types_default.a.bool
};

/* harmony default export */ var contractorLaborTables = (Object(react_redux_es["connect"])(function (state) {
  return {
    lineItems: selectors_contractorLineItem(state)
  };
}, { requestPhaseItems: phase_items["i" /* requestPhaseItems */] })(contractorLaborTables_ContractorLaborTables));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseAccounting/components/laborSheetTable.jsx
function laborSheetTable__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function laborSheetTable__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function laborSheetTable__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var laborSheetTable_LINE_ITEM_TYPE = 'laborSheets';
var laborSheetTable_theme = { CollapsableCard: laborTables_default.a };

var laborSheetTable_LaborSheetTable = function (_Component) {
  laborSheetTable__inherits(LaborSheetTable, _Component);

  function LaborSheetTable(props) {
    laborSheetTable__classCallCheck(this, LaborSheetTable);

    var _this = laborSheetTable__possibleConstructorReturn(this, (LaborSheetTable.__proto__ || Object.getPrototypeOf(LaborSheetTable)).call(this, props));

    Object.defineProperty(_this, 'componentDidMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.showLineItems ? _this.toggleLaborSheetLineItems(_this.getAllLaborSheetIds(), true) : null;
      }
    });
    Object.defineProperty(_this, 'componentDidUpdate', {
      enumerable: true,
      writable: true,
      value: function value(prevProps, prevState) {
        var _this$props = _this.props,
            showLineItems = _this$props.showLineItems,
            tableName = _this$props.tableName,
            toggleShowHide = _this$props.toggleShowHide;
        var laborSheetIds = _this.state.laborSheetIds;

        var allLabSheetIds = _this.getAllLaborSheetIds();
        if (prevProps !== _this.props && showLineItems && laborSheetIds.length !== allLabSheetIds.length) {
          _this.toggleLaborSheetLineItems(allLabSheetIds, true);
        }
        if (prevProps.showLineItems !== showLineItems) {
          if (showLineItems) _this.toggleLaborSheetLineItems(allLabSheetIds, true);
          if (!showLineItems) _this.toggleLaborSheetLineItems([], true);
        }
        if (prevState.laborSheetIds.length !== laborSheetIds.length && laborSheetIds.length === 0) {
          toggleShowHide(tableName, false);
        } else if (prevState.laborSheetIds.length !== laborSheetIds.length && laborSheetIds.length === allLabSheetIds.length) {
          toggleShowHide(tableName, true);
        }
      }
    });
    Object.defineProperty(_this, 'getAllLaborSheetIds', {
      enumerable: true,
      writable: true,
      value: function value() {
        var newLabSheetIds = [];
        _this.props.lineItems.forEach(function (li) {
          if (li.id > 0) newLabSheetIds.push(li.id);
        });
        return newLabSheetIds;
      }
    });
    Object.defineProperty(_this, 'handleSave', {
      enumerable: true,
      writable: true,
      value: function value(lineItem) {
        return _this.props.savePhaseItem(_this.props.phaseId, lineItem, laborSheetTable_LINE_ITEM_TYPE);
      }
    });
    Object.defineProperty(_this, 'canUpdate', {
      enumerable: true,
      writable: true,
      value: function value(role, item, lpa) {
        if (lpa || Object(services["a" /* can */])(role, 'update', 'labor_sheet', { obj_status: item.status })) return true;
        return false;
      }
    });
    Object.defineProperty(_this, 'determineCanViewTotal', {
      enumerable: true,
      writable: true,
      value: function value(role) {
        return Object(services["a" /* can */])(role, 'view', 'labor_total');
      }
    });
    Object.defineProperty(_this, 'toggleLaborSheetLineItems', {
      enumerable: true,
      writable: true,
      value: function value(labSheetIds) {
        var toggleAll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var laborSheetIds = _this.state.laborSheetIds;

        var newLabSheetIdsArr = laborSheetIds.slice();
        if (toggleAll) {
          // labSheetIds is multiple ID's
          // add all line items to laborSheetIds
          _this.setState({ laborSheetIds: labSheetIds });
        } else {
          // labSheetIds are individual ID's
          // add single line Item to laborSheetIds
          if (labSheetIds >= 0 && !newLabSheetIdsArr.includes(labSheetIds)) {
            newLabSheetIdsArr.push(labSheetIds);
            _this.toggleLPATutorialStep2(labSheetIds);
          } else {
            // remove single line item from laborSheetIds
            var index = newLabSheetIdsArr.indexOf(labSheetIds);
            newLabSheetIdsArr.splice(index, 1);
          }
          _this.setState({ laborSheetIds: newLabSheetIdsArr });
        }
      }
    });
    Object.defineProperty(_this, 'toggleLPATutorialStep2', {
      enumerable: true,
      writable: true,
      value: function value(labSheetId) {
        var _this$props$lineItems = _this.props.lineItems,
            lineItems = _this$props$lineItems === undefined ? [] : _this$props$lineItems;

        var lineItem = lineItems.find(function (item) {
          return item.id === labSheetId;
        }) || {};
        if (['Pending Review', 'Not Payable'].includes(lineItem.status)) _this.props.doLPATutorialStep2(true);
      }
    });
    Object.defineProperty(_this, 'toggleEditMode', {
      enumerable: true,
      writable: true,
      value: function value(bool) {
        return _this.setState({ isInEditMode: bool });
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props2 = _this.props,
            lineItems = _this$props2.lineItems,
            documents = _this$props2.documents,
            refreshLineItemList = _this$props2.refreshLineItemList,
            phaseId = _this$props2.phaseId,
            editable = _this$props2.editable,
            lpa = _this$props2.lpa,
            role = _this$props2.role,
            employableType = _this$props2.employableType,
            filterLineItems = _this$props2.filterLineItems;
        var _this$state = _this.state,
            laborSheetIds = _this$state.laborSheetIds,
            isInEditMode = _this$state.isInEditMode;

        var total = lineItems.reduce(function (curr, next) {
          return curr + (next.total || 0);
        }, 0);
        var canViewTotal = _this.determineCanViewTotal(role);
        return react_default.a.createElement(
          react_css_themr_lib["ThemeProvider"],
          { theme: laborSheetTable_theme },
          react_default.a.createElement(
            components_LineItemTable,
            {
              hasCreatableRow: false,
              readOnly: !editable,
              title: 'Labor Sheets',
              refreshList: refreshLineItemList,
              total: total,
              canViewTotal: canViewTotal,
              toggleEditMode: _this.toggleEditMode,
              diffChildren: true,
              accountingTable: true
            },
            lineItems.filter(function (li) {
              return li.id > 0;
            }).map(function (item, index) {
              return react_default.a.createElement(
                'div',
                { key: item.id },
                react_default.a.createElement(laborSheetRow, {
                  key: item.id,
                  role: role,
                  onSave: _this.handleSave,
                  lineItem: item,
                  documents: documents,
                  index: index + 1,
                  phaseId: phaseId,
                  readOnly: !_this.canUpdate(role, item),
                  canViewTotal: canViewTotal,
                  toggleLineItem: isInEditMode ? null : function () {
                    return _this.toggleLaborSheetLineItems(item.id);
                  },
                  phase: _this.props.phase
                }),
                laborSheetIds.includes(item.id) && Object(services["a" /* can */])(role, 'view', 'contractor_line_item') && react_default.a.createElement(contractorLaborTables, {
                  readOnly: !_this.canUpdate(role, item, lpa),
                  phaseId: phaseId,
                  lineItemId: item.id,
                  employableType: employableType,
                  refreshLineItemList: refreshLineItemList,
                  appointmentStartDate: item.appointment.start_date,
                  filterLineItems: filterLineItems
                })
              );
            })
          )
        );
      }
    });

    _this.state = { laborSheetIds: [], isInEditMode: false };
    return _this;
  }

  return LaborSheetTable;
}(react["Component"]);

laborSheetTable_LaborSheetTable.defaultProps = { lineItems: [] };

laborSheetTable_LaborSheetTable.propTypes = {
  phaseId: prop_types_default.a.string,
  employableType: prop_types_default.a.string,
  tableName: prop_types_default.a.string,
  toggleShowHide: prop_types_default.a.func,
  savePhaseItem: prop_types_default.a.func,
  deletePhaseItem: prop_types_default.a.func,
  requestPhaseItems: prop_types_default.a.func,
  refreshLineItemList: prop_types_default.a.func.isRequired,
  lineItems: prop_types_default.a.arrayOf(types_laborSheet),
  documents: prop_types_default.a.arrayOf(documentUpload).isRequired,
  editable: prop_types_default.a.bool.isRequired,
  doLPATutorialStep2: prop_types_default.a.func,
  lpa: prop_types_default.a.bool,
  showLineItems: prop_types_default.a.bool,
  role: prop_types_default.a.string,
  filterLineItems: prop_types_default.a.bool,
  phase: prop_types_default.a.object
};

/* harmony default export */ var laborSheetTable = (Object(react_redux_es["connect"])(function (state) {
  return {
    editable: Object(services["a" /* can */])(Object(reducers["_12" /* getRole */])(state), 'editable', 'labor_sheet'),
    lpa: Object(services["a" /* can */])(Object(reducers["_12" /* getRole */])(state), 'update', 'LPA'),
    role: Object(reducers["_12" /* getRole */])(state),
    phase: state.phase.details
  };
}, { savePhaseItem: phase_items["k" /* savePhaseItem */], deletePhaseItem: phase_items["e" /* deletePhaseItem */] })(laborSheetTable_LaborSheetTable));
// CONCATENATED MODULE: ./client/app/shared/types/phaseMerchandiseItem.js


/* harmony default export */ var phaseMerchandiseItem = ({
  id: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]),
  item_number: prop_types_default.a.string,
  vendor: prop_types_default.a.string,
  model_number: prop_types_default.a.string,
  item_name: prop_types_default.a.string,
  stock: prop_types_default.a.string,
  quantity: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]),
  status: prop_types_default.a.string,
  note: prop_types_default.a.string,
  errors: prop_types_default.a.shape({
    item_number: prop_types_default.a.array,
    model_number: prop_types_default.a.array,
    item_name: prop_types_default.a.array,
    stock: prop_types_default.a.array,
    quantity: prop_types_default.a.array,
    status: prop_types_default.a.array,
    note: prop_types_default.a.array
  })
});
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/components/merchandiseTableRow.jsx
var merchandiseTableRow__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function merchandiseTableRow__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function merchandiseTableRow__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function merchandiseTableRow__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function merchandiseTableRow__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var merchandiseTableRow_MerchandiseTableRow = function (_Editable) {
  merchandiseTableRow__inherits(MerchandiseTableRow, _Editable);

  function MerchandiseTableRow() {
    var _ref;

    var _temp, _this, _ret;

    merchandiseTableRow__classCallCheck(this, MerchandiseTableRow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = merchandiseTableRow__possibleConstructorReturn(this, (_ref = MerchandiseTableRow.__proto__ || Object.getPrototypeOf(MerchandiseTableRow)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'state', {
      enumerable: true,
      writable: true,
      value: merchandiseTableRow__extends({}, _this.props.lineItem)
    }), Object.defineProperty(_this, 'handleChange', {
      enumerable: true,
      writable: true,
      value: function value(attr) {
        return function (val) {
          var value = val.target ? val.target.value : val;
          if (attr === 'status') value = val.status;
          _this.setState(merchandiseTableRow__defineProperty({}, attr, value));
        };
      }
    }), Object.defineProperty(_this, 'handleItemNumberChange', {
      enumerable: true,
      writable: true,
      value: _this.handleChange('item_number')
    }), Object.defineProperty(_this, 'handleModelNumberChange', {
      enumerable: true,
      writable: true,
      value: _this.handleChange('model_number')
    }), Object.defineProperty(_this, 'handleItemNameChange', {
      enumerable: true,
      writable: true,
      value: _this.handleChange('item_name')
    }), Object.defineProperty(_this, 'handleQuantityChange', {
      enumerable: true,
      writable: true,
      value: _this.handleChange('quantity')
    }), Object.defineProperty(_this, 'handleStockChange', {
      enumerable: true,
      writable: true,
      value: _this.handleChange('stock')
    }), Object.defineProperty(_this, 'handleNoteChange', {
      enumerable: true,
      writable: true,
      value: _this.handleChange('note')
    }), Object.defineProperty(_this, 'handleDeliveryTypeChange', {
      enumerable: true,
      writable: true,
      value: _this.handleChange('delivery_type')
    }), Object.defineProperty(_this, 'handleStatusChange', {
      enumerable: true,
      writable: true,
      value: _this.handleChange('status')
    }), Object.defineProperty(_this, 'handleSave', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.onSave(_this.state);
      }
    }), Object.defineProperty(_this, 'handleDelete', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.onDelete(_this.state.id);
      }
    }), Object.defineProperty(_this, 'renderStatusCell', {
      enumerable: true,
      writable: true,
      value: function value() {
        var lineItem = _this.state;
        var _this$props = _this.props,
            onSave = _this$props.onSave,
            readOnly = _this$props.readOnly;

        var options = constants["_0" /* MERCHANDISE_VERIFICATION_STATUSES */];
        var onChange = _this.context.isEditable ? _this.handleStatusChange : onSave;
        var val = readOnly ? lineItem.status : react_default.a.createElement(lineItemStatus, {
          onChange: onChange, lineItem: lineItem, options: options
        });
        return react_default.a.createElement(
          editableTableCell,
          { onChange: onChange, label: 'Status', value: val, className: table_default.a.largeColumn },
          val
        );
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var isEditable = _this.context.isEditable;

        var lineItem = _this.state;
        var style = { background: constants["w" /* CONTRACT_VERIFICATION_STATUS_COLORS */][lineItem.status] };
        var itemNumber = lineItem.item_number;
        var itemNumberLink = constants["_8" /* NON_LHI_SOURCES */].includes(_this.props.phaseSource) ? itemNumber : react_default.a.createElement(
          'a',
          { href: urls.lowesItem(itemNumber), target: '_blank', rel: 'noopener noreferrer' },
          itemNumber
        );
        var rowProps = { isNew: lineItem.id < 0, style: style, onSave: _this.handleSave, onDelete: _this.handleDelete };
        return react_default.a.createElement(
          editableTableRow,
          merchandiseTableRow__extends({ key: lineItem.id, id: lineItem.id }, rowProps),
          react_default.a.createElement(components_LineItemTable_itemEvents, {
            display: !isEditable,
            label: '',
            itemType: 'phaseMerchandiseItems',
            lineItem: lineItem,
            dataKeys: ['status', 'item_number', 'model_number', 'item_name', 'stock', 'quantity', 'delivery_type', 'note']
          }),
          _this.renderStatusCell(),
          react_default.a.createElement(inputCell, { attr: 'item_number', label: 'Item Number', lineItem: lineItem, onChange: _this.handleItemNumberChange, cellValue: itemNumberLink }),
          react_default.a.createElement(inputCell, { attr: 'model_number', label: 'Model Number', lineItem: lineItem, onChange: _this.handleModelNumberChange }),
          react_default.a.createElement(inputCell, { attr: 'item_name', label: 'Item Name', lineItem: lineItem, onChange: _this.handleItemNameChange }),
          react_default.a.createElement(inputCell, { attr: 'stock', label: 'Stock', lineItem: lineItem, onChange: _this.handleStockChange }),
          react_default.a.createElement(inputCell, { attr: 'quantity', label: 'QTY', lineItem: lineItem, onChange: _this.handleQuantityChange }),
          react_default.a.createElement(inputCell, { attr: 'delivery_type', label: 'Delivery Type', lineItem: lineItem, onChange: _this.handleDeliveryTypeChange }),
          react_default.a.createElement(LineItemTable_itemNote, { display: true, label: 'Note', onChange: _this.handleNoteChange, note: lineItem.note, id: lineItem.id, kind: 'merch' })
        );
      }
    }), _temp), merchandiseTableRow__possibleConstructorReturn(_this, _ret);
  }

  return MerchandiseTableRow;
}(mixins_editable(react_default.a.Component));

merchandiseTableRow_MerchandiseTableRow.contextTypes = { isEditable: prop_types_default.a.bool };

merchandiseTableRow_MerchandiseTableRow.propTypes = {
  lineItem: prop_types_default.a.shape(phaseMerchandiseItem),
  onSave: prop_types_default.a.func,
  onDelete: prop_types_default.a.func,
  readOnly: prop_types_default.a.bool,
  phaseSource: prop_types_default.a.string
};

merchandiseTableRow_MerchandiseTableRow.defaultProps = { lineItem: {} };

/* harmony default export */ var merchandiseTableRow = (merchandiseTableRow_MerchandiseTableRow);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/components/phaseMerchandiseItemTable.jsx
function phaseMerchandiseItemTable__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function phaseMerchandiseItemTable__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function phaseMerchandiseItemTable__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var phaseMerchandiseItemTable_LINE_ITEM_TYPE = 'phaseMerchandiseItems';

var phaseMerchandiseItemTable_PhaseMerchandiseItemTable = function (_Component) {
  phaseMerchandiseItemTable__inherits(PhaseMerchandiseItemTable, _Component);

  function PhaseMerchandiseItemTable() {
    var _ref;

    var _temp, _this, _ret;

    phaseMerchandiseItemTable__classCallCheck(this, PhaseMerchandiseItemTable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = phaseMerchandiseItemTable__possibleConstructorReturn(this, (_ref = PhaseMerchandiseItemTable.__proto__ || Object.getPrototypeOf(PhaseMerchandiseItemTable)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'componentWillMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return !_this.hasParentLineItems() ? _this.refreshLineItemList() : null;
      }
    }), Object.defineProperty(_this, 'refreshLineItemList', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.requestPhaseItems(_this.props.phaseId, phaseMerchandiseItemTable_LINE_ITEM_TYPE);
      }
    }), Object.defineProperty(_this, 'handleDelete', {
      enumerable: true,
      writable: true,
      value: function value(lineItemId) {
        return _this.props.deletePhaseItem(_this.props.phaseId, { id: lineItemId }, phaseMerchandiseItemTable_LINE_ITEM_TYPE);
      }
    }), Object.defineProperty(_this, 'handleSave', {
      enumerable: true,
      writable: true,
      value: function value(lineItem) {
        return _this.props.savePhaseItem(_this.props.phaseId, lineItem, phaseMerchandiseItemTable_LINE_ITEM_TYPE);
      }
    }), Object.defineProperty(_this, 'hasParentLineItems', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.parentLineItems.length > 0;
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        return react_default.a.createElement(
          components_LineItemTable,
          {
            title: 'Merchandise',
            refreshList: _this.refreshLineItemList,
            readOnly: !Object(services["a" /* can */])(_this.props.role, 'update', 'labor'),
            cv: _this.props.cv,
            accountingTable: true
          },
          _this.props.lineItems.map(function (item) {
            return react_default.a.createElement(merchandiseTableRow, {
              key: item.id,
              onSave: _this.handleSave,
              onDelete: _this.handleDelete,
              lineItem: item,
              readOnly: !Object(services["a" /* can */])(_this.props.role, 'update', 'labor'),
              phaseSource: _this.props.phaseSource
            });
          })
        );
      }
    }), _temp), phaseMerchandiseItemTable__possibleConstructorReturn(_this, _ret);
  }

  return PhaseMerchandiseItemTable;
}(react["Component"]);

phaseMerchandiseItemTable_PhaseMerchandiseItemTable.defaultProps = {
  lineItems: [], parentLineItems: [], cv: false
};

phaseMerchandiseItemTable_PhaseMerchandiseItemTable.propTypes = {
  phaseId: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]),
  phaseSource: prop_types_default.a.string,
  lineItems: prop_types_default.a.arrayOf(prop_types_default.a.shape(phaseMerchandiseItem)),
  parentLineItems: prop_types_default.a.arrayOf(prop_types_default.a.shape(phaseMerchandiseItem)),
  requestPhaseItems: prop_types_default.a.func,
  savePhaseItem: prop_types_default.a.func,
  deletePhaseItem: prop_types_default.a.func,
  role: prop_types_default.a.string.isRequired,
  cv: prop_types_default.a.bool
};

var phaseMerchandiseItemTable_mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    role: Object(reducers["_12" /* getRole */])(state),
    lineItems: (ownProps.parentLineItems || []).length > 0 ? ownProps.parentLineItems : state.phase.phaseMerchandiseItems.items
  };
};

/* harmony default export */ var phaseMerchandiseItemTable = (Object(react_redux_es["connect"])(phaseMerchandiseItemTable_mapStateToProps, {
  requestPhaseItems: phase_items["i" /* requestPhaseItems */],
  savePhaseItem: phase_items["k" /* savePhaseItem */],
  deletePhaseItem: phase_items["e" /* deletePhaseItem */]
})(phaseMerchandiseItemTable_PhaseMerchandiseItemTable));
// EXTERNAL MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseAccounting/styles.scss
var phaseAccounting_styles = __webpack_require__("3Eoq");
var phaseAccounting_styles_default = /*#__PURE__*/__webpack_require__.n(phaseAccounting_styles);

// EXTERNAL MODULE: ./client/app/assets/images/pro-tip.png
var pro_tip = __webpack_require__("HWGv");
var pro_tip_default = /*#__PURE__*/__webpack_require__.n(pro_tip);

// EXTERNAL MODULE: ./node_modules/react-joyride/es/index.js + 4 modules
var react_joyride_es = __webpack_require__("/3/s");

// EXTERNAL MODULE: ./client/app/shared/components/SpotJoyride/LPATutorial.scss
var SpotJoyride_LPATutorial = __webpack_require__("K8d9");
var LPATutorial_default = /*#__PURE__*/__webpack_require__.n(SpotJoyride_LPATutorial);

// CONCATENATED MODULE: ./client/app/shared/components/SpotJoyride/LPATutorial.jsx
function LPATutorial__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function LPATutorial__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function LPATutorial__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var ADD_INSTALLER_PAY_TUTORIAL = [{
  placement: 'top',
  target: '#installerPayTutorial0',
  disableBeacon: true,
  disableOverlayClose: true,
  hideCloseButton: true,
  title: 'Labor, Product & Accouting',
  content: 'This is where you can add pay to your labor sheet.'
}, {
  placement: 'top',
  target: '#header_laborSheet',
  content: 'Here are your Labors Sheets. Please select the contractor who is being paid',
  disableBeacon: true,
  disableOverlayClose: true,
  spotlightClicks: true,
  hideBackButton: true,
  hideCloseButton: false
}, {
  placement: 'top-end',
  target: '#installerPayTutorial2',
  content: 'You can click the "EDIT" button here to start',
  disableBeacon: true,
  disableOverlayClose: true,
  spotlightClicks: true
}, {
  placement: 'bottom',
  target: '#installerPayTutorial3',
  content: 'Add the line item, quantity, pay rates, and a note. Click the "SAVE" button to finish.',
  spotlightClicks: true,
  disableBeacon: true,
  disableOverlay: true
}, {
  placement: 'top',
  target: '#laborSheet_done',
  content: 'Click the "DONE" button here where you are finished',
  disableBeacon: true,
  disableOverlayClose: true,
  spotlightClicks: true,
  hideCloseButton: true,
  disableScrolling: false
}];

var LPATutorial_LPATutorial = function (_Component) {
  LPATutorial__inherits(LPATutorial, _Component);

  function LPATutorial(props) {
    LPATutorial__classCallCheck(this, LPATutorial);

    var _this = LPATutorial__possibleConstructorReturn(this, (LPATutorial.__proto__ || Object.getPrototypeOf(LPATutorial)).call(this, props));

    Object.defineProperty(_this, 'runStep3', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$state = _this.state,
            run = _this$state.run,
            stepIndex = _this$state.stepIndex;

        if (run && stepIndex === 2) {
          setTimeout(function () {
            return _this.setState({ stepIndex: stepIndex + 1, continuous: true });
          }, 500);
        }
      }
    });
    Object.defineProperty(_this, 'restartTutorial', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ buildIndex: 0, run: true, continuous: true });
      }
    });
    Object.defineProperty(_this, 'isStepComplete', {
      enumerable: true,
      writable: true,
      value: function value(action, lifecycle) {
        return action === react_joyride_es["a" /* ACTIONS */].NEXT && lifecycle === react_joyride_es["c" /* LIFECYCLE */].COMPLETE;
      }
    });
    Object.defineProperty(_this, 'isStepReady', {
      enumerable: true,
      writable: true,
      value: function value(action, lifecycle) {
        return action === react_joyride_es["a" /* ACTIONS */].NEXT && lifecycle === react_joyride_es["c" /* LIFECYCLE */].READY;
      }
    });
    Object.defineProperty(_this, 'didTutorialClose', {
      enumerable: true,
      writable: true,
      value: function value(action) {
        return action === react_joyride_es["a" /* ACTIONS */].CLOSE;
      }
    });
    Object.defineProperty(_this, 'changeStep', {
      enumerable: true,
      writable: true,
      value: function value(index) {
        return _this.setState({ buildIndex: index });
      }
    });
    Object.defineProperty(_this, 'handleJoyrideSteps', {
      enumerable: true,
      writable: true,
      value: function value(data) {
        var action = data.action,
            index = data.index,
            lifecycle = data.lifecycle,
            type = data.type;
        // This opens the laborsheet table when user clicks next on first step

        if (index === 0 && _this.isStepComplete(action, lifecycle)) {
          var headerBtn = document.getElementById('header_laborSheet') || {};
          if (!Object(lodash["isEmpty"])(headerBtn)) headerBtn.click();
          _this.setState({ stepIndex: index + 1 });
        } else if (index === 1 && _this.isStepReady(action, lifecycle)) {
          _this.setState({ continuous: false });
        } else if (index === 2 && action === react_joyride_es["a" /* ACTIONS */].PREV) {
          _this.props.toggleStep2();
          _this.setState({ stepIndex: 1, continuous: false, runStep2: false });
        } else if (index === 2 && _this.isStepComplete(action, lifecycle)) {
          var editBtn = document.getElementById('laborSheet_edit') || {};
          if (!Object(lodash["isEmpty"])(editBtn)) {
            editBtn.click();
          }
          setTimeout(function () {
            return _this.setState({ stepIndex: index + 1, continuous: true });
          }, 500);
        } else if (index === 3 && _this.isStepComplete(action, lifecycle)) {
          _this.setState({ stepIndex: index + 1 });
        } else if (index === 4 && _this.isStepComplete(action, lifecycle)) {
          _this.setState({ stepIndex: 0, run: false });
        } else if (_this.didTutorialClose(action)) {
          _this.setState({ stepIndex: 0, run: false, continuous: true });
        } else if (type === react_joyride_es["b" /* EVENTS */].TARGET_NOT_FOUND) {
          // skip if target isnt mounted
          _this.setState({ stepIndex: index + 1 });
        } else if (type === react_joyride_es["b" /* EVENTS */].STEP_AFTER) {
          // this make sure back buttons work
          _this.setState({ stepIndex: index + (action === react_joyride_es["a" /* ACTIONS */].PREV ? -1 : 1) });
        }
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$state2 = _this.state,
            run = _this$state2.run,
            continuous = _this$state2.continuous,
            stepIndex = _this$state2.stepIndex;

        if (stepIndex === 1 && _this.props.runStep2) {
          _this.setState({ stepIndex: 2, run: true, continuous: true });
        }

        return react_default.a.createElement(
          'div',
          null,
          react_default.a.createElement('button', { id: 'tutorialRestartBtn', className: LPATutorial_default.a.joyrideBtn, type: 'button', onClick: _this.restartTutorial }),
          react_default.a.createElement('button', { id: 'runStep3Btn', className: LPATutorial_default.a.joyrideBtn, type: 'button', onClick: _this.runStep3 }),
          react_default.a.createElement(react_joyride_es["d" /* default */], {
            steps: ADD_INSTALLER_PAY_TUTORIAL,
            stepIndex: stepIndex,
            continuous: continuous // allows next button
            , run: run // toggles the tour
            , showProgress: true,
            disableOverlayClose: true // doesnt close when clicked outside
            , disableBeacon: true // clickable red dot that toggles the tutorial
            , callback: _this.handleJoyrideSteps
          })
        );
      }
    });


    _this.state = {
      run: false,
      stepIndex: 0,
      continuous: true,
      runStep2: false,
      step3Ref: {}
    };

    _this.restartTutorial = _this.restartTutorial.bind(_this);
    _this.runStep3 = _this.runStep3.bind(_this);
    return _this;
  }

  // This allows more programmatically control over joyride
  // data is props passed from Joyride, while tutorial is running


  return LPATutorial;
}(react["Component"]);

LPATutorial_LPATutorial.propTypes = {
  run: prop_types_default.a.bool,
  runStep2: prop_types_default.a.bool,
  toggleStep2: prop_types_default.a.func
};

/* harmony default export */ var components_SpotJoyride_LPATutorial = (LPATutorial_LPATutorial);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseAccounting/index.jsx
function phaseAccounting__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function phaseAccounting__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function phaseAccounting__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable jsx-a11y/no-static-element-interactions */
























var phaseAccounting_AccountingWidget = function (_Component) {
  phaseAccounting__inherits(AccountingWidget, _Component);

  function AccountingWidget(props) {
    phaseAccounting__classCallCheck(this, AccountingWidget);

    var _this = phaseAccounting__possibleConstructorReturn(this, (AccountingWidget.__proto__ || Object.getPrototypeOf(AccountingWidget)).call(this, props));

    phaseAccounting__initialiseProps.call(_this);

    var tables = ['walkthrough', 'chargeback', 'laborsheet', 'merchandise', 'purchase-order'];
    var lpaFocus = tables.find(function (ext) {
      return location.pathname.includes(ext);
    });
    _this.state = {
      // -When navigating to lpa tab without table path after '/', open all tables
      // -Including table in url navigates to and opens only that table
      showPurchaseOrderSection: _this.determineStateProperty(lpaFocus, 'purchase-order'),
      showPOLineItems: _this.determineStateProperty(lpaFocus, 'purchase-order'),
      showLaborSheetSection: _this.determineStateProperty(lpaFocus, 'laborsheet'),
      showLaborSheetLineItems: _this.determineStateProperty(lpaFocus, 'laborsheet'),
      showChargebackSection: _this.determineStateProperty(lpaFocus, 'chargeback'),
      showMerchandiseSection: _this.determineStateProperty(lpaFocus, 'merchandise'),
      runStep2LPATutorial: false,
      allTablesCollapsedBtn: _this.determineStateProperty(lpaFocus, 'walkthrough'),
      filterLineItems: true
    };
    _this.doLPATutorialStep2 = _this.doLPATutorialStep2.bind(_this);
    _this.purchaseOrderRef = react_default.a.createRef();
    _this.laborSheetRef = react_default.a.createRef();
    _this.merchandiseRef = react_default.a.createRef();
    _this.chargebackRef = react_default.a.createRef();
    return _this;
  }

  // eslint-disable-next-line consistent-return


  return AccountingWidget;
}(react["Component"]);

var phaseAccounting__initialiseProps = function _initialiseProps() {
  var _this2 = this;

  Object.defineProperty(this, 'componentWillMount', {
    enumerable: true,
    writable: true,
    value: function value() {
      _this2.props.fetchPhaseDocuments(_this2.props.phaseId);
      _this2.fetchContractorLineItems();
      _this2.fetchChargebackItems();
      _this2.fetchPurchaseOrders();
      _this2.fetchMerchandiseItems();
      _this2.fetchEmployeeData();
    }
  });
  Object.defineProperty(this, 'componentDidMount', {
    enumerable: true,
    writable: true,
    value: function value() {
      var tableNameInPathName = _this2.grabTableNameFromPathName();
      if (tableNameInPathName !== null) {
        if (location.pathname.includes('purchase-order')) _this2.focusTable('purchaseOrder');
        if (location.pathname.includes('laborsheet')) _this2.focusTable('laborSheet');
        if (location.pathname.includes('merchandise')) _this2.focusTable('merchandise');
        if (location.pathname.includes('chargeback')) _this2.focusTable('chargeback');
      } else _this2.startUrlPathCheckInterval();
    }
  });
  Object.defineProperty(this, 'componentDidUpdate', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _state = _this2.state,
          showPurchaseOrderSection = _state.showPurchaseOrderSection,
          showLaborSheetSection = _state.showLaborSheetSection,
          showChargebackSection = _state.showChargebackSection,
          showMerchandiseSection = _state.showMerchandiseSection,
          allTablesCollapsedBtn = _state.allTablesCollapsedBtn;

      var sections = [showPurchaseOrderSection, showLaborSheetSection, showChargebackSection, showMerchandiseSection];
      var anyOpened = sections.some(function (sect) {
        return sect;
      });
      var allCollapsed = sections.every(function (sect) {
        return !sect;
      });
      if (anyOpened && allTablesCollapsedBtn) _this2.setState({ allTablesCollapsedBtn: false });
      if (allCollapsed && !allTablesCollapsedBtn) _this2.setState({ allTablesCollapsedBtn: true });
    }
  });
  Object.defineProperty(this, 'componentWillUnmount', {
    enumerable: true,
    writable: true,
    value: function value() {
      return window.myInterval !== undefined ? window.clearInterval(window.myInterval) : null;
    }
  });
  Object.defineProperty(this, 'getRelevantTableItems', {
    enumerable: true,
    writable: true,
    value: function value(tableName) {
      var lineItemsArr = void 0;
      switch (tableName) {
        case 'purchaseOrder':
          lineItemsArr = _this2.props.purchaseOrders;
          break;
        case 'laborSheet':
          lineItemsArr = _this2.props.laborSheets;
          break;
        case 'merchandise':
          lineItemsArr = _this2.props.merchandiseItems;
          break;
        case 'chargeback':
          lineItemsArr = _this2.props.chargebackLineItems;
          break;
        default:
          lineItemsArr = [];
      }
      return lineItemsArr;
    }
  });
  Object.defineProperty(this, 'getTableCount', {
    enumerable: true,
    writable: true,
    value: function value(tableName) {
      var tableItems = _this2.getRelevantTableItems(tableName);
      var cbCount = 0;
      tableItems.forEach(function (cbli) {
        if (cbli.id > 0) cbCount += 1;
      });
      return cbCount;
    }
  });
  Object.defineProperty(this, 'getTableRef', {
    enumerable: true,
    writable: true,
    value: function value(tableName) {
      var tableRef = void 0;
      switch (tableName) {
        case 'chargeback':
          tableRef = _this2.chargebackRef;
          break;
        case 'purchaseOrder':
          tableRef = _this2.purchaseOrderRef;
          break;
        case 'laborSheet':
          tableRef = _this2.laborSheetRef;
          break;
        case 'merchandise':
          tableRef = _this2.merchandiseRef;
          break;
        default:
          tableRef = null;
      }
      return tableRef;
    }
  });
  Object.defineProperty(this, 'descVendor', {
    enumerable: true,
    writable: true,
    value: function value() {
      return Object(utils["E" /* vendorDisplayName */])(_this2.props.phaseSource, _this2.props.workroomName);
    }
  });
  Object.defineProperty(this, 'purchaseOrderDesc', {
    enumerable: true,
    writable: true,
    value: function value() {
      return 'Money being paid to SPIG from ' + _this2.descVendor();
    }
  });
  Object.defineProperty(this, 'laborSheetDesc', {
    enumerable: true,
    writable: true,
    value: function value() {
      return 'Money being paid to Sub-Contractor from SPIG';
    }
  });
  Object.defineProperty(this, 'merchDesc', {
    enumerable: true,
    writable: true,
    value: function value() {
      return 'Product sold to Customer by ' + _this2.descVendor();
    }
  });
  Object.defineProperty(this, 'chargebackDesc', {
    enumerable: true,
    writable: true,
    value: function value() {
      return 'Money owed to SPIG from Sub-Contractor or In-House monies that will not be recouped';
    }
  });
  Object.defineProperty(this, 'determineStateProperty', {
    enumerable: true,
    writable: true,
    value: function value(lpaFocus, comparator) {
      return comparator === 'walkthrough' ? lpaFocus === 'walkthrough' : lpaFocus === comparator || !lpaFocus;
    }
  });
  Object.defineProperty(this, 'grabTableNameFromPathName', {
    enumerable: true,
    writable: true,
    value: function value() {
      var tableNames = ['chargeback', 'purchase-order', 'laborsheet', 'merchandise'];
      var tableNameInPathName = tableNames.filter(function (name) {
        return location.pathname.includes(name);
      });
      return tableNameInPathName[0] === undefined ? null : tableNameInPathName[0];
    }
  });
  Object.defineProperty(this, 'startUrlPathCheckInterval', {
    enumerable: true,
    writable: true,
    value: function value() {
      var currentPath = location.pathname;
      if (window.myInterval !== undefined) clearInterval(window.myInterval);
      window.myInterval = setInterval(function () {
        var tableName = _this2.grabTableNameFromPathName();
        var isWalkthrough = location.pathname.includes('walkthrough');
        if (currentPath !== location.pathname && tableName !== null) {
          _this2.focusTable(tableName);
          if (window.myInterval !== undefined) clearInterval(window.myInterval);
          window.history.pushState(null, null, currentPath);
          _this2.startUrlPathCheckInterval();
        }
        if (currentPath !== location.pathname && isWalkthrough) {
          _this2.handleTables(true);
          window.history.pushState(null, null, '/phases/' + _this2.props.phaseId + '/labor-product-accounting');
        }
      }, 500);
    }
  });
  Object.defineProperty(this, 'handleTables', {
    enumerable: true,
    writable: true,
    value: function value() {
      var forceClose = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var _state2 = _this2.state,
          showPurchaseOrderSection = _state2.showPurchaseOrderSection,
          showLaborSheetSection = _state2.showLaborSheetSection,
          showChargebackSection = _state2.showChargebackSection,
          showMerchandiseSection = _state2.showMerchandiseSection;

      var sections = [showPurchaseOrderSection, showLaborSheetSection, showChargebackSection, showMerchandiseSection];
      var anyOpened = sections.some(function (sect) {
        return sect;
      });
      if (anyOpened || forceClose) {
        _this2.setState({
          showPurchaseOrderSection: false,
          showLaborSheetSection: false,
          showChargebackSection: false,
          showMerchandiseSection: false,
          showPOLineItems: false,
          showLaborSheetLineItems: false,
          allTablesCollapsedBtn: true
        });
      } else if (_this2.state.allTablesCollapsedBtn) {
        _this2.setState({
          showPurchaseOrderSection: true,
          showLaborSheetSection: true,
          showChargebackSection: true,
          showMerchandiseSection: true,
          showPOLineItems: true,
          showLaborSheetLineItems: true,
          allTablesCollapsedBtn: false
        });
      }
    }
  });
  Object.defineProperty(this, 'focusTable', {
    enumerable: true,
    writable: true,
    value: function value(tableName) {
      var tableRef = _this2.getTableRef(tableName);
      var tableHeaderOffset = 200;
      setTimeout(function () {
        window.scrollTo({
          left: 0,
          top: tableRef.current.offsetTop - tableHeaderOffset,
          behavior: 'smooth'
        });
      }, 200);

      switch (tableName) {
        case 'chargeback':
          _this2.setState({ showChargebackSection: true });
          break;
        case 'purchaseOrder':
          _this2.setState({ showPurchaseOrderSection: true });
          break;
        case 'laborSheet':
          _this2.setState({ showLaborSheetSection: true });
          break;
        case 'merchandise':
          _this2.setState({ showMerchandiseSection: true });
          break;
        default:
          return null;
      }
      window.history.pushState(null, null, '/phases/' + _this2.props.phaseId + '/labor-product-accounting');
      _this2.startUrlPathCheckInterval();
    }
  });
  Object.defineProperty(this, 'doLPATutorialStep2', {
    enumerable: true,
    writable: true,
    value: function value() {
      var run = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return _this2.setState({ runStep2LPATutorial: run });
    }
  });
  Object.defineProperty(this, 'fetchEmployeeData', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _props = _this2.props,
          employableId = _props.employableId,
          employableType = _props.employableType;

      if (employableType === 'employee') _this2.props.requestEmployee(employableId);
    }
  });
  Object.defineProperty(this, 'fetchContractorLineItems', {
    enumerable: true,
    writable: true,
    value: function value() {
      return _this2.props.requestPhaseItems(_this2.props.phaseId, 'contractorLineItems');
    }
  });
  Object.defineProperty(this, 'fetchChargebackItems', {
    enumerable: true,
    writable: true,
    value: function value() {
      return _this2.props.requestPhaseItems(_this2.props.phaseId, 'contractorChargebackItems');
    }
  });
  Object.defineProperty(this, 'fetchPurchaseOrders', {
    enumerable: true,
    writable: true,
    value: function value() {
      return _this2.props.requestPhaseItems(_this2.props.phaseId, 'purchaseOrders');
    }
  });
  Object.defineProperty(this, 'fetchMerchandiseItems', {
    enumerable: true,
    writable: true,
    value: function value() {
      return _this2.props.requestPhaseItems(_this2.props.phaseId, 'phaseMerchandiseItems');
    }
  });
  Object.defineProperty(this, 'toggleSection', {
    enumerable: true,
    writable: true,
    value: function value(section) {
      var _state3 = _this2.state,
          showPurchaseOrderSection = _state3.showPurchaseOrderSection,
          showLaborSheetSection = _state3.showLaborSheetSection,
          showChargebackSection = _state3.showChargebackSection,
          showMerchandiseSection = _state3.showMerchandiseSection;

      if (section === 'purchaseOrder') {
        if (showPurchaseOrderSection === false) _this2.toggleTableLineItems(section, false);
        _this2.setState({ showPurchaseOrderSection: !showPurchaseOrderSection });
      }
      if (section === 'laborSheet') {
        if (showLaborSheetSection === false) _this2.toggleTableLineItems(section, false);
        _this2.setState({ showLaborSheetSection: !showLaborSheetSection });
      }
      if (section === 'chargeback') _this2.setState({ showChargebackSection: !showChargebackSection });
      if (section === 'merchandise') _this2.setState({ showMerchandiseSection: !showMerchandiseSection });
    }
  });
  Object.defineProperty(this, 'toggleTableLineItems', {
    enumerable: true,
    writable: true,
    value: function value(tableName) {
      var reset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var _state4 = _this2.state,
          showPOLineItems = _state4.showPOLineItems,
          showLaborSheetLineItems = _state4.showLaborSheetLineItems;

      if (reset !== null) {
        if (tableName === 'purchaseOrder' && showPOLineItems !== reset) _this2.setState({ showPOLineItems: reset });
        if (tableName === 'laborSheet' && showLaborSheetLineItems !== reset) _this2.setState({ showLaborSheetLineItems: reset });
      } else {
        if (tableName === 'purchaseOrder') _this2.setState({ showPOLineItems: !showPOLineItems });
        if (tableName === 'laborSheet') _this2.setState({ showLaborSheetLineItems: !showLaborSheetLineItems });
      }
    }
  });
  Object.defineProperty(this, 'handleCheckboxChange', {
    enumerable: true,
    writable: true,
    value: function value() {
      var filterLineItems = _this2.state.filterLineItems;

      if (!filterLineItems) _this2.setState({ filterLineItems: true });else _this2.setState({ filterLineItems: false });
    }
  });
  Object.defineProperty(this, 'displayCorrectTable', {
    enumerable: true,
    writable: true,
    value: function value(tableName, showSection, permission) {
      var _props2 = _this2.props,
          phaseId = _props2.phaseId,
          documents = _props2.documents,
          employableType = _props2.employableType,
          chargebackLineItems = _props2.chargebackLineItems,
          purchaseOrders = _props2.purchaseOrders,
          laborSheets = _props2.laborSheets,
          merchandiseItems = _props2.merchandiseItems,
          phaseSource = _props2.phaseSource;
      var _state5 = _this2.state,
          showPOLineItems = _state5.showPOLineItems,
          showLaborSheetLineItems = _state5.showLaborSheetLineItems,
          filterLineItems = _state5.filterLineItems;

      var purchaseOrderSection = permission && showSection && react_default.a.createElement(purchaseOrderTable, {
        phaseId: phaseId,
        documents: documents,
        parentLineItems: purchaseOrders,
        showLineItems: showPOLineItems,
        toggleShowHide: _this2.toggleTableLineItems,
        tableName: tableName,
        expandableRow: true,
        filterLineItems: filterLineItems
      });
      var laborSheetSection = permission && showSection && react_default.a.createElement(laborSheetTable, {
        phaseId: phaseId,
        documents: documents,
        refreshLineItemList: _this2.fetchContractorLineItems,
        employableType: employableType,
        lineItems: laborSheets,
        showLineItems: showLaborSheetLineItems,
        toggleShowHide: _this2.toggleTableLineItems,
        tableName: tableName,
        doLPATutorialStep2: _this2.doLPATutorialStep2,
        filterLineItems: filterLineItems
      });
      var merchSection = showSection && react_default.a.createElement(phaseMerchandiseItemTable, {
        phaseId: phaseId, parentLineItems: merchandiseItems, phaseSource: phaseSource
      });
      var chargebackSection = permission && showSection && react_default.a.createElement(contractorChargebackTable, {
        phaseId: phaseId,
        documents: documents,
        lineItems: chargebackLineItems
      });
      switch (tableName) {
        case 'purchaseOrder':
          return purchaseOrderSection;
        case 'laborSheet':
          return laborSheetSection;
        case 'merchandise':
          return merchSection;
        case 'chargeback':
          return chargebackSection;
        default:
          return null;
      }
    }
  });
  Object.defineProperty(this, 'toolTip', {
    enumerable: true,
    writable: true,
    value: function value(tableName, tipDesc) {
      return react_default.a.createElement(
        'div',
        { className: phaseAccounting_styles_default.a.tooltip },
        react_default.a.createElement(
          'button',
          {
            className: phaseAccounting_styles_default.a.tooltipBtn,
            'data-tip': true,
            'data-for': tableName + 'Tip'
          },
          react_default.a.createElement('img', { src: pro_tip_default.a, alt: 'Pro Tip Icon', className: phaseAccounting_styles_default.a.tooltipImg })
        ),
        react_default.a.createElement(
          react_tooltip_dist_default.a,
          { id: tableName + 'Tip', place: 'top', effect: 'solid' },
          react_default.a.createElement(
            'span',
            { className: phaseAccounting_styles_default.a.tooltipText },
            tipDesc
          )
        )
      );
    }
  });
  Object.defineProperty(this, 'renderHandleTablesBtn', {
    enumerable: true,
    writable: true,
    value: function value(label, btnType) {
      return react_default.a.createElement(
        'div',
        { className: phaseAccounting_styles_default.a.collapseAllTablesBtn },
        react_default.a.createElement(
          react_toolbox_lib["FontIcon"],
          null,
          btnType
        ),
        react_default.a.createElement(
          'div',
          null,
          label
        ),
        react_default.a.createElement(
          react_toolbox_lib["FontIcon"],
          null,
          btnType
        )
      );
    }
  });
  Object.defineProperty(this, 'renderTable', {
    enumerable: true,
    writable: true,
    value: function value(tableName, tableTitle, tipDesc, showSection) {
      var showTableLineItems = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
      var permission = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;

      var tableCount = _this2.getTableCount(tableName);
      var tablesWithShowButton = ['purchaseOrder', 'laborSheet'];
      var tableRef = _this2.getTableRef(tableName);
      return permission && react_default.a.createElement(
        'div',
        {
          id: 'header_' + tableName // LPATutorial installerPayTutorial1
          , className: showSection ? phaseAccounting_styles_default.a.activeContainerStyles : phaseAccounting_styles_default.a.InactiveContainerStyles,
          ref: tableRef,
          onClick: function onClick() {
            return _this2.toggleSection(tableName);
          }
        },
        tableCount > 0 ? react_default.a.createElement(
          'div',
          { className: phaseAccounting_styles_default.a.header },
          tableTitle,
          react_default.a.createElement(
            'div',
            { className: tableName === 'chargeback' ? phaseAccounting_styles_default.a.redCount : phaseAccounting_styles_default.a.greenCount },
            '(' + tableCount + ')'
          ),
          _this2.toolTip(tableName, tipDesc)
        ) : react_default.a.createElement(
          'div',
          { className: phaseAccounting_styles_default.a.header },
          react_default.a.createElement(
            'div',
            null,
            tableTitle
          ),
          _this2.toolTip(tableName, tipDesc)
        ),
        react_default.a.createElement(
          'div',
          { className: showSection ? phaseAccounting_styles_default.a.content : '', onClick: function onClick(e) {
              return e.stopPropagation(e);
            } },
          tablesWithShowButton.includes(tableName) && showSection && react_default.a.createElement(
            'div',
            {
              className: phaseAccounting_styles_default.a.btnWrapper,
              onClick: function onClick(e) {
                return e.stopPropagation(e);
              }
            },
            react_default.a.createElement(
              'button',
              {
                id: 'showLIBtn_' + tableName,
                className: phaseAccounting_styles_default.a.showHideBtn,
                onClick: function onClick() {
                  return _this2.toggleTableLineItems(tableName);
                }
              },
              !showTableLineItems ? 'SHOW Line Items' : 'HIDE Line Items'
            )
          ),
          _this2.displayCorrectTable(tableName, showSection, permission),
          react_default.a.createElement(
            'div',
            {
              className: phaseAccounting_styles_default.a.shelfBottom,
              onClick: function onClick() {
                return _this2.toggleSection(tableName);
              }
            },
            react_default.a.createElement(
              'div',
              { className: showSection ? phaseAccounting_styles_default.a.shelfBottomCollapse : phaseAccounting_styles_default.a.shelfBottomExpand },
              react_default.a.createElement(
                react_toolbox_lib["FontIcon"],
                { className: phaseAccounting_styles_default.a.shelfBottomArrow },
                showSection ? 'keyboard_arrow_up' : 'keyboard_arrow_down'
              )
            )
          )
        )
      );
    }
  });
  Object.defineProperty(this, 'render', {
    enumerable: true,
    writable: true,
    value: function value() {
      var role = _this2.props.role;
      var _state6 = _this2.state,
          showPurchaseOrderSection = _state6.showPurchaseOrderSection,
          showLaborSheetSection = _state6.showLaborSheetSection,
          showMerchandiseSection = _state6.showMerchandiseSection,
          showChargebackSection = _state6.showChargebackSection,
          showPOLineItems = _state6.showPOLineItems,
          showLaborSheetLineItems = _state6.showLaborSheetLineItems,
          runStep2LPATutorial = _state6.runStep2LPATutorial,
          allTablesCollapsedBtn = _state6.allTablesCollapsedBtn,
          filterLineItems = _state6.filterLineItems;

      return react_default.a.createElement(
        'div',
        null,
        react_default.a.createElement(react_toolbox_lib["Checkbox"], {
          checked: filterLineItems,
          className: form_default.a.purchaseOrdercheckbox,
          onChange: _this2.handleCheckboxChange,
          label: 'Filter Line Item Options By Phase Surface Type',
          theme: checkbox_default.a, type: 'checkbox',
          styles: { textAlign: 'center' }
        }),
        react_default.a.createElement(
          'button',
          {
            className: phaseAccounting_styles_default.a.collapseAllTablesBtnContainer,
            onClick: function onClick() {
              return _this2.handleTables();
            }
          },
          allTablesCollapsedBtn ? _this2.renderHandleTablesBtn('Expand All Tables', 'keyboard_arrow_down') : _this2.renderHandleTablesBtn('Collapse All Tables', 'keyboard_arrow_up')
        ),
        react_default.a.createElement(components_SpotJoyride_LPATutorial, { runStep2: runStep2LPATutorial, toggleStep2: _this2.doLPATutorialStep2 }),
        react_default.a.createElement(
          'div',
          { id: 'installerPayTutorial0', className: phaseAccounting_styles_default.a.layout },
          _this2.renderTable('purchaseOrder', 'PURCHASE ORDERS', _this2.purchaseOrderDesc(), showPurchaseOrderSection, showPOLineItems, Object(services["a" /* can */])(role, 'view', 'purchase_order')),
          _this2.renderTable('laborSheet', 'LABOR SHEETS', _this2.laborSheetDesc(), showLaborSheetSection, showLaborSheetLineItems, Object(services["a" /* can */])(role, 'view', 'labor_sheet')),
          _this2.renderTable('merchandise', 'MERCHANDISE', _this2.merchDesc(), showMerchandiseSection),
          _this2.renderTable('chargeback', 'CHARGEBACKS', _this2.chargebackDesc(), showChargebackSection, null, Object(services["a" /* can */])(role, 'view', 'chargeback'))
        )
      );
    }
  });
};

phaseAccounting_AccountingWidget.propTypes = {
  phaseId: prop_types_default.a.string,
  phaseSource: prop_types_default.a.string,
  workroomName: prop_types_default.a.string,
  documents: prop_types_default.a.arrayOf(documentUpload).isRequired,
  lineItems: prop_types_default.a.arrayOf(prop_types_default.a.shape(contractorChargebackItem)),
  purchaseOrders: prop_types_default.a.arrayOf(prop_types_default.a.shape(purchaseOrder)),
  laborSheets: prop_types_default.a.arrayOf(types_laborSheet),
  merchandiseItems: prop_types_default.a.arrayOf(prop_types_default.a.shape(phaseMerchandiseItem)),
  chargebackLineItems: prop_types_default.a.arrayOf(prop_types_default.a.shape(contractorChargebackItem)),
  role: prop_types_default.a.string.isRequired,
  employableId: prop_types_default.a.number,
  employableType: prop_types_default.a.string,
  fetchPhaseDocuments: prop_types_default.a.func.isRequired,
  documentsLoaded: prop_types_default.a.bool.isRequired,
  requestPhaseItems: prop_types_default.a.func.isRequired,
  requestEmployee: prop_types_default.a.func.isRequired
};

/* harmony default export */ var phaseAccounting = (Object(react_redux_es["connect"])(function (state) {
  return {
    purchaseOrders: state.phase.purchaseOrders.items,
    laborSheets: state.phase.laborSheets.items,
    merchandiseItems: state.phase.phaseMerchandiseItems.items,
    chargebackLineItems: state.phase.contractorChargebackItems.items,
    documents: state.phase.documents.data,
    documentsLoaded: state.phase.documents.loaded,
    role: Object(reducers["_12" /* getRole */])(state),
    employableType: state.user.employable_type.toLowerCase(),
    employableId: state.user.employable_id,
    phaseSource: state.phase.details.source || '',
    workroomName: state.phase.details.workroom ? state.phase.details.workroom.name : null

  };
}, { fetchPhaseDocuments: actionCreators["A" /* fetchPhaseDocuments */], requestPhaseItems: actionCreators["_17" /* requestPhaseItems */], requestEmployee: actionCreators["X" /* requestEmployee */] })(phaseAccounting_AccountingWidget));
// CONCATENATED MODULE: ./client/app/shared/types/warehouseMerchandiseItem.js


/* harmony default export */ var warehouseMerchandiseItem = ({
  id: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]),
  item_name: prop_types_default.a.string,
  received_quantity: prop_types_default.a.number,
  status: prop_types_default.a.string,
  po_number: prop_types_default.a.string,
  phase_line_item_id: prop_types_default.a.number,
  tag_number: prop_types_default.a.number,
  bin: prop_types_default.a.string,
  note: prop_types_default.a.string,
  errors: prop_types_default.a.shape({
    item_name: prop_types_default.a.array,
    received_quantity: prop_types_default.a.array,
    status: prop_types_default.a.array,
    tag_number: prop_types_default.a.array,
    bin: prop_types_default.a.array,
    note: prop_types_default.a.array
  })
});
// EXTERNAL MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/warehouseMaterials/components/printLabel.scss
var printLabel = __webpack_require__("Uqwq");
var printLabel_default = /*#__PURE__*/__webpack_require__.n(printLabel);

// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/warehouseMaterials/components/printLabel.jsx
function printLabel__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function printLabel__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function printLabel__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var printLabel_PrintLabel = function (_Component) {
  printLabel__inherits(PrintLabel, _Component);

  function PrintLabel() {
    var _ref;

    var _temp, _this, _ret;

    printLabel__classCallCheck(this, PrintLabel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = printLabel__possibleConstructorReturn(this, (_ref = PrintLabel.__proto__ || Object.getPrototypeOf(PrintLabel)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'buildQuery', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            phase = _this$props.phase,
            lineItem = _this$props.lineItem,
            padInfo = _this$props.padInfo;
        var quantity = lineItem.received_quantity,
            tagNumber = lineItem.tag_number,
            bin = lineItem.bin,
            itemName = lineItem.item_name;
        var details = phase.details;
        var customerName = details.customer_name,
            store = details.store;

        var dateReceived = lineItem.date_received ? moment_default()(lineItem.date_received).format('MM/DD/YYYY') : null;
        var b64Query = btoa(JSON.stringify([{
          storeNumber: store.number,
          customerName: customerName,
          poNumber: lineItem.po_number,
          quantity: quantity,
          dateReceived: dateReceived,
          tagNumber: tagNumber,
          bin: bin,
          itemName: itemName.replace(/\s\s+/g, ' ').trim(),
          pads: padInfo
        }]));
        return { queryData: JSON.stringify(b64Query) };
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        return react_default.a.createElement(
          es["c" /* Link */],
          {
            className: printLabel_default.a.anchor,
            to: { pathname: '/print-label', query: _this.buildQuery() },
            target: '_blank'
          },
          react_default.a.createElement(react_toolbox_lib["FontIcon"], { className: printLabel_default.a.icon, value: 'ic_print' })
        );
      }
    }), _temp), printLabel__possibleConstructorReturn(_this, _ret);
  }

  return PrintLabel;
}(react["Component"]);

printLabel_PrintLabel.propTypes = {
  lineItem: prop_types_default.a.shape(warehouseMerchandiseItem),
  phase: types_phase.isRequired,
  padInfo: prop_types_default.a.arrayOf(prop_types_default.a.shape({ cut_quantity: prop_types_default.a.string }))
};

/* harmony default export */ var components_printLabel = (Object(react_redux_es["connect"])(function (state) {
  return { phase: state.phase };
})(printLabel_PrintLabel));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/warehouseMaterials/components/warehouseMerchandiseTableRow.jsx
var warehouseMerchandiseTableRow__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function warehouseMerchandiseTableRow__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function warehouseMerchandiseTableRow__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function warehouseMerchandiseTableRow__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function warehouseMerchandiseTableRow__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var warehouseMerchandiseTableRow_WarehouseMerchandiseTableRow = function (_Editable) {
  warehouseMerchandiseTableRow__inherits(WarehouseMerchandiseTableRow, _Editable);

  function WarehouseMerchandiseTableRow() {
    var _ref;

    var _temp, _this, _ret;

    warehouseMerchandiseTableRow__classCallCheck(this, WarehouseMerchandiseTableRow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = warehouseMerchandiseTableRow__possibleConstructorReturn(this, (_ref = WarehouseMerchandiseTableRow.__proto__ || Object.getPrototypeOf(WarehouseMerchandiseTableRow)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'state', {
      enumerable: true,
      writable: true,
      value: warehouseMerchandiseTableRow__extends({}, _this.props.lineItem)
    }), Object.defineProperty(_this, 'handleChange', {
      enumerable: true,
      writable: true,
      value: function value(key) {
        return function (event) {
          var value = null;
          if (['item_name', 'bin', 'note'].includes(key)) {
            value = event.target ? event.target.value : event;
            if (!value) value = '';
            // these characters stay in the code because we are catching them here,
            // not using them.
            value = value.replace(/[´‘’']/g, ' ft').replace(/[“”"]/g, ' in').replace(/[^\w\s]/gi, '');
          } else if (key === 'status') value = event.status;else if (key === 'date_received') value = moment_default()(event).format(constants["_19" /* RAILS_DATE */]);else value = event.target ? event.target.value : event;
          _this.setState(warehouseMerchandiseTableRow__defineProperty({}, key, value));
        };
      }
    }), Object.defineProperty(_this, 'handleStatusChange', {
      enumerable: true,
      writable: true,
      value: _this.handleChange('status')
    }), Object.defineProperty(_this, 'handleDateChange', {
      enumerable: true,
      writable: true,
      value: _this.handleChange('date_received')
    }), Object.defineProperty(_this, 'handlePOChange', {
      enumerable: true,
      writable: true,
      value: _this.handleChange('purchase_order_id')
    }), Object.defineProperty(_this, 'handleItemNameChange', {
      enumerable: true,
      writable: true,
      value: _this.handleChange('item_name')
    }), Object.defineProperty(_this, 'handleReceivedQuantityChange', {
      enumerable: true,
      writable: true,
      value: _this.handleChange('received_quantity')
    }), Object.defineProperty(_this, 'handleBinChange', {
      enumerable: true,
      writable: true,
      value: _this.handleChange('bin')
    }), Object.defineProperty(_this, 'handleNoteChange', {
      enumerable: true,
      writable: true,
      value: _this.handleChange('note')
    }), Object.defineProperty(_this, 'handleStatusSave', {
      enumerable: true,
      writable: true,
      value: function value(lineItem) {
        return _this.props.onSave(lineItem);
      }
    }), Object.defineProperty(_this, 'handleSave', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.onSave(_this.state);
      }
    }), Object.defineProperty(_this, 'handleDelete', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.onDelete(_this.state.id);
      }
    }), Object.defineProperty(_this, 'renderStatusCell', {
      enumerable: true,
      writable: true,
      value: function value() {
        var options = constants["_58" /* WAREHOUSE_MERCHANDISE_STATUSES */];
        var onChange = _this.context.isEditable ? _this.handleStatusChange : _this.handleStatusSave;
        var lineItemStatusProps = { onChange: onChange, lineItem: _this.state, options: options };
        var value = _this.props.readOnly ? _this.state.status : react_default.a.createElement(lineItemStatus, lineItemStatusProps);
        return react_default.a.createElement(
          editableTableCell,
          { onChange: onChange, label: 'Status', value: value, className: table_default.a.largeColumn },
          value
        );
      }
    }), Object.defineProperty(_this, 'renderTagNumber', {
      enumerable: true,
      writable: true,
      value: function value() {
        var value = react_default.a.createElement(
          'div',
          { style: { width: 92, position: 'relative' } },
          _this.state.tag_number,
          react_default.a.createElement(components_printLabel, { lineItem: _this.state, padInfo: _this.props.padInfo })
        );
        return react_default.a.createElement(editableTableCell, {
          display: !_this.context.isEditable,
          label: 'Tag #',
          value: value
        });
      }
    }), Object.defineProperty(_this, 'renderDateReceived', {
      enumerable: true,
      writable: true,
      value: function value() {
        var lineItem = _this.state;
        var dateReceived = lineItem.date_received ? moment_default()(lineItem.date_received).format(constants["E" /* DISPLAY_DATE */]) : '';
        var onChange = _this.handleDateChange;
        var value = react_default.a.createElement(DatePicker, { value: dateReceived, onChange: onChange });
        var cellProps = { label: 'Date Received', onChange: onChange, value: dateReceived, className: table_default.a.smallColumn };
        return react_default.a.createElement(
          editableTableCell,
          cellProps,
          value
        );
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var lineItem = _this.state;
        var rowProps = { isNew: lineItem.id < 0, onSave: _this.handleSave, onDelete: _this.showDeleteDialog };
        return react_default.a.createElement(
          editableTableRow,
          warehouseMerchandiseTableRow__extends({ key: lineItem.id, id: lineItem.id }, rowProps),
          react_default.a.createElement(components_LineItemTable_itemEvents, {
            display: !_this.context.isEditable,
            label: '',
            itemType: 'warehouseMerchandiseItems',
            lineItem: lineItem,
            dataKeys: ['po_number', 'item_name', 'received_quantity', 'tag_number', 'bin', 'date_received', 'status']
          }),
          react_default.a.createElement(dropDownCell, {
            attr: 'purchase_order',
            isIdAttr: true,
            label: 'PO Number',
            lineItem: lineItem,
            options: _this.props.purchaseOrderOptions,
            cellValue: lineItem.po_number || '',
            onChange: _this.handlePOChange
          }),
          react_default.a.createElement(inputCell, { attr: 'item_name', label: 'Item Name', lineItem: lineItem, onChange: _this.handleItemNameChange }),
          react_default.a.createElement(inputCell, { attr: 'received_quantity', label: 'QTY Received', lineItem: lineItem, onChange: _this.handleReceivedQuantityChange }),
          _this.renderTagNumber(),
          react_default.a.createElement(inputCell, { attr: 'bin', label: 'Bin', lineItem: lineItem, onChange: _this.handleBinChange }),
          _this.renderDateReceived(),
          react_default.a.createElement(LineItemTable_itemNote, { display: true, label: 'Note', onChange: _this.handleNoteChange, note: lineItem.note, errors: lineItem.errors, id: lineItem.id }),
          _this.renderStatusCell()
        );
      }
    }), _temp), warehouseMerchandiseTableRow__possibleConstructorReturn(_this, _ret);
  }

  return WarehouseMerchandiseTableRow;
}(mixins_editable(react_default.a.Component));

warehouseMerchandiseTableRow_WarehouseMerchandiseTableRow.contextTypes = { isEditable: prop_types_default.a.bool };

warehouseMerchandiseTableRow_WarehouseMerchandiseTableRow.propTypes = {
  lineItem: prop_types_default.a.shape(warehouseMerchandiseItem),
  onSave: prop_types_default.a.func,
  onDelete: prop_types_default.a.func,
  purchaseOrderOptions: purchaseOrderOptionsType,
  readOnly: prop_types_default.a.bool,
  padInfo: prop_types_default.a.arrayOf(prop_types_default.a.shape({ cut_quantity: prop_types_default.a.string }))
};

warehouseMerchandiseTableRow_WarehouseMerchandiseTableRow.defaultProps = { lineItem: {} };

/* harmony default export */ var warehouseMerchandiseTableRow = (warehouseMerchandiseTableRow_WarehouseMerchandiseTableRow);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/warehouseMaterials/components/warehouseMerchandiseItemTable.jsx
function warehouseMerchandiseItemTable__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function warehouseMerchandiseItemTable__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function warehouseMerchandiseItemTable__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var warehouseMerchandiseItemTable_LINE_ITEM_TYPE = 'warehouseMerchandiseItems';

var warehouseMerchandiseItemTable_WarehouseMerchandiseItemTable = function (_Component) {
  warehouseMerchandiseItemTable__inherits(WarehouseMerchandiseItemTable, _Component);

  function WarehouseMerchandiseItemTable() {
    var _ref;

    var _temp, _this, _ret;

    warehouseMerchandiseItemTable__classCallCheck(this, WarehouseMerchandiseItemTable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = warehouseMerchandiseItemTable__possibleConstructorReturn(this, (_ref = WarehouseMerchandiseItemTable.__proto__ || Object.getPrototypeOf(WarehouseMerchandiseItemTable)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'handleDelete', {
      enumerable: true,
      writable: true,
      value: function value(lineItemId) {
        return _this.props.deletePhaseItem(_this.props.phaseId, { id: lineItemId }, warehouseMerchandiseItemTable_LINE_ITEM_TYPE);
      }
    }), Object.defineProperty(_this, 'handleSave', {
      enumerable: true,
      writable: true,
      value: function value(lineItem) {
        return _this.props.savePhaseItem(_this.props.phaseId, lineItem, warehouseMerchandiseItemTable_LINE_ITEM_TYPE);
      }
    }), Object.defineProperty(_this, 'refreshLineItemList', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.requestPhaseItems(_this.props.phaseId, warehouseMerchandiseItemTable_LINE_ITEM_TYPE);
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        return react_default.a.createElement(
          components_LineItemTable,
          {
            title: 'Warehouse Merchandise',
            refreshList: _this.refreshLineItemList,
            readOnly: !_this.props.editable,
            cv: _this.props.cv
          },
          _this.props.lineItems.map(function (item) {
            return react_default.a.createElement(warehouseMerchandiseTableRow, {
              padInfo: _this.props.padInfo,
              key: item.id,
              onSave: _this.handleSave,
              onDelete: _this.handleDelete,
              lineItem: item,
              purchaseOrderOptions: _this.props.purchaseOrderOptions,
              readOnly: !_this.props.editable
            });
          })
        );
      }
    }), _temp), warehouseMerchandiseItemTable__possibleConstructorReturn(_this, _ret);
  }

  return WarehouseMerchandiseItemTable;
}(react["Component"]);

warehouseMerchandiseItemTable_WarehouseMerchandiseItemTable.defaultProps = {
  lineItems: [], editable: true, cv: false
};

warehouseMerchandiseItemTable_WarehouseMerchandiseItemTable.propTypes = {
  phaseId: prop_types_default.a.string,
  lineItems: prop_types_default.a.arrayOf(prop_types_default.a.shape(warehouseMerchandiseItem)),
  requestPhaseItems: prop_types_default.a.func,
  savePhaseItem: prop_types_default.a.func,
  deletePhaseItem: prop_types_default.a.func,
  purchaseOrderOptions: purchaseOrderOptionsType,
  editable: prop_types_default.a.bool.isRequired,
  padInfo: prop_types_default.a.arrayOf(prop_types_default.a.shape({
    cut_quantity: prop_types_default.a.string, description: prop_types_default.a.string
  })),
  cv: prop_types_default.a.bool
};

/* harmony default export */ var warehouseMerchandiseItemTable = (Object(react_redux_es["connect"])(function (state) {
  return { purchaseOrderOptions: selectors_purchaseOrderOptions(state) };
}, {
  requestPhaseItems: phase_items["i" /* requestPhaseItems */], savePhaseItem: phase_items["k" /* savePhaseItem */], deletePhaseItem: phase_items["e" /* deletePhaseItem */]
})(warehouseMerchandiseItemTable_WarehouseMerchandiseItemTable));
// EXTERNAL MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/components/assessmentSelection.scss
var assessmentSelection = __webpack_require__("RetX");
var assessmentSelection_default = /*#__PURE__*/__webpack_require__.n(assessmentSelection);

// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/components/assessmentSelection.jsx
function assessmentSelection__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function assessmentSelection__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function assessmentSelection__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var VerifyButton = Auth_visibleFor('verify_document', 'phase', function (_ref) {
  var disabled = _ref.disabled,
      onClick = _ref.onClick;
  return react_default.a.createElement(ColoredButton["a" /* default */], {
    className: assessmentSelection_default.a.actionButton,
    responsive: true,
    color: 'blue',
    label: 'Verify Document',
    onClick: onClick,
    disabled: disabled
  });
});

var assessmentSelection_AssessmentSelection = function (_Component) {
  assessmentSelection__inherits(AssessmentSelection, _Component);

  function AssessmentSelection(props) {
    assessmentSelection__classCallCheck(this, AssessmentSelection);

    var _this = assessmentSelection__possibleConstructorReturn(this, (AssessmentSelection.__proto__ || Object.getPrototypeOf(AssessmentSelection)).call(this, props));

    Object.defineProperty(_this, 'componentWillMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return !_this.hasParentDocs() ? _this.props.fetchPhaseDocuments(_this.props.phaseId).then(_this.setVerifiedDocument) : _this.setVerifiedDocument();
      }
    });
    Object.defineProperty(_this, 'setVerifiedDocument', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            documents = _this$props.documents,
            verifiedDocumentId = _this$props.verifiedDocumentId;

        if (!verifiedDocumentId) return;
        var doc = documents.find(function (d) {
          return d.id === verifiedDocumentId;
        });
        if (!doc) return;
        _this.setState({ url: doc.expiring_download_url, id: doc.id });
      }
    });
    Object.defineProperty(_this, 'getDocumentLabel', {
      enumerable: true,
      writable: true,
      value: function value(doc) {
        var verifiedDocumentId = _this.props.verifiedDocumentId;

        var VERIFIED_STRING = ' (Verified Document)';
        var verified = doc.id === verifiedDocumentId ? VERIFIED_STRING : '';
        var documentName = doc.document_name + ' ' + Object(dateUtils["l" /* getMinLocalDate */])(doc.created_at);
        return '' + documentName + verified;
      }
    });
    Object.defineProperty(_this, 'getDocOptions', {
      enumerable: true,
      writable: true,
      value: function value() {
        var documents = _this.props.documents;

        return documents.filter(function (doc) {
          return doc.document_type === 'Assessment/Refigure';
        }).map(function (doc) {
          return {
            label: _this.getDocumentLabel(doc),
            value: doc.id,
            url: doc.expiring_download_url
          };
        });
      }
    });
    Object.defineProperty(_this, 'hasParentDocs', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.parentDocs.length || [] > 0;
      }
    });
    Object.defineProperty(_this, 'handleOpenDocument', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.state.url ? window.open(_this.state.url, '_blank', 'toolbar=1, scrollbars=1, location=1, statusbar=0, menubar=1, resizable=1, width=900, height=900') : null;
      }
    });
    Object.defineProperty(_this, 'handleStatusChange', {
      enumerable: true,
      writable: true,
      value: function value(option) {
        return _this.setState({ url: option.url, id: option.value });
      }
    });
    Object.defineProperty(_this, 'verifyDocument', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.verifyPhaseAssessment({
          verified_assessment_document_id: _this.state.id,
          id: _this.props.phaseId
        });
      }
    });
    Object.defineProperty(_this, 'renderContents', {
      enumerable: true,
      writable: true,
      value: function value() {
        return react_default.a.createElement(
          flexbox_react_dist_default.a,
          { justifyContent: 'flex-end', flexWrap: 'wrap' },
          react_default.a.createElement(Select_default.a, {
            autoSize: false,
            placeholder: 'Select Assessment/Refigure',
            onChange: _this.handleStatusChange,
            options: _this.getDocOptions(),
            className: react_select_styles_default.a.prettyDropDown + ' ' + assessmentSelection_default.a.wrapper,
            value: _this.state.id,
            clearable: false
          }),
          react_default.a.createElement(ColoredButton["a" /* default */], {
            className: assessmentSelection_default.a.actionButton,
            responsive: true,
            color: 'green',
            label: 'Open document in new window',
            onClick: _this.handleOpenDocument,
            disabled: !_this.state.id
          }),
          react_default.a.createElement(VerifyButton, {
            onClick: _this.verifyDocument,
            disabled: !_this.state.id
          })
        );
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.cv ? _this.renderContents() : react_default.a.createElement(
          'div',
          { className: assessmentSelection_default.a.wrapper },
          _this.renderContents()
        );
      }
    });

    _this.state = { url: '', id: '' };
    return _this;
  }

  return AssessmentSelection;
}(react["Component"]);

assessmentSelection_AssessmentSelection.defaultProps = { documents: [], parentDocs: [], cv: false };

assessmentSelection_AssessmentSelection.propTypes = {
  phaseId: prop_types_default.a.number.isRequired,
  verifiedDocumentId: prop_types_default.a.number,
  verifyPhaseAssessment: prop_types_default.a.func.isRequired,
  parentDocs: prop_types_default.a.arrayOf(documentUpload),
  documents: prop_types_default.a.arrayOf(documentUpload).isRequired,
  fetchPhaseDocuments: prop_types_default.a.func.isRequired,
  cv: prop_types_default.a.bool
};

var assessmentSelection_mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    phaseId: state.phase.details.id,
    verifiedDocumentId: state.phase.details.verified_assessment_document_id,
    documents: (ownProps.parentDocs || []).length > 0 ? ownProps.parentDocs : state.phase.documents.data
  };
};

/* harmony default export */ var components_assessmentSelection = (Object(react_redux_es["connect"])(assessmentSelection_mapStateToProps, {
  fetchPhaseDocuments: actionCreators["A" /* fetchPhaseDocuments */], verifyPhaseAssessment: actionCreators["_80" /* verifyPhaseAssessment */]
})(assessmentSelection_AssessmentSelection));
// CONCATENATED MODULE: ./client/app/shared/actionCreators/merged_phases.js



var merged_phases__createActions = Object(redux_actions_lib["createActions"])({
  CREATE_MERGED_PHASES_SUCCESS: function CREATE_MERGED_PHASES_SUCCESS(json, relatedPhaseId) {
    return {
      message: json.message,
      relatedPhaseId: relatedPhaseId
    };
  }
}, 'CREATE_MERGED_PHASES_REQUEST', 'CREATE_MERGED_PHASES_FAILURE'),
    createMergedPhasesRequest = merged_phases__createActions.createMergedPhasesRequest,
    createMergedPhasesSuccess = merged_phases__createActions.createMergedPhasesSuccess,
    createMergedPhasesFailure = merged_phases__createActions.createMergedPhasesFailure;

function createMergedPhases(phaseId, relatedPhaseId) {
  return function (dispatch) {
    dispatch(createMergedPhasesRequest());

    var req = { method: 'POST', body: { related_phase_id: relatedPhaseId } };
    return Object(services["h" /* request */])('phases/' + phaseId + '/merged_phases', req).then(function (_ref) {
      var json = _ref.json;
      return dispatch(createMergedPhasesSuccess(json, phaseId));
    }).catch(function (error) {
      return dispatch(createMergedPhasesFailure(error));
    });
  };
}
// EXTERNAL MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/relatedPhases/styles.scss
var relatedPhases_styles = __webpack_require__("aO8m");
var relatedPhases_styles_default = /*#__PURE__*/__webpack_require__.n(relatedPhases_styles);

// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/relatedPhases/components/phaseSearch.jsx
function phaseSearch__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function phaseSearch__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function phaseSearch__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var phaseSearch_PhaseSearch = function (_Component) {
  phaseSearch__inherits(PhaseSearch, _Component);

  function PhaseSearch() {
    var _ref;

    var _temp, _this, _ret;

    phaseSearch__classCallCheck(this, PhaseSearch);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = phaseSearch__possibleConstructorReturn(this, (_ref = PhaseSearch.__proto__ || Object.getPrototypeOf(PhaseSearch)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'componentWillMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props$phase = _this.props.phase,
            _this$props$phase$str = _this$props$phase.street_address,
            street_address = _this$props$phase$str === undefined ? '' : _this$props$phase$str,
            _this$props$phase$cit = _this$props$phase.city,
            city = _this$props$phase$cit === undefined ? '' : _this$props$phase$cit,
            _this$props$phase$sta = _this$props$phase.state,
            state = _this$props$phase$sta === undefined ? '' : _this$props$phase$sta,
            _this$props$phase$zip = _this$props$phase.zip_code,
            zip_code = _this$props$phase$zip === undefined ? '' : _this$props$phase$zip,
            _this$props$phase$cus = _this$props$phase.customer_name,
            customer_name = _this$props$phase$cus === undefined ? '' : _this$props$phase$cus;

        var initialQuery = street_address + ', ' + city + ', ' + state + ', ' + zip_code + ', ' + customer_name;
        _this.search({ query: initialQuery, limit: 3 });
        _this.state = { searchTerms: '' };
      }
    }), Object.defineProperty(_this, 'onSearch', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        e.preventDefault();
        var searchTerms = e.target.query.value.trim() || undefined;
        _this.setState({ searchTerms: searchTerms }, function () {
          return _this.search({ query: searchTerms });
        });
      }
    }), Object.defineProperty(_this, 'search', {
      enumerable: true,
      writable: true,
      value: function value(query) {
        return _this.props.resetPhasePagination(query).then(function () {
          return _this.props.requestPhaseList();
        });
      }
    }), Object.defineProperty(_this, 'renderPhaseList', {
      enumerable: true,
      writable: true,
      value: function value(phaseList) {
        if (_this.props.loading) {
          return react_default.a.createElement(components_Loading, null);
        } else if (phaseList.length === 0) {
          return react_default.a.createElement(
            'div',
            { className: relatedPhases_styles_default.a.emptyRelatedPhasesContainer },
            react_default.a.createElement(
              'span',
              { className: relatedPhases_styles_default.a.emptyText },
              'We couldn\'t find anything. Try using the search box above.'
            )
          );
        }
        return phaseList;
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            phases = _this$props.phases,
            role = _this$props.role,
            position = _this$props.position,
            relatedPhaseIds = _this$props.relatedPhaseIds,
            onLinkClick = _this$props.onLinkClick,
            _this$props$phase$id = _this$props.phase.id,
            currId = _this$props$phase$id === undefined ? null : _this$props$phase$id;

        var phaseList = phases.filter(function (phase) {
          return phase.id !== currId && relatedPhaseIds.indexOf(phase.id) === -1;
        }).map(function (phase) {
          var _phase$id = phase.id,
              id = _phase$id === undefined ? null : _phase$id,
              _phase$surface_type = phase.surface_type,
              surface_type = _phase$surface_type === undefined ? null : _phase$surface_type,
              _phase$store = phase.store,
              store = _phase$store === undefined ? null : _phase$store;

          var actionButton = Object(services["a" /* can */])(role, 'relate', 'phase') ? { text: 'Link Phase', onClick: function onClick() {
              return onLinkClick(id);
            } } : null;
          return react_default.a.createElement(components_phaseCard, {
            key: 'phase-' + id,
            role: role,
            position: position,
            phase: phase,
            onSelect: _this.viewAction,
            surfaceType: surface_type,
            store: store,
            actionButton: actionButton
          });
        });
        return react_default.a.createElement(
          'div',
          null,
          react_default.a.createElement(
            components_CardTitle,
            {
              title: 'Phase Search',
              subtitle: 'We\'ve tried to find some possible matches.'
            },
            react_default.a.createElement(SearchBox, {
              placeholder: 'Search by customer name, PO number, address, phone...',
              theme: relatedPhases_styles_default.a,
              value: _this.state.searchTerms,
              onSubmit: _this.onSearch
            })
          ),
          react_default.a.createElement(
            'div',
            { className: relatedPhases_styles_default.a.relatedPhasesSectionContainer },
            _this.renderPhaseList(phaseList)
          )
        );
      }
    }), _temp), phaseSearch__possibleConstructorReturn(_this, _ret);
  }

  return PhaseSearch;
}(react["Component"]);

phaseSearch_PhaseSearch.propTypes = {
  requestPhaseList: prop_types_default.a.func.isRequired,
  resetPhasePagination: prop_types_default.a.func.isRequired,
  role: prop_types_default.a.string.isRequired,
  position: prop_types_default.a.string.isRequired,
  loading: prop_types_default.a.bool,
  phases: prop_types_default.a.arrayOf(PhaseIndexType),
  phase: types_phase.isRequired,
  onLinkClick: prop_types_default.a.func,
  relatedPhaseIds: prop_types_default.a.arrayOf(prop_types_default.a.number)
};

phaseSearch_PhaseSearch.defaultProps = {
  relatedPhaseIds: [],
  role: '',
  position: '',
  loading: false,
  phases: [],
  phase: {}
};

/* harmony default export */ var phaseSearch = (Object(react_redux_es["connect"])(function (state) {
  return {
    phases: state.phases.results,
    searchFilter: state.phases.filters.data,
    loading: state.phases.common.loading,
    role: Object(reducers["_12" /* getRole */])(state),
    position: Object(reducers["_8" /* getPosition */])(state)
  };
}, { requestPhaseList: actionCreators["_18" /* requestPhaseList */], resetPhasePagination: actionCreators["_38" /* resetPhasePagination */] })(phaseSearch_PhaseSearch));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/relatedPhases/index.jsx
var relatedPhases__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function relatedPhases__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function relatedPhases__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function relatedPhases__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





















var RelatedPhaseSearch = Auth_visibleFor('update', 'related_phase', function (_ref) {
  var phase = _ref.phase,
      onLinkClick = _ref.onLinkClick,
      relatedPhaseIds = _ref.relatedPhaseIds;
  return react_default.a.createElement(
    'div',
    null,
    react_default.a.createElement('hr', { className: relatedPhases_styles_default.a.dividerLine }),
    react_default.a.createElement(phaseSearch, {
      phase: phase,
      onLinkClick: onLinkClick,
      relatedPhaseIds: relatedPhaseIds
    })
  );
});

var relatedPhases_RelatedPhases = function (_Component) {
  relatedPhases__inherits(RelatedPhases, _Component);

  function RelatedPhases(props) {
    relatedPhases__classCallCheck(this, RelatedPhases);

    var _this = relatedPhases__possibleConstructorReturn(this, (RelatedPhases.__proto__ || Object.getPrototypeOf(RelatedPhases)).call(this, props));

    Object.defineProperty(_this, 'componentWillMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.requestRelatedPhases(_this.props.phase.id);
      }
    });
    Object.defineProperty(_this, 'onLinkClick', {
      enumerable: true,
      writable: true,
      value: function value(relatedPhaseId) {
        return _this.props.createRelatedPhase(_this.props.phase.id, relatedPhaseId).then(function () {
          return _this.fetchDocsIfCv();
        });
      }
    });
    Object.defineProperty(_this, 'onUnlinkClick', {
      enumerable: true,
      writable: true,
      value: function value(relatedPhaseId) {
        return _this.props.removeRelatedPhase(_this.props.phase.id, relatedPhaseId).then(function () {
          return _this.fetchDocsIfCv();
        });
      }
    });
    Object.defineProperty(_this, 'onMergePhaseClick', {
      enumerable: true,
      writable: true,
      value: function value(relatedPhaseId) {
        return _this.props.createMergedPhases(_this.props.phase.id, relatedPhaseId).then(function () {
          return _this.fetchDocsIfCv();
        }).then(function () {
          return _this.handleMergeConfirm(false);
        }).then(function () {
          return window.location.reload();
        });
      }
    });
    Object.defineProperty(_this, 'handleMergeConfirm', {
      enumerable: true,
      writable: true,
      value: function value() {
        var show = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        return _this.setState({ showMergeConfirm: show });
      }
    });
    Object.defineProperty(_this, 'fetchDocsIfCv', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.cv ? _this.props.fetchPhaseDocuments(_this.props.phase.id) : null;
      }
    });
    Object.defineProperty(_this, 'renderRelatedPhases', {
      enumerable: true,
      writable: true,
      value: function value(relatedPhaseCards, loading) {
        if (loading) return react_default.a.createElement(components_Loading, null);else if (relatedPhaseCards.length === 0) {
          return react_default.a.createElement(
            'div',
            { className: relatedPhases_styles_default.a.emptyRelatedPhasesContainer },
            'No phase has been associated.'
          );
        }
        return relatedPhaseCards;
      }
    });

    _this.state = { showMergeConfirm: false };
    _this.handleMergeConfirm = _this.handleMergeConfirm.bind(_this);
    _this.onMergePhaseClick = _this.onMergePhaseClick.bind(_this);
    return _this;
  }

  relatedPhases__createClass(RelatedPhases, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          phase = _props.phase,
          loading = _props.loading,
          relatedPhases = _props.relatedPhases,
          errors = _props.errors,
          role = _props.role,
          position = _props.position;

      var relatedPhaseIds = [];
      var relatedPhaseCards = relatedPhases.map(function (relatedPhase) {
        relatedPhaseIds.push(relatedPhase.id);
        var actionButton = Object(services["a" /* can */])(role, 'relate', 'phase') ? { text: 'Unlink Phase', onClick: function onClick() {
            return _this2.onUnlinkClick(relatedPhase.id);
          } } : null;
        var actionButton2 = Object(services["a" /* can */])(role, 'relate', 'phase') ? { text: 'Merge Phase', onClick: function onClick() {
            return _this2.handleMergeConfirm();
          } } : null;
        return react_default.a.createElement(
          react["Fragment"],
          { key: 'relatedPhase-' + relatedPhase.id },
          react_default.a.createElement(components_phaseCard, {
            role: role,
            position: position,
            phase: relatedPhase,
            sourcePhase: phase,
            store: relatedPhase.store,
            surfaceType: relatedPhase.surface_type,
            actionButton: actionButton,
            actionButton2: actionButton2
          }),
          _this2.state.showMergeConfirm && react_default.a.createElement(ConfirmDialog["a" /* default */], {
            theActions: ['OK'],
            title: 'Confirm Merge Phase',
            confirmation: 'Once the phases have been merged, it cannot be undone. Is that okay?',
            dismiss: function dismiss() {
              return _this2.handleMergeConfirm(false);
            },
            proceed: function proceed() {
              return _this2.onMergePhaseClick(relatedPhase.id);
            }
          })
        );
      });
      return react_default.a.createElement(
        'div',
        null,
        react_default.a.createElement(
          components_Card,
          null,
          react_default.a.createElement(components_CardTitle, {
            title: 'Associated Phases',
            subtitle: 'Please select an assessment to link. This ensures that Contract Verification has access to the necessary documentation.'
          }),
          react_default.a.createElement(
            'div',
            { className: relatedPhases_styles_default.a.relatedPhasesSectionContainer },
            errors.length !== 0 && react_default.a.createElement(MessageBox["a" /* default */], { error: true, message: errors.join(', ') }),
            this.renderRelatedPhases(relatedPhaseCards, loading)
          ),
          react_default.a.createElement(RelatedPhaseSearch, {
            phase: phase,
            onLinkClick: this.onLinkClick,
            relatedPhaseIds: relatedPhaseIds
          })
        )
      );
    }
  }]);

  return RelatedPhases;
}(react["Component"]);

relatedPhases_RelatedPhases.defaultProps = { cv: false };

relatedPhases_RelatedPhases.propTypes = {
  requestRelatedPhases: prop_types_default.a.func.isRequired,
  createRelatedPhase: prop_types_default.a.func.isRequired,
  removeRelatedPhase: prop_types_default.a.func.isRequired,
  fetchPhaseDocuments: prop_types_default.a.func.isRequired,
  createMergedPhases: prop_types_default.a.func.isRequired,
  phase: types_phase.isRequired,
  relatedPhases: prop_types_default.a.arrayOf(types_phase),
  loading: prop_types_default.a.bool,
  errors: prop_types_default.a.array,
  role: prop_types_default.a.string,
  position: prop_types_default.a.string,
  cv: prop_types_default.a.bool
};

/* harmony default export */ var tabs_relatedPhases = (Object(react_redux_es["connect"])(function (state) {
  return {
    phase: state.phase.details,
    relatedPhases: state.phase.related.data,
    errors: state.phase.related.errors,
    loading: state.phase.related.loading,
    role: Object(reducers["_12" /* getRole */])(state),
    position: Object(reducers["_8" /* getPosition */])(state)
  };
}, {
  requestRelatedPhases: requestRelatedPhases,
  createRelatedPhase: createRelatedPhase,
  removeRelatedPhase: removeRelatedPhase,
  fetchPhaseDocuments: actionCreators["A" /* fetchPhaseDocuments */],
  createMergedPhases: createMergedPhases
})(relatedPhases_RelatedPhases));
// EXTERNAL MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseContractVerificationChecklist/styles.scss
var phaseContractVerificationChecklist_styles = __webpack_require__("5OXM");
var phaseContractVerificationChecklist_styles_default = /*#__PURE__*/__webpack_require__.n(phaseContractVerificationChecklist_styles);

// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseContractVerificationChecklist/components/assessmentLinkSuggestions.jsx





var STATE_CHIPS = {
  auto_applied: 'LINKED BY SPOTBOT',
  accepted: 'LINKED',
  edited: 'EDITED',
  rejected: 'DISMISSED'
};

var assessmentLinkSuggestions_percent = function percent(confidence) {
  return confidence ? Math.round(confidence * 100) + '%' : '—';
};

// M5: SPOTBOT's ranked Assessment-link candidates. Accepting links the phases server-side
// through the proposal endpoint (the pipeline's single write path) — no separate relate call.
var assessmentLinkSuggestions_AssessmentLinkSuggestions = function AssessmentLinkSuggestions(_ref) {
  var proposals = _ref.proposals,
      onResolve = _ref.onResolve;

  if (proposals.length === 0) return null;
  return react_default.a.createElement(
    'div',
    { className: phaseContractVerificationChecklist_styles_default.a.spotbotSuggestions },
    react_default.a.createElement(
      'h5',
      null,
      'SPOTBOT: Likely Matching Assessments'
    ),
    proposals.map(function (proposal) {
      return react_default.a.createElement(
        'div',
        { key: proposal.id, className: phaseContractVerificationChecklist_styles_default.a.suggestionRow },
        react_default.a.createElement(
          'div',
          { className: phaseContractVerificationChecklist_styles_default.a.suggestionInfo },
          react_default.a.createElement(
            'span',
            { className: phaseContractVerificationChecklist_styles_default.a.suggestionTitle },
            proposal.proposed_value.customer_name + ' \u2014 Project #',
            (proposal.proposed_value.project_number || 'unknown') + ' ',
            '(' + assessmentLinkSuggestions_percent(proposal.confidence) + ' match)'
          ),
          react_default.a.createElement(
            'span',
            { className: phaseContractVerificationChecklist_styles_default.a.suggestionReason },
            proposal.rationale
          )
        ),
        STATE_CHIPS[proposal.state] ? react_default.a.createElement(
          'span',
          { className: phaseContractVerificationChecklist_styles_default.a.appliedChip },
          STATE_CHIPS[proposal.state]
        ) : react_default.a.createElement(
          'div',
          { className: phaseContractVerificationChecklist_styles_default.a.suggestionActions },
          react_default.a.createElement(react_toolbox_lib["Button"], {
            label: 'Link', flat: true, inverse: true, ripple: true, className: phaseContractVerificationChecklist_styles_default.a.saveButton,
            onClick: function onClick() {
              return onResolve(proposal, 'accepted');
            }
          }),
          react_default.a.createElement(react_toolbox_lib["Button"], {
            label: 'Dismiss', flat: true, ripple: true,
            onClick: function onClick() {
              return onResolve(proposal, 'rejected');
            }
          })
        )
      );
    })
  );
};

assessmentLinkSuggestions_AssessmentLinkSuggestions.propTypes = {
  proposals: prop_types_default.a.arrayOf(prop_types_default.a.object).isRequired,
  onResolve: prop_types_default.a.func.isRequired
};

/* harmony default export */ var assessmentLinkSuggestions = (assessmentLinkSuggestions_AssessmentLinkSuggestions);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseContractVerificationChecklist/components/lineItemVerification.jsx






var lineItemVerification_STATE_CHIPS = {
  auto_applied: 'APPLIED BY SPOTBOT',
  accepted: 'APPLIED',
  edited: 'EDITED',
  rejected: 'DISMISSED'
};

var lineItemVerification_percent = function percent(confidence) {
  return confidence ? Math.round(confidence * 100) + '%' : '—';
};

var lineItemVerification_statusClass = function statusClass(status) {
  return status && status.indexOf('Error') === 0 ? phaseContractVerificationChecklist_styles_default.a.statusError : phaseContractVerificationChecklist_styles_default.a.statusCorrect;
};

// M4: SPOTBOT's proposed verification status per PO line item, with its reasoning. Safe
// statuses can arrive already auto-applied (auto_safe autonomy); every Error/Not Enough
// Information row waits for a human Accept, which writes through the normal line-item flow.
var lineItemVerification_LineItemVerification = function LineItemVerification(_ref) {
  var proposals = _ref.proposals,
      lineItems = _ref.lineItems,
      onResolve = _ref.onResolve;

  if (proposals.length === 0) return null;
  var itemFor = function itemFor(proposal) {
    return lineItems.find(function (item) {
      return item.id === proposal.target.phase_line_item_id;
    }) || {};
  };
  return react_default.a.createElement(
    components_Card,
    { className: phaseContractVerificationChecklist_styles_default.a.card },
    react_default.a.createElement(
      'div',
      { className: phaseContractVerificationChecklist_styles_default.a.headerContainer },
      react_default.a.createElement(
        'h4',
        { className: phaseContractVerificationChecklist_styles_default.a.title },
        'SPOTBOT Labor & Product Verification'
      )
    ),
    react_default.a.createElement(
      'div',
      { className: phaseContractVerificationChecklist_styles_default.a.checklistContainer },
      react_default.a.createElement(
        'p',
        null,
        'SPOTBOT compared each PO line item to the Detail. Accept writes the proposed status; Dismiss records that the proposal was wrong.'
      ),
      react_default.a.createElement(
        'table',
        { className: phaseContractVerificationChecklist_styles_default.a.verificationTable },
        react_default.a.createElement(
          'thead',
          null,
          react_default.a.createElement(
            'tr',
            null,
            react_default.a.createElement(
              'th',
              null,
              'Item'
            ),
            react_default.a.createElement(
              'th',
              null,
              'Qty'
            ),
            react_default.a.createElement(
              'th',
              null,
              'Current'
            ),
            react_default.a.createElement(
              'th',
              null,
              'Proposed'
            ),
            react_default.a.createElement(
              'th',
              null,
              'Confidence'
            ),
            react_default.a.createElement(
              'th',
              null,
              'Why'
            ),
            react_default.a.createElement('th', null)
          )
        ),
        react_default.a.createElement(
          'tbody',
          null,
          proposals.map(function (proposal) {
            var item = itemFor(proposal);
            return react_default.a.createElement(
              'tr',
              { key: proposal.id },
              react_default.a.createElement(
                'td',
                null,
                item.description
              ),
              react_default.a.createElement(
                'td',
                null,
                item.quantity
              ),
              react_default.a.createElement(
                'td',
                null,
                item.status
              ),
              react_default.a.createElement(
                'td',
                { className: lineItemVerification_statusClass(proposal.proposed_value) },
                proposal.proposed_value
              ),
              react_default.a.createElement(
                'td',
                null,
                lineItemVerification_percent(proposal.confidence)
              ),
              react_default.a.createElement(
                'td',
                { className: phaseContractVerificationChecklist_styles_default.a.suggestionReason },
                proposal.rationale
              ),
              react_default.a.createElement(
                'td',
                { className: phaseContractVerificationChecklist_styles_default.a.suggestionActions },
                lineItemVerification_STATE_CHIPS[proposal.state] ? react_default.a.createElement(
                  'span',
                  { className: phaseContractVerificationChecklist_styles_default.a.appliedChip },
                  lineItemVerification_STATE_CHIPS[proposal.state]
                ) : react_default.a.createElement(
                  'span',
                  null,
                  react_default.a.createElement(react_toolbox_lib["Button"], {
                    label: 'Accept', flat: true, inverse: true, ripple: true, className: phaseContractVerificationChecklist_styles_default.a.saveButton,
                    onClick: function onClick() {
                      return onResolve(proposal, 'accepted');
                    }
                  }),
                  react_default.a.createElement(react_toolbox_lib["Button"], {
                    label: 'Dismiss', flat: true, ripple: true,
                    onClick: function onClick() {
                      return onResolve(proposal, 'rejected');
                    }
                  })
                )
              )
            );
          })
        )
      )
    )
  );
};

lineItemVerification_LineItemVerification.propTypes = {
  proposals: prop_types_default.a.arrayOf(prop_types_default.a.object).isRequired,
  lineItems: prop_types_default.a.arrayOf(prop_types_default.a.object).isRequired,
  onResolve: prop_types_default.a.func.isRequired
};

/* harmony default export */ var lineItemVerification = (lineItemVerification_LineItemVerification);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseContractVerificationChecklist/index.jsx
var phaseContractVerificationChecklist__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function phaseContractVerificationChecklist__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function phaseContractVerificationChecklist__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function phaseContractVerificationChecklist__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function phaseContractVerificationChecklist__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




































var phaseContractVerificationChecklist_largeInput = classnames_default()(form_default.a.inputs, form_default.a.largeInput);
var phaseContractVerificationChecklist_smallInput = classnames_default()(form_default.a.inputs, form_default.a.smallInput);

// Maps CV extraction site-question keys (see BuildProposals) to this component's state keys.
var SITE_QUESTION_STATE_KEYS = {
  new_construction: 'newConstruction',
  paved_driveway: 'pavedDriveway',
  difficult_access: 'difficultAccess',
  restricted_parking: 'restrictedParking',
  elevator_available: 'elevatorAvailable',
  floor_or_baseboard_heating: 'floorBaseHeating',
  freshly_painted_walls: 'freshPaintWalls',
  pets_onsite: 'petsPresent',
  place_to_cut_materials: 'cuttingArea',
  building_type: 'buildingType',
  installer_supplies_transitions: 'rolledGoodsTransitions',
  pickup_required: 'pickup',
  gas_appliances: 'gasAppliances'
};
var SITE_QUESTION_LABELS = {
  new_construction: 'New Construction',
  paved_driveway: 'Paved Driveway',
  difficult_access: 'Difficult Access',
  restricted_parking: 'Restricted Parking',
  elevator_available: 'Elevator Available',
  floor_or_baseboard_heating: 'Floor/Baseboard Heating',
  freshly_painted_walls: 'Freshly Painted Walls',
  pets_onsite: 'Pets Present',
  place_to_cut_materials: 'Place to Cut Materials',
  building_type: 'Building Type',
  installer_supplies_transitions: 'Installer Supplies Transitions',
  pickup_required: 'Pick Up Required',
  gas_appliances: 'Gas Appliances'
};
var PHASE_INFO_LABELS = {
  net_square_footage: 'Net Square Feet',
  year_built: 'Year Built'
};

var phaseContractVerificationChecklist_ContractVerificationChecklist = function (_React$Component) {
  phaseContractVerificationChecklist__inherits(ContractVerificationChecklist, _React$Component);

  function ContractVerificationChecklist(props) {
    phaseContractVerificationChecklist__classCallCheck(this, ContractVerificationChecklist);

    var _this = phaseContractVerificationChecklist__possibleConstructorReturn(this, (ContractVerificationChecklist.__proto__ || Object.getPrototypeOf(ContractVerificationChecklist)).call(this, props));

    phaseContractVerificationChecklist__initialiseProps.call(_this);

    var _this$props = _this.props,
        _this$props$phase = _this$props.phase,
        phase = _this$props$phase === undefined ? {} : _this$props$phase,
        anchoredRemoval = _this$props.anchoredRemoval;

    var phaseClone = Object(lodash["cloneDeep"])(phase);
    if (anchoredRemoval && Object.keys(phaseClone).length > 0) {
      constants["h" /* ANCHORED_REMOVAL_SLUGS */].forEach(function (s) {
        phaseClone.phase_specific[s] = false;
      });
    }
    _this.state = {
      phase: phaseClone,
      newPhaseInfo: false,
      newConstruction: '',
      pavedDriveway: '',
      difficultAccess: '',
      restrictedParking: '',
      elevatorAvailable: '',
      floorBaseHeating: '',
      freshPaintWalls: '',
      petsPresent: '',
      cuttingArea: '',
      rapidSetMortar: '',
      woodSubfloor: '',
      hardyBackerMortar: '',
      rolledGoodsTransitions: '',
      pickup: '',
      gasAppliances: '',
      buildingType: '',
      installerNote: '',
      customerNote: '',
      readyToSubmit: false,
      expressInstallation: '',
      confirmedAnchorRemovals: [],
      ifiDoneStatus: '',
      prefilled: {},
      cvProposals: []
    };
    return _this;
  }

  // M3 prefill: seed untouched checklist fields from SPOTBOT extraction proposals. Only fills
  // blanks (never overwrites SPIG/scraped values) and records provenance for the banner/tags.


  // Accept applies the proposal server-side (line-item write / phase link) through the
  // pipeline's single write path; afterwards refresh whichever list the write changed.


  return ContractVerificationChecklist;
}(react_default.a.Component);

var phaseContractVerificationChecklist__initialiseProps = function _initialiseProps() {
  var _this2 = this;

  Object.defineProperty(this, 'componentWillMount', {
    enumerable: true,
    writable: true,
    value: function value() {
      _this2.requestRequiredLists();
      _this2.props.fetchCvProposals(_this2.props.phase.id).then(function (proposals) {
        _this2.setState({ cvProposals: proposals });
        _this2.applyPrefill(proposals);
      }).catch(function () {});
    }
  });
  Object.defineProperty(this, 'componentWillUpdate', {
    enumerable: true,
    writable: true,
    value: function value(nextProps) {
      var nextDocs = nextProps.documents.data,
          nextMerch = nextProps.lineItemsWarehouseMerchandise,
          nextPads = nextProps.lineItemsWarehousePads;
      var _props = _this2.props,
          currDocs = _props.documents.data,
          currMerch = _props.lineItemsWarehouseMerchandise,
          currPads = _props.lineItemsWarehousePads;

      if (nextDocs.length > 0 && nextDocs.length !== currDocs.length || nextMerch.length > 0 && nextMerch.length !== currMerch.length || nextPads.length > 0 && nextPads.length !== currPads.length) {
        _this2.requestRequiredLists();
      }
    }
  });
  Object.defineProperty(this, 'requestRequiredLists', {
    enumerable: true,
    writable: true,
    value: function value() {
      _this2.props.fetchPhaseDocuments(_this2.props.phase.id);
      _this2.props.requestPhaseItems(_this2.props.phase.id, 'phaseLineItems');
      _this2.props.requestPhaseItems(_this2.props.phase.id, 'warehouseMerchandiseItems');
      _this2.setState({ pads: _this2.parsePads(_this2.props.lineItemsWarehousePads) });
    }
  });
  Object.defineProperty(this, 'nothingToSubmit', {
    enumerable: true,
    writable: true,
    value: function value() {
      return !_this2.state.newPhaseInfo;
    }
  });
  Object.defineProperty(this, 'handlePhaseBasic', {
    enumerable: true,
    writable: true,
    value: function value(key, val) {
      var phase = _this2.state.phase;

      phase[key] = val;
      _this2.setState({ phase: phase, newPhaseInfo: true });
    }
  });
  Object.defineProperty(this, 'handlePhaseSpecific', {
    enumerable: true,
    writable: true,
    value: function value(key, val) {
      var _state = _this2.state,
          phase = _state.phase,
          confirmedAnchorRemovals = _state.confirmedAnchorRemovals;

      var changedAnchoredRemoval = constants["h" /* ANCHORED_REMOVAL_SLUGS */].includes(key);
      var editedPhase = Object(lodash["cloneDeep"])(phase);
      var editedRemovals = Object(lodash["clone"])(confirmedAnchorRemovals);
      editedPhase.phase_specific[key] = val;
      if (val && key === 'need_move_furniture_oversized') editedPhase.phase_specific.need_move_furniture = true;else if (changedAnchoredRemoval) {
        if (val && !editedRemovals.includes(key)) editedRemovals.push(key);else if (!val && editedRemovals.includes(key)) {
          editedRemovals = editedRemovals.filter(function (item) {
            return item !== key;
          });
        }
      }
      var updatedState = { phase: editedPhase, newPhaseInfo: true };
      if (!Object(lodash["isEqual"])(editedRemovals, confirmedAnchorRemovals)) {
        updatedState.confirmedAnchorRemovals = editedRemovals;
      }
      _this2.setState(updatedState);
    }
  });
  Object.defineProperty(this, 'handleMillworkSpecific', {
    enumerable: true,
    writable: true,
    value: function value(key, val) {
      var phase = _this2.state.phase;

      var editedPhase = Object(lodash["cloneDeep"])(phase);
      editedPhase.phase_specific.millwork_specifics = phaseContractVerificationChecklist__extends({}, editedPhase.phase_specific.millwork_specifics, phaseContractVerificationChecklist__defineProperty({}, key, val));
      _this2.setState({ phase: editedPhase, newPhaseInfo: true });
    }
  });
  Object.defineProperty(this, 'handleVal', {
    enumerable: true,
    writable: true,
    value: function value(key, val) {
      return _this2.setState(phaseContractVerificationChecklist__defineProperty({}, key, val));
    }
  });
  Object.defineProperty(this, 'handleInstallerNote', {
    enumerable: true,
    writable: true,
    value: function value(e) {
      return _this2.handleVal('installerNote', e.target.value);
    }
  });
  Object.defineProperty(this, 'handleCustomerNote', {
    enumerable: true,
    writable: true,
    value: function value(e) {
      return _this2.handleVal('customerNote', e.target.value);
    }
  });
  Object.defineProperty(this, 'handleReadyToSubmit', {
    enumerable: true,
    writable: true,
    value: function value(val) {
      return _this2.setState({ readyToSubmit: val === 'Yes' });
    }
  });
  Object.defineProperty(this, 'applyPrefill', {
    enumerable: true,
    writable: true,
    value: function value(proposals) {
      if (!proposals || proposals.length === 0) return;
      var prefilled = {};
      var updates = {};
      var phase = Object(lodash["cloneDeep"])(_this2.state.phase);
      var touchedPhase = false;
      proposals.forEach(function (proposal) {
        var value = proposal.proposed_value;
        if (proposal.kind === 'site_question') {
          var stateKey = SITE_QUESTION_STATE_KEYS[proposal.target.key];
          if (!stateKey || _this2.state[stateKey] !== '') return;
          updates[stateKey] = _this2.prefillDisplayValue(value);
          prefilled[stateKey] = _this2.provenance(SITE_QUESTION_LABELS[proposal.target.key], proposal);
        } else if (proposal.kind === 'note' && proposal.target.field === 'customer_responsibilities') {
          if (_this2.state.customerNote !== '') return;
          updates.customerNote = value;
          prefilled.customerNote = _this2.provenance('Customer Responsibilities', proposal);
        } else if (proposal.kind === 'phase_info') {
          var field = proposal.target.field;
          if (phase[field]) return;
          phase[field] = value;
          touchedPhase = true;
          prefilled[field] = _this2.provenance(PHASE_INFO_LABELS[field], proposal);
        }
      });
      if (Object.keys(prefilled).length === 0) return;
      if (touchedPhase) {
        updates.phase = phase;updates.newPhaseInfo = true;
      }
      updates.prefilled = phaseContractVerificationChecklist__extends({}, _this2.state.prefilled, prefilled);
      _this2.setState(updates);
    }
  });
  Object.defineProperty(this, 'provenance', {
    enumerable: true,
    writable: true,
    value: function value(label, proposal) {
      return { label: label, confidence: proposal.confidence };
    }
  });
  Object.defineProperty(this, 'prefillDisplayValue', {
    enumerable: true,
    writable: true,
    value: function value(_value) {
      if (_value === true) return 'Yes';
      if (_value === false) return 'No';
      return _value;
    }
  });
  Object.defineProperty(this, 'prefillTag', {
    enumerable: true,
    writable: true,
    value: function value(field) {
      var entry = _this2.state.prefilled[field];
      if (!entry) return null;
      var pct = entry.confidence ? ' ' + Math.round(entry.confidence * 100) + '%' : '';
      return react_default.a.createElement(
        'span',
        { className: phaseContractVerificationChecklist_styles_default.a.prefillTag },
        'SPOTBOT prefilled' + pct
      );
    }
  });
  Object.defineProperty(this, 'prefillBanner', {
    enumerable: true,
    writable: true,
    value: function value() {
      var keys = Object.keys(_this2.state.prefilled);
      if (keys.length === 0) return null;
      var names = keys.map(function (key) {
        var _state$prefilled$key = _this2.state.prefilled[key],
            label = _state$prefilled$key.label,
            confidence = _state$prefilled$key.confidence;

        return confidence ? label + ' (' + Math.round(confidence * 100) + '%)' : label;
      });
      return react_default.a.createElement(
        'div',
        { className: phaseContractVerificationChecklist_styles_default.a.prefillBanner },
        react_default.a.createElement(
          'strong',
          null,
          'SPOTBOT pre-filled ' + keys.length + ' field(s) from the Detail. '
        ),
        'Review before submitting: ' + names.join(', ') + '.'
      );
    }
  });
  Object.defineProperty(this, 'proposalsOfKind', {
    enumerable: true,
    writable: true,
    value: function value(kind) {
      return _this2.state.cvProposals.filter(function (p) {
        return p.kind === kind;
      });
    }
  });
  Object.defineProperty(this, 'handleResolveProposal', {
    enumerable: true,
    writable: true,
    value: function value(proposal, resolution) {
      _this2.props.resolveCvProposal(_this2.props.phase.id, proposal.id, resolution).then(function (resolved) {
        if (!resolved) return;
        _this2.setState({
          cvProposals: _this2.state.cvProposals.map(function (existing) {
            return existing.id === resolved.id ? resolved : existing;
          })
        });
        if (resolution !== 'accepted') return;
        if (proposal.kind === 'line_item_status') {
          _this2.props.requestPhaseItems(_this2.props.phase.id, 'phaseLineItems');
        }
        if (proposal.kind === 'assessment_link') _this2.requestRequiredLists();
      });
    }
  });
  Object.defineProperty(this, 'completeCvChecklist', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _state2 = _this2.state,
          phase = _state2.phase,
          _state2$phase = _state2.phase,
          id = _state2$phase.id,
          phase_specific = _state2$phase.phase_specific,
          expressInstallation = _state2.expressInstallation;

      var note = _this2.contractorNotes();
      phase.contractor_notes = note;
      if (phase.date_sold || '') delete phase.date_sold;
      var expressInstallBool = expressInstallation === 'Yes' ? 'true' : 'false';
      _this2.props.updatePhase(phaseContractVerificationChecklist__extends({}, phase, { phase_specific_attributes: phase_specific }), {}).then(function () {
        return _this2.props.updatePhaseTask(id, 'cv_checklist', {
          task: { status: 'complete' },
          event: { data: {} },
          phase: { status: 'waiting_for_product' },
          express_installation: expressInstallBool
        });
      }).then(function () {
        return _this2.props.navigate(urls.phaseHistory(phase));
      }).catch(function () {});
    }
  });
  Object.defineProperty(this, 'parsePads', {
    enumerable: true,
    writable: true,
    value: function value(lineItemsPad) {
      return lineItemsPad.map(function (lineItem) {
        return {
          cut_quantity: Object(lineItemUtils["d" /* cutQuantityString */])(lineItem.warehouse_quantity),
          description: lineItem.description
        };
      });
    }
  });
  Object.defineProperty(this, 'fieldNeeded', {
    enumerable: true,
    writable: true,
    value: function value(field) {
      var _state3 = _this2.state,
          _state3$phase = _state3.phase,
          surface_type = _state3$phase.surface_type,
          net_square_footage = _state3$phase.net_square_footage,
          woodSubfloor = _state3.woodSubfloor;

      switch (field) {
        case 'rapidSetMortar':
          return surface_type.name === 'Tile';
        case 'woodSubfloor':
          return surface_type.name !== 'Carpet' && (!net_square_footage || net_square_footage < 150);
        case 'hardyBackerMortar':
          return surface_type.name === 'Tile' && woodSubfloor === 'Yes';
        default:
          return true;
      }
    }
  });
  Object.defineProperty(this, 'requiredFieldsMissing', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _props2 = _this2.props,
          _props2$phase = _props2.phase,
          product_type = _props2$phase.product_type,
          name = _props2$phase.surface_type.name,
          anchoredRemoval = _props2.anchoredRemoval;

      var warning = '';
      // If product type is "STK" create a new object because-
      // another property is needed for validation
      var requiredFieldsObj = product_type === 'STK' ? Object.assign({}, constants["_26" /* REQUIRED_CV_FIELDS */]) : constants["_26" /* REQUIRED_CV_FIELDS */];
      if (product_type === 'STK' && name === 'Carpet') requiredFieldsObj.expressInstallation = 'Express Installation';
      var requiredFieldsKeys = Object.keys(requiredFieldsObj);
      requiredFieldsKeys.forEach(function (f) {
        if (_this2.fieldNeeded(f) && !_this2.state[f]) {
          warning += warning ? ', ' + requiredFieldsObj[f] : 'Please input a(n) ' + requiredFieldsObj[f];
        }
      });
      if (anchoredRemoval && _this2.state.confirmedAnchorRemovals < 1) {
        warning += warning ? ', Hardwood Removal Type' : 'Please select an Hardwood Removal Type';
      }
      return warning;
    }
  });
  Object.defineProperty(this, 'requiredFieldsMissingIfi', {
    enumerable: true,
    writable: true,
    value: function value() {
      var warning = '';
      Object.keys(constants["_27" /* REQUIRED_CV_FIELDS_IFI */]).forEach(function (f) {
        if (!_this2.state[f]) {
          warning += warning ? ', ' + constants["_27" /* REQUIRED_CV_FIELDS_IFI */][f] : 'Please input a(n) ' + constants["_27" /* REQUIRED_CV_FIELDS_IFI */][f];
        }
      });
      return warning;
    }
  });
  Object.defineProperty(this, 'note', {
    enumerable: true,
    writable: true,
    value: function value(val) {
      return val || 'N/A';
    }
  });
  Object.defineProperty(this, 'gasAppliancesNote', {
    enumerable: true,
    writable: true,
    value: function value() {
      return _this2.state.gasAppliances === 'Yes' ? ' - gas appliances on worksite' : '';
    }
  });
  Object.defineProperty(this, 'contractorNotes', {
    enumerable: true,
    writable: true,
    value: function value() {
      var vendor = Object(utils["E" /* vendorDisplayName */])(_this2.state.phase.source, _this2.state.phase.workroom.name);
      return (_this2.props.phase.contractor_notes || '') + '\n\n-->> INSTALLER NOTES: ' + _this2.note(_this2.state.installerNote) + ' <<--\n\n-->> CUSTOMER RESPONSIBILITIES: ' + (_this2.note(_this2.state.customerNote) + _this2.gasAppliancesNote()) + ' <<--\n\n-->> NEW CONSTRUCTION: ' + _this2.note(_this2.state.newConstruction) + ' <<--\n\n-->> PAVED DRIVEWAY: ' + _this2.note(_this2.state.pavedDriveway) + ' <<--\n\n-->> DIFFICULT ACCESS: ' + _this2.note(_this2.state.difficultAccess) + ' <<--\n\n-->> RESTRICTED PARKING ACCESS: ' + _this2.note(_this2.state.restrictedParking) + ' <<--\n\n-->> ELEVATOR AVAILABLE: ' + _this2.note(_this2.state.elevatorAvailable) + ' <<--\n\n-->> FLOOR/BASEBOARD HEATING PRESENT: ' + _this2.note(_this2.state.floorBaseHeating) + ' <<--\n\n-->> FRESHLY PAINTED WALLS: ' + _this2.note(_this2.state.freshPaintWalls) + ' <<--\n\n-->> PETS AT THE SITE: ' + _this2.note(_this2.state.petsPresent) + ' <<--\n\n-->> PLACE TO CUT MATERIALS: ' + _this2.note(_this2.state.cuttingArea) + ' <<--\n\n-->> BUILDING TYPE: ' + _this2.note(_this2.state.buildingType) + ' <<--\n\n-->> SUPPLYING TRANSITIONS FOR ROLLED GOODS: ' + _this2.note(_this2.state.rolledGoodsTransitions) + ' <<--\n\n-->> PICKUP REQUIRED: ' + _this2.note(_this2.state.pickup) + ' <<--\n\n-->> RAPID SETTING MORTAR: ' + _this2.note(_this2.state.rapidSetMortar) + ' <<--\n\n-->> WOOD SUBFLOOR: ' + _this2.note(_this2.state.woodSubfloor) + ' <<--\n\n-->> HARDY BACKER + MORTAR: ' + _this2.note(_this2.state.hardyBackerMortar) + ' <<--\n********\nAll sub contractors should have the following items:\n' + (vendor === 'Lowe\'s' ? '--Lowe\'s T shirt\n--Lowe\'s Badge\n--Lowe\'s Installation yard sign' : '') + '\n--Oil Shield for Drive Way parking\n--Tarp for protecting customers property\n--A smile\nTodos los subcontratistas deben tener los siguientes elementos:\n' + (vendor === 'Lowe\'s' ? '--Camiseta Lowe\'s\n--Insignia de Lowe\'s\n--Lowe\'s Signo de patio de instalaci\xF3n' : '') + '\n--Escudo de aceite para estacionamiento de garaje\n--Lona para proteger propiedad de los clientes\n--Una sonrisa\n********';
    }
  });
  Object.defineProperty(this, 'buttons', {
    enumerable: true,
    writable: true,
    value: function value() {
      var isReadyToSubmitRadio = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return [{ label: 'YES', value: 'Yes' }, { label: 'NO', value: 'No' }].concat(isReadyToSubmitRadio ? [] : { label: 'N/A', value: 'N/A' });
    }
  });
  Object.defineProperty(this, 'buildingTypeOptions', {
    enumerable: true,
    writable: true,
    value: function value() {
      return [{ label: 'Residential', value: 'Residential' }, { label: 'Commercial', value: 'Commercial' }, { label: 'Mobile Home', value: 'Mobile Home' }];
    }
  });
  Object.defineProperty(this, 'completeCvChecklistIfi', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _state4 = _this2.state,
          phase = _state4.phase,
          _state4$phase = _state4.phase,
          id = _state4$phase.id,
          phase_specific = _state4$phase.phase_specific;

      var note = _this2.contractorNotesIfi();
      phase.contractor_notes = note;
      if (phase.date_sold || '') delete phase.date_sold;
      _this2.props.updatePhase(phaseContractVerificationChecklist__extends({}, phase, { phase_specific_attributes: phase_specific }), {}).then(function () {
        return _this2.props.updatePhaseTask(id, 'cv_checklist', {
          task: { status: 'complete' },
          event: { data: {} },
          phase: { status: _this2.state.ifiDoneStatus }
        });
      }).then(function () {
        return _this2.props.navigate(urls.phaseHistory(phase));
      }).catch(function () {});
    }
  });
  Object.defineProperty(this, 'contractorNotesIfi', {
    enumerable: true,
    writable: true,
    value: function value() {
      return (_this2.props.phase.contractor_notes || '') + '\n\n-->> INSTALLER NOTES: ' + _this2.note(_this2.state.installerNote) + ' <<--\n\n-->> CUSTOMER RESPONSIBILITIES: ' + _this2.note(_this2.state.customerNote) + ' <<--\n\n-->> DIFFICULT ACCESS: ' + _this2.note(_this2.state.difficultAccess) + ' <<--\n\n-->> RESTRICTED PARKING ACCESS: ' + _this2.note(_this2.state.restrictedParking) + ' <<--\n\n-->> ELEVATOR AVAILABLE: ' + _this2.note(_this2.state.elevatorAvailable) + ' <<--\n\n-->> BUILDING TYPE: ' + _this2.note(_this2.state.buildingType) + ' <<--\n\n-->> PICKUP REQUIRED: ' + _this2.note(_this2.state.pickup) + ' <<--';
    }
  });
  Object.defineProperty(this, 'renderIfi', {
    enumerable: true,
    writable: true,
    value: function value() {
      return react_default.a.createElement(
        'div',
        null,
        react_default.a.createElement(
          components_Card,
          { className: phaseContractVerificationChecklist_styles_default.a.card },
          react_default.a.createElement(
            'div',
            { className: phaseContractVerificationChecklist_styles_default.a.headerContainer },
            react_default.a.createElement(
              'h4',
              { className: phaseContractVerificationChecklist_styles_default.a.title },
              'Getting Started'
            )
          ),
          react_default.a.createElement(
            'div',
            { className: phaseContractVerificationChecklist_styles_default.a.checklistContainer },
            react_default.a.createElement(
              'h5',
              null,
              'Linking The Assessment Phase To The Installation Phase'
            ),
            react_default.a.createElement('br', null),
            react_default.a.createElement(
              'ul',
              { className: phaseContractVerificationChecklist_styles_default.a.scriptList },
              react_default.a.createElement(
                'li',
                null,
                'Linking the phases will pull all Assessment and Refigure documents into the Installation Phase'
              )
            ),
            react_default.a.createElement('br', null),
            react_default.a.createElement(tabs_relatedPhases, { cv: true }),
            react_default.a.createElement('br', null),
            react_default.a.createElement(
              'h5',
              null,
              'Selecting/Verifying The Matching Assessment Document'
            ),
            react_default.a.createElement('br', null),
            react_default.a.createElement(
              'ul',
              { className: phaseContractVerificationChecklist_styles_default.a.scriptList },
              react_default.a.createElement(
                'li',
                null,
                'Select appropriate assessment from the dropdown below (If the correct one is not there, upload it in the Upload box below, under',
                '\'Assessment/Refigure\'',
                ')'
              ),
              react_default.a.createElement(
                'li',
                null,
                'Click the green button to open the doc in a new window to visually confirm information on the assessment'
              ),
              react_default.a.createElement(
                'li',
                null,
                'KEEP THE ASSESSMENT OPEN FOR THE DURATION OF THIS CHECKLIST - it is needed as a reference'
              )
            ),
            react_default.a.createElement('br', null),
            react_default.a.createElement(components_assessmentSelection, { cv: true, parentDocs: _this2.props.documents.data }),
            react_default.a.createElement(assessmentLinkSuggestions, {
              proposals: _this2.proposalsOfKind('assessment_link'),
              onResolve: _this2.handleResolveProposal
            })
          )
        ),
        react_default.a.createElement(
          components_Card,
          { className: phaseContractVerificationChecklist_styles_default.a.card },
          react_default.a.createElement(
            'div',
            { className: phaseContractVerificationChecklist_styles_default.a.headerContainer },
            react_default.a.createElement(
              'h4',
              { className: phaseContractVerificationChecklist_styles_default.a.title },
              'Verifying Product/Labor'
            )
          ),
          react_default.a.createElement(
            'div',
            { className: phaseContractVerificationChecklist_styles_default.a.checklistContainer },
            react_default.a.createElement(
              'h5',
              null,
              'Verifying Product'
            ),
            react_default.a.createElement('br', null),
            react_default.a.createElement(
              'ul',
              { className: phaseContractVerificationChecklist_styles_default.a.scriptList },
              react_default.a.createElement(
                'li',
                null,
                'Cross-check that all materials listed in the Detail Sheet are listed on the contract and sold in the correct quantities.'
              ),
              react_default.a.createElement(
                'li',
                null,
                'Compare the measurements on the Detail Sheet to what was sold on the ',
                '\'Extended Order Details\'',
                '.'
              ),
              react_default.a.createElement(
                'li',
                null,
                'Confirm that the door/window sizes match exactly.'
              ),
              react_default.a.createElement(
                'li',
                null,
                'If measurements do not match, submit a Support Request to resolve the issue.'
              )
            ),
            react_default.a.createElement('br', null),
            react_default.a.createElement(purchaseOrderTable, {
              cv: true, phaseId: _this2.state.phase.id, documents: _this2.props.documents.data
            }),
            react_default.a.createElement('br', null),
            react_default.a.createElement(phaseMerchandiseItemTable, {
              phaseId: _this2.state.phase.id, phaseSource: _this2.state.phase.source, cv: true
            }),
            react_default.a.createElement('br', null),
            react_default.a.createElement(
              'h5',
              null,
              'Identifying/Inputting Custom Labor'
            ),
            react_default.a.createElement('br', null),
            react_default.a.createElement(
              'ul',
              { className: phaseContractVerificationChecklist_styles_default.a.scriptList },
              react_default.a.createElement(
                'li',
                null,
                'The layout of assessment/refigure docs may vary, so finding custom labor may vary from document to document'
              ),
              react_default.a.createElement(
                'li',
                null,
                'Utilize your computer',
                '\'',
                's built-in search function (CTRL+f) to search for key words such as: ',
                '\'Custom\'',
                ', ',
                '\'Additional\'',
                ', ',
                '\'Additional Custom\'',
                ',',
                '\'Custom Labor\'',
                ', etc. (these are not the only things you can search)'
              ),
              react_default.a.createElement(
                'li',
                null,
                'If the document has a ',
                '\'Service Items\'',
                ' Section, if a item in that has ',
                '\'Custom\'',
                ' in the ',
                '\'Item Number\'',
                ' column, it is a custom labor'
              ),
              react_default.a.createElement(
                'li',
                null,
                'If the document has a table that starts on the first or second page and has a column titled ',
                '\'LN\'',
                ', in that table look for any Labor described as custom, and there is also a specific row called',
                '\'Additional Custom Work\'',
                ' (it',
                '\'',
                's usually ',
                '\'LN 57\'',
                ')'
              ),
              react_default.a.createElement(
                'li',
                null,
                'Input custom labor in the PO table below (where applicable)'
              )
            ),
            react_default.a.createElement('br', null),
            react_default.a.createElement(phaseLineItemTables, { cv: true, phaseId: _this2.state.phase.id })
          )
        ),
        react_default.a.createElement(lineItemVerification, {
          proposals: _this2.proposalsOfKind('line_item_status'),
          lineItems: _this2.props.phaseLineItems,
          onResolve: _this2.handleResolveProposal
        }),
        react_default.a.createElement(
          components_Card,
          { className: phaseContractVerificationChecklist_styles_default.a.card },
          react_default.a.createElement(
            'div',
            { className: phaseContractVerificationChecklist_styles_default.a.headerContainer },
            react_default.a.createElement(
              'h4',
              { className: phaseContractVerificationChecklist_styles_default.a.title },
              'Input Phase Info'
            )
          ),
          react_default.a.createElement(
            'div',
            { className: phaseContractVerificationChecklist_styles_default.a.checklistContainer },
            react_default.a.createElement(react_toolbox_lib["Input"], {
              label: 'Number of Doors',
              className: phaseContractVerificationChecklist_largeInput,
              value: _this2.state.phase.phase_specific.millwork_specifics ? _this2.state.phase.phase_specific.millwork_specifics.num_doors || '' : '',
              onChange: function onChange(val) {
                return _this2.handleMillworkSpecific('num_doors', val);
              }
            }),
            react_default.a.createElement(react_toolbox_lib["Input"], {
              label: 'Number of Windows',
              className: phaseContractVerificationChecklist_largeInput,
              value: _this2.state.phase.phase_specific.millwork_specifics ? _this2.state.phase.phase_specific.millwork_specifics.num_windows || '' : '',
              onChange: function onChange(val) {
                return _this2.handleMillworkSpecific('num_windows', val);
              }
            }),
            react_default.a.createElement(react_toolbox_lib["Input"], {
              label: 'Year Built',
              className: phaseContractVerificationChecklist_smallInput,
              value: _this2.state.phase.year_built || '',
              onChange: function onChange(val) {
                return _this2.handlePhaseBasic('year_built', val);
              },
              error: Object(utils["c" /* error */])('year_built', _this2.props.errors)
            }),
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              name: 'hasPower',
              label: 'Has Power',
              onChange: function onChange(val) {
                return _this2.handlePhaseSpecific('customer_has_power', val);
              },
              checked: _this2.state.phase.phase_specific.customer_has_power
            }),
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              name: 'hasClimateControl',
              label: 'Has Climate Control',
              onChange: function onChange(val) {
                return _this2.handlePhaseSpecific('customer_has_climate_control', val);
              },
              checked: _this2.state.phase.phase_specific.customer_has_climate_control
            }),
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              name: 'permitRequired',
              label: 'Permit Required',
              onChange: function onChange(val) {
                return _this2.handleMillworkSpecific('permit_required', val);
              },
              checked: !!(_this2.state.phase.phase_specific.millwork_specifics && _this2.state.phase.phase_specific.millwork_specifics.permit_required)
            })
          )
        ),
        react_default.a.createElement(
          components_Card,
          { className: phaseContractVerificationChecklist_styles_default.a.card },
          react_default.a.createElement(
            'div',
            { className: phaseContractVerificationChecklist_styles_default.a.headerContainer },
            react_default.a.createElement(
              'h4',
              { className: phaseContractVerificationChecklist_styles_default.a.title },
              'Input Contractor Note Info'
            )
          ),
          react_default.a.createElement(
            'div',
            { className: phaseContractVerificationChecklist_styles_default.a.checklistContainer },
            react_default.a.createElement(components_RadioButtons, {
              label: 'Difficult Access?',
              onChange: function onChange(val) {
                return _this2.handleVal('difficultAccess', val);
              },
              selectedValue: _this2.state.difficultAccess,
              radioButtons: _this2.buttons()
            }),
            react_default.a.createElement(components_RadioButtons, {
              label: 'Restricted Parking Access?',
              onChange: function onChange(val) {
                return _this2.handleVal('restrictedParking', val);
              },
              selectedValue: _this2.state.restrictedParking,
              radioButtons: _this2.buttons()
            }),
            react_default.a.createElement(components_RadioButtons, {
              label: 'If Multi-Family Unit, Is Elevator Available?',
              onChange: function onChange(val) {
                return _this2.handleVal('elevatorAvailable', val);
              },
              selectedValue: _this2.state.elevatorAvailable,
              radioButtons: _this2.buttons()
            }),
            react_default.a.createElement('br', null),
            react_default.a.createElement(components_StyledSelect, {
              className: phaseContractVerificationChecklist_largeInput,
              label: 'Building Type',
              onChange: function onChange(val) {
                return _this2.handleVal('buildingType', val);
              },
              options: _this2.buildingTypeOptions(),
              value: _this2.state.buildingType || '',
              placeholder: 'Select Building Type'
            }),
            react_default.a.createElement(components_RadioButtons, {
              label: 'Pickup Required?',
              onChange: function onChange(val) {
                return _this2.handleVal('pickup', val);
              },
              selectedValue: _this2.state.pickup,
              radioButtons: _this2.buttons()
            }),
            react_default.a.createElement(components_SimpleInput, {
              label: 'Installer Note',
              text: _this2.state.installerNote,
              errors: _this2.props.errors.installerNote,
              onChange: _this2.handleInstallerNote
            }),
            react_default.a.createElement(components_SimpleInput, {
              label: 'Customer Responsibilities',
              text: _this2.state.customerNote,
              errors: _this2.props.errors.customerNote,
              onChange: _this2.handleCustomerNote
            })
          )
        ),
        react_default.a.createElement(
          components_Card,
          { className: phaseContractVerificationChecklist_styles_default.a.card },
          react_default.a.createElement(
            'div',
            { className: phaseContractVerificationChecklist_styles_default.a.headerContainer },
            react_default.a.createElement(
              'h4',
              { className: phaseContractVerificationChecklist_styles_default.a.title },
              'Confirm And Submit'
            )
          ),
          react_default.a.createElement(
            'div',
            { className: phaseContractVerificationChecklist_styles_default.a.checklistContainer },
            _this2.requiredFieldsMissingIfi() ? react_default.a.createElement(
              'p',
              { className: phaseContractVerificationChecklist_styles_default.a.checklistError },
              _this2.requiredFieldsMissingIfi()
            ) : react_default.a.createElement(
              react["Fragment"],
              null,
              react_default.a.createElement(components_RadioButtons, {
                label: 'Where should this phase go?',
                onChange: function onChange(val) {
                  return _this2.handleVal('ifiDoneStatus', val);
                },
                selectedValue: _this2.state.ifiDoneStatus,
                radioButtons: [{ label: 'Waiting for Product', value: 'waiting_for_product' }, { label: 'Sent to Scheduling', value: 'scheduling' }, { label: 'IWOL', value: 'hold' }]
              }),
              react_default.a.createElement('br', null),
              _this2.state.ifiDoneStatus ? react_default.a.createElement(react_toolbox_lib["Button"], {
                label: 'Submit Info And Complete Checklist',
                flat: true, inverse: true, ripple: true,
                className: phaseContractVerificationChecklist_styles_default.a.saveButton,
                onClick: function onClick() {
                  return _this2.completeCvChecklistIfi();
                }
              }) : react_default.a.createElement(
                'p',
                { className: phaseContractVerificationChecklist_styles_default.a.checklistError },
                'You must select a completion status to continue'
              )
            )
          )
        )
      );
    }
  });
  Object.defineProperty(this, 'renderDefault', {
    enumerable: true,
    writable: true,
    value: function value() {
      return react_default.a.createElement(
        'div',
        null,
        react_default.a.createElement(
          components_Card,
          { className: phaseContractVerificationChecklist_styles_default.a.card },
          react_default.a.createElement(
            'div',
            { className: phaseContractVerificationChecklist_styles_default.a.headerContainer },
            react_default.a.createElement(
              'h4',
              { className: phaseContractVerificationChecklist_styles_default.a.title },
              'Getting Started'
            )
          ),
          _this2.props.phase.product_type === 'STK' && _this2.props.phase.surface_type.name === 'Carpet' && react_default.a.createElement(
            'div',
            { className: phaseContractVerificationChecklist_styles_default.a.checklistContainer },
            react_default.a.createElement(components_RadioButtons, {
              label: 'Is this an Express Installation?',
              onChange: function onChange(val) {
                return _this2.handleVal('expressInstallation', val);
              },
              selectedValue: _this2.state.expressInstallation,
              radioButtons: _this2.buttons(true)
            })
          ),
          react_default.a.createElement(
            'div',
            { className: phaseContractVerificationChecklist_styles_default.a.checklistContainer },
            react_default.a.createElement(
              'h5',
              null,
              'Linking The Assessment Phase To The Installation Phase'
            ),
            react_default.a.createElement('br', null),
            react_default.a.createElement(
              'ul',
              { className: phaseContractVerificationChecklist_styles_default.a.scriptList },
              react_default.a.createElement(
                'li',
                null,
                'Linking the phases will pull all Assessment and Refigure documents into the Installation Phase'
              )
            ),
            react_default.a.createElement('br', null),
            react_default.a.createElement(tabs_relatedPhases, { cv: true }),
            react_default.a.createElement('br', null),
            react_default.a.createElement(
              'h5',
              null,
              'Selecting/Verifying The Matching Assessment Document'
            ),
            react_default.a.createElement('br', null),
            react_default.a.createElement(
              'ul',
              { className: phaseContractVerificationChecklist_styles_default.a.scriptList },
              react_default.a.createElement(
                'li',
                null,
                'Select appropriate assessment from the dropdown below (If the correct one is not there, upload it in the Upload box below, under',
                '\'Assessment/Refigure\'',
                ')'
              ),
              react_default.a.createElement(
                'li',
                null,
                'Click the green button to open the doc in a new window to visually confirm information on the assessment'
              ),
              react_default.a.createElement(
                'li',
                null,
                'KEEP THE ASSESSMENT OPEN FOR THE DURATION OF THIS CHECKLIST - it is needed as a reference'
              )
            ),
            react_default.a.createElement('br', null),
            react_default.a.createElement(components_assessmentSelection, { cv: true, parentDocs: _this2.props.documents.data }),
            react_default.a.createElement(assessmentLinkSuggestions, {
              proposals: _this2.proposalsOfKind('assessment_link'),
              onResolve: _this2.handleResolveProposal
            })
          )
        ),
        react_default.a.createElement(
          components_Card,
          { className: phaseContractVerificationChecklist_styles_default.a.card },
          react_default.a.createElement(
            'div',
            { className: phaseContractVerificationChecklist_styles_default.a.headerContainer },
            react_default.a.createElement(
              'h4',
              { className: phaseContractVerificationChecklist_styles_default.a.title },
              'Verifying Product/Labor'
            )
          ),
          react_default.a.createElement(
            'div',
            { className: phaseContractVerificationChecklist_styles_default.a.checklistContainer },
            react_default.a.createElement(
              'h5',
              null,
              'How To Verify Assessment Drawings/Merchandise'
            ),
            react_default.a.createElement('br', null),
            react_default.a.createElement(
              'ul',
              { className: phaseContractVerificationChecklist_styles_default.a.scriptList },
              react_default.a.createElement(
                'li',
                null,
                'Verify the amount of flooring sold (see the Merchandise Table) matches the square footage in the assessment (this can be found on either page 1 or 2 depending on the surface type)'
              ),
              react_default.a.createElement(
                'li',
                null,
                'Once you confirm your detail matches what was sold, you will select the floor plan that is attached to the matching detail, therefore when looking at the floor plan you want make sure you have no seams in the doorways, lay direction, number of rooms, pattern is noted or not, no T-seams with pattern or berber carpet (Look for T-seams with Pattern or Berber carpet ONLY if a SPIG measure - APEX measures will be pushed through with T-seams with Pattern or Berber carpet)'
              )
            ),
            react_default.a.createElement('br', null),
            react_default.a.createElement(
              'h5',
              null,
              'How To Identify An Internal Refigure Is Needed'
            ),
            react_default.a.createElement('br', null),
            react_default.a.createElement(
              'ul',
              { className: phaseContractVerificationChecklist_styles_default.a.scriptList },
              react_default.a.createElement(
                'li',
                null,
                'An internal refigure is needed when:',
                react_default.a.createElement(
                  'ul',
                  null,
                  react_default.a.createElement(
                    'li',
                    null,
                    'Carpet sold does not match the amount on the detail'
                  ),
                  react_default.a.createElement(
                    'li',
                    null,
                    'Carpet/Vinyl sold has a pattern, but no pattern on the assessment'
                  ),
                  react_default.a.createElement(
                    'li',
                    null,
                    'Carpet sold is berber or has a pattern and the floor plan is a T-seam'
                  ),
                  react_default.a.createElement(
                    'li',
                    null,
                    'Original floor plan has seams in doorways'
                  ),
                  react_default.a.createElement(
                    'li',
                    null,
                    'Store sells what they want to sell without requesting a refigure to add/combine or remove rooms'
                  ),
                  react_default.a.createElement(
                    'li',
                    null,
                    'Sold nail-down/glue-down wood from a laminate assessment'
                  ),
                  react_default.a.createElement(
                    'li',
                    null,
                    'Sold laminate off a vinyl plank assessment'
                  )
                )
              ),
              react_default.a.createElement('br', null),
              react_default.a.createElement(
                'li',
                null,
                'Other internal refigures would be needed for onsite issues:',
                react_default.a.createElement(
                  'ul',
                  null,
                  react_default.a.createElement(
                    'li',
                    null,
                    'A room needs to be removed or added to know how much material and labor is needed'
                  ),
                  react_default.a.createElement(
                    'li',
                    null,
                    'Plywood needs to be added to the order once the installer arrived on site'
                  ),
                  react_default.a.createElement(
                    'li',
                    null,
                    'Change an area from one surface type to another (e.g. carpet to hard surface or vice versa)'
                  )
                )
              )
            ),
            react_default.a.createElement('br', null),
            react_default.a.createElement(
              'h5',
              null,
              'How To Submit A Refigure'
            ),
            react_default.a.createElement('br', null),
            react_default.a.createElement(
              'ul',
              { className: phaseContractVerificationChecklist_styles_default.a.scriptList },
              react_default.a.createElement(
                'li',
                null,
                'If an Apex measure, send to Apex:',
                react_default.a.createElement(
                  'ul',
                  null,
                  react_default.a.createElement(
                    'li',
                    null,
                    react_default.a.createElement(
                      components_EmailLink,
                      { email: 'recalcs@apexmeasuring.com' },
                      'recalcs@apexmeasuring.com'
                    )
                  ),
                  react_default.a.createElement(
                    'li',
                    null,
                    'Once the refigured assessment is received, upload it to the',
                    '\'Assessments/Refigures\'',
                    ' folder in the ',
                    '\'Documents\'',
                    ' tab and continue verification'
                  )
                )
              ),
              react_default.a.createElement('br', null),
              react_default.a.createElement(
                'li',
                null,
                'If a SPIG measure, request an internal refigure to know how much surface type material will be needed with the amount/pattern size sold:',
                react_default.a.createElement(
                  'ul',
                  null,
                  react_default.a.createElement(
                    'li',
                    null,
                    'Open the linked Assessment Phase, and follow the remaining refigure instructions'
                  ),
                  react_default.a.createElement(
                    'li',
                    null,
                    'Click the red ',
                    '\'Action\'',
                    ' button (bottom-right of the screen, has a white ',
                    '\'+\'',
                    ' symbol)'
                  ),
                  react_default.a.createElement(
                    'li',
                    null,
                    'Select ',
                    '\'Override Status\''
                  ),
                  react_default.a.createElement(
                    'li',
                    null,
                    'In the pop-up window, select ',
                    '\'Refigure\'',
                    ' from the dropdown menu'
                  ),
                  react_default.a.createElement(
                    'li',
                    null,
                    'Include the reason for the refigure in the ',
                    '\'Notes\'',
                    ' section'
                  ),
                  react_default.a.createElement(
                    'li',
                    null,
                    'Click the blue ',
                    '\'Override Status\'',
                    ' button to save'
                  ),
                  react_default.a.createElement(
                    'li',
                    null,
                    'Click the ',
                    '\'Action\'',
                    ' button again'
                  ),
                  react_default.a.createElement(
                    'li',
                    null,
                    'Select ',
                    '\'Add Flag\''
                  ),
                  react_default.a.createElement(
                    'li',
                    null,
                    'Select ',
                    '\'Internal Refigure\'',
                    ' from the options'
                  ),
                  react_default.a.createElement(
                    'li',
                    null,
                    'Add a note'
                  ),
                  react_default.a.createElement(
                    'li',
                    null,
                    'Click ',
                    '\'Add Flag\'',
                    ' to save'
                  )
                )
              ),
              react_default.a.createElement('br', null),
              react_default.a.createElement(
                'li',
                null,
                'If SPIG measure with T-seams, request an Internal Refigure to eliminate the T-seams:',
                react_default.a.createElement(
                  'ul',
                  null,
                  react_default.a.createElement(
                    'li',
                    null,
                    'Navigate to the Assessment Phase'
                  ),
                  react_default.a.createElement(
                    'li',
                    null,
                    'Click the Action button'
                  ),
                  react_default.a.createElement(
                    'li',
                    null,
                    'Select Override Status'
                  ),
                  react_default.a.createElement(
                    'li',
                    null,
                    'In the pop-up window, select Refigure from the dropdown menu'
                  ),
                  react_default.a.createElement(
                    'li',
                    null,
                    'Include the reason for the refigure in the Notes section'
                  ),
                  react_default.a.createElement(
                    'li',
                    null,
                    'Click the blue Override Status button to save'
                  ),
                  react_default.a.createElement(
                    'li',
                    null,
                    'Click the Action button'
                  ),
                  react_default.a.createElement(
                    'li',
                    null,
                    'Select Add Flag'
                  ),
                  react_default.a.createElement(
                    'li',
                    null,
                    'Select Internal Refigure from the options'
                  ),
                  react_default.a.createElement(
                    'li',
                    null,
                    'Add a note'
                  ),
                  react_default.a.createElement(
                    'li',
                    null,
                    'Click Add Flag'
                  )
                )
              ),
              react_default.a.createElement('br', null),
              react_default.a.createElement(
                'li',
                null,
                'If Apex measure, send a Refigure Request to Apex at recalcs@apexmeasuring.com',
                react_default.a.createElement(
                  'ul',
                  null,
                  react_default.a.createElement(
                    'li',
                    null,
                    'Once the refigured Assessment is received, upload it to the',
                    '\'Assessments/Refigures\'',
                    ' file in the ',
                    '\'Documents\'',
                    ' tab and continue verification'
                  )
                )
              )
            ),
            react_default.a.createElement('br', null),
            _this2.state.phase.product_type === 'SOS' && react_default.a.createElement(
              react["Fragment"],
              null,
              react_default.a.createElement(
                'h5',
                null,
                'How To Add SOS PO And For Tracking/Inventory Purposes'
              ),
              react_default.a.createElement('br', null),
              react_default.a.createElement(
                'ul',
                { className: phaseContractVerificationChecklist_styles_default.a.scriptList },
                react_default.a.createElement(
                  'li',
                  null,
                  'In the purchase orders table below, click the blue ',
                  '\'Edit\'',
                  ' button'
                ),
                react_default.a.createElement('br', null),
                react_default.a.createElement(
                  'li',
                  null,
                  'In the blank row that populates, enter information in the following fields:',
                  react_default.a.createElement(
                    'ul',
                    null,
                    react_default.a.createElement(
                      'li',
                      null,
                      'PO # - found in IMS under the ',
                      '\'Current Items Sold\'',
                      ' section in the customer',
                      '\'',
                      's profile'
                    ),
                    react_default.a.createElement(
                      'li',
                      null,
                      'Type - select ',
                      '\'Special Order\'',
                      ' from the dropdown menu'
                    ),
                    react_default.a.createElement(
                      'li',
                      null,
                      'Invoice Status - select ',
                      '\'Non-Billable\'',
                      ' from the dropdown menu'
                    ),
                    react_default.a.createElement(
                      'li',
                      null,
                      'Total - enter ',
                      '\'0\''
                    )
                  )
                ),
                react_default.a.createElement('br', null),
                react_default.a.createElement(
                  'li',
                  null,
                  'Click the green ',
                  '\'Save\'',
                  ' button'
                ),
                react_default.a.createElement(
                  'li',
                  null,
                  'Click the green ',
                  '\'Done\'',
                  ' button'
                )
              ),
              react_default.a.createElement('br', null),
              react_default.a.createElement(purchaseOrderTable, {
                cv: true, phaseId: _this2.state.phase.id, documents: _this2.props.documents.data
              }),
              react_default.a.createElement('br', null),
              react_default.a.createElement(
                'h5',
                null,
                'How To Add SOS Product To Warehouse Merchandise Table'
              ),
              react_default.a.createElement('br', null),
              react_default.a.createElement(
                'ul',
                { className: phaseContractVerificationChecklist_styles_default.a.scriptList },
                react_default.a.createElement(
                  'li',
                  null,
                  'In the merchandise table below, click the blue ',
                  '\'Edit\'',
                  ' button'
                ),
                react_default.a.createElement('br', null),
                react_default.a.createElement(
                  'li',
                  null,
                  'In the blank row that populates, enter information in the following fields:',
                  react_default.a.createElement(
                    'ul',
                    null,
                    react_default.a.createElement(
                      'li',
                      null,
                      'PO Number - select the non-billable PO that was just created'
                    ),
                    react_default.a.createElement(
                      'li',
                      null,
                      'Item Name'
                    ),
                    react_default.a.createElement(
                      'li',
                      null,
                      'QTY Received - enter amount/sqft of surface type material'
                    ),
                    react_default.a.createElement(
                      'li',
                      null,
                      'Date Received'
                    ),
                    react_default.a.createElement(
                      'li',
                      null,
                      'Note (optional)'
                    ),
                    react_default.a.createElement(
                      'li',
                      null,
                      'Status - select ',
                      '\'On Order\'',
                      ' from the drop-down list'
                    )
                  )
                ),
                react_default.a.createElement('br', null),
                react_default.a.createElement(
                  'li',
                  null,
                  'Click the green ',
                  '\'Save\'',
                  ' button'
                ),
                react_default.a.createElement(
                  'li',
                  null,
                  'Click the green ',
                  '\'Done\'',
                  ' button'
                )
              ),
              react_default.a.createElement('br', null),
              react_default.a.createElement(warehouseMerchandiseItemTable, {
                padInfo: _this2.state.pads,
                lineItems: _this2.props.lineItemsWarehouseMerchandise,
                editable: Object(services["a" /* can */])(_this2.props.role, 'update', 'warehouse'),
                phaseId: _this2.state.phase.id,
                cv: true
              }),
              react_default.a.createElement('br', null)
            ),
            _this2.state.phase.surface_type.name === 'Carpet' && react_default.a.createElement(
              react["Fragment"],
              null,
              react_default.a.createElement(
                'h5',
                null,
                'Handling Berber Carpet Seams & Pattern Match Carpets'
              ),
              react_default.a.createElement('br', null),
              react_default.a.createElement(
                'ul',
                { className: phaseContractVerificationChecklist_styles_default.a.scriptList },
                react_default.a.createElement(
                  'li',
                  null,
                  'In the merchandise table below, click on the item number (this will take you to the product on Lowe',
                  '\'',
                  's website)'
                ),
                react_default.a.createElement(
                  'li',
                  null,
                  'On page 3 (usually) of the detail, find pattern size'
                ),
                react_default.a.createElement(
                  'li',
                  null,
                  'You can also see the pattern match at the bottom right of each page of the actual assessment and on the cut sheet'
                ),
                react_default.a.createElement('br', null),
                react_default.a.createElement(
                  'li',
                  null,
                  'Berber Carpet Info:',
                  react_default.a.createElement(
                    'ul',
                    null,
                    react_default.a.createElement(
                      'li',
                      null,
                      'T-seam definition: Installer makes a head seam between two short fill pieces, and then side-seams them to the start piece (should be no wider than 2ft.) - NOT suitable for berber carpet'
                    ),
                    react_default.a.createElement(
                      'li',
                      null,
                      'Head/Cross Seam Definition: Installer joins two pieces that are cut across the width of the carpet - NOT suitable for berber carpet'
                    ),
                    react_default.a.createElement(
                      'li',
                      null,
                      'When verifying the assessment(s) vs. what was sold and it has been determined that the store sold less carpet than required for a pattern match carpet, an internal refigure will need to be performed to see if we can adjust the layout and use what carpet was sold or if the store needs to order more carpet'
                    )
                  )
                ),
                react_default.a.createElement('br', null),
                react_default.a.createElement(
                  'li',
                  null,
                  'Why does patterned material add so much waste to the job?',
                  react_default.a.createElement(
                    'ul',
                    null,
                    react_default.a.createElement(
                      'li',
                      null,
                      'When installing carpet or sheet vinyl with a pattern, the installer must match the pattern on all seams'
                    ),
                    react_default.a.createElement(
                      'li',
                      null,
                      'Each fill piece needs to have one pattern repeat (both height width) added to it so the installer can shift it into place'
                    ),
                    react_default.a.createElement(
                      'li',
                      null,
                      'No matching or producing an ',
                      '\'economy match\'',
                      ' could void the warranty'
                    )
                  )
                )
              ),
              react_default.a.createElement('br', null)
            ),
            _this2.state.phase.source === 'BJ' && react_default.a.createElement(
              react["Fragment"],
              null,
              react_default.a.createElement(
                'h5',
                null,
                'How To Add BJ',
                "'",
                's PO For Tracking/Inventory Purposes'
              ),
              react_default.a.createElement('br', null),
              react_default.a.createElement(
                'ul',
                { className: phaseContractVerificationChecklist_styles_default.a.scriptList },
                react_default.a.createElement(
                  'li',
                  null,
                  'In the purchase orders table below, click the blue ',
                  '\'Edit\'',
                  ' button'
                ),
                react_default.a.createElement('br', null),
                react_default.a.createElement(
                  'li',
                  null,
                  'In the blank row that populates, enter information in the following fields:',
                  react_default.a.createElement(
                    'ul',
                    null,
                    react_default.a.createElement(
                      'li',
                      null,
                      'PO # - enter the purchase order number from BJ',
                      "'",
                      's system or documents'
                    ),
                    react_default.a.createElement(
                      'li',
                      null,
                      'Type - select ',
                      '\'Special Order\'',
                      ' from the dropdown menu'
                    ),
                    react_default.a.createElement(
                      'li',
                      null,
                      'Invoice Status - select ',
                      '\'Non-Billable\'',
                      ' from the dropdown menu'
                    ),
                    react_default.a.createElement(
                      'li',
                      null,
                      'Total - enter ',
                      '\'0\''
                    )
                  )
                ),
                react_default.a.createElement('br', null),
                react_default.a.createElement(
                  'li',
                  null,
                  'Click the green ',
                  '\'Save\'',
                  ' button'
                ),
                react_default.a.createElement(
                  'li',
                  null,
                  'Click the green ',
                  '\'Done\'',
                  ' button'
                )
              ),
              react_default.a.createElement('br', null),
              react_default.a.createElement(purchaseOrderTable, {
                cv: true, phaseId: _this2.state.phase.id, documents: _this2.props.documents.data
              }),
              react_default.a.createElement('br', null),
              react_default.a.createElement(
                'h5',
                null,
                'How To Add BJ',
                "'",
                's Product To Warehouse Merchandise Table'
              ),
              react_default.a.createElement('br', null),
              react_default.a.createElement(
                'ul',
                { className: phaseContractVerificationChecklist_styles_default.a.scriptList },
                react_default.a.createElement(
                  'li',
                  null,
                  'In the merchandise table below, click the blue ',
                  '\'Edit\'',
                  ' button'
                ),
                react_default.a.createElement('br', null),
                react_default.a.createElement(
                  'li',
                  null,
                  'In the blank row that populates, enter information in the following fields:',
                  react_default.a.createElement(
                    'ul',
                    null,
                    react_default.a.createElement(
                      'li',
                      null,
                      'PO Number - select the non-billable PO that was just created'
                    ),
                    react_default.a.createElement(
                      'li',
                      null,
                      'Item Name'
                    ),
                    react_default.a.createElement(
                      'li',
                      null,
                      'QTY Received - enter amount/sqft of surface type material'
                    ),
                    react_default.a.createElement(
                      'li',
                      null,
                      'Date Received'
                    ),
                    react_default.a.createElement(
                      'li',
                      null,
                      'Note (optional)'
                    ),
                    react_default.a.createElement(
                      'li',
                      null,
                      'Status - select ',
                      '\'On Order\'',
                      ' from the drop-down list'
                    )
                  )
                ),
                react_default.a.createElement('br', null),
                react_default.a.createElement(
                  'li',
                  null,
                  'Click the green ',
                  '\'Save\'',
                  ' button'
                ),
                react_default.a.createElement(
                  'li',
                  null,
                  'Click the green ',
                  '\'Done\'',
                  ' button'
                )
              ),
              react_default.a.createElement('br', null),
              react_default.a.createElement(warehouseMerchandiseItemTable, {
                padInfo: _this2.state.pads,
                lineItems: _this2.props.lineItemsWarehouseMerchandise,
                editable: Object(services["a" /* can */])(_this2.props.role, 'update', 'warehouse'),
                phaseId: _this2.state.phase.id,
                cv: true
              }),
              react_default.a.createElement('br', null)
            ),
            react_default.a.createElement(phaseMerchandiseItemTable, {
              phaseId: _this2.state.phase.id, phaseSource: _this2.state.phase.source, cv: true
            }),
            react_default.a.createElement('br', null),
            react_default.a.createElement(
              'h5',
              null,
              'Identifying/Inputting Custom Labor'
            ),
            react_default.a.createElement('br', null),
            react_default.a.createElement(
              'ul',
              { className: phaseContractVerificationChecklist_styles_default.a.scriptList },
              react_default.a.createElement(
                'li',
                null,
                'The layout of assessment/refigure docs may vary, so finding custom labor may vary from document to document'
              ),
              react_default.a.createElement(
                'li',
                null,
                'Utilize your computer',
                '\'',
                's built-in search function (CTRL+f) to search for key words such as: ',
                '\'Custom\'',
                ', ',
                '\'Additional\'',
                ', ',
                '\'Additional Custom\'',
                ',',
                '\'Custom Labor\'',
                ', etc. (these are not the only things you can search)'
              ),
              react_default.a.createElement(
                'li',
                null,
                'If the document has a ',
                '\'Service Items\'',
                ' Section, if a item in that has ',
                '\'Custom\'',
                ' in the ',
                '\'Item Number\'',
                ' column, it is a custom labor'
              ),
              react_default.a.createElement(
                'li',
                null,
                'If the document has a table that starts on the first or second page and has a column titled ',
                '\'LN\'',
                ', in that table look for any Labor described as custom, and there is also a specific row called',
                '\'Additional Custom Work\'',
                ' (it',
                '\'',
                's usually ',
                '\'LN 57\'',
                ')'
              ),
              react_default.a.createElement(
                'li',
                null,
                'Input custom labor in the PO table below (where applicable)'
              )
            ),
            react_default.a.createElement('br', null),
            react_default.a.createElement(phaseLineItemTables, { cv: true, phaseId: _this2.state.phase.id })
          )
        ),
        react_default.a.createElement(lineItemVerification, {
          proposals: _this2.proposalsOfKind('line_item_status'),
          lineItems: _this2.props.phaseLineItems,
          onResolve: _this2.handleResolveProposal
        }),
        react_default.a.createElement(
          components_Card,
          { className: phaseContractVerificationChecklist_styles_default.a.card },
          react_default.a.createElement(
            'div',
            { className: phaseContractVerificationChecklist_styles_default.a.headerContainer },
            react_default.a.createElement(
              'h4',
              { className: phaseContractVerificationChecklist_styles_default.a.title },
              'Floor Plan Upload'
            )
          ),
          react_default.a.createElement(
            'div',
            { className: phaseContractVerificationChecklist_styles_default.a.checklistContainer },
            react_default.a.createElement(
              'h5',
              null,
              'Uploading The Floor Plan'
            ),
            react_default.a.createElement('br', null),
            react_default.a.createElement(
              'ul',
              { className: phaseContractVerificationChecklist_styles_default.a.scriptList },
              react_default.a.createElement(
                'li',
                null,
                'Once you have confirmed you have the correct floor plan, print the floor plan as a pdf (Click the printer icon in the window you are viewing the assessment in, select ',
                '\'Save as PDF\'',
                ' as the Destination, select ',
                '\'Custom\'',
                ' then input the page(s) the floor plan is on, such as',
                '\'6\'',
                ' or ',
                '\'7-8\'',
                ', as the Pages option, then click ',
                '\'Save\'',
                ' and save as ',
                '\'CUSTOMER_LAST_NAME_FLOOR_PLAN\'',
                ')'
              ),
              react_default.a.createElement(
                'li',
                null,
                'Upload the newly saved floor plan pdf under ',
                '\'Floor Plan\'',
                ' in the Upload box below (NEVER use the SPOTBOT floor plan already populated in documents, as this is not an accurate floor plan and must ALWAYS be marked as ',
                '\'do not use\'',
                ')'
              ),
              react_default.a.createElement(
                'li',
                null,
                'Alternatively, you can drag the document from your Desktop (or if open, the folder it was saved in, such as ',
                '\'Documents\'',
                ' or',
                '\'Downloads\'',
                ') into the upload box, still saving it as ',
                '\'Floor Plan\''
              ),
              react_default.a.createElement(
                'li',
                null,
                'If you accidentally upload the wrong document, click the grey',
                '\'cancel\'',
                ' icon to highlight it in red and mark it as ',
                '\'DO NOT USE\''
              )
            ),
            react_default.a.createElement('br', null),
            react_default.a.createElement(phaseDocuments, {
              cv: true,
              parentId: _this2.state.phase.id,
              parentDocs: Object(reducers["b" /* folderDocuments */])(_this2.props.documents.data)
            })
          )
        ),
        react_default.a.createElement(
          components_Card,
          { className: phaseContractVerificationChecklist_styles_default.a.card },
          react_default.a.createElement(
            'div',
            { className: phaseContractVerificationChecklist_styles_default.a.headerContainer },
            react_default.a.createElement(
              'h4',
              { className: phaseContractVerificationChecklist_styles_default.a.title },
              'Input Phase Info'
            )
          ),
          react_default.a.createElement(
            'div',
            { className: phaseContractVerificationChecklist_styles_default.a.checklistContainer },
            react_default.a.createElement(
              'ul',
              { className: phaseContractVerificationChecklist_styles_default.a.scriptList },
              react_default.a.createElement(
                'li',
                null,
                'Net SQFT is found on the Flooring Detail Diagram page of the assessment'
              ),
              react_default.a.createElement(
                'li',
                null,
                'If a SPIG measure: the best way to find it is the ',
                '\'total\'',
                ' line at the bottom of the page'
              ),
              react_default.a.createElement('br', null),
              react_default.a.createElement(
                'li',
                null,
                'If an Apex measure:',
                react_default.a.createElement(
                  'ul',
                  null,
                  react_default.a.createElement(
                    'li',
                    null,
                    'On this page, you will see 4 columns; Material Type, Room, Recommended Material needed, and Actual Room Size'
                  ),
                  react_default.a.createElement(
                    'li',
                    null,
                    'Actual Room Size is considered the ',
                    '\'net square footage\''
                  ),
                  react_default.a.createElement(
                    'li',
                    null,
                    'Round whenever number has a decimal (e.g. if the overall combined actual room size is 2417.2 net square feet, we will round it up to 2418 square feet)'
                  )
                )
              )
            ),
            react_default.a.createElement('br', null),
            _this2.prefillBanner(),
            react_default.a.createElement(react_toolbox_lib["Input"], {
              label: 'Net Square Feet',
              className: phaseContractVerificationChecklist_largeInput,
              value: _this2.state.phase.net_square_footage || '',
              onChange: function onChange(val) {
                return _this2.handlePhaseBasic('net_square_footage', val);
              },
              error: Object(utils["c" /* error */])('net_square_footage', _this2.props.errors)
            }),
            _this2.prefillTag('net_square_footage'),
            react_default.a.createElement(
              'ul',
              { className: phaseContractVerificationChecklist_styles_default.a.scriptList },
              react_default.a.createElement(
                'li',
                null,
                'The fields below can be found in various spots, depending on the layout of the assessment'
              ),
              react_default.a.createElement(
                'li',
                null,
                'If the document has a table with a column labeled ',
                '\'LN\'',
                ', a lot of these items can be found therein (such as subfloor - usually ',
                '\'LN 27\'',
                ',',
                '\'LN 28\'',
                ', ',
                '\'LN 29\'',
                ', ',
                '\'LN 30\'',
                ' - items and furniture questions)'
              ),
              react_default.a.createElement(
                'li',
                null,
                'If there is an ',
                '\'Additional Comments\'',
                ' section, this can also contain this info, such as subfloor'
              ),
              react_default.a.createElement(
                'li',
                null,
                'If there is a ',
                '\'Site Details\'',
                '/',
                '\'Site Questions\'',
                ' section, things such as power (',
                '\'Electricity Available\'',
                ') and climate control (',
                '\'Regulated Temperature\'',
                ') can be found there'
              ),
              react_default.a.createElement(
                'li',
                null,
                'Two other good sections to check are ',
                '\'Detail Specifications\'',
                ' and',
                '\'Room Details\''
              ),
              react_default.a.createElement(
                'li',
                null,
                'If you are having trouble finding these in the described sections above, they are usually easily found searching for keywords (CTRL+f)'
              )
            ),
            react_default.a.createElement('br', null),
            react_default.a.createElement(react_toolbox_lib["Input"], {
              label: 'Year Built',
              className: phaseContractVerificationChecklist_smallInput,
              value: _this2.state.phase.year_built || '',
              onChange: function onChange(val) {
                return _this2.handlePhaseBasic('year_built', val);
              },
              error: Object(utils["c" /* error */])('year_built', _this2.props.errors)
            }),
            _this2.prefillTag('year_built'),
            _this2.state.phase.surface_type.name !== 'Carpet' && _this2.state.phase.store.delivery_method !== 'None' && react_default.a.createElement(react_toolbox_lib["Switch"], {
              name: 'spigDelivery',
              label: 'Is SPIG delivering and staging product?',
              onChange: function onChange(val) {
                return _this2.handlePhaseBasic('spig_delivery', val);
              },
              checked: _this2.state.phase.spig_delivery
            }),
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              name: 'hasPower',
              label: 'Has Power',
              onChange: function onChange(val) {
                return _this2.handlePhaseSpecific('customer_has_power', val);
              },
              checked: _this2.state.phase.phase_specific.customer_has_power
            }),
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              name: 'hasClimateControl',
              label: 'Has Climate Control',
              onChange: function onChange(val) {
                return _this2.handlePhaseSpecific('customer_has_climate_control', val);
              },
              checked: _this2.state.phase.phase_specific.customer_has_climate_control
            }),
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              name: 'needMoveFurniture',
              label: 'Moving Furniture',
              onChange: function onChange(val) {
                return _this2.handlePhaseSpecific('need_move_furniture', val);
              },
              checked: _this2.state.phase.phase_specific.need_move_furniture
            }),
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              name: 'needMoveFurnitureOversized',
              label: 'Moving Oversized Furniture',
              onChange: function onChange(val) {
                return _this2.handlePhaseSpecific('need_move_furniture_oversized', val);
              },
              checked: _this2.state.phase.phase_specific.need_move_furniture_oversized
            }),
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              name: 'needSubfloorPrep',
              label: 'Subfloor Prep',
              onChange: function onChange(val) {
                return _this2.handlePhaseSpecific('need_subfloor_prep', val);
              },
              checked: _this2.state.phase.phase_specific.need_subfloor_prep
            }),
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              name: 'needSubfloorReplacement',
              label: 'Subfloor Replacement',
              onChange: function onChange(val) {
                return _this2.handlePhaseSpecific('need_subfloor_replacement', val);
              },
              checked: _this2.state.phase.phase_specific.need_subfloor_replacement
            }),
            _this2.state.phase.surface_type.name === 'Carpet' && react_default.a.createElement(
              react["Fragment"],
              null,
              react_default.a.createElement(react_toolbox_lib["Switch"], {
                name: 'needHardSurfaceTransistions',
                label: 'Need Hard Surface Transistions',
                onChange: function onChange(val) {
                  return _this2.handlePhaseSpecific('need_hardsurface_transitions', val);
                },
                checked: _this2.state.phase.phase_specific.need_hardsurface_transitions
              }),
              react_default.a.createElement(react_toolbox_lib["Switch"], {
                name: 'needBaseboardMoulding',
                label: 'Need Baseboard/Moulding',
                onChange: function onChange(val) {
                  return _this2.handlePhaseSpecific('need_install_baseboard', val);
                },
                checked: _this2.state.phase.phase_specific.need_install_baseboard
              }),
              react_default.a.createElement(react_toolbox_lib["Switch"], {
                name: 'needBinding',
                label: 'Needs Binding',
                onChange: function onChange(val) {
                  return _this2.handlePhaseSpecific('is_binding_carpet', val);
                },
                checked: _this2.state.phase.phase_specific.is_binding_carpet
              }),
              react_default.a.createElement(react_toolbox_lib["Switch"], {
                name: 'isPatternMatchCarpet',
                label: 'Pattern Match Carpet',
                onChange: function onChange(val) {
                  return _this2.handlePhaseSpecific('is_pattern_match_carpet', val);
                },
                checked: _this2.state.phase.phase_specific.is_pattern_match_carpet
              }),
              react_default.a.createElement(react_toolbox_lib["Switch"], {
                className: form_default.a.specificSwitch,
                name: 'isBerberCarpet',
                label: 'Berber Carpet',
                onChange: function onChange(val) {
                  return _this2.handlePhaseSpecific('is_berber_carpet', val);
                },
                checked: _this2.state.phase.phase_specific.is_berber_carpet,
                disabled: false
              })
            ),
            _this2.state.phase.surface_type.name === 'Hardwood' && react_default.a.createElement(react_toolbox_lib["Switch"], {
              className: form_default.a.specificSwitch,
              name: 'isStepsHardwood',
              label: 'Hardwood Steps',
              onChange: function onChange(val) {
                return _this2.handlePhaseSpecific('is_steps_hardwood', val);
              },
              checked: _this2.state.phase.phase_specific.is_steps_hardwood,
              disabled: false
            }),
            _this2.props.anchoredRemoval && react_default.a.createElement(
              react["Fragment"],
              null,
              react_default.a.createElement(
                'h6',
                null,
                'Which Hardwood Removal?'
              ),
              constants["h" /* ANCHORED_REMOVAL_SLUGS */].map(function (slug, index) {
                return react_default.a.createElement(react_toolbox_lib["Checkbox"], {
                  key: slug,
                  checked: _this2.state.phase.phase_specific[slug],
                  label: slug.replace('need_remove', '').replace(/_/g, ' ').toUpperCase().trim(),
                  onChange: function onChange(val) {
                    return _this2.handlePhaseSpecific(slug, val);
                  },
                  className: form_default.a.cvCheckboxListItem,
                  style: index > 0 ? { marginLeft: '15px' } : {}
                });
              }),
              react_default.a.createElement('br', null)
            )
          )
        ),
        react_default.a.createElement(
          components_Card,
          { className: phaseContractVerificationChecklist_styles_default.a.card },
          react_default.a.createElement(
            'div',
            { className: phaseContractVerificationChecklist_styles_default.a.headerContainer },
            react_default.a.createElement(
              'h4',
              { className: phaseContractVerificationChecklist_styles_default.a.title },
              'Input Contractor Note Info'
            )
          ),
          react_default.a.createElement(
            'div',
            { className: phaseContractVerificationChecklist_styles_default.a.checklistContainer },
            react_default.a.createElement(
              'ul',
              { className: phaseContractVerificationChecklist_styles_default.a.scriptList },
              react_default.a.createElement(
                'li',
                null,
                'Most of this is found in the ',
                '\'Site Details\'',
                ' or',
                '\'Site Questions\'',
                ' section'
              ),
              react_default.a.createElement(
                'li',
                null,
                'Installer Notes and Customer Responsibilities can be found in additional sections such as ',
                '\'Notes\'',
                ', ',
                '\'Comments\'',
                ',',
                '\'Additional Comments\'',
                ' (also sometimes there is a standalone',
                '\'Customer Responsibilities\'',
                ' section)'
              ),
              react_default.a.createElement(
                'li',
                null,
                'Always an option - the computer',
                '\'',
                's search command (CTRL+f)'
              ),
              react_default.a.createElement(
                'li',
                null,
                'If any of these do not apply to the phase or you cannot find the information, select or type ',
                '\'N/A\''
              )
            ),
            react_default.a.createElement('br', null),
            react_default.a.createElement(components_RadioButtons, {
              label: 'New Construction?',
              onChange: function onChange(val) {
                return _this2.handleVal('newConstruction', val);
              },
              selectedValue: _this2.state.newConstruction,
              radioButtons: _this2.buttons()
            }),
            react_default.a.createElement(components_RadioButtons, {
              label: 'Paved Driveway?',
              onChange: function onChange(val) {
                return _this2.handleVal('pavedDriveway', val);
              },
              selectedValue: _this2.state.pavedDriveway,
              radioButtons: _this2.buttons()
            }),
            react_default.a.createElement(components_RadioButtons, {
              label: 'Difficult Access?',
              onChange: function onChange(val) {
                return _this2.handleVal('difficultAccess', val);
              },
              selectedValue: _this2.state.difficultAccess,
              radioButtons: _this2.buttons()
            }),
            react_default.a.createElement(components_RadioButtons, {
              label: 'Restricted Parking Access?',
              onChange: function onChange(val) {
                return _this2.handleVal('restrictedParking', val);
              },
              selectedValue: _this2.state.restrictedParking,
              radioButtons: _this2.buttons()
            }),
            react_default.a.createElement(components_RadioButtons, {
              label: 'If Multi-Family Unit, Is Elevator Available?',
              onChange: function onChange(val) {
                return _this2.handleVal('elevatorAvailable', val);
              },
              selectedValue: _this2.state.elevatorAvailable,
              radioButtons: _this2.buttons()
            }),
            react_default.a.createElement(components_RadioButtons, {
              label: 'Floor/Baseboard Heating?',
              onChange: function onChange(val) {
                return _this2.handleVal('floorBaseHeating', val);
              },
              selectedValue: _this2.state.floorBaseHeating,
              radioButtons: _this2.buttons()
            }),
            react_default.a.createElement(components_RadioButtons, {
              label: 'Freshly Painted Walls?',
              onChange: function onChange(val) {
                return _this2.handleVal('freshPaintWalls', val);
              },
              selectedValue: _this2.state.freshPaintWalls,
              radioButtons: _this2.buttons()
            }),
            react_default.a.createElement(components_RadioButtons, {
              label: 'Pets Present?',
              onChange: function onChange(val) {
                return _this2.handleVal('petsPresent', val);
              },
              selectedValue: _this2.state.petsPresent,
              radioButtons: _this2.buttons()
            }),
            react_default.a.createElement(components_RadioButtons, {
              label: 'Place To Cut Materials?',
              onChange: function onChange(val) {
                return _this2.handleVal('cuttingArea', val);
              },
              selectedValue: _this2.state.cuttingArea,
              radioButtons: _this2.buttons()
            }),
            react_default.a.createElement('br', null),
            react_default.a.createElement(components_StyledSelect, {
              className: phaseContractVerificationChecklist_largeInput,
              label: 'Building Type',
              onChange: function onChange(val) {
                return _this2.handleVal('buildingType', val);
              },
              options: _this2.buildingTypeOptions(),
              value: _this2.state.buildingType || '',
              placeholder: 'Select Building Type'
            }),
            _this2.state.phase.surface_type.name === 'Tile' && react_default.a.createElement(components_RadioButtons, {
              label: 'Rapid Setting Mortar?',
              onChange: function onChange(val) {
                return _this2.handleVal('rapidSetMortar', val);
              },
              selectedValue: _this2.state.rapidSetMortar,
              radioButtons: _this2.buttons()
            }),
            (!_this2.state.phase.net_square_footage || _this2.state.phase.net_square_footage < 150) && react_default.a.createElement(
              react["Fragment"],
              null,
              react_default.a.createElement(components_RadioButtons, {
                label: 'Wood Subfloor?',
                onChange: function onChange(val) {
                  return _this2.handleVal('woodSubfloor', val);
                },
                selectedValue: _this2.state.woodSubfloor,
                radioButtons: _this2.buttons()
              }),
              _this2.state.woodSubfloor === 'Yes' && _this2.props.phase.surface_type.name === 'Tile' && react_default.a.createElement(components_RadioButtons, {
                label: 'Backer Board And Mortar?',
                onChange: function onChange(val) {
                  return _this2.handleVal('hardyBackerMortar', val);
                },
                selectedValue: _this2.state.hardyBackerMortar,
                radioButtons: _this2.buttons()
              })
            ),
            react_default.a.createElement(components_RadioButtons, {
              label: 'Are We Supplying Transitions For Rolled Goods?',
              onChange: function onChange(val) {
                return _this2.handleVal('rolledGoodsTransitions', val);
              },
              selectedValue: _this2.state.rolledGoodsTransitions,
              radioButtons: _this2.buttons()
            }),
            react_default.a.createElement(components_RadioButtons, {
              label: 'Pickup Required?',
              onChange: function onChange(val) {
                return _this2.handleVal('pickup', val);
              },
              selectedValue: _this2.state.pickup,
              radioButtons: _this2.buttons()
            }),
            react_default.a.createElement(components_SimpleInput, {
              label: 'Installer Note',
              text: _this2.state.installerNote,
              errors: _this2.props.errors.installerNote,
              onChange: _this2.handleInstallerNote
            }),
            react_default.a.createElement(components_RadioButtons, {
              label: 'Gas Appliance(s) Present?',
              onChange: function onChange(val) {
                return _this2.handleVal('gasAppliances', val);
              },
              selectedValue: _this2.state.gasAppliances,
              radioButtons: _this2.buttons()
            }),
            react_default.a.createElement(components_SimpleInput, {
              label: 'Customer Responsibilities',
              text: _this2.state.customerNote,
              errors: _this2.props.errors.customerNote,
              onChange: _this2.handleCustomerNote
            })
          )
        ),
        react_default.a.createElement(
          components_Card,
          { className: phaseContractVerificationChecklist_styles_default.a.card },
          react_default.a.createElement(
            'div',
            { className: phaseContractVerificationChecklist_styles_default.a.headerContainer },
            react_default.a.createElement(
              'h4',
              { className: phaseContractVerificationChecklist_styles_default.a.title },
              'Confirm And Submit'
            )
          ),
          react_default.a.createElement(
            'div',
            { className: phaseContractVerificationChecklist_styles_default.a.checklistContainer },
            _this2.requiredFieldsMissing() ? react_default.a.createElement(
              'p',
              { className: phaseContractVerificationChecklist_styles_default.a.checklistError },
              _this2.requiredFieldsMissing()
            ) : react_default.a.createElement(
              react["Fragment"],
              null,
              _this2.nothingToSubmit() ? react_default.a.createElement(
                'p',
                { className: phaseContractVerificationChecklist_styles_default.a.checklistError },
                'Submit some new Phase Info to continue'
              ) : react_default.a.createElement(components_RadioButtons, {
                label: 'Have You Gathered All The Information That You Can?',
                onChange: function onChange(val) {
                  return _this2.handleReadyToSubmit(val);
                },
                selectedValue: _this2.state.readyToSubmit ? 'Yes' : 'No',
                radioButtons: _this2.buttons(true)
              }),
              react_default.a.createElement('br', null),
              !_this2.nothingToSubmit() && react_default.a.createElement(
                react["Fragment"],
                null,
                _this2.state.readyToSubmit ? react_default.a.createElement(react_toolbox_lib["Button"], {
                  label: 'Submit Info And Complete Checklist',
                  flat: true, inverse: true, ripple: true,
                  className: phaseContractVerificationChecklist_styles_default.a.saveButton,
                  onClick: function onClick() {
                    return _this2.completeCvChecklist();
                  }
                }) : react_default.a.createElement(
                  'p',
                  { className: phaseContractVerificationChecklist_styles_default.a.checklistError },
                  'You must verify you are ready to submit to continue'
                )
              )
            )
          )
        )
      );
    }
  });
  Object.defineProperty(this, 'render', {
    enumerable: true,
    writable: true,
    value: function value() {
      if (_this2.props.phase.source === 'IFI') return _this2.renderIfi();
      return _this2.renderDefault();
    }
  });
};

phaseContractVerificationChecklist_ContractVerificationChecklist.propTypes = {
  navigate: prop_types_default.a.func.isRequired,
  updatePhase: prop_types_default.a.func.isRequired,
  updatePhaseTask: prop_types_default.a.func.isRequired,
  addEventToPhase: prop_types_default.a.func.isRequired,
  fetchPhaseDocuments: prop_types_default.a.func.isRequired,
  fetchCvProposals: prop_types_default.a.func.isRequired,
  resolveCvProposal: prop_types_default.a.func.isRequired,
  phase: types_phase,
  phaseLineItems: prop_types_default.a.arrayOf(prop_types_default.a.shape(lineItemPropType)),
  role: prop_types_default.a.string,
  documents: prop_types_default.a.object,
  errors: prop_types_default.a.object,
  anchoredRemoval: prop_types_default.a.bool,
  lineItemsWarehousePads: prop_types_default.a.arrayOf(prop_types_default.a.shape(lineItemPropType)),
  lineItemsWarehouseMerchandise: prop_types_default.a.arrayOf(prop_types_default.a.shape(warehouseMerchandiseItem)),
  requestPhaseItems: prop_types_default.a.func
};

var phaseContractVerificationChecklist_mapStateToProps = function mapStateToProps(state) {
  return {
    anchoredRemoval: state.phase.phaseLineItems.items.filter(function (li) {
      return li.id > 0 && constants["g" /* ANCHORED_REMOVAL_PLIS */].includes(li.item_number);
    }).length > 0,
    lineItemsWarehousePads: state.phase.phaseLineItems.items.filter(function (li) {
      if (state.phase.source === 'IME') {
        return li.kind === 'Pad';
      }
      return li.kind === 'Product';
    }),
    lineItemsWarehouseMerchandise: state.phase.warehouseMerchandiseItems.items,
    phaseLineItems: state.phase.phaseLineItems.items,
    phase: state.phase.details,
    documents: state.phase.documents,
    role: Object(reducers["_12" /* getRole */])(state),
    errors: Object(reducers["Y" /* getPhaseErrors */])(state) || {}
  };
};

/* harmony default export */ var phaseContractVerificationChecklist = (Object(react_redux_es["connect"])(phaseContractVerificationChecklist_mapStateToProps, {
  navigate: actionCreators["O" /* navigate */],
  updatePhase: actionCreators_phase["r" /* updatePhase */],
  updatePhaseTask: actionCreators_phase["s" /* updatePhaseTask */],
  addEventToPhase: actionCreators_phase["a" /* addEventToPhase */],
  fetchPhaseDocuments: actionCreators["A" /* fetchPhaseDocuments */],
  fetchCvProposals: actionCreators_phase["j" /* fetchCvProposals */],
  resolveCvProposal: actionCreators_phase["q" /* resolveCvProposal */],
  requestPhaseItems: phase_items["i" /* requestPhaseItems */]
})(phaseContractVerificationChecklist_ContractVerificationChecklist));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseSchedulingChecklist/components/styledComponents.js
var styledComponents__templateObject = styledComponents__taggedTemplateLiteral(['\n0% {\n    transform: translateY(-100%);\n    opacity: 0;\n  }\n\n100% {\n    transform: translateY(0);\n    opacity: 1;\n  }\n'], ['\n0% {\n    transform: translateY(-100%);\n    opacity: 0;\n  }\n\n100% {\n    transform: translateY(0);\n    opacity: 1;\n  }\n']),
    styledComponents__templateObject2 = styledComponents__taggedTemplateLiteral(['\noverflow: hidden;\n'], ['\noverflow: hidden;\n']);

function styledComponents__taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }




var styledComponents_expand = Object(core_browser_esm["keyframes"])(styledComponents__templateObject);

var styledComponents_DropdownDiv = styled_browser_esm["a" /* default */].div(function (_ref) {
    var condition = _ref.condition;
    return {
        animation: condition ? styledComponents_expand + ' 400ms ease-out' : ''
    };
});

var styledComponents_ContainerDiv = styled_browser_esm["a" /* default */].div(styledComponents__templateObject2);
// EXTERNAL MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseSchedulingChecklist/styles.scss
var phaseSchedulingChecklist_styles = __webpack_require__("3w41");
var phaseSchedulingChecklist_styles_default = /*#__PURE__*/__webpack_require__.n(phaseSchedulingChecklist_styles);

// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseSchedulingChecklist/components/checklistRescheduler.jsx
/* eslint-disable max-len */









var checklistRescheduler_ChecklistRescheduler = function ChecklistRescheduler(props) {
  return react_default.a.createElement(
    'span',
    null,
    props.condition === true && react_default.a.createElement(
      styledComponents_ContainerDiv,
      null,
      react_default.a.createElement(
        styledComponents_DropdownDiv,
        { condition: props.condition },
        react_default.a.createElement(
          'div',
          { className: phaseSchedulingChecklist_styles_default.a.checklistContainer },
          react_default.a.createElement(
            'p',
            null,
            props.text
          ),
          react_default.a.createElement(components_UpdateDueDate, {
            value: props.newDate || '',
            onChange: props.handleNewDate,
            errors: props.errors
          }),
          react_default.a.createElement(components_TextArea, {
            label: 'Notes',
            value: props.newDateNote,
            onChange: props.handleNewDateNote,
            errors: props.errors.note
          }),
          react_default.a.createElement('br', null),
          react_default.a.createElement(
            'p',
            null,
            'Due Date Times earlier than 8am will be set to 8am'
          ),
          react_default.a.createElement('br', null),
          react_default.a.createElement(lib_button["Button"], {
            label: 'Update Due Date',
            flat: true, inverse: true, ripple: true,
            className: phaseSchedulingChecklist_styles_default.a.saveButton,
            onClick: props.submitNewDate
          }),
          props.newDateError && react_default.a.createElement(
            'p',
            { className: phaseSchedulingChecklist_styles_default.a.checklistError },
            props.newDateError
          )
        )
      )
    )
  );
};

checklistRescheduler_ChecklistRescheduler.propTypes = {
  condition: prop_types_default.a.bool,
  text: prop_types_default.a.string,
  newDate: prop_types_default.a.string,
  handleNewDate: prop_types_default.a.func,
  errors: prop_types_default.a.object,
  newDateNote: prop_types_default.a.string,
  handleNewDateNote: prop_types_default.a.func,
  submitNewDate: prop_types_default.a.func,
  newDateError: prop_types_default.a.string
};

/* harmony default export */ var checklistRescheduler = (checklistRescheduler_ChecklistRescheduler);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseSchedulingChecklist/components/checklistIntro.jsx
/* eslint-disable max-len */









var checklistIntro_ChecklistIntro = function ChecklistIntro(props) {
  var user = props.user,
      isInbound = props.isInbound,
      answered = props.answered,
      canTalk = props.canTalk,
      newDate = props.newDate,
      newDateNote = props.newDateNote,
      newDateError = props.newDateError,
      handleIntroQuestion = props.handleIntroQuestion,
      handleNewDate = props.handleNewDate,
      handleNewDateNote = props.handleNewDateNote,
      submitNewDate = props.submitNewDate,
      errors = props.errors,
      _props$phase = props.phase;
  _props$phase = _props$phase === undefined ? {} : _props$phase;
  var customerName = _props$phase.customer_name,
      source = _props$phase.source,
      _props$phase$workroom = _props$phase.workroom;
  _props$phase$workroom = _props$phase$workroom === undefined ? {} : _props$phase$workroom;
  var _props$phase$workroom2 = _props$phase$workroom.name,
      workroom = _props$phase$workroom2 === undefined ? '' : _props$phase$workroom2;

  var vendor = Object(utils["E" /* vendorDisplayName */])(source, workroom);

  var canTalkGreeting = void 0;
  if (isInbound) {
    canTalkGreeting = react_default.a.createElement(
      react["Fragment"],
      null,
      react_default.a.createElement(
        'p',
        null,
        'I',
        '\'',
        'd like to review some information with you as we schedule your installation, do you have a few minutes?'
      ),
      react_default.a.createElement('br', null),
      react_default.a.createElement(
        'p',
        null,
        'The number you just called is the best number to reach us. You can also visit our website, serviceprosig.com and chat with us online.'
      )
    );
  } else if (source === 'IFI') {
    canTalkGreeting = react_default.a.createElement(
      react["Fragment"],
      null,
      react_default.a.createElement(
        'p',
        null,
        'Great! I',
        '\'',
        'd like to go over some information before we add the appointment.'
      ),
      react_default.a.createElement('br', null),
      react_default.a.createElement(
        'p',
        null,
        'First, I want to make sure you know the best ways to contact us. We can be reached by phone; would you like a moment to write this down? Our number is 833-377-2712.'
      )
    );
  } else {
    canTalkGreeting = react_default.a.createElement(
      react["Fragment"],
      null,
      react_default.a.createElement(
        'p',
        null,
        'Great! I',
        '\'',
        'd like to go over some information before we start, do you have a few minutes?'
      ),
      react_default.a.createElement('br', null),
      react_default.a.createElement(
        'p',
        null,
        'First, I want to make sure you know the best ways to contact us. We can be reached by phone or online. Would you like a moment to write this down? Our number is 866-774-4411 or you can chat with us on our website at serviceprosig.com.'
      )
    );
  }

  return react_default.a.createElement(
    components_Card,
    { className: phaseSchedulingChecklist_styles_default.a.card },
    react_default.a.createElement(
      'div',
      { className: phaseSchedulingChecklist_styles_default.a.headerContainer },
      react_default.a.createElement(
        'h4',
        { className: phaseSchedulingChecklist_styles_default.a.title },
        'Scheduling Checklist Intro'
      )
    ),
    react_default.a.createElement(
      'div',
      { className: phaseSchedulingChecklist_styles_default.a.checklistContainer },
      react_default.a.createElement(
        'p',
        { className: phaseSchedulingChecklist_styles_default.a.checklistUserNote },
        'USER NOTE: Is this an inbound or outbound call?'
      ),
      react_default.a.createElement('br', null),
      react_default.a.createElement(lib_button["Button"], {
        label: 'INBOUND',
        flat: true, inverse: true, ripple: true,
        disabled: isInbound,
        className: phaseSchedulingChecklist_styles_default.a.standardButton,
        onClick: function onClick() {
          return handleIntroQuestion('isInbound', true);
        }
      }),
      react_default.a.createElement(lib_button["Button"], {
        label: 'OUTBOUND',
        flat: true, inverse: true, ripple: true,
        disabled: isInbound === false,
        className: phaseSchedulingChecklist_styles_default.a.standardButton,
        onClick: function onClick() {
          return handleIntroQuestion('isInbound', false);
        }
      })
    ),
    isInbound === false && react_default.a.createElement(
      styledComponents_ContainerDiv,
      null,
      react_default.a.createElement(
        styledComponents_DropdownDiv,
        { condition: isInbound === false },
        react_default.a.createElement(
          'div',
          { className: phaseSchedulingChecklist_styles_default.a.checklistContainer },
          react_default.a.createElement(
            'p',
            { className: phaseSchedulingChecklist_styles_default.a.checklistUserNote },
            'USER NOTE: Did the customer answer?'
          ),
          react_default.a.createElement('br', null),
          react_default.a.createElement(lib_button["Button"], {
            label: 'YES',
            flat: true, inverse: true, ripple: true,
            disabled: answered,
            className: phaseSchedulingChecklist_styles_default.a.standardButton,
            onClick: function onClick() {
              return handleIntroQuestion('answered', true);
            }
          }),
          react_default.a.createElement(lib_button["Button"], {
            label: 'NO',
            flat: true, inverse: true, ripple: true,
            disabled: answered === false,
            className: phaseSchedulingChecklist_styles_default.a.standardButton,
            onClick: function onClick() {
              return handleIntroQuestion('answered', false);
            }
          })
        )
      )
    ),
    isInbound === false && answered && react_default.a.createElement(
      styledComponents_ContainerDiv,
      null,
      react_default.a.createElement(
        styledComponents_DropdownDiv,
        { condition: isInbound === false && answered },
        react_default.a.createElement(
          'div',
          { className: phaseSchedulingChecklist_styles_default.a.checklistContainer },
          source === 'IFI' ? react_default.a.createElement(
            'p',
            null,
            'Good Morning/Afternoon ',
            react_default.a.createElement(
              'span',
              { className: phaseSchedulingChecklist_styles_default.a.checklistText },
              customerName
            ),
            '. My name is ',
            react_default.a.createElement(
              'span',
              { className: phaseSchedulingChecklist_styles_default.a.checklistText },
              user
            ),
            ', and I',
            '\'',
            'm calling from Integrity First Installation, your door/window installer for Lowe',
            '\'',
            's. Is this a good time to schedule your installation?'
          ) : react_default.a.createElement(
            'p',
            null,
            'Good Morning/Afternoon ',
            react_default.a.createElement(
              'span',
              { className: phaseSchedulingChecklist_styles_default.a.checklistText },
              customerName
            ),
            '. My name is ',
            react_default.a.createElement(
              'span',
              { className: phaseSchedulingChecklist_styles_default.a.checklistText },
              user
            ),
            ', and I',
            '\'',
            'm calling from Service Pros, your ',
            vendor,
            ' flooring installer. Is this a good time to talk about scheduling your installation?'
          ),
          react_default.a.createElement('br', null),
          react_default.a.createElement(lib_button["Button"], {
            label: 'YES',
            flat: true, inverse: true, ripple: true,
            disabled: canTalk,
            className: phaseSchedulingChecklist_styles_default.a.standardButton,
            onClick: function onClick() {
              return handleIntroQuestion('canTalk', true);
            }
          }),
          react_default.a.createElement(lib_button["Button"], {
            label: 'NO',
            flat: true, inverse: true, ripple: true,
            disabled: canTalk === false,
            className: phaseSchedulingChecklist_styles_default.a.standardButton,
            onClick: function onClick() {
              return handleIntroQuestion('canTalk', false);
            }
          })
        )
      )
    ),
    canTalk && react_default.a.createElement(
      styledComponents_ContainerDiv,
      null,
      react_default.a.createElement(
        styledComponents_DropdownDiv,
        { condition: canTalk },
        react_default.a.createElement(
          'div',
          { className: phaseSchedulingChecklist_styles_default.a.checklistContainer },
          canTalkGreeting,
          react_default.a.createElement('br', null),
          vendor === 'Lowe\'s' && source !== 'IFI' && react_default.a.createElement(
            react["Fragment"],
            null,
            react_default.a.createElement(
              'p',
              null,
              'Also, after your installation is complete, Lowe',
              '\'',
              's will reach out via email to survey your experience. They will ask about our craftsmanship, our professionalism, and your likelihood to recommend to family and friends. We strive for  10s, as they are the only passing score. If at any time during your installation process you do not feel we are earning 10s, please reach out so we can continue to improve our services.'
            ),
            react_default.a.createElement('br', null)
          ),
          react_default.a.createElement(
            'p',
            null,
            'Do you have any questions so far? Alright, let',
            '\'',
            's get you scheduled.'
          )
        )
      )
    ),
    !canTalk && answered === false && react_default.a.createElement(
      styledComponents_ContainerDiv,
      null,
      react_default.a.createElement(
        styledComponents_DropdownDiv,
        { condition: !canTalk && answered === false },
        react_default.a.createElement(
          'div',
          { className: phaseSchedulingChecklist_styles_default.a.checklistContainer },
          react_default.a.createElement('br', null),
          react_default.a.createElement(lib_button["Button"], {
            label: 'Send Scheduling Reminder To Customer',
            flat: true, inverse: true, ripple: true,
            disabled: false,
            className: phaseSchedulingChecklist_styles_default.a.saveButton,
            onClick: function onClick() {
              return submitNewDate(false);
            }
          })
        )
      )
    ),
    react_default.a.createElement(checklistRescheduler, {
      condition: canTalk === false,
      text: 'When would be a good time to call you back?',
      newDate: newDate,
      handleNewDate: handleNewDate,
      errors: errors,
      newDateNote: newDateNote,
      handleNewDateNote: handleNewDateNote,
      submitNewDate: submitNewDate,
      newDateError: newDateError
    })
  );
};

checklistIntro_ChecklistIntro.propTypes = {
  user: prop_types_default.a.string,
  phase: prop_types_default.a.object,
  isInbound: prop_types_default.a.bool,
  answered: prop_types_default.a.bool,
  canTalk: prop_types_default.a.bool,
  newDate: prop_types_default.a.string,
  newDateNote: prop_types_default.a.string,
  newDateError: prop_types_default.a.string,
  handleIntroQuestion: prop_types_default.a.func,
  handleNewDate: prop_types_default.a.func,
  handleNewDateNote: prop_types_default.a.func,
  submitNewDate: prop_types_default.a.func,
  errors: prop_types_default.a.object
};

/* harmony default export */ var checklistIntro = (checklistIntro_ChecklistIntro);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseSchedulingChecklist/components/checklistPhaseInfo.jsx













var checklistPhaseInfo_ChecklistPhaseInfo = function ChecklistPhaseInfo(props) {
  var _props$phase = props.phase,
      street_address = _props$phase.street_address,
      city = _props$phase.city,
      state = _props$phase.state,
      zip_code = _props$phase.zip_code,
      originalAddress = props.originalAddress,
      addressConfirmed = props.addressConfirmed,
      handleAddressConfirmed = props.handleAddressConfirmed,
      handleNewAddress = props.handleNewAddress,
      submitNewAddress = props.submitNewAddress,
      assessmentScheduling = props.assessmentScheduling;

  var statesSource = constants["_35" /* STATES */].map(function (s) {
    return { value: s, label: s };
  });
  var stateValue = constants["_35" /* STATES */].includes(state) ? state : constants["_36" /* STATES_WITH_ABBREV */][state];
  var largeInput = classnames_default()(form_default.a.inputs, form_default.a.largeInput);
  var smallInput = classnames_default()(form_default.a.inputs, form_default.a.smallInput);

  return react_default.a.createElement(
    components_Card,
    { className: phaseSchedulingChecklist_styles_default.a.card },
    react_default.a.createElement(
      'div',
      { className: phaseSchedulingChecklist_styles_default.a.headerContainer },
      react_default.a.createElement(
        'h4',
        { className: phaseSchedulingChecklist_styles_default.a.title },
        'Scheduling Checklist Phase Info'
      )
    ),
    react_default.a.createElement(
      'div',
      { className: phaseSchedulingChecklist_styles_default.a.checklistContainer },
      react_default.a.createElement(
        'p',
        null,
        'The ',
        assessmentScheduling ? 'assessment' : 'installation',
        ' address I see here is ',
        react_default.a.createElement(
          'span',
          { className: phaseSchedulingChecklist_styles_default.a.checklistText },
          originalAddress
        ),
        '. Is that correct?'
      ),
      react_default.a.createElement('br', null),
      react_default.a.createElement(lib_button["Button"], {
        label: 'YES',
        flat: true, inverse: true, ripple: true,
        disabled: addressConfirmed,
        className: phaseSchedulingChecklist_styles_default.a.standardButton,
        onClick: function onClick() {
          return handleAddressConfirmed(true);
        }
      }),
      react_default.a.createElement(lib_button["Button"], {
        label: 'NO',
        flat: true, inverse: true, ripple: true,
        disabled: addressConfirmed === false,
        className: phaseSchedulingChecklist_styles_default.a.standardButton,
        onClick: function onClick() {
          return handleAddressConfirmed(false);
        }
      })
    ),
    addressConfirmed === false && react_default.a.createElement(
      styledComponents_ContainerDiv,
      null,
      react_default.a.createElement(
        styledComponents_DropdownDiv,
        { condition: addressConfirmed || addressConfirmed === false },
        react_default.a.createElement(
          'div',
          { className: phaseSchedulingChecklist_styles_default.a.checklistContainer },
          react_default.a.createElement(react_toolbox_lib["Input"], {
            label: 'Street Address',
            className: largeInput,
            value: street_address,
            onChange: function onChange(val) {
              return handleNewAddress('street_address', val);
            },
            required: true
          }),
          react_default.a.createElement(react_toolbox_lib["Input"], {
            label: 'City',
            className: largeInput,
            value: city,
            onChange: function onChange(val) {
              return handleNewAddress('city', val);
            },
            required: true
          }),
          react_default.a.createElement(components_StyledSelect, {
            className: largeInput,
            label: 'State',
            onChange: function onChange(val) {
              return handleNewAddress('state', val);
            },
            options: statesSource,
            value: stateValue,
            placeholder: 'Select State',
            required: true
          }),
          react_default.a.createElement(react_toolbox_lib["Input"], {
            label: 'Zip Code',
            className: smallInput,
            value: zip_code,
            onChange: function onChange(val) {
              return handleNewAddress('zip_code', val);
            },
            required: true
          }),
          react_default.a.createElement(lib_button["Button"], {
            label: 'Correct Address',
            flat: true, inverse: true, ripple: true,
            className: phaseSchedulingChecklist_styles_default.a.saveButton,
            onClick: function onClick() {
              return submitNewAddress();
            }
          })
        )
      )
    )
  );
};

checklistPhaseInfo_ChecklistPhaseInfo.propTypes = {
  user: prop_types_default.a.string,
  phase: prop_types_default.a.object,
  assessmentScheduling: prop_types_default.a.bool,
  originalAddress: prop_types_default.a.string,
  addressConfirmed: prop_types_default.a.bool,
  handleAddressConfirmed: prop_types_default.a.func,
  handleNewAddress: prop_types_default.a.func,
  submitNewAddress: prop_types_default.a.func
};

/* harmony default export */ var checklistPhaseInfo = (checklistPhaseInfo_ChecklistPhaseInfo);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseSchedulingChecklist/components/checklistResponseNote.jsx
/* eslint-disable max-len */







var checklistResponseNote_ChecklistResponseNote = function ChecklistResponseNote(props) {
  return react_default.a.createElement(
    'span',
    null,
    props.canShow && react_default.a.createElement(
      styledComponents_ContainerDiv,
      null,
      react_default.a.createElement(
        styledComponents_DropdownDiv,
        { condition: props.canShow },
        react_default.a.createElement(
          'div',
          { className: phaseSchedulingChecklist_styles_default.a.checklistContainer },
          react_default.a.createElement(
            'p',
            {
              className: ['flagNote', 'workroomNote', 'okToTextNote'].includes(props.noteKey) ? phaseSchedulingChecklist_styles_default.a.checklistUserNote : ''
            },
            constants["u" /* CHECKLIST_RESPONSE_NOTES */][props.noteKey]
          )
        )
      )
    )
  );
};

checklistResponseNote_ChecklistResponseNote.defaultProps = { canShow: true };

checklistResponseNote_ChecklistResponseNote.propTypes = {
  canShow: prop_types_default.a.bool,
  noteKey: prop_types_default.a.string
};

/* harmony default export */ var checklistResponseNote = (checklistResponseNote_ChecklistResponseNote);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseSchedulingChecklist/components/checklistPhaseContactInfo.jsx











var checklistPhaseContactInfo_ChecklistPhaseContactInfo = function ChecklistPhaseContactInfo(props) {
  var phone_numbers = props.phone_numbers,
      assessmentScheduling = props.assessmentScheduling,
      contactInfoConfirmed = props.contactInfoConfirmed,
      handlePhoneNumber = props.handlePhoneNumber,
      submitContactInfo = props.submitContactInfo;

  var oneNumber = phone_numbers.length === 1;
  return react_default.a.createElement(
    components_Card,
    { className: phaseSchedulingChecklist_styles_default.a.card },
    react_default.a.createElement(
      'div',
      { className: phaseSchedulingChecklist_styles_default.a.headerContainer },
      react_default.a.createElement(
        'h4',
        { className: phaseSchedulingChecklist_styles_default.a.title },
        'Scheduling Checklist Phase Contact Info'
      )
    ),
    react_default.a.createElement(
      'div',
      { className: phaseSchedulingChecklist_styles_default.a.checklistContainer },
      react_default.a.createElement(
        'p',
        null,
        'Do you want to receive text updates at the following number',
        oneNumber ? '' : 's',
        '?'
      ),
      react_default.a.createElement('br', null),
      react_default.a.createElement(checklistResponseNote, { noteKey: 'okToTextNote' }),
      phone_numbers.map(function (n, i) {
        var id = n.id,
            ok_to_text = n.ok_to_text,
            number = n.number;

        return react_default.a.createElement(react_toolbox_lib["Checkbox"], {
          key: id,
          checked: ok_to_text,
          label: Object(utils["h" /* formatTelephone */])(number),
          theme: checkbox_default.a,
          className: form_default.a.checkboxListItem,
          onChange: function onChange(val) {
            return handlePhoneNumber(i, 'ok_to_text', val);
          }
        });
      }),
      react_default.a.createElement('br', null),
      react_default.a.createElement('br', null)
    ),
    react_default.a.createElement('br', null),
    react_default.a.createElement(
      'div',
      { className: phaseSchedulingChecklist_styles_default.a.checklistContainer },
      react_default.a.createElement(lib_button["Button"], {
        label: 'Confirm Texting Permissions',
        flat: true, inverse: true, ripple: true,
        className: phaseSchedulingChecklist_styles_default.a.saveButton,
        onClick: function onClick() {
          return submitContactInfo();
        }
      }),
      contactInfoConfirmed && assessmentScheduling && react_default.a.createElement(
        react["Fragment"],
        null,
        react_default.a.createElement('br', null),
        react_default.a.createElement('br', null),
        react_default.a.createElement(
          'p',
          null,
          'OK, let',
          '\'',
          's get you scheduled! I can offer a morning or afternoon appointment. Your measure tech will call you the night before or morning of to narrow down the time frame.'
        )
      )
    )
  );
};

checklistPhaseContactInfo_ChecklistPhaseContactInfo.propTypes = {
  user: prop_types_default.a.string,
  assessmentScheduling: prop_types_default.a.bool,
  phone_numbers: prop_types_default.a.array,
  contactInfoConfirmed: prop_types_default.a.bool,
  handlePhoneNumber: prop_types_default.a.func,
  submitContactInfo: prop_types_default.a.func
};

/* harmony default export */ var checklistPhaseContactInfo = (checklistPhaseContactInfo_ChecklistPhaseContactInfo);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseSchedulingChecklist/components/basicYesNoQuestion.jsx
/* eslint-disable max-len */








var basicYesNoQuestion_renderList = function renderList(list) {
  return react_default.a.createElement(
    'ul',
    { className: phaseSchedulingChecklist_styles_default.a.scriptList },
    list.map(function (i) {
      return react_default.a.createElement(
        'li',
        { key: i },
        i
      );
    })
  );
};

var basicYesNoQuestion_renderNoteLists = function renderNoteLists(showKey) {
  return react_default.a.createElement(
    react["Fragment"],
    null,
    constants["t" /* CHECKLIST_BASIC_YES_NO_LISTS */][showKey].can.length > 0 && react_default.a.createElement(
      react["Fragment"],
      null,
      react_default.a.createElement(
        'p',
        null,
        'We will:'
      ),
      basicYesNoQuestion_renderList(constants["t" /* CHECKLIST_BASIC_YES_NO_LISTS */][showKey].can)
    ),
    constants["t" /* CHECKLIST_BASIC_YES_NO_LISTS */][showKey].cannot.length > 0 && react_default.a.createElement(
      react["Fragment"],
      null,
      react_default.a.createElement(
        'p',
        null,
        'We cannot:'
      ),
      basicYesNoQuestion_renderList(constants["t" /* CHECKLIST_BASIC_YES_NO_LISTS */][showKey].cannot)
    )
  );
};

var basicYesNoQuestion_BasicYesNoQuestion = function BasicYesNoQuestion(_ref) {
  var parentAnswer = _ref.parentAnswer,
      canShow = _ref.canShow,
      showKey = _ref.showKey,
      showNote = _ref.showNote,
      yesDisabled = _ref.yesDisabled,
      noDisabled = _ref.noDisabled,
      handleAnswered = _ref.handleAnswered;
  return react_default.a.createElement(
    react["Fragment"],
    null,
    canShow && react_default.a.createElement(
      styledComponents_ContainerDiv,
      null,
      react_default.a.createElement(
        styledComponents_DropdownDiv,
        { condition: canShow },
        react_default.a.createElement(
          'div',
          { className: phaseSchedulingChecklist_styles_default.a.checklistContainer },
          react_default.a.createElement(
            'p',
            null,
            parentAnswer === 'yes' ? '' : constants["t" /* CHECKLIST_BASIC_YES_NO_LISTS */][showKey].intro.prefix,
            constants["t" /* CHECKLIST_BASIC_YES_NO_LISTS */][showKey].intro.base
          ),
          react_default.a.createElement('br', null),
          react_default.a.createElement(lib_button["Button"], {
            label: 'YES',
            flat: true, inverse: true, ripple: true,
            disabled: yesDisabled,
            className: phaseSchedulingChecklist_styles_default.a.standardButton,
            onClick: function onClick() {
              return handleAnswered(showKey, false, 'yes');
            }
          }),
          react_default.a.createElement(lib_button["Button"], {
            label: 'NO',
            flat: true, inverse: true, ripple: true,
            disabled: noDisabled,
            className: phaseSchedulingChecklist_styles_default.a.standardButton,
            onClick: function onClick() {
              return handleAnswered(showKey, true, 'no');
            }
          }),
          react_default.a.createElement('br', null),
          react_default.a.createElement('br', null),
          showNote && react_default.a.createElement(
            styledComponents_ContainerDiv,
            null,
            react_default.a.createElement(
              styledComponents_DropdownDiv,
              { condition: showNote },
              basicYesNoQuestion_renderNoteLists(showKey)
            )
          )
        )
      )
    )
  );
};

basicYesNoQuestion_BasicYesNoQuestion.propTypes = {
  parentAnswer: prop_types_default.a.string,
  canShow: prop_types_default.a.bool,
  yesDisabled: prop_types_default.a.bool,
  noDisabled: prop_types_default.a.bool,
  handleAnswered: prop_types_default.a.func,
  showKey: prop_types_default.a.string,
  showNote: prop_types_default.a.bool
};

/* harmony default export */ var basicYesNoQuestion = (basicYesNoQuestion_BasicYesNoQuestion);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseSchedulingChecklist/components/checklistYesNoQuestion.jsx
/* eslint-disable max-len */








var checklistYesNoQuestion_ChecklistYesNoQuestion = function ChecklistYesNoQuestion(_ref) {
  var phaseSpecific = _ref.phaseSpecific,
      canShow = _ref.canShow,
      text = _ref.text,
      yesDisabled = _ref.yesDisabled,
      noDisabled = _ref.noDisabled,
      handleAnswered = _ref.handleAnswered,
      answeredArgs = _ref.answeredArgs,
      showNote = _ref.showNote,
      noteKey = _ref.noteKey;
  return react_default.a.createElement(
    react["Fragment"],
    null,
    canShow && react_default.a.createElement(
      styledComponents_ContainerDiv,
      null,
      react_default.a.createElement(
        styledComponents_DropdownDiv,
        { condition: canShow },
        react_default.a.createElement(
          'div',
          { className: phaseSchedulingChecklist_styles_default.a.checklistContainer },
          react_default.a.createElement(
            'p',
            null,
            text
          ),
          react_default.a.createElement('br', null),
          react_default.a.createElement(lib_button["Button"], {
            label: 'YES',
            flat: true, inverse: true, ripple: true,
            disabled: yesDisabled,
            className: phaseSchedulingChecklist_styles_default.a.standardButton,
            onClick: function onClick() {
              if (phaseSpecific) handleAnswered(answeredArgs[0], answeredArgs[1], true);else handleAnswered(true);
            }
          }),
          react_default.a.createElement(lib_button["Button"], {
            label: 'NO',
            flat: true, inverse: true, ripple: true,
            disabled: noDisabled,
            className: phaseSchedulingChecklist_styles_default.a.standardButton,
            onClick: function onClick() {
              if (phaseSpecific) handleAnswered(answeredArgs[0], answeredArgs[1], false);else handleAnswered(false);
            }
          })
        ),
        react_default.a.createElement(checklistResponseNote, { canShow: showNote, noteKey: noteKey })
      )
    )
  );
};

checklistYesNoQuestion_ChecklistYesNoQuestion.defaultProps = {
  phaseSpecific: false,
  answeredArgs: [],
  showNote: false,
  noteKey: ''
};

checklistYesNoQuestion_ChecklistYesNoQuestion.propTypes = {
  phaseSpecific: prop_types_default.a.bool,
  canShow: prop_types_default.a.bool,
  text: prop_types_default.a.string,
  yesDisabled: prop_types_default.a.bool,
  noDisabled: prop_types_default.a.bool,
  handleAnswered: prop_types_default.a.func,
  answeredArgs: prop_types_default.a.array,
  showNote: prop_types_default.a.bool,
  noteKey: prop_types_default.a.string
};

/* harmony default export */ var checklistYesNoQuestion = (checklistYesNoQuestion_ChecklistYesNoQuestion);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseSchedulingChecklist/components/checklistPhaseSpecifics.jsx
/* eslint-disable max-len */
/* eslint-disable camelcase */















var checklistPhaseSpecifics_ChecklistPhaseSpecifics = function ChecklistPhaseSpecifics(props) {
  var _props$phase = props.phase,
      _props$phase$vendor_e = _props$phase.vendor_eta,
      vendor_eta = _props$phase$vendor_e === undefined ? null : _props$phase$vendor_e,
      surfaceId = _props$phase.surface_type.id,
      _props$phase$phase_sp = _props$phase.phase_specific,
      customer_has_water = _props$phase$phase_sp.customer_has_water,
      need_move_furniture = _props$phase$phase_sp.need_move_furniture,
      need_move_furniture_oversized = _props$phase$phase_sp.need_move_furniture_oversized,
      need_move_appliances = _props$phase$phase_sp.need_move_appliances,
      need_remove_replace_toilet = _props$phase$phase_sp.need_remove_replace_toilet,
      need_remove_floating_hardwood = _props$phase$phase_sp.need_remove_floating_hardwood,
      need_remove_gluedown_carpet = _props$phase$phase_sp.need_remove_gluedown_carpet,
      need_remove_gluedown_hardwood = _props$phase$phase_sp.need_remove_gluedown_hardwood,
      need_remove_gluedown_vinyl = _props$phase$phase_sp.need_remove_gluedown_vinyl,
      need_remove_laminate = _props$phase$phase_sp.need_remove_laminate,
      need_remove_naildown_hardwood = _props$phase$phase_sp.need_remove_naildown_hardwood,
      need_remove_over_pad_carpet = _props$phase$phase_sp.need_remove_over_pad_carpet,
      need_remove_tile = _props$phase$phase_sp.need_remove_tile,
      need_remove_vinyl_plank = _props$phase$phase_sp.need_remove_vinyl_plank,
      powerAnswered = props.powerAnswered,
      climateControlAnswered = props.climateControlAnswered,
      waterAnswered = props.waterAnswered,
      furnitureAnswered = props.furnitureAnswered,
      furnitureOversizedAnswered = props.furnitureOversizedAnswered,
      appliancesAnswered = props.appliancesAnswered,
      toiletAnswered = props.toiletAnswered,
      removalAnswered = props.removalAnswered,
      selectedRemovalType = props.selectedRemovalType,
      newDate = props.newDate,
      newDateNote = props.newDateNote,
      newDateError = props.newDateError,
      haltMessage = props.haltMessage,
      showFurnitureNote = props.showFurnitureNote,
      showFurnitureNoteAnswered = props.showFurnitureNoteAnswered,
      showAppliancesNote = props.showAppliancesNote,
      showAppliancesNoteAnswered = props.showAppliancesNoteAnswered,
      showToiletNote = props.showToiletNote,
      showToiletNoteAnswered = props.showToiletNoteAnswered,
      handleBasicYesNo = props.handleBasicYesNo,
      handleSpecificAnswered = props.handleSpecificAnswered,
      handleRemovalType = props.handleRemovalType,
      handleNewDate = props.handleNewDate,
      handleNewDateNote = props.handleNewDateNote,
      submitNewSpecifics = props.submitNewSpecifics,
      submitNewDate = props.submitNewDate,
      position = props.position,
      errors = props.errors;

  var waterRequired = [3, 7].includes(surfaceId);
  var removalValues = [need_remove_floating_hardwood, need_remove_gluedown_carpet, need_remove_gluedown_hardwood, need_remove_gluedown_vinyl, need_remove_laminate, need_remove_naildown_hardwood, need_remove_over_pad_carpet, need_remove_tile, need_remove_vinyl_plank];
  var powerConfirmed = powerAnswered === 'yes';
  var climateControlConfirmed = climateControlAnswered === 'yes';
  var waterConfirmed = !waterRequired || customer_has_water === true || waterAnswered === 'yes';
  var furnitureConfirmed = need_move_furniture === true || furnitureAnswered.length > 0;
  var furnitureOversizedConfirmed = need_move_furniture_oversized === true || furnitureOversizedAnswered.length > 0;
  var furnitureQuestionsConfirmed = furnitureAnswered === 'yes' ? furnitureOversizedConfirmed : furnitureConfirmed;
  var appliancesQuestionsConfirmed = appliancesAnswered === 'no' || showAppliancesNoteAnswered.length > 0;
  var toiletQuestionsConfirmed = toiletAnswered === 'no' || showToiletNoteAnswered.length > 0;
  var removalConfirmed = removalValues.includes(true) || removalAnswered === 'yes' || removalAnswered === 'no' && selectedRemovalType.length > 0;
  var showWater = waterRequired && (!customer_has_water || waterAnswered.length > 0) && powerConfirmed && climateControlConfirmed;
  var showFurniture = (!need_move_furniture || furnitureAnswered.length > 0) && powerConfirmed && climateControlConfirmed && waterConfirmed;
  var showFurnitureNoteQuestion = (need_move_furniture || furnitureAnswered === 'yes') && powerConfirmed && climateControlConfirmed && waterConfirmed;
  var showFurnitureOversized = (!need_move_furniture_oversized || furnitureOversizedAnswered.length > 0) && powerConfirmed && climateControlConfirmed && waterConfirmed && furnitureAnswered === 'yes';
  var showAppliances = (!need_move_appliances || appliancesAnswered) && powerConfirmed && climateControlConfirmed && waterConfirmed && furnitureQuestionsConfirmed;
  var showAppliancesNoteQuestion = (need_move_appliances || appliancesAnswered === 'yes') && powerConfirmed && climateControlConfirmed && waterConfirmed && furnitureQuestionsConfirmed;
  var showToilet = (!need_remove_replace_toilet || toiletAnswered) && powerConfirmed && climateControlConfirmed && waterConfirmed && furnitureQuestionsConfirmed && appliancesQuestionsConfirmed;
  var showToiletNoteQuestion = (need_remove_replace_toilet || toiletAnswered === 'yes') && powerConfirmed && climateControlConfirmed && waterConfirmed && furnitureQuestionsConfirmed && appliancesQuestionsConfirmed;
  var showRemoval = (!removalValues.includes(true) || removalAnswered) && powerConfirmed && climateControlConfirmed && waterConfirmed && furnitureQuestionsConfirmed && appliancesQuestionsConfirmed && toiletQuestionsConfirmed;
  var allQuestionsAnswered = powerConfirmed && climateControlConfirmed && waterConfirmed && furnitureQuestionsConfirmed && appliancesQuestionsConfirmed && toiletQuestionsConfirmed && removalConfirmed;
  var showCompleteButton = allQuestionsAnswered;

  var largeInput = classnames_default()(form_default.a.inputs, form_default.a.largeInput);

  return react_default.a.createElement(
    components_Card,
    { className: phaseSchedulingChecklist_styles_default.a.card },
    react_default.a.createElement(
      'div',
      { className: phaseSchedulingChecklist_styles_default.a.headerContainer },
      react_default.a.createElement(
        'h4',
        { className: phaseSchedulingChecklist_styles_default.a.title },
        'Scheduling Checklist Phase Specifics'
      )
    ),
    react_default.a.createElement(checklistResponseNote, {
      noteKey: position === 'Customer Care Specialist' ? 'flagNote' : 'workroomNote'
    }),
    react_default.a.createElement(checklistYesNoQuestion, {
      phaseSpecific: true,
      canShow: true,
      text: 'Will the power be on and available for our installers to use during the installation?',
      yesDisabled: powerAnswered === 'yes',
      noDisabled: powerAnswered === 'no',
      handleAnswered: handleSpecificAnswered,
      answeredArgs: ['powerAnswered', 'customer_has_power']
    }),
    react_default.a.createElement(checklistYesNoQuestion, {
      phaseSpecific: true,
      canShow: powerConfirmed,
      text: 'Will your home be climate controlled before, during, and after the installation?',
      yesDisabled: climateControlAnswered === 'yes',
      noDisabled: climateControlAnswered === 'no',
      handleAnswered: handleSpecificAnswered,
      answeredArgs: ['climateControlAnswered', 'customer_has_climate_control']
    }),
    react_default.a.createElement(checklistYesNoQuestion, {
      phaseSpecific: true,
      canShow: showWater,
      text: 'Is the water turned on?',
      yesDisabled: waterAnswered === 'yes',
      noDisabled: waterAnswered === 'no',
      handleAnswered: handleSpecificAnswered,
      answeredArgs: ['waterAnswered', 'customer_has_water']
    }),
    react_default.a.createElement(checklistYesNoQuestion, {
      phaseSpecific: true,
      canShow: showFurniture,
      text: 'Will we be moving any furniture from the room(s) we\\\'re installing in? It is currently notated that we aren\\\'t.',
      yesDisabled: furnitureAnswered === 'yes',
      noDisabled: furnitureAnswered === 'no',
      handleAnswered: handleSpecificAnswered,
      answeredArgs: ['furnitureAnswered', 'need_move_furniture'],
      showNote: furnitureAnswered === 'yes',
      noteKey: 'priceAdjust'
    }),
    react_default.a.createElement(basicYesNoQuestion, {
      parentAnswer: furnitureAnswered,
      canShow: showFurnitureNoteQuestion,
      yesDisabled: showFurnitureNoteAnswered === 'yes',
      noDisabled: showFurnitureNoteAnswered === 'no',
      handleAnswered: handleBasicYesNo,
      showKey: 'showFurnitureNote',
      showNote: showFurnitureNote
    }),
    react_default.a.createElement(checklistYesNoQuestion, {
      phaseSpecific: true,
      canShow: showFurnitureOversized,
      text: 'Is any of it an armoire, large entertainment center, 3-piece or larger sectional sofa, dresser with mirror, nut & bolt bed, or 4 post bed?',
      yesDisabled: furnitureOversizedAnswered === 'yes',
      noDisabled: furnitureOversizedAnswered === 'no',
      handleAnswered: handleSpecificAnswered,
      answeredArgs: ['furnitureOversizedAnswered', 'need_move_furniture_oversized']
    }),
    react_default.a.createElement(checklistYesNoQuestion, {
      phaseSpecific: true,
      canShow: showAppliances,
      text: 'Will we be moving any appliances from the room(s) we\\\'re installing in? It is currently notated that we aren\\\'t.',
      yesDisabled: appliancesAnswered === 'yes',
      noDisabled: appliancesAnswered === 'no',
      handleAnswered: handleSpecificAnswered,
      answeredArgs: ['appliancesAnswered', 'need_move_appliances'],
      showNote: appliancesAnswered === 'yes',
      noteKey: 'priceAdjust'
    }),
    react_default.a.createElement(basicYesNoQuestion, {
      parentAnswer: appliancesAnswered,
      canShow: showAppliancesNoteQuestion,
      yesDisabled: showAppliancesNoteAnswered === 'yes',
      noDisabled: showAppliancesNoteAnswered === 'no',
      handleAnswered: handleBasicYesNo,
      showKey: 'showAppliancesNote',
      showNote: showAppliancesNote
    }),
    react_default.a.createElement(checklistYesNoQuestion, {
      phaseSpecific: true,
      canShow: showToilet,
      text: 'Will we be removing and/or replacing a toilet? It is currently notated that we aren\\\'t.',
      yesDisabled: toiletAnswered === 'yes',
      noDisabled: toiletAnswered === 'no',
      handleAnswered: handleSpecificAnswered,
      answeredArgs: ['toiletAnswered', 'need_remove_replace_toilet'],
      showNote: toiletAnswered === 'yes',
      noteKey: 'priceAdjust'
    }),
    react_default.a.createElement(basicYesNoQuestion, {
      parentAnswer: toiletAnswered,
      canShow: showToiletNoteQuestion,
      yesDisabled: showToiletNoteAnswered === 'yes',
      noDisabled: showToiletNoteAnswered === 'no',
      handleAnswered: handleBasicYesNo,
      showKey: 'showToiletNote',
      showNote: showToiletNote
    }),
    react_default.a.createElement(checklistYesNoQuestion, {
      phaseSpecific: true,
      canShow: showRemoval,
      text: 'I\\\'m showing we will not be removing any existing flooring from the rooms we\\\'re installing in. Is that correct?',
      yesDisabled: removalAnswered === 'yes',
      noDisabled: removalAnswered === 'no',
      handleAnswered: handleSpecificAnswered,
      answeredArgs: ['removalAnswered', ''],
      showNote: removalAnswered === 'no',
      noteKey: 'priceAdjust'
    }),
    removalAnswered === 'no' && react_default.a.createElement(
      'div',
      { className: phaseSchedulingChecklist_styles_default.a.checklistContainer },
      react_default.a.createElement(components_StyledSelect, {
        className: largeInput,
        label: 'Type Of Removal',
        onChange: handleRemovalType,
        options: constants["_24" /* REMOVAL_OPTIONS */],
        value: selectedRemovalType,
        placeholder: 'What Type Of Flooring?',
        required: true
      })
    ),
    showCompleteButton && react_default.a.createElement(
      'div',
      { className: phaseSchedulingChecklist_styles_default.a.checklistContainer },
      react_default.a.createElement(
        'p',
        null,
        vendor_eta && surfaceId === 2 ? 'Your carpet is due to arrive ' + vendor_eta + '.\nLet\'s take a look at the schedule and see what day after that we can get you scheduled.\nIf at any point your carpet is delayed in arriving to our warehouse,\nwe will reach out to you to get a new schedule date set.' : 'OK, let\'s get you scheduled!'
      ),
      react_default.a.createElement('br', null),
      react_default.a.createElement(lib_button["Button"], {
        label: 'COMPLETE CHECKLIST',
        flat: true, inverse: true, ripple: true,
        disabled: false,
        className: phaseSchedulingChecklist_styles_default.a.saveButton,
        onClick: function onClick() {
          return submitNewSpecifics();
        }
      })
    ),
    haltMessage && react_default.a.createElement(checklistRescheduler, {
      condition: haltMessage.length > 0,
      text: haltMessage,
      newDate: newDate,
      handleNewDate: handleNewDate,
      errors: errors,
      newDateNote: newDateNote,
      handleNewDateNote: handleNewDateNote,
      submitNewDate: submitNewDate,
      newDateError: newDateError
    })
  );
};

checklistPhaseSpecifics_ChecklistPhaseSpecifics.propTypes = {
  position: prop_types_default.a.string,
  phase: prop_types_default.a.object,
  powerAnswered: prop_types_default.a.string,
  climateControlAnswered: prop_types_default.a.string,
  waterAnswered: prop_types_default.a.string,
  furnitureAnswered: prop_types_default.a.string,
  furnitureOversizedAnswered: prop_types_default.a.string,
  appliancesAnswered: prop_types_default.a.string,
  toiletAnswered: prop_types_default.a.string,
  removalAnswered: prop_types_default.a.string,
  selectedRemovalType: prop_types_default.a.string,
  newDate: prop_types_default.a.string,
  newDateNote: prop_types_default.a.string,
  newDateError: prop_types_default.a.string,
  haltMessage: prop_types_default.a.string,
  showFurnitureNote: prop_types_default.a.bool,
  showFurnitureNoteAnswered: prop_types_default.a.string,
  showAppliancesNote: prop_types_default.a.bool,
  showAppliancesNoteAnswered: prop_types_default.a.string,
  showToiletNote: prop_types_default.a.bool,
  showToiletNoteAnswered: prop_types_default.a.string,
  handleBasicYesNo: prop_types_default.a.func,
  handleSpecificAnswered: prop_types_default.a.func,
  handleRemovalType: prop_types_default.a.func,
  handleNewDate: prop_types_default.a.func,
  handleNewDateNote: prop_types_default.a.func,
  submitNewSpecifics: prop_types_default.a.func,
  submitNewDate: prop_types_default.a.func,
  errors: prop_types_default.a.object
};

/* harmony default export */ var checklistPhaseSpecifics = (checklistPhaseSpecifics_ChecklistPhaseSpecifics);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseSchedulingChecklist/components/haltCard.jsx








var haltCard_HaltCard = function HaltCard(_ref) {
  var newConstructionAnswered = _ref.newConstructionAnswered,
      handleHaltQuestion = _ref.handleHaltQuestion,
      haltNote = _ref.haltNote,
      handleHaltNote = _ref.handleHaltNote,
      submitHaltNote = _ref.submitHaltNote;
  return react_default.a.createElement(
    components_Card,
    null,
    react_default.a.createElement(
      'div',
      { className: phaseSchedulingChecklist_styles_default.a.headerContainer },
      react_default.a.createElement(
        'h4',
        { className: phaseSchedulingChecklist_styles_default.a.title },
        'Potential Halt'
      )
    ),
    react_default.a.createElement(
      'div',
      { className: phaseSchedulingChecklist_styles_default.a.checklistContainer },
      react_default.a.createElement(
        'p',
        null,
        'Have you had any construction done or made any changes to the areas where the flooring will be installed since the last time we visited your home?'
      ),
      react_default.a.createElement('br', null),
      react_default.a.createElement(lib_button["Button"], {
        label: 'YES',
        flat: true, inverse: true, ripple: true,
        disabled: newConstructionAnswered === 'yes',
        className: phaseSchedulingChecklist_styles_default.a.standardButton,
        onClick: function onClick() {
          return handleHaltQuestion('newConstructionAnswered', 'yes');
        }
      }),
      react_default.a.createElement(lib_button["Button"], {
        label: 'NO',
        flat: true, inverse: true, ripple: true,
        disabled: newConstructionAnswered === 'no',
        className: phaseSchedulingChecklist_styles_default.a.standardButton,
        onClick: function onClick() {
          return handleHaltQuestion('newConstructionAnswered', 'no');
        }
      }),
      react_default.a.createElement('br', null),
      react_default.a.createElement('br', null),
      newConstructionAnswered === 'yes' && react_default.a.createElement(
        styledComponents_ContainerDiv,
        null,
        react_default.a.createElement(
          styledComponents_DropdownDiv,
          { condition: newConstructionAnswered === 'yes' },
          react_default.a.createElement(
            'p',
            null,
            'When changes are made to the installation areas it can affect the amount of materials needed for your installation. We will need to come out and perform a remeasure at your home before we can proceed with the installation. I am going to put in the request and you will receive a call back to schedule.'
          ),
          react_default.a.createElement('br', null),
          react_default.a.createElement(components_TextArea, {
            label: 'Notes',
            value: haltNote,
            onChange: handleHaltNote
          }),
          react_default.a.createElement('br', null),
          react_default.a.createElement(lib_button["Button"], {
            label: 'End Call',
            flat: true, inverse: true, ripple: true,
            className: phaseSchedulingChecklist_styles_default.a.saveButton,
            disabled: !haltNote,
            onClick: submitHaltNote
          })
        )
      )
    )
  );
};

haltCard_HaltCard.propTypes = {
  newConstructionAnswered: prop_types_default.a.string,
  handleHaltQuestion: prop_types_default.a.func,
  haltNote: prop_types_default.a.string,
  handleHaltNote: prop_types_default.a.func,
  submitHaltNote: prop_types_default.a.func
};

/* harmony default export */ var haltCard = (haltCard_HaltCard);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseSchedulingChecklist/components/ifiHaltCard.jsx







var ifiHaltCard_IfiHaltCard = function IfiHaltCard(_ref) {
  var powerAnswered = _ref.powerAnswered,
      handleSpecificAnswered = _ref.handleSpecificAnswered,
      haltMessage = _ref.haltMessage,
      newDate = _ref.newDate,
      newDateNote = _ref.newDateNote,
      newDateError = _ref.newDateError,
      handleNewDate = _ref.handleNewDate,
      handleNewDateNote = _ref.handleNewDateNote,
      submitNewDate = _ref.submitNewDate,
      errors = _ref.errors;
  return react_default.a.createElement(
    components_Card,
    null,
    react_default.a.createElement(
      'div',
      { className: phaseSchedulingChecklist_styles_default.a.headerContainer },
      react_default.a.createElement(
        'h4',
        { className: phaseSchedulingChecklist_styles_default.a.title },
        'Potential Halt'
      )
    ),
    react_default.a.createElement(checklistYesNoQuestion, {
      phaseSpecific: true,
      canShow: true,
      text: 'Will the power be on and available for our installers to use during the installation?',
      yesDisabled: powerAnswered === 'yes',
      noDisabled: powerAnswered === 'no',
      handleAnswered: handleSpecificAnswered,
      answeredArgs: ['powerAnswered', 'customer_has_power']
    }),
    react_default.a.createElement(checklistRescheduler, {
      condition: powerAnswered === 'no',
      text: haltMessage,
      newDate: newDate,
      handleNewDate: handleNewDate,
      errors: errors,
      newDateNote: newDateNote,
      handleNewDateNote: handleNewDateNote,
      submitNewDate: submitNewDate,
      newDateError: newDateError
    })
  );
};

ifiHaltCard_IfiHaltCard.propTypes = {
  powerAnswered: prop_types_default.a.string,
  handleSpecificAnswered: prop_types_default.a.func,
  haltMessage: prop_types_default.a.string,
  newDate: prop_types_default.a.string,
  newDateNote: prop_types_default.a.string,
  newDateError: prop_types_default.a.string,
  handleNewDate: prop_types_default.a.func,
  handleNewDateNote: prop_types_default.a.func,
  submitNewDate: prop_types_default.a.func,
  errors: prop_types_default.a.object
};

/* harmony default export */ var ifiHaltCard = (ifiHaltCard_IfiHaltCard);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseSchedulingChecklist/components/ifiClearingArea.jsx
/* eslint-disable max-len */







var ifiClearingArea_IfiClearingArea = function IfiClearingArea(_ref) {
  var hasPets = _ref.hasPets,
      customerResponsibilitiesReviewed = _ref.customerResponsibilitiesReviewed,
      broughtMaterials = _ref.broughtMaterials,
      handleHaltQuestion = _ref.handleHaltQuestion,
      submitNewSpecifics = _ref.submitNewSpecifics;
  return react_default.a.createElement(
    components_Card,
    { className: phaseSchedulingChecklist_styles_default.a.card },
    react_default.a.createElement(
      'div',
      { className: phaseSchedulingChecklist_styles_default.a.headerContainer },
      react_default.a.createElement(
        'h4',
        { className: phaseSchedulingChecklist_styles_default.a.title },
        'Clearing the Installation Area'
      )
    ),
    react_default.a.createElement(
      'div',
      { className: phaseSchedulingChecklist_styles_default.a.checklistContainer },
      react_default.a.createElement(
        'p',
        null,
        'Do you have pets?'
      ),
      react_default.a.createElement('br', null),
      react_default.a.createElement(lib_button["Button"], {
        label: 'YES',
        flat: true, inverse: true, ripple: true,
        disabled: hasPets === 'yes',
        className: phaseSchedulingChecklist_styles_default.a.standardButton,
        onClick: function onClick() {
          return handleHaltQuestion('hasPets', 'yes');
        }
      }),
      react_default.a.createElement(lib_button["Button"], {
        label: 'NO',
        flat: true, inverse: true, ripple: true,
        disabled: hasPets === 'no',
        className: phaseSchedulingChecklist_styles_default.a.standardButton,
        onClick: function onClick() {
          return handleHaltQuestion('hasPets', 'no');
        }
      }),
      hasPets === 'yes' && react_default.a.createElement(
        styledComponents_ContainerDiv,
        null,
        react_default.a.createElement(
          styledComponents_DropdownDiv,
          { condition: hasPets === 'yes' },
          react_default.a.createElement(
            'p',
            null,
            'Please ensure all animals and pets are secured and cleared from the installation area.'
          )
        )
      )
    ),
    hasPets.length > 0 && react_default.a.createElement(
      styledComponents_ContainerDiv,
      null,
      react_default.a.createElement(
        styledComponents_DropdownDiv,
        { condition: hasPets.length > 0 },
        react_default.a.createElement(
          'div',
          { className: phaseSchedulingChecklist_styles_default.a.checklistContainer },
          react_default.a.createElement(
            'p',
            null,
            'Has anyone reviewed customer responsibilities with you yet?'
          ),
          react_default.a.createElement('br', null),
          react_default.a.createElement(lib_button["Button"], {
            label: 'YES',
            flat: true, inverse: true, ripple: true,
            disabled: customerResponsibilitiesReviewed === 'yes',
            className: phaseSchedulingChecklist_styles_default.a.standardButton,
            onClick: function onClick() {
              return handleHaltQuestion('customerResponsibilitiesReviewed', 'yes');
            }
          }),
          react_default.a.createElement(lib_button["Button"], {
            label: 'NO',
            flat: true, inverse: true, ripple: true,
            disabled: customerResponsibilitiesReviewed === 'no',
            className: phaseSchedulingChecklist_styles_default.a.standardButton,
            onClick: function onClick() {
              return handleHaltQuestion('customerResponsibilitiesReviewed', 'no');
            }
          }),
          customerResponsibilitiesReviewed === 'no' && react_default.a.createElement(
            styledComponents_ContainerDiv,
            null,
            react_default.a.createElement(
              styledComponents_DropdownDiv,
              { condition: customerResponsibilitiesReviewed === 'no' },
              react_default.a.createElement(
                'p',
                null,
                'For a seamless and successful installation with limited delays, we ask all customers clear the working area and remove any devices.'
              ),
              react_default.a.createElement('br', null),
              react_default.a.createElement(
                'ul',
                { className: phaseSchedulingChecklist_styles_default.a.scriptList },
                react_default.a.createElement(
                  'li',
                  null,
                  'Move all furniture/personal items from around windows and out of door ways.'
                ),
                react_default.a.createElement(
                  'li',
                  null,
                  'Clear out a path to entryways being installed. Example: snow, patio furniture, plants.'
                ),
                react_default.a.createElement(
                  'li',
                  null,
                  'Security systems, doorbell-cameras, light fixtures in the way of the installation.'
                )
              ),
              react_default.a.createElement('br', null),
              react_default.a.createElement(
                'p',
                null,
                'Last reminder is that our installers do not provide painting services and will not be able to paint any surfaces after the completion of installation. Please expect minor damage to existing paint during installation.'
              )
            )
          )
        )
      )
    ),
    customerResponsibilitiesReviewed.length > 0 && react_default.a.createElement(
      styledComponents_ContainerDiv,
      null,
      react_default.a.createElement(
        styledComponents_DropdownDiv,
        { condition: customerResponsibilitiesReviewed.length > 0 },
        react_default.a.createElement(
          'div',
          { className: phaseSchedulingChecklist_styles_default.a.checklistContainer },
          react_default.a.createElement(
            'p',
            null,
            'Did you bring any materials home with you?'
          ),
          react_default.a.createElement('br', null),
          react_default.a.createElement(lib_button["Button"], {
            label: 'YES',
            flat: true, inverse: true, ripple: true,
            disabled: broughtMaterials === 'yes',
            className: phaseSchedulingChecklist_styles_default.a.standardButton,
            onClick: function onClick() {
              return handleHaltQuestion('broughtMaterials', 'yes');
            }
          }),
          react_default.a.createElement(lib_button["Button"], {
            label: 'NO',
            flat: true, inverse: true, ripple: true,
            disabled: broughtMaterials === 'no',
            className: phaseSchedulingChecklist_styles_default.a.standardButton,
            onClick: function onClick() {
              return handleHaltQuestion('broughtMaterials', 'no');
            }
          })
        )
      )
    ),
    broughtMaterials.length > 0 && react_default.a.createElement(
      styledComponents_ContainerDiv,
      null,
      react_default.a.createElement(
        styledComponents_DropdownDiv,
        { condition: broughtMaterials.length > 0 },
        react_default.a.createElement(
          'div',
          { className: phaseSchedulingChecklist_styles_default.a.checklistContainer },
          react_default.a.createElement(
            react["Fragment"],
            null,
            react_default.a.createElement(
              'p',
              null,
              'That was all the information I needed from you today.'
            ),
            react_default.a.createElement('br', null),
            react_default.a.createElement(
              'p',
              null,
              'Do you have any questions for me before we schedule the appointment?'
            ),
            react_default.a.createElement('br', null),
            react_default.a.createElement(
              'p',
              null,
              "Let's",
              ' get you scheduled.'
            ),
            react_default.a.createElement('br', null),
            react_default.a.createElement(lib_button["Button"], {
              label: 'COMPLETE CHECKLIST',
              flat: true, inverse: true, ripple: true,
              className: phaseSchedulingChecklist_styles_default.a.saveButton,
              onClick: submitNewSpecifics
            })
          )
        )
      )
    )
  );
};

ifiClearingArea_IfiClearingArea.propTypes = {
  hasPets: prop_types_default.a.string,
  customerResponsibilitiesReviewed: prop_types_default.a.string,
  broughtMaterials: prop_types_default.a.string,
  handleHaltQuestion: prop_types_default.a.func,
  submitNewSpecifics: prop_types_default.a.func
};

/* harmony default export */ var ifiClearingArea = (ifiClearingArea_IfiClearingArea);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseSchedulingChecklist/index.jsx
var phaseSchedulingChecklist__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function phaseSchedulingChecklist__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function phaseSchedulingChecklist__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function phaseSchedulingChecklist__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function phaseSchedulingChecklist__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

























var phaseSchedulingChecklist_PhaseSchedulingChecklist = function (_React$Component) {
  phaseSchedulingChecklist__inherits(PhaseSchedulingChecklist, _React$Component);

  function PhaseSchedulingChecklist(props) {
    phaseSchedulingChecklist__classCallCheck(this, PhaseSchedulingChecklist);

    var _this = phaseSchedulingChecklist__possibleConstructorReturn(this, (PhaseSchedulingChecklist.__proto__ || Object.getPrototypeOf(PhaseSchedulingChecklist)).call(this, props));

    phaseSchedulingChecklist__initialiseProps.call(_this);

    _this.handleBasicYesNo = _this.handleBasicYesNo.bind(_this);
    _this.handleIntroQuestion = _this.handleIntroQuestion.bind(_this);
    _this.handleNewDate = _this.handleNewDate.bind(_this);
    _this.handleNewDateNote = _this.handleNewDateNote.bind(_this);
    _this.handleAddressConfirmed = _this.handleAddressConfirmed.bind(_this);
    _this.handleNewAddress = _this.handleNewAddress.bind(_this);
    _this.handleHaltQuestion = _this.handleHaltQuestion.bind(_this);
    _this.handleHaltNote = _this.handleHaltNote.bind(_this);
    _this.handleSpecificAnswered = _this.handleSpecificAnswered.bind(_this);
    _this.handleRemovalType = _this.handleRemovalType.bind(_this);
    _this.handleAddAssessment = _this.handleAddAssessment.bind(_this);
    _this.submitNewDate = _this.submitNewDate.bind(_this);
    _this.submitNewAddress = _this.submitNewAddress.bind(_this);
    _this.submitHaltNote = _this.submitHaltNote.bind(_this);
    _this.submitNewSpecifics = _this.submitNewSpecifics.bind(_this);
    var _this$props$phase = _this.props.phase,
        phase = _this$props$phase === undefined ? {} : _this$props$phase;

    var today = moment_default()();
    _this.state = {
      today: today,
      phase: phase,
      phaseDate: phase.date_sold,
      isInbound: null,
      answered: null,
      canTalk: null,
      newDate: '',
      haltCardConfirmed: '',
      newDateNote: '',
      newDateError: '',
      addressConfirmed: null,
      contactInfoConfirmed: null,
      newConstructionAnswered: '',
      haltNote: '',
      powerAnswered: '',
      climateControlAnswered: '',
      waterAnswered: '',
      furnitureAnswered: '',
      furnitureOversizedAnswered: '',
      appliancesAnswered: '',
      toiletAnswered: '',
      removalAnswered: '',
      hasPets: '',
      customerResponsibilitiesReviewed: '',
      broughtMaterials: '',
      selectedRemovalType: '',
      showFurnitureNote: false,
      showFurnitureNoteAnswered: '',
      showAppliancesNote: false,
      showAppliancesNoteAnswered: '',
      showToiletNote: false,
      showToiletNoteAnswered: '',
      year: today.clone().format('YYYY'),
      potentialHalt: { answeredKey: '', message: '' },
      assessmentScheduling: phase.type === 'Assessment',
      errors: {}
    };
    return _this;
  }

  return PhaseSchedulingChecklist;
}(react_default.a.Component);

var phaseSchedulingChecklist__initialiseProps = function _initialiseProps() {
  var _this2 = this;

  Object.defineProperty(this, 'handleScrollDown', {
    enumerable: true,
    writable: true,
    value: function value(percent) {
      return Object(utils["z" /* smoothScrollBy */])({ percent: percent });
    }
  });
  Object.defineProperty(this, 'handleBasicYesNo', {
    enumerable: true,
    writable: true,
    value: function value(key, val, answeredVal) {
      var _this2$setState;

      return _this2.setState((_this2$setState = {}, phaseSchedulingChecklist__defineProperty(_this2$setState, key, val), phaseSchedulingChecklist__defineProperty(_this2$setState, key + 'Answered', answeredVal), phaseSchedulingChecklist__defineProperty(_this2$setState, 'scrollDown', 18), _this2$setState));
    }
  });
  Object.defineProperty(this, 'handleHaltQuestion', {
    enumerable: true,
    writable: true,
    value: function value(key, val) {
      return _this2.setState(phaseSchedulingChecklist__defineProperty({}, key, val), function () {
        return _this2.handleScrollDown(18);
      });
    }
  });
  Object.defineProperty(this, 'handleHaltNote', {
    enumerable: true,
    writable: true,
    value: function value(e) {
      return _this2.setState({ haltNote: e.target.value });
    }
  });
  Object.defineProperty(this, 'handleIntroQuestion', {
    enumerable: true,
    writable: true,
    value: function value(key, val) {
      var newState = {};
      var scrollDown = 20;
      if (['answered', 'canTalk'].includes(key)) {
        newState[key] = val;
        if (val) scrollDown = 18;
      } else if (val) newState = { isInbound: val, answered: val, canTalk: val };else newState = { isInbound: val, answered: null, canTalk: null };
      _this2.setState(newState, function () {
        return _this2.handleScrollDown(scrollDown);
      });
    }
  });
  Object.defineProperty(this, 'handleNewDate', {
    enumerable: true,
    writable: true,
    value: function value(newDate) {
      return _this2.setState({ newDate: newDate });
    }
  });
  Object.defineProperty(this, 'handleNewDateNote', {
    enumerable: true,
    writable: true,
    value: function value(e) {
      return _this2.setState({ newDateNote: e.target.value });
    }
  });
  Object.defineProperty(this, 'handleNewDateError', {
    enumerable: true,
    writable: true,
    value: function value() {
      return _this2.setState({ newDateError: 'You must choose a date to submit' });
    }
  });
  Object.defineProperty(this, 'handleAddressConfirmed', {
    enumerable: true,
    writable: true,
    value: function value(addressConfirmed) {
      return _this2.setState({ addressConfirmed: addressConfirmed, newDateError: '' }, function () {
        return _this2.handleScrollDown(addressConfirmed ? 20 : 25);
      });
    }
  });
  Object.defineProperty(this, 'handleContactInfoConfirmed', {
    enumerable: true,
    writable: true,
    value: function value(scrollDown) {
      return _this2.setState({ contactInfoConfirmed: true }, function () {
        return _this2.handleScrollDown(scrollDown);
      });
    }
  });
  Object.defineProperty(this, 'handleNewAddress', {
    enumerable: true,
    writable: true,
    value: function value(key, val) {
      var phase = _this2.state.phase;

      phase[key] = val;
      _this2.setState({ phase: phase });
    }
  });
  Object.defineProperty(this, 'handlePhoneNumber', {
    enumerable: true,
    writable: true,
    value: function value(index, key, val) {
      var phase = _this2.state.phase;

      phase.phone_numbers[index][key] = val;
      _this2.setState({ phase: phase });
    }
  });
  Object.defineProperty(this, 'handleSpecificAnswered', {
    enumerable: true,
    writable: true,
    value: function value(answeredKey, specificKey, val) {
      var _newState;

      var phase = _this2.state.phase;

      var answeredVal = val ? 'yes' : 'no';
      var newState = (_newState = {}, phaseSchedulingChecklist__defineProperty(_newState, answeredKey, answeredVal), phaseSchedulingChecklist__defineProperty(_newState, 'phase', phase), _newState);
      var scrollDown = 20;
      if (answeredKey !== 'removalAnswered') {
        newState.phase.phase_specific[specificKey] = val;
        if (!['furnitureAnswered', 'furnitureOversizedAnswered', 'appliancesAnswered', 'toiletAnswered'].includes(answeredKey)) {
          newState.potentialHalt = answeredVal === 'yes' ? { answeredKey: '', message: '' } : { answeredKey: answeredKey, message: constants["_17" /* POTENTIAL_HALT_MESSAGES */][answeredKey] };
          scrollDown = 15;
        }
      }
      _this2.setState(newState, function () {
        return _this2.handleScrollDown(scrollDown);
      });
    }
  });
  Object.defineProperty(this, 'handleRemovalType', {
    enumerable: true,
    writable: true,
    value: function value(val) {
      var phase = _this2.props.phase;

      phase.phase_specific[val] = true;
      _this2.setState({ phase: phase, selectedRemovalType: val }, function () {
        return _this2.handleScrollDown(20);
      });
    }
  });
  Object.defineProperty(this, 'handleAddAssessment', {
    enumerable: true,
    writable: true,
    value: function value() {
      return _this2.props.navigate(urls.newAppointment(_this2.props.phase.id, 'assessment'));
    }
  });
  Object.defineProperty(this, 'submitNewDate', {
    enumerable: true,
    writable: true,
    value: function value() {
      var answered = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var _state = _this2.state,
          _state$phase = _state.phase,
          id = _state$phase.id,
          due_at = _state$phase.due_at,
          phase_specific = _state$phase.phase_specific,
          phase = _state.phase,
          newDate = _state.newDate,
          newDateNote = _state.newDateNote;

      var new_due_date = answered ? newDate || '' : moment_business_days_default()().add(1, 'day').toISOString();
      var editedDateNote = answered ? newDateNote : 'Due date moved to next business day due to the customer not answering';
      if (answered && !new_due_date) _this2.handleNewDateError();else {
        var updatePhaseArg = { id: id, due_at: new_due_date };
        var updateAddtlArgs = { actionType: 'update_due_at' };
        if (answered) updatePhaseArg.phase_specific_attributes = phase_specific;else updateAddtlArgs.communication = 'SendScheduleAttemptMessage';
        var noteProps = {
          name: 'Due Date Updated',
          kind: 'due_date_updated',
          data: { newDateNote: editedDateNote, old_due_date: due_at, new_due_date: new_due_date }
        };
        _this2.props.updatePhase(updatePhaseArg, updateAddtlArgs).then(function () {
          return _this2.props.addEventToPhase(id, noteProps);
        }).then(function () {
          return _this2.props.navigate(urls.phaseHistory(phase));
        }).catch(function () {});
      }
    }
  });
  Object.defineProperty(this, 'submitNewAddress', {
    enumerable: true,
    writable: true,
    value: function value() {
      var phase = _this2.state.phase;

      if (phase.date_sold || '') delete phase.date_sold;
      _this2.props.updatePhase(phase, {}).then(function () {
        return _this2.handleAddressConfirmed(null);
      }).catch(function () {});
    }
  });
  Object.defineProperty(this, 'submitContactInfo', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _state2 = _this2.state,
          phase = _state2.phase,
          _state2$phase = _state2.phase,
          id = _state2$phase.id,
          phone_numbers = _state2$phase.phone_numbers;

      var setAutoComText = false;
      var phoneNumbersAttributes = phone_numbers.map(function (phone, i) {
        if (phone.number.trim() === '') {
          if (!phone.id) return i > 0 ? null : phone;
          return phaseSchedulingChecklist__extends({}, phone, { _destroy: true });
        }
        if (phone.ok_to_text === true && phase.communication_method !== 'text') setAutoComText = true;
        return phone;
      }).filter(function (n) {
        return !!n;
      });
      _this2.props.updatePhase(phaseSchedulingChecklist__extends({
        id: id,
        phone_numbers_attributes: phoneNumbersAttributes
      }, setAutoComText && { communication_method: 'text' }), {}).then(function () {
        return _this2.handleContactInfoConfirmed(20);
      }).catch(function () {});
    }
  });
  Object.defineProperty(this, 'submitHaltNote', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _state3 = _this2.state,
          phase = _state3.phase,
          id = _state3.phase.id,
          haltNote = _state3.haltNote;

      var noteProps = {
        name: 'Note',
        kind: 'note',
        data: { note: haltNote }
      };
      _this2.props.addEventToPhase(id, noteProps).then(function () {
        return _this2.props.navigate(urls.phaseHistory(phase));
      }).catch(function () {});
    }
  });
  Object.defineProperty(this, 'submitNewSpecifics', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _state4 = _this2.state,
          phase = _state4.phase,
          _state4$phase = _state4.phase,
          id = _state4$phase.id,
          phase_specific = _state4$phase.phase_specific;

      _this2.props.updatePhase({ id: id, phase_specific_attributes: phase_specific }, {}).then(function () {
        _this2.props.updatePhaseTask(id, 'scheduling_checklist', { task: { status: 'complete' } });
      }).then(function () {
        return _this2.props.navigate(urls.phaseAppointments(phase));
      }).catch(function () {});
    }
  });
  Object.defineProperty(this, 'ifiContractorNotes', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _state5 = _this2.state,
          contractor_notes = _state5.phase.contractor_notes,
          hasPets = _state5.hasPets,
          broughtMaterials = _state5.broughtMaterials;

      return (contractor_notes || '') + '\n\n-->> PETS PRESENT: ' + (hasPets === 'yes' ? 'Yes' : 'No') + ' <<--\n\n-->> BROUGHT MATERIALS HOME: ' + (broughtMaterials === 'yes' ? 'Yes' : 'No') + ' <<--';
    }
  });
  Object.defineProperty(this, 'submitIfiNewSpecifics', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _state6 = _this2.state,
          phase = _state6.phase,
          _state6$phase = _state6.phase,
          id = _state6$phase.id,
          phase_specific = _state6$phase.phase_specific;

      var payload = phaseSchedulingChecklist__extends({}, phase, {
        contractor_notes: _this2.ifiContractorNotes(),
        phase_specific_attributes: phase_specific
      });
      if (payload.date_sold || '') delete payload.date_sold;
      _this2.props.updatePhase(payload, {}).then(function () {
        return _this2.props.updatePhaseTask(id, 'scheduling_checklist', { task: { status: 'complete' } });
      }).then(function () {
        return _this2.props.navigate(urls.phaseAppointments(phase));
      }).catch(function () {});
    }
  });
  Object.defineProperty(this, 'render', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _state7 = _this2.state,
          phase = _state7.phase,
          isInbound = _state7.isInbound,
          answered = _state7.answered,
          canTalk = _state7.canTalk,
          newDate = _state7.newDate,
          newDateNote = _state7.newDateNote,
          newDateError = _state7.newDateError,
          addressConfirmed = _state7.addressConfirmed,
          contactInfoConfirmed = _state7.contactInfoConfirmed,
          newConstructionAnswered = _state7.newConstructionAnswered,
          haltNote = _state7.haltNote,
          powerAnswered = _state7.powerAnswered,
          climateControlAnswered = _state7.climateControlAnswered,
          waterAnswered = _state7.waterAnswered,
          furnitureAnswered = _state7.furnitureAnswered,
          furnitureOversizedAnswered = _state7.furnitureOversizedAnswered,
          appliancesAnswered = _state7.appliancesAnswered,
          toiletAnswered = _state7.toiletAnswered,
          removalAnswered = _state7.removalAnswered,
          selectedRemovalType = _state7.selectedRemovalType,
          hasPets = _state7.hasPets,
          customerResponsibilitiesReviewed = _state7.customerResponsibilitiesReviewed,
          broughtMaterials = _state7.broughtMaterials,
          showFurnitureNote = _state7.showFurnitureNote,
          showFurnitureNoteAnswered = _state7.showFurnitureNoteAnswered,
          showAppliancesNote = _state7.showAppliancesNote,
          showAppliancesNoteAnswered = _state7.showAppliancesNoteAnswered,
          showToiletNote = _state7.showToiletNote,
          showToiletNoteAnswered = _state7.showToiletNoteAnswered,
          errors = _state7.errors,
          message = _state7.potentialHalt.message,
          assessmentScheduling = _state7.assessmentScheduling;
      var _props = _this2.props,
          user = _props.user,
          position = _props.position;

      var isIfi = ifiUtils(phase);
      return react_default.a.createElement(
        'div',
        null,
        !assessmentScheduling && react_default.a.createElement(
          react["Fragment"],
          null,
          react_default.a.createElement(checklistIntro, {
            user: user,
            phase: phase,
            isInbound: isInbound,
            answered: answered,
            canTalk: canTalk,
            newDate: newDate,
            newDateNote: newDateNote,
            newDateError: newDateError,
            handleIntroQuestion: _this2.handleIntroQuestion,
            handleNewDate: _this2.handleNewDate,
            handleNewDateNote: _this2.handleNewDateNote,
            submitNewDate: _this2.submitNewDate,
            errors: errors
          }),
          react_default.a.createElement('br', null)
        ),
        (canTalk || assessmentScheduling) && react_default.a.createElement(
          styledComponents_ContainerDiv,
          null,
          react_default.a.createElement(
            styledComponents_DropdownDiv,
            { condition: canTalk || assessmentScheduling },
            react_default.a.createElement(checklistPhaseInfo, {
              phase: phase,
              assessmentScheduling: assessmentScheduling,
              originalAddress: Object(utils["i" /* fullAddress */])(phase),
              addressConfirmed: addressConfirmed,
              handleAddressConfirmed: _this2.handleAddressConfirmed,
              handleNewAddress: _this2.handleNewAddress,
              submitNewAddress: _this2.submitNewAddress
            })
          )
        ),
        (addressConfirmed || assessmentScheduling) && react_default.a.createElement(
          styledComponents_ContainerDiv,
          null,
          react_default.a.createElement(
            styledComponents_DropdownDiv,
            { condition: addressConfirmed || assessmentScheduling },
            react_default.a.createElement(checklistPhaseContactInfo, {
              assessmentScheduling: assessmentScheduling,
              phone_numbers: phase.phone_numbers,
              contactInfoConfirmed: contactInfoConfirmed,
              handlePhoneNumber: _this2.handlePhoneNumber,
              submitContactInfo: _this2.submitContactInfo
            })
          )
        ),
        !assessmentScheduling && react_default.a.createElement(
          react["Fragment"],
          null,
          contactInfoConfirmed && react_default.a.createElement(
            styledComponents_ContainerDiv,
            null,
            react_default.a.createElement(
              styledComponents_DropdownDiv,
              { condition: contactInfoConfirmed },
              isIfi ? react_default.a.createElement(ifiHaltCard, {
                powerAnswered: powerAnswered,
                handleSpecificAnswered: _this2.handleSpecificAnswered,
                haltMessage: message,
                newDate: newDate,
                newDateNote: newDateNote,
                newDateError: newDateError,
                handleNewDate: _this2.handleNewDate,
                handleNewDateNote: _this2.handleNewDateNote,
                submitNewDate: _this2.submitNewDate,
                errors: errors
              }) : react_default.a.createElement(haltCard, {
                handleHaltQuestion: _this2.handleHaltQuestion,
                newConstructionAnswered: newConstructionAnswered,
                handleHaltNote: _this2.handleHaltNote,
                haltNote: haltNote,
                submitHaltNote: _this2.submitHaltNote
              })
            )
          ),
          react_default.a.createElement('br', null),
          isIfi ? powerAnswered === 'yes' && react_default.a.createElement(
            styledComponents_ContainerDiv,
            null,
            react_default.a.createElement(
              styledComponents_DropdownDiv,
              { condition: powerAnswered === 'yes' },
              react_default.a.createElement(ifiClearingArea, {
                hasPets: hasPets,
                customerResponsibilitiesReviewed: customerResponsibilitiesReviewed,
                broughtMaterials: broughtMaterials,
                handleHaltQuestion: _this2.handleHaltQuestion,
                submitNewSpecifics: _this2.submitIfiNewSpecifics
              })
            )
          ) : newConstructionAnswered === 'no' && react_default.a.createElement(
            styledComponents_ContainerDiv,
            null,
            react_default.a.createElement(
              styledComponents_DropdownDiv,
              { condition: newConstructionAnswered === 'no' },
              react_default.a.createElement(checklistPhaseSpecifics, {
                position: position,
                phase: phase,
                powerAnswered: powerAnswered,
                climateControlAnswered: climateControlAnswered,
                waterAnswered: waterAnswered,
                furnitureAnswered: furnitureAnswered,
                furnitureOversizedAnswered: furnitureOversizedAnswered,
                appliancesAnswered: appliancesAnswered,
                toiletAnswered: toiletAnswered,
                removalAnswered: removalAnswered,
                selectedRemovalType: selectedRemovalType,
                newDate: newDate,
                newDateNote: newDateNote,
                newDateError: newDateError,
                haltMessage: message,
                showFurnitureNote: showFurnitureNote,
                showFurnitureNoteAnswered: showFurnitureNoteAnswered,
                showAppliancesNote: showAppliancesNote,
                showAppliancesNoteAnswered: showAppliancesNoteAnswered,
                showToiletNote: showToiletNote,
                showToiletNoteAnswered: showToiletNoteAnswered,
                handleBasicYesNo: _this2.handleBasicYesNo,
                handleSpecificAnswered: _this2.handleSpecificAnswered,
                handleRemovalType: _this2.handleRemovalType,
                handleNewDate: _this2.handleNewDate,
                handleNewDateNote: _this2.handleNewDateNote,
                submitNewSpecifics: _this2.submitNewSpecifics,
                submitNewDate: _this2.submitNewDate,
                errors: errors
              })
            )
          )
        ),
        assessmentScheduling && react_default.a.createElement(lib_button["Button"], {
          label: 'PROCEED TO SCHEDULING',
          flat: true, inverse: true, ripple: true,
          disabled: !contactInfoConfirmed,
          className: phaseSchedulingChecklist_styles_default.a.saveButton,
          onClick: function onClick() {
            return _this2.handleAddAssessment();
          }
        })
      );
    }
  });
};

phaseSchedulingChecklist_PhaseSchedulingChecklist.propTypes = {
  phase: types_phase.isRequired,
  position: prop_types_default.a.string.isRequired,
  user: prop_types_default.a.string.isRequired,
  navigate: prop_types_default.a.func.isRequired,
  updatePhase: prop_types_default.a.func.isRequired,
  updatePhaseTask: prop_types_default.a.func.isRequired,
  addEventToPhase: prop_types_default.a.func.isRequired,
  overridePhaseStatus: prop_types_default.a.func.isRequired,
  clearValidation: prop_types_default.a.func.isRequired,
  removeFlagFromPhase: prop_types_default.a.func.isRequired
};

/* harmony default export */ var phaseSchedulingChecklist = (Object(react_redux_es["connect"])(function (state) {
  return {
    phase: state.phase.details,
    user: state.user.name,
    position: Object(reducers["_8" /* getPosition */])(state)
  };
}, {
  navigate: actionCreators["O" /* navigate */],
  updatePhase: actionCreators_phase["r" /* updatePhase */],
  updatePhaseTask: actionCreators_phase["s" /* updatePhaseTask */],
  addEventToPhase: actionCreators_phase["a" /* addEventToPhase */],
  overridePhaseStatus: actionCreators_phase["l" /* overridePhaseStatus */],
  clearValidation: actionCreators_phase["f" /* clearValidation */],
  removeFlagFromPhase: actionCreators_phase["m" /* removeFlagFromPhase */]
})(phaseSchedulingChecklist_PhaseSchedulingChecklist));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseAppointments/components/deleteAppointmentModal.jsx
function deleteAppointmentModal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function deleteAppointmentModal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function deleteAppointmentModal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var deleteAppointmentModal_DEFAULT_STATE = {
  who: '',
  reason: '',
  showConfirm: false,
  errors: {}
};

var deleteAppointmentModal_DeleteAppointmentModal = function (_React$Component) {
  deleteAppointmentModal__inherits(DeleteAppointmentModal, _React$Component);

  function DeleteAppointmentModal(props) {
    deleteAppointmentModal__classCallCheck(this, DeleteAppointmentModal);

    var _this = deleteAppointmentModal__possibleConstructorReturn(this, (DeleteAppointmentModal.__proto__ || Object.getPrototypeOf(DeleteAppointmentModal)).call(this, props));

    Object.defineProperty(_this, 'handleWhoChange', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        return _this.setState({ who: e });
      }
    });
    Object.defineProperty(_this, 'handleReasonChange', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        return _this.setState({ reason: e.target.value });
      }
    });
    Object.defineProperty(_this, 'handleSubmit', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$state = _this.state,
            who = _this$state.who,
            reason = _this$state.reason;

        var errors = {};
        if (who.trim() === '') errors.who = 'Can\'t be blank.';
        if (reason.trim() === '') errors.reason = 'Can\'t be blank.';
        _this.setState({ errors: errors, showConfirm: !(errors.who || errors.reason) });
      }
    });
    Object.defineProperty(_this, 'handleClose', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.setState(deleteAppointmentModal_DEFAULT_STATE);
        _this.props.onClose();
      }
    });
    Object.defineProperty(_this, 'handleConfirmSubmit', {
      enumerable: true,
      writable: true,
      value: function value() {
        var appt = _this.props.appointment;
        var _this$state2 = _this.state,
            who = _this$state2.who,
            reason = _this$state2.reason;

        var eventProps = { who: who, note: reason };
        _this.props.deletePhaseAppointment(appt.id, eventProps).then(function () {
          return _this.handleClose();
        });
      }
    });
    Object.defineProperty(_this, 'handleConfirmClose', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.handleClose();
      }
    });
    Object.defineProperty(_this, 'options', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            phaseSource = _this$props.phaseSource,
            phaseWorkroom = _this$props.phaseWorkroom;

        var vendorOption = Object(utils["E" /* vendorDisplayName */])(phaseSource, phaseWorkroom);
        var baseOptions = ['Customer', 'SPIG', vendorOption];
        return (vendorOption !== 'Refloor' ? baseOptions : [].concat(baseOptions, [Object(utils["E" /* vendorDisplayName */])('PFT', null, true)])).map(function (o) {
          return { value: o, label: o };
        });
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props2 = _this.props,
            active = _this$props2.active,
            serverErrors = _this$props2.serverErrors;
        var _this$state3 = _this.state,
            who = _this$state3.who,
            reason = _this$state3.reason,
            showConfirm = _this$state3.showConfirm,
            errors = _this$state3.errors;

        return react_default.a.createElement(
          react_toolbox_lib["Dialog"],
          {
            active: active,
            className: modal_default.a.modal,
            type: 'fullscreen',
            onEscKeyDown: _this.handleClose,
            onOverlayClick: _this.handleClose
          },
          react_default.a.createElement(
            'div',
            { className: input_default.a.errored },
            Object.keys(serverErrors).length > 0 && react_default.a.createElement(
              'span',
              { className: input_default.a.error },
              'This action could not be completed.'
            )
          ),
          react_default.a.createElement(lib_button["IconButton"], {
            icon: 'close',
            className: modal_default.a.close,
            onClick: _this.handleClose,
            tabIndex: -1
          }),
          react_default.a.createElement(
            'h5',
            { className: modal_default.a.title },
            'Delete Appointment'
          ),
          react_default.a.createElement(components_StyledSelect, {
            className: modal_default.a.select,
            label: 'Who is deleting? *',
            onChange: _this.handleWhoChange,
            options: _this.options(),
            value: who,
            placeholder: 'Select',
            error: errors.who
          }),
          react_default.a.createElement(components_TextArea, {
            label: 'Reason *',
            value: reason,
            errors: [errors.reason],
            onChange: _this.handleReasonChange
          }),
          react_default.a.createElement(lib_button["Button"], {
            label: 'Delete Appointment',
            flat: true, inverse: true, ripple: true,
            className: modal_default.a.submit,
            onClick: _this.handleSubmit
          }),
          react_default.a.createElement(ConfirmDialog["a" /* default */], {
            title: 'Are you sure you want to delete this appointment?',
            okLabel: 'Yes, Delete the Appointment',
            cancelLabel: 'No',
            show: showConfirm,
            cancel: _this.handleConfirmClose,
            dismiss: _this.handleConfirmClose,
            proceed: _this.handleConfirmSubmit
          })
        );
      }
    });

    _this.state = deleteAppointmentModal_DEFAULT_STATE;
    return _this;
  }

  // Until we make PFT its own vendor, we have to make special consideration
  // TODO: Remove this function when PFT is a vendor


  return DeleteAppointmentModal;
}(react_default.a.Component);

deleteAppointmentModal_DeleteAppointmentModal.propTypes = {
  active: prop_types_default.a.bool.isRequired,
  deletePhaseAppointment: prop_types_default.a.func.isRequired,
  onClose: prop_types_default.a.func.isRequired,
  appointment: prop_types_default.a.object,
  serverErrors: prop_types_default.a.shape({}),
  phaseSource: prop_types_default.a.string,
  phaseWorkroom: prop_types_default.a.string
};

deleteAppointmentModal_DeleteAppointmentModal.defaultProps = { active: false };

/* harmony default export */ var deleteAppointmentModal = (Object(react_redux_es["connect"])(function (state) {
  return { serverErrors: Object(reducers["Y" /* getPhaseErrors */])(state) };
}, { deletePhaseAppointment: deletePhaseAppointment })(deleteAppointmentModal_DeleteAppointmentModal));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseAppointments/components/convertAppointmentModal.jsx
function convertAppointmentModal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function convertAppointmentModal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function convertAppointmentModal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var convertAppointmentModal_DEFAULT_STATE = { note: '', showConfirm: false, errors: {} };
var SS_DATA = { source: 'calendar', ignoredWarnings: [] };

var convertAppointmentModal_ConvertAppointmentModal = function (_React$Component) {
  convertAppointmentModal__inherits(ConvertAppointmentModal, _React$Component);

  function ConvertAppointmentModal(props) {
    convertAppointmentModal__classCallCheck(this, ConvertAppointmentModal);

    var _this = convertAppointmentModal__possibleConstructorReturn(this, (ConvertAppointmentModal.__proto__ || Object.getPrototypeOf(ConvertAppointmentModal)).call(this, props));

    Object.defineProperty(_this, 'handleNoteChange', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        return _this.setState({ note: e.target.value });
      }
    });
    Object.defineProperty(_this, 'handleSubmit', {
      enumerable: true,
      writable: true,
      value: function value() {
        var errors = {};
        if (_this.state.note.trim() === '') errors.reason = 'Can\'t be blank.';
        _this.setState({ errors: errors, showConfirm: !errors.note });
      }
    });
    Object.defineProperty(_this, 'handleClose', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.setState(convertAppointmentModal_DEFAULT_STATE);
        _this.props.onClose();
      }
    });
    Object.defineProperty(_this, 'handleConfirmSubmit', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            phaseId = _this$props.phaseId,
            _this$props$appointme = _this$props.appointment,
            _this$props$appointme2 = _this$props$appointme.id,
            id = _this$props$appointme2 === undefined ? null : _this$props$appointme2,
            _this$props$appointme3 = _this$props$appointme.kind,
            kind = _this$props$appointme3 === undefined ? '' : _this$props$appointme3;

        var params = { note: _this.state.note };
        if (kind === 'installation_hold') params.kind = 'installation';else if (kind === 'workorder_hold') params.kind = 'repair';else if (kind === 'assessment_hold') params.kind = 'assessment';else params.kind = 'delivery';
        _this.props.editPhaseAppointment(id, phaseId, params, SS_DATA, {}).then(function () {
          return _this.handleClose();
        });
      }
    });
    Object.defineProperty(_this, 'handleConfirmClose', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.handleClose();
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props2 = _this.props,
            active = _this$props2.active,
            serverErrors = _this$props2.serverErrors;
        var _this$state = _this.state,
            note = _this$state.note,
            showConfirm = _this$state.showConfirm,
            errors = _this$state.errors;

        return react_default.a.createElement(
          react_toolbox_lib["Dialog"],
          {
            active: active,
            className: modal_default.a.modal,
            type: 'fullscreen',
            onEscKeyDown: _this.handleClose,
            onOverlayClick: _this.handleClose
          },
          react_default.a.createElement(
            'div',
            { className: input_default.a.errored },
            Object.keys(serverErrors).length > 0 && react_default.a.createElement(
              'span',
              { className: input_default.a.error },
              'This action could not be completed.'
            )
          ),
          react_default.a.createElement(lib_button["IconButton"], {
            icon: 'close',
            className: modal_default.a.close,
            onClick: _this.handleClose,
            tabIndex: -1
          }),
          react_default.a.createElement(
            'h5',
            { className: modal_default.a.title },
            'Confirm Appointment'
          ),
          react_default.a.createElement(components_TextArea, {
            label: 'Note *',
            value: note,
            errors: [errors.note],
            onChange: _this.handleNoteChange
          }),
          react_default.a.createElement(lib_button["Button"], {
            label: 'Confirm Appointment',
            flat: true, inverse: true, ripple: true,
            className: modal_default.a.submit,
            onClick: _this.handleSubmit
          }),
          react_default.a.createElement(ConfirmDialog["a" /* default */], {
            title: 'Are you sure you want to confirm this appointment?',
            okLabel: 'Yes, Confirm the Appointment',
            cancelLabel: 'No',
            show: showConfirm,
            cancel: _this.handleConfirmClose,
            dismiss: _this.handleConfirmClose,
            proceed: _this.handleConfirmSubmit
          })
        );
      }
    });

    _this.state = convertAppointmentModal_DEFAULT_STATE;
    return _this;
  }

  return ConvertAppointmentModal;
}(react_default.a.Component);

convertAppointmentModal_ConvertAppointmentModal.propTypes = {
  active: prop_types_default.a.bool.isRequired,
  editPhaseAppointment: prop_types_default.a.func.isRequired,
  onClose: prop_types_default.a.func.isRequired,
  phaseId: prop_types_default.a.number,
  appointment: prop_types_default.a.object,
  serverErrors: prop_types_default.a.shape({})
};

convertAppointmentModal_ConvertAppointmentModal.defaultProps = { active: false };

/* harmony default export */ var convertAppointmentModal = (Object(react_redux_es["connect"])(function (state) {
  return { serverErrors: Object(reducers["Y" /* getPhaseErrors */])(state) };
}, { editPhaseAppointment: editPhaseAppointment })(convertAppointmentModal_ConvertAppointmentModal));
// EXTERNAL MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseAppointments/phaseAppointmentCard.scss
var phaseAppointmentCard = __webpack_require__("vi6X");
var phaseAppointmentCard_default = /*#__PURE__*/__webpack_require__.n(phaseAppointmentCard);

// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseAppointments/index.jsx
function phaseAppointments__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function phaseAppointments__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function phaseAppointments__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


























var phaseAppointments_PhaseAppointments = function (_Component) {
  phaseAppointments__inherits(PhaseAppointments, _Component);

  function PhaseAppointments(props) {
    phaseAppointments__classCallCheck(this, PhaseAppointments);

    var _this = phaseAppointments__possibleConstructorReturn(this, (PhaseAppointments.__proto__ || Object.getPrototypeOf(PhaseAppointments)).call(this, props));

    Object.defineProperty(_this, 'componentDidMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.requestPhaseAppointments(_this.props.phaseId);
      }
    });
    Object.defineProperty(_this, 'can', {
      enumerable: true,
      writable: true,
      value: function value(ability) {
        var attrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return Object(services["a" /* can */])(_this.props.role, ability, 'appointment_form', attrs);
      }
    });
    Object.defineProperty(_this, 'isCcs', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.position === 'Customer Care Specialist';
      }
    });
    Object.defineProperty(_this, 'canEditApptType', {
      enumerable: true,
      writable: true,
      value: function value(type) {
        return !_this.isCcs() || ['installation', 'installation_hold', 'delivery', 'delivery_hold', 'assessment', 'assessment_hold'].includes(type);
      }
    });
    Object.defineProperty(_this, 'sortAppointments', {
      enumerable: true,
      writable: true,
      value: function value(appointments) {
        var scheduled = [];
        var completed = [];
        appointments.forEach(function (appt) {
          if (appt.end_moment.isSameOrAfter(moment_default()().startOf('day'))) scheduled.push(appt);else completed.push(appt);
        });
        return { scheduled: scheduled, completed: completed };
      }
    });
    Object.defineProperty(_this, 'handleAddAppointment', {
      enumerable: true,
      writable: true,
      value: function value(apptType) {
        return _this.props.navigate(urls.newAppointment(_this.props.phaseId, apptType === 'installation_hold' ? 'installation' : apptType));
      }
    });
    Object.defineProperty(_this, 'handleAddAssessment', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.role === 'estimator' ? _this.props.navigate(urls.newAppointment(_this.props.phaseId, 'assessment')) : _this.props.navigate('/phases/' + _this.props.phaseId + '/scheduling-checklist');
      }
    });
    Object.defineProperty(_this, 'handleDeleteAppointment', {
      enumerable: true,
      writable: true,
      value: function value(appt) {
        return _this.setState({
          selectedAppointment: appt, deleteAppointment: true
        });
      }
    });
    Object.defineProperty(_this, 'handleConvertAppointment', {
      enumerable: true,
      writable: true,
      value: function value(appt) {
        return _this.setState({
          selectedAppointment: appt, convertAppointment: true
        });
      }
    });
    Object.defineProperty(_this, 'handleDeleteAppointmentClose', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ deleteAppointment: false }, function () {
          return window.location.reload();
        });
      }
    });
    Object.defineProperty(_this, 'handleConvertAppointmentClose', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ convertAppointment: false }, function () {
          return window.location.reload();
        });
      }
    });
    Object.defineProperty(_this, 'handleEditAppointment', {
      enumerable: true,
      writable: true,
      value: function value(appt) {
        return _this.props.navigate('/phases/' + _this.props.phaseId + '/appointments/' + appt.id + '/edit/' + appt.kind);
      }
    });
    Object.defineProperty(_this, 'handlePrintAppointment', {
      enumerable: true,
      writable: true,
      value: function value(appt) {
        return _this.setState({
          selectedAppointment: appt, printAppointment: true
        });
      }
    });
    Object.defineProperty(_this, 'handlePrintAppointmentClose', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ printAppointment: false });
      }
    });
    Object.defineProperty(_this, 'handleEditAppointmentClose', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ editAppointment: false });
      }
    });
    Object.defineProperty(_this, 'handleDisableEditDelete', {
      enumerable: true,
      writable: true,
      value: function value(apptId, apptPhaseId, date, phaseType) {
        var apptType = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'edit';

        if (_this.isCcs() && phaseType !== 'Assessment' && apptType === 'edit' || moment_default()().isAfter(date, 'day') || apptPhaseId !== _this.props.phaseId) return true;
        var laborSheet = _this.props.laborSheets.filter(function (ls) {
          return ls.appointment;
        }).find(function (ls) {
          return ls.appointment.id === apptId;
        }) || null;
        if (laborSheet) return ['Ready for Accounting', 'Recorded'].includes(laborSheet.status);
        return false;
      }
    });
    Object.defineProperty(_this, 'phaseBlocked', {
      enumerable: true,
      writable: true,
      value: function value() {
        return ['canceled'].includes(_this.props.phaseStatus);
      }
    });
    Object.defineProperty(_this, 'ifiHiddenApptTypes', {
      enumerable: true,
      writable: true,
      value: function value() {
        if (_this.props.phaseSource !== 'IFI') return [];
        var phaseType = _this.props.phaseType;

        if (phaseType === 'Installation') return ['stack_cali_bamboo', 'deliver_stack_cali_bamboo', 'delivery', 'delivery_hold', 'bust_day'];
        if (phaseType === 'Workorder') return ['stack_cali_bamboo', 'bust_day'];
        return [];
      }
    });
    Object.defineProperty(_this, 'determineAddBtns', {
      enumerable: true,
      writable: true,
      value: function value() {
        if (_this.phaseBlocked()) return _this.renderPhaseBlocked();
        var _this$props = _this.props,
            storeSchedulable = _this$props.storeSchedulable,
            phaseSchedulable = _this$props.phaseSchedulable,
            ccsSchedulable = _this$props.ccsSchedulable,
            phaseType = _this$props.phaseType,
            imeSurface = _this$props.imeSurface;

        var blockArr = [];
        if (_this.isCcs()) {
          if (!storeSchedulable) blockArr.push('Store not CCS Schedulable');
          if (!phaseSchedulable || imeSurface) blockArr.push('Phase not CCS Schedulable');
        }
        var btns = null;
        if (!_this.isCcs() || !imeSurface && phaseType === 'Assessment') btns = _this.renderAddApptBtns(blockArr);else if (!imeSurface && ccsSchedulable) btns = _this.renderCcsAddApptBtns();else if (phaseType !== 'Assessment') btns = _this.renderCcsCannotSchedule(blockArr);
        return btns;
      }
    });
    Object.defineProperty(_this, 'determineRenderMessage', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props2 = _this.props,
            ccsSchedulable = _this$props2.ccsSchedulable,
            appointments = _this$props2.appointments;

        if (_this.isCcs() && !ccsSchedulable && appointments.length === 0) {
          return _this.renderCcsNotSchedulable();
        } else if (appointments.length === 0) return _this.renderNoAppointmentsMsg();
        return null;
      }
    });
    Object.defineProperty(_this, 'determineDisableReason', {
      enumerable: true,
      writable: true,
      value: function value(apptId, apptPhaseId, date, dateType) {
        if (apptPhaseId !== _this.props.phaseId) return 'appt. belongs to related phase';else if (moment_default()().isAfter(date, 'day')) return 'appt. ' + dateType + ' in the past';else if (_this.isCcs()) return 'user is a CCS';
        var laborSheet = _this.props.laborSheets.filter(function (ls) {
          return ls.appointment;
        }).find(function (ls) {
          return ls.appointment.id === apptId;
        }) || null;
        if (laborSheet && ['Ready for Accounting', 'Recorded'].includes(laborSheet.status)) {
          return 'labor sheet status';
        }
        return 'N/A';
      }
    });
    Object.defineProperty(_this, 'ifiApptAttrs', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props3 = _this.props,
            phaseSource = _this$props3.phaseSource,
            phaseInstallerId = _this$props3.phaseInstallerId,
            phaseEstimatorId = _this$props3.phaseEstimatorId,
            employableId = _this$props3.employableId,
            isSelfSchedulable = _this$props3.isSelfSchedulable;

        return {
          source: phaseSource,
          phase_installer_id: phaseInstallerId,
          phase_estimator_id: phaseEstimatorId,
          employable_id: employableId,
          is_self_schedulable: isSelfSchedulable
        };
      }
    });
    Object.defineProperty(_this, 'renderPhaseBlocked', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props4 = _this.props,
            phaseStatus = _this$props4.phaseStatus,
            phaseType = _this$props4.phaseType;

        var additionalInfo = '';
        if (phaseType === 'Assessment') additionalInfo = ' Please add an estimator inquiry flag to have EC reopen.';
        if (phaseType === 'Installation') additionalInfo = ' If install is active in IMS override to scheduling to add appointment.';
        return react_default.a.createElement(
          react["Fragment"],
          null,
          react_default.a.createElement(
            'div',
            { style: { color: 'red' } },
            'Unable to add appointments to a ',
            phaseStatus,
            ' phase.',
            additionalInfo
          ),
          react_default.a.createElement('br', null)
        );
      }
    });
    Object.defineProperty(_this, 'renderCcsCannotSchedule', {
      enumerable: true,
      writable: true,
      value: function value(blockArr) {
        return react_default.a.createElement(
          react["Fragment"],
          null,
          react_default.a.createElement(
            'div',
            { style: { color: 'red' } },
            'CCS cannot schedule due to: ',
            blockArr.join(', ')
          ),
          react_default.a.createElement('br', null)
        );
      }
    });
    Object.defineProperty(_this, 'renderAssignee', {
      enumerable: true,
      writable: true,
      value: function value(appt) {
        var url = '';
        var nonCrewObject = { id: appt.assignee_id };
        switch (appt.assignee_type) {
          case 'Crew':
            url = urls.crew({ installer_id: appt.installer_id });
            break;
          case 'Estimator':
            url = urls.estimator(nonCrewObject);
            break;
          case 'IQM':
            url = urls.iqm(nonCrewObject);
            break;
          default:
            url = '';
        }
        return react_default.a.createElement(
          es["c" /* Link */],
          { to: url },
          appt.assignee
        );
      }
    });
    Object.defineProperty(_this, 'renderCcsAddApptBtns', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props5 = _this.props,
            phaseType = _this$props5.phaseType,
            surfaceType = _this$props5.surfaceType,
            storeDeliveryMethod = _this$props5.storeDeliveryMethod,
            spigDelivery = _this$props5.spigDelivery;

        var delivery = Object(utils["o" /* isDeliveryPhase */])(phaseType, surfaceType, storeDeliveryMethod, spigDelivery);
        return phaseType === 'Installation' ? react_default.a.createElement(
          'div',
          null,
          react_default.a.createElement(ColoredButton["a" /* default */], {
            color: 'blue',
            className: phaseAppointments_styles_default.a.addButton,
            label: 'Add ' + (delivery ? 'Delivery & ' : '') + 'Installation/Hold',
            onClick: function onClick() {
              return _this.handleAddAppointment('installation');
            }
          })
        ) : null;
      }
    });
    Object.defineProperty(_this, 'renderAddApptBtns', {
      enumerable: true,
      writable: true,
      value: function value(blocks) {
        return Object(services["a" /* can */])(_this.props.role, 'create', 'appointment', _this.ifiApptAttrs()) ? react_default.a.createElement(
          'div',
          null,
          _this.props.phaseType !== 'Assessment' && blocks.length > 0 && _this.renderCcsCannotSchedule(blocks),
          _this.props.phaseType === 'Assessment' ? react_default.a.createElement(
            react["Fragment"],
            null,
            react_default.a.createElement(ColoredButton["a" /* default */], {
              key: 'assessment',
              color: 'blue',
              className: phaseAppointments_styles_default.a.addButton,
              label: constants["c" /* ADD_APPT_TYPE_LABELS */].assessment,
              onClick: function onClick() {
                return _this.handleAddAssessment();
              }
            }),
            react_default.a.createElement(ColoredButton["a" /* default */], {
              key: 'assessment_hold',
              color: 'blue',
              className: phaseAppointments_styles_default.a.addButton,
              label: constants["c" /* ADD_APPT_TYPE_LABELS */].assessment_hold,
              onClick: function onClick() {
                return _this.handleAddAppointment('assessment_hold');
              }
            })
          ) : react_default.a.createElement(
            react["Fragment"],
            null,
            constants["_12" /* PHASE_APPOINTMENT_TYPES */][_this.props.phaseType].filter(function (a) {
              return a !== 'installation_hold' && !_this.ifiHiddenApptTypes().includes(a);
            }).map(function (a) {
              return react_default.a.createElement(ColoredButton["a" /* default */], {
                key: a,
                color: 'blue',
                className: phaseAppointments_styles_default.a.addButton,
                label: constants["c" /* ADD_APPT_TYPE_LABELS */][a],
                onClick: function onClick() {
                  return _this.handleAddAppointment(a);
                }
              });
            })
          )
        ) : null;
      }
    });
    Object.defineProperty(_this, 'renderEditDeleteDisableTooltip', {
      enumerable: true,
      writable: true,
      value: function value(apptId, apptPhaseId, date) {
        var dateType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'start';
        return react_default.a.createElement(
          react_tooltip_dist_default.a,
          { id: (dateType === 'start' ? 'delete' : 'edit') + 'Action' + apptId, place: 'top', effect: 'solid' },
          react_default.a.createElement(
            'span',
            { className: phaseAppointmentCard_default.a.tooltipText },
            'Action disabled - ' + _this.determineDisableReason(apptId, apptPhaseId, date, dateType)
          )
        );
      }
    });
    Object.defineProperty(_this, 'renderAppointment', {
      enumerable: true,
      writable: true,
      value: function value(appt, altColor, title) {
        var _this$props6 = _this.props,
            role = _this$props6.role,
            zone = _this$props6.zone,
            _this$props6$user = _this$props6.user,
            id = _this$props6$user.id,
            name = _this$props6$user.name,
            phaseType = _this$props6.phaseType;
        var apptId = appt.id,
            startMoment = appt.start_moment,
            endMoment = appt.end_moment,
            start_date = appt.start_date,
            end_date = appt.end_date,
            apptPhaseId = appt.phase_id,
            appointment_confirmation_moment = appt.appointment_confirmation_moment,
            product_confirmation_moment = appt.product_confirmation_moment,
            pickup_moment = appt.pickup_moment,
            assignee = appt.assignee,
            user_id = appt.user_id,
            kind = appt.kind,
            scheduling_reason = appt.scheduling_reason;

        var dateStart = startMoment.format('MM/DD/YY');
        var dateEnd = end_date && end_date !== start_date ? endMoment.format('MM/DD/YY') : null;
        var timezone = zone.includes('Eastern') ? 'EST' : 'CST';
        var arrivalWindow = startMoment.format('hh:mma') + ' - ' + endMoment.format('hh:mma') + ' ' + timezone;
        var confirmation = appointment_confirmation_moment && appointment_confirmation_moment.local().format('MM/DD/YY').toString();
        var productConfirmation = product_confirmation_moment && product_confirmation_moment.local().format('MM/DD/YY').toString();
        var pickupDate = pickup_moment && pickup_moment.local().format('MM/DD/YY').toString();
        var canAttrs = role === 'iqm' ? { user_name: name, obj_name: assignee } : { user_id: id, obj_id: user_id };
        var showConvert = !_this.phaseBlocked() && !title.includes('previous') && phaseType === 'Installation' && ['installation_hold', 'delivery_hold'].includes(kind);
        var showWoConvert = !_this.phaseBlocked() && !title.includes('previous') && phaseType === 'Workorder' && ['workorder_hold'].includes(kind);
        var showAssessmentConvert = !_this.phaseBlocked() && !title.includes('previous') && phaseType === 'Assessment' && kind === 'assessment_hold';
        var editDisabled = _this.phaseBlocked() || _this.handleDisableEditDelete(apptId, apptPhaseId, endMoment, phaseType);
        var deleteDisabled = _this.phaseBlocked() || _this.handleDisableEditDelete(apptId, apptPhaseId, startMoment, phaseType, 'delete');
        return react_default.a.createElement(
          components_Card,
          { key: apptId, id: 'appointment' + apptId, className: resourceCard_default.a.resourceCard, altColor: altColor },
          react_default.a.createElement(ResourceCardElement, {
            title: 'Appointment Type',
            value: kind === 'repair_inspection' ? 'Workorder Inspection' : Object(utils["B" /* titleize */])(kind),
            size: 'medium',
            theme: phaseAppointmentCard_default.a
          }),
          react_default.a.createElement(ResourceCardElement, {
            title: 'Date',
            value: dateStart + (dateEnd ? ' - ' + dateEnd : ''),
            size: 'medium',
            theme: phaseAppointmentCard_default.a
          }),
          react_default.a.createElement(ResourceCardElement, {
            title: 'Arrival Window',
            value: arrivalWindow,
            size: 'medium',
            theme: phaseAppointmentCard_default.a
          }),
          react_default.a.createElement(ResourceCardElement, {
            title: 'Assigned To',
            value: _this.renderAssignee(appt),
            size: 'medium',
            theme: phaseAppointmentCard_default.a
          }),
          react_default.a.createElement(ResourceCardElement, {
            title: 'Scheduling Reason',
            value: scheduling_reason || 'N/A',
            size: 'medium',
            theme: phaseAppointmentCard_default.a
          }),
          react_default.a.createElement(ResourceCardElement, {
            title: 'Appt. Confirmation',
            value: confirmation || 'N/A',
            size: 'medium',
            theme: phaseAppointmentCard_default.a
          }),
          react_default.a.createElement(ResourceCardElement, {
            title: 'Product Confirmation',
            value: productConfirmation || 'N/A',
            size: 'medium',
            theme: phaseAppointmentCard_default.a
          }),
          pickupDate && react_default.a.createElement(ResourceCardElement, {
            title: 'Pickup',
            value: pickupDate,
            size: 'medium',
            theme: phaseAppointmentCard_default.a
          }),
          react_default.a.createElement(
            ResourceCardElement,
            { size: 'full' },
            kind !== 'delivery_hold' ? showConvert && react_default.a.createElement(
              react["Fragment"],
              null,
              react_default.a.createElement(
                'div',
                {
                  className: phaseAppointments_styles_default.a.editAndDeleteContainer,
                  'data-tip': true, 'data-tip-disable': !showConvert, 'data-for': 'convertInstall' + apptId
                },
                react_default.a.createElement(react_toolbox_lib["Button"], {
                  icon: 'done',
                  onClick: function onClick() {
                    return _this.handleConvertAppointment(appt);
                  },
                  className: phaseAppointments_styles_default.a.button,
                  mini: true, inverse: true, flat: true, ripple: true
                })
              )
            ) : showConvert && react_default.a.createElement(
              react["Fragment"],
              null,
              react_default.a.createElement(
                'div',
                {
                  className: phaseAppointments_styles_default.a.editAndDeleteContainer,
                  'data-tip': true, 'data-tip-disable': !showConvert, 'data-for': 'convertDelivery' + apptId
                },
                react_default.a.createElement(react_toolbox_lib["Button"], {
                  icon: 'done',
                  onClick: function onClick() {
                    return _this.handleConvertAppointment(appt);
                  },
                  className: phaseAppointments_styles_default.a.button,
                  mini: true, inverse: true, flat: true, ripple: true
                })
              )
            ),
            showWoConvert && react_default.a.createElement(
              'div',
              {
                className: phaseAppointments_styles_default.a.editAndDeleteContainer,
                'data-tip': true, 'data-tip-disable': !showWoConvert, 'data-for': 'convertWoConvert' + apptId
              },
              react_default.a.createElement(react_toolbox_lib["Button"], {
                icon: 'done',
                onClick: function onClick() {
                  return _this.handleConvertAppointment(appt);
                },
                className: phaseAppointments_styles_default.a.button,
                mini: true, inverse: true, flat: true, ripple: true
              })
            ),
            react_default.a.createElement(
              react_tooltip_dist_default.a,
              { id: 'convertInstall' + apptId, place: 'top', effect: 'solid' },
              react_default.a.createElement(
                'span',
                { className: phaseAppointmentCard_default.a.tooltipText },
                'Confirm Installation'
              )
            ),
            react_default.a.createElement(
              react_tooltip_dist_default.a,
              { id: 'convertDelivery' + apptId, place: 'top', effect: 'solid' },
              react_default.a.createElement(
                'span',
                { className: phaseAppointmentCard_default.a.tooltipText },
                'Confirm Delivery'
              )
            ),
            react_default.a.createElement(
              react_tooltip_dist_default.a,
              { id: 'convertWoConvert' + apptId, place: 'top', effect: 'solid' },
              react_default.a.createElement(
                'span',
                { className: phaseAppointmentCard_default.a.tooltipText },
                'Confirm Workorder'
              )
            ),
            showAssessmentConvert && react_default.a.createElement(
              'div',
              {
                className: phaseAppointments_styles_default.a.editAndDeleteContainer,
                'data-tip': true, 'data-tip-disable': !showAssessmentConvert, 'data-for': 'convertAssessment' + apptId
              },
              react_default.a.createElement(react_toolbox_lib["Button"], {
                icon: 'done',
                onClick: function onClick() {
                  return _this.handleConvertAppointment(appt);
                },
                className: phaseAppointments_styles_default.a.button,
                mini: true, inverse: true, flat: true, ripple: true
              })
            ),
            react_default.a.createElement(
              react_tooltip_dist_default.a,
              { id: 'convertAssessment' + apptId, place: 'top', effect: 'solid' },
              react_default.a.createElement(
                'span',
                { className: phaseAppointmentCard_default.a.tooltipText },
                'Confirm Assessment'
              )
            ),
            _this.can('delete', canAttrs) && _this.canEditApptType(kind) && react_default.a.createElement(
              'div',
              {
                className: phaseAppointments_styles_default.a.editAndDeleteContainer,
                'data-tip': true, 'data-tip-disable': !deleteDisabled, 'data-for': 'deleteAction' + apptId
              },
              react_default.a.createElement(react_toolbox_lib["Button"], {
                icon: 'delete',
                onClick: function onClick() {
                  return _this.handleDeleteAppointment(appt);
                },
                className: phaseAppointments_styles_default.a.button + ' ' + phaseAppointments_styles_default.a.tooltipBtn,
                mini: true, inverse: true, flat: true, ripple: true,
                disabled: deleteDisabled
              })
            ),
            _this.can('update', canAttrs) && _this.canEditApptType(kind) && react_default.a.createElement(
              'div',
              {
                className: phaseAppointments_styles_default.a.editAndDeleteContainer,
                'data-tip': true, 'data-tip-disable': !editDisabled, 'data-for': 'editAction' + apptId
              },
              react_default.a.createElement(react_toolbox_lib["Button"], {
                icon: 'mode_edit',
                onClick: function onClick() {
                  return _this.handleEditAppointment(appt);
                },
                className: phaseAppointments_styles_default.a.button + ' ' + phaseAppointments_styles_default.a.tooltipBtn,
                mini: true, inverse: true, flat: true, ripple: true,
                disabled: editDisabled
              })
            ),
            _this.renderEditDeleteDisableTooltip(apptId, apptPhaseId, endMoment, 'end'),
            _this.renderEditDeleteDisableTooltip(apptId, apptPhaseId, startMoment),
            react_default.a.createElement(react_toolbox_lib["Button"], {
              icon: 'print',
              onClick: function onClick() {
                return _this.handlePrintAppointment(appt);
              },
              className: phaseAppointments_styles_default.a.button,
              mini: true, inverse: true, flat: true, ripple: true
            })
          )
        );
      }
    });
    Object.defineProperty(_this, 'renderAppointmentList', {
      enumerable: true,
      writable: true,
      value: function value(title, appointments) {
        return react_default.a.createElement(
          components_Card,
          {
            className: phaseAppointmentCard_default.a.phaseAppointmentCard__container
          },
          react_default.a.createElement(
            'section',
            { className: phaseAppointmentCard_default.a.phaseAppointmentCard },
            react_default.a.createElement(
              'div',
              { className: phaseAppointmentCard_default.a.phaseAppointmentCard__title },
              react_default.a.createElement(
                'span',
                null,
                title
              )
            ),
            react_default.a.createElement(
              'div',
              { className: phaseAppointmentCard_default.a.phaseAppointmentCard__content },
              appointments.map(function (appt, i) {
                return _this.renderAppointment(appt, i % 2 !== 0, title);
              })
            )
          )
        );
      }
    });
    Object.defineProperty(_this, 'renderNoAppointmentsMsg', {
      enumerable: true,
      writable: true,
      value: function value() {
        return react_default.a.createElement(
          components_Card,
          { className: phaseAppointments_styles_default.a.msgCard },
          react_default.a.createElement(
            'h4',
            null,
            'Use the button(s) above to add appointments'
          )
        );
      }
    });
    Object.defineProperty(_this, 'renderCcsNotSchedulable', {
      enumerable: true,
      writable: true,
      value: function value() {
        return react_default.a.createElement(
          components_Card,
          { className: phaseAppointments_styles_default.a.msgCard },
          react_default.a.createElement(
            'h4',
            null,
            'Unable to add appointment(s) for this phase'
          )
        );
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props7 = _this.props,
            phaseId = _this$props7.phaseId,
            phaseSource = _this$props7.phaseSource,
            appointments = _this$props7.appointments,
            role = _this$props7.role,
            workroom = _this$props7.workroom;
        var _this$state = _this.state,
            selectedAppointment = _this$state.selectedAppointment,
            deleteAppointment = _this$state.deleteAppointment,
            convertAppointment = _this$state.convertAppointment,
            printAppointment = _this$state.printAppointment;

        var _this$sortAppointment = _this.sortAppointments(appointments),
            scheduled = _this$sortAppointment.scheduled,
            completed = _this$sortAppointment.completed;

        var scheduledAppointments = _this.renderAppointmentList('scheduled', scheduled);
        var completedAppointments = _this.renderAppointmentList('previous appointments', completed);
        return react_default.a.createElement(
          'section',
          null,
          _this.determineAddBtns(),
          _this.determineRenderMessage(),
          scheduled.length > 0 && scheduledAppointments,
          completed.length > 0 && completedAppointments,
          react_default.a.createElement(convertAppointmentModal, {
            phaseId: phaseId,
            appointment: selectedAppointment,
            active: convertAppointment,
            onClose: _this.handleConvertAppointmentClose
          }),
          react_default.a.createElement(deleteAppointmentModal, {
            appointment: selectedAppointment,
            active: deleteAppointment,
            onClose: _this.handleDeleteAppointmentClose,
            phaseSource: phaseSource,
            phaseWorkroom: workroom
          }),
          react_default.a.createElement(printInstallerPaperworkModal, {
            appointment: selectedAppointment,
            active: printAppointment,
            onClose: _this.handlePrintAppointmentClose,
            role: role
          })
        );
      }
    });

    _this.state = {
      loading: false,
      errors: {},
      deleteAppointment: false,
      convertAppointment: false,
      editAppointment: false,
      printAppointment: false
    };
    return _this;
  }

  return PhaseAppointments;
}(react["Component"]);

phaseAppointments_PhaseAppointments.propTypes = {
  phaseId: prop_types_default.a.number.isRequired,
  phaseType: prop_types_default.a.string,
  phaseStatus: prop_types_default.a.string,
  phaseSource: prop_types_default.a.string,
  phaseInstallerId: prop_types_default.a.number,
  phaseEstimatorId: prop_types_default.a.number,
  employableId: prop_types_default.a.number,
  isSelfSchedulable: prop_types_default.a.bool,
  surfaceType: prop_types_default.a.string,
  workroom: prop_types_default.a.string,
  zone: prop_types_default.a.string,
  ccsSchedulable: prop_types_default.a.bool.isRequired,
  storeSchedulable: prop_types_default.a.bool,
  phaseSchedulable: prop_types_default.a.bool,
  appointments: prop_types_default.a.arrayOf(AppointmentType).isRequired,
  role: prop_types_default.a.string.isRequired,
  requestPhaseAppointments: prop_types_default.a.func.isRequired,
  navigate: prop_types_default.a.func.isRequired,
  position: prop_types_default.a.string,
  user: RoleType,
  laborSheets: prop_types_default.a.array,
  storeDeliveryMethod: prop_types_default.a.string,
  spigDelivery: prop_types_default.a.bool,
  imeSurface: prop_types_default.a.bool
};

var phaseAppointments_mapStateToProps = function mapStateToProps(state) {
  var _state$phase = state.phase,
      _state$phase$details = _state$phase.details,
      id = _state$phase$details.id,
      type = _state$phase$details.type,
      phaseSchedulable = _state$phase$details.ccs_schedulable,
      status = _state$phase$details.status,
      source = _state$phase$details.source,
      phaseInstallerId = _state$phase$details.installer_id,
      phaseEstimatorId = _state$phase$details.estimator_id,
      _state$phase$details$ = _state$phase$details.workroom,
      name = _state$phase$details$.name,
      timezone = _state$phase$details$.timezone,
      surfaceType = _state$phase$details.surface_type.name,
      _state$phase$details$2 = _state$phase$details.store,
      delivery_method = _state$phase$details$2.delivery_method,
      storeSchedulable = _state$phase$details$2.ccs_schedulable,
      spigDelivery = _state$phase$details.spig_delivery,
      _state$phase$laborShe = _state$phase.laborSheets,
      laborSheets = _state$phase$laborShe === undefined ? {} : _state$phase$laborShe,
      _state$user = state.user,
      role = _state$user.role,
      position = _state$user.position,
      employableId = _state$user.employable_id,
      isSelfSchedulable = _state$user.is_self_schedulable,
      user = state.user;

  var imeSurface = surfaceType === 'Pro Direct';
  return {
    phaseId: id,
    phaseType: type,
    phaseStatus: status,
    phaseSource: source,
    phaseInstallerId: phaseInstallerId,
    phaseEstimatorId: phaseEstimatorId,
    employableId: employableId,
    isSelfSchedulable: !!isSelfSchedulable,
    surfaceType: surfaceType,
    storeDeliveryMethod: delivery_method,
    ccsSchedulable: storeSchedulable && phaseSchedulable,
    storeSchedulable: storeSchedulable,
    phaseSchedulable: phaseSchedulable,
    imeSurface: imeSurface,
    spigDelivery: spigDelivery,
    workroom: name,
    zone: timezone,
    appointments: sortPhaseAppointments(state),
    position: position,
    role: role,
    user: user,
    laborSheets: laborSheets.items || []
  };
};

/* harmony default export */ var phaseAppointments = (Object(react_redux_es["connect"])(phaseAppointments_mapStateToProps, { navigate: actionCreators["O" /* navigate */], requestPhaseAppointments: actionCreators["_15" /* requestPhaseAppointments */] })(phaseAppointments_PhaseAppointments));
// EXTERNAL MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseContractVerification/styles.scss
var phaseContractVerification_styles = __webpack_require__("TAhH");
var phaseContractVerification_styles_default = /*#__PURE__*/__webpack_require__.n(phaseContractVerification_styles);

// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseContractVerification/index.jsx






var phaseContractVerification_ContractVerification = function ContractVerification(_ref) {
  var params = _ref.params;
  return react_default.a.createElement(
    'div',
    { className: phaseContractVerification_styles_default.a.container },
    react_default.a.createElement(components_assessmentSelection, null),
    react_default.a.createElement(phaseAccounting, { phaseId: params.id })
  );
};

phaseContractVerification_ContractVerification.propTypes = {
  params: prop_types_default.a.shape({ id: prop_types_default.a.string })
};

/* harmony default export */ var phaseContractVerification = (phaseContractVerification_ContractVerification);
// EXTERNAL MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/warehouseMaterials/components/styles.scss
var warehouseMaterials_components_styles = __webpack_require__("IWhS");
var warehouseMaterials_components_styles_default = /*#__PURE__*/__webpack_require__.n(warehouseMaterials_components_styles);

// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/warehouseMaterials/components/warehousePadTableRow.jsx
var warehousePadTableRow__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var warehousePadTableRow__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function warehousePadTableRow__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function warehousePadTableRow__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function warehousePadTableRow__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var warehousePadTableRow_WarehousePadTableRow = function (_Component) {
  warehousePadTableRow__inherits(WarehousePadTableRow, _Component);

  warehousePadTableRow__createClass(WarehousePadTableRow, null, [{
    key: 'parseNetQuantity',
    value: function parseNetQuantity(value) {
      if (value === '' || value === null || value === undefined) return null;
      var trimmed = String(value).trim();
      if (!/^[-+]?\d+(\.\d+)?$/.test(trimmed)) return null;
      var parsed = parseFloat(trimmed);
      return Number.isNaN(parsed) ? null : parsed;
    }
  }]);

  function WarehousePadTableRow(props) {
    warehousePadTableRow__classCallCheck(this, WarehousePadTableRow);

    var _this = warehousePadTableRow__possibleConstructorReturn(this, (WarehousePadTableRow.__proto__ || Object.getPrototypeOf(WarehousePadTableRow)).call(this));

    warehousePadTableRow__initialiseProps.call(_this);

    var netQuantity = props.lineItem.net_quantity;

    _this.state = {
      netQuantity: WarehousePadTableRow.parseNetQuantity(netQuantity)
    };
    _this.rowRef = react_default.a.createRef();
    return _this;
  }

  warehousePadTableRow__createClass(WarehousePadTableRow, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          lineItem = _props.lineItem,
          readOnly = _props.readOnly;

      var cutQuantityValue = Object(lineItemUtils["d" /* cutQuantityString */])(lineItem.warehouse_quantity);
      var lineItemWithCutQuantity = warehousePadTableRow__extends({}, lineItem, { cut_quantity: cutQuantityValue });

      return react_default.a.createElement(
        editableTableRow,
        {
          ref: this.rowRef,
          key: lineItem.id,
          id: lineItem.id,
          onSave: !readOnly ? this.handleSave : undefined
        },
        react_default.a.createElement(components_LineItemTable_itemEvents, {
          display: !this.context.isEditable,
          label: '',
          itemType: 'phaseLineItems',
          lineItem: lineItemWithCutQuantity,
          dataKeys: ['po_number', 'net_quantity', 'cut_quantity', 'total', 'status']
        }),
        react_default.a.createElement(editableTableCell, { label: 'Item #', value: lineItem.item_number || '', cellReadOnly: true }),
        react_default.a.createElement(editableTableCell, { label: 'Item Name', value: lineItem.description || '', cellReadOnly: true }),
        this.renderNetQuantity(),
        react_default.a.createElement(
          editableTableCell,
          { label: 'Cut Quantity', value: cutQuantityValue },
          this.renderCutQuantity()
        ),
        react_default.a.createElement(
          editableTableCell,
          { label: 'Status', value: lineItem.warehouse_status || '', className: table_default.a.largeColumn },
          this.renderStatus()
        )
      );
    }
  }]);

  return WarehousePadTableRow;
}(react["Component"]);

Object.defineProperty(warehousePadTableRow_WarehousePadTableRow, 'NET_QUANTITY_MISSING_MESSAGE', {
  enumerable: true,
  writable: true,
  value: 'Net square footage missing.'
});

var warehousePadTableRow__initialiseProps = function _initialiseProps() {
  var _this2 = this;

  Object.defineProperty(this, 'handleWarehouseStatus', {
    enumerable: true,
    writable: true,
    value: function value(lineItem) {
      var submitObject = {
        warehouse_status: lineItem.status,
        id: _this2.props.lineItem.id
      };
      _this2.props.onSave(submitObject);
    }
  });
  Object.defineProperty(this, 'updateNetQuantityAndMarkDirty', {
    enumerable: true,
    writable: true,
    value: function value(netQuantity) {
      var row = _this2.rowRef.current;
      if (row && typeof row.setDirtyState === 'function') {
        row.setDirtyState(true);
      }
      _this2.setState({ netQuantity: netQuantity });
    }
  });
  Object.defineProperty(this, 'handleIncreaseNetQuantity', {
    enumerable: true,
    writable: true,
    value: function value() {
      var netQuantity = (_this2.state.netQuantity || 0) + 1;
      _this2.updateNetQuantityAndMarkDirty(netQuantity);
    }
  });
  Object.defineProperty(this, 'handleDecreaseNetQuantity', {
    enumerable: true,
    writable: true,
    value: function value() {
      var netQuantity = (_this2.state.netQuantity || 0) - 1;
      _this2.updateNetQuantityAndMarkDirty(netQuantity);
    }
  });
  Object.defineProperty(this, 'handleNetQuantityInputChange', {
    enumerable: true,
    writable: true,
    value: function value(event) {
      var value = event.target.value;

      var netQuantity = warehousePadTableRow_WarehousePadTableRow.parseNetQuantity(value);
      _this2.updateNetQuantityAndMarkDirty(netQuantity);
    }
  });
  Object.defineProperty(this, 'handleSave', {
    enumerable: true,
    writable: true,
    value: function value() {
      var lineItem = _this2.props.lineItem;

      _this2.props.onSave({
        id: lineItem.id,
        net_quantity: _this2.state.netQuantity
      });
    }
  });
  Object.defineProperty(this, 'renderStatus', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _props2 = _this2.props,
          lineItem = _props2.lineItem,
          readOnly = _props2.readOnly;

      if (readOnly) {
        return lineItem.warehouse_status || '';
      }
      return react_default.a.createElement(lineItemStatus, {
        onChange: _this2.handleWarehouseStatus,
        lineItem: { status: lineItem.warehouse_status },
        options: ['Not Cut', 'Cut', 'Released']
      });
    }
  });
  Object.defineProperty(this, 'renderNetQuantity', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _props3 = _this2.props,
          lineItem = _props3.lineItem,
          readOnly = _props3.readOnly;

      if (readOnly) {
        return react_default.a.createElement(editableTableCell, {
          label: 'Net Quantity',
          value: _this2.state.netQuantity === null ? warehousePadTableRow_WarehousePadTableRow.NET_QUANTITY_MISSING_MESSAGE : _this2.state.netQuantity
        });
      }
      var lineItemWithState = warehousePadTableRow__extends({}, lineItem, {
        net_quantity: _this2.state.netQuantity
      });
      return react_default.a.createElement(inputCell, {
        key: 'net-quantity-' + lineItem.id,
        attr: 'net_quantity',
        label: 'Net Quantity',
        lineItem: lineItemWithState,
        onChange: _this2.handleNetQuantityInputChange,
        cellValue: _this2.state.netQuantity === null ? '' : _this2.state.netQuantity,
        type: 'number'
      });
    }
  });
  Object.defineProperty(this, 'renderCutQuantity', {
    enumerable: true,
    writable: true,
    value: function value() {
      var lineItem = _this2.props.lineItem;

      var cutQuantityValue = Object(lineItemUtils["d" /* cutQuantityString */])(lineItem.warehouse_quantity);
      return react_default.a.createElement(
        'div',
        { className: warehouseMaterials_components_styles_default.a.cutQuantityContainer },
        cutQuantityValue,
        react_default.a.createElement(
          'div',
          { className: warehouseMaterials_components_styles_default.a.cutQuantityActions },
          react_default.a.createElement(lib_button["Button"], {
            theme: warehouseMaterials_components_styles_default.a,
            icon: 'arrow_upward',
            floating: true,
            ripple: true,
            primary: true,
            onClick: function onClick(e) {
              e.stopPropagation();
              _this2.handleIncreaseNetQuantity();
            }
          }),
          react_default.a.createElement(lib_button["Button"], {
            theme: warehouseMaterials_components_styles_default.a,
            icon: 'arrow_downward',
            floating: true,
            ripple: true,
            primary: true,
            onClick: function onClick(e) {
              e.stopPropagation();
              _this2.handleDecreaseNetQuantity();
            }
          })
        )
      );
    }
  });
};

warehousePadTableRow_WarehousePadTableRow.contextTypes = {
  onChange: prop_types_default.a.func,
  isEditable: prop_types_default.a.bool
};

warehousePadTableRow_WarehousePadTableRow.propTypes = {
  lineItem: prop_types_default.a.shape(lineItemPropType),
  onSave: prop_types_default.a.func,
  readOnly: prop_types_default.a.bool
};

/* harmony default export */ var warehousePadTableRow = (warehousePadTableRow_WarehousePadTableRow);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/warehouseMaterials/components/warehousePadTable.jsx








var warehousePadTable_WarehousePadTable = function WarehousePadTable(_ref) {
  var lineItems = _ref.lineItems,
      editable = _ref.editable,
      handleSave = _ref.handleSave;

  var hasData = (lineItems || []).length > 0;
  return react_default.a.createElement(
    components_LineItemTable,
    { title: 'Warehouse Pads', readOnly: !hasData },
    hasData && lineItems.map(function (item) {
      return react_default.a.createElement(warehousePadTableRow, {
        key: item.id,
        onSave: handleSave,
        lineItem: item,
        readOnly: !editable
      });
    })
  );
};

warehousePadTable_WarehousePadTable.defaultProps = {
  lineItems: []
};

warehousePadTable_WarehousePadTable.propTypes = {
  phaseId: prop_types_default.a.string,
  lineItems: prop_types_default.a.arrayOf(prop_types_default.a.shape(lineItemPropType)),
  savePhaseItem: prop_types_default.a.func,
  handleSave: prop_types_default.a.func,
  editable: prop_types_default.a.bool.isRequired
};

/* harmony default export */ var warehousePadTable = (Object(react_redux_es["connect"])(null, {
  savePhaseItem: phase_items["k" /* savePhaseItem */]
})(warehousePadTable_WarehousePadTable));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/warehouseMaterials/components/levelerInputCell.jsx




// import { error as parseError } from '../../../utils';



var levelerInputCell_LevelerInputCell = function LevelerInputCell(_ref) {
  var levelerItems = _ref.levelerItems,
      attr = _ref.attr,
      label = _ref.label,
      onChange = _ref.onChange,
      cellValue = _ref.cellValue,
      type = _ref.type,
      className = _ref.className,
      cellReadOnly = _ref.cellReadOnly;

  var value = levelerItems[attr];
  var error = levelerItems.errors && levelerItems.errors[attr];
  var cellVal = value === null || cellValue === null ? '' : cellValue || value;
  var cellProps = { label: label, onChange: onChange, error: error, value: cellVal, cellReadOnly: cellReadOnly };
  return react_default.a.createElement(
    editableTableCell,
    cellProps,
    react_default.a.createElement('input', {
      type: type,
      value: value === null ? '' : value,
      className: classnames_default()(input_default.a.inputElement, table_default.a.input, className)
    })
  );
};

levelerInputCell_LevelerInputCell.defaultProps = {
  cellValue: '',
  display: true,
  type: 'text',
  className: '',
  cellReadOnly: false
};

levelerInputCell_LevelerInputCell.propTypes = {
  levelerItems: prop_types_default.a.object.isRequired,
  display: prop_types_default.a.bool,
  attr: prop_types_default.a.string.isRequired,
  label: prop_types_default.a.string.isRequired,
  onChange: prop_types_default.a.func.isRequired,
  cellValue: prop_types_default.a.node,
  type: prop_types_default.a.string,
  className: prop_types_default.a.string,
  cellReadOnly: prop_types_default.a.bool
};

/* harmony default export */ var levelerInputCell = (levelerInputCell_LevelerInputCell);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/warehouseMaterials/components/levelerTableRow.jsx
var levelerTableRow__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function levelerTableRow__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function levelerTableRow__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function levelerTableRow__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var levelerTableRow_LevelerTableRow = function (_Editable) {
  levelerTableRow__inherits(LevelerTableRow, _Editable);

  function LevelerTableRow() {
    var _ref;

    var _temp, _this, _ret;

    levelerTableRow__classCallCheck(this, LevelerTableRow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = levelerTableRow__possibleConstructorReturn(this, (_ref = LevelerTableRow.__proto__ || Object.getPrototypeOf(LevelerTableRow)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'state', {
      enumerable: true,
      writable: true,
      value: levelerTableRow__extends({}, _this.props.levelerItem)
    }), Object.defineProperty(_this, 'bagSizeOptions', {
      enumerable: true,
      writable: true,
      value: [{ value: '25', label: '25LB' }, { value: '50', label: '50LB' }]
    }), Object.defineProperty(_this, 'handleQuantityChange', {
      enumerable: true,
      writable: true,
      value: function value(option) {
        return _this.setState({ quantity: option });
      }
    }), Object.defineProperty(_this, 'handleBagSizeChange', {
      enumerable: true,
      writable: true,
      value: function value(option) {
        return _this.setState({ bag_size: option.value });
      }
    }), Object.defineProperty(_this, 'handleSave', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.onSave(_this.state);
      }
    }), Object.defineProperty(_this, 'renderLevelersCell', {
      enumerable: true,
      writable: true,
      value: function value(label) {
        var _this$state$bag_size = _this.state.bag_size,
            bag_size = _this$state$bag_size === undefined ? null : _this$state$bag_size;

        var displayOption = bag_size ? _this.bagSizeOptions.find(function (o) {
          return o.value === bag_size;
        }) : '';
        return react_default.a.createElement(
          editableTableCell,
          {
            label: label,
            value: typeof displayOption === 'string' ? displayOption : displayOption.label,
            onChange: function onChange(value) {
              return _this.handleBagSizeChange(value);
            }
          },
          react_default.a.createElement(react_select, {
            name: 'Levelers',
            className: ReactSelect_styles_default.a.levelerSelectWrapper,
            value: _this.state.bag_size,
            options: _this.bagSizeOptions,
            placeholder: 'Select size'
          })
        );
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var levelerItem = _this.state;
        var rowProps = { isNew: levelerItem.id < 0,
          onSave: _this.handleSave,
          onDelete: _this.showDeleteDialog };
        return react_default.a.createElement(
          editableTableRow,
          levelerTableRow__extends({ key: levelerItem.id, id: levelerItem.id }, rowProps),
          react_default.a.createElement(components_LineItemTable_itemEvents, {
            display: !_this.context.isEditable,
            label: '',
            itemType: 'levelers',
            dataKeys: ['bag_size', 'quantity'],
            levelerItem: levelerItem,
            levelerEvents: true
          }),
          _this.renderLevelersCell('Bag size'),
          react_default.a.createElement(levelerInputCell, {
            attr: 'quantity',
            label: 'Quantity',
            levelerItems: _this.state,
            className: ReactSelect_styles_default.a.levelerSelectWrapper,
            placeholder: 'Select size',
            cellValue: _this.state.quantity || '',
            onChange: function onChange(event) {
              return _this.handleQuantityChange(event.target.value);
            }
          })
        );
      }
    }), _temp), levelerTableRow__possibleConstructorReturn(_this, _ret);
  }

  return LevelerTableRow;
}(mixins_editable(react_default.a.Component));

levelerTableRow_LevelerTableRow.contextTypes = { isEditable: prop_types_default.a.bool };

levelerTableRow_LevelerTableRow.propTypes = {
  levelerItem: prop_types_default.a.object.isRequired,
  onSave: prop_types_default.a.func,
  onDelete: prop_types_default.a.func,
  readOnly: prop_types_default.a.bool
};

levelerTableRow_LevelerTableRow.defaultProps = { levelerItem: {} };

/* harmony default export */ var levelerTableRow = (levelerTableRow_LevelerTableRow);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/warehouseMaterials/components/levelerTable.jsx
function levelerTable__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function levelerTable__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function levelerTable__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var ITEM_TYPE = 'leveler';

var levelerTable_LevelerTable = function (_Component) {
  levelerTable__inherits(LevelerTable, _Component);

  function LevelerTable() {
    var _ref;

    var _temp, _this, _ret;

    levelerTable__classCallCheck(this, LevelerTable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = levelerTable__possibleConstructorReturn(this, (_ref = LevelerTable.__proto__ || Object.getPrototypeOf(LevelerTable)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'handleSave', {
      enumerable: true,
      writable: true,
      value: function value(item) {
        _this.props.savePhaseLevelerItem(_this.props.phaseId, item, ITEM_TYPE);
      }
    }), Object.defineProperty(_this, 'refreshLevelerTable', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.requestPhaseLevelerItems(_this.props.phaseId, ITEM_TYPE);
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var levelerItems = _this.props.levelerItems;

        return react_default.a.createElement(
          components_LineItemTable,
          {
            title: 'Leveler',
            refreshList: _this.refreshLevelerTable,
            readOnly: !_this.props.editable,
            cv: _this.props.cv
          },
          levelerItems.map(function (item) {
            return react_default.a.createElement(levelerTableRow, {
              onSave: _this.handleSave,
              key: item.id,
              readOnly: !_this.props.editable,
              levelerItem: item
            });
          })
        );
      }
    }), _temp), levelerTable__possibleConstructorReturn(_this, _ret);
  }

  return LevelerTable;
}(react["Component"]);

levelerTable_LevelerTable.defaultProps = {
  levelerItems: [], editable: true, cv: false
};

levelerTable_LevelerTable.propTypes = {
  phaseId: prop_types_default.a.string,
  requestPhaseLevelerItems: prop_types_default.a.func,
  savePhaseLevelerItem: prop_types_default.a.func,
  editable: prop_types_default.a.bool.isRequired,
  levelerItems: prop_types_default.a.array.isRequired,
  cv: prop_types_default.a.bool
};

var levelerTable_mapStateToProps = function mapStateToProps(state) {
  return {
    levelerItems: state.phase.levelers.items.data
  };
};

/* harmony default export */ var levelerTable = (Object(react_redux_es["connect"])(levelerTable_mapStateToProps, {
  savePhaseLevelerItem: phase_items["l" /* savePhaseLevelerItem */],
  requestPhaseLevelerItems: phase_items["j" /* requestPhaseLevelerItems */]
})(levelerTable_LevelerTable));
// EXTERNAL MODULE: ./client/app/shared/components/LineItemTable/components/receiveReleaseAll.scss
var receiveReleaseAll = __webpack_require__("CCP7");
var receiveReleaseAll_default = /*#__PURE__*/__webpack_require__.n(receiveReleaseAll);

// CONCATENATED MODULE: ./client/app/shared/components/LineItemTable/components/receiveReleaseAll.jsx
var receiveReleaseAll__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function receiveReleaseAll__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function receiveReleaseAll__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function receiveReleaseAll__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var WAREHOUSE_MERCH_ITEM_TYPE = 'warehouseMerchandiseItems';
var WAREHOUSE_PADS_ITEM_TYPE = 'phaseLineItems';

var receiveReleaseAll_ReceiveReleaseAll = function (_Component) {
  receiveReleaseAll__inherits(ReceiveReleaseAll, _Component);

  function ReceiveReleaseAll(props) {
    receiveReleaseAll__classCallCheck(this, ReceiveReleaseAll);

    var _this = receiveReleaseAll__possibleConstructorReturn(this, (ReceiveReleaseAll.__proto__ || Object.getPrototypeOf(ReceiveReleaseAll)).call(this, props));

    Object.defineProperty(_this, 'toggleModalActive', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.setState({ modalActive: !_this.state.modalActive });
      }
    });
    Object.defineProperty(_this, 'handleReceiveRelease', {
      enumerable: true,
      writable: true,
      value: function value(action) {
        if (action === 'receive') {
          _this.setState({ modalActive: true,
            title: 'Receive All',
            status: 'In Warehouse'
          });
        } else {
          _this.setState({ modalActive: true,
            title: 'Release All',
            status: 'Released'
          });
        }
      }
    });
    Object.defineProperty(_this, 'handleConfirm', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            warehouseMerch = _this$props.warehouseMerch,
            warehousePads = _this$props.warehousePads,
            phaseId = _this$props.phaseId;
        var title = _this.state.title;


        if (title === 'Receive All') {
          _this.receiveMerch(warehouseMerch, phaseId);
        } else if (title === 'Release All') {
          _this.releaseWarehouseMerch(warehouseMerch, phaseId);
          _this.releaseWarehousePads(warehousePads, phaseId);
        }
        _this.toggleModalActive();
      }
    });
    Object.defineProperty(_this, 'receiveMerch', {
      enumerable: true,
      writable: true,
      value: function value(merch, phaseId) {
        if (merch.length > 1) {
          merch.forEach(function (item) {
            if (item.id > 0) {
              var lineItem = item;
              lineItem.status = _this.state.status;
              _this.props.savePhaseItem(phaseId, lineItem, WAREHOUSE_MERCH_ITEM_TYPE);
            }
          });
        }
      }
    });
    Object.defineProperty(_this, 'releaseWarehouseMerch', {
      enumerable: true,
      writable: true,
      value: function value(merch, phaseId) {
        if (merch.length > 0) {
          merch.forEach(function (item) {
            if (item.id > 0) {
              var lineItem = item;
              lineItem.status = _this.state.status;
              _this.props.savePhaseItem(phaseId, lineItem, WAREHOUSE_MERCH_ITEM_TYPE);
            }
          });
        }
      }
    });
    Object.defineProperty(_this, 'releaseWarehousePads', {
      enumerable: true,
      writable: true,
      value: function value(pads, phaseId) {
        if (pads.length > 0) {
          pads.forEach(function (pad) {
            var lineItem = pad;
            lineItem.warehouse_status = _this.state.status;
            _this.props.savePhaseItem(phaseId, lineItem, WAREHOUSE_PADS_ITEM_TYPE);
          });
        }
      }
    });


    _this.state = {
      modalActive: false,
      title: '',
      status: ''
    };
    return _this;
  }

  receiveReleaseAll__createClass(ReceiveReleaseAll, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          modalActive = _state.modalActive,
          status = _state.status;


      return react_default.a.createElement(
        'div',
        { className: receiveReleaseAll_default.a.container },
        react_default.a.createElement(ColoredButton["a" /* default */], {
          color: 'green',
          label: 'Receive All',
          className: receiveReleaseAll_default.a.receive,
          onClick: function onClick() {
            return _this2.handleReceiveRelease('receive');
          }
        }),
        react_default.a.createElement(ColoredButton["a" /* default */], {
          color: 'yellow',
          label: 'Release All',
          className: receiveReleaseAll_default.a.release,
          onClick: function onClick() {
            return _this2.handleReceiveRelease('release');
          }
        }),
        modalActive && react_default.a.createElement(ConfirmDialog["a" /* default */], {
          title: 'Mark all items as \'' + status + '\'?',
          okLabel: 'Yes',
          cancelLabel: 'Cancel',
          cancel: this.toggleModalActive,
          dismiss: this.toggleModalActive,
          proceed: this.handleConfirm
        })
      );
    }
  }]);

  return ReceiveReleaseAll;
}(react["Component"]);

receiveReleaseAll_ReceiveReleaseAll.propTypes = {
  warehouseMerch: prop_types_default.a.array,
  warehousePads: prop_types_default.a.array,
  savePhaseItem: prop_types_default.a.func,
  phaseId: prop_types_default.a.number
};

/* harmony default export */ var components_receiveReleaseAll = (Object(react_redux_es["connect"])(null, { savePhaseItem: phase_items["k" /* savePhaseItem */] })(receiveReleaseAll_ReceiveReleaseAll));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/warehouseMaterials/index.jsx
function warehouseMaterials__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function warehouseMaterials__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function warehouseMaterials__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var warehouseMaterials_WarehouseMaterials = function (_Component) {
  warehouseMaterials__inherits(WarehouseMaterials, _Component);

  function WarehouseMaterials() {
    var _ref;

    var _temp, _this, _ret;

    warehouseMaterials__classCallCheck(this, WarehouseMaterials);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = warehouseMaterials__possibleConstructorReturn(this, (_ref = WarehouseMaterials.__proto__ || Object.getPrototypeOf(WarehouseMaterials)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'state', {
      enumerable: true,
      writable: true,
      value: {
        pads: []
      }
    }), Object.defineProperty(_this, 'componentWillMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.props.requestPhaseItems(_this.props.params.id, 'phaseLineItems');
        _this.props.requestPhaseItems(_this.props.params.id, 'warehouseMerchandiseItems');
        _this.props.requestPhaseLevelerItems(_this.props.params.id, 'levelers');
        _this.setState({ pads: _this.parsePads(_this.props.lineItemsWarehousePads) });
      }
    }), Object.defineProperty(_this, 'componentDidUpdate', {
      enumerable: true,
      writable: true,
      value: function value(prevProps) {
        if (!Object(lodash["isEqual"])(prevProps.lineItemsWarehousePads, _this.props.lineItemsWarehousePads)) {
          // shutup eslint. I know what I'm doing, I think...
          // eslint-disable-next-line react/no-did-update-set-state
          _this.setState({ pads: _this.parsePads(_this.props.lineItemsWarehousePads) });
        }
      }
    }), Object.defineProperty(_this, 'parsePads', {
      enumerable: true,
      writable: true,
      value: function value(lineItemsPad) {
        return lineItemsPad.map(function (lineItem) {
          return {
            cut_quantity: Object(lineItemUtils["d" /* cutQuantityString */])(lineItem.warehouse_quantity),
            description: lineItem.description
          };
        });
      }
    }), Object.defineProperty(_this, 'handleSavePads', {
      enumerable: true,
      writable: true,
      value: function value(lineItem) {
        _this.props.savePhaseItem(_this.props.params.id, lineItem, 'phaseLineItems');
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            params = _this$props.params,
            lineItemsWarehousePads = _this$props.lineItemsWarehousePads,
            role = _this$props.role,
            lineItemsWarehouseMerchandise = _this$props.lineItemsWarehouseMerchandise;

        var editable = Object(services["a" /* can */])(role, 'update', 'warehouse');
        return react_default.a.createElement(
          'div',
          null,
          react_default.a.createElement(components_receiveReleaseAll, {
            warehouseMerch: lineItemsWarehouseMerchandise,
            warehousePads: lineItemsWarehousePads,
            phaseId: params.id
          }),
          react_default.a.createElement(warehouseMerchandiseItemTable, {
            padInfo: _this.state.pads,
            lineItems: lineItemsWarehouseMerchandise,
            editable: editable,
            phaseId: params.id
          }),
          react_default.a.createElement(warehousePadTable, {
            handleSave: _this.handleSavePads,
            editable: editable,
            lineItems: lineItemsWarehousePads,
            phaseId: params.id
          }),
          react_default.a.createElement(levelerTable, {
            lineItems: lineItemsWarehouseMerchandise,
            editable: editable,
            phaseId: params.id
          })
        );
      }
    }), _temp), warehouseMaterials__possibleConstructorReturn(_this, _ret);
  }

  return WarehouseMaterials;
}(react["Component"]);

warehouseMaterials_WarehouseMaterials.propTypes = {
  lineItemsWarehousePads: prop_types_default.a.arrayOf(prop_types_default.a.shape(lineItemPropType)),
  lineItemsWarehouseMerchandise: prop_types_default.a.arrayOf(prop_types_default.a.shape(warehouseMerchandiseItem)),
  requestPhaseItems: prop_types_default.a.func,
  savePhaseItem: prop_types_default.a.func,
  requestPhaseLevelerItems: prop_types_default.a.func,
  params: prop_types_default.a.shape({
    id: prop_types_default.a.string
  }),
  role: prop_types_default.a.string.isRequired
};

/* harmony default export */ var warehouseMaterials = (Object(react_redux_es["connect"])(function (state) {
  return {
    lineItemsWarehousePads: state.phase.phaseLineItems.items.filter(function (lineItem) {
      if (state.phase.source === 'IME') {
        return lineItem.kind === 'Pad';
      }
      return lineItem.kind === 'Product';
    }),
    lineItemsWarehouseMerchandise: state.phase.warehouseMerchandiseItems.items,
    role: Object(reducers["_12" /* getRole */])(state)
  };
}, {
  requestPhaseItems: phase_items["i" /* requestPhaseItems */],
  savePhaseItem: phase_items["k" /* savePhaseItem */],
  requestPhaseLevelerItems: phase_items["j" /* requestPhaseLevelerItems */]
})(warehouseMaterials_WarehouseMaterials));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseCommunications/components/styledComponents.js
var components_styledComponents__templateObject = components_styledComponents__taggedTemplateLiteral(['\n0% {\n    transform: translateY(-100%);\n    opacity: 0;\n  }\n\n100% {\n    transform: translateY(0);\n    opacity: 1;\n  }\n'], ['\n0% {\n    transform: translateY(-100%);\n    opacity: 0;\n  }\n\n100% {\n    transform: translateY(0);\n    opacity: 1;\n  }\n']),
    components_styledComponents__templateObject2 = components_styledComponents__taggedTemplateLiteral(['\noverflow: hidden;\n'], ['\noverflow: hidden;\n']);

function components_styledComponents__taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }




var components_styledComponents_expand = Object(core_browser_esm["keyframes"])(components_styledComponents__templateObject);

var components_styledComponents_DropdownDiv = styled_browser_esm["a" /* default */].div(function (_ref) {
    var condition = _ref.condition;
    return {
        animation: condition ? components_styledComponents_expand + ' 400ms ease-out' : ''
    };
});

var components_styledComponents_ContainerDiv = styled_browser_esm["a" /* default */].div(components_styledComponents__templateObject2);
// EXTERNAL MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseCommunications/styles.scss
var phaseCommunications_styles = __webpack_require__("LPKT");
var phaseCommunications_styles_default = /*#__PURE__*/__webpack_require__.n(phaseCommunications_styles);

// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseCommunications/components/scriptsIntro.jsx
/* eslint-disable max-len */








var scriptsIntro_ScriptsIntro = function ScriptsIntro(props) {
  var user = props.user,
      phase = props.phase,
      title = props.title,
      customerAnswered = props.customerAnswered,
      handleBasicQuestion = props.handleBasicQuestion;

  var isFollowUpDelivery = function isFollowUpDelivery(type) {
    return type === 'Follow Up Delivery Call';
  };
  var isFollowUp = function isFollowUp(type) {
    return type === 'Follow Up Call';
  };
  var important = function important(text) {
    return react_default.a.createElement(
      'span',
      { className: phaseCommunications_styles_default.a.scriptText },
      text
    );
  };
  return react_default.a.createElement(
    components_Card,
    { className: phaseCommunications_styles_default.a.card },
    react_default.a.createElement(
      'div',
      { className: phaseCommunications_styles_default.a.headerContainer },
      react_default.a.createElement(
        'h4',
        { className: phaseCommunications_styles_default.a.title },
        title,
        ' Script Intro'
      )
    ),
    react_default.a.createElement(
      'div',
      { className: phaseCommunications_styles_default.a.scriptContainer },
      react_default.a.createElement(
        'p',
        { className: phaseCommunications_styles_default.a.scriptUserNote },
        'USER NOTE: Did the customer answer?'
      ),
      react_default.a.createElement('br', null),
      react_default.a.createElement(lib_button["Button"], {
        label: 'ANSWERED',
        flat: true, inverse: true, ripple: true,
        disabled: customerAnswered === 'yes',
        className: phaseCommunications_styles_default.a.standardButton,
        onClick: function onClick() {
          return handleBasicQuestion('customerAnswered', 'yes');
        }
      }),
      react_default.a.createElement(lib_button["Button"], {
        label: 'VOICEMAIL',
        flat: true, inverse: true, ripple: true,
        disabled: customerAnswered === 'no',
        className: phaseCommunications_styles_default.a.standardButton,
        onClick: function onClick() {
          return handleBasicQuestion('customerAnswered', 'no');
        }
      })
    ),
    customerAnswered && react_default.a.createElement(
      components_styledComponents_ContainerDiv,
      null,
      react_default.a.createElement(
        components_styledComponents_DropdownDiv,
        { condition: customerAnswered },
        react_default.a.createElement(
          'div',
          { className: phaseCommunications_styles_default.a.scriptContainer },
          isFollowUpDelivery(title) ? react_default.a.createElement(
            'p',
            null,
            'Hello Mr./Ms. ',
            important(phase.customer_name),
            ', this is ',
            important(user),
            ' with ',
            ifiUtils(phase) ? "Integrity First Installations, your Lowe's millwork specialist" : 'Service Pros',
            '. I wanted to touch base to ensure that everything went okay with the delivery of your materials.'
          ) : react_default.a.createElement(
            'p',
            null,
            'Hi, Mr./Ms. ',
            important(phase.customer_name),
            ', my name is ',
            important(user),
            ' with ',
            ifiUtils(phase) ? "Integrity First Installations, your Lowe's millwork specialist" : 'Service Pros',
            ', calling',
            isFollowUp(title) ? ' to follow up on ' : ' about ',
            'your ',
            important(phase.surface_type.name),
            ' installation',
            isFollowUp(title) ? ' and make sure everything went well' : '',
            '.'
          )
        )
      )
    ),
    customerAnswered === 'yes' && react_default.a.createElement(
      components_styledComponents_ContainerDiv,
      null,
      react_default.a.createElement(
        components_styledComponents_DropdownDiv,
        { condition: customerAnswered === 'yes' },
        react_default.a.createElement(
          'div',
          { className: phaseCommunications_styles_default.a.scriptContainer },
          react_default.a.createElement(
            'p',
            { className: phaseCommunications_styles_default.a.scriptUserNote },
            'USER NOTE: Pause and allow the customer to respond.'
          )
        )
      )
    )
  );
};

scriptsIntro_ScriptsIntro.propTypes = {
  user: prop_types_default.a.string,
  phase: prop_types_default.a.object,
  title: prop_types_default.a.string,
  customerAnswered: prop_types_default.a.string,
  canTalk: prop_types_default.a.string,
  handleBasicQuestion: prop_types_default.a.func
};

/* harmony default export */ var scriptsIntro = (scriptsIntro_ScriptsIntro);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseCommunications/components/jobReviewScript.jsx
/* eslint-disable max-len */










var SURVEY_REMINDER = 'Once your installation is complete, Lowe\'s will be reaching out via text or email to complete a survey.\nThey will ask about our craftsmanship, professionalism, and your likelihood to recommend Lowe\'s and Service Pros to your family or friends.\nThe survey is very important to us and only 10s are passing scores.\nIf for any reason you feel we are not earning a 10, please reach out so we can assist with a resolution.';

var jobReviewScript_JobReviewScript = function JobReviewScript(props) {
  var _props$phase = props.phase,
      appointments = _props$phase.appointments,
      source = _props$phase.source,
      _props$phase$surface_ = _props$phase.surface_type,
      surfaceId = _props$phase$surface_.id,
      surfaceName = _props$phase$surface_.name,
      need_move_furniture = _props$phase.phase_specific.need_move_furniture,
      workroomName = _props$phase.workroom.name,
      title = props.title,
      customerAnswered = props.customerAnswered,
      movingFurniture = props.movingFurniture,
      handleSpecificAnswered = props.handleSpecificAnswered,
      originalFurnitureStatus = props.originalFurnitureStatus;

  var isCarpet = surfaceName && surfaceName.trim().toLowerCase() === 'carpet';
  var formatDate = function formatDate(date) {
    return moment_default()(date, constants["_19" /* RAILS_DATE */]).format(constants["E" /* DISPLAY_DATE */]);
  };
  var formatTime = function formatTime(time) {
    return moment_default()(time, constants["_3" /* MOMENT_TIME */]).format('h:mm A');
  };
  var didAnswer = customerAnswered === 'yes';
  var appt = Object(dateUtils["s" /* sortApptsByDate */])(Object(dateUtils["a" /* filterApptsByTodayOrLater */])(appointments, true), true)[0] || {};
  var lhiScript = !workroomName.includes('PFT-') && !constants["_8" /* NON_LHI_SOURCES */].includes(source);
  var ifiPhase = source === 'IFI';
  var surveyElement = react_default.a.createElement(
    react["Fragment"],
    null,
    react_default.a.createElement('br', null),
    react_default.a.createElement(
      'p',
      null,
      SURVEY_REMINDER
    )
  );
  var ifiSurveyElement = react_default.a.createElement(
    react["Fragment"],
    null,
    react_default.a.createElement('br', null),
    react_default.a.createElement(
      'p',
      null,
      'Once your installation is complete, Lowe\'s will be reaching out via text or email to complete a survey. They will ask about our craftsmanship, professionalism, and your likelihood to recommend Lowe\'s and Integrity First to your family or friends. The survey is very important to us and only 10s are passing scores. If for any reason you feel we are not earning a 10, please reach out so we can assist with a resolution.'
    )
  );
  var appointmentLine = react_default.a.createElement(
    'p',
    null,
    'We have you scheduled for ',
    react_default.a.createElement(
      'span',
      { className: phaseCommunications_styles_default.a.scriptText },
      formatDate(appt.start_date)
    ),
    ', with an arrival window of ',
    react_default.a.createElement(
      'span',
      { className: phaseCommunications_styles_default.a.scriptText },
      formatTime(appt.arrival_start_time),
      ' - ',
      formatTime(appt.arrival_end_time)
    )
  );
  return react_default.a.createElement(
    components_Card,
    { className: phaseCommunications_styles_default.a.card },
    react_default.a.createElement(
      'div',
      { className: phaseCommunications_styles_default.a.headerContainer },
      react_default.a.createElement(
        'h4',
        { className: phaseCommunications_styles_default.a.title },
        title + ' ' + (didAnswer ? 'Answered' : 'Voicemail'),
        ' Script'
      )
    ),
    react_default.a.createElement(
      'div',
      { className: phaseCommunications_styles_default.a.scriptContainer },
      ifiPhase ? react_default.a.createElement(
        react["Fragment"],
        null,
        didAnswer ? react_default.a.createElement(
          react["Fragment"],
          null,
          appointmentLine,
          react_default.a.createElement('br', null),
          react_default.a.createElement(
            'p',
            null,
            'I need to confirm a few things with you, real quick.'
          ),
          react_default.a.createElement('br', null),
          react_default.a.createElement(
            'p',
            { className: phaseCommunications_styles_default.a.scriptUserNote },
            'USER NOTE: Check contractor notes.'
          ),
          react_default.a.createElement('br', null),
          react_default.a.createElement(
            'p',
            null,
            'I see that we are installing (product) in (location).'
          ),
          react_default.a.createElement('br', null),
          react_default.a.createElement(
            'p',
            null,
            'Have you had a chance to clear the area of any furniture and personal belongings where the installation will take place?'
          ),
          react_default.a.createElement('br', null),
          react_default.a.createElement(
            'p',
            { className: phaseCommunications_styles_default.a.scriptUserNote },
            'YES: That\'s great! USER NOTE: Move to next question.'
          ),
          react_default.a.createElement(
            'p',
            { className: phaseCommunications_styles_default.a.scriptUserNote },
            'NO: No worries! We just ask that the installation area be cleared of furniture and personal belongings before our installers arrive. Will you be able to get that taken care of before your appointment?'
          ),
          react_default.a.createElement(
            'p',
            { className: phaseCommunications_styles_default.a.scriptUserNote },
            '\xA0\xA0\xA0\xA0YES: That\'s great. Thank you so much. USER NOTE: Move to next question.'
          ),
          react_default.a.createElement(
            'p',
            { className: phaseCommunications_styles_default.a.scriptUserNote },
            '\xA0\xA0\xA0\xA0NO: I completely understand! Unfortunately, our installers are unable to move furniture or personal items. We want to make sure your installation goes smoothly, so we\'ll need to reschedule your appointment for a time when the area can be cleared. Let\'s find a date that works best for you!'
          ),
          react_default.a.createElement('br', null),
          react_default.a.createElement(
            'p',
            { className: phaseCommunications_styles_default.a.scriptUserNote },
            'USER NOTE: Check contractor notes, photos, and detail for CUSTOMER RESPONSIBILITIES. Are there any security systems, doorbell-cameras, shutters, blinds, etc (any fixtures) that need to be removed and reinstalled by the customer. If the project and/or customer indicate removal/reinstallation is needed:'
          ),
          react_default.a.createElement('br', null),
          react_default.a.createElement(
            'p',
            null,
            'As a friendly reminder, please remove your _______ and note that the installers will not be able to reinstall them.'
          ),
          ifiSurveyElement,
          react_default.a.createElement('br', null),
          react_default.a.createElement(
            'p',
            null,
            'Do you have our customer care number in case you need anything during your installation?'
          ),
          react_default.a.createElement('br', null),
          react_default.a.createElement(
            'p',
            null,
            'We look forward to helping you complete your project.'
          ),
          react_default.a.createElement('br', null),
          react_default.a.createElement(
            'p',
            null,
            'Thank you and have a great day!'
          )
        ) : react_default.a.createElement(
          react["Fragment"],
          null,
          appointmentLine,
          react_default.a.createElement('br', null),
          react_default.a.createElement(
            'p',
            null,
            'Just a reminder to ensure the installation area is cleared of all furniture, personal items, security systems, and/or any shutters/blinds.'
          ),
          react_default.a.createElement('br', null),
          react_default.a.createElement(
            'p',
            null,
            'If any of this information is incorrect, please call us back at 833-377-2712.'
          ),
          ifiSurveyElement,
          react_default.a.createElement('br', null),
          react_default.a.createElement(
            'p',
            null,
            'We look forward to helping you complete your project. Thank you and have a great day!'
          )
        )
      ) : react_default.a.createElement(
        react["Fragment"],
        null,
        react_default.a.createElement(
          'p',
          null,
          'We have you scheduled for ',
          react_default.a.createElement(
            'span',
            { className: phaseCommunications_styles_default.a.scriptText },
            formatDate(appt.start_date)
          ),
          ', with an arrival window of ',
          react_default.a.createElement(
            'span',
            { className: phaseCommunications_styles_default.a.scriptText },
            formatTime(appt.arrival_start_time),
            ' - ',
            formatTime(appt.arrival_end_time)
          )
        ),
        react_default.a.createElement('br', null),
        didAnswer ? react_default.a.createElement(
          react["Fragment"],
          null,
          react_default.a.createElement(
            'p',
            null,
            'I need to confirm a few things with you, real quick.'
          ),
          react_default.a.createElement('br', null),
          react_default.a.createElement(
            'p',
            null,
            'I see that we are installing in the _____ rooms of the home.'
          ),
          react_default.a.createElement('br', null),
          react_default.a.createElement(
            'p',
            { className: phaseCommunications_styles_default.a.scriptUserNote },
            'USER NOTE: Check contractor notes for rooms.'
          ),
          isCarpet && react_default.a.createElement(
            react["Fragment"],
            null,
            react_default.a.createElement('br', null),
            react_default.a.createElement(
              'p',
              null,
              'Can we review seam placement together?'
            ),
            react_default.a.createElement('br', null),
            react_default.a.createElement(
              'p',
              { className: phaseCommunications_styles_default.a.scriptUserNote },
              'USER NOTE: Review seam placement.'
            )
          ),
          react_default.a.createElement('br', null),
          react_default.a.createElement(
            'p',
            null,
            'It looks like we are ',
            originalFurnitureStatus ? 'moving furniture. Is that correct?' : 'not moving furniture. Has that changed?'
          ),
          react_default.a.createElement('br', null),
          react_default.a.createElement(lib_button["Button"], {
            label: 'YES',
            flat: true, inverse: true, ripple: true,
            disabled: movingFurniture === 'yes',
            className: phaseCommunications_styles_default.a.standardButton,
            onClick: function onClick() {
              return handleSpecificAnswered('movingFurniture', 'need_move_furniture', true);
            }
          }),
          react_default.a.createElement(lib_button["Button"], {
            label: 'NO',
            flat: true, inverse: true, ripple: true,
            disabled: movingFurniture === 'no',
            className: phaseCommunications_styles_default.a.standardButton,
            onClick: function onClick() {
              return handleSpecificAnswered('movingFurniture', 'need_move_furniture', false);
            }
          }),
          react_default.a.createElement('br', null),
          movingFurniture && react_default.a.createElement(
            components_styledComponents_ContainerDiv,
            null,
            react_default.a.createElement(
              components_styledComponents_DropdownDiv,
              { condition: movingFurniture },
              need_move_furniture !== originalFurnitureStatus && react_default.a.createElement(
                react["Fragment"],
                null,
                react_default.a.createElement('br', null),
                react_default.a.createElement(
                  'p',
                  null,
                  'No problem; I will adjust this now. ',
                  lhiScript ? 'Lowe\'s will reach out regarding an adjustment to the price.' : '',
                  '.'
                )
              ),
              movingFurniture === 'yes' && react_default.a.createElement(
                react["Fragment"],
                null,
                react_default.a.createElement('br', null),
                react_default.a.createElement(
                  'p',
                  null,
                  'We will:'
                ),
                react_default.a.createElement(
                  'ul',
                  null,
                  react_default.a.createElement(
                    'li',
                    { className: phaseCommunications_styles_default.a.listItem },
                    '\u2022',
                    ' Move all furnishings, but request that they are emptied and that bedding is stripped.'
                  )
                ),
                react_default.a.createElement(
                  'p',
                  null,
                  'We cannot:'
                ),
                react_default.a.createElement(
                  'ul',
                  null,
                  react_default.a.createElement(
                    'li',
                    { className: phaseCommunications_styles_default.a.listItem },
                    '\u2022',
                    ' Move personal belongings such as jewelry, photos, and clothes.'
                  ),
                  react_default.a.createElement(
                    'li',
                    { className: phaseCommunications_styles_default.a.listItem },
                    '\u2022',
                    ' Move pianos, aquariums, waterbeds, antiques, pool tables, holiday decorations, free standing gas heating units, large exercise equipment, safes.'
                  ),
                  react_default.a.createElement(
                    'li',
                    { className: phaseCommunications_styles_default.a.listItem },
                    '\u2022',
                    ' Remove, replace or reconnect baseboard heaters and wall mounted radiators.'
                  ),
                  react_default.a.createElement(
                    'li',
                    { className: phaseCommunications_styles_default.a.listItem },
                    '\u2022',
                    ' Move any electronics (If it has a power cord it will need to be moved prior to install).'
                  ),
                  react_default.a.createElement(
                    'li',
                    { className: phaseCommunications_styles_default.a.listItem },
                    '\u2022',
                    ' If the customer asks for details (computers, stereos, home theaters, televisions, medical equipment, alarm systems, mechanical beds and living room furniture etc).'
                  )
                )
              ),
              react_default.a.createElement('br', null),
              react_default.a.createElement(
                'p',
                { className: phaseCommunications_styles_default.a.scriptUserNote },
                'USER NOTE: Go over any specific customer responsibilities found on the Detail.'
              ),
              !lhiScript || surfaceId === 2 ? null : react_default.a.createElement(
                react["Fragment"],
                null,
                react_default.a.createElement('br', null),
                [3, 7].includes(surfaceId) ? react_default.a.createElement(
                  'p',
                  { className: phaseCommunications_styles_default.a.scriptUserNote },
                  'USER NOTE: If project is 150sqft or more, the product will need to be picked up by the customer or delivered by Lowe',
                  '\'',
                  's before the appointment.'
                ) : react_default.a.createElement(
                  'p',
                  null,
                  'Have all of your materials been delivered and are they inside the home for acclimation?'
                )
              ),
              react_default.a.createElement('br', null),
              react_default.a.createElement(
                'p',
                null,
                'Do you have any questions for us at this time?'
              ),
              lhiScript && surveyElement,
              react_default.a.createElement('br', null),
              react_default.a.createElement(
                'p',
                null,
                'Do you have our customer care number in case you need anything during your installation?'
              ),
              react_default.a.createElement('br', null),
              react_default.a.createElement(
                'p',
                null,
                'We look forward to helping you complete your project.'
              ),
              react_default.a.createElement('br', null),
              react_default.a.createElement(
                'p',
                null,
                'Thank you and have a great day!'
              )
            )
          )
        ) : react_default.a.createElement(
          react["Fragment"],
          null,
          react_default.a.createElement(
            'p',
            null,
            'Just a reminder that if we are moving furniture, please remove all of your personal items, breakables, and electronics prior to the installer',
            '\'',
            's arrival.'
          ),
          surfaceId !== 2 && react_default.a.createElement(
            react["Fragment"],
            null,
            react_default.a.createElement('br', null),
            react_default.a.createElement(
              'p',
              null,
              'I need to confirm that all the materials have been delivered or picked up and are in the home acclimating so we can move forward with the installation as scheduled.'
            )
          ),
          react_default.a.createElement('br', null),
          react_default.a.createElement(
            'p',
            null,
            'If any of this information is incorrect, please call us back at 866-774-4411 or you can chat with us at serviceprosig.com.'
          ),
          lhiScript && surveyElement,
          react_default.a.createElement('br', null),
          react_default.a.createElement(
            'p',
            null,
            'We look forward to helping you complete your project. Thank you and have a great day!'
          )
        )
      )
    )
  );
};

jobReviewScript_JobReviewScript.propTypes = {
  title: prop_types_default.a.string,
  phase: prop_types_default.a.object,
  originalFurnitureStatus: prop_types_default.a.bool,
  customerAnswered: prop_types_default.a.string,
  movingFurniture: prop_types_default.a.string,
  handleSpecificAnswered: prop_types_default.a.func
};

/* harmony default export */ var jobReviewScript = (jobReviewScript_JobReviewScript);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseCommunications/components/inProgressCallScript.jsx
/* eslint-disable max-len */






var inProgressCallScript_InProgressCallScript = function InProgressCallScript(props) {
  var title = props.title,
      customerAnswered = props.customerAnswered,
      source = props.source;

  var didAnswer = customerAnswered === 'yes';
  var lhiPhase = !constants["_8" /* NON_LHI_SOURCES */].includes(source);
  var ifiPhase = source === 'IFI';
  return react_default.a.createElement(
    components_Card,
    { className: phaseCommunications_styles_default.a.card },
    react_default.a.createElement(
      'div',
      { className: phaseCommunications_styles_default.a.headerContainer },
      react_default.a.createElement(
        'h4',
        { className: phaseCommunications_styles_default.a.title },
        title + ' ' + (didAnswer ? 'Answered' : 'Voicemail'),
        ' Script'
      )
    ),
    react_default.a.createElement(
      'div',
      { className: phaseCommunications_styles_default.a.scriptContainer },
      ifiPhase ? react_default.a.createElement(
        react["Fragment"],
        null,
        react_default.a.createElement(
          'p',
          null,
          'Hi Mr./Mrs. ____________ my name is ____________.'
        ),
        react_default.a.createElement('br', null),
        react_default.a.createElement(
          'p',
          null,
          'I\'m with Integrity First Installations, the Window and Door installation company for Lowe\'s.'
        ),
        react_default.a.createElement('br', null),
        didAnswer ? react_default.a.createElement(
          react["Fragment"],
          null,
          react_default.a.createElement(
            'p',
            null,
            'I am calling regarding your installation; just wanted to check in to see how everything was going and if you have any questions?'
          ),
          react_default.a.createElement('br', null),
          react_default.a.createElement(
            'p',
            { className: phaseCommunications_styles_default.a.scriptUserNote },
            '-Wait for response-'
          ),
          react_default.a.createElement('br', null),
          react_default.a.createElement(
            'p',
            { className: phaseCommunications_styles_default.a.scriptUserNote },
            'IF NO TO QUESTIONS/CONCERNS:'
          ),
          react_default.a.createElement(
            'p',
            null,
            'Great, if you do have any questions or concerns give us a call at 833-377-2712. We\'re always happy to help. Have a great day!'
          ),
          react_default.a.createElement('br', null),
          react_default.a.createElement(
            'p',
            { className: phaseCommunications_styles_default.a.scriptUserNote },
            'IF YES TO QUESTIONS/CONCERNS:'
          ),
          react_default.a.createElement(
            'p',
            null,
            react_default.a.createElement(
              'em',
              null,
              'Respond to their question and offer a solution if possible.'
            )
          ),
          react_default.a.createElement('br', null),
          react_default.a.createElement(
            'p',
            null,
            react_default.a.createElement(
              'em',
              null,
              '*If it\'s something you need to look into further:'
            )
          ),
          react_default.a.createElement(
            'p',
            null,
            'I\'ll get the answers and follow up with you shortly. In the meantime, if anything else comes up, don\'t hesitate to give us a call at 833-377-2712. Thank you!'
          )
        ) : react_default.a.createElement(
          'p',
          null,
          'I am calling regarding your installation; just wanted to check in to see how everything was going and if you have any questions or concerns. If you do please do not hesitate to give us a call back at 833-377-2712. Thank you!'
        )
      ) : react_default.a.createElement(
        react["Fragment"],
        null,
        react_default.a.createElement(
          'p',
          null,
          'I want to check in and make sure that the installers have arrived and everything is going well so far.'
        ),
        react_default.a.createElement('br', null),
        didAnswer ? react_default.a.createElement(
          react["Fragment"],
          null,
          react_default.a.createElement(
            'p',
            { className: phaseCommunications_styles_default.a.scriptUserNote },
            'USER NOTE: Pause and allow the customer to respond.'
          ),
          react_default.a.createElement('br', null),
          react_default.a.createElement(
            'p',
            null,
            'Do you have any questions or concerns about your installation at this time?'
          ),
          react_default.a.createElement('br', null),
          lhiPhase && react_default.a.createElement(
            'p',
            null,
            'That',
            '\'',
            's great! Also, when the installation is complete, we will reach out again to follow up on your overall satisfaction. Has anyone mentioned the survey to you yet?'
          ),
          react_default.a.createElement('br', null),
          react_default.a.createElement(
            'p',
            { className: phaseCommunications_styles_default.a.scriptUserNote },
            'USER NOTE: Pause and allow the customer to respond.'
          ),
          react_default.a.createElement('br', null),
          react_default.a.createElement(
            'p',
            null,
            'Okay, great! Just a reminder, if at any time during your installation process you do not feel we are earning 10s, please reach out so we can continue to improve our services.'
          ),
          react_default.a.createElement('br', null),
          lhiPhase && react_default.a.createElement(
            react["Fragment"],
            null,
            react_default.a.createElement(
              'p',
              null,
              'After your installation is complete, Lowe',
              '\'',
              's will reach out either by text or email to survey your experience. They will ask about our craftsmanship, our professionalism, and your likelihood to recommend to family and friends. ',
              react_default.a.createElement('br', null),
              'We strive for 10s, as they are the only passing score. If at any time during your installation process you do not feel we are earning 10s, please reach out so we can continue to improve our services.'
            ),
            react_default.a.createElement('br', null)
          ),
          react_default.a.createElement(
            'p',
            null,
            'Do you have any questions for us at this time?'
          ),
          react_default.a.createElement('br', null),
          react_default.a.createElement(
            'p',
            null,
            'Do you have our Customer Care Line in case you need anything during or after your installation?'
          ),
          react_default.a.createElement('br', null),
          react_default.a.createElement(
            'p',
            null,
            'We look forward to completing your project and hope you have a great day!'
          )
        ) : react_default.a.createElement(
          'p',
          null,
          'If you have any questions or need anything during your installation, please call us back at 866-774-4411.'
        ),
        react_default.a.createElement('br', null),
        react_default.a.createElement(
          'p',
          null,
          'Thank you and have a great day!'
        )
      )
    )
  );
};

inProgressCallScript_InProgressCallScript.propTypes = {
  title: prop_types_default.a.string,
  customerAnswered: prop_types_default.a.string,
  source: prop_types_default.a.string
};

/* harmony default export */ var inProgressCallScript = (inProgressCallScript_InProgressCallScript);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseCommunications/components/followUpCallScript.jsx
/* eslint-disable max-len */








var followUpCallScript_FollowUpCallScript = function FollowUpCallScript(props) {
  var title = props.title,
      customerAnswered = props.customerAnswered,
      jobNotFinished = props.jobNotFinished,
      customerUnsatisfied = props.customerUnsatisfied,
      handleBasicQuestion = props.handleBasicQuestion,
      source = props.source;

  var didAnswer = customerAnswered === 'yes';
  var lhiPhase = !constants["_8" /* NON_LHI_SOURCES */].includes(source);
  var ifiPhase = source === 'IFI';
  return react_default.a.createElement(
    components_Card,
    { className: phaseCommunications_styles_default.a.card },
    react_default.a.createElement(
      'div',
      { className: phaseCommunications_styles_default.a.headerContainer },
      react_default.a.createElement(
        'h4',
        { className: phaseCommunications_styles_default.a.title },
        title + ' ' + (didAnswer ? 'Answered' : 'Voicemail'),
        ' Script'
      )
    ),
    react_default.a.createElement(
      react["Fragment"],
      null,
      ifiPhase ? react_default.a.createElement(
        react["Fragment"],
        null,
        didAnswer ? react_default.a.createElement(
          'div',
          { className: phaseCommunications_styles_default.a.scriptContainer },
          react_default.a.createElement(
            'p',
            null,
            react_default.a.createElement(
              'strong',
              null,
              'Positive:'
            ),
            ' Great! That is what we love to hear, I wanted to let you know if you have any questions or concerns with your installation, please don\'t hesitate to reach out because you do have that 1-year warranty. Also, I wanted to let you know Lowe\'s will be sending an email out with a survey on the installer\'s craftmanship, professionalism, and your likelihood to recommend us to friends and family. This survey is very important to our installers as only 10\'s are passing scores.'
          ),
          react_default.a.createElement('br', null),
          react_default.a.createElement(
            'p',
            null,
            'Was there any part of your installation that would prevent you from rating your overall experience a 10?'
          ),
          react_default.a.createElement('br', null),
          react_default.a.createElement(lib_button["Button"], {
            label: 'YES',
            flat: true, inverse: true, ripple: true,
            disabled: customerUnsatisfied === 'yes',
            className: phaseCommunications_styles_default.a.standardButton,
            onClick: function onClick() {
              return handleBasicQuestion('customerUnsatisfied', 'yes');
            }
          }),
          react_default.a.createElement(lib_button["Button"], {
            label: 'NO',
            flat: true, inverse: true, ripple: true,
            disabled: customerUnsatisfied === 'no',
            className: phaseCommunications_styles_default.a.standardButton,
            onClick: function onClick() {
              return handleBasicQuestion('customerUnsatisfied', 'no');
            }
          }),
          customerUnsatisfied && react_default.a.createElement(
            components_styledComponents_ContainerDiv,
            null,
            react_default.a.createElement(
              components_styledComponents_DropdownDiv,
              { condition: customerUnsatisfied },
              react_default.a.createElement('br', null),
              customerUnsatisfied === 'no' ? react_default.a.createElement(
                'p',
                null,
                'Perfect! Again, if you need anything please give us a call at 833-377-2712. Thank you and have a great day!'
              ) : react_default.a.createElement(
                react["Fragment"],
                null,
                react_default.a.createElement(
                  'p',
                  null,
                  'Ok, what were the issues you experienced? (Wait for reply)'
                ),
                react_default.a.createElement('br', null),
                react_default.a.createElement(
                  'p',
                  { className: phaseCommunications_styles_default.a.scriptUserNote },
                  react_default.a.createElement(
                    'strong',
                    null,
                    'If it is something installer side that we need to get the installer back out to:'
                  ),
                  ' Ok, I understand, I will get what we call a work order opened so we can get those issues fixed. We will reach out to Lowe\'s to get this created and you should hear something back within 48 hours.'
                ),
                react_default.a.createElement('br', null),
                react_default.a.createElement(
                  'p',
                  { className: phaseCommunications_styles_default.a.scriptUserNote },
                  react_default.a.createElement(
                    'strong',
                    null,
                    'If it is something on the store side:'
                  ),
                  ' Ok, on the survey there will be a section where you can leave a comment. This is where you can put your issues you experienced and this will go straight to the store. If you ever need anything please give us a call back at 833-377-2712. Thank you and have a great day.'
                )
              )
            )
          )
        ) : react_default.a.createElement(
          'div',
          { className: phaseCommunications_styles_default.a.scriptContainer },
          react_default.a.createElement(
            'p',
            null,
            'I wanted to confirm that everything has been completed and you are happy with your installation.'
          ),
          react_default.a.createElement('br', null),
          react_default.a.createElement(
            'p',
            null,
            'Lowe\'s will be reaching out via text or email to complete a survey. They will ask about our craftmanship, professionalism, and your likelihood to recommend Lowe\'s and Integrity First to family or friends. The survey is very important to our installers and only 10s are passing scores. If for any reason you are not completely satisfied with your installation, please reach out so we can assist with a resolution.'
          ),
          react_default.a.createElement('br', null),
          react_default.a.createElement(
            'p',
            null,
            'Also, as a reminder you have a 1-year labor warranty. If you have any concerns with your installation during that time frame, please call 833-377-2712.'
          ),
          react_default.a.createElement('br', null),
          react_default.a.createElement(
            'p',
            null,
            'Thank you and have a great day!'
          )
        )
      ) : react_default.a.createElement(
        react["Fragment"],
        null,
        didAnswer ? react_default.a.createElement(
          react["Fragment"],
          null,
          react_default.a.createElement(
            'div',
            { className: phaseCommunications_styles_default.a.scriptContainer },
            react_default.a.createElement(
              'p',
              { className: phaseCommunications_styles_default.a.scriptUserNote },
              'USER NOTE: Did the customer say the job was NOT completed?'
            ),
            react_default.a.createElement('br', null),
            react_default.a.createElement(lib_button["Button"], {
              label: 'YES',
              flat: true, inverse: true, ripple: true,
              disabled: jobNotFinished === 'yes',
              className: phaseCommunications_styles_default.a.standardButton,
              onClick: function onClick() {
                return handleBasicQuestion('jobNotFinished', 'yes');
              }
            }),
            react_default.a.createElement(lib_button["Button"], {
              label: 'NO',
              flat: true, inverse: true, ripple: true,
              disabled: jobNotFinished === 'no',
              className: phaseCommunications_styles_default.a.standardButton,
              onClick: function onClick() {
                return handleBasicQuestion('jobNotFinished', 'no');
              }
            })
          ),
          jobNotFinished && react_default.a.createElement(
            components_styledComponents_ContainerDiv,
            null,
            react_default.a.createElement(
              components_styledComponents_DropdownDiv,
              { condition: jobNotFinished },
              react_default.a.createElement(
                'div',
                { className: phaseCommunications_styles_default.a.scriptContainer },
                jobNotFinished === 'yes' ? react_default.a.createElement(
                  react["Fragment"],
                  null,
                  react_default.a.createElement(
                    'p',
                    null,
                    'I',
                    '\'',
                    'm so sorry to hear that. I am going to connect with the installer to gather more information and we will call you back with a resolution.'
                  ),
                  react_default.a.createElement('br', null),
                  react_default.a.createElement(
                    'p',
                    { className: phaseCommunications_styles_default.a.scriptUserNote },
                    'USER NOTE: Pause and allow the customer to respond.'
                  ),
                  react_default.a.createElement('br', null),
                  react_default.a.createElement(
                    'p',
                    null,
                    'Again, we are very sorry this has happened. Thank you for your patience and I hope you have a great day.'
                  )
                ) : react_default.a.createElement(
                  react["Fragment"],
                  null,
                  lhiPhase && react_default.a.createElement(
                    react["Fragment"],
                    null,
                    react_default.a.createElement(
                      'p',
                      null,
                      'Lowe',
                      '\'',
                      's will be reaching out via text or email to complete a survey. They will ask about our craftsmanship, professionalism, and your likelihood to recommend Lowe',
                      '\'',
                      's and Service Pros to family or friends. The survey is very important to us, and only 10s are passing scores.'
                    ),
                    react_default.a.createElement('br', null)
                  ),
                  react_default.a.createElement(
                    'p',
                    null,
                    'Was there any part of your project that would prevent you from rating your experience a 10?'
                  ),
                  react_default.a.createElement('br', null),
                  react_default.a.createElement(lib_button["Button"], {
                    label: 'YES',
                    flat: true, inverse: true, ripple: true,
                    disabled: customerUnsatisfied === 'yes',
                    className: phaseCommunications_styles_default.a.standardButton,
                    onClick: function onClick() {
                      return handleBasicQuestion('customerUnsatisfied', 'yes');
                    }
                  }),
                  react_default.a.createElement(lib_button["Button"], {
                    label: 'NO',
                    flat: true, inverse: true, ripple: true,
                    disabled: customerUnsatisfied === 'no',
                    className: phaseCommunications_styles_default.a.standardButton,
                    onClick: function onClick() {
                      return handleBasicQuestion('customerUnsatisfied', 'no');
                    }
                  }),
                  customerUnsatisfied && react_default.a.createElement(
                    components_styledComponents_ContainerDiv,
                    null,
                    react_default.a.createElement(
                      components_styledComponents_DropdownDiv,
                      { condition: customerUnsatisfied },
                      react_default.a.createElement('br', null),
                      customerUnsatisfied === 'yes' ? react_default.a.createElement(
                        'p',
                        { className: phaseCommunications_styles_default.a.scriptUserNote },
                        'Identify and address the concern and explain the next steps for resolution.'
                      ) : react_default.a.createElement(
                        'p',
                        null,
                        'Perfect! I',
                        '\'',
                        'm happy to hear that.'
                      ),
                      react_default.a.createElement('br', null),
                      react_default.a.createElement(
                        'p',
                        null,
                        'Also, as a reminder you have a 1-year labor warranty. If you have any concerns with your installation during that time frame, please call and let us know.'
                      ),
                      react_default.a.createElement('br', null),
                      react_default.a.createElement(
                        'p',
                        null,
                        'Thank you and have a great day!'
                      )
                    )
                  )
                )
              )
            )
          )
        ) : react_default.a.createElement(
          'div',
          { className: phaseCommunications_styles_default.a.scriptContainer },
          react_default.a.createElement(
            'p',
            null,
            'I wanted to confirm that everything has been completed and you are happy with your installation.'
          ),
          react_default.a.createElement('br', null),
          react_default.a.createElement(
            'p',
            null,
            lhiPhase && react_default.a.createElement(
              'span',
              null,
              'Lowe',
              '\'',
              's will be reaching out via text or email to complete a survey. They will ask about our craftsmanship, professionalism, and your likelihood to recommend to family or friends. The survey is very important to our installers and only 10s are passing scores.'
            ),
            'If for any reason you are not completely satisfied with your installation, please reach out so we can assist with a resolution.'
          ),
          react_default.a.createElement('br', null),
          react_default.a.createElement(
            'p',
            null,
            'Also, as a reminder you have a 1-year labor warranty. If you have any concerns with your installation during that time frame, please call 866-774-4411.'
          ),
          react_default.a.createElement('br', null),
          react_default.a.createElement(
            'p',
            null,
            'Thank you and have a great day!'
          )
        )
      )
    )
  );
};

followUpCallScript_FollowUpCallScript.propTypes = {
  title: prop_types_default.a.string,
  customerAnswered: prop_types_default.a.string,
  jobNotFinished: prop_types_default.a.string,
  customerUnsatisfied: prop_types_default.a.string,
  handleBasicQuestion: prop_types_default.a.func,
  source: prop_types_default.a.string
};

/* harmony default export */ var followUpCallScript = (followUpCallScript_FollowUpCallScript);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseCommunications/components/followUpDeliveryCallScript.jsx
/* eslint-disable max-len */










var followUpDeliveryCallScript_FollowUpDeliveryCallScript = function FollowUpDeliveryCallScript(props) {
  var title = props.title,
      appointments = props.phase.appointments,
      customerAnswered = props.customerAnswered,
      deliveryOkay = props.deliveryOkay,
      handleBasicQuestion = props.handleBasicQuestion;

  var appt = Object(dateUtils["s" /* sortApptsByDate */])(Object(dateUtils["a" /* filterApptsByTodayOrLater */])(appointments, true), true)[0] || {};
  var formatDate = function formatDate(date) {
    return moment_default()(date, constants["_19" /* RAILS_DATE */]).format(constants["E" /* DISPLAY_DATE */]);
  };
  var formatTime = function formatTime(time) {
    return moment_default()(time, constants["_3" /* MOMENT_TIME */]).format('h:mm A');
  };
  var didAnswer = customerAnswered === 'yes';
  return react_default.a.createElement(
    components_Card,
    { className: phaseCommunications_styles_default.a.card },
    react_default.a.createElement(
      'div',
      { className: phaseCommunications_styles_default.a.headerContainer },
      react_default.a.createElement(
        'h4',
        { className: phaseCommunications_styles_default.a.title },
        title + ' ' + (didAnswer ? 'Answered' : 'Voicemail'),
        ' Script'
      )
    ),
    react_default.a.createElement(
      react["Fragment"],
      null,
      didAnswer ? react_default.a.createElement(
        react["Fragment"],
        null,
        react_default.a.createElement(
          'div',
          { className: phaseCommunications_styles_default.a.scriptContainer },
          react_default.a.createElement(
            'p',
            { className: phaseCommunications_styles_default.a.scriptUserNote },
            'USER NOTE: Did the customer say the delivery went okay?'
          ),
          react_default.a.createElement('br', null),
          react_default.a.createElement(lib_button["Button"], {
            label: 'YES',
            flat: true, inverse: true, ripple: true,
            disabled: deliveryOkay === 'yes',
            className: phaseCommunications_styles_default.a.standardButton,
            onClick: function onClick() {
              return handleBasicQuestion('deliveryOkay', 'yes');
            }
          }),
          react_default.a.createElement(lib_button["Button"], {
            label: 'NO',
            flat: true, inverse: true, ripple: true,
            disabled: deliveryOkay === 'no',
            className: phaseCommunications_styles_default.a.standardButton,
            onClick: function onClick() {
              return handleBasicQuestion('deliveryOkay', 'no');
            }
          })
        ),
        deliveryOkay && react_default.a.createElement(
          components_styledComponents_ContainerDiv,
          null,
          react_default.a.createElement(
            components_styledComponents_DropdownDiv,
            { condition: deliveryOkay },
            react_default.a.createElement(
              'div',
              { className: phaseCommunications_styles_default.a.scriptContainer },
              deliveryOkay === 'yes' ? react_default.a.createElement(
                react["Fragment"],
                null,
                react_default.a.createElement(
                  'p',
                  null,
                  'That',
                  '\'',
                  's great. We look forward to your installation scheduled for ',
                  react_default.a.createElement(
                    'span',
                    { className: phaseCommunications_styles_default.a.scriptText },
                    formatDate(appt.start_date)
                  ),
                  ', with an arrival window of ',
                  react_default.a.createElement(
                    'span',
                    { className: phaseCommunications_styles_default.a.scriptText },
                    formatTime(appt.arrival_start_time),
                    ' - ',
                    formatTime(appt.arrival_end_time)
                  ),
                  '. Do you have any questions or concerns about your upcoming installation that I can answer for you at this time?'
                ),
                react_default.a.createElement('br', null),
                react_default.a.createElement(
                  'p',
                  { className: phaseCommunications_styles_default.a.scriptUserNote },
                  'USER NOTE: Please allow time for the customer to respond and address any questions/concerns.'
                ),
                react_default.a.createElement('br', null),
                react_default.a.createElement(
                  'p',
                  null,
                  'Alright, we look forward to helping you complete your project.'
                ),
                react_default.a.createElement('br', null),
                react_default.a.createElement(
                  'p',
                  null,
                  'Have a great day!'
                )
              ) : react_default.a.createElement(
                react["Fragment"],
                null,
                react_default.a.createElement(
                  'p',
                  { className: phaseCommunications_styles_default.a.scriptUserNote },
                  'USER NOTE: Address the customer',
                  '\'',
                  's concern. If the delivery was not completed, reschedule the customer. If items are missing, reassure the customer that you will work with the store to receive the missing items and follow up with an update.'
                )
              )
            )
          )
        )
      ) : react_default.a.createElement(
        'div',
        { className: phaseCommunications_styles_default.a.scriptContainer },
        react_default.a.createElement(
          'p',
          null,
          'If your delivery did not go as expected or you have questions about your upcoming installation, please contact us at 866-774-4411.'
        ),
        react_default.a.createElement('br', null),
        react_default.a.createElement(
          'p',
          null,
          'Thank you and have a great day!'
        )
      )
    )
  );
};

followUpDeliveryCallScript_FollowUpDeliveryCallScript.propTypes = {
  title: prop_types_default.a.string,
  phase: prop_types_default.a.object,
  customerAnswered: prop_types_default.a.string,
  deliveryOkay: prop_types_default.a.string,
  handleBasicQuestion: prop_types_default.a.func
};

/* harmony default export */ var followUpDeliveryCallScript = (followUpDeliveryCallScript_FollowUpDeliveryCallScript);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseCommunications/components/welcomeCallScript.jsx






var welcomeCallScript_WelcomeCallScript = function WelcomeCallScript(props) {
  var title = props.title,
      customerAnswered = props.customerAnswered,
      phase = props.phase;

  var didAnswer = customerAnswered === 'yes';
  var isWaitingForProduct = phase.status === 'waiting_for_product';
  var isIfi = ifiUtils(phase);
  var surfaceName = phase.surface_type && phase.surface_type.name || '';
  var millwork = phase.phase_specific && phase.phase_specific.millwork_specifics || {};
  var isDoorType = surfaceName.toLowerCase().includes('door');
  var millworkCount = isDoorType ? millwork.num_doors : millwork.num_windows;
  var pluralizedSurface = millworkCount !== 1 && !surfaceName.toLowerCase().endsWith('s') ? surfaceName + 's' : surfaceName;

  return react_default.a.createElement(
    components_Card,
    { className: phaseCommunications_styles_default.a.card },
    react_default.a.createElement(
      'div',
      { className: phaseCommunications_styles_default.a.headerContainer },
      react_default.a.createElement(
        'h4',
        { className: phaseCommunications_styles_default.a.title },
        title + ' ' + (didAnswer ? 'Answered' : 'Voicemail'),
        ' Script'
      )
    ),
    react_default.a.createElement(
      'div',
      { className: phaseCommunications_styles_default.a.scriptContainer },
      didAnswer ? react_default.a.createElement(
        react["Fragment"],
        null,
        react_default.a.createElement(
          'p',
          null,
          'If you have just one moment, I would like to go over the process for your project and ensure that you have all the information you need for a successful installation. Is now a good time?'
        ),
        react_default.a.createElement('br', null),
        react_default.a.createElement(
          'p',
          null,
          'I see that we are installing',
          ' ',
          isIfi ? react_default.a.createElement(
            'span',
            { className: phaseCommunications_styles_default.a.scriptText },
            millworkCount,
            ' ',
            pluralizedSurface
          ) : react_default.a.createElement(
            react["Fragment"],
            null,
            react_default.a.createElement(
              'span',
              { className: phaseCommunications_styles_default.a.scriptBlank },
              '__'
            ),
            ' ',
            react_default.a.createElement(
              'strong',
              null,
              '(specify the doors/windows)'
            ),
            ' ',
            react_default.a.createElement(
              'span',
              { className: phaseCommunications_styles_default.a.scriptBlank },
              '__'
            )
          ),
          '. Is that correct?'
        ),
        react_default.a.createElement('br', null),
        isWaitingForProduct ? react_default.a.createElement(
          react["Fragment"],
          null,
          react_default.a.createElement(
            'p',
            null,
            'At this time, we are waiting for your material to arrive. Once it arrives, Contractor will be notified to schedule your installation. We want to communicate in a way that works best for you throughout your project.'
          ),
          react_default.a.createElement('br', null),
          react_default.a.createElement(
            'p',
            null,
            'What number is best to reach you?'
          ),
          react_default.a.createElement('br', null),
          react_default.a.createElement(
            'p',
            null,
            'OK, and to make sure I have it right, I heard ',
            react_default.a.createElement(
              'span',
              { className: phaseCommunications_styles_default.a.scriptText },
              '___'
            ),
            '.'
          )
        ) : react_default.a.createElement(
          react["Fragment"],
          null,
          react_default.a.createElement(
            'p',
            null,
            'Lowe',
            '\'',
            's has confirmed that all materials have been received and your project is ready to schedule. We have notified our subcontractor who will be completing the installation, they will reach out to you within 48 business hours to offer our soonest available date.'
          ),
          react_default.a.createElement('br', null),
          react_default.a.createElement(
            'p',
            null,
            'What number would you like us to contact you on?'
          ),
          react_default.a.createElement('br', null),
          react_default.a.createElement(
            'p',
            null,
            'OK, and to make sure I have it right, ',
            react_default.a.createElement(
              'span',
              { className: phaseCommunications_styles_default.a.scriptText },
              '___'
            ),
            ' is the best number?'
          )
        ),
        react_default.a.createElement('br', null),
        react_default.a.createElement(
          'p',
          null,
          'I would also like to ensure that you have our number for any questions or concerns throughout your project. I can text that number to you, or if you',
          '\'',
          're able to write it down I can read that to you over the phone. Our number is 833-377-2712. Our office is open from 7am to 6pm, Monday through Friday. And 8am to 5pm on Saturdays.'
        ),
        react_default.a.createElement('br', null),
        react_default.a.createElement(
          'p',
          null,
          'Do you have any questions for me at this time?'
        ),
        react_default.a.createElement('br', null),
        react_default.a.createElement(
          'p',
          null,
          'Thank you for your purchase. We look forward to working with you.'
        )
      ) : react_default.a.createElement(
        react["Fragment"],
        null,
        isWaitingForProduct ? react_default.a.createElement(
          react["Fragment"],
          null,
          react_default.a.createElement(
            'p',
            null,
            'At this time, we are waiting for your material to arrive. Once it arrives, our Contractor will be notified to schedule your installation. I would also like to ensure that you have our phone number for any questions or concerns throughout your installation. Our number is 833-377-2712. Our office is open from 7am to 6pm, Monday through Friday. And 8am to 5pm on Saturdays.'
          ),
          react_default.a.createElement('br', null),
          react_default.a.createElement(
            'p',
            null,
            'If you have any questions or if any of the information was not correct, please contact us at your convenience.'
          )
        ) : react_default.a.createElement(
          react["Fragment"],
          null,
          react_default.a.createElement(
            'p',
            null,
            'I wanted to go over the process for your project and ensure that you have all the information you need for a successful installation.'
          ),
          react_default.a.createElement('br', null),
          react_default.a.createElement(
            'p',
            null,
            'Lowe',
            '\'',
            's has confirmed that all materials have been received and your project is ready to schedule. Our subcontractor will be reaching out to you within 48 business hours to offer our soonest available date. I would also like to ensure that you have our phone number for any questions or concerns throughout your installation. Our number is 833-377-2712. Our office is open from 7am to 6pm, Monday through Friday. And 8am to 5pm on Saturdays.'
          ),
          react_default.a.createElement('br', null),
          react_default.a.createElement(
            'p',
            null,
            'Do you have any questions for us at this time?'
          )
        ),
        react_default.a.createElement('br', null),
        react_default.a.createElement(
          'p',
          null,
          'Thank you for your purchase. We look forward to working with you.'
        )
      )
    )
  );
};

welcomeCallScript_WelcomeCallScript.propTypes = {
  title: prop_types_default.a.string,
  customerAnswered: prop_types_default.a.string,
  phase: prop_types_default.a.object
};

/* harmony default export */ var welcomeCallScript = (welcomeCallScript_WelcomeCallScript);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseCommunications/index.jsx
function phaseCommunications__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function phaseCommunications__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function phaseCommunications__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function phaseCommunications__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



























var phaseCommunications_theme = { RTInput: input_default.a, RTCard: styles_card_default.a };

var PhaseCommunications = function (_React$Component) {
  phaseCommunications__inherits(PhaseCommunications, _React$Component);

  function PhaseCommunications(props) {
    phaseCommunications__classCallCheck(this, PhaseCommunications);

    var _this = phaseCommunications__possibleConstructorReturn(this, (PhaseCommunications.__proto__ || Object.getPrototypeOf(PhaseCommunications)).call(this, props));

    phaseCommunications__initialiseProps.call(_this);

    _this.handleBasicQuestion = _this.handleBasicQuestion.bind(_this);
    _this.handleSpecificAnswered = _this.handleSpecificAnswered.bind(_this);
    _this.handleCommNote = _this.handleFormChange.bind(_this, 'commNote');
    var _this$props = _this.props,
        phase = _this$props.phase,
        need_move_furniture = _this$props.phase.phase_specific.need_move_furniture;

    _this.state = {
      phase: phase,
      originalFurnitureStatus: need_move_furniture,
      customerAnswered: '',
      canTalk: '',
      movingFurniture: '',
      jobNotFinished: '',
      deliveryOkay: '',
      customerUnsatisfied: '',
      commNote: ''
    };
    return _this;
  }

  return PhaseCommunications;
}(react_default.a.Component);

var phaseCommunications__initialiseProps = function _initialiseProps() {
  var _this2 = this;

  Object.defineProperty(this, 'handleScrollDown', {
    enumerable: true,
    writable: true,
    value: function value(percent) {
      return Object(utils["z" /* smoothScrollBy */])({ percent: percent });
    }
  });
  Object.defineProperty(this, 'handleBasicQuestion', {
    enumerable: true,
    writable: true,
    value: function value(key, val) {
      return _this2.setState(phaseCommunications__defineProperty({}, key, val), function () {
        return _this2.handleScrollDown(18);
      });
    }
  });
  Object.defineProperty(this, 'handleSkipCanTalk', {
    enumerable: true,
    writable: true,
    value: function value(key, val) {
      return _this2.setState({ canTalk: val }, function () {
        return _this2.handleBasicQuestion(key, val);
      });
    }
  });
  Object.defineProperty(this, 'handleSpecificAnswered', {
    enumerable: true,
    writable: true,
    value: function value(answeredKey, specificKey, val) {
      var _newState;

      var phase = _this2.state.phase;

      var answeredVal = val ? 'yes' : 'no';
      var newState = (_newState = {}, phaseCommunications__defineProperty(_newState, answeredKey, answeredVal), phaseCommunications__defineProperty(_newState, 'phase', phase), _newState);
      newState.phase.phase_specific[specificKey] = val;
      if (specificKey === 'need_move_furniture' && !val) {
        newState.phase.phase_specific.need_move_furniture_oversized = val;
      }
      _this2.setState(newState, function () {
        return _this2.handleScrollDown(18);
      });
    }
  });
  Object.defineProperty(this, 'handleFormChange', {
    enumerable: true,
    writable: true,
    value: function value(key, val) {
      return _this2.setState(phaseCommunications__defineProperty({}, key, val));
    }
  });
  Object.defineProperty(this, 'updateTask', {
    enumerable: true,
    writable: true,
    value: function value(id, slug) {
      var _state = _this2.state,
          customerAnswered = _state.customerAnswered,
          canTalk = _state.canTalk,
          commNote = _state.commNote,
          jobNotFinished = _state.jobNotFinished,
          deliveryOkay = _state.deliveryOkay,
          customerUnsatisfied = _state.customerUnsatisfied;

      return _this2.props.updatePhaseTask(id, slug, {
        task: { status: 'complete' },
        data: {
          answered: customerAnswered,
          can_talk: canTalk,
          comm_note: commNote,
          customer_unsatisfied: customerUnsatisfied || jobNotFinished || deliveryOkay === 'no'
        }
      });
    }
  });
  Object.defineProperty(this, 'addNote', {
    enumerable: true,
    writable: true,
    value: function value(id) {
      var _state2 = _this2.state,
          phase = _state2.phase,
          commNote = _state2.commNote;

      var noteProps = {
        name: 'Note',
        kind: 'note',
        data: { note: commNote }
      };
      _this2.props.addEventToPhase(id, noteProps).then(function () {
        return _this2.navigateToHistory(phase);
      }).catch(function () {});
    }
  });
  Object.defineProperty(this, 'navigateToHistory', {
    enumerable: true,
    writable: true,
    value: function value(phase) {
      return _this2.props.navigate(urls.phaseHistory(phase));
    }
  });
  Object.defineProperty(this, 'finishCommunication', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _state3 = _this2.state,
          phase = _state3.phase,
          commNote = _state3.commNote;

      if (_this2.isWelcomeCall()) {
        var customerAnswered = _this2.state.customerAnswered;

        var flag = _this2.props.phase.flags.find(function (f) {
          return f.name === 'Welcome Call Needed';
        });
        var removeFlag = function removeFlag() {
          return flag ? _this2.props.removeFlagFromPhase(phase.id, { id: flag.id, note: commNote }) : Promise.resolve();
        };
        // Only the voicemail (no-answer) branch sends the welcome text; on an
        // answered call the rep covers everything live.
        var sendWelcomeText = customerAnswered === 'no' ? _this2.props.updatePhase({ id: phase.id }, { communication: 'SendWelcomeTextMessage' }) : Promise.resolve();
        sendWelcomeText.then(removeFlag).then(function () {
          return _this2.navigateToHistory(phase);
        }).catch(function () {});
        return;
      }
      var _state4 = _this2.state,
          jobNotFinished = _state4.jobNotFinished,
          deliveryOkay = _state4.deliveryOkay,
          customerUnsatisfied = _state4.customerUnsatisfied,
          _state4$phase = _state4.phase,
          id = _state4$phase.id,
          phase_specific = _state4$phase.phase_specific;

      var slug = _this2.determineSlug();
      if (['installation_customer_review', 'workorder_customer_review'].includes(slug)) {
        _this2.props.updatePhase({ id: id, phase_specific_attributes: phase_specific }, {}).then(function () {
          return _this2.updateTask(id, slug);
        }).then(function () {
          return _this2.navigateToHistory(phase);
        }).catch(function () {});
      } else if (jobNotFinished === 'yes' || deliveryOkay === 'no' || slug === 'follow_up_call' && _this2.state.phase.source === 'IFI' && customerUnsatisfied === 'yes') _this2.addNote(id);else _this2.updateTask(id, slug).then(function () {
        return _this2.navigateToHistory(phase);
      }).catch(function () {});
    }
  });
  Object.defineProperty(this, 'determineSlug', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _props$phase = _this2.props.phase,
          status = _props$phase.status,
          type = _props$phase.type;

      switch (status) {
        case constants["_32" /* SCRIPT_STATUSES */][0]:
          return type === 'Installation' ? 'installation_customer_review' : 'workorder_customer_review';
        case constants["_32" /* SCRIPT_STATUSES */][1]:
          return 'install_in_progress_call';
        case constants["_32" /* SCRIPT_STATUSES */][2]:
          return 'workorder_in_progress_call';
        case constants["_32" /* SCRIPT_STATUSES */][3]:
          return 'follow_up_call';
        case constants["_32" /* SCRIPT_STATUSES */][4]:
          return 'follow_up_delivery_call';
        default:
          return '';
      }
    }
  });
  Object.defineProperty(this, 'determineSubmitDisabled', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _state5 = _this2.state,
          customerAnswered = _state5.customerAnswered,
          canTalk = _state5.canTalk,
          movingFurniture = _state5.movingFurniture,
          jobNotFinished = _state5.jobNotFinished,
          deliveryOkay = _state5.deliveryOkay,
          customerUnsatisfied = _state5.customerUnsatisfied,
          commNote = _state5.commNote;

      if (_this2.determineNoApptBlocked()) return true;
      if (!commNote) return true;
      if (customerAnswered === 'no') return false;
      var title = _this2.determineTitle();
      if (title === 'Job Review' && _this2.state.phase.source !== 'IFI') return canTalk === 'yes' ? !movingFurniture : !canTalk;
      if (title === 'Follow Up Call') {
        if (_this2.state.phase.source === 'IFI') return !customerUnsatisfied;
        return !jobNotFinished || jobNotFinished === 'no' && !customerUnsatisfied;
      }
      if (title === 'Follow Up Delivery Call') return !deliveryOkay;
      return !customerAnswered;
    }
  });
  Object.defineProperty(this, 'isWelcomeCall', {
    enumerable: true,
    writable: true,
    value: function value() {
      return _this2.props.phase.flags.some(function (f) {
        return f.name === 'Welcome Call Needed';
      });
    }
  });
  Object.defineProperty(this, 'determineTitle', {
    enumerable: true,
    writable: true,
    value: function value() {
      if (_this2.isWelcomeCall()) return 'Welcome Call';
      switch (_this2.state.phase.status) {
        case constants["_32" /* SCRIPT_STATUSES */][0]:
          return 'Job Review';
        case constants["_32" /* SCRIPT_STATUSES */][1]:
        case constants["_32" /* SCRIPT_STATUSES */][2]:
          return 'In Progress Call';
        case constants["_32" /* SCRIPT_STATUSES */][3]:
          return 'Follow Up Call';
        case constants["_32" /* SCRIPT_STATUSES */][4]:
          return 'Follow Up Delivery Call';
        default:
          return '';
      }
    }
  });
  Object.defineProperty(this, 'determineNoApptBlocked', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _state$phase$appointm = _this2.state.phase.appointments,
          appointments = _state$phase$appointm === undefined ? [] : _state$phase$appointm;

      if (_this2.determineTitle() === 'Job Review') {
        return !appointments.length || !appointments.some(function (a) {
          return a.kind === 'installation' && moment_default()(a.start_date, constants["_19" /* RAILS_DATE */]).isAfter(moment_default()());
        });
      }
      return false;
    }
  });
  Object.defineProperty(this, 'renderScriptBody', {
    enumerable: true,
    writable: true,
    value: function value(title) {
      var _state6 = _this2.state,
          _state6$phase = _state6.phase,
          status = _state6$phase.status,
          source = _state6$phase.source,
          phase = _state6.phase,
          customerAnswered = _state6.customerAnswered,
          jobNotFinished = _state6.jobNotFinished,
          deliveryOkay = _state6.deliveryOkay,
          customerUnsatisfied = _state6.customerUnsatisfied,
          movingFurniture = _state6.movingFurniture,
          originalFurnitureStatus = _state6.originalFurnitureStatus;

      if (_this2.isWelcomeCall()) {
        return react_default.a.createElement(welcomeCallScript, {
          title: title,
          phase: phase,
          customerAnswered: customerAnswered
        });
      }
      switch (status) {
        case constants["_32" /* SCRIPT_STATUSES */][0]:
          return react_default.a.createElement(jobReviewScript, {
            title: title,
            phase: phase,
            originalFurnitureStatus: originalFurnitureStatus,
            customerAnswered: customerAnswered,
            movingFurniture: movingFurniture,
            handleSpecificAnswered: _this2.handleSpecificAnswered
          });
        case constants["_32" /* SCRIPT_STATUSES */][1]:
        case constants["_32" /* SCRIPT_STATUSES */][2]:
          return react_default.a.createElement(inProgressCallScript, {
            title: title,
            customerAnswered: customerAnswered,
            source: source
          });
        case constants["_32" /* SCRIPT_STATUSES */][3]:
          return react_default.a.createElement(followUpCallScript, {
            title: title,
            customerAnswered: customerAnswered,
            jobNotFinished: jobNotFinished,
            customerUnsatisfied: customerUnsatisfied,
            handleBasicQuestion: _this2.handleBasicQuestion,
            source: source
          });
        case constants["_32" /* SCRIPT_STATUSES */][4]:
          return react_default.a.createElement(followUpDeliveryCallScript, {
            title: title,
            phase: phase,
            customerAnswered: customerAnswered,
            deliveryOkay: deliveryOkay,
            handleBasicQuestion: _this2.handleBasicQuestion
          });
        default:
          return null;
      }
    }
  });
  Object.defineProperty(this, 'render', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _state7 = _this2.state,
          phase = _state7.phase,
          customerAnswered = _state7.customerAnswered,
          commNote = _state7.commNote;

      var title = _this2.determineTitle();
      return react_default.a.createElement(
        react["Fragment"],
        null,
        react_default.a.createElement(scriptsIntro, {
          user: _this2.props.user,
          phase: phase,
          title: title,
          customerAnswered: customerAnswered,
          handleBasicQuestion: title === 'Job Review' ? _this2.handleSkipCanTalk : _this2.handleBasicQuestion
        }),
        customerAnswered && react_default.a.createElement(
          components_styledComponents_ContainerDiv,
          null,
          react_default.a.createElement(
            components_styledComponents_DropdownDiv,
            { condition: customerAnswered },
            _this2.renderScriptBody(title)
          )
        ),
        react_default.a.createElement(
          react_css_themr_lib["ThemeProvider"],
          { theme: phaseCommunications_theme },
          react_default.a.createElement(
            components_Card,
            { className: phaseCommunications_styles_default.a.card },
            react_default.a.createElement(
              'div',
              { className: phaseCommunications_styles_default.a.headerContainer },
              react_default.a.createElement(
                'h4',
                { className: phaseCommunications_styles_default.a.title },
                'End Of Call'
              )
            ),
            react_default.a.createElement(
              'div',
              { className: phaseCommunications_styles_default.a.scriptContainer },
              react_default.a.createElement(react_toolbox_lib["Input"], {
                label: 'Call Notes',
                multiline: true,
                theme: form_default.a,
                value: commNote || '',
                className: form_default.a.textArea,
                onChange: _this2.handleCommNote
              }),
              react_default.a.createElement('br', null),
              react_default.a.createElement(lib_button["Button"], {
                label: 'END COMMUNICATION',
                flat: true, inverse: true, ripple: true,
                disabled: _this2.determineSubmitDisabled(),
                className: phaseCommunications_styles_default.a.saveButton,
                onClick: function onClick() {
                  return _this2.finishCommunication();
                }
              })
            )
          )
        )
      );
    }
  });
};

PhaseCommunications.propTypes = {
  phase: types_phase.isRequired,
  role: prop_types_default.a.string.isRequired,
  user: prop_types_default.a.string.isRequired,
  navigate: prop_types_default.a.func.isRequired,
  updatePhase: prop_types_default.a.func.isRequired,
  updatePhaseTask: prop_types_default.a.func.isRequired,
  addEventToPhase: prop_types_default.a.func.isRequired,
  overridePhaseStatus: prop_types_default.a.func.isRequired,
  removeFlagFromPhase: prop_types_default.a.func.isRequired
};

/* harmony default export */ var phaseCommunications = (Object(react_redux_es["connect"])(function (state) {
  return {
    phase: state.phase.details,
    user: state.user.name,
    role: state.user.role
  };
}, {
  navigate: actionCreators["O" /* navigate */],
  updatePhase: actionCreators_phase["r" /* updatePhase */],
  updatePhaseTask: actionCreators_phase["s" /* updatePhaseTask */],
  addEventToPhase: actionCreators_phase["a" /* addEventToPhase */],
  overridePhaseStatus: actionCreators_phase["l" /* overridePhaseStatus */],
  removeFlagFromPhase: actionCreators_phase["m" /* removeFlagFromPhase */]
})(PhaseCommunications));
// EXTERNAL MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseMaterialsChecklist/styles.scss
var phaseMaterialsChecklist_styles = __webpack_require__("g4rU");
var phaseMaterialsChecklist_styles_default = /*#__PURE__*/__webpack_require__.n(phaseMaterialsChecklist_styles);

// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseMaterialsChecklist/index.jsx
function phaseMaterialsChecklist__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function phaseMaterialsChecklist__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function phaseMaterialsChecklist__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var phaseMaterialsChecklist_LINE_ITEM_TYPE = 'warehouseMerchandiseItems';

var PhaseMaterialsChecklist = function (_React$Component) {
  phaseMaterialsChecklist__inherits(PhaseMaterialsChecklist, _React$Component);

  function PhaseMaterialsChecklist(props) {
    phaseMaterialsChecklist__classCallCheck(this, PhaseMaterialsChecklist);

    var _this = phaseMaterialsChecklist__possibleConstructorReturn(this, (PhaseMaterialsChecklist.__proto__ || Object.getPrototypeOf(PhaseMaterialsChecklist)).call(this, props));

    phaseMaterialsChecklist__initialiseProps.call(_this);

    _this.handleLineItemChange = _this.handleLineItemChange.bind(_this);
    var _this$props = _this.props,
        phase = _this$props.phase,
        need_move_furniture = _this$props.phase.phase_specific.need_move_furniture,
        merchItems = _this$props.merchItems;

    _this.state = {
      phase: phase,
      originalFurnitureStatus: need_move_furniture,
      merchItems: merchItems,
      noteId: null,
      active: false,
      showErrorMessage: false
    };
    return _this;
  }

  return PhaseMaterialsChecklist;
}(react_default.a.Component);

var phaseMaterialsChecklist__initialiseProps = function _initialiseProps() {
  var _this2 = this;

  Object.defineProperty(this, 'componentWillMount', {
    enumerable: true,
    writable: true,
    value: function value() {
      return _this2.props.requestPhaseItems(_this2.props.params.id, 'warehouseMerchandiseItems');
    }
  });
  Object.defineProperty(this, 'componentDidUpdate', {
    enumerable: true,
    writable: true,
    value: function value(prevProps) {
      return !Object(lodash["isEqual"])(prevProps.merchItems, _this2.props.merchItems) ? _this2.setState({ merchItems: _this2.props.merchItems }) : null;
    }
  });
  Object.defineProperty(this, 'handleLineItemChange', {
    enumerable: true,
    writable: true,
    value: function value(key) {
      var editedItemList = _this2.state.merchItems.map(function (i) {
        var editedItem = i;
        if (i.id === key) {
          editedItem.date_received = !i.date_received ? moment_default()().format(constants["_19" /* RAILS_DATE */]) : null;
        }
        return editedItem;
      });
      _this2.setState({ merchItems: editedItemList });
    }
  });
  Object.defineProperty(this, 'handleTextNote', {
    enumerable: true,
    writable: true,
    value: function value(e, key) {
      var note = e.target.value;
      var editedItemList = _this2.state.merchItems.map(function (i) {
        var editedItem = i;
        if (i.id === key) editedItem.note = note;
        return editedItem;
      });
      _this2.setState({ deliveryNote: editedItemList });
    }
  });
  Object.defineProperty(this, 'showNoteModal', {
    enumerable: true,
    writable: true,
    value: function value(id) {
      return _this2.setState({ noteId: id, active: true });
    }
  });
  Object.defineProperty(this, 'hideNoteModal', {
    enumerable: true,
    writable: true,
    value: function value() {
      return _this2.setState({ active: false, noteId: null });
    }
  });
  Object.defineProperty(this, 'releaseItems', {
    enumerable: true,
    writable: true,
    value: function value(items) {
      return items.map(function (i) {
        var editedItem = i;
        editedItem.status = i.date_received ? 'Released' : i.status;
        return editedItem;
      });
    }
  });
  Object.defineProperty(this, 'navigateToHistory', {
    enumerable: true,
    writable: true,
    value: function value(phase) {
      return _this2.props.navigate(urls.phaseHistory(phase));
    }
  });
  Object.defineProperty(this, 'handleChecklistSubmit', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _state = _this2.state,
          merchItems = _state.merchItems,
          phase = _state.phase,
          id = _state.phase.id;

      var filterForUncheckedItems = _this2.state.merchItems.filter(function (i) {
        return !i.date_received && !i.note;
      });
      if (filterForUncheckedItems.length > 0) _this2.setState({ showErrorMessage: true });else {
        Promise.all(_this2.releaseItems(merchItems).map(function (i) {
          return _this2.props.savePhaseItem(_this2.state.phase.id, i, phaseMaterialsChecklist_LINE_ITEM_TYPE);
        })).then(function () {
          return _this2.props.updatePhaseTask(id, 'check_out_of_store', {
            task: { status: 'complete' } });
        }).then(function () {
          return _this2.navigateToHistory(phase);
        }).catch(function () {});
      }
    }
  });
  Object.defineProperty(this, 'render', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _state2 = _this2.state,
          showErrorMessage = _state2.showErrorMessage,
          active = _state2.active,
          merchItems = _state2.merchItems,
          noteId = _state2.noteId;

      return react_default.a.createElement(
        'div',
        null,
        react_default.a.createElement(
          'div',
          { className: phaseMaterialsChecklist_styles_default.a.submitBtnContainer },
          react_default.a.createElement(
            'h4',
            { className: phaseMaterialsChecklist_styles_default.a.checklistHeading },
            'Material Checklist'
          ),
          react_default.a.createElement(ColoredButton["a" /* default */], {
            id: 'checklistSubmitBtn',
            color: 'red',
            responsive: true,
            label: 'Submit',
            className: 'd-none',
            onClick: _this2.handleChecklistSubmit
          })
        ),
        react_default.a.createElement(
          'p',
          { style: { textAlign: 'center', color: 'red' } },
          showErrorMessage ? 'All items must be checked or a note must be provided prior to submitting.' : ''
        ),
        react_default.a.createElement(
          'table',
          { style: phaseMaterialsChecklist_styles_default.a.table },
          react_default.a.createElement(
            'thead',
            null,
            react_default.a.createElement(
              'tr',
              null,
              react_default.a.createElement(
                'th',
                null,
                'Item Description'
              ),
              react_default.a.createElement(
                'th',
                null,
                'Received'
              ),
              react_default.a.createElement(
                'th',
                null,
                'Note'
              )
            )
          ),
          react_default.a.createElement(
            'tbody',
            null,
            merchItems.map(function (item) {
              return react_default.a.createElement(
                'tr',
                { key: item.id },
                react_default.a.createElement(
                  'td',
                  null,
                  '' + item.item_name,
                  ' ',
                  react_default.a.createElement('br', null),
                  ' ',
                  '(Qty: ' + item.received_quantity + ')'
                ),
                react_default.a.createElement(
                  'td',
                  null,
                  react_default.a.createElement('input', {
                    id: 'mainInput',
                    type: 'checkbox',
                    checked: !!item.date_received,
                    onChange: function onChange() {
                      return _this2.handleLineItemChange(item.id);
                    }
                  })
                ),
                react_default.a.createElement(
                  'td',
                  null,
                  react_default.a.createElement(
                    'button',
                    { onClick: function onClick() {
                        return _this2.showNoteModal(item.id);
                      } },
                    'Add Note'
                  )
                )
              );
            })
          )
        ),
        react_default.a.createElement(
          react_toolbox_lib["Dialog"],
          {
            active: active && noteId, className: phaseMaterialsChecklist_styles_default.a.modal, type: 'large',
            onEscKeyDown: _this2.handleClose, onOverlayClick: _this2.handleClose
          },
          react_default.a.createElement(
            'h5',
            null,
            'Note'
          ),
          react_default.a.createElement(
            'div',
            null,
            react_default.a.createElement(
              'div',
              null,
              react_default.a.createElement('textarea', {
                rows: 6, style: { width: '100%' },
                onChange: function onChange() {
                  return _this2.handleTextNote(event, noteId);
                }
              })
            ),
            react_default.a.createElement(ColoredButton["a" /* default */], {
              color: 'blue',
              responsive: true,
              label: 'Done',
              className: 'd-none',
              onClick: _this2.hideNoteModal
            })
          )
        )
      );
    }
  });
};

PhaseMaterialsChecklist.propTypes = {
  phase: types_phase.isRequired,
  merchItems: prop_types_default.a.array,
  role: prop_types_default.a.string.isRequired,
  user: prop_types_default.a.string.isRequired,
  navigate: prop_types_default.a.func.isRequired,
  updatePhase: prop_types_default.a.func.isRequired,
  updatePhaseTask: prop_types_default.a.func.isRequired,
  requestPhaseItems: prop_types_default.a.func,
  savePhaseItem: prop_types_default.a.func,
  params: prop_types_default.a.shape({
    id: prop_types_default.a.string
  })
};

var phaseMaterialsChecklist_mapStateToProps = function mapStateToProps(state) {
  var _state$phase = state.phase,
      _state$phase$details = _state$phase.details,
      details = _state$phase$details === undefined ? {} : _state$phase$details,
      _state$phase$warehous = _state$phase.warehouseMerchandiseItems,
      warehouseMerchandiseItems = _state$phase$warehous === undefined ? { items: [] } : _state$phase$warehous,
      _state$user = state.user,
      name = _state$user.name,
      role = _state$user.role;
  var items = warehouseMerchandiseItems.items;

  return {
    phase: details,
    user: name,
    role: role,
    merchItems: items.length ? items.filter(function (item) {
      return !!item.item_name;
    }) : []
  };
};

/* harmony default export */ var phaseMaterialsChecklist = (Object(react_redux_es["connect"])(phaseMaterialsChecklist_mapStateToProps, {
  navigate: actionCreators["O" /* navigate */],
  updatePhase: actionCreators_phase["r" /* updatePhase */],
  updatePhaseTask: actionCreators_phase["s" /* updatePhaseTask */],
  WarehouseMaterials: warehouseMaterials,
  requestPhaseItems: phase_items["i" /* requestPhaseItems */],
  savePhaseItem: phase_items["k" /* savePhaseItem */]
})(PhaseMaterialsChecklist));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/index.jsx
function phaseShow__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function phaseShow__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function phaseShow__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function phaseShow__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


































// import PhaseSurvey from './tabs/phaseSurvey';



var QUICK_SCHEDULE_POLL_MS = 60000;

var phaseShow_PhaseShow = function (_React$Component) {
  phaseShow__inherits(PhaseShow, _React$Component);

  function PhaseShow() {
    var _ref;

    var _temp, _this, _ret;

    phaseShow__classCallCheck(this, PhaseShow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = phaseShow__possibleConstructorReturn(this, (_ref = PhaseShow.__proto__ || Object.getPrototypeOf(PhaseShow)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'componentDidMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            id = _this$props.id,
            phase = _this$props.phase,
            employeeId = _this$props.employeeId,
            employeeType = _this$props.employeeType,
            propLoad = _this$props.loadPhase,
            propEmployee = _this$props.requestEmployee;

        _this.updateActiveTabFromLocation();
        if (!phase || id !== phase.id) propLoad(id);
        if (employeeType === 'Employee') propEmployee(employeeId);
        if (_this.shouldQuickSchedulePoll(phase, _this.props.location)) _this.startQuickSchedulePoll();
      }
    }), Object.defineProperty(_this, 'componentWillReceiveProps', {
      enumerable: true,
      writable: true,
      value: function value(nextProps) {
        var _this$props2 = _this.props,
            id = _this$props2.id,
            pathname = _this$props2.location.pathname,
            propLoad = _this$props2.loadPhase;

        if (id !== nextProps.id) propLoad(nextProps.id).then(_this.updateActiveTabFromLocation);else if (pathname !== nextProps.location.pathname) _this.updateActiveTabFromLocation(nextProps);

        var wasPolling = !!_this.quickSchedulePoll;
        var willPoll = _this.shouldQuickSchedulePoll(nextProps.phase, nextProps.location);
        if (willPoll && !wasPolling) _this.startQuickSchedulePoll();else if (!willPoll && wasPolling) _this.stopQuickSchedulePoll();
      }
    }), Object.defineProperty(_this, 'componentWillUnmount', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.stopQuickSchedulePoll();
        return _this.props.ui.successMessage ? _this.props.updateUI('successMessage', '') : null;
      }
    }), Object.defineProperty(_this, 'getPhaseTabs', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props$phase = _this.props.phase,
            phase_tasks = _this$props$phase.phase_tasks,
            status = _this$props$phase.status,
            type = _this$props$phase.type,
            _this$props$phase$app = _this$props$phase.appointments,
            appointments = _this$props$phase$app === undefined ? [] : _this$props$phase$app;

        return constants["_13" /* PHASE_DETAILS_TABS */].filter(function (tab) {
          return tab.phaseTypes.indexOf(type) > -1;
        }).filter(function (tab) {
          return _this.taskAndStatusFilters(tab.label, status, phase_tasks, appointments);
        });
      }
    }), Object.defineProperty(_this, 'getTabBarColor', {
      enumerable: true,
      writable: true,
      value: function value(phaseObj) {
        var defaultStyle = phaseDetailsBar_default.a.tabs;
        if (phaseObj) {
          var _phaseObj$source = phaseObj.source,
              source = _phaseObj$source === undefined ? null : _phaseObj$source,
              _phaseObj$workroom = phaseObj.workroom,
              workroom = _phaseObj$workroom === undefined ? null : _phaseObj$workroom;

          var vendor = source;
          if (workroom && workroom.name.includes('PFT-')) vendor = 'PFT';else if (!constants["_51" /* VENDORS */].includes(_this.isLhi() ? 'LHI' : vendor)) return defaultStyle;
          return phaseDetailsBar_default.a[vendor.toLowerCase() + 'Tabs'];
        }
        return defaultStyle;
      }
    }), Object.defineProperty(_this, 'getRelatedColor', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.isLhi() ? phaseDetailsBar_default.a.lowesRelatedPhases : phaseDetailsBar_default.a.relatedCount;
      }
    }), Object.defineProperty(_this, 'shouldQuickSchedulePoll', {
      enumerable: true,
      writable: true,
      value: function value(phase, location) {
        return !!(phase && phase.pending_quick_schedule_response && location && location.pathname && location.pathname.indexOf('/appointments') > -1);
      }
    }), Object.defineProperty(_this, 'startQuickSchedulePoll', {
      enumerable: true,
      writable: true,
      value: function value() {
        if (_this.quickSchedulePoll) return;
        _this.quickSchedulePoll = setInterval(function () {
          return _this.props.loadPhase(_this.props.id);
        }, QUICK_SCHEDULE_POLL_MS);
      }
    }), Object.defineProperty(_this, 'stopQuickSchedulePoll', {
      enumerable: true,
      writable: true,
      value: function value() {
        if (!_this.quickSchedulePoll) return;
        clearInterval(_this.quickSchedulePoll);
        _this.quickSchedulePoll = null;
      }
    }), Object.defineProperty(_this, 'isLhi', {
      enumerable: true,
      writable: true,
      value: function value() {
        return Object(utils["D" /* validateSource */])(_this.props.phase.source);
      }
    }), Object.defineProperty(_this, 'taskAndStatusFilters', {
      enumerable: true,
      writable: true,
      value: function value(tab, status, phaseTasks, phaseAppts) {
        switch (tab) {
          case 'Contract Verification Checklist':
            return _this.cVFilter(status, phaseTasks);
          case 'Scheduling Checklist':
            return _this.schedulingFilter(status, phaseTasks);
          case 'Communication Scripts':
            return _this.scriptsFilter(status, phaseTasks, phaseAppts);
          default:
            return true;
        }
      }
    }), Object.defineProperty(_this, 'isTaskStatusComplete', {
      enumerable: true,
      writable: true,
      value: function value(tasks, name) {
        return (Object(lodash["find"])(tasks, { name: name }) || {}).status === 'complete';
      }
    }), Object.defineProperty(_this, 'basicStatusFilter', {
      enumerable: true,
      writable: true,
      value: function value(tab, requiredStatus, status, phaseTasks) {
        return !(status !== requiredStatus || _this.isTaskStatusComplete(phaseTasks, tab));
      }
    }), Object.defineProperty(_this, 'cVFilter', {
      enumerable: true,
      writable: true,
      value: function value(tab, status, phaseTasks) {
        return _this.basicStatusFilter(tab, 'receiving', status, phaseTasks);
      }
    }), Object.defineProperty(_this, 'schedulingFilter', {
      enumerable: true,
      writable: true,
      value: function value(tab, status, phaseTasks) {
        return _this.basicStatusFilter(tab, 'scheduling', status, phaseTasks);
      }
    }), Object.defineProperty(_this, 'scriptsFilter', {
      enumerable: true,
      writable: true,
      value: function value(status, phaseTasks, phaseAppts) {
        if (!constants["_32" /* SCRIPT_STATUSES */].includes(status)) return false;
        var _this$props$phase$typ = _this.props.phase.type,
            type = _this$props$phase$typ === undefined ? '' : _this$props$phase$typ;

        switch (status) {
          case constants["_32" /* SCRIPT_STATUSES */][0]:
            return _this.validApptsExist(phaseAppts) && !_this.isTaskStatusComplete(phaseTasks, 'Customer Review');
          case constants["_32" /* SCRIPT_STATUSES */][1]:
          case constants["_32" /* SCRIPT_STATUSES */][2]:
            return !_this.isTaskStatusComplete(phaseTasks, 'In Progress Call');
          case constants["_32" /* SCRIPT_STATUSES */][3]:
            return type === 'Installation' && !_this.isTaskStatusComplete(phaseTasks, 'Follow Up Call');
          case constants["_32" /* SCRIPT_STATUSES */][4]:
            return type === 'Installation' && !_this.isTaskStatusComplete(phaseTasks, 'Follow Up Delivery Call');
          default:
            return false;
        }
      }
    }), Object.defineProperty(_this, 'validApptsExist', {
      enumerable: true,
      writable: true,
      value: function value(phaseAppts) {
        return [phaseAppts.length, Object(dateUtils["a" /* filterApptsByTodayOrLater */])(phaseAppts).length].every(function (l) {
          return l > 0;
        });
      }
    }), Object.defineProperty(_this, 'updateActiveTabFromLocation', {
      enumerable: true,
      writable: true,
      value: function value() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;
        var location = props.location,
            updateUI = props.updateUI;

        var tabObject = Object(lodash["find"])(constants["_13" /* PHASE_DETAILS_TABS */], function (tab) {
          return location.pathname.indexOf('/' + tab.path) > -1;
        });
        if (!tabObject) return;
        updateUI('activeTab', tabObject.path);
      }
    }), Object.defineProperty(_this, 'handleTabChange', {
      enumerable: true,
      writable: true,
      value: function value(tabIndex) {
        var path = _this.getPhaseTabs()[tabIndex].path;
        _this.props.updateUI('activeTab', path);
        _this.props.navigate('/phases/' + _this.props.id + '/' + path);
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props3 = _this.props,
            loading = _this$props3.loading,
            phase = _this$props3.phase,
            ui = _this$props3.ui,
            role = _this$props3.role,
            position = _this$props3.position,
            relatedCount = _this$props3.relatedCount,
            employeeType = _this$props3.employeeType,
            canViewWorkroom = _this$props3.canViewWorkroom,
            mvw = _this$props3.mvw;

        return loading ? react_default.a.createElement(components_Loading, null) : react_default.a.createElement(
          react["Fragment"],
          null,
          react_default.a.createElement(Helmet_default.a, { title: phase.customer_name }),
          react_default.a.createElement(components_phaseDetailsBar, {
            phase: phase,
            role: role,
            position: position,
            mvw: mvw,
            canViewWorkroom: canViewWorkroom
          }),
          react_default.a.createElement(components_phaseTaskBar, { phase: phase, role: role, employeeType: employeeType }),
          react_default.a.createElement(
            react_css_themr_lib["ThemeProvider"],
            { theme: { RTTabs: phaseDetailsBar_default.a } },
            react_default.a.createElement(
              react_toolbox_lib["Tabs"],
              {
                index: Object(lodash["findIndex"])(_this.getPhaseTabs(), function (tab) {
                  return tab.path === ui.activeTab;
                }),
                onChange: _this.handleTabChange,
                className: _this.getTabBarColor(phase)
              },
              _this.getPhaseTabs().map(function (tab) {
                var _cx;

                var label = tab.label,
                    ability = tab.ability;

                var relatedTab = label === 'Related Phases';
                return react_default.a.createElement(react_toolbox_lib["Tab"], {
                  key: tab.routeName,
                  label: relatedTab ? label + ' (' + relatedCount + ')' : label,
                  className: classnames_default()((_cx = {}, phaseShow__defineProperty(_cx, phaseDetailsBar_default.a.phaseTab, true), phaseShow__defineProperty(_cx, _this.getRelatedColor(), relatedTab && relatedCount > 0), phaseShow__defineProperty(_cx, phaseDetailsBar_default.a.hidden, !Object(services["a" /* can */])(role, 'view', ability) || phase.source === 'IFI' && label === 'Materials'), _cx))
                });
              })
            )
          ),
          react_default.a.createElement(
            flexbox_react_dist_default.a,
            null,
            react_default.a.createElement(
              'div',
              {
                className: contentArea_default.a.contentAreaContainer,
                style: { paddingBottom: '100px' }
              },
              ui.successMessage ? react_default.a.createElement(MessageBox["a" /* default */], { message: ui.successMessage }) : null,
              _this.props.children
            )
          ),
          react_default.a.createElement(phaseActionMenu, { phase: phase, role: role, position: position, mvw: mvw })
        );
      }
    }), _temp), phaseShow__possibleConstructorReturn(_this, _ret);
  }

  return PhaseShow;
}(react_default.a.Component);

phaseShow_PhaseShow.propTypes = {
  id: prop_types_default.a.number,
  employeeId: prop_types_default.a.number,
  employeeType: prop_types_default.a.string,
  ui: prop_types_default.a.shape({
    activeTab: prop_types_default.a.string,
    successMessage: prop_types_default.a.string
  }),
  loading: prop_types_default.a.bool,
  phase: types_phase,
  role: prop_types_default.a.string.isRequired,
  position: prop_types_default.a.string.isRequired,
  mvw: prop_types_default.a.object,
  updateUI: prop_types_default.a.func.isRequired,
  loadPhase: prop_types_default.a.func.isRequired,
  navigate: prop_types_default.a.func.isRequired,
  requestEmployee: prop_types_default.a.func.isRequired,
  children: prop_types_default.a.element.isRequired,
  location: prop_types_default.a.object,
  relatedCount: prop_types_default.a.number,
  canViewWorkroom: prop_types_default.a.bool
};

var phaseShow_mapStateToProps = function mapStateToProps(state, ownProps) {
  var _state$user = state.user,
      employable_id = _state$user.employable_id,
      employable_type = _state$user.employable_type,
      role = _state$user.role,
      position = _state$user.position,
      _state$user$manage_ve = _state$user.manage_vendor_workrooms,
      mvw = _state$user$manage_ve === undefined ? {} : _state$user$manage_ve,
      _state$phase = state.phase,
      details = _state$phase.details,
      loaded = _state$phase.details.loaded,
      related = _state$phase.related,
      phase = state.phase;

  return {
    id: Number(ownProps.params.id),
    phase: loaded ? details : null,
    relatedCount: related.count,
    role: role,
    position: position,
    mvw: mvw,
    employeeId: employable_id,
    employeeType: employable_type,
    loading: phase ? !loaded : true,
    canViewWorkroom: Object(services["a" /* can */])(role, 'view', 'workroom')
  };
};

/* harmony default export */ var phaseShow = (transpiled_default()()(Object(react_redux_es["connect"])(phaseShow_mapStateToProps, {
  loadPhase: actionCreators["G" /* loadPhase */], navigate: actionCreators["O" /* navigate */], requestEmployee: actionCreators["X" /* requestEmployee */]
})(phaseShow_PhaseShow)));


// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/index.jsx









var Phases = function Phases(_ref) {
  var children = _ref.children;
  return children;
};

Phases.propTypes = {
  children: prop_types_default.a.element.isRequired
};

/* harmony default export */ var screens_phases = (transpiled_default()({
  key: 'phases',
  state: {
    successMessage: '',
    activeTab: '',
    foldersActive: []
  }
})(Phases));


// CONCATENATED MODULE: ./client/app/shared/components/Filters/WorkroomFilters/index.jsx
var WorkroomFilters__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var WorkroomFilters__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function WorkroomFilters__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function WorkroomFilters__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function WorkroomFilters__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var WorkroomFilters_WorkroomFilters = function (_Component) {
  WorkroomFilters__inherits(WorkroomFilters, _Component);

  function WorkroomFilters() {
    var _ref;

    var _temp, _this, _ret;

    WorkroomFilters__classCallCheck(this, WorkroomFilters);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = WorkroomFilters__possibleConstructorReturn(this, (_ref = WorkroomFilters.__proto__ || Object.getPrototypeOf(WorkroomFilters)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'handleFilter', {
      enumerable: true,
      writable: true,
      value: function value(key, _value) {
        var filters = WorkroomFilters__extends({}, _this.props.filters);
        filters[key] = _value;

        _this.props.handleFilterChange(filters);
      }
    }), Object.defineProperty(_this, 'handleActive', {
      enumerable: true,
      writable: true,
      value: function value(_value2) {
        return _this.handleFilter('is_active', _value2);
      }
    }), _temp), WorkroomFilters__possibleConstructorReturn(_this, _ret);
  }

  WorkroomFilters__createClass(WorkroomFilters, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          filters = _props.filters,
          active = _props.active,
          title = _props.title,
          reset = _props.reset;

      return react_default.a.createElement(
        components_FiltersDrawer,
        {
          title: title,
          active: active,
          toggle: this.props.onOverlayClick,
          reset: reset
        },
        react_default.a.createElement(formElements_ActiveSelect, {
          key: 'active',
          className: Filters_styles_default.a.dropdown,
          value: filters.is_active,
          onChange: this.handleActive
        })
      );
    }
  }]);

  return WorkroomFilters;
}(react["Component"]);

WorkroomFilters_WorkroomFilters.propTypes = {
  handleFilterChange: prop_types_default.a.func,
  onOverlayClick: prop_types_default.a.func,
  filters: prop_types_default.a.object,
  active: prop_types_default.a.bool,
  title: prop_types_default.a.string.isRequired,
  reset: prop_types_default.a.func.isRequired
};

/* harmony default export */ var Filters_WorkroomFilters = (WorkroomFilters_WorkroomFilters);
// CONCATENATED MODULE: ./client/app/screens/main/screens/workrooms/components/workroomCard.jsx
function workroomCard__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }










var workroomCard_WorkroomCard = function WorkroomCard(_ref) {
  var _cx;

  var workroom = _ref.workroom;
  return react_default.a.createElement(
    es["c" /* Link */],
    { className: resourceCard_default.a.viewLink, to: urls.workroom(workroom) },
    react_default.a.createElement(
      components_Card,
      {
        key: workroom.id,
        className: classnames_default()((_cx = {}, workroomCard__defineProperty(_cx, resourceCard_default.a.inactive, !workroom.active), workroomCard__defineProperty(_cx, resourceCard_default.a.resourceCard, true), _cx)),
        inactive: !workroom.active
      },
      react_default.a.createElement(ResourceCardElement, { title: 'Workroom Name', size: 'small', value: workroom.name }),
      react_default.a.createElement(ResourceCardElement, { title: 'Address', size: 'small', value: workroom.address }),
      react_default.a.createElement(ResourceCardElement, { title: 'City', size: 'small', value: workroom.city }),
      react_default.a.createElement(ResourceCardElement, { title: 'State', size: 'small', value: workroom.state }),
      react_default.a.createElement(ResourceCardElement, { title: 'Zip', size: 'small', value: workroom.zip_code }),
      react_default.a.createElement(ResourceCardElement, { title: 'Phone Number', size: 'small', value: workroom.phone_number })
    )
  );
};

workroomCard_WorkroomCard.propTypes = {
  workroom: types_workroom.isRequired
};

/* harmony default export */ var workroomCard = (workroomCard_WorkroomCard);
// CONCATENATED MODULE: ./client/app/screens/main/screens/workrooms/workroomList.jsx
var workroomList__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function workroomList__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function workroomList__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function workroomList__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var workroomList_WorkroomList = function (_Component) {
  workroomList__inherits(WorkroomList, _Component);

  function WorkroomList() {
    workroomList__classCallCheck(this, WorkroomList);

    return workroomList__possibleConstructorReturn(this, (WorkroomList.__proto__ || Object.getPrototypeOf(WorkroomList)).apply(this, arguments));
  }

  workroomList__createClass(WorkroomList, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.requestWorkroomList();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.ui.successMessage) {
        this.props.updateUI('successMessage', '');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          workrooms = _props.workrooms,
          loading = _props.loading;


      return react_default.a.createElement(
        'div',
        null,
        this.props.ui.successMessage && react_default.a.createElement(MessageBox["a" /* default */], { message: this.props.ui.successMessage }),
        loading && react_default.a.createElement(components_Loading, { message: 'Loading workrooms...' }),
        workrooms.map(function (workroom) {
          return react_default.a.createElement(workroomCard, {
            key: workroom.id,
            workroom: workroom
          });
        })
      );
    }
  }]);

  return WorkroomList;
}(react["Component"]);

Object.defineProperty(workroomList_WorkroomList, 'propTypes', {
  enumerable: true,
  writable: true,
  value: {
    ui: prop_types_default.a.object,
    loading: prop_types_default.a.bool,
    needsMore: prop_types_default.a.bool,
    workrooms: prop_types_default.a.array,
    updateUI: prop_types_default.a.func,
    dispatch: prop_types_default.a.func,
    requestWorkroomList: prop_types_default.a.func
  }
});

var workroomList_mapStateToProps = function mapStateToProps(state) {
  var workrooms = Object(reducers["_37" /* getWorkroomList */])(state);
  var loading = Object(reducers["_39" /* getWorkroomLoading */])(state);
  return {
    loading: loading,
    workrooms: workrooms
  };
};

/* harmony default export */ var workroomList = (transpiled_default()()(Object(react_redux_es["connect"])(workroomList_mapStateToProps, { requestWorkroomList: actionCreators["_31" /* requestWorkroomList */] })(workroomList_WorkroomList)));
// CONCATENATED MODULE: ./client/app/screens/main/screens/workrooms/components/workroomDetailsCard.jsx
var workroomDetailsCard__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };















var workroomDetailsCard_detailsTheme = { RTCard: resourceDetailsCard_default.a, ResourceDetailsCE: detailsCardElement_default.a };

var filterUsersByRole = function filterUsersByRole(user, role) {
  if (role === 'estimator') {
    return ['Estimation Coordinator', 'Installation Service Manager', 'Quality Assurance Specialist'].includes(user.position);
  }
  if (role === 'installer') {
    return ['Installation Coordinator', 'Installation Service Manager', 'Quality Assurance Specialist', 'Area Installation Specialist'].includes(user.position);
  }
  return true;
};

var workroomDetailsCard_WorkroomDetailsCard = function WorkroomDetailsCard(props) {
  var workroom = props.workroom,
      canEdit = props.canEdit,
      users = props.users,
      role = props.role;
  var vendor = workroom.vendor;

  var statusText = workroom.active ? 'Active' : 'Inactive';
  var EditAction = react_default.a.createElement(
    components_RouterLink,
    { className: resourceDetailsCard_default.a.detailsLink, to: '/workrooms/' + workroom.id + '/edit' },
    react_default.a.createElement(
      'span',
      { className: resourceDetailsCard_default.a.editText },
      vendor === 'IFI' ? 'Edit District' : 'Edit Workroom'
    )
  );
  var sortedUsers = users.sort(function (a, b) {
    if (a.employable_type < b.employable_type) return -1;
    if (a.employable_type > b.employable_type) return 1;
    return 0;
  }).filter(function (user) {
    return filterUsersByRole(user, role);
  }).map(function (user) {
    return workroomDetailsCard__extends({}, user, { id: user.employable_id });
  });
  return react_default.a.createElement(
    react_css_themr_lib["ThemeProvider"],
    { theme: workroomDetailsCard_detailsTheme },
    react_default.a.createElement(
      'div',
      null,
      react_default.a.createElement(
        components_Card,
        null,
        react_default.a.createElement(
          'section',
          { className: detailsSection_default.a.section },
          react_default.a.createElement(
            flexbox_react_dist_default.a,
            { justifyContent: 'space-between' },
            react_default.a.createElement(
              'div',
              null,
              react_default.a.createElement(
                'div',
                { className: resourceDetailsCard_default.a.mainTitle },
                react_default.a.createElement(
                  'span',
                  { className: resourceDetailsCard_default.a.boldWord },
                  workroom.name,
                  ' '
                ),
                react_default.a.createElement(
                  'span',
                  { className: workroom.active ? resourceDetailsCard_default.a.activeText : resourceDetailsCard_default.a.inactiveText },
                  '(',
                  statusText,
                  ')'
                )
              ),
              react_default.a.createElement(components_DetailsAddress, {
                className: resourceDetailsCard_default.a.mainSubtitle,
                address: workroom.address,
                city: workroom.city,
                state: workroom.state,
                zipCode: workroom.zip_code
              })
            ),
            canEdit ? EditAction : null
          )
        ),
        react_default.a.createElement('hr', { className: resourceDetailsCard_default.a.dividerLine }),
        react_default.a.createElement(
          'section',
          { className: detailsSection_default.a.section },
          react_default.a.createElement(
            flexbox_react_dist_default.a,
            { flexWrap: 'wrap', className: resourceDetailsCard_default.a.detailsElementContainer },
            react_default.a.createElement(ResourceDetailsCardElement, { title: 'vendor', value: workroom.vendor }),
            react_default.a.createElement(
              ResourceDetailsCardElement,
              { title: 'phone number' },
              workroom.phone_number
            ),
            react_default.a.createElement(ResourceDetailsCardElement, { title: 'accounting id', value: workroom.accounting_id }),
            react_default.a.createElement(ResourceDetailsCardElement, { title: 'inventory id', value: workroom.inventory_id })
          )
        )
      ),
      react_default.a.createElement(
        'div',
        null,
        sortedUsers.map(function (user) {
          return react_default.a.createElement(users_UserCard, {
            key: user.id + '-' + user.employable_type,
            user: user,
            type: user.employable_type + 's',
            showEmployableType: true,
            clickable: role !== 'estimator' && role !== 'installer'
          });
        })
      )
    )
  );
};

workroomDetailsCard_WorkroomDetailsCard.defaultProps = { users: [] };

workroomDetailsCard_WorkroomDetailsCard.propTypes = {
  workroom: types_workroom.isRequired,
  canEdit: prop_types_default.a.bool,
  users: prop_types_default.a.array,
  role: prop_types_default.a.string
};

/* harmony default export */ var workroomDetailsCard = (workroomDetailsCard_WorkroomDetailsCard);
// CONCATENATED MODULE: ./client/app/screens/main/screens/workrooms/workroomDetails.jsx
function workroomDetails__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function workroomDetails__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function workroomDetails__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var workroomDetails_WorkroomDetails = function (_React$Component) {
  workroomDetails__inherits(WorkroomDetails, _React$Component);

  function WorkroomDetails() {
    var _ref;

    var _temp, _this, _ret;

    workroomDetails__classCallCheck(this, WorkroomDetails);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = workroomDetails__possibleConstructorReturn(this, (_ref = WorkroomDetails.__proto__ || Object.getPrototypeOf(WorkroomDetails)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'componentDidMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.requestWorkroom(_this.props.id);
      }
    }), Object.defineProperty(_this, 'componentWillUnmount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.ui.successMessage ? _this.props.updateUI('successMessage', '') : null;
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            loading = _this$props.loading,
            workroom = _this$props.workroom,
            canEdit = _this$props.canEdit,
            ui = _this$props.ui,
            role = _this$props.role;

        return react_default.a.createElement(
          'div',
          null,
          ui.successMessage ? react_default.a.createElement(MessageBox["a" /* default */], { message: ui.successMessage }) : null,
          loading ? react_default.a.createElement(components_Loading, null) : react_default.a.createElement(workroomDetailsCard, {
            canEdit: canEdit, workroom: workroom, users: workroom.users, role: role
          })
        );
      }
    }), _temp), workroomDetails__possibleConstructorReturn(_this, _ret);
  }

  return WorkroomDetails;
}(react_default.a.Component);

workroomDetails_WorkroomDetails.propTypes = {
  loading: prop_types_default.a.bool,
  canEdit: prop_types_default.a.bool,
  workroom: prop_types_default.a.object,
  ui: prop_types_default.a.object,
  updateUI: prop_types_default.a.func,
  id: prop_types_default.a.number,
  requestWorkroom: prop_types_default.a.func,
  role: prop_types_default.a.string
};

function workroomDetails_mapStateToProps(state, ownProps) {
  var id = Number(ownProps.params.id);
  var workroom = Object(reducers["_33" /* getWorkroomById */])(state)(id);
  var loading = workroom ? workroom.loading : true;
  var role = Object(reducers["_12" /* getRole */])(state);
  return {
    id: id,
    workroom: workroom,
    canEdit: Object(services["a" /* can */])(role, 'update', 'workroom'),
    role: role,
    loading: loading
  };
}

/* harmony default export */ var workroomDetails = (transpiled_default()()(Object(react_redux_es["connect"])(workroomDetails_mapStateToProps, { requestWorkroom: actionCreators["_30" /* requestWorkroom */] })(workroomDetails_WorkroomDetails)));
// CONCATENATED MODULE: ./client/app/screens/main/screens/workrooms/components/workroomForm.jsx
var workroomForm__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var workroomForm__cx;

function workroomForm__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function workroomForm__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function workroomForm__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function workroomForm__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






















var workroomForm_theme = { RTInput: input_default.a, RTDropdown: dropdown_default.a, RTCard: styles_card_default.a, RTSwitch: switch_default.a };
var workroomForm_mediumInput = classnames_default()((workroomForm__cx = {}, workroomForm__defineProperty(workroomForm__cx, form_default.a.inputs, true), workroomForm__defineProperty(workroomForm__cx, form_default.a.largeInput, true), workroomForm__cx));
var workroomForm_cancelClass = classnames_default()([form_default.a.cancelButton, form_default.a.actionButton]);
var STATE_OPTIONS = constants["_35" /* STATES */].map(function (state) {
  return { value: state, label: state };
});

var workroomForm_WorkroomForm = function (_Component) {
  workroomForm__inherits(WorkroomForm, _Component);

  function WorkroomForm(props) {
    workroomForm__classCallCheck(this, WorkroomForm);

    var _this = workroomForm__possibleConstructorReturn(this, (WorkroomForm.__proto__ || Object.getPrototypeOf(WorkroomForm)).call(this, props));

    workroomForm__initialiseProps.call(_this);

    _this.handleSave = _this.handleSave.bind(_this);
    _this.handleActive = _this.handleChange.bind(_this, 'active');
    _this.handleIhq = _this.handleChange.bind(_this, 'ihq');
    _this.handleName = _this.handleChange.bind(_this, 'name');
    _this.handleAccountingId = _this.handleChange.bind(_this, 'accounting_id');
    _this.handleInventoryId = _this.handleChange.bind(_this, 'inventory_id');
    _this.handleAddress = _this.handleChange.bind(_this, 'address');
    _this.handleCity = _this.handleChange.bind(_this, 'city');
    _this.handleState = _this.handleChange.bind(_this, 'state');
    _this.handleZip = _this.handleChange.bind(_this, 'zip_code');
    _this.handlePhoneNumber = _this.handleChange.bind(_this, 'phone_number');
    _this.handleTimezone = _this.handleChange.bind(_this, 'timezone');
    _this.timezonesSource = constants["_46" /* TIMEZONES */].map(function (tz) {
      return { value: tz, label: tz };
    });
    _this.handleVendor = _this.handleChange.bind(_this, 'vendor');
    _this.vendorsSource = constants["_51" /* VENDORS */].map(function (v) {
      return { value: v, label: v };
    });
    var workroom = _this.props.workroom;

    _this.state = { workroom: workroom && workroomForm__extends({}, workroom) || { active: true, ihq: false } };
    return _this;
  }

  return WorkroomForm;
}(react["Component"]);

var workroomForm__initialiseProps = function _initialiseProps() {
  var _this2 = this;

  Object.defineProperty(this, 'handleChange', {
    enumerable: true,
    writable: true,
    value: function value(key, _value) {
      var workroom = _this2.state.workroom;
      workroom[key] = _value;
      _this2.setState({ workroom: workroom });
    }
  });
  Object.defineProperty(this, 'handleCancel', {
    enumerable: true,
    writable: true,
    value: function value() {
      return _this2.props.onCancel();
    }
  });
  Object.defineProperty(this, 'handleSave', {
    enumerable: true,
    writable: true,
    value: function value() {
      return _this2.props.onSave(workroomForm__extends({}, _this2.state.workroom));
    }
  });
  Object.defineProperty(this, 'renderTitle', {
    enumerable: true,
    writable: true,
    value: function value(workroom, isEdit, vendor) {
      var _cx2;

      var entityLabel = vendor === 'IFI' ? 'District' : 'Workroom';
      var title = isEdit ? workroom.name || 'Edit ' + entityLabel : 'Add ' + entityLabel;
      var switchClassNames = classnames_default()((_cx2 = {}, workroomForm__defineProperty(_cx2, form_default.a.switchTitleAdd, !isEdit), workroomForm__defineProperty(_cx2, form_default.a.switchTitle, true), _cx2));
      return react_default.a.createElement(
        'div',
        null,
        react_default.a.createElement(
          flexbox_react_dist_default.a,
          { justifyContent: 'space-between', className: form_default.a.divider },
          react_default.a.createElement(
            'div',
            null,
            react_default.a.createElement(
              'h5',
              { className: form_default.a.cardTitle },
              title
            ),
            react_default.a.createElement(
              'p',
              { className: form_default.a.cardSubtitle },
              'Please ensure that all fields contain accurate information'
            )
          ),
          react_default.a.createElement(
            'div',
            null,
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              name: 'active',
              label: vendor === 'IFI' ? 'District Active' : 'Workroom Active',
              onChange: _this2.handleActive,
              className: switchClassNames,
              checked: workroom.active
            }),
            react_default.a.createElement(react_toolbox_lib["Switch"], {
              name: 'ihq',
              label: 'IHQ',
              onChange: _this2.handleIhq,
              className: switchClassNames,
              checked: workroom.ihq || false
            })
          )
        )
      );
    }
  });
  Object.defineProperty(this, 'render', {
    enumerable: true,
    writable: true,
    value: function value() {
      var workroom = _this2.state.workroom;
      var _props = _this2.props,
          errors = _props.errors,
          role = _props.role;
      var vendor = workroom.vendor;

      var isEdit = !!workroom.id;
      var gError = Object(utils["c" /* error */])('global', errors);
      return react_default.a.createElement(
        react_css_themr_lib["ThemeProvider"],
        { theme: workroomForm_theme },
        react_default.a.createElement(
          components_Card,
          null,
          _this2.renderTitle(workroom, isEdit, vendor),
          gError ? react_default.a.createElement(MessageBox["a" /* default */], { error: true, message: gError }) : null,
          react_default.a.createElement(
            flexbox_react_dist_default.a,
            { flexWrap: 'wrap', className: form_default.a.divider },
            Object(services_ability["a" /* can */])(role, 'manage', 'manage_vendors') && react_default.a.createElement(components_StyledSelect, {
              className: workroomForm_mediumInput,
              label: 'Vendor',
              onChange: _this2.handleVendor,
              options: _this2.vendorsSource,
              value: workroom.vendor,
              placeholder: 'Select Vendor',
              error: Object(utils["c" /* error */])('vendor', errors)
            }),
            react_default.a.createElement(react_toolbox_lib["Input"], {
              label: 'Name',
              className: workroomForm_mediumInput,
              value: workroom.name,
              onChange: _this2.handleName,
              error: Object(utils["c" /* error */])('name', errors),
              required: true
            }),
            react_default.a.createElement(react_toolbox_lib["Input"], {
              label: 'Accounting ID',
              className: workroomForm_mediumInput,
              value: workroom.accounting_id,
              onChange: _this2.handleAccountingId,
              error: Object(utils["c" /* error */])('accounting_id', errors),
              required: true
            }),
            react_default.a.createElement(react_toolbox_lib["Input"], {
              label: 'Inventory ID',
              className: workroomForm_mediumInput,
              value: workroom.inventory_id,
              onChange: _this2.handleInventoryId,
              error: Object(utils["c" /* error */])('inventory_id', errors),
              required: true
            })
          ),
          react_default.a.createElement(
            flexbox_react_dist_default.a,
            { flexWrap: 'wrap', className: form_default.a.divider },
            react_default.a.createElement(react_toolbox_lib["Input"], {
              label: 'Address',
              value: workroom.address,
              className: workroomForm_mediumInput,
              onChange: _this2.handleAddress,
              error: Object(utils["c" /* error */])('address', errors)
            }),
            react_default.a.createElement(react_toolbox_lib["Input"], {
              label: 'City',
              value: workroom.city,
              className: workroomForm_mediumInput,
              onChange: _this2.handleCity,
              error: Object(utils["c" /* error */])('city', errors)
            }),
            react_default.a.createElement(components_StyledSelect, {
              className: workroomForm_mediumInput,
              label: 'State',
              onChange: _this2.handleState,
              options: STATE_OPTIONS,
              value: workroom.state,
              placeholder: 'Select State',
              error: Object(utils["c" /* error */])('state', errors)
            }),
            react_default.a.createElement(react_toolbox_lib["Input"], {
              label: 'Zip Code',
              value: workroom.zip_code,
              className: workroomForm_mediumInput,
              onChange: _this2.handleZip,
              error: Object(utils["c" /* error */])('zip_code', errors)
            }),
            react_default.a.createElement(components_StyledSelect, {
              className: workroomForm_mediumInput,
              label: 'Timezone',
              onChange: _this2.handleTimezone,
              options: _this2.timezonesSource,
              value: workroom.timezone,
              placeholder: 'Select Timezone',
              error: Object(utils["c" /* error */])('timezone', errors)
            }),
            react_default.a.createElement(PhoneType_PhoneInput, {
              label: 'Phone Number',
              type: 'tel',
              value: workroom.phone_number,
              className: workroomForm_mediumInput,
              onChange: _this2.handlePhoneNumber,
              error: Object(utils["c" /* error */])('phone_number', errors)
            })
          ),
          react_default.a.createElement(
            flexbox_react_dist_default.a,
            { justifyContent: 'flex-end', flexWrap: 'wrap' },
            react_default.a.createElement(
              react_toolbox_lib["CardActions"],
              { className: form_default.a.actionsWrapper },
              react_default.a.createElement(ColoredButton["a" /* default */], {
                className: workroomForm_cancelClass,
                responsive: true,
                color: 'gray',
                label: 'Cancel',
                onClick: _this2.handleCancel
              }),
              react_default.a.createElement(ColoredButton["a" /* default */], {
                className: form_default.a.actionButton,
                responsive: true,
                color: 'green',
                label: isEdit ? 'Save Changes' : 'Add workroom',
                onClick: _this2.handleSave
              })
            )
          )
        )
      );
    }
  });
};

workroomForm_WorkroomForm.propTypes = {
  errors: prop_types_default.a.object,
  workroom: types_workroom,
  onCancel: prop_types_default.a.func,
  onSave: prop_types_default.a.func,
  role: prop_types_default.a.string.isRequired
};

/* harmony default export */ var workroomForm = (workroomForm_WorkroomForm);
// CONCATENATED MODULE: ./client/app/screens/main/screens/workrooms/workroomNew.jsx
function workroomNew__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function workroomNew__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function workroomNew__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var workroomNew_WorkroomNew = function (_Component) {
  workroomNew__inherits(WorkroomNew, _Component);

  function WorkroomNew(props) {
    workroomNew__classCallCheck(this, WorkroomNew);

    var _this = workroomNew__possibleConstructorReturn(this, (WorkroomNew.__proto__ || Object.getPrototypeOf(WorkroomNew)).call(this, props));

    Object.defineProperty(_this, 'componentWillUnmount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.clearValidationErrors('WORKROOM');
      }
    });
    Object.defineProperty(_this, 'handleSave', {
      enumerable: true,
      writable: true,
      value: function value(workroom) {
        return _this.props.createWorkroom(workroom).then(function () {
          _this.props.navigate(urls.workrooms());
          _this.setSuccessMessage(workroom.name);
        });
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        return react_default.a.createElement(workroomForm, {
          role: _this.props.role,
          errors: _this.props.errors,
          onSave: _this.handleSave,
          onCancel: _this.handleCancel
        });
      }
    });

    _this.handleSave = _this.handleSave.bind(_this);
    _this.handleCancel = function () {
      _this.props.navigate(urls.workrooms());
    };
    _this.setSuccessMessage = function (name) {
      return _this.props.updateUI('successMessage', 'The workroom ' + name + ' was successfully created.');
    };
    return _this;
  }

  return WorkroomNew;
}(react["Component"]);

workroomNew_WorkroomNew.propTypes = {
  updateUI: prop_types_default.a.func,
  errors: prop_types_default.a.object,
  createWorkroom: prop_types_default.a.func.isRequired,
  navigate: prop_types_default.a.func.isRequired,
  clearValidationErrors: prop_types_default.a.func.isRequired,
  role: prop_types_default.a.string.isRequired
};

var workroomNew_mapStateToProps = function mapStateToProps(state) {
  return {
    errors: Object(reducers["_34" /* getWorkroomErrors */])(state) || {},
    role: Object(reducers["_12" /* getRole */])(state)
  };
};

/* harmony default export */ var workroomNew = (transpiled_default()()(Object(react_redux_es["connect"])(workroomNew_mapStateToProps, { createWorkroom: actionCreators["v" /* createWorkroom */], navigate: actionCreators["O" /* navigate */], clearValidationErrors: actionCreators["k" /* clearValidationErrors */] })(workroomNew_WorkroomNew)));
// CONCATENATED MODULE: ./client/app/screens/main/screens/workrooms/workroomEdit.jsx
function workroomEdit__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function workroomEdit__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function workroomEdit__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var workroomEdit_WorkroomEdit = function (_Component) {
  workroomEdit__inherits(WorkroomEdit, _Component);

  function WorkroomEdit(props) {
    workroomEdit__classCallCheck(this, WorkroomEdit);

    var _this = workroomEdit__possibleConstructorReturn(this, (WorkroomEdit.__proto__ || Object.getPrototypeOf(WorkroomEdit)).call(this, props));

    Object.defineProperty(_this, 'componentDidMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.requestWorkroom(_this.props.id);
      }
    });
    Object.defineProperty(_this, 'componentWillUnmount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.clearValidationErrors('WORKROOM');
      }
    });
    Object.defineProperty(_this, 'handleSave', {
      enumerable: true,
      writable: true,
      value: function value(workroom) {
        return _this.props.updateWorkroom(workroom).then(function () {
          _this.props.navigate(urls.workroom(workroom));
          _this.setSuccessMessage();
        });
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            errors = _this$props.errors,
            workroom = _this$props.workroom,
            loading = _this$props.loading,
            role = _this$props.role;

        return !loading ? react_default.a.createElement(workroomForm, {
          role: role,
          errors: errors,
          onSave: _this.handleSave,
          onCancel: _this.handleCancel,
          workroom: workroom
        }) : react_default.a.createElement(
          'p',
          null,
          'Loading...'
        );
      }
    });

    _this.handleSave = _this.handleSave.bind(_this);
    _this.handleCancel = function () {
      _this.props.navigate(urls.workroom(props.workroom));
    };
    _this.setSuccessMessage = function () {
      return _this.props.updateUI('successMessage', 'Changes have been saved');
    };
    return _this;
  }

  return WorkroomEdit;
}(react["Component"]);

workroomEdit_WorkroomEdit.propTypes = {
  id: prop_types_default.a.number,
  updateUI: prop_types_default.a.func,
  errors: prop_types_default.a.object,
  updateWorkroom: prop_types_default.a.func.isRequired,
  requestWorkroom: prop_types_default.a.func.isRequired,
  navigate: prop_types_default.a.func.isRequired,
  clearValidationErrors: prop_types_default.a.func.isRequired,
  workroom: prop_types_default.a.object,
  loading: prop_types_default.a.bool.isRequired,
  role: prop_types_default.a.string.isRequired
};

var workroomEdit_mapStateToProps = function mapStateToProps(state, ownProps) {
  var id = Number(ownProps.params.id);
  var workroom = Object(reducers["_33" /* getWorkroomById */])(state)(id);
  return {
    id: id,
    workroom: workroom,
    errors: Object(reducers["_34" /* getWorkroomErrors */])(state) || {},
    loading: workroom ? workroom.loading : true,
    role: Object(reducers["_12" /* getRole */])(state)
  };
};

/* harmony default export */ var workroomEdit = (transpiled_default()()(Object(react_redux_es["connect"])(workroomEdit_mapStateToProps, { updateWorkroom: actionCreators["_73" /* updateWorkroom */], requestWorkroom: actionCreators["_30" /* requestWorkroom */], navigate: actionCreators["O" /* navigate */], clearValidationErrors: actionCreators["k" /* clearValidationErrors */] })(workroomEdit_WorkroomEdit)));
// CONCATENATED MODULE: ./client/app/screens/main/screens/workrooms/index.jsx
var workrooms__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function workrooms__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function workrooms__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function workrooms__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var workrooms_Workrooms = function (_Component) {
  workrooms__inherits(Workrooms, _Component);

  function Workrooms(props) {
    workrooms__classCallCheck(this, Workrooms);

    var _this = workrooms__possibleConstructorReturn(this, (Workrooms.__proto__ || Object.getPrototypeOf(Workrooms)).call(this, props));

    Object.defineProperty(_this, 'onSearch', {
      enumerable: true,
      writable: true,
      value: function value(e, _value) {
        e.preventDefault();
        var filters = workrooms__extends({}, _this.props.filters);
        filters.query = _value;
        _this.handleFilterChange(filters);
      }
    });
    Object.defineProperty(_this, 'addAction', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.navigate('/workrooms/new');
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        return react_default.a.createElement(
          'div',
          null,
          react_default.a.createElement(components_PageActionBar, {
            hidesAddOnMobile: true,
            resource: 'workroom',
            role: _this.props.role,
            addAction: _this.addAction,
            showFiltersBtn: _this.isIndexRoute(),
            title: 'Workroom Management',
            searchText: 'Search for a workroom...',
            toggleFilters: _this.toggleFilterDrawer,
            onSearch: _this.onSearch,
            parentComponent: 'Workrooms',
            employableType: _this.props.employableType
          }),
          react_default.a.createElement(
            'div',
            { className: contentArea_default.a.contentAreaContainer },
            _this.props.children,
            react_default.a.createElement(Filters_WorkroomFilters, {
              active: _this.state.showFilterDrawer,
              onOverlayClick: _this.toggleFilterDrawer,
              handleFilterChange: _this.handleFilterChange,
              filters: _this.props.filters,
              title: 'Workrooms',
              reset: _this.props.resetWorkroomFilters,
              role: _this.props.role,
              resource: 'workroom'
            })
          )
        );
      }
    });

    _this.addAction = _this.addAction.bind(_this);
    _this.state = {
      showFilterDrawer: false
    };
    _this.toggleFilterDrawer = function () {
      return _this.setState({ showFilterDrawer: !_this.state.showFilterDrawer });
    };
    _this.handleFilterChange = function (filters) {
      return _this.props.setWorkroomFilters(filters);
    };
    _this.isIndexRoute = function () {
      return _this.props.location.pathname === _this.props.route.path;
    };
    return _this;
  }

  return Workrooms;
}(react["Component"]);

workrooms_Workrooms.propTypes = {
  setWorkroomFilters: prop_types_default.a.func.isRequired,
  navigate: prop_types_default.a.func,
  location: prop_types_default.a.object,
  route: prop_types_default.a.object,
  role: prop_types_default.a.string,
  children: prop_types_default.a.oneOfType([prop_types_default.a.object, prop_types_default.a.array]),
  filters: prop_types_default.a.object,
  resetWorkroomFilters: prop_types_default.a.func.isRequired,
  employableType: prop_types_default.a.string
};

var workrooms_mapStateToProps = function mapStateToProps(state) {
  return {
    role: Object(reducers["_12" /* getRole */])(state),
    employableType: Object(reducers["h" /* getEmployableType */])(state),
    filters: Object(reducers["_36" /* getWorkroomFilters */])(state)
  };
};

/* harmony default export */ var screens_workrooms = (transpiled_default()({ key: 'workrooms', state: { successMessage: '', activeTab: 0 } })(Object(react_redux_es["connect"])(workrooms_mapStateToProps, { navigate: actionCreators["O" /* navigate */], setWorkroomFilters: actionCreators["_52" /* setWorkroomFilters */], resetWorkroomFilters: actionCreators["_40" /* resetWorkroomFilters */] })(workrooms_Workrooms)));


// CONCATENATED MODULE: ./client/app/screens/main/screens/schedule/index.jsx
var schedule__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function schedule__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function screens_schedule__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function screens_schedule__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function screens_schedule__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var schedule_Schedule = function (_React$Component) {
  screens_schedule__inherits(Schedule, _React$Component);

  function Schedule() {
    var _ref;

    var _temp, _this, _ret;

    screens_schedule__classCallCheck(this, Schedule);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = screens_schedule__possibleConstructorReturn(this, (_ref = Schedule.__proto__ || Object.getPrototypeOf(Schedule)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'state', {
      enumerable: true,
      writable: true,
      value: { date: new Date() }
    }), Object.defineProperty(_this, 'componentWillMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            location = _this$props.location,
            user = _this$props.user;

        if (!['Estimator', 'Installer'].includes(user.employable_type) && location.search) {
          _this.props.replace('' + _this.props.location.pathname);
        }
        if (['Estimator', 'Installer'].includes(user.employable_type)) {
          var filters = user.employable_type === 'Installer' ? { assignee_type: ['Crew'] } : { assignee_type: ['Estimator'] };
          _this.props.updateScheduleFilters(filters);
          _this.updateFilters(filters, true);
        }
      }
    }), Object.defineProperty(_this, 'componentWillReceiveProps', {
      enumerable: true,
      writable: true,
      value: function value(newProps) {
        if (newProps.location.search && newProps.location.search !== _this.props.location.search) {
          _this.applyFilterObjToScheduleFilters(newProps.location.search);
        }
      }
    }), Object.defineProperty(_this, 'applyFilterObjToScheduleFilters', {
      enumerable: true,
      writable: true,
      value: function value(search) {
        var filterObject = qs_lib_default.a.parse(search.slice(1), { arrayLimit: 1000 });
        if (filterObject.workroom) {
          filterObject.workroom = filterObject.workroom.map(function (id) {
            return parseInt(id, 10);
          });
        }
        if (filterObject.surface_type) {
          filterObject.surface_type = filterObject.surface_type.map(function (id) {
            return parseInt(id, 10);
          });
        }
        _this.props.updateScheduleFilters(filterObject);
      }
    }), Object.defineProperty(_this, 'handleFilterChange', {
      enumerable: true,
      writable: true,
      value: function value(key, values) {
        return _this.updateFilters(schedule__extends({}, _this.props.filters, schedule__defineProperty({}, key, values)));
      }
    }), Object.defineProperty(_this, 'updateFilters', {
      enumerable: true,
      writable: true,
      value: function value(newFilters) {
        var isRestricted = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        var filters = qs_lib_default.a.stringify(newFilters);
        if (!filters && !isRestricted) _this.props.updateScheduleFilters({});
        _this.props.replace('' + _this.props.location.pathname + (filters ? '?' + filters : ''));
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props2 = _this.props,
            dates = _this$props2.dates,
            filters = _this$props2.filters,
            _this$props2$user = _this$props2.user,
            name = _this$props2$user.name,
            role = _this$props2$user.role,
            employable_id = _this$props2$user.employable_id;

        var date = _this.props.day ? new Date(_this.props.year, _this.props.month - 1, _this.props.day) : _this.state.date;
        return react_default.a.createElement(components_calendar, {
          title: 'Schedule',
          date: date,
          dates: dates,
          filters: filters,
          role: role,
          employableId: employable_id,
          username: name,
          onFilterChange: _this.handleFilterChange,
          updateScheduleFilters: _this.props.updateScheduleFilters,
          updateFilters: _this.updateFilters,
          isScheduleBoard: true
        });
      }
    }), _temp), screens_schedule__possibleConstructorReturn(_this, _ret);
  }

  return Schedule;
}(react_default.a.Component);

schedule_Schedule.propTypes = {
  dates: prop_types_default.a.arrayOf(prop_types_default.a.instanceOf(moment_default.a)).isRequired,
  location: prop_types_default.a.shape({
    search: prop_types_default.a.string.isRequired,
    pathname: prop_types_default.a.string.isRequired
  }).isRequired,
  filters: CalendarFilterType,
  year: prop_types_default.a.number,
  month: prop_types_default.a.number,
  day: prop_types_default.a.number,
  updateScheduleFilters: prop_types_default.a.func,
  navigate: prop_types_default.a.func,
  user: prop_types_default.a.object,
  replace: prop_types_default.a.func
};

var schedule_mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    user: state.user,
    filters: state.schedule.filters,
    dates: Object(reducers["_13" /* getScheduleDates */])(state),
    year: ownProps.params.year ? parseInt(ownProps.params.year, 10) : undefined,
    month: ownProps.params.month ? parseInt(ownProps.params.month, 10) : undefined,
    day: ownProps.params.day ? parseInt(ownProps.params.day, 10) : undefined
  };
};

/* harmony default export */ var screens_schedule = (Object(react_redux_es["connect"])(schedule_mapStateToProps, {
  updateScheduleFilters: actionCreators["_70" /* updateScheduleFilters */], navigate: actionCreators["O" /* navigate */], replace: react_router_redux_lib["replace"]
})(schedule_Schedule));
// EXTERNAL MODULE: ./client/app/screens/main/screens/reports/shared/styles.scss
var shared_styles = __webpack_require__("m2+S");
var shared_styles_default = /*#__PURE__*/__webpack_require__.n(shared_styles);

// CONCATENATED MODULE: ./client/app/screens/main/screens/reports/components/ReportFilters/index.jsx
var ReportFilters__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var ReportFilters__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ReportFilters__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ReportFilters__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ReportFilters__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var ReportFilters_ReportFilters = function (_React$Component) {
  ReportFilters__inherits(ReportFilters, _React$Component);

  function ReportFilters(props) {
    ReportFilters__classCallCheck(this, ReportFilters);

    var _this = ReportFilters__possibleConstructorReturn(this, (ReportFilters.__proto__ || Object.getPrototypeOf(ReportFilters)).call(this, props));

    Object.defineProperty(_this, 'onWorkroomChange', {
      enumerable: true,
      writable: true,
      value: function value(selected) {
        var wrId = selected.length > 0 ? selected[selected.length - 1].value : null;
        _this.setState({ workroom_id: wrId || null, error: '' });
      }
    });
    Object.defineProperty(_this, 'onDateChange', {
      enumerable: true,
      writable: true,
      value: function value(date) {
        return _this.setState({ install_date: Object(dateUtils["o" /* handleDateSave */])(date) });
      }
    });
    Object.defineProperty(_this, 'onSurfaceTypeChange', {
      enumerable: true,
      writable: true,
      value: function value(selected) {
        return _this.setState({ surface_type_id: selected.value || null });
      }
    });
    Object.defineProperty(_this, 'setError', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ error: 'Please select a workroom' });
      }
    });
    Object.defineProperty(_this, 'submit', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        e.preventDefault();
        if (!_this.state.workroom_id) return _this.setError();
        var query = ReportFilters__extends({}, _this.state);
        delete query.error;
        if (!_this.state.surface_type_id) delete query.surface_type_id;

        if (_this.props.onSubmit) return _this.props.onSubmit(query);

        return _this.props.push({ pathname: _this.props.location.pathname, query: query });
      }
    });


    var startingState = {
      workroom_id: parseInt(props.location.query.workroom_id, 10) || null,
      surface_type_id: parseInt(props.location.query.surface_type_id, 10) || null,
      install_date: props.location.query.install_date || moment_default()().format('YYYY-MM-DD'),
      error: ''
    };

    _this.state = startingState;
    return _this;
  }

  ReportFilters__createClass(ReportFilters, [{
    key: 'render',
    value: function render() {
      var date = moment_default()(this.state.install_date).format('MM/DD/YYYY');
      return react_default.a.createElement(
        'form',
        { onSubmit: this.submit, className: shared_styles_default.a.form },
        react_default.a.createElement(formElements_WorkroomSelect, {
          className: shared_styles_default.a.formElement,
          multi: false,
          resetValue: null,
          onChange: this.onWorkroomChange,
          value: this.state.workroom_id,
          error: this.state.error,
          required: true
        }),
        react_default.a.createElement(formElements_SurfaceTypeSelect, {
          multi: false,
          className: shared_styles_default.a.formElement,
          onChange: this.onSurfaceTypeChange,
          value: this.state.surface_type_id,
          placeholder: 'All Surfaces'
        }),
        react_default.a.createElement(DatePicker, {
          className: shared_styles_default.a.formElement,
          label: 'Date',
          value: date,
          onChange: this.onDateChange,
          placeholder: 'Select Date',
          required: true
        }),
        this.props.children,
        react_default.a.createElement('div', { className: shared_styles_default.a.formBreak }),
        react_default.a.createElement(
          ColoredButton["a" /* default */],
          { type: 'submit' },
          'Run Report'
        )
      );
    }
  }]);

  return ReportFilters;
}(react_default.a.Component);

ReportFilters_ReportFilters.propTypes = {
  location: prop_types_default.a.shape({
    pathname: prop_types_default.a.string.isRequired,
    query: prop_types_default.a.shape({
      workroom_id: prop_types_default.a.string,
      install_date: prop_types_default.a.string,
      surface_type_id: prop_types_default.a.string
    })
  }).isRequired,
  push: prop_types_default.a.func.isRequired,
  onSubmit: prop_types_default.a.func,
  children: prop_types_default.a.node
};

/* harmony default export */ var components_ReportFilters = (Object(react_redux_es["connect"])(function () {
  return {};
}, { push: react_router_redux_lib["push"] })(ReportFilters_ReportFilters));
// CONCATENATED MODULE: ./client/app/screens/main/screens/reports/components/ReportHeaders/index.jsx
function ReportHeaders__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }










var ReportHeaders_ReportHeaders = function ReportHeaders(_ref) {
  var workroom = _ref.workroom,
      printable = _ref.printable;
  return react_default.a.createElement(
    'header',
    { className: classnames_default()(shared_styles_default.a.header, ReportHeaders__defineProperty({}, shared_styles_default.a.printable, printable)) },
    react_default.a.createElement(
      'h4',
      { className: shared_styles_default.a.title },
      workroom && workroom.name + ' Workroom'
    ),
    react_default.a.createElement(react_toolbox_lib["IconButton"], { icon: 'print', className: shared_styles_default.a.print, onClick: window.print })
  );
};

ReportHeaders_ReportHeaders.propTypes = {
  workroom: types_workroom,
  printable: prop_types_default.a.bool.isRequired
};

ReportHeaders_ReportHeaders.defaultProps = {
  printable: true
};

/* harmony default export */ var components_ReportHeaders = (Object(react_redux_es["connect"])(function (state, ownProps) {
  return {
    workroom: Object(reducers["_33" /* getWorkroomById */])(state)(ownProps.workroom)
  };
})(ReportHeaders_ReportHeaders));
// EXTERNAL MODULE: ./client/app/screens/main/screens/reports/components/ReleaseMerchandise/releaseMerchandise.scss
var releaseMerchandise = __webpack_require__("PQWF");
var releaseMerchandise_default = /*#__PURE__*/__webpack_require__.n(releaseMerchandise);

// CONCATENATED MODULE: ./client/app/screens/main/screens/reports/components/ReleaseMerchandise/index.jsx
var ReleaseMerchandise__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ReleaseMerchandise__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ReleaseMerchandise__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ReleaseMerchandise__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var ReleaseMerchandise_WAREHOUSE_MERCH_ITEM_TYPE = 'warehouseMerchandiseItems';
var ReleaseMerchandise_WAREHOUSE_PADS_ITEM_TYPE = 'phaseLineItems';
var RELEASED = 'Released';

var ReleaseMerchandise_ReleaseMerchandise = function (_Component) {
  ReleaseMerchandise__inherits(ReleaseMerchandise, _Component);

  function ReleaseMerchandise(props) {
    ReleaseMerchandise__classCallCheck(this, ReleaseMerchandise);

    var _this = ReleaseMerchandise__possibleConstructorReturn(this, (ReleaseMerchandise.__proto__ || Object.getPrototypeOf(ReleaseMerchandise)).call(this, props));

    Object.defineProperty(_this, 'hasUnreleasedItems', {
      enumerable: true,
      writable: true,
      value: function value(appt) {
        return appt.warehouse_merchandise_items.filter(function (i) {
          return i.status !== RELEASED;
        }).length > 0 || appt.phase_line_items.filter(function (i) {
          return i.warehouse_status !== RELEASED;
        }).length > 0;
      }
    });
    Object.defineProperty(_this, 'handleRelease', {
      enumerable: true,
      writable: true,
      value: function value(appt) {
        var warehouse_merchandise_items = appt.warehouse_merchandise_items,
            phase_line_items = appt.phase_line_items,
            id = appt.phase.id;

        _this.releaseWarehouseMerch(warehouse_merchandise_items, id);
        _this.releaseWarehousePads(phase_line_items, id);
        _this.toggleModalActive();
      }
    });
    Object.defineProperty(_this, 'releaseWarehouseMerch', {
      enumerable: true,
      writable: true,
      value: function value(merch, phaseId) {
        if (merch.length > 0) {
          merch.forEach(function (item) {
            var lineItem = item;
            lineItem.status = RELEASED;
            _this.props.savePhaseItem(phaseId, lineItem, ReleaseMerchandise_WAREHOUSE_MERCH_ITEM_TYPE);
          });
        }
      }
    });
    Object.defineProperty(_this, 'releaseWarehousePads', {
      enumerable: true,
      writable: true,
      value: function value(pads, phaseId) {
        if (pads.length > 0) {
          pads.forEach(function (pad) {
            var lineItem = pad;
            lineItem.warehouse_status = RELEASED;
            _this.props.savePhaseItem(phaseId, lineItem, ReleaseMerchandise_WAREHOUSE_PADS_ITEM_TYPE);
          });
        }
      }
    });
    Object.defineProperty(_this, 'toggleModalActive', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ modalActive: !_this.state.modalActive });
      }
    });


    _this.state = {
      modalActive: false
    };

    _this.handleRelease = _this.handleRelease.bind(_this);
    return _this;
  }

  ReleaseMerchandise__createClass(ReleaseMerchandise, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var appt = this.props.appt;
      var modalActive = this.state.modalActive;

      var hasUnreleasedItems = this.hasUnreleasedItems(appt);
      return react_default.a.createElement(
        'div',
        null,
        react_default.a.createElement(ColoredButton["a" /* default */], {
          color: 'green',
          label: hasUnreleasedItems ? 'Release All' : 'Released',
          disabled: !hasUnreleasedItems,
          className: releaseMerchandise_default.a.receive,
          onClick: function onClick() {
            return _this2.toggleModalActive(appt);
          }
        }),
        modalActive && react_default.a.createElement(ConfirmDialog["a" /* default */], {
          title: 'Mark all Warehouse Merchandise and Pads as Released?',
          okLabel: 'Yes',
          cancelLabel: 'Cancel',
          cancel: this.toggleModalActive,
          dismiss: this.toggleModalActive,
          proceed: function proceed() {
            return _this2.handleRelease(appt);
          }
        })
      );
    }
  }]);

  return ReleaseMerchandise;
}(react["Component"]);

ReleaseMerchandise_ReleaseMerchandise.propTypes = {
  appt: prop_types_default.a.object,
  savePhaseItem: prop_types_default.a.func.isRequired
};

/* harmony default export */ var components_ReleaseMerchandise = (Object(react_redux_es["connect"])(null, { savePhaseItem: phase_items["k" /* savePhaseItem */] })(ReleaseMerchandise_ReleaseMerchandise));
// CONCATENATED MODULE: ./client/app/screens/main/screens/reports/warehouse/components/WarehouseSummaryTable/index.jsx













function uniqueValues(a, prop) {
  return Object(lodash["uniq"])(a.map(function (i) {
    return i[prop];
  })).join(', ');
}

var WarehouseSummaryTable_WarehouseSummaryTable = function WarehouseSummaryTable(_ref) {
  var data = _ref.report.data;
  return react_default.a.createElement(
    'table',
    { className: table_default.a.cardTable + ' ' + shared_styles_default.a.table, cellSpacing: '0' },
    react_default.a.createElement(
      'thead',
      null,
      react_default.a.createElement(
        'tr',
        { className: table_default.a.headerRow },
        react_default.a.createElement(
          'th',
          { className: table_default.a.column },
          'Store #'
        ),
        react_default.a.createElement(
          'th',
          { className: table_default.a.column },
          'Install Date'
        ),
        react_default.a.createElement(
          'th',
          { className: table_default.a.column },
          'Installer'
        ),
        react_default.a.createElement(
          'th',
          { className: table_default.a.column },
          'Appointment Type'
        ),
        react_default.a.createElement(
          'th',
          { className: table_default.a.column },
          'Customer Name'
        ),
        react_default.a.createElement(
          'th',
          { className: table_default.a.column },
          'PO #'
        ),
        react_default.a.createElement(
          'th',
          { className: table_default.a.column },
          'Carpet'
        ),
        react_default.a.createElement(
          'th',
          { className: table_default.a.column },
          'Bin'
        ),
        react_default.a.createElement(
          'th',
          { className: table_default.a.column },
          'Tag #'
        ),
        react_default.a.createElement(
          'th',
          { className: table_default.a.column },
          'Pad Type'
        ),
        react_default.a.createElement(
          'th',
          { className: table_default.a.column },
          'Pad QTY'
        ),
        react_default.a.createElement(
          'th',
          { className: table_default.a.column },
          'Cut'
        ),
        react_default.a.createElement(
          'th',
          { className: table_default.a.column },
          'Release'
        )
      )
    ),
    react_default.a.createElement(
      'tbody',
      null,
      data.map(function (appt) {
        return react_default.a.createElement(
          'tr',
          { key: appt.id, className: table_default.a.contentRow },
          react_default.a.createElement(
            'td',
            { className: table_default.a.column },
            react_default.a.createElement(
              es["c" /* Link */],
              { to: urls.store(appt.store), className: shared_styles_default.a.link, target: '_blank' },
              appt.store.number
            )
          ),
          react_default.a.createElement(
            'td',
            { className: table_default.a.column },
            react_default.a.createElement(
              'div',
              null,
              moment_default()(appt.start_date).format('MM/DD/YYYY')
            ),
            Object(dateUtils["b" /* formatTime */])(appt.arrival_start_time),
            ' - ',
            Object(dateUtils["b" /* formatTime */])(appt.arrival_end_time)
          ),
          react_default.a.createElement(
            'td',
            { className: table_default.a.column },
            appt.assignee.name
          ),
          react_default.a.createElement(
            'td',
            { className: table_default.a.column },
            Object(lodash["capitalize"])(appt.kind)
          ),
          react_default.a.createElement(
            'td',
            { className: table_default.a.column },
            react_default.a.createElement(
              es["c" /* Link */],
              { to: urls.phaseWarehouseMaterials(appt.phase.id), className: shared_styles_default.a.link, target: '_blank' },
              appt.phase.customer_name
            )
          ),
          react_default.a.createElement(
            'td',
            { className: table_default.a.column },
            appt.phase.original_po
          ),
          react_default.a.createElement(
            'td',
            { className: table_default.a.column },
            uniqueValues(appt.warehouse_merchandise_items, 'item_name')
          ),
          react_default.a.createElement(
            'td',
            { className: table_default.a.column },
            uniqueValues(appt.warehouse_merchandise_items, 'bin')
          ),
          react_default.a.createElement(
            'td',
            { className: table_default.a.column },
            uniqueValues(appt.warehouse_merchandise_items, 'tag_number')
          ),
          react_default.a.createElement(
            'td',
            { className: table_default.a.column },
            uniqueValues(appt.phase_line_items, 'description')
          ),
          react_default.a.createElement(
            'td',
            { className: table_default.a.column },
            appt.phase_line_items.map(function (i) {
              return Object(lineItemUtils["d" /* cutQuantityString */])(i.warehouse_quantity);
            }).join(', ')
          ),
          react_default.a.createElement(
            'td',
            { className: table_default.a.column },
            appt.phase_line_items.map(function (i) {
              return i.warehouse_status;
            }).join(', ')
          ),
          react_default.a.createElement(
            'td',
            { className: table_default.a.column + ' ' + table_default.a.centeredColumn },
            react_default.a.createElement(components_ReleaseMerchandise, { appt: appt })
          )
        );
      }),
      !data.length && react_default.a.createElement(
        'tr',
        null,
        react_default.a.createElement(
          'td',
          { colSpan: '9', className: shared_styles_default.a.empty + ' ' + table_default.a.column },
          'No Matching Appointments'
        )
      )
    )
  );
};

WarehouseSummaryTable_WarehouseSummaryTable.propTypes = {
  report: prop_types_default.a.shape({
    loading: prop_types_default.a.bool,
    loaded: prop_types_default.a.bool,
    data: prop_types_default.a.array
  })
};

/* harmony default export */ var components_WarehouseSummaryTable = (Object(react_redux_es["connect"])(function (state) {
  return {
    report: state.reports.warehouse
  };
})(WarehouseSummaryTable_WarehouseSummaryTable));
// CONCATENATED MODULE: ./client/app/screens/main/screens/reports/warehouse/index.jsx
var warehouse__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function warehouse__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function warehouse__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function warehouse__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var warehouse_WarehouseReport = function (_React$Component) {
  warehouse__inherits(WarehouseReport, _React$Component);

  function WarehouseReport() {
    warehouse__classCallCheck(this, WarehouseReport);

    return warehouse__possibleConstructorReturn(this, (WarehouseReport.__proto__ || Object.getPrototypeOf(WarehouseReport)).apply(this, arguments));
  }

  warehouse__createClass(WarehouseReport, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.clearWarehouseReport();
      if (this.props.location.search) {
        this.props.requestWarehouseReport(this.props.location.query);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.location.search !== this.props.location.search) {
        if (nextProps.location.search) {
          this.props.requestWarehouseReport(nextProps.location.query);
        } else {
          this.props.clearWarehouseReport();
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.clearWarehouseReport();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          location = _props.location,
          loaded = _props.report.loaded;

      return react_default.a.createElement(
        'div',
        null,
        react_default.a.createElement(components_PageActionBar, {
          showAdd: false,
          showFiltersBtn: false,
          title: 'Warehouse Report'
        }),
        react_default.a.createElement(
          'div',
          { className: contentArea_default.a.contentAreaContainer },
          react_default.a.createElement(
            'div',
            { className: contentArea_default.a.contentArea + ' ' + shared_styles_default.a.noPrint },
            react_default.a.createElement(components_ReportFilters, { location: location })
          ),
          loaded && react_default.a.createElement(
            'div',
            { className: contentArea_default.a.contentArea + ' ' + shared_styles_default.a.tableContainer },
            react_default.a.createElement(components_ReportHeaders, { workroom: location.query.workroom_id }),
            react_default.a.createElement(components_WarehouseSummaryTable, null)
          )
        )
      );
    }
  }]);

  return WarehouseReport;
}(react_default.a.Component);

warehouse_WarehouseReport.propTypes = {
  location: prop_types_default.a.shape({
    query: prop_types_default.a.objectOf(prop_types_default.a.string).isRequired,
    search: prop_types_default.a.string.isRequired
  }).isRequired,
  report: prop_types_default.a.shape({
    loaded: prop_types_default.a.bool
  }),
  requestWarehouseReport: prop_types_default.a.func.isRequired,
  clearWarehouseReport: prop_types_default.a.func.isRequired
};

/* harmony default export */ var warehouse = (Object(react_redux_es["connect"])(function (state, ownProps) {
  return {
    report: state.reports.warehouse,
    workroom: Object(reducers["_33" /* getWorkroomById */])(state)(ownProps.location.query.workroom_id)
  };
}, { requestWarehouseReport: actionCreators["_29" /* requestWarehouseReport */], clearWarehouseReport: actionCreators["l" /* clearWarehouseReport */] })(warehouse_WarehouseReport));
// CONCATENATED MODULE: ./client/app/utils/validationUtils.js
function stringToNum(string) {
  return parseInt(string, 10);
}

function checkIfParamString(param) {
  return typeof param === 'string';
}

function checkForQueryKey(obj, key) {
  return key in obj;
}

function isParamToAdjust(obj, key) {
  return checkForQueryKey(obj, key) && checkIfParamString(obj[key]);
}

function queryParamToArray(param) {
  if (Array.isArray(param)) return param;
  return [param];
}

function stringsToInts() {
  var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  if (!Array.isArray(param)) return stringToNum(param);
  return param.map(function (p) {
    if (typeof p === 'string') return stringToNum(p);
    return p;
  });
}

function queryParamStringsToIntArray(param) {
  return stringsToInts(queryParamToArray(param));
}

function reassignQueryProps(query, keys, newVals) {
  var newQuery = Object.assign({}, query);
  keys.forEach(function (k, i) {
    newQuery[k] = newVals[i];
  });
  return newQuery;
}
// EXTERNAL MODULE: ./client/app/shared/components/formElements/AssigneeSelect/assigneeSelect.scss
var assigneeSelect = __webpack_require__("65/N");
var assigneeSelect_default = /*#__PURE__*/__webpack_require__.n(assigneeSelect);

// CONCATENATED MODULE: ./client/app/shared/components/formElements/AssigneeSelect/index.jsx





var AssigneeSelect_AssigneeSelect = function AssigneeSelect(props) {
  var className = props.className,
      onChange = props.onChange,
      placeholder = props.placeholder,
      installerOnly = props.installerOnly;

  var employableTypes = installerOnly ? ['Installer'] : ['Installer', 'Employee'];
  return react_default.a.createElement(
    'span',
    null,
    react_default.a.createElement(
      'label',
      {
        htmlFor: 'select',
        className: assigneeSelect_default.a.label
      },
      installerOnly ? 'Installer' : 'Assignee'
    ),
    react_default.a.createElement(components_UserSearch, {
      isAssigneeSelect: true,
      employableType: employableTypes,
      initialValues: {},
      onChange: onChange,
      className: className,
      placeholder: placeholder
    })
  );
};

AssigneeSelect_AssigneeSelect.defaultProps = {
  installerOnly: false,
  onChange: function onChange() {},
  className: '',
  placeholder: 'Select Assignee'
};

AssigneeSelect_AssigneeSelect.propTypes = {
  installerOnly: prop_types_default.a.bool,
  onChange: prop_types_default.a.func,
  className: prop_types_default.a.string,
  placeholder: prop_types_default.a.string
};

/* harmony default export */ var formElements_AssigneeSelect = (AssigneeSelect_AssigneeSelect);
// CONCATENATED MODULE: ./client/app/screens/main/screens/reports/installWorkorderReport/components/InstallWorkorderFilters/index.jsx
var InstallWorkorderFilters__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var InstallWorkorderFilters__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function InstallWorkorderFilters__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function InstallWorkorderFilters__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function InstallWorkorderFilters__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function InstallWorkorderFilters__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var InstallWorkorderFilters_InstallWorkorderFilters = function (_React$Component) {
  InstallWorkorderFilters__inherits(InstallWorkorderFilters, _React$Component);

  function InstallWorkorderFilters(props) {
    InstallWorkorderFilters__classCallCheck(this, InstallWorkorderFilters);

    var _this = InstallWorkorderFilters__possibleConstructorReturn(this, (InstallWorkorderFilters.__proto__ || Object.getPrototypeOf(InstallWorkorderFilters)).call(this, props));

    Object.defineProperty(_this, 'onStartDateChange', {
      enumerable: true,
      writable: true,
      value: function value(date) {
        return _this.setState({ start_date: Object(dateUtils["o" /* handleDateSave */])(date) });
      }
    });
    Object.defineProperty(_this, 'onEndDateChange', {
      enumerable: true,
      writable: true,
      value: function value(date) {
        return _this.setState({ end_date: Object(dateUtils["o" /* handleDateSave */])(date) });
      }
    });
    Object.defineProperty(_this, 'onAssigneeChange', {
      enumerable: true,
      writable: true,
      value: function value(val) {
        _this.setState({
          assignee_id: _this.getAssigneeChangeValue(val, 'employable_id') || null,
          assignee_type: _this.getAssigneeChangeValue(val, 'employable_type') || null
        });
      }
    });
    Object.defineProperty(_this, 'setError', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ error: 'Please select a workroom' });
      }
    });
    Object.defineProperty(_this, 'getAssigneeChangeValue', {
      enumerable: true,
      writable: true,
      value: function value(val, key) {
        return val ? val[key] : null;
      }
    });
    Object.defineProperty(_this, 'submit', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        e.preventDefault();

        var _this$state = _this.state,
            workrooms = _this$state.workrooms,
            surface_types = _this$state.surface_types,
            assignee_id = _this$state.assignee_id,
            assignee_type = _this$state.assignee_type;

        if (workrooms === undefined || workrooms.length === 0) return _this.setError();
        var query = InstallWorkorderFilters__extends({}, _this.state);

        delete query.error;
        if (!surface_types || surface_types.length === 0) delete query.surface_types;
        if (!assignee_id || !assignee_type) {
          delete query.assignee_id;
          delete query.assignee_type;
        }

        if (_this.props.onSubmit) return _this.props.onSubmit(query);
        return _this.props.push({ pathname: _this.props.location.pathname, query: query });
      }
    });


    var startingState = {
      workrooms: props.location.query.workrooms || [],
      surface_types: props.location.query.surface_types || [],
      assignee_id: parseInt(props.location.query.assignee_id, 10) || null,
      assignee_type: props.location.query.assignee_type || '',
      start_date: props.location.query.start_date || moment_default()().format('YYYY-MM-DD'),
      end_date: props.location.query.end_date || moment_default()().format('YYYY-MM-DD'),
      error: ''
    };

    _this.state = startingState;
    _this.handleWorkrooms = _this.onSelectChange.bind(_this, 'workrooms');
    _this.handleSurfaceTypes = _this.onSelectChange.bind(_this, 'surface_types');
    return _this;
  }

  InstallWorkorderFilters__createClass(InstallWorkorderFilters, [{
    key: 'onSelectChange',
    value: function onSelectChange(key, value) {
      var stateVal = value.map(function (v) {
        return v.value;
      });
      this.setState(InstallWorkorderFilters__defineProperty({}, key, stateVal));
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          start_date = _state.start_date,
          end_date = _state.end_date,
          workrooms = _state.workrooms,
          error = _state.error,
          surface_types = _state.surface_types;

      var startDate = moment_default()(start_date).format('MM/DD/YYYY');
      var endDate = moment_default()(end_date).format('MM/DD/YYYY');

      return react_default.a.createElement(
        'form',
        { onSubmit: this.submit, className: shared_styles_default.a.form },
        react_default.a.createElement(formElements_WorkroomSelect, {
          className: shared_styles_default.a.formElement,
          multi: true,
          resetValue: [],
          onChange: this.handleWorkrooms,
          value: workrooms,
          error: error,
          required: true
        }),
        react_default.a.createElement(DatePicker, {
          className: shared_styles_default.a.formElement,
          label: 'Start Date',
          value: startDate,
          onChange: this.onStartDateChange,
          placeholder: 'Select Start Date',
          required: true
        }),
        react_default.a.createElement(DatePicker, {
          className: shared_styles_default.a.formElement,
          label: 'End Date',
          value: endDate,
          onChange: this.onEndDateChange,
          placeholder: 'Select End Date',
          required: true
        }),
        react_default.a.createElement(formElements_SurfaceTypeSelect, {
          className: shared_styles_default.a.formElement,
          multi: true,
          resetValue: [],
          onChange: this.handleSurfaceTypes,
          value: surface_types,
          placeholder: 'All Surfaces'
        }),
        this.props.children,
        react_default.a.createElement(formElements_AssigneeSelect, {
          multi: false,
          className: shared_styles_default.a.assigneeFormElement,
          onChange: this.onAssigneeChange,
          placeholder: 'All Installers/Employees'
        }),
        react_default.a.createElement(
          ColoredButton["a" /* default */],
          { type: 'submit', className: shared_styles_default.a.formSubmit },
          'Run Report'
        )
      );
    }
  }]);

  return InstallWorkorderFilters;
}(react_default.a.Component);

InstallWorkorderFilters_InstallWorkorderFilters.propTypes = {
  location: prop_types_default.a.shape({
    pathname: prop_types_default.a.string.isRequired,
    query: prop_types_default.a.shape({
      workrooms: prop_types_default.a.array,
      start_date: prop_types_default.a.string,
      end_date: prop_types_default.a.string,
      surface_types: prop_types_default.a.array,
      assignee_id: prop_types_default.a.string,
      assignee_type: prop_types_default.a.string
    })
  }).isRequired,
  push: prop_types_default.a.func.isRequired,
  onSubmit: prop_types_default.a.func,
  children: prop_types_default.a.node
};

/* harmony default export */ var components_InstallWorkorderFilters = (Object(react_redux_es["connect"])(function () {
  return {};
}, { push: react_router_redux_lib["push"] })(InstallWorkorderFilters_InstallWorkorderFilters));
// CONCATENATED MODULE: ./client/app/screens/main/screens/reports/installWorkorderReport/components/InstallWorkorderHeader/index.jsx
function InstallWorkorderHeader__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }










var InstallWorkorderHeader_InstallWorkorderHeader = function InstallWorkorderHeader(_ref) {
  var workrooms = _ref.workrooms,
      printable = _ref.printable,
      resultCount = _ref.resultCount;

  var getWorkroomTitle = function getWorkroomTitle() {
    var title = '';
    workrooms.forEach(function (w) {
      if (!title) {
        title = w.name;
      } else {
        title = title.concat(', ', w.name);
      }
    });
    return title + ' Workroom' + (workrooms.length > 1 ? 's' : '');
  };

  var renderCount = function renderCount() {
    return react_default.a.createElement(
      'span',
      { className: resultCount ? shared_styles_default.a.resultCount : shared_styles_default.a.noResult },
      resultCount
    );
  };

  var renderCountHeader = function renderCountHeader() {
    return react_default.a.createElement(
      'h6',
      { className: shared_styles_default.a.countHeader },
      'Your search yielded ',
      renderCount(),
      ' result',
      resultCount > 1 ? 's ' : ' ',
      '(Click workroom name below to expand/collapse results)'
    );
  };

  return react_default.a.createElement(
    'header',
    { className: classnames_default()(shared_styles_default.a.header, InstallWorkorderHeader__defineProperty({}, shared_styles_default.a.printable, printable)) },
    react_default.a.createElement(
      'h4',
      { className: shared_styles_default.a.title },
      workrooms && getWorkroomTitle()
    ),
    renderCountHeader(),
    react_default.a.createElement(react_toolbox_lib["IconButton"], { icon: 'print', className: shared_styles_default.a.print, onClick: window.print })
  );
};

InstallWorkorderHeader_InstallWorkorderHeader.propTypes = {
  workrooms: prop_types_default.a.array.isRequired,
  printable: prop_types_default.a.bool.isRequired,
  resultCount: prop_types_default.a.number
};

InstallWorkorderHeader_InstallWorkorderHeader.defaultProps = {
  printable: true,
  resultCount: 0
};

/* harmony default export */ var components_InstallWorkorderHeader = (Object(react_redux_es["connect"])(function (state, ownProps) {
  var workrooms = queryParamStringsToIntArray(ownProps.workrooms || []);
  return {
    workrooms: Object(reducers["_35" /* getWorkroomFilteredByIds */])(state)(workrooms || [])
  };
})(InstallWorkorderHeader_InstallWorkorderHeader));
// CONCATENATED MODULE: ./client/app/screens/main/screens/reports/installWorkorderReport/components/InstallWorkorderTable/index.jsx
















var InstallWorkorderTable_InstallWorkorderTable = function InstallWorkorderTable(_ref) {
  var workrooms = _ref.workrooms,
      data = _ref.report.data;

  var resultCount = data.length;

  var getWorkroomCount = function getWorkroomCount(filteredResults) {
    return filteredResults.length;
  };

  var filterByWorkroom = function filterByWorkroom(workroom) {
    return Object(lodash["filter"])(data, { workroom_name: workroom });
  };

  var sortWorkroomsWithCount = function sortWorkroomsWithCount(workroomsWithCount) {
    return workroomsWithCount.sort(function (a, b) {
      return b.resultCount - a.resultCount;
    });
  };

  var sortWorkroomsByCount = function sortWorkroomsByCount() {
    var workroomsWithCount = [];

    workrooms.forEach(function (w) {
      var alteredWorkroom = {
        name: w.name,
        resultCount: filterByWorkroom(w.name).length
      };
      workroomsWithCount.push(alteredWorkroom);
    });

    return sortWorkroomsWithCount(workroomsWithCount);
  };

  var renderNoWorkroomResults = function renderNoWorkroomResults(workroom) {
    return react_default.a.createElement(
      'div',
      { className: shared_styles_default.a.noWorkroomResults },
      'No results for the ' + workroom + ' workroom'
    );
  };

  var renderTable = function renderTable(results) {
    return react_default.a.createElement(
      'table',
      { className: table_default.a.cardTable + ' ' + shared_styles_default.a.table, cellSpacing: '0' },
      react_default.a.createElement(
        'thead',
        null,
        react_default.a.createElement(
          'tr',
          { className: table_default.a.headerRow },
          react_default.a.createElement(
            'th',
            { className: table_default.a.column },
            'PO #'
          ),
          react_default.a.createElement(
            'th',
            { className: table_default.a.column },
            'Customer Name'
          ),
          react_default.a.createElement(
            'th',
            { className: table_default.a.column },
            'Customer Phone #'
          ),
          react_default.a.createElement(
            'th',
            { className: table_default.a.column },
            'Customer Address'
          ),
          react_default.a.createElement(
            'th',
            { className: table_default.a.column },
            'Surface Type'
          ),
          react_default.a.createElement(
            'th',
            { className: table_default.a.column },
            'Net Sq Ft'
          ),
          react_default.a.createElement(
            'th',
            { className: table_default.a.column },
            'Arrival Window'
          ),
          react_default.a.createElement(
            'th',
            { className: table_default.a.column },
            'Assignee'
          ),
          react_default.a.createElement(
            'th',
            { className: table_default.a.column },
            'Store #'
          ),
          react_default.a.createElement(
            'th',
            { className: table_default.a.column },
            'Store Phone #'
          ),
          react_default.a.createElement(
            'th',
            { className: table_default.a.column },
            'Release'
          )
        )
      ),
      react_default.a.createElement(
        'tbody',
        null,
        results.map(function (appt) {
          return react_default.a.createElement(
            'tr',
            { key: appt.id, className: table_default.a.contentRow },
            react_default.a.createElement(
              'td',
              { className: table_default.a.column },
              appt.phase.original_po || 'N/A'
            ),
            react_default.a.createElement(
              'td',
              { className: table_default.a.column },
              react_default.a.createElement(
                es["c" /* Link */],
                {
                  to: urls.phaseWarehouseMaterials(appt.phase.id),
                  className: shared_styles_default.a.link,
                  target: '_blank'
                },
                appt.phase.customer_name || 'N/A'
              )
            ),
            react_default.a.createElement(
              'td',
              { className: table_default.a.column },
              appt.phase.phone_number ? react_default.a.createElement(components_PhoneLink, { number: appt.phase.phone_number }) : 'N/A'
            ),
            react_default.a.createElement(
              'td',
              { className: table_default.a.column },
              (appt.phase.street_address || '') + ' \n              ' + (appt.phase.city || '') + ' ' + (appt.phase.state || '') + ' \n              ' + (appt.phase.zip_code || '')
            ),
            react_default.a.createElement(
              'td',
              { className: table_default.a.column },
              appt.phase.surface_type || 'N/A'
            ),
            react_default.a.createElement(
              'td',
              { className: table_default.a.column },
              appt.phase.net_square_footage || 'N/A'
            ),
            react_default.a.createElement(
              'td',
              { className: table_default.a.column },
              react_default.a.createElement(
                'div',
                null,
                moment_default()(appt.start_date).format('MM/DD/YYYY')
              ),
              Object(dateUtils["b" /* formatTime */])(appt.arrival_start_time),
              ' - ',
              Object(dateUtils["b" /* formatTime */])(appt.arrival_end_time)
            ),
            react_default.a.createElement(
              'td',
              { className: table_default.a.column },
              appt.assignee.name
            ),
            react_default.a.createElement(
              'td',
              { className: table_default.a.column },
              react_default.a.createElement(
                es["c" /* Link */],
                {
                  to: urls.store(appt.store),
                  className: shared_styles_default.a.link,
                  target: '_blank'
                },
                appt.store.number
              )
            ),
            react_default.a.createElement(
              'td',
              { className: table_default.a.column },
              appt.store.phone_number ? react_default.a.createElement(components_PhoneLink, { number: appt.store.phone_number }) : 'N/A'
            ),
            react_default.a.createElement(
              'td',
              { className: table_default.a.column },
              react_default.a.createElement(components_ReleaseMerchandise, { appt: appt })
            )
          );
        })
      )
    );
  };

  var renderTablesByWorkroom = function renderTablesByWorkroom() {
    var sortedWorkrooms = sortWorkroomsByCount(workrooms);
    var tables = sortedWorkrooms.map(function (w) {
      var workroom = w.name;
      var workroomResults = filterByWorkroom(workroom) || [];
      var workroomCount = getWorkroomCount(workroomResults);
      return react_default.a.createElement(
        dist_modules["AccordionItem"],
        {
          titleClassName: shared_styles_default.a.workroomHeader,
          expandedClassName: shared_styles_default.a.expandedResults,
          title: workroom + ' (' + workroomCount + ')',
          key: workroom,
          expanded: false
        },
        workroomResults.length > 0 ? renderTable(workroomResults) : renderNoWorkroomResults(workroom)
      );
    });
    return react_default.a.createElement(
      dist_modules["Accordion"],
      { allowMultiple: true },
      tables
    );
  };

  var renderView = function renderView() {
    if (resultCount) return renderTablesByWorkroom();
    return null;
  };

  return renderView();
};

InstallWorkorderTable_InstallWorkorderTable.propTypes = {
  report: prop_types_default.a.shape({
    loading: prop_types_default.a.bool,
    loaded: prop_types_default.a.bool,
    data: prop_types_default.a.array
  })
};

/* harmony default export */ var components_InstallWorkorderTable = (Object(react_redux_es["connect"])(function (state, ownProps) {
  var workrooms = queryParamStringsToIntArray(ownProps.workrooms || []);
  return {
    workrooms: Object(reducers["_35" /* getWorkroomFilteredByIds */])(state)(workrooms || []),
    report: state.reports.installWorkorder
  };
})(InstallWorkorderTable_InstallWorkorderTable));
// CONCATENATED MODULE: ./client/app/screens/main/screens/reports/installWorkorderReport/index.jsx
function installWorkorderReport__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function installWorkorderReport__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function installWorkorderReport__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var installWorkorderReport_InstallWorkorderReport = function (_React$Component) {
  installWorkorderReport__inherits(InstallWorkorderReport, _React$Component);

  function InstallWorkorderReport() {
    var _ref;

    var _temp, _this, _ret;

    installWorkorderReport__classCallCheck(this, InstallWorkorderReport);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = installWorkorderReport__possibleConstructorReturn(this, (_ref = InstallWorkorderReport.__proto__ || Object.getPrototypeOf(InstallWorkorderReport)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'componentDidMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props$location = _this.props.location,
            search = _this$props$location.search,
            query = _this$props$location.query;

        _this.props.clearInstallWorkorderReport();
        if (search) {
          var adjustedQuery = _this.adjustWorkroomsAndSurfaceTypeParams(query || {});
          _this.props.requestInstallWorkorderReport(adjustedQuery);
        }
      }
    }), Object.defineProperty(_this, 'componentWillReceiveProps', {
      enumerable: true,
      writable: true,
      value: function value(nextProps) {
        var _nextProps$location = nextProps.location,
            search = _nextProps$location.search,
            query = _nextProps$location.query;

        if (search !== _this.props.location.search) {
          if (search) {
            var adjustedQuery = _this.adjustWorkroomsAndSurfaceTypeParams(query || {});
            _this.props.requestInstallWorkorderReport(adjustedQuery);
          } else _this.props.clearInstallWorkorderReport();
        }
      }
    }), Object.defineProperty(_this, 'componentWillUnmount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.clearInstallWorkorderReport();
      }
    }), Object.defineProperty(_this, 'adjustWorkroomsAndSurfaceTypeParams', {
      enumerable: true,
      writable: true,
      value: function value(query) {
        var adjustWorkrooms = isParamToAdjust(query, 'workrooms');
        var adjustSurfaceTypes = isParamToAdjust(query, 'surface_types');
        if (!adjustWorkrooms && !adjustSurfaceTypes) return query;
        var fields = [];
        var vals = [];
        if (adjustWorkrooms) {
          fields.push('workrooms');
          vals.push(queryParamToArray(query.workrooms));
        }
        if (adjustSurfaceTypes) {
          fields.push('surface_types');
          vals.push(queryParamToArray(query.surface_types));
        }
        return reassignQueryProps(query, fields, vals);
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            location = _this$props.location,
            _this$props$report = _this$props.report,
            loading = _this$props$report.loading,
            loaded = _this$props$report.loaded,
            data = _this$props$report.data;

        return react_default.a.createElement(
          'div',
          null,
          react_default.a.createElement(components_PageActionBar, {
            showAdd: false,
            showFiltersBtn: false,
            title: 'Install/Workorder Report'
          }),
          react_default.a.createElement(
            'div',
            { className: contentArea_default.a.contentAreaContainer },
            react_default.a.createElement(
              'div',
              { className: contentArea_default.a.contentArea + ' ' + shared_styles_default.a.noPrint },
              react_default.a.createElement(components_InstallWorkorderFilters, { location: location })
            ),
            loaded && react_default.a.createElement(
              'div',
              { className: contentArea_default.a.contentArea + ' ' + shared_styles_default.a.tableContainer },
              react_default.a.createElement(components_InstallWorkorderHeader, {
                workrooms: location.query.workrooms,
                resultCount: data.length
              }),
              react_default.a.createElement(components_InstallWorkorderTable, { workrooms: location.query.workrooms })
            ),
            loading && react_default.a.createElement(components_Loading, null)
          )
        );
      }
    }), _temp), installWorkorderReport__possibleConstructorReturn(_this, _ret);
  }

  return InstallWorkorderReport;
}(react_default.a.Component);

installWorkorderReport_InstallWorkorderReport.propTypes = {
  location: prop_types_default.a.shape({
    query: prop_types_default.a.objectOf(prop_types_default.a.string).isRequired,
    search: prop_types_default.a.string.isRequired
  }).isRequired,
  report: prop_types_default.a.shape({
    loaded: prop_types_default.a.bool
  }),
  requestInstallWorkorderReport: prop_types_default.a.func.isRequired,
  clearInstallWorkorderReport: prop_types_default.a.func.isRequired
};

/* harmony default export */ var installWorkorderReport = (Object(react_redux_es["connect"])(function (state, ownProps) {
  var workrooms = queryParamStringsToIntArray(ownProps.location.query.workrooms || []);
  return {
    report: state.reports.installWorkorder,
    workrooms: Object(reducers["_35" /* getWorkroomFilteredByIds */])(state)(workrooms || [])
  };
}, { requestInstallWorkorderReport: actionCreators["_5" /* requestInstallWorkorderReport */], clearInstallWorkorderReport: actionCreators["g" /* clearInstallWorkorderReport */] })(installWorkorderReport_InstallWorkorderReport));
// EXTERNAL MODULE: ./client/app/shared/actionCreators/reports.js
var reports = __webpack_require__("zdX5");

// CONCATENATED MODULE: ./client/app/shared/mixins/simple_request.js
var simple_request__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function simple_request__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function simple_request__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function simple_request__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var simpleRequestMixin = function simpleRequestMixin(Base, action) {
  return function (_Base) {
    simple_request__inherits(_class, _Base);

    function _class() {
      simple_request__classCallCheck(this, _class);

      return simple_request__possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
    }

    simple_request__createClass(_class, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.props["clear" + action]();
        if (this.props.location.search) {
          this.props["request" + action](this.props.location.query);
        }
      }
    }, {
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(nextProps) {
        if (nextProps.location.search !== this.props.location.search) {
          if (nextProps.location.search) {
            this.props["request" + action](nextProps.location.query);
          } else {
            this.props["clear" + action]();
          }
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.props["clear" + action]();
      }
    }]);

    return _class;
  }(Base);
};

/* harmony default export */ var simple_request = (simpleRequestMixin);
// EXTERNAL MODULE: ./client/app/screens/main/screens/reports/jobHistory/jobHistoryStyles.scss
var jobHistoryStyles = __webpack_require__("74fA");
var jobHistoryStyles_default = /*#__PURE__*/__webpack_require__.n(jobHistoryStyles);

// CONCATENATED MODULE: ./client/app/screens/main/screens/reports/jobHistory/components/JobHistoryRow.jsx









var JobHistoryRow_JobHistoryRow = function JobHistoryRow(_ref) {
  var appt = _ref.appt;

  var hasPhase = !!(appt.phase || null) && appt.phase !== 'N/A';

  var renderCrewCell = function renderCrewCell() {
    return react_default.a.createElement(editableTableCell, {
      label: 'Crew',
      value: appt.crew,
      cellReadOnly: true
    });
  };

  var renderLink = function renderLink() {
    return hasPhase ? react_default.a.createElement(
      es["c" /* Link */],
      {
        to: urls.phaseHistory(appt.phase),
        target: '_blank'
      },
      appt.phase.project_number
    ) : 'N/A';
  };

  var renderProjectNumberCell = function renderProjectNumberCell() {
    var link = renderLink();
    return react_default.a.createElement(
      editableTableCell,
      {
        label: 'Project Number',
        value: link,
        cellReadOnly: true
      },
      link
    );
  };

  var renderApptTypeCell = function renderApptTypeCell() {
    return react_default.a.createElement(editableTableCell, {
      label: 'Appt. Type',
      value: appt.apptType,
      cellReadOnly: true
    });
  };

  var renderDateCell = function renderDateCell(label, date) {
    return react_default.a.createElement(editableTableCell, {
      label: label + ' Date',
      value: date,
      cellReadOnly: true
    });
  };

  var renderDocLink = function renderDocLink(url) {
    return url ? react_default.a.createElement(
      documentLink,
      { href: url },
      react_default.a.createElement(react_toolbox_lib["FontIcon"], { className: jobHistoryStyles_default.a.downloadIcon, value: 'launch' })
    ) : 'N/A';
  };

  var renderInspectionCell = function renderInspectionCell() {
    var link = 'N/A';
    if (hasPhase) {
      var phase = appt.phase,
          crewId = appt.crewId;

      var doc = (phase.document_uploads || []).length ? phase.document_uploads.find(function (d) {
        return d.document_name.includes('ID: ' + crewId);
      }) || null : null;
      var url = doc ? doc.expiring_download_url : doc;
      link = renderDocLink(url);
    }
    return react_default.a.createElement(
      editableTableCell,
      {
        label: 'Crew Inspection',
        value: link,
        cellReadOnly: true
      },
      link
    );
  };

  return react_default.a.createElement(
    editableTableRow,
    { readOnly: true },
    renderCrewCell(),
    renderProjectNumberCell(),
    renderApptTypeCell(),
    renderDateCell('Start', appt.startDate),
    renderDateCell('End', appt.endDate),
    renderInspectionCell()
  );
};

JobHistoryRow_JobHistoryRow.propTypes = {
  appt: prop_types_default.a.object, className: prop_types_default.a.string
};

JobHistoryRow_JobHistoryRow.defaultProps = { appt: null, className: '' };

/* harmony default export */ var components_JobHistoryRow = (JobHistoryRow_JobHistoryRow);
// CONCATENATED MODULE: ./client/app/screens/main/screens/reports/jobHistory/components/JobHistoryExcelSheet.jsx
function JobHistoryExcelSheet__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function JobHistoryExcelSheet__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function JobHistoryExcelSheet__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var JobHistoryExcelSheet_ExcelFile = react_data_export_dist_default.a.ExcelFile;
var JobHistoryExcelSheet_ExcelSheet = react_data_export_dist_default.a.ExcelFile.ExcelSheet;
var JobHistoryExcelSheet_ExcelColumn = react_data_export_dist_default.a.ExcelFile.ExcelColumn;

var JobHistoryExcelSheet_JobHistoryExcelSheet = function (_React$Component) {
  JobHistoryExcelSheet__inherits(JobHistoryExcelSheet, _React$Component);

  function JobHistoryExcelSheet() {
    var _ref;

    var _temp, _this, _ret;

    JobHistoryExcelSheet__classCallCheck(this, JobHistoryExcelSheet);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = JobHistoryExcelSheet__possibleConstructorReturn(this, (_ref = JobHistoryExcelSheet.__proto__ || Object.getPrototypeOf(JobHistoryExcelSheet)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'componentDidMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.Interval = setInterval(_this.props.unmountExcelSheet.bind(_this), 2500);
      }
    }), Object.defineProperty(_this, 'componentWillUnMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return clearInterval(_this.Interval);
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var formattedAppts = _this.props.appts.map(function (a) {
          var crew = a.crew,
              apptType = a.apptType,
              startDate = a.startDate,
              endDate = a.endDate,
              _a$phase = a.phase,
              phase = _a$phase === undefined ? 'N/A' : _a$phase;

          var docs = !phase || typeof phase === 'string' ? [] : phase.document_uploads;
          return {
            crew: crew,
            apptType: apptType,
            startDate: startDate,
            endDate: endDate,
            projectNumber: !phase || typeof phase === 'string' ? 'N/A' : phase.project_number,
            crewInspection: docs.length && docs.some(function (d) {
              return d.document_name.includes('ID:');
            }) ? 'YES' : 'NO'
          };
        }) || [];

        return react_default.a.createElement(
          JobHistoryExcelSheet_ExcelFile,
          { hideElement: true },
          react_default.a.createElement(
            JobHistoryExcelSheet_ExcelSheet,
            { data: formattedAppts || [], name: 'Phase List' },
            react_default.a.createElement(JobHistoryExcelSheet_ExcelColumn, { label: 'Crew', value: 'crew' }),
            react_default.a.createElement(JobHistoryExcelSheet_ExcelColumn, { label: 'Project Number', value: 'projectNumber' }),
            react_default.a.createElement(JobHistoryExcelSheet_ExcelColumn, { label: 'Appt. Type', value: 'apptType' }),
            react_default.a.createElement(JobHistoryExcelSheet_ExcelColumn, { label: 'Start Date', value: 'startDate' }),
            react_default.a.createElement(JobHistoryExcelSheet_ExcelColumn, { label: 'End Date', value: 'endDate' }),
            react_default.a.createElement(JobHistoryExcelSheet_ExcelColumn, { label: 'Has Inspection', value: 'crewInspection' })
          )
        );
      }
    }), _temp), JobHistoryExcelSheet__possibleConstructorReturn(_this, _ret);
  }

  return JobHistoryExcelSheet;
}(react_default.a.Component);

JobHistoryExcelSheet_JobHistoryExcelSheet.propTypes = {
  appts: prop_types_default.a.array, unmountExcelSheet: prop_types_default.a.func
};

/* harmony default export */ var components_JobHistoryExcelSheet = (JobHistoryExcelSheet_JobHistoryExcelSheet);
// CONCATENATED MODULE: ./client/app/screens/main/screens/reports/jobHistory/components/JobHistoryHeader.jsx









var SMALL_INPUT = classnames_default()(form_default.a.inputs, form_default.a.mediumInput, contentArea_default.a.actionInput);

var JobHistoryHeader_JobHistoryHeader = function JobHistoryHeader(_ref) {
  var renderExcel = _ref.renderExcel,
      setRenderExcel = _ref.setRenderExcel,
      appts = _ref.appts,
      search = _ref.search,
      setSearch = _ref.setSearch;
  return react_default.a.createElement(
    flexbox_react_dist_default.a,
    { className: contentArea_default.a.contentAreaActions },
    react_default.a.createElement(
      'div',
      { className: contentArea_default.a.leftActions },
      react_default.a.createElement(react_toolbox_lib["FontIcon"], { value: 'search' }),
      react_default.a.createElement(react_toolbox_lib["Input"], {
        className: SMALL_INPUT,
        value: search,
        onChange: setSearch
      })
    ),
    react_default.a.createElement(
      'div',
      { className: contentArea_default.a.rightActions },
      renderExcel ? react_default.a.createElement(components_JobHistoryExcelSheet, {
        appts: appts, unmountExcelSheet: function unmountExcelSheet() {
          return setRenderExcel(false);
        }
      }) : null,
      react_default.a.createElement(
        'button',
        { onClick: function onClick() {
            return setRenderExcel(true);
          }, className: contentArea_default.a.titleAction },
        react_default.a.createElement(react_toolbox_lib["FontIcon"], { value: 'get_app' })
      )
    )
  );
};

JobHistoryHeader_JobHistoryHeader.propTypes = {
  renderExcel: prop_types_default.a.bool.isRequired,
  setRenderExcel: prop_types_default.a.func.isRequired,
  appts: prop_types_default.a.array.isRequired,
  search: prop_types_default.a.string.isRequired,
  setSearch: prop_types_default.a.func.isRequired
};

/* harmony default export */ var components_JobHistoryHeader = (JobHistoryHeader_JobHistoryHeader);
// CONCATENATED MODULE: ./client/app/screens/main/screens/reports/jobHistory/components/JobHistoryTable.jsx
function JobHistoryTable__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function JobHistoryTable__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function JobHistoryTable__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var JobHistoryTable_EMPTY_TABLE = react_default.a.createElement(
  'div',
  { className: jobHistoryStyles_default.a.emptyTable },
  react_default.a.createElement(
    'h4',
    null,
    'No job history found'
  )
);

var DENOMINATOR = 15;

var JobHistoryTable = function (_React$Component) {
  JobHistoryTable__inherits(JobHistoryTable, _React$Component);

  function JobHistoryTable(props) {
    JobHistoryTable__classCallCheck(this, JobHistoryTable);

    var _this = JobHistoryTable__possibleConstructorReturn(this, (JobHistoryTable.__proto__ || Object.getPrototypeOf(JobHistoryTable)).call(this, props));

    JobHistoryTable__initialiseProps.call(_this);

    _this.setRenderExcel = _this.setRenderExcel.bind(_this);
    _this.setPage = _this.setPage.bind(_this);
    _this.setSearch = _this.setSearch.bind(_this);
    var fullJobHistory = _this.getJobHistory() || [];
    _this.state = {
      fullJobHistory: fullJobHistory,
      filteredJobHistory: fullJobHistory,
      totalCount: fullJobHistory.length,
      currentPage: 1,
      search: '',
      renderExcel: false
    };
    return _this;
  }

  return JobHistoryTable;
}(react_default.a.Component);

var JobHistoryTable__initialiseProps = function _initialiseProps() {
  var _this2 = this;

  Object.defineProperty(this, 'setRenderExcel', {
    enumerable: true,
    writable: true,
    value: function value(val) {
      return _this2.setState({ renderExcel: val });
    }
  });
  Object.defineProperty(this, 'setPage', {
    enumerable: true,
    writable: true,
    value: function value(page) {
      return _this2.setState({ currentPage: page });
    }
  });
  Object.defineProperty(this, 'setSearch', {
    enumerable: true,
    writable: true,
    value: function value(term) {
      var fullJobHistory = _this2.state.fullJobHistory;

      var termCopy = term.toString();
      if (!termCopy) {
        _this2.setState({
          currentPage: 1,
          search: '',
          filteredJobHistory: fullJobHistory,
          totalCount: fullJobHistory.length });
      } else {
        var fullClone = Object(lodash["cloneDeep"])(fullJobHistory);
        var filteredClone = fullClone.filter(function (appt) {
          var valArr = [];
          Object(lodash["forEach"])(appt, function (val, key) {
            var valCopy = val;
            if (typeof val === 'number') valCopy = valCopy.toString();
            if (key === 'phase') {
              if (_this2.noVal(valCopy)) valArr.push('n/a');
              valArr.push((valCopy.project_number || 'n/a').toString());
            } else valArr.push(valCopy.toLowerCase());
          });
          return valArr.some(function (val) {
            return val.includes(termCopy.toLowerCase());
          });
        });
        _this2.setState({
          currentPage: 1,
          search: termCopy,
          filteredJobHistory: filteredClone,
          totalCount: filteredClone.length
        });
      }
    }
  });
  Object.defineProperty(this, 'getJobHistory', {
    enumerable: true,
    writable: true,
    value: function value() {
      var crews = _this2.props.crews;

      if (!crews.length) return [];
      var list = [];
      crews.forEach(function (c) {
        var _c$id = c.id,
            crewId = _c$id === undefined ? null : _c$id,
            _c$appointments = c.appointments,
            appts = _c$appointments === undefined ? [] : _c$appointments;

        if (appts.length) {
          appts.forEach(function (a) {
            var _a$id = a.id,
                id = _a$id === undefined ? null : _a$id,
                _a$assignee = a.assignee,
                assignee = _a$assignee === undefined ? 'N/A' : _a$assignee,
                _a$kind = a.kind,
                kind = _a$kind === undefined ? 'N/A' : _a$kind,
                _a$phase = a.phase,
                phase = _a$phase === undefined ? 'N/A' : _a$phase,
                _a$start_date = a.start_date,
                start_date = _a$start_date === undefined ? 'N/A' : _a$start_date,
                _a$end_date = a.end_date,
                end_date = _a$end_date === undefined ? 'N/A' : _a$end_date;

            list.push({
              id: id,
              crewId: crewId,
              crew: assignee,
              apptType: kind.replace('_', ' '),
              startDate: _this2.noVal(start_date) ? start_date : _this2.formatDate(start_date),
              endDate: _this2.noVal(end_date) ? end_date : _this2.formatDate(end_date),
              phase: phase
            });
          });
        }
      });
      return list;
    }
  });
  Object.defineProperty(this, 'getHistoryByPage', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _state = _this2.state,
          _state$filteredJobHis = _state.filteredJobHistory,
          filteredJobHistory = _state$filteredJobHis === undefined ? [] : _state$filteredJobHis,
          currentPage = _state.currentPage;

      if (!filteredJobHistory.length) return [];
      var paginatedHistory = Object(schedulingUtils["g" /* groupSuggestionsByPage */])(Object(lodash["cloneDeep"])(filteredJobHistory), DENOMINATOR);
      return paginatedHistory[currentPage - 1] || [];
    }
  });
  Object.defineProperty(this, 'noVal', {
    enumerable: true,
    writable: true,
    value: function value(val) {
      return !val || val === 'N/A';
    }
  });
  Object.defineProperty(this, 'formatDate', {
    enumerable: true,
    writable: true,
    value: function value(date) {
      return moment_default()(date, constants["_19" /* RAILS_DATE */]).format(constants["E" /* DISPLAY_DATE */]);
    }
  });
  Object.defineProperty(this, 'render', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _state2 = _this2.state,
          filteredJobHistory = _state2.filteredJobHistory,
          renderExcel = _state2.renderExcel,
          totalCount = _state2.totalCount,
          currentPage = _state2.currentPage,
          search = _state2.search;

      var historyByPage = _this2.getHistoryByPage();
      return react_default.a.createElement(
        'div',
        { className: jobHistoryStyles_default.a.jobHistoryTable },
        react_default.a.createElement(components_JobHistoryHeader, {
          setRenderExcel: _this2.setRenderExcel,
          renderExcel: renderExcel,
          appts: filteredJobHistory,
          search: search,
          setSearch: _this2.setSearch
        }),
        historyByPage.length ? react_default.a.createElement(
          react["Fragment"],
          null,
          react_default.a.createElement(
            editableTable,
            { isEditable: false, hasCreatableRow: false },
            historyByPage.map(function (appt) {
              return react_default.a.createElement(components_JobHistoryRow, { key: appt.id, appt: appt });
            })
          ),
          react_default.a.createElement('br', null),
          react_default.a.createElement(
            'div',
            { className: jobHistoryStyles_default.a.paginationContainer },
            react_default.a.createElement(Pagination, {
              denominator: DENOMINATOR,
              currentPage: currentPage,
              totalCount: totalCount,
              getListPage: function getListPage(page) {
                return _this2.setPage(page);
              },
              buttonStyle: 'listPageButton'
            })
          ),
          react_default.a.createElement('br', null)
        ) : JobHistoryTable_EMPTY_TABLE
      );
    }
  });
};

JobHistoryTable.propTypes = { crews: prop_types_default.a.array };

JobHistoryTable.defaultProps = { crews: [] };

/* harmony default export */ var components_JobHistoryTable = (JobHistoryTable);
// CONCATENATED MODULE: ./client/app/screens/main/screens/reports/jobHistory/index.jsx
function jobHistory__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function jobHistory__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function jobHistory__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



















var jobHistory_JobHistoryReport = function (_Validator) {
  jobHistory__inherits(JobHistoryReport, _Validator);

  function JobHistoryReport(props) {
    jobHistory__classCallCheck(this, JobHistoryReport);

    var _this = jobHistory__possibleConstructorReturn(this, (JobHistoryReport.__proto__ || Object.getPrototypeOf(JobHistoryReport)).call(this, props));

    jobHistory__initialiseProps.call(_this);

    var query = _this.props.location.query;
    _this.state = {
      installer_id: query.installer_id || null,
      start_date: moment_default()(query.start_date).format('MM/DD/YYYY') || moment_default()().format('YYYY-MM-DD'),
      errors: {}
    };
    return _this;
  }

  return JobHistoryReport;
}(validator(simple_request(react_default.a.Component, 'JobHistoryReport')));

Object.defineProperty(jobHistory_JobHistoryReport, 'VALIDATIONS', {
  enumerable: true,
  writable: true,
  value: { installer_id: true }
});

var jobHistory__initialiseProps = function _initialiseProps() {
  var _this2 = this;

  Object.defineProperty(this, 'onStartDateChange', {
    enumerable: true,
    writable: true,
    value: function value(date) {
      return _this2.setState({ start_date: date });
    }
  });
  Object.defineProperty(this, 'onInstallerChange', {
    enumerable: true,
    writable: true,
    value: function value(val) {
      return _this2.setState({ installer_id: val.employable_id || null });
    }
  });
  Object.defineProperty(this, 'submit', {
    enumerable: true,
    writable: true,
    value: function value(e) {
      e.preventDefault();
      if (!_this2.validate()) {
        return;
      }
      var _state = _this2.state,
          installer_id = _state.installer_id,
          start_date = _state.start_date;

      var query = {
        installer_id: parseInt(installer_id, 10),
        start_date: Object(dateUtils["o" /* handleDateSave */])(moment_default()(start_date, 'MM/DD/YYYY'))
      };
      _this2.props.push({ pathname: _this2.props.location.pathname, query: query });
    }
  });
  Object.defineProperty(this, 'render', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _props$report = _this2.props.report,
          loaded = _props$report.loaded,
          loading = _props$report.loading,
          data = _props$report.data;
      var _state2 = _this2.state,
          start_date = _state2.start_date,
          errors = _state2.errors;

      return react_default.a.createElement(
        'div',
        null,
        react_default.a.createElement(components_PageActionBar, {
          showAdd: false,
          showFiltersBtn: false,
          title: 'Job History Report'
        }),
        react_default.a.createElement(
          'div',
          { className: contentArea_default.a.contentAreaContainer },
          react_default.a.createElement(
            'div',
            { className: contentArea_default.a.contentArea + ' ' + shared_styles_default.a.noPrint },
            react_default.a.createElement(
              'form',
              { onSubmit: _this2.submit, className: shared_styles_default.a.form },
              react_default.a.createElement(formElements_AssigneeSelect, {
                multi: false,
                className: shared_styles_default.a.formElement,
                onChange: _this2.onInstallerChange,
                placeholder: 'All Installers',
                installerOnly: true
              }),
              react_default.a.createElement(DatePicker, {
                className: shared_styles_default.a.formElement,
                label: 'Start Date',
                value: start_date,
                onChange: _this2.onStartDateChange,
                placeholder: 'Select Start Date',
                error: errors.start_date && errors.start_date.join(', '),
                required: true
              }),
              _this2.props.children,
              react_default.a.createElement(
                ColoredButton["a" /* default */],
                { type: 'submit', className: shared_styles_default.a.formSubmit },
                'Run Report'
              )
            )
          ),
          loaded && react_default.a.createElement(
            'div',
            { className: contentArea_default.a.contentArea + ' ' + shared_styles_default.a.tableContainer },
            react_default.a.createElement(components_JobHistoryTable, { crews: data })
          ),
          loading && react_default.a.createElement(components_Loading, null)
        )
      );
    }
  });
};

jobHistory_JobHistoryReport.propTypes = {
  location: prop_types_default.a.shape({
    query: prop_types_default.a.objectOf(prop_types_default.a.string).isRequired,
    search: prop_types_default.a.string.isRequired,
    pathname: prop_types_default.a.string.isRequired
  }).isRequired,
  report: prop_types_default.a.shape({
    loaded: prop_types_default.a.bool
  }),
  requestJobHistoryReport: prop_types_default.a.func.isRequired,
  clearJobHistoryReport: prop_types_default.a.func.isRequired
};

/* harmony default export */ var jobHistory = (Object(react_redux_es["connect"])(function (state) {
  return {
    report: state.reports.jobHistory
  };
}, { requestJobHistoryReport: reports["j" /* requestJobHistoryReport */], clearJobHistoryReport: reports["d" /* clearJobHistoryReport */], push: react_router_redux_lib["push"] })(jobHistory_JobHistoryReport));
// CONCATENATED MODULE: ./client/app/screens/main/screens/reports/installerPaperwork/index.jsx
function installerPaperwork__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function installerPaperwork__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function installerPaperwork__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var installerPaperwork_InstallerPaperwork = function (_React$Component) {
  installerPaperwork__inherits(InstallerPaperwork, _React$Component);

  function InstallerPaperwork(props) {
    installerPaperwork__classCallCheck(this, InstallerPaperwork);

    var _this = installerPaperwork__possibleConstructorReturn(this, (InstallerPaperwork.__proto__ || Object.getPrototypeOf(InstallerPaperwork)).call(this, props));

    Object.defineProperty(_this, 'componentDidMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.props.clearInstallerPaperwork();
        if (_this.props.location.search) _this.props.requestInstallerPaperwork(_this.props.location.query);
      }
    });
    Object.defineProperty(_this, 'componentWillReceiveProps', {
      enumerable: true,
      writable: true,
      value: function value(nextProps) {
        var paperworkUrl = nextProps.report.paperwork_url,
            _nextProps$location = nextProps.location,
            search = _nextProps$location.search,
            query = _nextProps$location.query;

        if (search !== _this.props.location.search) {
          if (search) _this.props.requestInstallerPaperwork(query);else _this.props.clearInstallerPaperwork();
        }
        if (paperworkUrl && paperworkUrl !== _this.props.report.paperwork_url) {
          if (_this.isOneTimeReport(query)) window.location.href = paperworkUrl;else window.open(paperworkUrl);
        }
      }
    });
    Object.defineProperty(_this, 'componentWillUnmount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.clearInstallerPaperwork();
      }
    });
    Object.defineProperty(_this, 'onHideCostsChange', {
      enumerable: true,
      writable: true,
      value: function value(_value) {
        return _this.setState({ hide_costs: _value });
      }
    });
    Object.defineProperty(_this, 'onSubmit', {
      enumerable: true,
      writable: true,
      value: function value(queryParams) {
        var query = Object.assign({}, queryParams, _this.state);
        if (!_this.state.hide_costs) delete query.hide_costs;
        return _this.props.push({ pathname: _this.props.location.pathname, query: query });
      }
    });
    Object.defineProperty(_this, 'isOneTimeReport', {
      enumerable: true,
      writable: true,
      value: function value(query) {
        return query.appointment_id || query.installer_id && query.phase_id;
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            _this$props$report = _this$props.report,
            loaded = _this$props$report.loaded,
            loading = _this$props$report.loading,
            paperworkUrl = _this$props$report.paperwork_url,
            count = _this$props$report.count,
            location = _this$props.location;

        var hasPaperwork = count > 0;
        var showFilters = !_this.isOneTimeReport(location.query);
        return react_default.a.createElement(
          'div',
          null,
          react_default.a.createElement(components_PageActionBar, {
            showAdd: false,
            showFiltersBtn: false,
            title: 'Installations Paperwork'
          }),
          react_default.a.createElement(
            'div',
            { className: contentArea_default.a.contentAreaContainer },
            showFilters && react_default.a.createElement(
              'div',
              { className: contentArea_default.a.contentArea },
              react_default.a.createElement(
                components_ReportFilters,
                { location: _this.props.location, onSubmit: _this.onSubmit },
                react_default.a.createElement(react_toolbox_lib["Checkbox"], {
                  checked: _this.state.hide_costs,
                  label: 'Hide Costs',
                  onChange: _this.onHideCostsChange,
                  className: shared_styles_default.a.checkbox,
                  theme: checkbox_default.a
                })
              )
            ),
            loaded && hasPaperwork && react_default.a.createElement(
              'div',
              { className: contentArea_default.a.contentArea },
              react_default.a.createElement(
                'a',
                { href: paperworkUrl, target: '_blank', rel: 'noopener noreferrer' },
                'View Installer Paperwork'
              )
            ),
            loaded && !hasPaperwork && react_default.a.createElement(MessageBox["a" /* default */], {
              error: true,
              message: 'No installations scheduled for the selected options'
            }),
            loading && react_default.a.createElement(components_Loading, null)
          )
        );
      }
    });
    var queriedHideCosts = props.location.query.hide_costs;

    _this.state = { hide_costs: queriedHideCosts !== undefined ? queriedHideCosts : true };
    return _this;
  }

  return InstallerPaperwork;
}(react_default.a.Component);

installerPaperwork_InstallerPaperwork.propTypes = {
  location: prop_types_default.a.shape({
    pathname: prop_types_default.a.string.isRequired,
    query: prop_types_default.a.objectOf(prop_types_default.a.string).isRequired,
    search: prop_types_default.a.string.isRequired
  }).isRequired,
  report: prop_types_default.a.shape({
    loaded: prop_types_default.a.bool,
    paperwork_url: prop_types_default.a.string,
    count: prop_types_default.a.number
  }),
  requestInstallerPaperwork: prop_types_default.a.func.isRequired,
  clearInstallerPaperwork: prop_types_default.a.func.isRequired,
  push: prop_types_default.a.func.isRequired
};

/* harmony default export */ var installerPaperwork = (Object(react_redux_es["connect"])(function (state) {
  return {
    report: state.reports.installerPaperwork
  };
}, { requestInstallerPaperwork: actionCreators["_8" /* requestInstallerPaperwork */], clearInstallerPaperwork: actionCreators["h" /* clearInstallerPaperwork */], push: react_router_redux_lib["push"] })(installerPaperwork_InstallerPaperwork));
// CONCATENATED MODULE: ./client/app/screens/main/screens/reports/activity/index.jsx
function activity__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function activity__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function activity__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function activity__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






















var DATE_MSG = 'Must be on or before end date';
var TOO_LONG_MSG = 'Maximum of 7 days may be returned';

var activity_ActivityReport = function (_Validator) {
  activity__inherits(ActivityReport, _Validator);

  function ActivityReport(props) {
    activity__classCallCheck(this, ActivityReport);

    var _this = activity__possibleConstructorReturn(this, (ActivityReport.__proto__ || Object.getPrototypeOf(ActivityReport)).call(this, props));

    activity__initialiseProps.call(_this);

    var query = _this.props.location.query;
    _this.state = {
      errors: {},
      user_id: query.user_id || null,
      start_date: moment_default()(query.start_date).format('MM/DD/YYYY'),
      end_date: moment_default()(query.end_date).format('MM/DD/YYYY')
    };
    return _this;
  }

  return ActivityReport;
}(validator(simple_request(react_default.a.Component, 'ActivityReport')));

Object.defineProperty(activity_ActivityReport, 'VALIDATIONS', {
  enumerable: true,
  writable: true,
  value: { user_id: true, start_date: true, end_date: true }
});

var activity__initialiseProps = function _initialiseProps() {
  var _this2 = this;

  Object.defineProperty(this, 'onDateChange', {
    enumerable: true,
    writable: true,
    value: function value(kind) {
      return function (date) {
        return _this2.setState(activity__defineProperty({}, kind, date));
      };
    }
  });
  Object.defineProperty(this, 'onUserChange', {
    enumerable: true,
    writable: true,
    value: function value(val) {
      return _this2.setState({ user_id: val.id });
    }
  });
  Object.defineProperty(this, 'submit', {
    enumerable: true,
    writable: true,
    value: function value(e) {
      e.preventDefault();
      if (!_this2.validate()) {
        return;
      }
      var _state = _this2.state,
          user = _state.user_id,
          start_date = _state.start_date,
          end_date = _state.end_date;

      var startMoment = moment_default()(start_date, 'MM/DD/YYYY');
      var endMoment = moment_default()(end_date, 'MM/DD/YYYY');
      if (endMoment.isBefore(startMoment)) {
        _this2.setState({ errors: { start_date: [DATE_MSG] } });
      } else if (endMoment.diff(startMoment, 'days') > 7) {
        _this2.setState({ errors: { end_date: [TOO_LONG_MSG] } });
      } else {
        var query = {
          user_id: user,
          start_date: Object(dateUtils["o" /* handleDateSave */])(startMoment),
          end_date: Object(dateUtils["o" /* handleDateSave */])(endMoment)
        };
        _this2.props.push({ pathname: _this2.props.location.pathname, query: query });
      }
    }
  });
  Object.defineProperty(this, 'render', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _props$report = _this2.props.report,
          loaded = _props$report.loaded,
          loading = _props$report.loading,
          data = _props$report.data;
      var _state2 = _this2.state,
          start = _state2.start_date,
          end = _state2.end_date,
          errors = _state2.errors;

      return react_default.a.createElement(
        'div',
        null,
        react_default.a.createElement(components_PageActionBar, {
          showAdd: false,
          showFiltersBtn: false,
          title: 'Activity Report'
        }),
        react_default.a.createElement(
          'div',
          { className: contentArea_default.a.contentAreaContainer },
          react_default.a.createElement(
            'div',
            { className: classnames_default()(contentArea_default.a.contentArea, shared_styles_default.a.noPrint, shared_styles_default.a.filters) },
            react_default.a.createElement(
              'form',
              { onSubmit: _this2.submit, className: shared_styles_default.a.form },
              react_default.a.createElement(components_UserSearch, {
                label: 'User',
                required: true,
                className: classnames_default()(shared_styles_default.a.formElement, shared_styles_default.a.select),
                onChange: _this2.onUserChange,
                error: errors.user_id && errors.user_id.join(', ')
              }),
              react_default.a.createElement(DatePicker, {
                className: shared_styles_default.a.formElement,
                label: 'Start Date',
                value: start,
                onChange: _this2.onDateChange('start_date'),
                placeholder: 'Select Date',
                error: errors.start_date && errors.start_date.join(', '),
                required: true
              }),
              react_default.a.createElement(DatePicker, {
                className: shared_styles_default.a.formElement,
                label: 'End Date',
                value: end,
                onChange: _this2.onDateChange('end_date'),
                placeholder: 'Select Date',
                error: errors.end_date && errors.end_date.join(', '),
                required: true
              }),
              react_default.a.createElement('div', { className: shared_styles_default.a.formBreak }),
              react_default.a.createElement(
                ColoredButton["a" /* default */],
                { type: 'submit' },
                'Run Report'
              )
            )
          ),
          loaded && react_default.a.createElement(components_PhaseHistoryCard, {
            name: '\n              ' + data.meta.user.name + '\n              (' + moment_default()(data.meta.start_date).format('MM/DD/YYYY') + ' \u2013 ' + moment_default()(data.meta.end_date).format('MM/DD/YYYY') + ')\n                \u2014 ' + data.events.length + ' Events\n            ',
            events: data.events,
            collapsed: false
          }),
          loading && react_default.a.createElement(components_Loading, null)
        )
      );
    }
  });
};

activity_ActivityReport.propTypes = {
  location: prop_types_default.a.shape({
    query: prop_types_default.a.objectOf(prop_types_default.a.string).isRequired,
    search: prop_types_default.a.string.isRequired,
    pathname: prop_types_default.a.string.isRequired
  }).isRequired,
  report: prop_types_default.a.shape({
    loaded: prop_types_default.a.bool,
    data: prop_types_default.a.shape({
      events: prop_types_default.a.arrayOf(types_event),
      meta: prop_types_default.a.shape({
        user: prop_types_default.a.shape({
          name: prop_types_default.a.string.isRequired
        })
      })
    })
  }),
  requestActivityReport: prop_types_default.a.func.isRequired,
  clearActivityReport: prop_types_default.a.func.isRequired,
  push: prop_types_default.a.func.isRequired,
  phase: types_phase
};

/* harmony default export */ var activity = (Object(react_redux_es["connect"])(function (state) {
  return {
    report: state.reports.activity,
    phase: state.phase.details
  };
}, { requestActivityReport: actionCreators["T" /* requestActivityReport */], clearActivityReport: actionCreators["f" /* clearActivityReport */], push: react_router_redux_lib["push"] })(activity_ActivityReport));
// CONCATENATED MODULE: ./client/app/screens/main/screens/reports/tags/components/TagsBulkPrintFilters/index.jsx
var TagsBulkPrintFilters__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function TagsBulkPrintFilters__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function TagsBulkPrintFilters__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function TagsBulkPrintFilters__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var TagsBulkPrintFilters_TagsBulkExportFilters = function (_React$Component) {
  TagsBulkPrintFilters__inherits(TagsBulkExportFilters, _React$Component);

  function TagsBulkExportFilters(props) {
    TagsBulkPrintFilters__classCallCheck(this, TagsBulkExportFilters);

    var _this = TagsBulkPrintFilters__possibleConstructorReturn(this, (TagsBulkExportFilters.__proto__ || Object.getPrototypeOf(TagsBulkExportFilters)).call(this, props));

    Object.defineProperty(_this, 'onWorkroomChange', {
      enumerable: true,
      writable: true,
      value: function value() {
        var selected = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        var workroom_id = Array.isArray(selected) ? (selected[0] || {}).value || null : (selected || {}).value || null;
        return _this.setState({ workroom_id: workroom_id, error: '' });
      }
    });
    Object.defineProperty(_this, 'onDateChange', {
      enumerable: true,
      writable: true,
      value: function value(date) {
        return _this.setState({ date_received: Object(dateUtils["o" /* handleDateSave */])(date) });
      }
    });
    Object.defineProperty(_this, 'setError', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState({ error: 'Please select a workroom' });
      }
    });
    Object.defineProperty(_this, 'submit', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        e.preventDefault();
        if (!_this.state.workroom_id) return _this.setError();
        var query = TagsBulkPrintFilters__extends({}, _this.state);
        delete query.error;
        if (_this.props.onSubmit) return _this.props.onSubmit(query);

        return _this.props.push({ pathname: _this.props.location.pathname, query: query });
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var date = moment_default()(_this.state.date_received).format(constants["E" /* DISPLAY_DATE */]);
        return react_default.a.createElement(
          'form',
          { onSubmit: _this.submit, className: shared_styles_default.a.form },
          react_default.a.createElement(formElements_WorkroomSelect, {
            className: shared_styles_default.a.formElement,
            multi: false,
            resetValue: null,
            onChange: _this.onWorkroomChange,
            value: _this.state.workroom_id,
            error: _this.state.error,
            required: true
          }),
          react_default.a.createElement(DatePicker, {
            className: shared_styles_default.a.formElement,
            label: 'Date',
            value: date,
            onChange: _this.onDateChange,
            placeholder: 'Select Date',
            required: true
          }),
          _this.props.children,
          react_default.a.createElement(
            ColoredButton["a" /* default */],
            { type: 'submit' },
            'List Tags'
          ),
          '\xA0\xA0\xA0',
          _this.props.showPrint && react_default.a.createElement(
            ColoredButton["a" /* default */],
            {
              type: 'button',
              onClick: function onClick() {
                return _this.props.handlePrint();
              }
            },
            'Print Selected Tags'
          )
        );
      }
    });


    var startingState = {
      workroom_id: parseInt(props.location.query.workroom_id, 10) || null,
      date_received: props.location.query.date_received || moment_default()().format('YYYY-MM-DD'),
      error: ''
    };

    _this.state = startingState;
    return _this;
  }

  return TagsBulkExportFilters;
}(react_default.a.Component);

TagsBulkPrintFilters_TagsBulkExportFilters.propTypes = {
  location: prop_types_default.a.shape({
    pathname: prop_types_default.a.string.isRequired,
    query: prop_types_default.a.shape({
      workroom_id: prop_types_default.a.string,
      date_received: prop_types_default.a.string
    })
  }).isRequired,
  someSelected: prop_types_default.a.bool,
  push: prop_types_default.a.func.isRequired,
  onSubmit: prop_types_default.a.func,
  children: prop_types_default.a.node,
  showPrint: prop_types_default.a.bool,
  handlePrint: prop_types_default.a.func
};

/* harmony default export */ var TagsBulkPrintFilters = (Object(react_redux_es["connect"])(function () {
  return {};
}, { push: react_router_redux_lib["push"] })(TagsBulkPrintFilters_TagsBulkExportFilters));
// CONCATENATED MODULE: ./client/app/screens/main/screens/reports/tags/components/TagsBulkPrintTable/index.jsx
function TagsBulkPrintTable__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function TagsBulkPrintTable__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function TagsBulkPrintTable__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var TagsBulkPrintTable_TagsBulkExportTable = function (_React$Component) {
  TagsBulkPrintTable__inherits(TagsBulkExportTable, _React$Component);

  function TagsBulkExportTable() {
    var _ref;

    var _temp, _this, _ret;

    TagsBulkPrintTable__classCallCheck(this, TagsBulkExportTable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = TagsBulkPrintTable__possibleConstructorReturn(this, (_ref = TagsBulkExportTable.__proto__ || Object.getPrototypeOf(TagsBulkExportTable)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'componentDidUpdate', {
      enumerable: true,
      writable: true,
      value: function value() {
        // only true if no tags in state are checked
        var noTagsChecked = _this.props.tags.every(function (t) {
          return t.isChecked === false;
        });
        // If no tags are checked, do not show the print button
        // If any tags are checked, show the print button
        if (noTagsChecked === true && _this.props.showPrint) _this.props.toggleShowPrint(false);
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            tags = _this$props.tags,
            checkedAll = _this$props.checkedAll;

        return react_default.a.createElement(
          'table',
          {
            className: table_default.a.cardTable + ' ' + shared_styles_default.a.table,
            cellSpacing: '0'
          },
          react_default.a.createElement(
            'thead',
            null,
            react_default.a.createElement(
              'tr',
              { className: table_default.a.headerRow },
              react_default.a.createElement(
                'th',
                { className: table_default.a.column },
                react_default.a.createElement(react_toolbox_lib["Checkbox"], {
                  key: 'checkAll',
                  checked: checkedAll,
                  label: 'Select/Unselect all',
                  onChange: function onChange() {
                    return _this.props.handleToggleAll();
                  },
                  className: form_default.a.checkboxListItem,
                  theme: checkbox_default.a
                })
              ),
              react_default.a.createElement(
                'th',
                { className: table_default.a.column },
                'PO #'
              ),
              react_default.a.createElement(
                'th',
                { className: table_default.a.column },
                'Customer Name'
              ),
              react_default.a.createElement(
                'th',
                { className: table_default.a.column },
                'Store #'
              ),
              react_default.a.createElement(
                'th',
                { className: table_default.a.column },
                'Item Name'
              ),
              react_default.a.createElement(
                'th',
                { className: table_default.a.column },
                'Quantity'
              ),
              react_default.a.createElement(
                'th',
                { className: table_default.a.column },
                'Tag #'
              ),
              react_default.a.createElement(
                'th',
                { className: table_default.a.column },
                'Date Received'
              ),
              react_default.a.createElement(
                'th',
                { className: table_default.a.column },
                'Bin'
              )
            )
          ),
          react_default.a.createElement(
            'tbody',
            null,
            tags.map(function (tag) {
              return react_default.a.createElement(
                'tr',
                { key: tag.id, className: table_default.a.contentRow },
                react_default.a.createElement(
                  'td',
                  { className: table_default.a.column },
                  react_default.a.createElement(react_toolbox_lib["Checkbox"], {
                    checked: tag.isChecked,
                    label: react_default.a.createElement(react_toolbox_lib["FontIcon"], { className: table_default.a.icon, value: 'ic_print' }),
                    onChange: function onChange() {
                      return _this.props.handleChange(tag);
                    },
                    className: form_default.a.checkboxListItem,
                    theme: checkbox_default.a
                  })
                ),
                react_default.a.createElement(
                  'td',
                  { className: table_default.a.column },
                  react_default.a.createElement(
                    es["c" /* Link */],
                    {
                      to: urls.phasePurchaseOrders(tag.phase_id),
                      className: shared_styles_default.a.link,
                      target: '_blank'
                    },
                    tag.purchase_order_number || 'N/A'
                  )
                ),
                react_default.a.createElement(
                  'td',
                  { className: table_default.a.column },
                  react_default.a.createElement(
                    es["c" /* Link */],
                    {
                      to: urls.phaseWarehouseMaterials(tag.phase_id),
                      className: shared_styles_default.a.link,
                      target: '_blank'
                    },
                    tag.customer_name || 'N/A'
                  )
                ),
                react_default.a.createElement(
                  'td',
                  { className: table_default.a.column },
                  tag.store_number || 'N/A'
                ),
                react_default.a.createElement(
                  'td',
                  { className: table_default.a.column },
                  tag.item_name || 'N/A'
                ),
                react_default.a.createElement(
                  'td',
                  { className: table_default.a.column },
                  Math.floor(tag.received_quantity) || 'N/A'
                ),
                react_default.a.createElement(
                  'td',
                  { className: table_default.a.column },
                  tag.tag_number || 'N/A'
                ),
                react_default.a.createElement(
                  'td',
                  { className: table_default.a.column },
                  react_default.a.createElement(
                    'div',
                    null,
                    moment_default()(tag.date_received).format('MM/DD/YYYY')
                  )
                ),
                react_default.a.createElement(
                  'td',
                  { className: table_default.a.column },
                  tag.bin
                )
              );
            })
          )
        );
      }
    }), _temp), TagsBulkPrintTable__possibleConstructorReturn(_this, _ret);
  }

  return TagsBulkExportTable;
}(react_default.a.Component);

/* harmony default export */ var TagsBulkPrintTable = (TagsBulkPrintTable_TagsBulkExportTable);


TagsBulkPrintTable_TagsBulkExportTable.propTypes = {
  tags: prop_types_default.a.array.isRequired,
  toggleShowPrint: prop_types_default.a.func.isRequired,
  showPrint: prop_types_default.a.bool.isRequired,
  checkedAll: prop_types_default.a.bool.isRequired,
  handleToggleAll: prop_types_default.a.func.isRequired,
  handleChange: prop_types_default.a.func.isRequired
};
// CONCATENATED MODULE: ./client/app/screens/main/screens/reports/tags/index.jsx
var tags__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function tags__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function tags__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function tags__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var tags_TagsReports = function (_React$Component) {
  tags__inherits(TagsReports, _React$Component);

  function TagsReports(props) {
    tags__classCallCheck(this, TagsReports);

    var _this = tags__possibleConstructorReturn(this, (TagsReports.__proto__ || Object.getPrototypeOf(TagsReports)).call(this, props));

    Object.defineProperty(_this, 'componentDidMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.props.clearTagBulkPrint();
        if (_this.props.location.search) _this.props.requestTagBulkPrint(_this.props.location.query);
      }
    });
    Object.defineProperty(_this, 'componentWillReceiveProps', {
      enumerable: true,
      writable: true,
      value: function value(nextProps) {
        var _nextProps$location = nextProps.location,
            search = _nextProps$location.search,
            query = _nextProps$location.query;

        var tags = void 0;
        if (search !== _this.props.location.search) {
          if (search) _this.props.requestTagBulkPrint(query);else _this.props.clearTagBulkPrint();
        }
        if (nextProps.bulkTags.tags && nextProps.bulkTags.tags !== _this.props.bulkTags.tags) {
          tags = nextProps.bulkTags.tags.map(function (tag) {
            return tags__extends({}, tag, { isChecked: true });
          });
          _this.setState({ tags: tags });
        }
      }
    });
    Object.defineProperty(_this, 'componentDidUpdate', {
      enumerable: true,
      writable: true,
      value: function value(prevProps, prevState) {
        var _this$props$bulkTags = _this.props.bulkTags,
            loaded = _this$props$bulkTags.loaded,
            count = _this$props$bulkTags.count;

        if (loaded && count > 0 && _this.state.showPrint === false && prevState.showPrint === false) _this.toggleShowPrint(true);
      }
    });
    Object.defineProperty(_this, 'componentWillUnmount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.clearTagBulkPrint();
      }
    });
    Object.defineProperty(_this, 'onSubmit', {
      enumerable: true,
      writable: true,
      value: function value(query) {
        return _this.props.push({ pathname: _this.props.location.pathname, query: query });
      }
    });
    Object.defineProperty(_this, 'handlePrint', {
      enumerable: true,
      writable: true,
      value: function value() {
        var tagsToPrint = _this.state.tags.filter(function (tag) {
          return tag.isChecked;
        });
        if (tagsToPrint.length > 0) {
          var tags = tagsToPrint.map(function (tag) {
            return {
              storeNumber: tag.store_number,
              customerName: tag.customer_name,
              poNumber: tag.purchase_order_number,
              quantity: tag.received_quantity,
              dateReceived: tag.date_received,
              tagNumber: tag.tag_number,
              bin: tag.bin,
              itemName: tag.item_name.replace(/\s\s+/g, ' ').trim(),
              pads: tag.pads
            };
          });
          var b64Query = btoa(JSON.stringify(tags));
          es["g" /* browserHistory */].push({ pathname: '/print-label', search: '?queryData=' + JSON.stringify(b64Query) });
        }
      }
    });
    Object.defineProperty(_this, 'handleTagToggle', {
      enumerable: true,
      writable: true,
      value: function value(tag) {
        var tags = _this.state.tags;
        tags.find(function (t) {
          return t.id === tag.id;
        }).isChecked = !tag.isChecked;
        _this.setState({ tags: tags, checkedAll: false });
        var noTagsChecked = _this.state.tags.every(function (t) {
          return t.isChecked === false;
        });
        if (noTagsChecked === false && _this.state.showPrint === false) {
          _this.toggleShowPrint(false);
        }
      }
    });
    Object.defineProperty(_this, 'handleToggleAll', {
      enumerable: true,
      writable: true,
      value: function value() {
        var checkedAll = !_this.state.checkedAll;
        var newTag = void 0;
        var tags = _this.state.tags.map(function (tag) {
          if (checkedAll) newTag = tags__extends({}, tag, { isChecked: true });else newTag = tags__extends({}, tag, { isChecked: !tag.isChecked });
          return newTag;
        });
        _this.setState({ tags: tags, checkedAll: checkedAll });
        if (checkedAll) _this.toggleShowPrint(true);else _this.toggleShowPrint(false);
      }
    });
    Object.defineProperty(_this, 'toggleShowPrint', {
      enumerable: true,
      writable: true,
      value: function value(showPrint) {
        return _this.setState({ showPrint: showPrint });
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            _this$props$bulkTags2 = _this$props.bulkTags,
            loaded = _this$props$bulkTags2.loaded,
            loading = _this$props$bulkTags2.loading,
            count = _this$props$bulkTags2.count,
            location = _this$props.location;
        var _this$state = _this.state,
            showPrint = _this$state.showPrint,
            tags = _this$state.tags,
            checkedAll = _this$state.checkedAll;

        return react_default.a.createElement(
          react["Fragment"],
          null,
          react_default.a.createElement(components_PageActionBar, {
            showFiltersBtn: false,
            title: 'Tags Bulk Print'
          }),
          react_default.a.createElement(
            'div',
            { className: contentArea_default.a.contentAreaContainer },
            react_default.a.createElement(
              'div',
              { className: contentArea_default.a.contentArea },
              react_default.a.createElement(TagsBulkPrintFilters, {
                location: location,
                onSubmit: _this.onSubmit,
                showPrint: showPrint,
                handlePrint: _this.handlePrint
              }),
              react_default.a.createElement('br', null),
              loaded && react_default.a.createElement(TagsBulkPrintTable, {
                tags: tags,
                showPrint: showPrint,
                checkedAll: checkedAll,
                handleChange: _this.handleTagToggle,
                handleToggleAll: function handleToggleAll() {
                  return _this.handleToggleAll();
                },
                toggleShowPrint: _this.toggleShowPrint
              }),
              loaded && count <= 0 && react_default.a.createElement(MessageBox["a" /* default */], {
                error: true,
                message: 'No installations scheduled for the selected options'
              }),
              loading && react_default.a.createElement(components_Loading, null)
            )
          )
        );
      }
    });

    _this.state = { showPrint: false, tags: [], checkedAll: true };
    return _this;
  }

  return TagsReports;
}(react_default.a.Component);

tags_TagsReports.propTypes = {
  location: prop_types_default.a.shape({
    pathname: prop_types_default.a.string.isRequired,
    query: prop_types_default.a.shape({
      date_received: prop_types_default.a.string,
      workroom_id: prop_types_default.a.string
    }).isRequired,
    search: prop_types_default.a.string.isRequired
  }).isRequired,
  bulkTags: prop_types_default.a.shape({
    loaded: prop_types_default.a.bool,
    tags: prop_types_default.a.array,
    count: prop_types_default.a.number
  }),
  requestTagBulkPrint: prop_types_default.a.func.isRequired,
  clearTagBulkPrint: prop_types_default.a.func.isRequired,
  push: prop_types_default.a.func.isRequired
};

/* harmony default export */ var reports_tags = (Object(react_redux_es["connect"])(function (state) {
  return {
    bulkTags: state.reports.tagsBulkPrint
  };
}, { requestTagBulkPrint: actionCreators["_26" /* requestTagBulkPrint */], clearTagBulkPrint: actionCreators["i" /* clearTagBulkPrint */], push: react_router_redux_lib["push"] })(tags_TagsReports));
// EXTERNAL MODULE: ./client/app/screens/main/screens/tools/scraper/scraper.scss
var scraper = __webpack_require__("kGAz");
var scraper_default = /*#__PURE__*/__webpack_require__.n(scraper);

// CONCATENATED MODULE: ./client/app/screens/main/screens/tools/scraper/index.jsx
var scraper__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function scraper__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function scraper__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function scraper__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var scraper_Scraper = function (_Component) {
  scraper__inherits(Scraper, _Component);

  function Scraper() {
    var _ref;

    var _temp, _this, _ret;

    scraper__classCallCheck(this, Scraper);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = scraper__possibleConstructorReturn(this, (_ref = Scraper.__proto__ || Object.getPrototypeOf(Scraper)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'handleSubmit', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        e.preventDefault();
        var formData = new FormData();
        var fileInput = _this.fileInput.files;
        if (fileInput.length === 0) {
          _this.errorMessage = 'Please select a file.';
        }
        Array.from({ length: fileInput.length }).forEach(function (_, i) {
          return formData.append('scraper[asset-' + i + ']', fileInput[i]);
        });
        _this.props.scraper(formData);
      }
    }), Object.defineProperty(_this, 'phaseLink', {
      enumerable: true,
      writable: true,
      value: function value(phase) {
        return phase.assessment ? phase.assessment.id : phase.installation.id;
      }
    }), _temp), scraper__possibleConstructorReturn(_this, _ret);
  }

  scraper__createClass(Scraper, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          documents = _props.documents,
          loading = _props.loading;


      var allPages = void 0;
      if (!Object(utils["p" /* isEmpty */])(documents)) {
        allPages = documents.map(function (doc) {
          return react_default.a.createElement(
            'div',
            { key: doc.id, className: scraper_default.a.documents },
            react_default.a.createElement(
              'div',
              { className: doc.failure === true ? scraper_default.a.fail : scraper_default.a.success },
              doc.original_name && react_default.a.createElement(
                'p',
                { className: scraper_default.a.document },
                'Document Name: ',
                doc.original_name
              ),
              doc.errors && react_default.a.createElement(
                'p',
                { className: scraper_default.a.document },
                'Errors: ',
                doc.errors
              )
            ),
            doc.pages && doc.pages.map(function (page) {
              return react_default.a.createElement(
                'div',
                { key: page.id, className: scraper_default.a.page },
                (page.errors.length > 0 || page.subtype) && react_default.a.createElement(
                  'div',
                  null,
                  page.original_name && react_default.a.createElement(
                    'p',
                    null,
                    'Page: ',
                    page.id + 1
                  ),
                  page.phase && (page.phase.assessment || page.phase.installation) && react_default.a.createElement(
                    'p',
                    null,
                    react_default.a.createElement(
                      es["c" /* Link */],
                      { to: '/phases/' + _this2.phaseLink(page.phase) + '/info', target: '_blank' },
                      'View Phase'
                    )
                  ),
                  page.errors.length > 0 && react_default.a.createElement(
                    'p',
                    null,
                    'Errors: ',
                    page.errors
                  ),
                  page.type && react_default.a.createElement(
                    'p',
                    null,
                    'Type: ',
                    page.type
                  ),
                  page.subtype && react_default.a.createElement(
                    'p',
                    null,
                    'Subtype: ',
                    page.subtype
                  )
                )
              );
            })
          );
        });
      }
      return react_default.a.createElement(
        'div',
        null,
        react_default.a.createElement(components_PageActionBar, {
          showAdd: false,
          showFiltersBtn: false,
          title: 'Scraper'
        }),
        react_default.a.createElement(
          'div',
          { className: contentArea_default.a.contentAreaContainer },
          react_default.a.createElement(
            'div',
            { className: contentArea_default.a.contentArea },
            react_default.a.createElement(
              'form',
              { onSubmit: this.handleSubmit },
              react_default.a.createElement('input', { type: 'file', placeholder: 'Select a file', ref: function ref(c) {
                  _this2.fileInput = c;
                }, multiple: true }),
              react_default.a.createElement(
                ColoredButton["a" /* default */],
                { type: 'submit', disabled: loading },
                'Scrape'
              )
            ),
            !Object(utils["p" /* isEmpty */])(documents) && react_default.a.createElement(
              'div',
              null,
              allPages
            ),
            loading && react_default.a.createElement(components_Loading, null)
          )
        )
      );
    }
  }]);

  return Scraper;
}(react["Component"]);

scraper_Scraper.propTypes = {
  scraper: prop_types_default.a.func,
  documents: prop_types_default.a.array,
  loading: prop_types_default.a.bool
};

var scraper_mapStateToProps = function mapStateToProps(state) {
  return {
    documents: state.scraper.documents,
    loading: state.scraper.loading
  };
};

/* harmony default export */ var tools_scraper = (Object(react_redux_es["connect"])(scraper_mapStateToProps, {
  scraper: actionCreators["_42" /* scraper */]
})(scraper_Scraper));
// EXTERNAL MODULE: ./client/app/shared/components/UploadManager/styles.scss
var UploadManager_styles = __webpack_require__("eorU");
var UploadManager_styles_default = /*#__PURE__*/__webpack_require__.n(UploadManager_styles);

// CONCATENATED MODULE: ./client/app/shared/components/UploadManager/index.jsx
var UploadManager__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function UploadManager__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function UploadManager__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function UploadManager__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var UploadManager_UploadsManager = function (_Component) {
  UploadManager__inherits(UploadsManager, _Component);

  function UploadsManager(props) {
    UploadManager__classCallCheck(this, UploadsManager);

    var _this = UploadManager__possibleConstructorReturn(this, (UploadsManager.__proto__ || Object.getPrototypeOf(UploadsManager)).call(this, props));

    Object.defineProperty(_this, 'componentWillMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.getUploadsList(_this.props.uploadType, 1);
      }
    });
    Object.defineProperty(_this, 'componentWillUnmount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return clearInterval(_this.polling);
      }
    });
    Object.defineProperty(_this, 'setErrorMessage', {
      enumerable: true,
      writable: true,
      value: function value(error) {
        return _this.props.setErrorMessage(error, _this.props.uploadType);
      }
    });
    Object.defineProperty(_this, 'getUploadListByPage', {
      enumerable: true,
      writable: true,
      value: function value(page) {
        return _this.props.getUploadsList(_this.props.uploadType, page);
      }
    });
    Object.defineProperty(_this, 'startPoll', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.polling = setInterval(function () {
          return _this.props.getUploadsList(_this.props.uploadType);
        }, 7000);
      }
    });
    Object.defineProperty(_this, 'handleDialogToggle', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.toggleDialog(!_this.props.dialogActive, _this.props.uploadType);
      }
    });
    Object.defineProperty(_this, 'handleDialogSubmit', {
      enumerable: true,
      writable: true,
      value: function value(formData) {
        return _this.props.uploadFile(formData, _this.props.uploadType).then(function () {
          return _this.props.getUploadsList(_this.props.uploadType);
        });
      }
    });
    Object.defineProperty(_this, 'addAction', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.handleDialogToggle();
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            data = _this$props.data,
            uploadType = _this$props.uploadType,
            title = _this$props.title,
            loading = _this$props.loading,
            needsMore = _this$props.needsMore,
            role = _this$props.role,
            page = _this$props.page,
            totalCount = _this$props.totalCount,
            user = _this$props.user;

        var uploads = data.map(function (upload) {
          return {
            id: upload.id,
            active: upload.active,
            uploadName: react_default.a.createElement(
              'a',
              { href: upload.expiring_download_url, className: UploadManager_styles_default.a.uploadLink },
              react_default.a.createElement(react_toolbox_lib["FontIcon"], { value: 'insert_drive_file', className: UploadManager_styles_default.a.centerFont })
            ),
            uploadedBy: upload.user.name,
            uploadedOn: Object(dateUtils["k" /* getLocalDate */])(upload.created_at),
            uploadedOnMobile: Object(dateUtils["l" /* getMinLocalDate */])(upload.created_at),
            statusText: upload.status,
            summary: upload.summary
          };
        });
        var resource = uploadType.slice(0, -1);
        return react_default.a.createElement(
          'div',
          null,
          react_default.a.createElement(components_PageActionBar, {
            resource: resource,
            role: role,
            title: title + ' Uploads',
            addAction: _this.addAction,
            showFiltersBtn: false,
            user: user,
            showAdd: true
          }),
          react_default.a.createElement(components_UploadDialog, {
            active: _this.props.dialogActive,
            title: 'Upload ' + title,
            formDataKey: resource + '[asset]',
            handleToggle: _this.handleDialogToggle,
            handleSubmit: _this.handleDialogSubmit,
            errors: _this.props.uploadError,
            setErrorMessage: _this.setErrorMessage,
            fileLoading: _this.props.fileLoading
          }),
          react_default.a.createElement(
            'div',
            { className: contentArea_default.a.contentAreaContainer },
            react_default.a.createElement(components_UploadsTable, {
              downloadColumnName: 'Download',
              role: role,
              data: uploads,
              needsMore: needsMore,
              loading: loading,
              handleInfiniteLoad: _this.handleInfiniteLoad
            }),
            react_default.a.createElement('br', null),
            react_default.a.createElement(Pagination, {
              currentPage: page,
              totalCount: totalCount,
              getListPage: function getListPage(pageNum) {
                return _this.getUploadListByPage(pageNum);
              }
            })
          )
        );
      }
    });

    _this.addAction = _this.addAction.bind(_this);
    _this.handleDialogToggle = _this.handleDialogToggle.bind(_this);
    _this.handleDialogSubmit = _this.handleDialogSubmit.bind(_this);
    _this.setErrorMessage = _this.setErrorMessage.bind(_this);
    return _this;
  }

  UploadManager__createClass(UploadsManager, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.data !== nextProps.data) {
        clearInterval(this.polling);
        if (nextProps.uploadIsProcessing) this.startPoll();
      }
    }
  }]);

  return UploadsManager;
}(react["Component"]);

UploadManager_UploadsManager.propTypes = {
  role: prop_types_default.a.string,
  uploadError: prop_types_default.a.object,
  fileLoading: prop_types_default.a.bool,
  dialogActive: prop_types_default.a.bool,
  uploadFile: prop_types_default.a.func,
  toggleDialog: prop_types_default.a.func,
  setErrorMessage: prop_types_default.a.func,
  getUploadListData: prop_types_default.a.func,
  data: prop_types_default.a.array,
  uploadIsProcessing: prop_types_default.a.bool,
  uploadType: prop_types_default.a.string.isRequired,
  title: prop_types_default.a.string.isRequired,
  getUploadsList: prop_types_default.a.func,
  needsMore: prop_types_default.a.bool,
  loading: prop_types_default.a.bool,
  page: prop_types_default.a.number,
  totalCount: prop_types_default.a.number,
  user: prop_types_default.a.object
};

var UploadManager_mapStateToProps = function mapStateToProps(state, ownProps) {
  var uploadKey = Object(lodash["camelCase"])(ownProps.uploadType);
  var uploadState = state[uploadKey];
  return {
    role: Object(reducers["_12" /* getRole */])(state),
    needsMore: Object(reducers["_26" /* getUploadHasNextPage */])(uploadState),
    loading: Object(reducers["_29" /* getUploadListLoading */])(uploadState),
    uploadError: Object(reducers["_25" /* getUploadError */])(uploadState) || {},
    fileLoading: Object(reducers["_30" /* getUploadLoading */])(uploadState),
    dialogActive: Object(reducers["_24" /* getUploadDialogStatus */])(uploadState),
    data: Object(reducers["_28" /* getUploadListData */])(uploadState) || [],
    uploadIsProcessing: Object(reducers["_27" /* getUploadIsProcessing */])(uploadState),
    page: Object(reducers["_31" /* getUploadPage */])(uploadState),
    totalCount: Object(reducers["_32" /* getUploadTotalCount */])(uploadState),
    user: state.user
  };
};

/* harmony default export */ var UploadManager = (Object(react_redux_es["connect"])(UploadManager_mapStateToProps, {
  uploadFile: actionCreators["_75" /* uploadFile */], toggleDialog: actionCreators["_57" /* toggleDialog */], setErrorMessage: actionCreators["_46" /* setErrorMessage */], getUploadsList: actionCreators["B" /* getUploadsList */]
})(UploadManager_UploadsManager));
// CONCATENATED MODULE: ./client/app/screens/main/screens/pricePatchUploads/index.jsx



var pricePatchUploads_PricePatchUploads = function PricePatchUploads() {
  return react_default.a.createElement(UploadManager, {
    uploadType: 'price_patch_uploads',
    title: 'Price Patch'
  });
};

/* harmony default export */ var pricePatchUploads = (pricePatchUploads_PricePatchUploads);
// EXTERNAL MODULE: ./client/app/shared/actionCreators/line_items.js
var line_items = __webpack_require__("/gPC");

// CONCATENATED MODULE: ./client/app/screens/main/screens/lineItems/components/lineItemRow.jsx
var lineItemRow__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function lineItemRow__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function lineItemRow__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function lineItemRow__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function lineItemRow__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var lineItemRow_formatOptions = function formatOptions(options) {
  return options.map(function (value) {
    return { value: value, label: Object(utils["B" /* titleize */])(value) };
  });
};
var KIND_OPTIONS = lineItemRow_formatOptions(['Labor', 'Product']);
var lineItemRow_CATEGORY_OPTIONS = lineItemRow_formatOptions(['', 'lead_assessment', 'pad', 'mileage']);
var SURFACE_TYPE_OPTIONS = lineItemRow_formatOptions(['', 'All', 'Hardwood', 'Carpet', 'Tile', 'Laminate', 'Vinyl', 'Vinyl Plank', 'Backsplash', 'Pro Direct', 'Multi']);

var lineItemRow_LineItemRow = function (_Editable) {
  lineItemRow__inherits(LineItemRow, _Editable);

  function LineItemRow() {
    var _ref;

    var _temp, _this, _ret;

    lineItemRow__classCallCheck(this, LineItemRow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = lineItemRow__possibleConstructorReturn(this, (_ref = LineItemRow.__proto__ || Object.getPrototypeOf(LineItemRow)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'state', {
      enumerable: true,
      writable: true,
      value: lineItemRow__extends({}, _this.props.lineItem)
    }), Object.defineProperty(_this, 'handleSave', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.onSave(_this.state);
      }
    }), Object.defineProperty(_this, 'handleChange', {
      enumerable: true,
      writable: true,
      value: function value(attr) {
        return function (val) {
          return _this.setState(lineItemRow__defineProperty({}, attr, val.target ? val.target.value : val));
        };
      }
    }), Object.defineProperty(_this, 'handleItemNumberChange', {
      enumerable: true,
      writable: true,
      value: _this.handleChange('item_number')
    }), Object.defineProperty(_this, 'handleDescriptionChange', {
      enumerable: true,
      writable: true,
      value: _this.handleChange('description')
    }), Object.defineProperty(_this, 'handleNetPayableChange', {
      enumerable: true,
      writable: true,
      value: _this.handleChange('net_payable')
    }), Object.defineProperty(_this, 'handlePayableChange', {
      enumerable: true,
      writable: true,
      value: _this.handleChange('payable')
    }), Object.defineProperty(_this, 'handleActiveChange', {
      enumerable: true,
      writable: true,
      value: _this.handleChange('active')
    }), Object.defineProperty(_this, 'handleKindChange', {
      enumerable: true,
      writable: true,
      value: _this.handleChange('kind')
    }), Object.defineProperty(_this, 'handleCategoryChange', {
      enumerable: true,
      writable: true,
      value: _this.handleChange('category')
    }), Object.defineProperty(_this, 'handleVendorTypeChange', {
      enumerable: true,
      writable: true,
      value: _this.handleChange('vendor')
    }), Object.defineProperty(_this, 'handleSurfaceTypeChange', {
      enumerable: true,
      writable: true,
      value: _this.handleChange('surface_type')
    }), Object.defineProperty(_this, 'handleAccountingIdChange', {
      enumerable: true,
      writable: true,
      value: _this.handleChange('accounting_id')
    }), Object.defineProperty(_this, 'handlePayableSave', {
      enumerable: true,
      writable: true,
      value: function value(val) {
        return _this.setState({ payable: val }, _this.handleSave);
      }
    }), Object.defineProperty(_this, 'handleActiveSave', {
      enumerable: true,
      writable: true,
      value: function value(val) {
        return _this.setState({ active: val }, _this.handleSave);
      }
    }), Object.defineProperty(_this, 'formatPercent', {
      enumerable: true,
      writable: true,
      value: function value(val) {
        return val ? val + '%' : '';
      }
    }), Object.defineProperty(_this, 'renderPayable', {
      enumerable: true,
      writable: true,
      value: function value() {
        var value = react_default.a.createElement(react_toolbox_lib["Checkbox"], {
          checked: _this.state.payable,
          onChange: _this.handlePayableSave,
          className: form_default.a.checkboxListItem,
          theme: checkbox_default.a
        });
        return react_default.a.createElement(
          editableTableCell,
          { label: 'Payable', value: value, onChange: _this.handlePayableChange },
          value
        );
      }
    }), Object.defineProperty(_this, 'renderActive', {
      enumerable: true,
      writable: true,
      value: function value() {
        var value = react_default.a.createElement(react_toolbox_lib["Checkbox"], {
          checked: _this.state.active,
          onChange: _this.handleActiveSave,
          className: form_default.a.checkboxListItem,
          theme: checkbox_default.a
        });
        return react_default.a.createElement(
          editableTableCell,
          { label: 'Active', value: value, onChange: _this.handleActiveChange },
          value
        );
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var lineItem = _this.state;
        var rowProps = { isNew: lineItem.id < 0, onSave: _this.handleSave };
        var vendorTypes = _this.props.vendorTypes;

        var VENDOR_TYPE_OPTIONS = lineItemRow_formatOptions(vendorTypes);
        return react_default.a.createElement(
          editableTableRow,
          lineItemRow__extends({ key: lineItem.id, id: lineItem.id }, rowProps),
          react_default.a.createElement(inputCell, { attr: 'item_number', label: 'Item Number', lineItem: lineItem, onChange: _this.handleItemNumberChange }),
          react_default.a.createElement(inputCell, { attr: 'description', label: 'Description', lineItem: lineItem, onChange: _this.handleDescriptionChange }),
          react_default.a.createElement(dropDownCell, {
            attr: 'kind',
            label: 'Type',
            lineItem: lineItem,
            options: KIND_OPTIONS,
            onChange: _this.handleKindChange
          }),
          react_default.a.createElement(dropDownCell, {
            attr: 'category',
            label: 'Category',
            lineItem: lineItem,
            options: lineItemRow_CATEGORY_OPTIONS,
            onChange: _this.handleCategoryChange
          }),
          react_default.a.createElement(dropDownCell, {
            attr: 'vendor',
            label: 'Vendor',
            lineItem: lineItem,
            options: VENDOR_TYPE_OPTIONS,
            onChange: _this.handleVendorTypeChange
          }),
          react_default.a.createElement(dropDownCell, {
            attr: 'surface_type',
            label: 'Surface Type',
            lineItem: lineItem,
            options: SURFACE_TYPE_OPTIONS,
            onChange: _this.handleSurfaceTypeChange
          }),
          react_default.a.createElement(inputCell, { attr: 'accounting_id', label: 'Accounting Id', lineItem: lineItem, onChange: _this.handleAccountingIdChange }),
          react_default.a.createElement(inputCell, { attr: 'net_payable', cellValue: _this.formatPercent(lineItem.net_payable), label: 'Net Payable %', lineItem: lineItem, onChange: _this.handleNetPayableChange }),
          _this.renderPayable(),
          _this.renderActive()
        );
      }
    }), _temp), lineItemRow__possibleConstructorReturn(_this, _ret);
  }

  return LineItemRow;
}(mixins_editable(react_default.a.Component));

lineItemRow_LineItemRow.propTypes = {
  lineItem: prop_types_default.a.shape(lineItemPropType),
  vendorTypes: prop_types_default.a.arrayOf(prop_types_default.a.string).isRequired,
  onSave: prop_types_default.a.func.isRequired
};

lineItemRow_LineItemRow.defaultProps = { lineItem: {} };

/* harmony default export */ var lineItemRow = (lineItemRow_LineItemRow);
// CONCATENATED MODULE: ./client/app/screens/main/screens/lineItems/index.jsx
var lineItems__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var lineItems__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function lineItems__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function lineItems__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function lineItems__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var lineItems_LineItems = function (_Component) {
  lineItems__inherits(LineItems, _Component);

  function LineItems(props) {
    lineItems__classCallCheck(this, LineItems);

    var _this = lineItems__possibleConstructorReturn(this, (LineItems.__proto__ || Object.getPrototypeOf(LineItems)).call(this, props));

    Object.defineProperty(_this, 'componentWillMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.refreshLineItemList();
      }
    });
    Object.defineProperty(_this, 'onSearch', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        e.preventDefault();
        var value = e.target.value || e.target.searchText || e.target.querySelector('input').value;
        var filters = lineItems__extends({}, _this.props.filters, { query: value, vendor: _this.state.selectedVendor });
        _this.props.setLineItemFilters(filters);
      }
    });
    Object.defineProperty(_this, 'refreshLineItemList', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.props.fetchVendorTypes();
        _this.props.requestLineItems();
      }
    });
    Object.defineProperty(_this, 'handleVendorChange', {
      enumerable: true,
      writable: true,
      value: function value(selectedOption) {
        var vendor = selectedOption ? selectedOption.value : '';
        var filters = lineItems__extends({}, _this.props.filters, { vendor: vendor, query: _this.props.filters.query });
        _this.setState({ selectedVendor: vendor });
        _this.props.setLineItemFilters(filters);
      }
    });
    Object.defineProperty(_this, 'handleSave', {
      enumerable: true,
      writable: true,
      value: function value(lineItem) {
        return lineItem.id < 0 ? _this.props.createLineItem(lineItem) : _this.props.updateLineItem(lineItem);
      }
    });
    Object.defineProperty(_this, 'toggleFiltersDrawer', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState(function (prevState) {
          return {
            filtersDrawerActive: !prevState.filtersDrawerActive
          };
        });
      }
    });
    Object.defineProperty(_this, 'resetFilters', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.setState({ selectedVendor: '' });
        _this.props.setLineItemFilters({ vendor: '', query: '' });
      }
    });
    Object.defineProperty(_this, 'itemsByVendor', {
      enumerable: true,
      writable: true,
      value: function value(items, mvw) {
        return items.filter(function (item) {
          var vendor = (typeof item === 'undefined' ? 'undefined' : lineItems__typeof(item)) === 'object' ? item.vendor || null : item || null;
          if (!vendor) return true;
          if (constants["_8" /* NON_LHI_SOURCES */].includes(vendor)) return mvw[vendor.toLowerCase()] === true;
          return (mvw.lhi || false) === true;
        });
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            lineItems = _this$props.lineItems,
            vendorTypes = _this$props.vendorTypes,
            filters = _this$props.filters,
            mvw = _this$props.user.manage_vendor_workrooms;
        var _this$state = _this.state,
            selectedVendor = _this$state.selectedVendor,
            filtersDrawerActive = _this$state.filtersDrawerActive;

        var filteredVendorTypes = _this.itemsByVendor(vendorTypes, mvw);
        var filteredLineItems = _this.itemsByVendor(lineItems.filter(function (item) {
          var matchesVendor = !filters.vendor || item.vendor === filters.vendor;
          var matchesSearch = !filters.query || item.item_number && item.item_number.includes(filters.query);
          return matchesVendor && matchesSearch;
        }), mvw);
        return react_default.a.createElement(
          'div',
          null,
          react_default.a.createElement(components_PageActionBar, {
            showFiltersBtn: true,
            showAdd: false,
            title: 'Line Items',
            searchText: 'Search for a Line Item number...',
            onSearch: _this.onSearch,
            toggleFilters: _this.toggleFiltersDrawer
          }),
          react_default.a.createElement(
            components_FiltersDrawer,
            {
              title: 'Line Items',
              active: filtersDrawerActive,
              toggle: _this.toggleFiltersDrawer,
              reset: _this.resetFilters
            },
            react_default.a.createElement(react_select, {
              key: 'vendors',
              className: contentArea_default.a.dropdown,
              label: 'Vendors',
              name: 'vendors',
              placeholder: 'All Vendors',
              options: filteredVendorTypes.map(function (vendor) {
                return { value: vendor, label: vendor };
              }),
              value: selectedVendor ? { value: selectedVendor, label: selectedVendor } : null,
              onChange: _this.handleVendorChange
            })
          ),
          react_default.a.createElement(
            'div',
            { className: contentArea_default.a.contentAreaContainer },
            react_default.a.createElement(
              components_LineItemTable,
              {
                adminTable: true,
                editableOnly: true,
                title: '',
                refreshList: _this.refreshLineItemList
              },
              filteredLineItems.map(function (item) {
                return react_default.a.createElement(lineItemRow, {
                  key: item.id,
                  onSave: _this.handleSave,
                  lineItem: item,
                  vendorTypes: filteredVendorTypes
                });
              })
            )
          )
        );
      }
    });

    _this.state = {
      filtersDrawerActive: false,
      selectedVendor: ''
    };
    _this.onSearch = _this.onSearch.bind(_this);
    _this.toggleFiltersDrawer = _this.toggleFiltersDrawer.bind(_this);
    _this.handleVendorChange = _this.handleVendorChange.bind(_this);
    _this.resetFilters = _this.resetFilters.bind(_this);
    return _this;
  }

  return LineItems;
}(react["Component"]);

lineItems_LineItems.defaultProps = { lineItems: [], vendorTypes: [] };

lineItems_LineItems.propTypes = {
  phaseId: prop_types_default.a.string,
  lineItems: prop_types_default.a.arrayOf(prop_types_default.a.shape(phaseMerchandiseItem)),
  requestLineItems: prop_types_default.a.func,
  updateLineItem: prop_types_default.a.func,
  createLineItem: prop_types_default.a.func,
  setLineItemFilters: prop_types_default.a.func,
  filters: prop_types_default.a.shape({
    vendor: prop_types_default.a.string,
    query: prop_types_default.a.string
  }),
  vendorTypes: prop_types_default.a.arrayOf(prop_types_default.a.string),
  fetchVendorTypes: prop_types_default.a.func.isRequired,
  user: prop_types_default.a.object
};

var lineItems_mapStateToProps = function mapStateToProps(state) {
  return {
    lineItems: state.lineItems.items,
    vendorTypes: state.lineItems.vendorTypes,
    filters: state.lineItems.filters || { vendor: '', query: '' },
    user: state.user
  };
};

var lineItems_mapDispatchToProps = {
  requestLineItems: line_items["c" /* requestLineItems */],
  updateLineItem: line_items["e" /* updateLineItem */],
  createLineItem: line_items["a" /* createLineItem */],
  setLineItemFilters: line_items["d" /* setLineItemFilters */],
  fetchVendorTypes: line_items["b" /* fetchVendorTypes */]
};

/* harmony default export */ var screens_lineItems = (Object(react_redux_es["connect"])(lineItems_mapStateToProps, lineItems_mapDispatchToProps)(lineItems_LineItems));
// CONCATENATED MODULE: ./client/app/screens/main/screens/bulkUpdateUploads/index.jsx



var bulkUpdateUploads_BulkUpdateUploads = function BulkUpdateUploads() {
  return react_default.a.createElement(UploadManager, {
    uploadType: 'bulk_update_uploads',
    title: 'Bulk Update'
  });
};

/* harmony default export */ var bulkUpdateUploads = (bulkUpdateUploads_BulkUpdateUploads);
// CONCATENATED MODULE: ./client/app/screens/main/screens/marginUploads/index.jsx



var marginUploads_MarginUploads = function MarginUploads() {
  return react_default.a.createElement(UploadManager, {
    uploadType: 'margin_uploads',
    title: 'Margin Update'
  });
};

/* harmony default export */ var marginUploads = (marginUploads_MarginUploads);
// CONCATENATED MODULE: ./client/app/screens/main/screens/activityUploads/index.jsx



var activityUploads_ActivityUploads = function ActivityUploads() {
  return react_default.a.createElement(UploadManager, {
    uploadType: 'activity_uploads',
    title: 'Activity'
  });
};

/* harmony default export */ var activityUploads = (activityUploads_ActivityUploads);
// EXTERNAL MODULE: ./client/app/screens/main/screens/bulkProjectsLoad/styles.scss
var bulkProjectsLoad_styles = __webpack_require__("pe20");
var bulkProjectsLoad_styles_default = /*#__PURE__*/__webpack_require__.n(bulkProjectsLoad_styles);

// CONCATENATED MODULE: ./client/app/screens/main/screens/bulkProjectsLoad/index.jsx
var bulkProjectsLoad__slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function bulkProjectsLoad__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }















var bulkProjectsLoad_BulkProjectsLoad = function BulkProjectsLoad(props) {
  var _cx;

  var _React$useState = react_default.a.useState(''),
      _React$useState2 = bulkProjectsLoad__slicedToArray(_React$useState, 2),
      jobs = _React$useState2[0],
      setJobs = _React$useState2[1];

  var _React$useState3 = react_default.a.useState(''),
      _React$useState4 = bulkProjectsLoad__slicedToArray(_React$useState3, 2),
      details = _React$useState4[0],
      setDetails = _React$useState4[1];

  var _React$useState5 = react_default.a.useState(''),
      _React$useState6 = bulkProjectsLoad__slicedToArray(_React$useState5, 2),
      workorders = _React$useState6[0],
      setWorkorders = _React$useState6[1];

  var _React$useState7 = react_default.a.useState(''),
      _React$useState8 = bulkProjectsLoad__slicedToArray(_React$useState7, 2),
      error = _React$useState8[0],
      setError = _React$useState8[1];

  var _React$useState9 = react_default.a.useState(''),
      _React$useState10 = bulkProjectsLoad__slicedToArray(_React$useState9, 2),
      success = _React$useState10[0],
      setSuccess = _React$useState10[1];

  var loadProjects = function loadProjects() {
    var jobsArray = jobs.split(/[\n|\n\r|,|\s]/).filter(function (j) {
      return j !== '';
    });
    var detailsArray = details.split(/[\n|\n\r|,|\s]/).filter(function (j) {
      return j !== '';
    });
    var workordersArray = workorders.split(/[\n|\n\r|,|\s]/).filter(function (j) {
      return j !== '';
    });
    props.requestbulkProjectLoad({
      jobs: jobsArray,
      details: detailsArray,
      workorders: workordersArray
    }).then(function () {
      setError('');setSuccess('Projects scheduled for loading.');
    }).catch(function (e) {
      return setError(e.payload.errors);
    });
  };

  return react_default.a.createElement(
    'div',
    null,
    react_default.a.createElement(components_PageActionBar, {
      role: props.role,
      title: 'Bulk Project Load',
      showAdd: false,
      showFiltersBtn: false
    }),
    react_default.a.createElement(
      'div',
      { className: contentArea_default.a.contentAreaContainer },
      react_default.a.createElement(
        components_Card,
        null,
        react_default.a.createElement(
          'div',
          { className: bulkProjectsLoad_styles_default.a.content_area },
          react_default.a.createElement(
            'p',
            { className: bulkProjectsLoad_styles_default.a.explanation },
            'Input project numbers separated by a comma or a new line'
          ),
          react_default.a.createElement(components_TextArea, {
            className: bulkProjectsLoad_styles_default.a.text_area,
            label: 'Jobs',
            value: jobs,
            onChange: function onChange(e) {
              return setJobs(e.target.value);
            },
            autoFocus: true
          }),
          react_default.a.createElement(components_TextArea, {
            label: 'Details',
            value: details,
            onChange: function onChange(e) {
              return setDetails(e.target.value);
            }, className: bulkProjectsLoad_styles_default.a.text_area
          }),
          react_default.a.createElement(components_TextArea, {
            label: 'Workorders',
            value: workorders,
            onChange: function onChange(e) {
              return setWorkorders(e.target.value);
            }, className: bulkProjectsLoad_styles_default.a.text_area
          }),
          react_default.a.createElement(ColoredButton["a" /* default */], { disabled: !jobs && !details && !workorders, onClick: loadProjects, color: 'green', label: 'Load Projects', responsive: true, className: bulkProjectsLoad_styles_default.a.button }),
          react_default.a.createElement(MessageBox["a" /* default */], {
            className: classnames_default()((_cx = {}, bulkProjectsLoad__defineProperty(_cx, bulkProjectsLoad_styles_default.a.messageBox, true), bulkProjectsLoad__defineProperty(_cx, bulkProjectsLoad_styles_default.a.visible, error || success), _cx)), message: error || success, error: error
          })
        )
      )
    )
  );
};

bulkProjectsLoad_BulkProjectsLoad.propTypes = {
  role: prop_types_default.a.string,
  requestbulkProjectLoad: prop_types_default.a.func
};

var bulkProjectsLoad_mapStateToProps = function mapStateToProps(state) {
  return {
    role: Object(reducers["_12" /* getRole */])(state)
  };
};

/* harmony default export */ var bulkProjectsLoad = (Object(react_redux_es["connect"])(bulkProjectsLoad_mapStateToProps, {
  requestbulkProjectLoad: actionCreators["_32" /* requestbulkProjectLoad */]
})(bulkProjectsLoad_BulkProjectsLoad));
// CONCATENATED MODULE: ./client/app/screens/main/screens/lowesSurveyUploads/index.jsx



var lowesSurveyUploads_LowesSurveyUploads = function LowesSurveyUploads() {
  return react_default.a.createElement(UploadManager, {
    uploadType: 'lowes_survey_uploads',
    title: 'Lowe\'s C&P'
  });
};

/* harmony default export */ var lowesSurveyUploads = (lowesSurveyUploads_LowesSurveyUploads);
// EXTERNAL MODULE: ./client/app/shared/actionCreators/default_installer_pay.js
var default_installer_pay = __webpack_require__("xXcJ");

// CONCATENATED MODULE: ./client/app/screens/main/screens/defaultInstallerPay/DefaultInstallerPayRow.jsx
var DefaultInstallerPayRow__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function DefaultInstallerPayRow__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function DefaultInstallerPayRow__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function DefaultInstallerPayRow__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var DefaultInstallerPayRow_DefaultInstallerPayRow = function (_Component) {
  DefaultInstallerPayRow__inherits(DefaultInstallerPayRow, _Component);

  function DefaultInstallerPayRow(props) {
    DefaultInstallerPayRow__classCallCheck(this, DefaultInstallerPayRow);

    var _this = DefaultInstallerPayRow__possibleConstructorReturn(this, (DefaultInstallerPayRow.__proto__ || Object.getPrototypeOf(DefaultInstallerPayRow)).call(this, props));

    Object.defineProperty(_this, 'handleChange', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        var value = e.target.value;

        var cents = Math.round(parseFloat(value || 0) * 100);
        _this.setState({ value: value, dirty: true });
        _this.props.onDirtyChange(_this.props.patchItem.id, cents);
      }
    });
    Object.defineProperty(_this, 'handleSave', {
      enumerable: true,
      writable: true,
      value: function value() {
        var cents = Math.round(parseFloat(_this.state.value || 0) * 100);
        _this.props.onSave(_this.props.patchItem.id, cents);
        _this.setState({ dirty: false });
        _this.props.onDirtyChange(_this.props.patchItem.id, null);
      }
    });

    _this.state = {
      value: (props.patchItem.default_installer_pay / 100).toFixed(2),
      dirty: false
    };
    return _this;
  }

  DefaultInstallerPayRow__createClass(DefaultInstallerPayRow, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.patchItem.default_installer_pay !== this.props.patchItem.default_installer_pay) {
        this.setState({
          value: (nextProps.patchItem.default_installer_pay / 100).toFixed(2),
          dirty: false
        });
        this.props.onDirtyChange(nextProps.patchItem.id, null);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var patchItem = this.props.patchItem;

      return react_default.a.createElement(
        'tr',
        null,
        react_default.a.createElement(
          'td',
          { style: { textAlign: 'center', padding: '8px' } },
          patchItem.item_number
        ),
        react_default.a.createElement(
          'td',
          { style: { textAlign: 'center', padding: '8px' } },
          patchItem.price_patch_name
        ),
        react_default.a.createElement(
          'td',
          { style: { textAlign: 'center', padding: '8px' } },
          patchItem.description
        ),
        react_default.a.createElement(
          'td',
          { style: { textAlign: 'center', padding: '8px' } },
          react_default.a.createElement('input', {
            type: 'number',
            step: '0.01',
            min: '0',
            value: this.state.value,
            onChange: this.handleChange,
            style: { width: '100px' }
          }),
          react_default.a.createElement(
            'button',
            {
              type: 'button',
              disabled: !this.state.dirty,
              onClick: this.handleSave,
              style: { marginLeft: '8px' }
            },
            'Save'
          )
        )
      );
    }
  }]);

  return DefaultInstallerPayRow;
}(react["Component"]);

DefaultInstallerPayRow_DefaultInstallerPayRow.propTypes = {
  patchItem: prop_types_default.a.shape({
    id: prop_types_default.a.number,
    item_number: prop_types_default.a.string,
    description: prop_types_default.a.string,
    default_installer_pay: prop_types_default.a.number,
    price_patch_name: prop_types_default.a.string
  }).isRequired,
  onSave: prop_types_default.a.func.isRequired,
  onDirtyChange: prop_types_default.a.func.isRequired
};

/* harmony default export */ var defaultInstallerPay_DefaultInstallerPayRow = (DefaultInstallerPayRow_DefaultInstallerPayRow);
// CONCATENATED MODULE: ./client/app/screens/main/screens/defaultInstallerPay/index.jsx
var defaultInstallerPay__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var defaultInstallerPay__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function defaultInstallerPay__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function defaultInstallerPay__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function defaultInstallerPay__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var floatingBarStyle = {
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
  background: '#fff',
  borderTop: '2px solid #ddd',
  padding: '12px 24px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  boxShadow: '0 -2px 8px rgba(0,0,0,0.12)',
  zIndex: 1000
};

var defaultInstallerPay_DefaultInstallerPay = function (_Component) {
  defaultInstallerPay__inherits(DefaultInstallerPay, _Component);

  function DefaultInstallerPay(props) {
    defaultInstallerPay__classCallCheck(this, DefaultInstallerPay);

    var _this = defaultInstallerPay__possibleConstructorReturn(this, (DefaultInstallerPay.__proto__ || Object.getPrototypeOf(DefaultInstallerPay)).call(this, props));

    Object.defineProperty(_this, 'handlePricePatchChange', {
      enumerable: true,
      writable: true,
      value: function value(option) {
        var id = option ? option.value : null;
        _this.setState({ selectedPricePatch: option, dirtyItems: {} });
        _this.props.fetchDefaultInstallerPay(id);
      }
    });
    Object.defineProperty(_this, 'handleSave', {
      enumerable: true,
      writable: true,
      value: function value(id, cents) {
        _this.props.updateDefaultInstallerPay(id, cents);
      }
    });
    Object.defineProperty(_this, 'handleDirtyChange', {
      enumerable: true,
      writable: true,
      value: function value(id, cents) {
        _this.setState(function (prevState) {
          var dirtyItems = defaultInstallerPay__extends({}, prevState.dirtyItems);
          if (cents === null) {
            delete dirtyItems[id];
          } else {
            dirtyItems[id] = cents;
          }
          return { dirtyItems: dirtyItems };
        });
      }
    });
    Object.defineProperty(_this, 'handleSaveAll', {
      enumerable: true,
      writable: true,
      value: function value() {
        var dirtyItems = _this.state.dirtyItems;

        var items = Object.keys(dirtyItems).map(function (id) {
          return {
            id: Number(id),
            default_installer_pay: dirtyItems[id]
          };
        });
        _this.props.bulkUpdateDefaultInstallerPay(items);
      }
    });

    _this.state = { selectedPricePatch: null, dirtyItems: {} };
    return _this;
  }

  defaultInstallerPay__createClass(DefaultInstallerPay, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.requestPricePatchesList();
      this.props.fetchDefaultInstallerPay(null);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          patchItems = _props.patchItems,
          pricePatches = _props.pricePatches,
          loading = _props.loading;
      var _state = this.state,
          selectedPricePatch = _state.selectedPricePatch,
          dirtyItems = _state.dirtyItems;

      var pricePatchOptions = pricePatches.map(function (pp) {
        return { value: pp.id, label: pp.name };
      });
      var dirtyCount = Object.keys(dirtyItems).length;

      return react_default.a.createElement(
        'div',
        null,
        react_default.a.createElement(components_PageActionBar, {
          showAdd: false,
          showFiltersBtn: false,
          title: 'Default Installer Pay'
        }),
        react_default.a.createElement(
          'div',
          { className: contentArea_default.a.contentAreaContainer, style: { paddingBottom: '64px' } },
          react_default.a.createElement(
            'div',
            { style: { maxWidth: '300px', marginBottom: '16px' } },
            react_default.a.createElement(react_select, {
              label: 'Price Patch (LCZ)',
              name: 'price_patch',
              placeholder: 'All LCZs',
              options: pricePatchOptions,
              value: selectedPricePatch,
              onChange: this.handlePricePatchChange,
              clearable: true
            })
          ),
          loading && react_default.a.createElement(components_Loading, null),
          !loading && react_default.a.createElement(
            'table',
            { style: { width: '100%', borderCollapse: 'collapse' } },
            react_default.a.createElement(
              'thead',
              null,
              react_default.a.createElement(
                'tr',
                null,
                react_default.a.createElement(
                  'th',
                  { style: { textAlign: 'center', padding: '8px', borderBottom: '1px solid #ddd' } },
                  'Item Number'
                ),
                react_default.a.createElement(
                  'th',
                  { style: { textAlign: 'center', padding: '8px', borderBottom: '1px solid #ddd' } },
                  'LCZ'
                ),
                react_default.a.createElement(
                  'th',
                  { style: { textAlign: 'center', padding: '8px', borderBottom: '1px solid #ddd' } },
                  'Description'
                ),
                react_default.a.createElement(
                  'th',
                  { style: { textAlign: 'center', padding: '8px', borderBottom: '1px solid #ddd' } },
                  'Default Pay ($)'
                )
              )
            ),
            react_default.a.createElement(
              'tbody',
              null,
              patchItems.map(function (item) {
                return react_default.a.createElement(defaultInstallerPay_DefaultInstallerPayRow, {
                  key: item.id,
                  patchItem: item,
                  onSave: _this2.handleSave,
                  onDirtyChange: _this2.handleDirtyChange
                });
              })
            )
          )
        ),
        react_default.a.createElement(
          'div',
          { style: floatingBarStyle },
          react_default.a.createElement(
            'span',
            { style: { marginRight: '16px', color: dirtyCount > 1 ? '#333' : '#999' } },
            dirtyCount === 1 ? 'Bulk Save - only 1 unsaved change' : 'Bulk Save - ' + (dirtyCount > 0 ? dirtyCount + ' unsaved changes' : 'No unsaved changes')
          ),
          react_default.a.createElement(ColoredButton["a" /* default */], {
            label: 'Save All',
            color: 'green',
            disabled: dirtyCount <= 1,
            onClick: this.handleSaveAll
          })
        )
      );
    }
  }]);

  return DefaultInstallerPay;
}(react["Component"]);

defaultInstallerPay_DefaultInstallerPay.defaultProps = {
  patchItems: [],
  pricePatches: [],
  loading: false
};

defaultInstallerPay_DefaultInstallerPay.propTypes = {
  patchItems: prop_types_default.a.arrayOf(prop_types_default.a.shape({
    id: prop_types_default.a.number,
    item_number: prop_types_default.a.string,
    description: prop_types_default.a.string,
    default_installer_pay: prop_types_default.a.number,
    price_patch_name: prop_types_default.a.string
  })),
  pricePatches: prop_types_default.a.arrayOf(prop_types_default.a.shape({
    id: prop_types_default.a.number,
    name: prop_types_default.a.string
  })),
  loading: prop_types_default.a.bool,
  fetchDefaultInstallerPay: prop_types_default.a.func.isRequired,
  updateDefaultInstallerPay: prop_types_default.a.func.isRequired,
  bulkUpdateDefaultInstallerPay: prop_types_default.a.func.isRequired,
  requestPricePatchesList: prop_types_default.a.func.isRequired
};

var defaultInstallerPay_mapStateToProps = function mapStateToProps(state) {
  return {
    patchItems: state.defaultInstallerPay.patchItems,
    pricePatches: Object(reducers["_10" /* getPricePatchesList */])(state),
    loading: state.defaultInstallerPay.loading
  };
};

var defaultInstallerPay_mapDispatchToProps = {
  fetchDefaultInstallerPay: default_installer_pay["b" /* fetchDefaultInstallerPay */],
  updateDefaultInstallerPay: default_installer_pay["c" /* updateDefaultInstallerPay */],
  bulkUpdateDefaultInstallerPay: default_installer_pay["a" /* bulkUpdateDefaultInstallerPay */],
  requestPricePatchesList: dropdown_lists["e" /* requestPricePatchesList */]
};

/* harmony default export */ var defaultInstallerPay = (Object(react_redux_es["connect"])(defaultInstallerPay_mapStateToProps, defaultInstallerPay_mapDispatchToProps)(defaultInstallerPay_DefaultInstallerPay));
// CONCATENATED MODULE: ./client/app/shared/actionCreators/holiday_promo_settings.js



var holiday_promo_settings__createActions = Object(redux_actions_lib["createActions"])('HOLIDAY_PROMO_SETTINGS_REQUEST', 'HOLIDAY_PROMO_SETTINGS_SUCCESS', 'HOLIDAY_PROMO_SETTINGS_FAILURE'),
    holidayPromoSettingsRequest = holiday_promo_settings__createActions.holidayPromoSettingsRequest,
    holidayPromoSettingsSuccess = holiday_promo_settings__createActions.holidayPromoSettingsSuccess,
    holidayPromoSettingsFailure = holiday_promo_settings__createActions.holidayPromoSettingsFailure;

function fetchHolidayPromoSetting() {
  var vendor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'LHI';

  return function (dispatch) {
    dispatch(holidayPromoSettingsRequest());
    return Object(services["h" /* request */])('holiday_promo_settings?vendor=' + vendor).then(function (_ref) {
      var json = _ref.json;
      return dispatch(holidayPromoSettingsSuccess(json));
    }).catch(function (error) {
      return dispatch(holidayPromoSettingsFailure(error));
    });
  };
}

var holiday_promo_settings__createActions2 = Object(redux_actions_lib["createActions"])('UPDATE_HOLIDAY_PROMO_SETTINGS_REQUEST', 'UPDATE_HOLIDAY_PROMO_SETTINGS_SUCCESS', 'UPDATE_HOLIDAY_PROMO_SETTINGS_FAILURE'),
    updateHolidayPromoSettingsRequest = holiday_promo_settings__createActions2.updateHolidayPromoSettingsRequest,
    updateHolidayPromoSettingsSuccess = holiday_promo_settings__createActions2.updateHolidayPromoSettingsSuccess,
    updateHolidayPromoSettingsFailure = holiday_promo_settings__createActions2.updateHolidayPromoSettingsFailure;

function updateHolidayPromoSetting(attrs) {
  var vendor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'LHI';

  return function (dispatch) {
    dispatch(updateHolidayPromoSettingsRequest());
    return Object(services["h" /* request */])('holiday_promo_settings?vendor=' + vendor, {
      method: 'PUT',
      body: { holiday_promo_setting: attrs }
    }).then(function (_ref2) {
      var json = _ref2.json;
      return dispatch(updateHolidayPromoSettingsSuccess(json));
    }).catch(function (error) {
      dispatch(updateHolidayPromoSettingsFailure(error));
      throw error;
    });
  };
}
// EXTERNAL MODULE: ./client/app/screens/main/screens/holidayPromoSettings/styles.scss
var holidayPromoSettings_styles = __webpack_require__("fQMP");
var holidayPromoSettings_styles_default = /*#__PURE__*/__webpack_require__.n(holidayPromoSettings_styles);

// CONCATENATED MODULE: ./client/app/screens/main/screens/holidayPromoSettings/index.jsx
var holidayPromoSettings__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var holidayPromoSettings__slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var holidayPromoSettings__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var holidayPromoSettings__cx;

function holidayPromoSettings__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function holidayPromoSettings__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function holidayPromoSettings__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function holidayPromoSettings__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function holidayPromoSettings__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

























var holidayPromoSettings_theme = { RTInput: input_default.a };
var fieldWidth = classnames_default()((holidayPromoSettings__cx = {}, holidayPromoSettings__defineProperty(holidayPromoSettings__cx, form_default.a.inputs, true), holidayPromoSettings__defineProperty(holidayPromoSettings__cx, form_default.a.largeInput, true), holidayPromoSettings__cx));
var holidayPromoSettings_cancelClass = classnames_default()([form_default.a.cancelButton, form_default.a.actionButton]);

var HOLIDAY_PROMO_VENDORS = ['LHI', 'IFI'];

var availableVendorsFor = function availableVendorsFor(user) {
  var mvw = user && user.manage_vendor_workrooms || {};
  return HOLIDAY_PROMO_VENDORS.filter(function (vendor) {
    return mvw[vendor.toLowerCase()] === true;
  });
};

var YEAR_FIELD = {
  key: 'promo_year',
  label: 'Promo Year',
  tooltip: "Which year's Thanksgiving & Christmas the promo targets; holiday dates are derived from this year."
};

var DATE_FIELDS = [{
  key: 'promo_start_date',
  label: 'Holiday Promo Start',
  tooltip: 'Earliest sold date that qualifies, and the date the promo goes live.'
}, {
  key: 'thanksgiving_sold_end_date',
  label: 'Thanksgiving Sales Cutoff Date',
  tooltip: 'Latest sold date eligible for the Thanksgiving promo.'
}, {
  key: 'thanksgiving_cutoff_date',
  label: 'Thanksgiving Scheduling Cutoff Date',
  tooltip: 'After this date, a phase can no longer be flagged for Thanksgiving; it rolls over to Christmas.'
}, {
  key: 'christmas_sold_end_date',
  label: 'Christmas Sales Cutoff Date',
  tooltip: 'Latest sold date eligible for the Christmas promo.'
}, {
  key: 'promo_end_date',
  label: 'Holiday Promo End Date',
  tooltip: 'The entire promo ends on this date.'
}];

var FIELD_KEYS = [YEAR_FIELD.key].concat(holidayPromoSettings__toConsumableArray(DATE_FIELDS.map(function (f) {
  return f.key;
})));

var formFromSetting = function formFromSetting(setting) {
  if (!setting) return {};
  return FIELD_KEYS.reduce(function (acc, key) {
    acc[key] = setting[key] == null ? '' : String(setting[key]);
    return acc;
  }, {});
};

var holidayPromoSettings_HolidayPromoSettings = function (_Component) {
  holidayPromoSettings__inherits(HolidayPromoSettings, _Component);

  function HolidayPromoSettings(props) {
    holidayPromoSettings__classCallCheck(this, HolidayPromoSettings);

    var _this = holidayPromoSettings__possibleConstructorReturn(this, (HolidayPromoSettings.__proto__ || Object.getPrototypeOf(HolidayPromoSettings)).call(this, props));

    holidayPromoSettings__initialiseProps.call(_this);

    var _availableVendorsFor = availableVendorsFor(props.user),
        _availableVendorsFor2 = holidayPromoSettings__slicedToArray(_availableVendorsFor, 1),
        vendor = _availableVendorsFor2[0];

    _this.state = { form: formFromSetting(props.setting), vendor: vendor };
    return _this;
  }

  holidayPromoSettings__createClass(HolidayPromoSettings, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (this.state.vendor) this.props.fetchHolidayPromoSetting(this.state.vendor);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.setting && nextProps.setting !== this.props.setting) {
        this.setState({ form: formFromSetting(nextProps.setting) });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          loading = _props.loading,
          errors = _props.errors,
          user = _props.user;
      var vendor = this.state.vendor;

      var availableVendors = availableVendorsFor(user);

      if (!vendor) {
        return react_default.a.createElement(
          'div',
          null,
          react_default.a.createElement(components_PageActionBar, { showAdd: false, showFiltersBtn: false, title: 'Holiday Promo Settings' }),
          react_default.a.createElement(
            'div',
            { className: contentArea_default.a.contentAreaContainer },
            react_default.a.createElement(
              'p',
              null,
              'You don\'t have access to any vendor\'s Holiday Promo Settings.'
            )
          )
        );
      }

      var title = availableVendors.length > 1 ? 'Holiday Promo Settings' : 'Holiday Promo Settings - ' + vendor;

      return react_default.a.createElement(
        'div',
        null,
        react_default.a.createElement(components_PageActionBar, {
          showAdd: false,
          showFiltersBtn: false,
          title: title
        }),
        react_default.a.createElement(
          'div',
          { className: contentArea_default.a.contentAreaContainer },
          loading && react_default.a.createElement(components_Loading, null),
          !loading && react_default.a.createElement(
            react_css_themr_lib["ThemeProvider"],
            { theme: holidayPromoSettings_theme },
            react_default.a.createElement(
              components_Card,
              null,
              react_default.a.createElement(
                'div',
                { className: form_default.a.divider },
                react_default.a.createElement(
                  'h5',
                  { className: form_default.a.cardTitle },
                  'Promo Window'
                ),
                react_default.a.createElement(
                  'p',
                  { className: form_default.a.cardSubtitle },
                  'Configure when the "Install by the Holidays" promo is active and which sold dates and appointments qualify.'
                )
              ),
              availableVendors.length > 1 && react_default.a.createElement(
                flexbox_react_dist_default.a,
                { flexWrap: 'wrap', className: form_default.a.divider },
                react_default.a.createElement(react_select, {
                  key: 'vendor',
                  className: fieldWidth,
                  label: 'Vendor',
                  clearable: false,
                  options: availableVendors.map(function (v) {
                    return { value: v, label: v };
                  }),
                  value: { value: vendor, label: vendor },
                  onChange: this.handleVendorChange
                })
              ),
              react_default.a.createElement(
                flexbox_react_dist_default.a,
                { flexWrap: 'wrap', className: form_default.a.divider },
                react_default.a.createElement(react_toolbox_lib["Input"], {
                  type: 'number',
                  min: '0',
                  step: '1',
                  label: this.renderFieldLabel(YEAR_FIELD),
                  className: fieldWidth,
                  value: this.state.form[YEAR_FIELD.key] || '',
                  onChange: this.handleYearChange,
                  error: Object(utils["c" /* error */])(YEAR_FIELD.key, errors)
                }),
                DATE_FIELDS.map(this.renderDateField)
              ),
              react_default.a.createElement(
                flexbox_react_dist_default.a,
                { justifyContent: 'flex-end', flexWrap: 'wrap' },
                react_default.a.createElement(
                  react_toolbox_lib["CardActions"],
                  { className: form_default.a.actionsWrapper },
                  react_default.a.createElement(ColoredButton["a" /* default */], {
                    className: holidayPromoSettings_cancelClass,
                    responsive: true,
                    color: 'gray',
                    label: 'Cancel',
                    onClick: this.handleCancel
                  }),
                  react_default.a.createElement(ColoredButton["a" /* default */], {
                    className: form_default.a.actionButton,
                    responsive: true,
                    color: 'green',
                    label: 'Save Changes',
                    onClick: this.handleSave
                  })
                )
              )
            )
          )
        )
      );
    }
  }]);

  return HolidayPromoSettings;
}(react["Component"]);

var holidayPromoSettings__initialiseProps = function _initialiseProps() {
  var _this2 = this;

  Object.defineProperty(this, 'handleYearChange', {
    enumerable: true,
    writable: true,
    value: function value(_value) {
      return _this2.setState({ form: holidayPromoSettings__extends({}, _this2.state.form, holidayPromoSettings__defineProperty({}, YEAR_FIELD.key, _value)) });
    }
  });
  Object.defineProperty(this, 'handleDateChange', {
    enumerable: true,
    writable: true,
    value: function value(key) {
      return function (value) {
        return _this2.setState({ form: holidayPromoSettings__extends({}, _this2.state.form, holidayPromoSettings__defineProperty({}, key, value)) });
      };
    }
  });
  Object.defineProperty(this, 'handleVendorChange', {
    enumerable: true,
    writable: true,
    value: function value(selectedOption) {
      var vendor = selectedOption && selectedOption.value;
      if (!vendor || vendor === _this2.state.vendor) return;
      _this2.setState({ vendor: vendor, form: {} });
      _this2.props.fetchHolidayPromoSetting(vendor);
    }
  });
  Object.defineProperty(this, 'handleCancel', {
    enumerable: true,
    writable: true,
    value: function value() {
      return _this2.setState({ form: formFromSetting(_this2.props.setting) });
    }
  });
  Object.defineProperty(this, 'handleSave', {
    enumerable: true,
    writable: true,
    value: function value() {
      var _state = _this2.state,
          form = _state.form,
          vendor = _state.vendor;

      var attrs = holidayPromoSettings__extends({}, form);
      DATE_FIELDS.forEach(function (_ref) {
        var key = _ref.key;

        var rawValue = attrs[key];
        attrs[key] = rawValue ? moment_default()(rawValue, ['MM/DD/YYYY', 'YYYY-MM-DD']).format('YYYY-MM-DD') : '';
      });
      _this2.props.updateHolidayPromoSetting(attrs, vendor).catch(function () {});
    }
  });
  Object.defineProperty(this, 'renderFieldLabel', {
    enumerable: true,
    writable: true,
    value: function value(_ref2) {
      var key = _ref2.key,
          label = _ref2.label,
          tooltip = _ref2.tooltip;
      return react_default.a.createElement(
        'span',
        { className: holidayPromoSettings_styles_default.a.labelContent },
        label,
        react_default.a.createElement(font_icon_default.a, {
          value: 'info_outline',
          className: holidayPromoSettings_styles_default.a.infoIcon,
          'data-tip': true,
          'data-for': 'hps-' + key
        }),
        react_default.a.createElement(
          react_tooltip_dist_default.a,
          { id: 'hps-' + key, place: 'top', effect: 'solid' },
          react_default.a.createElement(
            'span',
            { className: holidayPromoSettings_styles_default.a.tooltipText },
            tooltip
          )
        )
      );
    }
  });
  Object.defineProperty(this, 'renderDateField', {
    enumerable: true,
    writable: true,
    value: function value(field) {
      var errors = _this2.props.errors;

      return react_default.a.createElement(DatePicker, {
        key: field.key,
        className: fieldWidth,
        label: _this2.renderFieldLabel(field),
        value: _this2.state.form[field.key] || '',
        onChange: _this2.handleDateChange(field.key),
        error: Object(utils["c" /* error */])(field.key, errors)
      });
    }
  });
};

holidayPromoSettings_HolidayPromoSettings.defaultProps = {
  setting: null,
  loading: false,
  errors: {},
  user: {}
};

holidayPromoSettings_HolidayPromoSettings.propTypes = {
  setting: prop_types_default.a.object,
  loading: prop_types_default.a.bool,
  errors: prop_types_default.a.object,
  user: prop_types_default.a.object,
  fetchHolidayPromoSetting: prop_types_default.a.func.isRequired,
  updateHolidayPromoSetting: prop_types_default.a.func.isRequired
};

var holidayPromoSettings_mapStateToProps = function mapStateToProps(state) {
  return {
    setting: Object(reducers["y" /* getHolidayPromoSetting */])(state),
    loading: Object(reducers["A" /* getHolidayPromoSettingLoading */])(state),
    errors: Object(reducers["z" /* getHolidayPromoSettingErrors */])(state),
    user: state.user
  };
};

var holidayPromoSettings_mapDispatchToProps = {
  fetchHolidayPromoSetting: fetchHolidayPromoSetting,
  updateHolidayPromoSetting: updateHolidayPromoSetting
};

/* harmony default export */ var holidayPromoSettings = (Object(react_redux_es["connect"])(holidayPromoSettings_mapStateToProps, holidayPromoSettings_mapDispatchToProps)(holidayPromoSettings_HolidayPromoSettings));
// EXTERNAL MODULE: ./node_modules/react-toolbox/lib/card/index.js
var lib_card = __webpack_require__("uAOa");
var lib_card_default = /*#__PURE__*/__webpack_require__.n(lib_card);

// EXTERNAL MODULE: ./client/app/assets/images/sp-logo.svg
var sp_logo = __webpack_require__("n5Rb");
var sp_logo_default = /*#__PURE__*/__webpack_require__.n(sp_logo);

// EXTERNAL MODULE: ./client/app/screens/login/login.scss
var login = __webpack_require__("80jm");
var login_default = /*#__PURE__*/__webpack_require__.n(login);

// EXTERNAL MODULE: ./node_modules/@azure/msal-browser/dist/index.js + 98 modules
var msal_browser_dist = __webpack_require__("2hFk");

// CONCATENATED MODULE: ./client/app/screens/login/azure/azure-authentication-context.js
var azure_authentication_context__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function azure_authentication_context__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var MSAL_CONFIG = {
  auth: {
    clientId: "f18781ea-3b64-4c9d-b93f-1ec42af69a36",
    redirectUri: "https://cvdemo.serviceprosig.com/mscallback"
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false
  }
};

var myMSALObj = new msal_browser_dist["a" /* PublicClientApplication */](MSAL_CONFIG);

var AzureAuthenticationContext = function AzureAuthenticationContext() {
  var _this = this;

  azure_authentication_context__classCallCheck(this, AzureAuthenticationContext);

  Object.defineProperty(this, 'setRequestObjects', {
    enumerable: true,
    writable: true,
    value: function value() {
      _this.loginRequest = {
        scopes: ['user.read', 'profile', 'openid', 'email'],
        prompt: 'select_account'
      };
      _this.loginRedirectRequest = azure_authentication_context__extends({}, _this.loginRequest, {
        redirectStartPage: window.location.href
      });
    }
  });
  Object.defineProperty(this, 'login', {
    enumerable: true,
    writable: true,
    value: function value(signInType, setUser, onError) {
      if (signInType === 'loginPopup') {
        onError(null); // Clearing the error
        myMSALObj.loginPopup(_this.loginRequest).then(function (resp) {
          _this.handleResponse(resp, setUser);
        }).catch(function (err) {
          if (err.errorCode === 'interaction_in_progress') {
            onError('Interaction is currently in progress. We have cancelled the interaction for you. Attempt to login again');
          } else onError(err.errorMessage);
          sessionStorage.clear();
        });
      } else if (signInType === 'loginRedirect') {
        _this.myMSALObj.loginRedirect(_this.loginRedirectRequest);
      }
    }
  });
  Object.defineProperty(this, 'handleResponse', {
    enumerable: true,
    writable: true,
    value: function value(response, incomingFunction) {
      if (response !== null && response.account !== null) {
        incomingFunction(response, myMSALObj);
      }
    }
  });

  this.setRequestObjects();
};

/* harmony default export */ var azure_authentication_context = (AzureAuthenticationContext);
// EXTERNAL MODULE: ./app/assets/images/microsoft_assets/ms-logo.png
var ms_logo = __webpack_require__("/V75");
var ms_logo_default = /*#__PURE__*/__webpack_require__.n(ms_logo);

// CONCATENATED MODULE: ./client/app/screens/login/azure/MicrosoftLoginButton.jsx






var MicrosoftLoginButton_MicrosoftLogin = function MicrosoftLogin(_ref) {
  var onAuthenticated = _ref.onAuthenticated,
      onError = _ref.onError;

  var authenticationModule = new azure_authentication_context();

  var returnedAccountInfo = function returnedAccountInfo(accountInfo, msal) {
    return onAuthenticated(accountInfo, msal);
  };

  var logIn = function logIn() {
    return authenticationModule.login('loginPopup', returnedAccountInfo, onError);
  };

  return react_default.a.createElement(
    'button',
    { className: login_default.a.msBtnContainer, onClick: logIn },
    react_default.a.createElement('img', { className: login_default.a.msBtnImg, src: ms_logo_default.a, width: '38', height: '38', alt: '' }),
    react_default.a.createElement(
      'span',
      { className: login_default.a.msBtnText },
      'Sign In with Microsoft'
    )
  );
};

MicrosoftLoginButton_MicrosoftLogin.propTypes = {
  onAuthenticated: prop_types_default.a.func,
  onError: prop_types_default.a.func
};

/* harmony default export */ var MicrosoftLoginButton = (MicrosoftLoginButton_MicrosoftLogin);
// EXTERNAL MODULE: ./node_modules/@react-oauth/google/dist/index.esm.js
var index_esm = __webpack_require__("StTx");

// CONCATENATED MODULE: ./client/app/shared/components/Auth/googleLoginButton.jsx





function GoogleLoginButton(props) {
  var googleLogin = Object(index_esm["b" /* useGoogleLogin */])({
    onSuccess: function onSuccess(codeResponse) {
      return props.handleGoogleResponse(codeResponse);
    },
    flow: 'auth-code',
    scopes: 'openid email profile'
  });

  return react_default.a.createElement(
    'button',
    { className: login_default.a.googleAuthBtn, onClick: function onClick() {
        return googleLogin();
      } },
    react_default.a.createElement('img', {
      className: login_default.a.googleAuthLogo,
      src: 'https://developers.google.com/identity/images/g-logo.png',
      alt: 'Google logo'
    }),
    'Sign in with Google'
  );
}

GoogleLoginButton.defaultProps = { handleGoogleResponse: function handleGoogleResponse() {} };

GoogleLoginButton.propTypes = { handleGoogleResponse: prop_types_default.a.func };

/* harmony default export */ var googleLoginButton = (GoogleLoginButton);
// CONCATENATED MODULE: ./client/app/screens/login/index.jsx
var login__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function login__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function login__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function login__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var DEFAULT_REDIRECT_PATH = '/';
var cpText = 'Copyright ' + new Date().getFullYear() + '. All rights reserved';
var login_theme = { RTCard: login_default.a };

var searchIdToken = function searchIdToken(data) {
  if ({}.hasOwnProperty.call(data, 'id_token')) return data.id_token;
  var token = null;
  Object.keys(data).forEach(function (key) {
    token = token || login__typeof(data[key]) === 'object' && searchIdToken(data[key]);
  });
  return token;
};

var login_Login = function (_React$Component) {
  login__inherits(Login, _React$Component);

  function Login(props) {
    login__classCallCheck(this, Login);

    var _this = login__possibleConstructorReturn(this, (Login.__proto__ || Object.getPrototypeOf(Login)).call(this, props));

    Object.defineProperty(_this, 'componentWillMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            isAuthenticated = _this$props.isAuthenticated,
            replace = _this$props.replace,
            redirect = _this$props.redirect;

        if (isAuthenticated) replace(redirect);
      }
    });
    Object.defineProperty(_this, 'componentWillReceiveProps', {
      enumerable: true,
      writable: true,
      value: function value(nextProps) {
        var isAuthenticated = nextProps.isAuthenticated,
            replace = nextProps.replace,
            redirect = nextProps.redirect;
        var wasAuthenticated = _this.props.isAuthenticated;

        if (!wasAuthenticated && isAuthenticated) replace(redirect);
      }
    });
    Object.defineProperty(_this, 'onMicrosoftAuthenticated', {
      enumerable: true,
      writable: true,
      value: function value(data, msal) {
        _this.handleMicrosoftError('');
        _this.props.signInMicrosoftUser({
          id_token: data.idToken,
          uid_type: 'microsoft'
        }, msal);
      }
    });
    Object.defineProperty(_this, 'handleGoogleResponse', {
      enumerable: true,
      writable: true,
      value: function value(response) {
        return _this.props.signInGoogleUser({
          code: response.code, uid_type: 'google'
        });
      }
    });
    Object.defineProperty(_this, 'handleGoogleError', {
      enumerable: true,
      writable: true,
      value: function value(response) {
        return _this.props.loginUserFailure(response.error);
      }
    });
    Object.defineProperty(_this, 'handleMicrosoftError', {
      enumerable: true,
      writable: true,
      value: function value(err) {
        return _this.props.loginUserFailure(err);
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var hasLoginError = _this.props.statusText != null;
        return react_default.a.createElement(
          'div',
          { className: login_default.a.loginWrapper },
          react_default.a.createElement(
            react_css_themr_lib["ThemeProvider"],
            { theme: login_theme },
            react_default.a.createElement(
              lib_card["Card"],
              null,
              react_default.a.createElement(
                lib_card["CardMedia"],
                null,
                react_default.a.createElement('img', { className: login_default.a.spLogo, alt: 'Service Pros logo', src: sp_logo_default.a })
              ),
              hasLoginError ? react_default.a.createElement(
                lib_card["CardText"],
                null,
                _this.props.statusText
              ) : null,
              react_default.a.createElement(
                lib_card["CardActions"],
                null,
                react_default.a.createElement(
                  index_esm["a" /* GoogleOAuthProvider */],
                  { clientId: "505224199545-l51jca4uhc22t8jb28n587ggkrpi2f7h.apps.googleusercontent.com" },
                  react_default.a.createElement(googleLoginButton, { handleGoogleResponse: _this.handleGoogleResponse })
                )
              ),
              react_default.a.createElement(
                lib_card["CardActions"],
                null,
                react_default.a.createElement(MicrosoftLoginButton, {
                  onAuthenticated: _this.onMicrosoftAuthenticated,
                  onError: _this.handleMicrosoftError
                })
              )
            )
          ),
          react_default.a.createElement(
            'div',
            { className: login_default.a.copyright },
            cpText
          )
        );
      }
    });

    _this.handleGoogleResponse = _this.handleGoogleResponse.bind(_this);
    return _this;
  }

  return Login;
}(react_default.a.Component);

var login_mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    statusText: state.user.statusText,
    isAuthenticated: state.user.isAuthenticated,
    wasAuthenticated: ownProps.isAuthenticated,
    redirect: ownProps.location.query.redirect || DEFAULT_REDIRECT_PATH
  };
};

login_Login.propTypes = {
  replace: prop_types_default.a.func,
  signInGoogleUser: prop_types_default.a.func,
  signInMicrosoftUser: prop_types_default.a.func,
  loginUserFailure: prop_types_default.a.func,
  redirect: prop_types_default.a.string,
  statusText: prop_types_default.a.string,
  isAuthenticated: prop_types_default.a.bool,
  wasAuthenticated: prop_types_default.a.bool
};

/* harmony default export */ var screens_login = (Object(react_redux_es["connect"])(login_mapStateToProps, {
  signInGoogleUser: actionCreators["_54" /* signInGoogleUser */],
  signInMicrosoftUser: actionCreators["_55" /* signInMicrosoftUser */],
  loginUserFailure: actionCreators["K" /* loginUserFailure */],
  replace: react_router_redux_lib["routerActions"].replace
})(login_Login));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseAppointments/components/newPhaseAppointment.jsx
function newPhaseAppointment__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function newPhaseAppointment__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function newPhaseAppointment__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var newPhaseAppointment_NewPhaseAppointment = function (_React$Component) {
  newPhaseAppointment__inherits(NewPhaseAppointment, _React$Component);

  function NewPhaseAppointment() {
    var _ref;

    var _temp, _this, _ret;

    newPhaseAppointment__classCallCheck(this, NewPhaseAppointment);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = newPhaseAppointment__possibleConstructorReturn(this, (_ref = NewPhaseAppointment.__proto__ || Object.getPrototypeOf(NewPhaseAppointment)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'componentWillMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.phaseAppointmentClearValidation();
      }
    }), Object.defineProperty(_this, 'processSubmit', {
      enumerable: true,
      writable: true,
      value: function value(phaseId, params, ssData, event) {
        return _this.props.createPhaseAppointment(phaseId, params, ssData, event);
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        return react_default.a.createElement(schedulePhaseAppointment, {
          onSubmit: _this.processSubmit,
          errors: _this.props.appointmentState.errors
        });
      }
    }), _temp), newPhaseAppointment__possibleConstructorReturn(_this, _ret);
  }

  return NewPhaseAppointment;
}(react_default.a.Component);

newPhaseAppointment_NewPhaseAppointment.propTypes = {
  createPhaseAppointment: prop_types_default.a.func.isRequired,
  phaseAppointmentClearValidation: prop_types_default.a.func.isRequired,
  appointmentState: prop_types_default.a.shape({
    loading: prop_types_default.a.bool,
    errors: prop_types_default.a.object
  })
};

/* harmony default export */ var newPhaseAppointment = (Object(react_redux_es["connect"])(function (state) {
  return { appointmentState: state.appointment };
}, { createPhaseAppointment: createPhaseAppointment, phaseAppointmentClearValidation: phaseAppointmentClearValidation })(newPhaseAppointment_NewPhaseAppointment));
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseAppointments/components/editPhaseAppointment.jsx
function editPhaseAppointment__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function editPhaseAppointment__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function editPhaseAppointment__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var editPhaseAppointment_EditPhaseAppointment = function (_React$Component) {
  editPhaseAppointment__inherits(EditPhaseAppointment, _React$Component);

  function EditPhaseAppointment() {
    var _ref;

    var _temp, _this, _ret;

    editPhaseAppointment__classCallCheck(this, EditPhaseAppointment);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = editPhaseAppointment__possibleConstructorReturn(this, (_ref = EditPhaseAppointment.__proto__ || Object.getPrototypeOf(EditPhaseAppointment)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'componentWillMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.requestAppointment(_this.props.params.appointmentId);
      }
    }), Object.defineProperty(_this, 'componentWillUnmount', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.phaseAppointmentClearValidation();
      }
    }), Object.defineProperty(_this, 'processSubmit', {
      enumerable: true,
      writable: true,
      value: function value(phaseId, params, ssData, event) {
        var overrideReschedule = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

        if (overrideReschedule) {
          return _this.props.createPhaseAppointment(phaseId, params, ssData, event);
        }
        return _this.props.editPhaseAppointment(_this.props.params.appointmentId, _this.props.params.id, params, ssData, event);
      }
    }), Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props$appointme = _this.props.appointmentState,
            data = _this$props$appointme.data,
            loading = _this$props$appointme.loading,
            errors = _this$props$appointme.errors;

        if (loading) return react_default.a.createElement(components_Loading, null);
        var assignee = data.assignee;

        var arrivalStart = moment_default()(data.arrival_start_time, 'HH:mm');
        var arrivalEnd = moment_default()(data.arrival_end_time, 'HH:mm');
        var startDate = moment_default()(data.start_date).format('MM/DD/YYYY');
        var endDate = moment_default()(data.end_date).format('MM/DD/YYYY');
        var pickupDate = data.pickup_date ? moment_default()(data.pickup_date).format('MM/DD/YYYY') : null;
        var type = data.kind || '';
        var confirmationDate = null;
        if (data.appointment_confirmation_date) {
          confirmationDate = moment_default()(data.appointment_confirmation_date).format('MM/DD/YYYY');
        }
        var apptObj = {
          id: data.id,
          schedulingReason: data.scheduling_reason,
          arrivalStart: arrivalStart.format('HH:mm'),
          arrivalEnd: arrivalEnd.format('HH:mm'),
          confirmationDate: confirmationDate,
          startDate: startDate,
          endDate: endDate,
          pickupDate: pickupDate,
          selectedAssignee: assignee ? assignee[Object.keys(assignee)[0]] : null,
          apptType: type,
          note: data.note || ''
        };
        return react_default.a.createElement(schedulePhaseAppointment, {
          onSubmit: _this.processSubmit,
          appointment: apptObj,
          originalDate: apptObj.startDate,
          originalStart: apptObj.arrivalStart,
          originalEnd: apptObj.arrivalEnd,
          errors: errors,
          isEdit: true
        });
      }
    }), _temp), editPhaseAppointment__possibleConstructorReturn(_this, _ret);
  }

  return EditPhaseAppointment;
}(react_default.a.Component);

editPhaseAppointment_EditPhaseAppointment.propTypes = {
  createPhaseAppointment: prop_types_default.a.func.isRequired,
  editPhaseAppointment: prop_types_default.a.func.isRequired,
  requestAppointment: prop_types_default.a.func.isRequired,
  phaseAppointmentClearValidation: prop_types_default.a.func.isRequired,
  appointmentState: prop_types_default.a.shape({
    data: prop_types_default.a.object.isRequired,
    loading: prop_types_default.a.bool,
    errors: prop_types_default.a.object
  }),
  params: prop_types_default.a.shape({
    id: prop_types_default.a.string,
    appointmentId: prop_types_default.a.string
  })
};

/* harmony default export */ var components_editPhaseAppointment = (Object(react_redux_es["connect"])(function (state) {
  return { appointmentState: state.appointment };
}, {
  createPhaseAppointment: createPhaseAppointment,
  editPhaseAppointment: editPhaseAppointment,
  requestAppointment: requestAppointment,
  phaseAppointmentClearValidation: phaseAppointmentClearValidation
})(editPhaseAppointment_EditPhaseAppointment));
// EXTERNAL MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/ifiTemplate/templates/TemplateStyling.scss
var TemplateStyling = __webpack_require__("qHOt");
var TemplateStyling_default = /*#__PURE__*/__webpack_require__.n(TemplateStyling);

// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/ifiTemplate/templates/components/measures/measurementParsing.js
var measurementParsing__slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

// Measurements must be in inches, so no ' or " (feet/inch marks) are accepted.
// Accepts whole numbers, decimals, bare fractions, a whole + fraction combined
// (fraction before or after the whole, separated by a space or "-"), and a
// dash-separated range of two whole/decimal numbers (parsed as their average):
// "34", "34.5", "1/2", "34 1/2", "34-1/2", "1/2 34", "1/2-34", "34-35".
var WHOLE_ONLY_RE = /^\d+(?:\.\d+)?$/;
var FRACTION_ONLY_RE = /^(\d+)\/(\d+)$/;
var WHOLE_THEN_FRACTION_RE = /^(\d+(?:\.\d+)?)[-\s](\d+)\/(\d+)$/;
var FRACTION_THEN_WHOLE_RE = /^(\d+)\/(\d+)[-\s](\d+(?:\.\d+)?)$/;
var WHOLE_RANGE_RE = /^(\d+(?:\.\d+)?)-(\d+(?:\.\d+)?)$/;

function fraction(numerator, denominator) {
  return Number(denominator) === 0 ? NaN : Number(numerator) / Number(denominator);
}

function parseMeasurement(value) {
  var trimmed = String(value).trim();

  if (WHOLE_ONLY_RE.test(trimmed)) {
    return parseFloat(trimmed);
  }

  var match = trimmed.match(FRACTION_ONLY_RE);
  if (match) {
    var _match = match,
        _match2 = measurementParsing__slicedToArray(_match, 3),
        numerator = _match2[1],
        denominator = _match2[2];

    return fraction(numerator, denominator);
  }

  match = trimmed.match(WHOLE_THEN_FRACTION_RE);
  if (match) {
    var _match3 = match,
        _match4 = measurementParsing__slicedToArray(_match3, 4),
        whole = _match4[1],
        _numerator = _match4[2],
        _denominator = _match4[3];

    return parseFloat(whole) + fraction(_numerator, _denominator);
  }

  match = trimmed.match(FRACTION_THEN_WHOLE_RE);
  if (match) {
    var _match5 = match,
        _match6 = measurementParsing__slicedToArray(_match5, 4),
        _numerator2 = _match6[1],
        _denominator2 = _match6[2],
        _whole = _match6[3];

    return parseFloat(_whole) + fraction(_numerator2, _denominator2);
  }

  match = trimmed.match(WHOLE_RANGE_RE);
  if (match) {
    var _match7 = match,
        _match8 = measurementParsing__slicedToArray(_match7, 3),
        start = _match8[1],
        end = _match8[2];

    return (parseFloat(start) + parseFloat(end)) / 2;
  }

  return NaN;
}

// Some measurement fields (door widths/heights) disallow decimal notation
// ("34.5") while still allowing fraction notation ("34 1/2").
function hasDecimalNotation(value) {
  return String(value).includes('.');
}
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/ifiTemplate/templates/components/measures/EntryDoorMeasures.jsx
var EntryDoorMeasures__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function EntryDoorMeasures__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function EntryDoorMeasures__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var entryDoorConfigTypes = [{ value: 'Slab Only (S)', label: 'Slab Only (S)' }, { value: 'Single', label: 'Single' }, { value: 'Single w/ sidelite', label: 'Single w/ sidelite' }, { value: 'Double', label: 'Double' }, { value: 'Sidelite', label: 'Sidelite' }, { value: 'Transom', label: 'Transom' }, { value: 'Patio Slider', label: 'Patio Slider' }, { value: 'French Patio', label: 'French Patio' }];

var slabOrFullFrame = [{ value: 'Slab', label: 'Slab' }, { value: 'Full Frame', label: 'Full Frame' }];

var SLAB_ONLY = 'Slab Only (S)';

// Slab Only is always a slab; every other configuration (Single, Double, etc.)
// can be either, so it still needs the Slab or Full Frame question.
function needsSlabOrFullFrameChoice(configuration) {
  return configuration && configuration !== SLAB_ONLY;
}

function isSlab(measure) {
  if (measure.configuration === SLAB_ONLY) return true;
  return measure.slab_or_full_frame === 'Slab';
}

function EntryDoorMeasures(_ref) {
  var measures = _ref.measures,
      onChange = _ref.onChange;

  var handleFieldChange = function handleFieldChange(idx, field, value) {
    var updated = measures.map(function (m, i) {
      return i === idx ? EntryDoorMeasures__extends({}, m, EntryDoorMeasures__defineProperty({}, field, value)) : m;
    });
    onChange(updated);
  };

  var handleConfigurationChange = function handleConfigurationChange(idx, value) {
    var updated = measures.map(function (m, i) {
      if (i !== idx) return m;
      var next = EntryDoorMeasures__extends({}, m, { configuration: value });
      if (!needsSlabOrFullFrameChoice(value)) next.slab_or_full_frame = '';
      if (!isSlab(next)) next.slab_thickness = '';
      return next;
    });
    onChange(updated);
  };

  var handleSlabOrFullFrameChange = function handleSlabOrFullFrameChange(idx, value) {
    var updated = measures.map(function (m, i) {
      if (i !== idx) return m;
      var next = EntryDoorMeasures__extends({}, m, { slab_or_full_frame: value });
      if (!isSlab(next)) next.slab_thickness = '';
      return next;
    });
    onChange(updated);
  };

  var handleNestedChange = function handleNestedChange(idx, group, subfield, value) {
    var updated = measures.map(function (m, i) {
      if (i === idx) {
        return EntryDoorMeasures__extends({}, m, EntryDoorMeasures__defineProperty({}, group, EntryDoorMeasures__extends({}, m[group], EntryDoorMeasures__defineProperty({}, subfield, value))));
      }
      return m;
    });
    onChange(updated);
  };

  var addRow = function addRow() {
    onChange([].concat(EntryDoorMeasures__toConsumableArray(measures), [{
      openingNumber: '',
      location: '',
      configuration: '',
      slab_or_full_frame: '',
      slab_thickness: '',
      jamb_size: '',
      unitSize: { width: '', height: '' },
      roughOpening: { width: '', height: '' },
      handing: '',
      notes: ''
    }]));
  };

  var removeRow = function removeRow(idx) {
    onChange(measures.filter(function (_, i) {
      return i !== idx;
    }));
  };

  return react_default.a.createElement(
    'div',
    null,
    react_default.a.createElement(
      'h6',
      null,
      'Entry Doors Measured'
    ),
    measures.map(function (measure, idx) {
      return react_default.a.createElement(
        'div',
        { key: measure.openingNumber || 'entryDoor-' + idx, style: { border: '1px solid #eee', marginBottom: 10, padding: 10 } },
        react_default.a.createElement(
          'div',
          { className: TemplateStyling_default.a.container },
          react_default.a.createElement(
            'strong',
            null,
            'ALL MEASURES MUST BE IN INCHES'
          ),
          react_default.a.createElement(
            'strong',
            null,
            'Opening #',
            idx + 1
          )
        ),
        react_default.a.createElement(react_toolbox_lib["Input"], { label: 'Location', value: measure.location, onChange: function onChange(v) {
            return handleFieldChange(idx, 'location', v);
          } }),
        react_default.a.createElement(react_toolbox_lib["Dropdown"], { label: 'Configuration', source: entryDoorConfigTypes, value: measure.configuration, onChange: function onChange(v) {
            return handleConfigurationChange(idx, v);
          } }),
        needsSlabOrFullFrameChoice(measure.configuration) && react_default.a.createElement(react_toolbox_lib["Dropdown"], { label: 'Slab or Full Frame', source: slabOrFullFrame, value: measure.slab_or_full_frame, onChange: function onChange(v) {
            return handleSlabOrFullFrameChange(idx, v);
          } }),
        isSlab(measure) && react_default.a.createElement(react_toolbox_lib["Input"], { label: 'Slab Thickness', hint: 'e.g. 34 1/2', value: measure.slab_thickness, onChange: function onChange(v) {
            return handleFieldChange(idx, 'slab_thickness', v);
          } }),
        react_default.a.createElement(react_toolbox_lib["Input"], { label: 'Jamb Size', hint: 'e.g. 34 1/2', value: measure.jamb_size, onChange: function onChange(v) {
            return handleFieldChange(idx, 'jamb_size', v);
          } }),
        react_default.a.createElement(
          'strong',
          null,
          'UNIT SIZE'
        ),
        react_default.a.createElement(react_toolbox_lib["Input"], { label: 'Width', hint: 'e.g. 34 1/2', value: measure.unitSize.width, onChange: function onChange(v) {
            return handleNestedChange(idx, 'unitSize', 'width', v);
          } }),
        react_default.a.createElement(react_toolbox_lib["Input"], { label: 'Height', hint: 'e.g. 34 1/2', value: measure.unitSize.height, onChange: function onChange(v) {
            return handleNestedChange(idx, 'unitSize', 'height', v);
          } }),
        react_default.a.createElement(
          'strong',
          null,
          'ROUGH OPENING'
        ),
        react_default.a.createElement(react_toolbox_lib["Input"], { label: 'Width', hint: 'e.g. 34 1/2', value: measure.roughOpening.width, onChange: function onChange(v) {
            return handleNestedChange(idx, 'roughOpening', 'width', v);
          } }),
        react_default.a.createElement(react_toolbox_lib["Input"], { label: 'Height', hint: 'e.g. 34 1/2', value: measure.roughOpening.height, onChange: function onChange(v) {
            return handleNestedChange(idx, 'roughOpening', 'height', v);
          } }),
        react_default.a.createElement(
          'strong',
          null,
          'OTHER'
        ),
        react_default.a.createElement(react_toolbox_lib["Input"], { label: 'Handing', value: measure.handing, onChange: function onChange(v) {
            return handleFieldChange(idx, 'handing', v);
          } }),
        react_default.a.createElement(components_TextArea, {
          label: 'Notes',
          value: measure.notes || '',
          onChange: function onChange(e) {
            return handleFieldChange(idx, 'notes', e.target.value);
          }
        }),
        react_default.a.createElement(react_toolbox_lib["Button"], { className: TemplateStyling_default.a.removeButton, label: 'Remove', onClick: function onClick() {
            return removeRow(idx);
          } })
      );
    }),
    react_default.a.createElement(react_toolbox_lib["Button"], { className: TemplateStyling_default.a.button, label: 'Add Entry Door', onClick: addRow })
  );
}

EntryDoorMeasures.propTypes = {
  measures: prop_types_default.a.arrayOf(prop_types_default.a.shape({
    openingNumber: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]),
    location: prop_types_default.a.string,
    configuration: prop_types_default.a.string,
    slab_or_full_frame: prop_types_default.a.string,
    slab_thickness: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]),
    jamb_size: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]),
    unitSize: prop_types_default.a.shape({
      width: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]),
      height: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number])
    }),
    roughOpening: prop_types_default.a.shape({
      width: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]),
      height: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number])
    }),
    handing: prop_types_default.a.string,
    notes: prop_types_default.a.string
  })).isRequired,
  onChange: prop_types_default.a.func.isRequired
};

/* harmony default export */ var measures_EntryDoorMeasures = (EntryDoorMeasures);

function validateEntryDoorMeasures(measures) {
  var errors = {};
  measures.forEach(function (item, idx) {
    if (needsSlabOrFullFrameChoice(item.configuration) && !item.slab_or_full_frame) {
      if (!errors[idx]) errors[idx] = {};
      errors[idx].slab_or_full_frame = ['slab_or_full_frame is required for this configuration.'];
    }
    if (isSlab(item) && (item.slab_thickness === undefined || item.slab_thickness === '')) {
      if (!errors[idx]) errors[idx] = {};
      errors[idx].slab_thickness = ['slab_thickness is required for a slab configuration.'];
    }
    var measurementFields = ['slab_thickness', 'jamb_size'];
    measurementFields.forEach(function (field) {
      var value = item[field];
      if (value !== undefined && value !== '' && isNaN(parseMeasurement(value))) {
        if (!errors[idx]) errors[idx] = {};
        errors[idx][field] = [field + ' must be a number or fraction.'];
      }
    });
    if (item.unitSize) {
      ['width', 'height'].forEach(function (subfield) {
        var value = item.unitSize[subfield];
        if (value === undefined || value === '') return;
        if (isNaN(parseMeasurement(value))) {
          if (!errors[idx]) errors[idx] = {};
          errors[idx]['unitSize.' + subfield] = ['unitSize.' + subfield + ' must be a number or fraction.'];
        } else if (hasDecimalNotation(value)) {
          if (!errors[idx]) errors[idx] = {};
          errors[idx]['unitSize.' + subfield] = ['unitSize.' + subfield + ' must not use decimal notation; use a fraction instead (e.g. 34 1/2).'];
        }
      });
    }
    if (item.roughOpening) {
      ['width', 'height'].forEach(function (subfield) {
        var value = item.roughOpening[subfield];
        if (value === undefined || value === '') return;
        if (isNaN(parseMeasurement(value))) {
          if (!errors[idx]) errors[idx] = {};
          errors[idx]['roughOpening.' + subfield] = ['roughOpening.' + subfield + ' must be a number or fraction.'];
        } else if (hasDecimalNotation(value)) {
          if (!errors[idx]) errors[idx] = {};
          errors[idx]['roughOpening.' + subfield] = ['roughOpening.' + subfield + ' must not use decimal notation; use a fraction instead (e.g. 34 1/2).'];
        }
      });
    }
  });
  if (Object.keys(errors).length > 0) {
    errors.entryDoorMeasures = ['Please ensure all numeric fields are valid numbers.'];
  }
  return errors;
}
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/ifiTemplate/templates/components/charts/DoorCharts.jsx



function DoorCharts(_ref) {
  var configurationChart = _ref.configurationChart,
      handingChart = _ref.handingChart,
      configAlt = _ref.configAlt,
      handingAlt = _ref.handingAlt;

  return react_default.a.createElement(
    'div',
    null,
    react_default.a.createElement(
      'div',
      { style: { marginBottom: 16 } },
      react_default.a.createElement(
        'h6',
        null,
        'Configuration Chart'
      ),
      react_default.a.createElement('img', {
        src: configurationChart,
        alt: configAlt,
        style: { maxWidth: '100%', marginBottom: 8 }
      })
    ),
    react_default.a.createElement(
      'div',
      { style: { marginBottom: 16 } },
      react_default.a.createElement(
        'h6',
        null,
        'Handing Chart'
      ),
      react_default.a.createElement('img', {
        src: handingChart,
        alt: handingAlt,
        style: { maxWidth: '100%', marginBottom: 8 }
      })
    )
  );
}

DoorCharts.propTypes = {
  configurationChart: prop_types_default.a.string.isRequired,
  handingChart: prop_types_default.a.string.isRequired,
  configAlt: prop_types_default.a.string.isRequired,
  handingAlt: prop_types_default.a.string.isRequired
};

/* harmony default export */ var charts_DoorCharts = (DoorCharts);
// EXTERNAL MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/ifiTemplate/templates/assets/entry_configuration.png
var entry_configuration = __webpack_require__("D5fg");
var entry_configuration_default = /*#__PURE__*/__webpack_require__.n(entry_configuration);

// EXTERNAL MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/ifiTemplate/templates/assets/entry_handing.png
var entry_handing = __webpack_require__("sTdn");
var entry_handing_default = /*#__PURE__*/__webpack_require__.n(entry_handing);

// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/ifiTemplate/templates/components/ArchesTransoms.jsx
var ArchesTransoms__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function ArchesTransoms__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function ArchesTransoms__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var archOrTransomTypes = [{ value: 'Arch', label: 'Arch' }, { value: 'Transom', label: 'Transom' }];

function ArchesTransoms(_ref) {
  var arches_transoms_measures = _ref.arches_transoms_measures,
      onChange = _ref.onChange,
      openingCount = _ref.openingCount,
      openingTypeLabel = _ref.openingTypeLabel;

  var handleFieldChange = function handleFieldChange(idx, field, value) {
    var updated = arches_transoms_measures.map(function (m, i) {
      return i === idx ? ArchesTransoms__extends({}, m, ArchesTransoms__defineProperty({}, field, value)) : m;
    });
    onChange(updated);
  };

  var handleNestedChange = function handleNestedChange(idx, group, subfield, value) {
    var updated = arches_transoms_measures.map(function (m, i) {
      if (i === idx) {
        return ArchesTransoms__extends({}, m, ArchesTransoms__defineProperty({}, group, ArchesTransoms__extends({}, m[group], ArchesTransoms__defineProperty({}, subfield, value))));
      }
      return m;
    });
    onChange(updated);
  };

  var addRow = function addRow() {
    onChange([].concat(ArchesTransoms__toConsumableArray(arches_transoms_measures), [{
      openingNumber: '',
      archOrTransom: '',
      unitSize: { width: '', height: '' },
      roughOpening: { width: '', height: '' },
      legHeight: ''
    }]));
  };

  var removeRow = function removeRow(idx) {
    onChange(arches_transoms_measures.filter(function (_, i) {
      return i !== idx;
    }));
  };

  return react_default.a.createElement(
    'div',
    null,
    react_default.a.createElement(
      'h6',
      null,
      'Arches/Transoms Measured'
    ),
    arches_transoms_measures.map(function (measure, idx) {
      return react_default.a.createElement(
        'div',
        { key: measure.openingNumber || 'archTransom-' + idx, style: { border: '1px solid #eee', marginBottom: 10, padding: 10 } },
        react_default.a.createElement(
          'div',
          { className: TemplateStyling_default.a.container },
          react_default.a.createElement(
            'strong',
            null,
            'ALL MEASURES MUST BE IN INCHES'
          ),
          react_default.a.createElement(
            'strong',
            null,
            'Opening #',
            idx + 1
          )
        ),
        react_default.a.createElement(react_toolbox_lib["Input"], { label: 'Opening #', hint: '1-' + openingCount + ', matching a measured ' + openingTypeLabel, value: measure.openingNumber, onChange: function onChange(v) {
            return handleFieldChange(idx, 'openingNumber', v);
          } }),
        react_default.a.createElement(react_toolbox_lib["Dropdown"], { label: 'Arch or Transom', source: archOrTransomTypes, value: measure.archOrTransom, onChange: function onChange(v) {
            return handleFieldChange(idx, 'archOrTransom', v);
          } }),
        react_default.a.createElement(
          'strong',
          null,
          'UNIT SIZE'
        ),
        react_default.a.createElement(react_toolbox_lib["Input"], { label: 'Width', hint: 'e.g. 34 1/2', value: measure.unitSize.width, onChange: function onChange(v) {
            return handleNestedChange(idx, 'unitSize', 'width', v);
          } }),
        react_default.a.createElement(react_toolbox_lib["Input"], { label: 'Height', hint: 'e.g. 34 1/2', value: measure.unitSize.height, onChange: function onChange(v) {
            return handleNestedChange(idx, 'unitSize', 'height', v);
          } }),
        react_default.a.createElement(
          'strong',
          null,
          'ROUGH OPENING'
        ),
        react_default.a.createElement(react_toolbox_lib["Input"], { label: 'Width', hint: 'e.g. 34 1/2', value: measure.roughOpening.width, onChange: function onChange(v) {
            return handleNestedChange(idx, 'roughOpening', 'width', v);
          } }),
        react_default.a.createElement(react_toolbox_lib["Input"], { label: 'Height', hint: 'e.g. 34 1/2', value: measure.roughOpening.height, onChange: function onChange(v) {
            return handleNestedChange(idx, 'roughOpening', 'height', v);
          } }),
        react_default.a.createElement(
          'strong',
          null,
          'LEG HEIGHT'
        ),
        react_default.a.createElement(react_toolbox_lib["Input"], { label: 'Height', hint: 'e.g. 34 1/2', value: measure.legHeight, onChange: function onChange(v) {
            return handleFieldChange(idx, 'legHeight', v);
          } }),
        react_default.a.createElement(react_toolbox_lib["Button"], { className: TemplateStyling_default.a.removeButton, label: 'Remove', onClick: function onClick() {
            return removeRow(idx);
          } })
      );
    }),
    react_default.a.createElement(react_toolbox_lib["Button"], { className: TemplateStyling_default.a.button, label: 'Add Arch/Transom', onClick: addRow })
  );
}

ArchesTransoms.propTypes = {
  arches_transoms_measures: prop_types_default.a.arrayOf(prop_types_default.a.shape({
    openingNumber: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]),
    archOrTransom: prop_types_default.a.string,
    unitSize: prop_types_default.a.shape({
      width: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]),
      height: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number])
    }),
    roughOpening: prop_types_default.a.shape({
      width: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]),
      height: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number])
    }),
    legHeight: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number])
  })),
  onChange: prop_types_default.a.func.isRequired,
  openingCount: prop_types_default.a.number.isRequired,
  openingTypeLabel: prop_types_default.a.string.isRequired
};

/* harmony default export */ var components_ArchesTransoms = (ArchesTransoms);

function validateArchesTransoms(arches_transoms_measures, openingCount, openingTypeLabel) {
  var errors = {};
  arches_transoms_measures.forEach(function (item, idx) {
    if (!item.archOrTransom) {
      if (!errors[idx]) errors[idx] = {};
      errors[idx].archOrTransom = ['Arch or Transom is required.'];
    }
    var openingNumber = Number(item.openingNumber);
    if (item.openingNumber === undefined || item.openingNumber === '' || !Number.isInteger(openingNumber) || openingNumber < 1 || openingNumber > openingCount) {
      if (!errors[idx]) errors[idx] = {};
      errors[idx].openingNumber = ['Opening # must be a number between 1 and ' + openingCount + ', matching a measured ' + openingTypeLabel + '.'];
    }
    var measurementFields = ['legHeight'];
    measurementFields.forEach(function (field) {
      var value = item[field];
      if (value !== undefined && value !== '' && isNaN(parseMeasurement(value))) {
        if (!errors[idx]) errors[idx] = {};
        errors[idx][field] = [field + ' must be a number or fraction.'];
      }
    });
    if (item.unitSize) {
      ['width', 'height'].forEach(function (subfield) {
        var value = item.unitSize[subfield];
        if (value !== undefined && value !== '' && isNaN(parseMeasurement(value))) {
          if (!errors[idx]) errors[idx] = {};
          errors[idx]['unitSize.' + subfield] = ['unitSize.' + subfield + ' must be a number or fraction.'];
        }
      });
    }
    if (item.roughOpening) {
      ['width', 'height'].forEach(function (subfield) {
        var value = item.roughOpening[subfield];
        if (value !== undefined && value !== '' && isNaN(parseMeasurement(value))) {
          if (!errors[idx]) errors[idx] = {};
          errors[idx]['roughOpening.' + subfield] = ['roughOpening.' + subfield + ' must be a number or fraction.'];
        }
      });
    }
  });
  if (Object.keys(errors).length > 0) {
    errors.archesTransoms = ['Please ensure all numeric fields are valid numbers.'];
  }
  return errors;
}
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/ifiTemplate/templates/components/LaborMaterial.jsx
var LaborMaterial__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function LaborMaterial__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function LaborMaterial__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var itemOrLabor = [{ value: 'Item', label: 'Item' }, { value: 'Labor', label: 'Labor' }];

function LaborMaterial(_ref) {
  var labors_materials = _ref.labors_materials,
      onChange = _ref.onChange;

  var handleFieldChange = function handleFieldChange(idx, field, value) {
    var updated = labors_materials.map(function (m, i) {
      return i === idx ? LaborMaterial__extends({}, m, LaborMaterial__defineProperty({}, field, value)) : m;
    });
    onChange(updated);
  };

  var addRow = function addRow() {
    onChange([].concat(LaborMaterial__toConsumableArray(labors_materials), [{
      itemOrLabor: '',
      qty: '',
      costToLowes: '',
      description: ''
    }]));
  };

  var removeRow = function removeRow(idx) {
    onChange(labors_materials.filter(function (_, i) {
      return i !== idx;
    }));
  };

  return react_default.a.createElement(
    'div',
    null,
    react_default.a.createElement(
      'h6',
      null,
      'Additional Labor/Material'
    ),
    labors_materials.map(function (item, idx) {
      return react_default.a.createElement(
        'div',
        { key: item.itemOrLabor || 'additional-' + idx, style: { border: '1px solid #eee', marginBottom: 10, padding: 10 } },
        react_default.a.createElement(react_toolbox_lib["Dropdown"], { label: 'Item / Labor', source: itemOrLabor, value: item.itemOrLabor, onChange: function onChange(v) {
            return handleFieldChange(idx, 'itemOrLabor', v);
          } }),
        react_default.a.createElement(react_toolbox_lib["Input"], { label: 'Qty', value: item.qty, onChange: function onChange(v) {
            return handleFieldChange(idx, 'qty', v);
          } }),
        react_default.a.createElement(react_toolbox_lib["Input"], { label: 'Cost to Lowes', value: item.costToLowes, onChange: function onChange(v) {
            return handleFieldChange(idx, 'costToLowes', v);
          } }),
        react_default.a.createElement(react_toolbox_lib["Input"], { label: 'Description', value: item.description, onChange: function onChange(v) {
            return handleFieldChange(idx, 'description', v);
          } }),
        react_default.a.createElement(react_toolbox_lib["Button"], { className: TemplateStyling_default.a.removeButton, label: 'Remove', onClick: function onClick() {
            return removeRow(idx);
          } })
      );
    }),
    react_default.a.createElement(react_toolbox_lib["Button"], { className: TemplateStyling_default.a.button, label: 'Add Item', onClick: addRow })
  );
}

LaborMaterial.propTypes = {
  labors_materials: prop_types_default.a.arrayOf(prop_types_default.a.shape({
    itemOrLabor: prop_types_default.a.string,
    qty: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]),
    costToLowes: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]),
    description: prop_types_default.a.string
  })),
  onChange: prop_types_default.a.func.isRequired
};

/* harmony default export */ var components_LaborMaterial = (LaborMaterial);

function validateLaborMaterials(labors_materials) {
  var errors = {};
  labors_materials.forEach(function (item, idx) {
    var numberFields = ['qty', 'costToLowes'];
    numberFields.forEach(function (field) {
      var value = item[field];
      if (value === undefined || value === '') return;
      if (isNaN(Number(value))) {
        if (!errors[idx]) errors[idx] = {};
        errors[idx][field] = [field + ' must be a number.'];
        return;
      }
      if (field === 'qty' && Number(value) === 0) {
        if (!errors[idx]) errors[idx] = {};
        errors[idx][field] = [field + ' cannot be 0, starts in a unit of 1.'];
        return;
      }
      if (field === 'costToLowes' && Number(value) !== Number(Number(value).toFixed(3))) {
        if (!errors[idx]) errors[idx] = {};
        errors[idx][field] = [field + ' cannot have more than 3 decimal places.'];
      }
    });
  });
  if (Object.keys(errors).length > 0) {
    errors.laborMaterials = ['Please ensure all Qty and Cost fields are valid numbers.'];
  }
  return errors;
}
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/ifiTemplate/templates/components/Comments.jsx




function Comments(_ref) {
  var comments = _ref.comments,
      _onChange = _ref.onChange;

  return react_default.a.createElement(
    'div',
    null,
    react_default.a.createElement(components_TextArea, {
      label: 'Comments / Notes',
      value: comments || '',
      onChange: function onChange(e) {
        return _onChange(e.target.value);
      }
    })
  );
}

Comments.propTypes = {
  comments: prop_types_default.a.string,
  onChange: prop_types_default.a.func.isRequired
};

/* harmony default export */ var components_Comments = (Comments);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/ifiTemplate/templates/components/ProjectNeeds.jsx
var ProjectNeeds__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function ProjectNeeds__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





function ProjectNeeds(_ref) {
  var needs = _ref.needs,
      onChange = _ref.onChange,
      _ref$showDumpFee = _ref.showDumpFee,
      showDumpFee = _ref$showDumpFee === undefined ? true : _ref$showDumpFee,
      _ref$showAdditionalMi = _ref.showAdditionalMiles,
      showAdditionalMiles = _ref$showAdditionalMi === undefined ? true : _ref$showAdditionalMi,
      permitRequired = _ref.permitRequired,
      onPermitRequiredChange = _ref.onPermitRequiredChange;

  var handleFieldChange = function handleFieldChange(field, value) {
    onChange(ProjectNeeds__extends({}, needs, ProjectNeeds__defineProperty({}, field, value)));
  };

  return react_default.a.createElement(
    'div',
    null,
    react_default.a.createElement(react_toolbox_lib["Checkbox"], {
      label: 'Permit Required',
      checked: !!permitRequired,
      onChange: onPermitRequiredChange
    }),
    showDumpFee && react_default.a.createElement(react_toolbox_lib["Checkbox"], {
      label: 'Dump Fee Needed',
      checked: !!needs.dumpFeeNeeded,
      onChange: function onChange(v) {
        return handleFieldChange('dumpFeeNeeded', v);
      }
    }),
    showAdditionalMiles && react_default.a.createElement(react_toolbox_lib["Input"], {
      label: 'Additional Miles Over 20',
      value: needs.additionalMilesOver20 || '',
      onChange: function onChange(v) {
        return handleFieldChange('additionalMilesOver20', v);
      }
    })
  );
}

ProjectNeeds.propTypes = {
  needs: prop_types_default.a.shape({
    dumpFeeNeeded: prop_types_default.a.bool,
    additionalMilesOver20: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number])
  }),
  onChange: prop_types_default.a.func.isRequired,
  showDumpFee: prop_types_default.a.bool,
  showAdditionalMiles: prop_types_default.a.bool,
  permitRequired: prop_types_default.a.bool,
  onPermitRequiredChange: prop_types_default.a.func
};

/* harmony default export */ var components_ProjectNeeds = (ProjectNeeds);

function validateProjectNeeds(needs) {
  var errors = {};
  var numberFields = ['additionalMilesOver20'];
  var hasNumberError = false;
  numberFields.forEach(function (field) {
    var value = needs[field];
    if (value !== undefined && value !== '' && isNaN(Number(value))) {
      errors[field] = [field + ' must be a number.'];
      hasNumberError = true;
    }
  });
  if (hasNumberError) {
    errors.numberFields = ['Please ensure all numeric fields are valid numbers.'];
  }
  return errors;
}
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/ifiTemplate/templates/components/HomeDiagram.jsx
var HomeDiagram__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function HomeDiagram__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function HomeDiagram__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function HomeDiagram__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function HomeDiagram__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var MAX_DIMENSION = 1600;
var JPEG_QUALITY = 0.8;

var normalizeImages = function normalizeImages(value) {
  if (Array.isArray(value)) return value;
  if (value && value.image_data_url) return [value];
  return [];
};

// Resize to MAX_DIMENSION on the long edge, re-encode as JPEG to keep wkhtmltopdf reliable.
function resizeAndEncode(dataUrl, onDone) {
  var img = new Image();
  img.onload = function () {
    var width = img.width,
        height = img.height;

    var scale = Math.min(1, MAX_DIMENSION / Math.max(width, height));
    var canvas = document.createElement('canvas');
    canvas.width = Math.round(width * scale);
    canvas.height = Math.round(height * scale);
    canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
    onDone(canvas.toDataURL('image/jpeg', JPEG_QUALITY));
  };
  // Fall back to the original data URL so the counter is always released.
  img.onerror = function () {
    return onDone(dataUrl);
  };
  img.src = dataUrl;
}

var HomeDiagram_HomeDiagram = function (_React$Component) {
  HomeDiagram__inherits(HomeDiagram, _React$Component);

  function HomeDiagram() {
    var _ref;

    var _temp, _this, _ret;

    HomeDiagram__classCallCheck(this, HomeDiagram);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = HomeDiagram__possibleConstructorReturn(this, (_ref = HomeDiagram.__proto__ || Object.getPrototypeOf(HomeDiagram)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'handleFileChange', {
      enumerable: true,
      writable: true,
      value: function value(event) {
        var file = event.target.files && event.target.files[0];
        if (!file) return;

        if (_this.props.onReadStart) _this.props.onReadStart();

        var reader = new FileReader();
        reader.onload = function () {
          resizeAndEncode(reader.result, function (encodedUrl) {
            var images = normalizeImages(_this.props.home_diagram);
            _this.props.onChange([].concat(HomeDiagram__toConsumableArray(images), [{
              file_name: file.name,
              content_type: 'image/jpeg',
              image_data_url: encodedUrl
            }]));
            if (_this.props.onReadEnd) _this.props.onReadEnd();
          });
        };
        reader.onerror = function () {
          if (_this.props.onReadEnd) _this.props.onReadEnd();
        };
        reader.readAsDataURL(file);

        if (_this.fileInput) {
          _this.fileInput.value = '';
        }
      }
    }), Object.defineProperty(_this, 'removeImage', {
      enumerable: true,
      writable: true,
      value: function value(index) {
        var images = normalizeImages(_this.props.home_diagram);
        _this.props.onChange(images.filter(function (_, i) {
          return i !== index;
        }));
      }
    }), _temp), HomeDiagram__possibleConstructorReturn(_this, _ret);
  }

  HomeDiagram__createClass(HomeDiagram, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var images = normalizeImages(this.props.home_diagram);

      return react_default.a.createElement(
        'div',
        { style: { marginTop: '20px' } },
        react_default.a.createElement(
          'h5',
          null,
          'Home Diagram'
        ),
        react_default.a.createElement(
          'h6',
          null,
          'This section should be utilized to upload a drawing of the home diagram with placement of products.'
        ),
        react_default.a.createElement('input', {
          type: 'file',
          accept: 'image/*',
          onChange: this.handleFileChange,
          style: { marginTop: '8px' },
          ref: function ref(input) {
            _this2.fileInput = input;
          }
        }),
        images.map(function (image, index) {
          return react_default.a.createElement(
            'div',
            { key: image.image_data_url, style: { marginTop: '8px' } },
            react_default.a.createElement(
              'div',
              { style: { display: 'flex', alignItems: 'center' } },
              react_default.a.createElement(
                'span',
                { style: { marginRight: '8px' } },
                image.file_name || 'Image attached'
              ),
              react_default.a.createElement(react_toolbox_lib["IconButton"], {
                icon: 'close',
                onClick: function onClick() {
                  return _this2.removeImage(index);
                }
              })
            ),
            react_default.a.createElement('img', {
              src: image.image_data_url,
              alt: 'Home Diagram preview',
              style: { maxWidth: '200px', maxHeight: '200px', marginTop: '4px' }
            })
          );
        })
      );
    }
  }]);

  return HomeDiagram;
}(react_default.a.Component);

HomeDiagram_HomeDiagram.propTypes = {
  home_diagram: prop_types_default.a.oneOfType([prop_types_default.a.array, prop_types_default.a.object]),
  onChange: prop_types_default.a.func.isRequired,
  onReadStart: prop_types_default.a.func,
  onReadEnd: prop_types_default.a.func
};

/* harmony default export */ var components_HomeDiagram = (HomeDiagram_HomeDiagram);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/ifiTemplate/templates/components/ProductTemplate.jsx
var ProductTemplate__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ProductTemplate__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function ProductTemplate__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ProductTemplate__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ProductTemplate__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var ProductTemplate_MAX_DIMENSION = 1600;
var ProductTemplate_JPEG_QUALITY = 0.8;

var ProductTemplate_normalizeImages = function normalizeImages(value) {
  if (Array.isArray(value)) return value;
  if (value && value.image_data_url) return [value];
  return [];
};

// Resize to MAX_DIMENSION on the long edge, re-encode as JPEG to keep wkhtmltopdf reliable.
function ProductTemplate_resizeAndEncode(dataUrl, onDone) {
  var img = new Image();
  img.onload = function () {
    var width = img.width,
        height = img.height;

    var scale = Math.min(1, ProductTemplate_MAX_DIMENSION / Math.max(width, height));
    var canvas = document.createElement('canvas');
    canvas.width = Math.round(width * scale);
    canvas.height = Math.round(height * scale);
    canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
    onDone(canvas.toDataURL('image/jpeg', ProductTemplate_JPEG_QUALITY));
  };
  // Fall back to the original data URL so the counter is always released.
  img.onerror = function () {
    return onDone(dataUrl);
  };
  img.src = dataUrl;
}

var ProductTemplate_ProductTemplate = function (_React$Component) {
  ProductTemplate__inherits(ProductTemplate, _React$Component);

  function ProductTemplate() {
    var _ref;

    var _temp, _this, _ret;

    ProductTemplate__classCallCheck(this, ProductTemplate);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = ProductTemplate__possibleConstructorReturn(this, (_ref = ProductTemplate.__proto__ || Object.getPrototypeOf(ProductTemplate)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'handleFileChange', {
      enumerable: true,
      writable: true,
      value: function value(event) {
        var file = event.target.files && event.target.files[0];
        if (!file) return;

        if (_this.props.onReadStart) _this.props.onReadStart();

        var reader = new FileReader();
        reader.onload = function () {
          ProductTemplate_resizeAndEncode(reader.result, function (encodedUrl) {
            var images = ProductTemplate_normalizeImages(_this.props.product_template);
            _this.props.onChange([].concat(ProductTemplate__toConsumableArray(images), [{
              file_name: file.name,
              content_type: 'image/jpeg',
              image_data_url: encodedUrl
            }]));
            if (_this.props.onReadEnd) _this.props.onReadEnd();
          });
        };
        reader.onerror = function () {
          if (_this.props.onReadEnd) _this.props.onReadEnd();
        };
        reader.readAsDataURL(file);

        if (_this.fileInput) {
          _this.fileInput.value = '';
        }
      }
    }), Object.defineProperty(_this, 'removeImage', {
      enumerable: true,
      writable: true,
      value: function value(index) {
        var images = ProductTemplate_normalizeImages(_this.props.product_template);
        _this.props.onChange(images.filter(function (_, i) {
          return i !== index;
        }));
      }
    }), _temp), ProductTemplate__possibleConstructorReturn(_this, _ret);
  }

  ProductTemplate__createClass(ProductTemplate, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var images = ProductTemplate_normalizeImages(this.props.product_template);

      return react_default.a.createElement(
        'div',
        { style: { marginTop: '20px' } },
        react_default.a.createElement(
          'h5',
          null,
          'Product Template'
        ),
        react_default.a.createElement(
          'h6',
          null,
          'This section should be utilized if needed for highly configurable products, complex measurements, or specification of products.'
        ),
        react_default.a.createElement('input', {
          type: 'file',
          accept: 'image/*',
          onChange: this.handleFileChange,
          style: { marginTop: '8px' },
          ref: function ref(input) {
            _this2.fileInput = input;
          }
        }),
        images.map(function (image, index) {
          return react_default.a.createElement(
            'div',
            { key: image.image_data_url, style: { marginTop: '8px' } },
            react_default.a.createElement(
              'div',
              { style: { display: 'flex', alignItems: 'center' } },
              react_default.a.createElement(
                'span',
                { style: { marginRight: '8px' } },
                image.file_name || 'Image attached'
              ),
              react_default.a.createElement(react_toolbox_lib["IconButton"], {
                icon: 'close',
                onClick: function onClick() {
                  return _this2.removeImage(index);
                }
              })
            ),
            react_default.a.createElement('img', {
              src: image.image_data_url,
              alt: 'Product Template preview',
              style: { maxWidth: '200px', maxHeight: '200px', marginTop: '4px' }
            })
          );
        })
      );
    }
  }]);

  return ProductTemplate;
}(react_default.a.Component);

ProductTemplate_ProductTemplate.propTypes = {
  product_template: prop_types_default.a.oneOfType([prop_types_default.a.array, prop_types_default.a.object]),
  onChange: prop_types_default.a.func.isRequired,
  onReadStart: prop_types_default.a.func,
  onReadEnd: prop_types_default.a.func
};

/* harmony default export */ var components_ProductTemplate = (ProductTemplate_ProductTemplate);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/ifiTemplate/templates/EntryDoorTemplate.jsx
var EntryDoorTemplate__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };














function EntryDoorTemplate(_ref) {
  var data = _ref.data,
      _onChange = _ref.onChange,
      permitRequired = _ref.permitRequired,
      onPermitRequiredChange = _ref.onPermitRequiredChange,
      onReadStart = _ref.onReadStart,
      onReadEnd = _ref.onReadEnd;
  var _data$measures = data.measures,
      measures = _data$measures === undefined ? { entry_doors: [] } : _data$measures,
      _data$arches_transoms = data.arches_transoms_measures,
      arches_transoms_measures = _data$arches_transoms === undefined ? [] : _data$arches_transoms,
      _data$labors_material = data.labors_materials,
      labors_materials = _data$labors_material === undefined ? [] : _data$labors_material,
      _data$comments = data.comments,
      comments = _data$comments === undefined ? '' : _data$comments,
      _data$needs = data.needs,
      needs = _data$needs === undefined ? {} : _data$needs,
      _data$home_diagram = data.home_diagram,
      home_diagram = _data$home_diagram === undefined ? {} : _data$home_diagram,
      _data$product_templat = data.product_template,
      product_template = _data$product_templat === undefined ? {} : _data$product_templat;


  return react_default.a.createElement(
    'div',
    null,
    react_default.a.createElement(
      'h4',
      null,
      'Entry Door Worksheet'
    ),
    react_default.a.createElement(charts_DoorCharts, {
      configurationChart: entry_configuration_default.a,
      handingChart: entry_handing_default.a,
      configAlt: 'Entry Door Configuration Chart',
      handingAlt: 'Entry Door Handing Chart'
    }),
    react_default.a.createElement(measures_EntryDoorMeasures, {
      measures: measures.entry_doors,
      onChange: function onChange(updatedMeasures) {
        return _onChange(EntryDoorTemplate__extends({}, data, { measures: EntryDoorTemplate__extends({}, data.measures, { entry_doors: updatedMeasures }) }));
      }
    }),
    react_default.a.createElement(components_ArchesTransoms, {
      arches_transoms_measures: arches_transoms_measures,
      onChange: function onChange(updatedArchesTransoms) {
        return _onChange(EntryDoorTemplate__extends({}, data, { arches_transoms_measures: updatedArchesTransoms }));
      },
      openingCount: measures.entry_doors.length,
      openingTypeLabel: 'entry door'
    }),
    react_default.a.createElement(components_LaborMaterial, {
      labors_materials: labors_materials,
      onChange: function onChange(updatedLaborsMaterials) {
        return _onChange(EntryDoorTemplate__extends({}, data, { labors_materials: updatedLaborsMaterials }));
      }
    }),
    react_default.a.createElement(components_Comments, {
      comments: comments,
      onChange: function onChange(updatedComments) {
        return _onChange(EntryDoorTemplate__extends({}, data, { comments: updatedComments }));
      }
    }),
    react_default.a.createElement(components_ProjectNeeds, {
      needs: needs,
      onChange: function onChange(updatedNeeds) {
        return _onChange(EntryDoorTemplate__extends({}, data, { needs: updatedNeeds }));
      },
      permitRequired: permitRequired,
      onPermitRequiredChange: onPermitRequiredChange
    }),
    react_default.a.createElement(components_HomeDiagram, {
      home_diagram: home_diagram,
      onChange: function onChange(updatedHomeDiagram) {
        return _onChange(EntryDoorTemplate__extends({}, data, { home_diagram: updatedHomeDiagram }));
      },
      onReadStart: onReadStart,
      onReadEnd: onReadEnd
    }),
    react_default.a.createElement(components_ProductTemplate, {
      product_template: product_template,
      onChange: function onChange(updatedProductTemplate) {
        return _onChange(EntryDoorTemplate__extends({}, data, { product_template: updatedProductTemplate }));
      },
      onReadStart: onReadStart,
      onReadEnd: onReadEnd
    })
  );
}

EntryDoorTemplate.propTypes = {
  data: prop_types_default.a.object.isRequired,
  onChange: prop_types_default.a.func.isRequired,
  permitRequired: prop_types_default.a.bool,
  onPermitRequiredChange: prop_types_default.a.func,
  onReadStart: prop_types_default.a.func,
  onReadEnd: prop_types_default.a.func
};

/* harmony default export */ var templates_EntryDoorTemplate = (EntryDoorTemplate);
// EXTERNAL MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/ifiTemplate/templates/assets/interior_configuration.png
var interior_configuration = __webpack_require__("tdwW");
var interior_configuration_default = /*#__PURE__*/__webpack_require__.n(interior_configuration);

// EXTERNAL MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/ifiTemplate/templates/assets/interior_handing.png
var interior_handing = __webpack_require__("4uL5");
var interior_handing_default = /*#__PURE__*/__webpack_require__.n(interior_handing);

// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/ifiTemplate/templates/components/measures/InteriorDoorMeasures.jsx
var InteriorDoorMeasures__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function InteriorDoorMeasures__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function InteriorDoorMeasures__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var interiorDoorConfigTypes = [{ value: 'Slab Only (S)', label: 'Slab Only (S)' }, { value: 'Pre Hung (PH)', label: 'Pre Hung (PH)' }, { value: 'Bi-Fold (BF)', label: 'Bi-Fold (BF)' }, { value: 'Bypass (BP)', label: 'Bypass (BP)' }, { value: 'Accordion (A)', label: 'Accordion (A)' }];

var InteriorDoorMeasures_slabOrFullFrame = [{ value: 'Slab', label: 'Slab' }, { value: 'Full Frame', label: 'Full Frame' }];

var PRE_HUNG = 'Pre Hung (PH)';
var InteriorDoorMeasures_SLAB_ONLY = 'Slab Only (S)';

// Pre Hung is always full-frame and Slab Only is always a slab; every other
// configuration (Bi-Fold, Barn Door Sliding, Bypass, Accordion) can be either,
// so it still needs the Slab or Full Frame question.
function InteriorDoorMeasures_needsSlabOrFullFrameChoice(configuration) {
  return configuration && configuration !== PRE_HUNG && configuration !== InteriorDoorMeasures_SLAB_ONLY;
}

function InteriorDoorMeasures_isSlab(measure) {
  if (measure.configuration === InteriorDoorMeasures_SLAB_ONLY) return true;
  if (measure.configuration === PRE_HUNG) return false;
  return measure.slab_or_full_frame === 'Slab';
}

function InteriorDoorMeasures(_ref) {
  var measures = _ref.measures,
      onChange = _ref.onChange;

  var handleFieldChange = function handleFieldChange(idx, field, value) {
    var updated = measures.map(function (m, i) {
      return i === idx ? InteriorDoorMeasures__extends({}, m, InteriorDoorMeasures__defineProperty({}, field, value)) : m;
    });
    onChange(updated);
  };

  var handleConfigurationChange = function handleConfigurationChange(idx, value) {
    var updated = measures.map(function (m, i) {
      if (i !== idx) return m;
      var next = InteriorDoorMeasures__extends({}, m, { configuration: value });
      if (!InteriorDoorMeasures_needsSlabOrFullFrameChoice(value)) next.slab_or_full_frame = '';
      if (!InteriorDoorMeasures_isSlab(next)) next.slab_thickness = '';
      return next;
    });
    onChange(updated);
  };

  var handleSlabOrFullFrameChange = function handleSlabOrFullFrameChange(idx, value) {
    var updated = measures.map(function (m, i) {
      if (i !== idx) return m;
      var next = InteriorDoorMeasures__extends({}, m, { slab_or_full_frame: value });
      if (!InteriorDoorMeasures_isSlab(next)) next.slab_thickness = '';
      return next;
    });
    onChange(updated);
  };

  var handleNestedChange = function handleNestedChange(idx, group, subfield, value) {
    var updated = measures.map(function (m, i) {
      if (i === idx) {
        return InteriorDoorMeasures__extends({}, m, InteriorDoorMeasures__defineProperty({}, group, InteriorDoorMeasures__extends({}, m[group], InteriorDoorMeasures__defineProperty({}, subfield, value))));
      }
      return m;
    });
    onChange(updated);
  };

  var addRow = function addRow() {
    onChange([].concat(InteriorDoorMeasures__toConsumableArray(measures), [{
      openingNumber: '',
      location: '',
      configuration: '',
      slab_or_full_frame: '',
      slab_thickness: '',
      jamb_size: '',
      unitSize: { width: '', height: '' },
      finishedOpening: { width: '', height: '' },
      handing: '',
      notes: ''
    }]));
  };

  var removeRow = function removeRow(idx) {
    onChange(measures.filter(function (_, i) {
      return i !== idx;
    }));
  };

  return react_default.a.createElement(
    'div',
    null,
    react_default.a.createElement(
      'h6',
      null,
      'Interior Doors Measured'
    ),
    measures.map(function (measure, idx) {
      return react_default.a.createElement(
        'div',
        { key: measure.openingNumber || 'interiorDoor-' + idx, style: { border: '1px solid #eee', marginBottom: 10, padding: 10 } },
        react_default.a.createElement(
          'div',
          { className: TemplateStyling_default.a.container },
          react_default.a.createElement(
            'strong',
            null,
            'ALL MEASURES MUST BE IN INCHES'
          ),
          react_default.a.createElement(
            'strong',
            null,
            'Opening #',
            idx + 1
          )
        ),
        react_default.a.createElement(react_toolbox_lib["Input"], { label: 'Location', value: measure.location, onChange: function onChange(v) {
            return handleFieldChange(idx, 'location', v);
          } }),
        react_default.a.createElement(react_toolbox_lib["Dropdown"], { label: 'Configuration', source: interiorDoorConfigTypes, value: measure.configuration, onChange: function onChange(v) {
            return handleConfigurationChange(idx, v);
          } }),
        InteriorDoorMeasures_needsSlabOrFullFrameChoice(measure.configuration) && react_default.a.createElement(react_toolbox_lib["Dropdown"], { label: 'Slab or Full Frame', source: InteriorDoorMeasures_slabOrFullFrame, value: measure.slab_or_full_frame, onChange: function onChange(v) {
            return handleSlabOrFullFrameChange(idx, v);
          } }),
        InteriorDoorMeasures_isSlab(measure) && react_default.a.createElement(react_toolbox_lib["Input"], { label: 'Slab Thickness', hint: 'e.g. 34 1/2', value: measure.slab_thickness, onChange: function onChange(v) {
            return handleFieldChange(idx, 'slab_thickness', v);
          } }),
        react_default.a.createElement(react_toolbox_lib["Input"], { label: 'Jamb Size', hint: 'e.g. 34 1/2', value: measure.jamb_size, onChange: function onChange(v) {
            return handleFieldChange(idx, 'jamb_size', v);
          } }),
        react_default.a.createElement(
          'strong',
          null,
          'UNIT SIZE'
        ),
        react_default.a.createElement(react_toolbox_lib["Input"], { label: 'Width', hint: 'e.g. 34 1/2', value: measure.unitSize.width, onChange: function onChange(v) {
            return handleNestedChange(idx, 'unitSize', 'width', v);
          } }),
        react_default.a.createElement(react_toolbox_lib["Input"], { label: 'Height', hint: 'e.g. 34 1/2', value: measure.unitSize.height, onChange: function onChange(v) {
            return handleNestedChange(idx, 'unitSize', 'height', v);
          } }),
        react_default.a.createElement(
          'strong',
          null,
          'FINISHED OPENING'
        ),
        react_default.a.createElement(react_toolbox_lib["Input"], { label: 'Width', hint: 'e.g. 34 1/2', value: measure.finishedOpening.width, onChange: function onChange(v) {
            return handleNestedChange(idx, 'finishedOpening', 'width', v);
          } }),
        react_default.a.createElement(react_toolbox_lib["Input"], { label: 'Height', hint: 'e.g. 34 1/2', value: measure.finishedOpening.height, onChange: function onChange(v) {
            return handleNestedChange(idx, 'finishedOpening', 'height', v);
          } }),
        react_default.a.createElement(
          'strong',
          null,
          'OTHER'
        ),
        react_default.a.createElement(react_toolbox_lib["Input"], { label: 'Handing', value: measure.handing, onChange: function onChange(v) {
            return handleFieldChange(idx, 'handing', v);
          } }),
        react_default.a.createElement(components_TextArea, {
          label: 'Notes',
          value: measure.notes || '',
          onChange: function onChange(e) {
            return handleFieldChange(idx, 'notes', e.target.value);
          }
        }),
        react_default.a.createElement(react_toolbox_lib["Button"], { className: TemplateStyling_default.a.removeButton, label: 'Remove', onClick: function onClick() {
            return removeRow(idx);
          } })
      );
    }),
    react_default.a.createElement(react_toolbox_lib["Button"], { className: TemplateStyling_default.a.button, label: 'Add Interior Door', onClick: addRow })
  );
}

InteriorDoorMeasures.propTypes = {
  measures: prop_types_default.a.arrayOf(prop_types_default.a.shape({
    openingNumber: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]),
    location: prop_types_default.a.string,
    configuration: prop_types_default.a.string,
    slab_or_full_frame: prop_types_default.a.string,
    slab_thickness: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]),
    jamb_size: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]),
    unitSize: prop_types_default.a.shape({
      width: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]),
      height: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number])
    }),
    finishedOpening: prop_types_default.a.shape({
      width: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]),
      height: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number])
    }),
    handing: prop_types_default.a.string,
    notes: prop_types_default.a.string
  })).isRequired,
  onChange: prop_types_default.a.func.isRequired
};

/* harmony default export */ var measures_InteriorDoorMeasures = (InteriorDoorMeasures);

function validateInteriorDoorMeasures(measures) {
  var errors = {};
  measures.forEach(function (item, idx) {
    if (InteriorDoorMeasures_needsSlabOrFullFrameChoice(item.configuration) && !item.slab_or_full_frame) {
      if (!errors[idx]) errors[idx] = {};
      errors[idx].slab_or_full_frame = ['slab_or_full_frame is required for this configuration.'];
    }
    if (InteriorDoorMeasures_isSlab(item) && (item.slab_thickness === undefined || item.slab_thickness === '')) {
      if (!errors[idx]) errors[idx] = {};
      errors[idx].slab_thickness = ['slab_thickness is required for a slab configuration.'];
    }
    var measurementFields = ['slab_thickness', 'jamb_size'];
    measurementFields.forEach(function (field) {
      var value = item[field];
      if (value !== undefined && value !== '' && isNaN(parseMeasurement(value))) {
        if (!errors[idx]) errors[idx] = {};
        errors[idx][field] = [field + ' must be a number or fraction.'];
      }
    });
    if (item.unitSize) {
      ['width', 'height'].forEach(function (subfield) {
        var value = item.unitSize[subfield];
        if (value === undefined || value === '') return;
        if (isNaN(parseMeasurement(value))) {
          if (!errors[idx]) errors[idx] = {};
          errors[idx]['unitSize.' + subfield] = ['unitSize.' + subfield + ' must be a number or fraction.'];
        } else if (hasDecimalNotation(value)) {
          if (!errors[idx]) errors[idx] = {};
          errors[idx]['unitSize.' + subfield] = ['unitSize.' + subfield + ' must not use decimal notation; use a fraction instead (e.g. 34 1/2).'];
        }
      });
    }
    if (item.finishedOpening) {
      ['width', 'height'].forEach(function (subfield) {
        var value = item.finishedOpening[subfield];
        if (value === undefined || value === '') return;
        if (isNaN(parseMeasurement(value))) {
          if (!errors[idx]) errors[idx] = {};
          errors[idx]['finishedOpening.' + subfield] = ['finishedOpening.' + subfield + ' must be a number or fraction.'];
        } else if (hasDecimalNotation(value)) {
          if (!errors[idx]) errors[idx] = {};
          errors[idx]['finishedOpening.' + subfield] = ['finishedOpening.' + subfield + ' must not use decimal notation; use a fraction instead (e.g. 34 1/2).'];
        }
      });
    }
  });
  if (Object.keys(errors).length > 0) {
    errors.interiorDoorMeasures = ['Please ensure all numeric fields are valid numbers.'];
  }
  return errors;
}
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/ifiTemplate/templates/components/measures/BarnDoorMeasures.jsx
var BarnDoorMeasures__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function BarnDoorMeasures__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function BarnDoorMeasures__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var singleOrDouble = [{ value: 'Single', label: 'Single' }, { value: 'Double', label: 'Double' }];

function BarnDoorMeasures(_ref) {
  var measures = _ref.measures,
      onChange = _ref.onChange;

  var handleFieldChange = function handleFieldChange(idx, field, value) {
    var updated = measures.map(function (m, i) {
      return i === idx ? BarnDoorMeasures__extends({}, m, BarnDoorMeasures__defineProperty({}, field, value)) : m;
    });
    onChange(updated);
  };

  var handleNestedChange = function handleNestedChange(idx, group, subfield, value) {
    var updated = measures.map(function (m, i) {
      if (i === idx) {
        return BarnDoorMeasures__extends({}, m, BarnDoorMeasures__defineProperty({}, group, BarnDoorMeasures__extends({}, m[group], BarnDoorMeasures__defineProperty({}, subfield, value))));
      }
      return m;
    });
    onChange(updated);
  };

  var addRow = function addRow() {
    onChange([].concat(BarnDoorMeasures__toConsumableArray(measures), [{
      openingNumber: '',
      location: '',
      singleOrDouble: '',
      finishedOpening: { width: '', height: '' },
      hardwareTrack: { width: '', height: '' },
      handing: '',
      notes: ''
    }]));
  };

  var removeRow = function removeRow(idx) {
    onChange(measures.filter(function (_, i) {
      return i !== idx;
    }));
  };

  return react_default.a.createElement(
    'div',
    null,
    react_default.a.createElement(
      'h6',
      null,
      'Barn Doors Measured'
    ),
    measures.map(function (measure, idx) {
      return react_default.a.createElement(
        'div',
        { key: measure.openingNumber || 'barnDoor-' + idx, style: { border: '1px solid #eee', marginBottom: 10, padding: 10 } },
        react_default.a.createElement(
          'div',
          { className: TemplateStyling_default.a.container },
          react_default.a.createElement(
            'strong',
            null,
            'ALL MEASURES MUST BE IN INCHES'
          ),
          react_default.a.createElement(
            'strong',
            null,
            'Opening #',
            idx + 1
          )
        ),
        react_default.a.createElement(react_toolbox_lib["Input"], { label: 'Location', value: measure.location, onChange: function onChange(v) {
            return handleFieldChange(idx, 'location', v);
          } }),
        react_default.a.createElement(react_toolbox_lib["Dropdown"], { label: 'Single or Double', source: singleOrDouble, value: measure.singleOrDouble, onChange: function onChange(v) {
            return handleFieldChange(idx, 'singleOrDouble', v);
          } }),
        react_default.a.createElement(
          'strong',
          null,
          'FINISHED OPENING'
        ),
        react_default.a.createElement(react_toolbox_lib["Input"], { label: 'Width', hint: 'e.g. 34 1/2', value: measure.finishedOpening.width, onChange: function onChange(v) {
            return handleNestedChange(idx, 'finishedOpening', 'width', v);
          } }),
        react_default.a.createElement(react_toolbox_lib["Input"], { label: 'Height', hint: 'e.g. 34 1/2', value: measure.finishedOpening.height, onChange: function onChange(v) {
            return handleNestedChange(idx, 'finishedOpening', 'height', v);
          } }),
        react_default.a.createElement(
          'strong',
          null,
          'HARDWARE TRACK'
        ),
        react_default.a.createElement(react_toolbox_lib["Input"], { label: 'Width', hint: 'e.g. 34 1/2', value: measure.hardwareTrack.width, onChange: function onChange(v) {
            return handleNestedChange(idx, 'hardwareTrack', 'width', v);
          } }),
        react_default.a.createElement(react_toolbox_lib["Input"], { label: 'Height', hint: 'e.g. 34 1/2', value: measure.hardwareTrack.height, onChange: function onChange(v) {
            return handleNestedChange(idx, 'hardwareTrack', 'height', v);
          } }),
        react_default.a.createElement(components_TextArea, {
          label: 'Notes',
          value: measure.notes || '',
          onChange: function onChange(e) {
            return handleFieldChange(idx, 'notes', e.target.value);
          }
        }),
        react_default.a.createElement(react_toolbox_lib["Button"], { className: TemplateStyling_default.a.removeButton, label: 'Remove', onClick: function onClick() {
            return removeRow(idx);
          } })
      );
    }),
    react_default.a.createElement(react_toolbox_lib["Button"], { className: TemplateStyling_default.a.button, label: 'Add Barn Door', onClick: addRow })
  );
}

BarnDoorMeasures.propTypes = {
  measures: prop_types_default.a.arrayOf(prop_types_default.a.shape({
    openingNumber: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]),
    location: prop_types_default.a.string,
    singleOrDouble: prop_types_default.a.string,
    finishedOpening: prop_types_default.a.shape({
      width: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]),
      height: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number])
    }),
    hardwareTrack: prop_types_default.a.shape({
      width: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]),
      height: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number])
    }),
    handing: prop_types_default.a.string,
    notes: prop_types_default.a.string
  })).isRequired,
  onChange: prop_types_default.a.func.isRequired
};

/* harmony default export */ var measures_BarnDoorMeasures = (BarnDoorMeasures);

function validateBarnDoorMeasures(measures) {
  var errors = {};
  measures.forEach(function (item, idx) {
    if (item.finishedOpening) {
      ['width', 'height'].forEach(function (subfield) {
        var value = item.finishedOpening[subfield];
        if (value === undefined || value === '') return;
        if (isNaN(parseMeasurement(value))) {
          if (!errors[idx]) errors[idx] = {};
          errors[idx]['finishedOpening.' + subfield] = ['finishedOpening.' + subfield + ' must be a number or fraction.'];
        } else if (hasDecimalNotation(value)) {
          if (!errors[idx]) errors[idx] = {};
          errors[idx]['finishedOpening.' + subfield] = ['finishedOpening.' + subfield + ' must not use decimal notation; use a fraction instead (e.g. 34 1/2).'];
        }
      });
    }
    if (item.hardwareTrack) {
      ['width', 'height'].forEach(function (subfield) {
        var value = item.hardwareTrack[subfield];
        if (value === undefined || value === '') return;
        if (isNaN(parseMeasurement(value))) {
          if (!errors[idx]) errors[idx] = {};
          errors[idx]['hardwareTrack.' + subfield] = ['hardwareTrack.' + subfield + ' must be a number or fraction.'];
        } else if (hasDecimalNotation(value)) {
          if (!errors[idx]) errors[idx] = {};
          errors[idx]['hardwareTrack.' + subfield] = ['hardwareTrack.' + subfield + ' must not use decimal notation; use a fraction instead (e.g. 34 1/2).'];
        }
      });
    }
  });
  if (Object.keys(errors).length > 0) {
    errors.barnDoorMeasures = ['Please ensure all numeric fields are valid numbers.'];
  }
  return errors;
}
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/ifiTemplate/templates/InteriorDoorTemplate.jsx
var InteriorDoorTemplate__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };














function InteriorDoorTemplate(_ref) {
  var data = _ref.data,
      _onChange = _ref.onChange,
      permitRequired = _ref.permitRequired,
      onPermitRequiredChange = _ref.onPermitRequiredChange,
      onReadStart = _ref.onReadStart,
      onReadEnd = _ref.onReadEnd;
  var _data$measures = data.measures,
      measures = _data$measures === undefined ? { interior_doors: [], barn_doors: [] } : _data$measures,
      _data$needs = data.needs,
      needs = _data$needs === undefined ? {} : _data$needs,
      _data$labors_material = data.labors_materials,
      labors_materials = _data$labors_material === undefined ? [] : _data$labors_material,
      _data$comments = data.comments,
      comments = _data$comments === undefined ? '' : _data$comments,
      _data$home_diagram = data.home_diagram,
      home_diagram = _data$home_diagram === undefined ? {} : _data$home_diagram,
      _data$product_templat = data.product_template,
      product_template = _data$product_templat === undefined ? {} : _data$product_templat;


  var interior_doors = measures.interior_doors || [];
  var barn_doors = measures.barn_doors || [];

  return react_default.a.createElement(
    'div',
    null,
    react_default.a.createElement(
      'h4',
      null,
      'Interior Door Worksheet'
    ),
    react_default.a.createElement(charts_DoorCharts, {
      configurationChart: interior_configuration_default.a,
      handingChart: interior_handing_default.a,
      configAlt: 'Interior Door Configuration Chart',
      handingAlt: 'Interior Door Handing Chart'
    }),
    react_default.a.createElement(measures_InteriorDoorMeasures, {
      measures: interior_doors,
      onChange: function onChange(updatedMeasures) {
        return _onChange(InteriorDoorTemplate__extends({}, data, { measures: InteriorDoorTemplate__extends({}, data.measures, { interior_doors: updatedMeasures }) }));
      }
    }),
    react_default.a.createElement(measures_BarnDoorMeasures, {
      measures: barn_doors,
      onChange: function onChange(updatedMeasures) {
        return _onChange(InteriorDoorTemplate__extends({}, data, { measures: InteriorDoorTemplate__extends({}, data.measures, { barn_doors: updatedMeasures }) }));
      }
    }),
    react_default.a.createElement(components_LaborMaterial, {
      labors_materials: labors_materials,
      onChange: function onChange(updatedLaborsMaterials) {
        return _onChange(InteriorDoorTemplate__extends({}, data, { labors_materials: updatedLaborsMaterials }));
      }
    }),
    react_default.a.createElement(components_Comments, {
      comments: comments,
      onChange: function onChange(updatedComments) {
        return _onChange(InteriorDoorTemplate__extends({}, data, { comments: updatedComments }));
      }
    }),
    react_default.a.createElement(components_ProjectNeeds, {
      needs: needs,
      onChange: function onChange(updatedNeeds) {
        return _onChange(InteriorDoorTemplate__extends({}, data, { needs: updatedNeeds }));
      },
      permitRequired: permitRequired,
      onPermitRequiredChange: onPermitRequiredChange
    }),
    react_default.a.createElement(components_HomeDiagram, {
      home_diagram: home_diagram,
      onChange: function onChange(updatedHomeDiagram) {
        return _onChange(InteriorDoorTemplate__extends({}, data, { home_diagram: updatedHomeDiagram }));
      },
      onReadStart: onReadStart,
      onReadEnd: onReadEnd
    }),
    react_default.a.createElement(components_ProductTemplate, {
      product_template: product_template,
      onChange: function onChange(updatedProductTemplate) {
        return _onChange(InteriorDoorTemplate__extends({}, data, { product_template: updatedProductTemplate }));
      },
      onReadStart: onReadStart,
      onReadEnd: onReadEnd
    })
  );
}

InteriorDoorTemplate.propTypes = {
  data: prop_types_default.a.object.isRequired,
  onChange: prop_types_default.a.func.isRequired,
  permitRequired: prop_types_default.a.bool,
  onPermitRequiredChange: prop_types_default.a.func,
  onReadStart: prop_types_default.a.func,
  onReadEnd: prop_types_default.a.func
};

/* harmony default export */ var templates_InteriorDoorTemplate = (InteriorDoorTemplate);
// EXTERNAL MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/ifiTemplate/templates/assets/storm_configuration.png
var storm_configuration = __webpack_require__("km9F");
var storm_configuration_default = /*#__PURE__*/__webpack_require__.n(storm_configuration);

// EXTERNAL MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/ifiTemplate/templates/assets/storm_handing.png
var storm_handing = __webpack_require__("ZdED");
var storm_handing_default = /*#__PURE__*/__webpack_require__.n(storm_handing);

// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/ifiTemplate/templates/components/measures/StormDoorMeasures.jsx
var StormDoorMeasures__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function StormDoorMeasures__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function StormDoorMeasures__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var stormDoorConfigTypes = [{ value: 'Single', label: 'Single' }, { value: 'Double', label: 'Double' }];

var sizing = [{ value: 'Standard', label: 'Standard' }, { value: 'Custom', label: 'Custom' }];

function StormDoorMeasures(_ref) {
  var measures = _ref.measures,
      onChange = _ref.onChange;

  var handleFieldChange = function handleFieldChange(idx, field, value) {
    var updated = measures.map(function (m, i) {
      return i === idx ? StormDoorMeasures__extends({}, m, StormDoorMeasures__defineProperty({}, field, value)) : m;
    });
    onChange(updated);
  };

  var handleNestedChange = function handleNestedChange(idx, group, subfield, value) {
    var updated = measures.map(function (m, i) {
      if (i === idx) {
        return StormDoorMeasures__extends({}, m, StormDoorMeasures__defineProperty({}, group, StormDoorMeasures__extends({}, m[group], StormDoorMeasures__defineProperty({}, subfield, value))));
      }
      return m;
    });
    onChange(updated);
  };

  var addRow = function addRow() {
    onChange([].concat(StormDoorMeasures__toConsumableArray(measures), [{
      openingNumber: '',
      configuration: '',
      opening: { width: '', height: '' },
      sizing: '',
      handing: '',
      notes: ''
    }]));
  };

  var removeRow = function removeRow(idx) {
    onChange(measures.filter(function (_, i) {
      return i !== idx;
    }));
  };

  return react_default.a.createElement(
    'div',
    null,
    react_default.a.createElement(
      'h6',
      null,
      'Storm Doors Measured'
    ),
    measures.map(function (measure, idx) {
      return react_default.a.createElement(
        'div',
        { key: measure.openingNumber || 'stormDoor-' + idx, style: { border: '1px solid #eee', marginBottom: 10, padding: 10 } },
        react_default.a.createElement(
          'div',
          { className: TemplateStyling_default.a.container },
          react_default.a.createElement(
            'strong',
            null,
            'ALL MEASURES MUST BE IN INCHES'
          ),
          react_default.a.createElement(
            'strong',
            null,
            'Opening #',
            idx + 1
          )
        ),
        react_default.a.createElement(react_toolbox_lib["Dropdown"], { label: 'Configuration', source: stormDoorConfigTypes, value: measure.configuration, onChange: function onChange(v) {
            return handleFieldChange(idx, 'configuration', v);
          } }),
        react_default.a.createElement(
          'strong',
          null,
          'MEASUREMENT'
        ),
        react_default.a.createElement(react_toolbox_lib["Input"], { label: 'Width', hint: 'e.g. 34 1/2', value: measure.opening.width, onChange: function onChange(v) {
            return handleNestedChange(idx, 'opening', 'width', v);
          } }),
        react_default.a.createElement(react_toolbox_lib["Input"], { label: 'Height', hint: 'e.g. 34 1/2', value: measure.opening.height, onChange: function onChange(v) {
            return handleNestedChange(idx, 'opening', 'height', v);
          } }),
        react_default.a.createElement(
          'strong',
          null,
          'SIZING'
        ),
        react_default.a.createElement(react_toolbox_lib["Dropdown"], { label: 'Standard / Custom', source: sizing, value: measure.sizing, onChange: function onChange(v) {
            return handleFieldChange(idx, 'sizing', v);
          } }),
        react_default.a.createElement(
          'strong',
          null,
          'OTHER'
        ),
        react_default.a.createElement(react_toolbox_lib["Input"], { label: 'Handing', value: measure.handing, onChange: function onChange(v) {
            return handleFieldChange(idx, 'handing', v);
          } }),
        react_default.a.createElement(components_TextArea, {
          label: 'Notes',
          value: measure.notes || '',
          onChange: function onChange(e) {
            return handleFieldChange(idx, 'notes', e.target.value);
          }
        }),
        react_default.a.createElement(react_toolbox_lib["Button"], { className: TemplateStyling_default.a.removeButton, label: 'Remove', onClick: function onClick() {
            return removeRow(idx);
          } })
      );
    }),
    react_default.a.createElement(react_toolbox_lib["Button"], { className: TemplateStyling_default.a.button, label: 'Add Storm Door', onClick: addRow })
  );
}

StormDoorMeasures.propTypes = {
  measures: prop_types_default.a.arrayOf(prop_types_default.a.shape({
    openingNumber: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]),
    configuration: prop_types_default.a.string,
    opening: prop_types_default.a.shape({
      width: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]),
      height: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number])
    }),
    sizing: prop_types_default.a.string,
    handing: prop_types_default.a.string,
    notes: prop_types_default.a.string
  })).isRequired,
  onChange: prop_types_default.a.func.isRequired
};

/* harmony default export */ var measures_StormDoorMeasures = (StormDoorMeasures);

function validateStormDoorMeasures(measures) {
  var errors = {};
  measures.forEach(function (item, idx) {
    if (item.opening) {
      ['width', 'height'].forEach(function (subfield) {
        var value = item.opening[subfield];
        if (value === undefined || value === '') return;
        if (isNaN(parseMeasurement(value))) {
          if (!errors[idx]) errors[idx] = {};
          errors[idx]['opening.' + subfield] = ['opening.' + subfield + ' must be a number or fraction.'];
        } else if (hasDecimalNotation(value)) {
          if (!errors[idx]) errors[idx] = {};
          errors[idx]['opening.' + subfield] = ['opening.' + subfield + ' must not use decimal notation; use a fraction instead (e.g. 34 1/2).'];
        }
      });
    }
  });
  if (Object.keys(errors).length > 0) {
    errors.stormDoorMeasures = ['Please ensure all numeric fields are valid numbers.'];
  }
  return errors;
}
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/ifiTemplate/templates/StormDoorTemplate.jsx
var StormDoorTemplate__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };













function StormDoorTemplate(_ref) {
  var data = _ref.data,
      _onChange = _ref.onChange,
      permitRequired = _ref.permitRequired,
      onPermitRequiredChange = _ref.onPermitRequiredChange,
      onReadStart = _ref.onReadStart,
      onReadEnd = _ref.onReadEnd;
  var _data$measures = data.measures,
      measures = _data$measures === undefined ? { storm_doors: [] } : _data$measures,
      _data$labors_material = data.labors_materials,
      labors_materials = _data$labors_material === undefined ? [] : _data$labors_material,
      _data$comments = data.comments,
      comments = _data$comments === undefined ? '' : _data$comments,
      _data$needs = data.needs,
      needs = _data$needs === undefined ? {} : _data$needs,
      _data$home_diagram = data.home_diagram,
      home_diagram = _data$home_diagram === undefined ? {} : _data$home_diagram,
      _data$product_templat = data.product_template,
      product_template = _data$product_templat === undefined ? {} : _data$product_templat;


  return react_default.a.createElement(
    'div',
    null,
    react_default.a.createElement(
      'h4',
      null,
      'Storm Door Worksheet'
    ),
    react_default.a.createElement(charts_DoorCharts, {
      configurationChart: storm_configuration_default.a,
      handingChart: storm_handing_default.a,
      configAlt: 'Storm Door Configuration Chart',
      handingAlt: 'Storm Door Handing Chart'
    }),
    react_default.a.createElement(measures_StormDoorMeasures, {
      measures: measures.storm_doors,
      onChange: function onChange(updatedMeasures) {
        return _onChange(StormDoorTemplate__extends({}, data, { measures: StormDoorTemplate__extends({}, data.measures, { storm_doors: updatedMeasures }) }));
      }
    }),
    react_default.a.createElement(components_LaborMaterial, {
      labors_materials: labors_materials,
      onChange: function onChange(updatedLaborsMaterials) {
        return _onChange(StormDoorTemplate__extends({}, data, { labors_materials: updatedLaborsMaterials }));
      }
    }),
    react_default.a.createElement(components_Comments, {
      comments: comments,
      onChange: function onChange(updatedComments) {
        return _onChange(StormDoorTemplate__extends({}, data, { comments: updatedComments }));
      }
    }),
    react_default.a.createElement(components_ProjectNeeds, {
      needs: needs,
      onChange: function onChange(updatedNeeds) {
        return _onChange(StormDoorTemplate__extends({}, data, { needs: updatedNeeds }));
      },
      permitRequired: permitRequired,
      onPermitRequiredChange: onPermitRequiredChange
    }),
    react_default.a.createElement(components_HomeDiagram, {
      home_diagram: home_diagram,
      onChange: function onChange(updatedHomeDiagram) {
        return _onChange(StormDoorTemplate__extends({}, data, { home_diagram: updatedHomeDiagram }));
      },
      onReadStart: onReadStart,
      onReadEnd: onReadEnd
    }),
    react_default.a.createElement(components_ProductTemplate, {
      product_template: product_template,
      onChange: function onChange(updatedProductTemplate) {
        return _onChange(StormDoorTemplate__extends({}, data, { product_template: updatedProductTemplate }));
      },
      onReadStart: onReadStart,
      onReadEnd: onReadEnd
    })
  );
}

StormDoorTemplate.propTypes = {
  data: prop_types_default.a.object.isRequired,
  onChange: prop_types_default.a.func.isRequired,
  permitRequired: prop_types_default.a.bool,
  onPermitRequiredChange: prop_types_default.a.func,
  onReadStart: prop_types_default.a.func,
  onReadEnd: prop_types_default.a.func
};

/* harmony default export */ var templates_StormDoorTemplate = (StormDoorTemplate);
// EXTERNAL MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/ifiTemplate/templates/assets/window_configuration.png
var window_configuration = __webpack_require__("KT9c");
var window_configuration_default = /*#__PURE__*/__webpack_require__.n(window_configuration);

// EXTERNAL MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/ifiTemplate/templates/assets/window_frames.png
var window_frames = __webpack_require__("yJDZ");
var window_frames_default = /*#__PURE__*/__webpack_require__.n(window_frames);

// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/ifiTemplate/templates/components/charts/WindowCharts.jsx




function WindowCharts() {
  return react_default.a.createElement(
    'div',
    null,
    react_default.a.createElement(
      'div',
      { style: { marginBottom: 16 } },
      react_default.a.createElement(
        'h6',
        null,
        'Configuration Chart'
      ),
      react_default.a.createElement('img', {
        src: window_configuration_default.a,
        alt: 'Window Configuration Chart',
        style: { maxWidth: '100%', marginBottom: 8 }
      })
    ),
    react_default.a.createElement(
      'div',
      { style: { marginBottom: 16 } },
      react_default.a.createElement(
        'h6',
        null,
        'Frame Type'
      ),
      react_default.a.createElement('img', {
        src: window_frames_default.a,
        alt: 'Window Frame Types',
        style: { maxWidth: '100%', marginBottom: 8 }
      })
    )
  );
}

/* harmony default export */ var charts_WindowCharts = (WindowCharts);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/ifiTemplate/templates/components/measures/WindowMeasures.jsx
var WindowMeasures__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function WindowMeasures__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function WindowMeasures__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var windowConfigTypes = [{ value: 'Single Hung', label: 'Single Hung' }, { value: 'Double Hung', label: 'Double Hung' }, { value: 'Sliding', label: 'Sliding' }, { value: 'Casement', label: 'Casement' }, { value: 'Awning', label: 'Awning' }, { value: 'Special Shapes', label: 'Special Shapes' }, { value: 'Picture', label: 'Picture' }, { value: 'Transom', label: 'Transom' }, { value: 'Combination', label: 'Combination' }];

var windowFrameTypes = [{ value: 'Block', label: 'Block Frame' }, { value: 'Nailing Fin', label: 'Nailing Fin Frame' }, { value: 'Nailing Fin w/J-Channel', label: 'Nailing Fin w/J-Channel Frame' }, { value: 'Flush Flange', label: 'Flush Flange Frame' }];

function WindowMeasures(_ref) {
  var measures = _ref.measures,
      onChange = _ref.onChange;

  var handleFieldChange = function handleFieldChange(idx, field, value) {
    var updated = measures.map(function (m, i) {
      return i === idx ? WindowMeasures__extends({}, m, WindowMeasures__defineProperty({}, field, value)) : m;
    });
    onChange(updated);
  };

  var handleNestedChange = function handleNestedChange(idx, group, subfield, value) {
    var updated = measures.map(function (m, i) {
      if (i === idx) {
        return WindowMeasures__extends({}, m, WindowMeasures__defineProperty({}, group, WindowMeasures__extends({}, m[group], WindowMeasures__defineProperty({}, subfield, value))));
      }
      return m;
    });
    onChange(updated);
  };

  var handleCheckboxChange = function handleCheckboxChange(idx, field, value) {
    handleFieldChange(idx, field, value);
  };

  var addRow = function addRow() {
    onChange([].concat(WindowMeasures__toConsumableArray(measures), [{
      openingNumber: '',
      location: '',
      qty: '',
      configuration: '',
      frameType: '',
      frameDepth: '',
      unitSize: { width: '', height: '' },
      roughOpening: { width: '', height: '' },
      temp: false,
      obsc: false,
      trans: false,
      notes: ''
    }]));
  };

  var removeRow = function removeRow(idx) {
    onChange(measures.filter(function (_, i) {
      return i !== idx;
    }));
  };

  return react_default.a.createElement(
    'div',
    null,
    react_default.a.createElement(
      'h6',
      null,
      'Windows Measured'
    ),
    measures.map(function (measure, idx) {
      return react_default.a.createElement(
        'div',
        { key: measure.openingNumber || 'window-' + idx, style: { border: '1px solid #eee', marginBottom: 10, padding: 10 } },
        react_default.a.createElement(
          'div',
          { className: TemplateStyling_default.a.container },
          react_default.a.createElement(
            'strong',
            null,
            'ALL MEASURES MUST BE IN INCHES'
          ),
          react_default.a.createElement(
            'strong',
            null,
            'Opening #',
            idx + 1
          )
        ),
        react_default.a.createElement(react_toolbox_lib["Input"], { label: 'Location', value: measure.location, onChange: function onChange(v) {
            return handleFieldChange(idx, 'location', v);
          } }),
        react_default.a.createElement(react_toolbox_lib["Input"], { label: 'Qty', type: 'number', value: measure.qty, onChange: function onChange(v) {
            return handleFieldChange(idx, 'qty', v);
          } }),
        react_default.a.createElement(react_toolbox_lib["Dropdown"], { label: 'Configuration', source: windowConfigTypes, value: measure.configuration, onChange: function onChange(v) {
            return handleFieldChange(idx, 'configuration', v);
          } }),
        react_default.a.createElement(react_toolbox_lib["Dropdown"], { label: 'Frame Type', source: windowFrameTypes, value: measure.frameType, onChange: function onChange(v) {
            return handleFieldChange(idx, 'frameType', v);
          } }),
        react_default.a.createElement(react_toolbox_lib["Input"], { label: 'Frame Depth', hint: 'e.g. 34 1/2', value: measure.frameDepth, onChange: function onChange(v) {
            return handleFieldChange(idx, 'frameDepth', v);
          } }),
        react_default.a.createElement(
          'strong',
          null,
          'UNIT SIZE'
        ),
        react_default.a.createElement(react_toolbox_lib["Input"], { label: 'Width', hint: 'e.g. 34 1/2', value: measure.unitSize.width, onChange: function onChange(v) {
            return handleNestedChange(idx, 'unitSize', 'width', v);
          } }),
        react_default.a.createElement(react_toolbox_lib["Input"], { label: 'Height', hint: 'e.g. 34 1/2', value: measure.unitSize.height, onChange: function onChange(v) {
            return handleNestedChange(idx, 'unitSize', 'height', v);
          } }),
        react_default.a.createElement(
          'strong',
          null,
          'ROUGH OPENING'
        ),
        react_default.a.createElement(react_toolbox_lib["Input"], { label: 'Width', hint: 'e.g. 34 1/2', value: measure.roughOpening.width, onChange: function onChange(v) {
            return handleNestedChange(idx, 'roughOpening', 'width', v);
          } }),
        react_default.a.createElement(react_toolbox_lib["Input"], { label: 'Height', hint: 'e.g. 34 1/2', value: measure.roughOpening.height, onChange: function onChange(v) {
            return handleNestedChange(idx, 'roughOpening', 'height', v);
          } }),
        react_default.a.createElement(
          'strong',
          null,
          'TEMP/OBSC/TRANS'
        ),
        react_default.a.createElement(react_toolbox_lib["Checkbox"], { className: TemplateStyling_default.a.tempObscTransCheckbox, label: 'Temp', checked: measure.temp, onChange: function onChange(v) {
            return handleCheckboxChange(idx, 'temp', v);
          } }),
        react_default.a.createElement(react_toolbox_lib["Checkbox"], { className: TemplateStyling_default.a.tempObscTransCheckbox, label: 'Obsc', checked: measure.obsc, onChange: function onChange(v) {
            return handleCheckboxChange(idx, 'obsc', v);
          } }),
        react_default.a.createElement(react_toolbox_lib["Checkbox"], { className: TemplateStyling_default.a.tempObscTransCheckbox, label: 'Trans', checked: measure.trans, onChange: function onChange(v) {
            return handleCheckboxChange(idx, 'trans', v);
          } }),
        react_default.a.createElement(components_TextArea, {
          label: 'Notes',
          value: measure.notes || '',
          onChange: function onChange(e) {
            return handleFieldChange(idx, 'notes', e.target.value);
          }
        }),
        react_default.a.createElement(react_toolbox_lib["Button"], { className: TemplateStyling_default.a.removeButton, label: 'Remove', onClick: function onClick() {
            return removeRow(idx);
          } })
      );
    }),
    react_default.a.createElement(react_toolbox_lib["Button"], { className: TemplateStyling_default.a.button, label: 'Add Window', onClick: addRow })
  );
}

WindowMeasures.propTypes = {
  measures: prop_types_default.a.arrayOf(prop_types_default.a.shape({
    openingNumber: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]),
    location: prop_types_default.a.string,
    qty: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]),
    configuration: prop_types_default.a.string,
    frameType: prop_types_default.a.string,
    frameDepth: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]),
    unitSize: prop_types_default.a.shape({
      width: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]),
      height: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number])
    }),
    roughOpening: prop_types_default.a.shape({
      width: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]),
      height: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number])
    }),
    temp: prop_types_default.a.bool,
    obsc: prop_types_default.a.bool,
    trans: prop_types_default.a.bool,
    notes: prop_types_default.a.string
  })).isRequired,
  onChange: prop_types_default.a.func.isRequired
};

/* harmony default export */ var measures_WindowMeasures = (WindowMeasures);

function validateWindowMeasures(measures) {
  var errors = {};
  measures.forEach(function (item, idx) {
    var qty = item.qty;

    if (qty !== undefined && qty !== '' && isNaN(Number(qty))) {
      if (!errors[idx]) errors[idx] = {};
      errors[idx].qty = ['qty must be a number.'];
    }
    var measurementFields = ['frameDepth'];
    measurementFields.forEach(function (field) {
      var value = item[field];
      if (value !== undefined && value !== '' && isNaN(parseMeasurement(value))) {
        if (!errors[idx]) errors[idx] = {};
        errors[idx][field] = [field + ' must be a number or fraction.'];
      }
    });
    if (item.unitSize) {
      ['width', 'height'].forEach(function (subfield) {
        var value = item.unitSize[subfield];
        if (value !== undefined && value !== '' && isNaN(parseMeasurement(value))) {
          if (!errors[idx]) errors[idx] = {};
          errors[idx]['unitSize.' + subfield] = ['unitSize.' + subfield + ' must be a number or fraction.'];
        }
      });
    }
    if (item.roughOpening) {
      ['width', 'height'].forEach(function (subfield) {
        var value = item.roughOpening[subfield];
        if (value !== undefined && value !== '' && isNaN(parseMeasurement(value))) {
          if (!errors[idx]) errors[idx] = {};
          errors[idx]['roughOpening.' + subfield] = ['roughOpening.' + subfield + ' must be a number or fraction.'];
        }
      });
    }
  });
  if (Object.keys(errors).length > 0) {
    errors.windowMeasures = ['Please ensure all numeric fields are valid numbers.'];
  }
  return errors;
}
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/ifiTemplate/templates/WindowsTemplate.jsx
var WindowsTemplate__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };












function WindowsTemplate(_ref) {
  var data = _ref.data,
      _onChange = _ref.onChange,
      permitRequired = _ref.permitRequired,
      onPermitRequiredChange = _ref.onPermitRequiredChange,
      onReadStart = _ref.onReadStart,
      onReadEnd = _ref.onReadEnd;
  var _data$measures = data.measures,
      measures = _data$measures === undefined ? { windows: [] } : _data$measures,
      _data$arches_transoms = data.arches_transoms_measures,
      arches_transoms_measures = _data$arches_transoms === undefined ? [] : _data$arches_transoms,
      _data$labors_material = data.labors_materials,
      labors_materials = _data$labors_material === undefined ? [] : _data$labors_material,
      _data$comments = data.comments,
      comments = _data$comments === undefined ? '' : _data$comments,
      _data$needs = data.needs,
      needs = _data$needs === undefined ? {} : _data$needs,
      _data$home_diagram = data.home_diagram,
      home_diagram = _data$home_diagram === undefined ? {} : _data$home_diagram,
      _data$product_templat = data.product_template,
      product_template = _data$product_templat === undefined ? {} : _data$product_templat;


  return react_default.a.createElement(
    'div',
    null,
    react_default.a.createElement(
      'h4',
      null,
      'Windows Worksheet'
    ),
    react_default.a.createElement(charts_WindowCharts, null),
    react_default.a.createElement(measures_WindowMeasures, {
      measures: measures.windows,
      onChange: function onChange(updatedMeasures) {
        return _onChange(WindowsTemplate__extends({}, data, { measures: WindowsTemplate__extends({}, data.measures, { windows: updatedMeasures }) }));
      }
    }),
    react_default.a.createElement(components_ArchesTransoms, {
      arches_transoms_measures: arches_transoms_measures,
      onChange: function onChange(updatedArchesTransoms) {
        return _onChange(WindowsTemplate__extends({}, data, { arches_transoms_measures: updatedArchesTransoms }));
      },
      openingCount: measures.windows.length,
      openingTypeLabel: 'window'
    }),
    react_default.a.createElement(components_LaborMaterial, {
      labors_materials: labors_materials,
      onChange: function onChange(updatedLaborsMaterials) {
        return _onChange(WindowsTemplate__extends({}, data, { labors_materials: updatedLaborsMaterials }));
      }
    }),
    react_default.a.createElement(components_Comments, {
      comments: comments,
      onChange: function onChange(updatedComments) {
        return _onChange(WindowsTemplate__extends({}, data, { comments: updatedComments }));
      }
    }),
    react_default.a.createElement(components_ProjectNeeds, {
      needs: needs,
      onChange: function onChange(updatedNeeds) {
        return _onChange(WindowsTemplate__extends({}, data, { needs: updatedNeeds }));
      },
      permitRequired: permitRequired,
      onPermitRequiredChange: onPermitRequiredChange
    }),
    react_default.a.createElement(components_HomeDiagram, {
      home_diagram: home_diagram,
      onChange: function onChange(updatedHomeDiagram) {
        return _onChange(WindowsTemplate__extends({}, data, { home_diagram: updatedHomeDiagram }));
      },
      onReadStart: onReadStart,
      onReadEnd: onReadEnd
    }),
    react_default.a.createElement(components_ProductTemplate, {
      product_template: product_template,
      onChange: function onChange(updatedProductTemplate) {
        return _onChange(WindowsTemplate__extends({}, data, { product_template: updatedProductTemplate }));
      },
      onReadStart: onReadStart,
      onReadEnd: onReadEnd
    })
  );
}

WindowsTemplate.propTypes = {
  data: prop_types_default.a.object.isRequired,
  onChange: prop_types_default.a.func.isRequired,
  permitRequired: prop_types_default.a.bool,
  onPermitRequiredChange: prop_types_default.a.func,
  onReadStart: prop_types_default.a.func,
  onReadEnd: prop_types_default.a.func
};

/* harmony default export */ var templates_WindowsTemplate = (WindowsTemplate);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/ifiTemplate/templates/components/WorkOrderDetails.jsx
var WorkOrderDetails__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function WorkOrderDetails__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








function WorkOrderDetails(_ref) {
  var details = _ref.details,
      onChange = _ref.onChange;

  // Generic handler for any field
  var handleFieldChange = function handleFieldChange(field, value) {
    onChange(WorkOrderDetails__extends({}, details, WorkOrderDetails__defineProperty({}, field, value)));
  };

  return react_default.a.createElement(
    'div',
    null,
    react_default.a.createElement(
      'div',
      null,
      react_default.a.createElement(
        'em',
        null,
        'Please fill out this form completely, take photos of the door/window, exterior of home, entry door if Condo and any damage that occured. If windows, provide picture of Sash Tag.'
      )
    ),
    react_default.a.createElement(
      'div',
      null,
      react_default.a.createElement(react_toolbox_lib["Input"], { label: 'Customer Name:', value: details.customerName, onChange: function onChange(v) {
          return handleFieldChange('customerName', v);
        } }),
      react_default.a.createElement(react_toolbox_lib["Input"], { label: 'WO/Job #:', value: details.job_id, onChange: function onChange(v) {
          return handleFieldChange('job_id', v);
        } }),
      react_default.a.createElement(react_toolbox_lib["Input"], {
        type: 'date',
        label: 'Date of Inspection:',
        value: details.dateOfInspection || '',
        onChange: function onChange(v) {
          return handleFieldChange('dateOfInspection', v);
        }
      }),
      react_default.a.createElement(react_toolbox_lib["Input"], { label: 'Room Name, Location:', value: details.location, onChange: function onChange(v) {
          return handleFieldChange('location', v);
        } })
    ),
    react_default.a.createElement(
      'div',
      { className: TemplateStyling_default.a.checkboxContainer },
      react_default.a.createElement(
        'div',
        null,
        react_default.a.createElement(
          'span',
          null,
          'Property Damage:'
        ),
        react_default.a.createElement(react_toolbox_lib["Checkbox"], {
          label: 'Yes',
          checked: details.propertyDamage === true,
          onChange: function onChange() {
            return handleFieldChange('propertyDamage', true);
          },
          className: TemplateStyling_default.a.theme__check___1CXAo
        }),
        react_default.a.createElement(react_toolbox_lib["Checkbox"], {
          label: 'No',
          checked: details.propertyDamage === false,
          onChange: function onChange() {
            return handleFieldChange('propertyDamage', false);
          },
          className: TemplateStyling_default.a.theme__check___1CXAo
        })
      ),
      details.propertyDamage === true && react_default.a.createElement(react_toolbox_lib["Input"], {
        label: 'If yes, please explain (Where damage occured? What was damaged? If flooring, provide sq. ft.)',
        value: details.propertyDamageExplanation || '',
        onChange: function onChange(v) {
          return handleFieldChange('propertyDamageExplanation', v);
        },
        required: true
      })
    ),
    react_default.a.createElement(
      'div',
      null,
      react_default.a.createElement(react_toolbox_lib["Input"], { label: 'Nature of Issue:', value: details.natureOfIssue || '', onChange: function onChange(v) {
          return handleFieldChange('natureOfIssue', v);
        } }),
      react_default.a.createElement(react_toolbox_lib["Input"], { label: 'Resolution:', value: details.resolution || '', onChange: function onChange(v) {
          return handleFieldChange('resolution', v);
        } })
    ),
    react_default.a.createElement(
      'div',
      { className: TemplateStyling_default.a.checkboxContainer },
      react_default.a.createElement(
        'div',
        null,
        react_default.a.createElement(
          'span',
          null,
          'Product Required:'
        ),
        react_default.a.createElement(react_toolbox_lib["Checkbox"], {
          label: 'Yes',
          checked: details.productRequired === true,
          onChange: function onChange() {
            return handleFieldChange('productRequired', true);
          },
          className: TemplateStyling_default.a.theme__check___1CXAo
        }),
        react_default.a.createElement(react_toolbox_lib["Checkbox"], {
          label: 'No',
          checked: details.productRequired === false,
          onChange: function onChange() {
            return handleFieldChange('productRequired', false);
          },
          className: TemplateStyling_default.a.theme__check___1CXAo
        })
      ),
      details.productRequired === true && react_default.a.createElement(react_toolbox_lib["Input"], {
        label: 'If yes, please explain:',
        value: details.productRequiredExplanation || '',
        onChange: function onChange(v) {
          return handleFieldChange('productRequiredExplanation', v);
        },
        required: true
      })
    ),
    react_default.a.createElement(
      'div',
      { className: TemplateStyling_default.a.checkboxContainer },
      react_default.a.createElement(
        'div',
        null,
        react_default.a.createElement(
          'span',
          null,
          'Labor Required for repairs:'
        ),
        react_default.a.createElement(react_toolbox_lib["Checkbox"], {
          label: 'Yes',
          checked: details.laborRequired === true,
          onChange: function onChange() {
            return handleFieldChange('laborRequired', true);
          },
          className: TemplateStyling_default.a.theme__check___1CXAo
        }),
        react_default.a.createElement(react_toolbox_lib["Checkbox"], {
          label: 'No',
          checked: details.laborRequired === false,
          onChange: function onChange() {
            return handleFieldChange('laborRequired', false);
          },
          className: TemplateStyling_default.a.theme__check___1CXAo
        })
      ),
      details.laborRequired === true && react_default.a.createElement(react_toolbox_lib["Input"], {
        label: 'If yes, please explain:',
        value: details.laborRequiredExplanation || '',
        onChange: function onChange(v) {
          return handleFieldChange('laborRequiredExplanation', v);
        },
        required: true
      })
    ),
    react_default.a.createElement(
      'div',
      { className: TemplateStyling_default.a.checkboxContainer },
      react_default.a.createElement(
        'span',
        null,
        'Door/Window Information'
      ),
      react_default.a.createElement(
        'div',
        { className: TemplateStyling_default.a.checkboxContainer },
        react_default.a.createElement(react_toolbox_lib["Checkbox"], {
          label: 'LH',
          checked: details.lh || false,
          onChange: function onChange(v) {
            return handleFieldChange('lh', v);
          },
          className: TemplateStyling_default.a.theme__check___1CXAo
        }),
        react_default.a.createElement(react_toolbox_lib["Checkbox"], {
          label: 'RH',
          checked: details.rh || false,
          onChange: function onChange(v) {
            return handleFieldChange('rh', v);
          },
          className: TemplateStyling_default.a.theme__check___1CXAo
        }),
        react_default.a.createElement(react_toolbox_lib["Checkbox"], {
          label: 'Inswing',
          checked: details.inswing || false,
          onChange: function onChange(v) {
            return handleFieldChange('inswing', v);
          },
          className: TemplateStyling_default.a.theme__check___1CXAo
        }),
        react_default.a.createElement(react_toolbox_lib["Checkbox"], {
          label: 'Outswing',
          checked: details.outswing || false,
          onChange: function onChange(v) {
            return handleFieldChange('outswing', v);
          },
          className: TemplateStyling_default.a.theme__check___1CXAo
        })
      ),
      react_default.a.createElement(react_toolbox_lib["Input"], { label: 'Color', value: details.color || '', onChange: function onChange(v) {
          return handleFieldChange('color', v);
        } }),
      react_default.a.createElement(react_toolbox_lib["Input"], { label: 'Jamb Size', hint: 'e.g. 34 1/2', value: details.jambSize || '', onChange: function onChange(v) {
          return handleFieldChange('jambSize', v);
        } }),
      react_default.a.createElement(
        'span',
        null,
        'Door Measurements'
      ),
      react_default.a.createElement(react_toolbox_lib["Input"], { label: 'Door Width, frame size (prehung)', hint: 'e.g. 34 1/2', value: details.doorWidthFrame || '', onChange: function onChange(v) {
          return handleFieldChange('doorWidthFrame', v);
        } }),
      react_default.a.createElement(react_toolbox_lib["Input"], { label: 'Door Height, frame size (prehung)', hint: 'e.g. 34 1/2', value: details.doorHeightFrame || '', onChange: function onChange(v) {
          return handleFieldChange('doorHeightFrame', v);
        } }),
      react_default.a.createElement(react_toolbox_lib["Input"], { label: 'Door Width, slab', hint: 'e.g. 34 1/2', value: details.doorWidthSlab || '', onChange: function onChange(v) {
          return handleFieldChange('doorWidthSlab', v);
        } }),
      react_default.a.createElement(react_toolbox_lib["Input"], { label: 'Door Height, slab', hint: 'e.g. 34 1/2', value: details.doorHeightSlab || '', onChange: function onChange(v) {
          return handleFieldChange('doorHeightSlab', v);
        } }),
      react_default.a.createElement(
        'span',
        null,
        'Window Information'
      ),
      react_default.a.createElement(
        'div',
        { className: TemplateStyling_default.a.checkboxContainer },
        react_default.a.createElement(react_toolbox_lib["Checkbox"], {
          label: 'Full frame',
          checked: details.fullFrame || false,
          onChange: function onChange(v) {
            return handleFieldChange('fullFrame', v);
          },
          className: TemplateStyling_default.a.theme__check___1CXAo
        }),
        react_default.a.createElement(react_toolbox_lib["Checkbox"], {
          label: 'Pocket RPL',
          checked: details.pocketRPL || false,
          onChange: function onChange(v) {
            return handleFieldChange('pocketRPL', v);
          },
          className: TemplateStyling_default.a.theme__check___1CXAo
        })
      ),
      react_default.a.createElement(react_toolbox_lib["Input"], { label: 'Exact Frame Width', hint: 'e.g. 34 1/2', value: details.exactFrameWidth || '', onChange: function onChange(v) {
          return handleFieldChange('exactFrameWidth', v);
        } }),
      react_default.a.createElement(react_toolbox_lib["Input"], { label: 'Exact Frame Height', hint: 'e.g. 34 1/2', value: details.exactFrameHeight || '', onChange: function onChange(v) {
          return handleFieldChange('exactFrameHeight', v);
        } })
    ),
    react_default.a.createElement(
      'div',
      null,
      react_default.a.createElement(components_TextArea, { label: 'Additional Comments:', value: details.additionalComments || '', onChange: function onChange(e) {
          return handleFieldChange('additionalComments', e.target.value);
        } })
    )
  );
}

WorkOrderDetails.propTypes = {
  details: prop_types_default.a.shape({
    customerName: prop_types_default.a.string,
    job_id: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]),
    dateOfInspection: prop_types_default.a.string,
    location: prop_types_default.a.string,
    propertyDamage: prop_types_default.a.bool,
    propertyDamageExplanation: prop_types_default.a.string,
    natureOfIssue: prop_types_default.a.string,
    resolution: prop_types_default.a.string,
    productRequired: prop_types_default.a.bool,
    productRequiredExplanation: prop_types_default.a.string,
    laborRequired: prop_types_default.a.bool,
    laborRequiredExplanation: prop_types_default.a.string,
    lh: prop_types_default.a.bool,
    rh: prop_types_default.a.bool,
    inswing: prop_types_default.a.bool,
    outswing: prop_types_default.a.bool,
    color: prop_types_default.a.string,
    jambSize: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]),
    doorWidthFrame: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]),
    doorHeightFrame: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]),
    doorWidthSlab: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]),
    doorHeightSlab: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]),
    fullFrame: prop_types_default.a.bool,
    pocketRPL: prop_types_default.a.bool,
    exactFrameWidth: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]),
    exactFrameHeight: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]),
    additionalComments: prop_types_default.a.string
  }).isRequired,
  onChange: prop_types_default.a.func.isRequired
};

/* harmony default export */ var components_WorkOrderDetails = (WorkOrderDetails);

function validateWorkOrderDetails(details) {
  var errors = {};
  var measurementFields = ['jambSize', 'doorWidthFrame', 'doorHeightFrame', 'doorWidthSlab', 'doorHeightSlab', 'exactFrameWidth', 'exactFrameHeight'];
  var hasMeasurementError = false;
  measurementFields.forEach(function (field) {
    var value = details[field];
    if (value !== undefined && value !== '' && isNaN(parseMeasurement(value))) {
      errors[field] = [field + ' must be a number or fraction.'];
      hasMeasurementError = true;
    }
  });
  if (hasMeasurementError) {
    errors.numberFields = ['Please ensure all measurement fields are valid numbers or fractions (in inches).'];
  }
  if (!details.dateOfInspection) {
    errors.dateOfInspection = ['Date of Inspection is required.'];
  } else if (isNaN(Date.parse(details.dateOfInspection))) {
    errors.dateOfInspection = ['Date of Inspection must be a valid date.'];
  }
  var yesNoExplanationFields = [{ field: 'propertyDamage', explanationField: 'propertyDamageExplanation', label: 'Property Damage' }, { field: 'productRequired', explanationField: 'productRequiredExplanation', label: 'Product Required' }, { field: 'laborRequired', explanationField: 'laborRequiredExplanation', label: 'Labor Required' }];
  yesNoExplanationFields.forEach(function (_ref2) {
    var field = _ref2.field,
        explanationField = _ref2.explanationField,
        label = _ref2.label;

    if (details[field] === true && !(details[explanationField] || '').trim()) {
      errors[explanationField] = ['Please provide an explanation for ' + label + '.'];
    }
  });
  return errors;
}
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/ifiTemplate/templates/WorkorderTemplate.jsx
var WorkorderTemplate__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






function WorkOrderTemplate(_ref) {
  var data = _ref.data,
      _onChange = _ref.onChange,
      permitRequired = _ref.permitRequired,
      onPermitRequiredChange = _ref.onPermitRequiredChange;
  var _data$details = data.details,
      details = _data$details === undefined ? {} : _data$details,
      _data$needs = data.needs,
      needs = _data$needs === undefined ? {} : _data$needs;


  return react_default.a.createElement(
    'div',
    null,
    react_default.a.createElement(
      'h4',
      null,
      'Work Order Inspection Report'
    ),
    react_default.a.createElement(components_WorkOrderDetails, {
      details: details,
      onChange: function onChange(updatedDetails) {
        return _onChange(WorkorderTemplate__extends({}, data, { details: updatedDetails }));
      }
    }),
    react_default.a.createElement(components_ProjectNeeds, {
      needs: needs,
      onChange: function onChange(updatedNeeds) {
        return _onChange(WorkorderTemplate__extends({}, data, { needs: updatedNeeds }));
      },
      permitRequired: permitRequired,
      onPermitRequiredChange: onPermitRequiredChange,
      showAdditionalMiles: false
    })
  );
}

WorkOrderTemplate.propTypes = {
  data: prop_types_default.a.object.isRequired,
  onChange: prop_types_default.a.func.isRequired,
  permitRequired: prop_types_default.a.bool,
  onPermitRequiredChange: prop_types_default.a.func
};

/* harmony default export */ var WorkorderTemplate = (WorkOrderTemplate);
// CONCATENATED MODULE: ./client/app/screens/main/screens/phases/phaseShow/tabs/ifiTemplate/index.jsx
var ifiTemplate__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var ifiTemplate__slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var ifiTemplate__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function ifiTemplate__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function ifiTemplate__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ifiTemplate__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ifiTemplate__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





























var isBlank = function isBlank(value) {
  return value === undefined || value === null || typeof value === 'string' && value.trim() === '';
};

function addError(errors, key, message) {
  var nextErrors = ifiTemplate__extends({}, errors);
  var currentMessages = nextErrors[key] || [];
  nextErrors[key] = currentMessages.concat(message);
  return nextErrors;
}

function validateAssessmentMeasureRows(measures, templateLabel, requiredFields) {
  var allowEmpty = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  var errors = {};

  if (!Array.isArray(measures)) {
    if (allowEmpty) return errors;
    errors.requiredMeasures = ['At least one ' + templateLabel + ' measure is required.'];
    return errors;
  }
  if (measures.length === 0) {
    if (allowEmpty) return errors;
    errors.requiredMeasures = ['At least one ' + templateLabel + ' measure is required.'];
    return errors;
  }

  measures.forEach(function (measure, idx) {
    requiredFields.forEach(function (fieldPath) {
      var fieldParts = fieldPath.split('.');
      var value = fieldParts.reduce(function (obj, key) {
        return obj ? obj[key] : undefined;
      }, measure);
      if (isBlank(value)) {
        Object.assign(errors, addError(errors, 'required.' + idx + '.' + fieldPath, templateLabel + ' opening #' + (idx + 1) + ': ' + fieldPath + ' is required.'));
      }
    });
  });

  return errors;
}

function validateRequiredTemplateData(templateType) {
  var templateData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var errors = {};
  var _templateData$measure = templateData.measures,
      measures = _templateData$measure === undefined ? {} : _templateData$measure,
      _templateData$details = templateData.details,
      details = _templateData$details === undefined ? {} : _templateData$details;


  switch (templateType) {
    case 'entry_door_worksheet':
      return validateAssessmentMeasureRows(measures.entry_doors, 'Entry door', ['location', 'configuration', 'jamb_size', 'unitSize.width', 'unitSize.height', 'roughOpening.width', 'roughOpening.height', 'handing']);
    case 'interior_door_worksheet':
      {
        var interiorDoors = measures.interior_doors || [];
        var barnDoors = measures.barn_doors || [];

        if (!interiorDoors.length && !barnDoors.length) {
          errors.requiredMeasures = ['At least one interior door or barn door measure is required.'];
          return errors;
        }

        var interiorErrors = validateAssessmentMeasureRows(interiorDoors, 'Interior door', ['location', 'configuration', 'jamb_size', 'unitSize.width', 'unitSize.height', 'finishedOpening.width', 'finishedOpening.height', 'handing'], true);
        var barnErrors = validateAssessmentMeasureRows(barnDoors, 'Barn door', ['location', 'singleOrDouble', 'finishedOpening.width', 'finishedOpening.height', 'hardwareTrack.width', 'hardwareTrack.height'], true);

        return ifiTemplate__extends({}, interiorErrors, barnErrors);
      }
    case 'storm_door_worksheet':
      return validateAssessmentMeasureRows(measures.storm_doors, 'Storm door', ['configuration', 'opening.width', 'opening.height', 'sizing', 'handing']);
    case 'window_worksheet':
      return validateAssessmentMeasureRows(measures.windows, 'Window', ['location', 'qty', 'configuration', 'frameType', 'frameDepth', 'unitSize.width', 'unitSize.height', 'roughOpening.width', 'roughOpening.height']);
    case 'workorder_inspection':
      {
        var requiredDetailFields = ['customerName', 'job_id', 'dateOfInspection', 'location', 'natureOfIssue', 'resolution', 'propertyDamage', 'productRequired', 'laborRequired'];
        requiredDetailFields.forEach(function (field) {
          if (isBlank(details[field])) {
            Object.assign(errors, addError(errors, 'details.' + field, field + ' is required.'));
          }
        });
        return errors;
      }
    default:
      return {};
  }
}

function validateTemplateData(templateType, templateData) {
  var requiredFieldErrors = validateRequiredTemplateData(templateType, templateData);
  // validations for all templates
  var projectNeedsErrors = validateProjectNeeds(templateData.needs || {});
  var errors = {};

  // validations specific to template type
  switch (templateType) {
    case 'entry_door_worksheet':
      {
        var _templateData$measure2 = templateData.measures,
            measures = _templateData$measure2 === undefined ? {} : _templateData$measure2,
            _templateData$arches_ = templateData.arches_transoms_measures,
            arches_transoms_measures = _templateData$arches_ === undefined ? [] : _templateData$arches_,
            _templateData$labors_ = templateData.labors_materials,
            labors_materials = _templateData$labors_ === undefined ? [] : _templateData$labors_;

        errors = ifiTemplate__extends({}, validateEntryDoorMeasures(measures.entry_doors || []), validateArchesTransoms(arches_transoms_measures, (measures.entry_doors || []).length, 'entry door'), validateLaborMaterials(labors_materials));
        break;
      }
    case 'interior_door_worksheet':
      {
        var _templateData$measure3 = templateData.measures,
            _measures = _templateData$measure3 === undefined ? {} : _templateData$measure3,
            _templateData$labors_2 = templateData.labors_materials,
            _labors_materials = _templateData$labors_2 === undefined ? [] : _templateData$labors_2;

        errors = ifiTemplate__extends({}, validateInteriorDoorMeasures(_measures.interior_doors || []), validateBarnDoorMeasures(_measures.barn_doors || []), validateLaborMaterials(_labors_materials));
        break;
      }
    case 'storm_door_worksheet':
      {
        var _templateData$measure4 = templateData.measures,
            _measures2 = _templateData$measure4 === undefined ? {} : _templateData$measure4,
            _templateData$labors_3 = templateData.labors_materials,
            _labors_materials2 = _templateData$labors_3 === undefined ? [] : _templateData$labors_3;

        errors = ifiTemplate__extends({}, validateStormDoorMeasures(_measures2.storm_doors || []), validateLaborMaterials(_labors_materials2));
        break;
      }
    case 'window_worksheet':
      {
        var _templateData$measure5 = templateData.measures,
            _measures3 = _templateData$measure5 === undefined ? {} : _templateData$measure5,
            _templateData$arches_2 = templateData.arches_transoms_measures,
            _arches_transoms_measures = _templateData$arches_2 === undefined ? [] : _templateData$arches_2,
            _templateData$labors_4 = templateData.labors_materials,
            _labors_materials3 = _templateData$labors_4 === undefined ? [] : _templateData$labors_4;

        errors = ifiTemplate__extends({}, validateWindowMeasures(_measures3.windows || []), validateArchesTransoms(_arches_transoms_measures, (_measures3.windows || []).length, 'window'), validateLaborMaterials(_labors_materials3));
        break;
      }
    case 'workorder_inspection':
      {
        var _templateData$details2 = templateData.details,
            details = _templateData$details2 === undefined ? {} : _templateData$details2;

        errors = ifiTemplate__extends({}, validateWorkOrderDetails(details));
        break;
      }
    default:
      errors = {};
  }
  // Merge errors
  return ifiTemplate__extends({}, requiredFieldErrors, errors, projectNeedsErrors);
}

var COPY_EXISTING_TEMPLATE = '__copy_existing_template__';

function buildCopySourceLabel(template) {
  var typeLabel = JOB_PAPERWORK_TEMPLATE_LABELS[template.template_type] || template.template_type;
  var dateLabel = moment_default()(template.created_at).format(constants["F" /* DISPLAY_DATE_TIME */]);
  return typeLabel + ' \u2014 ' + dateLabel + (template.not_use ? ' (not active)' : '');
}

var ifiTemplate_IfiTemplatePage = function (_Validator) {
  ifiTemplate__inherits(IfiTemplatePage, _Validator);

  function IfiTemplatePage(props) {
    ifiTemplate__classCallCheck(this, IfiTemplatePage);

    var _this = ifiTemplate__possibleConstructorReturn(this, (IfiTemplatePage.__proto__ || Object.getPrototypeOf(IfiTemplatePage)).call(this, props));

    Object.defineProperty(_this, 'componentWillMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            phase = _this$props.phase,
            role = _this$props.role;

        if (!Object(services["c" /* canAccessIfiTemplate */])({ role: role, phase_type: phase.type, phase_source: phase.source })) {
          _this.props.navigate(urls.phaseHistory(phase));
        }
      }
    });
    Object.defineProperty(_this, 'componentDidMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props2 = _this.props,
            phase = _this$props2.phase,
            role = _this$props2.role;

        if (!Object(services["c" /* canAccessIfiTemplate */])({ role: role, phase_type: phase.type, phase_source: phase.source })) return;
        Object(actionCreators["_11" /* requestJobPaperworkTemplates */])(phase.id).then(function (_ref) {
          var templates = _ref.templates,
              error = _ref.error;

          if (error) return;
          _this.setState({ templates: templates });
        });
      }
    });
    Object.defineProperty(_this, 'getTemplateComponent', {
      enumerable: true,
      writable: true,
      value: function value() {
        switch (_this.state.templateType) {
          case 'window_worksheet':
            return templates_WindowsTemplate;
          case 'entry_door_worksheet':
            return templates_EntryDoorTemplate;
          case 'storm_door_worksheet':
            return templates_StormDoorTemplate;
          case 'interior_door_worksheet':
            return templates_InteriorDoorTemplate;
          case 'workorder_inspection':
            return WorkorderTemplate;
          default:
            return null;
        }
      }
    });
    Object.defineProperty(_this, 'goToHistory', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.props.clearValidation();
        _this.props.navigate(urls.phaseHistory(_this.props.phase));
      }
    });
    Object.defineProperty(_this, 'handleCancel', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.goToHistory();
      }
    });
    Object.defineProperty(_this, 'handleImageReadStart', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState(function (s) {
          return { imagesLoading: s.imagesLoading + 1 };
        });
      }
    });
    Object.defineProperty(_this, 'handleImageReadEnd', {
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.setState(function (s) {
          return {
            imagesLoading: Math.max(0, s.imagesLoading - 1)
          };
        });
      }
    });
    Object.defineProperty(_this, 'handleTemplateTypeChange', {
      enumerable: true,
      writable: true,
      value: function value(_value) {
        if (_value === COPY_EXISTING_TEMPLATE) {
          _this.setState({ copyMode: true, templateType: '', copySourceId: '' });
          return;
        }
        var templateData = ifiTemplate__extends({}, IfiTemplatePage.DEFAULT_STATE.templateData);
        if (_value === 'workorder_inspection') {
          templateData.details = ifiTemplate__extends({}, IfiTemplatePage.DEFAULT_STATE.templateData.details, {
            job_id: _this.props.phase.project_number,
            propertyDamage: false,
            productRequired: false,
            laborRequired: false
          });
        }
        _this.setState({
          copyMode: false,
          templateType: _value,
          copySourceId: '',
          templateData: templateData
        });
      }
    });
    Object.defineProperty(_this, 'handleCopySourceChange', {
      enumerable: true,
      writable: true,
      value: function value(_value2) {
        var source = _this.state.templates.find(function (t) {
          return t.id === _value2;
        });
        if (!source) return;
        _this.setState({
          copySourceId: _value2,
          templateType: source.template_type,
          permitRequired: !!source.permit_required,
          templateData: source.template_data || IfiTemplatePage.DEFAULT_STATE.templateData
        });
      }
    });
    Object.defineProperty(_this, 'handlePermitRequiredChange', {
      enumerable: true,
      writable: true,
      value: function value(_value3) {
        return _this.setState({ permitRequired: _value3 });
      }
    });
    Object.defineProperty(_this, 'handleTemplateDataChange', {
      enumerable: true,
      writable: true,
      value: function value(data) {
        return _this.setState({ templateData: data });
      }
    });
    Object.defineProperty(_this, 'handleSubmit', {
      enumerable: true,
      writable: true,
      value: function value() {
        var copyMode = _this.state.copyMode;

        var validated = copyMode ? _this.validate({ copySourceId: 'Please select an existing template to copy from.' }) : _this.validate();
        if (!validated) return;

        var phase = _this.props.phase;
        var _this$state = _this.state,
            templateType = _this$state.templateType,
            permitRequired = _this$state.permitRequired,
            templateData = _this$state.templateData;

        // Centralized validation

        var errors = validateTemplateData(templateType, templateData);

        if (Object.keys(errors).length > 0) {
          _this.setState({ errors: errors });
          return;
        }

        var templatePayload = {
          phase_id: phase.id,
          template_type: templateType,
          permit_required: permitRequired,
          template_data: templateData
        };

        _this.setState({ submitting: true });
        _this.props.jobPaperworkTemplateCreate(templatePayload).then(function () {
          return _this.props.loadPhase(phase.id).catch(function () {
            return null;
          });
        }).then(function () {
          _this.setState({ submitting: false });
          _this.goToHistory();
        }).catch(function () {
          _this.setState({
            submitting: false,
            errors: { submit: ['Unable to create template. Please try again.'] }
          });
        });
      }
    });
    Object.defineProperty(_this, 'render', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props3 = _this.props,
            phase = _this$props3.phase,
            role = _this$props3.role;

        if (!Object(services["c" /* canAccessIfiTemplate */])({ role: role, phase_type: phase.type, phase_source: phase.source })) {
          return null;
        }

        var _this$state2 = _this.state,
            templateType = _this$state2.templateType,
            templateData = _this$state2.templateData,
            permitRequired = _this$state2.permitRequired,
            submitting = _this$state2.submitting,
            imagesLoading = _this$state2.imagesLoading,
            errors = _this$state2.errors,
            templates = _this$state2.templates,
            copyMode = _this$state2.copyMode,
            copySourceId = _this$state2.copySourceId;

        var templateError = ((errors || {}).templateType || [])[0];
        var copySourceError = ((errors || {}).copySourceId || [])[0];
        var templateOptions = JOB_PAPERWORK_TEMPLATE_OPTIONS[phase.type] || [];
        var topDropdownOptions = templates.length > 0 ? [].concat(ifiTemplate__toConsumableArray(templateOptions), [{ value: COPY_EXISTING_TEMPLATE, label: 'Copy Existing Template' }]) : templateOptions;
        var topDropdownValue = copyMode ? COPY_EXISTING_TEMPLATE : templateType;
        var copySourceOptions = templates.slice().sort(function (a, b) {
          return moment_default()(b.created_at).valueOf() - moment_default()(a.created_at).valueOf();
        }).map(function (t) {
          return { value: t.id, label: buildCopySourceLabel(t) };
        });
        var TemplateComponent = _this.getTemplateComponent();
        var isWorkorderInspection = templateType === 'workorder_inspection';
        var submitLabel = submitting ? 'Creating...' : 'Submit';

        return react_default.a.createElement(
          'div',
          { style: { padding: '20px' } },
          react_default.a.createElement(
            'div',
            { className: input_default.a.errored },
            errors.submit && react_default.a.createElement(
              'span',
              { className: input_default.a.error },
              errors.submit[0]
            )
          ),
          react_default.a.createElement(
            'h5',
            null,
            'IFI Template'
          ),
          !isWorkorderInspection && react_default.a.createElement(
            'div',
            { style: { textAlign: 'center', marginBottom: '20px' } },
            react_default.a.createElement(
              'h6',
              { style: { paddingBottom: '10px' } },
              'Please have all diagram and template photos accessible before completing worksheet'
            ),
            react_default.a.createElement(
              'li',
              { style: { fontSize: '12px', listStyle: 'none' } },
              'Home Diagram \u2014 Drawing/image showing the layout of the home with product placement locations.'
            ),
            react_default.a.createElement(
              'li',
              { style: { fontSize: '12px', listStyle: 'none' } },
              'Product Template \u2014 Reference image for highly configurable products, complex measurements, or product specifications.'
            )
          ),
          react_default.a.createElement(react_toolbox_lib["Dropdown"], {
            label: 'Select Template',
            value: topDropdownValue,
            onChange: _this.handleTemplateTypeChange,
            source: topDropdownOptions,
            required: true,
            error: templateError
          }),
          copyMode && react_default.a.createElement(react_toolbox_lib["Dropdown"], {
            label: 'Copy From',
            value: copySourceId,
            onChange: _this.handleCopySourceChange,
            source: copySourceOptions,
            required: true,
            error: copySourceError
          }),
          TemplateComponent && react_default.a.createElement(TemplateComponent, {
            data: templateData || null,
            onChange: _this.handleTemplateDataChange,
            permitRequired: permitRequired,
            onPermitRequiredChange: _this.handlePermitRequiredChange,
            onReadStart: _this.handleImageReadStart,
            onReadEnd: _this.handleImageReadEnd
          }),
          Object.keys(errors).length > 0 && react_default.a.createElement(
            'div',
            { style: { color: 'red', marginBottom: 16 } },
            Object.entries(errors).map(function (_ref2) {
              var _ref3 = ifiTemplate__slicedToArray(_ref2, 2),
                  field = _ref3[0],
                  msgs = _ref3[1];

              if (field === 'submit') return null;
              if (Array.isArray(msgs)) return msgs.map(function (msg) {
                return react_default.a.createElement(
                  'div',
                  { key: field + '-' + msg },
                  msg
                );
              });
              // If msgs is an object (nested errors), flatten and display
              if ((typeof msgs === 'undefined' ? 'undefined' : ifiTemplate__typeof(msgs)) === 'object' && msgs !== null) {
                return Object.entries(msgs).map(function (_ref4) {
                  var _ref5 = ifiTemplate__slicedToArray(_ref4, 2),
                      subField = _ref5[0],
                      subMsgs = _ref5[1];

                  return Array.isArray(subMsgs) ? subMsgs.map(function (subMsg) {
                    return react_default.a.createElement(
                      'div',
                      { key: field + '-' + subField + '-' + subMsg },
                      subMsg
                    );
                  }) : react_default.a.createElement(
                    'div',
                    { key: field + '-' + subField },
                    subMsgs
                  );
                });
              }
              return react_default.a.createElement(
                'div',
                { key: field },
                msgs
              );
            })
          ),
          react_default.a.createElement(
            'div',
            { style: { marginTop: '20px', display: 'flex', justifyContent: 'flex-end', gap: '10px' } },
            react_default.a.createElement(react_toolbox_lib["Button"], { label: 'Cancel', onClick: _this.handleCancel, disabled: submitting }),
            react_default.a.createElement(react_toolbox_lib["Button"], {
              label: imagesLoading > 0 ? 'Processing image...' : submitLabel,
              primary: true,
              raised: true,
              onClick: _this.handleSubmit,
              disabled: submitting || imagesLoading > 0
            })
          )
        );
      }
    });
    var _props$phase$phase_sp = props.phase.phase_specific;
    _props$phase$phase_sp = _props$phase$phase_sp === undefined ? {} : _props$phase$phase_sp;
    var _props$phase$phase_sp2 = _props$phase$phase_sp.millwork_specifics;
    _props$phase$phase_sp2 = _props$phase$phase_sp2 === undefined ? {} : _props$phase$phase_sp2;
    var _props$phase$phase_sp3 = _props$phase$phase_sp2.permit_required,
        permit_required = _props$phase$phase_sp3 === undefined ? false : _props$phase$phase_sp3;

    _this.state = ifiTemplate__extends({}, IfiTemplatePage.DEFAULT_STATE, { permitRequired: permit_required });
    return _this;
  }

  return IfiTemplatePage;
}(validator(react_default.a.Component));

Object.defineProperty(ifiTemplate_IfiTemplatePage, 'DEFAULT_STATE', {
  enumerable: true,
  writable: true,
  value: {
    templateType: '',
    permitRequired: false,
    errors: {},
    submitting: false,
    imagesLoading: 0,
    templateData: {
      measures: {
        windows: [], entry_doors: [], storm_doors: [], interior_doors: [], barn_doors: []
      }, // for assessments
      arches_transoms_measures: [], // for assessments
      labors_materials: [], // for assessments
      comments: '', // for assessments
      needs: {}, // for all templates
      details: {} },
    templates: [],
    copyMode: false,
    copySourceId: ''
  }
});
Object.defineProperty(ifiTemplate_IfiTemplatePage, 'VALIDATIONS', {
  enumerable: true,
  writable: true,
  value: { templateType: true }
});


ifiTemplate_IfiTemplatePage.propTypes = {
  clearValidation: prop_types_default.a.func.isRequired,
  jobPaperworkTemplateCreate: prop_types_default.a.func.isRequired,
  loadPhase: prop_types_default.a.func.isRequired,
  navigate: prop_types_default.a.func.isRequired,
  phase: types_phase.isRequired,
  role: prop_types_default.a.string.isRequired
};

/* harmony default export */ var ifiTemplate = (Object(react_redux_es["connect"])(function (state) {
  return { phase: state.phase.details, role: state.user.role };
}, { clearValidation: actionCreators["j" /* clearValidation */], jobPaperworkTemplateCreate: actionCreators["E" /* jobPaperworkTemplateCreate */], loadPhase: actionCreators["G" /* loadPhase */], navigate: actionCreators["O" /* navigate */] })(ifiTemplate_IfiTemplatePage));
// EXTERNAL MODULE: ./client/app/screens/refigure/form/refigure.scss
var refigure = __webpack_require__("kpm4");
var refigure_default = /*#__PURE__*/__webpack_require__.n(refigure);

// CONCATENATED MODULE: ./client/app/screens/refigure/form/components/refigureHeader.jsx








var refigureHeader_theme = {
  ResourceDetailsCE: refigure_default.a
};

var refigureHeader_RefigureHeader = function RefigureHeader(_ref) {
  var phaseDetails = _ref.phaseDetails;
  return react_default.a.createElement(
    react_css_themr_lib["ThemeProvider"],
    { theme: refigureHeader_theme },
    react_default.a.createElement(
      'div',
      { className: refigure_default.a.ResourceDetails },
      react_default.a.createElement(
        'h5',
        { className: refigure_default.a.RefigureHeader },
        'Refigure Request:'
      ),
      react_default.a.createElement(ResourceDetailsCardElement, { title: 'customer name:', value: phaseDetails.customer_name }),
      react_default.a.createElement(ResourceDetailsCardElement, { title: 'phone number:', value: Object(utils["h" /* formatTelephone */])(phaseDetails.phone_number) }),
      react_default.a.createElement(
        ResourceDetailsCardElement,
        { title: 'p.o. #:' },
        react_default.a.createElement(components_PurchaseOrders, {
          className: refigure_default.a.resourceCardElementValue,
          purchaseOrders: phaseDetails.purchase_orders
        })
      ),
      react_default.a.createElement(ResourceDetailsCardElement, { title: 'Store #:', value: phaseDetails.store_number })
    )
  );
};

refigureHeader_RefigureHeader.propTypes = {
  phaseDetails: prop_types_default.a.object
};

/* harmony default export */ var refigureHeader = (refigureHeader_RefigureHeader);
// CONCATENATED MODULE: ./client/app/screens/refigure/form/components/refigureCard.jsx
var refigureCard__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function refigureCard__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function refigureCard__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function refigureCard__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var refigureCard_largeInput = classnames_default()(form_default.a.inputs, form_default.a.largeInput);
var refigureCard_titleStyle = classnames_default()(form_default.a.bottomTitle, form_default.a.childTitle);

var refigureCard_RefigureCard = function (_Component) {
  refigureCard__inherits(RefigureCard, _Component);

  function RefigureCard(props) {
    refigureCard__classCallCheck(this, RefigureCard);

    var _this = refigureCard__possibleConstructorReturn(this, (RefigureCard.__proto__ || Object.getPrototypeOf(RefigureCard)).call(this, props));

    Object.defineProperty(_this, 'deleteDetails', {
      enumerable: true,
      writable: true,
      value: function value() {
        var phase = _this.state.phase;
        phase = { surface_information: {}, surface_type: { id: '' } };
        _this.setState({ phase: phase }, _this.props.deleteRefigureDetails(_this.props.index));
      }
    });
    Object.defineProperty(_this, 'handleSurfaceInfoChange', {
      enumerable: true,
      writable: true,
      value: function value(key, _value) {
        var phase = _this.state.phase;
        phase.surface_information = phase.surface_information || {};
        if (key === 'sqft') {
          phase.sqft = _value;
        } else {
          phase.surface_information[key] = _value;
        }
        _this.setState({ phase: phase });
        _this.props.updateRefigureDetails(_this.props.index, phase);
      }
    });
    Object.defineProperty(_this, 'handleSurfaceType', {
      enumerable: true,
      writable: true,
      value: function value(_value2) {
        var phase = _this.state.phase;
        phase.surface_information = {};
        phase.surface_type.id = _value2;
        phase.surface_type.value = _this.props.surfaceTypes.find(function (type) {
          return type.id === parseInt(_value2, 10);
        }).name;
        _this.setState({ phase: phase });
        _this.props.updateRefigureDetails(_this.props.index, phase);
      }
    });
    Object.defineProperty(_this, 'handleAdditionalDetails', {
      enumerable: true,
      writable: true,
      value: function value(key, _value3) {
        var phase = _this.state.phase;
        phase[key] = _value3;
        _this.props.updateRefigureDetails(_this.props.index, phase);
      }
    });
    Object.defineProperty(_this, 'handleRoomNameChange', {
      enumerable: true,
      writable: true,
      value: function value(_value4) {
        _this.handleAdditionalDetails('roomName', _value4);
      }
    });
    Object.defineProperty(_this, 'handleSpecialInstructions', {
      enumerable: true,
      writable: true,
      value: function value(_value5) {
        _this.handleAdditionalDetails('specialInstructions', _value5);
      }
    });


    _this.state = {
      phase: { sqft: '', surface_information: {}, surface_type: { id: '' } },
      actions: [{
        icon: 'delete',
        onClick: function onClick(e) {
          _this.deleteDetails(e);
        }
      }]
    };
    return _this;
  }

  refigureCard__createClass(RefigureCard, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          surfaceTypes = _props.surfaceTypes,
          index = _props.index,
          errors = _props.errors;
      var phase = this.state.phase;

      var refigureError = Object(lodash["has"])(errors, 'refigureDetails') ? errors.refigureDetails[index] : {};
      return react_default.a.createElement(
        'div',
        { className: refigure_default.a.RefigureCardWrapper },
        react_default.a.createElement(
          components_CollapsableCard,
          {
            title: 'Refigure #' + (index + 1),
            actions: this.state.actions,
            headerStyles: refigure_default.a.collapsableCardHeader
          },
          react_default.a.createElement(
            'div',
            { className: form_default.a.divider },
            react_default.a.createElement(
              'h5',
              { className: refigureCard_titleStyle },
              'Surface Information'
            ),
            react_default.a.createElement(components_StyledSelect, {
              className: refigureCard_largeInput,
              label: 'Surface Type',
              onChange: this.handleSurfaceType,
              options: Object(utils["j" /* generateSource */])(surfaceTypes),
              value: phase.surface_type.id,
              placeholder: 'Select Surface Type',
              error: Object(utils["c" /* error */])('surface_type', refigureError),
              required: true
            })
          ),
          react_default.a.createElement(phaseSurfaceInfoForm, {
            phase: phase,
            surfaceTypes: surfaceTypes,
            onChange: this.handleSurfaceInfoChange,
            onPhaseChange: this.handleSurfaceInfoChange
          }),
          react_default.a.createElement(
            'div',
            { className: form_default.a.divider },
            react_default.a.createElement(
              'h5',
              { className: refigureCard_titleStyle },
              'Additional Details'
            ),
            react_default.a.createElement(react_toolbox_lib["Input"], {
              label: 'Room Names',
              className: refigureCard_largeInput,
              value: phase.roomName || '',
              onChange: this.handleRoomNameChange
            }),
            react_default.a.createElement(react_toolbox_lib["Input"], {
              multiline: true,
              label: 'Special Instructions',
              theme: form_default.a,
              value: phase.specialInstructions || '',
              className: form_default.a.textArea,
              onChange: this.handleSpecialInstructions
            })
          )
        )
      );
    }
  }]);

  return RefigureCard;
}(react["Component"]);

refigureCard_RefigureCard.propTypes = {
  index: prop_types_default.a.number,
  surfaceTypes: prop_types_default.a.array,
  updateRefigureDetails: prop_types_default.a.func,
  deleteRefigureDetails: prop_types_default.a.func,
  errors: prop_types_default.a.object
};

/* harmony default export */ var refigureCard = (refigureCard_RefigureCard);
// CONCATENATED MODULE: ./client/app/screens/refigure/form/components/storeInformation.jsx
var storeInformation__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var storeInformation__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function storeInformation__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function storeInformation__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function storeInformation__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var storeInformation_largeInput = classnames_default()(form_default.a.inputs, form_default.a.largeInput);
var storeInformation_titleStyle = classnames_default()(form_default.a.bottomTitle, form_default.a.childTitle);
var storeInformation_DEFAULT_STATE = {
  associateName: '',
  associateEmail: ''
};

var storeInformation_StoreInformation = function (_Component) {
  storeInformation__inherits(StoreInformation, _Component);

  function StoreInformation() {
    var _ref;

    var _temp, _this, _ret;

    storeInformation__classCallCheck(this, StoreInformation);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = storeInformation__possibleConstructorReturn(this, (_ref = StoreInformation.__proto__ || Object.getPrototypeOf(StoreInformation)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'state', {
      enumerable: true,
      writable: true,
      value: storeInformation_DEFAULT_STATE
    }), Object.defineProperty(_this, 'handleStoreInformation', {
      enumerable: true,
      writable: true,
      value: function value(key, _value) {
        var state = _this.state;
        state[key] = _value;
        _this.setState(storeInformation__extends({}, state));
        _this.props.updateStoreInformation(_this.state);
      }
    }), Object.defineProperty(_this, 'handleNameChange', {
      enumerable: true,
      writable: true,
      value: function value(_value2) {
        _this.handleStoreInformation('associateName', _value2);
      }
    }), Object.defineProperty(_this, 'handleEmailChange', {
      enumerable: true,
      writable: true,
      value: function value(_value3) {
        _this.handleStoreInformation('associateEmail', _value3);
      }
    }), _temp), storeInformation__possibleConstructorReturn(_this, _ret);
  }

  storeInformation__createClass(StoreInformation, [{
    key: 'render',
    value: function render() {
      var _state = this.state,
          associateName = _state.associateName,
          associateEmail = _state.associateEmail;
      var errors = this.props.errors;

      return react_default.a.createElement(
        'div',
        { className: form_default.a.divider },
        react_default.a.createElement(
          'h5',
          { className: storeInformation_titleStyle },
          'Store Information'
        ),
        react_default.a.createElement(
          flexbox_react_dist_default.a,
          { flexWrap: 'wrap' },
          react_default.a.createElement(react_toolbox_lib["Input"], {
            label: 'Associate\'s Name',
            className: storeInformation_largeInput,
            value: associateName,
            onChange: this.handleNameChange,
            error: Object(utils["c" /* error */])('associateName', errors),
            required: true
          }),
          react_default.a.createElement(react_toolbox_lib["Input"], {
            label: 'Associate\'s Email Address',
            className: storeInformation_largeInput,
            value: associateEmail,
            onChange: this.handleEmailChange,
            error: Object(utils["c" /* error */])('associateEmail', errors),
            required: true
          })
        )
      );
    }
  }]);

  return StoreInformation;
}(react["Component"]);

storeInformation_StoreInformation.propTypes = {
  updateStoreInformation: prop_types_default.a.func,
  errors: prop_types_default.a.object
};

/* harmony default export */ var storeInformation = (storeInformation_StoreInformation);
// CONCATENATED MODULE: ./client/app/screens/refigure/form/components/specialOptions.jsx
var specialOptions__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var specialOptions__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function specialOptions__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function specialOptions__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function specialOptions__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var specialOptions_titleStyle = classnames_default()(form_default.a.bottomTitle, form_default.a.childTitle);
var specialOptions_DEFAULT_STATE = {
  rushRequest: false,
  commercialRefigure: false,
  rushRequestNote: ''
};

var specialOptions_SpecialOptions = function (_Component) {
  specialOptions__inherits(SpecialOptions, _Component);

  function SpecialOptions() {
    var _ref;

    var _temp, _this, _ret;

    specialOptions__classCallCheck(this, SpecialOptions);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = specialOptions__possibleConstructorReturn(this, (_ref = SpecialOptions.__proto__ || Object.getPrototypeOf(SpecialOptions)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'state', {
      enumerable: true,
      writable: true,
      value: specialOptions_DEFAULT_STATE
    }), Object.defineProperty(_this, 'handleSpecialOptions', {
      enumerable: true,
      writable: true,
      value: function value(key, _value) {
        var state = _this.state;
        state[key] = _value;
        _this.setState(specialOptions__extends({}, state));
        _this.props.updateSpecialOptions(_this.state);
      }
    }), Object.defineProperty(_this, 'handleRushChange', {
      enumerable: true,
      writable: true,
      value: function value(_value2) {
        _this.handleSpecialOptions('rushRequest', _value2);
      }
    }), Object.defineProperty(_this, 'handleCommercialChange', {
      enumerable: true,
      writable: true,
      value: function value(_value3) {
        _this.handleSpecialOptions('commercialRefigure', _value3);
      }
    }), Object.defineProperty(_this, 'handleRushNoteChange', {
      enumerable: true,
      writable: true,
      value: function value(_value4) {
        _this.handleSpecialOptions('rushRequestNote', _value4);
      }
    }), _temp), specialOptions__possibleConstructorReturn(_this, _ret);
  }

  specialOptions__createClass(SpecialOptions, [{
    key: 'render',
    value: function render() {
      var _state = this.state,
          rushRequest = _state.rushRequest,
          commercialRefigure = _state.commercialRefigure,
          rushRequestNote = _state.rushRequestNote;

      return react_default.a.createElement(
        'div',
        { className: form_default.a.divider },
        react_default.a.createElement(
          'h5',
          { className: specialOptions_titleStyle },
          'Special Options (may not be applicable)'
        ),
        react_default.a.createElement(
          flexbox_react_dist_default.a,
          { flexWrap: 'wrap' },
          react_default.a.createElement(react_toolbox_lib["Checkbox"], {
            checked: rushRequest,
            label: 'RUSH REQUEST (CUSTOMER IN STORE)',
            theme: checkbox_default.a,
            className: form_default.a.checkboxListItem,
            onChange: this.handleRushChange
          }),
          react_default.a.createElement(react_toolbox_lib["Checkbox"], {
            checked: commercialRefigure,
            label: 'COMMERCIAL REFIGURE (REQUIRES APPROVAL)',
            theme: checkbox_default.a,
            className: form_default.a.checkboxListItem,
            onChange: this.handleCommercialChange
          })
        ),
        rushRequest && react_default.a.createElement(react_toolbox_lib["Input"], {
          multiline: true,
          required: true,
          label: 'Reason For Rush Request',
          theme: form_default.a,
          value: rushRequestNote,
          className: form_default.a.textArea,
          error: Object(utils["c" /* error */])('rushRequestNote', this.props.errors),
          onChange: this.handleRushNoteChange
        })
      );
    }
  }]);

  return SpecialOptions;
}(react["Component"]);

specialOptions_SpecialOptions.propTypes = {
  updateSpecialOptions: prop_types_default.a.func,
  errors: prop_types_default.a.object
};

/* harmony default export */ var components_specialOptions = (specialOptions_SpecialOptions);
// CONCATENATED MODULE: ./client/app/screens/refigure/form/components/refigureActions.jsx








var addRefigureClass = classnames_default()([form_default.a.leftButton, form_default.a.actionButton]);

var refigureActions_RefigureActions = function RefigureActions(_ref) {
  var addRefigureDetails = _ref.addRefigureDetails,
      handleSubmit = _ref.handleSubmit;
  return react_default.a.createElement(
    flexbox_react_dist_default.a,
    { justifyContent: 'flex-end', flexWrap: 'wrap' },
    react_default.a.createElement(
      react_toolbox_lib["CardActions"],
      { className: form_default.a.actionsWrapper },
      react_default.a.createElement(ColoredButton["a" /* default */], {
        className: addRefigureClass,
        responsive: true,
        color: 'blue',
        label: 'ADD REFIGURE',
        onClick: addRefigureDetails
      }),
      react_default.a.createElement(ColoredButton["a" /* default */], {
        className: form_default.a.actionButton,
        responsive: true,
        color: 'green',
        label: 'SUBMIT REFIGURE(S)',
        onClick: handleSubmit
      })
    )
  );
};

refigureActions_RefigureActions.propTypes = {
  addRefigureDetails: prop_types_default.a.func,
  handleSubmit: prop_types_default.a.func
};

/* harmony default export */ var refigureActions = (refigureActions_RefigureActions);
// CONCATENATED MODULE: ./client/app/screens/refigure/form/index.jsx
var form__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var form__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function form__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function form__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function form__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






















var form_theme = { RTInput: input_default.a, RTDropdown: dropdown_default.a, RTCard: styles_card_default.a };
var form_DEFAULT_STATE = {
  allFetched: false,
  refigureDetails: [{ id: 0 }],
  storeInfo: { associateName: '', associateEmail: '' },
  specialOptions: { rushRequest: false, commercialRefigure: false, rushRequestNote: '' },
  errors: {}
};

var form_Refigure = function (_Component) {
  form__inherits(Refigure, _Component);

  function Refigure() {
    var _ref;

    var _temp, _this, _ret;

    form__classCallCheck(this, Refigure);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = form__possibleConstructorReturn(this, (_ref = Refigure.__proto__ || Object.getPrototypeOf(Refigure)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'state', {
      enumerable: true,
      writable: true,
      value: form_DEFAULT_STATE
    }), Object.defineProperty(_this, 'componentDidMount', {
      enumerable: true,
      writable: true,
      value: function value() {
        Promise.all([_this.props.requestSurfaceTypesList(), _this.props.requestRefigureForm()]).then(function () {
          return _this.setState({ allFetched: true });
        });
      }
    }), Object.defineProperty(_this, 'addRefigureDetails', {
      enumerable: true,
      writable: true,
      value: function value() {
        var refigureDetails = _this.state.refigureDetails;
        refigureDetails.push({ id: Math.round(Math.random() * 1000) + 1 });
        _this.setState({ refigureDetails: refigureDetails });
      }
    }), Object.defineProperty(_this, 'updateRefigureDetails', {
      enumerable: true,
      writable: true,
      value: function value(index, details) {
        var refigureDetails = _this.state.refigureDetails;
        Object.assign(refigureDetails[index], details);
        _this.setState({ refigureDetails: refigureDetails });
      }
    }), Object.defineProperty(_this, 'deleteRefigureDetails', {
      enumerable: true,
      writable: true,
      value: function value(index) {
        var refigureDetails = _this.state.refigureDetails;
        refigureDetails.splice(index, 1);
        _this.setState({ refigureDetails: refigureDetails });
      }
    }), Object.defineProperty(_this, 'updateStoreInformation', {
      enumerable: true,
      writable: true,
      value: function value(storeInfo) {
        _this.setState({ storeInfo: storeInfo });
      }
    }), Object.defineProperty(_this, 'updateSpecialOptions', {
      enumerable: true,
      writable: true,
      value: function value(specialOptions) {
        _this.setState({ specialOptions: specialOptions });
      }
    }), Object.defineProperty(_this, 'handleSubmit', {
      enumerable: true,
      writable: true,
      value: function value() {
        var valid = _this.validate();
        if (!valid) return;
        var submitData = form__extends({}, _this.state);
        delete submitData.allFetched;
        delete submitData.errors;
        _this.props.submitRefigureForm(submitData);
      }
    }), Object.defineProperty(_this, 'validate', {
      enumerable: true,
      writable: true,
      value: function value() {
        var errors = {};
        Object.assign(errors, _this.validateStoreInfo());
        Object.assign(errors, _this.validateSpecialOptions());
        Object.assign(errors, _this.validateRefigureDetails());
        _this.setState({ errors: errors });
        return Object.keys(errors).length === 0;
      }
    }), Object.defineProperty(_this, 'validateStoreInfo', {
      enumerable: true,
      writable: true,
      value: function value() {
        var storeInfo = _this.state.storeInfo;

        var errors = {};
        if (!storeInfo.associateName) {
          errors.associateName = ["can't be blank"];
        }
        if (!storeInfo.associateEmail) {
          errors.associateEmail = ["can't be blank"];
        }
        return errors;
      }
    }), Object.defineProperty(_this, 'validateSpecialOptions', {
      enumerable: true,
      writable: true,
      value: function value() {
        var specialOptions = _this.state.specialOptions;

        var errors = {};
        var rushRequest = specialOptions.rushRequest,
            rushRequestNote = specialOptions.rushRequestNote;

        var rushNoteRequired = rushRequest ? !rushRequestNote : false;
        if (rushNoteRequired) {
          errors.rushRequestNote = ["can't be blank"];
        }
        return errors;
      }
    }), Object.defineProperty(_this, 'validateRefigureDetails', {
      enumerable: true,
      writable: true,
      value: function value() {
        var refigureDetails = _this.state.refigureDetails;

        var errors = { refigureDetails: [] };
        var hasError = false;
        refigureDetails.forEach(function (detail) {
          var hasSurfaceType = Object(lodash["has"])(detail, 'surface_type');
          if (!hasSurfaceType || !detail.surface_type.id) {
            hasError = true;
            errors.refigureDetails.push({ surface_type: ["can't be blank"] });
          } else {
            errors.refigureDetails.push({});
          }
        });

        return hasError ? errors : {};
      }
    }), _temp), form__possibleConstructorReturn(_this, _ret);
  }

  form__createClass(Refigure, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          surfaceTypes = _props.surfaceTypes,
          refigureForm = _props.refigureForm;
      var _state = this.state,
          allFetched = _state.allFetched,
          refigureDetails = _state.refigureDetails,
          errors = _state.errors;

      var serverError = Object.keys(refigureForm.errors).length > 0;
      return allFetched ? react_default.a.createElement(
        'div',
        null,
        react_default.a.createElement(refigureHeader, { phaseDetails: refigureForm }),
        react_default.a.createElement(
          'div',
          { className: contentArea_default.a.contentAreaContainer },
          react_default.a.createElement(
            react_css_themr_lib["ThemeProvider"],
            { theme: form_theme },
            react_default.a.createElement(
              components_Card,
              null,
              react_default.a.createElement(storeInformation, {
                updateStoreInformation: this.updateStoreInformation,
                errors: errors
              }),
              react_default.a.createElement(components_specialOptions, { updateSpecialOptions: this.updateSpecialOptions, errors: errors }),
              refigureDetails.map(function (detail, i) {
                return react_default.a.createElement(refigureCard, {
                  key: 'details-' + detail.id,
                  index: i,
                  surfaceTypes: surfaceTypes,
                  updateRefigureDetails: _this2.updateRefigureDetails,
                  deleteRefigureDetails: _this2.deleteRefigureDetails,
                  errors: errors
                });
              }),
              react_default.a.createElement(refigureActions, {
                addRefigureDetails: this.addRefigureDetails,
                handleSubmit: this.handleSubmit
              }),
              serverError && react_default.a.createElement(MessageBox["a" /* default */], { error: true, message: 'This action could not be completed.' })
            )
          )
        )
      ) : react_default.a.createElement(components_Loading, null);
    }
  }]);

  return Refigure;
}(react["Component"]);

form_Refigure.propTypes = {
  surfaceTypes: prop_types_default.a.array,
  requestSurfaceTypesList: prop_types_default.a.func.isRequired,
  requestRefigureForm: prop_types_default.a.func.isRequired,
  refigureForm: prop_types_default.a.object,
  submitRefigureForm: prop_types_default.a.func.isRequired
};

var form_mapStateToProps = function mapStateToProps(state) {
  var refigureForm = state.refigureForm;

  return {
    refigureForm: refigureForm,
    surfaceTypes: Object(reducers["_22" /* getSurfaceTypeList */])(state) || []
  };
};

/* harmony default export */ var refigure_form = (transpiled_default()()(Object(react_redux_es["connect"])(form_mapStateToProps, {
  requestRefigureForm: actionCreators["_21" /* requestRefigureForm */],
  requestSurfaceTypesList: actionCreators["_25" /* requestSurfaceTypesList */],
  submitRefigureForm: actionCreators["_56" /* submitRefigureForm */]
})(form_Refigure)));
// EXTERNAL MODULE: ./client/app/screens/refigure/thankyou/thankyou.scss
var thankyou = __webpack_require__("IGnt");
var thankyou_default = /*#__PURE__*/__webpack_require__.n(thankyou);

// CONCATENATED MODULE: ./client/app/screens/refigure/thankyou/index.jsx
var thankyou__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function thankyou__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function thankyou__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function thankyou__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var thankyou_RefigureThankYou = function (_Component) {
  thankyou__inherits(RefigureThankYou, _Component);

  function RefigureThankYou(props) {
    thankyou__classCallCheck(this, RefigureThankYou);

    var _this = thankyou__possibleConstructorReturn(this, (RefigureThankYou.__proto__ || Object.getPrototypeOf(RefigureThankYou)).call(this, props));

    _this.state = {};
    return _this;
  }

  thankyou__createClass(RefigureThankYou, [{
    key: 'render',
    value: function render() {
      return react_default.a.createElement(
        'div',
        { className: thankyou_default.a.wrapper },
        react_default.a.createElement(
          components_Card,
          { theme: thankyou_default.a },
          react_default.a.createElement(
            lib_card["CardMedia"],
            null,
            react_default.a.createElement('img', { className: thankyou_default.a.spLogo, alt: 'Service Pros logo', src: sp_logo_default.a })
          ),
          react_default.a.createElement(
            lib_card["CardText"],
            null,
            'Thank you for submitting a refigure to Service Pros. Please allow 24 hours for processing unless the refigure was indicated as a rush job. If you have any questions or concerns, please contact us at 336-792-4111.'
          )
        )
      );
    }
  }]);

  return RefigureThankYou;
}(react["Component"]);

thankyou_RefigureThankYou.propTypes = {};

/* harmony default export */ var refigure_thankyou = (thankyou_RefigureThankYou);
// EXTERNAL MODULE: ./client/app/screens/printLabel/printLabel.scss
var printLabel_printLabel = __webpack_require__("FhFp");
var printLabel_printLabel_default = /*#__PURE__*/__webpack_require__.n(printLabel_printLabel);

// CONCATENATED MODULE: ./client/app/screens/printLabel/index.jsx
var printLabel__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function screens_printLabel__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function screens_printLabel__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function screens_printLabel__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var screens_printLabel_PrintLabel = function (_Component) {
  screens_printLabel__inherits(PrintLabel, _Component);

  function PrintLabel() {
    screens_printLabel__classCallCheck(this, PrintLabel);

    return screens_printLabel__possibleConstructorReturn(this, (PrintLabel.__proto__ || Object.getPrototypeOf(PrintLabel)).apply(this, arguments));
  }

  printLabel__createClass(PrintLabel, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.print();
    }
  }, {
    key: 'render',
    value: function render() {
      var queryData = this.props.location.query.queryData;

      var stringifiedQuery = atob(JSON.parse(queryData));
      var query = JSON.parse(stringifiedQuery);

      return react_default.a.createElement(
        react["Fragment"],
        null,
        query.map(function (item) {
          return react_default.a.createElement(
            react["Fragment"],
            { key: item.poNumber },
            react_default.a.createElement(
              'div',
              { className: printLabel_printLabel_default.a.wrapper },
              react_default.a.createElement(
                'p',
                { className: printLabel_printLabel_default.a.wrapperParagraph },
                item.customerName.toUpperCase()
              ),
              react_default.a.createElement(
                'p',
                { className: printLabel_printLabel_default.a.wrapperParagraph },
                item.poNumber
              ),
              react_default.a.createElement(
                'p',
                { className: printLabel_printLabel_default.a.wrapperParagraph },
                item.storeNumber
              ),
              react_default.a.createElement(
                'p',
                { className: printLabel_printLabel_default.a.wrapperParagraph },
                item.itemName
              ),
              react_default.a.createElement(
                'p',
                { className: printLabel_printLabel_default.a.wrapperParagraph },
                'Quantity: ',
                Math.floor(item.quantity)
              ),
              react_default.a.createElement(
                'p',
                { className: printLabel_printLabel_default.a.wrapperParagraph + ' ' + printLabel_printLabel_default.a.isLarge },
                item.tagNumber
              ),
              react_default.a.createElement(
                'p',
                { className: printLabel_printLabel_default.a.wrapperParagraph },
                item.dateReceived
              ),
              react_default.a.createElement(
                'p',
                { className: printLabel_printLabel_default.a.wrapperParagraph },
                item.bin
              ),
              react_default.a.createElement('br', null),
              item.pads.length > 0 && item.pads.map(function (pad) {
                return react_default.a.createElement(
                  'div',
                  { key: pad.description },
                  react_default.a.createElement(
                    'p',
                    { className: printLabel_printLabel_default.a.wrapperParagraph },
                    pad.description
                  ),
                  react_default.a.createElement(
                    'p',
                    { className: printLabel_printLabel_default.a.wrapperParagraph },
                    pad.cut_quantity
                  )
                );
              })
            ),
            react_default.a.createElement('footer', null)
          );
        })
      );
    }
  }]);

  return PrintLabel;
}(react["Component"]);

screens_printLabel_PrintLabel.propTypes = {
  location: prop_types_default.a.shape({
    query: prop_types_default.a.shape({
      queryData: prop_types_default.a.string
    })
  })
};

/* harmony default export */ var screens_printLabel = (screens_printLabel_PrintLabel);
// CONCATENATED MODULE: ./client/app/app.jsx
/* eslint-disable max-len */





// eslint-disable-next-line no-unused-vars














// import Dashboard from './screens/main/screens/dashboard';


























var Authenticated = userIsAuthenticated(function (props) {
  return props.children;
});

var app_App = function App(props) {
  return react_default.a.createElement(
    'div',
    null,
    react_default.a.createElement(Helmet_default.a, {
      titleTemplate: '%s - Service Pros',
      defaultTitle: 'Service Pros'
    }),
    react_default.a.createElement(
      es["e" /* Router */],
      { name: 'app', history: props.history, render: Object(es["f" /* applyRouterMiddleware */])(Object(lib["useScroll"])()) },
      react_default.a.createElement(
        es["d" /* Route */],
        { component: Authenticated },
        react_default.a.createElement(
          es["d" /* Route */],
          { name: 'main', path: '/', component: main },
          react_default.a.createElement(es["b" /* IndexRoute */], { component: main_redirect }),
          react_default.a.createElement(
            es["d" /* Route */],
            { name: 'phases', path: '/phases', component: Auth_userCan('view', 'phase', screens_phases) },
            react_default.a.createElement(es["b" /* IndexRoute */], { name: 'phase-list', component: phases_phaseList }),
            react_default.a.createElement(es["d" /* Route */], { name: 'phase-add', path: 'new', component: Auth_userCan('create', 'phase', phaseNew) }),
            react_default.a.createElement(
              es["d" /* Route */],
              { name: 'phase-show', path: ':id', component: Auth_userCan('view', 'phase', phaseShow) },
              react_default.a.createElement(es["a" /* IndexRedirect */], { to: 'history' }),
              react_default.a.createElement(es["d" /* Route */], { name: 'phase-history', path: 'history', component: Auth_userCan('view', 'event', tabs_phaseHistory, { redirectPath: 'labor-product-accounting' }) }),
              react_default.a.createElement(es["d" /* Route */], { name: 'phase-info', path: 'info', component: Auth_userCan('view', 'phase_info', tabs_phaseDetails, { redirectPath: 'labor-product-accounting' }) }),
              react_default.a.createElement(es["d" /* Route */], { name: 'phase-labor-product-accounting', path: 'labor-product-accounting(/:table)', component: Auth_userCan('view', ['accounting', 'labor'], phaseContractVerification, { redirectPath: 'labor-product-accounting' }) }),
              react_default.a.createElement(es["d" /* Route */], { name: 'phase-documents', path: 'documents', component: Auth_userCan('view', 'document', phaseDocuments, { redirectPath: 'labor-product-accounting' }) }),
              react_default.a.createElement(es["d" /* Route */], { name: 'phase-cv-checklist', path: 'cv-checklist', component: Auth_userCan('view', 'labor', phaseContractVerificationChecklist, { redirectPath: 'labor-product-accounting' }) }),
              react_default.a.createElement(es["d" /* Route */], { name: 'phase-scheduling-checklist', path: 'scheduling-checklist', component: Auth_userCan('manage', 'checklist', phaseSchedulingChecklist, { redirectPath: 'labor-product-accounting' }) }),
              react_default.a.createElement(es["d" /* Route */], { name: 'phase-appointments', path: 'appointments', component: Auth_userCan('view', 'appointment', phaseAppointments, { redirectPath: 'labor-product-accounting' }) }),
              react_default.a.createElement(es["d" /* Route */], { name: 'phase-new-appointment', path: 'appointments/new/:apptType', component: Auth_userCan('create', 'appointment', newPhaseAppointment) }),
              react_default.a.createElement(es["d" /* Route */], { name: 'phase-edit-appointment', path: 'appointments/:appointmentId/edit/:apptType', component: Auth_userCan('update', 'appointment', components_editPhaseAppointment) }),
              react_default.a.createElement(es["d" /* Route */], { name: 'related-phases', path: 'related-phases', component: Auth_userCan('view', 'related_phase', tabs_relatedPhases, { redirectPath: 'labor-product-accounting' }) }),
              react_default.a.createElement(es["d" /* Route */], { name: 'warehouse-materials', path: 'warehouse-materials', component: Auth_userCan('view', 'warehouse', warehouseMaterials, { redirectPath: 'labor-product-accounting' }) }),
              react_default.a.createElement(es["d" /* Route */], { name: 'phase-communications', path: 'communications', component: Auth_userCan('view', 'communications', phaseCommunications, { redirectPath: 'labor-product-accounting' }) }),
              react_default.a.createElement(es["d" /* Route */], { name: 'phase-materials-checklist', path: 'materials-checklist', component: Auth_userCan('view', 'materials_checklist', phaseMaterialsChecklist, { redirectPath: 'labor-product-accounting' }) }),
              react_default.a.createElement(es["d" /* Route */], { name: 'phase-ifi-template', path: 'ifi-template', component: ifiTemplate })
            ),
            react_default.a.createElement(es["d" /* Route */], { name: 'phase-edit', path: ':id/edit', component: Auth_userCan('update', 'phase', phaseEdit) })
          ),
          react_default.a.createElement(es["d" /* Route */], { name: 'schedule', path: '/schedule(/:year/:month/:day)', component: Auth_userCan('view', 'schedule', screens_schedule) }),
          react_default.a.createElement(
            es["d" /* Route */],
            { name: 'reports', path: '/reports' },
            react_default.a.createElement(es["d" /* Route */], { name: 'warehouse-report', path: 'warehouse', component: warehouse }),
            react_default.a.createElement(es["d" /* Route */], { name: 'install-workorder-report', path: 'install-workorder', component: installWorkorderReport }),
            react_default.a.createElement(es["d" /* Route */], { name: 'job-history-report', path: 'job-history', component: jobHistory }),
            react_default.a.createElement(es["d" /* Route */], { name: 'installer-paperwork', path: 'installer-paperwork', component: installerPaperwork }),
            react_default.a.createElement(es["d" /* Route */], { name: 'activity-report', path: 'activity', component: activity }),
            react_default.a.createElement(es["d" /* Route */], { name: 'tags-report', path: 'tags-report', component: reports_tags })
          ),
          react_default.a.createElement(
            es["d" /* Route */],
            { name: 'tools', path: '/tools' },
            react_default.a.createElement(es["d" /* Route */], { name: 'scraper', path: 'scraper', component: tools_scraper })
          ),
          react_default.a.createElement(
            es["d" /* Route */],
            { name: 'employees', path: '/employees', component: Auth_userCan('view', 'employee', screens_employees) },
            react_default.a.createElement(es["b" /* IndexRoute */], { name: 'employee-list', component: employeeList }),
            react_default.a.createElement(es["d" /* Route */], { name: 'employee-add', path: 'new', component: Auth_userCan('create', 'employee', employeeNew) }),
            react_default.a.createElement(es["d" /* Route */], {
              name: 'employee-edit',
              path: ':id/edit',
              component: Auth_userCan('update', 'employee', employeeEdit)
            }),
            react_default.a.createElement(es["d" /* Route */], { name: 'employee-details', path: ':id', component: Auth_userCan('view', 'employee', employeeDetails) })
          ),
          react_default.a.createElement(
            es["d" /* Route */],
            { name: 'iqms', path: '/iqms', component: Auth_userCan('view', 'iqm', screens_iqms) },
            react_default.a.createElement(es["b" /* IndexRoute */], { name: 'iqm-list', component: iqms_IQMList }),
            react_default.a.createElement(es["d" /* Route */], { name: 'iqm-add', path: 'new', component: Auth_userCan('create', 'iqm', iqms_IQMNew) }),
            react_default.a.createElement(es["d" /* Route */], {
              name: 'iqm-edit',
              path: ':id/edit',
              component: Auth_userCan('update', 'iqm', iqms_IQMEdit)
            }),
            react_default.a.createElement(es["d" /* Route */], { name: 'iqm-details', path: ':id', component: Auth_userCan('view', 'iqm', iqms_IQMDetails) })
          ),
          react_default.a.createElement(
            es["d" /* Route */],
            { name: 'stores', path: '/stores', component: Auth_userCan('view', 'store', screens_stores) },
            react_default.a.createElement(es["b" /* IndexRoute */], { name: 'store-list', component: storeList }),
            react_default.a.createElement(es["d" /* Route */], { name: 'store-add', path: 'new', component: Auth_userCan('create', 'store', storeNew) }),
            react_default.a.createElement(es["d" /* Route */], { name: 'store-details', path: ':id', component: Auth_userCan('view', 'store', stores_storeDetails) }),
            react_default.a.createElement(es["d" /* Route */], { name: 'store-edit', path: ':id/edit', component: Auth_userCan('update', 'store', storeEdit) })
          ),
          react_default.a.createElement(
            es["d" /* Route */],
            { name: 'estimators', path: '/estimators', component: Auth_userCan('view', 'estimator', screens_estimators) },
            react_default.a.createElement(es["b" /* IndexRoute */], { name: 'estimator-list', component: estimatorList }),
            react_default.a.createElement(es["d" /* Route */], { name: 'estimator-add', path: 'new', component: Auth_userCan('create', 'estimator', estimatorNew) }),
            react_default.a.createElement(es["d" /* Route */], { name: 'estimator-details', path: ':id', component: Auth_userCan('view', 'estimator', estimatorDetails) }),
            react_default.a.createElement(es["d" /* Route */], { name: 'estimator-edit', path: ':id/edit', component: Auth_userCan('update', 'estimator', estimatorEdit) })
          ),
          react_default.a.createElement(
            es["d" /* Route */],
            { name: 'installers', path: '/installers', component: Auth_userCan('view', 'installer', screens_installers) },
            react_default.a.createElement(es["b" /* IndexRoute */], { name: 'installer-list', component: installerList }),
            react_default.a.createElement(es["d" /* Route */], { name: 'installer-add', path: 'new', component: Auth_userCan('create', 'installer', installerNew) }),
            react_default.a.createElement(es["d" /* Route */], { name: 'installer-details', path: ':id', component: Auth_userCan('view', 'installer', installerDetails) }),
            react_default.a.createElement(es["d" /* Route */], { name: 'installer-edit', path: ':id/edit', component: Auth_userCan('update_basic', 'installer', installerEdit) })
          ),
          react_default.a.createElement(
            es["d" /* Route */],
            { name: 'workrooms', path: '/workrooms', component: Auth_userCan('view', 'workroom', screens_workrooms) },
            react_default.a.createElement(es["b" /* IndexRoute */], { name: 'workroom-list', component: workroomList }),
            react_default.a.createElement(es["d" /* Route */], { name: 'workroom-add', path: 'new', component: Auth_userCan('create', 'workroom', workroomNew) }),
            react_default.a.createElement(es["d" /* Route */], { name: 'workroom-details', path: ':id', component: Auth_userCan('view', 'workroom', workroomDetails) }),
            react_default.a.createElement(es["d" /* Route */], { name: 'workroom-edit', path: ':id/edit', component: Auth_userCan('update', 'workroom', workroomEdit) })
          ),
          react_default.a.createElement(es["d" /* Route */], { name: 'pricePatchUploads', path: '/pricepatchuploads', component: Auth_userCan('view', 'price_patch_upload', pricePatchUploads) }),
          react_default.a.createElement(es["d" /* Route */], { name: 'bulkUpdateUploads', path: '/bulk-updates', component: Auth_userCan('view', 'bulk_update_upload', bulkUpdateUploads) }),
          react_default.a.createElement(es["d" /* Route */], { name: 'marginUploads', path: '/margin-updates', component: Auth_userCan('view', 'margin_upload', marginUploads) }),
          react_default.a.createElement(es["d" /* Route */], { name: 'activityUploads', path: '/activity-updates', component: Auth_userCan('view', 'activity_upload', activityUploads) }),
          react_default.a.createElement(es["d" /* Route */], { name: 'bulkProjectsLoad', path: '/bulk-projects', component: Auth_userCan('view', 'bulk_projects_load', bulkProjectsLoad) }),
          react_default.a.createElement(es["d" /* Route */], { name: 'lowesSurveyUploads', path: '/lowes-survey', component: Auth_userCan('view', 'lowes_survey_upload', lowesSurveyUploads) }),
          react_default.a.createElement(es["d" /* Route */], { name: 'line-items', path: '/line-items', component: Auth_userCan('view', 'line_item', screens_lineItems) }),
          react_default.a.createElement(es["d" /* Route */], { name: 'defaultInstallerPay', path: '/default-installer-pay', component: Auth_userCan('manage', 'default_installer_pay', defaultInstallerPay) }),
          react_default.a.createElement(es["d" /* Route */], { name: 'holidayPromoSettings', path: '/holiday-promo-settings', component: Auth_userCan('manage', 'holiday_promo_settings', holidayPromoSettings) })
        )
      ),
      react_default.a.createElement(es["d" /* Route */], { name: 'login', path: '/login', component: screens_login }),
      react_default.a.createElement(es["d" /* Route */], { name: 'refigure', path: '/refigure', component: refigure_form }),
      react_default.a.createElement(es["d" /* Route */], { name: 'refigure-thank-you', path: '/refigure/thankyou', component: refigure_thankyou }),
      react_default.a.createElement(es["d" /* Route */], { name: 'print-label', path: '/print-label', component: screens_printLabel }),
      react_default.a.createElement(es["d" /* Route */], { name: 'unauthorized', path: '/no-access', component: components_Unauthorized }),
      react_default.a.createElement(es["d" /* Route */], { path: '*', component: components_Unauthorized })
    )
  );
};

app_App.propTypes = {
  history: prop_types_default.a.shape({})
};

/* harmony default export */ var app = __webpack_exports__["default"] = (app_App);

/***/ }),

/***/ "RM3C":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"resourceCard__msignaturepad___Ma2NT","m-signature-pad--body":"resourceCard__m-signature-pad--body___1A8my","m-signature-pad--footer":"resourceCard__m-signature-pad--footer___31mpx","description":"resourceCard__description___1V4qS","button":"resourceCard__button___2gHHM","clear":"resourceCard__clear___3Qioc","save":"resourceCard__save___9S05Q","m-signature-pad":"resourceCard__m-signature-pad___2FuKf","github":"resourceCard__github___6dZ6_","resourceCard":"resourceCard__resourceCard___2cguH","selectableCard":"resourceCard__selectableCard___1Qk7V","aside":"resourceCard__aside___3C3cu","viewLink":"resourceCard__viewLink___2Lmnx","cenerLink":"resourceCard__cenerLink___1_Ysk","inactive":"resourceCard__inactive___1QzVv","phoneType":"resourceCard__phoneType___nXUGp","resourceCardColumn":"resourceCard__resourceCardColumn___3gb-O","column":"resourceCard__column___bGm13","mobileColumn":"resourceCard__mobileColumn___27ghW"};

/***/ }),

/***/ "RMfO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___3o94b","m-signature-pad--body":"styles__m-signature-pad--body___3yPjc","m-signature-pad--footer":"styles__m-signature-pad--footer___e3eTe","description":"styles__description___2RP9z","button":"styles__button___LbbVW","clear":"styles__clear___1qNrO","save":"styles__save___3XrYs","m-signature-pad":"styles__m-signature-pad___3mZur","github":"styles__github___20niK","contentArea":"styles__contentArea___sCkcx","addButton":"styles__addButton___2RzgL","apptTypeBtn":"styles__apptTypeBtn___Zpl06","addButtonContainer":"styles__addButtonContainer___2etu1","mainSubmitButton":"styles__mainSubmitButton___2pMWb","formPadding":"styles__formPadding___1cq_H","ResourceDetails":"styles__ResourceDetails___148sr","headerContainer":"styles__headerContainer___27cvy","sectionTitle":"styles__sectionTitle___35NMg","datePicker":"styles__datePicker___1g2gq","emptyAssigneeContainer":"styles__emptyAssigneeContainer___25RGw","error":"styles__error___Az1ec","workerContainer":"styles__workerContainer___2h1eU","assignedWorkerLabel":"styles__assignedWorkerLabel___PXIMJ","saveButtonContainer":"styles__saveButtonContainer___1vfeM","saveButton":"styles__saveButton___1iLg5","availableWorkersContainer":"styles__availableWorkersContainer___QpUlW","confirmationDate":"styles__confirmationDate___1yzZc","editAndDeleteContainer":"styles__editAndDeleteContainer___3ttuW","tooltipBtn":"styles__tooltipBtn___24GXB","tooltipText":"styles__tooltipText___yAP0b","msgCard":"styles__msgCard___1YWtA","scheduleCard":"styles__scheduleCard___2E35w","scheduleBody":"styles__scheduleBody___21OlX","scheduleHeader":"styles__scheduleHeader___26Vt5","filters":"styles__filters___1KSNw","fieldsWarning":"styles__fieldsWarning___3Ummh","apptTypeBtnContainer":"styles__apptTypeBtnContainer___2R0qZ"};

/***/ }),

/***/ "RRIK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___YAXej","m-signature-pad--body":"styles__m-signature-pad--body___1ayBL","m-signature-pad--footer":"styles__m-signature-pad--footer___2KbGo","description":"styles__description___2UjyL","button":"styles__button___3-Bfp","clear":"styles__clear___1Dxzw","save":"styles__save___2akb2","m-signature-pad":"styles__m-signature-pad___2yFZM","github":"styles__github___VikYx","uploadsTable":"styles__uploadsTable___3nhZy","latestSuccess":"styles__latestSuccess___hK4HT","downloadColumn":"styles__downloadColumn___1PjJl","downloadLink":"styles__downloadLink___2chGq","statusText":"styles__statusText___5Xjty","patchLink":"styles__patchLink___2YnAT","centerFont":"styles__centerFont___vgZfX","desktopDate":"styles__desktopDate___3PsGX","mobileDate":"styles__mobileDate___1NMDP","uploadFileWrapper":"styles__uploadFileWrapper___1cby4"};

/***/ }),

/***/ "RbI9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/redux/es/index.js + 6 modules
var es = __webpack_require__("2KeS");

// EXTERNAL MODULE: ./node_modules/react-router-redux/lib/index.js
var lib = __webpack_require__("jZgO");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/redux-ui/transpiled/index.js
var transpiled = __webpack_require__("uEc2");
var transpiled_default = /*#__PURE__*/__webpack_require__.n(transpiled);

// EXTERNAL MODULE: ./client/app/reducers/user.js
var user = __webpack_require__("33h8");

// EXTERNAL MODULE: ./node_modules/reselect/lib/index.js
var reselect_lib = __webpack_require__("bndy");
var reselect_lib_default = /*#__PURE__*/__webpack_require__.n(reselect_lib);

// EXTERNAL MODULE: ./client/app/utils/index.js
var utils = __webpack_require__("FbQg");

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("M4fF");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// CONCATENATED MODULE: ./client/app/reducers/employees.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var employees_resource = function resource(state, _ref) {
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'EMPLOYEE_RESOURCE_REQUEST':
      return _extends({}, state, payload, {
        loading: true
      });
    case 'EMPLOYEE_RESOURCE_SUCCESS':
    case 'EMPLOYEE_RESOURCE_CREATE_SUCCESS':
    case 'EMPLOYEE_RESOURCE_UPDATE_SUCCESS':
      return _extends({}, state, payload, {
        loading: false
      });
    default:
      return state;
  }
};

var employees_byId = function byId() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;

  switch (type) {
    case 'PAY_RATE_UPLOADS_FILE_UPLOAD_SUCCESS':
    case 'PAY_RATE_UPLOADS_LIST_REQUEST_SUCCESS':
      {
        return Object.assign({}, state, payload.entities && payload.entities.employees);
      }
    case 'EMPLOYEE_RESOURCE_REQUEST':
    case 'EMPLOYEE_RESOURCE_SUCCESS':
    case 'EMPLOYEE_RESOURCE_CREATE_SUCCESS':
    case 'EMPLOYEE_RESOURCE_UPDATE_SUCCESS':
      return _extends({}, state, _defineProperty({}, payload.id, employees_resource(state[payload.id], action)));
    case 'EMPLOYEE_LIST_SUCCESS':
      // Test if it is not an overkill, assign always from a new object
      return Object.assign({}, state, Object(utils["t" /* normalize */])(payload.employees));
    case 'ADD_EVENT_TO_EMPLOYEE_SUCCESS':
      {
        var clonedState = Object.assign({}, state);
        clonedState[payload.employeeId] = _extends({}, clonedState[payload.employeeId], {
          events: 'events' in state[payload.employeeId] ? [payload.event].concat(_toConsumableArray(state[payload.employeeId].events)) : [payload.event]
        });
        return clonedState;
      }
    case 'ADD_EVENT_TO_EMPLOYEE_FAILURE':
    default:
      return state;
  }
};

var defaultFilters = {
  data: {
    is_active: true,
    for_workrooms: [],
    is_pending: null,
    for_roles: [],
    query: null
  },
  idsByFilter: [] };

var employees_filters = function filters() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultFilters;
  var _ref2 = arguments[1];
  var type = _ref2.type,
      payload = _ref2.payload;

  switch (type) {
    case 'EMPLOYEE_LIST_SUCCESS':
      {
        return _extends({}, state, {
          idsByFilter: Object(lodash["union"])(state.idsByFilter || [], payload.employees.map(function (item) {
            return item.id;
          }))
        });
      }
    case 'EMPLOYEE_SET_FILTER':
      {
        return _extends({}, state, {
          data: Object.assign({}, payload)
        });
      }
    case 'EMPLOYEE_RESET_FILTERS':
      return defaultFilters;
    // When a user is created/updated the easiest behaviour is to reset pagination
    // so the filters are properly updated in the listing screen
    case 'EMPLOYEE_RESOURCE_CREATE_SUCCESS':
    case 'EMPLOYEE_RESOURCE_UPDATE_SUCCESS':
    case 'EMPLOYEE_RESET_PAGINATION':
      {
        return _extends({}, state, {
          idsByFilter: []
        });
      }
    default:
      return state;
  }
};

var initialState = {
  loading: false,
  errors: {},
  page: 1,
  hasNextPage: true
};

var common = function common() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref3 = arguments[1];
  var type = _ref3.type,
      payload = _ref3.payload;

  switch (type) {
    case 'EMPLOYEE_LIST_REQUEST':
      return _extends({}, state, {
        loading: true
      });
    case 'EMPLOYEE_RESOURCE_CREATE_SUCCESS':
    case 'EMPLOYEE_RESOURCE_UPDATE_SUCCESS':
    case 'EMPLOYEE_RESET_PAGINATION':
      return _extends({}, state, {
        page: 1,
        hasNextPage: true
      });
    case 'EMPLOYEE_LIST_SUCCESS':
      return _extends({}, state, {
        loading: false,
        page: state.page + 1,
        hasNextPage: payload.has_next_page
      });
    case 'EMPLOYEE_LIST_FAILURE':
    case 'EMPLOYEE_RESOURCE_CREATE_FAILURE':
    case 'EMPLOYEE_RESOURCE_UPDATE_FAILURE':
    case 'EMPLOYEE_RESOURCE_SYNC_VALIDATION_FAILURE':
      return _extends({}, state, {
        loading: false,
        errors: payload.errors
      });
    case 'EMPLOYEE_RESOURCE_REQUEST':
    case 'EMPLOYEE_RESOURCE_SUCCESS':
    case 'EMPLOYEE_RESOURCE_CLEAR_VALIDATION':
      return _extends({}, state, {
        errors: {}
      });
    default:
      return state;
  }
};

/* harmony default export */ var employees = (Object(es["combineReducers"])({
  byId: employees_byId,
  common: common,
  filters: employees_filters
}));

var getById = function getById(state) {
  return state.byId;
};
var getHasNextPage = function getHasNextPage(state) {
  return state.common.hasNextPage;
};
var getPage = function getPage(state) {
  return state.common.page;
};
var getLoading = function getLoading(state) {
  return state.common.loading;
};
var getVisibleFilter = function getVisibleFilter(state) {
  return state.filters.data.status;
};
var getFiltersData = function getFiltersData(state) {
  return state.filters.data;
};
var idsByFilter = function idsByFilter(state) {
  return state.filters.idsByFilter;
};
var getErrors = function getErrors(state) {
  return state.common.errors;
};

var employees_getList = Object(reselect_lib["createSelector"])(getById, idsByFilter, function (lookup, list) {
  return list.map(function (id) {
    return lookup[id];
  });
});

var getInactiveVisible = Object(reselect_lib["createSelector"])(getVisibleFilter, function (status) {
  return status === 'all';
});


// CONCATENATED MODULE: ./client/app/reducers/workrooms.js
var workrooms__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function workrooms__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var workrooms_resource = function resource(state, _ref) {
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'WORKROOM_RESOURCE_REQUEST':
      return workrooms__extends({}, state, payload, {
        loading: true
      });
    case 'WORKROOM_RESOURCE_SUCCESS':
    case 'WORKROOM_RESOURCE_CREATE_SUCCESS':
    case 'WORKROOM_RESOURCE_UPDATE_SUCCESS':
      return workrooms__extends({}, state, payload, {
        loading: false
      });
    default:
      return state;
  }
};

var workrooms_byId = function byId() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;

  switch (type) {
    case 'WORKROOM_RESOURCE_REQUEST':
    case 'WORKROOM_RESOURCE_SUCCESS':
    case 'WORKROOM_RESOURCE_CREATE_SUCCESS':
    case 'WORKROOM_RESOURCE_UPDATE_SUCCESS':
      {
        var id = payload.id !== null && payload.id !== undefined ? payload.id : payload.result;
        // If payload has an id, it's a REQUEST action otherwise
        // the id is in the result field from normalizr
        var resourcePayload = payload.entities && payload.entities.workrooms && payload.entities.workrooms[id];
        return workrooms__extends({}, state, workrooms__defineProperty({}, id, workrooms_resource(state[id], { type: type, payload: resourcePayload })));
      }
    case 'WORKROOM_LIST_SUCCESS':
      return Object.assign({}, state, Object(utils["t" /* normalize */])(payload.workrooms));
    case 'ESTIMATOR_LIST_SUCCESS':
    case 'ESTIMATOR_RESOURCE_SUCCESS':
    case 'INSTALLER_RESOURCE_SUCCESS':
      {
        var wr = payload.entities && payload.entities.workrooms;
        return Object(lodash["merge"])({}, state, wr);
      }
    default:
      return state;
  }
};

var workrooms_defaultFilters = {
  data: {
    is_active: true,
    query: null
  },
  idsByFilter: []
};

var workrooms_filters = function filters() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : workrooms_defaultFilters;
  var _ref2 = arguments[1];
  var type = _ref2.type,
      payload = _ref2.payload;

  switch (type) {
    case 'WORKROOM_LIST_SUCCESS':
      return workrooms__extends({}, state, {
        idsByFilter: Object(lodash["union"])(state.idsByFilter || [], payload.workrooms.map(function (item) {
          return item.id;
        }))
      });
    case 'WORKROOM_SET_FILTER':
      return workrooms__extends({}, state, {
        idsByFilter: [],
        data: Object.assign({}, payload)
      });
    case 'WORKROOM_RESET_FILTERS':
      return workrooms_defaultFilters;
    case 'WORKROOM_RESOURCE_CREATE_SUCCESS':
    case 'WORKROOM_RESOURCE_UPDATE_SUCCESS':
      return workrooms__extends({}, state, {
        idsByFilter: []
      });
    default:
      return state;
  }
};

var workrooms_initialState = {
  loading: false,
  loaded: false,
  errors: {},
  page: 1,
  hasNextPage: true
};

var workrooms_common = function common() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : workrooms_initialState;
  var _ref3 = arguments[1];
  var type = _ref3.type,
      payload = _ref3.payload;

  switch (type) {
    case 'WORKROOM_LIST_REQUEST':
      return workrooms__extends({}, state, {
        loading: true
      });
    case 'WORKROOM_RESET_PAGINATION':
      return workrooms__extends({}, state, {
        page: 1,
        hasNextPage: true
      });
    case 'WORKROOM_RESOURCE_CREATE_SUCCESS':
    case 'WORKROOM_RESOURCE_UPDATE_SUCCESS':
      return workrooms__extends({}, state, {
        errors: {},
        page: 1,
        hasNextPage: true
      });
    case 'WORKROOM_LIST_SUCCESS':
      return workrooms__extends({}, state, {
        loading: false,
        loaded: true,
        page: state.page + 1,
        hasNextPage: payload.has_next_page
      });
    case 'WORKROOM_LIST_FAILURE':
    case 'WORKROOM_RESOURCE_CREATE_FAILURE':
    case 'WORKROOM_RESOURCE_UPDATE_FAILURE':
      return workrooms__extends({}, state, {
        loading: false,
        loaded: false,
        errors: payload.errors
      });
    case 'WORKROOM_RESOURCE_REQUEST':
    case 'WORKROOM_RESOURCE_SUCCESS':
      return workrooms__extends({}, state, {
        errors: {}
      });
    default:
      return state;
  }
};

/* harmony default export */ var workrooms = (Object(es["combineReducers"])({
  byId: workrooms_byId,
  common: workrooms_common,
  filters: workrooms_filters
}));

var workrooms_getById = function getById(state) {
  return function (id) {
    return state.byId[id];
  };
};
var workrooms_getHasNextPage = function getHasNextPage(state) {
  return state.common.hasNextPage;
};
var workrooms_getPage = function getPage(state) {
  return state.common.page;
};
var workrooms_getLoading = function getLoading(state) {
  return state.common.loading;
};
var getLoaded = function getLoaded(state) {
  return state.common.loaded;
};
var workrooms_getFiltersData = function getFiltersData(state) {
  return state.filters.data;
};
var workrooms_idsByFilter = function idsByFilter(state) {
  return state.filters.idsByFilter;
};
var workrooms_getErrors = function getErrors(state) {
  return state.common.errors;
};
var getFilteredByIds = function getFilteredByIds(state) {
  return function (ids) {
    return ids.map(function (id) {
      return workrooms_getById(state)(id);
    });
  };
};

var workrooms_getList = Object(reselect_lib["createSelector"])(workrooms_getById, workrooms_idsByFilter, function (lookup, list) {
  return list.map(function (id) {
    return lookup(id);
  });
});


// CONCATENATED MODULE: ./client/app/reducers/tasks.js
var tasks__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var tasks_initialState = {
  loading: false,
  loaded: false,
  errors: {},
  data: []
};

var tasks = function tasks() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : tasks_initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'TASK_LIST_REQUEST':
      return tasks__extends({}, state, {
        loading: true
      });
    case 'TASK_LIST_SUCCESS':
      return tasks__extends({}, state, {
        loading: false,
        loaded: true,
        data: payload
      });
    case 'TASK_LIST_FAILURE':
      return tasks__extends({}, state, {
        loading: false,
        errors: payload.errors
      });
    default:
      return state;
  }
};

/* harmony default export */ var reducers_tasks = (tasks);

var taskList = function taskList(state) {
  return state.data;
};
// CONCATENATED MODULE: ./client/app/reducers/estimators.js
var estimators__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function estimators__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function estimators__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var estimators_resource = function resource(state, _ref) {
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'ESTIMATOR_RESOURCE_REQUEST':
      return estimators__extends({}, state, payload, {
        loading: true
      });
    case 'ESTIMATOR_RESOURCE_SUCCESS':
    case 'ESTIMATOR_RESOURCE_CREATE_SUCCESS':
    case 'ESTIMATOR_RESOURCE_UPDATE_SUCCESS':
      return estimators__extends({}, state, payload, {
        loading: false
      });
    default:
      return state;
  }
};

var estimators_byId = function byId() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;

  switch (type) {
    case 'ESTIMATOR_RESOURCE_REQUEST':
    case 'ESTIMATOR_RESOURCE_SUCCESS':
    case 'ESTIMATOR_RESOURCE_CREATE_SUCCESS':
    case 'ESTIMATOR_RESOURCE_UPDATE_SUCCESS':
      {
        var id = payload.id !== null && payload.id !== undefined ? payload.id : payload.result;
        // If payload has an id, it's a REQUEST action otherwise
        // the id is in the result field from normalizr
        var resourcePayload = payload.entities && payload.entities.estimators && payload.entities.estimators[id];
        return estimators__extends({}, state, estimators__defineProperty({}, id, estimators_resource(state[id], { type: type, payload: resourcePayload })));
      }
    case 'ESTIMATOR_LIST_SUCCESS':
      return Object.assign({}, state, payload.entities && payload.entities.estimators);
    case 'ADD_EVENT_TO_ESTIMATOR_SUCCESS':
      {
        var clonedState = Object.assign({}, state);
        clonedState[payload.estimatorId] = estimators__extends({}, clonedState[payload.estimatorId], {
          events: 'events' in state[payload.estimatorId] ? [payload.event].concat(estimators__toConsumableArray(state[payload.estimatorId].events)) : [payload.event]
        });
        return clonedState;
      }
    case 'ADD_EVENT_TO_ESTIMATOR_FAILURE':
    default:
      return state;
  }
};

var estimators_defaultFilters = {
  data: {
    for_workrooms: [],
    is_active: true,
    is_pending: null,
    query: null
  },
  idsByFilter: []
};

var estimators_filters = function filters() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : estimators_defaultFilters;
  var _ref2 = arguments[1];
  var type = _ref2.type,
      payload = _ref2.payload;

  switch (type) {
    case 'ESTIMATOR_LIST_SUCCESS':
      return estimators__extends({}, state, {
        idsByFilter: Object(lodash["union"])(state.idsByFilter || [], payload.result.estimators)
      });
    case 'ESTIMATOR_SET_FILTER':
      return estimators__extends({}, state, {
        data: Object.assign({}, payload)
      });
    case 'ESTIMATOR_RESET_FILTERS':
      return estimators_defaultFilters;
    case 'ESTIMATOR_RESOURCE_CREATE_SUCCESS':
    case 'ESTIMATOR_RESOURCE_UPDATE_SUCCESS':
    case 'ESTIMATOR_RESET_PAGINATION':
      return estimators__extends({}, state, {
        idsByFilter: []
      });
    default:
      return state;
  }
};

var estimators_initialState = {
  loading: false,
  errors: {},
  page: 1,
  hasNextPage: true
};

var estimators_common = function common() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : estimators_initialState;
  var _ref3 = arguments[1];
  var type = _ref3.type,
      payload = _ref3.payload;

  switch (type) {
    case 'ESTIMATOR_LIST_REQUEST':
      return estimators__extends({}, state, {
        loading: true
      });
    case 'ESTIMATOR_RESOURCE_CREATE_SUCCESS':
    case 'ESTIMATOR_RESOURCE_UPDATE_SUCCESS':
      return estimators__extends({}, state, {
        page: 1,
        hasNextPage: true,
        errors: {}
      });
    case 'ESTIMATOR_RESET_PAGINATION':
      return estimators__extends({}, state, {
        page: 1,
        hasNextPage: true
      });
    case 'ESTIMATOR_LIST_SUCCESS':
      return estimators__extends({}, state, {
        loading: false,
        page: state.page + 1,
        hasNextPage: payload.result.has_next_page
      });
    case 'ESTIMATOR_LIST_FAILURE':
    case 'ESTIMATOR_RESOURCE_CREATE_FAILURE':
    case 'ESTIMATOR_RESOURCE_UPDATE_FAILURE':
      return estimators__extends({}, state, {
        loading: false,
        errors: payload.errors
      });
    case 'ESTIMATOR_RESOURCE_REQUEST':
    case 'ESTIMATOR_RESOURCE_SUCCESS':
    case 'ESTIMATOR_RESOURCE_CLEAR_VALIDATION':
      return estimators__extends({}, state, {
        errors: {}
      });
    default:
      return state;
  }
};

var forZipState = {
  loading: false,
  errors: {},
  data: []
};

var forZipCode = function forZipCode() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : forZipState;
  var _ref4 = arguments[1];
  var type = _ref4.type,
      payload = _ref4.payload;

  switch (type) {
    case 'ESTIMATOR_RESOURCE_FOR_ZIP_CODE_REQUEST':
      return estimators__extends({}, state, {
        loading: true
      });
    case 'ESTIMATOR_RESOURCE_FOR_ZIP_CODE_SUCCESS':
      return estimators__extends({}, state, {
        loading: false,
        data: payload.estimators
      });
    case 'ESTIMATOR_RESOURCE_FOR_ZIP_CODE_FAILURE':
      return estimators__extends({}, state, {
        loading: false,
        errors: payload.errors
      });
    default:
      return state;
  }
};

/* harmony default export */ var estimators = (Object(es["combineReducers"])({
  byId: estimators_byId,
  common: estimators_common,
  filters: estimators_filters,
  forZipCode: forZipCode
}));

var estimators_getById = function getById(state) {
  return function (id) {
    return state.byId[id];
  };
};
var estimators_getHasNextPage = function getHasNextPage(state) {
  return state.common.hasNextPage;
};
var estimators_getPage = function getPage(state) {
  return state.common.page;
};
var estimators_getLoading = function getLoading(state) {
  return state.common.loading;
};
var estimators_getErrors = function getErrors(state) {
  return state.common.errors;
};
var estimators_getFiltersData = function getFiltersData(state) {
  return state.filters.data;
};
var estimators_idsByFilter = function idsByFilter(state) {
  return state.filters.idsByFilter;
};

var estimators_getList = Object(reselect_lib["createSelector"])(estimators_getById, estimators_idsByFilter, function (lookup, list) {
  return list.map(function (id) {
    return lookup(id);
  });
});


// CONCATENATED MODULE: ./client/app/reducers/iqms.js
var iqms__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function iqms__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function iqms__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }






// Results state

var iqms_resource = function resource() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'IQM_LIST_SUCCESS':
      return [].concat(iqms__toConsumableArray(state), iqms__toConsumableArray(payload));
    case 'IQM_RESOURCE_CREATE_SUCCESS':
    case 'IQM_RESOURCE_UPDATE_SUCCESS':
    case 'IQM_RESET_PAGINATION':
      return [];
    default:
      return state;
  }
};

var details = function details() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref2 = arguments[1];
  var type = _ref2.type,
      payload = _ref2.payload;

  switch (type) {
    case 'IQM_RESOURCE_SUCCESS':
    case 'IQM_RESOURCE_CREATE_SUCCESS':
    case 'IQM_RESOURCE_UPDATE_SUCCESS':
      return payload;
    case 'IQM_RESOURCE_REQUEST':
    case 'IQM_RESOURCE_FAILURE':
      return {};
    default:
      return state;
  }
};

// Filters state
var iqms_defaultFilters = {
  data: {
    for_workrooms: [],
    is_active: true,
    is_pending: null,
    query: null
  },
  idsByFilter: []
};

var iqms_filters = function filters() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : iqms_defaultFilters;
  var _ref3 = arguments[1];
  var type = _ref3.type,
      payload = _ref3.payload;

  switch (type) {
    case 'IQM_LIST_SUCCESS':
      return iqms__extends({}, state, {
        idsByFilter: Object(lodash["union"])(state.idsByFilter || [], payload.iqms.map(function (item) {
          return item.id;
        }))
      });
    case 'IQM_SET_FILTER':
      return iqms__extends({}, state, {
        data: Object.assign({}, payload)
      });
    case 'IQM_RESOURCE_CREATE_SUCCESS':
    case 'IQM_RESOURCE_UPDATE_SUCCESS':
    case 'IQM_RESET_PAGINATION':
      return iqms__extends({}, state, {
        idsByFilter: []
      });
    case 'IQM_RESET_FILTERS':
      return iqms__extends({}, iqms_defaultFilters);
    default:
      return state;
  }
};

var iqms_byId = function byId() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;

  switch (type) {
    case 'IQM_RESOURCE_REQUEST':
    case 'IQM_RESOURCE_SUCCESS':
    case 'IQM_RESOURCE_CREATE_SUCCESS':
    case 'IQM_RESOURCE_UPDATE_SUCCESS':
      {
        var id = payload.id !== null && payload.id !== undefined ? payload.id : payload.result;
        // If payload has an id, it's a REQUEST action otherwise
        // the id is in the result field from normalizr
        var resourcePayload = payload.entities && payload.entities.iqms && payload.entities.iqms[id];
        return iqms__extends({}, state, iqms__defineProperty({}, id, iqms_resource(state[id], { type: type, payload: resourcePayload })));
      }
    case 'IQM_LIST_SUCCESS':
      return Object.assign({}, state, Object(utils["t" /* normalize */])(payload.iqms));
    default:
      return state;
  }
};

// Common (errors, loading) state

var initialCommon = {
  loading: false,
  loaded: false,
  errors: {},
  has_next_page: true,
  page: 0
};

var iqms_common = function common() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialCommon;
  var _ref4 = arguments[1];
  var type = _ref4.type,
      payload = _ref4.payload;

  switch (type) {
    case 'IQM_LIST_REQUEST':
    case 'IQM_RESOURCE_REQUEST':
      return iqms__extends({}, state, {
        loading: true,
        loaded: false
      });
    case 'IQM_LIST_SUCCESS':
      return iqms__extends({}, state, {
        loaded: true,
        loading: false,
        page: state.page + 1,
        hasNextPage: payload.has_next_page
      });
    case 'IQM_RESOURCE_SUCCESS':
      return iqms__extends({}, state, {
        loading: false,
        loaded: true,
        errors: {}
      });
    case 'IQM_LIST_FAILURE':
    case 'IQM_RESOURCE_FAILURE':
    case 'IQM_RESOURCE_CREATE_FAILURE':
      return iqms__extends({}, state, {
        loading: false,
        loaded: false,
        errors: payload.errors
      });
    case 'IQM_RESET_PAGINATION':
      return iqms__extends({}, state, {
        page: 1,
        hasNextPage: true
      });
    case 'IQM_RESOURCE_CREATE_SUCCESS':
    case 'IQM_RESOURCE_UPDATE_SUCCESS':
      return iqms__extends({}, state, {
        errors: {},
        page: 1,
        hasNextPage: true
      });
    default:
      return state;
  }
};

/* harmony default export */ var iqms = (Object(es["combineReducers"])({
  byId: iqms_byId,
  resource: iqms_resource,
  details: details,
  common: iqms_common,
  filters: iqms_filters
}));

var iqms_getById = function getById(state) {
  return state.byId;
};
var iqms_getHasNextPage = function getHasNextPage(state) {
  return state.common.hasNextPage;
};
var iqms_getPage = function getPage(state) {
  return state.common.page;
};
var iqms_getLoading = function getLoading(state) {
  return state.common.loading;
};
var iqms_getErrors = function getErrors(state) {
  return state.common.errors;
};
var iqms_getFiltersData = function getFiltersData(state) {
  return state.filters.data;
};
var iqms_idsByFilter = function idsByFilter(state) {
  return state.filters.idsByFilter;
};

var iqms_getList = Object(reselect_lib["createSelector"])(iqms_getById, iqms_idsByFilter, function (lookup, list) {
  return list.map(function (id) {
    return lookup[id];
  });
});


// CONCATENATED MODULE: ./client/app/reducers/flags.js
var flags__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var flags_initialState = {
  flags: [],
  errors: {}
};

var flags = function flags() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : flags_initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'FLAGS_RESOURCE_SUCCESS':
      return flags__extends({}, state, {
        flags: payload.flag_options
      });
    case 'FLAGS_RESOURCE_FAILURE':
      return flags__extends({}, state, {
        errors: payload.errors
      });
    default:
      return state;
  }
};

/* harmony default export */ var reducers_flags = (flags);

var getFlags = function getFlags(state) {
  return state.flags;
};

// CONCATENATED MODULE: ./client/app/reducers/stores.js
var stores__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function stores__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var stores_initialState = {
  loading: false,
  loaded: false,
  errors: {},
  page: 1,
  hasNextPage: true
};

var stores_resource = function resource(state, _ref) {
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'STORE_RESOURCE_REQUEST':
      return stores__extends({}, state, payload, {
        loading: true
      });
    case 'STORE_RESOURCE_SUCCESS':
    case 'STORE_RESOURCE_CREATE_SUCCESS':
      return Object(lodash["merge"])({}, state, payload, { loading: false });
    case 'STORE_RESOURCE_UPDATE_SUCCESS':
      return stores__extends({}, state, payload, {
        loading: false
      });
    default:
      return state;
  }
};

var stores_byId = function byId() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;

  switch (type) {
    case 'STORE_RESOURCE_REQUEST':
    case 'STORE_RESOURCE_SUCCESS':
    case 'STORE_RESOURCE_CREATE_SUCCESS':
    case 'STORE_RESOURCE_UPDATE_SUCCESS':
      {
        var id = Object(utils["l" /* getIdFromPayload */])(payload);
        var resourcePayload = Object(utils["n" /* getResource */])('stores', payload, id);
        return stores__extends({}, state, stores__defineProperty({}, id, stores_resource(state[id], { type: type, payload: resourcePayload })));
      }
    case 'STORE_LIST_SUCCESS':
      return payload.entities.stores || {};
    default:
      return state;
  }
};

var stores_common = function common() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : stores_initialState;
  var _ref2 = arguments[1];
  var type = _ref2.type,
      payload = _ref2.payload;

  switch (type) {
    case 'STORE_LIST_REQUEST':
      return stores__extends({}, state, {
        loading: true
      });
    case 'STORE_LIST_SUCCESS':
      return stores__extends({}, state, {
        loading: false,
        loaded: true,
        page: state.page + 1,
        hasNextPage: payload.result.has_next_page
      });
    case 'STORE_LIST_FAILURE':
    case 'STORE_RESOURCE_CREATE_FAILURE':
    case 'STORE_RESOURCE_UPDATE_FAILURE':
    case 'STORE_RESOURCE_SYNC_VALIDATION_FAILURE':
      return stores__extends({}, state, {
        loading: false,
        errors: payload.errors
      });
    case 'STORE_RESOURCE_REQUEST':
      return stores__extends({}, state, {
        errors: {}
      });
    case 'STORE_RESOURCE_SUCCESS':
    case 'STORE_RESOURCE_CREATE_SUCCESS':
    case 'STORE_RESOURCE_UPDATE_SUCCESS':
      return stores__extends({}, state, {
        errors: {}
      });
    case 'STORE_RESOURCE_CLEAR_VALIDATION':
      return stores__extends({}, state, {
        errors: payload.errors
      });
    default:
      return state;
  }
};

var stores_defaultFilters = {
  data: {
    for_workrooms: [],
    for_divisions: [],
    for_regionss: [],
    for_marketss: [],
    all: true,
    query: null
  },
  idsByFilter: []
};

var defaultInstallerPrioritization = {
  installers: [],
  surfaceTypes: [],
  loading: false
};

var installerPrioritization = function installerPrioritization() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultInstallerPrioritization;
  var _ref3 = arguments[1];
  var type = _ref3.type,
      payload = _ref3.payload;

  switch (type) {
    case 'STORE_INSTALLER_PRIORITIZATION_REQUEST':
      return stores__extends({}, state, {
        loading: true
      });
    case 'STORE_INSTALLER_PRIORITIZATION_SUCCESS':
      return stores__extends({}, state, {
        installers: payload.installers,
        surfaceTypes: payload.surfaceTypes,
        loading: false
      });
    case 'STORE_INSTALLER_PRIORITIZATION_FAILURE':
      return stores__extends({}, state, {
        loading: false
      });
    case 'STORE_INSTALLER_PRIORITIZATION_RESET':
      return defaultInstallerPrioritization;
    default:
      return state;
  }
};

var stores_filters = function filters() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : stores_defaultFilters;
  var _ref4 = arguments[1];
  var type = _ref4.type,
      payload = _ref4.payload;

  switch (type) {
    case 'STORE_LIST_SUCCESS':
      return stores__extends({}, state, {
        idsByFilter: payload.result.stores
      });
    case 'STORE_SET_FILTER':
      return stores__extends({}, state, {
        idsByFilter: [],
        data: stores__extends({}, payload)
      });
    case 'STORE_RESET_FILTERS':
      return stores_defaultFilters;
    default:
      return state;
  }
};

/* harmony default export */ var stores = (Object(es["combineReducers"])({
  byId: stores_byId,
  common: stores_common,
  filters: stores_filters,
  installerPrioritization: installerPrioritization
}));

var stores_getById = function getById(state) {
  return function (id) {
    return state.byId[id];
  };
};
var stores_getHasNextPage = function getHasNextPage(state) {
  return state.common.hasNextPage;
};
var stores_getPage = function getPage(state) {
  return state.common.page;
};
var stores_getLoading = function getLoading(state) {
  return state.common.loading;
};
var stores_getLoaded = function getLoaded(state) {
  return state.common.loaded;
};
var stores_getErrors = function getErrors(state) {
  return state.common.errors;
};
var stores_idsByFilter = function idsByFilter(state) {
  return state.filters.idsByFilter;
};
var stores_getFiltersData = function getFiltersData(state) {
  return state.filters.data;
};
var getInstallerPrioritization = function getInstallerPrioritization(state) {
  return state.installerPrioritization;
};

var stores_getList = Object(reselect_lib["createSelector"])(stores_getById, stores_idsByFilter, function (lookup, list) {
  return list.map(function (id) {
    return lookup(id);
  });
});


// CONCATENATED MODULE: ./client/app/reducers/markets.js
var markets__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var markets_initialState = {
  loading: false,
  errors: {},
  data: {}
};

var markets_markets = function markets() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : markets_initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'MARKET_LIST_REQUEST':
      return markets__extends({}, state, {
        loading: true,
        data: {}
      });
    case 'MARKET_LIST_SUCCESS':
      return markets__extends({}, state, {
        loading: false,
        data: Object.assign({}, state.data, Object(utils["t" /* normalize */])(payload))
      });
    case 'MARKET_LIST_FAILURE':
      return markets__extends({}, state, {
        loading: false,
        errors: payload.errors
      });
    default:
      return state;
  }
};

/* harmony default export */ var reducers_markets = (markets_markets);

var markets_marketsList = function marketsList(state) {
  return Object(utils["r" /* mapObjectToList */])(state.data);
};
// CONCATENATED MODULE: ./client/app/reducers/regions.js
var regions__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var regions_initialState = {
  loading: false,
  errors: {},
  data: {}
};

var regions_regions = function regions() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : regions_initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'REGION_LIST_REQUEST':
      return regions__extends({}, state, {
        loading: true,
        data: {}
      });
    case 'REGION_LIST_SUCCESS':
      return regions__extends({}, state, {
        loading: false,
        data: Object.assign({}, state.data, Object(utils["t" /* normalize */])(payload))
      });
    case 'REGION_LIST_FAILURE':
      return regions__extends({}, state, {
        loading: false,
        errors: payload.errors
      });
    default:
      return state;
  }
};

/* harmony default export */ var reducers_regions = (regions_regions);

var regions_regionsList = function regionsList(state) {
  return Object(utils["r" /* mapObjectToList */])(state.data);
};
// CONCATENATED MODULE: ./client/app/reducers/divisions.js
var divisions__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var divisions_initialState = {
  loading: false,
  errors: {},
  data: {}
};

var divisions_divisions = function divisions() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : divisions_initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'DIVISION_LIST_REQUEST':
      return divisions__extends({}, state, {
        loading: true,
        data: {}
      });
    case 'DIVISION_LIST_SUCCESS':
      return divisions__extends({}, state, {
        loading: false,
        data: Object.assign({}, state.data, Object(utils["t" /* normalize */])(payload))
      });
    case 'DIVISION_LIST_FAILURE':
      return divisions__extends({}, state, {
        loading: false,
        errors: payload.errors
      });
    default:
      return state;
  }
};

/* harmony default export */ var reducers_divisions = (divisions_divisions);

var divisions_divisionsList = function divisionsList(state) {
  return Object(utils["r" /* mapObjectToList */])(state.data);
};
// CONCATENATED MODULE: ./client/app/reducers/installers.js
var installers__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function installers__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function installers__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var installers_resource = function resource(state, _ref) {
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'INSTALLER_RESOURCE_REQUEST':
      return installers__extends({}, state, payload, {
        loading: true
      });
    case 'INSTALLER_RESOURCE_SUCCESS':
    case 'INSTALLER_RESOURCE_CREATE_SUCCESS':
    case 'INSTALLER_RESOURCE_UPDATE_SUCCESS':
      return installers__extends({}, state, payload, {
        loading: false
      });
    default:
      return state;
  }
};

var installers_byId = function byId() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;

  switch (type) {
    case 'INSTALLER_RESOURCE_REQUEST':
    case 'INSTALLER_RESOURCE_SUCCESS':
    case 'INSTALLER_RESOURCE_CREATE_SUCCESS':
    case 'INSTALLER_RESOURCE_UPDATE_SUCCESS':
      {
        var id = payload.id !== null && payload.id !== undefined ? payload.id : payload.result;
        // If payload has an id, it's a REQUEST action otherwise
        // the id is in the result field from normalizr
        var resourcePayload = payload.entities && payload.entities.installers && payload.entities.installers[id];
        return installers__extends({}, state, installers__defineProperty({}, id, installers_resource(state[id], { type: type, payload: resourcePayload })));
      }
    case 'INSTALLER_LIST_SUCCESS':
      return Object.assign({}, state, Object(utils["t" /* normalize */])(payload.installers));
    case 'ADD_EVENT_TO_INSTALLER_SUCCESS':
      {
        var clonedState = Object.assign({}, state);
        clonedState[payload.installerId] = installers__extends({}, clonedState[payload.installerId], {
          events: 'events' in state[payload.installerId] ? [payload.event].concat(installers__toConsumableArray(state[payload.installerId].events)) : [payload.event]
        });
        return clonedState;
      }
    case 'ADD_EVENT_TO_INSTALLER_FAILURE':
    default:
      return state;
  }
};

var installers_defaultFilters = {
  data: {
    is_active: true,
    for_workrooms: [],
    is_pending: null,
    query: null
  },
  idsByFilter: []
};

var installers_filters = function filters() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : installers_defaultFilters;
  var _ref2 = arguments[1];
  var type = _ref2.type,
      payload = _ref2.payload;

  switch (type) {
    case 'INSTALLER_LIST_SUCCESS':
      return installers__extends({}, state, {
        idsByFilter: Object(lodash["union"])(state.idsByFilter || [], payload.installers.map(function (item) {
          return item.id;
        }))
      });
    case 'INSTALLER_SET_FILTER':
      return installers__extends({}, state, {
        data: Object.assign({}, payload)
      });
    case 'INSTALLER_RESET_FILTERS':
      return installers_defaultFilters;
    // When a installer is created/updated the easiest behaviour is to reset pagination
    // so the filters are properly updated in the listing screen
    case 'INSTALLER_RESOURCE_CREATE_SUCCESS':
    case 'INSTALLER_RESOURCE_UPDATE_SUCCESS':
    case 'INSTALLER_RESET_PAGINATION':
      return installers__extends({}, state, {
        idsByFilter: []
      });
    default:
      return state;
  }
};

var installers_initialState = {
  loading: false,
  errors: {},
  page: 1,
  hasNextPage: true
};

var installers_common = function common() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : installers_initialState;
  var _ref3 = arguments[1];
  var type = _ref3.type,
      payload = _ref3.payload;

  switch (type) {
    case 'INSTALLER_LIST_REQUEST':
      return installers__extends({}, state, {
        loading: true
      });
    case 'INSTALLER_RESET_PAGINATION':
      return installers__extends({}, state, {
        page: 1,
        hasNextPage: true
      });
    case 'INSTALLER_RESOURCE_CREATE_SUCCESS':
    case 'INSTALLER_RESOURCE_UPDATE_SUCCESS':
      return installers__extends({}, state, {
        errors: {},
        page: 1,
        hasNextPage: true
      });
    case 'INSTALLER_LIST_SUCCESS':
      return installers__extends({}, state, {
        loading: false,
        page: state.page + 1,
        hasNextPage: payload.has_next_page
      });
    case 'INSTALLER_LIST_FAILURE':
    case 'INSTALLER_RESOURCE_CREATE_FAILURE':
    case 'INSTALLER_RESOURCE_UPDATE_FAILURE':
    case 'INSTALLER_RESOURCE_SYNC_VALIDATION_FAILURE':
      return installers__extends({}, state, {
        loading: false,
        errors: payload.errors
      });
    case 'INSTALLER_RESOURCE_REQUEST':
    case 'INSTALLER_RESOURCE_SUCCESS':
    case 'INSTALLER_RESOURCE_CLEAR_VALIDATION':
      return installers__extends({}, state, {
        errors: {}
      });
    default:
      return state;
  }
};

/* harmony default export */ var installers = (Object(es["combineReducers"])({
  byId: installers_byId,
  common: installers_common,
  filters: installers_filters
}));

var installers_getById = function getById(state) {
  return state.byId;
};
var installers_getHasNextPage = function getHasNextPage(state) {
  return state.common.hasNextPage;
};
var installers_getPage = function getPage(state) {
  return state.common.page;
};
var installers_getLoading = function getLoading(state) {
  return state.common.loading;
};
var installers_getVisibleFilter = function getVisibleFilter(state) {
  return state.filters.data.status;
};
var installers_getFiltersData = function getFiltersData(state) {
  return state.filters.data;
};
var installers_idsByFilter = function idsByFilter(state) {
  return state.filters.idsByFilter;
};
var installers_getErrors = function getErrors(state) {
  return state.common.errors;
};

var installers_getList = Object(reselect_lib["createSelector"])(installers_getById, installers_idsByFilter, function (lookup, list) {
  return list.map(function (id) {
    return lookup[id];
  });
});

var installers_getInactiveVisible = Object(reselect_lib["createSelector"])(installers_getVisibleFilter, function (status) {
  return status === 'all';
});


// CONCATENATED MODULE: ./client/app/reducers/helpers.js



var helpers_initialState = {
  data: {}
};

var helpers_helpers = function helpers() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : helpers_initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'INSTALLER_RESOURCE_SUCCESS':
    case 'INSTALLER_RESOURCE_CREATE_SUCCESS':
    case 'INSTALLER_RESOURCE_UPDATE_SUCCESS':
      {
        var helper = payload.entities && payload.entities.helpers;
        return Object(lodash["merge"])({}, state, { data: helper });
      }
    default:
      return state;
  }
};

/* harmony default export */ var reducers_helpers = (helpers_helpers);

var helpers_helperList = function helperList(state) {
  return Object(utils["r" /* mapObjectToList */])(state.data);
};
var helpers_getById = function getById(state) {
  return function (id) {
    return state.data[id];
  };
};
// CONCATENATED MODULE: ./client/app/reducers/crews.js



var crews_initialState = {
  data: {}
};

var crews_crews = function crews() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : crews_initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'INSTALLER_RESOURCE_SUCCESS':
    case 'INSTALLER_RESOURCE_CREATE_SUCCESS':
    case 'INSTALLER_RESOURCE_UPDATE_SUCCESS':
      {
        var crew = payload.entities && payload.entities.crews;
        return Object(lodash["merge"])({}, state, { data: crew });
      }
    default:
      return state;
  }
};

/* harmony default export */ var reducers_crews = (crews_crews);

var crews_crewList = function crewList(state) {
  return Object(utils["r" /* mapObjectToList */])(state.data);
};
var crews_getById = function getById(state) {
  return function (id) {
    return state.data[id];
  };
};
// CONCATENATED MODULE: ./client/app/reducers/surfaceTypes.js
var surfaceTypes__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var surfaceTypes_initialState = {
  loading: false,
  loaded: false,
  errors: {},
  data: {}
};

var surfaceTypes_surfaceTypes = function surfaceTypes() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : surfaceTypes_initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'SURFACE_TYPE_LIST_REQUEST':
      return surfaceTypes__extends({}, state, {
        loading: true
      });
    case 'SURFACE_TYPE_LIST_SUCCESS':
      return surfaceTypes__extends({}, state, {
        loading: false,
        loaded: true,
        data: Object.assign({}, state.data, Object(utils["t" /* normalize */])(payload))
      });
    case 'SURFACE_TYPE_LIST_FAILURE':
      return surfaceTypes__extends({}, state, {
        loading: false,
        errors: payload.errors
      });
    case 'ESTIMATOR_LIST_SUCCESS':
    case 'ESTIMATOR_RESOURCE_SUCCESS':
    case 'INSTALLER_RESOURCE_SUCCESS':
      {
        var st = payload.entities && payload.entities.surface_types;
        return Object(lodash["merge"])({}, state, { data: st });
      }
    default:
      return state;
  }
};

/* harmony default export */ var reducers_surfaceTypes = (surfaceTypes_surfaceTypes);

var surfaceTypes_surfaceTypeList = function surfaceTypeList(state) {
  return Object(utils["r" /* mapObjectToList */])(state.data);
};
var surfaceTypes_getById = function getById(state) {
  return function (id) {
    return state.data[id];
  };
};
// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var qs_lib = __webpack_require__("mw3O");
var qs_lib_default = /*#__PURE__*/__webpack_require__.n(qs_lib);

// CONCATENATED MODULE: ./client/app/reducers/phases.js
var phases__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function phases__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }





// Results state

var phases_results = function results() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  var result = Object(lodash["unionBy"])(state, payload, 'id');
  switch (type) {
    case 'PHASE_LIST_SUCCESS':
      return [].concat(phases__toConsumableArray(result));
    case 'PHASE_RESOURCE_CREATE_SUCCESS':
    case 'PHASE_RESOURCE_UPDATE_SUCCESS':
    case 'PHASE_RESET_PAGINATION':
      return [];
    default:
      return state;
  }
};

var exportResults = function exportResults() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var _ref2 = arguments[1];
  var type = _ref2.type,
      payload = _ref2.payload;

  switch (type) {
    case 'EXPORT_PHASES_SUCCESS':
      return payload;
    default:
      return state;
  }
};

// Filters state

var phases_defaultFilters = {
  data: {},
  location: {},
  idsByFilter: []
};

var phases_filters = function filters() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : phases_defaultFilters;
  var _ref3 = arguments[1];
  var type = _ref3.type,
      payload = _ref3.payload;

  switch (type) {
    case 'LOGIN_USER_SUCCESS':
    case 'USER_GET_SESSION_SUCCESS':
      return phases__extends({}, state, {
        location: payload.preferences.saved_location_filters || state.location
      });
    case 'UPDATE_PHASE_FILTERS_LOCATION_REQUEST':
      return phases__extends({}, state, {
        location: Object.assign({}, payload)
      });
    case 'PHASE_SET_FILTER':
      return phases__extends({}, state, {
        data: Object.assign({}, payload)
      });
    case 'PHASE_RESET_FILTERS':
      return phases__extends({}, phases_defaultFilters);
    default:
      return state;
  }
};

// Common (errors, loading) state

var phases_initialCommon = {
  loading: false,
  loaded: false,
  errors: {}
};

var phases_common = function common() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : phases_initialCommon;
  var _ref4 = arguments[1];
  var type = _ref4.type,
      payload = _ref4.payload;

  switch (type) {
    case 'PHASE_LIST_REQUEST':
      return phases__extends({}, state, {
        loading: true,
        loaded: false
      });
    case 'PHASE_LIST_SUCCESS':
      return phases__extends({}, state, {
        loading: false,
        loaded: true,
        errors: {}
      });
    case 'PHASE_LIST_FAILURE':
      return phases__extends({}, state, {
        loading: false,
        loaded: false,
        errors: payload.errors
      });
    case 'EXPORT_PHASES_FAILURE':
      return phases__extends({}, state, {
        errors: payload.errors
      });
    default:
      return state;
  }
};

// Pagination state

var initPagination = {
  current_page: 0,
  next_page: 1,
  prev_page: null,
  total_count: 0,
  total_pages: 0
};

var pagination = function pagination() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initPagination;
  var _ref5 = arguments[1];
  var type = _ref5.type,
      meta = _ref5.meta;

  switch (type) {
    case 'PHASE_RESET_PAGINATION':
    case 'PHASE_RESOURCE_CREATE_SUCCESS':
    case 'PHASE_RESOURCE_UPDATE_SUCCESS':
      return phases__extends({}, state, initPagination);
    case 'PHASE_LIST_SUCCESS':
    case 'SAVED_FILTERS_LIST_SUCCESS':
      return phases__extends({}, state, meta);
    case 'PHASE_LIST_FAILURE':
      return phases__extends({}, state, {
        next_page: null
      });
    default:
      return state;
  }
};

/* harmony default export */ var phases = (Object(es["combineReducers"])({
  results: phases_results,
  exportResults: exportResults,
  common: phases_common,
  filters: phases_filters,
  pagination: pagination
}));

var phases_getList = function getList(state) {
  return state.results;
};
var getExportList = function getExportList(state) {
  return state.exportResults;
};
var phases_getHasNextPage = function getHasNextPage(state) {
  return state.pagination.next_page !== null && state.pagination.next_page !== undefined;
};
var phases_getPage = function getPage(state) {
  return state.pagination.current_page;
};
var getNextPage = function getNextPage(state) {
  return state.pagination.next_page;
};
var phases_getLoading = function getLoading(state) {
  return state.common.loading;
};
var phases_getErrors = function getErrors(state) {
  return state.common.errors;
};
var phases_getFiltersData = function getFiltersData(state) {
  return state.filters.data;
};
var getFiltersLocation = function getFiltersLocation(state) {
  return state.filters.location;
};

var getCurrentQuery = Object(reselect_lib["createSelector"])(phases_getFiltersData, getFiltersLocation, function (data, location) {
  return qs_lib_default.a.stringify(Object.assign({}, data, location));
});

var getCurrentQueryNoLocation = Object(reselect_lib["createSelector"])(phases_getFiltersData, function (data) {
  return qs_lib_default.a.stringify(Object.assign({}, data));
});


// EXTERNAL MODULE: ./client/app/utils/lineItemUtils.js
var lineItemUtils = __webpack_require__("bEtk");

// CONCATENATED MODULE: ./client/app/reducers/phase_items.js
var phase_items__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var phase_items_initialState = {
  loading: false,
  items: []
};

var getLaborSheet = function getLaborSheet(laborSheets, id) {
  return laborSheets.find(function (ls) {
    return ls.id === id;
  });
};

var phase_items_addBlankLineItemToPhase = function addBlankLineItemToPhase(state, type) {
  var stateLineItems = Object(lodash["cloneDeep"])(state.data);
  if (type === 'contractorLineItems' && stateLineItems.length > 0) {
    stateLineItems.forEach(function (laborSheet) {
      return laborSheet.line_items.push(Object(lineItemUtils["h" /* getNewLineItem */])());
    });
  } else if (type !== 'contractorLineItems') {
    stateLineItems.push(Object(lineItemUtils["h" /* getNewLineItem */])());
  }
  return stateLineItems;
};

var phase_items_addBlankLevelerToPhase = function addBlankLevelerToPhase(state, type) {
  var stateLevelerItems = Object(lodash["cloneDeep"])(state);
  if (type === 'levelers' && stateLevelerItems.length > 0) {
    stateLevelerItems.forEach(function (item) {
      return item.data.push(Object(lineItemUtils["h" /* getNewLineItem */])());
    });
  }
  stateLevelerItems.data.push(Object(lineItemUtils["h" /* getNewLineItem */])());
  return stateLevelerItems;
};

var getLineItemsToUpdate = function getLineItemsToUpdate(stateLineItems, payload) {
  if (payload.type === 'contractorLineItems') {
    var laborSheet = getLaborSheet(stateLineItems, payload.line_item.labor_sheet_id);
    return laborSheet.line_items;
  }
  return stateLineItems;
};

var phase_items_updateStateLineItemsOnCreate = function updateStateLineItemsOnCreate(state, payload, listName) {
  var stateLineItems = Object(lodash["cloneDeep"])(state.items);
  var lineItemsToUpdate = getLineItemsToUpdate(stateLineItems, payload);
  if (payload.type === 'exception') {
    Object(lineItemUtils["m" /* updateOnCreateExceptionHelper */])(lineItemsToUpdate, payload, listName);
  } else {
    Object(lineItemUtils["k" /* updateLineItemsOnCreateHelper */])(lineItemsToUpdate, payload);
  }
  return stateLineItems;
};

var phase_items_removeStateLineItemOnDelete = function removeStateLineItemOnDelete(state, payload) {
  var stateLineItems = Object(lodash["cloneDeep"])(state.items);
  var lineItemsToUpdate = getLineItemsToUpdate(stateLineItems, payload);
  Object(lineItemUtils["e" /* deleteLineItemHelper */])(lineItemsToUpdate, payload.line_item.id);
  return stateLineItems;
};

var phase_items_updateStateLineItemsOnUpdate = function updateStateLineItemsOnUpdate(state, payload) {
  var stateLineItems = Object(lodash["cloneDeep"])(state.items);
  var lineItemsToUpdate = getLineItemsToUpdate(stateLineItems, payload);
  Object(lineItemUtils["l" /* updateLineItemsOnUpdateHelper */])(lineItemsToUpdate, payload);
  return stateLineItems;
};

var phase_items_addLineItemError = function addLineItemError(state, payload) {
  var stateLineItems = Object(lodash["cloneDeep"])(state.items);
  var lineItemsToUpdate = getLineItemsToUpdate(stateLineItems, payload);
  Object(lineItemUtils["a" /* addLineItemErrorHelper */])(lineItemsToUpdate, payload);
  return stateLineItems;
};

var phase_items_addLineItemEvent = function addLineItemEvent(state, payload) {
  var stateLineItems = Object(lodash["cloneDeep"])(state.items);
  var lineItemsToUpdate = getLineItemsToUpdate(stateLineItems, payload);
  Object(lineItemUtils["b" /* addLineItemEventsHelper */])(lineItemsToUpdate, payload);
  return stateLineItems;
};

var phase_items_createListWithNamedType = function createListWithNamedType() {
  var listName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : phase_items_initialState;
    var _ref = arguments[1];
    var type = _ref.type,
        payload = _ref.payload;

    var newState = {};
    var payloadType = Object(lodash["has"])(payload, 'type') ? payload.type : '';
    var isHandlingException = payloadType === 'exception' && ['purchaseOrders', 'phaseLineItems'].includes(listName);
    if (listName !== payloadType && !isHandlingException) return state;
    switch (type) {
      case 'REQUEST_PHASE_ITEMS_SUCCESS':
        newState.items = phase_items_addBlankLineItemToPhase({ data: payload.line_items }, payloadType);
        return Object.assign({}, state, { loading: false }, newState);
      case 'CREATE_PHASE_ITEMS_SUCCESS':
      case 'CREATE_PHASE_LEVELER_ITEMS_SUCCESS':
      case 'CREATE_EXCEPTION_SUCCESS':
        newState.items = phase_items_updateStateLineItemsOnCreate(state, payload, listName);
        return Object.assign({}, state, { loading: false }, newState);
      case 'DELETE_PHASE_ITEMS_SUCCESS':
        newState.items = phase_items_removeStateLineItemOnDelete(state, payload);
        return Object.assign({}, state, { loading: false }, newState);
      case 'UPDATE_PHASE_ITEMS_FAILURE':
      case 'UPDATE_PHASE_LEVELER_ITEMS_FAILURE':
      case 'CREATE_PHASE_ITEMS_FAILURE':
      case 'CREATE_PHASE_LEVELER_ITEMS_FAILURE':
      case 'DELETE_PHASE_ITEMS_FAILURE':
        newState.items = phase_items_addLineItemError(state, payload);
        return Object.assign({}, state, { loading: false }, newState);
      case 'UPDATE_PHASE_ITEMS_SUCCESS':
        newState.items = phase_items_updateStateLineItemsOnUpdate(state, payload);
        return Object.assign({}, state, { loading: false }, newState);
      case 'UPDATE_PHASE_LEVELER_ITEMS_SUCCESS:':
        newState.items = phase_items_addBlankLevelerToPhase(state, payload);
        return Object.assign({}, state, { loading: false }, newState);
      case 'REQUEST_PHASE_ITEMS_REQUEST':
      case 'DELETE_PHASE_ITEMS_REQUEST':
        return phase_items__extends({}, state, {
          loading: true
        });
      case 'REQUEST_PHASE_ITEMS_FAILURE':
      case 'APPROVE_LABOR_SHEET_FAILURE':
        return phase_items__extends({}, state, {
          errors: payload.errors || {},
          loading: false
        });
      case 'PHASE_ITEM_EVENTS_REQUEST':
        return phase_items__extends({}, state, {
          loading: true
        });
      case 'PHASE_ITEM_EVENTS_SUCCESS':
        return phase_items__extends({}, state, {
          items: phase_items_addLineItemEvent(state, payload),
          loading: false
        });
      case 'PHASE_ITEM_EVENTS_FAILURE':
        return phase_items__extends({}, state, {
          items: phase_items_addLineItemError(state, payload),
          loading: false
        });
      case 'REQUEST_PHASE_LEVELER_ITEMS_REQUEST':
        return phase_items__extends({}, state, {
          loading: true
        });
      case 'REQUEST_PHASE_LEVELER_ITEMS_SUCCESS':
        newState.items = phase_items_addBlankLevelerToPhase({ data: payload.levelers }, payloadType);
        return Object.assign({}, state, { loading: false }, newState);
      case 'REQUEST_PHASE_LEVELER_ITEMS_FAILURE':
      default:
        return state;
    }
  };
};

/* harmony default export */ var phase_items = (phase_items_createListWithNamedType);
// CONCATENATED MODULE: ./client/app/reducers/documents.js
var documents__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function documents__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var documents_initialState = {
  data: [],
  uploadError: '',
  filesLoading: false,
  loading: false,
  loaded: false,
  errors: {}
};

var updateDocument = function updateDocument(state, payload) {
  var data = state.data.map(function (document) {
    if (document.id === payload.id) return payload;
    return document;
  });
  return documents__extends({}, state, {
    data: data,
    loading: false
  });
};

var documents = function documents() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : documents_initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'PHASE_RESOURCE_REQUEST':
      return documents_initialState;
    case 'DOCUMENTS_REQUEST':
      return documents__extends({}, state, {
        loading: true,
        loaded: false
      });
    case 'DOCUMENTS_REQUEST_SUCCESS':
      return documents__extends({}, state, {
        data: payload,
        loading: false,
        loaded: true
      });
    case 'DOCUMENTS_REQUEST_FAILURE':
      return documents__extends({}, documents_initialState, {
        errors: payload.errors
      });
    case 'DOCUMENTS_FILES_UPLOAD':
      return documents__extends({}, state, {
        filesLoading: true,
        uploadError: ''
      });
    case 'DOCUMENT_RESOURCE_UPDATE_REQUEST':
      return documents__extends({}, state, {
        loading: true
      });
    case 'DOCUMENT_RESOURCE_UPDATE_SUCCESS':
      return updateDocument(state, payload);
    case 'DOCUMENTS_FILES_UPLOAD_SUCCESS':
      return documents__extends({}, state, {
        data: payload,
        filesLoading: false
      });
    case 'APPROVE_LABOR_SHEET_SUCCESS':
      return documents__extends({}, state, {
        data: [].concat(documents__toConsumableArray(state.data), documents__toConsumableArray(payload.document_uploads))
      });
    case 'DOCUMENTS_FILES_UPLOAD_FAILURE':
    case 'DOCUMENT_RESOURCE_UPDATE_FAILURE':
      return documents__extends({}, state, {
        filesLoading: false,
        uploadError: payload.errors
      });
    case 'CREATE_RELATED_PHASE_SUCCESS':
    case 'REMOVE_RELATED_PHASE_SUCCESS':
    case 'PHASE_RESOURCE_CREATE_SUCCESS':
      return documents__extends({}, state, {
        loaded: false,
        data: []
      });
    default:
      return state;
  }
};

/* harmony default export */ var reducers_documents = (documents);
// CONCATENATED MODULE: ./client/app/reducers/related_phases.js
var related_phases__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function related_phases__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var related_phases_initialState = {
  loading: false,
  data: [],
  errors: [],
  count: 0
};

var pushNewPhase = function pushNewPhase(payload, state) {
  var stateData = [].concat(related_phases__toConsumableArray(state.data));
  stateData.push(payload);
  return stateData;
};

var removeRelatedPhase = function removeRelatedPhase(relatedPhaseId, state) {
  return state.data.filter(function (relatedPhase) {
    return relatedPhase.id !== relatedPhaseId;
  });
};

var related = function related() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : related_phases_initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload,
      meta = _ref.meta;

  switch (type) {
    case 'PHASE_RESOURCE_REQUEST':
      return related_phases_initialState;
    case 'REQUEST_RELATED_PHASES_REQUEST':
      return related_phases__extends({}, state, {
        loading: true,
        errors: []
      });
    case 'REQUEST_RELATED_PHASES_SUCCESS':
      return related_phases__extends({}, state, {
        loading: false,
        data: payload.relatedPhases,
        count: payload.relatedPhases.length
      });
    case 'CREATE_RELATED_PHASE_SUCCESS':
      {
        var data = pushNewPhase(payload.relatedPhase, state);
        return related_phases__extends({}, state, {
          loading: false,
          data: data,
          count: data.length
        });
      }
    case 'REMOVE_RELATED_PHASE_SUCCESS':
      {
        var _data = removeRelatedPhase(payload.relatedPhaseId, state);
        return related_phases__extends({}, state, {
          loading: false,
          data: _data,
          count: _data.length
        });
      }
    case 'PHASE_RESOURCE_SUCCESS':
    case 'PHASE_RESOURCE_CREATE_SUCCESS':
    case 'PHASE_RESOURCE_UPDATE_SUCCESS':
      return related_phases__extends({}, state, {
        count: meta.related_count
      });
    case 'REQUEST_RELATED_PHASES_FAILURE':
    case 'CREATE_RELATED_PHASE_FAILURE':
    case 'REMOVE_RELATED_PHASE_FAILURE':
      return related_phases__extends({}, state, {
        loading: false,
        errors: payload.errors
      });
    case 'CREATE_RELATED_PHASE_REQUEST':
    default:
      return state;
  }
};

/* harmony default export */ var related_phases = (related);
// CONCATENATED MODULE: ./client/app/reducers/phase.js
var phase__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function phase__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }







var phase_initialState = {
  loading: false,
  loaded: false,
  errors: {},
  phone_numbers: [],
  surface_information: {},
  store: {},
  surface_type: {},
  events: [],
  current_tasks: [],
  estimatorsByWorkroom: [],
  installersForAssignment: []
};

var phase_getErrors = function getErrors(state) {
  return state.errors;
};
var phase_getLoading = function getLoading(state) {
  return state.loading;
};
var getCurrentTasks = function getCurrentTasks(state) {
  return state.current_tasks;
};

var changeTask = function changeTask(task, taskID, action) {
  if (task.slug === taskID) {
    return phase__extends({}, task, { status: action });
  }
  return task;
};

var getEvents = function getEvents(state) {
  var kind = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return state.events.filter(function (e) {
    return !kind || e.kind === kind;
  });
};
var phase_getFlags = function getFlags(state) {
  return state.flags;
};

var phase_removeRedundantProperties = function removeRedundantProperties(phase) {
  return Object(lodash["omit"])(phase, ['purchase_orders']);
};

var phase_details = function details() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : phase_initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload,
      meta = _ref.meta;

  switch (type) {
    case 'PHASE_RESOURCE_REQUEST':
      return phase__extends({}, state, {
        loading: true,
        loaded: false
      }, payload.optimisticState || {});
    case 'PHASE_RESOURCE_CREATE_REQUEST':
    case 'PHASE_RESOURCE_COPY_REQUEST':
    case 'PHASE_RESOURCE_UPDATE_REQUEST':
    case 'ADD_FLAG_TO_PHASE_REQUEST':
    case 'REMOVE_FLAG_FROM_PHASE_REQUEST':
    case 'ESTIMATOR_LIST_BY_WORKROOM_REQUEST':
    case 'INSTALLERS_FOR_ASSIGNMENT_REQUEST':
    case 'PHASE_APPOINTMENTS_REQUEST':
    case 'CANCEL_PHASE_REQUEST':
    case 'FETCH_CONTRACTOR_LIST_REQUEST':
    case 'VERIFY_PHASE_ASSESSMENT_REQUEST':
      return phase__extends({}, state, {
        loading: true
      });
    case 'UPDATE_PHASE_TASK_REQUEST':
      return phase__extends({}, state, {
        current_tasks: getCurrentTasks(state).map(function (task) {
          return changeTask(task, payload, 'pending');
        }),
        loading: true
      });
    case 'PHASE_RESOURCE_SUCCESS':
    case 'PHASE_RESOURCE_CREATE_SUCCESS':
    case 'PHASE_RESOURCE_COPY_SUCCESS':
    case 'PHASE_RESOURCE_UPDATE_SUCCESS':
    case 'OVERRIDE_PHASE_STATUS_SUCCESS':
    case 'UPDATE_PHASE_TASK_SUCCESS':
    case 'ADD_FLAG_TO_PHASE_SUCCESS':
    case 'REMOVE_FLAG_FROM_PHASE_SUCCESS':
    case 'ASSIGN_PHASE_ESTIMATOR_SUCCESS':
    case 'ASSIGN_PHASE_INSTALLER_SUCCESS':
    case 'APPROVE_LABOR_SHEET_SUCCESS':
    case 'CANCEL_PHASE_SUCCESS':
    case 'VERIFY_PHASE_ASSESSMENT_SUCCESS':
    case 'CREATE_RELATED_PHASE_SUCCESS':
    case 'SEND_QUICK_SCHEDULE_MESSAGE_SUCCESS':
      return phase__extends({}, state, phase_removeRedundantProperties(payload.phase), {
        loading: false,
        loaded: true,
        errors: {}
      });
    case 'PHASE_RESOURCE_CLEAR_VALIDATION':
      return phase__extends({}, state, {
        errors: {}
      });
    case 'ADD_EVENT_TO_PHASE_SUCCESS':
      return phase__extends({}, state, {
        events: [payload.event].concat(phase__toConsumableArray(state.events)),
        loading: false,
        errors: {}
      });
    case 'ESTIMATOR_LIST_BY_WORKROOM_SUCCESS':
      return phase__extends({}, state, {
        loading: false,
        estimatorsByWorkroom: payload.estimatorListByWorkroom
      });
    case 'INSTALLERS_FOR_ASSIGNMENT_SUCCESS':
      return phase__extends({}, state, {
        loading: false,
        installersForAssignment: payload.installersForAssignment
      });
    case 'FETCH_CONTRACTOR_LIST_SUCCESS':
      return phase__extends({}, state, {
        loading: false,
        contractors: payload.contractors
      });
    case 'PHASE_APPOINTMENTS_SUCCESS':
      return phase__extends({}, state, {
        loading: false,
        appointments: payload.appointments
      });
    case 'PHASE_APPOINTMENT_CREATE_SUCCESS':
      return phase__extends({}, state, {
        loading: false,
        errors: {},
        appointments: [].concat(phase__toConsumableArray(state.appointments || []), [payload.appointment])
      }, payload.phase);
    case 'PHASE_APPOINTMENT_EDIT_SUCCESS':
      {
        // when editing a related phases appointment we don't want to overwrite the phase
        // we are currently viewing with the related phases details
        var phase = payload.phase.id === state.id ? payload.phase : {};
        return phase__extends({}, state, {
          loading: false,
          errors: {},
          appointments: [].concat(phase__toConsumableArray((state.appointments || []).filter(function (appt) {
            return appt.id !== payload.appointment.id;
          })), [payload.appointment])
        }, phase);
      }
    case 'PHASE_APPOINTMENT_DELETE_SUCCESS':
      return phase__extends({}, state, {
        loading: false,
        errors: {},
        appointments: state.appointments.filter(function (appt) {
          return appt.id !== payload.appointmentID;
        }),
        events: [payload.event].concat(phase__toConsumableArray(state.events))
      });
    case 'SURVEY_UPDATE_SUCCESS':
      return phase__extends({}, state, phase_removeRedundantProperties(payload.meta.phase));
    case 'PHASE_RESOURCE_FAILURE':
    case 'PHASE_RESOURCE_CREATE_FAILURE':
    case 'PHASE_RESOURCE_COPY_FAILURE':
    case 'PHASE_RESOURCE_UPDATE_FAILURE':
    case 'ADD_EVENT_TO_PHASE_FAILURE':
    case 'OVERRIDE_PHASE_STATUS_FAILURE':
    case 'ADD_FLAG_TO_PHASE_FAILURE':
    case 'REMOVE_FLAG_FROM_PHASE_FAILURE':
    case 'ESTIMATOR_LIST_BY_WORKROOM_FAILURE':
    case 'INSTALLERS_FOR_ASSIGNMENT_FAILURE':
    case 'FETCH_CONTRACTOR_LIST_FAILURE':
    case 'PHASE_APPOINTMENTS_FAILURE':
    case 'ASSIGN_PHASE_ESTIMATOR_FAILURE':
    case 'ASSIGN_PHASE_INSTALLER_FAILURE':
    case 'CANCEL_PHASE_FAILURE':
    case 'VERIFY_PHASE_ASSESSMENT_FAILURE':
    case 'SEND_QUICK_SCHEDULE_MESSAGE_FAILURE':
      return phase__extends({}, state, {
        errors: payload.errors || {},
        loading: false
      });
    case 'UPDATE_PHASE_TASK_FAILURE':
      return phase__extends({}, state, {
        errors: payload.errors || {},
        current_tasks: getCurrentTasks(state).map(function (task) {
          return changeTask(task, meta.taskID, 'incomplete');
        }),
        loading: false
      });
    case 'CREATE_PHASE_ITEMS_SUCCESS':
    case 'UPDATE_PHASE_ITEMS_SUCCESS':
    case 'DELETE_PHASE_ITEMS_SUCCESS':
    case 'REQUEST_PHASE_ITEMS_SUCCESS':
      if (!meta || !meta.phase) return state;
      return phase__extends({}, state, meta.phase);
    default:
      return state;
  }
};

var initialSurveyState = {
  loading: false,
  loaded: false,
  questions: [],
  installer: null,
  errors: {}
};

var survey = function survey() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialSurveyState;
  var _ref2 = arguments[1];
  var type = _ref2.type,
      payload = _ref2.payload;

  switch (type) {
    case 'SURVEY_FETCH_REQUEST':
    case 'SURVEY_UPDATE_REQUEST':
      return phase__extends({}, state, {
        loading: true
      });
    case 'SURVEY_FETCH_SUCCESS':
    case 'SURVEY_UPDATE_SUCCESS':
      return phase__extends({}, state, payload.survey, {
        loading: false,
        loaded: true
      });
    case 'SURVEY_FETCH_FAILURE':
    case 'SURVEY_UPDATE_FAILURE':
      return phase__extends({}, state, {
        loading: false,
        errors: payload.errors
      });
    default:
      return state;
  }
};

/* harmony default export */ var reducers_phase = (Object(es["combineReducers"])({
  details: phase_details,
  documents: reducers_documents,
  related: related_phases,
  survey: survey,
  contractorLineItems: phase_items('contractorLineItems'),
  phaseMerchandiseItems: phase_items('phaseMerchandiseItems'),
  phaseLineItems: phase_items('phaseLineItems'),
  warehouseMerchandiseItems: phase_items('warehouseMerchandiseItems'),
  contractorChargebackItems: phase_items('contractorChargebackItems'),
  purchaseOrders: phase_items('purchaseOrders'),
  laborSheets: phase_items('laborSheets'),
  levelers: phase_items('levelers')
}));


// CONCATENATED MODULE: ./client/app/reducers/price_patches.js
var price_patches__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var price_patches_byId = function byId() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;

  switch (type) {
    case 'STORE_RESOURCE_SUCCESS':
    case 'STORE_RESOURCE_CREATE_SUCCESS':
    case 'STORE_RESOURCE_UPDATE_SUCCESS':
      {
        return price_patches__extends({}, state, payload.entities.price_patches);
      }

    case 'PRICE_PATCH_LIST_SUCCESS':
      return Object.assign({}, state, payload.entities && payload.entities.price_patches);
    default:
      return state;
  }
};

var price_patches_initialState = {
  loading: false,
  errors: {}
};

var price_patches_common = function common() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : price_patches_initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'PRICE_PATCH_LIST_REQUEST':
      return price_patches__extends({}, state, {
        loading: true
      });
    case 'PRICE_PATCH_LIST_SUCCESS':
      return price_patches__extends({}, state, {
        loading: false
      });
    case 'PRICE_PATCH_LIST_FAILURE':
      return price_patches__extends({}, state, {
        loading: false,
        errors: payload.errors
      });
    default:
      return state;
  }
};

/* harmony default export */ var price_patches = (Object(es["combineReducers"])({
  byId: price_patches_byId,
  common: price_patches_common
}));

var price_patches_getList = function getList(state) {
  return Object(utils["r" /* mapObjectToList */])(state.byId);
};
var price_patches_getById = function getById(state) {
  return function (id) {
    return state.byId[id];
  };
};
// CONCATENATED MODULE: ./client/app/reducers/pay_rates.js
var pay_rates__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var pay_rates_byId = function byId() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { payRates: [] };
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'PAY_RATE_LIST_SUCCESS':
      return pay_rates__extends({}, state, {
        payRates: payload.pay_rates
      });
    default:
      return state;
  }
};

var pay_rates_initialState = {
  loading: false,
  currentRate: '',
  showingHistoryScreen: false
};

var pay_rates_common = function common() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : pay_rates_initialState;
  var _ref2 = arguments[1];
  var type = _ref2.type,
      payload = _ref2.payload,
      meta = _ref2.meta;

  switch (type) {
    case 'SHOW_RATE_HISTORY':
      return pay_rates__extends({}, state, {
        currentRate: payload.rate,
        showingHistoryScreen: true
      });
    case 'HIDE_RATE_HISTORY':
      return pay_rates__extends({}, state, {
        currentRate: '',
        showingHistoryScreen: false
      });
    case 'PAY_RATE_LIST_REQUEST':
      return pay_rates__extends({}, state, {
        loading: true
      });
    case 'PAY_RATE_LIST_SUCCESS':
      return pay_rates__extends({}, state, {
        currentRate: meta.rate,
        loading: false
      });
    default:
      return state;
  }
};

/* harmony default export */ var pay_rates = (Object(es["combineReducers"])({
  byId: pay_rates_byId,
  common: pay_rates_common
}));

var getCurrentHistoryList = function getCurrentHistoryList(state) {
  return state.byId.payRates;
};

var pay_rates_getLoading = function getLoading(state) {
  return state.common.loading;
};
var getShowHistory = function getShowHistory(state) {
  return state.common.showingHistoryScreen;
};
var pay_rates_getCurrentName = function getCurrentName(state) {
  return Object(utils["B" /* titleize */])(state.common.currentRate);
};
// CONCATENATED MODULE: ./client/app/reducers/pay_rate_uploads.js
var pay_rate_uploads__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var pay_rate_uploads_initialState = {
  showUploadDialog: false,
  errorMessage: '',
  listLoading: false,
  data: [],
  uploadMessage: '',
  uploadError: {},
  fileLoading: false
};

var payRateUploads = function payRateUploads() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : pay_rate_uploads_initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'PAY_RATE_UPLOADS_LIST_REQUEST':
      return pay_rate_uploads__extends({}, state, {
        listLoading: true
      });
    case 'PAY_RATE_UPLOADS_LIST_REQUEST_SUCCESS':
      return pay_rate_uploads__extends({}, state, {
        listLoading: false,
        data: payload
      });
    case 'PAY_RATE_UPLOADS_LIST_REQUEST_FAILURE':
      return pay_rate_uploads__extends({}, state, {
        listLoading: false,
        errors: payload.errors
      });
    case 'PAY_RATE_UPLOADS_FILE_UPLOAD':
      return pay_rate_uploads__extends({}, state, {
        fileLoading: true,
        uploadMessage: '',
        uploadError: {}
      });
    case 'PAY_RATE_UPLOADS_FILE_UPLOAD_SUCCESS':
      state.data.unshift(payload);
      return pay_rate_uploads__extends({}, state, {
        data: state.data,
        fileLoading: false,
        showUploadDialog: false,
        uploadMessage: 'Success'
      });
    case 'PAY_RATE_UPLOADS_FILE_UPLOAD_FAILURE':
      return pay_rate_uploads__extends({}, state, {
        fileLoading: false,
        uploadError: payload.errors
      });
    case 'PAY_RATE_UPLOADS_TOGGLE_DIALOG':
      return pay_rate_uploads__extends({}, state, {
        showUploadDialog: !state.showUploadDialog,
        uploadError: {}
      });
    default:
      return state;
  }
};

var getLoadingStatus = function getLoadingStatus(state) {
  return state.listLoading;
};
var getListData = function getListData(state) {
  return state.data;
};
var getErrorMessage = function getErrorMessage(state) {
  return state.errorMessage;
};
var pay_rate_uploads_getUploadError = function getUploadError(state) {
  return state.uploadError;
};
var getUploadMesage = function getUploadMesage(state) {
  return state.uploadMessage;
};
var getFileLoading = function getFileLoading(state) {
  return state.fileLoading;
};
var getShowDialog = function getShowDialog(state) {
  return state.showUploadDialog;
};

/* harmony default export */ var pay_rate_uploads = (payRateUploads);


// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// CONCATENATED MODULE: ./client/app/reducers/schedule.js
var schedule__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var schedule_initialState = {
  loading: false,
  loaded: false,
  errors: {},
  startDate: null,
  filters: {},
  members: [],
  suggestions: []
};

var schedule_getErrors = function getErrors(state) {
  return state.errors;
};
var schedule_getLoading = function getLoading(state) {
  return state.loading;
};
var getStartDate = function getStartDate(state) {
  return state.startDate;
};
var getEndDate = function getEndDate(state) {
  return state.endDate;
};
var getDates = Object(reselect_lib["createSelector"])(getStartDate, getEndDate, function (startDate, endDate) {
  return moment_default.a.range(moment_default()(startDate), moment_default()(endDate)).toArray('days', true);
});

var schedule = function schedule() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : schedule_initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'LOGIN_USER_SUCCESS':
    case 'USER_GET_SESSION_SUCCESS':
      return schedule__extends({}, state, {
        filters: payload.preferences.saved_schedule_filters || state.filters
      });
    case 'SCHEDULE_UPDATE_FILTERS':
      return schedule__extends({}, state, {
        filters: payload
      });
    case 'SCHEDULE_REQUEST':
      return schedule__extends({}, state, {
        startDate: payload.startDate,
        endDate: payload.endDate,
        loading: true
      });
    case 'SUGGESTION_REQUEST':
      return schedule__extends({}, state, {
        phaseId: payload.phaseId || 'N/A',
        startDate: payload.startDate || 'N/A',
        loading: true
      });
    case 'SCHEDULE_SUCCESS':
      return schedule__extends({}, state, payload, {
        loading: false,
        loaded: true,
        errors: {}
      });
    case 'SUGGESTION_SUCCESS':
      return schedule__extends({}, state, payload, {
        members: [],
        loading: false,
        loaded: true,
        errors: {}
      });
    case 'SCHEDULE_FAILURE':
      return schedule__extends({}, state, {
        errors: payload.errors || {},
        loading: false
      });
    default:
      return state;
  }
};

/* harmony default export */ var reducers_schedule = (schedule);

// CONCATENATED MODULE: ./client/app/reducers/saved_filters.js
var saved_filters__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function saved_filters__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var saved_filters_initialState = {
  loading: false,
  loaded: false,
  errors: {},
  filters: []
};

var savedFilters = function savedFilters() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : saved_filters_initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'SAVED_FILTERS_LIST_REQUEST':
    case 'SAVED_FILTER_CREATE_REQUEST':
    case 'SAVED_FILTER_UPDATE_REQUEST':
    case 'SAVED_FILTER_DELETE_REQUEST':
      return saved_filters__extends({}, state, {
        loading: true
      });
    case 'SAVED_FILTERS_LIST_SUCCESS':
      return saved_filters__extends({}, state, {
        loaded: true,
        loading: false,
        filters: payload
      });
    case 'UPDATE_SAVED_FILTER_POSITION':
      {
        var newOrder = [].concat(saved_filters__toConsumableArray(state.filters));
        newOrder.splice.apply(newOrder, [payload.newPosition, 0].concat(saved_filters__toConsumableArray(newOrder.splice(payload.oldPosition, 1))));
        return saved_filters__extends({}, state, {
          filters: newOrder
        });
      }
    case 'SAVED_FILTER_CREATE_SUCCESS':
      return saved_filters__extends({}, state, {
        loaded: true,
        loading: false,
        filters: [].concat(saved_filters__toConsumableArray(state.filters), [payload])
      });
    case 'SAVED_FILTER_UPDATE_SUCCESS':
      return saved_filters__extends({}, state, {
        loaded: true,
        loading: false,
        filters: state.filters.map(function (filter) {
          if (filter.id === payload.id) {
            return payload;
          }
          return filter;
        })
      });
    case 'SAVED_FILTER_DELETE_SUCCESS':
      return saved_filters__extends({}, state, {
        loaded: true,
        loading: false,
        filters: state.filters.filter(function (filter) {
          return filter.id !== payload.savedFilterId;
        })
      });
    case 'SAVED_FILTERS_LIST_FAILURE':
      return saved_filters__extends({}, state, {
        loading: false,
        loaded: false,
        errors: payload.errors
      });
    case 'SAVED_FILTER_CREATE_FAILURE':
    case 'SAVED_FILTER_UPDATE_FAILURE':
    case 'SAVED_FILTER_DELETE_FAILURE':
      return saved_filters__extends({}, state, {
        loading: false,
        errors: payload.errors
      });
    case 'SAVED_FILTER_RESOURCE_CLEAR_VALIDATION':
      return saved_filters__extends({}, state, {
        errors: {}
      });
    default:
      return state;
  }
};

/* harmony default export */ var saved_filters = (savedFilters);
// CONCATENATED MODULE: ./client/app/reducers/assigned_filters.js
var assigned_filters__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var assigned_filters_initialState = {
  loading: false,
  loaded: false,
  errors: {},
  filters: []
};

var assignedFilters = function assignedFilters() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : assigned_filters_initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'ASSIGNED_FILTERS_LIST_REQUEST':
      return assigned_filters__extends({}, state, {
        loading: true
      });
    case 'ASSIGNED_FILTERS_LIST_SUCCESS':
      return assigned_filters__extends({}, state, {
        loaded: true,
        loading: false,
        filters: payload
      });
    case 'ASSIGNED_FILTER_COUNT_SUCCESS':
      {
        var newState = assigned_filters__extends({}, state, {
          loaded: true,
          loading: false
        });
        if (payload && (payload.id || null)) {
          newState['filter' + payload.id + 'PhaseCounts'] = payload;
        }
        return newState;
      }case 'ASSIGNED_FILTERS_LIST_FAILURE':
      return assigned_filters__extends({}, state, {
        loading: false,
        loaded: false,
        errors: payload.errors
      });
    case 'ASSIGNED_FILTER_RESOURCE_CLEAR_VALIDATION':
      return assigned_filters__extends({}, state, {
        errors: {}
      });
    default:
      return state;
  }
};

/* harmony default export */ var assigned_filters = (assignedFilters);
// CONCATENATED MODULE: ./client/app/reducers/price_patch_line_items.js
var price_patch_line_items__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var price_patch_line_items_initialState = {
  loading: false,
  errors: {},
  data: []
};

var pricePatchLineItems = function pricePatchLineItems() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : price_patch_line_items_initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'PRICE_PATCH_LINE_ITEM_LIST_REQUEST':
      return price_patch_line_items__extends({}, state, {
        loading: true,
        data: []
      });
    case 'PRICE_PATCH_LINE_ITEM_LIST_SUCCESS':
      return price_patch_line_items__extends({}, state, {
        loading: false,
        data: payload.lineItems
      });
    case 'PRICE_PATCH_LINE_ITEM_LIST_FAILURE':
      return price_patch_line_items__extends({}, state, {
        loading: false,
        errors: payload.errors
      });
    default:
      return state;
  }
};

/* harmony default export */ var price_patch_line_items = (pricePatchLineItems);
// CONCATENATED MODULE: ./client/app/reducers/pay_rate_line_items.js
var pay_rate_line_items__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var pay_rate_line_items_initialState = {
  loading: false,
  errors: {},
  data: {}
};

var setLineItems = function setLineItems(stateData, payload) {
  var newStateData = JSON.parse(JSON.stringify(stateData));
  newStateData[payload.referenceId] = payload.lineItems;
  return newStateData;
};

var payRateLineItems = function payRateLineItems() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : pay_rate_line_items_initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'PAY_RATE_LINE_ITEM_LIST_REQUEST':
      return pay_rate_line_items__extends({}, state, {
        loading: true
      });
    case 'PAY_RATE_LINE_ITEM_LIST_SUCCESS':
      return pay_rate_line_items__extends({}, state, {
        loading: false,
        data: setLineItems(state.data, payload)
      });
    case 'PAY_RATE_LINE_ITEM_LIST_FAILURE':
      return pay_rate_line_items__extends({}, state, {
        loading: false,
        errors: payload.errors
      });
    default:
      return state;
  }
};

/* harmony default export */ var pay_rate_line_items = (payRateLineItems);
// CONCATENATED MODULE: ./client/app/reducers/appointment.js
var appointment__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var appointment_initialState = {
  loading: true,
  data: {},
  errors: {}
};

var appointment = function appointment() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : appointment_initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'REQUEST_APPOINTMENT_REQUEST':
    case 'PHASE_APPOINTMENT_DELETE_REQUEST':
      return appointment__extends({}, state, {
        loading: true,
        errors: {}
      });
    case 'REQUEST_APPOINTMENT_SUCCESS':
      return appointment__extends({}, state, {
        loading: false,
        data: payload.appointment,
        errors: {}
      });
    case 'REQUEST_APPOINTMENT_FAILURE':
      return appointment__extends({}, state, {
        errors: payload.errors || {},
        loading: false
      });
    case 'PHASE_APPOINTMENT_CREATE_FAILURE':
    case 'PHASE_APPOINTMENT_EDIT_FAILURE':
    case 'PHASE_APPOINTMENT_DELETE_FAILURE':
    case 'PHASE_APPOINTMENT_ADD_VALIDATION':
      return appointment__extends({}, state, {
        errors: payload.errors || {},
        loading: false
      });
    case 'PHASE_APPOINTMENT_CLEAR_VALIDATION':
      return appointment__extends({}, state, {
        loading: true,
        errors: {}
      });
    default:
      return state;
  }
};

/* harmony default export */ var reducers_appointment = (appointment);
// CONCATENATED MODULE: ./client/app/reducers/refigure_form.js
var refigure_form__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var refigure_form_initialState = {
  loading: false,
  errors: {},
  customer_name: '',
  phone_number: '',
  purchase_orders: [],
  store_number: ''
};

var refigureForm = function refigureForm() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : refigure_form_initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'REQUEST_REFIGURE_FORM_REQUEST':
      return refigure_form__extends({}, state, {
        loading: true
      });
    case 'REQUEST_REFIGURE_FORM_SUCCESS':
      return Object.assign({}, state, payload.refigure, { loading: false });
    case 'REQUEST_REFIGURE_FORM_FAILURE':
      return refigure_form__extends({}, state, {
        loading: false,
        errors: payload.errors
      });
    case 'SUBMIT_REFIGURE_FORM_REQUEST':
      return refigure_form__extends({}, state, {
        loading: true
      });
    case 'SUBMIT_REFIGURE_FORM_SUCCESS':
      return refigure_form__extends({}, state, {
        loading: false
      });
    case 'SUBMIT_REFIGURE_FORM_FAILURE':
      return refigure_form__extends({}, state, {
        loading: false,
        errors: payload.errors
      });
    default:
      return state;
  }
};

/* harmony default export */ var refigure_form = (refigureForm);
// CONCATENATED MODULE: ./client/app/reducers/scraper.js
var scraper__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var scraper_initialState = {
  uploadError: '',
  loading: false,
  documents: {}
};

var scraper = function scraper() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : scraper_initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'SCRAPE_REQUEST':
      return scraper__extends({}, state, {
        loading: true
      });
    case 'SCRAPE_SUCCESS':
      return scraper__extends({}, state, {
        loading: false,
        documents: payload.documents,
        uploadError: ''
      });
    case 'SCRAPE_FAILURE':
      return scraper__extends({}, state, {
        documents: {},
        loading: false,
        uploadError: payload.errors
      });
    default:
      return state;
  }
};

/* harmony default export */ var reducers_scraper = (scraper);
// CONCATENATED MODULE: ./client/app/reducers/cocs.js
var cocs__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var cocs_initialState = {
  uploadError: {},
  loading: false,
  cocData: {}
};

var cocs = function cocs() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : cocs_initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'COC_CREATE_REQUEST':
      return cocs__extends({}, state, {
        loading: true
      });
    case 'COC_CREATE_SUCCESS':
      return cocs__extends({}, state, {
        loading: false,
        cocData: payload.cocData,
        uploadError: ''
      });
    case 'COC_CREATE_FAILURE':
      return cocs__extends({}, state, {
        cocData: {},
        loading: false,
        uploadError: payload.errors
      });
    default:
      return state;
  }
};

/* harmony default export */ var reducers_cocs = (cocs);
// CONCATENATED MODULE: ./client/app/reducers/lrrps.js
var lrrps__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var lrrps_initialState = {
  uploadError: {},
  loading: false,
  lrrpData: {}
};

var lrrps = function lrrps() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : lrrps_initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'LRRP_CREATE_REQUEST':
      return lrrps__extends({}, state, {
        loading: true
      });
    case 'LRRP_CREATE_SUCCESS':
      return lrrps__extends({}, state, {
        loading: false,
        lrrpData: payload.lrrpData,
        uploadError: ''
      });
    case 'LRRP_CREATE_FAILURE':
      return lrrps__extends({}, state, {
        lrrpData: {},
        loading: false,
        uploadError: payload.errors
      });
    default:
      return state;
  }
};

/* harmony default export */ var reducers_lrrps = (lrrps);
// CONCATENATED MODULE: ./client/app/reducers/walkthroughs.js
var walkthroughs__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var walkthroughs_initialState = {
  uploadError: {},
  loading: false,
  walkthroughData: {}
};

var walkthroughs = function walkthroughs() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : walkthroughs_initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'WALKTHROUGH_CREATE_REQUEST':
      return walkthroughs__extends({}, state, {
        loading: true
      });
    case 'WALKTHROUGH_CREATE_SUCCESS':
      return walkthroughs__extends({}, state, {
        loading: false,
        walkthroughData: payload.walkthroughData,
        uploadError: ''
      });
    case 'WALKTHROUGH_CREATE_FAILURE':
      return walkthroughs__extends({}, state, {
        walkthroughData: {},
        loading: false,
        uploadError: payload.errors
      });
    default:
      return state;
  }
};

/* harmony default export */ var reducers_walkthroughs = (walkthroughs);
// CONCATENATED MODULE: ./client/app/reducers/settings.js
var settings__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var settings_initialState = {
  useHighContrast: JSON.parse(localStorage.getItem('useHighContrast'))
};

var settings = function settings() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : settings_initialState;
  var _ref = arguments[1];
  var type = _ref.type;

  switch (type) {
    case 'TOGGLE_CONTRAST':
      return settings__extends({}, state, {
        useHighContrast: !state.useHighContrast
      });
    default:
      return state;
  }
};

/* harmony default export */ var reducers_settings = (settings);
// CONCATENATED MODULE: ./client/app/reducers/repair_inspection_report.js
var repair_inspection_report__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var repair_inspection_report_initialState = {
  uploadError: {},
  loading: false,
  repairInspectionReportData: {}
};

var repairInspectionReport = function repairInspectionReport() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : repair_inspection_report_initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'REPAIR_INSPECTION_REPORT_CREATE_REQUEST':
      return repair_inspection_report__extends({}, state, {
        loading: true
      });
    case 'REPAIR_INSPECTION_REPORT_CREATE_SUCCESS':
      return repair_inspection_report__extends({}, state, {
        loading: false,
        repairInspectionReportData: payload.repairInspectionReportData,
        uploadError: ''
      });
    case 'REPAIR_INSPECTION_REPORT_CREATE_FAILURE':
      return repair_inspection_report__extends({}, state, {
        repairInspectionReportData: {},
        loading: false,
        uploadError: payload.errors
      });
    default:
      return state;
  }
};

/* harmony default export */ var repair_inspection_report = (repairInspectionReport);
// CONCATENATED MODULE: ./client/app/reducers/crew_inspection.js
var crew_inspection__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var crew_inspection_initialState = {
  uploadError: {},
  loading: false,
  crewInspectionData: {}
};

var crewInspection = function crewInspection() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : crew_inspection_initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'CREW_INSPECTION_CREATE_REQUEST':
      return crew_inspection__extends({}, state, {
        loading: true
      });
    case 'CREW_INSPECTION_CREATE_SUCCESS':
      return crew_inspection__extends({}, state, {
        loading: false,
        crewInspectionData: payload.crewInspectionData,
        uploadError: ''
      });
    case 'CREW_INSPECTION_CREATE_FAILURE':
      return crew_inspection__extends({}, state, {
        crewInspectionData: {},
        loading: false,
        uploadError: payload.errors
      });
    default:
      return state;
  }
};

/* harmony default export */ var crew_inspection = (crewInspection);
// CONCATENATED MODULE: ./client/app/reducers/ptos.js
var ptos__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function ptos__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var ptos_initialState = {
  data: [],
  errors: {}
};

var insertCreatedPTO = function insertCreatedPTO(state, payload) {
  var data = [].concat(ptos__toConsumableArray(state.data));
  if (data.length > 0 && data[0].id === 'new') {
    data[0] = payload.pto;
  } else {
    data.unshift(payload.pto);
  }

  return data;
};

var handlePTOCreateErrors = function handlePTOCreateErrors(state, payload) {
  var errPTO = ptos__extends({}, payload.pto, { errors: payload.errors, id: 'new' });
  var data = [].concat(ptos__toConsumableArray(state.data));

  if (data.length > 0 && data[0].id === 'new') {
    data[0] = errPTO;
  } else {
    data.unshift(errPTO);
  }

  return data;
};

var ptos = function ptos() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ptos_initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'PTO_INDEX_SUCCESS':
      return ptos__extends({}, state, {
        data: payload.ptos
      });
    case 'PTO_CREATE_SUCCESS':
      return ptos__extends({}, state, {
        data: insertCreatedPTO(state, payload)
      });
    case 'PTO_UPDATE_SUCCESS':
      return ptos__extends({}, state, {
        data: state.data.map(function (pto) {
          return pto.id === payload.pto.id ? payload.pto : pto;
        })
      });
    case 'PTO_DELETE_SUCCESS':
      return ptos__extends({}, state, {
        data: state.data.filter(function (pto) {
          return pto.id !== payload.ptoID;
        })
      });
    case 'PTO_INDEX_FAILURE':
      return ptos__extends({}, state, {
        errors: payload.errors
      });
    case 'PTO_CREATE_FAILURE':
      return ptos__extends({}, state, {
        data: handlePTOCreateErrors(state, payload)
      });
    case 'PTO_UPDATE_FAILURE':
    case 'PTO_DELETE_FAILURE':
      return ptos__extends({}, state, {
        data: state.data.map(function (pto) {
          return pto.id === payload.pto.id ? ptos__extends({}, payload.pto, { errors: payload.errors }) : pto;
        })
      });
    case 'PTO_INDEX_REQUEST':
    case 'PTO_CREATE_REQUEST':
    case 'PTO_UPDATE_REQUEST':
    case 'PTO_DELETE_REQUEST':
      return ptos__extends({}, state, {
        loading: true
      });
    default:
      return state;
  }
};

/* harmony default export */ var reducers_ptos = (ptos);
// CONCATENATED MODULE: ./client/app/reducers/traveling_work_dates.js
var traveling_work_dates__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function traveling_work_dates__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var traveling_work_dates_initialState = { data: [], errors: {} };

var insertCreatedTravelingWorkDate = function insertCreatedTravelingWorkDate(state, payload) {
  var data = [].concat(traveling_work_dates__toConsumableArray(state.data));
  if (data.length > 0 && data[0].id === 'new') data[0] = payload.traveling_work_date;else data.unshift(payload.traveling_work_date);
  return data;
};

var handleTravelingWorkDateCreateErrors = function handleTravelingWorkDateCreateErrors(state, payload) {
  var errTravelingWorkDate = traveling_work_dates__extends({}, payload.traveling_work_date, { errors: payload.errors, id: 'new' });
  var data = [].concat(traveling_work_dates__toConsumableArray(state.data));
  if (data.length > 0 && data[0].id === 'new') data[0] = errTravelingWorkDate;else data.unshift(errTravelingWorkDate);
  return data;
};

var travelingWorkDates = function travelingWorkDates() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : traveling_work_dates_initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'TRAVELING_WORK_DATE_INDEX_SUCCESS':
      return traveling_work_dates__extends({}, state, { data: payload.traveling_work_dates });
    case 'TRAVELING_WORK_DATE_CREATE_SUCCESS':
      return traveling_work_dates__extends({}, state, {
        data: insertCreatedTravelingWorkDate(state, payload)
      });
    case 'TRAVELING_WORK_DATE_UPDATE_SUCCESS':
      return traveling_work_dates__extends({}, state, {
        data: state.data.map(function (traveling_work_date) {
          return traveling_work_date.id === payload.traveling_work_date.id ? payload.traveling_work_date : traveling_work_date;
        })
      });
    case 'TRAVELING_WORK_DATE_DELETE_SUCCESS':
      return traveling_work_dates__extends({}, state, {
        data: state.data.filter(function (traveling_work_date) {
          return traveling_work_date.id !== payload.travelingWorkDateID;
        }) });
    case 'TRAVELING_WORK_DATE_INDEX_FAILURE':
      return traveling_work_dates__extends({}, state, { errors: payload.errors });
    case 'TRAVELING_WORK_DATE_CREATE_FAILURE':
      return traveling_work_dates__extends({}, state, { data: handleTravelingWorkDateCreateErrors(state, payload) });
    case 'TRAVELING_WORK_DATE_UPDATE_FAILURE':
    case 'TRAVELING_WORK_DATE_DELETE_FAILURE':
      return traveling_work_dates__extends({}, state, {
        data: state.data.map(function (traveling_work_date) {
          return traveling_work_date.id === payload.traveling_work_date.id ? traveling_work_dates__extends({}, payload.traveling_work_date, { errors: payload.errors }) : traveling_work_date;
        })
      });
    case 'TRAVELING_WORK_DATE_INDEX_REQUEST':
    case 'TRAVELING_WORK_DATE_CREATE_REQUEST':
    case 'TRAVELING_WORK_DATE_UPDATE_REQUEST':
    case 'TRAVELING_WORK_DATE_DELETE_REQUEST':
      return traveling_work_dates__extends({}, state, { loading: true });
    default:
      return state;
  }
};

/* harmony default export */ var traveling_work_dates = (travelingWorkDates);
// CONCATENATED MODULE: ./client/app/reducers/reports.js
var reports__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var defaultReport = {
  loading: false,
  loaded: false,
  data: []
};

var createReport = function createReport(KIND) {
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultReport;
    var _ref = arguments[1];
    var type = _ref.type,
        payload = _ref.payload;

    switch (type) {
      case KIND + '_REPORT_SUCCESS':
        return reports__extends({}, state, {
          loading: false,
          loaded: true,
          data: payload
        });
      case KIND + '_REPORT_REQUEST':
        return reports__extends({}, state, {
          loading: true,
          loaded: false
        });
      case KIND + '_REPORT_FAILURE':
        return reports__extends({}, state, {
          loading: true,
          loaded: false,
          errors: payload.errors
        });
      case KIND + '_REPORT_CLEAR':
        return reports__extends({}, defaultReport);
      default:
        return state;
    }
  };
};

var defaultInstallerPaperwork = {
  loading: false,
  loaded: false,
  paperwork_url: null,
  count: null
};

var installerPaperwork = function installerPaperwork() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultInstallerPaperwork;
  var _ref2 = arguments[1];
  var type = _ref2.type,
      payload = _ref2.payload;

  switch (type) {
    case 'INSTALLER_PAPERWORK_SUCCESS':
      return reports__extends({}, state, {
        loading: false,
        loaded: true,
        paperwork_url: payload.paperwork_url,
        count: payload.count
      });
    case 'INSTALLER_PAPERWORK_REQUEST':
      return reports__extends({}, state, {
        paperwork_url: null,
        count: null,
        loading: true,
        loaded: false
      });
    case 'INSTALLER_PAPERWORK_FAILURE':
      return reports__extends({}, state, {
        loading: true,
        loaded: false,
        errors: payload.errors
      });
    case 'INSTALLER_PAPERWORK_CLEAR':
      return reports__extends({}, defaultInstallerPaperwork);
    default:
      return state;
  }
};

var defaultTagsBulkPrint = {
  loading: false,
  loaded: false,
  tags: null,
  count: null
};

var tagsBulkPrint = function tagsBulkPrint() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultTagsBulkPrint;
  var _ref3 = arguments[1];
  var type = _ref3.type,
      payload = _ref3.payload;

  switch (type) {
    case 'TAG_BULK_PRINT_SUCCESS':
      return reports__extends({}, state, {
        loading: false,
        loaded: true,
        tags: payload,
        count: payload.length
      });
    case 'TAG_BULK_PRINT_REQUEST':
      return reports__extends({}, state, {
        tags: null,
        count: null,
        loading: true,
        loaded: false
      });
    case 'TAG_BULK_PRINT_FAILURE':
      return reports__extends({}, state, {
        loading: true,
        loaded: false,
        errors: payload.errors
      });
    case 'TAG_BULK_PRINT_CLEAR':
      return reports__extends({}, defaultTagsBulkPrint);
    default:
      return state;
  }
};

/* harmony default export */ var reports = (Object(es["combineReducers"])({
  installerPaperwork: installerPaperwork,
  warehouse: createReport('WAREHOUSE'),
  installWorkorder: createReport('INSTALL_WORKORDER'),
  jobHistory: createReport('JOB_HISTORY'),
  activity: createReport('ACTIVITY'),
  tagsBulkPrint: tagsBulkPrint
}));

var getWarehouse = function getWarehouse(state) {
  return state.warehouse;
};


// CONCATENATED MODULE: ./client/app/reducers/error.js
var error__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var error_initialState = {
  messages: null
};

var errors = function errors() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : error_initialState;
  var _ref = arguments[1];
  var payload = _ref.payload,
      error = _ref.error;

  if (error && payload.global && payload.errors) {
    return error__extends({}, state, payload.errors);
  }
  return error_initialState;
};

/* harmony default export */ var error = (errors);
// CONCATENATED MODULE: ./client/app/reducers/line_items.js
var line_items__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function line_items__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



var line_items_initialState = {
  loading: false,
  items: [],
  vendorTypes: [],
  filters: {
    query: null,
    vendor: ''
  },
  errors: {}
};

// include filters or not?
var line_items_newState = function newState(state, items) {
  return line_items__extends({}, state, {
    items: items,
    loading: false,
    filters: {
      query: null
    }
  });
};

var line_items_addBlankLineItemToPhase = function addBlankLineItemToPhase(state, items) {
  items.push(Object(lineItemUtils["h" /* getNewLineItem */])());
  return line_items_newState(state, items);
};

var line_items_updateStateLineItemsOnCreate = function updateStateLineItemsOnCreate(state, payload) {
  var items = [].concat(line_items__toConsumableArray(state.items));
  Object(lineItemUtils["k" /* updateLineItemsOnCreateHelper */])(items, payload);
  return line_items_newState(state, items);
};

var line_items_updateStateLineItemsOnUpdate = function updateStateLineItemsOnUpdate(state, payload) {
  var items = [].concat(line_items__toConsumableArray(state.items));
  Object(lineItemUtils["l" /* updateLineItemsOnUpdateHelper */])(items, payload);
  return line_items_newState(state, items);
};

var line_items_addLineItemError = function addLineItemError(state, payload) {
  var items = [].concat(line_items__toConsumableArray(state.items));
  Object(lineItemUtils["a" /* addLineItemErrorHelper */])(items, payload);
  return line_items_newState(state, items);
};

var lineItems = function lineItems() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : line_items_initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'FETCH_VENDOR_TYPES_REQUEST':
      return line_items__extends({}, state, {
        loading: true
      });
    case 'FETCH_VENDOR_TYPES_SUCCESS':
      return line_items__extends({}, state, {
        loading: false,
        vendorTypes: payload
      });
    case 'FETCH_VENDOR_TYPES_FAILURE':
      return line_items__extends({}, state, {
        loading: false,
        errors: payload.errors
      });
    case 'LINE_ITEMS_SUCCESS':
      return line_items_addBlankLineItemToPhase(state, payload.line_items);
    case 'CREATE_LINE_ITEM_SUCCESS':
      return line_items_updateStateLineItemsOnCreate(state, payload);
    case 'CREATE_LINE_ITEM_FAILURE':
    case 'UPDATE_LINE_ITEM_FAILURE':
      return line_items_addLineItemError(state, payload);
    case 'UPDATE_LINE_ITEM_SUCCESS':
      return line_items_updateStateLineItemsOnUpdate(state, payload);
    case 'LINE_ITEMS_REQUEST':
      return line_items__extends({}, state, {
        loading: true
      });
    case 'LINE_ITEMS_FAILURE':
      return line_items__extends({}, state, {
        errors: payload.errors || {},
        loading: false
      });
    case 'LINE_ITEMS_SET_FILTERS':
      return line_items__extends({}, state, {
        filters: payload
      });
    default:
      return state;
  }
};

/* harmony default export */ var line_items = (lineItems);

var getVendorTypes = function getVendorTypes(state) {
  return state.lineItems.vendorTypes;
};
// CONCATENATED MODULE: ./client/app/reducers/uploads.js
var uploads__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var uploads_initialState = {
  errorMessage: '',
  page: 1,
  data: [],
  uploadError: '',
  fileLoading: false,
  dialogActive: false,
  hasNextPage: true,
  uploadName: '',
  totalCount: 0
};

var uploads_createUploadWithNamedType = function createUploadWithNamedType() {
  var uploadName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : uploads_initialState;
    var _ref = arguments[1];
    var type = _ref.type,
        payload = _ref.payload;

    var payloadType = Object(lodash["has"])(payload, 'type') ? payload.type : '';
    if (payloadType !== uploadName) return state;

    switch (type) {
      case 'UPLOADS_LIST_REQUEST':
        return uploads__extends({}, state, {
          listLoading: true
        });
      case 'UPLOADS_LIST_REQUEST_SUCCESS':
        return uploads__extends({}, state, {
          listLoading: false,
          data: payload.data[payloadType] || [],
          page: payload.page || state.page,
          hasNextPage: payload.data.has_next_page,
          totalCount: payload.data.total_count
        });
      case 'UPLOADS_LIST_REQUEST_FAILURE':
        return uploads__extends({}, state, {
          listLoading: false,
          errors: payload.errors
        });
      case 'UPLOADS_FILE_UPLOAD':
        return uploads__extends({}, state, {
          fileLoading: true,
          uploadMessage: '',
          uploadError: {}
        });
      case 'UPLOADS_FILE_UPLOAD_SUCCESS':
        return uploads__extends({}, state, {
          fileLoading: false,
          uploadMessage: 'Success',
          dialogActive: false
        });
      case 'UPLOADS_FILE_UPLOAD_FAILURE':
        return uploads__extends({}, state, {
          fileLoading: false,
          uploadError: payload.errors
        });
      case 'UPLOAD_DIALOG_TOGGLE':
        return uploads__extends({}, state, {
          uploadError: '',
          dialogActive: payload.status
        });
      default:
        return state;
    }
  };
};

/* harmony default export */ var uploads = (uploads_createUploadWithNamedType);

var uploads_getListData = function getListData(state) {
  return state.data;
};
var uploads_getErrorMessage = function getErrorMessage(state) {
  return state.errorMessage;
};
var uploads_getUploadError = function getUploadError(state) {
  return state.uploadError;
};
var uploads_getFileLoading = function getFileLoading(state) {
  return state.fileLoading;
};
var getDialogActive = function getDialogActive(state) {
  return state.dialogActive;
};
var uploads_getHasNextPage = function getHasNextPage(state) {
  return state.hasNextPage;
};
var getListLoading = function getListLoading(state) {
  return state.listLoading;
};
var uploads_getPage = function getPage(state) {
  return state.page;
};
var getTotalCount = function getTotalCount(state) {
  return state.totalCount;
};

var uploads_getUploadIsProcessing = function getUploadIsProcessing(state) {
  return state.data.filter(function (el) {
    return el.status === 'pending';
  }).length > 0;
};


// CONCATENATED MODULE: ./client/app/reducers/ims_actions.js
var ims_actions__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var ims_actions_initialState = {
  uploadError: {},
  loading: false,
  imsActionResponse: {}
};

var imsActions = function imsActions() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ims_actions_initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'IMS_ACTIONS_UPDATE_REQUEST':
      return ims_actions__extends({}, state, {
        loading: true
      });
    case 'IMS_ACTIONS_UPDATE_SUCCESS':
      return ims_actions__extends({}, state, {
        loading: false,
        imsActionResponse: payload,
        uploadError: ''
      });
    case 'IMS_ACTIONS_UPDATE_FAILURE':
      return ims_actions__extends({}, state, {
        imsActionResponse: {},
        loading: false,
        uploadError: payload.errors
      });
    default:
      return state;
  }
};

/* harmony default export */ var ims_actions = (imsActions);
// CONCATENATED MODULE: ./client/app/reducers/default_installer_pay.js
var default_installer_pay__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var default_installer_pay_initialState = {
  loading: false,
  patchItems: [],
  errors: {}
};

var defaultInstallerPay = function defaultInstallerPay() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : default_installer_pay_initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'DEFAULT_INSTALLER_PAY_REQUEST':
      return default_installer_pay__extends({}, state, { loading: true });
    case 'DEFAULT_INSTALLER_PAY_SUCCESS':
      return default_installer_pay__extends({}, state, { loading: false, patchItems: payload.patch_items });
    case 'UPDATE_DEFAULT_INSTALLER_PAY_SUCCESS':
      return default_installer_pay__extends({}, state, {
        loading: false,
        patchItems: state.patchItems.map(function (item) {
          return item.id === payload.patch_item.id ? payload.patch_item : item;
        })
      });
    case 'BULK_UPDATE_DEFAULT_INSTALLER_PAY_SUCCESS':
      {
        var updatedById = {};
        payload.patch_items.forEach(function (item) {
          updatedById[item.id] = item;
        });
        return default_installer_pay__extends({}, state, {
          loading: false,
          patchItems: state.patchItems.map(function (item) {
            return updatedById[item.id] || item;
          })
        });
      }
    case 'DEFAULT_INSTALLER_PAY_FAILURE':
    case 'UPDATE_DEFAULT_INSTALLER_PAY_FAILURE':
    case 'BULK_UPDATE_DEFAULT_INSTALLER_PAY_FAILURE':
      return default_installer_pay__extends({}, state, { loading: false, errors: payload });
    default:
      return state;
  }
};

/* harmony default export */ var default_installer_pay = (defaultInstallerPay);
// CONCATENATED MODULE: ./client/app/reducers/holiday_promo_settings.js
var holiday_promo_settings__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var holiday_promo_settings_initialState = {
  loading: false,
  setting: null,
  errors: {}
};

var holidayPromoSettings = function holidayPromoSettings() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : holiday_promo_settings_initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'HOLIDAY_PROMO_SETTINGS_REQUEST':
    case 'UPDATE_HOLIDAY_PROMO_SETTINGS_REQUEST':
      return holiday_promo_settings__extends({}, state, { loading: true, errors: {} });
    case 'HOLIDAY_PROMO_SETTINGS_SUCCESS':
    case 'UPDATE_HOLIDAY_PROMO_SETTINGS_SUCCESS':
      return holiday_promo_settings__extends({}, state, {
        loading: false,
        setting: payload.holiday_promo_setting,
        errors: {}
      });
    case 'HOLIDAY_PROMO_SETTINGS_FAILURE':
    case 'UPDATE_HOLIDAY_PROMO_SETTINGS_FAILURE':
      return holiday_promo_settings__extends({}, state, { loading: false, errors: payload && payload.errors || {} });
    default:
      return state;
  }
};

var holiday_promo_settings_getHolidayPromoSetting = function getHolidayPromoSetting(state) {
  return state.setting;
};
var holiday_promo_settings_getHolidayPromoSettingLoading = function getHolidayPromoSettingLoading(state) {
  return state.loading;
};
var holiday_promo_settings_getHolidayPromoSettingErrors = function getHolidayPromoSettingErrors(state) {
  return state.errors;
};

/* harmony default export */ var holiday_promo_settings = (holidayPromoSettings);
// CONCATENATED MODULE: ./client/app/reducers/index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return reducers_getRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return reducers_getEmployableId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return reducers_getEmployableType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return reducers_getPosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return reducers_getManageVendorWorkrooms; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return reducers_getWorkroomList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return reducers_getWorkroomById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return reducers_getWorkroomFilteredByIds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return reducers_getWorkroomLoaded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return reducers_getWorkroomLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return reducers_getWorkroomFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return reducers_getWorkroomErrors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return reducers_getTaskList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return reducers_getSurfaceTypeList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return reducers_getSurfaceTypeById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return reducers_getIqmsHasNextPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return reducers_getIqmsLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return reducers_getIqmsPage; });
/* unused harmony export getIqmsById */
/* unused harmony export getIqmsErrors */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return reducers_getIqmsFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return reducers_getIqmsList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return reducers_getEmployeeList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return reducers_getEmployeeHasNextPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return reducers_getEmployeePage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return reducers_getEmployeeLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return reducers_getEmployeeFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return reducers_getEmployeeErrors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return reducers_getEmployeeById; });
/* unused harmony export getEmployeeInactiveVisible */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return reducers_getInstallerList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return reducers_getInstallerHasNextPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return reducers_getInstallerPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return reducers_getInstallerLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return reducers_getInstallerFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return reducers_getInstallerErrors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return reducers_getInstallerById; });
/* unused harmony export getInstallerInactiveVisible */
/* unused harmony export getPhaseList */
/* unused harmony export getPhaseExportList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return reducers_getPhaseHasNextPage; });
/* unused harmony export getPhasePage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return reducers_getPhaseNextPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return reducers_getPhasesLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return reducers_getPhaseFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return reducers_getPhaseFiltersQueryOnly; });
/* unused harmony export getPhasesErrors */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return reducers_getPhaseFiltersData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return reducers_getPhaseFiltersLocation; });
/* unused harmony export getPhaseLoading */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return reducers_getPhaseErrors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return reducers_getPhaseEvents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return reducers_getPhaseFlags; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return reducers_getHelperById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return reducers_getCrewById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return reducers_getStoreList; });
/* unused harmony export getStoreHasNextPage */
/* unused harmony export getStorePage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return reducers_getStoreLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return reducers_getStoreLoaded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return reducers_getStoreErrors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return reducers_getStoreById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return reducers_getStoreFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return reducers_getStoreInstallerPrioritization; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return reducers_getMarketList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return reducers_getDivisionList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return reducers_getRegionList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return reducers_getEstimatorList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return reducers_getEstimatorHasNextPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return reducers_getEstimatorLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return reducers_getEstimatorPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return reducers_getEstimatorById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return reducers_getEstimatorErrors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return reducers_getEstimatorFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return reducers_getPricePatchesList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return reducers_getPricePatchById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return reducers_getFlagOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return reducers_getHolidayPromoSetting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return reducers_getHolidayPromoSettingLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return reducers_getHolidayPromoSettingErrors; });
/* unused harmony export getVendorTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return folderDocuments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return getPhaseDocuments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getDocumentUploadError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getDocumentUploadLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return reducers_getPayRateCurrentHistoryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return reducers_getPayRateLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return reducers_getPayRateShowHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return reducers_getPayRateCurrentName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return reducers_getPayRateUploadsListData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return reducers_getPayRateUploadsError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return reducers_getPayRateUploadsLoading; });
/* unused harmony export getPayRateUploadsMessage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return reducers_getPayRateUploadsShowDialog; });
/* unused harmony export getScheduleLoading */
/* unused harmony export getScheduleErrors */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return reducers_getScheduleDates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return reducers_getUploadListData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return reducers_getUploadPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return reducers_getUploadHasNextPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return reducers_getUploadListLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return reducers_getUploadError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return reducers_getUploadLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return reducers_getUploadDialogStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return reducers_getUploadIsProcessing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return reducers_getUploadTotalCount; });















































var AppReducer = Object(es["combineReducers"])({
  routing: lib["routerReducer"],
  ui: transpiled["reducer"],
  user: user["a" /* default */],
  employees: employees,
  workrooms: workrooms,
  tasks: reducers_tasks,
  estimators: estimators,
  iqms: iqms,
  stores: stores,
  markets: reducers_markets,
  regions: reducers_regions,
  divisions: reducers_divisions,
  installers: installers,
  helpers: reducers_helpers,
  crews: reducers_crews,
  surfaceTypes: reducers_surfaceTypes,
  phases: phases,
  phase: reducers_phase,
  flags: reducers_flags,
  pricePatchUploads: uploads('price_patch_uploads'),
  pricePatches: price_patches,
  payRates: pay_rates,
  payRateUploads: pay_rate_uploads,
  schedule: reducers_schedule,
  savedFilters: saved_filters,
  assignedFilters: assigned_filters,
  pricePatchLineItems: price_patch_line_items,
  payRateLineItems: pay_rate_line_items,
  appointment: reducers_appointment,
  refigureForm: refigure_form,
  scraper: reducers_scraper,
  cocs: reducers_cocs,
  lrrps: reducers_lrrps,
  walkthroughs: reducers_walkthroughs,
  settings: reducers_settings,
  repairInspectionReport: repair_inspection_report,
  crewInspection: crew_inspection,
  ptos: reducers_ptos,
  travelingWorkDates: traveling_work_dates,
  reports: reports,
  error: error,
  lineItems: line_items,
  bulkUpdateUploads: uploads('bulk_update_uploads'),
  marginUploads: uploads('margin_uploads'),
  activityUploads: uploads('activity_uploads'),
  lowesSurveyUploads: uploads('lowes_survey_uploads'),
  imsActions: ims_actions,
  defaultInstallerPay: default_installer_pay,
  holidayPromoSettings: holiday_promo_settings
});

//  RootReducer, can apply logic to state before App level Reducer
/* harmony default export */ var reducers = __webpack_exports__["a"] = (function (state, action) {
  if (action.type.includes('LOCATION_CHANGE')) {
    var stateArr = Object.entries(state);

    stateArr.forEach(function (entry) {
      var propObj = entry[1];

      if (Object.prototype.hasOwnProperty.call(propObj, 'filters') && Object.prototype.hasOwnProperty.call(propObj.filters, 'data')) {
        propObj.filters.data.query = '';
        propObj.common.page = 1;
      }
    });
  }

  return AppReducer(state, action);
});

var reducers_getRole = function getRole(state) {
  return user["f" /* getRole */](state.user);
};
var reducers_getEmployableId = function getEmployableId(state) {
  return user["b" /* getEmployableId */](state.user);
};
var reducers_getEmployableType = function getEmployableType(state) {
  return user["c" /* getEmployableType */](state.user);
};
var reducers_getPosition = function getPosition(state) {
  return user["e" /* getPosition */](state.user);
};
var reducers_getManageVendorWorkrooms = function getManageVendorWorkrooms(state) {
  return user["d" /* getManageVendorWorkrooms */](state.user);
};

var reducers_getWorkroomList = function getWorkroomList(state) {
  return workrooms_getList(state.workrooms);
};
var reducers_getWorkroomById = function getWorkroomById(state) {
  return workrooms_getById(state.workrooms);
};
var reducers_getWorkroomFilteredByIds = function getWorkroomFilteredByIds(state) {
  return getFilteredByIds(state.workrooms);
};
var reducers_getWorkroomLoaded = function getWorkroomLoaded(state) {
  return getLoaded(state.workrooms);
};
var reducers_getWorkroomLoading = function getWorkroomLoading(state) {
  return workrooms_getLoading(state.workrooms);
};
var reducers_getWorkroomFilters = function getWorkroomFilters(state) {
  return workrooms_getFiltersData(state.workrooms);
};
var reducers_getWorkroomErrors = function getWorkroomErrors(state) {
  return workrooms_getErrors(state.workrooms);
};

var reducers_getTaskList = function getTaskList(state) {
  return taskList(state.tasks);
};

var reducers_getSurfaceTypeList = function getSurfaceTypeList(state) {
  return surfaceTypes_surfaceTypeList(state.surfaceTypes);
};
var reducers_getSurfaceTypeById = function getSurfaceTypeById(state) {
  return surfaceTypes_getById(state.surfaceTypes);
};

// There's a pattern here that could be refactored to a factory function
var reducers_getIqmsHasNextPage = function getIqmsHasNextPage(state) {
  return iqms_getHasNextPage(state.iqms);
};
var reducers_getIqmsLoading = function getIqmsLoading(state) {
  return iqms_getLoading(state.iqms);
};
var reducers_getIqmsPage = function getIqmsPage(state) {
  return iqms_getPage(state.iqms);
};
var reducers_getIqmsById = function getIqmsById(state) {
  return iqms_getById(state.iqms);
};
var reducers_getIqmsErrors = function getIqmsErrors(state) {
  return iqms_getErrors(state.iqms);
};
var reducers_getIqmsFilters = function getIqmsFilters(state) {
  return iqms_getFiltersData(state.iqms);
};
var reducers_getIqmsList = function getIqmsList(state) {
  return iqms_getList(state.iqms);
};

var reducers_getEmployeeList = function getEmployeeList(state) {
  return employees_getList(state.employees);
};
var reducers_getEmployeeHasNextPage = function getEmployeeHasNextPage(state) {
  return getHasNextPage(state.employees);
};
var reducers_getEmployeePage = function getEmployeePage(state) {
  return getPage(state.employees);
};
var reducers_getEmployeeLoading = function getEmployeeLoading(state) {
  return getLoading(state.employees);
};
var reducers_getEmployeeFilters = function getEmployeeFilters(state) {
  return getFiltersData(state.employees);
};
var reducers_getEmployeeErrors = function getEmployeeErrors(state) {
  return getErrors(state.employees);
};
var reducers_getEmployeeById = function getEmployeeById(state) {
  return getById(state.employees);
};
var reducers_getEmployeeInactiveVisible = function getEmployeeInactiveVisible(state) {
  return getInactiveVisible(state.employees);
};

var reducers_getInstallerList = function getInstallerList(state) {
  return installers_getList(state.installers);
};
var reducers_getInstallerHasNextPage = function getInstallerHasNextPage(state) {
  return installers_getHasNextPage(state.installers);
};
var reducers_getInstallerPage = function getInstallerPage(state) {
  return installers_getPage(state.installers);
};
var reducers_getInstallerLoading = function getInstallerLoading(state) {
  return installers_getLoading(state.installers);
};
var reducers_getInstallerFilters = function getInstallerFilters(state) {
  return installers_getFiltersData(state.installers);
};
var reducers_getInstallerErrors = function getInstallerErrors(state) {
  return installers_getErrors(state.installers);
};
var reducers_getInstallerById = function getInstallerById(state) {
  return installers_getById(state.installers);
};
var reducers_getInstallerInactiveVisible = function getInstallerInactiveVisible(state) {
  return installers_getInactiveVisible(state.installers);
};

var reducers_getPhaseList = function getPhaseList(state) {
  return phases_getList(state.phases);
};
var reducers_getPhaseExportList = function getPhaseExportList(state) {
  return getExportList(state.exportPhases);
};
var reducers_getPhaseHasNextPage = function getPhaseHasNextPage(state) {
  return phases_getHasNextPage(state.phases);
};
var reducers_getPhasePage = function getPhasePage(state) {
  return phases_getPage(state.phases);
};
var reducers_getPhaseNextPage = function getPhaseNextPage(state) {
  return getNextPage(state.phases);
};
var reducers_getPhasesLoading = function getPhasesLoading(state) {
  return phases_getLoading(state.phases);
};
var reducers_getPhaseFilters = function getPhaseFilters(state) {
  return getCurrentQuery(state.phases);
};
var reducers_getPhaseFiltersQueryOnly = function getPhaseFiltersQueryOnly(state) {
  return getCurrentQueryNoLocation(state.phases);
};
var reducers_getPhasesErrors = function getPhasesErrors(state) {
  return phases_getErrors(state.phases);
};
var reducers_getPhaseFiltersData = function getPhaseFiltersData(state) {
  return phases_getFiltersData(state.phases);
};
var reducers_getPhaseFiltersLocation = function getPhaseFiltersLocation(state) {
  return getFiltersLocation(state.phases);
};

var reducers_getPhaseLoading = function getPhaseLoading(state) {
  return phase_getLoading(state.phase.details);
};
var reducers_getPhaseErrors = function getPhaseErrors(state) {
  return phase_getErrors(state.phase.details);
};
var reducers_getPhaseEvents = function getPhaseEvents(state, kind) {
  return getEvents(state.phase.details, kind);
};
var reducers_getPhaseFlags = function getPhaseFlags(state) {
  return phase_getFlags(state.phase.details);
};

var reducers_getHelperById = function getHelperById(state) {
  return helpers_getById(state.helpers);
};
var reducers_getCrewById = function getCrewById(state) {
  return crews_getById(state.crews);
};

var reducers_getStoreList = function getStoreList(state) {
  return stores_getList(state.stores);
};
var reducers_getStoreHasNextPage = function getStoreHasNextPage(state) {
  return stores_getHasNextPage(state.stores);
};
var reducers_getStorePage = function getStorePage(state) {
  return stores_getPage(state.stores);
};
var reducers_getStoreLoading = function getStoreLoading(state) {
  return stores_getLoading(state.stores);
};
var reducers_getStoreLoaded = function getStoreLoaded(state) {
  return stores_getLoaded(state.stores);
};
var reducers_getStoreErrors = function getStoreErrors(state) {
  return stores_getErrors(state.stores);
};
var reducers_getStoreById = function getStoreById(state) {
  return stores_getById(state.stores);
};
var reducers_getStoreFilters = function getStoreFilters(state) {
  return stores_getFiltersData(state.stores);
};
var reducers_getStoreInstallerPrioritization = function getStoreInstallerPrioritization(state) {
  return getInstallerPrioritization(state.stores);
};

var reducers_getMarketList = function getMarketList(state) {
  return markets_marketsList(state.markets);
};
var reducers_getDivisionList = function getDivisionList(state) {
  return divisions_divisionsList(state.divisions);
};
var reducers_getRegionList = function getRegionList(state) {
  return regions_regionsList(state.regions);
};

var reducers_getEstimatorList = function getEstimatorList(state) {
  return estimators_getList(state.estimators);
};
var reducers_getEstimatorHasNextPage = function getEstimatorHasNextPage(state) {
  return estimators_getHasNextPage(state.estimators);
};
var reducers_getEstimatorLoading = function getEstimatorLoading(state) {
  return estimators_getLoading(state.estimators);
};
var reducers_getEstimatorPage = function getEstimatorPage(state) {
  return estimators_getPage(state.estimators);
};
var reducers_getEstimatorById = function getEstimatorById(state) {
  return estimators_getById(state.estimators);
};
var reducers_getEstimatorErrors = function getEstimatorErrors(state) {
  return estimators_getErrors(state.estimators);
};
var reducers_getEstimatorFilters = function getEstimatorFilters(state) {
  return estimators_getFiltersData(state.estimators);
};

var reducers_getPricePatchesList = function getPricePatchesList(state) {
  return price_patches_getList(state.pricePatches);
};
var reducers_getPricePatchById = function getPricePatchById(state) {
  return price_patches_getById(state.pricePatches);
};

var reducers_getFlagOptions = function getFlagOptions(state) {
  return getFlags(state.flags);
};

var reducers_getHolidayPromoSetting = function getHolidayPromoSetting(state) {
  return holiday_promo_settings_getHolidayPromoSetting(state.holidayPromoSettings);
};
var reducers_getHolidayPromoSettingLoading = function getHolidayPromoSettingLoading(state) {
  return holiday_promo_settings_getHolidayPromoSettingLoading(state.holidayPromoSettings);
};
var reducers_getHolidayPromoSettingErrors = function getHolidayPromoSettingErrors(state) {
  return holiday_promo_settings_getHolidayPromoSettingErrors(state.holidayPromoSettings);
};

var reducers_getVendorTypes = getVendorTypes;

var folderDocuments = function folderDocuments(docs) {
  var folders = {};
  docs.map(function (doc) {
    var docType = doc.document_type;
    if (!folders[docType]) {
      folders[docType] = [];
    }
    folders[docType].push(doc);
    return null;
  });

  Object.keys(folders).map(function (folder) {
    var docums = folders[folder];
    docums.sort(function (docA, docB) {
      if (docA.not_use !== docB.not_use) {
        if (docA.not_use && !docB.not_use) {
          return 1;
        }

        if (docB.not_use && !docA.not_use) {
          return -1;
        }
        return 0;
      }

      return docA.id < docB.id ? 1 : -1;
    });

    return null;
  });

  return folders;
};

var getPhaseDocuments = function getPhaseDocuments(state) {
  return folderDocuments(state.phase.documents.data);
};

var getDocumentUploadError = function getDocumentUploadError(state) {
  return state.phase.documents.uploadError;
};
var getDocumentUploadLoading = function getDocumentUploadLoading(state) {
  return state.phase.documents.filesLoading;
};

var reducers_getPayRateCurrentHistoryList = function getPayRateCurrentHistoryList(state) {
  return getCurrentHistoryList(state.payRates);
};
var reducers_getPayRateLoading = function getPayRateLoading(state) {
  return pay_rates_getLoading(state.payRates);
};
var reducers_getPayRateShowHistory = function getPayRateShowHistory(state) {
  return getShowHistory(state.payRates);
};
var reducers_getPayRateCurrentName = function getPayRateCurrentName(state) {
  return pay_rates_getCurrentName(state.payRates);
};

var reducers_getPayRateUploadsListData = function getPayRateUploadsListData(state) {
  return getListData(state.payRateUploads);
};
var reducers_getPayRateUploadsError = function getPayRateUploadsError(state) {
  return pay_rate_uploads_getUploadError(state.payRateUploads);
};
var reducers_getPayRateUploadsLoading = function getPayRateUploadsLoading(state) {
  return getFileLoading(state.payRateUploads);
};
var reducers_getPayRateUploadsMessage = function getPayRateUploadsMessage(state) {
  return getUploadMesage(state.payRateUploads);
};
var reducers_getPayRateUploadsShowDialog = function getPayRateUploadsShowDialog(state) {
  return getShowDialog(state.payRateUploads);
};

var reducers_getScheduleLoading = function getScheduleLoading(state) {
  return schedule_getLoading(state.schedule);
};
var reducers_getScheduleErrors = function getScheduleErrors(state) {
  return schedule_getErrors(state.schedule);
};
var reducers_getScheduleDates = function getScheduleDates(state) {
  return getDates(state.schedule);
};

var reducers_getUploadListData = function getUploadListData(state) {
  return uploads_getListData(state);
};
var reducers_getUploadPage = function getUploadPage(state) {
  return uploads_getPage(state);
};
var reducers_getUploadHasNextPage = function getUploadHasNextPage(state) {
  return uploads_getHasNextPage(state);
};
var reducers_getUploadListLoading = function getUploadListLoading(state) {
  return getListLoading(state);
};
var reducers_getUploadError = function getUploadError(state) {
  return uploads_getUploadError(state);
};
var reducers_getUploadLoading = function getUploadLoading(state) {
  return uploads_getFileLoading(state);
};
var reducers_getUploadDialogStatus = function getUploadDialogStatus(state) {
  return getDialogActive(state);
};
var reducers_getUploadIsProcessing = function getUploadIsProcessing(state) {
  return uploads_getUploadIsProcessing(state);
};
var reducers_getUploadTotalCount = function getUploadTotalCount(state) {
  return getTotalCount(state);
};

/***/ }),

/***/ "RetX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"assessmentSelection__msignaturepad___2Cnag","m-signature-pad--body":"assessmentSelection__m-signature-pad--body___1LtLc","m-signature-pad--footer":"assessmentSelection__m-signature-pad--footer___16vDR","description":"assessmentSelection__description___2wSYb","button":"assessmentSelection__button___2N8kN","clear":"assessmentSelection__clear___1A_hC","save":"assessmentSelection__save___1zNzJ","m-signature-pad":"assessmentSelection__m-signature-pad___272E3","github":"assessmentSelection__github___1hLtN","wrapper":"assessmentSelection__wrapper___2C5di","actionButton":"assessmentSelection__actionButton___3LJFC"};

/***/ }),

/***/ "Rq0V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = requestTravelingWorkDatesList;
/* harmony export (immutable) */ __webpack_exports__["a"] = createTravelingWorkDate;
/* harmony export (immutable) */ __webpack_exports__["d"] = updateTravelingWorkDate;
/* harmony export (immutable) */ __webpack_exports__["b"] = deleteTravelingWorkDate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services__ = __webpack_require__("NvlE");



var _createActions = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])('TRAVELING_WORK_DATE_INDEX_REQUEST', 'TRAVELING_WORK_DATE_INDEX_SUCCESS', 'TRAVELING_WORK_DATE_INDEX_FAILURE'),
    travelingWorkDateIndexRequest = _createActions.travelingWorkDateIndexRequest,
    travelingWorkDateIndexSuccess = _createActions.travelingWorkDateIndexSuccess,
    travelingWorkDateIndexFailure = _createActions.travelingWorkDateIndexFailure;

function requestTravelingWorkDatesList(parentID, parentKind) {
  return function (dispatch) {
    dispatch(travelingWorkDateIndexRequest());

    return Object(__WEBPACK_IMPORTED_MODULE_1__services__["h" /* request */])(parentKind + '/' + parentID + '/traveling_work_dates').then(function (_ref) {
      var json = _ref.json;
      return dispatch(travelingWorkDateIndexSuccess(json));
    }).catch(function (error) {
      return dispatch(travelingWorkDateIndexFailure(error));
    });
  };
}

var _createActions2 = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])('TRAVELING_WORK_DATE_CREATE_REQUEST', 'TRAVELING_WORK_DATE_CREATE_SUCCESS', 'TRAVELING_WORK_DATE_CREATE_FAILURE'),
    travelingWorkDateCreateRequest = _createActions2.travelingWorkDateCreateRequest,
    travelingWorkDateCreateSuccess = _createActions2.travelingWorkDateCreateSuccess,
    travelingWorkDateCreateFailure = _createActions2.travelingWorkDateCreateFailure;

function createTravelingWorkDate(parentID, parentKind, travelingWorkDate) {
  return function (dispatch) {
    dispatch(travelingWorkDateCreateRequest());
    return Object(__WEBPACK_IMPORTED_MODULE_1__services__["h" /* request */])(parentKind + '/' + parentID + '/traveling_work_dates', { method: 'POST', body: { traveling_work_date: travelingWorkDate } }).then(function (_ref2) {
      var json = _ref2.json;
      return dispatch(travelingWorkDateCreateSuccess(json));
    }).catch(function (_ref3) {
      var errors = _ref3.errors;
      return dispatch(travelingWorkDateCreateFailure({ travelingWorkDate: travelingWorkDate, errors: errors }));
    });
  };
}

var _createActions3 = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])('TRAVELING_WORK_DATE_UPDATE_SUCCESS', 'TRAVELING_WORK_DATE_UPDATE_REQUEST', 'TRAVELING_WORK_DATE_UPDATE_FAILURE'),
    travelingWorkDateUpdateRequest = _createActions3.travelingWorkDateUpdateRequest,
    travelingWorkDateUpdateSuccess = _createActions3.travelingWorkDateUpdateSuccess,
    travelingWorkDateUpdateFailure = _createActions3.travelingWorkDateUpdateFailure;

function updateTravelingWorkDate(travelingWorkDateID, travelingWorkDate) {
  return function (dispatch) {
    dispatch(travelingWorkDateUpdateRequest());

    return Object(__WEBPACK_IMPORTED_MODULE_1__services__["h" /* request */])('traveling_work_dates/' + travelingWorkDateID, { method: 'PATCH', body: { traveling_work_date: travelingWorkDate } }).then(function (_ref4) {
      var json = _ref4.json;
      return dispatch(travelingWorkDateUpdateSuccess(json));
    }).catch(function (_ref5) {
      var errors = _ref5.errors;
      return dispatch(travelingWorkDateUpdateFailure({ travelingWorkDate: travelingWorkDate, errors: errors }));
    });
  };
}

var _createActions4 = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])('TRAVELING_WORK_DATE_DELETE_SUCCESS', 'TRAVELING_WORK_DATE_DELETE_REQUEST', 'TRAVELING_WORK_DATE_DELETE_FAILURE'),
    travelingWorkDateDeleteRequest = _createActions4.travelingWorkDateDeleteRequest,
    travelingWorkDateDeleteSuccess = _createActions4.travelingWorkDateDeleteSuccess,
    travelingWorkDateDeleteFailure = _createActions4.travelingWorkDateDeleteFailure;

function deleteTravelingWorkDate(travelingWorkDateID) {
  return function (dispatch) {
    dispatch(travelingWorkDateDeleteRequest());

    return Object(__WEBPACK_IMPORTED_MODULE_1__services__["h" /* request */])('traveling_work_dates/' + travelingWorkDateID, { method: 'DELETE' }).then(function () {
      return dispatch(travelingWorkDateDeleteSuccess({ travelingWorkDateID: travelingWorkDateID }));
    }).catch(function (error) {
      return dispatch(travelingWorkDateDeleteFailure(error));
    });
  };
}

/***/ }),

/***/ "Rurv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___1lEz7","m-signature-pad--body":"styles__m-signature-pad--body___3pKiW","m-signature-pad--footer":"styles__m-signature-pad--footer___3LFiC","description":"styles__description___1ITPc","button":"styles__button___2949c","clear":"styles__clear___3mW6T","save":"styles__save___MBxYP","m-signature-pad":"styles__m-signature-pad___S-Qef","github":"styles__github___33Zc2","label":"styles__label___ww7ci","outcomeNote":"styles__outcomeNote___1lMBh"};

/***/ }),

/***/ "SMIQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"button__msignaturepad___1kQ8P","m-signature-pad--body":"button__m-signature-pad--body___VH2fF","m-signature-pad--footer":"button__m-signature-pad--footer___2RyDK","description":"button__description___15ZVj","button":"button__button___UkooD","clear":"button__clear___vBKBa","save":"button__save___3K6zu","m-signature-pad":"button__m-signature-pad___39_8v","github":"button__github___251Vc","neutral":"button__neutral___3r-bM","inverse":"button__inverse___1I8ZQ","flat":"button__flat___Sgu4i","primary":"button__primary___t7jFA","subMenuHorizontal":"button__subMenuHorizontal___2CRR4","selected":"button__selected___yKJRV","subMenuVertical":"button__subMenuVertical___K8w3O"};

/***/ }),

/***/ "SObt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"phaseDetailsCard__msignaturepad___35Dr3","m-signature-pad--body":"phaseDetailsCard__m-signature-pad--body___3yMXS","m-signature-pad--footer":"phaseDetailsCard__m-signature-pad--footer___2PnTK","description":"phaseDetailsCard__description___SRsnQ","button":"phaseDetailsCard__button___1HM8d","clear":"phaseDetailsCard__clear___lETAf","save":"phaseDetailsCard__save___2o6ra","m-signature-pad":"phaseDetailsCard__m-signature-pad___28qXd","github":"phaseDetailsCard__github___Xn_t5","detailsCardContainer":"phaseDetailsCard__detailsCardContainer___2WvKR","additionalComments":"phaseDetailsCard__additionalComments___3KMv4","resourceDetails":"phaseDetailsCard__resourceDetails___2evnX","surfaceInfoList":"phaseDetailsCard__surfaceInfoList___2fksZ"};

/***/ }),

/***/ "SfFG":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "way1-4912b3a12461114784acbbd58d8b0578.png";

/***/ }),

/***/ "T3qJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"card__msignaturepad___EyX9n","m-signature-pad--body":"card__m-signature-pad--body___3tmwJ","m-signature-pad--footer":"card__m-signature-pad--footer___11d_n","description":"card__description___8C-cf","button":"card__button___2kEaA","clear":"card__clear___3UISX","save":"card__save___27yS6","m-signature-pad":"card__m-signature-pad___1ut8g","github":"card__github___1kYAs"};

/***/ }),

/***/ "TAhH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___2cpth","m-signature-pad--body":"styles__m-signature-pad--body___WoqUZ","m-signature-pad--footer":"styles__m-signature-pad--footer___1r2Yx","description":"styles__description___4WBIp","button":"styles__button___5dMJr","clear":"styles__clear___mWGEt","save":"styles__save___yMC6L","m-signature-pad":"styles__m-signature-pad___3KtGj","github":"styles__github___26Onn","container":"styles__container___2-tND"};

/***/ }),

/***/ "Tokm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"crewForm__msignaturepad___15EvC","m-signature-pad--body":"crewForm__m-signature-pad--body___1p8_-","m-signature-pad--footer":"crewForm__m-signature-pad--footer___a-LP3","description":"crewForm__description___2fApX","button":"crewForm__button___3M4N9","clear":"crewForm__clear___3VQio","save":"crewForm__save___zCF1_","m-signature-pad":"crewForm__m-signature-pad___3DHQP","github":"crewForm__github___2DMAa","field":"crewForm__field___1ZrF_","crewContainer":"crewForm__crewContainer___1YwHM","crewSwitch":"crewForm__crewSwitch___2ktE5","removeButtonFloatFix":"crewForm__removeButtonFloatFix___1GuhH","switchStyling":"crewForm__switchStyling___OHpoT","crewSwitchContainer":"crewForm__crewSwitchContainer___1dCdu","mobileHeaderContainer":"crewForm__mobileHeaderContainer___3MmFt","mobileInstallerInfoContainer":"crewForm__mobileInstallerInfoContainer___NjEha","crewActiveSwitch":"crewForm__crewActiveSwitch___2AlSg","mheader":"crewForm__mheader___j3v-p","mdates":"crewForm__mdates___1wh6l"};

/***/ }),

/***/ "U2Su":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"phaseDetailsBar__msignaturepad___2O1C1","m-signature-pad--body":"phaseDetailsBar__m-signature-pad--body___zMbAz","m-signature-pad--footer":"phaseDetailsBar__m-signature-pad--footer___D5HRZ","description":"phaseDetailsBar__description___LIaBu","button":"phaseDetailsBar__button___1oscW","clear":"phaseDetailsBar__clear___24Vge","save":"phaseDetailsBar__save___2u7aB","m-signature-pad":"phaseDetailsBar__m-signature-pad____DXJO","github":"phaseDetailsBar__github___2GaNh","phaseDetailsBar":"phaseDetailsBar__phaseDetailsBar___2RzMg","ResourceDetails":"phaseDetailsBar__ResourceDetails___1dvOu","ResourceDetailsCE_resourceCardElementTitle":"phaseDetailsBar__ResourceDetailsCE_resourceCardElementTitle___1U_t1","ResourceDetailsCE_resourceCardElementValue":"phaseDetailsBar__ResourceDetailsCE_resourceCardElementValue___77aGS","ResourceDetails-expanded":"phaseDetailsBar__ResourceDetails-expanded___2xIQN","scrolling":"phaseDetailsBar__scrolling___2Dfz8","expandButton":"phaseDetailsBar__expandButton___22QW_","resourceCardElement":"phaseDetailsBar__resourceCardElement___3CapK","notes":"phaseDetailsBar__notes___2LFbv","notesContainer":"phaseDetailsBar__notesContainer___BRrKW","phaseType":"phaseDetailsBar__phaseType___1QfeW","phaseDue":"phaseDetailsBar__phaseDue___Vuvo8","mobilePhaseDue":"phaseDetailsBar__mobilePhaseDue___3L9Kc","mobilePhaseDueContent":"phaseDetailsBar__mobilePhaseDueContent___2sKQL","phaseDueLine":"phaseDetailsBar__phaseDueLine___3qcZE","label":"phaseDetailsBar__label___3guJf","active":"phaseDetailsBar__active___2xoI6","tabs":"phaseDetailsBar__tabs___3LiKI","wayTabs":"phaseDetailsBar__wayTabs___33xlV","samTabs":"phaseDetailsBar__samTabs___1YsUK","pftTabs":"phaseDetailsBar__pftTabs___jXjxW","bjTabs":"phaseDetailsBar__bjTabs___ZIoPZ","ahTabs":"phaseDetailsBar__ahTabs___1v2pK","ifiTabs":"phaseDetailsBar__ifiTabs___1XC7L","lhiTabs":"phaseDetailsBar__lhiTabs___sNrYD","fdTabs":"phaseDetailsBar__fdTabs___1KDB9","rfTabs":"phaseDetailsBar__rfTabs___1xiaZ","phaseTab":"phaseDetailsBar__phaseTab___3r9g2","hidden":"phaseDetailsBar__hidden___2OQWn","navigation":"phaseDetailsBar__navigation___3XszC","pointer":"phaseDetailsBar__pointer___2kn_1","phone":"phaseDetailsBar__phone___1J4cp","relatedPhases":"phaseDetailsBar__relatedPhases___3eEvu","lowesRelatedPhases":"phaseDetailsBar__lowesRelatedPhases___rt4Wy","rfImg":"phaseDetailsBar__rfImg___1Zjbh","fdImg":"phaseDetailsBar__fdImg___1gIFh","pftImg":"phaseDetailsBar__pftImg___30MXe","lhiImg":"phaseDetailsBar__lhiImg___2xu_4","ifiImg":"phaseDetailsBar__ifiImg___1HXdQ","ahImg":"phaseDetailsBar__ahImg___1wuec","bjImg":"phaseDetailsBar__bjImg___37gPf","samImg":"phaseDetailsBar__samImg___3uTD5","wayImg":"phaseDetailsBar__wayImg___1BU5X","logoMobile":"phaseDetailsBar__logoMobile___1Qe-U","multiTypeDescription":"phaseDetailsBar__multiTypeDescription___1On5H"};

/***/ }),

/***/ "UaJO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___1FUMr","m-signature-pad--body":"styles__m-signature-pad--body____v7lu","m-signature-pad--footer":"styles__m-signature-pad--footer___1wECu","description":"styles__description___1QG_c","button":"styles__button___nyNgF","clear":"styles__clear___DOiY6","save":"styles__save___3bsVW","m-signature-pad":"styles__m-signature-pad___1_wtb","github":"styles__github___2Usnl","userDetailsPhoneType":"styles__userDetailsPhoneType___1frdN"};

/***/ }),

/***/ "Uqwq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"printLabel__msignaturepad___fhWs4","m-signature-pad--body":"printLabel__m-signature-pad--body___3LcHI","m-signature-pad--footer":"printLabel__m-signature-pad--footer___2wvqm","description":"printLabel__description___2CgEk","button":"printLabel__button___2mjNy","clear":"printLabel__clear___11Ebw","save":"printLabel__save___1y2WV","m-signature-pad":"printLabel__m-signature-pad___1Ze0w","github":"printLabel__github___DWakF","icon":"printLabel__icon___2Yvg4","anchor":"printLabel__anchor___3xEZP"};

/***/ }),

/***/ "WTkQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "arrow_forward-86d9631119bdad787c8bf16414bb7a2e.png";

/***/ }),

/***/ "WWCX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = requestDivisionList;
/* harmony export (immutable) */ __webpack_exports__["f"] = requestRegionList;
/* harmony export (immutable) */ __webpack_exports__["b"] = requestMarketList;
/* harmony export (immutable) */ __webpack_exports__["e"] = requestPricePatchesList;
/* harmony export (immutable) */ __webpack_exports__["d"] = requestPricePatchLineItemList;
/* harmony export (immutable) */ __webpack_exports__["c"] = requestPayRateLineItemList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services__ = __webpack_require__("NvlE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_schemas__ = __webpack_require__("oge5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_normalizr__ = __webpack_require__("rI7m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_normalizr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_normalizr__);





var _createActions = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])({
  DIVISION_LIST_SUCCESS: function DIVISION_LIST_SUCCESS(json) {
    return json.divisions;
  }
}, 'DIVISION_LIST_REQUEST', 'DIVISION_LIST_FAILURE'),
    divisionListRequest = _createActions.divisionListRequest,
    divisionListSuccess = _createActions.divisionListSuccess,
    divisionListFailure = _createActions.divisionListFailure;

function requestDivisionList() {
  return function (dispatch) {
    dispatch(divisionListRequest());
    return Object(__WEBPACK_IMPORTED_MODULE_1__services__["h" /* request */])('divisions').then(function (_ref) {
      var json = _ref.json;

      dispatch(divisionListSuccess(json));
    }, function (error) {
      dispatch(divisionListFailure(error));
    });
  };
}

var _createActions2 = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])({
  REGION_LIST_SUCCESS: function REGION_LIST_SUCCESS(json) {
    return json.regions;
  }
}, 'REGION_LIST_REQUEST', 'REGION_LIST_FAILURE'),
    regionListRequest = _createActions2.regionListRequest,
    regionListSuccess = _createActions2.regionListSuccess,
    regionListFailure = _createActions2.regionListFailure;

function requestRegionList() {
  var divisionId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  var queryString = '';
  if (divisionId) queryString = '?from_division=' + divisionId;
  return function (dispatch) {
    dispatch(regionListRequest());
    return Object(__WEBPACK_IMPORTED_MODULE_1__services__["h" /* request */])('regions' + queryString).then(function (_ref2) {
      var json = _ref2.json;

      dispatch(regionListSuccess(json));
    }, function (error) {
      dispatch(regionListFailure(error));
    });
  };
}

var _createActions3 = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])({
  MARKET_LIST_SUCCESS: function MARKET_LIST_SUCCESS(json) {
    return json.markets;
  }
}, 'MARKET_LIST_REQUEST', 'MARKET_LIST_FAILURE'),
    marketListRequest = _createActions3.marketListRequest,
    marketListSuccess = _createActions3.marketListSuccess,
    marketListFailure = _createActions3.marketListFailure;

function requestMarketList() {
  var regionId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  var queryString = '';
  if (regionId) queryString = '?from_region=' + regionId;
  return function (dispatch) {
    dispatch(marketListRequest());
    return Object(__WEBPACK_IMPORTED_MODULE_1__services__["h" /* request */])('markets' + queryString).then(function (_ref3) {
      var json = _ref3.json;

      dispatch(marketListSuccess(json));
    }, function (error) {
      dispatch(marketListFailure(error));
    });
  };
}

var _createActions4 = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])({
  PRICE_PATCH_LIST_SUCCESS: function PRICE_PATCH_LIST_SUCCESS(json) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_normalizr__["normalize"])(json, { price_patches: __WEBPACK_IMPORTED_MODULE_2_schemas__["a" /* default */].PRICE_PATCH_ARRAY });
  }
}, 'PRICE_PATCH_LIST_REQUEST', 'PRICE_PATCH_LIST_FAILURE'),
    pricePatchListRequest = _createActions4.pricePatchListRequest,
    pricePatchListSuccess = _createActions4.pricePatchListSuccess,
    pricePatchListFailure = _createActions4.pricePatchListFailure;

function requestPricePatchesList() {
  return function (dispatch) {
    dispatch(pricePatchListRequest());
    return Object(__WEBPACK_IMPORTED_MODULE_1__services__["h" /* request */])('price_patches').then(function (_ref4) {
      var json = _ref4.json;

      dispatch(pricePatchListSuccess(json));
    }, function (error) {
      dispatch(pricePatchListFailure(error));
    });
  };
}

var _createActions5 = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])({
  PRICE_PATCH_LINE_ITEM_LIST_SUCCESS: function PRICE_PATCH_LINE_ITEM_LIST_SUCCESS(json) {
    return {
      lineItems: json.line_items
    };
  }
}, 'PRICE_PATCH_LINE_ITEM_LIST_REQUEST', 'PRICE_PATCH_LINE_ITEM_LIST_FAILURE'),
    pricePatchLineItemListRequest = _createActions5.pricePatchLineItemListRequest,
    pricePatchLineItemListSuccess = _createActions5.pricePatchLineItemListSuccess,
    pricePatchLineItemListFailure = _createActions5.pricePatchLineItemListFailure;

function requestPricePatchLineItemList(phaseId) {
  return function (dispatch) {
    dispatch(pricePatchLineItemListRequest());
    return Object(__WEBPACK_IMPORTED_MODULE_1__services__["h" /* request */])('price_patch_line_items?phase_id=' + phaseId).then(function (_ref5) {
      var json = _ref5.json;
      return dispatch(pricePatchLineItemListSuccess(json));
    }, function (error) {
      return dispatch(pricePatchLineItemListFailure(error));
    });
  };
}

var _createActions6 = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])({
  PAY_RATE_LINE_ITEM_LIST_SUCCESS: function PAY_RATE_LINE_ITEM_LIST_SUCCESS(json, referenceId) {
    return {
      lineItems: json.line_items,
      referenceId: referenceId
    };
  }
}, 'PAY_RATE_LINE_ITEM_LIST_REQUEST', 'PAY_RATE_LINE_ITEM_LIST_FAILURE'),
    payRateLineItemListRequest = _createActions6.payRateLineItemListRequest,
    payRateLineItemListSuccess = _createActions6.payRateLineItemListSuccess,
    payRateLineItemListFailure = _createActions6.payRateLineItemListFailure;

function requestPayRateLineItemList(contractorType, contractorId, referenceId) {
  return function (dispatch) {
    dispatch(payRateLineItemListRequest());
    return Object(__WEBPACK_IMPORTED_MODULE_1__services__["h" /* request */])('pay_rate_line_items?contractor_type=' + contractorType + '&contractor_id=' + contractorId + '&labor_sheet_id=' + referenceId).then(function (_ref6) {
      var json = _ref6.json;
      return dispatch(payRateLineItemListSuccess(json, referenceId));
    }, function (error) {
      return dispatch(payRateLineItemListFailure(error));
    });
  };
}

/***/ }),

/***/ "Wi68":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___1XRju","m-signature-pad--body":"styles__m-signature-pad--body___upo_j","m-signature-pad--footer":"styles__m-signature-pad--footer___33Km8","description":"styles__description___10bGq","button":"styles__button___SEFtt","clear":"styles__clear___14Xm-","save":"styles__save___2IFJz","m-signature-pad":"styles__m-signature-pad___FT4oa","github":"styles__github___1iKt_","container":"styles__container___qy9s2","tabs":"styles__tabs___3jGwH","tabContent":"styles__tabContent___3Ihua","noInstallersMessage":"styles__noInstallersMessage___2TYVt","slidersSection":"styles__slidersSection___yFhLF","sliderRow":"styles__sliderRow___2rL4-","installerInfo":"styles__installerInfo___1RJtW","installerLabel":"styles__installerLabel___11PjO","phaseCount":"styles__phaseCount___3qxp1","sliderControls":"styles__sliderControls___DRYVT","sliderWrapper":"styles__sliderWrapper____0AzC","slider":"styles__slider___105hN","sliderRuler":"styles__sliderRuler___1ZUw6","rulerTick":"styles__rulerTick___vsf43","inputGroup":"styles__inputGroup___1_shP","percentInput":"styles__percentInput___3ankP","percentSymbol":"styles__percentSymbol___JSiK8","totalRow":"styles__totalRow___dcZbp","totalLabel":"styles__totalLabel___1Mjc0","totalValue":"styles__totalValue___1gfKS","totalValueInvalid":"styles__totalValueInvalid___1hDhA"};

/***/ }),

/***/ "XEfE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"displayFeedStyling__msignaturepad___1-oi5","m-signature-pad--body":"displayFeedStyling__m-signature-pad--body___zhIPF","m-signature-pad--footer":"displayFeedStyling__m-signature-pad--footer___2CFaM","description":"displayFeedStyling__description___2fp0e","button":"displayFeedStyling__button___1Ymuc","clear":"displayFeedStyling__clear___2QATF","save":"displayFeedStyling__save___Z3NV-","m-signature-pad":"displayFeedStyling__m-signature-pad___2Qd7v","github":"displayFeedStyling__github___18IDs","screenshotImage":"displayFeedStyling__screenshotImage___2WwJp","display-cover":"displayFeedStyling__display-cover___22qOv","videoOptions":"displayFeedStyling__videoOptions___dcfcI","controls":"displayFeedStyling__controls___3dpa_"};

/***/ }),

/***/ "YV0Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___1nOHh","m-signature-pad--body":"styles__m-signature-pad--body___3oxXF","m-signature-pad--footer":"styles__m-signature-pad--footer___GlnMQ","description":"styles__description___3ipqF","button":"styles__button___2xRFX","clear":"styles__clear___1Ghlz","save":"styles__save___2dWTk","m-signature-pad":"styles__m-signature-pad___2WP8A","github":"styles__github___1yRON","taskCheckedIcon":"styles__taskCheckedIcon___16Nz-","taskClockIcon":"styles__taskClockIcon___2eV-A","taskPendingIcon":"styles__taskPendingIcon___3Y9J9"};

/***/ }),

/***/ "Z5Js":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"common__msignaturepad___1fytd","m-signature-pad--body":"common__m-signature-pad--body___WAKn3","m-signature-pad--footer":"common__m-signature-pad--footer___2H9n5","description":"common__description___3YXJW","button":"common__button___3l4Hu","clear":"common__clear___Hh88O","save":"common__save___1WWf9","m-signature-pad":"common__m-signature-pad___3r-O9","github":"common__github___1YJwL","react-entry":"common__react-entry___1WPTr","floatRight":"common__floatRight___1z8yj","floatLeft":"common__floatLeft___2EVlU"};

/***/ }),

/***/ "Z8kv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"phaseHistory__msignaturepad___3aQTM","m-signature-pad--body":"phaseHistory__m-signature-pad--body___Pdmk1","m-signature-pad--footer":"phaseHistory__m-signature-pad--footer___2E_df","description":"phaseHistory__description___ewg2l","button":"phaseHistory__button___1qbJU","clear":"phaseHistory__clear___2Alx6","save":"phaseHistory__save___1fwjt","m-signature-pad":"phaseHistory__m-signature-pad___kaSi8","github":"phaseHistory__github___FRMD1","phaseHistorySortContainer":"phaseHistory__phaseHistorySortContainer___33OYu","phaseHistorySortDirection":"phaseHistory__phaseHistorySortDirection___1OIG4","phaseHistoryContainer":"phaseHistory__phaseHistoryContainer___1F8oJ"};

/***/ }),

/***/ "ZNld":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"phaseTaskBar__msignaturepad___14UeM","m-signature-pad--body":"phaseTaskBar__m-signature-pad--body___1p8cY","m-signature-pad--footer":"phaseTaskBar__m-signature-pad--footer___3pVuX","description":"phaseTaskBar__description___3PoSi","button":"phaseTaskBar__button___1tj_i","clear":"phaseTaskBar__clear___XzBra","save":"phaseTaskBar__save___1QcLV","m-signature-pad":"phaseTaskBar__m-signature-pad___1Sa1e","github":"phaseTaskBar__github___2yk5I","phaseTaskBar":"phaseTaskBar__phaseTaskBar___rEmKR","phaseTaskBar__status":"phaseTaskBar__phaseTaskBar__status___3s0AS","statusText":"phaseTaskBar__statusText___1SHQX","phaseTaskBar__infoContainer":"phaseTaskBar__phaseTaskBar__infoContainer___3fVMu","phaseTaskBar__taskContainer":"phaseTaskBar__phaseTaskBar__taskContainer___1Btui","phaseTaskBar__flagsContainer":"phaseTaskBar__phaseTaskBar__flagsContainer___2yeH4","mobileButtonsWrapper":"phaseTaskBar__mobileButtonsWrapper___1rWT4","pendingQuickScheduleBadge":"phaseTaskBar__pendingQuickScheduleBadge___1hGDr"};

/***/ }),

/***/ "ZOQn":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "arrow_back-44430f0176649a84410c01c26d70e774.png";

/***/ }),

/***/ "ZdED":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "storm_handing-342913755c63ff8a78865a93843b1d26.png";

/***/ }),

/***/ "ZyHx":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "coc-42ef6ed2e16b8ecad29254576cd78d1a.jpg";

/***/ }),

/***/ "aO8m":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___3MuyW","m-signature-pad--body":"styles__m-signature-pad--body___1RtZP","m-signature-pad--footer":"styles__m-signature-pad--footer___9spOW","description":"styles__description___10AGr","button":"styles__button___2AVSs","clear":"styles__clear___31nHG","save":"styles__save___1tJaf","m-signature-pad":"styles__m-signature-pad___1Txv9","github":"styles__github___138A7","relatedPhasesSectionContainer":"styles__relatedPhasesSectionContainer___1wDso","emptyRelatedPhasesContainer":"styles__emptyRelatedPhasesContainer___2900A","emptyText":"styles__emptyText___2HrHN","dividerLine":"styles__dividerLine___2Lwho","wrapper":"styles__wrapper___3ta72"};

/***/ }),

/***/ "aVRF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___PFIxy","m-signature-pad--body":"styles__m-signature-pad--body___24r96","m-signature-pad--footer":"styles__m-signature-pad--footer___2g658","description":"styles__description___1yWLp","button":"styles__button___2-k5H","clear":"styles__clear___1AJ9g","save":"styles__save___2qjze","m-signature-pad":"styles__m-signature-pad___A6gBc","github":"styles__github___BxK9J","titleRow":"styles__titleRow___3JTe1","titleWrapper":"styles__titleWrapper___3wXO9","flexFullWidth":"styles__flexFullWidth___1TKdS","row":"styles__row___1zuy_"};

/***/ }),

/***/ "aZp/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"rtDatePicker__msignaturepad___1PUvQ","m-signature-pad--body":"rtDatePicker__m-signature-pad--body___2IPbJ","m-signature-pad--footer":"rtDatePicker__m-signature-pad--footer___3feFK","description":"rtDatePicker__description___1qe4j","button":"rtDatePicker__button___1Q08F","clear":"rtDatePicker__clear___2XhoY","save":"rtDatePicker__save___wZAVV","m-signature-pad":"rtDatePicker__m-signature-pad___3CZNR","github":"rtDatePicker__github___KbqsR","input":"rtDatePicker__input___BLDE0"};

/***/ }),

/***/ "avsK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___203Cz","m-signature-pad--body":"styles__m-signature-pad--body___2cq6c","m-signature-pad--footer":"styles__m-signature-pad--footer___1Oq62","description":"styles__description___164Go","button":"styles__button___3_LvV","clear":"styles__clear___rW2Yt","save":"styles__save___1pPDS","m-signature-pad":"styles__m-signature-pad___29Q6R","github":"styles__github___bE309","element":"styles__element___1rIbq"};

/***/ }),

/***/ "bEtk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getRandomNegativeInt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getNewLineItem; });
/* unused harmony export getIndexOfLineItem */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return updateLineItemsOnCreateHelper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return updateOnCreateExceptionHelper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return updateLineItemsOnUpdateHelper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addLineItemErrorHelper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addLineItemEventsHelper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return deleteLineItemHelper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return calculateTotal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return cutQuantityString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return formatDollars; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return filterByVendor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return normalizePayRateLineItemOptions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_config_constants__ = __webpack_require__("JKMY");
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* eslint no-param-reassign: 0 */



var getLineItemsFromExceptionData = function getLineItemsFromExceptionData(newItems) {
  var simplifiedList = [];
  newItems.forEach(function (item) {
    return simplifiedList.push(item.phase_line_item);
  });
  return simplifiedList;
};

var getRandomNegativeInt = function getRandomNegativeInt() {
  return Math.floor(Math.random() * (-1 - -999 + 1) + -999);
};

var getNewLineItem = function getNewLineItem() {
  var newId = new Date().getUTCMilliseconds() * -1;
  return { id: newId };
};

var getIndexOfLineItem = function getIndexOfLineItem(lineItems, id) {
  return lineItems.findIndex(function (n) {
    return n.id === id;
  });
};

var updateLineItemsOnCreateHelper = function updateLineItemsOnCreateHelper(lineItems, payload) {
  lineItems[lineItems.length - 1] = payload.line_item;
  lineItems.push(getNewLineItem());
};

var updateOnCreateExceptionHelper = function updateOnCreateExceptionHelper(lineItems, payload, listName) {
  if (listName === 'phaseLineItems') {
    var newItems = getLineItemsFromExceptionData(payload.line_items);
    newItems.forEach(function (item) {
      lineItems[lineItems.length - 1] = item;
    });
  } else {
    lineItems[lineItems.length - 1] = payload.po.purchase_order;
  }
  lineItems.push(getNewLineItem());
};

var updateLineItemsOnUpdateHelper = function updateLineItemsOnUpdateHelper(lineItems, payload) {
  var indexOfLineItem = getIndexOfLineItem(lineItems, payload.line_item.id);
  lineItems[indexOfLineItem] = payload.line_item;
};

var addLineItemErrorHelper = function addLineItemErrorHelper(lineItems, payload) {
  var indexOfLineItem = getIndexOfLineItem(lineItems, payload.line_item.id);
  lineItems[indexOfLineItem].errors = payload.errors.errors;
};

var addLineItemEventsHelper = function addLineItemEventsHelper(lineItems, payload) {
  var indexOfLineItem = getIndexOfLineItem(lineItems, payload.line_item.id);
  lineItems[indexOfLineItem].events = payload.events;
};

var deleteLineItemHelper = function deleteLineItemHelper(lineItems, id) {
  var indexOfLineItem = getIndexOfLineItem(lineItems, id);
  lineItems.splice(indexOfLineItem, 1);
};

var calculateTotal = function calculateTotal(price, quantity) {
  var priceFloat = parseFloat(price);
  var quantityFloat = parseFloat(quantity);

  if (isNaN(priceFloat) || isNaN(quantityFloat)) {
    return 0;
  }
  return Math.round(priceFloat * quantityFloat * 100) / 100;
};

var cutQuantityString = function cutQuantityString(cutObject) {
  var packages = cutObject.packages,
      remainder = cutObject.remainder;

  var padString = packages ? packages + ' roll(s)' : '';
  var feetString = remainder || !padString ? remainder + ' feet' : '';
  var addString = padString && feetString ? ' + ' : '';
  return '' + padString + addString + feetString;
};

var formatDollars = function formatDollars(value) {
  return '$' + parseFloat(value || 0).toFixed(2);
};

var filterByVendor = function filterByVendor(lineItemOptions, phaseSource) {
  if (__WEBPACK_IMPORTED_MODULE_0_config_constants__["_8" /* NON_LHI_SOURCES */].includes(phaseSource || '')) {
    return lineItemOptions.filter(function (o) {
      return o.vendor === phaseSource;
    });
  }
  return lineItemOptions.filter(function (o) {
    return !__WEBPACK_IMPORTED_MODULE_0_config_constants__["_8" /* NON_LHI_SOURCES */].includes(o.vendor || '');
  });
};

/**
 * payRateLineItems.data is { [laborSheetId]: options[] } (see pay_rate_line_items reducer).
 * Callers may also pass an already-normalized array.
 */
var normalizePayRateLineItemOptions = function normalizePayRateLineItemOptions(payData, laborSheets) {
  var sheets = laborSheets || [];
  if (payData == null) return [];
  if (Array.isArray(payData)) return payData;
  if ((typeof payData === 'undefined' ? 'undefined' : _typeof(payData)) !== 'object') return [];

  var preferNonEmpty = function preferNonEmpty(arrays) {
    var valid = arrays.filter(Array.isArray);
    var withItems = valid.find(function (a) {
      return a.length > 0;
    });
    if (withItems) return withItems;
    return valid[0];
  };

  var fromSheets = preferNonEmpty(sheets.map(function (s) {
    return payData[s.id];
  }));
  if (fromSheets !== undefined) return fromSheets;

  var fromValues = preferNonEmpty(Object.values(payData));
  return fromValues !== undefined ? fromValues : [];
};

/***/ }),

/***/ "bGvD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"detailsSection__msignaturepad___2i4Ol","m-signature-pad--body":"detailsSection__m-signature-pad--body___ssSqU","m-signature-pad--footer":"detailsSection__m-signature-pad--footer___1-pRr","description":"detailsSection__description___3kZpA","button":"detailsSection__button___2jhgj","clear":"detailsSection__clear___1PDv0","save":"detailsSection__save___2FHJl","m-signature-pad":"detailsSection__m-signature-pad___3fmzP","github":"detailsSection__github___1pNu8","section":"detailsSection__section___1tXqU","innerSection":"detailsSection__innerSection___2KvtL","inactive":"detailsSection__inactive___1sFab","sectionTitle":"detailsSection__sectionTitle___2lE6E","cardHeader":"detailsSection__cardHeader___3D_Hy","cardTitle":"detailsSection__cardTitle___3KPtu","cardDeliveryStatus":"detailsSection__cardDeliveryStatus___3w23n","normalText":"detailsSection__normalText___Nm4Xu","flexboxDiv":"detailsSection__flexboxDiv___xhDRU","bigTitle":"detailsSection__bigTitle___2tfxp","mediumTitle":"detailsSection__mediumTitle___1DnQS","sectionListItem":"detailsSection__sectionListItem___bQCvj","innerFlexSection":"detailsSection__innerFlexSection___25cjB","userDetailsLink":"detailsSection__userDetailsLink___1-t36"};

/***/ }),

/***/ "cjrT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"headerResourceDetailsCard__msignaturepad____6CZU","m-signature-pad--body":"headerResourceDetailsCard__m-signature-pad--body___2m6H6","m-signature-pad--footer":"headerResourceDetailsCard__m-signature-pad--footer___RGT8i","description":"headerResourceDetailsCard__description___iCvPP","button":"headerResourceDetailsCard__button___sSuY6","clear":"headerResourceDetailsCard__clear___h12uC","save":"headerResourceDetailsCard__save___3Dcz7","m-signature-pad":"headerResourceDetailsCard__m-signature-pad___2rh0w","github":"headerResourceDetailsCard__github___3fL3B","resourceCardElement":"headerResourceDetailsCard__resourceCardElement___2MsLv"};

/***/ }),

/***/ "cufn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___2Z1SH","m-signature-pad--body":"styles__m-signature-pad--body___k8X0U","m-signature-pad--footer":"styles__m-signature-pad--footer___3giyU","description":"styles__description___eWQoX","button":"styles__button___1VyLg","clear":"styles__clear___3VqRa","save":"styles__save___1tXlO","m-signature-pad":"styles__m-signature-pad___3aILh","github":"styles__github___1knq3","mot":"styles__mot___2BpCF","motOnTime":"styles__motOnTime___1ASOE","motWarning":"styles__motWarning___1lntC","motOverdue":"styles__motOverdue___1Dl6u","motNotApplicable":"styles__motNotApplicable___2mPq2"};

/***/ }),

/***/ "dFE1":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ic-history-black-24-px-copy-4-65479dc888586efb01715a007bab53a1.svg";

/***/ }),

/***/ "dZ0t":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___3v6l4","m-signature-pad--body":"styles__m-signature-pad--body___33PXI","m-signature-pad--footer":"styles__m-signature-pad--footer___12PYt","description":"styles__description___17Xis","button":"styles__button___3F4VE","clear":"styles__clear___32IPy","save":"styles__save___2XGbj","m-signature-pad":"styles__m-signature-pad___3PUac","github":"styles__github___1xxpP","label":"styles__label___3daOg","text":"styles__text___fmGHa","errorLabel":"styles__errorLabel___2xtsF","errorMsg":"styles__errorMsg___2TDMg"};

/***/ }),

/***/ "diHI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___1zS3G","m-signature-pad--body":"styles__m-signature-pad--body___3etuf","m-signature-pad--footer":"styles__m-signature-pad--footer___1HwXP","description":"styles__description___1fwaB","button":"styles__button___C1u82","clear":"styles__clear___n_zjB","save":"styles__save___h9IwK","m-signature-pad":"styles__m-signature-pad___38O81","github":"styles__github___2Gxkh","updatesList":"styles__updatesList___264i6","nestedAttribute":"styles__nestedAttribute___4DMGK"};

/***/ }),

/***/ "eorU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___3IAvD","m-signature-pad--body":"styles__m-signature-pad--body___1BnSp","m-signature-pad--footer":"styles__m-signature-pad--footer___1Yq8E","description":"styles__description___2uI2-","button":"styles__button___2vo5M","clear":"styles__clear___3I0g8","save":"styles__save___3SY_u","m-signature-pad":"styles__m-signature-pad___uvUpw","github":"styles__github___3Di0c","uploadLink":"styles__uploadLink___ckoQn","centerFont":"styles__centerFont___2NdHp"};

/***/ }),

/***/ "ewgj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"documentLink__msignaturepad___3BQvv","m-signature-pad--body":"documentLink__m-signature-pad--body___1u-b0","m-signature-pad--footer":"documentLink__m-signature-pad--footer___sL_xN","description":"documentLink__description___I1U6H","button":"documentLink__button___D5Nry","clear":"documentLink__clear___mf7Ot","save":"documentLink__save___Izi01","m-signature-pad":"documentLink__m-signature-pad___3hGpX","github":"documentLink__github___tDBzL","notUse":"documentLink__notUse___3w7b0"};

/***/ }),

/***/ "fQMP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___1BIsj","m-signature-pad--body":"styles__m-signature-pad--body___1YWeB","m-signature-pad--footer":"styles__m-signature-pad--footer___2r1nE","description":"styles__description___NlKrJ","button":"styles__button___3IM-n","clear":"styles__clear___2y75j","save":"styles__save___3Bvum","m-signature-pad":"styles__m-signature-pad___3RR90","github":"styles__github___1KSmZ","labelContent":"styles__labelContent___1ARMD","infoIcon":"styles__infoIcon___12C-S","tooltipText":"styles__tooltipText___1vJ9P"};

/***/ }),

/***/ "fvgW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"employableHistoryCard__msignaturepad___2Pcyz","m-signature-pad--body":"employableHistoryCard__m-signature-pad--body___29DNK","m-signature-pad--footer":"employableHistoryCard__m-signature-pad--footer___C6BsQ","description":"employableHistoryCard__description___1nVd2","button":"employableHistoryCard__button___3bOwZ","clear":"employableHistoryCard__clear___3wKkZ","save":"employableHistoryCard__save___CwYFA","m-signature-pad":"employableHistoryCard__m-signature-pad___1DbkV","github":"employableHistoryCard__github___25ch0","employableHistoryCard":"employableHistoryCard__employableHistoryCard___23RL2","employableHistoryCard__container":"employableHistoryCard__employableHistoryCard__container___1imb2","employableHistoryCard__title":"employableHistoryCard__employableHistoryCard__title___2QnNZ","employableHistoryCard__collapseToggle":"employableHistoryCard__employableHistoryCard__collapseToggle___3pFF6","employableHistoryCard__content":"employableHistoryCard__employableHistoryCard__content___2OI6z","resourceCardElement":"employableHistoryCard__resourceCardElement___1GNwr","resourceCardElementTitle":"employableHistoryCard__resourceCardElementTitle___HENCA","employableEventCard":"employableHistoryCard__employableEventCard___1KBw0"};

/***/ }),

/***/ "fyNL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"eventTable__msignaturepad___2f9m1","m-signature-pad--body":"eventTable__m-signature-pad--body___N_ZSr","m-signature-pad--footer":"eventTable__m-signature-pad--footer___3tGMh","description":"eventTable__description___3S9LU","button":"eventTable__button___Qb97z","clear":"eventTable__clear___3AA86","save":"eventTable__save___3ZFpZ","m-signature-pad":"eventTable__m-signature-pad___3eEoo","github":"eventTable__github___3Aj1U","table":"eventTable__table___pROqe","header":"eventTable__header___3Lq9I","data":"eventTable__data___MO8s5"};

/***/ }),

/***/ "g2ib":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"mobilePhaseCard__msignaturepad___2hYA6","m-signature-pad--body":"mobilePhaseCard__m-signature-pad--body___v9uH_","m-signature-pad--footer":"mobilePhaseCard__m-signature-pad--footer___3HXJe","description":"mobilePhaseCard__description___1hFn4","button":"mobilePhaseCard__button___1Xteo","clear":"mobilePhaseCard__clear___36H8a","save":"mobilePhaseCard__save___1EgKk","m-signature-pad":"mobilePhaseCard__m-signature-pad___2xNou","github":"mobilePhaseCard__github___1F3Un","resourceCardElement":"mobilePhaseCard__resourceCardElement___UwhZy","resourceCardElementTitle":"mobilePhaseCard__resourceCardElementTitle___2xF-4"};

/***/ }),

/***/ "g4rU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___1DTyI","m-signature-pad--body":"styles__m-signature-pad--body___1ZsYz","m-signature-pad--footer":"styles__m-signature-pad--footer___20-0E","description":"styles__description___3kN9v","button":"styles__button___alTLO","clear":"styles__clear___2qouw","save":"styles__save___5B3zX","m-signature-pad":"styles__m-signature-pad___3kAnk","github":"styles__github___149YN","close":"styles__close___3N_9z","submitBtnContainer":"styles__submitBtnContainer___2rwmj","checklistHeading":"styles__checklistHeading___bjwhy"};

/***/ }),

/***/ "gDOu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___3ezCp","m-signature-pad--body":"styles__m-signature-pad--body___2IqZI","m-signature-pad--footer":"styles__m-signature-pad--footer___25iEJ","description":"styles__description___2XZhD","button":"styles__button___28rqU","clear":"styles__clear___11mg-","save":"styles__save___30n68","m-signature-pad":"styles__m-signature-pad___1infg","github":"styles__github___2Ztjn","userDetailsLink":"styles__userDetailsLink___APgv5","userDetailsButton":"styles__userDetailsButton___1Ov6f","userDetailsLinkSeparator":"styles__userDetailsLinkSeparator___3Jy31","userDetailsEdit":"styles__userDetailsEdit___2bgtD","userDetailsDivider":"styles__userDetailsDivider___1tBIw","userDetailsName":"styles__userDetailsName___2nvN5","userDetailsPosition":"styles__userDetailsPosition___14S4T","userRole":"styles__userRole___2lZJ5","nameOnly":"styles__nameOnly___ocpG4"};

/***/ }),

/***/ "gIPr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"pageActionButton__msignaturepad___1WiUk","m-signature-pad--body":"pageActionButton__m-signature-pad--body___2czfp","m-signature-pad--footer":"pageActionButton__m-signature-pad--footer___13vXz","description":"pageActionButton__description___2w9gk","button":"pageActionButton__button___Ur5SE","clear":"pageActionButton__clear___19nri","save":"pageActionButton__save___1WuWc","m-signature-pad":"pageActionButton__m-signature-pad___1Ydqc","github":"pageActionButton__github___2HY2m","actions":"pageActionButton__actions___-sG86","iconButtonText":"pageActionButton__iconButtonText___1eyes","blue":"pageActionButton__blue___3KX3O","orange":"pageActionButton__orange___3ETnF"};

/***/ }),

/***/ "gTrv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"card__msignaturepad___3_Kv6","m-signature-pad--body":"card__m-signature-pad--body___2QnNG","m-signature-pad--footer":"card__m-signature-pad--footer___Or7D1","description":"card__description___1Qe-4","button":"card__button___2v8EX","clear":"card__clear___PR_xh","save":"card__save___vR0lx","m-signature-pad":"card__m-signature-pad___UhGx5","github":"card__github___pWwUg","cardTitle":"card__cardTitle___2iTkP","subtitle":"card__subtitle___3cxBa","large":"card__large___2F3JL","title":"card__title___1ImmB"};

/***/ }),

/***/ "gsey":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"detailsCardElement__msignaturepad___3v4oV","m-signature-pad--body":"detailsCardElement__m-signature-pad--body___2CviC","m-signature-pad--footer":"detailsCardElement__m-signature-pad--footer___3J2qD","description":"detailsCardElement__description___2NkAC","button":"detailsCardElement__button___YYs6c","clear":"detailsCardElement__clear___3-I5H","save":"detailsCardElement__save___w3wo5","m-signature-pad":"detailsCardElement__m-signature-pad___3j8Yk","github":"detailsCardElement__github___39qk2","resourceCardElement":"detailsCardElement__resourceCardElement___GjAqd","desktop-3x":"detailsCardElement__desktop-3x___3_qRy","desktop-2x":"detailsCardElement__desktop-2x___8II77","desktop-1x":"detailsCardElement__desktop-1x___fMQDX","mobile-2x":"detailsCardElement__mobile-2x___3iV-z","mobile-1x":"detailsCardElement__mobile-1x___3SXVi"};

/***/ }),

/***/ "h4x6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"contentArea__msignaturepad___2pcHC","m-signature-pad--body":"contentArea__m-signature-pad--body___1C12i","m-signature-pad--footer":"contentArea__m-signature-pad--footer___11jZc","description":"contentArea__description___1j52t","button":"contentArea__button___2B67r","clear":"contentArea__clear___3iJqd","save":"contentArea__save___3bOkV","m-signature-pad":"contentArea__m-signature-pad___2PIJO","github":"contentArea__github___1H1PA","contentAreaContainer":"contentArea__contentAreaContainer___1fhuY","containerWithSidebar":"contentArea__containerWithSidebar___1tr8s","contentWithSidebar":"contentArea__contentWithSidebar___1qkRO","contentAreaWrapper":"contentArea__contentAreaWrapper___2_IqW","contentArea":"contentArea__contentArea___vqJ0I","contentSidebar":"contentArea__contentSidebar___toM_O","contentSidebarEditing":"contentArea__contentSidebarEditing___v2kg2","filter":"contentArea__filter___rIh7K","contentAreaTitle":"contentArea__contentAreaTitle___gLEiv","contentAreaActions":"contentArea__contentAreaActions___2gI61","titleActions":"contentArea__titleActions___176m9","rightActions":"contentArea__rightActions___3L3Ie","leftActions":"contentArea__leftActions___21o9s","titleAction":"contentArea__titleAction___1sB1_","actionInput":"contentArea__actionInput___2a7BA"};

/***/ }),

/***/ "hG6Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___3WA_M","m-signature-pad--body":"styles__m-signature-pad--body___xtA2Z","m-signature-pad--footer":"styles__m-signature-pad--footer___1-Tnz","description":"styles__description___2W00F","button":"styles__button___3k_bG","clear":"styles__clear___260_H","save":"styles__save___3OERP","m-signature-pad":"styles__m-signature-pad___zs6dA","github":"styles__github___3udTo","flexListItem":"styles__flexListItem___VEKys","text":"styles__text___3K7ho","dropdown":"styles__dropdown___24CSp","check":"styles__check___1cl5f"};

/***/ }),

/***/ "hYGo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___3OrIR","m-signature-pad--body":"styles__m-signature-pad--body___3P4ix","m-signature-pad--footer":"styles__m-signature-pad--footer___1-yeC","description":"styles__description___3ycOy","button":"styles__button___352Pf","clear":"styles__clear___2YkPr","save":"styles__save___3lc0i","m-signature-pad":"styles__m-signature-pad___2FbYz","github":"styles__github___2GRpY","timeOffTable":"styles__timeOffTable___dl1--","select":"styles__select___16l-r","datepicker":"styles__datepicker___1bkXv","reasonInput":"styles__reasonInput___2FAx0","mheader":"styles__mheader___7AlqT","mdates":"styles__mdates___IfgXG","hidden":"styles__hidden___2CIIn","emptyTable":"styles__emptyTable___ORo_e"};

/***/ }),

/***/ "hZAV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"calendar__msignaturepad___J7WA_","m-signature-pad--body":"calendar__m-signature-pad--body___1gE6o","m-signature-pad--footer":"calendar__m-signature-pad--footer___3TOvH","description":"calendar__description___35BAT","button":"calendar__button___3JLye","clear":"calendar__clear___x9c6N","save":"calendar__save___kVVDr","m-signature-pad":"calendar__m-signature-pad___CIuzF","github":"calendar__github___2SJ_O","legend":"calendar__legend___2LftN","CalendarActionBar":"calendar__CalendarActionBar___1CTz7","calendarActionBar":"calendar__calendarActionBar___Wf4uo","calendar-action-bar":"calendar__calendar-action-bar___2J16e","legendItem":"calendar__legendItem___1OAmB","legendItemFlex":"calendar__legendItemFlex___-14AI","legendSwatch":"calendar__legendSwatch___3XH5S","fd_install":"calendar__fd_install___GWJmX","fd_repair":"calendar__fd_repair___7Pp2w","assessment":"calendar__assessment___a1ujr","stack_cali_bamboo":"calendar__stack_cali_bamboo___tt3dd","stk_installation":"calendar__stk_installation___3MEm5","sos_installation":"calendar__sos_installation___Tb4mE","inspection":"calendar__inspection___1i_MM","crew_and_repair":"calendar__crew_and_repair___5n6Cp","delivery":"calendar__delivery___3Fgl3","deliver_stack_cali_bamboo":"calendar__deliver_stack_cali_bamboo___rEssZ","legendIcon":"calendar__legendIcon___tZ0E1","filtersList":"calendar__filtersList___KLW46","header":"calendar__header___2i5TZ","calendar":"calendar__calendar___1XSa4","spinner":"calendar__spinner___2FYx1","empty":"calendar__empty___M-thv","row":"calendar__row___1lE2H","dayCell":"calendar__dayCell___2kVHE","legendCell":"calendar__legendCell___3xcQI","headerRow":"calendar__headerRow___lk-75","inAppointments":"calendar__inAppointments___2rj7a","inSchedule":"calendar__inSchedule___2aRZN","scrolling":"calendar__scrolling___1b2uN","noSticky":"calendar__noSticky___3hZbt","headerCell":"calendar__headerCell___34tCg","today":"calendar__today___3tG6h","nextButton":"calendar__nextButton___2EPdc","prevButton":"calendar__prevButton___2x8kG","memberRow":"calendar__memberRow___APmJb","crewSpecificMatchRow":"calendar__crewSpecificMatchRow___33jGj","loading":"calendar__loading___2sr2P","assignee":"calendar__assignee___1bftv","assigneeInfo":"calendar__assigneeInfo___2S3ob","assigneeDetails":"calendar__assigneeDetails___JClp7","assigneeText":"calendar__assigneeText___1WMop","assigneeLink":"calendar__assigneeLink___3_zmb","assigneeAvatar":"calendar__assigneeAvatar___3pUUe","expand":"calendar__expand___8LUfG","contract":"calendar__contract___jbEzt","label":"calendar__label___2Lbyv","day":"calendar__day___EKFUH","appointmentsContainer":"calendar__appointmentsContainer___t325E","appointments":"calendar__appointments___2WfSf","dayTotal":"calendar__dayTotal___1Qyw-","blockage":"calendar__blockage___27S6n","pto":"calendar__pto___2o5NL","ssBlock":"calendar__ssBlock___2_mHg","suggestedTime":"calendar__suggestedTime___2OS6Q","hasNextDay":"calendar__hasNextDay___1atPP","hasPreviousDay":"calendar__hasPreviousDay___DfJfI","datePicker":"calendar__datePicker___-EFJD","date":"calendar__date___2VGtE","selectedRow":"calendar__selectedRow___1U3uE","selectedCol":"calendar__selectedCol___2wsT7","selectable":"calendar__selectable___3uee8","loadButton":"calendar__loadButton___2RsS1","notice":"calendar__notice___3wvxY","buttonContainer":"calendar__buttonContainer___13OjP","overrideBtnContainer":"calendar__overrideBtnContainer___34NV-"};

/***/ }),

/***/ "ivs0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"navigation__msignaturepad___3rnBf","m-signature-pad--body":"navigation__m-signature-pad--body___1Nczq","m-signature-pad--footer":"navigation__m-signature-pad--footer___33qWC","description":"navigation__description___2_yev","button":"navigation__button___1qU5J","clear":"navigation__clear___8Tq9_","save":"navigation__save___1rwEc","m-signature-pad":"navigation__m-signature-pad___1Dyy-","github":"navigation__github___3WnXf","horizontal":"navigation__horizontal___1QkT4"};

/***/ }),

/***/ "jNK8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"global__msignaturepad___1xyFA","m-signature-pad--body":"global__m-signature-pad--body___294gc","m-signature-pad--footer":"global__m-signature-pad--footer___1ovE1","description":"global__description___2AY3b","button":"global__button___9A8wp","clear":"global__clear___17tKU","save":"global__save___2gH0V","m-signature-pad":"global__m-signature-pad___33wqO","github":"global__github___1v0AO"};

/***/ }),

/***/ "jVzx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global, process) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rsvp__ = __webpack_require__("AGkK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_react__ = __webpack_require__("AFMW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__("O27J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux__ = __webpack_require__("jZgO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__app_store_configureStore__ = __webpack_require__("q68u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__app_services__ = __webpack_require__("NvlE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__app_shared_actionCreators__ = __webpack_require__("uJNR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_select_dist_react_select_css__ = __webpack_require__("RmHk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_select_dist_react_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_select_dist_react_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__app_shared_styles_custom_react_select_css__ = __webpack_require__("/biN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__app_shared_styles_custom_react_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__app_shared_styles_custom_react_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__app_shared_styles_signature_css__ = __webpack_require__("uhZm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__app_shared_styles_signature_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__app_shared_styles_signature_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };















global.Promise = __WEBPACK_IMPORTED_MODULE_0_rsvp__["a" /* default */].Promise;
__webpack_require__("j9g7");

var store = Object(__WEBPACK_IMPORTED_MODULE_7__app_store_configureStore__["a" /* default */])({ history: __WEBPACK_IMPORTED_MODULE_5_react_router__["g" /* browserHistory */] });
var history = Object(__WEBPACK_IMPORTED_MODULE_6_react_router_redux__["syncHistoryWithStore"])(__WEBPACK_IMPORTED_MODULE_5_react_router__["g" /* browserHistory */], store);
var rootElement = document.getElementById('react-entry');

if (process.env.SENTRY_DSN) {
  __WEBPACK_IMPORTED_MODULE_1__sentry_react__["e" /* init */]({
    dsn: process.env.SENTRY_DSN,
    environment: window.SPOT.env,
    release: window.SPOT.version,
    ignoreErrors: ['Unprocessable Entity', 'CUSTOM', 'Token not refreshed'],
    normalizeDepth: 10 });
  var sentryOnError = function sentryOnError(error) {
    if (error.payload) {
      __WEBPACK_IMPORTED_MODULE_1__sentry_react__["b" /* captureException */](error.payload, {
        tags: { action: error.type },
        extra: _extends({}, error.payload)
      });
    } else {
      __WEBPACK_IMPORTED_MODULE_1__sentry_react__["b" /* captureException */](error);
    }
  };
  window.onunhandledrejection = function (e) {
    return sentryOnError(e.reason);
  };
  __WEBPACK_IMPORTED_MODULE_0_rsvp__["a" /* default */].on('error', sentryOnError);
}

if (Object(__WEBPACK_IMPORTED_MODULE_8__app_services__["f" /* getCurrentToken */])()) {
  store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__app_shared_actionCreators__["_77" /* userGetSession */])());
}

var render = function render() {
  var App = __webpack_require__("R3fY").default; // eslint-disable-line global-require

  __WEBPACK_IMPORTED_MODULE_3_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4_react_redux__["Provider"],
    { store: store },
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(App, { history: history })
  ), rootElement);
};

if (false) {
  // Support hot reloading of components
  // and display an overlay for runtime errors
  var renderApp = render;
  var renderError = function renderError(error) {
    var RedBox = require('redbox-react'); // eslint-disable-line global-require

    console.error(error); // eslint-disable-line no-console
    ReactDOM.render(React.createElement(RedBox, { error: error }), rootElement);
  };

  render = function render() {
    try {
      renderApp();
    } catch (error) {
      renderError(error);
    }
  };

  module.hot.accept('../app/app.jsx', function () {
    setTimeout(render);
  });
}

render();
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2"), __webpack_require__("W2nU")))

/***/ }),

/***/ "jq96":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "sam1-b4ba6ba8107957838112b94516e18015.png";

/***/ }),

/***/ "kGAz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"scraper__msignaturepad___2ZbAJ","m-signature-pad--body":"scraper__m-signature-pad--body___26oXE","m-signature-pad--footer":"scraper__m-signature-pad--footer___GS9eO","description":"scraper__description___1q2ig","button":"scraper__button___gkqp4","clear":"scraper__clear___F6Kwr","save":"scraper__save___4Y2Ek","m-signature-pad":"scraper__m-signature-pad___3KPCg","github":"scraper__github___2SRBm","documents":"scraper__documents___3620E","fail":"scraper__fail___2c-Sy","success":"scraper__success___21Wau","document":"scraper__document___2wPOM","page":"scraper__page___3s70r"};

/***/ }),

/***/ "kYTj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"documentStyles__msignaturepad___2wK8i","m-signature-pad--body":"documentStyles__m-signature-pad--body___2pNdK","m-signature-pad--footer":"documentStyles__m-signature-pad--footer___24U_r","description":"documentStyles__description___2uOjZ","button":"documentStyles__button___9SN89","clear":"documentStyles__clear___2JKL4","save":"documentStyles__save___2_rRm","m-signature-pad":"documentStyles__m-signature-pad___1QHHI","github":"documentStyles__github___zdJ91","row":"documentStyles__row___3I5oJ","title":"documentStyles__title___2RUpm","titleClassName":"documentStyles__titleClassName___ddRFj","folder":"documentStyles__folder___213lt","folderTitleText":"documentStyles__folderTitleText___2PT_O","firstRowDoc":"documentStyles__firstRowDoc___1OpB4","subRowDoc":"documentStyles__subRowDoc___Wvb0n","nameRowDoc":"documentStyles__nameRowDoc___1ymHw","documentNameLink":"documentStyles__documentNameLink___1TR5p","thumbnailImage":"documentStyles__thumbnailImage___1rTWG","preview":"documentStyles__preview___3w90I","textRow":"documentStyles__textRow___2g-ce","centerDoc":"documentStyles__centerDoc___2dU9U","downloadIcon":"documentStyles__downloadIcon___21vT0","emailIcon":"documentStyles__emailIcon___3iCVH","lockIcon":"documentStyles__lockIcon___1AL-M","locked":"documentStyles__locked___2mS6Y","rowLocked":"documentStyles__rowLocked___1Mcnu","mobileRow":"documentStyles__mobileRow___3gljg","mobileInfo":"documentStyles__mobileInfo___24LCj","subInfo":"documentStyles__subInfo___37une"};

/***/ }),

/***/ "km9F":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "storm_configuration-31191a7e65abd231ae08589c72b6701b.png";

/***/ }),

/***/ "kpm4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"refigure__msignaturepad___14NU2","m-signature-pad--body":"refigure__m-signature-pad--body___gDUN0","m-signature-pad--footer":"refigure__m-signature-pad--footer___2hwl9","description":"refigure__description___2FqOt","button":"refigure__button___24yk6","clear":"refigure__clear___3dhhe","save":"refigure__save___1n7V0","m-signature-pad":"refigure__m-signature-pad___uu09y","github":"refigure__github___1eZXE","ResourceDetails":"refigure__ResourceDetails___-_4NO","resourceCardElement":"refigure__resourceCardElement___1w6-m","resourceCardElementValue":"refigure__resourceCardElementValue___SL8Ta","RefigureHeader":"refigure__RefigureHeader___2EuPI","RefigureCardWrapper":"refigure__RefigureCardWrapper___22alF","collapsableCardHeader":"refigure__collapsableCardHeader___1JH_k"};

/***/ }),

/***/ "lIXC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___3PAI9","m-signature-pad--body":"styles__m-signature-pad--body___2SMTZ","m-signature-pad--footer":"styles__m-signature-pad--footer___lSN4S","description":"styles__description___H9kFJ","button":"styles__button___o5xmv","clear":"styles__clear___WRDnX","save":"styles__save___1tYGv","m-signature-pad":"styles__m-signature-pad___2VqAp","github":"styles__github___3wKYG","due":"styles__due___5H12u","overdue":"styles__overdue____0oQh"};

/***/ }),

/***/ "lXSk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"rtButton__msignaturepad___2ihsK","m-signature-pad--body":"rtButton__m-signature-pad--body___3gfSB","m-signature-pad--footer":"rtButton__m-signature-pad--footer___2ECtc","description":"rtButton__description___1fmys","button":"rtButton__button___2iWGo","clear":"rtButton__clear___zVlYG","save":"rtButton__save___ZvGe8","m-signature-pad":"rtButton__m-signature-pad___1qcFb","github":"rtButton__github___2DgKU","icon":"rtButton__icon___3kdD4","toggle":"rtButton__toggle___2y0Ai"};

/***/ }),

/***/ "ljxu":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "silver-medal-ee2dfa881749a1f884c710f3096bc1ab.png";

/***/ }),

/***/ "m2+S":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___1fXch","m-signature-pad--body":"styles__m-signature-pad--body___M2LiB","m-signature-pad--footer":"styles__m-signature-pad--footer___3HZMv","description":"styles__description___beyc3","button":"styles__button___1ugvO","clear":"styles__clear___2R_o6","save":"styles__save___1vRIJ","m-signature-pad":"styles__m-signature-pad___3XVEg","github":"styles__github___2hip4","tableContainer":"styles__tableContainer___30hXn","form":"styles__form___HEyCR","formElement":"styles__formElement___Lwh3X","assigneeFormElement":"styles__assigneeFormElement___1IibZ","select":"styles__select___9QY_K","formSubmit":"styles__formSubmit___1NzeE","filters":"styles__filters___29qX3","table":"styles__table___27FMG","header":"styles__header___2S2b6","print":"styles__print___3fzUQ","link":"styles__link___377yv","empty":"styles__empty___1aYO9","loading":"styles__loading___3S6mT","checkbox":"styles__checkbox___3XQAf","printable":"styles__printable___1stCo","title":"styles__title___trcLK","noPrint":"styles__noPrint___3mui7","countHeader":"styles__countHeader___RoBIi","workroomDiv":"styles__workroomDiv___1yU3L","workroomHeader":"styles__workroomHeader___2ky1c","expandedResults":"styles__expandedResults___16ek_","resultCount":"styles__resultCount___3fkdF","noWorkroomResults":"styles__noWorkroomResults___2zIrr","noResult":"styles__noResult___3i6OR"};

/***/ }),

/***/ "mI0T":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"payRates__msignaturepad___Wfh9X","m-signature-pad--body":"payRates__m-signature-pad--body___1wFL6","m-signature-pad--footer":"payRates__m-signature-pad--footer___2xTSP","description":"payRates__description___3A2TB","button":"payRates__button___2wDg3","clear":"payRates__clear___2mi0m","save":"payRates__save___32duc","m-signature-pad":"payRates__m-signature-pad___VzB34","github":"payRates__github___26iI8","payRateContainer":"payRates__payRateContainer___12BVT"};

/***/ }),

/***/ "mIoA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"calendarActionBar__msignaturepad___WoGnU","m-signature-pad--body":"calendarActionBar__m-signature-pad--body___3FfjJ","m-signature-pad--footer":"calendarActionBar__m-signature-pad--footer___3Yzw2","description":"calendarActionBar__description___2VyZx","button":"calendarActionBar__button___3cUlR","clear":"calendarActionBar__clear___55UT2","save":"calendarActionBar__save___2vJBO","m-signature-pad":"calendarActionBar__m-signature-pad___2QPDl","github":"calendarActionBar__github___3UPzQ","inAppointments":"calendarActionBar__inAppointments___P2wNY","inSchedule":"calendarActionBar__inSchedule___75YdE","calendarActionBarContainer":"calendarActionBar__calendarActionBarContainer___13yfW","mobile":"calendarActionBar__mobile___296bw","title":"calendarActionBar__title___38tgs","subTitle":"calendarActionBar__subTitle___m8uC1","banner":"calendarActionBar__banner___1gSwN","middle":"calendarActionBar__middle___9hpT3","scrolling":"calendarActionBar__scrolling___33gWg"};

/***/ }),

/***/ "n5Rb":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "sp-logo-554aaa9cf8a5cb539b8a52786e95f551.svg";

/***/ }),

/***/ "nAl5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_toolbox__ = __webpack_require__("iXbh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_toolbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_toolbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_confirm__ = __webpack_require__("sfvs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_confirm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_confirm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_ColoredButton__ = __webpack_require__("EHD2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_MessageBox__ = __webpack_require__("nYV9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styles_form_scss__ = __webpack_require__("QIbJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styles_form_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_styles_form_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }










var cancelClass = __WEBPACK_IMPORTED_MODULE_7_classnames___default()([__WEBPACK_IMPORTED_MODULE_6_styles_form_scss___default.a.cancelButton, __WEBPACK_IMPORTED_MODULE_6_styles_form_scss___default.a.actionButton]);
var cardActionsClass = __WEBPACK_IMPORTED_MODULE_7_classnames___default()([__WEBPACK_IMPORTED_MODULE_6_styles_form_scss___default.a.actionsWrapper, __WEBPACK_IMPORTED_MODULE_6_styles_form_scss___default.a.rightDown]);

var ConfirmDialog = function ConfirmDialog(_ref) {
  var show = _ref.show,
      proceed = _ref.proceed,
      dismiss = _ref.dismiss,
      cancel = _ref.cancel,
      confirmation = _ref.confirmation,
      error = _ref.error,
      options = _objectWithoutProperties(_ref, ['show', 'proceed', 'dismiss', 'cancel', 'confirmation', 'error']);

  var title = options.title,
      theActions = options.theActions;

  var actions = theActions || ['Cancel', 'OK'];
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_toolbox__["Dialog"],
    {
      active: show,
      onEscKeyDown: dismiss,
      onOverlayClick: dismiss,
      title: title || 'Delete confirmation'
    },
    confirmation,
    error && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_MessageBox__["a" /* default */], { message: error, error: true }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_toolbox__["CardActions"],
      { className: cardActionsClass },
      actions.indexOf('Cancel') > -1 ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_ColoredButton__["a" /* default */], {
        className: cancelClass,
        responsive: true,
        color: options.cancelColor,
        label: options.cancelLabel,
        onClick: cancel
      }) : null,
      actions.indexOf('OK') > -1 ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_ColoredButton__["a" /* default */], {
        className: __WEBPACK_IMPORTED_MODULE_6_styles_form_scss___default.a.actionButton,
        responsive: true,
        color: options.okColor,
        label: options.okLabel,
        onClick: proceed
      }) : null
    )
  );
};

ConfirmDialog.defaultProps = { okLabel: 'OK', cancelLabel: 'Cancel', okColor: 'green', cancelColor: 'gray' };

ConfirmDialog.propTypes = {
  show: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  proceed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  dismiss: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  cancel: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  confirmation: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node,
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  okLabel: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  cancelLabel: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  okColor: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  cancelColor: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  error: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_confirm__["confirmable"])(ConfirmDialog));

/***/ }),

/***/ "nSBd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"exportModalInput__msignaturepad___2jlXJ","m-signature-pad--body":"exportModalInput__m-signature-pad--body___ND9LH","m-signature-pad--footer":"exportModalInput__m-signature-pad--footer___IZvl9","description":"exportModalInput__description___34_l7","button":"exportModalInput__button___2lNa1","clear":"exportModalInput__clear___2MpGG","save":"exportModalInput__save___o495x","m-signature-pad":"exportModalInput__m-signature-pad___1qIdp","github":"exportModalInput__github___3xNRE","export":"exportModalInput__export___3O-3Z","bar":"exportModalInput__bar___1DjbN","highlight":"exportModalInput__highlight___1AE7t","inputHighlighter":"exportModalInput__inputHighlighter___sbvpZ"};

/***/ }),

/***/ "nYV9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__("Brzw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles__);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var MessageBox = function MessageBox(props) {
  var _cx;

  var classNames = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(props.className, (_cx = {}, _defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_3__styles___default.a.messageBox, true), _defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_3__styles___default.a.error, props.error), _cx));
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    { className: classNames },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'strong',
      null,
      props.message
    ),
    props.children
  );
};

MessageBox.propTypes = {
  error: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node
};

/* harmony default export */ __webpack_exports__["a"] = (MessageBox);

/***/ }),

/***/ "o2wf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"suggestions__msignaturepad___2CWlV","m-signature-pad--body":"suggestions__m-signature-pad--body___gq8Mg","m-signature-pad--footer":"suggestions__m-signature-pad--footer___Yz0E6","description":"suggestions__description___-oKxq","button":"suggestions__button___1XA6G","clear":"suggestions__clear___fZmOs","save":"suggestions__save___3RgXU","m-signature-pad":"suggestions__m-signature-pad___PMOfl","github":"suggestions__github___2qt3X","resourceCardElement":"suggestions__resourceCardElement___2CuE_","resourceCardElementTitle":"suggestions__resourceCardElementTitle___1y_-Z","suggestionCard":"suggestions__suggestionCard___3xn1R","suggestionCard__container":"suggestions__suggestionCard__container___3ZpXL","suggestionCard__title":"suggestions__suggestionCard__title___kauDP","suggestionCard__content":"suggestions__suggestionCard__content___3C6W3","msgCard":"suggestions__msgCard___3ZTnA","checkboxContainer":"suggestions__checkboxContainer___2U_nF","emptyCheckbox":"suggestions__emptyCheckbox___1sZ1C","selectedCheckbox":"suggestions__selectedCheckbox___AAYaR","paginationContainer":"suggestions__paginationContainer___1H-jS","buttonContainer":"suggestions__buttonContainer___IHg4a","individualBtnContainer":"suggestions__individualBtnContainer___2tkwR","datePickerContainer":"suggestions__datePickerContainer___3gm_9","saveBtnContainer":"suggestions__saveBtnContainer___2su4N","overrideBtnContainer":"suggestions__overrideBtnContainer___1mRvt","stdBtnsContainer":"suggestions__stdBtnsContainer___3HZIb","schedulingReason":"suggestions__schedulingReason___2SLJ8","datePicker":"suggestions__datePicker___6Lf4a","suggestion":"suggestions__suggestion___RhYfN","mainSubmitButton":"suggestions__mainSubmitButton___1zH1y","fieldsWarning":"suggestions__fieldsWarning___2v5lf"};

/***/ }),

/***/ "od/G":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"input__msignaturepad____s-mo","m-signature-pad--body":"input__m-signature-pad--body___M4qRW","m-signature-pad--footer":"input__m-signature-pad--footer___3Mzwp","description":"input__description___2-gao","button":"input__button___3E4vG","clear":"input__clear___9hBQA","save":"input__save___2-l_u","m-signature-pad":"input__m-signature-pad___1sFk4","github":"input__github___3GtYr","inputElement":"input__inputElement___3dK7g","label":"input__label___3siLF","fixed":"input__fixed___y4QsG","filled":"input__filled___3uB_J","errored":"input__errored___3sMn7","error":"input__error___3rKTT","chargebackError":"input__chargebackError___YHzUf","bar":"input__bar___2KIzW","hint":"input__hint___1r8Nl","input":"input__input___1RbBv","sigPad":"input__sigPad___2TCFI"};

/***/ }),

/***/ "oge5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_normalizr__ = __webpack_require__("rI7m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_normalizr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_normalizr__);


var store = new __WEBPACK_IMPORTED_MODULE_0_normalizr__["Schema"]('stores');
var workroom = new __WEBPACK_IMPORTED_MODULE_0_normalizr__["Schema"]('workrooms');
var estimator = new __WEBPACK_IMPORTED_MODULE_0_normalizr__["Schema"]('estimators');

var surfaceType = new __WEBPACK_IMPORTED_MODULE_0_normalizr__["Schema"]('surface_types');
var helper = new __WEBPACK_IMPORTED_MODULE_0_normalizr__["Schema"]('helpers');
var crew = new __WEBPACK_IMPORTED_MODULE_0_normalizr__["Schema"]('crews');
var installer = new __WEBPACK_IMPORTED_MODULE_0_normalizr__["Schema"]('installers');
var pricePatch = new __WEBPACK_IMPORTED_MODULE_0_normalizr__["Schema"]('price_patches');
var payRate = new __WEBPACK_IMPORTED_MODULE_0_normalizr__["Schema"]('pay_rates');
var documentEntity = new __WEBPACK_IMPORTED_MODULE_0_normalizr__["Schema"]('documents');
var payRateUpload = new __WEBPACK_IMPORTED_MODULE_0_normalizr__["Schema"]('pay_rate_uploads');

var employee = new __WEBPACK_IMPORTED_MODULE_0_normalizr__["Schema"]('employees');

store.define({
  price_patch: pricePatch
});

installer.define({
  helpers: Object(__WEBPACK_IMPORTED_MODULE_0_normalizr__["arrayOf"])(helper),
  crews: Object(__WEBPACK_IMPORTED_MODULE_0_normalizr__["arrayOf"])(crew)
});

crew.define({
  workrooms: Object(__WEBPACK_IMPORTED_MODULE_0_normalizr__["arrayOf"])(workroom),
  surface_types: Object(__WEBPACK_IMPORTED_MODULE_0_normalizr__["arrayOf"])(surfaceType)
});

estimator.define({
  stores: Object(__WEBPACK_IMPORTED_MODULE_0_normalizr__["arrayOf"])(store),
  workrooms: Object(__WEBPACK_IMPORTED_MODULE_0_normalizr__["arrayOf"])(workroom)
});

payRateUpload.define({
  user: employee
});

var Schemas = {
  INSTALLER: installer,
  INSTALLER_ARRAY: Object(__WEBPACK_IMPORTED_MODULE_0_normalizr__["arrayOf"])(installer),
  HELPER: helper,
  HELPER_ARRAY: Object(__WEBPACK_IMPORTED_MODULE_0_normalizr__["arrayOf"])(helper),
  CREW: crew,
  CREW_ARRAY: Object(__WEBPACK_IMPORTED_MODULE_0_normalizr__["arrayOf"])(crew),
  SURFACE_TYPE: surfaceType,
  SURFACE_TYPE_ARRAY: Object(__WEBPACK_IMPORTED_MODULE_0_normalizr__["arrayOf"])(surfaceType),
  ESTIMATOR: estimator,
  ESTIMATOR_ARRAY: Object(__WEBPACK_IMPORTED_MODULE_0_normalizr__["arrayOf"])(estimator),
  STORE: store,
  STORE_ARRAY: Object(__WEBPACK_IMPORTED_MODULE_0_normalizr__["arrayOf"])(store),
  WORKROOM: workroom,
  WORKROOM_ARRAY: Object(__WEBPACK_IMPORTED_MODULE_0_normalizr__["arrayOf"])(workroom),
  PRICE_PATCH: pricePatch,
  PRICE_PATCH_ARRAY: Object(__WEBPACK_IMPORTED_MODULE_0_normalizr__["arrayOf"])(pricePatch),
  PAY_RATE: payRate,
  PAY_RATE_ARRAY: Object(__WEBPACK_IMPORTED_MODULE_0_normalizr__["arrayOf"])(payRate),
  DOCUMENT: documentEntity,
  DOCUMENTS: Object(__WEBPACK_IMPORTED_MODULE_0_normalizr__["arrayOf"])(documentEntity),
  PAY_RATE_UPLOAD: payRateUpload,
  PAY_RATE_UPLOAD_ARRAY: Object(__WEBPACK_IMPORTED_MODULE_0_normalizr__["arrayOf"])(payRateUpload)
};

/* harmony default export */ __webpack_exports__["a"] = (Schemas);

/***/ }),

/***/ "oh4S":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___1EQ2P","m-signature-pad--body":"styles__m-signature-pad--body___3I10r","m-signature-pad--footer":"styles__m-signature-pad--footer___2aDMe","description":"styles__description___3FA7H","button":"styles__button___1q6sz","clear":"styles__clear___ou0SS","save":"styles__save___zDEFC","m-signature-pad":"styles__m-signature-pad___1LIRE","github":"styles__github___2hXeb","note":"styles__note___3zkqm"};

/***/ }),

/***/ "p/vx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"noResults__msignaturepad___3Rle7","m-signature-pad--body":"noResults__m-signature-pad--body___1aM94","m-signature-pad--footer":"noResults__m-signature-pad--footer___3nNAn","description":"noResults__description___1KpTw","button":"noResults__button___vG3k-","clear":"noResults__clear___rWzcg","save":"noResults__save___1TWEu","m-signature-pad":"noResults__m-signature-pad___2O4d6","github":"noResults__github___38NjM","noResultsContent":"noResults__noResultsContent___Z3Xzf","noResultsTitle":"noResults__noResultsTitle___1YDp3","noResultsSubTitle":"noResults__noResultsSubTitle___gEjET"};

/***/ }),

/***/ "pe20":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___1WslW","m-signature-pad--body":"styles__m-signature-pad--body___KVWsn","m-signature-pad--footer":"styles__m-signature-pad--footer___1jMfA","description":"styles__description___1Qd0E","button":"styles__button___3vioO","clear":"styles__clear___3jP7l","save":"styles__save___36qJ0","m-signature-pad":"styles__m-signature-pad___3WCFL","github":"styles__github___1oZ3p","text_area":"styles__text_area___3ulF6","content_area":"styles__content_area___2fhZ2","messageBox":"styles__messageBox___32e9H","visible":"styles__visible___2OUwB","explanation":"styles__explanation___3tu5U"};

/***/ }),

/***/ "q+dO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___2VoHp","m-signature-pad--body":"styles__m-signature-pad--body___3gJRK","m-signature-pad--footer":"styles__m-signature-pad--footer___LGPIT","description":"styles__description___3F7xr","button":"styles__button___18FJN","clear":"styles__clear___33PgX","save":"styles__save___NOdS_","m-signature-pad":"styles__m-signature-pad___2GkzJ","github":"styles__github___3Qs00","loadingLabel":"styles__loadingLabel___2nzNE"};

/***/ }),

/***/ "q68u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/redux/es/index.js + 6 modules
var es = __webpack_require__("2KeS");

// EXTERNAL MODULE: ./node_modules/react-router-redux/lib/index.js
var lib = __webpack_require__("jZgO");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/redux-thunk/lib/index.js
var redux_thunk_lib = __webpack_require__("4ufr");
var redux_thunk_lib_default = /*#__PURE__*/__webpack_require__.n(redux_thunk_lib);

// EXTERNAL MODULE: ./node_modules/@sentry/react/esm/index.js + 75 modules
var esm = __webpack_require__("AFMW");

// EXTERNAL MODULE: ./client/app/shared/actionCreators/index.js + 27 modules
var actionCreators = __webpack_require__("uJNR");

// EXTERNAL MODULE: ./node_modules/jwt-autorefresh/lib/index.js
var jwt_autorefresh_lib = __webpack_require__("vyeh");
var jwt_autorefresh_lib_default = /*#__PURE__*/__webpack_require__.n(jwt_autorefresh_lib);

// CONCATENATED MODULE: ./client/app/store/middlewares.js




var middlewares_errorTracking = function errorTracking() {
  return function (next) {
    return function (action) {
      if (action.type === 'USER_GET_SESSION_SUCCESS' || action.type === 'LOGIN_USER_SUCCESS') {
        esm["f" /* setUser */]({
          id: action.payload.id,
          name: action.payload.name,
          email: action.payload.email,
          token: action.payload.auth_token
        });
        esm["a" /* addBreadcrumb */]({
          message: 'Token Updated',
          category: 'auth',
          level: 'info',
          data: {
            token: action.payload.auth_token
          }
        });
      }
      esm["a" /* addBreadcrumb */]({
        message: action.type,
        category: 'redux',
        level: 'info'
      });
      return next(action);
    };
  };
};

var middlewares_checkSessionExpired = function checkSessionExpired(store) {
  return function (next) {
    return function (action) {
      if (!action.error) return next(action);
      var error = action.payload;
      if (error && error.response && error.response.status === 419) {
        store.dispatch(Object(actionCreators["L" /* logoutUser */])('Your session has expired. You have been logged out due to inactivity.'));
      }
      return next(action);
    };
  };
};

var leadSeconds = function leadSeconds() {
  var SECONDS_IN_MINUTE = 60;
  var FIVE_MINUTES = SECONDS_IN_MINUTE * 5;
  // offset refresh requests so multiple tabs aren't refreshing at same time
  var variance = Math.floor(Math.random() * SECONDS_IN_MINUTE);

  return FIVE_MINUTES + variance;
};

var cancel = function cancel() {}; // Cancel token refresh function is just an empty function the first time
var start = null;

var middlewares_refreshJWT = function refreshJWT(store) {
  return function (next) {
    return function (action) {
      var type = action.type,
          payload = action.payload;

      if (type === 'LOGOUT_USER') {
        cancel(); // End refresh token timer
      }

      if (type !== 'INIT_TOKEN_REFRESH') {
        return next(action);
      }
      if (start == null) {
        var refresh = function refresh() {
          return store.dispatch(Object(actionCreators["Q" /* refreshToken */])());
        };
        start = jwt_autorefresh_lib_default()({ refresh: refresh, leadSeconds: leadSeconds });
      }
      cancel();
      cancel = start(payload.token);

      return null;
    };
  };
};

// Ensure all errored actions result in a rejected promise
var rejectErrors = function rejectErrors() {
  return function (next) {
    return function (action) {
      if (action.error) {
        if (action.payload && action.payload instanceof TypeError) {
          throw action.payload;
        }
        return Promise.reject(next(action));
      }
      return next(action);
    };
  };
};
// EXTERNAL MODULE: ./node_modules/remote-redux-devtools/lib/index.js
var remote_redux_devtools_lib = __webpack_require__("lMEB");
var remote_redux_devtools_lib_default = /*#__PURE__*/__webpack_require__.n(remote_redux_devtools_lib);

// EXTERNAL MODULE: ./client/app/reducers/index.js + 45 modules
var reducers = __webpack_require__("RbI9");

// CONCATENATED MODULE: ./client/app/store/configureStore.js
/* harmony export (immutable) */ __webpack_exports__["a"] = configureStore;







/** - Install composeWithDevTools -
 * This tool is used to debug redux using the remote devtools. Prior to
 * using this tool, developing for mobile on local dev would not be
 * possible as the screen would just be blank. This happens because when
 * webpack runs in development mode it expects to see the redux devtools
 * installed.
 * With this tool installed, we can check whether the environment is
 * running in development or not. If in development, check whether the
 * redux devtools are mounted on the window object. If not, use the
 * composeWithDevTools to allow remote debuggin.
 */



var sentryReduxEnhancer = esm["c" /* createReduxEnhancer */]({});

function configureStore(_ref) {
  var history = _ref.history;

  var router = Object(lib["routerMiddleware"])(history);
  var middlewares = Object(es["applyMiddleware"])(router, redux_thunk_lib_default.a, middlewares_checkSessionExpired, middlewares_errorTracking, middlewares_refreshJWT, rejectErrors);

  var finalCreateStore = null;
  if (false) {
    /* eslint-enable */
    finalCreateStore = compose(middlewares,
    /* eslint-disable */
    window.__REDUX_DEVTOOLS_EXTENSION__({ trace: true, traceLimit: 25 }))(createStore);
  } else if (false) {
    finalCreateStore = composeWithDevTools(middlewares)(createStore);
  } else {
    finalCreateStore = Object(es["compose"])(middlewares, sentryReduxEnhancer)(es["createStore"]);
  }

  var store = finalCreateStore(reducers["a" /* default */]);

  if (false) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../reducers', function () {
      var nextReducer = require('../reducers').default; // eslint-disable-line global-require

      store.replaceReducer(nextReducer);
    });
  }

  return store;
}

/***/ }),

/***/ "qHOt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"TemplateStyling__msignaturepad___3FnPJ","m-signature-pad--body":"TemplateStyling__m-signature-pad--body___15b2h","m-signature-pad--footer":"TemplateStyling__m-signature-pad--footer___2jEKV","description":"TemplateStyling__description___3vkm7","button":"TemplateStyling__button___1uqIJ","clear":"TemplateStyling__clear___1zNaf","save":"TemplateStyling__save___1NXgs","m-signature-pad":"TemplateStyling__m-signature-pad___13OjQ","github":"TemplateStyling__github___g1HQn","removeButton":"TemplateStyling__removeButton___3V48-","tempObscTransCheckbox":"TemplateStyling__tempObscTransCheckbox___2X0dz","container":"TemplateStyling__container___2u11I","theme__check___1CXAo":"TemplateStyling__theme__check___1CXAo___2w-EE","checkboxContainer":"TemplateStyling__checkboxContainer___2uDCF","paddingTop":"TemplateStyling__paddingTop___2vK8G"};

/***/ }),

/***/ "qN56":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ifi1-4ed7caf6fe37034738f95708afbb0c3b.png";

/***/ }),

/***/ "qia1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___1YkCN","m-signature-pad--body":"styles__m-signature-pad--body___2GxaU","m-signature-pad--footer":"styles__m-signature-pad--footer___jDmuM","description":"styles__description___3twAR","button":"styles__button___2zdYj","clear":"styles__clear___298Vi","save":"styles__save___18se6","m-signature-pad":"styles__m-signature-pad___GS-8U","github":"styles__github___Pw2YX","historyTable":"styles__historyTable___2nyYZ","tableContainer":"styles__tableContainer___hAS3k","dialog":"styles__dialog___1ZK7n","tableHeader":"styles__tableHeader___3ELAN","tableCell":"styles__tableCell___3DefL","priceColumn":"styles__priceColumn___1A9gD","rateName":"styles__rateName___1xwDK","closeIcon":"styles__closeIcon___2mjiz"};

/***/ }),

/***/ "rVfS":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "lhi1-0c4d4f68797c347a1f4332fe21abae9c.png";

/***/ }),

/***/ "s3iu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"phaseHistoryCard__msignaturepad___3NGVN","m-signature-pad--body":"phaseHistoryCard__m-signature-pad--body___2H9We","m-signature-pad--footer":"phaseHistoryCard__m-signature-pad--footer___1zzyD","description":"phaseHistoryCard__description___eZwzi","button":"phaseHistoryCard__button___2bNDi","clear":"phaseHistoryCard__clear___1O8tC","save":"phaseHistoryCard__save___3btJB","m-signature-pad":"phaseHistoryCard__m-signature-pad___35g_S","github":"phaseHistoryCard__github___AngA_","phaseHistoryCard":"phaseHistoryCard__phaseHistoryCard___E09vS","phaseHistoryAside":"phaseHistoryCard__phaseHistoryAside___1w_an","withNote":"phaseHistoryCard__withNote___1sv1x","withPhase":"phaseHistoryCard__withPhase___1R-9U","phaseHistoryNotes":"phaseHistoryCard__phaseHistoryNotes___2gHji","phaseHistoryPhaseInfo":"phaseHistoryCard__phaseHistoryPhaseInfo___1zUms","phaseHistoryCard__container":"phaseHistoryCard__phaseHistoryCard__container___2MgxZ","phaseHistoryCard__title":"phaseHistoryCard__phaseHistoryCard__title___1bksw","phaseHistoryCard__collapseToggle":"phaseHistoryCard__phaseHistoryCard__collapseToggle___32Too","phaseHistoryCard__content":"phaseHistoryCard__phaseHistoryCard__content___3_Z4Q","resourceCardElement":"phaseHistoryCard__resourceCardElement___2yI3C","resourceCardElementTitle":"phaseHistoryCard__resourceCardElementTitle___1YWKP","phaseEventCard":"phaseHistoryCard__phaseEventCard___XwHZa","cardButton":"phaseHistoryCard__cardButton___3XnJS","link":"phaseHistoryCard__link___1sAu7"};

/***/ }),

/***/ "sTdn":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "entry_handing-1359d9f4a42a4d2de2b25418f2dad2c4.png";

/***/ }),

/***/ "sWbZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"SIStyles__msignaturepad___1Kk8I","m-signature-pad--body":"SIStyles__m-signature-pad--body___3YRgw","m-signature-pad--footer":"SIStyles__m-signature-pad--footer___1Q8GM","description":"SIStyles__description___3EurH","button":"SIStyles__button___3Ejp6","clear":"SIStyles__clear___2R2xT","save":"SIStyles__save___2csH9","m-signature-pad":"SIStyles__m-signature-pad___yXfCR","github":"SIStyles__github___11GZh","tag":"SIStyles__tag___29oDo","storeNumber":"SIStyles__storeNumber___1upGt","add":"SIStyles__add___1RKVZ","remove":"SIStyles__remove___3OpZP"};

/***/ }),

/***/ "tHjr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export loginUserRequest */
/* unused harmony export loginUserSuccess */
/* harmony export (immutable) */ __webpack_exports__["a"] = loginUserFailure;
/* harmony export (immutable) */ __webpack_exports__["b"] = logoutUser;
/* unused harmony export initTokenRefresh */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return refreshToken; });
/* harmony export (immutable) */ __webpack_exports__["d"] = signInGoogleUser;
/* harmony export (immutable) */ __webpack_exports__["e"] = signInMicrosoftUser;
/* harmony export (immutable) */ __webpack_exports__["g"] = userGetSession;
/* harmony export (immutable) */ __webpack_exports__["h"] = userResendLink;
/* harmony export (immutable) */ __webpack_exports__["i"] = userUpdatePreferences;
/* harmony export (immutable) */ __webpack_exports__["f"] = updateUserBadge;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_react__ = __webpack_require__("AFMW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services__ = __webpack_require__("NvlE");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var loginUserRequest = function loginUserRequest() {
  return { type: 'LOGIN_USER_REQUEST' };
};

function loginUserSuccess(payload) {
  return { type: 'LOGIN_USER_SUCCESS', payload: payload };
}

function loginUserFailure(errorMessage) {
  return { type: 'LOGIN_USER_FAILURE', payload: { error: errorMessage } };
}

function logoutUser() {
  var reason = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  return { type: 'LOGOUT_USER', payload: { reason: reason } };
}

var initTokenRefresh = function initTokenRefresh(token) {
  return { type: 'INIT_TOKEN_REFRESH', payload: { token: token } };
};

/* TODO
 * Get lastRequestTime and token from redux state instead of local storage
 * Save token in redux state on successful refresh
 * Trigger token refresh when loading token from local storage
 *
 * refreshToken is called when jwt-autorefresh needs to obtain a new token
 * because the previous one is about to expire.
*/
var refreshToken = function refreshToken() {
  return function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__services__["h" /* request */])('/refresh_token', {
      method: 'POST'
    }).then(function (_ref) {
      var json = _ref.json;

      var user = __WEBPACK_IMPORTED_MODULE_0__sentry_react__["d" /* getCurrentHub */]().getScope().getUser();
      __WEBPACK_IMPORTED_MODULE_0__sentry_react__["f" /* setUser */](_extends({}, user, {
        token: json.auth_token
      }));
      __WEBPACK_IMPORTED_MODULE_0__sentry_react__["a" /* addBreadcrumb */]({
        message: 'Token Updated',
        category: 'auth',
        level: 'info',
        data: {
          token: json.auth_token
        }
      });
      Object(__WEBPACK_IMPORTED_MODULE_2__services__["j" /* saveAuthToken */])(json.auth_token);
      return json.auth_token;
    }).catch(function (error) {
      dispatch(logoutUser('You have been logged out - token not refreshed successfully.'));
      return Promise.reject(new Error('Token not refreshed' + (error.json ? ' - ' + error.json.errors : '')));
    });
  };
};

function signInGoogleUser(googleAuthObj) {
  return function (dispatch) {
    dispatch(loginUserRequest());

    Object(__WEBPACK_IMPORTED_MODULE_2__services__["i" /* requestNoAuthentication */])('/oauth2callback', {
      method: 'POST',
      body: googleAuthObj
    }).then(function (_ref2) {
      var json = _ref2.json;

      dispatch(loginUserSuccess(_extends({}, json.user, { msal: null })));
      dispatch(initTokenRefresh(json.user.auth_token));
    }).catch(function (error) {
      return dispatch(loginUserFailure(error.json.error));
    });
  };
}

function signInMicrosoftUser(microsoftAuthObj) {
  var msal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  return function (dispatch) {
    dispatch(loginUserRequest());

    Object(__WEBPACK_IMPORTED_MODULE_2__services__["i" /* requestNoAuthentication */])('/oauth2callback', {
      method: 'POST',
      body: microsoftAuthObj
    }).then(function (_ref3) {
      var json = _ref3.json;

      dispatch(loginUserSuccess(_extends({}, json.user, { msal: msal })));
      dispatch(initTokenRefresh(json.user.auth_token));
    }).catch(function (error) {
      return dispatch(loginUserFailure(error.json.error));
    });
  };
}

var _createActions = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createActions"])({
  USER_GET_SESSION_SUCCESS: function USER_GET_SESSION_SUCCESS(json) {
    return json.user;
  }
}, 'USER_GET_SESSION_REQUEST', 'USER_GET_SESSION_FAILURE'),
    userGetSessionRequest = _createActions.userGetSessionRequest,
    userGetSessionSuccess = _createActions.userGetSessionSuccess,
    userGetSessionFailure = _createActions.userGetSessionFailure;

function userGetSession() {
  return function (dispatch) {
    dispatch(userGetSessionRequest());
    return Object(__WEBPACK_IMPORTED_MODULE_2__services__["h" /* request */])('/session').then(function (_ref4) {
      var json = _ref4.json;

      dispatch(userGetSessionSuccess(json));
      dispatch(initTokenRefresh(json.user.auth_token));
    }).catch(function (error) {
      return dispatch(userGetSessionFailure(error));
    });
  };
}

var _createActions2 = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createActions"])('USER_RESEND_LINK_REQUEST', 'USER_RESEND_LINK_SUCCESS', 'USER_RESEND_LINK_FAILURE'),
    userResendLinkRequest = _createActions2.userResendLinkRequest,
    userResendLinkSuccess = _createActions2.userResendLinkSuccess,
    userResendLinkFailure = _createActions2.userResendLinkFailure;

function userResendLink(userId) {
  return function (dispatch) {
    dispatch(userResendLinkRequest());
    return Object(__WEBPACK_IMPORTED_MODULE_2__services__["h" /* request */])('users/' + userId + '/resend_link', {
      method: 'POST'
    }).then(function (_ref5) {
      var json = _ref5.json;
      return dispatch(userResendLinkSuccess(json));
    }).catch(function (error) {
      return dispatch(userResendLinkFailure(error));
    });
  };
}

var _createActions3 = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createActions"])({
  USER_UPDATE_PREFERENCES_SUCCESS: function USER_UPDATE_PREFERENCES_SUCCESS(json) {
    return json.user;
  }
}, 'USER_UPDATE_PREFERENCES_REQUEST', 'USER_UPDATE_PREFERENCES_FAILURE'),
    userUpdatePreferencesRequest = _createActions3.userUpdatePreferencesRequest,
    userUpdatePreferencesSuccess = _createActions3.userUpdatePreferencesSuccess,
    userUpdatePreferencesFailure = _createActions3.userUpdatePreferencesFailure;

function userUpdatePreferences(prefs) {
  return function (dispatch, getState) {
    var state = getState();
    dispatch(userUpdatePreferencesRequest(prefs));
    return Object(__WEBPACK_IMPORTED_MODULE_2__services__["k" /* update */])('user', {
      id: state.user.id,
      preferences: _extends({}, state.user.preferences, prefs)
    }).then(function (_ref6) {
      var json = _ref6.json;
      return dispatch(userUpdatePreferencesSuccess(json));
    }).catch(function (error) {
      return dispatch(userUpdatePreferencesFailure(error));
    });
  };
}

var _createActions4 = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createActions"])('USER_BADGE_UPDATE_REQUEST', 'USER_BADGE_UPDATE_SUCCESS', 'USER_BADGE_UPDATE_FAILURE'),
    userBadgeUpdateRequest = _createActions4.userBadgeUpdateRequest,
    userBadgeUpdateSuccess = _createActions4.userBadgeUpdateSuccess;

function updateUserBadge(userID, badge) {
  return function (dispatch) {
    dispatch(userBadgeUpdateRequest());

    return Object(__WEBPACK_IMPORTED_MODULE_2__services__["h" /* request */])('users/' + userID + '/badge', { method: 'PATCH', body: { badge: badge } }).then(function (_ref7) {
      var json = _ref7.json;
      return dispatch(userBadgeUpdateSuccess(json));
    });
  };
}

/***/ }),

/***/ "tOYP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"appointment__msignaturepad___U0Wfr","m-signature-pad--body":"appointment__m-signature-pad--body___1v9C3","m-signature-pad--footer":"appointment__m-signature-pad--footer___3sX0x","description":"appointment__description___377AE","button":"appointment__button___20Nvg","clear":"appointment__clear___ao_LW","save":"appointment__save___1J4Kt","m-signature-pad":"appointment__m-signature-pad___1YxiX","github":"appointment__github___9T9iz","appointment":"appointment__appointment___3IM0E","fd_install":"appointment__fd_install___2z_y5","fd_install_hold":"appointment__fd_install_hold___1G5Eg","fd_repair":"appointment__fd_repair___1kLei","fd_workorder_hold":"appointment__fd_workorder_hold___UlYvi","assessment":"appointment__assessment___35jmC","assessment_hold":"appointment__assessment_hold___3WEl6","assessment_due":"appointment__assessment_due___3mCZQ","stack_cali_bamboo":"appointment__stack_cali_bamboo___MA_oj","stk":"appointment__stk___1OAX8","stk_hold":"appointment__stk_hold___7MRMg","sos":"appointment__sos___3QDGR","sos_hold":"appointment__sos_hold___3mPvu","delivery":"appointment__delivery___2NSIx","delivery_hold":"appointment__delivery_hold___3bGJ_","deliver_stack_cali_bamboo":"appointment__deliver_stack_cali_bamboo___2Jmk8","repair_inspection":"appointment__repair_inspection___3I1BT","repair":"appointment__repair___buHZ5","crew_inspection":"appointment__crew_inspection___3ywA1","jobsite_inspection":"appointment__jobsite_inspection___CgYHV","workorder_hold":"appointment__workorder_hold___1ruGW","highlight":"appointment__highlight___2Gjbh","float":"appointment__float___1zKak","link":"appointment__link___2rEdq","linkAssessmentDue":"appointment__linkAssessmentDue___1jzTC","title":"appointment__title___jnjPp","time":"appointment__time___nB3Xw","sequence":"appointment__sequence___2_T3E","surfaceInfo":"appointment__surfaceInfo___2OxJ3","customer":"appointment__customer___14jKu","city":"appointment__city___3GHMx","store":"appointment__store___14iuo","mot":"appointment__mot___3ToGw","motOnTime":"appointment__motOnTime___efOmY","motWarning":"appointment__motWarning___1KhiB","motWarningAssessmentDue":"appointment__motWarningAssessmentDue___1e8yn","motOverdue":"appointment__motOverdue____q6qy","related":"appointment__related___3GWtG","actions":"appointment__actions___35co6","actionsButtons":"appointment__actionsButtons___YGGMF","actionsButtonsAssessmentDue":"appointment__actionsButtonsAssessmentDue___2Vo47","noteIcon":"appointment__noteIcon___Zse-e","closeIcon":"appointment__closeIcon___3UODJ","priorityFlag":"appointment__priorityFlag___-euIr","duration":"appointment__duration___1XYqe","ssWarning":"appointment__ssWarning___1WMh_","editButton":"appointment__editButton___v7foQ","editMulti":"appointment__editMulti___2JXco","editButtonAssessmentDue":"appointment__editButtonAssessmentDue___1Re3w","tooltip":"appointment__tooltip___1eyha","tooltip_high_contrast":"appointment__tooltip_high_contrast___1q5AP","place-top":"appointment__place-top___2JbNP","place-right":"appointment__place-right___TKls1","place-left":"appointment__place-left___2d14R","place-bottom":"appointment__place-bottom___InkZo","ribbon":"appointment__ribbon___3Z10k"};

/***/ }),

/***/ "tVfH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___3wG-_","m-signature-pad--body":"styles__m-signature-pad--body___21eo6","m-signature-pad--footer":"styles__m-signature-pad--footer___1iN6N","description":"styles__description___i9bt3","button":"styles__button___28IbL","clear":"styles__clear___3itnF","save":"styles__save___c6iB1","m-signature-pad":"styles__m-signature-pad___2M5Ev","github":"styles__github___1MgrB","noteBtnAndFiltersContainer":"styles__noteBtnAndFiltersContainer___1EJnK","createNoteBtn":"styles__createNoteBtn___3Vfmx","emptyList":"styles__emptyList___2EDMQ"};

/***/ }),

/***/ "tdwW":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "interior_configuration-d65802e23735a7dba80ef364f7ef7841.png";

/***/ }),

/***/ "u8j8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"phaseTask__msignaturepad___195Bh","m-signature-pad--body":"phaseTask__m-signature-pad--body___3rMjk","m-signature-pad--footer":"phaseTask__m-signature-pad--footer___3TY5I","description":"phaseTask__description___1goRQ","button":"phaseTask__button___tYGEK","clear":"phaseTask__clear___fulKZ","save":"phaseTask__save___3MQNv","m-signature-pad":"phaseTask__m-signature-pad___36KMe","github":"phaseTask__github___1r0us","taskContainer":"phaseTask__taskContainer___gPPHP","taskButton":"phaseTask__taskButton___2w8bD","taskButtonBlocked":"phaseTask__taskButtonBlocked___2h5VM"};

/***/ }),

/***/ "uJNR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/react-router-redux/lib/index.js
var lib = __webpack_require__("jZgO");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./client/app/shared/actionCreators/user.js
var user = __webpack_require__("tHjr");

// EXTERNAL MODULE: ./client/app/shared/actionCreators/employees.js
var employees = __webpack_require__("1HIx");

// EXTERNAL MODULE: ./node_modules/redux-actions/lib/index.js
var redux_actions_lib = __webpack_require__("QFmZ");
var redux_actions_lib_default = /*#__PURE__*/__webpack_require__.n(redux_actions_lib);

// EXTERNAL MODULE: ./client/app/services/index.js + 3 modules
var services = __webpack_require__("NvlE");

// EXTERNAL MODULE: ./client/app/reducers/index.js + 45 modules
var reducers = __webpack_require__("RbI9");

// EXTERNAL MODULE: ./client/app/shared/schemas/index.js
var schemas = __webpack_require__("oge5");

// EXTERNAL MODULE: ./node_modules/normalizr/lib/index.js
var normalizr_lib = __webpack_require__("rI7m");
var normalizr_lib_default = /*#__PURE__*/__webpack_require__.n(normalizr_lib);

// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var qs_lib = __webpack_require__("mw3O");
var qs_lib_default = /*#__PURE__*/__webpack_require__.n(qs_lib);

// CONCATENATED MODULE: ./client/app/shared/actionCreators/workrooms.js







var _createActions = Object(redux_actions_lib["createActions"])('WORKROOM_LIST_SUCCESS', 'WORKROOM_LIST_REQUEST', 'WORKROOM_LIST_FAILURE'),
    workroomListRequest = _createActions.workroomListRequest,
    workroomListSuccess = _createActions.workroomListSuccess,
    workroomListFailure = _createActions.workroomListFailure;

function requestWorkroomList() {
  return function (dispatch, getState) {
    var state = getState();
    var filterParams = qs_lib_default.a.stringify(Object(reducers["_36" /* getWorkroomFilters */])(state));
    dispatch(workroomListRequest());
    return Object(services["h" /* request */])('workrooms?' + filterParams).then(function (_ref) {
      var json = _ref.json;

      dispatch(workroomListSuccess(json));
    }, function (error) {
      dispatch(workroomListFailure(error));
    });
  };
}

var _createActions2 = Object(redux_actions_lib["createActions"])({
  WORKROOM_RESOURCE_REQUEST: function WORKROOM_RESOURCE_REQUEST(id) {
    return { id: id };
  },
  WORKROOM_RESOURCE_SUCCESS: function WORKROOM_RESOURCE_SUCCESS(json) {
    return Object(normalizr_lib["normalize"])(json, schemas["a" /* default */].WORKROOM);
  }
}, 'WORKROOM_RESOURCE_FAILURE'),
    workroomResourceRequest = _createActions2.workroomResourceRequest,
    workroomResourceSuccess = _createActions2.workroomResourceSuccess,
    workroomResourceFailure = _createActions2.workroomResourceFailure;

function requestWorkroom(id) {
  return function (dispatch) {
    dispatch(workroomResourceRequest(id));
    Object(services["h" /* request */])('workrooms/' + id).then(function (_ref2) {
      var json = _ref2.json;
      return dispatch(workroomResourceSuccess(json));
    }).catch(function (error) {
      return dispatch(workroomResourceFailure(error));
    });
  };
}

var _createActions3 = Object(redux_actions_lib["createActions"])({
  WORKROOM_RESOURCE_CREATE_SUCCESS: function WORKROOM_RESOURCE_CREATE_SUCCESS(json) {
    return Object(normalizr_lib["normalize"])(json, schemas["a" /* default */].WORKROOM);
  }
}, 'WORKROOM_RESOURCE_CREATE_REQUEST', 'WORKROOM_RESOURCE_CREATE_FAILURE'),
    workroomResourceCreateRequest = _createActions3.workroomResourceCreateRequest,
    workroomResourceCreateSuccess = _createActions3.workroomResourceCreateSuccess,
    workroomResourceCreateFailure = _createActions3.workroomResourceCreateFailure;

function createWorkroom(workroom) {
  return function (dispatch) {
    dispatch(workroomResourceCreateRequest());
    return Object(services["d" /* create */])('workroom', workroom).then(function (_ref3) {
      var json = _ref3.json;
      return dispatch(workroomResourceCreateSuccess(json));
    }).catch(function (error) {
      return dispatch(workroomResourceCreateFailure(error));
    });
  };
}

var _createActions4 = Object(redux_actions_lib["createActions"])({
  WORKROOM_RESOURCE_UPDATE_SUCCESS: function WORKROOM_RESOURCE_UPDATE_SUCCESS(json) {
    return Object(normalizr_lib["normalize"])(json, schemas["a" /* default */].WORKROOM);
  }
}, 'WORKROOM_RESOURCE_UPDATE_REQUEST', 'WORKROOM_RESOURCE_UPDATE_FAILURE'),
    workroomResourceUpdateRequest = _createActions4.workroomResourceUpdateRequest,
    workroomResourceUpdateSuccess = _createActions4.workroomResourceUpdateSuccess,
    workroomResourceUpdateFailure = _createActions4.workroomResourceUpdateFailure;

function updateWorkroom(workroom) {
  return function (dispatch) {
    dispatch(workroomResourceUpdateRequest());
    return Object(services["k" /* update */])('workroom', workroom).then(function (_ref4) {
      var json = _ref4.json;
      return dispatch(workroomResourceUpdateSuccess(json));
    }, function (error) {
      return dispatch(workroomResourceUpdateFailure(error));
    });
  };
}

function setWorkroomFilters(filter) {
  return function (dispatch) {
    dispatch({ type: 'WORKROOM_SET_FILTER', payload: filter });
    dispatch(requestWorkroomList());
  };
}

function resetWorkroomFilters() {
  return function (dispatch) {
    dispatch({ type: 'WORKROOM_RESET_FILTERS' });
    dispatch(requestWorkroomList());
  };
}
// CONCATENATED MODULE: ./client/app/shared/actionCreators/tasks.js
/* eslint-disable import/prefer-default-export */



var tasks__createActions = Object(redux_actions_lib["createActions"])({
  TASK_LIST_SUCCESS: function TASK_LIST_SUCCESS(json) {
    return json.tasks;
  }
}, 'TASK_LIST_REQUEST', 'TASK_LIST_FAILURE'),
    taskListRequest = tasks__createActions.taskListRequest,
    taskListSuccess = tasks__createActions.taskListSuccess,
    taskListFailure = tasks__createActions.taskListFailure;

function requestTaskList() {
  return function (dispatch) {
    dispatch(taskListRequest());
    return Object(services["h" /* request */])('tasks').then(function (_ref) {
      var json = _ref.json;

      dispatch(taskListSuccess(json));
    }, function (error) {
      dispatch(taskListFailure(error));
    });
  };
}
// EXTERNAL MODULE: ./client/app/utils/index.js
var utils = __webpack_require__("FbQg");

// CONCATENATED MODULE: ./client/app/shared/actionCreators/stores.js










var stores__createActions = Object(redux_actions_lib["createActions"])({
  STORE_LIST_SUCCESS: function STORE_LIST_SUCCESS(json) {
    return Object(normalizr_lib["normalize"])(json, { stores: schemas["a" /* default */].STORE_ARRAY });
  }
}, 'STORE_LIST_REQUEST', 'STORE_LIST_FAILURE'),
    storeListRequest = stores__createActions.storeListRequest,
    storeListSuccess = stores__createActions.storeListSuccess,
    storeListFailure = stores__createActions.storeListFailure;

function requestAllStores() {
  return function (dispatch, getState) {
    var filters = Object(reducers["_16" /* getStoreFilters */])(getState());
    var filterParams = qs_lib_default.a.stringify(filters);
    dispatch(storeListRequest());
    return Object(services["h" /* request */])('stores?' + filterParams).then(function (_ref) {
      var json = _ref.json;
      return dispatch(storeListSuccess(json));
    }).catch(function (error) {
      return dispatch(storeListFailure(error));
    });
  };
}

var stores__createActions2 = Object(redux_actions_lib["createActions"])({
  STORE_RESOURCE_REQUEST: function STORE_RESOURCE_REQUEST(id) {
    return { id: id };
  },
  STORE_RESOURCE_SUCCESS: function STORE_RESOURCE_SUCCESS(json) {
    return Object(normalizr_lib["normalize"])(json, schemas["a" /* default */].STORE);
  }
}, 'STORE_RESOURCE_FAILURE'),
    storeResourceRequest = stores__createActions2.storeResourceRequest,
    storeResourceSuccess = stores__createActions2.storeResourceSuccess,
    storeResourceFailure = stores__createActions2.storeResourceFailure;

function requestStore(id) {
  return function (dispatch) {
    dispatch(storeResourceRequest(id));
    Object(services["h" /* request */])('stores/' + id).then(function (_ref2) {
      var json = _ref2.json;
      return dispatch(storeResourceSuccess(json));
    }).catch(function (error) {
      return dispatch(storeResourceFailure(error));
    });
  };
}

function validateNewStore(store) {
  return Object(utils["x" /* requireAllFields */])(store, []);
}

function validationFailure(errors) {
  return { type: 'STORE_RESOURCE_SYNC_VALIDATION_FAILURE', payload: { errors: errors }, error: true };
}

var stores__createActions3 = Object(redux_actions_lib["createActions"])({
  STORE_RESOURCE_CREATE_SUCCESS: function STORE_RESOURCE_CREATE_SUCCESS(json) {
    return Object(normalizr_lib["normalize"])(json, schemas["a" /* default */].STORE);
  }
}, 'STORE_RESOURCE_CREATE_REQUEST', 'STORE_RESOURCE_CREATE_FAILURE'),
    storeResourceCreateRequest = stores__createActions3.storeResourceCreateRequest,
    storeResourceCreateSuccess = stores__createActions3.storeResourceCreateSuccess,
    storeResourceCreateFailure = stores__createActions3.storeResourceCreateFailure;

function createStore(store, onSuccess) {
  return function (dispatch) {
    var syncErrors = validateNewStore(store);
    if (!Object(utils["p" /* isEmpty */])(syncErrors)) {
      dispatch(validationFailure(syncErrors));
      return;
    }

    dispatch(storeResourceCreateRequest());
    Object(services["h" /* request */])('stores/', {
      method: 'POST',
      body: { store: store }
    }).then(function (_ref3) {
      var json = _ref3.json;

      onSuccess(store.name, store.number);
      dispatch(storeResourceCreateSuccess(json));
      dispatch(Object(lib["push"])('/stores'));
    }, function (error) {
      dispatch(storeResourceCreateFailure(error));
    });
  };
}

var stores__createActions4 = Object(redux_actions_lib["createActions"])({
  STORE_RESOURCE_UPDATE_SUCCESS: function STORE_RESOURCE_UPDATE_SUCCESS(json) {
    return Object(normalizr_lib["normalize"])(json, schemas["a" /* default */].STORE);
  }
}, 'STORE_RESOURCE_UPDATE_REQUEST', 'STORE_RESOURCE_UPDATE_FAILURE'),
    storeResourceUpdateRequest = stores__createActions4.storeResourceUpdateRequest,
    storeResourceUpdateSuccess = stores__createActions4.storeResourceUpdateSuccess,
    storeResourceUpdateFailure = stores__createActions4.storeResourceUpdateFailure;

function updateStore(store, onSuccess) {
  return function (dispatch) {
    dispatch(storeResourceUpdateRequest());
    Object(services["h" /* request */])('stores/' + store.id, {
      method: 'PUT',
      body: { store: store }
    }).then(function (_ref4) {
      var json = _ref4.json;

      onSuccess();
      dispatch(storeResourceUpdateSuccess(json));
      dispatch(navigateBack());
    }, function (error) {
      dispatch(storeResourceUpdateFailure(error));
    });
  };
}

function resetStoreFilters() {
  return function (dispatch) {
    return Promise.all([dispatch({ type: 'STORE_RESET_FILTERS' }), dispatch(requestAllStores())]);
  };
}

function setStoreFilters(filters) {
  return function (dispatch) {
    return Promise.all([dispatch({ type: 'STORE_SET_FILTER', payload: filters }), dispatch(requestAllStores())]);
  };
}

function fetchInstallersForPrioritization(storeId) {
  return function (dispatch, getState) {
    var store = getState().stores.byId[storeId];
    if (!store || store.vendor !== 'IFI') {
      return Promise.resolve();
    }
    dispatch({ type: 'STORE_INSTALLER_PRIORITIZATION_REQUEST' });
    return Object(services["h" /* request */])('stores/' + storeId + '/installer_priority').then(function (_ref5) {
      var json = _ref5.json;

      dispatch({
        type: 'STORE_INSTALLER_PRIORITIZATION_SUCCESS',
        payload: {
          installers: json.installers || [],
          surfaceTypes: json.surface_types || []
        }
      });
    }).catch(function () {
      dispatch({ type: 'STORE_INSTALLER_PRIORITIZATION_FAILURE' });
    });
  };
}

function resetInstallerPrioritization() {
  return { type: 'STORE_INSTALLER_PRIORITIZATION_RESET' };
}
// EXTERNAL MODULE: ./client/app/shared/actionCreators/dropdown_lists.js
var dropdown_lists = __webpack_require__("WWCX");

// EXTERNAL MODULE: ./client/app/shared/actionCreators/estimators.js
var estimators = __webpack_require__("L1+g");

// CONCATENATED MODULE: ./client/app/shared/actionCreators/installers.js








var installers__createActions = Object(redux_actions_lib["createActions"])('INSTALLER_LIST_REQUEST', 'INSTALLER_LIST_SUCCESS', 'INSTALLER_LIST_FAILURE'),
    installerListRequest = installers__createActions.installerListRequest,
    installerListSuccess = installers__createActions.installerListSuccess,
    installerListFailure = installers__createActions.installerListFailure;

function requestInstallerList() {
  return function (dispatch, getState) {
    var state = getState();
    var page = Object(reducers["H" /* getInstallerPage */])(state);
    var filterParams = qs_lib_default.a.stringify(Object(reducers["D" /* getInstallerFilters */])(state));

    dispatch(installerListRequest());
    Object(services["h" /* request */])('installers?page=' + page + '&' + filterParams).then(function (_ref) {
      var json = _ref.json;
      return dispatch(installerListSuccess(json, filterParams));
    }, function (error) {
      return dispatch(installerListFailure(error));
    });
  };
}

var installers__createActions2 = Object(redux_actions_lib["createActions"])({
  INSTALLER_RESOURCE_REQUEST: function INSTALLER_RESOURCE_REQUEST(id) {
    return { id: id };
  },
  INSTALLER_RESOURCE_SUCCESS: function INSTALLER_RESOURCE_SUCCESS(json) {
    return Object(normalizr_lib["normalize"])(json, schemas["a" /* default */].INSTALLER);
  }
}, 'INSTALLER_RESOURCE_FAILURE'),
    installerResourceRequest = installers__createActions2.installerResourceRequest,
    installerResourceSuccess = installers__createActions2.installerResourceSuccess,
    installerResourceFailure = installers__createActions2.installerResourceFailure;

function requestInstaller(id) {
  return function (dispatch) {
    dispatch(installerResourceRequest(id));
    Object(services["h" /* request */])('installers/' + id).then(function (_ref2) {
      var json = _ref2.json;
      return dispatch(installerResourceSuccess(json));
    }).catch(function (error) {
      return dispatch(installerResourceFailure(error));
    });
  };
}

var installers__createActions3 = Object(redux_actions_lib["createActions"])({
  INSTALLER_RESOURCE_CREATE_SUCCESS: function INSTALLER_RESOURCE_CREATE_SUCCESS(json) {
    return Object(normalizr_lib["normalize"])(json, schemas["a" /* default */].INSTALLER);
  }
}, 'INSTALLER_RESOURCE_CREATE_REQUEST', 'INSTALLER_RESOURCE_CREATE_FAILURE'),
    installerResourceCreateRequest = installers__createActions3.installerResourceCreateRequest,
    installerResourceCreateSuccess = installers__createActions3.installerResourceCreateSuccess,
    installerResourceCreateFailure = installers__createActions3.installerResourceCreateFailure;

function createInstaller(installer) {
  return function (dispatch) {
    dispatch(installerResourceCreateRequest());
    return Object(services["d" /* create */])('installer', installer).then(function (_ref3) {
      var json = _ref3.json;
      return Promise.all([dispatch(installerResourceCreateSuccess(json)), json]);
    }).catch(function (error) {
      dispatch(installerResourceCreateFailure(error));
      throw error;
    });
  };
}

var installers__createActions4 = Object(redux_actions_lib["createActions"])({
  INSTALLER_RESOURCE_UPDATE_SUCCESS: function INSTALLER_RESOURCE_UPDATE_SUCCESS(json) {
    return Object(normalizr_lib["normalize"])(json, schemas["a" /* default */].INSTALLER);
  }
}, 'INSTALLER_RESOURCE_UPDATE_REQUEST', 'INSTALLER_RESOURCE_UPDATE_FAILURE'),
    installerResourceUpdateRequest = installers__createActions4.installerResourceUpdateRequest,
    installerResourceUpdateSuccess = installers__createActions4.installerResourceUpdateSuccess,
    installerResourceUpdateFailure = installers__createActions4.installerResourceUpdateFailure;

function updateInstaller(installer) {
  return function (dispatch) {
    dispatch(installerResourceUpdateRequest());
    return Object(services["k" /* update */])('installer', installer).then(function (_ref4) {
      var json = _ref4.json;
      return Promise.all([dispatch(installerResourceUpdateSuccess(json)), dispatch(actionCreators_navigate('/installers/' + json.id))]);
    }).catch(function (error) {
      dispatch(installerResourceUpdateFailure(error));
      throw error;
    });
  };
}

var _createActions5 = Object(redux_actions_lib["createActions"])({
  ADD_EVENT_TO_INSTALLER_SUCCESS: function ADD_EVENT_TO_INSTALLER_SUCCESS(json, installerId) {
    return { event: json.event, installerId: installerId };
  }
}, 'ADD_EVENT_TO_INSTALLER_FAILURE', 'ADD_EVENT_TO_INSTALLER_REQUEST'),
    addEventToInstallerRequest = _createActions5.addEventToInstallerRequest,
    addEventToInstallerSuccess = _createActions5.addEventToInstallerSuccess,
    addEventToInstallerFailure = _createActions5.addEventToInstallerFailure;

var installers_addEventToInstaller = function addEventToInstaller(installerId, event) {
  return function (dispatch) {
    dispatch(addEventToInstallerRequest(event));
    return Object(services["h" /* request */])('installers/' + installerId + '/events', { method: 'POST', body: event }).then(function (_ref5) {
      var json = _ref5.json;
      return dispatch(addEventToInstallerSuccess(json, installerId));
    }).catch(function (errors) {
      return dispatch(addEventToInstallerFailure(errors));
    });
  };
};

function setInstallerFilters(filter) {
  return function (dispatch) {
    dispatch({ type: 'INSTALLER_SET_FILTER', payload: filter });
    dispatch({ type: 'INSTALLER_RESET_PAGINATION' });
    dispatch(requestInstallerList());
  };
}

function resetInstallerFilters() {
  return function (dispatch) {
    dispatch({ type: 'INSTALLER_RESET_FILTERS' });
    dispatch({ type: 'INSTALLER_RESET_PAGINATION' });
    dispatch(requestInstallerList());
  };
}
// CONCATENATED MODULE: ./client/app/shared/actionCreators/iqms.js





var iqms__createActions = Object(redux_actions_lib["createActions"])('IQM_LIST_SUCCESS', 'IQM_LIST_REQUEST', 'IQM_LIST_FAILURE'),
    iqmListRequest = iqms__createActions.iqmListRequest,
    iqmListSuccess = iqms__createActions.iqmListSuccess,
    iqmListFailure = iqms__createActions.iqmListFailure;

function requestIQMList() {
  return function (dispatch, getState) {
    var state = getState();
    var page = Object(reducers["M" /* getIqmsPage */])(state);
    var filterParams = qs_lib_default.a.stringify(Object(reducers["I" /* getIqmsFilters */])(state));

    dispatch(iqmListRequest());
    return Object(services["h" /* request */])('iqms?page=' + page + '&' + filterParams).then(function (_ref) {
      var json = _ref.json;
      return dispatch(iqmListSuccess(json, filterParams, page));
    }).catch(function (error) {
      return dispatch(iqmListFailure(error));
    });
  };
}

function setIQMFilters(filter) {
  return function (dispatch) {
    dispatch({ type: 'IQM_SET_FILTER', payload: filter });
    dispatch({ type: 'IQM_RESET_PAGINATION' });
    return dispatch(requestIQMList());
  };
}

function resetIQMFilters() {
  return function (dispatch) {
    return Promise.all([dispatch({ type: 'IQM_RESET_FILTERS' }), dispatch({ type: 'IQM_RESET_PAGINATION' }), dispatch(requestIQMList())]);
  };
}

var iqms__createActions2 = Object(redux_actions_lib["createActions"])({
  IQM_RESOURCE_REQUEST: function IQM_RESOURCE_REQUEST(id) {
    return { id: id };
  },
  IQM_RESOURCE_SUCCESS: function IQM_RESOURCE_SUCCESS(json) {
    return json.iqm;
  }
}, 'IQM_RESOURCE_FAILURE'),
    iqmResourceRequest = iqms__createActions2.iqmResourceRequest,
    iqmResourceSuccess = iqms__createActions2.iqmResourceSuccess,
    iqmResourceFailure = iqms__createActions2.iqmResourceFailure;

function requestIQM(id) {
  return function (dispatch) {
    dispatch(iqmResourceRequest(id));
    return Object(services["h" /* request */])('iqms/' + id).then(function (_ref2) {
      var json = _ref2.json;
      return dispatch(iqmResourceSuccess(json));
    }).catch(function (error) {
      return dispatch(iqmResourceFailure(error));
    });
  };
}

var iqms__createActions3 = Object(redux_actions_lib["createActions"])({
  IQM_RESOURCE_CREATE_SUCCESS: function IQM_RESOURCE_CREATE_SUCCESS(json) {
    return json.iqm;
  }
}, 'IQM_RESOURCE_CREATE_REQUEST', 'IQM_RESOURCE_CREATE_FAILURE'),
    iqmResourceCreateRequest = iqms__createActions3.iqmResourceCreateRequest,
    iqmResourceCreateSuccess = iqms__createActions3.iqmResourceCreateSuccess,
    iqmResourceCreateFailure = iqms__createActions3.iqmResourceCreateFailure;

function createIQM(iqm) {
  return function (dispatch) {
    dispatch(iqmResourceCreateRequest());
    return Object(services["h" /* request */])('iqms/', {
      method: 'POST',
      body: { iqm: iqm }
    }).then(function (_ref3) {
      var json = _ref3.json;
      return dispatch(iqmResourceCreateSuccess(json));
    }).catch(function (error) {
      return dispatch(iqmResourceCreateFailure(error));
    });
  };
}

var iqms__createActions4 = Object(redux_actions_lib["createActions"])({
  IQM_RESOURCE_UPDATE_SUCCESS: function IQM_RESOURCE_UPDATE_SUCCESS(json) {
    return json.iqm;
  }
}, 'IQM_RESOURCE_UPDATE_REQUEST', 'IQM_RESOURCE_UPDATE_FAILURE'),
    iqmResourceUpdateRequest = iqms__createActions4.iqmResourceUpdateRequest,
    iqmResourceUpdateSuccess = iqms__createActions4.iqmResourceUpdateSuccess,
    iqmResourceUpdateFailure = iqms__createActions4.iqmResourceUpdateFailure;

function updateIQM(iqm) {
  return function (dispatch) {
    dispatch(iqmResourceUpdateRequest());
    return Object(services["h" /* request */])('iqms/' + iqm.id, {
      method: 'PUT',
      body: { iqm: iqm }
    }).then(function (_ref4) {
      var json = _ref4.json;
      return dispatch(iqmResourceUpdateSuccess(json));
    }).catch(function (error) {
      return dispatch(iqmResourceUpdateFailure(error));
    });
  };
}
// CONCATENATED MODULE: ./client/app/shared/actionCreators/surface_types.js
/* eslint-disable import/prefer-default-export */



var surface_types__createActions = Object(redux_actions_lib["createActions"])({
  SURFACE_TYPE_LIST_SUCCESS: function SURFACE_TYPE_LIST_SUCCESS(json) {
    return json.surface_types;
  }
}, 'SURFACE_TYPE_LIST_REQUEST', 'SURFACE_TYPE_LIST_FAILURE'),
    surfaceTypeListRequest = surface_types__createActions.surfaceTypeListRequest,
    surfaceTypeListSuccess = surface_types__createActions.surfaceTypeListSuccess,
    surfaceTypeListFailure = surface_types__createActions.surfaceTypeListFailure;

function requestSurfaceTypesList() {
  return function (dispatch) {
    dispatch(surfaceTypeListRequest());
    return Object(services["h" /* request */])('surface_types').then(function (_ref) {
      var json = _ref.json;

      dispatch(surfaceTypeListSuccess(json));
    }, function (error) {
      dispatch(surfaceTypeListFailure(error));
    });
  };
}
// CONCATENATED MODULE: ./client/app/shared/actionCreators/phases.js





var phases__createActions = Object(redux_actions_lib["createActions"])({
  PHASE_LIST_SUCCESS: [function (json) {
    return json.phases;
  }, function (json) {
    return json.meta;
  }]
}, 'PHASE_LIST_REQUEST', 'PHASE_LIST_FAILURE'),
    phaseListSuccess = phases__createActions.phaseListSuccess,
    phaseListFailure = phases__createActions.phaseListFailure,
    phaseListRequest = phases__createActions.phaseListRequest;

var phases__createActions2 = Object(redux_actions_lib["createActions"])({
  EXPORT_PHASES_SUCCESS: [function (json) {
    return json.phases;
  }, function (json) {
    return json.meta;
  }]
}, 'EXPORT_PHASES_FAILURE'),
    exportPhasesSuccess = phases__createActions2.exportPhasesSuccess,
    exportPhasesFailure = phases__createActions2.exportPhasesFailure;

var phases_requestPhaseList = function requestPhaseList() {
  var ignoreLocationFilters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return function (dispatch, getState) {
    var state = getState();
    var page = Object(reducers["_6" /* getPhaseNextPage */])(state);
    var filterParams = ignoreLocationFilters ? Object(reducers["_3" /* getPhaseFiltersQueryOnly */])(state) : Object(reducers["_0" /* getPhaseFilters */])(state);
    if (page === null || page === undefined) {
      return Promise.resolve('');
    }
    dispatch(phaseListRequest());
    return Object(services["h" /* request */])('phases?page=' + page + '&' + filterParams).then(function (_ref) {
      var json = _ref.json;
      return dispatch(phaseListSuccess(json));
    }).catch(function (error) {
      return dispatch(phaseListFailure(error));
    });
  };
};

var phases_requestPhasesForExport = function requestPhasesForExport(page) {
  return function (dispatch, getState) {
    var state = getState();
    var filterParams = Object(reducers["_0" /* getPhaseFilters */])(state);
    return Object(services["h" /* request */])('phases/phase_export?page=' + page + '&limit=1000&' + filterParams).then(function (_ref2) {
      var json = _ref2.json;
      return dispatch(exportPhasesSuccess(json));
    }).catch(function (error) {
      return dispatch(exportPhasesFailure(error));
    });
  };
};

function resetPhasePagination(filter) {
  return function (dispatch) {
    return Promise.all([dispatch({ type: 'PHASE_SET_FILTER', payload: filter }), dispatch({ type: 'PHASE_RESET_PAGINATION' })]);
  };
}
var updatePhaseFiltersLocationRequest = Object(redux_actions_lib["createAction"])('UPDATE_PHASE_FILTERS_LOCATION_REQUEST');

var phases_updatePhaseFiltersLocation = function updatePhaseFiltersLocation(filters) {
  return function (dispatch) {
    return Promise.all([dispatch(Object(user["i" /* userUpdatePreferences */])({ saved_location_filters: filters })), dispatch(updatePhaseFiltersLocationRequest(filters)), dispatch({ type: 'PHASE_RESET_PAGINATION' }), dispatch(phases_requestPhaseList())]).then(function () {
      return dispatch(saved_filters_requestSavedFilters());
    }).then(function () {
      return dispatch(assigned_filters_requestAssignedFilters());
    });
  };
};
// EXTERNAL MODULE: ./client/app/shared/actionCreators/phase.js
var actionCreators_phase = __webpack_require__("IJEG");

// CONCATENATED MODULE: ./client/app/shared/actionCreators/document_uploads.js



var document_uploads__createActions = Object(redux_actions_lib["createActions"])({
  DOCUMENTS_REQUEST_SUCCESS: function DOCUMENTS_REQUEST_SUCCESS(json) {
    return json.document_uploads;
  }
}, 'DOCUMENTS_REQUEST', 'DOCUMENTS_REQUEST_FAILURE'),
    documentsRequest = document_uploads__createActions.documentsRequest,
    documentsRequestSuccess = document_uploads__createActions.documentsRequestSuccess,
    documentsRequestFailure = document_uploads__createActions.documentsRequestFailure;

function fetchPhaseDocuments(phaseId) {
  return function (dispatch) {
    dispatch(documentsRequest());
    return Object(services["h" /* request */])('phases/' + phaseId + '/document_uploads').then(function (_ref) {
      var json = _ref.json;
      return dispatch(documentsRequestSuccess(json));
    }, function (error) {
      return dispatch(documentsRequestFailure(error));
    });
  };
}

var document_uploads__createActions2 = Object(redux_actions_lib["createActions"])({
  DOCUMENTS_FILES_UPLOAD_SUCCESS: function DOCUMENTS_FILES_UPLOAD_SUCCESS(json) {
    return json.document_uploads;
  }
}, 'DOCUMENTS_FILES_UPLOAD', 'DOCUMENTS_FILES_UPLOAD_FAILURE'),
    documentsFilesUpload = document_uploads__createActions2.documentsFilesUpload,
    documentsFilesUploadSuccess = document_uploads__createActions2.documentsFilesUploadSuccess,
    documentsFilesUploadFailure = document_uploads__createActions2.documentsFilesUploadFailure;

function uploadDocument(formData, phaseId) {
  return function (dispatch) {
    dispatch(documentsFilesUpload());
    return Object(services["l" /* upload */])(formData, 'phases/' + phaseId + '/document_uploads').then(function (_ref2) {
      var json = _ref2.json;
      return dispatch(documentsFilesUploadSuccess(json));
    }, function (error) {
      return dispatch(documentsFilesUploadFailure(error));
    });
  };
}

var document_uploads__createActions3 = Object(redux_actions_lib["createActions"])({
  DOCUMENT_RESOURCE_UPDATE_SUCCESS: function DOCUMENT_RESOURCE_UPDATE_SUCCESS(json) {
    return json;
  }
}, 'DOCUMENT_RESOURCE_UPDATE_REQUEST', 'DOCUMENT_RESOURCE_UPDATE_FAILURE'),
    documentResourceUpdateRequest = document_uploads__createActions3.documentResourceUpdateRequest,
    documentResourceUpdateSuccess = document_uploads__createActions3.documentResourceUpdateSuccess,
    documentResourceUpdateFailure = document_uploads__createActions3.documentResourceUpdateFailure;

function updateDocument(phaseId, document) {
  return function (dispatch) {
    dispatch(documentResourceUpdateRequest());
    return Object(services["k" /* update */])('phases/' + phaseId + '/document_upload', document, 'document_upload').then(function (_ref3) {
      var json = _ref3.json;

      dispatch(documentResourceUpdateSuccess(json));
    }, function (error) {
      return dispatch(documentResourceUpdateFailure(error));
    });
  };
}
// CONCATENATED MODULE: ./client/app/shared/actionCreators/pay_rates.js



var showHistoryScreen = function showHistoryScreen(rate) {
  return { type: 'SHOW_RATE_HISTORY', payload: { rate: rate } };
};

var hideHistoryScreen = function hideHistoryScreen() {
  return { type: 'HIDE_RATE_HISTORY' };
};

var pay_rates__createActions = Object(redux_actions_lib["createActions"])({
  PAY_RATE_LIST_SUCCESS: [function (json) {
    return json;
  }, function (json, rate) {
    return { rate: rate };
  }]
}, 'PAY_RATE_LIST_REQUEST', 'PAY_RATE_LIST_FAILURE'),
    payRateListRequest = pay_rates__createActions.payRateListRequest,
    payRateListSuccess = pay_rates__createActions.payRateListSuccess,
    payRateListFailure = pay_rates__createActions.payRateListFailure;

function requestPayRatesList(id, rate) {
  return function (dispatch) {
    dispatch(payRateListRequest());

    return Object(services["h" /* request */])('estimators/' + id + '/pay_rate_history/' + rate).then(function (_ref) {
      var json = _ref.json;
      return dispatch(payRateListSuccess(json, rate));
    }, function (error) {
      dispatch(payRateListFailure(error));
    });
  };
}
// CONCATENATED MODULE: ./client/app/shared/actionCreators/pay_rates_uploads.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var pay_rates_uploads__createActions = Object(redux_actions_lib["createActions"])({
  /*
   *  We need to add the installer id, because the API does not includes it in the response
   *  Notice that the client side schema should NOT have an installer relation declared
   * to make this work properly.
   */
  PAY_RATE_UPLOADS_FILE_UPLOAD_SUCCESS: function PAY_RATE_UPLOADS_FILE_UPLOAD_SUCCESS(json, id) {
    return _extends({
      installer: id
    }, json.labor_rate_upload);
  }
}, 'PAY_RATE_UPLOADS_FILE_UPLOAD', 'PAY_RATE_UPLOADS_FILE_UPLOAD_FAILURE'),
    payRateUploadsFileUpload = pay_rates_uploads__createActions.payRateUploadsFileUpload,
    payRateUploadsFileUploadFailure = pay_rates_uploads__createActions.payRateUploadsFileUploadFailure,
    payRateUploadsFileUploadSuccess = pay_rates_uploads__createActions.payRateUploadsFileUploadSuccess;

function uploadInstallerPayRate(id, formData) {
  var crewId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  return function (dispatch) {
    dispatch(payRateUploadsFileUpload());
    return Object(services["l" /* upload */])(formData, 'installers/' + id + '/labor_rate_uploads?crew_id=' + crewId).then(function (_ref) {
      var json = _ref.json;

      dispatch(payRateUploadsFileUploadSuccess(json, id));
    }, function (error) {
      dispatch(payRateUploadsFileUploadFailure(error));
    });
  };
}

var pay_rates_uploads__createActions2 = Object(redux_actions_lib["createActions"])({
  PAY_RATE_UPLOADS_LIST_REQUEST_SUCCESS: function PAY_RATE_UPLOADS_LIST_REQUEST_SUCCESS(json, id) {
    var payRateUploads = {
      pay_rate_uploads: json.labor_rate_uploads.map(function (up) {
        return _extends({
          installer: id
        }, up);
      })
    };
    return payRateUploads.pay_rate_uploads;
  }
}, 'PAY_RATE_UPLOADS_LIST_REQUEST', 'PAY_RATE_UPLOADS_LIST_REQUEST_FAILURE'),
    payRateUploadsListRequest = pay_rates_uploads__createActions2.payRateUploadsListRequest,
    payRateUploadsListRequestSuccess = pay_rates_uploads__createActions2.payRateUploadsListRequestSuccess,
    payRateUploadsListRequestFailure = pay_rates_uploads__createActions2.payRateUploadsListRequestFailure;

function requestInstallerPayRateUploads(id) {
  return function (dispatch) {
    dispatch(payRateUploadsListRequest());
    return Object(services["h" /* request */])('installers/' + id + '/labor_rate_uploads').then(function (_ref2) {
      var json = _ref2.json;

      dispatch(payRateUploadsListRequestSuccess(json, id));
    }, function (error) {
      dispatch(payRateUploadsListRequestFailure(error));
    });
  };
}

function toggleInstallerPayRateUploadDialog() {
  return { type: 'PAY_RATE_UPLOADS_TOGGLE_DIALOG' };
}

function setPayRateUploadErrorMessage(errors) {
  return function (dispatch) {
    dispatch({ type: 'PAY_RATE_UPLOADS_FILE_UPLOAD_FAILURE', payload: { errors: errors } });
  };
}
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("M4fF");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./client/app/utils/schedulingUtils.js
var schedulingUtils = __webpack_require__("5nhd");

// CONCATENATED MODULE: ./client/app/shared/actionCreators/schedule.js








var schedule__createActions = Object(redux_actions_lib["createActions"])({
  SCHEDULE_SUCCESS: function SCHEDULE_SUCCESS(json) {
    return json;
  }
}, 'SCHEDULE_FAILURE', 'SCHEDULE_REQUEST', 'SUGGESTION_REQUEST', 'SUGGESTION_SUCCESS'),
    scheduleSuccess = schedule__createActions.scheduleSuccess,
    scheduleFailure = schedule__createActions.scheduleFailure,
    scheduleRequest = schedule__createActions.scheduleRequest,
    suggestionRequest = schedule__createActions.suggestionRequest,
    suggestionSuccess = schedule__createActions.suggestionSuccess;

var schedule_loadSchedule = function loadSchedule(start, filters, calendarRequest) {
  var calendarArgs = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var addtlArgs = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : { emptyMembers: false };
  return function (dispatch) {
    var startDate = moment_default()(start).format('YYYY-MM-DD');
    var requestString = 'schedule?start_date=' + startDate + '&calendar_request=' + (calendarRequest ? 1 : 0);
    if (calendarRequest && (addtlArgs.emptyMembers || false)) {
      return dispatch(scheduleSuccess({ members: [] }));
    }
    if (calendarRequest) {
      var days = calendarArgs.days,
          isScheduleBoard = calendarArgs.isScheduleBoard;

      var daysToAdd = !isScheduleBoard ? days + 30 : days;
      var endDate = moment_default()(start).add(daysToAdd, 'days').format('YYYY-MM-DD');
      requestString += '&end_date=' + endDate;
      dispatch(scheduleRequest({ startDate: startDate, endDate: endDate }));
    } else dispatch(suggestionRequest({ startDate: startDate }));
    return Object(services["h" /* request */])(requestString + '&' + qs_lib_default.a.stringify(filters)).then(function (_ref) {
      var json = _ref.json;

      var members = json;
      if (!calendarRequest && Object(schedulingUtils["k" /* membersContainCrews */])(members)) {
        var phase = addtlArgs.phase,
            relatedPhases = addtlArgs.relatedPhases;

        Object(schedulingUtils["f" /* getInstallSuggestions */])(members, phase, startDate, relatedPhases).then(function (res) {
          return dispatch(suggestionSuccess(res));
        });
      } else if (!calendarArgs.isScheduleBoard) {
        var defaultCalStart = addtlArgs.defaultCalStart,
            role = addtlArgs.role,
            username = addtlArgs.username,
            pendingAppointment = addtlArgs.pendingAppointment,
            _addtlArgs$applySmart = addtlArgs.applySmartScheduling,
            applySmartScheduling = _addtlArgs$applySmart === undefined ? false : _addtlArgs$applySmart,
            _addtlArgs$isCcs = addtlArgs.isCcs,
            isCcs = _addtlArgs$isCcs === undefined ? false : _addtlArgs$isCcs,
            _addtlArgs$phaseSourc = addtlArgs.phaseSource,
            phaseSource = _addtlArgs$phaseSourc === undefined ? '' : _addtlArgs$phaseSourc;

        if (role === 'iqm') members = json.filter(function (m) {
          return m.assignee.name === username;
        });else if (!!pendingAppointment && (pendingAppointment.kind === 'delivery' || pendingAppointment.kind === 'delivery_hold' || pendingAppointment.kind === 'deliver_stack_cali_bamboo')) {
          members = json.filter(function (m) {
            return m.assignee.can_deliver;
          });
        }
        if (applySmartScheduling && members.length && Object(schedulingUtils["k" /* membersContainCrews */])(members) && pendingAppointment && phaseSource !== 'IFI') {
          dispatch(scheduleSuccess({
            members: Object(schedulingUtils["m" /* reorderResultsAndPrioritizeCrews */])(members, pendingAppointment, defaultCalStart, isCcs)
          }));
        } else dispatch(scheduleSuccess({ members: members }));
      } else dispatch(scheduleSuccess({ members: members }));
    }).catch(function (error) {
      return dispatch(scheduleFailure(error));
    });
  };
};

var schedule_loadSuggestions = function loadSuggestions(phaseId, phaseType, start) {
  var isCcs = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  return function (dispatch) {
    var startDate = moment_default()(start).format('YYYY-MM-DD');
    var isCcsString = isCcs ? 'y' : 'n';
    dispatch(suggestionRequest({ phaseId: phaseId, phaseType: phaseType, startDate: startDate }));
    return Object(services["h" /* request */])('suggestion?phase_id=' + phaseId + '&phase_type=' + phaseType + '&start_date=' + startDate + '&is_ccs=' + isCcsString).then(function (_ref2) {
      var json = _ref2.json;
      return dispatch(suggestionSuccess(json));
    });
  };
};

var updateScheduleFiltersRequest = Object(redux_actions_lib["createAction"])('SCHEDULE_UPDATE_FILTERS');

var schedule_updateScheduleFilters = function updateScheduleFilters(filters) {
  return function (dispatch, getState) {
    var promises = [];
    if (!Object(lodash["isEqual"])(filters, getState().schedule.filters)) {
      promises.push(dispatch(Object(user["i" /* userUpdatePreferences */])({ saved_schedule_filters: filters })));
    }
    promises.push(dispatch(updateScheduleFiltersRequest(filters)));
    return Promise.all(promises);
  };
};
// CONCATENATED MODULE: ./client/app/shared/actionCreators/saved_filters.js
var saved_filters__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var saved_filters__createActions = Object(redux_actions_lib["createActions"])({
  SAVED_FILTERS_LIST_SUCCESS: [function (json) {
    return json.saved_filters;
  }, function (json) {
    return json.meta;
  }]
}, 'SAVED_FILTERS_LIST_REQUEST', 'SAVED_FILTERS_LIST_FAILURE'),
    savedFiltersListRequest = saved_filters__createActions.savedFiltersListRequest,
    savedFiltersListSuccess = saved_filters__createActions.savedFiltersListSuccess,
    savedFiltersListFailure = saved_filters__createActions.savedFiltersListFailure;

var updateSavedFilterPosition = Object(redux_actions_lib["createAction"])('UPDATE_SAVED_FILTER_POSITION', function (oldPosition, newPosition) {
  return {
    oldPosition: oldPosition,
    newPosition: newPosition
  };
});

var saved_filters_requestSavedFilters = function requestSavedFilters() {
  return function (dispatch) {
    dispatch(savedFiltersListRequest());
    return Object(services["h" /* request */])('saved_filters').then(function (_ref) {
      var json = _ref.json;

      var mapped = json;
      mapped.saved_filters = json.saved_filters.map(function (e) {
        return saved_filters__extends({}, e, {
          type: 'saved'
        });
      });
      return mapped;
    }).then(function (json) {
      return dispatch(savedFiltersListSuccess(json));
    }).catch(function (error) {
      return dispatch(savedFiltersListFailure(error));
    });
  };
};

var saved_filters__createActions2 = Object(redux_actions_lib["createActions"])({
  SAVED_FILTER_CREATE_SUCCESS: function SAVED_FILTER_CREATE_SUCCESS(json) {
    return json.saved_filter;
  }
}, 'SAVED_FILTER_CREATE_REQUEST', 'SAVED_FILTER_CREATE_FAILURE'),
    savedFilterCreateRequest = saved_filters__createActions2.savedFilterCreateRequest,
    savedFilterCreateSuccess = saved_filters__createActions2.savedFilterCreateSuccess,
    savedFilterCreateFailure = saved_filters__createActions2.savedFilterCreateFailure;

var saved_filters_createSavedFilter = function createSavedFilter(savedFilter) {
  return function (dispatch) {
    dispatch(savedFilterCreateRequest());

    return Object(services["h" /* request */])('saved_filters/', {
      method: 'POST',
      body: {
        saved_filter: savedFilter
      }
    }).then(function (_ref2) {
      var json = _ref2.json;
      return dispatch(savedFilterCreateSuccess(json));
    }).catch(function (error) {
      return dispatch(savedFilterCreateFailure(error));
    });
  };
};

var saved_filters__createActions3 = Object(redux_actions_lib["createActions"])({
  SAVED_FILTER_UPDATE_SUCCESS: function SAVED_FILTER_UPDATE_SUCCESS(json) {
    return json.saved_filter;
  }
}, 'SAVED_FILTER_UPDATE_REQUEST', 'SAVED_FILTER_UPDATE_FAILURE'),
    savedFilterUpdateRequest = saved_filters__createActions3.savedFilterUpdateRequest,
    savedFilterUpdateSuccess = saved_filters__createActions3.savedFilterUpdateSuccess,
    savedFilterUpdateFailure = saved_filters__createActions3.savedFilterUpdateFailure;

var saved_filters_updateSavedFilter = function updateSavedFilter(savedFilter, savedFilterId) {
  return function (dispatch) {
    dispatch(savedFilterUpdateRequest());
    return Object(services["h" /* request */])('saved_filters/' + savedFilterId, {
      method: 'PUT',
      body: {
        saved_filter: savedFilter
      }
    }).then(function (_ref3) {
      var json = _ref3.json;
      return dispatch(savedFilterUpdateSuccess(json));
    }).catch(function (error) {
      return dispatch(savedFilterUpdateFailure(error));
    });
  };
};

var saved_filters__createActions4 = Object(redux_actions_lib["createActions"])({
  SAVED_FILTER_DELETE_SUCCESS: function SAVED_FILTER_DELETE_SUCCESS(savedFilterId) {
    return {
      savedFilterId: savedFilterId
    };
  }
}, 'SAVED_FILTER_DELETE_REQUEST', 'SAVED_FILTER_DELETE_FAILURE'),
    savedFilterDeleteRequest = saved_filters__createActions4.savedFilterDeleteRequest,
    savedFilterDeleteSuccess = saved_filters__createActions4.savedFilterDeleteSuccess,
    savedFilterDeleteFailure = saved_filters__createActions4.savedFilterDeleteFailure;

var saved_filters_deleteSavedFilter = function deleteSavedFilter(savedFilterId) {
  return function (dispatch) {
    dispatch(savedFilterDeleteRequest());
    return Object(services["h" /* request */])('saved_filters/' + savedFilterId, {
      method: 'DELETE'
    }).then(function () {
      return dispatch(savedFilterDeleteSuccess(savedFilterId));
    }).catch(function (error) {
      return dispatch(savedFilterDeleteFailure(error));
    });
  };
};
// CONCATENATED MODULE: ./client/app/shared/actionCreators/assigned_filters.js
var assigned_filters__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var assigned_filters__createActions = Object(redux_actions_lib["createActions"])({
  ASSIGNED_FILTERS_LIST_SUCCESS: [function (json) {
    return json.assigned_filters;
  }, function (json) {
    return json.meta;
  }]
}, 'ASSIGNED_FILTERS_LIST_REQUEST', 'ASSIGNED_FILTERS_LIST_FAILURE'),
    assignedFiltersListRequest = assigned_filters__createActions.assignedFiltersListRequest,
    assignedFiltersListSuccess = assigned_filters__createActions.assignedFiltersListSuccess,
    assignedFiltersListFailure = assigned_filters__createActions.assignedFiltersListFailure;

var updateAssignedFilterPosition = Object(redux_actions_lib["createAction"])('UPDATE_ASSIGNED_FILTER_POSITION', function (oldPosition, newPosition) {
  return { oldPosition: oldPosition, newPosition: newPosition };
});

var assigned_filters_requestAssignedFilters = function requestAssignedFilters() {
  return function (dispatch) {
    dispatch(assignedFiltersListRequest());
    return Object(services["h" /* request */])('assigned_filters').then(function (_ref) {
      var json = _ref.json;

      var mapped = json;
      mapped.assigned_filters = json.assigned_filters.map(function (e) {
        return assigned_filters__extends({}, e, { type: 'assigned'
        });
      });
      return mapped;
    }).then(function (json) {
      return dispatch(assignedFiltersListSuccess(json));
    }).catch(function (error) {
      return dispatch(assignedFiltersListFailure(error));
    });
  };
};

var assigned_filters__createActions2 = Object(redux_actions_lib["createActions"])({
  ASSIGNED_FILTER_COUNT_SUCCESS: function ASSIGNED_FILTER_COUNT_SUCCESS(json) {
    return json;
  }
}, 'ASSIGNED_FILTER_COUNT_REQUEST', 'ASSIGNED_FILTER_COUNT_FAILURE'),
    assignedFilterCountRequest = assigned_filters__createActions2.assignedFilterCountRequest,
    assignedFilterCountSuccess = assigned_filters__createActions2.assignedFilterCountSuccess,
    assignedFilterCountFailure = assigned_filters__createActions2.assignedFilterCountFailure;

var assigned_filters_requestFilterCount = function requestFilterCount(filterId) {
  return function (dispatch) {
    dispatch(assignedFilterCountRequest());
    return Object(services["h" /* request */])('assigned_filters/' + filterId).then(function (_ref2) {
      var json = _ref2.json;
      return dispatch(assignedFilterCountSuccess(json));
    }).catch(function (error) {
      return dispatch(assignedFilterCountFailure(error));
    });
  };
};

var assigned_filters__createActions3 = Object(redux_actions_lib["createActions"])({
  ASSIGNED_FILTER_CREATE_SUCCESS: function ASSIGNED_FILTER_CREATE_SUCCESS(json) {
    return json.assigned_filter;
  }
}, 'ASSIGNED_FILTER_CREATE_REQUEST', 'ASSIGNED_FILTER_CREATE_FAILURE'),
    assignedFilterCreateRequest = assigned_filters__createActions3.assignedFilterCreateRequest,
    assignedFilterCreateSuccess = assigned_filters__createActions3.assignedFilterCreateSuccess,
    assignedFilterCreateFailure = assigned_filters__createActions3.assignedFilterCreateFailure;

var assigned_filters_createAssignedFilter = function createAssignedFilter(assignedFilter) {
  return function (dispatch) {
    dispatch(assignedFilterCreateRequest());
    return Object(services["h" /* request */])('assigned_filters/', {
      method: 'POST', body: { assigned_filter: assignedFilter }
    }).then(function (_ref3) {
      var json = _ref3.json;
      return dispatch(assignedFilterCreateSuccess(json));
    }).catch(function (error) {
      return dispatch(assignedFilterCreateFailure(error));
    });
  };
};

var assigned_filters__createActions4 = Object(redux_actions_lib["createActions"])({
  ASSIGNED_FILTER_UPDATE_SUCCESS: function ASSIGNED_FILTER_UPDATE_SUCCESS(json) {
    return json.assigned_filter;
  }
}, 'ASSIGNED_FILTER_UPDATE_REQUEST', 'ASSIGNED_FILTER_UPDATE_FAILURE'),
    assignedFilterUpdateRequest = assigned_filters__createActions4.assignedFilterUpdateRequest,
    assignedFilterUpdateSuccess = assigned_filters__createActions4.assignedFilterUpdateSuccess,
    assignedFilterUpdateFailure = assigned_filters__createActions4.assignedFilterUpdateFailure;

var assigned_filters_updateAssignedFilter = function updateAssignedFilter(assignedFilter, assignedFilterId) {
  return function (dispatch) {
    dispatch(assignedFilterUpdateRequest());
    return Object(services["h" /* request */])('assigned_filters/' + assignedFilterId, {
      method: 'PUT', body: { assigned_filter: assignedFilter }
    }).then(function (_ref4) {
      var json = _ref4.json;
      return dispatch(assignedFilterUpdateSuccess(json));
    }).catch(function (error) {
      return dispatch(assignedFilterUpdateFailure(error));
    });
  };
};

var assigned_filters__createActions5 = Object(redux_actions_lib["createActions"])({
  ASSIGNED_FILTER_DELETE_SUCCESS: function ASSIGNED_FILTER_DELETE_SUCCESS(assignedFilterId) {
    return { assignedFilterId: assignedFilterId };
  }
}, 'ASSIGNED_FILTER_DELETE_REQUEST', 'ASSIGNED_FILTER_DELETE_FAILURE'),
    assignedFilterDeleteRequest = assigned_filters__createActions5.assignedFilterDeleteRequest,
    assignedFilterDeleteSuccess = assigned_filters__createActions5.assignedFilterDeleteSuccess,
    assignedFilterDeleteFailure = assigned_filters__createActions5.assignedFilterDeleteFailure;

var assigned_filters_deleteAssignedFilter = function deleteAssignedFilter(assignedFilterId) {
  return function (dispatch) {
    dispatch(assignedFilterDeleteRequest());
    return Object(services["h" /* request */])('assigned_filters/' + assignedFilterId, { method: 'DELETE' }).then(function () {
      return dispatch(assignedFilterDeleteSuccess(assignedFilterId));
    }).catch(function (error) {
      return dispatch(assignedFilterDeleteFailure(error));
    });
  };
};
// CONCATENATED MODULE: ./client/app/shared/actionCreators/scraper.js



var scraper__createActions = Object(redux_actions_lib["createActions"])({
  SCRAPE_SUCCESS: function SCRAPE_SUCCESS(json) {
    return json;
  }
}, 'SCRAPE_REQUEST', 'SCRAPE_FAILURE'),
    scrapeRequest = scraper__createActions.scrapeRequest,
    scrapeSuccess = scraper__createActions.scrapeSuccess,
    scrapeFailure = scraper__createActions.scrapeFailure;

function scraper(formData) {
  return function (dispatch) {
    dispatch(scrapeRequest());
    return Object(services["l" /* upload */])(formData, 'scrapers').then(function (_ref) {
      var json = _ref.json;
      return dispatch(scrapeSuccess(json));
    }).catch(function (error) {
      return dispatch(scrapeFailure(error));
    });
  };
}
// CONCATENATED MODULE: ./client/app/shared/actionCreators/cocs.js



var cocs__createActions = Object(redux_actions_lib["createActions"])({
  COC_CREATE_SUCCESS: function COC_CREATE_SUCCESS(json) {
    return json;
  }
}, 'COC_CREATE_REQUEST', 'COC_CREATE_FAILURE'),
    cocCreateRequest = cocs__createActions.cocCreateRequest,
    cocCreateSuccess = cocs__createActions.cocCreateSuccess,
    cocCreateFailure = cocs__createActions.cocCreateFailure;

function cocCreate(cocData) {
  return function (dispatch) {
    dispatch(cocCreateRequest());
    return Object(services["d" /* create */])('coc', cocData).then(function (_ref) {
      var json = _ref.json;
      return dispatch(cocCreateSuccess(json));
    }).catch(function (error) {
      return dispatch(cocCreateFailure(error));
    });
  };
}
// CONCATENATED MODULE: ./client/app/shared/actionCreators/lrrps.js



var lrrps__createActions = Object(redux_actions_lib["createActions"])({
  LRRP_CREATE_SUCCESS: function LRRP_CREATE_SUCCESS(json) {
    return json;
  }
}, 'LRRP_CREATE_REQUEST', 'LRRP_CREATE_FAILURE'),
    lrrpCreateRequest = lrrps__createActions.lrrpCreateRequest,
    lrrpCreateSuccess = lrrps__createActions.lrrpCreateSuccess,
    lrrpCreateFailure = lrrps__createActions.lrrpCreateFailure;

function lrrpCreate(lrrpData) {
  return function (dispatch) {
    dispatch(lrrpCreateRequest());
    return Object(services["d" /* create */])('lrrp', lrrpData).then(function (_ref) {
      var json = _ref.json;
      return dispatch(lrrpCreateSuccess(json));
    }).catch(function (error) {
      return dispatch(lrrpCreateFailure(error));
    });
  };
}
// CONCATENATED MODULE: ./client/app/shared/actionCreators/ifi_lrrps.js



var ifi_lrrps__createActions = Object(redux_actions_lib["createActions"])({
  IFI_LRRP_CREATE_SUCCESS: function IFI_LRRP_CREATE_SUCCESS(json) {
    return json;
  }
}, 'IFI_LRRP_CREATE_REQUEST', 'IFI_LRRP_CREATE_FAILURE'),
    ifiLrrpCreateRequest = ifi_lrrps__createActions.ifiLrrpCreateRequest,
    ifiLrrpCreateSuccess = ifi_lrrps__createActions.ifiLrrpCreateSuccess,
    ifiLrrpCreateFailure = ifi_lrrps__createActions.ifiLrrpCreateFailure;

function ifiLrrpCreate(ifiLrrpData) {
  return function (dispatch) {
    dispatch(ifiLrrpCreateRequest());
    return Object(services["d" /* create */])('ifi_lrrp', ifiLrrpData).then(function (_ref) {
      var json = _ref.json;

      dispatch(ifiLrrpCreateSuccess(json));
      return json;
    }).catch(function (error) {
      dispatch(ifiLrrpCreateFailure(error));
      throw error;
    });
  };
}
// CONCATENATED MODULE: ./client/app/shared/actionCreators/walkthroughs.js



var walkthroughs__createActions = Object(redux_actions_lib["createActions"])({
  WALKTHROUGH_CREATE_SUCCESS: function WALKTHROUGH_CREATE_SUCCESS(json) {
    return json;
  }
}, 'WALKTHROUGH_CREATE_REQUEST', 'WALKTHROUGH_CREATE_FAILURE'),
    walkthroughCreateRequest = walkthroughs__createActions.walkthroughCreateRequest,
    walkthroughCreateSuccess = walkthroughs__createActions.walkthroughCreateSuccess,
    walkthroughCreateFailure = walkthroughs__createActions.walkthroughCreateFailure;

function walkthroughCreate(walkthroughData) {
  return function (dispatch) {
    dispatch(walkthroughCreateRequest());
    return Object(services["d" /* create */])('walkthrough', walkthroughData).then(function (_ref) {
      var json = _ref.json;
      return dispatch(walkthroughCreateSuccess(json));
    }).catch(function (error) {
      return dispatch(walkthroughCreateFailure(error));
    });
  };
}
// CONCATENATED MODULE: ./client/app/shared/actionCreators/settings.js


var settings__createActions = Object(redux_actions_lib["createActions"])('TOGGLE_CONTRAST'),
    toggleContrast = settings__createActions.toggleContrast;

function toggleHighContrast() {
  /**
  * No payload is being dispatched since the reducer uses the inverse
  * of the current boolean value already present in state. The reducer
  * simply flips the state to indicate wether or not high contrast should be used.
  */
  return function (dispatch) {
    return dispatch(toggleContrast());
  };
}
// CONCATENATED MODULE: ./client/app/shared/actionCreators/repair_inspection_report.js



var repair_inspection_report__createActions = Object(redux_actions_lib["createActions"])({
  REPAIR_INSPECTION_REPORT_CREATE_SUCCESS: function REPAIR_INSPECTION_REPORT_CREATE_SUCCESS(json) {
    return json;
  }
}, 'REPAIR_INSPECTION_REPORT_CREATE_REQUEST', 'REPAIR_INSPECTION_REPORT_CREATE_FAILURE'),
    repairInspectionReportCreateRequest = repair_inspection_report__createActions.repairInspectionReportCreateRequest,
    repairInspectionReportCreateSuccess = repair_inspection_report__createActions.repairInspectionReportCreateSuccess,
    repairInspectionReportCreateFailure = repair_inspection_report__createActions.repairInspectionReportCreateFailure;

function repairInspectionReportCreate(repairInspectionReportData) {
  return function (dispatch) {
    dispatch(repairInspectionReportCreateRequest());
    return Object(services["d" /* create */])('repair_inspection_report', repairInspectionReportData).then(function (_ref) {
      var json = _ref.json;
      return dispatch(repairInspectionReportCreateSuccess(json));
    }).catch(function (error) {
      return dispatch(repairInspectionReportCreateFailure(error));
    });
  };
}
// CONCATENATED MODULE: ./client/app/shared/actionCreators/crew_inspection.js



var crew_inspection__createActions = Object(redux_actions_lib["createActions"])({
  CREW_INSPECTION_CREATE_SUCCESS: function CREW_INSPECTION_CREATE_SUCCESS(json) {
    return json;
  }
}, 'CREW_INSPECTION_CREATE_REQUEST', 'CREW_INSPECTION_CREATE_FAILURE'),
    crewInspectionCreateRequest = crew_inspection__createActions.crewInspectionCreateRequest,
    crewInspectionCreateSuccess = crew_inspection__createActions.crewInspectionCreateSuccess,
    crewInspectionCreateFailure = crew_inspection__createActions.crewInspectionCreateFailure;

function crewInspectionCreate(crewInspectionData) {
  return function (dispatch) {
    dispatch(crewInspectionCreateRequest());
    return Object(services["d" /* create */])('crew_inspection', crewInspectionData).then(function (_ref) {
      var json = _ref.json;
      return dispatch(crewInspectionCreateSuccess(json));
    }).catch(function (error) {
      return dispatch(crewInspectionCreateFailure(error));
    });
  };
}
// CONCATENATED MODULE: ./client/app/shared/actionCreators/job_paperwork_templates.js



var job_paperwork_templates__createActions = Object(redux_actions_lib["createActions"])({
  JOB_PAPERWORK_TEMPLATE_CREATE_SUCCESS: function JOB_PAPERWORK_TEMPLATE_CREATE_SUCCESS(json) {
    return json.job_paperwork_template;
  }
}, 'JOB_PAPERWORK_TEMPLATE_CREATE_REQUEST', 'JOB_PAPERWORK_TEMPLATE_CREATE_FAILURE'),
    jobPaperworkTemplateCreateRequest = job_paperwork_templates__createActions.jobPaperworkTemplateCreateRequest,
    jobPaperworkTemplateCreateSuccess = job_paperwork_templates__createActions.jobPaperworkTemplateCreateSuccess,
    jobPaperworkTemplateCreateFailure = job_paperwork_templates__createActions.jobPaperworkTemplateCreateFailure;

function jobPaperworkTemplateCreate(templateData) {
  return function (dispatch) {
    dispatch(jobPaperworkTemplateCreateRequest());
    return Object(services["h" /* request */])('phases/' + templateData.phase_id + '/job_paperwork_templates', {
      method: 'POST',
      body: { job_paperwork_template: templateData }
    }).then(function (_ref) {
      var json = _ref.json;
      return dispatch(jobPaperworkTemplateCreateSuccess(json));
    }).catch(function (error) {
      dispatch(jobPaperworkTemplateCreateFailure(error));
      throw error;
    });
  };
}

function requestJobPaperworkTemplates(phaseId) {
  return Object(services["h" /* request */])('phases/' + phaseId + '/job_paperwork_templates').then(function (_ref2) {
    var json = _ref2.json;
    return {
      templates: json.job_paperwork_templates || [],
      error: null
    };
  }).catch(function (error) {
    return {
      templates: [],
      error: error
    };
  });
}
// CONCATENATED MODULE: ./client/app/shared/actionCreators/refigure_form.js




var refigure_form__createActions = Object(redux_actions_lib["createActions"])({
  REQUEST_REFIGURE_FORM_SUCCESS: function REQUEST_REFIGURE_FORM_SUCCESS(json) {
    return {
      refigure: json.refigure
    };
  }
}, 'REQUEST_REFIGURE_FORM_REQUEST', 'REQUEST_REFIGURE_FORM_FAILURE'),
    requestRefigureFormRequest = refigure_form__createActions.requestRefigureFormRequest,
    requestRefigureFormSuccess = refigure_form__createActions.requestRefigureFormSuccess,
    requestRefigureFormFailure = refigure_form__createActions.requestRefigureFormFailure;

function requestRefigureForm() {
  return function (dispatch) {
    dispatch(requestRefigureFormRequest());
    return Object(services["h" /* request */])('refigures').then(function (_ref) {
      var json = _ref.json;
      return dispatch(requestRefigureFormSuccess(json));
    }).catch(function (error) {
      return dispatch(requestRefigureFormFailure(error));
    });
  };
}

var refigure_form__createActions2 = Object(redux_actions_lib["createActions"])('SUBMIT_REFIGURE_FORM_SUCCESS', 'SUBMIT_REFIGURE_FORM_REQUEST', 'SUBMIT_REFIGURE_FORM_FAILURE'),
    submitRefigureFormRequest = refigure_form__createActions2.submitRefigureFormRequest,
    submitRefigureFormSuccess = refigure_form__createActions2.submitRefigureFormSuccess,
    submitRefigureFormFailure = refigure_form__createActions2.submitRefigureFormFailure;

function submitRefigureForm(refigure) {
  return function (dispatch) {
    dispatch(submitRefigureFormRequest());
    return Object(services["h" /* request */])('refigures', { method: 'POST', body: { refigure: refigure } }).then(function () {
      dispatch(submitRefigureFormSuccess());
      dispatch(actionCreators_navigate('/refigure/thankyou'));
    }).catch(function (error) {
      return dispatch(submitRefigureFormFailure(error));
    });
  };
}
// EXTERNAL MODULE: ./client/app/shared/actionCreators/phase_items.js
var phase_items = __webpack_require__("PMQ5");

// EXTERNAL MODULE: ./client/app/shared/actionCreators/ptos.js
var ptos = __webpack_require__("z2+H");

// EXTERNAL MODULE: ./client/app/shared/actionCreators/traveling_work_dates.js
var traveling_work_dates = __webpack_require__("Rq0V");

// EXTERNAL MODULE: ./client/app/shared/actionCreators/reports.js
var reports = __webpack_require__("zdX5");

// CONCATENATED MODULE: ./client/app/shared/actionCreators/survey.js



var survey__createActions = Object(redux_actions_lib["createActions"])('SURVEY_FETCH_SUCCESS', 'SURVEY_FETCH_REQUEST', 'SURVEY_FETCH_FAILURE'),
    surveyFetchRequest = survey__createActions.surveyFetchRequest,
    surveyFetchSuccess = survey__createActions.surveyFetchSuccess,
    surveyFetchFailure = survey__createActions.surveyFetchFailure;

function requestPhaseSurvey(phaseID) {
  return function (dispatch) {
    dispatch(surveyFetchRequest());

    return Object(services["h" /* request */])('phases/' + phaseID + '/survey').then(function (_ref) {
      var json = _ref.json;
      return dispatch(surveyFetchSuccess(json));
    }).catch(function (error) {
      return dispatch(surveyFetchFailure(error));
    });
  };
}

var survey__createActions2 = Object(redux_actions_lib["createActions"])('SURVEY_UPDATE_SUCCESS', 'SURVEY_UPDATE_REQUEST', 'SURVEY_UPDATE_FAILURE'),
    surveyUpdateRequest = survey__createActions2.surveyUpdateRequest,
    surveyUpdateSuccess = survey__createActions2.surveyUpdateSuccess,
    surveyUpdateFailure = survey__createActions2.surveyUpdateFailure;

function updatePhaseSurvey(phaseID, params) {
  return function (dispatch) {
    dispatch(surveyUpdateRequest());

    var questions = params.questions.map(function (q) {
      return { id: q.id, answers_attributes: q.answers };
    });
    var body = { survey: {
        comment: params.comment,
        resolution: params.resolution,
        questions_attributes: questions
      } };

    return Object(services["h" /* request */])('phases/' + phaseID + '/survey', { method: 'PATCH', body: body }).then(function (_ref2) {
      var json = _ref2.json;
      return dispatch(surveyUpdateSuccess(json));
    }).catch(function (error) {
      return dispatch(surveyUpdateFailure(error));
    });
  };
}

var survey__createActions3 = Object(redux_actions_lib["createActions"])('SURVEY_POOR_SCORE_NOTIFICATION_SUCCESS', 'SURVEY_POOR_SCORE_NOTIFICATION_REQUEST', 'SURVEY_POOR_SCORE_NOTIFICATION_FAILURE'),
    surveyPoorScoreNotificationRequest = survey__createActions3.surveyPoorScoreNotificationRequest,
    surveyPoorScoreNotificationSuccess = survey__createActions3.surveyPoorScoreNotificationSuccess,
    surveyPoorScoreNotificationFailure = survey__createActions3.surveyPoorScoreNotificationFailure;

function sendPoorScoreNotification(phaseID, params) {
  return function (dispatch) {
    dispatch(surveyPoorScoreNotificationRequest());
    var body = { email: params };

    return Object(services["h" /* request */])('phases/' + phaseID + '/survey/send_poor_score_notification', { method: 'POST', body: body }).then(function (_ref3) {
      var json = _ref3.json;
      return dispatch(surveyPoorScoreNotificationSuccess(json));
    }).catch(function (error) {
      return dispatch(surveyPoorScoreNotificationFailure(error));
    });
  };
}
// EXTERNAL MODULE: ./client/app/shared/actionCreators/line_items.js
var line_items = __webpack_require__("/gPC");

// CONCATENATED MODULE: ./client/app/shared/actionCreators/uploads.js




var uploads__createActions = Object(redux_actions_lib["createActions"])({
  UPLOADS_LIST_REQUEST_SUCCESS: function UPLOADS_LIST_REQUEST_SUCCESS(json, type, page) {
    return { data: json, type: type, page: page };
  }
}, 'UPLOADS_LIST_REQUEST', 'UPLOADS_LIST_REQUEST_FAILURE'),
    uploadsListRequest = uploads__createActions.uploadsListRequest,
    uploadsListRequestSuccess = uploads__createActions.uploadsListRequestSuccess,
    uploadsListRequestFailure = uploads__createActions.uploadsListRequestFailure;

function getUploadsList(type, page) {
  return function (dispatch, getState) {
    var state = getState();
    var uploadKey = Object(lodash["camelCase"])(type);
    var newPage = page || state[uploadKey].page;

    dispatch(uploadsListRequest({ type: type, newPage: newPage }));
    return Object(services["h" /* request */])(type + '?page=' + newPage).then(function (_ref) {
      var json = _ref.json;
      return dispatch(uploadsListRequestSuccess(json, type, page));
    }).catch(function (errors) {
      return dispatch(uploadsListRequestFailure({ errors: errors, type: type }));
    });
  };
}

var uploads__createActions2 = Object(redux_actions_lib["createActions"])({
  UPLOADS_FILE_UPLOAD_SUCCESS: function UPLOADS_FILE_UPLOAD_SUCCESS(json, type) {
    return { data: json, type: type };
  }
}, 'UPLOADS_FILE_UPLOAD', 'UPLOADS_FILE_UPLOAD_FAILURE'),
    uploadsFileUpload = uploads__createActions2.uploadsFileUpload,
    uploadsFileUploadSuccess = uploads__createActions2.uploadsFileUploadSuccess,
    uploadsFileUploadFailure = uploads__createActions2.uploadsFileUploadFailure;

function uploadFile(formData, type) {
  return function (dispatch) {
    dispatch(uploadsFileUpload({ type: type }));
    return Object(services["l" /* upload */])(formData, type).then(function (_ref2) {
      var json = _ref2.json;
      return dispatch(uploadsFileUploadSuccess(json[type.slice(0, -1)], type));
    }).catch(function (errors) {
      return dispatch(uploadsFileUploadFailure({ errors: errors.errors, type: type }));
    });
  };
}

function toggleDialog(status, type) {
  return function (dispatch) {
    dispatch({ type: 'UPLOAD_DIALOG_TOGGLE', payload: { status: status, type: type } });
  };
}

function setErrorMessage(errors, type) {
  return function (dispatch) {
    dispatch({ type: 'UPLOADS_FILE_UPLOAD_FAILURE', payload: { errors: errors, type: type } });
  };
}
// EXTERNAL MODULE: ./client/app/shared/actionCreators/ims_actions.js
var ims_actions = __webpack_require__("+GGQ");

// EXTERNAL MODULE: ./client/app/shared/actionCreators/default_installer_pay.js
var default_installer_pay = __webpack_require__("xXcJ");

// CONCATENATED MODULE: ./client/app/shared/actionCreators/projects.js



var projects__createActions = Object(redux_actions_lib["createActions"])('BULK_PROJECT_LOAD_SUCCESS', 'BULK_PROJECT_LOAD_REQUEST', 'BULK_PROJECT_LOAD_FAILURE'),
    bulkProjectLoadSuccess = projects__createActions.bulkProjectLoadSuccess,
    bulkProjectLoadFailure = projects__createActions.bulkProjectLoadFailure,
    bulkProjectLoadRequest = projects__createActions.bulkProjectLoadRequest;

var projects_requestbulkProjectLoad = function requestbulkProjectLoad(projects) {
  return function (dispatch) {
    dispatch(bulkProjectLoadRequest());
    return Object(services["h" /* request */])('projects', { method: 'POST', body: { projects: projects } }).then(function () {
      return dispatch(bulkProjectLoadSuccess());
    }).catch(function (error) {
      return dispatch(bulkProjectLoadFailure(error));
    });
  };
};
// CONCATENATED MODULE: ./client/app/shared/actionCreators/quick_schedule.js



var quick_schedule__createActions = Object(redux_actions_lib["createActions"])({
  SEND_QUICK_SCHEDULE_MESSAGE_SUCCESS: function SEND_QUICK_SCHEDULE_MESSAGE_SUCCESS(json) {
    return {
      phase: json.phase || json
    };
  }
}, 'SEND_QUICK_SCHEDULE_MESSAGE_REQUEST', 'SEND_QUICK_SCHEDULE_MESSAGE_FAILURE'),
    sendQuickScheduleMessageRequest = quick_schedule__createActions.sendQuickScheduleMessageRequest,
    sendQuickScheduleMessageSuccess = quick_schedule__createActions.sendQuickScheduleMessageSuccess,
    sendQuickScheduleMessageFailure = quick_schedule__createActions.sendQuickScheduleMessageFailure;

function sendQuickScheduleMessage(phaseID, apptParams) {
  return function (dispatch) {
    dispatch(sendQuickScheduleMessageRequest());
    var req = {
      method: 'POST',
      body: { appt_params: apptParams }
    };
    return Object(services["h" /* request */])('phases/' + phaseID + '/quick_schedule', req).then(function (_ref) {
      var json = _ref.json;
      return dispatch(sendQuickScheduleMessageSuccess(json));
    }).catch(function (error) {
      return dispatch(sendQuickScheduleMessageFailure(error));
    });
  };
}
// CONCATENATED MODULE: ./client/app/shared/actionCreators/index.js
/* harmony export (immutable) */ __webpack_exports__["O"] = actionCreators_navigate;
/* harmony export (immutable) */ __webpack_exports__["P"] = navigateBack;
/* harmony export (immutable) */ __webpack_exports__["k"] = clearValidationErrors;
/* harmony export (immutable) */ __webpack_exports__["F"] = listOfRequests;
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "K", function() { return user["a" /* loginUserFailure */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "L", function() { return user["b" /* logoutUser */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Q", function() { return user["c" /* refreshToken */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_54", function() { return user["d" /* signInGoogleUser */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_55", function() { return user["e" /* signInMicrosoftUser */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_77", function() { return user["g" /* userGetSession */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_78", function() { return user["h" /* userResendLink */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_79", function() { return user["i" /* userUpdatePreferences */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_72", function() { return user["f" /* updateUserBadge */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Y", function() { return employees["d" /* requestEmployeeList */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "X", function() { return employees["c" /* requestEmployee */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "n", function() { return employees["b" /* createEmployee */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_61", function() { return employees["g" /* updateEmployee */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return employees["a" /* addEventToEmployee */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_45", function() { return employees["f" /* setEmployeeFilters */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_33", function() { return employees["e" /* resetEmployeeFilters */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_31", function() { return requestWorkroomList; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_30", function() { return requestWorkroom; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "v", function() { return createWorkroom; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_73", function() { return updateWorkroom; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_52", function() { return setWorkroomFilters; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_40", function() { return resetWorkroomFilters; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_27", function() { return requestTaskList; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "U", function() { return requestAllStores; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_24", function() { return requestStore; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "u", function() { return createStore; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_71", function() { return updateStore; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_39", function() { return resetStoreFilters; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_51", function() { return setStoreFilters; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "z", function() { return fetchInstallersForPrioritization; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_37", function() { return resetInstallerPrioritization; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "W", function() { return dropdown_lists["a" /* requestDivisionList */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_22", function() { return dropdown_lists["f" /* requestRegionList */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_12", function() { return dropdown_lists["b" /* requestMarketList */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_20", function() { return dropdown_lists["e" /* requestPricePatchesList */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return dropdown_lists["d" /* requestPricePatchLineItemList */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return dropdown_lists["c" /* requestPayRateLineItemList */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_0", function() { return estimators["e" /* requestEstimatorList */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_47", function() { return estimators["h" /* setEstimatorFilters */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Z", function() { return estimators["d" /* requestEstimator */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "o", function() { return estimators["b" /* createEstimator */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_62", function() { return estimators["i" /* updateEstimator */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return estimators["c" /* getEstimatorsForZipCode */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return estimators["a" /* addEventToEstimator */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_34", function() { return estimators["f" /* resetEstimatorFilters */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_43", function() { return estimators["g" /* sendEstimatorEmail */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_7", function() { return requestInstallerList; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_6", function() { return requestInstaller; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "r", function() { return createInstaller; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_64", function() { return updateInstaller; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return installers_addEventToInstaller; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_49", function() { return setInstallerFilters; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_36", function() { return resetInstallerFilters; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_4", function() { return requestIQMList; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_48", function() { return setIQMFilters; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_35", function() { return resetIQMFilters; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_3", function() { return requestIQM; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "q", function() { return createIQM; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_63", function() { return updateIQM; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_25", function() { return requestSurfaceTypesList; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_18", function() { return phases_requestPhaseList; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_19", function() { return phases_requestPhasesForExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_38", function() { return resetPhasePagination; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_66", function() { return phases_updatePhaseFiltersLocation; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "G", function() { return actionCreators_phase["k" /* loadPhase */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "s", function() { return actionCreators_phase["h" /* createPhase */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return actionCreators_phase["g" /* copyPhase */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_65", function() { return actionCreators_phase["r" /* updatePhase */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "j", function() { return actionCreators_phase["f" /* clearValidation */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return actionCreators_phase["a" /* addEventToPhase */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return actionCreators_phase["l" /* overridePhaseStatus */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return actionCreators_phase["b" /* addFlagToPhase */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "R", function() { return actionCreators_phase["m" /* removeFlagFromPhase */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_67", function() { return actionCreators_phase["s" /* updatePhaseTask */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return actionCreators_phase["c" /* assignPhaseEstimator */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "e", function() { return actionCreators_phase["d" /* assignPhaseInstaller */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_1", function() { return actionCreators_phase["n" /* requestEstimatorListByWorkroom */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_10", function() { return actionCreators_phase["o" /* requestInstallersForAssignment */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_15", function() { return actionCreators_phase["p" /* requestPhaseAppointments */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return actionCreators_phase["e" /* cancelPhase */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_80", function() { return actionCreators_phase["t" /* verifyPhaseAssessment */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return actionCreators_phase["i" /* createSupportRequest */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return actionCreators_phase["j" /* fetchCvProposals */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return actionCreators_phase["q" /* resolveCvProposal */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "A", function() { return fetchPhaseDocuments; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_74", function() { return uploadDocument; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_60", function() { return updateDocument; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_53", function() { return showHistoryScreen; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "C", function() { return hideHistoryScreen; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_14", function() { return requestPayRatesList; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_76", function() { return uploadInstallerPayRate; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_9", function() { return requestInstallerPayRateUploads; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_59", function() { return toggleInstallerPayRateUploadDialog; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_50", function() { return setPayRateUploadErrorMessage; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "I", function() { return schedule_loadSchedule; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "J", function() { return schedule_loadSuggestions; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_70", function() { return schedule_updateScheduleFilters; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_69", function() { return updateSavedFilterPosition; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_23", function() { return saved_filters_requestSavedFilters; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "t", function() { return saved_filters_createSavedFilter; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_68", function() { return saved_filters_updateSavedFilter; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "y", function() { return saved_filters_deleteSavedFilter; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return updateAssignedFilterPosition; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "V", function() { return assigned_filters_requestAssignedFilters; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_2", function() { return assigned_filters_requestFilterCount; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return assigned_filters_createAssignedFilter; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return assigned_filters_updateAssignedFilter; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return assigned_filters_deleteAssignedFilter; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_42", function() { return scraper; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "m", function() { return cocCreate; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "M", function() { return lrrpCreate; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "D", function() { return ifiLrrpCreate; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_81", function() { return walkthroughCreate; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_58", function() { return toggleHighContrast; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "S", function() { return repairInspectionReportCreate; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "w", function() { return crewInspectionCreate; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "E", function() { return jobPaperworkTemplateCreate; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_11", function() { return requestJobPaperworkTemplates; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_21", function() { return requestRefigureForm; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_56", function() { return submitRefigureForm; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_17", function() { return phase_items["i" /* requestPhaseItems */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return phase_items["j" /* requestPhaseLevelerItems */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "H", function() { return phase_items["f" /* loadPhaseItems */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return phase_items["d" /* createPhaseItem */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_41", function() { return phase_items["k" /* savePhaseItem */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return phase_items["l" /* savePhaseLevelerItem */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "N", function() { return phase_items["g" /* mergePurchaseOrderToOriginal */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "x", function() { return phase_items["e" /* deletePhaseItem */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_16", function() { return phase_items["h" /* requestPhaseItemEventList */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return phase_items["b" /* copyLaborItemsToLaborSheet */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return phase_items["a" /* approveLaborSheet */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "p", function() { return phase_items["c" /* createExceptionItem */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_13", function() { return ptos["c" /* requestPTOList */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return ptos["a" /* createPTO */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return ptos["d" /* updatePTO */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return ptos["b" /* deletePTO */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_28", function() { return traveling_work_dates["c" /* requestTravelingWorkDatesList */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return traveling_work_dates["a" /* createTravelingWorkDate */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return traveling_work_dates["d" /* updateTravelingWorkDate */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return traveling_work_dates["b" /* deleteTravelingWorkDate */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_29", function() { return reports["l" /* requestWarehouseReport */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "l", function() { return reports["f" /* clearWarehouseReport */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return reports["j" /* requestJobHistoryReport */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return reports["d" /* clearJobHistoryReport */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_5", function() { return reports["h" /* requestInstallWorkorderReport */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "g", function() { return reports["b" /* clearInstallWorkorderReport */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_8", function() { return reports["i" /* requestInstallerPaperwork */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "h", function() { return reports["c" /* clearInstallerPaperwork */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_26", function() { return reports["k" /* requestTagBulkPrint */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "i", function() { return reports["e" /* clearTagBulkPrint */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "T", function() { return reports["g" /* requestActivityReport */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "f", function() { return reports["a" /* clearActivityReport */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return requestPhaseSurvey; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return updatePhaseSurvey; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return sendPoorScoreNotification; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return line_items["b" /* fetchVendorTypes */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return line_items["c" /* requestLineItems */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return line_items["a" /* createLineItem */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return line_items["e" /* updateLineItem */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return line_items["d" /* setLineItemFilters */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "B", function() { return getUploadsList; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_75", function() { return uploadFile; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_57", function() { return toggleDialog; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_46", function() { return setErrorMessage; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return ims_actions["a" /* updateIMS */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return ims_actions["b" /* updateIMSNote */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return default_installer_pay["b" /* fetchDefaultInstallerPay */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return default_installer_pay["c" /* updateDefaultInstallerPay */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return default_installer_pay["a" /* bulkUpdateDefaultInstallerPay */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_32", function() { return projects_requestbulkProjectLoad; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_44", function() { return sendQuickScheduleMessage; });










































function actionCreators_navigate(url) {
  return Object(lib["push"])(url);
}

function navigateBack() {
  return Object(lib["goBack"])();
}

function clearValidationErrors(entity) {
  var errors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return function (dispatch) {
    dispatch({
      type: entity + '_RESOURCE_CLEAR_VALIDATION',
      payload: errors
    });
  };
}

function listOfRequests(list) {
  return function () {
    return Promise.all(list);
  };
}

/***/ }),

/***/ "ucW6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___1O_Bw","m-signature-pad--body":"styles__m-signature-pad--body___1Bp4V","m-signature-pad--footer":"styles__m-signature-pad--footer___30HyO","description":"styles__description___1DCC4","button":"styles__button___3wwAr","clear":"styles__clear___E2b5c","save":"styles__save___226U5","m-signature-pad":"styles__m-signature-pad___iBMg3","github":"styles__github___wiYoE","wrapper":"styles__wrapper___kSdfu","label":"styles__label___31gYl","element":"styles__element___1DA-1","tag":"styles__tag___2wmYB","input":"styles__input___225nF","error":"styles__error___2DsNT","errorLabel":"styles__errorLabel___2ewNE","errorMsg":"styles__errorMsg___3vMPI"};

/***/ }),

/***/ "uhZm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"signature__msignaturepad___31XWY","m-signature-pad--body":"signature__m-signature-pad--body___JiAkr","m-signature-pad--footer":"signature__m-signature-pad--footer___8XcVY","description":"signature__description___1D6fs","button":"signature__button___OKtoe","clear":"signature__clear___lueAz","save":"signature__save___3hstm","m-signature-pad":"signature__m-signature-pad___1zIjF","github":"signature__github___I32TT","SignaturePad":"signature__SignaturePad___2XthH"};

/***/ }),

/***/ "un+S":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___lPkZQ","m-signature-pad--body":"styles__m-signature-pad--body___WLSsQ","m-signature-pad--footer":"styles__m-signature-pad--footer___MdLaU","description":"styles__description___N_axu","button":"styles__button___pOUDy","clear":"styles__clear___3-CEm","save":"styles__save___1fyeD","m-signature-pad":"styles__m-signature-pad___eUC3B","github":"styles__github___388bM","card":"styles__card___6Kuq0","altColor":"styles__altColor___1_OWG","inactive":"styles__inactive___22Krw"};

/***/ }),

/***/ "v6Iw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"resourceDetailsCardElement__msignaturepad___3XPUG","m-signature-pad--body":"resourceDetailsCardElement__m-signature-pad--body___349tp","m-signature-pad--footer":"resourceDetailsCardElement__m-signature-pad--footer___1z3QV","description":"resourceDetailsCardElement__description___23LuG","button":"resourceDetailsCardElement__button___3t05C","clear":"resourceDetailsCardElement__clear___3koEs","save":"resourceDetailsCardElement__save___18BKA","m-signature-pad":"resourceDetailsCardElement__m-signature-pad___2K2pi","github":"resourceDetailsCardElement__github___2O8l2","resourceCardElement":"resourceDetailsCardElement__resourceCardElement___2JH8b","resourceCardElementTitle":"resourceDetailsCardElement__resourceCardElementTitle___iDlzH","resourceCardElementValue":"resourceDetailsCardElement__resourceCardElementValue___37pfX"};

/***/ }),

/***/ "vMT/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___1v_T7","m-signature-pad--body":"styles__m-signature-pad--body___3Ciy6","m-signature-pad--footer":"styles__m-signature-pad--footer___2jogj","description":"styles__description___MCb1h","button":"styles__button___wwFUQ","clear":"styles__clear___Fe_Jp","save":"styles__save___744CH","m-signature-pad":"styles__m-signature-pad___2gPQS","github":"styles__github___1nxXP","PurchaseOrder":"styles__PurchaseOrder___2Ipbb"};

/***/ }),

/***/ "vXuv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___AwWch","m-signature-pad--body":"styles__m-signature-pad--body___2qO-g","m-signature-pad--footer":"styles__m-signature-pad--footer___2WrJs","description":"styles__description___3Gi2w","button":"styles__button___30mBu","clear":"styles__clear___35qkc","save":"styles__save___24yNL","m-signature-pad":"styles__m-signature-pad___1pIVj","github":"styles__github___zYCO2","datePickerWrapper":"styles__datePickerWrapper___15VKa","hide":"styles__hide___Bxioe","inputElement":"styles__inputElement___254ER","errorText":"styles__errorText___2ldbv","disabled":"styles__disabled___1BOM1","errorMessage":"styles__errorMessage___2SX82","mobileInputElement":"styles__mobileInputElement___nEmQj"};

/***/ }),

/***/ "vhgL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"quickScheduleModal__msignaturepad___2gWmK","m-signature-pad--body":"quickScheduleModal__m-signature-pad--body___18Rdv","m-signature-pad--footer":"quickScheduleModal__m-signature-pad--footer___WZpCc","description":"quickScheduleModal__description___mAskV","button":"quickScheduleModal__button___w1SUX","clear":"quickScheduleModal__clear___2aV9u","save":"quickScheduleModal__save___3hYLN","m-signature-pad":"quickScheduleModal__m-signature-pad___2Q9BC","github":"quickScheduleModal__github___3fzZH","wideModal":"quickScheduleModal__wideModal___1FLZ2"};

/***/ }),

/***/ "vi6X":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"phaseAppointmentCard__msignaturepad___29Cb9","m-signature-pad--body":"phaseAppointmentCard__m-signature-pad--body___1B_e2","m-signature-pad--footer":"phaseAppointmentCard__m-signature-pad--footer___fozdH","description":"phaseAppointmentCard__description___3oY4R","button":"phaseAppointmentCard__button___rZXp1","clear":"phaseAppointmentCard__clear___2sXp-","save":"phaseAppointmentCard__save___H73CR","m-signature-pad":"phaseAppointmentCard__m-signature-pad___2ABWJ","github":"phaseAppointmentCard__github___87W2g","resourceCardElement":"phaseAppointmentCard__resourceCardElement___fOUip","resourceCardElementTitle":"phaseAppointmentCard__resourceCardElementTitle___YJM2U","phaseAppointmentCard":"phaseAppointmentCard__phaseAppointmentCard___3cNCL","phaseAppointmentCard__container":"phaseAppointmentCard__phaseAppointmentCard__container___2rY1P","phaseAppointmentCard__title":"phaseAppointmentCard__phaseAppointmentCard__title___27M-I","phaseAppointmentCard__content":"phaseAppointmentCard__phaseAppointmentCard__content___S1Uga"};

/***/ }),

/***/ "wGVS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___2i7bY","m-signature-pad--body":"styles__m-signature-pad--body___b8ZW0","m-signature-pad--footer":"styles__m-signature-pad--footer___2QRYH","description":"styles__description___3rb-w","button":"styles__button___a1ETI","clear":"styles__clear___170E6","save":"styles__save___1oUjI","m-signature-pad":"styles__m-signature-pad___2GIIP","github":"styles__github___3rEbR","paginationContainer":"styles__paginationContainer___Psj07","tablePageButton":"styles__tablePageButton___199vx","listPageButton":"styles__listPageButton___2HgXz","active":"styles__active___1CyKn"};

/***/ }),

/***/ "wMiq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___1N4ok","m-signature-pad--body":"styles__m-signature-pad--body___3is6f","m-signature-pad--footer":"styles__m-signature-pad--footer___1nJgB","description":"styles__description___LifaY","button":"styles__button___2Q2Vq","clear":"styles__clear___2yOgx","save":"styles__save___1xOnR","m-signature-pad":"styles__m-signature-pad___3rEVm","github":"styles__github___1WVzV","travelingWorkTable":"styles__travelingWorkTable___2GGoQ","select":"styles__select___3yAM5","datepicker":"styles__datepicker___LOP6w","reasonInput":"styles__reasonInput___3XIbG","mheader":"styles__mheader___1iOOU","mdates":"styles__mdates___3z_49","hidden":"styles__hidden___1L4AS","emptyTable":"styles__emptyTable___troon"};

/***/ }),

/***/ "xFof":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___2LLb7","m-signature-pad--body":"styles__m-signature-pad--body___1XHt_","m-signature-pad--footer":"styles__m-signature-pad--footer___314fv","description":"styles__description___GbZjc","button":"styles__button___39r4T","clear":"styles__clear___20B5i","save":"styles__save___3pMtn","m-signature-pad":"styles__m-signature-pad___1LIDx","github":"styles__github___1QO3U","container":"styles__container___93Oeb","wrapper":"styles__wrapper___v2CYv","minimized":"styles__minimized___1WChG","title":"styles__title___26sZl","headerButton":"styles__headerButton___2WF5C","content":"styles__content___3IXV9","compose":"styles__compose___3PhT5","actions":"styles__actions___27C-G"};

/***/ }),

/***/ "xXcJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchDefaultInstallerPay;
/* harmony export (immutable) */ __webpack_exports__["c"] = updateDefaultInstallerPay;
/* harmony export (immutable) */ __webpack_exports__["a"] = bulkUpdateDefaultInstallerPay;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services__ = __webpack_require__("NvlE");



var _createActions = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])('DEFAULT_INSTALLER_PAY_REQUEST', 'DEFAULT_INSTALLER_PAY_SUCCESS', 'DEFAULT_INSTALLER_PAY_FAILURE'),
    defaultInstallerPayRequest = _createActions.defaultInstallerPayRequest,
    defaultInstallerPaySuccess = _createActions.defaultInstallerPaySuccess,
    defaultInstallerPayFailure = _createActions.defaultInstallerPayFailure;

function fetchDefaultInstallerPay(pricePatchId) {
  return function (dispatch) {
    dispatch(defaultInstallerPayRequest());
    var query = pricePatchId ? '?price_patch_id=' + pricePatchId : '';
    return Object(__WEBPACK_IMPORTED_MODULE_1__services__["h" /* request */])('default_installer_pay' + query).then(function (_ref) {
      var json = _ref.json;
      return dispatch(defaultInstallerPaySuccess(json));
    }).catch(function (error) {
      return dispatch(defaultInstallerPayFailure(error));
    });
  };
}

var _createActions2 = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])('UPDATE_DEFAULT_INSTALLER_PAY_REQUEST', 'UPDATE_DEFAULT_INSTALLER_PAY_SUCCESS', 'UPDATE_DEFAULT_INSTALLER_PAY_FAILURE'),
    updateDefaultInstallerPayRequest = _createActions2.updateDefaultInstallerPayRequest,
    updateDefaultInstallerPaySuccess = _createActions2.updateDefaultInstallerPaySuccess,
    updateDefaultInstallerPayFailure = _createActions2.updateDefaultInstallerPayFailure;

function updateDefaultInstallerPay(id, defaultInstallerPayCents) {
  return function (dispatch) {
    dispatch(updateDefaultInstallerPayRequest());
    return Object(__WEBPACK_IMPORTED_MODULE_1__services__["h" /* request */])('default_installer_pay/' + id, {
      method: 'PATCH',
      body: { patch_item: { default_installer_pay: defaultInstallerPayCents } }
    }).then(function (_ref2) {
      var json = _ref2.json;
      return dispatch(updateDefaultInstallerPaySuccess(json));
    }).catch(function (error) {
      return dispatch(updateDefaultInstallerPayFailure(error));
    });
  };
}

var _createActions3 = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])('BULK_UPDATE_DEFAULT_INSTALLER_PAY_REQUEST', 'BULK_UPDATE_DEFAULT_INSTALLER_PAY_SUCCESS', 'BULK_UPDATE_DEFAULT_INSTALLER_PAY_FAILURE'),
    bulkUpdateDefaultInstallerPayRequest = _createActions3.bulkUpdateDefaultInstallerPayRequest,
    bulkUpdateDefaultInstallerPaySuccess = _createActions3.bulkUpdateDefaultInstallerPaySuccess,
    bulkUpdateDefaultInstallerPayFailure = _createActions3.bulkUpdateDefaultInstallerPayFailure;

function bulkUpdateDefaultInstallerPay(items) {
  return function (dispatch) {
    dispatch(bulkUpdateDefaultInstallerPayRequest());
    return Object(__WEBPACK_IMPORTED_MODULE_1__services__["h" /* request */])('default_installer_pay/bulk_update', {
      method: 'PATCH',
      body: { patch_items: items }
    }).then(function (_ref3) {
      var json = _ref3.json;
      return dispatch(bulkUpdateDefaultInstallerPaySuccess(json));
    }).catch(function (error) {
      return dispatch(bulkUpdateDefaultInstallerPayFailure(error));
    });
  };
}

/***/ }),

/***/ "xY9K":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"resourceCardElement__msignaturepad___1fU_R","m-signature-pad--body":"resourceCardElement__m-signature-pad--body___3LDyN","m-signature-pad--footer":"resourceCardElement__m-signature-pad--footer___3Ijp2","description":"resourceCardElement__description___2V_do","button":"resourceCardElement__button___2pWeW","clear":"resourceCardElement__clear___HjkLo","save":"resourceCardElement__save___3MWu9","m-signature-pad":"resourceCardElement__m-signature-pad___361fw","github":"resourceCardElement__github___1ePqI","resourceCardElement":"resourceCardElement__resourceCardElement___dWphP","wrap":"resourceCardElement__wrap___2mpIE","small":"resourceCardElement__small___3X9q1","medium":"resourceCardElement__medium___2ZGMA","large":"resourceCardElement__large___NFnkm","min":"resourceCardElement__min___3p8rN","full":"resourceCardElement__full___2V6Nj","resourceCardElementTitle":"resourceCardElement__resourceCardElementTitle___uvDvm","noMarginTitle":"resourceCardElement__noMarginTitle___2rPOO","noFlexMobile":"resourceCardElement__noFlexMobile___13kcu","halfMobileBasic":"resourceCardElement__halfMobileBasic___3HJm4","halfMobile":"resourceCardElement__halfMobile___2Qyko"};

/***/ }),

/***/ "xqJT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___Fae4W","m-signature-pad--body":"styles__m-signature-pad--body___3K-8U","m-signature-pad--footer":"styles__m-signature-pad--footer___25ZNi","description":"styles__description___2xcNW","button":"styles__button___37xg_","clear":"styles__clear___3LKGn","save":"styles__save___34qGV","m-signature-pad":"styles__m-signature-pad___2SMR3","github":"styles__github___2hU1C","wrapper":"styles__wrapper___2w8Fy","contentWrapper":"styles__contentWrapper___1Xacz","content":"styles__content___3okaI","medalImg":"styles__medalImg___1wxPR"};

/***/ }),

/***/ "yHqj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"payRateHistory__msignaturepad___PhiAT","m-signature-pad--body":"payRateHistory__m-signature-pad--body___18X99","m-signature-pad--footer":"payRateHistory__m-signature-pad--footer___1Gtoh","description":"payRateHistory__description___3qV1K","button":"payRateHistory__button___3UgMR","clear":"payRateHistory__clear___3w937","save":"payRateHistory__save___S2_pC","m-signature-pad":"payRateHistory__m-signature-pad___zFfyX","github":"payRateHistory__github___YwcnD","historyIcon":"payRateHistory__historyIcon___2MAk-","detailsView":"payRateHistory__detailsView___NibWK","rateValue":"payRateHistory__rateValue___2w25X","wrapper":"payRateHistory__wrapper___1rI56"};

/***/ }),

/***/ "yJDZ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "window_frames-2b463e73eeb52cb8901f1caf78ab90d4.png";

/***/ }),

/***/ "yNA9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"search__msignaturepad___3bM8t","m-signature-pad--body":"search__m-signature-pad--body___5J5V3","m-signature-pad--footer":"search__m-signature-pad--footer___2D5SI","description":"search__description___zHLCb","button":"search__button___rpYyD","clear":"search__clear___3FXCW","save":"search__save___3hR1c","m-signature-pad":"search__m-signature-pad___3ouF1","github":"search__github___2PmPD","inputElement":"search__inputElement___1e8sL","submit":"search__submit___2dDs_","icon":"search__icon___24peq","wrapper":"search__wrapper___2UHP7"};

/***/ }),

/***/ "yWL5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"dropzoneStyles__msignaturepad___1IxVD","m-signature-pad--body":"dropzoneStyles__m-signature-pad--body___1jIia","m-signature-pad--footer":"dropzoneStyles__m-signature-pad--footer___1D8CI","description":"dropzoneStyles__description___2yg_B","button":"dropzoneStyles__button___24hUS","clear":"dropzoneStyles__clear___330sY","save":"dropzoneStyles__save___CKu6L","m-signature-pad":"dropzoneStyles__m-signature-pad___3VkoE","github":"dropzoneStyles__github___3htl8","dropzone":"dropzoneStyles__dropzone___5Fhac","empty":"dropzoneStyles__empty___3p-yl","opaque":"dropzoneStyles__opaque___3SFqj","card":"dropzoneStyles__card___fm97f","uploadFile":"dropzoneStyles__uploadFile___3EFlD","uploadText":"dropzoneStyles__uploadText___3BLZ_","whiteBack":"dropzoneStyles__whiteBack___1jcH1","placeholder":"dropzoneStyles__placeholder___2vzaL","dropHere":"dropzoneStyles__dropHere___3TRDz"};

/***/ }),

/***/ "z2+H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = requestPTOList;
/* harmony export (immutable) */ __webpack_exports__["a"] = createPTO;
/* harmony export (immutable) */ __webpack_exports__["d"] = updatePTO;
/* harmony export (immutable) */ __webpack_exports__["b"] = deletePTO;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services__ = __webpack_require__("NvlE");



var _createActions = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])('PTO_INDEX_SUCCESS', 'PTO_INDEX_REQUEST', 'PTO_INDEX_FAILURE'),
    ptoIndexRequest = _createActions.ptoIndexRequest,
    ptoIndexSuccess = _createActions.ptoIndexSuccess,
    ptoIndexFailure = _createActions.ptoIndexFailure;

function requestPTOList(parentID, parentKind) {
  return function (dispatch) {
    dispatch(ptoIndexRequest());

    return Object(__WEBPACK_IMPORTED_MODULE_1__services__["h" /* request */])(parentKind + '/' + parentID + '/ptos').then(function (_ref) {
      var json = _ref.json;
      return dispatch(ptoIndexSuccess(json));
    }).catch(function (error) {
      return dispatch(ptoIndexFailure(error));
    });
  };
}

var _createActions2 = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])('PTO_CREATE_REQUEST', 'PTO_CREATE_SUCCESS', 'PTO_CREATE_FAILURE'),
    ptoCreateRequest = _createActions2.ptoCreateRequest,
    ptoCreateSuccess = _createActions2.ptoCreateSuccess,
    ptoCreateFailure = _createActions2.ptoCreateFailure;

function createPTO(parentID, parentKind, pto) {
  return function (dispatch) {
    dispatch(ptoCreateRequest());

    return Object(__WEBPACK_IMPORTED_MODULE_1__services__["h" /* request */])(parentKind + '/' + parentID + '/ptos', { method: 'POST', body: { pto: pto } }).then(function (_ref2) {
      var json = _ref2.json;
      return dispatch(ptoCreateSuccess(json));
    }).catch(function (_ref3) {
      var errors = _ref3.errors;
      return dispatch(ptoCreateFailure({ pto: pto, errors: errors }));
    });
  };
}

var _createActions3 = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])('PTO_UPDATE_SUCCESS', 'PTO_UPDATE_REQUEST', 'PTO_UPDATE_FAILURE'),
    ptoUpdateRequest = _createActions3.ptoUpdateRequest,
    ptoUpdateSuccess = _createActions3.ptoUpdateSuccess,
    ptoUpdateFailure = _createActions3.ptoUpdateFailure;

function updatePTO(ptoID, pto) {
  return function (dispatch) {
    dispatch(ptoUpdateRequest());

    return Object(__WEBPACK_IMPORTED_MODULE_1__services__["h" /* request */])('ptos/' + ptoID, { method: 'PATCH', body: { pto: pto } }).then(function (_ref4) {
      var json = _ref4.json;
      return dispatch(ptoUpdateSuccess(json));
    }).catch(function (_ref5) {
      var errors = _ref5.errors;
      return dispatch(ptoUpdateFailure({ pto: pto, errors: errors }));
    });
  };
}

var _createActions4 = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createActions"])('PTO_DELETE_SUCCESS', 'PTO_DELETE_REQUEST', 'PTO_DELETE_FAILURE'),
    ptoDeleteRequest = _createActions4.ptoDeleteRequest,
    ptoDeleteSuccess = _createActions4.ptoDeleteSuccess,
    ptoDeleteFailure = _createActions4.ptoDeleteFailure;

function deletePTO(ptoID) {
  return function (dispatch) {
    dispatch(ptoDeleteRequest());

    return Object(__WEBPACK_IMPORTED_MODULE_1__services__["h" /* request */])('ptos/' + ptoID, { method: 'DELETE' }).then(function () {
      return dispatch(ptoDeleteSuccess({ ptoID: ptoID }));
    }).catch(function (error) {
      return dispatch(ptoDeleteFailure(error));
    });
  };
}

/***/ }),

/***/ "zWSg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"photoCarouselStyling__msignaturepad___1XFXv","m-signature-pad--body":"photoCarouselStyling__m-signature-pad--body___1KaIC","m-signature-pad--footer":"photoCarouselStyling__m-signature-pad--footer___2Ajpy","description":"photoCarouselStyling__description___3OD5n","button":"photoCarouselStyling__button____-6Je","clear":"photoCarouselStyling__clear___3qJB2","save":"photoCarouselStyling__save___1JPop","m-signature-pad":"photoCarouselStyling__m-signature-pad___3dN-s","github":"photoCarouselStyling__github___Jvmt6","leftButton":"photoCarouselStyling__leftButton___32rdf","rightButton":"photoCarouselStyling__rightButton___1DiBX","modal":"photoCarouselStyling__modal___4h_AM","backgroundImg":"photoCarouselStyling__backgroundImg___1tZcd","bottomCarousel":"photoCarouselStyling__bottomCarousel___1h0QM","docName":"photoCarouselStyling__docName___110Jg","container":"photoCarouselStyling__container___1U5Mx","carouselContainer":"photoCarouselStyling__carouselContainer___1s2dk"};

/***/ }),

/***/ "zdX5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return requestWarehouseReport; });
/* harmony export (immutable) */ __webpack_exports__["f"] = clearWarehouseReport;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return requestJobHistoryReport; });
/* harmony export (immutable) */ __webpack_exports__["d"] = clearJobHistoryReport;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return requestInstallWorkorderReport; });
/* harmony export (immutable) */ __webpack_exports__["b"] = clearInstallWorkorderReport;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return requestInstallerPaperwork; });
/* harmony export (immutable) */ __webpack_exports__["c"] = clearInstallerPaperwork;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return requestTagBulkPrint; });
/* harmony export (immutable) */ __webpack_exports__["e"] = clearTagBulkPrint;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return requestActivityReport; });
/* harmony export (immutable) */ __webpack_exports__["a"] = clearActivityReport;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services__ = __webpack_require__("NvlE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_qs__);




var _createActions = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createActions"])('WAREHOUSE_REPORT_SUCCESS', 'WAREHOUSE_REPORT_REQUEST', 'WAREHOUSE_REPORT_FAILURE'),
    warehouseReportSuccess = _createActions.warehouseReportSuccess,
    warehouseReportFailure = _createActions.warehouseReportFailure,
    warehouseReportRequest = _createActions.warehouseReportRequest;

var requestWarehouseReport = function requestWarehouseReport(filters) {
  return function (dispatch) {
    dispatch(warehouseReportRequest());

    return Object(__WEBPACK_IMPORTED_MODULE_0__services__["h" /* request */])('reports/warehouse_summary?' + __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(filters)).then(function (_ref) {
      var json = _ref.json;
      return dispatch(warehouseReportSuccess(json));
    }).catch(function (error) {
      return dispatch(warehouseReportFailure(error));
    });
  };
};

function clearWarehouseReport() {
  return { type: 'WAREHOUSE_REPORT_CLEAR' };
}

var _createActions2 = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createActions"])('JOB_HISTORY_REPORT_SUCCESS', 'JOB_HISTORY_REPORT_REQUEST', 'JOB_HISTORY_REPORT_FAILURE'),
    jobHistoryReportSuccess = _createActions2.jobHistoryReportSuccess,
    jobHistoryReportFailure = _createActions2.jobHistoryReportFailure,
    jobHistoryReportRequest = _createActions2.jobHistoryReportRequest;

var requestJobHistoryReport = function requestJobHistoryReport(filters) {
  return function (dispatch) {
    dispatch(jobHistoryReportRequest());
    return Object(__WEBPACK_IMPORTED_MODULE_0__services__["h" /* request */])('reports/job_history_report?' + __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(filters)).then(function (_ref2) {
      var json = _ref2.json;
      return dispatch(jobHistoryReportSuccess(json));
    }).catch(function (error) {
      return dispatch(jobHistoryReportFailure(error));
    });
  };
};

function clearJobHistoryReport() {
  return { type: 'JOB_HISTORY_REPORT_CLEAR' };
}

var _createActions3 = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createActions"])('INSTALL_WORKORDER_REPORT_SUCCESS', 'INSTALL_WORKORDER_REPORT_REQUEST', 'INSTALL_WORKORDER_REPORT_FAILURE'),
    installWorkorderReportSuccess = _createActions3.installWorkorderReportSuccess,
    installWorkorderReportFailure = _createActions3.installWorkorderReportFailure,
    installWorkorderReportRequest = _createActions3.installWorkorderReportRequest;

var requestInstallWorkorderReport = function requestInstallWorkorderReport(filters) {
  return function (dispatch) {
    dispatch(installWorkorderReportRequest());
    return Object(__WEBPACK_IMPORTED_MODULE_0__services__["h" /* request */])('reports/install_workorder_report?' + __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(filters)).then(function (_ref3) {
      var json = _ref3.json;
      return dispatch(installWorkorderReportSuccess(json));
    }).catch(function (error) {
      return dispatch(installWorkorderReportFailure(error));
    });
  };
};

function clearInstallWorkorderReport() {
  return { type: 'INSTALL_WORKORDER_REPORT_CLEAR' };
}

var _createActions4 = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createActions"])('INSTALLER_PAPERWORK_SUCCESS', 'INSTALLER_PAPERWORK_REQUEST', 'INSTALLER_PAPERWORK_FAILURE'),
    installerPaperworkSuccess = _createActions4.installerPaperworkSuccess,
    installerPaperworkFailure = _createActions4.installerPaperworkFailure,
    installerPaperworkRequest = _createActions4.installerPaperworkRequest;

var requestInstallerPaperwork = function requestInstallerPaperwork(filters) {
  return function (dispatch) {
    dispatch(installerPaperworkRequest());
    return Object(__WEBPACK_IMPORTED_MODULE_0__services__["h" /* request */])('reports/installer_paperwork?' + __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(filters)).then(function (_ref4) {
      var json = _ref4.json;
      return dispatch(installerPaperworkSuccess(json));
    }).catch(function (error) {
      return dispatch(installerPaperworkFailure(error));
    });
  };
};

function clearInstallerPaperwork() {
  return { type: 'INSTALLER_PAPERWORK_CLEAR' };
}

var _createActions5 = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createActions"])('TAG_BULK_PRINT_SUCCESS', 'TAG_BULK_PRINT_REQUEST', 'TAG_BULK_PRINT_FAILURE'),
    tagBulkPrintSuccess = _createActions5.tagBulkPrintSuccess,
    tagBulkPrintFailure = _createActions5.tagBulkPrintFailure,
    tagBulkPrintRequest = _createActions5.tagBulkPrintRequest;

var requestTagBulkPrint = function requestTagBulkPrint(filters) {
  return function (dispatch) {
    dispatch(tagBulkPrintRequest());

    return Object(__WEBPACK_IMPORTED_MODULE_0__services__["h" /* request */])('reports/tags_bulk_print?' + __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(filters)).then(function (_ref5) {
      var json = _ref5.json;
      return dispatch(tagBulkPrintSuccess(json));
    }).catch(function (error) {
      return dispatch(tagBulkPrintFailure(error));
    });
  };
};

function clearTagBulkPrint() {
  return { type: 'TAG_BULK_PRINT_CLEAR' };
}

var _createActions6 = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createActions"])('ACTIVITY_REPORT_SUCCESS', 'ACTIVITY_REPORT_REQUEST', 'ACTIVITY_REPORT_FAILURE'),
    activityReportSuccess = _createActions6.activityReportSuccess,
    activityReportFailure = _createActions6.activityReportFailure,
    activityReportRequest = _createActions6.activityReportRequest;

var requestActivityReport = function requestActivityReport(filters) {
  return function (dispatch) {
    dispatch(activityReportRequest());

    return Object(__WEBPACK_IMPORTED_MODULE_0__services__["h" /* request */])('reports/activity?' + __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(filters)).then(function (_ref6) {
      var json = _ref6.json;
      return dispatch(activityReportSuccess(json));
    }).catch(function (error) {
      return dispatch(activityReportFailure(error));
    });
  };
};

function clearActivityReport() {
  return { type: 'ACTIVITY_REPORT_CLEAR' };
}

/***/ })

},["jVzx"]);


// WEBPACK FOOTER //
// client.762797e68edfb8c015a3.js